/**
 * @author Stefano Poli
 * created on 21/10/2016
 */

'use strict';

var deps = [];
var emmaConsip = angular.module('emma.consip', ['emma', 'emma.constants']);
emmaConsip.constant('REVISION_INSERTED', 0).constant('REVISION_APPROVED', 1).constant('REVISION_REFUSED', 2).constant('CONTRACT_TYPES', {
  loose: 'loose',
  strict: 'strict'
});
/**
 * @author Stefano Poli
 * created on 07/11/2016
 */

'use strict';

var datasetConsip = angular.module('emma.dataset', ['emma', 'emma.constants']);
/**
 * @author Stefano Poli
 * created on 21/10/2016
 */

'use strict';

var emmaEnergy = angular.module('emma.energy', ['emma', 'emma.constants']);
/**
 * @author Stefano Poli
 * created on 21/10/2016
 */

'use strict';

var emmaLm = angular.module('emma.lm', ['emma', 'emma.constants']);
/**
 * @author Stefano Poli
 * created on 21/10/2016
 */

'use strict';

var emmaPlan = angular.module('emma.plan', ['emma', 'emma.constants']);
'use strict';

var emmaPortal = angular.module('emma.portal', ['emma', 'emma.constants']);
/**
 * @author Stefano Poli
 * created on 07/11/2016
 */

'use strict';

// var deps = [];
//
// try {
//   //This throws an expection if module does not exist.
//   angular.module('ui.bootstrap');
//   deps.push('ui.bootstrap');
// } catch (e) {}
//
// try {
//   //This throws an expection if module does not exist.
//   angular.module('LocalStorageModule');
//   deps.push('LocalStorageModule');
// } catch (e) {}
//
// try {
//   //This throws an expection if module does not exist.
//   angular.module('schemaForm');
//   deps.push('schemaForm');
// } catch (e) {}
var emmaTheme = angular.module('emma.theme', ['emma', 'emma.constants']).config(['cfpLoadingBarProvider', function (cfpLoadingBarProvider) {
  cfpLoadingBarProvider.spinnerTemplate = '<div id="loading-bar-spinner"><div class="spinner-icon"></div></div>';
  angular.element(document.getElementById('loading-bar-spinner')).removeClass('custom-loading-bar-spinner');
  cfpLoadingBarProvider.includeSpinner = true;
}]).config(['localStorageServiceProvider', function (localStorageServiceProvider) {
  localStorageServiceProvider.setPrefix('sixls');
}]);
'use strict';

/**
 * @ngdoc overview
 * @name sixEmmaApp
 * @description
 * # sixEmmaApp
 *
 * Main module of the application.
 */
var _module = angular.module('emma', ['LocalStorageModule', 'ngAnimate', 'ngCookies', 'ngResource', 'ngRoute', 'ngSanitize', 'ngTouch', 'ui.bootstrap', 'ui.select', 'ui.ace', 'schemaForm', 'ui.grid', 'ui.grid.importer', 'ui.grid.selection', 'ui.grid.exporter', 'ui.grid.edit', 'ui.grid.rowEdit', 'ui.grid.cellNav', 'ui.grid.expandable', 'ui.grid.pinning', 'ui.grid.resizeColumns', 'ui.grid.pagination', 'ui.grid.moveColumns', 'ui.grid.autoResize', 'ui.grid.saveState', 'ui.grid.pinning', 'ui.tree', 'ngDialog', 'ngMessages', 'toaster', 'ngWebSocket', 'fileSaver', 'ui.bootstrap-slider', 'mgcrea.ngStrap', 'mgcrea.ngStrap.modal', 'mgcrea.ngStrap.select', 'pascalprecht.translate', 'angular-md5', 'monospaced.qrcode', 'gantt', 'gantt.table', 'gantt.tooltips', 'gantt.tree', 'gantt.groups', 'angularFileUpload', 'cfp.loadingBar', 'cfp.loadingBarInterceptor', 'emma.theme', 'emma.dataset', 'emma.energy', 'emma.plan', 'emma.lm', 'emma.consip', 'emma.constants', 'emma.portal', 'sixFramework', 'sixMenu', 'sixToolbar', 'ngTagsInput', "ng-mfb", "ui.bootstrap.datetimepicker", "pdf", "as.sortable", "angular.filter", "ui.slimscroll", "xeditable", 'ui.tinymce']).config(['tagsInputConfigProvider', function (tagsInputConfigProvider) {
  tagsInputConfigProvider.setDefaults('tagsInput', {
    placeholder: ''
  });
  tagsInputConfigProvider.setActiveInterpolation('tagsInput', {
    placeholder: true
  });
}]).run(['$animate', 'CAS', function ($animate, CAS) {
  if (CAS) {
    $animate.enabled(false);
  }
}]).run(["editableOptions", function (editableOptions) {
  editableOptions.theme = 'bs3';
}]);
;
var auth = {};
"use strict";

(function () {
  'use strict';

  angular.module('emma.dataset').run(["$rootScope", "authFactory", "recordWSFactory", "notificationService", "toaster", "loadingBarService", function ($rootScope, authFactory, recordWSFactory, notificationService, toaster, loadingBarService) {
    /** NOTIFICHE **/
    $rootScope.importListener = function (n) {
      console.log(n);
      var object = "Operazione di import completata";
      var icon = n.message_type == 'success' ? 'fa-check' : 'fa-exclamation';
      var level = n.message_type == 'success' ? 'info' : 'warning';
      var message = n.message || "";
      var notification = {
        icon: 'fa ' + icon,
        object: object,
        message: message,
        data: n.serviceResponse,
        level: level,
        time: new Date(),
        action: 'serviceResponse'
      };
      notificationService.push(notification);
      //assicuriamoci di essere invadenti aggiungendo anche il toaster
      if (n.message_type == 'success') {
        toaster.success(object + " - " + message);
      } else {
        toaster.error(object + " - " + message);
      }
    };
    recordWSFactory.addHandler($rootScope.importListener);

    //instauro la connessione non appena è disponibile l'autenticazione
    $rootScope.$watchCollection(function () {
      return authFactory.getAuthData();
    }, function (newValue, oldValue) {
      if (authFactory.getAuthData()) {
        recordWSFactory.connect(authFactory.getAuthData().authId);
      }
    });
  }]);
})();
"use strict";

/**
 * @author Stefano Poli
 * created on 07/11/2016
 */
(function () {
  'use strict';

  angular.module('emma.plan').run(["$rootScope", "authFactory", "invoiceWSFactory", "notificationService", "toaster", function ($rootScope, authFactory, invoiceWSFactory, notificationService, toaster) {
    /** NOTIFICHE **/
    $rootScope.invoiceListener = function (n) {
      if (n.invoiceheader) {
        var object = "Fattura " + n.invoiceheader.model.code + " - " + n.invoiceheader.model.description;
        var icon = n.message_type == 'success' ? 'fa-check' : 'fa-exclamation';
        var level = n.message_type == 'success' ? 'info' : 'warning';
        var notification = {
          icon: 'fa ' + icon,
          object: object,
          message: n.message,
          level: level,
          time: new Date(),
          action: 'templateDialog'
        };
        notificationService.push(notification);
        //assicuriamoci di essere invadenti aggiungendo anche il toaster
        if (n.message_type == 'success') {
          toaster.success(object + " - " + n.message);
        } else {
          toaster.error(object + " - " + n.message);
        }
        $rootScope.$broadcast("invoiceheaderChanged", n.invoiceheader);
      }
    };
    invoiceWSFactory.addHandler($rootScope.invoiceListener);

    //instauro la connessione non appena è disponibile l'autenticazione
    $rootScope.$watchCollection(function () {
      return authFactory.getAuthData();
    }, function (newValue, oldValue) {
      if (authFactory.getAuthData()) {
        invoiceWSFactory.connect(authFactory.getAuthData().authId);
      }
    });
  }]);
})();
'use strict';

angular.module('emma.portal').filter('midletruncate', function () {
  return function (value, max, ellipsis) {
    if (!value) return '';
    var maxLength = max || 10;
    if (maxLength < 0) return value;
    if (maxLength == 1) return value.substring(0, 1) + '...';
    if (value.length <= max) return value;
    var midpoint = Math.ceil(value.length / 2);
    var toremove = value.length - maxLength;
    var lstrip = Math.ceil(toremove / 2);
    var rstrip = toremove - lstrip;
    return value.substring(0, midpoint - lstrip) + (ellipsis || '...') + value.substring(midpoint + rstrip);
  };
});
"use strict";

/**
 * Created by stefano on 08/11/16.
 */

(function () {
  'use strict';

  httpConfig.$inject = ["$routeProvider", "$httpProvider"];
  angular.module('emma.theme').config(httpConfig);

  /** @ngInject */
  function httpConfig($routeProvider, $httpProvider) {
    $routeProvider.when('/', {
      templateUrl: 'theme/main.html',
      controller: 'MainCtrl'
    }).when('/home', {
      templateUrl: 'theme/main.html',
      controller: 'MainCtrl'
    }).otherwise({
      templateUrl: 'theme/view404.html'
    });
    $httpProvider.interceptors.push('authHttpRequestInterceptor');
  }
})();
"use strict";

/**
 * @author Stefano Poli
 * created on 07/11/2016
 */
(function () {
  'use strict';

  angular.module('emma.theme').run(["$rootScope", "$location", "authFactory", "$log", "$templateCache", "localStorageService", "ENV", "CAS", "broadcastWSFactory", "concurrencyEntityWSFactory", "notificationService", "toaster", "dialogService", "ENABLE_BROADCAST_WS", function ($rootScope, $location, authFactory, $log, $templateCache, localStorageService, ENV, CAS, broadcastWSFactory, concurrencyEntityWSFactory, notificationService, toaster, dialogService, ENABLE_BROADCAST_WS) {
    $rootScope.$on('$routeChangeStart', function (event, next) {
      if (next.templateUrl === 'theme/login/fakelogin.html') {
        $rootScope.bodyClass = 'login-six';
        localStorageService.set('preferred_login', 'fakelogin');
      } else if (next.templateUrl === 'theme/login/login.html') {
        $rootScope.bodyClass = 'login-six';
        localStorageService.set('preferred_login', 'login');
      } else if (next.templateUrl === 'theme/auth/postauth.html') {
        $rootScope.bodyClass = 'login-six';
      } else if (!authFactory.isAuthenticated()) {
        $rootScope.bodyClass = 'login-six';
        if (angular.isString($location.path())) {
          localStorageService.set(ENV + '_nextPath', $location.path());
        } else {
          localStorageService.set(ENV + '_nextPath', '/'); // home
        }

        var forceSixLogin = localStorageService.get('force_six_login');
        if (CAS && !forceSixLogin) {
          // autenticazione con CAS CoopService
          window.location = 'emmacas/auth';
        } else {
          // autenticazione senza CAS
          var loginpath = localStorageService.get('preferred_login');
          $location.path(loginpath || 'login');
        }
      } else if (next.templateUrl === '404.html') {
        $rootScope.bodyClass = 'login-six';
      } else {
        $rootScope.bodyClass = '';
      }
    });
    // Cambio l'icona di espansione righe delle ui-grid
    $templateCache.put('ui-grid/expandableTopRowHeader', '<div class="ui-grid-row-header-cell ui-grid-expandable-buttons-cell">' + '<div class="ui-grid-cell-contents">' + '<i ng-class="{ \'fa fa-chevron-right\' : !grid.expandable.expandedAll, \'fa fa-chevron-down\' : grid.expandable.expandedAll }" ng-click="grid.api.expandable.toggleAllRows()"></i>' + '</div>' + '</div>');
    $templateCache.put('ui-grid/expandableRowHeader', '<div class=\"ui-grid-row-header-cell ui-grid-expandable-buttons-cell\">' + '<div class=\"ui-grid-cell-contents\">' + '<i ng-class=\"{ \'fa fa-chevron-right\' : !row.isExpanded, \'fa fa-chevron-down\' : row.isExpanded }\" ng-click=\"grid.api.expandable.toggleRowExpansion(row.entity)\"></i>' + '</div>' + '</div>');

    // BROADCAST NOTIFICATION WEB SOCKET

    $rootScope.broadcastListener = function (msg) {
      if (msg.type == 'broadcast') {
        var level = msg.level.toLowerCase();
        var icon;
        switch (msg.level.toLowerCase()) {
          case 'info':
            icon = 'fa fa-info text-info-dker';
            break;
          case 'success':
            icon = 'fa fa-check text-success-dker';
            break;
          case 'warning':
            icon = 'fa fa-exclamation text-warning-dker';
            break;
          case 'error':
            icon = 'fa fa-times text-danger-dker';
            break;
        }
        if (level == 'error') level = 'danger';
        var notification = {
          from: msg.from,
          icon: icon,
          object: msg.object,
          message: msg.message,
          level: level,
          time: new Date(),
          action: 'templateDialog'
        };
        notificationService.push(notification);
        if (msg.pinned) {
          var dialogScope = {
            n: notification
          };
          var template = '' + '<span class="font-bold ngdialog-icon"></span>' + '<div style="text-align: center;">' + '<div class="font-bold font-italic text-muted">Nuovo messaggio ricevuto</div>' + '<div class="font-bold">{{n.object}}</div>' + '<div style="margin: 10px 5px 5px 5px; text-align: center;" ng-bind-html="n.message"></div>' + '<div class="text-sm font-italic text-muted">' + '<span ng-if="n.time">{{n.time | date: "dd/MM/yyyy HH:mm:ss"}} </span>' + '<span ng-if="n.from">da {{n.from}}</span>' + '</div>' + '</div>';
          // dialogService.dialog(notification.object, notification.message, notification.level, -1, false);
          dialogService.templateDialog(template, notification.level, dialogScope, undefined, -1);
        } else {
          toaster.pop(msg.level.toLowerCase(), notification.object, notification.message);
        }
      }
    };
    broadcastWSFactory.register($rootScope.broadcastListener); // mi connetto

    $rootScope.concurrencyHandler = function () {
      // var notification = {
      //   icon: 'fa fa-exclamation text-warning-dker',
      //   object: 'Concorrenza',
      //   message: 'Un altro utente sta lavorando su questa pagina',
      //   level: 'warning',
      //   time: new Date(),
      //   action: 'templateDialog'
      // }
      // notificationService.push(notification);
      toaster.warning('Un altro utente sta lavorando su questa pagina');
    };
    concurrencyEntityWSFactory.register($rootScope.concurrencyHandler);
    if (ENABLE_BROADCAST_WS) {
      $rootScope.$watchCollection(function () {
        return authFactory.getAuthData();
      }, function (newValue, oldValue) {
        $log.info('authFactory', authFactory.getAuthData());
        if (authFactory.getAuthData()) {
          broadcastWSFactory.connect(authFactory.getAuthData().authId); // mi connetto
          concurrencyEntityWSFactory.connect(authFactory.getAuthData().authId); // mi connetto
        }
      });

      // comunico in che pagina mi trovo

      $rootScope.$on('$routeChangeSuccess', function (event, next, current) {
        $log.debug('route changed', event, next, current);
        var authId;
        if (authFactory.getAuthData() && authFactory.getAuthData().authId) {
          authId = authFactory.getAuthData().authId;
        }
        var commission;
        if (authFactory.getAuthData() && authFactory.getAuthData().info && authFactory.getAuthData().info.commissions && authFactory.getAuthData().info.commissions.current) {
          commission = authFactory.getAuthData().info.commissions.current.code;
        }
        var msg = {
          type: 'imhere',
          authId: authId,
          commission: commission,
          location: next.$$route.templateUrl
        };
        broadcastWSFactory.send(msg, false);
        if (current) {
          concurrencyEntityWSFactory.sendClose(current.pathParams, current.$$route.originalPath);
        }
        concurrencyEntityWSFactory.sendOpen(next.pathParams, next.$$route.originalPath);
      });
    }
  }]);
})();
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:AcquisitionStepCtrl
 * @description
 * # AcquisitionStepCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.consip').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/acquisitionstep', {
    templateUrl: 'consip/acquisitionstep/acquisitionstep_list.html',
    controller: 'AcquisitionStepCtrl'
  }).when('/acquisitionstep/page/:number', {
    templateUrl: 'consip/acquisitionstep/acquisitionstep_list.html',
    controller: 'AcquisitionStepCtrl'
  }).when('/acquisitionstep/:id', {
    templateUrl: 'consip/acquisitionstep/acquisitionstep_detail.html',
    controller: 'AcquisitionStepCtrl'
  });
}]).controller('AcquisitionStepCtrl', ["$scope", "$routeParams", "$location", "formulaFactory", "$log", "acquisitionStepFactory", "$window", "schemaFactory", "toaster", function ($scope, $routeParams, $location, formulaFactory, $log, acquisitionStepFactory, $window, schemaFactory, toaster) {
  $scope.form = {};
  $scope.step = {};
  $scope.model = {};
  $scope.schema = {};
  $scope.property = {};
  $scope.checked = {};
  $scope.uiselectMap = {};
  $scope.itemTypeMap = {};
  $scope.newItemArray = {
    record_id: {}
  };
  $scope.status = {
    isFirstOpen: true,
    isFirstDisabled: false
  };
  $scope.modeltypeList = schemaFactory().lookupList({
    page_size: 1000
  });

  /* ------------------------------------------------ */

  $scope.stepList = []; /* lista degli step per la pagina _list */

  $scope.formulaList = {}; /* formule disponibili da poter inserire con il configuratore */

  $scope.selected = {}; /** contenitore */

  $scope.newStep = function () {
    $location.path('acquisitionstep/new');
  };
  $scope.back = function () {
    $location.path('acquisitionstep');
  };
  $scope.pageChanged = function () {
    $location.path('/acquisitionstep/page/' + $scope.stepList.currentPage, false);
  };
  $scope.getFormulaList = function () {
    formulaFactory.getFormulasList({
      query: $scope.queryParam,
      page_size: 1000
    }).$promise.then(function (data) {
      $scope.formulaList = data.list;
    });
  };
  $scope.getStepList = function () {
    /** scarico la lista dei modelli di step inseriti */
    acquisitionStepFactory().lookup({
      page_size: 1000
    }).$promise.then(function (data) {
      $scope.stepList = data;
    });
  };
  $scope.getStep = function (UUID) {
    acquisitionStepFactory().byUUID({
      id: UUID
    }).$promise.then(function (response) {
      if (response.model) {
        $scope.selected = angular.copy(response);
        $scope.updateScope();
      }
    });
  };
  $scope.save = function () {
    if ($scope.selected.model.code && $scope.selected.model.description) {
      if ($scope.selected.version) {
        acquisitionStepFactory().update({
          id: $scope.selected.version
        }, $scope.aceModel).$promise.then(function () {
          $window.history.back();
        });
      } else {
        var toSave = JSON.parse($scope.aceModel);
        acquisitionStepFactory().create(toSave.model).$promise.then(function () {
          $window.history.back();
        });
      }
    } else {
      toaster.pop('error', 'Errore', 'Dati obbligatori mancanti');
    }
  };
  $scope["delete"] = function (idToDelete) {
    acquisitionStepFactory()["delete"]({
      id: idToDelete
    }).$promise.then(function () {
      $window.history.back();
    });
  };

  /*______MAIN____ */

  if ($routeParams.id) {
    if ($routeParams.id != 'new') {
      /** carico un modello esistente */
      $scope.getStep($routeParams.id);
    }

    /* scarico comunque l'elenco delle formule */
    $scope.getFormulaList();
  } else {
    /* lista delle configurazioni inserite */
    $scope.getStepList();
  }

  /*****************************************************************************/
  /*************** ADD & DELETE PROPERTIES ON $scope.model.schema *************/
  /***************************************************************************/

  $scope.addProperty = function () {
    if (angular.isDefined($scope.property.key)) {
      var p = {
        title: angular.copy($scope.property.title),
        type: angular.copy($scope.property.type),
        check: false
      };
      if ($scope.property.format) {
        p.format = angular.copy($scope.property.format);
      }
      if (p.type == 'date') {
        p.type = 'string';
        p.format = 'date';
      }
      if (p.type == 'array') {
        p.items = {
          type: angular.copy($scope.property.items_type)
        }; // default
        if ($scope.property.items_type === 'date') {
          // se è una data è diverso...
          p.items = {
            type: 'string',
            format: 'date'
          };
        }
      }
      if ($scope.property.inherited) {
        if ($scope.property.inherited == true) {
          p.format = 'inherit';
          p.field = '';
          p.record = '';
          if ($scope.property.format) {
            p.field_inherit_type = $scope.property.format;
            if ($scope.property.format == 'enum') {
              delete p["enum"];
            }
          }
          if (p.type == 'integer') {
            p.type = 'number';
          }
        }
      }
      $scope.selected.model.schema.properties[$scope.property.key] = p;
      var item = {
        title: angular.copy($scope.property.title),
        type: null,
        key: [angular.copy($scope.property.key)]
      };
      if (p.format) {
        if (p.format == 'date') {
          item.type = 'datepicker';
        } else if (p.format == 'enum') {
          item.type = 'uiselect';
          item.titleMap = [];
        } else if (p.format == 'lookup') {
          item.type = 'sixlookup';
        } else if (p.format == 'formula') {
          item.type = 'sixformula';
        } else if (p.format == 'inherit') {
          item.type = 'sixinherit';
        }
      } else if (p.type == 'string') {
        item.type = 'text';
      } else if (p.type == 'number' || p.type == 'integer') {
        item.type = 'number';
      } else if (p.type == 'boolean') {
        item.type = 'checkbox';
      } else if (p.type == 'array') {
        item.type = 'uiselectmultiple';
        item.titleMap = [];
      } else {
        // default
        item.type = angular.copy(p.type);
      }
      for (var i in $scope.selected.model.form[0].items) {
        if ($scope.selected.model.form[0].items[i].tabs) {
          $scope.selected.model.form[0].items[i].tabs[0].items.push(item);
        }
      }
    }
    $scope.getUiSelectMap();
    $scope.clearNewCol();
    $scope.updateScope();
  };
  $scope.clearNewCol = function () {
    $scope.property.key = '';
    $scope.property.title = '';
    delete $scope.property.type;
    delete $scope.property.format;
    delete $scope.property.inherited;
  };
  $scope.deleteProperty = function (keyToDelete) {
    delete $scope.selected.model.schema.properties[keyToDelete];
    for (var i = $scope.selected.model.columnDefs.length; i--;) {
      if ($scope.selected.model.columnDefs[i].field == keyToDelete) $scope.selected.model.columnDefs.splice(i, 1);
    }
    for (var i = $scope.selected.model.form[0].items.length; i--;) {
      if ($scope.selected.model.form[0].items[i].key && $scope.selected.model.form[0].items[i].key[0] == keyToDelete) {
        $scope.selected.model.form[0].items.splice(i, 1);
      }
      // Scorro anche i tabs
      if ($scope.selected.model.form[0].items[i].tabs) {
        for (var j = $scope.selected.model.form[0].items[i].tabs.length; j--;) {
          for (var k = $scope.selected.model.form[0].items[i].tabs[j].items.length; k--;) {
            if ($scope.selected.model.form[0].items[i].tabs[j].items[k].key[0] == keyToDelete) {
              $scope.selected.model.form[0].items[i].tabs[j].items.splice(k, 1);
            }
          }
        }
      }
    }
    $scope.updateScope();
  };

  /*****************************************************************************/
  /*************** AGGIORNA LA $scope.selected.model.columnDefs ***************/
  /***************************************************************************/

  $scope.changeColumnDefs = function (key, value) {
    var item = {
      name: value.title,
      field: key
    };
    var map = {};
    angular.forEach($scope.selected.model.columnDefs, function (v) {
      map[v.field] = angular.copy(v);
    });
    if (value.check) {
      map[item.field] = angular.copy(item);
      if (value.width == '' || value.width == null) {
        delete $scope.selected.model.schema.properties[key].width;
      }
    } else {
      delete map[item.field];
      delete $scope.selected.model.schema.properties[key].width;
      $scope.selected.model.schema.properties[key].enableFiltering = false;
      $scope.selected.model.schema.properties[key].enableSorting = false;
    }
    $scope.selected.model.columnDefs = [];
    for (var it in map) {
      var app = {
        name: map[it].name,
        field: map[it].field
      };
      $scope.selected.model.columnDefs.push(app);
    }
    $scope.updateScope();
  };

  /*************************************/
  /*************** FORM ***************/
  /***********************************/

  $scope.newFieldForm = {};
  $scope.newTab = {
    title: "",
    items: []
  };
  $scope.addTab = function (container) {
    if (!container.tabs) {
      container.tabs = [];
    }
    if (container.type !== 'tabs') {
      container.type = 'tabs';
    }
    var toAdd = angular.copy($scope.newTab);
    $log.log(container);
    container.tabs.push(toAdd);
    $log.log(container);
    $scope.updateScope();
    $scope.newTab = {
      title: "",
      items: []
    };
  };
  $scope.addFieldToTab = function (tab) {
    if (!tab.items) {
      tab.items = [];
    }
    var toAdd = angular.copy($scope.newFieldForm);
    if ($scope.newFieldForm.type === '' || $scope.newFieldForm.type === 'formula' || $scope.newFieldForm.type === 'inherited') {
      delete toAdd.type;
    }
    toAdd.key = [];
    toAdd.key.push($scope.newFieldForm.key);
    tab.items.push(toAdd);
    $log.log(tab);
    $scope.updateScope();
    $scope.newFieldForm = {
      key: [],
      title: "",
      required: false,
      type: "text"
    };
  };
  $scope.removeTabOrField = function (key, container) {
    container.splice(key, 1);
    $log.log(container);
    $scope.updateScope();
  };
  $scope.swapUp = function (key, collection) {
    if (key > 0) {
      var tmp = collection[key];
      collection[key] = collection[key - 1];
      collection[key - 1] = tmp;
    }
    $scope.updateScope();
  };
  $scope.swapDown = function (key, collection) {
    if (key < collection.length - 1) {
      var tmp = collection[key];
      collection[key] = collection[key + 1];
      collection[key + 1] = tmp;
    }
    $scope.updateScope();
  };
  $scope.updateField = function (field) {
    if (field.type === '') {
      delete field.type;
    }
    $scope.updateScope();
  };

  /**********************************************************************************************************/
  /*************** GESTIONE DEGLI ELEMENTI NEI TAB $scope.selected.model.form[0].items[i].tabs *************/
  /********************************************************************************************************/

  $scope.addItemOnArray = function (key, newItem) {
    if (newItem != undefined && newItem != null) {
      newItem.name = newItem.name.toString();
      if ($scope.itemTypeMap[key] == 'integer') {
        if (parseInt(newItem.name)) {
          newItem.value = parseInt(newItem.name);
          newItem.name = newItem.value.toString(); /* nel caso ci dovesse essere un cast, torno a sovrascrivere il name */
        } else {
          return;
        }
      } else if ($scope.itemTypeMap[key] == 'number') {
        if (parseFloat(newItem.name)) {
          newItem.value = parseFloat(newItem.name);
        } else {
          return;
        }
      } else {
        newItem.value = newItem.name.toString().replace(/\s/g, '_').toLowerCase();
      }
      for (var i in $scope.selected.model.form[0].items) {
        if ($scope.selected.model.form[0].items[i].tabs) {
          $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
            if (key == item.key[0]) {
              item.titleMap.push(newItem);
            }
          });
        }
      }
      this.newItem = null;
      $scope.updateScope();
    }
  };
  $scope.deleteItemOnArray = function (key, obj) {
    for (var i in $scope.selected.model.form[0].items) {
      if ($scope.selected.model.form[0].items[i].tabs) {
        $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
          if (key == item.key[0]) {
            for (var j = item.titleMap.length; j--;) {
              if (item.titleMap[j].value == obj.value) {
                item.titleMap.splice(j, 1);
              }
            }
          }
        });
      }
    }
    this.newItem = null;
    $scope.updateScope();
  };
  $scope.addRefOnArray = function (key, ref) {
    var newItem = {};
    if (ref.record_id != undefined && ref.record_id != null) {
      newItem.value = ref.record_id.code;
      newItem.name = ref.record_id.description;
      $scope.addItemOnArray(key, newItem);
    }
  };

  /*****************************************/
  /*************** FIX SCHEMA *************/
  /***************************************/

  $scope.fixSchemaFormModel = function () {
    for (var i in $scope.selected.model.form[0].items) {
      if ($scope.selected.model.form[0].items[i].tabs) {
        $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
          if (item.type == 'uiselect') {
            $scope.selected.model.schema.properties[item.key[0]].format = 'enum';
          }
          if (item.type == 'uiselectmultiple') {
            $scope.selected.model.schema.properties[item.key[0]].type = 'array';
          }
        });
      }
    }
  };

  /***************************************************************************/
  /***** UTILITY PER DATA BINDING TRA $scope.selected E $scope.aceModel *****/
  /*************************************************************************/

  $scope.isInheritable = function (type) {
    return type == 'number' || type == 'integer' || type == 'string' || type == 'boolean' || type == 'lookup';
  };
  $scope.formChanged = function () {
    $scope.aceModel = JSON.stringify(angular.copy($scope.selected), null, '\t');
  };
  $scope.chargeAceModel = function () {
    var defaultData = angular.fromJson(angular.copy($scope.aceModel));
    if (defaultData) {
      $scope.selected = defaultData;
      $scope.schema = angular.fromJson(defaultData.model.schema);
      $scope.form = angular.fromJson(defaultData.model.form);
      $scope.columnDefs = angular.fromJson(defaultData.model.columnDefs);
    }
  };
  $scope.updateScope = function () {
    $scope.schema = angular.fromJson(angular.copy($scope.selected.model.schema));
    $scope.form = [angular.fromJson(angular.copy($scope.selected.model.form[0]))];
    $scope.columnDefs = angular.fromJson(angular.copy($scope.selected.model.columnDefs));
    $scope.formChanged();
  };
  function addSelectedValue(array, obj) {
    var blankValuePresent = false;
    array.forEach(function (item) {
      if (item.value == obj.value && item.name == obj.name) {
        blankValuePresent = true;
      }
    });
    if (blankValuePresent == false) {
      array.push(obj);
    }
    return array;
  }
  $scope.getUiSelectMap = function () {
    $scope.uiselectMap = {};
    $scope.itemTypeMap = {};
    for (var i in $scope.selected.model.form[0].items) {
      if ($scope.selected.model.form[0].items[i].tabs) {
        $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
          if (item.type !== 'fieldset') {
            $scope.itemTypeMap[item.key[0]] = $scope.selected.model.schema.properties[item.key[0]].type;
            if ($scope.selected.model.schema.properties[item.key[0]].type == 'array') {
              $scope.itemTypeMap[item.key[0]] = $scope.selected.model.schema.properties[item.key[0]].items.type;
            }
            if (item.type == 'uiselect' || item.type == 'uiselectmultiple') {
              var blankObject = {
                name: '',
                value: ''
              };
              $scope.uiselectMap[item.key[0]] = addSelectedValue(item.titleMap, blankObject);
              /* aggiunto un elemento vuoto all'array per consentire il deselezionamento */
            }
          }
        });
      }
    }

    console.log($scope.itemTypeMap);
  };
  $scope.toggleEnumDefault = function (key, objValue) {
    var property = $scope.selected.model.schema.properties[key];
    if (typeof property["default"] == "undefined" || property["default"].indexOf(objValue) == -1) {
      property["default"] = [objValue];
    } else {
      property["default"] = undefined;
    }
    this.newItem = null;
    $scope.updateScope();
  };
  $scope.aceLoaded = function () {
    var defaultModel = {
      model: {
        schema: {
          type: "object",
          title: "",
          properties: {
            code: {
              title: "Codice",
              type: "string",
              check: true
            },
            description: {
              title: "Descrizione",
              type: "string",
              check: true
            }
          },
          required: ["code", "description"]
        },
        form: [{
          type: "fieldset",
          items: [{
            type: "tabs",
            tabs: [{
              title: "Dati Base",
              items: [{
                key: ["code"],
                title: "Codice",
                required: true,
                type: "text"
              }, {
                key: ["description"],
                title: "Descrizione",
                required: true,
                type: "text"
              }]
            }]
          }]
        }],
        columnDefs: [{
          "field": "code",
          "name": "Codice"
        }, {
          "field": "description",
          "name": "Descrizione"
        }]
      }
    };
    $scope.aceModel = JSON.stringify(defaultModel, null, '\t');
    $scope.chargeAceModel();
    $scope.title = angular.copy($scope.selected.model.form[0].title);
    acquisitionStepFactory().byUUID({
      id: $routeParams.id
    }).$promise.then(function (data) {
      if (data.model) {
        $scope.selected.model = angular.copy(data.model);
        $scope.fixSchemaFormModel();
        $scope.schema = angular.copy($scope.selected.model.schema);
        $scope.form = angular.copy($scope.selected.model.form);
        $scope.title = angular.copy($scope.selected.model.form[0].title);
        $scope.code = angular.copy($scope.selected.model.code);
        $scope.description = angular.copy($scope.selected.model.description);
        if ($scope.selected.model.columnDefs && $scope.selected.model.columnDefs.length != 0) {
          $scope.columnDefs = angular.copy($scope.selected.model.columnDefs);
        } else {
          $scope.columnDefs = [{
            name: 'Codice',
            field: 'code'
          }, {
            name: 'Descrizione',
            field: 'description'
          }];
          $scope.selected.model.columnDefs = angular.copy($scope.columnDefs);
        }
        angular.forEach($scope.columnDefs, function (value) {
          $scope.selected.model.schema.properties[value.field].check = true;
        });
        $scope.schema = angular.copy($scope.selected.model.schema);
        $scope.aceModel = JSON.stringify($scope.selected, null, '\t');
        $scope.model = {};
        $scope.customForm = angular.copy($scope.selected.model.customForm);
        $scope.history = angular.copy($scope.selected.model.history);
        $scope.attachmentManagement = angular.copy($scope.selected.model.attachmentManagement);
        $scope.getUiSelectMap();
      }
    });
  };
  $scope.$watch('customForm', function () {
    if ($scope.selected && $scope.selected.model) {
      $scope.selected.model.customForm = $scope.customForm;
      $scope.updateScope();
    }
  });
  $scope.$watch('attachmentManagement', function () {
    if ($scope.selected && $scope.selected.model) {
      $scope.selected.model.attachmentManagement = $scope.attachmentManagement;
      $scope.updateScope();
    }
  });
  $scope.refreshCode = function (code) {
    $scope.chargeAceModel();
    $scope.selected.model.code = angular.copy(code);
    $scope.updateScope();
  };
  $scope.refreshDescription = function (description) {
    $scope.chargeAceModel();
    if (description) {
      $scope.selected.model.description = angular.copy(description);
      if (angular.isUndefined($scope.selected.UUID)) {
        $scope.code = sixStringLib.removeDiacritics(description);
        $scope.code = $scope.code.replace(/[^\w]|_/g, '').replace(/^(\d)(.*)/, '_$1$2').toLowerCase();
        $scope.selected.model.code = angular.copy($scope.code);
      }
    }
    $scope.updateScope();
  };
  $scope.refreshLookup = function (key, entity_id) {
    $scope.chargeAceModel();
    for (var i = $scope.selected.model.form[0].items.length; i--;) {
      if ($scope.selected.model.form[0].items[i].key && $scope.selected.model.form[0].items[i].key[0] == key) {
        $scope.selected.model.form[0].items[i].entity_id = angular.copy(entity_id);
      }
      // Scorro anche i tabs
      if ($scope.selected.model.form[0].items[i].tabs) {
        for (var j = $scope.selected.model.form[0].items[i].tabs.length; j--;) {
          for (var k = $scope.selected.model.form[0].items[i].tabs[j].items.length; k--;) {
            if ($scope.selected.model.form[0].items[i].tabs[j].items[k].key[0] == key) $scope.selected.model.form[0].items[i].tabs[j].items[k].entity_id = angular.copy(entity_id);
          }
        }
      }
    }
    $scope.selected.model.schema.properties[key].entity_id = angular.copy(entity_id);
    $scope.updateScope();
  };
  $scope.refreshCommission = function () {
    $scope.chargeAceModel();
    $scope.selected.model.commission = [];
    angular.forEach($scope.commissionsSelected.codes, function (obj) {
      $scope.selected.model.commission.push(obj.code);
    });
    $scope.updateScope();
  };
  $scope.refreshFormula = function (key, formula_id) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].formula_id = angular.copy(formula_id);
    $scope.updateScope();
  };
  $scope.refreshFormulaParams = function (key, formula_params) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].formula_params = angular.copy(formula_params);
    $scope.updateScope();
  };
  $scope.refreshBasePath = function (key, basePath) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].basePath = angular.copy(basePath);
    $scope.updateScope();
  };
  $scope.refreshWar = function (key, war) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].war = angular.copy(war);
    $scope.updateScope();
  };
  $scope.refreshInheritRecord = function (key, record) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].record = angular.copy(record);
    $scope.updateScope();
  };
  $scope.refreshInheritField = function (key, field) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].field = angular.copy(field);
    $scope.updateScope();
  };
  $scope.refreshFiltered = function (key, filtered) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].filtered = angular.copy(filtered);
    $scope.updateScope();
  };
  $scope.refreshFilterSourceField = function (key, filterSourceField) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].filterSourceField = angular.copy(filterSourceField);
    $scope.updateScope();
  };
  $scope.refreshFilterDestField = function (key, filterDestField) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].filterDestField = angular.copy(filterDestField);
    $scope.updateScope();
  };
  $scope.refreshTitleForm = function (title) {
    $scope.chargeAceModel();
    $scope.selected.model.form[0].title = angular.copy(title);
    $scope.updateScope();
  };
  $scope.refreshCopyToCheckbox = function (key, enableCopyTo) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].enableCopyTo = angular.copy(enableCopyTo);
    if (enableCopyTo == false) {
      delete $scope.selected.model.schema.properties[key].copyTo;
    }
    $scope.updateScope();
  };
  $scope.addItemCopyTo = function (key, newItem) {
    if (newItem != undefined && newItem.name != null && newItem.name != '') {
      if (!angular.isDefined($scope.selected.model.schema.properties[key].copyTo)) {
        $scope.selected.model.schema.properties[key].copyTo = [];
      }
      $scope.selected.model.schema.properties[key].copyTo.push(newItem.name);
      this.newItem = null;
      $scope.updateScope();
    }
  };
  $scope.deleteItemCopyTo = function (key, refName) {
    if (angular.isDefined($scope.selected.model.schema.properties[key].copyTo)) {
      for (var j = $scope.selected.model.schema.properties[key].copyTo.length; j--;) {
        if ($scope.selected.model.schema.properties[key].copyTo[j] == refName) {
          $scope.selected.model.schema.properties[key].copyTo.splice(j, 1);
        }
      }
    }
    if ($scope.selected.model.schema.properties[key].copyTo.length == 0) {
      /* elimino la proprietà per mantenere pulito lo schema */
      $scope.selected.model.schema.properties[key].enableCopyTo = false;
      delete $scope.selected.model.schema.properties[key].copyTo;
    }
    $scope.updateScope();
  };
}]);
'use strict';

angular.module('emma.consip').controller('CreatePdi', ["$scope", "$q", "authFactory", "FileUploader", "alfrescoFactory", "ALFRESCO_URL", "REVISION_INSERTED", "$log", "ENV", function ($scope, $q, authFactory, FileUploader, alfrescoFactory, ALFRESCO_URL, REVISION_INSERTED, $log, ENV) {
  var DESTINATION = "/Sites/" + ENV + "/" + authFactory.getAuthData().info.commissions.current.code;
  var uploadError = false;
  var uploader = $scope.uploader = new FileUploader({
    url: ALFRESCO_URL + '/upload',
    removeAfterUpload: true,
    filters: [{
      name: 'single_xls',
      fn: function fn(file) {
        if (isExcel(file.name)) {
          return !this.queue.some(function (f) {
            var extension = f.file.name.split('.').pop();
            return extension == 'xls' || extension == 'xlsx';
          });
        }
        return true;
      }
    }, {
      name: 'unique_file',
      fn: function fn(file) {
        return this.queue.findIndex(function (fItem) {
          return fItem.file.name == file.name;
        }) < 0;
      }
    }],
    formData: [{
      destination: DESTINATION
    }]
  });
  $scope.upload = {
    show: false,
    errors: [],
    warnings: [],
    pupupEmissionOpened: false,
    pupupApprovalOpened: false,
    pupupRefusalOpened: false
  };
  $scope.loadQuote = function () {
    $scope.upload.completed = false;
    $scope.hasXls = false;
    $scope.revision = {
      date_emission: new Date(),
      revision_number: undefined,
      user: authFactory.getAuthData().authId,
      files: []
    };
    uploader.clearQueue();
    $scope.addQuote();
  };
  $scope.addQuote = function () {
    $scope.upload.errors.length = 0;
    $scope.upload.warnings.length = 0;
    angular.element('#fileUploadBtn').trigger('click');
  };
  $scope.confirmDisabled = function () {
    var noFiles = uploader.getNotUploadedItems().length == 0;
    var noEmissionDate = angular.isUndefined($scope.revision.date_emission) || $scope.revision.date_emission === '' || $scope.revision.date_emission === null;
    var noRevisionNumber = angular.isUndefined($scope.revision.revision_number) || $scope.revision.revision_number === '';
    return noFiles || noEmissionDate || noRevisionNumber || !$scope.hasXls || $scope.invalidPdi;
  };
  $scope.undoUpload = function () {
    $scope.upload.show = false;
    uploader.clearQueue();
    $scope.upload.warnings.length = 0;
  };
  $scope.onInvalidPdi = function () {
    $scope.invalidPdi = true;
  };
  $scope.remove = function (fileItem) {
    fileItem.remove();
    if (uploader.queue.length == 0) {
      $scope.undoUpload();
    } else if (isExcel(fileItem.file.name)) {
      $scope.xlsData = null;
      $scope.hasXls = false;
    }
  };
  function isExcel(filename) {
    var extension = filename.split('.').pop();
    return extension === 'xls' || extension === 'xlsx';
  }
  function printUploadError(errorMessage) {
    $scope.upload.errors.push(errorMessage);
  }
  function printUploadWarning(warningMessage) {
    if ($scope.upload.warnings.indexOf(warningMessage) < 0) $scope.upload.warnings.push(warningMessage);
  }
  function readXlsFromFile(file) {
    var response = $q.defer();
    var fileReader = new FileReader();
    fileReader.onload = function (e) {
      try {
        // pre-process data
        var binary = "";
        var bytes = new Uint8Array(e.target.result);
        for (var i = 0; i < bytes.length; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        // call 'xlsx' to read the file
        response.resolve(XLSX.read(binary, {
          type: 'binary',
          cellDates: true
        }));
      } catch (e) {
        response.reject(e);
      }
    };
    try {
      fileReader.readAsArrayBuffer(file);
    } catch (error) {
      response.reject(e);
    }
    return response.promise;
  }

  /** ***********************************
  * Uploader callbacks
  * ***********************************/
  uploader.onAfterAddingFile = function (fileItem) {
    if (isExcel(fileItem.file.name)) {
      $scope.hasXls = true;
      $scope.invalidPdi = false;
      readXlsFromFile(fileItem._file).then(function (data) {
        $scope.xlsData = data;
      }, function (err) {
        $log.error(err);
        fileItem.remove();
        $scope.hasXls = false;
      });
    }
  };
  uploader.onAfterAddingAll = function (addedFileItems) {
    $scope.upload.completed = false;
    $scope.upload.started = false;
    $scope.upload.show = true;
  };
  uploader.onBeforeUploadItem = function (item) {
    $scope.upload.started = true;
  };
  uploader.onSuccessItem = function (fileItem, response, status, headers) {
    if (angular.isDefined(response.ERROR)) {
      uploadError = true;
      $scope.upload.show = false;
      printUploadError(response.ERROR);
    } else {
      uploadError = false;
      fileItem.objectId = response.objectId;
      $scope.revision.files.push({
        title: fileItem.file.name,
        user: authFactory.getAuthData().authId,
        date_insertion: new Date(),
        destination: DESTINATION,
        object_id: fileItem.objectId
      });
    }
  };
  uploader.onErrorItem = function (fileItem, response, status, headers) {
    $scope.undoUpload();
    uploadError = true;
    $scope.upload.show = false;
    printUploadError("Errore nel caricamento del file " + fileItem.file.name);
  };
  uploader.onCompleteAll = function () {
    $scope.upload.completed = true;
    $scope.upload.show = false;
    $scope.revision.approval_status = REVISION_INSERTED;
    if (!uploadError) $scope.addRevision($scope.revision, "uploader.onCompleteAll"); //controller padre
  };

  uploader.onWhenAddingFileFailed = function (item, filter) {
    switch (filter.name) {
      case 'single_xls':
        printUploadWarning('Non è possibile caricare più file Excel per una stessa revisione.');
        break;
      case 'unique_file':
        printUploadWarning('Stai già caricando il file "' + item.name + '"');
        break;
    }
  };
}]);
'use strict';

/**
 * N.B. Il controller principale resta AcquisitionWizardCtrl. Quì c'è solo la logica per lo step OPF,
 * che richiede una gestione un po' particolare non riconducibile al semplice schema/form.
 */
angular.module('emma.consip').controller('OpfCtrl', ["$scope", "dialogService", "toaster", "stepToWizardService", "orderRowFactory", "authFactory", "userFactory", "additionalActsFactory", "ALFRESCO_URL", "uiGridConstants", "recordFactory", "plafondSrv", function ($scope, dialogService, toaster, stepToWizardService, orderRowFactory, authFactory, userFactory, additionalActsFactory, ALFRESCO_URL, uiGridConstants, recordFactory, plafondSrv) {
  var currentContract = authFactory.getAuthData().info.commissions.current;
  var gridColumnAdaptCommand = {
    title: 'Adatta colonne',
    icon: 'fa fa-text-width',
    action: function action($event) {
      document.querySelectorAll(".ui-grid-column-resizer.right").forEach(function (el) {
        el.dispatchEvent(new CustomEvent("dblclick"));
      });
    },
    order: 208
  };
  var COLUMNS = {
    QTA: 'Qta',
    PU: 'PU',
    PERC_SCONTO: '% Sconto',
    MESI_EROGAZIONE: 'Mesi erogazione',
    N_PREST_PER_ANNO: 'N° prest x anno',
    RIDUZ_PER_ATTIVITA: 'Riduzione x attivita canone',
    REPERIBLILITA: 'Reperibilita',
    IMPORTO_TOTALE: 'Importo totale',
    IMPORTO_ANNUO: 'Importo annuo',
    SERVIZIO: 'Servizio',
    EDIFICIO: 'Edificio',
    UM: 'UM',
    START_DATE: 'Data inizio',
    END_DATE: 'Data fine'
  };
  var RELATED_COLUMNS = [COLUMNS.SERVIZIO, COLUMNS.EDIFICIO, COLUMNS.UM];
  $scope.gridSeOptions = {
    enableGridMenu: true,
    enableFiltering: true,
    showColumnFooter: true,
    gridMenuCustomItems: [gridColumnAdaptCommand],
    onRegisterApi: function onRegisterApi(gridApi) {
      $scope.gridSeApi = gridApi;
    },
    data: 'seData',
    columnDefs: [{
      displayName: 'Tipo servizio',
      field: 'service_type',
      footerCellTemplate: '<div class= "ui-grid-cell-contents"><b>Totali:</b></div>'
    }, {
      displayName: 'Cod servizio',
      field: 'service.model.code'
    }, {
      displayName: 'Gruppo servizi',
      field: 'service.model.description'
    }, {
      displayName: 'Classe',
      field: 'service.model.classeservizio_id.description'
    }, {
      displayName: 'Importo annuo',
      field: 'year_amount',
      cellClass: 'cont-right',
      cellFilter: 'currency:"€":2',
      aggregationHideLabel: true,
      footerCellClass: 'cont-right',
      footerCellFilter: 'currency:"€":2',
      aggregationType: uiGridConstants.aggregationTypes.sum
    }, {
      displayName: 'Importo totale',
      field: 'total_amount',
      cellClass: 'cont-right',
      cellFilter: 'currency:"€":2',
      aggregationHideLabel: true,
      footerCellClass: 'cont-right',
      footerCellFilter: 'currency:"€":2',
      aggregationType: uiGridConstants.aggregationTypes.sum
    }, {
      displayName: 'Data inizio',
      field: 'start_date',
      cellClass: 'cont-center',
      cellFilter: 'date:"dd/MM/yyyy"'
    }, {
      displayName: 'Data fine',
      field: 'end_date',
      cellClass: 'cont-center',
      cellFilter: 'date:"dd/MM/yyyy"'
    }]
  };
  $scope.gridDveOptions = {
    enableGridMenu: true,
    enableFiltering: true,
    showColumnFooter: true,
    gridMenuCustomItems: [gridColumnAdaptCommand],
    onRegisterApi: function onRegisterApi(gridApi) {
      $scope.gridDveApi = gridApi;
    },
    data: 'dveData',
    columnDefs: [{
      displayName: 'Cod sito',
      field: 'building.model.code',
      footerCellTemplate: '<div class= "ui-grid-cell-contents font-bold">Totali:</div>'
    }, {
      displayName: 'Nome sito',
      field: 'building.model.description'
    }, {
      displayName: 'Tipo servizio',
      field: 'service_type'
    }, {
      displayName: 'Cod servizio',
      field: 'service.model.code'
    }, {
      displayName: 'Gruppo servizi',
      field: 'service.model.description'
    }, {
      displayName: 'Classe',
      field: 'service.model.classeservizio_id.description'
    }, {
      displayName: 'PU',
      field: 'pu',
      cellClass: 'cont-right',
      cellFilter: 'currency:"€":4'
    }, {
      displayName: 'Qta',
      field: 'qty'
    }, {
      displayName: 'Prestazioni per anno',
      field: 'annual_services'
    }, {
      displayName: 'UM',
      field: 'um.model.description'
    }, {
      displayName: 'Mesi erogazione',
      field: 'months'
    }, {
      displayName: 'Importo annuo',
      field: 'year_amount',
      cellClass: 'cont-right',
      cellFilter: 'currency:"€":2',
      aggregationHideLabel: true,
      footerCellClass: 'cont-right',
      footerCellFilter: 'currency:"€":2',
      aggregationType: uiGridConstants.aggregationTypes.sum
    }, {
      displayName: 'Importo totale',
      field: 'total_amount',
      cellClass: 'cont-right',
      cellFilter: 'currency:"€":2',
      aggregationHideLabel: true,
      footerCellClass: 'cont-right',
      footerCellFilter: 'currency:"€":2',
      aggregationType: uiGridConstants.aggregationTypes.sum
    }, {
      displayName: 'Data inizio',
      field: 'start_date',
      cellClass: 'cont-center',
      cellFilter: 'date:"dd/MM/yyyy"'
    }, {
      displayName: 'Data fine',
      field: 'end_date',
      cellClass: 'cont-center',
      cellFilter: 'date:"dd/MM/yyyy"'
    }, {
      displayName: 'Reperibilità',
      field: 'availability'
    }, {
      displayName: 'Sconto',
      field: 'discount'
    }, {
      displayName: 'Riduzione per attività',
      field: 'activity_discount'
    }]
  };
  $scope.validFormItem = function (item) {
    return !(item.type == 'array' || item.key[0] == 'reporter_id');
  };
  $scope.getInputType = function (modelItem) {
    if (modelItem.type == 'datepicker') {
      return 'date';
    } else {
      return modelItem.type;
    }
  };
  $scope.exportSe = function () {
    sixExportLib.exportXLSXAllRowsGrid($scope.gridSeApi, currentContract.code + '_opf_se_' + $scope.wizard.model.client_id.code);
  };
  $scope.exportDve = function () {
    sixExportLib.exportXLSXAllRowsGrid($scope.gridDveApi, currentContract.code + '_opf_dve_' + $scope.wizard.model.client_id.code);
  };
  function resolveRecords() {
    return recordFactory('WTF').bulkResolve(reduceData($scope.fileRows)).$promise.then(function (resolvedEntities) {
      var groupedRow = {},
        anagraphicError = false;
      $scope.opfModel.totals = {
        canone: 0,
        extra_canone: 0,
        total: 0
      };
      $scope.dveData = $scope.fileRows.map(function (row) {
        var service = resolvedEntities.servizio[row[COLUMNS.SERVIZIO]],
          building = resolvedEntities.edificio[row[COLUMNS.EDIFICIO]],
          um = resolvedEntities.um[row[COLUMNS.UM].replace(/\//g, '_').toLowerCase()];
        if (service && building && um) {
          var service_type = service.model.una_tantum ? 'extra canone' : 'canone',
            total = row[COLUMNS.IMPORTO_TOTALE],
            key = service.UUID;
          $scope.opfModel.totals.total += total;
          if (service_type == 'canone') {
            $scope.opfModel.totals.canone += total;
          } else {
            $scope.opfModel.totals.extra_canone += total;
          }
          if (!groupedRow[key]) {
            groupedRow[key] = {
              service: service,
              service_type: service_type,
              start_date: row[COLUMNS.START_DATE],
              end_date: row[COLUMNS.END_DATE],
              total_amount: total,
              year_amount: row[COLUMNS.IMPORTO_ANNUO]
            };
          } else {
            var serow = groupedRow[key];
            serow.total_amount += total;
            serow.year_amount += row[COLUMNS.IMPORTO_ANNUO];
          }
          return {
            building: building,
            um: um,
            service: service,
            service_type: service_type,
            qty: row[COLUMNS.QTA],
            pu: row[COLUMNS.PU],
            discount: row[COLUMNS.PERC_SCONTO],
            availability: row[COLUMNS.REPERIBLILITA],
            months: row[COLUMNS.MESI_EROGAZIONE],
            annual_services: row[COLUMNS.N_PREST_PER_ANNO],
            activity_discount: row[COLUMNS.RIDUZ_PER_ATTIVITA],
            start_date: row[COLUMNS.START_DATE],
            end_date: row[COLUMNS.END_DATE],
            total_amount: total,
            year_amount: row[COLUMNS.IMPORTO_ANNUO]
          };
        } else {
          anagraphicError = true;
        }
      });
      $scope.seData = Object.values(groupedRow);
      $scope.wizard.partial_plafond = $scope.opfModel.totals.total;
      if (!$scope.isWizardReadonly()) {
        if (anagraphicError) {
          toaster.pop('error', '', 'Alcuni dati caricati nel file non hanno corrispondenza in anagrafica.');
        } else if ($scope.wizard.partial_plafond > $scope.plafond.residual) {
          toaster.pop('error', '', 'Plafond residuo insufficiente.');
        } else {
          stepToWizardService.unlockStepCallback(stepToWizardService.opfIndex);
        }
      }
    }, function (err) {
      console.error(err);
    });
  }
  function reduceData(rows) {
    return rows.reduce(function (entities, row) {
      RELATED_COLUMNS.forEach(function (col) {
        var code = col == COLUMNS.UM ? row[COLUMNS.UM].replace(/\//g, '_').toLowerCase() : row[col];
        if (code) {
          var entityRequest = entities[col.toLowerCase()];
          if (!entityRequest[code]) {
            entityRequest[code] = 1;
          }
        } else {
          console.error("Impossibile trovare il codice");
        }
      });
      return entities;
    }, RELATED_COLUMNS.reduce(function (body, col) {
      body[col.toLowerCase()] = {};
      return body;
    }, {}));
  }
  function fixDates(opfModel) {
    if (angular.isDefined(opfModel)) {
      $scope.opfForm[0].items.forEach(function (item) {
        item.tabs.forEach(function (tab) {
          tab.items.forEach(function (model_item) {
            if (model_item.type === 'datepicker') {
              var propertyName = model_item.key[0];
              if (angular.isDefined(opfModel[propertyName]) && opfModel[propertyName] != null) {
                opfModel[propertyName] = new Date(opfModel[propertyName]);
              }
            }
          });
        });
      });
    }
    return opfModel;
  }
  function getAdditionalActsTotals(additional_acts) {
    if (angular.isArray(additional_acts) && additional_acts.length) {
      var payload = {
        step_id: $scope.opfId,
        attribute: 'totals',
        list: additional_acts.map(function (act) {
          return act.UUID;
        })
      };
      additionalActsFactory.getAttributes(payload).$promise.then(function (data) {
        if (data.response.total_results > 0) {
          $scope.additionalActTotals = {
            canone: 0,
            extra_canone: 0,
            total: 0
          };
          $scope.additionalActs = data.response.list;
          $scope.additionalActs.filter(function (opf) {
            return opf.totals != null;
          }).forEach(function (opf) {
            var tot = opf.totals;
            $scope.additionalActTotals.canone += tot.canone;
            $scope.additionalActTotals.extra_canone += tot.extra_canone;
            $scope.additionalActTotals.total += tot.total;
          });
        }
      });
    }
  }
  function loadPdi(xls_quote) {
    var objectId = xls_quote.replace('workspace://SpacesStore/', '$WorkspaceSpacesStore$');
    var file = ALFRESCO_URL + '/api/alfresco/' + objectId;
    console.log("Loading... ", file);
    toaster.pop({
      type: 'info',
      title: 'Caricamento PDI',
      body: 'Caricamento PDI in corso...',
      toastId: 'loading',
      timeout: 0
    });
    var httpFileRequest = new XMLHttpRequest();
    httpFileRequest.onload = function (e) {
      var arraybuffer = httpFileRequest.response;

      /* convert data to binary string */
      var data = new Uint8Array(arraybuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");

      /* Call XLSX */
      try {
        var workbook = XLSX.read(bstr, {
          type: "binary",
          cellDates: true
        });
        $scope.fileRows = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], {
          raw: true
        });
        resolveRecords().then(function () {
          toaster.clear('*', 'loading');
        });
      } catch (err) {
        $scope.errorMsg = 'Il file excel caricato presenta un formato non valido.';
        stepToWizardService.lockStepCallback(stepToWizardService.opfIndex);
      }
    };
    httpFileRequest.open("GET", file, true);
    httpFileRequest.responseType = "arraybuffer";
    httpFileRequest.send();
  }
  function saveOrder() {
    var acquisitionUUID = $scope.wizard.UUID;
    var orderType = 'opf';
    if (angular.isDefined($scope.wizard.model.source_acquisition_id)) {
      acquisitionUUID = $scope.wizard.model.source_acquisition_id.UUID;
      orderType = 'aa';
    }
    var opfCode = $scope.opfModel.code,
      orderRows = $scope.dveData.map(function (row) {
        return {
          acquisition_uuid: acquisitionUUID,
          model: {
            code: opfCode,
            tipo_riga: orderType,
            data_inizio: row.start_date,
            data_fine: row.end_date,
            mesi_erogazione: row.months,
            pu: row.pu,
            qta: row.qty,
            importo_annuo: row.year_amount,
            importo_totale: row.total_amount,
            edificio_id: sixObjectLib.recordToHisRef(row.building),
            um_id: sixObjectLib.recordToHisRef(row.um),
            servizio_id: sixObjectLib.recordToHisRef(row.service),
            classeservizio_id: row.service.model.classeservizio_id,
            tipo_servizio: row.service_type,
            sconto: row.discount,
            sconto_attivita: row.activity_discount,
            reperibilita: row.availability,
            prestazioni_annue: row.annual_services
          }
        };
      });
    return orderRowFactory.bulkSave(orderRows).$promise.then(function (data) {
      toaster.pop('info', '', data.list.length + ' Opf salvati con successo');
      stepToWizardService.beforeApproval = angular.identity;
      return true;
    });
  }
  $scope.forceSaveOrder = function () {
    dialogService.confirmDialog("L'operazione duplicherà gli ordini già creati. Continuare?", function () {
      saveOrder();
    });
  };

  /** ***********************************
   * Messaggi e notifiche
   * ***********************************/

  $scope.loadingSixMail = true;
  $scope.getMessage = function () {
    /* creazione testo mail */
    var searchInit = {
      search: {
        obj: {
          username: authFactory.getAuthData().authId
        }
      },
      init: {
        authId: true,
        email: true
      }
    };
    $scope.opfRef = getOpfRef();
    $scope.loadingSixMail = true;
    userFactory.getMail(searchInit).$promise.then(function (response) {
      $scope.loadingSixMail = false;
      $scope.objMail = {
        title: '',
        to: '',
        cc: formatMailCc(response[0].list[0].email),
        message: 'Testo di esempio da sostituire'
      };
    }, function (err) {
      console.error(err);
    });
  };
  function getOpfRef() {
    var ref = null;
    if ($scope.wizard) {
      return sixObjectLib.recordToHisRef($scope.wizard);
    }
    return ref;
  }
  function formatMailCc(UserMailSix) {
    if (UserMailSix) {
      return UserMailSix;
    } else {
      return null;
    }
  }

  /** ***********************************
   * MAIN
   * ***********************************/

  function initController() {
    stepToWizardService.lockStepCallback(stepToWizardService.opfIndex);
    $scope.opfId = 'step' + (stepToWizardService.opfIndex + 1);
    $scope.opfForm = stepToWizardService.opfForm;
    $scope.opfModel = fixDates(stepToWizardService.opfModel);
    $scope.data = {
      model: $scope.opfModel
    };
    getAdditionalActsTotals($scope.wizard.model.additional_acts);
    plafondSrv.getContractPlafond().then(function (data) {
      $scope.plafond = data;
    }, function (err) {
      $scope.plafond = {
        residual: -1
      };
      toaster.pop('error', '', 'Impossibile calcolare il plafond');
    });
    if ($scope.wizard.model.approved_xls_quote) {
      loadPdi($scope.wizard.model.approved_xls_quote);
    }
    if (!$scope.isWizardReadonly() && $scope.wizard.model.current_step.step == $scope.opfId) {
      stepToWizardService.beforeApproval = saveOrder;
    } else {
      stepToWizardService.beforeApproval = angular.identity;
    }
  }
  stepToWizardService.initOpfCallback = initController;
  initController();
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:PdiCtrl
 * @description
 * # PdiCtrl
 * Controller of the sixEmmaApp
 */

/**
 * N.B. Il controller principale resta AcquisitionWizardCtrl. Quì c'è solo la logica per lo step PDI,
 * che richiede una gestione un po' particolare non riconducibile al semplice schema/form.
 */
angular.module('emma.consip').controller('PdiCtrl', ["$scope", "stepToWizardService", "$rootScope", "$log", "ALFRESCO_URL", "REVISION_INSERTED", "REVISION_APPROVED", "REVISION_REFUSED", function ($scope, stepToWizardService, $rootScope, $log, ALFRESCO_URL, REVISION_INSERTED, REVISION_APPROVED, REVISION_REFUSED) {
  $scope.DOWNLOAD_URL = ALFRESCO_URL + "/api/alfresco/";
  $scope.editing = [];
  $scope.approveQuote = function (revision, index) {
    if (angular.isDefined(revision.date_refusal)) {
      // Revisione vecchia, la archivio.
      var oldRevision = jQuery.extend(true, {}, revision);
      oldRevision.date_out = new Date();
      delete oldRevision['selected'];
      $scope.revisions.splice(index, 0, oldRevision);
      index++;
    }
    revision.approval_status = REVISION_APPROVED;
    revision.selected = true;
    revision.date_approval = new Date();
    $scope.wizard.model.approved_xls_quote = getApprovedExcel(revision);
    delete revision.date_refusal;
    // Se avevo già un'altra revisione approvata la rifiuto. Altrimenti salvo e bona.
    var list = getApprovedRevisions();
    var found = false;
    if (list.length > 0) {
      for (var i = 0; i < list.length; i++) {
        if (list[i] != index) {
          found = true;
          $scope.refuseQuote($scope.revisions[list[i]], list[i]);
        }
      }
    }
    if (!found) {
      checkLockStepApproval();
      saveStep("$scope.approveQuote");
    }
  };
  function getApprovedExcel(revision) {
    var excelPath = undefined;
    if (revision.selected) {
      for (var i = 0; i < revision.files.length; i++) {
        var file = revision.files[i];
        if (isExcel(file.title)) {
          excelPath = file.object_id;
          break;
        }
      }
    }
    return excelPath;
  }
  $scope.differentFromPrevious = function (index) {
    var result = true;
    if (index > 0) {
      result = $scope.revisions[index].revision_number !== $scope.revisions[index - 1].revision_number;
    }
    return result;
  };
  $scope.startEditQuote = function (index) {
    $scope.datesError = false;
    $scope.editing[index] = true;
    $scope.editingMode = true;
    $scope.editData = {};
    if (angular.isDefined($scope.revisions[index].date_approval)) {
      $scope.editData.date_approval = new Date($scope.revisions[index].date_approval);
    }
    if (angular.isDefined($scope.revisions[index].date_emission)) {
      $scope.editData.date_emission = new Date($scope.revisions[index].date_emission);
    }
    if (angular.isDefined($scope.revisions[index].date_refusal)) {
      $scope.editData.date_refusal = new Date($scope.revisions[index].date_refusal);
    }
  };
  $scope.areDatesValid = function (index) {
    $scope.datesError = false;
    if (!$scope.editData.date_emission) {
      $scope.datesError |= true;
    }
    if (!$scope.datesError && angular.isDefined($scope.revisions[index].date_approval)) {
      if (angular.isUndefined($scope.editData.date_approval)) {
        $scope.datesError |= true;
      } else {
        $scope.datesError |= $scope.editData.date_approval < $scope.editData.date_emission;
      }
    }
    if (!$scope.datesError && angular.isDefined($scope.revisions[index].date_refusal)) {
      if (angular.isUndefined($scope.editData.date_refusal)) {
        $scope.datesError |= true;
      } else {
        $scope.datesError |= $scope.editData.date_refusal < $scope.editData.date_emission;
      }
    }
    return !$scope.datesError;
  };
  $scope.stopEditQuote = function (index) {
    if ($scope.areDatesValid(index)) {
      $scope.editing[index] = false;
      $scope.editingMode = false;
      if (angular.isDefined($scope.editData.date_approval)) {
        $scope.revisions[index].date_approval = $scope.editData.date_approval;
      }
      if (angular.isDefined($scope.editData.date_emission)) {
        $scope.revisions[index].date_emission = $scope.editData.date_emission;
        for (var i = index - 1; i >= 0; i--) {
          if ($scope.revisions[index].revision_number === $scope.revisions[i].revision_number) {
            $scope.revisions[i].date_emission = $scope.pupupEmissionOpenededitData.date_emission;
          } else {
            break;
          }
        }
      }
      if (angular.isDefined($scope.editData.date_refusal)) {
        $scope.revisions[index].date_refusal = $scope.editData.date_refusal;
      }
      saveStep("$scope.stopEditQuote");
    }
  };
  $scope.undoEditQuote = function (index) {
    $scope.editing[index] = false;
    $scope.editingMode = false;
  };
  $scope.refuseQuote = function (revision, index) {
    delete revision['selected'];
    if (angular.isDefined(revision.date_approval)) {
      // Revisione vecchia, la archivio.
      var oldRevision = jQuery.extend(true, {}, revision);
      oldRevision.date_out = new Date();
      $scope.revisions.splice(index, 0, oldRevision);
      if (!existsSelectedRevision()) {
        $scope.wizard.model.approved_xls_quote = undefined;
      }
    }
    revision.approval_status = REVISION_REFUSED;
    revision.date_refusal = new Date();
    delete revision.date_approval;
    checkLockStepApproval();
    saveStep("$scope.refuseQuote");
  };
  function existsSelectedRevision() {
    var exists = false;
    for (var i = 0; i < $scope.revisions.length; i++) {
      if ($scope.revisions[i].selected) {
        exists = true;
        break;
      }
    }
    return exists;
  }
  $scope.isInserted = function (revision, index) {
    if (angular.isDefined(index)) {
      for (var i = index + 1; i < $scope.revisions.length; i++) {
        var different = $scope.differentFromPrevious(i);
        if (!different) {
          revision = $scope.revisions[i];
        } else {
          break;
        }
      }
    }
    var result = revision.approval_status === REVISION_INSERTED;
    return result;
  };
  $scope.isRefused = function (revision, index) {
    if (angular.isDefined(index)) {
      for (var i = index + 1; i < $scope.revisions.length; i++) {
        var different = $scope.differentFromPrevious(i);
        if (!different) {
          revision = $scope.revisions[i];
        } else {
          break;
        }
      }
    }
    var result = revision.approval_status === REVISION_REFUSED;
    return result;
  };
  $scope.isApproved = function (revision, index) {
    if (angular.isDefined(index)) {
      for (var i = index + 1; i < $scope.revisions.length; i++) {
        var different = $scope.differentFromPrevious(i);
        if (!different) {
          revision = $scope.revisions[i];
        } else {
          break;
        }
      }
    }
    var result = revision.approval_status === REVISION_APPROVED;
    return result;
  };
  $scope.isOld = function (revision) {
    var result = angular.isDefined(revision.date_out);
    return result;
  };

  //TEMPORANEO DA CANCELLARE!! Solo per test in fase di sviluppo.
  $scope.reset = function () {
    stepToWizardService.pdiModel.revisions.length = 0;
    saveStep("$scope.reset");
  };
  function saveStep(caller) {
    $log.warn(caller);
    stepToWizardService.saveCallback();
  }
  $rootScope.$on('acquisitionWizard:readonlyChange', function (event, param) {
    $scope.readonlyMode = param[stepToWizardService.pdiIndex];
  });
  function getApprovedRevisions() {
    var array = [];
    if (angular.isDefined(stepToWizardService.pdiModel.revisions)) {
      for (var i = 0; i < stepToWizardService.pdiModel.revisions.length; i++) {
        var revision = stepToWizardService.pdiModel.revisions[i];
        if (angular.isUndefined(revision.date_out) && revision.approval_status === REVISION_APPROVED) {
          array.push(i);
        }
      }
    }
    return array;
  }
  function checkLockStepApproval() {
    var locked = !(getApprovedRevisions().length > 0);
    if (locked) {
      stepToWizardService.lockStepCallback(stepToWizardService.pdiIndex);
    } else {
      stepToWizardService.unlockStepCallback(stepToWizardService.pdiIndex);
    }
  }
  $scope.addRevision = function (revision, caller) {
    stepToWizardService.pdiModel.revisions.push(revision);
    updateEditing();
    saveStep(caller);
  };
  function initFiles() {
    if (angular.isUndefined(stepToWizardService.pdiModel.revisions)) {
      stepToWizardService.pdiModel.revisions = [];
    }
    $scope.revisions = stepToWizardService.pdiModel.revisions;
    $scope.pdiIndex = stepToWizardService.pdiIndex;
    $scope.pdiId = 'step' + ($scope.pdiIndex + 1);
    $scope.pdiSchema = stepToWizardService.pdiSchema;
    $scope.pdiForm = stepToWizardService.pdiForm;
    $scope.pdiModel = stepToWizardService.pdiModel;
    updateEditing();
  }
  function updateEditing() {
    $scope.editing.length = 0;
    for (var i = 0; i < $scope.revisions.length; i++) {
      $scope.editing[i] = false;
    }
  }
  function initController() {
    initFiles();
    checkLockStepApproval();
  }
  function isExcel(filename) {
    var extension = filename.split('.').pop();
    return extension === 'xls' || extension === 'xlsx';
  }

  //__main__
  stepToWizardService.initPdiCallback = initController;
  initController();
  $scope.transformObjectIdForBackend = function (objectId) {
    return objectId.replace('workspace://SpacesStore/', '$WorkspaceSpacesStore$');
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:AcquisitionWizardCtrl
 * @description
 * # AcquisitionWizardCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.consip').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/acquisitionwizard/detail/:id', {
    templateUrl: 'consip/acquisitionwizard/acquisitionwizard_detail.html',
    controller: 'AcquisitionWizardCtrl',
    consipEntity: 'acquisitionwizard'
  }).when('/additionalacts/detail/:id', {
    templateUrl: 'consip/acquisitionwizard/acquisitionwizard_detail.html',
    controller: 'AcquisitionWizardCtrl',
    consipEntity: 'additionalacts'
  });
}]).constant('ADHESION_ACTIVE', 0).constant('ADHESION_REFUSED', 1).constant('STEP_TIMING_OFF', 0).constant('STEP_TIMING_OK', 1).constant('STEP_TIMING_WARNING', 2).constant('STEP_TIMING_PENALTY', 3).controller('AcquisitionWizardCtrl', ["$scope", "contractFactory", "$location", "acquisitionStepFactory", "$routeParams", "authFactory", "loginFactory", "acquisitionWizardFactory", "additionalActsFactory", "dialogService", "toaster", "stepToWizardService", "$rootScope", "$q", "$timeout", "ADHESION_REFUSED", "$log", "$route", "plafondSrv", function ($scope, contractFactory, $location, acquisitionStepFactory, $routeParams, authFactory, loginFactory, acquisitionWizardFactory, additionalActsFactory, dialogService, toaster, stepToWizardService, $rootScope, $q, $timeout, ADHESION_REFUSED, $log, $route, plafondSrv) {
  $scope.tabs = [];
  $scope.stepIds = [];
  $scope.activeTab = 0;
  $scope.wizard = {
    model: {
      current_step: 'step1'
    }
  };
  $scope.pdiStep = undefined;
  $scope.opfStep = undefined;
  $scope.stepCount = 0;
  $scope.form = {};
  $scope.model = {};
  $scope.schema = {};
  $scope.backToList = function () {
    $location.path('acquisitionwizard');
  };
  var istatAdjustmentConfig;
  $scope.getContract = function () {
    contractFactory().recordByCommission().$promise.then(function (data) {
      if (angular.isUndefined(data.model)) {
        dialogService.alert('Non è stato definito un modello per la convenzione corrente', 4000);
      } else {
        $scope.contract = data;
        getConstraints(data);
        initTabs();
        istatAdjustmentConfig = data.model.istat_config;
        // Carico le form per i singoli step e le riempio con i dati della specifica acquisizione (wizard)
        var wizard_promise;
        if ($scope.isAdditionalAct) {
          wizard_promise = additionalActsFactory.getActByUUID({
            id: $routeParams.id
          }).$promise;
        } else {
          wizard_promise = acquisitionWizardFactory.getWizardByUUID({
            id: $routeParams.id
          }).$promise;
        }
        var waitForPromises = {
          wizard: wizard_promise
        };
        for (var i = 0; i < $scope.stepCount; i++) {
          var stepId = $scope.stepIds[i];
          waitForPromises[stepId] = acquisitionStepFactory().byUUID({
            id: $scope.contract.model.steps[stepId].step_id.UUID
          }).$promise;
        }
        var combinedPromise = $q.all(waitForPromises);
        combinedPromise.then(function (responses) {
          if (angular.isUndefined(responses.wizard.model)) {
            $scope.backToList();
          } else {
            setWizard(responses.wizard);
            for (var i = 0; i < $scope.stepCount; i++) {
              var stepId = $scope.stepIds[i];
              $scope.getStep(responses[stepId], i, stepId);
            }
            // Aspetto che l'interfaccia si sia caricata
            $timeout(function () {
              $scope.initActiveTab();
              $scope.initAttachments();
            }, 0);
          }
        });
      }
    });
  };
  function getConstraints(document) {
    var constraintMap = angular.copy(document.model.constraints) || {};
    for (var key in constraintMap) {
      constraintMap[key].forEach(function (keyConstrain) {
        keyConstrain.value = document.model[keyConstrain.key] ? document.model[keyConstrain.key] : document[keyConstrain.key];
      });
    }
    $scope.constraints = constraintMap;
  }
  function setWizard(data) {
    $scope.wizard = data;
    forceCustomerProfile($scope.wizard.model.client_id);
    $scope.wizard.dataIn = new Date($scope.wizard.dataIn);
    stepToWizardService.document = $scope.wizard;
    $log.info($scope.wizard);
  }
  function initTabs() {
    $scope.stepCount = Object.keys($scope.contract.model.steps).length;
    for (var i = 0; i < $scope.stepCount; i++) {
      var newTab = {
        title: 'Step N.1',
        disabled: false,
        approvalLocked: false,
        attachments: []
      };
      $scope.tabs.push(newTab);
      $scope.stepIds.push($scope.getId(i + 1));
    }
  }
  $scope.isApprovalLocked = function () {
    var locked = $scope.isWizardReadonly();
    if (!locked && angular.isDefined($scope.activeTab) && angular.isDefined($scope.tabs[$scope.activeTab])) {
      locked = $scope.tabs[$scope.activeTab].approvalLocked;
    }
    if (locked) {
      locked = locked;
    }
    return locked;
  };
  function initPdiStep(tabIndex) {
    $scope.pdiStep = $scope.getId(tabIndex + 1); // "step" + (tabIndex+1);
    stepToWizardService.pdiIndex = tabIndex;
    stepToWizardService.pdiModel = $scope.wizard.model[$scope.pdiStep].model;
    stepToWizardService.pdiSchema = $scope.tabs[tabIndex].schema;
    stepToWizardService.pdiForm = $scope.tabs[tabIndex].form;
    stepToWizardService.saveCallback = $scope.save;
    stepToWizardService.lockStepCallback = lockStep;
    stepToWizardService.unlockStepCallback = unlockStep;
  }
  function initOpfStep(tabIndex) {
    $scope.opfStep = $scope.getId(tabIndex + 1); // "step" + (tabIndex+1);
    stepToWizardService.opfIndex = tabIndex;
    stepToWizardService.opfModel = $scope.wizard.model[$scope.opfStep].model;
    stepToWizardService.opfSchema = $scope.tabs[tabIndex].schema;
    stepToWizardService.opfForm = $scope.tabs[tabIndex].form;
    stepToWizardService.saveCallback = $scope.save;
    stepToWizardService.lockStepCallback = lockStep;
    stepToWizardService.unlockStepCallback = unlockStep;
  }
  $scope.initActiveTab = function () {
    var i = -1;
    for (i = 0; i < $scope.stepCount; i++) {
      if ($scope.wizard.model.current_step.step === $scope.stepIds[i]) {
        $scope.activeTab = i;
        $scope.maxActiveTab = i;
        break;
      }
    }
    if (i < 0 || i >= $scope.stepCount) {
      if ($scope.wizard.model.current_step.status == 'terminated') {
        $scope.activeTab = $scope.stepCount - 1;
        $scope.maxActiveTab = $scope.stepCount;
      } else {
        $scope.activeTab = 0;
        $scope.maxActiveTab = 0;
      }
    }
    updateDisabledTabs();
    updateReadonlyTabs();
  };

  /* rende non modificabili i precedenti a quello corrente */
  function updateReadonlyTabs() {
    var readonlyArray = [];
    for (var i = 1; i <= $scope.tabs.length; i++) {
      if (i <= $scope.maxActiveTab || $scope.isWizardReadonly()) {
        $('#step' + i + ' input').attr("disabled", true);
        $('#step' + i + ' .ui-select-choices').css("visibility", "hidden");
        $('#step' + i + ' button').attr("disabled", true);
        $('#step' + i + ' textarea').attr("disabled", true);
        $('#step' + i + ' .ui-select-match-text').css("cursor", "not-allowed");
        $('#step' + i + ' .ui-select-toggle').css("background-color", "#eee");
        readonlyArray.push(true);
      } else {
        $('#step' + i + ' input').attr("disabled", false);
        $('#step' + i + ' textarea').attr("disabled", false);
        $('#step' + i + ' input[ng-model="inherited_value"]').attr("disabled", true);
        $('#step' + i + ' .ui-select-choices').css("visibility", "visible");
        $('#step' + i + ' button').attr("disabled", "block");
        $('#step' + i + ' .ui-select-match-text').css("cursor", "pointer");
        $('#step' + i + ' .ui-select-toggle').css("background-color", "#fff");
        readonlyArray.push(false);
      }
      disableClientId();
    }
    $rootScope.$broadcast('acquisitionWizard:readonlyChange', readonlyArray);
  }
  function disableClientId() {
    var possibleClients = $('div[ng-model]');
    for (var j = 0; j < possibleClients.length; j++) {
      if ($(possibleClients[j]).attr("ng-model") === "model['client_id']") {
        var myTarget = $(possibleClients[j]).parent().parent();
        myTarget.find('.ui-select-choices').css("visibility", "hidden");
        myTarget.find('input').attr("disabled", true);
        myTarget.find('.ui-select-toggle').css("background-color", "#eee");
      }
    }
  }

  /* disabilita i tab successivi a quello corrente */
  function updateDisabledTabs() {
    for (var i = 1; i < $scope.tabs.length; i++) {
      $scope.tabs[i].disabled = i > $scope.activeTab;
    }
  }
  $scope.getStep = function (data, tabIndex, stepXstring) {
    if (!data.model) {
      dialogService.alert('Non è stato definito un modello per l\'entità ' + $scope.typeName, 4000);
      $scope.isModelDefined = false;
      return;
    }
    $scope.isCollapsed = true;
    $scope.tabs[tabIndex].schema = data.model.schema;
    $scope.tabs[tabIndex].title = data.model.description;
    $scope.tabs[tabIndex].form = data.model.form;
    $scope.tabs[tabIndex].attachmentManagement = data.model.attachmentManagement;
    $scope.tabs[tabIndex].customForm = data.model.customForm;
    $scope.tabs[tabIndex].code = data.model.code;
    propagateClientId(data.model, stepXstring);
    initCustomSteps(tabIndex, data.model);
  };
  function initCustomSteps(tabIndex, stepModel) {
    if (stepModel.customForm) {
      if (stepModel.code == 'pdi' || stepModel.code == 'pditracciato') {
        initPdiStep(tabIndex);
      } else if (stepModel.code == 'opf' || stepModel.code == 'opftracciato') {
        initOpfStep(tabIndex);
      }
    }
  }
  function lockStep(stepIndex) {
    if (angular.isDefined($scope.tabs[stepIndex])) {
      $scope.tabs[stepIndex].approvalLocked = true;
    }
  }
  function unlockStep(stepIndex) {
    if (angular.isDefined($scope.tabs[stepIndex])) {
      $scope.tabs[stepIndex].approvalLocked = false;
    }
  }
  function reinitCustomSteps() {
    stepToWizardService.beforeApproval = angular.identity;
    if (angular.isDefined($scope.wizard.model[$scope.pdiStep]) && angular.isDefined(stepToWizardService.initPdiCallback)) {
      if ($scope.maxActiveTab >= stepToWizardService.pdiIndex) {
        stepToWizardService.pdiModel = $scope.wizard.model[$scope.pdiStep].model;
        stepToWizardService.initPdiCallback();
      }
    }
    if (angular.isDefined($scope.wizard.model[$scope.opfStep]) && angular.isDefined(stepToWizardService.initOpfCallback)) {
      if ($scope.maxActiveTab >= stepToWizardService.opfIndex) {
        stepToWizardService.opfModel = $scope.wizard.model[$scope.opfStep].model;
        stepToWizardService.initOpfCallback();
      }
    }
  }
  $scope.save = function () {
    if (angular.isDefined($scope.wizard.dataIn)) {
      $scope.wizard.dataIn = new Date($scope.wizard.dataIn);
    }
    if ($scope.saving) {
      dialogService.alert('Impossibile eseguire il salvataggio. Si prega di riprovare', 4000);
    } else {
      $scope.saving = true;
      writeAllAttachments();
      var promise;
      if ($scope.isAdditionalAct) {
        promise = additionalActsFactory.updateAct({
          id: $scope.wizard.version
        }, $scope.wizard).$promise;
      } else {
        promise = acquisitionWizardFactory.updateWizard({
          id: $scope.wizard.version
        }, $scope.wizard).$promise;
      }
      promise.then(function (data) {
        $scope.wizard = data;
        $scope.wizard.dataIn = new Date($scope.wizard.dataIn);
        toaster.pop('success', 'Salvataggio completato', 'Salvataggio eseguito con successo');
        reinitCustomSteps();
        $scope.saving = false;
      });
    }
  };
  $scope.doApprove = function () {
    if ($scope.saving) {
      dialogService.alert('Impossibile eseguire il salvataggio. Si prega di riprovare', 4000);
      return;
    }
    $scope.saving = true;
    $q.when(stepToWizardService.beforeApproval($scope.wizard)).then(function (response) {
      if (response) {
        if ($scope.tabs[$scope.activeTab].code == 'pdisanitario') {
          plafondSrv.getContractPlafond().then(function (data) {
            var plafondValue = $scope.getModel($scope.activeTab + 1).plafond;
            if (plafondValue > data.residual) {
              $scope.saving = false;
              toaster.pop('error', '', 'Plafond residuo insufficiente.');
            } else {
              $scope.wizard.partial_plafond = plafondValue;
              _doApproval();
            }
          }, function (err) {
            $scope.saving = false;
            toaster.pop('error', '', 'Impossibile calcolare il plafond residuo.');
          });
        } else {
          _doApproval();
        }
      } else {
        $scope.saving = false;
        toaster.pop('error', '', 'Impossibile eseguire il salvataggio.');
      }
    }, function (err) {
      $scope.saving = false;
      toaster.pop('error', '', 'Impossibile eseguire il salvataggio.');
    });
  };
  function _doApproval() {
    //check sulle date
    var promiseDaysRefreshed;
    if ($scope.isAdditionalAct) {
      promiseDaysRefreshed = additionalActsFactory.getDaysRefreshed($scope.wizard).$promise;
    } else {
      promiseDaysRefreshed = acquisitionWizardFactory.getDaysRefreshed($scope.wizard).$promise;
    }
    promiseDaysRefreshed.then(function (data) {
      $scope.wizard = data;
      writeAllAttachments();
      var promise;
      if ($scope.isAdditionalAct) {
        promise = additionalActsFactory.stepForward({
          id: $scope.wizard.UUID
        }, $scope.wizard).$promise;
      } else if (setIstatAdjustmentDate()) {
        promise = acquisitionWizardFactory.stepForward({
          id: $scope.wizard.UUID
        }, $scope.wizard).$promise;
      } else {
        promise = $q.reject("missing_field");
      }
      promise.then(function (data) {
        $scope.wizard = data;
        $scope.wizard.dataIn = new Date($scope.wizard.dataIn);
        if ($scope.wizard.model.current_step.status == "terminated") {
          if ($scope.isAdditionalAct) {
            additionalActsFactory.updateAct({
              id: $scope.wizard.version
            }, $scope.wizard).$promise.then(function (data) {
              $scope.backToList();
            });
          } else {
            acquisitionWizardFactory.updateWizard({
              id: $scope.wizard.version
            }, $scope.wizard).$promise.then(function (data) {
              $scope.backToList();
            });
          }
        } else {
          $route.reload();
        }
        $scope.saving = false;
      }, console.error);
    }, console.error)["finally"](function () {
      $scope.saving = false;
    });
  }
  $scope.approveStep = function () {
    var targetStepId = $scope.getId($scope.maxActiveTab + 1);
    var form = document.forms[targetStepId];
    if (form) {
      $scope.$broadcast('schemaFormValidate');
      $timeout(function () {
        var invElements = angular.element(form.getElementsByClassName("ng-invalid"));
        if (invElements.length > 0) {
          toaster.pop('error', 'Errore', 'Dati obbligatori mancanti.');
        } else {
          var constraintsOk = checkConstraints();
          if (constraintsOk.result) {
            $scope.doApprove();
          } else {
            toaster.pop("error", "ERRORE", constraintsOk.message);
          }
        }
      }, 100);
    } else {
      var constraintsOk = checkConstraints();
      if (constraintsOk.result) {
        $scope.doApprove();
      } else {
        toaster.pop("error", "ERRORE", constraintsOk.message);
      }
    }
  };
  function setIstatAdjustmentDate() {
    var currentStepSf = $scope.tabs[$scope.activeTab];
    var currentStepId = $scope.stepIds[$scope.activeTab];
    var currentStep = $scope.wizard.model[currentStepId].model;
    if (istatAdjustmentConfig && currentStepSf.code && istatAdjustmentConfig.step_id.code == currentStepSf.code) {
      if (currentStep[istatAdjustmentConfig.step_field]) {
        try {
          new Date(currentStep[istatAdjustmentConfig.step_field]);
        } catch (e) {
          toaster.pop('error', "Errore", "Il campo \"" + currentStepSf.schema.properties[istatAdjustmentConfig.step_field] + "\"non è una data valida");
          return false;
        }
        $scope.wizard.model.start_contract_date = currentStep[istatAdjustmentConfig.step_field];
        return true;
      } else {
        toaster.pop('error', "Errore", "Campo \"" + currentStepSf.schema.properties[istatAdjustmentConfig.step_field].title + "\" mancante");
        return false;
      }
    }
    return true;
  }
  function checkConstraints() {
    var currentStepCode = $scope.tabs[$scope.activeTab].code;
    var currentStepForm = $scope.tabs[$scope.activeTab].form;
    var currentStepId = $scope.stepIds[$scope.activeTab];
    var currentStep = $scope.wizard.model[currentStepId].model;
    var result = {
      result: true,
      message: null
    };
    if ($scope.constraints[currentStepCode]) {
      $scope.constraints[currentStepCode].some(function (constr) {
        var field = constr.step.fieldToCheck.trim().split(".");
        field = field[field.length - 1];
        currentStepForm.some(function (form) {
          // ma che bello
          form.items.some(function (item) {
            // questo cazzo
            item.tabs.some(function (tab) {
              // di
              tab.items.some(function (item) {
                // schema form
                if (item.required) {
                  if (item.key[0] == field) {
                    if (currentStep[field]) {
                      var relation;
                      var limit = new Date(constr.value);
                      var currentValue = new Date(currentStep[field]);
                      if (constr.relation === '<') {
                        relation = "minore";
                        if (limit.getTime() < currentValue.getTime()) {
                          result = {
                            result: false,
                            message: "Il campo " + item.title + " deve essere " + relation + " di " + limit.toLocaleString()
                          };
                        }
                      } else {
                        relation = "maggiore";
                        if (limit.getTime() > currentValue.getTime()) {
                          result = {
                            result: false,
                            message: "Il campo " + item.title + " deve essere " + relation + " di " + limit.toLocaleString()
                          };
                        }
                      }
                    }
                  }
                }
                if (!result.result) return true;
              });
              if (!result.result) return true;
            });
            if (!result.result) return true;
          });
          if (!result.result) return true;
        });
        if (!result.result) return true;
      });
    }
    return result;
  }

  // Limita la validazione allo step corrente.
  // Finché lasciamo il reload è inutile
  function limitStepValidation(targetStepId) {
    for (var i = 1; i <= $scope.stepCount; i++) {
      var myId = $scope.getId(i);
      if (myId !== targetStepId) {
        var myForm = document.forms[myId];
        var allElements = angular.element(myForm.getElementsByClassName("form-group"));
        $log.info("approveStep");
        for (var j = 0; j < allElements.length; j++) {
          var el = $(allElements[j]);
          el.removeClass('has-success');
          el.removeClass('has-error');
        }
      }
    }
  }
  $scope.insertAdditionalActs = function () {
    var UUIDAcquisitionWizard = $scope.wizard.UUID;
    $location.path('additionalacts/acquisition/' + UUIDAcquisitionWizard);
  };
  $scope.getId = function (idx) {
    return 'step' + idx;
  };
  $scope.getModel = function (idx) {
    var model = undefined;
    if (angular.isDefined($scope.wizard.model[$scope.getId(idx)])) {
      model = $scope.wizard.model[$scope.getId(idx)].model;
    }
    return model;
  };
  $scope.getAcquisitionWizard = function () {
    var acquisitionWizard = undefined;
    if (angular.isDefined($scope.wizard.model)) {
      acquisitionWizard = $scope.wizard.model;
    }
    return acquisitionWizard;
  };
  $scope.getStepDocument = function (idx) {
    return $scope.wizard.model[$scope.getId(idx)];
  };
  $scope.undoStep = function () {
    if ($scope.saving) {
      dialogService.alert('Impossibile eseguire il salvataggio. Si prega di riprovare', 4000);
    } else {
      $scope.saving = true;
      writeAllAttachments();
      var promise;
      if ($scope.isAdditionalAct) {
        promise = additionalActsFactory.stepBack({
          id: $scope.wizard.UUID
        }, $scope.wizard).$promise;
      } else {
        promise = acquisitionWizardFactory.stepBack({
          id: $scope.wizard.UUID
        }, $scope.wizard).$promise;
      }
      promise.then(function (data) {
        $scope.wizard = data;
        $scope.wizard.dataIn = new Date($scope.wizard.dataIn);
        $scope.updateTabs(false);
        $scope.approvalLocked = false;
        toaster.pop('success', 'Salvataggio completato', 'Salvataggio eseguito con successo');
        reinitCustomSteps();
        $scope.saving = false;
      });
    }
  };
  $scope.isWizardReadonly = function () {
    var result = $scope.wizard.model.current_step.status == 'terminated' || $scope.wizard.adhesion_status === ADHESION_REFUSED;
    return result;
  };
  $scope.updateTabs = function (forward) {
    var i = -1;
    for (i = 0; i < $scope.stepCount; i++) {
      if ($scope.wizard.model.current_step.step === $scope.stepIds[i]) {
        break;
      }
    }
    if (i < 0 || i >= $scope.stepCount) {
      if ($scope.wizard.model.current_step.status == 'terminated') {
        $scope.activeTab = 0;
        $scope.maxActiveTab = 0;
      } else {
        $scope.activeTab = $scope.stepCount;
        $scope.maxActiveTab = $scope.stepCount + 1;
      }
    } else if (i == 0) {
      if (forward) {
        $scope.activeTab++;
        $scope.maxActiveTab++;
      } else {
        $scope.activeTab = 0;
        $scope.maxActiveTab = 0;
      }
    } else {
      if (forward) {
        $scope.activeTab++;
        $scope.maxActiveTab++;
      } else {
        $scope.maxActiveTab--;
        $scope.activeTab = $scope.maxActiveTab;
      }
    }
    updateDisabledTabs();
    updateReadonlyTabs();
  };
  function propagateClientId(stepModel, stepXstring) {
    var properties = stepModel.schema.properties;
    if (angular.isDefined(properties.client_id) && angular.isDefined(properties.client_id.format) && properties.client_id.format === 'lookup') {
      $scope.wizard.model[stepXstring].model.client_id = {};
      angular.copy($scope.wizard.model.client_id, $scope.wizard.model[stepXstring].model.client_id);
    }
  }

  // Gestione allegati
  function readAttachments(index) {
    $scope.tabs[index].attachments.length = 0;
    var modelList = $scope.getModel(index + 1).attachments;
    for (var i = 0; i < modelList.length; i++) {
      $scope.tabs[index].attachments.push(modelList[i]);
    }
  }
  function writeAttachments(index) {
    var modelList = $scope.getModel(index + 1).attachments;
    modelList.length = 0;
    for (var i = 0; i < $scope.tabs[index].attachments.length; i++) {
      modelList.push($scope.tabs[index].attachments[i]);
    }
  }
  function writeAllAttachments() {
    for (var i = 0; i < $scope.tabs.length; i++) {
      if ($scope.tabs[i].attachmentManagement) {
        writeAttachments(i);
      }
    }
  }
  $scope.updAttachments = function (index) {
    writeAttachments(index);
    $scope.save();
  };
  $scope.initAttachments = function () {
    for (var i = 0; i < $scope.tabs.length; i++) {
      if ($scope.tabs[i].attachmentManagement) {
        if (angular.isUndefined($scope.getModel(i + 1).attachments)) {
          $scope.getModel(i + 1).attachments = [];
        } else {
          readAttachments(i);
        }
      }
    }
  };
  $scope.setNotAdherent = function () {
    dialogService.confirmDialog("L'operazione non potrà essere annullata. Continuare?", function () {
      $scope.wizard.adhesion_status = ADHESION_REFUSED;
      $scope.wizard.adhesion_refusal_date = new Date();
      updateReadonlyTabs();
      $scope.save();
    });
  };
  $scope.isNotAdherent = function () {
    var result = $scope.wizard.adhesion_status === ADHESION_REFUSED;
    return result;
  };
  $scope["delete"] = function () {
    dialogService.confirmDialog('Eliminare l\'acquisizione ' + $scope.wizard.model.code + ' del cliente ' + $scope.wizard.model.client_id.description + '?', function () {
      var promise;
      if ($scope.isAdditionalAct) {
        promise = additionalActsFactory.deleteAct({
          id: $scope.wizard.version
        }).$promise;
      } else {
        promise = acquisitionWizardFactory.deleteWizard({
          id: $scope.wizard.version
        }).$promise;
      }
      promise.then(function (response) {
        toaster.pop('success', 'Eliminazione completata', 'Eliminazione eseguita con successo');
        $scope.backToList();
      })["catch"](function (response) {
        // error
        toaster.pop('error', 'Errore eliminazione', 'Eliminazione non riuscita');
      })["finally"](function (response) {
        // finally
      });
    });
  };
  function forceCustomerProfile(client_id) {
    if (client_id.UUID) {
      var profile = authFactory.getAuthData().profile;
      var customer = profile.items.filter(function (p) {
        return p.type == "customer";
      })[0];
      if (!customer) {
        customer = {
          code: null,
          description: null
        };
      }
      if (customer.code != client_id.UUID) {
        var commission = authFactory.getAuthData().info.commissions.current;
        var switchProfileElement = {
          selected: {
            type: '',
            cod: 0,
            code: commission.code,
            description: commission.description,
            items: [{
              type: 'commission',
              cod: 0,
              code: commission.code,
              description: commission.code + ' - ' + commission.description
            }, {
              type: 'customer',
              cod: 0,
              code: client_id.UUID,
              description: client_id.code + ' - ' + client_id.description
            }]
          }
        };
        loginFactory["switch"](switchProfileElement).$promise.then(function (response) {
          $log.info('Switch automatico commessa');
          response.info.commissions.current = commission;
          authFactory.setAuthData(response);
          //$route.reload();
        });
      }
    }
  }

  //___main__
  var consipEntity = $route.current.$$route.consipEntity;
  $scope.isAdditionalAct = $route.current.$$route.consipEntity === 'additionalacts';
  $scope.getContract();
}]);
'use strict';

/**
* @ngdoc function
* @name sixEmmaApp.controller:AcquisitionWizardListCtrl
* @description
* # AcquisitionWizardListCtrl
* Controller of the sixEmmaApp
*/
angular.module('emma.consip').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/acquisitionwizard', {
    templateUrl: 'consip/acquisitionwizard/acquisitionwizard_list.html',
    controller: 'AcquisitionWizardListCtrl'
  });
}]).controller('AcquisitionWizardListCtrl', ["$scope", "$location", "uiGridConstants", "acquisitionWizardFactory", "dialogService", "contractFactory", function ($scope, $location, uiGridConstants, acquisitionWizardFactory, dialogService, contractFactory) {
  $scope.wizardList = {};
  $scope.params = {
    queryParam: '',
    filterQuery: ''
  };
  $scope.statusLabel = {
    inprogress: 'In corso',
    terminated: 'Terminata'
  };
  $scope.viewGridOptions = {
    enableRowSelection: false,
    enableRowHeaderSelection: false,
    appScopeProvider: $scope,
    columnDefs: [{
      displayName: '',
      field: 'id',
      width: 36,
      enableFiltering: false,
      enableSorting: false,
      enableColumnResizing: false,
      enablePinning: false,
      pinnedLeft: true,
      cellTemplate: 'consip/acquisitionwizard/template/detail_column.html'
    }, {
      displayName: 'Codice',
      field: 'model.code',
      width: 60,
      enableFiltering: true,
      filters: [{
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }, {
      displayName: 'Descrizione',
      field: 'model.description',
      enableFiltering: true,
      filters: [{
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }, {
      displayName: 'Step',
      field: 'model.current_step.step',
      enableFiltering: true,
      cellTemplate: '<div class="ui-grid-cell-contents">{{grid.appScope.stepLabel[row.entity.model.current_step.step]}}</div>',
      sixFilteringCallback: onFilterStepCallback,
      filters: [{
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }, {
      displayName: 'Stato',
      field: 'model.current_step.status',
      enableFiltering: true,
      cellTemplate: '<div class="ui-grid-cell-contents">{{grid.appScope.statusLabel[row.entity.model.current_step.status]}}</div>',
      sixFilteringCallback: onFilterStatusCallback,
      filters: [{
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }, {
      displayName: 'Adesione',
      field: 'adhesion_status',
      enableFiltering: false,
      cellTemplate: 'consip/acquisitionwizard/template/adhesion_column.html'
    }, {
      displayName: 'Tempistiche',
      field: 'model.code',
      enableFiltering: false,
      enableSorting: false,
      cellTemplate: 'consip/acquisitionwizard/template/steps_column.html'
    }, {
      displayName: 'Atti aggiuntivi',
      field: 'model.current_step.status',
      enableFiltering: false,
      width: 150,
      cellTemplate: 'consip/acquisitionwizard/template/acts_column.html'
    }]
  };
  $scope.getData = function () {
    var payload = {
      query: $scope.params.queryParam,
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      sort_fields: defaultSort(),
      show_revision: false
    };
    return acquisitionWizardFactory.getWizardsListFiltered(payload, $scope.params.filterQuery).$promise.then(function (data) {
      $scope.wizardList.totalResults = data.totalResults;
      $scope.wizardList.list = data.list;
      $scope.params.sixApi.refreshList(data.list);
      return data;
    });
  };
  $scope.newWizard = function () {
    if ($scope.plafond.remaining <= 0) {
      dialogService.alert('Plafond esaurito, impossibile procedere', 4000);
    } else {
      $location.path('acquisitionwizard/new');
    }
  };
  function onFilterStatusCallback(term) {
    if (term && term != '') {
      term = term.toLowerCase();
      var matching = [];
      for (var prop in $scope.statusLabel) {
        var desc = $scope.statusLabel[prop].toLowerCase();
        if (desc.indexOf(term) !== -1) {
          matching.push(prop);
        }
      }
      if (matching.length > 1) {
        term = '';
      } else if (matching.length < 1) {
        term = "-";
      } else {
        term = matching[0];
      }
    }
    return term;
  }
  ;
  function onFilterStepCallback(term) {
    if (term && term != '') {
      term = term.toLowerCase();
      var matching = [];
      for (var prop in $scope.stepLabel) {
        var desc = $scope.stepLabel[prop].toLowerCase();
        if (desc.indexOf(term) !== -1) {
          matching.push(prop);
        }
      }
      if (matching.length > 1) {
        term = 'step';
      } else if (matching.length < 1) {
        term = "-";
      } else {
        term = matching[0];
      }
    }
    return term;
  }
  ;
  function defaultSort() {
    return ($scope.sortFields || 'model.code') + ':' + ($scope.sortOrder || 'asc');
  }
  function getContract() {
    contractFactory().recordByCommission().$promise.then(function (data) {
      if (!data.model) {
        dialogService.alert('Nessuna convenzione definita', 4000);
      } else {
        $scope.contract = data;
        loadStepsDescriptions();
        getPlafond();
      }
    });
  }
  function loadStepsDescriptions() {
    $scope.steps = $scope.contract.model.steps;
    $scope.stepLabel = {
      step1: angular.isDefined($scope.steps.step1) ? $scope.steps.step1.step_id.description : '',
      step2: angular.isDefined($scope.steps.step2) ? $scope.steps.step2.step_id.description : '',
      step3: angular.isDefined($scope.steps.step3) ? $scope.steps.step3.step_id.description : '',
      step4: angular.isDefined($scope.steps.step4) ? $scope.steps.step4.step_id.description : '',
      step5: angular.isDefined($scope.steps.step5) ? $scope.steps.step5.step_id.description : '',
      step6: angular.isDefined($scope.steps.step6) ? $scope.steps.step6.step_id.description : '',
      step7: angular.isDefined($scope.steps.step7) ? $scope.steps.step7.step_id.description : '',
      step8: angular.isDefined($scope.steps.step8) ? $scope.steps.step8.step_id.description : '',
      step9: angular.isDefined($scope.steps.step9) ? $scope.steps.step9.step_id.description : ''
    };
  }
  function getPlafond() {
    $scope.plafond = {};
    $scope.plafond.available = $scope.contract.model.plafond_total;
    acquisitionWizardFactory.getUsedPlafond().$promise.then(function (data) {
      $scope.plafond.used = data.result;
      $scope.plafond.remaining = $scope.plafond.available - $scope.plafond.used;
      $scope.plafond.remaining_class = $scope.plafond.remaining > 0 ? "text-success-dker" : "text-danger-dker";
    });
  }

  //__main__
  getContract();
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:AcquisitionWizardNewCtrl
 * @description
 * # AcquisitionWizardNewCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.consip').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/acquisitionwizard/new', {
    templateUrl: 'consip/acquisitionwizard/acquisitionwizard_new.html',
    controller: 'AcquisitionWizardNewCtrl'
  });
}]).controller('AcquisitionWizardNewCtrl', ["$scope", "acquisitionWizardFactory", "toaster", "authFactory", "$location", "contractFactory", "STEP_TIMING_OFF", "loginFactory", "dialogService", "$q", function ($scope, acquisitionWizardFactory, toaster, authFactory, $location, contractFactory, STEP_TIMING_OFF, loginFactory, dialogService, $q) {
  $scope.wizard = {};
  $scope.validDefaultSettings = false;
  $scope.$watchCollection('wizard.client_id', function (newValue, oldValue) {
    $scope.validDefaultSettings = angular.isDefined($scope.wizard.client_id);
  });
  $scope.confirmNewWizard = function () {
    acquisitionWizardFactory.getByClient({
      id: $scope.wizard.client_id.UUID
    }).$promise.then(function (data) {
      var success = !data.exist;
      if (success) {
        createNewWizard();
      } else {
        toaster.pop('error', 'Errore', 'Esiste già un flusso di acquisizione attivo associato a questo cliente.');
      }
    });
  };
  function createNewWizard() {
    var commission = authFactory.getAuthData().info.commissions.current.code;
    $scope.wizard.description = commission + " - " + $scope.wizard.client_id.description;
    $scope.wizard.code = commission + "_" + $scope.wizard.client_id.code;
    acquisitionWizardFactory.createWizard({}, $scope.wizard).$promise.then(function (data) {
      forceCustomerProfile(data.model.client_id).then(function () {
        if (angular.isUndefined(data.UUID)) {
          alert("Servizio non disponibile");
        } else {
          $location.path('acquisitionwizard/detail/' + data.UUID);
        }
      });
    });
  }
  ;
  function forceCustomerProfile(client_id) {
    if (client_id.UUID) {
      var profile = authFactory.getAuthData().profile;
      var customer = profile.items.filter(function (p) {
        return p.type == "customer";
      })[0];
      if (!customer) {
        customer = {
          code: null,
          description: null
        };
      }
      if (customer.code != client_id.UUID) {
        var commission = authFactory.getAuthData().info.commissions.current;
        var switchProfileElement = {
          selected: {
            type: '',
            cod: 0,
            code: commission.code,
            description: commission.description,
            items: [{
              type: 'commission',
              cod: 0,
              code: commission.code,
              description: commission.code + ' - ' + commission.description
            }, {
              type: 'customer',
              cod: 0,
              code: client_id.UUID,
              description: client_id.code + ' - ' + client_id.description
            }]
          }
        };
        dialogService.loading('Cambio profilo <i class="fa fa-angle-double-right"></i> ' + client_id.description);
        return loginFactory["switch"](switchProfileElement).$promise.then(function (response) {
          dialogService.stopLoading();
          console.log('Switch automatico commessa');
          response.info.commissions.current = commission;
          authFactory.setAuthData(response);
        });
      }
    }
    return $q.resolve();
  }
  function getContract() {
    contractFactory().recordByCommission().$promise.then(function (data) {
      if (angular.isUndefined(data.model)) {
        dialogService.alert('Non è stato definito un modello per la convenzione corrente', 4000);
      } else {
        var contract = data;
        var stepCount = Object.keys(contract.model.steps).length;
        for (var i = 0; i < stepCount; i++) {
          var stepId = 'step' + (i + 1);
          var days = contract.model.steps[stepId].days;
          var type_days = contract.model.steps[stepId].type_days;
          var dateStart = contract.model.steps[stepId].date_start;
          var dateEnd = contract.model.steps[stepId].date_end;
          $scope.wizard.step_count = stepCount;
          $scope.wizard[stepId] = {
            type_days: type_days,
            days: days,
            date_start: dateStart,
            date_end: dateEnd,
            timing_status: STEP_TIMING_OFF,
            model: {}
          };
        }
      }
    });
  }
  ;

  //__main__
  getContract();
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:AcquisitionWizardListCtrl
 * @description
 * # AcquisitionWizardListCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.consip').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/additionalacts', {
    templateUrl: 'consip/acquisitionwizard/additionalacts_list.html',
    controller: 'AdditionalActsListCtrl'
  }).when('/additionalacts/page/:number', {
    templateUrl: 'consip/acquisitionwizard/additionalacts_list.html',
    controller: 'AdditionalActsListCtrl'
  }).when('/additionalacts/acquisition/:acquisitionId', {
    templateUrl: 'consip/acquisitionwizard/additionalacts_list.html',
    controller: 'AdditionalActsListCtrl'
  });
}]).controller('AdditionalActsListCtrl', ["$scope", "additionalActsFactory", "$log", "$routeParams", "$location", "uiGridConstants", "contractFactory", "authFactory", "acquisitionWizardFactory", "dialogService", "STEP_TIMING_OFF", function ($scope, additionalActsFactory, $log, $routeParams, $location, uiGridConstants, contractFactory, authFactory, acquisitionWizardFactory, dialogService, STEP_TIMING_OFF) {
  $scope.actsList = {};
  $scope.params = {
    queryParam: '',
    filterQuery: {}
  };
  $scope.viewGridOptions = {
    columnDefs: [{
      name: ' '
    }]
  };
  var DEFAULT_SORT_FIELD = 'model.code';
  function defaultSort() {
    var result = $scope.sortFields ? $scope.sortFields : DEFAULT_SORT_FIELD;
    return result;
  }
  var DEFAULT_SORT_ORDER = 'asc';
  function defaultSortOrder() {
    var result = $scope.sortOrder ? $scope.sortOrder : DEFAULT_SORT_ORDER;
    return result;
  }
  var getPage = function getPage() {
    $scope.viewGridOptions.totalItems = $scope.actsList.totalResults;
    var firstRow = ($scope.params.pageNumber - 1) * $scope.params.pageSize;
    var lastRow = firstRow + $scope.params.pageSize;
    $scope.viewGridOptions.data = $scope.viewGridOptions.data.slice(firstRow, lastRow);
  };
  function initGridColumns() {
    $scope.viewGridOptions.columnDefs = [];
    $scope.viewGridOptions.columnDefs.push({
      displayName: '',
      field: 'id',
      width: 36,
      enableCellEdit: true,
      enableFiltering: false,
      enableSorting: false,
      cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/additionalacts/detail/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' + '<span class="fa fa-search"></span>' + '</a>' + '</div>'
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Codice',
      field: 'model.code',
      width: 60,
      enableFiltering: true,
      filters: [{
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Descrizione',
      field: 'model.step1.model.description',
      enableFiltering: true,
      filters: [{
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Step',
      field: 'model.current_step.step',
      enableFiltering: true,
      cellTemplate: '<div class="ui-grid-cell-contents">{{grid.appScope.$parent.stepLabel[row.entity.model.current_step.step]}}</div>',
      sixFilteringCallback: $scope.onFilterStepCallback,
      filters: [{
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Stato',
      field: 'model.current_step.status',
      enableFiltering: true,
      cellTemplate: '<div class="ui-grid-cell-contents">{{grid.appScope.$parent.statusLabel[row.entity.model.current_step.status]}}</div>',
      sixFilteringCallback: $scope.onFilterStatusCallback,
      filters: [{
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Adesione',
      field: 'adhesion_status',
      enableCellEdit: true,
      enableFiltering: false,
      enableSorting: true,
      cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<span ng-if="row.entity.adhesion_status===1">' + 'Non aderente' + '</span>' + '</div>'
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Tempistiche',
      field: 'model.code',
      enableFiltering: false,
      enableSorting: false,
      cellTemplate: '<div class="ui-grid-cell-contents">' + '<span ng-if="row.entity.model.step1">' + '<six-consip-timing-led sx-value="row.entity.model.step1.timing_status" sx-description="grid.appScope.$parent.stepLabel.step1"></six-consip-timing-led>' + '</span>' + '<span ng-if="row.entity.model.step2">' + '<six-consip-timing-led sx-value="row.entity.model.step2.timing_status" sx-description="grid.appScope.$parent.stepLabel.step2"></six-consip-timing-led>' + '</span>' + '<span ng-if="row.entity.model.step3">' + '<six-consip-timing-led sx-value="row.entity.model.step3.timing_status" sx-description="grid.appScope.$parent.stepLabel.step3"></six-consip-timing-led>' + '</span>' + '<span ng-if="row.entity.model.step4">' + '<six-consip-timing-led sx-value="row.entity.model.step4.timing_status" sx-description="grid.appScope.$parent.stepLabel.step4"></six-consip-timing-led>' + '</span>' + '<span ng-if="row.entity.model.step5">' + '<six-consip-timing-led sx-value="row.entity.model.step5.timing_status" sx-description="grid.appScope.$parent.stepLabel.step5"></six-consip-timing-led>' + '</span>' + '<span ng-if="row.entity.model.step6">' + '<six-consip-timing-led sx-value="row.entity.model.step6.timing_status" sx-description="grid.appScope.$parent.stepLabel.step6"></six-consip-timing-led>' + '</span>' + '<span ng-if="row.entity.model.step7">' + '<six-consip-timing-led sx-value="row.entity.model.step7.timing_status" sx-description="grid.appScope.$parent.stepLabel.step7"></six-consip-timing-led>' + '</span>' + '<span ng-if="row.entity.model.step8">' + '<six-consip-timing-led sx-value="row.entity.model.step8.timing_status" sx-description="grid.appScope.$parent.stepLabel.step8"></six-consip-timing-led>' + '</span>' + '<span ng-if="row.entity.model.step9">' + '<six-consip-timing-led sx-value="row.entity.model.step9.timing_status" sx-description="grid.appScope.$parent.stepLabel.step9"></six-consip-timing-led>' + '</span>' + '</div>'
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Acquisizione',
      field: 'row.entity.model.source_acquisition_id.UUID',
      enableFiltering: false,
      width: 150,
      cellTemplate: '<div class="ui-grid-cell-contents" style="vertical-align:middle;text-align:center;">' + '<a ng-href="#/acquisitionwizard/detail/{{row.entity.model.source_acquisition_id.UUID}}" class="btn btn-xs btn-primary">' + '{{row.entity.model.source_acquisition_id.UUID}}' + '</a>' + '</div>'
    });
  }
  $scope.onFilterStatusCallback = function (term) {
    if (term && term != '') {
      term = term.toLowerCase();
      var matching = [];
      for (var prop in $scope.statusLabel) {
        var desc = $scope.statusLabel[prop].toLowerCase();
        if (desc.indexOf(term) !== -1) {
          matching.push(prop);
        }
      }
      if (matching.length > 1) {
        term = '';
      } else if (matching.length < 1) {
        term = "-";
      } else {
        term = matching[0];
      }
    }
    return term;
  };
  $scope.onFilterStepCallback = function (term) {
    if (term && term != '') {
      term = term.toLowerCase();
      var matching = [];
      for (var prop in $scope.stepLabel) {
        var desc = $scope.stepLabel[prop].toLowerCase();
        if (desc.indexOf(term) !== -1) {
          matching.push(prop);
        }
      }
      if (matching.length > 1) {
        term = 'step';
      } else if (matching.length < 1) {
        term = "-";
      } else {
        term = matching[0];
      }
    }
    return term;
  };
  $scope.getData = function () {
    var payload = {
      query: $scope.params.queryParam,
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      sort_fields: defaultSort() + ':' + defaultSortOrder(),
      show_revision: false
    };
    if (angular.isDefined($routeParams.acquisitionId)) {
      $scope.params.filterQuery['model.source_acquisition_id.UUID'] = $routeParams.acquisitionId;
    }
    return additionalActsFactory.getActsListFiltered(payload, $scope.params.filterQuery).$promise.then(function (data) {
      $scope.actsList.totalResults = data.totalResults;
      $scope.actsList.list = data.list;
      getPage();
      $scope.params.sixApi.refreshList(data.list);
      return data;
    });
  };
  $scope.newAdditionalAct = function () {
    if ($scope.plafond.remaining <= 0) {
      dialogService.alert('Plafond esaurito, impossibile procedere', 4000);
    } else {
      var commission = authFactory.getAuthData().info.commissions.current.code;
      var stepCount = Object.keys($scope.contract.model.steps).length;
      var actModel = {
        description: commission + " - " + $scope.sourceAcquisition.model.client_id.description,
        code: commission + "_" + $scope.sourceAcquisition.model.client_id.code,
        client_id: $scope.sourceAcquisition.model.client_id,
        source_acquisition_id: sixObjectLib.recordToHisRef($scope.sourceAcquisition),
        step_count: stepCount
      };
      for (var i = 0; i < stepCount; i++) {
        var stepId = 'step' + (i + 1);
        var type_days = $scope.contract.model.steps[stepId].type_days_acts;
        var days = $scope.contract.model.steps[stepId].days_acts;
        var dateStart = $scope.contract.model.steps[stepId].date_start;
        var dateEnd = $scope.contract.model.steps[stepId].date_end;
        actModel[stepId] = {
          type_days: type_days,
          days: days,
          date_start: dateStart,
          date_end: dateEnd,
          timing_status: STEP_TIMING_OFF,
          model: {}
        };
      }
      additionalActsFactory.createAct({
        param1: $scope.sourceAcquisition.model.client_id.UUID
      }, actModel).$promise.then(function (data) {
        if (angular.isUndefined($scope.sourceAcquisition.model.additional_acts)) {
          $scope.sourceAcquisition.model.additional_acts = [];
        }
        $scope.sourceAcquisition.model.additional_acts.push(sixObjectLib.recordToHisRef(data));
        $scope.newActUUID = data.UUID;
        acquisitionWizardFactory.updateWizard({
          id: $scope.sourceAcquisition.version
        }, $scope.sourceAcquisition).$promise.then(function (response) {
          $location.path('additionalacts/detail/' + $scope.newActUUID);
        });
      });
    }
  };
  function getContract() {
    contractFactory().recordByCommission().$promise.then(function (data) {
      if (!data.model) {
        dialogService.alert('Nessuna convenzione definita', 4000);
      } else {
        $scope.contract = data;
        loadStepsDescriptions();
        loadStatusesDescriptions();
        getPlafond();
      }
    });
  }
  function loadStepsDescriptions() {
    $scope.steps = $scope.contract.model.steps;
    $scope.stepLabel = {
      step1: angular.isDefined($scope.steps.step1) ? $scope.steps.step1.step_id.description : '',
      step2: angular.isDefined($scope.steps.step2) ? $scope.steps.step2.step_id.description : '',
      step3: angular.isDefined($scope.steps.step3) ? $scope.steps.step3.step_id.description : '',
      step4: angular.isDefined($scope.steps.step4) ? $scope.steps.step4.step_id.description : '',
      step5: angular.isDefined($scope.steps.step5) ? $scope.steps.step5.step_id.description : '',
      step6: angular.isDefined($scope.steps.step6) ? $scope.steps.step6.step_id.description : '',
      step7: angular.isDefined($scope.steps.step7) ? $scope.steps.step7.step_id.description : '',
      step8: angular.isDefined($scope.steps.step8) ? $scope.steps.step8.step_id.description : '',
      step9: angular.isDefined($scope.steps.step9) ? $scope.steps.step9.step_id.description : ''
    };
  }
  function loadStatusesDescriptions() {
    $scope.statusLabel = {
      inprogress: 'In corso',
      terminated: 'Terminata'
    };
  }
  function getSourceAcquisition(UUID) {
    acquisitionWizardFactory.getWizardByUUID({
      id: UUID
    }).$promise.then(function (data) {
      $scope.sourceAcquisition = data;
    });
  }
  ;
  function getPlafond() {
    $scope.plafond = {};
    $scope.plafond.available = $scope.contract.model.plafond_total;
    acquisitionWizardFactory.getUsedPlafond().$promise.then(function (data) {
      $scope.plafond.used = data.used_plafond;
      $scope.plafond.remaining = $scope.plafond.available - $scope.plafond.used;
      $scope.plafond.remaining_class = $scope.plafond.remaining > 0 ? "text-success-dker" : "text-danger-dker";
    });
  }

  //__main__
  getContract();
  if (angular.isDefined($routeParams.acquisitionId)) {
    getSourceAcquisition($routeParams.acquisitionId);
  }
  initGridColumns();
}]);
'use strict';

angular.module('emma.consip').directive("inputDisabled", function () {
  return function (scope, element, attrs) {
    scope.$watch(attrs.inputDisabled, function (val) {
      if (val) element.removeAttr("disabled");else element.attr("disabled", "disabled");
    });
  };
});

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:ContractCtrl
 * @description
 * # ContractCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.consip').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/contract', {
    templateUrl: 'consip/contract/contract.html',
    controller: 'ContractCtrl'
  });
}]).controller('ContractCtrl', ["$scope", "$route", "contractFactory", "recordFactory", "authFactory", "acquisitionStepFactory", "formulaFactory", "salWorkflow", "dialogService", "toaster", "acquisitionWizardFactory", "$timeout", "$q", function ($scope, $route, contractFactory, recordFactory, authFactory, acquisitionStepFactory, formulaFactory, salWorkflow, dialogService, toaster, acquisitionWizardFactory, $timeout, $q) {
  $scope.currentTab = 0;
  $scope.workflow = {
    ref: ''
  };
  $scope.selected = {
    model: {
      workflow_id: null,
      steps: {},
      code: '',
      description: ''
    }
  };
  $scope.formuleStrBodyDays = {};
  $scope.formuleStrBodyDaysActs = {};
  $scope.isPlafondEditing = false;
  $scope.confModel = {};
  $scope.dateStepArray = {};
  $scope.selectedStep = {
    value: {}
  };
  $scope.excludedServices = {
    services: []
  };
  $scope.arrayRet = [];
  $scope.arrayIds = [];
  var currentCommission = authFactory.getAuthData().info.commissions.current;
  $scope.enableAttachments = false;
  $scope.enableServiceExclusion = false;
  $scope.istatType = {
    types: [{
      key: "single_date",
      title: "Data unica"
    }, {
      key: "min_adhesion",
      title: "Data unica con adesione minima"
    }, {
      key: "month_adhesion",
      title: "Mesi di adesione"
    }],
    selected: {}
  };
  $scope.monthList = getMonths();
  function getStepList() {
    if (!$scope.stepList) {
      acquisitionStepFactory().lookup({
        page_size: 1000
      }).$promise.then(function (data) {
        $scope.stepList = data.list.map(function (step) {
          return Object.assign(step.model, {
            UUID: step.UUID,
            type: "step"
          });
        });
      });
    }
  }
  $scope.onStepSelect = function () {
    delete $scope.istatType.selected.step_field;
  };
  $scope.getStepFields = function () {
    if (!$scope.fieldList) $scope.fieldList = [];else $scope.fieldList.length = 0;
    delete $scope.istatType.selected.stepField;
    $timeout(function () {
      // perchè six-on-select esegue la funzione prima che il model abbia tempo di aggiornarsi
      acquisitionStepFactory().byUUID({
        id: $scope.istatType.selected.step_id.UUID
      }).$promise.then(function (data) {
        for (var k in data.model.schema.properties) {
          if (data.model.schema.properties[k].format && data.model.schema.properties[k].format == 'date') $scope.fieldList.push({
            title: data.model.schema.properties[k].title,
            key: k
          });
        }
      });
    });
  };
  function getMonths() {
    return sixDateLib.getMonths().map(function (value, index) {
      return {
        key: index,
        title: value
      };
    });
  }
  $scope.refreshCodeByDescription = function () {
    if (angular.isUndefined($scope.selected.UUID)) {
      $scope.code = sixStringLib.removeDiacritics($scope.selected.model.description);
      $scope.code = $scope.code.replace(/[^\w]|_/g, '').replace(/^(\d)(.*)/, '_$1$2').toLowerCase();
      $scope.selected.model.code = angular.copy($scope.code);
    }
  };
  $scope.setCurrentTab = function (index) {
    $scope.currentTab = index;
  };
  $scope.onSubmit = function (form) {
    $scope.$broadcast('schemaFormValidate');
    var isValid = form.$valid;
    if (isValid) {
      for (var i = 0; i < $scope.arrayIds.length; i++) {
        var step_id = $scope.selected.model.steps[$scope.arrayIds[i]];
        isValid &= angular.isDefined(step_id);
        isValid &= angular.isDefined(step_id.type_days);
        if (angular.isDefined(step_id.type_days)) {
          if (step_id.type_days == 'formula') {
            isValid &= angular.isDefined(step_id.formula_days) && step_id.formula_days != null;
          } else if (step_id.type_days == 'number') {
            isValid &= angular.isDefined(step_id.days) && step_id.days != null;
          }
        }
        isValid &= angular.isDefined(step_id.type_days_acts);
        if (angular.isDefined(step_id.type_days_acts)) {
          if (step_id.type_days_acts == 'formula') {
            isValid &= angular.isDefined(step_id.formula_days_acts) && step_id.formula_days_acts != null;
          } else if (step_id.type_days_acts == 'number') {
            isValid &= angular.isDefined(step_id.days_acts) && step_id.days_acts != null;
          }
        }
        isValid &= angular.isDefined(step_id.date_start) && step_id.date_start != '';
        isValid &= angular.isDefined(step_id.date_end) && step_id.date_end != '';
        if (!isValid) {
          break;
        }
      }
    }
    if (isValid) {
      $scope.save();
    } else {
      toaster.pop('error', 'Impossibile effettuare il salvataggio: alcuni campi non sono stati compilati', '');
    }
  };
  $scope.getInputType = function (modelItem) {
    if (modelItem.type == 'datepicker') {
      return 'date';
    } else {
      return modelItem.type;
    }
  };
  $scope.save = function (silent) {
    $scope.selected.model.plafond_total = getPlafondTotal();
    getPlafondUsed();
    setConstraints();
    if (setIstatAdjustmentConfig()) {
      if ($scope.enableServiceExclusion && $scope.excludedServices.services.length) {
        $scope.selected.model.exclude_from_istat = $scope.excludedServices.services;
      } else {
        delete $scope.selected.model.exclude_from_istat;
      }
      if ($scope.selected.version) {
        //update
        contractFactory().updateRecord({
          id: $scope.selected.version
        }, $scope.selected).$promise.then(function () {
          console.log('updated!');
          if (!silent) {
            toaster.pop('success', 'Salvataggio effettuato');
            $route.reload();
          }
        })["catch"](function (error) {
          toaster.error('Errore', error.message, 4000);
        });
        ;
      } else {
        //create
        contractFactory().createRecord($scope.selected.model).$promise.then(function () {
          console.log('created!');
          if (!silent) {
            toaster.pop('success', 'Salvataggio effettuato');
            $route.reload();
          }
        })["catch"](function (error) {
          toaster.pop('error', 'Errore', error.message, 4000);
        });
      }
    }
  };
  function setIstatAdjustmentConfig() {
    var toSave = angular.copy($scope.istatType.selected);
    if (toSave.type && toSave.type.key && toSave.step_id && toSave.step_field) {
      if (toSave.type.key == "month_adhesion" && !toSave.recurrency) {
        toaster.pop("error", "Errore", "Campi obbligatori mancanti");
        return false;
      } else if (toSave.type.key == "single_date" && !toSave.month) {
        toaster.pop("error", "Errore", "Campi obbligatori mancanti");
        return false;
      } else if (toSave.type.key == "min_adhesion" && !(toSave.month && toSave.recurrency)) {
        toaster.pop("error", "Errore", "Campi obbligatori mancanti");
        return false;
      }
      for (var k in toSave) {
        if (toSave[k].key != undefined) toSave[k] = toSave[k].key;
      }
      if (toSave.type == "single_date") {
        delete toSave.recurrency;
      } else if (toSave.type == "month_adhesion") {
        delete toSave.month;
      }
      $scope.selected.model.istat_config = toSave;
      return true;
    } else {
      toaster.pop("error", "Errore", "Campi obbligatori mancanti");
      return false;
    }
  }
  function setConstraints() {
    for (var key in $scope.schema.properties) {
      if ($scope.schema.properties[key].enableConstraints) {
        if (!angular.isDefined($scope.selected.model.constraints)) {
          $scope.selected.model.constraints = {};
        }
        $scope.schema.properties[key].constraints.forEach(function (c) {
          var stepCode = c.step.code;
          if (!$scope.selected.model.constraints[stepCode]) {
            $scope.selected.model.constraints[stepCode] = [c];
          } else {
            $scope.selected.model.constraints[stepCode].push(c);
          }
        });
      } else {
        for (var k in $scope.selected.model.constraints) {
          removeConstraint($scope.selected.model.constraints[k], key);
          if (!$scope.selected.model.constraints[k].length) delete $scope.selected.model.constraints[k];
        }
        if ($scope.selected.model.constraints && !Object.keys($scope.selected.model.constraints).length) delete $scope.selected.model.constraints;
      }
    }
  }
  function removeConstraint(step, key) {
    if (step && key && step.length) {
      for (var k in step) {
        if (step[k].key == key) {
          step.splice(parseInt(k), 1);
          removeConstraint(step, key);
        }
      }
    }
  }
  /**********************************
   * Temistiche SAL
   **********************************/

  $scope.addSalRule = function () {
    ($scope.selected.model.sal_timing_rules || ($scope.selected.model.sal_timing_rules = [])).push({});
  };
  $scope.deleteSalRule = function (index) {
    $scope.selected.model.sal_timing_rules.splice(index, 1);
  };
  function getSalStatus() {
    salWorkflow.getStatuses().then(function (status) {
      $scope.salSatatus = status;
    });
  }

  /*************************************/
  // Allegati
  /*************************************/

  $scope.attachments = [];
  function readAttachments(modelList) {
    if (modelList && modelList.length > 0) {
      $scope.attachments.splice(0, $scope.attachments.length);
      for (var i = 0; i < modelList.length; i++) {
        $scope.attachments.push(modelList[i]);
      }
    }
  }
  function writeAttachments(modelList) {
    modelList.splice(0, modelList.length);
    for (var i = 0; i < $scope.attachments.length; i++) {
      modelList.push($scope.attachments[i]);
    }
  }
  $scope.updateAttachments = function () {
    if (angular.isUndefined($scope.selected.model.attachments) || !angular.isArray($scope.selected.model.attachments)) {
      $scope.selected.model.attachments = [];
    }
    writeAttachments($scope.selected.model.attachments);
    $scope.save(true);
  };
  $scope["delete"] = function () {
    contractFactory().deleteRecord({
      id: $scope.selected.version
    }).$promise.then(function () {
      toaster.pop('success', 'Eliminazione effettuata', '');
      $route.reload();
    });
  };
  $scope.getWorkflowRef = function () {
    /* controllo se tra i campi c'è una lookup sul workflow */
    angular.forEach($scope.form[0].items, function (item) {
      angular.forEach(item.tabs, function (tab) {
        angular.forEach(tab.items, function (model_item) {
          if (model_item.entity_id == 'workflow') {
            $scope.workflow.ref = angular.copy(model_item);
          }
        });
      });
    });
  };
  $scope.$watch('selected.model.workflow_id', function (newValue, oldValue) {
    /* mi tiro giù tutto il workflow con il numero di stati */
    //$scope.selected.model.workflow_id = $scope.confModel.workflow_id;
    if ($scope.selected.model.workflow_id != undefined) {
      var UUID = $scope.selected.model.workflow_id.UUID;
      var type = $scope.selected.model.workflow_id.type;
      recordFactory(type).byUUID({
        id: UUID
      }).$promise.then(function (responseWorkflow) {
        if (responseWorkflow.model) {
          if (responseWorkflow.model.steps == Object.keys($scope.selected.model.steps).length) {
            for (var i = 0; i < responseWorkflow.model.steps; i++) {
              if (!$scope.selected.UUID) {
                $scope.selected.model.steps['step' + (i + 1).toString()] = {
                  'step_id': {},
                  'days': 0,
                  'days_acts': 0,
                  'date_start': '',
                  'date_end': ''
                };
              }
            }
          } else if (responseWorkflow.model.steps < Object.keys($scope.selected.model.steps).length) {
            var start = Object.keys($scope.selected.model.steps).length;
            for (var i = start; i >= responseWorkflow.model.steps; i--) {
              delete $scope.selected.model.steps['step' + (i + 1).toString()];
            }
          } else if (responseWorkflow.model.steps > Object.keys($scope.selected.model.steps).length) {
            for (var i = Object.keys($scope.selected.model.steps).length; i < responseWorkflow.model.steps; i++) {
              $scope.selected.model.steps['step' + (i + 1).toString()] = {
                'step_id': {},
                'days': 0,
                'days_acts': 0,
                'date_start': '',
                'date_end': ''
              };
            }
          }
          $scope.getArrayFromProp($scope.selected.model.steps);
        }
      });
    }
  });
  $scope.$watch('selectedStep.value.UUID', function () {
    if (angular.isDefined($scope.selectedStep.value) && $scope.selectedStep.value.UUID) {
      /* devo trovare lo step associato */
      angular.forEach($scope.selected.model.steps, function (value, key) {
        if (value.step_id.UUID == $scope.selectedStep.value.UUID) {
          console.log(key);
          $scope.getAttributeList(key);
        }
      });
    }
  });
  $scope.workflowSelected = function (ref) {
    return ref != null && ref != '' && ref != undefined;
  };
  $scope.getArrayFromProp = function (obj) {
    /* obj = { steps3: '', step2: '', step1: '' } => creo array e ordino per nome proprietà => [ step1 : {}, step2 : {}, step3 : {} ] */
    $scope.arrayRet.length = 0;
    $scope.arrayIds.length = 0;
    var keys = [];
    for (var k in obj) {
      if (obj.hasOwnProperty(k)) {
        keys.push(k);
      }
    }
    keys.sort();
    var len = keys.length;
    for (var i = 0; i < len; i++) {
      k = keys[i];
      $scope.arrayRet.push(obj[k]);
      $scope.arrayIds.push('step' + (i + 1));
    }
    return $scope.arrayRet;
  };
  $scope.getAttributeList = function (key) {
    // key sarà step1, step2, step3
    $scope.dateStepArray[key] = [];
    if ($scope.selectedStep.value.model) {
      angular.forEach($scope.selectedStep.value.model.form[0].items, function (item) {
        angular.forEach(item.tabs, function (tab) {
          angular.forEach(tab.items, function (model_item) {
            if (model_item.type == 'datepicker') {
              $scope.dateStepArray[key].push(model_item);
            }
          });
        });
      });
    }
  };
  function fixDates(contract) {
    if (angular.isDefined(contract.model)) {
      $scope.form[0].items.forEach(function (item) {
        item.tabs.forEach(function (tab) {
          tab.items.forEach(function (model_item) {
            if (model_item.type === 'datepicker') {
              var propertyName = model_item.key[0];
              if (angular.isDefined(contract.model[propertyName]) && contract.model[propertyName] != null) {
                contract.model[propertyName] = new Date(contract.model[propertyName]);
              }
            }
          });
        });
      });
    }
    return contract;
  }
  function getContractRecord() {
    contractFactory().recordByCommission().$promise.then(function (responseRecord) {
      if (responseRecord.model) {
        $scope.lock = true;
        $scope.selected = fixDates(responseRecord);
        if (responseRecord.model.exclude_from_istat) $scope.excludedServices.services = responseRecord.model.exclude_from_istat;
        $scope.getArrayFromProp($scope.selected.model.steps);
        $scope.plafond_total = getPlafondTotal();
        getPlafondUsed();
        readAttachments($scope.selected.model.attachments);
        getIstatConfig(responseRecord.model.istat_config).then(function (data) {
          $scope.istatType.selected = data;
        });
        console.log($scope.selected);
      } else {
        $scope.lock = false;
        $scope.selected = {
          model: {
            workflow_id: null,
            steps: {},
            code: currentCommission.code,
            description: currentCommission.description
          }
        };
      }
    });
  }
  function getIstatConfig(config) {
    return $q(function (resolve, reject) {
      if (config) {
        var result = {
          step_id: config.step_id
        };
        result.type = {
          key: config.type,
          title: $scope.istatType.types[$scope.istatType.types.findIndex(function (el) {
            return el.key == config.type;
          })].title
        };
        if (config.month != undefined) {
          result.month = {
            key: config.month,
            title: $scope.monthList[$scope.monthList.findIndex(function (m) {
              return m.key == config.month;
            })].title
          };
        }
        if (config.recurrency) {
          result.recurrency = config.recurrency;
        }
        acquisitionStepFactory().byUUID({
          id: config.step_id.UUID
        }).$promise.then(function (data) {
          result.step_field = {
            key: config.step_field,
            title: data.model.schema.properties[config.step_field].title
          };
          resolve(result);
        });
      } else {
        resolve({});
      }
    });
  }
  $scope.getContractSchema = function () {
    /* scarico il modello e se me lo trova scarico anche il record -> che sarà sempre lo stesso */
    contractFactory().schemaByCommission().$promise.then(function (responseSchema) {
      if (!responseSchema.model) {
        dialogService.alert('Non è stato definito un modello specifico per la convenzione ', 4000);
        return;
      }
      $scope.enableAttachments = responseSchema.model.attachmentManagement;
      $scope.enableServiceExclusion = responseSchema.model.excludeServicesFromIstat;
      $scope.schema = responseSchema.model.schema;
      $scope.form = responseSchema.model.form;
      $scope.getWorkflowRef();
      getContractRecord();
    })["catch"](function (response) {
      // error
    })["finally"](function (response) {
      // finally
    });
  };
  $scope.isIntegrationEnabled = function () {
    var enabled = $scope.selected.version && $scope.selected.model.plafond && $scope.selected.model.plafond > 0;
    return enabled;
  };
  $scope.hasPlafondIntegrations = function () {
    var hasIntegrations = $scope.selected.version && $scope.selected.model.plafond && $scope.selected.model.plafond > 0 && angular.isDefined($scope.selected.model.plafond_integrations);
    return hasIntegrations;
  };
  $scope.integratePlafond = function () {
    $scope.isPlafondEditing = true;
    $scope.plafond_total = getPlafondTotal();
    getPlafondUsed();
    $scope.newPlafondIntegration = {
      date: new Date()
    };
  };
  $scope.saveIntegratePlafond = function () {
    if (!$scope.newPlafondIntegration.value) {
      toaster.pop('error', 'Inserire un valore valido', 'La cifra inserita per l\'integrazione non è valida.');
    } else if (!$scope.newPlafondIntegration.date) {
      toaster.pop('error', 'Inserire una data valida', 'La data inserita per l\'integrazione non è valida.');
    } else {
      $scope.isPlafondEditing = false;
      var newItem = {};
      for (var key in $scope.newPlafondIntegration) {
        newItem[key] = $scope.newPlafondIntegration[key];
      }
      if (angular.isUndefined($scope.selected.model.plafond_integrations)) {
        $scope.selected.model.plafond_integrations = [];
      }
      $scope.selected.model.plafond_integrations.push(newItem);
      $scope.plafond_total = getPlafondTotal();
      getPlafondUsed();
    }
  };
  function getPlafondTotal() {
    $scope.newPlafondIntegration = undefined;
    var sum = $scope.selected.model.plafond;
    if (angular.isDefined($scope.selected.model.plafond_integrations)) {
      angular.forEach($scope.selected.model.plafond_integrations, function (item) {
        sum += item.value;
      });
    }
    return sum;
  }
  function getPlafondUsed() {
    $scope.plafond = {
      used: 0,
      remaining: 0,
      available: 0
    };
    if (angular.isDefined($scope.plafond_total)) {
      $scope.plafond.available = $scope.plafond_total;
      acquisitionWizardFactory.getUsedPlafond().$promise.then(function (data) {
        $scope.plafond.used = data.result;
        $scope.plafond.remaining = $scope.plafond.available - $scope.plafond.used;
        $scope.plafond.remaining_class = $scope.plafond.remaining > 0 ? "text-success-dker" : "text-danger-dker";
      });
    }
  }
  $scope.undoIntegratePlafond = function () {
    $scope.isPlafondEditing = false;
    $scope.newPlafondIntegration = undefined;
  };
  $scope.getFormulaList = function () {
    formulaFactory.getFormulasList({
      query: $scope.queryParam,
      page_size: 1000
    }).$promise.then(function (data) {
      $scope.formulaList = data.list;
    });
  };
  $scope.setDefaultDays = function (index) {
    if (!angular.isDefined($scope.selected.model.steps[index].type_days)) {
      $scope.selected.model.steps[index].type_days = 'nolimits';
    }
  };
  $scope.refreshDays = function (index) {
    if ($scope.selected.model.steps[index].type_days == 'number') {
      if (angular.isDefined($scope.selected.model.steps[index].formula_days)) {
        delete $scope.selected.model.steps[index].formula_days;
        delete $scope.selected.model.steps[index].params_days;
      }
    } else if ($scope.selected.model.steps[index].type_days == 'formula') {
      if (angular.isDefined($scope.selected.model.steps[index].days)) {
        delete $scope.selected.model.steps[index].days;
      }
    } else if ($scope.selected.model.steps[index].type_days == 'nolimits') {
      delete $scope.selected.model.steps[index].days;
      if (angular.isDefined($scope.selected.model.steps[index].formula_days)) {
        delete $scope.selected.model.steps[index].formula_days;
        delete $scope.selected.model.steps[index].params_days;
      }
    }
  };
  $scope.setDefaultDaysActs = function (index) {
    if (!angular.isDefined($scope.selected.model.steps[index].type_days_acts)) {
      $scope.selected.model.steps[index].type_days_acts = 'nolimits';
    }
  };
  $scope.refreshDaysActs = function (index) {
    if ($scope.selected.model.steps[index].type_days_acts == 'number') {
      if (angular.isDefined($scope.selected.model.steps[index].formula_days_acts)) {
        delete $scope.selected.model.steps[index].formula_days_acts;
        delete $scope.selected.model.steps[index].params_days_acts;
      }
    } else if ($scope.selected.model.steps[index].type_days_acts == 'formula') {
      if (angular.isDefined($scope.selected.model.steps[index].days_acts)) {
        delete $scope.selected.model.steps[index].days_acts;
      }
    } else if ($scope.selected.model.steps[index].type_days_acts == 'nolimits') {
      delete $scope.selected.model.steps[index].days_acts;
      if (angular.isDefined($scope.selected.model.steps[index].formula_days_acts)) {
        delete $scope.selected.model.steps[index].formula_days_acts;
        delete $scope.selected.model.steps[index].params_days_acts;
      }
    }
  };
  $scope.initFormuleDescriptors = function () {
    if (angular.isDefined($scope.selected.model)) {
      angular.forEach($scope.selected.model.steps, function (value, key) {
        if (angular.isDefined(value['formula_days'])) {
          formulaFactory.getFormulaById({
            id: value['formula_days']
          }).$promise.then(function (data) {
            if (data.formula) {
              $scope.formuleStrBodyDays[key] = data.formula;
            }
          });
        }
        /* atti aggiuntivi */
        if (angular.isDefined(value['formula_days_acts'])) {
          formulaFactory.getFormulaById({
            id: value['formula_days_acts']
          }).$promise.then(function (data) {
            if (data.formula) {
              $scope.formuleStrBodyDaysActs[key] = data.formula;
            }
          });
        }
      });
    }
  };
  $scope.getFormattedParams = function (index) {
    if ($scope.selected.model.steps[index].type_days == 'formula') {
      return 'col-md-offset-1 col-md-6';
    } else {
      return 'col-md-5';
    }
  };
  $scope.getParams = function (step, formulaField, paramsField) {
    formulaFactory.getParamsByArray({
      id: $scope.selected.model.steps[step][formulaField]
    }).$promise.then(function (data) {
      if (angular.isDefined(data.result)) {
        $scope.selected.model.steps[step][paramsField] = {};
        if (data.result != null) {
          $scope.selected.model.steps[step][paramsField] = data.result;
        }
      }
    });
    formulaFactory.getFormulaById({
      id: $scope.selected.model.steps[step][formulaField]
    }).$promise.then(function (data) {
      if (data.formula) {
        if (formulaField == 'formula_days') {
          $scope.formuleStrBodyDays[step] = data.formula;
        } else if (formulaField == 'formula_days_acts') {
          $scope.formuleStrBodyDaysActs[step] = data.formula;
        }
      }
    });
  };

  // ____ main
  $scope.getContractSchema();
  $scope.getFormulaList();
  getStepList();
  getSalStatus();
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:ContractConfiguratorCtrl
 * @description
 * # ContractConfiguratorCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.consip').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/contractconfigurator', {
    templateUrl: 'consip/contract/contractconfigurator_detail.html',
    controller: 'ContractConfiguratorCtrl'
  });
}]).controller('ContractConfiguratorCtrl', ["$scope", "$routeParams", "$location", "$route", "contractFactory", "acquisitionStepFactory", "schemaFactory", "commissionFactory", "formulaFactory", "authFactory", "toaster", "$log", function ($scope, $routeParams, $location, $route, contractFactory, acquisitionStepFactory, schemaFactory, commissionFactory, formulaFactory, authFactory, toaster, $log) {
  $scope.form = {};
  $scope.model = {};
  $scope.schema = {};
  $scope.property = {};
  $scope.checked = {};
  $scope.uiselectMap = {};
  $scope.itemTypeMap = {};
  $scope.newItemArray = {
    record_id: {}
  };
  $scope.status = {
    isFirstOpen: true,
    isFirstDisabled: false
  };

  /* ------------------------------------------------ */

  $scope.attachmentManagement = false;
  $scope.excludeServicesFromIstat = false;
  $scope.contractList = []; /* lista delle convenzioni per la pagina _list */

  $scope.formList = []; /* lista dei form da associare agli step */

  $scope.registry = {}; /* model della CONVENZIONE */

  $scope.steps = {};
  $scope.commissions = []; /* commesse disponibili */

  $scope.commissionsSelected = {
    codes: []
  }; /* commesse selezionate */

  $scope.formulaList = {}; /* formule disponibili da poter inserire con il configuratore */

  $scope.modeltypeList = schemaFactory().lookupList({
    page_size: 1000
  });
  var currentCommission = authFactory.getAuthData().info.commissions.current;
  $scope.selected = {
    /** contenitore */
    model: {
      commission: [],
      schema: {},
      form: [],
      code: '',
      description: '',
      columnDefs: []
    }
  };
  $scope.getFormulaList = function () {
    formulaFactory.getFormulasList({
      query: $scope.queryParam,
      page_size: 1000
    }).$promise.then(function (data) {
      $scope.formulaList = data.list;
    });
  };
  $scope.save = function () {
    if ($scope.code && $scope.description) {
      /* aggiorno code e description */
      $scope.selected.model.code = $scope.code;
      $scope.selected.model.description = $scope.description;
      $scope.selected.model.attachmentManagement = $scope.attachmentManagement;
      $scope.selected.model.excludeServicesFromIstat = $scope.excludeServicesFromIstat;
      if ($scope.selected.version) {
        /* update */
        contractFactory().updateSchema({
          id: $scope.selected.version
        }, $scope.aceModel).$promise.then(function () {
          console.log('updated!');
          toaster.pop('success', 'Salvataggio effettuato', '');
          $route.reload();
        });
      } else {
        /* create */
        $scope.selected.model.hidden = true; //nascondo le convenzioni dalla schermata dei modelli    
        contractFactory().createSchema($scope.selected).$promise.then(function () {
          console.log('created!');
          toaster.pop('success', 'Salvataggio effettuato', '');
          $route.reload();
        });
      }
    }
  };
  $scope["delete"] = function () {
    /* eliminare tramite routeParam.id */
    contractFactory().deleteSchema({
      id: $scope.selected.version
    }).$promise.then(function () {
      console.log('deleted!');
      toaster.pop('error', 'Eliminazione effettuata', '');
      $route.reload();
    });
  };
  $scope.getSetupConfiguration = function () {
    /* prende i dati del modello convenzione di BASE */
    return schemaFactory().byCode({
      id: 'convenzione'
    }).$promise.then(function (data) {
      if (data.model) {
        $scope.selected.columnDefs = data.model.columnDefs;
        $scope.selected.schema = data.model.schema;
        $scope.selected.form = data.model.form;
        return data.model;
      } else {
        return false;
      }
    });
  };
  $scope.setCommissionSelected = function () {
    angular.forEach($scope.selected.model.commission, function (value_cm_string) {
      var index = null;
      angular.forEach($scope.commissions, function (value_cm_obj) {
        if (value_cm_string == value_cm_obj.code) {
          index = $scope.commissions.indexOf(value_cm_obj);
          $scope.commissionsSelected.codes.push(value_cm_obj);
          $scope.commissions.splice(index, 1);
        }
      });
    });
  };
  $scope.setCommissionToSelect = function () {
    $scope.selected.model.commission = [];
    angular.forEach($scope.commissionsSelected.codes, function (obj) {
      $scope.selected.model.commission.push(obj.code);
    });
  };
  $scope.getCommission = function getCommission() {
    return commissionFactory().getCommissionsList().$promise.then(function (response) {
      if (response.list) {
        $scope.commissions = response.list;
        var index = null;
        angular.forEach($scope.commissions, function (value_cm_obj) {
          if (currentCommission.code == value_cm_obj.code) {
            index = $scope.commissions.indexOf(value_cm_obj);
            $scope.commissionsSelected.codes.push(value_cm_obj);
            $scope.commissions.splice(index, 1);
          }
        });
        $scope.refreshCommission();
      }
    });
  };
  $scope.getContractConfiguration = function () {
    $scope.getSetupConfiguration().then(function (defaultConfiguration) {
      /* scarico prima la convenzione di base dalla quale partire */
      $scope.getCommission().then(function () {
        /* inserisco la commessa tra i dati */
        contractFactory().schemaByCommission().$promise.then(function (response) {
          /* scarico se c'è uno schema di convenzione salvato per la mia commessa  */
          if (response.model) {
            $scope.selected = angular.copy(response);
            $scope.code = response.model.code;
            $scope.description = response.model.description;
            $scope.attachmentManagement = response.model.attachmentManagement;
            $scope.excludeServicesFromIstat = response.model.excludeServicesFromIstat;
            $scope.setCommissionSelected();
            $scope.updateScope();
          } else {
            if (!defaultConfiguration) {
              toaster.pop('info', 'Configurazione predefinita mancante', 'Non esiste una configurazione di convenzione predefinita (schema: "convenzione") e non esiste una configurazione specifica per la commessa corrente.');
            }
            $scope.code = currentCommission.code;
            $scope.description = currentCommission.description;
            $scope.updateScope();
          }
        });
      });
    });
  };
  $scope.getContractConfiguration();
  $scope.getFormulaList();

  /*****************************************************************************/
  /*************** ADD & DELETE PROPERTIES ON $scope.model.schema *************/
  /***************************************************************************/

  $scope.addProperty = function () {
    if (angular.isDefined($scope.property.key)) {
      var p = {
        title: angular.copy($scope.property.title),
        type: angular.copy($scope.property.type),
        check: false
      };
      if ($scope.property.format) {
        p.format = angular.copy($scope.property.format);
      }
      if (p.type == 'date') {
        p.type = 'string';
        p.format = 'date';
      }
      if (p.type == 'array') {
        p.items = {
          type: angular.copy($scope.property.items_type)
        }; // default
        if ($scope.property.items_type === 'date') {
          // se è una data è diverso...
          p.items = {
            type: 'string',
            format: 'date'
          };
        }
      }
      if ($scope.property.inherited) {
        if ($scope.property.inherited == true) {
          p.format = 'inherit';
          p.field = '';
          p.record = '';
          if ($scope.property.format) {
            p.field_inherit_type = $scope.property.format;
            if ($scope.property.format == 'enum') {
              delete p["enum"];
            }
          }
          if (p.type == 'integer') {
            p.type = 'number';
          }
        }
      }
      $scope.selected.model.schema.properties[$scope.property.key] = p;
      var item = {
        title: angular.copy($scope.property.title),
        type: null,
        key: [angular.copy($scope.property.key)]
      };
      if (p.format) {
        if (p.format == 'date') {
          item.type = 'datepicker';
        } else if (p.format == 'enum') {
          item.type = 'uiselect';
          item.titleMap = [];
        } else if (p.format == 'lookup') {
          item.type = 'sixlookup';
        } else if (p.format == 'formula') {
          item.type = 'sixformula';
        } else if (p.format == 'inherit') {
          item.type = 'sixinherit';
        }
      } else if (p.type == 'string') {
        item.type = 'text';
      } else if (p.type == 'number' || p.type == 'integer') {
        item.type = 'number';
      } else if (p.type == 'boolean') {
        item.type = 'checkbox';
      } else if (p.type == 'array') {
        item.type = 'uiselectmultiple';
        item.titleMap = [];
      } else {
        // default
        item.type = angular.copy(p.type);
      }
      for (var i in $scope.selected.model.form[0].items) {
        if ($scope.selected.model.form[0].items[i].tabs) {
          $scope.selected.model.form[0].items[i].tabs[0].items.push(item);
        }
      }
    }
    $scope.getUiSelectMap();
    $scope.clearNewCol();
    $scope.updateScope();
  };
  $scope.clearNewCol = function () {
    $scope.property.key = '';
    $scope.property.title = '';
    delete $scope.property.type;
    delete $scope.property.format;
    delete $scope.property.inherited;
  };
  $scope.deleteProperty = function (keyToDelete) {
    delete $scope.selected.model.schema.properties[keyToDelete];
    for (var i = $scope.selected.model.columnDefs.length; i--;) {
      if ($scope.selected.model.columnDefs[i].field == keyToDelete) $scope.selected.model.columnDefs.splice(i, 1);
    }
    for (var i = $scope.selected.model.form[0].items.length; i--;) {
      if ($scope.selected.model.form[0].items[i].key && $scope.selected.model.form[0].items[i].key[0] == keyToDelete) {
        $scope.selected.model.form[0].items.splice(i, 1);
      }
      // Scorro anche i tabs
      if ($scope.selected.model.form[0].items[i].tabs) {
        for (var j = $scope.selected.model.form[0].items[i].tabs.length; j--;) {
          for (var k = $scope.selected.model.form[0].items[i].tabs[j].items.length; k--;) {
            if ($scope.selected.model.form[0].items[i].tabs[j].items[k].key[0] == keyToDelete) {
              $scope.selected.model.form[0].items[i].tabs[j].items.splice(k, 1);
            }
          }
        }
      }
    }
    $scope.updateScope();
  };
  $scope.getStepList = function () {
    if (!$scope.stepList) {
      acquisitionStepFactory().lookup({
        page_size: 1000
      }).$promise.then(function (data) {
        $scope.stepList = data.list;
      });
    }
  };
  $scope.refreshContraintsCheckbox = function (key, enableConstraints) {
    if (enableConstraints) {
      $scope.selected.model.schema.properties[key].enableConstraints = enableConstraints;
    } else {
      delete $scope.selected.model.schema.properties[key].constraints;
      delete $scope.selected.model.schema.properties[key].enableConstraints;
    }
    $scope.updateScope();
  };
  $scope.addConstraint = function (key, newItem) {
    if (newItem && newItem.name && newItem.name != '' && newItem.relation && newItem.relation != '') {
      if (!angular.isDefined($scope.selected.model.schema.properties[key].constraints)) {
        $scope.selected.model.schema.properties[key].constraints = [];
      }
      var toPush = {
        key: key,
        step: {
          fieldToCheck: newItem.name.trim(),
          code: newItem.step.model.code,
          description: newItem.step.model.description,
          uuid: newItem.step.UUID
        },
        relation: newItem.relation
      };
      $scope.selected.model.schema.properties[key].constraints.push(toPush);
      this.newItem = null;
      $scope.updateScope();
    }
  };
  $scope.deleteConstraint = function (key, index) {
    if (angular.isDefined($scope.selected.model.schema.properties[key].constraints) && Array.isArray($scope.selected.model.schema.properties[key].constraints)) {
      $scope.selected.model.schema.properties[key].constraints.splice(index, 1);
    }
    if ($scope.selected.model.schema.properties[key].constraints.length == 0) {
      delete $scope.selected.model.schema.properties[key].enableConstraints;
      delete $scope.selected.model.schema.properties[key].constraints;
    }
    $scope.updateScope();
  };

  /*****************************************************************************/
  /*************** AGGIORNA LA $scope.selected.model.columnDefs ***************/
  /***************************************************************************/

  $scope.changeColumnDefs = function (key, value) {
    var item = {
      name: value.title,
      field: key
    };
    var map = {};
    angular.forEach($scope.selected.model.columnDefs, function (v) {
      map[v.field] = angular.copy(v);
    });
    if (value.check) {
      map[item.field] = angular.copy(item);
      if (value.width == '' || value.width == null) {
        delete $scope.selected.model.schema.properties[key].width;
      }
    } else {
      delete map[item.field];
      delete $scope.selected.model.schema.properties[key].width;
      $scope.selected.model.schema.properties[key].enableFiltering = false;
      $scope.selected.model.schema.properties[key].enableSorting = false;
    }
    $scope.selected.model.columnDefs = [];
    for (var it in map) {
      var app = {
        name: map[it].name,
        field: map[it].field
      };
      $scope.selected.model.columnDefs.push(app);
    }
    $scope.updateScope();
  };

  /*************************************/
  /*************** FORM ***************/
  /***********************************/

  $scope.newFieldForm = {};
  $scope.newTab = {
    title: "",
    items: []
  };
  $scope.addTab = function (container) {
    if (!container.tabs) {
      container.tabs = [];
    }
    if (container.type !== 'tabs') {
      container.type = 'tabs';
    }
    var toAdd = angular.copy($scope.newTab);
    $log.log(container);
    container.tabs.push(toAdd);
    $log.log(container);
    $scope.updateScope();
    $scope.newTab = {
      title: "",
      items: []
    };
  };
  $scope.addFieldToTab = function (tab) {
    if (!tab.items) {
      tab.items = [];
    }
    var toAdd = angular.copy($scope.newFieldForm);
    if ($scope.newFieldForm.type === '' || $scope.newFieldForm.type === 'formula' || $scope.newFieldForm.type === 'inherited') {
      delete toAdd.type;
    }
    /* key è da cambiare in un array */
    toAdd.key = [];
    toAdd.key.push($scope.newFieldForm.key);
    /* se è una lookup, e se ha definito il campo entity_id nello schema, ci attacco anche l'entity_id */
    if (toAdd.type == 'sixlookup' && $scope.schema.properties[$scope.newFieldForm.key]['entity_id']) {
      toAdd['entity_id'] = $scope.schema.properties[$scope.newFieldForm.key]['entity_id'];
    }
    tab.items.push(toAdd);
    $log.log(tab);
    $scope.updateScope();
    $scope.newFieldForm = {
      key: [],
      title: "",
      required: false,
      type: "text"
    };
  };
  $scope.removeTabOrField = function (key, container) {
    container.splice(key, 1);
    $log.log(container);
    $scope.updateScope();
  };
  $scope.swapUp = function (key, collection) {
    if (key > 0) {
      var tmp = collection[key];
      collection[key] = collection[key - 1];
      collection[key - 1] = tmp;
    }
    $scope.updateScope();
  };
  $scope.swapDown = function (key, collection) {
    if (key < collection.length - 1) {
      var tmp = collection[key];
      collection[key] = collection[key + 1];
      collection[key + 1] = tmp;
    }
    $scope.updateScope();
  };
  $scope.updateField = function (field) {
    if (field.type === '') {
      delete field.type;
    }
    $scope.updateScope();
  };

  /**********************************************************************************************************/
  /*************** GESTIONE DEGLI ELEMENTI NEI TAB $scope.selected.model.form[0].items[i].tabs *************/
  /********************************************************************************************************/

  $scope.addItemOnArray = function (key, newItem) {
    if (newItem != undefined && newItem != null) {
      newItem.name = newItem.name.toString();
      if ($scope.itemTypeMap[key] == 'integer') {
        if (parseInt(newItem.name)) {
          newItem.value = parseInt(newItem.name);
          newItem.name = newItem.value.toString(); /* nel caso ci dovesse essere un cast, torno a sovrascrivere il name */
        } else {
          return;
        }
      } else if ($scope.itemTypeMap[key] == 'number') {
        if (parseFloat(newItem.name)) {
          newItem.value = parseFloat(newItem.name);
        } else {
          return;
        }
      } else {
        newItem.value = newItem.name.toString().replace(/\s/g, '_').toLowerCase();
      }
      for (var i in $scope.selected.model.form[0].items) {
        if ($scope.selected.model.form[0].items[i].tabs) {
          $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
            if (key == item.key[0]) {
              item.titleMap.push(newItem);
            }
          });
        }
      }
      this.newItem = null;
      $scope.updateScope();
    }
  };
  $scope.deleteItemOnArray = function (key, obj) {
    for (var i in $scope.selected.model.form[0].items) {
      if ($scope.selected.model.form[0].items[i].tabs) {
        $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
          if (key == item.key[0]) {
            for (var j = item.titleMap.length; j--;) {
              if (item.titleMap[j].value == obj.value) {
                item.titleMap.splice(j, 1);
              }
            }
          }
        });
      }
    }
    this.newItem = null;
    $scope.updateScope();
  };
  $scope.addRefOnArray = function (key, ref) {
    var newItem = {};
    if (ref.record_id != undefined && ref.record_id != null) {
      newItem.value = ref.record_id.code;
      newItem.name = ref.record_id.description;
      $scope.addItemOnArray(key, newItem);
    }
  };

  /*****************************************/
  /*************** FIX SCHEMA *************/
  /***************************************/

  $scope.fixSchemaFormModel = function () {
    for (var i in $scope.selected.model.form[0].items) {
      if ($scope.selected.model.form[0].items[i].tabs) {
        $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
          if (item.type == 'uiselect') {
            $scope.selected.model.schema.properties[item.key[0]].format = 'enum';
          }
          if (item.type == 'uiselectmultiple') {
            $scope.selected.model.schema.properties[item.key[0]].type = 'array';
          }
        });
      }
    }
  };

  /***************************************************************************/
  /***** UTILITY PER DATA BINDING TRA $scope.selected E $scope.aceModel *****/
  /*************************************************************************/

  $scope.isInheritable = function (type) {
    return type == 'number' || type == 'integer' || type == 'string' || type == 'boolean' || type == 'lookup';
  };
  $scope.formChanged = function () {
    $scope.aceModel = JSON.stringify(angular.copy($scope.selected), null, '\t');
  };
  $scope.chargeAceModel = function () {
    var defaultData = angular.fromJson(angular.copy($scope.aceModel));
    if (defaultData) {
      $scope.selected = defaultData;
      $scope.schema = angular.fromJson(defaultData.model.schema);
      $scope.form = angular.fromJson(defaultData.model.form);
      $scope.columnDefs = angular.fromJson(defaultData.model.columnDefs);
    }
  };
  $scope.updateScope = function () {
    $scope.schema = angular.fromJson(angular.copy($scope.selected.model.schema));
    $scope.form = [angular.fromJson(angular.copy($scope.selected.model.form[0]))];
    $scope.columnDefs = angular.fromJson(angular.copy($scope.selected.model.columnDefs));
    $scope.formChanged();
  };
  function addSelectedValue(array, obj) {
    var blankValuePresent = false;
    array.forEach(function (item) {
      if (item.value == obj.value && item.name == obj.name) {
        blankValuePresent = true;
      }
    });
    if (blankValuePresent == false) {
      array.push(obj);
    }
    return array;
  }
  $scope.getUiSelectMap = function () {
    $scope.uiselectMap = {};
    $scope.itemTypeMap = {};
    for (var i in $scope.selected.model.form[0].items) {
      if ($scope.selected.model.form[0].items[i].tabs) {
        $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
          if (item.type !== 'fieldset') {
            $scope.itemTypeMap[item.key[0]] = $scope.selected.model.schema.properties[item.key[0]].type;
            if ($scope.selected.model.schema.properties[item.key[0]].type == 'array') {
              $scope.itemTypeMap[item.key[0]] = $scope.selected.model.schema.properties[item.key[0]].items.type;
            }
            if (item.type == 'uiselect' || item.type == 'uiselectmultiple') {
              var blankObject = {
                name: '',
                value: ''
              };
              $scope.uiselectMap[item.key[0]] = addSelectedValue(item.titleMap, blankObject);
              /* aggiunto un elemento vuoto all'array per consentire il deselezionamento */
            }
          }
        });
      }
    }
  };

  $scope.toggleEnumDefault = function (key, objValue) {
    var property = $scope.selected.model.schema.properties[key];
    if (typeof property["default"] == "undefined" || property["default"].indexOf(objValue) == -1) {
      property["default"] = [objValue];
    } else {
      property["default"] = undefined;
    }
    this.newItem = null;
    $scope.updateScope();
  };
  $scope.aceLoaded = function () {
    var defaultModel = {
      model: {
        schema: {
          type: "object",
          title: "",
          properties: {
            code: {
              title: "Codice",
              type: "string",
              check: true
            },
            description: {
              title: "Descrizione",
              type: "string",
              check: true
            }
          },
          required: ["code", "description"]
        },
        form: [{
          type: "fieldset",
          items: [{
            type: "tabs",
            tabs: [{
              title: "Dati Base",
              items: [{
                key: ["code"],
                title: "Codice",
                required: true,
                type: "text"
              }, {
                key: ["description"],
                title: "Descrizione",
                required: true,
                type: "text"
              }]
            }]
          }]
        }],
        columnDefs: [{
          "field": "code",
          "name": "Codice"
        }, {
          "field": "description",
          "name": "Descrizione"
        }]
      }
    };
    $scope.aceModel = JSON.stringify(defaultModel, null, '\t');
    $scope.chargeAceModel();
    $scope.title = angular.copy($scope.selected.model.form[0].title);

    /**********************************************/
    /* MAIN
    /*********************************************/
    $scope.getStepList();
    schemaFactory().byCode({
      id: 'convenzione'
    }).$promise.then(function (data) {
      if (data.model) {
        data.model.code = '';
        data.model.description = '';
        $scope.selected.model = angular.copy(data.model);
        $scope.fixSchemaFormModel();
        $scope.schema = angular.copy($scope.selected.model.schema);
        $scope.form = angular.copy($scope.selected.model.form);
        $scope.title = angular.copy($scope.selected.model.form[0].title);
        $scope.code = angular.copy($scope.selected.model.code);
        $scope.description = angular.copy($scope.selected.model.description);
        if ($scope.selected.model.columnDefs && $scope.selected.model.columnDefs.length != 0) {
          $scope.columnDefs = angular.copy($scope.selected.model.columnDefs);
        } else {
          $scope.columnDefs = [{
            name: 'Codice',
            field: 'code'
          }, {
            name: 'Descrizione',
            field: 'description'
          }];
          $scope.selected.model.columnDefs = angular.copy($scope.columnDefs);
        }
        angular.forEach($scope.columnDefs, function (value) {
          $scope.selected.model.schema.properties[value.field].check = true;
        });
        $scope.schema = angular.copy($scope.selected.model.schema);
        $scope.aceModel = JSON.stringify($scope.selected, null, '\t');
        $scope.model = {};
        $scope.commissionDependent = $scope.selected.model.commissionDependent;
        $scope.history = angular.copy($scope.selected.model.history);
        $scope.attachmentManagement = $scope.selected.model.attachmentManagement;
        $scope.excludeServicesFromIstat = $scope.selected.model.excludeServicesFromIstat;
        $scope.getUiSelectMap();
      }
    });
  };
  $scope.refreshCode = function (code) {
    $scope.chargeAceModel();
    $scope.selected.model.code = angular.copy(code);
    $scope.updateScope();
  };
  $scope.refreshDescription = function (description) {
    $scope.chargeAceModel();
    if (description) {
      $scope.selected.model.description = angular.copy(description);
      if (angular.isUndefined($scope.selected.UUID)) {
        $scope.code = sixStringLib.removeDiacritics(description);
        $scope.code = $scope.code.replace(/[^\w]|_/g, '').replace(/^(\d)(.*)/, '_$1$2').toLowerCase();
        $scope.selected.model.code = angular.copy($scope.code);
      }
    }
    $scope.updateScope();
  };
  $scope.refreshLookup = function (key, entity_id) {
    $scope.chargeAceModel();
    for (var i = $scope.selected.model.form[0].items.length; i--;) {
      if ($scope.selected.model.form[0].items[i].key && $scope.selected.model.form[0].items[i].key[0] == key) {
        $scope.selected.model.form[0].items[i].entity_id = angular.copy(entity_id);
      }
      // Scorro anche i tabs
      if ($scope.selected.model.form[0].items[i].tabs) {
        for (var j = $scope.selected.model.form[0].items[i].tabs.length; j--;) {
          for (var k = $scope.selected.model.form[0].items[i].tabs[j].items.length; k--;) {
            if ($scope.selected.model.form[0].items[i].tabs[j].items[k].key[0] == key) $scope.selected.model.form[0].items[i].tabs[j].items[k].entity_id = angular.copy(entity_id);
          }
        }
      }
    }
    $scope.selected.model.schema.properties[key].entity_id = angular.copy(entity_id);
    $scope.updateScope();
  };
  $scope.refreshCommission = function () {
    /** PROBABILMENTE E' DA SISTEMARE */
    $scope.chargeAceModel();
    $scope.selected.model.commission = [];
    angular.forEach($scope.commissionsSelected.codes, function (obj) {
      $scope.selected.model.commission.push(obj.code);
    });
    $scope.updateScope();
  };
  $scope.refreshAttachmentManagement = function () {
    $scope.chargeAceModel();
    $scope.selected.model.attachmentManagement = $scope.attachmentManagement;
    $scope.updateScope();
  };
  $scope.refreshExcludeServicesFromIstat = function () {
    $scope.chargeAceModel();
    $scope.selected.model.excludeServicesFromIstat = $scope.excludeServicesFromIstat;
    $scope.updateScope();
  };
  $scope.refreshStep = function (step) {
    $scope.chargeAceModel();
    $scope.selected.model.step = step;
    $scope.updateScope();
  };
  $scope.refreshFormula = function (key, formula_id) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].formula_id = angular.copy(formula_id);
    $scope.updateScope();
  };
  $scope.refreshFormulaParams = function (key, formula_params) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].formula_params = angular.copy(formula_params);
    $scope.updateScope();
  };
  $scope.refreshBasePath = function (key, basePath) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].basePath = angular.copy(basePath);
    $scope.updateScope();
  };
  $scope.refreshWar = function (key, war) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].war = angular.copy(war);
    $scope.updateScope();
  };
  $scope.refreshInheritRecord = function (key, record) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].record = angular.copy(record);
    $scope.updateScope();
  };
  $scope.refreshInheritField = function (key, field) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].field = angular.copy(field);
    $scope.updateScope();
  };
  $scope.refreshFiltered = function (key, filtered) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].filtered = angular.copy(filtered);
    $scope.updateScope();
  };
  $scope.refreshFilterSourceField = function (key, filterSourceField) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].filterSourceField = angular.copy(filterSourceField);
    $scope.updateScope();
  };
  $scope.refreshFilterDestField = function (key, filterDestField) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].filterDestField = angular.copy(filterDestField);
    $scope.updateScope();
  };
  $scope.refreshTitleForm = function (title) {
    $scope.chargeAceModel();
    $scope.selected.model.form[0].title = angular.copy(title);
    $scope.updateScope();
  };
}]);
'use strict';

/**
 * @author Rita Beltrami
 * @ngdoc function
 * @name sixEmmaApp.controller:DashboardConsipCtrl
 * @description
 * # DashboardConsipCtrl
 * Controller of the Consip project dashboard
 */
angular.module('emma.consip').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/consip', {
    templateUrl: 'theme/dashboard/dashboard.html',
    controller: 'DashboardConsipCtrl'
  });
}]).controller('DashboardConsipCtrl', ["$scope", "$log", "dashboardAssetFactory", "authFactory", function ($scope, $log, dashboardAssetFactory, authFactory) {
  //__params__
  var logInfo = true;
  var config = [];
  $scope.pos1 = [];
  $scope.pos2 = [];
  $scope.pos3 = [];
  $scope.widgetClass = "panel-widge";
  function userInfo() {
    if (authFactory.isAuthenticated()) {
      var authData = authFactory.getAuthData();
      return authData;
    } else {
      return;
    }
  }
  config = [{
    // Ultimi ODL inseriti
    "maxData": 5,
    //TODO: gestire
    "widgetApi": "dashboard/odl/list",
    "title": "Ultimi ODL inseriti",
    "skin": "primary",
    "widgetType": "widget-simple-list",
    "position": "pos-1",
    "buttons": [{
      "icon": "fa fa-plus",
      "label": "Nuovo ODL",
      "link": "odl/new"
    }]
  }, {
    // Profilo utente
    "title": "Profilo utente",
    "skin": "info",
    "widgetType": "widget-user",
    "position": "pos-2",
    "data": [{
      "user": userInfo().info.name + " " + userInfo().info.surname,
      "group": userInfo().authId,
      "avatar": "avatar.png",
      "buttons": [{
        "icon": "icon-bell",
        "label": "Notifiche",
        "link": "notification",
        "hasBadge": false
      }, {
        "icon": "icon-logout",
        "label": "Logout",
        "link": "#",
        "hasBadge": false
      }]
    }]
  }];

  /*
    function toDonutItem(item) {
        item.data = [
            {label: "1", value: 20, color: $scope.app.color.primary, description: 'Pippo'},
            {label: "2", value: 50, color: $scope.app.color.info, description: 'Pluto'},
            {label: "3", value: 30, color: $scope.app.color.warning, description: 'Paperino'}
        ];
    }
  */

  function convertToDonutFormat(item) {
    item.appColor = item.color;
    switch (item.color) {
      case "primary":
        item.color = $scope.app.color.primary;
        break;
      case "info":
        item.color = $scope.app.color.info;
        break;
      case "success":
        item.color = $scope.app.color.success;
        break;
      case "light":
        item.color = $scope.app.color.light;
        break;
      case "dark":
        item.color = $scope.app.color.dark;
        break;
      case "danger":
        item.color = $scope.app.color.danger;
        break;
      case "warning":
        item.color = $scope.app.color.warning;
        break;
      default:
        break;
    }
  }
  function createWidget(item) {
    // Retrieves data from the backend
    if (angular.isDefined(item.widgetApi)) {
      item.data = [];
      dashboardAssetFactory(item.widgetApi).query().$promise.then(function (data) {
        for (var i = 0; i < data.list.length; i++) {
          if (item.widgetType == "widget-donut") {
            convertToDonutFormat(data.list[i]);
          }
          item.data.push(data.list[i]);
        }
      });
    }
    // Sets widget to the right position.
    switch (item.position) {
      case 'pos-1':
        $scope.pos1.push(item);
        break;
      case 'pos-2':
        $scope.pos2.push(item);
        break;
      case 'pos-3':
        $scope.pos3.push(item);
        break;
      default:
        $log.info("Posizione widget sconosciuta");
    }
  }
  $scope.getDynamic = function (item) {
    return undefined;
  };
  $scope.initDashboard = function () {
    for (var i = 0; i < config.length; i++) {
      createWidget(config[i]);
    }
  };

  //__main__
  $scope.initDashboard();
}]);
"use strict";

angular.module('emma.consip').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/plafonddash', {
    templateUrl: 'consip/dashboard/plafond_dashboard.html',
    controller: 'PlafondDashboardCtrl'
  });
}]).controller('PlafondDashboardCtrl', ["$scope", "plafondSrv", "dialogService", "toaster", function ($scope, plafondSrv, dialogService, toaster) {
  $scope.liquidOpt = {
    waveAnimateTime: 1000
  };
  plafondSrv.getContractReport().then(function (contractReport) {
    console.log(contractReport);
    if (contractReport.hasErrors) {
      dialogService.serviceResponse('Report', contractPlafond, false);
    } else {
      var result = contractReport.result;
      $scope.customers = result.customer_plafonds;
      $scope.contractPlafond = {
        acquired: result.acquired,
        total: result.contract.model.plafond_total,
        residual: result.contract.model.plafond_total - result.acquired,
        turnover: result.turnover,
        acquiredPercent: result.acquired * 100 / result.contract.model.plafond_total
      };
      $scope.customerData = {
        name: 'root',
        children: result.customer_plafonds.map(function (item) {
          return {
            name: item.customer.code,
            description: item.customer.description,
            size: item.total,
            children: [{
              name: 'Fatturato',
              color: '#de783b',
              size: item.turnover
            }, {
              name: 'Disponibile',
              color: '#6ab975',
              size: item.total - item.turnover
            }]
          };
        })
      };
      $scope.customerData.children.push({
        name: 'Disponibile',
        color: '#d4d4d4',
        size: $scope.contractPlafond.residual
      });
    }
  })["catch"](function (err) {
    toaster.pop('error', '', 'Impossibile caricare i dati');
  });
}]);
'use strict';

angular.module('emma.theme').controller('SunburstChartCtrl', ['$scope', '$element', function ($scope, $element) {
  // Dimensions of sunburst.
  var width = 600;
  var height = 600;
  var radius = Math.min(width, height) / 2;

  // Breadcrumb dimensions: width, height, spacing, width of tip/tail.
  var b = {
    w: 90,
    h: 30,
    s: 3,
    t: 10
  };

  // Mapping of step names to colors.
  var color = d3.scale.category20();

  // Total size of all segments; we set this later, after loading the data.
  var totalSize = 0;
  var vis = d3.select($element[0].lastElementChild).append("svg:svg").attr("width", width).attr("height", height).style({
    display: 'block',
    margin: 'auto'
  }).append("svg:g").attr("id", "container").attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");
  var partition = d3.layout.partition().size([2 * Math.PI, radius * radius]).value(function (d) {
    return d.size;
  });
  var arc = d3.svg.arc().startAngle(function (d) {
    return d.x;
  }).endAngle(function (d) {
    return d.x + d.dx;
  }).innerRadius(function (d) {
    return Math.sqrt(d.y);
  }).outerRadius(function (d) {
    return Math.sqrt(d.y + d.dy);
  });
  createVisualization($scope.chartData);

  // Main function to draw and set up the visualization, once we have the data.
  function createVisualization(json) {
    // Basic setup of page elements.
    initializeBreadcrumbTrail();

    // Bounding circle underneath the sunburst, to make it easier to detect
    // when the mouse leaves the parent g.
    vis.append("svg:circle").attr("r", radius).style("opacity", 0);

    // For efficiency, filter nodes to keep only those large enough to see.
    var nodes = partition.nodes(json).filter(function (d) {
      return d.dx > 0.005; // 0.005 radians = 0.29 degrees
    });

    var path = vis.data([json]).selectAll("path").data(nodes).enter().append("svg:path").attr("display", function (d) {
      return d.depth ? null : "none";
    }).attr("d", arc).attr("fill-rule", "evenodd").style("fill", function (d, i) {
      return d.color || (d.color = color(i));
    }).style("opacity", 1).on("mouseover", mouseover);

    // Add the mouseleave handler to the bounding circle.
    d3.select("#container").on("mouseleave", mouseleave);

    // Get total size of the tree = value of root node from partition.
    totalSize = path.node().__data__.value;
  }
  ;

  // Fade all but the current sequence, and show it in the breadcrumb trail.
  function mouseover(d) {
    var percentage = (100 * d.value / d.parent.value).toPrecision(3);
    var percentageString = percentage + "%";
    if (percentage < 0.1) {
      percentageString = "< 0.1%";
    }
    $scope.point = {
      name: d.name,
      value: d.value,
      percentage: percentage
    };
    if (d.depth == 2) {
      $scope.point.description = d.parent.description;
    } else {
      $scope.point.description = d.description;
    }
    $scope.$digest();
    var sequenceArray = getAncestors(d);
    updateBreadcrumbs(sequenceArray, percentageString);

    // Fade all the segments.
    vis.selectAll("path").style("opacity", 0.3);

    // Then highlight only those that are an ancestor of the current segment.
    vis.selectAll("path").filter(function (node) {
      return sequenceArray.indexOf(node) >= 0;
    }).style("opacity", 1);
  }

  // Restore everything to full opacity when moving off the visualization.
  function mouseleave(d) {
    // Hide the breadcrumb trail
    d3.select("#trail").style("visibility", "hidden");

    // Deactivate all segments during transition.
    vis.selectAll("path").on("mouseover", null);

    // Transition each segment to full opacity and then reactivate it.
    vis.selectAll("path").transition().duration(1000).style("opacity", 1).each("end", function () {
      d3.select(this).on("mouseover", mouseover);
    });
    $scope.point = false;
    $scope.$digest();
  }

  // Given a node in a partition layout, return an array of all of its ancestor
  // nodes, highest first, but excluding the root.
  function getAncestors(node) {
    var path = [];
    var current = node;
    while (current.parent) {
      path.unshift(current);
      current = current.parent;
    }
    return path;
  }
  function initializeBreadcrumbTrail() {
    // Add the svg area.
    var trail = d3.select("#sequence").append("svg:svg").attr("width", width).attr("height", 50).attr("id", "trail");
    // Add the label at the end, for the percentage.
    trail.append("svg:text").attr("id", "endlabel").style("fill", "#000");
  }

  // Generate a string that describes the points of a breadcrumb polygon.
  function breadcrumbPoints(d, i) {
    var points = [];
    points.push("0,0");
    points.push(b.w + ",0");
    points.push(b.w + b.t + "," + b.h / 2);
    points.push(b.w + "," + b.h);
    points.push("0," + b.h);
    if (i > 0) {
      // Leftmost breadcrumb; don't include 6th vertex.
      points.push(b.t + "," + b.h / 2);
    }
    return points.join(" ");
  }

  // Update the breadcrumb trail to show the current sequence and percentage.
  function updateBreadcrumbs(nodeArray, percentageString) {
    // Data join; key function combines name and depth (= position in sequence).
    var g = d3.select("#trail").selectAll("g").data(nodeArray, function (d) {
      return d.name + d.depth;
    });

    // Add breadcrumb and label for entering nodes.
    var entering = g.enter().append("svg:g");
    entering.append("svg:polygon").attr("points", breadcrumbPoints).style("fill", function (d, i) {
      return d.color || color(i);
    });
    entering.append("svg:text").attr("x", (b.w + b.t) / 2).attr("y", b.h / 2).attr("dy", "0.35em").attr("text-anchor", "middle").text(function (d) {
      return d.name;
    });

    // Set position for entering and updating nodes.
    g.attr("transform", function (d, i) {
      return "translate(" + i * (b.w + b.s) + ", 0)";
    });

    // Remove exiting nodes.
    g.exit().remove();

    // Now move and update the percentage at the end.
    d3.select("#trail").select("#endlabel").attr("x", (nodeArray.length + 0.5) * (b.w + b.s)).attr("y", b.h / 2).attr("dy", "0.35em").attr("text-anchor", "middle").text(percentageString);

    // Make the breadcrumb trail visible, if it's hidden.
    d3.select("#trail").style("visibility", "");
  }
}]).directive('sunburst', function () {
  return {
    scope: {
      chartData: '='
    },
    restrict: 'AE',
    templateUrl: 'consip/dashboard/sunburst.html',
    controller: 'SunburstChartCtrl'
  };
});
"use strict";

angular.module('emma.consip').factory('acquisitionStepFactory', ["CONSIP_URL", "$resource", function (CONSIP_URL, $resource) {
  return function (type, param1, param2) {
    return $resource(CONSIP_URL + '/api/acquisitionstep/:verb/:id/:param1/:param2/:param3', {}, {
      query: {
        method: 'GET',
        isArray: false
      },
      lookup: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_lookup'
        }
      },
      lookupList: {
        method: 'GET',
        isArray: true,
        params: {
          verb: '_lookup',
          res_mode: 'list'
        }
      },
      byUUID: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_uuid',
          id: '@version',
          param1: '_current'
        }
      },
      byID: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_id',
          id: '@version'
        }
      },
      byCode: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_code',
          id: '@version'
        }
      },
      getSchema: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_uuid'
        }
      },
      search: {
        method: 'POST',
        isArray: false
      },
      filter: {
        method: 'POST',
        isArray: true
      },
      select: {
        method: 'GET',
        isArray: true
      },
      create: {
        method: 'POST'
      },
      bulk: {
        method: 'POST',
        isArray: true
      },
      show: {
        method: 'GET'
      },
      update: {
        method: 'PUT',
        params: {
          id: '@id'
        }
      },
      "delete": {
        method: 'DELETE',
        params: {
          id: '@id'
        }
      }
    });
  };
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.acquisitionWizardFactory
 * @description
 * # acquisitionWizardFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.consip').factory('acquisitionWizardFactory', ["CONSIP_URL", "$resource", function (CONSIP_URL, $resource) {
  return $resource(CONSIP_URL + '/api/acquisitionwizard/acquisition/:verb/:id/:param1/:param2/:param3', {}, {
    getWizardById: {
      method: 'GET'
    },
    getWizardByUUID: {
      method: 'GET',
      params: {
        verb: '_uuid',
        param1: '_current'
      }
    },
    getWizardsList: {
      method: 'GET'
    },
    getWizardsListFiltered: {
      method: 'POST',
      params: {
        verb: '_search'
      }
    },
    getByClient: {
      method: 'GET',
      params: {
        param1: '_client',
        param2: '_active'
      }
    },
    getTerminatedByClient: {
      method: 'GET',
      params: {
        param1: '_client',
        param2: '_terminated'
      }
    },
    createWizard: {
      method: 'POST',
      params: {
        verb: '_save'
      }
    },
    updateWizard: {
      method: 'PUT'
    },
    deleteWizard: {
      method: 'DELETE',
      params: {
        id: '@id'
      }
    },
    stepForward: {
      method: 'PUT',
      params: {
        id: '@id',
        param1: '_step',
        param2: 'approved'
      }
    },
    stepBack: {
      method: 'PUT',
      params: {
        id: '@id',
        param1: '_step',
        param2: 'back'
      }
    },
    getStep: {
      method: 'GET',
      params: {
        param1: '_step'
      }
    },
    getUsedPlafond: {
      method: 'GET',
      params: {
        verb: '_plafond'
      }
    },
    adminDeleteInvalidActsRef: {
      method: 'GET',
      params: {
        verb: '_admin',
        param1: '_deleteInvalidActsRef'
      }
    },
    getDaysRefreshed: {
      method: 'POST',
      params: {
        param1: '_days'
      }
    }
  });
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.additionalActsFactory
 * @description
 * # additionalActsFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.consip').factory('additionalActsFactory', ["CONSIP_URL", "$resource", function (CONSIP_URL, $resource) {
  return $resource(CONSIP_URL + '/api/acquisitionwizard/additionalacts/:verb/:id/:param1/:param2/:param3', {}, {
    getActById: {
      method: 'GET'
    },
    getActByUUID: {
      method: 'GET',
      params: {
        verb: '_uuid',
        param1: '_current'
      }
    },
    getActsList: {
      method: 'GET'
    },
    getActsListFiltered: {
      method: 'POST',
      params: {
        verb: '_search'
      }
    },
    getBySourceUUID: {
      method: 'GET',
      params: {
        param1: '_source'
      }
    },
    getByClient: {
      method: 'GET',
      params: {
        param1: '_client',
        param2: '_active'
      }
    },
    createAct: {
      method: 'POST',
      params: {
        verb: '_save',
        param1: '@param1'
      }
    },
    updateAct: {
      method: 'PUT'
    },
    deleteAct: {
      method: 'DELETE',
      params: {
        id: '@id'
      }
    },
    stepForward: {
      method: 'PUT',
      params: {
        id: '@id',
        param1: '_step',
        param2: 'approved'
      }
    },
    stepBack: {
      method: 'PUT',
      params: {
        id: '@id',
        param1: '_step',
        param2: 'back'
      }
    },
    getStep: {
      method: 'GET',
      params: {
        param1: '_step'
      }
    },
    adminDeleteOrphanActs: {
      method: 'GET',
      params: {
        verb: '_admin',
        param1: '_deleteOrphanActs'
      }
    },
    getAttributes: {
      method: 'POST',
      params: {
        verb: '_attribute'
      }
    },
    getDaysRefreshed: {
      method: 'POST',
      params: {
        param1: '_days'
      }
    }
  });
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.contractFactory
 * @description
 * # contractFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.consip').factory('contractFactory', ["CONSIP_URL", "$resource", function (CONSIP_URL, $resource) {
  return function () {
    return $resource(CONSIP_URL + '/api/contract/:type/:verb/:id/:param1/:param2/:param3', {}, {
      createSchema: {
        method: 'POST',
        params: {
          type: 'schema'
        }
      },
      updateSchema: {
        method: 'PUT',
        params: {
          type: 'schema',
          id: '@id'
        }
      },
      deleteSchema: {
        method: 'DELETE',
        params: {
          type: 'schema',
          id: '@id'
        }
      },
      schemaByCommission: {
        method: 'GET',
        isArray: false,
        params: {
          type: 'schema',
          verb: '_commission'
        }
      },
      recordByUUID: {
        method: 'GET',
        isArray: false,
        params: {
          type: 'record',
          verb: '_uuid',
          id: '@version',
          param1: '_current'
        }
      },
      recordByID: {
        method: 'GET',
        isArray: false,
        params: {
          type: 'record',
          verb: '_id',
          id: '@version'
        }
      },
      recordByCommission: {
        method: 'GET',
        isArray: false,
        params: {
          type: 'record',
          verb: '_commission'
        }
      },
      recordByCode: {
        method: 'GET',
        isArray: false,
        params: {
          type: 'record',
          verb: '_code',
          id: '@version'
        }
      },
      createRecord: {
        method: 'POST',
        params: {
          type: 'record'
        }
      },
      updateRecord: {
        method: 'PUT',
        params: {
          type: 'record',
          id: '@id'
        }
      },
      deleteRecord: {
        method: 'DELETE',
        params: {
          type: 'record',
          id: '@id'
        }
      },
      getAvailablePlafond: {
        method: 'GET',
        isArray: false,
        params: {
          type: 'record',
          verb: '_plafond'
        }
      }
    });
  };
}]);
// Default:
// {
//   'get':    {method:'GET'},
//   'save':   {method:'POST'},
//   'query':  {method:'GET', isArray:true},
//   'remove': {method:'DELETE'},
//   'delete': {method:'DELETE'}
// }
"use strict";

angular.module('emma.consip').factory('istatFactory', ["CONSIP_URL", "$resource", function (CONSIP_URL, $resource) {
  return $resource(CONSIP_URL + '/api/istat/:verb/:id', {}, {
    search: {
      method: 'POST',
      isArray: false,
      params: {
        verb: '_search'
      }
    },
    save: {
      method: 'POST',
      isArray: false,
      params: {
        verb: '_save'
      }
    },
    update: {
      method: 'PUT',
      isArray: false,
      params: {
        id: '@id'
      }
    },
    getLastAppliedIstatDate: {
      method: 'POST',
      isArray: false,
      params: {
        verb: 'last'
      }
    },
    updateIstat: {
      method: 'PUT',
      isArray: false,
      params: {
        verb: 'updateistat'
      }
    }
  });
}]);
"use strict";

// ordine CONSIP!!!

angular.module('emma.consip').factory('orderRowFactory', ["CONSIP_URL", "$resource", function (CONSIP_URL, $resource) {
  return $resource(CONSIP_URL + '/api/order/row/:verb/:id/:param', {}, {
    search: {
      method: 'POST',
      isArray: false,
      params: {
        verb: '_search'
      }
    },
    bulkSave: {
      method: 'POST',
      isArray: false,
      params: {
        verb: '_bulk'
      }
    },
    bulkDelete: {
      method: 'POST',
      isArray: false,
      params: {
        verb: '_delete'
      }
    },
    applyIstat: {
      method: 'POST',
      isArray: false,
      params: {
        verb: '_applyistat'
      }
    },
    getByUUID: {
      method: 'GET',
      params: {
        verb: '_uuid',
        param: '_current'
      }
    }
  });
}]);
'use strict';

angular.module('emma.consip').factory('plafondFactory', ["CONSIP_URL", "$resource", function (CONSIP_URL, $resource) {
  return $resource(CONSIP_URL + '/api/plafond/:entity/:verb', {}, {
    report: {
      method: 'GET',
      isArray: false,
      params: {
        verb: 'report'
      }
    },
    commissionReport: {
      method: 'GET',
      isArray: false,
      params: {
        entity: 'commission',
        verb: 'report'
      }
    },
    getPlafonds: {
      method: 'POST',
      isArray: false,
      params: {
        verb: 'bulk'
      }
    },
    getPlafond: {
      method: 'POST',
      isArray: false
    }
  });
}]);
"use strict";

// listino CONSIP!!!

angular.module('emma.consip').factory('pricelistRowFactory', ["CONSIP_URL", "$resource", function (CONSIP_URL, $resource) {
  return $resource(CONSIP_URL + '/api/pricelist/row/:verb/:id/:param1/:param2/:param3', {}, {
    search: {
      method: 'POST',
      isArray: false,
      params: {
        verb: '_search'
      }
    },
    enriched: {
      method: 'POST',
      isArray: false,
      params: {
        verb: '_enrich'
      }
    },
    "delete": {
      method: 'POST',
      isArray: false,
      params: {
        verb: '_delete'
      }
    },
    bulkSave: {
      method: 'POST',
      isArray: false,
      params: {
        verb: '_bulk'
      }
    }
  });
}]);
"use strict";

angular.module('emma.consip').factory('salAttachmentsFactory', ["CONSIP_URL", "$resource", function (CONSIP_URL, $resource) {
  return $resource(CONSIP_URL + '/api/sal/attachments/:verb/:id', {}, {
    search: {
      method: 'POST',
      isArray: false,
      params: {
        verb: '_search',
        id: '@id'
      }
    }
  });
}]);
"use strict";

// ordine CONSIP!!!

angular.module('emma.consip').factory('salConfigurationFactory', ["CONSIP_URL", "$resource", function (CONSIP_URL, $resource) {
  return $resource(CONSIP_URL + '/api/sal/configuration/:verb/:id/:param1/:param2/:param3', {}, {
    create: {
      method: 'POST'
    },
    unique: {
      method: 'GET',
      isArray: false,
      params: {
        verb: '_unique'
      }
    },
    update: {
      method: 'PUT',
      isArray: false,
      params: {
        id: '@id'
      }
    },
    search: {
      method: 'POST',
      isArray: false,
      params: {
        verb: '_search'
      }
    },
    "delete": {
      method: 'DELETE',
      isArray: false,
      params: {
        id: '@id'
      }
    },
    bulkDelete: {
      method: 'POST',
      isArray: false,
      params: {
        verb: '_delete'
      }
    },
    getByUUID: {
      method: 'GET',
      isArray: false,
      params: {
        verb: '_uuid',
        id: '@id'
      }
    },
    fetchall: {
      method: 'POST',
      isArray: false,
      params: {
        verb: '_fetchall'
      }
    }
  });
}]);
"use strict";

// ordine CONSIP!!!

angular.module('emma.consip').factory('salFactory', ["CONSIP_URL", "$resource", function (CONSIP_URL, $resource) {
  return $resource(CONSIP_URL + '/api/sal/:verb/:id/:param1/:param2', {}, {
    search: {
      method: 'POST',
      isArray: false,
      params: {
        verb: '_search'
      }
    },
    generate: {
      method: 'POST',
      isArray: false,
      params: {
        verb: '_generate'
      }
    },
    save: {
      method: 'POST',
      isArray: false,
      params: {
        verb: '_save'
      }
    },
    setStatus: {
      method: 'POST',
      isArray: false,
      params: {
        verb: '_setstatus'
      }
    },
    bulkSetStatus: {
      method: 'POST',
      isArray: false,
      params: {
        verb: '_setstatus',
        param1: '_bulk'
      }
    },
    unique: {
      method: 'GET',
      isArray: false,
      params: {
        verb: '_unique',
        entity: 'salheader'
      }
    },
    head: {
      method: 'GET',
      isArray: false,
      params: {
        verb: '_head'
      }
    },
    getByUUID: {
      method: 'GET',
      params: {
        verb: '_uuid',
        param1: '_current'
      }
    },
    taskList: {
      method: 'POST',
      params: {
        verb: 'task',
        param1: 'list'
      }
    },
    automaticGeneration: {
      method: 'POST',
      isArray: false,
      params: {
        verb: '_generate',
        id: '@commission'
      }
    },
    automaticStatus: {
      method: 'POST',
      isArray: false,
      params: {
        verb: '_status',
        id: '@commission'
      }
    }
  });
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:OrderCtrl
 * @description
 * # OrderCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.consip').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/order/detail/:id', {
    templateUrl: 'consip/order/order_detail.html',
    controller: 'OrderCtrl'
  });
}]).controller('OrderCtrl', ["$scope", "$location", "$routeParams", "acquisitionWizardFactory", "dialogService", "$log", "uiGridConstants", "orderRowFactory", "ngDialog", "$rootScope", "authFactory", "sixGridPaginationConstants", "istatFactory", "toaster", function ($scope, $location, $routeParams, acquisitionWizardFactory, dialogService, $log, uiGridConstants, orderRowFactory, ngDialog, $rootScope, authFactory, sixGridPaginationConstants, istatFactory, toaster) {
  var currentCustomer = authFactory.getCurrentCustomer();
  var minAllowedIstatAdjustmentDate = null;
  $scope.params = {
    pageNumber: 1,
    pageSize: 100,
    totalItems: 0,
    filters: {}
  };
  $scope.appliedIstats = undefined;
  $scope.orderRows = {
    list: [],
    totalResults: 0
  };
  $scope.autoResizeParams = {
    enabled: true,
    minHeight: 200,
    marginTop: 260,
    filterRows: 2
  };
  $scope.viewGridOptions = {
    enableFiltering: true,
    enableOrdering: true,
    columnDefs: [{
      name: ' '
    }]
  };
  function initGridColumns() {
    $scope.viewGridOptions.columnDefs = [];
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Codice',
      field: 'model.code',
      width: 100,
      enableFiltering: true,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Cod. Edificio',
      field: 'model.edificio_id.code',
      enableFiltering: true,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Edificio',
      field: 'model.edificio_id.description',
      enableFiltering: true,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Cod. Servizio',
      field: 'model.servizio_id.code',
      enableFiltering: true,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Descr. Servizio',
      field: 'model.servizio_id.description',
      enableFiltering: true,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Tipo Servizio',
      field: 'model.tipo_servizio',
      enableFiltering: true,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Cod. Classe',
      field: 'model.classeservizio_id.code',
      enableFiltering: true,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Descr. Classe',
      field: 'model.classeservizio_id.description',
      enableFiltering: true,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'UM',
      field: 'model.um_id.description',
      enableFiltering: true,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Importo annuo',
      field: 'model.importo_annuo',
      enableFiltering: true,
      cellClass: 'cont-right',
      cellFilter: 'currency:"€":2',
      filters: [{
        type: sixGridPaginationConstants.filterType.NUMBER,
        relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
        placeholder: 'da...',
        condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
      }, {
        type: sixGridPaginationConstants.filterType.NUMBER,
        relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
        placeholder: 'a...',
        condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Importo totale',
      field: 'model.importo_totale',
      enableFiltering: true,
      cellClass: 'cont-right',
      cellFilter: 'currency:"€":2',
      filters: [{
        type: sixGridPaginationConstants.filterType.NUMBER,
        relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
        placeholder: 'da...',
        condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
      }, {
        type: sixGridPaginationConstants.filterType.NUMBER,
        relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
        placeholder: 'a...',
        condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'PU',
      field: 'model.pu',
      enableFiltering: true,
      cellClass: 'cont-right',
      cellFilter: 'currency:"€":4',
      filters: [{
        type: sixGridPaginationConstants.filterType.NUMBER,
        relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
        placeholder: 'da...',
        condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
      }, {
        type: sixGridPaginationConstants.filterType.NUMBER,
        relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
        placeholder: 'a...',
        condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Quantità/Anno',
      field: 'model.qta',
      enableFiltering: true,
      filters: [{
        type: sixGridPaginationConstants.filterType.NUMBER,
        relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
        placeholder: 'da...',
        condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
      }, {
        type: sixGridPaginationConstants.filterType.NUMBER,
        relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
        placeholder: 'a...',
        condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Data inizio validità',
      field: 'model.data_inizio',
      enableFiltering: true,
      cellClass: 'cont-center',
      cellFilter: 'date:"dd/MM/yyyy"',
      filters: [{
        type: sixGridPaginationConstants.filterType.DATE,
        relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
        placeholder: 'da...',
        condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
      }, {
        type: sixGridPaginationConstants.filterType.DATE,
        relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
        placeholder: 'a...',
        condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Data fine validità',
      field: 'model.data_fine',
      enableFiltering: true,
      cellClass: 'cont-center',
      cellFilter: 'date:"dd/MM/yyyy"',
      filters: [{
        type: sixGridPaginationConstants.filterType.DATE,
        relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
        placeholder: 'da...',
        condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
      }, {
        type: sixGridPaginationConstants.filterType.DATE,
        relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
        placeholder: 'a...',
        condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Adeg. ISTAT',
      field: 'model.istat_alteration',
      enableFiltering: true,
      cellFilter: 'currency:"%":1',
      filters: [{
        type: sixGridPaginationConstants.filterType.NUMBER,
        relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
        placeholder: 'da...',
        condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
      }, {
        type: sixGridPaginationConstants.filterType.NUMBER,
        relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
        placeholder: 'a...',
        condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Tipo Rif.',
      field: 'model.tipo_riga',
      enableFiltering: true,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
  }
  function getAppliedIstat() {
    var filter = {
      customer: sixFiltersLib.exact('customer', $scope.wizard.model.client_id.UUID)
    };
    istatFactory.search({
      page_size: 10
    }, filter).$promise.then(function (resp) {
      if (resp.list && resp.list.length) {
        resp.list.forEach(function (item, index) {
          readAttachments(item.model.attachments, index);
        });
        $scope.appliedIstats = resp.list;
      }
    });
  }
  function setMinAllowedAdjustmentDate() {
    istatFactory.getLastAppliedIstatDate({}, [$scope.wizard.model.client_id.UUID]).$promise.then(function (response) {
      if (response.result[$scope.wizard.model.client_id.UUID]) minAllowedIstatAdjustmentDate = response.result[$scope.wizard.model.client_id.UUID].model.adjustment_date;
    });
  }
  $scope.toDateString = function (date) {
    return new Date(date).toLocaleDateString();
  };
  $scope.backToList = function () {
    $location.path('order');
  };
  $scope.getOrder = function () {
    getAppliedIstat();
    setMinAllowedAdjustmentDate();
    var payload = {
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      show_revision: false,
      query: $scope.params.queryParam,
      sort_fields: $scope.params.sortFields
    };
    $scope.params.filters['acquisition_uuid'] = $scope.wizard.UUID;
    //$scope.params.filters['customer'] = $scope.wizard.model.client_id.UUID;
    return orderRowFactory.search(payload, $scope.params.filters).$promise.then(function (data) {
      $scope.orderRows.totalResults = data.totalResults;
      $scope.orderRows.list = data.list;
      if (!$scope.orderRows.list || $scope.orderRows.list.length == 0) {
        if (currentCustomer) {
          dialogService.dialog('ATTENZIONE', 'Nessun ordine per il cliente ' + currentCustomer.description, 'warning', -1); //, discreet, bodyTextAlign);
        } else {
          dialogService.dialog('ATTENZIONE', 'Nessun ordine per il cliente selezionato', 'warning', -1); //, discreet, bodyTextAlign);
        }
      }

      $scope.params.sixApi.refreshList(data.list);
      return data;
    });
  };
  $scope.bulkDelete = function () {
    dialogService.confirmDialog('Eliminare l\'ordine?', function () {
      var payload = {
        show_revision: true
      };
      $scope.params.filters['acquisition_uuid'] = $scope.wizard.UUID;
      $scope.params.filters['customer'] = $scope.wizard.model.client_id.UUID;
      orderRowFactory.bulkDelete(payload, $scope.params.filters).$promise.then(function (data) {
        $scope.getOrder();
      });
    });
  };
  $scope.applyIstat = function (date, percentage) {
    if (percentage != undefined && date) {
      var istatConfig = {
        date: date,
        percentage: percentage,
        acquisitionsUUID: [$scope.wizard.UUID]
      };
      if ($scope.wizard.UUID) {
        orderRowFactory.applyIstat({}, istatConfig).$promise.then(function (resp) {
          if (resp.rows.length) toaster.pop("success", "Adeguamento completato", "Adeguate " + resp.rows.length + " righe d'ordine");else toaster.pop("warn", "", "Nessuna riga d'ordine aggiornata, controllare che la data inserita per l'adeguamento ISTAT " + "sia inferiore alla data fine validità degli ordini processati");
          $scope.getOrder();
          $log.log(resp);
        })["catch"](function (error) {
          toaster.pop("error", "Errore", error.message);
        });
      } else {
        toaster.pop("error", "Errore", "Impossibile recuperare l'UUID dell'acquisizione");
      }
    }
  };
  $scope.dateOptions = {
    formatYear: 'yyyy',
    minDate: new Date(),
    opened: false
  };
  $scope.showIstatDialog = function () {
    var dialogScope = $rootScope.$new();
    dialogScope.dateOptions = {
      opened: false
    };
    if (minAllowedIstatAdjustmentDate) {
      var minPlusDay = new Date(new Date(minAllowedIstatAdjustmentDate).setDate(new Date(minAllowedIstatAdjustmentDate).getDate() + 1));
      minPlusDay = new Date(minPlusDay.setHours(0, 0, 0, 0, 0));
      dialogScope.minDate = minPlusDay.toISOString();
      dialogScope.dateOptions.minDate = minPlusDay;
    }
    dialogScope.fn = $scope.applyIstat;
    dialogScope.datePicker = {
      from: new Date()
    };
    ngDialog.open({
      name: 'loadingDialog',
      closeByDocument: true,
      showClose: true,
      template: 'consip/order/istat_dialog.html',
      className: 'ngdialog-theme-default',
      width: '60%',
      scope: dialogScope
    });
  };

  // ***** ALLEGATI ***** //

  $scope.attachments = [];
  function readAttachments(documentAttachments, index) {
    if (documentAttachments && documentAttachments.length > 0) {
      if (!$scope.attachments[index]) {
        $scope.attachments[index] = [];
      }
      documentAttachments.forEach(function (attachment) {
        $scope.attachments[index].push(attachment);
      });
    }
  }
  $scope.updateAttachments = function (document, index) {
    if ($scope.appliedIstats && document.model) {
      document.model.attachments = $scope.attachments[index];
      istatFactory.updateIstat(document);
    }
  };

  // ***** EXPORT ***** //

  var currentContract = authFactory.getAuthData().info.commissions.current;
  $scope["export"] = function () {
    sixExportLib.exportXLSXVisibleRowsGrid($scope.params.gridApi, currentContract.code + '_order_' + $scope.wizard.model.client_id.code);
  };

  //___main__
  if (!angular.isDefined($routeParams.id)) {
    $scope.backToList();
  } else {
    acquisitionWizardFactory.getWizardByUUID({
      id: $routeParams.id
    }).$promise.then(function (data) {
      if (angular.isDefined(data.model)) {
        $scope.wizard = data;
        initGridColumns();
      } else {
        $scope.backToList();
      }
    })["catch"](function (err) {
      $scope.backToList();
    });
  }
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:AcquisitionWizardListCtrl
 * @description
 * # AcquisitionWizardListCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.consip').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/order', {
    templateUrl: 'consip/order/order_list.html',
    controller: 'OrderListCtrl'
  });
}]).controller('OrderListCtrl', ["$scope", "$log", "acquisitionWizardFactory", "orderRowFactory", "$location", "authFactory", "dialogService", "ngDialog", "uiGridConstants", "sixGridPaginationConstants", "contractFactory", "istatFactory", "toaster", function ($scope, $log, acquisitionWizardFactory, orderRowFactory, $location, authFactory, dialogService, ngDialog, uiGridConstants, sixGridPaginationConstants, contractFactory, istatFactory, toaster) {
  var currentCustomer = authFactory.getCurrentCustomer();
  var istat_config;
  $scope.params = {
    queryParam: '',
    filters: {}
  };
  $scope.viewGridOptions = {
    multiSelect: true,
    enableRowSelection: true,
    enableRowHeaderSelection: true,
    columnDefs: [{
      displayName: '',
      field: 'id',
      width: 36,
      enableHiding: false,
      enableColumnMenu: false,
      enableFiltering: false,
      enableSorting: false,
      cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/order/detail/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' + '<span class="fa fa-search"></span>' + '</a>' + '</div>'
    }, {
      displayName: 'Codice',
      field: 'model.code',
      width: 150,
      filters: [{
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }, {
      displayName: 'Descrizione',
      field: 'model.description',
      filters: [{
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }, {
      displayName: 'Inizio Adesione',
      field: 'model.start_contract_date',
      type: 'date',
      cellFilter: 'date:\'dd/MM/yyyy\'',
      enableFiltering: true,
      filters: [{
        type: sixGridPaginationConstants.filterType.DATE,
        relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
        placeholder: 'da...',
        condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
      }, {
        type: sixGridPaginationConstants.filterType.DATE,
        relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
        placeholder: 'a...',
        condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
      }]
    }, {
      displayName: 'Prossimo Adeguamento Istat',
      field: 'model.start_contract_date',
      type: 'date',
      cellFilter: 'date:\'dd/MM/yyyy\'',
      enableFiltering: true,
      cellTemplate: '<div> <six-consip-timing-led sx-value="grid.appScope.$parent.getStoplightValue(row.entity.last_adjustment)" ></six-consip-timing-led>  {{grid.appScope.$parent.getNextIstatAdj(row.entity.last_adjustment, true)}}</div>'
    }]
  };
  $scope.getNextIstatAdj = function (date, toString) {
    if (date) {
      var adjustmentType = istat_config.type;
      switch (adjustmentType) {
        case "single_date":
          return toString ? adjustSingleDate(date, istat_config.month).toLocaleDateString() : adjustSingleDate(date, istat_config.month);
        case "min_adhesion":
          return toString ? adjustMinAdhesion(date, istat_config.month, istat_config.recurrency).toLocaleDateString() : adjustMinAdhesion(date, istat_config.month, istat_config.recurrency);
        case "month_adhesion":
          return toString ? adjustMonthAdhesion(date, istat_config.recurrency).toLocaleDateString() : adjustMonthAdhesion(date, istat_config.recurrency);
      }
    }
  };
  $scope.getStoplightValue = function (date) {
    if (date) {
      var nextAdjustment = $scope.getNextIstatAdj(date);
      var oneDay = 24 * 60 * 60 * 1000;
      var remainingDays = Math.round((nextAdjustment.getTime() - new Date().getTime()) / oneDay);
      var adjustmentWarnDate = Math.round((nextAdjustment.getTime() - new Date(date).getTime()) / oneDay * 0.10);
      if (remainingDays - adjustmentWarnDate < 0) {
        return 3; //red
      } else if (remainingDays - adjustmentWarnDate < adjustmentWarnDate) {
        return 2; //yellow
      } else {
        return 1; //green
      }
    }
  };

  function adjustSingleDate(date, month) {
    var acquisitionStart = new Date(date);
    return date && month != undefined ? new Date(acquisitionStart.setFullYear(acquisitionStart.getFullYear() + 1, month, 1)) : '';
  }
  function adjustMinAdhesion(date, month, recurrency) {
    if (date) {
      var acquisitionStart = new Date(date);
      var nextAdjustment = new Date(acquisitionStart.setFullYear(acquisitionStart.getFullYear() + 1, month, 1));
      for (var i = 0; i < recurrency; i++) {
        nextAdjustment = new Date(nextAdjustment.setMonth(nextAdjustment.getMonth() + 1));
      }
      return nextAdjustment;
    } else {
      return '';
    }
  }
  function adjustMonthAdhesion(date, recurrency) {
    if (date) {
      var nextAdjustment = new Date(date);
      for (var i = 0; i < recurrency; i++) {
        nextAdjustment = new Date(nextAdjustment.setMonth(nextAdjustment.getMonth() + 1, 1));
      }
      return nextAdjustment;
    } else {
      return '';
    }
  }
  $scope.crossCustomer = function () {
    return angular.isUndefined(currentCustomer);
  };
  $scope.showIstatDialog = function () {
    var dialogScope = $scope.$new();
    var minDate = getAdjustmentMinDateForSelected();
    dialogScope.dateOptions = {
      opened: false
    };
    if (minDate) {
      var minPlusDay = new Date(new Date(minDate).setDate(new Date(minDate).getDate() + 1));
      dialogScope.minDate = minPlusDay.toISOString();
      dialogScope.dateOptions.minDate = minPlusDay;
    }
    dialogScope.fn = $scope.applyIstat;
    dialogScope.datePicker = {
      from: new Date()
    };
    ngDialog.open({
      name: 'loadingDialog',
      closeByDocument: true,
      showClose: true,
      template: 'consip/order/istat_dialog.html',
      className: 'ngdialog-theme-default',
      width: '60%',
      scope: dialogScope
    });
  };
  $scope.applyIstat = function (date, percentage) {
    if (percentage != undefined && date) {
      var uuidList = getSelectedAcquisitionsUuid();
      if (uuidList.length) {
        var istatConfig = {
          date: date,
          percentage: percentage,
          acquisitionsUUID: uuidList
        };
        orderRowFactory.applyIstat({}, istatConfig).$promise.then(function (resp) {
          if (resp.rows.length) toaster.pop("success", "Adeguamento completato", "Adeguate " + resp.rows.length + " righe d'ordine");else toaster.pop("warn", "", "Nessuna riga d'ordine aggiornata, controllare che la data inserita per l'adeguamento ISTAT " + "sia inferiore alla data fine validità degli ordini processati");
          $log.log(resp);
        });
      } else {
        toaster.pop("error", "Errore", "Selezionare le acquisizioni su cui applicare l'adeguamento");
      }
    }
  };
  function getAdjustmentMinDateForSelected() {
    var rows = $scope.params.gridApi.selection.getSelectedGridRows();
    var date = null;
    if (rows.length) {
      rows.forEach(function (row) {
        if (!date) {
          date = row.entity.last_adjustment;
        } else if (row.entity.last_adjustment) {
          if (new Date(row.entity.last_adjustment).getTime() > new Date(date).getTime()) {
            date = row.entity.last_adjustment;
          }
        }
      });
    }
    return date;
  }
  function getSelectedAcquisitionsUuid() {
    return $scope.params.gridApi.selection.getSelectedGridRows().reduce(function (prev, current) {
      prev.push(current.entity.UUID);
      return prev;
    }, []);
  }
  var DEFAULT_SORT_FIELD = 'model.code';
  function defaultSort() {
    var result = $scope.sortFields ? $scope.sortFields : DEFAULT_SORT_FIELD;
    return result;
  }
  var DEFAULT_SORT_ORDER = 'asc';
  function defaultSortOrder() {
    var result = $scope.sortOrder ? $scope.sortOrder : DEFAULT_SORT_ORDER;
    return result;
  }
  $scope.getData = function () {
    var payload = {
      query: $scope.params.queryParam,
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      sort_fields: defaultSort() + ':' + defaultSortOrder(),
      show_revision: false
    };
    var filters = angular.copy($scope.params.filters);
    filters['model.current_step.status'] = sixFiltersLib.exact('model.current_step.status', 'terminated');
    return acquisitionWizardFactory.getWizardsListFiltered(payload, filters).$promise.then(function (data) {
      return getLastIstatAdjustment(data);
    });
  };
  function getLastIstatAdjustment(response) {
    var customers = response.list.reduce(function (cumulated, current) {
      if (current.customer) return cumulated.concat(current.customer);else return cumulated;
    }, []);
    return istatFactory.getLastAppliedIstatDate({}, customers).$promise.then(function (data) {
      response.list.map(function (acq) {
        if (data.result[acq.customer[0]]) acq.last_adjustment = data.result[acq.customer[0]].model.adjustment_date;
      });
      return response;
    });
  }
  function redirectToCustomerOrder() {
    var payload = {
      page_size: 1,
      show_revision: false
    };
    var filters = {
      'model.current_step.status': sixFiltersLib.exact('model.current_step.status', 'terminated')
    };
    acquisitionWizardFactory.getWizardsListFiltered(payload, filters).$promise.then(function (data) {
      if (data && data.list && data.list.length > 0) {
        $location.path('order/detail/' + data.list[0].UUID);
      } else {
        dialogService.dialog('ATTENZIONE', 'Nessun ordine per il cliente ' + currentCustomer.description, 'warning', -1); //, discreet, bodyTextAlign);
      }
    });
  }

  function getIstatConfig() {
    contractFactory().recordByCommission().$promise.then(function (resp) {
      istat_config = resp.model.istat_config;
    });
  }

  //__main__
  if (!$scope.crossCustomer()) {
    // visualizzo la lista degli ordini
    redirectToCustomerOrder(); // vado diretto sull'ordine del cliente
  } else {
    getIstatConfig();
  }
}]);
'use strict';

angular.module('emma.consip').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/plafond', {
    templateUrl: 'consip/plafond/report.html',
    controller: 'PlafondReportCtrl'
  });
}]).controller('PlafondReportCtrl', ["$scope", "toaster", "authFactory", "plafondFactory", "uiGridConstants", function ($scope, toaster, authFactory, plafondFactory, uiGridConstants) {
  $scope.gridOptions = {
    enableSorting: true,
    enableFiltering: true,
    enableGridMenu: true,
    exporterMenuPdf: false,
    paginationPageSizes: [10, 20, 50],
    paginationPageSize: 20,
    data: [],
    gridMenuCustomItems: [{
      title: 'Esporta in XLS',
      icon: 'fa fa-file-excel-o',
      action: function action($event) {
        sixExportLib.exportXLSXAllRowsGrid(this.grid.api, 'export');
      },
      order: 210
    }, {
      title: 'Esporta solo dati visibili in XLS',
      icon: 'fa fa-file-excel-o',
      action: function action($event) {
        sixExportLib.exportXLSXVisibleRowsGrid(this.grid.api, 'export');
      },
      order: 211
    }],
    columnDefs: [{
      displayName: 'Codice servizio',
      field: 'service.code'
    }, {
      displayName: 'Descrizione servizio',
      field: 'service.description'
    }, {
      displayName: 'Tipo servizio',
      field: 'service_type',
      filters: [{
        type: uiGridConstants.filter.SELECT,
        condition: uiGridConstants.filter.STARTS_WITH,
        selectOptions: [{
          value: 'canone',
          label: 'Canone'
        }, {
          value: 'extra',
          label: 'Extra canone'
        }]
      }]
    }, {
      displayName: 'Codice edificio',
      field: 'building.code'
    }, {
      displayName: 'Descrizione edificio',
      field: 'building.description'
    }, {
      displayName: 'Plafond',
      field: 'plafond',
      cellClass: 'cont-right',
      cellFilter: 'currency:"€":2',
      filters: [{
        condition: uiGridConstants.filter.GREATER_THAN,
        placeholder: 'più di ...'
      }, {
        condition: uiGridConstants.filter.LESS_THAN,
        placeholder: 'meno di ...'
      }]
    }, {
      displayName: 'Plafond erogato',
      field: 'used',
      cellClass: 'cont-right',
      cellFilter: 'currency:"€":2',
      filters: [{
        condition: uiGridConstants.filter.GREATER_THAN,
        placeholder: 'più di ...'
      }, {
        condition: uiGridConstants.filter.LESS_THAN,
        placeholder: 'meno di ...'
      }]
    }, {
      displayName: 'Plafond impegnato',
      field: 'constrain',
      cellClass: 'cont-right',
      cellFilter: 'currency:"€":2',
      filters: [{
        condition: uiGridConstants.filter.GREATER_THAN,
        placeholder: 'più di ...'
      }, {
        condition: uiGridConstants.filter.LESS_THAN,
        placeholder: 'meno di ...'
      }]
    }, {
      displayName: 'Plafond residuo',
      field: 'residual',
      cellClass: 'cont-right',
      cellFilter: 'currency:"€":2',
      filters: [{
        condition: uiGridConstants.filter.GREATER_THAN,
        placeholder: 'più di ...'
      }, {
        condition: uiGridConstants.filter.LESS_THAN,
        placeholder: 'meno di ...'
      }]
    }]
  };
  $scope.getReport = function () {
    plafondFactory.report().$promise.then(function (data) {
      $scope.gridOptions.data = data.result.map(function (d) {
        d.residual = (d.plafond || 0) - (d.used || 0);
        return d;
      });
    }, function (error) {
      toaster.pop('error', 'Errore', 'Errore durante il recupero dei dati');
    });
  };
  $scope.currentCustomer = authFactory.getCurrentCustomer();
  if ($scope.currentCustomer) {
    $scope.getReport();
  }
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:OrderCtrl
 * @description
 * # OrderCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.consip').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/consippricelist/detail', {
    templateUrl: 'consip/pricelists/pricelist_detail.html',
    controller: 'ConsipPricelistCtrl'
  });
}]).controller('ConsipPricelistCtrl', ["$scope", "$location", "$routeParams", "errorService", "dialogService", "toaster", "$log", "$route", "uiGridConstants", "pricelistRowFactory", "authFactory", "recordFactory", "loadingBarService", function ($scope, $location, $routeParams, errorService, dialogService, toaster, $log, $route, uiGridConstants, pricelistRowFactory, authFactory, recordFactory, loadingBarService) {
  var currentContract = authFactory.getAuthData().info.commissions.current;
  $scope.isAlreadyPresent = false;
  $scope.params = {
    queryParam: '',
    filterQuery: {}
  };
  $scope.pricelistRows = {};
  $scope.viewGridOptions = {
    enableSorting: true,
    enableFiltering: true,
    paginationPageSizes: [10, 20, 50, 100, 250, 500, 1000],
    paginationPageSize: 20,
    data: [],
    onRegisterApi: function onRegisterApi(gridApi) {
      $scope.gridApi = gridApi;
    },
    columnDefs: [{
      name: ' '
    }]
  };
  function initGridColumns() {
    $scope.viewGridOptions.columnDefs = [];
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Codice',
      field: 'model.service_id.code',
      width: 100,
      enableFiltering: true,
      filters: [{
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Servizio',
      field: 'model.service_id.description',
      enableFiltering: true,
      filters: [{
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Cod. classe',
      field: 'model.classeservizio_id.code',
      width: 100,
      enableFiltering: true,
      filters: [{
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Descrizione classe',
      field: 'model.classeservizio_id.description',
      enableFiltering: true,
      filters: [{
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Valore',
      field: 'model.value',
      width: 100,
      cellFilter: 'number:4',
      enableFiltering: true,
      filters: [{
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Unità di misura',
      field: 'model.um_id.description',
      width: 200,
      enableFiltering: true,
      filters: [{
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
  }
  $scope.backToList = function () {
    $location.path('consippricelist');
  };
  $scope.getPricelist = function () {
    $scope.viewGridOptions.data = [];
    var payload = {
      page: 1,
      page_size: 10000,
      show_revision: false
    };
    $scope.params.filterQuery['contract'] = currentContract; // = commission
    return pricelistRowFactory.enriched(payload, $scope.params.filterQuery).$promise.then(function (data) {
      if (data.hasErrors || data.hasWarnings) {
        dialogService.serviceResponse('Esito', data, false);
      }
      if (data.result.totalResults > 0) {
        $scope.viewGridOptions.data = data.result.list;
        $scope.isAlreadyPresent = true;
      } else {
        $scope.viewGridOptions.data = [];
        $scope.isAlreadyPresent = false;
      }
      return data;
    })["catch"](function (response) {
      // error
    })["finally"](function (response) {
      // finally
      loadingBarService.stop();
    });
  };
  $scope["delete"] = function () {
    var payload = {
      page: 1,
      page_size: 10000,
      show_revision: false
    };
    $scope.params.filterQuery['contract'] = currentContract; // = commission
    pricelistRowFactory["delete"](payload, $scope.params.filterQuery).$promise.then(function (data) {
      if (data.hasErrors || data.hasWarnings) {
        dialogService.serviceResponse('Esito', data, false);
      }
      $scope.getPricelist();
    })["catch"](function (response) {
      // error
    })["finally"](function (response) {
      // finally
    });
  };

  // Quando cambio la dimensione della pagina della grid ridimensiono anche la grid stessa
  $scope.$watch(function () {
    return $scope.viewGridOptions.paginationPageSize;
  }, function (newVal, oldVal) {
    if (newVal) {
      resizeGrid();
    }
  });

  // Quando ridimensiono la finestra ridimensiono anche la grid
  $(window).resize(function () {
    resizeGrid();
  });
  function resizeGrid() {
    var newHeight = $scope.viewGridOptions.paginationPageSize * 30 + 110;
    var windowHeight = $(window).height() - 250;
    windowHeight = Math.max(windowHeight, 200); // minimo 200px
    newHeight = Math.min(windowHeight, newHeight); // massima altezza: altezza visualizzabile dalla finestra alle dimensioni correnti
    angular.element(document.getElementsByClassName('grid')[0]).css('height', newHeight + 'px');
  }

  // ***** IMPORT ***** //

  var messages = [];
  $scope.importingError = false;

  //dati caricati da xls
  $scope.$watch(function () {
    return $scope.viewGridOptions.xlsData;
  }, function (newValue, oldValue) {
    if (newValue && newValue.length > 0) {
      messages = [];
      $scope.importingError = false;
      $scope.checkData();
      // ottenuti i riferimenti ai dati, rimpiazzo le vecchie colonne per visualizzare i riferimenti sottoforma di codice invece che oggetti stile lookup
      $scope.viewGridOptions.columnDefs.splice(0, 2, {
        displayName: 'Codice',
        field: 'Codice.code',
        width: 150,
        enableFiltering: true,
        filters: [{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      }, {
        displayName: 'Voce',
        field: 'Codice.description',
        enableFiltering: true,
        filters: [{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.splice(3, 1, {
        displayName: 'Unità di misura',
        field: 'Unità di misura.description',
        width: 150,
        enableFiltering: true,
        filters: [{
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
    }
  });
  $scope.checkData = function () {
    var mapToResolve = {};
    $scope.viewGridOptions.xlsData.forEach(function (row) {
      parseTypes(row);
      $scope.viewGridOptions.data = $scope.viewGridOptions.data.concat(row);
      addToMapToResolve(mapToResolve, row);
    });
    checkBulkDependencies(mapToResolve);
  };
  function parseTypes(row) {
    row['Valore'] = parseFloat(row['Valore']);
    return row;
  }
  function addToMapToResolve(mapToResolve, row) {
    var servicesMap = mapToResolve['servizio'] || {};
    servicesMap[row['Codice']] = '';
    mapToResolve['servizio'] = servicesMap;
    var umMap = mapToResolve['um'] || {};
    umMap[row['Unità di misura']] = '';
    mapToResolve['um'] = umMap;
    return mapToResolve;
  }
  function checkBulkDependencies(codeMap) {
    recordFactory('type').bulkResolve(codeMap).$promise.then(function (result) {
      updateDataCheckStatus(result);
      if (messages.length > 0) {
        var messagesToDisplay = sixServiceMessageLib.emulateServiceResponse(messages);
        dialogService.serviceResponse('Risposta', messagesToDisplay, true);
      }
    });
  }
  function updateDataCheckStatus(codeMap) {
    $scope.viewGridOptions.data.forEach(function (row) {
      updateRowCheckStatus(row, codeMap);
    });
  }
  function updateRowCheckStatus(row, codeMap) {
    var code = row['Codice'];
    var servicesMap = codeMap['servizio'];
    var resolved = servicesMap[code];
    if (angular.isDefined(resolved) && resolved != null) {
      row['Codice'] = sixObjectLib.recordToHisRef(resolved);
      // messages.push(sixServiceMessageLib.emulateLogServiceMessage('Servizio \'' + code + '\' trovato', true, false, false));
    } else {
      messages.push(sixServiceMessageLib.emulateLogServiceMessage('Servizio \'' + code + '\' non trovato!!', false, false, true));
      $scope.importingError = true;
    }
    var um = row['Unità di misura'];
    var umMap = codeMap['um'];
    resolved = umMap[um];
    if (angular.isDefined(resolved) && resolved != null) {
      row['Unità di misura'] = sixObjectLib.recordToHisRef(resolved);
      // messages.push(sixServiceMessageLib.emulateLogServiceMessage('Unità di misura \'' + um + '\' trovata', true, false, false));
    } else {
      messages.push(sixServiceMessageLib.emulateLogServiceMessage('Unità di misura \'' + um + '\' non trovata!!', false, false, true));
      $scope.importingError = true;
    }
  }
  $scope["import"] = function () {
    if ($scope.viewGridOptions.data && $scope.viewGridOptions.data.length > 0) {
      loadingBarService.start('Importazione...');
      epurateRows($scope.viewGridOptions.data);
      pricelistRowFactory.bulkSave($scope.viewGridOptions.data).$promise.then(function (response) {
        initGridColumns();
        // dialogService.serviceResponse('Importazione', response);
        $scope.getPricelist();
      });
    }
  };
  function epurateRows(rows) {
    rows.forEach(function (r) {
      delete r['Voce'];
      r['um_id'] = r['Unità di misura'];
      delete r['Unità di misura'];
      r['service_id'] = r['Codice'];
      delete r['Codice'];
      r['value'] = r['Valore'];
      delete r['Valore'];
    });
    return rows;
  }

  // ***** EXPORT ***** //

  $scope["export"] = function () {
    sixExportLib.exportXLSXVisibleRowsGrid($scope.gridApi, 'pricelist_' + currentContract.code);
  };

  //___main__
  initGridColumns();
  $scope.getPricelist();
}]);
'use strict';

/**
 * @ngdoc function
 * @name emma.consip.controller:SalCtrl
 * @description
 * # SalCtrl
 * Controller of the emma.consip
 */
angular.module('emma.consip').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/sal/:sal_code', {
    templateUrl: 'consip/sal/sal_detail.html',
    controller: 'SalCtrl'
  });
}]).controller('SalCtrl', ["$scope", "$location", "$routeParams", "$interpolate", "$q", "dialogService", "toaster", "uiGridConstants", "contractFactory", "authFactory", "salFactory", "odlFactory", "invoiceFactory", "plafondSrv", "orderRowFactory", "salGenerationService", "notificationFactory", "userFactory", "salWorkflow", "CONTRACT_TYPES", function ($scope, $location, $routeParams, $interpolate, $q, dialogService, toaster, uiGridConstants, contractFactory, authFactory, salFactory, odlFactory, invoiceFactory, plafondSrv, orderRowFactory, salGenerationService, notificationFactory, userFactory, salWorkflow, CONTRACT_TYPES) {
  var currentContract = authFactory.getAuthData().info.commissions.current;
  var lockedStatuses;
  $scope.isLooseContract = false;
  $scope.allowedStatuses = [];
  $scope.viewGridOptions = {
    expandableRowTemplate: 'consip/sal/expandableRowTemplate.html',
    expandableRowHeight: 120,
    enableExpandableRowHeader: false,
    enableFiltering: true,
    enableCellEdit: false,
    showColumnFooter: true,
    enableGridMenu: true,
    paginationPageSizes: [25, 50, 100],
    rowEditWaitInterval: -1,
    onRegisterApi: onRegisterApi,
    rowHeight: 35,
    gridMenuCustomItems: [{
      title: 'Esporta in XLS',
      icon: 'fa fa-file-excel-o',
      action: function action($event) {
        sixExportLib.exportXLSXAllRowsGrid(this.grid.api, currentContract.code + '_SAL_' + $scope.currentCustomer.code);
      },
      order: 210
    }, {
      title: 'Esporta solo dati visibili in XLS',
      icon: 'fa fa-file-excel-o',
      action: function action($event) {
        sixExportLib.exportXLSXVisibleRowsGrid(this.grid.api, currentContract.code + '_SAL_' + $scope.currentCustomer.code);
      },
      order: 211
    }],
    columnDefs: [{
      displayName: '',
      field: 'id',
      width: 70,
      enableColumnMenu: false,
      enableFiltering: false,
      enableSorting: false,
      enableColumnResizing: false,
      enableHiding: false,
      cellTemplate: 'consip/sal/sal_detail_action_col.html'
    }, {
      displayName: 'Importo',
      field: 'model.amount',
      type: 'number',
      cellFilter: 'currency:"€":2',
      enableCellEdit: true,
      cellEditableCondition: isCellEditable,
      cellClass: function cellClass(grid, row, col) {
        return 'cont-right ' + editableCellClass(grid, row, col);
      },
      aggregationType: function aggregationType() {
        if ($scope.viewGridOptions.data.length > 0) {
          try {
            return $scope.viewGridOptions.data.map(function (row) {
              return row.model.amount;
            }).reduce(function (total, amount) {
              return total + amount;
            });
          } catch (error) {
            console.error(error);
          }
        }
        return 0;
      },
      footerCellClass: 'cont-right',
      footerCellFilter: 'currency:"€":2',
      filters: [{
        condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL,
        placeholder: 'da...'
      }, {
        relation: uiGridConstants.filter.LESS_THAN_OR_EQUAL,
        placeholder: 'a...'
      }]
    }, {
      displayName: '',
      field: 'model.order_id',
      width: 40,
      enableColumnMenu: false,
      enableFiltering: false,
      enableSorting: false,
      enableColumnResizing: false,
      enableHiding: false,
      cellTemplate: '<div class="ui-grid-cell-contents text-center">\
        <a ng-click="grid.appScope.showOrder(row.entity)" ng-if="row.entity.model.order_id" class="btn btn-rounded btn-xs btn-icon btn-primary">\
        <i class="fa fa-file-text-o"></i>\
        </a>\
        <a ng-click="grid.appScope.showOdl(row.entity)" ng-if="row.entity.model.odl_id" class="btn btn-rounded btn-xs btn-icon btn-primary">\
        <i class="fa fa-wrench"></i>\
        </a>\
        <a ng-click="grid.appScope.showInvoice(row.entity)" ng-if="row.entity.model.invoice_id" class="btn btn-rounded btn-xs btn-icon btn-primary">\
        <i class="fa fa-eur"></i>\
        </a>\
        </div>'
    }]
  };
  $scope.headerSalInformation = {};
  $scope.isWritePermAllowed = function () {
    if (lockedStatuses && $scope.headerSalInformation && $scope.headerSalInformation.model && $scope.headerSalInformation.model.status) {
      return lockedStatuses.indexOf($scope.headerSalInformation.model.status) < 0;
    }
    return false;
  };
  $scope.loadAlowedSatatus = function () {
    if ($scope.headerSalInformation.model.status) {
      console.log("Loading allowed statuses for ", $scope.headerSalInformation.model.status);
      salWorkflow.getNextStatuses($scope.headerSalInformation.model.status).then(function (allowedStatuses) {
        $scope.allowedStatuses = allowedStatuses;
      }, function (err) {
        toaster.pop('error', '', 'Impossibile caricare gli stati di SAL consentiti');
      });
    }
  };
  $scope.getSal = function () {
    salFactory.get({
      id: $scope.currentSalCode
    }).$promise.then(function (response) {
      if (!response.hasErrors) {
        if (!response.result.head && response.result.rows.length == 0) {
          $scope.goToSalList();
          return;
        }
        $scope.headerSalInformation = response.result.header;
        if ($scope.headerSalInformation.model.billable_services) {
          $scope.billableServices = {
            billable_services: sixFiltersLib["in"]('UUID', $scope.headerSalInformation.model.billable_services.map(function (service) {
              return service.UUID;
            }))
          };
        } else {
          $scope.billableServices = {};
        }
        $scope.loadAlowedSatatus();
        var salCustomer = $scope.headerSalInformation.customer[0];
        if (salCustomer) {
          $scope.currentCustomer = currentContract.customers.find(function (customer) {
            return salCustomer == customer.uuid;
          });
        }
        $scope.viewGridOptions.data = response.result.rows || [];
      } else {
        dialogService.serviceResponse('Caricamento SAL', response, true);
      }
    })["catch"](function (response) {
      toaster.pop('error', 'Errore', 'Errore durante il recupero dei dati');
    });
  };
  $scope.isDeletionAllowed = function () {
    return $scope.allowedStatuses.findIndex(function (status) {
      return status.code == 'deleted';
    }) >= 0;
  };
  $scope.deleteSal = function () {
    dialogService.confirmDialog('Eliminare il SAL?', function () {
      salWorkflow.setStatus('deleted', {
        code: $scope.headerSalInformation.model.code
      }, $scope.headerSalInformation.UUID).then(function (response) {
        $scope.goToSalList();
      })["catch"](function (err) {
        if (angular.isString(err)) {
          toaster.pop('error', 'Errore', err);
        } else {
          toaster.pop('error', 'Errore', 'Impossibile eliminare il SAL');
        }
      });
    });
  };
  $scope.deleteRowDialog = function (row) {
    dialogService.confirmDialog('Eliminare la riga?', function () {
      if (row.entity.version) {
        if (row.entity.model.odl_id) {
          odlFactory().cleanInvoice({
            salUuid: $scope.headerSalInformation.UUID,
            odlUuid: row.entity.model.odl_id.UUID
          }).$promise.then(function (response) {
            if (!response.hasErrors) {
              deleteRow(row.entity);
            } else {
              dialogService.serviceResponse('Salvataggio ODL', response, true);
            }
          })["catch"](function () {
            toaster.pop('error', 'Errore', 'Impossibile aggiornare l\'ODL');
          });
        } else if (row.entity.model.invoice_id) {
          invoiceFactory.cleanInvoice({
            salUuid: $scope.headerSalInformation.UUID,
            invoiceUuid: row.entity.model.invoice_id.UUID
          }).$promise.then(function (response) {
            if (!response.hasErrors) {
              deleteRow(row.entity);
            } else {
              dialogService.serviceResponse('Salvataggio Prefattura', response, true);
            }
          })["catch"](function () {
            toaster.pop('error', 'Errore', 'Impossibile aggiornare la prefattura');
          });
        } else {
          deleteRow(row.entity);
        }
      } else {
        $scope.gridApi.rowEdit.setRowsClean([row.entity]);
        $scope.viewGridOptions.data.splice($scope.viewGridOptions.data.findIndex(function (r) {
          return angular.equals(r, row.entity);
        }), 1);
      }
    });
  };
  $scope.getSalAmount = function () {
    try {
      var col = $scope.gridApi && $scope.gridApi.grid.getColumn('model.amount');
      if (col) {
        return col.getAggregationValue() - $scope.headerSalInformation.model.total;
      }
    } catch (error) {
      console.error(error);
    }
    return 0;
  };
  $scope.showOrder = function (salRow) {
    dialogService.closeDialog();
    getOrder(salRow.model.order_id.UUID).then(function (order) {
      if (!order) return;
      var dialogScope = {
          order: order.model
        },
        opts = {
          name: 'orderDialog',
          width: 300,
          plain: false,
          overlay: false,
          closeByNavigation: true
        };
      dialogService.templateDialog('consip/sal/order_dialog.html', dialogService.DIALOG_TYPE.INFO, dialogScope, opts, -1, false);
    });
  };
  $scope.showOdl = function (salRow) {
    dialogService.closeDialog();
    getOdl(salRow.model.odl_id.UUID).then(function (odl) {
      if (!odl) return;
      var dialogScope = {
          odl: odl
        },
        opts = {
          name: 'odlDialog',
          width: 300,
          plain: false,
          overlay: false,
          closeByNavigation: true
        };
      dialogService.templateDialog('consip/sal/odl_dialog.html', dialogService.DIALOG_TYPE.INFO, dialogScope, opts, -1, false);
    });
  };
  $scope.showInvoice = function (salRow) {
    dialogService.closeDialog();
    getInvoice(salRow.model.invoice_id.UUID).then(function (invoice) {
      if (!invoice) return;
      var dialogScope = {
          invoice: invoice.model,
          uuid: invoice.UUID
        },
        opts = {
          name: 'invoiceDialog',
          width: 300,
          plain: false,
          overlay: false,
          closeByNavigation: true
        };
      dialogService.templateDialog('consip/sal/invoice_dialog.html', dialogService.DIALOG_TYPE.INFO, dialogScope, opts, -1, false);
    });
  };
  $scope.jasperReport = function () {
    var reportPrameters = {
      commission: currentContract.code,
      customer: $scope.currentCustomer.uuid,
      salcode: $scope.currentSalCode,
      aggregations: $scope.headerSalInformation.model.aggregation_fields
    };
    salGenerationService.salReport(reportPrameters, $scope.currentSalCode + '.pdf');
  };
  $scope.refresh = function () {
    var gridRows = $scope.gridApi.rowEdit.getDirtyRows().map(function (gridRow) {
      return gridRow.entity;
    });
    $scope.gridApi.rowEdit.setRowsClean(gridRows);
    $scope.getSal();
  };
  $scope.isDirty = function () {
    return $scope.gridApi && $scope.gridApi.rowEdit.getDirtyRows().length > 0;
  };
  $scope.canSave = function () {
    if ($scope.isDirty()) {
      return isResidualPlafondPositive() || authFactory.checkPerm('SAL', 'negative_residual');
    }
    return false;
  };
  $scope.saveSal = function () {
    var rows = $scope.gridApi.rowEdit.getDirtyRows().filter(isToSave).map(function (row) {
      return row.entity;
    }).map(function (row) {
      delete row.$$hashKey;
      delete row.plafond;
      return row;
    });
    if (rows.length > 0) {
      salFactory.save({
        id: $scope.currentSalCode
      }, rows).$promise.then(function (response) {
        if (!response.hasErrors) {
          toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito correttamente');
          $scope.refresh();
        } else {
          dialogService.serviceResponse('Esito salvataggio righe SAL', response, true);
        }
      })["catch"](function (response) {
        toaster.pop('error', 'Errore salvataggio', 'Salvataggio fallito');
      });
    } else {
      toaster.pop('info', '', 'Non ci sono righe da salvare');
    }
  };

  // ***** redirects ***** //

  $scope.goToSalList = function () {
    $location.path('sal');
  };
  function isResidualPlafondPositive() {
    if ($scope.isLooseContract) {
      if ($scope.plafond) {
        return $scope.plafond.total - $scope.plafond.turnover - $scope.getSalAmount() >= 0;
      }
      return false;
    } else {
      var negativePlafondIdx = $scope.gridApi.rowEdit.getDirtyRows().filter(isToSave).findIndex(function (r) {
        return r.entity.plafond && r.entity.plafond.residual < 0;
      });
      return negativePlafondIdx < 0;
    }
  }
  var orderCache = {};
  function getOrder(uuid) {
    if (!orderCache[uuid]) {
      orderCache[uuid] = orderRowFactory.getByUUID({
        id: uuid
      }).$promise.then(function (response) {
        if (response.model) {
          return response;
        }
        return $q.reject();
      })["catch"](function (err) {
        toaster.pop('error', '', 'Impossibile trovare l\'ordine');
        delete orderCache[uuid];
      });
    }
    return orderCache[uuid];
  }
  var odlCache = {};
  function getOdl(uuid) {
    if (!odlCache[uuid]) {
      odlCache[uuid] = odlFactory().getOdlByUUID({
        uuid: uuid
      }).$promise.then(function (response) {
        if (response.model) {
          return response;
        }
        return $q.reject();
      })["catch"](function (err) {
        toaster.pop('error', '', 'Impossibile trovare l\'ordine');
        delete odlCache[uuid];
      });
    }
    return odlCache[uuid];
  }
  var invoiceCache = {};
  function getInvoice(uuid) {
    if (!invoiceCache[uuid]) {
      invoiceCache[uuid] = invoiceFactory.getInvoiceByUUID({
        uuid: uuid
      }).$promise.then(function (response) {
        if (response.model) {
          return response;
        }
        return $q.reject();
      })["catch"](function (err) {
        toaster.pop('error', '', 'Impossibile trovare la prefattura');
        delete invoiceCache[uuid];
      });
    }
    return invoiceCache[uuid];
  }
  function deleteRow(rowEntity) {
    return salFactory["delete"]({
      id: rowEntity.version
    }).$promise.then(function (response) {
      $scope.gridApi.rowEdit.setRowsClean([rowEntity]);
      $scope.viewGridOptions.data.splice($scope.viewGridOptions.data.findIndex(function (r) {
        return angular.equals(r, rowEntity);
      }), 1);
    })["catch"](function () {
      toaster.pop('error', 'Errore', 'Impossibile eliminare la riga');
    });
  }
  function isCellEditable(scope) {
    return $scope.isWritePermAllowed() && (scope.row.entity.model.service_type === 'extra canone' || scope.row.entity.model.type === 'manual' || scope.row.entity.model.type === 'fake');
  }
  function editableCellClass(grid, row, col) {
    if (isCellEditable({
      row: row
    })) {
      return 'toedit';
    }
  }
  function onRegisterApi(gridApi) {
    $scope.gridApi = gridApi;
    gridApi.edit.on.afterCellEdit($scope, function (rowEntity, colDef, newValueStr, oldValue) {
      var canInsertNegativeRow = authFactory.checkPerm('SAL', 'negative_row');
      var newValue = parseFloat(newValueStr);
      if (newValue < 0 && !canInsertNegativeRow) {
        dialogService.dialog('Permesso negato', 'l\'importo non può essere negativo', 'warning', -1);
        if (colDef.field == 'model.amount') {
          rowEntity.model.amount = oldValue;
        } else if (colDef.field == 'model.qty') {
          rowEntity.model.qty = oldValue;
        }
        return;
      }
      if ($scope.isLooseContract) return;
      if (newValue != oldValue) {
        var isFake = rowEntity.model.type == 'fake';
        if (colDef.field == 'model.amount') {
          rowEntity.model.qty = newValue / rowEntity.model.pu;
          if (!isFake) {
            rowEntity.plafond.residual -= newValue;
          }
        } else if (colDef.field == 'model.qty') {
          var computedAmount = newValue * rowEntity.model.pu;
          rowEntity.model.amount = computedAmount;
          if (!isFake) {
            rowEntity.plafond.residual -= computedAmount;
          }
        }
        if (!isFake && rowEntity.plafond.residual < 0) {
          dialogService.dialog('ATTENZIONE', 'Il residuo è negativo', 'warning', -1);
        }
        if (rowEntity.model.service_type == 'canone' && rowEntity.model.amount) {
          dialogService.confirmDialog('Stai erodendo plafond di un servizio a canone. Sei sicuro?', angular.identity, function () {
            rowEntity.model.amount = 0;
            rowEntity.model.qty = 0;
          });
        }
      }
      dialogService.closeDialog();
    });
    gridApi.edit.on.beginCellEdit($scope, function (rowEntity, colDef) {
      if (rowEntity.model.type == 'fake' || $scope.isLooseContract) return;
      plafondSrv.getPlafond(rowEntity.model.service_id.UUID, rowEntity.model.asset_id.UUID).then(function (response) {
        rowEntity.plafond = response;
        var dialogScope = {
            row: rowEntity,
            plafond: response
          },
          opts = {
            name: 'plafondDialog',
            closeByDocument: false,
            width: 300,
            plain: false,
            showClose: false,
            overlay: false,
            closeByNavigation: true,
            closeByEscape: false,
            trapFocus: false
          };
        dialogService.templateDialog('consip/sal/plafond_dialog.html', dialogService.DIALOG_TYPE.INFO, dialogScope, opts, -1, false).id;
      });
    });
    gridApi.edit.on.cancelCellEdit($scope, function () {
      dialogService.closeDialog();
    });
  }
  function initGridColumns() {
    if ($scope.isLooseContract) {
      $scope.viewGridOptions.columnDefs.splice(1, 0, {
        displayName: 'Cod. Servizio',
        field: 'model.service_id.code'
      }, {
        displayName: 'Descr. Servizio',
        field: 'model.service_id.description'
      });
    } else {
      $scope.viewGridOptions.columnDefs.splice(1, 0, {
        displayName: 'Cod. Edificio',
        field: 'model.asset_id.code'
      }, {
        displayName: 'Edificio',
        field: 'model.asset_id.description'
      }, {
        displayName: 'Cod. Servizio',
        field: 'model.service_id.code'
      }, {
        displayName: 'Descr. Servizio',
        field: 'model.service_id.description'
      }, {
        displayName: 'Cod. Classe',
        field: 'model.serviceclass_id.code'
      }, {
        displayName: 'Descr. Classe',
        field: 'model.serviceclass_id.description'
      }, {
        displayName: 'Tipo servizio',
        field: 'model.service_type',
        filters: [{
          type: uiGridConstants.filter.SELECT,
          condition: uiGridConstants.filter.STARTS_WITH,
          selectOptions: [{
            value: 'canone',
            label: 'Canone'
          }, {
            value: 'extra',
            label: 'Extra canone'
          }]
        }]
      }, {
        displayName: 'Quantità',
        field: 'model.qty',
        cellFilter: 'number:1',
        enableCellEdit: true,
        cellEditableCondition: isCellEditable,
        cellClass: editableCellClass,
        filters: [{
          condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL,
          placeholder: 'da...'
        }, {
          relation: uiGridConstants.filter.LESS_THAN_OR_EQUAL,
          placeholder: 'a...'
        }]
      }, {
        displayName: 'PU',
        field: 'model.pu',
        cellClass: 'cont-right',
        cellFilter: 'currency:"€":4',
        filters: [{
          condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL,
          placeholder: 'da...'
        }, {
          relation: uiGridConstants.filter.LESS_THAN_OR_EQUAL,
          placeholder: 'a...'
        }]
      }, {
        displayName: 'UM',
        field: 'model.um_id.description'
      });
    }
  }
  function isToSave(row) {
    var rowEntity = row.entity;
    return !(rowEntity.newlyAdded && rowEntity.model.amount == 0);
  }

  /** ***********************************
   * Messaggi e notifiche
   * ***********************************/

  $scope.loadingSixMail = true;
  $scope.currentSalRef = null;
  function setObjectSixSendMail() {
    return {
      type: 'sal',
      UUID: '',
      code: $scope.currentSalCode,
      description: ''
    };
  }
  function setBodyText(notification) {
    var model = notification.model;
    if (angular.isDefined(model)) {
      var bodyHtml = model.body;
      if (angular.isDefined(bodyHtml)) {
        bodyHtml = "<div>" + bodyHtml + "</div>";
        var bodyText = $(bodyHtml).text();
        model.bodyAsText = bodyText;
      }
    }
  }
  $scope.getNotificationsList = function () {
    var payload = {
      page: 1,
      pageSize: 10000,
      //UUID: $scope.data.UUID,
      //index: 'six_odl',
      typeNotification: 'sal',
      list: null
    };
    notificationFactory().getListFiltered(payload).$promise.then(function (data) {
      $scope.notifications = data.list;
      if ($scope.notifications) {
        for (var i = 0; i < $scope.notifications.length; i++) {
          var notification = $scope.notifications[i];
          setBodyText(notification);
          notification.color = 'b-l-warning';
          notification.href = "#/notification/" + notification.version;
        }
      }
    });
  };
  $scope.getMessage = function () {
    /* creazione testo mail */
    var searchInit = {
      search: {
        obj: {
          'username': authFactory.getAuthData().authId
        }
      },
      init: {
        authId: true,
        email: true
      }
    };
    var promiseMailUser = userFactory.getMail(searchInit).$promise;
    $scope.loadingSixMail = true;
    Promise.all([promiseMailUser]).then(function (response) {
      $scope.loadingSixMail = false;
      $scope.objMail = {
        title: 'Documento Sal',
        to: ($scope.headerSalInformation.model.emails || []).join(','),
        cc: formatMailCc(response[0].list[0].email),
        message: 'In allegato, il sal corrispondente'
      };
    });
  };
  function formatMailCc(UserMailSix) {
    if (UserMailSix) {
      return UserMailSix;
    } else {
      return null;
    }
  }

  /**
   * Add SAL rows
   **/

  $scope.onAddManualRow = function (service) {
    var found = $scope.viewGridOptions.data.find(function (row) {
      return row.model.type == 'manual' && row.model.service_id.UUID == service.UUID;
    });
    if (found) {
      toaster.pop('warning', '', 'Esiste già una riga manuale per il servizio ' + service.description);
    } else {
      $scope.viewGridOptions.data.unshift({
        model: {
          amount: 0,
          service_id: service,
          type: 'manual'
        }
      });
    }
  };
  var duplicateRow = $interpolate('Esiste già una riga manuale per il servizio {{service_id.description}} all\'edificio {{asset_id.descriprion}}');
  $scope.addSalRows = function (rows, type) {
    rows.forEach(function (r) {
      var index = $scope.viewGridOptions.data.findIndex(function (salRow) {
        return (salRow.model.type == 'manual' || salRow.model.type == 'fake') && salRow.model.service_id.code == r.model.service_id.code && salRow.model.asset_id.code == r.model.asset_id.code;
      });
      if (index < 0) {
        r.model.type = type;
        r.newlyAdded = true;
        $scope.viewGridOptions.data.unshift(r);
      } else {
        toaster.pop('warning', '', duplicateRow(r.model));
      }
    });
  };

  // ***** _main ***** //
  if ($routeParams.sal_code) {
    $scope.currentSalCode = $routeParams.sal_code;
    $scope.currentSalRef = setObjectSixSendMail();
    salWorkflow.getLockedStatuses().then(function (statuses) {
      lockedStatuses = statuses;
    }, function (err) {
      console.warn('Impossibile caricare gli stati del SAL');
    });
    contractFactory().recordByCommission().$promise.then(function (contract) {
      $scope.isLooseContract = CONTRACT_TYPES.loose == contract.model.contract_type;
      initGridColumns();
      if ($scope.isLooseContract) {
        plafondSrv.getCustomerPlafond().then(function (response) {
          if (response.hasErrors) {
            dialogService.serviceResponce('Plafond', response, false);
          } else {
            $scope.plafond = response.result;
          }
        });
      }
      $scope.getSal();
    }, function (err) {
      toaster.pop('error', '', 'Inpossibile caricare il contratto per la convenzione');
      $scope.goToSalList();
    });
  } else {
    $scope.goToSalList();
  }
}]).controller('SalAttachmentCtrl', ["$scope", "toaster", "$log", "authFactory", "ALFRESCO_URL", "salAttachmentsFactory", "FileUploader", "alfrescoFactory", "salWorkflow", "ENV", function ($scope, toaster, $log, authFactory, ALFRESCO_URL, salAttachmentsFactory, FileUploader, alfrescoFactory, salWorkflow, ENV) {
  /** ***********************************
   * Gestione documentale
   * ***********************************/

  var DESTINATION = "/Sites/" + ENV + "/" + authFactory.getAuthData().info.commissions.current.code;
  $scope.DOWNLOAD_URL = ALFRESCO_URL + "/api/alfresco/";
  $scope.canRemoveInvoice = authFactory.checkPerm('SAL', 'remove_invoice');
  $scope.attachmentsListDocument = [];
  $scope.invoice = {};
  $scope.upload = {
    errors: []
  };
  var uploader = $scope.uploader = new FileUploader({
    removeAfterUpload: true,
    url: ALFRESCO_URL + '/upload',
    formData: [{
      destination: DESTINATION
    }]
  });
  $scope.undoUpload = function () {
    uploader.clearQueue();
    $scope.upload.errors.length = 0;
  };
  $scope.loadQuote = function () {
    $scope.undoUpload();
    $scope.addQuote();
  };
  $scope.addQuote = function () {
    angular.element('#fileUploadBtn').trigger('click');
  };
  $scope.setInvoice = function (fileItem) {
    if (fileItem.is_invoice) {
      uploader.queue.forEach(function (fi) {
        if (fi.file.name != fileItem.file.name) {
          fi.is_invoice = false;
        }
      });
    }
  };
  $scope.removeAttachment = function (attachment) {
    salAttachmentsFactory["delete"]({
      id: attachment.version
    }).$promise.then(function () {
      alfrescoFactory["delete"]({
        id: attachment.model.object_id
      });
      getSalAttachment();
      if (attachment.model.is_invoice && $scope.headerSalInformation.model.status == 'closed') {
        $log.info("UUID: " + $scope.currentSalCode + " --> passa a: approved");
        salWorkflow.setStatus('approved', {
          code: $scope.currentSalCode,
          status_note: 'Eliminata fattura'
        }).then(function (updatedObject) {
          $scope.headerSalInformation.model.status = updatedObject.status;
          $scope.loadAlowedSatatus();
        }, function () {
          toaster.pop('error', 'Errore', 'Passaggio di stato fallito');
        });
      }
    }, function (err) {
      toaster.pop('error', '', 'Impossibile cancellare l\'allegato ' + attachment.model.title);
    });
  };
  function printUploadError(errorMessage) {
    $scope.upload.errors.push(errorMessage);
  }
  function addUploadedFileToList(fileItem) {
    var documentAttachedToSave = {
      sal_code: $scope.currentSalCode,
      date_insertion: new Date(),
      object_id: fileItem.objectId,
      title: fileItem.file.name,
      is_invoice: fileItem.is_invoice,
      user: authFactory.getAuthData().authId,
      destination: DESTINATION
    };
    if (documentAttachedToSave.is_invoice) {
      angular.extend(documentAttachedToSave, $scope.invoice);
    }
    salAttachmentsFactory.save(documentAttachedToSave).$promise.then(function (response) {
      if (response.model) {
        $scope.attachmentsListDocument.push(response);
        if (response.model.is_invoice && $scope.headerSalInformation.model.status != 'invoice_opened') {
          $log.info("UUID: " + $scope.currentSalCode + " --> passa a: closed");
          salWorkflow.setStatus('invoice_opened', {
            code: $scope.currentSalCode,
            status_note: 'allegata fattura'
          }).then(function (updatedObject) {
            $scope.headerSalInformation.model.status = updatedObject.status;
            $scope.loadAlowedSatatus();
          }, function () {
            toaster.pop('error', 'Errore', 'Passaggio di stato fallito');
          });
        }
      }
    });
  }
  $scope.canAttachInvoice = function () {
    return $scope.allowedStatuses.findIndex(function (status) {
      return status.code == 'invoice_opened';
    }) >= 0 && $scope.attachmentsListDocument.findIndex(function (attachment) {
      return attachment.model.is_invoice;
    }) < 0;
  };

  /**************************************
   * Uploader callbacks
   *************************************/

  uploader.onSuccessItem = function (fileItem, response, status, headers) {
    if (angular.isDefined(response.ERROR)) {
      printUploadError(response.ERROR);
    } else {
      fileItem.objectId = response.objectId;
      addUploadedFileToList(fileItem);
    }
  };
  uploader.onErrorItem = function (fileItem, response, status, headers) {
    printUploadError("Errore nel caricamento del file " + fileItem.file.name);
  };

  /**
   * main
   */

  function getSalAttachment() {
    salAttachmentsFactory.search({
      id: $scope.currentSalCode
    }).$promise.then(function (response) {
      if (!response.hasErrors) {
        $scope.attachmentsListDocument = response.result;
      } else {
        toaster.pop('error', '', 'Impossibile caricare gli allegati');
      }
    });
  }
  getSalAttachment();
}]);
"use strict";

/**
 * Created by luca on 12/12/16.
 */

/**
 * @ngdoc function
 * @name emma.consip.controller:SalConfigurationCtrl
 * @description
 * # SalConfigurationCtrl
 * Controller of the emma.consip
 */
angular.module('emma.consip').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/salconfiguration', {
    templateUrl: 'consip/sal/sal_configuration.html',
    controller: 'SalConfigurationCtrl'
  });
}]).controller('SalConfigurationCtrl', ["$scope", "sixGridPaginationConstants", "uiGridConstants", "toaster", "authFactory", "salGenerationService", "salConfigurationFactory", "dialogService", "contractFactory", "CONTRACT_TYPES", function ($scope, sixGridPaginationConstants, uiGridConstants, toaster, authFactory, salGenerationService, salConfigurationFactory, dialogService, contractFactory, CONTRACT_TYPES) {
  $scope.commission = authFactory.getAuthData().info.commissions.current;
  $scope.currentCustomer = authFactory.getCurrentCustomer();
  $scope.form = {};
  $scope.serviceTypeList = [{
    key: 'canone',
    description: 'Canone'
  }, {
    key: 'extra canone',
    description: 'Extra-canone'
  }, {
    key: 'da odl',
    description: 'Extra-canone da ODL'
  }];
  $scope.aggregationFields = salGenerationService.aggregationOptions;
  $scope.params = {
    filters: {}
  };
  $scope.configuration = null;
  $scope.configurations = {
    list: [],
    totalResults: 0
  };
  $scope.viewGridOptions = {
    enableFiltering: true,
    enableRowHeaderSelection: false,
    enableRowSelection: false,
    appScopeProvider: $scope,
    columnDefs: [{
      displayName: '',
      field: 'id',
      width: 105,
      enableHiding: false,
      enableColumnMenu: false,
      enableFiltering: false,
      enableSorting: false,
      cellTemplate: '<div class="ui-grid-cell-contents text-center">' + '<a ng-href ng-click="grid.appScope.setConfiguration(row.entity)" class="btn btn-xs btn-primary m-r-xs">' + '<span class="fa fa-search"></span>' + '</a>' + '<a ng-href ng-click="grid.appScope.deleteSalConfiguration(row.entity)" class="btn btn-xs btn-danger m-r-xs">' + '<span class="fa fa-trash"></span>' + '</a>' + '<a ng-href ng-click="grid.appScope.duplicateSalConfiguration(row.entity)" class="btn btn-xs btn-success">' + '<span class="fa fa-clone"></span>' + '</a>' + '</div>'
    }, {
      displayName: 'Codice',
      field: 'model.code',
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS
      }]
    }, {
      displayName: 'Descrizione',
      field: 'model.description',
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }, {
      displayName: 'Schedulato',
      field: 'model.scheduleActive',
      type: 'boolean',
      cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.model.scheduleActive? "Sì" : "No"}}</div>',
      enableFiltering: false
    }, {
      displayName: '',
      field: 'id',
      width: 30,
      enableHiding: false,
      enableColumnMenu: false,
      enableFiltering: false,
      enableSorting: false,
      cellTemplate: '<div class="ui-grid-cell-contents text-center">' + '<i class="fa fa-{{row.entity.model.suspended? \'pause\' : \'play\'}}" ng-if="row.entity.model.scheduleActive"></i>' + '</div>'
    }]
  };
  $scope.setConfiguration = function (conf) {
    $scope.configuration = conf;
    // FIXME retrocompatibilità sul serviceType
    if ($scope.configuration && $scope.configuration.model.serviceType && !angular.isArray($scope.configuration.model.serviceType)) {
      $scope.configuration.model.serviceType = [$scope.configuration.model.serviceType];
    }
  };
  $scope.newSalConfiguration = function () {
    if ($scope.contract.model.contract_type == CONTRACT_TYPES.loose) {
      $scope.setConfiguration({
        model: {
          contract_type: CONTRACT_TYPES.loose
        }
      });
    } else {
      $scope.setConfiguration({
        model: {
          contract_type: CONTRACT_TYPES.strict,
          aggregations: [],
          services: [],
          serviceGroups: [],
          assets: [],
          serviceType: []
        }
      });
    }
  };
  $scope.saveSalConfiguration = function () {
    if ($scope.configuration.version) {
      salConfigurationFactory.update({
        id: $scope.configuration.version,
        history: false
      }, $scope.configuration).$promise.then(function (response) {
        if (!response.hasErrors) {
          $scope.setConfiguration();
          $scope.getList();
        } else {
          toaster.pop('error', 'Errore Aggiornamento', 'Aggiornamento configurazione SAL fallita');
        }
      })["catch"](function (response) {
        // error
        toaster.pop('error', 'Errore Aggiornamento', 'Aggiornamento configurazione SAL fallita');
      });
    } else {
      salConfigurationFactory.create($scope.configuration.model).$promise.then(function (response) {
        if (!response.hasErrors) {
          $scope.setConfiguration();
          $scope.getList();
        } else {
          toaster.pop('error', 'Errore creazione', 'Creazione configurazione SAL fallita');
        }
      })["catch"](function (response) {
        // error
        toaster.pop('error', 'Errore creazione', 'Creazione configurazione SAL fallita');
      });
    }
  };
  $scope.getList = function () {
    var params = {
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      sort_fields: $scope.params.sortFields
    };
    $scope.params.filters.commission = sixFiltersLib.exact('commission', $scope.commission.code);
    if ($scope.currentCustomer) {
      $scope.params.filters.customer = sixFiltersLib.exact('customer', $scope.currentCustomer.code);
    }
    return salConfigurationFactory.search(params, $scope.params.filters).$promise.then(function (response) {
      if (response.totalResults > 0) {
        $scope.configurations.list = response.list || [];
        $scope.configurations.totalResults = response.totalResults;
        $scope.params.sixApi.refreshList(response.list);
      } else {
        toaster.pop('info', 'Caricamento configurazione', 'Nessuna configurazione scaricata per la commessa ed il cliente selezionati');
      }
      return response;
    })["catch"](function (response) {
      toaster.pop('info', 'Caricamento configurazione', 'Nessuna configurazione scaricata per la commessa ed il cliente selezionati');
    });
  };
  $scope.deleteSalConfiguration = function (salc) {
    dialogService.confirmDialog('Eliminare la configurazione ' + salc.model.description + ' ?', function () {
      salConfigurationFactory["delete"]({
        id: salc.version
      }).$promise.then(function () {
        $scope.getList();
        $scope.setConfiguration();
      });
    });
  };
  $scope.duplicateSalConfiguration = function (salc) {
    var conf = {
      model: angular.copy(salc.model)
    };
    conf.model.code = null;
    $scope.setConfiguration(conf);
  };
  var EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  $scope.emailValidation = function (value) {
    return EMAIL_REGEX.test(value) && value.toLowerCase();
  };

  /**
   * MAIN
   */
  $scope.loading = true;
  contractFactory().recordByCommission().$promise.then(function (data) {
    if (!data.model) {
      dialogService.alert('Nessuna convenzione definita', 4000);
    } else {
      $scope.contract = data;
    }
  })["catch"](function (err) {
    dialogService.alert('Impossibile caricare il contratto', 4000);
  })["finally"](function () {
    $scope.loading = false;
  });
}]);
'use strict';

/**
 * @ngdoc function
 * @name emma.consip.controller:SalCtrl
 * @description
 * # SalCtrl
 * Controller of the emma.consip
 */
angular.module('emma.consip').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/salnew/strict/:salConf', {
    templateUrl: 'consip/sal/sal_new.html',
    controller: 'SalGenerationCtrl'
  });
}]).controller('SalGenerationCtrl', ["$scope", "$rootScope", "$location", "$routeParams", "acquisitionWizardFactory", "dialogService", "toaster", "$q", "$log", "uiGridConstants", "authFactory", "recordFactory", "salGenerationService", "contractFactory", "orderRowFactory", "odlFactory", "salFactory", "salConfigurationFactory", "$interpolate", function ($scope, $rootScope, $location, $routeParams, acquisitionWizardFactory, dialogService, toaster, $q, $log, uiGridConstants, authFactory, recordFactory, salGenerationService, contractFactory, orderRowFactory, odlFactory, salFactory, salConfigurationFactory, $interpolate) {
  var currentContract = authFactory.getAuthData().info.commissions.current;
  var salPeriod = 1;
  var getSalCode = $interpolate("sal_{{contract}}_{{customer.code}}_{{from | date:'yyyyMMdd'}}_{{to | date:'yyyyMMdd'}}");
  var getSalDesctription = $interpolate("Sal contratto {{contract}} - cliente {{customer.code}} dal {{from | date:'dd/MM/yyyy'}} al {{to | date:'dd/MM/yyyy'}}");
  var odlErrMsg = $interpolate('Impossibile trovare nel contratto, il servizio {{service.description}} per l\'edificio {{building.code}}');
  $scope.currentCustomer = authFactory.getCurrentCustomer();
  $scope.salConfiguration = {
    services: [],
    assets: [],
    serviceGroups: [],
    aggregations: [],
    serviceType: []
  };
  $scope.aggregationFields = salGenerationService.aggregationOptions;
  $scope.salRows = [];
  $scope.serviceTypeList = [{
    key: 'canone',
    description: 'Canone'
  }, {
    key: 'extra canone',
    description: 'Extra-canone'
  }, {
    key: 'da odl',
    description: 'Extra-canone da ODL'
  }];
  $scope.odlSixLookupStyle = true;
  $scope.odl = {
    selected: []
  };
  $scope.dateOptions = {
    formatYear: 'yyyy',
    startingDay: 1,
    datepickerMode: 'month',
    minMode: 'month',
    maxMode: 'year'
  };
  $scope.dateFormat = 'MMMM yyyy';
  $scope.viewGridOptions = {
    expandableRowTemplate: '<div class="h-full w-full">\
      <textarea class="form-control w-full" style="resize:none; height: 100%;" ng-model="row.entity.note" placeholder="Note"\
        ng-change="grid.api.rowEdit.setRowsDirty([row.entity])"></textarea>\
      </div>',
    expandableRowHeight: 120,
    enableExpandableRowHeader: false,
    enableGridMenu: true,
    enableFiltering: true,
    enableCellEdit: false,
    showColumnFooter: true,
    paginationPageSizes: [10, 15, 25, 50, 100, 250, 500],
    paginationPageSize: 500,
    data: 'salRows',
    rowEditWaitInterval: -1,
    rowHeight: 35,
    onRegisterApi: onRegisterApi,
    columnDefs: [{
      name: ' '
    }]
  };
  function onRegisterApi(gridApi) {
    $scope.gridApi = gridApi;
    gridApi.edit.on.afterCellEdit($scope, function (rowEntity, colDef, newValue, oldValue) {
      if (colDef.field == 'amount') {
        var diff = oldValue - newValue;
        rowEntity.qty = newValue / rowEntity.pu;
        alignAmount(rowEntity, diff);
        if (rowEntity.plafond.residual < 0) {
          dialogService.dialog('ATTENZIONE', 'Il residuo è negativo', 'warning', -1);
        }
      } else if (colDef.field == 'qty') {
        var computedAmount = newValue * rowEntity.pu;
        var diff = rowEntity.amount - computedAmount;
        rowEntity.amount = computedAmount;
        alignAmount(rowEntity, diff);
        if (rowEntity.plafond.residual < 0) {
          dialogService.dialog('ATTENZIONE', 'Il residuo è negativo', 'warning', -1);
        }
      }
      $scope.$apply();
    });
  }
  function initGridColumns() {
    $scope.viewGridOptions.columnDefs = [{
      displayName: '',
      field: 'id',
      enableColumnMenu: false,
      enableFiltering: false,
      enableSorting: false,
      enableColumnResizing: false,
      enableHiding: false,
      width: 40,
      cellTemplate: '<div class="ui-grid-cell-contents text-center">\
        <a ng-click="grid.api.expandable.toggleRowExpansion(row.entity)" class="btn btn-rounded btn-xs btn-icon btn-{{row.isExpanded? \'default\' : \'info\'}}"\
        ng-class="{shadow: row.entity.note}">\
        <i class="fa fa-pencil-square-o"></i>\
        </a>\
        </div>'
    }, {
      displayName: 'Cod. Edificio',
      field: 'asset_id.code'
    }, {
      displayName: 'Edificio',
      field: 'asset_id.description'
    }, {
      displayName: 'Cod. Servizio',
      field: 'service_id.code'
    }, {
      displayName: 'Descr. Servizio',
      field: 'service_id.description'
    }, {
      displayName: 'Cod. Classe',
      field: 'serviceclass_id.code'
    }, {
      displayName: 'Descr. Classe',
      field: 'serviceclass_id.description'
    }, {
      displayName: 'Tipo servizio',
      field: 'service_type',
      filters: [{
        type: uiGridConstants.filter.SELECT,
        condition: uiGridConstants.filter.STARTS_WITH,
        selectOptions: [{
          value: 'canone',
          label: 'Canone'
        }, {
          value: 'extra',
          label: 'Extra canone'
        }]
      }]
    }, {
      displayName: 'Quantità',
      field: 'qty',
      enableCellEdit: true,
      cellEditableCondition: isCellEditable,
      cellFilter: 'number:1',
      cellClass: editableCellClass,
      filters: [{
        placeholder: 'da...',
        condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
      }, {
        placeholder: 'a...',
        condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
      }]
    }, {
      displayName: 'PU',
      field: 'pu',
      cellClass: 'cont-right',
      cellFilter: 'currency:\'€\':4',
      filters: [{
        placeholder: 'da...',
        condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
      }, {
        placeholder: 'a...',
        condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
      }]
    }, {
      displayName: 'UM',
      field: 'um_id.description'
    }, {
      displayName: 'Importo',
      field: 'amount',
      enableCellEdit: true,
      cellEditableCondition: isCellEditable,
      cellFilter: 'currency:\'€\':2',
      cellClass: function cellClass(grid, row, col) {
        return 'cont-right ' + editableCellClass(grid, row, col);
      },
      aggregationType: function aggregationType() {
        try {
          return $scope.viewGridOptions.data.map(function (row) {
            return row.amount;
          }).reduce(function (total, amount) {
            return total + amount;
          });
        } catch (error) {
          console.error(error);
          return 0;
        }
      },
      filters: [{
        placeholder: 'da...',
        condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
      }, {
        placeholder: 'a...',
        condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
      }]
    }, {
      displayName: 'Totale',
      field: 'plafond.plafond',
      cellClass: 'cont-right',
      cellFilter: 'currency:\'€\':2',
      filters: [{
        placeholder: 'da...',
        condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
      }, {
        placeholder: 'a...',
        condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
      }]
    }, {
      displayName: 'Usato',
      field: 'plafond.used',
      cellClass: 'cont-right',
      cellFilter: 'currency:\'€\':2',
      filters: [{
        placeholder: 'da...',
        condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
      }, {
        placeholder: 'a...',
        condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
      }]
    }, {
      displayName: 'Residuo',
      field: 'plafond.residual',
      cellClass: 'cont-right',
      cellFilter: 'currency:\'€\':2',
      filters: [{
        placeholder: 'da...',
        condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
      }, {
        placeholder: 'a...',
        condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
      }]
    }, {
      displayName: 'Gen.',
      field: 'id',
      width: 70,
      enableColumnMenu: false,
      enableFiltering: false,
      enableSorting: false,
      enableColumnResizing: false,
      enableHiding: false,
      cellTemplate: '<div class="ui-grid-cell-contents text-center">' + '  <a ng-click="grid.appScope.openAlreadyProcessedRow(row.entity)" ng-if="row.entity.duplicated_row_id.length" class="btn btn-xs btn-icon btn-primary">' + '    <i class="fa fa-search"></i>' + '  </a>' + '  <a ng-click="grid.appScope.showOrder(row.entity)" ng-if="row.entity.order_id" class="btn btn-rounded btn-xs btn-icon btn-primary">' + '    <i class="fa fa-file-text-o"></i>' + '  </a>' + '  <a ng-click="grid.appScope.showOdl(row.entity)" ng-if="row.entity.odl_id" class="btn btn-rounded btn-xs btn-icon btn-primary">' + '    <i class="fa fa-wrench"></i>' + '  </a>' + '</div>'
    }];
  }
  function isCellEditable(scope) {
    return scope.row.entity.service_type === 'extra canone';
  }
  function editableCellClass(grid, row, col, rowRenderIndex, colRenderIndex) {
    if (isCellEditable({
      row: row
    })) {
      return 'toedit';
    }
    return;
  }
  function alignAmount(salRow, diff) {
    $scope.salRows.filter(function (sal) {
      return sal.service_type === salRow.service_type && sal.asset_id.UUID == salRow.asset_id.UUID && sal.service_id.UUID == salRow.service_id.UUID;
    }).forEach(function (sal) {
      sal.plafond.residual += diff;
    });
  }
  $scope.create = function () {
    if ($scope.form.$invalid) {
      $log.log('errori nella form');
      return;
    }
    var payload = {
      from: $scope.salConfiguration.from,
      to: $scope.salConfiguration.to,
      acquisition_uuid: $scope.acquisition.UUID,
      save: false
    };
    if ($scope.salConfiguration.services.length > 0) {
      var services = $scope.salConfiguration.services.map(function (obj) {
        return obj.code;
      });
      payload.services = services;
    }
    if ($scope.salConfiguration.assets.length > 0) {
      var assets = $scope.salConfiguration.assets.map(function (obj) {
        return obj.code;
      });
      payload.assets = assets;
    }
    if ($scope.salConfiguration.serviceGroups.length > 0) {
      var serviceGroups = $scope.salConfiguration.serviceGroups.map(function (obj) {
        return obj.code;
      });
      payload.service_groups = serviceGroups;
    }
    payload.service_type = getServiceTypeFilter($scope.salConfiguration.serviceType);
    salGenerationService.generate(payload).then(function (response) {
      if (!response.hasErrors) {
        $scope.salRows = response.result;
        if ($scope.salRows.length == 0) {
          toaster.pop('warning', 'Non esistono righe d\'ordine per la generazione del SAL');
          return;
        }
        sixDateLib.fixDates($scope.salRows);
        if ($scope.salRows.findIndex(function (r) {
          return r.service_type == 'extra canone';
        }) >= 0) {
          dialogService.dialog('Generazione eseguita', 'Proseguire con la modifica manuale degli importi extra-canone', 'info', 5000, true);
        }
        if ($scope.salRows.findIndex(function (r) {
          return r.duplicated_row_id && r.duplicated_row_id.length;
        }) >= 0) {
          dialogService.dialog('Righe già presenti', 'Sono presenti righe già generate per lo stesso periodo', 'warning', 5000, true);
        }
        $scope.salRows.forEach(function (row) {
          row.plafond.residual = (row.plafond.plafond || .0) - (row.plafond.used || .0);
        });
        $scope.generateOdlRows();
      } else {
        dialogService.serviceResponse('Esito SAL', response, true);
      }
    })["catch"](function (response) {
      toaster.pop('error', 'Errore generazione', 'Generazione SAL fallita');
    });
  };
  $scope.generateOdlRows = function () {
    if ($scope.odl.selected) {
      $scope.odl.selected.forEach(function (odl) {
        var salRow = $scope.salRows.find(function (sal) {
          return sal.service_type === 'extra canone' && sal.asset_id.UUID == odl.model.record_id.UUID && sal.service_id.UUID == odl.model.service_id.UUID;
        });
        if (salRow) {
          var amount = odl.consumptives.filter(function (item) {
            return item.model.status == 'approved';
          })[0].model.total;
          salRow = angular.copy(salRow);
          salRow.amount = amount;
          salRow.qty = amount / salRow.pu;
          salRow.odl_id = {
            code: odl.model.code,
            description: odl.model.description,
            UUID: odl.UUID,
            type: odl.schemaCode
          };
          salRow.odl = odl;
          $scope.salRows.push(salRow);
          alignAmount(salRow, -amount);
        } else {
          toaster.pop('error', 'ODL ' + odl.model.code, odlErrMsg({
            service: odl.model.service_id,
            building: odl.model.record_id
          }));
        }
      });
    }
  };
  function getServiceTypeFilter(typeList) {
    if (typeList) {
      var serviceType = {};
      typeList.forEach(function (s) {
        if (s.key == 'da odl') {
          serviceType['extra canone'] = 0;
        } else {
          serviceType[s.key] = 0;
        }
      });
      serviceType = Object.keys(serviceType);
      if (serviceType.length == 1) {
        return serviceType[0];
      }
    }
    return undefined;
  }
  $scope.openAlreadyProcessedRow = function (row) {
    getSalRow(row.duplicated_row_id.map(function (i) {
      return i.UUID;
    })).then(function (response) {
      var dialogScope = {
        row: response
      };
      var opts = {
        name: 'salOldRowDialog',
        closeByDocument: true,
        width: '80%',
        plain: false
      };
      // N.B. 'dialogTemplate.html' è definito come <script type="text/ng-template"> nel file sal_new.html
      dialogService.templateDialog('dialogOldRowTemplate.html', dialogService.DIALOG_TYPE.INFO, dialogScope, opts, -1, false);
    });
  };
  $scope.canSave = function () {
    if ($scope.salRows.length > 0) {
      if ($scope.salRows.findIndex(function (r) {
        return r.plafond && r.plafond.residual < 0;
      }) < 0) {
        return true;
      }
      return authFactory.checkPerm('SAL', 'negative_residual');
    }
    return false;
  };
  $scope.saveWithDialog = function () {
    if (!checkPreSave()) {
      showSaveDialog();
    } else {
      $scope.saveAll();
    }
  };
  $scope.saveAll = function () {
    $log.log('saveAll');
    var toSave = filterToSave();
    _save(toSave);
  };
  $scope.saveOnlyDirty = function () {
    var dirty = getDirty();
    var canone = filterCanone();
    var extraCanoneOdl = filterExtraCanoneOdl();
    var toSave = filterToSave(dirty.concat(canone).concat(extraCanoneOdl));
    _save(toSave);
  };
  function _save(rows) {
    var aggs = $scope.salConfiguration.aggregations.map(function (a) {
      return a.code;
    });
    var odlList = [],
      negativePlafond = authFactory.checkPerm('SAL', 'negative_residual');
    rows.forEach(function (row) {
      if (row.odl) {
        odlList.push(row.odl);
      }
      delete row.$$hashKey;
      delete row.odl;
      if (negativePlafond) {
        delete row.plafond;
      }
    });
    salFactory.save({
      from: $scope.salConfiguration.from,
      to: $scope.salConfiguration.to,
      code: $scope.salConfiguration.code,
      description: $scope.salConfiguration.description,
      emails: $scope.salConfiguration.emails,
      aggregations: aggs,
      rows: rows
    }).$promise.then(function (response) {
      if (!response.hasErrors) {
        toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito correttamente');
        updateOdl(response.result.header, odlList);
        $scope.jasperReport();
        $scope.goToSalList();
      } else {
        dialogService.serviceResponse('Esito SAL', response, true);
      }
    })["catch"](function (response) {
      toaster.pop('error', 'Errore salvataggio', 'Salvataggio fallito');
    });
  }
  function updateOdl(salHeader, odlList) {
    if (odlList.length) {
      var headerRef = {
        UUID: salHeader.UUID,
        code: salHeader.model.code,
        description: salHeader.model.description,
        type: salHeader.schemaCode
      };
      odlList.forEach(function (odl) {
        odl.invoice_id = headerRef;
      });
      odlFactory().bulkUpdateOdl(odlList).$promise.then(function (response) {
        toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito correttamente');
      })["catch"](function (response) {
        toaster.pop('error', 'Errore salvataggio', 'Salvataggio ODL fallito');
      });
    }
  }
  function getSalConfiguration() {
    if ($routeParams.salConf == 'empty') return;
    salConfigurationFactory.getByUUID({
      id: $routeParams.salConf
    }).$promise.then(function (response) {
      if (response.list.length > 0) {
        // carico la configurazione...
        var configuration = response.list[0].model;
        if (configuration.serviceType) {
          $scope.salConfiguration.serviceType = angular.isArray(configuration.serviceType) ? configuration.serviceType : [configuration.serviceType];
        }
        $scope.salConfiguration.services = configuration.services || [];
        $scope.salConfiguration.assets = configuration.assets || [];
        $scope.salConfiguration.serviceGroups = configuration.serviceGroups || [];
        $scope.salConfiguration.aggregations = configuration.aggregations || [];
        $scope.salConfiguration.emails = configuration.emails || [];
      } else {
        toaster.pop('warning', 'Caricamento configurazione', 'Impossibile caricare la configurazione');
      }
    })["catch"](function (response) {
      toaster.pop('warning', 'Caricamento configurazione', 'Impossibile caricare la configurazione');
    });
  }
  $scope.jasperReport = function () {
    var reportPrameters = {
      commission: currentContract.code,
      customer: $scope.currentCustomer.code,
      salcode: $scope.salConfiguration.code,
      aggregations: $scope.salConfiguration.aggregations
    };
    salGenerationService.salReport(reportPrameters, $scope.salConfiguration.code + '.pdf');
  };
  var EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  $scope.emailValidation = function (value) {
    return EMAIL_REGEX.test(value) && value.toLowerCase();
  };

  // ***** WATCHES ***** //

  $scope.$watchCollection('salConfiguration.serviceType', function (newVal, oldVal) {
    if (!$scope.isFromOdlMode()) {
      $scope.odl.selected.length = 0;
    }
    $scope.resetSalRows();
  });
  $scope.$watchCollection('salConfiguration.services', function () {
    $scope.odl.selected.length = 0;
    $scope.resetSalRows();
  });
  $scope.$watchCollection('salConfiguration.assets', function () {
    $scope.odl.selected.length = 0;
    $scope.resetSalRows();
  });
  $scope.$watchCollection('salConfiguration.serviceGroups', function () {
    $scope.odl.selected.length = 0;
    $scope.resetSalRows();
  });
  $scope.$watch('salConfiguration.from', function (newVal, oldVal) {
    if (!newVal) {
      var now = new Date();
      $scope.salConfiguration.from = new Date(now.getFullYear(), now.getMonth(), 1);
    }
    $scope.odl.selected.length = 0;
    $scope.resetSalRows();
    adjustDatePicker();
    generateSalCode();
    generateSalDescription();
    isSalGenerable();
  });
  $scope.$watchCollection('odl.selected', function () {
    $scope.resetSalRows();
  });
  $scope.selectOdl = function (selection) {
    $scope.odl.selected = selection;
  };
  $scope.isFromOdlMode = function () {
    return $scope.salConfiguration.serviceType.length == 0 || $scope.salConfiguration.serviceType.filter(function (i) {
      return i.key == 'da odl';
    }).length > 0;
  };
  $scope.openOdlPanel = function () {
    if ($scope.isFromOdlMode()) {
      $rootScope.$broadcast('closeSixLookup2', {
        id: 'odl_panel'
      });
      $scope.$broadcast('reload', $scope.odl.selected);
      return true;
    }
  };

  // ***** redirects ***** //
  $scope.goToSalList = function () {
    $location.path('sal');
  };
  $scope.isCustomerMissing = function () {
    return angular.isUndefined($scope.currentCustomer) || $scope.currentCustomer == null;
  };
  function loadContract() {
    return contractFactory().recordByCommission().$promise.then(function (responseRecord) {
      if (responseRecord.model && responseRecord.model.sal_period) {
        salPeriod = responseRecord.model.sal_period;
      }
      return responseRecord;
    });
  }
  function loadCustomerInfo() {
    if ($scope.currentCustomer) {
      return recordFactory('cliente').byUUID({
        id: $scope.currentCustomer.code
      }).$promise.then(function (response) {
        $scope.currentCustomerInfo = response.model;
      })["catch"](function (response) {
        toaster.pop('warning', '', 'Impossibile trovare le informazioni del cliente');
      });
    }
    return $q.reject("select customer");
  }
  function loadAcquisition() {
    if ($scope.currentCustomer) {
      return acquisitionWizardFactory.getTerminatedByClient({
        id: $scope.currentCustomer.code
      }).$promise.then(function (response) {
        $scope.acquisition = response.result;
      })["catch"](function (response) {
        // error
      });
    }
    return $q.reject("select customer");
  }
  $scope.isSalGenerable = false;
  function isSalGenerable() {
    if ($scope.acquisition && $scope.acquisition.model) {
      var startContractDate = $scope.acquisition.model.start_contract_date;
      var endContractDate = $scope.acquisition.model.end_contract_date;
      if (!startContractDate || !endContractDate) {
        if (!$scope.isSalGenerable) {
          toaster.pop('warning', '', 'Impossibile recuperare le informazioni di inizio e fine contratto');
          $scope.isSalGenerable = true;
        }
      } else {
        var resultStart = compareDate(new Date(startContractDate), $scope.salConfiguration.from) <= 0;
        var resultEnd = compareDate(new Date(endContractDate), $scope.salConfiguration.to) >= 0;
        $scope.isSalGenerable = resultStart && resultEnd;
      }
    }
  }
  function compareDate(date1, date2) {
    var d1 = angular.copy(date1); // evito di modificare la data originale
    var d2 = angular.copy(date2); // evito di modificare la data originale

    d1.setHours(0);
    d1.setMinutes(0);
    d1.setSeconds(0);
    d1.setMilliseconds(0);
    d2.setHours(0);
    d2.setMinutes(0);
    d2.setSeconds(0);
    d2.setMilliseconds(0);
    return d1.getTime() - d2.getTime();
  }
  $scope.resetSalRows = function () {
    $scope.salRows.length = 0;
  };
  function adjustDatePicker() {
    if ($scope.salConfiguration.from) {
      $scope.salConfiguration.to = new Date($scope.salConfiguration.from.getFullYear(), $scope.salConfiguration.from.getMonth() + salPeriod, 0);
    } else {
      $scope.salConfiguration.to = null;
    }
  }
  function generateSalCode() {
    if ($scope.form && !$scope.form.salCode.$dirty) {
      $scope.salConfiguration.code = getSalCode({
        contract: currentContract.code,
        customer: $scope.currentCustomerInfo,
        from: $scope.salConfiguration.from,
        to: $scope.salConfiguration.to
      });
    }
  }
  function generateSalDescription() {
    if ($scope.form && !$scope.form.salDescription.$dirty) {
      $scope.salConfiguration.description = getSalDesctription({
        contract: currentContract.code,
        customer: $scope.currentCustomerInfo,
        from: $scope.salConfiguration.from,
        to: $scope.salConfiguration.to
      });
    }
  }
  $scope.hasDirtyRows = function () {
    return getDirty().length > 0;
  };
  function filterCanone(toFilter) {
    toFilter = toFilter || $scope.salRows;
    return toFilter.filter(function (r) {
      return r.service_type === 'canone';
    });
  }
  function filterExtraCanone(toFilter) {
    toFilter = toFilter || $scope.salRows;
    return toFilter.filter(function (r) {
      return r.service_type === 'extra canone';
    });
  }
  function filterExtraCanoneOdl(toFilter) {
    toFilter = toFilter || $scope.salRows;
    return toFilter.filter(function (r) {
      return r.odl_id;
    });
  }
  function filterAlreadyGenerated(toFilter) {
    toFilter = toFilter || $scope.salRows;
    return toFilter.filter(function (r) {
      return angular.isDefined(r.old);
    });
  }
  function filterToSave(toFilter) {
    toFilter = toFilter || $scope.salRows;
    return toFilter.filter(function (r) {
      return angular.isUndefined(r.old);
    });
  }
  function getDirty() {
    return $scope.gridApi.rowEdit.getDirtyRows().map(function (row) {
      return row.entity;
    }).filter(function (row) {
      return !row.odl_id;
    });
  }
  function getZeroAmounts(toFilter) {
    return filterExtraCanone(toFilter).filter(function (r) {
      return r.amount == 0;
    });
  }
  function getNotModified(toFilter) {
    var extra = filterExtraCanone(toFilter);
    var dirty = getDirty();
    return sixObjectLib.diffArray(extra, dirty);
  }
  function getResidualErrors(toFilter) {
    toFilter = toFilter || $scope.salRows;
    return toFilter.filter(function (r) {
      return r.plafond.residual < 0;
    });
  }
  function checkPreSave() {
    return getNotModified().length == 0 && getResidualErrors().length == 0 && getZeroAmounts().length == 0 && filterAlreadyGenerated().length == 0;
  }
  function showSaveDialog() {
    var dialogScope = {
      errors: getResidualErrors().length,
      saveAll: $scope.saveAll,
      saveDirty: $scope.saveOnlyDirty,
      allCount: $scope.salRows.length,
      canoneCount: filterCanone().length,
      extraCanoneCount: filterExtraCanone().length,
      dirtyCount: getDirty().length,
      zeroAmountCount: getZeroAmounts().length,
      notModifiedCount: getNotModified().length,
      alreadyGeneratedCount: filterAlreadyGenerated().length,
      extraCanoneOdlToSaveCount: filterExtraCanoneOdl().length,
      extraCanoneToSaveCount: filterToSave(filterExtraCanone()).length,
      canoneToSaveCount: filterToSave(filterCanone()).length,
      dirtyToSaveCount: filterToSave(getDirty()).length,
      allToSaveCount: filterToSave().length
    };
    var opts = {
      name: 'salSaveDialog',
      closeByDocument: false,
      width: '50%',
      plain: false
    };
    // N.B. 'dialogTemplate.html' è definito come <script type="text/ng-template"> nel file sal_new.html
    dialogService.templateDialog('dialogTemplate.html', dialogService.DIALOG_TYPE.WARNING, dialogScope, opts, -1, false);
  }
  $scope.showOrder = function (salRow) {
    dialogService.closeDialog();
    getOrder(salRow.order_id.UUID).then(function (order) {
      if (!order) return;
      var dialogScope = {
          order: order.model
        },
        opts = {
          name: 'orderDialog',
          width: 300,
          plain: false,
          overlay: false,
          closeByNavigation: true
        };
      dialogService.templateDialog('consip/sal/order_dialog.html', dialogService.DIALOG_TYPE.INFO, dialogScope, opts, -1, false);
    });
  };
  var orderCache = {};
  function getOrder(uuid) {
    if (!orderCache[uuid]) {
      orderCache[uuid] = orderRowFactory.getByUUID({
        id: uuid
      }).$promise.then(function (response) {
        if (response.model) {
          return response;
        }
        return $q.reject();
      })["catch"](function (err) {
        toaster.pop('error', '', 'Imossibile trovare l\'ordine');
        delete orderCache[uuid];
      });
    }
    return orderCache[uuid];
  }
  var rowCache = {};
  function getSalRow(uuid) {
    if (angular.isArray(uuid)) {
      return $q.all(uuid.map(getSalRow));
    }
    if (!rowCache[uuid]) {
      rowCache[uuid] = salFactory.getByUUID({
        id: uuid
      }).$promise.then(function (response) {
        if (response.model) {
          return response;
        }
        return $q.reject();
      })["catch"](function (err) {
        toaster.pop('error', '', 'Imossibile trovare il SAL');
        delete rowCache[uuid];
      });
    }
    return rowCache[uuid];
  }
  $scope.showOdl = function (salRow) {
    dialogService.closeDialog();
    var dialogScope = {
        odl: salRow.odl
      },
      opts = {
        name: 'odlDialog',
        width: 300,
        plain: false,
        overlay: false,
        closeByNavigation: true
      };
    dialogService.templateDialog('consip/sal/odl_dialog.html', dialogService.DIALOG_TYPE.INFO, dialogScope, opts, -1, false);
  };

  // ***** _main ***** //
  loadContract().then(function () {
    loadCustomerInfo().then(function () {
      loadAcquisition().then(function () {
        adjustDatePicker();
        generateSalCode();
        generateSalDescription();
        isSalGenerable();
      });
      initGridColumns();
      getSalConfiguration();
    });
  });
}]);
'use strict';

angular.module('emma.consip').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/salnew/loose/:salConf', {
    templateUrl: 'consip/sal/sal_new_loose.html',
    controller: 'SalGenerationLooseCtrl'
  });
}]).controller('SalGenerationLooseCtrl', ["$scope", "$routeParams", "$location", "toaster", "dialogService", "authFactory", "salGenerationService", "plafondSrv", "uiGridConstants", function ($scope, $routeParams, $location, toaster, dialogService, authFactory, salGenerationService, plafondSrv, uiGridConstants) {
  $scope.visiblePanel = {
    sal: true
  };
  $scope.dateOptions = {
    formatYear: 'yyyy',
    startingDay: 1,
    datepickerMode: 'month',
    minMode: 'month',
    maxMode: 'year'
  };
  $scope.dateFormat = 'MMMM yyyy';
  $scope.isSalGenerable = false;
  $scope.currentCustomer = authFactory.getCurrentCustomer();
  $scope.salConfiguration = {
    aggregations: ['model.service_id.code']
  };
  $scope.salRows = [];
  $scope.viewGridOptions = {
    expandableRowTemplate: '<div class="h-full w-full">\
      <textarea class="form-control w-full" style="resize:none; height: 100%;" ng-model="row.entity.note" placeholder="Note"\
        ng-change="grid.api.rowEdit.setRowsDirty([row.entity])"></textarea>\
      </div>',
    expandableRowHeight: 120,
    rowHeight: 35,
    enableExpandableRowHeader: false,
    enableGridMenu: true,
    enableFiltering: true,
    enableCellEdit: false,
    showColumnFooter: true,
    rowEditWaitInterval: -1,
    onRegisterApi: function onRegisterApi(gridApi) {
      $scope.gridApi = gridApi;
      var canInsertNegativeRow = authFactory.checkPerm('SAL', 'negative_row');
      gridApi.edit.on.afterCellEdit($scope, function (rowEntity, colDef, newValueStr, oldValue) {
        var newValue = parseFloat(newValueStr) || 0;
        if (newValue < 0 && !canInsertNegativeRow) {
          dialogService.dialog('Permesso negato', 'l\'importo non può essere negativo', 'warning', -1);
          rowEntity.amount = oldValue;
        } else {
          rowEntity.amount = newValue;
        }
      });
    },
    data: 'salRows',
    columnDefs: [{
      displayName: '',
      field: 'id',
      enableColumnMenu: false,
      enableFiltering: false,
      enableSorting: false,
      enableColumnResizing: false,
      enableHiding: false,
      width: 40,
      cellTemplate: '<div class="ui-grid-cell-contents text-center">\
          <a ng-click="grid.api.expandable.toggleRowExpansion(row.entity)" class="btn btn-rounded btn-xs btn-icon btn-{{row.isExpanded? \'default\' : \'info\'}}"\
          ng-class="{shadow: row.entity.note}">\
          <i class="fa fa-pencil-square-o"></i>\
          </a>\
          </div>'
    }, {
      displayName: 'Cod. Servizio',
      field: 'service_id.code'
    }, {
      displayName: 'Descr. Servizio',
      field: 'service_id.description'
    }, {
      displayName: 'Importo',
      field: 'amount',
      enableCellEdit: true,
      cellFilter: 'currency:"€":3',
      footerCellFilter: 'currency:"€":3',
      cellClass: 'toedit',
      aggregationType: function aggregationType() {
        if ($scope.salRows.length > 0) {
          try {
            return $scope.salRows.map(function (row) {
              return row.amount;
            }).reduce(function (total, amount) {
              return total + amount;
            });
          } catch (error) {
            console.error(error);
          }
        }
        return 0;
      },
      filters: [{
        placeholder: 'da...',
        condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
      }, {
        placeholder: 'a...',
        condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
      }]
    }, {
      displayName: '',
      field: 'id',
      width: 70,
      enableColumnMenu: false,
      enableFiltering: false,
      enableSorting: false,
      enableColumnResizing: false,
      enableHiding: false,
      cellTemplate: '<div class="ui-grid-cell-contents text-center">' + '  <a ng-click="grid.appScope.removeRow(row.entity, grid.api)" class="btn btn-rounded btn-xs btn-icon btn-danger">' + '    <i class="fa fa-trash"></i>' + '  </a>' + '  <a ng-click="grid.appScope.showInvoice(row.entity)" ng-if="row.entity.invoice" class="btn btn-rounded btn-xs btn-icon btn-primary">' + '    <i class="fa fa-eur"></i>' + '  </a>' + '  <a ng-click="grid.appScope.showOdl(row.entity)" ng-if="row.entity.odl" class="btn btn-rounded btn-xs btn-icon btn-primary">' + '    <i class="fa fa-wrench"></i>' + '  </a>' + '</div>'
    }]
  };
  $scope.getSalAmount = function () {
    try {
      var col = $scope.gridApi && $scope.gridApi.grid.getColumn('amount');
      if (col) {
        return col.getAggregationValue();
      }
    } catch (error) {
      console.error(error);
    }
    return 0;
  };
  $scope.isCustomerMissing = function () {
    return !$scope.currentCustomer;
  };
  $scope.onCloseOdl = function () {
    $scope.visiblePanel.odl = false;
    $scope.visiblePanel.sal = true;
  };
  $scope.selectOdl = function (selection) {
    $scope.onCloseOdl();
    $scope.salRows = selection.filter(function (odl) {
      return $scope.salRows.findIndex(function (row) {
        return row.odl_id && row.odl_id.UUID == odl.UUID;
      }) < 0;
    }).map(function (odl) {
      var amount = odl.consumptives.filter(function (item) {
        return item.model.status == 'approved';
      })[0].model.total;
      return {
        odl: odl,
        amount: amount,
        odl_id: sixObjectLib.recordToHisRef(odl),
        service_id: odl.model.service_id,
        effective_date: odl.date_closing
      };
    }).concat($scope.salRows);
  };
  $scope.onCloseInvoice = function () {
    $scope.visiblePanel.invoice = false;
    $scope.visiblePanel.sal = true;
  };
  $scope.selectInvoice = function (selection) {
    $scope.onCloseInvoice();
    $scope.salRows = selection.filter(function (invoice) {
      return $scope.salRows.findIndex(function (row) {
        return row.invoice_id && row.invoice_id.UUID == invoice.UUID;
      }) < 0;
    }).map(function (invoice) {
      return {
        invoice: invoice,
        amount: invoice.model.total_price,
        invoice_id: sixObjectLib.recordToHisRef(invoice),
        service_id: invoice.model.service_id,
        effective_date: invoice.model.from
      };
    }).concat($scope.salRows);
  };
  $scope.onAddManualRow = function (service, createAnother) {
    var found = $scope.salRows.find(function (row) {
      return row.type == 'manual' && row.service_id.UUID == service.UUID;
    });
    if (found) {
      toaster.pop('warning', '', 'Esiste già una riga manuale per il servizio ' + service.description);
    } else {
      $scope.salRows.unshift({
        amount: 0,
        service_id: service,
        type: 'manual'
      });
    }
    if (!createAnother) {
      $scope.visiblePanel.manual = false;
      $scope.visiblePanel.sal = true;
    }
  };
  $scope.showOdl = function (salRow) {
    dialogService.closeDialog();
    var dialogScope = {
        odl: salRow.odl
      },
      opts = {
        name: 'odlDialog',
        width: 300,
        plain: false,
        overlay: false,
        closeByNavigation: true
      };
    dialogService.templateDialog('consip/sal/odl_dialog.html', dialogService.DIALOG_TYPE.INFO, dialogScope, opts, -1, false);
  };
  $scope.showInvoice = function (salRow) {
    dialogService.closeDialog();
    var dialogScope = {
        invoice: salRow.invoice.model,
        uuid: salRow.invoice.UUID
      },
      opts = {
        name: 'invoiceDialog',
        width: 300,
        plain: false,
        overlay: false,
        closeByNavigation: true
      };
    dialogService.templateDialog('consip/sal/invoice_dialog.html', dialogService.DIALOG_TYPE.INFO, dialogScope, opts, -1, false);
  };
  $scope.removeRow = function (rowEntity, gridApi) {
    gridApi.rowEdit.setRowsClean([rowEntity]);
    $scope.salRows.splice($scope.salRows.findIndex(function (r) {
      return angular.equals(r, rowEntity);
    }), 1);
  };
  $scope.canSave = function () {
    if ($scope.salRows.length > 0 && $scope.form.$valid) {
      if ($scope.plafond.total - $scope.plafond.turnover - $scope.getSalAmount() >= 0) {
        return true;
      }
      return authFactory.checkPerm('SAL', 'negative_residual');
    }
    return false;
  };
  $scope.saveWithDialog = function (skipPlafondCheck) {
    if (!skipPlafondCheck && $scope.plafond.total - $scope.plafond.turnover - $scope.getSalAmount() < 0) {
      dialogService.confirmDialog('Stai sforando il plafond. Sei sicuro?', function () {
        $scope.saveWithDialog(true);
      });
    } else if ($scope.salRows.filter(function (row) {
      return row.amount == 0;
    }).length > 0) {
      dialogService.confirmDialog('Stai salvando delle righe senza importo. Sei sicuro?', save);
    } else {
      save();
    }
  };
  var EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  $scope.emailValidation = function (value) {
    return EMAIL_REGEX.test(value) && value.toLowerCase();
  };
  function save() {
    salGenerationService.save($scope.salRows.map(function (i) {
      return angular.copy(i);
    }), $scope.salConfiguration).then(function (response) {
      if (!response.hasErrors) {
        toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito correttamente');
        jasperReport();
        $location.path('sal');
      } else {
        dialogService.serviceResponse('Esito SAL', response, true);
      }
    })["catch"](function (response) {
      toaster.pop('error', 'Errore salvataggio', 'Salvataggio fallito');
    });
  }
  function jasperReport() {
    var reportPrameters = {
      commission: $scope.context.contract.code,
      customer: $scope.currentCustomer.code,
      salcode: $scope.salConfiguration.code,
      aggregations: $scope.salConfiguration.aggregations
    };
    salGenerationService.salReport(reportPrameters, $scope.salConfiguration.code + '.pdf');
  }
  ;
  function isSalGenerable() {
    if ($scope.context.acquisition && $scope.context.acquisition.model) {
      var startContractDate = $scope.context.acquisition.model.start_contract_date;
      var endContractDate = $scope.context.acquisition.model.end_contract_date;
      if (!startContractDate || !endContractDate) {
        if (!$scope.isSalGenerable) {
          toaster.pop('warning', '', 'Impossibile recuperare le informazioni di inizio e fine contratto');
          $scope.isSalGenerable = true;
        }
      } else {
        var resultStart = compareDate(startContractDate, $scope.salConfiguration.from) <= 0;
        var resultEnd = compareDate(endContractDate, $scope.salConfiguration.to) >= 0;
        $scope.isSalGenerable = resultStart && resultEnd;
      }
    }
  }
  function compareDate(date1, date2) {
    return moment(date1).startOf('day').diff(moment(date2).startOf('day'), 'days');
  }
  function adjustDatePicker() {
    if ($scope.salConfiguration.from) {
      var month = $scope.salConfiguration.from.getMonth() + ($scope.context.contract.sal_period || 1);
      $scope.salConfiguration.to = new Date($scope.salConfiguration.from.getFullYear(), month, 0);
    } else {
      $scope.salConfiguration.to = null;
    }
  }
  function generateSalCode() {
    if ($scope.form && !$scope.form.salCode.$dirty) {
      $scope.salConfiguration.code = salGenerationService.getSalCode({
        contract: $scope.context.contract.code,
        customer: $scope.context.customerInfo,
        from: $scope.salConfiguration.from,
        to: $scope.salConfiguration.to
      });
    }
  }
  function generateSalDescription() {
    if ($scope.form && !$scope.form.salDescription.$dirty) {
      $scope.salConfiguration.description = salGenerationService.getSalDesctription({
        contract: $scope.context.contract.code,
        customer: $scope.context.customerInfo,
        from: $scope.salConfiguration.from,
        to: $scope.salConfiguration.to
      });
    }
  }
  if ($scope.currentCustomer && $scope.currentCustomer.code) {
    salGenerationService.loadContext($scope.currentCustomer.code, $routeParams.salConf == 'empty' ? null : $routeParams.salConf).then(function (context) {
      $scope.context = context;
      if (context.contract) {
        if (context.salConfiguration) {
          $scope.salConfiguration.emails = context.salConfiguration.emails;
          if (context.salConfiguration.billable_services) {
            $scope.salConfiguration.billable_services = context.salConfiguration.billable_services;
            $scope.billableServices = {
              billable_services: sixFiltersLib["in"]('UUID', context.salConfiguration.billable_services.map(function (service) {
                return service.UUID;
              }))
            };
          }
        } else if ($routeParams.salConf != 'empty') {
          toaster.pop('warning', 'Caricamento configurazione', 'Impossibile caricare la configurazione');
        }
        $scope.$watch('salConfiguration.from', function (newVal) {
          if (!newVal) {
            var now = new Date();
            $scope.salConfiguration.from = new Date(now.getFullYear(), now.getMonth(), 1);
          }
          // $scope.resetSalRows();
          adjustDatePicker();
          generateSalCode();
          generateSalDescription();
          isSalGenerable();
        });
        plafondSrv.getCustomerPlafond().then(function (response) {
          if (response.hasErrors) {
            dialogService.serviceResponce('Plafond', response, false);
          } else {
            $scope.plafond = response.result;
          }
        });
      }
    }, function (err) {
      toaster.pop('error', '', 'Impossibile ottenere le informazioni di contratto');
    });
  }
}]);
'use strict';

angular.module('emma.consip').controller('SalInvoicePanel', ["$scope", "invoiceFactory", "sixGridPaginationConstants", "uiGridConstants", function ($scope, invoiceFactory, sixGridPaginationConstants, uiGridConstants) {
  $scope.params = {
    filters: {}
  };
  $scope.invoiceList = {
    list: []
  };
  $scope.viewGridOptions = {
    exporterMenuCsv: false,
    appScopeProvider: $scope,
    multiSelect: true,
    enableHorizontalScrollbar: true,
    columnDefs: [{
      displayName: 'Codice',
      field: 'model.code',
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS
      }]
    }, {
      displayName: 'Descrizione',
      field: 'model.description',
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS
      }]
    }, {
      displayName: 'Servizio',
      field: 'model.service_id',
      cellFilter: 'reference'
    }, {
      displayName: 'Importo',
      field: 'model.total_price',
      enableFiltering: false,
      cellFilter: 'currency'
    }]
  };
  $scope.onAddInvoice = function () {
    $scope.selectInvoice($scope.params.gridApi.selection.getSelectedRows());
  };
  $scope.loadInvoiceList = function () {
    var payload = {
        page: $scope.params.pageNumber,
        page_size: $scope.params.pageSize,
        sort_fields: $scope.params.sortFields,
        show_revision: false
      },
      filters = angular.merge({
        'model.status': true,
        'invoiced': sixFiltersLib.exists('invoice_id', sixFiltersLib.CONSTRAINTS.ANDNOT)
      }, $scope.params.filters);
    return invoiceFactory.searchInvoice(payload, filters).$promise.then(function (data) {
      $scope.invoiceList.totalResults = data.totalResults;
      $scope.invoiceList.list = data.list;
      return data;
    });
  };
}]);
'use strict';

angular.module('emma.consip').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/sal', {
    templateUrl: 'consip/sal/sal_list.html',
    controller: 'SalListCtrl'
  });
}]).controller('SalListCtrl', ["$scope", "$location", "toaster", "uiGridConstants", "authFactory", "ngDialog", "salFactory", "salConfigurationFactory", "sixGridPaginationConstants", "salWorkflow", "dialogService", "contractFactory", "CONTRACT_TYPES", function ($scope, $location, toaster, uiGridConstants, authFactory, ngDialog, salFactory, salConfigurationFactory, sixGridPaginationConstants, salWorkflow, dialogService, contractFactory, CONTRACT_TYPES) {
  var currentCustomer = authFactory.getCurrentCustomer();
  var customerList = authFactory.getAuthData().info.commissions.current.customers;
  var statusOptions = [];
  $scope.params = {
    pageNumber: 1,
    pageSize: 100,
    totalItems: 0,
    filters: {}
  };
  $scope.listSalRows = {
    list: [],
    totalResults: 0
  };
  $scope.canClose = authFactory.checkPerm('SAL', 'closed');
  $scope.viewGridListSalOptions = {
    enableFiltering: true,
    enableOrdering: true,
    enableHorizontalScrollbar: 1,
    enableRowSelection: $scope.canClose,
    enableRowHeaderSelection: $scope.canClose,
    appScopeProvider: $scope,
    isRowSelectable: function isRowSelectable(row) {
      return row.entity.model.status == 'invoice_opened';
    },
    columnDefs: [{
      displayName: '',
      field: 'id',
      width: 36,
      enableColumnMenu: false,
      enableFiltering: false,
      enableSorting: false,
      enableColumnResizing: false,
      enableHiding: false,
      cellTemplate: '<div class="ui-grid-cell-contents text-center">' + '<a ng-click="grid.appScope.gotoDetail(row)" class="btn btn-xs btn-primary">' + '<span class="fa fa-search"></span>' + '</a>' + '</div>'
    }, {
      displayName: 'Codice SAL',
      field: 'model.code',
      enableFiltering: true,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS
      }]
    }, {
      displayName: 'Descrizione SAL',
      field: 'model.description',
      enableFiltering: true,
      width: 500,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS
      }]
    }, {
      displayName: 'Totale',
      field: 'model.total',
      enableFiltering: true,
      cellClass: 'cont-right',
      cellFilter: 'currency:"€":2'
    }, {
      displayName: 'Data inizio',
      field: 'model.start_date',
      cellClass: 'cont-center',
      cellFilter: 'date:\'dd/MM/yyyy\'',
      enableFiltering: true,
      filters: [{
        type: sixGridPaginationConstants.filterType.DATE,
        relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
        placeholder: 'da...',
        condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
      }, {
        type: sixGridPaginationConstants.filterType.DATE,
        relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
        placeholder: 'a...',
        condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
      }]
    }, {
      displayName: 'Data fine',
      field: 'model.end_date',
      cellClass: 'cont-center',
      cellFilter: 'date:\'dd/MM/yyyy\'',
      enableFiltering: true,
      filters: [{
        type: sixGridPaginationConstants.filterType.DATE,
        relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
        placeholder: 'da...',
        condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
      }, {
        type: sixGridPaginationConstants.filterType.DATE,
        relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
        placeholder: 'a...',
        condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
      }]
    }, {
      displayName: 'Stato',
      field: 'model.status',
      enableFiltering: true,
      filterHeaderTemplate: '<div class="ui-grid-filter-container"><a class="block btn btn-default btn-xs" ng-repeat="colFilter in col.filters" ' + 'ng-click="grid.appScope.buildMultiSelectFilter(colFilter)">Filtro</a></div>',
      filters: [{
        type: sixGridPaginationConstants.filterType.SELECTMULTIPLE,
        selectOptions: statusOptions,
        condition: uiGridConstants.filter.CONTAINS
      }],
      cellTemplate: '<div class="ui-grid-cell-contents" style="vertical-align:middle;">' + '{{grid.appScope.getReadableStatus(row.entity.model.status)}}' + '</div>'
    }]
  };
  $scope.getSelectedRows = function () {
    if ($scope.params.gridApi) {
      return $scope.params.gridApi.selection.getSelectedGridRows();
    }
    return false;
  };
  $scope.closeSal = function () {
    var salCodes = $scope.params.gridApi.selection.getSelectedGridRows().map(function (r) {
      return r.entity.model.code;
    });
    salWorkflow.bulkSetStatus('closed', salCodes).then(function (response) {
      if (response.hasErrors) {
        dialogService.serviceResponse('Chisura SAL', response, true);
      }
    }, function (err) {
      toaster.pop('error', 'Errore', 'Passaggio di stato fallito');
    })["finally"]($scope.getListSal);
  };
  function init() {
    contractFactory().recordByCommission().$promise.then(function (responseRecord) {
      $scope.contract = responseRecord.model || {};
    })["catch"](function () {
      toaster.pop('warning', '', 'Impossibile trovare il contratto');
    });
    loadSalConfigurations();
    loadStatus();
    if (!currentCustomer) {
      //se sono in visualizzazione cross-customer
      $scope.viewGridListSalOptions.columnDefs.push({
        displayName: 'Cliente',
        field: 'customerDescList',
        sixFieldCallback: function sixFieldCallback() {
          return "customer";
        },
        enableFiltering: true,
        filters: [{
          type: sixGridPaginationConstants.filterType.SELECT,
          condition: uiGridConstants.filter.CONTAINS,
          selectOptions: customerList.map(function (customer) {
            return {
              value: customer.uuid,
              label: customer.code + "-" + customer.description
            };
          }),
          placeholder: 'Cliente...'
        }]
      });
    }
  }
  function loadStatus() {
    salWorkflow.getStatuses().then(function (statuses) {
      statusOptions = statuses.map(function (s) {
        statusOptions.push({
          value: s.code,
          label: s.label
        });
      });
    });
  }
  $scope.gotoDetail = function (row) {
    $location.path("/sal/" + row.entity.model.code);
  };
  $scope.getListSal = function () {
    var payload = {
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      query: $scope.params.queryParam,
      sort_fields: $scope.params.sortFields,
      entity: 'salheader'
    };
    return salFactory.search(payload, $scope.params.filters).$promise.then(function (response) {
      $scope.listSalRows.list = response.list || [];
      $scope.listSalRows.totalResults = response.totalResults;
      $scope.listSalRows.list.forEach(function (row) {
        if (row.customer) {
          customerList.forEach(function (customer) {
            if (customer.uuid == row.customer[0]) {
              row.customerDescList = customer.code + "-" + customer.description;
            }
          });
        }
      });
      $scope.params.sixApi.refreshList(response.list);
      return response;
    })["catch"](function (response) {
      toaster.pop('error', 'Errore', 'Errore durante il recupero dei dati');
    });
  };
  $scope.goToNewSal = function (salConf) {
    $location.path(['salnew', salConf && salConf.model.contract_type || $scope.contract && $scope.contract.contract_type || CONTRACT_TYPES.strict, salConf && salConf.UUID || 'empty'].join('/'));
  };
  function loadSalConfigurations() {
    var payload = {
      sort_fields: 'model.description:asc'
    };
    return salConfigurationFactory.fetchall(payload, {}).$promise.then(function (response) {
      if (response.hasErrors) {
        toaster.pop('info', 'Caricamento configurazione', 'Impossibile trovare configurazioni SAL');
      } else {
        $scope.salConfigurations = response.result;
      }
      return response;
    })["catch"](function (response) {
      $scope.salConfigurations = [];
      toaster.pop('info', 'Caricamento configurazione', 'Impossibile trovare configurazioni SAL');
    });
  }
  $scope.getReadableStatus = salWorkflow.getReadableStatus;
  $scope.buildMultiSelectFilter = function (filter) {
    var options = '';
    filter.selectOptions.forEach(function (val, key) {
      options += '<label class="checkbox i-checks m-t-none m-b-none"><input type="checkbox" ' + 'ng-model="ngDialogData.selection[' + key + '].active"><i></i> ' + val.label + '</label>';
    });
    if (Array.isArray(filter.term)) {
      filter.term.forEach(function (term) {
        filter.selectOptions.forEach(function (v, k, opt) {
          if (v.value == term) opt[k].active = true;
        });
      });
    }
    ngDialog.openConfirm({
      name: 'multiSelectFilterDialog',
      closeByDocument: false,
      showClose: true,
      template: '' + '<div style="text-align:center">Seleziona filtri da attivare ' + '</div><br>' + '' + options + '' + '<div class="row" style="text-align:center; clear: both">' + '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ' + 'ng-click="confirm(ngDialogData.selection)">Applica filtro</button>' + '</div>',
      data: {
        selection: filter.selectOptions
      },
      plain: true,
      className: 'ngdialog-theme-default ngdialog-theme-custom'
    }).then(function (selection) {
      filter.term = [];
      selection.forEach(function (sel) {
        if (sel.active) {
          filter.term.push(sel.value);
        }
      });
    });
  };
  init();
}]);
'use strict';

angular.module('emma.consip').filter('odlStatus', ["odlWorkflow", function (odlWorkflow) {
  return odlWorkflow.getReadableStatus;
}]).controller('SalOdlPanel', ["$scope", "$log", "ngDialog", "toaster", "uiGridConstants", "sixGridPaginationConstants", "SalOdlService", function ($scope, $log, ngDialog, toaster, uiGridConstants, sixGridPaginationConstants, SalOdlService) {
  var latestRequest = {};
  $scope.dateClosing = {};
  $scope.params = {
    filters: {}
  };
  $scope.statusFilterOptions = [];
  SalOdlService.getStatusOptions().then(function (status) {
    $log.debug("Loaded workflow status", status);
    status.forEach(function (i) {
      $scope.statusFilterOptions.push(i);
    });
  });
  $scope.$on('reload', function (event, previusSelection) {
    if (!angular.equals(latestRequest, {
      service: angular.copy($scope.salConfiguration.services),
      assets: angular.copy($scope.salConfiguration.assets),
      serviceGroups: angular.copy($scope.salConfiguration.serviceGroups)
    })) {
      $scope.getOdlList();
    }
  });
  $scope.$on('$destroy', $scope.$watch('salConfiguration.to', function (newValue) {
    $scope.dateClosing.date = newValue;
  }));
  $scope.viewGridOptions = {
    enablePagination: false,
    enablePaginationControls: false,
    exporterMenuCsv: false,
    appScopeProvider: $scope,
    multiSelect: true,
    enableHorizontalScrollbar: true,
    isRowSelectable: hasApprovedConsumptive,
    columnDefs: [{
      displayName: 'Codice ODL',
      field: 'model.code',
      width: 150,
      cellClass: cellClass,
      cellTooltip: cellTooltip,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }, {
      name: 'Stato',
      field: 'status',
      width: 100,
      cellClass: cellClass,
      cellTooltip: cellTooltip,
      filterHeaderTemplate: '<div class="ui-grid-filter-container"><a class="block btn btn-default btn-xs" ng-repeat="colFilter in col.filters" ' + 'ng-click="grid.appScope.buildMultiSelectFilter(colFilter)">Filtro</a></div>',
      filters: [{
        type: sixGridPaginationConstants.filterType.SELECTMULTIPLE,
        selectOptions: $scope.statusFilterOptions,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }],
      cellFilter: 'odlStatus'
    }, {
      displayName: 'Desctrizione',
      field: 'model.description',
      width: 150,
      cellClass: cellClass,
      cellTooltip: cellTooltip,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }, {
      displayName: 'Data richiesta',
      field: 'date_requested',
      type: 'date',
      cellFilter: 'date:\'dd/MM/yyyy\'',
      width: 100,
      cellClass: cellClass,
      cellTooltip: cellTooltip,
      filters: [{
        type: sixGridPaginationConstants.filterType.DATE,
        relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
        placeholder: 'da...',
        condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
      }, {
        type: sixGridPaginationConstants.filterType.DATE,
        relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
        placeholder: 'a...',
        condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
      }]
    }, {
      displayName: 'Data inizio lavori',
      field: 'date_handling',
      type: 'date',
      cellFilter: 'date:\'dd/MM/yyyy\'',
      width: 100,
      cellClass: cellClass,
      cellTooltip: cellTooltip,
      filters: [{
        type: sixGridPaginationConstants.filterType.DATE,
        relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
        placeholder: 'da...',
        condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
      }, {
        type: sixGridPaginationConstants.filterType.DATE,
        relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
        placeholder: 'a...',
        condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
      }]
    }, {
      displayName: 'Data chiusura',
      field: 'date_closing',
      type: 'date',
      cellFilter: 'date:\'dd/MM/yyyy\'',
      width: 100,
      cellClass: cellClass,
      cellTooltip: cellTooltip,
      enableFiltering: false
    }, {
      displayName: 'Edificio',
      field: 'model.record_id',
      cellFilter: 'reference',
      enableFiltering: true,
      width: 150,
      cellClass: cellClass,
      cellTooltip: cellTooltip,
      filters: [{
        type: sixGridPaginationConstants.filterType.SIXLOOKUP,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }, {
      displayName: 'Servizio',
      field: 'model.service_id',
      cellFilter: 'reference',
      enableFiltering: true,
      width: 150,
      cellClass: cellClass,
      cellTooltip: cellTooltip,
      filters: [{
        type: sixGridPaginationConstants.filterType.SIXLOOKUP,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }, {
      name: 'Preventivo cliente',
      field: 'customer_estimates',
      enableFiltering: false,
      enableSorting: false,
      width: 150,
      cellClass: cellClass,
      cellTooltip: cellTooltip,
      cellTemplate: '<div class="ui-grid-cell-contents" ng-bind-html="grid.appScope.detectPrice(row.entity.customer_estimates)"></div>'
    }, {
      name: 'Consuntivi',
      field: 'consumptives',
      enableFiltering: false,
      enableSorting: false,
      width: 150,
      cellClass: cellClass,
      cellTooltip: cellTooltip,
      cellTemplate: '<div class="ui-grid-cell-contents" ng-bind-html="grid.appScope.detectPrice(row.entity.consumptives)"></div>'
    }]
  };
  $scope.odlList = {
    list: []
  };
  $scope.getOdlList = function () {
    latestRequest = {
      service: angular.copy($scope.salConfiguration.services),
      assets: angular.copy($scope.salConfiguration.assets),
      serviceGroups: angular.copy($scope.salConfiguration.serviceGroups)
    };
    return SalOdlService.loadOdl($scope.params, $scope.dateClosing.date, $scope.salConfiguration.services || [], $scope.salConfiguration.assets || [], $scope.salConfiguration.serviceGroups || []).then(function (data) {
      $scope.odlList.totalResults = data.totalResults;
      $scope.odlList.list = data.list;
      if ($scope.params.sixApi) $scope.params.sixApi.refreshList(data.list);
      return data;
    })["catch"](function (err) {
      // error
      toaster.pop('error', 'Errore ricerca', 'Ricerca ODL fallita');
    });
  };
  $scope.buildMultiSelectFilter = function (filter) {
    ngDialog.openConfirm({
      name: 'multiSelectFilterDialog',
      closeByDocument: false,
      showClose: true,
      template: '<div style="text-align:center">Seleziona filtri da attivare</div><br>' + '<label ng-repeat="opt in ngDialogData.selection" class="checkbox i-checks m-t-none m-b-none">' + '<input type="checkbox" ng-model="opt.active"><i></i> {{opt.label}}</label>' + '<div class="row text-center" style="clear: both">' + '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ' + 'ng-click="confirm(ngDialogData.selection)">Applica filtro</button>' + '</div>',
      data: {
        selection: filter.selectOptions
      },
      plain: true,
      className: 'ngdialog-theme-default ngdialog-theme-custom'
    }).then(function (selection) {
      filter.term = selection.filter(function (i) {
        return i.active;
      }).map(function (i) {
        return i.value;
      });
    });
  };
  $scope.detectPrice = function (list) {
    var approved_status = 'approved';
    if (typeof list == 'undefined' || list.length == 0) {
      return '';
    }
    var content = '<span class="badge primary pull-right">' + list.length + '</span>';
    if (list.length == 1) {
      var status = list[0].model.status == approved_status ? '<i class="fa fa-check"></i> ' : '';
      content += status + formatPrice(list[0].model.total);
    } else {
      //cerco il primo approvato
      list.forEach(function (item) {
        if (item.model.status == approved_status) {
          var status = '<i class="fa fa-check"></i> ';
          content += status + formatPrice(item.model.total);
          return; //termino il foreach
        }
      });
    }

    return content;
  };
  $scope.onAddOdl = function () {
    $scope.selectOdl($scope.params.gridApi.selection.getSelectedRows());
  };
  function formatPrice(num) {
    if (num) {
      num = Math.round(num * 100) / 100;
      num = num.toFixed(2);
    }
    return num ? num.toString().replace(/\./g, ',') + ' €' : '--';
  }
  function hasApprovedConsumptive(row) {
    if (row.entity.consumptives && row.entity.consumptives.length) {
      return row.entity.consumptives.filter(function (i) {
        return i.model.status == 'approved';
      }).length == 1;
    }
    return false;
  }
  function cellClass(grid, row) {
    if (!hasApprovedConsumptive(row)) {
      return 'red-highlight';
    }
  }
  function cellTooltip(row) {
    if (!row.entity.consumptives || row.entity.consumptives.length == 0) {
      return 'L\'ODL non ha un consuntivo approvato';
    }
    var approved = row.entity.consumptives.filter(function (i) {
      return i.model.status == 'approved';
    });
    if (approved.length == 0) {
      return 'L\'ODL non ha un consuntivo approvato';
    }
    if (approved.length > 1) {
      return 'L\'ODL ha più di un consuntivo approvato';
    }
  }
}]);
'use strict';

angular.module('emma.consip').controller('salStatusCtrl', ['$scope', '$log', 'toaster', 'dialogService', 'salWorkflow', function ($scope, $log, toaster, dialogService, salWorkflow) {
  if (angular.isUndefined($scope.sxShowStatus)) {
    $scope.sxShowStatus = true;
  }
  if (angular.isUndefined($scope.sxShowButtons)) {
    $scope.sxShowButtons = true;
  }
  $scope.list = [];
  $scope.getStatuses = function () {
    /* chiamata per recuperare gli stati */
    salWorkflow.getNextStatuses($scope.sxStatus).then(function (response) {
      if (Array.isArray(response)) {
        $scope.list = response;
        $scope.sxStatusLabel = salWorkflow.getReadableStatus($scope.sxStatus);
      }
    });
  };
  $scope.statusNoteDialog = function (code) {
    $scope.setOperation(code, "");
  };
  $scope.setOperation = function (code, status_note) {
    if (code == 'rejected') {
      dialogService.confirmDialog('Una volta rifiutato, un SAL non potra più cabiare di stato. <br> Sei sicuro di voler rifiutare questo SAL?', function () {
        setStatus(code, status_note);
      });
    } else {
      setStatus(code, status_note);
    }
  };
  function setStatus(code, status_note) {
    console.log("UUID: " + $scope.sxUuid + " --> passa a: " + code);
    if (status_note != "") {
      $scope.sxObject.status_note = status_note;
    }
    if (!angular.isDefined($scope.sxUuid)) {
      toaster.pop('error', 'Errore', 'Salvare il documento prima di effettuare il passaggio di stato');
    } else {
      salWorkflow.setStatus(code, $scope.sxObject, $scope.sxUuid).then(function (updatedObject) {
        //success
        $scope.sxObject = updatedObject;
        if ($scope.sxCallback && angular.isFunction($scope.sxCallback)) {
          $scope.sxCallback();
        }
      }, function () {
        //error
        toaster.pop('error', 'Errore', 'Passaggio di stato fallito');
      });
    }
  }
  $scope.$watch('sxStatus', function (newVal, oldVal) {
    if (newVal && newVal != oldVal) {
      $scope.getStatuses();
    }
  });
}]);

/**
 * @ngdoc directive
 * @name sixEmmaApp.directive:salStatus
 * @description
 * # salStatus
 */
angular.module('emma.consip').directive('salStatus', function () {
  return {
    template: '<div class="input-group has-button m-t" style="width: 100%; display: inline;">' + '<div style="display: inline; margin-left: 30px; margin-right: 30px;" ng-show="sxShowStatus">' + '<span class="btn btn-sm btn-bg btn-default font-bold" style="pointer-events: none;" ng-show="sxStatus">{{sxStatusLabel}}</span>' + '</div>' + '<ui-select ng-show="sxShowButtons && list.length" ng-model="sxStatus" on-select="statusNoteDialog($item.code)" ' + 'style="display: inline-block; vertical-align: middle; position: relative; min-width: 160px;">' + '<ui-select-match class="ui-select-match" placeholder="Cambia Stato">Cambia Stato</ui-select-match>' + '<ui-select-choices class="ui-select-choices" repeat="status in list track by $index">' + '<span class="{{status.style}}" ng-bind-html="status.label"></span>' + '</ui-select-choices>' + '</ui-select>' + '</div>',
    restrict: 'E',
    scope: {
      sxObject: '=',
      sxStatus: '=',
      sxUuid: '=',
      sxShowStatus: '<?',
      sxShowButtons: '<?',
      sxCallback: '&'
    },
    controller: 'salStatusCtrl'
  };
});
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.salWorkflow
 * @description
 * # salWorkflow
 * Service in the sixEmmaApp.
 */
angular.module('emma.consip').service('salWorkflow', ['$q', 'salFactory', 'odlFactory', 'invoiceFactory', 'authFactory', function ($q, salFactory, odlFactory, invoiceFactory, authFactory) {
  //servizio analogo al servizio su plan per gli odl, ma con logiche cablate.
  //in questo modo è predisposto all'introduzione di un workflow editabile

  var self = this;
  var statuses = {
    "generated": "Generato",
    "sent": "Inviato",
    "approved": "Approvato",
    "suspended": "Sospeso",
    "rejected": "Rifiutato",
    "invoice_opened": "Fattura Aperta",
    "closed": "Chiuso",
    "deleted": "Eliminato"
  };
  this.getReadableStatus = function (status) {
    if (statuses[status]) {
      return statuses[status];
    }
    return status;
  };

  //rappresentano gli status che rendono il sal intoccabile
  this.getLockedStatuses = function () {
    return $q.resolve(["approved", "closed", "invoice_opened", "rejected", "deleted"]);
  };
  this.getStatuses = function () {
    return $q.resolve(formatStatusList(Object.keys(statuses)));
  };
  this.getNextStatuses = function (currentStatus) {
    //mappa passaggi di stato ipotetica
    //TODO: i passaggi di stato devono essere profilati, non tutti gli utenti possono effettuare tutti i passaggi di stato
    var statusChanges = {
      "generated": ["sent", "suspended", "deleted"],
      "sent": ["generated", "approved", "rejected"],
      "suspended": ["generated", "approved", "rejected"],
      "approved": ["invoice_opened"],
      "invoice_opened": ["closed", "approved"],
      "rejected": [],
      "closed": ["invoice_opened"],
      "deleted": []
    };
    return $q.resolve(formatStatusList(statusChanges[currentStatus]));
    //al momento è consentito il passaggio da qualsiasi stato a qualsiasi stato
    //return $q.resolve(formatStatusList(Object.keys(statuses)));
  };

  this.setStatus = function (statusCode, headerSal, salUuid) {
    if ((statusCode == 'rejected' || statusCode == 'deleted') && !salUuid) throw "Missing sal UUID parameter";
    return salFactory.setStatus({
      id: headerSal.code,
      status: statusCode
    }, {}).$promise.then(function (response) {
      if (response && response.status == 'ok') {
        headerSal.status = statusCode;
        if (statusCode == 'rejected' || statusCode == 'deleted') {
          return odlFactory().cleanInvoice({
            salUuid: salUuid
          }).$promise.then(function (odlResp) {
            return invoiceFactory.cleanInvoice({
              salUuid: salUuid
            }).$promise.then(function () {
              return headerSal;
            }, function (err) {
              return $q.reject('Errore durante l\'aggiornamento delle prefatture');
            });
          }, function (err) {
            return $q.reject('Errore durante l\'aggiornamento degli ODL');
          });
        }
        return headerSal;
      } else {
        throw 'StatusChangeError';
      }
    });
  };
  this.bulkSetStatus = function (statusCode, salCodes) {
    return salFactory.bulkSetStatus({
      status: statusCode
    }, salCodes).$promise;
  };
  function formatStatusList(stringList) {
    //formatto il dato per retrocompatibilità
    if (Array.isArray(stringList)) {
      return stringList.filter(function (status) {
        switch (status) {
          case 'invoice_opened':
          case 'approved':
          case 'closed':
          case 'deleted':
          case 'rejected':
          case 'suspended':
            return authFactory.checkPerm('SAL', status);
          default:
            return true;
        }
      }).map(function (status) {
        return {
          code: status,
          label: self.getReadableStatus(status),
          style: "neutral"
        };
      });
    }
    return [];
  }
}]);
'use strict';

angular.module('emma.consip').service('plafondSrv', ["$q", "$log", "plafondFactory", "odlFactory", "authFactory", "contractFactory", "acquisitionWizardFactory", function ($q, $log, plafondFactory, odlFactory, authFactory, contractFactory, acquisitionWizardFactory) {
  var service = {};
  service.getContractPlafond = function () {
    return getContract().then(function (contract) {
      return acquisitionWizardFactory.getUsedPlafond().$promise.then(function (data) {
        return {
          total: contract.model.plafond_total,
          used: data.result,
          residual: contract.model.plafond_total - data.result
        };
      });
    });
  };
  service.getContractReport = function () {
    return $q.all([getContract(), plafondFactory.commissionReport().$promise]).then(function (responses) {
      if (!responses[1].hasErrors) {
        responses[1].result.contract = responses[0];
      }
      return responses[1];
    });
  };
  service.getCustomerPlafond = function () {
    return plafondFactory.get().$promise;
  };
  service.getPlafond = function (serviceUUID, asset) {
    $log.info("Loading opf and sal", serviceUUID, asset);
    return plafondFactory.getPlafond({}, {
      service: serviceUUID,
      asset: asset
    }).$promise.then(function (response) {
      if (response.result.service_type == 'extra canone') {
        return service.getConstrain(serviceUUID, asset).then(function (constrain) {
          return {
            total: response.result.plafond,
            used: response.result.used,
            constrain: constrain,
            residual: response.result.plafond - response.result.used
          };
        });
      }
      return {
        total: response.result.plafond,
        used: response.result.used,
        residual: response.result.plafond - response.result.used
      };
    });
  };

  // plafond impegnato
  service.getConstrain = function (serviceUUID, asset) {
    var filters = {
      generated_by: sixFiltersLib.exact('generated_by', 'issue'),
      building: sixFiltersLib.exact('model.type_id.code', 'edificio'),
      invoiced: sixFiltersLib.exists('invoice_id', sixFiltersLib.CONSTRAINTS.ANDNOT)
    };
    if (serviceUUID) {
      filters.service_UUID = sixFiltersLib.exact('model.service_id.UUID', serviceUUID);
    }
    if (asset) {
      filters.asset_UUID = sixFiltersLib.exact('model.record_id.UUID', asset);
    }
    var payload = {
      page_size: 10000,
      show_revision: false,
      commission: authFactory.getAuthData().info.commissions.current.code,
      enrich: 'dashboard'
    };
    return odlFactory().search(payload, filters).$promise.then(function (data) {
      var constrain = 0;
      data.list.forEach(function (odl) {
        var approved;
        if (angular.isArray(odl.consumptives)) {
          approved = odl.consumptives.filter(function (o) {
            return o.model.status == 'approved';
          });
        }
        if ((!approved || approved.length == 0) && angular.isArray(odl.customer_estimates)) {
          approved = odl.customer_estimates.filter(function (o) {
            return o.model.status == 'approved';
          });
        }
        if (approved && approved.length > 0) {
          constrain += approved[0].model.total;
        }
      });
      return constrain;
    });
  };
  function getContract() {
    return contractFactory().recordByCommission().$promise.then(function (data) {
      if (data.model) {
        return data;
      }
      return $q.reject('Nessuna convenzione definita');
    });
  }
  return service;
}]);
'use strict';

angular.module('emma.consip').service('salGenerationService', ["$http", "$q", "$interpolate", "salFactory", "orderRowFactory", "toaster", "APP_URL", "SaveAs", "contractFactory", "acquisitionWizardFactory", "recordFactory", "salConfigurationFactory", "odlFactory", "invoiceFactory", function ($http, $q, $interpolate, salFactory, orderRowFactory, toaster, APP_URL, SaveAs, contractFactory, acquisitionWizardFactory, recordFactory, salConfigurationFactory, odlFactory, invoiceFactory) {
  var service = {
    aggregationOptions: [{
      code: 'model.asset_id.code',
      description: 'Edificio'
    }, {
      code: 'model.serviceclass_id.code',
      description: 'Classe servizio'
    }, {
      code: 'model.service_id.code',
      description: 'Servizio'
    }]
  };
  service.getSalCode = $interpolate("sal_{{contract}}_{{customer.code}}_{{from | date:'yyyyMMdd'}}_{{to | date:'yyyyMMdd'}}");
  service.getSalDesctription = $interpolate("Sal contratto {{contract}} - cliente {{customer.code}} dal {{from | date:'dd/MM/yyyy'}} al {{to | date:'dd/MM/yyyy'}}");
  service.loadContext = function (customerUuid, salCfgUuid) {
    return contractFactory().recordByCommission().$promise.then(function (contract) {
      return recordFactory('cliente').byUUID({
        id: customerUuid
      }).$promise.then(function (customerInfo) {
        return acquisitionWizardFactory.getTerminatedByClient({
          id: customerUuid
        }).$promise.then(function (acquisition) {
          var contextResponse = {
            contract: contract.model,
            customerInfo: customerInfo.model,
            acquisition: acquisition.result
          };
          if (salCfgUuid) {
            return salConfigurationFactory.getByUUID({
              id: salCfgUuid
            }).$promise.then(function (salConfResponse) {
              if (salConfResponse.list.length > 0) {
                contextResponse.salConfiguration = salConfResponse.list[0].model;
              }
              return contextResponse;
            });
          } else {
            return contextResponse;
          }
        });
      });
    });
  };

  /**
   * parameters => {
   *   commission:
   *   customer:
   *   salcode:
   *   assets:
   *   services:
   *   servicegroups:
   *   aggregations:
   * }
   */
  service.salReport = function (parameters, fileName) {
    var query = [''];
    angular.forEach(parameters, function (value, key) {
      if (value) {
        if (angular.isArray(value)) {
          query.push(key + '=' + value.map(function (obj) {
            if (angular.isString(obj)) {
              return obj;
            }
            return obj.code;
          }).join(';'));
        } else if (angular.isString(value)) {
          query.push(key + '=' + value);
        } else if (angular.isObject(value) && value.code) {
          query.push(key + '=' + value.code);
        }
      }
    });
    var _fileName = fileName || 'sal_' + (parameters.commission.code || parameters.commission) + '_' + (parameters.customer.code || parameters.customer) + '.pdf';
    $http.post(APP_URL + '/rest/report/generate', {
      path: 'reports/EMMA/Consip/sal.pdf',
      query: query.join('&')
    }, {
      responseType: 'arraybuffer'
    }).success(function (data, status, headers, config) {
      if (data) {
        SaveAs.download(data, _fileName, {
          type: 'application/pdf'
        });
      } else {
        toaster.pop('error', "Errore", 'Errore generazione del SAL');
      }
    }).error(function (data, status, headers, config) {
      toaster.pop('error', "Errore", 'Errore generazione del SAL');
    });
  };
  service.availableRow = function (filter) {
    return orderRowFactory.search({
      page_size: 10000,
      sort_fields: 'model.data_inizio:desc'
    }, filter).$promise.then(function (response) {
      if (!response.hasErrors) {
        var orderSet = {};
        response.distinctResult = response.list.filter(function (order) {
          var key = order.model.edificio_id.UUID + order.model.servizio_id.UUID;
          if (orderSet[key] === undefined) {
            orderSet[key] = 1;
            return true;
          }
          return false;
        }).map(function (order) {
          var salRow = {
            customer: order.customer,
            commison: order.commison,
            model: {
              effective_date: order.model.data_inizio,
              asset_id: order.model.edificio_id,
              service_id: order.model.servizio_id,
              serviceclass_id: order.model.classeservizio_id,
              acquisition_uuid: order.model.acquisition_uuid,
              service_type: order.model.tipo_servizio,
              um_id: order.model.um_id,
              pu: order.model.pu,
              amount: .0,
              qty: .0
            }
          };
          if (order.model.tipo_servizio == 'canone') {
            salRow.model.order_id = {
              code: order.model.code,
              description: order.model.description,
              UUID: order.UUID,
              type: order.schemaCode || 'orderrow'
            };
          }
          return salRow;
        });
      }
      return response;
    });
  };
  service.generate = function (payload) {
    return salFactory.generate(payload).$promise;
  };
  service.save = function (salRows, salConfiguration) {
    var odlList = [],
      invoiceList = [],
      rows = salRows.map(function (row) {
        if (row.odl) {
          odlList.push(row.odl);
        }
        if (row.invoice) {
          invoiceList.push(row.invoice);
        }
        var copy = angular.copy(row);
        delete copy.odl;
        delete copy.invoice;
        return copy;
      });
    return salFactory.save(angular.extend({
      rows: rows
    }, salConfiguration)).$promise.then(function (response) {
      if (!response.hasErrors) {
        return $q.all([updateOdl(response.result.header, odlList), updateInvoice(response.result.header, invoiceList)]).then(function () {
          return response;
        }, function (err) {
          if (odlList.length) {
            odlFactory().cleanInvoice({
              salUuid: response.result.header.UUID
            });
          }
          if (invoiceList.length) {
            invoiceFactory.cleanInvoice({
              salUuid: response.result.header.UUID
            });
          }
          salFactory["delete"]({
            verb: '_hard',
            id: response.result.header.version,
            entity: 'salheader'
          });
        });
      } else {
        return response;
      }
    });
  };
  function updateOdl(salHeader, odlList) {
    if (odlList.length) {
      var headerRef = sixObjectLib.recordToHisRef(salHeader);
      odlList.forEach(function (odl) {
        odl.invoice_id = headerRef;
      });
      return odlFactory().bulkUpdateOdl(odlList).$promise;
    }
    return $q.resolve('nothing to do');
  }
  function updateInvoice(salHeader, invoiceList) {
    if (invoiceList.length) {
      var headerRef = sixObjectLib.recordToHisRef(salHeader);
      invoiceList.forEach(function (invoice) {
        invoice.invoice_id = headerRef;
      });
      return invoiceFactory.bulkUpdate(invoiceList).$promise;
    }
    return $q.resolve('nothing to do');
  }
  return service;
}]);
'use strict';

angular.module('emma.plan').service('SalOdlService', ["odlWorkflow", "authFactory", "odlFactory", function (odlWorkflow, authFactory, odlFactory) {
  var service = {};
  service.getStatusOptions = function () {
    return odlWorkflow.getStatuses().then(function (statuses) {
      return statuses.map(function (s) {
        return {
          value: s.code,
          label: s.label
        };
      });
    });
  };
  service.loadOdl = function (params, dateClosing, services, assets, serviceGroups) {
    var filters = angular.copy(params.filters);
    filters.generated_by = sixFiltersLib.exact('generated_by', 'issue');
    filters.building = sixFiltersLib.exact('model.type_id.code', 'edificio');
    filters.invoiced = sixFiltersLib.exists('invoice_id', sixFiltersLib.CONSTRAINTS.ANDNOT);
    if (dateClosing) {
      filters.date_closing = sixFiltersLib.must({
        lte: sixFiltersLib.rangeLte('date_closing', dateClosing, sixFiltersLib.CONSTRAINTS.OR),
        missing: sixFiltersLib.missing('date_closing', sixFiltersLib.CONSTRAINTS.OR)
      });
    }
    if (services.length > 0) {
      filters.service_id = sixFiltersLib["in"]('model.service_id.UUID', services.map(function (obj) {
        return obj.UUID;
      }));
    }
    if (assets.length > 0) {
      filters.asset = sixFiltersLib["in"]('model.record_id.UUID', assets.map(function (obj) {
        return obj.UUID;
      }));
    }
    var payload = {
      page_size: 200,
      sort_fields: params.sortFields,
      show_revision: false,
      commission: authFactory.getAuthData().info.commissions.current.code,
      enrich: 'dashboard'
    };
    return odlFactory().search(payload, filters).$promise.then(function (data) {
      var odlList = filterResult(data.list, serviceGroups.map(function (obj) {
        return obj.UUID;
      }));
      return {
        totalResults: odlList.length,
        list: odlList
      };
    });
  };
  function filterResult(response, serviceGroups) {
    return response.filter(function (record) {
      return angular.isDefined(record.consumptives);
    }).filter(function (record) {
      return serviceGroups.length == 0 || serviceGroups.indexOf(record.service_group_id.UUID) >= 0;
    });
  }
  return service;
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.stepToWizardService
 * @description
 * # stepToWizardService
 * Service in the sixEmmaApp.
 */
angular.module('emma.consip').service('stepToWizardService', function () {
  // private variable
  var _pdiModel = {};
  var _pdiIndex = -1;
  var _pdiSchema = {};
  var _pdiForm = {};
  var _initPdiCallback = undefined;
  var _opfModel = {};
  var _opfIndex = -1;
  var _opfSchema = {};
  var _opfForm = {};
  var _initOpfCallback = undefined;
  var _saveCallback = undefined;
  var _lockStepCallback = undefined;
  var _unlockStepCallback = undefined;

  // public API
  this.pdiModel = _pdiModel;
  this.pdiIndex = _pdiIndex;
  this.pdiSchema = _pdiSchema;
  this.pdiForm = _pdiForm;
  this.initPdiCallback = _initPdiCallback;
  this.opfModel = _opfModel;
  this.opfIndex = _opfIndex;
  this.opfSchema = _opfSchema;
  this.opfForm = _opfForm;
  this.initOpfCallback = _initOpfCallback;
  this.saveCallback = _saveCallback;
  this.lockStepCallback = _lockStepCallback;
  this.unlockStepCallback = _unlockStepCallback;
  this.beforeApproval = angular.identity;
});
"use strict";

(function () {
  'use strict';

  angular.module('emma.consip').config(["$routeProvider", function ($routeProvider) {
    $routeProvider.when('/tasklog', {
      templateUrl: 'consip/tasklog/tasklog_list.html',
      controller: 'TaskLogCtrl'
    });
  }]).controller('TaskLogCtrl', ["$scope", "dialogService", "salFactory", "authFactory", function ($scope, dialogService, salFactory, authFactory) {
    var commissionCode = authFactory.getAuthData().info.commissions.current.code;
    $scope.taskList;
    function getData() {
      return salFactory.taskList({}).$promise;
    }
    function init() {
      getData().then(function (resp) {
        $scope.taskList = resp.list;
      });
    }
    $scope.getStatus = function (task) {
      var resp = "Sconosciuto";
      if (task.elapsed) {
        resp = "Terminato";
      } else if (!task.elapsed) {
        resp = "Avviato";
      } else if (!(task.request && task.response)) resp = "Errore";
      return resp;
    };
    $scope.getStartTime = function (date) {
      var now = moment();
      var d = moment(date);
      var duration = now.diff(d, 'hours');
      if (duration > 48) {
        return d.format('DD/MM/YYYY HH:mm:ss');
      } else {
        return d.fromNow();
      }
    };
    $scope.getElapsed = function (elapsed) {
      if (elapsed / 1000 > 60) return (elapsed / 60000).toString().replace(".", ",") + " Minuti";else return (elapsed / 1000).toString().replace(".", ",") + " Secondi";
    };
    $scope.openDialog = function (task) {
      dialogService.serviceResponse(null, task.response);
    };
    $scope.triggerSalGeneration = function () {
      salFactory.automaticGeneration({}, {
        "commission": commissionCode
      });
    };
    $scope.triggerStatusChange = function () {
      salFactory.automaticStatus({}, {
        "commission": commissionCode
      });
    };
    init();
  }]);
})();
'use strict';

/**
 * @ngdoc controller
 * @author Riccardo Campani
 *         Created on 24/11/2017
 * @name emma.dataset.controller:AssetCalendarCtrl
 * @description
 * #AssetCalendarCtrl
 * Controller of the emma.dataset
 *
 *
 * EXTERNAL COMPONENTS:
 *    boostrap-year-calendar ~> http://www.bootstrap-year-calendar.com/#Documentation
 */
angular.module('emma.dataset').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/assetcalendar', {
    templateUrl: 'dataset/assetcalendar/assetcalendar.html',
    controller: 'AssetCalendarCtrl'
  }).when('/assetcalendar/:importmode', {
    templateUrl: 'dataset/assetcalendar/assetcalendar_import.html',
    controller: 'AssetCalendarCtrl'
  });
}]).controller('AssetCalendarCtrl', ["$scope", "$location", "$timeout", "$route", "$window", "$routeParams", "$q", "authFactory", "schemaFactory", "recordFactory", "assetcalendarFactory", "lookupFactory", "errorService", "modelIconService", "toaster", "treeUtilities", "DATA_SET_URL", "ngDialog", "recordWSFactory", function ($scope, $location, $timeout, $route, $window, $routeParams, $q, authFactory, schemaFactory, recordFactory, assetcalendarFactory, lookupFactory, errorService, modelIconService, toaster, treeUtilities, DATA_SET_URL, ngDialog, recordWSFactory) {
  /******************** VARIABLES ********************/
  var currentCommission = authFactory.getAuthData().info.commissions.current;
  var urlParams = $location.search();
  var CONFRONT_MODE = {
    STRICT: 'strict',
    LOOSE: 'loose'
  };
  $scope.errorCount = -1;
  $scope.bool = {
    commissionCalendar: angular.isDefined(urlParams.commissionCalendar) ? JSON.parse(urlParams.commissionCalendar) : true,
    gridViewMode: false,
    showSingleEvent: $routeParams.importmode == "single",
    showImportXls: $routeParams.importmode == "importxls",
    showOpeningView: $routeParams.importmode == "openingview",
    importHasData: false,
    showDeleteButton: angular.isDefined(urlParams.date)
  };
  $scope.opt = {
    model: {
      type_id: {},
      record_id: {
        UUID: null
      },
      record_id_list: []
    },
    openingDate: today()
  };
  $scope.gridDates = {
    fromDate: new Date(fromDate(today().getFullYear().toString())),
    toDate: new Date(toDate(today().getFullYear().toString()))
  };
  $scope.importGridOptions = {
    onRegisterApi: function onRegisterApi(gridApi) {
      $scope.xlsGridApi = gridApi;
    }
  };
  $scope.params = {
    pageNumber: 1,
    pageSize: 10000,
    totalItems: 0,
    queryParam: undefined,
    filters: {}
  };
  $scope.viewGridOptions = {
    enableSorting: false,
    enableGridMenu: true,
    enableRowSelection: false,
    enableRowHeaderSelection: false,
    paginationPageSizes: [],
    exporterCsvColumnSeparator: ';',
    enableFiltering: false,
    enableColumnResizing: true,
    paginationPageSize: $scope.params.pageSize,
    columnDefs: [{
      name: ' '
    }]
  };
  $scope.gridCustomFilters = {
    statusFilter: {
      key: null,
      description: 'Tutti gli stati'
    },
    extraordinaryFilter: {
      key: null,
      description: 'Tutti gli eventi'
    }
  };
  $scope.toSave = {
    startDate: today(),
    endDate: today(),
    commission: currentCommission.code,
    status: {
      key: 'open',
      description: 'Aperto'
    },
    type: {
      key: 'r',
      description: 'Evento con durata indefinita'
    },
    description: '',
    extraordinary: {
      key: false,
      description: 'Evento ordinario'
    },
    timeSlots: []
  };
  $scope.savemode = {
    key: 'keep',
    description: 'Mantieni eventi futuri'
  };
  $scope.typeIdFilter = null;
  treeUtilities.getFlatStructureUuids().then(function (types) {
    if (types) {
      $scope.typeIdFilter = {
        'typeIdFilter': sixFiltersLib["in"]('UUID', types)
      };
    }
  });
  $scope.calendarDataSource = {
    list: []
  };
  $scope.calendarEvent = {
    list: [{
      key: "Apertura",
      value: 'open'
    }, {
      key: "Chiusura",
      value: 'closed'
    }],
    selected: undefined
  };

  /**
   * @description
   * Prepara i parametri da passare tra una pagina e l'altra
   * @returns {Object}
   */
  $scope.getPageChangedParams = function () {
    return {
      commissionCalendar: $scope.bool.commissionCalendar,
      opt: JSON.stringify($scope.opt)
    };
  };
  $scope.calendarOptions = {
    language: "it",
    enableRangeSelection: false,
    /**
     * @description
     * Gestisce il render custom dei giorni del componente angular-year-calendar
     * @param element
     * @param date
     */
    customDayRenderer: function customDayRenderer(element, date) {
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      if (date.getTime() === today.getTime()) {
        jQuery(element).css('background-color', '#1199C4');
        jQuery(element).css('color', '#FFFFFF');
      }
      jQuery(element).css('border-bottom', '1px solid #1199C4');
      jQuery(element).css('border-radius', '0%');
      if (!isNullOrUndefined($scope.calendarDataSource) && $scope.calendarDataSource.list != []) {
        $scope.calendarDataSource.list.forEach(function (e) {
          if (e.color != null && e.color != undefined) {
            delete e["color"];
          }
          if (date.between(e.startDate, e.endDate)) {
            if (e.name == "Chiusura straordinaria") {
              if (date.getTime() === today.getTime()) {
                jQuery(element).css('background-color', '#C41700');
                jQuery(element).css('color', '#FFFFFF');
              }
              jQuery(element).css('border-bottom', '4px solid #C41700');
            } else if (e.name == "Chiusura ordinaria") {
              if (date.getTime() === today.getTime()) {
                jQuery(element).css('background-color', '#FF9205');
                jQuery(element).css('color', '#FFFFFF');
              }
              jQuery(element).css('border-bottom', '4px solid #FF9205');
            } else if (e.name == "Apertura straordinaria") {
              if (date.getTime() === today.getTime()) {
                jQuery(element).css('background-color', '#1199C4');
                jQuery(element).css('color', '#FFFFFF');
              }
              jQuery(element).css('border-bottom', '4px solid #1199C4');
            }
            jQuery(element).addClass("with-popover").popover({
              trigger: 'hover',
              container: 'body',
              html: true,
              content: '<div class="event-tooltip-content">' + '<div class="event-name" style="font-weight: bold;">' + e.description + '</div>' + '<div class="event-location">' + e.timeSlots + '</div>' + '</div>'
            });
          }
        });
      }
    },
    /**
     * @description
     * Gestisce il click su un giorno del calendario: prepara i parametri da passare alla nuova pagina
     * ed esegue il redirect verso il dettaglio dell'evento in vigore al giorno selezionato.
     * @param evt
     */
    clickDay: function clickDay(evt) {
      var params = $scope.getPageChangedParams();
      params.date = evt.date;
      $scope.goToNewEvent(params);
    },
    /**
     * @description
     * Gestisce l'evento di fine render del componente angular-year-calendar: è anche usata per intercettare
     * il cambio di anno selezionato nel componente
     */
    renderEnd: function renderEnd() {
      var calendarElement = jQuery('#year-calendar-view').data('calendar');
      if (!isNullOrUndefined($scope.currentYear) && !isNullOrUndefined(calendarElement)) {
        if (calendarElement.getYear().toString() != $scope.currentYear.toString()) {
          $scope.getAssetCalendar();
        }
      }
      //fix popover, elimina eventuali popover rimasti
      jQuery('.popover').remove();
    }
  };

  /******************** WATCH ********************/
  /**
   * @description
   * Watch sui dati importati da file .xls e .xlsx
   */
  $scope.$watch(function () {
    return $scope.importGridOptions.xlsData;
  }, function (newValue) {
    if (newValue && newValue.length > 0) {
      $scope.checkAndAddData();
      $scope.getReadableHeader();
    }
  });

  /**
   * @description
   * Watch sulla checkbox "Mostra calendario commessa": si occupa di caricare $scope.opt con i dati corretti
   * in seguito a un cambio di pagina
   */
  $scope.$watch(function () {
    return $scope.bool.commissionCalendar;
  }, function (value) {
    if (!value && angular.isDefined(urlParams.opt)) {
      $scope.opt = JSON.parse(urlParams.opt);
      $scope.opt.openingDate = $scope.opt.openingDate ? new Date($scope.opt.openingDate) : today();
    } else {
      $scope.opt = {
        model: {
          type_id: {},
          record_id: {
            UUID: null
          },
          record_id_list: []
        },
        openingDate: today()
      };
    }
    if ($scope.opt.model.record_id.UUID != null) {
      $scope.opt.model.record_id_list.push($scope.opt.model.record_id);
      $scope.opt.model.record_id_list = removeDuplicates($scope.opt.model.record_id_list);
    }
  });

  /**
   * @description
   * Watch sull'anno selezionato all'interno del componente angular-year-calendar: si occupa di allineare le date selezionate
   * nella vista a griglia con l'anno del componente
   */
  $scope.$watch(function () {
    var calendarElement = jQuery('#year-calendar-view').data('calendar');
    return !isNullOrUndefined(calendarElement) ? calendarElement.getYear() : null;
  }, function (value) {
    if (!isNullOrUndefined(value)) {
      $scope.gridDates.fromDate = new Date(fromDate(value.toString()));
      $scope.gridDates.toDate = new Date(toDate(value.toString()));
    } else {
      $scope.gridDates.fromDate = new Date(fromDate(today().getFullYear().toString()));
      $scope.gridDates.toDate = new Date(toDate(today().getFullYear().toString()));
    }
  });

  /**
   * @description
   * Watch sull'elemento tecnologico scelto dall'utente: ad ogni variazione del valore,
   * carica la lista di asset corrispondenti al tipo scelto.
   */
  $scope.$watch(function () {
    return $scope.opt.model.type_id;
  }, function (newVal, oldVal) {
    if (newVal) {
      $scope.getAssetList();
    } else {
      $scope.searchedAssetList = undefined;
    }
  });

  /******************** GRID FUNCTIONS ********************/
  /**
   * @description
   * Funzione per la traduzione degli header del file importato con excel in un formato più leggibile
   */
  $scope.getReadableHeader = function () {
    $scope.importGridOptions.columnDefs.forEach(function (def) {
      switch (def.field) {
        case "from":
          def.name = "Dal";
          def.cellFilter = 'date:\'dd-MM-yyyy\'';
          break;
        case "to":
          def.name = "Al";
          def.cellFilter = 'date:\'dd-MM-yyyy\'';
          break;
        case "status":
          def.name = "Stato";
          break;
        case "extraordinary":
          def.name = "Evento Straordinario";
          break;
        case "description":
          def.name = "Descrizione";
          break;
        case "timeslots":
          def.name = "Fasce orarie";
          break;
        case "type":
          def.name = "El. Tecnologico";
          break;
        case 'asset':
          def.name = 'Asset';
          break;
      }
    });
  };

  /**
   * @description
   * funzione per la lettura e l'interpretazione dei file .xls importati
   */
  $scope.checkAndAddData = function () {
    var data = [];
    $scope.errorCount = 0;
    var assetsTypeMap = getAssetTypeMap($scope.importGridOptions.xlsData);
    recordFactory().bulkResolve(assetsTypeMap).$promise.then(function (resolvedAssets) {
      $scope.importGridOptions.xlsData.forEach(function (xlsRow, index) {
        var formattedRow = {
          'sx-status': 'OK'
        };
        var from, to;
        var multiDateFieldRegexp = new RegExp(/(\d{2}\/\d{2}\/\d{4}-\d{2}\/\d{2}\/\d{4};?)+/);
        if (/^(aperto|open)$/.test(xlsRow.status.toLowerCase())) {
          /*
           * FORMATTAZIONE STATUS
           * status = 'open';
           * MATCHES:
           * aperto
           * open
           */
          formattedRow["status"] = "open";
        } else if (/^(chiuso|closed)$/.test(xlsRow.status.toLowerCase())) {
          /*
           * FORMATTAZIONE STATUS
           * status = 'closed';
           * MATCHES:
           * chiuso
           * closed
           */
          formattedRow["status"] = "closed";
        } else {
          formattedRow["status"] = xlsRow.status;
          formattedRow['sx-status'] = formattedRow['sx-status'].startsWith('ERRORE') ? formattedRow['sx-status'] + ', "Stato"' : 'ERRORE COLONNA: "Stato"';
          $scope.errorCount++;
        }
        if (/^(no|false|falso)$/.test(xlsRow.extraordinary.toLowerCase())) {
          /*
           * FORMATTAZIONE FLAG EVENTO STRAORDINARIO
           * extraordinary = false;
           * MATCHES:
           * no
           * false
           * falso
           */
          formattedRow["extraordinary"] = false;
        } else if (/^(si|yes|true|vero)$/.test(xlsRow.extraordinary.toLowerCase())) {
          /*
           * FORMATTAZIONE FLAG EVENTO STRAORDINARIO
           * extraordinary = true;
           * MATCHES:
           * si
           * yes
           * true
           * vero
           */
          formattedRow["extraordinary"] = true;
        } else {
          formattedRow["extraordinary"] = xlsRow.extraordinary;
          formattedRow['sx-status'] = formattedRow['sx-status'].startsWith('ERRORE') ? +formattedRow['sx-status'] + ', "Evento Straordinario"' : 'ERRORE COLONNA: "Evento Straordinario"';
          $scope.errorCount++;
        }
        if (xlsRow.timeslots != null && xlsRow.timeslots != undefined) {
          if (/(([01]?[0-9]|2[0-4]):([0-5][0-9])\s?[–\-]\s?([01]?[0-9]|2[0-4]):([0-5][0-9]);\s?)+/.test(xlsRow.timeslots.replace(" ", ""))) {
            /*
             * FORMATTAZIONE FASCE ORARIE
             * timeslots
             * MATCHES:
             * HH:mm-HH:mm;
             * HH:mm - HH:mm;
             */
            var formattedTimeSlots = xlsRow.timeslots.replace(/\s+/g, ""); //removes both single and multiple spaces
            formattedTimeSlots = formattedTimeSlots.replace(/[–\-]/g, "-"); //replaces dash-like characters with "-"
            formattedRow["timeslots"] = formattedTimeSlots;
          } else {
            formattedRow["timeslots"] = xlsRow.timeslots;
            formattedRow['sx-status'] = formattedRow['sx-status'].startsWith("ERRORE") ? formattedRow['sx-status'] + ', "Fasce Orarie"' : 'ERRORE COLONNA: "Fasce Orarie"';
            $scope.errorCount++;
          }
        }
        formattedRow["description"] = xlsRow.description ? xlsRow.description : "";
        if (xlsRow.type) {
          formattedRow["type"] = xlsRow.type;
        }
        if (xlsRow.asset) {
          formattedRow["asset"] = xlsRow.asset.replace(/[–\-]/g, "-");
        }
        if (xlsRow.type && !xlsRow.asset || !xlsRow.type && xlsRow.asset) {
          var missing = xlsRow.type ? 'Asset' : '"El. Tecnologico"';
          formattedRow['sx-status'] = formattedRow['sx-status'].startsWith("ERRORE") ? formattedRow['sx-status'] + ', ' + missing : 'ERRORE COLONNA: ' + missing;
          $scope.errorCount++;
        }

        //controllo asset
        if (resolvedAssets[xlsRow.type]) {
          if (!resolvedAssets[xlsRow.type][xlsRow.asset]) {
            formattedRow["sx-status"] = formattedRow['sx-status'].startsWith("ERRORE") ? formattedRow['sx-status'] + ', Asset (inesistente)' : 'ERRORE COLONNA: Asset (inesistente)';
            $scope.errorCount++;
          } else {
            formattedRow.assetUUID = resolvedAssets[xlsRow.type][xlsRow.asset].UUID;
          }
        } else {
          formattedRow.assetUUID = null;
        }

        /*
         * Controllo date
         * Deve restare come ultimo step poiché il from potrebbe essere nel formato con più date e andrebbe quindi a creare più righe
         * Accetta singoli intervalli con from e to separati nei formati: gg mm aaaa o aaaa mm gg
         * Accetta anche più intervalli sul campo from (e campo to ignorato), gli intervalli devono essere nel formato from-to;from1-to1; ...
         */
        if (multiDateFieldRegexp.test(xlsRow.from)) {
          //import multi-intervallo, genera righe fittizie
          var intervals = xlsRow.from.split(";");
          intervals.forEach(function (interval) {
            if (interval) {
              formattedRow["from"] = normalizeDate(interval.split("-")[0]);
              formattedRow["to"] = normalizeDate(interval.split("-")[1]);
              data.push(angular.copy(formattedRow));
            }
          });
        } else {
          if (from = normalizeDate(xlsRow.from)) {
            formattedRow["from"] = from;
            formattedRow['sx-status'] = 'OK';
          } else {
            formattedRow["from"] = xlsRow.from;
            formattedRow['sx-status'] = formattedRow['sx-status'].startsWith('ERRORE') ? formattedRow['sx-status'] + ', "Dal"' : 'ERRORE COLONNA: "Dal"';
            $scope.errorCount++;
          }
          if (to = normalizeDate(xlsRow.to)) {
            formattedRow["to"] = to;
            if (!formattedRow['sx-status'].startsWith('ERRORE')) formattedRow['sx-status'] = 'OK';
          } else {
            formattedRow["to"] = xlsRow.to;
            formattedRow['sx-status'] = formattedRow['sx-status'].startsWith('ERRORE') ? formattedRow['sx-status'] + ', "Al"' : 'ERRORE COLONNA: "Al"';
            $scope.errorCount++;
          }
          data.push(formattedRow);
        }
      });
      if ($scope.errorCount == 0) {
        //se non ho errori aggiungo la riga, altrimenti avverto l'utente che il formato non è corretto
        $scope.bool.importHasData = true;
        $scope.importGridOptions.data = angular.copy(data);
      } else {
        $scope.bool.importHasData = false;
        $scope.importGridOptions.columnDefs.splice(0, 0, {
          field: 'sx-status'
        });
        $scope.importGridOptions.data = angular.copy(data);
        toaster.pop('error', 'Errore formato righe xls!', 'Sono stati riscontrati degli errori nel formato delle righe del file importato!');
        //$scope.reset();
      }
    });
  };

  function normalizeDate(dateString) {
    var style1 = /(0[1-9]|[12][0-9]|3[01])[–\/\-](0[1-9]|1[012])[–\/\-](\d{4})/; // gg mm aaaa
    var style2 = /(\d{4})[–\/\-](0[1-9]|1[012])[–\/\-](0[1-9]|[12][0-9]|3[01])/; // aaaa mm dd
    if (style1.test(dateString)) {
      return dateString.replace(style1, '$3-$2-$1T00:00:00.000Z');
    } else if (style2.test(dateString)) {
      return dateString.replace(style1, '$1-$2-$3T00:00:00.000Z');
    }
    return false; //data che non so convertire
  }

  /**
   * @description
   * Definisce le collone della grid per la vista tabellare degli eventi
   */
  function setColumnDefs() {
    $scope.viewGridOptions.columnDefs = [];
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Dal',
      field: 'startDate',
      cellTemplate: '<div class="ui-grid-cell-contents">' + '{{ row.entity.startDate | date : dd-MM-yyyy : UTC }}' + '</div>',
      enableFiltering: false
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Al',
      field: 'endDate',
      type: "date",
      cellTemplate: '<div class="ui-grid-cell-contents">' + '{{ row.entity.endDate | date : dd-MM-yyyy : UTC }}' + '</div>',
      enableFiltering: false
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Tipo evento',
      field: 'name',
      cellTemplate: '<div class="ui-grid-cell-contents">' + '{{ row.entity.name }}' + '</div>',
      enableFiltering: false
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Descrizione',
      field: 'description',
      enableFiltering: false
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Fasce orarie',
      field: 'timeSlots',
      enableFiltering: false
    });
  }

  /**
   * @description
   * Trova l'icona da visualizzare in base al tipo di asset passato
   * @param {string} assetType
   * @returns {string} ritorna la classe da dare all'elemento html
   */
  $scope.getIconClbck = function (assetType) {
    return modelIconService.getModelIcon(assetType) || 'fa fa-list';
  };

  /******************** SERVICE FUNCTIONS ********************/

  /**
   * @description
   * NON USARE IN FE
   * Funzione per test di funzionamento del servizio BE utilizzato per il calcolo dei calendari in fase di fatturazione
   */
  $scope.testServiceCalendar = function () {
    var promise = $scope.getServiceCalendar("2018-03-01T00:00:00.000Z", "2018-03-31T00:00:00.000Z", {
      UUID: "AV8BuMI9_gO5H2E2DfUv",
      type: "edificio"
    });
    promise.then(function (response) {
      console.log(response);
    });
  };

  /**
   * @description
   * Interroga il BE per ricevere i dati del calendario da visualizzare
   * @returns {Promise}
   */
  $scope.getAssetCalendar = function () {
    var calendarElement = jQuery('#year-calendar-view').data('calendar');
    $scope.currentYear = !isNullOrUndefined(calendarElement) ? calendarElement.getYear() : today().getFullYear();
    var payload = {
      fromDate: $scope.bool.gridViewMode ? $scope.gridDates.fromDate : fromDate($scope.currentYear),
      toDate: $scope.bool.gridViewMode ? $scope.gridDates.toDate : toDate($scope.currentYear),
      assetType: !isNullOrUndefined($scope.opt.model.type_id.UUID) ? $scope.opt.model.type_id.UUID : null,
      assetUUID: !isNullOrUndefined($scope.opt.model.record_id.UUID) ? $scope.opt.model.record_id.UUID : null
    };
    var filters = $scope.bool.gridViewMode ? angular.copy($scope.gridCustomFilters) : {};
    var promise = assetcalendarFactory.getCalendarFiltered(payload, filters).$promise;
    promise.then(function (response) {
      if (Object.keys(response.list).length == 0) {
        //niente chiavi = calendario non trovato
        toaster.pop('note', 'Calendario non trovato', 'Non è stato trovato alcun calendario per l\'anno selezionato');
      }
      response.list = $scope.getFormattedEvents(response.list);
      $scope.calendarDataSource = response;
      if (!isNullOrUndefined(calendarElement)) {
        calendarElement.setDataSource($scope.calendarDataSource.list);
        calendarElement._render();
      }
      if ($scope.bool.gridViewMode) {
        $scope.params.sixApi.refreshList($scope.calendarDataSource.list);
      }
    });
    return promise;
  };

  /**
   * @description
   * Interroga il BE per ricevere i dati riguardanti l'evento in vigore nella data inserita sul calendario legato all'asset selezionato
   * @param {Date} date ~> REQUIRED
   * @param {string} assetUUID ~> REQUIRED
   */
  $scope.getEventByDate = function (date, assetUUID) {
    var payload = {
      date: date,
      assetUUID: assetUUID
    };
    assetcalendarFactory.getEventByDate(payload).$promise.then(function (response) {
      var currentEventDetail = response.currentEvent;
      $scope.toSave.startDate = new Date(currentEventDetail.startDate);
      $scope.toSave.endDate = null;
      $scope.toSave.commission = currentEventDetail.commission;
      $scope.toSave.status = currentEventDetail.status == "open" ? {
        key: 'open',
        description: 'Aperto'
      } : {
        key: 'closed',
        description: 'Chiuso'
      };
      $scope.toSave.type = currentEventDetail.type == "k" ? {
        key: 'k',
        description: 'Eredita il calendario padre'
      } : {
        key: 'r',
        description: 'Evento con durata indefinita'
      };
      $scope.toSave.description = currentEventDetail.description;
      $scope.toSave.extraordinary = currentEventDetail.extraordinary ? {
        key: true,
        description: 'Evento straordinario'
      } : {
        key: false,
        description: 'Evento ordinario'
      };
      if (currentEventDetail.timeSlots) currentEventDetail.timeSlots.forEach(function (tSlot) {
        var tmp = {};
        tmp.fromH = new Date(tSlot.fromH);
        tmp.toH = new Date(tSlot.toH);
        $scope.toSave.timeSlots.push(tmp);
      });
      if (response.nextEvent && response.nextEvent.startDate) {
        var currentEvEnd = new Date(response.nextEvent.startDate);
        currentEvEnd = new Date(currentEvEnd.setDate(currentEvEnd.getDate() - 1));
        $scope.toSave.endDate = currentEvEnd;
      }
      $scope.oldEvent = angular.copy($scope.toSave); //Mi ricordo della forma 'originale' dell'evento che modifico
      var nextEventDetail = response.nextEvent;
      if (nextEventDetail) {
        $scope.nextEventDetail = {
          startDate: new Date(nextEventDetail.startDate),
          endDate: null,
          commission: nextEventDetail.commission,
          description: nextEventDetail.description,
          status: nextEventDetail.status == "open" ? {
            key: 'open',
            description: 'Aperto'
          } : {
            key: 'closed',
            description: 'Chiuso'
          },
          type: nextEventDetail.type == "k" ? {
            key: 'k',
            description: 'Eredita il calendario padre'
          } : {
            key: 'r',
            description: 'Evento con durata indefinita'
          },
          extraordinary: nextEventDetail.extraordinary ? {
            key: true,
            description: 'Evento straordinario'
          } : {
            key: false,
            description: 'Evento ordinario'
          },
          timeSlots: []
        };
        if (response.eventAfterNextEvent && response.eventAfterNextEvent.startDate) {
          var nextEvEnd = new Date(response.eventAfterNextEvent.startDate);
          nextEvEnd = new Date(nextEvEnd.setDate(nextEvEnd.getDate() - 1));
          $scope.nextEventDetail.endDate = nextEvEnd;
        }
        if ($scope.nextEventDetail.endDate) $scope.nextEventDetail.endDate = moment($scope.nextEventDetail.endDate).format('DD/MM/YYYY');else $scope.nextEventDetail.endDate = $scope.nextEventDetail.type.description;
        nextEventDetail.timeSlots.forEach(function (tSlot) {
          var tmp = {};
          tmp.fromH = new Date(tSlot.fromH);
          tmp.toH = new Date(tSlot.toH);
          $scope.nextEventDetail.timeSlots.push(tmp);
        });
      }
    });
  };

  /**
   * @description
   * Interroga il BE per ricevere i dati degli asset aperti a una specifica data
   */
  $scope.getAssetOpenings = function (assetList) {
    var searchedAssetList = assetList || [];
    if (angular.isDefined($scope.searchedAssetList)) {
      if (!isNullOrUndefined($scope.opt.openingDate)) {
        var date = new Date($scope.opt.openingDate);
        var isoDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString();
        var payload = {
          date: isoDate
        };
        var promise = assetcalendarFactory.getAssetListForEvent(payload, {
          assetList: searchedAssetList,
          event: $scope.calendarEvent.selected.value,
          assetType: $scope.opt.model.type_id.code
        }).$promise;
        promise.then(function (response) {
          console.log(response); //response ha i dati di tutti gli asset aperti in questa data
          if (response.list && response.list.length > 0) {
            $scope.openAssetList = response.list;
          } else {
            toaster.pop("info", "Nessun dato", "Non è stato trovato nessun asset del tipo scelto aperto in questa data!");
          }
        });
      } else {
        toaster.pop("error", "Errore", "Selezionare una data d\'apertura prima di proseguire!");
      }
    } else {
      toaster.pop("error", "Errore", "Selezionare un elemento tecnologico prima di proseguire!");
    }
  };

  /**
   * @description
   * Interroga il BE per ricevere la lista di asset di un determinato tipo
   */
  $scope.getAssetList = function () {
    if ($scope.bool.showOpeningView) {
      //la lista di asset mi serve solo se sono in "Apertura asset"
      var warUrl = DATA_SET_URL + '/api/';
      var path = "record/" + $scope.opt.model.type_id.UUID + "/_lookup";
      var query = {
        query: '',
        history: false,
        page: 1,
        page_size: 10000
      };
      var promise = lookupFactory(warUrl, path).query(query, {}).$promise;
      promise.then(function (resp) {
        if (angular.isDefined(resp) && resp.hasOwnProperty('list')) {
          $scope.searchedAssetList = resp.list.map(function (i) {
            return buildRef(i);
          });
        }
      });
    }
  };

  /**
   * @description
   * Elimina l'evento corrispondente alla data inserita. L'operazione non è reversibile!
   * @param {Date} date
   * @param {Boolean} skipRedirect ~> Opzionale: si può specificare se evitare il redirect alla pagina di visualizzazione grafica del calendario
   */
  $scope.deleteEvent = function (date, skipRedirect) {
    skipRedirect = !isNullOrUndefined(skipRedirect) ? skipRedirect : false;
    var promise = $q.defer();
    var instantlyResolved = true;
    var payload = {
      date: date ? date : $scope.toSave.startDate.toISOString(),
      assetUUID: !isNullOrUndefined($scope.opt.model.record_id.UUID) ? $scope.opt.model.record_id.UUID : null
    };
    if (angular.isDefined($scope.toSave.startDate)) {
      instantlyResolved = false;
      assetcalendarFactory.deleteEvent(payload, {}).$promise.then(function (response) {
        toaster.pop("success", "Successo", "Evento eliminato correttamente!");
        console.log("eliminato: ", response);
      }).then(function () {
        promise.resolve();
      });
      if (!skipRedirect) {
        var params = $scope.getPageChangedParams();
        $scope.goToCalendarView(params);
      }
    } else {
      toaster.pop("error", "Errore validazione", 'I dati inseriti non sono validi!');
    }
    if (instantlyResolved) {
      promise.resolve();
    }
    return promise;
  };

  /**
   * @description
   * Decide come salvare un evento modificato o nuovo ed esegue il salvataggio.
   */
  $scope.saveSingle = function () {
    var payload = {
      assetType: $scope.opt.model.type_id.UUID ? $scope.opt.model.type_id.UUID : null,
      savemode: isNullOrUndefined($scope.toSave.endDate) ? $scope.savemode.key : null
    };
    var assetUuidList = getUuidList($scope.opt.model.record_id_list);
    var newEvent = $scope.getFormattedEventToSave($scope.toSave);
    if ($scope.oldEvent) {
      var promise;
      var oldEvent = $scope.getFormattedEventToSave($scope.oldEvent);
      if (newEvent.startDate > oldEvent.startDate) {
        var payloadForOld = angular.copy(payload);
        payloadForOld.savemode = 'keep'; //forzo la modalità di salvataggio di oldEvent per assicurarmi che non sovrascriva nulla
        if (assetUuidList == null) {
          //niente kill sul calendario di commessa
          oldEvent.status = 'open';
          oldEvent.type = 'r'; //durata indefinita
          oldEvent.extraordinary = false;
          oldEvent.description = "Apertura ordinaria standard";
          oldEvent.timeSlots = [];
        } else {
          oldEvent.type = 'k'; //kill
        }

        promise = $scope.saveEvent(payloadForOld, {
          document: oldEvent,
          assetUuidList: assetUuidList
        }, true).promise;
        promise.then(function () {
          $scope.saveEvent(payload, {
            document: newEvent,
            assetUuidList: assetUuidList
          }, false);
        });
      } else {
        promise = $scope.deleteEvent(oldEvent.startDate, true).promise;
        promise.then(function () {
          $scope.saveEvent(payload, {
            document: newEvent,
            assetUuidList: assetUuidList
          }, false);
        });
      }
    } else {
      $scope.saveEvent(payload, {
        document: newEvent,
        assetUuidList: assetUuidList
      }, false);
    }
  };

  /**
   * @description
   * Esegue la chiamata in POST per il salvataggio di un evento
   * @param {Object} payload ~> payload della chiamata
   * @param toSave ~> documento contenente i dati formattati riguardanti l'evento da salvare
   * @param skipRedirect ~> Opzionale: si può specificare se evitare il redirect alla pagina di visualizzazione grafica del calendario
   */
  $scope.saveEvent = function (payload, toSave, skipRedirect) {
    skipRedirect = angular.isDefined(skipRedirect) ? skipRedirect : false;
    var promise = $q.defer();
    var instantlyResolved = true;
    if ($scope.validateDialog(payload, toSave)) {
      instantlyResolved = false;
      assetcalendarFactory.saveEvent(payload, toSave).$promise.then(function (response) {
        if (errorService.handleError(response)) {
          toaster.pop('success', 'Salvataggio', 'Salvataggio eseguito con successo');
        } else {
          toaster.pop("error", "Errore", "Errore durante il salvataggio");
        }
      }).then(function () {
        promise.resolve();
      });
      if (!skipRedirect) {
        var params = $scope.getPageChangedParams();
        $scope.goToCalendarView(params);
      }
    } else {
      toaster.pop("error", "Errore validazione", 'I dati inseriti non sono validi!');
    }
    if (instantlyResolved) {
      promise.resolve();
    }
    return promise;
  };

  /**
   * @description
   * Esegue formattazione e salvataggio (tramite chiamata in POST) del file importato tramite excel
   */
  $scope.importXls = function () {
    var formattedData = $scope.formatXlsDataToSave($scope.importGridOptions.data);
    if ($scope.validateImport(formattedData)) {
      notifyToDialog().then(function (notify) {
        var payload = {
          savemode: "import"
        };
        if (notify.async) payload["notify_to"] = notify.to;
        var toastInstance = toaster.pop({
          type: 'warning',
          title: 'Upload',
          body: 'Upload file in corso, non ricaricare la pagina.',
          timeout: 0
        });
        return assetcalendarFactory.importEvents(payload, formattedData).$promise.then(function (response) {
          toaster.clear(toastInstance);
          return response;
        });
      }, function () {
        return $q.reject("Operazione annullata");
      }).then(function (response) {
        if (response.status === 'errors') {
          toaster.pop('error', 'Errore', 'Errore durante il salvataggio');
        } else if (response.meta.type === 'async') {
          toaster.pop('success', 'Importazione avviata', 'Importazione avviata. Riceverai una notifica al termine.');
          recordWSFactory.subscribe('import_calendar/' + response.result);
        } else {
          toaster.pop('success', 'Importazione completata', 'L\'importazione è terminata correttamente.');
        }
      })["catch"](function (response) {
        toaster.pop('error', 'Errore', 'Impossibile eseguire l\'importazione: ' + response);
      });
    } else {
      toaster.pop("error", "Errore validazione", "I dati inseriti non sono validi!");
    }
  };
  function notifyToDialog() {
    var notifyData = {
      async: true,
      to: null
    };
    var notifyToDialog = ngDialog.openConfirm({
      name: 'notifyToDialog',
      closeByDocument: false,
      showClose: true,
      data: notifyData,
      template: '' + '<div style="text-align:center"><i class="fa fa-list"></i>&nbsp; Notifica Import Eventi Calendario</div><br>' + '<div class="m-l-n-xxs" style="clear: both">' + '<input type="checkbox" id="async_elaboration" ng-model="ngDialogData.async" style="clear: both" /> <label for="async_elaboration" class="control-label"> Invia via mail</label><br />' + '</div>' + '<div class="row wrapper" style="text-align:center; clear: both" ng-show="ngDialogData.async">' + 'Invia una notifica di completamento al seguente indirizzo:<br>' + '<input class="form-control" type="email" ng-model="ngDialogData.to" placeholder="Indirizzo email"><br />' + '</div>' + '<div class="row" style="text-align:center; clear: both">' + '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ng-click="confirm(ngDialogData)">Continua</button>' + '</div>',
      plain: true,
      className: 'ngdialog-theme-default ngdialog-theme-custom'
    });
    var userFilter = {
      'model.username': sixFiltersLib.exact('model.username', authFactory.getAuthData().authId)
    };
    recordFactory('operatore').search(userFilter).$promise.then(function (resp) {
      if (resp.list) {
        notifyData.to = resp.list[0].model.mail;
      }
    });
    return notifyToDialog;
  }
  function getAssetTypeMap(rows) {
    var map = {};
    rows.forEach(function (row) {
      var key = row.type;
      var val = row.asset;
      if (key) {
        if (!map[key]) {
          map[key] = {};
          map[key][val] = null;
        } else {
          map[key][val] = null;
        }
      }
    });
    return map;
  }

  /******************** DATA FORMAT FUNCTIONS ********************/
  /**
   * @description
   * Formatta i dati usati nel FE in modo che piacciano al BE
   * @param eventToSave ~> dati non formattati dell'evento
   * @returns {Object} ~> versione formattata (per il BE) dei dati inseriti
   */
  $scope.getFormattedEventToSave = function (eventToSave) {
    var toSave = angular.copy(eventToSave);
    //le date vengono tutte impostate a mezzanotte
    if (!isNullOrUndefined(toSave.startDate)) {
      toSave.startDate.setHours(0, 0, 0, 0);
    }
    if (!isNullOrUndefined(toSave.endDate)) {
      toSave.endDate.setHours(0, 0, 0, 0);
    }
    toSave.extraordinary = toSave.extraordinary.key;
    toSave.status = toSave.status.key;
    toSave.type = toSave.type.key;
    toSave.timeSlots.forEach(function (timeSlot) {
      delete timeSlot["$$hashKey"]; //robaccia di angular
      timeSlot.fromH = new Date(timeSlot.fromH).toISOString();
      timeSlot.toH = new Date(timeSlot.toH).toISOString();
    });
    return toSave;
  };

  /**
   * @description
   * Formatta i dati in arivo dal BE in modo che piacciano al FE
   * @param assetCalendar ~> dati non formattati in arrivo dal BE
   * @returns {Object} ~> versione formattata (pronta per utilizzo in FE) dei dati in ingresso
   */
  $scope.getFormattedEvents = function (assetCalendar) {
    var formattedEvents = [];
    Object.keys(assetCalendar).forEach(function (key) {
      var newEvent = {};
      newEvent.id = key;
      newEvent.startDate = new Date(assetCalendar[key].startDate);
      newEvent.startDate.setHours(0, 0, 0, 0);
      newEvent.endDate = new Date(assetCalendar[key].endDate);
      newEvent.endDate.setHours(0, 0, 0, 0);
      newEvent.name = (assetCalendar[key].status == "open" ? "Apertura" : "Chiusura") + (assetCalendar[key].extraordinary ? " straordinaria" : " ordinaria");
      newEvent.timeSlots = "";
      if (angular.isDefined(assetCalendar[key].timeSlots)) {
        assetCalendar[key].timeSlots.forEach(function (tSlot) {
          newEvent.timeSlots += tSlot.fromH + " - " + tSlot.toH + "; ";
        });
      }
      newEvent.description = assetCalendar[key].description;
      formattedEvents.push(newEvent);
    });
    return formattedEvents;
  };

  /**
   * @description
   * Formatta i dati in arrivo da excel in modo che piacciano al FE
   * @param data ~> dati JSON in formato xls-like
   * @returns {Array}
   */
  $scope.formatXlsDataToSave = function (data) {
    var formattedData = [];
    var timeslotsRegexp = /(\d+:\d+)\-(\d+:\d+)/;
    data.forEach(function (xlsRow) {
      var formattedRow = angular.copy(xlsRow);
      formattedRow["commission"] = currentCommission.code;
      var formattedTimeSlots = [];
      if (formattedRow["timeslots"]) {
        var xlsTimeSlots = formattedRow["timeslots"].split(";");
        xlsTimeSlots.forEach(function (xlsTimeSlot) {
          if (timeslotsRegexp.test(xlsTimeSlot)) {
            var formattedTimeSlot = {};
            xlsTimeSlot = xlsTimeSlot.split("-");
            var fromH = new Date("1970-01-01T" + xlsTimeSlot[0] + ":00.000Z");
            var toH = new Date("1970-01-01T" + xlsTimeSlot[1] + ":00.000Z");
            fromH.setHours(fromH.getHours() - 2);
            toH.setHours(toH.getHours() - 2);
            formattedTimeSlot["fromH"] = fromH;
            formattedTimeSlot["toH"] = toH;
            formattedTimeSlots.push(formattedTimeSlot);
          }
        });
      }
      formattedRow["timeSlots"] = formattedTimeSlots;
      formattedRow["startDate"] = new Date(formattedRow["from"]);
      delete formattedRow["from"];
      formattedRow["endDate"] = new Date(formattedRow["to"]);
      delete formattedRow["to"];
      formattedData.push(formattedRow);
    });
    return formattedData;
  };

  /**
   * @description
   * Valida i dati dell'evento inseriti dall'utente in modo che non generino conflitti
   * @param payload
   * @param docToSave
   * @returns {boolean}
   */
  $scope.validateDialog = function (payload, docToSave) {
    var valid = $scope.checkOptions();
    //Campi che devono essere definiti: startDate
    if (isNullOrUndefined(docToSave.document.startDate)) {
      valid = false;
    }
    //non voglio eventi "kill" sul calendario di commessa
    if (isNullOrUndefined(docToSave.assetUuidList) && docToSave.document.type === "k") {
      valid = false;
    }
    //endDate definita -> type e savemode settate a null
    if (!isNullOrUndefined(docToSave.document.endDate)) {
      docToSave.type = null;
      payload.savemode = null;
      //endDate deve essere successiva a startDate
      if (confrontDates(docToSave.document.endDate, docToSave.document.startDate, CONFRONT_MODE.STRICT)) {
        valid = false;
      }
    } else {
      //endDate non definita
      //type e savemode devono essere definiti
      if (isNullOrUndefined(docToSave.document.type) || isNullOrUndefined(payload.savemode)) {
        valid = false;
      }
    }
    //se è arrivato qui, il form è valido. Finisco validando la scelta dell'asset.
    return valid;
  };

  /**
   * @description
   * Valida i dati importati e formattati per assicurarsi che non ci siano conflitti
   * @param formattedData ~> dati formattati dalla funzione $scope.formatXlsDataToSave()
   * @returns {boolean}
   */
  $scope.validateImport = function (formattedData) {
    var valid = true;
    formattedData.forEach(function (toSave) {
      //Campi che devono essere definiti: startDate
      if (isNullOrUndefined(toSave.startDate) || isNullOrUndefined(toSave.endDate)) {
        valid = false;
      }
      //endDate deve essere successiva a startDate
      if (confrontDates(toSave.endDate, toSave.startDate, CONFRONT_MODE.STRICT)) {
        valid = false;
      }
    });
    return valid;
  };

  /******************** NAVIGATION FUNCTIONS ********************/
  /**
   * @description
   * Esegue il redirect verso il dettaglio di un evento
   * @param params ~> parametri da passare alla nuova pagina
   */
  $scope.goToNewEvent = function (params) {
    var myParams = params || {};
    $timeout(function () {
      $location.search(myParams).path("assetcalendar/single");
      jQuery(".with-popover").popover("hide");
    });
  };

  /**
   * @description
   * Esegue il redirect verso la vista grafica del calendario
   * @param params ~> parametri da passare alla nuova pagina
   */
  $scope.goToCalendarView = function (params) {
    var myParams = params || {};
    $timeout(function () {
      $location.search(myParams).path("assetcalendar");
      jQuery(".with-popover").popover("hide");
    });
  };

  /**
   * @description
   * Esegue il redirect verso la vista grafica del calendario associato all'asset
   * @param assetRef
   */
  $scope.viewAssetCalendar = function (assetRef) {
    var opt = angular.copy($scope.opt);
    opt.model.record_id = assetRef;
    var myParams = {
      commissionCalendar: false,
      opt: JSON.stringify(opt)
    };
    $timeout(function () {
      $location.search(myParams).path("assetcalendar");
      jQuery(".with-popover").popover("hide");
    });
  };

  /**
   * @description
   * Esegue il redirect verso il dettaglio del prossimo evento
   */
  /*     $scope.goToNextEventDetail = function() {
        if ($scope.nextEventDetail){
          var myParams = $scope.getPageChangedParams();
          myParams.date = new Date($scope.nextEventDetail.startDate);
          $scope.goToNewEvent(myParams);
        }
      }; */

  /**
   * @description
   * Esegue il redirect verso la vista degli asset aperti in una data selezionata
   */
  $scope.goToOpeningView = function () {
    $scope.bool.commissionCalendar = false;
    var myParams = $scope.getPageChangedParams() || {};
    $timeout(function () {
      $location.search(myParams).path("assetcalendar/openingview");
      jQuery(".with-popover").popover("hide");
    });
  };

  /**
   * @description
   * Esegue il redirect verso la pagina di importazione tramite excel
   */
  $scope.goToXlsImport = function () {
    var myParams = $scope.getPageChangedParams() || {};
    $timeout(function () {
      $location.search(myParams).path("assetcalendar/importxls");
      jQuery(".with-popover").popover("hide");
    });
  };

  /**
   * @description
   * Esegue il redirect verso il dettaglio dell'asset associato al riferimento(tipo lookup) passato
   * @param assetRef
   */
  $scope.goToAssetDetail = function (assetRef) {
    $location.path("/record/snap/" + assetRef.type + "/" + assetRef.UUID);
  };

  /**
   * @description
   * Esegue il redirect all'URL precedente nella history del browser
   */
  $scope.back = function () {
    $window.history.back();
  };
  $scope.getTemplate = function () {
    location.href = 'dataset/attachments/template_import_calendar.xlsx';
  };

  /******************** COMMON FUNCTIONS ********************/

  /**
   * @description
   * Esegue il passaggio da visualizzazione grafica del calendario a tabellare e viceversa
   */
  $scope.toggleViewMode = function () {
    $scope.bool.gridViewMode = !$scope.bool.gridViewMode;
    $scope.getAssetCalendar();
  };

  /**
   * @description
   * Esegue il reset di alcune variabili quando necessario
   */
  $scope.reset = function () {
    $scope.errorCount = -1;
    $scope.bool.commissionCalendar = !$scope.bool.showOpeningView;
    $scope.opt = {
      model: {
        type_id: {},
        record_id: {
          UUID: null
        },
        record_id_list: []
      },
      openingDate: today()
    };
    if ($scope.bool.showImportXls) {
      $scope.bool.importHasData = false;
      $scope.importGridOptions.data = [];
      $scope.importGridOptions.columnDefs = [];
    }
  };

  /**
   * @description
   * Prima di un salvataggio controlla che non ci siano conflitti nelle options scelte da utente
   * @returns {boolean}
   */
  $scope.checkOptions = function () {
    if (!$scope.bool.commissionCalendar && angular.isUndefined($scope.opt.model.record_id.UUID) && $scope.opt.model.record_id_list.length == 0) {
      toaster.pop('error', 'Asset non selezionato', 'Prima di procedere imposta un asset, altrimenti seleziona la spunta \'Applica su tutta la commessa\'!');
      return false;
    } else {
      return true;
    }
  };

  /**
   * @description
   * Aggiunge un nuovo elemento 'timeSlot' alle fasce orarie dell'elemento modificato correntemente
   */
  $scope.addTimeSlot = function () {
    $scope.toSave.timeSlots.push({
      fromH: today(),
      toH: today()
    });
  };

  /**
   * @description
   * Rimuove il 'timeSlot' inserito dall'elemento modificato correntemente
   * @param timeSlot
   */
  $scope.removeTimeSlot = function (timeSlot) {
    var index = $scope.toSave.timeSlots.indexOf(timeSlot);
    if (index != -1) {
      $scope.toSave.timeSlots.splice(index, 1);
    }
  };

  /******************** UTILITY FUNCTIONS ********************/
  /**
   * @description
   * Returns start of current day as Date
   * @return {Date} start of current day
   */
  function today() {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  }

  /**
   * @description
   * Returns first day of a given year as a date ISO_string
   * setting UTC TimeZone
   * @param {string} year  (format: yyyy)
   * @return {string} first day of the year as ISO_string
   */
  function fromDate(year) {
    return year + "-01-01T00:00:00.000Z";
  }

  /**
   * @description
   * Returns last day of a given year as a date ISO_string
   * setting UTC TimeZone
   * @param {string} year  (format: yyyy)
   * @return {string} last day of the year as ISO_string
   */
  function toDate(year) {
    return year + "-12-31T00:00:00.000Z";
  }

  /**
   * @description
   * Check if firstDate is in the past compared to secondDate
   * @param {Date} firstDate
   * @param {Date} secondDate
   * @param {String} mode
   *                     if STRICT -> firstDate < secondDate
   *                     else -> firstDate <= secondDate
   * @return {boolean} true if firstDate is in the past compared to secondDate
   */
  function confrontDates(firstDate, secondDate, mode) {
    if (mode == CONFRONT_MODE.STRICT) {
      return firstDate < secondDate;
    }
    return firstDate <= secondDate;
  }

  /**
   * @description
   * Check if the date is between a given range of dates
   * @param {Date} startDate
   * @param {Date} endDate
   * @return {boolean} true id this is between the two given dates
   */
  Date.prototype.between = function (startDate, endDate) {
    return this <= endDate && startDate <= this;
  };

  /**
   * @description
   * From a list of objects calculates the list of their UUIDs
   * @param {Array<Object>} record_id_list
   * @return {Array<String>} null if param is not defined
   */
  function getUuidList(record_id_list) {
    if (angular.isDefined(record_id_list) && record_id_list != null) {
      var uuidList = [];
      record_id_list.forEach(function (record_id) {
        uuidList.push(record_id.UUID);
      });
      return uuidList;
    }
    return null;
  }

  /**
   * @description
   * Pads a number into a two characters string
   * @param {Number} number
   * @returns {String}
   */
  function pad(number) {
    if (number < 10) {
      return '0' + number;
    }
    return number;
  }

  /**
   * @description
   * Transforms date to String following ISO-8601 format
   * @returns {string}
   */
  Date.prototype.toISOString = function () {
    return this.getUTCFullYear() + '-' + pad(this.getUTCMonth() + 1) + '-' + pad(this.getUTCDate()) + 'T' + pad(this.getUTCHours()) + ':' + pad(this.getUTCMinutes()) + ':' + pad(this.getUTCSeconds()) + '.' + (this.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z';
  };

  /**
   * @description
   * Checks if given obj is null or undefined
   * @param {Object} obj
   * @return {boolean} true if given obj is null or undefined
   */
  function isNullOrUndefined(obj) {
    return obj == null || angular.isUndefined(obj);
  }

  /**
   * @description
   * Removes duplicate element from any array.
   * Works with {Object} items.
   * @param {Array} a ~> any array
   * @returns {Array}
   */
  function removeDuplicates(a) {
    var result = [];
    a.forEach(function (item) {
      var match = result.some(function (el) {
        return angular.equals(item, el);
      });
      if (!match) {
        result.push(item);
      }
    });
    return result;
  }

  /**
   * @description
   * Costruisce un riferimento in stile lookup
   * @param {Object} item ~> full object from BE
   * @returns {{
   *   UUID: {string}
   *   code: {string},
   *   description: {string},
   *   type: {string},
   *   customCode: {string}
   * }}
   */
  function buildRef(item) {
    var typeRef = null;
    var code = null;
    var description = null;
    var uuid = null;
    var customCode = null;
    if (item.model) {
      if (item.schemaCode) {
        typeRef = item.schemaCode;
      } else {
        typeRef = $scope.opt.model.type_id.UUID;
      }
      code = item.model.code;
      description = item.model.description;
      uuid = item.UUID;
      customCode = item.model.customCode;
    } else {
      if (item.type) {
        typeRef = item.type;
      } else {
        typeRef = $scope.opt.model.type_id.UUID;
      }
      code = item.code;
      description = item.description;
      uuid = item.UUID;
      customCode = item.customCode;
    }
    return {
      type: typeRef,
      code: code,
      description: description,
      UUID: uuid,
      customCode: customCode
    };
  }

  /************************************
  ********* Check permissions *********
  ************************************/
  var RESOURCE_NAME = 'calendar';

  /**
   * @description
   * Controlla i permessi di scrittura dell'utente
   */
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };

  /**
   * @description
   * Controlla i permessi di eliminazione dell'utente
   */
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };

  /******************** MAIN ********************/

  /**
   * @description
   * Gestisce l'inizializzazione della pagina
   */
  $scope.initCalendar = function () {
    if (angular.isDefined(urlParams.date)) {
      urlParams.date = new Date(urlParams.date);
      var opt = JSON.parse(urlParams.opt);
      $scope.getEventByDate(urlParams.date.toISOString(), !isNullOrUndefined(opt.model.record_id.UUID) ? opt.model.record_id.UUID : null);
    }
    if (!$scope.bool.gridViewMode) {
      jQuery('#year-calendar-view').calendar($scope.calendarOptions);
      $timeout(function () {
        $scope.getAssetCalendar();
      });
    }
    setColumnDefs();
  };
  $scope.initCalendar();
}]);
'use strict';

angular.module('emma.plan').controller('ictDrawingCtrl', ["$q", "$log", "$timeout", "drawingFactory", "$location", "$scope", function ($q, $log, $timeout, drawingFactory, $location, $scope) {
  var ctrl = this;
  ctrl.$onInit = function () {
    ctrl.loaded = false;
  };
  var bufferedPromise;
  ctrl.$onChanges = function (changesObj) {
    if (bufferedPromise) {
      $timeout.cancel(bufferedPromise);
    }
    bufferedPromise = $timeout(loadDrawing, 200, true, changesObj.drawingUuid.currentValue);
  };
  function loadDrawing(uuid) {
    if (uuid) {
      $log.debug("Loading drawing data", uuid);
      drawingFactory.getDrawingData({
        uuid: uuid
      }).$promise.then(function (drawingData) {
        var loader = new THREE.FontLoader();
        var element = document.getElementById("ictDrawingCanvas");
        loader.load('fonts/helvetiker_regular.typeface.json', function (font) {
          angular.element(element).on("loaded", function () {
            ctrl.loaded = true;
          });
          ctrl.cadCanvas = new ThreeDxf.Viewer(drawingData, element, false, false, font);
        });
      });
    } else {
      clear();
    }
  }
  function clear() {
    //cleanup della scena e reset dell'interfaccia
  }
}]).component('ictDrawing', {
  controller: 'ictDrawingCtrl',
  templateUrl: 'dataset/components/ict_drawing.html',
  bindings: {
    drawingUuid: '<',
    assetUuid: '<?',
    //l'asset su cui limitare le ricerche dei codici
    highlight: '<?',
    //il code associato alla polilinea da evidenziare
    onAssetSelect: '&'
  }
});
"use strict";

//three-dxf v0.3.0

/**
 * Returns the angle in radians of the vector (p1,p2). In other words, imagine
 * putting the base of the vector at coordinates (0,0) and finding the angle
 * from vector (1,0) to (p1,p2).
 * @param  {Object} p1 start point of the vector
 * @param  {Object} p2 end point of the vector
 * @return {Number} the angle
 */
THREE.Math.angle2 = function (p1, p2) {
  var v1 = new THREE.Vector2(p1.x, p1.y);
  var v2 = new THREE.Vector2(p2.x, p2.y);
  v2.sub(v1); // sets v2 to be our chord
  v2.normalize();
  if (v2.y < 0) return -Math.acos(v2.x);
  return Math.acos(v2.x);
};
THREE.Math.polar = function (point, distance, angle) {
  var result = {};
  result.x = point.x + distance * Math.cos(angle);
  result.y = point.y + distance * Math.sin(angle);
  return result;
};

/**
 * Calculates points for a curve between two points
 * @param startPoint - the starting point of the curve
 * @param endPoint - the ending point of the curve
 * @param bulge - a value indicating how much to curve
 * @param segments - number of segments between the two given points
 */
THREE.BulgeGeometry = function (startPoint, endPoint, bulge, segments) {
  var vertex, i, center, p0, p1, angle, radius, startAngle, thetaAngle;
  THREE.Geometry.call(this);
  this.startPoint = p0 = startPoint ? new THREE.Vector2(startPoint.x, startPoint.y) : new THREE.Vector2(0, 0);
  this.endPoint = p1 = endPoint ? new THREE.Vector2(endPoint.x, endPoint.y) : new THREE.Vector2(1, 0);
  this.bulge = bulge = bulge || 1;
  angle = 4 * Math.atan(bulge);
  radius = p0.distanceTo(p1) / 2 / Math.sin(angle / 2);
  center = THREE.Math.polar(startPoint, radius, THREE.Math.angle2(p0, p1) + (Math.PI / 2 - angle / 2));
  this.segments = segments = segments || Math.max(Math.abs(Math.ceil(angle / (Math.PI / 18))), 6); // By default want a segment roughly every 10 degrees
  startAngle = THREE.Math.angle2(center, p0);
  thetaAngle = angle / segments;
  this.vertices.push(new THREE.Vector3(p0.x, p0.y, 0));
  for (i = 1; i <= segments - 1; i++) {
    vertex = THREE.Math.polar(center, Math.abs(radius), startAngle + thetaAngle * i);
    this.vertices.push(new THREE.Vector3(vertex.x, vertex.y, 0));
  }
};
THREE.BulgeGeometry.prototype = Object.create(THREE.Geometry.prototype);
var ThreeDxf;
(function (ThreeDxf) {
  /**
   * Viewer class for a dxf object.
   * @param {Object} data - the dxf object
   * @param {Object} parent - the parent element to which we attach the rendering canvas
   * @param {Number} width - width of the rendering canvas in pixels
   * @param {Number} height - height of the rendering canvas in pixels
   * @param {Object} font - a font loaded with THREE.FontLoader
   * @constructor
   */
  ThreeDxf.Viewer = function (data, parent, width, height, font) {
    var $parent = $(parent);
    console.log(data);
    createLineTypeShaders(data);
    var scene = new THREE.Scene();

    // Create scene from dxf object (data)
    var i, entity, obj, min_x, min_y, min_z, max_x, max_y, max_z;
    var dims = {
      min: {
        x: false,
        y: false,
        z: false
      },
      max: {
        x: false,
        y: false,
        z: false
      }
    };
    for (i = 0; i < data.entities.length; i++) {
      entity = data.entities[i];
      if (entity.hidden) continue;
      if (entity.type === 'DIMENSION') {
        if (entity.block) {
          var block = data.blocks[entity.block];
          if (!block) {
            console.error('Missing referenced block "' + entity.block + '"');
            continue;
          }
          for (var j = 0; j < block.entities.length; j++) {
            obj = drawEntity(block.entities[j], data);
          }
        } else {
          console.log('WARNING: No block for DIMENSION entity');
        }
      } else {
        obj = drawEntity(entity, data);
      }
      if (obj) {
        if (entity.type === 'LWPOLYLINE' && entity.layer == "VANI") {
          var bbox = new THREE.Box3().setFromObject(obj);
          if (bbox.min.x && (dims.min.x === false || dims.min.x > bbox.min.x)) dims.min.x = bbox.min.x;
          if (bbox.min.y && (dims.min.y === false || dims.min.y > bbox.min.y)) dims.min.y = bbox.min.y;
          if (bbox.min.z && (dims.min.z === false || dims.min.z > bbox.min.z)) dims.min.z = bbox.min.z;
          if (bbox.max.x && (dims.max.x === false || dims.max.x < bbox.max.x)) dims.max.x = bbox.max.x;
          if (bbox.max.y && (dims.max.y === false || dims.max.y < bbox.max.y)) dims.max.y = bbox.max.y;
          if (bbox.max.z && (dims.max.z === false || dims.max.z < bbox.max.z)) dims.max.z = bbox.max.z;
        }
        scene.add(obj);
      }
      obj = null;
    }
    width = width || $parent.innerWidth();
    height = height || $parent.innerHeight();
    var aspectRatio = width / height;
    var upperRightCorner = {
      x: dims.max.x,
      y: dims.max.y
    };
    var lowerLeftCorner = {
      x: dims.min.x,
      y: dims.min.y
    };

    // Figure out the current viewport extents
    var vp_width = upperRightCorner.x - lowerLeftCorner.x;
    var vp_height = upperRightCorner.y - lowerLeftCorner.y;
    var center = center || {
      x: vp_width / 2 + lowerLeftCorner.x,
      y: vp_height / 2 + lowerLeftCorner.y
    };

    // Fit all objects into current ThreeDXF viewer
    var extentsAspectRatio = Math.abs(vp_width / vp_height);
    if (aspectRatio > extentsAspectRatio) {
      vp_width = vp_height * aspectRatio;
    } else {
      vp_height = vp_width / aspectRatio;
    }
    var viewPort = {
      bottom: -vp_height / 2,
      left: -vp_width / 2,
      top: vp_height / 2,
      right: vp_width / 2,
      center: {
        x: center.x,
        y: center.y
      }
    };
    var camera = new THREE.OrthographicCamera(viewPort.left, viewPort.right, viewPort.top, viewPort.bottom, 1, 19);
    camera.position.z = 10;
    camera.position.x = viewPort.center.x;
    camera.position.y = viewPort.center.y;
    var renderer = this.renderer = new THREE.WebGLRenderer({
      antialias: true
    });
    renderer.setSize(width, height);
    renderer.setClearColor(0xfffffff, 1);
    $parent.append(renderer.domElement);
    $parent.show();
    var controls = new THREE.OrbitControls(camera, parent);
    controls.target.x = camera.position.x;
    controls.target.y = camera.position.y;
    controls.target.z = 0;
    controls.enableRotate = false;
    controls.screenSpacePanning = true;
    controls.zoomSpeed = 3;
    controls.mouseButtons = {
      LEFT: THREE.MOUSE.RIGHT,
      MIDDLE: THREE.MOUSE.MIDDLE,
      RIGHT: THREE.MOUSE.LEFT
    };
    this.render = function () {
      renderer.render(scene, camera);
    };
    controls.addEventListener('change', this.render);
    this.render();
    controls.update();
    $parent.triggerHandler("loaded");
    $parent.on('click', function (event) {
      var $el = $(renderer.domElement);
      var vector = new THREE.Vector3((event.pageX - $el.offset().left) / $el.innerWidth() * 2 - 1, -((event.pageY - $el.offset().top) / $el.innerHeight()) * 2 + 1, 0.5);
      vector.unproject(camera);
      var dir = vector.sub(camera.position).normalize();
      var distance = -camera.position.z / dir.z;
      var pos = camera.position.clone().add(dir.multiplyScalar(distance));
      console.log(pos.x, pos.y); // Position in cad that is clicked
    });

    this.resize = function (width, height) {
      var originalWidth = renderer.domElement.width;
      var originalHeight = renderer.domElement.height;
      var hscale = width / originalWidth;
      var vscale = height / originalHeight;
      camera.top = vscale * camera.top;
      camera.bottom = vscale * camera.bottom;
      camera.left = hscale * camera.left;
      camera.right = hscale * camera.right;

      //        camera.updateProjectionMatrix();

      renderer.setSize(width, height);
      renderer.setClearColor(0xfffffff, 1);
      this.render();
    };
    function drawEntity(entity, data) {
      var mesh;
      if (entity.type === 'CIRCLE' || entity.type === 'ARC') {
        mesh = drawCircle(entity, data);
      } else if (entity.type === 'LWPOLYLINE') {
        mesh = drawPolyline(entity, data);
      } else if (entity.type === 'LINE' || entity.type === 'POLYLINE') {
        mesh = drawLine(entity, data);
      } else if (entity.type === 'TEXT') {
        mesh = drawText(entity, data);
      } else if (entity.type === 'SOLID') {
        mesh = drawSolid(entity, data);
      } else if (entity.type === 'POINT') {
        mesh = drawPoint(entity, data);
      } else if (entity.type === 'INSERT') {
        mesh = drawBlock(entity, data);
      } else if (entity.type === 'SPLINE') {
        mesh = drawSpline(entity, data);
      } else if (entity.type === 'MTEXT') {
        mesh = drawMtext(entity, data);
      } else if (entity.type === 'ELLIPSE') {
        mesh = drawEllipse(entity, data);
      } else {
        console.log("Unsupported Entity Type: " + entity.type);
      }
      return mesh;
    }
    function drawEllipse(entity, data) {
      var color = getColor(entity, data);
      var xrad = Math.sqrt(Math.pow(entity.majorAxisEndPoint.x, 2) + Math.pow(entity.majorAxisEndPoint.y, 2));
      var yrad = xrad * entity.axisRatio;
      var rotation = Math.atan2(entity.majorAxisEndPoint.y, entity.majorAxisEndPoint.x);
      var curve = new THREE.EllipseCurve(entity.center.x, entity.center.y, xrad, yrad, entity.startAngle, entity.endAngle, false,
      // Always counterclockwise
      rotation);
      var points = curve.getPoints(50);
      var geometry = new THREE.BufferGeometry().setFromPoints(points);
      var material = new THREE.LineBasicMaterial({
        linewidth: 1,
        color: color
      });

      // Create the final object to add to the scene
      var ellipse = new THREE.Line(geometry, material);
      return ellipse;
    }
    function drawMtext(entity, data) {
      var color = getColor(entity, data);
      var geometry = new THREE.TextGeometry(entity.text, {
        font: font,
        size: entity.height * (4 / 5),
        height: 1
      });
      var material = new THREE.MeshBasicMaterial({
        color: color
      });
      var text = new THREE.Mesh(geometry, material);

      // Measure what we rendered.
      var measure = new THREE.Box3();
      measure.setFromObject(text);
      var textWidth = measure.max.x - measure.min.x;

      // If the text ends up being wider than the box, it's supposed
      // to be multiline. Doing that in threeJS is overkill.
      if (textWidth > entity.width) {
        // console.log("Can't render this multiline MTEXT entity correctly, it will overflow, sorry.", entity);
        return;
      }
      text.position.z = 0;
      switch (entity.attachmentPoint) {
        case 1:
          // Top Left
          text.position.x = entity.position.x;
          text.position.y = entity.position.y - entity.height;
          break;
        case 2:
          // Top Center
          text.position.x = entity.position.x - textWidth / 2;
          text.position.y = entity.position.y - entity.height;
          break;
        case 3:
          // Top Right
          text.position.x = entity.position.x - textWidth;
          text.position.y = entity.position.y - entity.height;
          break;
        case 4:
          // Middle Left
          text.position.x = entity.position.x;
          text.position.y = entity.position.y - entity.height / 2;
          break;
        case 5:
          // Middle Center
          text.position.x = entity.position.x - textWidth / 2;
          text.position.y = entity.position.y - entity.height / 2;
          break;
        case 6:
          // Middle Right
          text.position.x = entity.position.x - textWidth;
          text.position.y = entity.position.y - entity.height / 2;
          break;
        case 7:
          // Bottom Left
          text.position.x = entity.position.x;
          text.position.y = entity.position.y;
          break;
        case 8:
          // Bottom Center
          text.position.x = entity.position.x - textWidth / 2;
          text.position.y = entity.position.y;
          break;
        case 9:
          // Bottom Right
          text.position.x = entity.position.x - textWidth;
          text.position.y = entity.position.y;
          break;
        default:
          return undefined;
      }
      ;
      return text;
    }
    function drawSpline(entity, data) {
      var color = getColor(entity, data);
      var points = entity.controlPoints.map(function (vec) {
        return new THREE.Vector2(vec.x, vec.y);
      });
      var interpolatedPoints = [];
      if (entity.degreeOfSplineCurve == 2) {
        for (var i = 0; i + 2 < points.length; i = i + 2) {
          curve = new THREE.QuadraticBezierCurve(points[i], points[i + 1], points[i + 2]);
          interpolatedPoints.push.apply(interpolatedPoints, curve.getPoints(50));
        }
      } else {
        curve = new THREE.SplineCurve(points);
        interpolatedPoints = curve.getPoints(100);
      }
      var geometry = new THREE.BufferGeometry().setFromPoints(interpolatedPoints);
      var material = new THREE.LineBasicMaterial({
        linewidth: 1,
        color: color
      });
      var splineObject = new THREE.Line(geometry, material);
      return splineObject;
    }
    function drawPolyline(entity, data) {
      var group = new THREE.Object3D();
      group.add(drawLine(entity, data));
      if (!entity.focused) return group;
      var material,
        verts,
        geometry = new THREE.Geometry();
      verts = [];
      entity.vertices.forEach(function (v) {
        verts.push(new THREE.Vector2(v.x, v.y));
      });
      var poly = new THREE.Shape(verts);
      var geometry = new THREE.ShapeGeometry(poly);
      var material = new THREE.MeshBasicMaterial({
        color: 0x00ff00
      });
      group.add(new THREE.Mesh(geometry, material));
      return group;
    }
    function drawLine(entity, data) {
      var geometry = new THREE.Geometry(),
        color = getColor(entity, data),
        material,
        lineType,
        vertex,
        startPoint,
        endPoint,
        bulgeGeometry,
        bulge,
        i,
        line;

      // create geometry
      for (i = 0; i < entity.vertices.length; i++) {
        if (entity.vertices[i].bulge) {
          bulge = entity.vertices[i].bulge;
          startPoint = entity.vertices[i];
          endPoint = i + 1 < entity.vertices.length ? entity.vertices[i + 1] : geometry.vertices[0];
          bulgeGeometry = new THREE.BulgeGeometry(startPoint, endPoint, bulge);
          geometry.vertices.push.apply(geometry.vertices, bulgeGeometry.vertices);
        } else {
          vertex = entity.vertices[i];
          geometry.vertices.push(new THREE.Vector3(vertex.x, vertex.y, 0));
        }
      }
      if (entity.shape) geometry.vertices.push(geometry.vertices[0]);

      // set material
      if (entity.lineType) {
        lineType = data.tables.lineType.lineTypes[entity.lineType];
      }
      if (lineType && lineType.pattern && lineType.pattern.length !== 0) {
        material = new THREE.LineDashedMaterial({
          color: color,
          gapSize: 4,
          dashSize: 4
        });
      } else {
        material = new THREE.LineBasicMaterial({
          linewidth: 1,
          color: color
        });
      }

      // if(lineType && lineType.pattern && lineType.pattern.length !== 0) {

      //           geometry.computeLineDistances();

      //           // Ugly hack to add diffuse to this. Maybe copy the uniforms object so we
      //           // don't add diffuse to a material.
      //           lineType.material.uniforms.diffuse = { type: 'c', value: new THREE.Color(color) };

      // 	material = new THREE.ShaderMaterial({
      // 		uniforms: lineType.material.uniforms,
      // 		vertexShader: lineType.material.vertexShader,
      // 		fragmentShader: lineType.material.fragmentShader
      // 	});
      // }else {
      // 	material = new THREE.LineBasicMaterial({ linewidth: 1, color: color });
      // }

      line = new THREE.Line(geometry, material);
      return line;
    }
    function drawCircle(entity, data) {
      var geometry, material, circle;
      geometry = new THREE.CircleGeometry(entity.radius, 32, entity.startAngle, entity.angleLength);
      geometry.vertices.shift();
      material = new THREE.LineBasicMaterial({
        color: getColor(entity, data)
      });
      circle = new THREE.Line(geometry, material);
      circle.position.x = entity.center.x;
      circle.position.y = entity.center.y;
      circle.position.z = entity.center.z;
      return circle;
    }
    function drawSolid(entity, data) {
      var material,
        mesh,
        verts,
        geometry = new THREE.Geometry();
      verts = geometry.vertices;
      verts.push(new THREE.Vector3(entity.points[0].x, entity.points[0].y, entity.points[0].z));
      verts.push(new THREE.Vector3(entity.points[1].x, entity.points[1].y, entity.points[1].z));
      verts.push(new THREE.Vector3(entity.points[2].x, entity.points[2].y, entity.points[2].z));
      verts.push(new THREE.Vector3(entity.points[3].x, entity.points[3].y, entity.points[3].z));

      // Calculate which direction the points are facing (clockwise or counter-clockwise)
      var vector1 = new THREE.Vector3();
      var vector2 = new THREE.Vector3();
      vector1.subVectors(verts[1], verts[0]);
      vector2.subVectors(verts[2], verts[0]);
      vector1.cross(vector2);

      // If z < 0 then we must draw these in reverse order
      if (vector1.z < 0) {
        geometry.faces.push(new THREE.Face3(2, 1, 0));
        geometry.faces.push(new THREE.Face3(2, 3, 1));
      } else {
        geometry.faces.push(new THREE.Face3(0, 1, 2));
        geometry.faces.push(new THREE.Face3(1, 3, 2));
      }
      material = new THREE.MeshBasicMaterial({
        color: getColor(entity, data)
      });
      return new THREE.Mesh(geometry, material);
    }
    function drawText(entity, data) {
      var geometry, material, text;
      if (!font) return console.warn('Text is not supported without a Three.js font loaded with THREE.FontLoader! Load a font of your choice and pass this into the constructor. See the sample for this repository or Three.js examples at http://threejs.org/examples/?q=text#webgl_geometry_text for more details.');
      geometry = new THREE.TextGeometry(entity.text, {
        font: font,
        height: 0,
        size: entity.textHeight || 12
      });
      material = new THREE.MeshBasicMaterial({
        color: getColor(entity, data)
      });
      text = new THREE.Mesh(geometry, material);
      text.position.x = entity.startPoint.x;
      text.position.y = entity.startPoint.y;
      text.position.z = entity.startPoint.z;
      return text;
    }
    function drawPoint(entity, data) {
      var geometry, material, point;
      geometry = new THREE.Geometry();
      geometry.vertices.push(new THREE.Vector3(entity.position.x, entity.position.y, entity.position.z));

      // TODO: could be more efficient. PointCloud per layer?

      var numPoints = 1;
      var color = getColor(entity, data);
      var colors = new Float32Array(numPoints * 3);
      colors[0] = color.r;
      colors[1] = color.g;
      colors[2] = color.b;
      geometry.colors = colors;
      geometry.computeBoundingBox();
      material = new THREE.PointsMaterial({
        size: 0.05,
        vertexColors: THREE.VertexColors
      });
      point = new THREE.Points(geometry, material);
      scene.add(point);
    }
    function drawInsert(entity, data) {
      var geometry, material, point;
      geometry = new THREE.CircleGeometry(0.2, 32);
      material = new THREE.MeshBasicMaterial({
        color: 0x888888
      });
      var pos = new THREE.Vector3(entity.position.x, entity.position.y, entity.position.z);
      geometry.position = pos;
      point = new THREE.Mesh(geometry, material);
      geometry.vertices.shift();
      return point;
    }
    function drawBlock(entity, data) {
      var block = data.blocks[entity.name];

      // if (!block.entities) return null;

      var container = new THREE.Object3D();
      var group = new THREE.Object3D();
      if (entity.xScale) group.scale.x = entity.xScale;
      if (entity.yScale) group.scale.y = entity.yScale;
      if (entity.rotation) {
        group.rotation.z = entity.rotation * Math.PI / 180;
      }
      if (entity.position) {
        group.position.x = entity.position.x;
        group.position.y = entity.position.y;
        group.position.z = entity.position.z;
      }
      for (var i = 0; i < block.entities.length; i++) {
        var childEntity = drawEntity(block.entities[i], data, group);
        if (childEntity) group.add(childEntity);
      }
      if (entity.attributes && entity.attributes.length) {
        entity.attributes.forEach(function (v) {
          container.add(drawText(v, data));
        });
      }
      group.add(drawInsert(entity, data));
      container.add(group);
      return container;
    }
    function getColor(entity, data) {
      var color = 0x000000; //default
      if (entity.color) color = entity.color;else if (data.tables && data.tables.layer && data.tables.layer.layers[entity.layer]) color = data.tables.layer.layers[entity.layer].color;
      if (color == null || color === 0xffffff) {
        color = 0x000000;
      }
      return color;
    }
    function createLineTypeShaders(data) {
      var ltype, type;
      if (!data.tables || !data.tables.lineType) return;
      var ltypes = data.tables.lineType.lineTypes;
      for (type in ltypes) {
        ltype = ltypes[type];
        if (!ltype.pattern) continue;
        ltype.material = createDashedLineShader(ltype.pattern);
      }
    }
    function createDashedLineShader(pattern) {
      var i,
        dashedLineShader = {},
        totalLength = 0.0;
      for (i = 0; i < pattern.length; i++) {
        totalLength += Math.abs(pattern[i]);
      }
      dashedLineShader.uniforms = THREE.UniformsUtils.merge([THREE.UniformsLib['common'], THREE.UniformsLib['fog'], {
        'pattern': {
          type: 'fv1',
          value: pattern
        },
        'patternLength': {
          type: 'f',
          value: totalLength
        }
      }]);
      dashedLineShader.vertexShader = ['attribute float lineDistance;', 'varying float vLineDistance;', THREE.ShaderChunk['color_pars_vertex'], 'void main() {', THREE.ShaderChunk['color_vertex'], 'vLineDistance = lineDistance;', 'gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );', '}'].join('\n');
      dashedLineShader.fragmentShader = ['uniform vec3 diffuse;', 'uniform float opacity;', 'uniform float pattern[' + pattern.length + '];', 'uniform float patternLength;', 'varying float vLineDistance;', THREE.ShaderChunk['color_pars_fragment'], THREE.ShaderChunk['fog_pars_fragment'], 'void main() {', 'float pos = mod(vLineDistance, patternLength);', 'for ( int i = 0; i < ' + pattern.length + '; i++ ) {', 'pos = pos - abs(pattern[i]);', 'if( pos < 0.0 ) {', 'if( pattern[i] > 0.0 ) {', 'gl_FragColor = vec4(1.0, 0.0, 0.0, opacity );', 'break;', '}', 'discard;', '}', '}', THREE.ShaderChunk['color_fragment'], THREE.ShaderChunk['fog_fragment'], '}'].join('\n');
      return dashedLineShader;
    }
    function findExtents(scene) {
      for (var c in scene.children) {
        var child = scene.children[c];
        var minX, maxX, minY, maxY;
        if (child.position) {
          minX = Math.min(child.position.x, minX);
          minY = Math.min(child.position.y, minY);
          maxX = Math.max(child.position.x, maxX);
          maxY = Math.max(child.position.y, maxY);
        }
      }
      return {
        min: {
          x: minX,
          y: minY
        },
        max: {
          x: maxX,
          y: maxY
        }
      };
    }
  };
})(ThreeDxf || (ThreeDxf = {}));
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:DiffCtrl
 * @description
 * Controller of the sixEmmaApp
 */
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
angular.module('emma.dataset').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/diff', {
    templateUrl: 'dataset/diff/diff_list.html',
    controller: 'DiffCtrl',
    reloadOnSearch: false
  }).when('/diff/:type/:version/vs/:diffversion', {
    templateUrl: 'dataset/diff/diff.html',
    controller: 'DiffCtrl'
  });
}]).controller('DiffCtrl', ["$scope", "$q", "$routeParams", "$location", "$timeout", "$window", "toaster", "uiGridConstants", "authFactory", "recordFactory", "schemaFactory", "treeUtilities", function ($scope, $q, $routeParams, $location, $timeout, $window, toaster, uiGridConstants, authFactory, recordFactory, schemaFactory, treeUtilities) {
  //init dei parametri di ricerca
  var urlSearch = $location.search();
  if (urlSearch.from) {
    var startOfDay = new Date(urlSearch.from);
  } else {
    var startOfDay = new Date();
    startOfDay.setHours(0, 0, 0, 0);
  }
  if (urlSearch.to) {
    var endOfDay = new Date(urlSearch.to);
  } else {
    var endOfDay = new Date();
    endOfDay.setHours(23, 59, 59, 999);
  }
  var initialType = urlSearch.schema ? {
    UUID: urlSearch.schema
  } : '';
  var initialRecord = [];
  if (urlSearch.record) {
    urlSearch.record.split(",").forEach(function (uuid) {
      initialRecord.push({
        UUID: uuid
      });
    });
  }
  $scope.search = {
    from: startOfDay,
    to: endOfDay,
    type_id: initialType,
    record_id: initialRecord
  };
  $scope.hidratePreselection = function (obj, model) {
    var model = Array.isArray(model) ? model : [model];
    model.forEach(function (item) {
      if (item.code && item.description) return; //skip dei dati già completi
      if (item.UUID == obj.UUID) {
        item.code = obj.model.code;
        item.description = obj.model.description;
        item.type = obj.schemaCode;
      }
    });
  };
  var rowsRenderedTimeout;
  $scope.gridApi = null;
  $scope.gridOptions = {
    enableGridMenu: true,
    exporterCsvColumnSeparator: ';',
    exporterMenuPdf: false,
    enableFiltering: false,
    enableSorting: true,
    enableRowHeaderSelection: false,
    //non attivare, le righe ad altezza variabile funzionano male con le colonne pinnate a sx
    multiSelect: true,
    onRegisterApi: function onRegisterApi(gridApi) {
      $scope.gridApi = gridApi;
    },
    data: [],
    columnDefs: [{
      displayName: '',
      field: 'id',
      width: 36,
      cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/diff/{{row.entity.current.schemaCode}}/{{row.entity.current.version}}/vs/{{row.entity.prev.version}}" class="btn btn-xs btn-primary">' + '<span class="fa fa-search"></span>' + '</a>' + '</div>'
    }, {
      displayName: 'Codice',
      field: 'current.model.code'
    }, {
      displayName: 'Descrizione',
      field: 'current.model.description'
    }, {
      displayName: 'Tipo',
      field: 'current.schemaCode',
      cellTemplate: '<div class="ui-grid-cell-contents">{{grid.appScope.schemaCodeFormatter(grid.getCellValue(row, col))}}</div>'
    }, {
      displayName: 'Variazioni',
      field: 'current.UUID',
      width: 500,
      cellTemplate: '<div class="ui-grid-cell-contents"><span ng-bind-html="grid.appScope.diffFormatter(row.entity)"></span></div>'
    }, {
      displayName: 'Data Variazione',
      type: 'date',
      width: 150,
      cellFilter: 'date:\'yyyy-MM-dd HH:mm:ss\'',
      field: 'current.dataIn'
    }]
  };
  $scope.gridOptions.exporterFieldCallback = function (grid, row, col, value) {
    if (col.displayName === 'Variazioni') {
      value = formatValue(row);
    }
    return value;
  };
  function formatValue(row) {
    var result = $scope.diffFormatter(row.entity);
    return removeHtmlTagFromString(result);
  }
  function removeHtmlTagFromString(htmlstring) {
    var dom = $('<div>').html(htmlstring);
    var result = '';
    if (dom && dom.length) {
      result = dom[0].textContent;
    }
    return result;
  }
  $scope.knownSchema = [];
  $scope.loadKnownSchema = function () {
    if (Array.isArray($scope.typeList) && $scope.typeList.length > 0) {
      if (Array.isArray($scope.knownSchema) && $scope.knownSchema.length > 0) {
        return $q.resolve($scope.knownSchema);
      } else {
        if (Array.isArray($scope.knownSchema)) {
          var filters = {
            'typeIdFilter': sixFiltersLib["in"]('UUID', $scope.typeList)
          };
          var payload = {
            show_revision: false
          };
          $scope.knownSchema = schemaFactory().search(payload, filters).$promise.then(function (result) {
            $scope.knownSchema = result.list;
            return result;
          });
        }
        return $scope.knownSchema;
      }
    } else {
      return $q.resolve($scope.knownSchema);
    }
  };
  $scope.schemaCodeFormatter = function (value) {
    $scope.loadKnownSchema();
    var formatted = value;
    if (Array.isArray($scope.knownSchema)) {
      $scope.knownSchema.forEach(function (v) {
        if (v.model.code == value) {
          formatted = v.model.description;
        }
      });
    }
    return formatted;
  };
  $scope.diffFormatter = function (obj) {
    var readableDiffs = [];
    var modelDiff = diff.getDiff(obj.prev.model, obj.current.model, {
      strictNullCheck: false
    });
    var parentDiff = diff.getDiff(obj.prev.parents, obj.current.parents, {
      strictNullCheck: false
    });
    if (Object.keys(parentDiff).length) {
      if (obj.current.parents == null) {
        readableDiffs.push("<strong>Rimosso dal tree</strong>");
      } else if (obj.prev.parents == null) {
        var currentTree = $scope.treeFormatter(obj.current.parents);
        readableDiffs.push("<strong>Inserito su tree:</strong> " + currentTree);
      } else {
        var prevTree = $scope.treeFormatter(obj.prev.parents);
        var currentTree = $scope.treeFormatter(obj.current.parents);
        readableDiffs.push("<strong>Spostamento nel tree da:</strong> " + prevTree + "<strong> a </strong> " + currentTree);
      }
    }
    if (Object.keys(modelDiff).length) {
      angular.forEach(modelDiff, function (value, path) {
        var key = path.replace(/^\/([^\/]*).*$/, '$1');
        var keyDef = $scope.searchKeyInSchema(key, obj.current.schemaCode);
        var readableKey = keyDef.title;
        var oldValue = $scope.formatValue(obj.prev, keyDef, path);
        var newValue = $scope.formatValue(obj.current, keyDef, path);
        if (value.operation == "update" && oldValue && newValue) {
          readableDiffs.push("<strong>Modifica</strong> <span class=\"field\">" + readableKey + "</span>," + " <strong>da</strong> <span class=\"oldvalue\">" + oldValue + "</span>" + " <strong>a</strong> <span class=\"newvalue\">" + newValue + "</span>");
        } else if (value.operation == "add" && newValue) {
          readableDiffs.push("<strong>Inserito</strong> <span class=\"field\">" + readableKey + "</span>: " + "<span class=\"newvalue\">" + newValue + "</span>");
        } else if (value.operation == "delete" && oldValue) {
          readableDiffs.push("<strong>Eliminato</strong> <span class=\"field\">" + readableKey + "</span>." + " <strong>Valore precedente:</strong> <span class=\"oldvalue\">" + oldValue + "</span>");
        }
      });
    }
    return readableDiffs.join(';<br>');
  };
  $scope.treeFormatter = function (parents) {
    return "/" + parents.map(function (v) {
      if (v.code || v.treeLevel == 0) {
        var titleParts = [];
        if (v.type) {
          titleParts.push($scope.schemaCodeFormatter(v.type));
        }
        if (v.description) {
          titleParts.push(v.description);
        }
        if (!v.code && v.treeLevel == 0) {
          v.code = v.treeCode;
        }
        return '<span class="treeNode" title="' + titleParts.join(' - ') + '">' + v.code + '</span>';
      }
    }).join('/');
  };
  $scope.searchKeyInSchema = function (key, schemaCode) {
    $scope.loadKnownSchema();
    var formatted = {
      title: key,
      field: key
    };
    if (Array.isArray($scope.knownSchema)) {
      $scope.knownSchema.forEach(function (v) {
        if (v.model.code == schemaCode) {
          if (angular.isDefined(v.model.schema.properties[key])) {
            formatted = v.model.schema.properties[key];
            formatted.field = key;
          }
        }
      });
    }
    return formatted;
  };
  $scope.formatValue = function (source, keyDef, path) {
    var val = source.model[keyDef.field];
    if (val && keyDef.format == "lookup") {
      val = val.description + " (" + val.code + ")";
    }
    if (_typeof(val) == 'object' && val != null) val = formatObjType(val, path);
    //TODO: gestire ad-hoc altri formati?
    if (keyDef.title != "attachments" && (path.match(/\//g) || []).length > 1 && path.indexOf("UUID") == -1) {
      return false; //skippo le variazioni delle sottochiavi a meno che non sia un UUID
    }

    return val;
  };
  function isPlainObject(input) {
    return input && !Array.isArray(input) && _typeof(input) === 'object';
  }
  function formatObjType(element, path) {
    if (isPlainObject(element)) return formatPlainObj(element, path);else return formatArray(element, path);
  }
  function formatPlainObj(obj, path) {
    if (obj.folder) return formatFolder(obj, path);else return obj.code + " - " + obj.description;
  }
  function formatFolder(el, path) {
    var result = el;
    var keys = path.substr(1, path.length).split("/");
    for (var i in keys) {
      var k = keys[i];
      if (result[k]) result = result[k];
    }
    return result.title;
  }
  function formatArray(arr, path) {
    if (Array.isArray(arr)) {
      var result = [];
      arr.forEach(function (el) {
        if (el) {
          if (isPlainObject(el)) result.push(formatPlainObj(el, path));else result.push(v.code + " - " + v.description);
        }
      });
      return result;
    }
    console.error("Type error: provided data was not an array");
    return undefined;
  }
  $scope.typeIdFilter = null;
  $scope.typeList = null;
  treeUtilities.getFlatStructureUuids().then(function (types) {
    if (types) {
      $scope.typeIdFilter = {
        'typeIdFilter': sixFiltersLib["in"]('UUID', types)
      };
      $scope.typeList = types;
      if (!$routeParams.type) {
        $scope.getVariationsList();
      }
    }
  });
  $scope.dateFormat = 'dd/MM/yyyy';
  $scope.dateOptionsFrom = {
    formatYear: 'yyyy',
    startingDay: 1,
    datepickerMode: 'day',
    minMode: 'day',
    maxMode: 'year'
  };
  $scope.dateOptionsTo = {
    formatYear: 'yyyy',
    startingDay: 1,
    datepickerMode: 'day',
    minMode: 'day',
    maxMode: 'year'
  };
  $scope.getVariationsList = function () {
    var filters = {};
    var searchType = null;
    if ($scope.search.type_id) {
      searchType = $scope.search.type_id.UUID;
      filters['typeIdFilter'] = sixFiltersLib.exact('schemaCode', $scope.search.type_id.UUID);
    } else if ($scope.typeList) {
      filters['typeIdFilter'] = sixFiltersLib["in"]('schemaCode', $scope.typeList);
    }
    if ($scope.search.record_id.length > 0) {
      var uuids = $scope.search.record_id.map(function (v) {
        return v.UUID;
      });
      filters['recordIdFilter'] = sixFiltersLib["in"]('UUID', uuids);
      uuids = uuids.join(",");
    }
    var urlSearch = {
      'from': $scope.search.from.toISOString(),
      'to': $scope.search.to.toISOString(),
      'schema': searchType,
      'record': uuids
    };
    $location.search(urlSearch);
    var payload = {
      from: $scope.search.from,
      to: $scope.search.to
    };
    return recordFactory("any").getChanges(payload, filters).$promise.then(function (data) {
      $scope.gridOptions.data = data.list;
      return data;
    });
  };
  $scope.diffSelected = function () {
    //costruisce l'url in base ai dati selezionati ed esegue la navigazione verso l'url
    var toDiff = $scope.gridApi.selection.getSelectedRows();
    var url = "/diff/" + toDiff[0].current.schemaCode + "/" + toDiff[0].current.version + "/vs/";
    if (toDiff.length == 1) {
      url += toDiff[0].prev.version;
    } else if (toDiff.length == 2) {
      url += toDiff[1].current.version;
    }
    $location.search({});
    $location.path(url);
  };
  $scope.noDiffReason = "";
  $scope.canDiff = function () {
    //verifica che ci siano almeno 2 dati selezionati dello stesso tipo
    var toDiff = $scope.gridApi.selection.getSelectedRows();
    if (toDiff.length < 1) {
      $scope.noDiffReason = "Devi selezionare almeno 1 riga";
      return false;
    } else if (toDiff.length == 2) {
      if (toDiff[0].current.schemaCode != toDiff[1].current.schemaCode || toDiff[0].current.UUID != toDiff[1].current.UUID) {
        $scope.noDiffReason = "Le versioni selezionate non sono dello stesso asset";
        return false;
      }
    } else if (toDiff.length > 2) {
      $scope.noDiffReason = "Puoi selezionare al massimo 2 versioni dello stesso asset";
      return false;
    }
    $scope.noDiffReason = "";
    return true;
  };
  $scope.clearAsset = function (type) {
    $scope.search.record_id = [];
  };
  $scope.back = function () {
    $window.history.back();
  };
  $scope.gotoLeftVersion = function () {
    var obj = $scope.leftVersion;
    $location.path("/record/snap/" + obj.schemaCode + "/" + obj.UUID + "/v/" + obj.version);
  };
  $scope.gotoRightVersion = function () {
    var obj = $scope.rightVersion;
    $location.path("/record/snap/" + obj.schemaCode + "/" + obj.UUID + "/v/" + obj.version);
  };
  function disableFormFields(form, fieldNames) {
    if (Array.isArray(form)) {
      for (var i in form) {
        form[i] = disableFormFields(form[i], fieldNames);
      }
    }
    if (!Array.isArray(fieldNames)) {
      fieldNames = [fieldNames];
    }
    if ("key" in form) {
      var intersection = [];
      if (Array.isArray(fieldNames) && Array.isArray(form.key)) {
        intersection = form.key.filter(function (n) {
          return fieldNames.indexOf(n) !== -1;
        });
      }
      if (!fieldNames || intersection.length) {
        form.htmlClass = "diff-highlight";
      } else {
        form.htmlClass = "de-emphasize";
      }
      //fix per evitare lo styling della validazione
      form.disableSuccessState = true;
      form.disableErrorState = true;
      form.feedback = false;
    } else {
      for (var i in form) {
        if (Object.prototype.hasOwnProperty.call(form, i) && Array.isArray(form[i])) {
          form[i] = disableFormFields(form[i], fieldNames);
        }
      }
    }
    return form;
  }

  //___ main ___
  if ($routeParams.type) {
    var type = $routeParams.type;
    schemaFactory().byCode({
      id: type
    }).$promise.then(function (schemaResult) {
      var loadLeft = recordFactory(type).byID({
        id: $routeParams.diffversion
      }).$promise.then(function (result) {
        $scope.leftVersion = result;
        if (result.parents) $scope.leftTree = $scope.treeFormatter(result.parents);
        return result;
      });
      var loadRight = recordFactory(type).byID({
        id: $routeParams.version
      }).$promise.then(function (result) {
        $scope.rightVersion = result;
        if (result.parents) $scope.rightTree = $scope.treeFormatter(result.parents);
        return result;
      });
      $q.all([loadLeft, loadRight]).then(function (results) {
        var modelDiff = diff.getDiff($scope.leftVersion.model, $scope.rightVersion.model, {
          strictNullCheck: false
        });
        var fields = Object.keys(modelDiff).map(function (path) {
          return path.replace(/^\/([^\/]*).*$/, '$1');
        });
        $scope.schema = schemaResult.model.schema;
        $scope.form = disableFormFields(schemaResult.model.form, fields);
      });
    });
  }
}]);
'use strict';

/**
 * @ngdoc function
 * @name emma.dataset.controller:DrawingCtrl
 * @description
 * # DrawingCtrl
 * Controller of the emma.dataset
 */
angular.module('emma.dataset').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/drawing/:uuid', {
    templateUrl: 'dataset/drawing/drawing_detail.html',
    controller: 'DrawingCtrl'
  });
}]).controller('DrawingCtrl', ["$scope", "$routeParams", "drawingFactory", function ($scope, $routeParams, drawingFactory) {
  $scope.drawing = {};
  if ($routeParams.uuid && 'new' !== $routeParams.uuid) {
    $scope.drawingUuid = $routeParams.uuid;
    drawingFactory.getDrawingById({
      uuid: $routeParams.uuid
    }).$promise.then(function (data) {
      $scope.drawing.all = JSON.stringify(data, null, '\t');
      $scope.drawing.blocks = data.list[0].model.blocks;
      $scope.drawing.layers = data.list[0].model.layers;
    });
  }
}]);
'use strict';

/**
 * @ngdoc function
 * @name emma.dataset.controller:DrawingListCtrl
 * @description
 * # DrawingListCtrl
 * Controller of emma.dataset
 */
angular.module('emma.dataset').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/drawing', {
    templateUrl: 'dataset/drawing/drawinglist.html',
    controller: 'DrawingListCtrl'
  });
}]).controller('DrawingListCtrl', ["$scope", "FileUploader", "drawingFactory", "toaster", "$filter", "$log", "authHttpRequestInterceptor", function ($scope, FileUploader, drawingFactory, toaster, $filter, $log, authHttpRequestInterceptor) {
  $scope.rows = {
    list: [],
    totalResults: 0
  };
  $scope.params = {
    pageNumber: 0,
    pageSize: 10,
    filters: {}
  };
  $scope.viewGridOptions = {
    enableFiltering: true,
    enableOrdering: true,
    showGridFooter: true,
    enableHorizontalScrollbar: 1,
    columnDefs: [{
      displayName: '',
      field: 'id',
      width: 36,
      enableHiding: false,
      enableColumnMenu: false,
      enableFiltering: false,
      enableSorting: false,
      cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/drawing/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' + '<span class="fa fa-search"></span>' + '</a>' + '</div>'
    }, {
      displayName: 'Codice',
      field: 'model.code'
    }, {
      displayName: 'Descrizione',
      field: 'model.description'
    }, {
      displayName: 'Layer principale',
      field: 'model.main_layer'
    }]
  };
  $scope.getList = function () {
    var payload = {
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      history: false
    };
    return drawingFactory.search(payload, $scope.params.filters).$promise.then(function (result) {
      $scope.rows.list = result.list || [];
      $scope.rows.totalResults = result.totalResults;
      $scope.params.sixApi.refreshList(result.list);
      return result;
    });
  };

  //file upload
  var uploaderOptions = authHttpRequestInterceptor.request({
    url: drawingFactory.uploadPath,
    disableMultipart: true,
    queueLimit: 1,
    removeAfterUpload: false,
    filters: [{
      name: 'drawingFilter',
      fn: function fn(item /*{File|FileLikeObject}*/, options) {
        return !!item.type.match(/.*(dxf|dwg)$/);
      }
    }]
  });
  var uploader = $scope.uploader = new FileUploader(uploaderOptions);
  FileUploader.FileSelect.prototype.isEmptyAfterSelection = function () {
    return true;
  };
  $scope.resetUploadStatus = function (dontHide) {
    toaster.clear($scope.toastInstance);
    uploader.clearQueue();
    $scope.upload = {
      show: dontHide ? true : false,
      readyToSend: false,
      lastfile: false
    };
  };
  $scope.resetUploadStatus();
  uploader.onWhenAddingFileFailed = function (file, filter, options) {
    if (filter.name == 'queueLimit') {
      toaster.pop('warning', 'Errore', 'Puoi caricare al massimo 1 file. Rifiutato il file: ' + file.name);
    } else if (filter.name == 'drawingFilter') {
      toaster.pop('warning', 'Errore', 'Estensione del file non valida: ' + file.name);
    } else {
      toaster.pop('warning', 'Errore', 'Impossibile aggiungere il file selezionato');
    }
  };
  uploader.onBeforeUploadItem = function (item) {
    item.headers['filename'] = item.file.name;
  };
  uploader.onAfterAddingAll = function (addedFileItems) {
    var file = addedFileItems[0].file;
    $scope.upload.lastfile = file.name + " (" + $filter("bytes")(file.size) + ")";
    $scope.upload.readyToSend = true;
  };
  uploader.onSuccessItem = function (item, response, status, headers) {
    $log.debug("Upload completed", response);
    $scope.resetUploadStatus();
    $scope.getList();
  };
  uploader.onErrorItem = function (fileItem, response, status, headers) {
    toaster.pop('Errore', 'Errore', 'Errore nell\'elaborazione del file ' + fileItem.file.name);
    $scope.resetUploadStatus();
  };
  $scope.doUpload = function () {
    $log.debug(uploader);
    uploader.uploadAll();
    $scope.upload.readyToSend = false;
    $scope.toastInstance = toaster.pop({
      type: 'warning',
      title: 'Upload',
      body: 'Upload file in corso, non ricaricare la pagina.',
      timeout: 0
    });
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name emma.dataset.controller:ExportCtrl
 * @description
 * # ExportCtrl
 * Controller of the emma.dataset
 */
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
angular.module('emma.dataset').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/export', {
    templateUrl: 'dataset/export/export.html',
    controller: 'ExportCtrl'
  });
}]).controller('ExportCtrl', ["$scope", "$routeParams", "schemaFactory", "recordFactory", "zonaTermicaFactory", "uiGridConstants", "authFactory", "sixGridPaginationConstants", "commissionFactory", "toaster", "$q", "loadingBarService", function ($scope, $routeParams, schemaFactory, recordFactory, zonaTermicaFactory, uiGridConstants, authFactory, sixGridPaginationConstants, commissionFactory, toaster, $q, loadingBarService) {
  $scope.limit = 10000;
  $scope.typeExport = 'export';
  $scope.entity = {};
  $scope.schema = {};
  $scope.data = [];
  $scope.isEntitySelected = false;
  $scope.exportList = {
    list: []
  };
  $scope.extraColumnsToExport = {
    list: [{
      key: 'UUID',
      description: 'UUID'
    }, {
      key: 'version',
      description: 'Version'
    }],
    selected: []
  };
  $scope.params = {
    pageNumber: 1,
    pageSize: 100,
    totalItems: 0,
    filters: {}
  };
  $scope.gridAppCallbacks = {};
  $scope.date = {
    currentDate: new Date()
  };
  $scope.viewGridOptions = {
    enableSorting: true,
    enableGridMenu: true,
    exporterCsvColumnSeparator: ';',
    exporterMenuPdf: false,
    enableFiltering: true,
    enableColumnResizing: true,
    paginationPageSizes: [100, 250, 500, 1000, 10000],
    paginationPageSize: 100,
    totalItems: 0,
    useExternalPagination: true,
    useExternalFiltering: true,
    multiSelect: true,
    enableRowHeaderSelection: true,
    enableRowSelection: true,
    columnDefs: [{
      name: ' '
    }]
  };
  $scope.commissionFilter = 'current';
  $scope.currentCommission = authFactory.getAuthData().info.commissions.current;
  $scope.currentCustomer = authFactory.getCurrentCustomer();
  $scope.operation = authFactory.getAuthData().info.operations["record/{entity}"].filter(function (op) {
    return op.name == 'EXPORT_VERSION' || op.name == 'ALL';
  }).reduce(function (op, item) {
    op[item.name] = item.permitted;
    return op;
  }, {});
  $scope.addParentsJSON = $routeParams.parents;
  var commissions = {
    authorizedCodes: authFactory.getAuthData().profiles.filter(function (p) {
      return p.type == 'commission';
    }).map(function (p) {
      return p.code;
    }),
    /* Promise */
    openedCodes: commissionFactory().search({
      page_size: 10000
    }, {
      'closed': sixFiltersLib.exact('status', 'closed')
    }).$promise.then(function (response) {
      if (response && response.list && response.list.length) {
        var closed = response.list.map(function (c) {
          return c.code;
        });
        return commissions.authorizedCodes.filter(function (c) {
          return closed.indexOf(c) < 0;
        });
      }
      return commissions.authorizedCodes;
    })
  };
  var customerMap = {};
  $scope.$watchGroup(['entity.type', 'limit', 'date.currentDate', 'date.toDate', 'commissionFilter'], function (newValue, oldValue) {
    $scope.isEntitySelected = angular.isDefined(newValue[0]);
    if ($scope.isEntitySelected == true && newValue != oldValue) {
      var typeUUID = $scope.entity.type.UUID;

      // getting schema of entity.type
      schemaFactory().byUUID({
        id: typeUUID
      }).$promise.then(function (response) {
        $scope.schema = response;
        if ($scope.schema.model.columnDefs) {
          $scope.viewGridOptions.columnDefs.length = 0;
          angular.forEach($scope.schema.model.columnDefs, function (colDef) {
            //colDef has name and field -> {name: 'Codice', field: 'code'}
            var newColDef = {
              displayName: $scope.schema.model.schema.properties[colDef.field].title,
              field: 'model.' + colDef.field,
              filters: [{
                type: 'text',
                condition: uiGridConstants.filter.CONTAINS,
                placeholder: ''
              }],
              enableFiltering: true
            };
            if ($scope.schema.model.schema.properties[colDef.field].type === 'string') {
              // specific filters for lookup and dates
              if ($scope.schema.model.schema.properties[colDef.field].format === 'lookup') {
                newColDef.field = 'model.' + colDef.field;
                newColDef.cellTemplate = '<div class="ui-grid-cell ui-grid-cell-contents {{grid.appScope.cellClassFormatter(undefined, row)}}" title="{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}">{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}</div>';
                newColDef.filters = [{
                  type: sixGridPaginationConstants.filterType.SIXLOOKUP,
                  condition: uiGridConstants.filter.CONTAINS,
                  placeholder: ''
                }];
              }
              if ($scope.schema.model.schema.properties[colDef.field].format === 'commissionmapper') {
                //specific filters for commission mappers
                newColDef.field = 'model.' + colDef.field;
                newColDef.cellTemplate = '<div class="ui-grid-cell ui-grid-cell-contents {{grid.appScope.cellClassFormatter(undefined, row)}}" title="{{grid.appScope.cmapperCellValueFormatter(grid.getCellValue(row, col))}}">{{grid.appScope.cmapperCellValueFormatter(grid.getCellValue(row, col))}}</div>';
                newColDef.filters = [{
                  type: sixGridPaginationConstants.filterType.TEXT,
                  condition: uiGridConstants.filter.CONTAINS,
                  placeholder: ''
                }];
              }
              if ($scope.schema.model.schema.properties[colDef.field].format === 'date') {
                newColDef.filters = [{
                  type: 'date',
                  relation: 'gte',
                  placeholder: 'da...',
                  condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
                }, {
                  type: 'date',
                  relation: 'lte',
                  placeholder: 'a...',
                  condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
                }];
              }
            }
            if ($scope.schema.model.schema.properties[colDef.field].type === 'number') {
              // specific filters for numbers
              newColDef.filters = [{
                type: 'number',
                relation: 'gte',
                placeholder: 'da...',
                condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
              }, {
                type: 'number',
                relation: 'e',
                placeholder: 'uguale a...',
                condition: uiGridConstants.filter.EXACT
              }, {
                type: 'number',
                relation: 'lte',
                placeholder: 'a...',
                condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
              }];
            }
            $scope.viewGridOptions.columnDefs.push(newColDef);
          });
          $scope.viewGridOptions.columnDefs.push({
            displayName: 'Commessa',
            field: 'commission',
            cellTemplate: '<div class="ui-grid-cell ui-grid-cell-contents {{grid.appScope.cellClassFormatter(undefined, row)}}" title="{{grid.appScope.commissionFormatter(grid.getCellValue(row, col))}}">{{grid.appScope.commissionFormatter(grid.getCellValue(row, col))}}</div>',
            filters: [{
              type: 'text',
              condition: uiGridConstants.filter.CONTAINS,
              placeholder: ''
            }],
            enableFiltering: true
          });
        }
        $scope.getExportList();
      });
    }
  });
  $scope.commissionFormatter = function (value) {
    if (value) {
      return JSON.stringify(value).replace(new RegExp('["\[\\]]', 'g'), '');
    }
    return '';
  };
  $scope.gridAppCallbacks['commissionFormatter'] = $scope.commissionFormatter;
  $scope.lookupCellValueFormatter = function (value) {
    var formatted = "";
    if (typeof value != "undefined") {
      if (Object.prototype.toString.call(value) === '[object Array]') {
        for (var v in value) {
          formatted += value[v].code + " (" + value[v].description + "); ";
        }
      } else {
        formatted = value.code + " (" + value.description + ")";
      }
    }
    return formatted;
  };
  $scope.gridAppCallbacks['lookupCellValueFormatter'] = $scope.lookupCellValueFormatter;
  $scope.cmapperCellValueFormatter = function (value) {
    var formatted = "";
    if (typeof value != "undefined") {
      if (value !== null && _typeof(value) === 'object') {
        angular.forEach(value, function (row, commission) {
          formatted += commission + ": " + row.code + " (" + row.description + "); \n";
        });
      } else {
        formatted = value;
      }
    }
    return formatted;
  };
  $scope.gridAppCallbacks['cmapperCellValueFormatter'] = $scope.cmapperCellValueFormatter;

  // Inserisce la colonna 'version' tra le colonne extra da esportare (chiamata quando si seleziona 'esportazione per reimportaz. versionata')
  $scope.setVersionColumn = function () {
    if ($scope.extraColumnsToExport.selected) {
      var exist = false;
      $scope.extraColumnsToExport.selected.forEach(function (col) {
        if (col.key === 'version') {
          exist = true;
        }
      });
      if (!exist) {
        $scope.extraColumnsToExport.selected.push({
          key: 'version',
          description: 'Version'
        });
      }
    }
  };
  $scope.getExportList = function () {
    var promise = {};
    return buildFiltersAndPayload().then(function (filtersAndPayload) {
      if ($scope.entity.type.UUID != 'zonatermica') {
        promise = recordFactory($scope.entity.type.UUID).search(filtersAndPayload.payload, filtersAndPayload.filters).$promise;
      } else {
        // endpoint per le zt: in modo da risolvere la colonna dei gradi giorno stagione termica
        promise = zonaTermicaFactory.search(filtersAndPayload.payload, filtersAndPayload.filters).$promise;
      }
      // aspetto la risposta
      return promise.then(function (data) {
        $scope.params.totalItems = data.totalResults;
        $scope.viewGridOptions.totalItems = data.totalResults;
        $scope.exportList.totalResults = data.totalResults;
        $scope.exportList.list = data.list;
        // injectTreeColumns($scope.viewGridOptions.columnDefs, $scope.exportList.list);
        data.list.forEach(function (row) {
          var commission = row['commission'];
          var customer = row['customer'];
          var treeCode = getTreeCode(commission, customer);
          var parent = findParent(row, treeCode);
          if (parent) {
            if (!parent.type || !parent.code) {
              parent.type = 'definition';
              parent.code = treeCode;
            }
            row['parent_type'] = parent.type;
            row['parent_code'] = parent.code;
          } else {
            row['parent_type'] = "";
            row['parent_code'] = "";
          }
        });
        $scope.params.sixApi.refreshList(data.list);
        return data;
      });
    });
  };
  function buildFiltersAndPayload() {
    var deferred = $q.defer();
    var payload = {
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      sort_fields: $scope.params.sortFields,
      show_revision: $scope.typeExport == 'exportToImportVersioned',
      cross: $scope.commissionFilter != 'current',
      solve_inherit: true
    };
    var filters = angular.copy($scope.params.filters);
    if ($scope.typeExport == 'exportToImportVersioned') {
      if ($scope.date.toDate) {
        filters.in_lte = sixFiltersLib.rangeLte("dataIn", moment($scope.date.toDate).endOf('day').format());
      }
      if ($scope.date.currentDate) {
        filters.dateOut = sixFiltersLib.must({
          out_gte: sixFiltersLib.rangeGte("dataOut", moment($scope.date.currentDate).startOf('day').format(), sixFiltersLib.CONSTRAINTS.OR),
          out_mis: sixFiltersLib.missing("dataOut", sixFiltersLib.CONSTRAINTS.OR)
        });
      }
    } else if ($scope.date.currentDate) {
      payload.currentDate = moment($scope.date.currentDate).endOf('day').format();
    }
    if ($scope.commissionFilter == 'open') {
      commissions.openedCodes.then(function (commisionsCodes) {
        filters.commissions = sixFiltersLib.must({
          "in": sixFiltersLib["in"]('commission', commisionsCodes, 'or'),
          "missed": sixFiltersLib.missing('commission', 'or')
        });
        deferred.resolve({
          filters: filters,
          payload: payload
        });
      }, function (err) {
        console.error(err);
        deferred.reject('Unable to build open commission filter');
      });
    } else if ($scope.commissionFilter == 'all') {
      filters.commissions = sixFiltersLib.must({
        "in": sixFiltersLib["in"]('commission', commissions.authorizedCodes, 'or'),
        "missed": sixFiltersLib.missing('commission', 'or')
      });
      deferred.resolve({
        filters: filters,
        payload: payload
      });
    } else {
      deferred.resolve({
        filters: filters,
        payload: payload
      });
    }
    return deferred.promise;
  }
  $scope.exportXLSX = function () {
    // preparo colonne
    var columns = [];
    angular.forEach($scope.schema.model.schema.properties, function (property, key) {
      var column = {
        key: 'model.' + key,
        name: $scope.typeExport == 'exportToImport' || $scope.typeExport == 'exportToImportVersioned' ? key : property.title
      };
      if (property.hasOwnProperty('format') && property.format == 'lookup' && property.hasOwnProperty('multiple') && property.multiple == true) {
        column.transform = multiLookupTransformer;
      }
      if (property.hasOwnProperty('format') && (property.format == 'datepicker' || property.format == 'date')) {
        column.t = 'd';
        if ($scope.typeExport == 'exportToImport' || $scope.typeExport == 'exportToImportVersioned') {
          column.format = 'YYYY\-MM\-DD';
        }
      }
      columns.push(column);
    });
    if ($scope.typeExport == 'export') {
      columns.push({
        key: 'commission',
        name: 'Commessa'
      });
      columns.push({
        key: 'dataIn',
        name: 'Inizio validità',
        t: 'd'
      });
      columns.push({
        key: 'dataOut',
        name: 'Fine validità',
        t: 'd'
      });
    } else {
      columns.push({
        key: 'commission',
        name: 'commission'
      });
      columns.push({
        key: 'dataIn',
        name: 'dataIn',
        t: 'd',
        format: 'YYYY\-MM\-DD'
      });
      columns.push({
        key: 'dataOut',
        name: 'dataOut',
        t: 'd',
        format: 'YYYY\-MM\-DD'
      });
      columns.push({
        key: 'customer',
        name: 'customer'
      });
    }
    if ($scope.extraColumnsToExport.selected) {
      $scope.extraColumnsToExport.selected.forEach(function (col) {
        if ($scope.typeExport == 'export') {
          columns.push({
            key: col.key,
            name: col.description
          });
        } else {
          columns.push({
            key: col.key,
            name: col.key
          });
        }
      });
    }

    // preparo righe
    var rows = $scope.params.gridApi.selection.getSelectedRows();
    if (!rows || rows.length == 0) {
      buildFiltersAndPayload().then(function (request) {
        request.payload.sort_fields = $scope.typeExport == 'exportToImportVersioned' ? 'UUID;dataIn:desc' : undefined;
        request.payload.solve_inherit = $scope.typeExport == 'export';
        loadData(request.payload, request.filters, columns);
      }, function (err) {
        console.error(err);
      });
    } else {
      injectTreeColumns(columns, rows);
      resolveCustomersCodes(rows);
      sixExportLib.exportXLSX(columns, rows, $scope.entity.type.description, $scope.typeExport == 'export');
    }
  };
  function resolveCustomersCodes(rows) {
    rows.forEach(function (row) {
      if (row.customer && row.customer[0] && customerMap[row.customer[0]]) row.customer = customerMap[row.customer[0]];
    });
  }
  $scope.setCommissionFilter = function (value) {
    switch (value) {
      case 'open':
        commissions.openedCodes.then(function (codes) {
          if (codes.length == 0) {
            toaster.warning('Tutte le commesse a cui sei abilitato sono chiuse');
          } else {
            $scope.commissionFilter = 'open';
          }
        }, function () {
          toaster.error('Impossibile scaricare le commesse!');
        });
        break;
      case 'all':
        if (commissions.authorizedCodes.length == 1) {
          toaster.info('Sei autorizzato a vedere solo la commessa corrente');
          break;
        }
      default:
        $scope.commissionFilter = value;
    }
  };
  $scope.getCommissionFilterLabel = function () {
    switch ($scope.commissionFilter) {
      case 'current':
        return $scope.currentCommission.code;
      case 'open':
        return 'Aperte';
      case 'all':
        return 'Tutte';
    }
  };
  function loadData(payload, filters, columns) {
    loadingBarService.start('Preparazione file in corso...');
    var promise;
    if ($scope.entity.type.UUID != 'zonatermica') {
      promise = recordFactory($scope.entity.type.UUID).fetchAll(payload, filters).$promise;
    } else {
      // endpoint per le zt: in modo da risolvere la colonna dei gradi giorno stagione termica
      promise = zonaTermicaFactory.fetchAll(payload, filters).$promise;
    }
    // aspetto la risposta...
    promise.then(function (rows) {
      injectTreeColumns(columns, rows);
      resolveCustomersCodes(rows);
      loadingBarService.stop();
      sixExportLib.exportXLSX(columns, rows, $scope.entity.type.description, $scope.typeExport == 'export');
    }, function (error) {
      console.error(error);
      loadingBarService.stop();
    });
  }
  function multiLookupTransformer(v) {
    if (Array.isArray(v) && v.length) {
      for (var i = v.length; i--;) {
        v[i] = v[i].code;
      }
    }
    return v;
  }
  function injectTreeColumns(columns, rows) {
    var PARENT_TYPE_COLUMN = "parent_type";
    var PARENT_CODE_COLUMN = "parent_code";
    if (columns && rows) {
      if ($scope.addParentsJSON && $scope.typeExport != 'export') {
        columns.push({
          key: 'parents',
          name: 'parents'
        });
        rows.forEach(function (row) {
          row.parents = row.parents ? JSON.stringify(row.parents) : "[]";
        });
      } else {
        if ($scope.typeExport === 'export') {
          columns.unshift({
            key: PARENT_CODE_COLUMN,
            name: "Codice genitore"
          });
          columns.unshift({
            key: PARENT_TYPE_COLUMN,
            name: "Tipo genitore"
          });
        } else {
          columns.unshift({
            key: PARENT_CODE_COLUMN,
            name: PARENT_CODE_COLUMN
          });
          columns.unshift({
            key: PARENT_TYPE_COLUMN,
            name: PARENT_TYPE_COLUMN
          });
        }
        rows.forEach(function (row) {
          var commission = row['commission'];
          var customer = row['customer'];
          var treeCode = getTreeCode(commission, customer);
          var parent = findParent(row, treeCode);
          if (parent) {
            if (!parent.type || !parent.code) {
              parent.type = 'definition';
              parent.code = treeCode;
            }
            row[PARENT_TYPE_COLUMN] = parent.type;
            row[PARENT_CODE_COLUMN] = parent.code;
          } else {
            row[PARENT_TYPE_COLUMN] = "";
            row[PARENT_CODE_COLUMN] = "";
          }
        });
      }
    }
  }
  function findParent(document, treeCode) {
    if (document.parents) {
      for (var d in document.parents) {
        if (document.parents[d].treeCode == treeCode) {
          if (document.parents[d].treeLevel === document.parents[d].treeTotalLevels - 1) {
            return document.parents[d];
          }
        }
      }
    }
    return;
  }
  function getTreeCode(commission, customer) {
    var code = 'def' + (commission && commission[0] ? commission[0] : $scope.currentCommission.code);
    if (customer && customer[0]) code += 'cli' + customer[0];
    return code;
  }
  function init() {
    recordFactory('cliente').search({
      page_size: 10000
    }, {}).$promise.then(function (response) {
      response.list.forEach(function (customer) {
        customerMap[customer.UUID] = customer.model.code;
      });
    });
  }
  init();
}]);
'use strict';

/**
 * @ngdoc function
 * @name emma.dataset.controller:ExportcrossCtrl
 * @description
 * # ExportcrossCtrl
 * Controller of the emma.dataset
 */
angular.module('emma.dataset').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/exportcross', {
    templateUrl: 'dataset/export/exportcross.html',
    controller: 'ExportcrossCtrl'
  });
}]).controller('ExportcrossCtrl', ["$scope", "$log", "schemaFactory", "authFactory", "loginFactory", "$location", "recordFactory", "zonaTermicaFactory", "dialogService", "errorService", "uiGridExporterService", "uiGridExporterConstants", "uiGridConstants", "sixGridPaginationConstants", "commissionFactory", function ($scope, $log, schemaFactory, authFactory, loginFactory, $location, recordFactory, zonaTermicaFactory, dialogService, errorService, uiGridExporterService, uiGridExporterConstants, uiGridConstants, sixGridPaginationConstants, commissionFactory) {
  $scope.limit = 10000;
  $scope.typeExport = 'export';
  $scope.commissionFilter = 'current';
  $scope.closedCommissions = [];
  $scope.entity = {};
  $scope.schema = {};
  $scope.data = [];
  $scope.isEntitySelected = false;
  $scope.exportList = {
    list: []
  };
  $scope.params = {
    pageNumber: 1,
    pageSize: 100,
    totalItems: 0,
    filters: {}
  };
  $scope.typeName = '';
  $scope.historyMode = '';
  $scope.gridAppCallbacks = {};
  $scope.currentCommission = authFactory.getAuthData().info.commissions.current;
  $scope.currentCustomer = authFactory.getCurrentCustomer();
  $scope.viewGridOptions = {
    //appScopeProvider: this,
    enableSorting: true,
    enableGridMenu: true,
    exporterCsvColumnSeparator: ';',
    exporterMenuPdf: false,
    enableFiltering: true,
    enableColumnResizing: true,
    paginationPageSizes: [100, 250, 500, 1000, 10000],
    paginationPageSize: 100,
    totalItems: 0,
    useExternalPagination: true,
    useExternalFiltering: true,
    multiSelect: true,
    enableRowHeaderSelection: true,
    enableRowSelection: true,
    columnDefs: [{
      name: ' '
    }]
  };

  //precaricamento lista commesse chiuse
  var closedCommissionFilter = {
    'closed': sixFiltersLib.exact('status', 'closed')
  };
  var commissionSearchOptions = {
    page_size: 10000
  };
  commissionFactory().search(commissionSearchOptions, closedCommissionFilter).$promise.then(function (commissions) {
    if (commissions && commissions.list && commissions.list.length) {
      $scope.closedCommissions = commissions.list.map(function (c) {
        return c.code;
      });
    }
  });
  $scope.$watchGroup(['entity.type', 'commissionFilter'], function (newValue, oldValue) {
    $scope.isEntitySelected = angular.isDefined(newValue[0]);
    if ($scope.isEntitySelected == true && newValue != oldValue) {
      var typeUUID = $scope.entity.type.UUID;

      // getting schema of entity.type
      schemaFactory().byUUID({
        id: typeUUID
      }).$promise.then(function (response) {
        $scope.schema = response;
        $scope.typeName = $scope.schema.model.code;
        $scope.historyMode = $scope.schema.model.history ? 'snap' : 'stable';
        if ($scope.schema.model.columnDefs) {
          $scope.viewGridOptions.columnDefs = [];
          $scope.viewGridOptions.columnDefs.push({
            displayName: '',
            field: 'id',
            width: 36,
            enableCellEdit: true,
            enableFiltering: false,
            enableSorting: false,
            cellTemplate: '<div class="ui-grid-cell-contents" style="vertical-align:middle;text-align:center;">' + '<button type="button" class="btn btn-xs btn-primary fa fa-search" ng-click="grid.appScope.$parent.goToItem(row)">' + '</button>' + '</div>'
          });
          angular.forEach($scope.schema.model.columnDefs, function (colDef) {
            //colDef has name and field -> {name: 'Codice', field: 'code'}
            var newColDef = {
              displayName: $scope.schema.model.schema.properties[colDef.field].title,
              field: 'model.' + colDef.field,
              filters: [{
                type: 'text',
                condition: uiGridConstants.filter.CONTAINS,
                placeholder: ''
              }],
              enableFiltering: true
            };
            if ($scope.schema.model.schema.properties[colDef.field].type === 'string') {
              // specific filters for lookup and dates
              if ($scope.schema.model.schema.properties[colDef.field].format === 'lookup') {
                newColDef.field = 'model.' + colDef.field;
                newColDef.cellTemplate = '<div class="ui-grid-cell ui-grid-cell-contents {{grid.appScope.cellClassFormatter(undefined, row)}}" title="{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}">{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}</div>';
                newColDef.filters = [{
                  type: sixGridPaginationConstants.filterType.SIXLOOKUP,
                  condition: uiGridConstants.filter.CONTAINS,
                  placeholder: ''
                }];
              }
              if ($scope.schema.model.schema.properties[colDef.field].format === 'date') {
                newColDef.filters = [{
                  type: 'date',
                  relation: 'gte',
                  placeholder: 'da...',
                  condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
                }, {
                  type: 'date',
                  relation: 'lte',
                  placeholder: 'a...',
                  condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
                }];
              }
            }
            if ($scope.schema.model.schema.properties[colDef.field].type === 'number') {
              // specific filters for numbers
              newColDef.filters = [{
                type: 'number',
                relation: 'gte',
                placeholder: 'da...',
                condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
              }, {
                type: 'number',
                relation: 'e',
                placeholder: 'uguale a...',
                condition: uiGridConstants.filter.EXACT
              }, {
                type: 'number',
                relation: 'lte',
                placeholder: 'a...',
                condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
              }];
            }
            $scope.viewGridOptions.columnDefs.push(newColDef);
          });

          // the last column is the commission...
          $scope.viewGridOptions.columnDefs.push({
            displayName: 'Commessa',
            field: 'commission',
            cellTemplate: '<div class="ui-grid-cell-contents">{{grid.appScope.$parent.getCommission(row)}}</div>',
            filters: [{
              type: 'text',
              condition: uiGridConstants.filter.CONTAINS,
              placeholder: ''
            }],
            enableFiltering: true
          });
        }
        $scope.params.filters = {};
        $scope.getExportList();
      });
    }
  });
  $scope.getExportList = function () {
    var promise = {};
    var payload = {
      query: $scope.queryParam,
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      sort_fields: $scope.params.sortFields,
      show_revision: false,
      solve_inherit: true,
      cross: $scope.commissionFilter != 'current'
    };
    if ($scope.commissionFilter == 'open') {
      $scope.params.filters.commissionFilter = sixFiltersLib["in"]('commission', $scope.closedCommissions, 'andnot');
    } else {
      delete $scope.params.filters.commissionFilter;
    }
    if ($scope.entity.type.UUID != 'zonatermica') {
      promise = recordFactory($scope.entity.type.UUID).search(payload, $scope.params.filters).$promise;
    } else {
      // endpoint per le zt: in modo da risolvere la colonna dei gradi giorno stagione termica
      promise = zonaTermicaFactory.search(payload, $scope.params.filters).$promise;
    }
    // aspetto la risposta...
    return promise.then(function (data) {
      $scope.params.totalItems = data.totalResults;
      $scope.viewGridOptions.totalItems = data.totalResults;
      $scope.exportList.totalResults = data.totalResults;
      $scope.exportList.list = data.list;
      $scope.params.sixApi.refreshList(data.list);
      return data;
    });
  };
  $scope.importData = function () {
    $scope.dataExp.forEach(function (value) {
      $log.info(value);
    });
  };
  $scope.getCommission = function (row) {
    var str = '';
    var sep = '';
    if (row.entity.commission) {
      [].concat(row.entity.commission).forEach(function (c) {
        str += sep + c;
        sep = ',';
      });
    }
    return str;
  };
  $scope.goToItem = function (row) {
    var comm = getCommissionInfoByCode([].concat(row.entity.commission)[0]);
    var desc = comm ? comm.description : [].concat(row.entity.commission)[0];
    var switchProfileElement = {
      selected: {
        type: '',
        cod: 0,
        code: [].concat(row.entity.commission)[0],
        description: desc,
        items: [{
          type: 'commission',
          cod: 0,
          code: [].concat(row.entity.commission)[0],
          description: desc
        }]
      }
    };
    if (authFactory.getAuthData().info.commissions.current.code == row.entity.commission[0]) {
      console.log('record/' + $scope.historyMode + '/' + $scope.typeName + '/' + row.entity.UUID);
      $location.path('record/' + $scope.historyMode + '/' + $scope.typeName + '/' + row.entity.UUID);
    } else {
      console.log('GO!!!');
      dialogService.loading('Cambio commessa ' + authFactory.getAuthData().info.commissions.current.code + ' <i class="fa fa-angle-double-right"></i> ' + row.entity.commission[0]);
      loginFactory["switch"](switchProfileElement).$promise.then(function (response) {
        var commissionCode = response.info.commissions.current.code;
        commissionFactory().getCommissionByCode({
          code: commissionCode
        }).$promise.then(function (commissionData) {
          response.info.commissions.current = commissionData;
          authFactory.setAuthData(response);
          dialogService.stopLoading();
          console.log('record/' + $scope.historyMode + '/' + $scope.typeName + '/' + row.entity.UUID);
          $location.path('record/' + $scope.historyMode + '/' + $scope.typeName + '/' + row.entity.UUID);
        });
      });
    }
  };
  function getCommissionInfoByCode(code) {
    for (var i in authFactory.getAuthData().info.commissions.list) {
      var c = authFactory.getAuthData().info.commissions.list[i];
      if (c.code === code) {
        return c;
      }
    }
  }
  $scope.exportXLSX = function () {
    // preparo colonne
    var columns = [];
    angular.forEach($scope.schema.model.schema.properties, function (property, key) {
      var column = {
        key: 'model.' + key,
        name: $scope.typeExport == 'exportToImport' ? key : property.title
      };
      if (property.hasOwnProperty('format') && property.format == 'lookup' && property.hasOwnProperty('multiple') && property.multiple == true) {
        column.transform = multiLookupTransformer;
      }
      if ($scope.typeExport == 'export' && property.hasOwnProperty('format') && property.format == 'datepicker') {
        column.t = 'd';
      }
      columns.push(column);
    });
    if ($scope.typeExport == 'export') {
      columns.push({
        key: 'commission',
        name: 'Commessa'
      });
      columns.push({
        key: 'dataIn',
        name: 'Inizio validità',
        t: 'd'
      });
      columns.push({
        key: 'dataOut',
        name: 'Fine validità',
        t: 'd'
      });
    } else {
      columns.push({
        key: 'commission',
        name: 'commission'
      });
      columns.push({
        key: 'dataIn',
        name: 'dataIn',
        t: 'd',
        format: 'YYYY\-MM\-DD'
      });
      columns.push({
        key: 'dataOut',
        name: 'dataOut',
        t: 'd',
        format: 'YYYY\-MM\-DD'
      });
    }

    // preparo righe
    var rows = $scope.params.gridApi.selection.getSelectedRows();
    if (!rows || rows.length == 0) {
      var promise = {};
      var payload = {
        query: $scope.queryParam,
        page: 1,
        page_size: 10000,
        show_revision: false,
        solve_inherit: $scope.typeExport == 'exportToImport' ? false : true,
        cross: $scope.commissionFilter != 'current'
      };
      if ($scope.commissionFilter == 'open') {
        $scope.params.filters.commissionFilter = sixFiltersLib["in"]('commission', $scope.closedCommissions, 'andnot');
      } else {
        delete $scope.params.filters.commissionFilter;
      }
      if ($scope.entity.type.UUID != 'zonatermica') {
        promise = recordFactory($scope.entity.type.UUID).search(payload, $scope.params.filters).$promise;
      } else {
        // endpoint per le zt: in modo da risolvere la colonna dei gradi giorno stagione termica
        promise = zonaTermicaFactory.search(payload, $scope.params.filters).$promise;
      }
      // aspetto la risposta...
      promise.then(function (data) {
        rows = data.list;
        injectTreeColumns(columns, rows);
        sixExportLib.exportXLSX(columns, rows, $scope.entity.type.description, $scope.typeExport !== 'exportToImport');
      });
    } else {
      injectTreeColumns(columns, rows);
      sixExportLib.exportXLSX(columns, rows, $scope.entity.type.description, $scope.typeExport !== 'exportToImport');
    }
  };
  $scope.lookupCellValueFormatter = function (value) {
    var formatted = "";
    if (typeof value != "undefined") {
      if (Object.prototype.toString.call(value) === '[object Array]') {
        for (var v in value) {
          formatted += value[v].code + " (" + value[v].description + "); ";
        }
      } else {
        formatted = value.code + " (" + value.description + ")";
      }
    }
    return formatted;
  };
  $scope.gridAppCallbacks['lookupCellValueFormatter'] = $scope.lookupCellValueFormatter;

  // typeExport
  $scope.setTypeExport = function (value) {
    $scope.typeExport = value;
  };
  $scope.setCommissionFilter = function (value) {
    $scope.commissionFilter = value;
  };
  $scope.getCommissionFilterLabel = function () {
    switch ($scope.commissionFilter) {
      case 'current':
        return $scope.currentCommission.code;
      case 'open':
        return 'Aperte';
      case 'all':
        return 'Tutte';
    }
  };
  function multiLookupTransformer(v) {
    if (Array.isArray(v) && v.length) {
      for (var i = v.length; i--;) {
        v[i] = v[i].code;
      }
    }
    return v;
  }
  function injectTreeColumns(columns, rows) {
    var PARENT_TYPE_COLUMN = "parent_type";
    var PARENT_CODE_COLUMN = "parent_code";
    if (columns && rows) {
      if ($scope.typeExport === 'exportToImport') {
        columns.unshift({
          key: PARENT_CODE_COLUMN,
          name: PARENT_CODE_COLUMN
        });
        columns.unshift({
          key: PARENT_TYPE_COLUMN,
          name: PARENT_TYPE_COLUMN
        });
      } else {
        columns.unshift({
          key: PARENT_CODE_COLUMN,
          name: "Codice genitore"
        });
        columns.unshift({
          key: PARENT_TYPE_COLUMN,
          name: "Tipo genitore"
        });
      }
      for (var r in rows) {
        var commission = rows[r]['commission'];
        var treeCode = getTreeCode(commission);
        var parent = findParent(rows[r], treeCode);
        if (parent) {
          if (!parent.type || !parent.code) {
            parent.type = 'definition';
            parent.code = treeCode;
          }
          rows[r][PARENT_TYPE_COLUMN] = parent.type;
          rows[r][PARENT_CODE_COLUMN] = parent.code;
        } else {
          rows[r][PARENT_TYPE_COLUMN] = "";
          rows[r][PARENT_CODE_COLUMN] = "";
        }
      }
    }
  }
  function findParent(document, treeCode) {
    if (document.parents) {
      for (var d in document.parents) {
        if (document.parents[d].treeCode == treeCode) {
          if (document.parents[d].treeLevel === document.parents[d].treeTotalLevels - 1) {
            return document.parents[d];
          }
        }
      }
    }
    return;
  }
  function getTreeCode(commission) {
    var code = 'def' + (commission ? commission : $scope.currentCommission.code);
    if (angular.isDefined($scope.currentCustomer)) {
      code += 'cli' + $scope.currentCustomer.code;
    }
    return code;
  }
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.assetcalendarFactory
 * @description
 * # assetcalendarFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.plan').factory('assetcalendarFactory', ["DATA_SET_URL", "$resource", function (DATA_SET_URL, $resource) {
  return $resource(DATA_SET_URL + '/api/calendar/:verb/:id/:uuid', {}, {
    getCalendarFiltered: {
      method: 'POST',
      params: {
        verb: '_calendar'
      }
    },
    getEventByDate: {
      method: 'GET',
      params: {
        verb: '_byDate'
      }
    },
    getCalendarService: {
      method: 'POST',
      params: {
        verb: '_calendarService'
      }
    },
    getAssetListForEvent: {
      method: 'POST',
      params: {
        verb: '_assetlistforevent'
      }
    },
    saveEvent: {
      method: 'POST',
      params: {
        verb: '_saveEvent'
      }
    },
    deleteEvent: {
      method: 'POST',
      params: {
        verb: '_deleteEvent'
      }
    },
    importEvents: {
      method: 'POST',
      params: {
        verb: '_import'
      }
    }
  });
}]);
'use strict';

/**
 * @ngdoc service
 * @name emma.dataset.baseFactory
 * @description
 * # baseFactory
 * Factory in the emma.dataset.
 */
angular.module('emma.dataset').factory('dataSetFactory', ["DATA_SET_URL", "$resource", function (DATA_SET_URL, $resource) {
  return function (entity) {
    return $resource(DATA_SET_URL + '/api/' + entity + '/:id', {}, {
      query: {
        method: 'GET',
        isArray: false
      },
      search: {
        method: 'POST',
        isArray: false
      },
      filter: {
        method: 'POST',
        isArray: true
      },
      select: {
        method: 'GET',
        isArray: true
      },
      create: {
        method: 'POST'
      },
      bulk: {
        method: 'POST',
        isArray: true
      },
      show: {
        method: 'GET'
      },
      update: {
        method: 'PUT',
        params: {
          id: '@id'
        }
      },
      "delete": {
        method: 'DELETE',
        params: {
          id: '@id'
        }
      },
      copy: {
        method: 'POST',
        params: {
          id: 'copy'
        },
        isArray: false
      }
    });
  };
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.drawingFactory
 * @description
 * # drawingFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.plan').factory('drawingFactory', ["DATA_SET_URL", "$resource", function (DATA_SET_URL, $resource) {
  var basePath = DATA_SET_URL + '/api/drawing/';
  var r = $resource(basePath + ':verb/:id/:uuid', {}, {
    search: {
      method: 'POST',
      params: {
        verb: '_search'
      }
    },
    getLayers: {
      method: 'GET',
      params: {
        verb: '_layers'
      }
    },
    getDrawingById: {
      method: 'GET',
      params: {
        verb: '_uuid'
      }
    },
    getDrawingData: {
      method: 'GET',
      params: {
        verb: '_data'
      }
    }
  });
  //"endpoint" speciale, restituisce solo l'url, è il componente di upload a effettuare l'invio
  r.uploadPath = basePath + "_upload";
  return r;
}]);
"use strict";

angular.module('emma.plan').factory('recordWSFactory', ["DATA_SET_URL", "ENV", "DEV", "$websocket", "$log", "$location", "$timeout", "dialogService", function (DATA_SET_URL, ENV, DEV, $websocket, $log, $location, $timeout, dialogService) {
  var MAX_ATTEMPTS = 2;
  var user;
  var ws;
  var listeners = [];
  var method = {};
  method.connect = function (userName) {
    if (ws) ws.close();

    // costruzione url
    var wsPath;
    if ($location.protocol() == 'https') {
      wsPath = 'wss://'; // se viaggio su https
    } else {
      wsPath = 'ws://'; // se viaggio su http
    }

    wsPath += $location.host() + ':' + $location.port() + '/';
    if (!DEV) {
      wsPath += ENV + '/';
    }
    wsPath += 'ws/' + DATA_SET_URL + '/record/ws/' + userName;
    ws = $websocket(wsPath);
    user = userName;
    ws.onOpen(function () {
      $log.info("Socket with record/ws has been opened!");
    });
    ws.onClose(function (event) {
      $log.warn("Socket with record/ws has been closed!");
    });
    ws.onError(function (event) {
      $log.error('recordWSFactory error', event);
    });
    ws.onMessage(function (message) {
      $log.debug(message);
      var parsed = JSON.parse(message.data);
      $log.debug('responseId = ' + parsed.$id);
      listeners.forEach(function (l) {
        l(parsed);
      });
    });
  };
  method.addHandler = function (listener) {
    listeners.push(listener);
    return function () {
      var idx = listeners.indexOf(listener);
      if (idx > -1) {
        listeners.splice(idx, 1);
      }
    };
  };
  method.subscribe = function (channel) {
    var msg = {
      operation: 'subscribe',
      channel: channel
    };
    _send(msg, 0);
  };
  function _send(msg, attempts) {
    if (!msg.operation) {
      $log.debug('Invalid message', msg);
      return;
    }
    if (ws) {
      if (ws.readyState == 0) {
        // connecting => aspetto e riprovo ad inviare
        $log.info('readyState = ' + ws.readyState + ' => retry ' + (attempts + 1));
        $timeout(function () {
          _send(msg, attempts + 1);
        }, 1000);
      } else if (ws.readyState == 1) {
        // open
        $log.debug('Sending message ', msg);
        var stringified = JSON.stringify(msg);
        ws.send(stringified).then(function () {
          $log.info('Message sent ', msg);
        });
      } else if (attempts < MAX_ATTEMPTS) {
        // closing o closed => provo a riconnettermi
        $log.warn('readyState = ' + ws.readyState + ' => retry ' + (attempts + 1));
        method.connect(user);
        $timeout(function () {
          _send(msg, attempts + 1);
        }, 200);
      } else {
        $log.error('readyState = ' + ws.readyState + ' => too many attempts (' + attempts + ')!!!');
        dialogService.dialog('Attenzione', 'La connessione con il server è stata persa: provare a ricaricare la pagina', dialogService.DIALOG_TYPE.WARNING, -1);
      }
    } else {
      $log.error('ws undefined: maybe you\'re not connected');
    }
  }
  return method;
}]);
'use strict';

/**
 * @ngdoc function
 * @name emma.dataset.controller:FormulaCtrl
 * @description
 * # FormulaCtrl
 * Controller of the emma.dataset
 */
angular.module('emma.dataset').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/formula', {
    templateUrl: 'dataset/formula/formula_list.html',
    controller: 'FormulaCtrl'
  }).when('/formula/:id', {
    templateUrl: 'dataset/formula/formula_detail.html',
    controller: 'FormulaCtrl'
  });
}]).controller('FormulaCtrl', ["$scope", "$window", "$location", "$routeParams", "formulaFactory", "dialogService", function ($scope, $window, $location, $routeParams, formulaFactory, dialogService) {
  $scope.model = {
    code: '',
    description: '',
    formula: undefined
  };
  $scope.output = undefined;
  $scope.arrayFunction = {
    'radice': {
      key: 'radice',
      description: 'Math.sqrt(value)',
      check: false
    },
    'potenza': {
      key: 'potenza',
      description: 'Math.pow(value, exponent)',
      check: false
    },
    'seno': {
      key: 'seno',
      description: 'Math.sin(valueInRadiant)',
      check: false
    },
    'arcoseno': {
      key: 'arcoseno',
      description: 'Math.asin(value)',
      open: false
    },
    'coseno': {
      key: 'coseno',
      description: 'Math.cos(valueInRadiant)',
      open: false
    },
    'arcocoseno': {
      key: 'arcocoseno',
      description: 'Math.acos(value)',
      open: false
    },
    'tangente': {
      key: 'tangente',
      description: 'Math.tan(valueInRadiant)',
      open: false
    },
    'arcotangente': {
      key: 'arcotangente',
      description: 'Math.atan(value)',
      open: false
    }
  };
  if ($routeParams.id && 'new' !== $routeParams.id) {
    formulaFactory.getFormulaById({
      id: $routeParams.id
    }).$promise.then(function (data) {
      $scope.model = data;
    });
  }
  $scope.newFormula = function () {
    $location.path('formula/new');
  };
  $scope.saveForm = function () {
    if ($routeParams.id !== 'new') {
      formulaFactory.updateFormula({
        id: $scope.model.code
      }, $scope.model).$promise.then(function () {
        $window.history.back();
      });
    } else {
      formulaFactory.createFormula($scope.model).$promise.then(function () {
        $window.history.back();
      });
    }
  };
  $scope["delete"] = function (idToDelete) {
    formulaFactory.deleteFormula({
      id: $scope.model.code
    }).$promise.then(function () {
      $window.history.back();
    });
  };
  $scope.pageChanged = function () {
    $scope.listWrapper = formulaFactory.getFormulasList({
      query: $scope.queryParam,
      page: $scope.listWrapper.currentPage
    });
  };
  $scope.getListWrapper = function () {
    formulaFactory.getFormulasList({
      query: $scope.queryParam
    }).$promise.then(function (data) {
      $scope.listWrapper = data;
    });
  };
  $scope.getListWrapper();
  $scope.calculate = function (params) {
    var obj = {
      formula: $scope.model.formula,
      value: params
    };
    formulaFactory.getCalculationResult(obj).$promise.then(function (data) {
      $scope.output = data.result;
    });
  };
}]);
'use strict';

/**
 * @ngdoc service
 * @name emma.dataset.formulaFactory
 * @description
 * # formulaFactory
 * Factory in the emma.dataset.
 */
angular.module('emma.dataset').factory('formulaFactory', ["DATA_SET_URL", "$resource", function (DATA_SET_URL, $resource) {
  return $resource(DATA_SET_URL + '/api/formula/:verb/:type/:id/:param1/:param2/:param3', {}, {
    getFormulaById: {
      method: 'GET',
      params: {
        verb: '_id'
      }
    },
    getFormulasList: {
      method: 'GET'
    },
    getCalculationResult: {
      method: 'POST',
      params: {
        verb: '_test'
      }
    },
    createFormula: {
      method: 'POST',
      params: {
        id: '@id'
      }
    },
    updateFormula: {
      method: 'PUT',
      params: {
        id: '@id'
      }
    },
    deleteFormula: {
      method: 'DELETE',
      params: {
        id: '@id'
      }
    },
    getParamsByNum: {
      method: 'GET',
      params: {
        verb: '_params',
        type: 'number',
        id: '@id'
      }
    },
    getParamsByArray: {
      method: 'GET',
      params: {
        verb: '_params',
        type: 'array',
        id: '@id'
      }
    }
  });
}]);
'use strict';

/**
 * @ngdoc function
 * @name emma.dataset.controller:ImportCtrl
 * @description
 * # ImportCtrl
 * Controller of the emma.dataset
 */
angular.module('emma.dataset').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/import', {
    templateUrl: 'dataset/import/import.html',
    controller: 'ImportCtrl'
  });
}]).controller('ImportCtrl', ["$scope", "$log", "$q", "schemaFactory", "recordFactory", "priceListFactory", "zonaTermicaFactory", "dialogService", "ngDialog", "$timeout", "toaster", "authFactory", "treeFactory", "historyLock", "recordWSFactory", function ($scope, $log, $q, schemaFactory, recordFactory, priceListFactory, zonaTermicaFactory, dialogService, ngDialog, $timeout, toaster, authFactory, treeFactory, historyLock, recordWSFactory) {
  $scope.errorCount = 0;
  $scope.importBusy = false;
  $scope.percent = 0;
  $scope.prePercent = 0;
  $scope.preprocessToResolve = 0;
  $scope.preprocessResolved = 0;
  $scope.entity = {};
  $scope.data = [];
  $scope.isEntitySelected = false;
  $scope.typeName = '';
  $scope.reportMessages = [];
  $scope.schemaDefinition = {};
  $scope.gridOptions = {
    importerDataAddCallback: function importerDataAddCallback(grid, newObjects) {
      // $scope.data = $scope.data.concat( newObjects ); //questa in realtà non viene chiamata... la direttiva xlsx non scatena l'evento..
    },
    onRegisterApi: function onRegisterApi(gridApi) {
      $scope.gridApi = gridApi;
    }
  };
  var currentCommission = authFactory.getAuthData().info.commissions.current;
  var currentCustomer = authFactory.getCurrentCustomer();
  var PARENT_TYPE_COLUMN = "parent_type";
  var PARENT_CODE_COLUMN = "parent_code";
  var ROOT_KEYWORD = "root";
  var ROOT_TYPE = "definition";
  var treeStructuresToResolve = {};
  var staticFields = ['parents', 'commission', 'customer', 'dataIn', 'dataOut', 'version', 'UUID', 'sixImportStatus', 'sixInfo'];
  $scope.minDate = new Date(-8640000000000000);
  historyLock.loadMinimumDate(currentCommission.code).then(function (minDate) {
    $scope.minDate = minDate;
  });
  $scope.reportGridOptions = {
    enableSorting: true,
    exporterMenuPdf: false,
    paginationPageSizes: [10, 20, 30],
    paginationPageSize: 10,
    useExternalPagination: false,
    data: 'reportMessages',
    columnDefs: [{
      displayName: 'Codice',
      field: 'code',
      width: '60'
    }, {
      displayName: 'Stato',
      field: 'status',
      width: '100'
    }, {
      displayName: 'Messaggio',
      field: 'message'
    }, {
      displayName: 'Record type',
      field: 'record.type',
      width: '120'
    }, {
      displayName: 'Record code',
      field: 'record.code',
      width: '120'
    }, {
      displayName: 'Record UUID',
      field: 'record.uuid',
      width: '120'
    }, {
      displayName: 'Record Id',
      field: 'recordId',
      width: '120'
    }, {
      displayName: 'Commission',
      field: 'commission',
      width: '120'
    }]
  };
  $scope.reset = function () {
    $scope.errorCount = 0;
    $scope.percent = 0;
    $scope.prePercent = 0;
    $scope.missingParentCount = 0;
    $scope.preprocessToResolve = 0;
    $scope.preprocessResolved = 0;
    $scope.entity = {};
    $scope.data = [];
    $scope.gridOptions.data = [];
    $scope.gridOptions.columnDefs = [];
    $scope.typeName = '';
    $scope.schemaDefinition = {};
    $scope.reportMessages = [];
    $scope.isEntitySelected;
    $scope.withTree = false;
  };

  //dati caricati da xls
  $scope.$watch(function () {
    return $scope.gridOptions.xlsData;
  }, function (newValue, oldValue) {
    if (newValue && newValue.length > 0) {
      $scope.checkData();
    }
  });
  function checkDate(value) {
    // aaaa-MM-gg + time
    if (value) {
      var dateArray = value.split("-");
      // se la stringa è composta come: aaaa-MM-gg, la analizzo
      if (dateArray.length > 0 && dateArray.length == 3) {
        var timeMatch = dateArray[2].match(/^(\d{2})T(\d{2}):(\d{2}):(\d{2}\.?\d*)?Z/);
        var day = timeMatch ? timeMatch[1] : dateArray[2];
        var date = new Date(dateArray[0], dateArray[1] - 1, day); // year, month, day
        // qui effettuo il confronto tra le due stringhe
        var convertedDate = "" + date.getFullYear() + ("0" + (date.getMonth() + 1)).slice(-2) + ("0" + date.getDate()).slice(-2);
        var initialDate = "" + dateArray[0] + dateArray[1] + day;
        // CONFRONTO
        return initialDate == convertedDate;
      }
    }
    // se non è definita (= vuota), o se non arriva al confronto, non va bene
    return false;
  }
  function getRequestForOther(indexMapToResolve, k, v, lookupCommission, basePath, type, properties) {
    if (!indexMapToResolve[basePath]) {
      indexMapToResolve[basePath] = {};
    }
    if (!indexMapToResolve[basePath][lookupCommission]) {
      indexMapToResolve[basePath][lookupCommission] = {};
    }
    if (!indexMapToResolve[basePath][lookupCommission][type]) {
      indexMapToResolve[basePath][lookupCommission][type] = {};
    }
    if (properties[k].multiple && properties[k].multiple == true) {
      // gestione lookup multipla
      var arrayLookup = arrayLookupParser(v);
      if (arrayLookup.length > 0) {
        arrayLookup.forEach(function (vlookup) {
          indexMapToResolve[basePath][lookupCommission][type][vlookup] = '';
        });
      }
    } else {
      // gestione lookup singola
      indexMapToResolve[basePath][lookupCommission][type][v] = '';
    }
  }
  function setNestedObj(obj, propArray, finalValue) {
    function _setNestedObj(obj, propArray) {
      if (propArray.length) {
        var p = propArray[0];
        obj[p] = Object(obj[p]);
        propArray.shift();
        if (propArray.length == 1 && finalValue) {
          obj[p][propArray[0]] = finalValue;
        } else {
          _setNestedObj(obj[p], propArray);
        }
      }
    }
    _setNestedObj(obj, propArray);
    return obj;
  }
  function getRequestForRecord(indexMapToResolve, k, v, type, properties, value) {
    if (properties[k].multiple && properties[k].multiple == true) {
      // gestione lookup multipla
      var arrayLookup = arrayLookupParser(v);
      if (arrayLookup.length > 0) {
        arrayLookup.forEach(function (vlookup) {
          setMapRequest(indexMapToResolve.record, {
            commission: value.commission,
            customer: value.customer,
            type: type,
            code: vlookup
          });
        });
      }
    } else {
      // gestione lookup singola
      setMapRequest(indexMapToResolve.record, {
        commission: value.commission,
        customer: value.customer,
        type: type,
        code: v
      });
    }
  }
  function setMapRequest(object, requestObj, opt) {
    if (object && requestObj && requestObj.code) {
      setNestedObj(object, [requestObj.commission ? requestObj.commission : 'cross', requestObj.customer ? requestObj.customer : 'cross', requestObj.type ? requestObj.type : $scope.typeName, requestObj.code], opt);
    }
  }
  function getRequestFromMap(uniqueTemplateMap) {
    var request = [];
    for (var commission in uniqueTemplateMap) {
      for (var customer in uniqueTemplateMap[commission]) {
        for (var type in uniqueTemplateMap[commission][customer]) {
          for (var code in uniqueTemplateMap[commission][customer][type]) {
            request.push({
              commission: commission == 'cross' ? undefined : commission,
              customer: customer == 'cross' ? undefined : customer,
              type: type,
              code: code
            });
            if (Object.keys(uniqueTemplateMap[commission][customer][type][code]).length) {
              request[request.length - 1] = Object.assign(request[request.length - 1], uniqueTemplateMap[commission][customer][type][code]);
            }
          }
        }
      }
    }
    return request;
  }
  function getCustomerCode(code, custList) {
    if (code && code != "" && custList) {
      var c = code.trim();
      var result = custList.find(function (el) {
        return el.response ? el.response.model.code === c : false;
      });
      return result && result.response ? result.response.UUID : undefined;
    }
    return undefined;
  }
  function getRowsCustomers() {
    var customers = {};
    $scope.gridOptions.xlsData.forEach(function (row) {
      if ($scope.schemaDefinition.model.commissionDependent && row.customer) {
        setMapRequest(customers, {
          commission: row.commission ? row.commission : currentCommission.code,
          customer: null,
          type: 'cliente',
          code: row.customer
        });
      }
    });
    return getRequestFromMap(customers);
  }
  function getCommissionAndCustomer(value, rowCustomers) {
    var autoCommission = false,
      autoCustomer = false;
    if (!value.commission && $scope.schemaDefinition.model.commissionDependent) {
      //se la commessa non è indicata, ma il dato dipende dalla commessa allora uso la commessa corrente
      value.commission = currentCommission ? currentCommission.code : undefined;
      autoCommission = true;
    }
    if (!value.commission && autoCommission) {
      value.sixInfo = value.sixInfo.concat("Commission non trovata, il dato sarà cross-commission; ");
    } else if (autoCommission) {
      value.sixInfo = value.sixInfo.concat("Commission non trovata, inserita commission attuale; ");
    }
    if ($scope.schemaDefinition.model.commissionDependent) {
      value.customer = getCustomerCode(value.customer, rowCustomers); //tenta il parsing da codice cliente a UUID guardando nei rowCustomers
      if (!value.customer) {
        value.customer = currentCustomer ? currentCustomer.code : undefined;
        autoCustomer = true;
      }
      if (!value.customer && autoCustomer) {
        value.sixInfo = value.sixInfo.concat("Customer non trovato, il dato sarà cross-customer; ");
      } else if (autoCustomer) {
        value.sixInfo = value.sixInfo.concat("Customer non trovato, inserito customer attuale; ");
      }
    } else {
      //dati cross commission sono sempre cross customer
      value.customer = undefined;
    }
  }
  function parseDataTypes(value, arrays, numbers, booleans, dates, maps) {
    function parseBoolean(value) {
      var lower = value.toLowerCase();
      return lower === 'vero' || lower === 'v' || lower === 'true' || lower === 't' || lower === 'si' || lower === 's';
    }
    arrays.forEach(function (a) {
      if (value[a]) {
        var isArray = false; // se il json è un array
        var jsonArray; // variabile risultato
        try {
          value[a] = value[a].replace(/[“”']/g, '"');
          jsonArray = JSON.parse(value[a]);
          if (jsonArray.length) {
            // deve essere un array -> length
            isArray = true;
          }
        } catch (e) {
          isArray = false;
        }
        if (!isArray) {
          // errore
          value['sixImportStatus'] = 'Array ' + a + ' non valido';
          $scope.errorCount++;
        } else {
          // ok
          value[a] = jsonArray;
        }
      }
    });
    numbers.forEach(function (n) {
      if (value[n] && value[n].trim().length > 0) {
        if (isNaN(value[n])) {
          // errore
          value['sixImportStatus'] = 'Numero ' + n + ' non valido';
          $scope.errorCount++;
        } else {
          // ok
          value[n] = parseFloat(value[n]);
        }
      }
    });
    booleans.forEach(function (b) {
      if (value[b]) {
        // il check non serve -> sempre true/false
        value[b] = parseBoolean(value[b]);
      }
    });
    dates.forEach(function (d) {
      if (value[d] && value[d].trim().length > 0) {
        // check sul formato della data
        if (!checkDate(value[d])) {
          // errore
          value['sixImportStatus'] = 'Data ' + d + ' in formato non valido (richiesto: AAAA-MM-GG)';
          $scope.errorCount++;
        } else {
          if (d == 'dataIn' && compareDates(value[d], $scope.minDate) < 0) {
            value['sixImportStatus'] = 'DataIn non valida. Non puoi importare in data antecedente al ' + $scope.minDate.toLocaleDateString();
            $scope.errorCount++;
          }
        }
      }
    });
    maps.forEach(function (m) {
      if (value[m]) {
        var isObj = false; // se il json è un oggetto
        var jsonObj; // variabile risultato
        try {
          value[m] = value[m].replace(/[“”']/g, '"');
          jsonObj = JSON.parse(value[m]);
          if (jsonObj) {
            isObj = true;
          }
        } catch (e) {
          isObj = false;
        }
        if (!isObj) {
          // errore
          value['sixImportStatus'] = 'Oggetto ' + m + ' non valido';
          $scope.errorCount++;
        } else {
          // ok
          value[m] = jsonObj;
        }
      }
    });
  }
  function checkRequiredProperties(value, propertiesRequired, parentsJson) {
    var stringWithPropertiesRequired = [];
    for (var req in propertiesRequired) {
      var error = false;
      // controllo se non ha la proprietà, oppure se ce l'ha ma non è valorizzata o è uno spazio bianco...
      if (!value.hasOwnProperty(req) || angular.isUndefined(value[req]) || value[req] == null) {
        error = true;
      } else {
        if (angular.isString(value[req]) && value[req].trim().length == 0) {
          error = true;
        } else if (angular.isArray(value[req]) && value[req].length == 0) {
          error = true;
        } else if (angular.isObject(value[req]) && value[req] == {}) {
          error = true;
        }
      }
      if (error) {
        stringWithPropertiesRequired.push(req);
        $scope.errorCount++;
      }
    }
    // stampo un messaggio legato a quanti campi obbligatori non trovo
    if (stringWithPropertiesRequired.length == 1) {
      value['sixImportStatus'] = stringWithPropertiesRequired[0] + ' non trovato;';
    } else if (stringWithPropertiesRequired.length > 1) {
      value['sixImportStatus'] = stringWithPropertiesRequired.toString() + ' non trovati;';
    } else if (!parentsJson && value['parents']) {
      value['sixImportStatus'] = 'La colonna parents non è importabile;';
    }
  }
  function checkAllowedFields(value, properties) {
    var sFields = staticFields;
    if ($scope.withTree) {
      sFields = sFields.concat([PARENT_TYPE_COLUMN, PARENT_CODE_COLUMN]);
    }
    for (var field in value) {
      if (!properties[field] && sFields.indexOf(field) == -1) {
        $scope.errorCount++;
        if (field == PARENT_TYPE_COLUMN || field == PARENT_CODE_COLUMN) {
          value['sixImportStatus'] = "La colonna " + field + " non può essere importata se non è abilitato l'import del tree.";
        } else {
          value['sixImportStatus'] = "La colonna " + field + " non è una proprietà riconosciuta per il tipo di asset importato.";
        }
      }
    }
  }
  $scope.checkData = function () {
    dialogService.showLoadingMessage('Controllo dati...');
    console.log('Controllo e preprocesso i dati');
    /// $scope.gridOptions.xlsData ----> $scope.gridOptions.data

    $scope.gridOptions.columnDefs.splice(0, 0, {
      field: 'sixInfo',
      cellTemplate: "<div class=\"ui-grid-cell-contents\" title=\"{{COL_FIELD}}\">{{COL_FIELD}}</div>"
    });
    $scope.gridOptions.columnDefs.splice(0, 0, {
      field: 'sixOperation',
      cellTemplate: "<div class=\"ui-grid-cell-contents\" title=\"{{COL_FIELD}}\">{{COL_FIELD}}</div>"
    });
    $scope.gridOptions.columnDefs.splice(0, 0, {
      field: 'sixImportStatus',
      cellTemplate: "<div class=\"ui-grid-cell-contents\" title=\"{{COL_FIELD}}\">{{COL_FIELD}}</div>"
    });
    var properties = $scope.schemaDefinition.model.schema.properties;
    var propertiesRequired = {};
    var lookups = [];
    var arrays = [];
    var numbers = [];
    var booleans = [];
    var dates = ['dataIn'];
    var maps = [];
    var parentsJson = $scope.withTree && $scope.gridOptions.xlsData.length > 0 && angular.isString($scope.gridOptions.xlsData[0].parents);

    // carico i campi obbligatori
    if ($scope.schemaDefinition.model.schema.required.length) {
      $scope.schemaDefinition.model.schema.required.forEach(function (p) {
        propertiesRequired[p] = properties[p];
      });
    }
    for (var key in properties) {
      if (properties[key]) {
        if (properties[key].format == 'lookup' && properties[key].entity_id) {
          lookups.push(key);
        } else if (properties[key].type == 'array') {
          arrays.push(key);
        } else if (properties[key].type == 'integer' || properties[key].type == 'number') {
          numbers.push(key);
        } else if (properties[key].type == 'boolean') {
          booleans.push(key);
        } else if (properties[key].type == 'string' && properties[key].format == 'date') {
          dates.push(key);
        } else if (properties[key].type == 'string' && properties[key].format == 'commissionmapper') {
          maps.push(key);
        }
      }
    }
    var indexMapToResolve = {
      //mappa per risolvere le lookup
      record: {}
    };
    var futureVersions = {}; //per ottenere i documenti elastic con cui avere la (eventuale) data-out dei dati importati
    var assetImported = {};
    var dateNow = new Date().toISOString();

    //per tutte le righe, ottengo i customer a partire dalla commission per risolvere il codice cliente inserito dall'utente
    recordFactory('type').bulkFindList(getRowsCustomers()).$promise.then(function (rowCustomers) {
      $scope.gridOptions.xlsData.forEach(function (value) {
        // uso un array per gestire l'assenza di uno o più campi -> per stampare un messaggio associato
        value['sixImportStatus'] = 'OK';
        value['sixInfo'] = "";
        $scope.preprocessToResolve++; ///un po' così.... conto 1 per ogni record+ 1 per ogni lookup da risolvere...

        var uniqueCodesCount = $scope.gridOptions.xlsData.reduce(function (count, row) {
          if (value.code == row.code) {
            count++;
          }
          return count;
        }, 0);
        if (uniqueCodesCount > 1) {
          $scope.errorCount++;
          value['sixImportStatus'] = 'Codice duplicato: ' + value.code;
        }
        getCommissionAndCustomer(value, rowCustomers);

        //cerco versioni future per warn sulla sovrascrittura dell'import in un secondo step
        setMapRequest(futureVersions, {
          commission: value.commission,
          customer: value.customer,
          code: value.code,
          type: $scope.typeName
        }, {
          query_date: value.dataIn ? value.dataIn : dateNow,
          exact_match: true,
          look_forward: true,
          ignore_date_time: false
        });

        //cerco gli asset importati per verificare la struttura del tree in un secondo step
        setMapRequest(assetImported, {
          commission: value.commission,
          customer: value.customer,
          code: value.code,
          type: $scope.typeName
        }, {
          exact_match: true
        });
        for (var l in lookups) {
          (function () {
            //closure <3
            var k = lookups[l];
            var v = value[k]; //codice asset
            var lookupCommission = value.commission ? value.commission : currentCommission.code;
            var basePath = properties[k].basePath; //'record' o altro
            var type = properties[k].entity_id; //tipo asset

            if (!angular.isUndefined(v)) {
              if (angular.isUndefined(basePath) || basePath == 'record') {
                getRequestForRecord(indexMapToResolve, k, v, type, properties, value); //cerco gli asset referenziati dalle lookup
              } else {
                getRequestForOther(indexMapToResolve, k, v, lookupCommission, basePath, type, value, properties);
              }
            }
          })();
        }
        parseDataTypes(value, arrays, numbers, booleans, dates, maps);

        //gestione tree, verifica le colonne parent_type e parent_code
        if ($scope.withTree && $scope.schemaDefinition.model.commissionDependent) {
          if (parentsJson) {
            try {
              //implementazione per uso interno
              value.parents = JSON.parse(value.parents);
              if (!angular.isArray(value.parents)) {
                $scope.errorCount++;
                value['sixImportStatus'] = 'Parents non è un array';
              } else if (value.parents.length == 0) {
                $scope.missingParentCount++;
              }
            } catch (e) {
              $scope.errorCount++;
              value['sixImportStatus'] = 'Parents ha un errore di sintassi';
            }
          } else {
            var ptype = value[PARENT_TYPE_COLUMN] ? value[PARENT_TYPE_COLUMN].trim() : value[PARENT_TYPE_COLUMN];
            var pcode = value[PARENT_CODE_COLUMN] ? value[PARENT_CODE_COLUMN].trim() : value[PARENT_CODE_COLUMN];
            if (ptype && pcode) {
              if (ptype != ROOT_TYPE && ptype != ROOT_KEYWORD && pcode != ROOT_KEYWORD) {
                //cerco il parent specificato per verificare che esista;
                setMapRequest(indexMapToResolve.record, {
                  code: pcode,
                  type: ptype,
                  commission: value.commission,
                  customer: value.customer
                }, {
                  exact_match: true
                });
              }
              //accantono la commessa e il customer per recuperarne la struttura del tree
              var concatCode = ""; //per ottenere una mappa flat
              if (value.commission) {
                concatCode = concatCode.concat('commi' + value.commission);
              }
              if (value.customer) {
                concatCode = concatCode.concat('custo' + value.customer);
              }
              if (!treeStructuresToResolve[concatCode]) {
                //concatCode = commi1600006custoAVYwt2qGeVUjCAcTjL0H
                treeStructuresToResolve[concatCode] = {};
              }
            } else {
              $scope.missingParentCount++;
            }
          }
        }
        $scope.preprocessResolved++;
        $scope.updatePreprocessPercent();
        checkRequiredProperties(value, propertiesRequired, parentsJson); //controllo la presenza dei campi required
        checkAllowedFields(value, properties); //controllo che i campi presenti si attengano al modello definito dallo schemaform

        // add
        $scope.gridOptions.data = $scope.gridOptions.data.concat(value);
      });

      //warning (non bloccante) se sto importando il tree ma non ho trovato parent
      if ($scope.withTree) {
        if ($scope.missingParentCount == $scope.gridOptions.xlsData.length) {
          dialogService.dialog('L\'importazione del tree è attiva, ma non è stato indicato alcun parent.', 'Gli asset nuovi non saranno inseriti nel tree, mentre gli asset esistenti verranno rimossi dal tree. Verifica i dati prima di procedere!', 'warning', 15000, true);
        }
      }

      // se non ci sono errori (tutti campi obbligatori presenti): risolvo le lookup e i parent
      if ($scope.errorCount <= 0) {
        $log.info(indexMapToResolve);

        //controllo la relazione parent-child sia ammessa dalla treeconfig
        if (!parentsJson && $scope.withTree && $scope.schemaDefinition.model.commissionDependent) {
          $log.info(treeStructuresToResolve);
          var matchCust = /custo(.*)$/;
          var matchComm = /^commi([^custo]*)/;
          //precarico le strutture del tree per i controlli
          var treePromises = [$q.resolve()]; //mi assicuro di avere almeno 1 promessa
          for (var concatCode in treeStructuresToResolve) {
            //concatCode = commi1600006custoAVYwt2-GeVUjCAcTjL0H
            if (matchComm.test(concatCode) || matchCust.test(concatCode)) {
              var _comm = matchComm.test(concatCode) ? concatCode.match(matchComm)[1] : currentCommission ? currentCommission.code : undefined;
              var _cust = matchCust.test(concatCode) ? concatCode.match(matchCust)[1] : currentCustomer ? currentCustomer.code : undefined;
              treePromises.push(treeFactory.getStructureByCommissionAndCustomer({}, {
                commission: _comm,
                customer: _cust
              }).$promise);
            }
          }
          $q.all(treePromises).then(function (responses) {
            for (var r in responses) {
              if (responses[r] && responses[r].model && responses[r].model.code) {
                //snellisco la struttura per tenere solo le info sulle relazioni parent-child
                if (responses[r].model && responses[r].model.nodes) {
                  var parentSchema = ROOT_TYPE;
                  treeStructuresToResolve['def' + responses[r].model.code] = buildAllowedParents(parentSchema, responses[r].model.nodes);
                  //tree-config code = 1600006clicustoAVYwt2qGeVUjCAcTjL0H
                  //tree code = def + 1600006clicustoAVYwt2qGeVUjCAcTjL0H
                } else {
                  $log.error('Il treeConfig per la commessa "' + responses[r].model.code + '" non ha nodi.');
                }
              }
            }
            $scope.gridOptions.xlsData.forEach(function (value) {
              var ptype = value[PARENT_TYPE_COLUMN];
              if (ptype) {
                var search = ptype;
                if (ptype == ROOT_KEYWORD) search = ROOT_TYPE;
                //verifico sia un parent consentito
                var idCode = getTreeCode(value.commission, value.customer);
                var allowedParents = treeStructuresToResolve[idCode] ? treeStructuresToResolve[idCode][$scope.typeName] : null;
                if (!allowedParents || allowedParents.indexOf(search.trim()) === -1) {
                  if (value['sixImportStatus'] == 'OK') value['sixImportStatus'] = '';
                  value['sixImportStatus'] = value['sixImportStatus'].concat('Parent non consentito; ');
                  $scope.errorCount++;
                }
              }
            });
          });
        }
        for (var index in indexMapToResolve) {
          var mapToResolve = indexMapToResolve[index];
          var promise;
          if (index === 'record') {
            var lookupRequests = getRequestFromMap(mapToResolve);
            var _assetImported = getRequestFromMap(assetImported);
            promise = recordFactory('type').bulkFindList(lookupRequests.concat(_assetImported)).$promise;
          } else if (index === 'pricelist') {
            promise = priceListFactory.bulkResolve(mapToResolve).$promise;
          }
          promise.then(function (index) {
            return function (data) {
              $log.info(data);
              $scope.gridOptions.xlsData.forEach(function (value) {
                $scope.preprocessToResolve++; ///un po' così.... conto 1 per ogni record+ 1 per ogni lookup da risolvere...

                for (var l in lookups) {
                  (function () {
                    //closure <3
                    var k = lookups[l];
                    var v = value[k];
                    if (!angular.isUndefined(v) && v !== null) {
                      $scope.preprocessResolved++;
                      if (index === 'record') {
                        resolveForRecord(value, k, v, properties, data);
                      } else {
                        var resolved = data[properties[k].entity_id];
                        resolveForOther(value, k, v, properties, resolved);
                      }
                    }
                  })();
                }
                if (!parentsJson && $scope.withTree && index === 'record') {
                  var ptype = value[PARENT_TYPE_COLUMN] ? value[PARENT_TYPE_COLUMN].trim() : value[PARENT_TYPE_COLUMN];
                  var pcode = value[PARENT_CODE_COLUMN] ? value[PARENT_CODE_COLUMN].trim() : value[PARENT_CODE_COLUMN];
                  if (ptype || pcode) {
                    //verifico il parent esista
                    var parent = findParent(data, value, pcode, ptype); //parent non può essere undefined
                    var treeCode = getTreeCode(value.commission, value.customer);
                    if (ptype && pcode && (ptype == ROOT_TYPE || ptype == ROOT_KEYWORD && pcode == ROOT_KEYWORD || parent)) {
                      if (ptype == ROOT_KEYWORD && pcode == ROOT_KEYWORD) {
                        addParentToChildren(value.commission, value.customer, treeCode, value);
                      } else if (ptype == ROOT_TYPE) {
                        addParentToChildren(value.commission, value.customer, pcode, value); //fixme? non valido in alcun modo il nome del tree
                      } else {
                        addParentToChildren(value.commission, value.customer, treeCode, value, parent.response);
                      }
                    } else {
                      if (value['sixImportStatus'] == 'OK') value['sixImportStatus'] = '';
                      value['sixImportStatus'] = value['sixImportStatus'].concat('Parent non trovato; ');
                      $scope.errorCount++;
                    }
                    var child = findChild(data, value); //child può essere undefined solo quando l'asset importato non esiste prima dell'import
                    //controllo corrispondenza tra il codice del tree e i codici parent-child
                    var parentTreeCode = getAssetTreeCode(parent ? parent.response : undefined, value);
                    var childTreeCode = getAssetTreeCode(child ? child.response : undefined, value);
                    if (parent && treeCode != parentTreeCode || child && treeCode != childTreeCode) {
                      if (value['sixImportStatus'] == 'OK') value['sixImportStatus'] = '';
                      value['sixImportStatus'] = value['sixImportStatus'].concat('Combinazione parent-child non consentita; ');
                      $scope.errorCount++;
                      // il tree deve essere o completamente cross-customer o specifico per il customer.
                      // Il parent cross-customer non può avere un child con il customer settato, e viceversa.
                    }
                  }
                }

                if (!findChild(data, value)) {
                  value.sixOperation = 'INSERT';
                } else {
                  value.sixOperation = 'UPDATE';
                }
              });
            };
          }(index));
        }
      }
    }).then(function () {
      return recordFactory('type').bulkFindList(getRequestFromMap(futureVersions)).$promise.then(function (data) {
        data = data.map(function (el) {
          return el.response;
        });
        $scope.gridOptions.xlsData.forEach(function (row) {
          var futureV = getFutureVersion(data, row);
          if (futureV) {
            row.sixInfo = row.sixInfo.concat("Attenzione, il dato sarà sovrascritto in data " + moment(futureV.dataIn).format("DD/MM/YYYY-HH:mm:ss") + " dalla versione " + futureV.version);
          }
        });
      });
    }).then(function (data) {
      dialogService.stopLoading();
      $timeout(function () {
        //resize colonne per leggibilità
        document.querySelectorAll(".ui-grid-column-resizer.right").forEach(function (el) {
          el.dispatchEvent(new CustomEvent("dblclick"));
        });
      });
    });
  };
  function findParent(data, value, pcode, ptype) {
    return data.find(function (el) {
      if (value.commission && value.customer) {
        return el.response && el.response.schemaCode == ptype && el.response.model.code == pcode && el.request.exact_match && el.response.commission && el.response.commission.indexOf(value.commission) != -1 && el.response.customer && el.response.customer.indexOf(value.customer) != -1;
      } else if (!value.commission && value.customer) {
        return el.response && el.response.schemaCode == ptype && el.response.model.code == pcode && el.request.exact_match && (!el.response.commission || el.response.commission.length == 0) && el.response.customer && el.response.customer.indexOf(value.customer) != -1;
      } else if (value.commission && !value.customer) {
        return el.response && el.response.schemaCode == ptype && el.response.model.code == pcode && el.request.exact_match && (!el.response.customer || el.response.customer.length == 0) && el.response.commission && el.response.commission.indexOf(value.commission) != -1;
      } else if (!value.commission && !value.customer) {
        return el.response && el.response.schemaCode == ptype && el.response.model.code == pcode && el.request.exact_match && (!el.response.customer || el.response.customer.length == 0) && (!el.response.commission || el.response.commission.length == 0);
      }
      return false;
    });
  }
  function findChild(data, value) {
    return data.find(function (el) {
      if (value.commission && value.customer) {
        return el.response && el.response.schemaCode == $scope.typeName && el.response.model.code == value.code && el.response.commission && el.response.commission.indexOf(value.commission) != -1 && el.response.customer && el.response.customer.indexOf(value.customer) != -1;
      } else if (!value.commission && value.customer) {
        return el.response && el.response.schemaCode == $scope.typeName && el.response.model.code == value.code && (!el.response.commission || el.response.commission.length == 0) && el.response.customer && el.response.customer.indexOf(value.customer) != -1;
      } else if (value.commission && !value.customer) {
        return el.response && el.response.schemaCode == $scope.typeName && el.response.model.code == value.code && (!el.response.customer || el.response.customer.length == 0) && el.response.commission && el.response.commission.indexOf(value.commission) != -1;
      } else if (!value.commission && !value.customer) {
        return el.response && el.response.schemaCode == $scope.typeName && el.response.model.code == value.code && (!el.response.customer || el.response.customer.length == 0) && (!el.response.commission || el.response.commission.length == 0);
      }
      return false;
    });
  }
  function getAssetTreeCode(asset, value) {
    var commission, customer;
    if (asset && asset.commission) {
      commission = asset.commission[asset.commission.findIndex(function (el) {
        return el == value.commission;
      })];
    }
    if (asset && asset.customer) {
      customer = asset.customer[asset.customer.findIndex(function (el) {
        return el == value.customer;
      })];
    }
    return getTreeCode(commission, customer);
  }
  function getFutureVersion(data, row) {
    return data.find(function (el) {
      if (el) {
        if (row.commission && row.customer) {
          return el.model.code == row.code && el.commission && el.commission.indexOf(row.commission) != -1 && el.customer && el.customer.indexOf(row.customer) != -1 && el.schemaCode == $scope.typeName;
        } else if (!row.commission && row.customer) {
          return el.model.code == row.code && !el.commission && el.customer && el.customer.indexOf(row.customer) != -1 && el.schemaCode == $scope.typeName;
        } else if (row.commission && !row.customer) {
          return el.model.code == row.code && el.commission && el.commission.indexOf(row.commission) != -1 && !el.customer && el.schemaCode == $scope.typeName;
        } else if (!row.commission && !row.customer) {
          return el.model.code == row.code && !el.commission && !el.customer && el.schemaCode == $scope.typeName;
        }
      }
      return false;
    });
  }
  function resolveForRecord(value, k, v, properties, data) {
    if (properties[k].hasOwnProperty('multiple') && properties[k].multiple == true) {
      // lookup multipla
      var arrayLookup = arrayLookupParser(v);
      var resolved;
      if (arrayLookup.length > 0) {
        value[k] = [];
        arrayLookup.forEach(function (vlookup) {
          resolved = data.find(function (el) {
            return el.response && el.response.model.code == vlookup && !el.request.exact_match && el.response.schemaCode == properties[k].entity_id && el.request.customer == value.customer && el.request.commission == value.commission;
          });
          var ref = sixObjectLib.recordToHisRef(resolved ? resolved.response : resolved);
          if (!ref) {
            if (value['sixImportStatus'] == 'OK') value['sixImportStatus'] = '';
            value['sixImportStatus'] = value['sixImportStatus'].concat(k + ' (' + properties[k].entity_id + ') array di lookup non risolto per: "' + vlookup + '"; ');
            $scope.errorCount++;
          } else {
            value[k].push(ref);
          }
        });
      }
    } else {
      resolved = data.find(function (el) {
        return el.response && el.response.model.code == v && !el.request.exact_match && el.response.schemaCode == properties[k].entity_id && el.request.customer == value.customer && el.request.commission == value.commission;
      });
      var ref = sixObjectLib.recordToHisRef(resolved.response);
      if (!ref) {
        if (value['sixImportStatus'] == 'OK') value['sixImportStatus'] = '';
        value['sixImportStatus'] = value['sixImportStatus'].concat(k + ' (' + properties[k].entity_id + ') ' + v + ' non trovato; ');
        $scope.errorCount++;
      } else {
        value[k] = ref;
      }
    }
  }
  function resolveForOther(value, k, v, properties, resolved) {
    if (resolved) {
      if (properties[k].hasOwnProperty('multiple') && properties[k].multiple == true) {
        // lookup multipla
        var arrayLookup = arrayLookupParser(v);
        if (arrayLookup.length > 0) {
          value[k] = [];
          arrayLookup.forEach(function (vlookup) {
            if (resolved.hasOwnProperty(vlookup)) {
              var ref = sixObjectLib.recordToHisRef(resolved[vlookup]);
              if (!ref) {
                if (value['sixImportStatus'] == 'OK') value['sixImportStatus'] = '';
                value['sixImportStatus'] = value['sixImportStatus'].concat(k + ' (' + properties[k].entity_id + ') array di lookup non risolto per: "' + vlookup + '"; ');
                $scope.errorCount++;
              } else {
                value[k].push(ref);
              }
            }
          });
        }
      } else {
        var ref = sixObjectLib.recordToHisRef(resolved[v]);
        if (!ref) {
          if (value['sixImportStatus'] == 'OK') value['sixImportStatus'] = '';
          value['sixImportStatus'] = value['sixImportStatus'].concat(k + ' (' + properties[k].entity_id + ') ' + v + ' non trovato; ');
          $scope.errorCount++;
        } else {
          value[k] = ref;
        }
      }
    }
  }
  function getTreeCode(commission, customer) {
    var idCode = "";
    if (commission) {
      idCode = idCode.concat('def' + commission);
    }
    if (customer) {
      idCode = idCode.concat('cli' + customer);
    }
    return idCode;
  }
  function arrayLookupParser(string) {
    var arrayString = string;
    var arrayLookup = [];
    arrayString = arrayString.replace(new RegExp('"', 'g'), ''); // pulizia dai vari tipi di virgolette, in base alla formattazione..
    arrayString = arrayString.replace(new RegExp('“', 'g'), '');
    arrayString = arrayString.replace(new RegExp('”', 'g'), '');
    arrayString = arrayString.replace(new RegExp(' ', 'g'), ''); // pulizia dagli spazi dei codici..
    arrayString = arrayString.substring(arrayString.lastIndexOf("[") + 1, arrayString.lastIndexOf("]")); // eliminazione []
    if (arrayString.length > 0) {
      arrayLookup = arrayString.split(","); // creazione array con i 'code'
    }

    return arrayLookup;
  }
  function buildAllowedParents(parentSchema, nodes, result) {
    //restituisce una struttura del tipo:
    //{ tipoChild1: [tipoParentValido1, tipoParentValido2, ...], tipoChild2: [tipoParentValido3, tipoParentValido4, ...], ... }
    var result = result || {};
    if (nodes && nodes.length) {
      for (var n in nodes) {
        var child = nodes[n].UUID;
        if (!result[child]) {
          result[child] = [];
        }
        if (result[child].indexOf(parentSchema) === -1) {
          result[child].push(parentSchema);
        }
        buildAllowedParents(child, nodes[n].nodes, result);
      }
    }
    return result;
  }
  function addParentToChildren(commission, customer, treeCode, child, parentDest) {
    var root = angular.isUndefined(parentDest);
    var treeCode = treeCode ? treeCode : getTreeCode(commission, customer);
    if (!child.parents) {
      child.parents = [];
    }
    // TODO in realtà dovrei rimuovere solo i parent di questo tree (possibilità di avere più tree)
    child.parents = [];
    var parentRef;
    if (root) {
      parentRef = {};
    } else {
      parentRef = sixObjectLib.recordToHisRef(parentDest);
    }
    parentRef.treeCode = treeCode;
    var parents = [];
    if (parentDest && parentDest.parents && [].concat(parentDest.parents).length > 0) {
      parents = parentDest.parents;
    }
    child.parents = child.parents.concat(parents).concat(parentRef);
  }
  $scope.updatePreprocessPercent = function () {
    $scope.prePercent = $scope.preprocessResolved * 1.0 / $scope.preprocessToResolve * 100;
  };
  $scope.notifyToDialog = function () {
    var notifyData = {
      async: true,
      to: null
    };
    var notifyToDialog = ngDialog.openConfirm({
      name: 'notifyToDialog',
      closeByDocument: false,
      showClose: true,
      data: notifyData,
      template: '' + '<div style="text-align:center"><i class="fa fa-list"></i>&nbsp; Notifica generazione righe</div><br>' + '<div class="m-l-n-xxs" style="clear: both">' + '<input type="checkbox" id="async_elaboration" ng-model="ngDialogData.async" style="clear: both" /> <label for="async_elaboration" class="control-label"> Invia via mail</label><br />' + '</div>' + '<div class="row wrapper" style="text-align:center; clear: both" ng-show="ngDialogData.async">' + 'Invia una notifica di completamento al seguente indirizzo:<br>' + '<input class="form-control" type="email" ng-model="ngDialogData.to" placeholder="Indirizzo email"><br />' + '</div>' + '<div class="row" style="text-align:center; clear: both">' + '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ng-click="confirm(ngDialogData)">Continua</button>' + '</div>',
      plain: true,
      className: 'ngdialog-theme-default ngdialog-theme-custom'
    });
    var userFilter = {
      'model.username': sixFiltersLib.exact('model.username', authFactory.getAuthData().authId)
    };
    recordFactory('operatore').search(userFilter).$promise.then(function (resp) {
      if (resp.list) {
        notifyData.to = resp.list[0].model.mail;
      }
    });
    return notifyToDialog;
  };
  $scope.importData = function () {
    if ($scope.errorCount > 0) {
      dialogService.dialog('Sono presenti errori', 'Impossibile importare i dati', 'warning', 4000, true);
      return;
    }
    dialogService.showLoadingMessage('Importazione...');
    $scope.importBusy = true;
    var counter = 0;
    $scope.data = [];
    $scope.gridOptions.data.forEach(function (value) {
      delete value['$$hashKey']; //questa è robaccia di uigrid
      delete value['sixImportStatus'];
      delete value['sixInfo'];
      delete value['sixOperation'];
      delete value[PARENT_TYPE_COLUMN];
      delete value[PARENT_CODE_COLUMN];
      if (!$scope.withTree) {
        delete value['parents'];
      }
      $scope.data = $scope.data.concat(value);
    });
    stopDummyUpdateProgressBar = false;
    updateDummyProgressBar();
    var promise;
    if ($scope.typeName === 'zonatermica') {
      promise = zonaTermicaFactory.bulk($scope.data).$promise;
    } else {
      stopDummyUpdateProgressBar = true;
      promise = $scope.notifyToDialog().then(function (notify) {
        var params = {
          "with_tree": $scope.withTree
        };
        if (notify.async) {
          params["notify_to"] = notify.to;
        }
        stopDummyUpdateProgressBar = false;
        updateDummyProgressBar();
        var toastInstance = toaster.pop({
          type: 'warning',
          title: 'Upload',
          body: 'Upload file in corso, non ricaricare la pagina.',
          timeout: 0
        });
        return recordFactory($scope.typeName).bulkImport(params, $scope.data).$promise.then(function (result) {
          toaster.clear(toastInstance);
          return result;
        });
      }, function () {
        return $q.reject("Operazione annullata");
      });
    }
    promise.then(function (response) {
      $scope.reportMessages = response.messages;
      stopDummyUpdateProgressBar = true;
      dialogService.stopLoading();
      if (response.status === 'errors') {
        toaster.pop('error', 'Errore', 'Errore durante il salvataggio');
      } else if (response.meta.type === 'async') {
        counter = $scope.data.length;
        $scope.percent = counter / $scope.data.length * 100;
        toaster.pop('success', 'Importazione avviata', 'Importazione avviata. Riceverai una notifica al termine.');
        recordWSFactory.subscribe('import/' + response.result);
      } else {
        counter = $scope.data.length;
        $scope.percent = counter / $scope.data.length * 100;
        toaster.pop('success', 'Importazione completata', 'L\'importazione è terminata correttamente.');
      }
    })["catch"](function (response) {
      $scope.percent = 0;
      stopDummyUpdateProgressBar = true;
      toaster.pop('error', 'Errore', 'Impossibile eseguire l\'importazione. Dettaglio: ' + response);
    });
  };

  //cambio type
  $scope.$watch(function () {
    return $scope.entity.type;
  }, function (newValue, oldValue) {
    $scope.isEntitySelected = angular.isDefined(newValue);
    if (!$scope.isEntitySelected) {
      $scope.reset();
    }
    if (newValue != oldValue) {
      $scope.importBusy = false;
      $scope.errorCount = 0;
      $scope.percent = 0;
      $scope.prePercent = 0;
      $scope.missingParentCount = 0;
      $scope.preprocessToResolve = 0;
      $scope.preprocessResolved = 0;
      $scope.gridOptions.xlsData = [];
      $scope.data = [];
      $scope.gridOptions.data = [];
      $scope.gridOptions.columnDefs = [];
      $scope.typeName = '';
      $scope.schemaDefinition = {};
      $scope.reportMessages = [];
      if ($scope.entity.type) {
        $scope.typeName = $scope.entity.type.UUID;
        //carico le definizioni dello schema
        dialogService.showLoadingMessage('Caricamento modello...');
        schemaFactory().byUUID({
          id: $scope.typeName
        }).$promise.then(function (schemaDefinition) {
          setTimeout(function () {
            dialogService.stopLoading();
          }, 10);
          $scope.schemaDefinition = schemaDefinition;
          if (!schemaDefinition || !schemaDefinition.model || !schemaDefinition.model.schema.properties) {
            dialogService.alert('Definizione modello non trovata o errata');
            return;
          }
          //disattivo withTree se è un asset crossCommessa
          if (!$scope.schemaDefinition.model.commissionDependent) {
            $scope.withTree = false;
          } /*else {
            $scope.withTree = true;
            }*/
        });
      } else {
        $scope.typeName = '';
      }
    }
  });

  //attivazione/disattivazione import tree
  $scope.$watch("withTree", function (newValue, oldValue) {
    if (newValue != oldValue) {
      if (!$scope.isEntitySelected) {
        $scope.reset();
        $scope.withTree = newValue;
      } else {
        $scope.importBusy = false;
        $scope.errorCount = 0;
        $scope.percent = 0;
        $scope.prePercent = 0;
        $scope.missingParentCount = 0;
        $scope.preprocessToResolve = 0;
        $scope.preprocessResolved = 0;
        $scope.gridOptions.xlsData = [];
        $scope.data = [];
        $scope.gridOptions.data = [];
        $scope.reportMessages = [];
      }
    }
  });

  /*************************************/
  // Template xlsx
  /*************************************/

  function buildDataType(prop) {
    if (prop.type === 'string' && prop.format === 'date') {
      return 'yyyy-MM-dd';
    } else if (prop.type === 'string' && prop.format === 'lookup') {
      return 'ref';
    } else if (prop.type === 'integer') {
      return 1;
    } else if (prop.type === 'number') {
      return 1.234;
    } else if (prop.type === 'object') {
      var obj = {};
      for (var key in prop.properties) {
        obj[key] = buildDataType(prop.properties[key]);
      }
      return JSON.stringify(obj);
    }
    return 'text';
  }
  function schemaDefinitionToSheet() {
    var ws = {};
    var range = {
      s: {
        c: 10000000,
        r: 10000000
      },
      e: {
        c: 0,
        r: 0
      }
    };
    var data = [[], []];
    data[0].push(PARENT_TYPE_COLUMN);
    data[1].push("text");
    data[0].push(PARENT_CODE_COLUMN);
    data[1].push("text");
    if ($scope.schemaDefinition.model.commissionDependent) {
      data[0].push("commission");
      data[1].push("text");
    }
    data[0].push("customer");
    data[1].push("text");
    for (var key in $scope.schemaDefinition.model.schema.properties) {
      // Intestazione di colonna
      data[0].push(key);
      // Riga di esempio
      var prop = $scope.schemaDefinition.model.schema.properties[key];
      var example = 'text';
      if (prop.type === 'array') {
        if (!prop.items) {
          example = '[item1, item2]';
        } else {
          example = '[' + buildDataType(prop.items) + ',' + buildDataType(prop.items) + ']';
        }
      } else {
        example = buildDataType(prop);
      }
      data[1].push(example);
    }
    data[0].push("dataIn");
    data[1].push("AAAA-MM-GG");
    for (var R = 0; R != data.length; ++R) {
      for (var C = 0; C != data[R].length; ++C) {
        if (range.s.r > R) range.s.r = R;
        if (range.s.c > C) range.s.c = C;
        if (range.e.r < R) range.e.r = R;
        if (range.e.c < C) range.e.c = C;
        var cell = {
          v: data[R][C]
        };
        if (cell.v == null) continue;
        var cell_ref = XLSX.utils.encode_cell({
          c: C,
          r: R
        });
        if (typeof cell.v === 'number') cell.t = 'n';else if (typeof cell.v === 'boolean') cell.t = 'b';else if (cell.v instanceof Date) {
          cell.t = 'n';
          cell.z = XLSX.SSF._table[14];
          cell.v = datenum(cell.v);
        } else cell.t = 's';
        ws[cell_ref] = cell;
      }
    }
    if (range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
    return ws;
  }
  function Workbook() {
    if (!(this instanceof Workbook)) return new Workbook();
    this.SheetNames = [];
    this.Sheets = {};
  }
  function datenum(v, date1904) {
    if (date1904) v += 1462;
    var epoch = Date.parse(v);
    return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
  }
  $scope.schemaDefinitionToXlsx = function () {
    //var ranges = oo[1];

    /* original data */
    var ws_name = $scope.entity.type.UUID;
    var wb = new Workbook();
    var ws = schemaDefinitionToSheet();

    /* add ranges to worksheet */
    //ws['!merges'] = ranges;

    /* add worksheet to workbook */
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    var wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      bookSST: false,
      type: 'binary'
    });
    saveAs(new Blob([s2ab(wbout)], {
      type: "application/octet-stream"
    }), $scope.entity.type.UUID + ".xlsx");
  };
  function s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
  }

  // fa avanzare la progress bar a caso, giusto per far vedere che sta facendo qualcosa
  var stopDummyUpdateProgressBar = false;
  function updateDummyProgressBar() {
    if ($scope.percent < 100 && stopDummyUpdateProgressBar === false) {
      $timeout(function () {
        if (stopDummyUpdateProgressBar === false) {
          $scope.percent += $scope.percent < 90 ? Math.random() * 5 : 0; // appena supero il 90% mi fermo e attendo che qualcuno lo porti a 100%
          if ($scope.percent < 100) {
            updateDummyProgressBar();
          }
        }
      }, Math.random() * 2000);
    }
  }
  function compareDates(date1, date2) {
    var d1, d2;
    d1 = angular.isDate(date1) ? date1 : new Date(date1);
    d2 = angular.isDate(date2) ? date2 : new Date(date2);
    if (d1 && !d2) return 1; // d1 > d2
    if (!d1 && d2) return -1; // d1 < d2
    if (!d1 && !d2) return 0; // d1 == d2
    if (d1.getTime() > d2.getTime()) return 1;
    if (d1.getTime() < d2.getTime()) return -1;
    return 0;
  }

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'record/{entity}';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };

  /** ***********************************
   * Help dialog
   * ***********************************/

  $scope.showHelpDialog = function () {
    var dlgScope = {
      lang: 'html'
    };
    var dlgOpts = {
      name: 'helpDialog',
      closeByDocument: true,
      plain: false
    };
    var helpDialog = dialogService.templateDialog('helpTemplate.html', dialogService.DIALOG_TYPE.INFO, dlgScope, dlgOpts, -1, false, '50%');
  };
}]);
"use strict";

(function () {
  'use strict';

  angular.module('emma.dataset').config(["$routeProvider", function ($routeProvider) {
    $routeProvider.when('/mailrecord', {
      templateUrl: 'dataset/mailrecord/mailrecord_list.html',
      controller: 'MailRecordCtrl'
    });
  }]).controller('MailRecordCtrl', ["$scope", "toaster", "uiGridConstants", "sixGridPaginationConstants", "notificationFactory", function ($scope, toaster, uiGridConstants, sixGridPaginationConstants, notificationFactory) {
    $scope.notificationPanelOpen = false;
    $scope.params = {
      pageNumber: 1,
      pageSize: 100,
      filters: {},
      sortFields: "dataIn:desc"
    };
    $scope.notificationList = {
      list: []
    };
    $scope.viewgridOpt = {
      enableFiltering: true,
      enableOrdering: true,
      enableHorizontalScrollbar: 1,
      enableRowSelection: $scope.canClose,
      enableRowHeaderSelection: $scope.canClose,
      appScopeProvider: $scope,
      isRowSelectable: function isRowSelectable(row) {
        return row.entity.model.status == 'invoice_opened';
      },
      columnDefs: [{
        displayName: '',
        field: 'id',
        width: 36,
        enableColumnMenu: false,
        enableFiltering: false,
        enableSorting: false,
        enableColumnResizing: false,
        enableHiding: false,
        cellTemplate: '<div class="ui-grid-cell-contents text-center">' + '<a ng-click="grid.appScope.gotoDetail(row)" class="btn btn-xs btn-primary">' + '<span class="fa fa-search"></span>' + '</a>' + '</div>'
      }, {
        displayName: 'Oggetto',
        field: 'model.subject',
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS
        }]
      }, {
        displayName: 'Destinatari',
        field: 'model.to',
        width: 500,
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS
        }]
      }, {
        displayName: 'Codice Mail',
        field: 'model.mailId',
        cellTemplate: '<div data-toggle="tooltip" data-placement="top" title="{{row.entity.model.mailId > 0? \'Mail Consegnata\' : \'Mail Non Consegnata\' }}"> <six-consip-timing-led sx-value="grid.appScope.getStoplightValue(row.entity.model.mailId)" ></six-consip-timing-led>  {{row.entity.model.mailId}}</div>',
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS
        }]
      }, {
        displayName: 'Data',
        field: 'dataIn',
        cellFilter: "date:'dd/MM/yyyy HH:mm'",
        filters: [{
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
          placeholder: 'da...',
          condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
        }, {
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
          placeholder: 'a...',
          condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
        }]
      }]
    };
    $scope.gotoDetail = function (row) {
      $scope.notificationPanelOpen = true;
      $scope.selectedNotification = row.entity;
    };
    $scope.getStoplightValue = function (id) {
      return id > 0 ? 1 : 3;
    };
    $scope.getList = function () {
      var payload = {
        page: $scope.params.pageNumber,
        page_size: $scope.params.pageSize,
        query: $scope.params.queryParam,
        sort_fields: $scope.params.sortFields,
        entity: 'notification'
      };
      return notificationFactory().search(payload, $scope.params.filters).$promise.then(function (response) {
        $scope.notificationList.list = response.list || [];
        $scope.notificationList.totalResults = response.totalResults;
        $scope.params.sixApi.refreshList(response.list);
        return response;
      })["catch"](function (response) {
        toaster.pop('error', 'Errore', 'Errore durante il recupero dei dati');
      });
    };
  }]);
})();
'use strict';

/**
 * @ngdoc service
 * @name emma.dataset.modelFactory
 * @description
 * # modelFactory
 * Factory in the emma.dataset.
 */
angular.module('emma.dataset').factory('modelFactory', ["DATA_SET_URL", "$resource", function (DATA_SET_URL, $resource) {
  return $resource(DATA_SET_URL + '/api/model/:type/:id', {}, {
    query: {
      method: 'GET',
      params: {
        type: '@type'
      },
      isArray: false
    },
    create: {
      method: 'POST',
      params: {
        type: '@type'
      }
    },
    show: {
      method: 'GET'
    },
    update: {
      method: 'PUT',
      params: {
        type: '@type',
        id: '@id'
      }
    },
    "delete": {
      method: 'DELETE',
      params: {
        type: '@type',
        id: '@id'
      }
    }
  });
}]);
'use strict';

/**
 * @ngdoc function
 * @name emma.dataset.controller:ModeltypeCtrl
 * @description
 * # ModeltypeCtrl
 * Controller of the emma.dataset
 */
angular.module('emma.dataset').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/modeltype/:type', {
    templateUrl: 'dataset/modeltype/modeltype_list.html',
    controller: 'ModeltypeCtrl'
  }).when('/modeltype/:type/:id', {
    templateUrl: 'dataset/modeltype/modeltype_detail.html',
    controller: 'ModeltypeCtrl'
  }).when('/modeltype/page/:type/:number', {
    templateUrl: 'dataset/modeltype/modeltype_list.html',
    controller: 'ModeltypeCtrl'
  });
}]).controller('ModeltypeCtrl', ["$scope", "$routeParams", "$location", "$log", "$window", "formulaFactory", "toaster", "authFactory", "$q", "schemaFactory", "uiGridConstants", "sixGridPaginationConstants", "dialogService", "$filter", "$timeout", function ($scope, $routeParams, $location, $log, $window, formulaFactory, toaster, authFactory, $q, schemaFactory, uiGridConstants, sixGridPaginationConstants, dialogService, $filter, $timeout) {
  $scope.form = {};
  $scope.model = {};
  $scope.schema = {};
  $scope.property = {};
  $scope.checked = {};
  $scope.uiselectMap = {};
  $scope.itemTypeMap = {};
  $scope.newItemArray = {
    record_id: {}
  };
  $scope.status = {
    isFirstOpen: true,
    isFirstDisabled: false
  };
  $scope.selfGeneratedCode = {
    codeNameSix: '',
    active: false
  };
  $scope.bools = {
    formCrossCommission: false,
    columndefsCrossCommission: false
  };
  var CURRENT_COMMISSION = authFactory.getAuthData().info.commissions.current;
  $scope.modeltypeList = schemaFactory().lookupList({
    page_size: 1000
  });
  $scope.type = {
    list: [],
    totalResults: 0
  };
  $scope.params = {
    pageNumber: 1,
    pageSize: 15,
    totalItems: 0,
    queryParam: undefined,
    filters: {
      hidden: sixFiltersLib.missing('model.hidden', sixFiltersLib.CONSTRAINTS.AND)
    }
  };
  $scope.gridAppCallbacks = {};
  $scope.viewGridOptions = {
    enableSorting: true,
    enableFiltering: true,
    columnDefs: [],
    enableColumnResizing: true,
    paginationPageSize: $scope.params.pageSize
  };
  $scope.viewGridOptions.columnDefs = [{
    displayName: '',
    field: 'id',
    width: 36,
    enableCellEdit: true,
    enableFiltering: false,
    enableSorting: false,
    cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/modeltype/schema/{{row.entity.version}}" class="btn btn-xs btn-primary">' + '<span class="fa fa-search"></span>' + '</a>' + '</div>'
  }, {
    displayName: 'Codice',
    field: 'model.code',
    enableFiltering: true,
    filters: [{
      type: sixGridPaginationConstants.filterType.TEXT,
      condition: uiGridConstants.filter.CONTAINS,
      //exact o contains non funziona comunque, colpa del lowercase da qualche parte...
      placeholder: ''
    }]
  }, {
    displayName: 'Descrizione',
    field: 'model.description',
    enableFiltering: true,
    filters: [{
      type: sixGridPaginationConstants.filterType.TEXT,
      condition: uiGridConstants.filter.CONTAINS,
      placeholder: ''
    }]
  }, {
    displayName: '',
    field: 'link',
    width: 36,
    enableCellEdit: true,
    enableFiltering: false,
    enableSorting: false,
    cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="{{grid.appScope.getRecordPath(row.entity.model)}}" class="btn btn-xs btn-primary">' + '<span class="fa fa-chevron-right"></span>' + '</a>' + '</div>'
  }];
  $scope.getRecordPath = function (model) {
    var editorType = "";
    if (model.priceListManagement) {
      editorType = "list";
    } else {
      if (model.history) {
        editorType = "snap";
      } else {
        editorType = "stable";
      }
    }
    return "#/record/" + editorType + "/" + model.code;
  };
  $scope.gridAppCallbacks["getRecordPath"] = $scope.getRecordPath;
  $scope.newModel = function () {
    $location.path('modeltype/' + $scope.typeName + '/new');
  };
  $scope.debug = function () {
    $scope.jsonshow;
  };
  $scope.refresh = function () {
    $scope.getType();
    $location.path('modeltype/' + $scope.typeName);
  };
  $scope.getFormulaList = function () {
    formulaFactory.getFormulasList({
      query: $scope.queryParam,
      page_size: 1000
    }).$promise.then(function (data) {
      $scope.formulaList = data.list;
    });
  };
  $scope.getFormulaList();
  $scope.getType = function () {
    var payload = {
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      sort_fields: $scope.params.sortFields,
      sort_order: $scope.params.sortOrder,
      show_revision: false,
      query: $scope.params.queryParam
    };
    return schemaFactory().search(payload, $scope.params.filters).$promise.then(function (result) {
      $scope.type.list = result.list || [];
      $scope.type.totalResults = result.totalResults;
      $scope.params.sixApi.refreshList(result.list);
      return result;
    });
  };
  $scope.pageList = function () {
    $location.path('/modeltype/' + $scope.typeName, false);
  };

  // ___main___
  if ($routeParams.id) {
    $scope.typeName = $routeParams.type;
  } else if ($routeParams.number) {
    $scope.typeName = $routeParams.type;
    $scope.type = schemaFactory().query({
      query: $scope.queryParam,
      page: $routeParams.number
    });
  } else {
    $scope.typeName = $routeParams.type;
  }
  $scope.saveForm = function (history, back) {
    var deferred = $q.defer();
    if (angular.isUndefined(history)) {
      history = true;
    }
    if (angular.isUndefined(back)) {
      back = true;
    }
    var temp = JSON.parse($scope.aceModel);
    temp.columndefsCommission = CURRENT_COMMISSION.code;
    $scope.aceModel = JSON.stringify(temp, null, '\t');
    if ($scope.type.selected.model.code && $scope.type.selected.model.description) {
      if ($scope.type.selected.version) {
        var payload = {
          id: $scope.type.selected.version,
          history: history
        };
        schemaFactory().update(payload, $scope.aceModel).$promise.then(function (resp) {
          if (!resp || !resp.hasErrors) {
            deferred.resolve(resp);
            toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
            if (back) $window.history.back();
          } else {
            deferred.reject();
            toaster.pop('error', 'Errore salvataggio', 'Si è verificato un errore durante il salvataggio');
            dialogService.serviceResponse('Errore salvataggio', resp);
          }
        })["catch"](function (rejection) {
          deferred.reject();
          $log.error(rejection);
          var message = rejection.data.message.indexOf('MapperParsingException') !== -1 ? 'Potrebbe essersi verificato un conflitto tra i tipi di campi impostati' : 'Si è verificato un errore durante il salvataggio';
          toaster.pop('error', 'Errore salvataggio', message);
        });
      } else {
        var toSave = JSON.parse($scope.aceModel);
        toSave.model.columndefsCommission = toSave.columndefsCommission;
        toSave.model.columndefsCrossCommission = toSave.columndefsCrossCommission;
        schemaFactory().create(toSave.model).$promise.then(function (resp) {
          if (resp) {
            deferred.resolve(resp);
            toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
            if (back) $window.history.back();
          } else {
            deferred.reject();
            toaster.pop('error', 'Errore salvataggio', 'Si è verificato un errore durante il salvataggio');
          }
        })["catch"](function (response) {
          deferred.reject();
          toaster.pop('error', 'Errore salvataggio', 'Si è verificato un errore durante il salvataggio');
        });
      }
    }
    return deferred.promise;
  };
  $scope["delete"] = function () {
    schemaFactory().referenceCount({
      id: $scope.type.selected.UUID
    }).$promise.then(function (response) {
      var deleteMessage = 'Eliminare il modello "' + $scope.type.selected.model.description + '"?';
      if (response.count != 0) {
        var deleteMessage = 'Il modello: "' + $scope.type.selected.model.description + '"' + ' è in uso nel sistema.<br> Vuoi rimuoverlo comunque?';
      }
      dialogService.confirmDialog(deleteMessage, function () {
        schemaFactory()["delete"]({
          id: $scope.type.selected.version
        }).$promise.then(function () {
          $window.history.back();
        });
      });
    });
  };
  $scope.addProperty = function () {
    if (angular.isDefined($scope.property.key)) {
      var p = {
        title: angular.copy($scope.property.title),
        type: angular.copy($scope.property.type),
        check: false
      };
      if ($scope.property.format) {
        p.format = angular.copy($scope.property.format);
      }
      if (p.type == 'date') {
        p.type = 'string';
        p.format = 'date';
      }
      if (p.type == 'array') {
        p.items = {
          type: angular.copy($scope.property.items_type)
        }; // default
        if ($scope.property.items_type === 'date') {
          // se è una data è diverso...
          p.items = {
            type: 'string',
            format: 'date'
          };
        }
      }
      if (p.format) {
        if (p.format == 'lookup') {
          p.show_filters = true;
        }
      }
      if ($scope.property.inherited) {
        if ($scope.property.inherited == true) {
          p.format = 'inherit';
          p.field = '';
          p.record = '';
          if ($scope.property.format) {
            p.field_inherit_type = $scope.property.format;
            if ($scope.property.format == 'enum') {
              delete p["enum"];
            }
          }
          if (p.type == 'integer') {
            p.type = 'number';
          }
        }
      }
      $scope.type.selected.model.schema.properties[$scope.property.key] = p;
      var item = {
        title: angular.copy($scope.property.title),
        type: null,
        key: [angular.copy($scope.property.key)]
      };
      if (p.format) {
        if (p.format == 'date') {
          item.type = 'datepicker';
        } else if (p.format == 'enum') {
          item.type = 'uiselect';
          item.titleMap = [];
        } else if (p.format == 'lookup') {
          item.type = 'sixlookup';
        } else if (p.format == 'formula') {
          item.type = 'sixformula';
        } else if (p.format == 'inherit') {
          item.type = 'sixinherit';
        }
      } else if (p.type == 'string') {
        item.type = 'text';
      } else if (p.type == 'number' || p.type == 'integer') {
        item.type = 'number';
      } else if (p.type == 'boolean') {
        item.type = 'checkbox';
      } else if (p.type == 'array') {
        if (p.items && p.items.format && p.items.format == 'date') {
          item.type = 'array';
        } else {
          item.type = 'uiselectmultiple';
          item.titleMap = [];
        }
      } else {
        // default
        item.type = angular.copy(p.type);
      }
      for (var i in $scope.type.selected.model.form[0].items) {
        if ($scope.type.selected.model.form[0].items[i].tabs) {
          $scope.type.selected.model.form[0].items[i].tabs[0].items.push(item);
        }
      }
    }
    $scope.getUiselectMap();
    $scope.clearNewCol();
    $scope.updateScope();
  };
  $scope.clearNewCol = function () {
    $scope.property.key = '';
    $scope.property.title = '';
    delete $scope.property.type;
    delete $scope.property.format;
    delete $scope.property.inherited;
  };
  $scope.getItemType = function (key) {
    $log.info(valueSchema);
    if (valueSchema.type != 'array') {
      return valueSchema.type;
    } else {
      return valueSchema.items.type;
    }
  };
  $scope.addItemOnArray = function (key, newItem) {
    if (newItem != undefined && newItem != null) {
      newItem.name = newItem.name.toString();
      if ($scope.itemTypeMap[key] == 'integer') {
        if (parseInt(newItem.name)) {
          newItem.value = parseInt(newItem.name);
          newItem.name = newItem.value.toString(); /* nel caso ci dovesse essere un cast, torno a sovrascrivere il name */
        } else {
          return;
        }
      } else if ($scope.itemTypeMap[key] == 'number') {
        if (parseFloat(newItem.name)) {
          newItem.value = parseFloat(newItem.name);
        } else {
          return;
        }
      } else {
        newItem.value = newItem.name.toString().replace(/\s/g, '_').toLowerCase();
      }
      for (var i in $scope.type.selected.model.form[0].items) {
        if ($scope.type.selected.model.form[0].items[i].tabs) {
          $scope.type.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
            if (key == item.key[0]) {
              item.titleMap.push(newItem);
            }
          });
        }
      }
      this.newItem = null;
      $scope.updateScope();
    }
  };
  $scope.deleteItemOnArray = function (key, obj) {
    for (var i in $scope.type.selected.model.form[0].items) {
      if ($scope.type.selected.model.form[0].items[i].tabs) {
        $scope.type.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
          if (key == item.key[0]) {
            for (var j = item.titleMap.length; j--;) {
              if (item.titleMap[j].value == obj.value) {
                item.titleMap.splice(j, 1);
              }
            }
          }
        });
      }
    }
    this.newItem = null;
    $scope.updateScope();
  };
  $scope.addRefOnArray = function (key, ref) {
    var newItem = {};
    if (ref.record_id != undefined && ref.record_id != null) {
      newItem.value = ref.record_id.code;
      newItem.name = ref.record_id.description;
      $scope.addItemOnArray(key, newItem);
    }
  };
  $scope.deleteProperty = function (keyToDelete) {
    delete $scope.type.selected.model.schema.properties[keyToDelete];
    var indexOfKeyToDelete = $scope.type.selected.model.schema.required.indexOf(keyToDelete);
    if (indexOfKeyToDelete !== -1) {
      $scope.type.selected.model.schema.required.splice(indexOfKeyToDelete, 1);
    }
    for (var i = $scope.type.selected.model.columnDefs.length; i--;) {
      if ($scope.type.selected.model.columnDefs[i].field == keyToDelete) $scope.type.selected.model.columnDefs.splice(i, 1);
    }
    for (var i = $scope.type.selected.model.form[0].items.length; i--;) {
      if ($scope.type.selected.model.form[0].items[i].key && $scope.type.selected.model.form[0].items[i].key[0] == keyToDelete) {
        $scope.type.selected.model.form[0].items.splice(i, 1);
      }
      // Scorro anche i tabs
      if ($scope.type.selected.model.form[0].items[i].tabs) {
        for (var j = $scope.type.selected.model.form[0].items[i].tabs.length; j--;) {
          for (var k = $scope.type.selected.model.form[0].items[i].tabs[j].items.length; k--;) {
            if ($scope.type.selected.model.form[0].items[i].tabs[j].items[k].key[0] == keyToDelete) {
              $scope.type.selected.model.form[0].items[i].tabs[j].items.splice(k, 1);
            }
          }
        }
      }
    }
    $scope.updateScope();
  };
  $scope.refreshCode = function (code) {
    $scope.chargeAceModel();
    $scope.type.selected.model.code = angular.copy(code);
    $scope.updateScope();
  };
  $scope.refreshDescription = function (description) {
    $scope.chargeAceModel();
    if (description) {
      $scope.type.selected.model.description = angular.copy(description);
      if (angular.isUndefined($scope.type.selected.UUID)) {
        $scope.code = sixStringLib.removeDiacritics(description);
        $scope.code = $scope.code.replace(/[^\w]|_/g, '').replace(/^(\d)(.*)/, '_$1$2').toLowerCase();
        $scope.type.selected.model.code = angular.copy($scope.code);
      }
    }
    $scope.updateScope();
  };
  $scope.refreshLookup = function (key, entity_id) {
    $scope.chargeAceModel();
    for (var i = $scope.type.selected.model.form[0].items.length; i--;) {
      if ($scope.type.selected.model.form[0].items[i].key && $scope.type.selected.model.form[0].items[i].key[0] == key) {
        $scope.type.selected.model.form[0].items[i].entity_id = angular.copy(entity_id);
      }
      // Scorro anche i tabs
      if ($scope.type.selected.model.form[0].items[i].tabs) {
        for (var j = $scope.type.selected.model.form[0].items[i].tabs.length; j--;) {
          for (var k = $scope.type.selected.model.form[0].items[i].tabs[j].items.length; k--;) {
            if ($scope.type.selected.model.form[0].items[i].tabs[j].items[k].key[0] == key) $scope.type.selected.model.form[0].items[i].tabs[j].items[k].entity_id = angular.copy(entity_id);
          }
        }
      }
    }
    $scope.type.selected.model.schema.properties[key].entity_id = angular.copy(entity_id);
    $scope.updateScope();
  };
  $scope.updateReverseLookup = function (key, reverseLookup) {
    if (reverseLookup) {
      $scope.refreshReverseFilterField(key, $scope.oldReverseFilterField || "");
    } else {
      $scope.oldReverseFilterField = $scope.type.selected.model.schema.properties[key].reverseFilterField;
      $scope.refreshReverseFilterField(key);
    }
  };
  $scope.refreshReverseFilterField = function (key, reverseFilterField) {
    $scope.chargeAceModel();
    $scope.type.selected.model.schema.properties[key].reverseFilterField = reverseFilterField;
    if (angular.isDefined(reverseFilterField)) {
      //forzo alcuni prerequisiti se settato
      $scope.type.selected.model.schema.properties[key].readonly = true;
      $scope.type.selected.model.schema.properties[key].compact = false;
      $scope.type.selected.model.schema.properties[key].auto_init = false;
    } else {
      $scope.type.selected.model.schema.properties[key].readonly = false;
    }
    $scope.updateScope();
  };
  $scope.refreshFormula = function (key, formula_id) {
    $scope.chargeAceModel();
    $scope.type.selected.model.schema.properties[key].formula_id = angular.copy(formula_id);
    $scope.updateScope();
  };
  $scope.refreshFormulaParams = function (key, formula_params) {
    $scope.chargeAceModel();
    $scope.type.selected.model.schema.properties[key].formula_params = angular.copy(formula_params);
    $scope.updateScope();
  };
  $scope.refreshBasePath = function (key, basePath) {
    $scope.chargeAceModel();
    $scope.type.selected.model.schema.properties[key].basePath = angular.copy(basePath);
    $scope.updateScope();
  };
  $scope.refreshWar = function (key, war) {
    $scope.chargeAceModel();
    $scope.type.selected.model.schema.properties[key].war = angular.copy(war);
    $scope.updateScope();
  };
  $scope.refreshInheritRecord = function (key, record) {
    $scope.chargeAceModel();
    $scope.type.selected.model.schema.properties[key].record = angular.copy(record);
    $scope.updateScope();
  };
  $scope.refreshInheritField = function (key, field) {
    $scope.chargeAceModel();
    $scope.type.selected.model.schema.properties[key].field = angular.copy(field);
    $scope.updateScope();
  };
  $scope.refreshFiltered = function (key, filtered) {
    $scope.chargeAceModel();
    $scope.type.selected.model.schema.properties[key].filtered = angular.copy(filtered);
    $scope.updateScope();
  };
  $scope.refreshFilterSourceField = function (key, filterSourceField) {
    $scope.chargeAceModel();
    $scope.type.selected.model.schema.properties[key].filterSourceField = angular.copy(filterSourceField);
    $scope.updateScope();
  };
  $scope.refreshFilterDestField = function (key, filterDestField) {
    $scope.chargeAceModel();
    $scope.type.selected.model.schema.properties[key].filterDestField = angular.copy(filterDestField);
    $scope.updateScope();
  };
  $scope.refreshLookupOption = function (key, option, value) {
    $scope.chargeAceModel();
    $scope.type.selected.model.schema.properties[key][option] = angular.copy(value);
    $scope.updateScope();
  };
  $scope.refreshTitleForm = function (title) {
    $scope.chargeAceModel();
    $scope.type.selected.model.form[0].title = angular.copy(title);
    $scope.updateScope();
  };
  $scope.chargeAceModel = function () {
    var defaultData = angular.fromJson(angular.copy($scope.aceModel));
    if (defaultData) {
      $scope.type = {
        selected: defaultData
      };
      $scope.schema = angular.fromJson(defaultData.model.schema);
      $scope.form = angular.fromJson(defaultData.model.form);
      $scope.columnDefs = angular.fromJson(defaultData.model.columnDefs);
    }
  };
  $scope.changeColumnDefs = function (key, value) {
    var item = {
      name: value.title,
      field: key
    };
    var map = new Map();
    angular.forEach($scope.type.selected.model.columnDefs, function (v) {
      map[v.field] = angular.copy(v);
    });
    if (value.check) {
      map[item.field] = angular.copy(item);
      if (value.width == '' || value.width == null) {
        delete $scope.type.selected.model.schema.properties[key].width;
      }
    } else {
      delete map[item.field];
      delete $scope.type.selected.model.schema.properties[key].width;
      $scope.type.selected.model.schema.properties[key].enableFiltering = false;
      $scope.type.selected.model.schema.properties[key].enableSorting = false;
    }
    $scope.type.selected.model.columnDefs = [];
    for (var it in map) {
      var app = {
        name: map[it].name,
        field: map[it].field
      };
      $scope.type.selected.model.columnDefs.push(app);
    }
    $scope.updateScope();
  };
  $scope.aceLoaded = function (_editor) {
    var defaultModel = {
      model: {
        schema: {
          type: "object",
          title: "",
          properties: {
            code: {
              title: "Codice",
              type: "string",
              check: true
            },
            description: {
              title: "Descrizione",
              type: "string",
              check: true
            }
          },
          required: ["code", "description"]
        },
        form: [{
          type: "fieldset",
          items: [{
            type: "tabs",
            tabs: [{
              title: "Dati Base",
              items: [{
                key: ["code"],
                title: "Codice",
                required: true,
                type: "text"
              }, {
                key: ["description"],
                title: "Descrizione",
                required: true,
                type: "text"
              }]
            }]
          }]
        }],
        columnDefs: [{
          "field": "code",
          "name": "Codice"
        }, {
          "field": "description",
          "name": "Descrizione"
        }]
      }
    };
    $scope.aceModel = JSON.stringify(defaultModel, null, '\t');
    $scope.chargeAceModel();
    $scope.title = angular.copy($scope.type.selected.model.form[0].title);
    schemaFactory().byID({
      id: $routeParams.id
    }).$promise.then(function (data) {
      refreshData(data);
      $scope.$broadcast('sixtimeline:refresh');
    });
  };
  function refreshData(data) {
    $log.debug('refreshData', data);
    if (data && data.model) {
      $scope.type = {
        selected: angular.copy(fixDates(data))
      };
      $scope.fixSchemaFormModel();
      $scope.schema = angular.copy($scope.type.selected.model.schema);
      $scope.form = angular.copy($scope.type.selected.model.form);
      $scope.code = angular.copy($scope.type.selected.model.code);
      $scope.description = angular.copy($scope.type.selected.model.description);
      $scope.title = angular.copy($scope.type.selected.model.form[0].title);
      if ($scope.type.selected.model.columnDefs && $scope.type.selected.model.columnDefs.length != 0) {
        $scope.columnDefs = angular.copy($scope.type.selected.model.columnDefs);
      } else {
        $scope.columnDefs = [{
          name: 'Codice',
          field: 'code'
        }, {
          name: 'Descrizione',
          field: 'description'
        }];
        $scope.type.selected.model.columnDefs = angular.copy($scope.columnDefs);
      }
      angular.forEach($scope.columnDefs, function (value) {
        $scope.type.selected.model.schema.properties[value.field].check = true;
      });
      $scope.schema = angular.copy($scope.type.selected.model.schema);
      $scope.aceModel = JSON.stringify($scope.type.selected, null, '\t');
      $scope.model = {};
      $scope.commissionDependent = angular.copy($scope.type.selected.model.commissionDependent);
      $scope.customerDependent = angular.copy($scope.type.selected.model.customerDependent);
      $scope.history = angular.copy($scope.type.selected.model.history);
      $scope.attachmentManagement = angular.copy($scope.type.selected.model.attachmentManagement);
      $scope.calendarManagement = angular.copy($scope.type.selected.model.calendarManagement);
      $scope.priceListManagement = angular.copy($scope.type.selected.model.priceListManagement);
      $scope.priceListKey = angular.copy($scope.type.selected.model.priceListKey);
      $scope.drawingManagement = angular.copy($scope.type.selected.model.drawingManagement);
      $scope.showSubnodes = angular.copy($scope.type.selected.model.showSubnodes);
      $scope.subNodesType = angular.copy($scope.type.selected.model.subNodesType);
      $scope.subNodesLabel = angular.copy($scope.type.selected.model.subNodesLabel);
      if ($scope.type.selected.model.selfGeneratedCode) {
        $scope.selfGeneratedCode = angular.copy($scope.type.selected.model.selfGeneratedCode);
      }
      $scope.getUiselectMap();
      originalStringifiedModel = angular.copy($scope.aceModel);
    }
  }
  $scope.getUiselectMap = function () {
    $scope.uiselectMap = {};
    $scope.itemTypeMap = {};
    for (var i in $scope.type.selected.model.form[0].items) {
      if ($scope.type.selected.model.form[0].items[i].tabs) {
        $scope.type.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
          if (item.type !== 'fieldset') {
            $scope.itemTypeMap[item.key[0]] = $scope.type.selected.model.schema.properties[item.key[0]].type;
            if ($scope.type.selected.model.schema.properties[item.key[0]].type == 'array') {
              $scope.itemTypeMap[item.key[0]] = $scope.type.selected.model.schema.properties[item.key[0]].items.type;
            }
            if (item.type == 'uiselect' || item.type == 'uiselectmultiple') {
              var blankObject = {
                name: '',
                value: ''
              };
              $scope.uiselectMap[item.key[0]] = addSelectedValue(item.titleMap, blankObject);
              /* aggiunto un elemento vuoto all'array per consentire il deselezionamento */
            }
          }
        });
      }
    }
  };

  $scope.toggleEnumDefault = function (key, objValue) {
    var property = $scope.type.selected.model.schema.properties[key];
    if (typeof property["default"] == "undefined" || property["default"].indexOf(objValue) == -1) {
      property["default"] = [objValue];
    } else {
      property["default"] = undefined;
    }
    this.newItem = null;
    $scope.updateScope();
  };
  function addSelectedValue(array, obj) {
    var blankValuePresent = false;
    array.forEach(function (item) {
      if (item.value == obj.value && item.name == obj.name) {
        blankValuePresent = true;
      }
    });
    if (blankValuePresent == false) {
      array.push(obj);
    }
    return array;
  }
  $scope.isInheritable = function (type) {
    return type == 'number' || type == 'integer' || type == 'string' || type == 'boolean' || type == 'lookup';
  };

  /**********************/
  /***** FIX SCHEMA *****/
  /**********************/

  $scope.fixSchemaFormModel = function () {
    for (var i in $scope.type.selected.model.form[0].items) {
      if ($scope.type.selected.model.form[0].items[i].tabs) {
        $scope.type.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
          if (item.type == 'uiselect') {
            $scope.type.selected.model.schema.properties[item.key[0]].format = 'enum';
          }
          if (item.type == 'uiselectmultiple') {
            $scope.type.selected.model.schema.properties[item.key[0]].type = 'array';
          }
        });
      }
    }
  };

  /****************/
  /***** FORM *****/
  /****************/

  $scope.newFieldForm = {};
  $scope.newTab = {
    title: "",
    items: []
  };
  $scope.addTab = function (container) {
    if (!container.tabs) {
      container.tabs = [];
    }
    if (container.type !== 'tabs') {
      container.type = 'tabs';
    }
    var toAdd = angular.copy($scope.newTab);
    $log.log(container);
    container.tabs.push(toAdd);
    $log.log(container);
    $scope.updateScope();
    $scope.newTab = {
      title: "",
      items: []
    };
  };
  $scope.addFieldToTab = function (tab) {
    if (!tab.items) {
      tab.items = [];
    }
    var toAdd = angular.copy($scope.newFieldForm);
    if ($scope.newFieldForm.type === '' || $scope.newFieldForm.type === 'formula') {
      delete toAdd.type;
    } else if ($scope.newFieldForm.type === 'inherited') {
      toAdd.type = 'sixinherit';
    }
    /* key è da cambiare in un array */
    toAdd.key = [];
    toAdd.key.push($scope.newFieldForm.key);
    /* se è una lookup, e se ha definito il campo entity_id nello schema, ci attacco anche l'entity_id */
    if (toAdd.type == 'sixlookup' && $scope.schema.properties[$scope.newFieldForm.key]['entity_id']) {
      toAdd['entity_id'] = $scope.schema.properties[$scope.newFieldForm.key]['entity_id'];
    }
    tab.items.push(toAdd);
    $scope.updateScope();
    $scope.newFieldForm = {
      key: [],
      title: "",
      required: false,
      type: "text"
    };
  };
  $scope.removeTabOrField = function (key, container) {
    container.splice(key, 1);
    $log.log(container);
    $scope.updateScope();
  };
  $scope.swapUp = function (key, collection) {
    if (key > 0) {
      var tmp = collection[key];
      collection[key] = collection[key - 1];
      collection[key - 1] = tmp;
    }
    $scope.updateScope();
  };
  $scope.swapDown = function (key, collection) {
    if (key < collection.length - 1) {
      var tmp = collection[key];
      collection[key] = collection[key + 1];
      collection[key + 1] = tmp;
    }
    $scope.updateScope();
  };
  $scope.updateField = function (field) {
    if (field.type === '') {
      delete field.type;
    }
    $scope.updateScope();
  };

  // quando spunto la checkbox relativa al campo obbligatorio,
  // oltre ad aggiorname il form (automaticamente tramite ng-model),
  // aggiorno anche l'array 'required' nello schema
  $scope.updateRequiredField = function (field) {
    if (field.required == true) {
      $scope.type.selected.model.schema.required.push(field.key[0]);
    } else {
      var i = $scope.type.selected.model.schema.required.indexOf(field.key[0]);
      if (i != -1) {
        $scope.type.selected.model.schema.required.splice(i, 1);
      }
    }
    $scope.updateScope();
  };
  $scope.$watchGroup(['commissionDependent', 'history'], function () {
    if ($scope.commissionDependent === true) {
      $scope.history = true;
    }
    if ($scope.type.selected) {
      $scope.type.selected.model.history = $scope.history;
      $scope.type.selected.model.commissionDependent = $scope.commissionDependent;
      $scope.updateScope();
    }
  });
  $scope.$watch(function () {
    return $scope.attachmentManagement;
  }, function () {
    if ($scope.type.selected) {
      $scope.type.selected.model.attachmentManagement = $scope.attachmentManagement;
      $scope.updateScope();
    }
  });
  $scope.$watch(function () {
    return $scope.calendarManagement;
  }, function () {
    if ($scope.type.selected) {
      $scope.type.selected.model.calendarManagement = $scope.calendarManagement;
      $scope.updateScope();
    }
  });
  $scope.$watch(function () {
    return $scope.priceListManagement;
  }, function () {
    if ($scope.type.selected) {
      $scope.type.selected.model.priceListManagement = $scope.priceListManagement;
      if ($scope.priceListManagement) $scope.history = true; //prerequisito per il funzionamento
      if ($scope.priceListManagement) $scope.attachmentManagement = false; //compatibilità con gli allegati non implementata
      $scope.updateScope();
    }
  });
  $scope.$watch('priceListKey', function () {
    if ($scope.type.selected) {
      $scope.type.selected.model.priceListKey = $scope.priceListKey;
      $scope.updateScope();
    }
  });
  $scope.$watch('drawingManagement', function () {
    if ($scope.type.selected) {
      $scope.type.selected.model.drawingManagement = $scope.drawingManagement;
      $scope.updateScope();
    }
  });
  $scope.$watch(function () {
    return $scope.showSubnodes;
  }, function () {
    if ($scope.type.selected) {
      $scope.type.selected.model.showSubnodes = $scope.showSubnodes;
      $scope.updateScope();
    }
  });
  $scope.$watch(function () {
    return $scope.subNodesType;
  }, function () {
    if ($scope.type.selected) {
      $scope.type.selected.model.subNodesType = $scope.subNodesType;
      $scope.updateScope();
    }
  });
  $scope.$watch(function () {
    return $scope.subNodesLabel;
  }, function () {
    if ($scope.type.selected) {
      $scope.type.selected.model.subNodesLabel = $scope.subNodesLabel;
      $scope.updateScope();
    }
  });
  $scope.$watch(function () {
    return $scope.customerDependent;
  }, function () {
    if ($scope.type.selected) {
      $scope.type.selected.model.customerDependent = $scope.customerDependent;
      $scope.updateScope();
    }
  });
  $scope.$watch('selfGeneratedCode.active', function (newVal, oldVal) {
    if (newVal != oldVal) {
      if ($scope.type.selected) {
        $scope.type.selected.model.selfGeneratedCode = $scope.selfGeneratedCode;
        $scope.updateScope();
      }
    }
  });
  $scope.$watch('selfGeneratedCode.codeNameSix', function (newVal, oldVal) {
    if (newVal != oldVal && $scope.selfGeneratedCode.active) {
      if ($scope.type.selected) {
        $scope.type.selected.model.selfGeneratedCode = $scope.selfGeneratedCode;
        $scope.updateScope();
      }
    }
  });
  $scope.$watchCollection(function (scope) {
    return $scope.bools;
  }, function (newVal, oldVal) {
    if ($scope.type && $scope.type.selected && $scope.type.selected.model && $scope.type.selected.model.form && $scope.type.selected.model.form[0]) {
      $scope.type.selected.model.form[0].crossCommission = $scope.bools.formCrossCommission;
    }
    if ($scope.type && $scope.type.selected) {
      $scope.type.selected.columndefsCrossCommission = $scope.bools.columndefsCrossCommission;
    }
    $scope.updateScope();
  });
  $scope.$watch(function (scope) {
    return $scope.type.selected ? $scope.type.selected.dataIn : '';
  }, function (newVal, oldVal) {
    if ($scope.type && $scope.type.selected && $scope.type.selected.dataIn) {
      $scope.updateScope();
    }
  });
  $scope.$watch(function (scope) {
    return $scope.type.selected ? $scope.type.selected.dataOut : '';
  }, function (newVal, oldVal) {
    if ($scope.type && $scope.type.selected && $scope.type.selected.dataIn) {
      $scope.updateScope();
    }
  });
  $scope.$watch(function (scope) {
    return $scope.type.selected ? $scope.type.selected.UUID : '';
  }, function (newVal, oldVal) {
    if ($scope.type && $scope.type.selected && $scope.type.selected.dataIn) {
      $scope.updateScope();
    }
  });
  $scope.updateScope = function () {
    if ($scope.type.selected && $scope.type.selected.model) {
      console.log('updateScope');
      $scope.schema = angular.fromJson(angular.copy($scope.type.selected.model.schema));
      $scope.form = [angular.fromJson(angular.copy($scope.type.selected.model.form[0]))];
      $scope.columnDefs = angular.fromJson(angular.copy($scope.type.selected.model.columnDefs));
      $scope.formChanged();
    }
  };
  $scope.formChanged = function () {
    $scope.aceModel = JSON.stringify(angular.copy($scope.type.selected), null, '\t');
  };
  $scope.aceChanged = function (e) {
    $log.info('aceChanged', e);
    if ($scope.type && $scope.type.selected) {
      angular.extend($scope.type.selected, fixDates(JSON.parse($scope.aceModel)));
      $scope.updateScope();
    }
  };

  /** ************************************ **/
  /** ************* Timeline ************* **/
  /** ************************************ **/

  $scope.timelineFlags = {
    showTimeline: false
  };
  $scope.closeTimeline = function () {
    $scope.timelineFlags.showTimeline = false;
    $scope.isCollapsed = true;
  };
  $scope.refreshTimeline = function () {
    if ($scope.type.selected.UUID) {
      return schemaFactory().getTimeline({
        param1: $scope.type.selected.UUID
      }).$promise;
    } else {
      var p = $q.defer();
      p.resolve({
        list: []
      });
      return p.promise;
    }
  };

  // Avvia il fix della timeline (riordina le dataIn e sistema le dataOut)
  $scope.fixTimeline = function () {
    // fix della timeline
    return schemaFactory().fixTimeline({
      param2: $scope.type.selected.UUID
    }).$promise;
  };

  // Avvia il fix della timeline (riordina le dataIn e sistema le dataOut)
  $scope.checkTimeline = function () {
    // fix della timeline
    return schemaFactory().checkTimeline({
      param2: $scope.type.selected.UUID
    }).$promise;
  };
  $scope.onSelectVersion = function (selected, event) {
    if (event != 'changed_externally') {
      refreshData(selected);
    }
  };
  $scope.onSaveVersion = function (data) {
    $scope.saveForm(false, false).then(function (resp) {
      $scope.$broadcast('sixtimeline:refresh');
    });
  };
  $scope.onDeleteVersion = function (data) {
    var deleteMessage = 'Stai eliminando permanentemente la versione <i>' + $scope.type.selected.version + '</i> ' + 'del documento (dataIn: ' + $filter('date')($scope.type.selected.dataIn, 'dd/MM/yyyy HH:mm:ss') + ' - dataOut: ' + $filter('date')($scope.type.selected.dataOut, 'dd/MM/yyyy HH:mm:ss') + '), ' + 'modificandone la relativa timeline. <br />' + 'Probabilmente sarà necessario modificare anche gli attributi <i>dataIn</i> e <i>dataOut</i> delle versioni precedenti e successive a questa, per ripristinare una timeline coerente.<br /><br />' + '<b>L\'operazione è IRREVERSIBILE</b><br /><br />' + 'Eliminarla comunque?';
    var closeDeleteDialog = function closeDeleteDialog() {
      if (deleteDialog) {
        deleteDialog.close();
        deleteDialog = undefined;
      }
    };
    var hardDelete = function hardDelete() {
      schemaFactory().hardDelete({
        id: data.version
      }).$promise.then(function (response) {
        // refresh timeline
        $scope.$broadcast('sixtimeline:refresh');
        deleteDialog.close();
      });
    };
    var dialogScope = {
      lang: 'html',
      deleteMessage: deleteMessage,
      deleteFunction: hardDelete,
      notDeleteFunction: closeDeleteDialog
    };
    var opts = {
      name: 'deleteVersion',
      closeByDocument: true,
      plain: false
    };
    var deleteDialog = dialogService.templateDialog('deleteTemplate.html', dialogService.DIALOG_TYPE.DANGER, dialogScope, opts, -1, false);
  };

  /** ********************** **/
  /** ******** Date ******** **/
  /** ********************** **/

  // Sistema le date reinizializzandole (da backend potrebbero arrivarmi come stringhe)
  function fixDates(data) {
    if (data.creationDate) {
      data.creationDate = createDateTime(data.creationDate);
    }
    if (data.dataIn) {
      data.dataIn = createDateTime(data.dataIn);
    }
    if (data.dataOut) {
      data.dataOut = createDateTime(data.dataOut);
    }
    return data;
  }

  // Crea un dateTime fino ai secondi (yyyy-MM-dd HH:mm:ss)
  function createDateTime(date) {
    var d = new Date(date);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds());
  }

  /** *********************** **/
  /** **** Check changes **** **/
  /** *********************** **/

  var originalStringifiedModel = undefined;
  $scope.isDataChanged = function (current) {
    return originalStringifiedModel != current;
  };

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'schema';
  $scope.isWriteVersionAllowed = function () {
    return authFactory.checkPerm(RESOURCE_NAME, 'MODIFY_HISTORY');
  };
}]);
'use strict';

/**
 * @ngdoc service
 * @name emma.dataset.baseFactory
 * @description
 * # baseFactory
 * Factory in the emma.dataset.
 */
angular.module('emma.dataset').factory('schemaFactory', ["DATA_SET_URL", "$resource", function (DATA_SET_URL, $resource) {
  return function () {
    return $resource(DATA_SET_URL + '/api/schema/:verb/:id/:param1/:param2', {}, {
      query: {
        method: 'GET',
        isArray: false
      },
      lookup: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_lookup'
        }
      },
      lookupList: {
        method: 'GET',
        isArray: true,
        params: {
          verb: '_lookup',
          res_mode: 'list'
        }
      },
      byUUID: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_uuid',
          id: '@version',
          param1: '_current'
        }
      },
      byDate: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_uuid'
        }
      },
      byID: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_id',
          id: '@version'
        }
      },
      byCode: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_code',
          id: '@version'
        }
      },
      getSchema: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_uuid'
        }
      },
      bulkResolve: {
        method: 'POST',
        isArray: false,
        params: {
          verb: '_resolve',
          param1: '_bulk'
        }
      },
      search: {
        method: 'POST',
        isArray: false,
        params: {
          verb: '_search'
        }
      },
      filter: {
        method: 'POST',
        isArray: true
      },
      select: {
        method: 'GET',
        isArray: true
      },
      create: {
        method: 'POST'
      },
      bulk: {
        method: 'POST',
        isArray: true
      },
      show: {
        method: 'GET'
      },
      update: {
        method: 'PUT',
        params: {
          id: '@id'
        }
      },
      "delete": {
        method: 'DELETE',
        params: {
          id: '@id'
        }
      },
      hardDelete: {
        method: 'DELETE',
        params: {
          verb: '_hard',
          id: '@version'
        },
        ignoreLoadingBar: true
      },
      referenceCount: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_referencecount'
        },
        ignoreLoadingBar: true
      },
      getTimeline: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_uuid',
          param1: '@param1'
        }
      },
      fixTimeline: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_fix',
          param1: 'timeline',
          param2: '@uuid'
        },
        ignoreLoadingBar: true
      },
      checkTimeline: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_check',
          param1: 'timeline',
          param2: '@uuid'
        },
        ignoreLoadingBar: true
      }
    });
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name emma.dataset.controller:RecordCtrl
 * @description
 * # RecordCtrl
 * Controller of the emma.dataset
 */
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
angular.module('emma.dataset').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/record/:editMode/vettoreenergetico/:id', {
    templateUrl: 'dataset/record/vettoreenergetico_detail.html',
    controller: 'RecordCtrl',
    resolve: {
      // http://stackoverflow.com/questions/12524533/can-angularjs-routes-have-default-parameter-values
      type: ['$route', function ($route) {
        $route.current.params.type = 'vettoreenergetico'; // forzo il parametro di route :type a 'vettoreenergetico'
      }]
    }
  }).when('/record/:editMode/:type', {
    templateUrl: 'dataset/record/record_list.html',
    controller: 'RecordCtrl'
  }).when('/record/:editMode/:type/:id', {
    templateUrl: 'dataset/record/record_detail.html',
    controller: 'RecordCtrl'
  }).when('/record/:editMode/:type/:id/v/:version', {
    templateUrl: 'dataset/record/record_detail.html',
    controller: 'RecordCtrl'
  }).when('/record/:editMode/:type/:id/:action', {
    templateUrl: 'dataset/record/record_detail.html',
    controller: 'RecordCtrl'
  });
}]).controller('RecordCtrl', ["$scope", "$routeParams", "$location", "$log", "$window", "counterFactory", "sixGridPaginationConstants", "$rootScope", "treeFactory", "dataSetFactory", "dialogService", "sessionFactory", "uiGridConstants", "dayDegreeFactory", "errorService", "toaster", "authFactory", "schemaFactory", "recordFactory", "$filter", "$q", "cfpLoadingBar", "localStorageService", "commissionFactory", "$timeout", "assetcalendarFactory", "historyLock", "modelIconService", "ALFRESCO_URL", function ($scope, $routeParams, $location, $log, $window, counterFactory, sixGridPaginationConstants, $rootScope, treeFactory, dataSetFactory, dialogService, sessionFactory, uiGridConstants, dayDegreeFactory, errorService, toaster, authFactory, schemaFactory, recordFactory, $filter, $q, cfpLoadingBar, localStorageService, commissionFactory, $timeout, assetcalendarFactory, historyLock, modelIconService, ALFRESCO_URL) {
  var currentCommission = authFactory.getAuthData().info.commissions.current;
  $scope.currentCustomer = authFactory.getCurrentCustomer();
  var STABLE = 'stable',
    SNAP = 'snap'; //eventualmente costanti?

  var FIXABLE_CODE_PROBLEMS = {
    // code: path per al service di fix
    '2': '_fix/dataout',
    // più dataOut = null
    '3': '_fix/schemacode',
    // schema mancante
    '6': '_fix/commission' // commission mancante
  };

  var actionsWhitelist = ['clone'];
  var originalRecordDetail = undefined;
  $scope.isCustomerSchemaForm = angular.isDefined($routeParams.type) && $routeParams.type === 'cliente' || false;
  $scope.withTree = false;
  ///////////////////////////////////////////// CALENDAR_VIEW START /////////////////////////////////////////////

  $scope.enableCalendarView = angular.isDefined($routeParams.type) && angular.isDefined($routeParams.id) || true;
  $scope.calendarOptions = {
    language: "it",
    enableRangeSelection: false,
    customDayRenderer: function customDayRenderer(element, date) {
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      if (date.getTime() === today.getTime()) {
        jQuery(element).css('background-color', '#1199C4');
        jQuery(element).css('color', '#FFFFFF');
      }
      jQuery(element).css('border-bottom', '1px solid #1199C4');
      jQuery(element).css('border-radius', '0%');
      if (angular.isDefined($scope.calendarDataSource) && $scope.calendarDataSource.list != []) {
        $scope.calendarDataSource.list.forEach(function (e) {
          if (e.color != null && e.color != undefined) {
            delete e["color"];
          }
          if (date.between(e.startDate, e.endDate)) {
            if (e.name == "Chiusura straordinaria") {
              if (date.getTime() === today.getTime()) {
                jQuery(element).css('background-color', '#C41700');
                jQuery(element).css('color', '#FFFFFF');
              }
              jQuery(element).css('border-bottom', '4px solid #C41700');
            } else if (e.name == "Chiusura ordinaria") {
              if (date.getTime() === today.getTime()) {
                jQuery(element).css('background-color', '#FF9205');
                jQuery(element).css('color', '#FFFFFF');
              }
              jQuery(element).css('border-bottom', '4px solid #FF9205');
            } else if (e.name == "Apertura straordinaria") {
              if (date.getTime() === today.getTime()) {
                jQuery(element).css('background-color', '#1199C4');
                jQuery(element).css('color', '#FFFFFF');
              }
              jQuery(element).css('border-bottom', '4px solid #1199C4');
            }
            jQuery(element).addClass("with-popover").popover({
              trigger: 'hover',
              container: 'body',
              html: true,
              content: '<div class="event-tooltip-content">' + '<div class="event-name" style="font-weight: bold;">' + e.description + '</div>' + '<div class="event-location">' + e.timeSlots + '</div>' + '</div>'
            });
          }
        });
      }
    },
    renderEnd: function renderEnd() {
      var calendarElement = jQuery('#year-calendar-view').data('calendar');
      if (angular.isDefined($scope.currentYear) && angular.isDefined(calendarElement)) {
        if (calendarElement.getYear().toString() != $scope.currentYear.toString()) {
          $scope.getAssetCalendar();
        }
      }
    }
  };
  function today() {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  }
  function fromDate(year) {
    return year + "-01-01T00:00:00.000Z";
  }
  function toDate(year) {
    return year + "-12-31T00:00:00.000Z";
  }
  Date.prototype.between = function (startDate, endDate) {
    return this <= endDate && startDate <= this;
  };
  $scope.getAssetCalendar = function () {
    var calendarElement = jQuery('#year-calendar-view').data('calendar');
    $scope.currentYear = angular.isDefined(calendarElement) ? calendarElement.getYear() : today().getFullYear();
    var payload = {
      fromDate: $scope.currentYear != null ? fromDate($scope.currentYear) : fromDate(today().getFullYear().toString()),
      toDate: $scope.currentYear != null ? toDate($scope.currentYear) : fromDate(today().getFullYear().toString()),
      assetType: angular.isDefined($routeParams.type) ? $routeParams.type : null,
      assetUUID: angular.isDefined($routeParams.id) ? $routeParams.id : null
    };
    var promise = assetcalendarFactory.getCalendarFiltered(payload, {}).$promise;
    promise.then(function (response) {
      if (Object.keys(response.list).length == 0) {
        //niente chiavi = calendario non trovato (se si verifica o è un bug o nessun calendario è definito)
        toaster.pop('note', 'Calendario non trovato', 'Non è stato trovato alcun calendario per l\'anno selezionato');
      }
      response.list = $scope.getFormattedEvents(response.list);
      $scope.calendarDataSource = response;
      if (angular.isDefined(calendarElement)) {
        calendarElement.setDataSource($scope.calendarDataSource.list);
        calendarElement._render();
      }
    });
    return promise;
  };
  $scope.getFormattedEvents = function (assetCalendar) {
    //BE ~> FE
    var formattedEvents = [];
    Object.keys(assetCalendar).forEach(function (key) {
      var newEvent = {};
      newEvent.id = key;
      newEvent.description = assetCalendar[key].description;
      newEvent.startDate = new Date(assetCalendar[key].startDate);
      newEvent.startDate.setHours(0, 0, 0, 0);
      newEvent.endDate = new Date(assetCalendar[key].endDate);
      newEvent.endDate.setHours(0, 0, 0, 0);
      newEvent.name = (assetCalendar[key].status == "open" ? "Apertura" : "Chiusura") + (assetCalendar[key].extraordinary ? " straordinaria" : " ordinaria");
      newEvent.timeSlots = "";
      if (angular.isDefined(assetCalendar[key].timeSlots)) {
        assetCalendar[key].timeSlots.forEach(function (tSlot) {
          newEvent.timeSlots += tSlot.fromH + " - " + tSlot.toH + "; ";
        });
      }
      formattedEvents.push(newEvent);
    });
    return formattedEvents;
  };
  $scope.initCalendar = function () {
    jQuery('#year-calendar-view').calendar($scope.calendarOptions);
    $scope.getAssetCalendar();
  };

  ///////////////////////////////////////////// CALENDAR_VIEW END /////////////////////////////////////////////

  $scope.params = {
    pageNumber: 1,
    pageSize: 15,
    totalItems: 0,
    queryParam: undefined,
    filters: {}
  };
  $scope.gridAppCallbacks = {};
  $scope.selfGeneratedCode = {
    codeNameSix: '',
    active: false
  };
  $scope.form = {};
  $scope.uniqueExclusions = null;
  $scope.type = {
    list: [],
    totalResults: 0
  };
  $scope.subnodes = {
    list: [],
    totalResults: 0
  };
  $scope.commissionDependent = false;
  var bool = {
    crossCommission: false,
    viewCommissionData: true,
    viewCrossData: true
  };
  $scope.timelineFlags = {
    showTimeline: false
  };
  $scope.bool = localStorageService.get('record_bool') ? localStorageService.get('record_bool') : bool;
  $scope.editCrossCommission = false;
  $scope.customerDependent = false;
  $scope.attachmentManagement = false;
  $scope.calendarManagement = false;
  $scope.drawingManagement = false;
  $scope.showSubnodes = false;
  $scope.schema = {};
  $scope.isCollapsed = false;
  $scope.isModelDefined = true; //al momento do per scontato che ci sia, al primo 'nuovo', faccio il controllo

  $scope.historyMode = $routeParams.editMode ? $routeParams.editMode : STABLE;
  if ($routeParams.editMode == "list") {
    $scope.historyMode = SNAP;
  }
  $scope.editMode = $routeParams.editMode ? $routeParams.editMode : $scope.historyMode;
  $scope.deleteDialog = undefined;
  $scope.lookuped = [];
  $scope.commissions = {
    list: [],
    selected: []
  };
  $scope.customers = {
    list: [],
    selected: [],
    fullList: undefined
  };
  $scope.date = {
    currentDate: undefined,
    lastDate: undefined
  };
  $scope.action = {};
  if (actionsWhitelist.indexOf($routeParams.action) !== -1) {
    $scope.action[$routeParams.action] = true;
  }
  $scope.reportGridOptions = {
    enableSorting: true,
    enableFiltering: true,
    exporterMenuPdf: false,
    paginationPageSizes: [10, 20, 30],
    paginationPageSize: 10,
    useExternalPagination: false,
    data: 'messages',
    columnDefs: [{
      displayName: 'Codice',
      field: 'code',
      width: '60'
    }, {
      displayName: 'Stato',
      field: 'status',
      width: '100'
    }, {
      displayName: 'Messaggio',
      field: 'message'
    }, {
      displayName: 'Record type',
      field: 'record.type',
      width: '120'
    }, {
      displayName: 'Record code',
      field: 'record.code',
      width: '120'
    }, {
      displayName: 'Record UUID',
      field: 'record.uuid',
      width: '120'
    }, {
      displayName: 'Record Id',
      field: 'recordId',
      width: '120'
    }, {
      displayName: 'Commission',
      field: 'commission',
      width: '120'
    }, {
      displayName: '',
      field: 'code',
      cellTemplate: '<div><a class="btn btn-xs" title="Correggi" ng-confirm-message="Correggere?" ng-if="grid.appScope.isFixable(row.entity.code)===true" ng-confirm-click="grid.appScope.tryFixProblem(row.entity)" ng-confirm-condition=true><span class="fa fa-medkit"></span></a></div>',
      width: 50,
      enableSorting: true,
      enableFiltering: false,
      enableCellEdit: false
    }]
  };
  $scope.dataInOptions = {};
  $scope.dataOutOptions = {};
  $scope.isFixable = function (problemCode) {
    for (var code in FIXABLE_CODE_PROBLEMS) {
      if (problemCode === code) {
        return true;
      }
    }
    return false;
  };
  $scope.refresh = function () {
    $scope.getType();
    $location.path('record/' + $scope.editMode + '/' + $scope.typeName);
  };
  $scope.back = function () {
    if (sessionFactory.getSessionData().currentDate !== null) {
      $scope.closeTimeline(); //close timeline
    }
    // torno alla pagina precedente
    $window.history.back();
  };
  $scope.newModelType = function () {
    $location.path('modeltype/schema/new');
  };
  var walkThruField = function walkThruField(item, parts) {
    if (!angular.isArray(parts)) {
      return item[parts];
    } else if (parts.length == 1) {
      return item[parts[0]];
    } else {
      return walkThruField(item[parts[0]], parts.pop());
    }
  };
  $scope.getItemField = function (item, field) {
    var parts = field.split("."),
      property = item.model || this;
    if (angular.isUndefined(parts) || parts.length == 0) {
      return property;
    }
    return walkThruField(property, parts);
  };
  function buildGridRecordDetailLink() {
    if ($scope.uuid) {
      //sono sul singolo record, la grid che sto popolando è dei subnodes
      //FIXME: non è detto sia corretto usare l'editmode del parent
      return '#/record/' + $scope.editMode + '/' + $scope.subNodesType + '/{{row.entity.UUID}}';
    } else {
      if ($scope.isListEditMode()) {
        return '#/record/' + $scope.editMode + '/' + $scope.typeName + '/{{row.entity.UUID}}/v/{{row.entity.version}}';
      } else {
        return '#/record/' + $scope.editMode + '/' + $scope.typeName + '/{{row.entity.UUID}}';
      }
    }
  }
  function loadColumnOrDefault(destination, data) {
    destination.columnDefs = [];
    destination.columnDefs.push({
      displayName: '',
      field: 'Link Dettaglio',
      cellClass: $scope.cellClassFormatter,
      width: 36,
      enableCellEdit: true,
      enableFiltering: false,
      enableSorting: false,
      cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="' + buildGridRecordDetailLink() + '" class="btn btn-xs btn-primary">' + '<span class="fa fa-search"></span>' + '</a>' + '</div>'
    });
    //clone tool
    if (!$scope.uuid) {
      destination.columnDefs.push({
        displayName: '',
        field: 'Link Clona',
        cellClass: $scope.cellClassFormatter,
        width: 36,
        enableCellEdit: true,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/record/' + $scope.editMode + '/' + $scope.typeName + '/{{row.entity.UUID}}/clone" class="btn btn-xs btn-primary">' + '<span class="fa fa-clone"></span>' + '</a>' + '</div>'
      });
    }
    if (angular.isUndefined(data.model.columnDefs) || data.model.columnDefs.length == 0 || data.model.columnDefs === null) {
      destination.columnDefs.push({
        displayName: 'Codice',
        field: 'model.code',
        enableFiltering: true,
        cellClass: $scope.cellClassFormatter,
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          //exact o contains non funziona comunque, colpa del lowercase da qualche parte...
          placeholder: ''
        }]
      });
      destination.columnDefs.push({
        displayName: 'Descrizione',
        field: 'model.description',
        enableFiltering: true,
        cellClass: $scope.cellClassFormatter,
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
    } else {
      angular.forEach(data.model.schema.properties, function (value, key) {
        var filterType = sixGridPaginationConstants.filterType.TEXT;
        var cellTemplate = undefined;
        switch (value.format) {
          case 'lookup':
            filterType = sixGridPaginationConstants.filterType.SIXLOOKUP;
            cellTemplate = '<div class="ui-grid-cell-contents {{grid.appScope.cellClassFormatter(undefined, row)}}" title="{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}">{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}</div>';
            break;
          case 'commissionmapper':
            filterType = sixGridPaginationConstants.filterType.TEXT;
            cellTemplate = '<div class="ui-grid-cell-contents {{grid.appScope.cellClassFormatter(undefined, row)}}" title="{{grid.appScope.cmapperCellValueFormatter(grid.getCellValue(row, col))}}">{{grid.appScope.cmapperCellValueFormatter(grid.getCellValue(row, col))}}</div>';
            break;
          case 'nestedreference':
            cellTemplate = '<div class="ui-grid-cell-contents {{grid.appScope.cellClassFormatter(undefined, row)}}" title="{{grid.appScope.nestedRefCellValueFormatter(grid.getCellValue(row, col))}}">{{grid.appScope.nestedRefCellValueFormatter(grid.getCellValue(row, col))}}</div>';
            break;
          case 'inherit':
            cellTemplate = '<div class="ui-grid-cell-contents {{grid.appScope.cellClassFormatter(undefined, row)}}" title="{{grid.appScope.inheritCellValueFormatter(grid.getCellValue(row, col))}}">{{grid.appScope.inheritCellValueFormatter(grid.getCellValue(row, col))}}</div>';
            break;
          default:
            filterType = sixGridPaginationConstants.filterType.TEXT;
            break;
        }
        var visible = isShownByDefault(key, data.model.columnDefs);
        var colDef = {
          displayName: value.title,
          field: 'model.' + key,
          cellClass: $scope.cellClassFormatter,
          enableFiltering: value.enableFiltering,
          enableSorting: value.enableSorting,
          width: value.width,
          visible: visible,
          filters: [{
            type: filterType,
            condition: uiGridConstants.filter.CONTAINS,
            placeholder: ''
          }]
        };
        if (angular.isDefined(cellTemplate)) {
          colDef.cellTemplate = cellTemplate;
        }
        if (value.type == 'file') {
          colDef.cellTemplate = '<div class="ui-grid-cell-contents">' + '<a target="_blank" href="{{grid.appScope.fileDownloadUrl(grid.getCellValue(row,col).object_id)}}" ng-if="(grid.getCellValue(row,col)).object_id" class="btn btn-xs btn-primary"> ' + '<span class="fa fa-download"></span></a>   {{ (grid.getCellValue(row,col)).title }} </div>';
          colDef.filters[0].type = sixGridPaginationConstants.filterType.FILE;
        }
        destination.columnDefs.push(colDef);
      });
    }
    destination.columnDefs.push({
      displayName: 'Schema Code',
      field: 'schemaCode',
      cellClass: $scope.cellClassFormatter,
      enableCellEdit: false,
      enableFiltering: true,
      enableSorting: true,
      visible: false,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    destination.columnDefs.push({
      displayName: 'UUID',
      field: 'UUID',
      cellClass: $scope.cellClassFormatter,
      enableCellEdit: false,
      enableFiltering: true,
      enableSorting: true,
      visible: false,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    destination.columnDefs.push({
      displayName: 'Version',
      field: 'version',
      cellClass: $scope.cellClassFormatter,
      enableCellEdit: false,
      enableFiltering: true,
      enableSorting: true,
      visible: false,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    if ($scope.isSnapshot() && !$scope.isListEditMode()) {
      destination.columnDefs.push({
        displayName: 'Termine validità',
        field: 'dataOut',
        cellClass: $scope.cellClassFormatter,
        width: 150,
        enableCellEdit: false,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate: '<div class="ui-grid-cell-contents cont-center">{{ row.entity.dataOut | date: \'dd/MM/yyyy HH:mm:ss\' }}</div>'
      });
    }
    if ($scope.isListEditMode()) {
      destination.columnDefs.push({
        displayName: 'Inizio validità',
        field: 'dataIn',
        cellTemplate: '<div class="ui-grid-cell-contents cont-center">{{ row.entity.dataIn | date: \'dd/MM/yyyy HH:mm:ss\' }}</div>',
        type: 'date',
        cellClass: $scope.cellClassFormatter,
        width: 150,
        enableFiltering: true,
        enableSorting: true,
        filters: [{
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
          placeholder: 'da...',
          condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
        }, {
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
          placeholder: 'a...',
          condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
        }]
      });
      destination.columnDefs.push({
        displayName: 'Termine validità',
        field: 'dataOut',
        cellTemplate: '<div class="ui-grid-cell-contents cont-center">{{ row.entity.dataOut | date: \'dd/MM/yyyy HH:mm:ss\' }}</div>',
        type: 'date',
        cellClass: $scope.cellClassFormatter,
        width: 150,
        enableFiltering: true,
        enableSorting: true,
        filters: [{
          type: sixGridPaginationConstants.filterType.DATE_OR_NULL,
          relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
          placeholder: 'da...',
          condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
        }, {
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
          placeholder: 'a...',
          condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
        }]
      });
    }
    setTimeout(function () {
      if ($scope.params.sixApi) {
        $scope.params.sixApi.restoreState();
      }
      if ($scope.params.gridApi) {
        $scope.params.gridApi.core.refresh();
      }
    }, 500);
  }
  $scope.fileDownloadUrl = function (object_id) {
    return ALFRESCO_URL + '/api/alfresco/' + object_id.replace("workspace://SpacesStore/", "$WorkspaceSpacesStore$");
  };
  $scope.gridAppCallbacks['fileDownloadUrl'] = $scope.fileDownloadUrl;
  function isShownByDefault(col, defaultColumnDefs) {
    for (var idx in defaultColumnDefs) {
      if (defaultColumnDefs[idx].field == col) {
        return true;
      }
    }
    return false;
  }
  $scope.cellClassFormatter = function (grid, row, col, rowRenderIndex, colRenderIndex) {
    return row.entity.model.stato === 'chiuso' ? "closed-record" : "";
  };
  $scope.gridAppCallbacks['cellClassFormatter'] = $scope.cellClassFormatter;
  $scope.lookupCellValueFormatter = function (value) {
    var formatted = "";
    if (typeof value != "undefined") {
      if (Object.prototype.toString.call(value) === '[object Array]') {
        for (var v in value) {
          formatted += value[v].code + " (" + value[v].description + "); ";
        }
      } else {
        formatted = value.code + " (" + value.description + ")";
      }
    }
    return formatted;
  };
  $scope.gridAppCallbacks['lookupCellValueFormatter'] = $scope.lookupCellValueFormatter;
  $scope.inheritCellValueFormatter = function (value) {
    var formatted = "";
    if (typeof value != "undefined") {
      if (Object.prototype.toString.call(value) === '[object Array]') {
        for (var v in value) {
          formatted += value[v].code + " (" + value[v].description + "); ";
        }
      } else if (_typeof(value) == 'object' && value.hasOwnProperty('type') && value.hasOwnProperty('code') && value.hasOwnProperty('UUID') && value.hasOwnProperty('description')) {
        // se è una lookup
        formatted = value.code + " (" + value.description + ")";
      } else {
        formatted = value;
      }
    }
    return formatted;
  };
  $scope.gridAppCallbacks['inheritCellValueFormatter'] = $scope.inheritCellValueFormatter;
  $scope.cmapperCellValueFormatter = function (value) {
    var formatted = "";
    if (typeof value != "undefined") {
      if (value !== null && _typeof(value) === 'object') {
        angular.forEach(value, function (row, commission) {
          formatted += commission + ": " + row.code + " (" + row.description + "); \n";
        });
      } else {
        formatted = value;
      }
    }
    return formatted;
  };
  $scope.gridAppCallbacks['cmapperCellValueFormatter'] = $scope.cmapperCellValueFormatter;
  $scope.nestedRefCellValueFormatter = function (value) {
    var formatted = "";
    value.forEach(function (partitionReference) {
      formatted = formatted.concat(partitionReference.cost_center.description + " - " + partitionReference.partition + "%; ");
    });
    return formatted;
  };
  $scope.gridAppCallbacks['nestedRefCellValueFormatter'] = $scope.nestedRefCellValueFormatter;
  $scope.isStable = function () {
    return $scope.historyMode == STABLE;
  };
  $scope.isSnapshot = function () {
    return $scope.historyMode == SNAP;
  };
  $scope.isListEditMode = function () {
    return $routeParams.editMode == "list";
  };
  function _changeCurrentDate(currentDate, boolRipristineDate) {
    // boolRipristineDate -> bool per decidere cosa prendere come lastDate
    var session = sessionFactory.getSessionData();
    if (angular.isUndefined(session)) {
      session = {};
    }
    /* aggiorno le variabili con le date $scope */
    $scope.date.currentDate = currentDate;
    if (angular.isUndefined(session.currentDate)) {
      $scope.date.lastDate = null;
    } else {
      if (boolRipristineDate) {
        $scope.date.lastDate = null; /* per comodità lascio tornare indietro solo di un "passo" */
      } else {
        $scope.date.lastDate = session.currentDate;
      }
    }
    /* aggiorno la sessione corrente */
    session.currentDate = currentDate;
    sessionFactory.setSessionData(session);
  }
  $scope.changeCurrentDate = function (currentDate, boolRipristineDate) {
    if (currentDate) {
      $scope.timelineFlags.showTimeline = true;
    }
    _changeCurrentDate(currentDate, boolRipristineDate);
    if ($routeParams.id) {
      $scope.getRecordDetail($scope.type.selected.UUID);
      if ($scope.showSubnodes) {
        $scope.getSubnodes();
      }
    } else {
      $scope.getType();
    }
  };
  $scope.ripristineDate = function () {
    $scope.date = {
      currentDate: $scope.date.lastDate,
      lastDate: null
    };
  };
  function setCommissionFilters() {
    if ($scope.bool.viewCommissionData == true && $scope.bool.viewCrossData == true) {
      $scope.params.filters['commission'] = undefined;
      $scope.params.filters['cross_commission'] = undefined;
    } else if ($scope.bool.viewCommissionData == true && $scope.bool.viewCrossData == false) {
      $scope.params.filters['commission'] = sixFiltersLib.match('commission', currentCommission.code, sixFiltersLib.CONSTRAINTS.AND);
      $scope.params.filters['cross_commission'] = undefined;
    } else if ($scope.bool.viewCommissionData == false && $scope.bool.viewCrossData == true) {
      $scope.params.filters['commission'] = undefined;
      $scope.params.filters['cross_commission'] = sixFiltersLib.missing('commission', sixFiltersLib.CONSTRAINTS.AND);
    } else {
      $scope.params.filters['commission'] = sixFiltersLib.match('commission', currentCommission.code, sixFiltersLib.CONSTRAINTS.AND);
      $scope.params.filters['cross_commission'] = sixFiltersLib.missing('commission', sixFiltersLib.CONSTRAINTS.AND);
    }
  }

  // record/snap/nazione
  // record/stable/nazione

  $scope.getType = function () {
    $scope.messages = [];
    var payload = {
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      sort_fields: $scope.params.sortFields,
      show_revision: false,
      solve_inherit: true,
      query: $scope.params.queryParam
    };
    if ($scope.date.currentDate) {
      payload.currentDate = $scope.date.currentDate.toISOString();
      payload.show_revision = true;
    } else {
      if (!$scope.isListEditMode()) {
        payload.currentDate = new Date().toISOString();
      }
      payload.show_revision = true;
    }
    setCommissionFilters();
    if ($scope.isListEditMode()) {
      payload.show_revision = true;
    }
    var promise = recordFactory($scope.typeName).search(payload, $scope.params.filters).$promise;
    promise.then(function (result) {
      $scope.type.list = result.list || [];
      $scope.type.totalResults = result.totalResults;
      cfpLoadingBar.complete();
      if ($scope.params.sixApi) {
        $scope.params.sixApi.refreshList($scope.type.list);
      }
      return result;
    });
    return promise;
  };
  $scope.getAll = function () {
    var payload = {
      page_size: 10000,
      sort_fields: $scope.params.sortFields,
      show_revision: false,
      solve_inherit: true
      //query: $scope.params.queryParam
    };

    if ($scope.date.currentDate) {
      payload.currentDate = $scope.date.currentDate.toISOString(); // $filter('date')($scope.date.currentDate, 'yyyy-MM-dd');
      payload.show_revision = true;
    }
    setCommissionFilters();
    if ($scope.isListEditMode()) {
      payload.show_revision = true;
    }
    return recordFactory($scope.typeName).search(payload, $scope.params.filters).$promise;
  };
  $scope.$on('sx-sf-lookup', function (event, args) {
    $scope.lookuped.push(args);
  });

  // commesse in stile six-select-2 (es. { key: '1600000', description: 'Commessa Demo'})
  $scope.setDataCommissions = function (data, commissions) {
    data.commission = [];
    if ($scope.bool.crossCommission == true) {
      // se è cross-commessa ignoro qualsiasi commessa settata da qualsiasi parte ...
      data.commission = null;
    } else {
      // ... altrimenti
      if (!commissions || [].concat(commissions).length === 0) {
        // ... se non ho selezionato una commessa, prendo quella corrente ...
        data.commission.push(currentCommission.code);
      } else {
        // ... altrimenti aggiungio quelle selezionate
        [].concat(commissions).forEach(function (c) {
          data.commission.push(c.key);
        });
      }
    }
  };
  function setDataCustomers(data, customers) {
    data.customer = [];
    if (!customers || [].concat(customers).length === 0) {
      data.customer = null; // ... se non ho selezionato un customer allora è cross-customers
    } else {
      // ... altrimenti
      [].concat(customers).forEach(function (c) {
        for (var i = 0; i < $scope.customers.fullList.length; i++) {
          if ($scope.customers.fullList[i].model.code === c.key) {
            data.customer.push($scope.customers.fullList[i].UUID);
            break;
          }
        }
      });
    }
  }
  $scope.update = function (history, callback) {
    if ($scope.lookuped.length > 0) {
      for (var i = 0; i < $scope.lookuped.length; i++) {
        var field = $scope.lookuped[i];
        if (angular.isDefined($scope.type.selected) && angular.isDefined($scope.type.selected.model[field])) {
          var value = $scope.type.selected.model[field];
          if (value == "") {
            delete $scope.type.selected.model[field];
          }
        }
      }
    }
    // gestione code tramite contatore di SIX, confermo il codice...
    if ($scope.selfGeneratedCode.active == true) {
      counterFactory.next({
        code: $scope.selfGeneratedCode.codeNameSix
      }).$promise.then(function (response) {
        if (response.errors) {
          toaster.pop('error', 'Errore', 'Problema rilevato nell\'inizializziazione automatica del codice: ' + response.errors.error);
        } else {
          if (angular.isDefined($scope.type) && angular.isDefined($scope.type.selected) && $scope.type.selected.version) {
            if (!$scope.type.selected.model.code) {
              $scope.type.selected.model.code = response.next; // se è già versionato...
            }
          } else {
            if (!$scope.type.selected.model.code) {
              // se è ancora vuoto lo riempio
              $scope.type.selected.model.code = response.next; // se è nuovo, confermo il codice...
            }
          }
        }

        _update(history, callback);
      });
    } else {
      _update(history, callback);
    }
  };
  function _update(history, callback) {
    var deferred = $q.defer();
    if (angular.isDefined($scope.type) && angular.isDefined($scope.type.selected) && $scope.type.selected.version) {
      if ($scope.commissionDependent == true) {
        $scope.setDataCommissions($scope.type.selected, $scope.commissions.selected);
      }
      setDataCustomers($scope.type.selected, $scope.customers.selected);
      var params = {
        id: $scope.type.selected.version,
        history: history
      };
      if (history) {
        // se la history è abilitata
        if ($scope.isListEditMode() || !$scope.currentVersionInTimeline || compareDates($scope.currentVersionInTimeline.dataIn, $scope.type.selected.dataIn) != 0) {
          // se sto editando i listini o se ho cambiato la dataIn (i listini hanno sempre una dataIn selezionabile dall'utente)
          params.forceDataIn = $scope.type.selected.dataIn;
          $scope.type.selected.dataIn = new Date();
        }
      }
      recordFactory($scope.typeName).update(params, $scope.type.selected).$promise.then(function (respUpdate) {
        var newDocument = fixDates(respUpdate);
        var dataInChanged = compareDates(newDocument.dataIn, $scope.type.selected.dataIn) != 0;
        var dataOutChanged = compareDates(newDocument.dataOut, $scope.type.selected.dataOut) != 0;
        if (dataInChanged || dataOutChanged) {
          recordFactory($scope.typeName).fixDataOut({
            uuid: $scope.type.selected.UUID
          }); // fix della timeline
        }

        angular.extend($scope.type.selected, newDocument);
        callback(respUpdate);
        deferred.resolve(respUpdate);
      })["catch"](function (rejection) {
        toaster.pop('error', 'Errore salvataggio', rejection.data.message ? rejection.data.message : rejection.statusText);
        deferred.reject(rejection);
      });
    } else {
      if ($scope.commissionDependent == true && $scope.bool.crossCommission == true) {
        $scope.commissionDependent = false;
        $scope.customerDependent = false;
      }
      var params = {
        commission_dependent: $scope.commissionDependent,
        customer_dependent: $scope.customerDependent,
        history: $scope.isSnapshot(),
        dataIn: $scope.type.selected.dataIn
      };
      recordFactory($scope.typeName).create(params, $scope.type.selected.model).$promise.then(function (respCreate) {
        angular.extend($scope.type.selected, fixDates(respCreate));
        callback(respCreate);
        deferred.resolve(respCreate);
      })["catch"](function (response) {
        toaster.pop('error', 'Errore salvataggio', 'Si è verificato un errore durante il salvataggio');
        deferred.reject(response);
      });
    }
    return deferred.promise;
  }
  $scope.openDeleteDialog = function () {
    recordFactory($scope.typeName).referenceCount({
      id: $scope.type.selected.UUID
    }).$promise.then(function (response) {
      var deleteMessage = 'Eliminare il record?';
      if (response.count != 0) {
        deleteMessage = 'L\'elemento che stai eliminando è in uso nel sistema. Vuoi rimuoverlo comunque?';
      }
      var dialogScope = {
        lang: 'plain',
        skipTreeCheck: false,
        deleteMessage: deleteMessage,
        record: $scope.type.selected,
        treePaths: buildTreeInfoPaths(),
        getModelIcon: $scope.getModelIcon,
        deleteFunction: function deleteFunction() {
          if ($scope.isListEditMode()) {
            $scope.hardDelete().then(function () {
              //FIXME? sarebbe meglio mostrare un avviso diverso per i listini?
              $scope.back();
            });
          } else {
            $scope["delete"]();
          }
        },
        notDeleteFunction: $scope.closeDeleteDialog
      };
      var opts = {
        name: 'infoTreeDelete',
        closeByDocument: true,
        plain: false
      };
      $scope.deleteDialog = dialogService.templateDialog('recordInfoTreeDelete.html', dialogService.DIALOG_TYPE.DANGER, dialogScope, opts, -1, false);
    });
  };
  $scope.openDeleteVersionDialog = function () {
    var deleteMessage = 'Stai eliminando permanentemente la versione <i>' + $scope.type.selected.version + '</i> ' + 'del documento (dataIn: ' + $filter('date')($scope.type.selected.dataIn, 'dd/MM/yyyy HH:mm:ss') + ' - dataOut: ' + $filter('date')($scope.type.selected.dataOut, 'dd/MM/yyyy HH:mm:ss') + '), ' + 'modificandone la relativa timeline. <br />' + 'Probabilmente sarà necessario modificare anche gli attributi <i>dataIn</i> e <i>dataOut</i> delle versioni precedenti e successive a questa, per ripristinare una timeline coerente.<br /><br />' + '<b>L\'operazione è IRREVERSIBILE</b><br /><br />' + 'Eliminarla comunque?';
    var dialogScope = {
      lang: 'html',
      skipTreeCheck: true,
      deleteMessage: deleteMessage,
      record: $scope.type.selected,
      treePaths: buildTreeInfoPaths(),
      deleteFunction: $scope.hardDelete,
      notDeleteFunction: $scope.closeDeleteDialog
    };
    var opts = {
      name: 'infoTreeDelete',
      closeByDocument: true,
      plain: false
    };
    $scope.deleteDialog = dialogService.templateDialog('recordInfoTreeDelete.html', dialogService.DIALOG_TYPE.DANGER, dialogScope, opts, -1, false);
  };
  $scope.closeDeleteDialog = function () {
    $scope.deleteDialog.close();
  };
  $scope["delete"] = function () {
    $scope.deleteDialog.close();
    return recordFactory($scope.typeName)["delete"]({
      id: $scope.type.selected.version
    }).$promise.then(function (response) {
      $scope.back();
    });
  };
  $scope.hardDelete = function () {
    $scope.deleteDialog.close();
    return recordFactory($scope.typeName).hardDelete({
      id: $scope.type.selected.version
    }).$promise.then(function (response) {
      // refresh timeline
      $scope.$broadcast('sixtimeline:refresh');
    });
  };
  $scope.clone = function (uuid) {
    dialogService.confirmDialog('Eventuali modifiche non salvate saranno perse, vuoi proseguire?', function () {
      $location.path('record/' + $scope.editMode + '/' + $scope.typeName + '/' + uuid + '/clone');
    });
  };
  $scope.setCrossCommission = function () {
    $scope.bool.crossCommission = angular.isUndefined($scope.type.selected.commission) || $scope.type.selected.commission == null;
  };

  // version è opzionale: se non specificata viene considerata la data selezionata
  $scope.getRecordDetail = function (UUID, version) {
    $scope.typeName = $routeParams.type;
    if (angular.isUndefined(UUID)) {
      $scope.type['selected'] = {
        model: {}
      };
      loadSchemaByPromise(schemaFactory().byUUID({
        id: $scope.typeName
      }).$promise);
    } else if (UUID != 'new') {
      var recordPromise;
      if (version) {
        // se ho cliccato sulla timeline ho la version settata
        recordPromise = recordFactory($scope.typeName).byID({
          id: version
        }).$promise;
      } else if ($scope.date.currentDate) {
        // altrimenti mi baso sull'UUID e la data settata
        recordPromise = recordFactory($scope.typeName).byDate({
          param1: $filter('date')($scope.date.currentDate, 'yyyy-MM-dd'),
          id: UUID
        }).$promise;
      } else {
        // altrimenti su UUID e versione corrente (non ho aperto la timeline)
        recordPromise = recordFactory($scope.typeName).byUUID({
          id: UUID
        }).$promise;
      }
      recordPromise.then(function (data) {
        refreshData(data, version);
        $scope.$broadcast('sixtimeline:refresh');
      });
    } else {
      // è un nuovo record => carico lo schema
      $scope.type['selected'] = {};
      $scope.type.selected['model'] = {};
      $scope.type.selected['commission'] = [];
      $scope.type.selected['dataIn'] = new Date();
      fillCommissionFromAvailables([currentCommission.code]);
      loadCustomerList();
      loadSchemaByPromise(schemaFactory().byUUID({
        id: $scope.typeName
      }).$promise);
    }
  };
  function refreshData(data, version) {
    if (data.model) {
      $scope.uniqueExclusions = [data.model.code];
      $scope.type['selected'] = data;
      $scope.setCrossCommission();
      $timeout(function () {
        loadRightSchema(data);
      }, 500); // così funziona lo unique-validation... evidentemente la uniqueExclusions non fa in tempo ad essere bindata con la direttiva, quindi ritardo il caricamento dello schema (che a sua volta triggera la unique validation)
      if ($scope.action.clone) {
        //se è un operazione di copia rimuovo l'UUID e il version
        $scope.type.selected.UUID = null;
        $scope.type.selected.version = null;
      }

      // dataIn e dataOut
      fixDates($scope.type.selected);
      $scope.setValidityPeriodLimits();
      if (data.commission) {
        fillCommissionFromAvailables(data.commission);
      }
      if (data.customer) {
        fillCustomerFromAvailables(data.customer);
      } else {
        loadCustomerList();
      }
      if (data.parents && data.parents.length) {
        $scope.withTree = true;
      } else {
        $scope.withTree = false;
      }
      readAttachments($scope.type.selected.model.attachments);
      $scope.type.selected.model["UUID"] = $scope.type.selected.UUID;
      originalRecordDetail = angular.copy($scope.type.selected);
    } else {
      dialogService.alert('Non sono presenti versioni nella data selezionata per l\'entità ', 4000);
    }
  }
  function loadRightSchema(record) {
    var session = sessionFactory.getSessionData();
    var schemaPromise;
    if ($scope.date.currentDate) {
      // se ho una currentDate sto caricando un dato vecchio ...
      if (record.schemaVersion) {
        // ... => carico il modello corrispondente a quello indicato in schemaVersion (se presente) ...
        schemaPromise = schemaFactory().byID({
          version: record.schemaVersion
        }).$promise;
      } else {
        // ... oppure carico il modello valido alla dataIn del record (se non è presente schemaVersion)
        schemaPromise = schemaFactory().byDate({
          param1: $filter('date')(record.dataIn, 'yyyy-MM-dd'),
          id: $scope.typeName
        }).$promise;
      }
    } else {
      // ... altrimenti sto visualizzando il dato attuale quindi carico l'ultimo modello valido
      schemaPromise = schemaFactory().byUUID({
        id: $scope.typeName
      }).$promise;
    }
    loadSchemaByPromise(schemaPromise);
  }
  function loadSchemaByPromise(promise) {
    promise.then(function (data) {
      if (!data.model) {
        dialogService.alert('Non è stato definito un modello per l\'entità ' + $scope.typeName, 4000);
        $scope.isModelDefined = false;
        return;
      }
      $scope.isCollapsed = true;
      $scope.schema = data.model.schema;
      $scope.schemaUUID = data.UUID;
      $scope.schemaVersion = data.version;
      $scope.schemaCreationDate = data.creationDate;
      $scope.schemaDataIn = data.dataIn;
      $scope.schemaDataOut = data.dataOut;
      $scope.typeDescription = data.model.description;
      $scope.schemaDescription = data.model.description;
      $scope.schemaCode = data.model.code;
      $scope.schemaCommission = data.model.commission;
      $scope.form = getPatchedForm(data.model);
      $scope.commissionDependent = data.model.commissionDependent;
      $scope.editCrossCommission = $scope.commissionDependent == true;
      $scope.customerDependent = data.model.customerDependent;
      $scope.attachmentManagement = data.model.attachmentManagement;
      $scope.calendarManagement = data.model.calendarManagement;
      $scope.drawingManagement = data.model.drawingManagement;
      $scope.showSubnodes = data.model.showSubnodes;
      $scope.subNodesType = data.model.subNodesType;
      $scope.subNodesLabel = data.model.subNodesLabel || "Sottonodi";
      if (data.model.selfGeneratedCode && data.model.selfGeneratedCode.active) {
        $scope.selfGeneratedCode = data.model.selfGeneratedCode;
        // scarico il codice della segnalazione dal contatore di SIX associato
        counterFactory.current({
          code: $scope.selfGeneratedCode.codeNameSix
        }).$promise.then(function (response) {
          if (!$scope.type.selected.model.code) {
            if (response.errors) {
              toaster.pop('error', 'Errore', 'Problema rilevato nell\'inizializzazione automatica del codice: ' + response.errors.error);
            } else {
              $scope.type.selected.model.code = (parseInt(response.current) + 1).toString();
            }
          }
        });
      } else {
        if ($scope.isListEditMode()) {
          $scope.type.selected.model.code = sixObjectLib.makeGUID();
        }
      }
      if ($scope.isListEditMode() && !$scope.type.selected.model.description) {
        $scope.type.selected.model.description = "Riga listino";
      }
      loadColumnOrDefault($scope.viewGridOptions, data);
      // $scope.$broadcast('schemaFormRedraw');
    });
  }

  function getPatchedForm(model) {
    //disabilita dinamicamente i campi che non dovrebbero essere modificabili
    var form = model.form;
    if ($scope.isListEditMode() && !$scope.isNew()) {
      var lowerDateLimit = historyLock.getMinimumDate($scope.type.selected.commission);
      if (compareDates($scope.type.selected.dataIn, lowerDateLimit) < 0) {
        form = disableFormField(model.form);
      } else {
        //disabilita il campo chiave per i listini
        if (model.priceListKey) {
          form = disableFormField(model.form, model.priceListKey);
        }
      }
    } else {
      if (!$scope.isWriteVersionAllowed() && $scope.type.selected.dataOut && $scope.type.selected.dataOut < new Date()) {
        //disabilita tutto se non si hanno i permessi di modifica nel passato
        form = disableFormField(model.form);
      }
    }
    return form;
  }
  function disableFormField(form, fieldName) {
    if (Array.isArray(form)) {
      for (var i in form) {
        form[i] = disableFormField(form[i], fieldName);
      }
    }
    if ("key" in form) {
      if (!fieldName || form.key == fieldName || Array.isArray(form.key) && form.key.indexOf(fieldName) != -1) {
        form.readonly = true;
      }
    } else {
      for (var i in form) {
        if (Object.prototype.hasOwnProperty.call(form, i) && Array.isArray(form[i])) {
          form[i] = disableFormField(form[i], fieldName);
        }
      }
    }
    return form;
  }
  $scope.initDrawing = function () {
    if (typeof $scope.hasDrawing !== "undefined") return;
    $scope.drawingUuid = null;
    $scope.drawingAssetUuid = null;
    $scope.hasDrawing = false;

    //assumes schema is loaded and asset is loaded
    if ($scope.type.selected.model.drawing_id) {
      $scope.drawingUuid = $scope.type.selected.model.drawing_id.UUID;
      $scope.drawingAssetUuid = $scope.type.selected.UUID;
      $scope.hasDrawing = true;
    } else {
      //cerco il primo parent che contenga un drawing_id
      var treeCode = getTreeCode();
      var parentsUuid = $scope.type.selected.parents.filter(function (p) {
        return p.treeCode == treeCode && p.UUID;
      }).sort(function (a, b) {
        return b.treeLevel - a.treeLevel;
      }).map(function (p) {
        return p.UUID;
      });
      var payload = {
        page_size: 100
      };
      var filters = {
        "myParent": sixFiltersLib["in"]("UUID", parentsUuid),
        "withDrawing": sixFiltersLib.exists("model.drawing_id.UUID")
      };
      recordFactory('type').untypedSearch(payload, filters).$promise.then(function (result) {
        if (result && result.list) {
          var closest = Infinity;
          var asset = null;
          result.list.forEach(function (doc) {
            var distance = parentsUuid.indexOf(doc.UUID);
            if (distance < closest) {
              closest = distance;
              asset = doc;
            }
          });
          if (asset) {
            $scope.drawingUuid = asset.model.drawing_id.UUID;
            $scope.drawingAssetUuid = asset.UUID;
            $scope.hasDrawing = true;
          }
        }
      });
    }
  };
  $scope.getColumns = function () {
    $scope.typeName = $routeParams.type;
    schemaFactory().byUUID({
      id: $scope.typeName
    }).$promise.then(function (data) {
      if (!data.model) {
        dialogService.alert('Non è stato definito un modello per l\'entità ' + $scope.typeName, 4000);
        $scope.isModelDefined = false;
      } else {
        $scope.bulkEditConf.schema = data.model;
        $scope.typeDescription = data.model.description;
        loadColumnOrDefault($scope.viewGridOptions, data);
      }
    });
    return $scope.columnDefs;
  };
  $scope["new"] = function () {
    $location.path('record/' + $scope.editMode + '/' + $scope.typeName + '/' + 'new');
  };
  $scope.$on('schemaFormRedraw', function (event, param) {
    if ($scope.isStable() && angular.isDefined($scope.type.selected.version) && !$scope.action.clone) {
      makeCodeReadonly();
    }
  });
  function makeCodeReadonly() {
    setTimeout(function () {
      $('input#code').prop("readonly", true);
    }, 0);
  }
  function validateModelDates() {
    var dateElements = document.getElementsByTagName("input");
    for (var i = 0; i < dateElements.length; i++) {
      var dateForm = dateElements[i];
      if (dateForm.value == '' && $scope.schema.properties[dateForm.name] && $scope.schema.properties[dateForm.name].format == 'date') {
        delete $scope.type.selected.model[dateForm.name];
      }
    }
  }
  function isValidDate(date) {
    return moment(date, moment.ISO_8601).isValid();
  }
  $scope.listEditModeInsert = function (form) {
    var lowerDateLimit = historyLock.getMinimumDate($scope.type.selected.commission);
    var payload = {
      id: $scope.type.selected.UUID,
      date: $scope.type.selected.dataIn
    };
    recordFactory($scope.typeName).getAdjacent(payload).$promise.then(function (result) {
      var max = result.next ? new Date(result.next.dataIn) : null;
      var min = new Date(result.current.dataIn);
      if (min < lowerDateLimit) {
        min = lowerDateLimit;
      }
      var suggestedDataIn = $scope.type.selected.dataOut;
      if (!suggestedDataIn) {
        //in alternativa scelgo arbitrariamente di suggerire il giorno successivo al min
        suggestedDataIn = new Date(min.valueOf() + 1000 * 3600 * 24);
      }
      var dialogScope = {
        dataInOptions: {
          minDate: min,
          maxDate: max
        },
        dataOutOptions: {
          minDate: min,
          maxDate: max
        },
        dataIn: suggestedDataIn,
        dataOut: max,
        proceed: function proceed(dataIn, dataOut) {
          $scope.type.selected.dataIn = dataIn;
          $scope.type.selected.dataOut = dataOut;
          $scope.onSubmit(form, true, function (updateResponse) {
            dialogRef.close();
            var uuid = updateResponse.UUID;
            var version = updateResponse.version;
            $location.path('record/' + $scope.editMode + '/' + $scope.typeName + '/' + uuid + '/v/' + version);
          });
        },
        cancel: function cancel() {
          dialogRef.close();
        }
      };
      var opts = {
        name: 'validitySelector',
        closeByDocument: true,
        plain: false
      };
      var dialogRef = dialogService.templateDialog('validitySelector.html', dialogService.DIALOG_TYPE.INFO, dialogScope, opts, -1, false);
    });
  };
  $scope.onSubmit = function (form, history, back) {
    if (angular.isUndefined(history) || history == null) {
      if ($scope.isListEditMode()) {
        history = false;
      } else {
        history = $scope.isSnapshot();
      }
    }
    if (angular.isUndefined(back) || back == null) {
      back = true;
    }
    if ($scope.isCustomerMissing()) {
      dialogService.alert('Selezionare un cliente per abilitare il salvataggio.', 4000);
    } else if (!isValidDate($scope.type.selected.dataIn)) {
      dialogService.alert('Campo: "Inizio validità" non valido', 4000);
    } else {
      /** TO DO: bisogna pulire il model dalle date "vuote" -> BISOGNERA' SOST. IL PICKER */
      validateModelDates();

      // First we broadcast an event so all fields validate themselves
      $scope.$broadcast('schemaFormValidate');
      // Then we check if the form is valid

      $log.debug('form', form);
      if (form.$valid) {
        var updateFnt = function updateFnt() {
          $scope.update(history, function (updateResponse) {
            if (angular.isDefined($scope.type) && angular.isDefined($scope.type.selected) && $scope.type.selected.version && back) {
              // update
              if (angular.isFunction(back)) {
                back(updateResponse);
              } else {
                $scope.back();
              }
            } else {
              // create
              if ($scope.action.clone) {
                $location.path('record/' + $scope.editMode + '/' + $scope.typeName);
              } else if (back) {
                if (angular.isFunction(back)) {
                  back(updateResponse);
                } else {
                  $scope.back();
                }
              }
            }
            // refresh timeline
            $scope.$broadcast('sixtimeline:refresh');
            if (updateDialog) {
              updateDialog.close();
            }
          });
        };

        // Se ho una versione futura mostro una dialog di avviso ...
        if ($scope.nextVersionInTimeline && !$scope.isListEditMode()) {
          var dialogScope = {
            lang: 'html',
            next: $scope.nextVersionInTimeline,
            help: $scope.showWriteVersionHelp,
            updateFnt: updateFnt,
            notUpdateFnt: function notUpdateFnt() {
              updateDialog.close();
            }
          };
          var opts = {
            name: 'recordInfoUpdate',
            closeByDocument: true,
            plain: false
          };
          var updateDialog = dialogService.templateDialog('recordInfoUpdate.html', dialogService.DIALOG_TYPE.WARNING, dialogScope, opts, -1, false);
        } else {
          // ... altrimenti salvo e basta
          updateFnt();
        }
      } else {
        toaster.pop('error', 'Errore validazione', 'Controllare i dati inseriti in ogni scheda');
      }
    }
  };
  $scope.showTimelineHelpDialog = function (message) {
    var dlgScope = {
      lang: 'html',
      message: message,
      newVersion: $scope.type.selected,
      next: $scope.nextVersionInTimeline,
      current: $scope.currentVersionInTimeline,
      prev: $scope.prevVersionInTimeline,
      now: new Date()
    };
    if ($scope.currentVersionInTimeline) {
      dlgScope.dataInChanged = $scope.type.selected.dataIn != $scope.currentVersionInTimeline.dataIn;
    } else {
      dlgScope.dataInChanged = true;
    }
    var dlgOpts = {
      name: 'helpDialog',
      closeByDocument: true,
      plain: false
    };
    var helpDialog = dialogService.templateDialog('helpTimelineTemplate.html', dialogService.DIALOG_TYPE.INFO, dlgScope, dlgOpts, -1, false, '50%');
  };
  $scope.showWriteVersionHelp = function () {
    var message = '&Egrave; presente una versione con data di inizio validità successiva a quella che si sta cercando di inserire. ' + 'Tutte le modifiche apportate ora cesseranno la loro validità in data ' + $filter('date')($scope.nextVersionInTimeline.dataIn, 'dd/MM/yyyy HH:mm:ss');
    $scope.showTimelineHelpDialog(message);
  };
  $scope.getRecordVersionInfoMsg = function () {
    if ($scope.type.selected) {
      var msg = 'Stai visualizzando una versione valida dal ' + $filter('date')($scope.type.selected.dataIn, 'dd/MM/yyyy');
      if ($scope.type.selected.dataOut) {
        msg += ' al ' + $filter('date')($scope.type.selected.dataOut, 'dd/MM/yyyy');
      }
      return msg;
    }
  };
  $scope.viewGridOptions = {
    enableSorting: true,
    enableGridMenu: true,
    exporterCsvColumnSeparator: ';',
    exporterSuppressColumns: ['id', 'timeline'],
    exporterMenuPdf: false,
    enableFiltering: true,
    enableColumnResizing: true,
    paginationPageSize: $scope.params.pageSize,
    columnDefs: [{
      name: ' '
    }]
  };

  // finito di renderizzare lo schema-form...
  $scope.$on('sf-render-finished', function () {
    setTimeout(disableMousewheelScroll, 1000); //...disabilito lo scroll sugli input type=number
  });

  function disableMousewheelScroll() {
    angular.element(':input[type=number]').on('mousewheel', function (e) {
      $(this).blur();
    });
  }
  $scope.isCustomerMissing = function () {
    return $scope.app.profileCustomer && $scope.customerDependent && angular.isUndefined($scope.currentCustomer);
  };
  $scope.isNew = function () {
    return $routeParams.id && (!$scope.type || !$scope.type.selected || !$scope.type.selected.version);
  };

  /** ************************************ **/
  /** ************* Timeline ************* **/
  /** ************************************ **/

  $scope.timelineFlags = {
    showTimeline: false
  };
  $scope.showNextVersion = function () {
    var dialogScope = {
      dataIn: new Date($scope.nextVersionInTimeline.dataIn),
      dataOut: $scope.nextVersionInTimeline.dataOut ? new Date($scope.nextVersionInTimeline.dataOut) : undefined,
      schema: $scope.schema,
      form: $scope.form,
      model: $scope.nextVersionInTimeline.model
    };
    var opts = {
      name: 'nextVersionDialog',
      closeByDocument: true,
      plain: false
    };
    dialogService.templateDialog('nextVersionTemplate.html', dialogService.DIALOG_TYPE.INFO, dialogScope, opts, -1, false, '90%');
  };

  // Controlla se la versione mostrata è quella corrente o è stata caricata selezionandola dalla timeline
  $scope.isCurrentVersion = function () {
    if (!$scope.type.selected) {
      return false;
    }
    if (compareDates($scope.type.selected.dataIn, new Date()) > 0) {
      // versione futura
      return false;
    }
    if ($scope.type.selected.dataOut && compareDates($scope.type.selected.dataOut, new Date()) < 0) {
      // versione passata
      return false;
    }
    return true;
  };
  $scope.closeTimeline = function () {
    $scope.timelineFlags.showTimeline = false;
    $scope.isCollapsed = true;
  };
  $scope.refreshTimeline = function () {
    if ($routeParams.id) {
      return recordFactory($scope.typeName, $routeParams.id).getTimeline().$promise;
    } else {
      var p = $q.defer();
      p.resolve({
        list: []
      });
      return p.promise;
    }
  };

  // Avvia il fix della timeline (riordina le dataIn e sistema le dataOut)
  $scope.fixTimeline = function () {
    // fix della timeline
    return recordFactory($scope.typeName).fixTimeline({
      param2: $scope.type.selected.UUID
    }).$promise;
  };

  // Avvia il fix della timeline (riordina le dataIn e sistema le dataOut)
  $scope.checkTimeline = function () {
    // fix della timeline
    return recordFactory($scope.typeName).checkTimeline({
      param2: $scope.type.selected.UUID
    }).$promise;
  };
  $scope.onSelectVersion = function (selected, event) {
    if (event != 'changed_externally') {
      refreshData(selected, selected.version);
    }
  };
  $scope.onSaveVersion = function (data) {
    if (isValidDate($scope.type.selected.dataIn)) {
      _update(false, function () {}).then(function (resp) {
        $scope.$broadcast('sixtimeline:refresh');
      });
    } else {
      dialogService.alert('Campo: "Inizio validità" non valido', 4000);
    }
  };
  $scope.onDeleteVersion = function (data) {
    $scope.openDeleteVersionDialog();
  };
  $scope.onDateChanged = function (currentDate, event) {
    $log.debug('date changed!', currentDate, event);
    if (event == 'date_selected') {
      $scope.changeCurrentDate(currentDate, true);
    }
  };

  /****************************************/
  /********** check and fix type **********/
  /****************************************/

  function getTreeCode() {
    var code = 'def' + currentCommission.code;
    if (angular.isDefined($scope.currentCustomer)) {
      code += 'cli' + $scope.currentCustomer.code;
    }
    return code;
  }
  $scope.removeFromTree = function () {
    var treeCode = getTreeCode();
    var n = {
      code: angular.copy($scope.type.selected.model.code),
      description: angular.copy($scope.type.selected.model.description),
      UUID: angular.copy($scope.type.selected.UUID),
      type: angular.copy($scope.type.selected.schemaCode),
      deleted: true,
      parents: []
    };
    treeFactory.updateNode({
      id: treeCode
    }, n).$promise.then(function (response) {
      // success
      toaster.pop('success', 'Rimosso da tree', 'Il record è stato rimosso dal tree \'' + treeCode + '\'');
      if (response && response.result) {
        $scope.type.selected.parents = response.result.parents;
        $scope.type.selected.version = response.result.version;
      }
    })["catch"](function (response) {
      // error
      toaster.pop('error', 'Errore rimozione da tree', 'Errore durante la rimozione del record dal tree \'' + treeCode + '\'');
    });
  };

  /****************************************/
  /********** check and fix type **********/
  /****************************************/

  $scope.checkType = function () {
    dialogService.showLoadingMessage('Checking ' + $scope.typeName + '...');
    recordFactory($scope.typeName).check().$promise.then(function (response) {
      $scope.messages = response.messages;
      if (response.status === 'ok') {
        toaster.pop('success', 'Tutto ok', 'Nessun problema rilevato');
      } else {
        toaster.pop('warning', 'Attenzione', 'Problemi rilevati: ' + $scope.messages.length);
      }
    })["catch"](function (response) {
      toaster.pop('error', 'Errore', 'Impossibile controllare il tipo ' + $scope.typeName);
    })["finally"](function (response) {
      dialogService.hideLoadingMessage();
    });
  };
  $scope.tryFixAllProblems = function () {
    dialogService.showLoadingMessage('Fixing ' + $scope.typeName + '...');
    recordFactory($scope.typeName).fixAll().$promise.then(function (response) {
      $scope.messages = response.messages;
      toaster.pop('success', 'Corretto', 'Gli errori rilevati sono stati corretti sul tipo ' + $scope.typeName);
    })["catch"](function (response) {
      toaster.pop('error', 'Errore', 'Impossibile correggere gli errori sui dati del tipo ' + $scope.typeName);
    })["finally"](function (response) {
      dialogService.hideLoadingMessage();
    });
  };
  $scope.tryFixProblem = function (problem) {
    if (problem) {
      var path = 'record/' + problem.record.type + '/' + FIXABLE_CODE_PROBLEMS[problem.code];
      if (path) {
        dialogService.showLoadingMessage('Fixing ' + $scope.typeName + '...');
        dataSetFactory(path + '/' + problem.record.uuid).query().$promise.then(function (response) {
          $scope.messages = response.messages;
          if (response.status !== 'ok') {
            toaster.pop('error', 'Errore', 'Impossibile correggere gli errori sul record ' + problem.record.uuid + ' del tipo ' + problem.record.type);
          } else {
            toaster.pop('success', 'Corretto', 'Gli errori rilevati sono stati corretti sul record ' + problem.record.uuid + ' di tipo ' + problem.record.type);
          }
        })["catch"](function (response) {
          toaster.pop('error', 'Errore', 'Impossibile correggere gli errori sul record ' + problem.record.uuid + ' del tipo ' + problem.record.type);
        })["finally"](function () {
          dialogService.hideLoadingMessage();
        });
      }
    }
  };

  // Recupera l'icona del model da menu
  $scope.getModelIcon = function (modelName) {
    $log.debug('getModelIcon: ' + modelName);
    var icon = modelIconService.getModelIcon(modelName) || 'fa fa-circle-o';
    return 'fa-fw ' + icon;
  };
  $scope.showRecordInfo = function () {
    var dialogScope = {
      treePaths: buildTreeInfoPaths(),
      getModelIcon: $scope.getModelIcon,
      record: $scope.type.selected,
      schema: {
        code: $scope.schemaCode,
        UUID: $scope.schemaUUID,
        version: $scope.schemaVersion,
        creationDate: $scope.schemaCreationDate,
        dataIn: $scope.schemaDataIn,
        dataOut: $scope.schemaDataOut,
        commission: $scope.schemaCommission
      }
    };
    var opts = {
      name: 'recordInfoDialog',
      closeByDocument: true,
      plain: false
    };
    dialogService.templateDialog('recordInfoTemplate.html', dialogService.DIALOG_TYPE.INFO, dialogScope, opts, -1, false, '50%');
  };
  function buildTreeInfoPaths() {
    var treePaths = undefined;
    if ($scope.type.selected.parents && $scope.type.selected.parents.length > 0) {
      treePaths = {};
      $scope.type.selected.parents.forEach(function (p) {
        var path = treePaths[p.treeCode] || [];
        // ci metto dentro tutte le info del nodo
        path.push(p);
        treePaths[p.treeCode] = path;
      });
    }
    return treePaths;
  }

  /**************************************
   * Sottonodi
   **************************************/

  $scope.hasParents = function () {
    return $scope.type.selected && $scope.type.selected.parents && $scope.type.selected.parents.length > 0;
  };
  $scope.subNodesViewGridOptions = {
    enableSorting: true,
    enableGridMenu: true,
    exporterCsvColumnSeparator: ';',
    exporterSuppressColumns: ['id', 'timeline'],
    exporterMenuPdf: false,
    enableFiltering: true,
    enableColumnResizing: true,
    paginationPageSize: $scope.params.pageSize,
    columnDefs: [{
      name: ' '
    }]
  };
  $scope.loadSubNodes = function () {
    $scope.treePaths = buildTreeInfoPaths();
    schemaFactory().byUUID({
      id: $scope.subNodesType
    }).$promise.then(function (data) {
      if (!data.model) {
        dialogService.alert('Non è stato definito un modello per l\'entità ' + $scope.subNodesType, 4000);
      } else {
        loadColumnOrDefault($scope.subNodesViewGridOptions, data);
      }
    });
  };
  $scope.getAllSubnodes = function () {
    return $scope.getSubnodes(true);
  };
  $scope.getSubnodes = function (getAll) {
    var payload = {
      page: getAll ? 1 : $scope.params.pageNumber,
      page_size: getAll ? 10000 : $scope.params.pageSize,
      sort_fields: $scope.params.sortFields,
      show_revision: true,
      solve_inherit: true,
      query: getAll ? undefined : $scope.params.queryParam
    };
    if ($scope.date.currentDate) {
      payload.currentDate = $scope.date.currentDate.toISOString();
    } else {
      payload.currentDate = new Date().toISOString();
    }
    var subfilters = {
      "p_type": sixFiltersLib.exact("parents.type", $scope.type.selected.schemaCode),
      "p_uuid": sixFiltersLib.exact("parents.UUID", $scope.type.selected.UUID)
    };
    $scope.params.filters["mysons"] = sixFiltersLib.nested("parents", subfilters);
    var promise = recordFactory($scope.subNodesType).search(payload, $scope.params.filters).$promise;
    if (!getAll) {
      promise.then(function (result) {
        $scope.subnodes.list = result.list || [];
        $scope.subnodes.totalResults = result.totalResults;
        cfpLoadingBar.complete();
        if ($scope.params.sixApi) {
          $scope.params.sixApi.refreshList($scope.subnodes.list);
        }
        return result;
      });
    }
    return promise;
  };

  /** ***********************************
   * Commesse
   * ***********************************/

  function loadCommissionList() {
    return commissionFactory().getCommissionsSelectList().$promise.then(function (response) {
      if (response.list) {
        $scope.commissions.list = response.list;
      }
      return response;
    });
  }
  function fillCommissionFromAvailables(commissions) {
    if (!$scope.commissions.list || $scope.commissions.list.length === 0) {
      loadCommissionList().then(function () {
        _fillCommissionFromAvailables(commissions);
      });
    } else {
      _fillCommissionFromAvailables(commissions);
    }
  }
  function _fillCommissionFromAvailables(commissions) {
    $scope.commissions.selected = [];
    [].concat(commissions).forEach(function (code) {
      var found = _findCommissionFromAvailables(code);
      if (found) {
        $scope.commissions.selected.push(found);
      }
    });
  }
  function _findCommissionFromAvailables(code) {
    if ($scope.commissions.list && $scope.commissions.list.length > 0) {
      for (var idx in $scope.commissions.list) {
        if ($scope.commissions.list[idx].key === code) {
          return $scope.commissions.list[idx];
        }
      }
    }
    return undefined;
  }
  function loadCustomerList() {
    var payload = {
      page_size: 10000,
      query: undefined,
      show_revision: false
    };
    return recordFactory("cliente").search(payload, {}).$promise.then(function (response) {
      if (response.list) {
        var result = [];
        response.list.forEach(function (customer) {
          result.push({
            key: customer.model.code,
            description: customer.model.description
          });
        });
        $scope.customers.list = result;
        $scope.customers.fullList = response.list;
      }
      return response;
    });
  }
  function fillCustomerFromAvailables(customers) {
    if (!$scope.customers.list || $scope.customers.list.length === 0) {
      loadCustomerList().then(function () {
        _fillCustomerFromAvailables(customers);
      });
    } else {
      _fillCustomerFromAvailables(customers);
    }
  }
  function _fillCustomerFromAvailables(customers) {
    $scope.customers.selected = [];
    [].concat(customers).forEach(function (code) {
      var found = _findCustomerFromAvailables(code);
      if (found) {
        $scope.customers.selected.push(found);
      }
    });
  }
  function _findCustomerFromAvailables(code) {
    if ($scope.customers.fullList && $scope.customers.fullList.length) {
      for (var idx in $scope.customers.fullList) {
        if ($scope.customers.fullList[idx].UUID === code) {
          return {
            key: $scope.customers.fullList[idx].model.code,
            description: $scope.customers.fullList[idx].model.description
          };
        }
      }
    }
    return undefined;
  }

  /** ********************* **/
  /** **** ATTACHMENTS **** **/
  /** ********************* **/

  $scope.saveAttachments = function () {
    $timeout(function () {
      //altrimenti angular non fa in tempo ad aggiornare l'array
      var history;
      if ($scope.isListEditMode()) history = false;else history = $scope.isSnapshot();
      $scope.type.selected.model.attachments = $scope.attachments;
      $scope.update(history, function () {});
    });
  };
  $scope.attachments = [];
  function readAttachments(modelList) {
    if (angular.isDefined(modelList)) {
      $scope.attachments.splice(0, $scope.attachments.length);
      for (var i = 0; i < modelList.length; i++) {
        $scope.attachments.push(modelList[i]);
      }
    }
  }
  function writeAttachments(modelList) {
    if (modelList) {
      modelList.splice(0, modelList.length);
      for (var i = 0; i < $scope.attachments.length; i++) {
        modelList.push($scope.attachments[i]);
      }
    }
  }
  $scope.writeAttachments = function () {
    if (angular.isUndefined($scope.type.selected.model.attachments)) {
      $scope.type.selected.model.attachments = [];
    }
    writeAttachments($scope.type.selected.model.attachments);
  };
  $scope.writeAttachments = function () {
    if (angular.isUndefined($scope.type.selected.model.attachments)) {
      $scope.type.selected.model.attachments = [];
    }
    writeAttachments($scope.type.selected.model.attachments);
  };

  /** *********************** **/
  /** **** Check changes **** **/
  /** *********************** **/

  // var originalStringifiedModel = undefined;

  // Controlla se è stato cambiato qualche valore (usato per controllare l'abilitazione del pulsante di salvataggio)
  function isDataChanged() {
    var res = true;
    if (originalRecordDetail && $scope.type.selected) {
      res = Object.keys(diff.getDiff(originalRecordDetail, $scope.type.selected, {
        strictNullCheck: false
      })).length > 0;
      if (!res && $scope.commissions.selected) {
        res = compareLookupAndSchema({
          key: "key",
          value: $scope.commissions.selected
        }, {
          value: $scope.type.selected.commission
        });
      }
      if (!res && $scope.customers.selected) {
        res = compareCustomer();
      }
      if ($scope.isListEditMode()) {
        //nei listini è editabile anche il dataIn
        res = res || JSON.stringify(originalRecordDetail.dataIn) != JSON.stringify($scope.type.selected.dataIn);
      }
    }
    return res;
  }
  function compareCustomer() {
    var customersUuidList = [];
    $scope.customers.selected.forEach(function (data) {
      for (var ind = 0; ind < $scope.customers.fullList.length; ind++) {
        if ($scope.customers.fullList[ind].model.code == data.key) {
          customersUuidList.push($scope.customers.fullList[ind].UUID);
        }
      }
    });
    return compareLookupAndSchema({
      value: customersUuidList
    }, {
      value: $scope.type.selected.customer
    });
  }
  function compareLookupAndSchema(sixLookupObj, obj) {
    var isDiff = false;
    if (Array.isArray(sixLookupObj.value) && Array.isArray(obj.value)) {
      //TO-DO: gestire altri casi?
      var sixKey = sixLookupObj.key;
      var sixVal = sixLookupObj.value;
      if (sixKey) {
        var lookupObjToCompare = [].concat(function () {
          var result = [];
          for (var i = 0; i < sixVal.length; i++) {
            result.push(sixVal[i][sixKey]);
          }
          return result;
        }());
      } else {
        var lookupObjToCompare = sixLookupObj.value;
      }
      var objKey = obj.key;
      var objValue = obj.value;
      if (objKey) {
        var obyToCompare = [].concat(function () {
          var result = [];
          for (var i = 0; i < objValue.length; i++) {
            result.push(objValue[i][objKey]);
          }
          return result;
        }());
      } else {
        var obyToCompare = objValue;
      }
      isDiff = Object.keys(diff.getDiff(lookupObjToCompare, obyToCompare)).length > 0;
    }
    return isDiff;
  }

  /** ********************** **/
  /** ******** Date ******** **/
  /** ********************** **/

  // Sistema le date reinizializzandole (da backend potrebbero arrivarmi come stringhe)
  function fixDates(data) {
    if (data.creationDate) {
      data.creationDate = createDateTime(data.creationDate);
    }
    if (data.dataIn) {
      data.dataIn = createDateTime(data.dataIn);
    }
    if (data.dataOut) {
      data.dataOut = createDateTime(data.dataOut);
    }
    return data;
  }

  // Crea un dateTime fino ai secondi (yyyy-MM-dd HH:mm:ss)
  function createDateTime(date) {
    var d = new Date(date);
    return new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds());
  }

  /* Permessi ad-hoc per i listini */
  $scope.dataInDisabled = function () {
    if ($scope.isListEditMode() && $scope.isNew() == false) {
      var dateLimit = historyLock.getMinimumDate($scope.type.selected.commission);
      return !$scope.type.selected.dataIn || compareDates(new Date($scope.type.selected.dataIn), dateLimit) < 0;
    } else {
      return $scope.isWriteVersionAllowed() == false || $scope.isNew() && !$scope.isFutureInsertAllowed();
    }
  };

  // Controlla la possibilità di modificare la dataOut a mano
  $scope.dataOutDisabled = function () {
    if ($scope.isListEditMode() && $scope.isNew() == false) {
      var dateLimit = historyLock.getMinimumDate($scope.type.selected.commission);
      return angular.isDefined($scope.nextVersionInTimeline) || angular.isDefined($scope.type.selected.dataOut) && $scope.type.selected.dataOut != null && compareDates(new Date($scope.type.selected.dataOut), dateLimit) < 0;
    } else {
      return $scope.isWriteVersionAllowed() == false || $scope.isNew() && !$scope.isFutureInsertAllowed();
    }
  };
  $scope.canAddListVersion = function () {
    if ($scope.type.selected && $scope.type.selected.commission) {
      var dateLimit = historyLock.getMinimumDate($scope.type.selected.commission);
      var dataOutMiss = angular.isUndefined($scope.type.selected.dataOut) || $scope.type.selected.dataOut == null;
      var dataOutAfterLimit = compareDates(new Date($scope.type.selected.dataOut), dateLimit) > 0;
      return authFactory.isWritePermAllowed(RESOURCE_NAME) && $scope.isListEditMode() && !$scope.isNew() && (dataOutMiss || dataOutAfterLimit);
    } else {
      return false;
    }
  };

  // Imposta il range di date selezionabili dai datetime picker
  $scope.setValidityPeriodLimits = function () {
    $scope.loadAdjacentVersions($scope.type.selected.UUID, $scope.type.selected.dataIn).then(function (result) {
      //FIXME: dovrei tenere conto anche delle variazioni di schema
      var dateLimit = historyLock.getMinimumDate($scope.type.selected.commission);
      var max = result.next ? new Date(result.next.dataIn) : null;
      var min = result.prev ? new Date(result.prev.dataIn) : null;
      if (!min && !$scope.isWriteVersionAllowed()) {
        min = new Date();
      }
      if (compareDates(min, dateLimit) < 0) {
        min = dateLimit;
      }
      $scope.dataInOptions.minDate = min;
      $scope.dataInOptions.maxDate = max;
      $scope.dataOutOptions.minDate = $scope.type.selected.dataIn;
      $scope.dataOutOptions.maxDate = max;
    });
  };

  // Carica le versioni successiva, precedente e corrente rispetto alla data selezionata
  $scope.loadAdjacentVersions = function (uuid, dataIn) {
    // chiede al backend il documento precedente e il successivo nella timeline
    var payload = {
      id: uuid,
      date: dataIn
    };
    return recordFactory($scope.typeName).getAdjacent(payload).$promise.then(function (result) {
      //FIXME: dovrei tenere conto anche delle variazioni di schema
      if (result.next) {
        $scope.nextVersionInTimeline = fixDates(result.next);
      } else {
        $scope.nextVersionInTimeline = undefined;
      }
      if (result.current) {
        $scope.currentVersionInTimeline = fixDates(result.current);
      } else {
        $scope.currentVersionInTimeline = undefined;
      }
      if (result.prev) {
        $scope.prevVersionInTimeline = fixDates(result.prev);
      } else {
        $scope.prevVersionInTimeline = undefined;
      }
      return result;
    });
  };
  function compareDates(date1, date2) {
    var d1, d2;
    d1 = angular.isDate(date1) ? date1 : new Date(date1);
    d2 = angular.isDate(date2) ? date2 : new Date(date2);
    if (d1 && !d2) return 1; // d1 > d2
    if (!d1 && d2) return -1; // d1 < d2
    if (!d1 && !d2) return 0; // d1 == d2
    if (d1.getTime() > d2.getTime()) return 1;
    if (d1.getTime() < d2.getTime()) return -1;
    return 0;
  }
  $scope.getSelectedRows = function () {
    var api = $scope.params.gridApi;
    if (api && api.selection) {
      return api.selection.getSelectedRows();
    } else {
      return [];
    }
  };
  $scope.bulkEditorVisible = false;
  $scope.bulkEditConf = {
    dataGetter: function dataGetter(searchDate) {
      //recupero l'ultima versione dei dati selezionati nella grid
      var rows = $scope.getSelectedRows();
      if (rows.length) {
        var uuid_filters = {};
        for (var r in rows) {
          uuid_filters['uuid_' + r] = sixFiltersLib.exact('UUID', rows[r].UUID, sixFiltersLib.CONSTRAINTS.OR);
        }
        var filters = {
          "uuid": sixFiltersLib.must(uuid_filters)
        };
        var payload = {
          page_size: 10000,
          show_revision: true,
          currentDate: searchDate.toISOString()
        };
        return recordFactory($scope.typeName).search(payload, filters).$promise.then(function (results) {
          if (results.list) {
            return results.list;
          }
          return [];
        });
      } else {
        return [];
      }
    },
    factory: function factory(searchDate, payload) {
      return recordFactory($scope.typeName).bulkUpdate({
        dataIn: searchDate
      }, payload).$promise;
    },
    postSave: function postSave(result) {
      $scope.bulkEditorVisible = false;
      $scope.refresh();
    },
    cancel: function cancel() {
      $scope.bulkEditorVisible = false;
    },
    dateOptions: {}
  };
  historyLock.loadMinimumDate(currentCommission.code).then(function (minDate) {
    $scope.bulkEditConf.dateOptions = {
      minDate: minDate
    };
  });
  $scope.bulkEdit = function () {
    $scope.bulkEditorVisible = true;
  };

  /** *********************** **/
  /** ******* WATCHES ******* **/
  /** *********************** **/

  $scope.$watch('bool.viewCommissionData', function () {
    $scope.getType();
    localStorageService.set('record_bool', $scope.bool);
  });
  $scope.$watch('bool.viewCrossData', function () {
    $scope.getType();
    localStorageService.set('record_bool', $scope.bool);
  });
  $scope.$watchCollection(function (scope) {
    return $scope.type.selected;
  }, function (newVal, oldVal) {
    if ($scope.type && $scope.type.selected) {
      checkPermAndSetAce();
    }
  });
  $scope.$watchCollection(function (scope) {
    return $scope.type.selected ? $scope.type.selected.model : '';
  }, function (newVal, oldVal) {
    if ($scope.type && $scope.type.selected) {
      checkPermAndSetAce();
    }
  });
  $scope.$watchCollection(function (scope) {
    return $scope.type.selected ? $scope.type.selected.model.typeoperator_map : '';
  }, function (newVal, oldVal) {
    if ($scope.type && $scope.type.selected) {
      checkPermAndSetAce();
    }
  });
  $scope.$watchCollection(function (scope) {
    return $scope.type.selected ? $scope.type.selected.model.attachments : '';
  }, function (newVal, oldVal) {
    if ($scope.type && $scope.type.selected) {
      checkPermAndSetAce();
    }
  });
  $scope.$watchCollection(function (scope) {
    return $scope.commissions ? $scope.commissions.selected : '';
  }, function (newVal, oldVal) {
    if ($scope.commissions && $scope.commissions.selected) {
      if (!angular.equals(newVal, oldVal)) {
        checkPermAndSetAce();
      }
    }
  });
  $scope.$watchCollection(function (scope) {
    return $scope.customers ? $scope.customers.selected : '';
  }, function (newVal, oldVal) {
    if ($scope.customers && $scope.customers.selected) {
      if (!angular.equals(newVal, oldVal)) {
        checkPermAndSetAce();
      }
    }
  });
  $scope.$watch(function (scope) {
    return $scope.type.selected ? $scope.type.selected.dataIn : '';
  }, function (newVal, oldVal) {
    if ($scope.type && $scope.type.selected && $scope.type.selected.dataIn) {
      $scope.loadAdjacentVersions($scope.type.selected.UUID, $scope.type.selected.dataIn);
    }
  });
  var exclude = function exclude(key) {
    return !key.startsWith("$") && !key.startsWith("toJSON");
  };
  $scope.aceChanged = function (e) {
    $log.debug('aceChanged', e);
    if ($scope.type && $scope.type.selected) {
      //angular.extend($scope.type.selected, fixDates(JSON.parse($scope.aceModel)));
      try {
        var previous = JSON.parse($scope.aceModel);
      } catch (error) {
        if (!(error instanceof SyntaxError)) throw error;
      }
      var current = $scope.type.selected;
      var difference = diff.getDiff(current, previous, {
        strictNullCheck: false,
        doNotMatch: exclude
      });
      if (Object.keys(difference).length) {
        diff.applyDiff(current, difference);
        fixDates(current);
      }
    }
  };
  var timeout = undefined;
  function checkPermAndSetAce() {
    if (timeout) {
      $timeout.cancel(timeout);
      timeout = undefined;
    }
    timeout = $timeout(function () {
      $scope.savePerm = $scope.canSaveWithMsg();
      $scope.aceModel = JSON.stringify($scope.type.selected, null, '\t');
      timeout = undefined;
    }, 500); // così non viene chiamata 600 volte al millisecondo (ogni volta che cambia una cazzata)
  }

  /** ***********************************
   * Check permissions
   * ***********************************/

  $scope.isDrawingUploadAllowed = function () {
    return authFactory.isWritePermAllowed('drawing');
  };
  var RESOURCE_NAME = 'record/{entity}';
  $scope.isWritePermAllowed = function () {
    var session = sessionFactory.getSessionData();
    if ($scope.isListEditMode() && $scope.dataInDisabled() && !$scope.isNew()) {
      return false;
    }
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    var session = sessionFactory.getSessionData();
    if (!$scope.isCurrentVersion() && !$scope.isListEditMode() || $scope.isListEditMode() && $scope.dataInDisabled()) {
      return false;
    }
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
  $scope.isWriteVersionAllowed = function () {
    return authFactory.checkPerm(RESOURCE_NAME, 'MODIFY_HISTORY');
  };
  $scope.isUpdatePermAllowed = function () {
    return authFactory.isUpdatePermAllowed(RESOURCE_NAME);
  };
  $scope.isFutureInsertAllowed = function () {
    return authFactory.checkPerm(RESOURCE_NAME, 'FUTURE_INSERT');
  };
  $scope.canSaveWithMsg = function () {
    var perm = {
      perm: true
    };
    if (!$scope.isWritePermAllowed()) {
      // può salvare?
      perm = {
        perm: false,
        cause: 'Non hai i permessi per salvare nuovi dati'
      };
      return perm;
    }
    if (!isDataChanged()) {
      // sono state apportate modifiche alla versione che si vuole salvare?
      perm = {
        perm: false,
        cause: 'Non è stata fatta nessuna modifica ai dati: non c\'è nulla da salvare'
      };
      return perm;
    }
    if (!$scope.isListEditMode()) {
      if (!$scope.isCurrentVersion()) {
        // se è stata selezionata una versione dalla timeline ...
        if (!$scope.isWriteVersionAllowed()) {
          // può sovrascrivere versioni in timeline?
          perm = {
            perm: false,
            cause: 'Non hai i permessi per salvare dati in timeline'
          };
          return perm;
        }
        if (compareDates($scope.type.selected.dataIn, new Date()) > 0) {
          // se ho una dataIn nel futuro ...
          if (!$scope.isFutureInsertAllowed()) {
            // può salvare versioni future?
            perm = {
              perm: false,
              cause: 'Non hai i permessi per salvare dati nel futuro'
            };
            return perm;
          }
        }
      }

      // se sto cercando di creare una versione nel passato ...
      if ($scope.type.selected && $scope.type.selected.version // non è un nuovo documento
      && $scope.nextVersionInTimeline // ho una versione successiva nella timeline (=> sto inserendo una versione in mezzo alla timeline)
      && compareDates($scope.nextVersionInTimeline.dataIn, new Date()) < 0 // la versione successiva ha inizio validità nel passato (quindi sto inserendo una versione ancora più vecchia)
      && compareDates($scope.type.selected.dataIn, originalRecordDetail.dataIn) == 0 // non ho cambiato la dataIn di ciò che voglio salvare
      ) {
        perm = {
          perm: false,
          cause: 'Seleziona una data di inizio validità differente per abilitare il salvataggio'
        };
        return perm;
      }
    }
    return perm; // nulla da comunicare => può salvare
  };

  function checkRevisionMismatch() {
    if ($routeParams && $routeParams.editMode && $routeParams.type) {
      schemaFactory().byUUID({
        id: $routeParams.type
      }).$promise.then(function (schemaDefinition) {
        if (!schemaDefinition.model.history && $routeParams.editMode != 'stable') {
          toaster.pop('warning', "Attenzione", "Il salvataggio creerà una nuova versione per un tipo di asset non versionato!");
        } else if (schemaDefinition.model.history && $routeParams.editMode == 'stable') {
          toaster.pop('warning', "Attenzione", "Si sta visualizzzando un dato versionato in modalità \'STABLE\'," + " il salvataggio sovrascriverà la versione attuale del documento!");
        }
      });
    }
  }

  /** ***********************************
   * MAIN
   * ***********************************/

  var session = sessionFactory.getSessionData();
  if (session.currentDate) {
    $scope.date.currentDate = session.currentDate;
    if (!$scope.isNew()) {
      $scope.timelineFlags.showTimeline = true;
    }
  }

  // loadCommissionList();
  if ($routeParams.id) {
    if ($routeParams.version) {
      $scope.getRecordDetail($routeParams.id, $routeParams.version);
    } else {
      $scope.getRecordDetail($routeParams.id);
    }
    $scope.typeName = $routeParams.type;
    $scope.uuid = $routeParams.id;
    checkRevisionMismatch();
  } else {
    var logOut = $rootScope.bodyClass == 'login-six';
    if (!logOut) {
      $scope.getColumns();
    }
  }
}]);
'use strict';

/**
 * @ngdoc service
 * @name emma.dataset.baseFactory
 * @description
 * # baseFactory
 * Factory in the emma.dataset.
 */
angular.module('emma.dataset').factory('recordFactory', ["DATA_SET_URL", "$resource", function (DATA_SET_URL, $resource) {
  return function (type, param1) {
    return $resource(DATA_SET_URL + '/api/record/' + type + '/:verb/:id/:param1/:param2/:param3', {}, {
      query: {
        method: 'GET',
        isArray: false,
        ignoreLoadingBar: true
      },
      lookup: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_lookup'
        },
        ignoreLoadingBar: true
      },
      byUUID: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_uuid',
          param1: '_current'
        },
        ignoreLoadingBar: true
      },
      byDate: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_uuid'
        },
        ignoreLoadingBar: true
      },
      byID: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_id'
        },
        ignoreLoadingBar: true
      },
      byCode: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_code'
        },
        ignoreLoadingBar: true
      },
      getTimeline: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_uuid',
          param1: param1
        }
      },
      getAdjacent: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_uuid',
          param1: '_adjacent'
        }
      },
      getChanges: {
        method: 'POST',
        isArray: false,
        params: {
          verb: '_changes'
        }
      },
      search: {
        method: 'POST',
        isArray: false,
        params: {
          verb: '_search'
        },
        ignoreLoadingBar: true
      },
      filter: {
        method: 'POST',
        isArray: false,
        params: {
          verb: '_search'
        },
        ignoreLoadingBar: true
      },
      untypedSearch: {
        method: 'POST',
        isArray: false,
        params: {
          verb: '_untypedsearch'
        },
        ignoreLoadingBar: true
      },
      fetchAll: {
        method: 'POST',
        isArray: true,
        params: {
          verb: '_fetchall'
        },
        ignoreLoadingBar: true
      },
      select: {
        method: 'GET',
        isArray: true,
        ignoreLoadingBar: true
      },
      create: {
        method: 'POST'
      },
      bulk: {
        method: 'POST',
        isArray: true
      },
      bulkUpdate: {
        method: 'POST',
        isArray: false,
        params: {
          verb: '_bulk',
          param1: '_update'
        }
      },
      bulkImport: {
        method: 'POST',
        isArray: false,
        params: {
          verb: '_bulk'
        }
      },
      bulkResolveMC: {
        method: 'POST',
        isArray: false,
        params: {
          verb: '_bulk',
          param1: '_resolve',
          param2: '_multicommission'
        }
      },
      bulkResolve: {
        method: 'POST',
        isArray: false,
        params: {
          verb: '_bulk',
          param1: '_resolve'
        }
      },
      bulkResolveMcForward: {
        method: 'POST',
        isArray: false,
        params: {
          verb: '_bulk',
          param1: '_resolve',
          param2: '_multicommission',
          param3: '_forward'
        }
      },
      //multicommessa
      bulkFindList: {
        method: 'POST',
        isArray: true,
        params: {
          verb: '_bulk',
          param1: 'find',
          param2: 'list'
        }
      },
      //multicommessa e multicustomer
      show: {
        method: 'GET',
        ignoreLoadingBar: true
      },
      update: {
        method: 'PUT',
        params: {
          id: '@version'
        },
        ignoreLoadingBar: true
      },
      "delete": {
        method: 'DELETE',
        params: {
          id: '@version'
        },
        ignoreLoadingBar: true
      },
      deleteByQuery: {
        method: 'POST',
        isArray: false,
        params: {
          verb: '_delete'
        },
        ignoreLoadingBar: true
      },
      hardDelete: {
        method: 'DELETE',
        params: {
          verb: '_hard',
          id: '@version'
        },
        ignoreLoadingBar: true
      },
      check: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_check'
        }
      },
      fixAll: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_fix',
          param1: 'all'
        }
      },
      fixDataOut: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_fix',
          param1: 'dataout',
          param2: '@uuid'
        }
      },
      unique: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_unique'
        }
      },
      referenceCount: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_referencecount'
        },
        ignoreLoadingBar: true
      },
      fixTimeline: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_fix',
          param1: 'timeline',
          param2: '@uuid'
        },
        ignoreLoadingBar: true
      },
      checkTimeline: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_check',
          param1: 'timeline',
          param2: '@uuid'
        },
        ignoreLoadingBar: true
      }
    });
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:VettoreEnergeticoCtrl
 * @description
 * # VettoreEnergeticoCtrl
 * Controller of the sixEmmaApp
 */

/**
 * XXX N.B. Il controller principale resta RecordCtrl. Quì c'è solo la logica per i fattori di conversione tra UM
 */
angular.module('emma.dataset')
// La route è configurata in dataset/record/record.js
.controller('VettoreEnergeticoCtrl', ["$scope", function ($scope) {
  $scope.pciUm = function (um1, um2) {
    return um1 + '/' + um2;
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name emma.theme.controller:MappingDetailCtrl
 * @description
 * # MappingDetailCtrl
 * Controller of the emma.dataset
 */
angular.module('emma.dataset').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/mapping/:uuid', {
    templateUrl: 'dataset/rolemapping/mappingdetail.html',
    controller: 'MappingDetailCtrl'
  });
}]).controller('MappingDetailCtrl', ["APP_URL", "$scope", "authFactory", "$location", "sysConfigFactory", "$routeParams", "toaster", "ENV", "DEV", function (APP_URL, $scope, authFactory, $location, sysConfigFactory, $routeParams, toaster, ENV, DEV) {
  var TYPE = 'rolemapping';
  $scope.mapping = {
    model: {
      emma_role_id: undefined,
      ldap_groups: []
    }
  };
  function loadMapping(uuid) {
    sysConfigFactory(TYPE).byUUID({
      id: uuid
    }).$promise.then(function (response) {
      if (response && response.model) {
        $scope.mapping = response;
      } else {
        toaster.pop('error', 'Errore', 'Errore durante il caricamento del dato \'' + uuid + '\'');
      }
    });
  }
  $scope.update = function () {
    var params = {
      commission_dependent: false,
      customer_dependent: false,
      history: false
    };
    if ($scope.mapping.version) {
      sysConfigFactory(TYPE).update({
        id: $scope.mapping.version,
        history: false
      }, $scope.mapping).$promise.then(function (response) {
        toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
        $scope.goToMappingList();
      })["catch"](function (rejection) {
        toaster.pop('error', 'Errore salvataggio', rejection.data.message ? rejection.data.message : rejection.statusText);
      });
    } else {
      $scope.mapping.model.code = sixObjectLib.makeGUID();
      $scope.mapping.model.description = 'Mapping per il ruolo ' + $scope.mapping.model.emma_role_id.description;
      sysConfigFactory(TYPE).create(params, $scope.mapping.model).$promise.then(function (response) {
        toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
        $scope.goToMappingList();
      })["catch"](function (rejection) {
        toaster.pop('error', 'Errore salvataggio', 'Si è verificato un errore durante il salvataggio');
      });
    }
  };
  $scope.clearLdapGroup = function () {
    $scope.mapping.model.ldap_groups = [];
  };
  $scope.goToMappingList = function () {
    $location.path('mapping');
  };

  // ***** _main ***** //
  if ($routeParams.uuid !== 'new') {
    loadMapping($routeParams.uuid);
  } else {
    $scope.mapping = {
      model: {
        emma_role: undefined,
        ldap_groups: []
      }
    };
  }
}]);
'use strict';

/**
 * @ngdoc function
 * @name emma.theme.controller:MappingCtrl
 * @description
 * # MappingCtrl
 * Controller of the emma.dataset
 */
angular.module('emma.dataset').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/mapping', {
    templateUrl: 'dataset/rolemapping/mappinglist.html',
    controller: 'MappingCtrl'
  });
}]).controller('MappingCtrl', ["APP_URL", "$scope", "authFactory", "sysConfigFactory", "$routeParams", "$location", "sixGridPaginationConstants", "uiGridConstants", "ENV", "DEV", function (APP_URL, $scope, authFactory, sysConfigFactory, $routeParams, $location, sixGridPaginationConstants, uiGridConstants, ENV, DEV) {
  $scope.rows = {
    list: [],
    totalResults: 0
  };
  $scope.params = {
    pageNumber: 0,
    pageSize: 10,
    filters: {}
  };
  $scope.viewGridOptions = {
    enableFiltering: true,
    enableOrdering: true,
    showGridFooter: true,
    showColumnFooter: true,
    enableHorizontalScrollbar: 1,
    columnDefs: [{
      name: ' '
    }]
  };
  $scope.gridAppCallbacks = {};
  function initGridColumns() {
    $scope.viewGridOptions.columnDefs = [];
    $scope.viewGridOptions.columnDefs.push({
      displayName: '',
      field: 'id',
      width: 36,
      enableCellEdit: true,
      enableFiltering: false,
      enableSorting: false,
      cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/mapping/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' + '<span class="fa fa-search"></span>' + '</a>' + '</div>'
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Emma',
      field: 'model.emma_role_id.description',
      enableFiltering: true,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'LDAP',
      field: 'model.ldap_role',
      enableFiltering: true,
      cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<span>{{grid.appScope.concatLdapGroups(row.entity.model.ldap_groups)}}</span>' + '</div>',
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
  }
  $scope.getList = function () {
    var payload = {
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      cross: true,
      history: false
    };
    return sysConfigFactory('rolemapping').search(payload, $scope.params.filters).$promise.then(function (result) {
      $scope.rows.list = result.list || [];
      $scope.rows.totalResults = result.totalResults;
      $scope.params.sixApi.refreshList(result.list);
      return result;
    });
  };
  $scope.concatLdapGroups = function (groups) {
    var concat = '';
    var sep = '';
    groups.forEach(function (g) {
      concat += sep + g.code;
      sep = '; ';
    });
    return concat;
  };
  $scope.gridAppCallbacks['concatLdapGroups'] = $scope.concatLdapGroups;
  $scope.goToNewMapping = function () {
    $location.path('mapping/new');
  };
  initGridColumns();
  // $scope.getList();
}]);
"use strict";

angular.module('emma.dataset').directive('sixCommissionMapper', ["$window", function ($window) {
  return {
    restrict: 'A',
    bindToController: {
      sixCommissionMapper: '='
    },
    controllerAs: 'sixCm',
    controller: 'CommissionMapperController'
  };
}]);
angular.module('emma.dataset').controller('CommissionMapperController', ['$scope', 'commissionFactory', function ($scope, commissionFactory) {
  var ctrl = this;

  /* INIT */
  if (!ctrl.sixCommissionMapper) ctrl.sixCommissionMapper = {};
  $scope.keys = {};
  $scope.allCommissions = [];
  $scope.freeCommissions = [];
  commissionFactory().getCommissionsList({
    page_size: 100
  }).$promise.then(function (response) {
    if (response.totalResults) {
      $scope.allCommissions = response.list;
      $scope.allCommissions.push({
        code: "tutte",
        description: "Tutte le commesse"
      });
      angular.forEach(ctrl.sixCommissionMapper, function (role, commission) {
        $scope.keys[commission] = commission;
      });
      response.list.forEach(function (val) {
        if (!$scope.keys.hasOwnProperty(val.code)) {
          $scope.freeCommissions.push(val.code);
        }
      });
    }
  });
  $scope.updateCommission = function (oldCommission, newCommission) {
    ctrl.sixCommissionMapper[newCommission] = ctrl.sixCommissionMapper[oldCommission];
    $scope.keys[newCommission] = newCommission;
    delete ctrl.sixCommissionMapper[oldCommission];
    $scope.freeCommissions.splice($scope.freeCommissions.indexOf(newCommission), 1);
    $scope.freeCommissions.push(oldCommission);
  };
  $scope.removeCommission = function (commission) {
    delete ctrl.sixCommissionMapper[commission];
    $scope.freeCommissions.push(commission);
  };
  $scope.addMapping = function () {
    if (!ctrl.sixCommissionMapper) {
      ctrl.sixCommissionMapper = {};
    }
    if ($scope.freeCommissions.length > 0) {
      var commission = $scope.freeCommissions.pop();
      ctrl.sixCommissionMapper[commission] = undefined;
      $scope.keys[commission] = commission;
    }
  };
}]);
angular.module('schemaForm').config(["schemaFormDecoratorsProvider", "sfBuilderProvider", function (schemaFormDecoratorsProvider, sfBuilderProvider) {
  schemaFormDecoratorsProvider.defineAddOn('bootstrapDecorator', 'commissionmapper', 'dataset/schema-form/commission-mapper.html', sfBuilderProvider.stdBuilders);
}]);
"use strict";

angular.module('schemaForm').config(["schemaFormProvider", "sfPathProvider", function (schemaFormProvider, sfPathProvider) {
  var datepicker = function datepicker(name, schema, options) {
    if (schema.type === 'string' && (schema.format === 'date' || schema.format === 'date-time')) {
      var f = schemaFormProvider.stdFormObj(name, schema, options);
      f.key = options.path;
      f.type = 'datepicker';

      // opzioni di default aggiunte per vedere mese,anno e per avere la data formata in datetime
      f.selectMonths = true;
      f.selectYears = 50;
      f.format = "yyyy-mm-ddT00:00:00.000Z";
      options.lookup[sfPathProvider.stringify(options.path)] = f;
      return f;
    }
  };

  // Put it first in the list of functions
  schemaFormProvider.defaults.string.unshift(datepicker);
}]);
'use strict';

angular.module('emma.dataset').directive('sxFile', function () {
  return {
    restrict: 'A',
    controller: 'SixFileController'
  };
}).controller('SixFileController', ["$scope", "$timeout", "$log", "$q", "FileUploader", "toaster", "dialogService", "alfrescoFactory", "authFactory", "ALFRESCO_URL", "ENV", function ($scope, $timeout, $log, $q, FileUploader, toaster, dialogService, alfrescoFactory, authFactory, ALFRESCO_URL, ENV) {
  var DESTINATION = "/Sites/".concat(ENV, "/").concat(authFactory.getAuthData().info.commissions.current.code);
  $scope.uploader = new FileUploader({
    url: ALFRESCO_URL + '/upload',
    removeAfterUpload: true,
    autoUpload: true,
    formData: [{
      destination: DESTINATION
    }],
    onSuccessItem: function onSuccessItem(fileItem, response, status, headers) {
      if (angular.isDefined(response.ERROR)) {
        toaster.error('Errore nel caricamento del file', response.ERROR);
      } else {
        $log.debug('Uploaded file', fileItem);
        if ($scope.model[$scope.form.key[0]]) {
          doRemove($scope.model[$scope.form.key[0]].object_id)["finally"](function () {
            return doSave({
              title: fileItem.file.name,
              date_insertion: new Date(),
              destination: DESTINATION,
              object_id: response.objectId
            });
          });
        } else {
          doSave({
            title: fileItem.file.name,
            date_insertion: new Date(),
            destination: DESTINATION,
            object_id: response.objectId
          });
        }
      }
    },
    onErrorItem: function onErrorItem(fileItem, response, status, headers) {
      $log.error('while upload', response, fileItem);
      toaster.error('Errore nel caricamento del file', response.ERROR);
    }
  });
  $scope.loadFile = function () {
    if ($scope.model[$scope.form.key[0]]) {
      dialogService.confirmDialog("<b>Attenzione</b><br/>\n          Allegare un nuovo file comporter\xE0 la sovrascrittura del file \"".concat($scope.model[$scope.form.key[0]].title, "\".<br />\n          Vuoi continuare?"), function () {
        return angular.element("#".concat($scope.fieldId())).trigger('click');
      }, angular.identity);
    } else {
      angular.element("#".concat($scope.fieldId())).trigger('click');
    }
  };
  $scope.removeFile = function (fileId) {
    return dialogService.confirmDialog('<b>Attenzione</b><br/>Una volta eliminato il file non potrà più essere recuperato.<br/>Vuoi continuare?', function () {
      return doRemove(fileId)["finally"](doSave);
    });
  };
  $scope.getDownloadLink = function () {
    var objId = $scope.model[$scope.form.key[0]].object_id;
    if (objId) {
      return "".concat(ALFRESCO_URL, "/api/alfresco/").concat(objId.replace('workspace://SpacesStore/', '$WorkspaceSpacesStore$'));
    }
  };
  $scope.fieldId = function () {
    return angular.isArray($scope.form.key) ? $scope.form.key.join('-') : $scope.form.key;
  };
  function doSave(fileItem) {
    $scope.model[$scope.form.key[0]] = fileItem;
    $timeout(function () {
      return angular.element("#".concat($scope.fieldId(), "submit")).trigger('click');
    }, 200);
  }
  function doRemove(fileId) {
    if (fileId) {
      return alfrescoFactory["delete"]({
        id: fileId.replace('workspace://SpacesStore/', '$WorkspaceSpacesStore$')
      }).$promise;
    }
    return $q.resolve();
  }
}]);
angular.module('schemaForm').config(["schemaFormDecoratorsProvider", "sfBuilderProvider", function (schemaFormDecoratorsProvider, sfBuilderProvider) {
  schemaFormDecoratorsProvider.defineAddOn('bootstrapDecorator', 'file', 'dataset/schema-form/file-field.html', sfBuilderProvider.stdBuilders);
}]);
"use strict";

angular.module('emma.dataset').directive('sixNestedReference', ["$window", function ($window) {
  return {
    restrict: 'A',
    bindToController: {
      sixNestedReference: '='
    },
    controllerAs: 'sixNr',
    controller: 'NestedReferenceController'
  };
}]);
angular.module('emma.dataset').controller('NestedReferenceController', ['$scope', function ($scope) {
  var ctrl = this;

  /* INIT */
  if (!ctrl.sixNestedReference) ctrl.sixNestedReference = [];

  //creo una 'shortcut' per poter riempire la lookup mantenedo un minimo di leggibilità nel html
  $scope.costCenterSchema = $scope.form.schema.items.properties.cost_center;
  $scope.partitionSchema = $scope.form.schema.items.properties.partition;
  $scope.removeReference = function (reference) {
    //line 18
    ctrl.sixNestedReference = ctrl.sixNestedReference.filter(function (item) {
      return item != reference;
    });
  };
  $scope.addReference = function () {
    //line 3
    ctrl.sixNestedReference.push({
      cost_center: undefined,
      partition: 1
    });
  };
}]);
angular.module('schemaForm').config(["schemaFormDecoratorsProvider", "sfBuilderProvider", function (schemaFormDecoratorsProvider, sfBuilderProvider) {
  schemaFormDecoratorsProvider.defineAddOn('bootstrapDecorator', 'nestedreference', 'dataset/schema-form/nested-reference.html', sfBuilderProvider.stdBuilders);
}]);
"use strict";

/**
 * @ngdoc service
 * @name emma.dataset.historyLock
 * @description
 * Determina la data limite per le modifiche nel passato
 * Service in the emma.dataset.
 */
angular.module('emma.dataset').factory('historyLock', ["$rootScope", "authFactory", "$q", "$injector", function ($rootScope, authFactory, $q, $injector) {
  var historyLock = {};
  var minDate = new Date(-8640000000000000);
  var cachedMinimumDate = {}; //TODO: gestire una qualche forma di invalidazione della data

  //aggancio il precaricamento della data minima al cambio commessa
  $rootScope.$watchCollection(function () {
    return authFactory.getAuthData();
  }, function (newValue, oldValue) {
    if (authFactory.getAuthData().info.commissions.current.code) {
      historyLock.loadMinimumDate(authFactory.getAuthData().info.commissions.current.code);
    }
  });
  historyLock.loadMinimumDate = function (commission) {
    if (Array.isArray(commission)) {
      commission = commission[0];
    }
    cachedMinimumDate[commission] = minDate;

    //se il plan è disponibile, la data minima è determinata dalla fatturazione
    if ($rootScope.frontEndInfo && $rootScope.frontEndInfo.installedmodules && $rootScope.frontEndInfo.installedmodules.indexOf("six-plan") != -1) {
      if ($injector.has("invoiceFactory")) {
        return $injector.get("invoiceFactory").getLatestDate({
          'commission': commission,
          'approved': true
        }).$promise.then(function (response) {
          cachedMinimumDate[commission] = new Date(response.date);
          return cachedMinimumDate[commission];
        });
      }
    }
    return $q.resolve(cachedMinimumDate[commission]);
  };

  //se la data non è stata precaricata, restituirà il valore di default (minDate)
  historyLock.getMinimumDate = function (commission) {
    var date = minDate;
    if (!commission) {
      date = new Date();
      //se è un dato cross commessa non permetto la modifica della storia
      //FIXME: idealmente bisognerebbe cercare il MAX delle minimumDate su tutte le commesse
    }

    if (Array.isArray(commission)) {
      commission = commission[0]; //FIXME: idealmente andrebbe cercato il max tra le varie commesse
    }

    if (cachedMinimumDate[commission]) {
      date = cachedMinimumDate[commission];
    } else {
      historyLock.loadMinimumDate(commission); //precarico per il futuro
    }

    return date;
  };
  return historyLock;
}]);
'use strict';

/**
 * @ngdoc service
 * @name emma.dataset.baseFactory
 * @description
 * # baseFactory
 * Factory in the emma.dataset.
 */
angular.module('emma.dataset').factory('sysConfigFactory', ["DATA_SET_URL", "$resource", function (DATA_SET_URL, $resource) {
  return function (type, param1, param2) {
    return $resource(DATA_SET_URL + '/api/sysconfig/' + type + '/:verb/:id/:param1/:param2/:param3', {}, {
      query: {
        method: 'GET',
        isArray: false,
        ignoreLoadingBar: true
      },
      lookup: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_lookup'
        },
        ignoreLoadingBar: true
      },
      byUUID: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_uuid',
          param1: '_current'
        },
        ignoreLoadingBar: true
      },
      byDate: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_uuid'
        },
        ignoreLoadingBar: true
      },
      byID: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_id'
        },
        ignoreLoadingBar: true
      },
      byCode: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_code'
        },
        ignoreLoadingBar: true
      },
      getTimeline: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_uuid',
          param1: param1
        }
      },
      search: {
        method: 'POST',
        isArray: false,
        params: {
          verb: '_search'
        },
        ignoreLoadingBar: true
      },
      filter: {
        method: 'POST',
        isArray: false,
        params: {
          verb: '_search'
        },
        ignoreLoadingBar: true
      },
      select: {
        method: 'GET',
        isArray: true,
        ignoreLoadingBar: true
      },
      create: {
        method: 'POST'
      },
      bulk: {
        method: 'POST',
        isArray: true
      },
      bulkImport: {
        method: 'POST',
        isArray: false,
        params: {
          verb: '_bulk',
          param1: param1,
          param2: param2
        }
      },
      bulkResolveMC: {
        method: 'POST',
        isArray: false,
        params: {
          verb: '_bulk',
          param1: '_resolve',
          param2: '_multicommission'
        }
      },
      bulkResolve: {
        method: 'POST',
        isArray: false,
        params: {
          verb: '_bulk',
          param1: '_resolve'
        }
      },
      show: {
        method: 'GET',
        ignoreLoadingBar: true
      },
      update: {
        method: 'PUT',
        params: {
          id: '@version'
        },
        ignoreLoadingBar: true
      },
      "delete": {
        method: 'DELETE',
        params: {
          id: '@version'
        },
        ignoreLoadingBar: true
      },
      check: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_check'
        }
      },
      fixAll: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_fix',
          param1: 'all'
        }
      },
      unique: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_unique'
        }
      }
    });
  };
}]);
'use strict';

angular.module('emma.dataset').controller('sixTimelineCtrl', ["$scope", "$log", "$q", "toaster", "dialogService", "modelIconService", function ($scope, $log, $q, toaster, dialogService, modelIconService) {
  /** ********* **/
  /** Variables **/
  /** ********* **/

  var ctrl = this;
  ctrl.treePaths = [];
  this.EVENTS = {
    DATE_SELECTED: 'date_selected',
    VERSION_SELECTED: 'version_selected',
    CHANGED_EXTERNALLY: 'changed_externally'
  };
  ctrl.timeline;
  ctrl.selected;
  ctrl.date = {
    currentDate: undefined
  };
  if (angular.isUndefined(ctrl.historyPerm)) {
    ctrl.historyPerm = true;
  }

  // default options
  ctrl.opts = {
    datePickerEnabled: true
  };
  angular.merge(ctrl.opts, ctrl.options); // sostituisco i valori di default con quelli passati al componente

  function buildTreeInfoPaths(timelineList) {
    if (timelineList) {
      var treePaths = undefined;
      ctrl.treePaths.length = 0;
      timelineList.forEach(function (timeline) {
        if (timeline.parents && timeline.parents.length) {
          treePaths = {};
          timeline.parents.forEach(function (p) {
            var path = treePaths[p.treeCode] || [];
            // ci metto dentro tutte le info del nodo
            path.push(p);
            treePaths[p.treeCode] = path;
          });
        }
        ctrl.treePaths.push(treePaths);
      });
    }
  }

  // Recupera l'icona del model da menu
  $scope.getModelIcon = function (modelName) {
    $log.debug('getModelIcon: ' + modelName);
    var icon = modelIconService.getModelIcon(modelName) || 'fa fa-circle-o';
    return 'fa-fw ' + icon;
  };

  /** ******************* **/
  /** Timeline retrieving **/
  /** ******************* **/

  ctrl.reloadTimeline = function () {
    $log.debug('Reloading timeline');
    if (angular.isFunction(ctrl.getTimeline)) {
      ctrl.getTimeline().then(function (data) {
        ctrl.timeline = data.list;
        buildTreeInfoPaths(data.list);
      });
    } else {
      $log.error('No loadTimeline function provided!!');
    }
  };

  /** ***************** **/
  /** Version selection **/
  /** ***************** **/

  function select(item, event, changeCurrentDate) {
    $log.debug('Version selected', item);
    ctrl.selected = item;
    if (ctrl.selected && changeCurrentDate) {
      ctrl.date.currentDate = new Date(ctrl.selected.dataIn);
      ctrl.changeCurrentDate(ctrl.date.currentDate, ctrl.EVENTS.VERSION_SELECTED);
    }
    if (angular.isFunction(ctrl.onSelect)) {
      ctrl.onSelect({
        value: item,
        event: event
      });
    }
  }
  ctrl.onClickedVersion = function (item) {
    select(item, ctrl.EVENTS.VERSION_SELECTED, true);
  };

  /** **** **/
  /** Save **/
  /** **** **/

  ctrl.save = function (item) {
    $log.debug('Calling version save', item);
    if (angular.isFunction(ctrl.onSave)) {
      ctrl.onSave({
        value: item
      });
    }
  };

  /** ****** **/
  /** Delete **/
  /** ****** **/

  ctrl["delete"] = function (item) {
    $log.debug('Calling version delete', item);
    if (angular.isFunction(ctrl.onDelete)) {
      ctrl.onDelete({
        value: item
      });
    }
  };

  /** ************* **/
  /** Date changing **/
  /** ************* **/

  /**
   * @param currentDate
   * @param event:  'version_selected' se la data è cambiata in conseguenza alla selezione di una versione in timeline,
   *                'date_selected' se la data è stata selezionata tramite dateTimePicker
   */
  ctrl.changeCurrentDate = function (currentDate, event) {
    $log.debug('Date changed', currentDate);
    if (angular.isFunction(ctrl.onDateChanged)) {
      ctrl.onDateChanged({
        value: currentDate,
        event: event
      });
    }
  };

  /** ********************** **/
  /** Timeline check and fix **/
  /** ********************** **/

  ctrl.checkTimeline = function () {
    $log.debug('Calling checkTimeline');
    if (angular.isFunction(ctrl.onCheckTimeline)) {
      ctrl.onCheckTimeline().then(function (resp) {
        if (resp) {
          ctrl.reloadTimeline();
          dialogService.serviceResponse('Fix timeline', resp);
        } else {
          toaster.pop('error', 'Errore', 'Non è stato possibile completare l\'operazione');
        }
      });
    }
  };
  ctrl.fixTimeline = function () {
    $log.debug('Calling fixTimeline');
    if (angular.isFunction(ctrl.onFixTimeline)) {
      ctrl.onFixTimeline().then(function (resp) {
        if (resp) {
          ctrl.reloadTimeline();
          dialogService.serviceResponse('Fix timeline', resp);
        } else {
          toaster.pop('error', 'Errore', 'Non è stato possibile completare l\'operazione');
        }
      });
    }
  };

  /** ********* **/
  /** Listeners **/
  /** ********* **/

  $scope.$on('sixtimeline:refresh', function (event) {
    ctrl.reloadTimeline();
  });
  $scope.$watch(function () {
    return ctrl.extSelected;
  }, function (newVal, oldVal) {
    if (ctrl.extSelected && ctrl.extSelected.version) {
      select(ctrl.extSelected, ctrl.EVENTS.CHANGED_EXTERNALLY, false);
    }
  });

  /** **** **/
  /** Init **/
  /** **** **/

  ctrl.reloadTimeline();
}]);

/**
 * @ngdoc directive
 * @name emma.dataset.component:sixTimeline
 * @description
 * # sixTimeline
 *
 * options = {
 *   datePickerEnabled: boolean - abilita/disabilita la selezione di una data per cercare la corrispondente versione valida
 * };
 */
angular.module('emma.dataset').component('sixTimeline', {
  controller: 'sixTimelineCtrl',
  templateUrl: 'dataset/timeline/templates/sixtimeline.html',
  restrict: 'E',
  bindings: {
    options: '<',
    // options del componente
    historyPerm: '<',
    // permessi per scrivere nella storia
    extSelected: '<',
    // documento selezionato dall'esterno
    getTimeline: '&',
    // getTimeline function  - chiamata per recuperare la timeline (must return a $promise and an object {list: []})
    onSelect: '&?',
    // select callback - chiamata quando viene selezionata una versione
    onSave: '&?',
    // save callback - chiamata quando viene premuto il pulsante di salvataggio versione
    onDelete: '&?',
    // delete callback - chiamata quando viene premuto il pulsante di eliminazione versione
    onDateChanged: '&?',
    // dateChanged callback - chiamata quando viene cambiata la data tramite dateTimePicker
    onCheckTimeline: '&?',
    // check timeline callback - chiamata quando viene premuto il pulsante di check timeline
    onFixTimeline: '&?' // fix timeline callback - chiamata quando viene premuto il pulsante di fix timeline
  }
});
'use strict';

/**
 * @ngdoc function
 * @name emma.dataset.controller:TimelineCtrl
 * @description
 * # TimelineCtrl
 * Controller of the emma.dataset
 */
angular.module('emma.dataset').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/timeline/:basePath/:entity/:UUID', {
    templateUrl: 'dataset/timeline/timeline.html',
    controller: 'TimelineCtrl'
  }).when('/timeline/:entity/:UUID', {
    templateUrl: 'dataset/timeline/timeline.html',
    controller: 'TimelineCtrl'
  }).when('/timeline/:basePath/:entity/:UUID/v/:version', {
    templateUrl: 'dataset/timeline/timeline.html',
    controller: 'TimelineCtrl'
  }).when('/timeline/:entity/:UUID/v/:version', {
    templateUrl: 'dataset/timeline/timeline.html',
    controller: 'TimelineCtrl'
  });
}]).controller('TimelineCtrl', ["$scope", "$routeParams", "schemaFactory", "authFactory", "recordFactory", function ($scope, $routeParams, schemaFactory, authFactory, recordFactory) {
  var currentCommission = authFactory.getAuthData().info.commissions.current;
  $scope.data = {};
  $scope.model = {};
  $scope.treePaths = undefined;
  $scope.timeline = [];
  var basePath = $routeParams.basePath || 'record';
  var schemaBasePath = $routeParams.basePath ? $routeParams.basePath + '/' : '';
  $scope.getTimeline = function () {
    if (angular.isDefined($routeParams.entity) && angular.isDefined($routeParams.UUID)) {
      var buildPromise = $scope.buildTimeline($routeParams.entity, $routeParams.UUID, $routeParams.version);
      if (angular.isDefined($routeParams.version)) {
        buildPromise.then(function () {
          $scope.getModelDetail($routeParams.version);
        });
      }
    }
  };
  $scope.buildTimeline = function (entity, UUID, version) {
    $scope.entity = entity;
    $scope.timeline = recordFactory(entity, UUID).getTimeline().$promise.then(function (data) {
      $scope.timeline = data.list;
      if (angular.isDefined(version)) {
        $scope.model['version'] = version;
      }
    });
    return $scope.timeline;
  };
  $scope.getModelDetail = function (version) {
    $scope.treePaths = undefined;
    recordFactory($routeParams.entity, version).byID({
      id: version
    }).$promise.then(function (data) {
      $scope.data = data;
      $scope.model.version = data.version;
      if ($scope.data.parents && $scope.data.parents.length > 0) {
        $scope.treePaths = {};
        $scope.data.parents.forEach(function (p) {
          var path = $scope.treePaths[p.treeCode] || [];
          path.push(p.code);
          $scope.treePaths[p.treeCode] = path;
        });
      }
      if (angular.isDefined(data.creationDate) && data.creationDate) {
        // elimino i millisecondi dalla visualizzazione
        var date = new Date(data.creationDate);
        data.creationDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
      }
      if (angular.isDefined(data.dataIn) && data.dataIn) {
        // elimino i millisecondi dalla visualizzazione
        var date = new Date(data.dataIn);
        data.dataIn = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
      }
      var schemaData = '_current';
      if (angular.isDefined(data.dataOut) && data.dataOut) {
        schemaData = data.dataOut;
        // elimino i millisecondi dalla visualizzazione
        var date = new Date(data.dataOut);
        data.dataOut = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
      }
      schemaFactory().getSchema({
        id: data.schemaCode,
        param1: schemaData
      }).$promise.then(function (response) {
        $scope.showDetail = true;
        $scope.schema = response.model.schema;
        $scope.form = response.model.form;
      });
    });
  };
  $scope.getTimeline();
}]);
'use strict';

(function () {
  /**** CONSTANTS ****/

  var SCHEMA = 'schema'; // endpoint per le entity
  var TREE = 'tree'; // endpoint per i tree
  var RECORD = 'record'; // endpoint per le istanze di entity
  var PREFIX = 'def'; // prefisso del code del tree nell'indice
  var DEFAULT_DIALOG_TIMEOUT = 4000;
  var COPY_DIALOG_TIMEOUT = 2000;
  var CHILDREN_FIELD_NAME = 'nodes';
  var PARENTS_FIELD_NAME = 'parents';
  var TREETYPE = 'definition';

  /**** COMMON FUNCTIONS ****/

  // Comparatore di oggetti record e schema
  var record2SchemaComparator = function record2SchemaComparator(node1, node2) {
    if (node1 && node2 && node1.type === node2.model.code) {
      return true;
    }
    return false;
  };

  // Comparatore di oggetti record
  var record2RecordComparator = function record2RecordComparator(node1, node2) {
    if (node1 && node2 && node1.UUID === node2.UUID) {
      return true;
    }
    return false;
  };

  /**** ANGULAR ****/

  /**
   * @ngdoc function
   * @name emma.dataset.controller:TreeCtrl
   * @description
   * # TreeCtrl
   * Controller of the emma.dataset
   */
  var app = angular.module('emma.dataset');
  app.config(["$routeProvider", "treeConfig", function ($routeProvider, treeConfig) {
    $routeProvider.when('/tree', {
      templateUrl: 'dataset/tree/tree.html',
      controller: 'TreeCtrl',
      controllerAs: 'treeController'
    }).when('/tree/:viewMode', {
      templateUrl: 'dataset/tree/tree.html',
      controller: 'TreeCtrl'
    });
    treeConfig.defaultCollapsed = true; // collapse nodes by default
  }]);

  app.controller('TreeCtrl', ["$scope", "$routeParams", "$location", "treeFactory", "recordFactory", "schemaFactory", "$filter", "$log", "authFactory", "counterFactory", "dialogService", "treeService", "modelIconService", "errorService", "toaster", "pipeConfigurationTree", "treePlanConfigFactory", "$q", "$timeout", "sixGridPaginationConstants", "uiGridConstants", "sessionFactory", "assetcalendarFactory", function ($scope, $routeParams, $location, treeFactory, recordFactory, schemaFactory, $filter, $log, authFactory, counterFactory, dialogService, treeService, modelIconService, errorService, toaster, pipeConfigurationTree, treePlanConfigFactory, $q, $timeout, sixGridPaginationConstants, uiGridConstants, sessionFactory, assetcalendarFactory) {
    var currentCommission = authFactory.getAuthData().info.commissions.current;
    $scope.currentCustomer = authFactory.getCurrentCustomer();
    var TREE_CODE = getTreeCode();
    $scope.showRecordsList = false; // flag per mostrare/nascondere la lista dei record
    $scope.showDetails = false; // flag per mostrare/nascondere i dettagli del record selezionato
    $scope.rightSidebarSize = '50';
    $scope.searchInput = {
      text: undefined
    }; // Oggetto che contiene i filtri di ricerca
    $scope.searchInputInTree = {
      text: undefined,
      depth: 0
    }; // Oggetto che contiene i filtri di ricerca nel tree

    $scope.tree = {
      wrapper: {
        model: {
          nodes: [],
          type: TREETYPE
        }
      },
      // wrapper che arriva dall'endpoint che fornisce l'albero richiesto
      structure: {},
      // struttura dell'albero creata tramite il tree configurator
      loaded: false,
      structureLoaded: false
    };
    $scope.viewMode = $routeParams.viewMode;
    $scope.treeCollapsed = true;
    $scope.records = {
      list: [],
      // lista non filtrata delle entity ammesse nel nodo selezionato
      loaded: false
    };
    $scope.commissionDependent = false;
    $scope.historyMode = 'snap';

    // Record da aggiungere "inline" da questa pagina
    $scope.record = emptyRecord();
    $scope.typeDescription = undefined;
    $scope.selected = {
      treeNode: undefined,
      // Nodo dell'albero correntemente selezionato
      records: [] // Record correntemente selezionati (selezione multipla)
    };

    $scope.dropdownList = {
      roots: [],
      // Lista delle radici che è possibile creare ex-novo
      nodes: [] // Lista dei nodi che è possibile creare ex-novo in base all'elemento del tree selezionato
    };

    $scope.selfGeneratedCode = {
      codeNameSix: '',
      active: false
    };
    $scope.searchInputInTree.depth = 1;
    $scope.selectDestination = false;
    $scope.nodeToCopy = undefined;
    $scope.nodeList = {
      list: []
    };
    $scope.date = {
      currentDate: undefined,
      lastDate: undefined
    };
    $scope.calendar = {
      show: false,
      withClosedChilds: {},
      data: {}
    };
    $scope.params = {
      pageNumber: 1,
      pageSize: 25,
      filters: {}
    };
    $scope.viewGridOptions = {
      enableSorting: true,
      enableGridMenu: true,
      exporterCsvColumnSeparator: ';',
      exporterSuppressColumns: ['id', 'timeline'],
      exporterMenuPdf: false,
      enableFiltering: true,
      enableHorizontalScrollbar: 2,
      enableColumnResizing: true,
      paginationPageSizes: [25, 50, 100, 500],
      paginationPageSize: 25,
      useExternalPagination: true,
      useExternalFiltering: true,
      enableRowHeaderSelection: true,
      enableRowSelection: true,
      rowHeight: 60,
      columnDefs: [{
        name: ' '
      }]
    };
    $scope.autoResizeParams = {
      enabled: true,
      minHeight: 200,
      marginTop: 290
    };
    $scope.refresh = function () {
      $scope.getTree();
      $scope.getColumns();
      if ($scope.viewMode == 'grid') {
        $scope.getNodesList();
      }
    };
    $scope.getColumns = function () {
      getColumnOrDefault();
      return $scope.columnDefs;
    };
    function getColumnOrDefault() {
      $scope.viewGridOptions.columnDefs = [];
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Codice',
        field: 'model.code',
        enableFiltering: true,
        width: 200,
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Descrizione',
        field: 'model.description',
        enableFiltering: true,
        width: 300,
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Tipo Asset',
        field: 'schemaCode',
        //non 'model.type' perchè non è definito per tutti gli elementi. 'schemaCode' non è corretto a livello logico, ma funziona
        enableFiltering: true,
        width: 100,
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      /**Cicla i parents del nodo e li visualizza se non sono a livello 0 (per non scrivere il tree)*/
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Percorso',
        field: PARENTS_FIELD_NAME,
        cellTemplate: '<div class="ui-grid-cell-contents">\
                        <span ng-repeat="p in row.entity.parents" ng-show="p.treeLevel != 0" title="{{p.description}} ({{p.type}} - {{p.code}})" style="display: inline-block;\
                                                                                                                              border: 1px solid #d4d4d4;\
                                                                                                                              padding: 3px 0;\
                                                                                                                              border-radius: 4px;\
                                                                                                                              margin-right: 20px;\
                                                                                                                              text-align: center;\
                                                                                                                              width: 150px;\
                                                                                                                              overflow-x: hidden;>"\
                          <span>\
                            <span>{{p.description}}<br>({{p.type}} - {{p.code}})</span>\
                          </span>\
                        </span>\
                      </div>',
        enableSorting: false,
        enableFiltering: false,
        //TODO Implementare un filtro cutsom
        width: 900 /*,
                   filters:[{
                   type: sixGridPaginationConstants.filterType.TEXT,
                   condition: uiGridConstants.filter.CONTAINS,
                   placeholder: ''
                   }]*/
      });
    }

    function isCustomerMissing() {
      var missing = $scope.app.profileCustomer && angular.isUndefined($scope.currentCustomer);
      return missing;
    }
    $scope.isCustomerMissing = isCustomerMissing;

    // records tree callbacks
    $scope.recordsOptions = {
      // Richiamata quando si cerca di trascinare un nodo in un punto dell'albero:
      // controlla se la destinazione può accettare il nodo
      accept: function accept(sourceNodeScope, destNodesScope, destIndex) {
        return false;
      },
      // Richiamata prima di iniziare il trascinamento
      beforeDrag: function beforeDrag(sourceNodeScope) {
        return $scope.isWritePermAllowed();
      },
      // Richiamata quando si inizia il trascinamento
      dragStart: function dragStart(event) {
        // Tolgo dal nodo tutte le info che non servono
      },
      // Richiamata quando si rilascia il nodo dopo il trascinamento
      beforeDrop: function beforeDrop(event) {
        if (event.dest.nodesScope.$treeScope.$element[0].id == 'tree2-root') {
          // la destinazione è ancora la lista dei record => accetto ma non salvo nulla
          var deferred = $q.defer();
          deferred.resolve();
          return deferred.promise;
        } else {
          // la destinazione è il tree vero e proprio => accetto e salvo
          if (event.source.nodeScope.$modelValue && !event.source.nodeScope.$modelValue.nodes) {
            event.source.nodeScope.$modelValue.nodes = [];
          }
          var resPromise = addParentToChildren(event.source.nodeScope.$modelValue, event.dest.nodesScope.$parent.$modelValue, null);
          resPromise.then(function (success) {
            // success
            if (event.dest.nodesScope.$parent.$modelValue) {
              event.dest.nodesScope.$parent.$modelValue.hasChilds = true;
            } // per evitare errore 'undefined'
            $scope.removeRecordFromSelection(event.source.nodeScope.$modelValue); // Se era selezionato lo rimuovo
          })["catch"](function (response) {
            // error
          });
          return resPromise;
        }
      }
    };
    var sourceNode; // usato per verificare se il nodo di partenza è diverso da quello di destinazione (nel drag&drop)

    // Tree tree callbacks
    $scope.treeOptions = {
      // Richiamata quando si cerca di trascinare un nodo in un punto dell'albero:
      // controlla se la destinazione può accettare il nodo
      accept: function accept(sourceNodeScope, destNodesScope, destIndex) {
        var destNode = undefined;
        if (destNodesScope.$nodeScope != undefined) {
          // per evitare errori nel log
          destNode = destNodesScope.$nodeScope.$modelValue;
        }
        // il nodo è ammesso se è previsto nella struttura del tree e non è già stato inserito
        return isChildAllowed(sourceNodeScope.$modelValue, destNode);
      },
      beforeDrag: function beforeDrag(sourceNodeScope) {
        return $scope.isWritePermAllowed();
      },
      // Richiamata quando si inizia il trascinamento
      dragStart: function dragStart(event) {
        sourceNode = event.source;
        return true;
      },
      // Richiamata quando si rilascia il nodo dopo il trascinamento
      dragStop: function dragStop(event) {
        if (!isTheSameTreeNode(sourceNode.nodesScope.$parent, event.dest.nodesScope.$parent)) {
          var promiseChildAdded = addParentToChildren(event.source.nodeScope.$modelValue, event.dest.nodesScope.$parent.$modelValue, event.source.nodesScope.$parent.$modelValue);
          event.dest.nodesScope.$parent.$modelValue.hasChilds = true;
          var refSource = event.source.nodesScope.$parent.$modelValue;
          var refDest = event.dest.nodesScope.$parent.$modelValue;
          // una volta spostato il nodo -> carico i figli della destinazione per mostrarli
          promiseChildAdded.then(function () {
            console.log(refDest);
            getNodesChilds(refDest);
          })["catch"](function (reason) {
            console.log(reason);
          });
          $log.info('destNode != sourceNode');
        } else {
          $log.info('destNode == sourceNode');
        }
        sourceNode = undefined;
      }
    };
    function isTheSameTreeNode(source, dest) {
      if (!source.$modelValue && !dest.$modelValue) return true;
      if (source.$modelValue && dest.$modelValue && source.$modelValue.UUID == dest.$modelValue.UUID) return true;
      return false;
    }

    // Rimuove un nodo dall'albero
    $scope.removeTreeNode = function (scope) {
      $log.info('remove ' + scope.index());
      var original = angular.copy(scope.$modelValue.parents); // preservo per eventuale failback
      scope.$modelValue.parents = [];
      if (scope.$parent.$modelValue.schemaCode == 'configurazione') {
        treePlanConfigFactory.deleteConfiguration({
          id: scope.$parent.$modelValue.UUID
        }).$promise.then(function () {
          console.log('Configuration deleted on index');
          if ($scope.showDetails) {
            $scope.getRecordDetail(false, scope.$parent.$modelValue.parents[0].type, scope.$parent.$modelValue.parents[0].UUID);
          }
        })["catch"](function (response) {
          // error
        });
      } else {
        scope.$modelValue.deleted = true; // passo al backend per indicare che sto rimuovendo il nodo dal tree
        _updateTreeNodes(scope.$modelValue).then(function (success) {
          delete scope.$modelValue.deleted;
          scope.remove();
        })["catch"](function (errors) {
          // error: torno indietro
          delete scope.$modelValue.deleted;
          scope.$modelValue.parents = original;
        });
      }
    };

    // (De)Comprime i rami dell'albero
    $scope.toggleNode = function (scope) {
      if (scope.collapsed == true) {
        getNodesChilds(scope.$modelValue).then(function () {
          scope.toggle();
          $scope.loadCalendars();
        });
      } else {
        // pulisco i nodi
        if (scope.$modelValue.nodes && angular.isArray(scope.$modelValue.nodes)) {
          scope.$modelValue.nodes.length = 0;
        } else {
          scope.$modelValue.nodes = [];
        }
        scope.toggle();
        $scope.loadCalendars();
      }
    };
    function getNodesChilds(node) {
      // pulisco l'array dei nodi
      if (node.nodes && angular.isArray(node.nodes)) {
        node.nodes.length = 0;
      } else {
        node.nodes = [];
      }
      var payload = {
        id: TREE_CODE,
        path: (node.parents && node.parents.length > 0 ? node.parents.map(function (p) {
          return p.UUID;
        }).join(';') + ';' : '') + node.UUID,
        depth: 0
      };
      if (payload.path.charAt(0) == ';') {
        payload.path = payload.path.substring(1);
      }
      var filters = {};
      if ($scope.searchInputInTree.text && $scope.searchInputInTree.text.length >= 3) {
        var value4Regex = buildSearchRegexp($scope.searchInputInTree.text);
        filters = {
          code: sixFiltersLib.regex('model.code', '.*' + value4Regex + '.*', sixFiltersLib.CONSTRAINTS.OR),
          description: sixFiltersLib.regex('model.description', '.*' + value4Regex + '.*', sixFiltersLib.CONSTRAINTS.OR),
          customCode: sixFiltersLib.regex('model.customCode', '.*' + value4Regex + '.*', sixFiltersLib.CONSTRAINTS.OR)
        };
      }
      var deferred = $q.defer();
      if ($scope.date.currentDate) {
        payload.currentDate = $filter('date')($scope.date.currentDate, 'yyyy-MM-dd');
        payload.show_revision = true;
      }
      treeFactory.childs(payload, filters).$promise.then(function (resp) {
        if (!resp.hasErrors) {
          node.nodes = resp.result;
          deferred.resolve(resp);
        } else {
          toaster.pop('error', 'Errore caricamento', 'Errore recupero nodi');
          deferred.reject(resp);
        }
      })["catch"](function (response) {
        toaster.pop('error', 'Errore caricamento', 'Errore recupero nodi');
        deferred.reject(response);
      });
      return deferred.promise;
    }
    $scope.getNodesList = function () {
      if (!$scope.params.sortFields || $scope.params.sortFields.trim() == '') {
        $scope.params.sortFields = 'model.code:asc';
      }
      var payload = {
        id: TREE_CODE,
        depth: 10,
        flat: true,
        page: $scope.params.pageNumber,
        page_size: $scope.params.pageSize,
        sort_fields: $scope.params.sortFields
      };
      var deferred = $q.defer();
      treeFactory.filtered(payload, $scope.params.filters).$promise.then(function (resp) {
        if (!resp.hasErrors) {
          $scope.nodeList.list = resp.result;
          $scope.nodeList.totalResults = resp.meta.totalResults;
          deferred.resolve($scope.nodeList);
        } else {
          toaster.pop('error', 'Errore caricamento', 'Errore recupero nodi');
          deferred.reject(resp);
        }
      })["catch"](function (response) {
        toaster.pop('error', 'Errore caricamento', 'Errore recupero nodi');
        deferred.reject(response);
      });
      return deferred.promise;
    };
    $scope.toggleAll = function () {
      var scope = angular.element(document.getElementById("tree1-root")).scope();
      if ($scope.treeCollapsed === false) {
        $scope.collapseAll();
        $scope.treeCollapsed = true;
      } else {
        $scope.expandAll();
        $scope.treeCollapsed = false;
      }
    };
    $scope.collapseAll = function () {
      $scope.$broadcast('angular-ui-tree:collapse-all');
    };
    $scope.expandAll = function () {
      $scope.$broadcast('angular-ui-tree:expand-all');
    };

    // utils

    // Cancella un albero dall'indice
    $scope.deleteTree = function () {
      // TODO devo cancellare i parents (di questo tree) da tutti i record coinvolti in questo tree
    };

    // Salva o aggiorna un record nell'indice
    $scope.updateRecord = function () {
      // gestione code tramite contatore di SIX, confermo il codice...
      if ($scope.selfGeneratedCode.active == true) {
        counterFactory.next({
          code: $scope.selfGeneratedCode.codeNameSix
        }).$promise.then(function (response) {
          if (response.errors) {
            toaster.pop('error', 'Errore', 'Problema rilevato nell\'inizializziazione automatica del codice: ' + response.errors.error);
          } else {
            if (!$scope.record.model.code) {
              // se è ancora vuoto lo riempio
              $scope.record.model.code = response.next; // se è nuovo, confermo il codice...
            }
          }

          _update();
        })["catch"](function (response) {
          toaster.pop('error', 'Errore', 'Problema rilevato nell\'inizializziazione automatica del codice');
        });
      } else {
        _update();
      }
    };

    // Sistema le date reinizializzandole (da backend potrebbero arrivarmi come stringhe)
    function fixDates(data) {
      if (data.creationDate) {
        data.creationDate = createDateTime(data.creationDate);
      }
      if (data.dataIn) {
        data.dataIn = createDateTime(data.dataIn);
      }
      if (data.dataOut) {
        data.dataOut = createDateTime(data.dataOut);
      }
      return data;
    }

    // Crea un dateTime fino ai secondi (yyyy-MM-dd HH:mm:ss)
    function createDateTime(date) {
      var d = new Date(date);
      return new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds());
    }
    function _update() {
      if ($scope.record.version) {
        recordFactory($scope.record.type).update({
          id: $scope.record.version,
          history: $scope.historyMode === 'snap'
        }, $scope.record.wrapper).$promise.then(function (data) {
          $scope.record.wrapper = fixDates(data);
          $scope.record.version = data.version;
          $scope.record.model = $scope.record.wrapper.model;
          $scope.selected.treeNode.code = $scope.record.wrapper.model.code; // Aggiorno la visualizzazione nel tree
          $scope.selected.treeNode.description = $scope.record.wrapper.model.description; // Aggiorno la visualizzazione nel tree
          $scope.selected.treeNode.customCode = $scope.record.wrapper.model.customCode; // Aggiorno la visualizzazione nel tree

          dialogService.dialog('Record salvato', '', 'success', DEFAULT_DIALOG_TIMEOUT, true);
        })["catch"](function (response) {
          toaster.pop('error', 'Errore salvataggio', 'Errore durante il salvataggio');
        });
      } else {
        recordFactory($scope.record.type).create({
          commission_dependent: $scope.commissionDependent,
          history: $scope.historyMode === 'snap'
        }, $scope.record.model).$promise.then(function (data) {
          $scope.record.wrapper = fixDates(data);
          $scope.record.version = data.version;
          $scope.record.model = $scope.record.wrapper.model;
          // $scope.record.wrapper.nodes = [];
          $scope.addNodesToParent($scope.record.parent, sixObjectLib.recordToHisRef($scope.record.wrapper));
          dialogService.dialog('Record salvato', '', 'success', DEFAULT_DIALOG_TIMEOUT, true);
        })["catch"](function (response) {
          toaster.pop('error', 'Errore salvataggio', 'Errore durante il salvataggio');
        });
      }
    }

    // Aggiunge un nodo ad un padre
    $scope.addNodesToParent = function (parent, nodes) {
      addParentToChildren(nodes, parent, null).then(function (success) {
        parent = parent || $scope.tree.wrapper;
        if (!parent.nodes) {
          parent.nodes = [];
        }
        if (nodes && [].concat(nodes).length > 0) {
          // parent.nodes = parent.nodes.concat(nodes);
          [].concat(nodes).forEach(function (n) {
            parent.nodes.push(n);
          }); // uno a uno per far contento ui-tree
          parent.hasChilds = true;
        }
        [].concat(nodes).forEach(function (n) {
          removeNodeFromRecordsList(n); // Rimuovo dalla lista dei record disponibili
        });

        $scope.unselectAllFromRecordsList(); // pulisco l'array 'nodes'
      });
    };

    // Aggiunge i parent ai figli
    function addParentToChildren(childrenSource, parentDest, parentSource) {
      var root = angular.isUndefined(parentDest);
      if (childrenSource && [].concat(childrenSource).length > 0) {
        [].concat(childrenSource).forEach(function (child) {
          if (!child.parents) {
            child.parents = [];
          }
          // TODO in realtà dovrei rimuovere solo i parent di questo tree (possibilità di avere più tree)
          child.parents = [];
          var parentRef;
          if (root) {
            // treeLevel = 0;
            parentRef = {};
          } else {
            parentRef = angular.copy(parentDest);
          }
          parentRef.treeCode = TREE_CODE;
          // parentRef.treeLevel = treeLevel;
          delete parentRef.nodes;
          var drainedParents = [];
          if (parentDest && parentDest.parents && [].concat(parentDest.parents).length > 0) {
            drainedParents = parentDest.parents.map(function (p) {
              delete p.nodes;
              return p;
            });
          }
          child.parents = child.parents.concat(drainedParents).concat(parentRef);
          // aggiorno il padre dall'UUID spostato e hasChilds
          if (parentSource && [].concat(parentSource.nodes).length >= 0) {
            var indxChildrenSource = -1;
            [].concat(parentSource.nodes).forEach(function (node, indexNode) {
              if (node.UUID == childrenSource.UUID) {
                // individuo il nodo da eliminare (se ancora presente)
                indxChildrenSource = indexNode;
              }
            });
            if (indxChildrenSource > -1) {
              // se esiste, lo elimino
              parentSource.nodes.splice(indxChildrenSource, 1);
            }
            if (parentSource.nodes.length == 0) {
              // se nodes == 0 -> aggiorno la var. sui figli
              parentSource.hasChilds = false;
            }
          }
        });
        return _updateTreeNodes(childrenSource); // return a promise
      } else {
        var returnPromise = $q.defer();
        returnPromise.resolve();
        return returnPromise.promise;
      }
    }
    $scope.checkNodeToDestination = function (treeNode) {
      if (treeNode) {
        $scope.selectDestination = true;
        $scope.nodeToCopy = treeNode;
        dialogService.dialog('Selezionare il nodo di destinazione per la copia', '', 'info', COPY_DIALOG_TIMEOUT, true);
      }
    };
    $scope.addNodeToDestination = function (parent) {
      if (parent && $scope.nodeToCopy) {
        dialogService.confirmDialog('Copiare il nodo selezionato in ' + parent.code + ' - ' + parent.description + '?', function () {
          // per ora gestiamo solo la copia delle configurazioni
          if ($scope.nodeToCopy.type == 'configurazione') {
            var p = $scope.copyConfiguration($scope.nodeToCopy, parent);
            p.then(function () {
              closeCopy();
            })["catch"](function () {
              closeCopy();
            });
          }
        }, function () {
          closeCopy();
        });
      }
    };
    function closeCopy() {
      // ad aggiunta fatta, pulisco le variabili per la copia
      $scope.selectDestination = false;
      $scope.nodeToCopy = undefined;
    }
    function _updateTreeNodes(nodes) {
      showUpdateLoading('Aggiornamento tree in corso...');
      var returnPromise = $q.defer();
      var promises = [];
      [].concat(nodes).forEach(function (n) {
        n.parents = n.parents.map(function (p) {
          delete p.parents;
          delete p.hasChilds;
          delete p.childCount;
          return p;
        });
        promises.push(treeFactory.updateNode({
          id: TREE_CODE
        }, n).$promise);
      });
      $q.all(promises).then(function (resp) {
        $log.log(resp);
        var errors = 0;
        resp.forEach(function (r) {
          if (!errorService.handleError(r)) {
            $log.error(r);
            errors++;
          }
        });
        stopUpdateLoading();
        if (errors > 0) {
          // errors
          $log.error('Errors amount: ' + errors);
          toaster.pop('error', 'Errore aggiornamento tree', 'Si è verificato un errore durante l\'aggiornamento del tree');
          returnPromise.reject(resp);
        } else {
          // success
          toaster.pop('success', 'Tree aggiornato', 'Tree aggiornato');
          returnPromise.resolve(nodes);
        }
      })["catch"](function (err) {
        // errors

        stopUpdateLoading();
        $log.error(err);
        toaster.pop('error', 'Errore aggiornamento tree', 'Si è verificato un errore durante l\'aggiornamento del tree');
        returnPromise.reject(err);
      });
      return returnPromise.promise; // return a promise
    }

    // Submit del form dettagli record
    $scope.onSubmitDetailForm = function (form) {
      // First we broadcast an event so all fields validate themselves
      $scope.$broadcast('schemaFormValidate');

      // Then we check if the form is valid
      if (form.$valid) {
        $scope.updateRecord();
      }
    };
    function emptyRecord() {
      return {
        wrapper: {},
        // wrapper che arriva dall'endpoint che fornisce l'albero richiesto
        type: undefined,
        // tipo di record (schemaCode)
        model: {},
        // valorizzazione del record
        schema: {},
        form: {},
        version: undefined,
        parent: undefined,
        // nodo in cui si sta cercando di aggiungere il record
        loaded: false
      };
    }

    // Recupera i dettagli del record selezionato (o carica il form per inserirne uno nuovo)
    $scope.getRecordDetail = function (isRoot, entityType, id) {
      if (!entityType) {
        return;
      }
      $scope.record = emptyRecord();
      $scope.commissionDependent = false;
      $scope.historyMode = 'snap';
      $scope.selfGeneratedCode = false;
      $scope.typeDescription = undefined;
      $scope.record.loaded = false;
      $scope.record.type = entityType;
      if (isRoot) {
        $scope.record.parent = $scope.tree.wrapper;
      } else {
        $scope.record.parent = $scope.selected.treeNode;
      }
      if (entityType == 'configurazione') {
        // carico lo schema corretto
        loadRightSchema(entityType, null).then(function (data) {
          // apro il caricamento della configurazione...
          $scope.openConfiguration();
          // mostro il pannello (abilito entrambe le variabili)...
          $scope.record.loaded = true;
          $scope.showDetails = true;
        })["catch"](function (err) {
          $log.error(err);
          toaster.pop('error', 'Schema non trovato', 'Impossibile caricare lo schema del record selezionato');
        });
      } else {
        // se è un record lancio la chiamata per scaricare il dato...

        var recordPromise;
        if ($scope.date.currentDate) {
          // altrimenti mi baso sull'UUID e la data settata
          recordPromise = recordFactory(entityType).byDate({
            param1: $filter('date')($scope.date.currentDate, 'yyyy-MM-dd'),
            id: id
          }).$promise;
        } else {
          recordPromise = recordFactory(entityType).byUUID({
            id: id
          }).$promise;
        }
        recordPromise.then(function (data) {
          if (data.model) {
            $scope.record.wrapper = data;
            $scope.record.model = $scope.record.wrapper.model;
            $scope.record.version = $scope.record.wrapper.version;
            var date = new Date($scope.record.wrapper.dataIn);
            $scope.record.wrapper.dataIn = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
            if ($scope.record.wrapper.dataOut) {
              date = new Date($scope.record.wrapper.dataOut);
              $scope.record.wrapper.dataOut = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
            }

            // carico lo schema corretto
            loadRightSchema(entityType, $scope.record.wrapper).then(function (data) {
              // mostro il pannello (abilito entrambe le variabili)...
              $scope.record.loaded = true;
              $scope.showDetails = true;
            })["catch"](function (err) {
              $log.error(err);
              toaster.pop('error', 'Schema non trovato', 'Impossibile caricare lo schema del record selezionato');
            });
          } else {
            // carico lo schema corretto
            loadRightSchema(entityType, $scope.record.wrapper).then(function (data) {
              // mostro il pannello (abilito entrambe le variabili)...
              /* scarico il codice della segnalazione dal contatore di SIX */
              if ($scope.selfGeneratedCode.active == true) {
                counterFactory.current({
                  code: $scope.selfGeneratedCode.codeNameSix
                }).$promise.then(function (response) {
                  if (response.errors) {
                    toaster.pop('error', 'Errore', 'Problema rilevato nell\'inizializziazione automatica del codice: ' + response.errors.error);
                  } else {
                    $scope.record.model.code = (parseInt(response.current) + 1).toString();
                  }
                });
              }
              $scope.record.loaded = true;
              $scope.showDetails = true;
            })["catch"](function (err) {
              $log.error(err);
              toaster.pop('error', 'Schema non trovato', 'Impossibile caricare lo schema del record selezionato');
            });
          }
          if (!data.model && isRoot) {
            $scope.selected.treeNode = {
              type: 'root'
            };
          }
        })["catch"](function (err) {
          // error
          $log.error(err);
          toaster.pop('error', 'Record non trovato', 'Impossibile caricare il dato selezionato');
        });
      }
    };
    function loadRightSchema(type, record) {
      var schemaPromise;
      if (record && $scope.date.currentDate) {
        // se ho una currentDate sto caricando un dato vecchio ...
        if (record.schemaVersion) {
          // ... => carico il modello corrispondente a quello indicato in schemaVersion (se presente) ...
          schemaPromise = schemaFactory().byID({
            version: record.schemaVersion
          }).$promise;
        } else {
          // ... oppure carico il modello valido alla dataIn del record (se non è presente schemaVersion)
          schemaPromise = schemaFactory().byDate({
            param1: $filter('date')(record.dataIn, 'yyyy-MM-dd'),
            id: record.schemaCode
          }).$promise;
        }
      } else {
        // ... altrimenti sto visualizzando il dato attuale quindi carico l'ultimo modello valido
        schemaPromise = schemaFactory().byCode({
          id: type
        }).$promise;
      }
      loadSchemaByPromise(schemaPromise);
      return schemaPromise;
    }
    function loadSchemaByPromise(promise) {
      promise.then(function (data) {
        $scope.record.schema = data.model.schema;
        $scope.record.form = data.model.form;
        $scope.commissionDependent = data.model.commissionDependent;
        $scope.historyMode = data.model.history == true ? 'snap' : 'stable';
        if (data.model.selfGeneratedCode) {
          $scope.selfGeneratedCode = data.model.selfGeneratedCode;
        } else {
          $scope.selfGeneratedCode = {
            codeNameSix: '',
            active: false
          };
        }
        $scope.typeDescription = data.model.description;
        $scope.$broadcast('schemaFormRedraw');
      });
    }

    // Recupera un tree salvato filtrato
    $scope.getTree = function () {
      $scope.tree.loaded = false;
      $scope.calendar.data = {};
      $scope.calendar.withClosedChilds = {};
      var expandAll = false;
      var filters = {};
      var payload = {
        id: TREE_CODE,
        depth: $scope.searchInputInTree.depth
      };
      if ($scope.searchInputInTree.text && $scope.searchInputInTree.text.length >= 3) {
        // filtrato
        var value4Regex = buildSearchRegexp($scope.searchInputInTree.text);
        filters = {
          code: sixFiltersLib.regex('model.code', '.*' + value4Regex + '.*', sixFiltersLib.CONSTRAINTS.OR),
          description: sixFiltersLib.regex('model.description', '.*' + value4Regex + '.*', sixFiltersLib.CONSTRAINTS.OR),
          customCode: sixFiltersLib.regex('model.customCode', '.*' + value4Regex + '.*', sixFiltersLib.CONSTRAINTS.OR)
        };
        expandAll = true;
      }
      if ($scope.date.currentDate) {
        // altrimenti mi baso sull'UUID e la data settata
        payload.currentDate = $filter('date')($scope.date.currentDate, 'yyyy-MM-dd');
        payload.show_revision = true;
      }
      var promise = treeFactory.filtered(payload, filters).$promise;
      promise.then(function (data) {
        if (data.result) {
          $scope.tree.wrapper = data.result;
        } else {
          $scope.tree.wrapper = {
            nodes: [],
            type: TREETYPE
          };
        }
        $scope.tree.loaded = true;
        $scope.loadCalendars();
        if (expandAll) {
          $timeout(function () {
            $scope.expandAll();
          }, 200);
        }
      })["catch"](function (response) {
        dialogService.alert('Non sono presenti versioni nella data selezionata per il tree', 4000);
        $scope.ripristineDate();
        $scope.changeCurrentDate($scope.date.currentDate, true);
      });
      return promise;
    };

    // Recupera la struttura dell'albero realizzata con il tree configurator
    $scope.getTreeStructure = function () {
      return treeFactory.getTreeStructure().$promise.then(function (data) {
        if (data.model) {
          $scope.tree.structure = data.model.nodes;
          if ($scope.showRecordsList) {
            $scope.loadAllowedRecords(); // senza parametri parte dalla root
          }

          $scope.dropdownList.roots = $scope.getEntityChildsInTreeStructure(); // tutte le root
          $scope.dropdownList.nodes = angular.copy($scope.dropdownList.roots);
        } else {
          dialogService.dialog('ATTENZIONE', 'Nessuna struttura albero definita', 'warning', DEFAULT_DIALOG_TIMEOUT);
        }
      })["catch"](function (response) {
        // error
        dialogService.dialog('ATTENZIONE', 'Nessuna struttura albero definita', 'warning', DEFAULT_DIALOG_TIMEOUT);
      });
    };
    $scope.selectAllFromRecordsList = function () {
      $scope.selected.records = [];
      $scope.records.list.forEach(function (r) {
        $scope.selected.records.push(r);
      });
    };
    $scope.unselectAllFromRecordsList = function () {
      $scope.selected.records = [];
    };

    // De/Seleziona un record (lista di sinistra)
    $scope.toggleRecordSelection = function (node) {
      if (node === undefined) {
        $scope.selected.records = [];
      } else {
        if ($scope.isRecordSelected(node)) {
          $scope.removeRecordFromSelection(node);
        } else {
          $scope.selected.records.push(node);
        }
      }
    };

    // Deselezione il record
    $scope.removeRecordFromSelection = function (node) {
      if ($scope.selected.records && node) {
        $scope.selected.records.forEach(function (elem, index) {
          if (node.UUID === elem.UUID) {
            $scope.selected.records.splice(index, 1);
            return;
          }
        });
      }
    };

    // Selezione nodo dell'albero
    // Gestisce click su un nodo dell'albero
    $scope.selectNode = function (node) {
      // Deselezione generica -> (da button)
      if (node === undefined) {
        $scope.unselectNode();
        $scope.showRecordsList = true;
        $scope.selectDestination = false; // pulisco la variabile per la copia (nel caso sia stata selezionata)
      } else {
        // Selezione/Deselezione nodo corrente

        // Controllo se è stato selezionato il bottone copia
        if ($scope.selectDestination) {
          // copia: chiamo la funzione per attaccare il nodo selez. in precedenza sotto 'node'
          $scope.addNodeToDestination(node);
        } else {
          // no copia: riutilizzo il vecchio codice
          if (angular.isDefined($scope.selected.treeNode) && angular.isDefined(node) && $scope.selected.treeNode.UUID == node.UUID) {
            // Deselezione nodo (se arrivo da un click sullo stesso)
            $scope.unselectNode();
          } else {
            // Selezione nodo
            if ($scope.showRecordsList && (angular.isUndefined($scope.selected.treeNode) || node.UUID != $scope.selected.treeNode.UUID)) {
              $scope.loadAllowedRecords(node);
            }
            if ($scope.showDetails && (angular.isUndefined($scope.selected.treeNode) || node.UUID != $scope.selected.treeNode.UUID)) {
              $scope.getRecordDetail(false, node.type, node.UUID);
            }
            $scope.selected.treeNode = node;
            $scope.selected.records = [];
            $scope.dropdownList.nodes = $scope.getEntityChildsInTreeStructure(node);
          }
        }
      }
    };

    // Deselezione nodo dell'albero
    $scope.unselectNode = function () {
      if ($scope.showRecordsList && angular.isDefined($scope.selected.treeNode)) {
        $scope.loadAllowedRecords();
      }
      $scope.unselectRecord();
      $scope.dropdownList.nodes = angular.copy($scope.dropdownList.roots);
    };

    // Deselezione record
    $scope.unselectRecord = function () {
      $scope.record = emptyRecord();
      $scope.selected.treeNode = undefined;
      $scope.selected.records = [];
      $scope.dropdownList.nodes = $scope.getEntityChildsInTreeStructure();
    };
    $scope.loadAllowedRecords = function (parent) {
      $scope.records.list = [];
      $scope.records.loaded = false;
      var payload = {
        param1: TREE_CODE,
        duplicates_allowed: false
      };
      if (parent) {
        var parentsList = [];
        if (parent.parents && parent.parents.length > 0) {
          parentsList = parent.parents.filter(function (p) {
            return p.treeLevel != 0;
          });
        }
        var parentSchemas = (parentsList && parentsList.length > 0 ? parentsList.map(function (p) {
          return p.type;
        }).join(';') + ';' : '') + parent.type;
        if (parentSchemas.charAt(0) == ';') {
          parentSchemas = parentSchemas.substring(1);
        }
        payload.parents_schema = parentSchemas;
      }
      var filters = {};
      if ($scope.searchInput.type && $scope.searchInput.type.UUID) {
        filters.schemaCode = sixFiltersLib.exact('schemaCode', $scope.searchInput.type.UUID, sixFiltersLib.CONSTRAINTS.AND);
      }
      if ($scope.searchInput.text) {
        var value4Regex = buildSearchRegexp($scope.searchInput.text);
        var tmp = {};
        tmp.code = sixFiltersLib.regex('model.code', '.*' + value4Regex + '.*', sixFiltersLib.CONSTRAINTS.OR);
        tmp.description = sixFiltersLib.regex('model.description', '.*' + value4Regex + '.*', sixFiltersLib.CONSTRAINTS.OR);
        tmp.customCode = sixFiltersLib.regex('model.customCode', '.*' + value4Regex + '.*', sixFiltersLib.CONSTRAINTS.OR);
        filters.must = sixFiltersLib.must(tmp, sixFiltersLib.CONSTRAINTS.AND);
      }
      return treeFactory.allowedChildsV2(payload, filters).$promise.then(function (data) {
        if (!data.hasErrors) {
          if (data.result && [].concat(data.result).length > 0) {
            var list = data.result.map(function (n) {
              return sixObjectLib.recordToHisRef(n);
            });
            addNodeToRecordsList(list);
          }
        } else {
          toaster.pop('error', 'Errore recupero dati', 'Errore durante il recupero dei possibili nodi di \'' + parent ? parent.code : 'root' + '\'');
        }
      })["catch"](function (response) {
        // error
        toaster.pop('error', 'Errore recupero dati', 'Errore durante il recupero dei possibili nodi di \'' + parent ? parent.code : 'root' + '\'');
      })["finally"](function (response) {
        $scope.records.loaded = true;
      });
    };

    // Restituisce i possibili nodi figli (entity) di un parent
    $scope.getEntityChildsInTreeStructure = function (parent) {
      if (parent === undefined) {
        // root
        return $scope.tree.structure;
      }
      var path = [].concat(parent.parents.filter(function (p) {
        return angular.isDefined(p.UUID);
      })).concat(parent);
      var node = treeService.findNodeInTreeWithPath(path, {
        nodes: $scope.tree.structure
      }, record2SchemaComparator);
      if (!angular.isUndefined(node)) {
        return node.nodes;
      }
      return undefined;
    };
    function buildSearchRegexp(text) {
      text = text.replace(/(\.\*\+\?\\\/\ \"\'\(\)\[\]\{\}\^\$)/g, '\\\$1'); //escaping caratteri speciali
      text = text.replace(/[a-zA-Z]/g, function (match) {
        var low = match.toLowerCase();
        var up = match.toUpperCase();
        return "[" + low + up + "]";
      });
      return text;
    }

    // Controlla se un figlio è ammissibile per un nodo
    var isChildAllowed = function isChildAllowed(sourceNode, destNode) {
      var allowedChildren = $scope.getEntityChildsInTreeStructure(destNode);
      if (allowedChildren != undefined) {
        for (var idx in allowedChildren) {
          if (allowedChildren[idx].model.code == sourceNode.type) {
            return true;
          }
        }
        return false;
      }
    };

    // Aggiunge un array di nodi alla lista dei records
    function addNodeToRecordsList(nodes) {
      if (angular.isUndefined($scope.records.list)) {
        $scope.records.list = [];
      }
      // $scope.records.list = $scope.records.list.concat(nodes);
      nodes.forEach(function (r) {
        $scope.records.list.push(r);
      });
    }

    // Rimuove un nodo dalla lista dei records
    function removeNodeFromRecordsList(node) {
      if (angular.isDefined($scope.records.list)) {
        var pos = $scope.records.list.indexOf(node);
        if (~pos) $scope.records.list.splice(pos, 1);
      }
    }

    // Mostra/nascondi la lista di record a sinistra
    $scope.toggleRecordsList = function () {
      $scope.showRecordsList = !$scope.showRecordsList;
    };

    // Mostra/nascondi dettagli
    $scope.toggleDetails = function () {
      $scope.showDetails = !$scope.showDetails;
      // se è da visualizzare, allora lancio la chiamata per scaricare il dato...
      if ($scope.showDetails == true && angular.isDefined($scope.selected.treeNode)) {
        $scope.getRecordDetail(false, $scope.selected.treeNode.type, $scope.selected.treeNode.UUID);
      } else {
        // altrimenti pulisco la variabile del panel di destra...
        $scope.record = emptyRecord();
      }
    };
    $scope.$watch('showRecordsList', function () {
      if ($scope.showRecordsList) {
        $scope.loadAllowedRecords($scope.selected.treeNode); // senza parametri parte dalla root
      }
    });

    var filterTimeout;
    $scope.searchInTree = function () {
      if (!$scope.searchInputInTree.depth || $scope.searchInputInTree.depth < 0) {
        toaster.pop('error', 'Profondità non valida', 'Il valore di profondità deve essere maggiore o uguale a 0');
      } else {
        // Timeout per evitare rimbalzi di chiamate.
        if (angular.isDefined(filterTimeout)) {
          $timeout.cancel(filterTimeout);
        }
        filterTimeout = $timeout(function () {
          $scope.getTree();
        }, 500);
      }
    };
    var filterListTimeout;
    $scope.searchList = function () {
      $scope.selected.records = [];
      // Timeout per evitare rimbalzi di chiamate.
      if (angular.isDefined(filterListTimeout)) {
        $timeout.cancel(filterListTimeout);
      }
      filterListTimeout = $timeout(function () {
        $scope.loadAllowedRecords($scope.selected.treeNode);
      }, 500);
    };

    // Recuper l'icona del model da menu
    $scope.getModelIcon = function (modelName) {
      var icon = modelIconService.getModelIcon(modelName) || 'fa fa-circle-o';
      return 'fa-fw ' + icon;
    };

    // Necessario per evitare deselezione (solo a livello html) del nodo selezionato ogni volta che viene
    // ridisegnato l'albero (i riferimenti cambiano)
    $scope.isNodeSelected = function (node) {
      if ($scope.selected.treeNode && node) {
        return record2RecordComparator(node, $scope.selected.treeNode);
      }
      return false;
    };
    $scope.isRecordSelected = function (node) {
      var selected = false;
      if ($scope.selected.records && node) {
        $scope.selected.records.forEach(function (elem) {
          if (record2RecordComparator(node, elem)) {
            selected = true;
          }
        });
      }
      return selected;
    };
    $scope.concatFields = function (item) {
      return item.model.code + item.model.description;
    };
    $scope.toggleRightSidebarSize = function (forceOpen) {
      if (forceOpen) {
        $scope.rightSidebarSize = 100;
      } else {
        $scope.rightSidebarSize = $scope.rightSidebarSize == '50' ? '100' : '50';
      }
    };
    function getTreeCode() {
      var code = 'def' + currentCommission.code;
      if (angular.isDefined($scope.currentCustomer)) {
        code += 'cli' + $scope.currentCustomer.code;
      }
      return code;
    }

    /** CALENDAR */
    function getNodesWithoutCalendarInfo(node) {
      //NOTA: se dovessero spuntare problemi di performance, si potrebbe costruire una whitelist dei type che supportano il calendario
      //in modo da includere solo quei documenti nella consultazione del calendario e ridurre il carico di lavoro
      var collected = {};
      if (node.UUID && angular.isUndefined($scope.calendar.data[node.UUID])) {
        //push del finto documento con i dati essenziali per il recupero del calendario
        collected[node.UUID] = {
          UUID: node.UUID,
          schemaCode: node.type,
          parents: node.parents
        };
      }
      if (Array.isArray(node.nodes) && node.nodes.length) {
        for (var i = 0; i < node.nodes.length; i++) {
          angular.merge(collected, getNodesWithoutCalendarInfo(node.nodes[i]));
        }
      }
      return collected;
    }
    $scope.loadCalendars = function () {
      if ($scope.calendar.show) {
        var toLoad = getNodesWithoutCalendarInfo($scope.tree.wrapper);
        var when = ($scope.date.currentDate ? new Date($scope.date.currentDate) : new Date()).toISOString();
        var params = {
          fromDate: when,
          toDate: when
        };
        assetcalendarFactory.getCalendarService(params, Object.values(toLoad)).$promise.then(function (calendars) {
          if (calendars) {
            Object.keys(calendars).forEach(function (uuid) {
              for (var day in calendars[uuid]) {
                $scope.calendar.data[uuid] = calendars[uuid][day];
                break;
              }
              if ($scope.calendar.data[uuid] == 0 && toLoad[uuid].parents) {
                //se chiuso, aggiungo tutti i parents all'elenco apposito
                toLoad[uuid].parents.forEach(function (parent) {
                  if (parent.UUID) {
                    $scope.calendar.withClosedChilds[parent.UUID] = true;
                  }
                });
              }
            });
          }
        });
      } else {
        $scope.calendar.data = {};
      }
    };
    $scope.isNodeWithClosedCalendar = function (node) {
      if (node.UUID) {
        return angular.isDefined($scope.calendar.data[node.UUID]) && $scope.calendar.data[node.UUID] == 0;
      }
    };
    $scope.isNodeWithClosedChild = function (node) {
      if (node.UUID) {
        return angular.isDefined($scope.calendar.withClosedChilds[node.UUID]) && $scope.calendar.withClosedChilds[node.UUID];
      }
    };

    /** ***********************************
     * Configurazioni
     * ***********************************/

    $scope.saveConfigurationOnTree = function (resp) {
      var obj = {
        schemaVersion: resp.schemaVersion,
        schemaCode: resp.schemaCode,
        model: {
          code: resp.model.code,
          description: resp.model.description,
          customCode: resp.model.customCode
        },
        UUID: resp.UUID,
        version: resp.version,
        parents: [],
        nodes: []
      };
      $scope.addNodesToParent($scope.record.parent, sixObjectLib.recordToHisRef(obj));
    };
    $scope.updateConfigurationOnTree = function (resp) {
      dialogService.dialog('Configurazione salvata', '', 'success', DEFAULT_DIALOG_TIMEOUT, true);
    };
    $scope.openConfiguration = function () {
      var ref = {};
      if ($scope.selected && $scope.selected.treeNode && $scope.selected.treeNode.type == 'configurazione') {
        /* apertura di uno già esistente */
        var when = $scope.date.currentDate;
        pipeConfigurationTree.pushTreeIdToConfig($scope.selected.treeNode.UUID, when);
      } else {
        /* gestione per un tipo di dato diverso da 'configurazione' */
        if ($scope.record.parent && $scope.record.parent.UUID) {
          /* se ho selezionato un nodo */
          ref = {
            UUID: $scope.selected.treeNode.UUID,
            code: $scope.selected.treeNode.code,
            description: $scope.selected.treeNode.description,
            customCode: $scope.selected.treeNode.customCode
          };
        } else {
          /* se è la root */
          ref = {
            UUID: null,
            code: $scope.tree.wrapper.code,
            description: 'Root'
          };
        }
        pipeConfigurationTree.pushTreeObjToConfig(ref);
      }
    };
    $scope.copyConfiguration = function (original, nodeDest) {
      var deferred = $q.defer();
      var copy = {
        code: sixObjectLib.makeGUID(),
        description: 'Configurazione',
        configuration: {}
      };
      var promiseGet = treePlanConfigFactory.getConfigurationByUUID({
        id: original.UUID,
        typecode: '_current'
      }).$promise;
      promiseGet.then(function (response) {
        if (response.model) {
          copy.configuration = response.model.configuration;
          var promiseCreate = treePlanConfigFactory.createConfiguration(copy).$promise;
          promiseCreate.then(function (response) {
            if (response.model) {
              $scope.addNodesToParent(nodeDest, sixObjectLib.recordToHisRef(response));
              deferred.resolve();
            } else {
              toaster.pop('error', 'Errore', 'Errore durante la copia della configurazione');
              deferred.reject();
            }
          });
        } else {
          toaster.pop('error', 'Errore', 'Errore durante la copia della configurazione');
          deferred.reject();
        }
      });
      return deferred.promise;
    };

    /** ************************
     * Loading dialog
     ** ************************/

    var updateTimeout = undefined;
    function showUpdateLoading(message) {
      updateTimeout = $timeout(function () {
        // parte 1 sec dopo per evitare di mostrarlo ad ogni singola operazione (molte operazioni sono rapidissime)
        dialogService.pushLoading(message);
      }, 1000);
    }
    function stopUpdateLoading() {
      if (updateTimeout) {
        // non è ancora partito
        $timeout.cancel(updateTimeout);
        updateTimeout = undefined;
      }
      dialogService.popLoading();
    }

    /** ***********************************
     * Check permissions
     * ***********************************/

    var RESOURCE_NAME = 'tree';
    $scope.isWritePermAllowed = function () {
      if ($scope.date.currentDate) {
        return false;
      }
      return authFactory.isWritePermAllowed(RESOURCE_NAME);
    };
    $scope.isWriteVersionAllowed = function () {
      return authFactory.checkPerm(RESOURCE_NAME, 'MODIFY_HISTORY');
    };
    $scope.isDeletePermAllowed = function () {
      if ($scope.date.currentDate) {
        return false;
      }
      return authFactory.isDeletePermAllowed(RESOURCE_NAME);
    };
    $scope.isWriteRecordPermAllowed = function () {
      if ($scope.date.currentDate) {
        return false;
      }
      return authFactory.isWritePermAllowed('record/{entity}');
    };
    $scope.isCopyConfPermAllowed = function (treeNode) {
      if ($scope.date.currentDate) {
        return false;
      }
      if (treeNode) {
        // check sul tipo: per ora si possono copiare solo le configurazioni
        if (treeNode.type && treeNode.type == 'configurazione') {
          return true;
        }
      }
      return false;
    };
    $scope.recordsIndexing = function () {
      treeFactory.recordsIndexing({
        id: $scope.tree.wrapper.UUID
      }).$promise.then(function (resp) {
        dialogService.serviceResponse('Indicizzazione', resp);
      })["catch"](function (response) {
        // error
      });
    };
    $scope.showIndexRecordsButton = function () {
      return false; // qui nascosto, visualizzato solo da treeold
    };

    $scope.showExpandAllButton = function () {
      return false; // qui nascosto, visualizzato solo da treeold
    };

    /**
     * TIMELINE
     */

    function _changeCurrentDate(currentDate, boolRipristineDate) {
      // boolRipristineDate -> bool per decidere cosa prendere come lastDate
      var session = sessionFactory.getSessionData();
      if (angular.isUndefined(session)) {
        session = {};
      }
      /* aggiorno le variabili con le date $scope */
      if (currentDate !== $scope.date.currentDate) {
        $scope.date.currentDate = currentDate;
        if (angular.isUndefined(session.currentDate)) {
          $scope.date.lastDate = null;
        } else {
          if (boolRipristineDate) {
            $scope.date.lastDate = null; /* per comodità lascio tornare indietro solo di un "passo" */
          } else {
            $scope.date.lastDate = session.currentDate;
          }
        }
        /* aggiorno la sessione corrente */
        session.currentDate = currentDate;
        sessionFactory.setSessionData(session);
        return true;
      } else {
        return false;
      }
    }
    $scope.changeCurrentDate = function (currentDate, boolRipristineDate) {
      if (currentDate) {
        $scope.showTimeline = true;
      }
      var dateChanged = _changeCurrentDate(currentDate, boolRipristineDate);
      if (dateChanged) {
        $scope.getTree();
      }
    };
    $scope.ripristineDate = function () {
      $scope.date = {
        currentDate: $scope.date.lastDate,
        lastDate: null
      };
    };
    $scope.goToAsset = function (node) {
      $location.path('record/snap/' + node.type + '/' + node.parent.UUID);
    };

    // Route: tree

    if ($scope.isCustomerMissing()) {
      dialogService.alert('Selezionare un cliente.', 4000);
    } else {
      $scope.getTreeStructure();
    }
    if ($scope.isCustomerMissing()) {
      dialogService.alert('Selezionare un cliente.', 4000);
    } else {
      $scope.refresh();
    }
  }]);

  /**** FILTERS ****/

  app.filter('recordsSearchFilter', function () {
    return function (input, search, destList) {
      if (search) {
        var lower = angular.lowercase(search);
        var output = [];
        input.forEach(function (node) {
          if (angular.isDefined(node)) {
            if (angular.lowercase(node.code).includes(lower) || angular.lowercase(node.description) && angular.lowercase(node.description).includes(lower) || angular.lowercase(node.type).includes(lower)) {
              output.push(node);
            }
          }
        });
        if (destList) {
          destList = output;
        }
        return output;
      } else {
        return input;
      }
    };
  });
})();
'use strict';

/**
 * @ngdoc function
 * @name emma.dataset.controller:TreeConfiguratorCtrl
 * @description
 * # TreeConfiguratorCtrl
 * Controller of the emma.dataset
 */
angular.module('emma.dataset').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/treeconfigurator', {
    templateUrl: 'dataset/tree/treeconfigurator.html',
    controller: 'TreeConfiguratorCtrl'
  }).when('/treeconfigurator/:id', {
    templateUrl: 'dataset/tree/treeconfigurator.html',
    controller: 'TreeConfiguratorCtrl'
  });
}]).controller('TreeConfiguratorCtrl', ["$scope", "$routeParams", "$location", "treeFactory", "treeService", "schemaFactory", "$filter", "$log", "authFactory", "dialogService", "modelIconService", "errorService", "toaster", function ($scope, $routeParams, $location, treeFactory, treeService, schemaFactory, $filter, $log, authFactory, dialogService, modelIconService, errorService, toaster) {
  var DEFAULT_DIALOG_TIMEOUT = 4000;
  var CHILDREN_FIELD_NAME = 'nodes';
  var PARENTS_FIELD_NAME = 'parents';
  var TREETYPE = 'structure';
  var currentCommission = authFactory.getAuthData().info.commissions.current;
  $scope.showEntitiesList = true; // flag per mostrare/nascondere la lista delle entities
  $scope.rightSidebarSize = '50';
  $scope.searchInput = {
    text: undefined
  }; // Oggetto che contiene i filtri di ricerca
  $scope.searchInputInTree = {
    text: undefined
  }; // Oggetto che contiene i filtri di ricerca nel tree

  $scope.tree = {
    wrapper: {
      model: {
        nodes: [],
        type: TREETYPE
      }
    },
    // wrapper che arriva dall'endpoint che fornisce l'albero richiesto
    loaded: false
  };
  $scope.treeCollapsed = true;
  $scope.entities = {
    loaded: false,
    list: [] // lista non filtrata delle entity
  };

  // Callbacks
  $scope.entitiesOptions = {
    // Richiamata quando si cerca di trascinare un nodo in un punto dell'albero:
    // controlla se la destinazione può accettare il nodo
    accept: function accept(sourceNodeScope, destNodesScope, destIndex) {
      return false;
    },
    // Richiamata prima di iniziare il trascinamento
    beforeDrag: function beforeDrag(sourceNodeScope) {
      return $scope.isWritePermAllowed();
    }
  };

  // Tree tree callbacks
  $scope.treeOptions = {
    // Richiamata quando si cerca di trascinare un nodo in un punto dell'albero:
    // controlla se la destinazione può accettare il nodo
    accept: function accept(sourceNodeScope, destNodesScope, destIndex) {
      var destNode = $scope.tree;
      if (destNodesScope.$nodeScope != undefined) {
        // per evitare errori nel log
        destNode = destNodesScope.$nodeScope.$modelValue;
      }
      var sourceNode = sourceNodeScope.$modelValue;
      // il nodo è ammesso se è previsto nella struttura del tree e non è già stato inserito
      return isChildAllowed(sourceNodeScope.$modelValue, destNode);
    },
    beforeDrag: function beforeDrag(sourceNodeScope) {
      return $scope.isWritePermAllowed();
    }
  };
  $scope.selected = {
    treeNode: undefined,
    // Nodo dell'albero correntemente selezionato
    entities: [] // Entities correntemente selezionate (selezione multipla)
  };

  // Rimuove un nodo dall'albero
  $scope.remove = function (scope) {
    scope.remove();
  };

  // Comparatore di oggetti record
  var record2RecordComparator = function record2RecordComparator(node1, node2) {
    if (node1 && node2 && node1.$$hashKey === node2.$$hashKey) {
      return true;
    }
    return false;
  };

  // (De)Comprime i rami dell'albero
  $scope.toggleNode = function (scope) {
    scope.toggle();
  };
  $scope.toggleAll = function () {
    var scope = angular.element(document.getElementById("tree1-root")).scope();
    if ($scope.treeCollapsed === false) {
      $scope.collapseAll();
      $scope.treeCollapsed = true;
    } else {
      $scope.expandAll();
      $scope.treeCollapsed = false;
    }
  };
  $scope.collapseAll = function () {
    $scope.$broadcast('angular-ui-tree:collapse-all');
  };
  $scope.expandAll = function () {
    $scope.$broadcast('angular-ui-tree:expand-all');
  };
  $scope.isNodeVisible = function (node) {
    if ($scope.searchInputInTree.text && $scope.searchInputInTree.text !== '') {
      var expr = $scope.searchInputInTree.text.toLowerCase();
      return recursiveNodeSearch(node, expr, false);
    } else {
      return true;
    }
  };
  function recursiveNodeSearch(node, expr, partialResult) {
    var found = partialResult;
    if (!found && node) {
      // se l'ho già trovato ritorno subito true, altrimenti cerco ricorsivamente
      found = found || node.model.code.toLowerCase().includes(expr);
      found = found || node.model.description.toLowerCase().includes(expr);
      if (!found && node.nodes && node.nodes.length > 0) {
        node.nodes.forEach(function (child) {
          if (!found) {
            found = found || recursiveNodeSearch(child, expr, found);
          }
        });
      }
    }
    return found;
  }
  $scope.isEntityVisible = function (entity) {
    if (angular.isUndefined($scope.searchInput) || angular.isUndefined($scope.searchInput.text)) {
      return true;
    }
    var search = angular.lowercase($scope.searchInput.text);
    if (angular.isDefined(entity.model) && entity.model != null) {
      if (angular.lowercase(entity.model.code).includes(search) || angular.lowercase(entity.model.description) && angular.lowercase(entity.model.description).includes(search)) {
        return true;
      }
    }
    return false;
  };
  $scope.selectAllFromEntitiesList = function () {
    $scope.selected.entities = $filter('entitiesSearchFilter')($scope.entities.list, $scope.searchInput.text);
  };
  $scope.unselectAllFromEntitiesList = function () {
    $scope.selected.entities = [];
  };

  // Mostra/nascondi la lista di entities a sinistra
  $scope.toggleEntitiesList = function () {
    $scope.showEntitiesList = !$scope.showEntitiesList;
  };

  // De/Seleziona una entity (lista di sinistra)
  $scope.toggleEntitySelection = function (node) {
    if (node === undefined) {
      $scope.selected.entities = [];
    } else {
      if ($scope.isEntitySelected(node)) {
        $scope.removeEntityFromSelection(node);
      } else {
        $scope.selected.entities.push(node);
      }
    }
  };

  // Deselezione entity
  $scope.removeEntityFromSelection = function (node) {
    if ($scope.selected.entities && node) {
      $scope.selected.entities.forEach(function (elem, index) {
        if (node.version === elem.version) {
          $scope.selected.entities.splice(index, 1);
          return;
        }
      });
    }
  };
  $scope.isNodeSelected = function (node) {
    if ($scope.selected.treeNode && node) {
      return record2RecordComparator(node, $scope.selected.treeNode);
    }
    return false;
  };
  $scope.isEntitySelected = function (node) {
    var selected = false;
    if ($scope.selected.entities && node) {
      $scope.selected.entities.forEach(function (elem) {
        if (record2RecordComparator(node, elem)) {
          selected = true;
        }
      });
    }
    return selected;
  };

  // Seleziona un nodo dell'albero
  $scope.selectNode = function (node) {
    if (node === undefined) {
      $scope.unselectEntity();
      $scope.showEntitiesList = true;
    } else {
      $scope.selected.treeNode = node;
      $scope.selected.entities = [];
    }
  };

  // Deseleziona il nodo selezionato
  $scope.unselectEntity = function () {
    $scope.entity = {
      wrapper: {},
      type: {},
      version: undefined,
      schema: {},
      model: {},
      form: {},
      parent: $scope.tree.wrapper.model
    };
    $scope.selected.treeNode = undefined;
    $scope.selected.entities = [];
  };

  // Aggiunge un nodo ad un padre
  $scope.addNodesToParent = function (parent, nodes) {
    var root = false;
    if (angular.isUndefined(parent)) {
      root = true;
    }
    parent = parent || $scope.tree.wrapper.model;
    nodes = [].concat(nodes);
    if (parent && nodes && nodes.length > 0) {
      var childrenToAdd = [];
      nodes.forEach(function (child) {
        if (isChildAllowed(child, parent)) {
          childrenToAdd.push(angular.copy(child));
        }
      });
      if (childrenToAdd.length > 0) {
        if (treeService.addNodesToParent(parent, childrenToAdd, CHILDREN_FIELD_NAME)) {
          if (root === false) {
            $scope.addParentToChildren(parent, childrenToAdd);
          }
          $scope.selected.entities = [];
        }
      }
    } else {
      dialogService.dialog('Nessun nodo selezionato', '', 'warning', DEFAULT_DIALOG_TIMEOUT, true);
    }
  };

  // Aggiunge i parent ai figli
  $scope.addParentToChildren = function (parents, children) {
    if (children && [].concat(children).length > 0 && parents && [].concat(parents).length > 0) {
      [].concat(children).forEach(function (child) {
        if (!treeService.addNodesToParent(child, treeService.drainRecords(parents), PARENTS_FIELD_NAME)) {
          dialogService.dialog('Errore nell\'inserimento del riferimento al padre', '', 'danger', DEFAULT_DIALOG_TIMEOUT, true);
        }
      });
    }
  };

  // Rimuove il parent dal figlio
  $scope.removeParentFromChild = function (parent, child) {
    if (child && parent) {
      if (!child.parents) {
        child.parents = [];
      }
      child.parents.forEach(function (p, index) {
        if (p.version === parent.version) {
          child.parents.splice(index, 1);
        }
      });
    }
  };

  // Rimuove un nodo dall'albero
  $scope.removeTreeNode = function (scope) {
    if (scope.$modelValue.nodes.length === 0) {
      scope.remove();
    } else {
      dialogService.confirmDialog('Il nodo non è vuoto, eliminarlo ugualmente?', function () {
        scope.remove();
      }, function () {});
    }
  };

  // utils

  // Salva o aggiorna l'albero nell'indice
  $scope.saveForm = function () {
    if ($scope.isCustomerMissing()) {
      dialogService.alert('Selezionare un cliente per abilitare il salvataggio.', 4000);
    } else {
      if ($scope.tree.wrapper.version) {
        treeFactory.update({
          id: $scope.tree.wrapper.version
        }, $scope.tree.wrapper).$promise.then(function (data) {
          dialogService.dialog('Salvato', '', 'success', DEFAULT_DIALOG_TIMEOUT, true);
        })["catch"](function (response) {
          toaster.pop('error', 'Errore', 'Errore durante il salvataggio');
        });
      } else {
        //var treeObj = {nodes: $scope.tree.wrapper.model.nodes, type: 'structure'};
        var treeObj = $scope.tree.wrapper.model;
        $log.info(angular.toJson(treeObj));
        treeFactory.create(treeObj).$promise.then(function (data) {
          var model = $scope.tree.wrapper.model;
          model.code = data.model.code;
          $scope.tree.wrapper = data;
          $scope.tree.wrapper.model = model;
          dialogService.dialog('Salvato', '', 'success', DEFAULT_DIALOG_TIMEOUT, true);
        })["catch"](function (response) {
          toaster.pop('error', 'Errore', 'Errore durante il salvataggio');
        });
      }
    }
  };

  // Cancella un albero dall'indice
  $scope["delete"] = function () {
    treeFactory["delete"]({
      id: $scope.tree.wrapper.version
    }).$promise.then(function () {
      $scope.tree.wrapper = {};
      $location.path('/treeconfigurator/new');
      dialogService.dialog('Eliminato', '', 'success', DEFAULT_DIALOG_TIMEOUT, true);
    });
  };

  // Recupera la lista delle entities (nodi) da inserire nel tree
  $scope.getEntities = function (query) {
    $scope.entities.loaded = false;
    schemaFactory().query({
      query: $scope.queryParam,
      show_version: false,
      page: 1,
      page_size: 10000
    }).$promise.then(function (data) {
      $scope.entities.list = treeService.drainRecords(data.list);
      $scope.entities.loaded = true;
    });
  };

  // Recupera un tree salvato
  $scope.getTreeByUUID = function (treeId) {
    $scope.tree.loaded = false;
    treeFactory.byUUID({
      id: treeId
    }).$promise.then(function (data) {
      if (data.version) {
        $scope.tree.wrapper = data;
      } else {
        $scope.tree.wrapper = {
          model: {
            nodes: [],
            type: TREETYPE
          }
        };
      }
      $scope.tree.loaded = true;
    });
  };
  $scope.getTree = function () {
    $scope.tree.loaded = false;
    treeFactory.getTreeStructure().$promise.then(function (data) {
      if (data.version) {
        $scope.tree.wrapper = data;
      } else {
        $scope.tree.wrapper = {
          model: {
            nodes: [],
            type: TREETYPE
          }
        };
      }
      $scope.tree.loaded = true;
    });
  };
  $scope.getModelIcon = function (modelName) {
    var icon = modelIconService.getModelIcon(modelName) || 'fa fa-list';
    return icon;
  };
  var validAncestors = function validAncestors(node, parent) {
    //verifica che un tipo di nodo non sia discendente di se stesso
    //parent non contiene al suo interno tutti gli ancestors la verifica quindi
    //cerca tramite $$hashKey il nodo nel tree globale dello scope e da li ricostruisce gli antenati
    //NOTA: i nodi di configurazione sono ignorati

    var rootNode = $scope.tree.wrapper.model;
    var withDescendants = function withDescendants(v) {
      return v && v.nodes && v.nodes.length;
    };
    var getDescendantsCodes = function getDescendantsCodes(node) {
      if (withDescendants(node)) {
        return node.nodes.reduce(function (accumulator, n) {
          return accumulator.concat(getDescendantsCodes(n));
        }, [node.model.code]);
      } else {
        return [node.model.code];
      }
    };
    var nodeCodes = getDescendantsCodes(node).filter(function (v) {
      return v != "configurazione";
    });
    var search = function search(currentNode, ancestorTypes) {
      if (currentNode.model) {
        ancestorTypes.push(currentNode.model.code);
      }
      if (parent.$$hashKey === currentNode.$$hashKey) {
        //nodo parent trovato
        var intersection = ancestorTypes.filter(function (v) {
          return nodeCodes.indexOf(v) != -1;
        });
        return intersection.length == 0; //true se nessun antenato è dello stesso tipo
      }

      if (withDescendants(currentNode)) {
        var childsResult = true;
        currentNode.nodes.forEach(function (node) {
          childsResult = childsResult && search(node, angular.copy(ancestorTypes));
        });
        return childsResult;
      }
      return true;
    };
    return search(rootNode, []);
  };
  var isChildAllowed = function isChildAllowed(node, parent) {
    for (var index in parent.nodes) {
      var n = parent.nodes[index];
      if (node.model.code === n.model.code) {
        return false;
      }
    }
    return validAncestors(node, parent);
  };
  $scope.isCustomerMissing = function () {
    var missing = $scope.app.profileCustomer && angular.isUndefined($scope.currentCustomer);
    return missing;
  };

  //___main___
  $scope.getEntities();
  if ($routeParams.id) {
    $scope.getTreeByUUID($routeParams.id);
  } else {
    if ($scope.app.profileCustomer) {
      $scope.currentCustomer = authFactory.getCurrentCustomer();
      if (angular.isDefined($scope.currentCustomer)) {
        if (angular.isDefined($scope.currentCustomer)) {
          treeFactory.getStructureCode().$promise.then(function (data) {
            $scope.getTree();
          });
        }
      }
    } else {
      $scope.getTree();
    }
  }

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'tree';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
}])
/**** FILTERS ****/.filter('entitiesSearchFilter', function () {
  return function (input, search, destList) {
    if (search) {
      var lower = angular.lowercase(search);
      var output = [];
      input.forEach(function (node) {
        if (angular.isDefined(node.model) && node.model != null) {
          if (angular.lowercase(node.model.code).includes(lower) || angular.lowercase(node.model.description) && angular.lowercase(node.model.description).includes(lower)) {
            output.push(node);
          }
        }
      });
      if (destList) {
        destList = output;
      }
      return output;
    } else {
      return input;
    }
  };
});
"use strict";

// Default:
// {
//   'get':    {method:'GET'},
//   'save':   {method:'POST'},
//   'query':  {method:'GET', isArray:true},
//   'remove': {method:'DELETE'},
//   'delete': {method:'DELETE'}
// }
angular.module('emma.dataset').factory('treeFactory', ["DATA_SET_URL", "$resource", function (DATA_SET_URL, $resource) {
  return $resource(DATA_SET_URL + '/api/tree/:version/:verb/:id/:param1/:param2/:param3', {}, {
    create: {
      method: 'POST',
      params: {
        id: '@version'
      }
    },
    byUUID: {
      method: 'GET',
      params: {
        verb: '_uuid',
        param1: '_current'
      }
    },
    update: {
      method: 'PUT',
      params: {
        id: '@version'
      }
    },
    "delete": {
      method: 'DELETE',
      params: {
        id: '@version'
      }
    },
    allowedChilds: {
      method: 'GET',
      params: {
        verb: '_allowedChilds'
      }
    },
    nodeSchemasList: {
      method: 'GET',
      params: {
        verb: '_flat',
        param1: '_lookup'
      }
    },
    getStructureCode: {
      method: 'GET',
      params: {
        verb: '_structure',
        param1: '_code'
      }
    },
    getDefinitionCode: {
      method: 'GET',
      params: {
        verb: '_definition',
        param1: '_code'
      }
    },
    getTreeStructure: {
      method: 'GET',
      params: {
        verb: '_structure',
        param1: '_current'
      }
    },
    getTreeStructureByCommission: {
      method: 'GET',
      params: {
        verb: '_structure',
        param1: '_commission',
        param2: '@commission'
      }
    },
    getStructureByCommissionAndCustomer: {
      method: 'POST',
      params: {
        verb: '_structure',
        param1: 'commission',
        param2: 'customer'
      }
    },
    //cerca la configurazione del tree per il customer con fallback su quella di commessa
    getTreeDefinition: {
      method: 'GET',
      params: {
        verb: '_definition',
        param1: '_current'
      }
    },
    getTreeSchemaList: {
      method: 'GET',
      params: {
        verb: '_schemalist'
      }
    },
    /* **** VERSION 2 **** */
    recordsIndexing: {
      method: 'GET',
      params: {
        version: 'v2',
        id: '_index',
        param1: '@param1'
      }
    },
    byImplictFilters: {
      method: 'GET',
      params: {
        version: 'v2'
      }
    },
    //byCode:             {method: 'GET', params: {version: 'v2', id: '@id'}}, //WARNING non esiste nel backend!
    filtered: {
      method: 'POST',
      params: {
        version: 'v2',
        id: '@id'
      }
    },
    childs: {
      method: 'POST',
      params: {
        version: 'v2',
        id: '@id',
        param1: '_childs',
        param2: '@param2'
      }
    },
    updateNode: {
      method: 'POST',
      params: {
        version: 'v2',
        id: '@id',
        param1: '_update'
      }
    },
    allowedChildsV2: {
      method: 'POST',
      params: {
        version: 'v2',
        verb: '_allowed',
        param1: '@param1',
        param2: '@param2'
      }
    }
  });
}]);
'use strict';

/**
 * @ngdoc function
 * @name emma.dataset.controller:TreeplanconfigCtrl
 * @description
 * # TreeplanconfigCtrl
 * Controller of the emma.dataset
 */
angular.module('emma.dataset').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/treeplanconfig', {
    templateUrl: 'dataset/tree/treeplanconfig.html',
    controller: 'TreeplanconfigCtrl'
  });
}]).controller('TreeplanconfigCtrl', ["$scope", "schemaFactory", "recordFactory", "pipeConfigurationTree", "treePlanConfigFactory", "toaster", "$log", "authFactory", "$filter", "dialogService", function ($scope, schemaFactory, recordFactory, pipeConfigurationTree, treePlanConfigFactory, toaster, $log, authFactory, $filter, dialogService) {
  // sono state create due liste di filtraggio differenti perchè non è possibile filtrare la lista delle lookup per le priorità
  // quindi onde evitare errori si è tolto il codice del modello anche dalla lookup
  $scope.typeProfilingFilterAssignee = {
    'model.code': 'azienda, fornitore, operatore, segreteria'
  };
  $scope.typeProfilingFilterDefault = {
    'model.code': 'azienda, fornitore, operatore, segreteria, tiposegnalazione, priorita'
  };
  var currentCommission = authFactory.getAuthData().info.commissions.current;
  var typeoperatorFilterField = 'model.typeoperator_map.' + currentCommission.code + '.code';
  var typeoperatorFallbackFilterField = 'model.typeoperator_map.tutte.code';
  $scope.availableTypeOperatorList = [{
    description: 'Responsabile esterno',
    key: 'responsabile_esterno',
    filters: {
      'typeoperator_map': sixFiltersLib.must({
        "specific": sixFiltersLib.should({
          "match_specific": sixFiltersLib.exact(typeoperatorFilterField, 'tecnico_esterno')
        }),
        "fallback": sixFiltersLib.should({
          "miss_specific": sixFiltersLib.missing(typeoperatorFilterField),
          "match_fallback": sixFiltersLib.exact(typeoperatorFallbackFilterField, 'tecnico_esterno')
        })
      })
    }
  }, {
    description: 'Responsabile interno',
    key: 'responsabile_interno',
    filters: {
      'typeoperator_map': sixFiltersLib.must({
        "specific": sixFiltersLib.should({
          "match_specific": sixFiltersLib.exact(typeoperatorFilterField, 'tecnico_commessa')
        }),
        "fallback": sixFiltersLib.should({
          "miss_specific": sixFiltersLib.missing(typeoperatorFilterField),
          "match_fallback": sixFiltersLib.exact(typeoperatorFallbackFilterField, 'tecnico_commessa')
        })
      })
    }
  }, {
    description: 'Capo commessa',
    key: 'capo_commessa',
    filters: {
      'typeoperator_map': sixFiltersLib.must({
        "specific": sixFiltersLib.should({
          "match_specific": sixFiltersLib.exact(typeoperatorFilterField, 'capo_commessa')
        }),
        "fallback": sixFiltersLib.should({
          "miss_specific": sixFiltersLib.missing(typeoperatorFilterField),
          "match_fallback": sixFiltersLib.exact(typeoperatorFallbackFilterField, 'capo_commessa')
        })
      })
    }
  }, {
    description: 'Tecnico commessa',
    key: 'tecnico_commessa',
    filters: {
      'typeoperator_map': sixFiltersLib.must({
        "specific": sixFiltersLib.should({
          "match_specific": sixFiltersLib.exact(typeoperatorFilterField, 'tecnico_commessa')
        }),
        "fallback": sixFiltersLib.should({
          "miss_specific": sixFiltersLib.missing(typeoperatorFilterField),
          "match_fallback": sixFiltersLib.exact(typeoperatorFallbackFilterField, 'tecnico_commessa')
        })
      })
    }
  }, {
    description: 'Manutentore',
    key: 'manutentore',
    filters: {
      'typeoperator_map': sixFiltersLib.must({
        "specific": sixFiltersLib.should({
          "match_specific": sixFiltersLib.exact(typeoperatorFilterField, 'manutentore')
        }),
        "fallback": sixFiltersLib.should({
          "miss_specific": sixFiltersLib.missing(typeoperatorFilterField),
          "match_fallback": sixFiltersLib.exact(typeoperatorFallbackFilterField, 'manutentore')
        })
      })
    }
  }, {
    description: 'Referente Attività',
    key: 'referente_attivita',
    filters: {
      'typeoperator_map': sixFiltersLib.must({
        "specific": sixFiltersLib.should({
          "match_specific": sixFiltersLib.exact(typeoperatorFilterField, 'referente_attivita')
        }),
        "fallback": sixFiltersLib.should({
          "miss_specific": sixFiltersLib.missing(typeoperatorFilterField),
          "match_fallback": sixFiltersLib.exact(typeoperatorFallbackFilterField, 'referente_attivita')
        })
      })
    }
  }];
  $scope.insertNewRowAssignee = {};
  $scope.insertNewRowDefault = {};
  $scope.insertNewRowResponsable = {};
  $scope.insertNewWatcher = {};
  $scope.insertNewRowInvoicing = {};
  $scope.selected = {
    model: {
      configuration: {
        assignee: [],
        "default": [],
        responsable: [],
        watchers: {
          external: [],
          internal: []
        },
        invoicing: []
      }
    }
  };
  function compFields(field1, field2) {
    var equals = false;
    if (field1 && field2) {
      // confronto le 2 strutture
      if (field1 == field2) {
        equals = true;
      }
      if (field1.key && field2.key && field1.key == field2.key) {
        equals = true;
      }
      if (field1.UUID && field2.UUID && field1.UUID == field2.UUID) {
        equals = true;
      }
    } else if (!field1 && !field2) {
      // se sono undefined, sono uguali
      equals = true;
    }
    return equals;
  }
  function itemIsNew(array, row) {
    /* controllo se c'è già una riga uguale tra i default */
    var isNew = true;
    array.forEach(function (item) {
      // confronto: servizio, asset, schema profilazione, azienda, tipo operatore
      if (compFields(item.service_id, row.service_id) && compFields(item.type_id, row.type_id) && compFields(item.typeprofiling_id, row.typeprofiling_id) && compFields(item.company_id, row.company_id) && compFields(item.typeprofiling_filter, row.typeprofiling_filter)) {
        isNew = false;
      }
    });
    return isNew;
  }
  $scope["delete"] = function (array, item) {
    var index = array.indexOf(item);
    $log.info('delete ' + index);
    if (index > -1) {
      array.splice(index, 1);
    }
  };
  $scope.addAssignee = function (row) {
    var assigneeArray = $scope.selected.model.configuration.assignee;
    if (itemIsNew(assigneeArray, row)) {
      assigneeArray.push(angular.copy(row));
      emptyObject(row);
    } else {
      toaster.pop('info', 'Attenzione', 'Configurazione già inserita');
    }
  };
  $scope.deleteAssignee = function (row) {
    var assigneeArray = $scope.selected.model.configuration.assignee;
    $scope["delete"](assigneeArray, row);
  };
  $scope.addDefault = function (row) {
    var defaultArray = $scope.selected.model.configuration["default"];
    if (itemIsNew(defaultArray, row)) {
      defaultArray.push(angular.copy(row));
      emptyObject(row);
      toaster.pop('success', 'OK', 'Configurazione inserita tra quelle di default');
    } else {
      toaster.pop('info', 'Attenzione', 'Configurazione già inserita tra gli assegnatari di default');
    }
  };
  $scope.deleteDefault = function (row) {
    var defaultArray = $scope.selected.model.configuration["default"];
    $scope["delete"](defaultArray, row);
  };
  $scope.addResponsable = function (row) {
    var responsableArray = $scope.selected.model.configuration.responsable;
    responsableArray.push(angular.copy(row));
    emptyObject(row);
  };
  function clearDataEntry() {
    $scope.selected.model = {
      code: undefined,
      description: undefined,
      configuration: {
        assignee: [],
        responsable: [],
        "default": [],
        watchers: {
          external: [],
          internal: []
        }
      }
    };
  }
  function emptyObject(obj) {
    for (var k in obj) {
      delete obj[k];
    }
    return obj;
  }
  function copyInnerProps(source, dest) {
    for (var k in source) {
      dest[k] = angular.copy(source[k]);
    }
    return dest;
  }

  /** PARTE WATCHERS */

  $scope.addWatcher = function (row) {
    if (row.internal == true) {
      /* interno */
      $scope.selected.model.configuration.watchers.internal.push(row.lookup);
    } else if (row.external == true) {
      /* esterno */
      $scope.selected.model.configuration.watchers.external.push(row.mail);
    }
    emptyObject(row); // pulisco la riga
    $scope.newWatcher = false;
  };
  $scope.getMailWatcher = function (row) {
    /* questa riga contiene il riferimento all'operatore da risolvere  */
    var mail = "";
    recordFactory(row.lookup.type).byUUID({
      id: row.lookup.UUID
    }).$promise.then(function (response) {
      if (response.model['mail']) {
        mail = response.model.mail;
      } else {
        mail = "Mail non recuperata";
      }
      return mail;
    });
  };

  /* nel caso la configurazione non abbia la parte dei watchers -> la impostiamo per aggiornare il dato */
  function fixWatchers(data) {
    if (!data.model.configuration.watchers) {
      data.model.configuration.watchers = {
        internal: [],
        external: []
      };
    }
  }

  /** --- FINE PARTE WATCHERS --- */

  /* Controlli fatturazione */
  $scope.addInvoicing = function (row) {
    //verifico che sia interamente compilata
    if (row.company_id && row.service_id && row.type_id && Object.keys(row.company_id).length && row.service_id.length && row.type_id.length) {
      if (!Array.isArray($scope.selected.model.configuration.invoicing)) {
        $scope.selected.model.configuration.invoicing = [];
      }
      var invoicingRows = $scope.selected.model.configuration.invoicing;
      invoicingRows.push(angular.copy(row));
      emptyObject(row);
    } else {
      toaster.pop('warning', 'Attenzione', 'La configurazione che stai inserendo non è valida.');
    }
  };
  $scope.deleteInvoicingRow = function (row) {
    var invoicingRows = $scope.selected.model.configuration.invoicing;
    $scope["delete"](invoicingRows, row);
  };
  $scope.save = function (overwrite) {
    if ($scope.selected.version) {
      var params = {
        id: $scope.selected.version
      };
      if (overwrite) {
        params.history = false;
      }
      treePlanConfigFactory.updateConfiguration(params, $scope.selected).$promise.then(function (response) {
        if (response.version) {
          /** format date */
          $scope.selected = fixDates(response);
          $scope.$parent.updateConfigurationOnTree($scope.selected);
        }
      })["catch"](function (rejection) {
        toaster.pop('error', 'Errore salvataggio', rejection.data.message ? rejection.data.message : rejection.statusText);
      });
    } else {
      treePlanConfigFactory.createConfiguration($scope.selected.model).$promise.then(function (response) {
        if (response.version) {
          $scope.selected = fixDates(response);
          $scope.$parent.saveConfigurationOnTree($scope.selected);
        }
      })["catch"](function (rejection) {
        toaster.pop('error', 'Errore salvataggio', 'Si è verificato un errore durante il salvataggio');
      });
    }
  };
  function fixDates(data) {
    if (data.creationDate) {
      data.creationDate = new Date(data.creationDate);
    }
    if (data.dataIn) {
      data.dataIn = new Date(data.dataIn);
    }
    if (data.dataOut) {
      data.dataOut = new Date(data.dataOut);
    }
    return data;
  }
  $scope.history;
  $scope.editRow = function (row) {
    $scope.history = angular.copy(row);
    row.edit = true;
  };
  $scope.restoreHistory = function (row) {
    copyInnerProps($scope.history, row);
    row.edit = false;
  };
  $scope.confirmRow = function (row) {
    if (row.company_id && row.service_id && row.type_id && Object.keys(row.company_id).length && row.service_id.length && row.type_id.length) {
      $scope.history = undefined;
      row.edit = false;
    } else {
      toaster.pop('warning', 'Attenzione', 'La configurazione che stai inserendo non è valida.');
    }
  };
  $scope.showCompanyLookup = function (row) {
    return angular.isDefined(row.typeprofiling_id) && row.typeprofiling_id.code != 'azienda' && row.typeprofiling_id.code != 'fornitore' && row.typeprofiling_id.code != 'segreteria' && row.typeprofiling_id.code != 'tiposegnalazione' && row.typeprofiling_id.code != 'priorita';
  };
  $scope.showTypeProfilingFilter = function (row) {
    return angular.isDefined(row.typeprofiling_id) && row.typeprofiling_id.code == 'operatore';
  };

  /** --- CARICAMENTO NUOVE CONFIGURAZIONI --- */

  $scope.$watch(['pipeConfigurationTree.treeObjToConfig.list'], function () {
    if (pipeConfigurationTree.treeObjToConfig.list.length != 0) {
      var objConf = pipeConfigurationTree.popTreeObjToConfig();
      clearDataEntry();
      if (objConf != undefined && objConf != null) {
        $scope.selected.model.code = sixObjectLib.makeGUID();
        $scope.selected.model.description = 'Configurazione';
      } else {
        toaster.pop('error', 'Errore creazione configurazione', 'Codice configurazione non presente');
      }
    }
  });

  /** --- APERTURA CONFIGURAZIONE --- */

  $scope.$watch(function () {
    return angular.toJson([pipeConfigurationTree.treeIdToConfig.list.length]);
  }, function () {
    if (pipeConfigurationTree.treeIdToConfig.list.length != 0) {
      var pipedConf = pipeConfigurationTree.popTreeIdToConfig();
      var UUIDConf = pipedConf.uuid;
      var date = pipedConf.date;
      var version = pipedConf.version;
      clearDataEntry();
      if (angular.isDefined(UUIDConf)) {
        var promise;
        if (version) {
          //la ricerca per version ha la priorità
          promise = treePlanConfigFactory.getConfigurationById({
            id: version
          }).$promise;
        } else if (angular.isDefined(date)) {
          date = $filter('date')(date, 'yyyy-MM-dd');
          promise = treePlanConfigFactory.getConfigurationByUUID({
            id: UUIDConf,
            param1: $filter('date')(date, 'yyyy-MM-dd')
          }).$promise;
        } else {
          promise = treePlanConfigFactory.getConfigurationByUUID({
            param1: '_current',
            id: UUIDConf
          }).$promise;
        }
        promise.then(function (response) {
          var responseDocument;
          if (response.model) {
            responseDocument = response;
          } else if (response.list && response.list[0].model) {
            responseDocument = response.list[0];
          }
          if (responseDocument) {
            $scope.selected = responseDocument;
            fixDates($scope.selected);
            fixWatchers($scope.selected);
          } else {
            toaster.pop('error', 'Errore', 'Configurazione inesistente alla data selezionata');
          }
        });
      } else {
        toaster.pop('error', 'Errore', 'Apertura configurazione non riuscita');
      }
    }
  }, true);

  /** --- FILTRO SULLA LOOKUP DEI RECORD --- **/

  // costruisco il filtro per i record sulla base della riga passata (tipo di operatore e dell'azienda)
  $scope.buildRecordFilter = function (row) {
    if (row.typeprofiling_filter || row.company_id) {
      // svuoto il filtro per azzerarlo e poi riempirlo
      row.filters = {};
    }
    // filtro sul tipo di operatore
    if (row.typeprofiling_filter) {
      row.filters = row.typeprofiling_filter.filters;
    } else {
      delete row.filters['typeoperator_map'];
    }
    // filtro sull'azienda
    if (row.company_id) {
      row.filters['company_id_1'] = sixFiltersLib.exact('model.company_id.UUID', row.company_id.UUID);
    } else {
      delete row.filters['company_id_1'];
    }
  };

  /* TIMELINE */
  $scope.timelineFlags = {
    showTimeline: false
  };
  $scope.isNew = function () {
    return !$scope.selected.version;
  };
  $scope.toggleTimeline = function () {
    if ($scope.timelineFlags.showTimeline == true) {
      $scope.timelineFlags.showTimeline = false;
    } else {
      $scope.timelineFlags.showTimeline = true;
      $scope.toggleRightSidebarSize(true);
    }
  };
  $scope.overwriteDocument = function () {
    $scope.save(true);
  };
  $scope.openDetail = function (uuid, version) {
    pipeConfigurationTree.pushTreeVersionToConfig(uuid, version);
  };
  function refreshTimeline() {
    var timeline = angular.element(document.getElementById('timeline_section'));
    timeline.scope().buildTimeline($scope.selected.UUID, $scope.selected.version);
  }
  $scope.hardDelete = function () {
    $scope.deleteDialog.close();
    treePlanConfigFactory.hardDeleteConfiguration({
      id: $scope.selected.version
    }).$promise.then(function (response) {
      pipeConfigurationTree.pushTreeVersionToConfig($scope.selected.UUID);
      refreshTimeline();
    });
  };
  $scope.openDeleteVersionDialog = function () {
    //FIXME
    //TODO: inserire il controllo per verificare che la versione non sia utilizzata in un periodo già fatturato e approvato
    var deleteMessage = 'Stai eliminando permanentemente la versione <i>' + $scope.selected.version + '</i> ' + 'del documento (dataIn: ' + $filter('date')($scope.selected.dataIn, 'dd/MM/yyyy HH:mm:ss') + ' - dataOut: ' + $filter('date')($scope.selected.dataOut, 'dd/MM/yyyy HH:mm:ss') + '), ' + 'modificandone la relativa timeline. <br />' + 'Probabilmente sarà necessario modificare anche gli attributi <i>dataIn</i> e <i>dataOut</i> delle versioni precedenti e successive a questa, per ripristinare una timeline coerente.<br /><br />' + '<b>L\'operazione è IRREVERSIBILE</b><br /><br />' + 'Eliminarla comunque?';
    var dialogScope = {
      lang: 'html',
      deleteMessage: deleteMessage,
      deleteFunction: $scope.hardDelete,
      notDeleteFunction: $scope.closeDeleteDialog
    };
    var opts = {
      name: 'infoDelete',
      closeByDocument: true,
      plain: false
    };
    $scope.deleteDialog = dialogService.templateDialog('recordDelete.html', dialogService.DIALOG_TYPE.DANGER, dialogScope, opts, -1, false);
  };
  $scope.closeDeleteDialog = function () {
    //FIXME
    $scope.deleteDialog.close();
  };

  /* PROFILAZIONE */
  //FIXME? sarebbe meglio profilare separatamente dalla gestione del tree?
  var RESOURCE_NAME = 'tree';
  $scope.isWriteVersionAllowed = function () {
    return true;
    return authFactory.checkPerm(RESOURCE_NAME, 'MODIFY_HISTORY');
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name emma.dataset.controller:TreePlanConfigTimelineCtrl
 * @description
 * # TreePlanConfigTimelineCtrl
 * Controller of the emma.dataset
 */
angular.module('emma.plan').controller('TreePlanConfigTimelineCtrl', ["$scope", "authFactory", "treePlanConfigFactory", function ($scope, authFactory, treePlanConfigFactory) {
  var currentCommission = authFactory.getAuthData().info.commissions.current;
  $scope.data = {};
  $scope.model = {};
  $scope.timeline = [];
  $scope.buildTimeline = function (UUID, selectedVersion) {
    $scope.timeline = treePlanConfigFactory.getTimeline({
      id: UUID
    }).$promise.then(function (data) {
      $scope.timeline = data.list;
      if (angular.isDefined(selectedVersion)) {
        $scope.model['version'] = selectedVersion;
      }
    });
  };
  $scope.getModelDetail = function (version) {
    treePlanConfigFactory.getConfigurationById({
      id: version
    }).$promise.then(function (data) {
      $scope.data = data;
      $scope.model.version = data.version;
      if (angular.isDefined(data.creationDate) && data.creationDate) {
        // elimino i millisecondi dalla visualizzazione
        var date = new Date(data.creationDate);
        data.creationDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
      }
      if (angular.isDefined(data.dataIn) && data.dataIn) {
        // elimino i millisecondi dalla visualizzazione
        var date = new Date(data.dataIn);
        data.dataIn = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
      }
    });
  };
}]);
'use strict';

/**
 * @ngdoc service
 * @name emma.dataset.treeService
 * @description
 * # treeService
 * Service in the emma.dataset.
 */
angular.module('emma.dataset').service('treeService', function () {
  // Deep first
  this.findNodeInTree = function (toFind, parent, comparatorFn, childrenFieldName) {
    childrenFieldName = childrenFieldName || 'nodes';
    for (var index in parent[childrenFieldName]) {
      var node = parent[childrenFieldName][index];
      if (comparatorFn(toFind, node)) {
        return node;
      } else {
        var res = this.findNodeInTree(toFind, node, comparatorFn, childrenFieldName);
        if (res !== undefined) {
          return res;
        }
      }
    }
    return undefined;
  };
  this.findNodeInTreeWithPath = function (path, parent, comparatorFn, childrenFieldName) {
    childrenFieldName = childrenFieldName || 'nodes';
    if ([].concat(path).length == 0) {
      return parent;
    }
    for (var index in parent[childrenFieldName]) {
      var node = parent[childrenFieldName][index];
      if (comparatorFn(path[0], node)) {
        var res = this.findNodeInTreeWithPath(path.slice(1, path.length), node, comparatorFn, childrenFieldName);
        if (res !== undefined) {
          return res;
        }
      }
    }
    return undefined;
  };

  // Width first
  this.getNodePath = function (toFind, parent, comparatorFn, childrenFieldName) {
    childrenFieldName = childrenFieldName || 'nodes';
    var me = parent;

    // Se sono io...
    if (comparatorFn(toFind, me)) {
      return [me];
    }

    // ... altrimenti cerco ricorsivamente tra tutti i miei figli
    for (var index in me[childrenFieldName]) {
      var child = me[childrenFieldName][index];
      var subPath = this.getNodePath(toFind, child, comparatorFn, childrenFieldName);
      if (subPath && subPath.length > 0) {
        return [me].concat(subPath);
      }
    }
    return [];
  };

  // Aggiunge una lista di nodi ad un padre
  this.addNodesToParent = function (parent, nodes, childrenFieldName) {
    childrenFieldName = childrenFieldName || 'nodes';
    if (parent && nodes && [].concat(nodes).length > 0) {
      parent[childrenFieldName] = parent[childrenFieldName].concat(nodes);
      return parent;
    } else {
      return undefined;
    }
  };

  // "Snellisce" il nodo mantenendo soltanto gli attributi necessari
  this.drainRecords = function (originalObj) {
    var drainedList = [];
    var originals = [].concat(originalObj);
    originals.forEach(function (elem) {
      drainedList.push({
        schemaVersion: elem.schemaVersion,
        schemaCode: elem.schemaCode,
        model: {
          code: elem.model.code,
          description: elem.model.description
        },
        UUID: elem.UUID,
        version: elem.version,
        parents: [],
        nodes: []
      });
    });
    if (drainedList.length === 1) {
      return drainedList[0];
    }
    return drainedList;
  };
});
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.treeUtilities
 * @description
 * # treeUtilities
 * Service in the sixEmmaApp.
 */
angular.module('emma.dataset').service('treeUtilities', ['$q', 'treeFactory', function ($q, treeFactory) {
  var typeIdBlacklist = ["configurazione"];

  //restituisce una promessa
  //conterrà l'elenco degli uuid nel treeconfig senza duplicati ed elementi in blacklist
  this.getFlatStructureUuids = function () {
    return treeFactory.getTreeStructure().$promise.then(function (data) {
      var types = extractTreeUUID(data.model);
      if (types !== false) {
        types = types.filter(function (x, i, a) {
          //rimuovo duplicati e elementi in blacklist
          return a.indexOf(x) == i && typeIdBlacklist.indexOf(x) == -1;
        });
      }
      return types;
    });
  };
  function extractTreeUUID(node) {
    if (!node) return false;
    var uuids = [];
    if (typeof node.UUID != "undefined") {
      uuids.push(node.UUID);
    }
    if (node.nodes) {
      for (var n in node.nodes) {
        var child = extractTreeUUID(node.nodes[n]);
        uuids = uuids.concat(child);
      }
    }
    return uuids;
  }
}]);
'use strict';

/**
 * @ngdoc function
 * @name emma.theme.controller:ProfileFiltersCtrl
 * @description
 * # ProfileFiltersCtrl
 * Controller of the emma.dataset
 */
angular.module('emma.dataset').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/treefilter/:profile/:uuid', {
    templateUrl: 'dataset/treefilter/profilefilters.html',
    controller: 'ProfileFiltersCtrl'
  });
}]).controller('ProfileFiltersCtrl', ["APP_URL", "$scope", "authFactory", "$location", "schemaFactory", "recordFactory", "$routeParams", "toaster", "ENV", "DEV", function (APP_URL, $scope, authFactory, $location, schemaFactory, recordFactory, $routeParams, toaster, ENV, DEV) {
  var currentCommission = authFactory.getAuthData().info.commissions.current;
  $scope.recordType = null;
  $scope.record = {
    model: {}
  };
  var profile = $routeParams.profile;
  var uuid = $routeParams.uuid;
  var knownRecordTypes = ["gruppo"];
  var filtersKey = "treefilter";
  var planFiltersKey = "planfilter";

  //implicitamente devo permettere sempre la lettura di alcuni tipi di dato
  var assetWhitelist = ["operatore", "gruppo", "schema", "azienda", "servizio", "dashboardconfiguration", "documentale", "priorita", "trackinglist", "categoria", "sottocategoria", "ruolooperatore"];
  $scope.formattedString = "";
  if (knownRecordTypes.indexOf(profile) !== -1) {
    $scope.profilable = true;
  } else {
    $scope.profilable = false;
  }
  $scope.resetFilters = function () {
    $scope.recordFilters = {
      node: [],
      parents: [],
      formattedObj: {}
    };
    $scope.planFilters = {
      issueVisibility: "all",
      odlVisibility: "all"
    };
  };
  $scope["delete"] = function () {
    recordFactory(profile)["delete"]({
      id: $scope.record.version
    }).$promise.then(function (record) {
      toaster.pop('success', 'Elemento rimosso', 'Elemento rimosso correttamente.');
      $scope.goToProfileList();
    });
  };
  function checkIntegrity() {
    var codeNotPresent = false;
    // controllo che abbia il codice
    if (!$scope.record.model || !$scope.record.model.code) {
      codeNotPresent = true;
      toaster.pop('error', 'Errore inserimento', 'Codice non presente.');
    }
    return !codeNotPresent;
  }
  $scope.save = function () {
    if (checkIntegrity()) {
      if (!$scope.record.version) {
        var params = {
          commission_dependent: true
        };
        $scope.record.commission = [currentCommission.code];
        recordFactory(profile).create(params, $scope.record.model).$promise.then(function (record) {
          toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
          $scope.goToProfileList();
        });
        return;
      }
      //update
      if (angular.isDefined($scope.formattedString) && $scope.formattedString != "") {
        try {
          $scope.recordFilters.formattedObj = JSON.parse($scope.formattedString);
        } catch (ex) {
          toaster.pop('error', 'Salvataggio fallito', 'Il dettaglio avanzato non contiene json valido.');
          return;
        }
      }
      if (Object.keys($scope.recordFilters.formattedObj).length == 0) {
        //ho un oggetto vuoto, non applico filtri
        $scope.recordFilters = undefined;
      }
      $scope.record.model[filtersKey] = $scope.recordFilters;
      $scope.record.model[planFiltersKey] = $scope.planFilters;
      $scope.record.commission = [currentCommission.code];
      //Scrive tutto recordFilters nel model del profilo corrente.
      var recordToSave = angular.copy($scope.record);
      recordToSave.model[filtersKey].node.forEach(function (v, k, obj) {
        obj[k] = JSON.stringify(v);
      });
      recordToSave.model[filtersKey].parents.forEach(function (v, k, obj) {
        obj[k] = JSON.stringify(v);
      });
      recordToSave.model[filtersKey].formattedObj = JSON.stringify(recordToSave.model[filtersKey].formattedObj);
      recordFactory(profile).update(recordToSave).$promise.then(function (record) {
        toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
        $scope.goToProfileList();
      });
    }
  };
  $scope.goToProfileList = function () {
    $location.path('/treefilter/' + profile);
  };
  $scope.newProfile = function () {
    $location.path('/treefilter/' + profile + '/new');
  };
  $scope.addNodeFilter = function () {
    $scope.recordFilters.node.push({
      "filtersOut": [],
      "filters": [],
      "model": {}
    });
  };
  $scope.removeNodeFilter = function (k) {
    $scope.recordFilters.node.splice(k, 1);
  };
  $scope.addParentFilter = function () {
    $scope.recordFilters.parents.push({
      uuid: "",
      code: "",
      type: {},
      description: "",
      parents: {}
    });
  };
  $scope.removeParentFilter = function (k) {
    $scope.recordFilters.parents.splice(k, 1);
  };
  $scope.searchNode = function (scope, field) {
    //console.log(scope.rule);
    if (angular.isUndefined(scope.rule.type.type_id)) {
      toaster.pop('error', 'Seleziona un modello', 'Devi selezionare un modello per poter effettuare la ricerca.');
    } else {
      var payload = {
        page: 1,
        page_size: 1,
        show_revision: false
      };
      var filters = {};
      if (field == 'code') {
        filters['code'] = sixFiltersLib.exact('model.code', scope.rule.code);
      }
      if (field == 'uuid') {
        filters['uuid'] = sixFiltersLib.exact('UUID', scope.rule.uuid);
      }
      recordFactory(scope.rule.type.type_id.UUID).search(payload, filters).$promise.then(function (resp) {
        if (resp.totalResults == 0) {
          toaster.pop('error', 'Non trovato', 'Nessun risultato trovato, modifica i dati inseriti e riprova.');
        } else {
          scope.rule.code = resp.list[0].model.code;
          scope.rule.uuid = resp.list[0].UUID;
          scope.rule.description = resp.list[0].model.description;
          scope.rule.parents = resp.list[0].parents;
        }
      });
    }
  };
  $scope.buildformattedString = function () {
    //console.log("rebuilding formatted string");
    var out = {};
    //filtri nodo:
    var node = $scope.recordFilters.node;
    var nodeFilters = {};
    for (var n in node) {
      if (angular.isDefined(node[n].model.type_id)) {
        var subfilters = {};
        for (var f in node[n].filtersOut) {
          var key = f.replace(new RegExp("\\.", 'g'), "__"); //https://www.elastic.co/guide/en/elasticsearch/reference/2.0/breaking_20_mapping_changes.html#_field_names_may_not_contain_dots
          subfilters[key] = node[n].filtersOut[f];
        }
        //accodo ai filtri il vincolo sulla tipologia di asset
        subfilters["type_filter"] = sixFiltersLib.exact("schemaCode", node[n].model.type_id.UUID);
        var whitelistPos = assetWhitelist.indexOf(node[n].model.type_id.UUID);
        if (whitelistPos !== -1) {
          assetWhitelist.splice(whitelistPos, 1);
          console.log(whitelistPos);
        }
        nodeFilters["node" + n] = sixFiltersLib.should(subfilters);
      }
    }
    if (Object.keys(nodeFilters).length) {
      for (var w in assetWhitelist) {
        //aggiungo gli asset in whitelist solo se necessario
        nodeFilters["whitelist" + w] = sixFiltersLib.should({
          "whiteList": sixFiltersLib.exact("schemaCode", assetWhitelist[w])
        });
      }
      out["node"] = sixFiltersLib.must(nodeFilters);
    }

    //filtri albero
    var parents = $scope.recordFilters.parents;
    var parentFilters = {};
    for (var p in parents) {
      if (angular.isDefined(parents[p].type.type_id)) {
        //filtro per includere tutti i nodi che hanno tra i parent la radice scelta
        var subfilters = {
          "p_type": sixFiltersLib.exact("parents.type", parents[p].type.type_id.UUID),
          "p_uuid": sixFiltersLib.exact("parents.UUID", parents[p].uuid)
        };
        parentFilters["descendants" + p] = sixFiltersLib.should({
          "nest_wrap": sixFiltersLib.nested("parents", subfilters)
        });

        //per includere anche la radice scelta tra i risultati
        var pfilter = {
          "type": sixFiltersLib.exact("schemaCode", parents[p].type.type_id.UUID),
          "uuid": sixFiltersLib.exact("UUID", parents[p].uuid)
        };
        parentFilters["root" + p] = sixFiltersLib.should(pfilter);

        //includo anche i parents della radice
        var ancestors = parents[p].parents;
        for (var a in ancestors) {
          if (ancestors[a].type && ancestors[a].UUID) {
            var ancestorsfilter = {
              "type": sixFiltersLib.exact("schemaCode", ancestors[a].type),
              "uuid": sixFiltersLib.exact("UUID", ancestors[a].UUID)
            };
            parentFilters["ancestors" + p + "_" + a] = sixFiltersLib.should(ancestorsfilter);
          }
        }
      }
    }
    if (Object.keys(parentFilters).length) {
      parentFilters["parentless"] = sixFiltersLib.should({
        "nest_wrap": sixFiltersLib.nested("parents", {
          "withparents": sixFiltersLib.exists("parents")
        }, "andnot")
      });
      out["parents"] = sixFiltersLib.must(parentFilters);
    }
    $scope.formattedString = JSON.stringify(out, null, '\t');
  };
  $scope.$watch("recordFilters.node", $scope.buildformattedString, true);
  $scope.$watch("recordFilters.parents", $scope.buildformattedString, true);
  $scope.onFilterChanged = function () {
    $scope.buildformattedString();
  };

  /* STARTUP - resetto i filtri e carico i dati */
  $scope.resetFilters();
  function getSchema() {
    schemaFactory().byCode({
      id: profile
    }).$promise.then(function (schemaDefinition) {
      $scope.recordType = schemaDefinition;
      if (!schemaDefinition || !schemaDefinition.model || !schemaDefinition.model.schema.properties) {
        $scope.profilable = false;
      }
    });
  }
  function getRecord() {
    recordFactory(profile).byUUID({
      id: uuid
    }).$promise.then(function (record) {
      $scope.record = record;
      if (!record || !record.model) {
        $scope.profilable = false;
        toaster.pop('error', 'Errore', 'Errore durante il caricamento del dato \'' + uuid + '\'');
      } else {
        if (record.model[planFiltersKey]) {
          $scope.planFilters = record.model[planFiltersKey];
        }
        if (record.model[filtersKey]) {
          $scope.recordFilters = record.model[filtersKey];
          //decode delle parti in json condizionato per retrocompatibilità in lettura
          $scope.recordFilters.node.forEach(function (v, k, obj) {
            if (typeof v == "string") obj[k] = JSON.parse(v);
          });
          $scope.recordFilters.parents.forEach(function (v, k, obj) {
            if (typeof v == "string") obj[k] = JSON.parse(v);
          });
          if (typeof record.model[filtersKey].formattedObj == "string") {
            $scope.recordFilters.formattedObj = JSON.parse(record.model[filtersKey].formattedObj);
          }
          $scope.formattedString = JSON.stringify($scope.recordFilters.formattedObj, null, '\t');
        }
      }
    });
  }
  getSchema();
  if ($routeParams.uuid != 'new') {
    getRecord();
  }
}]);
'use strict';

/**
 * @ngdoc function
 * @name emma.theme.controller:ProfileListCtrl
 * @description
 * # ProfileListCtrl
 * Controller of the emma.dataset
 */
angular.module('emma.dataset').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/treefilter/:profile', {
    templateUrl: 'dataset/treefilter/profilelist.html',
    controller: 'ProfileListCtrl'
  });
}]).controller('ProfileListCtrl', ["$scope", "schemaFactory", "recordFactory", "$routeParams", "$location", "sixGridPaginationConstants", "uiGridConstants", function ($scope, schemaFactory, recordFactory, $routeParams, $location, sixGridPaginationConstants, uiGridConstants) {
  $scope.recordType = null;
  var profile = $routeParams.profile;
  var knownRecordTypes = ["gruppo"];
  var filtersKey = "treefilter";
  if (knownRecordTypes.indexOf(profile) !== -1) {
    $scope.profilable = true;
  } else {
    $scope.profilable = false;
  }
  schemaFactory().byCode({
    id: profile
  }).$promise.then(function (schemaDefinition) {
    $scope.recordType = schemaDefinition;
    if (!schemaDefinition || !schemaDefinition.model || !schemaDefinition.model.schema.properties) {
      $scope.profilable = false;
    } else {
      $scope.viewGridOptions.columnDefs[1].displayName = schemaDefinition.model.description;
    }
  });
  $scope.rows = {
    list: [],
    totalResults: 0
  };
  $scope.params = {
    pageNumber: 0,
    pageSize: 10,
    filters: {}
  };
  $scope.viewGridOptions = {
    enableFiltering: true,
    enableOrdering: true,
    showGridFooter: true,
    showColumnFooter: true,
    enableHorizontalScrollbar: 1,
    appScopeProvider: $scope,
    columnDefs: [{
      displayName: '',
      field: 'id',
      width: 36,
      enableCellEdit: true,
      enableFiltering: false,
      enableSorting: false,
      cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/treefilter/{{grid.appScope.getProfile()}}/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' + '<span class="fa fa-search"></span>' + '</a>' + '</div>'
    }, {
      displayName: "Codice",
      field: 'model.code',
      enableFiltering: true,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }, {
      displayName: "Descrizione",
      field: 'model.description',
      enableFiltering: true,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }, {
      displayName: "Operatori",
      field: 'model.operatori',
      enableFiltering: true,
      cellTemplate: '<div class="ui-grid-cell-contents">' + '<span ng-repeat="operatore in row.entity.model.operatori">{{operatore.description}}({{operatore.code}});&nbsp&nbsp</span>' + '</div>',
      filters: [{
        type: sixGridPaginationConstants.filterType.SIXLOOKUP,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }, {
      displayName: 'Filtri',
      field: 'model[' + filtersKey + ']',
      enableFiltering: true,
      cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<span>{{grid.appScope.readableFilters(row.entity.model)}}</span>' + '</div>',
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }]
  };
  $scope.gridCustomFilters = {
    operatorsFilter: {}
  };
  $scope.lookupCallback = function (item) {
    if (item) {
      $scope.gridCustomFilters.operatorsFilter = item;
    }
  };
  $scope.getList = function () {
    var payload = {
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      show_revision: false,
      solve_inherit: true,
      query: $scope.params.queryParam //recupera dalla sixgrid il filtro "generico"
    };

    return recordFactory(profile).search(payload, $scope.params.filters).$promise.then(function (result) {
      $scope.rows.list = result.list || [];
      $scope.rows.totalResults = result.totalResults;
      return result;
    });
  };
  $scope.readableFilters = function (model) {
    if (model[filtersKey]) {
      var n = model[filtersKey].node;
      var p = model[filtersKey].parents;
      var concat = 'Filtri asset: ' + n.length + " - Filtri tree: " + p.length;
      return concat;
    } else {
      return 'Nessun filtro';
    }
  };
  $scope.getProfile = function () {
    return profile;
  };
  $scope.goToNewProfile = function () {
    $location.path('/treefilter/' + profile + '/new');
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name emma.dataset.controller:UomCtrl
 * @description
 * # UomCtrl
 * Controller of the emma.dataset
 */
angular.module('emma.dataset').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/uom/:id', {
    templateUrl: 'dataset/uom/uom_detail.html',
    controller: 'UomCtrl'
  }).when('/uom', {
    templateUrl: 'dataset/uom/uom_list.html',
    controller: 'UomCtrl'
  });
}]).controller('UomCtrl', ["$scope", "$window", "$location", "$log", "$routeParams", "uomFactory", "dialogService", "toaster", "authFactory", function ($scope, $window, $location, $log, $routeParams, uomFactory, dialogService, toaster, authFactory) {
  $scope.model = {
    formula: undefined,
    inputName: undefined,
    uom_from: {
      uom: {},
      obj: ''
    },
    uom_to: {
      uom: {},
      obj: ''
    },
    record_id: {},
    constant_params: [],
    rounding_mode: '',
    precision: ''
  };
  $scope.container_from = {
    obj: {}
  };
  $scope.container_to = {
    obj: {}
  };
  $scope.output = undefined;
  var DEFAULT_DIALOG_TIMEOUT = 4000;
  function buildPath(id) {
    return 'conversion/_id/' + id;
  }
  if ($routeParams.id && 'new' !== $routeParams.id) {
    uomFactory.byID({
      id: $routeParams.id
    }).$promise.then(function (data) {
      $scope.model = data;
      if (angular.isUndefined($scope.model.record_id)) {
        $scope.model.record_id = {};
      }
    });
  }
  $scope.newUom = function () {
    $location.path('uom/new');
  };
  $scope.saveForm = function () {
    if (!$scope.model.formula) {
      toaster.pop('error', 'Errore', 'Nessuna formula inserita');
    } else {
      if (!$scope.model.uom_from.uom.UUID) {
        toaster.pop('error', 'Errore', 'UM di partenza mancante');
      } else {
        if (!$scope.model.uom_to.uom.UUID) {
          toaster.pop('error', 'Errore', 'UM di destinazione mancante');
        } else {
          if ($scope.verifyParameters()) {
            $scope.model.uom_from.obj = $scope.container_from.obj.model;
            $scope.model.uom_to.obj = $scope.container_to.obj.model;
            if ($scope.model.code) {
              uomFactory.update({
                id: $scope.model.code
              }, $scope.model).$promise.then(function () {
                $window.history.back();
              });
            } else {
              uomFactory.create($scope.model).$promise.then(function () {
                $window.history.back();
              });
            }
          }
        }
      }
    }
  };
  $scope.deleteWithDialog = function (idToDelete) {
    dialogService.confirmDialog('Eliminare il record di ' + $scope.schemaDescription + ' \'' + $scope.model.code + '\'?', function () {
      $scope["delete"](idToDelete);
    });
  };
  $scope["delete"] = function (idToDelete) {
    uomFactory["delete"]({
      id: $scope.model.code
    }).$promise.then(function () {
      $window.history.back();
    });
  };
  $scope.formChanged = function () {
    /* da implementare, è stato introdotto dalla select sugli arrotondamenti */
  };
  $scope.pageChanged = function () {
    $scope.listWrapper = uomFactory.query({
      query: $scope.queryParam,
      page: $scope.listWrapper.currentPage
    });
  };
  $scope.getListWrapper = function () {
    uomFactory.query({
      query: $scope.queryParam
    }).$promise.then(function (data) {
      $scope.listWrapper = data;
    });
  };
  $scope.getListWrapper();
  $scope.calculate = function (inputVal) {
    if (inputVal === undefined) {
      $scope.output = null;
      toaster.pop('warning', 'Attenzione', 'Inserire un valore di input');
    } else {
      var args = $scope.model.inputName;
      var value = new Array();
      var body = 'return ' + $scope.model.formula + ';';
      for (var i = 0; i < $scope.model.constant_params.length; i++) {
        args = args + ', ' + $scope.model.constant_params[i].name;
      }
      if (isNaN(parseFloat(inputVal))) {
        toaster.pop('warning', 'Attenzione', 'Inserire un input valido (valore numerico)');
        return;
      }
      value.push(parseFloat(inputVal));
      if (!$scope.verifyParameters()) {
        return;
      }
      for (var i = 0; i < $scope.model.constant_params.length; i++) {
        value.push(parseFloat($scope.model.constant_params[i].value));
      }
      var fn = new Function(args, body);
      $scope.output = fn.apply(null, value);
      if ($scope.model.rounding_mode === 'none') {
        $scope.output = none($scope.output);
      } else if ($scope.model.rounding_mode === 'round') {
        $scope.output = round($scope.output, $scope.model.precision);
      } else if ($scope.model.rounding_mode === 'ceil') {
        $scope.output = ceil($scope.output, $scope.model.precision);
      } else if ($scope.model.rounding_mode === 'floor') {
        $scope.output = floor($scope.output, $scope.model.precision);
      }
    }
  };
  $scope.verifyParameters = function () {
    var success = true;
    for (var i = 0; i < $scope.model.constant_params.length; i++) {
      var name = $scope.model.constant_params[i].name;
      var value = $scope.model.constant_params[i].value;
      if (angular.isUndefined(name) || name.length == 0) {
        toaster.pop('warning', 'Attenzione', 'Non è possibile inserire un parametro privo di nome');
        success = false;
        break;
      } else {
        if (angular.isUndefined(value) || isNaN(value)) {
          toaster.pop('warning', 'Attenzione', 'Inserire un valore numerico per ogni parametro');
          success = false;
          break;
        }
      }
    }
    return success;
  };
  $scope.deleteItemOnArray = function (i) {
    var rows = $('.params-row');
    $scope.model.constant_params.splice(i, 1);
    rows[i].remove();
  };
  $scope.appendToArray = function () {
    var item = {};
    if ($scope.verifyParameters()) {
      $scope.model.constant_params.push(item);
    }
  };
  function none(result) {
    return result;
  }
  function round(result, precision) {
    //return Math.round(result);
    var app = 1;
    for (var i = 0; i < precision; i++) {
      app = app * 10;
    }
    return Math.round(result * app) / app;
  }
  function ceil(result, precision) {
    //return Math.ceil(result);
    var app = 1;
    for (var i = 0; i < precision; i++) {
      app = app * 10;
    }
    return Math.ceil(result * app) / app;
  }
  function floor(result, precision) {
    //return Math.floor(result);
    var app = 1;
    for (var i = 0; i < precision; i++) {
      app = app * 10;
    }
    return Math.floor(result * app) / app;
  }

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'conversion';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
}]);
"use strict";

// Default:
// {
//   'get':    {method:'GET'},
//   'save':   {method:'POST'},
//   'query':  {method:'GET', isArray:true},
//   'remove': {method:'DELETE'},
//   'delete': {method:'DELETE'}
// }
angular.module('emma.dataset').factory('uomFactory', ["DATA_SET_URL", "$resource", function (DATA_SET_URL, $resource) {
  return $resource(DATA_SET_URL + '/api/conversion/:verb/:id/:param1/:param2/:param3', {}, {
    query: {
      method: 'GET',
      isArray: false
    },
    create: {
      method: 'POST',
      params: {
        id: '@version'
      }
    },
    byUUID: {
      method: 'GET',
      params: {
        verb: '_uuid',
        param1: '_current'
      }
    },
    byID: {
      method: 'GET',
      params: {
        verb: '_id'
      }
    },
    update: {
      method: 'PUT',
      params: {
        id: '@version'
      }
    },
    "delete": {
      method: 'DELETE',
      params: {
        id: '@version'
      }
    },
    allowedChilds: {
      method: 'GET',
      params: {
        verb: '_allowedChilds'
      }
    }
  });
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:BudgetCtrl
 * @description
 * # BudgetCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/budget/get', {
    templateUrl: 'energy/budget/budget_list.html',
    controller: 'BudgetCtrl'
  }).when('/budget/get/:code', {
    templateUrl: 'energy/budget/budget_detail.html',
    controller: 'BudgetCtrl'
  }).when('/budget/detail/', {
    templateUrl: 'energy/budget/budget_detail.html',
    controller: 'BudgetCtrl'
  }).when('/budget/detail/:code', {
    templateUrl: 'energy/budget/budget_detail.html',
    controller: 'BudgetCtrl'
  }).when('/budget/new', {
    templateUrl: 'energy/budget/budget_new.html',
    controller: 'BudgetCtrl'
  }).when('/budget/add/:codeToAdd', {
    templateUrl: 'energy/budget/budget_new.html',
    controller: 'BudgetCtrl'
  });
}]).controller('BudgetCtrl', ["$scope", "$routeParams", "$rootScope", "$log", "$filter", "$location", "authFactory", "budgetFactory", "evalFactory", "recordFactory", "$q", "toaster", "SaveAs", "APP_URL", "$http", "dialogService", "errorService", "loadingBarService", function ($scope, $routeParams, $rootScope, $log, $filter, $location, authFactory, budgetFactory, evalFactory, recordFactory, $q, toaster, SaveAs, APP_URL, $http, dialogService, errorService, loadingBarService) {
  var currentCommission = authFactory.getAuthData().info.commissions.current;
  $scope.CODE_PATTERN = /^[a-zA-Z]+\w*$/;
  $scope.record = {};
  $scope.year = $filter('date')(new Date(), 'yyyy');
  $scope.availableBudgetCodes = [];
  $scope.isCollapsed = false;
  $scope.importingOperation = false;
  $scope.graphData = [];
  $scope.budget = {
    budget_code: undefined,
    budget_description: undefined,
    budget_default: false,
    searchCode: undefined,
    eval_date: null
  };
  $scope.dateOptions = {
    formatYear: 'yyyy'
  };
  $scope.priceListGas = {};
  $scope.priceListElectricity = {};
  $scope.priceList = {};
  $scope.deleteDialog = undefined;
  $scope.search = {};
  $scope.views = {
    um: true,
    std: false,
    economic: false
  };
  var gridDoubleCellTemplate = '<div class="ui-grid-cell ui-grid-cell-contents" style="height: 75px !important">' + '<div>{{row.entity[col.field].tot | number: 2}} <span>{{row.entity[col.field].um.description}}</span>' + '</div>' + '<div ng-if="row.entity.record_type !== \'contatoreelettricita\' && row.entity[col.field].tot_std">{{row.entity[col.field].tot_std | number: 2}} kWh</div>' + '<div ng-if="row.entity[col.field].tot_economic">{{row.entity[col.field].tot_economic | number: 2}} €</div>' + '</div>';
  var monthsColumnDefs = [{
    name: 'tipo',
    field: 'record_type',
    enableFiltering: true
  }, {
    name: 'cod-descr',
    field: 'record_code',
    enableFiltering: true,
    cellTemplate: '<div class="ui-grid-cell ui-grid-cell-contents"><a href ng-click="grid.appScope.getRecordDetailURL(row.entity.record_type, row.entity.record_uuid)">{{row.entity.record_code}} - {{row.entity.record_description}}</a></div>'
  }, {
    name: 'anno',
    enableFiltering: true
  }, {
    name: 'gennaio',
    enableFiltering: false,
    cellTemplate: gridDoubleCellTemplate
  }, {
    name: 'febbraio',
    enableFiltering: false,
    cellTemplate: gridDoubleCellTemplate
  }, {
    name: 'marzo',
    enableFiltering: false,
    cellTemplate: gridDoubleCellTemplate
  }, {
    name: 'aprile',
    enableFiltering: false,
    cellTemplate: gridDoubleCellTemplate
  }, {
    name: 'maggio',
    enableFiltering: false,
    cellTemplate: gridDoubleCellTemplate
  }, {
    name: 'giugno',
    enableFiltering: false,
    cellTemplate: gridDoubleCellTemplate
  }, {
    name: 'luglio',
    enableFiltering: false,
    cellTemplate: gridDoubleCellTemplate
  }, {
    name: 'agosto',
    enableFiltering: false,
    cellTemplate: gridDoubleCellTemplate
  }, {
    name: 'settembre',
    enableFiltering: false,
    cellTemplate: gridDoubleCellTemplate
  }, {
    name: 'ottobre',
    enableFiltering: false,
    cellTemplate: gridDoubleCellTemplate
  }, {
    name: 'novembre',
    enableFiltering: false,
    cellTemplate: gridDoubleCellTemplate
  }, {
    name: 'dicembre',
    enableFiltering: false,
    cellTemplate: gridDoubleCellTemplate
  }, {
    name: 'totale',
    field: 'tot',
    enableFiltering: false,
    cellTemplate: gridDoubleCellTemplate
  }];
  var monthsColumnDefsSub = [{
    name: 'voce',
    field: 'voice_code',
    enableFiltering: true
  }, {
    name: 'prezzo un.',
    field: 'unit_price',
    enableFiltering: false,
    cellTemplate: gridDoubleCellTemplate
  }, {
    name: 'gennaio',
    enableFiltering: false,
    cellTemplate: gridDoubleCellTemplate
  }, {
    name: 'febbraio',
    enableFiltering: false,
    cellTemplate: gridDoubleCellTemplate
  }, {
    name: 'marzo',
    enableFiltering: false,
    cellTemplate: gridDoubleCellTemplate
  }, {
    name: 'aprile',
    enableFiltering: false,
    cellTemplate: gridDoubleCellTemplate
  }, {
    name: 'maggio',
    enableFiltering: false,
    cellTemplate: gridDoubleCellTemplate
  }, {
    name: 'giugno',
    enableFiltering: false,
    cellTemplate: gridDoubleCellTemplate
  }, {
    name: 'luglio',
    enableFiltering: false,
    cellTemplate: gridDoubleCellTemplate
  }, {
    name: 'agosto',
    enableFiltering: false,
    cellTemplate: gridDoubleCellTemplate
  }, {
    name: 'settembre',
    enableFiltering: false,
    cellTemplate: gridDoubleCellTemplate
  }, {
    name: 'ottobre',
    enableFiltering: false,
    cellTemplate: gridDoubleCellTemplate
  }, {
    name: 'novembre',
    enableFiltering: false,
    cellTemplate: gridDoubleCellTemplate
  }, {
    name: 'dicembre',
    enableFiltering: false,
    cellTemplate: gridDoubleCellTemplate
  }, {
    name: 'totale',
    field: 'tot',
    enableFiltering: false,
    cellTemplate: gridDoubleCellTemplate
  }];
  $scope.gridImportOptions = {
    importerDataAddCallback: function importerDataAddCallback(grid, newObjects) {
      // $scope.data = $scope.data.concat( newObjects ); //questa in realtà non viene chiamata... la direttiva xlsx non scatena l'evento..
    },
    onRegisterApi: function onRegisterApi(gridApi) {
      $scope.gridImportApi = gridApi;
    }
  };

  //dati caricati da xls
  $scope.$watch(function () {
    /* qua arriva l'array delle righe in $scope.gridOptions.xlsData  */
    return $scope.gridImportOptions.xlsData;
  }, function (newValue) {
    if (newValue && newValue.length > 0) {
      /* chiamata alla funzione per formare i dati */
      $scope.fixBudget();
    }
  });
  $scope.fixBudget = function () {
    for (var n = 0; n < $scope.gridImportOptions.xlsData.length; n++) {
      for (var i = 0; i < 12; i++) {
        parseMonth(sixDateLib.getMonthName(i), $scope.gridImportOptions.xlsData[n]);
      }
    }
    //console.log($scope.gridImportOptions.xlsData);
    $scope.gridImportOptions.data = $scope.gridImportOptions.xlsData;
    $scope.data = $scope.gridImportOptions.xlsData;
    $scope.importingOperation = true;
  };
  function parseMonth(month, line) {
    if (line[month]) {
      line[month] = parseFloat(line[month]);
    } else {
      line[month] = 0;
    }
  }
  $scope.downloadTemplate = function () {
    var anchor = $('#linkToTemplate');
    var url = anchor.attr("href");
    anchor.click(function (e) {
      e.preventDefault();
      window.location.href = url;
    });
    anchor.click();
  };
  var parse = function parse(st) {
    if ('' === st) {
      return 0;
    } else if (st.indexOf(',') === st.length - 3) {
      st = st.replace('.', '').replace(',', '.');
    } else {
      st = st.replace(',', '');
    }
    return parseFloat(st, 2);
  };
  $scope.parseColumn = function (value, columnName) {
    switch (columnName) {
      case 'anno':
      case 'record_code':
      case 'record_id':
      case 'record_type':
        return value;
      default:
        if ($.isNumeric(value)) {
          return $filter('number')(value, 2);
        }
        return value;
    }
  };
  $scope.parseBoolean = function (value) {
    switch (value) {
      case 'true':
      case 'True':
      case 'TRUE':
      case 't':
      case 'T':
      case '1':
      case true:
        return true;
      default:
        return false;
    }
  };
  $scope.percent = 0;
  $scope.data = [];
  $scope.detailSelected = undefined;

  /***** Grid options *****/

  $scope.gridDetailOptions = {
    enableFiltering: true,
    enableSorting: true,
    enableRowSelection: false,
    enableRowHeaderSelection: false,
    multiSelect: false,
    enableGridMenu: true,
    exporterMenuPdf: false,
    data: 'data',
    //rowTemplate: $scope.gridRowTemplate,
    columnDefs: monthsColumnDefs,
    expandableRowTemplate: 'energy/budget/expandableRowTemplate.html',
    rowHeight: 75,
    expandableRowHeight: 240,
    //subGridVariable will be available in subGrid scope
    expandableRowScope: {
      parseColumn: $scope.parseColumn
    },
    onRegisterApi: function onRegisterApi(gridApi) {
      $scope.gridApi = gridApi;
      gridApi.selection.on.rowSelectionChanged($scope, function (row) {
        if (row.isSelected) {
          $scope.detailSelected = row.entity;
        } else {
          $scope.detailSelected = undefined;
        }
      });
    }
  };
  $scope.colListTemplate = '<div class="ui-grid-cell ui-grid-cell-contents" ng-class="{\'font-bold\': grid.appScope.parseBoolean(row.entity.default)}">{{row.entity[col.field}}</div>';
  $scope.gridListOptions = {
    enableSorting: true,
    enableGridMenu: false,
    exporterMenuPdf: false,
    enableFiltering: true,
    data: 'availableBudgetCodes',
    //rowTemplate: $scope.colListTemplate,
    columnDefs: [{
      displayName: '',
      field: 'code',
      enableFiltering: false,
      width: 36,
      cellTemplate: '<div class="ui-grid-cell-contents"><button type="button" class="btn btn-xs btn-primary" ng-click="grid.appScope.viewBudgetDetail(row.entity.UUID)"><i class="fa fa-search"></i></button></div>'
    }, {
      displayName: '',
      field: 'code',
      enableFiltering: false,
      width: 36,
      cellTemplate: '<div class="ui-grid-cell-contents"><button type="button" class="btn btn-xs btn-primary" ng-click="grid.appScope.analyze(row.entity.UUID)"><i class="fa fa-euro"></i></button></div>'
    }, {
      displayName: 'Codice',
      field: 'code',
      width: 400,
      cellTemplate: '<div class="ui-grid-cell-contents" ng-class="{\'font-bold\': grid.appScope.parseBoolean(row.entity.default)}">{{row.entity.code}}</div>'
    }, {
      displayName: 'Descrizione',
      field: 'description',
      cellTemplate: '<div class="ui-grid-cell-contents" ng-class="{\'font-bold\': grid.appScope.parseBoolean(row.entity.default)}">{{row.entity.description}}</div>'
    }, {
      displayName: 'Anno',
      field: 'year',
      width: 100,
      cellTemplate: '<div class="ui-grid-cell-contents" ng-class="{\'font-bold\': grid.appScope.parseBoolean(row.entity.default)}">{{row.entity.year}}</div>'
    }, {
      displayName: 'Default',
      field: 'default',
      enableFiltering: false,
      width: 100,
      cellTemplate: '<div class="ui-grid-cell-contents" ng-class="{\'font-bold\': grid.appScope.parseBoolean(row.entity.default)}" style="vertical-align:middle;text-align:center;"><span class="fa fa-check" ng-if="grid.appScope.parseBoolean(row.entity.default)"></span></div>'
    }]
  };

  /***** *****/

  $scope.open = function ($event) {
    $event.preventDefault();
    $event.stopPropagation();
    $scope.opened = true;
  };
  function setDefaultDimension(string) {
    string = '' + string;
    if (string.length == 1) {
      string = '0' + string;
    }
    return string;
  }
  $scope.importData = function () {
    if ($scope.budget.budget_code) {
      loadingBarService.start('Importazione dati...');
      var counter = 0;
      var toSave = [];
      $scope.data.forEach(function (value) {
        for (var i = 0; i < 12; i++) {
          var month = '' + (i + 1);
          month = setDefaultDimension(month);
          var day = value['anno'] + month + '01';
          var temp = {};
          temp['date'] = value['anno'] + '-' + month + '-' + '01';
          temp['budget_code'] = $scope.budget.budget_code;
          temp['budget_description'] = $scope.budget.budget_description;
          temp['budget_default'] = $scope.budget.budget_default;
          temp['budget_eval_date'] = $scope.budget.eval_date;
          temp['voice_key'] = value['voce'];
          temp['voice_value'] = parseFloat(value[sixDateLib.getMonthName(i).toLowerCase()]);
          temp['tot'] = parseFloat(temp['voice_value']);
          temp['um'] = value.um;
          temp['record_type'] = value['tipo_cont'];
          temp['record_code'] = value['cod_cont'];
          temp['unit_price'] = value['prezzo_unitario'];
          $log.log(temp);
          toSave.push(temp);
        }
      });
      budgetFactory.bulk(toSave).$promise.then(function (response) {
        $scope.percent = 100;
        $scope.reportMessages = response.messages;
        if ($scope.hasErrors) {
          toaster.pop('error', 'Attenzione', 'Errori durante l\'importazione');
          loadingBarService.stop(response);
        } else if ($scope.hasWarnings) {
          toaster.pop('warning', 'Attenzione', 'Avvisi durante l\'importazione');
          loadingBarService.stop(response);
        } else {
          toaster.pop('success', 'Successo', 'Importazione avvenuta con successo');
        }
      })["catch"](function (error) {
        $log.error('Errore durante l\'importazione', error);
        toaster.pop('error', 'Errore', 'Errore durante l\'importazione');
      })["finally"](function (response) {
        loadingBarService.stop();
      });
    } else {
      toaster.pop('error', 'Errore', 'Codice budget non specificato');
    }
  };
  $scope.update = function () {
    var budgetDetails = {
      budget_code: $scope.budget.budget_UUID,
      description: $scope.budget.budget_description,
      "default": $scope.budget.budget_default,
      year: $scope.year,
      eval_date: $scope.budget.eval_date
    };
    budgetFactory.update(budgetDetails).$promise.then(function (response) {
      $scope.percent = 100;
    })["catch"](function (response) {
      toaster.pop('error', 'Errore', 'Errore durante il salvataggio');
    });
  };
  $scope.deleteWithDialog = function () {
    var deleteMessage = 'Eliminare il record?';
    budgetFactory.referenceCount({
      id: $scope.budget.budget_UUID
    }).$promise.then(function (response) {
      if (response.count != 0) {
        deleteMessage = 'L\'elemento che stai eliminando è in uso nel sistema. Vuoi rimuoverlo comunque?';
      }
      showDeletePanel(deleteMessage);
    })["catch"](function (response) {
      toaster.pop('error', 'Errore', 'Errore durante la ricerca dei dati referenziati');
      showDeletePanel(deleteMessage);
    });
  };
  function showDeletePanel(message) {
    var dialogScope = {
      deleteMessage: message,
      record: $scope.budget,
      deleteFunction: $scope["delete"],
      notDeleteFunction: $scope.closeDeleteDialog
    };
    var opts = {
      name: 'infoBudgetDelete',
      closeByDocument: true,
      plain: false
    };
    $scope.deleteDialog = dialogService.templateDialog('budgetInfoDelete.html', dialogService.DIALOG_TYPE.DANGER, dialogScope, opts, -1, false);
  }
  $scope["delete"] = function () {
    var budgetDetails = {
      budget_code: $scope.budget.budget_UUID,
      year: $scope.budget.year
    };
    budgetFactory["delete"](budgetDetails).$promise.then(function (response) {
      $scope.unselectBudget(); // deseleziono il budget
      $scope.closeDeleteDialog(); // chiudo la dialog di eliminazione
      $scope.loadbudgetListPage(); // carico la pagina di lista
    });
  };

  $scope.closeDeleteDialog = function () {
    $scope.deleteDialog.close();
  };
  $scope.unselectBudget = function () {
    $scope.record = {};
    $scope.importingOperation = false;
    $scope.isCollapsed = false;
    $scope.graphData = [];
    $scope.data = [];
    $scope.percent = 0;
    $scope.budget = {
      budget_code: undefined,
      budget_description: undefined,
      budget_default: false,
      searchCode: undefined
    };
  };
  $scope.getData = function (valorize, valorizeLikeConsumptions) {
    $scope.importingOperation = false;
    $scope.percent = 0;
    $scope.data = [];
    $scope.graphData = [];
    valorize = valorize || false;
    valorizeLikeConsumptions = valorizeLikeConsumptions || false;
    if (!$scope.budget.searchCode || !$scope.budget.searchCode.UUID) {
      toaster.pop('error', 'Errore', 'Budget non specificato');
    } else {
      loadingBarService.start('Caricamento dati...');
      getHeader().then(function () {
        var promise;
        if (valorize === true) {
          var params = {
            budgetCode: $scope.budget.budget_UUID,
            to: $scope.budget.year + '-12-31',
            from: $scope.budget.year + '-01-01',
            frequency: 'MONTHLY',
            consumptionsLike: valorizeLikeConsumptions
          };
          promise = evalFactory.budgetAndEval(params).$promise;
        } else {
          var query = {};
          query.year = $scope.budget.year;
          if ($scope.budget.searchCode.UUID) {
            query.budget_codes = $scope.budget.searchCode.UUID;
          }
          if ($scope.record.type_id) {
            query.record_types = $scope.record.type_id.UUID;
          }
          if ($scope.record.record_id) {
            query.record_ids = $scope.record.record_id.UUID;
          }
          promise = budgetFactory.byYear(query).$promise;
        }
        promise.then(function (response) {
          $log.log(response);
          if (response.hasOwnProperty('list') && response.list.length) {
            response.list.forEach(function (item) {
              item.subGridOptions = {
                enableFiltering: true,
                columnDefs: monthsColumnDefsSub,
                data: item.details,
                rowHeight: 75
              };
            });
            $scope.data = response.list;
            $scope.reportMessages = response.messages;
            buildGraphData();
          }
          $scope.$broadcast(DATA_READY_EVENT, 'data');
          loadingBarService.stop();
        }, function (error) {
          toaster.pop('error', 'Errore', 'Errore durante il recupero dei dati');
          $log.error('Errore durante il recupero dei dati', error);
          $scope.$broadcast(DATA_READY_EVENT, 'data');
          loadingBarService.stop();
        });
      });
    }
  };
  function getHeader() {
    var query = {};
    query.year = $scope.year;
    if ($scope.budget.searchCode.UUID) {
      query.budget_codes = $scope.budget.searchCode.UUID;
    }
    if ($scope.record.type_id) {
      query.record_types = $scope.record.type_id.UUID;
    }
    if ($scope.record.record_id) {
      query.record_ids = $scope.record.record_id.UUID;
    }
    var promise = budgetFactory.byHeader({
      id: $scope.budget.searchCode.UUID
    }).$promise;
    promise.then(function (response) {
      $scope.budget.budget_UUID = response.UUID;
      $scope.budget.budget_code = response.model.code;
      $scope.budget.budget_description = response.model.code;
      $scope.budget.budget_default = response.model["default"];
      $scope.budget.year = response.model.year;
      $scope.budget.eval_date = new Date(response.model.eval_date);
    }, function (error) {
      toaster.pop('error', 'Errore', 'Errore durante il recupero dei dati');
      $log.error('Errore durante il recupero dei dati', error);
    });
    return promise;
  }
  $scope.getRecordDetailURL = function (itemType, itemId) {
    // $location.path('/record/snap/'+itemType+'/'+itemId);
    return '#/record/snap/' + itemType + '/' + itemId;
  };
  function getAvailableBudgetCodes(from, to, recordType, recordId) {
    loadingBarService.start();
    var query = {};
    if (from) {
      query.from = from;
    }
    if (to) {
      query.to = to;
    }
    if (recordType) {
      query.record_type = recordType;
    }
    if (recordId) {
      query.record_id = recordId;
    }
    return budgetFactory.budgetCodes(query).$promise.then(function (response) {
      var list = [];
      if (response.hasOwnProperty('list') && response.list.length) {
        list = response.list;
      }
      return list;
    })["catch"](function (response) {
      toaster.pop('error', 'Errore', 'Errore durante il recupero dei budget');
    })["finally"](function (response) {
      $scope.$broadcast(DATA_READY_EVENT, 'budgetCodes');
    });
  }
  $scope.getBudgetByCode = function (code) {
    $scope.isCollapsed = true;
    //$location.path('/budget/'+code);
    $scope.budget.searchCode = {
      UUID: code
    };
    $scope.getData(false);
  };
  $scope.newBudget = function () {
    $location.path('/budget/new');
  };
  $scope.loadbudgetListPage = function () {
    $location.path('/budget/get');
  };
  $scope.$watchGroup(['record.type_id', 'record.record_id'], function (newValue, oldValue) {
    if (newValue) {
      $scope.availableBudgetCodes = [];
      $scope.loadAvailableBudgetCodes();
    }
  });
  $scope.loadAvailableBudgetCodes = function () {
    var from = undefined;
    var to = undefined;
    var recordType = undefined;
    var recordId = undefined;
    if ($scope.year) {
      $log.info('year: ' + $scope.year);
      from = $scope.year + '-01-01';
      to = $scope.year + '-12-31';
    }
    if ($scope.record && $scope.record.type_id) {
      recordType = $scope.record.type_id.UUID;
    }
    if ($scope.record && $scope.record.record_id) {
      recordId = $scope.record.record_id.UUID;
    }
    getAvailableBudgetCodes(from, to, recordType, recordId).then(function (list) {
      $scope.availableBudgetCodes = list;
    });
  };
  $scope.addVoices = function () {
    $location.path('budget/add/' + $scope.budget.searchCode.UUID);
  };
  function buildGraphData() {
    var map = [];
    $scope.data.forEach(function (item) {
      item.details.forEach(function (det) {
        var voiceKey = det.voice_code;
        for (var month = 0; month < 12; month++) {
          var monthName = sixDateLib.getMonthName(month).toLowerCase();
          var graphKey = monthName;
          var graphItem = map[graphKey] || {
            tot: 0
          };
          graphItem.date = new Date($scope.year, month, 1);
          if (!graphItem.hasOwnProperty(voiceKey)) {
            graphItem[voiceKey] = 0;
          }
          graphItem[voiceKey] += det[monthName].tot || 0;
          graphItem.tot += det[monthName].tot || 0;
          map[graphKey] = graphItem;
        }
      });
    });
    $scope.graphData = [];
    for (var i in map) {
      $scope.graphData.push(map[i]);
    }
    $scope.graphData = $filter('orderBy')($scope.graphData, 'date');
  }
  $scope.reset = function () {
    $scope.budget = {
      budget_code: undefined,
      budget_description: undefined,
      budget_default: false,
      searchCode: undefined,
      eval_date: null
    };
    $scope.reportMessages = [];
    $scope.data = [];
    $scope.gridImportOptions.data = [];
    $scope.percent = 0;
  };
  $scope.getTotals = function (list, key1, key2) {
    return list.map(function (item) {
      return item[key1][key2];
    }).reduce(function (total, item) {
      return total + item;
    });
  };

  /***** Gestione tabella dettaglio *****/

  $scope.allRowsExpanded = false;
  $scope.viewMode = function (mode) {
    switch (mode) {
      case 'um':
        $scope.views.um = !$scope.views.um;
        break;
      case 'std':
        $scope.views.std = !$scope.views.std;
        break;
      case 'economic':
        $scope.views.economic = !$scope.views.economic;
        break;
    }
    return $scope.views;
  };
  $scope.toggleAllRows = function () {
    $scope.allRowsExpanded = !$scope.allRowsExpanded;
    $scope.data.forEach(function (row) {
      row.expanded = $scope.allRowsExpanded;
    });
  };
  $scope.sort = []; // sort

  $scope.sortBy = function (propertyName) {
    var idx = $scope.sort.indexOf(propertyName);
    if (~idx) {
      $scope.sort[idx] = '-' + propertyName;
    } else {
      idx = $scope.sort.indexOf('-' + propertyName);
      if (~idx) {
        $scope.sort.splice(idx, 1);
      } else {
        $scope.sort.push(propertyName);
      }
    }
  };
  $scope.isSorted = function (propertyName) {
    var idx = $scope.sort.indexOf(propertyName);
    if (~idx) {
      return 1;
    } else {
      idx = $scope.sort.indexOf('-' + propertyName);
      if (~idx) {
        return -1;
      }
    }
    return 0;
  };

  /***** Esportazioni *****/

  $scope.exportXLSX = function () {
    // preparo colonne
    var columns = [];
    columns.push({
      key: 'record_type',
      name: 'tipo_cont'
    });
    columns.push({
      key: 'record_code',
      name: 'cod_cont'
    });
    columns.push({
      key: 'anno',
      name: 'anno'
    });
    angular.forEach(monthsColumnDefsSub, function (col, idx) {
      var c;
      if (col.name == 'voce') {
        c = {
          key: col.field,
          name: col.name
        };
      } else if (col.name == 'totale') {
        c = {
          key: 'tot',
          name: 'tot'
        };
      } else if (col.name == 'prezzo un.') {
        c = {
          key: 'unit_price',
          name: 'prezzo_unitario'
        };
      } else {
        c = {
          key: col.name,
          name: col.name
        };
      }
      columns.push(c);
    });
    columns.push({
      key: 'um',
      name: 'um'
    });

    // preparo righe
    var rows = [];
    $scope.data.forEach(function (r) {
      r.details.forEach(function (d) {
        var row = angular.copy(d);
        row['anno'] = r['anno'];
        columns.forEach(function (c) {
          if (c.name != 'voce' && c.key != 'record_type' && c.key != 'record_code' && c.key != 'anno' && c.key != 'um' && c.key != 'unit_price') {
            row['um'] = row[c.key].um.code;
            row[c.key] = row[c.key].tot;
          }
        });
        rows.push(row);
      });
    });
    if (rows && rows.length > 0) {
      sixExportLib.exportXLSX(columns, rows, 'budget_' + $scope.budget.budget_code, false);
    }
  };
  var REPORT_BASE_DIR = "reports/EMMA/";
  var REPORT_API_BASE = $location.protocol() + '://' + location.host + '' + APP_URL + '/rest/report/';
  //var REPORT_API_BASE = "http://docker0.ict-group.it:7878/six/rest/report/";
  var REPORT_QUERY_BASE = "&net.sf.jasperreports.json.source=" + REPORT_API_BASE;
  $scope.getPdf = function () {
    loadingBarService.start('Generazione report in corso');
    var query = REPORT_QUERY_BASE + "budget/" + currentCommission.code + "/" + $scope.year + "/" + $scope.budget.budget_UUID;
    $http.post(APP_URL + '/rest/report/generate', {
      path: REPORT_BASE_DIR + "Test_Budget.pdf",
      query: query
    }, {
      responseType: 'arraybuffer'
    }).then(function (data, status, headers, config) {
      loadingBarService.stop();
      var options = {
        type: 'application/pdf'
      };
      SaveAs.download(data, 'report.pdf', options);
    }, function (data, status, headers, config) {
      loadingBarService.stop();
      toaster.pop('error', "Errore", 'Errore generazione report');
      // called asynchronously if an error occurs
      // or server returns response with an error status.
    });
  };

  $scope.getXlsx = function () {
    loadingBarService.start('Generazione report in corso');
    //"&net.sf.jasperreports.json.source=http://docker0.ict-group.it:7878/six/rest/report/budget/"+currentCommission.code+"/"+$scope.year+"/"+$scope.budget.budget_UUID
    var query = REPORT_QUERY_BASE + "budget/" + currentCommission.code + "/" + $scope.year + "/" + $scope.budget.budget_UUID;
    $http.post(APP_URL + '/rest/report/generate', {
      path: REPORT_BASE_DIR + "Test_Budget_xlsx.xlsx",
      query: query
    }, {
      responseType: 'arraybuffer'
    }).then(function (data, status, headers, config) {
      loadingBarService.stop();
      var options = {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      };
      SaveAs.download(data, 'report.xlsx', options);
    }, function (data, status, headers, config) {
      loadingBarService.stop();
      toaster.pop('error', "Errore", 'Errore generazione report');
      // called asynchronously if an error occurs
      // or server returns response with an error status.
    });
  };

  $scope.getChart = function () {
    loadingBarService.start('Generazione report in corso');
    //"&net.sf.jasperreports.json.source=http://docker0.ict-group.it:7878/six/rest/report/chart/budget/"+currentCommission.code+"/"+$scope.year+"/"+$scope.budget.budget_UUID
    var query = REPORT_QUERY_BASE + "chart/budget/" + currentCommission.code + "/" + $scope.year + "/" + $scope.budget.budget_UUID;
    $http.post(APP_URL + '/rest/report/generate', {
      path: REPORT_BASE_DIR + "Test_Budget_graph.pdf",
      query: query
    }, {
      responseType: 'arraybuffer'
    }).then(function (data, status, headers, config) {
      loadingBarService.stop();
      var options = {
        type: 'application/pdf'
      };
      SaveAs.download(data, 'chart.pdf', options);
    }, function (data, status, headers, config) {
      loadingBarService.stop();
      toaster.pop('error', "Errore", 'Errore generazione report');
      // called asynchronously if an error occurs
      // or server returns response with an error status.
    });
  };

  $scope.analyze = function (uuid) {
    $location.path('/budget/eval/' + uuid);
  };

  /***** Data ready events *****/

  var DATA_READY_EVENT = 'dataReady';

  // $scope.$on(DATA_READY_EVENT, function(event) {
  //   setTimeout(function() { // evita che venga richiamato troppo velocemente (altrimenti si accavalla a showLoadingMessage)
  //     if($scope.gridApi && $scope.gridApi.core) {
  //       $scope.gridApi.core.refresh();
  //     }
  //     loadingBarService.stop();
  //   }, 200);
  // });

  $scope.viewBudgetDetail = function (uuid) {
    $location.path('budget/detail/' + uuid);
  };
  $scope.goBack = function () {
    $location.path('budget/get');
  };

  /******* Log messages *******/

  $scope.reportMessages = [];
  $scope.reportGridOptions = {
    enableSorting: true,
    exporterMenuPdf: false,
    paginationPageSizes: [10, 20, 30],
    paginationPageSize: 10,
    useExternalPagination: false,
    data: 'reportMessages',
    columnDefs: [{
      displayName: 'Stato',
      field: 'status',
      width: '100'
    }, {
      displayName: 'Messaggio',
      field: 'message'
    }]
  };

  /***** Caricamento dati di dettaglio *****/

  if ($routeParams.codeToAdd) {
    $scope.budget.searchCode = {
      UUID: $routeParams.codeToAdd
    };
    getHeader();
  } else if ($routeParams.code) {
    $scope.budget.searchCode = {
      UUID: $routeParams.code
    };
    $scope.getData(false);
  }

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'budget';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:BudgetCtrl
 * @description
 * # BudgetCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/budget/eval', {
    templateUrl: 'energy/budget/budget_eval.html',
    controller: 'BudgetEvalCtrl'
  }).when('/budget/eval/:code', {
    templateUrl: 'energy/budget/budget_eval.html',
    controller: 'BudgetEvalCtrl'
  });
}]).controller('BudgetEvalCtrl', ["$scope", "$routeParams", "$rootScope", "$log", "$filter", "$location", "authFactory", "budgetFactory", "energyCarrierFactory", "evalFactory", "recordFactory", "$q", "toaster", "SaveAs", "APP_URL", "$http", "dialogService", "errorService", function ($scope, $routeParams, $rootScope, $log, $filter, $location, authFactory, budgetFactory, energyCarrierFactory, evalFactory, recordFactory, $q, toaster, SaveAs, APP_URL, $http, dialogService, errorService) {
  var currentCommission = authFactory.getAuthData().info.commissions.current;
  $scope.loadingPlaceHolder = {
    show: false,
    info: false,
    warn: false,
    error: false,
    message: ''
  };
  $scope.budget = {};
  $scope.data = [];
  $scope.graphData = [];

  // Filtri
  $scope.record = {};
  $scope.type = {};
  $scope.recordTypeFilter = {
    'model.code': ''
  };
  $scope.vector = {};
  $scope.datePicker = {
    from: new Date(new Date().getFullYear(), 0, 1),
    to: new Date(new Date().getFullYear(), 11, 31)
  };
  $scope.budgetList = [];
  $scope.getData = function () {
    $scope.data = [];
    $scope.graphData = [];
    if (angular.isUndefined($scope.budget) || angular.isUndefined($scope.budget.UUID)) {
      // toaster.pop('error', 'Errore', 'Budget non specificato');
      loadingPlaceHolder(true, false, false, 'Selezionare un budget');
    } else {
      loadingPlaceHolder(false, false, false, 'Caricamento dati...');
      budgetFactory.byHeader({
        id: $scope.budget.UUID
      }).$promise.then(function (response) {
        $scope.budget.code = response.model.code;
        $scope.budget.description = response.model.code;
        $scope.budget["default"] = response.model["default"];
        $scope.budget.year = response.model.year;
        $scope.budget.eval_date = new Date(response.model.eval_date);
        $scope.datePicker.from = new Date($scope.budget.year + '-01-01');
        $scope.datePicker.to = new Date($scope.budget.year + '-12-31');
        var params = {
          id: $scope.budget.UUID,
          to: $scope.budget.year + '-12-31',
          // FIXME
          from: $scope.budget.year + '-01-01' // FIXME
        };

        if (angular.isDefined($scope.vector.id)) {
          params.vectorUUID = $scope.vector.id.UUID;
        }
        if (angular.isDefined($scope.type.id)) {
          params.typeUUID = $scope.type.id.UUID;
        }
        if (angular.isDefined($scope.record.id)) {
          params.recordUUID = $scope.record.id.UUID;
        }
        evalFactory.analysis(params).$promise.then(function (response) {
          $log.log(response);
          if (checkResponse(response)) {
            $scope.data = $filter('orderBy')(response.result, 'date', false, function (v1, v2) {
              if (angular.isUndefined(v1.value)) return 1;
              if (angular.isUndefined(v2.value)) return -1;
              return new Date(v1.value) < new Date(v2.value) ? -1 : 1;
            });
            $scope.data.forEach(function (obj) {
              if (angular.isDefined(obj.date)) {
                // se undefined è un totale
                var item = {
                  date: new Date(obj.date)
                };
                item['bdg val.'] = obj.bdgEval;
                item['bdg att.'] = obj.bdgEvalConsLike;
                item['cons. val.'] = obj.consEval;
                // item['fatt. rev.'] = obj.fattRevEuros;
                // item['scost. cons.'] = obj.consDiffEuros;
                $scope.graphData.push(item);
              }
            });
          }
        });
      })["catch"](function (response) {
        $log.error('Errore durante il recupero dei dati', response);
        toaster.pop('error', 'Errore', 'Errore durante il recupero dei dati');
        showErrors('Errore durante il recupero dei dati');
      });
    }
  };
  function checkResponse(response) {
    if (errorService.handleError(response)) {
      if (response.hasError) {
        // retrocompatibilità
        $log.error('Errore durante il recupero dei dati', response);
        showErrors('Errore durante il recupero dei dati');
        return false;
      } else if (response.hasErrors) {
        // ServiceResponse
        $log.error('Errore durante il recupero dei dati', response);
        dialogService.serviceResponse('Esito', response, true);
        showErrors('Errore durante il recupero dei dati');
        return false;
      } else if (response.hasWarnings) {
        // ServiceResponse
        $log.warning('Warnings durante il recupero dei dati', response);
        dialogService.serviceResponse('Esito', response, true);
        hideLoadingPlaceHolder();
        return true;
      } else if (!response.result || response.result.length == 0) {
        showNoResults();
        return false;
      }
      hideLoadingPlaceHolder();
      return true;
    } else {
      $log.error('Errore durante il recupero dei dati', response);
      showErrors('Errore durante il recupero dei dati');
      return false;
    }
  }
  function loadAvailableBudgetCodes() {
    var query = {
      from: createDate($scope.datePicker.from),
      to: createDate($scope.datePicker.to)
    };
    if ($scope.type.type_id) {
      query.type = $scope.type.type_id.UUID;
    }
    return budgetFactory.budgetCodes(query).$promise.then(function (response) {
      if (response.hasOwnProperty('list') && response.list.length) {
        $scope.budgetList = response.list;
      }
    });
  }
  function createDate(d) {
    var date = new Date(d);
    return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
  }
  $scope.goBack = function () {
    $location.path('budget/get');
  };

  /***** Caricamento dati di dettaglio *****/

  if ($routeParams.code) {
    $scope.budget = {
      UUID: $routeParams.code
    };
    $scope.getData(false);
  } else {
    loadingPlaceHolder(true, false, false, 'Selezionare un budget');
  }

  /***** Data ready events *****/

  function hideLoadingPlaceHolder() {
    $scope.loadingPlaceHolder = {
      show: false,
      info: false,
      warn: false,
      error: false,
      message: ''
    };
  }
  function showNoResults() {
    loadingPlaceHolder(false, true, false, 'Nessun dato da mostrare');
  }
  function showErrors(msg) {
    loadingPlaceHolder(false, false, true, msg);
  }
  function loadingPlaceHolder(info, warn, err, msg) {
    $scope.loadingPlaceHolder = {
      show: true,
      info: info,
      warn: warn,
      error: err,
      message: msg
    };
  }
  function updateContatoreTypeFilter() {
    if ($scope.vector.id) {
      energyCarrierFactory.schemas({
        id: $scope.vector.id.UUID
      }).$promise.then(function (response) {
        $scope.recordTypeFilter = {
          'model.code': response.list.join()
        };
      })["catch"](function (response) {
        toaster.pop('error', 'Errore', 'Errore durante il recupero dei modelli con vettore_id ' + $scope.vettore.id.code);
      });
    }
  }
  $scope.$watch(function () {
    return $scope.vector.id;
  }, function (newVal, oldVal) {
    if (angular.isDefined(newVal) && newVal !== oldVal) {
      updateContatoreTypeFilter();
    } else {
      $scope.type = {};
    }
  });
  $scope.$watchCollection(['datePicker.from', 'datePicker.to'], function (newVal, oldVal) {
    loadAvailableBudgetCodes();
  });

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'budget';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:ConsumptionAnalysisCtrl
 * @description
 * # ConsumptionAnalysisCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/closure', {
    templateUrl: 'energy/closure/closure.html',
    controller: 'ClosureCtrl'
  });
}]).controller('ClosureCtrl', ["$scope", "consumptiveFactory", "recordFactory", "energyCarrierFactory", "dialogService", "errorService", "toaster", "$log", "$q", "localStorageService", function ($scope, consumptiveFactory, recordFactory, energyCarrierFactory, dialogService, errorService, toaster, $log, $q, localStorageService) {
  $scope.schema = {};
  $scope.record = {};
  $scope.um = undefined;
  $scope.read = {};

  // Date Picker

  $scope.datePicker = {};
  $scope.dateOptions = {
    dateDisabled: false,
    formatYear: 'yyyy',
    maxDate: new Date(),
    minDate: new Date() - 365 * 10,
    // -10 anni
    startingDay: 1
  };
  $scope.dpStatus = {
    opened: false
  };
  $scope.dpOpen = function ($event) {
    $scope.dpStatus.opened = true;
  };

  // Functions

  $scope.checkInputData = function () {
    return angular.isDefined($scope.schema.id) && angular.isDefined($scope.record.id) && angular.isDefined($scope.datePicker.date) && (angular.isDefined($scope.read.f0) || angular.isDefined($scope.read.f1) || angular.isDefined($scope.read.f2) || angular.isDefined($scope.read.f3));
  };
  $scope.closeRecord = function () {
    var p1 = saveRecord();
    var p2 = saveRead();
    $q.all([p1, p2]).then(function (responses) {
      if (responses[0] && responses[1]) {
        toaster.pop('success', 'Ok', 'Chiusura avvenuta correttamente');
      }
    });
  };
  function saveRecord() {
    var toUpdate = $scope.record.obj;
    toUpdate.model.stato = 'chiuso';
    toUpdate.model.data_chiusura = $scope.datePicker.date;
    return recordFactory($scope.schema.id.code).update({
      id: toUpdate.version
    }, toUpdate).$promise.then(function (data) {
      return true;
    })["catch"](function (response) {
      toaster.pop('error', 'Errore', 'Errore durante il salvataggio del contatore');
      return false;
    });
  }
  function saveRead() {
    var toSave = prepareDataForSaving($scope.read);
    toSave.date = $scope.datePicker.date;
    if (!toSave.date || !toSave.record_id.type || !toSave.record_id.code || toSave.reads.length == 0) {
      toaster.pop('error', 'Errore', 'Controllare tipo e codice contatore, data e letture');
      var deferred = $q.defer();
      deferred.resolve(false);
      return deferred.promise;
    }
    return consumptiveFactory.create(toSave).$promise.then(function (data) {
      return false;
    })["catch"](function (response) {
      toaster.pop('error', 'Errore', 'Errore durante il salvataggio della lettura');
      return true;
    });
  }
  function prepareDataForSaving(value) {
    var toSave = angular.copy(value);
    toSave.reads = [];
    toSave.record_id = $scope.record.id;
    toSave.date = toSave.data;
    toSave.um_id = $scope.um;
    delete toSave.sixImportStatus;
    delete toSave.data;
    delete toSave.um;
    delete toSave.value;
    switch ($scope.schema.id.code) {
      case 'contatoreelettricita':
        delete toSave.pod;
        if (toSave.f0) {
          toSave.reads.push({
            time_slot: 'f0',
            value: parseFloat(toSave.f0)
          });
        }
        if (toSave.f1) {
          toSave.reads.push({
            time_slot: 'f1',
            value: parseFloat(toSave.f1)
          });
        }
        if (toSave.f2) {
          toSave.reads.push({
            time_slot: 'f2',
            value: parseFloat(toSave.f2)
          });
        }
        if (toSave.f3) {
          toSave.reads.push({
            time_slot: 'f3',
            value: parseFloat(toSave.f3)
          });
        }
        delete toSave.f0;
        delete toSave.f1;
        delete toSave.f2;
        delete toSave.f3;
        break;
      case 'contatoregas':
        delete toSave.pdr;
        if (toSave.f0) {
          var read = {
            time_slot: 'f0',
            // lettura
            value: parseFloat(toSave.f0)
          };
          if (toSave.correttore) {
            read.correttore = parseFloat(toSave.correttore);
          }
          toSave.reads.push(read);
        }
        delete toSave.f0;
        delete toSave.correttore;
        break;
      case 'contatoreacqua':
        delete toSave.matricola;
        if (toSave.f0) {
          toSave.reads.push({
            time_slot: 'f0',
            // lettura
            value: parseFloat(toSave.f0)
          });
        }
        delete toSave.f0;
        break;
      case 'serbatoiopressioneatmosferica':
        delete toSave.cod;
        if (toSave.f0) {
          var read = {
            time_slot: 'f0',
            // steccatura
            value: parseFloat(toSave.f0)
          };
          if (toSave.scarico) {
            read.scarico = parseFloat(toSave.scarico);
          }
          toSave.reads.push(read);
        }
        delete toSave.f0;
        delete toSave.scarico;
        break;
      case 'serbatoioinpressione':
        delete toSave.cod;
        if (toSave.f0) {
          var read = {
            time_slot: 'f0',
            // percentuale
            value: parseFloat(toSave.f0)
          };
          if (toSave.scarico) {
            read.scarico = parseFloat(toSave.scarico);
          }
          toSave.reads.push(read);
        }
        delete toSave.f0;
        delete toSave.scarico;
        break;
      case 'contatoreteleriscaldamento':
        delete toSave.cod;
        if (toSave.f0) {
          toSave.reads.push({
            time_slot: 'f0',
            value: parseFloat(toSave.f0)
          });
        }
        delete toSave.f0;
        break;
      case 'contatoreteleraffreddamento':
        delete toSave.cod;
        if (toSave.f0) {
          toSave.reads.push({
            time_slot: 'f0',
            value: parseFloat(toSave.f0)
          });
        }
        delete toSave.f0;
        break;
      default:
        toaster.pop('error', 'Errore', 'Tipo contatore non riconosciuto');
    }
    return toSave;
  }

  // Watchers

  $scope.$watch(function () {
    return $scope.record.obj;
  }, function (newVal, oldVal) {
    if (angular.isDefined(newVal)) {
      $scope.um = $scope.record.obj.model.um_letture_id;
    }
  });
  if (localStorageService.get('closure.schema') && localStorageService.get('closure.record')) {
    $scope.schema.id = localStorageService.get('closure.schema');
    $scope.record.id = localStorageService.get('closure.record');
    localStorageService.remove('closure.schema');
    localStorageService.remove('closure.record');
  }
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:ConsumptionAnalysisCtrl
 * @description
 * # ConsumptionAnalysisCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/consumptionanalysis', {
    templateUrl: 'energy/consumptionanalysis/consumptionanalysis.html',
    controller: 'ConsumptionAnalysisCtrl'
  });
}]).controller('ConsumptionAnalysisCtrl', ["$scope", "energyCarrierFactory", "authFactory", "consumptionFactory", "recordFactory", "budgetFactory", "$q", "ENERGY_URL", "DEV", "consumptionAnalysisFactory", "$location", "$anchorScroll", "dialogService", "errorService", "toaster", "$window", "$filter", "APP_URL", "$http", "SaveAs", "$log", "cfpLoadingBar", "loadingBarService", "ngDialog", "$rootScope", "$timeout", "notificationService", "consanalysisWSFactory", "localStorageService", "schemaFactory", "loginFactory", "$route", "commissionFactory", function ($scope, energyCarrierFactory, authFactory, consumptionFactory, recordFactory, budgetFactory, $q, ENERGY_URL, DEV, consumptionAnalysisFactory, $location, $anchorScroll, dialogService, errorService, toaster, $window, $filter, APP_URL, $http, SaveAs, $log, cfpLoadingBar, loadingBarService, ngDialog, $rootScope, $timeout, notificationService, consanalysisWSFactory, localStorageService, schemaFactory, loginFactory, $route, commissionFactory) {
  var SHOW_ERROR_POPUP = true;
  $scope.contatore = {};
  $scope.type = {};
  $scope.selectedBudgets = {
    selected: []
  };
  $scope.info = authFactory.getAuthData().info;
  $scope.totVector = {
    total: true,
    model: {
      code: 'total',
      description: 'Totale',
      um: {
        type: 'um',
        UUID: 'kwh',
        code: 'kwh',
        description: 'kWh'
      },
      color: '#7266BA',
      skin: 'primary'
    }
  };
  $scope.vectors = {};
  $scope.budget = {
    code: undefined,
    description: undefined,
    list: [],
    totalConsumption: 0,
    season: 0,
    totalBudget: 0,
    deltaSeason: 0,
    deltaTech: 0,
    involvedRecords: [],
    consumptionInvolvedRecords: []
  };
  $scope.dashYearsPicker = {
    from: new Date(new Date().getFullYear(), 0, 1),
    to: new Date(new Date().getFullYear(), 11, 31)
  };
  $scope.datePicker = {
    from: new Date(new Date().getFullYear(), 0, 1),
    to: new Date(new Date().getFullYear(), 11, 31)
  };
  if (new Date().getMonth() == 0) {
    // sono ancora a gennaio => torno indietro di 1 anno
    $scope.datePicker.from.setFullYear($scope.datePicker.from.getFullYear() - 1);
    $scope.datePicker.to.setFullYear($scope.datePicker.to.getFullYear() - 1);
  }
  $scope.availableBudgetCodes = [{
    code: 'test',
    description: 'Test'
  }];
  $scope.currentVector = {};
  $scope.vector = {};
  $scope.contatoreTypeFilter = {
    'model.code': ''
  };
  $scope.forceReprocessing = false;
  $scope.$watchCollection('type', function (newValue, oldValue) {
    if (newValue !== oldValue) {
      $scope.contatore = {};
      refreshAvailableBudgets();
      $scope.vectors = {};
    }
  });
  $scope.$watchCollection('contatore', function (newValue, oldValue) {
    if (newValue !== oldValue) {
      refreshAvailableBudgets();
      $scope.vectors = {};
    }
  });
  $scope.$watchCollection('datePicker', function (newValue, oldValue) {
    if (newValue !== oldValue) {
      $scope.selectedBudgets.selected = [];
      refreshAvailableBudgets();
      $scope.vectors = {};
    }
  });
  $scope.$watch(function () {
    return $scope.vector.id;
  }, function (newVal, oldVal) {
    if (angular.isDefined(newVal) && newVal !== oldVal) {
      updateContatoreTypeFilter();
    } else {
      $scope.type = {};
    }
    $scope.vectors = {};
  });
  function refreshSelectedBudgets(selected) {
    if (angular.isDefined(selected) && angular.isArray(selected) && selected.length > 0) {
      var old = angular.copy(selected); // se gli viene passato $scope.selectedBudgets.selected lo copio, altrimenti non funziona più una fava visto che lo resetto a []
      $scope.selectedBudgets.selected = [];
      old.forEach(function (bc) {
        // MODIFICATO
        var result = getBudgetByCodeFromAvailablesList(bc);
        if (angular.isDefined(result)) {
          $scope.selectedBudgets.selected.push(result);
        }
      });
    }
  }
  $scope.loadData = function (vector, forceReprocessing) {
    var queryFromFilters = $scope.currentVector && $scope.currentVector.model && !vector.total; // $scope.currentVector è il vettore impostato dalla lookup: se definito prendo questo, altrimenti il vettore passato
    var query = queryFromFilters ? getQuery() : getQuery(vector);
    if (forceReprocessing) {
      $scope.recreateAllSnapshots();
    }
    $scope.budget = {
      list: undefined
    };
    vector.loadingPlaceHolder = {
      show: true,
      message: 'Caricamento dati...'
    };
    var promise = consumptionAnalysisFactory().getConsumptionAnalysis(query).$promise;
    promise.then(function (consAnResp) {
      if (consAnResp.hasErrors || consAnResp.hasWarnings) {
        dialogService.serviceResponse('Analisi consumi', consAnResp, true);
      }
      console.log(consAnResp);
      var budget = {},
        graphData = [],
        graphDataCumulative = [],
        selectedBudgets = [];
      if (consAnResp.hasErrors === true) {
        var details = [];
        consAnResp.messages.forEach(function (m) {
          details.push(m.message);
        });
        vector.loadingPlaceHolder = {
          show: true,
          message: 'Errore durante il recupero dei dati',
          error: true,
          details: details
        };
      } else if (angular.isDefined(consAnResp.result) && angular.isDefined(consAnResp.result.list)) {
        budget.list = consAnResp.result.list;
        angular.forEach(consAnResp.result.list, function (record, idx) {
          var grpDT = {
            'date': Date.parse(record.date)
          };
          var grpDTCumulative = {
            'date': Date.parse(record.date)
          };
          budget.toRender = {};
          if (vector.total) {
            grpDT['consumi ' + $filter('number')(consAnResp.result.std.cons, 3)] = '' + record.std.cons;
            grpDT['budget ' + $filter('number')(consAnResp.result.std.budget, 3)] = '' + record.std.budget;
            grpDT['stagionalita ' + $filter('number')(consAnResp.result.std.season, 3)] = '' + record.std.season;
            grpDTCumulative['consumi ' + $filter('number')(consAnResp.result.std.cons, 3)] = '' + (record.std.cumCons || 0);
            grpDTCumulative['budget ' + $filter('number')(consAnResp.result.std.budget, 3)] = '' + (record.std.cumBudget || 0);
            budget.toRender.list = [];
            budget.list.forEach(function (record) {
              var r = angular.copy(record.std);
              r.budgetEconomic = record.um.budgetEconomic;
              r.consEconomic = record.um.consEconomic;
              r.date = record.date;
              budget.toRender.list.push(r);
            });
            budget.toRender.totalBudget = consAnResp.result.std.budget;
            budget.toRender.totalConsumption = consAnResp.result.std.cons;
            budget.toRender.season = consAnResp.result.std.season;
            budget.toRender.deltaSeason = consAnResp.result.std.deltaSeason;
            budget.toRender.deltaTech = consAnResp.result.std.deltaTech;
            budget.toRender.percentage = consAnResp.result.std.percentage;

            //Economic
            budget.toRender.totalBudgetEconomic = consAnResp.result.um.budgetEconomic;
            budget.toRender.totalConsEconomic = consAnResp.result.um.consEconomic;
            if ($scope.contatore.contatore_id) {
              budget.toRender.involvedRecords = [$scope.contatore.contatore_id];
            } else {
              budget.toRender.involvedRecords = consAnResp.result.involvedRecords;
            }
            budget.toRender.consumptionInvolvedRecords = consAnResp.result.consumptionInvolvedRecords;
            budget.toRender.consumptionInvolvedRecords.map(function (r) {
              r.check = $scope.checkRecordInList(r, budget.toRender.involvedRecords);
            });
            budget.toRender.involvedRecords.map(function (r) {
              r.check = $scope.checkRecordInList(r, budget.toRender.consumptionInvolvedRecords);
            });
          } else {
            grpDT['consumi ' + $filter('number')(consAnResp.result.um.cons, 3)] = '' + record.um.cons;
            grpDT['budget ' + $filter('number')(consAnResp.result.um.budget, 3)] = '' + record.um.budget;
            grpDT['stagionalita ' + $filter('number')(consAnResp.result.um.season, 3)] = '' + record.um.season;
            grpDTCumulative['consumi ' + $filter('number')(consAnResp.result.um.cons, 3)] = '' + (record.um.cumCons || 0);
            grpDTCumulative['budget ' + $filter('number')(consAnResp.result.um.budget, 3)] = '' + (record.um.cumBudget || 0);
            budget.toRender.list = [];
            budget.list.forEach(function (record) {
              var r = angular.copy(record.um);
              r.date = record.date;
              budget.toRender.list.push(r);
            });
            budget.toRender.totalBudget = consAnResp.result.um.budget;
            budget.toRender.totalConsumption = consAnResp.result.um.cons;
            budget.toRender.season = consAnResp.result.um.season;
            budget.toRender.deltaSeason = consAnResp.result.um.deltaSeason;
            budget.toRender.deltaTech = consAnResp.result.um.deltaTech;
            budget.toRender.percentage = consAnResp.result.um.percentage;
            // budget.toRender.um = consAnResp.result.um.percentage;

            //Economic
            budget.toRender.totalBudgetEconomic = consAnResp.result.um.budgetEconomic;
            budget.toRender.totalConsEconomic = consAnResp.result.um.consEconomic;
            if ($scope.contatore.contatore_id) {
              budget.toRender.involvedRecords = [$scope.contatore.contatore_id];
            } else {
              budget.toRender.involvedRecords = consAnResp.result.involvedRecords;
            }
            budget.toRender.consumptionInvolvedRecords = consAnResp.result.consumptionInvolvedRecords;
            budget.toRender.consumptionInvolvedRecords.map(function (r) {
              r.check = $scope.checkRecordInList(r, budget.toRender.involvedRecords);
            });
            budget.toRender.involvedRecords.map(function (r) {
              r.check = $scope.checkRecordInList(r, budget.toRender.consumptionInvolvedRecords);
            });
          }
          graphData.push(grpDT);
          graphDataCumulative.push(grpDTCumulative);
        });
        if (angular.isDefined(consAnResp.result) && consAnResp.result.um) {
          budget.um = consAnResp.result.um;
          budget.totalBudget = consAnResp.result.um.budget;
          budget.totalConsumption = consAnResp.result.um.cons;
        }
        if (angular.isDefined(consAnResp.result) && consAnResp.result.std) {
          budget.totalBudgetStd = consAnResp.result.std.budget;
          budget.totalConsumptionStd = consAnResp.result.std.cons;
          budget.std = consAnResp.result.std;
          budget.season = consAnResp.result.std.season;
          budget.deltaSeason = consAnResp.result.std.deltaSeason;
          budget.deltaTech = consAnResp.result.std.deltaTech;
          budget.percentage = consAnResp.result.std.percentage;
        }
        if (angular.isDefined(consAnResp.result)) {
          if ($scope.contatore.contatore_id) {
            budget.involvedRecords = [$scope.contatore.contatore_id];
          } else {
            budget.involvedRecords = consAnResp.result.involvedRecords;
          }
          budget.consumptionInvolvedRecords = consAnResp.result.consumptionInvolvedRecords;
          budget.consumptionInvolvedRecords.map(function (r) {
            r.check = $scope.checkRecordInList(r, budget.involvedRecords);
          });
          budget.involvedRecords.map(function (r) {
            r.check = $scope.checkRecordInList(r, budget.consumptionInvolvedRecords);
          });
        }

        //lo lascio qua budgetComparison, ma in realtà forse non verrà più usato..
        budget.budgetComparison = consAnResp.result.budget ? (consAnResp.result.consumptionStd - consAnResp.result.budget) * 1.0 / consAnResp.result.budget * 100 : 0;
        if (vector && angular.isUndefined(vector.UUID)) {
          selectedBudgets = consAnResp.result.budgetCodes;
          refreshSelectedBudgets(selectedBudgets);
          $scope.analysisHeaderInfos = {
            period: $scope.datePicker.from.getFullYear() + ' - ' + $scope.datePicker.to.getFullYear()
          };
          $scope.analysisHeaderInfos.budgets = '';
          var sep = '';
          $scope.selectedBudgets.selected.forEach(function (bc) {
            if (bc) {
              $scope.analysisHeaderInfos.budgets += sep + bc.code;
              sep = ', ';
            }
          });
          $scope.budget = budget;
        }

        // console.log(budget);
        vector.cachedData = {};
        vector.cachedData.graphData = graphData;
        vector.cachedData.graphDataCumulative = graphDataCumulative;
        vector.cachedData.budget = budget;
        console.log(budget);
        vector.loadingPlaceHolder = {
          show: false,
          message: ''
        };
        $scope.reloadDonuts();
      }
    })["catch"](function (response) {
      vector.loadingPlaceHolder = {
        show: true,
        message: 'Errore durante il recupero dei dati',
        error: true
      };
    });
  };
  $scope.loadVectors = function () {
    $scope.vectors = {};
    if (angular.isDefined($scope.currentVector) && angular.isDefined($scope.currentVector.model)) {
      $scope.vectors[$scope.currentVector.model.code] = $scope.currentVector;
      $scope.loadData($scope.currentVector, $scope.forceReprocessing);
    } else {
      angular.forEach($scope.allVectors, function (vector, key) {
        $scope.vectors[key] = angular.copy(vector);
        $scope.vectors[key].loadingPlaceHolder = {
          show: true,
          message: 'Caricamento dati...'
        };
        $scope.loadData($scope.vectors[key], $scope.forceReprocessing);
      });
    }
  };
  $scope.checkAndLoadVectors = function () {
    $scope.vectors = {};
    if (angular.isDefined($scope.currentVector) && angular.isDefined($scope.currentVector.model)) {
      $scope.vectors[$scope.currentVector.model.code] = $scope.currentVector;
      checkAllSnaps($scope.currentVector).then(function (snaps) {
        if (snaps.length > 0) {
          $log.info('recreateSnaps ' + snaps.join());
          consanalysisWSFactory.recreateSnaps(getQuery($scope.currentVector), snaps.join());
        } else {
          $scope.loadData($scope.currentVector, $scope.forceReprocessing);
        }
      });
    } else {
      var promises = [];
      for (var key in $scope.allVectors) {
        var vector = $scope.allVectors[key];
        $scope.vectors[key] = angular.copy(vector);
        $scope.vectors[key].loadingPlaceHolder = {
          show: true,
          message: 'Caricamento dati...'
        };
        promises.push(checkAllSnaps(vector));
      }
      $q.all(promises).then(function (responses) {
        $log.info(responses);
        var snaps = [];
        responses.forEach(function (s) {
          if (s && s.length > 0) {
            snaps = snaps.concat(s);
          }
        });
        if (snaps.length > 0) {
          var s = snaps.filter(function (value, index, self) {
            // elimino doppioni
            return self.indexOf(value) === index;
          }).join(); // concateno con ,
          $log.info('recreateSnaps ' + s);
          consanalysisWSFactory.recreateSnaps(getQuery(), s);
        } else {
          $scope.loadVectors();
        }
      });
    }
  };
  function checkAllSnaps(vector) {
    var allP = $q.defer();
    var snaps = [];
    $log.info('Getting budget snap', vector);
    $scope.getBudgetSnapDate(vector).then(function (resp) {
      if (!resp || !resp.result || !resp.result.creationDate) {
        $log.warn('No budget snap', vector);
        snaps.push('budget');
        snaps.push('associations');
        var deferred = $q.defer();
        deferred.resolve();
        return deferred.promise;
      } else {
        $log.info('Getting DD snap', vector);
        return $scope.getDDSnapDate(vector); // se non ho risolto il budget, evito di chiedere
      }
    }).then(function (resp) {
      if (!resp || !resp.result || !resp.result.creationDate) {
        $log.warn('No DD snap', vector);
        snaps.push('dd');
      } else {
        $log.info('Getting consumption snap', vector);
      }
      return $scope.getConsumptionsSnapDate(vector);
    }).then(function (resp) {
      if (!resp || !resp || !resp.result || !resp.result.creationDate) {
        $log.warn('No consumption snap', vector);
        snaps.push('consumptions');
        var deferred = $q.defer();
        deferred.resolve();
        return deferred.promise;
      } else {
        $log.info('Getting consumption analysis snap', vector);
        return $scope.getConsAnalysisSnapDate(vector);
      }
    }).then(function (resp) {
      if (!resp || !resp.result || !resp.result.creationDate) {
        $log.warn('No consumption analysis snap', vector);
        snaps.push('analysis');
      }
      allP.resolve(snaps);
    });
    return allP.promise;
  }
  $scope.reload = function () {
    $scope.datePicker.from = $scope.dashYearsPicker.from;
    $scope.datePicker.to = $scope.dashYearsPicker.to;
    $scope.selectedBudgets.selected = [];
    $scope.loadVectors();
  };
  function refreshAvailableBudgets() {
    getAvailableBudgetCodes().then(function (list) {
      $scope.availableBudgetCodes = list;
    });
  }
  function getAvailableBudgetCodes() {
    var query = {
      from: createDate($scope.datePicker.from),
      to: createDate($scope.datePicker.to)
    };
    if ($scope.type.type_id) {
      query.type = $scope.type.type_id.UUID;
    }
    return budgetFactory.budgetCodes(query).$promise.then(function (response) {
      var list = [];
      if (response.hasOwnProperty('list') && response.list.length) {
        list = response.list;
      }
      return list;
    });
  }
  function getBudgetByCodeFromAvailablesList(code) {
    for (var idx in $scope.availableBudgetCodes) {
      if ($scope.availableBudgetCodes[idx].UUID === code) {
        return $scope.availableBudgetCodes[idx];
      }
    }
  }
  function replaceAll(str, find, replace) {
    return str.replace(new RegExp(find, 'g'), replace);
  }

  /* **************** */
  /* **** REPORT **** */
  /* **************** */

  var REPORT_JASPER_DIRECTORY = 'reports/EMMA/Energy/'; /* path del report su jasperserver */
  var REPORT_JASPER_NAME = 'consumptionanalysis_tab_all_vectors'; /* path del report su jasperserver */
  var REPORT_XLS_JASPER_NAME = 'consumptionanalysis_tab_all_vectors_xls'; /* path del report su jasperserver */

  $scope.openDialogReport = function (extensionFile) {
    printReportConsumptionAnalysis(callJasper, extensionFile);
  };
  function printReportConsumptionAnalysis(printReport, extensionFile) {
    var message = 'Selezionare le voci da esportare';
    var listItemDialog = ngDialog.openConfirm({
      name: 'printReportConsumptionAnalysisDialog',
      closeByDocument: false,
      showClose: true,
      template: '' + '<div style="text-align:center"><i class="fa fa-list"></i>&nbsp; ' + message + '</div><br>' + '<input type="checkbox" id="input_cons" ng-init="itemList.cons=true" ng-model="itemList.cons"/> <label for="input_cons" class="control-label"> Consuntivo</label><br />' + '<input type="checkbox" id="input_cons_std" ng-init="itemList.cons_std=true" ng-model="itemList.cons_std"/> <label for="input_cons_std" class="control-label"> Consuntivo std</label><br />' + '<input type="checkbox" id="input_budget" ng-init="itemList.budget=true" ng-model="itemList.budget"/> <label for="input_budget" class="control-label"> Budget</label><br />' + '<input type="checkbox" id="input_season" ng-model="itemList.season"/> <label for="input_season" class="control-label"> Stagionalità</label><br />' + '<input type="checkbox" id="input_delta_season" ng-model="itemList.deltaSeason"/> <label for="input_delta_season" class="control-label"> Delta stagionalità</label><br />' + '<input type="checkbox" id="input_delta_tech" ng-model="itemList.deltaTech"/> <label for="input_delta_tech" class="control-label"> Delta tecnico</label><br />' + '<input type="checkbox" id="input_percentage" ng-model="itemList.percentage"/> <label for="input_percentage" class="control-label"> Scostamento percentuale</label><br />' + '<input type="checkbox" id="input_bdg_economic" ng-model="itemList.budgetEconomic"/> <label for="input_bdg_economic" class="control-label"> Budget valorizz.</label><br />' + '<input type="checkbox" id="input_cons_economic" ng-model="itemList.consEconomic"/> <label for="input_cons_economic" class="control-label"> Consuntivo valorizz.</label><br />' + '<div class="row wrapper pull-right">' + '<input type="checkbox" id="split_by_counter" ng-model="splitByCounter" /> ' + '<label id="split_by_counter_key" for="split_by_counter" class="control-label"> Dividi per contatore</label>' + '</div>' + '<div class="row" style="text-align:center; clear: both">' + '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ng-click="confirm()">Esporta</button>' + '</div>',
      plain: true,
      className: 'ngdialog-theme-default ngdialog-theme-custom'
    });
    listItemDialog.then(function () {
      /* lancia la stampa del report */
      var parametersSelected = {};
      parametersSelected['cons'] = document.getElementById("input_cons").checked;
      parametersSelected['cons_std'] = document.getElementById("input_cons_std").checked;
      parametersSelected['budget'] = document.getElementById("input_budget").checked;
      parametersSelected['season'] = document.getElementById("input_season").checked;
      parametersSelected['deltaSeason'] = document.getElementById("input_delta_season").checked;
      parametersSelected['deltaTech'] = document.getElementById("input_delta_tech").checked;
      parametersSelected['percentage'] = document.getElementById("input_percentage").checked;
      parametersSelected['budgetEconomic'] = document.getElementById("input_bdg_economic").checked;
      parametersSelected['consEconomic'] = document.getElementById("input_cons_economic").checked;
      var splitByCounter = document.getElementById("split_by_counter").checked;
      if (angular.isFunction(printReport)) {
        printReport(parametersSelected, splitByCounter, extensionFile);
      }
    }, function () {/* non fa nulla */});
  }
  function callJasper(parametersMap, splitByCounter, extensionFile) {
    var urlPrefix = DEV ? '/' : '/emma/';
    var endpointAddressGenericReport = $location.protocol() + '://' + $location.$$host + ':' + $location.$$port + urlPrefix + ENERGY_URL + '/api/report/_consumptionanalysis/_get/_url';
    var endpointAddressSingleReport = $location.protocol() + '://' + $location.$$host + ':' + $location.$$port + urlPrefix + ENERGY_URL + '/api/report/_consumptionanalysis/_get/_data';
    // var endpointAddressGenericReport = 'http://172.29.151.80:9000' + urlPrefix + ENERGY_URL + '/api/report/_consumptionanalysis/_get/_url';
    // var endpointAddressSingleReport = 'http://172.29.151.80:9000' + urlPrefix + ENERGY_URL + '/api/report/_consumptionanalysis/_get/_data';
    var reportNameToSave = 'report_analisi_consumi'; // nome con il quale viene salvato sul pc dell'utente
    var reportPath = REPORT_JASPER_DIRECTORY + REPORT_JASPER_NAME + '.' + extensionFile; // dove si trova il report su jasperserver (http://172.29.100.155:7878/jasperserver) + nome report .pdf
    if (extensionFile == 'xls' || extensionFile == 'xlsx') {
      reportPath = REPORT_JASPER_DIRECTORY + REPORT_XLS_JASPER_NAME + '.' + extensionFile; // dove si trova il report su jasperserver (http://172.29.100.155:7878/jasperserver) + nome report .xls
    }

    if (angular.isDefined($scope.datePicker.from) && angular.isDefined($scope.datePicker.to) && $scope.selectedBudgets.selected.length > 0) {
      // obbligatori: from, to, budget
      var commission = null;
      var vectorId = null;
      var contatoreTypeId = null;
      var contatoreId = null;
      var from = null;
      var to = null;
      var budgetCodes = null;
      var parametersToPrint = null;
      /* imposto il codice della commessa */
      if (angular.isDefined(authFactory.getAuthData().info.commissions.current)) {
        commission = authFactory.getAuthData().info.commissions.current.code;
      }
      /* imposto il vettore corrente */
      if (angular.isDefined($scope.vector.id)) {
        vectorId = $scope.vector.id.UUID;
      }
      /* imposto il tipo contatore */
      if (angular.isDefined($scope.type.type_id)) {
        contatoreTypeId = $scope.type.type_id.UUID;
      }
      /* imposto il contatore */
      if (angular.isDefined($scope.contatore.contatore_id)) {
        contatoreId = $scope.contatore.contatore_id.UUID;
      }
      /* imposto la data di inizio e di fine */
      if (angular.isDefined($scope.datePicker.from)) {
        from = $scope.datePicker.from.getFullYear() + '-' + ('0' + ($scope.datePicker.from.getMonth() + 1)).slice(-2) + '-' + ('0' + $scope.datePicker.from.getDate()).slice(-2);
      }
      if (angular.isDefined($scope.datePicker.to)) {
        to = $scope.datePicker.to.getFullYear() + '-' + ('0' + ($scope.datePicker.to.getMonth() + 1)).slice(-2) + '-' + ('0' + $scope.datePicker.to.getDate()).slice(-2);
      }
      /* imposto i codici dei budgets */
      $scope.selectedBudgets.selected.forEach(function (object) {
        if (budgetCodes == null) {
          budgetCodes = object.UUID;
        } else {
          budgetCodes = budgetCodes + ',' + object.UUID;
        }
      });
      /* imposto i parametri da stampare */
      for (var key in parametersMap) {
        if (parametersMap[key]) {
          if (parametersToPrint == null) {
            parametersToPrint = key;
          } else {
            parametersToPrint = parametersToPrint + ',' + key;
          }
        }
      }
      endpointAddressSingleReport = replaceAll(endpointAddressSingleReport, '/', '$');
      endpointAddressGenericReport = endpointAddressGenericReport + '/' + commission + '/' + vectorId + '/' + contatoreTypeId + '/' + contatoreId + '/' + from + '/' + to + '/' + 'MONTHLY' + '/' + budgetCodes + '/' + splitByCounter + '/' + parametersToPrint + '/' + endpointAddressSingleReport;
      var query = '&net.sf.jasperreports.json.source=' + endpointAddressGenericReport;
      if (extensionFile == 'xls' || extensionFile == 'xlsx') {
        query += '&ignorePagination=true';
      }
      loadingBarService.start('Generazione report in corso...');
      $http.post(APP_URL + '/rest/report/generate', {
        path: reportPath,
        query: query
      }, {
        responseType: 'arraybuffer'
      }).success(function (data, status, headers, config) {
        $log.info('status -> ' + status);
        $log.info(data);
        var options;
        if (extensionFile == 'pdf') {
          options = {
            type: 'application/pdf'
          };
        } else if (extensionFile == 'xls' || extensionFile == 'xlsx') {
          options = {
            type: 'application/vnd.ms-excel;'
          };
        }
        SaveAs.download(data, reportNameToSave + '.' + extensionFile, options);
        loadingBarService.stop();
      }).error(function (data, status, headers, config) {
        loadingBarService.stop();
        toaster.pop('error', "Errore", 'Errore generazione report');
      });
    } else {
      toaster.pop('error', "Errore inserimento parametri", 'Parametri obbligatori: data inizio, data fine, almeno un budget di riferimento');
    }
  }

  /*********************/
  /**** Date picker ****/
  /*********************/

  $scope.dateOptionsStart = {
    datepickerMode: 'month',
    minMode: 'month',
    formatYear: 'yy',
    startingDay: 1
  };
  $scope.dateOptionsEnd = {
    datepickerMode: 'month',
    minMode: 'month',
    formatYear: 'yy',
    startingDay: 1
  };
  $scope.setEndDate = function () {
    $scope.datePicker.to = new Date($scope.datePicker.to.getFullYear(), $scope.datePicker.to.getMonth() + 1, 0);
  };
  $scope.openFrom = function ($event) {
    $scope.statusFrom.opened = true;
  };
  $scope.openTo = function ($event) {
    $scope.statusTo.opened = true;
  };
  $scope.statusFrom = {
    opened: false
  };
  $scope.statusTo = {
    opened: false
  };
  function createDate(d) {
    var date = new Date(d);
    return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
  }
  var REPORT_BASE_DIR = "reports/EMMA/";
  var REPORT_API_BASE = $location.protocol() + '://' + location.host + '' + APP_URL + '/rest/report/';
  //var REPORT_API_BASE = "http://docker0.ict-group.it:7878/six/rest/report/";
  var REPORT_QUERY_BASE = "&net.sf.jasperreports.json.source=" + REPORT_API_BASE;
  var currentCommission = authFactory.getAuthData().info.commissions.current;
  $scope.generateReport = function (reportPath, query) {
    console.log("generation report " + (APP_URL + '/rest/report/generate') + " " + reportPath + " " + query);
    loadingBarService.start('Generazione report in corso');
    $http.post(APP_URL + '/rest/report/generate', {
      path: reportPath,
      query: query
    }, {
      responseType: 'arraybuffer'
    }).then(function (data, status, headers, config) {
      loadingBarService.stop();
      var options = {
        type: 'application/pdf'
      };
      SaveAs.download(data, 'consumption_analysis.pdf', options);
    }, function (data, status, headers, config) {
      loadingBarService.stop();
      toaster.pop('error', "Errore", 'Errore generazione report');
      // called asynchronously if an error occurs
      // or server returns response with an error status.
    });
  };

  $scope.setCurrentVector = function (vector) {
    if ($scope.currentVector == vector) {
      $scope.currentVector = $scope.totVector;
    } else {
      $scope.currentVector = vector;
    }
    $scope.changedVector();
  };
  $scope.changedVector = function () {
    if ($scope.currentVector && $scope.currentVector.cachedData) {
      $scope.graphData = $scope.currentVector.cachedData.graphData;
      $scope.graphDataCumulative = $scope.currentVector.cachedData.graphDataCumulative;
      $scope.budget = $scope.currentVector.cachedData.budget;
    } else {
      $scope.loadData($scope.currentVector, true);
    }
  };
  $scope.reloadDonuts = function () {
    $scope.donutDataBudget = [];
    $scope.donutDataConsumption = [];
    for (var kv in $scope.vectors) {
      if ($scope.vectors.hasOwnProperty(kv)) {
        var v = $scope.vectors[kv];
        if (v.cachedData && "Totale".localeCompare(v.model.description) != 0) {
          if (v.cachedData.budget.totalConsumptionStd > 0) {
            $scope.donutDataConsumption.push({
              label: v.model.description,
              value: v.cachedData.budget.totalConsumptionStd
            });
          }
          if (v.cachedData.budget.totalBudgetStd > 0) {
            $scope.donutDataBudget.push({
              label: v.model.description,
              value: v.cachedData.budget.totalBudgetStd
            });
          }
        }
      }
    }
  };

  /*
  Ritorna i dati in um standard (kwh) o specifica del vettore
   */
  $scope.getValues = function (vectorData) {
    if (vectorData && vectorData.cachedData && vectorData.cachedData.budget) {
      if ("Totale".localeCompare(vectorData.model.description) != 0) {
        return vectorData.cachedData.budget.um;
      } else {
        return vectorData.cachedData.budget.std;
      }
    } else {
      return {};
    }
  };
  getAvailableBudgetCodes().then(function (list) {
    $scope.availableBudgetCodes = list;
  });
  function updateContatoreTypeFilter() {
    if ($scope.vector.id) {
      energyCarrierFactory.schemas({
        id: $scope.vector.id.UUID
      }).$promise.then(function (response) {
        $scope.contatoreTypeFilter = {
          'model.code': response.list.join()
        };
      })["catch"](function (response) {
        toaster.pop('error', 'Errore', 'Errore durante il recupero dei modelli con vettore_id ' + $scope.vettore.id.code);
      });
    }
  }
  $scope.toggleForceReprocessing = function () {
    $scope.forceReprocessing = !$scope.forceReprocessing;
  };
  $scope.goToAnchor = function (x) {
    // call $anchorScroll() explicitly,
    // since $location.hash hasn't changed
    $anchorScroll(x);
    window.scrollBy(0, -100); // salto le toolbar in alto (tot. 100px)
  };

  /* ********************* */
  /* ***** SNAPSHOTS ***** */
  /* ********************* */

  $scope.allVectors = {};
  $scope.retrieveAllVectors = function () {
    var tmp = [];
    recordFactory('vettoreenergetico').query({
      page_size: 10000,
      show_revision: false
    }).$promise.then(function (data) {
      var promises = [];
      data.list.forEach(function (value) {
        var p = energyCarrierFactory.schemas({
          id: value.UUID
        }).$promise;
        promises.push(p);
        p.then(function (response) {
          // controllo se esistono record con questo vettore energetico per questa commessa
          if (errorService.handleError(response, false) && response && response.list && response.list.length > 0) {
            tmp.push(value);
          }
        });
      });
      // attendo tutte le response e poi ordino per model code
      $q.all(promises).then(function (responses) {
        var sorted = tmp.sort(function (v1, v2) {
          if (v1.model.code < v2.model.code) return -1;
          if (v1.model.code > v2.model.code) return 1;
          return 0;
        });
        sorted.forEach(function (value) {
          $scope.allVectors[value.model.code] = value;
        });
        $scope.allVectors[$scope.totVector.model.code] = $scope.totVector;
      });
    });
  };
  $scope.retrieveAllVectors();
  $scope.loadAllSnapsDate = function () {
    // il recupero dello snapshot dell'analisi consumi richiede il recupero del budget: se non ho snap del budget
    // evito di chiamare (altrimenti la commessa 1600003 scoppia)
    $scope.getBudgetSnapDate().then(function (resp) {
      if (resp.result && resp.result.creationDate) {
        $scope.getConsAnalysisSnapDate();
        $scope.getDDSnapDate();
        $scope.getConsumptionsSnapDate();
      }
    });
    for (var v in $scope.allVectors) {
      // il recupero dello snapshot dell'analisi consumi richiede il recupero del budget: se non ho snap del budget
      // evito di chiamare (altrimenti la commessa 1600003 scoppia)
      $scope.getBudgetSnapDate($scope.allVectors[v]).then(function (resp) {
        if (resp.result && resp.result.creationDate) {
          $scope.getConsAnalysisSnapDate($scope.allVectors[v]);
          $scope.getDDSnapDate($scope.allVectors[v]);
          $scope.getConsumptionsSnapDate($scope.allVectors[v]);
        }
      });
    }
  };

  //************************************
  // Gestore loading bar e dialog
  //************************************

  var EVENTS = ['snap:creating', 'snap:removing', 'snap:recreating'];
  var waitQueue = {};
  var globalResp = undefined;
  EVENTS.forEach(function (evt) {
    waitQueue[evt] = 0;
    $scope.$on(evt, function (event, status, component, resp) {
      $log.debug('watcher on evt = ' + evt + ' - status: ' + status + ', component: ' + component + ', resp', resp);
      var cleanGlobalResp = true;
      angular.forEach(waitQueue, function (queued, e) {
        if (queued > 0) {
          cleanGlobalResp = false;
        }
      });
      if (cleanGlobalResp === true) {
        globalResp = {
          messages: [],
          hasErrors: false,
          hasWarnings: false,
          status: 'ok',
          result: {}
        };
      }
      if (status == 'started') {
        var message = 'Elaborazione ...';
        waitQueue[evt]++;
        if (event.name == 'snap:creating') {
          message = 'Creazione snapshot ' + component + ' ...';
        } else if (event.name == 'snap:removing') {
          message = 'Eliminazione snapshot ' + component + ' ...';
        }
        loadingBarService.start(message);
      } else if (status == 'terminated') {
        waitQueue[evt]--;
      }
      if (angular.isDefined(resp)) {
        if (resp.code && angular.isNumber(resp.code) && resp.code >= 500) {
          // il backend ha sparato un'eccezione probabilmente
          globalResp.messages = globalResp.messages.concat({
            status: 'SEVERE',
            error: true,
            message: resp.message
          });
          globalResp.hasErrors = true;
        } else {
          globalResp.messages = globalResp.messages.concat(resp.messages);
          globalResp.hasErrors = globalResp.hasErrors || resp.hasErrors;
          globalResp.hasWarnings = globalResp.hasWarnings || resp.hasWarnings;
        }

        // status
        if (globalResp.hasErrors) {
          globalResp.status = 'errors';
        } else if (globalResp.hasWarnings) {
          globalResp.status = 'warnings';
        } else {
          globalResp.status = 'ok';
        }
      }
      var stillWait = false;
      angular.forEach(waitQueue, function (queued) {
        if (queued > 0) {
          stillWait = true;
        }
      });
      $log.debug('waitQueue', waitQueue);
      $log.debug('stillWait = ' + stillWait);
      $log.debug('globalResp', globalResp);
      if (stillWait === false) {
        var message = 'Elaborazione';
        if (evt == 'snap:creating') {
          message = 'Creazione snapshot ' + component;
        } else if (evt == 'snap:removing') {
          message = 'Eliminazione snapshot ' + component;
        } else if (evt == 'snap:recreating') {
          message = 'Creazione snapshot ' + component;
        }
        var notify = {
          message: message + ' -> fine',
          time: new Date(),
          data: globalResp
        };
        if (globalResp.hasErrors || globalResp.hasWarnings) {
          loadingBarService.stop(globalResp, component + ': messaggi', true); // mostro la dialog con i messaggi
          notify.message += ' con errori';
        } else {
          loadingBarService.stop({}, component + ': messaggi'); // non mostro la dialog con i messaggi
          toaster.pop('success', 'Eseguito', 'Eseguito');
        }
        notificationService.push(notify);
        // $scope.loadVectors();
      }
    });
  });

  //-------------------
  // Budget
  //-------------------

  $scope.loadBudgetSnapDate = function () {
    $scope.getBudgetSnapDate();
    for (var v in $scope.allVectors) {
      $scope.getBudgetSnapDate($scope.allVectors[v]);
    }
  };
  $scope.getBudgetSnapDate = function (vector) {
    if (angular.isDefined(vector)) {
      vector.bdgSnapDate = undefined;
    } else {
      $scope.filterBdgSnapDate = undefined;
    }
    var p = consumptionAnalysisFactory().getBudgetSnap({
      sources: 'creationDate'
    }, getQuery(vector)).$promise;
    p.then(function (resp) {
      if (resp.result && resp.result.creationDate) {
        if (angular.isDefined(vector)) {
          vector.bdgSnapDate = new Date(resp.result.creationDate);
        } else {
          $scope.filterBdgSnapDate = new Date(resp.result.creationDate);
        }
      } else {
        if (angular.isDefined(vector)) {
          vector.bdgSnapDate = 'Non presente';
        } else {
          $scope.filterBdgSnapDate = 'Non presente';
        }
      }
    }, function (error) {
      toaster.pop('error', 'Errore', 'Errore durante il recupero dello snapshot del budget');
    });
    return p;
  };
  $scope.recreateBudgetSnap = function (vector, mode) {
    consanalysisWSFactory.recreateBudgetSnap(getQuery(vector, mode));
  };
  $scope.createBudgetSnap = function (vector, mode) {
    consanalysisWSFactory.createBudgetSnap(getQuery(vector, mode));
  };
  $scope.createAllBudgetSnap = function () {
    consanalysisWSFactory.recreateBudgetSnap(getQuery());
  };
  $scope.deleteBudgetSnap = function (vector, mode) {
    consanalysisWSFactory.deleteBudgetSnap(getQuery(vector, mode));
  };
  function getVectorDesc(vector) {
    if (angular.isDefined(vector)) {
      return vector.model.description.toUpperCase();
    }
    return 'FILTRI';
  }

  //-------------------
  // Contatore - Z.T.
  //-------------------

  $scope.recreateZtSnap = function () {
    consanalysisWSFactory.recreateAssociationsSnap(getQuery());
  };
  $scope.createZtSnap = function () {
    consanalysisWSFactory.createAssociationsSnap(getQuery());
  };
  $scope.deleteZtSnap = function () {
    consanalysisWSFactory.deleteAssociationsSnap(getQuery());
  };

  //-------------------
  // Day Degrees
  //-------------------

  $scope.loadDDSnapsDate = function () {
    // il recupero dello snapshot dell'analisi consumi richiede il recupero del budget: se non ho snap del budget
    // evito di chiamare (altrimenti la commessa 1600003 scoppia)
    $scope.filterDDSnapDate = undefined;
    for (var v in $scope.allVectors) {
      $scope.allVectors[v].ddSnapDate = undefined;
    }
    $scope.getBudgetSnapDate().then(function (resp) {
      if (resp.result && resp.result.creationDate) {
        $scope.getDDSnapDate();
      } else {
        $scope.filterDDSnapDate = 'No budget snap';
      }
    }, function (error) {
      // toaster.pop('error', 'Errore', 'Errore durante il recupero dello snapshot del budget');
    });
    angular.forEach($scope.allVectors, function (vector) {
      $scope.getBudgetSnapDate(vector).then(function (resp) {
        if (resp.result && resp.result.creationDate) {
          $scope.getDDSnapDate(vector);
        } else {
          vector.ddSnapDate = 'No budget snap';
        }
      }, function (error) {
        // toaster.pop('error', 'Errore', 'Errore durante il recupero dello snapshot del budget');
      });
    });
  };
  $scope.filterDDSnapDate = 'Non presente';
  $scope.getDDSnapDate = function (vector) {
    var promise = consumptionAnalysisFactory().getDDSnap({
      sources: 'creationDate'
    }, getQuery(vector)).$promise;
    promise.then(function (resp) {
      if (resp.result && resp.result.creationDate) {
        if (angular.isDefined(vector)) {
          vector.ddSnapDate = new Date(resp.result.creationDate);
        } else {
          $scope.filterDDSnapDate = new Date(resp.result.creationDate);
        }
      } else {
        if (angular.isDefined(vector)) {
          vector.ddSnapDate = 'Non presente';
        } else {
          $scope.filterDDSnapDate = 'Non presente';
        }
      }
    }, function (error) {
      toaster.pop('error', 'Errore', 'Errore durante il recupero dello snapshot dei gradi giorno');
    });
    return promise;
  };
  $scope.recreateDDSnap = function (vector, mode) {
    consanalysisWSFactory.recreateDDSnap(getQuery(vector, mode));
  };
  $scope.createDDSnap = function (vector, mode) {
    consanalysisWSFactory.createDDSnap(getQuery(vector, mode));
  };
  $scope.createAllDDSnap = function () {
    consanalysisWSFactory.recreateDDSnap(getQuery());
  };
  $scope.deleteDDSnap = function (vector, mode) {
    consanalysisWSFactory.deleteDDSnap(getQuery(vector, mode));
  };

  //-------------------
  // Consumptions
  //-------------------

  $scope.loadConsumptionsSnapsDate = function () {
    // il recupero dello snapshot dell'analisi consumi richiede il recupero del budget: se non ho snap del budget
    // evito di chiamare (altrimenti la commessa 1600003 scoppia)
    $scope.getConsumptionsSnapDate();
    angular.forEach($scope.allVectors, function (vector) {
      $scope.getConsumptionsSnapDate(vector);
    });
  };
  $scope.getConsumptionsSnapDate = function (vector) {
    if (angular.isDefined(vector)) {
      vector.consumptionsSnapDate = undefined;
    } else {
      $scope.filterConsumptionsSnapDate = undefined;
    }
    var p = consumptionAnalysisFactory().getConsumptionsSnap({
      sources: 'creationDate'
    }, getQuery(vector)).$promise;
    p.then(function (resp) {
      if (resp.result && resp.result.creationDate) {
        if (angular.isDefined(vector)) {
          vector.consumptionsSnapDate = new Date(resp.result.creationDate);
        } else {
          $scope.filterConsumptionsSnapDate = new Date(resp.result.creationDate);
        }
      } else {
        if (angular.isDefined(vector)) {
          vector.consumptionsSnapDate = 'Non presente';
        } else {
          $scope.filterConsumptionsSnapDate = 'Non presente';
        }
      }
    }, function (error) {
      toaster.pop('error', 'Errore', 'Errore durante il recupero dello snapshot dei consumi');
    });
    return p;
  };
  $scope.recreateConsumptionsSnap = function (vector, mode) {
    consanalysisWSFactory.recreateConsumptionsSnap(getQuery(vector, mode));
  };
  $scope.createConsumptionsSnap = function (vector, mode) {
    consanalysisWSFactory.createConsumptionsSnap(getQuery(vector, mode));
  };
  $scope.createAllConsumptionsSnap = function () {
    consanalysisWSFactory.recreateConsumptionsSnap(getQuery());
  };
  $scope.deleteConsumptionsSnap = function (vector, mode) {
    consanalysisWSFactory.deleteConsumptionsSnap(getQuery(vector, mode));
  };
  $scope.deleteCommissionConsumptionsSnap = function () {
    consanalysisWSFactory.deleteConsumptionsSnap(getQuery());
  };

  //------------------------
  // Consumption Analysis
  //------------------------

  $scope.loadConsAnalysisSnapsDate = function () {
    // il recupero dello snapshot dell'analisi consumi richiede il recupero del budget: se non ho snap del budget
    // evito di chiamare (altrimenti la commessa 1600003 scoppia)
    $scope.filterConsAnalysisSnapDate = undefined;
    for (var v in $scope.allVectors) {
      $scope.allVectors[v].consAnalysisSnapDate = undefined;
    }
    $scope.getBudgetSnapDate().then(function (resp) {
      if (resp.result && resp.result.creationDate) {
        $scope.getConsAnalysisSnapDate();
      } else {
        $scope.filterConsAnalysisSnapDate = 'No budget snap';
      }
    })["catch"](function (response) {
      // toaster.pop('error', 'Errore', 'Errore durante l\'eliminazione dello snapshot dei consumi');
    });
    angular.forEach($scope.allVectors, function (vector) {
      $scope.getBudgetSnapDate(vector).then(function (resp) {
        if (resp.result && resp.result.creationDate) {
          $scope.getConsAnalysisSnapDate(vector);
        } else {
          vector.consAnalysisSnapDate = 'No budget snap';
        }
      }, function (error) {
        // toaster.pop('error', 'Errore', 'Errore durante il recupero dello snapshot dei consumi');
      });
    });
  };
  $scope.getConsAnalysisSnapDate = function (vector) {
    if (vector) {
      vector.consAnalysisSnapDate = undefined;
    } else {
      $scope.filterConsAnalysisSnapDate = undefined;
    }
    var p = consumptionAnalysisFactory().getConsAnalysisSnap({
      sources: 'creationDate'
    }, getQuery(vector)).$promise;
    p.then(function (resp) {
      if (resp.result && resp.result.creationDate) {
        if (vector) {
          vector.consAnalysisSnapDate = new Date(resp.result.creationDate);
        } else {
          $scope.filterConsAnalysisSnapDate = new Date(resp.result.creationDate);
        }
      } else {
        if (vector) {
          vector.consAnalysisSnapDate = 'Non presente';
        } else {
          $scope.filterConsAnalysisSnapDate = 'Non presente';
        }
      }
    }, function (error) {
      toaster.pop('error', 'Errore', 'Errore durante il recupero dello snapshot dell\'analisi consumi');
    });
    return p;
  };
  $scope.recreateConsAnalysisSnap = function (vector, mode) {
    consanalysisWSFactory.createAnalysisSnap(getQuery(vector, mode));
  };
  $scope.createConsAnalysisSnap = function (vector, mode) {
    consanalysisWSFactory.createAnalysisSnap(getQuery(vector, mode));
  };
  $scope.createAllConsAnalysisSnap = function () {
    consanalysisWSFactory.recreateAnalysisSnap(getQuery());
  };
  $scope.deleteConsAnalysisSnap = function (vector, mode) {
    consanalysisWSFactory.deleteAnalysisSnap(getQuery(vector, mode));
  };
  $scope.deleteCommissionConsAnalysisSnap = function () {
    consanalysisWSFactory.deleteAnalysisSnap(getQuery());
  };

  //------------------------
  // All snapshots
  //------------------------

  var authId = authFactory.getAuthData().authId;
  $scope.listener = function (n) {
    $log.debug('notification', n);
    if (n.status === 'INPROGRESS') {
      loadingBarService.start(n.message);
    } else if (n.status === 'END') {
      var notify = {
        message: n.message,
        object: n.object,
        time: new Date(),
        action: 'link',
        url: 'consumptionanalysis',
        params: n.params
      };
      notificationService.push(notify);
      if (n.serviceResponse.messages && (n.serviceResponse.hasErrors || n.serviceResponse.hasWarnings)) {
        loadingBarService.stop(n.serviceResponse);
      } else {
        loadingBarService.stop();
      }

      // se ho calcolaro l'analisi consumi e non ho avuto errori => carico i dati
      if (!n.serviceResponse.hasErrors && (n.snaps.indexOf('analysis') > -1 || n.snaps.indexOf('all') > -1) && (n.action == 'CREATE' || n.action == 'RECREATE')) {
        $scope.loadVectors();
      }
    } else if (n.status === 'WARNING') {
      toaster.pop('warning', 'Avviso', n.message);
    } else if (n.status === 'ERROR') {
      toaster.pop('error', 'Errore', n.message);
    }
  };
  consanalysisWSFactory.connect(authId, $scope.listener);
  $scope.recreateAllSnapshots = function () {
    consanalysisWSFactory.recreateAllSnaps(getQuery());
  };

  //------------------------
  // Query
  //------------------------

  function getMode(vector, mode) {
    if (mode) return mode;
    if (vector) {
      return vector.total ? 'ONLY_TOTAL' : 'VECTOR';
    }
    return 'ALL';
  }
  function getQuery(vector, mode) {
    $scope.budget = {
      list: undefined
    };

    //CONSUMI E BUDGET
    var query = {
      frequency: 'MONTHLY',
      from: '',
      to: ''
    };
    var from = createDate($scope.datePicker.from);
    var to = createDate($scope.datePicker.to);
    if (from) {
      query.from = from;
    }
    if (to) {
      query.to = to;
    }
    query.mode = getMode(vector, mode); // solo per parte websocket: default: indico al backend di elaborare tutti i vettori energetici e i filtri (altri valori possibili: ONLY_FILTERS, ONLY_TOTAL)

    if (vector && vector.UUID) {
      // se ho passato un vettore specifico ignoro i filtri impostati
      query.vector_id = vector.UUID;
    } else if (!vector) {
      // se non ho passato uno specifico vettore considero i filtri impostati
      if ($scope.currentVector && angular.isDefined($scope.currentVector.UUID)) {
        query.vector_id = $scope.currentVector.UUID;
      }
      if ($scope.type.type_id && angular.isDefined($scope.type.type_id.UUID)) {
        query.contatore_type = $scope.type.type_id.UUID;
      }
      if ($scope.contatore.contatore_id && angular.isDefined($scope.contatore.contatore_id.UUID)) {
        query.contatore_id = $scope.contatore.contatore_id.UUID;
      }
    }
    if ($scope.selectedBudgets.selected && $scope.selectedBudgets.selected.length > 0) {
      query.budget_codes = '';
      var sep = '';
      $scope.selectedBudgets.selected.forEach(function (b) {
        if (b) {
          query.budget_codes += sep + b.UUID;
          sep = ',';
        }
      });
    }
    query.commission = authFactory.getAuthData().info.commissions.current.code;
    query.economic_eval = $scope.views.economic;
    return query;
  }
  $scope.checkRecordInList = function (record, recordList) {
    return recordList.some(function (element, index, array) {
      return element.UUID == record.UUID;
    });
  };
  $scope.someRecordNotInBudget = function (records) {
    return records.some(function (element, index, array) {
      return element.check == false;
    });
  };
  $scope.showInvolvedRecords = function (records, title, checkRecord, checkColTitle, filters) {
    var dialogScope = $rootScope.$new();
    dialogScope.title = title || 'contatori coinvolti';
    dialogScope.checkColTitle = checkColTitle || 'Check';
    dialogScope.search = filters;
    dialogScope.records = records;
    dialogScope.exportFn = sixExportLib.exportXLSX;
    dialogScope.showCheck = checkRecord;
    dialogScope.fileName = 'contatori';
    dialogScope.columns = [{
      key: 'type',
      name: 'Tipo'
    }, {
      key: 'code',
      name: 'Codice'
    }, {
      key: 'description',
      name: 'Descrizione'
    }, {
      key: 'UUID',
      name: 'UUID'
    }, {
      key: 'check',
      name: dialogScope.checkColTitle
    }];
    var involvedRecordsDialog = ngDialog.open({
      name: 'involvedRecordsDialog',
      closeByDocument: false,
      showClose: true,
      template: '' + '<a class="btn btn-xs btn-info pull-right m-r-lg" ng-click="exportFn(columns, records, fileName)"><span class="fa fa-download"></span> Esporta xlsx</a>' + '<div style="font-size: small" class="pull-right m-r-lg"><strong>{{(records | filter: {type: search.type, code: search.code, description: search.description, UUID: search.UUID, check: search.check}).length}} di {{records.length}}</strong></div>' + '<div style="font-size: small"><strong>{{title}}</strong></div>' + '<table class="tinyTable m-t">' + '<tr style="border-bottom: 2px">' + '<th style="min-width: 10%">' + 'Tipo' + '<input type="text" ng-model="search.type" class="form-control input-sm" placeholder="tipo ..." /> ' + '</th>' + '<th style="min-width: 10%">' + 'Codice' + '<input type="text" ng-model="search.code" class="form-control input-sm" placeholder="codice ..." /> ' + '</th>' + '<th style="min-width: 70%">' + 'Descrizione' + '<input type="text" ng-model="search.description" class="form-control input-sm" placeholder="descrizione ..." /> ' + '</th>' + '<th style="min-width: 10%">' + 'UUID' + '<input type="text" ng-model="search.UUID" class="form-control input-sm" placeholder="UUID ..." /> ' + '</th>' + '<th style="width: 60px" ng-show="showCheck">' + '{{checkColTitle}}' + '<select ng-model="search.check" class="form-control input-sm">' + '<option value=""></option>' + '<option value="true">Si</option>' + '<option value="false">No</option>' + '</select> ' + '</th>' + '</tr>' + '<tr ng-repeat="r in records | filter: {type: search.type, code: search.code, description: search.description, UUID: search.UUID, check: search.check} | orderBy:[\'type\', \'code\', \'description\', \'UUID\']" ng-if="records && records.length>0">' + '<td>{{r.type}}</td>' + '<td>{{r.code}}</td>' + '<td>{{r.description}}</td>' + '<td>{{r.UUID}}</td>' + '<td ng-show="showCheck" style="text-align: center">' + '<i class="fa" ng-class="{\'fa-check text-success-dker\': r.check, \'fa-times text-danger-dker\': !r.check}"></i>' + '</td>' + '</tr>' + '<tr ng-show="!records || records.length==0">' + '<td colspan="5">' + '<span>Nessun contatore coinvolto</span>' + '</td>' + '</tr>' + '</table>',
      plain: true,
      className: 'ngdialog-theme-default',
      width: '60%',
      scope: dialogScope
    });
  };
  $scope.getWarningTooltip = function (vector, economic) {
    if (vector && vector.cachedData && vector.cachedData.budget && $scope.someRecordNotInBudget(vector.cachedData.budget.consumptionInvolvedRecords)) {
      if (economic) {
        return 'N.B. la valorizzazione potrebbe considerare soltanto i contatori inseriti a budget a causa di alcune variabili deducibili soltanto da questo (es. \'cg\' per i contatori gas)';
      } else {
        return 'N.B. il consuntivo considera contatori che potrebbero NON essere presenti a budget: le statistiche sottostanti potrebbero non essere coerenti';
      }
    }
  };

  /****** VIEW MODE ******/

  $scope.views = {
    um: true,
    std: false,
    economic: true
  };
  $scope.viewMode = function (mode) {
    var dialog;
    var dialogScope = {
      reload: function reload() {
        $scope.loadVectors();
        dialog.close();
      },
      btnUpdate: $scope.btnUpdate
    };
    var opts = {
      name: 'economicInfoTemplate',
      closeByDocument: true,
      plain: false
    };
    switch (mode) {
      case 'um':
        $scope.views.um = !$scope.views.um;
        break;
      case 'std':
        $scope.views.std = !$scope.views.std;
        break;
      case 'economic':
        if (!sixObjectLib.isEmpty($scope.vectors) && !$scope.views.economic) {
          dialog = dialogService.templateDialog('economicInfoTemplate.html', dialogService.DIALOG_TYPE.WARNING, dialogScope, opts, -1, false);
        }
        $scope.views.economic = !$scope.views.economic;
        break;
    }
    return $scope.views;
  };

  /****** SIDEBAR ******/

  $scope.sidebar = false;
  $scope.toggleSidebar = function () {
    $scope.sidebar = !$scope.sidebar;
  };

  /****** INIT ******/

  var params = localStorageService.get('params');
  if (params && params.commission != currentCommission.code) {
    switchProfile(params.commission);
  } else {
    prefillParams();
  }
  function prefillParams() {
    var params = localStorageService.get('params');
    if (params) {
      // from
      if (params.from) {
        var splitted = params.from.split('-');
        $scope.datePicker.from = new Date(splitted[0], splitted[1] - 1, splitted[2]);
      }

      // to
      if (params.to) {
        var splitted = params.to.split('-');
        $scope.datePicker.to = new Date(splitted[0], splitted[1] - 1, splitted[2]);
      }

      // vettore energetico
      if (params.vector_id) {
        recordFactory('vettoreenergetico').byUUID({
          id: params.vector_id
        }).$promise.then(function (data) {
          $scope.vector.id = sixObjectLib.recordToHisRef(data);
          return data;
        }).then(function () {
          // tipo contatore
          if (params.contatore_type) {
            return schemaFactory().byUUID({
              id: params.contatore_type
            }).$promise.then(function (data) {
              $scope.type.type_id = sixObjectLib.recordToHisRef(data);
              return data;
            });
          }
          return $q.defer().resolve(); // se non entro nell'if
        }).then(function () {
          // contatore
          if (params.contatore_id) {
            return recordFactory(params.contatore_type).byUUID({
              id: params.contatore_id
            }).$promise.then(function (data) {
              $scope.contatore.contatore_id = sixObjectLib.recordToHisRef(data);
              return data;
            });
          }
          return $q.defer().resolve(); // se non entro nell'if
        });
      }

      // budget
      if (params.budget_codes) {
        // es: [{"default":true,"code":"BDG_2017_1500068","year":2017,"description":"BDG_2017_1500068","eval_date":"2016-08-31T22:00:00.000Z","UUID":"BDG_2017_1500068_2017"}]
        $scope.selectedBudgets.selected.length = 0;
        var splitted = params.budget_codes.split(',');
        getAvailableBudgetCodes().then(function (list) {
          list.forEach(function (bdg) {
            if (splitted.indexOf(bdg.UUID) >= 0) {
              $scope.selectedBudgets.selected.push(bdg);
            }
          });
        });
      }
      localStorageService.remove('params');
    }
  }
  function switchProfile(commission) {
    if (commission) {
      //switcho immediatamente commessa se necessario
      if (commission != currentCommission.code) {
        commissionFactory().getCommissionByCode({
          code: commission
        }).$promise.then(function (commissionResponse) {
          var switchProfileElement = {
            selected: {
              type: '',
              cod: 0,
              code: commission,
              description: commissionResponse.description,
              items: [{
                type: 'commission',
                cod: 0,
                code: commission,
                description: commission + ' - ' + commissionResponse.description
              }]
            }
          };
          loginFactory["switch"](switchProfileElement).$promise.then(function (response) {
            $log.info('Switch automatico commessa');
            response.info.commissions.current = commissionResponse;
            authFactory.setAuthData(response);
            $route.reload();
          });
        });
      }
    }
  }

  /* *************** */
  /* Stato websocket */
  /* *************** */

  $scope.btnUpdate = {
    label: 'Sconosciuto',
    "class": 'btn-info'
  };
  $scope.$watch(function () {
    return consanalysisWSFactory.status();
  }, function (newVal, oldVal) {
    $log.debug('--- ' + consanalysisWSFactory.status());
    switch (consanalysisWSFactory.status()) {
      case 0:
        $scope.btnUpdate.label = 'In connessione';
        $scope.btnUpdate["class"] = 'btn-warning';
        break;
      case 1:
        $scope.btnUpdate.label = 'Connesso';
        $scope.btnUpdate["class"] = 'btn-success';
        break;
      case 2:
        $scope.btnUpdate.label = 'In disconnessione';
        $scope.btnUpdate["class"] = 'btn-danger';
        break;
      case 3:
        $scope.btnUpdate.label = 'Disconnesso';
        $scope.btnUpdate["class"] = 'btn-danger';
        break;
      default:
        $scope.btnUpdate.label = 'Sconosciuto';
        $scope.btnUpdate["class"] = 'btn-info';
        break;
    }
  });
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:ConsumptionAnalysisCrossCtrl
 * @description
 * # ConsumptionAnalysisCrossCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/consumptionanalysiscross', {
    templateUrl: 'energy/consumptionanalysis/consumptionanalysiscross.html',
    controller: 'ConsumptionAnalysisCrossCtrl'
  });
}]).controller('ConsumptionAnalysisCrossCtrl', ["$scope", "energyCarrierFactory", "authFactory", "consumptionFactory", "recordFactory", "budgetFactory", "$q", "ENERGY_URL", "DEV", "consumptionAnalysisFactory", "$location", "$anchorScroll", "dialogService", "errorService", "toaster", "$window", "commissionFactory", "$filter", "APP_URL", "$http", "SaveAs", "$log", "cfpLoadingBar", "loadingBarService", "ngDialog", function ($scope, energyCarrierFactory, authFactory, consumptionFactory, recordFactory, budgetFactory, $q, ENERGY_URL, DEV, consumptionAnalysisFactory, $location, $anchorScroll, dialogService, errorService, toaster, $window, commissionFactory, $filter, APP_URL, $http, SaveAs, $log, cfpLoadingBar, loadingBarService, ngDialog) {
  var SHOW_ERROR_POPUP = true;
  $scope.type = {};
  $scope.currentVector = {};
  $scope.vector = {};
  $scope.commissionList = [];
  $scope.commissions = {
    selected: []
  };
  $scope.contatoreTypeFilter = {
    'model.code': ''
  };
  $scope.datePicker = {
    from: new Date(new Date().getFullYear(), 0, 1),
    to: new Date(new Date().getFullYear(), 11, 31)
  };
  $scope.$watch(function () {
    return $scope.vector.id;
  }, function (newVal, oldVal) {
    if (angular.isDefined(newVal) && newVal !== oldVal) {
      updateContatoreTypeFilter();
    } else {
      $scope.type = {};
    }
  });
  $scope.$watch('datePicker', function (newVal, oldVal) {
    if (angular.isDefined(newVal)) {
      //caricamento lista commesse valide
      var commissionSearchOptions = {
        page_size: 10000
      };
      var commissionFilter = {
        'opened': sixFiltersLib.must({
          'o1': sixFiltersLib.should({
            'missOpening': sixFiltersLib.missing('date')
          }),
          'o2': sixFiltersLib.should({
            'dateBeforeEnd': sixFiltersLib.rangeLte('date', newVal.to)
          })
        }),
        'closed': sixFiltersLib.must({
          'c1': sixFiltersLib.should({
            'missClosing': sixFiltersLib.missing('closing_date')
          }),
          'c2': sixFiltersLib.should({
            'closingDateAfterStart': sixFiltersLib.rangeGte('closing_date', newVal.from)
          })
        })
      };
      commissionFactory().search(commissionSearchOptions, commissionFilter).$promise.then(function (commissions) {
        if (commissions && commissions.list) {
          ///generazione lista per la lookup
          $scope.commissionList = commissions.list.map(function (c) {
            return {
              'description': c.description,
              'key': c.code
            };
          });

          //pulizia valori eventualmente già selezionati
          if ($scope.commissions.selected.length) {
            var whitelist = $scope.commissionList.map(function (c) {
              return c.key;
            });
            $scope.commissions.selected = $scope.commissions.selected.filter(function (v) {
              if (whitelist.indexOf(v.key) !== -1) {
                return true;
              } else {
                return false;
              }
            });
          }
        }
      });
    }
  }, true);
  function replaceAll(str, find, replace) {
    return str.replace(new RegExp(find, 'g'), replace);
  }

  /* **************** */
  /* **** REPORT **** */
  /* **************** */

  function dateTimeStringFormatted(date) {
    var dateStr = '';
    if (date instanceof Date) {
      dateStr = date.getDate() + "_" + (date.getMonth() + 1) + "_" + date.getFullYear() + "_" + date.getHours() + "_" + date.getMinutes() + "_" + date.getSeconds();
    }
    return dateStr;
  }
  var REPORT_JASPER_DIRECTORY = 'reports/EMMA/Energy/'; /* path del report su jasperserver */
  var REPORT_JASPER_NAME = 'consumptionanalysis_cross_tab_all_vectors'; /* path del report su jasperserver */
  var REPORT_XLS_JASPER_NAME = 'consumptionanalysis_cross_tab_all_vectors_xls'; /* path del report su jasperserver */

  $scope.openDialogReport = function (extensionFile) {
    printReportConsumptionAnalysis(callJasper, extensionFile);
  };
  function printReportConsumptionAnalysis(printReport, extensionFile) {
    var userFilter = {
      'model.username': sixFiltersLib.exact('model.username', authFactory.getAuthData().authId)
    };
    recordFactory('operatore').search(userFilter).$promise.then(function (resp) {
      if (resp.list) {
        document.getElementById("dialog_notify_to").value = resp.list[0].model.mail;
      }
    });
    var message = 'Selezionare le voci da esportare';
    var listItemDialog = ngDialog.openConfirm({
      name: 'printReportConsumptionAnalysisDialog',
      closeByDocument: false,
      showClose: true,
      template: '' + '<div style="text-align:center"><i class="fa fa-list"></i>&nbsp; ' + message + '</div><br>' + '<input type="checkbox" id="input_cons" ng-init="itemList.cons=true" ng-model="itemList.cons"/> <label for="input_cons" class="control-label"> Consuntivo</label><br />' + '<input type="checkbox" id="input_cons_std" ng-init="itemList.cons_std=true" ng-model="itemList.cons_std"/> <label for="input_cons_std" class="control-label"> Consuntivo std</label><br />' + '<input type="checkbox" id="input_budget" ng-init="itemList.budget=true" ng-model="itemList.budget"/> <label for="input_budget" class="control-label"> Budget</label><br />' + '<input type="checkbox" id="input_season" ng-model="itemList.season"/> <label for="input_season" class="control-label"> Stagionalità</label><br />' + '<input type="checkbox" id="input_delta_season" ng-model="itemList.deltaSeason"/> <label for="input_delta_season" class="control-label"> Delta stagionalità</label><br />' + '<input type="checkbox" id="input_delta_tech" ng-model="itemList.deltaTech"/> <label for="input_delta_tech" class="control-label"> Delta tecnico</label><br />' + '<input type="checkbox" id="input_percentage" ng-model="itemList.percentage"/> <label for="input_percentage" class="control-label"> Scostamento percentuale</label><br />' + '<input type="checkbox" id="input_bdg_economic" ng-model="itemList.budgetEconomic"/> <label for="input_bdg_economic" class="control-label"> Budget valorizz.</label><br />' + '<input type="checkbox" id="input_cons_economic" ng-model="itemList.consEconomic"/> <label for="input_cons_economic" class="control-label"> Consuntivo valorizz.</label><br />' + '<div class="row wrapper pull-right">' + '<input type="checkbox" id="split_by_counter" ng-model="splitByCounter" /> ' + '<label id="split_by_counter_key" for="split_by_counter" class="control-label"> Dividi per contatore</label>' + '</div>' + '<div class="m-l-n-xxs" style="clear: both">' + '<input type="checkbox" id="async_elaboration" ng-init="async=true" ng-model="async" style="clear: both" /> <label for="async_elaboration" class="control-label"> Invia via mail</label><br />' + '</div>' + '<div class="row wrapper" style="text-align:center; clear: both" ng-show="async">' + 'Invia una notifica di completamento al seguente indirizzo:<br>' + '<input class="form-control" id="dialog_notify_to" type="email" ng-model="notifyTo" value="test@example.net"><br />' + '</div>' + '<div class="row" style="text-align:center; clear: both">' + '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ng-click="confirm()">Esporta</button>' + '</div>',
      plain: true,
      className: 'ngdialog-theme-default ngdialog-theme-custom'
    });
    listItemDialog.then(function () {
      /* lancia la stampa del report */
      var parametersSelected = {};
      parametersSelected['cons'] = document.getElementById("input_cons").checked;
      parametersSelected['cons_std'] = document.getElementById("input_cons_std").checked;
      parametersSelected['budget'] = document.getElementById("input_budget").checked;
      parametersSelected['season'] = document.getElementById("input_season").checked;
      parametersSelected['deltaSeason'] = document.getElementById("input_delta_season").checked;
      parametersSelected['deltaTech'] = document.getElementById("input_delta_tech").checked;
      parametersSelected['percentage'] = document.getElementById("input_percentage").checked;
      parametersSelected['budgetEconomic'] = document.getElementById("input_bdg_economic").checked;
      parametersSelected['consEconomic'] = document.getElementById("input_cons_economic").checked;
      var splitByCounter = document.getElementById("split_by_counter").checked;
      var async = document.getElementById("async_elaboration").checked;
      var notifyTo = document.getElementById("dialog_notify_to").value;
      if (angular.isFunction(printReport)) {
        printReport(parametersSelected, splitByCounter, notifyTo, extensionFile, async);
      }
    }, function () {/* non fa nulla */});
  }
  function callJasper(parametersMap, splitByCounter, notifyTo, extensionFile, async) {
    async = angular.isUndefined(async) ? true : async;
    var urlPrefix = DEV ? '/' : '/emma/';
    var endpointAddressGenericReport = $location.protocol() + '://' + $location.$$host + ':' + $location.$$port + urlPrefix + ENERGY_URL + '/api/report/_consumptionanalysis/_get/_cross';
    var endpointAddressSingleReport = $location.protocol() + '://' + $location.$$host + ':' + $location.$$port + urlPrefix + ENERGY_URL + '/api/report/_consumptionanalysis/_get/_data';
    // var endpointAddressGenericReport = 'http://172.29.151.80:9000' + urlPrefix + ENERGY_URL + '/api/report/_consumptionanalysis/_get/_cross';
    // var endpointAddressSingleReport = 'http://172.29.151.80:9000' + urlPrefix + ENERGY_URL + '/api/report/_consumptionanalysis/_get/_data';
    var reportNameToSave = 'report_analisi_consumi_multicommessa_' + dateTimeStringFormatted(new Date()); // nome con il quale viene salvato sul pc dell'utente
    // dove si trova il report su jasperserver (http://172.29.100.155:7878/jasperserver) + nome report .pdf
    var reportPath = REPORT_JASPER_DIRECTORY + REPORT_JASPER_NAME + '.' + extensionFile;
    if (extensionFile == 'xls' || extensionFile == 'xlsx') {
      // dove si trova il report su jasperserver (http://172.29.100.155:7878/jasperserver) + nome report .xls
      reportPath = REPORT_JASPER_DIRECTORY + REPORT_XLS_JASPER_NAME + '.' + extensionFile;
    }
    if (angular.isDefined($scope.datePicker.from) && angular.isDefined($scope.datePicker.to) && $scope.commissions.selected.length > 0) {
      // obbligatori: from, to, commesse
      var from = $scope.datePicker.from.getFullYear() + '-' + ('0' + ($scope.datePicker.from.getMonth() + 1)).slice(-2) + '-' + ('0' + $scope.datePicker.from.getDate()).slice(-2);
      var to = $scope.datePicker.to.getFullYear() + '-' + ('0' + ($scope.datePicker.to.getMonth() + 1)).slice(-2) + '-' + ('0' + $scope.datePicker.to.getDate()).slice(-2);
      var commissions = null;
      var vectorId = null;
      var contatoreTypeId = null;
      var parametersToPrint = null;
      /* scarico i codici delle commesse */
      $scope.commissions.selected.forEach(function (c, index) {
        if (index == 0) {
          commissions = c.key;
        } else {
          commissions = commissions + ',' + c.key;
        }
      });
      /* imposto il vettore corrente */
      if (angular.isDefined($scope.vector.id)) {
        vectorId = $scope.vector.id.UUID;
      }
      /* imposto il tipo contatore */
      if (angular.isDefined($scope.type.type_id)) {
        contatoreTypeId = $scope.type.type_id.UUID;
      }
      /* imposto i parametri da stampare */
      for (var key in parametersMap) {
        if (parametersMap[key]) {
          if (parametersToPrint == null) {
            parametersToPrint = key;
          } else {
            parametersToPrint = parametersToPrint + ',' + key;
          }
        }
      }
      endpointAddressSingleReport = replaceAll(endpointAddressSingleReport, '/', '$');
      endpointAddressGenericReport = endpointAddressGenericReport + '/' + commissions + '/' + vectorId + '/' + contatoreTypeId + '/' + from + '/' + to + '/' + 'MONTHLY' + '/' + splitByCounter + '/' + parametersToPrint + '/' + endpointAddressSingleReport;
      var query = '&net.sf.jasperreports.json.source=' + endpointAddressGenericReport;
      if (extensionFile == 'xls' || extensionFile == 'xlsx') {
        query += '&ignorePagination=true';
      }
      loadingBarService.start('Generazione report in corso...');
      if (async === true) {
        var payload = [{
          path: [reportPath],
          query: query,
          filename: reportNameToSave + '.' + extensionFile
        }];
        var promise = $http.post(APP_URL + '/rest/report/generate-many?notifyTo=' + notifyTo, payload);
        promise.success(function (data, status) {
          //parametri disponibili, ma non utilizzati: headers, config
          loadingBarService.stop();
          if (status == 202) {
            toaster.pop('success', 'Elaborazione avviata', 'Elaborazione avviata, riceverai una email al completamento.');
          } else {
            toaster.pop('error', "Errore", 'Errore generazione report');
          }
        }).error(function (data, status, headers, config) {
          loadingBarService.stop();
          toaster.pop('error', "Errore", 'Errore generazione report');
        });
      } else {
        $http.post(APP_URL + '/rest/report/generate', {
          path: reportPath,
          query: query
        }, {
          responseType: 'arraybuffer'
        }).success(function (data, status, headers, config) {
          var options;
          if (extensionFile == 'pdf') {
            options = {
              type: 'application/pdf'
            };
          } else if (extensionFile == 'xls' || extensionFile == 'xlsx') {
            options = {
              type: 'application/vnd.ms-excel;'
            };
          }
          SaveAs.download(data, reportNameToSave + '.' + extensionFile, options);
          loadingBarService.stop();
        }).error(function (data, status, headers, config) {
          loadingBarService.stop();
          toaster.pop('error', "Errore", 'Errore generazione report');
        });
      }
    } else {
      toaster.pop('error', "Errore inserimento parametri", 'Parametri obbligatori: data inizio, data fine, commessa');
    }
  }

  /*********************/
  /**** Date picker ****/
  /*********************/

  $scope.dateOptionsStart = {
    datepickerMode: 'month',
    minMode: 'month',
    formatYear: 'yy',
    startingDay: 1
  };
  $scope.dateOptionsEnd = {
    datepickerMode: 'month',
    minMode: 'month',
    formatYear: 'yy',
    startingDay: 1
  };
  $scope.setEndDate = function () {
    $scope.datePicker.to = new Date($scope.datePicker.to.getFullYear(), $scope.datePicker.to.getMonth() + 1, 0);
  };
  $scope.openFrom = function ($event) {
    $scope.statusFrom.opened = true;
  };
  $scope.openTo = function ($event) {
    $scope.statusTo.opened = true;
  };
  $scope.statusFrom = {
    opened: false
  };
  $scope.statusTo = {
    opened: false
  };
  var REPORT_BASE_DIR = "reports/EMMA/";
  var REPORT_API_BASE = $location.protocol() + '://' + location.host + '' + APP_URL + '/rest/report/';
  //var REPORT_API_BASE = "http://docker0.ict-group.it:7878/six/rest/report/";
  var REPORT_QUERY_BASE = "&net.sf.jasperreports.json.source=" + REPORT_API_BASE;
  var currentCommission = authFactory.getAuthData().info.commissions.current;
  $scope.generateReport = function (reportPath, query) {
    console.log("generation report " + (APP_URL + '/rest/report/generate') + " " + reportPath + " " + query);
    loadingBarService.start('Generazione report in corso...');
    $http.post(APP_URL + '/rest/report/generate', {
      path: reportPath,
      query: query
    }, {
      responseType: 'arraybuffer'
    }).then(function (data, status, headers, config) {
      loadingBarService.stop();
      var options = {
        type: 'application/pdf'
      };
      SaveAs.download(data, 'consumption_analysis.pdf', options);
    }, function (data, status, headers, config) {
      loadingBarService.stop();
      toaster.pop('error', "Errore", 'Errore generazione report');
      // called asynchronously if an error occurs or server returns response with an error status.
    });
  };

  /*
   * Ritorna i dati in um standard (kwh) o specifica del vettore
   */
  $scope.getValues = function (vectorData) {
    if (vectorData && vectorData.cachedData && vectorData.cachedData.budget) {
      if ("Totale".localeCompare(vectorData.model.description) != 0) {
        return vectorData.cachedData.budget.um;
      } else {
        return vectorData.cachedData.budget.std;
      }
    } else {
      return {};
    }
  };
  function updateContatoreTypeFilter() {
    if ($scope.vector.id) {
      energyCarrierFactory.schemas({
        id: $scope.vector.id.UUID
      }).$promise.then(function (response) {
        $scope.contatoreTypeFilter = {
          'model.code': response.list.join()
        };
      })["catch"](function (response) {
        toaster.pop('error', 'Errore', 'Errore durante il recupero dei modelli con vettore_id ' + $scope.vettore.id.code);
      });
    }
  }
  $scope.goToAnchor = function (x) {
    $anchorScroll(x);
    window.scrollBy(0, -100); // salto le toolbar in alto (tot. 100px)
  };

  /****** SIDEBAR ******/

  $scope.sidebar = false;
  $scope.toggleSidebar = function () {
    $scope.sidebar = !$scope.sidebar;
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:ConsumptiveCtrl
 * @description
 * # ConsumptiveCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/consumptive/consumption', {
    templateUrl: 'energy/consumptive/consumptive.html',
    controller: 'ConsumptiveCtrl'
  }).when('/consumptive/consumption/import', {
    templateUrl: 'energy/consumptive/import.html',
    controller: 'ImportConsumptionCtrl'
  }).when('/consumptive/import/:multiCommission', {
    templateUrl: 'energy/consumptive/import_multicommission.html',
    controller: 'ConsumptiveCtrl'
  });
}]).controller('ConsumptiveCtrl', ["$scope", "$routeParams", "$timeout", "$log", "$location", "authFactory", "$filter", "$q", "dialogService", "recordFactory", "consumptiveFactory", "consumptionFactory", "evalFactory", "budgetFactory", "toaster", "errorService", "$templateCache", "uiGridConstants", "localStorageService", "$window", "loadingBarService", "ngDialog", "$rootScope", "schemaFactory", function ($scope, $routeParams, $timeout, $log, $location, authFactory, $filter, $q, dialogService, recordFactory, consumptiveFactory, consumptionFactory, evalFactory, budgetFactory, toaster, errorService, $templateCache, uiGridConstants, localStorageService, $window, loadingBarService, ngDialog, $rootScope, schemaFactory) {
  /**** Costanti ****/
  var NOW = new Date();
  // mese n-2. Es. now=2017-07-05 , item.data='2017-03-31' => item non passa perchè item.data<2017-04-30 (ultimo giorno di now.month-2 => 06-02=04)
  $scope.LIMIT = new Date(NOW.getFullYear(), NOW.getMonth() - 2, 0);
  var FREQ_MONTH = 'MONTHLY';
  var FREQ_DAY = 'DAILY';
  var DATA_READY_EVENT = 'data_ready';
  var IMPORTED_READS = 'imported_reads';
  var LOADED_READS = 'loaded_reads';
  var LOADED_BUDGET = 'loaded_budget';
  var LOADED_CONSUMPTIONS = 'loaded_consumptions';
  var CALC_CONSUMPTIONS = 'calc_consumptions';
  var LOADED_AVAILABLE_BUDGET_CODES = 'loaded_available_budget_codes';
  $scope.TYPE_BDG = 'budget';
  $scope.TYPE_MIXED = 'mixed';
  $scope.TYPE_CONSUMPTION = 'consumption';
  /**** Costanti: end ****/

  var dataReadyStatus = [];
  resetDataReadyStatus();
  var multiCommission = $routeParams.multiCommission == 'true';
  var currentCommission = authFactory.getAuthData().info.commissions.current;
  $scope.selectedTab = 'read';
  $scope.percent = 0;
  $scope.contatoreType = {};
  $scope.contatoreTypeFilter = {
    'model.code': 'contatoreacqua,contatoreelettricita,contatoregas,contatoregpl,serbatoioinpressione,serbatoiopressioneatmosferica,contatoreteleriscaldamento,contatoreteleraffreddamento'
  };
  $scope.contatore = {
    contatore: '',
    obj: {}
  };
  $scope.datePicker = {
    from: new Date(new Date().getFullYear(), 0, 1),
    to: new Date()
  };
  $scope.dateOptions = {
    from: {
      datepickerMode: 'month',
      minMode: 'month',
      startingDay: 1,
      formatYear: 'yyyy'
    },
    to: {
      datepickerMode: 'month',
      minMode: 'month',
      startingDay: 1,
      formatYear: 'yyyy'
    }
  };
  $scope.monthlyConsumptions = [];
  $scope.monthlyEvaluatedConsumptions = [];
  $scope.dailyConsumptions = [];
  $scope.totalPeriodConsumptions = {
    totale: 0
  };
  $scope.totalPeriodDays = 0;
  $scope.budget = {
    searchCode: [],
    list: []
  };
  $scope.priceList = {};
  $scope.selectedMonthDetail = {
    month: -1,
    year: -1
  };
  $scope.um = {};
  $scope.importingOperation = false;
  $scope.isImportBusy = false;
  $scope.isAllOk = true;
  $scope.sort = undefined;
  $scope.recordHistory = {
    active: true
  };
  $scope.economic = {
    active: false
  };
  $scope.schema = {};

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'consumptive';
  $scope.modifyOldAllowed = function () {
    return authFactory.checkPerm(RESOURCE_NAME, "MODIFY_OLD");
  };
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isClosed = function () {
    if (angular.isDefined($scope.contatore.obj) && angular.isDefined($scope.contatore.obj.model)) {
      return $scope.contatore.obj.model.stato === 'chiuso';
    }
    return false;
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
  $scope.getIconPerm = function () {
    var perm = $scope.isWritePermAllowed() && $scope.isDeletePermAllowed() && $scope.modifyOldAllowed();
    return perm ? 'fa fa-check-circle-o text-success-dker' : 'fa fa-exclamation-circle text-warning-dker';
  };
  $scope.getLabelPerm = function () {
    if ($scope.isWritePermAllowed() && $scope.isDeletePermAllowed() && $scope.modifyOldAllowed()) {
      return 'Permessi completi';
    } else if ($scope.isWritePermAllowed() && $scope.isDeletePermAllowed() && !$scope.modifyOldAllowed()) {
      return 'Possibilità di intervenire su letture/consumi con data succesiva al ' + $filter('date')($scope.LIMIT, 'yyyy-MM-dd');
    } else {
      return 'Permessi limitati';
    }
  };
  $scope.showPermissions = function () {
    var dialogScope = {
      isWritePermAllowed: $scope.isWritePermAllowed,
      isDeletePermAllowed: $scope.isDeletePermAllowed,
      modifyOldAllowed: $scope.modifyOldAllowed,
      limit: $scope.LIMIT
    };
    var opts = {
      name: 'permissionsInfoDialog',
      closeByDocument: true,
      plain: false
    };
    dialogService.templateDialog('permissionsInfoTemplate.html', dialogService.DIALOG_TYPE.INFO, dialogScope, opts, -1, false);
  };

  /***** GRID *****/

  $scope.viewGridOptions = {
    enableSorting: true,
    enableGridMenu: true,
    exporterMenuPdf: false,
    expandableRowHeight: 180,
    paginationPageSizes: [10, 20, 30],
    paginationPageSize: 10,
    useExternalPagination: true,
    gridMenuCustomItems: [{
      title: 'Pulisci',
      action: function action($event) {
        $scope.resetGrid();
      },
      order: 210
    }],
    onRegisterApi: onRegisterApiCallback,
    columnDefs: [{
      name: ' '
    }]
  };
  function cellClassFormatter(grid, row, col, rowRenderIndex, colRenderIndex) {
    var classes = '';
    var sep = '';
    if (row.entity[col.field] < 0) {
      classes += sep + 'warningRead';
      sep = ' ';
    }
    classes += sep + (row.entity.reset === true ? 'resetRead' : '');
    classes += ' ' + (row.entity.sixImportStatus === 'errore' ? 'errorRead' : '');
    classes += ' ' + (row.entity.automatic === true ? 'automaticRead' : '');
    if ($scope.importingOperation) {
      if (col.field == 'data' && !$scope.checkDate(row.entity.data)) classes += ' errorRead';
      if (row.entity.sixImportStatus && row.entity.sixImportStatus != '' && row.entity.sixImportStatus != 'OK') classes += ' errorRead';
    }
    return classes;
  }
  function cellTooltipFormatter(row, col) {
    if (row.entity[col.field] < 0) {
      return 'Lettura negativa!!';
    }
    if (row.entity.reset === true) {
      return 'Lettura con cambio contatore';
    }
    if (row.entity.automatic === true) {
      return 'Lettura prevista';
    }
    return 'Lettura';
  }
  function isCellEditable(scope) {
    var writePerm = $scope.isWritePermAllowed();
    $log.info($scope.importingOperation + ' ' + scope.row.entity.UUID + ' ' + writePerm);

    // check date
    $log.info('limit: ' + $scope.LIMIT);
    $log.info(new Date(scope.row.entity.data));
    var check = $scope.checkDate(scope.row.entity.data);
    $log.info('checkDate: ' + check);
    return !$scope.importingOperation && writePerm === true && check;
  }
  $scope.downloadTemplate = function () {
    var anchor = $('#linkToTemplate');
    var url = anchor.attr("href");
    anchor.click(function (e) {
      e.preventDefault();
      window.location.href = url;
    });
    anchor.click();
  };

  /***************/
  /**** READS ****/
  /***************/

  $scope.resetGrid = function () {
    $scope.isImportBusy = false;
    $scope.viewGridOptions.data = [];
    $scope.viewGridOptions.xlsData = [];
  };
  $scope.importData = function () {
    var inError = [];
    $scope.isImportBusy = true;
    var toSave = [];
    var selected = $scope.gridApi.selection.getSelectedRows();
    if (!selected || !selected.length) {
      selected = $scope.viewGridOptions.data;
    }
    $log.info('limit: ' + $scope.LIMIT);
    selected.forEach(function (item) {
      // check date
      $log.info(new Date(item.data));
      var check = $scope.checkDate(item.data);
      $log.info('checkDate: ' + check);
      if (check) {
        toSave.push(item);
      } else {
        inError.push(item);
      }
    });
    if (inError.length == 0) {
      $scope.saveOrUpdateReads(toSave);
    } else {
      toaster.pop('error', 'Errore importazione', 'Controllare che non vi siano letture antecedenti il ' + $filter('date')($scope.LIMIT, 'yyyy-MM-dd'));
      $scope.showReadsInError(inError);
      $scope.isImportBusy = false;
    }
  };
  $scope.checkDate = function (date) {
    if ($scope.modifyOldAllowed()) return true;
    var check = new Date(date).getTime() > $scope.LIMIT.getTime();
    return check;
  };
  $scope.showReadsInError = function (reads) {
    var dialogScope = $rootScope.$new();
    dialogScope.reads = reads;
    dialogScope.columns = [];
    dialogScope.limit = $scope.LIMIT;
    dialogScope.comparator = function (actual, expected) {
      var res = true;
      expected.split(',').forEach(function (t) {
        res = res && actual != t.trim();
      });
      return res;
    };
    dialogScope.checkColumn = function (k) {
      return k.key != '$$hashKey' && k.key != 'sixImportStatus';
    };
    angular.forEach(reads[0], function (v, k) {
      dialogScope.columns.push({
        key: k,
        name: k
      });
    });
    var readsInErrorDialog = ngDialog.open({
      name: 'readsInError',
      closeByDocument: false,
      showClose: true,
      template: '' + '<div style="font-size: small"><strong><span class="text-danger-dker">Letture in errore:</span> la data non può essere antecedente il <span class="text-info-dker">{{limit | date:\'yyyy-MM-dd\'}}</span></strong></div>' + '<table class="tinyTable m-t">' + '<tr style="border-bottom: 2px">' + '<th style="min-width: 10%" ng-repeat="k in columns | filter: { key: \'$$hashKey\,sixImportStatus,record_id\' }: comparator">' + '{{k.name}}' + '</th>' + '</tr>' + '<tr ng-repeat="r in reads">' + '<td ng-repeat="k in columns | filter: { key: \'$$hashKey,sixImportStatus,record_id\' }: comparator">' + '<span ng-if="!r[k.key].code">{{r[k.key]}}</span>' + '<span ng-if="r[k.key].code">{{r[k.key].code}}</span>' + '</td>' + '</tr>' + '</table>',
      plain: true,
      className: 'ngdialog-theme-default',
      width: '60%',
      scope: dialogScope
    });
  };
  function prepareDataForSaving(value) {
    var toSave = angular.copy(value);
    toSave.reads = [];
    toSave.record_id.type = $scope.contatoreType.tipo_id.UUID;
    toSave.date = toSave.data;
    delete toSave.sixImportStatus;
    delete toSave.data;
    delete toSave.um;
    delete toSave.value;
    switch ($scope.contatoreType.tipo_id.UUID) {
      case 'contatoreelettricita':
        delete toSave.pod;
        if (toSave.f0) {
          toSave.reads.push({
            time_slot: 'f0',
            value: parseFloat(toSave.f0)
          });
        }
        if (toSave.f1) {
          toSave.reads.push({
            time_slot: 'f1',
            value: parseFloat(toSave.f1)
          });
        }
        if (toSave.f2) {
          toSave.reads.push({
            time_slot: 'f2',
            value: parseFloat(toSave.f2)
          });
        }
        if (toSave.f3) {
          toSave.reads.push({
            time_slot: 'f3',
            value: parseFloat(toSave.f3)
          });
        }
        delete toSave.f0;
        delete toSave.f1;
        delete toSave.f2;
        delete toSave.f3;
        break;
      case 'contatoregas':
        delete toSave.pdr;
        if (toSave.f0) {
          var read = {
            time_slot: 'f0',
            // lettura
            value: parseFloat(toSave.f0)
          };
          if (toSave.correttore) {
            read.correttore = parseFloat(toSave.correttore);
          }
          toSave.reads.push(read);
        }
        delete toSave.f0;
        delete toSave.correttore;
        break;
      case 'contatoreacqua':
        delete toSave.matricola;
        if (toSave.f0) {
          toSave.reads.push({
            time_slot: 'f0',
            // lettura
            value: parseFloat(toSave.f0)
          });
        }
        delete toSave.f0;
        break;
      case 'serbatoiopressioneatmosferica':
        delete toSave.cod;
        if (toSave.f0) {
          var read = {
            time_slot: 'f0',
            // steccatura
            value: parseFloat(toSave.f0)
          };
          if (toSave.scarico) {
            read.scarico = parseFloat(toSave.scarico);
          }
          toSave.reads.push(read);
        }
        delete toSave.f0;
        delete toSave.scarico;
        break;
      case 'serbatoioinpressione':
        delete toSave.cod;
        if (toSave.f0) {
          var read = {
            time_slot: 'f0',
            // percentuale
            value: parseFloat(toSave.f0)
          };
          if (toSave.scarico) {
            read.scarico = parseFloat(toSave.scarico);
          }
          toSave.reads.push(read);
        }
        delete toSave.f0;
        delete toSave.scarico;
        break;
      case 'contatoreteleriscaldamento':
        delete toSave.cod;
        if (toSave.f0) {
          toSave.reads.push({
            time_slot: 'f0',
            value: parseFloat(toSave.f0)
          });
        }
        delete toSave.f0;
        break;
      case 'contatoreteleraffreddamento':
        delete toSave.cod;
        if (toSave.f0) {
          toSave.reads.push({
            time_slot: 'f0',
            value: parseFloat(toSave.f0)
          });
        }
        delete toSave.f0;
        break;
      default:
        toaster.pop('error', 'Errore', 'Tipo contatore non riconosciuto');
    }
    return toSave;
  }
  function prepareDataForGrid(value) {
    var result = angular.copy(value.model);
    result.UUID = value.UUID;
    result.data = result.date;
    result.um = result.um_id.UUID;
    result.reads.forEach(function (read) {
      for (var key in read) {
        if (key === 'time_slot') {
          result[read.time_slot] = read.value;
        } else {
          result[key] = read[key];
        }
      }
    });
    return result;
  }
  $scope.saveOrUpdateReads = function (reads) {
    if ($scope.isWritePermAllowed() === true) {
      loadingBarService.start('Importazione...');
      startDummmyProgressBar(Math.random() * 10 + Math.random() * 10); // inizio a caso, giusto per dare la sensazione che stia facendo qualcosa...
      var error = false;
      var toSave = [];
      // Controllo se è tutto corretto
      reads.forEach(function (value) {
        var tmp = prepareDataForSaving(value);
        if (!tmp.date || !tmp.record_id.type || !tmp.record_id.code || tmp.reads.length == 0) {
          toaster.pop('error', 'Errore', 'Controllare tipo e codice contatore, data e letture');
          error = true;
          resetDummmyProgressBar();
          $scope.$broadcast(DATA_READY_EVENT, IMPORTED_READS);
          return;
        }
        toSave.push(tmp);
      });
      if (!error) {
        var query = {
          record_history: $scope.recordHistory.active
        };

        //consumptiveFactory.bulk(toSave).$promise.then(function (response) {
        var promise;
        if (multiCommission === true) {
          promise = consumptiveFactory.bulkMulticommission(query, toSave).$promise;
        } else {
          promise = consumptiveFactory.bulk(query, toSave).$promise;
        }
        promise.then(function (response) {
          $scope.percent = 100;
          if (response.hasErrors || response.hasWarnings) {
            dialogService.serviceResponse('Consumi', response, true);
          }
          reads.forEach(function (item) {
            item['sixImportStatus'] = 'errore';
            response.list.forEach(function (i) {
              // aggiorno lo stato delle varie righe
              if (i.model.record_id.code === item.record_id.code) {
                item['sixImportStatus'] = 'importato';
              }
            });
          });
        })["catch"](function (response) {
          $scope.percent = 0;
          if (response.hasErrors || response.hasWarnings) {
            dialogService.serviceResponse('Consumi', response, true);
          }
          stopDummmyProgressBar();
          $log.error('Errore durante il salvataggio', response);
          toaster.pop('error', 'Errore', 'Errore durante il salvataggio');
        })["finally"](function (response) {
          $log.debug('Consumptive import is over');
          $scope.isImportBusy = false;
          $scope.$broadcast(DATA_READY_EVENT, IMPORTED_READS);
          loadingBarService.stop();
          $scope.loadConsumptions();
        });
      }
    }
  };
  function saveOrUpdateSingleRead(value, counter, totalCount) {
    if ($scope.isWritePermAllowed() === true) {
      var toSave = prepareDataForSaving(value);
      if (!toSave.date || !toSave.record_id.type || !toSave.record_id.code || toSave.reads.length == 0) {
        toaster.pop('error', 'Errore', 'Controllare tipo e codice contatore, data e letture');
        return;
      }
      var query = {
        record_history: $scope.recordHistory.active
      };
      if (angular.isUndefined(value.UUID)) {
        // salvo una nuova lettura
        consumptiveFactory.create(query, toSave).$promise.then(function (data) {
          counter = counter + 1;
          $scope.percent = counter / totalCount * 100;
          value.UUID = data.list[0].UUID; // aggiorno l'UUID
          value.code = data.list[0].model.code; // aggiorno il codice
        })["catch"](function (response) {
          $log.error('Errore durante il salvataggio dellla lettura', value, response);
          toaster.pop('error', 'Errore salvataggio', 'Errore durante il salvataggio');
        })["finally"](function () {
          $scope.loadReads();
          $scope.loadConsumptions();
        });
      } else {
        query.id = value.code;
        query.type = 'read';
        consumptiveFactory.update(query, toSave).$promise.then(function (data) {
          counter = counter + 1;
          $scope.percent = counter / totalCount * 100;
          value.UUID = data.UUID; // aggiorno l'UUID
          value.code = data.model.code; // aggiorno il codice
        })["catch"](function (response) {
          $log.error('Errore durante il salvataggio dellla lettura', value, response);
          toaster.pop('error', 'Errore salvataggio', 'Errore durante il salvataggio');
        })["finally"](function () {
          $scope.loadReads();
          $scope.loadConsumptions();
        });
      }
    }
  }
  $scope.addRead = function () {
    var newRead = {};
    newRead.type = 'read';
    newRead.um_id = $scope.contatore.obj.model.um_letture_id;
    newRead.record_id = $scope.contatore.contatore_id;
    newRead.data = $filter('date')(new Date(), 'yyyy-MM-dd');
    $scope.viewGridOptions.data.unshift(newRead);
    $scope.totalResults++;
  };
  $scope.removeReadsWithDialog = function (rows) {
    dialogService.confirmDialog('Eliminare le letture?', function () {
      $scope.removeReads(rows);
    });
  };
  $scope.removeReads = function (rows) {
    var promises = [];
    if ($scope.importingOperation === false) {
      rows.forEach(function (data) {
        if (data.code) {
          // usiamo data.code perchè NON abbiamo l'id, ma coincidono
          var prom = consumptiveFactory["delete"]({
            id: data.code
          }).$promise.then(function (response) {
            console.log(response);
            // successo
          })["catch"](function (response) {
            $log.error('Impossibile eliminare il dato', data, response);
            toaster.pop('error', 'Errore', 'Impossibile eliminare il dato del ' + data.date);
          });
          promises.push(prom);
        }
      });
      $q.all(promises).then(function (responses) {
        getReads();
      }); // ricarico i dati solo dopo aver eliminato tutti i selezionati
    } else {
      rows.forEach(function (data) {
        var idx = $scope.viewGridOptions.data.indexOf(data);
        $scope.viewGridOptions.data.splice(idx, 1);
      });
    }
  };
  $scope.loadReads = function () {
    loadingBarService.start();
    getReads();
  };
  function getConsumptiveReadsSortFields() {
    if ($scope.sort && $scope.sort.fields) {
      if ($scope.sort.fields === 'data') {
        return 'model.date';
      }
      return 'model.' + $scope.sort.fields;
    }
    return 'model.date';
  }
  function getConsumptiveReadsSortDirections() {
    if ($scope.sort && $scope.sort.directions) {
      return $scope.sort.directions;
    }
    return 'desc';
  }
  function getConsumptiveReadsQuery() {
    var from = $filter('date')($scope.datePicker.from, 'yyyy-MM-dd');
    var to = $filter('date')($scope.datePicker.to, 'yyyy-MM-dd');
    var query = {
      page: paginationOptions.pageNumber,
      page_size: paginationOptions.pageSize,
      sort_fields: getConsumptiveReadsSortFields(),
      sort_directions: getConsumptiveReadsSortDirections()
    };
    if (from) {
      query.from = from;
    }
    if (to) {
      query.to = to;
    }
    if ($scope.contatore.contatore_id) {
      query.type = $scope.contatore.contatore_id.type;
      query.id = $scope.contatore.contatore_id.UUID;
    }
    return query;
  }
  if ($scope.modifyOldAllowed()) {
    $scope.datepickerOptions = {};
  } else {
    $scope.datepickerOptions = {
      minDate: new Date($scope.LIMIT.getFullYear(), $scope.LIMIT.getMonth(), $scope.LIMIT.getDate() + 1)
    };
  }
  var dateCellTemplate = '<div><form name="inputForm"><div ui-grid-edit-datepicker datepicker-options="datepickerOptions" ng-class="\'colt\' + col.uid"></div></form></div>';
  var actionsCol = {
    displayName: '',
    field: 'id',
    headerCellTemplate: '<div><button class="btn btn-sm" style="background-color: transparent !important" ng-disabled="!grid.appScope.contatore.contatore_id || grid.appScope.importingOperation || grid.appScope.isWritePermAllowed() === false || grid.appScope.isClosed()" ng-click="grid.appScope.addRead()"><span class="fa fa-plus"></span></button></div>',
    cellTemplate: '<div title="Elimina"><button class="btn btn-xs" style="background-color: transparent !important" ng-click="grid.appScope.removeReadsWithDialog([row.entity])" ng-disabled="grid.appScope.isDeletePermAllowed() === false || !grid.appScope.checkDate(row.entity.data)"><span class="fa fa-trash"></span></button></div>',
    width: 50,
    enableSorting: false,
    enableFiltering: false,
    enableCellEdit: false,
    cellClass: cellClassFormatter
  };
  function updateColumnDefs() {
    $scope.viewGridOptions.isRowSelectable = function (row) {
      return !($scope.isDeletePermAllowed() === false || !$scope.checkDate(row.entity.data));
    };
    $scope.viewGridOptions.columnDefs = [];
    if ($scope.contatoreType && $scope.contatoreType.tipo_id) {
      if ($scope.importingOperation === true) {
        $scope.viewGridOptions.columnDefs.unshift({
          name: 'Stato importazione',
          field: 'sixImportStatus',
          cellClass: cellClassFormatter
        });
      }
      switch ($scope.contatoreType.tipo_id.UUID) {
        case 'contatoreelettricita':
          $scope.viewGridOptions.columnDefs.push({
            name: 'Pod',
            field: 'record_id.code',
            enableCellEdit: false,
            cellClass: cellClassFormatter,
            cellTooltip: cellTooltipFormatter
          });
          $scope.viewGridOptions.columnDefs.push({
            name: 'Data',
            field: 'data',
            cellEditableCondition: isCellEditable,
            type: 'date',
            editableCellTemplate: dateCellTemplate,
            cellFilter: 'date:"yyyy-MM-dd"',
            cellClass: cellClassFormatter
          });
          $scope.viewGridOptions.columnDefs.push({
            name: 'F0',
            field: 'f0',
            cellEditableCondition: isCellEditable,
            cellClass: cellClassFormatter,
            cellTooltip: cellTooltipFormatter,
            enableSorting: false
          });
          $scope.viewGridOptions.columnDefs.push({
            name: 'F1',
            field: 'f1',
            cellEditableCondition: isCellEditable,
            cellClass: cellClassFormatter,
            cellTooltip: cellTooltipFormatter,
            enableSorting: false
          });
          $scope.viewGridOptions.columnDefs.push({
            name: 'F2',
            field: 'f2',
            cellEditableCondition: isCellEditable,
            cellClass: cellClassFormatter,
            cellTooltip: cellTooltipFormatter,
            enableSorting: false
          });
          $scope.viewGridOptions.columnDefs.push({
            name: 'F3',
            field: 'f3',
            cellEditableCondition: isCellEditable,
            cellClass: cellClassFormatter,
            cellTooltip: cellTooltipFormatter,
            enableSorting: false
          });
          break;
        case 'contatoregas':
          $scope.viewGridOptions.columnDefs.push({
            name: 'PDR',
            field: 'record_id.code',
            enableCellEdit: false,
            cellClass: cellClassFormatter,
            cellTooltip: cellTooltipFormatter
          });
          $scope.viewGridOptions.columnDefs.push({
            name: 'Data',
            field: 'data',
            cellEditableCondition: isCellEditable,
            type: 'date',
            editableCellTemplate: dateCellTemplate,
            cellFilter: 'date:"yyyy-MM-dd"',
            cellClass: cellClassFormatter
          });
          $scope.viewGridOptions.columnDefs.push({
            name: 'Lett. contatore',
            field: 'f0',
            cellEditableCondition: isCellEditable,
            cellClass: cellClassFormatter,
            cellTooltip: cellTooltipFormatter,
            enableSorting: false
          });
          $scope.viewGridOptions.columnDefs.push({
            name: 'Lett. correttore',
            field: 'correttore',
            cellEditableCondition: isCellEditable,
            cellClass: cellClassFormatter,
            cellTooltip: cellTooltipFormatter,
            enableSorting: false
          });
          break;
        case 'contatoreacqua':
          $scope.viewGridOptions.columnDefs.push({
            name: 'Matricola',
            field: 'record_id.code',
            enableCellEdit: false,
            cellClass: cellClassFormatter,
            cellTooltip: cellTooltipFormatter
          });
          $scope.viewGridOptions.columnDefs.push({
            name: 'Data',
            field: 'data',
            cellEditableCondition: isCellEditable,
            type: 'date',
            editableCellTemplate: dateCellTemplate,
            cellFilter: 'date:"yyyy-MM-dd"',
            cellClass: cellClassFormatter
          });
          $scope.viewGridOptions.columnDefs.push({
            name: 'Lettura',
            field: 'f0',
            cellEditableCondition: isCellEditable,
            cellClass: cellClassFormatter,
            cellTooltip: cellTooltipFormatter,
            enableSorting: false
          });
          break;
        case 'serbatoiopressioneatmosferica':
          $scope.viewGridOptions.columnDefs.push({
            name: 'Cod.',
            field: 'record_id.code',
            enableCellEdit: false,
            cellClass: cellClassFormatter,
            cellTooltip: cellTooltipFormatter
          });
          $scope.viewGridOptions.columnDefs.push({
            name: 'Data',
            field: 'data',
            cellEditableCondition: isCellEditable,
            type: 'date',
            editableCellTemplate: dateCellTemplate,
            cellFilter: 'date:"yyyy-MM-dd"',
            cellClass: cellClassFormatter
          });
          $scope.viewGridOptions.columnDefs.push({
            name: 'Steccatura',
            field: 'f0',
            cellEditableCondition: isCellEditable,
            cellClass: cellClassFormatter,
            cellTooltip: cellTooltipFormatter,
            enableSorting: false
          });
          $scope.viewGridOptions.columnDefs.push({
            name: 'Scarico [l]',
            field: 'scarico',
            cellEditableCondition: isCellEditable,
            cellClass: cellClassFormatter,
            cellTooltip: cellTooltipFormatter,
            enableSorting: false
          });
          break;
        case 'serbatoioinpressione':
          $scope.viewGridOptions.columnDefs.push({
            name: 'Cod.',
            field: 'record_id.code',
            enableCellEdit: false,
            cellClass: cellClassFormatter,
            cellTooltip: cellTooltipFormatter
          });
          $scope.viewGridOptions.columnDefs.push({
            name: 'Data',
            field: 'data',
            cellEditableCondition: isCellEditable,
            type: 'date',
            editableCellTemplate: dateCellTemplate,
            cellFilter: 'date:"yyyy-MM-dd"',
            cellClass: cellClassFormatter
          });
          $scope.viewGridOptions.columnDefs.push({
            name: 'Percentuale',
            field: 'f0',
            cellEditableCondition: isCellEditable,
            cellClass: cellClassFormatter,
            cellTooltip: cellTooltipFormatter,
            enableSorting: false
          });
          $scope.viewGridOptions.columnDefs.push({
            name: 'Scarico [l]',
            field: 'scarico',
            cellEditableCondition: isCellEditable,
            cellClass: cellClassFormatter,
            cellTooltip: cellTooltipFormatter,
            enableSorting: false
          });
          break;
        case 'contatoreteleriscaldamento':
        case 'contatoreteleraffreddamento':
          $scope.viewGridOptions.columnDefs.push({
            name: 'Cod.',
            field: 'record_id.code',
            enableCellEdit: false,
            cellClass: cellClassFormatter,
            cellTooltip: cellTooltipFormatter
          });
          $scope.viewGridOptions.columnDefs.push({
            name: 'Data',
            field: 'data',
            cellEditableCondition: isCellEditable,
            type: 'date',
            editableCellTemplate: dateCellTemplate,
            cellFilter: 'date:"yyyy-MM-dd"',
            cellClass: cellClassFormatter,
            enableSorting: false
          });
          $scope.viewGridOptions.columnDefs.push({
            name: 'Lettura',
            field: 'f0',
            cellEditableCondition: isCellEditable,
            cellClass: cellClassFormatter,
            cellTooltip: cellTooltipFormatter,
            enableSorting: false
          });
          break;
        default:
          toaster.pop('error', 'Errore', 'Tipo contatore non riconosciuto');
          return false;
      }
      $scope.viewGridOptions.columnDefs.push({
        name: 'U.M.',
        field: 'um_id.code',
        enableCellEdit: false,
        cellClass: cellClassFormatter,
        cellTooltip: cellTooltipFormatter
      });
      if (multiCommission === true) {
        $scope.viewGridOptions.columnDefs.push({
          name: 'Commessa',
          field: 'commessa',
          enableCellEdit: false,
          cellClass: cellClassFormatter
        });
      }
      $scope.viewGridOptions.columnDefs.push(actionsCol);
    }
  }
  function getReads() {
    $scope.percent = 0;
    $scope.viewGridOptions.useExternalPagination = true;
    $scope.viewGridOptions.data = [];
    $scope.importingOperation = false;
    updateColumnDefs();
    consumptiveFactory.consumptiveByContatoreInPeriod(getConsumptiveReadsQuery()).$promise.then(function (response) {
      if (response.length) {
        response.forEach(function (item) {
          $scope.viewGridOptions.data.push(prepareDataForGrid(item));
        });
        $scope.totalResults = response.totalResults;
      }
    })["catch"](function (response) {
      $log.error('Errore durante il recupero dei dati', response);
      toaster.pop('error', 'Errore', 'Errore durante il recupero dei dati');
    })["finally"](function (response) {
      $scope.$broadcast(DATA_READY_EVENT, LOADED_READS);
    });
  }

  /**********************/
  /**** CONSUMPTIONS ****/
  /**********************/

  $scope.loadConsumptions = function () {
    var from = $filter('date')($scope.datePicker.from, 'yyyy-MM-dd');
    var to = $filter('date')($scope.datePicker.to, 'yyyy-MM-dd');
    resetMatrixConsumptions();
    $scope.budget.periods = undefined;
    getConsumptions(from, to, FREQ_MONTH, false);
    getConsumptions(from, to, FREQ_DAY, false);
    if ($scope.economic.active) {
      getEvaluatedConsumptions(from, to, FREQ_MONTH);
    }
  };
  $scope.recalcConsumptions = function () {
    var from = $filter('date')($scope.datePicker.from, 'yyyy-MM-dd');
    var to = $filter('date')($scope.datePicker.to, 'yyyy-MM-dd');
    if (!$scope.checkDate(to)) {
      toaster.pop('error', 'Attenzione', 'Non è possibile ricalcolare i consumi precedenti al ' + $filter('date')($scope.LIMIT, 'yyyy-MM-dd'));
      $log.info('from: ' + from);
      $log.info('to: ' + to);
      return;
    }
    if (!$scope.checkDate(from)) {
      toaster.pop('warning', 'Attenzione', 'Non è possibile ricalcolare i consumi precedenti al ' + $filter('date')($scope.LIMIT, 'yyyy-MM-dd') + ': saranno ricalcolati i consumi dal ' + $filter('date')(from, 'yyyy-MM-dd') + ' al ' + $filter('date')(to, 'yyyy-MM-dd'));
      from = new Date($scope.LIMIT.getFullYear(), $scope.LIMIT.getMonth(), $scope.LIMIT.getDate() + 1);
      $log.info('from: ' + from);
      $log.info('to: ' + to);
    }
    $scope.deleteConsumptions(from, to, false).then(function () {
      $scope.calcAndLoadConsumptions(from, to);
    });
  };
  $scope.calcAndLoadConsumptions = function (from, to) {
    resetMatrixConsumptions();
    $scope.budget.periods = undefined;
    getConsumptions(from, to, FREQ_MONTH, true).then(function (resp) {
      $scope.loadConsumptions(); // per evitare che vengano recuperati i soli consumi imposti dai permessi sul limite di data
    });
  };

  // FIXME sarebbe da spezzare in 2 funzioni: una che recupera e una che calcola
  function getConsumptions(fromDate, toDate, frequency, calc) {
    var deferred = $q.defer();
    loadingBarService.start('Caricamento consumi...');
    var from = $filter('date')(fromDate, 'yyyy-MM-dd');
    var to = $filter('date')(toDate, 'yyyy-MM-dd');
    var query = {};
    if (from) {
      query.from = from;
    }
    if (to) {
      query.to = to;
    }
    query.frequency = frequency;
    if ($scope.um.um) {
      query.um = $scope.um.um.UUID;
    }
    query.record_history = $scope.recordHistory.active;
    var promise;
    // se è un ricalcolo cancello e ricalcolo tutto
    if (calc) {
      if ($scope.contatore.contatore_id) {
        query.type = $scope.contatore.contatore_id.type;
        query.id = $scope.contatore.contatore_id.UUID;
      }
      promise = consumptionFactory.calcAndGetConsumption(query).$promise;
    } else {
      if ($scope.contatore.contatore_id) {
        query.types = $scope.contatore.contatore_id.type;
        query.codes = $scope.contatore.contatore_id.UUID;
      }
      promise = consumptionFactory.getConsumption(query).$promise;
    }
    if (frequency === FREQ_MONTH) {
      $scope.totalPeriodConsumptions = {
        totale: 0
      };
      $scope.totalPeriodDays = sixDateLib.getDatesInPeriod(new Date(fromDate), new Date(toDate)).length;
    }
    promise.then(function (response) {
      if (response.consumptions) {
        // Totali
        if (frequency === FREQ_MONTH && response.consumptions) {
          response.consumptions.forEach(function (item) {
            $scope.totalPeriodConsumptions.totale += item.tot;
          });
          response.slots.forEach(function (slot) {
            $scope.totalPeriodConsumptions[slot.time_slot] = slot.consumption;
          });
        }
        response.consumptions.forEach(function (item) {
          item.elements.forEach(function (agg) {
            if (agg.tot !== 0) {
              var year = parseInt($filter('date')(agg.date, 'yyyy'));
              var month = parseInt($filter('date')(agg.date, 'M')) - 1;
              switch (frequency) {
                case FREQ_MONTH:
                  $scope.monthlyConsumptions[year][month] = {
                    total: agg.tot,
                    type: $scope.TYPE_CONSUMPTION
                  };
                  break;
                case FREQ_DAY:
                  var day = parseInt($filter('date')(agg.date, 'd')) - 1;
                  $scope.dailyConsumptions[year][month][day] = {
                    total: agg.tot,
                    total_std: agg.tot_std,
                    slotted: agg.slots,
                    type: $scope.TYPE_CONSUMPTION
                  };
                  break;
              }
            }
          });
          $scope.um = undefined; // Per risvegliare la lookup in modo che si accorga della modifica
          $scope.um = {
            um: item.um_id
          };
        });
        // se è un ricalcolo aggiorno anche i giornalieri
        if (calc) {
          getConsumptions(fromDate, toDate, FREQ_DAY, false);
        }
        if (frequency === FREQ_DAY) {
          $scope.graph.graphData = toObjList($scope.dailyConsumptions, false);
          $scope.graph.graphDataCum = toObjList($scope.dailyConsumptions, true);
        }

        // Dati di budget per le date dopo l'ultima lettura registrata
        if (frequency === FREQ_DAY) {
          var query = {
            from: $filter('date')(fromDate, 'yyyy-MM-dd'),
            to: $filter('date')(toDate, 'yyyy-MM-dd'),
            frequency: frequency,
            record_types: $scope.contatore.contatore_id.type,
            record_ids: $scope.contatore.contatore_id.UUID
          };
          if ($scope.um.um) {
            query.um = $scope.um.um.UUID;
          }
          var sep = '';
          if ($scope.budget.searchCode) {
            query.budget_codes = '';
            $scope.budget.searchCode.forEach(function (b) {
              query.budget_codes += sep + b.UUID;
              sep = ',';
            });
          }
          budgetFactory.byCodeForPeriod(query).$promise.then(function (response) {
            $log.debug('budgetFactory.byCodeForPeriod', response);
            if (response.result && response.result.periods && response.result.periods.length > 0) {
              $scope.budget.periods = response.result.periods;
              prepareDailyBudget(response.result.periods);
              receivedBudgetCodes = response.result.budget_codes;
            }
          })["catch"](function (error) {
            $log.error('Errore durante il recupero del budget', error);
            toaster.pop('error', 'Errore', 'Errore durante il recupero del budget');
          })["finally"](function () {
            $scope.$broadcast(DATA_READY_EVENT, LOADED_BUDGET);
          });
        }
        deferred.resolve();
      } else {
        $log.error('Errore durante il recupero dei consumi');
        toaster.pop('error', 'Errore', 'Errore durante il recupero dei consumi');
        deferred.reject();
      }
    })["catch"](function (response) {
      $log.error('Errore durante il recupero dei consumi', response);
      toaster.pop('error', 'Errore', 'Errore durante il recupero dei consumi');
    })["finally"](function (response) {
      $scope.$broadcast(DATA_READY_EVENT, LOADED_CONSUMPTIONS);
    });
    return deferred.promise;
  }
  function getBudgetByCodeFromAvailablesList(code) {
    for (var idx in $scope.availableBudgetCodes) {
      if ($scope.availableBudgetCodes[idx].UUID === code) {
        return $scope.availableBudgetCodes[idx];
      }
    }
    return null;
  }
  $scope.deleteConsumptionsWithDialog = function () {
    var from = $filter('date')($scope.datePicker.from, 'yyyy-MM-dd');
    var to = $filter('date')($scope.datePicker.to, 'yyyy-MM-dd');
    var msg = 'Eliminare i consumi?';
    if (!$scope.checkDate(to)) {
      toaster.pop('error', 'Attenzione', 'Non è possibile eliminare i consumi precedenti al ' + $filter('date')($scope.LIMIT, 'yyyy-MM-dd'));
      $log.info('from: ' + from);
      $log.info('to: ' + to);
      return;
    }
    if (!$scope.checkDate(from)) {
      from = new Date($scope.LIMIT.getFullYear(), $scope.LIMIT.getMonth(), $scope.LIMIT.getDate() + 1);
      toaster.pop('warning', 'Attenzione', 'Non è possibile eliminare i consumi precedenti al ' + $filter('date')($scope.LIMIT, 'yyyy-MM-dd') + ': saranno eliminati i consumi dal ' + $filter('date')(from, 'yyyy-MM-dd') + ' al ' + $filter('date')(to, 'yyyy-MM-dd'));
      msg = 'ATTENZIONE: non è possibile eliminare i consumi precedenti al ' + $filter('date')($scope.LIMIT, 'yyyy-MM-dd') + ': saranno eliminati i consumi dal ' + $filter('date')(from, 'yyyy-MM-dd') + ' al ' + $filter('date')(to, 'yyyy-MM-dd') + '.' + ' Eliminare?';
      $log.info('from: ' + from);
      $log.info('to: ' + to);
    }
    dialogService.confirmDialog(msg, function () {
      $scope.deleteConsumptions(from, to);
    });
  };
  $scope.deleteConsumptions = function (from, to, reload) {
    if (angular.isUndefined(reload)) {
      reload = true;
    }
    var query = {
      from: $filter('date')(from, 'yyyy-MM-dd'),
      to: $filter('date')(to, 'yyyy-MM-dd'),
      type: $scope.contatore.contatore_id.type,
      id: $scope.contatore.contatore_id.UUID
    };
    var promise = consumptionFactory["delete"](query).$promise;
    promise.then(function (response) {
      if (reload) {
        $scope.loadConsumptions();
      }
    })["catch"](function (response) {
      $log.error('Errore durante l\'eliminazione dei consumi', response);
      toaster.pop('error', 'Errore', 'Errore durante l\'eliminazione dei consumi');
    });
    return promise;
  };
  function getEvaluatedConsumptions(fromDate, toDate, frequency) {
    $scope.totalEvaluatedPeriodConsumptions = [];
    var query = {
      from: fromDate,
      to: toDate,
      frequency: frequency,
      recordTypeId: $scope.contatore.contatore_id.type,
      recordId: $scope.contatore.contatore_id.UUID,
      record_history: $scope.recordHistory
    };
    if ($scope.priceList.id && $scope.priceList.id.UUID) {
      query.priceListId = $scope.priceList.id.UUID;
    }
    evalFactory.evalConsumption(query).$promise.then(function (response) {
      if (response.hasErrors || response.hasWarnings) {
        dialogService.serviceResponse('Consumi', response, true);
      } else {
        response.list.consumptions.forEach(function (rec) {
          rec.elements.forEach(function (date) {
            var year = parseInt($filter('date')(date.date, 'yyyy'));
            var month = parseInt($filter('date')(date.date, 'M')) - 1;
            date.slots.forEach(function (slot) {
              var yearVec = $scope.monthlyEvaluatedConsumptions[year] || [];
              yearVec[month] = slot.consumption;
              $scope.monthlyEvaluatedConsumptions[year] = yearVec;
            });
          });
        });

        // Totali
        if (frequency === FREQ_MONTH) {
          $scope.totalEvaluatedPeriodConsumptions.totale = response.list.tot;
          response.list.slots.forEach(function (slot) {
            $scope.totalEvaluatedPeriodConsumptions[slot.time_slot] = slot.consumption;
          });
        }
      }
    }, function (response) {
      $log.error('Errore durante la valorizzazione dei consumi', response);
      toaster.pop('error', 'Errore valorizzazione economica', 'Errore valorizzazione economica: controllare i log');
    });
  }

  /****************/
  /**** BUDGET ****/
  /****************/

  function prepareDailyBudget(budget) {
    budget.forEach(function (item) {
      // $log.log(item);
      var date = new Date(item.date);
      var day = parseInt($filter('date')(date, 'd')) - 1;
      var month = parseInt($filter('date')(date, 'M')) - 1;
      var year = $filter('date')(date, 'yyyy');
      var toDate = new Date(parseInt(year), month, sixDateLib.daysNumberInMonth(parseInt(year), month) + 1);
      sixDateLib.getDatesInPeriod(date, toDate).forEach(function (d) {
        d.setHours(0);
        d.setMinutes(0);
        d.setSeconds(0);
        d.setMilliseconds(0);
        day = parseInt($filter('date')(d, 'd')) - 1;
        var value = item.tot / sixDateLib.daysNumberInMonth(parseInt(year), month);
        var daily = $scope.dailyConsumptions[year][month][day];
        var monthly = $scope.monthlyConsumptions[year][month];
        if (daily.type === undefined) {
          daily.total = value;
          daily.type = $scope.TYPE_BDG;
          monthly.total += value;
          if (monthly.type === undefined) {
            monthly.type = $scope.TYPE_BDG;
          } else if (monthly.type === $scope.TYPE_CONSUMPTION) {
            monthly.type = $scope.TYPE_MIXED;
          }
        }
      });
    });
  }
  var receivedBudgetCodes = [];

  /*
   * Restituisce una promise => possibile richiamarla anche con $scope.getAvailableBudgetCodes().$promise.then(function(resp) { ... });
   */
  $scope.getAvailableBudgetCodes = function () {
    var query = {
      from: $filter('date')($scope.datePicker.from, 'yyyy-MM-dd'),
      to: $filter('date')($scope.datePicker.to, 'yyyy-MM-dd')
    };
    if ($scope.contatore.contatore_id) {
      query.record_id = $scope.contatore.contatore_id.UUID;
    }
    if ($scope.contatoreType.tipo_id) {
      query.type = $scope.contatoreType.tipo_id.UUID;
    }
    return budgetFactory.budgetCodes(query).$promise.then(function (response) {
      if (response.hasOwnProperty('list')) {
        $scope.availableBudgetCodes = response.list;
      }
      $scope.$broadcast(DATA_READY_EVENT, LOADED_AVAILABLE_BUDGET_CODES);
      return $scope.availableBudgetCodes;
    });
  };

  /** Record schema **/

  function loadRecordSchema() {
    schemaFactory().byUUID({
      id: $scope.contatoreType.tipo_id.code
    }).$promise.then(function (data) {
      if (!data.model) {
        toaster.pop('error', 'Non è stato definito un modello per l\'entità ' + $scope.contatoreType.tipo_id.code);
      } else {
        $scope.schema = data;
      }
    });
  }

  /****************/
  /**** EVENTS ****/
  /****************/

  function setDateTo() {
    var endOfMonth = new Date($scope.datePicker.to.getFullYear(), $scope.datePicker.to.getMonth() + 1, 0);
    if ($scope.datePicker.to.getDate() != endOfMonth.getDate()) {
      $scope.datePicker.to = endOfMonth;
    }
  }
  function setDateFrom() {
    var startOfMonth = new Date($scope.datePicker.from.getFullYear(), $scope.datePicker.from.getMonth(), 1);
    if ($scope.datePicker.from.getDate() != startOfMonth.getDate()) {
      $scope.datePicker.from = startOfMonth;
    }
  }
  $scope.open = function ($event, picker) {
    $event.preventDefault();
    $event.stopPropagation();
    picker.opened = true;
  };
  var timeout;
  $scope.$watchGroup(['contatore.contatore_id', 'datePicker.from', 'datePicker.to'], function (event) {
    if (timeout) {
      timeout.cancel();
    }
    timeout = $timeout(function () {
      // per evitare che venga triggerato a seguito di troppi cambiamenti in sequenza
      resetDataReadyStatus();
      if ($scope.contatore && $scope.contatore.contatore_id) {
        $scope.um = undefined; // Per risvegliare la lookup in modo che si accorga della modifica
        $scope.um = {
          um_id: undefined
        };
        $scope.toggleSelectMonth();
        $scope.loadConsumptions();
        $scope.loadReads();
      } else if ($scope.contatoreType && $scope.contatoreType.tipo_id) {
        toaster.pop('error', 'Errore', 'Il contatore non è stato trovato');
      }
      $scope.getAvailableBudgetCodes();
      timeout = undefined;
    }, 500);
  });
  $scope.$watch('datePicker.from', function (newVal, oldVal) {
    setDateFrom();
  });
  $scope.$watch('datePicker.to', function (newVal, oldVal) {
    setDateTo();
  });
  $scope.$watchCollection('contatoreType', function (newValue, oldValue) {
    resetVariables(true);
    updateColumnDefs();
    if ($scope.contatoreType.tipo_id) {
      $scope.loadRecords();
      loadRecordSchema();
    }
  });
  function resetVariables(resetContatore) {
    $log.log('reset');
    if (resetContatore === true) {
      $scope.contatore.contatore_id = undefined;
      $scope.contatore = {};
      $scope.recordList = [];
    }
    $scope.viewGridOptions.data = [];
    $scope.totalPeriodConsumptions = {
      totale: 0
    };
    $scope.totalEvaluatedPeriodConsumptions = {
      totale: 0
    };
    $scope.totalPeriodDays = 0;
    $scope.budget = {
      searchCode: []
    };
    $scope.availableBudgetCodes = [];
    $scope.graph.graphData = [];
    $scope.graph.graphDataCum = [];
    resetDataReadyStatus();
    resetMatrixConsumptions();
  }
  function resetDataReadyStatus() {
    dataReadyStatus = [];
    dataReadyStatus[IMPORTED_READS] = false;
    dataReadyStatus[LOADED_READS] = false;
    dataReadyStatus[LOADED_BUDGET] = false;
    dataReadyStatus[LOADED_CONSUMPTIONS] = false;
    dataReadyStatus[CALC_CONSUMPTIONS] = false;
    dataReadyStatus[LOADED_AVAILABLE_BUDGET_CODES] = false;
  }
  function resetMatrixConsumptions() {
    if (angular.isDate($scope.datePicker.from) && angular.isDate($scope.datePicker.to)) {
      var yearsArray = $scope.getYears($scope.datePicker.from.getFullYear(), $scope.datePicker.to.getFullYear());
      $scope.monthlyConsumptions = sixMatrixLib.getInitializedMatrix({
        total: 0,
        type: undefined
      }, yearsArray, 12);
      $scope.dailyConsumptions = sixMatrixLib.getInitializedMatrix({
        total: 0,
        slotted: [],
        type: undefined
      }, yearsArray, 12, 31);
      $scope.monthlyEvaluatedConsumptions = sixMatrixLib.getInitializedMatrix(0, yearsArray, 12);
    }
  }
  $scope.$on(DATA_READY_EVENT, function (event, args) {
    dataReadyStatus[args] = true;
    if (dataReadyStatus[LOADED_AVAILABLE_BUDGET_CODES] && dataReadyStatus[LOADED_BUDGET]) {
      $scope.budget.searchCode = [];
      if (receivedBudgetCodes && receivedBudgetCodes.length > 0 && $scope.availableBudgetCodes && $scope.availableBudgetCodes.length > 0) {
        receivedBudgetCodes.forEach(function (bc) {
          var b = getBudgetByCodeFromAvailablesList(bc);
          if (angular.isDefined(b) && b != null) {
            $scope.budget.searchCode.push(b);
          }
        });
      }
    }
    if (dataReadyStatus[LOADED_AVAILABLE_BUDGET_CODES] && dataReadyStatus[LOADED_BUDGET] && dataReadyStatus[LOADED_CONSUMPTIONS] && dataReadyStatus[LOADED_READS]) {
      setTimeout(function () {
        // evita che venga richiamato troppo velocemente (altrimenti si accavalla a showLoadingMessage)
        loadingBarService.stop();
      }, 500);
    }
    if (dataReadyStatus[CALC_CONSUMPTIONS]) {
      setTimeout(function () {
        // evita che venga richiamato troppo velocemente (altrimenti si accavalla a showLoadingMessage)
        loadingBarService.stop();
      }, 500);
    }
  });
  $scope.$watchGroup(['viewGridOptions.data', 'totalResults'], function (newValue) {
    $scope.viewGridOptions.totalItems = $scope.totalResults; // aggiorna la paginazione della grid
  });

  /**** month view detail ****/

  //Month is 0 based
  $scope.daysInMonth = function (year, month) {
    return sixDateLib.daysNumberInMonth(year, month);
  };

  // index from 0 to n-1
  $scope.getTimes = function (n) {
    var list = [];
    for (var i = 0; i < n; i++) {
      list.push(i);
    }
    return list;
  };

  // months from 0 to 11
  $scope.getMonths = function () {
    return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
  };

  // 0-based
  $scope.getMonthName = function (month) {
    return sixDateLib.getMonthShortName(month);
  };

  // years from fromDate (included) to toDate (included)
  $scope.getYears = function (start, end) {
    var list = [];
    for (var y = start; y <= end; y++) {
      list.push(y);
    }
    return list;
  };
  $scope.toggleSelectMonth = function (year, month) {
    if ($scope.selectedMonthDetail.year == year && $scope.selectedMonthDetail.month == month) {
      $scope.selectedMonthDetail.year = undefined;
      $scope.selectedMonthDetail.month = undefined; // 0-based
    } else {
      $scope.selectedMonthDetail.year = year;
      $scope.selectedMonthDetail.month = month; // 0-based
    }
  };

  /**** Grafico ****/

  $scope.graph = {
    graphData: [],
    graphDataCum: []
  };
  function toObjList(matrix, cumulative) {
    var from = new Date($filter('date')($scope.datePicker.from, 'yyyy'), 0, 1);
    var to = new Date($filter('date')($scope.datePicker.to, 'yyyy'), 11, 31);
    var data = [];
    cumulative = cumulative || false;
    var dates = sixDateLib.getDatesInPeriod(from, to);
    var totals = [];
    totals.totale = 0;
    dates.forEach(function (d) {
      var year = $filter('date')(d, 'yyyy');
      var month = $filter('date')(d, 'M');
      var day = $filter('date')(d, 'd');
      var item = matrix[year][month - 1][day - 1];
      totals.totale += item.total;
      var obj = {
        date: new Date(year, month - 1, day),
        totale: cumulative ? totals.totale : item.total
      };
      item.slotted.forEach(function (slot) {
        if (!totals[slot.time_slot]) {
          totals[slot.time_slot] = 0;
        }
        totals[slot.time_slot] += slot.consumption;
        obj[slot.time_slot] = cumulative ? totals[slot.time_slot] : slot.consumption;
      });
      data.push(obj);
      data = $filter('orderBy')(data, 'date');
    });
    // aggiorno i time slot degli oggetti dove non sono presenti
    data.forEach(function (item) {
      for (var k in totals) {
        if (k !== 'date' && k !== 'totale') {
          item[k] = item[k] || 0;
        }
      }
    });
    return data;
  }

  /**** Modalità ****/

  $scope.MODE_IMPORT = 'IMPORTAZIONE';
  $scope.MODE_MODIFY = 'MODIFICA';
  $scope.switchMode = function (mode) {
    switch (mode) {
      case $scope.MODE_IMPORT:
        $scope.importingOperation = true;
        $scope.resetGrid();
        break;
      case $scope.MODE_MODIFY:
        $scope.importingOperation = false;
        $scope.resetGrid();
        getReads();
        break;
      default:
        $log.error('Unknown mode', mode);
        break;
    }
  };

  /**** Paginazione ****/

  var paginationOptions = {
    pageNumber: 1,
    pageSize: 10
  };
  $scope.updatePagination = function () {
    if ($scope.importingOperation === false) {
      getReads();
    }
  };

  /**** UI GRID Callbacks ****/

  function onRegisterApiCallback(gridApi) {
    $scope.gridApi = gridApi;
    gridApi.rowEdit.on.saveRow($scope, onSaveRowCallbach);
    gridApi.edit.on.afterCellEdit($scope, afterCellEditCallback);
    gridApi.pagination.on.paginationChanged($scope, paginationChangedCallback);
    gridApi.core.on.sortChanged($scope, sortChangedCallback);
    gridApi.core.notifyDataChange(uiGridConstants.dataChange.OPTIONS);
  }

  //dati caricati da xls
  $scope.$watch(function () {
    return $scope.viewGridOptions.xlsData;
  }, function (newValue, oldValue) {
    if (newValue && newValue.length > 0) {
      $scope.importingOperation = true;
      updateColumnDefs();
      processData($scope.viewGridOptions.xlsData);
      resolveRefs($scope.viewGridOptions.data);
    }
  });
  function processData(newObjects) {
    $scope.importingOperation = true;
    $scope.percent = 0;
    $scope.viewGridOptions.useExternalPagination = false;
    newObjects.forEach(function (value) {
      for (var k in value) {
        var splittedKey = k.split(' [');
        if (splittedKey.length > 1) {
          value[splittedKey[0]] = value[k];
          delete value[k];
        }
      }
      value.record_id = {};
      value.um_id = {
        code: value.um
      };
      delete value.um;
      switch ($scope.contatoreType.tipo_id.UUID) {
        case 'contatoreelettricita':
          value.record_id.code = value.pod;
          break;
        case 'contatoregas':
          value.record_id.code = value.pdr;
          break;
        case 'contatoreacqua':
          value.record_id.code = value.matricola;
          break;
        case 'serbatoiopressioneatmosferica':
        case 'serbatoioinpressione':
        case 'contatoreteleriscaldamento':
        case 'contatoreteleraffreddamento':
          value.record_id.code = value.cod;
          break;
        default:
          toaster.pop('error', 'Errore', 'Tipo contatore non riconosciuto');
      }
      $scope.viewGridOptions.data.push(value);
    });
  }
  function resolveRefs(data) {
    $scope.isAllOk = true;
    var mapToResolve = {};
    //mapToResolve[$scope.contatoreType.tipo_id.UUID] = {};
    //mapToResolve['um'] = {};
    data.forEach(function (item) {
      var comm = item.commessa || currentCommission.code; // se è multi commessa => item.commessa, altrimenti => commessa corrente

      var innerMap = mapToResolve[comm] || {};
      var innerInnerMap = innerMap[$scope.contatoreType.tipo_id.UUID] || {};
      innerInnerMap[item.record_id.code] = '';
      innerMap[$scope.contatoreType.tipo_id.UUID] = innerInnerMap;
      mapToResolve[comm] = innerMap;

      //var innerMap = mapToResolve[$scope.contatoreType.tipo_id.UUID];
      //innerMap[item.record_id.code] = item.commessa || currentCommission; // se è multi commessa => item.commessa, altrimenti => commessa corrente

      var innerMap = mapToResolve[currentCommission.code] || {};
      var innerInnerMap = innerMap['um'] || {};
      innerInnerMap[item.um_id.code] = '';
      innerMap['um'] = innerInnerMap;
      mapToResolve[currentCommission.code] = innerMap;

      //var innerMap = mapToResolve['um'];
      //innerMap[item.um_id.code] = item.commessa || currentCommission; // se è multi commessa => item.commessa, altrimenti => commessa corrente
    });

    recordFactory('type').bulkResolveMC(mapToResolve).$promise.then(function (response) {
      $log.info(response);
      data.forEach(function (item) {
        item['sixImportStatus'] = 'OK';
        var comm = item.commessa || currentCommission.code;
        var resolved = response[comm][$scope.contatoreType.tipo_id.UUID][item.record_id.code];
        if (angular.isUndefined(resolved) || resolved === null) {
          item['sixImportStatus'] = $scope.contatoreType.tipo_id.description + ' \'' + item.record_id.code + '\'' + ' non trovato per la commessa ' + comm + '!';
          $scope.isAllOk = false;
        } else {
          item['record_id'] = sixObjectLib.recordToHisRef(resolved);
          if (resolved.model.stato == 'chiuso') {
            item['sixImportStatus'] = $scope.contatoreType.tipo_id.description + ' \'' + item.record_id.code + '\'' + ' CHIUSO!';
            $scope.isAllOk = false;
          }
        }
        var resolved = response[currentCommission.code]['um'][item.um_id.code];
        if (angular.isUndefined(resolved) || resolved === null) {
          var message = 'um \'' + item.um_id.code + '\'' + ' non trovata!';
          $scope.isAllOk = false;
          if (item['sixImportStatus'] === 'OK') {
            item['sixImportStatus'] = message;
          } else {
            item['sixImportStatus'] += '; ' + message;
          }
        } else {
          item['um_id'] = sixObjectLib.recordToHisRef(resolved);
        }
      });
      $scope.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
      if (!$scope.isAllOk) {
        toaster.pop('error', 'ATTENZIONE', 'Errori riscontrati durante le verifiche preliminari sui dati da importare: vedere la colonna \'Stato Importazione\'');
      }
    });
  }
  function onSaveRowCallbach(rowEntity) {
    var promise = $q.defer();
    $scope.gridApi.rowEdit.setSavePromise(rowEntity, promise.promise);
    if (!rowEntity || !rowEntity.data || !rowEntity.record_id.code) {
      promise.reject();
    } else {
      saveOrUpdateSingleRead(rowEntity, 0, 1);
      promise.resolve();
    }
  }
  function afterCellEditCallback(rowEntity, colDef, newValue, oldValue) {
    if (!rowEntity) {
      rowEntity = {};
    }
  }
  function paginationChangedCallback(newPage, pageSize) {
    paginationOptions.pageNumber = newPage;
    paginationOptions.pageSize = pageSize;
    $scope.updatePagination();
  }
  function sortChangedCallback(sortColumns) {
    if ($scope.importingOperation === false) {
      $scope.gridApi.grid.columns.forEach(function (col) {
        if (col.sort.direction) {
          $scope.sort = {
            fields: col.field,
            directions: col.sort.direction
          };
        }
      });
      getReads();
    }
  }
  $scope.getTemplateUrl = function () {
    if ($scope.contatoreType && $scope.contatoreType.tipo_id) {
      var prefix = 'energy/attachments/';
      var postfix = '.xls';
      var fileName;
      switch ($scope.contatoreType.tipo_id.UUID) {
        case 'contatoreelettricita':
          fileName = 'template_elettrico_letture';
          break;
        case 'contatoregas':
          fileName = 'template_gas_letture';
          break;
        case 'contatoreacqua':
          fileName = 'template_acqua_letture';
          break;
        case 'contatoreteleriscaldamento':
          fileName = 'template_teleriscaldamento_letture';
          break;
        case 'contatoreteleraffreddamento':
          fileName = 'template_teleraffreddamento_letture';
          break;
        case 'serbatoiopressioneatmosferica':
          fileName = 'template_serbpressatm_letture';
          break;
        case 'serbatoioinpressione':
          fileName = 'template_serbinpress_letture';
          break;
        default:
          return null;
      }
      if (multiCommission === true) {
        postfix = '_mc' + postfix;
      }
      return prefix + fileName + postfix;
    }
    return null;
  };
  $scope.goToImportConsumptions = function () {
    $location.path('consumptive/consumption/import');
  };
  $scope.goToUpdateRegistrationNumber = function () {
    localStorageService.set('resetcounter.type_id', $scope.contatoreType.tipo_id);
    localStorageService.set('resetcounter.record_id', $scope.contatore.contatore_id);
    $window.open('#/updateregistrationnumber', '_blank');
  };
  $scope.goToClosure = function () {
    localStorageService.set('closure.schema', $scope.contatoreType.tipo_id);
    localStorageService.set('closure.record', $scope.contatore.contatore_id);
    $window.open('#/closure', '_blank');
  };
  $scope.goToRecordDetails = function () {
    var mode = $scope.schema.model.history ? 'snap' : 'stable';
    $window.open('#/record/' + mode + '/' + $scope.contatoreType.tipo_id.code + '/' + $scope.contatore.contatore_id.UUID, '_blank');
  };
  $scope.getTooltip = function (value) {
    if (value.type === $scope.TYPE_MIXED) {
      return 'budget/consuntivo';
    }
    if (value.type === $scope.TYPE_BDG) {
      return 'budget';
    }
    if (value.type === $scope.TYPE_CONSUMPTION) {
      if (value.total < 0) {
        return 'consuntivo NEGATIVO!!!';
      }
      return 'consuntivo';
    }
  };
  $scope.calcAllConsumptions = function (allCommissions) {
    loadingBarService.start('Calcolo...');
    var query = {
      from: $filter('date')($scope.datePicker.from, 'yyyy-MM-dd'),
      to: $filter('date')($scope.datePicker.to, 'yyyy-MM-dd'),
      type: $scope.contatoreType.tipo_id.code
    };
    var promise;
    if (allCommissions === true) {
      promise = consumptionFactory.calcAll(query).$promise;
    } else {
      query.id = currentCommission.code;
      promise = consumptionFactory.calcAll(query).$promise;
    }
    promise.then(function (resp) {
      if (resp.hasErrors || resp.hasWarnings) {
        dialogService.serviceResponse('Consumi', resp, true);
      }
      $scope.$broadcast(DATA_READY_EVENT, CALC_CONSUMPTIONS);
    })["catch"](function (response) {
      $log.error('calcAllConsumptions', response);
      // ERRORE
    });
  };

  /***** DUMMY PROGRESS BAR *****/

  // fa avanzare la progress bar a caso, giusto per far vedere che sta facendo qualcosa
  var stopDummyUpdateProgressBar = false;
  function updateDummyProgressBar() {
    if ($scope.percent < 100 && stopDummyUpdateProgressBar === false) {
      $timeout(function () {
        if (stopDummyUpdateProgressBar === false) {
          $scope.percent += $scope.percent < 90 ? Math.random() * 5 : 0; // appena supero il 90% mi fermo e attendo che qualcuno lo porti a 100%
          if ($scope.percent < 100) {
            updateDummyProgressBar();
          }
        }
      }, Math.random() * 2000);
    }
  }
  function resetDummmyProgressBar() {
    stopDummmyProgressBar();
    $scope.percent = 0;
  }
  function startDummmyProgressBar(startVal) {
    stopDummyUpdateProgressBar = false;
    $scope.percent = startVal || 0;
    updateDummyProgressBar();
  }
  function stopDummmyProgressBar() {
    stopDummyUpdateProgressBar = true;
  }

  /***** RECORD SIDEBAR TOGGLE *****/

  // $scope.isSidebarOpened = angular.element(document.getElementById('list-sidebar')).hasClass('open');
  $scope.isSidebarOpened = true;
  $scope.isPinned = true;
  $scope.recordList = [];
  $scope.loadRecords = function () {
    if ($scope.contatoreType && $scope.contatoreType.tipo_id && $scope.contatoreType.tipo_id.code) {
      recordFactory($scope.contatoreType.tipo_id.code).lookup({
        page_size: 1000,
        sources: 'UUID;model.code;model.description;model.stato'
      }).$promise.then(function (resp) {
        $scope.recordList = resp.list;
      })["catch"](function (response) {
        $log.error('Errore', 'Errore durante il recupero dei dati', response);
        toaster.pop('error', 'Errore', 'Errore durante il recupero dei dati');
      });
    }
  };
  $scope.selectRecord = function (uuid, code, description) {
    if (uuid) {
      $scope.contatore.contatore_id = {
        type: $scope.contatoreType.tipo_id.code,
        UUID: uuid,
        code: code,
        description: description
      };
      recordFactory($scope.contatoreType.tipo_id.code).byUUID({
        id: uuid
      }).$promise.then(function (response) {
        $scope.contatore.obj = response;
      });
    }
  };
  $scope.isRecordSelected = function (uuid) {
    if ($scope.contatore && $scope.contatore.contatore_id) {
      return $scope.contatore.contatore_id.UUID === uuid;
    }
    return false;
  };
  $scope.toggleSidebar = function () {
    $scope.isSidebarOpened = !$scope.isSidebarOpened;
  };

  /** ***********************************
   * Tabs
   * ***********************************/

  $scope.selectTab = function (tab) {
    $scope.selectedTab = tab;
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:ImportConsumptionCtrl
 * @description
 * # ImportConsumptionCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy').controller('ImportConsumptionCtrl', ["$scope", "$timeout", "$log", "$location", "authFactory", "$filter", "$q", "dialogService", "$window", "recordFactory", "consumptionFactory", "toaster", "errorService", "ngDialog", "$rootScope", "uiGridConstants", function ($scope, $timeout, $log, $location, authFactory, $filter, $q, dialogService, $window, recordFactory, consumptionFactory, toaster, errorService, ngDialog, $rootScope, uiGridConstants) {
  var CONTATOREELETTRICITA = 'contatoreelettricita';
  var NOW = new Date();
  // mese n-2. Es. now=2017-06-01 , item.data='2017-03-31' => item non passa perchè item.data<2017-04-30 (ultimo giorno di now.month-2 => 06-02=04)
  $scope.LIMIT = new Date(NOW.getFullYear(), NOW.getMonth() - 2, 0);
  $scope.importingOperation = false;
  $scope.isImportBusy = false;
  $scope.isAllOk = true;
  $scope.reportMessages = [];
  $scope.viewGridOptions = {
    enableSorting: true,
    enableGridMenu: true,
    exporterMenuPdf: false,
    paginationPageSizes: [10, 20, 30],
    paginationPageSize: 10,
    useExternalPagination: false,
    gridMenuCustomItems: [{
      title: 'Pulisci',
      action: function action($event) {
        $scope.resetGrid();
      },
      order: 210
    }],
    onRegisterApi: function onRegisterApi(gridApi) {
      $scope.gridApi = gridApi;
    },
    columnDefs: [{
      name: ' '
    }]
  };
  $scope.reportGridOptions = {
    enableSorting: true,
    exporterMenuPdf: false,
    paginationPageSizes: [10, 20, 30],
    paginationPageSize: 10,
    useExternalPagination: false,
    data: 'reportMessages',
    columnDefs: [{
      displayName: 'Stato',
      field: 'status',
      width: '100'
    }, {
      displayName: 'Messaggio',
      field: 'message'
    }]
  };
  var columnDefs = [{
    name: 'Stato Importazione',
    field: 'sixImportStatus',
    enableSorting: false,
    cellClass: getCellClass
  }, {
    name: 'Pod',
    field: 'record_id.code',
    enableSorting: false,
    cellClass: getCellClass
  }, {
    name: 'Mese',
    field: 'mese',
    enableSorting: false,
    cellClass: getCellClass
  }, {
    name: 'Anno',
    field: 'anno',
    enableSorting: false,
    cellClass: getCellClass
  }, {
    name: 'F0',
    field: 'f0',
    enableSorting: false,
    cellClass: getCellClass
  }, {
    name: 'F1',
    field: 'f1',
    enableSorting: false,
    cellClass: getCellClass
  }, {
    name: 'F2',
    field: 'f2',
    enableSorting: false,
    cellClass: getCellClass
  }, {
    name: 'F3',
    field: 'f3',
    enableSorting: false,
    cellClass: getCellClass
  }, {
    name: 'Tot',
    field: 'tot',
    enableSorting: false,
    cellClass: getCellClass
  }, {
    name: 'U.M.',
    field: 'um_id.code',
    enableSorting: false,
    cellClass: getCellClass
  }];
  function getCellClass(grid, row, col, rowRenderIndex, colRenderIndex) {
    var classes = '';
    if ((col.field == 'mese' || col.field == 'anno') && !checkDate(row.entity)) classes += ' limitExceeded';
    if (row.entity.sixImportStatus && row.entity.sixImportStatus != '' && row.entity.sixImportStatus != 'OK') classes += ' error';
    if (col.field == 'sixImportStatus') $log.info(col, row.entity);
    return classes;
  }
  $scope.resetGrid = function () {
    $scope.isImportBusy = false;
    $scope.viewGridOptions.data = [];
    $scope.viewGridOptions.xlsData = [];
    $scope.reportMessages = [];
  };

  //dati caricati da xls
  $scope.$watch(function () {
    return $scope.viewGridOptions.xlsData;
  }, function (newValue, oldValue) {
    if (newValue && newValue.length > 0) {
      $scope.importingOperation = true;
      $scope.viewGridOptions.columnDefs = columnDefs;
      processData($scope.viewGridOptions.xlsData);
      resolveRefs($scope.viewGridOptions.data);
    }
  });
  function processData(newObjects) {
    $scope.importingOperation = true;
    $scope.percent = 0;
    $scope.viewGridOptions.data = [];
    newObjects.forEach(function (value) {
      value.record_id = {
        type: CONTATOREELETTRICITA,
        code: value.pod
      };
      value.um_id = {
        type: 'um',
        code: value.um
      };
      value.mese = parseInt(value.mese);
      value.anno = parseInt(value.anno);
      value.tot = parseFloat(value.tot || 0.0);
      value.f0 = parseFloat(value.f0 || 0.0);
      value.f1 = parseFloat(value.f1 || 0.0);
      value.f2 = parseFloat(value.f2 || 0.0);
      value.f3 = parseFloat(value.f3 || 0.0);
      value.tot = value.f0 + value.f1 + value.f2 + value.f3;
      delete value.pod;
      delete value.um;
      $scope.viewGridOptions.data.push(value);
    });
  }
  function resolveRefs(data) {
    $scope.isAllOk = true;
    var mapToResolve = {};
    mapToResolve[CONTATOREELETTRICITA] = {};
    mapToResolve['um'] = {};
    data.forEach(function (item) {
      var innerMap = mapToResolve[CONTATOREELETTRICITA];
      innerMap[item.record_id.code] = '';
      var innerMap = mapToResolve['um'];
      innerMap[item.um_id.code] = '';
    });
    recordFactory('type').bulkResolve(mapToResolve).$promise.then(function (response) {
      if (errorService.handleError(response)) {
        $log.info(response);
        data.forEach(function (item) {
          item['sixImportStatus'] = 'OK';
          var resolved = response[CONTATOREELETTRICITA][item.record_id.code];
          if (angular.isUndefined(resolved) || resolved === null) {
            item['sixImportStatus'] = 'Contatore Elettricità \'' + item.record_id.code + '\'' + ' non trovato!';
            $scope.isAllOk = false;
          } else {
            item['record_id'] = sixObjectLib.recordToHisRef(resolved);
            if (resolved.model.stato == 'chiuso') {
              item['sixImportStatus'] = 'Contatore Elettricità \'' + item.record_id.code + '\'' + ' CHIUSO!';
              $scope.isAllOk = false;
            }
          }
          var resolved = response['um'][item.um_id.code];
          if (angular.isUndefined(resolved) || resolved === null) {
            var message = 'um \'' + item.um_id.code + '\'' + ' non trovata!';
            $scope.isAllOk = false;
            if (item['sixImportStatus'] === 'OK') {
              item['sixImportStatus'] = message;
            } else {
              item['sixImportStatus'] += '; ' + message;
            }
          } else {
            item['um_id'] = sixObjectLib.recordToHisRef(resolved);
          }
        });
      } else {
        toaster.pop('error', 'Errore', 'Errore durante la risoluzione dei riferimenti');
      }
      $scope.isImportBusy = false;
      $scope.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
      if (!$scope.isAllOk) {
        toaster.pop('error', 'ATTENZIONE', 'Errori riscontrati durante le verifiche preliminari sui dati da importare: vedere la colonna \'Stato Importazione\'');
      }
    });
  }
  $scope.importData = function () {
    var inError = [];
    $scope.isImportBusy = true;
    var toSave = [];
    var selected = $scope.gridApi.selection.getSelectedRows();
    if (!selected || !selected.length) {
      selected = $scope.viewGridOptions.data;
    }
    selected.forEach(function (item) {
      // check date
      $log.info(new Date(item.anno, item.mese - 1, 15));
      var check = checkDate(item);
      $log.info('checkDate: ' + checkDate);
      if (check) {
        toSave.push(item);
      } else {
        inError.push(item);
      }
    });
    if (inError.length == 0) {
      $scope.saveOrUpdateConsumptions(toSave);
    } else {
      toaster.pop('error', 'Errore importazione', 'Controllare che non vi siano consumi antecedenti il ' + $filter('date')($scope.LIMIT, 'yyyy-MM-dd'));
      $scope.showConsumptionsInError(inError);
      $scope.isImportBusy = false;
    }
  };
  function checkDate(item) {
    if ($scope.modifyOldAllowed()) return true;
    var check = new Date(item.anno, item.mese - 1, 15).getTime() > $scope.LIMIT.getTime();
    return check;
  }
  $scope.showConsumptionsInError = function (reads) {
    var dialogScope = $rootScope.$new();
    dialogScope.reads = reads;
    dialogScope.columns = [];
    dialogScope.limit = $scope.LIMIT;
    dialogScope.comparator = function (actual, expected) {
      var res = true;
      expected.split(',').forEach(function (t) {
        res = res && actual != t.trim();
      });
      return res;
    };
    dialogScope.checkColumn = function (k) {
      return k.key != '$$hashKey' && k.key != 'sixImportStatus';
    };
    angular.forEach(reads[0], function (v, k) {
      dialogScope.columns.push({
        key: k,
        name: k
      });
    });
    var consumptionsInErrorDialog = ngDialog.open({
      name: 'consumptionsInError',
      closeByDocument: false,
      showClose: true,
      template: '' + '<div style="font-size: small"><strong><span class="text-danger-dker">Consumi in errore:</span> la data non può essere antecedente il <span class="text-info-dker">{{limit | date:\'yyyy-MM-dd\'}}</span></strong></div>' + '<table class="tinyTable m-t">' + '<tr style="border-bottom: 2px">' + '<th style="min-width: 10%" ng-repeat="k in columns | filter: { key: \'$$hashKey\,sixImportStatus,record_id\' }: comparator">' + '{{k.name}}' + '</th>' + '</tr>' + '<tr ng-repeat="r in reads">' + '<td ng-repeat="k in columns | filter: { key: \'$$hashKey,sixImportStatus,record_id\' }: comparator">' + '<span ng-if="!r[k.key].code">{{r[k.key]}}</span>' + '<span ng-if="r[k.key].code">{{r[k.key].code}}</span>' + '</td>' + '</tr>' + '</table>',
      plain: true,
      className: 'ngdialog-theme-default',
      width: '60%',
      scope: dialogScope
    });
  };
  $scope.saveOrUpdateConsumptions = function (consumptions) {
    dialogService.showLoadingMessage('Importazione dati...');
    startDummmyProgressBar(Math.random() * 10 + Math.random() * 10); // inizio a caso, giusto per dare la sensazione che stia facendo qualcosa...
    var error = false;
    // Controllo se è tutto corretto
    consumptions.forEach(function (value) {
      if (!value.record_id.type || !value.record_id.code) {
        toaster.pop('error', 'Errore', 'Controllare tipo e codice contatore, data e letture');
        error = true;
        resetDummmyProgressBar();
        return;
      }
    });
    if (!error) {
      consumptionFactory.bulk(consumptions).$promise.then(function (response) {
        $scope.percent = 100;
      })["catch"](function (response) {
        $scope.percent = 0;
        stopDummmyProgressBar();
        toaster.pop('error', 'Errore', 'Errore durante il salvataggio');
      })["finally"](function (response) {
        $scope.reportMessages = response.messages;
        $scope.isImportBusy = false;
        dialogService.hideLoadingMessage();
      });
    }
  };

  /***** Links *****/

  $scope.downloadTemplate = function () {
    window.location.href = 'energy/attachments/template_elettrico_consumi.xls';
  };
  $scope.back = function () {
    $window.history.back();
  };

  /***** DUMMY PROGRESS BAR *****/

  // fa avanzare la progress bar a caso, giusto per far vedere che sta facendo qualcosa
  var stopDummyUpdateProgressBar = false;
  function updateDummyProgressBar() {
    if ($scope.percent < 100 && stopDummyUpdateProgressBar === false) {
      $timeout(function () {
        if (stopDummyUpdateProgressBar === false) {
          $scope.percent += $scope.percent < 90 ? Math.random() * 5 : 0; // appena supero il 90% mi fermo e attendo che qualcuno lo porti a 100%
          if ($scope.percent < 100) {
            updateDummyProgressBar();
          }
        }
      }, Math.random() * 2000);
    }
  }
  function resetDummmyProgressBar() {
    stopDummmyProgressBar();
    $scope.percent = 0;
  }
  function startDummmyProgressBar(startVal) {
    stopDummyUpdateProgressBar = false;
    $scope.percent = startVal || 0;
    updateDummyProgressBar();
  }
  function stopDummmyProgressBar() {
    stopDummyUpdateProgressBar = true;
  }

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'consumptive'; // va comunque sull'endpoint delle letture

  $scope.modifyOldAllowed = function () {
    return authFactory.checkPerm(RESOURCE_NAME, "MODIFY_OLD");
  };
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isClosed = function () {
    if (angular.isDefined($scope.contatore.obj) && angular.isDefined($scope.contatore.obj.model)) {
      return $scope.contatore.obj.model.stato === 'chiuso';
    }
    return false;
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
  $scope.getIconPerm = function () {
    var perm = $scope.isWritePermAllowed() && $scope.isDeletePermAllowed() && $scope.modifyOldAllowed();
    return perm ? 'fa fa-check-circle-o text-success-dker' : 'fa fa-exclamation-circle text-warning-dker';
  };
  $scope.getLabelPerm = function () {
    if ($scope.isWritePermAllowed() && $scope.isDeletePermAllowed() && $scope.modifyOldAllowed()) {
      return 'Permessi completi';
    } else if ($scope.isWritePermAllowed() && $scope.isDeletePermAllowed() && !$scope.modifyOldAllowed()) {
      return 'Possibilità di intervenire su letture/consumi con data succesiva al ' + $filter('date')($scope.LIMIT, 'yyyy-MM-dd');
    } else {
      return 'Permessi limitati';
    }
  };
  $scope.showPermissions = function () {
    var dialogScope = {
      isWritePermAllowed: $scope.isWritePermAllowed,
      isDeletePermAllowed: $scope.isDeletePermAllowed,
      modifyOldAllowed: $scope.modifyOldAllowed,
      limit: $scope.LIMIT
    };
    var opts = {
      name: 'permissionsInfoDialog',
      closeByDocument: true,
      plain: false
    };
    dialogService.templateDialog('permissionsInfoTemplate.html', dialogService.DIALOG_TYPE.INFO, dialogScope, opts, -1, false);
  };
}]);
'use strict';

/**
 * @author Rita Beltrami
 * @ngdoc function
 * @name sixEmmaApp.controller:DashboardEmmaCtrl
 * @description
 * # DashboardEmmaCtrl
 * Controller of the Assets project dashboard
 */
angular.module('emma.energy').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/emma', {
    templateUrl: 'theme/dashboard/dashboard.html',
    controller: 'DashboardEmmaCtrl'
  });
}]).controller('DashboardEmmaCtrl', ["$scope", "$log", "dashboardEmmaFactory", "consumptionAnalysisFactory", "recordFactory", "errorService", "$filter", "authFactory", "loadingBarService", "notificationService", "toaster", "consanalysisWSFactory", "$q", function ($scope, $log, dashboardEmmaFactory, consumptionAnalysisFactory, recordFactory, errorService, $filter, authFactory, loadingBarService, notificationService, toaster, consanalysisWSFactory, $q) {
  var authId = authFactory.getAuthData().authId;

  //__params__
  var ENDPOINT = "dashboard";
  var WIDGET_ON = 'widget-on';
  var WIDGET_OFF = 'widget-off';
  $scope.config = {
    vectors: [],
    total: {},
    others: []
  };
  $scope.vectorsCount = 0;
  $scope.loadedVectors = 0;
  $scope.widgetClass = "panel-widget-emma";
  $scope.pos1 = [];
  $scope.pos2 = [];
  $scope.pos3 = [];
  $scope.tmp1 = [];
  $scope.tmp2 = [];
  $scope.tmp3 = [];
  $scope.wide = [];
  $scope.widgetEmmaClass = [WIDGET_OFF, WIDGET_OFF, WIDGET_OFF, WIDGET_OFF, WIDGET_OFF, WIDGET_OFF];
  $scope.widgetEmmaSelected = {};
  var skins = ["info", "primary", "success", "warning", "danger", "dark"];
  var skinCount = skins.length;
  $scope.items = {};
  $scope.lightOn = function (index) {
    $scope.widgetEmmaClass[index] = WIDGET_ON;
  };
  $scope.lightOff = function (index) {
    $scope.widgetEmmaClass[index] = WIDGET_OFF;
  };
  $scope.selectWidget = function (data) {
    $scope.widgetEmmaSelected = data;
  };
  $scope.isSelectedWidget = function (data) {
    return $scope.widgetEmmaSelected == data;
  };
  $scope.getDynamic = function (item) {
    var dynamic = {};
    if (item.widgetType === 'widget-consumptive-graph' && $scope.widgetEmmaSelected // if per evitare che venga preso un valore 'indefinito'
    && angular.isDefined($scope.widgetEmmaSelected.graph)) {
      // if per evitare che venga preso un valore 'indefinito'
      dynamic.subtitle = $scope.widgetEmmaSelected.graph.title;
    }
    return dynamic;
  };
  $scope.createWaitWidget = function (item, num) {
    if (num % 2) {
      $scope.tmp2.push(item);
    } else {
      $scope.tmp1.push(item);
    }
  };
  function initDashboard() {
    $log.info('initDashboard()');
    dashboardEmmaFactory('vettoreenergetico').getConfig({
      page_size: 10000,
      show_revision: false
    }).$promise.then(function (data) {
      var n = 0;
      data.list.forEach(function (item) {
        $scope.createWaitWidget(item, n);
        n++;
      });
      $scope.dashTemp = data;
      setTimeout(function () {
        $scope.loadDeferred($scope.dashTemp);
      }, 50);
    });
  }
  $scope.loadDeferred = function (data) {
    data.list.forEach(function (item) {
      if (item.widgetType == "widget-consumptive") {
        item.data = {}; // inizializzo data per evitare perdite di riferimenti
        $scope.vectorsCount++;
        var uuid = item.vector.total ? 'total' : item.vector.UUID;
        $scope.items[uuid] = item;
        setShowSpinner(item, true);
        $scope.checkAndLoadVector(item);
      } else {
        $scope.config.others.push(item);
      }
    });
  };
  function positionWidgets() {
    $scope.wcount = 0;
    $scope.totalWidgets = 0;
    positionWidget($scope.config.total);
    for (var i = 0; i < $scope.config.vectors.length; i++) {
      positionWidget($scope.config.vectors[i]);
    }
    for (var i = 0; i < $scope.config.others.length; i++) {
      positionWidget($scope.config.others[i]);
    }
  }
  function positionWidget(item) {
    $log.log(item);
    switch (item.position) {
      case 'pos1':
        $scope.pos1.push(item);
        $scope.wcount++;
        break;
      case 'pos2':
        $scope.pos2.push(item);
        $scope.wcount++;
        break;
      case 'wide':
        $scope.wide.push(item);
        break;
      default:
        if ($scope.wcount % 2) {
          $scope.pos2.push(item);
        } else {
          $scope.pos1.push(item);
        }
        $scope.wcount++;
    }
    $scope.totalWidgets++;
    item.skin = skins[$scope.totalWidgets % skinCount];
  }
  var today = new Date();
  var startYear = today.getFullYear();
  if (today.getMonth() == 0) {
    startYear = today.getFullYear() - 1;
  }
  $scope.datePicker = {
    from: new Date(startYear, 0, 1),
    to: new Date(today.getFullYear(), today.getMonth(), 0)
  };
  function createDate(d) {
    var date = new Date(d);
    return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
  }
  function createConsumptiveWidget(item, budget, graph) {
    // creo il vero e proprio widget
    if (item.vector.total == true) {
      angular.extend(item.data, budget.std);
      $scope.config.total = item;
      item.data.graph = graph;
      item.data.graph.id = 'total';
      item.data.graph.title = 'Totale';
    } else {
      angular.extend(item.data, budget.um);
      item.hideWidget = item.data.cons == 0 && item.data.budget == 0;
      if (!item.hideWidget) {
        $scope.config.vectors.push(item);
      }
      item.data.graph = graph;
      item.data.graph.id = item.vector.model.code;
      item.data.graph.title = item.vector.model.description;
    }
    $scope.loadedVectors++;
    if ($scope.loadedVectors == $scope.vectorsCount) {
      positionWidgets();
    }
  }

  //----------------------------
  // Load data senza Web Socket
  //----------------------------

  $scope.loadData = function (item) {
    $log.debug('loadData() for', item);
    var vector = item.vector;
    $scope.budget = {
      list: undefined
    };
    var query = getQuery(vector);
    consumptionAnalysisFactory().getConsumptionAnalysis(query).$promise.then(function (consAnResp) {
      var budget = {},
        graphData = [],
        graphDataCumulative = [];
      if (consAnResp.result && consAnResp.result.list) {
        budget.list = consAnResp.result.list;
        angular.forEach(consAnResp.result.list, function (record, idx) {
          var grpDT = {
            'date': Date.parse(record.date)
          };
          var grpDTCumulative = {
            'date': Date.parse(record.date)
          };
          budget.toRender = {};
          if (vector.total == true) {
            grpDT['consumi ' + $filter('number')(consAnResp.result.std.cons, 3)] = '' + record.std.cons;
            grpDT['budget ' + $filter('number')(consAnResp.result.std.budget, 3)] = '' + record.std.budget;
            grpDTCumulative['consumi ' + $filter('number')(consAnResp.result.std.cons, 3)] = '' + (record.std.cumCons || 0);
            grpDTCumulative['budget ' + $filter('number')(consAnResp.result.std.budget, 3)] = '' + (record.std.cumBudget || 0);
            budget.toRender.list = [];
            budget.list.forEach(function (record) {
              var r = angular.copy(record.std);
              r.date = record.date;
              budget.toRender.list.push(r);
            });
            budget.toRender.totalBudget = consAnResp.result.std.budget;
            budget.toRender.totalConsumption = consAnResp.result.std.cons;
            budget.toRender.season = consAnResp.result.std.season;
            budget.toRender.deltaSeason = consAnResp.result.std.deltaSeason;
            budget.toRender.deltaTech = consAnResp.result.std.deltaTech;
            budget.toRender.percentage = consAnResp.result.std.percentage;
          } else {
            grpDT['consumi ' + $filter('number')(consAnResp.result.um.cons, 3)] = '' + record.um.cons;
            grpDT['budget ' + $filter('number')(consAnResp.result.um.budget, 3)] = '' + record.um.budget;
            grpDTCumulative['consumi ' + $filter('number')(consAnResp.result.um.cons, 3)] = '' + (record.um.cumCons || 0);
            grpDTCumulative['budget ' + $filter('number')(consAnResp.result.um.budget, 3)] = '' + (record.um.cumBudget || 0);
            budget.toRender.list = [];
            budget.list.forEach(function (record) {
              var r = angular.copy(record.um);
              r.date = record.date;
              budget.toRender.list.push(r);
            });
            budget.toRender.totalBudget = consAnResp.result.um.budget;
            budget.toRender.totalConsumption = consAnResp.result.um.cons;
            budget.toRender.season = consAnResp.result.um.season;
            budget.toRender.deltaSeason = consAnResp.result.um.deltaSeason;
            budget.toRender.deltaTech = consAnResp.result.um.deltaTech;
            budget.toRender.percentage = consAnResp.result.um.percentage;
            budget.toRender.um = consAnResp.result.um.percentage;
          }
          graphData.push(grpDT);
          graphDataCumulative.push(grpDTCumulative);
        });
      }
      if (consAnResp.result && consAnResp.result.um) {
        budget.um = consAnResp.result.um;
        budget.totalBudget = consAnResp.result.um.budget;
        budget.totalConsumption = consAnResp.result.um.cons;
      }
      if (consAnResp.result && consAnResp.result.std) {
        budget.totalBudgetStd = consAnResp.result.std.budget;
        budget.totalConsumptionStd = consAnResp.result.std.cons;
        budget.std = consAnResp.result.std;
        budget.season = consAnResp.result.std.season;
        budget.deltaSeason = consAnResp.result.std.deltaSeason;
        budget.deltaTech = consAnResp.result.std.deltaTech;
        budget.percentage = consAnResp.result.std.percentage;
      }
      var graph = {
        graphData: graphData,
        graphDataCumulative: graphDataCumulative
      };

      // creo il vero e proprio widget
      createConsumptiveWidget(item, budget, graph);
      setShowSpinner(item, false);
    })["catch"](function (error) {
      // error
      setShowSpinner(item, false);
    });
  };
  function setShowSpinner(item, show) {
    item.data.showSpinner = show;
  }

  //------------------------
  // Reload con Web Socket
  //------------------------

  /**
   * Ricreo gli snapshot per turri i vettori energetici
   */
  $scope.reloadDashboard = function () {
    for (var uuid in $scope.items) {
      setShowSpinner($scope.items[uuid], true);
      consanalysisWSFactory.recreateSnaps(getQuery($scope.items[uuid].vector), 'consumptions,analysis');
    }
  };

  //------------------------
  // Query
  //------------------------

  function getMode(vector, mode) {
    if (mode) return mode;
    if (vector) {
      return vector.total ? 'ONLY_TOTAL' : 'ONLY_FILTERS';
    }
    return 'ALL';
  }
  function getQuery(vector, mode) {
    $scope.budget = {
      list: undefined
    };

    //CONSUMI E BUDGET
    var query = {
      frequency: 'MONTHLY',
      from: '',
      to: ''
    };
    var from = createDate($scope.datePicker.from);
    var to = createDate($scope.datePicker.to);
    if (from) {
      query.from = from;
    }
    if (to) {
      query.to = to;
    }
    query.mode = getMode(vector, mode); // solo per parte websocket: default: indico al backend di elaborare tutti i vettori energetici e i filtri (altri valori possibili: ONLY_FILTERS, ONLY_TOTAL)

    if (vector && vector.UUID) {
      // se ho passato un vettore specifico ignoro i filtri impostati
      query.vector_id = vector.UUID;
    } else if (!vector) {
      // se non ho passato uno specifico vettore considero i filtri impostati
      if ($scope.currentVector && angular.isDefined($scope.currentVector.UUID)) {
        query.vector_id = $scope.currentVector.UUID;
      }
      if ($scope.type.type_id && angular.isDefined($scope.type.type_id.UUID)) {
        query.contatore_type = $scope.type.type_id.UUID;
      }
      if ($scope.contatore.contatore_id && angular.isDefined($scope.contatore.contatore_id.UUID)) {
        query.contatore_id = $scope.contatore.contatore_id.UUID;
      }
    }
    query.commission = authFactory.getAuthData().info.commissions.current.code;
    return query;
  }

  //------------------------
  // WebSocket listener
  //------------------------

  /**
   * Recupera l'item (widget) corrispondente al vettore energetico
   * @param vector uuid del vettore energetico
   * @returns {*} item (widget) corrispondente al vettore enrgetico richiesto
   */
  function getItemFromVector(vector) {
    $log.debug('Looking for ' + vector + ' in', $scope.items);
    return $scope.items[vector];
  }

  /**
   * Listener dei messaggi inviati dalla web socket dell'analisi consumi (consanalysiswsfactory)
   * @param n notifica ricevuta
   */
  $scope.wsListener = function (n) {
    $log.debug('notification', n);
    if (n.status === 'INPROGRESS') {
      loadingBarService.start(n.message);
    } else if (n.status === 'END') {
      // var notify = {
      //   message: n.message,
      //   object: n.object,
      //   time: new Date(),
      //   action: 'link',
      //   url: 'consumptionanalysis',
      //   params: n.params
      // };
      // notificationService.push(notify);
      if (n.serviceResponse.messages && (n.serviceResponse.hasErrors || n.serviceResponse.hasWarnings)) {
        loadingBarService.stop(n.serviceResponse);
      } else {
        loadingBarService.stop();
      }

      // se ho calcolaro l'analisi consumi e non ho avuto errori => carico i dati
      if (!n.serviceResponse.hasErrors && (n.snaps.indexOf('analysis') > -1 || n.snaps.indexOf('all') > -1) && (n.action == 'CREATE' || n.action == 'RECREATE')) {
        var uuid = n.params.vector_id ? n.params.vector_id : 'total';
        var item = getItemFromVector(uuid);
        if (item && item.vector) {
          $scope.loadData(item);
        }
      }
    } else if (n.status === 'WARNING') {
      // toaster.pop('warning', 'Avviso', n.message);
    } else if (n.status === 'ERROR') {
      // toaster.pop('error', 'Errore', n.message);
    }
  };

  //-----------------------------
  // Check snapshots e ricalcolo
  //-----------------------------

  /**
   * Verifica l'esistenza di snapshot per il vettore energetico richiesto
   * @param vector vettore energetico richiesto
   * @return [string] lista di snapshot assenti
   */
  function checkAllSnaps(vector) {
    var allP = $q.defer();
    var snaps = [];
    $log.info('Getting budget snap', vector);
    $scope.getBudgetSnapDate(vector).then(function (resp) {
      if (!resp || !resp.result || !resp.result.creationDate) {
        $log.warn('No budget snap', vector);
        snaps.push('budget');
        snaps.push('associations');
        var deferred = $q.defer();
        deferred.resolve();
        return deferred.promise;
      } else {
        $log.info('Getting DD snap', vector);
        return $scope.getDDSnapDate(vector); // se non ho risolto il budget, evito di chiedere
      }
    }).then(function (resp) {
      if (!resp || !resp.result || !resp.result.creationDate) {
        $log.warn('No DD snap', vector);
        snaps.push('dd');
      } else {
        $log.info('Getting consumption snap', vector);
      }
      return $scope.getConsumptionsSnapDate(vector);
    }).then(function (resp) {
      if (!resp || !resp || !resp.result || !resp.result.creationDate) {
        $log.warn('No consumption snap', vector);
        snaps.push('consumptions');
        var deferred = $q.defer();
        deferred.resolve();
        return deferred.promise;
      } else {
        $log.info('Getting consumption analysis snap', vector);
        return $scope.getConsAnalysisSnapDate(vector);
      }
    }).then(function (resp) {
      if (!resp || !resp.result || !resp.result.creationDate) {
        $log.warn('No consumption analysis snap', vector);
        snaps.push('analysis');
      }
      allP.resolve(snaps);
    });
    return allP.promise;
  }

  /**
   * Verifica l'esistenza di snapshot esistenti per l'item (vettore energetico) richiesto:
   * se esistono tutti gli snapshot viene lanciato il caricamento dati, altrimenti viene lanciata la creazione degli snapshot mancanti
   * @param item (widget) contenente il vettore energetico richiesto
   */
  $scope.checkAndLoadVector = function (item) {
    var vector = item.vector;
    checkAllSnaps(vector).then(function (snaps) {
      if (snaps.length > 0) {
        var s = snaps.filter(function (value, index, self) {
          // elimino doppioni
          return self.indexOf(value) === index;
        }).join(); // concateno con ,
        $log.info('recreateSnaps ' + s);
        consanalysisWSFactory.recreateSnaps(getQuery(vector), s);
      } else {
        $scope.loadData(item);
      }
    });
  };

  //------------------------
  // Snapshots
  //------------------------

  $scope.getBudgetSnapDate = function (vector) {
    return consumptionAnalysisFactory().getBudgetSnap({
      sources: 'creationDate'
    }, getQuery(vector)).$promise;
  };
  $scope.getDDSnapDate = function (vector) {
    return consumptionAnalysisFactory().getDDSnap({
      sources: 'creationDate'
    }, getQuery(vector)).$promise;
  };
  $scope.getConsumptionsSnapDate = function (vector) {
    return consumptionAnalysisFactory().getConsumptionsSnap({
      sources: 'creationDate'
    }, getQuery(vector)).$promise;
  };
  $scope.getConsAnalysisSnapDate = function (vector) {
    return consumptionAnalysisFactory().getConsAnalysisSnap({
      sources: 'creationDate'
    }, getQuery(vector)).$promise;
  };

  //------------------------
  // MAIN
  //------------------------

  consanalysisWSFactory.connect(authId, $scope.wsListener);
  initDashboard();
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:DaydegreeCtrl
 * @description
 * # DaydegreeCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/energy/daydegree/:type', {
    templateUrl: 'energy/daydegrees/daydegree.html',
    controller: 'DaydegreeCtrl'
  });
}]).controller('DaydegreeCtrl', ["$scope", "$q", "$log", "$routeParams", "$location", "$sce", "dayDegreeFactory", "recordFactory", "$http", "SaveAs", "heatingSeasonFactory", "zonaTermicaFactory", "dialogService", "localStorageService", "ENERGY_URL", "APP_URL", "DEV", "zonaClimaticaFactory", "errorService", "ngDialog", "toaster", "authFactory", "loadingBarService", function ($scope, $q, $log, $routeParams, $location, $sce, dayDegreeFactory, recordFactory, $http, SaveAs, heatingSeasonFactory, zonaTermicaFactory, dialogService, localStorageService, ENERGY_URL, APP_URL, DEV, zonaClimaticaFactory, errorService, ngDialog, toaster, authFactory, loadingBarService) {
  var HIST_YEAR = 1970;
  $scope.bool = {
    selectPeriod: false
  };
  $scope.months = [];
  $scope.dataMatrix = createArray(12, 31);
  $scope.dataTotals = createArray(13);
  $scope.dataGrid = [];
  $scope.graphData = [];
  $scope.graphDataCum = [];
  $scope.dropdownActionList = {
    list: [] // Lista delle azioni disponibili
  };

  $scope.type = $routeParams.type === 'real' || $routeParams.type === 'hist' ? $routeParams.type : 'real';
  $scope.selected = {
    /* metto l'anno in un oggetto altrimenti ng-model non lo aggiorna */
    year: new Date().getFullYear().toString()
  };
  $scope.period = {
    dateFrom: '',
    dateTo: ''
  };
  $scope.max = 0;
  $scope.realDataLoaded = false;
  $scope.histDataLoaded = false;
  $scope.show = {
    firstHalf: true,
    secondHalf: true,
    stats: false
  };
  var CONSTANT_YEAR = 5;
  var low = new Date().getFullYear() - CONSTANT_YEAR;
  var high = new Date().getFullYear() + CONSTANT_YEAR;
  $scope.zonatermica = {};
  $scope.referring = null;
  $scope.refZonaTermica = {
    aa: 'a'
  };
  $scope.yearsInPeriod = [];
  $scope.seasonYears = {};
  $scope.monthsValues = null;
  $scope.monthsValuesHist = false;
  if (localStorageService.get('daydegree.zonatermica_id')) {
    $scope.zonatermica = {
      zonatermica_id: localStorageService.get('daydegree.zonatermica_id') || {}
    };
  }
  $scope.gridOptions = {
    enableGridMenu: true
  };
  $scope.gridOptions.columnDefs = [{
    field: 'placeLabel',
    name: 'Zona Termica',
    headerCellClass: 'largeColumn'
  }, {
    field: 'month',
    name: 'Mese',
    width: 100
  }, {
    field: 'year',
    name: 'Anno',
    width: 100
  }];
  for (var colIndex = 1; colIndex < 32; colIndex++) {
    $scope.gridOptions.columnDefs.push({
      field: '' + colIndex,
      name: '' + colIndex,
      width: 36,
      headerCellClass: 'smallHeader',
      enableColumnMenu: false
    });
  }
  $scope.getPlaceCode = function () {
    if (!$scope.zonatermica.zonatermica_id) return '';
    return $scope.zonatermica.zonatermica_id.UUID;
  };
  function createArray(length) {
    var arr = new Array(length || 0);
    var i = length;
    if (arguments.length > 1) {
      var args = Array.prototype.slice.call(arguments, 1);
      while (i--) arr[length - 1 - i] = createArray.apply(this, args);
    }
    return arr;
  }
  function reloadLocationData(doNotClear) {
    if (angular.isUndefined(doNotClear)) {
      $scope.zonatermica.model = null;
      $scope.referring = null;
      $scope.refZonaTermica = [];
      $scope.provincia = [];
      $scope.zonaClimatica = [];
      $scope.comune = []; //se la località ha un comune, quindi o è un comune o qualcosa di più piccolo, qua ci sono dati del comune e della provincia
      $scope.provincia = []; //se la località è quella che contiene i dati climatici della provincia, i dati della provincia li metto qua
      $scope.seasonEndDay = null;
      $scope.seasonStartDay = null;
      $scope.seasonEndMonth = null;
      $scope.seasonStartMonth = null;
    }
    zonaTermicaFactory.byUUID({
      id: $scope.zonatermica.zonatermica_id.UUID
    }).$promise.then(function (zonaTermicaData) {
      if (zonaTermicaData.model) {
        localStorageService.set('daydegree.zonatermica_id', $scope.zonatermica.zonatermica_id);
        $scope.zonatermica.model = zonaTermicaData.model;
        if (zonaTermicaData.model.ref_loc_id) {
          dayDegreeFactory.zonaTermicaWithDefaults({
            zt: zonaTermicaData.model.ref_loc_id.UUID
          }).$promise.then(function (refZonaTermicaData) {
            if (refZonaTermicaData) {
              $scope.refZonaTermica = refZonaTermicaData;
            }
          });
        }
        dayDegreeFactory.locReferencedBy({
          zt: zonaTermicaData.UUID
        }).$promise.then(function (referr) {
          $scope.referring = referr;
        });
        //recupero le info sulla zona climatica
        zonaClimaticaFactory.findByZonaTermica({
          id: zonaTermicaData.UUID
        }).$promise.then(function (zClim) {
          if (errorService.handleError(zClim)) {
            $scope.zonaClimatica = zClim;
            $scope.seasonEndDay = zClim.model.day_out;
            $scope.seasonStartDay = zClim.model.day_in;
            $scope.seasonEndMonth = sixDateLib.getMonthIndex(zClim.model.month_out);
            $scope.seasonStartMonth = sixDateLib.getMonthIndex(zClim.model.month_in);
          } else {
            toaster.pop('error', 'Errore', 'Zona Climatica non trovata');
          }
        });
        //E' UNA LOCALITA' "BASE", RECUPERO LE INFO SUL COMUNE E LA RELATIVA PROVINCIA
        if (zonaTermicaData.model.comune_id) {
          recordFactory(zonaTermicaData.model.comune_id.type).byUUID({
            id: zonaTermicaData.model.comune_id.UUID
          }).$promise.then(function (comune) {
            $scope.comune = comune;
            if ($scope.comune.model.provincia_id) {
              recordFactory($scope.comune.model.provincia_id.type).byUUID({
                id: $scope.comune.model.provincia_id.UUID
              }).$promise.then(function (provincia) {
                if (errorService.handleError(provincia)) {
                  $scope.provincia = provincia;
                } else {
                  toaster.pop('error', 'Errore', 'Provincia non trovata');
                }
              });
            }
          });
        }
      }
    });
  }
  $scope.showDay = function (day) {
    return day < 15 && $scope.show.firstHalf || day >= 15 && $scope.show.secondHalf;
  };
  function CheckDates() {
    if ($scope.bool.selectPeriod == false) {
      if (angular.isUndefined($scope.selected.year)) {
        return false;
      }
    } else {
      if ($scope.period.dateFrom == null || $scope.period.dateTo == null) {
        return false;
      } else {
        if ($scope.period.dateFrom > $scope.period.dateTo) {
          return false;
        }
      }
    }
    return true;
  }
  $scope.loadDD = function () {
    $log.log('loadDD');
    if (angular.isDefined($scope.zonatermica.zonatermica_id) && CheckDates()) {
      if ($scope.bool.selectPeriod == true) {
        $scope.period.dateFrom = new Date($scope.period.dateFrom);
        $scope.period.dateTo = new Date($scope.period.dateTo);
        var difference = sixDateLib.getMonthsInPeriod($scope.period.dateFrom, $scope.period.dateTo);
        $scope.months = [];
        var index = 0;
        difference.forEach(function (value) {
          var item = {
            numMonth: value.getMonth(),
            yearMonth: $scope.type === 'real' ? value.getFullYear() : HIST_YEAR,
            descrMonth: sixDateLib.getMonthShortName(value.getMonth()) + ' ' + value.getFullYear(),
            dateMonth: value,
            indexMatrix: index
          };
          index++;
          $scope.months.push(item);
        });
        $scope.yearsInPeriod = sixDateLib.getYearsInPeriod($scope.period.dateFrom, $scope.period.dateTo);
      } else {
        // metto da parte l'anno selezionato...
        $scope.year = parseInt($scope.selected.year);
        // inizializzo un array con tutti i dettagli di ogni mese...
        $scope.months = [];
        var index = 0;
        for (var i = 0; i < 12; i++) {
          var item = {
            numMonth: i,
            yearMonth: $scope.type === 'real' ? $scope.selected.year : HIST_YEAR,
            descrMonth: sixDateLib.getMonthShortName(i) + ' ' + $scope.selected.year,
            dateMonth: new Date($scope.selected.year, i, 1),
            indexMatrix: index
          };
          index++;
          $scope.months.push(item);
        }
        // fine inizializzazione array mesi...

        // creo un array contententi gli anni del periodo iniziato... (in questo caso sarà solamente un anno)
        $scope.yearsInPeriod = [];
        if ($scope.type === 'real') {
          $scope.yearsInPeriod.push($scope.selected.year);
        } else {
          // prendo lo storico... 1970
          $scope.yearsInPeriod.push(HIST_YEAR);
        }
      }
      // parte comune: dichiaro la matrice per i dati giorno x giorno, e la colonna per salvare i totali...
      $scope.dataMatrix = createArray($scope.months.length, 31);
      $scope.dataTotals = createArray($scope.months.length + 1);
      $scope.realDataLoaded = false;
      $scope.histDataLoaded = false;
      $scope.seasonYears = {};
      // scorro gli anni per prendere tutte le date di inizio/fine stag. termica...
      for (var i = 0; i < $scope.yearsInPeriod.length; i++) {
        $scope.seasonYears[$scope.yearsInPeriod[i]] = {};
        var seasonStartPromise = heatingSeasonFactory.begin({
          type: $scope.zonatermica.zonatermica_id.type,
          zt: $scope.zonatermica.zonatermica_id.UUID,
          year: $scope.yearsInPeriod[i]
        }).$promise.then(function (data) {
          if (errorService.handleError(data)) {
            $scope.seasonYears[new Date(data.result.date).getFullYear()].seasonStartDay = new Date(data.result.date).getDate();
            $scope.seasonYears[new Date(data.result.date).getFullYear()].seasonStartMonth = new Date(data.result.date).getMonth();
          } else {
            toaster.pop('error', 'Errore', 'Zona Climatica per l\'inizio della stagione termica non trovata');
          }
          return this;
        });
        var seasonEndPromise = heatingSeasonFactory.end({
          type: $scope.zonatermica.zonatermica_id.type,
          zt: $scope.zonatermica.zonatermica_id.UUID,
          year: $scope.yearsInPeriod[i]
        }).$promise.then(function (data) {
          if (errorService.handleError(data)) {
            $scope.seasonYears[new Date(data.result.date).getFullYear()].seasonEndDay = new Date(data.result.date).getDate();
            $scope.seasonYears[new Date(data.result.date).getFullYear()].seasonEndMonth = new Date(data.result.date).getMonth();
          } else {
            toaster.pop('error', 'Errore', 'Zona Climatica per la fine della stagione termica non trovata');
          }
          return this;
        });
      }
      // inizializzo a zero la colonna dei totali...
      for (var i = 0; i <= $scope.months.length; i++) {
        $scope.dataTotals[i] = {
          'totReal': 0
        };
      }
      //Se necessario, ricarico la località...
      var locChanged = true;
      if ($scope.zonatermica.model) {
        locChanged = $scope.zonatermica.model.code != $scope.zonatermica.zonatermica_id.UUID;
      }
      if (locChanged) {
        reloadLocationData();
      }
      var placeCode = $scope.getPlaceCode();
      $scope.graphData = [];
      $scope.graphDataCum = [];
      $scope.max = 0;
      // inizializzo la matrice per i dati giorno x giorno, con le date, i tipi 'hist' e 'real', e i valori a 0...
      /* init dataMatrix */
      for (var m = 0; m < $scope.months.length; m++) {
        for (var d = 1; d <= 31; d++) {
          var date = new Date($scope.months[m].dateMonth.getFullYear(), $scope.months[m].dateMonth.getMonth(), d);
          var histDate = new Date(HIST_YEAR, $scope.months[m].dateMonth.getMonth(), d);
          if (date.getMonth() == $scope.months[m].dateMonth.getMonth()) {
            //non ha shiftato al mese dopo
            var emptyData = {
              real: {
                'value': 0,
                'date': date.getTime(),
                'type': 'real'
              },
              hist: {
                'value': 0,
                'date': histDate.getTime(),
                'type': 'hist'
              }
            };
            $scope.dataMatrix[m][d - 1] = emptyData;
          }
        }
      }
      // una volta ottenute le date di inizio e fine stagione termica, riempio con i dati ottenuti dalla dayDegreeFactory...
      $q.all([seasonStartPromise, seasonEndPromise]).then(function () {
        if ($scope.bool.selectPeriod == true) {
          if ($scope.type == 'real') {
            /* dati di consuntivo del periodo scelto: sia storici che reali... */
            dayDegreeFactory.search({
              type: 'real',
              fromDate: $scope.period.dateFrom.getFullYear() + '/' + ($scope.period.dateFrom.getMonth() + 1) + '/' + $scope.period.dateFrom.getDate(),
              toDate: $scope.period.dateTo.getFullYear() + '/' + ($scope.period.dateTo.getMonth() + 1) + '/' + $scope.period.dateTo.getDate(),
              place: placeCode
            }).$promise.then(loadedRealData);
            dayDegreeFactory.search({
              type: 'hist',
              //l'anno poi sarà sostituito dal server con 1970..
              fromDate: $scope.period.dateFrom.getFullYear() + '/01/01',
              toDate: $scope.period.dateTo.getFullYear() + '/12/31',
              place: placeCode
            }).$promise.then(loadedHistDataSplit);
          } else if ($scope.type == 'hist') {
            /* dati di consuntivo storici, carico solo questi, carico però tutto l'anno... */
            dayDegreeFactory.search({
              type: 'hist',
              //l'anno poi sarà sostituito dal server con 1970..
              fromDate: $scope.period.dateFrom.getFullYear() + '/01/01',
              toDate: $scope.period.dateTo.getFullYear() + '/12/31',
              place: placeCode
            }).$promise.then(loadedHistDataSplit);
          }
        } else {
          /* dati di consuntivo dell'anno scelto: sia storici che reali... */
          if ($scope.type == 'real') {
            dayDegreeFactory.search({
              type: 'real',
              fromDate: $scope.selected.year + '/01/01',
              toDate: $scope.selected.year + '/12/31',
              place: placeCode
            }).$promise.then(loadedRealData);
            /* dati di storico */
            dayDegreeFactory.search({
              type: 'hist',
              //l'anno poi sarà sostituito dal server con 1970..
              fromDate: $scope.selected.year + '/01/01',
              toDate: $scope.selected.year + '/12/31',
              place: placeCode
            }).$promise.then(loadedHistData);
          } else if ($scope.type == 'hist') {
            /* dati di consuntivo storici, carico solo questi... */
            dayDegreeFactory.search({
              type: 'hist',
              //l'anno poi sarà sostituito dal server con 1970..
              fromDate: $scope.selected.year + '/01/01',
              toDate: $scope.selected.year + '/12/31',
              place: placeCode
            }).$promise.then(loadedHistData);
          }
        }
      });
    }
  };
  $scope.editingMonth = null;
  function loadedHistData(value) {
    value.list.forEach(function (record) {
      var dateCurrent = new Date(record.date);
      var m = sixDateLib.countMonthsInPeriod(new Date(HIST_YEAR, 0, 1), dateCurrent) - 1;
      $scope.dataMatrix[m][dateCurrent.getDate() - 1].hist = record;
      $scope.dataTotals[m]['totHist'] = ($scope.dataTotals[m]['totHist'] || 0) + record.value;
      $scope.dataTotals[$scope.months.length]['totHist'] = ($scope.dataTotals[$scope.months.length]['totHist'] || 0) + record.value;
      if ($scope.max < record.value) $scope.max = record.value;
    });
    $scope.histDataLoaded = true;
    evaluateTotalsAndGraph();
  }
  function loadedRealData(value) {
    value.list.forEach(function (record) {
      var dateCurrent = new Date(record.date);
      var m;
      if ($scope.bool.selectPeriod == true) {
        m = sixDateLib.countMonthsInPeriod($scope.period.dateFrom, dateCurrent) - 1;
      } else {
        m = sixDateLib.countMonthsInPeriod(new Date($scope.selected.year, 0, 1), dateCurrent) - 1;
      }
      $scope.dataMatrix[m][dateCurrent.getDate() - 1].real = record;
      if ($scope.inSeason(dateCurrent.getFullYear(), dateCurrent.getMonth(), dateCurrent.getDate()) === true) {
        $scope.dataTotals[m]['totReal'] = ($scope.dataTotals[m]['totReal'] || 0) + record.value;
        $scope.dataTotals[$scope.months.length]['totReal'] = ($scope.dataTotals[$scope.months.length]['totReal'] || 0) + record.value;
      }
      if ($scope.max < record.value) $scope.max = record.value;
    });
    $scope.realDataLoaded = true;
    evaluateTotalsAndGraph();
  }
  function loadedHistDataSplit(value) {
    var dateCurrent = new Date($scope.period.dateFrom.getFullYear(), $scope.period.dateFrom.getMonth(), 1);
    var histMatrix = createArray(12, 31);
    for (var m = 0; m < 12; m++) {
      /* matrice di appoggio per prelevare il budget di default */
      for (var d = 1; d <= 31; d++) {
        var date = new Date(HIST_YEAR, m, d);
        if (date.getMonth() == m) {
          var emptyData = {
            hist: {
              'value': 0,
              'date': date.getTime(),
              'type': 'hist'
            }
          };
          histMatrix[m][d - 1] = emptyData;
        }
      }
    }
    value.list.forEach(function (record) {
      /* aggiornamento matrice di appoggio -> con i dati del budget */
      var recordDate = new Date(record.date);
      histMatrix[recordDate.getMonth()][recordDate.getDate() - 1].hist = record;
    });
    var recordCurrent;
    while (dateCurrent <= $scope.period.dateTo) {
      /* aggiornamento dataMatrix */
      if (angular.isDefined(histMatrix[dateCurrent.getMonth()][dateCurrent.getDate() - 1])) {
        /* per gestire anni bisestili */
        var m = sixDateLib.countMonthsInPeriod($scope.period.dateFrom, dateCurrent) - 1;
        recordCurrent = histMatrix[dateCurrent.getMonth()][dateCurrent.getDate() - 1].hist;
        $scope.dataMatrix[m][dateCurrent.getDate() - 1].hist = recordCurrent;
        $scope.dataTotals[m]['totHist'] = ($scope.dataTotals[m]['totHist'] || 0) + recordCurrent.value;
        $scope.dataTotals[$scope.months.length]['totHist'] = ($scope.dataTotals[$scope.months.length]['totHist'] || 0) + recordCurrent.value;
        if ($scope.max < recordCurrent.value) {
          $scope.max = recordCurrent.value;
        }
      }
      dateCurrent.setDate(dateCurrent.getDate() + 1);
    }
    $scope.histDataLoaded = true;
    evaluateTotalsAndGraph();
  }
  function evaluateTotalsAndGraph() {
    if ($scope.type == 'hist' && $scope.histDataLoaded || $scope.type == 'real' && $scope.realDataLoaded && $scope.histDataLoaded) {
      //caricato entrambi o solo gli storici, dipende dalla pagina in cui siamo
      var cumReal = 0,
        cumHist = 0;
      if ($scope.max > 0) {
        for (var m = 0; m < $scope.months.length; m++) {
          var dmm = $scope.dataMatrix[m];
          var dtm = $scope.dataTotals[m];
          if (m > 0) {
            dtm['cumulReal'] = ($scope.dataTotals[m - 1]['cumulReal'] || 0) + (dtm['totReal'] || 0);
            dtm['cumulHist'] = ($scope.dataTotals[m - 1]['cumulHist'] || 0) + (dtm['totHist'] || 0);
          } else {
            dtm['cumulReal'] = dtm['totReal'];
            dtm['cumulHist'] = dtm['totHist'];
          }
          for (var d = 1; d <= 31; d++) {
            if (dmm[d - 1]) {
              var data = dmm[d - 1].real;
              cumReal += data.value;
              cumHist += dmm[d - 1].hist.value;
              var date = new Date(data.date);
              var grpDT = {
                'date': date
              };
              var grpCumDT = {
                'date': date
              };
              if ($scope.type != 'hist') {
                grpDT['Consuntivo'] = '' + data.value;
                grpCumDT['Consuntivo'] = '' + cumReal;
              }
              grpDT['Storico'] = '' + dmm[d - 1].hist.value;
              grpCumDT['Storico'] = '' + cumHist;
              $scope.graphData.push(grpDT);
              $scope.graphDataCum.push(grpCumDT);
            }
          }
        }
      }
    }
  }

  //TODO: questa parte è fatta in fretta.. sarà da sistemare
  $scope.calculateFromRef = function () {
    var value = {
      code_ref: $scope.refZonaTermica.UUID,
      code: $scope.zonatermica.zonatermica_id.UUID,
      description: $scope.zonatermica.model.description,
      year: $scope.selected.year
    };
    // dialogService.loading('Calcolo dati da località di riferimento ('+$scope.refZonaTermica.model.description+')');
    loadingBarService.start('Calcolo dati da località di riferimento (' + $scope.refZonaTermica.model.description + ')');
    dayDegreeFactory.saveByRef({
      type: $scope.type,
      op: $scope.refZonaTermica.UUID
    }, value).$promise.then(function (response) {
      if (errorService.handleError(response)) {
        $scope.loadDD();
      } else {
        toaster.pop('error', 'Errore', 'Errore nel calcolo dei gradi giorno');
      }
      // dialogService.stopLoading();
      loadingBarService.stop();
    }, function (error) {
      $log.error('Errore nel calcolo dei gradi giorno', error);
      toaster.pop('error', 'Errore', 'Errore nel calcolo dei gradi giorno');
      loadingBarService.stop();
    });
  };
  $scope.calculateReferring = function () {
    var value = {
      year: $scope.selected.year
    };
    // dialogService.loading('Calcolo località collegate ('+$scope.zonatermica.model.description+')');
    loadingBarService.start('Calcolo località collegate (' + $scope.zonatermica.model.description + ')');
    dayDegreeFactory.saveReferring({
      type: $scope.type,
      op: $scope.zonatermica.zonatermica_id.UUID
    }, value).$promise.then(function (response) {
      if (!errorService.handleError(response)) {
        toaster.pop('error', 'Errore', 'Errore nel calcolo dei gradi giorno');
      }
      // dialogService.stopLoading();
      loadingBarService.stop();
    }, function (error) {
      $log.error('Errore nel calcolo dei gradi giorno', error);
      toaster.pop('error', 'Errore', 'Errore nel calcolo dei gradi giorno');
      loadingBarService.stop();
    });
  };
  $scope.calculateAllReferring = function () {
    var message = 'ATTENZIONE: Ricalcolare i Gradi Giorno a consuntivo di TUTTE le zone termiche nel sistema?';
    dialogService.confirmDialog(message, function () {
      loadingBarService.start('Calcolo TUTTE le località...');
      dayDegreeFactory.saveAllReferring({
        time: $scope.selected.year
      }).$promise.then(function (response) {
        if (!errorService.handleError(response)) {
          toaster.pop('error', 'Errore', 'Errore nel calcolo dei gradi giorno');
        }
        loadingBarService.stop();
      }, function (error) {
        $log.error('Errore nel calcolo dei gradi giorno', error);
        toaster.pop('error', 'Errore', 'Errore nel calcolo dei gradi giorno');
        loadingBarService.stop();
      });
    });
  };
  $scope.tempToDD = function (normalized) {
    // dialogService.loading('Ricalcolo gradi giorno');
    loadingBarService.start('Ricalcolo gradi giorno');
    dayDegreeFactory.tempToDD({
      zt: $scope.zonatermica.zonatermica_id.UUID,
      normalize: normalized
    }).$promise.then(function (result) {
      if (errorService.handleError(result)) {
        $scope.loadDD();
      } else {
        toaster.pop('error', 'Errore', 'Errore nel calcolo dei gradi giorno');
      }
      // dialogService.stopLoading();
      loadingBarService.stop();
    }, function (error) {
      $log.error('Errore nel calcolo dei gradi giorno', error);
      toaster.pop('error', 'Errore', 'Errore nel calcolo dei gradi giorno');
      loadingBarService.stop();
    });
  };
  $scope.tempToDDAll = function () {
    var message = 'ATTENZIONE: Ricalcolare i Gradi Giorno storici di TUTTE le zone termiche nel sistema?';
    dialogService.confirmDialog(message, function () {
      // dialogService.loading('Ricalcolo gradi giorno (TUTTE le ZT)');
      loadingBarService.start('Ricalcolo gradi giorno (TUTTE le ZT)');
      dayDegreeFactory.tempToDDAll().$promise.then(function (result) {
        if (errorService.handleError(result)) {
          $scope.loadDD();
        } else {
          toaster.pop('error', 'Errore', 'Errore nel calcolo dei gradi giorno');
        }
        // dialogService.stopLoading();
        loadingBarService.stop(result);
      }, function (error) {
        $log.error('Errore nel calcolo dei gradi giorno', error);
        toaster.pop('error', 'Errore', 'Errore nel calcolo dei gradi giorno');
        loadingBarService.stop();
      });
    });
  };
  $scope["delete"] = function () {
    var value = {
      year: $scope.selected.year
    };
    loadingBarService.start('Cancellazione in corso');
    dayDegreeFactory["delete"]({
      type: $scope.type,
      op: $scope.zonatermica.zonatermica_id.UUID
    }, value).$promise.then(function (response) {
      console.log(response);
      $scope.loadDD();
      loadingBarService.stop();
    }, function (error) {
      $log.error('Errore durante l\'eliminazione', error);
      toaster.pop('error', 'Errore', 'Errore durante l\'eliminazione');
      loadingBarService.stop();
    });
  };
  function replaceAll(str, find, replace) {
    return str.replace(new RegExp(find, 'g'), replace);
  }
  var REPORT_JASPER_DIRECTORY = 'reports/EMMA/Energy/daydegree_tab_all_zt'; // path del report su jasperserver

  $scope.printReport = function (extensionFile) {
    var urlPrefix = DEV ? '/' : '/emma/';
    var endpointAddressGenericReport = 'http://' + $location.$$host + ':' + $location.$$port + urlPrefix + ENERGY_URL + '/api/report/_zonatermica/_list';
    var endpointAddressSingleReport = 'http://' + $location.$$host + ':' + $location.$$port + urlPrefix + ENERGY_URL + '/api/report/_daydegree/_tab';
    var reportNameToSave = 'report_gradi_giorno'; // nome con il quale viene salvato sul pc dell'utente
    var reportPath = REPORT_JASPER_DIRECTORY + '.' + extensionFile; // dove si trova il report su jasperserver (http://172.29.100.155:7878/jasperserver) + nome report .pdf
    if (CheckDates()) {
      var from = '';
      var to = '';
      var id = $scope.zonatermica.zonatermica_id ? new String($scope.zonatermica.zonatermica_id.UUID) : 'null';
      if ($scope.bool.selectPeriod == true) {
        from = sixDateLib.getDateStringFormattedFromDate($scope.period.dateFrom).replace('/', '-');
        to = sixDateLib.getDateStringFormattedFromDate($scope.period.dateTo).replace('/', '-');
      } else {
        from = $scope.selected.year + '-01-01';
        to = $scope.selected.year + '-12-31';
      }
      var singleReport = endpointAddressSingleReport + '/' + $scope.type + '/' + from + '/' + to + '/';
      var query = '&net.sf.jasperreports.json.source=' + endpointAddressGenericReport + '/' + id + '/' + replaceAll(singleReport, '/', '$');
      $http.post(APP_URL + '/rest/report/generate', {
        path: reportPath,
        query: query
      }, {
        responseType: 'arraybuffer'
      }).success(function (data, status, headers, config) {
        var options;
        if (extensionFile == 'pdf') {
          options = {
            type: 'application/pdf'
          };
        } else if (extensionFile == 'xls') {
          options = {
            type: 'application/vnd.ms-excel;'
          };
        }
        SaveAs.download(data, reportNameToSave + '.' + extensionFile, options);
      }).error(function (data, status, headers, config) {
        toaster.pop('error', "Errore", 'Errore generazione report');
      });
    }
  };
  $scope.getTimes = function (n) {
    return new Array(n);
  };
  $scope.getMonths = function () {
    return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
  };
  $scope.clearDates = function () {
    $scope.period.dateFrom = null;
    $scope.period.dateTo = null;
  };
  $scope.getKibanaUrl = function () {
    if (!$scope.zonatermica.zonatermica_id) return;
    var year = $scope.selected.year;
    if ($scope.type === 'hist') year = HIST_YEAR;
    var host = $location.host();
    host = 'localhost' === host ? 'docker.ict-group.it' : host;
    //FIXME: manca il tipo
    var src = 'http://' + host + ':5601/#/dashboard/BudgetDashboard?embed&_g=(refreshInterval:(display:Off,section:0,value:0),time:(from:\'' + year + '-01-01T00:00:00.000Z\',mode:absolute,to:\'' + (year + 1) + '-01-01T00:00:00.000Z\'))&_a=(filters:!(),panels:!((col:1,id:Budget-Visualization,row:1,size_x:12,size_y:3,type:visualization)),query:(query_string:(analyze_wildcard:!t,query:\'place.code%3D!\'' + $scope.getPlaceCode() + '!\'\')),title:BudgetDashboard)';
    return $sce.trustAsResourceUrl(src);
  };
  $scope.editMonth = function (month) {
    $scope.editingMonth = month;
  };
  $scope.confirmMonthWithDialog = function (month) {
    if ($scope.type === 'real') {
      var message = 'Ricalcolare anche i Gradi Giorno a consuntivo delle località che afferiscono a questa? ';
      dialogService.confirmDialog(message, function () {
        $scope.confirmMonth(month, true);
      }, function () {
        $scope.confirmMonth(month, false);
      });
    } else {
      $scope.confirmMonth(month, false);
    }
  };
  $scope.confirmMonth = function (month, saveReferring) {
    var value = [];
    $scope.editingMonth = null;
    // dialogService.loading('Salvataggio in corso');
    loadingBarService.start('Salvataggio in corso');
    var placeForNewDD = {
      type: $scope.zonatermica.zonatermica_id.type,
      UUID: $scope.zonatermica.zonatermica_id.UUID,
      code: $scope.zonatermica.model.code,
      description: $scope.zonatermica.model.description
    };
    for (var i = 0; i < 31; i++) {
      if ($scope.dataMatrix[month][i] && $scope.dataMatrix[month][i][$scope.type]) {
        var toSave = $scope.dataMatrix[month][i][$scope.type];
        if (!toSave.id) {
          //nuovo dato
          toSave.place = placeForNewDD;
        }
        value.push(toSave);
      }
    }
    dayDegreeFactory.save({
      saveReferring: saveReferring
    }, value).$promise.then(function (response) {
      $log.info('saved');
      $scope.loadDD();
      // dialogService.stopLoading();
      loadingBarService.stop();
    });
  };
  $scope.undoMonth = function (month) {
    //ricarico...
    $scope.editingMonth = null;
    $scope.loadDD();
  };
  $scope.inSeason = function (year, month, day) {
    // è da adattare in base all'anno passato come funzione sotto
    if (month < $scope.seasonYears[year].seasonEndMonth || month > $scope.seasonYears[year].seasonStartMonth) return true;
    return month == $scope.seasonYears[year].seasonEndMonth && day <= $scope.seasonYears[year].seasonEndDay || month == $scope.seasonYears[year].seasonStartMonth && day >= $scope.seasonYears[year].seasonStartDay;
  };
  $scope.DrawInSeason = function (m, day) {
    // è da adattare in base all'anno passato come funzione sotto
    if (m.numMonth < $scope.seasonYears[m.yearMonth].seasonEndMonth || m.numMonth > $scope.seasonYears[m.yearMonth].seasonStartMonth) return true;
    return m.numMonth == $scope.seasonYears[m.yearMonth].seasonEndMonth && day <= $scope.seasonYears[m.yearMonth].seasonEndDay || m.numMonth == $scope.seasonYears[m.yearMonth].seasonStartMonth && day >= $scope.seasonYears[m.yearMonth].seasonStartDay;
  };
  $scope.drawSeasonEnd = function (m, index) {
    if (m.numMonth == $scope.seasonYears[m.yearMonth].seasonEndMonth && index == $scope.seasonYears[m.yearMonth].seasonEndDay - 1) {
      return true;
    } else {
      return false;
    }
  };
  $scope.drawSeasonStart = function (m, index) {
    if (m.numMonth == $scope.seasonYears[m.yearMonth].seasonStartMonth && index == $scope.seasonYears[m.yearMonth].seasonStartDay - 1) {
      return true;
    } else {
      return false;
    }
  };
  $scope.editMonthsValues = function (history) {
    $scope.monthsValues = [];
    var type = '';
    if (history) {
      $scope.monthsValuesHist = true;
    } else {
      $scope.monthsValuesHist = false;
    }
    for (var m = 0; m < $scope.months.length; m++) {
      var value;
      if ($scope.dataTotals[m]) {
        value = $scope.monthsValuesHist ? $scope.dataTotals[m].totHist : $scope.dataTotals[m].totReal;
      }
      if (value) {
        $scope.monthsValues.push(value);
      } else {
        $scope.monthsValues.push(0);
      }
    }
  };
  $scope.confirmEditMonthsWithDialog = function () {
    if ($scope.type === 'real') {
      var message = 'Ricalcolare anche i Gradi Giorno a consuntivo delle località che afferiscono a questa? ';
      dialogService.confirmDialog(message, function () {
        $scope.confirmEditMonths(true);
      }, function () {
        $scope.confirmEditMonths(false);
      });
    } else {
      $scope.confirmEditMonths(false);
    }
  };
  $scope.confirmEditMonths = function (saveReferring) {
    // dialogService.loading('Salvataggio in corso');
    loadingBarService.start('Salvataggio in corso');
    var type = $scope.monthsValuesHist ? 'hist' : 'real';
    var valuesMap = {};
    for (var m = 0; m < $scope.months.length; m++) {
      valuesMap['' + m] = $scope.monthsValues[m];
    }
    dayDegreeFactory.saveMonths({
      type: type,
      zt: $scope.zonatermica.zonatermica_id.UUID,
      year: $scope.selected.year,
      saveReferring: saveReferring
    }, valuesMap).$promise.then(function (response) {
      if (errorService.handleError(response)) {
        $scope.monthsValues = null;
        $scope.loadDD();
      } else {
        toaster.pop('error', 'Errore', 'Errore durante la modifica dei gradi giorno');
      }
      // dialogService.stopLoading();
      loadingBarService.stop();
    });
  };
  $scope.getYears = function () {
    var years = [];
    for (var i = low; i < high; i++) {
      years.push(i);
    }
    return years;
  };
  $scope.previousYear = function () {
    $scope.selected.year = parseInt($scope.selected.year) - 1;
    if ($scope.selected.year <= low) {
      low = low - CONSTANT_YEAR;
    }
  };
  $scope.nextYear = function () {
    $scope.selected.year = parseInt($scope.selected.year) + 1;
    if ($scope.selected.year >= high) {
      high = high + CONSTANT_YEAR;
    }
  };
  $scope.undoEditMonths = function () {
    $scope.monthsValues = null;
  };
  $scope.goToImportDD = function () {
    $location.path('energy/importgg');
  };
  $scope.$watch('zonatermica.zonatermica_id', function (newValue, oldValue) {
    if (newValue != oldValue) {
      $scope.loadDD();
    }
  });
  $scope.$watch('selected.year', function (newVal, oldVal) {
    if (newVal != oldVal) {
      $scope.loadDD();
    }
  });
  $scope.loadDD();

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'energy/dd';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:ImportggCtrl
 * @description
 * # ImportggCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/energy/importgg', {
    templateUrl: 'energy/daydegrees/importgg.html',
    controller: 'ImportggCtrl'
  });
}]).controller('ImportggCtrl', ["$scope", "$location", "$log", "recordFactory", "dayDegreeFactory", "zonaTermicaFactory", "zonaClimaticaFactory", "dialogService", "$filter", function ($scope, $location, $log, recordFactory, dayDegreeFactory, zonaTermicaFactory, zonaClimaticaFactory, dialogService, $filter) {
  //http://ui-grid.info/

  $scope.period = 'month';
  $scope.type = 'real';
  $scope.season = {
    considerSeasonality: false
  };
  $scope.gridOptions = {
    onRegisterApi: function onRegisterApi(gridApi) {
      $scope.gridApi = gridApi;
    }
  };
  $scope.downloadTemplate = function () {
    var anchor = $('#linkToTemplate');
    var url = anchor.attr("href");
    anchor.click(function (e) {
      e.preventDefault();
      window.location.href = url;
    });
    anchor.click();
  };
  $scope.toggleSeasonality = function () {
    $scope.season.considerSeasonality = !$scope.season.considerSeasonality;
  };

  //dati caricati da xls
  $scope.$watch(function () {
    return $scope.gridOptions.xlsData;
  }, function (newValue, oldValue) {
    if (newValue && newValue.length > 0) {
      reloadGridOptions();
      processData();
    }
  });
  function processRow(row) {
    var result = angular.copy(row);
    result['placeLabel'] = result['Zona_Termica'];
    delete result.Zona_Termica;
    if ($scope.period === 'month') {
      result['1'] = result['Gen'] ? parseFloat(result['Gen']) : undefined;
      delete result['Gen'];
      result['2'] = result['Feb'] ? parseFloat(result['Feb']) : undefined;
      delete result['Feb'];
      result['3'] = result['Mar'] ? parseFloat(result['Mar']) : undefined;
      delete result['Mar'];
      result['4'] = result['Apr'] ? parseFloat(result['Apr']) : undefined;
      delete result['Apr'];
      result['5'] = result['Mag'] ? parseFloat(result['Mag']) : undefined;
      delete result['Mag'];
      result['6'] = result['Giu'] ? parseFloat(result['Giu']) : undefined;
      delete result['Giu'];
      result['7'] = result['Lug'] ? parseFloat(result['Lug']) : undefined;
      delete result['Lug'];
      result['8'] = result['Ago'] ? parseFloat(result['Ago']) : undefined;
      delete result['Ago'];
      result['9'] = result['Set'] ? parseFloat(result['Set']) : undefined;
      delete result['Set'];
      result['10'] = result['Ott'] ? parseFloat(result['Ott']) : undefined;
      delete result['Ott'];
      result['11'] = result['Nov'] ? parseFloat(result['Nov']) : undefined;
      delete result['Nov'];
      result['12'] = result['Dic'] ? parseFloat(result['Dic']) : undefined;
      delete result['Dic'];
      result['year'] = result['Anno'] ? parseInt(result['Anno']) : undefined;
      delete result['Anno'];
    } else if ($scope.period === 'day') {
      result['month'] = parseInt(result['Mese']);
      delete result['Mese'];
      result['year'] = parseInt(result['Anno']);
      delete result['Anno'];
      for (var colIndex = 1; colIndex < 32; colIndex++) {
        if (result[colIndex]) {
          result[colIndex] = result[colIndex] ? parseFloat(result[colIndex]) : undefined;
        }
      }
    }
    delete result.update;
    return result;
  }
  function processData() {
    $scope.canUndo = false;
    $scope.canImport = false;
    $scope.total = 0;
    $scope.ok = 0;
    $scope.gridOptions.xlsData.forEach(function (value) {
      if (value.update === 's') {
        $scope.total += 1;
        value = processRow(value);
        zonaTermicaFactory.byCode({
          id: value.placeLabel
        }).$promise.then(function (data) {
          if (data.model) {
            zonaClimaticaFactory.findByZonaTermica({
              id: data.UUID
            }).$promise.then(function (zoneData) {
              console.log('zona ' + JSON.stringify(zoneData));
              if (zoneData.model) {
                var year, monthIn, dayIn, monthOut, dayOut;
                $scope.type === 'real' ? year = $filter('date')(new Date(), 'yyyy') : year = '1970';
                $scope.type === 'real' ? dayIn = 1 : dayIn = zoneData.model.day_in;
                $scope.type === 'real' ? monthIn = 0 : monthIn = sixDateLib.getMonthIndex(zoneData.model.month_in);
                $scope.type === 'real' ? dayOut = 31 : dayOut = zoneData.model.day_out;
                $scope.type === 'real' ? monthOut = 11 : monthOut = sixDateLib.getMonthIndex(zoneData.model.month_out);
                value.dateIn = new Date(year, monthIn, dayIn);
                value.dateOut = new Date(year, monthOut, dayOut);
                value.zone = zoneData.model.code;
                if (!value.dateIn || !value.dateOut) {
                  value.Result = 'Date inizio/fine mancanti';
                } else {
                  value.dateInLabel = zoneData.model.day_in + '-' + zoneData.model.month_in;
                  value.dateOutLabel = zoneData.model.day_out + '-' + zoneData.model.month_out;
                  $scope.ok += 1;
                  if ($scope.ok > 1 && $scope.type === 'hist' && $scope.period === 'month') {
                    value.Result = 'Importare solo un anno per i dati storici';
                  } else {
                    value.Result = 'ok';
                  }
                }
                if ($scope.ok === $scope.total && !($scope.ok > 1 && $scope.type === 'hist' && $scope.period === 'month')) {
                  $scope.canImport = true;
                  $scope.canUndo = true;
                  console.log(JSON.stringify($scope.gridOptions.data));
                }
              } else {
                value.Result = 'Zona climatica mancante';
              }
            });
            value.place = sixObjectLib.recordToHisRef(data);
          } else {
            value.Result = 'Zona termica mancante';
          }
          $scope.gridOptions.data.push(value);
        });
      }
    });
  }
  $scope.importDataWithDialog = function () {
    if ($scope.type === 'real') {
      var message = 'Ricalcolare anche i Gradi Giorno a consuntivo delle località che afferiscono a questa? ';
      dialogService.confirmDialog(message, function () {
        $scope.importData(true);
      }, function () {
        $scope.importData(false);
      });
    } else {
      $scope.importData(false);
    }
  };
  $scope.importData = function (saveReferring) {
    $scope.gridOptions.data.forEach(function (value) {
      $log.info($scope.gridOptions.columnDefs);
      $log.info('saving: ' + value);
      value.Result = 'Importazione in corso';
      if ($scope.period == 'month') {
        dayDegreeFactory.saveByMonth({
          type: $scope.type,
          saveReferring: saveReferring,
          considerSeasonality: $scope.season.considerSeasonality
        }, value).$promise.then(function (response) {
          $log.info(response);
          value.Result = 'Importato';
        });
      } else {
        dayDegreeFactory.saveByDay({
          type: $scope.type,
          saveReferring: saveReferring,
          considerSeasonality: $scope.season.considerSeasonality
        }, value).$promise.then(function (response) {
          $log.info(response);
          value.Result = 'Importato';
        });
      }
    });
  };
  $scope.clearData = function () {
    $scope.canUndo = false;
    $scope.canImport = false;
    $scope.gridOptions.data = [];
  };
  $scope.toggleHelp = function () {
    $scope.showHelp = !$scope.showHelp;
  };
  $scope.showHelp = false;
  $scope.canImport = false;
  $scope.canUndo = false;
  $scope.importByMonth = function () {
    $scope.gridOptions.data = [];
    $scope.period = 'month';
    reloadGridOptions();
  };
  $scope.importByDay = function () {
    $scope.gridOptions.data = [];
    $scope.period = 'day';
    reloadGridOptions();
  };
  $scope.importHist = function () {
    $scope.clearData();
    $scope.type = 'hist';
    reloadGridOptions();
  };
  $scope.importReal = function () {
    $scope.clearData();
    $scope.type = 'real';
    reloadGridOptions();
  };
  function dateLabel(string) {
    return string.substr(8, 2) + '-' + string.substr(5, 2);
  }
  function reloadGridOptions() {
    //DEFINIZIONE TABELLA PER MESE
    if ($scope.period === 'month') {
      $scope.gridOptions.columnDefs = [{
        field: 'placeLabel',
        name: 'Zona_Termica',
        displayName: 'Zona Termica',
        enableSorting: false,
        width: 150
      }];
      if ($scope.type === 'real') {
        $scope.gridOptions.columnDefs.push({
          field: 'year',
          name: 'Anno',
          width: 100
        });
      }
      $scope.gridOptions.columnDefs.push({
        field: 'zone',
        name: 'Zona',
        width: 50,
        enableColumnMenu: false
      }, {
        field: 'dateInLabel',
        name: 'Da',
        width: 50,
        enableColumnMenu: false
      }, {
        field: 'dateOutLabel',
        name: 'A',
        width: 50,
        enableColumnMenu: false
      }, {
        field: '1',
        name: 'Gen',
        width: 50,
        enableColumnMenu: false
      }, {
        field: '2',
        name: 'Feb',
        width: 50,
        enableColumnMenu: false
      }, {
        field: '3',
        name: 'Mar',
        width: 50,
        enableColumnMenu: false
      }, {
        field: '4',
        name: 'Apr',
        width: 50,
        enableColumnMenu: false
      }, {
        field: '5',
        name: 'Mag',
        width: 50,
        enableColumnMenu: false
      }, {
        field: '6',
        name: 'Giu',
        width: 50,
        enableColumnMenu: false
      }, {
        field: '7',
        name: 'Lug',
        width: 50,
        enableColumnMenu: false
      }, {
        field: '8',
        name: 'Ago',
        width: 50,
        enableColumnMenu: false
      }, {
        field: '9',
        name: 'Set',
        width: 50,
        enableColumnMenu: false
      }, {
        field: '10',
        name: 'Ott',
        width: 50,
        enableColumnMenu: false
      }, {
        field: '11',
        name: 'Nov',
        width: 50,
        enableColumnMenu: false
      }, {
        field: '12',
        name: 'Dic',
        width: 50,
        enableColumnMenu: false
      }, {
        name: 'Result',
        cellClass: function cellClass(grid, row, col, rowRenderIndex, colRenderIndex) {}
      });
    }
    //DEFINIZIONE TABELLA PER GIORNO
    if ($scope.period === 'day') {
      $scope.gridOptions.columnDefs = [{
        field: 'placeLabel',
        name: 'Zona_Termica',
        displayName: 'Zona Termica',
        headerCellClass: 'largeColumn'
      }];
      if ($scope.type === 'real') {
        $scope.gridOptions.columnDefs.push({
          field: 'year',
          name: 'Anno',
          width: 50
        });
      }
      $scope.gridOptions.columnDefs.push({
        field: 'month',
        name: 'Mese',
        width: 50
      }, {
        field: 'dateInLabel',
        name: 'Inizio',
        width: 50
      }, {
        field: 'dateOutLabel',
        name: 'Fine',
        width: 50
      });
      for (var colIndex = 1; colIndex < 32; colIndex++) {
        $scope.gridOptions.columnDefs.push({
          field: '' + colIndex,
          name: '' + colIndex,
          width: 26,
          headerCellClass: 'smallHeader',
          enableColumnMenu: false
        });
      }
      $scope.gridOptions.columnDefs.push({
        name: 'Result',
        cellClass: function cellClass(grid, row, col, rowRenderIndex, colRenderIndex) {}
      });
    }
  }
  $scope.importByMonth();
  $scope.type = 'real';
}]);
'use strict';

/*
  WebSocket statuses:
  - CONNECTING	0	The connection is not yet open.
  - OPEN	1	The connection is open and ready to communicate.
  - CLOSING	2	The connection is in the process of closing.
  - CLOSED	3	The connection is closed or couldn't be opened.
*/

/**
 * @ngdoc service
 * @name emma.energy.consanalysisWSFactory
 * @description
 * # wsfactory
 * Factory in the emma.energy.
 */
angular.module('emma.theme').factory('broadcastWSFactory', ["APP_URL", "ENV", "DEV", "$websocket", "$log", "$location", "$timeout", "dialogService", function (APP_URL, ENV, DEV, $websocket, $log, $location, $timeout, dialogService) {
  var MAX_ATTEMPTS = 3;
  var id = 0;
  var user;
  var ws;
  var listeners = [];
  function _send2(msg, tryToConnect) {
    if (angular.isUndefined(tryToConnect)) {
      tryToConnect = true;
    }
    if (tryToConnect) {
      _send(msg);
    } else {
      _send(msg, MAX_ATTEMPTS);
    }
  }
  function _send(msg, attempts) {
    if (ws) {
      attempts = angular.isUndefined(attempts) ? 0 : attempts;
      if (ws.readyState == 0) {
        // connecting => aspetto e riprovo ad inviare
        $log.info('readyState = ' + ws.readyState + ' => retry ' + (attempts + 1));
        $timeout(function () {
          _send(msg, attempts + 1);
        }, 1000); // aspetto un attimo e ritento l'invio
      } else if (ws.readyState == 1) {
        // open
        $log.debug('Sending requestId ' + id);
        msg.$id = id;
        var stringified = JSON.stringify(msg);
        ws.send(stringified).then(function () {
          $log.debug('requestId ' + id + ' sent');
        });
        id++;
      } else if (attempts < MAX_ATTEMPTS) {
        // closing o closed => provo a riconnettermi
        $log.warn('readyState = ' + ws.readyState + ' => retry ' + (attempts + 1));
        _connect(user);
        $timeout(function () {
          _send(msg, attempts + 1);
        }, 200); // aspetto un attimo e ritento l'invio
      } else {
        $log.error('readyState = ' + ws.readyState + ' => too many attempts (' + attempts + ')!!!');
        dialogService.dialog('Attenzione', 'La connessione con il server è stata persa: provare a ricaricare la pagina', dialogService.DIALOG_TYPE.WARNING, -1);
      }
    } else {
      $log.error('ws undefined: maybe you\'re not connected');
    }
  }
  function _reconnect(authId) {
    _disconnect();
    $timeout(function () {
      _connect(authId);
    }, 1000);
  }
  function _connect(authId) {
    if (ws && ws.readyState == 0) {
      $log.info('readyState = ' + ws.readyState + ' => connecting');
    } else if (ws && ws.readyState == 1) {
      $log.info('readyState = ' + ws.readyState + ' => already connected');
    } else {
      user = authId;
      $log.info('Creating broadcast ws for user ' + authId + ' ...');

      // costruzione url
      var wsPath;
      if ($location.protocol() == 'https') {
        wsPath = 'wss://'; // se viaggio su https
      } else {
        wsPath = 'ws://'; // se viaggio su http
      }

      wsPath += $location.host() + ':' + $location.port() + '/';
      if (!DEV) {
        wsPath += ENV + '/';
      }
      wsPath += 'ws/' + APP_URL + '/broadcast/ws/';
      ws = $websocket(wsPath + user);
      ws.onOpen(function () {
        $log.debug('Socket with broadcast/ws has been opened! (user = ' + user + ')');
      });
      ws.onClose(function (event) {
        $log.warn('Socket with broadcast/ws has been closed! (user = ' + user + ')');
      });
      ws.onError(function (event) {
        $log.error('Socket with broadcast/ws error', event);
      });
      ws.onMessage(function (message) {
        $log.debug(message);
        var parsed = JSON.parse(message.data);
        // delete queue[parsed.id];  // mi è arrivata almeno una risposta => la richiesta è stata elaborata
        $log.debug('responseId = ' + parsed.$id);
        listeners.forEach(function (l) {
          l(parsed);
        });
      });
    }
  }
  function _disconnect() {
    if (ws) {
      $log.info('Closing broadcast ws...');
      ws.close();
    }
  }
  var methods = {
    register: function register(listener) {
      var idx = listeners.indexOf(listener);
      if (idx < 0) {
        listeners.push(listener);
      }
    },
    unregister: function unregister(listener) {
      var idx = listeners.indexOf(listener);
      if (idx > -1) {
        listeners.splice(idx, 1);
      }
    },
    connect: function connect(authId) {
      _connect(authId);
    },
    reconnect: function reconnect(authId) {
      _reconnect(authId);
    },
    disconnect: function disconnect() {
      _disconnect();
    },
    status: function status() {
      return ws.readyState;
    },
    send: function send(msg) {
      _send2(msg);
    },
    currentRequestId: function currentRequestId() {
      return id == 0 ? undefined : id - 1;
    }
  };
  return methods;
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.baseFactory
 * @description
 * # baseFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.energy').factory('budgetFactory', ["ENERGY_URL", "$resource", function (ENERGY_URL, $resource) {
  return $resource(ENERGY_URL + '/api/budget/:verb/:id/:param1/:param2/:param3', {}, {
    byYear: {
      method: 'GET',
      isArray: false,
      params: {
        verb: 'v2',
        param1: 'fe',
        param2: 'byyear'
      }
    },
    byHeader: {
      method: 'GET',
      isArray: false,
      params: {
        verb: '_header'
      }
    },
    byCodeForPeriod: {
      method: 'GET',
      isArray: false,
      params: {
        verb: 'bycodeforperiod'
      }
    },
    budgetCodes: {
      method: 'GET',
      isArray: false,
      params: {
        verb: 'budgetcodes'
      }
    },
    budgetCodesFromCommissions: {
      method: 'GET',
      isArray: false,
      params: {
        verb: 'budgetcodesfromcommissions'
      }
    },
    recordIdsFromBudgets: {
      method: 'GET',
      isArray: false,
      params: {
        verb: 'recordidsfrombudgets'
      }
    },
    bulk: {
      method: 'POST',
      isArray: false,
      params: {
        verb: '_bulk'
      }
    },
    update: {
      method: 'PUT',
      isArray: false,
      params: {
        verb: '_update',
        id: '@version'
      }
    },
    "delete": {
      method: 'DELETE',
      params: {
        verb: '_delete',
        id: '@version'
      },
      ignoreLoadingBar: true
    },
    referenceCount: {
      method: 'GET',
      isArray: false,
      params: {
        verb: '_referencecount'
      },
      ignoreLoadingBar: true
    }
  });
}]);
'use strict';

/**
 * @ngdoc service
 * @name emma.energy.consanalysisWSFactory
 * @description
 * # wsfactory
 * Factory in the emma.energy.
 */

/*
 * Web Socket readyState:
 * CONNECTING	0	The connection is not yet open.
 * OPEN       1	The connection is open and ready to communicate.
 * CLOSING	  2	The connection is in the process of closing.
 * CLOSED     3	The connection is closed or couldn't be opened.
 */
angular.module('emma.theme').factory('consanalysisWSFactory', ["DEV", "ENV", "ENERGY_URL", "$websocket", "$log", "$location", "$timeout", "dialogService", function (DEV, ENV, ENERGY_URL, $websocket, $log, $location, $timeout, dialogService) {
  var ws;
  var listenerFn;
  var connectedUser;
  // var queue = [];
  var id = 0;
  function send(msg, attempts) {
    attempts = angular.isUndefined(attempts) ? 0 : attempts;
    if (ws.readyState == 1) {
      $log.debug('Sending requestId ' + id, msg);
      msg.$id = id;
      var stringified = JSON.stringify(msg);
      ws.send(stringified).then(function () {
        $log.debug('requestId ' + id + ' sent');
      });
      // queue[id] = msg;
      id++;
    } else if (attempts < 3) {
      // riprovo a connettermi
      $log.warn('readyState = ' + ws.readyState + ' => retry ' + (attempts + 1));
      methods.connect(connectedUser, listenerFn);
      $timeout(function () {
        send(msg, attempts + 1);
      }, 200); // aspetto un attimo e ritento l'invio
    } else {
      $log.error('readyState = ' + ws.readyState + ' => too many attempts (' + attempts + ')!!!');
      dialogService.dialog('Attenzione', 'La connessione con il server è stata persa: provare a ricaricare la pagina', dialogService.DIALOG_TYPE.WARNING, -1);
    }
  }
  var methods = {
    connect: function connect(user, listener) {
      if (ws) {
        ws.close();
      }

      // costruzione url
      var wsPath;
      if ($location.protocol() == 'https') {
        wsPath = 'wss://'; // se viaggio su https
      } else {
        wsPath = 'ws://'; // se viaggio su http
      }

      wsPath += $location.host() + ':' + $location.port() + '/';
      if (!DEV) {
        wsPath += ENV + '/';
      }
      wsPath += 'ws/' + ENERGY_URL + '/consumptionanalysis/ws/';
      ws = $websocket(wsPath + user);
      listenerFn = listener;
      connectedUser = user;
      ws.onOpen(function () {
        $log.info("Socket with consumptionanalysis/ws has been opened!");
      });
      ws.onClose(function (event) {
        $log.warn("Socket with consumptionanalysis/ws has been closed!");
      });
      ws.onError(function (event) {
        $log.error('consanalysisWSFactory error', event);
      });
      ws.onMessage(function (message) {
        $log.debug(message);
        var parsed = JSON.parse(message.data);
        // delete queue[parsed.id];  // mi è arrivata almeno una risposta => la richiesta è stata elaborata
        $log.debug('responseId = ' + parsed.$id);
        listenerFn(parsed);
      });
    },
    disconnect: function disconnect() {
      ws.close();
    },
    status: function status() {
      return ws.readyState;
    },
    listener: function listener(_listener) {
      listenerFn = _listener;
    },
    createSnaps: function createSnaps(params, snaps) {
      send({
        action: 'create',
        params: params,
        snaps: snaps
      });
    },
    deleteSnaps: function deleteSnaps(params, snaps) {
      send({
        action: 'delete',
        params: params,
        snaps: snaps
      });
    },
    recreateSnaps: function recreateSnaps(params, snaps) {
      send({
        action: 'recreate',
        params: params,
        snaps: snaps
      });
    },
    createAllSnaps: function createAllSnaps(params) {
      send({
        action: 'create',
        params: params,
        snaps: 'all'
      });
    },
    deleteAllSnaps: function deleteAllSnaps(params) {
      send({
        action: 'delete',
        params: params,
        snaps: 'all'
      });
    },
    recreateAllSnaps: function recreateAllSnaps(params) {
      send({
        action: 'recreate',
        params: params,
        snaps: 'all'
      });
    },
    createBudgetSnap: function createBudgetSnap(params) {
      send({
        action: 'create',
        params: params,
        snaps: 'budget'
      });
    },
    deleteBudgetSnap: function deleteBudgetSnap(params) {
      send({
        action: 'delete',
        params: params,
        snaps: 'budget'
      });
    },
    recreateBudgetSnap: function recreateBudgetSnap(params) {
      send({
        action: 'recreate',
        params: params,
        snaps: 'budget'
      });
    },
    createAssociationsSnap: function createAssociationsSnap(params) {
      send({
        action: 'create',
        params: params,
        snaps: 'associations'
      });
    },
    deleteAssociationsSnap: function deleteAssociationsSnap(params) {
      send({
        action: 'delete',
        params: params,
        snaps: 'associations'
      });
    },
    recreateAssociationsSnap: function recreateAssociationsSnap(params) {
      send({
        action: 'recreate',
        params: params,
        snaps: 'associations'
      });
    },
    createDDSnap: function createDDSnap(params) {
      send({
        action: 'create',
        params: params,
        snaps: 'dd'
      });
    },
    deleteDDSnap: function deleteDDSnap(params) {
      send({
        action: 'delete',
        params: params,
        snaps: 'dd'
      });
    },
    recreateDDSnap: function recreateDDSnap(params) {
      send({
        action: 'recreate',
        params: params,
        snaps: 'dd'
      });
    },
    createConsumptionsSnap: function createConsumptionsSnap(params) {
      send({
        action: 'create',
        params: params,
        snaps: 'consumptions'
      });
    },
    deleteConsumptionsSnap: function deleteConsumptionsSnap(params) {
      send({
        action: 'delete',
        params: params,
        snaps: 'consumptions'
      });
    },
    recreateConsumptionsSnap: function recreateConsumptionsSnap(params) {
      send({
        action: 'recreate',
        params: params,
        snaps: 'consumptions'
      });
    },
    createAnalysisSnap: function createAnalysisSnap(params) {
      send({
        action: 'create',
        params: params,
        snaps: 'analysis'
      });
    },
    deleteAnalysisSnap: function deleteAnalysisSnap(params) {
      send({
        action: 'delete',
        params: params,
        snaps: 'analysis'
      });
    },
    recreateAnalysisSnap: function recreateAnalysisSnap(params) {
      send({
        action: 'recreate',
        params: params,
        snaps: 'analysis'
      });
    },
    currentRequestId: function currentRequestId() {
      return id == 0 ? undefined : id - 1;
    }
  };
  return methods;
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.consumptionfactory
 * @description
 * # consumptionfactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.energy').factory('consumptionAnalysisFactory', ["ENERGY_URL", "$resource", function (ENERGY_URL, $resource) {
  return function () {
    return $resource(ENERGY_URL + '/api/consumptionanalysis/:method/:p1/:p2', {}, {
      getConsumptionAnalysisByPlant: {
        method: 'GET',
        params: {
          method: 'getbyplant',
          idOrCode: '@id'
        }
      },
      getConsumptionAnalysis: {
        method: 'POST',
        params: {
          method: 'get'
        }
      },
      createRecAssocSnap: {
        method: 'POST',
        params: {
          method: '_snap',
          p1: 'zt',
          p2: '_create'
        }
      },
      deleteRecAssocSnap: {
        method: 'POST',
        params: {
          method: '_snap',
          p1: 'zt',
          p2: '_delete'
        }
      },
      getBudgetSnap: {
        method: 'POST',
        params: {
          method: '_snap',
          p1: 'budget',
          p2: '_get'
        },
        ignoreLoadingBar: true
      },
      createBudgetSnap: {
        method: 'POST',
        params: {
          method: '_snap',
          p1: 'budget',
          p2: '_create'
        }
      },
      deleteBudgetSnap: {
        method: 'POST',
        params: {
          method: '_snap',
          p1: 'budget',
          p2: '_delete'
        }
      },
      getConsAnalysisSnap: {
        method: 'POST',
        params: {
          method: '_snap',
          p1: 'consanalysis',
          p2: '_get'
        },
        ignoreLoadingBar: true
      },
      createConsAnalysisSnap: {
        method: 'POST',
        params: {
          method: '_snap',
          p1: 'consanalysis',
          p2: '_create'
        },
        pushNotification: false,
        pushNotificationMessage: 'Creazione snap analisi consumi: fine'
      },
      deleteConsAnalysisSnap: {
        method: 'POST',
        params: {
          method: '_snap',
          p1: 'consanalysis',
          p2: '_delete'
        }
      },
      deleteCommissionConsAnalysisSnap: {
        method: 'GET',
        params: {
          method: '_snap',
          p1: 'consanalysis',
          p2: '_delete'
        }
      },
      getConsumptionsSnap: {
        method: 'POST',
        params: {
          method: '_snap',
          p1: 'consumptions',
          p2: '_get'
        },
        ignoreLoadingBar: true
      },
      createConsumptionsSnap: {
        method: 'POST',
        params: {
          method: '_snap',
          p1: 'consumptions',
          p2: '_create'
        }
      },
      deleteConsumptionsSnap: {
        method: 'POST',
        params: {
          method: '_snap',
          p1: 'consumptions',
          p2: '_delete'
        }
      },
      deleteCommissionConsumptionsSnap: {
        method: 'GET',
        params: {
          method: '_snap',
          p1: 'consumptions',
          p2: '_delete'
        }
      },
      getDDSnap: {
        method: 'POST',
        params: {
          method: '_snap',
          p1: 'dd',
          p2: '_get'
        },
        ignoreLoadingBar: true
      },
      createDDSnap: {
        method: 'POST',
        params: {
          method: '_snap',
          p1: 'dd',
          p2: '_create'
        }
      },
      deleteDDSnap: {
        method: 'POST',
        params: {
          method: '_snap',
          p1: 'dd',
          p2: '_delete'
        }
      }
    });
  };
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.consumptionfactory
 * @description
 * # consumptionfactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.energy').factory('consumptionFactory', ["ENERGY_URL", "$resource", function (ENERGY_URL, $resource) {
  return $resource(ENERGY_URL + '/api/consumption/:version/:verb/:type/:id/:param1/:param2/:param3', {}, {
    calcConsumptions: {
      method: 'GET',
      params: {
        verb: 'calc',
        type: '@type',
        id: '@id'
      }
    },
    calcAll: {
      method: 'GET',
      params: {
        verb: 'calcall'
      }
    },
    getConsumption: {
      method: 'GET',
      params: {
        version: 'v2',
        verb: 'get'
      }
    },
    calcAndGetConsumption: {
      method: 'GET',
      params: {
        version: 'v2',
        verb: 'calcget',
        type: '@type',
        id: '@id'
      }
    },
    getConsumptionByPlant: {
      method: 'GET',
      params: {
        verb: 'getbyplant',
        type: '@type',
        id: '@id'
      }
    },
    "delete": {
      method: 'DELETE',
      params: {
        type: '@type',
        id: '@id'
      }
    },
    referenceCount: {
      method: 'GET',
      params: {
        verb: '_referencecount',
        type: '@type',
        id: '@id'
      }
    },
    bulk: {
      method: 'POST',
      params: {
        verb: '_bulk'
      }
    }
  });
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.consumptivefactory
 * @description
 * # consumptivefactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.energy').factory('consumptiveFactory', ["ENERGY_URL", "$resource", function (ENERGY_URL, $resource) {
  return $resource(ENERGY_URL + '/api/consumptive/:verb/:type/:id/:idlist/:param1/:param2/:param3', {}, {
    consumptiveByContatoreInPeriod: {
      method: 'GET',
      isArray: true,
      params: {
        type: '@type',
        id: '@id'
      }
    },
    create: {
      method: 'POST',
      params: {
        verb: 'save'
      }
    },
    bulk: {
      method: 'POST',
      params: {
        verb: '_bulk'
      }
    },
    bulkMulticommission: {
      method: 'POST',
      params: {
        verb: '_bulk',
        param1: 'multicommission'
      }
    },
    update: {
      method: 'PUT',
      params: {
        id: '@id',
        type: '@type'
      }
    },
    "delete": {
      method: 'DELETE',
      params: {
        id: '@id'
      }
    },
    referenceCount: {
      method: 'GET',
      params: {
        verb: '_referencecount',
        idlist: '@idlist'
      }
    },
    reset: {
      method: 'POST',
      params: {
        verb: 'reset'
      }
    }
  });
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.dayDegreeFactory
 * @description
 * # dayDegreeFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.energy').factory('dayDegreeFactory', ["ENERGY_URL", "$resource", function (ENERGY_URL, $resource) {
  return $resource(ENERGY_URL + '/api/energy/dd/:method/:time/:type/:op/:year', {}, {
    saveByMonth: {
      method: 'POST',
      params: {
        method: 'importSave',
        time: 'month'
      }
    },
    saveByDay: {
      method: 'POST',
      params: {
        method: 'importSave',
        time: 'day'
      }
    },
    saveByRef: {
      method: 'POST',
      params: {
        method: 'saveByRef' /*, time: 'day'*/
      }
    },
    saveReferring: {
      method: 'POST',
      params: {
        method: 'saveReferring',
        type: '@zt'
      }
    },
    saveAllReferring: {
      method: 'GET',
      params: {
        method: 'saveAllReferring',
        type: '@type'
      }
    },
    save: {
      method: 'POST',
      params: {
        method: 'save'
      }
    },
    "delete": {
      method: 'POST',
      params: {
        method: 'delete',
        type: '@zt'
      }
    },
    create: {
      method: 'POST'
    },
    query: {
      method: 'GET',
      params: {
        time: 'day' /*??*/,
        type: '@type'
      },
      isArray: false
    },
    search: {
      method: 'GET',
      params: {
        time: 'day' /*??*/,
        type: '@type',
        op: 'search'
      },
      isArray: false
    },
    //FIXME: i parametri in get sono usati male... sistemare
    locReferencedBy: {
      method: 'POST',
      params: {
        method: 'locReferencedBy',
        time: '@zt'
      },
      isArray: true
    },
    provinciaLocalita: {
      method: 'POST',
      params: {
        method: 'provinciaLocalita',
        time: '@zt'
      }
    },
    tempToDD: {
      method: 'POST',
      params: {
        method: 'tempToDD',
        time: '@zt'
      }
    },
    tempToDDAll: {
      method: 'GET',
      params: {
        method: 'tempToDD',
        time: 'all'
      }
    },
    saveMonths: {
      method: 'POST',
      params: {
        method: 'saveMonths',
        type: '@type',
        zt: '@zt',
        year: '@year'
      }
    },
    zonaTermicaWithDefaults: {
      method: 'POST',
      params: {
        method: 'zonaTermicaWithDefaults',
        time: '@zt'
      }
    },
    referenceCount: {
      method: 'GET',
      isArray: false,
      params: {
        method: '_referencecount'
      },
      ignoreLoadingBar: true
    }
  });
}]);
"use strict";

// Default:
// {
//   'get':    {method:'GET'},
//   'save':   {method:'POST'},
//   'query':  {method:'GET', isArray:true},
//   'remove': {method:'DELETE'},
//   'delete': {method:'DELETE'}
// }
angular.module('emma.energy').factory('energyCarrierFactory', ["ENERGY_URL", "$resource", function (ENERGY_URL, $resource) {
  return $resource(ENERGY_URL + '/api/energycarrier/:verb/:id/:param1/:param2/:param3', {}, {
    byUUID: {
      method: 'GET',
      isArray: false,
      params: {
        verb: '_uuid',
        param1: '_current'
      }
    },
    schemas: {
      method: 'GET',
      isArray: false,
      params: {
        verb: '_schemas'
      }
    }
  });
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.baseFactory
 * @description
 * # baseFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.energy').factory('heatingSeasonFactory', ["ENERGY_URL", "$resource", function (ENERGY_URL, $resource) {
  return $resource(ENERGY_URL + '/api/heatingseason/:verb/:type/:zt/:year/:param1', {}, {
    begin: {
      method: 'GET',
      isArray: false,
      params: {
        verb: '_date',
        param1: 'begin'
      }
    },
    end: {
      method: 'GET',
      isArray: false,
      params: {
        verb: '_date',
        param1: 'end'
      }
    },
    get: {
      method: 'GET',
      isArray: false
    },
    create: {
      method: 'POST'
    },
    "delete": {
      method: 'DELETE',
      params: {
        zt: '@id'
      }
    }
  });
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.listcomponentfactory
 * @description
 * # listcomponentfactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.energy').factory('listComponentFactory', ["ENERGY_URL", "$resource", function (ENERGY_URL, $resource) {
  return function (type) {
    return $resource(ENERGY_URL + '/api/list/component/' + type + '/:verb/:id/:param1/:param2/:param3', {}, {
      search: {
        method: 'POST',
        isArray: false,
        params: {
          verb: '_search'
        }
      },
      create: {
        method: 'POST',
        params: {
          id: '@id'
        }
      },
      bulk: {
        method: 'POST',
        isArray: false,
        params: {
          verb: '_bulk'
        }
      },
      update: {
        method: 'PUT',
        params: {
          id: '@id'
        }
      },
      "delete": {
        method: 'DELETE',
        params: {
          id: '@id'
        }
      }
    });
  };
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.perspectiveFactory
 * @description
 * # perspectiveFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.energy').factory('perspectiveFactory', ["ENERGY_URL", "$resource", function (ENERGY_URL, $resource) {
  return $resource(ENERGY_URL + '/api/perspective/:verb/:id/:param1/:param2/:param3', {}, {
    getHeaders: {
      method: 'GET',
      isArray: false,
      params: {
        verb: 'headers'
      }
    },
    createPerspective: {
      method: 'POST',
      isArray: false,
      params: {
        verb: 'create'
      }
    },
    generatePerspective: {
      method: 'POST',
      isArray: false,
      params: {
        verb: 'generate'
      }
    },
    deletePerspective: {
      method: 'DELETE',
      params: {
        verb: '_delete'
      }
    }
  });
}]);
"use strict";

// Default:
// {
//   'get':    {method:'GET'},
//   'save':   {method:'POST'},
//   'query':  {method:'GET', isArray:true},
//   'remove': {method:'DELETE'},
//   'delete': {method:'DELETE'}
// }
angular.module('emma.energy').factory('priceListFactory', ["ENERGY_URL", "$resource", function (ENERGY_URL, $resource) {
  return $resource(ENERGY_URL + '/api/pricelist/:type/:verb/:id/:param1/:param2/:param3', {}, {
    findAllList: {
      method: 'GET',
      isArray: true,
      params: {
        verb: '_list'
      }
    },
    findAll: {
      method: 'POST',
      params: {
        verb: '_headers'
      }
    },
    findAllByVector: {
      method: 'POST',
      params: {
        verb: '_headers'
      }
    },
    lookup: {
      method: 'GET',
      params: {
        verb: '_lookup'
      }
    },
    byUUID: {
      method: 'GET',
      params: {
        type: 'header',
        verb: '_uuid'
      }
    },
    byHeader: {
      method: 'GET',
      params: {
        verb: '_byheader'
      }
    },
    bulk: {
      method: 'POST',
      params: {
        verb: '_bulk'
      }
    },
    create: {
      method: 'POST'
    },
    bulkUpdate: {
      method: 'PUT',
      params: {
        verb: '_bulk'
      }
    },
    bulkResolve: {
      method: 'POST',
      params: {
        verb: '_bulk',
        param1: '_resolve'
      }
    },
    "delete": {
      method: 'DELETE',
      params: {
        id: '@id'
      }
    }
  });
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.reportFactory
 * @description
 * # reportFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.energy').factory('reportFactory', ["ENERGY_URL", "$resource", function (ENERGY_URL, $resource) {
  return $resource(ENERGY_URL + '/api/report/:type/:method', {}, {
    dayDegreeTab: {
      method: 'POST',
      isArray: false,
      params: {
        type: '_daydegree',
        method: '_tab'
      }
    }
  });
}]);
"use strict";

// Default:
// {
//   'get':    {method:'GET'},
//   'save':   {method:'POST'},
//   'query':  {method:'GET', isArray:true},
//   'remove': {method:'DELETE'},
//   'delete': {method:'DELETE'}
// }
angular.module('emma.energy').factory('simulationFactory', ["ENERGY_URL", "$resource", function (ENERGY_URL, $resource) {
  return $resource(ENERGY_URL + '/api/list/simulation/:verb/:id/:param1/:param2/:param3/:param4/:param5/:param6', {}, {
    get: {
      method: 'GET',
      isArray: false
    },
    list: {
      method: 'GET',
      isArray: false
    },
    params: {
      method: 'GET',
      isArray: false,
      params: {
        verb: '_params'
      }
    },
    simulate: {
      method: 'POST',
      isArray: false,
      params: {
        verb: '_simulate'
      }
    },
    binomia: {
      method: 'POST',
      isArray: false,
      params: {
        verb: '_binomia'
      }
    },
    spread: {
      method: 'GET',
      isArray: false,
      params: {
        verb: '_params',
        param1: 'spread'
      }
    },
    save: {
      method: 'POST',
      isArray: false,
      params: {
        verb: '_save'
      }
    },
    "delete": {
      method: 'DELETE',
      isArray: false,
      params: {
        id: '@id'
      }
    }
  });
}]);
"use strict";

// Default:
// {
//   'get':    {method:'GET'},
//   'save':   {method:'POST'},
//   'query':  {method:'GET', isArray:true},
//   'remove': {method:'DELETE'},
//   'delete': {method:'DELETE'}
// }
angular.module('emma.energy').factory('voltageClassFactory', ["ENERGY_URL", "$resource", function (ENERGY_URL, $resource) {
  return $resource(ENERGY_URL + '/api/voltageclass/:verb/:id/:param1/:param2/:param3', {}, {
    show: {
      method: 'GET'
    }
  });
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.zonaTermicaFactory
 * @description
 * # zonaTermicaFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.energy').factory('zonaClimaticaFactory', ["ENERGY_URL", "$resource", function (ENERGY_URL, $resource) {
  return $resource(ENERGY_URL + '/api/zonaclimatica/:verb/:id/:param1/:param2/:param3', {}, {
    findByZonaTermica: {
      method: 'GET',
      params: {
        verb: 'findByZonaTermica',
        id: '@save'
      }
    }
  });
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.zonaTermicaFactory
 * @description
 * # zonaTermicaFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.energy').factory('zonaTermicaFactory', ["ENERGY_URL", "$resource", function (ENERGY_URL, $resource) {
  return $resource(ENERGY_URL + '/api/zonatermica/:verb/:id/:param1/:param2/:param3', {}, {
    query: {
      method: 'GET',
      isArray: false
    },
    search: {
      method: 'POST',
      isArray: false,
      params: {
        verb: '_search'
      }
    },
    fetchAll: {
      method: 'POST',
      isArray: true,
      params: {
        verb: '_search',
        res_mode: 'list'
      }
    },
    show: {
      method: 'GET',
      params: {
        id: '@id'
      }
    },
    byID: {
      method: 'GET',
      params: {
        verb: '_id'
      }
    },
    byUUID: {
      method: 'GET',
      params: {
        verb: '_uuid',
        param1: '_current'
      }
    },
    byCode: {
      method: 'GET',
      params: {
        verb: '_code',
        id: '@id'
      }
    },
    create: {
      method: 'POST'
    },
    update: {
      method: 'PUT',
      params: {
        id: '@id'
      }
    },
    "delete": {
      method: 'DELETE',
      params: {
        id: '@id'
      }
    },
    zonaTermicaWithDefaults: {
      method: 'POST',
      params: {
        verb: 'zonaTermicaWithDefaults',
        id: '@id'
      }
    },
    tempProvinciaToZonaTermica: {
      method: 'POST',
      params: {
        verb: 'tempProvinciaToZonaTermica',
        id: '@save'
      }
    },
    tempProvinciaToZonaTermicaAll: {
      method: 'GET',
      params: {
        verb: 'tempProvinciaToZonaTermica',
        id: '_all',
        param1: '@save'
      }
    },
    bulkResolve: {
      method: 'POST',
      isArray: false,
      params: {
        verb: '_bulk',
        param1: '_resolve'
      }
    },
    bulk: {
      method: 'POST',
      isArray: false,
      params: {
        verb: '_bulk'
      }
    }
  });
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:MeasurementCtrl
 * @description
 * # MeasurementCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/measurement', {
    templateUrl: 'energy/measurements/measurement.html',
    controller: 'MeasurementCtrl'
  });
}]).controller('MeasurementCtrl', ["$scope", "$log", "$interval", "wsfactory", function ($scope, $log, $interval, wsfactory) {
  $scope.dayCount = 0;
  $scope.monthCount = 120;
  $scope.graphData = [];
  $scope.testWS = wsfactory;
  $scope.runningDisabled = false;
  $scope.stopDisabled = true;
  $scope.resetDisabled = true;
  var stop;
  $scope.fight = function () {
    // Don't start a new fight if we are already fighting
    if (angular.isDefined(stop)) return;
    $scope.runningDisabled = true;
    $scope.stopDisabled = false;
    $scope.resetDisabled = false;
    stop = $interval(function () {
      $scope.setData();
      $scope.dayCount++;
      $scope.monthCount++;
      //$scope.testWS.get();
    }, 100);
  };
  $scope.stopFight = function () {
    if (angular.isDefined(stop)) {
      $interval.cancel(stop);
      stop = undefined;
      $scope.runningDisabled = false;
      $scope.stopDisabled = true;
      $scope.resetDisabled = false;
    }
  };
  $scope.resetFight = function () {
    $scope.dayCount = 0;
    $scope.monthCount = 120;
    if ($scope.stopDisabled) {
      $scope.resetDisabled = true;
    }
  };
  $scope.$on('$destroy', function () {
    // Make sure that the interval is destroyed too
    $scope.stopFight();
  });
  $scope.setData = function () {
    var date = new Date();
    var grpDT = {
      'date': date
    };
    grpDT['T_Esterna'] = '' + Math.floor(Math.random() * 45 + 1);
    grpDT['T_Mandata'] = '' + Math.floor(Math.random() * 45 + 1);
    $scope.graphData.push(grpDT);
    if (100 < $scope.graphData.length) {
      $scope.graphData.splice(0, 1);
    }
    $log.info(JSON.stringify($scope.graphData));
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:OverridedatesCtrl
 * @description
 * # OverridedatesCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/overridedates', {
    templateUrl: 'energy/overridedates/overridedates.html',
    controller: 'OverridedatesCtrl'
  });
}]).controller('OverridedatesCtrl', ["$scope", "heatingSeasonFactory", "zonaClimaticaFactory", "authFactory", "uiGridConstants", "errorService", "toaster", function ($scope, heatingSeasonFactory, zonaClimaticaFactory, authFactory, uiGridConstants, errorService, toaster) {
  var currentCommission = authFactory.getAuthData().info.commissions.current;
  $scope.limit = 65536;
  $scope.record = {
    type_id: {
      code: 'zonatermica',
      UUID: 'zonatermica',
      description: 'Zona Termica'
    }
  };
  $scope.model = {};
  $scope.date = '';
  $scope.dates = {
    "in": '',
    out: ''
  };
  $scope.datesList = [];
  $scope.defaultDateBegin = '';
  $scope.defaultDateEnd = '';
  $scope.zonaClimatica = {};
  $scope.gridDates = {
    enableSorting: true,
    enableGridMenu: false,
    exporterMenuPdf: false,
    data: 'datesList',
    columnDefs: [{
      displayName: '',
      field: 'id',
      width: 40,
      enableCellEdit: true,
      enableFiltering: false,
      enableSorting: false,
      cellTemplate: '<div class="ui-grid-cell-contents"><button type="button" class="btn btn-xs btn-primary" ng-click="grid.appScope.delete(row.entity.model.code)" ng-disabled="grid.appScope.isDeletePermAllowed()===false"><i class="fa fa-trash"></i></button></div>'
    }, {
      displayName: 'Data',
      field: 'model.date',
      type: 'date',
      cellFilter: 'date:"dd-MM-yyyy"',
      sort: {
        direction: uiGridConstants.ASC,
        priority: 0
      }
    }, {
      displayName: 'Tipo di data',
      field: 'model.mode',
      sort: {
        direction: uiGridConstants.ASC
      },
      cellTemplate: '<div class="ui-grid-cell-contents"><div ng-if="row.entity.model.mode == \'begin\'">Inizio</div> <div ng-if="row.entity.model.mode == \'end\'">Fine</div></div>'
    }]
  };
  $scope.dateOptions = {
    formatYear: 'yyyy'
  };
  function dateIsDefined(date) {
    return date != '' && date != undefined && date != null;
  }
  $scope.addDate = function (date, mode) {
    if (angular.isDefined($scope.record.record_id) && angular.isDefined($scope.record.type_id) && dateIsDefined(date)) {
      var newCode = true;
      var code = currentCommission.code + '_' + $scope.record.type_id.code + '_' + $scope.record.record_id.code + '_' + mode + '_' + date.getFullYear();
      $scope.model = {
        code: code,
        date: date,
        mode: mode,
        record_id: $scope.record.record_id
      };
      angular.forEach($scope.datesList, function (item) {
        if (code == item.model.code) {
          newCode = false;
        }
      });
      if (newCode == true) {
        heatingSeasonFactory.create($scope.model).$promise.then(function () {
          $scope.refreshGrid();
        });
      } else {
        toaster.pop('error', 'Errore', 'Sovrascrittura già inserita: eliminare prima la data presente, poi procedere con un nuovo inserimento');
      }
    } else {
      toaster.pop('error', 'Errore', 'Errore inserimento parametri');
    }
  };
  $scope["delete"] = function (idToDelete) {
    heatingSeasonFactory["delete"]({
      zt: idToDelete
    }).$promise.then(function () {
      $scope.refreshGrid();
    });
  };
  $scope.$watchGroup(['record.type_id', 'record.record_id'], function (newValue) {
    if (angular.isDefined(newValue[0]) && angular.isDefined(newValue[1])) {
      var type = newValue[0].UUID;
      var record = newValue[1].UUID;
      heatingSeasonFactory.get({
        type: type,
        zt: record
      }).$promise.then(function (data) {
        if (data.result.list) {
          createDatesList(data.result.list);
        }
      });
      zonaClimaticaFactory.findByZonaTermica({
        id: newValue[1].UUID
      }).$promise.then(function (data) {
        $scope.zonaClimatica = data;
      });
    } else {
      $scope.datesList = [];
      $scope.zonaClimatica = {};
    }
    unselectRecord();
  });
  $scope.refreshGrid = function () {
    var type = $scope.record.type_id.UUID;
    var record = $scope.record.record_id.UUID;
    heatingSeasonFactory.get({
      type: type,
      zt: record
    }).$promise.then(function (data) {
      if (data.result.list) {
        createDatesList(data.result.list);
      }
    });
    unselectRecord();
  };
  function unselectRecord() {
    /* bisognerebbe riuscire a pulire anche le 2 lookup */
    $scope.dates["in"] = angular.copy('');
    $scope.dates.out = angular.copy('');
  }
  function createDatesList(list) {
    /* metodo per costruire i dati della grid:
    *  gli viene passata una list con tutti gli override delle date di inizio/fine che son state inserite
    *  e sulla base di queste organizza delle righe in maniera ordinata scaricando per ogni anno dove ci sono degli override
    *  le date di inizio e di fine della stagione termica */
    $scope.datesList = [];
    angular.forEach(list, function (item) {
      $scope.datesList.push(item);
    });
  }

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'heatingseason';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:PerspectiveCtrl
 * @description
 * # PerspectiveCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/perspective', {
    templateUrl: 'energy/perspective/perspective.html',
    controller: 'PerspectiveCtrl',
    controllerAs: 'perspective'
  });
}]).controller('PerspectiveCtrl', ["$scope", "$filter", "$log", "dialogService", "errorService", "consumptionAnalysisFactory", "perspectiveFactory", function ($scope, $filter, $log, dialogService, errorService, consumptionAnalysisFactory, perspectiveFactory) {
  $scope.searchFilter = {
    year: (1 + parseInt($filter('date')(new Date(), 'yyyy'))).toString()
  };
  $scope.percent = 10;
  $scope.step = 1;
  $scope.goToStep = function (index) {
    $scope.step = index;
  };
  $scope.perspective = {};
  $scope.seasonFactor = {};
  $scope.techFactor = {
    0: 0.0,
    1: 0.0,
    2: 0.0,
    3: 0.0,
    4: 0.0,
    5: 0.0,
    6: 0.0,
    7: 0.0,
    8: 0.0,
    9: 0.0,
    10: 0.0,
    11: 0.0
  };
  $scope.generatePerspectiveForm = false;
  $scope.perspectiveTemplate = {
    template: [{
      code: "PT001",
      description: "Budget anno precedente"
    }, {
      code: "PT002",
      description: "Consuntivo anno precedente"
    }, {
      code: "PT003",
      description: "Media Consuntivi anni precedenti"
    }, {
      code: "PT004",
      description: "Stagionalizzazione con regressione lineare"
    }]
  };
  $scope.availablePerspectiveCodes = [];
  $scope.gridListOptions = {
    enableSorting: true,
    enableGridMenu: true,
    exporterCsvColumnSeparator: ';',
    exporterSuppressColumns: ['view', 'delete'],
    exporterMenuPdf: false,
    exporterMenuCsv: true,
    enableFiltering: false,
    data: 'availablePerspectiveCodes',
    columnDefs: [{
      displayName: '',
      field: 'view',
      enableFiltering: false,
      width: 40,
      cellTemplate: '<div class="ui-grid-cell-contents" style="text-content: center;"><button type="button" class="btn btn-xs btn-primary" ng-click="grid.appScope.getPerspective(row.entity)"><i class="fa fa-search"></i></button></div>'
    }, {
      displayName: 'Codice',
      field: 'code',
      width: 400,
      cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.model.code}}</div>'
    }, {
      displayName: 'Descrizione',
      field: 'description',
      cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.model.description}}</div>'
    }, {
      displayName: 'Anno',
      field: 'year',
      width: 100,
      cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.model.year}}</div>'
    }, {
      displayName: '',
      field: 'delete',
      enableFiltering: false,
      width: 40,
      cellTemplate: '<div class="ui-grid-cell-contents" style="text-content: center;"><a ng-confirm-message="Confermare?" ng-confirm-click="grid.appScope.delete(row.entity)" ng-confirm-condition=true class="btn btn-xs btn-danger"><span class="glyphicon glyphicon-trash"></span></a></div>'
    }]
  };

  /***** Data ready events *****/

  var DATA_READY_EVENT = 'dataReady';
  $scope.$on(DATA_READY_EVENT, function (event) {
    setTimeout(function () {
      // evita che venga richiamato troppo velocemente (altrimenti si accavalla a showLoadingMessage)
      dialogService.hideLoadingMessage();
    }, 200);
  });
  $scope.budget = {
    code: undefined,
    description: undefined,
    list: [],
    totalConsumption: 0,
    season: 0,
    totalBudget: 0,
    deltaSeason: 0,
    deltaTech: 0
  };
  $scope.graphData = [];
  $scope.graphDataCumulative = [];
  $scope.backToPerspective = function () {
    $scope.generatePerspectiveForm = false;
  };
  $scope.getPerspective = function (perspective) {
    $scope.isCollapsed = true;
    $scope.perspective = perspective.model;
    var prevYear = perspective.model.year - 1;
    //CONSUMI E BUDGET
    var query = {
      frequency: 'MONTHLY',
      from: prevYear + '-01-01',
      to: prevYear + '-12-31'
    };
    var promise = consumptionAnalysisFactory().getConsumptionAnalysis(query).$promise;
    //var promise = baseFactory('consumptionanalysis/get').search(query).$promise;
    promise.then(function (consAnResp) {
      if (errorService.handleError(consAnResp)) {
        var budget = {},
          graphData = [],
          graphDataCumulative = [];
        budget.list = consAnResp.list;
        angular.forEach(consAnResp.list, function (record, idx) {
          var grpDT = {
            'date': Date.parse(record.date)
          };
          grpDT['consumi ' + $filter('number')(consAnResp.consumption, 3)] = '' + record.consumption;
          grpDT['budget ' + $filter('number')(consAnResp.budget, 3)] = '' + record.budget;
          grpDT['stagionalita ' + $filter('number')(consAnResp.season, 3)] = '' + record.season;
          graphData.push(grpDT);
          var grpDTCumulative = {
            'date': Date.parse(record.date)
          };
          grpDTCumulative['consumi ' + $filter('number')(consAnResp.consumption, 3)] = '' + record.cumulativeConsumption;
          grpDTCumulative['budget ' + $filter('number')(consAnResp.budget, 3)] = '' + record.cumulativeBudget;
          graphDataCumulative.push(grpDTCumulative);
        });
        console.log(consAnResp);
        budget.totalBudget = consAnResp.budget;
        budget.totalConsumption = consAnResp.consumption;
        budget.totalConsumptionStd = consAnResp.consumptionStd;
        budget.budgetComparison = consAnResp.budget ? (consAnResp.consumptionStd - consAnResp.budget) / consAnResp.budget * 100 : 0;
        budget.season = consAnResp.season;
        budget.deltaSeason = consAnResp.deltaSeason;
        budget.deltaTech = consAnResp.deltaTech;
        budget.percentage = consAnResp.percentage;
        budget.code = consAnResp.budgetCode;
        budget.description = consAnResp.budgetDescription;
        $scope.graphData = graphData;
        $scope.graphDataCumulative = graphDataCumulative;
        $scope.budget = budget;
        $scope.perspectiveComputation($scope.budget);
      }
    });
  };
  $scope.perspectiveComputation = function (dataset, seasonFactor) {
    $scope.graphPrev = [];
    $scope.perspective.totalOldBudget = dataset.totalBudget;
    $scope.perspective.totalBudget = dataset.totalConsumption;
    $scope.perspective.deltaTech = dataset.deltaTech;
    $scope.perspective.season = 0;
    $scope.perspective.deltaSeason = 0;
    $scope.perspective.list = [];
    angular.forEach(dataset.list, function (item) {
      var newItem = {};
      var prevDate = new Date(item.date);
      prevDate.setYear($scope.perspective.year);
      newItem.date = prevDate;
      newItem.oldBudget = item.budget;
      newItem.budget = item.consumption;
      if (seasonFactor) {
        $scope.seasonFactor = seasonFactor;
      } else {
        var sf = 0;
        if (item.historicalDD !== 0) {
          sf = sf - item.realDD / item.historicalDD;
        }
        $scope.seasonFactor[prevDate.getMonth()] = sf;
      }
      newItem.season = $scope.seasonFactor[prevDate.getMonth()] * item.consumption;
      newItem.perspective = newItem.budget + newItem.season;
      if ($scope.techFactor[prevDate.getMonth()]) {
        newItem.perspective = newItem.perspective + $scope.techFactor[prevDate.getMonth()] * item.deltaTech;
      }
      newItem.deltaSeason = 0 + (newItem.season - newItem.budget) / 100;
      $scope.perspective.season = $scope.perspective.season + newItem.season;
      newItem.deltaTech = item.deltaTech;
      this.push(newItem);
      var grpDT = {
        'date': prevDate,
        'previsione': newItem.budget,
        'fattore stag.': newItem.season,
        'prospettiva': newItem.perspective
      };
      $scope.graphPrev.push(grpDT);
    }, $scope.perspective.list);
    $scope.perspective.deltaSeason = $scope.perspective.season / $scope.perspective.totalBudget * 100;
    $scope.perspective.totalPerspective = $scope.perspective.season + $scope.perspective.totalBudget;
  };
  $scope.unselect = function () {
    $scope.perspective = {};
    $scope.isCollapsed = false;
    $scope.loadPerspectiveList();
  };
  $scope.toggleNewPerspective = function () {
    $scope.generatePerspectiveForm = !$scope.generatePerspectiveForm;
  };
  $scope.loadPerspectiveList = function () {
    var year = $scope.searchFilter.year;
    getAvailablePerspectiveCodes(year).then(function (list) {
      $scope.availablePerspectiveCodes = list;
    });
  };
  function getAvailablePerspectiveCodes(year) {
    dialogService.showLoadingMessage('Caricamento prospettive disponibili...');
    var query = {};
    if (year) {
      query.year = year;
    }
    return perspectiveFactory.getHeaders(query).$promise.then(function (response) {
      if (errorService.handleError(response)) {
        var list = [];
        if (response.hasOwnProperty('list') && response.list.length) {
          list = response.list;
        }
        $scope.$broadcast(DATA_READY_EVENT, 'perspective');
        return list;
      } else {
        $scope.$broadcast(DATA_READY_EVENT, 'perspective');
        toaster.pop('error', 'Errore', 'Errore durante il recupero delle prospettive');
      }
    });
  }
  $scope.createPerspective = function () {
    perspectiveFactory.createPerspective($scope.perspective).$promise.then(function () {
      $scope.toggleNewPerspective();
      $scope.loadPerspectiveList();
    });
  };
  $scope.generate = function () {
    perspectiveFactory.generatePerspective($scope.perspective).$promise.then(function () {
      $scope.unselect();
    });
  };
  $scope["delete"] = function (item) {
    var obj = {
      uuid: item.UUID,
      year: item.model.year
    };
    perspectiveFactory.deletePerspective(obj).$promise.then(function () {
      $scope.unselect();
    });
  };
  $scope.loadPerspectiveList();
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.componenttypefactory
 * @description
 * # componenttypefactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.energy').factory('componenttypefactory', ["uiGridConstants", function (uiGridConstants) {
  function getFilters(type) {
    var filters;
    switch (type) {
      case 'fascia':
        filters = [{
          //term: '',
          type: uiGridConstants.filter.SELECT,
          selectOptions: [{
            value: 'F1',
            label: 'F1'
          }, {
            value: 'F2',
            label: 'F2'
          }, {
            value: 'F3',
            label: 'F3'
          }, {
            value: 'F23',
            label: 'F23'
          }]
        }, {
          placeholder: 'Testo libero...'
        }];
        break;
      case 'gt':
        filters = [{
          condition: uiGridConstants.filter.GREATER_THAN,
          placeholder: 'maggiore di...'
        }];
        break;
      case 'lt':
        filters = [{
          condition: uiGridConstants.filter.LESS_THAN,
          placeholder: 'minore di...'
        }];
        break;
      case 'lgt':
        filters = [{
          condition: uiGridConstants.filter.GREATER_THAN,
          placeholder: 'maggiore di...'
        }, {
          condition: uiGridConstants.filter.LESS_THAN,
          placeholder: 'minore di...'
        }];
        break;
      default:
        filters = {
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: 'Testo libero...'
        };
    }
    return filters;
  }
  function isCellEditable(scope) {
    return !scope.row.entity.wrapper || !scope.row.entity.wrapper.UUID;
  }
  var componentTypesMap = [];
  componentTypesMap['ee'] = [];
  componentTypesMap['ee']['sv'] = [];
  componentTypesMap['ee']['sr'] = [];
  componentTypesMap['ee']['og'] = [];
  componentTypesMap['ee']['add'] = [];
  componentTypesMap['gas'] = [];
  componentTypesMap['gas']['sv'] = [];
  componentTypesMap['gas']['sr'] = [];
  componentTypesMap['gas']['add'] = [];
  componentTypesMap['gas']['altro'] = [];

  // Energia Elettrica (ee)
  // Servizi di Vendita (sv)
  componentTypesMap['ee']['sv'].push({
    code: 'PED_F',
    description: 'Servizi di vendita - Energia e Dispacciamento',
    columnDefs: [{
      displayName: 'Data',
      field: 'date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Fascia',
      field: 'fascia',
      filters: getFilters('fascia'),
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'PEDF,a.1',
      field: 'pedf_a1',
      type: 'number',
      filters: getFilters('lgt'),
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'PEDF,a.2',
      field: 'pedf_a2',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'PEDF,b',
      field: 'pedf_b',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'PEDF,c',
      field: 'pedf_c',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/kWh":3'
    }]
  });
  componentTypesMap['ee']['sv'].push({
    code: 'PED_M',
    description: 'Servizi di vendita - Energia e Dispacciamento',
    columnDefs: [{
      displayName: 'Data',
      field: 'date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Utenza',
      field: 'utenza',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'PEDM',
      field: 'pedm',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/kWh":3'
    }]
  });
  componentTypesMap['ee']['sv'].push({
    code: 'PCV',
    description: 'Servizi di vendita - Commercializzazione e Vendita',
    columnDefs: [{
      displayName: 'Data',
      field: 'date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Utenza',
      field: 'utenza',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'PCV_fissa',
      field: 'pcv_fissa',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/POD/Anno":3'
    }, {
      displayName: 'PCV_var',
      field: 'pcv_var',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/kWh":3'
    }]
  });
  componentTypesMap['ee']['sv'].push({
    code: 'PPE',
    description: 'Servizi di vendita - Componenti di Perequazione',
    columnDefs: [{
      displayName: 'Data',
      field: 'date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Utenza',
      field: 'utenza',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'PPE',
      field: 'ppe',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/kWh":3'
    }]
  });
  componentTypesMap['ee']['sv'].push({
    code: 'DISPbt_fissa',
    description: 'Servizi di vendita - Dispacciamento',
    columnDefs: [{
      displayName: 'Data',
      field: 'date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Utenza',
      field: 'utenza',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'DISPbt_fissa',
      type: 'number',
      field: 'dispbt_fissa',
      enableFiltering: false,
      cellFilter: 'currency:"c€/POD/Anno":3'
    }]
  });
  componentTypesMap['ee']['sv'].push({
    code: 'DISPbt_var',
    description: 'Servizi di vendita - Dispacciamento',
    columnDefs: [{
      displayName: 'Data',
      field: 'date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Scaglione',
      field: 'scaglione',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Lim. inf.',
      field: 'lim_inf',
      type: 'number',
      cellFilter: 'currency:"kWh":0'
    }, {
      displayName: 'Lim. sup.',
      field: 'lim_sup',
      type: 'number',
      cellFilter: 'currency:"kWh":0'
    }, {
      displayName: 'DISPbtvar,a1',
      field: 'dispbt_var_a1',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'DISPbtvar,a2',
      field: 'dispbt_var_a2',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'DISPbtvar,b',
      field: 'dispbt_var_b',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'DISPbtvar,c',
      field: 'dispbt_var_c',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/kWh":3'
    }]
  });
  componentTypesMap['ee']['sv'].push({
    code: 'Perdite',
    description: 'Servizi di vendita - Fattore di perdita',
    columnDefs: [{
      displayName: 'Data',
      field: 'date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Tipo Utenza',
      field: 'tipo_utenza_id',
      lookup: 'classificazionetensione',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Tensione',
      field: 'tensione',
      type: 'number',
      cellFilter: 'currency:"kV":0',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Fattore',
      field: 'fattore',
      type: 'number',
      cellFilter: 'percentage:1'
    }]
  });

  // Servizi di Rete (sr)
  componentTypesMap['ee']['sr'].push({
    code: 'DIST',
    description: 'Servizi di rete - Distribuzione',
    columnDefs: [{
      displayName: 'Data',
      field: 'date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Utenza',
      field: 'utenza',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'DISE',
      field: 'dise',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'DISP',
      field: 'disp',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'DIS_fissa',
      field: 'dis_fissa',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/POD/Anno":3'
    }]
  });
  componentTypesMap['ee']['sr'].push({
    code: 'TRAS',
    description: 'Servizi di rete - Trasporto (utenze non domestiche)',
    columnDefs: [{
      displayName: 'Data',
      field: 'date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Utenza',
      field: 'utenza',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'TRASE',
      field: 'trase',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'TRASP',
      field: 'trasp',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/kWh":3'
    }]
  });
  componentTypesMap['ee']['sr'].push({
    code: 'MIS',
    description: 'Servizi di rete - Misura (utenze non domestiche)',
    columnDefs: [{
      displayName: 'Data',
      field: 'date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Utenza',
      field: 'utenza',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'MISE',
      field: 'mise',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'MISPOD',
      field: 'mispod',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/POD/Anno":3'
    }]
  });
  componentTypesMap['ee']['sr'].push({
    code: 'Di',
    description: 'Servizi di rete - Distribuzione, trasporto e misura (utenze domestiche BT)',
    columnDefs: [{
      displayName: 'Data',
      field: 'date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Utenza',
      field: 'utenza',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Scaglione',
      field: 'scaglione',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Lim. inf.',
      field: 'lim_inf',
      type: 'number',
      cellFilter: 'currency:"kWh":0'
    }, {
      displayName: 'Lim. sup.',
      field: 'lim_sup',
      type: 'number',
      cellFilter: 'currency:"kWh":0'
    }, {
      displayName: 'Di,E',
      field: 'di_e',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'Di,P',
      field: 'di_p',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'Di,POD',
      field: 'di_pod',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/POD/Anno":3'
    }]
  });

  // Oneri Generali (og)
  componentTypesMap['ee']['og'].push({
    code: 'Oneri_UD',
    description: 'Oneri generali - Componenti A, UC e MCT (utenti domestici)',
    columnDefs: [{
      displayName: 'Data',
      field: 'date',
      minWidth: 80,
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Utenza',
      field: 'utenza',
      minWidth: 80,
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Scaglione',
      field: 'scaglione',
      minWidth: 80,
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Lim. inf.',
      field: 'lim_inf',
      type: 'number',
      cellFilter: 'currency: "kWh"',
      minWidth: 80
    }, {
      displayName: 'Lim. sup.',
      field: 'lim_sup',
      type: 'number',
      cellFilter: 'currency: "kWh"',
      minWidth: 80
    }, {
      displayName: 'A2POD',
      field: 'a2pod',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/POD/Anno":3'
    }, {
      displayName: 'A3POD',
      field: 'a3pod',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/POD/Anno":3'
    }, {
      displayName: 'A4POD',
      field: 'a4pod',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/POD/Anno":3'
    }, {
      displayName: 'A5POD',
      field: 'a5pod',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/POD/Anno":3'
    }, {
      displayName: 'ASPOD',
      field: 'aspod',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/POD/Anno":3'
    }, {
      displayName: 'ATOT,POD',
      field: 'atot_pod',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/POD/Anno":3'
    }, {
      displayName: 'A2E',
      field: 'a2e',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'A3E',
      field: 'a3e',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'A4E',
      field: 'a4e',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'A5E',
      field: 'a5e',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'ASE',
      field: 'ase',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'ATOT,E',
      field: 'atot_e',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'UC3POD',
      field: 'uc3pod',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/POD/Anno":3'
    }, {
      displayName: 'UC4POD',
      field: 'uc4pod',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/POD/Anno":3'
    }, {
      displayName: 'UC6POD',
      field: 'uc6pod',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/POD/Anno":3'
    }, {
      displayName: 'UC7POD',
      field: 'uc7pod',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/POD/Anno":3'
    }, {
      displayName: 'UCTOT,POD',
      field: 'uctot_pod',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/POD/Anno":3'
    }, {
      displayName: 'UC3E',
      field: 'uc3e',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'UC4E',
      field: 'uc4e',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'UC6E',
      field: 'uc6e',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'UC7E',
      field: 'uc7e',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'UCTOT,E',
      field: 'uctot_e',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'UC6P',
      field: 'uc6p',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'UCTOT,P',
      field: 'uctot_p',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'MCTPOD',
      field: 'mctpod',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/POD/Anno":3'
    }, {
      displayName: 'MCTE',
      field: 'mcte',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'OGPOD',
      field: 'ogpod',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/POD/Anno":3'
    }, {
      displayName: 'OGP',
      field: 'ogp',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'OGE',
      field: 'oge',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }]
  });
  componentTypesMap['ee']['og'].push({
    code: 'Oneri_UND',
    description: 'Oneri generali - Componenti A, UC e MCT (utenti non domestici)',
    columnDefs: [{
      displayName: 'Data',
      field: 'date',
      minWidth: 80,
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Utenza',
      field: 'utenza',
      minWidth: 80,
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'A2POD',
      field: 'a2pod',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/POD/Anno":3'
    }, {
      displayName: 'A3POD',
      field: 'a3pod',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/POD/Anno":3'
    }, {
      displayName: 'A4POD',
      field: 'a4pod',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/POD/Anno":3'
    }, {
      displayName: 'A5POD',
      field: 'a5pod',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/POD/Anno":3'
    }, {
      displayName: 'ASPOD',
      field: 'aspod',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/POD/Anno":3'
    }, {
      displayName: 'ATOT,POD',
      field: 'atot_pod',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/POD/Anno":3'
    }, {
      displayName: 'A2E',
      field: 'a2e',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'A3E',
      field: 'a3e',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'A4E',
      field: 'a4e',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'A5E',
      field: 'a5e',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'ASE',
      field: 'ase',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'AE',
      field: 'ae',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'ATOT,E',
      field: 'atot_e',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'UC3POD',
      field: 'uc3pod',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/POD/Anno":3'
    }, {
      displayName: 'UC4POD',
      field: 'uc4pod',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/POD/Anno":3'
    }, {
      displayName: 'UC6POD',
      field: 'uc6pod',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/POD/Anno":3'
    }, {
      displayName: 'UC7POD',
      field: 'uc7pod',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/POD/Anno":3'
    }, {
      displayName: 'UCTOT,POD',
      field: 'uctot_pod',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/POD/Anno":3'
    }, {
      displayName: 'UC3E',
      field: 'uc3e',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'UC4E',
      field: 'uc4e',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'UC6E',
      field: 'uc6e',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'UC7E',
      field: 'uc7e',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'UCTOT,E',
      field: 'uctot_e',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'UC6P',
      field: 'uc6p',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'UCTOT,P',
      field: 'uctot_p',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'MCTPOD',
      field: 'mctpod',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/POD/Anno":3'
    }, {
      displayName: 'MCTE',
      field: 'mcte',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'OGPOD',
      field: 'ogpod',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/POD/Anno":3'
    }, {
      displayName: 'OGP',
      field: 'ogp',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'OGE',
      field: 'oge',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/kWh":3'
    }]
  });

  // Addizionali (add)
  componentTypesMap['ee']['add'].push({
    code: 'EE_Addizionale',
    description: 'Addizionale provinciale',
    columnDefs: [{
      displayName: 'Data',
      field: 'date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Provincia',
      field: 'provincia_id',
      lookup: 'provincia',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'addizionale',
      field: 'addizionale',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/kWh":3'
    }]
  });
  componentTypesMap['ee']['add'].push({
    code: 'EE_Accise',
    description: 'Accise',
    columnDefs: [{
      displayName: 'Data',
      field: 'date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Scaglione',
      field: 'scaglione',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Lim. inf.',
      field: 'lim_inf',
      type: 'number',
      cellFilter: 'currency:"kWh":0'
    }, {
      displayName: 'Lim. sup.',
      field: 'lim_sup',
      type: 'number',
      cellFilter: 'currency:"kWh":0'
    }, {
      displayName: 'AccisaCIV',
      field: 'accisaciv',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'AccisaIND,varINF.1200',
      field: 'accisaind_varinf_1200',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'AccisaIND,varSUP.1200',
      field: 'accisaind_varsup_1200',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/kWh":3'
    }, {
      displayName: 'AccisaIND,meseSUP.1200',
      field: 'accisaind_mesesup_1200',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/Mese":3'
    }]
  });

  // Gas (gas)
  // Servizi di Vendita (sv)
  componentTypesMap['gas']['sv'].push({
    code: 'QVD_fissa',
    description: 'Servizi di vendita - Quota fissa di vendita',
    columnDefs: [{
      displayName: 'Data',
      field: 'date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Tipo cliente',
      field: 'tipo_cliente_id',
      lookup: 'tipologiacliente',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'QVD fissa',
      field: 'qvd_fissa',
      type: 'number',
      cellFilter: 'currency:"€/PDR/Anno":3'
    }]
  });
  componentTypesMap['gas']['sv'].push({
    code: 'QVD_var',
    description: 'Servizi di vendita - Quota vendita al dettaglio',
    columnDefs: [{
      displayName: 'Data',
      field: 'date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Scaglione',
      field: 'scaglione',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Lim. inf.',
      field: 'lim_inf',
      type: 'number',
      cellFilter: 'currency:"SMC":0'
    }, {
      displayName: 'Lim. sup.',
      field: 'lim_sup',
      type: 'number',
      cellFilter: 'currency:"SMC":0'
    }, {
      displayName: 'QVD var',
      field: 'qvd_var',
      type: 'number',
      cellFilter: 'currency:"c€/SMC":3'
    }]
  });
  componentTypesMap['gas']['sv'].push({
    code: 'CCI_CMEM',
    description: 'Commercializzazione all\'ingrosso',
    columnDefs: [{
      displayName: 'Data',
      field: 'date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      minWidth: 80,
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Indice IT',
      field: 'indice_it',
      type: 'number',
      enableFiltering: false,
      minWidth: 80
    }, {
      displayName: 'at',
      field: 'at',
      type: 'number',
      enableFiltering: false,
      minWidth: 80
    }, {
      displayName: 'PFOR,t',
      field: 'pfor_t',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"€/GJ":6'
    }, {
      displayName: 'QTint',
      field: 'qtint',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"€/GJ":6'
    }, {
      displayName: 'QTPSV',
      field: 'qtpsv',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"€/GJ":6'
    }, {
      displayName: 'QTMCV',
      field: 'qtmcv',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"€/GJ":6'
    }, {
      displayName: 'CCIt Tutela',
      field: 'ccit',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"€/GJ":6'
    }, {
      displayName: 'CCIt 38.10',
      field: 'ccit_3810',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"€/GJ":6'
    }, {
      displayName: 'CCIt 38.52',
      field: 'ccit_3852',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"€/GJ":6'
    }, {
      displayName: 'CCIt 64.09',
      field: 'ccit_6409',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"€/GJ":6'
    }, {
      displayName: 'CCIt 64.09 38.10',
      field: 'ccit_6409_3810',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/SMC":4'
    }, {
      displayName: 'CCIt 64.09 38.52',
      field: 'ccit_6409_3852',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/SMC":4'
    }, {
      displayName: 'CCIt 89.10',
      field: 'ccit_8910',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/SMC":4'
    }, {
      displayName: 'CCIt 89.10 38.10',
      field: 'ccit_8910_3810',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/SMC":4'
    }, {
      displayName: 'CCIt 89.10 38.52',
      field: 'ccit_8910_3852',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/SMC":4'
    }, {
      displayName: 'CCIt 77.11',
      field: 'ccit_7711',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/SMC":4'
    }, {
      displayName: 'CCIt 77.11 38.10',
      field: 'ccit_7711_3810',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/SMC":4'
    }, {
      displayName: 'CCIt 77.11 38.52',
      field: 'ccit_7711_3852',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/SMC":4'
    }, {
      displayName: 'CCIt 117.12',
      field: 'ccit_11712',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"€/GJ":6'
    }, {
      displayName: 'CCIt 117.12 38.10',
      field: 'ccit_11712_3810',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"€/SMC":4'
    }, {
      displayName: 'CCIt 117.12 38.52',
      field: 'ccit_11712_3852',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"€/SMC":4'
    }, {
      displayName: 'CCIt 385.12',
      field: 'ccit_38512',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/GJ":6'
    }, {
      displayName: 'CCIt 385.12 38.10',
      field: 'ccit_385_3810',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/SMC":4'
    }, {
      displayName: 'CCIt 385.12 38.52',
      field: 'ccit_385_3852',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/SMC":4'
    }, {
      displayName: 'CMEM,t 196.13',
      field: 'cmem_19613',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"€/GJ":6'
    }, {
      displayName: 'CMEM,t 196.13 38.10',
      field: 'cmem_19613_3810',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/SMC":4'
    }, {
      displayName: 'CMEM,t 196.13 38.52',
      field: 'cmem_19613_3852',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/SMC":4'
    }]
  });
  componentTypesMap['gas']['sv'].push({
    code: 'CCR',
    description: 'Servizi di vendita - CCR',
    columnDefs: [{
      displayName: 'Data',
      field: 'date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'CCR',
      field: 'ccr',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"€/GJ":6'
    }, {
      displayName: 'CCR (PCS 38.10)',
      field: 'ccr_pcs_3810',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/SMC":2'
    }, {
      displayName: 'CCR (PCS 38.52)',
      field: 'ccr_pcs_3852',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/SMC":2'
    }]
  });
  componentTypesMap['gas']['sv'].push({
    code: 'GRAD',
    description: 'Servizi di vendita - Oneri di gradualità',
    columnDefs: [{
      displayName: 'Data',
      field: 'date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'GRAD',
      field: 'grad',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/SMC":2'
    }, {
      displayName: 'CPR',
      field: 'cpr',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/SMC":2'
    }, {
      displayName: 'GRA TOT',
      field: 'grad_tot',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/SMC":2'
    }]
  });
  componentTypesMap['gas']['sv'].push({
    code: 'QOA',
    description: 'Servizi di vendita - Quota oneri aggiuntivi',
    columnDefs: [{
      displayName: 'Data',
      field: 'date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'QOA',
      field: 'qoa',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/SMC":4'
    }]
  });

  // Serzizi di Rete (sr)
  componentTypesMap['gas']['sr'].push({
    code: 'QT',
    description: 'Trasporto',
    columnDefs: [{
      displayName: 'Data',
      field: 'date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      minWidth: 80,
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Ambito Tariffario',
      field: 'ambito_tariffario_id',
      lookup: 'ambitotariffario',
      enableFiltering: false,
      minWidth: 80,
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'QT (tutela)',
      field: 'qt_tutela',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"€/GJ":6'
    }, {
      displayName: 'QT (tutela;t;38,10)',
      field: 'qt_tutela_t_3810',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/SMC":4'
    }, {
      displayName: 'QT (tutela;t;38,52)',
      field: 'qt_tutela_t_3852',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/SMC":4'
    }, {
      displayName: 'QT (64,09;t)',
      field: 'qt_6409_t',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"€/GJ":6'
    }, {
      displayName: 'QT (64,09;t;38,10)',
      field: 'qt_6409_t_3810',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/SMC":4'
    }, {
      displayName: 'QT (64,09;t;38,52)',
      field: 'qt_6409_t_3852',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/SMC":4'
    }, {
      displayName: 'QT (89,10;t)',
      field: 'qt_8910_t',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"€/GJ":6'
    }, {
      displayName: 'QT (89,10;t;38,10)',
      field: 'qt_8910_t_3810',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/SMC":4'
    }, {
      displayName: 'QT (89,10;t;38,52)',
      field: 'qt_8910_t_3852',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/SMC":4'
    }, {
      displayName: 'QT (77,11;t)',
      field: 'qt_7711_t',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"€/GJ":6'
    }, {
      displayName: 'QT (77,11;t;38,10)',
      field: 'qt_7711_t_3810',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/SMC":4'
    }, {
      displayName: 'QT (77,11;t;38,52)',
      field: 'qt_7711_t_3852',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/SMC":4'
    }, {
      displayName: 'QT (117,12;t)',
      field: 'qt_11712_t',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"€/GJ":6'
    }, {
      displayName: 'QT (117,12;t;38,10)',
      field: 'qt_11712_t_3810',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/SMC":4'
    }, {
      displayName: 'QT (117,12;t;38,52)',
      field: 'qt_11712_t_3852',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/SMC":4'
    }, {
      displayName: 'QT (385,12;t)',
      field: 'qt_38512_t',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"€/GJ":6'
    }, {
      displayName: 'QT (385,12;t;38,10)',
      field: 'qt_38512_t_3810',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/SMC":4'
    }, {
      displayName: 'QT (385,12;t;38,52)',
      field: 'qt_38512_t_3852',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/SMC":4'
    }, {
      displayName: 'QT (196,13;t)',
      field: 'qt_19613_t',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"€/GJ":6'
    }, {
      displayName: 'QT (196,13;t;38,10)',
      field: 'qt_19613_t_3810',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/SMC":4'
    }, {
      displayName: 'QT (196,13;t;38,52)',
      field: 'qt_19613_t_3852',
      type: 'number',
      enableFiltering: false,
      minWidth: 80,
      cellFilter: 'currency:"c€/SMC":4'
    }]
  });
  componentTypesMap['gas']['sr'].push({
    code: 'QS',
    description: 'Stoccaggio',
    columnDefs: [{
      displayName: 'Data',
      field: 'date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'QS',
      field: 'qs',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"€/GJ":6'
    }, {
      displayName: 'QS (PCS 38,10)',
      field: 'pcs_3810',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/SMC":4'
    }, {
      displayName: 'QS (PCS 38,52)',
      field: 'pcs_3852',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/SMC":4'
    }]
  });
  componentTypesMap['gas']['sr'].push({
    code: 'TD_fissa',
    description: 'Stoccaggio',
    columnDefs: [{
      displayName: 'Data',
      field: 'date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Ambito Tariffario',
      field: 'ambito_tariffario_id',
      lookup: 'ambitotariffario',
      enableFiltering: false,
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Classe misuratore',
      field: 'classe_misuratore',
      type: 'string',
      enableFiltering: false,
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'TD fissa',
      field: 'td_fissa',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"€/PDR/Anno":2'
    }]
  });
  componentTypesMap['gas']['sr'].push({
    code: 'TD_var',
    description: 'Distribuzione variabile',
    columnDefs: [{
      displayName: 'Data',
      field: 'date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Ambito Tariffario',
      field: 'ambito_tariffario_id',
      lookup: 'ambitotariffario',
      enableFiltering: false,
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Scaglione',
      field: 'scaglione',
      enableFiltering: false,
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Lim. inf.',
      field: 'lim_inf',
      type: 'number',
      cellFilter: 'currency:"SMC":0'
    }, {
      displayName: 'Lim. sup.',
      field: 'lim_sup',
      type: 'number',
      cellFilter: 'currency:"SMC":0'
    }, {
      displayName: 'TD var',
      field: 'td_var',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/SMC":3'
    }]
  });
  componentTypesMap['gas']['sr'].push({
    code: 'CRV',
    description: 'CRV',
    columnDefs: [{
      displayName: 'Data',
      field: 'date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'CRV i',
      field: 'crv_i',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/SMC":3'
    }, {
      displayName: 'CRV OS',
      field: 'crv_os',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/SMC":3'
    }, {
      displayName: 'CRV BL',
      field: 'crv_bl',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/SMC":3'
    }, {
      displayName: 'CRV TOT',
      field: 'crv_tot',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/SMC":3'
    }]
  });
  componentTypesMap['gas']['sr'].push({
    code: 'CPU',
    description: 'Corrispettivi unitari di capacità di rete nazionale',
    columnDefs: [{
      displayName: 'Anno',
      field: 'date',
      type: 'date',
      cellFilter: 'date:"yyyy"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Ambito Tariffario',
      field: 'ambito_tariffario_id',
      lookup: 'ambitotariffario',
      enableFiltering: false,
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'CPU',
      field: 'cpu',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"€/Anno/SMC/g":6'
    }]
  });
  componentTypesMap['gas']['sr'].push({
    code: 'CRR',
    description: 'Corrispettivo unitario di capacità di rete regionale',
    columnDefs: [{
      displayName: 'Anno',
      field: 'date',
      type: 'date',
      cellFilter: 'date:"yyyy"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'CRR',
      field: 'crr',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"€/Anno/SMC/g":6'
    }]
  });
  componentTypesMap['gas']['sr'].push({
    code: 'CMT',
    description: 'Corrispettivo transitorio per il servizio di misura',
    columnDefs: [{
      displayName: 'Anno',
      field: 'date',
      type: 'date',
      cellFilter: 'date:"yyyy"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'CMT',
      field: 'cmt',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"€/Anno/SMC/g":6'
    }]
  });

  // Accise (add)
  componentTypesMap['gas']['add'].push({
    code: 'GAS_Accise',
    description: 'Accisa e IVA',
    columnDefs: [{
      displayName: 'Data',
      field: 'date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Scaglione',
      field: 'scaglione',
      enableFiltering: false,
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Lim. inf.',
      field: 'lim_inf',
      type: 'number',
      cellFilter: 'currency:"SMC":0'
    }, {
      displayName: 'Lim. sup.',
      field: 'lim_sup',
      type: 'number',
      cellFilter: 'currency:"SMC":0'
    }, {
      displayName: 'Accisa uso civile Centro-Nord',
      field: 'uso_civile_centro_nord',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€":3'
    }, {
      displayName: 'Accisa uso civile Mezzogiorno',
      field: 'uso_civile_mezzogiorno',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€":3'
    }, {
      displayName: 'Accisa uso industriale/agevolata',
      field: 'uso_industriale_agevolato',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€":3'
    }, {
      displayName: 'Accisa autotrazione',
      field: 'autotrazione',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€":3'
    }, {
      displayName: 'Accisa Forze armate',
      field: 'forze_armate',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€":3'
    }, {
      displayName: 'Esente',
      field: 'esente',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€":3'
    }]
  });
  componentTypesMap['gas']['add'].push({
    code: 'GAS_Addizionale',
    description: 'Addizionale regionale',
    columnDefs: [{
      displayName: 'Data',
      field: 'date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Scaglione',
      field: 'scaglione',
      enableFiltering: false,
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Lim. inf.',
      field: 'lim_inf',
      type: 'number',
      cellFilter: 'currency:"SMC":0'
    }, {
      displayName: 'Lim. sup.',
      field: 'lim_sup',
      type: 'number',
      cellFilter: 'currency:"SMC":0'
    }, {
      displayName: 'Regione',
      field: 'regione_id',
      lookup: 'regione',
      enableFiltering: false
    }, {
      displayName: 'Uso civile',
      field: 'uso_civile',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/SMC":3'
    }, {
      displayName: 'Uso industriale',
      field: 'uso_industriale',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/SMC":3'
    }, {
      displayName: 'Identificativo delibera',
      field: 'identificativo_delibera',
      enableFiltering: false
    }]
  });
  componentTypesMap['gas']['add'].push({
    code: 'IVA',
    description: 'IVA',
    columnDefs: [{
      displayName: 'Data',
      field: 'date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Scaglione',
      field: 'scaglione',
      enableFiltering: false,
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Lim. inf.',
      field: 'lim_inf',
      type: 'number',
      cellFilter: 'currency:"SMC":0'
    }, {
      displayName: 'Lim. sup.',
      field: 'lim_sup',
      type: 'number',
      cellFilter: 'currency:"SMC":0'
    }, {
      displayName: 'IVA Uso civile',
      field: 'uso_civile',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'percentage:2'
    }, {
      displayName: 'IVA Uso industriale',
      field: 'uso_industriale',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'percentage:2'
    }, {
      displayName: 'IVA uso ind. agevolata',
      field: 'uso_industriale_agevolato',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'percentage:2'
    }]
  });

  // Altro
  componentTypesMap['gas']['altro'].push({
    code: 'GAS_Spread',
    description: 'Spread',
    columnDefs: [{
      displayName: 'Data',
      field: 'date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Tipo contratto',
      field: 'tipo_contratto',
      type: 'string',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Fornitore',
      field: 'fornitore_id',
      lookup: 'fornitore',
      enableFiltering: false,
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Comune',
      field: 'comune_id',
      lookup: 'comune',
      enableFiltering: false,
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Spread',
      field: 'spread',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/SMC":3',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Fisso',
      field: 'fisso',
      type: 'number',
      enableFiltering: false,
      cellFilter: 'currency:"c€/SMC":3',
      cellEditableCondition: isCellEditable
    }]
  });
  //componentTypesMap['gas']['altro'].push({code: 'prof_utenza', description: 'Prof. Utenza', columnDefs: [
  //  {displayName: 'Gruppo Utente', field: 'gruppo_utenze', cellEditableCondition: isCellEditable},
  //  {displayName: 'Pp', field: 'pp', enableFiltering: false},
  //  {displayName: 'Gen', field: 'gennaio', type: 'number', enableFiltering: false, cellFilter: 'percentage:0'},
  //  {displayName: 'Feb', field: 'febbraio', type: 'number', enableFiltering: false, cellFilter: 'percentage:0'},
  //  {displayName: 'Mar', field: 'marzo', type: 'number', enableFiltering: false, cellFilter: 'percentage:0'},
  //  {displayName: 'Apr', field: 'aprile', type: 'number', enableFiltering: false, cellFilter: 'percentage:0'},
  //  {displayName: 'Mag', field: 'maggio', type: 'number', enableFiltering: false, cellFilter: 'percentage:0'},
  //  {displayName: 'Giu', field: 'giugno', type: 'number', enableFiltering: false, cellFilter: 'percentage:0'},
  //  {displayName: 'Lug', field: 'luglio', type: 'number', enableFiltering: false, cellFilter: 'percentage:0'},
  //  {displayName: 'Ago', field: 'agosto', type: 'number', enableFiltering: false, cellFilter: 'percentage:0'},
  //  {displayName: 'Set', field: 'settembre', type: 'number', enableFiltering: false, cellFilter: 'percentage:0'},
  //  {displayName: 'Ott', field: 'ottobre', type: 'number', enableFiltering: false, cellFilter: 'percentage:0'},
  //  {displayName: 'Nov', field: 'novembre', type: 'number', enableFiltering: false, cellFilter: 'percentage:0'},
  //  {displayName: 'Dic', field: 'dicembre', type: 'number', enableFiltering: false, cellFilter: 'percentage:0'}
  //]});

  var typeDescriptors = [];
  typeDescriptors['ee'] = {
    code: 'ee',
    description: 'Energia Elettrica'
  };
  typeDescriptors['gas'] = {
    code: 'gas',
    description: 'Gas'
  };
  var categoryDescriptors = [];
  categoryDescriptors['sv'] = {
    code: 'sv',
    description: 'Servizi di Vendita',
    fornitore_dependent: false
  };
  categoryDescriptors['sr'] = {
    code: 'sr',
    description: 'Servizi di Rete e Distribuzione',
    fornitore_dependent: false
  };
  categoryDescriptors['og'] = {
    code: 'og',
    description: 'Oneri Generali',
    fornitore_dependent: false
  };
  categoryDescriptors['add'] = {
    code: 'add',
    description: 'Addizionali',
    fornitore_dependent: false
  };
  categoryDescriptors['altro'] = {
    code: 'altro',
    description: 'Altro',
    fornitore_dependent: false
  };

  // Public API here
  return {
    getTypes: function getTypes() {
      return componentTypesMap;
    },
    getCategories: function getCategories(type) {
      return componentTypesMap[type];
    },
    getCodes: function getCodes(type, category) {
      return componentTypesMap[type][category];
    },
    getByCode: function getByCode(type, category, code) {
      for (var idx in componentTypesMap[type][category]) {
        if (componentTypesMap[type][category][idx].code === code) {
          return componentTypesMap[type][category][idx];
        }
      }
    },
    getAll: function getAll() {
      var list = [];
      for (var typeIdx in componentTypesMap) {
        for (var catIdx in componentTypesMap[typeIdx]) {
          for (var codeIdx in componentTypesMap[typeIdx][catIdx]) {
            list.push(componentTypesMap[typeIdx][catIdx][codeIdx]);
          }
        }
      }
      return list;
    },
    getTypeDescriptor: function getTypeDescriptor(type) {
      return typeDescriptors[type];
    },
    getCategoryDescriptor: function getCategoryDescriptor(category) {
      return categoryDescriptors[category];
    }
  };
}]);
angular.module('emma.energy').filter('cellFormatter', ["$log", "$filter", function ($log, $filter) {
  return function (value, scope) {
    //$log.log(scope);
    // TODO a seconda del tipo di colonna posso applicare formattazioni differenti (scope.col... o scope.row.entity...)
    return $filter('currency')(value, 'c€', 3);
  };
}]);
angular.module('emma.energy').filter('percentage', ["$log", "$filter", function ($log, $filter) {
  return function (value, decimalPosition, scope) {
    return $filter('currency')(value * 100, '%', decimalPosition);
  };
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.gasComponentFactory
 * @description
 * # gasComponentFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.energy').factory('gasComponentFactory', ["uiGridConstants", function (uiGridConstants) {
  function getFilters(type) {
    var filters;
    switch (type) {
      case 'gt':
        filters = [{
          condition: uiGridConstants.filter.GREATER_THAN,
          placeholder: 'maggiore di...'
        }];
        break;
      case 'lt':
        filters = [{
          condition: uiGridConstants.filter.LESS_THAN,
          placeholder: 'minore di...'
        }];
        break;
      case 'lgt':
        filters = [{
          condition: uiGridConstants.filter.GREATER_THAN,
          placeholder: 'maggiore di...'
        }, {
          condition: uiGridConstants.filter.LESS_THAN,
          placeholder: 'minore di...'
        }];
        break;
      default:
        filters = {
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: 'Testo libero...'
        };
    }
    return filters;
  }
  function isCellEditable(scope) {
    return !scope.row.entity.wrapper || !scope.row.entity.wrapper.UUID;
  }
  var components = {};

  /* Esempi colonne
      {displayName: 'Tipo cliente', field: 'qtint', lookup: 'tipologiacliente', cellEditableCondition: isCellEditable},
      {displayName: 'qtpsv', field: 'qtpsv', type: 'number', cellFilter: 'currency:"€/PDR/Anno":3'}
  */

  // Gas (gas)
  components['pfor'] = {
    code: 'pfor',
    description: 'Pfor',
    columnDefs: [{
      displayName: 'Data',
      field: 'model.date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'pfor_t',
      field: 'model.pfor_t',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'qtint',
      field: 'model.qtint',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'qtpsv',
      field: 'model.qtpsv',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'qtmcv',
      field: 'model.qtmcv',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Cmem',
      field: 'model.cmem',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'Phi',
      field: 'model.phi',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'CVfg',
      field: 'model.cvfg',
      type: 'number',
      cellEditableCondition: isCellEditable
    }]
  };
  components['ccr'] = {
    code: 'ccr',
    description: 'CCR',
    columnDefs: [{
      displayName: 'Data',
      field: 'model.date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'ccr',
      field: 'model.ccr',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'ccr_pcs_3810',
      field: 'model.ccr_pcs_3810',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'ccr_pcs_3852',
      field: 'model.ccr_pcs_3852',
      type: 'number',
      cellEditableCondition: isCellEditable
    }]
  };
  components['qvd_fissa'] = {
    code: 'qvd_fissa',
    description: 'QVD_fissa',
    columnDefs: [{
      displayName: 'Data',
      field: 'model.date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'tipo_cliente',
      field: 'model.tipo_cliente',
      lookup: 'tipologiacliente',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'qvd_fissa',
      field: 'model.qvd_fissa',
      type: 'number',
      cellEditableCondition: isCellEditable
    }]
  };
  components['qvd_var'] = {
    code: 'qvd_var',
    description: 'QVD_var',
    columnDefs: [{
      displayName: 'Data',
      field: 'model.date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'scaglione',
      field: 'model.scaglione',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'lim_inf',
      field: 'model.lim_inf',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'lim_sup',
      field: 'model.lim_sup',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'qvd_var',
      field: 'model.qvd_var',
      type: 'number',
      cellEditableCondition: isCellEditable
    }]
  };
  components['grad_cpr'] = {
    code: 'grad_cpr',
    description: 'GRAD_Cpr',
    columnDefs: [{
      displayName: 'Data',
      field: 'model.date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'grad',
      field: 'model.grad',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'cpr',
      field: 'model.cpr',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'grad_tot',
      field: 'model.grad_tot',
      type: 'number',
      cellEditableCondition: isCellEditable
    }]
  };
  components['tf'] = {
    code: 'tf',
    description: 'TF',
    columnDefs: [{
      displayName: 'Data',
      field: 'model.date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'ambito_tariffario',
      field: 'model.ambito_tariffario',
      lookup: 'ambitotariffario',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'CRr',
      field: 'model.crr',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'CMT',
      field: 'model.cmt',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'CPu',
      field: 'model.cpu',
      type: 'number',
      cellEditableCondition: isCellEditable
    }]
  };
  components['tau_1'] = {
    code: 'tau_1',
    description: 'tau_1',
    columnDefs: [{
      displayName: 'Data',
      field: 'model.date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'ambito_tariffario',
      field: 'model.ambito_tariffario',
      lookup: 'ambitotariffario',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'classe_misuratore_1',
      field: 'model.classe_misuratore_1',
      lookup: 'classemisuratore',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'classe_misuratore_2',
      field: 'model.classe_misuratore_2',
      lookup: 'classemisuratore',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'tau1_cot',
      field: 'model.tau1_cot',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'tau1_dis',
      field: 'model.tau1_dis',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'tau1_mis',
      field: 'model.tau1_mis',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'tau1_tot_ctrl',
      field: 'model.tau1_tot_ctrl',
      type: 'number',
      cellEditableCondition: isCellEditable
    }]
  };
  components['tau_3'] = {
    code: 'tau_3',
    description: 'tau_3',
    columnDefs: [{
      displayName: 'Data',
      field: 'model.date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'ambito_tariffario',
      field: 'model.ambito_tariffario',
      lookup: 'ambitotariffario',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'scaglione',
      field: 'model.scaglione',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'lim_inf',
      field: 'model.lim_inf',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'lim_sup',
      field: 'model.lim_sup',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'td_var',
      field: 'model.td_var',
      type: 'number',
      cellEditableCondition: isCellEditable
    }]
  };
  components['qtf_i'] = {
    code: 'qtf_i',
    description: 'QTF_i',
    columnDefs: [{
      displayName: 'Data',
      field: 'model.date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'ambito_tariffario',
      field: 'model.ambito_tariffario',
      lookup: 'ambitotariffario',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'QTF_i',
      field: 'model.qtf_i',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'CRVi',
      field: 'model.crvi',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'CRVos',
      field: 'model.crvos',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'CRVbl',
      field: 'model.crvbl',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'CRVSt',
      field: 'model.crvst',
      type: 'number',
      cellEditableCondition: isCellEditable
    }]
  };
  components['qtv_i'] = {
    code: 'qtv_i',
    description: 'QTV_i',
    columnDefs: [{
      displayName: 'Data',
      field: 'model.date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'QTV_i',
      field: 'model.qtv_i',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'lambda',
      field: 'model.lambda',
      type: 'number',
      cellEditableCondition: isCellEditable
    }]
  };
  components['rs'] = {
    code: 'rs',
    description: 'RS',
    columnDefs: [{
      displayName: 'Data',
      field: 'model.date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'scaglione',
      field: 'model.scaglione',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'lim_inf',
      field: 'model.lim_inf',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'lim_sup',
      field: 'model.lim_sup',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'RS',
      field: 'model.rs',
      type: 'number',
      cellEditableCondition: isCellEditable
    }]
  };
  components['ug1'] = {
    code: 'ug1',
    description: 'UG1',
    columnDefs: [{
      displayName: 'Data',
      field: 'model.date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'scaglione',
      field: 'model.scaglione',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'lim_inf',
      field: 'model.lim_inf',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'lim_sup',
      field: 'model.lim_sup',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'UG1',
      field: 'model.ug1',
      type: 'number',
      cellEditableCondition: isCellEditable
    }]
  };
  components['st'] = {
    code: 'st',
    description: 'ST',
    columnDefs: [{
      displayName: 'Data',
      field: 'model.date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'scaglione',
      field: 'model.scaglione',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'lim_inf',
      field: 'model.lim_inf',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'lim_sup',
      field: 'model.lim_sup',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'ST',
      field: 'model.st',
      type: 'number',
      cellEditableCondition: isCellEditable
    }]
  };
  components['vr'] = {
    code: 'vr',
    description: 'VR',
    columnDefs: [{
      displayName: 'Data',
      field: 'model.date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'scaglione',
      field: 'model.scaglione',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'lim_inf',
      field: 'model.lim_inf',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'lim_sup',
      field: 'model.lim_sup',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'VR',
      field: 'model.vr',
      type: 'number',
      cellEditableCondition: isCellEditable
    }]
  };
  components['re'] = {
    code: 're',
    description: 'RE',
    columnDefs: [{
      displayName: 'Data',
      field: 'model.date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'scaglione',
      field: 'model.scaglione',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'lim_inf',
      field: 'model.lim_inf',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'lim_sup',
      field: 'model.lim_sup',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'RE',
      field: 'model.re',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'ReT',
      field: 'model.ret',
      type: 'number',
      cellEditableCondition: isCellEditable
    }]
  };
  components['ug2_var'] = {
    code: 'ug2_var',
    description: 'UG2_var',
    columnDefs: [{
      displayName: 'Data',
      field: 'model.date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'scaglione',
      field: 'model.scaglione',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'lim_inf',
      field: 'model.lim_inf',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'lim_sup',
      field: 'model.lim_sup',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'UG2_var',
      field: 'model.ug2_var',
      type: 'number',
      cellEditableCondition: isCellEditable
    }]
  };
  components['ug2_fissa'] = {
    code: 'ug2_fissa',
    description: 'UG2_fissa',
    columnDefs: [{
      displayName: 'Data',
      field: 'model.date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'ambito_tariffario',
      field: 'model.ambito_tariffario',
      lookup: 'ambitotariffario',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'classe_misuratore_1',
      field: 'model.classe_misuratore_1',
      lookup: 'classemisuratore',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'classe_misuratore_2',
      field: 'model.classe_misuratore_2',
      lookup: 'classemisuratore',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'UG2_fissa',
      field: 'model.ug2_fissa',
      type: 'number',
      cellEditableCondition: isCellEditable
    }]
  };
  components['ug3'] = {
    code: 'ug3',
    description: 'UG3',
    columnDefs: [{
      displayName: 'Data',
      field: 'model.date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'UG3',
      field: 'model.ug3',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'UG3T',
      field: 'model.ug3t',
      type: 'number',
      cellEditableCondition: isCellEditable
    }]
  };
  components['gs'] = {
    code: 'gs',
    description: 'GS',
    columnDefs: [{
      displayName: 'Data',
      field: 'model.date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'scaglione',
      field: 'model.scaglione',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'lim_inf',
      field: 'model.lim_inf',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'lim_sup',
      field: 'model.lim_sup',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'GS',
      field: 'model.gs',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'GSt',
      field: 'model.gst',
      type: 'number',
      cellEditableCondition: isCellEditable
    }]
  };
  components['gas_accise'] = {
    code: 'gas_accise',
    description: 'GAS_Accise',
    columnDefs: [{
      displayName: 'Data',
      field: 'model.date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'scaglione',
      field: 'model.scaglione',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'lim_inf',
      field: 'model.lim_inf',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'lim_sup',
      field: 'model.lim_sup',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'uso_civile_centro_nord',
      field: 'model.uso_civile_centro_nord',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'uso_civile_mezzogiorno',
      field: 'model.uso_civile_mezzogiorno',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'uso_industriale_agevolato',
      field: 'model.uso_industriale_agevolato',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'autotrazione',
      field: 'model.autotrazione',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'forze_armate_riscaldamento',
      field: 'model.forze_armate_riscaldamento',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'forze_armate_autotrazione',
      field: 'model.forze_armate_autotrazione',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'esente',
      field: 'model.esente',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'produz_diretta_indiretta',
      field: 'model.produz_diretta_indiretta',
      type: 'number',
      cellEditableCondition: isCellEditable
    }]
  };
  components['gas_addizionale'] = {
    code: 'gas_addizionale',
    description: 'GAS_Addizionale',
    columnDefs: [{
      displayName: 'Data',
      field: 'model.date',
      type: 'date',
      cellFilter: 'date:"yyyy-MM-dd"',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'scaglione',
      field: 'model.scaglione',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'lim_inf',
      field: 'model.lim_inf',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'lim_sup',
      field: 'model.lim_sup',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'regione',
      field: 'model.regione',
      lookup: 'areatariffariaregionale',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'uso_civile',
      field: 'model.uso_civile',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'uso_industriale',
      field: 'model.uso_industriale',
      type: 'number',
      cellEditableCondition: isCellEditable
    }, {
      displayName: 'identificativo_delibera',
      field: 'model.identificativo_delibera',
      type: 'text',
      cellEditableCondition: isCellEditable
    }]
  };

  // Public API here
  return {
    getTypes: function getTypes() {
      return angular.copy(components);
    },
    getType: function getType(type) {
      return angular.copy(components[type]);
    }
  };
}]);
angular.module('emma.energy').filter('cellFormatter', ["$log", "$filter", function ($log, $filter) {
  return function (value, scope) {
    //$log.log(scope);
    // TODO a seconda del tipo di colonna posso applicare formattazioni differenti (scope.col... o scope.row.entity...)
    return $filter('currency')(value, 'c€', 3);
  };
}]);
angular.module('emma.energy').filter('percentage', ["$log", "$filter", function ($log, $filter) {
  return function (value, decimalPosition, scope) {
    return $filter('currency')(value * 100, '%', decimalPosition);
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:ListCtrl
 * @description
 * # PriceListCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/pricelist/list', {
    templateUrl: 'energy/pricelist/pricelist_list.html',
    controller: 'PriceListCtrl'
  }).when('/pricelist/detail', {
    templateUrl: 'energy/pricelist/pricelist_detail.html',
    controller: 'PriceListCtrl'
  }).when('/pricelist/detail/:id', {
    templateUrl: 'energy/pricelist/pricelist_detail.html',
    controller: 'PriceListCtrl'
  });
}]).controller('PriceListCtrl', ["$scope", "$routeParams", "$timeout", "$rootScope", "$log", "$filter", "$location", "authFactory", "componenttypefactory", "priceListFactory", "listComponentFactory", "$q", "toaster", "errorService", "uiGridConstants", "dialogService", "sixGridPaginationConstants", function ($scope, $routeParams, $timeout, $rootScope, $log, $filter, $location, authFactory, componenttypefactory, priceListFactory, listComponentFactory, $q, toaster, errorService, uiGridConstants, dialogService, sixGridPaginationConstants) {
  // Gas
  $scope.deliberaAEEGList = [{
    code: 'arg_gas_64_09',
    description: 'ARG/gas 64/09'
  }, {
    code: 'arg_gas_77_11',
    description: 'ARG/gas 77/11'
  }, {
    code: 'arg_gas_117_12',
    description: 'ARG/gas 117/12'
  }, {
    code: 'arg_gas_385_12',
    description: 'ARG/gas 385/12'
  }, {
    code: 'arg_gas_196_13',
    description: 'ARG/gas 196/13'
  }, {
    code: 'cond_tutela',
    description: 'Condizioni di tutela'
  }];
  $scope.pcsStdList = [38.100, 38.52];
  $scope.pcsList = [];
  $scope.dependencies = [{
    code: 'vendita',
    description: 'Servizi di vendita',
    deps: [{
      code: 'spread',
      description: 'Spread',
      ref: 'Contratto privato',
      um: '€/Gj',
      formula: ''
    }, {
      code: 'qtint',
      description: 'Qtint',
      ref: 'Articolo 6 del TIVG',
      um: '€/Gj',
      formula: ''
    }, {
      code: 'qtpsv',
      description: 'Qtpsv',
      ref: 'Articolo 6 del TIVG',
      um: '€/Gj',
      formula: ''
    }, {
      code: 'qtmcv',
      description: 'Qtmcv',
      ref: 'Articolo 6 del TIVG',
      um: '€/Gj',
      formula: ''
    }, {
      code: 'phi',
      description: '&phi;',
      ref: 'Articolo 6 del TIVG',
      um: '€/Smc con pcs=0.03810',
      formula: ''
    }, {
      code: 'cvfg',
      description: 'CVfg',
      ref: 'Articolo 6 del TIVG',
      um: '€/Smc con pcs=0.03810',
      formula: ''
    }, {
      code: 'pfort',
      description: 'Pfor,t',
      ref: 'Articolo 6 del TIVG',
      um: '€/Gj',
      formula: ''
    }, {
      code: 'ccr',
      description: 'CCR',
      ref: 'Articolo 6bis del TIVG',
      um: 'c€/Gj',
      formula: ''
    }, {
      code: 'qvd_fissa',
      description: 'QVD fissa',
      ref: 'Articolo 7 del TIVG',
      um: '€/PDR',
      formula: ''
    }, {
      code: 'qvd_var',
      description: 'QVD var',
      ref: 'Articolo 7 del TIVG',
      um: 'c€/Smc',
      formula: ''
    }, {
      code: 'grad',
      description: 'GRAD',
      ref: 'Articolo 8bis del TIVG',
      um: 'c€/Smc',
      formula: ''
    }, {
      code: 'cpr',
      description: 'Cpr',
      ref: 'Articolo 8bis del TIVG',
      um: 'c€/Smc',
      formula: ''
    }, {
      code: 'tf',
      description: 'TF',
      ref: '(606/2015 R/gas)',
      um: '€/PDR/mese',
      formula: ''
    }, {
      code: 'crr',
      description: 'CRr',
      ref: '(606/2015 R/gas)',
      um: '€/PDR/Smc/gg',
      formula: ''
    }, {
      code: 'cmt',
      description: 'CMT',
      ref: '(606/2015 R/gas)',
      um: '€/PDR/Smc/gg',
      formula: ''
    }, {
      code: 'cpu',
      description: 'CPu',
      ref: '(606/2015 R/gas)',
      um: '€/PDR/Smc/gg',
      formula: ''
    }, {
      code: 'penali',
      description: 'Penali',
      ref: '(606/2015 R/gas)',
      um: '€/mese',
      formula: ''
    }]
  }, {
    code: 'trasporto',
    description: 'Servizi di Trasporto e Gestione del contatore',
    deps: [{
      code: 'tau1_cot',
      description: '&tau;1 cot',
      ref: 'Articolo 40 del RTDG',
      um: '€/PDR/mese',
      formula: ''
    }, {
      code: 'tau1_dis',
      description: '&tau;1 dis',
      ref: 'Articolo 40 del RTDG',
      um: '€/PDR/mese',
      formula: ''
    }, {
      code: 'tau1_mis',
      description: '&tau;1 mis',
      ref: 'Articolo 40 del RTDG',
      um: '€/PDR/mese',
      formula: ''
    }, {
      code: 'tau3',
      description: '&tau;3',
      ref: 'Articolo 40 del RTDG',
      um: 'c€/Smc',
      formula: ''
    }, {
      code: 'qtfi',
      description: 'QTFi',
      ref: 'Articolo 8 del TIVG (tab5)',
      um: '€/GJ',
      formula: ''
    }, {
      code: 'crvos',
      description: 'CRVos',
      ref: 'Articolo 8 del TIVG',
      um: '€/Smc con pcs=0,03810',
      formula: ''
    }, {
      code: 'crvbl',
      description: 'CRVbl',
      ref: 'Articolo 8 del TIVG',
      um: '€/Smc con pcs=0,03810',
      formula: ''
    }, {
      code: 'crvi',
      description: 'CRVi',
      ref: 'Articolo 8 del TIVG',
      um: '€/Smc con pcs=0,03810',
      formula: ''
    }, {
      code: 'crvst',
      description: 'CRVst',
      ref: 'Articolo 8 del TIVG',
      um: '€/Smc con pcs=0,03811',
      formula: ''
    }, {
      code: 'qtvi',
      description: 'QTVi',
      ref: 'Articolo 8 del TIVG',
      um: '€/GJ',
      formula: ''
    }, {
      code: 'rs',
      description: 'RS',
      ref: 'Articolo 40 del RTDG',
      um: 'c€/Smc',
      formula: ''
    }, {
      code: 'ug1',
      description: 'UG1',
      ref: 'Articolo 40 del RTDG',
      um: 'c€/Smc',
      formula: ''
    }, {
      code: 'st',
      description: 'ST',
      ref: 'Articolo 40 del RTDG',
      um: '€/PDR/mese',
      formula: ''
    }, {
      code: 'vr',
      description: 'VR',
      ref: 'Articolo 40 del RTDG',
      um: '€/PDR/mese',
      formula: ''
    }]
  }, {
    code: 'generali',
    description: 'Servizi Generali di Sistema',
    deps: [{
      code: 're',
      description: 'RE',
      ref: 'Articolo 40 del RTDG',
      um: 'c€/Smc',
      formula: ''
    }, {
      code: 'ret',
      description: 'ReT',
      ref: 'Articolo 40 del RTDG',
      um: 'c€/Smc',
      formula: ''
    }, {
      code: 'ug2_var',
      description: 'UG2_var',
      ref: 'Articolo 40 del RTDG',
      um: 'c€/Smc',
      formula: ''
    }, {
      code: 'ug2_fissa',
      description: 'UG2_fissa',
      ref: 'Articolo 40 del RTDG',
      um: '€/PDR/mese',
      formula: ''
    }, {
      code: 'ug3',
      description: 'UG3',
      ref: 'Articolo 40 del RTDG',
      um: 'c€/Smc',
      formula: ''
    }, {
      code: 'ug3t',
      description: 'UG3T',
      ref: 'Articolo 40 del RTDG',
      um: 'c€/Smc',
      formula: ''
    }, {
      code: 'gs',
      description: 'GS',
      ref: 'Articolo 40 del RTDG',
      um: 'c€/Smc',
      formula: ''
    }, {
      code: 'gst',
      description: 'GST',
      ref: 'Articolo 40 del RTDG',
      um: 'c€/Smc',
      formula: ''
    }]
  }, {
    code: 'imposte',
    description: 'Imposte',
    deps: [{
      code: 'accise',
      description: 'Accise',
      ref: 'Testo Unico delle accise',
      um: 'c€/Smc',
      formula: ''
    }, {
      code: 'addizionale',
      description: 'Addizionale',
      ref: 'Testo Unico delle accise',
      um: 'c€/Smc',
      formula: ''
    }]
  }];
  $scope.resetFields = function () {
    $scope.contatoreTypeFilter = {
      'model.code': 'contatoreacqua,contatoreelettricita,contatoregas,contatoregpl,serbatoioinpressione,serbatoiopressioneatmosferica,contatoreteleriscaldamento,contatoreteleraffreddamento'
    };
    $scope.header = {
      version: undefined,
      model: {
        code: undefined,
        description: undefined,
        vettore_id: undefined,
        fornitore_id: undefined,
        from: undefined,
        to: undefined,
        delibera_aeeg: {
          code: 'arg_gas_196_13',
          description: 'ARG/gas 196/13'
        },
        pcs_std: 38.100,
        dependencies: {}
      }
    };
    $scope.contatoreType = {};
    $scope.prices = [];
    $scope.list = [];
    $scope.types = [];
  };
  $scope.params = {
    pageNumber: 1,
    pageSize: 15,
    totalItems: 0,
    queryParam: undefined,
    filters: {}
  };
  var genericTypes = [{
    code: 'fisso'
  }];
  var gasTypes = [{
    code: 'fisso'
  }, {
    code: 'binomia'
  }, {
    code: 'monomia'
  }];
  var eeTypes = [{
    code: 'fisso'
  }, {
    code: 'monomia'
  }];
  var actionsCol = {
    displayName: '',
    field: 'model.code',
    headerCellTemplate: '<div><button class="btn btn-sm" style="background-color: transparent !important" ng-disabled="!grid.appScope.header.model.vettore_id || grid.appScope.isWritePermAllowed()===false" ng-click="grid.appScope.addPrice()"><span class="fa fa-plus"></span></button></div>',
    cellTemplate: '<div class="ui-grid-cell-contents"><button class="btn btn-xs btn-danger" ng-click="grid.appScope.removePricesWithDialog([row.entity])" ng-disabled="grid.appScope.isWritePermAllowed()===false"><span class="fa fa-trash"></span></button></div>',
    width: 50,
    enableSorting: false,
    enableFiltering: false,
    enableCellEdit: false
  };
  var fixedColumnDefs = [{
    displayName: 'Fascia',
    field: 'model.slot',
    sort: {
      direction: 'asc',
      priority: 0
    },
    maxWidth: 200
  }, {
    displayName: 'Tariffa',
    field: 'model.price',
    type: 'number',
    cellFilter: "currencyFilter:grid.appScope.header.model.vettore_id.code"
  }];
  $scope.gridAppCallbacks = {};

  // Grid
  $scope.listGridOptions = {
    paginationPageSizes: [10, 15, 20, 30],
    paginationPageSize: 15,
    useExternalPagination: true,
    enableHorizontalScrollbar: true
  };
  $scope.pricesGridOptions = {
    paginationPageSizes: [10, 20, 30],
    paginationPageSize: 10,
    useExternalPagination: false,
    enableHorizontalScrollbar: true,
    data: 'prices',
    onRegisterApi: function onRegisterApi(gridApi) {
      $scope.pricesGridApi = gridApi;
    }
  };
  $scope.getListColumns = function () {
    $scope.listGridOptions.columnDefs = [{
      displayName: '',
      field: 'model.code',
      enableFiltering: false,
      width: 34,
      cellTemplate: '<div class="ui-grid-cell-contents"><button type="button" class="btn btn-xs btn-primary" ng-click="grid.appScope.viewDetail(row.entity.UUID)"><i class="fa fa-search"></i></button></div>'
    }, {
      displayName: 'Codice',
      field: 'model.code',
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }, {
      displayName: 'Descrizione',
      field: 'model.description',
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }, {
      displayName: 'Fornitore',
      field: 'model.fornitore_id',
      cellTemplate: '<div class="ui-grid-cell ui-grid-cell-contents {{grid.appScope.cellClassFormatter(undefined, row)}}" title="{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}">{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}</div>',
      filters: [{
        type: sixGridPaginationConstants.filterType.SIXLOOKUP,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }, {
      displayName: 'Vettore',
      field: 'model.vettore_id',
      cellTemplate: '<div class="ui-grid-cell ui-grid-cell-contents {{grid.appScope.cellClassFormatter(undefined, row)}}" title="{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}">{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}</div>',
      filters: [{
        type: sixGridPaginationConstants.filterType.SIXLOOKUP,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }, {
      displayName: 'Tipo',
      field: 'model.type.code',
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }, {
      displayName: '',
      field: 'model.code',
      enableFiltering: false,
      width: 40,
      cellTemplate: '<div class="ui-grid-cell-contents"><button class="btn btn-xs btn-danger" ng-click="grid.appScope.deleteWithDialog(row.entity.version)" ng-disabled="grid.appScope.isDeletePermAllowed()===false"><i class="fa fa-trash"></i></button></div>'
    }];
  };
  $scope.lookupCellValueFormatter = function (value) {
    var formatted = "";
    if (typeof value != "undefined") {
      if (Object.prototype.toString.call(value) === '[object Array]') {
        for (var v in value) {
          formatted += value[v].description + " (" + value[v].code + "); ";
        }
      } else {
        formatted = value.description + " (" + value.code + ")";
      }
    }
    return formatted;
  };
  $scope.gridAppCallbacks['lookupCellValueFormatter'] = $scope.lookupCellValueFormatter;
  $scope.removePricesWithDialog = function (items) {
    dialogService.confirmDialog('Eliminare la tariffa?', function () {
      $scope.removePrices(items);
    });
  };
  $scope.removePrices = function (items) {
    if ($scope.header.model.vettore_id && Array.isArray($scope.prices)) {
      items.forEach(function (item) {
        var i = $scope.prices.indexOf(item);
        $scope.prices.splice(i, 1);
      });
    }
  };
  $scope.newPricelist = function () {
    $location.path('/pricelist/detail');
  };
  $scope.addPrice = function () {
    if ($scope.header.model.vettore_id) {
      if (!Array.isArray($scope.prices)) {
        $scope.prices = [];
      }

      // aggiorno il contatore degli slot
      var ordered = $filter('orderBy')($scope.prices, 'model.slot', false);
      var counter = 0;
      if (ordered.length > 0) {
        counter = parseInt(ordered[ordered.length - 1].model.slot.substring(1)) + 1;
      }
      for (var i = 1; i < ordered.length; i++) {
        var last = parseInt(ordered[i - 1].model.slot.substring(1));
        var current = parseInt(ordered[i].model.slot.substring(1));
        if (current - last > 1) {
          counter = last + 1;
        }
      }

      // aggiungo
      $scope.prices.push({
        model: {
          slot: 'F' + counter,
          price: ''
        }
      });
    }
  };
  function updateColumnDefs() {
    if ($scope.header.model.type.code === 'fisso') {
      $scope.pricesGridOptions.columnDefs = angular.copy(fixedColumnDefs);
      $scope.pricesGridOptions.columnDefs.push(actionsCol);
    }
    if ($scope.slotsGridApi) {
      $scope.slotsGridApi.core.refresh();
    }
  }
  function updateTypes() {
    if ($scope.header.model.vettore_id && $scope.header.model.vettore_id.code === 'elettricita') {
      $scope.types = eeTypes;
    } else if ($scope.header.model.vettore_id && $scope.header.model.vettore_id.code === 'gas') {
      $scope.types = gasTypes;
    } else {
      $scope.types = genericTypes;
    }
  }
  function isValidInput() {
    var isValid = true;
    if (angular.isUndefined($scope.header.model.code)) {
      toaster.pop('error', 'Errore', 'Inserire un codice');
      isValid = false;
    }
    if (angular.isUndefined($scope.header.model.description)) {
      toaster.pop('error', 'Errore', 'Inserire una descrizione');
      isValid = false;
    }
    if (angular.isUndefined($scope.header.model.to)) {
      toaster.pop('error', 'Errore', 'Definire una data di fine validità');
      isValid = false;
    }
    if ($scope.header.model.from > $scope.header.model.to) {
      toaster.pop('error', 'Errore', 'La data di fine validità non può essere antecedente alla data di inizio validità');
      isValid = false;
    }
    return isValid;
  }
  ;
  $scope.saveOrUpdate = function () {
    var promise;
    if (isValidInput() && $scope.header.model.type) {
      if ($scope.header.version) {
        // update
        promise = priceListFactory.bulkUpdate({
          header: $scope.header,
          list: $scope.prices
        }).$promise;
      } else {
        // create
        var toSave = [];
        if ($scope.prices && $scope.prices.length > 0) {
          $scope.prices.forEach(function (p) {
            toSave.push(p.model);
          });
        }
        promise = priceListFactory.bulk({
          header: $scope.header.model,
          list: toSave
        }).$promise;
      }
      promise.then(function (response) {
        if (errorService.handleError(response)) {
          if ($scope.header.model.type.code === 'fisso') {
            $scope.prices = response.list;
          }
          $scope.findPriceList();
          toaster.pop('success', 'Salvato', 'Salvataggio riuscito con successo');
          $location.path('pricelist/list');
        } else {
          toaster.pop('error', 'Errore', 'Errore durante il salvataggio');
        }
      });
    } else {
      toaster.pop('error', 'Errore', 'Selezionare il tipo di calcolo');
    }
  };
  $scope.deleteWithDialog = function (itemId) {
    dialogService.confirmDialog('Eliminare il listino?', function () {
      $scope["delete"](itemId);
    });
  };
  $scope.gridAppCallbacks['deleteWithDialog'] = $scope.deleteWithDialog;
  $scope["delete"] = function (itemId) {
    priceListFactory["delete"]({
      id: itemId
    }).$promise.then(function (resp) {
      if (errorService.handleError(resp)) {
        $scope.findPriceList();
        $scope.resetFields();
        $location.path('pricelist/list');
      } else {
        toaster.pop('error', 'Errore', 'Errore durante l\'eliminazione');
      }
    });
  };
  $scope.findPriceList = function () {
    var payload = {
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      query: $scope.params.queryParam,
      sort_fields: $scope.params.sortFields
    };
    return priceListFactory.findAll(payload, $scope.params.filters).$promise.then(function (result) {
      $scope.list = result;
      return result;
    });
  };
  $scope.load = function (uuid) {
    priceListFactory.byUUID({
      id: uuid
    }).$promise.then(function (response) {
      if (errorService.handleError(response)) {
        $scope.header = response;
        $scope.header.model.from = new Date(response.model.from);
        $scope.header.model.to = new Date(response.model.to);
        if (response.model.record_id) {
          $scope.contatoreType = {
            id: {
              type: 'schema',
              UUID: response.model.record_id.type,
              code: response.model.record_id.UUID
            }
          };
        }

        // carico i dati
        priceListFactory.byHeader({
          id: uuid
        }).$promise.then(function (prices) {
          if (errorService.handleError(prices)) {
            $scope.prices = prices.list;
          } else {
            toaster.pop('error', 'Errore', 'Errore durante il recuepro dei dati');
          }
        });
      } else {
        toaster.pop('error', 'Errore', 'Errore durante il recuepro dei dati');
      }
    });
  };
  $scope.showFixedPricesGrid = function () {
    return $scope.header.model.type && $scope.header.model.type.code === 'fisso' && $scope.header.model.vettore_id.code !== 'gas' && $scope.header.model.vettore_id.code !== 'elettricita';
  };
  $scope.viewDetail = function (uuid) {
    $location.path('/pricelist/detail/' + uuid);
  };
  $scope.gridAppCallbacks['viewDetail'] = $scope.viewDetail;
  $scope.goBack = function () {
    $("#code").removeAttr('required');
    $("#description").removeAttr('required');
    $("#from").removeAttr('required');
    $("#to").removeAttr('required');
    $location.path('/pricelist/list/');
  };
  if ($routeParams.id) {
    $scope.load($routeParams.id);
  } else {
    $scope.resetFields();
  }

  /********************/
  /***** WATCHERS *****/
  /********************/

  $scope.$watch('header.model.type.code', function (newVal, oldVal) {
    if (newVal) {
      updateColumnDefs();
    }
  });
  $scope.$watch(function () {
    return $scope.header.model.vettore_id;
  }, function (newVal, oldVal) {
    if (newVal) {
      updateTypes();
    }
  });
  $scope.onPcsStdSelect = function (selected) {
    var n = parseFloat(selected);
    if (!isFinite(n)) {
      return '';
    }
    $scope.pcsList = [selected];
    return selected;
  };

  // $scope.findPriceList();
  $scope.getListColumns();
  $scope.$watch(function () {
    return $scope.listGridOptions.paginationPageSize;
  }, function (newVal, oldVal) {
    if (newVal) {
      var newHeight = $scope.listGridOptions.paginationPageSize * 30 + 110;
      newHeight = Math.min(710, newHeight);
      angular.element(document.getElementsByClassName('grid')[0]).css('height', newHeight + 'px');
      //angular.element(document.getElementsByClassName('grid')[0]).css('width', newWidth + 'px');
    }
  });

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'pricelist';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
}]).filter('currencyFilter', function () {
  return function (value, vectorCode) {
    if (angular.isNumber(value)) {
      if (vectorCode === 'elettricita') {
        return parseFloat(value).toFixed(5) + ' c€/kWh';
      } else if (vectorCode === 'gas') {
        return parseFloat(value).toFixed(5) + ' c€/SMC';
      } else {
        return parseFloat(value).toFixed(5) + ' c€';
      }
    }
  };
});
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:ListComponentCtrl
 * @description
 * # ListComponentCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/pricelist/listcomponentmenu/:menuType/', {
    templateUrl: 'energy/pricelist/pricelist_component_menu.html',
    controller: 'PriceListComponentCtrl'
  });
}]).controller('PriceListComponentCtrl', ["$scope", "$routeParams", "$rootScope", "$log", "$filter", "$location", "authFactory", "gasComponentFactory", "listComponentFactory", "recordFactory", "$q", "toaster", "errorService", "uiGridConstants", "sixGridPaginationConstants", "$timeout", function ($scope, $routeParams, $rootScope, $log, $filter, $location, authFactory, gasComponentFactory, listComponentFactory, recordFactory, $q, toaster, errorService, uiGridConstants, sixGridPaginationConstants, $timeout) {
  $scope.mode = {
    mode: 'show'
  };
  $scope.components = {
    list: [],
    totalResults: 0
  };
  $scope.menu = {
    show: true,
    list: [],
    selected: {}
  };
  $scope.params = {
    pageNumber: 1,
    pageSize: 15,
    totalItems: 0,
    queryParam: undefined,
    filters: {},
    sortFields: 'model.date:desc'
  };
  $scope.gridAppCallbacks = {};
  $scope.gridDetailOptions = {
    enableSorting: true,
    enableGridMenu: true,
    exporterCsvColumnSeparator: ';',
    exporterSuppressColumns: ['id', 'timeline'],
    exporterMenuPdf: false,
    enableFiltering: true,
    enableColumnResizing: true,
    paginationPageSize: $scope.params.pageSize,
    columnDefs: [{
      name: ' '
    }]
  };
  $scope.importGridOptions = {
    enableSorting: true,
    enableFiltering: true,
    enableColumnResizing: true,
    columnDefs: [{
      name: ' '
    }],
    onRegisterApi: function onRegisterApi(gridApi) {
      $scope.importGridApi = gridApi;
    }
  };

  /* ******************************
   * IMPORT / SAVE / UPDATE
   * ******************************/

  $scope.importData = function () {
    if ($scope.importGridOptions.data && $scope.importGridOptions.data.length > 0) {
      $scope.importGridOptions.data.forEach(function (item) {
        item.model.type = $scope.menu.selected.code.toLowerCase();
        delete item.model.sixImportStatus;
      });
      var toSave = $scope.importGridOptions.data.map(function (item) {
        return item.model;
      });

      // bulk save
      listComponentFactory($scope.menu.selected.code).bulk(toSave).$promise.then(function (resp) {
        if (errorService.handleError(resp)) {
          $scope.percent = 100;
          toaster.pop('success', 'Salvataggio', 'Importazione eseguita con successo');
          $scope.getData();
          $scope.mode.mode = 'show';
        } else {
          toaster.pop('error', 'Errore', 'Errore durante l\'importazione');
        }
      }, function (resp) {
        toaster.pop('error', 'Errore', 'Errore durante l\'importazione: ' + resp.message);
      });
    }
  };
  $scope.saveOrUpdate = function (item) {
    if ($scope.mode.mode === 'show') {
      if (item.model.date) {
        item.model.date = $filter('date')(item.model.date, 'yyyy-MM-dd');
      }
      delete item.sixImportStatus;
      if (item.UUID) {
        // update
        listComponentFactory($scope.menu.selected.code).update({
          id: item.version
        }, item).$promise.then(function (resp) {
          if (errorService.handleError(resp)) {
            // TODO aggiornare l'item con quello ritornato dalla update
            toaster.pop('success', 'Salvataggio', 'Salvataggio eseguito con successo');
          } else {
            toaster.pop('error', 'Errore', 'Errore durante il salvataggio');
          }
        }, function (err) {
          $log.error(err);
          toaster.pop('error', 'Errore', 'Errore durante il salvataggio');
        });
      } else {
        // create
        listComponentFactory($scope.menu.selected.code).create(item.model).$promise.then(function (resp) {
          if (errorService.handleError(resp)) {
            // TODO aggiornare l'item con quello ritornato dalla create
            toaster.pop('success', 'Salvataggio', 'Salvataggio eseguito con successo');
          } else {
            toaster.pop('error', 'Errore', 'Errore durante il salvataggio');
          }
        }, function (err) {
          $log.error(err);
          toaster.pop('error', 'Errore', 'Errore durante il salvataggio');
        });
      }
    }
  };
  $scope.addRecord = function () {
    $scope.components.list.unshift({
      model: {
        type: $scope.menu.selected.code,
        date: Date.now()
      }
    });
    $scope.components.totalResults++;
  };
  $scope.removeRecords = function () {
    var promises = [];
    $scope.components.list.forEach(function (item) {
      if (item.model.code) {
        var prom = listComponentFactory($scope.menu.selected.code)["delete"]({
          id: item.model.code
        }).$promise.then(function (response) {
          if (!errorService.handleError(response)) {
            toaster.pop('error', 'Errore', 'Impossibile eliminare il dato del ' + item.model.date);
          }
        });
        promises.push(prom);
      }
    });
    $q.all(promises).then(function (responses) {
      find();
    }); // ricarico i dati solo dopo aver eliminato tutti i selezionati
  };

  function processData(data) {
    updateColumnDefs();
    var mapToResolve = {};
    var processed = [];
    data.forEach(function (row) {
      var item = {};
      for (var key in row) {
        item[key.toLowerCase()] = row[key];
      }
      processed.push(item);
    });

    // processo i numeri e preparo la richiesta per risolvere le lookup
    processed.forEach(function (row) {
      for (var key in row) {
        if (row.hasOwnProperty(key)) {
          $scope.menu.selected.columnDefs.forEach(function (col) {
            if (col.field === 'model.' + key) {
              if (col.type === 'number' && !isNaN(row[key])) {
                row[key] = parseFloat(row[key]);
              } else if (col.lookup) {
                var innerMap = mapToResolve[col.lookup] || {};
                innerMap[row[key]] = '';
                mapToResolve[col.lookup] = innerMap;
              }
            }
          });
        }
      }
    });

    // risolvo le lookup
    processed.forEach(function (row) {
      row['sixImportStatus'] = 'OK';
    });
    if (!sixObjectLib.isEmpty(mapToResolve)) {
      $scope.isAllOk = true;
      recordFactory('type').bulkResolve(mapToResolve).$promise.then(function (response) {
        $log.info(response);
        processed.forEach(function (row) {
          var message = '';
          var sep = '';
          for (var key in row) {
            $scope.menu.selected.columnDefs.forEach(function (col) {
              if (col.field === 'model.' + key) {
                if (col.lookup) {
                  var resolved = response[col.lookup][row[key]];
                  if (angular.isUndefined(resolved) || resolved === null) {
                    message += sep + 'record \'' + row[key] + '\'' + ' non trovato!';
                    sep = '; ';
                    row['sixImportStatus'] = message;
                    $scope.isAllOk = false;
                  } else {
                    row[key] = sixObjectLib.recordToHisRef(resolved);
                  }
                }
              }
            });
          }
        });
      });
    }
    return processed.map(function (item) {
      return {
        model: item
      };
    });
  }

  /* ******************************
   * GET DATA
   * ******************************/

  $scope.getData = function () {
    var payload = {
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      sort_fields: $scope.params.sortFields,
      show_revision: false,
      solve_inherit: true,
      query: $scope.params.queryParam
    };
    return listComponentFactory($scope.menu.selected.code).search(payload, $scope.params.filters).$promise.then(function (result) {
      if (errorService.handleError(result)) {
        $scope.components.list = result.list || [];
        $scope.components.totalResults = result.totalResults;
      } else {
        $scope.components.list.length = 0;
        $scope.components.totalResults = 0;
        toaster.pop('error', 'Errore', 'Errore durante il caricamento dati');
      }
      if ($scope.params.sixApi) {
        $scope.params.sixApi.refreshList($scope.components.list);
      }
      return result;
    }, function (err) {
      $scope.components.list.length = 0;
      $scope.components.totalResults = 0;
      toaster.pop('error', 'Errore', 'Errore durante il caricamento dati');
      $log.error(err);
      return err;
    });
  };
  $scope.getAll = function () {
    var payload = {
      page_size: 10000,
      sort_fields: $scope.params.sortFields,
      show_revision: false,
      solve_inherit: true
    };
    return listComponentFactory($scope.menu.selected.code).search(payload, $scope.params.filters).$promise;
  };
  function updateColumnDefs() {
    $scope.menu.selected.columnDefs.forEach(function (col) {
      if (col.type == 'date') {
        col.filters = [{
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
          placeholder: 'da...',
          condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
        }, {
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
          placeholder: 'a...',
          condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
        }];
      } else if (col.type == 'number') {
        col.filters = [{
          type: sixGridPaginationConstants.filterType.NUMBER,
          relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
          placeholder: 'da...',
          condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
        }, {
          type: sixGridPaginationConstants.filterType.NUMBER,
          relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
          placeholder: 'a...',
          condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
        }];
      } else if (col.lookup) {
        col.cellTemplate = '<div class="ui-grid-cell-contents {{grid.appScope.cellClassFormatter(undefined, row)}}" title="{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}">{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}</div>';
        col.filters = [{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }];
      }
    });
    $scope.gridDetailOptions.columnDefs = angular.copy($scope.menu.selected.columnDefs);
    $scope.importGridOptions.columnDefs = angular.copy($scope.menu.selected.columnDefs);
    $scope.importGridOptions.columnDefs.push({
      displayName: 'Stato',
      field: 'model.sixImportStatus'
    });
    if ($scope.importGridApi) {
      $timeout(function () {
        $scope.importGridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
      }, 50);
    }
  }

  /**********************/
  /****** Watchers ******/
  /**********************/

  $scope.$watch(function () {
    return $scope.mode.mode;
  }, function (newVal, oldVal) {
    if (newVal) {
      if ($scope.mode.mode === 'import') {
        $scope.components.list = [];
        $scope.components.totalResults = 0;
        $scope.importGridOptions.data = [];
      } else {
        $scope.getData();
      }
    }
  });

  //dati caricati da xls
  $scope.$watch(function () {
    return $scope.importGridOptions.xlsData;
  }, function (newValue, oldValue) {
    if ($scope.importGridOptions.xlsData && $scope.importGridOptions.xlsData.length > 0) {
      $scope.importGridOptions.data = processData($scope.importGridOptions.xlsData);
    }
  });

  /*****************************/
  /***** UI GRID Callbacks *****/
  /*****************************/

  function saveRowCallback(rowEntity) {
    $scope.percent = 0;
    var promise = $q.defer();
    $scope.gridApiDetail.rowEdit.setSavePromise(rowEntity, promise.promise);
    if (!rowEntity || !rowEntity.date) {
      toaster.pop('error', 'Errore', 'Errore durante l\'aggiornamento');
      promise.reject();
    } else {
      $scope.saveOrUpdate(rowEntity);
      promise.resolve();
    }
  }

  /*********************/
  /**** Date picker ****/
  /*********************/

  $scope.upperDate = new Date();
  $scope.dateOptions = {
    formatYear: 'yy',
    startingDay: 1
  };
  $scope.open = function ($event) {
    $scope.status.opened = true;
  };
  $scope.status = {
    opened: false
  };

  /*************************************/
  /*********** Template xlsx ***********/
  /*************************************/

  function buildDataType(prop) {
    if (prop.type === 'string' && prop.format === 'date') {
      return 'yyyy-MM-dd';
    } else if (prop.type === 'string' && prop.format === 'lookup') {
      return 'ref';
    } else if (prop.type === 'integer') {
      return 1;
    } else if (prop.type === 'number') {
      return 1.234;
    } else if (prop.type === 'object') {
      var obj = {};
      for (var key in prop.properties) {
        obj[key] = buildDataType(prop.properties[key]);
      }
      return JSON.stringify(obj);
    }
    return 'text';
  }
  function columnsToSheet() {
    var ws = {};
    var range = {
      s: {
        c: 10000000,
        r: 10000000
      },
      e: {
        c: 0,
        r: 0
      }
    };
    var data = [[], []];
    $scope.menu.selected.columnDefs.forEach(function (col) {
      // Intestazione di colonna
      data[0].push(col.field.replace('model.', ''));
    });
    for (var R = 0; R != data.length; ++R) {
      for (var C = 0; C != data[R].length; ++C) {
        if (range.s.r > R) range.s.r = R;
        if (range.s.c > C) range.s.c = C;
        if (range.e.r < R) range.e.r = R;
        if (range.e.c < C) range.e.c = C;
        var cell = {
          v: data[R][C]
        };
        if (cell.v == null) continue;
        var cell_ref = XLSX.utils.encode_cell({
          c: C,
          r: R
        });
        if (typeof cell.v === 'number') cell.t = 'n';else if (typeof cell.v === 'boolean') cell.t = 'b';else if (cell.v instanceof Date) {
          cell.t = 'n';
          cell.z = XLSX.SSF._table[14];
          cell.v = datenum(cell.v);
        } else cell.t = 's';
        ws[cell_ref] = cell;
      }
    }
    if (range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
    return ws;
  }
  function Workbook() {
    if (!(this instanceof Workbook)) return new Workbook();
    this.SheetNames = [];
    this.Sheets = {};
  }
  function datenum(v, date1904) {
    if (date1904) v += 1462;
    var epoch = Date.parse(v);
    return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
  }
  $scope.createTemplate = function () {
    //var ranges = oo[1];

    /* original data */
    var ws_name = $scope.menu.selected.code;
    var wb = new Workbook();
    var ws = columnsToSheet();

    /* add ranges to worksheet */
    //ws['!merges'] = ranges;

    /* add worksheet to workbook */
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    var wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      bookSST: false,
      type: 'binary'
    });
    saveAs(new Blob([s2ab(wbout)], {
      type: "application/octet-stream"
    }), $scope.menu.selected.code + ".xlsx");
  };
  function s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
  }

  /** ***********************************
   * GRID FORMATTERS
   * ***********************************/

  $scope.lookupCellValueFormatter = function (value) {
    var formatted = "";
    if (typeof value != "undefined") {
      if (Object.prototype.toString.call(value) === '[object Array]') {
        for (var v in value) {
          formatted += value[v].code + " (" + value[v].description + "); ";
        }
      } else {
        formatted = value.code + " (" + value.description + ")";
      }
    }
    return formatted;
  };
  $scope.gridAppCallbacks['lookupCellValueFormatter'] = $scope.lookupCellValueFormatter;
  $scope.selectComponent = function (component) {
    $scope.menu.selected = component;
    updateColumnDefs();
    $timeout(function () {
      $scope.getData();
    }, 100);
  };

  /** ***********************************
   * INIT
   * ***********************************/

  // $scope.menu.selected = gasComponentFactory.getType($routeParams.type);

  if ($routeParams.menuType === 'gas') {
    $scope.menu.list = gasComponentFactory.getTypes();
    $scope.menu.selected = $scope.menu.list['pfor'];
    updateColumnDefs();
  }

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'list/component/{entity}';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:PriceListSimulatorCtrl
 * @description
 * # PriceListComponentCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/pricelist/sim/:sim_type', {
    templateUrl: 'energy/pricelist/pricelist_sim.html',
    controller: 'PriceListSimulatorCtrl'
  });
}]).controller('PriceListSimulatorCtrl', ["$scope", "$routeParams", "$timeout", "$rootScope", "$log", "$filter", "$location", "authFactory", "energyCarrierFactory", "recordFactory", "componenttypefactory", "listComponentFactory", "voltageClassFactory", "contractFactory", "priceListFactory", "simulationFactory", "$q", "toaster", "errorService", "uiGridConstants", "dialogService", "sixGridPaginationConstants", function ($scope, $routeParams, $timeout, $rootScope, $log, $filter, $location, authFactory, energyCarrierFactory, recordFactory, componenttypefactory, listComponentFactory, voltageClassFactory, contractFactory, priceListFactory, simulationFactory, $q, toaster, errorService, uiGridConstants, dialogService, sixGridPaginationConstants) {
  var SHOW_ERROR_POPUP = true;
  $scope.ELETTRICITA = 'elettricita';
  $scope.GAS = 'gas';
  $scope.simType = $scope.ELETTRICITA; // 'elettricita' o 'gas'
  $scope.contatoreTypeFilter = undefined;
  $scope.vettore = {
    id: {}
  };
  $scope.advancedStatus = {
    open: false
  };
  $scope.advancedPriceListStatus = {
    open: true
  };

  // Parametri comuni per elettricita e gas
  $scope.params = {};
  $scope.params.contatoreType = {};
  $scope.params.contatore = {};
  $scope.params.code;
  $scope.params.year = new Date().getFullYear().toString();
  //$scope.params.month = sixDateLib.getMonthName(new Date().getMonth());
  $scope.params.month = 'Gennaio';
  $scope.params.algorithmType = {};
  $scope.params.fornitore = {};
  resetParams();
  $scope.ee_columnDefs = [{
    name: 'Data',
    field: 'date',
    type: 'date',
    sort: {
      direction: 'asc'
    },
    cellFilter: 'date: "MMMM-yyyy"',
    minWidth: 100
  }, {
    name: 'PE M',
    field: 'pem',
    cellFilter: 'number: 4',
    minWidth: 100
  }, {
    name: 'PE F1',
    field: 'pef1',
    cellFilter: 'number: 4',
    minWidth: 100
  }, {
    name: 'PE F2',
    field: 'pef2',
    cellFilter: 'number: 4',
    minWidth: 100
  }, {
    name: 'PE F3',
    field: 'pef3',
    cellFilter: 'number: 4',
    minWidth: 100
  }, {
    name: 'PE F23',
    field: 'pef23',
    cellFilter: 'number: 4',
    minWidth: 100
  }, {
    name: 'Tot. servizi rete',
    field: 'tot_rete',
    cellFilter: 'number: 4',
    minWidth: 100
  }, {
    name: 'Tot. oneri',
    field: 'tot_oneri',
    cellFilter: 'number: 4',
    minWidth: 100
  }, {
    name: 'Tot. accise',
    field: 'tot_accise',
    cellFilter: 'number: 4',
    minWidth: 100
  }, {
    name: 'Tot. Monorario',
    field: 'tot_monorario',
    cellFilter: 'number: 4',
    minWidth: 100
  }, {
    name: 'Tot. F1',
    field: 'tot_f1',
    cellFilter: 'number: 4',
    minWidth: 100
  }, {
    name: 'Tot. F2',
    field: 'tot_f2',
    cellFilter: 'number: 4',
    minWidth: 100
  }, {
    name: 'Tot. F3',
    field: 'tot_f3',
    cellFilter: 'number: 4',
    minWidth: 100
  }, {
    name: 'Tot. F23',
    field: 'tot_f23',
    cellFilter: 'number: 4',
    minWidth: 100
  }];
  $scope.gas_columnDefs = [{
    name: 'Data',
    field: 'date',
    type: 'date',
    sort: {
      direction: 'asc'
    },
    cellFilter: 'date: "MMMM-yyyy"',
    minWidth: 100
  }, {
    name: 'CCI periodo',
    field: 'cci',
    minWidth: 100
  }, {
    name: 'CCI t',
    field: 'cci_t',
    cellFilter: 'number: 4',
    minWidth: 100
  }, {
    name: 'PFOR t (196.13)',
    field: 'pfor_t_19613',
    cellFilter: 'number: 4',
    minWidth: 100
  }, {
    name: 'PFOR t (196.13, 38.10)',
    field: 'pfor_t_19613_3810',
    cellFilter: 'number: 4',
    minWidth: 100
  }, {
    name: 'PCS Sim',
    field: 'pcs_sim',
    cellFilter: 'number: 4',
    minWidth: 100
  }, {
    name: 'PFOR (PCS comune)',
    field: 'pfor_pcs_comune',
    cellFilter: 'number: 4',
    minWidth: 100
  }, {
    name: 'Spread',
    field: 'spread',
    cellFilter: 'number: 4',
    minWidth: 100
  }, {
    name: 'QTmcv',
    field: 'qtmcv',
    cellFilter: 'number: 4',
    minWidth: 100
  }, {
    name: 'Tot. vendita',
    field: 'tot_vendita',
    cellFilter: 'number: 4',
    minWidth: 100
  }, {
    name: 'QF',
    field: 'qf',
    cellFilter: 'number: 4',
    minWidth: 100
  }, {
    name: 'TD Var',
    field: 'td_var',
    cellFilter: 'number: 4',
    minWidth: 100
  }, {
    name: 'Add. regionale',
    field: 'add_regionale',
    cellFilter: 'number: 4',
    minWidth: 100
  }, {
    name: 'Accisa',
    field: 'accisa',
    cellFilter: 'number: 4',
    minWidth: 100
  }, {
    name: 'Tot. accise',
    field: 'tot_accise',
    cellFilter: 'number: 4',
    minWidth: 100
  }, {
    name: 'Imponibile un.',
    field: 'imponibile_unitario',
    cellFilter: 'number: 4',
    minWidth: 100
  }, {
    name: 'Imponibile',
    field: 'imponibile',
    cellFilter: 'number: 4',
    minWidth: 100
  }, {
    name: 'IVA',
    field: 'iva',
    cellFilter: 'percentage: 2',
    minWidth: 100
  }, {
    name: 'Costo finale + IVA',
    field: 'costo_finale_iva',
    cellFilter: 'currency: "€": 4',
    minWidth: 100
  }];
  var paginationOptions = {
    pageNumber: 1,
    pageSize: 15
  };

  // elettricita
  $scope.tensioneList = [{
    code: '1',
    description: '1 kV',
    value: 1
  }, {
    code: '35',
    description: '35 kV',
    value: 35
  }, {
    code: '150',
    description: '150 kV',
    value: 150
  }, {
    code: '220',
    description: '220 kV',
    value: 220
  }, {
    code: '380',
    description: '380 kV',
    value: 380
  }];

  // Gas
  $scope.deliberaEEGList = [{
    code: 'arg_gas_64_09',
    description: 'ARG/gas 64/09'
  }, {
    code: 'arg_gas_77_11',
    description: 'ARG/gas 77/11'
  }, {
    code: 'arg_gas_117_12',
    description: 'ARG/gas 117/12'
  }, {
    code: 'arg_gas_385_12',
    description: 'ARG/gas 385/12'
  }, {
    code: 'arg_gas_196_13',
    description: 'ARG/gas 196/13'
  }, {
    code: 'cond_tutela',
    description: 'Condizioni di tutela'
  }];
  $scope.pcsSimTypeList = [{
    code: 'pcs_comune',
    description: 'PCS Comune'
  }, {
    code: 'pcs_std',
    description: $scope.params.pcs_std
  }];
  $scope.algorithmTypes = [{
    code: 'fisso'
  }, {
    code: 'monomia'
  }, {
    code: 'binomia'
  }];
  $scope.pcsStdList = [Number('38.100'), Number('38.52')];
  $scope.pcsList = [Number('38.100'), Number('38.52')];

  // Grid
  $scope.listGridOptions = {
    paginationPageSizes: [10, 20, 30],
    paginationPageSize: 10,
    useExternalPagination: false,
    enableHorizontalScrollbar: true,
    columnDefs: [{
      displayName: '',
      field: 'model.code',
      enableFiltering: false,
      width: 36,
      cellTemplate: '<div class="ui-grid-cell-contents"><button type="button" class="btn btn-xs btn-primary" ng-click="grid.appScope.load(row.entity.version)"><i class="fa fa-search"></i></button></div>'
    }, {
      displayName: 'Codice',
      field: 'model.code'
    }, {
      displayName: '',
      field: 'model.code',
      width: 40,
      cellTemplate: '<div class="ui-grid-cell-contents"><button type="button" class="btn btn-xs btn-danger" ng-click="grid.appScope.deleteWithDialog(row.entity.version)" ng-disabled="grid.appScope.isDeletePermAllowed()===false"><i class="fa fa-trash"></i></button></div>'
    }]
  };
  $scope.gridOptions = {
    paginationPageSizes: [10, 20, 30],
    paginationPageSize: 20,
    useExternalPagination: false,
    enableHorizontalScrollbar: true
  };

  // Grid
  $scope.priceListGridOptions = {
    paginationPageSizes: [10, 15, 20, 30],
    paginationPageSize: 15,
    useExternalPagination: true,
    enableHorizontalScrollbar: true,
    columnDefs: [{
      displayName: '',
      field: 'model.code',
      enableFiltering: false,
      width: 34,
      cellTemplate: '<div class="ui-grid-cell-contents"><button type="button" class="btn btn-xs btn-primary" ng-click="grid.appScope.loadPriceList(row.entity.UUID)"><i class="fa fa-search"></i></button></div>'
    }, {
      displayName: 'Codice',
      field: 'model.code',
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }, {
      displayName: 'Descrizione',
      field: 'model.description',
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }, {
      displayName: 'Fornitore',
      field: 'model.fornitore_id',
      cellTemplate: '<div class="ui-grid-cell ui-grid-cell-contents">{{grid.getCellValue(row, col).description}} ({{grid.getCellValue(row, col).code}})</div>',
      filters: [{
        type: sixGridPaginationConstants.filterType.SIXLOOKUP,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }, {
      displayName: 'Vettore',
      field: 'model.vettore_id',
      cellTemplate: '<div class="ui-grid-cell ui-grid-cell-contents">{{grid.getCellValue(row, col).description}}</div>',
      filters: [{
        type: sixGridPaginationConstants.filterType.SIXLOOKUP,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }]
  };
  $scope.simulate = function () {
    if (checkRequiredParams() === true) {
      var params = {};
      if ($scope.simType === $scope.ELETTRICITA) {
        params.date = new Date($scope.params.year, sixDateLib.getMonthIndex($scope.params.month), 1);
        params.utenza = $scope.params.utenza.id;
        params.regime_fiscale = $scope.params.regimeFiscale.id;
        params.tensione = $scope.params.tensione.selected.value;
        params.livello_tensione = $scope.params.livelloTensione;
        params.potenza_impegnata = $scope.params.potenzaImpegnata;
        params.potenza_disponibile = $scope.params.potenzaDisponibile;
        params.tiv = $scope.params.tiv;
        params.tit = $scope.params.tit;
        params.perdite = $scope.params.perdite;
        params.comune = $scope.params.comune.id;
        params.provincia = $scope.params.provincia.id;
        params.regione = $scope.params.regione.id;
        params.potenza_max = $scope.params.potenzaMax;
        params.consumptions = $scope.params.consumptions;
        params.spread = $scope.params.spread;
      } else if ($scope.simType === $scope.GAS) {
        params.date = new Date($scope.params.year, sixDateLib.getMonthIndex($scope.params.month), 1);
        params.regime_fiscale = $scope.params.regimeFiscale.id;
        params.comune = $scope.params.comune.id;
        params.provincia = $scope.params.provincia.id;
        params.regione = $scope.params.regione.id;
        params.ambito_tariffario = $scope.params.ambitoTariffario.id;
        params.tipologia_cliente = $scope.params.tipologiaCliente.id;
        params.delibera_aeeg = $scope.params.deliberaAEEG.code;
        params.spread = $scope.params.spread;
        params.tf = $scope.params.tf;
        params.pcs_std = parseFloat($scope.params.pcsStd);
        params.pcs_sim = parseFloat($scope.params.pcsSim);
        params.classe_misuratore = $scope.params.classeMisuratore;
        params.consumptions = $scope.params.consumptions;
        params.tipo_algoritmo = $scope.params.algorithmType.code;
        params.fornitore = $scope.params.fornitore.id;
        params.fisso = $scope.params.fisso;
      }
      $scope.gridOptions.data = [];
      if ($scope.simType === $scope.ELETTRICITA) {
        $scope.gridOptions.columnDefs = $scope.ee_columnDefs;
      } else if ($scope.simType === $scope.GAS) {
        $scope.gridOptions.columnDefs = $scope.gas_columnDefs;
      }
      simulationFactory.simulate({
        param1: $scope.simType
      }, params).$promise.then(function (resp) {
        if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
          console.log(resp);
          for (var d in resp.list) {
            var r = angular.copy(resp.list[d]);
            r.date = new Date(d);
            $scope.gridOptions.data.push(r);
          }
        } else {
          toaster.pop('error', 'Errore', 'Impossibile completare la simulazione');
        }
      });
    }
  };
  function checkRequiredParams() {
    if ($scope.simType === $scope.ELETTRICITA) {
      var error = getErrorMessage(['params.year', 'params.month', 'params.tiv', 'params.tit', 'params.comune.id', 'params.potenzaMax']);
      if (angular.isUndefined(error)) {
        return true;
      }
      toaster.pop('error', 'Errore', error);
      return false;
    } else if ($scope.simType === $scope.GAS) {
      var error = getErrorMessage(['params.year', 'params.month', 'params.tipologiaCliente.id', 'params.comune.id', 'params.deliberaAEEG.code']);
      if (angular.isUndefined(error)) {
        return true;
      }
      toaster.pop('error', 'Errore', error);
      return false;
    }
    toaster.pop('error', 'Errore', 'Tipo simulazione non riconosciuto: ' + $scope.simType);
    return false;
  }
  function getErrorMessage(params) {
    var msg = undefined;
    var sep = '';
    for (var i in params) {
      var v = getDescendantProp($scope, params[i]);
      $log.log(params[i] + ' -> ' + v);
      if (angular.isUndefined(v)) {
        if (angular.isUndefined(msg)) {
          msg = '';
        }
        msg += sep + params[i];
        sep = ', ';
      }
    }
    if (angular.isDefined(msg)) {
      msg += ' non definiti';
    }
    return msg;
  }
  function getDescendantProp(obj, desc) {
    var arr = desc.split(".");
    while (arr.length && (obj = obj[arr.shift()]));
    return obj;
  }

  /********************/
  /***** WATCHERS *****/
  /********************/

  $scope.$watch(function () {
    return $scope.params.comune.obj;
  }, function (newVal, oldVal) {
    if (newVal && $scope.params.comune.obj && $scope.params.comune.obj.model && $scope.params.comune.obj.model.provincia_id) {
      recordFactory('provincia').byUUID({
        id: $scope.params.comune.obj.model.provincia_id.UUID
      }).$promise.then(function (resp) {
        if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
          $scope.params.provincia.id = sixObjectLib.recordToHisRef(resp);
        } else {
          toaster.pop('error', 'Errore', 'Impossibile recuperare la provincia ' + $scope.params.comune.obj.model.regione_id.UUID);
          $scope.params.provincia.id = {};
        }
      });
    } else {
      $scope.params.provincia.id = {};
    }
  });
  $scope.$watch(function () {
    return $scope.params.provincia.obj;
  }, function (newVal, oldVal) {
    if (newVal && $scope.params.provincia.obj && $scope.params.provincia.obj.model && $scope.params.provincia.obj.model.regione_id) {
      recordFactory('regione').byUUID({
        id: $scope.params.provincia.obj.model.regione_id.UUID
      }).$promise.then(function (resp) {
        if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
          $scope.params.regione.id = sixObjectLib.recordToHisRef(resp);
        } else {
          toaster.pop('error', 'Errore', 'Impossibile recuperare la regione ' + $scope.comune.obj.regione_id.UUID);
          $scope.params.regione.id = {};
        }
      });
    } else {
      $scope.params.regione.id = {};
    }
  });
  $scope.$watch(function () {
    return $scope.params.regione.obj;
  }, function (newVal, oldVal) {
    if (newVal && $scope.params.regione.obj && $scope.params.regione.obj.model && $scope.params.regione.obj.model.ambito_id) {
      recordFactory('ambitotariffario').byUUID({
        id: $scope.params.regione.obj.model.ambito_id.UUID
      }).$promise.then(function (resp) {
        if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
          $scope.params.ambitoTariffario.id = sixObjectLib.recordToHisRef(resp);
        } else {
          toaster.pop('error', 'Errore', 'Impossibile recuperare l\'ambito tariffario ' + $scope.params.regione.obj.model.ambito_id.UUID);
          $scope.params.ambitoTariffario.id = {};
        }
      });
    } else {
      $scope.params.ambitoTariffario.id = {};
    }
  });
  $scope.$watch(function () {
    return $scope.params.tensione.selected;
  }, function (newVal, oldVal) {
    if (newVal && $scope.params.tensione.selected && $scope.params.tensione.selected.value) {
      voltageClassFactory.show({
        id: $scope.params.tensione.selected.value
      }).$promise.then(function (resp) {
        if (errorService.handleError(resp)) {
          $scope.params.livelloTensione.id = sixObjectLib.recordToHisRef(resp);
        } else {
          toaster.pop('error', 'Errore', 'Impossibile recuperare il livello di tensione per ' + $scope.tensione.selected.description);
          $scope.params.livelloTensione.id = {};
        }
      });
    } else {
      $scope.params.livelloTensione.id = {};
    }
  });
  $scope.$watch(function () {
    return $scope.params.utenza.obj;
  }, function (newVal, oldVal) {
    if ($scope.simType === $scope.ELETTRICITA) {
      if (newVal && $scope.params.utenza.obj && $scope.params.utenza.obj.model && $scope.params.utenza.obj.model.regimefiscale_id) {
        recordFactory('regimefiscale').byUUID({
          id: $scope.params.utenza.obj.model.regimefiscale_id.UUID
        }).$promise.then(function (resp) {
          if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
            $scope.params.regimeFiscale.id = sixObjectLib.recordToHisRef(resp);
          } else {
            toaster.pop('error', 'Errore', 'Impossibile recuperare il regime fiscale per l\'utenza ' + $scope.params.utenza.id.code);
            $scope.params.regimeFiscale.id = {};
          }
        });
      } else {
        $scope.params.regimeFiscale.id = {};
      }
    }
  });
  $scope.$watchGroup(['params.utenza.id.UUID', 'params.livelloTensione.id.UUID', 'params.potenzaImpegnata', 'params.potenzaDisponibile'], function (newVal, oldVal) {
    resetContractData();
    if (newVal) {
      updateContract();
    }
  });
  $scope.$watchGroup(['params.livelloTensione.id', 'params.year', 'params.month'], function (newVal, oldVal) {
    if (newVal && $scope.params.livelloTensione.id && $scope.params.tensione.selected && $scope.params.year && $scope.params.month) {
      var dateStr = $scope.params.year + '-' + ('0' + (sixDateLib.getMonthIndex($scope.params.month) + 1)).slice(-2) + '-01';
      var query = {
        tensione: $scope.params.tensione.selected.value
      };
      query['tipo_utenza_id.UUID'] = $scope.params.livelloTensione.id.UUID;
      listComponentFactory('perdite').perdite({
        date: dateStr
      }, query).$promise.then(function (resp) {
        if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
          if (resp.model) {
            $scope.params.perdite = resp.model.fattore;
          } else {
            toaster.pop('error', 'Errore', 'Impossibile recuperare le perdite per: utenza ' + $scope.params.livelloTensione.id.code + ', tensione ' + $scope.params.tensione.selected.value + ', anno ' + $scope.params.year + ', mese ' + $scope.params.month);
            $scope.params.perdite = undefined;
          }
        } else {
          toaster.pop('error', 'Errore', 'Impossibile recuperare le perdite per: utenza ' + $scope.params.livelloTensione.id.code + ', tensione ' + $scope.params.tensione.selected.value + ', anno ' + $scope.params.year + ', mese ' + $scope.params.month);
          $scope.params.perdite = undefined;
        }
      });
    } else {
      $scope.params.perdite = undefined;
    }
  });
  $scope.$watch(function () {
    return $scope.simType;
  }, function (newVal, oldVal) {
    if (newVal) {
      $location.path('/pricelist/sim/' + $scope.simType);
    }
  });
  $scope.$watchGroup(['params.d', 'params.cg', 'params.ambitoTariffario.id.UUID'], function (newVal, oldVal) {
    if (newVal) {
      var cg = parseFloat($scope.params.cg);
      var d = parseFloat($scope.params.d);
      if (isFinite(cg) && isFinite(d) && $scope.params.ambitoTariffario.id && $scope.params.ambitoTariffario.id.UUID) {
        var params = {};
        params.date = new Date($scope.params.year, sixDateLib.getMonthIndex($scope.params.month), 1);
        params.cg = cg;
        params.d = d;
        params.ambito_tariffario = $scope.params.ambitoTariffario.id;
        simulationFactory.binomia(params).$promise.then(function (resp) {
          if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
            $scope.params.tf = parseFloat(resp.tf.toFixed(6));
          } else {
            toaster.pop('error', 'Errore', 'Impossibile simulare TF: ambito tariffario = ' + $scope.params.ambitoTariffario.id.code + ', Cg = ' + cg + ', D = ' + d + ', anno = ' + $scope.params.year);
            $scope.params.tf = undefined;
          }
        });
      } else {
        $scope.params.tf = undefined;
      }
    }
  });

  // spread
  $scope.$watchGroup(['params.fornitore.id.UUID', 'params.algorithmType', 'params.month', 'params.comune.id.UUID'], function (newVal, oldVal) {
    if (newVal && $scope.params.fornitore.id && $scope.params.algorithmType && $scope.params.comune.id) {
      var date = new Date($scope.params.year, sixDateLib.getMonthIndex($scope.params.month), 1);
      var dateStr = $filter('date')(date, 'yyyy-MM-dd');
      simulationFactory.spread({
        param2: $scope.simType,
        param3: dateStr,
        param4: $scope.params.algorithmType.code,
        param5: $scope.params.fornitore.id.UUID,
        param6: $scope.params.comune.id.UUID
      }).query().$promise.then(function (resp) {
        if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
          $scope.params.spread = resp.spread;
          $scope.params.fisso = resp.fisso;
        } else {
          toaster.pop('error', 'Errore', 'Impossibile recuperare il parametro spread per tipo = ' + $scope.simType + ', data = ' + dateStr + ' contratto = ' + $scope.params.algorithmType.code + ', fornitore = ' + $scope.params.fornitore.id.code + ', comune = ' + $scope.params.comune.id.code);
        }
      });
    }
  });
  $scope.$watchGroup(['params.contatore.id.UUID', 'params.year', 'params.month'], function (newVal, oldVal) {
    if (newVal && $scope.params.contatore.id && $scope.params.contatore.id.UUID) {
      resetParams();
      var date = new Date($scope.params.year, sixDateLib.getMonthIndex($scope.params.month), 1);
      simulationFactory.params({
        param1: $scope.simType,
        param2: $scope.params.contatoreType.id.UUID,
        param3: $scope.params.contatore.id.UUID,
        date: date
      }).$promise.then(function (resp) {
        if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
          $scope.params.comune.id = resp.comune;
          $scope.params.regimeFiscale.id = resp.regime_fiscale;
          //$scope.params.consumptions = resp.consumptions;
          for (var i in resp.consumptions) {
            $scope.params.consumptions[i] = parseFloat(resp.consumptions[i].toFixed(4));
          }
          if ($scope.simType === $scope.ELETTRICITA) {
            $scope.params.utenza.id = resp.utenza;
            $scope.params.potenzaMax = resp.potenza_max;
            $scope.params.potenzaImpegnata = resp.potenza_impegnata;
            $scope.params.potenzaDisponibile = resp.potenza_disponibile;
            $scope.params.tensione.selected = {
              code: resp.tensione,
              description: resp.tensione + ' kWh',
              value: parseFloat(resp.tensione)
            };
          } else if ($scope.simType === $scope.GAS) {
            $scope.params.pcsSim = resp.pcs_sim;
            $scope.params.tipologiaCliente.id = resp.tipologia_cliente;
            $scope.params.cg = resp.cg;
            $scope.params.d = resp.d;
            $scope.params.classeMisuratore = resp.classe_misuratore;
          }
        } else {
          toaster.pop('error', 'Errore', 'Impossibile recuperare i parametri per ' + $scope.params.contatoreType.id.code + ' ' + $scope.params.contatore.id.code);
        }
      }, function (err) {
        $log.error('ERROR - ' + err);
      });
    }
  });
  $scope.$watch(function () {
    return $scope.vettore.id;
  }, function (newVal, oldVal) {
    if (newVal) {
      updateContatoreTypeFilter();
    }
  });
  function updateContract() {
    if ($scope.params.utenza.id && $scope.params.utenza.id.UUID && $scope.params.livelloTensione.id && $scope.params.livelloTensione.id.UUID && $scope.params.potenzaImpegnata && $scope.params.potenzaDisponibile) {
      var query = {
        utenza: $scope.params.utenza.id.UUID,
        livello_tensione: $scope.params.livelloTensione.id.UUID,
        pot_impegnata: $scope.params.potenzaImpegnata,
        pot_disponibile: $scope.params.potenzaDisponibile
      };
      contractFactory.find(query).$promise.then(function (resp) {
        if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
          $scope.params.numContratto = resp.model.code;
          $scope.params.tipoContratto = resp.model.description;
          $scope.params.tiv = resp.model.tiv;
          $scope.params.tit = resp.model.tit;
        } else {
          toaster.pop('error', 'Errore', 'Impossibile recuperare il contratto per: utenza ' + $scope.params.utenza.id.code + ', tensione ' + $scope.params.livelloTensione.id.description + ', pot. impegnata ' + $scope.params.potenzaImpegnata + ', pot. disponibile ' + $scope.params.potenzaDisponibile);
          resetContractData();
        }
      });
    } else {
      resetContractData();
    }
  }
  function resetContractData() {
    $scope.params.numContratto = '';
    $scope.params.tipoContratto = '';
    $scope.params.tiv = '';
    $scope.params.tit = '';
  }
  $scope.simulateElettric = function () {
    $scope.simType = $scope.ELETTRICITA;
    //$log.info($scope.simType);
    //$scope.simType === $scope.ELETTRICITA
  };

  $scope.simulateGas = function () {
    //$log.info($scope.simType);
    $scope.simType = $scope.GAS;
  };
  $scope.saveOrUpdate = function () {
    $scope.form.$submitted = true;
    if ($scope.form.$valid) {
      var toSave = angular.copy($scope.params);
      delete toSave.comune.obj;
      delete toSave.provincia.obj;
      delete toSave.regione.obj;
      delete toSave.utenza.obj;
      delete toSave.regimeFiscale.obj;
      simulationFactory.save({
        id: $scope.simType
      }, $scope.params).$promise.then(function (resp) {
        if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
          toaster.pop('success', 'Salvataggio', 'Salvataggio eseguito con successo');
          $scope.loadList();
        } else {
          toaster.pop('error', 'Errore', 'Errore durante il salvataggio');
        }
      });
    } else {
      toaster.pop('error', 'Errore', 'Codice non specificato');
    }
  };
  $scope.loadList = function () {
    simulationFactory.list({
      param1: $scope.simType
    }).$promise.then(function (resp) {
      if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
        $scope.listGridOptions.data = resp.list;
      } else {
        toaster.pop('error', 'Errore', 'Errore durante il caricamento');
      }
    });
  };
  $scope.load = function (itemId) {
    resetParams();
    $scope.params.contatore = {};
    $scope.params.contatoreType = {};
    simulationFactory.get({
      param1: $scope.simType,
      param2: itemId
    }).$promise.then(function (resp) {
      if (errorService.handleError(resp, SHOW_ERROR_POPUP) && resp.model) {
        $scope.params = resp.model;
      } else {
        toaster.pop('error', 'Errore', 'Errore durante il caricamento');
      }
    });
  };
  $scope.deleteWithDialog = function (itemId) {
    dialogService.confirmDialog('Eliminare la simulazione?', function () {
      $scope["delete"](itemId);
    });
  };
  $scope["delete"] = function (itemId) {
    simulationFactory["delete"]({
      param1: $scope.simType,
      param2: itemId
    }).$promise.then(function (resp) {
      if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
        $scope.loadList();
      } else {
        toaster.pop('error', 'Errore', 'Errore durante l\'eliminazione');
      }
    });
  };
  function updateContatoreTypeFilter() {
    if ($scope.vettore.id) {
      energyCarrierFactory.schemas({
        id: $scope.vettore.id.UUID
      }).$promise.then(function (response) {
        if (errorService.handleError(response, SHOW_ERROR_POPUP)) {
          $scope.contatoreTypeFilter = {
            'model.code': response.list.join()
          };
          $log.info($scope.contatoreTypeFilter);
        } else {
          toaster.pop('error', 'Errore', 'Errore durante il recupero dei modelli con vettore_id ' + $scope.vettore.id.code);
        }
      });
    }
  }

  /**********************/
  /***** Price List *****/
  /**********************/

  $scope.pricelist = {
    list: [],
    totalResults: 0
  };
  $scope.priceListParams = {
    pageNumber: 1,
    pageSize: 15,
    totalItems: 0,
    queryParam: undefined,
    filters: {}
  };
  $scope.priceListGridAppCallbacks = {};
  $scope.findPriceList = function () {
    var deferred = $q.defer();
    $timeout(function () {
      var filter = $scope.priceListParams.filters || {};
      filter['model.vettore_id.UUID'] = $scope.vettore.id.UUID;
      var payload = {
        page: $scope.priceListParams.pageNumber,
        page_size: $scope.priceListParams.pageSize,
        sort_fields: $scope.priceListParams.sortFields
      };
      priceListFactory.findAllByVector(payload, filter).$promise.then(function (result) {
        $scope.pricelist = result;
        deferred.resolve(result);
      });
    }, 50);
    return deferred.promise;
  };
  $scope.loadPriceList = function (uuid) {
    return priceListFactory.byUUID({
      id: uuid
    }).$promise.then(function (response) {
      if (errorService.handleError(response, SHOW_ERROR_POPUP)) {
        $scope.params.deliberaAEEG = response.model.delibera_aeeg;
        $scope.params.pcsStd = '' + response.model.pcs_std;
        $scope.params.algorithmType = response.model.type;
        $scope.params.fornitore.id = response.model.fornitore_id;
        $log.log(response);
      } else {
        toaster.pop('error', 'Errore', 'Errore durante il recuepro dei dati');
      }
      return response;
    });
  };
  $scope.priceListGridAppCallbacks['loadPriceList'] = $scope.loadPriceList;

  /*************************/
  /********* ROUTE *********/
  /*************************/

  if ($routeParams.sim_type) {
    $scope.simType = $routeParams.sim_type;
    recordFactory('vettoreenergetico').byCode({
      id: $scope.simType
    }).$promise.then(function (resp) {
      if (errorService.handleError(resp, SHOW_ERROR_POPUP)) {
        $scope.vettore.id = sixObjectLib.recordToHisRef(resp);
      } else {
        toaster.pop('error', 'Errore', 'Errore durante il recuepro dei dati');
      }
    });
    $scope.loadList();

    // FIXME cablone da togliere
    if ($scope.simType === $scope.ELETTRICITA) {
      $scope.um = 'c€/kWh';

      //$scope.params.consumptions[0] = 47340.0;
      //$scope.params.consumptions[1] = 32850.0;
      //$scope.params.consumptions[2] = 30970.0;
      //$scope.params.consumptions[3] = 31080.0;
      //$scope.params.consumptions[4] = 35600.0;
      //$scope.params.consumptions[5] = 48750.0;
      //$scope.params.consumptions[6] = 54350.0;
      //$scope.params.consumptions[7] = 56290.0;
      //$scope.params.consumptions[8] = 56990.0;
      //$scope.params.consumptions[9] = 53310.0;
      //$scope.params.consumptions[10] = 54930.0;
      //$scope.params.consumptions[11] = 47540.0;
    } else if ($scope.simType === $scope.GAS) {
      $scope.um = 'c€/SMC';

      //$scope.params.consumptions[0] = 83333.0;
      //$scope.params.consumptions[1] = 83333.0;
      //$scope.params.consumptions[2] = 83333.0;
      //$scope.params.consumptions[3] = 83333.0;
      //$scope.params.consumptions[4] = 83333.0;
      //$scope.params.consumptions[5] = 83333.0;
      //$scope.params.consumptions[6] = 83333.0;
      //$scope.params.consumptions[7] = 83333.0;
      //$scope.params.consumptions[8] = 83333.0;
      //$scope.params.consumptions[9] = 83333.0;
      //$scope.params.consumptions[10] = 83333.0;
      //$scope.params.consumptions[11] = 83333.0;
      //
      //$scope.params.month = 'Gennaio';
      //$scope.params.comune = {id: {type: 'comune', UUID: '035016', code: '035016'}, obj: {}};
      //$scope.params.tipologiaCliente = {id: {type: 'tipologiacliente', UUID: 'AVFJZnxvTmDQzQRR_-mW', code: 'altri_servizi'}, obj: {}};
      //$scope.params.regimeFiscale = {id: {type: 'regimefiscale', UUID: 'AVGHSam4pkq3TGYMNmCu', code: 'uso_industriale_agevolato'}, obj: {}};
      //$scope.params.deliberaAEEG = {code: 'arg_gas_196_13', description: 'ARG/gas 196/13'};
      //$scope.params.spread = 4.3;
      //$scope.params.tf = 0.0;
      //$scope.params.pcsSim = 39.370;
      //$scope.params.pcsSimType = {code: 'pcs_comune', description: 'PCS Comune'};
    }
  }

  /*************************/
  /********* UTILS *********/
  /*************************/

  function resetParams() {
    // Parametri comuni per elettricita e gas
    $scope.params.comune = {};
    $scope.params.provincia = {};
    $scope.params.regione = {};

    // Parametri elettricita
    $scope.params.utenza = {}; // readonly
    $scope.params.regimeFiscale = {}; // readonly
    $scope.params.tensione = {
      selected: undefined
    };
    $scope.params.livelloTensione = {}; // readonly
    $scope.params.potenzaImpegnata = undefined;
    $scope.params.potenzaDisponibile = undefined;
    $scope.params.numContratto = undefined; // readonly
    $scope.params.tipoContratto = undefined; // readonly
    $scope.params.tiv = undefined; // readonly
    $scope.params.tit = undefined; // readonly
    $scope.params.perdite = undefined;
    $scope.params.potenzaMax = undefined;
    $scope.params.potenzaImpegnataClass = undefined;
    $scope.params.potenzaDisponibileClass = undefined;
    $scope.params.consumptions = [];
    $scope.params.spread = undefined;

    // Parametri gas
    $scope.params.ambitoTariffario = {};
    $scope.params.tipologiaCliente = {};
    $scope.params.regimeFiscale = {};
    $scope.params.deliberaAEEG = {
      code: 'arg_gas_196_13',
      description: 'ARG/gas 196/13'
    };
    $scope.params.spread = undefined;
    $scope.params.fisso = undefined;
    $scope.params.tf = undefined;
    $scope.params.pcsStd = Number('38.100');
    $scope.params.pcsSim = undefined;
    $scope.params.cg = undefined;
    $scope.params.d = undefined;
    $scope.params.classeMisuratore = undefined;
    $scope.params.consumptions = [];
  }
  $scope.getMonths = function () {
    return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
  };
  $scope.getMonthName = function (monthIndex) {
    return sixDateLib.getMonthShortName(monthIndex);
  };
  $scope.onPcsStdSelect = function (selected) {
    var n = parseFloat(selected);
    if (!isFinite(n)) {
      return '';
    }
    $scope.pcsList = [selected];
    return selected;
  };
  $scope.onPcsSelect = function (selected) {
    var n = parseFloat(selected);
    if (!isFinite(n)) {
      return '';
    }
    return selected;
  };
  $scope.tagTransform = function (tag) {
    return '' + tag;
  };

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'list/simulation';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
}]);
angular.module('emma.energy').filter('percentage', ["$log", "$filter", function ($log, $filter) {
  return function (value, decimalPosition, scope) {
    return $filter('currency')(value * 100, '%', decimalPosition);
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:ConsumptionAnalysisCrossCtrl
 * @description
 * # ConsumptionAnalysisCrossCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/readsexport', {
    templateUrl: 'energy/readsexport/readsexport.html',
    controller: 'ReadsExportCtrl'
  });
}]).controller('ReadsExportCtrl', ["$scope", "energyCarrierFactory", "authFactory", "consumptionFactory", "recordFactory", "budgetFactory", "$q", "ENERGY_URL", "DEV", "consumptionAnalysisFactory", "$location", "$anchorScroll", "dialogService", "errorService", "toaster", "$window", "commissionFactory", "$filter", "APP_URL", "$http", "SaveAs", "$log", "cfpLoadingBar", "loadingBarService", "ngDialog", function ($scope, energyCarrierFactory, authFactory, consumptionFactory, recordFactory, budgetFactory, $q, ENERGY_URL, DEV, consumptionAnalysisFactory, $location, $anchorScroll, dialogService, errorService, toaster, $window, commissionFactory, $filter, APP_URL, $http, SaveAs, $log, cfpLoadingBar, loadingBarService, ngDialog) {
  var SHOW_ERROR_POPUP = true;
  $scope.vector = {
    id: {
      UUID: 'AVFEfyYUAX3d7qEPD3Zm',
      code: 'gas',
      description: 'Gas Naturale',
      type: 'vettoreenergetico'
    }
  };
  $scope.type = {};
  $scope.record = {};
  $scope.commissionList = [];
  $scope.commissions = {
    selected: []
  };
  $scope.contatoreTypeFilter = {
    'model.code': ''
  };
  $scope.recordFilter = {};
  $scope.datePicker = {
    from: new Date(new Date().getFullYear(), 0, 1),
    to: new Date(new Date().getFullYear(), 11, 31)
  };
  $scope.$watch(function () {
    return $scope.vector.id;
  }, function (newVal, oldVal) {
    $scope.type = {};
    updateContatoreTypeFilter();
  });
  $scope.$watch(function () {
    return $scope.type.type_id;
  }, function (newVal, oldVal) {
    $scope.record = {};
    if (angular.isDefined(newVal) && newVal !== oldVal) {
      updateRecordFilter();
    }
  });
  $scope.$watchCollection('commissions.selected', function (newVal, oldVal) {
    $scope.record = {};
    if (angular.isDefined(newVal) && newVal !== oldVal) {
      updateRecordFilter();
    }
  });
  function replaceAll(str, find, replace) {
    return str.replace(new RegExp(find, 'g'), replace);
  }

  /* **************** */
  /* **** REPORT **** */
  /* **************** */

  function dateTimeStringFormatted(date) {
    var dateStr = '';
    if (date instanceof Date) {
      dateStr = date.getDate() + "_" + (date.getMonth() + 1) + "_" + date.getFullYear() + "_" + date.getHours() + "_" + date.getMinutes() + "_" + date.getSeconds();
    }
    return dateStr;
  }
  var REPORT_JASPER_DIRECTORY = 'reports/EMMA/Energy/'; /* path del report su jasperserver */
  var REPORT_JASPER_NAME = 'readexports_xls'; /* path del report su jasperserver */
  var REPORT_XLS_JASPER_NAME = 'readexports_xls'; /* path del report su jasperserver */

  $scope.callJasper = function (extensionFile) {
    $scope.$broadcast('schemaFormValidate');
    var urlPrefix = DEV ? '/' : '/emma/';
    var endpointAddressGenericReport = $location.protocol() + '://' + $location.$$host + ':' + $location.$$port + urlPrefix + ENERGY_URL + '/api/readsexporter/_export';
    // var endpointAddressGenericReport = 'http://172.29.151.80:8080' + urlPrefix + ENERGY_URL + '/api/readsexporter/_export';
    var reportNameToSave = 'letture_' + dateTimeStringFormatted(new Date()); // nome con il quale viene salvato sul pc dell'utente
    // dove si trova il report su jasperserver (http://172.29.100.155:7878/jasperserver) + nome report .pdf
    var reportPath = REPORT_JASPER_DIRECTORY + REPORT_JASPER_NAME + '.' + extensionFile;
    if (extensionFile == 'xls' || extensionFile == 'xlsx') {
      // dove si trova il report su jasperserver (http://172.29.100.155:7878/jasperserver) + nome report .xls
      reportPath = REPORT_JASPER_DIRECTORY + REPORT_XLS_JASPER_NAME + '.' + extensionFile;
    }
    if (angular.isDefined($scope.datePicker.from) && angular.isDefined($scope.datePicker.to) && angular.isDefined($scope.type.type_id)) {
      // obbligatori: from, to, commesse
      var from = $scope.datePicker.from.getFullYear() + '-' + ('0' + ($scope.datePicker.from.getMonth() + 1)).slice(-2) + '-' + ('0' + $scope.datePicker.from.getDate()).slice(-2);
      var to = $scope.datePicker.to.getFullYear() + '-' + ('0' + ($scope.datePicker.to.getMonth() + 1)).slice(-2) + '-' + ('0' + $scope.datePicker.to.getDate()).slice(-2);
      var commissionsCsv = null;
      var vectorId = null;
      var contatoreTypeId = null;
      var contatoreUuid = null;
      var parametersToPrint = null;
      /* scarico i codici delle commesse */
      if ($scope.commissions.selected && $scope.commissions.selected.length > 0) {
        commissionsCsv = $scope.commissions.selected.map(function (c) {
          return c.key;
        }).join();
      }
      /* imposto il vettore corrente */
      if (angular.isDefined($scope.vector.id)) {
        vectorId = $scope.vector.id.UUID;
      }
      /* imposto il tipo contatore */
      if (angular.isDefined($scope.type.type_id)) {
        contatoreTypeId = $scope.type.type_id.code;
      }
      /* imposto l'UUID del contatore */
      if (angular.isDefined($scope.record.record_id)) {
        contatoreUuid = $scope.record.record_id.UUID;
      }
      endpointAddressGenericReport = endpointAddressGenericReport + '/' + commissionsCsv + '/' + contatoreTypeId + '/' + contatoreUuid + '/' + from + '/' + to;
      var query = '&net.sf.jasperreports.json.source=' + endpointAddressGenericReport;
      if (extensionFile == 'xls' || extensionFile == 'xlsx') {
        query += '&ignorePagination=true';
      }
      loadingBarService.start('Generazione report in corso...');
      $http.post(APP_URL + '/rest/report/generate', {
        path: reportPath,
        query: query
      }, {
        responseType: 'arraybuffer'
      }).success(function (data, status, headers, config) {
        var options;
        if (extensionFile == 'pdf') {
          options = {
            type: 'application/pdf'
          };
        } else if (extensionFile == 'xls' || extensionFile == 'xlsx') {
          options = {
            type: 'application/vnd.ms-excel;'
          };
        }
        SaveAs.download(data, reportNameToSave + '.' + extensionFile, options);
        loadingBarService.stop();
      }).error(function (data, status, headers, config) {
        loadingBarService.stop();
        toaster.pop('error', "Errore", 'Errore generazione report');
      });
    } else {
      toaster.pop('error', "Errore inserimento parametri", 'Parametri obbligatori: data inizio, data fine, tipo contatore');
    }
  };

  /*********************/
  /**** Date picker ****/
  /*********************/

  $scope.dateOptionsStart = {
    datepickerMode: 'month',
    minMode: 'month',
    formatYear: 'yy',
    startingDay: 1
  };
  $scope.dateOptionsEnd = {
    datepickerMode: 'month',
    minMode: 'month',
    formatYear: 'yy',
    startingDay: 1
  };
  $scope.setEndDate = function () {
    $scope.datePicker.to = new Date($scope.datePicker.to.getFullYear(), $scope.datePicker.to.getMonth() + 1, 0);
  };
  $scope.openFrom = function ($event) {
    $scope.statusFrom.opened = true;
  };
  $scope.openTo = function ($event) {
    $scope.statusTo.opened = true;
  };
  $scope.statusFrom = {
    opened: false
  };
  $scope.statusTo = {
    opened: false
  };
  var REPORT_BASE_DIR = "reports/EMMA/";
  var REPORT_API_BASE = $location.protocol() + '://' + location.host + '' + APP_URL + '/rest/report/';
  //var REPORT_API_BASE = "http://docker0.ict-group.it:7878/six/rest/report/";
  var REPORT_QUERY_BASE = "&net.sf.jasperreports.json.source=" + REPORT_API_BASE;
  var currentCommission = authFactory.getAuthData().info.commissions.current;
  $scope.generateReport = function (reportPath, query) {
    console.log("generation report " + (APP_URL + '/rest/report/generate') + " " + reportPath + " " + query);
    loadingBarService.start('Generazione report in corso...');
    $http.post(APP_URL + '/rest/report/generate', {
      path: reportPath,
      query: query
    }, {
      responseType: 'arraybuffer'
    }).then(function (data, status, headers, config) {
      loadingBarService.stop();
      var options = {
        type: 'application/pdf'
      };
      SaveAs.download(data, 'consumption_analysis.pdf', options);
    }, function (data, status, headers, config) {
      loadingBarService.stop();
      toaster.pop('error', "Errore", 'Errore generazione report');
      // called asynchronously if an error occurs or server returns response with an error status.
    });
  };

  /*
   * Ritorna i dati in um standard (kwh) o specifica del vettore
   */
  $scope.getValues = function (vectorData) {
    if (vectorData && vectorData.cachedData && vectorData.cachedData.budget) {
      if ("Totale".localeCompare(vectorData.model.description) != 0) {
        return vectorData.cachedData.budget.um;
      } else {
        return vectorData.cachedData.budget.std;
      }
    } else {
      return {};
    }
  };
  function updateContatoreTypeFilter() {
    if ($scope.vector.id) {
      energyCarrierFactory.schemas({
        id: $scope.vector.id.UUID
      }).$promise.then(function (response) {
        if (errorService.handleError(response, SHOW_ERROR_POPUP)) {
          $scope.contatoreTypeFilter = {
            'model.code': response.list.join()
          };
        } else {
          toaster.pop('error', 'Errore', 'Errore durante il recupero dei modelli con vettore_id ' + $scope.vettore.id.code);
        }
      });
    }
  }
  function updateRecordFilter() {
    delete $scope.recordFilter.commission;
    if ($scope.type.type_id && $scope.commissions.selected && $scope.commissions.selected.length > 0) {
      $scope.recordFilter.commission = sixFiltersLib["in"]('commission', $scope.commissions.selected.map(function (c) {
        return c.key;
      }));
    }
  }
  $scope.goToAnchor = function (x) {
    $anchorScroll(x);
    window.scrollBy(0, -100); // salto le toolbar in alto (tot. 100px)
  };

  //------------------------
  // Commesse
  //------------------------

  $scope.loadCommissionList = function () {
    commissionFactory().getCommissionsSelectList().$promise.then(function (response) {
      if (response.list) {
        $scope.commissionList = response.list;
      }
    });
  };
  $scope.loadCommissionList();

  /****** SIDEBAR ******/

  $scope.sidebar = false;
  $scope.toggleSidebar = function () {
    $scope.sidebar = !$scope.sidebar;
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:ReadtemplateCtrl
 * @description
 * # ReadtemplateCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/consumptive/readtemplate', {
    templateUrl: 'energy/readtemplate/readtemplate.html',
    controller: 'ReadtemplateCtrl'
  });
}]).controller('ReadtemplateCtrl', ["$scope", "schemaFactory", "recordFactory", "dialogService", "toaster", "uiGridExporterService", "uiGridExporterConstants", "authFactory", function ($scope, schemaFactory, recordFactory, dialogService, toaster, uiGridExporterService, uiGridExporterConstants, authFactory) {
  $scope.year = new Date().getFullYear().toString();
  $scope.month = sixDateLib.getMonthName(new Date().getMonth());
  $scope.info = authFactory.getAuthData().info;
  $scope.entity = {};
  $scope.data = [];
  $scope.dataExport = [];
  $scope.limit = 10000;
  $scope.referencesExcluded = true;
  $scope.gridOptions = {
    columnDefs: [{
      name: 'Tipo contatore',
      field: 'tipo_contatore',
      type: 'string'
    }, {
      name: 'Codice',
      field: 'code',
      type: 'string'
    }, {
      name: 'Descrizione',
      field: 'description',
      type: 'string'
    }, {
      name: 'Data lettura',
      field: 'data_lettura',
      type: 'string'
    }, {
      name: 'UM',
      field: 'um_letture_id',
      type: 'string'
    }],
    multiSelect: true,
    enableGridMenu: true,
    exporterMenuPdf: false,
    exporterCsvColumnSeparator: ';',
    exporterHeaderFilter: function exporterHeaderFilter(displayName) {
      var header = displayName.toLowerCase();
      header = header.replace(/ /g, '_');
      return header;
    },
    data: 'data',
    onRegisterApi: function onRegisterApi(gridApi) {
      $scope.gridApi = gridApi;
    }
  };
  $scope.exportGridOptions = {
    columnDefs: [{
      name: 'Tipo contatore',
      field: 'tipo_contatore',
      type: 'string'
    }, {
      name: 'Codice',
      field: 'code',
      type: 'string'
    }, {
      name: 'Descrizione',
      field: 'description',
      type: 'string'
    }, {
      name: 'Data lettura',
      field: 'data_lettura',
      type: 'string'
    }, {
      name: 'UM',
      field: 'um_letture_id',
      type: 'string'
    }],
    enableRowHeaderSelection: false,
    enableRowSelection: false,
    enableGridMenu: true,
    exporterMenuPdf: false,
    exporterCsvColumnSeparator: ';',
    exporterHeaderFilter: function exporterHeaderFilter(displayName) {
      var header = displayName.toLowerCase();
      header = header.replace(/ /g, '_');
      return header;
    },
    data: 'dataExport',
    onRegisterApi: function onRegisterApi(gridApiExport) {
      $scope.gridApiExport = gridApiExport;
    }
  };
  $scope.addToExportGridOptions = function () {
    if (angular.isUndefined($scope.typeExported)) {
      /* imposto il tipo di contatore che verrà esportato, viene fatto la prima volta */
      $scope.typeExported = $scope.entity.type.code;
    }
    /* se non è la prima importazione */
    if ($scope.typeExported == $scope.entity.type.code) {
      /* sono le righe da prendere e da copiare nella seconda tabella */
      var selectedRows = $scope.gridApi.selection.getSelectedRows();
      for (var i = 0; i < selectedRows.length; i++) {
        var isPresent = false;
        for (var j = 0; j < $scope.dataExport.length; j++) {
          if (selectedRows[i].tipo_contatore == $scope.dataExport[j].tipo_contatore && selectedRows[i].code == $scope.dataExport[j].code) {
            isPresent = true;
          }
        }
        if (!isPresent) {
          $scope.dataExport.push(selectedRows[i]);
        }
        $scope.data.forEach(function (item, index) {
          if (selectedRows[i].tipo_contatore == item.tipo_contatore && selectedRows[i].code == item.code) {
            $scope.data.splice(index, 1);
          }
        });
      }
    }
  };
  $scope.clearGridOptions = function () {
    $scope.data = [];
  };
  $scope.clearExportGridOptions = function () {
    $scope.dataExport = [];
  };
  $scope.$watchGroup(['entity.type', 'referencesExcluded', 'limit'], function (newValue, oldValue) {
    var modelsCont = ['contatoreelettricita', 'contatoregas', 'contatoreacqua', 'serbatoiopressioneatmosferica', 'serbatoioinpressione', 'contatoreteleriscaldamento', 'contatoreteleraffreddamento'];
    if (angular.isDefined($scope.entity.type)) {
      if (modelsCont.indexOf($scope.entity.type.code) != -1) {
        /* codice eseguito solamente se si seleziona uno dei contatori */
        if (angular.isDefined(newValue) && newValue != oldValue) {
          $scope.data = [];
          var schema;
          var typeName = $scope.entity.type.UUID;
          dialogService.showLoadingMessage('Esportazione...');
          if ($scope.referencesExcluded === true) {
            schema = schemaFactory().byCode({
              id: typeName
            });
          }
          recordFactory(typeName).query({
            page_size: $scope.limit,
            show_revision: false
          }).$promise.then(function (data) {
            var ErrorListCodes = '';
            data.list.forEach(function (value) {
              var row = {};
              var lastDay = new Date($scope.year, sixDateLib.getMonthIndex($scope.month) + 1, 0);
              row.tipo_contatore = $scope.entity.type.description;
              row.code = value.model.code;
              row.description = value.model.description;
              if (angular.isDefined(value.model.um_letture_id)) {
                row.um_letture_id = value.model.um_letture_id.code;
              } else {
                if (ErrorListCodes.length == 0) {
                  ErrorListCodes = value.model.code;
                } else {
                  ErrorListCodes = ErrorListCodes + ', ' + value.model.code;
                }
              }
              row.data_lettura = formatDate(lastDay);
              $scope.data.push(row);
            });
            if (ErrorListCodes.length != 0) {
              toaster.pop('error', 'Errore', 'Errore durante il caricamento UM dei contatori con codice: ' + ErrorListCodes);
            }
            dialogService.stopLoading();
          });
        }
      }
    }
  });
  $scope.$watchGroup(['month', 'year'], function (newValue, oldValue) {
    if (angular.isDefined(newValue) && angular.isDefined(oldValue)) {
      if (newValue != oldValue) {
        refreshDate($scope.data);
        refreshDate($scope.dataExport);
      }
    }
  });
  function refreshDate(array) {
    var lastDay = new Date($scope.year, sixDateLib.getMonthIndex($scope.month) + 1, 0);
    for (var i = 0; i < array.length; i++) {
      if (array[i].data_lettura) {
        array[i].data_lettura = formatDate(lastDay);
      }
    }
  }
  function formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }
  $scope.exportXLSX = function () {
    dialogService.showLoadingMessage('Esportazione...');
    var data = [[] // header row
    ];

    var rows = uiGridExporterService.getData($scope.gridApiExport.grid, uiGridExporterConstants.VISIBLE, uiGridExporterConstants.VISIBLE);
    var columns = [];
    var sheet = {};
    var i = 0;
    var endLoc;
    if ($scope.typeExported) {
      switch ($scope.typeExported) {
        case 'contatoreelettricita':
          columns.push({
            name: 'pod'
          });
          columns.push({
            name: 'data'
          });
          columns.push({
            name: 'f0'
          });
          columns.push({
            name: 'f1'
          });
          columns.push({
            name: 'f2'
          });
          columns.push({
            name: 'f3'
          });
          columns.push({
            name: 'um'
          });
          columns.forEach(function (col) {
            var loc = XLSX.utils.encode_cell({
              r: 0,
              c: i
            });
            sheet[loc] = {
              v: col.name,
              t: 's'
            };
            i += 1;
          });
          rows.forEach(function (row, ri) {
            ri += 1;
            for (var ci = 0; ci < columns.length; ci++) {
              var loc = XLSX.utils.encode_cell({
                r: ri,
                c: ci
              });
              if (angular.isDefined(row[ci])) {
                if (ci == 0) {
                  sheet[loc] = {
                    v: row[1].value,
                    t: 's'
                  };
                } else if (ci == 1) {
                  sheet[loc] = {
                    v: row[3].value,
                    t: 's'
                  };
                } else if (ci == 2) {
                  sheet[loc] = {
                    v: '',
                    t: 'n'
                  };
                } else if (ci == 3) {
                  sheet[loc] = {
                    v: '',
                    t: 'n'
                  };
                } else if (ci == 4) {
                  sheet[loc] = {
                    v: '',
                    t: 'n'
                  };
                } else if (ci == 5) {
                  sheet[loc] = {
                    v: '',
                    t: 'n'
                  };
                } else if (ci == 6) {
                  sheet[loc] = {
                    v: row[4].value,
                    t: 's'
                  };
                }
              }
              endLoc = loc;
            }
          });
          break;
        case 'contatoregas':
          columns.push({
            name: 'pdr'
          });
          columns.push({
            name: 'data'
          });
          columns.push({
            name: 'lettura'
          });
          columns.push({
            name: 'correttore'
          });
          columns.push({
            name: 'um'
          });
          columns.forEach(function (col) {
            var loc = XLSX.utils.encode_cell({
              r: 0,
              c: i
            });
            sheet[loc] = {
              v: col.name,
              t: 's'
            };
            i += 1;
          });
          rows.forEach(function (row, ri) {
            ri += 1;
            for (var ci = 0; ci < columns.length; ci++) {
              var loc = XLSX.utils.encode_cell({
                r: ri,
                c: ci
              });
              if (angular.isDefined(row[ci])) {
                if (ci == 0) {
                  sheet[loc] = {
                    v: row[1].value,
                    t: 's'
                  };
                } else if (ci == 1) {
                  sheet[loc] = {
                    v: row[3].value,
                    t: 's'
                  };
                } else if (ci == 2) {
                  sheet[loc] = {
                    v: '',
                    t: 'n'
                  };
                } else if (ci == 3) {
                  sheet[loc] = {
                    v: '',
                    t: 'n'
                  };
                } else if (ci == 4) {
                  sheet[loc] = {
                    v: row[4].value,
                    t: 's'
                  };
                }
              }
              endLoc = loc;
            }
          });
          break;
        case 'contatoreacqua':
          columns.push({
            name: 'matricola'
          });
          columns.push({
            name: 'data'
          });
          columns.push({
            name: 'lettura'
          });
          columns.push({
            name: 'um'
          });
          columns.forEach(function (col) {
            var loc = XLSX.utils.encode_cell({
              r: 0,
              c: i
            });
            sheet[loc] = {
              v: col.name,
              t: 's'
            };
            i += 1;
          });
          rows.forEach(function (row, ri) {
            ri += 1;
            for (var ci = 0; ci < columns.length; ci++) {
              var loc = XLSX.utils.encode_cell({
                r: ri,
                c: ci
              });
              if (angular.isDefined(row[ci])) {
                if (ci == 0) {
                  sheet[loc] = {
                    v: row[1].value,
                    t: 's'
                  };
                } else if (ci == 1) {
                  sheet[loc] = {
                    v: row[3].value,
                    t: 's'
                  };
                } else if (ci == 2) {
                  sheet[loc] = {
                    v: '',
                    t: 'n'
                  };
                } else if (ci == 3) {
                  sheet[loc] = {
                    v: row[4].value,
                    t: 's'
                  };
                }
              }
              endLoc = loc;
            }
          });
          break;
        case 'serbatoiopressioneatmosferica':
          columns.push({
            name: 'cod'
          });
          columns.push({
            name: 'data'
          });
          columns.push({
            name: 'steccatura'
          });
          columns.push({
            name: 'scarico'
          });
          columns.push({
            name: 'um'
          });
          columns.forEach(function (col) {
            var loc = XLSX.utils.encode_cell({
              r: 0,
              c: i
            });
            sheet[loc] = {
              v: col.name,
              t: 's'
            };
            i += 1;
          });
          rows.forEach(function (row, ri) {
            ri += 1;
            for (var ci = 0; ci < columns.length; ci++) {
              var loc = XLSX.utils.encode_cell({
                r: ri,
                c: ci
              });
              if (angular.isDefined(row[ci])) {
                if (ci == 0) {
                  sheet[loc] = {
                    v: row[1].value,
                    t: 's'
                  };
                } else if (ci == 1) {
                  sheet[loc] = {
                    v: row[3].value,
                    t: 's'
                  };
                } else if (ci == 2) {
                  sheet[loc] = {
                    v: '',
                    t: 'n'
                  };
                } else if (ci == 3) {
                  sheet[loc] = {
                    v: '',
                    t: 'n'
                  };
                } else if (ci == 4) {
                  sheet[loc] = {
                    v: row[4].value,
                    t: 's'
                  };
                }
              }
              endLoc = loc;
            }
          });
          break;
        case 'serbatoioinpressione':
          columns.push({
            name: 'cod'
          });
          columns.push({
            name: 'data'
          });
          columns.push({
            name: 'percentuale'
          });
          columns.push({
            name: 'scarico'
          });
          columns.push({
            name: 'um'
          });
          columns.forEach(function (col) {
            var loc = XLSX.utils.encode_cell({
              r: 0,
              c: i
            });
            sheet[loc] = {
              v: col.name,
              t: 's'
            };
            i += 1;
          });
          rows.forEach(function (row, ri) {
            ri += 1;
            for (var ci = 0; ci < columns.length; ci++) {
              var loc = XLSX.utils.encode_cell({
                r: ri,
                c: ci
              });
              if (angular.isDefined(row[ci])) {
                if (ci == 0) {
                  sheet[loc] = {
                    v: row[1].value,
                    t: 's'
                  };
                } else if (ci == 1) {
                  sheet[loc] = {
                    v: row[3].value,
                    t: 's'
                  };
                } else if (ci == 2) {
                  sheet[loc] = {
                    v: '',
                    t: 'n'
                  };
                } else if (ci == 3) {
                  sheet[loc] = {
                    v: '',
                    t: 'n'
                  };
                } else if (ci == 4) {
                  sheet[loc] = {
                    v: row[4].value,
                    t: 's'
                  };
                }
              }
              endLoc = loc;
            }
          });
          break;
        case 'contatoreteleriscaldamento':
        case 'contatoreteleraffreddamento':
          columns.push({
            name: 'cod'
          });
          columns.push({
            name: 'data'
          });
          columns.push({
            name: 'lettura'
          });
          columns.push({
            name: 'um'
          });
          columns.forEach(function (col) {
            var loc = XLSX.utils.encode_cell({
              r: 0,
              c: i
            });
            sheet[loc] = {
              v: col.name,
              t: 's'
            };
            i += 1;
          });
          rows.forEach(function (row, ri) {
            ri += 1;
            for (var ci = 0; ci < columns.length; ci++) {
              var loc = XLSX.utils.encode_cell({
                r: ri,
                c: ci
              });
              if (angular.isDefined(row[ci])) {
                if (ci == 0) {
                  sheet[loc] = {
                    v: row[1].value,
                    t: 's'
                  };
                } else if (ci == 1) {
                  sheet[loc] = {
                    v: row[3].value,
                    t: 's'
                  };
                } else if (ci == 2) {
                  sheet[loc] = {
                    v: '',
                    t: 'n'
                  };
                } else if (ci == 3) {
                  sheet[loc] = {
                    v: row[4].value,
                    t: 's'
                  };
                }
              }
              endLoc = loc;
            }
          });
          break;
        default:
          toaster.pop('error', 'Errore', 'Tipo contatore non riconosciuto');
      }
    }
    sheet['!ref'] = XLSX.utils.encode_range({
      s: 'A1',
      e: endLoc
    });
    var workbook = {
      SheetNames: ['Sheet1'],
      Sheets: {
        Sheet1: sheet
      }
    };
    var wopts = {
      bookType: 'xlsx',
      bookSST: false,
      type: 'binary'
    };
    var wbout = XLSX.write(workbook, wopts);
    saveAs(new Blob([s2ab(wbout)], {
      type: ""
    }), "letture_" + $scope.typeExported + "_" + $scope.month.toLowerCase() + "_" + $scope.year + ".xlsx");
    dialogService.stopLoading();
    $scope.dataExport = [];
    $scope.typeExported = undefined;
  };
  function s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
  }
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:UpdateregistrationnumberCtrl
 * @description
 * # UpdateregistrationnumberCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.energy').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/updateregistrationnumber', {
    templateUrl: 'energy/updateregistrationnumber/updateregistrationnumber.html',
    controller: 'UpdateregistrationnumberCtrl'
  });
}]).controller('UpdateregistrationnumberCtrl', ["$scope", "$filter", "recordFactory", "$route", "consumptiveFactory", "toaster", "$log", "localStorageService", function ($scope, $filter, recordFactory, $route, consumptiveFactory, toaster, $log, localStorageService) {
  $scope.searchFilter = {
    year: parseInt($filter('date')(new Date(), 'yyyy'))
  };
  $scope.dateOptions = {};
  $scope.date = {
    changingDate: new Date()
  };
  $scope.record = {};
  $scope.updates = {};
  $scope.reads = {
    readNew: '',
    readOld: ''
  };
  $scope.availablePerspectiveCodes = [];
  $scope.matricolaDefault = '';
  $scope.getPerspective = function (uuid) {
    $scope.isCollapsed = true;
    $scope.updates.searchCode = {
      UUID: uuid
    };
    $scope.getData();
  };
  $scope.$watchGroup(['record.type_id', 'record.record_id'], function (newValue) {
    if (angular.isDefined(newValue[0]) && angular.isDefined(newValue[1])) {
      $scope.updates.type_id = $scope.record.type_id;
      $scope.updates.record_id = $scope.record.record_id;
      recordFactory($scope.record.type_id.UUID).byUUID({
        id: $scope.record.record_id.UUID
      }).$promise.then(function (data) {
        $scope.updates.contatore = data;
        if ($scope.record.type_id.UUID == 'contatoregas') {
          // se è un contatore del gas carico la matricola...
          $scope.matricolaDefault = data.model.matricola; // ... così da controllare le modifiche rispetto al valore iniziale, per attivare il bottone
        }

        var payload = {
          id: $scope.updates.contatore.UUID,
          date: $scope.updates.contatore.dataIn
        };
        recordFactory($scope.record.type_id.UUID).getAdjacent(payload).$promise.then(function (result) {
          var max = result.next ? new Date(result.next.dataIn) : null;
          var min = new Date(result.current.dataIn);
          $scope.dateOptions.minDate = min;
          $scope.dateOptions.maxDate = max;
        });
      });
    } else {
      $scope.updates = {};
    }
  });
  function pad(value, _char, length) {
    return value.toString().length < length ? pad(_char + value, _char, length) : value;
  }
  $scope.update = function () {
    var typeName = $scope.updates.type_id.UUID;
    var toSave = [];
    /* salvo la modifica della matricola */
    recordFactory(typeName).update({
      id: $scope.updates.contatore.version,
      history: true,
      forceDataIn: $filter('date')($scope.date.changingDate, 'yyyy-MM-dd')
    }, $scope.updates.contatore).$promise.then(function () {
      /* gestisco la creazione della lettura da inserire */
      createReads(typeName, toSave);
      /* la carico */
      consumptiveFactory.reset(toSave).$promise.then(function () {
        $route.reload();
      });
      recordFactory(typeName).fixDataOut({
        uuid: $scope.updates.contatore.UUID
      });
    });
  };
  function createReads(typeName, toSave) {
    var date = $scope.date.changingDate;
    var lastRead = {
      date: '',
      reads: [],
      um_id: {},
      record_id: {},
      reset: true
    };
    var newRead = {
      date: '',
      reads: [],
      um_id: {},
      record_id: {},
      first: true,
      reset: true
    };
    switch (typeName) {
      case 'contatoregas':
        /* costruisco lastRead */
        var value = {
          time_slot: 'f0',
          value: $scope.reads.readOld.lettura
        };
        if (angular.isDefined($scope.reads.readOld.correttore)) {
          value.correttore = $scope.reads.readOld.correttore;
        }
        lastRead.date = createFormattedDate(date);
        lastRead.um_id = $scope.updates.contatore.model.um_letture_id;
        lastRead.record_id = angular.copy($scope.updates.record_id);
        lastRead.reads.push(value);
        /* costruisco newRead */
        var value2 = {
          time_slot: 'f0',
          value: $scope.reads.readNew.lettura
        };
        if (angular.isDefined($scope.reads.readNew.correttore)) {
          value2.correttore = $scope.reads.readNew.correttore;
        }
        //date.setDate(date.getDate() + 1); // sposto la data avanti di un giorno per evitare di scrivere sullo stesso giorno...
        newRead.date = createFormattedDate(date);
        newRead.um_id = $scope.updates.contatore.model.um_letture_id;
        newRead.record_id = angular.copy($scope.updates.record_id);
        newRead.reads.push(value2);
        break;
      case 'contatoreacqua':
        /* costruisco lastRead */
        var value = {
          time_slot: 'f0',
          value: $scope.reads.readOld.lettura
        };
        lastRead.date = createFormattedDate(date);
        lastRead.um_id = $scope.updates.contatore.model.um_letture_id;
        lastRead.record_id = angular.copy($scope.updates.record_id);
        lastRead.reads.push(value);
        /* costruisco newRead */
        var value2 = {
          time_slot: 'f0',
          value: $scope.reads.readNew.lettura
        };
        //date.setDate(date.getDate() + 1); // sposto la data avanti di un giorno per evitare di scrivere sullo stesso giorno...
        newRead.date = createFormattedDate(date);
        newRead.um_id = $scope.updates.contatore.model.um_letture_id;
        newRead.record_id = angular.copy($scope.updates.record_id);
        newRead.record_id.code = $scope.updates.contatore.model.code;
        newRead.reads.push(value2);
        break;
      case 'contatoreelettricita':
        /* costruisco lastRead */
        var value = {};
        if (angular.isDefined($scope.reads.readOld.lettura.f0)) {
          value.time_slot = 'f0';
          value.value = $scope.reads.readOld.lettura.f0;
          lastRead.reads.push(value);
        }
        if (angular.isDefined($scope.reads.readOld.lettura.f1)) {
          value = {};
          value.time_slot = 'f1';
          value.value = $scope.reads.readOld.lettura.f1;
          lastRead.reads.push(value);
        }
        if (angular.isDefined($scope.reads.readOld.lettura.f2)) {
          value = {};
          value.time_slot = 'f2';
          value.value = $scope.reads.readOld.lettura.f2;
          lastRead.reads.push(value);
        }
        if (angular.isDefined($scope.reads.readOld.lettura.f3)) {
          value = {};
          value.time_slot = 'f3';
          value.value = $scope.reads.readOld.lettura.f3;
          lastRead.reads.push(value);
        }
        lastRead.date = createFormattedDate(date);
        lastRead.um_id = $scope.updates.contatore.model.um_letture_id;
        lastRead.record_id = angular.copy($scope.updates.record_id);
        /* costruisco newRead */
        var value2 = {};
        if (angular.isDefined($scope.reads.readNew.lettura.f0)) {
          value2.time_slot = 'f0';
          value2.value = $scope.reads.readNew.lettura.f0;
          newRead.reads.push(value2);
        }
        if (angular.isDefined($scope.reads.readNew.lettura.f1)) {
          value2 = {};
          value2.time_slot = 'f1';
          value2.value = $scope.reads.readNew.lettura.f1;
          newRead.reads.push(value2);
        }
        if (angular.isDefined($scope.reads.readNew.lettura.f2)) {
          value2 = {};
          value2.time_slot = 'f2';
          value2.value = $scope.reads.readNew.lettura.f2;
          newRead.reads.push(value2);
        }
        if (angular.isDefined($scope.reads.readNew.lettura.f3)) {
          value2 = {};
          value2.time_slot = 'f3';
          value2.value = $scope.reads.readNew.lettura.f3;
          newRead.reads.push(value2);
        }
        //date.setDate(date.getDate() + 1); // sposto la data avanti di un giorno per evitare di scrivere sullo stesso giorno...
        newRead.date = createFormattedDate(date);
        newRead.um_id = $scope.updates.contatore.model.um_letture_id;
        newRead.record_id = angular.copy($scope.updates.record_id);
        newRead.record_id.code = $scope.updates.contatore.model.code;
        break;
      case 'contatoreteleriscaldamento':
      case 'contatoreteleraffreddamento':
        /* costruisco lastRead */
        var value = {
          time_slot: 'f0',
          value: $scope.reads.readOld.lettura
        };
        lastRead.date = createFormattedDate(date);
        lastRead.um_id = $scope.updates.contatore.model.um_letture_id;
        lastRead.record_id = angular.copy($scope.updates.record_id);
        lastRead.reads.push(value);
        /* costruisco newRead */
        var value2 = {
          time_slot: 'f0',
          value: $scope.reads.readNew.lettura
        };
        //date.setDate(date.getDate() + 1); // sposto la data avanti di un giorno per evitare di scrivere sullo stesso giorno...
        newRead.date = createFormattedDate(date);
        newRead.um_id = $scope.updates.contatore.model.um_letture_id;
        newRead.record_id = angular.copy($scope.updates.record_id);
        newRead.record_id.code = $scope.updates.contatore.model.code;
        newRead.reads.push(value2);
        break;
      case 'serbatoioinpressione':
      case 'serbatoiopressioneatmosferica':
        /* costruisco lastRead */
        var value = {
          time_slot: 'f0',
          value: $scope.reads.readOld.lettura
        };
        lastRead.date = createFormattedDate(date);
        lastRead.um_id = $scope.updates.contatore.model.um_letture_id;
        lastRead.record_id = angular.copy($scope.updates.record_id);
        lastRead.reads.push(value);
        /* costruisco newRead */
        var value2 = {
          time_slot: 'f0',
          value: $scope.reads.readNew.lettura
        };
        //date.setDate(date.getDate() + 1); // sposto la data avanti di un giorno per evitare di scrivere sullo stesso giorno...
        newRead.date = createFormattedDate(date);
        newRead.um_id = $scope.updates.contatore.model.um_letture_id;
        newRead.record_id = angular.copy($scope.updates.record_id);
        newRead.record_id.code = $scope.updates.contatore.model.code;
        newRead.reads.push(value2);
        break;
      default:
        toaster.pop('error', 'Errore', 'Errore nel caricamento delle letture');
    }
    toSave.push(lastRead);
    toSave.push(newRead);
    return toSave;
  }
  function createFormattedDate(date) {
    var string = date.getFullYear().toString() + '-' + pad((date.getMonth() + 1).toString(), '0', 2) + '-' + pad(date.getDate().toString(), '0', 2);
    return string;
  }
  $scope.allDataInserted = function () {
    /* check per controllare che siano stati riempiti i campi necessari in base al tipo di contatore */
    switch ($scope.updates.record_id.type) {
      case 'contatoregas':
        /* controllo prima l'inserimento della lettura e poi la presenza dei correttori, se necessario */
        if (angular.isDefined($scope.reads.readOld.lettura) && angular.isDefined($scope.reads.readNew.lettura)) {
          if (!$scope.updates.contatore.model.correttore || $scope.updates.contatore.model.correttore && angular.isDefined($scope.reads.readOld.correttore) && $scope.updates.contatore.model.correttore && angular.isDefined($scope.reads.readNew.correttore)) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
        break;
      case 'contatoreelettricita':
        /* controllo l'ultima lettura */
        if (angular.isDefined($scope.reads.readOld.lettura.f0) && angular.isDefined($scope.reads.readOld.lettura.f1) && angular.isDefined($scope.reads.readOld.lettura.f2) && angular.isDefined($scope.reads.readOld.lettura.f3)
        /* controllo anche la prima lettura */ && angular.isDefined($scope.reads.readNew.lettura.f0) && angular.isDefined($scope.reads.readNew.lettura.f1) && angular.isDefined($scope.reads.readNew.lettura.f2) && angular.isDefined($scope.reads.readNew.lettura.f3)) {
          return true;
        } else {
          return false;
        }
        break;
      case 'contatoreteleriscaldamento':
      case 'contatoreteleraffreddamento':
      case 'serbatoiopressioneatmosferica':
      case 'serbatoioinpressione':
        /* basta controllare che siano state inserite le 2 letture */
        if (angular.isDefined($scope.reads.readOld.lettura) && angular.isDefined($scope.reads.readNew.lettura)) {
          return true;
        } else {
          return false;
        }
        break;
    }
  };
  if (localStorageService.get('resetcounter.type_id') && localStorageService.get('resetcounter.record_id')) {
    $scope.record.type_id = localStorageService.get('resetcounter.type_id');
    $scope.record.record_id = localStorageService.get('resetcounter.record_id');
    localStorageService.remove('resetcounter.type_id');
    localStorageService.remove('resetcounter.record_id');
  }
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:ZonatermicaCtrl
 * @description
 * # ZonatermicaCtrl
 * Controller of the sixEmmaApp
 */
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
angular.module('emma.energy').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/zonatermica/:id', {
    templateUrl: 'energy/zonatermica/zonatermica_detail.html',
    controller: 'ZonatermicaCtrl'
  }).when('/zonatermica', {
    templateUrl: 'energy/zonatermica/zonatermica_list.html',
    controller: 'ZonatermicaCtrl'
  }).when('/zonatermica/page/:number', {
    templateUrl: 'energy/zonatermica/zonatermica_list.html',
    controller: 'ZonatermicaCtrl'
  });
}]).controller('ZonatermicaCtrl', ["$scope", "$location", "$log", "$window", "$routeParams", "$rootScope", "baseFactory", "schemaFactory", "recordFactory", "dialogService", "sessionFactory", "uiGridConstants", "dayDegreeFactory", "sixGridPaginationConstants", "zonaTermicaFactory", "errorService", "toaster", "authFactory", function ($scope, $location, $log, $window, $routeParams, $rootScope, baseFactory, schemaFactory, recordFactory, dialogService, sessionFactory, uiGridConstants, dayDegreeFactory, sixGridPaginationConstants, zonaTermicaFactory, errorService, toaster, authFactory) {
  var STABLE = 'stable',
    SNAP = 'snap'; //eventualmente costanti?

  var SORT_FIELD = 'model.code';
  var saveArray; /* variabile booleana per comunicare al Backend di salvare o meno l'array delle temperature  */

  $scope.params = {
    pageNumber: 1,
    pageSize: 15,
    totalItems: 0,
    filters: {}
  };
  $scope.queryParam = '';
  $scope.uiGridFiltersQuery = '';
  $scope.showDetailView = false;
  $scope.form = {};
  $scope.model = {};
  $scope.schema = {};
  $scope.type = {
    list: [],
    totalResults: 0
  };
  $scope.commissionDependent = false;
  $scope.isCollapsed = false;
  $scope.isModelDefined = true; /* al momento do per scontato che ci sia, al primo 'nuovo', faccio il controllo */

  $scope.historyMode = $routeParams.historyMode ? $routeParams.historyMode : STABLE;
  $scope.showTimeline = false;
  $scope.provincia = {
    type: {},
    model: {}
  };
  $scope.comune = {
    type: {},
    model: {}
  };
  $scope.mapProvTemp = {}; /* mappa con le temperature della provincia */

  $scope.backupArrayTemp = []; /* array di appoggio per tenere salvate le temperature in caso di modifica */

  $scope.editingMode = false;
  $scope.updateArrayTemp = false; /* variabile booleana per tenere memoria della riposta dell'utente sull'aggiornamento dell'array */

  $scope.disableModify = true;
  $scope.gridAppCallbacks = {};
  $scope.viewGridOptions = {
    enableSorting: true,
    enableGridMenu: false,
    exporterMenuPdf: false,
    enableFiltering: true,
    columnDef: [],
    enableColumnResizing: true,
    paginationPageSize: $scope.params.pageSize,
    columnDefs: [{
      name: ' '
    }]
  };
  var walkThruField = function walkThruField(item, parts) {
    if (!angular.isArray(parts)) {
      return item[parts];
    } else if (parts.length == 1) {
      return item[parts[0]];
    } else {
      return walkThruField(item[parts[0]], parts.pop());
    }
  };
  $scope.refresh = function () {
    $scope.getType();
    // $location.path('zonatermica');
  };

  $scope.getItemField = function (item, field) {
    var parts = field.split("."),
      property = item.model || this;
    if (angular.isUndefined(parts) || parts.length == 0) {
      return property;
    }
    return walkThruField(property, parts);
  };
  $scope.getColumns = function () {
    $scope.typeName = 'zonatermica';
    schemaFactory().byUUID({
      id: $scope.typeName
    }).$promise.then(function (data) {
      if (errorService.handleError(data)) {
        getColumnOrDefault(data);
      } else {
        toaster.pop('error', 'Errore', 'Impossibile recuperare il modello');
      }
    });
    return $scope.columnDefs;
  };
  function getColumnOrDefault(data) {
    $scope.viewGridOptions.columnDefs = [];
    $scope.viewGridOptions.columnDefs.push({
      displayName: '',
      field: 'id',
      width: 36,
      enableCellEdit: true,
      enableFiltering: false,
      enableSorting: false,
      cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/zonatermica/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' + '<span class="fa fa-search"></span>' + '</a>' + '</div>'
    });
    if (angular.isUndefined(data.model.columnDefs) || data.model.columnDefs.length == 0 || data.model.columnDefs === null) {
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Codice',
        field: 'model.code',
        enableFiltering: true,
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          //exact o contains non funziona comunque, colpa del lowercase da qualche parte...
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Descrizione',
        field: 'model.description',
        enableFiltering: true,
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
    } else {
      angular.forEach(data.model.schema.properties, function (value, key) {
        var colFilters = {};
        var cellTemplate = undefined;
        // FIXME switch annidati.. è la cosa più merdosa che c'è
        switch (value.type) {
          case 'string':
            switch (value.format) {
              case 'lookup':
                cellTemplate = '<div class="ui-grid-cell ui-grid-cell-contents {{grid.appScope.cellClassFormatter(undefined, row)}}" title="{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}">{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}</div>';
                colFilters = [{
                  type: sixGridPaginationConstants.filterType.SIXLOOKUP,
                  condition: uiGridConstants.filter.CONTAINS,
                  placeholder: ''
                }];
                break;
              case 'commissionmapper':
                cellTemplate = '<div class="ui-grid-cell ui-grid-cell-contents {{grid.appScope.cellClassFormatter(undefined, row)}}" title="{{grid.appScope.cmapperCellValueFormatter(grid.getCellValue(row, col))}}">{{grid.appScope.cmapperCellValueFormatter(grid.getCellValue(row, col))}}</div>';
                colFilters = [{
                  type: sixGridPaginationConstants.filterType.TEXT,
                  condition: uiGridConstants.filter.CONTAINS,
                  placeholder: ''
                }];
                break;
              default:
                colFilters = [{
                  type: sixGridPaginationConstants.filterType.TEXT,
                  condition: uiGridConstants.filter.CONTAINS,
                  placeholder: ''
                }];
                break;
            }
            break;
          case 'integer':
          case 'number':
            colFilters = [{
              type: sixGridPaginationConstants.filterType.NUMBER,
              relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
              placeholder: 'da...',
              condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
            }, {
              type: sixGridPaginationConstants.filterType.NUMBER,
              relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
              placeholder: 'a...',
              condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
            }];
            break;
          case 'date':
            colFilters = [{
              type: sixGridPaginationConstants.filterType.DATE,
              relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
              placeholder: 'da...',
              condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
            }, {
              type: sixGridPaginationConstants.filterType.DATE,
              relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
              placeholder: 'a...',
              condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
            }];
            break;
          default:
            colFilters = [{
              type: sixGridPaginationConstants.filterType.TEXT,
              condition: uiGridConstants.filter.CONTAINS,
              placeholder: ''
            }];
            break;
        }
        var visible = isShownByDefault(key, data.model.columnDefs);
        var colDef = {
          displayName: value.title,
          field: 'model.' + key,
          cellClass: $scope.cellClassFormatter,
          enableFiltering: value.enableFiltering,
          enableSorting: value.enableSorting,
          width: value.width,
          visible: visible,
          filters: colFilters
        };
        if (angular.isDefined(cellTemplate)) {
          colDef.cellTemplate = cellTemplate;
        }
        $scope.viewGridOptions.columnDefs.push(colDef);
      });
    }
    if (!$scope.isStable()) {
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Timeline',
        field: 'timeline',
        width: 106,
        enableCellEdit: false,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate: '<div class="ui-grid-cell-contents" style="vertical-align:middle;text-align:center;"><a ng-href="#/timeline/{{row.entity.schemaCode}}/{{row.entity.UUID}}"><button type="button" class="btn btn-xs btn-primary"><i class="fa fa-history"></i></button></a></div>'
      });
    }
    setTimeout(function () {
      if ($scope.params.sixApi) {
        $scope.params.sixApi.restoreState();
      }
      if ($scope.params.gridApi) {
        $scope.params.gridApi.core.refresh();
      }
    }, 500);
  }
  function isShownByDefault(col, defaultColumnDefs) {
    for (var idx in defaultColumnDefs) {
      if (defaultColumnDefs[idx].field == col) {
        return true;
      }
    }
    return false;
  }
  $scope.cellClassFormatter = function (grid, row, col, rowRenderIndex, colRenderIndex) {
    return row.entity.model.stato === 'chiuso' ? "closed-record" : "";
  };
  $scope.gridAppCallbacks['cellClassFormatter'] = $scope.cellClassFormatter;
  $scope.lookupCellValueFormatter = function (value) {
    var formatted = "";
    if (typeof value != "undefined") {
      if (Object.prototype.toString.call(value) === '[object Array]') {
        for (var v in value) {
          formatted += value[v].code + " (" + value[v].description + "); ";
        }
      } else {
        formatted = value.code + " (" + value.description + ")";
      }
    }
    return formatted;
  };
  $scope.gridAppCallbacks['lookupCellValueFormatter'] = $scope.lookupCellValueFormatter;
  $scope.cmapperCellValueFormatter = function (value) {
    var formatted = "";
    if (typeof value != "undefined") {
      if (value !== null && _typeof(value) === 'object') {
        angular.forEach(value, function (row, commission) {
          formatted += commission + ": " + row.code + " (" + row.description + "); \n";
        });
      } else {
        formatted = value;
      }
    }
    return formatted;
  };
  $scope.gridAppCallbacks['cmapperCellValueFormatter'] = $scope.cmapperCellValueFormatter;
  $scope.isStable = function () {
    return $scope.historyMode == STABLE;
  };
  $scope.isSnapshot = function () {
    return $scope.historyMode == SNAP;
  };
  function buildPath() {
    return 'record/' + $scope.typeName;
  }
  function buildPathForWrite() {
    return 'zonatermica/_save';
  }
  $scope.getType = function () {
    $scope.showDetailView = false;
    $scope.showTimeline = false;
    var payload = {
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      sort_fields: $scope.params.sortFields,
      show_revision: false,
      solve_inherit: true,
      query: $scope.params.queryParam
    };
    return zonaTermicaFactory.search(payload, $scope.params.filters).$promise.then(function (result) {
      if (errorService.handleError(result)) {
        $scope.type.list = result.list || [];
        $scope.type.totalResults = result.totalResults;
        $scope.params.sixApi.refreshList(result.list);
      } else {
        toaster.pop('error', 'Errore', 'Impossibile recuperare la zona termica');
      }
      return result;
    });
    $scope.showTimeline = false;
    $scope.isCollapsed = false;
  };
  $scope["new"] = function () {
    $location.path('zonatermica/new');
  };
  $scope.back = function () {
    $location.path('zonatermica/');
  };
  function FromObjToArray(obj) {
    var array = [];
    for (var i = 0; i < 12; i++) {
      if (!angular.isUndefined(obj) && obj !== null && obj[i]) {
        obj[i].month = sixDateLib.getMonthName(i);
      }
    }
    for (var i = 0; i < 12; i++) {
      if (!angular.isUndefined(obj) && obj !== null && obj[i]) {
        array.push(obj[i]);
      } else {
        var item = {
          month: sixDateLib.getMonthName(i),
          temp: null
        };
        array.push(item);
      }
    }
    return array;
  }
  $scope.updateWithDialog = function () {
    if (angular.isDefined($scope.type) && angular.isDefined($scope.type.selected) && $scope.type.selected.version) {
      var message = 'ATTENZIONE: I valori modificati influenzano le temperature medie mensili. Si desidera ricalcolarle?';
      if ($scope.updateArrayTemp == true) {
        dialogService.confirmDialog(message, function () {
          saveArray = true;
          zonaTermicaFactory.tempProvinciaToZonaTermica({
            id: saveArray
          }, $scope.type.selected).$promise.then(function (result) {
            if (!errorService.handleError(result)) {
              toaster.pop('error', 'Errore', 'Errore durante il calcolo delle temperature');
            } else {
              $scope.type.selected.model = angular.copy(result.model);
              $scope.back();
            }
          });
        }, function () {
          /* update normale non devo aggiornare il vettore delle temperature  */
          zonaTermicaFactory.update({
            id: $scope.type.selected.version
          }, $scope.type.selected).$promise.then(function (resp) {
            if (!errorService.handleError(resp)) {
              toaster.pop('error', 'Errore', 'Errore durante l\'aggiornamento');
            } else {
              $scope.back();
            }
          });
        });
      } else {
        zonaTermicaFactory.update({
          id: $scope.type.selected.version
        }, $scope.type.selected).$promise.then(function (resp) {
          if (!errorService.handleError(resp)) {
            toaster.pop('error', 'Errore', 'Errore durante l\'aggiornamento');
          } else {
            $scope.back();
          }
        });
      }
    } else {
      if (!angular.isArray($scope.model.temp_giorn_medie)) {
        $scope.model.temp_giorn_medie = FromObjToArray($scope.model.temp_giorn_medie);
      }
      zonaTermicaFactory.create({
        commission_dependent: $scope.commissionDependent
      }, $scope.model).$promise.then(function (resp) {
        if (!errorService.handleError(resp)) {
          toaster.pop('error', 'Errore', 'Errore durante l\'aggiornamento');
        } else {
          $scope.back();
        }
      });
    }
  };
  $scope.calculateTempFromProv = function () {
    if (angular.isDefined($scope.type) && angular.isDefined($scope.type.selected) && $scope.type.selected.version) {
      if (!$scope.type.selected.model) {
        dialogService.alert('Dati non configurati per la zona termica corrente', 2000);
        return false;
      }
      saveArray = false;
      zonaTermicaFactory.tempProvinciaToZonaTermica({
        id: saveArray
      }, $scope.type.selected).$promise.then(function (result) {
        if (!errorService.handleError(result)) {
          toaster.pop('error', 'Errore', 'Errore durante il calcolo delle temperature');
        }
        $scope.type.selected.model = angular.copy(result.model);
        $scope.model = $scope.type.selected.model;
      });
    } else {
      saveArray = false;
      var obj = {
        model: angular.copy($scope.model)
      };
      zonaTermicaFactory.tempProvinciaToZonaTermica({
        id: saveArray
      }, obj).$promise.then(function (result) {
        if (!errorService.handleError(result)) {
          toaster.pop('error', 'Errore', 'Errore durante il calcolo delle temperature');
        }
        $scope.model = angular.copy(result.model);
      });
    }
    $scope.updateArrayTemp = false;
  };
  $scope["delete"] = function (idToDelete) {
    zonaTermicaFactory["delete"]({
      id: idToDelete
    }).$promise.then(function () {
      $scope.back();
    });
  };
  $scope.deleteWithDialog = function (idToDelete) {
    dialogService.confirmDialog('Eliminare il record di ' + $scope.schemaDescription + ' \'' + $scope.model.code + '\'?', function () {
      $scope["delete"](idToDelete);
    });
  };
  $scope.getRecordDetail = function (UUID) {
    $scope.showDetailView = true;
    $scope.showTimeline = false;
    $scope.typeName = 'zonatermica';
    schemaFactory().byUUID({
      id: $scope.typeName
    }).$promise.then(function (data) {
      if (errorService.handleError(data)) {
        if (!data.model) {
          dialogService.alert('Non è stato definito un modello per l\'entità ' + $scope.typeName, 4000);
          $scope.isModelDefined = false;
          return;
        }
        $scope.isCollapsed = true;
        $scope.schema = data.model.schema;
        $scope.schemaDescription = data.model.description;
        $scope.schemaUUID = data.UUID;
        $scope.schemaVersion = data.version;
        $scope.schemaCreationDate = data.creationDate;
        $scope.schemaDataIn = data.dataIn;
        $scope.schemaDataOut = data.dataOut;
        $scope.schemaCode = data.model.code;
        $scope.form = data.model.form;
        $scope.commissionDependent = data.commissionDependent;
        getColumnOrDefault(data);
        if (angular.isUndefined(UUID)) {
          $scope.disableModify = true;
          $scope.type['selected'] = {};
          $scope.type.selected['model'] = {};
          $scope.model = {};
          $scope.mapProvTemp = {};
          $scope.comune = undefined;
          $scope.provincia = undefined;
        } else {
          if (UUID != 'new') {
            zonaTermicaFactory.byUUID({
              id: UUID
            }).$promise.then(function (data) {
              if (data.model) {
                $scope.type['selected'] = data;
                $scope.model = $scope.type.selected.model;
                if ($scope.model.temp_giorn_medie) {
                  reOrderTemps();
                }
                /* inseriamo qua il recupero dei dati della provincia e del comune */
                if ($scope.type.selected.model.comune_id || $scope.type.selected.model.provincia_id) {
                  recordFactory('comune').byUUID({
                    id: $scope.type.selected.model.comune_id.UUID
                  }).$promise.then(function (data) {
                    $scope.comune = {};
                    $scope.comune.type = data;
                    $scope.comune.model = data.model;
                    recordFactory('provincia').byUUID({
                      id: $scope.comune.model.provincia_id.UUID
                    }).$promise.then(function (data) {
                      $scope.provincia = {};
                      $scope.provincia.type = data;
                      $scope.provincia.model = data.model;
                      if ($scope.provincia.model.temp_giorn_medie) {
                        angular.forEach($scope.provincia.model.temp_giorn_medie, function (value) {
                          $scope.mapProvTemp[sixDateLib.getMonthIndex(value.month)] = value;
                        });
                      }
                    });
                  });
                }
                $scope.$broadcast('schemaFormRedraw');
              } else {
                dialogService.alert('Non sono presenti versioni nella data selezionata per l\'entità ', 4000);
              }
            });
          }
        }
      }
      $scope.updateArrayTemp = false;
    });
  };
  function reOrderTemps() {
    /* funzione per riordinare l'array delle temperature da dare in pasto alla pagina */
    var map = {};
    var array = [];
    for (var i = 0; i < $scope.model.temp_giorn_medie.length; i++) {
      /* mappa di appoggio */
      map[$scope.model.temp_giorn_medie[i].month] = $scope.model.temp_giorn_medie[i].temp;
    }
    for (var i = 0; i < 12; i++) {
      var app = {
        month: sixDateLib.getMonthName(i),
        temp: null
      };
      if (angular.isDefined(map[sixDateLib.getMonthName(i)])) {
        app.temp = map[sixDateLib.getMonthName(i)];
      }
      array.push(app);
    }
    $scope.type.selected.model.temp_giorn_medie = angular.copy(array);
  }
  $scope.getTypeDescription = function () {
    schemaFactory().byUUID({
      id: $scope.typeName
    }).$promise.then(function (data) {
      if (errorService.handleError(data)) {
        if (!data.model) {
          dialogService.alert('Non è stato definito un modello per l\'entità ' + $scope.typeName, 4000);
          $scope.isModelDefined = false;
          return;
        }
        $scope.typeDescription = data.model.description;
      } else {
        toaster.pop('error', 'Errore', 'Impossibile recuperare il modello');
      }
    });
  };
  $scope.onSubmit = function (form) {
    // First we broadcast an event so all fields validate themselves
    $scope.$broadcast('schemaFormValidate');
    // Then we check if the form is valid
    if (form.$valid) {
      $scope.updateWithDialog();
    }
  };
  $scope.getTimes = function (n) {
    return new Array(n);
  };
  $scope.getMonthName = function (index) {
    return sixDateLib.getMonthName(index);
  };
  $scope.edit = function () {
    $scope.editingMode = true;
    $scope.backupArrayTemp = angular.copy($scope.model.temp_giorn_medie);
  };
  $scope.undo = function () {
    $scope.editingMode = false;
    $scope.model.temp_giorn_medie = angular.copy($scope.backupArrayTemp);
  };
  $scope.confirm = function () {
    $scope.editingMode = false;
  };
  $scope.dataPrint = function (item) {
    var string = '';
    if (angular.isUndefined($scope.comune) && angular.isUndefined($scope.provincia)) {
      return string;
    } else {
      if (item != 'code' && item != 'description') {
        if (item != 'temp_giorn_medie') {
          if ($scope.comune.model[item]) {
            string = string + $scope.comune.model[item].toString() + ' (comune)';
          }
          if ($scope.provincia.model[item]) {
            if (string.length != 0) {
              string = string + ' - ';
              string = string + $scope.provincia.model[item].toString() + ' (provincia)';
            } else {
              string = $scope.provincia.model[item].toString() + '(provincia)';
            }
          }
        }
      }
      return string;
    }
  };
  $scope.boolUpdate = function (item) {
    if (item.key[0] == 'altitude') {
      $scope.updateArrayTemp = true;
    }
  };
  $scope.$watch('type.selected.model.comune_id.code', function (newValue, oldValue) {
    if (angular.isDefined(newValue) && angular.isDefined(oldValue)) {
      if (newValue != oldValue) {
        $scope.updateArrayTemp = true;
      }
    }
  });
  $scope.$watch('model.comune_id.code', function (newValue, oldValue) {
    if (angular.isDefined(newValue) && angular.isDefined(oldValue)) {
      if (newValue != oldValue) {
        recordFactory('comune').byUUID({
          id: $scope.model.comune_id.UUID
        }).$promise.then(function (comune) {
          if (errorService.handleError(comune)) {
            recordFactory('provincia').byUUID({
              id: comune.model.provincia_id.UUID
            }).$promise.then(function (provincia) {
              if (errorService.handleError(provincia)) {
                $scope.provincia = {};
                $scope.provincia.type = provincia;
                $scope.provincia.model = provincia.model;
                if ($scope.provincia.model.temp_giorn_medie) {
                  angular.forEach($scope.provincia.model.temp_giorn_medie, function (value) {
                    $scope.mapProvTemp[sixDateLib.getMonthIndex(value.month)] = value;
                  });
                }
              } else {
                toaster.pop('error', 'Errore', 'Impossibile recuperare la provincia');
              }
            });
          } else {
            toaster.pop('error', 'Errore', 'Impossibile recuperare il comune');
          }
        });
      }
    }
  });
  $scope.typeName = 'zonatermica';
  if ($routeParams.id) {
    $scope.getRecordDetail($routeParams.id);
    $scope.getTypeDescription();
  } else {
    $scope.getTypeDescription();
    $scope.getColumns();
  }
  $scope.showRecordInfo = function () {
    var dialogScope = {
      record: $scope.type.selected,
      schema: {
        code: $scope.schemaCode,
        UUID: $scope.schemaUUID,
        version: $scope.schemaVersion,
        creationDate: $scope.schemaCreationDate,
        dataIn: $scope.schemaDataIn,
        dataOut: $scope.schemaDataOut,
        commission: $scope.schemaCommission
      }
    };
    var opts = {
      name: 'recordInfoDialog',
      closeByDocument: true,
      plain: false
    };
    dialogService.templateDialog('recordInfoTemplate.html', dialogService.DIALOG_TYPE.INFO, dialogScope, opts, -1, false);
  };

  /****************************************/
  /********** check and fix type **********/
  /****************************************/

  var FIXABLE_CODE_PROBLEMS = {
    // code: path per al service di fix
    '2': 'record/' + $scope.typeName + '/_fix/dataout',
    // più dataOut = null
    '3': 'record/' + $scope.typeName + '/_fix/schemacode',
    // schema mancante
    '6': 'record/' + $scope.typeName + '/_fix/commission' // commission defined per STABLE record
  };

  $scope.reportGridOptions = {
    enableSorting: true,
    exporterMenuPdf: false,
    paginationPageSizes: [10, 20, 30],
    paginationPageSize: 10,
    useExternalPagination: false,
    data: 'messages',
    columnDefs: [{
      displayName: 'Codice',
      field: 'code',
      width: '60'
    }, {
      displayName: 'Stato',
      field: 'status',
      width: '100'
    }, {
      displayName: 'Messaggio',
      field: 'message'
    }, {
      displayName: 'Record type',
      field: 'record.type',
      width: '120'
    }, {
      displayName: 'Record code',
      field: 'record.code',
      width: '120'
    }, {
      displayName: 'Record UUID',
      field: 'record.uuid',
      width: '120'
    }, {
      displayName: 'Record Id',
      field: 'recordId',
      width: '120'
    }, {
      displayName: 'Commission',
      field: 'commission',
      width: '120'
    }, {
      displayName: '',
      field: 'code',
      cellTemplate: '<div><a class="btn btn-xs" title="Correggi" ng-confirm-message="Correggere?" ng-if="grid.appScope.isFixable(row.entity.code)===true" ng-confirm-click="grid.appScope.tryFixProblem(row.entity)" ng-confirm-condition=true><span class="fa fa-medkit"></span></a></div>',
      width: 50,
      enableSorting: false,
      enableFiltering: false,
      enableCellEdit: false
    }]
  };
  $scope.isFixable = function (problemCode) {
    for (var code in FIXABLE_CODE_PROBLEMS) {
      if (problemCode === code) {
        return true;
      }
    }
    return false;
  };
  $scope.checkType = function () {
    dialogService.showLoadingMessage('Checking ' + $scope.typeName + '...');
    recordFactory($scope.typeName).check().$promise.then(function (response) {
      if (errorService.handleError(response)) {
        $scope.messages = response.messages;
        if (response.status === 'ok') {
          toaster.pop('success', 'Tutto ok', 'Nessun problema rilevato');
        } else {
          toaster.pop('warning', 'Attenzione', 'Problemi rilevati: ' + $scope.messages.length);
        }
      } else {
        toaster.pop('error', 'Errore', 'Impossibile controllare il tipo ' + $scope.typeName);
      }
      dialogService.hideLoadingMessage();
    });
  };
  $scope.tryFixAllProblems = function () {
    dialogService.showLoadingMessage('Fixing ' + $scope.typeName + '...');
    recordFactory($scope.typeName).fixAll().$promise.then(function (response) {
      if (errorService.handleError(response)) {
        $scope.messages = response.messages;
        toaster.pop('success', 'Corretto', 'Gli errori rilevati sono stati corretti sul tipo ' + $scope.typeName);
      } else {
        toaster.pop('error', 'Errore', 'Impossibile correggere gli errori sui dati del tipo ' + $scope.typeName);
      }
      dialogService.hideLoadingMessage();
    });
  };
  $scope.tryFixProblem = function (problem) {
    if (problem) {
      var path = FIXABLE_CODE_PROBLEMS[problem.code];
      if (path) {
        dialogService.showLoadingMessage('Fixing ' + $scope.typeName + '...');
        baseFactory(path + '/' + problem.record.type + '/' + problem.record.uuid).query().$promise.then(function (response) {
          if (errorService.handleError(response)) {
            $scope.messages = response.messages;
            if (response.status !== 'ok') {
              toaster.pop('error', 'Errore', 'Impossibile correggere gli errori sul record ' + problem.record.uuid + ' del tipo ' + problem.record.type);
            } else {
              toaster.pop('success', 'Corretto', 'Gli errori rilevati sono stati corretti sul record ' + problem.record.uuid + ' di tipo ' + problem.record.type);
            }
          } else {
            toaster.pop('error', 'Errore', 'Impossibile correggere gli errori sul record ' + problem.record.uuid + ' del tipo ' + problem.record.type);
          }
          dialogService.hideLoadingMessage();
        });
      }
    }
  };

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'zonatermica';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
}]);
'use strict';

angular.module('emma.lm').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/inventoryreport', {
    templateUrl: 'lm/inventory-report/inventory-report.html',
    controller: 'InventoryReportCtrl'
  });
}]).controller('InventoryReportCtrl', ["APP_URL", "$location", "lookupFactory", "$scope", "commissionFactory", "$log", "authFactory", "$routeParams", "recordFactory", "$window", "$interval", function (APP_URL, $location, lookupFactory, $scope, commissionFactory, $log, authFactory, $routeParams, recordFactory, $window, $interval) {
  /***************************************************************************************************************************************** 
   *************************************************************** UTILITIES ***************************************************************
   *****************************************************************************************************************************************/

  $scope.retrieveDate = function (datetime) {
    datetime = datetime.split("-");
    if (datetime.length === 3) {
      return datetime;
    }
  };
  $scope.stringEncoder = function (value) {
    var encoded = value.replace(/</g, "%3C");
    encoded = encoded.replace(/ /g, "%20");
    encoded = encoded.replace(/{/g, "%7B");
    encoded = encoded.replace(/"/g, "%22");
    encoded = encoded.replace(/\[/g, "%5B");
    encoded = encoded.replace(/}/g, "%7D");
    encoded = encoded.replace(/]/g, "%5D");
    return encoded;
  };
  $scope.stringDecoder = function (value) {
    var encoded = value.replace(/%3C/g, "<");
    encoded = encoded.replace(/%20/g, " ");
    encoded = encoded.replace(/%7B/g, "{");
    encoded = encoded.replace(/%22/g, "\"");
    encoded = encoded.replace(/%5B/g, "[");
    encoded = encoded.replace(/%7D/g, "}");
    encoded = encoded.replace(/%5D/g, "]");
    return encoded;
  };
  $scope.formatNumber = function (n) {
    if (n > 0 && n < 10) {
      return "0" + n.toString();
    } else {
      return n.toString();
    }
  };

  /***************************************************************************************************************************************** 
   ********************************************************** FINE UTILITIES ***************************************************************
   *****************************************************************************************************************************************/

  /*****************************************************************************************************************************************
   ***************************************************** Management Kibana Dashboard *******************************************************
   *****************************************************************************************************************************************/

  //urls
  $scope.sixDataRelURL = "api/six-data-rel/api/"; //URL modulo six-data-rel
  $scope.extDBURL = "record/externaldb/"; //URL DB Esterno (Relazionale)
  $scope.commissionFilterLabel = "customer_description"; //Key del campo COMMESSA nella dashboard kibana
  $scope.departmentFilterLabel = "current_customer_destination_description"; //Key del campo REPARTI nella dashboard kibana
  $scope.productFilterLabel = "product_description";

  //Filtri (lookup e select)
  $scope.commissionFilter = {}; //Filtro lookup commesse
  $scope.productFilter = {}; //Filtro lookup prodotti
  $scope.departmentFilter = {}; //FIltro lookup reparti
  $scope.selectedTime = "Tutte"; //Default fascia temporale
  $scope.times = ['Tutte', '<5', '<15', '<30', '<60', '<90', '<180', '>=180']; //Possibili fasce temporali
  $scope.kibanaUrl = ""; //Url kibana per iframe
  //Dati recuperati da select e lookup
  $scope.record = {
    lookup: {
      commission: {},
      department: {},
      product: {}
    },
    dates: [],
    model: {}
  };
  $scope.mapping = {
    department: {
      "code": "dest_code",
      "description": "dest_desc",
      "UUID": "id"
    },
    product: {
      "code": "code",
      "description": "description",
      "UUID": "id"
    }
  };
  //Lista commessa disponibili all'utonto corrente
  $scope.avaiableCommissions = [];

  //Variabili gestione dashboard
  $scope.kibanaUrl = "";
  $scope.url = "";
  $scope.first = "";
  $scope._g = "";
  $scope._g1 = "";
  $scope._g2 = "";
  $scope._g3 = "";
  $scope._a = "";
  $scope._a1 = "";
  $scope._a2 = "";
  $scope.negate = false;
  $scope.firstFilter = true;
  $scope.dashboard = "";
  $scope.inventoryDash = false;
  $scope.intervalDash = false;
  $scope.intervalFilter = "";
  $scope.partType = undefined;
  $scope.customTitle = "";
  $scope.customerQuery = "";
  $scope.departmentQuery = "";
  $scope.productQuery = "";

  /***************************************************************************************************************************************
   ***** 1) Se cambia l'url di kibana (tramite interazione con tabella) --> devo cambiare i valori dei filtri in alto correttamente ******
   ***************************************************************************************************************************************/

  //Aggiorna la lookup prod andando a chiedere al BE il dato completo del valore selezionato dalla dashboard
  $scope.setProdLookup = function (code, description) {
    var queryParams = {
      page: 1,
      page_size: 1,
      pageSize: 1,
      cross: false,
      history: false,
      sort_fields: 'code',
      sources: 'code AS code;description AS description;id AS UUID'
    };
    var filters = {
      "code": sixFiltersLib.exact("code", code, sixFiltersLib.CONSTRAINTS.AND),
      "description": sixFiltersLib.exact("description", description, sixFiltersLib.CONSTRAINTS.AND)
    };
    lookupFactory($scope.sixDataRelURL, $scope.extDBURL + "articoli/_lookup").search(queryParams, filters).$promise.then(function (data) {
      if (data.totalResults > 0) {
        $scope.record.model.product = data.list[0];
        $scope.record.lookup.product.obj = data.list[0];
        $scope.record.lookup.product.obj.model.code = data.list[0].code;
        $scope.record.lookup.product.obj.model.description = data.list[0].description;
      }
    })["catch"](function (err) {
      console.debug("Errore nella ricerca dei prodotti: ", err);
      toaster.pop('error', '', 'Prodotto non trovato');
    });
  };

  //Aggiorna la lookup Reparti andando a chiedere al BE il dato completo del valore selezionato dalla dashboard
  $scope.setDepartmentLookup = function (code) {
    var queryParams = {
      page: 1,
      page_size: 1,
      pageSize: 1,
      cross: false,
      history: false,
      sort_fields: "dest_code",
      sources: "dest_code AS code;dest_desc AS description;id AS UUID"
    };
    var filters = {
      "code": sixFiltersLib.exact("code", code, sixFiltersLib.CONSTRAINTS.AND)
    };
    lookupFactory($scope.sixDataRelURL, $scope.extDBURL + "reparti/_lookup").search(queryParams, filters).$promise.then(function (cd) {
      $scope.negate = isNegated;
      $scope.record.model.department = cd.list[0].id;
      var prevDest = $scope.record.lookup.department.obj;
      $scope.record.lookup.department.obj = cd.list[0];
      $scope.record.lookup.department.obj.model.code = cd.list[0].code;
      $scope.record.lookup.department.obj.model.description = cd.list[0].description;
      if (!prevDest || prevDest.id !== $scope.record.lookup.department.obj.id) {
        $scope.onDepartmentChange();
      }
    })["catch"](function (err) {
      console.debug("Errore nella ricerca dei reparti: ", err);
      toaster.pop('error', '', 'Reparto non trovato');
    });
  };

  //Aggiorna la lookup commessa (Che è l'equivalente per CUSTOMER in questa installazione)
  $scope.setCommissionLookup = function (description) {
    var queryParams = {
      page: 1,
      pageSize: 1,
      page_size: 1,
      cross: false,
      history: false
    };
    var filters = {
      "description": sixFiltersLib.exact("model.description", description)
    };
    recordFactory('commission').search(queryParams, filters).$promise.then(function (data) {
      if (data.totalResults > 0) {
        $scope.record.model.commission = data.list[0];
        var prevCommission = $scope.record.lookup.commission.obj;
        $scope.record.lookup.commission.obj = data.list[0];
        $scope.record.lookup.commission.obj.model.code = data.list[0].code;
        $scope.record.lookup.commission.obj.model.description = data.list[0].description;
        if (!prevCommission || prevCommission.UUID !== $scope.record.lookup.commission.obj.UUID) {
          $scope.onCommissionChange();
        }
      }
    })["catch"](function (ex) {});
  };

  //CHECKME: Aggiorna la lookup cliente di fatturazione --> In questa installazione non esiste
  $scope.setBillCustomerLookup = function (code) {};

  //Aggiorna l'intervallo di tempo in base a quello impostato nell'url
  $scope.decodeInterval = function (interval) {
    interval = interval.split("',to:'");
    var from = interval[0];
    var to = interval[1];
    if (from && to) {
      to = to.substring(0, to.length - 1);
      if (to.split("T").length > 1) {
        to = to.split("T")[0];
        to = $scope.retrieveDate(to);
        $scope.to_date = new Date(parseInt(to[0]), parseInt(to[1]) - 1, parseInt(to[2]));
      } else {
        to = $scope.retrieveDate(to);
        $scope.to_date = new Date(parseInt(to[0]), parseInt(to[1]) - 1, parseInt(to[2]) - 1);
      }
      from = from.split("from:'")[1];
      if (from.split("T").length > 1) {
        from = from.split("T")[0];
        from = $scope.retrieveDate(from);
        $scope.from_date = new Date(parseInt(from[0]), parseInt(from[1]) - 1, parseInt(from[2]) + 1);
      } else {
        from = $scope.retrieveDate(from);
        $scope.from_date = new Date(parseInt(from[0]), parseInt(from[1]) - 1, parseInt(from[2]));
      }
    }
  };

  //Aggiorna la select relativa alla fascia temporale in base al valore selezionato nella dashboard
  $scope.setTimeLookup = function (value) {
    $scope.selectedTime = value;
  };

  //CHECKME: controllare di utilizzare valori corretti
  //Aggiorna i filtri (lookup e select) per riflettere le modifiche fatte alla dashboard
  $scope.parseFilters = function (filters) {
    filters.map(function (f) {
      var departmentFilter = f.split("key:" + $scope.departmentFilterLabel);
      var negateFilter = "";
      var isNegated = false;
      if (departmentFilter.length > 1) {
        departmentFilter = departmentFilter[1];
        departmentFilter = departmentFilter.split(",value:");
        negateFilter = departmentFilter[0];
        negateFilter = negateFilter.split("negate:!");
        negateFilter = negateFilter[1].split(",params");
        if (negateFilter[0] === "t") {
          isNegated = true;
        }
        departmentFilter = departmentFilter[1];
        departmentFilter = departmentFilter.split("),")[0];
        departmentFilter = departmentFilter.replace(/'/g, "");
        departmentFilter = departmentFilter.replace(/%20/g, " ");
        departmentFilter = departmentFilter.replace(/%2B/g, "+");
        departmentFilter = departmentFilter.split(" - ");
        var wcode = "";
        var wdesc = "";
        if (departmentFilter.length > 2) {
          wcode = departmentFilter[0];
          departmentFilter.splice(0, 1);
          wdesc = departmentFilter.join(" - ");
        } else {
          wcode = departmentFilter[0];
          wdesc = departmentFilter[1];
        }
        $scope.setDepartmentLookup(wcode, wdesc, isNegated);
      }
      var prodFilter = f.split("key:" + $scope.productFilterLabel);
      if (prodFilter.length > 1) {
        prodFilter = prodFilter[1];
        prodFilter = prodFilter.split(",value:'")[1];
        prodFilter = prodFilter.split("'),")[0];
        prodFilter = prodFilter.replace(/%20/g, " ");
        prodFilter = prodFilter.replace(/%2F/g, "/");
        prodFilter = prodFilter.replace(/%25/g, "%");
        prodFilter = prodFilter.replace(/%2B/g, "+");
        prodFilter = prodFilter.split(" - ");
        var pcode = "";
        var pdesc = "";
        if (prodFilter.length > 2) {
          pcode = prodFilter[0];
          prodFilter.splice(0, 1);
          pdesc = prodFilter.join(" - ");
        } else {
          pcode = prodFilter[0];
          pdesc = prodFilter[1];
        }
        $scope.setProdLookup(pcode, pdesc);
      }

      //CHECKME: Cliente equivale a commessa in questa installazione 
      var commissionFilter = f.split("key:" + $scope.commissionFilterLabel);
      if (commissionFilter.length > 1) {
        commissionFilter = commissionFilter[1];
        commissionFilter = commissionFilter.split(",value:'")[1];
        commissionFilter = commissionFilter.split("'),")[0];
        var cdesc = commissionFilter.replace(/%20/g, " ");
        cdesc = cdesc.replace(/%2F/g, "/");
        cdesc = cdesc.replace(/%25/g, "%");
        cdesc = cdesc.replace(/%2B/g, "+");
        $scope.setCommissionLookup(cdesc);
      }

      //CHECKME: Cliente di fatturazione non esiste per questa installazione
      // var billCustomerFilter = f.split("key:clifatt_code");
      // if(billCustomerFilter.length > 1){
      //   billCustomerFilter = billCustomerFilter[1];
      //   billCustomerFilter = billCustomerFilter.split(",value:'")[1];
      //   billCustomerFilter = billCustomerFilter.split("'),")[0];
      //   var bccode = billCustomerFilter.replace(/%20/g, " ");
      //   bccode = bccode.replace(/%2F/g, "/")
      //   bccode = bccode.replace(/%25/g, "%")
      //   bccode = bccode.replace(/%2B/g, "+")
      //   $scope.setBillCustomerLookup(bccode)
      // }

      var dispersi = f.split("alias:'%3E%3D%20180'");
      if (dispersi.length > 1) {
        $scope.setTimeLookup(">=180");
      }
      var time = f.split("alias:'%3C");
      if (time.length > 1) {
        time = time[1];
        time = time.split("%20GG")[0];
        time = "<" + time;
        $scope.setTimeLookup(time);
      }
    });
  };

  //Aggiorna i filtri in base alle modifiche della dashboard
  $scope.updateFilters = function (url) {
    var _a = url.split("&_a");
    var _g = _a[0];
    _a = _a[1];
    var interval = "";
    _g = _g.split("_g=(")[1];
    if (_g.split("filters:!(").length === 1) {
      _g = "filters:!(" + _g;
    }
    _g = _g.substring(0, _g.length - 1);
    _g = _g.split(",time:(");
    interval = _g[1];
    interval = interval.substring(0, interval.length - 1);
    $scope.decodeInterval(interval);
    _g = _g[0];
    _g = _g.split("),refreshInterval")[0];
    _g = _g.split("filters:!(")[1];
    var filtersPlus = _a.split(",filters:!(")[1];
    var stringfilters = filtersPlus.split("),fullScreenMode:")[0];
    var n = (stringfilters.match(/\$state/g) || []).length;
    if (n > 0) {
      //ho almeno un filtro
      var filters = stringfilters.split(",(");
      if (filters.length > 1) {
        filters.map(function (f) {
          var index = filters.indexOf(f);
          if (index > 0) {
            filters[index] = "(" + filters[index];
          }
        });
      }
      $scope.parseFilters(filters);
    } else {
      var ng = (_g.match(/\$state/g) || []).length;
      if (ng > 0) {
        var gfilters = _g.split(",(");
        if (gfilters.length > 1) {
          gfilters.map(function (f) {
            var index = gfilters.indexOf(f);
            if (index > 0) {
              gfilters[index] = "(" + gfilters[index];
            }
          });
        }
        $scope.parseFilters(gfilters);
      }
    }
  };

  //Inizializza i valori delle variabili relative alla dashboard
  $scope.initializeFixed = function (url) {
    var splitted = url.split("&_g=(");
    $scope.first = splitted[0];
    $scope.dashboard = $scope.first.split("dashboard/")[1];
    $scope.dashboard = $scope.dashboard.split("?")[0];
    var left = "&_g=(filters:!()," + splitted[1];
    splitted = left.split("))&_a");
    $scope._g = splitted[0];
    $scope._a = "))&_a" + splitted[1];
    var _gSplitted = $scope._g.split("filters:!(");
    $scope._g1 = _gSplitted[0] + "filters:!(";
    $scope._g2 = _gSplitted[1];
    $scope._g3 = $scope._g2.split("time:(");
    $scope._g2 = $scope._g3[0] + "time:(";
    $scope.intervalFilter = $scope._g3[1];
    var _aSplitted = $scope._a.split("filters:!(");
    $scope._a1 = _aSplitted[0] + "filters:!(";
    $scope._a2 = _aSplitted[1];
    $scope.initializedFixedValues = true;
    $scope.updateUrl();
  };

  //Prende l'url di kibana dall'url della pagina (query param) e lo passa all'iframe (viene eseguita solo all'inizializzazione della pagina)
  $scope.getKibanaURL = function () {
    if (authFactory.getAuthData() == null) {
      console.log('auth data null');
      return '';
    }
    $scope.url = $routeParams.url;
    return $scope.url;
  };

  //Aggiorna o inizializza i filtri in base alle modifiche all'url di kibana
  $scope.$watch('kibanaUrl', function (newValue, oldValue) {
    if (oldValue !== newValue) {
      if ($scope.first !== "" && newValue.toString().split("&_a").length > 1 && $scope.initializedFixedValues) {
        $scope.updateFilters(newValue);
      }
      if ($scope.first === "" && newValue.toString().split("&_a").length > 1 && !$scope.initializedFixedValues) {
        $scope.initializeFixed(newValue);
      }
    }
  });

  //Si presume e spera che dopo 2 secondi $window.frames[0].location.href sia inizializzato
  $interval(function () {
    $scope.kibanaUrl = $window.frames[0].location.href;
    //$window.frames[0].location.href = "/kibana/app/kibana?jwtToken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlcyI6ImFkbWluIiwiaXNzIjoiaHR0cDovL2xvY2FsaG9zdCIsInN1YiI6ImFkbWluIn0.YJhdxq9AxOMh7OclzZnlUfAR4iOECvZqPl3_EUckMOQ&security_tenant=global#/Fdashboard/af42c5a0-8617-11ea-a8c1-4fe3189feca5?embed=true"
  }, 2000);

  /***************************************************************************************************************************************
   ************************************************************ Fine Parte 1 *************************************************************
   ***************************************************************************************************************************************/

  /***************************************************************************************************************************************
   ** 2) Se cambio i valori dei filtri in alto (tramite selezione utente) -> devo cambiare l'url di kibana per mostrare i dati corretti **
   ***************************************************************************************************************************************/

  //Ritorna pezzo di url relativo al PartType
  $scope.encodePartType = function () {
    if ($scope.firstFilter === true) {
      $scope.firstFilter = false;
      return "('$state':(store:globalState),meta:(alias:!n,disabled:!f,index:'39631cc0-5266-11ea-8163-115bb2e6baac',key:part_type_code.keyword,negate:!f,params:(query:'" + $scope.partType + "'),type:phrase,value:'" + $scope.partType + "'),query:(match:(part_type_code.keyword:(query:'" + $scope.partType + "',type:phrase))))";
    } else {
      return ",('$state':(store:globalState),meta:(alias:!n,disabled:!f,index:'39631cc0-5266-11ea-8163-115bb2e6baac',key:part_type_code.keyword,negate:!f,params:(query:'" + $scope.partType + "'),type:phrase,value:'" + $scope.partType + "'),query:(match:(part_type_code.keyword:(query:'" + $scope.partType + "',type:phrase))))";
    }
  };

  //Ritorna pezzo di url relativo al Time
  $scope.encodeTimeFilter = function (value) {
    var filter = "";
    if (value === ">=180") {
      filter = "('$state':(store:globalState),meta:(alias:'>= 180',disabled:!f,index:'39631cc0-5266-11ea-8163-115bb2e6baac',key:query,negate:!f,type:custom,value:'{\"bool\":{\"must\":[],\"filter\":[{\"bool\":{\"should\":[{\"range\":{\"days_diff\":{\"gte\":180}}}],\"minimum_should_match\":1}}],\"should\":[],\"must_not\":[]}}'),query:(bool:(filter:!((bool:(minimum_should_match:1,should:!((range:(days_diff:(gte:180))))))),must:!(),must_not:!(),should:!())))";
    } else {
      var timeIndex = $scope.times.indexOf(value);
      var previousTime = $scope.times[timeIndex - 1];
      if (previousTime === "Tutte") {
        previousTime = "<0";
      }
      var time = value.substring(1);
      previousTime = previousTime.substring(1);
      filter = "('$state':(store:globalState),meta:(alias:'<" + time + " GG',disabled:!f,index:'39631cc0-5266-11ea-8163-115bb2e6baac',key:query,negate:!f,type:custom,value:'{\"bool\":{\"must\":[],\"filter\":[{\"bool\":{\"filter\":[{\"bool\":{\"should\":[{\"range\":{\"days_diff\":{\"gte\":" + previousTime + "}}}],\"minimum_should_match\":1}},{\"bool\":{\"should\":[{\"range\":{\"days_diff\":{\"lt\":" + time + "}}}],\"minimum_should_match\":1}}]}}],\"should\":[],\"must_not\":[]}}'),query:(bool:(filter:!((bool:(filter:!((bool:(minimum_should_match:1,should:!((range:(days_diff:(gte:" + previousTime + ")))))),(bool:(minimum_should_match:1,should:!((range:(days_diff:(lt:" + time + ")))))))))),must:!(),must_not:!(),should:!())))";
    }
    filter = $scope.stringEncoder(filter);
    if ($scope.firstFilter === false) {
      return "," + filter;
    } else {
      return filter;
    }
  };

  //Ritorna pezzo di url relativo a IntervalFilter
  $scope.encodeIntervalFilter = function (from_date, to_date) {
    if (from_date != null && to_date != null) {
      var tmpDate = to_date.addDays(1);
      return "from:'" + from_date.getFullYear().toString() + "-" + $scope.formatNumber(from_date.getMonth() + 1) + "-" + $scope.formatNumber(from_date.getDate()) + "',to:'" + tmpDate.getFullYear().toString() + "-" + $scope.formatNumber(tmpDate.getMonth() + 1) + "-" + $scope.formatNumber(tmpDate.getDate()) + "'";
    }
  };

  //CHECKME: cambiare label in field con quelle corrette? --> cambiare direttamente da scope.xxxxFilterLabel
  //Ritorna pezzo di url relativo al filtro passato come parametro
  $scope.encodeFilter = function (field, code, value) {
    var formattedValue;
    var formattedCode;
    if (value) {
      formattedValue = value.replace(/%/g, "%25");
      formattedValue = formattedValue.replace(/ /g, "%20");
      formattedValue = formattedValue.replace(/\//g, "%2F");
      formattedValue = formattedValue.replace(/'/g, "!'");
      formattedValue = formattedValue.replace(/\+/g, "%2B");
      if (code) {
        formattedCode = code.replace(/%/g, "%25");
        formattedCode = formattedCode.replace(/ /g, "%20");
        formattedCode = formattedCode.replace(/\//g, "%2F");
        formattedCode = formattedCode.replace(/\+/g, "%2B");
      }
      if (field == $scope.departmentFilterLabel || field == $scope.productFilterLabel) {
        formattedValue = formattedCode + "%20-%20" + formattedValue;
      }
      var negateValue = "f";
      if (field == $scope.departmentFilterLabel && $scope.negate === true) {
        negateValue = "t";
      }
      if ($scope.firstFilter === true) {
        $scope.firstFilter = false;
        return "('$state':(store:globalState),meta:(alias:!n,disabled:!f,index:'39631cc0-5266-11ea-8163-115bb2e6baac',key:" + field + ".keyword,negate:!" + negateValue + ",params:(query:'" + formattedValue + "'),type:phrase,value:'" + formattedValue + "'),query:(match:(" + field + ".keyword:(query:'" + formattedValue + "',type:phrase))))";
      } else {
        return ",('$state':(store:globalState),meta:(alias:!n,disabled:!f,index:'39631cc0-5266-11ea-8163-115bb2e6baac',key:" + field + ".keyword,negate:!" + negateValue + ",params:(query:'" + formattedValue + "'),type:phrase,value:'" + formattedValue + "'),query:(match:(" + field + ".keyword:(query:'" + formattedValue + "',type:phrase))))";
      }
    } else if (field === "clifatt_code" && code) {
      if (code) {
        formattedCode = code.replace(/%/g, "%25");
        formattedCode = formattedCode.replace(/ /g, "%20");
        formattedCode = formattedCode.replace(/\//g, "%2F");
        formattedCode = formattedCode.replace(/\+/g, "%2B");
      }
      if ($scope.firstFilter === true) {
        $scope.firstFilter = false;
        return "('$state':(store:globalState),meta:(alias:!n,disabled:!f,index:'39631cc0-5266-11ea-8163-115bb2e6baac',key:" + field + ".keyword,negate:!f,params:(query:'" + formattedCode + "'),type:phrase,value:'" + formattedCode + "'),query:(match:(" + field + ".keyword:(query:'" + formattedCode + "',type:phrase))))";
      } else {
        return ",('$state':(store:globalState),meta:(alias:!n,disabled:!f,index:'39631cc0-5266-11ea-8163-115bb2e6baac',key:" + field + ".keyword,negate:!f,params:(query:'" + formattedCode + "'),type:phrase,value:'" + formattedCode + "'),query:(match:(" + field + ".keyword:(query:'" + formattedCode + "',type:phrase))))";
      }
    } else {
      return "";
    }
  };

  //CHECKME: usare label corrette (Devo cambiare il nome delle label?) --> Cambiare variabili di scope: xxxFilterLabel nel caso
  //Ricalcola l'url di kibana e lo aggiorna
  $scope.updateUrl = function () {
    var newUrl = "";
    $scope.firstFilter = true;
    newUrl = $scope.first + $scope._g1;
    //CUSTOMER equivale a COMMESSE in questa installazione
    if ($scope.record.lookup.commission && $scope.record.lookup.commission.obj) {
      newUrl = newUrl + $scope.encodeFilter($scope.commissionFilterLabel, $scope.record.lookup.commission.obj.code, $scope.record.lookup.commission.obj.description);
    }
    //Il CLIENTE DI FATTURAZIONE non c'è in questa installazione
    // if($scope.record.lookup.billCustomer && $scope.record.lookup.billCustomer.obj){
    //   newUrl = newUrl + $scope.encodeFilter("clifatt_code", $scope.record.lookup.billCustomer.obj.code,  null)
    // }
    //WARD equivale a REPARTI in questa installazione
    if ($scope.record.lookup.departmentFilter && $scope.record.lookup.departmentFilter.obj) {
      newUrl = newUrl + $scope.encodeFilter($scope.departmentFilterLabel, $scope.record.lookup.departmentFilter.obj.code, $scope.record.lookup.departmentFilter.obj.description);
    }
    //PRODUCT rimane uguale in questa installazione
    if ($scope.record.lookup.product && $scope.record.lookup.product.obj) {
      newUrl = newUrl + $scope.encodeFilter($scope.productFilterLabel, $scope.record.lookup.product.obj.code, $scope.record.lookup.product.obj.description);
    }
    if ($scope.partType) {
      newUrl = newUrl + $scope.encodePartType();
    }
    if ($scope.selectedTime !== "Tutte" && $scope.times.indexOf($scope.selectedTime) > 0) {
      newUrl = newUrl + $scope.encodeTimeFilter($scope.selectedTime);
    }
    newUrl = newUrl + $scope._g2;
    if ($scope.intervalDash) {
      newUrl = newUrl + $scope.encodeIntervalFilter($scope.from_date, $scope.to_date);
    }
    newUrl = newUrl + $scope._a1 + $scope._a2;
    $window.frames[0].location.href = newUrl;
  };

  //Callback utente preme pulsante reset
  $scope.resetFilters = function () {
    $scope.record.model.commission = null;
    $scope.record.model.department = null;
    $scope.record.model.product = undefined;
    $scope.record.lookup.commission.obj = {};
    $scope.record.lookup.department.obj = {};
    $scope.record.lookup.product.obj = {};
    $scope.commissionFilter = {};
    $scope.departmentFilter = {};
    $scope.productFilter = {};
    initFilters();
    $scope.selectedTime = "Tutte";
    $scope.negate = false;
    $scope.to_date = new Date();
    $scope.to_date = $scope.to_date.addDays(-1);
    $scope.from_date = new Date();
    $scope.from_date.setFullYear($scope.from_date.getFullYear() - 2);
    $scope.updateUrl();
  };

  //Callback chiamata al cambio commessa
  $scope.onCommissionChange = function () {
    //Cosa succede se cambio la commessa? --> Già gestita dalla watchgroup
    if ($scope.record.lookup.customer.obj) {
      // CHECKME: Capire perché va a rifare la chiamata che esegue già 
      // recordFactory('customer').filter({ page_size: 10000 }, dbFilterFactory.getStringFilter('t.code', $scope.record.lookup.customer.obj.code) ).$promise
      //   .then(function (data) {
      //     if(data.totalResults===1){
      //       $scope.record.model.customer = data.list[0];
      //       $scope.record.lookup.customer.obj = data.list[0];
      //       if(data.list[0].bill_to_customer_id){
      //         recordFactory('customer').filter({page_size: 100}, dbFilterFactory.getCustomFilter("t.id = "+ data.list[0].bill_to_customer_id)).$promise
      //           .then(function (b){
      //             if(b.totalResults===1){
      //               $scope.record.lookup.billCustomer.obj = b.list[0]
      //             }
      //           })
      //       }
      //     }
      //   })
      //   .catch(function(ex){});
      $scope.productFilter = {};
      $scope.departmentFilter = {};
      if ($scope.userDest) {
        $scope.departmentFilter = {
          "id": sixFiltersLib["in"]("id", $scope.userDest),
          "commission_id": sixFiltersLib.exact("commission_id", $scope.record.lookup.customer.obj.UUID)
        };
        //CHECKME: aggiornare departmentFilter in base ai dati corretti (receiver_type che tabella è?)
        //"AND receiver_type_id in (SELECT id FROM receiver_type WHERE code = 'REP'"+ ($scope.inventoryDash ? " OR code = 'GUA')" : ")") +"AND customer_id ="+$scope.record.lookup.customer.obj.id
      } else {
        $scope.departmentFilter = {
          "commission_id": sixFiltersLib.exact("commission_id", $scope.record.lookup.commission.obj.UUID)
        };
        //Checkme: aggiornare departmentFilter in base ai dati corretti (receiver_type che tabella è?)
        //" AND receiver_type_id in (SELECT id FROM receiver_type WHERE code = 'REP'"+ ($scope.inventoryDash ? " OR code = 'GUA')" : ")"
      }

      $scope.findValidAgreementProds($scope.record.lookup.customer.obj.id);
    } else {
      $scope.record.model.customer = undefined;
      $scope.record.lookup.customer.obj = undefined;
      $scope.productFilter = {};
      $scope.departmentFilter = {};
      if ($scope.userDest) {
        $scope.departmentFilter = {
          "id": sixFiltersLib["in"]("id", $scope.userDest)
        };
        //CHECKME: aggiornare departmentFilter in base ai dati corretti (receiver_type che tabella è?)
        //"AND receiver_type_id in (SELECT id FROM receiver_type WHERE code = 'REP'"+ ($scope.inventoryDash ? " OR code = 'GUA')" : ")") +"AND customer_id ="+$scope.record.lookup.customer.obj.id
      } else {
        $scope.departmentFilter = {};
        //Checkme: aggiornare departmentFilter in base ai dati corretti (receiver_type che tabella è?)
        //" AND receiver_type_id in (SELECT id FROM receiver_type WHERE code = 'REP'"+ ($scope.inventoryDash ? " OR code = 'GUA')" : ")"
      }

      $scope.productFilter["parent_product"] = sixFiltersLib.exists("parent_product_id", sixFiltersLib.CONSTRAINTS.AND);
    }
    if ($scope.partType) {
      //$scope.productFilter = $scope.productFilter.concat(dbFilterFactory.getCustomFilter("part_type_id IN (SELECT id FROM part_type WHERE code = '"+$scope.partType+"')"));
    }
  };

  //Callback chiamata al cambio Reparti
  $scope.onDepartmentChange = function () {
    //Cosa succede se cambio il reparto? --> Già gestita dalla watchgroup
  };

  //Callback chiamata al cambio prodotti
  $scope.onProductChange = function () {
    //Cosa succede se cambio i prodotti? --> Già gestita dalla watchgroup
  };

  //Se aggiorno i dati di una qualsiasi lookup, devo ricalcolare l'url di kibana e aggiornarlo
  $scope.$watchGroup(['record.lookup.customer.obj', 'record.lookup.billCustomer.obj', 'record.lookup.departmentFilter.obj', 'record.lookup.product.obj', 'negate', 'selectedTime', 'from_date', 'to_date'], function () {
    console.debug("Lookup: ", $scope.record.lookup);
    console.debug("First: ", $scope.first);
    if ($scope.first !== "") {
      $scope.updateUrl();
    }
  });

  /***************************************************************************************************************************************
   ************************************************************ Fine Parte 2 *************************************************************
   ***************************************************************************************************************************************/

  /***************************************************************************************************************************************
   **************************************************************** INIT *****************************************************************
   ***************************************************************************************************************************************/

  //Popola la lista di commesse disponibili all'utente prendendo da localstorage i dati di esse e chiedendo al BE il dato completo
  var getAllowedCommissionsList = function getAllowedCommissionsList() {
    $scope.avaiableCommissions = [];
    var allowedCommissionsUUID = authFactory.getAuthData().info.commissions.list.map(function (item) {
      return item.code;
    });
    if (allowedCommissionsUUID.length > 0) {
      var params = {
        page: 1,
        page_size: 10000,
        pageSize: 10000
      };
      var filters = {
        "UUID": sixFiltersLib["in"]("UUID", allowedCommissionsUUID)
      };
      commissionFactory().search(params, filters).$promise.then(function (commissionsResp) {
        console.debug("Commesse: ", commissionsResp);
        if (commissionsResp.totalResults == 0) {
          $scope.avaiableCommissions = authFactory.getAuthData().info.commissions.list;
        } else {
          $scope.avaiableCommissions = commissionsResp.list;
        }
        console.debug("Commesse disponibili: ", $scope.avaiableCommissions);
      });
    }
  };

  //FIXME utilizzare matrixpar per ottenere nome dashboard?
  $scope.setDashboardVariables = function () {
    var controls = parseInt($routeParams.controls);
    if (controls === 1) {
      $scope.inventoryDash = true;
    } else if (controls === 2) {
      $scope.intervalDash = true;
    } else {
      $scope.inventoryDash = true;
    }
    if ($routeParams.parttype) {
      $scope.partType = $routeParams.parttype;
    }
    if ($routeParams.title) {
      $scope.customTitle = $routeParams.title;
    } else {
      if (controls === 1) {
        // matrixParFactory.getValueOrDefault({key: 'inventoryReport.dashboard1', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'},
        //   {defaultValue: "Report Inventario Default 1"}).$promise.then(function (data){
        //   $scope.customTitle = data.result.value;
        // })
        $scope.customTitle = "Report Inventario Default 1";
      }
      if (controls === 2) {
        // matrixParFactory.getValueOrDefault({key: 'inventoryReport.dashboard2', d1: '*', d2: '*', d3: '*', d4: '*', d5: '*'},
        //   {defaultValue: "Report Inventario Default 2"}).$promise.then(function (data){
        //   $scope.customTitle = data.result.value;
        // })
        $scope.customTitle = "Report Inventario Default 2";
      }
    }
  };

  //Inizializza lookup e dati della pagina (date)
  function initData() {
    //CHECKME: devo inizializzare qualcosa per le lookup?
    $scope.to_date = new Date();
    $scope.to_date = $scope.to_date.addDays(-1);
    $scope.from_date = new Date();
    $scope.from_date.setFullYear($scope.from_date.getFullYear() - 2);
  }

  //CHECKME: controllarne coerenza
  //Inizializza i filtri delle lookup
  function initFilters() {
    var authData = authFactory.getAuthData();
    if (authData && authData.info && authData.info.authorizations && authData.info.authorizations.destinations) {
      $scope.userDest = authData.info.authorizations.destinations.toString();
    }
    //$scope.div = authFactory.getAuthData().info.divCod;
    if ($scope.userDest) {
      //FIXME: messo solo per testare, magari toglierlo prima di buttarlo in produzione
      $scope.departmentFilter = {
        "id": sixFiltersLib["in"]("id", $scope.userDest)
      };
      //CHECKME Controllare se servirà questa parte
      //  " AND receiver_type_id in (SELECT id FROM receiver_type WHERE code = 'REP'"+ ($scope.inventoryDash ? " OR code = 'GUA')" : ")")))
    }
    //CHECKME: aggiornare filtro correttamente se serve
    // $scope.wardFilter = $scope.wardFilter
    //   .concat(dbFilterFactory.getCustomFilter("receiver_type_id in (SELECT id FROM receiver_type WHERE code = 'REP'"+ ($scope.inventoryDash ? " OR code = 'GUA')" : ")")));
    // $scope.productFilter = $scope.productFilter.concat(dbFilterFactory.getCustomFilter("parent_product_id is not null"));

    //CHECKME: Aggiornare filtro correttamente se serve
    //if($scope.partType){
    //$scope.productFilter = $scope.productFilter.concat(dbFilterFactory.getCustomFilter("part_type_id IN (SELECT id FROM part_type WHERE code = '"+$scope.partType+"')"));
    // }
  }

  function init() {
    if ($routeParams.id == "1") {
      var URL1 = "inventoryreport\?parttype=PIANA\&title=Giacenza%20inventario%20piana\&url=%2Fkibana%2Fapp%2Fkibana%3FjwtToken%3DeyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlcyI6ImFkbWluIiwiaXNzIjoiaHR0cDovL2xvY2FsaG9zdCIsInN1YiI6ImFkbWluIn0.YJhdxq9AxOMh7OclzZnlUfAR4iOECvZqPl3_EUckMOQ%26security_tenant%3Dglobal%23%2Fdashboard%2Faf42c5a0-8617-11ea-a8c1-4fe3189feca5%3Fembed%3Dtrue";
      $location.path(URL1);
    } else if ($routeParams.id == "2") {
      var URL2 = "inventoryreport\?parttype=VESTIZIONI\&title=Giacenza%20inventario%20vestizioni\&url=%2Fkibana%2Fapp%2Fkibana%3FjwtToken%3DeyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlcyI6ImFkbWluIiwiaXNzIjoiaHR0cDovL2xvY2FsaG9zdCIsInN1YiI6ImFkbWluIn0.YJhdxq9AxOMh7OclzZnlUfAR4iOECvZqPl3_EUckMOQ%26security_tenant%3Dglobal%23%2Fdashboard%2Faf42c5a0-8617-11ea-a8c1-4fe3189feca5%3Fembed%3Dtrue";
      $location.path(URL2);
    } else if ($routeParams.id == "3") {
      var URL3 = "inventoryreport\?controls=2\&parttype=PIANA&title=Andamento%20fabbisogno%20cliente\&url=%2Fkibana%2Fapp%2Fkibana%3FjwtToken%3DeyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlcyI6ImFkbWluIiwiaXNzIjoiaHR0cDovL2xvY2FsaG9zdCIsInN1YiI6ImFkbWluIn0.YJhdxq9AxOMh7OclzZnlUfAR4iOECvZqPl3_EUckMOQ%26security_tenant%3Dglobal%23%2Fdashboard%2Fed2b9130-8f81-11ea-9676-01ae581ffe26%3Fembed%3Dtrue";
      $location.path(URL3);
    } else {
      initData();
      //Recupera la lista di commesse disponibili
      getAllowedCommissionsList();
      $scope.setDashboardVariables();
      initFilters();
      $scope.initializedFixedValues = false;
    }
  }
  init();
}]);
'use strict';

angular.module('emma.lm').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/reportoverview', {
    templateUrl: 'lm/report-overview/report-overview.html',
    controller: 'ReportOverviewCtrl'
  });
}]).controller('ReportOverviewCtrl', ["authFactory", "$location", "$scope", "ReportSrv", "recordFactory", "toaster", function (authFactory, $location, $scope, ReportSrv, recordFactory, toaster) {
  $scope.user = authFactory.getAuthData().info;
  $scope.ruolo_operatore = {};
  $scope.activeWidgetMap = {};
  $scope.widgetReportEditMode = false;
  $scope.blurredWidgetStyle = {};
  $scope.dashboardconfiguration = {};
  $scope.widgetList = {}; //lista dei widget (elementi di reportlist) da mostrare con ng-repeat
  $scope.reportlist = {};
  $scope.dashboardconfiguration_all_data = {};
  $scope.params = {
    pageNumber: 1,
    pageSize: 100
  };
  var activewidgetMap_keyset = ['tracking', 'quality-management', 'business', 'document', 'issue', 'contact']; //da aggiornare in caso di aggiunta o rimozione di widget.

  function load_reportList() {
    //Recupero il ruolo attuale
    var filtro_operatore = {
      'filtro_operatore': sixFiltersLib.exact('model.code', authFactory.getAuthData().authPermission)
    };
    recordFactory('ruolooperatore').search(filtro_operatore).$promise.then(function (response) {
      $scope.ruolo_operatore = response.list[0].model; //ottenuto il ruolo_operatore
      console.log($scope.ruolo_operatore.code);
      _load_reportList();
    });
  }
  function _load_reportList() {
    //Recupero la configurazione in funzione del $scope.ruolo_operatore.code corrente
    var filtro_ruolo = {
      'filtro_ruolo': sixFiltersLib.exact('model.role_id.code', $scope.ruolo_operatore.code)
    };
    recordFactory('dashboardconfiguration').search(filtro_ruolo).$promise.then(function (response) {
      if (!isEmpty(response.list)) {
        //controllo l'eventuale esistenza di una configurazione precedentemente salvata
        $scope.dashboardconfiguration_all_data = response.list[0];
        $scope.dashboardconfiguration = response.list[0].model;
        _load_all_reports();
      } else {
        //non esiste, me la creo
        for (var i = 0; i < activewidgetMap_keyset.length; i++) {
          $scope.activeWidgetMap[activewidgetMap_keyset[i]] = true;
        }
        //caricamento della nuova config

        $scope.dashboardconfiguration.role_id = $scope.ruolo_operatore;
        $scope.dashboardconfiguration.commission = authFactory.getAuthData().info.commissions.current.code;
        $scope.dashboardconfiguration.code = $scope.dashboardconfiguration.role_id.code;
        $scope.dashboardconfiguration.active_widget_map = $scope.activeWidgetMap;

        //uploadConfig($scope.dashboardconfiguration)
      }
    });
  }

  function _load_all_reports() {
    //Inizializzo la lista di tutti i widget
    var payload = {
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize
    };
    var commission_filter = {
      'filtro_commessa': sixFiltersLib.match('model.commission', authFactory.getAuthData().info.commissions.current.code, sixFiltersLib.CONSTRAINTS.OR),
      'filtro_missing': sixFiltersLib.missing('model.commission', sixFiltersLib.CONSTRAINTS.OR)
    };
    var reportlist_filter = {
      'filtro_must': sixFiltersLib.must(commission_filter)
    };
    recordFactory('reportoverview').search(payload, reportlist_filter).$promise.then(function (response) {
      if (response.list) {
        $scope.widgetList = Object.assign({}, response.list.filter(function (item) {
          //TODO: check
          return !item.model.hasOwnProperty('home');
        }).map(function (obj) {
          return obj.model;
        }));
      }
      _load_graphics();
    });
  }
  $scope.isHidden = function (code) {
    //determina se un widget è visibile o meno
    if ($scope.dashboardconfiguration.hidden_report_map) if ($scope.dashboardconfiguration.hidden_report_map[code]) return $scope.dashboardconfiguration.hidden_report_map[code];
    return false;
  };
  $scope.isWidgetVisible = function (widget) {
    //determina se un widget è visibile o meno in funzione della widgetReportEditMode
    if ($scope.dashboardconfiguration.hidden_report_map) if ($scope.dashboardconfiguration.hidden_report_map[widget.code]) return !$scope.dashboardconfiguration.hidden_report_map[widget.code] || $scope.widgetReportEditMode;
    return true;
  };
  $scope.hideWidget = function (code) {
    $scope.dashboardconfiguration.hidden_report_map = $scope.dashboardconfiguration.hidden_report_map || {}; //se non esiste una config ne creo una vuota
    if ($scope.dashboardconfiguration.hidden_report_map[code]) delete $scope.dashboardconfiguration.hidden_report_map[code];else $scope.dashboardconfiguration.hidden_report_map[code] = true;
    _load_graphics();
  };
  function uploadConfig(config) {
    //salva la config come una nuova entry
    recordFactory('dashboardconfiguration').create(config).$promise.then(function (resp_dasboardconfiguration) {
      _load_graphics();
      toaster.pop('success', 'Creato un nuovo dashboardconfiguration per il ruolo' + authFactory.getAuthData().info.commissions.current.code + '\': codice ' + resp_dasboardconfiguration.model.code);
      var filtro_ruolo = {
        'filtro_ruolo': sixFiltersLib.exact('model.role_id.code', $scope.ruolo_operatore.code)
      };
      recordFactory('dashboardconfiguration').search(filtro_ruolo).$promise.then(function (response) {
        if (!isEmpty(response.list)) {
          //controllo l'eventuale esistenza di una configurazione precedentemente salvata
          $scope.dashboardconfiguration_all_data = response.list[0];
        } else {
          console.log('ERROR I SHOULD NOT BE HERE');
        }
      });
    }, function (err) {
      toaster.error('uploadError', 'Impossibile salvare la configurazione');
    });
  }
  function updateConfig(config) {
    //Aggiorna la config
    $scope.dashboardconfiguration_all_data.model = Object.assign({}, config);
    var updated_config = Object.assign({}, $scope.dashboardconfiguration_all_data);
    recordFactory('dashboardconfiguration').update({
      id: $scope.dashboardconfiguration_all_data.version
    }, updated_config).$promise.then(function (response) {
      console.log('La configurazione è stata salvata');
    }, function (err) {
      if (err.data.message.search('concurrent versions') >= 0) {
        toaster.error('Impossibile salvare la configurazione', 'Un altro utente ha modificato questo configurazione. Ricarica i dati.');
      } else {
        toaster.error('Errore', 'Impossibile salvare la configurazione');
      }
    });
  }
  $scope.dashborad_version = {};
  $scope.enterEditMode = function () {
    //ingresso nella modalità di modifica
    _load_graphics();
    $scope.widgetReportEditMode = true;
  };
  $scope.exitEditMode = function () {
    //funzione chiamata alla pressione di salva disposizione
    //salvo la configurazione
    if (!isEmpty($scope.ruolo_operatore)) {
      var filtro_ruolo = {
        'filtro_ruolo': sixFiltersLib.exact('model.role_id.code', $scope.ruolo_operatore.code)
      };
      recordFactory('dashboardconfiguration').search(filtro_ruolo).$promise.then(function (response) {
        //controllo l'eventuale esistenza di una configurazione precedentemente salvata
        if (!isEmpty(response.list)) {
          //esiste già, la aggiorno
          $scope.dashboardconfiguration_all_data = response.list[0];
          updateConfig($scope.dashboardconfiguration);
        } else {
          //non esiste, la creo
          uploadConfig($scope.dashboardconfiguration);
        }
      });
      load_reportList();
      _reset_graphics();
      $scope.widgetReportEditMode = false;
    } else {
      toaster.error('uploadError', 'per poter salvare la configurazione è necessario selezionare un ruolo');
    }
  };
  $scope.urlHandler = function (url) {
    if ($scope.widgetReportEditMode == true) return '';
    return url;
  };
  $scope.clearRuoloFilter = function () {
    //chiamata allo svuotamento del filtro sui ruoli
    $scope.widgetList = {};
    $scope.ruolo_operatore = {};
    _reset_graphics();
  };
  $scope.updateRuoloFilter = function (ruolo) {
    //chiamata alla selezione di un altro ruolo
    $scope.ruolo_operatore.code = ruolo.code;
    $scope.ruolo_operatore.description = ruolo.description;
    $scope.ruolo_operatore.UUID = ruolo.UUID;
    _load_reportList();
  };
  $scope.removeWidget = function (code) {
    var filtro_code = {
      'filtro_code': sixFiltersLib.exact('model.code', code)
    };
    recordFactory('reportoverview').search(filtro_code).$promise.then(function (response) {
      if (!isEmpty(response.list)) {
        //controllo l'eventuale esistenza di una configurazione precedentemente salvata
        $scope.reportlist = response.list[0];
        recordFactory('reportoverview')["delete"]({
          id: $scope.reportlist.version
        }).$promise.then(function (response) {
          if (!isEmpty(response)) {
            if ($scope.dashboardconfiguration.hidden_report_map[code])
              //elimino eventuali configurazioni salvate
              delete $scope.dashboardconfiguration.hidden_report_map[code];
            _load_all_reports();
          } else {
            toaster.error('Errore', 'Errore nell\'eliminare la configurazione');
          }
        });
      } else {
        toaster.error('Errore', 'Errore nel caricare la configurazione');
      }
    });
  };
  function _reset_graphics() {
    //reimposta l'effetto blur di tutti gli elementi
    for (var key in $scope.widgetList) {
      $scope.blurredWidgetStyle[$scope.widgetList[key].code] = {};
    }
  }
  function _load_graphics() {
    //gestisce l'effetto blur
    console.log($scope.widgetList.length);
    for (var key in $scope.widgetList) {
      //controllo esistenza del dato
      console.log($scope.widgetList[key].code);
      $scope.dashboardconfiguration.hidden_report_map = $scope.dashboardconfiguration.hidden_report_map || {};
      if ($scope.dashboardconfiguration.hidden_report_map[$scope.widgetList[key].code]) $scope.blurredWidgetStyle[$scope.widgetList[key].code] = {
        'opacity': '0.6'
      };else $scope.blurredWidgetStyle[$scope.widgetList[key].code] = {};
    }
  }
  $scope.createReportListItem = function () {
    ReportSrv.creatioDialog().then(function (data) {
      console.log(data.id, 'closed with value', data.value);
      if (data.value == 'saved') {
        load_reportList();
      }
    });
  };
  function isEmpty(obj) {
    //Verifica se un object è vuoto
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }

  /**
   * MAIN
   */
  load_reportList();

  /** ***********************************
  * Check permissions
     * ***********************************/
  var RESOURCE_NAME = 'commission';
  $scope.superuser = function () {
    return $scope.isWritePermAllowed() && $scope.isDeletePermAllowed();
  };
  $scope.isWritePermAllowed = function () {
    //true se l'utente può modificare la visualizzazione dei widget
    return authFactory.isWritePermAllowed(RESOURCE_NAME, true);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME, true);
  };
}]).controller('ReportOverviewModalCtrl', ["$scope", "authFactory", "loadingBarService", "commissionFactory", "recordFactory", "toaster", function ($scope, authFactory, loadingBarService, commissionFactory, recordFactory, toaster) {
  var regex = /[^\w_]/g; //tutti i caratteri, meno alfanumerici e underscore
  var second_regex = /^(\d)(.*)/; //primo carattere della stringa numerico

  $scope.commissionLoaded = false;
  $scope.report = {};
  $scope.isCommissionModeEnabled = false;
  $scope.commissionslist = [];
  $scope.commissions = {
    selected: [{
      key: authFactory.getAuthData().info.commissions.current.code,
      description: authFactory.getAuthData().info.commissions.current.description
    }]
  };
  loadingBarService.start('Caricamento commesse, attendere...');
  commissionFactory().getCommissionsList({
    page_size: 100
  }).$promise.then(function (response) {
    if (response.list) {
      for (var idx in response.list) {
        $scope.commissionslist.push({
          key: response.list[idx].code,
          description: response.list[idx].description
        });
      }
    }
    $scope.commissionLoaded = true;
    loadingBarService.stop();
  })["catch"](function (e) {
    loadingBarService.stop();
    toaster.pop('error', '', 'Errore caricamento commesse.');
    $scope.commissionslist.push({
      key: authFactory.getAuthData().info.commissions.current.code,
      description: authFactory.getAuthData().info.commissions.current.description
    });
    $scope.commissionLoaded = true;
  });
  $scope.save = function () {
    //controlla se esiste già un widget con lo stesso codice
    if ($scope.superuser()) {
      var code;
      //assegno al code il titolo formattato
      if (regex.test($scope.report.title) || second_regex.test($scope.report.title)) code = $scope.report.title.replace(second_regex, '_' + $scope.report.title.split(-1)).replace(regex, '');else code = $scope.report.title;
      //controllo se esiste già un widget con questo codice
      var filtro_titolo = {
        'filtro_titolo': sixFiltersLib.exact('model.code', code)
      };
      recordFactory('reportoverview').search(filtro_titolo).$promise.then(function (response) {
        if (!isEmpty(response.list)) {
          //esiste già
          toaster.error('titleError', 'Esiste già un elemento con questo titolo.');
        } else {
          //non esiste, creo una nuova entry
          var tmp_report = {};
          tmp_report.title = $scope.report.title;
          tmp_report.description = $scope.report.description;
          tmp_report.url = $scope.report.url;
          var tmp_reportlist = {};
          tmp_reportlist.code = code;
          tmp_reportlist.report = tmp_report;
          //commission
          if (!$scope.isCommissionModeEnabled && $scope.commissions.selected.length > 0) {
            var tmp_selected_commissions = [];
            for (var idx in $scope.commissions.selected) {
              tmp_selected_commissions.push($scope.commissions.selected[idx].key);
            }
            tmp_reportlist.commission = tmp_selected_commissions;
          }
          uploadReport(tmp_reportlist);
        }
      });
    } else {
      toaster.error('Errore', 'Devi essere un amministratore per poter effettuare questa operazione. Se sei un amministratore e appare questo messaggio, contatta l\'assistenza');
    }
  };
  function uploadReport(reportlist) {
    //carica la nuova entry e chiude il dialog
    recordFactory('reportoverview').create(reportlist).$promise.then(function (resp_reportlist) {
      console.log('Creato una nuova reportlist con codice: ' + resp_reportlist.model.code);
      uploadReportConfig(resp_reportlist.model.code);
    }, function (err) {
      toaster.error('uploadError', 'Impossibile salvare la reportlist');
    });
  }
  $scope.dashboardconfiguration_all_data = {};
  $scope.dashboardconfiguration = {};
  $scope.dashboardconfiguration.hidden_report_map = {};
  $scope.ruoli = {};
  $scope.commission = [];
  $scope.activeWidgetMap = {};
  var activewidgetMap_keyset = ['tracking', 'quality-management', 'business', 'document', 'issue', 'contact']; //da aggiornare in caso di aggiunta o rimozione di widget.

  function uploadReportConfig(code) {
    recordFactory('ruolooperatore').fetchAll({}).$promise.then(function (response) {
      //per tutti gli operatori
      if (response.length) {
        $scope.ruoli = response.map(sixObjectLib.recordToHisRef);
        $scope.ruoli.forEach(function (entry) {
          var filtro_ruolo = {
            'filtro_ruolo': sixFiltersLib.exact('model.role_id.code', entry.code)
          };
          recordFactory('dashboardconfiguration').search(filtro_ruolo).$promise.then(function (response) {
            //TODO - Deve impostare PER TUTTE LE COMMESSE non solo la corrente.
            if (!isEmpty(response.list)) {
              //Se non è vuota, una dashboardconfiguration esiste già, la aggiorno con il dato
              $scope.dashboardconfiguration_all_data = response.list[0];
              $scope.dashboardconfiguration = response.list[0].model;
              if (!$scope.dashboardconfiguration.hasOwnProperty('hidden_report_map')) {
                $scope.dashboardconfiguration.hidden_report_map = {};
              }
              $scope.dashboardconfiguration.hidden_report_map[code] = false;
              updateConfig($scope.dashboardconfiguration);
            } else {
              //Può capitare che non sia stata ancora configurata una dashboardconfiguration per il ruolo scelto, provvedo a crearne una con i valori di default (settando il nuovo dato come "hidden").
              for (var i = 0; i < activewidgetMap_keyset.length; i++) {
                $scope.activeWidgetMap[activewidgetMap_keyset[i]] = true;
              }
              //caricamento della nuova config

              $scope.dashboardconfiguration.role_id = Object.assign({}, entry);
              $scope.dashboardconfiguration.commission = authFactory.getAuthData().info.commissions.current.code;
              $scope.dashboardconfiguration.code = entry.code;
              $scope.dashboardconfiguration.active_widget_map = $scope.activeWidgetMap;
              $scope.dashboardconfiguration.hidden_report_map[code] = false;
              uploadConfig($scope.dashboardconfiguration);
            }
            $scope.closeThisDialog('saved'); //dismiss dialog
          });
        });
      } else {
        toaster.error('Errore nel caricamento della config per il report appena creato.');
      }
    });
  }
  function updateConfig(config) {
    $scope.dashboardconfiguration_all_data.model = Object.assign({}, config);
    var updated_config = Object.assign({}, $scope.dashboardconfiguration_all_data);
    recordFactory('dashboardconfiguration').update({
      id: $scope.dashboardconfiguration_all_data.version
    }, updated_config).$promise.then(function (response) {
      console.log('La configurazione è stata salvata');
    }, function (err) {
      if (err.data.message.search('concurrent versions') >= 0) {
        toaster.error('Impossibile salvare la configurazione', 'Un altro utente ha modificato questo configurazione. Ricarica i dati.');
      } else {
        toaster.error('Errore', 'Impossibile salvare la configurazione');
      }
    });
  }
  function uploadConfig(config) {
    //salva la config come una nuova entry
    recordFactory('dashboardconfiguration').create(config).$promise.then(function (resp_dasboardconfiguration) {
      console.log('Creato un nuovo dashboardconfiguration per il ruolo' + authFactory.getAuthData().info.commissions.current.code + '\': codice ' + resp_dasboardconfiguration.model.code);
    }, function (err) {
      toaster.error('uploadError', 'Impossibile salvare la configurazione');
    });
  }
  function isEmpty(obj) {
    //Verifica se un object è vuoto
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }

  /** ***********************************
   * Check permissions
       * ***********************************/
  var RESOURCE_NAME = 'commission';
  $scope.superuser = function () {
    return $scope.isWritePermAllowed() && $scope.isDeletePermAllowed();
  };
  $scope.isWritePermAllowed = function () {
    //true se l'utente può modificare la visualizzazione dei widget
    return authFactory.isWritePermAllowed(RESOURCE_NAME, true);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME, true);
  };
}]);
'use strict';

angular.module('emma.lm').service('ReportSrv', ['ngDialog', 'authFactory', 'localStorageService', function (ngDialog, authFactory, localStorageService) {
  return {
    getFileIcon: function getFileIcon(fileName) {
      if (fileName) {
        switch (fileName.substring(fileName.lastIndexOf('.') + 1)) {
          default:
            return 'images/portal/app.svg';
        }
      }
    },
    creatioDialog: function creatioDialog() {
      return ngDialog.open({
        template: 'lm/report-overview/report-modal.html',
        controller: 'ReportOverviewModalCtrl',
        className: 'ngdialog-theme-default',
        appendClassName: 'ngdialog-report-create',
        closeByNavigation: true
      }).closePromise;
    },
    getMineOperator: function getMineOperator() {
      var operator = localStorageService.get('operatore');
      var ref = sixObjectLib.recordToHisRef(operator);
      var role = !operator.model.typeoperator_map ? null : operator.model.typeoperator_map[authFactory.getAuthData().info.commissions.current.code] || operator.model.typeoperator_map['tutte'];
      return {
        operator: ref,
        role: role
      };
    }
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:ActivityCtrls
 * @description
 * # ActivityCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/activity', {
    templateUrl: 'plan/activity/activity_list.html',
    controller: 'ActivityCtrl'
  }).when('/activity/detail', {
    templateUrl: 'plan/activity/activity_detail.html',
    controller: 'ActivityCtrl'
  }).when('/activity/detail/:id', {
    templateUrl: 'plan/activity/activity_detail.html',
    controller: 'ActivityCtrl'
  });
}]).controller('ActivityCtrl', ["$scope", "activityFactory", "$log", "$routeParams", "$location", "$window", "toaster", "uiGridConstants", "authFactory", "dialogService", function ($scope, activityFactory, $log, $routeParams, $location, $window, toaster, uiGridConstants, authFactory, dialogService) {
  $scope.activity = {
    model: {}
  };
  $scope.description = "";

  // Funzioni specifiche per vista paginata ---------------------------------------------
  $scope.activitiesList = {};
  $scope.params = {
    pageNumber: 1,
    pageSize: 15,
    filters: {}
  };
  $scope.viewGridOptions = {
    columnDefs: [{
      name: ' '
    }]
  };
  function initGridColumns() {
    $scope.viewGridOptions.columnDefs = [];
    $scope.viewGridOptions.columnDefs.push({
      displayName: '',
      field: 'id',
      width: 36,
      enableCellEdit: true,
      enableFiltering: false,
      enableSorting: false,
      cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/activity/detail/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' + '<span class="fa fa-search"></span>' + '</a>' + '</div>'
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Codice',
      field: 'model.code',
      enableFiltering: true,
      filters: [{
        type: 'text',
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Descrizione',
      field: 'model.description',
      enableFiltering: true,
      filters: [{
        type: 'text',
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
  }
  $scope.getActivitiesList = function () {
    if (!$scope.params.sortFields || $scope.params.sortFields.trim() == '') {
      $scope.params.sortFields = 'model.code:asc';
    }
    var payload = {
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      sort_fields: $scope.params.sortFields,
      show_revision: false
    };
    return activityFactory.getActivitiesListFiltered(payload, $scope.params.filters).$promise.then(function (data) {
      $scope.activitiesList.totalResults = data.totalResults;
      $scope.activitiesList.list = data.list;
      $scope.params.sixApi.refreshList(data.list);
      return data;
    });
  };
  // FINE - Funzioni specifiche per vista paginata ---------------------------------------------

  $scope.refreshDescription = function (description) {
    if (description) {
      $scope.activity.model.description = angular.copy(description);
    }
  };
  $scope.saveForm = function () {
    if ($scope.activity.model.code && $scope.activity.model.description) {
      if ($scope.activity.version) {
        activityFactory.updateActivity({
          id: $scope.activity.model.code
        }, $scope.activity).$promise.then(function () {
          $window.history.back();
        });
      } else {
        activityFactory.saveActivity($scope.activity.model).$promise.then(function () {
          $window.history.back();
        });
      }
    } else {
      toaster.pop('error', 'Errore', 'Descrizione obbligatoria');
    }
  };
  $scope.goToNewActivity = function () {
    $location.path('activity/detail');
  };
  $scope.getActivityById = function (id) {
    activityFactory.getActivityByUUID({
      uuid: id
    }).$promise.then(function (data) {
      $scope.activity = data;
      $scope.description = data.model.description;
    });
  };
  $scope["delete"] = function (version) {
    activityFactory.referenceCount({
      id: $scope.activity.UUID
    }).$promise.then(function (response) {
      var deleteMessage = 'Eliminare l\'attività "' + $scope.activity.model.code + ' - ' + $scope.activity.model.description + '"?';
      if (response.count != 0) {
        var deleteMessage = 'L\'attività: "' + $scope.activity.model.code + ' - ' + $scope.activity.model.description + '"' + ' è in uso nel sistema.<br> Vuoi rimuoverla comunque?';
      }
      dialogService.confirmDialog(deleteMessage, function () {
        activityFactory.deleteActivity({
          id: version
        }).$promise.then(function () {
          $window.history.back();
        });
      });
    });
  };

  //___ main ___
  if ($routeParams.id) {
    if ($routeParams.id != 'new') {
      $scope.getActivityById($routeParams.id);
    }
  } else {
    initGridColumns();
  }

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'activity';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
}]);
'use strict';

/**
 * @ngdoc component
 * @name emma.plan.component:ictIssue
 * @description
 * # ictIssue
 */
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
angular.module('emma.plan').controller('ictIssueController', ["$rootScope", "$scope", "$filter", "issueFactory", "recordFactory", "$location", "$log", "toaster", "$q", "localStorageService", "authFactory", "uiGridConstants", "issueToOdl", "odlFactory", "$timeout", "errorService", "lookupFactory", "$route", "counterFactory", "userFactory", "issueWorkflow", "DEV", "ENV", function ($rootScope, $scope, $filter, issueFactory, recordFactory, $location, $log, toaster, $q, localStorageService, authFactory, uiGridConstants, issueToOdl, odlFactory, $timeout, errorService, lookupFactory, $route, counterFactory, userFactory, issueWorkflow, DEV, ENV) {
  var ctrl = this;

  //setup configurazione
  var defaultConfig = {
    'tabs': ['ictIssue', 'ictAttachments', 'ictNotification'],
    'mode': 'portal',
    'fullPage': true
  };
  ctrl.config = angular.merge({}, defaultConfig, ctrl.config);
  $log.debug('ictIssue config:', ctrl.config);

  //gestione tab
  ctrl.getTab = function (tabName) {
    var tab = $filter('filter')(ctrl.config.tabs, tabName, function (actual, expected) {
      if (actual == expected) return true;
      if (_typeof(actual) == 'object' && actual.component == expected) return true;
    });
    if (tab.length) {
      return {
        'active': true,
        'config': tab[0].config
      };
    } else {
      return {
        'active': false,
        'config': {}
      };
    }
  };

  //init info
  var PATH_ISSUE_RECORD = 'issue/record';
  var PATH_ISSUE_SCHEMA = 'issue/schema';
  var PATH_CALLCENTER_ISSUE = 'callcenter_list';
  var PATH_CALLCENTER_ISSUE_DETAIL = 'callcenter_detail';
  var PATH_PORTAL_ISSUE = '/portal/issue';
  var CALLCENTER_ODL_NEW = '/odl/new';
  var PORTAL_ODL_NEW = '/portal/odl/new';
  ctrl.schemaIssueDefined = false;
  ctrl.issueName = 'issue';
  ctrl.counterNameIssue = 'issue';
  ctrl.commissionDependent = true;

  /**  VARIABILI  **/

  ctrl.loadingSixMail = true;
  var now = new Date();
  ctrl.schemaUUID = null;

  //utils
  ctrl.issueWorkflow = issueWorkflow;
  ctrl.resetsData = function () {
    ctrl.data = {
      date_insertion: now,
      date_requested: now,
      date_handling: null,
      date_closing: null,
      references_assignee: {
        // oggetto per contenere i riferimenti a: tecnici, assegnatari, fornitore...
        secretariat_id: null,
        supervisorExternal_id: null,
        activityReferer_id: null
      },
      watchers: {
        external: [],
        internal: []
      },
      reporter_id: null,
      model: {
        type_id: null,
        record_id: null,
        service_id: null,
        attachments: []
      }
    };
  };
  ctrl.errorsRetrievingCounter = function (errors) {
    $log.error('impossibile recuperare il contatore ' + JSON.stringify(errors));
    $rootScope.$broadcast('topPanel', {
      messages: errors
    });
  };
  ctrl.back = function () {
    if (ctrl.config.mode == 'portal') {
      $location.path(PATH_PORTAL_ISSUE);
    } else {
      $location.path(PATH_CALLCENTER_ISSUE);
    }
  };
  ctrl.goToIssueList = function () {
    if (ctrl.config.mode == 'portal') {
      $location.path(PATH_PORTAL_ISSUE, false);
    } else {
      $location.path(PATH_CALLCENTER_ISSUE, false);
    }
  };
  ctrl.goToOdlNew = function () {
    if (ctrl.config.mode == 'portal') {
      $location.path(PORTAL_ODL_NEW, false);
    } else {
      $location.path(CALLCENTER_ODL_NEW, false);
    }
  };
  ctrl.show_generate_odl = function (status) {
    return status == 'OPEN' || status == 'IN_SERVICE';
  };

  // Gestione allegati
  ctrl.attachments = [];
  function readAttachments(modelList) {
    if (angular.isDefined(modelList)) {
      ctrl.attachments.splice(0, ctrl.attachments.length);
      for (var i = 0; i < modelList.length; i++) {
        ctrl.attachments.push(modelList[i]);
      }
    }
  }
  function writeAttachments(modelList) {
    if (angular.isDefined(modelList)) {
      modelList.splice(0, modelList.length);
      for (var i = 0; i < ctrl.attachments.length; i++) {
        modelList.push(ctrl.attachments[i]);
      }
    }
  }
  ctrl.updAttachments = function () {
    writeAttachments(ctrl.data.model.attachments);
    issueFactory(PATH_ISSUE_RECORD).update({
      id: ctrl.data.version
    }, ctrl.data).$promise.then(function (response) {
      if (response.version) {
        ctrl.data.version = response.version;
      }
    })["catch"](function (rejection) {
      toaster.pop('error', 'Errore salvataggio', rejection.data.message ? rejection.data.message : rejection.statusText);
    });
  };

  // Validazione e salvataggio
  ctrl.validate = function (generateOdl) {
    var form = document.forms['detailForm'];
    if (form) {
      $scope.$broadcast('schemaFormValidate');
      $timeout(function () {
        _checkValidation(generateOdl);
      }, 100);
    }
  };
  function _checkValidation(generateOdl) {
    var form = document.forms['detailForm'];
    var invElements = angular.element(form.getElementsByClassName("ng-invalid"));
    if (!ctrl.data.model.record_id || !ctrl.data.model.type_id) {
      toaster.pop('error', 'Dati mancanti', 'Dati obbligatori mancanti: TIPO, ASSET');
    } else if (invElements.length > 0) {
      toaster.pop('error', 'Dati mancanti', 'Dati obbligatori mancanti.');
    } else {
      _update().then(function (resp) {
        // succeeded
        toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
        ctrl.data.version = resp.version;
        if (generateOdl) {
          // genero anche l'odl
          ctrl.generate_odl(resp.UUID);
        }
        ctrl.goToIssueList();
      }, function (rejection) {
        // rejected
        toaster.pop('error', 'Errore salvataggio', rejection.data.message ? rejection.data.message : rejection.statusText);
      });
    }
  }
  function _update() {
    if (!ctrl.data.version) {
      /* se è nuovo */
      //inietto nel dato la fonte della issue: portal o callcenter
      if (ctrl.config.mode == 'portal') {
        ctrl.data.model.insertedFrom = 'portal';
      } else {
        ctrl.data.model.insertedFrom = 'callcenter';
      }
      return counterFactory.next({
        code: ctrl.counterNameIssue
      }).$promise.then(function (response) {
        if (response.errors) {
          ctrl.errorsRetrievingCounter(response.errors);
          var deferred = $q.defer();
          deferred.reject('Errore nel recupero del contatore per la generazione del codice segnalazione');
          return deferred.promise;
        } else {
          ctrl.data.model.code = response.next;
          if (!ctrl.data.model.description) {
            ctrl.data.model.description = ctrl.data.model.code + ' - ' + ctrl.data.model.type_id.description + ' - ' + ctrl.data.model.record_id.description;
          }
          writeAttachments(ctrl.data.model.attachments);
          return issueFactory(PATH_ISSUE_RECORD).create({
            commissionDependent: ctrl.commissionDependent
          }, ctrl.data).$promise;
        }
      });
    } else {
      /* se è già versionato */
      if (angular.isUndefined(ctrl.data.model.attachments)) {
        writeAttachments(ctrl.data.model.attachments);
      }
      return issueFactory(PATH_ISSUE_RECORD).update({
        id: ctrl.data.version
      }, ctrl.data).$promise;
    }
  }
  ctrl.generate_odl = function (issueId) {
    issueFactory(PATH_ISSUE_RECORD + "/_uuid/" + issueId).getUUID().$promise.then(function (response) {
      if (response) {
        issueToOdl.push(response);
        ctrl.goToOdlNew();
      }
    });
  };
  function initIssue() {
    if (ctrl.config.mode == 'portal') {
      // riempio automaticamente il reporter: ctrl.data.reporter_id
      var userFilter = {
        'model.username': sixFiltersLib.exact('model.username', authFactory.getAuthData().authId)
      };
      recordFactory('operatore').search(userFilter).$promise.then(function (resp) {
        if (resp.list || resp.list.length == 1) {
          ctrl.data.reporter_id = sixObjectLib.recordToHisRef(resp.list[0]);
        }
      });
    }
  }
  ctrl.getIssueById = function (itemId) {
    if (itemId == 'new') {
      ctrl.isNew = true;
      ctrl.getSchemaIssue();
      /* carico il codice della segnalazione dal contatore di SIX */
      counterFactory.current({
        code: ctrl.counterNameIssue
      }).$promise.then(function (response) {
        if (response.errors) {
          ctrl.errorsRetrievingCounter(response.errors);
          $window.history.back();
          return;
        }
        ctrl.data.model.code = (parseInt(response.current) + 1).toString();
      });
      initIssue();
    } else {
      ctrl.isNew = false;
      issueFactory(PATH_ISSUE_RECORD + "/_uuid/" + itemId).getUUID().$promise.then(function (response) {
        if (response) {
          ctrl.data = response;
          /* ho cambiato la posizione per ottenere lo schema della issue altrimenti non si riusciva ad inizializzare la lookup */
          ctrl.getSchemaIssue();
          ctrl.currentIssueRef = sixObjectLib.recordToHisRef(ctrl.data);
          /** TO FIX: vedere come risolvere la gestione delle date */
          if (ctrl.data.date_insertion != null) {
            ctrl.data.date_insertion = new Date(ctrl.data.date_insertion);
          }
          if (ctrl.data.date_handling != null) {
            ctrl.data.date_handling = new Date(ctrl.data.date_handling);
          }
          if (ctrl.data.date_closing != null) {
            ctrl.data.date_closing = new Date(ctrl.data.date_closing);
          }
          if (ctrl.data.date_requested != null) {
            ctrl.data.date_requested = new Date(ctrl.data.date_requested);
          }
          ctrl.getOdlList();
          if (angular.isUndefined(ctrl.data.model.attachments)) {
            ctrl.data.model.attachments = [];
          }
          readAttachments(ctrl.data.model.attachments);
        }
      });
    }
  };
  ctrl.getSchemaIssue = function () {
    var factory = issueFactory(PATH_ISSUE_SCHEMA);
    if (ctrl.config.mode == 'portal') {
      factory = factory.schemaOrDefault();
    } else {
      factory = factory.callCenter();
    }
    factory.$promise.then(function (response) {
      if (response.model) {
        ctrl.schemaIssueDefined = true;
        ctrl.schemaUUID = response.UUID;
        ctrl.schema = response.model.schema;
        ctrl.form = response.model.form;
        ctrl.columnDefs = response.model.columnDefs;
      }
    });
  };
  ctrl.getWar = function (entity) {
    return ctrl.schema.properties[entity].war;
  };
  ctrl.getType = function (modelItem) {
    if (modelItem.type == 'datepicker') {
      return 'date';
    } else {
      return modelItem.type;
    }
  };
  ctrl.getOdlList = function () {
    ctrl.odlList = [];
    if (!angular.isUndefined(ctrl.data.model.code)) {
      var payload = {
        page: 1,
        page_size: 10000,
        show_revision: false
      };
      var filters = {
        'issue_id.UUID': sixFiltersLib.exact('issue_id.UUID', ctrl.data.UUID)
      };
      odlFactory().search(payload, filters).$promise.then(function (data) {
        ctrl.odlList = data.list;
      });
    }
  };

  /*** PARTE INIZIALIZZAZIONE DELLA PAGINA  ***/
  ctrl.$onChanges = function (changes) {
    // se arriva direttamente tutto l'oggetto: lo carico subito
    if (changes.issueObjFull && changes.issueObjFull.currentValue) {
      ctrl.data = changes.issueObjFull.currentValue;
      ctrl.getSchemaIssue();
    } else {
      // altrimenti risolvo l'id:
      if (changes.issueId && changes.issueId.currentValue) {
        ctrl.resetsData();
        ctrl.getIssueById(ctrl.issueId);
      }
    }
  };

  // Mail
  ctrl.getMessage = function () {
    /* creazione testo mail */
    var searchInit = {
      search: {
        obj: {
          'username': authFactory.getAuthData().authId
        }
      },
      init: {
        authId: true,
        email: true
      }
    };
    if (angular.isDefined(ctrl.data.model.type_id) && angular.isDefined(ctrl.data.model.record_id)) {
      ctrl.loadingSixMail = true;
      var promiseMailReceiver = issueFactory(PATH_ISSUE_RECORD).getMailReceiver(ctrl.data).$promise;
      var promiseMailUser = userFactory.getMail(searchInit).$promise;
      Promise.all([promiseMailReceiver, promiseMailUser]).then(function (response) {
        // response[0] = promiseMailReceiver, response[1] = promiseMailUser
        ctrl.loadingSixMail = false;
        var httpLink = 'http://' + $location.$$host + ':' + $location.$$port + (DEV ? '' : '/' + ENV) + '/#/' + PATH_CALLCENTER_ISSUE_DETAIL + '/' + ctrl.data.UUID;
        ctrl.objMail = {
          title: 'Segnalazione ' + ctrl.data.model.code + ' su asset ' + ctrl.data.model.type_id.description + ' - ' + ctrl.data.model.record_id.description,
          to: formatMailReceiver(response[0]),
          cc: formatMailCc(response[1].list[0].email),
          message: 'Segnalazione <b>' + ctrl.data.model.code + '</b> su asset <b>' + ctrl.data.model.type_id.description + '</b> - <b>' + ctrl.data.model.record_id.description + '</b><br /><br />' + 'Dettagli segnalazione: <br />' + '<i>Codice</i>: <b>' + ctrl.data.model.code + '</b> (link: ' + httpLink + ')' + '<br />' + '<i>Dati tipo elem. tecnologico</i>: (<i>cod.</i>) <b>' + getText(ctrl.data.model.type_id, 'code') + '</b> - (<i>descr.</i>) <b>' + getText(ctrl.data.model.type_id, 'description') + '</b><br />' + '<i>Dati elem. tecnologico</i>: (<i>cod.</i>) <b>' + getText(ctrl.data.model.record_id, 'code') + '</b> - (<i>descr.</i>) <b>' + getText(ctrl.data.model.record_id, 'description') + '</b><br />' + '<i>Tipo</i>: ' + getText(ctrl.data.model.issuetype_id, 'description') + '<br />' + '<i>Servizio</i>: ' + getText(ctrl.data.model.service_id, 'description') + '<br />' + '<i>Priorità</i>: ' + getText(ctrl.data.model.priority_id, 'description') + '<br /><br />' + '<i>Oggetto</i>: ' + getText(ctrl.data.model, 'description') + '<br />' + '<i>Note</i>: ' + getText(ctrl.data.model, 'note') + '<br />'
        };
      });
    } else {
      toaster.pop('error', 'Errore', 'Creazione della mail precompilata non riuscita.');
    }
  };
  function getText(ref, element) {
    if (angular.isDefined(ref) && ref != null) {
      if (angular.isDefined(ref[element]) && ref[element] != null) {
        return ref[element];
      }
    }
    return '';
  }
  function formatMailReceiver(array) {
    /* from array to formatted string with comma */
    if (angular.isDefined(array.result)) {
      if (array.result.length != 0) {
        var strConcat = '';
        for (var i = 0; i < array.result.length; i++) {
          if (i == 0) {
            strConcat = array.result[i];
          } else {
            strConcat = strConcat + ', ' + array.result[i];
          }
        }
        return strConcat;
      } else {
        return '';
      }
    } else {
      return '';
    }
  }
  function formatMailCc(UserMailSix) {
    if (UserMailSix) {
      return UserMailSix;
    } else {
      return null;
    }
  }

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'issue/record';
  ctrl.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  ctrl.isOdlWritePermAllowed = function () {
    return authFactory.isWritePermAllowed('odl');
  };
  ctrl.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
}]);
angular.module('emma.plan').component('ictIssue', {
  restrict: 'E',
  controller: 'ictIssueController',
  templateUrl: 'plan/components/ict_issue.html',
  bindings: {
    issueId: '<?',
    // input id
    issueObjFull: '<?',
    // input obj (param. passato per un problema di refresh legato allo stato)
    config: '<?' // input config
  },

  link: function postLink(scope, element, attrs) {}
});
'use strict';

/**
 * @ngdoc component
 * @name emma.plan.component:ictIssueData
 * @description
 * # ictIssueData
 */
angular.module('emma.plan').controller('ictIssueDataController', ["$scope", "treePlanConfigFactory", "treeUtilities", "$log", "authFactory", function ($scope, treePlanConfigFactory, treeUtilities, $log, authFactory) {
  var ctrl = this;

  //setup configurazione
  var defaultConfig = {
    'mode': 'basic',
    'showWatchers': false,
    'showAssignee': false,
    'onlyTreeAssets': false
  };
  ctrl.config = angular.merge({}, defaultConfig, ctrl.config);
  if (Array.isArray(ctrl.config.showAssignee)) {
    ctrl.assigneeColumnWidth = 'col-md-' + Math.floor(12 / ctrl.config.showAssignee.length);
  } else {
    ctrl.assigneeColumnWidth = 3;
  }
  $log.debug('ictIssueData config:', ctrl.config);
  var currentCommission = authFactory.getAuthData().info.commissions.current;
  ctrl.bool_watch_internal = true;
  ctrl.bool_watch_external = false;
  ctrl.secretariatFilter = {};
  ctrl.supervisorExternalFilter = {};
  ctrl.activityRefererFilter = {};
  ctrl.responsableList = [];
  var typeoperatorFilterField = 'model.typeoperator_map.' + currentCommission.code + '.code';
  var typeoperatorFallbackFilterField = 'model.typeoperator_map.tutte.code';
  ctrl.supervisorExternalFilter = {
    'typeoperator_map': sixFiltersLib.must({
      "specific": sixFiltersLib.should({
        "match_specific": sixFiltersLib.exact(typeoperatorFilterField, 'tecnico_esterno')
      }),
      "fallback": sixFiltersLib.should({
        "miss_specific": sixFiltersLib.missing(typeoperatorFilterField),
        "match_fallback": sixFiltersLib.exact(typeoperatorFallbackFilterField, 'tecnico_esterno')
      })
    })
  };
  ctrl.activityRefererFilter = {
    'typeoperator_map': sixFiltersLib.must({
      "specific": sixFiltersLib.should({
        "match_specific": sixFiltersLib.exact(typeoperatorFilterField, 'referente_attivita')
      }),
      "fallback": sixFiltersLib.should({
        "miss_specific": sixFiltersLib.missing(typeoperatorFilterField),
        "match_fallback": sixFiltersLib.exact(typeoperatorFallbackFilterField, 'referente_attivita')
      })
    })
  };
  ctrl.watcher = {
    user: '',
    mail: ''
  };
  ctrl.isNew = angular.isDefined(ctrl.isNewIssue) ? ctrl.isNewIssue : false;

  /* $watch per pulire il campo record quando cancello il tipo */
  $scope.$watch('$ctrl.data.model.type_id', function (newValue, oldValue) {
    if (newValue != oldValue && oldValue != undefined && angular.isDefined(newValue.UUID) && angular.isDefined(oldValue.UUID) && newValue.UUID != oldValue.UUID) {
      // if modificato in modo che lo sbianchi se cambia anche l'UUID, non se cambia solo il puntamento
      ctrl.data.model.record_id = null;
    }
  });

  //rilevo quando è disponibile il modello
  ctrl.watchModelUnregister = $scope.$watch('$ctrl.data.model', function (newValue, oldValue) {
    if (newValue) {
      ctrl.schemaIssueDefined = true;
      ctrl.watchModelUnregister();
    } else {
      ctrl.schemaIssueDefined = false;
    }
  });
  function isReferencesEmpty(data) {
    return !data.references_assignee.secretariat_id && !data.references_assignee.supervisorExternal_id && !data.references_assignee.activityReferer_id;
  }

  /* $watch per scaricare la configurazione */
  $scope.$watchGroup(['$ctrl.data.model.record_id', '$ctrl.data.model.service_id'], function (newValue, oldValue) {
    // se ho la terna (type_id, record_id, service_id) e se non ho la versione o se non sono valorizzati già gli assegnatari...
    if (angular.isDefined(ctrl.data) && ctrl.data.model.type_id && ctrl.data.model.record_id && (!ctrl.data.version || isReferencesEmpty(ctrl.data))) {
      // azzero i precedenti
      delete ctrl.data.references_assignee.secretariat_id;
      delete ctrl.data.references_assignee.supervisorExternal_id;
      delete ctrl.data.references_assignee.activityReferer_id;
      ctrl.data.watchers.internal = [];
      ctrl.data.watchers.external = [];
      var payload = {
        type_id: ctrl.data.model.type_id,
        record_id: ctrl.data.model.record_id,
        service_id: ctrl.data.model.service_id,
        response: {}
      };
      treePlanConfigFactory.getCompleteConfiguration(payload).$promise.then(function (respConf) {
        if (respConf.response != {} && respConf.response != undefined && respConf.response != null) {
          if (respConf.response.responsable && respConf.response.responsable.length > 0) {
            ctrl.responsableList = respConf.response.responsable;
          }
          if (respConf.response.secretariat) {
            // assegnaz. default
            if (respConf.response.secretariat["default"].length > 0) {
              ctrl.data.references_assignee.secretariat_id = respConf.response.secretariat["default"][0];
            }
            // creaz. filtro
            if (respConf.response.secretariat.assignee.length > 0) {
              ctrl.secretariatFilter = ctrl.getFilter(ctrl.secretariatFilter, respConf.response.secretariat.assignee);
            }
          }
          if (respConf.response.issueType) {
            // assegnaz. default
            if (respConf.response.issueType["default"].length > 0) {
              ctrl.data.model.issuetype_id = respConf.response.issueType["default"][0];
            }
            // creaz. filtro
            // al momento non riusciamo a filtrare dentro al model -> condizionare angular-schema-form-sixlookup
          }

          if (respConf.response.supervisorExternal) {
            if (respConf.response.supervisorExternal["default"].length > 0) {
              ctrl.data.references_assignee.supervisorExternal_id = respConf.response.supervisorExternal["default"][0];
            }
            if (respConf.response.supervisorExternal.assignee.length > 0) {
              ctrl.supervisorExternalFilter = ctrl.getFilter(ctrl.supervisorExternalFilter, respConf.response.supervisorExternal.assignee);
            }
          }
          if (respConf.response.activityReferer) {
            if (respConf.response.activityReferer["default"].length > 0) {
              ctrl.data.references_assignee.activityReferer_id = respConf.response.activityReferer["default"][0];
            }
            if (respConf.response.activityReferer.assignee.length > 0) {
              ctrl.activityRefererFilter = ctrl.getFilter(ctrl.activityRefererFilter, respConf.response.activityReferer.assignee);
            }
          }
          if (respConf.response.priority) {
            if (respConf.response.priority["default"].length > 0) {
              ctrl.data.model.priority_id = respConf.response.priority["default"][0];
            }
            // creaz. filtro
            // al momento non riusciamo a filtrare dentro al model -> condizionare angular-schema-form-sixlookup
          }

          if (respConf.response.watchers) {
            ctrl.data.watchers = respConf.response.watchers;
          }
        }
      });
    }
  });
  $scope.$watchGroup(['$ctrl.data.references_assignee.secretariat_id', '$ctrl.data.references_assignee.supervisorExternal_id', '$ctrl.data.references_assignee.activityReferer_id'], function (newValues, oldValues) {
    for (var i = 0; i < 3; i++) {
      if (newValues[i] != oldValues[i]) {
        // se è cambiato il riferimento, gestisco i vari casi:
        if (newValues[i] && !oldValues[i]) {
          // aggiungo il nuovo ai watchers
          ctrl.copyInWatchers(newValues[i]);
        } else if (!newValues[i] && oldValues[i]) {
          // tolgo dai watchers
          ctrl.deleteFromWatchers(oldValues[i]);
        } else if (newValues[i] && oldValues[i]) {
          // se sono entrambi definiti tolgo il vecchio e metto il nuovo rif.
          ctrl.deleteFromWatchers(oldValues[i]);
          ctrl.copyInWatchers(newValues[i]);
        }
      }
    }
  });
  ctrl.deleteFromWatchers = function (obj) {
    var index = -1;
    for (var i = 0; i < ctrl.data.watchers.internal.length; i++) {
      if (obj.UUID == ctrl.data.watchers.internal[i].UUID) {
        index = i;
      }
    }
    if (index > -1) {
      ctrl.data.watchers.internal.splice(index, 1);
    }
  };
  ctrl.copyInWatchers = function (obj) {
    var bool = false;
    for (var i = 0; i < ctrl.data.watchers.internal.length; i++) {
      if (obj.code == ctrl.data.watchers.internal[i].code) {
        bool = true;
      }
    }
    if (bool == false) {
      ctrl.data.watchers.internal.push(obj);
    }
  };
  ctrl.setBoolWatchInternal = function () {
    ctrl.bool_watch_internal = true;
    ctrl.bool_watch_external = false;
  };
  ctrl.setBoolWatchExternal = function () {
    ctrl.bool_watch_internal = false;
    ctrl.bool_watch_external = true;
  };
  ctrl.addWatcher = function () {
    if (ctrl.bool_watch_internal) {
      /* se è interno */
      if (ctrl.watcher.user != null && ctrl.include(ctrl.data.watchers.internal, ctrl.watcher.user) == false) {
        ctrl.data.watchers.internal.push(ctrl.watcher.user);
      }
      ctrl.watcher.user = null;
    } else if (ctrl.bool_watch_external) {
      /* se è esterno */
      if (ctrl.watcher.mail != null) {
        ctrl.data.watchers.external.push(ctrl.watcher.mail);
      }
      ctrl.watcher.mail = null;
    }
  };
  ctrl.addWatcherFromLookUp = function (lookUp) {
    if (angular.isDefined(lookUp) && lookUp != null) {
      ctrl.copyInWatchers(lookUp);
    }
  };
  ctrl.deleteWatcher = function (array, toDelete) {
    var index = array.indexOf(toDelete);
    if (index > -1) {
      array.splice(index, 1);
    }
  };
  ctrl.include = function (arr, obj) {
    var bool = false;
    for (var i = 0; i < arr.length; i++) {
      if (obj.code == arr[i].code) {
        bool = true;
      }
    }
    return bool;
  };
  ctrl.getFilter = function (filter, array) {
    var string = '';
    array.forEach(function (item, index) {
      if (index == 0) {
        string = item.UUID;
      } else {
        string = string + ',' + item.UUID;
      }
      filter['UUID'] = string;
    });
    return filter;
  };
  ctrl.typeIdFilter = null;
  treeUtilities.getFlatStructureUuids().then(function (types) {
    if (types) {
      ctrl.typeIdFilter = {
        'typeIdFilter': sixFiltersLib["in"]('UUID', types)
      };
    }
  });
  ctrl.assetFilter = null;
  if (ctrl.config.onlyTreeAssets) {
    //must have parents
    ctrl.assetFilter = {
      'onlyTreeAssetsFilter': sixFiltersLib.nested("parents", {
        "withparents": sixFiltersLib.exists("parents")
      })
    };
  }
}]);
angular.module('emma.plan').component('ictIssueData', {
  restrict: 'E',
  controller: 'ictIssueDataController',
  templateUrl: 'plan/components/ict_issue_data.html',
  bindings: {
    data: '=',
    isNewIssue: '=?',
    schema: '=',
    form: '=',
    config: '<?' // input config
  },

  link: function postLink(scope, element, attrs) {}
});
'use strict';

/**
 * @ngdoc component
 * @name emma.plan.component:ictIssueTimeline
 * @description
 * # ictIssueTimeline
 */
angular.module('emma.plan').controller('ictIssueTimelineController', ["issueFactory", "$log", function (issueFactory, $log) {
  var ctrl = this;
  var PATH_ISSUE_SCHEMA = 'issue/schema';
  ctrl.modelDataInTimeline = {};
  ctrl.schemaDataInTimeline = {};
  ctrl.formDataInTimeline = {};
  ctrl.timeline = [];
  ctrl.entity = 'issue/record';
  ctrl.getTimeline = function () {
    if (angular.isDefined(ctrl.entity) && angular.isDefined(ctrl.datauuid)) {
      ctrl.buildTimeline(ctrl.entity, ctrl.datauuid);
    }
  };
  ctrl.buildTimeline = function (entity, UUID, version) {
    ctrl.entity = entity;
    ctrl.timeline = issueFactory(entity, UUID).getTimeline().$promise.then(function (data) {
      ctrl.timeline = data.list;
      if (angular.isDefined(version)) {
        ctrl.modelDataInTimeline['version'] = version;
      }
    });
  };
  ctrl.getModelDetail = function (version) {
    issueFactory(ctrl.entity, version).byID({
      id: version
    }).$promise.then(function (data) {
      ctrl.currentDataInTimeline = data;
      angular.forEach(data, function (value, key) {
        //assumes all fields starting with "data_" are dates
        if (value && !angular.isDate(value) && key.indexOf('date_') == 0) {
          this[key] = new Date(value);
        }
      }, ctrl.currentDataInTimeline);
      ctrl.modelDataInTimeline.version = data.version;
      if (angular.isUndefined(data.dataOut) || data.dataOut == null) {
        data.dataOut = "_current";
      }
      issueFactory(PATH_ISSUE_SCHEMA).getSchemaInTimeline({
        id: ctrl.schemauuid,
        param1: data.dataOut
      }).$promise.then(function (response) {
        if (response.model) {
          ctrl.showDetail = true;
          ctrl.schemaDataInTimeline = response.model.schema;
          ctrl.formDataInTimeline = response.model.form;
        }
      });
    });
  };
  ctrl.$onChanges = function (changesObj) {
    //$log.debug('Issue data changed, updating timeline.', changesObj);
    if (changesObj.dataversion && changesObj.dataversion.currentValue) {
      ctrl.getTimeline();
    }
  };
}]);
angular.module('emma.plan').component('ictIssueTimeline', {
  restrict: 'E',
  controller: 'ictIssueTimelineController',
  templateUrl: 'plan/components/ict_issue_timeline.html',
  bindings: {
    datauuid: '<',
    schemauuid: '<',
    dataversion: '<',
    config: '<?' // input config
  },

  link: function postLink(scope, element, attrs) {}
});
'use strict';

/* Visualizza l'elenco di notifiche associate a uno specifico oggetto (definito tramite gli attributi ictType e ictUuid) */
angular.module('emma.plan').controller('ictNotificationsCtrl', ['notificationFactory', '$location', function (notificationFactory, $location) {
  var ctrl = this;
  if (angular.isUndefined(ctrl.ictDetailView)) {
    ctrl.ictDetailView = 'link';
  }
  ctrl.notifications = [];
  ctrl.selectedNotification = undefined;
  ctrl.notificationPanelOpen = false;
  function setBodyText(notification) {
    var model = notification.model;
    if (angular.isDefined(model)) {
      var bodyHtml = model.body;
      if (angular.isDefined(bodyHtml)) {
        bodyHtml = "<div>" + bodyHtml + "</div>";
        var bodyText = $(bodyHtml).text();
        model.bodyAsText = bodyText;
      }
    }
  }
  ctrl.getNotificationsList = function () {
    if (!ctrl.ictUuid || !ctrl.ictType) return;
    var payload = {
      page: 1,
      pageSize: 10000,
      UUID: ctrl.ictUuid,
      typeNotification: ctrl.ictType,
      list: null
    };
    notificationFactory().getListFiltered(payload).$promise.then(function (data) {
      ctrl.notifications = data.list;
      if (ctrl.notifications) {
        for (var i = 0; i < ctrl.notifications.length; i++) {
          var notification = ctrl.notifications[i];
          setBodyText(notification);
          notification.color = 'b-l-warning';
        }
      }
    });
  };
  ctrl.openDetail = function (notification) {
    if (ctrl.ictDetailView == 'link') {
      $location.path("notification/" + notification.version);
    } else {
      ctrl.notificationPanelOpen = true;
      ctrl.selectedNotification = notification;
    }
  };
  ctrl.$onChanges = function (changes) {
    if (changes.ictType && changes.ictType.currentValue || changes.ictUuid && changes.ictUuid.currentValue) {
      ctrl.notificationPanelOpen = false;
      ctrl.getNotificationsList();
    }
  };
  ctrl.getStoplightValue = function (id) {
    return id > 0 ? 1 : 3;
  };
}]);
angular.module('emma.plan').component('ictNotifications', {
  restrict: 'E',
  controller: 'ictNotificationsCtrl',
  templateUrl: 'plan/components/ict_notifications.html',
  bindings: {
    ictType: '<',
    ictUuid: '<',
    ictDetailView: '@' //valori validi: 'link' o 'sidebar'
  }
});
'use strict';

/*
Il componente si occupa di mostrare l'elenco dei consuntivi associati a un determinato odl.
Permette di operare sullo status dei consuntivi. Il funzionamento è implementato sulla base di IctOdlEstimate.
*/
angular.module('emma.plan').controller('ictOdlConsumptiveCtrl', ['$log', 'errorService', 'consumptiveOdlFactory', 'odlWorkflow', 'pipeConsumptive', '$q', 'schemaFactory', '$location', 'uiGridConstants', 'sixGridPaginationConstants', 'dialogService', 'toaster', function ($log, errorService, consumptiveOdlFactory, odlWorkflow, pipeConsumptive, $q, schemaFactory, $location, uiGridConstants, sixGridPaginationConstants, dialogService, toaster) {
  var PATH_CONSUMPTIVE_NEW = '/consumptive/manager/new';
  var ctrl = this;
  if (angular.isUndefined(ctrl.ictManage)) {
    ctrl.ictManage = false;
  }
  ctrl.schemaHeader = undefined;
  ctrl.schemaForm = undefined;
  ctrl.consumptiveList = {
    list: [],
    totalResults: 0
  };
  ctrl.updatingData = false;
  ctrl.consumptiveToLink = null;
  ctrl.linkConsumptiveFilter = {
    'onlyUnlinked': sixFiltersLib.missing('model.odl_id.UUID')
  };
  ctrl.params = {
    pageNumber: 1,
    pageSize: 1000,
    filters: {
      'model.odl_id.UUID': sixFiltersLib.exact('model.odl_id.UUID', ctrl.ictOdlUuid),
      //di default considero la vista limitata, mostro solo gli approvati
      //'model.status': sixFiltersLib.in('model.status', ['published', 'approved', 'refused', 'suspended', 'revised']),
      //e visualizzo solo i consutivi di tipo 'Cliente'
      'model.type': sixFiltersLib["in"]('model.type', ['customer', 'cliente'])
    }
  };
  ctrl.autoResizeParams = {
    enabled: true,
    minHeight: 200,
    marginTop: 290
  };
  ctrl.gridAppCallbacks = {};
  ctrl.gridAppCallbacks['countAttachments'] = countAttachments;
  ctrl.gridAppCallbacks['showPanel'] = showPanel;
  ctrl.viewGridOptions = {
    enableSorting: true,
    enableGridMenu: false,
    exporterCsvColumnSeparator: ';',
    exporterSuppressColumns: ['id', 'timeline'],
    exporterMenuPdf: false,
    enableFiltering: true,
    enableColumnResizing: true,
    paginationPageSizes: [1000],
    paginationPageSize: 1000,
    //cerco di evitare la paginazione
    useExternalPagination: false,
    useExternalFiltering: true,
    multiSelect: true,
    enableRowHeaderSelection: true,
    enableRowSelection: true,
    enableHorizontalScrollbar: 1,
    columnDefs: [{
      name: ' '
    }] //inizializzo con una colonna vuota, da togliere quando carico, se presenti, i dati dei consuntivi
  };

  function countAttachments(item) {
    var nodes = item.model.attachments;
    return recursiveCountFileAttachments(nodes);
  }
  ;
  function recursiveCountFileAttachments(nodes) {
    var count = 0;
    for (var n in nodes) {
      if (nodes[n].folder != true) {
        count++;
      }
      if (0 < nodes[n].nodes.length) {
        count += recursiveCountFileAttachments(nodes[n].nodes);
      }
    }
    return count;
  }
  ctrl.attachmentsPanelOpen = false;
  ctrl.panelConfig = {};
  function showPanel(item) {
    ctrl.attachmentsPanelOpen = true;
    ctrl.panelConfig = {
      title: "Allegati consuntivo: " + item.model.code,
      item: item
    };
  }
  ;
  ctrl.getConsumptiveColumns = function (forceRefresh) {
    if (forceRefresh || !ctrl.schemaHeader || !ctrl.schemaForm) {
      return schemaFactory().byCode({
        id: 'consumptiveheader'
      }).$promise.then(function (response) {
        if (response.model) {
          ctrl.schemaHeader = response.model.schema;
          ctrl.schemaForm = response.model.form;
          ctrl.viewGridOptions.columnDefs = []; // se ho dati, tolgo la colonna vuota con cui lo ho inizialzzato

          angular.forEach(response.model.columnDefs, function (obj) {
            var property = response.model.schema.properties[obj.field];
            if (property.check && property.check == true) {
              var col = {
                displayName: property.title,
                field: 'model.' + obj.field,
                enableFiltering: true
              };
              if (property.type == 'string') {
                col.filters = [{
                  type: 'text',
                  condition: uiGridConstants.filter.CONTAINS,
                  placeholder: ''
                }];
              }
              // template per le colonne in base al loro tipo
              if (property.type == 'string') {
                col.cellTemplate = '<div class="ui-grid-cell-contents cont-left">{{ row.entity.model[\'' + obj.field + '\'] }}</div>';
              }
              if (property.type == 'number' || property.type == 'integer') {
                col.cellTemplate = '<div class="ui-grid-cell-contents cont-right">{{ row.entity.model[\'' + obj.field + '\'] }}</div>';
              }
              if (property.format && property.format == 'date') {
                col.cellTemplate = '<div class="ui-grid-cell-contents cont-center">{{ row.entity.model[\'' + obj.field + '\'] | date: \'dd/MM/yyyy\' }}</div>';
              }
              if (property.format && property.format == 'lookup') {
                col.cellTemplate = '<div class="ui-grid-cell-contents cont-center">{{ row.entity.model[\'' + obj.field + '\'].code }} - {{ row.entity.model[\'' + obj.field + '\'].description }}</div>';
              }
              // template per le colonne custom
              if (obj.field == 'status') {
                col.cellTemplate = '<div class="ui-grid-cell-contents" style="vertical-align:middle;text-align:center;">{{grid.appScope.getReadableStatus(row.entity.model.status)}}</div>';
              }
              if (obj.field == 'type') {
                col.cellTemplate = '<div class="ui-grid-cell-contents" style="vertical-align:middle;text-align:center;">{{grid.appScope.getReadableType(row.entity.model.type)}}</div>';
              }
              // add
              ctrl.viewGridOptions.columnDefs.push(col);
            }
          });

          // colonna allegati
          ctrl.viewGridOptions.columnDefs.push({
            displayName: 'Allegati',
            field: 'model.attachments',
            width: 70,
            enableFiltering: false,
            enableSorting: false,
            cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center" ng-show="grid.appScope.countAttachments(row.entity)">' + '<a ng-click="grid.appScope.showPanel(row.entity)" class="btn btn-xs btn-primary" title="Mostra allegati">' + '<span class="fa fa-paperclip"></span>' + '<span class="badge badge-sm" style="margin: -2px 0 0 4px;">{{grid.appScope.countAttachments(row.entity)}}</span>' + '</a>' + '</div>'
          });
          // ultima colonna con riferimento
          ctrl.viewGridOptions.columnDefs.push({
            displayName: '',
            field: 'id',
            width: 36,
            enableCellEdit: false,
            enableFiltering: false,
            enableSorting: false,
            cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/consumptive/' + (ctrl.ictManage ? 'manager' : 'customer') + '/{{row.entity.UUID}}" class="btn btn-xs btn-primary"><span class="fa fa-search"></span></a>' + '</div>'
          });
        }
      });
    } else {
      return $q.resolve();
    }
  };
  ctrl.getConsumptiveList = function () {
    var p = $q.defer();
    if (ctrl.updatingData) {
      p.reject();
    } else {
      ctrl.updatingData = true;
      ctrl.getConsumptiveColumns().then(function () {
        var filters = angular.copy(ctrl.params.filters);
        if (ctrl.ictManage) {
          //lato admin (manage=true) disattivo i filtri per poter mostrare tutti i consuntivi
          delete filters['model.type'];
          delete filters['model.status'];
        }
        var payload = {
          page: ctrl.params.pageNumber,
          page_size: ctrl.params.pageSize,
          show_revision: false
        };
        consumptiveOdlFactory.searchHeader(payload, filters).$promise.then(function (response) {
          ctrl.consumptiveList.list = response.list || [];
          ctrl.consumptiveList.totalResults = response.totalResults;
          ctrl.viewGridOptions.paginationPageSize = response.totalResults;
          ctrl.updatingData = false;
          ctrl.params.sixApi.refreshList(response.list);
          p.resolve(response);
        });
      });
    }
    return p.promise;
  };
  ctrl.getConsumptiveReadableType = function (type) {
    //FIXME: sarebbe meglio prendere la titleMap da schema form
    var titleMap = [{
      "name": "Cliente",
      "value": "customer"
    }, {
      "name": "Fornitore",
      "value": "supplier"
    },
    //vecchia indicizzazione
    {
      "name": "Cliente",
      "value": "cliente"
    }, {
      "name": "Fornitore",
      "value": "fornitore"
    }];
    for (var i in titleMap) {
      if (titleMap[i].value == type) {
        return titleMap[i].name;
      }
    }
    return type;
  };
  ctrl.getConsumptiveReadableStatus = function (status) {
    //FIXME: sarebbe meglio prendere la titleMap da schema form
    var titleMap = [{
      "name": "Approvato",
      "value": "approved"
    }, {
      "name": "Rifiutato",
      "value": "refused"
    }];
    for (var i in titleMap) {
      if (titleMap[i].value == status) {
        return titleMap[i].name;
      }
    }
    return status;
  };
  ctrl.gridAppCallbacks['getReadableStatus'] = ctrl.getConsumptiveReadableStatus;
  ctrl.gridAppCallbacks['getReadableType'] = ctrl.getConsumptiveReadableType;

  //-- OPERAZIONI DISPONIBILI --//
  ctrl.acceptConsumptive = function () {
    //imposta il consuntivo selezionato su approved, i restanti su refused
    var updates = [];
    var toAccept = ctrl.params.gridApi.selection.getSelectedRows();
    toAccept[0].model.status = "approved";
    updates.push(consumptiveOdlFactory.saveHeader(angular.copy(toAccept[0])).$promise);
    var selection = ctrl.consumptiveList.list;
    for (var i in selection) {
      if (selection[i].UUID == toAccept[0].UUID) continue;
      var toUpdate = angular.copy(selection[i]);
      toUpdate.model.status = "refused";
      updates.push(consumptiveOdlFactory.saveHeader(toUpdate).$promise);
    }
    $q.all(updates).then(function (response) {
      ctrl.getConsumptiveList();
      toaster.pop('success', 'Accettato', 'Il consuntivo è stato accettato.');
    });
  };
  ctrl.denyConsumptives = function () {
    //imposta tutti i consuntivi su refused e triggera il cambio status
    var selection = ctrl.consumptiveList.list;
    var updates = [];
    for (var i in selection) {
      if (selection[i].model.type == "customer") {
        var toUpdate = angular.copy(selection[i]);
        toUpdate.model.status = "refused";
        updates.push(consumptiveOdlFactory.saveHeader(toUpdate).$promise);
      }
    }
    $q.all(updates).then(function (response) {
      ctrl.getConsumptiveList();
      toaster.pop('success', 'Rifiutati', 'I consuntivi sono stati rifiutati.');
    });
  };
  ctrl.linkConsumptive = function () {
    //collega un consuntivo all'odl corrente e aggiorna la lista
    consumptiveOdlFactory.getHeader({
      uuid: ctrl.consumptiveToLink.UUID
    }).$promise.then(function (response) {
      if (response.result) {
        response.result.model.odl_id = {
          UUID: ctrl.ictOdlUuid,
          code: ctrl.ictOdl.model.code,
          description: ctrl.ictOdl.model.description,
          type: "odl"
        };
        consumptiveOdlFactory.saveHeader(response.result).$promise.then(function (response) {
          ctrl.getConsumptiveList();
          toaster.pop('success', 'Collegato', 'Il consuntivo è stato associato all\'odl corrente.');
        });
      }
    });
  };
  ctrl.gotoNewConsumptive = function () {
    //link a creazione consumptive con odl precompilato
    dialogService.confirmDialog('Eventuali modifiche in corso verranno abbandonate, vuoi proseguire?', function () {
      var payload = {
        // consuntivo da inserire
        consumptive: {
          header: {
            model: {}
          }
        }
      };
      payload.consumptive.header.model['odl_id'] = {
        UUID: ctrl.ictOdlUuid,
        code: ctrl.ictOdl.model.code,
        description: ctrl.ictOdl.model.description,
        type: "odl"
      };
      pipeConsumptive.pushConsumptiveRows(payload);
      $location.path(PATH_CONSUMPTIVE_NEW);
    });
  };

  //business logic che vincola al workflow le possibili operazioni
  ctrl.opAllowed = function (operation) {
    //lato admin (manage=true) avrò tutte le opzioni del cliente più delle operazioni aggiuntive
    if (ctrl.ictManage) {
      return true; //sempre permesso
    } else {
      if (operation == 'acceptConsumptive' || operation == 'denyConsumptives') {
        return true;
      } else {
        return false;
      }
    }
  };

  //alcune operazioni sono abilitate solo in base a quali e quanti consuntivi sono selezionati
  ctrl.opDisabled = function (operation) {
    if (angular.isUndefined(ctrl.params.gridApi)) return true;
    var selection = ctrl.params.gridApi.selection.getSelectedRows();
    if (operation == 'acceptConsumptive') {
      return selection.length != 1;
    }
    return false;
  };
  ctrl.$onChanges = function (changes) {
    if (changes.ictOdlUuid && changes.ictOdlUuid.currentValue || changes.ictOdlStatus && changes.ictOdlStatus.currentValue) {
      ctrl.params.filters['model.odl_id.UUID'] = sixFiltersLib.exact('model.odl_id.UUID', ctrl.ictOdlUuid);
      ctrl.getConsumptiveList();
      ctrl.attachmentsPanelOpen = false;
    }
  };
}]);
angular.module('emma.plan').component('ictOdlConsumptive', {
  restrict: 'E',
  controller: 'ictOdlConsumptiveCtrl',
  templateUrl: 'plan/components/ict_odl_consumptive.html',
  bindings: {
    ictOdl: '=',
    ictOdlUuid: '<',
    ictOdlStatus: '<',
    ictManage: '=?'
  }
});
'use strict';

/*
Il componente si occupa di mostrare l'elenco dei preventivi associati a un determinato odl.
Permette di operare sullo status dei preventivi e di aggiornare anche lo status dell'odl.
Le operazioni permesse sono vincolate al workflow prestabilito.
*/
angular.module('emma.plan').controller('ictOdlEstimateCtrl', ['$log', 'errorService', 'estimateFactory', 'odlWorkflow', 'pipeEstimatePromote', '$q', 'schemaFactory', '$location', 'uiGridConstants', 'sixGridPaginationConstants', 'dialogService', 'toaster', function ($log, errorService, estimateFactory, odlWorkflow, pipeEstimatePromote, $q, schemaFactory, $location, uiGridConstants, sixGridPaginationConstants, dialogService, toaster) {
  var PATH_ESTIMATE_NEW = '/estimate/manager/new';
  var ctrl = this;
  if (angular.isUndefined(ctrl.ictManage)) {
    ctrl.ictManage = false;
  }
  ctrl.schemaHeader = undefined;
  ctrl.schemaForm = undefined;
  ctrl.estimateList = {
    list: [],
    totalResults: 0
  };
  ctrl.updatingData = false;
  ctrl.estimateToLink = null;
  ctrl.linkEstimateFilter = {
    'onlyUnlinked': sixFiltersLib.missing('model.odl_id.UUID')
  };
  ctrl.params = {
    pageNumber: 1,
    pageSize: 1000,
    filters: {
      'model.odl_id.UUID': sixFiltersLib.exact('model.odl_id.UUID', ctrl.ictOdlUuid),
      //di default considero la vista cliente, devo filtrare solo preventivi con status e di tipo customer
      'model.type': sixFiltersLib.exact('model.type', 'customer'),
      'model.status': sixFiltersLib["in"]('model.status', ['published', 'approved', 'refused', 'suspended', 'revised'])
    }
  };
  ctrl.autoResizeParams = {
    enabled: true,
    minHeight: 200,
    marginTop: 290
  };
  ctrl.gridAppCallbacks = {};
  ctrl.gridAppCallbacks['countAttachments'] = countAttachments;
  ctrl.gridAppCallbacks['showPanel'] = showPanel;
  ctrl.viewGridOptions = {
    enableSorting: true,
    enableGridMenu: false,
    exporterCsvColumnSeparator: ';',
    exporterSuppressColumns: ['id', 'timeline'],
    exporterMenuPdf: false,
    enableFiltering: true,
    enableColumnResizing: true,
    paginationPageSizes: [1000],
    paginationPageSize: 1000,
    //cerco di evitare la paginazione
    useExternalPagination: false,
    useExternalFiltering: true,
    multiSelect: true,
    enableRowHeaderSelection: true,
    enableRowSelection: true,
    enableHorizontalScrollbar: 1,
    columnDefs: [{
      name: ' '
    }] //inizializzo con una colonna vuota, da togliere quando carico, se presenti, i dati dei preventivi
  };

  //permessi gestiti da odlWorkflow, in base ai quali vengono determinate 
  //le azioni possibili per i preventivi e i passaggi di stato (sull'odl) associati all'azione
  ctrl.permissions = {
    "preventiva": false,
    "pubblica_preventivo": false,
    "accetta_preventivo": false,
    "rifiuta_preventivo": false,
    "revisiona_preventivo": false,
    "sospendi_preventivo": false
  };
  function countAttachments(item) {
    var nodes = item.model.attachments;
    return recursiveCountFileAttachments(nodes);
  }
  function recursiveCountFileAttachments(nodes) {
    var count = 0;
    for (var n in nodes) {
      if (nodes[n].folder != true) {
        count++;
      }
      if (0 < nodes[n].nodes.length) {
        count += recursiveCountFileAttachments(nodes[n].nodes);
      }
    }
    return count;
  }
  ctrl.attachmentsPanelOpen = false;
  ctrl.panelConfig = {};
  function showPanel(item) {
    ctrl.attachmentsPanelOpen = true;
    ctrl.panelConfig = {
      title: "Allegati preventivo: " + item.model.code,
      item: item
    };
  }
  ctrl.updatePermissions = function () {
    //i permessi sono determinati dallo status dell'odl
    odlWorkflow.getStatus(ctrl.ictOdlStatus).then(function (response) {
      for (var perm in ctrl.permissions) {
        if (response.permissions[perm]) {
          ctrl.permissions[perm] = response.permissions[perm];
        } else {
          ctrl.permissions[perm] = false;
        }
      }
    });
  };
  ctrl.getEstimateColumns = function (forceRefresh) {
    if (forceRefresh || !ctrl.schemaHeader || !ctrl.schemaForm) {
      return schemaFactory().byCode({
        id: 'estimateheader'
      }).$promise.then(function (response) {
        if (response.model) {
          ctrl.schemaHeader = response.model.schema;
          ctrl.schemaForm = response.model.form;
          ctrl.viewGridOptions.columnDefs = []; // se ho dati, tolgo la colonna vuota con cui lo ho inizialzzato

          angular.forEach(response.model.columnDefs, function (obj) {
            var property = response.model.schema.properties[obj.field];
            if (property.check && property.check == true) {
              var col = {
                displayName: property.title,
                field: 'model.' + obj.field,
                enableFiltering: true
              };
              if (property.type == 'string') {
                col.filters = [{
                  type: 'text',
                  condition: uiGridConstants.filter.CONTAINS,
                  placeholder: ''
                }];
              }
              // template per le colonne in base al loro tipo
              if (property.type == 'string') {
                col.cellTemplate = '<div class="ui-grid-cell-contents cont-left">{{ row.entity.model[\'' + obj.field + '\'] }}</div>';
              }
              if (property.type == 'number' || property.type == 'integer') {
                col.cellTemplate = '<div class="ui-grid-cell-contents cont-right">{{ row.entity.model[\'' + obj.field + '\'] }}</div>';
              }
              if (property.format && property.format == 'date') {
                col.cellTemplate = '<div class="ui-grid-cell-contents cont-center">{{ row.entity.model[\'' + obj.field + '\'] }}</div>';
              }
              if (property.format && property.format == 'lookup') {
                col.cellTemplate = '<div class="ui-grid-cell-contents cont-center">{{ row.entity.model[\'' + obj.field + '\'].code }} - {{ row.entity.model[\'' + obj.field + '\'].description }}</div>';
              }
              // template per le colonne custom
              if (obj.field == 'type') {
                col.cellTemplate = '<div class="ui-grid-cell-contents" ng-if="row.entity.model.type == \'customer\'" style="height: 50px">Cliente</div>' + '<div class="ui-grid-cell-contents" ng-if="row.entity.model.type == \'supplier\'" style="height: 50px">Fornitore</div>';
              }
              if (obj.field == 'status') {
                col.cellTemplate = '<div class="ui-grid-cell-contents" style="vertical-align:middle;text-align:center;">{{grid.appScope.getReadableStatus(row.entity.model.status)}}</div>';
              }
              // add
              ctrl.viewGridOptions.columnDefs.push(col);
            }
          });
          // colonna allegati
          ctrl.viewGridOptions.columnDefs.push({
            displayName: 'Allegati',
            field: 'model.attachments',
            width: 70,
            enableFiltering: false,
            enableSorting: false,
            cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center" ng-show="grid.appScope.countAttachments(row.entity)">' + '<a ng-click="grid.appScope.showPanel(row.entity)" class="btn btn-xs btn-primary" title="Mostra allegati">' + '<span class="fa fa-paperclip"></span>' + '<span class="badge badge-sm" style="margin: -2px 0 0 4px;">{{grid.appScope.countAttachments(row.entity)}}</span>' + '</a>' + '</div>'
          });
          // ultima colonna con riferimento
          ctrl.viewGridOptions.columnDefs.push({
            displayName: '',
            field: 'id',
            width: 36,
            enableCellEdit: false,
            enableFiltering: false,
            enableSorting: false,
            cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/estimate/' + (ctrl.ictManage ? 'manager' : 'customer') + '/{{row.entity.UUID}}" class="btn btn-xs btn-primary"><span class="fa fa-search"></span></a>' + '</div>'
          });
        }
      });
    } else {
      return $q.resolve();
    }
  };
  ctrl.getEstimateList = function () {
    var p = $q.defer();
    if (ctrl.updatingData) {
      p.reject();
    } else {
      ctrl.updatingData = true;
      ctrl.getEstimateColumns().then(function () {
        var filters = angular.copy(ctrl.params.filters);
        if (ctrl.ictManage) {
          //lato admin (manage=true) disattivo i filtri per poter mostrare tutti i preventivi
          delete filters['model.type'];
          delete filters['model.status'];
        }
        var payload = {
          page: ctrl.params.pageNumber,
          page_size: ctrl.params.pageSize,
          show_revision: false
        };
        estimateFactory.searchHeader(payload, filters).$promise.then(function (response) {
          ctrl.estimateList.list = response.list || [];
          ctrl.estimateList.totalResults = response.totalResults;
          ctrl.viewGridOptions.paginationPageSize = response.totalResults;
          ctrl.updatingData = false;
          ctrl.params.sixApi.refreshList(response.list);
          p.resolve(response);
        });
      });
    }
    return p.promise;
  };
  ctrl.getEstimateReadableStatus = function (status) {
    //FIXME: sarebbe meglio prendere la titleMap da schema form
    var titleMap = [{
      "name": "Pubblicato",
      "value": "published"
    }, {
      "name": "Approvato",
      "value": "approved"
    }, {
      "name": "Rifiutato",
      "value": "refused"
    }, {
      "name": "Sospeso",
      "value": "suspended"
    }, {
      "name": "Revisionato",
      "value": "revised"
    }];
    for (var i in titleMap) {
      if (titleMap[i].value == status) {
        return titleMap[i].name;
      }
    }
    return status;
  };
  ctrl.gridAppCallbacks['getReadableStatus'] = ctrl.getEstimateReadableStatus;

  //-- OPERAZIONI DISPONIBILI --//
  ctrl.acceptEstimate = function () {
    //imposta il preventivo selezionato su approved, i restanti su refused e triggera il cambio status
    dialogService.fillTextField('Note per passaggio di stato', function (status_note) {
      var updates = [];
      var toAccept = ctrl.params.gridApi.selection.getSelectedRows();
      toAccept[0].model.status = "approved";
      toAccept[0].model.status_note = status_note;
      updates.push(estimateFactory.saveHeader(angular.copy(toAccept[0])).$promise);
      var selection = ctrl.estimateList.list;
      for (var i in selection) {
        if (selection[i].UUID == toAccept[0].UUID) continue;
        if (selection[i].model.type == "customer") {
          var toUpdate = angular.copy(selection[i]);
          toUpdate.model.status = "refused";
          updates.push(estimateFactory.saveHeader(toUpdate).$promise);
        }
      }
      $q.all(updates).then(function (response) {
        ctrl.getEstimateList();
        toaster.pop('success', 'Accettato', 'Il preventivo è stato accettato.');
      })["catch"](function (rejection) {
        toaster.pop('error', 'Errore', 'Impossibile aggiornare lo stato del preventivo.');
      });
      ctrl.triggerOdlStatusChange('accetta_preventivo', status_note);
    });
  };
  ctrl.denyEstimates = function () {
    //imposta tutti i preventivi cliente su refused e triggera il cambio status
    dialogService.fillTextField('Note per passaggio di stato', function (status_note) {
      var selection = ctrl.estimateList.list;
      var updates = [];
      for (var i in selection) {
        if (selection[i].model.type == "customer") {
          var toUpdate = angular.copy(selection[i]);
          toUpdate.model.status = "refused";
          toUpdate.model.status_note = status_note;
          updates.push(estimateFactory.saveHeader(toUpdate).$promise);
        }
      }
      $q.all(updates).then(function (response) {
        ctrl.getEstimateList();
        toaster.pop('success', 'Rifiutati', 'I preventivi sono stati rifiutati.');
      })["catch"](function (rejection) {
        toaster.pop('error', 'Errore', 'Errore durante il salvataggio.');
      });
      ctrl.triggerOdlStatusChange('rifiuta_preventivo', status_note);
    });
  };
  ctrl.reviseEstimate = function () {
    //imposta il preventivo selezionato su revised, i restanti su refused e triggera il cambio status
    dialogService.fillTextField('Note per passaggio di stato', function (status_note) {
      var updates = [];
      var toRevise = ctrl.params.gridApi.selection.getSelectedRows();
      toRevise[0].model.status = "revised";
      toRevise[0].model.status_note = status_note;
      updates.push(estimateFactory.saveHeader(angular.copy(toRevise[0])).$promise);
      var selection = ctrl.estimateList.list;
      for (var i in selection) {
        if (selection[i].UUID == toRevise[0].UUID) continue;
        if (selection[i].model.type == "customer") {
          var toUpdate = angular.copy(selection[i]);
          toUpdate.model.status = "refused";
          updates.push(estimateFactory.saveHeader(toUpdate).$promise);
        }
      }
      $q.all(updates).then(function (response) {
        ctrl.getEstimateList();
        toaster.pop('success', 'In revisione', 'Il preventivo selezionato è stato impostato per la revisione.');
      })["catch"](function (rejection) {
        toaster.pop('error', 'Errore', 'Errore durante il salvataggio.');
      });
      ctrl.triggerOdlStatusChange('revisiona_preventivo', status_note);
    });
  };
  ctrl.startPreService = function () {
    //triggera il cambio status
    ctrl.triggerOdlStatusChange('preventiva');
  };
  ctrl.linkEstimate = function () {
    //collega un preventivo all'odl corrente e aggiorna la lista
    estimateFactory.getHeader({
      uuid: ctrl.estimateToLink.UUID
    }).$promise.then(function (response) {
      if (response.result) {
        response.result.model.odl_id = {
          UUID: ctrl.ictOdlUuid,
          code: ctrl.ictOdl.model.code,
          description: ctrl.ictOdl.model.description,
          type: "odl"
        };
        estimateFactory.saveHeader(response.result).$promise.then(function (response) {
          ctrl.getEstimateList();
          toaster.pop('success', 'Collegato', 'Il preventivo è stato associato all\'odl corrente.');
        })["catch"](function (rejection) {
          toaster.pop('error', 'Errore', 'Errore durante il salvataggio.');
        });
      }
    });
  };
  ctrl.gotoNewEstimate = function () {
    //link a creazione estimate con odl precompilato
    dialogService.confirmDialog('Eventuali modifiche in corso verranno abbandonate, vuoi proseguire?', function () {
      var payload = {
        // prev. cliente da inserire
        estimateCustomer: {
          header: {
            model: {}
          }
        }
      };
      payload.estimateCustomer.header.model['odl_id'] = {
        UUID: ctrl.ictOdlUuid,
        code: ctrl.ictOdl.model.code,
        description: ctrl.ictOdl.model.description,
        type: "odl"
      };
      pipeEstimatePromote.pushEstimateRows(payload);
      $location.path(PATH_ESTIMATE_NEW);
    });
  };
  ctrl.publishEstimates = function () {
    //imposta come published i preventivi scelti e triggera il cambio status (solo se è in ESTIMATE_REQUESTED)
    var selection = ctrl.params.gridApi.selection.getSelectedRows();
    var updates = [];
    for (var i in selection) {
      if (selection[i].model.type == "customer" && (angular.isUndefined(selection[i].model.status) || selection[i].model.status == "")) {
        var toUpdate = angular.copy(selection[i]);
        toUpdate.model.status = "published";
        updates.push(estimateFactory.saveHeader(toUpdate).$promise);
      }
    }
    $q.all(updates).then(function (response) {
      ctrl.getEstimateList();
      toaster.pop('success', 'Pubblicati', 'I preventivi selezionati sono stati pubblicati.');
    })["catch"](function (rejection) {
      toaster.pop('error', 'Errore', 'Errore durante il salvataggio.');
    });
    ctrl.triggerOdlStatusChange('pubblica_preventivo');
  };
  ctrl.suspendEstimates = function () {
    //imposta tutti i preventivi cliente su suspended e triggera il cambio status
    dialogService.fillTextField('Note per passaggio di stato', function (status_note) {
      var selection = ctrl.estimateList.list;
      var updates = [];
      for (var i in selection) {
        if (selection[i].model.type == "customer") {
          var toUpdate = angular.copy(selection[i]);
          toUpdate.model.status = "suspended";
          toUpdate.model.status_note = status_note;
          updates.push(estimateFactory.saveHeader(toUpdate).$promise);
        }
      }
      $q.all(updates).then(function (response) {
        ctrl.getEstimateList();
        toaster.pop('success', 'Sospesi', 'I preventivi sono stati sospesi.');
      })["catch"](function (rejection) {
        toaster.pop('error', 'Errore', 'Errore durante il salvataggio.');
      });
      ctrl.triggerOdlStatusChange('sospendi_preventivo', status_note);
    });
  };
  ctrl.triggerOdlStatusChange = function (permission, status_note) {
    if (ctrl.permissions[permission]) {
      var newStatus = ctrl.permissions[permission];
      //controllo lo status sia raggiungibile
      odlWorkflow.getNextStatuses(ctrl.ictOdlStatus).then(function (allowedStatuses) {
        var newStatusAvailable = false;
        for (var i in allowedStatuses) {
          if (allowedStatuses[i].code == newStatus) newStatusAvailable = true;
        }
        if (newStatusAvailable) {
          var statusLabel = odlWorkflow.getReadableStatus(newStatus);
          dialogService.confirmDialog('Confermi il passaggio allo status: ' + statusLabel, function () {
            var changeObj = {
              'status': newStatus
            };
            if (angular.isUndefined(status_note)) {
              dialogService.fillTextField('Note per passaggio di stato', function (status_note) {
                ctrl.doOdlStatusChange(newStatus, status_note);
              });
            } else {
              ctrl.doOdlStatusChange(newStatus, status_note);
            }
          });
        }
      });
    }
  };
  ctrl.doOdlStatusChange = function (newStatus, status_note) {
    if (status_note != "") {
      ctrl.ictOdl.status_note = status_note;
    }
    odlWorkflow.setStatus(newStatus, ctrl.ictOdl).then(function (updatedObject) {
      //success
      ctrl.ictOdl = updatedObject;
      //update
    }, function (rejection) {
      //error
      toaster.pop('error', 'Passaggio di stato fallito', rejection.data.message ? rejection.data.message : rejection.statusText);
    });
  };

  //business logic che vincola al workflow le possibili operazioni
  ctrl.opAllowed = function (operation) {
    if (operation == 'acceptEstimate') {
      return Boolean(ctrl.permissions["accetta_preventivo"]);
    }
    if (operation == 'denyEstimates') {
      return Boolean(ctrl.permissions["rifiuta_preventivo"]);
    }
    if (operation == 'reviseEstimate') {
      return Boolean(ctrl.permissions["revisiona_preventivo"]);
    }
    if (operation == 'suspendEstimates') {
      return Boolean(ctrl.permissions["sospendi_preventivo"]);
    }

    //lato admin (manage=true) avrò tutte le opzioni del cliente più delle operazioni aggiuntive
    if (ctrl.ictManage) {
      if (operation == 'startPreService') {
        return ctrl.estimateList.totalResults == 0 && ctrl.permissions["preventiva"];
      }
      if (operation == 'linkEstimate') {
        return true; //sempre permesso
      }

      if (operation == 'gotoNewEstimate') {
        return true; //sempre permesso
      }

      if (operation == 'publishEstimates') {
        //FIXME: ipotizzo i dati non vengano paginati per contare correttamente i preventivi senza status
        var list = ctrl.estimateList.list;
        for (var i = 0; i < list.length; i++) {
          if (list[i].model.status == '' || angular.isUndefined(list[i].model.status)) {
            return Boolean(ctrl.permissions["pubblica_preventivo"]);
          }
        }
        return false;
      }
    }
    return false;
  };

  //alcune operazioni sono abilitate solo in base a quali e quanti preventivi sono selezionati
  ctrl.opDisabled = function (operation) {
    if (angular.isUndefined(ctrl.params.gridApi)) return true;
    var selection = ctrl.params.gridApi.selection.getSelectedRows();
    if (operation == 'publishEstimates') {
      if (selection.length == 0) return true;
      var toPublish = 0;
      for (var i in selection) {
        if (angular.isUndefined(selection[i].model.status) || selection[i].model.status == "") toPublish++;
      }
      return !toPublish;
    }
    if (operation == 'acceptEstimate') {
      return selection.length != 1 || selection[0].model.type != "customer";
    }
    if (operation == 'reviseEstimate') {
      return selection.length != 1 || selection[0].model.type != "customer";
    }
    return false;
  };
  ctrl.$onChanges = function (changes) {
    if (changes.ictOdlUuid && changes.ictOdlUuid.currentValue || changes.ictOdlStatus && changes.ictOdlStatus.currentValue) {
      ctrl.params.filters['model.odl_id.UUID'] = sixFiltersLib.exact('model.odl_id.UUID', ctrl.ictOdlUuid);
      ctrl.updatePermissions();
      ctrl.getEstimateList();
      ctrl.attachmentsPanelOpen = false;
    }
  };
}]);
angular.module('emma.plan').component('ictOdlEstimate', {
  restrict: 'E',
  controller: 'ictOdlEstimateCtrl',
  templateUrl: 'plan/components/ict_odl_estimate.html',
  bindings: {
    ictOdl: '=',
    ictOdlUuid: '<',
    ictOdlStatus: '<',
    ictManage: '=?'
  }
});
'use strict';

angular.module('emma.plan').controller('ictPlafondCtrl', ["$q", "$log", "$timeout", "consipWrapper", "odlFactory", "$scope", function ($q, $log, $timeout, consipWrapper, odlFactory, $scope) {
  var plafondService = consipWrapper.getPlafondService();
  var ctrl = this;
  var bufferedPromise;
  ctrl.$onInit = function () {
    $log.info("Initalize ictPlafond");
    if (!plafondService) {
      $log.warn("Missing required service");
    } else {
      consipWrapper.getContract().then(function (contract) {
        $scope.contract = contract.model.contract_type || consipWrapper.CONTRACT_TYPES.strict;
        if ($scope.contract == consipWrapper.CONTRACT_TYPES.loose) {
          loadLoosePlafond();
        }
      }, function (err) {
        $log.error('Impossibile caricare il contratto per la convenzione');
      });
    }
  };
  var contractTimeout;
  ctrl.$onChanges = function (changesObj) {
    if ($scope.contract === undefined) {
      if (contractTimeout) $timeout.cancel(contractTimeout);
      contractTimeout = $timeout(ctrl.$onChanges, 200, true, changesObj);
      return;
    }
    if ($scope.contract == consipWrapper.CONTRACT_TYPES.strict) {
      $log.debug("Is first Changes", changesObj.odl.isFirstChange(), "Current value", changesObj.odl.currentValue);
      if (bufferedPromise) {
        $timeout.cancel(bufferedPromise);
      }
      bufferedPromise = $timeout(loadOdl, 200, true, changesObj.odl.currentValue);
    }
  };
  function loadOdl(odlRef) {
    if (odlRef && odlRef.UUID) {
      $log.debug("Loading odl", odlRef.UUID);
      odlFactory().getOdlByUUID({
        uuid: odlRef.UUID
      }).$promise.then(function (response) {
        $log.debug("Odl", response);
        if (response.model) {
          if (!(angular.equals(ctrl.service, response.model.service_id) && angular.equals(ctrl.asset, response.model.record_id))) {
            ctrl.service = response.model.service_id;
            ctrl.asset = response.model.record_id;
            loadPlafond();
          }
        } else {
          $log.error("Invalid ODL");
          clear();
        }
      }, function (err) {
        $log.error(err);
        clear();
      });
    } else {
      clear();
    }
  }
  function clear() {
    ctrl.service = null;
    ctrl.asset = null;
    if (ctrl.plafond != false) {
      ctrl.plafond = false;
      ctrl.onPlafondChange({
        plafond: false
      });
    }
  }
  function loadPlafond() {
    if (plafondService == false) return;
    if (ctrl.service && ctrl.service.UUID && ctrl.asset && ctrl.asset.UUID) {
      $log.debug("Loading opf and sal", ctrl.service, ctrl.asset);
      plafondService.getPlafond(ctrl.service.UUID, ctrl.asset.UUID).then(function (response) {
        ctrl.plafond = response;
      }, function (err) {
        ctrl.plafond = false;
      })["finally"](function () {
        ctrl.onPlafondChange({
          plafond: ctrl.plafond
        });
      });
    } else {
      if (ctrl.plafond != false) {
        ctrl.plafond = false;
        ctrl.onPlafondChange({
          plafond: false
        });
      }
    }
  }
  function loadLoosePlafond() {
    if (plafondService == false) return;
    $q.all([plafondService.getConstrain(), plafondService.getCustomerPlafond()]).then(function (responses) {
      if (responses[1].hasErrors) {
        $log.error('Impossibile caricare il plafond per il cliente');
        ctrl.plafond = false;
      } else {
        ctrl.plafond = responses[1].result;
        ctrl.plafond.residual = ctrl.plafond.total - ctrl.plafond.turnover;
        ctrl.plafond.constrain = responses[0];
      }
    }, function (err) {
      $log.error('Impossibile caricare il plafond per il cliente');
      ctrl.plafond = false;
    })["finally"](function () {
      ctrl.onPlafondChange({
        plafond: ctrl.plafond
      });
    });
  }
  $scope.$on("update_plafond", function () {
    if ($scope.contract == consipWrapper.CONTRACT_TYPES.loose) {
      loadLoosePlafond();
    } else {
      if (ctrl.odl) {
        loadPlafond();
      } else {
        $log.warn("odl missing, could not update plafond");
      }
    }
  });
}]).component('ictPlafond', {
  controller: 'ictPlafondCtrl',
  templateUrl: 'plan/components/ict_plafond.html',
  bindings: {
    odl: '<',
    onPlafondChange: '&'
  }
});
/**
 * Created by luca on 07/04/17.
 */

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:ConsumptiveOdlCtrl
 * @description
 * # ConsumptiveOdlCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan')
// type può essere 'customer' per i clienti, 'manager' per i dipendenti di manager
.config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/consumptive/:type', {
    templateUrl: 'plan/consumptiveodl/consumptiveodl_list.html',
    controller: 'ConsumptiveOdlCtrl'
  }).when('/consumptive/:type/:id', {
    templateUrl: 'plan/consumptiveodl/consumptiveodl_detail.html',
    controller: 'ConsumptiveOdlCtrl'
  });
}]).controller('ConsumptiveOdlCtrl', ["$scope", "consipWrapper", "authFactory", "$route", "$routeParams", "$log", "$q", "$timeout", "$location", "schemaFactory", "consumptiveOdlFactory", "uiGridConstants", "dialogService", "recordFactory", "pipeConsumptive", "toaster", "sixGridPaginationConstants", "$http", "APP_URL", "SaveAs", function ($scope, consipWrapper, authFactory, $route, $routeParams, $log, $q, $timeout, $location, schemaFactory, consumptiveOdlFactory, uiGridConstants, dialogService, recordFactory, pipeConsumptive, toaster, sixGridPaginationConstants, $http, APP_URL, SaveAs) {
  $scope.currentCommission = authFactory.getAuthData().info.commissions.current;
  $scope.isNew = false; // indica se il record inserito è nuovo o meno
  $scope.isCompliant = true; // booleano che indica se il totale è conforme
  $scope.schemaHeader = {}; // contenitore schema-form testata
  $scope.schemaRow = {}; // contenitore schema-form riga
  $scope.requiredField = {}; // contenitore con i campi obbligatori per la grid
  $scope.modifiedList = []; // righe modifiche -> update
  $scope.deletedList = []; // righe eliminate -> delete
  $scope.insertedList = []; // righe inserite  -> save
  $scope.currentIndexRow = 0; // indice contatore delle righe: per individuare univocamente ogni riga
  $scope.consumptiveList = {
    list: []
  }; // lista con tutte le testate
  $scope.findCross = false; // ricerca cross-commessa
  $scope.typeExport = 'export'; // tipo di esportazione
  $scope.rowPositionTotal = undefined; // posizione colonna con il totale nella grid
  $scope.type = 'customer'; // tipo di visualizzazione per la pagina: 'customer' o 'manager'
  $scope.editable = false;
  $scope.plafond = false;
  $scope.isPlafondEnabled = false;
  if ($routeParams.type) {
    $scope.type = $routeParams.type;
    $scope.editable = $routeParams.type == 'manager';
  }
  $scope.params = {
    // param. tabella: paginazione e filtri
    pageNumber: 1,
    pageSize: 100,
    filters: {}
  };
  $scope.autoResizeParams = {
    // param. tabella: pagina di lista con le testate dei consuntivi
    enabled: true,
    minHeight: 200,
    marginTop: 290
  };
  $scope.data = {
    // dato consuntivo
    header: {
      model: {
        attachments: []
      }
    },
    rows: []
  };
  $scope.readOnlyHeader = {
    model: {
      attachments: []
    }
  };
  $scope.modelLoaded = false;
  $scope.gridOptions = {
    // righe consuntivo
    xlsData: [],
    data: $scope.data.rows,
    columnDefs: [],
    showColumnFooter: true,
    importerDataAddCallback: function importerDataAddCallback(grid, newObjects) {},
    onRegisterApi: onRegisterApiCallback
  };
  function onRegisterApiCallback(gridApi) {
    $scope.gridApi = gridApi;
    gridApi.edit.on.afterCellEdit($scope, afterCellEditCallback);
    gridApi.rowEdit.on.saveRow($scope, onSaveRowCallback);
  }
  $scope.viewGridOptions = {
    enableSorting: true,
    enableGridMenu: false,
    exporterCsvColumnSeparator: ';',
    exporterSuppressColumns: ['id', 'timeline'],
    exporterMenuPdf: false,
    enableFiltering: true,
    enableColumnResizing: true,
    paginationPageSizes: [100, 250, 500, 1000, 10000],
    paginationPageSize: 100,
    useExternalPagination: true,
    useExternalFiltering: true,
    multiSelect: false,
    enableRowHeaderSelection: true,
    enableRowSelection: true,
    enableHorizontalScrollbar: 1,
    columnDefs: [{
      name: ' '
    }]
  };

  /** PLAFOND */

  consipWrapper.isPlafondEnabled().then(function (enabled) {
    $scope.isPlafondEnabled = enabled;
  }, $log.error);
  $scope.plafondChange = function (plafond) {
    $scope.plafond = plafond;
    checkPlafondLimit();
  };
  $scope.$watch("data.header.model.total", checkPlafondLimit);
  var checkPlafondLimitBuffer;
  function checkPlafondLimit() {
    if (checkPlafondLimitBuffer) {
      $timeout.cancel(checkPlafondLimitBuffer);
    }
    checkPlafondLimitBuffer = $timeout(function () {
      if ($scope.isPlafondEnabled && $scope.editable && angular.isObject($scope.plafond)) {
        if ($scope.plafond.residual < $scope.data.header.model.total) {
          toaster.pop("warning", "", "Il plafond residuo è inferiore al totale inserito");
        } else if ($scope.plafond.residual - $scope.plafond.constrain < $scope.data.header.model.total) {
          toaster.pop("warning", "", "Il plafond impegnato è maggiore di quello residuo");
        }
      }
    }, 500);
  }

  /** MODIFICA DI UNA RIGA */

  function onSaveRowCallback(rowEntity) {
    var promise = $q.defer();
    $scope.gridApi.rowEdit.setSavePromise(rowEntity, promise.promise);
    promise.resolve();
  }
  function afterCellEditCallback(rowEntity) {
    for (var field in rowEntity.model) {
      // pulisco la riga da campi vuoti
      if (rowEntity.model.hasOwnProperty(field) && rowEntity.model[field] == "") {
        delete rowEntity.model[field];
      }
    }
    if (rowEntity.UUID) {
      if (!isItemInArrayByCode($scope.modifiedList, rowEntity)) {
        $scope.modifiedList.push(rowEntity);
      }
    }
    $scope.addDataToGrid([rowEntity]);
  }

  /** CANCELLAZIONE DI UNA RIGA */

  $scope.deleteRow = function (item) {
    var index = $scope.data.rows.indexOf(item.entity);
    if (index > -1) {
      $scope.data.rows.splice(index, 1);
      /* gestione per mod/elim/agg righe nuove sul consuntivo */
      if (item.entity.UUID) {
        $scope.deletedList.push(item.entity);
        if (isItemInArrayByCode($scope.modifiedList, item.entity)) {
          deleteItemInArrayByCode($scope.modifiedList, item.entity);
        }
      } else {
        if (isItemInArrayByCode($scope.insertedList, item.entity)) {
          deleteItemInArrayByCode($scope.insertedList, item.entity);
        }
      }
    }
  };

  /** INSERIMENTO DI UNA RIGA */

  $scope.insertRow = function () {
    if ($scope.gridOptions.columnDefs.length == 0) {
      $scope.gridOptions.columnDefs = getColumnDefsGridFull();
    }
    var row = {
      sixImportStatus: 'NEW',
      model: {
        code: 'index_row_' + $scope.currentIndexRow
      }
    };
    $scope.currentIndexRow++;
    $scope.data.rows.push(row);
    $scope.insertedList.push(row);
  };

  /** IMPORTAZIONE RIGHE DA EXCEL */

  $scope.$watch(function () {
    return $scope.gridOptions.xlsData;
  }, function (newValue) {
    if (newValue && newValue.length > 0) {
      $scope.setDataFromXlsToGrid($scope.gridOptions.xlsData);
    }
  });

  /* da array excel -> ad array di oggetti (con solo model) */
  $scope.setDataFromXlsToGrid = function (xlsArray) {
    var rowArray = [];
    xlsArray.forEach(function (xlsRow) {
      xlsRow.code = 'index_row_' + $scope.currentIndexRow; // codice di default
      var row = {
        model: xlsRow,
        sixImportStatus: 'OK'
      };
      $scope.currentIndexRow++;
      rowArray.push(row);
    });
    $scope.addDataToGrid(rowArray);
  };

  /** CONTROLLO RIGHE E AGGIUNTA AL CONSUNTIVO */

  // le righe passate in 'arrayToImport' vengono controllate -> poi aggiunte alla grid
  // se le righe sono già state inserite -> vengono aggiornate, se le righe sono nuove -> vengono inserite
  $scope.addDataToGrid = function (arrayToImport) {
    $scope.gridOptions.columnDefs = getColumnDefsGridFull();
    var properties = $scope.schemaRow.model.schema.properties;
    var lookups = [];
    var arrays = [];
    var numbers = [];
    var booleans = [];
    for (var key in properties) {
      if (properties[key]) {
        if (properties[key].format == 'lookup' && properties[key].entity_id) {
          lookups.push(key);
        } else if (properties[key].type == 'array') {
          arrays.push(key);
        } else if (properties[key].type == 'integer' || properties[key].type == 'number') {
          numbers.push(key);
        } else if (properties[key].type == 'boolean') {
          booleans.push(key);
        }
      }
    }
    function parseBoolean(value) {
      var lower = value.toLowerCase();
      return lower === 'vero' || lower === 'v' || lower === 'true' || lower === 't' || lower === 'si' || lower === 's';
    }
    var indexMapToResolve = {
      record: {}
    };
    arrayToImport.forEach(function (row) {
      for (var l in lookups) {
        (function () {
          var k = lookups[l];
          var v = row.model[k];
          if (!angular.isUndefined(v)) {
            // se ho già una lookup -> prendo il code e controllo che venga risolto
            if (v['code'] && v['UUID'] && v['type'] && v['description']) {
              v = v['code'];
            }
            var mapToResolve = {};
            if (angular.isUndefined(properties[k].basePath)) {
              mapToResolve = indexMapToResolve.record;
            } else {
              if (properties[k].basePath in indexMapToResolve) {
                mapToResolve = indexMapToResolve[properties[k].basePath];
              } else {
                indexMapToResolve[properties[k].basePath] = {};
                mapToResolve = indexMapToResolve[properties[k].basePath];
              }
            }
            var innerMap;
            if (properties[k].entity_id in mapToResolve) {
              innerMap = mapToResolve[properties[k].entity_id];
              innerMap[v] = '';
            } else {
              mapToResolve[properties[k].entity_id] = {};
              innerMap = mapToResolve[properties[k].entity_id];
              innerMap[v] = '';
            }
          }
        })();
      }
      arrays.forEach(function (a) {
        if (row.model[a]) {
          row.model[a] = row.model[a].replace(/[“”']/g, '"');
          row.model[a] = JSON.parse(row.model[a]);
        }
      });
      numbers.forEach(function (n) {
        if (row.model[n]) {
          row.model[n] = parseFloat(row.model[n]);
        }
      });
      booleans.forEach(function (b) {
        if (row.model[b]) {
          row.model[b] = parseBoolean(row.model[b]);
        }
      });
    });
    for (var index in indexMapToResolve) {
      var mapToResolve = indexMapToResolve[index];
      var promise;
      if (index === 'record') {
        promise = recordFactory('type').bulkResolve(mapToResolve).$promise;
      }
      promise.then(function (data) {
        $log.info(data);
        arrayToImport.forEach(function (row) {
          if (index === 'record') {
            row['sixImportStatus'] = 'OK';
          }
          for (var l in lookups) {
            (function () {
              //closure <3
              var k = lookups[l];
              var v = row.model[k];
              if (!angular.isUndefined(v) && v !== null) {
                // se ho già una lookup -> prendo il code e controllo che venga risolto
                if (v['code'] && v['UUID'] && v['type'] && v['description']) {
                  v = v['code'];
                }
                var resolved = data[properties[k].entity_id];
                if (resolved) {
                  var ref;
                  if (properties[k].hasOwnProperty('multiple') && properties[k].multiple == true) {
                    // lookup multipla
                    row.model[k] = [];
                    for (var res in resolved) {
                      if (resolved.hasOwnProperty(res)) {
                        ref = sixObjectLib.recordToHisRef(resolved[res]);
                        if (!ref) {
                          if (row['sixImportStatus'] == 'OK') row['sixImportStatus'] = '';
                          row['sixImportStatus'] = row['sixImportStatus'].concat(k + ' (' + properties[k].entity_id + ') array di lookup non risolto; ');
                        } else {
                          row.model[k].push(ref);
                        }
                      }
                    }
                  } else {
                    ref = sixObjectLib.recordToHisRef(resolved[v]);
                    if (!ref) {
                      if (row['sixImportStatus'] == 'OK') row['sixImportStatus'] = '';
                      row['sixImportStatus'] = row['sixImportStatus'].concat(k + ' (' + properties[k].entity_id + ') ' + v + ' non trovato; ');
                    } else {
                      row.model[k] = ref;
                    }
                  }
                }
              }
            })();
          }
          var isNewRow = true; // riga con quel codice -> sostituisco, altrimenti -> push
          for (var i = 0; i < $scope.data.rows.length; i++) {
            if ($scope.data.rows[i].model.code == row.model.code) {
              isNewRow = false;
              $scope.data.rows[i] = row;
            }
          }
          if (isNewRow) {
            $scope.data.rows.push(row); // se è una riga nuova la aggiungo alla grid
            if (!row.version) {
              // se non ha la versione e anche da mandare alla "_save"
              $scope.insertedList.push(row);
            }
          }
        });
      });
    }
  };

  /** TABELLA - GRID CONSUNTIVO */

  $scope.checkTotalCompliant = function (total) {
    /** mi serve per formattare il totale a due cifre:
     * partono delle chiamate della grid che non riesco a controllare
     * quindi capita che arrivi un totale con più decimali
     * -> lo formatto in tutti i casi */
    if (total) {
      total = Math.round(total * 100) / 100;
    }
    $scope.isCompliant = total == $scope.data.header.model['total'];
    return $scope.isCompliant;
  };
  function getColumnDefsGridFull() {
    var array = [];
    array.push({
      field: 'sixImportStatus',
      enableCellEdit: false,
      enableHiding: false,
      cellTemplate: '<div class="ui-grid-cell-contents" ng-class="{ newclass: grid.appScope.rowIsNew(row), errorclass: grid.appScope.rowInError(row) }">' + '{{row.entity.sixImportStatus}}' + '</div>'
    });
    angular.forEach($scope.schemaRow.model.form, function (fValue) {
      angular.forEach(fValue.items, function (iValue) {
        angular.forEach(iValue.tabs, function (tValue) {
          angular.forEach(tValue.items, function (itemsValue) {
            var name = itemsValue.key[0];
            if (name != 'code' && name != 'description') {
              var property = $scope.schemaRow.model.schema.properties[name];
              var col = {
                displayName: property.title,
                field: 'model.' + name,
                filters: [{
                  placeholder: 'ends with...'
                }],
                enableCellEdit: true,
                enableFiltering: false,
                enableSorting: false,
                enableHiding: false,
                cellTemplate: '<div class="ui-grid-cell-contents" ng-if="row.entity.model[\'' + name + '\']" ng-class="{newclass: grid.appScope.rowIsNew(row), errorclass: grid.appScope.rowInError(row), requiredclass: grid.appScope.fieldIsRequired(row,\'' + name + '\',' + $scope.requiredField[name].required + ')}">' + '{{ row.entity.model[\'' + name + '\'] }}' + '</div>' + '<div class="ui-grid-cell-contents" ng-if="!row.entity.model[\'' + name + '\']" ng-class="{placehodlerclass: true, requiredclass: grid.appScope.fieldIsRequired(row,\'' + name + '\',' + $scope.requiredField[name].required + ')}">' + '{{ \'string\' }}' + '</div>'
              };
              if (property.type == 'string') {
                col['cellTemplate'] = '<div class="ui-grid-cell-contents cont-left" ng-if="row.entity.model[\'' + name + '\']" ng-class="{newclass: grid.appScope.rowIsNew(row), errorclass: grid.appScope.rowInError(row), requiredclass: grid.appScope.fieldIsRequired(row,\'' + name + '\',' + $scope.requiredField[name].required + ')}">' + '{{ row.entity.model[\'' + name + '\'] }}' + '</div>' + '<div class="ui-grid-cell-contents cont-left" ng-if="!row.entity.model[\'' + name + '\']" ng-class="{placehodlerclass: true, requiredclass: grid.appScope.fieldIsRequired(row,\'' + name + '\',' + $scope.requiredField[name].required + ')}">' + '{{ \'string\' }}' + '</div>';
              }
              if (property.format && property.format == 'date') {
                col['cellTemplate'] = '<div class="ui-grid-cell-contents cont-center" ng-if="row.entity.model[\'' + name + '\']" ng-class="{newclass: grid.appScope.rowIsNew(row), errorclass: grid.appScope.rowInError(row), requiredclass: grid.appScope.fieldIsRequired(row,\'' + name + '\',' + $scope.requiredField[name].required + ')}">' + '{{ row.entity.model[\'' + name + '\'] }}' + '</div>' + '<div class="ui-grid-cell-contents cont-center" ng-if="!row.entity.model[\'' + name + '\']" ng-class="{placehodlerclass: true, requiredclass: grid.appScope.fieldIsRequired(row,\'' + name + '\',' + $scope.requiredField[name].required + ')}">' + '{{ \'aaaa-mm-gg\' }}' + '</div>';
              }
              if (property.type == 'number' || property.type == 'integer') {
                col['type'] = 'number';
                col['cellTemplate'] = '<div class="ui-grid-cell-contents cont-right" ng-if="row.entity.model[\'' + name + '\']" ng-class="{newclass: grid.appScope.rowIsNew(row), errorclass: grid.appScope.rowInError(row), requiredclass: grid.appScope.fieldIsRequired(row,\'' + name + '\',' + $scope.requiredField[name].required + ')}">' + '{{grid.appScope.formatNumber(row.entity.model[\'' + name + '\'])}}' + '</div>' + '<div class="ui-grid-cell-contents cont-right" ng-if="!row.entity.model[\'' + name + '\']" ng-class="{placehodlerclass: true, requiredclass: grid.appScope.fieldIsRequired(row,\'' + name + '\',' + $scope.requiredField[name].required + ')}">' + '{{ \'1,234\' }}' + '</div>';
              }
              if (property.format && property.format == 'lookup') {
                col['cellTemplate'] = '<six-lookup-2 sx-id="' + itemsValue.sxId + '"' + ' ng-model="row.entity.model[\'' + name + '\']"' + ' sx-type="\'' + property.entity_id + '\'"' + ' sx-base-path="\'record\'"' + ' sx-add="' + itemsValue.sxAdd + '"' + ' sx-war="' + property.war + '"' + ' sx-show-details="' + itemsValue.sxShowDetails + '"' + ' sx-show-filters="' + itemsValue.sxShowFilters + '"' + ' sx-multiple="' + itemsValue.sxMultiple + '"' + ' sx-title="\'' + property.title + '\'"' + ' sx-compact="true"' + ' sx-on-select="grid.appScope.lookupCallback(item, row.entity)"' + '>' + '</six-lookup-2>';
              }
              // colonna 'totale' custom
              if (name == 'total') {
                $scope.rowPositionTotal = array.length;
                col['type'] = 'number';
                col['aggregationType'] = uiGridConstants.aggregationTypes.sum;
                // cella
                col['cellTemplate'] = '<div class="ui-grid-cell-contents cont-right" ng-if="grid.appScope.calculateTotalRow(row)" ng-class="{newclass: grid.appScope.rowIsNew(row), errorclass: grid.appScope.rowInError(row), requiredclass: grid.appScope.fieldIsRequired(row,\'' + name + '\',' + $scope.requiredField[name].required + ')}">' + '{{grid.appScope.calculateTotalRow(row)}} €' + '</div>';
                // footer
                col['footerCellTemplate'] = '<div class="ui-grid-cell-contents cont-right" ng-class="{errorclass: !grid.appScope.checkTotalCompliant(col.getAggregationValue()), requiredclass: grid.appScope.fieldIsRequired(row,\'' + name + '\',' + $scope.requiredField[name].required + ')}">' + '{{grid.appScope.calculateTotalGrid(col.getAggregationValue())}} €' + '</div>';
              }
              // colonna 'prezzo unitario' custom
              if (name == 'unit_price') {
                col['type'] = 'number';
                col['cellTemplate'] = '<div class="ui-grid-cell-contents cont-right" ng-if="row.entity.model[\'' + name + '\']" ng-class="{newclass: grid.appScope.rowIsNew(row), errorclass: grid.appScope.rowInError(row), requiredclass: grid.appScope.fieldIsRequired(row,\'' + name + '\',' + $scope.requiredField[name].required + ')}">' + '{{grid.appScope.formatPrice(row.entity.model[\'' + name + '\'])}} €' + '</div>' + '<div class="ui-grid-cell-contents cont-right" ng-if="!row.entity.model[\'' + name + '\']" ng-class="{placehodlerclass: true, requiredclass: grid.appScope.fieldIsRequired(row,\'' + name + '\',' + $scope.requiredField[name].required + ')}">' + '1,234 €' + '</div>';
              }
              array.push(col);
            }
          });
        });
      });
    });
    if ($scope.editable) {
      array.push({
        displayName: '',
        field: 'delete',
        width: 36,
        enableCellEdit: false,
        enableFiltering: false,
        enableSorting: false,
        enableHiding: false,
        cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<button ng-click="grid.appScope.deleteRow(row)" class="btn btn-xs btn-danger"><i class="fa fa-times"></i></button>' + '</div>'
      });
    }
    return array;
  }
  function getColumnDefsListFull() {
    var array = [];
    array.push({
      displayName: '',
      field: 'id',
      width: 36,
      enableCellEdit: false,
      enableFiltering: false,
      enableSorting: false,
      cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/consumptive/' + $scope.type + '/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' + '<span class="fa fa-search"></span>' + '</a>' + '</div>'
    });
    angular.forEach($scope.schemaHeader.model.columnDefs, function (obj) {
      var property = $scope.schemaHeader.model.schema.properties[obj.field];
      if (property.check && property.check == true) {
        var col = {
          displayName: property.title,
          field: 'model.' + obj.field,
          enableFiltering: true
        };
        if (property.type == 'string') {
          col.filters = [{
            type: sixGridPaginationConstants.filterType.TEXT,
            condition: uiGridConstants.filter.CONTAINS,
            placeholder: ''
          }];
        }
        // template per le colonne in base al loro tipo
        if (property.type == 'string') {
          col.cellTemplate = '<div class="ui-grid-cell-contents cont-left">{{ row.entity.model[\'' + obj.field + '\'] }}</div>';
        }
        if (property.type == 'number' || property.type == 'integer') {
          col.cellTemplate = '<div class="ui-grid-cell-contents cont-left">{{ row.entity.model[\'' + obj.field + '\'] }}</div>';
        }
        if (property.format && property.format == 'date') {
          col.cellTemplate = '<div class="ui-grid-cell-contents cont-center">{{ row.entity.model[\'' + obj.field + '\'] | date: \'dd/MM/yyyy\' }}</div>';
          col.type = 'date';
          col.cellFilter = 'date:\'dd/MM/yyyy\'';
          col.filters = [{
            type: sixGridPaginationConstants.filterType.DATE,
            relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
            placeholder: 'da...',
            condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
          }, {
            type: sixGridPaginationConstants.filterType.DATE,
            relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
            placeholder: 'a...',
            condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
          }];
        }
        // template per le colonne custom
        if (obj.field == 'type') {
          col.cellTemplate = '<div class="ui-grid-cell-contents" style="height: 50px">{{grid.appScope.$parent.getReadableType(row.entity.model.type)}}</div>';
        }
        if (obj.field == 'status') {
          col.cellTemplate = '<div class="ui-grid-cell-contents" style="vertical-align:middle;">{{grid.appScope.$parent.getReadableStatus(row.entity.model.status)}}</div>';
        }
        if (obj.field == 'odl_id') {
          col.cellTemplate = '<div class="ui-grid-cell-contents" style="vertical-align:middle;">{{row.entity.model.odl_id.code}} -  {{row.entity.model.odl_id.description}}</div>';
        }
        // add
        array.push(col);
      }
    });
    // aggiungo una colonna per la commessa
    array.push({
      displayName: 'Commessa',
      field: 'commission',
      visible: false,
      cellTemplate: '<div class="ui-grid-cell-contents">{{grid.appScope.$parent.getCommission(row)}}</div>',
      filters: [{
        type: 'text',
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }],
      enableFiltering: true
    });
    return array;
  }
  $scope.getReadableType = function (typeCode) {
    //FIXME: sarebbe meglio prendere la titleMap da schema form
    var titleMap = [{
      "name": "Cliente",
      "value": "customer"
    }, {
      "name": "Fornitore",
      "value": "supplier"
    },
    //Vecchia indicizzazione
    {
      "name": "Cliente",
      "value": "cliente"
    }, {
      "name": "Fornitore",
      "value": "fornitore"
    }];
    for (var i in titleMap) {
      if (titleMap[i].value == typeCode) {
        return titleMap[i].name;
      }
    }
    return typeCode;
  };
  $scope.getReadableStatus = function (status) {
    //FIXME: sarebbe meglio prendere la titleMap da schema form
    var titleMap = [{
      "name": "Pubblicato",
      "value": "published"
    }, {
      "name": "Approvato",
      "value": "approved"
    }, {
      "name": "Rifiutato",
      "value": "refused"
    }, {
      "name": "Sospeso",
      "value": "suspended"
    }, {
      "name": "Revisionato",
      "value": "revised"
    }];
    for (var i in titleMap) {
      if (titleMap[i].value == status) {
        return titleMap[i].name;
      }
    }
    return status;
  };

  /** INDIRIZZAMENTO */

  $scope.goToConsumptivePageList = function () {
    $location.path('/consumptive/' + $scope.type);
  };
  $scope.newConsumptive = function () {
    $location.path('/consumptive/' + $scope.type + '/new');
  };
  $scope.copy = function () {
    var payload = {
      consumptive: {
        rows: []
      }
    };
    payload.consumptive.rows = clearRowsToPromote($scope.data.rows);
    pipeConsumptive.pushConsumptiveRows(payload);
    $scope.newConsumptive();
  };

  /** FILTRAGGIO TESTATE CONSUNTIVI */

  $scope.$watchGroup(['findCross'], function (newValue, oldValue) {
    if (newValue != oldValue) {
      $scope.getConsumptiveList();
      $scope.viewGridOptions.columnDefs[$scope.viewGridOptions.columnDefs.length - 1].visible = !!$scope.findCross;
    }
  });
  $scope.getConsumptiveList = function () {
    var payload = {
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      sort_fields: $scope.params.sortFields,
      cross: $scope.findCross
    };
    return consumptiveOdlFactory.searchHeader(payload, $scope.params.filters).$promise.then(function (response) {
      $scope.consumptiveList.list = response.list || [];
      $scope.consumptiveList.totalResults = response.totalResults;
      $scope.params.sixApi.refreshList(response.list);
      return response;
    })["catch"](function (response) {
      // error
    });
  };
  $scope.refresh = function () {
    $scope.getConsumptiveList();
  };

  /** SCHEMA */

  function getSchema() {
    var pSchemaHeader = schemaFactory().byCode({
      id: 'consumptiveheader'
    }).$promise;
    var pSchemaRow;
    if ($scope.type == 'manager') {
      pSchemaRow = consumptiveOdlFactory.getCallCenterSchema().$promise;
    } else {
      pSchemaRow = consumptiveOdlFactory.getRowSchema().$promise;
    }
    return Promise.all([pSchemaHeader, pSchemaRow]).then(function (resp) {
      // resp[0] = header, resp[1] = row
      if (resp[0].model) {
        $scope.schemaHeader = resp[0];
      }
      if (resp[1].model) {
        $scope.schemaRow = resp[1];
        $scope.requiredField = buildRequiredField($scope.schemaRow.model.form);
        $scope.gridOptions.columnDefs = getColumnDefsGridFull();
        $scope.viewGridOptions.columnDefs = getColumnDefsListFull();
      }
    });
  }

  /** CARICAMENTO CONSUNTIVO */

  function getConsumptiveByUuid(uuid) {
    consumptiveOdlFactory.getHeader({
      uuid: uuid
    }).$promise.then(function (response) {
      if (response.result) {
        $scope.data.header = response.result;
        $scope.editable = $scope.type == 'manager' && !$scope.data.header.model.status;
        $scope.schemaHeader.model.schema.readOnly = !$scope.editable;
        $scope.readOnlyHeader = response.result;
        $scope.modelLoaded = true;
        readAttachments($scope.data.header.model.attachments);
        var rowFilter = {
          'header.UUID': sixFiltersLib.exact('header.UUID', $scope.data.header.UUID)
        };
        consumptiveOdlFactory.searchRows({
          page: 1,
          page_size: 10000
        }, rowFilter).$promise.then(function (response) {
          initCurrentIndexRow(response.list); // inizializz. contatore righe
          $scope.addDataToGrid(response.list); // carico le righe sulla grid
        })["catch"](function (response) {
          // error
        });
      }
    });
  }

  /** DELETE CONSUNTIVO */

  $scope["delete"] = function () {
    consumptiveOdlFactory.referenceCount({
      id: $scope.data.header.UUID
    }).$promise.then(function (response) {
      var deleteMessage = 'Eliminare il consuntivo "' + $scope.data.header.model.code + '"?';
      if (response.count != 0) {
        deleteMessage = 'Il consuntivo: "' + $scope.data.header.model.code + '" è in uso nel sistema.<br> Vuoi rimuoverlo comunque?';
      }
      dialogService.confirmDialog(deleteMessage, function () {
        consumptiveOdlFactory.removeHeader({
          uuid: $scope.data.header.UUID
        }).$promise.then(function (response) {
          if (response.result) {
            $scope.goToConsumptivePageList();
          }
        });
      });
    });
  };

  /** SALVATAGGIO */

  $scope.save = function () {
    if (checkIntegrity()) {
      // controllo quello che mi arriva
      consumptiveOdlFactory.saveHeader($scope.data.header).$promise.then(function (response) {
        if (response.version) {
          if (angular.isNumber(response.dataIn)) {
            response.dataIn = moment(response.dataIn).toISOString();
          }
          $scope.data.header = response;
          $scope.editable = $scope.type == 'manager' && !response.model.status;
          $scope.schemaHeader.model.schema = angular.extend({}, $scope.schemaHeader.model.schema, {
            readOnly: !$scope.editable
          });
          $scope.gridOptions.columnDefs = getColumnDefsGridFull();
          $scope.$broadcast("update_plafond");
          var payloadInsert = {
            header: $scope.data.header,
            rows: $scope.insertedList
          }; // save
          var payloadModify = {
            rows: $scope.modifiedList
          }; // update
          var payloadDelete = {
            rows: $scope.deletedList
          }; // delete

          var savePromise = consumptiveOdlFactory.saveRows(payloadInsert).$promise; // save
          var updatePromise = consumptiveOdlFactory.updateRows(payloadModify).$promise; // update
          var deletePromise = consumptiveOdlFactory.deleteRows(payloadDelete).$promise; // delete

          Promise.all([savePromise, updatePromise, deletePromise]).then(function (resp) {
            // resp[0] = save, resp[1] = update, resp[2] = delete
            if (resp[0].rows && resp[0].rows.length > 0) {
              $scope.insertedList = [];
              $scope.addDataToGrid(resp[0].rows);
            }
            if (resp[1].rows && resp[1].rows.length > 0) {
              $scope.modifiedList = [];
              $scope.addDataToGrid(resp[1].rows);
            }
            if (resp[2].rows) {
              $scope.deletedList = [];
            }
            toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
            if ($scope.isNew) {
              // ora ricarico la pagina per far funzionare la redirect, nel caso poi promuovessi il consuntivo
              $location.path('consumptive/' + $scope.type + '/' + response.UUID);
            }
          });
        }
      })["catch"](function (rejection) {
        toaster.pop('error', 'Errore salvataggio', rejection.data.message ? rejection.data.message : rejection.statusText);
      });
    }
  };

  /* UPDATE STATUS CONSUNTIVO DA CUSTOMER */
  function updateConsumptive(newStatus) {
    //
    $scope.readOnlyHeader.model.status = newStatus;
    consumptiveOdlFactory.saveHeader($scope.data.header).$promise.then(function (response) {
      if (response.version) {
        $scope.data.header.model.status = response.model.status;
        $scope.data.header.version = response.version; //aggiorno version
        $scope.readOnlyHeader.version = response.version;
      }
    });
    $route.reload();
  }
  $scope.refuseConsumptive = function () {
    updateConsumptive('refused');
  };
  $scope.approveConsumptive = function () {
    updateConsumptive('approved');
  };
  $scope.getReadableStatus = function (status) {
    switch (status) {
      case 'approved':
        return "Approvato";
      case 'refused':
        return "Rifiutato";
      default:
        return status;
    }
  };
  function loadData() {
    if ($routeParams.id != 'new') {
      $scope.isNew = false;
      getConsumptiveByUuid($routeParams.id);
    } else {
      $scope.isNew = true;
      getConsumptivePassed(); // controllo se ho dati nella pipe
      $scope.modelLoaded = true;
    }
  }

  /*************************************/
  // MAIN
  /*************************************/
  getSchema().then(function () {
    if ($routeParams.id) {
      $scope.type = $routeParams.type;
      loadData();
    }
  });

  /*************************************/
  // Funzioni gestione consuntivi
  /*************************************/

  function checkIntegrity() {
    var rowsWithErrors = false;
    var codeNotPresent = false;
    // controllo che tutte le righe siano corrette
    $scope.data.rows.map(function (r) {
      if (r.sixImportStatus != 'OK') {
        rowsWithErrors = true;
        toaster.pop('error', 'Errore inserimento', 'Riga consuntivo: [' + r.model['article'] + '] non conforme.');
      }
    });
    // righe con campi obbligatori mancanti
    var rowRequired = document.getElementsByClassName("requiredclass");
    if (rowRequired.length > 0) {
      rowsWithErrors = true;
      toaster.pop('error', 'Errore inserimento', 'Campi obbligatori mancanti tra le righe.');
    }
    // controllo che abbia il codice
    if (!$scope.data.header.model.code) {
      codeNotPresent = true;
      toaster.pop('error', 'Errore inserimento', 'Codice non presente.');
    }
    return !codeNotPresent && !rowsWithErrors;
  }

  // scarica i dati passati via pipe
  function getConsumptivePassed() {
    if (pipeConsumptive.list.length != 0) {
      var payload = pipeConsumptive.popConsumptiveRows(); // scarico il payload con il consuntivo

      if (payload.consumptive.header) {
        $scope.data.header.model = payload.consumptive.header.model;
        if (angular.isUndefined($scope.data.header.model.creation_date) || $scope.data.header.model.creation_date == null) {
          $scope.data.header.model.creation_date = new Date();
        }
      }
      if (payload.consumptive.rows) {
        initCurrentIndexRow(payload.consumptive.rows); // inizializz. contatore righe
        $scope.addDataToGrid(payload.consumptive.rows); // carico righe
      }
    }
  }

  /******************************************/
  // Gestione righe save/update/delete
  /******************************************/

  function isItemInArrayByCode(array, item) {
    var present = false;
    array.forEach(function (arrayItem) {
      if (arrayItem.model.code == item.model.code) {
        present = true;
      }
    });
    return present;
  }
  function deleteItemInArrayByCode(array, item) {
    var itemIndex = -1;
    array.forEach(function (itemCurrent, indexCurrent) {
      if (itemCurrent.model.code == item.model.code) {
        itemIndex = indexCurrent;
      }
    });
    array.splice(itemIndex, 1);
  }
  $scope.lookupCallback = function (item, rowEntity) {
    if (item.type == "um") {
      rowEntity.model["um_id"] = item;
    }
    afterCellEditCallback(rowEntity);
  };

  /*********************************************/
  // Vis. decimali + Calcolo totale
  /*********************************************/

  $scope.formatNumber = function (num) {
    return num ? num.toString().replace(/\./g, ',') : null;
  };
  $scope.formatPrice = function (num) {
    if (num) {
      num = Math.round(num * 100) / 100;
      num = parseFloat(num).toFixed(2);
    }
    return num ? num.replace(/\./g, ',') : null;
  };
  $scope.calculateTotalRow = function (row) {
    if (row && row.entity && row.entity.model) {
      // if total it's calculable
      if (row.entity.model['unit_price'] && row.entity.model['quantity']) {
        row.entity.model['unit_price'] = Math.round(row.entity.model['unit_price'] * 100) / 100; // formatting unit_price to double precision
        row.entity.model.total = Math.round(row.entity.model['unit_price'] * row.entity.model['quantity'] * 100) / 100; // formatting total to double precision
      } else {
        delete row.entity.model.total; // else delete total
      }
    }

    return $scope.formatPrice(row.entity.model.total); // return string to show
  };

  $scope.calculateTotalGrid = function (total) {
    if ($scope.data.header.model && $scope.data.header.model.auto_refresh_total) {
      $scope.data.header.model.total = Math.round(total * 100) / 100;
    }
    return $scope.formatPrice(total); // return string to show
  };

  $scope.$watch('data.header.model.auto_refresh_total', function (newValue, oldValue) {
    if (newValue != oldValue && newValue == true) {
      // posizione della colonna totale
      if ($scope.rowPositionTotal && $scope.gridApi.grid.columns && $scope.gridApi.grid.columns.length > 0) {
        var total = $scope.gridApi.grid.columns[$scope.rowPositionTotal].getAggregationValue();
        $scope.data.header.model.total = Math.round(total * 100) / 100;
      }
    }
  });

  /*************************************/
  // Allegati
  /*************************************/

  $scope.attachments = [];
  function readAttachments(modelList) {
    if (modelList && modelList.length > 0) {
      $scope.attachments.splice(0, $scope.attachments.length);
      for (var i = 0; i < modelList.length; i++) {
        $scope.attachments.push(modelList[i]);
      }
    }
  }
  function writeAttachments(modelList) {
    modelList.splice(0, modelList.length);
    for (var i = 0; i < $scope.attachments.length; i++) {
      modelList.push($scope.attachments[i]);
    }
  }
  $scope.updAttachments = function () {
    if (angular.isUndefined($scope.data.header.model.attachments) || !angular.isArray($scope.data.header.model.attachments)) {
      $scope.data.header.model.attachments = [];
    }
    writeAttachments($scope.data.header.model.attachments);
    consumptiveOdlFactory.saveHeader($scope.data.header).$promise.then(function (response) {
      if (response.version) {
        $scope.data.header.version = response.version;
        $log.debug('saving id: ' + $scope.data.header.version);
      }
    })["catch"](function (rejection) {
      toaster.pop('error', 'Errore salvataggio', rejection.data.message ? rejection.data.message : rejection.statusText);
    });
  };

  /*************************************/
  // Export xlsx
  /*************************************/

  $scope.exportXLSX = function () {
    var columns = [];
    angular.forEach($scope.schemaRow.model.schema.properties, function (property, key) {
      if (key != 'code' && key != 'description') {
        columns.push({
          key: 'model.' + key,
          name: $scope.typeExport == 'exportToImport' ? key : property.title
        });
      }
    });
    var rows = $scope.gridApi.grid.rows.map(function (r) {
      return r.entity;
    });
    sixExportLib.exportXLSX(columns, rows, 'consuntivo_' + $scope.data.header.model.code, $scope.typeExport !== 'exportToImport');
  };

  /*************************************/
  // Template xlsx
  /*************************************/

  function buildDataType(prop) {
    if (prop.type === 'string' && prop.format === 'date') {
      return 'yyyy-MM-dd';
    } else if (prop.type === 'string' && prop.format === 'lookup') {
      return 'ref. code to resolve';
    } else if (prop.type === 'integer') {
      return 1;
    } else if (prop.type === 'number') {
      return 1.234;
    } else if (prop.type === 'object') {
      var obj = {};
      for (var key in prop.properties) {
        obj[key] = buildDataType(prop.properties[key]);
      }
      return JSON.stringify(obj);
    }
    return 'text';
  }
  function schemaRowsDefinitionToSheet() {
    var ws = {};
    var range = {
      s: {
        c: 10000000,
        r: 10000000
      },
      e: {
        c: 0,
        r: 0
      }
    };
    var data = [[], []];
    for (var key in $scope.schemaRow.model.schema.properties) {
      if (key != 'code' && key != 'description') {
        data[0].push(key); // Intestazione di colonna
        var prop = $scope.schemaRow.model.schema.properties[key]; // Riga di esempio
        var example = 'text';
        if (prop.type === 'array') {
          if (!prop.items) {
            example = '[item1, item2]';
          } else {
            example = '[' + buildDataType(prop.items) + ',' + buildDataType(prop.items) + ']';
          }
        } else {
          example = buildDataType(prop);
        }
        data[1].push(example);
      }
    }
    for (var R = 0; R != data.length; ++R) {
      for (var C = 0; C != data[R].length; ++C) {
        if (range.s.r > R) range.s.r = R;
        if (range.s.c > C) range.s.c = C;
        if (range.e.r < R) range.e.r = R;
        if (range.e.c < C) range.e.c = C;
        var cell = {
          v: data[R][C]
        };
        if (cell.v == null) continue;
        var cell_ref = XLSX.utils.encode_cell({
          c: C,
          r: R
        });
        if (typeof cell.v === 'number') cell.t = 'n';else if (typeof cell.v === 'boolean') cell.t = 'b';else if (cell.v instanceof Date) {
          cell.t = 'n';
          cell.z = XLSX.SSF._table[14];
          cell.v = dateNum(cell.v);
        } else cell.t = 's';
        ws[cell_ref] = cell;
      }
    }
    if (range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
    return ws;
  }
  function Workbook() {
    if (!(this instanceof Workbook)) return new Workbook();
    this.SheetNames = [];
    this.Sheets = {};
  }
  function dateNum(v, date1904) {
    if (date1904) v += 1462;
    var epoch = Date.parse(v);
    return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
  }
  $scope.schemaRowsDefinitionToXlsx = function () {
    /* original data */
    var ws_name = 'consumptive';
    var wb = new Workbook();
    var ws = schemaRowsDefinitionToSheet();
    /* add worksheet to workbook */
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    var wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      bookSST: false,
      type: 'binary'
    });
    saveAs(new Blob([s2ab(wbout)], {
      type: "application/octet-stream"
    }), "consumptive_rows.xlsx");
  };
  function s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
  }

  /*************************************
  // Stampa PDF (E' possibile specializzare i report per commessa inserendo il suffisso '_[codice_commessa]' (es. odl_1600000))
  *************************************/

  $scope.printConsumptive = function (extension) {
    var report = 'consumptiveodl';
    var response = jasperReport(report + '_' + $scope.currentCommission.code, extension); // provo il report specifico della commessa
    response.success(function (data, status) {
      //parametri disponibili, ma non utilizzati: headers, config
      if (status == 204) {
        // se è vuoto, provo il report di default
        $log.warn('jasper report error with params report=' + report + '_' + $scope.currentCommission.code + ' and extension=' + extension + ': trying with default report');
        jasperReport(report, extension).success(function (data, status) {
          //parametri disponibili, ma non utilizzati: headers, config
          if (status != 200) {
            toaster.pop('error', "Errore", 'Errore generazione report');
          }
        });
      }
    }).error(function () {
      //parametri disponibili, ma non utilizzati: data, status, headers, config
      toaster.pop('error', "Errore", 'Errore generazione report');
    });
  };
  function jasperReport(report, extension) {
    var REPORT_URL = 'reports/EMMA/Asset/';
    report = report || 'consumptiveodl';
    extension = extension || 'pdf';
    var query = '&uuid=' + $scope.data.header.UUID + '&commission=' + $scope.currentCommission.code;
    var reportNameToSave = 'consumptiveodl_' + $scope.data.header.model.code + '.' + extension;
    var reportPath = REPORT_URL + report + '.' + extension;
    var payload = {
      path: reportPath,
      query: query
    };
    var config = {
      responseType: 'arraybuffer'
    };
    var promise = $http.post(APP_URL + '/rest/report/generate', payload, config);
    promise.success(function (data, status) {
      //parametri disponibili, ma non utilizzati: headers, config
      if (status == 200 && data) {
        var options;
        if (extension == 'pdf') {
          options = {
            type: 'application/pdf'
          };
        } else if (extension == 'xls') {
          options = {
            type: 'application/vnd.ms-excel;'
          };
        }
        SaveAs.download(data, reportNameToSave, options);
      }
    });
    return promise;
  }

  /*************************************/
  // Utility
  /*************************************/

  $scope.setTypeExport = function (value) {
    $scope.typeExport = value;
  };
  $scope.setFindCross = function (value) {
    $scope.findCross = value;
  };
  $scope.getCommission = function (row) {
    var str = '';
    var sep = '';
    if (row.entity.commission) {
      [].concat(row.entity.commission).forEach(function (c) {
        str += sep + c;
        sep = ',';
      });
    }
    return str;
  };

  // pulisce le righe da promuovere/clonare
  function clearRowsToPromote(array) {
    var clearRows = [];
    array.forEach(function (row) {
      var clearSingleRow = {
        model: row.model,
        sixImportStatus: 'OK'
      };
      clearRows.push(clearSingleRow);
    });
    return clearRows;
  }

  // init contatore per il code delle righe
  function initCurrentIndexRow(array) {
    array.forEach(function (row) {
      if (row.model.code) {
        var indexFullStr = row.model.code; // es. "index_row_6"
        var indexNumStr = indexFullStr.replace("index_row_", ""); // es. "6"
        if (parseInt(indexNumStr) >= $scope.currentIndexRow) {
          $scope.currentIndexRow = parseInt(indexNumStr) + 1; // es. 7
        }
      }
    });
  }

  $scope.rowIsNew = function (row) {
    var isNew = false;
    if (row.entity.sixImportStatus == 'NEW') {
      isNew = true;
    }
    return isNew;
  };
  $scope.rowInError = function (row) {
    var inError = false;
    if (row.entity.sixImportStatus != 'OK' && row.entity.sixImportStatus != 'NEW') {
      inError = true;
    }
    return inError;
  };
  $scope.fieldIsRequired = function (row, field, required) {
    var isRequired = false;
    if (row && required == true) {
      if (row.entity.model[field] == null || row.entity.model[field] == undefined) {
        isRequired = true;
      }
    }
    return isRequired;
  };
  function buildRequiredField(form) {
    var map = {};
    for (var f in form) {
      for (var i in form[f].items) {
        for (var t in form[f].items[i].tabs) {
          for (var item in form[f].items[i].tabs[t].items) {
            map[form[f].items[i].tabs[t].items[item].key[0]] = form[f].items[i].tabs[t].items[item];
          }
        }
      }
    }
    return map;
  }
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:ConsumptiveOdlRowConfiguratorCtrl
 * @description
 * # ConsumptiveOdlRowConfiguratorCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/consumptiveconfigurator/row', {
    templateUrl: 'plan/consumptiveodl/consumptiveodlrowconfigurator_list.html',
    controller: 'ConsumptiveOdlRowConfiguratorCtrl'
  }).when('/consumptiveconfigurator/row/page/:number', {
    templateUrl: 'plan/consumptiveodl/consumptiveodlrowconfigurator_list.html',
    controller: 'ConsumptiveOdlRowConfiguratorCtrl'
  }).when('/consumptiveconfigurator/row/:id', {
    templateUrl: 'plan/consumptiveodl/consumptiveodlrowconfigurator_detail.html',
    controller: 'ConsumptiveOdlRowConfiguratorCtrl'
  });
}]).controller('ConsumptiveOdlRowConfiguratorCtrl', ["$scope", "$routeParams", "$location", "$log", "$window", "consumptiveOdlFactory", "schemaFactory", "commissionFactory", "toaster", "authFactory", "dialogService", function ($scope, $routeParams, $location, $log, $window, consumptiveOdlFactory, schemaFactory, commissionFactory, toaster, authFactory, dialogService) {
  var PATH_CONSUMPTIVE_ROW_CONFIG = 'consumptiveconfigurator/row';
  $scope.bool = {
    /* contenitore per le variabili booleane */
    isNew: false,
    isCross: false,
    confModel: false,
    isCallCenter: false
  };
  $scope.commissionDependent = true;
  $scope.commissionCode = '';
  $scope.commissions = [];
  $scope.commissionsSelected = {
    codes: []
  };
  $scope.selected = {}; /* contenitore */

  $scope.form = {};
  $scope.model = {};
  $scope.schema = {};
  $scope.property = {};
  $scope.checked = {};
  $scope.uiselectMap = {};
  $scope.itemTypeMap = {};
  $scope.pageSize = 10;
  $scope.status = {
    isFirstOpen: true,
    isFirstDisabled: false
  };
  $scope.modeltypeList = schemaFactory().lookupList({
    page_size: 1000
  });
  $scope.addProperty = function () {
    /* aggiungo una proprietà allo Schema e al Form */
    if (angular.isDefined($scope.property.key)) {
      var p = {
        title: angular.copy($scope.property.title),
        type: angular.copy($scope.property.type),
        check: false
      };
      if ($scope.property.format) {
        p.format = angular.copy($scope.property.format);
      }
      if (p.type == 'date') {
        p.type = 'string';
        p.format = 'date';
      }
      if (p.type == 'array') {
        p.items = {
          type: angular.copy($scope.property.items_type)
        }; // default
        if ($scope.property.items_type === 'date') {
          // se è una data è diverso...
          p.items = {
            type: 'string',
            format: 'date'
          };
        }
      }
      $scope.selected.model.schema.properties[$scope.property.key] = p;
      var item = {
        title: angular.copy($scope.property.title),
        type: null,
        key: [angular.copy($scope.property.key)]
      };
      if (p.format) {
        if (p.format == 'date') {
          item.type = 'datepicker';
        } else if (p.format == 'enum') {
          item.type = 'uiselect';
          item.titleMap = [];
        } else if (p.format == 'lookup') {
          item.type = 'sixlookup';
        }
      } else if (p.type == 'string') {
        item.type = 'text';
      } else if (p.type == 'number' || p.type == 'integer') {
        item.type = 'number';
      } else if (p.type == 'boolean') {
        item.type = 'checkbox';
      } else if (p.type == 'array') {
        item.type = 'uiselectmultiple';
        item.titleMap = [];
      } else {
        // default
        item.type = angular.copy(p.type);
      }
      for (var i in $scope.selected.model.form[0].items) {
        if ($scope.selected.model.form[0].items[i].tabs) {
          $scope.selected.model.form[0].items[i].tabs[0].items.push(item);
        }
      }
    }
    $scope.getUiselectMap();
    $scope.clearNewCol();
    $scope.updateScope();
  };
  $scope.updateScope = function () {
    $scope.schema = angular.fromJson(angular.copy($scope.selected.model.schema));
    $scope.form = [angular.fromJson(angular.copy($scope.selected.model.form[0]))];
    $scope.columnDefs = angular.fromJson(angular.copy($scope.selected.model.columnDefs));
    $scope.formChanged();
  };
  $scope.clearNewCol = function () {
    /* pulisco la riga di inserimento di nuove proprietà */
    $scope.property.key = '';
    $scope.property.title = '';
    delete $scope.property.type;
    delete $scope.property.format;
  };
  $scope.getItemType = function (key) {
    if (valueSchema.type != 'array') {
      return valueSchema.type;
    } else {
      return valueSchema.items.type;
    }
  };
  $scope.addItemOnArray = function (key, newItem) {
    if (newItem != undefined && newItem != null) {
      newItem.name = newItem.name.toString();
      if ($scope.itemTypeMap[key] == 'integer') {
        if (parseInt(newItem.name)) {
          newItem.value = parseInt(newItem.name);
          newItem.name = newItem.value.toString(); /* nel caso ci dovesse essere un cast, torno a sovrascrivere il name */
        } else {
          return;
        }
      } else if ($scope.itemTypeMap[key] == 'number') {
        if (parseFloat(newItem.name)) {
          newItem.value = parseFloat(newItem.name);
        } else {
          return;
        }
      } else {
        newItem.value = newItem.name.toString().replace(/\s/g, '_').toLowerCase();
      }
      for (var i in $scope.selected.model.form[0].items) {
        if ($scope.selected.model.form[0].items[i].tabs) {
          $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
            if (key == item.key[0]) {
              item.titleMap.push(newItem);
            }
          });
        }
      }
      this.newItem = null;
      $scope.updateScope();
    }
  };
  $scope.deleteItemOnArray = function (key, obj) {
    for (var i in $scope.selected.model.form[0].items) {
      if ($scope.selected.model.form[0].items[i].tabs) {
        $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
          if (key == item.key[0]) {
            for (var j = item.titleMap.length; j--;) {
              if (item.titleMap[j].value == obj.value) {
                item.titleMap.splice(j, 1);
              }
            }
          }
        });
      }
    }
    this.newItem = null;
    $scope.updateScope();
  };
  $scope.deleteProperty = function (keyToDelete) {
    delete $scope.selected.model.schema.properties[keyToDelete];
    for (var i = $scope.selected.model.columnDefs.length; i--;) {
      if ($scope.selected.model.columnDefs[i].field == keyToDelete) $scope.selected.model.columnDefs.splice(i, 1);
    }
    // ...elimino sempre dalla form
    for (var i = $scope.selected.model.form[0].items.length; i--;) {
      if ($scope.selected.model.form[0].items[i].key && $scope.selected.model.form[0].items[i].key[0] == keyToDelete) {
        $scope.selected.model.form[0].items.splice(i, 1);
      }
      // Scorro anche i tabs
      if ($scope.selected.model.form[0].items[i].tabs) {
        for (var j = $scope.selected.model.form[0].items[i].tabs.length; j--;) {
          for (var k = $scope.selected.model.form[0].items[i].tabs[j].items.length; k--;) {
            if ($scope.selected.model.form[0].items[i].tabs[j].items[k].key[0] == keyToDelete) {
              $scope.selected.model.form[0].items[i].tabs[j].items.splice(k, 1);
            }
          }
        }
      }
    }
    $scope.updateScope();
  };
  $scope.formChanged = function () {
    $scope.aceModel = JSON.stringify(angular.copy($scope.selected), null, '\t');
  };
  $scope.refreshLookup = function (key, entity_id) {
    $scope.chargeAceModel();
    for (var i = $scope.selected.model.form[0].items.length; i--;) {
      if ($scope.selected.model.form[0].items[i].key && $scope.selected.model.form[0].items[i].key[0] == key) {
        $scope.selected.model.form[0].items[i].entity_id = angular.copy(entity_id);
      }
      // Scorro anche i tabs
      if ($scope.selected.model.form[0].items[i].tabs) {
        for (var j = $scope.selected.model.form[0].items[i].tabs.length; j--;) {
          for (var k = $scope.selected.model.form[0].items[i].tabs[j].items.length; k--;) {
            if ($scope.selected.model.form[0].items[i].tabs[j].items[k].key[0] == key) $scope.selected.model.form[0].items[i].tabs[j].items[k].entity_id = angular.copy(entity_id);
          }
        }
      }
    }
    $scope.selected.model.schema.properties[key].entity_id = angular.copy(entity_id);
    $scope.updateScope();
  };
  $scope.refreshBasePath = function (key, basePath) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].basePath = angular.copy(basePath);
    $scope.updateScope();
  };
  $scope.refreshWar = function (key, war) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].war = angular.copy(war);
    $scope.updateScope();
  };
  $scope.refreshFiltered = function (key, filtered) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].filtered = angular.copy(filtered);
    $scope.updateScope();
  };
  $scope.refreshFilterSourceField = function (key, filterSourceField) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].filterSourceField = angular.copy(filterSourceField);
    $scope.updateScope();
  };
  $scope.refreshFilterDestField = function (key, filterDestField) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].filterDestField = angular.copy(filterDestField);
    $scope.updateScope();
  };
  $scope.refreshLookupOption = function (key, option, value) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key][option] = angular.copy(value);
    $scope.updateScope();
  };
  $scope.refreshTitleForm = function (title) {
    $scope.chargeAceModel();
    $scope.selected.model.form[0].title = angular.copy(title);
    $scope.updateScope();
  };
  $scope.chargeAceModel = function () {
    var defaultData = angular.fromJson(angular.copy($scope.aceModel));
    if (defaultData) {
      $scope.selected = defaultData;
      $scope.schema = angular.fromJson(defaultData.model.schema);
      $scope.form = angular.fromJson(defaultData.model.form);
      $scope.columnDefs = angular.fromJson(defaultData.model.columnDefs);
    }
  };
  $scope.changeColumnDefs = function (key, value) {
    var item = {
      name: value.title,
      field: key
    };
    var map = new Map();
    angular.forEach($scope.selected.model.columnDefs, function (v) {
      map[v.field] = angular.copy(v);
    });
    if (value.check) {
      map[item.field] = angular.copy(item);
      if (value.width == '' || value.width == null) {
        delete $scope.selected.model.schema.properties[key].width;
      }
    } else {
      delete map[item.field];
      delete $scope.selected.model.schema.properties[key].width;
      $scope.selected.model.schema.properties[key].enableFiltering = false;
      $scope.selected.model.schema.properties[key].enableSorting = false;
    }
    $scope.selected.model.columnDefs = [];
    for (var it in map) {
      var app = {
        name: map[it].name,
        field: map[it].field
      };
      $scope.selected.model.columnDefs.push(app);
    }
    $scope.updateScope();
  };
  $scope.aceLoaded = function () {
    $scope.columnDefault = ['code', 'description', 'article', 'cost_center', 'quantity', 'total', 'type', 'type_row', 'um_id', 'unit_price'];
    var defaultModel = {
      model: {
        schema: {
          type: "object",
          title: "",
          properties: {
            code: {
              title: "Codice",
              type: "string",
              check: true
            },
            description: {
              title: "Descrizione",
              type: "string",
              check: true
            },
            article: {
              title: "Articolo",
              type: "string",
              check: false
            },
            cost_center: {
              title: "Centro di costo",
              type: "string",
              check: false
            },
            quantity: {
              title: "Quantità",
              type: "number",
              check: false
            },
            total: {
              title: "Totale",
              type: "number",
              check: false
            },
            type: {
              title: "Tipologia",
              type: "string",
              check: false
            },
            type_row: {
              title: "Tipo riga",
              type: "string",
              check: false
            },
            um_id: {
              title: "Unità di misura",
              type: "string",
              format: "lookup",
              entity_id: "um",
              war: "six-data-set",
              check: false
            },
            unit_price: {
              title: "Prezzo unitario",
              type: "number",
              check: false
            }
          },
          required: ["code", "description"]
        },
        form: [{
          type: "fieldset",
          items: [{
            type: "tabs",
            tabs: [{
              title: "Dati",
              items: [{
                key: ["code"],
                title: "Codice",
                required: true,
                type: "text"
              }, {
                key: ["description"],
                title: "Descrizione",
                required: true,
                type: "textarea",
                placeholder: "Testo di descrizione..."
              }, {
                key: ["article"],
                title: "Articolo",
                required: false,
                type: "text"
              }, {
                key: ["cost_center"],
                title: "Centro di costo",
                required: false,
                type: "text"
              }, {
                key: ["type"],
                title: "Tipologia",
                required: false,
                type: "text"
              }, {
                key: ["type_row"],
                title: "Tipo riga",
                required: false,
                type: "text"
              }, {
                key: ["quantity"],
                title: "Quantità",
                required: false,
                type: "number"
              }, {
                key: ["total"],
                title: "Totale",
                required: false,
                type: "number"
              }, {
                title: "Unità di misura",
                type: "sixlookup",
                entity_id: "um",
                required: false,
                key: ["um_id"]
              }, {
                key: ["unit_price"],
                title: "Prezzo unitario",
                required: false,
                type: "number"
              }]
            }]
          }]
        }],
        columnDefs: [{
          "field": "code",
          "name": "Codice"
        }, {
          "field": "description",
          "name": "Descrizione"
        }]
      }
    };
    $scope.aceModel = JSON.stringify(defaultModel, null, '\t');
    $scope.chargeAceModel();
    $scope.title = angular.copy($scope.selected.model.form[0].title);
  };
  $scope.getUiselectMap = function () {
    $scope.uiselectMap = {};
    $scope.itemTypeMap = {};
    for (var i in $scope.selected.model.form[0].items) {
      if ($scope.selected.model.form[0].items[i].tabs) {
        $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
          $scope.itemTypeMap[item.key[0]] = $scope.selected.model.schema.properties[item.key[0]].type;
          if ($scope.selected.model.schema.properties[item.key[0]].type == 'array') {
            $scope.itemTypeMap[item.key[0]] = $scope.selected.model.schema.properties[item.key[0]].items.type;
          }
          if (item.type == 'uiselect' || item.type == 'uiselectmultiple') {
            var blankObject = {
              name: '',
              value: ''
            };
            $scope.uiselectMap[item.key[0]] = addSelectedValue(item.titleMap, blankObject); /* aggiunto un elemento vuoto all'array per consentire il deselezionamento */
          }
        });
      }
    }
  };

  $scope.toggleEnumDefault = function (key, objValue) {
    var property = $scope.selected.model.schema.properties[key];
    if (typeof property["default"] == "undefined" || property["default"].indexOf(objValue) == -1) {
      property["default"] = [objValue];
    } else {
      property["default"] = undefined;
    }
    this.newItem = null;
    $scope.updateScope();
  };
  function addSelectedValue(array, obj) {
    var blankValuePresent = false;
    array.forEach(function (item) {
      if (item.value == obj.value && item.name == obj.name) {
        blankValuePresent = true;
      }
    });
    if (blankValuePresent == false) {
      array.push(obj);
    }
    return array;
  }
  $scope.isInheritable = function (type) {
    return type == 'number' || type == 'integer' || type == 'string' || type == 'boolean' || type == 'lookup';
  };
  $scope.disableDeleteColumn = function (key) {
    var columnsWithoutDelete = ['code', 'description', 'unit_price', 'um_id', 'total', 'quantity', 'type_row', 'type', 'cost_center', 'article'];
    return columnsWithoutDelete.indexOf(key) > -1;
  };
  $scope.disableInTableColumn = function (key) {
    var columns = ['code', 'description'];
    return columns.indexOf(key) > -1;
  };

  /**********************/
  /***** FIX SCHEMA *****/
  /**********************/

  $scope.fixSchemaFormModel = function () {
    for (var i in $scope.selected.model.form[0].items) {
      if ($scope.selected.model.form[0].items[i].tabs) {
        $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
          if (item.type == 'uiselect') {
            $scope.selected.model.schema.properties[item.key[0]].format = 'enum';
          }
          if (item.type == 'uiselectmultiple') {
            $scope.selected.model.schema.properties[item.key[0]].type = 'array';
          }
        });
      }
    }
  };

  /****************/
  /***** FORM *****/
  /****************/

  $scope.newFieldForm = {};
  $scope.newTab = {
    title: "",
    items: []
  };
  $scope.addTab = function (container) {
    if (!container.tabs) {
      container.tabs = [];
    }
    if (container.type !== 'tabs') {
      container.type = 'tabs';
    }
    var toAdd = angular.copy($scope.newTab);
    $log.log(container);
    container.tabs.push(toAdd);
    $log.log(container);
    $scope.updateScope();
    $scope.newTab = {
      title: "",
      items: []
    };
  };
  $scope.addFieldToTab = function (tab) {
    if (!tab.items) {
      tab.items = [];
    }
    var toAdd = angular.copy($scope.newFieldForm);
    if ($scope.newFieldForm.type === '' || $scope.newFieldForm.type === 'formula' || $scope.newFieldForm.type === 'inherited') {
      delete toAdd.type;
    }
    /* key è da cambiare in un array */
    toAdd.key = [];
    toAdd.key.push($scope.newFieldForm.key);
    /* se è una lookup, e se ha definito il campo entity_id nello schema, ci attacco anche l'entity_id */
    if (toAdd.type == 'sixlookup' && $scope.schema.properties[$scope.newFieldForm.key]['entity_id']) {
      toAdd['entity_id'] = $scope.schema.properties[$scope.newFieldForm.key]['entity_id'];
    }
    tab.items.push(toAdd);
    $log.log(tab);
    $scope.updateScope();
    $scope.newFieldForm = {
      key: [],
      title: "",
      required: false,
      type: "text"
    };
  };
  $scope.removeTabOrField = function (key, container) {
    container.splice(key, 1);
    $log.log(container);
    $scope.updateScope();
  };
  $scope.swapUp = function (key, collection) {
    if (key > 0) {
      var tmp = collection[key];
      collection[key] = collection[key - 1];
      collection[key - 1] = tmp;
    }
    $scope.updateScope();
  };
  $scope.swapDown = function (key, collection) {
    if (key < collection.length - 1) {
      var tmp = collection[key];
      collection[key] = collection[key + 1];
      collection[key + 1] = tmp;
    }
    $scope.updateScope();
  };
  $scope.updateField = function (field) {
    if (field.type === '') {
      delete field.type;
    }
    $scope.updateScope();
  };
  $scope.$watchGroup(['commissionDependent', 'history'], function () {
    if ($scope.commissionDependent === true) {
      $scope.history = true;
    }
    if ($scope.selected) {
      if ($scope.selected.model) {
        $scope.selected.model.history = $scope.history;
        $scope.selected.model.commissionDependent = $scope.commissionDependent;
        $scope.updateScope();
      }
    }
  });
  $scope.pageChanged = function () {
    $location.path('/consumptiveconfigurator/row/page/' + $scope.consumptiveRowConfiguratorList.currentPage, false);
    $scope.consumptiveRowConfiguratorList = consumptiveOdlFactory.getRowSchemaList({
      query: $scope.queryParam,
      page: $scope.consumptiveRowConfiguratorList.currentPage
    });
  };
  $scope.printCommission = function (commission_array) {
    var result = '';
    var pos = 0;
    if (commission_array != null) {
      angular.forEach(commission_array, function (value) {
        if (pos == 0) {
          result = value;
        } else {
          result = value + ', ' + result;
        }
        pos++;
      });
    }
    return result;
  };
  $scope.updateCode = function () {
    if ($scope.bool.isCross == true) {
      $scope.commissionCode = 'default';
      $scope.commissionsSelected.codes = [];
    } else {
      $scope.commissionCode = '';
    }
  };
  $scope.setCallCenter = function () {
    /* impostare le varaibili per salvare la configurazione per il call center */
    if ($scope.bool.isCallCenter == true) {
      $scope.commissionCode = 'callcenter';
      $scope.commissionsSelected.codes = [];
    } else {
      $scope.commissionCode = '';
    }
  };
  $scope.setConfModel = function () {
    $scope.bool.confModel = true;
    $scope.bool.isCross = false;
    $scope.bool.isCallCenter = false;
    delete $scope.selected.version;
    $scope.commissionsSelected.codes = [];
    $scope.commissionCode = '';
  };
  $scope.newConsumptiveRowConfiguration = function () {
    $location.path(PATH_CONSUMPTIVE_ROW_CONFIG + '/new');
  };
  $scope.refresh = function () {
    $location.path(PATH_CONSUMPTIVE_ROW_CONFIG);
  };
  $scope.back = function () {
    $location.path(PATH_CONSUMPTIVE_ROW_CONFIG);
  };
  $scope["delete"] = function () {
    dialogService.confirmDialog('Eliminare la configurazione?', function () {
      consumptiveOdlFactory.deleteRowSchema({
        id: $scope.selected.version
      }).$promise.then(function () {
        $scope.back();
      });
    });
  };
  $scope.setCommissionSelected = function () {
    angular.forEach($scope.selected.model.commission, function (value_cm_string) {
      var index = null;
      angular.forEach($scope.commissions, function (value_cm_obj) {
        if (value_cm_string == value_cm_obj.code) {
          index = $scope.commissions.indexOf(value_cm_obj);
          $scope.commissionsSelected.codes.push(value_cm_obj);
          $scope.commissions.splice(index, 1);
        }
      });
    });
  };
  $scope.setBooleanFlag = function () {
    if ($scope.selected.model) {
      if ($scope.selected.model.code == 'default') {
        $scope.bool.isCross = true;
      } else if ($scope.selected.model.code == 'callcenter') {
        $scope.bool.isCallCenter = true;
      }
    }
  };
  $scope.getConsumptiveRowConfigurationById = function (UUID) {
    consumptiveOdlFactory.getRowSchemaByUUID({
      uuid: UUID
    }).$promise.then(function (response) {
      if (response.model) {
        $scope.selected = angular.copy(response);
        $scope.commissionCode = $scope.selected.model.code;
        $scope.setCommissionSelected();
        $scope.setBooleanFlag();
        $scope.updateScope();
      }
    });
  };
  $scope.getConsumptiveRowConfigurationList = function () {
    consumptiveOdlFactory.getRowSchemaList({
      query: $scope.queryParam,
      pageSize: $scope.pageSize
    }).$promise.then(function (response) {
      $scope.consumptiveRowConfiguratorList = response;
    });
  };
  $scope.getCommission = function () {
    commissionFactory().getCommissionsList().$promise.then(function (response) {
      if (response.list) {
        $scope.commissions = response.list;
      }
    });
  };
  $scope.create = function () {
    consumptiveOdlFactory.createRowSchema($scope.aceModel).$promise.then(function () {
      toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
      $scope.back();
    })["catch"](function (response) {
      toaster.pop('error', 'Errore salvataggio', 'Si è verificato un errore durante il salvataggio');
    });
  };
  $scope.update = function () {
    consumptiveOdlFactory.updateRowSchema({
      id: $scope.selected.version
    }, $scope.aceModel).$promise.then(function () {
      toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
      $scope.back();
    })["catch"](function (rejection) {
      toaster.pop('error', 'Errore salvataggio', rejection.data.message ? rejection.data.message : rejection.statusText);
    });
  };
  function checkIntegrityModel() {
    // controllo se mancano alcuni dei campi obbligatori
    var integrityModel = true;
    angular.forEach($scope.columnDefault, function (col) {
      if (!$scope.selected.model.schema.properties[col]) {
        integrityModel = false;
      }
    });
    return integrityModel;
  }
  $scope.saveForm = function () {
    $scope.chargeAceModel();
    $scope.selected.model.code = $scope.commissionCode;
    if (checkIntegrityModel()) {
      if ($scope.bool.isCross || $scope.bool.isCallCenter) {
        /* se è cross non serve riempire il vettore delle commesse */
        $scope.selected.model.commission = null;
        $scope.selected.model.commissionDependent = false;
        $scope.formChanged(); /* aggiorno l'aceModel */
        if ($scope.selected.version) {
          $scope.update();
        } else {
          $scope.create();
        }
      } else {
        /* riempio il vettore delle commesse */
        $scope.selected.model.commission = [];
        angular.forEach($scope.commissionsSelected.codes, function (obj) {
          $scope.selected.model.commission.push(obj.code);
        });
        $scope.formChanged(); /* aggiorno l'aceModel */
        if ($scope.bool.confModel) {
          /* create obbligatoria */
          $scope.create();
        } else {
          if ($scope.selected.version) {
            $scope.update();
          } else {
            $scope.create();
          }
        }
      }
    } else {
      toaster.pop('error', 'Errore', 'Campi obbligatori mancanti nello schema.');
    }
  };
  if ($routeParams.id) {
    if ($routeParams.id !== 'new') {
      $scope.bool.isNew = false;
      commissionFactory().getCommissionsList().$promise.then(function (response) {
        if (response.list.length) {
          $scope.commissions = response.list;
        }
        $scope.getConsumptiveRowConfigurationById($routeParams.id);
      });
    } else {
      $scope.bool.isNew = true;
      $scope.getCommission();
    }
  } else {
    $scope.getConsumptiveRowConfigurationList();
  }

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'odl/schema';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.dashboardOdlColumnService
 * @description
 * Utilities per gestire le colonne della dashboard odl.
 */
angular.module('emma.plan').service('dashboardOdlColumnService', ['odlFactory', '$q', 'authFactory', 'localStorageService', '$log', function (odlFactory, $q, authFactory, localStorageService, $log) {
  //Ogni colonna va configurata con un oggetto completo per ui-grid, per brevità è possibile usare la proprietà "type"
  //che verrà espansa con degli stili predefiniti (es: "string", "number", "date", "sixlookup")
  //In aggiunta vi sono alcuni campi speciali:
  // - configName: nome leggibile mostrato in fase di configurazione
  // - id: identificativo univoco  colonna usato in configurazione
  // - active: determina se la colonna verrà mostrata o meno (settato dal configuratore)

  //Campi noti, ovvero i campi fuori dallo schema o che necessitano di una formattazione particolare (e che la dashboard sa come visualizzare)
  var knownFields = [{
    id: "col_manage_odl",
    configName: "Link a ODL",
    displayName: "",
    field: "manage_odl"
  }, {
    id: "col_code",
    displayName: "Codice ODL",
    field: "model.code",
    type: "string"
  }, {
    id: "col_description",
    displayName: "Descrizione",
    field: "model.description",
    type: "string"
  }, {
    id: "col_status",
    displayName: "Stato",
    field: "status"
  }, {
    id: "col_insertion",
    displayName: "Data inserimento",
    field: "date_insertion",
    type: "date"
  }, {
    id: "col_requested",
    displayName: "Data richiesta",
    field: "date_requested",
    type: "date"
  }, {
    id: "col_handling",
    displayName: "Data inizio lavori",
    field: "date_handling",
    type: "date"
  }, {
    id: "col_closing",
    displayName: "Data chiusura",
    field: "date_closing",
    type: "date"
  }, {
    id: "col_issue",
    displayName: "Segnalazione",
    field: "issue_id",
    type: "sixlookup"
  }, {
    id: "col_type",
    displayName: "Tipo asset",
    field: "model.type_id",
    type: "sixlookup"
  }, {
    id: "col_type_qty",
    displayName: "Tipo asset target (qta)",
    field: "target_type_id_qty"
  }, {
    id: "col_record",
    displayName: "Asset",
    field: "model.record_id",
    type: "sixlookup"
  }, {
    id: "col_service",
    displayName: "Servizio",
    field: "model.service_id",
    type: "sixlookup"
  }, {
    id: "col_generated_by",
    displayName: "Sorgente",
    field: "generated_by"
  }, {
    id: "col_generation_tag",
    displayName: "Codice generazione programmata",
    field: "model.generation_tag",
    type: "string"
  }, {
    id: "col_readable_user",
    displayName: "Utente generazione",
    field: "readable_user"
  }, {
    id: "col_supplier",
    displayName: "Fornitore",
    field: "references_assignee.supplier_id",
    type: "sixlookup"
  }, {
    id: "col_company",
    displayName: "Azienda assegnataria",
    field: "references_assignee.company_id",
    type: "sixlookup"
  }, {
    id: "col_headmanCommission",
    displayName: "Capo commessa",
    field: "references_assignee.headmanCommission_id",
    type: "sixlookup"
  }, {
    id: "col_supervisorInternal",
    displayName: "Responsabile interno",
    field: "references_assignee.supervisorInternal_id",
    type: "sixlookup"
  }, {
    id: "col_supervisorExternal",
    displayName: "Responsabile esterno",
    field: "references_assignee.supervisorExternal_id",
    type: "sixlookup"
  }, {
    id: "col_odl_attachments",
    configName: "Pannello allegati",
    displayName: "Allegati",
    field: "odl_attachments"
  }, {
    id: "col_odl_notifications",
    displayName: "Notifiche",
    field: "odl_notifications"
  }, {
    id: "col_manage_notifications",
    configName: "Pannello invio notifiche",
    displayName: "",
    field: "manage_notifications"
  }, {
    id: "col_customer_estimates",
    displayName: "Preventivo cliente",
    field: "customer_estimates"
  }, {
    id: "col_supplier_estimates",
    displayName: "Preventivo fornitore",
    field: "supplier_estimates"
  }, {
    id: "col_manage_estimate_admin",
    configName: "Pannello preventivi Amministrativo",
    displayName: "",
    field: "manage_estimate_admin"
  }, {
    id: "col_manage_estimate",
    configName: "Pannello preventivi Cliente",
    displayName: "",
    field: "manage_estimate"
  }, {
    id: "col_consumptives",
    displayName: "Consuntivo",
    field: "consumptives"
  }, {
    id: "col_manage_consumptive_admin",
    configName: "Pannello consuntivi Amministrativo",
    displayName: "",
    field: "manage_consumptive_admin"
  }, {
    id: "col_manage_consumptive",
    configName: "Pannello consuntivi Cliente",
    displayName: "",
    field: "manage_consumptive"
  }];

  //restituisce tutti i campi noti + quelli estratti dal model in base alla commessa (il ruolo non incide)
  //se la commessa non è indicata ritorna un placeholder per le colonne del model
  this.getAllFields = function (commission) {
    if (!commission) {
      var placeholder = {
        type: 'placeholder',
        configName: 'Campi specifici della commessa',
        field: 'placeholder',
        id: 'placeholder'
      };
      return $q.resolve(knownFields.concat(placeholder));
    }
    return odlFactory().getOdlSchema({
      commission: commission
    }).$promise.then(function (data) {
      var modelFields = [];
      if (data.model) {
        modelFields = extractSchemaColumns(data.model);
      }
      return knownFields.concat(modelFields);
    });
  };
  function extractSchemaColumns(model) {
    var modelFields = [];
    var schema = model.schema;
    var form = model.form;
    for (var i in schema.properties) {
      //determino il type
      var type = schema.properties[i].type;
      if (type == 'integer' || type == 'boolean') type = 'number';
      if (type == 'string' && schema.properties[i].format == 'lookup') {
        type = 'sixlookup';
      }
      if (type == 'array') {
        console.log("Campi array non gestiti: " + schema.properties[i].title);
        type = 'string';
      }

      //compongo la configurazione della colonna
      modelFields.push({
        type: type,
        displayName: schema.properties[i].title,
        field: 'model.' + i,
        id: 'col_m_' + i
      });
    }
    return modelFields;
  }

  //recupera la configurazione salvata in base a commessa e ruolo
  this.getConfiguredFields = function () {
    var commission = authFactory.getAuthData().info.commissions.current.code;
    try {
      var currentRole = localStorageService.get('operatore').model.typeoperator_map[commission];
      if (!currentRole) {
        currentRole = localStorageService.get('operatore').model.typeoperator_map['tutte'].code;
      } else {
        currentRole = currentRole.code;
      }
    } catch (e) {
      var currentRole = '*';
    }
    $log.info('Retrieving columns for commission: ' + commission + ' and role: ' + currentRole);
    return odlFactory().getDashboardConfigurationByRole({
      id: currentRole,
      code: commission
    }).$promise.then(function (result) {
      var colorMapping = result.model.colorMapping;
      var fields = [];
      var hasPlaceholder = false;
      for (var c in result.model.columns) {
        if (result.model.columns[c].active) {
          //se è il placeholder va arricchito
          if (result.model.columns[c].field == "placeholder") {
            hasPlaceholder = fields.push("placeholder");
          } else {
            fields.push(result.model.columns[c]);
          }
        }
      }
      if (fields.length == 0) {
        //nessun dato visibile, creo colonna fittizia
        fields = [{
          displayName: "Nessuna colonna abilitata",
          field: "model.code",
          type: "text"
        }];
      }
      if (hasPlaceholder) {
        return odlFactory().getOdlSchema({
          commission: commission
        }).$promise.then(function (data) {
          var insertPoint = hasPlaceholder - 1;
          var modelFields = [];
          if (data.model) {
            modelFields = extractSchemaColumns(data.model);
          }
          return {
            fields: fields.slice(0, insertPoint).concat(modelFields, fields.slice(insertPoint + 1)),
            colorMapping: colorMapping
          };
        });
      } else {
        return {
          fields: fields,
          colorMapping: colorMapping
        };
      }
    });
  };
}]);
/* 
TODO:
- permettere di customizzare il titolo della colonna e la larghezza
- migliorare mergeColumnData: fare un merge tra le vecchie colonne configurate e quelle ricevute in modo da non distruggere quanto già configurato
*/

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:DashboardOdlConfiguratorCtrl
 * @description
 * # OdlconfiguratorCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/dashboard_odl/configurator', {
    templateUrl: 'plan/dashboard/dashboardodl_configurator.html',
    controller: 'DashboardOdlConfiguratorCtrl'
  }).when('/dashboard_odl/configurator/page/:number', {
    templateUrl: 'plan/dashboard/dashboardodl_configurator.html',
    controller: 'DashboardOdlConfiguratorCtrl'
  }).when('/dashboard_odl/configurator/:id', {
    templateUrl: 'plan/dashboard/dashboardodl_configurator_detail.html',
    controller: 'DashboardOdlConfiguratorCtrl'
  });
}]).controller('DashboardOdlConfiguratorCtrl', ["$scope", "$routeParams", "$location", "$route", "$log", "$window", "odlFactory", "$document", "schemaFactory", "commissionFactory", "toaster", "authFactory", "dialogService", "dashboardOdlColumnService", function ($scope, $routeParams, $location, $route, $log, $window, odlFactory, $document, schemaFactory, commissionFactory, toaster, authFactory, dialogService, dashboardOdlColumnService) {
  var PATH_CONFIG = 'dashboard_odl/configurator';
  $scope.bool = {
    isNew: false,
    isDefault: false
  };
  $scope.queryParam = '';
  $scope.pageSize = 10;
  $scope.commission = {
    selected: authFactory.getAuthData().info.commissions.current
  };
  $scope.prevData = {
    commission: [authFactory.getAuthData().info.commissions.current.code],
    role: undefined,
    code: ""
  };

  // dati di default configurazione 
  $scope.columnConfig = {
    model: {
      code: '',
      columns: {},
      commission: [$scope.commission.selected.code],
      role: undefined,
      auto_generate_code: true
    }
  };
  $scope.configScopeSet = false;
  $scope.commissions = [];
  $scope.columnSortableOptions = {
    containerPositioning: 'relative',
    containment: '#columnManager'
  };
  $scope.activateAllColumns = function () {
    $scope.columnActiveToggle = !$scope.columnActiveToggle;
    for (var c in $scope.columnConfig.model.columns) {
      $scope.columnConfig.model.columns[c].active = $scope.columnActiveToggle;
    }
  };
  $scope.aceChanged = function () {
    var modifiedData = angular.fromJson(angular.copy($scope.aceModel));
    if (modifiedData) {
      $scope.columnConfig.model = modifiedData;
    }
  };
  $scope.aceLoaded = function () {
    $scope.aceModel = JSON.stringify($scope.columnConfig.model, null, '\t');
  };
  $scope.$watch('columnConfig.model', function (newValue, oldValue) {
    $scope.aceModel = JSON.stringify(angular.copy($scope.columnConfig.model), null, '\t');
  }, true);
  $scope.$watch('bool.isDefault', function (value) {
    if (value) {
      $scope.prevData.code = $scope.columnConfig.model.code;
      $scope.prevData.commission = $scope.columnConfig.model.commission;
      $scope.prevData.role = $scope.columnConfig.model.role;
      $scope.setCode();
    } else {
      $scope.columnConfig.model.commission = $scope.prevData.commission;
      $scope.columnConfig.model.role = $scope.prevData.role;
      if ($scope.prevData.code == 'default') {
        $scope.setCode($scope.commission.selected.code, undefined);
      } else {
        $scope.columnConfig.model.code = $scope.prevData.code;
      }
    }
  });
  $scope.$watchGroup(['columnConfig.model.commission', 'columnConfig.model.role', 'columnConfig.model.auto_generate_code'], function () {
    if ($scope.columnConfig.model.auto_generate_code) {
      $scope.setCode($scope.columnConfig.model.commission[0], $scope.columnConfig.model.role);
    }
  });
  $scope.setCommission = function ($item) {
    $scope.columnConfig.model.commission = [$item.code];
  };
  $scope.pageChanged = function () {
    $location.path('/dashboard_odl/configurator/page/' + $scope.currentPage, false);
    $scope.configuratorList = odlFactory().getDashboardConfigurationList({
      query: $scope.queryParam,
      page: $scope.currentPage
    });
  };
  $scope.printCommission = function (commission_array) {
    var result = '';
    var pos = 0;
    if (commission_array != null) {
      angular.forEach(commission_array, function (value) {
        if (pos == 0) {
          result = value;
        } else {
          result = value + ', ' + result;
        }
        pos++;
      });
    }
    return result;
  };
  $scope.$watchGroup(['configScopeSet', 'columnConfig.model.commission'], function (newValue, oldValue) {
    if ($scope.modelLoaded) {
      //salto il caricamento colonne se il dato è appena stato caricato
      $scope.modelLoaded = false;
      return;
    }
    if (!$scope.configScopeSet || !angular.equals(newValue[1], oldValue[1])) {
      $scope.configScopeSet = true;
      if (typeof $scope.columnConfig.model.commission != "undefined") {
        var commission = $scope.columnConfig.model.commission[0];
      }
      dashboardOdlColumnService.getAllFields(commission).then(function (columns) {
        if (columns) {
          mergeColumnData(columns);
        }
      });
    }
  }, true);
  function mergeColumnData(newColumns) {
    //l'ordine va mantenuto 
    //se era già configurata, va mantenuta la configurazione
    //le colonne diventate inesistenti vanno rimosse 
    //le colonne nuove vanno accodate
    var oldCol = angular.copy($scope.columnConfig.model.columns);
    var newCol = angular.copy(newColumns);
    var merged = [];
    for (var o in oldCol) {
      for (var n in newCol) {
        if (oldCol[o].id === newCol[n].id) {
          merged.push(Object.assign(newCol[n], oldCol[o]));
          newCol.splice(n, 1);
        }
      }
    }
    $scope.columnConfig.model.columns = merged.concat(newCol);
  }
  $scope.setCode = function (commission, role) {
    if (angular.isDefined(commission) && angular.isDefined(role)) {
      $scope.columnConfig.model.code = removeBlankSpaces(commission + '_' + role.code);
    } else if (angular.isDefined(commission)) {
      $scope.columnConfig.model.code = removeBlankSpaces(commission + '_no_role');
    } else {
      $scope.columnConfig.model.code = 'default';
      $scope.columnConfig.model.commission = undefined;
      $scope.columnConfig.model.role = undefined;
    }
  };
  $scope.newConfiguration = function () {
    $location.path(PATH_CONFIG + '/new');
  };
  $scope.refresh = function () {
    $route.reload();
  };
  $scope.back = function () {
    $location.path(PATH_CONFIG);
  };
  $scope["delete"] = function () {
    dialogService.confirmDialog('Eliminare la configurazione?', function () {
      odlFactory().deleteDashboardConfiguration({
        id: $scope.columnConfig.version
      }).$promise.then(function () {
        $scope.back();
      });
    });
  };
  $scope.getDashboardOdlConfigurationById = function (UUID) {
    odlFactory().getDashboardConfigurationByUUID({
      id: UUID
    }).$promise.then(function (response) {
      if (response.model) {
        $scope.columnConfig = response;
        $scope.configScopeSet = true;
        $scope.bool.isDefault = !$scope.columnConfig.model.commission && !$scope.columnConfig.model.role;
        if (!$scope.bool.isDefault) {
          $scope.commission.selected = {
            code: $scope.columnConfig.model.commission[0]
          };
          for (var c in $scope.commissions) {
            if ($scope.commissions[c].code == $scope.commission.selected.code) {
              $scope.commission.selected = $scope.commissions[c];
            }
          }
        }
        $scope.modelLoaded = true;
      }
    });
  };
  $scope.getDashboardOdlConfigurationList = function () {
    odlFactory().getDashboardConfigurationList({
      query: $scope.queryParam,
      pageSize: $scope.pageSize
    }).$promise.then(function (response) {
      $scope.configuratorList = response;
    });
  };
  $scope.getCommission = function () {
    commissionFactory().getCommissionsList().$promise.then(function (response) {
      if (response.list) {
        $scope.commissions = response.list;
      }
    });
  };
  $scope.create = function () {
    odlFactory().createDashboardConfiguration($scope.columnConfig).$promise.then(function () {
      toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
      $scope.back();
    })["catch"](function (response) {
      toaster.pop('error', 'Errore salvataggio', 'Si è verificato un errore durante il salvataggio');
    });
  };
  $scope.update = function () {
    odlFactory().updateDashboardConfiguration({
      id: $scope.columnConfig.version
    }, $scope.columnConfig).$promise.then(function () {
      toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
      $scope.back();
    })["catch"](function (rejection) {
      toaster.pop('error', 'Errore salvataggio', rejection.data.message ? rejection.data.message : rejection.statusText);
    });
  };
  $scope.saveForm = function () {
    if ($scope.columnConfig.version) {
      $scope.update();
    } else {
      $scope.create();
    }
  };
  if ($routeParams.id) {
    if ($routeParams.id !== 'new') {
      $scope.bool.isNew = false;
      commissionFactory().getCommissionsList().$promise.then(function (response) {
        if (response.list.length) {
          $scope.commissions = response.list;
        }
        $scope.getDashboardOdlConfigurationById($routeParams.id);
      });
    } else {
      $scope.bool.isNew = true;
      $scope.getCommission();
    }
  } else {
    $scope.getDashboardOdlConfigurationList();
  }

  /*************************************
   ************* Utilities *************
   ************************************/

  /**
   * Removes blank spaces, tabs and similar from a string
   * @param string Any string
   * @returns string without blank spaces
   */
  function removeBlankSpaces(string) {
    return string.replace(/\s/g, "");
  }

  /*************************************
   ********* Check permissions *********
   ************************************/

  var RESOURCE_NAME = 'odl/schema';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
}]);
'use strict';

/**
 * @author Rita Beltrami
 * @ngdoc function
 * @name sixEmmaApp.controller:DashboardassetCtrl
 * @description
 * # DashboardassetCtrl
 * Controller of the Assets project dashboard
 */
angular.module('emma.plan').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/asset', {
    templateUrl: 'theme/dashboard/dashboard.html',
    controller: 'DashboardAssetCtrl'
  });
}]).controller('DashboardAssetCtrl', ["$scope", "$log", "dashboardAssetFactory", "authFactory", function ($scope, $log, dashboardAssetFactory, authFactory) {
  //__params__
  var logInfo = true;
  var config = [];
  $scope.pos1 = [];
  $scope.pos2 = [];
  $scope.pos3 = [];
  $scope.widgetClass = "panel-widge";
  $scope.isLoggedIn = function () {
    return authFactory.isAuthenticated();
  };
  function userInfo() {
    if ($scope.isLoggedIn()) {
      var authData = authFactory.getAuthData();
      return authData;
    } else {
      return;
    }
  }
  config = [{
    // Ultimi ODL inseriti
    "maxData": 5,
    "widgetApi": "dashboard/odl/list",
    "title": "Ultimi ODL inseriti",
    "skin": "primary",
    "widgetType": "widget-simple-list",
    "position": "pos-2",
    "buttons": []
  }, {
    // Gestisci ODL
    "widgetApi": "dashboard/odl/list",
    "title": "ODL assegnati a te",
    "skin": "success",
    "widgetType": "widget-label-list",
    "position": "pos-1",
    "buttons": []
  }, {
    // ODL in scadenza
    "widgetApi": "dashboard/odl/list",
    "title": "ODL in scadenza",
    "icon": "fa fa-envelope",
    "widgetType": "widget-timeline",
    "position": "pos-3"
  }, {
    // Statistiche ODL
    "widgetApi": "dashboard/odl/donut",
    "title": "Statistiche ODL",
    "skin": "warning",
    "widgetType": "widget-donut",
    "position": "pos-1"
  }, {
    // Profilo utente
    "title": "Profilo utente",
    "skin": "info",
    "widgetType": "widget-user",
    "position": "pos-2",
    "data": [{
      "user": userInfo().info.name + " " + userInfo().info.surname,
      "group": userInfo().authId,
      "avatar": "avatar.png",
      "buttons": [{
        "icon": "icon-bell",
        "label": "Notifiche",
        "link": "notification",
        "hasBadge": false
      }, {
        "icon": "icon-logout",
        "label": "Logout",
        "link": 'logout',
        "hasBadge": false
      }]
    }]
  }, {
    // Ultime notifiche utente
    "maxData": 5,
    "widgetApi": "dashboard/notification",
    "title": "Ultime Notifiche - " + userInfo().info.name + " " + userInfo().info.surname + "(" + userInfo().authId + ")",
    //dopo averla vista non mi piace
    "skin": "dark",
    "widgetType": "widget-notifications",
    "position": "pos-1",
    "buttons": [{
      "icon": "icon-bell",
      "label": "Tutte le Notifiche",
      "link": "notification"
    }]
  }];
  function convertToDonutFormat(item) {
    item.appColor = item.color;
    switch (item.color) {
      case "primary":
        item.color = $scope.app.color.primary;
        break;
      case "info":
        item.color = $scope.app.color.info;
        break;
      case "success":
        item.color = $scope.app.color.success;
        break;
      case "light":
        item.color = $scope.app.color.light;
        break;
      case "dark":
        item.color = $scope.app.color.dark;
        break;
      case "danger":
        item.color = $scope.app.color.danger;
        break;
      case "warning":
        item.color = $scope.app.color.warning;
        break;
      default:
        break;
    }
  }
  function createWidget(item) {
    // Retrieves data from the backend
    if (angular.isDefined(item.widgetApi)) {
      item.data = [];
      var payload = {
        pageSize: item.maxData,
        show_revision: false
      };
      dashboardAssetFactory(item.widgetApi).query(payload).$promise.then(function (data) {
        if (data && data.list) {
          for (var i = 0; i < data.list.length; i++) {
            if (item.widgetType == "widget-donut") {
              convertToDonutFormat(data.list[i]);
            }
            item.data.push(data.list[i]);
          }
        }
      });
    }
    // Sets widget to the right position.
    switch (item.position) {
      case 'pos-1':
        $scope.pos1.push(item);
        break;
      case 'pos-2':
        $scope.pos2.push(item);
        break;
      case 'pos-3':
        $scope.pos3.push(item);
        break;
      default:
        $log.info("Posizione widget sconosciuta");
    }
  }
  $scope.getDynamic = function (item) {
    return undefined;
  };
  $scope.initDashboard = function () {
    for (var i = 0; i < config.length; i++) {
      createWidget(config[i]);
    }
  };

  //__main__
  $scope.initDashboard();
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:DashboardOdlCtrl
 * @description
 * # DashboardOdlCtrl
 * Controller of the sixEmmaApp
 */
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
angular.module('emma.plan').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/dashboard_odl', {
    templateUrl: 'plan/dashboard/dashboardodl.html',
    controller: 'DashboardOdlCtrl'
  });
}]).controller('DashboardOdlCtrl', ["$scope", "modelFactory", "authFactory", "odlFactory", "$routeParams", "$log", "$window", "errorService", "localStorageService", "modelIconService", "$location", "treePlanConfigFactory", "taskFactory", "issueFactory", "lookupFactory", "dialogService", "ngDialog", "toaster", "$filter", "issueToOdl", "uiGridConstants", "$timeout", "$route", "counterFactory", "userFactory", "recordFactory", "sixGridPaginationConstants", "odlWorkflow", "treeUtilities", "$http", "APP_URL", "SaveAs", "$q", "dashboardOdlColumnService", "DEV", "ENV", function ($scope, modelFactory, authFactory, odlFactory, $routeParams, $log, $window, errorService, localStorageService, modelIconService, $location, treePlanConfigFactory, taskFactory, issueFactory, lookupFactory, dialogService, ngDialog, toaster, $filter, issueToOdl, uiGridConstants, $timeout, $route, counterFactory, userFactory, recordFactory, sixGridPaginationConstants, odlWorkflow, treeUtilities, $http, APP_URL, SaveAs, $q, dashboardOdlColumnService, DEV, ENV) {
  $scope.dashboardConfiguration = {
    "columns": [],
    //array di colonne, l'ordine viene rispettato in visualizzazione
    "colorMapping": [] //mappatura colori, sovrascritta se definita nella configurazione
  };

  /**** CONSTANTS ****/

  var currentCommission = authFactory.getAuthData().info.commissions.current;
  $scope.odlRef = null;
  $scope.queryParam = '';
  $scope.uiGridFiltersQuery = '';
  $scope.commissionDependent = true;
  $scope.schemaOdlDefined = false;
  $scope.typeName = 'odl';
  if (localStorageService.get('odl_bool')) {
    $scope.bool = localStorageService.get('odl_bool');
  } else {
    $scope.bool = {
      allOdl: true,
      viewEstimateAssociated: true,
      viewConsumptiveAssociated: false
    };
  }
  $scope.odlList = {
    list: []
  };
  $scope.assetTreeFilter = [];
  $scope.params = {
    pageNumber: 1,
    pageSize: 100,
    filters: {}
  };
  $scope.autoResizeParams = {
    enabled: true,
    minHeight: 200,
    marginTop: 290
  };

  /** VARIABILI FILTRAGGIO LOOK UP */
  $scope.gridAppCallbacks = {};
  $scope.gridAppCallbacks['getReadableStatus'] = odlWorkflow.getReadableStatus;
  $scope.gridAppCallbacks['getReadableType'] = getReadableType;
  $scope.gridAppCallbacks['getReadableUser'] = getReadableUser;
  $scope.gridAppCallbacks['showPanel'] = showPanel;
  $scope.gridAppCallbacks['changeStatus'] = changeStatus;
  $scope.gridAppCallbacks['detectPrice'] = detectPrice;
  $scope.gridAppCallbacks['isWritePermAllowed'] = isWritePermAllowed;
  $scope.gridAppCallbacks['countAttachments'] = countAttachments;
  $scope.gridAppCallbacks['buildMultiSelectFilter'] = buildMultiSelectFilter;
  $scope.viewGridOptions = {
    enableSorting: true,
    enableGridMenu: true,
    exporterCsvColumnSeparator: ';',
    exporterSuppressColumns: ['id', 'timeline'],
    exporterMenuPdf: false,
    enableFiltering: true,
    enableColumnResizing: true,
    paginationPageSizes: [100, 250, 500, 1000, 10000],
    paginationPageSize: 100,
    useExternalPagination: true,
    useExternalFiltering: true,
    multiSelect: true,
    enableRowHeaderSelection: true,
    enableRowSelection: true,
    enableHorizontalScrollbar: 1,
    columnDefs: [{
      name: ' '
    }]
  };
  $scope.odlWorkflow = odlWorkflow;
  $scope.statusFilterOptions = [];
  $scope.typeIdFilter = null;
  treeUtilities.getFlatStructureUuids().then(function (types) {
    if (types) {
      $scope.typeIdFilter = {
        'typeIdFilter': sixFiltersLib["in"]('UUID', types)
      };
    }
  });
  $scope.newOdl = function () {
    $location.path('odl/new');
  };
  $scope.refresh = function () {
    // $route.reload();
    $scope.getColumns();
    $scope.getCurrentUserOdlList();
  };
  $scope.goToOdlList = function () {
    $location.path('odl');
  };
  $scope.getColumns = function () {
    getColumnOrDefault();
    return $scope.columnDefs;
  };
  function hidrateColumn(column) {
    //se è un field noto lo unisco alla specifica configurazione predefinita
    //altrimenti guardo se è specificato un type per unirlo a una delle config standard

    var knownFields = {
      "manage_odl": {
        field: 'id',
        width: 36,
        enableCellEdit: false,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/odl/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' + '<span class="fa fa-search"></span>' + '</a>' + '</div>'
      },
      "target_type_id_qty": {
        field: 'model.target_type_id',
        cellTemplate: '<div class="ui-grid-cell-contents" ng-if="!row.entity.is_aggregated">-</div>' + '<div class="ui-grid-cell-contents" ng-if="row.entity.is_aggregated">{{row.entity.model.target_type_id.description}} ({{row.entity.model.record_id.children_count}})</div>',
        enableFiltering: true,
        width: 150,
        filters: [{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      },
      "status": {
        field: 'status',
        enableFiltering: true,
        width: 100,
        filterHeaderTemplate: '<div class="ui-grid-filter-container"><a class="block btn btn-default btn-xs" ng-repeat="colFilter in col.filters" ' + 'ng-click="grid.appScope.buildMultiSelectFilter(colFilter)">Filtro</a></div>',
        filters: [{
          type: sixGridPaginationConstants.filterType.SELECTMULTIPLE,
          selectOptions: $scope.statusFilterOptions,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }],
        cellTemplate: '<div ng-if="grid.appScope.isWritePermAllowed()" class="pull-right ui-grid-cell-contents" style="vertical-align:middle;">' + '<a ng-click="grid.appScope.changeStatus(row.entity)" class="btn btn-xs btn-primary" title="Modifica Status">' + '<span class="fa fa-edit"></span>' + '</a>' + '</div>' + '<div class="ui-grid-cell-contents" style="vertical-align:middle;">' + '{{grid.appScope.getReadableStatus(row.entity.status)}}' + '</div>'
      },
      "readable_user": {
        field: 'user',
        cellTemplate: '<div class="ui-grid-cell-contents">{{grid.appScope.getReadableUser(row.entity)}}</div>',
        width: 100,
        enableFiltering: false,
        enableSorting: false
      },
      "generated_by": {
        field: 'generated_by',
        width: 150,
        enableFiltering: true,
        filters: [{
          type: sixGridPaginationConstants.filterType.SELECT,
          condition: uiGridConstants.filter.CONTAINS,
          selectOptions: [{
            value: 'issue',
            label: 'Segnalazione'
          }, {
            value: 'plan',
            label: 'Programmata'
          }],
          placeholder: ''
        }],
        cellTemplate: '<div class="ui-grid-cell-contents" style="vertical-align:middle;">' + '{{grid.appScope.getReadableType(row.entity.generated_by)}}' + '</div>'
      },
      "customer_estimates": {
        field: 'customer_estimates',
        enableFiltering: false,
        enableSorting: false,
        width: 150,
        cellTemplate: '<div class="ui-grid-cell-contents" ng-bind-html="grid.appScope.detectPrice(row.entity.customer_estimates)"></div>',
        filters: [{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      },
      "supplier_estimates": {
        field: 'supplier_estimates',
        enableFiltering: false,
        enableSorting: false,
        width: 150,
        cellTemplate: '<div class="ui-grid-cell-contents" ng-bind-html="grid.appScope.detectPrice(row.entity.supplier_estimates)"></div>',
        filters: [{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      },
      "manage_estimate_admin": {
        field: 'manage_estimate_admin',
        width: 36,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-click="grid.appScope.showPanel(\'estimate_admin\', row.entity)" class="btn btn-xs btn-primary" title="Gestisci preventivi">' + '<span class="fa fa-edit"></span>' + '</a>' + '</div>'
      },
      "manage_estimate": {
        field: 'manage_estimate',
        width: 36,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-click="grid.appScope.showPanel(\'estimate\', row.entity)" class="btn btn-xs btn-primary" title="Visualizza preventivi">' + '<span class="fa fa-edit"></span>' + '</a>' + '</div>'
      },
      "consumptives": {
        field: 'consumptives',
        enableFiltering: false,
        enableSorting: false,
        width: 150,
        cellTemplate: '<div class="ui-grid-cell-contents" ng-bind-html="grid.appScope.detectPrice(row.entity.consumptives)"></div>',
        filters: [{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      },
      "manage_consumptive_admin": {
        field: 'manage_consumptive_admin',
        width: 36,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-click="grid.appScope.showPanel(\'consumptive_admin\', row.entity)" class="btn btn-xs btn-primary" title="Gestisci consuntivi">' + '<span class="fa fa-edit"></span>' + '</a>' + '</div>'
      },
      "manage_consumptive": {
        field: 'manage_consumptive',
        width: 36,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-click="grid.appScope.showPanel(\'consumptive\', row.entity)" class="btn btn-xs btn-primary" title="Visualizza consuntivi">' + '<span class="fa fa-edit"></span>' + '</a>' + '</div>'
      },
      "odl_notifications": {
        field: 'odl_notifications',
        enableFiltering: false,
        enableSorting: false,
        width: 150,
        cellTooltip: function cellTooltip(row, col) {
          return row.entity.last_notification.model.subject;
        },
        cellTemplate: '<div class="ui-grid-cell-contents">\
            <a ng-click="grid.appScope.showPanel(\'notification\', row.entity)">\
              <span class="badge primary pull-right">{{row.entity.notification_count}}</span>{{row.entity.last_notification.model.subject}}</a>',
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      },
      "manage_notifications": {
        field: 'manage_notifications',
        width: 36,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-click="grid.appScope.showPanel(\'manage_notification\', row.entity)" class="btn btn-xs btn-primary" title="Gestisci Notifiche">' + '<span class="fa fa-envelope"></span>' + '</a>' + '</div>'
      },
      "odl_attachments": {
        field: 'odl_attachments',
        width: 70,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center" ng-show="grid.appScope.countAttachments(row.entity)">' + '<a ng-click="grid.appScope.showPanel(\'attachments\', row.entity)" class="btn btn-xs btn-primary" title="Mostra allegati">' + '<span class="fa fa-paperclip"></span>' + '<span class="badge badge-sm" style="margin: -2px 0 0 4px;">{{grid.appScope.countAttachments(row.entity)}}</span>' + '</a>' + '</div>'
      }
    };
    var typeConfig = {
      "string": {
        displayName: '<FIELD>',
        field: '<FIELD>',
        enableFiltering: true,
        width: 150,
        cellTooltip: function cellTooltip(row, col) {
          //FIXME: rendere più leggibile. Permette di leggere row.entity[col.field] anche se col.field è ad esempio "model.xxx"
          return col.field.split('.').reduce(function (obj, i) {
            return obj ? obj[i] : null;
          }, row.entity);
        },
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      },
      "number": {
        displayName: '<FIELD>',
        field: '<FIELD>',
        enableFiltering: true,
        width: 100,
        cellTemplate: '<div class="ui-grid-cell-contents cont-right">{{ row.entity.<FIELD> }}</div>',
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      },
      "date": {
        displayName: '<FIELD>',
        field: '<FIELD>',
        type: 'date',
        cellFilter: 'date:\'dd/MM/yyyy\'',
        width: 100,
        enableFiltering: true,
        filters: [{
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
          placeholder: 'da...',
          condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
        }, {
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
          placeholder: 'a...',
          condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
        }]
      },
      "sixlookup": {
        displayName: '<FIELD>',
        field: '<FIELD>',
        cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.<FIELD> | reference}}</div>',
        enableFiltering: true,
        width: 150,
        filters: [{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      }
    };
    var target = {};
    if (angular.isDefined(column.field) && column.field in knownFields) {
      target = knownFields[column.field];
      delete column.field;
    } else if (angular.isDefined(column.type) && column.type in typeConfig) {
      target = typeConfig[column.type];
      recursiveReplace(target, "<FIELD>", column.field);
    }
    var hidrated = Object.assign(target, column);
    hidrated.cellClass = applyColorMapping;
    return hidrated;
  }
  ;
  $scope.odlDashboardPanelOpen = false;
  $scope.panelConfig = {};
  function showPanel(type, item) {
    if ($scope.panelConfig.odlUuid == item.UUID && $scope.odlDashboardPanelOpen && $scope.panelConfig.type == type) {
      $scope.odlDashboardPanelOpen = false;
    } else {
      $scope.odlDashboardPanelOpen = true;
      $scope.panelConfig = {
        type: type,
        odl: item,
        odlStatus: item.status,
        odlUuid: item.UUID
      };
      if (type == 'estimate' || type == 'estimate_admin') {
        $scope.panelConfig.estimatePanel = true;
        $scope.panelConfig.title = "Preventivi per ODL: " + item.model.code;
        $scope.panelConfig.estimateManage = type == 'estimate_admin';
      } else if (type == 'consumptive' || type == 'consumptive_admin') {
        $scope.panelConfig.consumptivePanel = true;
        $scope.panelConfig.title = "Consuntivi per ODL: " + item.model.code;
        $scope.panelConfig.consumptiveManage = type == 'consumptive_admin';
      } else if (type == 'notification') {
        $scope.panelConfig.notificationPanel = true;
        $scope.panelConfig.title = "Notifiche per ODL: " + item.model.code;
      } else if (type == 'manage_notification') {
        $scope.panelConfig.manageNotificationPanel = true;
        $scope.panelConfig.title = "Invia Notifica per ODL: " + item.model.code;
        $scope.panelConfig.odlRef = {
          UUID: item.UUID,
          code: item.code,
          type: item.schemaCode,
          description: item.description
        };
        $scope.getMessage(item);
      } else if (type == 'attachments') {
        $scope.panelConfig.attachmentsPanel = true;
        $scope.panelConfig.title = "Allegati per ODL: " + item.model.code;
      }
    }
  }
  ;
  function changeStatus(item) {
    $scope.statusOdlObj = item;
    var notifyToDialog = ngDialog.openConfirm({
      name: 'notifyToDialog',
      closeByDocument: false,
      showClose: true,
      scope: $scope,
      template: '' + '<div style="text-align:center" class="m-b">' + '<div class="padder-v"><b>Seleziona il nuovo status da impostare:</b></div>' + '<odl-tab sx-object="statusOdlObj" sx-show-status="false" sx-base-path="\'odl\'" sx-status="statusOdlObj.status" \
          sx-uuid="statusOdlObj.UUID" sx-callback="closeThisDialog()"></odl-tab>' + '</div>',
      plain: true,
      className: 'ngdialog-theme-default ngdialog-theme-custom overflowing-dialog'
    });
  }
  ;
  function initStatusOptions() {
    return odlWorkflow.getStatuses().then(function (statuses) {
      $scope.statusFilterOptions = [];
      for (var s in statuses) {
        $scope.statusFilterOptions.push({
          "value": statuses[s].code,
          "label": statuses[s].label
        });
      }
    });
  }
  ;
  function getColumnOrDefault() {
    initStatusOptions().then(function () {
      $scope.viewGridOptions.columnDefs = [];
      var columns = angular.copy($scope.dashboardConfiguration.columns);
      for (var c in columns) {
        $scope.viewGridOptions.columnDefs.push(hidrateColumn(columns[c]));
      }
      $scope.params.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
    });
  }
  ;
  function applyColorMapping(grid, row, col, rowRenderIndex, colRenderIndex) {
    var colorMapping = $scope.dashboardConfiguration['colorMapping'];
    for (var m in colorMapping) {
      if (colorMapping[m].field == col.field) {
        var value = colorMapping[m].value_key.split('.').reduce(function (obj, i) {
          return obj ? obj[i] : null;
        }, row.entity);
        for (var k in colorMapping[m].mapping) {
          if (colorMapping[m].mapping[k].value == value) {
            return "cmap_" + m + "_" + k;
          }
        }
      }
    }
  }
  ;
  function injectCss() {
    //utilizza il mapping configurato per iniettare delle classi css nel documento
    var colorMapping = $scope.dashboardConfiguration['colorMapping'];
    var css = "";
    for (var m in colorMapping) {
      for (var k in colorMapping[m].mapping) {
        var selector = ".cmap_" + m + "_" + k;
        css += selector + "{ background-color: " + colorMapping[m].mapping[k].color + " !important } ";
      }
    }
    var style = document.createElement('style');
    style.type = 'text/css';
    style.innerHTML = css;
    document.getElementsByTagName('head')[0].appendChild(style);
  }
  ;
  function countAttachments(item) {
    var nodes = item.model.attachments;
    return recursiveCountFileAttachments(nodes);
  }
  ;
  function recursiveCountFileAttachments(nodes) {
    var count = 0;
    for (var n in nodes) {
      if (nodes[n].folder != true) {
        count++;
      }
      if (0 < nodes[n].nodes.length) {
        count += recursiveCountFileAttachments(nodes[n].nodes);
      }
    }
    return count;
  }
  function buildMultiSelectFilter(filter) {
    var options = '';
    filter.selectOptions.forEach(function (val, key) {
      options += '<label class="checkbox i-checks m-t-none m-b-none"><input type="checkbox" ' + 'ng-model="ngDialogData.selection[' + key + '].active"><i></i> ' + val.label + '</label>';
    });
    if (Array.isArray(filter.term)) {
      filter.term.forEach(function (term) {
        filter.selectOptions.forEach(function (v, k, opt) {
          if (v.value == term) opt[k].active = true;
        });
      });
    }
    ngDialog.openConfirm({
      name: 'multiSelectFilterDialog',
      closeByDocument: false,
      showClose: true,
      template: '' + '<div style="text-align:center">Seleziona filtri da attivare ' + '</div><br>' + '' + options + '' + '<div class="row" style="text-align:center; clear: both">' + '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ' + 'ng-click="confirm(ngDialogData.selection)">Applica filtro</button>' + '</div>',
      data: {
        selection: filter.selectOptions
      },
      plain: true,
      className: 'ngdialog-theme-default ngdialog-theme-custom'
    }).then(function (selection) {
      filter.term = [];
      selection.forEach(function (sel) {
        if (sel.active) {
          filter.term.push(sel.value);
        }
      });
    });
  }
  var OPERATOR_NOT_FOUND_ERR_SHOWN = false;
  $scope.getCurrentUserOperator = function () {
    $scope.currentUserOperator = undefined;
    var currentUser = authFactory.getAuthData().authId;
    var filters = {};
    filters['model.username'] = {
      type: '_exact',
      key: 'model.username',
      value: currentUser
    };
    return recordFactory('operatore').search({
      page_size: 1,
      show_revision: false
    }, filters).$promise.then(function (data) {
      $scope.currentUserOperator = data.list[0];
    })["catch"](function (response) {
      if (!OPERATOR_NOT_FOUND_ERR_SHOWN) {
        toaster.pop('error', 'Errore', 'Operatore corrispondente all\'utente \'' + currentUser + '\' non trovato');
        OPERATOR_NOT_FOUND_ERR_SHOWN = true;
      }
    })["finally"](function (response) {
      return $scope.currentUserOperator;
    });
  };
  $scope.getCurrentUserOdlList = function () {
    if (!$scope.currentUserOperator || !$scope.currentUserOperator.UUID) {
      return $scope.getCurrentUserOperator().then(function (operator) {
        return $scope.getOdlList();
      });
    } else {
      return $scope.getOdlList();
    }
  };
  $scope.getOdlList = function () {
    $scope.buildformattedString();
    var filters = angular.copy($scope.params.filters);
    // filtraggio in base all'operatore sugli assegnatari
    if ($scope.currentUserOperator && $scope.currentUserOperator.UUID && !$scope.bool.allOdl) {
      filters['user'] = sixFiltersLib.exact('user', $scope.currentUserOperator.model.username);
      filters['headmanCommission_id'] = sixFiltersLib.exact('references_assignee.headmanCommission_id.UUID', $scope.currentUserOperator.UUID, sixFiltersLib.CONSTRAINTS.OR);
      filters['technicianCommission_id'] = sixFiltersLib["in"]('references_assignee.technicianCommission_id', [$scope.currentUserOperator.UUID], sixFiltersLib.CONSTRAINTS.OR);
      filters['maintainer_id'] = sixFiltersLib["in"]('references_assignee.maintainer_id', [$scope.currentUserOperator.UUID], sixFiltersLib.CONSTRAINTS.OR);
      filters['supervisorInternal_id'] = sixFiltersLib.exact('references_assignee.supervisorInternal_id.UUID', $scope.currentUserOperator.UUID, sixFiltersLib.CONSTRAINTS.OR);
      filters['supervisorExternal_id'] = sixFiltersLib.exact('references_assignee.supervisorExternal_id.UUID', $scope.currentUserOperator.UUID, sixFiltersLib.CONSTRAINTS.OR);
    }

    //verifico se c'è un filtro sul generated_by inserito tramite grid prima di forzarlo
    if (!filters.hasOwnProperty('generated_by')) {
      filters['generated_by'] = sixFiltersLib.exact('generated_by', 'issue');
    }

    // creazione payload
    var payload = {
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      sort_fields: $scope.params.sortFields,
      show_revision: false,
      commission: currentCommission.code,
      enrich: "dashboard"
    };
    return odlFactory().search(payload, filters).$promise.then(function (data) {
      $scope.odlList.totalResults = data.totalResults;
      data.list = filterResult(data.list);
      $scope.odlList.list = data.list;
      $scope.params.sixApi.refreshList(data.list);
      return data;
    });
  };
  $scope.getSelectedRows = function () {
    var api = $scope.params.gridApi;
    if (api && api.selection) {
      return api.selection.getSelectedRows();
    } else {
      return [];
    }
  };
  $scope.deleteOdlSelected = function () {
    var rows = $scope.getSelectedRows();
    rows.forEach(function (val, i) {
      rows[i] = val.version;
    });
    odlFactory().bulkDeleteOdl(rows).$promise.then(function (data) {
      $scope.refresh();
    });
  };
  $scope.massiveClosingOdl = function () {
    var odlList = $scope.params.gridApi.selection.getSelectedRows();
    if (odlList && odlList.length > 0) {
      var dateClosingDialog = ngDialog.openConfirm({
        name: 'dateClosingDialog',
        closeByDocument: false,
        showClose: true,
        template: '' + '<div style="text-align:center"><i class="fa fa fa-calendar"></i> Inserire la data di chiusura</div><br>' + '<div style="text-align:left">' + ' da calendario:' + '<input class="form-control" id="input_dialog_date" type="date" ng-model="date">' + '</div>' + '<div style="text-align:left">' + ' o da num. giorni lavorativi:' + '<input class="form-control" id="input_dialog_days" type="number" ng-model="days">' + '</div>' + '<div style="text-align:center">' + '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ng-click="confirm()">OK</button>' + '</div>',
        plain: true,
        className: 'ngdialog-theme-default ngdialog-theme-custom'
      });
      dateClosingDialog.then(function () {
        // success
        var type = '';
        var value = null;
        if (document.getElementById("input_dialog_date").value) {
          value = document.getElementById("input_dialog_date").value;
          type = 'date';
        }
        if (document.getElementById("input_dialog_days").value) {
          value = document.getElementById("input_dialog_days").value;
          type = 'days';
        }
        var daysVar = null;
        var dateVar = null;
        if (type == 'days') {
          daysVar = parseInt(value);
        }
        if (type == 'date') {
          dateVar = new Date(value);
        }
        var payload = {
          odlList: odlList,
          typeClosingOdl: type,
          daysClosingValue: daysVar,
          dateClosingValue: dateVar
        };
        odlFactory().bulkClose(payload).$promise.then(function (data) {
          if (data.hasErrors || data.hasWarnings) {
            dialogService.serviceResponse('Esito', data, false);
          }
        })["catch"](function (response) {
          // error
        })["finally"](function (response) {
          $scope.getOdlList();
        });
      }, function (resp) {} // reject
      );
    } else {
      toaster.pop('warning', 'Nessuna selezione', 'Nessun ODL selezionato');
    }
  };

  /*** WATCH ***/
  $scope.$watchGroup(['bool.viewEstimateAssociated', 'bool.viewConsumptiveAssociated'], function () {
    localStorageService.set('odl_bool', $scope.bool);
    $scope.refresh();
  });

  /*** FILTRI ***/
  $scope.toggleAllOdl = function () {
    $scope.bool.allOdl = !$scope.bool.allOdl;
    localStorageService.set('odl_bool', $scope.bool);
    $scope.refresh();
  };
  $scope.addParentFilter = function () {
    $scope.assetTreeFilter.push({
      type: {},
      item: {},
      parents: {}
    });
  };
  $scope.removeParentFilter = function (k) {
    $scope.assetTreeFilter.splice(k, 1);
  };
  $scope.resetTreeFiltering = function () {
    $scope.assetTreeFilter = [];
    $scope.refresh();
  };
  $scope.buildformattedString = function () {
    var out = {};

    //filtri albero
    var parents = $scope.assetTreeFilter;
    var parentFilters = {};
    for (var p in parents) {
      if (angular.isDefined(parents[p].type.type_id)) {
        //filtro per includere tutti i nodi che hanno tra i parent la radice scelta
        var subfilters = {
          "p_type": sixFiltersLib.exact("parents.type", parents[p].type.type_id.UUID),
          "p_uuid": sixFiltersLib.exact("parents.UUID", parents[p].item.record_id.UUID)
        };
        parentFilters["descendants" + p] = sixFiltersLib.should({
          "nest_wrap": sixFiltersLib.nested("parents", subfilters)
        });

        //per includere anche la radice scelta tra i risultati
        var pfilter = {
          "type": sixFiltersLib.exact("schemaCode", parents[p].type.type_id.UUID),
          "uuid": sixFiltersLib.exact("UUID", parents[p].item.record_id.UUID)
        };
        parentFilters["root" + p] = sixFiltersLib.should(pfilter);
      }
    }
    if (Object.keys(parentFilters).length) {
      var assetWhitelist = ["azienda", "servizio"];
      for (var w in assetWhitelist) {
        //aggiungo gli asset in whitelist
        parentFilters["whitelist" + w] = sixFiltersLib.should({
          "whiteList": sixFiltersLib.exact("schemaCode", assetWhitelist[w])
        });
      }
      out["parents"] = sixFiltersLib.must(parentFilters);
      $scope.params.filters["assetSubtree"] = out;
    } else {
      $scope.params.filters["assetSubtree"] = undefined;
    }
  };

  /***** INIT *****/
  dashboardOdlColumnService.getConfiguredFields().then(function (result) {
    $scope.dashboardConfiguration['columns'] = result.fields;
    if (result.colorMapping) {
      $scope.dashboardConfiguration['colorMapping'] = result.colorMapping;
    }
    injectCss();
    $scope.getColumns();
    setTimeout(function () {
      if ($scope.params.sixApi) {
        $scope.params.sixApi.restoreState();
      }
    }, 500);
  });

  /******** funzioni di utility ***********/

  function filterResult(response) {
    var filteredList = [];
    if ($scope.bool.viewEstimateAssociated || $scope.bool.viewConsumptiveAssociated) {
      if ($scope.bool.viewEstimateAssociated) {
        response.filter(function (record) {
          return angular.isDefined(record.customer_estimates);
        }).forEach(function (e) {
          if (!filteredList.includes(e)) {
            filteredList.push(e);
          }
        });
      }
      if ($scope.bool.viewConsumptiveAssociated) {
        response.filter(function (record) {
          return angular.isDefined(record.consumptives);
        }).forEach(function (e) {
          if (!filteredList.includes(e)) {
            filteredList.push(e);
          }
        });
      }
    } else {
      filteredList = response;
    }
    return filteredList;
  }
  var PATH_ODL_DETAIL = 'odl';
  var PATH_PORTAL_ODL_DETAIL = 'portal/odl';
  $scope.getMessage = function (odl) {
    /* creazione testo mail */
    var searchInit = {
      search: {
        obj: {
          'username': authFactory.getAuthData().authId
        }
      },
      init: {
        authId: true,
        email: true
      }
    };
    if (angular.isDefined(odl.model.type_id) && angular.isDefined(odl.model.record_id)) {
      var promiseMailReceiver = odlFactory().getMailReceiver(odl).$promise;
      var promiseMailUser = userFactory.getMail(searchInit).$promise;
      Promise.all([promiseMailReceiver, promiseMailUser]).then(function (response) {
        // response[0] = promiseMailReceiver, response[1] = promiseMailUser
        var httpLink = 'http://' + $location.$$host + ':' + $location.$$port + (DEV ? '' : '/' + ENV) + '/#/' + PATH_ODL_DETAIL + '/' + odl.UUID;
        $scope.objMail = {
          title: 'ODL ' + odl.model.code + ' su asset ' + odl.model.type_id.description + ' - ' + odl.model.record_id.description,
          to: formatMailReceiver(response[0]),
          cc: formatMailCc(response[1].list[0].email),
          message: 'ODL <b>' + odl.model.code + '</b> su asset <b>' + odl.model.type_id.description + '</b> - <b>' + odl.model.record_id.description + '</b><br /><br />' + 'Dettagli ODL:<br />' + '<i>Codice</i>: <b>' + odl.model.code + '</b> (link: ' + httpLink + ')' + '<br />' + '<i>Tipo elemento tecnologico</i>: (<i>cod.</i>) <b>' + getText(odl.model.type_id, 'code') + '</b> - (<i>descr.</i>) <b>' + getText(odl.model.type_id, 'description') + '</b><br />' + '<i>Elemento tecnologico</i>: (<i>cod.</i>) <b>' + getText(odl.model.record_id, 'code') + '</b> - (<i>descr.</i>) <b>' + getText(odl.model.record_id, 'description') + '</b><br />' + '<i>Segnalazione di riferimento</i>: (<i>cod.</i>) ' + getText(odl.issue_id, 'code') + ' - (<i>descr.</i>) ' + getText(odl.issue_id, 'description') + '<br />' + '<i>Tipo</i>: ' + getText(odl.model.odltype_id, 'description') + '<br />' + '<i>Servizio</i>: ' + getText(odl.model.service_id, 'description') + '<br />' + '<i>Priorità</i>: ' + getText(odl.model.priority_id, 'description') + '<br /><br />' + '<i>Oggetto</i>: ' + getText(odl.model, 'title') + '<br />' + '<i>Note</i>: ' + getText(odl.model, 'description') + '<br /><br />'
        };
      });
    } else {
      $scope.objMail = {
        title: '',
        to: '',
        cc: '',
        message: ''
      };
      toaster.pop('error', 'Errore', 'Creazione della mail precompilata non riuscita.');
    }
  };
  function getText(ref, element) {
    if (angular.isDefined(ref) && ref != null) {
      if (angular.isDefined(ref[element]) && ref[element] != null) {
        return ref[element];
      }
    }
    return '';
  }
  ;
  function formatMailReceiver(array) {
    /* from array to formatted string with comma */
    if (angular.isDefined(array.result)) {
      if (array.result.length != 0) {
        var strConcat = '';
        for (var i = 0; i < array.result.length; i++) {
          if (i == 0) {
            strConcat = array.result[i];
          } else {
            strConcat = strConcat + ', ' + array.result[i];
          }
        }
        return strConcat;
      } else {
        return '';
      }
    } else {
      return '';
    }
  }
  ;
  function formatMailCc(UserMailSix) {
    if (UserMailSix) {
      return UserMailSix;
    } else {
      return null;
    }
  }
  ;
  function recursiveReplace(obj, regexpString, replace) {
    var keys = Object.keys(obj);
    keys.forEach(function (key) {
      var value = obj[key];
      if (typeof value === 'string') {
        obj[key] = value.replace(new RegExp(regexpString, 'g'), replace);
      } else if (_typeof(value) === 'object') {
        recursiveReplace(obj[key], regexpString, replace);
      }
    });
  }
  ;
  function detectPrice(list) {
    var approved_status = 'approved';
    if (typeof list == 'undefined' || list.length == 0) {
      return '';
    }
    var content = '<span class="badge primary pull-right">' + list.length + '</span>';
    if (list.length == 1) {
      var status = list[0].model.status == approved_status ? '<i class="fa fa-check"></i> ' : '';
      content += status + formatPrice(list[0].model.total);
    } else {
      //cerco il primo approvato
      list.forEach(function (item) {
        if (item.model.status == approved_status) {
          var status = '<i class="fa fa-check"></i> ';
          content += status + formatPrice(item.model.total);
          return; //termino il foreach
        }
      });
    }

    return content;
  }
  function formatPrice(num) {
    if (num) {
      num = Math.round(num * 100) / 100;
      num = num.toFixed(2);
    }
    return num ? num.toString().replace(/\./g, ',') + ' €' : '--';
  }
  ;
  function getReadableType(type) {
    switch (type) {
      case 'issue':
        return 'Segnalazione';
      case 'plan':
        return 'Programmata';
      default:
        return 'Sconosciuta';
    }
  }
  ;
  function getReadableUser(odl) {
    if (odl.userinfo) {
      return odl.userinfo.description;
    } else {
      return odl.user;
    }
  }
  ;

  /** STAMPA **/
  $scope.printSelectedOdl = function () {
    var odlList = $scope.params.gridApi.selection.getSelectedRows();
    var userFilter = {
      'model.username': sixFiltersLib.exact('model.username', authFactory.getAuthData().authId)
    };
    if (odlList && odlList.length > 0) {
      var notifyToDialog = ngDialog.openConfirm({
        name: 'notifyToDialog',
        closeByDocument: false,
        showClose: true,
        template: '' + '<div style="text-align:center">' + 'Invia una notifica di completamento al seguente indirizzo:<br>' + '<input class="form-control" id="dialog_notify_to" type="email" ng-model="notifyTo" value="test@example.net">' + '</div>' + '<div style="text-align:center">' + '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ng-click="confirm()">OK</button>' + '</div>',
        plain: true,
        className: 'ngdialog-theme-default ngdialog-theme-custom'
      });
      recordFactory('operatore').search(userFilter).$promise.then(function (resp) {
        if (resp.list) {
          document.getElementById("dialog_notify_to").value = resp.list[0].model.mail;
        }
      });
      notifyToDialog.then(function () {
        // success
        var notifyTo = document.getElementById("dialog_notify_to").value;
        var payload = [];
        var REPORT_URL = 'reports/EMMA/Asset/';
        for (var i in odlList) {
          var report = odlList[i].generated_by == 'plan' ? 'plan' : 'odl';
          var extension = 'pdf';
          var query = '&uuid=' + odlList[i].UUID + '&commission=' + currentCommission.code;
          var filename = 'odl_' + odlList[i].model.code + '.' + extension;
          var reportPaths = [
          //report specifico commessa + fallback
          REPORT_URL + report + '_' + currentCommission.code + '.' + extension, REPORT_URL + report + '.' + extension];
          payload.push({
            path: reportPaths,
            query: query,
            filename: filename
          });
        }
        var promise = $http.post(APP_URL + '/rest/report/generate-many?notifyTo=' + notifyTo, payload);
        promise.success(function (data, status, headers, config) {
          if (status == 202) {
            toaster.pop('success', 'Elaborazione avviata', 'Elaborazione avviata, riceverai una email al completamento.');
          }
        });
      }, function (resp) {} // reject
      );
    } else {
      toaster.pop('warning', 'Nessuna selezione', 'Nessun ODL selezionato');
    }
  };

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'odl';
  $scope.isWritePermAllowed = isWritePermAllowed;
  $scope.isDeletePermAllowed = isDeletePermAllowed;
  $scope.searchAllPermAllowed = searchAllPermAllowed;
  function isWritePermAllowed() {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  }
  ;
  function isDeletePermAllowed() {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  }
  ;
  function searchAllPermAllowed() {
    return authFactory.checkPerm(RESOURCE_NAME, 'SEARCH_ALL');
  }
  ;
}]);
'use strict';

angular.module('emma.plan').controller('issueDetailsCtrl', ['$scope', '$log', 'issueFactory', 'toaster', function ($scope, $log, issueFactory, toaster) {
  /**** CONSTANTS ****/

  var PATH_ISSUE_SCHEMA = 'issue/schema';
  var PATH_ISSUE_RECORD = 'issue/record';
  var STABLE = 'stable',
    SNAP = 'snap';
  $scope.commissionDependent = true;
  $scope.schemaIssueDefined = false;
  $scope.typeName = 'issue';
  if (angular.isUndefined($scope.sxShowWatchers)) {
    $scope.sxShowWatchers = true;
  }
  if (angular.isUndefined($scope.sxShowReferencesAssignee)) {
    $scope.sxShowReferencesAssignee = true;
  }
  if (angular.isUndefined($scope.sxShowResponsableList)) {
    $scope.sxShowResponsableList = true;
  }
  if (angular.isUndefined($scope.sxShowCustomerInfo)) {
    $scope.sxShowCustomerInfo = false;
  }

  // Gestione allegati
  $scope.attachments = [];
  function readAttachments(modelList) {
    $scope.attachments.splice(0, $scope.attachments.length);
    for (var i = 0; i < modelList.length; i++) {
      $scope.attachments.push(modelList[i]);
    }
  }
  function writeAttachments(modelList) {
    modelList.splice(0, modelList.length);
    for (var i = 0; i < $scope.attachments.length; i++) {
      modelList.push($scope.attachments[i]);
    }
  }
  $scope.updAttachments = function () {
    writeAttachments($scope.sxIssue.model.attachments);
    issueFactory(PATH_ISSUE_RECORD).update({
      id: $scope.sxIssue.version
    }, $scope.sxIssue).$promise.then(function (response) {
      if (response.version) {
        $scope.sxIssue.version = response.version;
      }
    });
  };
  $scope.isSnapshot = function () {
    return $scope.historyMode == SNAP;
  };

  /*** PARTE ISSUE ***/

  $scope.getIssueById = function (itemId) {
    if (itemId == 'new') {
      $scope.isNew = true;
    } else {
      $scope.isNew = false;
      issueFactory(PATH_ISSUE_RECORD + "/_uuid/" + itemId).getUUID().$promise.then(function (response) {
        if (response) {
          $scope.sxIssue = response;
          // TO FIX: vedere come risolvere la gestione delle date
          fixDates();
          // FINE DELLA PARTE DA FIXARE
          if (angular.isUndefined($scope.sxIssue.model.attachments)) {
            $scope.sxIssue.model.attachments = [];
          }
          readAttachments($scope.sxIssue.model.attachments);
        }
      });
    }
  };
  $scope.getSchemaIssue = function () {
    issueFactory(PATH_ISSUE_SCHEMA).schemaOrDefault().$promise.then(function (data) {
      if (data.model) {
        $scope.schemaIssueDefined = true;
        $scope.sxSchema = data.model;
      } else {
        $scope.schemaIssueDefined = false;
        toaster.pop('error', 'Errore caricamento pagina', 'Nessun modello salvato per il tipo \'segnalazione\'.');
      }
    });
  };
  $scope.sendMessage = function () {
    $location.path('wysiwyg');
  };
  function fixDates() {
    if ($scope.sxIssue.date_insertion != null) {
      $scope.sxIssue.date_insertion = new Date($scope.sxIssue.date_insertion);
    }
    if ($scope.sxIssue.date_handling != null) {
      $scope.sxIssue.date_handling = new Date($scope.sxIssue.date_handling);
    }
    if ($scope.sxIssue.date_requested != null) {
      $scope.sxIssue.date_requested = new Date($scope.sxIssue.date_requested);
    }
    if ($scope.sxIssue.date_closing != null) {
      $scope.sxIssue.date_closing = new Date($scope.sxIssue.date_closing);
    }
  }
  $scope.getMessage = function () {
    if (angular.isDefined($scope.sxIssue.model.type_id) && angular.isDefined($scope.sxIssue.model.record_id)) {
      var promise = issueFactory(PATH_ISSUE_RECORD).getMailReceiver($scope.sxIssue).$promise;
      promise.then(function (response) {
        $scope.objMail = {
          title: 'Apertura Segnalazione su asset: ' + $scope.sxIssue.model.type_id.description + ' - ' + $scope.sxIssue.model.record_id.description,
          receiver: formatMailReceiver(response),
          message: '<h2>Apertura segnalazione su asset: ' + $scope.sxIssue.model.type_id.description + ' - ' + $scope.sxIssue.model.record_id.description + ' </h2>' + '<br/>' + '<p style="font-size:12px">Dati tipo elem. tecnologico: (cod.) ' + getText($scope.sxIssue.model.type_id, 'code') + ' - (descr.) ' + getText($scope.sxIssue.model.type_id, 'description') + '</p>' + '<p style="font-size:12px">Dati elem. tecnologico: (cod.) ' + getText($scope.sxIssue.model.record_id, 'code') + ' - (descr.) ' + getText($scope.sxIssue.model.record_id, 'description') + '</p>' + '<p style="font-size:12px">Tipo segnalazione: ' + getText($scope.sxIssue.model.issuetype_id, 'description') + '</p>' + '<p style="font-size:12px">Servizio richiesto: ' + getText($scope.sxIssue.model.service_id, 'description') + '</p>' + '<p style="font-size:12px">Priorità: ' + getText($scope.sxIssue.model.priority_id, 'description') + '</p>' + '<p style="font-size:12px">Descrizione segnalazione: ' + getText($scope.sxIssue.model, 'description') + '</p><br/>' + '<p style="font-size:12px">Note aggiuntive: ' + getText($scope.sxIssue.model, 'note') + '</p>'
        };
      });
    } else {
      toaster.pop('error', 'Errore', 'Creazione della mail precompilata non riuscita.');
    }
  };
  function getText(ref, element) {
    if (angular.isDefined(ref) && ref != null) {
      if (angular.isDefined(ref[element]) && ref[element] != null) {
        return ref[element];
      }
    }
    return '';
  }
  function formatMailReceiver(array) {
    /* from array to formatted string with comma */
    if (angular.isDefined(array.result)) {
      if (array.result.length != 0) {
        var strConcat = '';
        for (var i = 0; i < array.result.length; i++) {
          if (i == 0) {
            strConcat = array.result[i];
          } else {
            strConcat = strConcat + ', ' + array.result[i];
          }
        }
        return strConcat;
      } else {
        return '';
      }
    } else {
      return '';
    }
  }
  function _init() {
    // schema
    if (!$scope.sxSchema) {
      $scope.getSchemaIssue();
    }

    // issue
    if ($scope.sxIssue) {
      fixDates();
    } else if ($scope.sxUuid) {
      $scope.getIssueById($scope.sxUuid);
    } else {
      toaster.pop('error', 'Errore', 'Non è stata trovata nessuna issue');
    }
  }
  $scope.$watchGroup(['sxIssue', 'sxUuid'], function (newVal, oldVal) {
    if (newVal[0] || newVal[1]) {
      _init();
    }
  });
}]);

/**
 * @ngdoc directive
 * @name sixEmmaApp.directive:issueTab
 * @description
 * # issueTab
 */
angular.module('emma.plan').directive('issueDetails', function () {
  return {
    templateUrl: 'plan/directives/issuedetails.html',
    restrict: 'E',
    scope: {
      sxUuid: '=?',
      sxIssue: '=?',
      sxSchema: '=?',
      sxShowCustomerInfo: '=?',
      sxShowWatchers: '=?',
      // parametro per mostrare i watchers, se non definito -> i watchers vengono mostrati
      sxShowReferencesAssignee: '=?',
      // parametro per mostrare i tecnici/assegnatari, se non definito -> i watchers vengono mostrati
      sxShowResponsableList: '=?' // parametro per mostrare la lista dei contatti dei "responsabili da poter contattare"
    },

    controller: 'issueDetailsCtrl'
  };
});
'use strict';

angular.module('emma.plan').controller('issueTabCtrl', ['$scope', '$log', 'toaster', 'dialogService', 'issueWorkflow', function ($scope, $log, toaster, dialogService, issueWorkflow) {
  if (angular.isUndefined($scope.sxShowStatus)) {
    $scope.sxShowStatus = true;
  }
  if (angular.isUndefined($scope.sxShowButtons)) {
    $scope.sxShowButtons = true;
  }
  $scope.list = [];
  $scope.getStatuses = function () {
    /* chiamata per recuperare gli stati */
    issueWorkflow.getNextStatuses($scope.sxStatus).then(function (response) {
      if (Array.isArray(response)) {
        $scope.list = response;
        $scope.sxStatusLabel = issueWorkflow.getReadableStatus($scope.sxStatus);
      }
    });
  };
  $scope.statusNoteDialog = function (code) {
    dialogService.fillTextField('Note per passaggio di stato', function (status_note) {
      $scope.setOperation(code, status_note);
    });
  };
  $scope.setOperation = function (code, status_note) {
    console.log("UUID: " + $scope.sxUuid + " --> passa a: " + code);
    if (status_note != "") {
      $scope.sxObject.status_note = status_note;
    }
    if (!angular.isDefined($scope.sxUuid)) {
      toaster.pop('error', 'Errore', 'Salvare il documento prima di effettuare il passaggio di stato');
    } else {
      issueWorkflow.setStatus(code, $scope.sxObject).then(function (updatedObject) {
        //success
        $scope.sxObject = updatedObject;
        if ($scope.sxCallback && angular.isFunction($scope.sxCallback)) {
          $scope.sxCallback();
        }
      }, function () {
        //error
        toaster.pop('error', 'Errore', 'Passaggio di stato fallito');
      });
    }
  };
  $scope.$watch('sxStatus', function (newVal, oldVal) {
    if (newVal && newVal != oldVal) {
      $scope.getStatuses();
    }
  });
}]);

/**
 * @ngdoc directive
 * @name sixEmmaApp.directive:issueTab
 * @description
 * # issueTab
 */
angular.module('emma.plan').directive('issueTab', function () {
  return {
    template: '<div class="input-group has-button m-t" style="width: 100%; display: inline;">' + '<div style="display: inline; margin-left: 30px; margin-right: 30px;" ng-show="sxShowStatus">' + '<span class="btn btn-sm btn-bg btn-default font-bold" style="pointer-events: none;" ng-show="sxStatus">{{sxStatusLabel}}</span>' + '</div>' + '<ui-select ng-show="sxShowButtons && list.length" ng-model="sxStatus" on-select="statusNoteDialog($item.code)" ' + 'style="display: inline-block; vertical-align: middle; position: relative; min-width: 160px;">' + '<ui-select-match class="ui-select-match" placeholder="Cambia Stato">Cambia Stato</ui-select-match>' + '<ui-select-choices class="ui-select-choices" repeat="status in list track by $index">' + '<span class="{{status.style}}" ng-bind-html="status.label"></span>' + '</ui-select-choices>' + '</ui-select>' + '</div>',
    restrict: 'E',
    scope: {
      sxObject: '=',
      sxBasePath: '=',
      sxStatus: '=',
      sxUuid: '=',
      sxShowStatus: '<?',
      sxShowButtons: '<?',
      sxCallback: '&'
    },
    controller: 'issueTabCtrl'
  };
});
'use strict';

angular.module('emma.plan').controller('odlTabCtrl', ['$scope', '$log', 'toaster', 'dialogService', 'odlWorkflow', function ($scope, $log, toaster, dialogService, odlWorkflow) {
  var cachedVal = null;
  if (angular.isUndefined($scope.sxShowStatus)) {
    $scope.sxShowStatus = true;
  }
  if (angular.isUndefined($scope.sxShowButtons)) {
    $scope.sxShowButtons = true;
  }
  $scope.list = [];
  $scope.getStatuses = function () {
    /* chiamata per recuperare gli stati */
    odlWorkflow.getNextStatuses($scope.sxStatus).then(function (response) {
      if (Array.isArray(response)) {
        $scope.list = response;
        $scope.sxStatusLabel = odlWorkflow.getReadableStatus($scope.sxStatus);
        cachedVal = $scope.sxStatus;
      }
    });
  };
  $scope.statusNoteDialog = function (code) {
    dialogService.fillTextField('Note per passaggio di stato', function (status_note) {
      $scope.setOperation(code, status_note);
    });
  };
  $scope.setOperation = function (code, status_note) {
    console.log("UUID: " + $scope.sxUuid + " --> passa a: " + code);
    if (status_note != "") {
      $scope.sxObject.status_note = status_note;
    }
    if (!angular.isDefined($scope.sxUuid)) {
      toaster.pop('error', 'Errore', 'Salvare il documento prima di effettuare il passaggio di stato');
    } else {
      odlWorkflow.setStatus(code, $scope.sxObject).then(function (updatedObject) {
        //success
        $scope.sxObject = updatedObject;
        if ($scope.sxCallback && angular.isFunction($scope.sxCallback)) {
          $scope.sxCallback();
        }
      }, function () {
        //error
        toaster.pop('error', 'Errore', 'Passaggio di stato fallito');
      });
    }
  };
  $scope.$watch('sxStatus', function (newVal, oldVal) {
    if (newVal && (newVal != oldVal || newVal != cachedVal)) {
      $scope.getStatuses();
    }
  });
}]);

/**
 * @ngdoc directive
 * @name sixEmmaApp.directive:odlTab
 * @description
 * # odlTab
 */
angular.module('emma.plan').directive('odlTab', function () {
  return {
    template: '<div class="input-group has-button" style="width: 100%; display: inline;">' + '<div style="display: inline-block; margin-left: 30px; margin-right: 30px;" ng-show="sxShowStatus">' + '<span class="btn btn-sm btn-bg btn-default font-bold" style="pointer-events: none;" ng-show="sxStatus">{{sxStatusLabel}}</span>' + '</div>' + '<ui-select ng-show="sxShowButtons && list.length" ng-model="sxStatus" on-select="statusNoteDialog($item.code)" ' + 'style="display: inline-block; vertical-align: middle; position: relative; min-width: 160px;">' + '<ui-select-match class="ui-select-match" placeholder="Cambia Stato">Cambia Stato</ui-select-match>' + '<ui-select-choices class="ui-select-choices" repeat="status in list track by $index">' + '<span class="{{status.style}}" ng-bind-html="status.label"></span>' + '</ui-select-choices>' + '</ui-select>' + '</div>',
    restrict: 'E',
    scope: {
      sxObject: '=',
      sxBasePath: '=',
      sxStatus: '=',
      sxUuid: '=',
      sxShowStatus: '=?',
      sxShowButtons: '=?',
      sxCallback: '&'
    },
    controller: 'odlTabCtrl'
  };
});
'use strict';

angular.module('emma.plan').controller('pdfReportViewerCtrl', ['$scope', '$element', 'pdfDelegate', function ($scope, $element, pdfDelegate) {
  var containerWidth = $element[0].getElementsByClassName('pdf-preview')[0].clientWidth;
  var prevScale = 1;
  $scope.loaded = false;
  $scope.$watch('load', function (newVal, oldVal) {
    if (newVal.length || newVal.byteLength) {
      pdfDelegate.$getByHandle('report-preview').load(newVal).then(function () {
        $scope.loaded = true;
        $element.find('canvas').eq(0).css("width", "100%");
        setTimeout(function () {
          //timeout per attendere il rendering della pagina
          //FIXME: usare un componente diverso o modificare l'attuale per avere un evento di fine rendering
          var canvasWidth = $element.find('canvas').eq(0).attr("width");
          var newScale = containerWidth / (canvasWidth / prevScale);
          var zoomTo = newScale ? newScale : prevScale;
          pdfDelegate.$getByHandle('report-preview').zoomTo(zoomTo);
          prevScale = zoomTo;
        }, 1000);
      });
    }
  });
  $scope.currentPage = 1;
  $scope.pageCount = function () {
    return pdfDelegate.$getByHandle('report-preview').getPageCount();
  };
  $scope.pageChanged = function () {
    pdfDelegate.$getByHandle('report-preview').goToPage($scope.currentPage);
  };
}]);

/**
 * @ngdoc directive
 * @name sixEmmaApp.directive:pdfReportViewer
 * @description
 * # pdfReportViewer
 */
angular.module('emma.plan').directive('pdfReportViewer', function () {
  return {
    template: '<div class="pdf-preview text-center" style="width: 100%; overflow: auto; border: 15px solid transparent; padding: 0;">\
            <pdf-viewer ng-show="loaded" delegate-handle="report-preview" show-toolbar="false"></pdf-viewer>\
            <ul ng-show="pageCount()>1" uib-pagination total-items="pageCount()" ng-model="currentPage" ng-change="pageChanged()" previous-text="&lsaquo;" next-text="&rsaquo;"></ul>\
         </div>',
    restrict: 'E',
    scope: {
      load: '='
    },
    controller: 'pdfReportViewerCtrl'
  };
});
/**
 * Created by luca on 07/04/17.
 */

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:EstimateCtrl
 * @description
 * # EstimateCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan')
// type può essere 'customer' per i clienti, 'manager' per i dipendenti di manager
.config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/estimate/:type', {
    templateUrl: 'plan/estimate/estimate_list.html',
    controller: 'EstimateCtrl'
  }).when('/estimate/:type/:id', {
    templateUrl: 'plan/estimate/estimate_detail.html',
    controller: 'EstimateCtrl'
  });
}]).controller('EstimateCtrl', ["$scope", "consipWrapper", "authFactory", "$routeParams", "$log", "$q", "$timeout", "$location", "schemaFactory", "estimateFactory", "uiGridConstants", "dialogService", "recordFactory", "ngDialog", "pipeEstimatePromote", "pipeConsumptive", "toaster", "$http", "SaveAs", "APP_URL", "sixGridPaginationConstants", function ($scope, consipWrapper, authFactory, $routeParams, $log, $q, $timeout, $location, schemaFactory, estimateFactory, uiGridConstants, dialogService, recordFactory, ngDialog, pipeEstimatePromote, pipeConsumptive, toaster, $http, SaveAs, APP_URL, sixGridPaginationConstants) {
  $scope.currentCommission = authFactory.getAuthData().info.commissions.current;
  $scope.isNew = false; // indica se il record inserito è nuovo o meno
  $scope.isCompliant = true; // booleano che indica se il totale è conforme
  $scope.schemaHeader = {}; // contenitore schema-form testata
  $scope.schemaRow = {}; // contenitore schema-form riga
  $scope.requiredField = {}; // contenitore con i campi obbligatori per la grid
  $scope.modifiedList = []; // righe modifiche -> update
  $scope.deletedList = []; // righe eliminate -> delete
  $scope.insertedList = []; // righe inserite  -> save
  $scope.currentIndexRow = 0; // indice contatore delle righe: per individuare univocamente ogni riga
  $scope.estimateList = {
    list: []
  }; // lista con tutte le testate
  $scope.findCross = false; // ricerca cross-commessa
  $scope.typeExport = 'export'; // tipo di esportazione
  $scope.rowPositionTotal = undefined; // posizione colonna con il totale nella grid
  $scope.type = 'customer'; // tipo di visualizzazione per la pagina: 'customer' o 'manager'
  $scope.editable = false;
  $scope.plafond = false;
  $scope.isPlafondEnabled = false;
  if ($routeParams.type) {
    $scope.type = $routeParams.type;
    $scope.editable = $routeParams.type == 'manager';
  }
  $scope.bool = {
    // pagina di lista: variabili booleane per filtrare i preventivi
    showSupplier: true,
    showCustomer: true
  };
  $scope.params = {
    // param. tabella: paginazione e filtri
    pageNumber: 1,
    pageSize: 100,
    filters: {}
  };
  $scope.autoResizeParams = {
    // param. tabella: pagina di lista con le testate dei preventivi
    enabled: true,
    minHeight: 200,
    marginTop: 290
  };
  $scope.data = {
    // dato preventivo
    header: {
      model: {
        attachments: []
      }
    },
    rows: []
  };
  $scope.modelLoaded = false;
  $scope.gridOptions = {
    // righe preventivo
    xlsData: [],
    data: $scope.data.rows,
    columnDefs: [],
    showColumnFooter: true,
    importerDataAddCallback: function importerDataAddCallback(grid, newObjects) {},
    onRegisterApi: onRegisterApiCallback
  };
  function onRegisterApiCallback(gridApi) {
    $scope.gridApi = gridApi;
    gridApi.edit.on.afterCellEdit($scope, afterCellEditCallback);
    gridApi.rowEdit.on.saveRow($scope, onSaveRowCallback);
  }
  $scope.viewGridOptions = {
    enableSorting: true,
    enableGridMenu: false,
    exporterCsvColumnSeparator: ';',
    exporterSuppressColumns: ['id', 'timeline'],
    exporterMenuPdf: false,
    enableFiltering: true,
    enableColumnResizing: true,
    paginationPageSizes: [100, 250, 500, 1000, 10000],
    paginationPageSize: 100,
    useExternalPagination: true,
    useExternalFiltering: true,
    multiSelect: false,
    enableRowHeaderSelection: true,
    enableRowSelection: true,
    enableHorizontalScrollbar: 1,
    columnDefs: [{
      name: ' '
    }]
  };

  /* PLAFOND */

  consipWrapper.isPlafondEnabled().then(function (enabled) {
    $scope.isPlafondEnabled = enabled;
  }, $log.error);
  $scope.plafondChange = function (plafond) {
    $scope.plafond = plafond;
    checkPlafondLimit();
  };
  $scope.$watch("data.header.model.total", checkPlafondLimit);
  var checkPlafondLimitBuffer;
  function checkPlafondLimit() {
    if (checkPlafondLimitBuffer) {
      $timeout.cancel(checkPlafondLimitBuffer);
    }
    checkPlafondLimitBuffer = $timeout(function () {
      if ($scope.isPlafondEnabled && $scope.editable && angular.isObject($scope.plafond)) {
        if ($scope.plafond.residual < $scope.data.header.model.total) {
          toaster.pop("warning", "", "Il plafond residuo è inferiore al totale inserito");
        } else if ($scope.plafond.residual - $scope.plafond.constrain < $scope.data.header.model.total) {
          toaster.pop("warning", "", "Il plafond impegnato è maggiore di quello residuo");
        }
      }
    }, 500);
  }

  /** MODIFICA RIGA */

  function onSaveRowCallback(rowEntity) {
    var promise = $q.defer();
    $scope.gridApi.rowEdit.setSavePromise(rowEntity, promise.promise);
    promise.resolve();
  }
  function afterCellEditCallback(rowEntity) {
    for (var field in rowEntity.model) {
      // pulisco la riga da campi vuoti
      if (rowEntity.model.hasOwnProperty(field) && rowEntity.model[field] == "") {
        delete rowEntity.model[field];
      }
    }
    if (rowEntity.UUID) {
      if (!isItemInArrayByCode($scope.modifiedList, rowEntity)) {
        $scope.modifiedList.push(rowEntity);
      }
    }
    $scope.addDataToGrid([rowEntity]);
  }

  /** DELETE RIGA */

  $scope.deleteRow = function (item) {
    var index = $scope.data.rows.indexOf(item.entity);
    if (index > -1) {
      $scope.data.rows.splice(index, 1);
      /* gestione per mod/elim/agg righe nuove sul preventivo */
      if (item.entity.UUID) {
        $scope.deletedList.push(item.entity);
        if (isItemInArrayByCode($scope.modifiedList, item.entity)) {
          deleteItemInArrayByCode($scope.modifiedList, item.entity);
        }
      } else {
        if (isItemInArrayByCode($scope.insertedList, item.entity)) {
          deleteItemInArrayByCode($scope.insertedList, item.entity);
        }
      }
    }
  };

  /** INSERT RIGA */

  $scope.insertRow = function () {
    if ($scope.gridOptions.columnDefs.length == 0) {
      $scope.gridOptions.columnDefs = getColumnDefsGridFull();
    }
    var row = {
      sixImportStatus: 'NEW',
      model: {
        code: 'index_row_' + $scope.currentIndexRow
      }
    };
    $scope.currentIndexRow++;
    $scope.data.rows.push(row);
    $scope.insertedList.push(row);
  };

  /** IMPORT RIGA (EXCEL) */

  $scope.$watch(function () {
    return $scope.gridOptions.xlsData;
  }, function (newValue) {
    if (newValue && newValue.length > 0) {
      $scope.setDataFromXlsToGrid($scope.gridOptions.xlsData);
    }
  });

  /* da array excel -> ad array di oggetti (con solo model) */
  $scope.setDataFromXlsToGrid = function (xlsArray) {
    var rowArray = [];
    xlsArray.forEach(function (xlsRow) {
      xlsRow.code = 'index_row_' + $scope.currentIndexRow; // codice di default
      var row = {
        model: xlsRow,
        sixImportStatus: 'OK'
      };
      $scope.currentIndexRow++;
      rowArray.push(row);
    });
    $scope.addDataToGrid(rowArray);
  };

  /** CONTROLLO RIGHE + AGGIUNTA AL PREVENTIVO */

  // le righe passate in 'arrayToImport' vengono controllate -> poi aggiunte alla grid
  // se le righe sono già state inserite -> vengono aggiornate, se le tighe sono nuove -> vengono inserite
  $scope.addDataToGrid = function (arrayToImport) {
    console.log('Controllo e preprocesso i dati');
    $scope.gridOptions.columnDefs = getColumnDefsGridFull();
    var properties = $scope.schemaRow.model.schema.properties;
    var lookups = [];
    var arrays = [];
    var numbers = [];
    var booleans = [];
    for (var key in properties) {
      if (properties[key]) {
        if (properties[key].format == 'lookup' && properties[key].entity_id) {
          lookups.push(key);
        } else if (properties[key].type == 'array') {
          arrays.push(key);
        } else if (properties[key].type == 'integer' || properties[key].type == 'number') {
          numbers.push(key);
        } else if (properties[key].type == 'boolean') {
          booleans.push(key);
        }
      }
    }
    function parseBoolean(value) {
      var lower = value.toLowerCase();
      return lower === 'vero' || lower === 'v' || lower === 'true' || lower === 't' || lower === 'si' || lower === 's';
    }
    var indexMapToResolve = {
      record: {}
    };
    arrayToImport.forEach(function (row) {
      for (var l in lookups) {
        (function () {
          var k = lookups[l];
          var v = row.model[k];
          if (!angular.isUndefined(v)) {
            // se ho già una lookup -> prendo il code e controllo che venga risolto
            if (v['code'] && v['UUID'] && v['type'] && v['description']) {
              v = v['code'];
            }
            var mapToResolve = {};
            if (angular.isUndefined(properties[k].basePath)) {
              mapToResolve = indexMapToResolve.record;
            } else {
              if (properties[k].basePath in indexMapToResolve) {
                mapToResolve = indexMapToResolve[properties[k].basePath];
              } else {
                indexMapToResolve[properties[k].basePath] = {};
                mapToResolve = indexMapToResolve[properties[k].basePath];
              }
            }
            var innerMap;
            if (properties[k].entity_id in mapToResolve) {
              innerMap = mapToResolve[properties[k].entity_id];
              innerMap[v] = '';
            } else {
              mapToResolve[properties[k].entity_id] = {};
              innerMap = mapToResolve[properties[k].entity_id];
              innerMap[v] = '';
            }
          }
        })();
      }
      arrays.forEach(function (a) {
        if (row.model[a]) {
          row.model[a] = row.model[a].replace(/[“”']/g, '"');
          row.model[a] = JSON.parse(row.model[a]);
        }
      });
      numbers.forEach(function (n) {
        if (row.model[n]) {
          row.model[n] = parseFloat(row.model[n]);
        }
      });
      booleans.forEach(function (b) {
        if (row.model[b]) {
          row.model[b] = parseBoolean(row.model[b]);
        }
      });
    });
    for (var index in indexMapToResolve) {
      var mapToResolve = indexMapToResolve[index];
      var promise;
      if (index === 'record') {
        promise = recordFactory('type').bulkResolve(mapToResolve).$promise;
      }
      promise.then(function (data) {
        $log.info(data);
        arrayToImport.forEach(function (row) {
          if (index === 'record') {
            row['sixImportStatus'] = 'OK';
          }
          for (var l in lookups) {
            (function () {
              //closure <3
              var k = lookups[l];
              var v = row.model[k];
              if (!angular.isUndefined(v) && v !== null) {
                // se ho già una lookup -> prendo il code e controllo che venga risolto
                if (v['code'] && v['UUID'] && v['type'] && v['description']) {
                  v = v['code'];
                }
                var resolved = data[properties[k].entity_id];
                if (resolved) {
                  var ref;
                  if (properties[k].hasOwnProperty('multiple') && properties[k].multiple == true) {
                    // lookup multipla
                    row.model[k] = [];
                    for (var res in resolved) {
                      if (resolved.hasOwnProperty(res)) {
                        ref = sixObjectLib.recordToHisRef(resolved[res]);
                        if (!ref) {
                          if (row['sixImportStatus'] == 'OK') row['sixImportStatus'] = '';
                          row['sixImportStatus'] = row['sixImportStatus'].concat(k + ' (' + properties[k].entity_id + ') array di lookup non risolto; ');
                        } else {
                          row.model[k].push(ref);
                        }
                      }
                    }
                  } else {
                    ref = sixObjectLib.recordToHisRef(resolved[v]);
                    if (!ref) {
                      if (row['sixImportStatus'] == 'OK') row['sixImportStatus'] = '';
                      row['sixImportStatus'] = row['sixImportStatus'].concat(k + ' (' + properties[k].entity_id + ') ' + v + ' non trovato; ');
                    } else {
                      row.model[k] = ref;
                    }
                  }
                }
              }
            })();
          }
          var isNewRow = true; // riga con quel codice -> sostituisco, altrimenti -> push
          for (var i = 0; i < $scope.data.rows.length; i++) {
            if ($scope.data.rows[i].model.code == row.model.code) {
              isNewRow = false;
              $scope.data.rows[i] = row;
            }
          }
          if (isNewRow) {
            $scope.data.rows.push(row); // se è una riga nuova la aggiungo alla grid
            if (!row.version) {
              // se non ha la versione e anche da mandare alla "_save"
              $scope.insertedList.push(row);
            }
          }
        });
      });
    }
  };

  /** COLONNE TABELLA */

  function getColumnDefsGridFull() {
    var array = [];
    array.push({
      field: 'sixImportStatus',
      enableCellEdit: false,
      enableHiding: false,
      cellTemplate: '<div class="ui-grid-cell-contents" ng-class="{ newclass: grid.appScope.rowIsNew(row), errorclass: grid.appScope.rowInError(row) }">' + '{{row.entity.sixImportStatus}}' + '</div>'
    });
    angular.forEach($scope.schemaRow.model.form, function (fValue) {
      angular.forEach(fValue.items, function (iValue) {
        angular.forEach(iValue.tabs, function (tValue) {
          angular.forEach(tValue.items, function (itemsValue) {
            var name = itemsValue.key[0];
            if (name != 'code' && name != 'description') {
              var property = $scope.schemaRow.model.schema.properties[name];
              var col = {
                displayName: property.title,
                field: 'model.' + name,
                enableCellEdit: true,
                enableFiltering: false,
                enableSorting: false,
                enableHiding: false,
                cellTemplate: '<div class="ui-grid-cell-contents" ng-if="row.entity.model[\'' + name + '\']" ng-class="{newclass: grid.appScope.rowIsNew(row), errorclass: grid.appScope.rowInError(row), requiredclass: grid.appScope.fieldIsRequired(row,\'' + name + '\',' + $scope.requiredField[name].required + ')}">' + '{{ row.entity.model[\'' + name + '\'] }}' + '</div>' + '<div class="ui-grid-cell-contents" ng-if="!row.entity.model[\'' + name + '\']" ng-class="{placehodlerclass: true, requiredclass: grid.appScope.fieldIsRequired(row,\'' + name + '\',' + $scope.requiredField[name].required + ')}">' + '{{ \'string\' }}' + '</div>'
              };
              if (property.type == 'string') {
                col['cellTemplate'] = '<div class="ui-grid-cell-contents cont-left" ng-if="row.entity.model[\'' + name + '\']" ng-class="{newclass: grid.appScope.rowIsNew(row), errorclass: grid.appScope.rowInError(row), requiredclass: grid.appScope.fieldIsRequired(row,\'' + name + '\',' + $scope.requiredField[name].required + ')}">' + '{{ row.entity.model[\'' + name + '\'] }}' + '</div>' + '<div class="ui-grid-cell-contents cont-left" ng-if="!row.entity.model[\'' + name + '\']" ng-class="{placehodlerclass: true, requiredclass: grid.appScope.fieldIsRequired(row,\'' + name + '\',' + $scope.requiredField[name].required + ')}">' + '{{ \'string\' }}' + '</div>';
              }
              if (property.format && property.format == 'date') {
                col['cellTemplate'] = '<div class="ui-grid-cell-contents cont-center" ng-if="row.entity.model[\'' + name + '\']" ng-class="{newclass: grid.appScope.rowIsNew(row), errorclass: grid.appScope.rowInError(row), requiredclass: grid.appScope.fieldIsRequired(row,\'' + name + '\',' + $scope.requiredField[name].required + ')}">' + '{{ row.entity.model[\'' + name + '\'] }}' + '</div>' + '<div class="ui-grid-cell-contents cont-center" ng-if="!row.entity.model[\'' + name + '\']" ng-class="{placehodlerclass: true, requiredclass: grid.appScope.fieldIsRequired(row,\'' + name + '\',' + $scope.requiredField[name].required + ')}">' + '{{ \'aaaa-mm-gg\' }}' + '</div>';
              }
              if (property.type == 'number' || property.type == 'integer') {
                col['type'] = 'number';
                col['cellTemplate'] = '<div class="ui-grid-cell-contents cont-right" ng-if="row.entity.model[\'' + name + '\']" ng-class="{newclass: grid.appScope.rowIsNew(row), errorclass: grid.appScope.rowInError(row), requiredclass: grid.appScope.fieldIsRequired(row,\'' + name + '\',' + $scope.requiredField[name].required + ')}">' + '{{grid.appScope.formatNumber(row.entity.model[\'' + name + '\'])}}' + '</div>' + '<div class="ui-grid-cell-contents cont-right"  ng-if="!row.entity.model[\'' + name + '\']" ng-class="{placehodlerclass: true, requiredclass: grid.appScope.fieldIsRequired(row,\'' + name + '\',' + $scope.requiredField[name].required + ')}">' + '{{ \'1,234\' }}' + '</div>';
              }
              if (property.format && property.format == 'lookup') {
                col['cellTemplate'] = '<six-lookup-2 sx-id="' + itemsValue.sxId + '"' + ' ng-model="row.entity.model[\'' + name + '\']"' + ' sx-type="\'' + property.entity_id + '\'"' + ' sx-base-path="\'record\'"' + ' sx-add="' + itemsValue.sxAdd + '"' + ' sx-war="' + property.war + '"' + ' sx-show-details="' + itemsValue.sxShowDetails + '"' + ' sx-show-filters="' + itemsValue.sxShowFilters + '"' + ' sx-multiple="' + itemsValue.sxMultiple + '"' + ' sx-title="\'' + property.title + '\'"' + ' sx-compact="true"' + ' sx-on-select="grid.appScope.lookupCallback(item, row.entity)"' + '>' + '</six-lookup-2>';
              }
              // colonna 'totale' custom
              if (name == 'total') {
                $scope.rowPositionTotal = array.length;
                col['type'] = 'number';
                col['aggregationType'] = uiGridConstants.aggregationTypes.sum;
                // cella
                col['cellTemplate'] = '<div class="ui-grid-cell-contents cont-right" ng-if="grid.appScope.calculateTotalRow(row)" ng-class="{newclass: grid.appScope.rowIsNew(row), errorclass: grid.appScope.rowInError(row), requiredclass: grid.appScope.fieldIsRequired(row,\'' + name + '\',' + $scope.requiredField[name].required + ')}">' + '{{grid.appScope.calculateTotalRow(row)}} €' + '</div>';
                // footer
                col['footerCellTemplate'] = '<div class="ui-grid-cell-contents cont-right" ng-class="{errorclass: !grid.appScope.checkTotalCompliant(col.getAggregationValue()), requiredclass: grid.appScope.fieldIsRequired(row,\'' + name + '\',' + $scope.requiredField[name].required + ')}">' + '{{grid.appScope.calculateTotalGrid(col.getAggregationValue())}} €' + '</div>';
              }
              // colonna 'prezzo unitario' custom
              if (name == 'unit_price') {
                col['type'] = 'number';
                col['cellTemplate'] = '<div class="ui-grid-cell-contents cont-right" ng-if="row.entity.model[\'' + name + '\']" ng-class="{newclass: grid.appScope.rowIsNew(row), errorclass: grid.appScope.rowInError(row), requiredclass: grid.appScope.fieldIsRequired(row,\'' + name + '\',' + $scope.requiredField[name].required + ')}">' + '{{grid.appScope.formatPrice(row.entity.model[\'' + name + '\'])}} €' + '</div>' + '<div class="ui-grid-cell-contents cont-right" ng-if="!row.entity.model[\'' + name + '\']" ng-class="{placehodlerclass: true, requiredclass: grid.appScope.fieldIsRequired(row,\'' + name + '\',' + $scope.requiredField[name].required + ')}">' + '1,234 €' + '</div>';
              }
              array.push(col);
            }
          });
        });
      });
    });
    if ($scope.editable) {
      array.push({
        displayName: '',
        field: 'delete',
        width: 36,
        enableCellEdit: false,
        enableFiltering: false,
        enableSorting: false,
        enableHiding: false,
        cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<button ng-click="grid.appScope.deleteRow(row)" class="btn btn-xs btn-danger"><i class="fa fa-times"></i></button>' + '</div>'
      });
    }
    return array;
  }
  function getColumnDefsListFull() {
    var array = [];
    array.push({
      displayName: '',
      field: 'id',
      width: 36,
      enableCellEdit: false,
      enableFiltering: false,
      enableSorting: false,
      cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/estimate/manager/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' + '<span class="fa fa-search"></span>' + '</a>' + '</div>'
    });
    angular.forEach($scope.schemaHeader.model.columnDefs, function (obj) {
      var property = $scope.schemaHeader.model.schema.properties[obj.field];
      if (property.check && property.check == true) {
        var col = {
          displayName: property.title,
          field: 'model.' + obj.field,
          enableFiltering: true
        };
        if (property.type == 'string') {
          col.filters = [{
            type: sixGridPaginationConstants.filterType.TEXT,
            condition: uiGridConstants.filter.CONTAINS,
            placeholder: ''
          }];
        }
        // template per le colonne in base al loro tipo
        if (property.type == 'string') {
          col.cellTemplate = '<div class="ui-grid-cell-contents cont-left">{{ row.entity.model[\'' + obj.field + '\'] }}</div>';
        }
        if (property.type == 'number' || property.type == 'integer') {
          col.cellTemplate = '<div class="ui-grid-cell-contents cont-left">{{ row.entity.model[\'' + obj.field + '\'] }}</div>';
        }
        if (property.format && property.format == 'date') {
          col.cellTemplate = '<div class="ui-grid-cell-contents cont-center">{{ row.entity.model[\'' + obj.field + '\'] }}</div>';
        }
        // template per le colonne custom
        if (obj.field == 'type') {
          col.cellTemplate = '<div class="ui-grid-cell-contents" ng-if="row.entity.model.type == \'customer\'" style="height: 50px">Cliente</div>' + '<div class="ui-grid-cell-contents" ng-if="row.entity.model.type == \'supplier\'" style="height: 50px">Fornitore</div>';
        }
        if (obj.field == 'status') {
          col.cellTemplate = '<div class="ui-grid-cell-contents" style="vertical-align:middle;">{{grid.appScope.$parent.getEstimateReadableStatus(row.entity.model.status)}}</div>';
        }
        if (obj.field == 'odl_id') {
          col.cellTemplate = '<div class="ui-grid-cell-contents" style="vertical-align:middle;">{{row.entity.model.odl_id.code}} -  {{row.entity.model.odl_id.description}}</div>';
        }
        // add
        array.push(col);
      }
    });
    // aggiungo una colonna per la commessa
    array.push({
      displayName: 'Commessa',
      field: 'commission',
      visible: false,
      cellTemplate: '<div class="ui-grid-cell-contents">{{grid.appScope.$parent.getCommission(row)}}</div>',
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }],
      enableFiltering: true
    });
    return array;
  }
  $scope.getEstimateReadableStatus = function (status) {
    //FIXME: sarebbe meglio prendere la titleMap da schema form
    var titleMap = [{
      "name": "Pubblicato",
      "value": "published"
    }, {
      "name": "Approvato",
      "value": "approved"
    }, {
      "name": "Rifiutato",
      "value": "refused"
    }, {
      "name": "Sospeso",
      "value": "suspended"
    }, {
      "name": "Revisionato",
      "value": "revised"
    }];
    for (var i in titleMap) {
      if (titleMap[i].value == status) {
        return titleMap[i].name;
      }
    }
    return status;
  };

  /** INDIRIZZAMENTO */

  $scope.goToEstimatePageList = function () {
    $location.path('/estimate/' + $scope.type);
  };
  $scope.newEstimate = function () {
    $location.path('/estimate/' + $scope.type + '/new');
  };

  /** PIPE PASSAGGIO PREVENTIVI */

  $scope.promote = function () {
    var dialogPromote = ngDialog.openConfirm({
      name: 'dialogPromote',
      showClose: true,
      plain: true,
      className: 'ngdialog-theme-default ngdialog-theme-custom',
      template: '<div style="text-align:center"><i class="fa fa-files-o"></i>&nbsp;<b>' + 'Promuovere il preventivo fornitore?' + '</b></div><br>' + '<label class="control-label"><b>Dati preventivo cliente:</b></label><br/>' + '<label class="control-label"> Codice</label><br/>' + '<input class="form-control" id="header_customer_code" type="text"/><br/>' + '<label class="control-label"> Descrizione</label><br/>' + '<input class="form-control" id="header_customer_description" type="text"/><br/>' + '<div class="row" style="text-align:center; clear: both">' + '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ng-click="confirm()">Si</button>' + '</div>'
    });
    dialogPromote.then(function () {
      var payload = {
        estimateCustomer: {
          header: {
            model: {}
          },
          rows: []
        } // prev. cliente da inserire
      };

      payload.estimateCustomer.header.model = angular.copy($scope.data.header.model);
      payload.estimateCustomer.header.model['code'] = document.getElementById("header_customer_code").value;
      payload.estimateCustomer.header.model['description'] = document.getElementById("header_customer_description").value;
      payload.estimateCustomer.header.model['type'] = "customer";
      payload.estimateCustomer.header.model['supplier_estimate_id'] = {
        'type': 'estimate',
        'code': $scope.data.header.model.code,
        'description': $scope.data.header.model.description,
        'UUID': $scope.data.header.UUID
      };
      payload.estimateCustomer.rows = clearRowsToPromote($scope.data.rows);
      pipeEstimatePromote.pushEstimateRows(payload);
      $scope.newEstimate();
    });
  };
  $scope.generateConsumptive = function () {
    var generateConsumptive = ngDialog.openConfirm({
      name: 'generateConsumptive',
      showClose: true,
      plain: true,
      className: 'ngdialog-theme-default ngdialog-theme-custom',
      template: '<div style="text-align:center"><i class="fa fa-files-o"></i>&nbsp;<b>' + 'Vuoi generare un consuntivo da questo preventivo?' + '</b></div><br>' + '<label class="control-label"><b>Inserisci dati consuntivo:</b></label><br/>' + '<label class="control-label"> Codice</label><br/>' + '<input class="form-control" id="header_customer_code" type="text"/><br/>' + '<label class="control-label"> Descrizione</label><br/>' + '<input class="form-control" id="header_customer_description" type="text"/><br/>' + '<div class="row" style="text-align:center; clear: both">' + '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ng-click="confirm()">Si</button>' + '</div>'
    });
    generateConsumptive.then(function () {
      var payload = {
        consumptive: {
          header: {
            model: {}
          },
          rows: []
        }
      };
      payload.consumptive.header.model = angular.copy($scope.data.header.model);
      payload.consumptive.header.model['attachments'] = {};
      payload.consumptive.header.model['status'] = null;
      payload.consumptive.header.model['creation_date'] = new Date();
      payload.consumptive.header.model['code'] = document.getElementById("header_customer_code").value;
      payload.consumptive.header.model['description'] = document.getElementById("header_customer_description").value;
      payload.consumptive.header.model['estimate_id'] = {
        'type': 'estimate',
        'code': $scope.data.header.model.code,
        'description': $scope.data.header.model.description,
        'UUID': $scope.data.header.UUID
      };
      payload.consumptive.rows = clearRowsToPromote($scope.data.rows);
      pipeConsumptive.pushConsumptiveRows(payload);
      $location.path('/consumptive/manager/new');
    });
  };
  $scope.copyAsRevision = function () {
    var payload = {
      estimateCustomer: {
        header: {
          model: {}
        },
        rows: []
      }
    };
    payload.estimateCustomer.header.model = angular.copy($scope.data.header.model);
    payload.estimateCustomer.header.model['attachments'] = {};
    payload.estimateCustomer.header.model['status'] = null;
    payload.estimateCustomer.header.model['creation_date'] = new Date();
    payload.estimateCustomer.header.model['prev_estimate_id'] = {
      'type': 'estimate',
      'code': $scope.data.header.model.code,
      'description': $scope.data.header.model.description,
      'UUID': $scope.data.header.UUID
    };
    payload.estimateCustomer.rows = clearRowsToPromote($scope.data.rows);
    pipeEstimatePromote.pushEstimateRows(payload);
    $scope.newEstimate();
  };
  $scope.fullCopy = function () {
    var payload = {
      estimateCustomer: {
        header: {
          model: {}
        },
        rows: []
      }
    };
    payload.estimateCustomer.header.model = angular.copy($scope.data.header.model);
    payload.estimateCustomer.header.model['attachments'] = {};
    payload.estimateCustomer.rows = clearRowsToPromote($scope.data.rows);
    pipeEstimatePromote.pushEstimateRows(payload);
    $scope.newEstimate();
  };
  $scope.copyRows = function () {
    var payload = {
      estimateCustomer: {
        rows: []
      }
    };
    payload.estimateCustomer.rows = clearRowsToPromote($scope.data.rows);
    pipeEstimatePromote.pushEstimateRows(payload);
    $scope.newEstimate();
  };

  /** FILTRO TESTATE PREVENTIVI */

  $scope.$watchGroup(['findCross'], function (newValue, oldValue) {
    if (newValue != oldValue) {
      $scope.getEstimateList();
      $scope.viewGridOptions.columnDefs[$scope.viewGridOptions.columnDefs.length - 1].visible = $scope.findCross;
    }
  });
  $scope.getEstimateList = function () {
    var payload = {
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      sort_fields: $scope.params.sortFields,
      cross: $scope.findCross
    };
    if ($scope.bool.showSupplier && !$scope.bool.showCustomer) {
      $scope.params.filters['model.type'] = sixFiltersLib.exact('model.type', 'supplier');
    }
    if (!$scope.bool.showSupplier && $scope.bool.showCustomer) {
      $scope.params.filters['model.type'] = sixFiltersLib.exact('model.type', 'customer');
    }
    if (!$scope.bool.showSupplier && !$scope.bool.showCustomer) {
      $scope.params.filters['model.type'] = sixFiltersLib.exact('model.type', ''); // ??? non so se va bene...
    }

    if ($scope.bool.showSupplier && $scope.bool.showCustomer) {
      $scope.params.filters['model.type'] = sixFiltersLib["in"]('model.type', ['customer', 'supplier'], sixFiltersLib.CONSTRAINTS.OR);
    }
    return estimateFactory.searchHeader(payload, $scope.params.filters).$promise.then(function (response) {
      $scope.estimateList.list = response.list || [];
      $scope.estimateList.totalResults = response.totalResults;
      $scope.params.sixApi.refreshList(response.list);
      return response;
    })["catch"](function (response) {
      // error
    });
  };
  $scope.refresh = function () {
    $scope.getEstimateList();
  };

  /** SCHEMA HEADER E RIGHE */

  function getSchema() {
    var pSchemaHeader = schemaFactory().byCode({
      id: 'estimateheader'
    }).$promise;
    var pSchemaRow;
    if ($scope.type == 'manager') {
      pSchemaRow = estimateFactory.getCallCenterSchema().$promise;
    } else {
      pSchemaRow = estimateFactory.getRowSchema().$promise;
    }
    return Promise.all([pSchemaHeader, pSchemaRow]).then(function (resp) {
      // resp[0] = header, resp[1] = row
      if (resp[0].model) {
        $scope.schemaHeader = resp[0];
      }
      if (resp[1].model) {
        $scope.schemaRow = resp[1];
        $scope.requiredField = buildRequiredField($scope.schemaRow.model.form);
        $scope.gridOptions.columnDefs = getColumnDefsGridFull();
        $scope.viewGridOptions.columnDefs = getColumnDefsListFull();
      }
    });
  }

  /** LOAD PREVENTIVO */

  function getEstimateByUuid(uuid) {
    estimateFactory.getHeader({
      uuid: uuid
    }).$promise.then(function (response) {
      if (response.result) {
        $scope.data.header = response.result;
        $scope.editable = $scope.type == 'manager' && !$scope.data.header.model.status;
        $scope.schemaHeader.model.schema.readOnly = !$scope.editable;
        $scope.modelLoaded = true;
        readAttachments($scope.data.header.model.attachments);
        var rowFilter = {
          'header.UUID': sixFiltersLib.exact('header.UUID', $scope.data.header.UUID)
        };
        estimateFactory.searchRows({
          page: 1,
          page_size: 10000
        }, rowFilter).$promise.then(function (response) {
          initCurrentIndexRow(response.list); // inizializz. contatore righe
          $scope.addDataToGrid(response.list); // carico le righe sulla grid
        })["catch"](function (response) {
          // error
        });
      }
    });
  }

  /** DELETE PREVENTIVO */

  $scope["delete"] = function () {
    estimateFactory.referenceCount({
      id: $scope.data.header.UUID
    }).$promise.then(function (response) {
      var deleteMessage = 'Eliminare il preventivo "' + $scope.data.header.model.code + '"?';
      if (response.count != 0) {
        deleteMessage = 'Il preventivo: "' + $scope.data.header.model.code + '" è in uso nel sistema.<br> Vuoi rimuoverlo comunque?';
      }
      dialogService.confirmDialog(deleteMessage, function () {
        estimateFactory.removeHeader({
          uuid: $scope.data.header.UUID
        }).$promise.then(function (response) {
          if (response.result) {
            $scope.goToEstimatePageList();
          }
        });
      });
    });
  };

  /** SAVE PREVENTIVO */

  $scope.save = function () {
    if (checkIntegrity()) {
      /** TODO: bisogna pulire il model dalle date "vuote" -> BISOGNERA' SOSTITUIRE IL PICKER */
      validateModelDates();

      // se il preventivo non ha data, la inserisco automaticamente
      if (angular.isUndefined($scope.data.header.model.creation_date) || $scope.data.header.model.creation_date == null) {
        $scope.data.header.model.creation_date = new Date();
      }
      estimateFactory.saveHeader($scope.data.header).$promise.then(function (response) {
        if (response.version) {
          if (angular.isNumber(response.dataIn)) {
            response.dataIn = moment(response.dataIn).toISOString();
          }
          $scope.data.header = response;
          $scope.editable = $scope.type == 'manager' && !response.model.status;
          $scope.schemaHeader.model.schema = angular.extend({}, $scope.schemaHeader.model.schema, {
            readOnly: !$scope.editable
          });
          $scope.gridOptions.columnDefs = getColumnDefsGridFull();
          $scope.$broadcast("update_plafond");
          var payloadInsert = {
            header: $scope.data.header,
            rows: $scope.insertedList
          }; // save
          var payloadModify = {
            rows: $scope.modifiedList
          }; // update
          var payloadDelete = {
            rows: $scope.deletedList
          }; // delete

          var savePromise = estimateFactory.saveRows(payloadInsert).$promise; // save
          var updatePromise = estimateFactory.updateRows(payloadModify).$promise; // update
          var deletePromise = estimateFactory.deleteRows(payloadDelete).$promise; // delete

          Promise.all([savePromise, updatePromise, deletePromise]).then(function (resp) {
            // resp[0] = save, resp[1] = update, resp[2] = delete
            if (resp[0].rows && resp[0].rows.length > 0) {
              $scope.insertedList = [];
              $scope.addDataToGrid(resp[0].rows);
            }
            if (resp[1].rows && resp[1].rows.length > 0) {
              $scope.modifiedList = [];
              $scope.addDataToGrid(resp[1].rows);
            }
            if (resp[2].rows) {
              $scope.deletedList = [];
            }
            toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
            if ($scope.isNew) {
              // ricarico la pagina per la redirect, nel caso poi promuovessi il preventivo
              $location.path('estimate/' + $scope.type + '/' + response.UUID);
            } else {
              // $scope.back();
            }
          });
        }
      })["catch"](function (rejection) {
        toaster.pop('error', 'Errore salvataggio', rejection.data.message ? rejection.data.message : rejection.statusText);
      });
    }
  };
  function loadData() {
    if ($routeParams.id != 'new') {
      $scope.isNew = false;
      getEstimateByUuid($routeParams.id);
    } else {
      $scope.isNew = true;
      getEstimatePromoted(); // controllo se ho dati nella pipe
      $scope.modelLoaded = true;
    }
  }

  /*************************************/
  // MAIN
  /*************************************/

  getSchema().then(function () {
    if ($routeParams.id) {
      $scope.type = $routeParams.type;
      loadData();
    }
  });

  /*************************************/
  // Funzioni gestione preventivi
  /*************************************/

  function checkIntegrity() {
    var rowsWithErrors = false;
    var codeNotPresent = false;
    // controllo che tutte le righe siano corrette
    $scope.data.rows.map(function (r) {
      if (r.sixImportStatus != 'OK') {
        rowsWithErrors = true;
        toaster.pop('error', 'Errore inserimento', 'Riga preventivo: [' + r.model['article'] + '] non conforme.');
      }
    });
    // righe con campi obbligatori mancanti
    var rowRequired = document.getElementsByClassName("requiredclass");
    if (rowRequired.length > 0) {
      rowsWithErrors = true;
      toaster.pop('error', 'Errore inserimento', 'Campi obbligatori mancanti tra le righe.');
    }
    // controllo che abbia il codice
    if (!$scope.data.header.model.code) {
      codeNotPresent = true;
      toaster.pop('error', 'Errore inserimento', 'Codice non presente.');
    }
    return !codeNotPresent && !rowsWithErrors;
  }

  // scarica i dati del prev. promosso
  function getEstimatePromoted() {
    if (pipeEstimatePromote.list.length != 0) {
      var payload = pipeEstimatePromote.popEstimateRows(); // scarico il payload con il preventivo
      if (payload.estimateCustomer.header) {
        $scope.data.header.model = payload.estimateCustomer.header.model;
      }
      if (payload.estimateCustomer.rows) {
        initCurrentIndexRow(payload.estimateCustomer.rows); // inizializz. contatore righe
        $scope.addDataToGrid(payload.estimateCustomer.rows); // carico righe
      }
    }
  }

  /******************************************/
  // Gestione righe save/update/delete
  /******************************************/

  function isItemInArrayByCode(array, item) {
    var present = false;
    array.forEach(function (arrayItem) {
      if (arrayItem.model.code == item.model.code) {
        present = true;
      }
    });
    return present;
  }
  function deleteItemInArrayByCode(array, item) {
    var itemIndex = -1;
    array.forEach(function (itemCurrent, indexCurrent) {
      if (itemCurrent.model.code == item.model.code) {
        itemIndex = indexCurrent;
      }
    });
    array.splice(itemIndex, 1);
  }
  $scope.lookupCallback = function (item, rowEntity) {
    if (item.type == "um") {
      rowEntity.model["um_id"] = item;
    }
    afterCellEditCallback(rowEntity);
  };

  /*********************************************/
  // Vis. decimali + Calcolo totale
  /*********************************************/

  $scope.formatNumber = function (num) {
    return num ? num.toString().replace(/\./g, ',') : null;
  };
  $scope.formatPrice = function (num) {
    if (num) {
      num = Math.round(num * 100) / 100;
    }
    return num ? num.toString().replace(/\./g, ',') : null;
  };
  $scope.calculateTotalRow = function (row) {
    if (row && row.entity && row.entity.model) {
      // if total it's calculable
      if (row.entity.model['unit_price'] && row.entity.model['quantity']) {
        row.entity.model['unit_price'] = Math.round(row.entity.model['unit_price'] * 100) / 100; // formating unit_price to double precision
        row.entity.model.total = Math.round(row.entity.model['unit_price'] * row.entity.model['quantity'] * 100) / 100; // formating total to double precision
      } else {
        delete row.entity.model.total; // else delete total
      }
    }

    return $scope.formatPrice(row.entity.model.total); // return string to show
  };

  $scope.calculateTotalGrid = function (total) {
    if ($scope.data.header.model && $scope.data.header.model.auto_refresh_total) {
      $scope.data.header.model.total = Math.round(total * 100) / 100;
    }
    return $scope.formatPrice(total); // return string to show
  };

  $scope.$watch('data.header.model.auto_refresh_total', function (newValue, oldValue) {
    if (newValue != oldValue && newValue == true) {
      // posizione della colonna totale
      if ($scope.rowPositionTotal && $scope.gridApi.grid.columns && $scope.gridApi.grid.columns.length > 0) {
        var total = $scope.gridApi.grid.columns[$scope.rowPositionTotal].getAggregationValue();
        $scope.data.header.model.total = Math.round(total * 100) / 100;
      }
    }
  });

  /*************************************/
  // Allegati
  /*************************************/

  $scope.attachments = [];
  function readAttachments(modelList) {
    if (modelList && modelList.length > 0) {
      $scope.attachments.splice(0, $scope.attachments.length);
      for (var i = 0; i < modelList.length; i++) {
        $scope.attachments.push(modelList[i]);
      }
    }
  }
  function writeAttachments(modelList) {
    modelList.splice(0, modelList.length);
    for (var i = 0; i < $scope.attachments.length; i++) {
      modelList.push($scope.attachments[i]);
    }
  }
  $scope.updAttachments = function () {
    if (angular.isUndefined($scope.data.header.model.attachments) || !angular.isArray($scope.data.header.model.attachments)) {
      $scope.data.header.model.attachments = [];
    }
    writeAttachments($scope.data.header.model.attachments);
    estimateFactory.saveHeader($scope.data.header).$promise.then(function (response) {
      if (response.version) {
        $scope.data.header.version = response.version;
        $log.debug('saving id: ' + $scope.data.header.version);
      }
    })["catch"](function (rejection) {
      toaster.pop('error', 'Errore salvataggio', rejection.data.message ? rejection.data.message : rejection.statusText);
    });
  };

  /*************************************/
  // Export xlsx
  /*************************************/

  $scope.exportXLSX = function () {
    var columns = [];
    angular.forEach($scope.schemaRow.model.schema.properties, function (property, key) {
      if (key != 'code' && key != 'description') {
        columns.push({
          key: 'model.' + key,
          name: $scope.typeExport == 'exportToImport' ? key : property.title
        });
      }
    });
    var rows = $scope.gridApi.grid.rows.map(function (r) {
      return r.entity;
    });
    sixExportLib.exportXLSX(columns, rows, 'preventivo_' + $scope.data.header.model.code, $scope.typeExport !== 'exportToImport');
  };

  /*************************************/
  // Template xlsx
  /*************************************/

  function buildDataType(prop) {
    if (prop.type === 'string' && prop.format === 'date') {
      return 'yyyy-MM-dd';
    } else if (prop.type === 'string' && prop.format === 'lookup') {
      return 'ref. code to resolve';
    } else if (prop.type === 'integer') {
      return 1;
    } else if (prop.type === 'number') {
      return 1.234;
    } else if (prop.type === 'object') {
      var obj = {};
      for (var key in prop.properties) {
        obj[key] = buildDataType(prop.properties[key]);
      }
      return JSON.stringify(obj);
    }
    return 'text';
  }
  function schemaRowsDefinitionToSheet() {
    var ws = {};
    var range = {
      s: {
        c: 10000000,
        r: 10000000
      },
      e: {
        c: 0,
        r: 0
      }
    };
    var data = [[], []];
    for (var key in $scope.schemaRow.model.schema.properties) {
      if (key != 'code' && key != 'description') {
        data[0].push(key); // Intestazione di colonna
        var prop = $scope.schemaRow.model.schema.properties[key]; // Riga di esempio
        var example = 'text';
        if (prop.type === 'array') {
          if (!prop.items) {
            example = '[item1, item2]';
          } else {
            example = '[' + buildDataType(prop.items) + ',' + buildDataType(prop.items) + ']';
          }
        } else {
          example = buildDataType(prop);
        }
        data[1].push(example);
      }
    }
    for (var R = 0; R != data.length; ++R) {
      for (var C = 0; C != data[R].length; ++C) {
        if (range.s.r > R) range.s.r = R;
        if (range.s.c > C) range.s.c = C;
        if (range.e.r < R) range.e.r = R;
        if (range.e.c < C) range.e.c = C;
        var cell = {
          v: data[R][C]
        };
        if (cell.v == null) continue;
        var cell_ref = XLSX.utils.encode_cell({
          c: C,
          r: R
        });
        if (typeof cell.v === 'number') cell.t = 'n';else if (typeof cell.v === 'boolean') cell.t = 'b';else if (cell.v instanceof Date) {
          cell.t = 'n';
          cell.z = XLSX.SSF._table[14];
          cell.v = datenum(cell.v);
        } else cell.t = 's';
        ws[cell_ref] = cell;
      }
    }
    if (range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
    return ws;
  }
  function Workbook() {
    if (!(this instanceof Workbook)) return new Workbook();
    this.SheetNames = [];
    this.Sheets = {};
  }
  function datenum(v, date1904) {
    if (date1904) v += 1462;
    var epoch = Date.parse(v);
    return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
  }
  $scope.schemaRowsDefinitionToXlsx = function () {
    /* original data */
    var ws_name = 'estimate';
    var wb = new Workbook();
    var ws = schemaRowsDefinitionToSheet();
    /* add worksheet to workbook */
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    var wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      bookSST: false,
      type: 'binary'
    });
    saveAs(new Blob([s2ab(wbout)], {
      type: "application/octet-stream"
    }), "estimate_rows.xlsx");
  };
  function s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
  }

  /*************************************/
  // Stampa PDF (E' possibile specializzare i report per commessa inserendo il suffisso '_[codice_commessa]' (es. odl_1600000))
  /*************************************/

  $scope.printEstimate = function (extension) {
    var report = 'estimate';
    var response = jasperReport(report + '_' + $scope.currentCommission.code, extension); // provo il report specifico della commessa
    response.success(function (data, status, headers, config) {
      if (status == 204) {
        // se è vuoto, provo il report di default
        $log.warn('jasper report error with params report=' + report + '_' + $scope.currentCommission.code + ' and extension=' + extension + ': trying with default report');
        jasperReport(report, extension).success(function (data, status, headers, config) {
          if (status != 200) {
            toaster.pop('error', "Errore", 'Errore generazione report');
          }
        });
      }
    }).error(function (data, status, headers, config) {
      toaster.pop('error', "Errore", 'Errore generazione report');
    });
  };
  function jasperReport(report, extension) {
    var REPORT_URL = 'reports/EMMA/Asset/';
    report = report || 'estimate';
    extension = extension || 'pdf';
    var query = '&uuid=' + $scope.data.header.UUID + '&commission=' + $scope.currentCommission.code;
    var reportNameToSave = 'estimate_' + $scope.data.header.model.code + '.' + extension;
    var reportPath = REPORT_URL + report + '.' + extension;
    var payload = {
      path: reportPath,
      query: query
    };
    var config = {
      responseType: 'arraybuffer'
    };
    var promise = $http.post(APP_URL + '/rest/report/generate', payload, config);
    promise.success(function (data, status, headers, config) {
      if (status == 200 && data) {
        var options;
        if (extension == 'pdf') {
          options = {
            type: 'application/pdf'
          };
        } else if (extension == 'xls') {
          options = {
            type: 'application/vnd.ms-excel;'
          };
        }
        SaveAs.download(data, reportNameToSave, options);
      }
    });
    return promise;
  }

  /*************************************/
  // Utility
  /*************************************/

  function validateModelDates() {
    var dateElements = document.getElementsByTagName("input");
    for (var i = 0; i < dateElements.length; i++) {
      var dateForm = dateElements[i];
      if (dateForm.value == '' && $scope.schemaHeader.model.schema.properties[dateForm.name] && $scope.schemaHeader.model.schema.properties[dateForm.name].format == 'date') {
        delete $scope.data.header.model[dateForm.name];
      }
    }
  }
  $scope.setTypeExport = function (value) {
    $scope.typeExport = value;
  };
  $scope.setFindCross = function (value) {
    $scope.findCross = value;
  };
  $scope.getCommission = function (row) {
    var str = '';
    var sep = '';
    if (row.entity.commission) {
      [].concat(row.entity.commission).forEach(function (c) {
        str += sep + c;
        sep = ',';
      });
    }
    return str;
  };

  // pulisce le righe del prev. da promuovere
  function clearRowsToPromote(array) {
    var clearRows = [];
    array.forEach(function (row) {
      var clearSingleRow = {
        model: row.model,
        sixImportStatus: 'OK'
      };
      clearRows.push(clearSingleRow);
    });
    return clearRows;
  }

  // init contatore per il code delle righe
  function initCurrentIndexRow(array) {
    array.forEach(function (row) {
      if (row.model.code) {
        var indxFullStr = row.model.code; // es. "index_row_6"
        var indxNumStr = indxFullStr.replace("index_row_", ""); // es. "6"
        if (parseInt(indxNumStr) >= $scope.currentIndexRow) {
          $scope.currentIndexRow = parseInt(indxNumStr) + 1; // es. 7
        }
      }
    });
  }

  $scope.rowIsNew = function (row) {
    var isNew = false;
    if (row.entity.sixImportStatus == 'NEW') {
      isNew = true;
    }
    return isNew;
  };
  $scope.rowInError = function (row) {
    var inError = false;
    if (row.entity.sixImportStatus != 'OK' && row.entity.sixImportStatus != 'NEW') {
      inError = true;
    }
    return inError;
  };
  $scope.checkTotalCompliant = function (total) {
    /** mi serve per formattare il totale a due cifre:
     * partono delle chiamate della grid che non riesco a controllare
     * quindi capita che arrivi un totale con più decimali
     * -> lo formatto in tutti i casi */
    if (total) {
      total = Math.round(total * 100) / 100;
    }
    $scope.isCompliant = total == $scope.data.header.model['total'];
    return $scope.isCompliant;
  };
  $scope.fieldIsRequired = function (row, field, required) {
    var isRequired = false;
    if (row && required == true) {
      if (row.entity.model[field] == null || row.entity.model[field] == undefined) {
        isRequired = true;
      }
    }
    return isRequired;
  };
  function buildRequiredField(form) {
    var map = {};
    for (var f in form) {
      for (var i in form[f].items) {
        for (var t in form[f].items[i].tabs) {
          for (var item in form[f].items[i].tabs[t].items) {
            map[form[f].items[i].tabs[t].items[item].key[0]] = form[f].items[i].tabs[t].items[item];
          }
        }
      }
    }
    return map;
  }
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:EstimateRowConfiguratorCtrl
 * @description
 * # EstimateRowConfiguratorCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/estimateconfigurator/row', {
    templateUrl: 'plan/estimate/estimaterowconfigurator_list.html',
    controller: 'EstimateRowConfiguratorCtrl'
  }).when('/estimateconfigurator/row/page/:number', {
    templateUrl: 'plan/estimate/estimaterowconfigurator_list.html',
    controller: 'EstimateRowConfiguratorCtrl'
  }).when('/estimateconfigurator/row/:id', {
    templateUrl: 'plan/estimate/estimaterowconfigurator_detail.html',
    controller: 'EstimateRowConfiguratorCtrl'
  });
}]).controller('EstimateRowConfiguratorCtrl', ["$scope", "$routeParams", "$location", "$log", "$window", "estimateFactory", "schemaFactory", "commissionFactory", "toaster", "authFactory", "dialogService", function ($scope, $routeParams, $location, $log, $window, estimateFactory, schemaFactory, commissionFactory, toaster, authFactory, dialogService) {
  var PATH_ESTIMATE_ROW_CONFIG = 'estimateconfigurator/row';
  $scope.bool = {
    /* contenitore per le variabili booleane */
    isNew: false,
    isCross: false,
    confModel: false,
    isCallCenter: false
  };
  $scope.commissionDependent = true;
  $scope.commissionCode = '';
  $scope.commissions = [];
  $scope.commissionsSelected = {
    codes: []
  };
  $scope.selected = {}; /* contenitore */

  $scope.form = {};
  $scope.model = {};
  $scope.schema = {};
  $scope.property = {};
  $scope.checked = {};
  $scope.uiselectMap = {};
  $scope.itemTypeMap = {};
  $scope.pageSize = 10;
  $scope.status = {
    isFirstOpen: true,
    isFirstDisabled: false
  };
  $scope.modeltypeList = schemaFactory().lookupList({
    page_size: 1000
  });
  $scope.addProperty = function () {
    /* aggiungo una proprietà allo Schema e al Form */
    if (angular.isDefined($scope.property.key)) {
      var p = {
        title: angular.copy($scope.property.title),
        type: angular.copy($scope.property.type),
        check: false
      };
      if ($scope.property.format) {
        p.format = angular.copy($scope.property.format);
      }
      if (p.type == 'date') {
        p.type = 'string';
        p.format = 'date';
      }
      if (p.type == 'array') {
        p.items = {
          type: angular.copy($scope.property.items_type)
        }; // default
        if ($scope.property.items_type === 'date') {
          // se è una data è diverso...
          p.items = {
            type: 'string',
            format: 'date'
          };
        }
      }
      $scope.selected.model.schema.properties[$scope.property.key] = p;
      var item = {
        title: angular.copy($scope.property.title),
        type: null,
        key: [angular.copy($scope.property.key)]
      };
      if (p.format) {
        if (p.format == 'date') {
          item.type = 'datepicker';
        } else if (p.format == 'enum') {
          item.type = 'uiselect';
          item.titleMap = [];
        } else if (p.format == 'lookup') {
          item.type = 'sixlookup';
        }
      } else if (p.type == 'string') {
        item.type = 'text';
      } else if (p.type == 'number' || p.type == 'integer') {
        item.type = 'number';
      } else if (p.type == 'boolean') {
        item.type = 'checkbox';
      } else if (p.type == 'array') {
        item.type = 'uiselectmultiple';
        item.titleMap = [];
      } else {
        // default
        item.type = angular.copy(p.type);
      }
      for (var i in $scope.selected.model.form[0].items) {
        if ($scope.selected.model.form[0].items[i].tabs) {
          $scope.selected.model.form[0].items[i].tabs[0].items.push(item);
        }
      }
    }
    $scope.getUiselectMap();
    $scope.clearNewCol();
    $scope.updateScope();
  };
  $scope.updateScope = function () {
    $scope.schema = angular.fromJson(angular.copy($scope.selected.model.schema));
    $scope.form = [angular.fromJson(angular.copy($scope.selected.model.form[0]))];
    $scope.columnDefs = angular.fromJson(angular.copy($scope.selected.model.columnDefs));
    $scope.formChanged();
  };
  $scope.clearNewCol = function () {
    /* pulisco la riga di inserimento di nuove proprietà */
    $scope.property.key = '';
    $scope.property.title = '';
    delete $scope.property.type;
    delete $scope.property.format;
  };
  $scope.getItemType = function (key) {
    if (valueSchema.type != 'array') {
      return valueSchema.type;
    } else {
      return valueSchema.items.type;
    }
  };
  $scope.addItemOnArray = function (key, newItem) {
    if (newItem != undefined && newItem != null) {
      newItem.name = newItem.name.toString();
      if ($scope.itemTypeMap[key] == 'integer') {
        if (parseInt(newItem.name)) {
          newItem.value = parseInt(newItem.name);
          newItem.name = newItem.value.toString(); /* nel caso ci dovesse essere un cast, torno a sovrascrivere il name */
        } else {
          return;
        }
      } else if ($scope.itemTypeMap[key] == 'number') {
        if (parseFloat(newItem.name)) {
          newItem.value = parseFloat(newItem.name);
        } else {
          return;
        }
      } else {
        newItem.value = newItem.name.toString().replace(/\s/g, '_').toLowerCase();
      }
      for (var i in $scope.selected.model.form[0].items) {
        if ($scope.selected.model.form[0].items[i].tabs) {
          $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
            if (key == item.key[0]) {
              item.titleMap.push(newItem);
            }
          });
        }
      }
      this.newItem = null;
      $scope.updateScope();
    }
  };
  $scope.deleteItemOnArray = function (key, obj) {
    for (var i in $scope.selected.model.form[0].items) {
      if ($scope.selected.model.form[0].items[i].tabs) {
        $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
          if (key == item.key[0]) {
            for (var j = item.titleMap.length; j--;) {
              if (item.titleMap[j].value == obj.value) {
                item.titleMap.splice(j, 1);
              }
            }
          }
        });
      }
    }
    this.newItem = null;
    $scope.updateScope();
  };
  $scope.deleteProperty = function (keyToDelete) {
    delete $scope.selected.model.schema.properties[keyToDelete];
    for (var i = $scope.selected.model.columnDefs.length; i--;) {
      if ($scope.selected.model.columnDefs[i].field == keyToDelete) $scope.selected.model.columnDefs.splice(i, 1);
    }
    // ...elimino sempre dalla form
    for (var i = $scope.selected.model.form[0].items.length; i--;) {
      if ($scope.selected.model.form[0].items[i].key && $scope.selected.model.form[0].items[i].key[0] == keyToDelete) {
        $scope.selected.model.form[0].items.splice(i, 1);
      }
      // Scorro anche i tabs
      if ($scope.selected.model.form[0].items[i].tabs) {
        for (var j = $scope.selected.model.form[0].items[i].tabs.length; j--;) {
          for (var k = $scope.selected.model.form[0].items[i].tabs[j].items.length; k--;) {
            if ($scope.selected.model.form[0].items[i].tabs[j].items[k].key[0] == keyToDelete) {
              $scope.selected.model.form[0].items[i].tabs[j].items.splice(k, 1);
            }
          }
        }
      }
    }
    $scope.updateScope();
  };
  $scope.formChanged = function () {
    $scope.aceModel = JSON.stringify(angular.copy($scope.selected), null, '\t');
  };
  $scope.refreshLookup = function (key, entity_id) {
    $scope.chargeAceModel();
    for (var i = $scope.selected.model.form[0].items.length; i--;) {
      if ($scope.selected.model.form[0].items[i].key && $scope.selected.model.form[0].items[i].key[0] == key) {
        $scope.selected.model.form[0].items[i].entity_id = angular.copy(entity_id);
      }
      // Scorro anche i tabs
      if ($scope.selected.model.form[0].items[i].tabs) {
        for (var j = $scope.selected.model.form[0].items[i].tabs.length; j--;) {
          for (var k = $scope.selected.model.form[0].items[i].tabs[j].items.length; k--;) {
            if ($scope.selected.model.form[0].items[i].tabs[j].items[k].key[0] == key) $scope.selected.model.form[0].items[i].tabs[j].items[k].entity_id = angular.copy(entity_id);
          }
        }
      }
    }
    $scope.selected.model.schema.properties[key].entity_id = angular.copy(entity_id);
    $scope.updateScope();
  };
  $scope.refreshBasePath = function (key, basePath) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].basePath = angular.copy(basePath);
    $scope.updateScope();
  };
  $scope.refreshWar = function (key, war) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].war = angular.copy(war);
    $scope.updateScope();
  };
  $scope.refreshFiltered = function (key, filtered) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].filtered = angular.copy(filtered);
    $scope.updateScope();
  };
  $scope.refreshFilterSourceField = function (key, filterSourceField) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].filterSourceField = angular.copy(filterSourceField);
    $scope.updateScope();
  };
  $scope.refreshFilterDestField = function (key, filterDestField) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].filterDestField = angular.copy(filterDestField);
    $scope.updateScope();
  };
  $scope.refreshLookupOption = function (key, option, value) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key][option] = angular.copy(value);
    $scope.updateScope();
  };
  $scope.refreshTitleForm = function (title) {
    $scope.chargeAceModel();
    $scope.selected.model.form[0].title = angular.copy(title);
    $scope.updateScope();
  };
  $scope.chargeAceModel = function () {
    var defaultData = angular.fromJson(angular.copy($scope.aceModel));
    if (defaultData) {
      $scope.selected = defaultData;
      $scope.schema = angular.fromJson(defaultData.model.schema);
      $scope.form = angular.fromJson(defaultData.model.form);
      $scope.columnDefs = angular.fromJson(defaultData.model.columnDefs);
    }
  };
  $scope.changeColumnDefs = function (key, value) {
    var item = {
      name: value.title,
      field: key
    };
    var map = new Map();
    angular.forEach($scope.selected.model.columnDefs, function (v) {
      map[v.field] = angular.copy(v);
    });
    if (value.check) {
      map[item.field] = angular.copy(item);
      if (value.width == '' || value.width == null) {
        delete $scope.selected.model.schema.properties[key].width;
      }
    } else {
      delete map[item.field];
      delete $scope.selected.model.schema.properties[key].width;
      $scope.selected.model.schema.properties[key].enableFiltering = false;
      $scope.selected.model.schema.properties[key].enableSorting = false;
    }
    $scope.selected.model.columnDefs = [];
    for (var it in map) {
      var app = {
        name: map[it].name,
        field: map[it].field
      };
      $scope.selected.model.columnDefs.push(app);
    }
    $scope.updateScope();
  };
  $scope.aceLoaded = function () {
    $scope.columnDefault = ['code', 'description', 'article', 'cost_center', 'quantity', 'total', 'type', 'type_row', 'um_id', 'unit_price'];
    var defaultModel = {
      model: {
        schema: {
          type: "object",
          title: "",
          properties: {
            code: {
              title: "Codice",
              type: "string",
              check: true
            },
            description: {
              title: "Descrizione",
              type: "string",
              check: true
            },
            article: {
              title: "Articolo",
              type: "string",
              check: false
            },
            cost_center: {
              title: "Centro di costo",
              type: "string",
              check: false
            },
            quantity: {
              title: "Quantità",
              type: "number",
              check: false
            },
            total: {
              title: "Totale",
              type: "number",
              check: false
            },
            type: {
              title: "Tipologia",
              type: "string",
              check: false
            },
            type_row: {
              title: "Tipo riga",
              type: "string",
              check: false
            },
            um_id: {
              title: "Unità di misura",
              type: "string",
              format: "lookup",
              entity_id: "um",
              war: "six-data-set",
              check: false
            },
            unit_price: {
              title: "Prezzo unitario",
              type: "number",
              check: false
            }
          },
          required: ["code", "description"]
        },
        form: [{
          type: "fieldset",
          items: [{
            type: "tabs",
            tabs: [{
              title: "Dati",
              items: [{
                key: ["code"],
                title: "Codice",
                required: true,
                type: "text"
              }, {
                key: ["description"],
                title: "Descrizione",
                required: true,
                type: "textarea",
                placeholder: "Testo di descrizione..."
              }, {
                key: ["article"],
                title: "Articolo",
                required: false,
                type: "text"
              }, {
                key: ["cost_center"],
                title: "Centro di costo",
                required: false,
                type: "text"
              }, {
                key: ["type"],
                title: "Tipologia",
                required: false,
                type: "text"
              }, {
                key: ["type_row"],
                title: "Tipo riga",
                required: false,
                type: "text"
              }, {
                key: ["quantity"],
                title: "Quantità",
                required: false,
                type: "number"
              }, {
                key: ["total"],
                title: "Totale",
                required: false,
                type: "number"
              }, {
                title: "Unità di misura",
                type: "sixlookup",
                entity_id: "um",
                required: false,
                key: ["um_id"]
              }, {
                key: ["unit_price"],
                title: "Prezzo unitario",
                required: false,
                type: "number"
              }]
            }]
          }]
        }],
        columnDefs: [{
          "field": "code",
          "name": "Codice"
        }, {
          "field": "description",
          "name": "Descrizione"
        }]
      }
    };
    $scope.aceModel = JSON.stringify(defaultModel, null, '\t');
    $scope.chargeAceModel();
    $scope.title = angular.copy($scope.selected.model.form[0].title);
  };
  $scope.getUiselectMap = function () {
    $scope.uiselectMap = {};
    $scope.itemTypeMap = {};
    for (var i in $scope.selected.model.form[0].items) {
      if ($scope.selected.model.form[0].items[i].tabs) {
        $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
          $scope.itemTypeMap[item.key[0]] = $scope.selected.model.schema.properties[item.key[0]].type;
          if ($scope.selected.model.schema.properties[item.key[0]].type == 'array') {
            $scope.itemTypeMap[item.key[0]] = $scope.selected.model.schema.properties[item.key[0]].items.type;
          }
          if (item.type == 'uiselect' || item.type == 'uiselectmultiple') {
            var blankObject = {
              name: '',
              value: ''
            };
            $scope.uiselectMap[item.key[0]] = addSelectedValue(item.titleMap, blankObject); /* aggiunto un elemento vuoto all'array per consentire il deselezionamento */
          }
        });
      }
    }
  };

  $scope.toggleEnumDefault = function (key, objValue) {
    var property = $scope.selected.model.schema.properties[key];
    if (typeof property["default"] == "undefined" || property["default"].indexOf(objValue) == -1) {
      property["default"] = [objValue];
    } else {
      property["default"] = undefined;
    }
    this.newItem = null;
    $scope.updateScope();
  };
  function addSelectedValue(array, obj) {
    var blankValuePresent = false;
    array.forEach(function (item) {
      if (item.value == obj.value && item.name == obj.name) {
        blankValuePresent = true;
      }
    });
    if (blankValuePresent == false) {
      array.push(obj);
    }
    return array;
  }
  $scope.isInheritable = function (type) {
    return type == 'number' || type == 'integer' || type == 'string' || type == 'boolean' || type == 'lookup';
  };
  $scope.disableDeleteColumn = function (key) {
    var columnsWithoutDelete = ['code', 'description', 'unit_price', 'um_id', 'total', 'quantity', 'type_row', 'type', 'cost_center', 'article'];
    return columnsWithoutDelete.indexOf(key) > -1;
  };
  $scope.disableInTableColumn = function (key) {
    var columns = ['code', 'description'];
    return columns.indexOf(key) > -1;
  };

  /**********************/
  /***** FIX SCHEMA *****/
  /**********************/

  $scope.fixSchemaFormModel = function () {
    for (var i in $scope.selected.model.form[0].items) {
      if ($scope.selected.model.form[0].items[i].tabs) {
        $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
          if (item.type == 'uiselect') {
            $scope.selected.model.schema.properties[item.key[0]].format = 'enum';
          }
          if (item.type == 'uiselectmultiple') {
            $scope.selected.model.schema.properties[item.key[0]].type = 'array';
          }
        });
      }
    }
  };

  /****************/
  /***** FORM *****/
  /****************/

  $scope.newFieldForm = {};
  $scope.newTab = {
    title: "",
    items: []
  };
  $scope.addTab = function (container) {
    if (!container.tabs) {
      container.tabs = [];
    }
    if (container.type !== 'tabs') {
      container.type = 'tabs';
    }
    var toAdd = angular.copy($scope.newTab);
    $log.log(container);
    container.tabs.push(toAdd);
    $log.log(container);
    $scope.updateScope();
    $scope.newTab = {
      title: "",
      items: []
    };
  };
  $scope.addFieldToTab = function (tab) {
    if (!tab.items) {
      tab.items = [];
    }
    var toAdd = angular.copy($scope.newFieldForm);
    if ($scope.newFieldForm.type === '' || $scope.newFieldForm.type === 'formula' || $scope.newFieldForm.type === 'inherited') {
      delete toAdd.type;
    }
    /* key è da cambiare in un array */
    toAdd.key = [];
    toAdd.key.push($scope.newFieldForm.key);
    /* se è una lookup, e se ha definito il campo entity_id nello schema, ci attacco anche l'entity_id */
    if (toAdd.type == 'sixlookup' && $scope.schema.properties[$scope.newFieldForm.key]['entity_id']) {
      toAdd['entity_id'] = $scope.schema.properties[$scope.newFieldForm.key]['entity_id'];
    }
    tab.items.push(toAdd);
    $log.log(tab);
    $scope.updateScope();
    $scope.newFieldForm = {
      key: [],
      title: "",
      required: false,
      type: "text"
    };
  };
  $scope.removeTabOrField = function (key, container) {
    container.splice(key, 1);
    $log.log(container);
    $scope.updateScope();
  };
  $scope.swapUp = function (key, collection) {
    if (key > 0) {
      var tmp = collection[key];
      collection[key] = collection[key - 1];
      collection[key - 1] = tmp;
    }
    $scope.updateScope();
  };
  $scope.swapDown = function (key, collection) {
    if (key < collection.length - 1) {
      var tmp = collection[key];
      collection[key] = collection[key + 1];
      collection[key + 1] = tmp;
    }
    $scope.updateScope();
  };
  $scope.updateField = function (field) {
    if (field.type === '') {
      delete field.type;
    }
    $scope.updateScope();
  };
  $scope.$watchGroup(['commissionDependent', 'history'], function () {
    if ($scope.commissionDependent === true) {
      $scope.history = true;
    }
    if ($scope.selected) {
      if ($scope.selected.model) {
        $scope.selected.model.history = $scope.history;
        $scope.selected.model.commissionDependent = $scope.commissionDependent;
        $scope.updateScope();
      }
    }
  });
  $scope.pageChanged = function () {
    $location.path('/estimateconfigurator/row/page/' + $scope.estimateRowConfiguratorList.currentPage, false);
    $scope.estimateRowConfiguratorList = estimateFactory.getRowSchemaList({
      query: $scope.queryParam,
      page: $scope.estimateRowConfiguratorList.currentPage
    });
  };
  $scope.printCommission = function (commission_array) {
    var result = '';
    var pos = 0;
    if (commission_array != null) {
      angular.forEach(commission_array, function (value) {
        if (pos == 0) {
          result = value;
        } else {
          result = value + ', ' + result;
        }
        pos++;
      });
    }
    return result;
  };
  $scope.updateCode = function () {
    if ($scope.bool.isCross == true) {
      $scope.commissionCode = 'default';
      $scope.commissionsSelected.codes = [];
    } else {
      $scope.commissionCode = '';
    }
  };
  $scope.setCallCenter = function () {
    /* impostare le varaibili per salvare la configurazione per il call center */
    if ($scope.bool.isCallCenter == true) {
      $scope.commissionCode = 'callcenter';
      $scope.commissionsSelected.codes = [];
    } else {
      $scope.commissionCode = '';
    }
  };
  $scope.setConfModel = function () {
    $scope.bool.confModel = true;
    $scope.bool.isCross = false;
    $scope.bool.isCallCenter = false;
    delete $scope.selected.version;
    $scope.commissionsSelected.codes = [];
    $scope.commissionCode = '';
  };
  $scope.newEstimateRowConfiguration = function () {
    $location.path(PATH_ESTIMATE_ROW_CONFIG + '/new');
  };
  $scope.refresh = function () {
    $location.path(PATH_ESTIMATE_ROW_CONFIG);
  };
  $scope.back = function () {
    $location.path(PATH_ESTIMATE_ROW_CONFIG);
  };
  $scope["delete"] = function () {
    dialogService.confirmDialog('Eliminare la configurazione?', function () {
      estimateFactory.deleteRowSchema({
        id: $scope.selected.version
      }).$promise.then(function () {
        $scope.back();
      });
    });
  };
  $scope.setCommissionSelected = function () {
    angular.forEach($scope.selected.model.commission, function (value_cm_string) {
      var index = null;
      angular.forEach($scope.commissions, function (value_cm_obj) {
        if (value_cm_string == value_cm_obj.code) {
          index = $scope.commissions.indexOf(value_cm_obj);
          $scope.commissionsSelected.codes.push(value_cm_obj);
          $scope.commissions.splice(index, 1);
        }
      });
    });
  };
  $scope.setBooleanFlag = function () {
    if ($scope.selected.model) {
      if ($scope.selected.model.code == 'default') {
        $scope.bool.isCross = true;
      } else if ($scope.selected.model.code == 'callcenter') {
        $scope.bool.isCallCenter = true;
      }
    }
  };
  $scope.getEstimateRowConfigurationById = function (UUID) {
    estimateFactory.getRowSchemaByUUID({
      uuid: UUID
    }).$promise.then(function (response) {
      if (response.model) {
        $scope.selected = angular.copy(response);
        $scope.commissionCode = $scope.selected.model.code;
        $scope.setCommissionSelected();
        $scope.setBooleanFlag();
        $scope.updateScope();
      }
    });
  };
  $scope.getEstimateRowConfigurationList = function () {
    estimateFactory.getRowSchemaList({
      query: $scope.queryParam,
      pageSize: $scope.pageSize
    }).$promise.then(function (response) {
      $scope.estimateRowConfiguratorList = response;
    });
  };
  $scope.getCommission = function () {
    commissionFactory().getCommissionsList().$promise.then(function (response) {
      if (response.list) {
        $scope.commissions = response.list;
      }
    });
  };
  $scope.create = function () {
    estimateFactory.createRowSchema($scope.aceModel).$promise.then(function () {
      toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
      $scope.back();
    })["catch"](function (response) {
      toaster.pop('error', 'Errore salvataggio', 'Si è verificato un errore durante il salvataggio');
    });
  };
  $scope.update = function () {
    estimateFactory.updateRowSchema({
      id: $scope.selected.version
    }, $scope.aceModel).$promise.then(function () {
      toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
      $scope.back();
    })["catch"](function (rejection) {
      toaster.pop('error', 'Errore salvataggio', rejection.data.message ? rejection.data.message : rejection.statusText);
    });
  };
  function checkIntegrityModel() {
    // controllo se mancano alcuni dei campi obbligatori
    var integrityModel = true;
    angular.forEach($scope.columnDefault, function (col) {
      if (!$scope.selected.model.schema.properties[col]) {
        integrityModel = false;
      }
    });
    return integrityModel;
  }
  $scope.saveForm = function () {
    $scope.chargeAceModel();
    $scope.selected.model.code = $scope.commissionCode;
    if (checkIntegrityModel()) {
      if ($scope.bool.isCross || $scope.bool.isCallCenter) {
        /* se è cross non serve riempire il vettore delle commesse */
        $scope.selected.model.commission = null;
        $scope.selected.model.commissionDependent = false;
        $scope.formChanged(); /* aggiorno l'aceModel */
        if ($scope.selected.version) {
          $scope.update();
        } else {
          $scope.create();
        }
      } else {
        /* riempio il vettore delle commesse */
        $scope.selected.model.commission = [];
        angular.forEach($scope.commissionsSelected.codes, function (obj) {
          $scope.selected.model.commission.push(obj.code);
        });
        $scope.formChanged(); /* aggiorno l'aceModel */
        if ($scope.bool.confModel) {
          /* create obbligatoria */
          $scope.create();
        } else {
          if ($scope.selected.version) {
            $scope.update();
          } else {
            $scope.create();
          }
        }
      }
    } else {
      toaster.pop('error', 'Errore', 'Campi obbligatori mancanti nello schema.');
    }
  };
  if ($routeParams.id) {
    if ($routeParams.id !== 'new') {
      $scope.bool.isNew = false;
      commissionFactory().getCommissionsList().$promise.then(function (response) {
        if (response.list.length) {
          $scope.commissions = response.list;
        }
        $scope.getEstimateRowConfigurationById($routeParams.id);
      });
    } else {
      $scope.bool.isNew = true;
      $scope.getCommission();
    }
  } else {
    $scope.getEstimateRowConfigurationList();
  }

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'odl/schema';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.activityFactory
 * @description
 * # activityFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.plan').factory('activityFactory', ["PLAN_URL", "$resource", function (PLAN_URL, $resource) {
  return $resource(PLAN_URL + '/api/activity/:verb/:id/:uuid', {}, {
    getActivityById: {
      method: 'GET'
    },
    getActivitiesList: {
      method: 'GET',
      params: {
        verb: '_list'
      }
    },
    getActivitiesListFiltered: {
      method: 'POST',
      params: {
        verb: '_search'
      }
    },
    deleteActivity: {
      method: 'DELETE',
      params: {
        verb: '_delete'
      }
    },
    updateActivity: {
      method: 'PUT',
      params: {
        verb: '_update'
      }
    },
    saveActivity: {
      method: 'POST',
      params: {
        verb: '_save'
      }
    },
    getActivityByUUID: {
      method: 'GET',
      params: {
        verb: '_uuid'
      }
    },
    referenceCount: {
      method: 'GET',
      params: {
        verb: '_referencecount'
      },
      isArray: false,
      ignoreLoadingBar: true
    }
  });
}]);
/**
 * Created by luca on 07/04/17.
 */

'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.consumptiveOdlFactory
 * @description
 * # consumptiveOdlFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.plan').factory('consumptiveOdlFactory', ["PLAN_URL", "$resource", function (PLAN_URL, $resource) {
  return $resource(PLAN_URL + '/api/consumptiveodl/:entity/:type/:verb/:operation/:uuid/:id/:param1/:param2', {}, {
    // HEADER e ROW

    /* gestione header */
    getHeader: {
      method: 'GET',
      isArray: false,
      params: {
        type: '_header',
        verb: '_get',
        operation: '_uuid',
        uuid: '@uuid'
      }
    },
    getHeaderByCode: {
      method: 'GET',
      isArray: false,
      params: {
        type: '_header',
        verb: '_get',
        operation: '_code',
        code: '@code'
      }
    },
    searchHeader: {
      method: 'POST',
      isArray: false,
      params: {
        type: '_header',
        operation: '_search'
      }
    },
    saveHeader: {
      method: 'POST',
      isArray: false,
      params: {
        type: '_header',
        verb: '_save'
      }
    },
    removeHeader: {
      method: 'DELETE',
      params: {
        type: '_header',
        verb: '_delete',
        uuid: '@uuid'
      }
    },
    referenceCount: {
      method: 'GET',
      isArray: false,
      params: {
        verb: '_referencecount'
      },
      ignoreLoadingBar: true
    },
    /* gestione righe in blocco */
    searchRows: {
      method: 'POST',
      isArray: false,
      params: {
        type: '_row',
        operation: '_search'
      }
    },
    saveRows: {
      method: 'POST',
      isArray: false,
      params: {
        type: '_row',
        verb: '_save',
        operation: '_bulk'
      }
    },
    updateRows: {
      method: 'POST',
      isArray: false,
      params: {
        type: '_row',
        verb: '_update',
        operation: '_bulk'
      }
    },
    deleteRows: {
      method: 'POST',
      isArray: false,
      params: {
        type: '_row',
        verb: '_delete',
        operation: '_bulk'
      }
    },
    // SCHEMA HEADER E ROW

    // ODL SCHEMA
    getRowSchema: {
      method: 'GET',
      params: {
        entity: 'schema',
        verb: '_codeordefault'
      }
    },
    getCallCenterSchema: {
      method: 'GET',
      params: {
        entity: 'schema',
        verb: '_callcenter'
      }
    },
    getRowSchemaList: {
      method: 'GET',
      params: {
        entity: 'schema'
      }
    },
    getRowSchemaByCode: {
      method: 'GET',
      params: {
        entity: 'schema',
        verb: '_code'
      }
    },
    getRowSchemaById: {
      method: 'GET',
      params: {
        entity: 'schema',
        verb: '_id'
      }
    },
    getRowSchemaByUUID: {
      method: 'GET',
      params: {
        entity: 'schema',
        verb: '_uuid'
      }
    },
    deleteRowSchema: {
      method: 'DELETE',
      params: {
        entity: 'schema'
      }
    },
    updateRowSchema: {
      method: 'PUT',
      params: {
        entity: 'schema'
      }
    },
    createRowSchema: {
      method: 'POST',
      params: {
        entity: 'schema'
      }
    }
  });
}]);
/**
 * Created by luca on 07/04/17.
 */

'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.estimateFactory
 * @description
 * # estimateFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.plan').factory('estimateFactory', ["PLAN_URL", "$resource", function (PLAN_URL, $resource) {
  return $resource(PLAN_URL + '/api/estimate/:entity/:type/:verb/:operation/:uuid/:id/:param1/:param2', {}, {
    // HEADER e ROW

    /* gestione header */
    getHeader: {
      method: 'GET',
      isArray: false,
      params: {
        type: '_header',
        verb: '_get',
        operation: '_uuid',
        uuid: '@uuid'
      }
    },
    getHeaderByCode: {
      method: 'GET',
      isArray: false,
      params: {
        type: '_header',
        verb: '_get',
        operation: '_code',
        code: '@code'
      }
    },
    searchHeader: {
      method: 'POST',
      isArray: false,
      params: {
        type: '_header',
        operation: '_search'
      }
    },
    saveHeader: {
      method: 'POST',
      isArray: false,
      params: {
        type: '_header',
        verb: '_save'
      }
    },
    removeHeader: {
      method: 'DELETE',
      params: {
        type: '_header',
        verb: '_delete',
        uuid: '@uuid'
      }
    },
    referenceCount: {
      method: 'GET',
      isArray: false,
      params: {
        verb: '_referencecount'
      },
      ignoreLoadingBar: true
    },
    /* gestione righe in blocco */
    searchRows: {
      method: 'POST',
      isArray: false,
      params: {
        type: '_row',
        operation: '_search'
      }
    },
    saveRows: {
      method: 'POST',
      isArray: false,
      params: {
        type: '_row',
        verb: '_save',
        operation: '_bulk'
      }
    },
    updateRows: {
      method: 'POST',
      isArray: false,
      params: {
        type: '_row',
        verb: '_update',
        operation: '_bulk'
      }
    },
    deleteRows: {
      method: 'POST',
      isArray: false,
      params: {
        type: '_row',
        verb: '_delete',
        operation: '_bulk'
      }
    },
    // SCHEMA HEADER E ROW

    // ODL SCHEMA
    getRowSchema: {
      method: 'GET',
      params: {
        entity: 'schema',
        verb: '_codeordefault'
      }
    },
    getCallCenterSchema: {
      method: 'GET',
      params: {
        entity: 'schema',
        verb: '_callcenter'
      }
    },
    getRowSchemaList: {
      method: 'GET',
      params: {
        entity: 'schema'
      }
    },
    getRowSchemaByCode: {
      method: 'GET',
      params: {
        entity: 'schema',
        verb: '_code'
      }
    },
    getRowSchemaById: {
      method: 'GET',
      params: {
        entity: 'schema',
        verb: '_id'
      }
    },
    getRowSchemaByUUID: {
      method: 'GET',
      params: {
        entity: 'schema',
        verb: '_uuid'
      }
    },
    deleteRowSchema: {
      method: 'DELETE',
      params: {
        entity: 'schema'
      }
    },
    updateRowSchema: {
      method: 'PUT',
      params: {
        entity: 'schema'
      }
    },
    createRowSchema: {
      method: 'POST',
      params: {
        entity: 'schema'
      }
    }
  });
}]);
"use strict";

angular.module('emma.plan').factory('invoiceWSFactory', ["PLAN_URL", "ENV", "DEV", "$websocket", "$log", "$location", "$timeout", "dialogService", function (PLAN_URL, ENV, DEV, $websocket, $log, $location, $timeout, dialogService) {
  var MAX_ATTEMPTS = 2;
  var user;
  var ws;
  var listeners = [];
  var method = {};
  method.connect = function (userName) {
    if (ws) ws.close();

    // costruzione url
    var wsPath;
    if ($location.protocol() == 'https') {
      wsPath = 'wss://'; // se viaggio su https
    } else {
      wsPath = 'ws://'; // se viaggio su http
    }

    wsPath += $location.host() + ':' + $location.port() + '/';
    if (!DEV) {
      wsPath += ENV + '/';
    }
    wsPath += 'ws/' + PLAN_URL + '/invoice/ws/' + userName;
    ws = $websocket(wsPath);
    user = userName;
    ws.onOpen(function () {
      $log.info("Socket with invoice/ws has been opened!");
    });
    ws.onClose(function (event) {
      $log.warn("Socket with invoice/ws has been closed!");
    });
    ws.onError(function (event) {
      $log.error('invoiceWSFactory error', event);
    });
    ws.onMessage(function (message) {
      $log.debug(message);
      var parsed = JSON.parse(message.data);
      $log.debug('responseId = ' + parsed.$id);
      listeners.forEach(function (l) {
        l(parsed);
      });
    });
  };
  method.addHandler = function (listener) {
    listeners.push(listener);
    return function () {
      var idx = listeners.indexOf(listener);
      if (idx > -1) {
        listeners.splice(idx, 1);
      }
    };
  };
  method.subscribe = function (channel) {
    var msg = {
      operation: 'subscribe',
      channel: channel
    };
    _send(msg, 0);
  };
  function _send(msg, attempts) {
    if (!msg.operation) {
      $log.debug('Invalid message', msg);
      return;
    }
    if (ws) {
      if (ws.readyState == 0) {
        // connecting => aspetto e riprovo ad inviare
        $log.info('readyState = ' + ws.readyState + ' => retry ' + (attempts + 1));
        $timeout(function () {
          _send(msg, attempts + 1);
        }, 1000);
      } else if (ws.readyState == 1) {
        // open
        $log.debug('Sending message ', msg);
        var stringified = JSON.stringify(msg);
        ws.send(stringified).then(function () {
          $log.info('Message sent ', msg);
        });
      } else if (attempts < MAX_ATTEMPTS) {
        // closing o closed => provo a riconnettermi
        $log.warn('readyState = ' + ws.readyState + ' => retry ' + (attempts + 1));
        method.connect(user);
        $timeout(function () {
          _send(msg, attempts + 1);
        }, 200);
      } else {
        $log.error('readyState = ' + ws.readyState + ' => too many attempts (' + attempts + ')!!!');
        dialogService.dialog('Attenzione', 'La connessione con il server è stata persa: provare a ricaricare la pagina', dialogService.DIALOG_TYPE.WARNING, -1);
      }
    } else {
      $log.error('ws undefined: maybe you\'re not connected');
    }
  }
  return method;
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.invoiceFactory
 * @description
 * # invoiceFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.plan').factory('invoiceFactory', ["PLAN_URL", "$resource", function (PLAN_URL, $resource) {
  return $resource(PLAN_URL + '/api/invoice/:entity/:type/:verb/:id/:uuid/:param1', {}, {
    getInvoiceById: {
      method: 'GET',
      params: {
        entity: 'invoice',
        verb: '_id',
        id: '@id'
      }
    },
    getInvoiceByUUID: {
      method: 'GET',
      params: {
        entity: 'invoice',
        verb: '_uuid',
        uuid: '@uuid',
        param1: '_current'
      }
    },
    getInvoiceList: {
      method: 'GET',
      params: {
        entity: 'invoice'
      }
    },
    searchInvoice: {
      method: 'POST',
      params: {
        entity: 'invoice',
        verb: '_search'
      }
    },
    deleteInvoice: {
      method: 'DELETE',
      params: {
        entity: 'invoice',
        id: '@id'
      }
    },
    updateInvoice: {
      method: 'PUT',
      params: {
        entity: 'invoice',
        id: '@id'
      }
    },
    updateInvoiceStatus: {
      method: 'PUT',
      params: {
        entity: 'invoice',
        verb: '_status',
        id: '@id'
      }
    },
    updateInvoiceRows: {
      method: 'POST',
      params: {
        entity: 'invoice',
        type: 'rows',
        verb: '_bulk',
        id: '@id'
      }
    },
    updateInvoiceAggregatedRows: {
      method: 'POST',
      params: {
        entity: 'invoice',
        type: 'aggregatedrows',
        verb: '_bulk',
        id: '@id'
      }
    },
    saveInvoice: {
      method: 'POST',
      params: {
        entity: 'invoice'
      }
    },
    generateRowsByUUID: {
      method: 'POST',
      params: {
        entity: 'invoice',
        verb: '_generate',
        uuid: '@uuid',
        notifyTo: '@notifyTo'
      }
    },
    deleteGeneratedRowsByUUID: {
      method: 'DELETE',
      params: {
        entity: 'invoice',
        verb: '_generatedRows',
        uuid: '@uuid'
      }
    },
    getRows: {
      method: 'GET',
      params: {
        entity: 'invoice',
        type: 'rows',
        id: '@id'
      }
    },
    getAggregatedRows: {
      method: 'GET',
      params: {
        entity: 'invoice',
        type: 'aggregatedrows',
        id: '@id'
      }
    },
    getAssets: {
      method: 'GET',
      params: {
        entity: 'invoice',
        type: 'assets',
        id: '@id'
      }
    },
    referenceCount: {
      method: 'GET',
      params: {
        entity: 'invoice',
        verb: '_referencecount',
        uuid: '@uuid'
      },
      isArray: false,
      ignoreLoadingBar: true
    },
    getLatestDate: {
      method: 'GET',
      params: {
        entity: 'invoice',
        verb: '_latestdate',
        approved: false,
        refused: false
      }
    },
    getInvoiceDiff: {
      method: 'GET',
      params: {
        entity: 'invoice',
        verb: '_diff',
        id: '@a',
        uuid: '@b'
      }
    },
    //Configurazione
    getConfiguration: {
      method: 'GET',
      params: {
        entity: 'configuration',
        verb: '_codeordefault'
      }
    },
    getConfigurationById: {
      method: 'GET',
      params: {
        entity: 'configuration',
        verb: '_id',
        id: '@id'
      }
    },
    getConfigurationByUUID: {
      method: 'GET',
      params: {
        entity: 'configuration',
        verb: '_uuid'
      }
    },
    getConfigurationList: {
      method: 'GET',
      params: {
        entity: 'configuration'
      }
    },
    searchConfiguration: {
      method: 'POST',
      params: {
        entity: 'configuration',
        verb: '_search'
      }
    },
    deleteConfiguration: {
      method: 'DELETE',
      params: {
        entity: 'configuration',
        id: '@id'
      }
    },
    updateConfiguration: {
      method: 'PUT',
      params: {
        entity: 'configuration',
        id: '@id'
      }
    },
    saveConfiguration: {
      method: 'POST',
      params: {
        entity: 'configuration'
      }
    },
    hardDeleteConfiguration: {
      method: 'DELETE',
      params: {
        entity: 'configuration',
        verb: '_hard',
        id: '@id'
      },
      ignoreLoadingBar: true
    },
    //generici per timeline
    getTimeline: {
      method: 'GET',
      params: {
        verb: '_uuid',
        uuid: '@uuid',
        entity: '@entity'
      }
    },
    byID: {
      method: 'GET',
      params: {
        verb: '_id',
        id: '@id',
        entity: '@entity'
      }
    },
    bulkUpdate: {
      method: 'POST',
      params: {
        entity: 'invoice',
        type: '_bulk',
        verb: '_update'
      }
    },
    cleanInvoice: {
      method: 'POST',
      params: {
        entity: 'invoice',
        type: '_invoice',
        verb: 'clean',
        id: '@salUuid',
        uuid: '@invoiceUuid'
      }
    }
  });
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.issueFactory
 * @description
 * # issueFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.plan').factory('issueFactory', ["PLAN_URL", "APP_URL", "$resource", function (PLAN_URL, APP_URL, $resource) {
  return function (entity, param1) {
    return $resource(PLAN_URL + '/api/' + entity + '/:verb/:id/:param1', {}, {
      query: {
        method: 'GET',
        isArray: false
      },
      search: {
        method: 'POST',
        isArray: false,
        params: {
          verb: '_search'
        }
      },
      searchWithOdl: {
        method: 'POST',
        isArray: false,
        params: {
          verb: '_searchwithodl'
        }
      },
      select: {
        method: 'GET',
        isArray: true
      },
      create: {
        method: 'POST'
      },
      show: {
        method: 'GET'
      },
      update: {
        method: 'PUT',
        params: {
          id: '@id'
        }
      },
      "delete": {
        method: 'DELETE',
        params: {
          id: '@id'
        }
      },
      bulkUpdateIssue: {
        method: 'POST',
        params: {
          verb: '_bulk',
          id: '_update'
        }
      },
      bulkDeleteIssue: {
        method: 'POST',
        params: {
          verb: '_bulk',
          id: '_delete'
        }
      },
      schemaOrDefault: {
        method: 'GET',
        params: {
          verb: '_codeordefault'
        }
      },
      callCenter: {
        method: 'GET',
        params: {
          verb: '_callcenter'
        }
      },
      getId: {
        method: 'GET',
        params: {
          verb: '_id',
          id: '@id'
        }
      },
      getUUID: {
        method: 'GET',
        params: {
          verb: '_current'
        }
      },
      getByCode: {
        method: 'GET',
        params: {
          verb: '_code',
          id: '@id'
        }
      },
      setStatus: {
        method: 'POST',
        params: {
          verb: '_setcurrentstate',
          version: '@version'
        }
      },
      byID: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_id'
        },
        ignoreLoadingBar: true
      },
      getMailReceiver: {
        method: 'POST',
        params: {
          verb: '_mailreceiver'
        }
      },
      // TIMELINE
      getTimeline: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_uuid',
          param1: param1
        }
      },
      getSchemaInTimeline: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_uuid'
        }
      }
    });
  };
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.odlFactory
 * @description
 * # odlFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.plan').factory('odlFactory', ["PLAN_URL", "$resource", function (PLAN_URL, $resource) {
  return function (entity, param1) {
    return $resource(PLAN_URL + '/api/odl/:entity/:verb/:id/:code/:param1', {}, {
      //ODl
      getOdlById: {
        method: 'GET',
        url: PLAN_URL + '/api/odl/record/:id'
      },
      getOdlByUUID: {
        method: 'GET',
        url: PLAN_URL + '/api/odl/_uuid/:uuid/_current'
      },
      getOdlList: {
        method: 'GET'
      },
      search: {
        method: 'POST',
        isArray: false,
        params: {
          verb: '_search'
        }
      },
      searchAggregated: {
        method: 'POST',
        isArray: false,
        params: {
          verb: '_aggregated',
          id: '_search'
        }
      },
      createOdl: {
        method: 'POST',
        url: PLAN_URL + '/api/odl'
      },
      bulkClose: {
        method: 'POST',
        url: PLAN_URL + '/api/odl/_bulk/_close'
      },
      updateOdl: {
        method: 'PUT',
        url: PLAN_URL + '/api/odl/:id'
      },
      bulkUpdateOdl: {
        method: 'POST',
        url: PLAN_URL + '/api/odl/_bulk/_update'
      },
      bulkDeleteOdl: {
        method: 'POST',
        url: PLAN_URL + '/api/odl/_bulk/_delete'
      },
      deletePlanOdl: {
        method: 'DELETE',
        url: PLAN_URL + '/api/odl/_delete/:id'
      },
      deleteIssueOdl: {
        method: 'DELETE',
        url: PLAN_URL + '/api/odl/:id'
      },
      getAssetsList: {
        method: 'GET',
        url: PLAN_URL + '/api/plan/odl/asset/_list/:id'
      },
      setStatus: {
        method: 'POST',
        params: {
          verb: '_setcurrentstatus'
        }
      },
      statuses: {
        method: 'GET',
        params: {
          verb: '_statuses'
        }
      },
      getMailReceiver: {
        method: 'POST',
        params: {
          entity: '_mailreceiver'
        }
      },
      getIssueNotAssigned: {
        method: 'GET',
        url: PLAN_URL + '/api/odl/_issueunassigned'
      },
      // ODL SCHEMA
      // getOdlSchema: id -> @commission
      getOdlSchema: {
        method: 'GET',
        params: {
          entity: 'schema',
          verb: '_codeordefault'
        }
      },
      getOdlSchemaList: {
        method: 'GET',
        params: {
          entity: 'schema'
        }
      },
      getOdlSchemaByCode: {
        method: 'GET',
        params: {
          entity: 'schema',
          verb: '_code'
        }
      },
      getOdlSchemaById: {
        method: 'GET',
        params: {
          entity: 'schema',
          verb: '_id'
        }
      },
      getOdlSchemaByUUID: {
        method: 'GET',
        params: {
          entity: 'schema',
          verb: '_uuid'
        }
      },
      deleteOdlSchema: {
        method: 'DELETE',
        params: {
          entity: 'schema'
        }
      },
      updateOdlSchema: {
        method: 'PUT',
        params: {
          entity: 'schema'
        }
      },
      createOdlSchema: {
        method: 'POST',
        params: {
          entity: 'schema'
        }
      },
      // ODL DASHBOARD
      // getDashboardConfigurationByRole: id -> @role; code -> @commission
      getDashboardConfigurationByRole: {
        method: 'GET',
        params: {
          entity: 'dashboard_config',
          verb: '_role'
        }
      },
      getDashboardConfigurationList: {
        method: 'GET',
        params: {
          entity: 'dashboard_config'
        }
      },
      getDashboardConfigurationByUUID: {
        method: 'GET',
        params: {
          entity: 'dashboard_config',
          verb: '_uuid'
        }
      },
      deleteDashboardConfiguration: {
        method: 'DELETE',
        params: {
          entity: 'dashboard_config'
        }
      },
      updateDashboardConfiguration: {
        method: 'PUT',
        params: {
          entity: 'dashboard_config'
        }
      },
      createDashboardConfiguration: {
        method: 'POST',
        params: {
          entity: 'dashboard_config'
        }
      },
      // TIMELINE
      getTimeline: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_uuid',
          param1: param1
        }
      },
      getSchemaInTimeline: {
        method: 'GET',
        isArray: false,
        params: {
          entity: 'schema',
          verb: '_uuid'
        }
      },
      referenceCount: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_referencecount'
        },
        ignoreLoadingBar: true
      },
      cleanInvoice: {
        method: 'POST',
        isArray: false,
        params: {
          entity: '_invoice',
          verb: 'clean',
          id: '@salUuid',
          code: '@odlUuid'
        }
      }
    });
  };
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.planFactory
 * @description
 * # planFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.plan').factory('planFactory', ["PLAN_URL", "$resource", "APP_URL", function (PLAN_URL, $resource, APP_URL) {
  return function (entity) {
    return $resource(PLAN_URL + '/api/' + entity + '/:id', {}, {
      getPlansList: {
        method: 'GET',
        url: PLAN_URL + '/api/plan/_list'
      },
      getPlanListFiltered: {
        method: 'POST',
        url: PLAN_URL + '/api/plan/_search'
      },
      getPlanByUUID: {
        method: 'GET',
        url: PLAN_URL + '/api/plan/_uuid/:id/_current'
      },
      getSimulationTargets: {
        method: 'POST',
        url: PLAN_URL + '/api/plan/_simulation/_targets'
      },
      deletePlan: {
        method: 'DELETE',
        url: PLAN_URL + '/api/plan/_delete/:id',
        params: {
          id: '@id'
        }
      },
      updatePlan: {
        method: 'PUT',
        url: PLAN_URL + '/api/plan/_update/:id',
        params: {
          id: '@id'
        }
      },
      savePlan: {
        method: 'POST',
        url: PLAN_URL + '/api/plan/_save'
      },
      bulkImport: {
        method: 'POST',
        url: PLAN_URL + '/api/plan/_bulk'
      },
      generateOdl: {
        method: 'POST',
        url: PLAN_URL + '/api/plan/_generate'
      },
      referenceCount: {
        method: 'GET',
        url: PLAN_URL + '/api/plan/_referencecount/:id',
        isArray: false,
        ignoreLoadingBar: true
      },
      // Da lasciare: servono per lookup
      query: {
        method: 'GET'
      },
      search: {
        method: 'POST'
      },
      show: {
        method: 'GET'
      }
    });
  };
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.planOdlFactory
 * @description
 * # planOdlFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.plan').factory('planOdlFactory', ["PLAN_URL", "$resource", function (PLAN_URL, $resource) {
  return function (entity) {
    return $resource(PLAN_URL + '/api/' + entity + '/:id', {}, {
      search: {
        method: 'POST',
        url: PLAN_URL + '/api/plan/odl/_search'
      },
      getOldEvents: {
        method: 'POST',
        url: PLAN_URL + '/api/plan/odl/_events'
      },
      getGeneratedOdlList: {
        method: 'GET',
        url: PLAN_URL + '/api/plan/odl/_list/' + entity
      },
      getPlanOdlList: {
        method: 'GET',
        url: PLAN_URL + '/api/plan/odl/_list/'
      },
      getPlanning: {
        method: 'GET',
        url: PLAN_URL + '/api/plan/odl/_planning/'
      },
      deletePlanOdlList: {
        method: 'DELETE',
        url: PLAN_URL + '/api/plan/odl/_delete/:id',
        params: {
          id: '@id'
        }
      }
    });
  };
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.activityFactory
 * @description
 * # activityFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.plan').factory('questionFactory', ["PLAN_URL", "$resource", function (PLAN_URL, $resource) {
  return $resource(PLAN_URL + '/api/question/:verb/:id/:uuid', {}, {
    getById: {
      method: 'GET',
      params: {
        verb: '_id'
      }
    },
    getByUuid: {
      method: 'GET',
      params: {
        verb: '_uuid'
      }
    },
    getByCode: {
      method: 'GET',
      params: {
        verb: '_code'
      }
    },
    search: {
      method: 'POST',
      params: {
        verb: '_search'
      }
    },
    create: {
      method: 'POST'
    },
    update: {
      method: 'PUT',
      params: {
        id: '@id'
      }
    },
    "delete": {
      method: 'DELETE',
      params: {
        id: '@id'
      }
    },
    referenceCount: {
      method: 'GET',
      params: {
        verb: '_referencecount'
      },
      isArray: false,
      ignoreLoadingBar: true
    }
  });
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.surveyFactory
 * @description
 * # surveyFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.plan').factory('surveyFactory', ["PLAN_URL", "$resource", function (PLAN_URL, $resource) {
  return function (type) {
    return $resource(PLAN_URL + '/api/survey/' + type + '/:verb/:id/:uuid/:param1', {}, {
      getById: {
        method: 'GET',
        params: {
          verb: '_id'
        }
      },
      getByUuid: {
        method: 'GET',
        params: {
          verb: '_uuid'
        }
      },
      getByCode: {
        method: 'GET',
        params: {
          verb: '_code'
        }
      },
      search: {
        method: 'POST',
        params: {
          verb: '_search'
        }
      },
      bulkSave: {
        method: 'POST',
        params: {
          verb: '_bulk',
          id: '_document'
        }
      },
      create: {
        method: 'POST'
      },
      update: {
        method: 'PUT',
        params: {
          id: '@version'
        }
      },
      "delete": {
        method: 'DELETE',
        params: {
          id: '@version'
        }
      },
      referenceCount: {
        method: 'GET',
        params: {
          verb: '_referencecount'
        },
        isArray: false,
        ignoreLoadingBar: true
      }
    });
  };
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.taskFactory
 * @description
 * # taskFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.plan').factory('taskFactory', ["PLAN_URL", "$resource", "DATA_SET_URL", function (PLAN_URL, $resource, DATA_SET_URL) {
  return $resource(PLAN_URL + '/api/task/:verb/:id/:uuid', {}, {
    getTaskById: {
      method: 'GET'
    },
    getTaskByUUID: {
      method: 'GET',
      params: {
        verb: '_uuid'
      }
    },
    getTasksList: {
      method: 'GET',
      params: {
        verb: '_list'
      }
    },
    getTasksListFiltered: {
      method: 'POST',
      params: {
        verb: '_search'
      }
    },
    deleteTask: {
      method: 'DELETE',
      params: {
        verb: '_delete'
      }
    },
    updateTask: {
      method: 'PUT',
      params: {
        verb: '_update'
      }
    },
    saveTask: {
      method: 'POST',
      params: {
        verb: '_save'
      }
    },
    getGantt: {
      method: 'GET',
      params: {
        verb: '_gantt'
      }
    },
    referenceCount: {
      method: 'GET',
      params: {
        verb: '_referencecount'
      },
      isArray: false,
      ignoreLoadingBar: true
    }
  });
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.treePlanConfigFactory
 * @description
 * # treePlanConfigFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.plan').factory('treePlanConfigFactory', ["DATA_SET_URL", "$resource", function (DATA_SET_URL, $resource) {
  return $resource(DATA_SET_URL + '/api/configuration/:verb/:type/:id/:typecode/:recordcode/:servicecode/:param1', {}, {
    getConfigurationByUUID: {
      method: 'GET',
      params: {
        verb: '_uuid'
      }
    },
    getConfigurationById: {
      method: 'GET',
      params: {
        verb: '_rawid'
      }
    },
    getTimeline: {
      method: 'GET',
      params: {
        verb: '_uuid'
      }
    },
    createConfiguration: {
      method: 'POST',
      params: {
        id: '@id'
      }
    },
    updateConfiguration: {
      method: 'PUT',
      params: {
        id: '@id'
      }
    },
    deleteConfiguration: {
      method: 'DELETE',
      params: {
        id: '@id'
      }
    },
    hardDeleteConfiguration: {
      method: 'DELETE',
      params: {
        verb: '_hard',
        id: '@id'
      },
      ignoreLoadingBar: true
    },
    /* chiamate per ottenere le configurazioni */
    getSupplierFiltered: {
      method: 'POST',
      params: {
        verb: '_supplier',
        type: '_filtered'
      }
    },
    getSupplierDefault: {
      method: 'POST',
      params: {
        verb: '_supplier',
        type: '_default'
      }
    },
    getCompanyFiltered: {
      method: 'POST',
      params: {
        verb: '_company',
        type: '_filtered'
      }
    },
    getCompanyDefault: {
      method: 'POST',
      params: {
        verb: '_company',
        type: '_default'
      }
    },
    getTechnicianExternalFiltered: {
      method: 'POST',
      params: {
        verb: '_operator',
        type: '_filtered'
      }
    },
    getTechnicianExternalDefault: {
      method: 'POST',
      params: {
        verb: '_operator',
        type: '_default'
      }
    },
    getHeadCommissionFiltered: {
      method: 'POST',
      params: {
        verb: '_operator',
        type: '_filtered'
      }
    },
    getHeadCommissionDefault: {
      method: 'POST',
      params: {
        verb: '_operator',
        type: '_default'
      }
    },
    getMaintainerFiltered: {
      method: 'POST',
      params: {
        verb: '_operator',
        type: '_filtered'
      }
    },
    getMaintainerDefault: {
      method: 'POST',
      params: {
        verb: '_operator',
        type: '_default'
      }
    },
    getOperatorFiltered: {
      method: 'POST',
      params: {
        verb: '_operator',
        type: '_filtered'
      }
    },
    getOperatorDefault: {
      method: 'POST',
      params: {
        verb: '_operator',
        type: '_default'
      }
    },
    getResponsable: {
      method: 'POST',
      params: {
        verb: '_responsable'
      }
    },
    getCompleteConfiguration: {
      method: 'POST',
      params: {
        verb: '_configuration'
      }
    },
    getConfigurationIssue: {
      method: 'POST',
      params: {
        verb: '_configuration'
      }
    },
    // callcenter
    getConfigurationOdl: {
      method: 'POST',
      params: {
        verb: '_configuration'
      }
    } // odl
  });
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.workflowFactory
 * @description
 * # workflowFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.plan').factory('workflowFactory', ["PLAN_URL", "$resource", "DATA_SET_URL", function (PLAN_URL, $resource, DATA_SET_URL) {
  return $resource(PLAN_URL + '/api/workflow/:verb/:id/:uuid', {}, {
    getWorkflowByUUID: {
      method: 'GET',
      params: {
        verb: '_uuid',
        uuid: '_current'
      }
    },
    getWorkflowsListFiltered: {
      method: 'POST',
      params: {
        verb: '_search',
        cross: true
      }
    },
    validateWorkflow: {
      method: 'POST',
      params: {
        verb: '_validate'
      }
    },
    deleteWorkflow: {
      method: 'DELETE'
    },
    updateWorkflow: {
      method: 'PUT'
    },
    saveWorkflow: {
      method: 'POST'
    },
    getWorkflowStatusMappings: {
      method: 'GET',
      params: {
        verb: '_statusmappings'
      }
    },
    getWorkflowStatus: {
      method: 'GET',
      params: {
        verb: '_status'
      }
    },
    getWorkflowStatuses: {
      method: 'GET',
      params: {
        verb: '_statuses'
      }
    },
    getWorkflowNextStatuses: {
      method: 'GET',
      params: {
        verb: '_outstatuses'
      }
    }
  });
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:InvoiceCtrl
 * @description
 * # InvoiceCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/invoice/:id', {
    templateUrl: 'plan/invoice/invoice_detail.html',
    controller: 'InvoiceCtrl'
  });
}]).controller('InvoiceCtrl', ["$scope", "$location", "$q", "$timeout", "authFactory", "$routeParams", "dialogService", "toaster", "invoiceFactory", "invoiceConfiguration", "schemaFactory", "sixGridPaginationConstants", "uiGridConstants", "invoiceWSFactory", "recordFactory", "ngDialog", "$filter", function ($scope, $location, $q, $timeout, authFactory, $routeParams, dialogService, toaster, invoiceFactory, invoiceConfiguration, schemaFactory, sixGridPaginationConstants, uiGridConstants, invoiceWSFactory, recordFactory, ngDialog, $filter) {
  var PATH_INVOICE = 'invoice';
  $scope.header = {
    model: {
      attachments: []
    }
  };
  $scope.form = {};
  $scope.datePicker = {
    from: new Date(),
    to: new Date()
  };
  $scope.dateOptionsFrom = {
    formatYear: 'yyyy',
    startingDay: 1,
    datepickerMode: 'day',
    minMode: 'day',
    maxMode: 'year'
  };
  $scope.dateOptionsTo = {
    formatYear: 'yyyy',
    startingDay: 1,
    datepickerMode: 'day',
    minMode: 'day',
    maxMode: 'year',
    minDate: $scope.header.model.from
  };
  $scope.periodTypeList = [{
    key: 'monthly',
    description: 'Mensile'
  }, {
    key: 'twomonthly',
    description: 'Bimestrale'
  }, {
    key: 'custom',
    description: 'Personalizzato'
  }];
  $scope.periodType = {
    selected: $scope.periodTypeList[0]
  };
  $scope.dateFormat = 'dd/MM/yyyy';
  $scope.odlFilter = {
    "issue-only": sixFiltersLib.exact('generated_by', 'issue')
  }; //rimuovere
  $scope.odlPanel = {
    open: false
  };
  $scope.forceChange = function (item) {
    $scope.header.model.odl_id = angular.copy($scope.header.model.odl_id);
  };
  $scope.invoiceTypes = invoiceConfiguration.getInvoiceTypes();
  if ($routeParams.id) {
    getSchema().then(function () {
      $scope.modelLoaded = true;
      if ($routeParams.id != 'new') {
        $scope.isNew = false;
        getInvoiceByUuid($routeParams.id);
      } else {
        $scope.isNew = true;
      }
    });
  }
  function getInvoiceByUuid(uuid) {
    invoiceFactory.getInvoiceByUUID({
      uuid: uuid
    }).$promise.then(function (response) {
      if (response) {
        $scope.header = fixDates(response);
        readAttachments($scope.header.model.attachments);
        $scope.loadRows();
      }
    })["catch"](function (response) {
      toaster.pop('error', 'Errore', 'Impossibile caricare la fattura');
    });
  }
  $scope.odlPanelClosed = function (selection) {
    $scope.odlPanel.open = false;
    if (!$scope.invoiceHasRows() && !$scope.isLocked()) {
      $scope.header.model.odl_id = selection;
    }
  };
  $scope["delete"] = function () {
    invoiceFactory.referenceCount({
      uuid: $scope.header.UUID
    }).$promise.then(function (response) {
      var deleteMessage = 'Eliminare la fattura "' + $scope.header.model.code + '"?';
      if (response.count != 0) {
        deleteMessage = 'La fattura: "' + $scope.header.model.code + '" è in uso nel sistema.<br> Vuoi rimuoverla comunque?';
      }
      dialogService.confirmDialog(deleteMessage, function () {
        invoiceFactory.deleteInvoice({
          uuid: $scope.header.version
        }).$promise.then(function (response) {
          $scope.back();
        });
      });
    });
  };
  $scope.back = function () {
    $location.path(PATH_INVOICE);
  };
  $scope.create = function () {
    //TODO: introdurre un contatore per il code? (come gli ODL)
    writeAttachments($scope.header.model.attachments);
    return invoiceFactory.saveInvoice($scope.header.model).$promise.then(function (response) {
      toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
      return response;
    })["catch"](function (rejection) {
      toaster.pop('error', 'Errore salvataggio', rejection.data.message ? rejection.data.message : rejection.statusText);
    });
  };
  $scope.update = function () {
    if (angular.isDefined($scope.header.model.attachments)) {
      writeAttachments($scope.header.model.attachments);
    }
    return invoiceFactory.updateInvoice({
      id: $scope.header.version
    }, $scope.header).$promise.then(function (invoiceResponse) {
      if ($scope.rowOverrides.edit.length + $scope.rowOverrides.insert.length + $scope.rowOverrides["delete"].length) {
        var insertModels = $scope.rowOverrides.insert.map(function (insert) {
          return insert.model;
        });
        var body = {
          insert: insertModels,
          edit: $scope.rowOverrides.edit,
          "delete": $scope.rowOverrides["delete"]
        };
        var overridePromise = invoiceFactory.updateInvoiceRows({
          id: invoiceResponse.version
        }, body).$promise;
      } else {
        var overridePromise = $q.resolve();
      }
      if ($scope.manualRowEdits.edit.length + $scope.manualRowEdits.insert.length + $scope.manualRowEdits["delete"].length) {
        var insertModels = $scope.manualRowEdits.insert.map(function (insert) {
          return insert.model;
        });
        var body = {
          insert: insertModels,
          edit: $scope.manualRowEdits.edit,
          "delete": $scope.manualRowEdits["delete"]
        };
        var manualRowsPromise = invoiceFactory.updateInvoiceAggregatedRows({
          id: invoiceResponse.version
        }, body).$promise;
      } else {
        var manualRowsPromise = $q.resolve();
      }
      return $q.all([overridePromise, manualRowsPromise]).then(function (rowResponses) {
        toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
        return invoiceResponse; //TODO: sarà visibile la variabile invoiceResponse???
      })["catch"](function (rejection) {
        toaster.pop('error', 'Errore salvataggio', rejection.data.message ? rejection.data.message : rejection.statusText);
      });
    })["catch"](function (rejection) {
      toaster.pop('error', 'Errore salvataggio', rejection.data.message ? rejection.data.message : rejection.statusText);
    });
  };
  $scope.saveForm = function () {
    if (isValidated()) {
      if ($scope.header.version) {
        return $scope.update();
      } else {
        return $scope.create();
      }
    } else {
      return $q.reject("Validazione fallita");
    }
  };
  $scope.saveAndBack = function () {
    $scope.saveForm().then(function () {
      $scope.back();
    });
  };
  $scope.saveAndGenerate = function () {
    $scope.saveForm().then(function (response) {
      $scope.header = fixDates(response);
      $scope.generateRows();
    });
  };
  function fixDates(data) {
    if (data.creationDate) {
      data.creationDate = new Date(data.creationDate);
    }
    if (data.dataIn) {
      data.dataIn = new Date(data.dataIn);
    }
    if (data.dataOut) {
      data.dataOut = new Date(data.dataOut);
    }
    if (data.model.from) {
      data.model.from = new Date(data.model.from);
    }
    if (data.model.to) {
      data.model.to = new Date(data.model.to);
    }
    $scope.periodType = {
      selected: $scope.periodTypeList[2]
    }; // custom
    $scope.datePicker.from = data.model.from;
    $scope.datePicker.to = data.model.to;
    return data;
  }
  function isValidated() {
    if (!$scope.header.model.code || !$scope.header.model.description || !$scope.header.model.invoiceType) {
      toaster.pop('error', "Errore", 'Codice, Descrizione e Tipologia sono obbligatori.');
      return false;
    }
    if (!$scope.header.model.from || !$scope.header.model.to) {
      toaster.pop('error', "Errore", 'Errore inserimento date: occorre inserire entrambe le date');
      return false;
    }
    if (!$scope.header.model.company_id || !$scope.header.model.service_id) {
      toaster.pop('error', "Errore", 'Azienda e Servizio sono obbligatori');
      return false;
    }
    return true;
  }
  $scope.manualRowGeneration = function () {
    if ($scope.rowsGridOptions.data.length > 0) {
      //alert se esistono già delle righe
      var deleteMessage = 'ATTENZIONE: le modifiche effettuate manualmente al dettaglio righe verranno sovrascritte.<br><br>\
        <b>La modifica sarà salvata immediatamente.</b><br>\
        Vuoi comunque rigenerare le righe per la fattura "' + $scope.header.model.code + '"?';
      dialogService.confirmDialog(deleteMessage, $scope.generateRows);
    } else {
      $scope.generateRows();
    }
  };
  $scope.deleteDetailRows = function () {
    if ($scope.rowsGridOptions.data.length > 0) {
      //elaboro solo se esistono già delle righe
      var deleteMessage = 'ATTENZIONE: le modifiche effettuate manualmente al dettaglio righe verranno sovrascritte.<br><br>\
        <b>La modifica sarà salvata immediatamente.</b><br>\
        Vuoi comunque eliminare le righe per la fattura "' + $scope.header.model.code + '"?';
      dialogService.confirmDialog(deleteMessage, function () {
        invoiceFactory.deleteGeneratedRowsByUUID({
          uuid: $scope.header.UUID
        }).$promise.then(function (updatedHeader) {
          $scope.header = fixDates(updatedHeader);
          $scope.loadRows();
        });
      });
    } else {
      toaster.pop('error', 'Errore', "Nessuna riga da eliminare");
    }
  };
  $scope.generateRows = function () {
    var notifyData = {
      async: true,
      to: null
    };
    var notifyToDialog = ngDialog.openConfirm({
      name: 'notifyToDialog',
      closeByDocument: false,
      showClose: true,
      data: notifyData,
      template: '' + '<div style="text-align:center"><i class="fa fa-list"></i>&nbsp; Notifica generazione righe</div><br>' + '<div class="m-l-n-xxs" style="clear: both">' + '<input type="checkbox" id="async_elaboration" ng-model="ngDialogData.async" style="clear: both" /> <label for="async_elaboration" class="control-label"> Invia via mail</label><br />' + '</div>' + '<div class="row wrapper" style="text-align:center; clear: both" ng-show="ngDialogData.async">' + 'Invia una notifica di completamento al seguente indirizzo:<br>' + '<input class="form-control" type="email" ng-model="ngDialogData.to" placeholder="email"><br />' + '</div>' + '<div class="row" style="text-align:center; clear: both">' + '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ng-click="confirm(ngDialogData)">Continua</button>' + '</div>',
      plain: true,
      className: 'ngdialog-theme-default ngdialog-theme-custom'
    });
    var userFilter = {
      'model.username': sixFiltersLib.exact('model.username', authFactory.getAuthData().authId)
    };
    recordFactory('operatore').search(userFilter).$promise.then(function (resp) {
      if (resp.list) {
        notifyData.to = resp.list[0].model.mail;
      }
    });
    notifyToDialog.then(function (notify) {
      var to;
      if (notify.async) {
        to = notify.to;
      }
      invoiceFactory.generateRowsByUUID({
        uuid: $scope.header.UUID,
        notifyTo: to
      }, {}).$promise.then(function (updatedHeader) {
        toaster.pop('success', 'Operazione avviata', 'Avviata la generazione delle righe');
        $scope.header = fixDates(updatedHeader);
        invoiceWSFactory.subscribe('rowsGeneration/' + $scope.header.UUID);
      })["catch"](function (rejection) {
        toaster.pop('error', 'Errore generazione', rejection.data.message ? rejection.data.message : rejection.statusText);
      });
    }, function () {/* non fa nulla */});
  };
  $scope.$on("invoiceheaderChanged", function (event, invoiceheader) {
    //se è la fattura che sto visualizzando, aggiorno
    if (invoiceheader.UUID == $scope.header.UUID) {
      $scope.header = fixDates(invoiceheader); //FIXME: perdo le modifiche all'intestazione in corso!
      $scope.loadRows();
    }
  });
  $scope.loadRows = function () {
    if ($scope.header.model.generation_code) {
      invoiceFactory.getRows({
        id: $scope.header.version
      }).$promise.then(function (result) {
        if (result.list) {
          $scope.rowsGridOptions.data = angular.copy(result.list);
        } else {
          toaster.pop('error', 'Errore caricamento', "Nessun dettaglio righe trovato");
        }
      });
      invoiceFactory.getAggregatedRows({
        id: $scope.header.version
      }).$promise.then(function (result) {
        if (result.list) {
          $scope.aggregatedRowsGridOptions.data = angular.copy(result.list);
          invoiceConfiguration.getConfiguration().then(setGridColumns);
        } else {
          toaster.pop('error', 'Errore caricamento', "Nessuna riga aggregata trovata");
        }
      });
    }
    invoiceFactory.getAssets({
      id: $scope.header.version
    }).$promise.then(function (result) {
      if (result.list) {
        $scope.assetsGridOptions.data = angular.copy(result.list);
      } else {
        toaster.pop('error', 'Errore caricamento', "Nessun asset trovato");
      }
    });
  };
  $scope.isLocked = function () {
    return $scope.header.model.generation_pending;
  };
  $scope.invoiceHasRows = function () {
    return $scope.header.model.generation_code && $scope.aggregatedRowsGridOptions.data.filter(function (el) {
      return !el.model.source;
    }).length > 0;
  };
  $scope.toBeApproved = function () {
    return angular.isUndefined($scope.header.model.status);
  };
  $scope.approveInvoice = function () {
    var message = 'Confermi di voler approvare la fattura "' + $scope.header.model.code + '"?';
    dialogService.confirmDialog(message, function () {
      var update = {
        status: true
      };
      invoiceFactory.updateInvoiceStatus({
        id: $scope.header.version
      }, update).$promise.then(function (response) {
        $scope.header.model.status = true;
        $scope.header.version = response.version;
      });
    });
  };
  $scope.refuseInvoice = function () {
    var message = 'Confermi di voler rifiutare la fattura "' + $scope.header.model.code + '"?';
    dialogService.confirmDialog(message, function () {
      var update = {
        status: false
      };
      invoiceFactory.updateInvoiceStatus({
        id: $scope.header.version
      }, update).$promise.then(function (response) {
        $scope.header.model.status = false;
        $scope.header.version = response.version;
      });
    });
  };
  $scope.download = function (what) {
    //what = 'rows' o 'aggregatedRows' (default)
    var gridOpts = $scope[(what || 'aggregatedRows') + 'GridOptions'];
    if (gridOpts) {
      if (gridOpts.data.length == 0) {
        toaster.pop('error', 'Errore', "Nessuna riga generata per la fattura.");
        return;
      }
      var filename = $scope.header.model.code + "-" + $scope.header.model.description;
      sixExportLib.exportXLSXAllRowsGrid(gridOpts.gridApi, filename, ['id', 'delete'], true);
    }
  };
  function getSchema() {
    return schemaFactory().byCode({
      id: 'invoiceheader'
    }).$promise.then(function (resp) {
      if (resp.model) {
        $scope.schemaHeader = resp;
      } else {
        toaster.pop('error', 'Errore', "Impossibile recuperare il modello per la fatturazione.");
      }
    });
  }

  // Gestione allegati
  $scope.attachments = [];
  function readAttachments(modelList) {
    $scope.attachments.splice(0, $scope.attachments.length);
    for (var i = 0; i < modelList.length; i++) {
      $scope.attachments.push(modelList[i]);
    }
  }
  function writeAttachments(modelList) {
    modelList.splice(0, modelList.length);
    for (var i = 0; i < $scope.attachments.length; i++) {
      modelList.push($scope.attachments[i]);
    }
  }

  /* FORMATTING UTILS */
  $scope.lookupCellValueFormatter = function (value) {
    var formatted = "";
    if (typeof value != "undefined") {
      if (value !== null && angular.isArray(value)) {
        angular.forEach(value, function (row) {
          formatted += row.description + ' (' + row.code + '); \n';
        });
      } else if (value !== null && angular.isObject(value)) {
        formatted = value.description + ' (' + value.code + ')';
      } else {
        formatted = value;
      }
    }
    return formatted;
  };
  $scope.numberFormatter = function (value) {
    var decimals = 2;
    var result = Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
    if (!isNaN(result)) {
      return result.toString().replace(/\./g, ',');
    }
  };
  $scope.currencyFormatter = function (value) {
    var decimals = 4;
    var result = Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
    if (!isNaN(result)) {
      return result.toLocaleString('it-IT') + ' €';
    }
  };
  $scope.textFormatter = function (value) {
    //cerca di rendere leggibili anche i campi particolari
    if (Array.isArray(value)) {
      value = value.map($scope.textFormatter).join(', ');
    }
    //se è un oggetto cerco di formattarlo come possibile
    if (Object.prototype.toString.call(value) == '[object Object]') {
      if (value.partition && value.cost_center) {
        //caso ad-hoc per CDC
        value = value.cost_center.description + ': ' + value.partition + '%';
      } else {
        value = JSON.stringify(value);
      }
    }
    return value;
  };
  $scope.rowReasonFormatter = function (value) {
    if (Array.isArray(value)) {
      //rimuovo duplicati
      var seen = {};
      value = value.filter(function (item) {
        return !item || seen.hasOwnProperty(item) ? false : seen[item] = true;
      });
      value = value.map($scope.rowReasonFormatter).join(', ');
    }
    if (value == 'assetVariation') {
      value = "Asset modificato";
    }
    if (value == 'listVariation') {
      value = "Listino modificato";
    }
    if (value == 'consumptive') {
      value = "Consuntivo";
    }
    return value;
  };
  function isRef(obj) {
    return obj && obj.type && obj.UUID;
  }
  $scope.diffFormatter = function (value) {
    //cerca di rendere leggibili anche i campi particolari
    if (Array.isArray(value)) {
      value = value.map($scope.diffFormatter).join(', ');
    } else if (value) {
      //TODO: dovrebbe recuperare gli schema per rappresentare le chiavi in maniera leggibile
      var diffs = [];
      var diffObj = JSON.parse(value);
      Object.keys(diffObj).forEach(function (d) {
        var readable;
        var from = diffObj[d].left;
        var to = diffObj[d].right;
        if (isRef(from)) {
          from = $filter('reference')(from, 50);
        }
        if (isRef(to)) {
          to = $filter('reference')(to, 50);
        }
        if (!from && to) {
          readable = "Inserimento " + d + ": " + to;
        }
        if (!to && from) {
          readable = "Rimozione " + d + ": " + to;
        }
        if (from && to) {
          readable = "Modifica " + d + ": da: " + from + " - a: " + to;
        }

        //casi gestiti ad-hoc
        if (d == "attachments") {
          readable = to ? "Allegati modificati" : "Allegati rimossi";
        }
        if (readable) {
          diffs.push(readable);
        }
      });
      value = diffs.join(', ');
    }
    return value;
  };
  function dateFormat(date) {
    //formatta nel formato gg/mm/aaaa)
    return ('0' + date.getDate()).slice(-2) + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + date.getFullYear();
  }
  $scope.dateListFormatter = function (value) {
    if (Array.isArray(value)) {
      value = value.map(function (obj) {
        if (obj.from && obj.to) {
          var from = new Date(obj.from);
          var to = new Date(obj.to);
          if (from - to == 0) {
            return dateFormat(from);
          } else {
            return dateFormat(from) + ' - ' + dateFormat(to);
          }
        }
      }).join(', ');
    } else {
      value = JSON.stringify(value); //formato non valido
    }

    return value;
  };
  $scope.numberExportFormatter = function (value) {
    var decimals = 10;
    var result = Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
    if (!isNaN(result)) {
      return result;
    }
  };
  $scope.assetFormatter = function (value) {
    //formatta l'intero asset con lo stile di una reference
    return value.code + " - " + value.description;
  };
  $scope.assetLinkFormatter = function (value) {
    var baseUrl = $location.absUrl().replace(/#.*/, '');
    return baseUrl + "#/record/snap/" + value.schemaCode + "/" + value.UUID;
  };

  /***********************
   * CONFIG GRID/COLONNE
   ***********************/
  $scope.gridAppCallbacks = {};
  $scope.gridAppCallbacks['lookupCellValueFormatter'] = $scope.lookupCellValueFormatter;
  $scope.gridAppCallbacks['numberFormatter'] = $scope.numberFormatter;
  $scope.gridAppCallbacks['currencyFormatter'] = $scope.currencyFormatter;
  $scope.gridAppCallbacks['deleteRow'] = $scope.deleteRow;
  $scope.assetsGridOptions = {
    enableGridMenu: true,
    exporterCsvColumnSeparator: ';',
    exporterMenuPdf: false,
    gridMenuCustomItems: [{
      title: 'Adatta colonne',
      icon: 'fa fa-text-width',
      action: function action($event) {
        document.querySelectorAll(".ui-grid-column-resizer.right").forEach(function (el) {
          el.dispatchEvent(new CustomEvent("dblclick"));
        });
      },
      order: 208
    }],
    data: [],
    columnDefs: [{
      displayName: '',
      field: 'id',
      width: 36,
      enableFiltering: false,
      enableSorting: false,
      cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/timeline/{{row.entity.schemaCode}}/{{row.entity.UUID}}/v/{{row.entity.version}}" class="btn btn-xs btn-primary">' + '<span class="fa fa-search"></span>' + '</a>' + '</div>'
    }, {
      displayName: 'Codice',
      field: 'model.code'
    }, {
      displayName: 'Descrizione',
      field: 'model.description'
    }, {
      displayName: 'Inizio Validità',
      field: 'dataIn',
      type: 'date',
      cellFilter: 'date:\'dd/MM/yyyy HH:mm:ss\'',
      width: 140
    }, {
      displayName: 'Termine Validità',
      field: 'dataOut',
      type: 'date',
      cellFilter: 'date:\'dd/MM/yyyy HH:mm:ss\'',
      width: 140
    }]
  };
  $scope.rowOverrides = {
    edit: [],
    insert: [],
    "delete": []
  };
  $scope.rowsGridOptions = {
    enableGridMenu: true,
    exporterCsvColumnSeparator: ';',
    exporterMenuPdf: false,
    onRegisterApi: function onRegisterApi(gridApi) {
      _onRegisterApi(gridApi, $scope.rowsGridOptions, $scope.rowOverrides);
    },
    showColumnFooter: true,
    gridMenuCustomItems: [{
      title: 'Adatta colonne',
      icon: 'fa fa-text-width',
      action: function action($event) {
        document.querySelectorAll(".ui-grid-column-resizer.right").forEach(function (el) {
          el.dispatchEvent(new CustomEvent("dblclick"));
        });
      },
      order: 208
    }],
    data: [],
    enableCellEdit: true,
    cellEditableCondition: function cellEditableCondition(cellScope, triggerEvent) {
      return $scope.isRowOverrideAllowed();
    },
    columnDefs: [{
      displayName: 'Dal',
      field: 'model.from',
      type: 'date',
      cellFilter: 'date:\'dd/MM/yyyy\'',
      width: 80,
      exportFormat: 'd'
    }, {
      displayName: 'Al',
      field: 'model.to',
      type: 'date',
      cellFilter: 'date:\'dd/MM/yyyy\'',
      width: 80,
      exportFormat: 'd'
    }, {
      displayName: 'Giorni',
      field: 'model.formula.segment_days',
      cellTemplate: '<div class="ui-grid-cell-contents cont-right">{{grid.appScope.numberFormatter(grid.getCellValue(row, col))}}</div>',
      transform: $scope.numberExportFormatter,
      exportFormat: 'n'
    }, {
      displayName: 'Aperture',
      field: 'model.formula.open_days',
      cellTemplate: '<div class="ui-grid-cell-contents cont-right">{{grid.appScope.numberFormatter(grid.getCellValue(row, col))}}</div>',
      transform: $scope.numberExportFormatter,
      exportFormat: 'n'
    }, {
      displayName: 'UM',
      field: 'model.formula.um'
    }, {
      displayName: 'Qtà',
      field: 'model.formula.quantita',
      cellTemplate: '<div class="ui-grid-cell-contents cont-right">{{grid.appScope.numberFormatter(grid.getCellValue(row, col))}}</div>',
      transform: $scope.numberExportFormatter,
      exportFormat: 'n'
    }, {
      displayName: 'Costo unitario',
      field: 'model.formula.costo_unitario',
      cellTemplate: '<div class="ui-grid-cell-contents cont-right">{{grid.appScope.currencyFormatter(grid.getCellValue(row, col))}}</div>',
      transform: $scope.numberExportFormatter,
      exportFormat: 'n'
    }, {
      displayName: 'Costo standard',
      field: 'model.formula.costo_standard',
      cellTemplate: '<div class="ui-grid-cell-contents cont-right">{{grid.appScope.currencyFormatter(grid.getCellValue(row, col))}}</div>',
      transform: $scope.numberExportFormatter,
      exportFormat: 'n',
      aggregationType: uiGridConstants.aggregationTypes.sum,
      footerCellTemplate: '<div class="ui-grid-cell-contents cont-right">{{grid.appScope.currencyFormatter(col.getAggregationValue())}}</div>'
    }, {
      displayName: 'Costo standard netto',
      field: 'model.formula.costo_standard_netto',
      cellTemplate: '<div class="ui-grid-cell-contents cont-right">{{grid.appScope.currencyFormatter(grid.getCellValue(row, col))}}</div>',
      transform: $scope.numberExportFormatter,
      exportFormat: 'n',
      aggregationType: uiGridConstants.aggregationTypes.sum,
      footerCellTemplate: '<div class="ui-grid-cell-contents cont-right">{{grid.appScope.currencyFormatter(col.getAggregationValue())}}</div>'
    }, {
      displayName: 'Sconto %',
      field: 'model.formula.sconto_perc'
    }, {
      displayName: 'Costo netto',
      field: 'model.formula.costo_netto',
      cellTemplate: '<div class="ui-grid-cell-contents cont-right">{{grid.appScope.currencyFormatter(grid.getCellValue(row, col))}}</div>',
      transform: $scope.numberExportFormatter,
      exportFormat: 'n',
      aggregationType: uiGridConstants.aggregationTypes.sum,
      width: 100,
      footerCellTemplate: '<div class="ui-grid-cell-contents cont-right">{{grid.appScope.currencyFormatter(col.getAggregationValue())}}</div>'
    }, {
      displayName: 'Servizio',
      field: 'model.service_id',
      cellTemplate: '<div class="ui-grid-cell-contents" title="{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}">{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}</div>',
      editableCellTemplate: '<lookup-modal sx-row="row.entity" sx-type="servizio" sx-field="model.service_id"></lookup-modal>'
    }, {
      displayName: 'Azienda',
      field: 'model.company_id',
      cellTemplate: '<div class="ui-grid-cell-contents" title="{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}">{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}</div>',
      editableCellTemplate: '<lookup-modal sx-row="row.entity" sx-type="azienda" sx-field="model.company_id"></lookup-modal>'
    }, {
      displayName: 'Asset',
      field: 'model.asset.model',
      cellTemplate: '<div class="ui-grid-cell-contents" ng-show="row.entity.model.asset.UUID">' + '<a ng-href="#/timeline/{{row.entity.model.asset.schemaCode}}/{{row.entity.model.asset.UUID}}/v/{{row.entity.model.asset.version}}" class="btn btn-xs btn-primary">' + '<span class="fa fa-search"></span>' + '</a> ' + ' {{row.entity.model.asset.model.code}} - {{row.entity.model.asset.model.description}} ' + '</div>',
      transform: $scope.assetFormatter,
      editableCellTemplate: '<lookup-modal sx-row="row.entity" sx-field="model.asset" sx-use-ref="false"></lookup-modal>'
    }, {
      displayName: 'Stato Asset',
      field: 'model.row_reason',
      cellTemplate: '<div class="ui-grid-cell-contents">{{grid.appScope.rowReasonFormatter(grid.getCellValue(row, col))}}</div>',
      transform: $scope.rowReasonFormatter
    }, {
      displayName: 'Variazioni Asset',
      field: 'model.asset_variation',
      cellTemplate: '<div class="ui-grid-cell-contents" title="{{grid.appScope.diffFormatter(grid.getCellValue(row, col))}}">\
            {{grid.appScope.diffFormatter(grid.getCellValue(row, col)) | limitTo:50}}',
      transform: $scope.diffFormatter
    }, {
      displayName: 'Inizio Validità Asset',
      field: 'model.asset.dataIn',
      type: 'date',
      cellFilter: 'date:\'dd/MM/yyyy HH:mm:ss\'',
      enableCellEdit: false,
      exportFormat: 'd'
    }, {
      displayName: 'Termine Validità Asset',
      field: 'model.asset.dataOut',
      type: 'date',
      cellFilter: 'date:\'dd/MM/yyyy HH:mm:ss\'',
      enableCellEdit: false,
      exportFormat: 'd'
    }, isRowOverrideAllowed() ? {
      displayName: '',
      field: 'delete',
      width: 36,
      enableCellEdit: false,
      enableFiltering: false,
      enableSorting: false,
      enableHiding: false,
      enableColumnMenu: false,
      cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-click="grid.appScope.deleteRow(row, \'rowsGridOptions\', \'rowOverrides\')" class="btn btn-xs btn-danger"><i class="fa fa-times"></i></a>' + '</div>'
    } : {
      field: 'delete',
      visible: false,
      enableHiding: false
    }]
  };
  $scope.manualRowEdits = {
    edit: [],
    insert: [],
    "delete": []
  };
  $scope.aggregatedRowsGridOptions = {
    enableGridMenu: true,
    exporterCsvColumnSeparator: ';',
    exporterMenuPdf: false,
    onRegisterApi: function onRegisterApi(gridApi) {
      _onRegisterApi(gridApi, $scope.aggregatedRowsGridOptions, $scope.manualRowEdits);
    },
    showColumnFooter: true,
    gridMenuCustomItems: [{
      title: 'Adatta colonne',
      icon: 'fa fa-text-width',
      action: function action($event) {
        document.querySelectorAll(".ui-grid-column-resizer.right").forEach(function (el) {
          el.dispatchEvent(new CustomEvent("dblclick"));
        });
      },
      order: 208
    }],
    data: [],
    enableFiltering: true,
    enableCellEdit: true,
    cellEditableCondition: function cellEditableCondition(cellScope, triggerEvent) {
      if ($scope.manualRowsAllowed()) {
        return cellScope.row.entity.model.source;
      }
      return false;
    },
    columnDefs: [{
      displayName: '',
      field: 'id',
      width: 36,
      enableFiltering: false,
      enableSorting: false,
      cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/{{row.entity.asset.schemaCode}}/{{row.entity.asset.UUID}}" class="btn btn-xs btn-primary">' + '<span class="fa fa-search"></span>' + '</a>' + '</div>'
    }, {
      displayName: 'Codice',
      field: 'asset.model.code',
      enableFiltering: true,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }, {
      displayName: 'Descrizione',
      field: 'asset.model.description',
      enableFiltering: true,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }]
  };
  function _onRegisterApi(gridApi, gridApiDestination, editsDestination) {
    gridApiDestination.gridApi = gridApi;
    if (editsDestination) {
      gridApi.edit.on.afterCellEdit($scope, function (gridOptions, destination) {
        return function (rowEntity) {
          afterCellEditCallback(gridOptions, destination, rowEntity);
        };
      }(gridApiDestination, editsDestination));
      gridApi.rowEdit.on.saveRow($scope, function (gridOptions) {
        return function (rowEntity) {
          onSaveRowCallback(gridOptions, rowEntity);
        };
      }(gridApiDestination));
    }
  }
  function pushParentsCols(dataSource, columnDest) {
    if (dataSource && dataSource.length) {
      var knownParentTypes = [];
      dataSource.forEach(function (row) {
        if (row.model && row.model.asset && row.model.asset[0].parents) {
          row.model.asset[0].parents.forEach(function (parent) {
            if (parent.type) knownParentTypes.push(parent.type);
          });
        }
      });
      knownParentTypes = knownParentTypes.filter(function (value, index, self) {
        return self.indexOf(value) === index && value != "definition";
      });
      knownParentTypes.forEach(function (type) {
        //FIXME: prendere model.asset[0] ha senso solo se i dati non sono aggregati o se l'aggregazione è "omogenea"
        var itemCode = {
          displayName: "Codice " + type,
          field: "model.asset[0].parents_flat." + type + ".code",
          cellTemplate: '<div class="ui-grid-cell-contents">{{grid.appScope.textFormatter(grid.getCellValue(row, col))}}</div>',
          transform: $scope.textFormatter
        };
        columnDest.push(itemCode);
        var itemDescr = {
          displayName: "Descrizione " + type,
          field: "model.asset[0].parents_flat." + type + ".description",
          cellTemplate: '<div class="ui-grid-cell-contents">{{grid.appScope.textFormatter(grid.getCellValue(row, col))}}</div>',
          transform: $scope.textFormatter
        };
        columnDest.push(itemDescr);
      });
    }
  }
  function setGridColumns(config) {
    var cols = config.columnMapping[$scope.header.model.invoiceType];
    $scope.aggregatedRowsGridOptions.columnDefs = [];
    cols.forEach(function (col) {
      if (col.field == "parents") {
        pushParentsCols($scope.aggregatedRowsGridOptions.data, $scope.aggregatedRowsGridOptions.columnDefs);
      } else {
        var item = {
          displayName: col.description,
          field: col.field
        };
        //customizzazione in base al format
        switch (col.format) {
          case 'number':
            item.cellTemplate = '<div class="ui-grid-cell-contents cont-right">\
                {{grid.appScope.numberFormatter(grid.getCellValue(row, col))}}\
              </div>';
            item.transform = $scope.numberExportFormatter;
            item.exportFormat = 'n';
            break;
          case 'currency':
            item.cellTemplate = '<div class="ui-grid-cell-contents cont-right">\
                {{grid.appScope.currencyFormatter(grid.getCellValue(row, col))}}\
              </div>';
            item.transform = $scope.numberExportFormatter;
            item.exportFormat = 'n';
            break;
          case 'string':
            item.cellTemplate = '<div class="ui-grid-cell-contents">\
                {{grid.appScope.textFormatter(grid.getCellValue(row, col))}}\
              </div>';
            item.transform = $scope.textFormatter;
            break;
          case 'diff':
            item.cellTemplate = '<div class="ui-grid-cell-contents" title="{{grid.appScope.diffFormatter(grid.getCellValue(row, col))}}">\
                {{grid.appScope.diffFormatter(grid.getCellValue(row, col)) | limitTo:50}}\
              </div>';
            item.transform = $scope.diffFormatter;
            break;
          case 'date-list':
            item.cellTemplate = '<div class="ui-grid-cell-contents">\
                {{grid.appScope.dateListFormatter(grid.getCellValue(row, col))}}\
              </div>';
            item.transform = $scope.dateListFormatter;
            break;
          case 'date':
            item.exportFormat = 'd';
            break;
          default:
          //nessuna customizzazione
        }

        //asset e um vanno gestiti diversamente
        if (col.field == "model.formula.um") {
          item.cellTemplate = '<div class="ui-grid-cell-contents">{{grid.getCellValue(row, col).join(",")}}</div>';
          item.transform = function (v) {
            return v.join(",");
          };
        }
        if (col.field.match(/^(model\.asset)(\..*)$/)) {
          item.field = col.field.replace(/^(model\.asset)(\..*)$/, "$1[0]$2");
          //TODO: mostrare tutti i valori, non solo il primo
        }

        if (col.field == "model.row_reason") {
          item.cellTemplate = '<div class="ui-grid-cell-contents">{{grid.appScope.rowReasonFormatter(grid.getCellValue(row, col))}}</div>';
          item.transform = $scope.rowReasonFormatter;
        }
        //imposto la somma per determinati campi
        if (col.field.match(/costo_standard|costo_standard_netto|costo_netto$/)) {
          item.aggregationType = uiGridConstants.aggregationTypes.sum;
          item.footerCellTemplate = '<div class="ui-grid-cell-contents cont-right">{{grid.appScope.currencyFormatter(col.getAggregationValue())}}</div>';
        }
        if (col.field.match(/costo_netto$/)) {
          item.pinnedRight = true;
        }
        if (col.field == "asset_link") {
          item.field = "model.asset[0]";
          item.cellTemplate = '<div class="ui-grid-cell-contents text-center">\
              <a href="{{grid.appScope.assetLinkFormatter(grid.getCellValue(row, col))}}" class="btn btn-xs btn-primary">\
                <span class="fa fa-search"></span>\
              </a>\
            </div>';
          item.transform = $scope.assetLinkFormatter;
          item.exportFormat = 'link:Dettaglio';
        }

        //TODO: gestire le lookup
        $scope.aggregatedRowsGridOptions.columnDefs.push(item);
      }
    });
    if ($scope.manualRowsAllowed()) {
      var item = {
        displayName: '',
        field: 'delete',
        width: 46,
        minWidth: 46,
        enableCellEdit: false,
        enableFiltering: false,
        enableSorting: false,
        enableHiding: false,
        enableColumnMenu: false,
        pinnedRight: true,
        cellTemplate: '<div class="ui-grid-cell-contents" ng-if="row.entity.model.source">' + '<a ng-click="grid.appScope.deleteRow(row, \'aggregatedRowsGridOptions\', \'manualRowEdits\')" class="btn btn-xs btn-danger"><i class="fa fa-times"></i></a>' + '</div>'
      };
      $scope.aggregatedRowsGridOptions.columnDefs.push(item);

      //resize colonne per leggibilità
      $timeout(function () {
        document.querySelectorAll(".ui-grid-column-resizer.right").forEach(function (el) {
          el.dispatchEvent(new CustomEvent("dblclick"));
        });
      }, 200);
    }
  }

  /* EDITING RIGHE (OVVERRIDE MANUALI) */
  function onSaveRowCallback(gridOptions, rowEntity) {
    var promise = $q.defer();
    gridOptions.gridApi.rowEdit.setSavePromise(rowEntity, promise.promise);
    promise.resolve();
  }
  function afterCellEditCallback(gridOptions, editsObj, rowEntity, column) {
    for (var field in rowEntity.model) {
      // pulisco la riga da campi vuoti
      if (rowEntity.model.hasOwnProperty(field) && rowEntity.model[field] == "") {
        delete rowEntity.model[field];
      }
    }
    $scope.addDataToGrid(gridOptions, editsObj, [rowEntity]);
  }

  /** DELETE RIGA */
  $scope.deleteRow = function (item, gridOptionsName, editsObjName) {
    var index = $scope[gridOptionsName].data.indexOf(item.entity);
    if (index > -1) {
      $scope[gridOptionsName].data.splice(index, 1); //rimuovo dalla grid
      if (item.entity.version) {
        //rimuovo dagli edit se serve
        $scope[editsObjName]["delete"].push(item.entity);
        var pos = isItemInArrayByUUID($scope[editsObjName].edit, item.entity);
        if (pos !== false) {
          $scope[editsObjName].edit.splice(pos, 1);
        }
      } else {
        //rimuovo dagli insert se serve
        var pos = isItemInArrayByUUID($scope[editsObjName].insert, item.entity);
        if (pos !== false) {
          $scope[editsObjName].insert.splice(pos, 1);
        }
      }
    }
  };

  /** INSERT RIGA */
  $scope.insertRow = function (gridOptionsName, editsObjName, source, schemaCode) {
    var days = Math.floor((new Date($scope.header.model.to) - new Date($scope.header.model.from)) / (24 * 3600 * 1000));
    var row = {
      UUID: sixObjectLib.makeGUID(),
      model: {
        company_id: $scope.header.model.company_id,
        service_id: $scope.header.model.service_id,
        formula: {
          segment_days: days,
          open_days: 0,
          closed_days: 0,
          quantita: 0,
          sconto_perc: 0,
          costo_unitario: 0,
          costo_standard: 0,
          costo_standard_netto: 0,
          costo_netto: 0
        },
        from: $scope.header.model.from,
        to: $scope.header.model.to
      }
    };
    if (source) {
      row.model.source = source;
    }
    if (schemaCode) {
      row.schemaCode = schemaCode;
    }
    $scope.addDataToGrid($scope[gridOptionsName], $scope[editsObjName], [row], true);
  };
  $scope.preprocessRows = function (gridOptions, rowsArray) {
    var promises = [];
    rowsArray.forEach(function (row) {
      var defer = $q.defer();
      var error = false;
      promises.push(defer.promise);
      if (row.schemaCode == 'invoicerow') {
        var errorMsg = 'Riga non valida, la riga non verrà salvata.';
        var required = {
          'model.asset.UUID': "Asset",
          'model.company_id.UUID': "Azienda",
          "model.service_id.UUID": "Servizio",
          "model.formula.segment_days": "Giorni calcolo",
          "model.formula.open_days": "Aperture",
          "model.formula.closed_days": "Chiusure",
          "model.formula.quantita": "Quantità",
          "model.formula.sconto_perc": "Sconto",
          "model.formula.costo_unitario": "Costo unitario",
          "model.formula.costo_standard": "Costo standard",
          "model.formula.costo_standard_netto": "Costo standard netto",
          "model.formula.costo_netto": "Costo netto",
          "model.from": "Dal",
          "model.to": "Al"
        };
        var keys = Object.keys(required);
        for (var k in keys) {
          var exists = keys[k].split('.').reduce(function (obj, current) {
            return obj && (obj[current] != null || typeof obj[current] != 'undefined') ? obj[current] : null;
          }, row);
          if (exists == null) {
            errorMsg += " Campo " + required[keys[k]] + " mancante.";
            error = true;
            break;
          }
        }
      }
      if (error) {
        defer.resolve({
          error: true,
          message: errorMsg,
          data: row
        });
      } else {
        defer.resolve(row);
      }
    });

    //per ogni riga ho una promise, verrà risolta con la riga elaborata
    return $q.all(promises);
  };
  $scope.addDataToGrid = function (gridOptions, editsObj, arrayToImport, silent) {
    console.log('Controllo e preprocesso i dati');
    $scope.preprocessRows(gridOptions, arrayToImport).then(function (rows) {
      rows.forEach(function (result) {
        var row = result.error ? result.data : result;
        //aggiorno la grid
        var isNewRow = true;
        for (var i = 0; i < gridOptions.data.length; i++) {
          if (gridOptions.data[i].UUID == row.UUID) {
            isNewRow = false;
            gridOptions.data[i] = row; // riga esistente: sostituisco
          }
        }

        if (isNewRow) {
          gridOptions.data.push(row); // nuova riga: la aggiungo alla grid
        }
        //aggiorno l'oggetto con gli edit se non ci sono stati errori
        if (!result.error) {
          if (row.version) {
            var pos = isItemInArrayByUUID(editsObj.edit, row);
            if (pos !== false) {
              editsObj.edit[pos] = row;
            } else {
              editsObj.edit.push(row);
            }
          } else {
            var pos = isItemInArrayByUUID(editsObj.insert, row);
            if (pos !== false) {
              editsObj.insert[pos] = row;
            } else {
              editsObj.insert.push(row);
            }
          }
        } else {
          if (!silent) {
            toaster.pop('error', 'Errore salvataggio', result.message);
          }
          if (row.version) {
            //se era già tra gli edit lo rimuovo
            var pos = isItemInArrayByUUID(editsObj.edit, row);
            if (pos !== false) {
              editsObj.edit.splice(pos, 1);
            }
          }
        }
      });
      $timeout(function () {
        gridOptions.gridApi.core.scrollTo(gridOptions.data[gridOptions.data.length - 1], gridOptions.columnDefs[0]);
      });
    })["catch"](function (error) {
      console.log(error); //TODO: visualizzazione errori di elaborazione
    });
  };

  function isItemInArrayByUUID(array, item) {
    for (var i = 0; i < array.length; i++) {
      if (array[i].UUID == item.UUID) {
        return i;
      }
    }
    return false;
  }
  $scope.$watch('datePicker.from', function (newVal, oldVal) {
    if (newVal && oldVal && newVal.getTime() !== oldVal.getTime()) {
      adjustDatePicker();
    }
    if ($scope.form.header && $scope.form.header.datePickerTo) {
      $timeout(function () {
        $scope.form.header.datePickerTo.$validate();
      });
    }
  });
  $scope.$watch('datePicker.to', function (newVal, oldVal) {
    if ($scope.form.header && $scope.form.header.datePickerFrom) {
      $timeout(function () {
        $scope.form.header.datePickerFrom.$validate();
      });
    }
  });
  $scope.$watchCollection('periodType', function (newVal, oldVal) {
    if ($scope.datePicker.from) {
      switch ($scope.periodType.selected.key) {
        case 'monthly':
        case 'twomonthly':
          $scope.dateFormat = 'MMMM yyyy';
          $scope.dateOptionsFrom.minMode = 'month';
          $scope.dateOptionsFrom.datepickerMode = 'month';
          $scope.dateOptionsTo.minMode = 'month';
          $scope.dateOptionsTo.datepickerMode = 'month';
          break;
        default:
          $scope.dateFormat = 'dd/MM/yyyy';
          $scope.dateOptionsFrom.minMode = 'day';
          $scope.dateOptionsFrom.datepickerMode = 'day';
          $scope.dateOptionsTo.minMode = 'day';
          $scope.dateOptionsTo.datepickerMode = 'day';
          $scope.dateOptionsTo.minDate = $scope.datePicker.from;
          break;
      }
      adjustDatePicker();
    }
  });
  function adjustDatePicker() {
    if ($scope.datePicker.from) {
      switch ($scope.periodType.selected.key) {
        case 'monthly':
          $scope.datePicker.from = new Date($scope.datePicker.from.getFullYear(), $scope.datePicker.from.getMonth(), 1);
          $scope.datePicker.to = new Date($scope.datePicker.from.getFullYear(), $scope.datePicker.from.getMonth() + 1, 0);
          break;
        case 'twomonthly':
          $scope.datePicker.from = new Date($scope.datePicker.from.getFullYear(), $scope.datePicker.from.getMonth(), 1);
          $scope.datePicker.to = new Date($scope.datePicker.from.getFullYear(), $scope.datePicker.from.getMonth() + 2, 0);
          break;
        default:
          break;
      }
      $scope.dateOptionsTo.minDate = $scope.datePicker.from;
    }
    $scope.header.model.from = $scope.datePicker.from;
    $scope.header.model.to = $scope.datePicker.to;
  }

  /*************************************
   * Check permissions
   *************************************/

  var RESOURCE_NAME = 'invoice';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
  $scope.isUpdatePermAllowed = function () {
    return authFactory.isUpdatePermAllowed(RESOURCE_NAME);
  };
  function isRowOverrideAllowed() {
    return authFactory.checkPerm(RESOURCE_NAME, 'ROW_OVERRIDE');
  }
  $scope.isRowOverrideAllowed = isRowOverrideAllowed;
  function manualRowsAllowed() {
    return authFactory.checkPerm(RESOURCE_NAME, 'MANUAL_ROW');
  }
  $scope.manualRowsAllowed = manualRowsAllowed;
  $scope.approvationAllowed = function () {
    return authFactory.checkPerm(RESOURCE_NAME, 'APPROVE');
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:InvoiceDiffCtrl
 * @description
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/invoice/diff/:version/:diffversion', {
    templateUrl: 'plan/invoice/invoice_diff.html',
    controller: 'InvoiceDiffCtrl'
  });
}]).controller('InvoiceDiffCtrl', ["$scope", "$q", "$routeParams", "$location", "$timeout", "$window", "toaster", "uiGridConstants", "authFactory", "invoiceFactory", "invoiceConfiguration", "schemaFactory", function ($scope, $q, $routeParams, $location, $timeout, $window, toaster, uiGridConstants, authFactory, invoiceFactory, invoiceConfiguration, schemaFactory) {
  $scope.gridApi = null;
  $scope.gridOptions = {
    enableGridMenu: true,
    exporterCsvColumnSeparator: ';',
    exporterMenuPdf: false,
    enableFiltering: false,
    enableSorting: true,
    multiSelect: true,
    showColumnFooter: true,
    onRegisterApi: function onRegisterApi(gridApi) {
      $scope.gridApi = gridApi;
    },
    data: [],
    columnDefs: [{
      name: ''
    }]
  };
  $scope.back = function () {
    $window.history.back();
  };
  $scope.gotoLeftVersion = function () {
    var obj = $scope.leftVersion;
    $location.path("/invoice/" + obj.UUID);
  };
  $scope.gotoRightVersion = function () {
    var obj = $scope.rightVersion;
    $location.path("/invoice/" + obj.UUID);
  };
  $scope.invertVersions = function () {
    var left = $scope.leftVersion.version;
    var right = $scope.rightVersion.version;
    $location.path("/invoice/diff/" + right + "/" + left);
  };
  function disableFormFields(form, fieldNames) {
    if (Array.isArray(form)) {
      for (var i in form) {
        form[i] = disableFormFields(form[i], fieldNames);
      }
    }
    if (!Array.isArray(fieldNames)) {
      fieldNames = [fieldNames];
    }
    if ("key" in form) {
      var intersection = [];
      if (Array.isArray(fieldNames) && Array.isArray(form.key)) {
        intersection = form.key.filter(function (n) {
          return fieldNames.indexOf(n) !== -1;
        });
      }
      if (!fieldNames || intersection.length) {
        form.htmlClass = "diff-highlight";
      } else {
        form.htmlClass = "de-emphasize";
      }
      //fix per evitare lo styling della validazione
      form.disableSuccessState = true;
      form.disableErrorState = true;
      form.feedback = false;
    } else {
      for (var i in form) {
        if (Object.prototype.hasOwnProperty.call(form, i) && Array.isArray(form[i])) {
          form[i] = disableFormFields(form[i], fieldNames);
        }
      }
    }
    return form;
  }
  $scope.lookupCellValueFormatter = function (value) {
    var formatted = "";
    if (typeof value != "undefined") {
      if (value !== null && angular.isArray(value)) {
        angular.forEach(value, function (row) {
          formatted += row.description + ' (' + row.code + '); \n';
        });
      } else if (value !== null && angular.isObject(value)) {
        formatted = value.description + ' (' + value.code + ')';
      } else {
        formatted = value;
      }
    }
    return formatted;
  };
  $scope.numberFormatter = function (value) {
    var decimals = 2;
    var result = Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
    if (!isNaN(result)) {
      return result;
    }
  };
  $scope.currencyFormatter = function (value) {
    var decimals = 4;
    var result = Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
    if (!isNaN(result)) {
      return result + ' €';
    }
  };
  $scope.knownSchema = [];
  $scope.loadKnownSchema = function () {
    if (Array.isArray($scope.typeList) && $scope.typeList.length > 0) {
      if (Array.isArray($scope.knownSchema) && $scope.knownSchema.length > 0) {
        return $q.resolve($scope.knownSchema);
      } else {
        if (Array.isArray($scope.knownSchema)) {
          var filters = {
            'typeIdFilter': sixFiltersLib["in"]('UUID', $scope.typeList)
          };
          var payload = {
            show_revision: false
          };
          $scope.knownSchema = schemaFactory().search(payload, filters).$promise.then(function (result) {
            $scope.knownSchema = result.list;
            return result;
          });
        }
        return $scope.knownSchema;
      }
    } else {
      return $q.resolve($scope.knownSchema);
    }
  };
  $scope.schemaCodeFormatter = function (value) {
    $scope.loadKnownSchema();
    var formatted = value;
    if (Array.isArray($scope.knownSchema)) {
      $scope.knownSchema.forEach(function (v) {
        if (v.model.code == value) {
          formatted = v.model.description;
        }
      });
    }
    return formatted;
  };
  $scope.diffFormatter = function (obj) {
    if (!obj.first) {
      return "Nuovo asset";
    }
    if (!obj.second) {
      return "Asset rimosso";
    }
    if (Array.isArray(obj.first.model.asset)) {
      obj.prev = obj.first.model.asset[0];
    } else {
      obj.prev = obj.first.model.asset;
    }
    if (Array.isArray(obj.second.model.asset)) {
      obj.current = obj.second.model.asset[0];
    } else {
      obj.current = obj.second.model.asset;
    }
    if (obj.prev.version == obj.current.version) {
      return "Nessuna variazione";
    }
    var readableDiffs = [];
    var modelDiff = diff.getDiff(obj.prev.model, obj.current.model, {
      strictNullCheck: false
    });
    var parentDiff = diff.getDiff(obj.prev.parents, obj.current.parents, {
      strictNullCheck: false
    });
    if (Object.keys(parentDiff).length) {
      if (obj.current.parents == null) {
        readableDiffs.push("Rimosso dal tree");
      } else if (obj.prev.parents == null) {
        var currentTree = $scope.treeFormatter(obj.current.parents);
        readableDiffs.push("Inserito su tree: " + currentTree);
      } else {
        var prevTree = $scope.treeFormatter(obj.prev.parents);
        var currentTree = $scope.treeFormatter(obj.current.parents);
        readableDiffs.push("Spostamento nel tree da: " + prevTree + " a " + currentTree);
      }
    }
    if (Object.keys(modelDiff).length) {
      angular.forEach(modelDiff, function (value, path) {
        var key = path.replace(/^\/([^\/]*).*$/, '$1');
        var keyDef = $scope.searchKeyInSchema(key, obj.current.schemaCode);
        var readableKey = keyDef.title;
        var oldValue = $scope.formatValue(obj.prev, keyDef, path);
        var newValue = $scope.formatValue(obj.current, keyDef, path);
        if (value.operation == "update" && oldValue && newValue) {
          readableDiffs.push("Modifica <span class=\"field\">" + readableKey + "</span>," + " da <span class=\"oldvalue\">" + oldValue + "</span>" + " a <span class=\"newvalue\">" + newValue + "</span>");
        } else if (value.operation == "add" && newValue) {
          readableDiffs.push("Inserito <span class=\"field\">" + readableKey + "</span>: " + "<span class=\"newvalue\">" + newValue + "</span>");
        } else if (value.operation == "delete" && oldValue) {
          readableDiffs.push("Eliminato <span class=\"field\">" + readableKey + "</span>." + " Valore precedente: <span class=\"oldvalue\">" + oldValue + "</span>");
        }
      });
    }
    return readableDiffs.join(';<br>');
  };
  $scope.treeFormatter = function (parents) {
    return "/" + parents.map(function (v) {
      if (v.code || v.treeLevel == 0) {
        var titleParts = [];
        if (v.type) {
          titleParts.push($scope.schemaCodeFormatter(v.type));
        }
        if (v.description) {
          titleParts.push(v.description);
        }
        if (!v.code && v.treeLevel == 0) {
          v.code = v.treeCode;
        }
        return '<span class="treeNode" title="' + titleParts.join(' - ') + '">' + v.code + '</span>';
      }
    }).join('/');
  };
  $scope.searchKeyInSchema = function (key, schemaCode) {
    $scope.loadKnownSchema();
    var formatted = {
      title: key,
      field: key
    };
    if (Array.isArray($scope.knownSchema)) {
      $scope.knownSchema.forEach(function (v) {
        if (v.model.code == schemaCode) {
          if (angular.isDefined(v.model.schema.properties[key])) {
            formatted = v.model.schema.properties[key];
            formatted.field = key;
          }
        }
      });
    }
    return formatted;
  };
  $scope.formatValue = function (source, keyDef, path) {
    var val = source.model[keyDef.field];
    if (val && keyDef.format == "lookup") {
      val = val.description + " (" + val.code + ")";
    }
    //TODO: gestire ad-hoc altri formati?
    if ((path.match(/\//g) || []).length > 1 && path.indexOf("UUID") == -1) {
      return false; //skippo le variazioni delle sottochiavi a meno che non sia un UUID
    }

    return val;
  };
  $scope.gridAppCallbacks = {};
  $scope.gridAppCallbacks['lookupCellValueFormatter'] = $scope.lookupCellValueFormatter;
  $scope.gridAppCallbacks['numberFormatter'] = $scope.numberFormatter;
  $scope.gridAppCallbacks['currencyFormatter'] = $scope.currencyFormatter;
  function getNested(object, field) {
    return field.split('.').reduce(function (obj, current) {
      var subParts = current.match(/(.*?)\[(.*?)\]/);
      if (subParts) {
        current = subParts[1];
        obj = obj && (obj[current] != null || typeof obj[current] != 'undefined') ? obj[current] : null;
        current = subParts[2];
      }
      return obj && (obj[current] != null || typeof obj[current] != 'undefined') ? obj[current] : null;
    }, object);
  }
  function customColCellClass(sourcePrefix, grid, row, col, rowRenderIndex, colRenderIndex) {
    var diffPrefix = sourcePrefix == 'first' ? 'second' : 'first';
    if (!row.entity[sourcePrefix] || !row.entity[diffPrefix]) {
      var wichIsMissing = !row.entity[sourcePrefix] ? sourcePrefix : diffPrefix;
      return "grid-miss-highlight miss-" + wichIsMissing;
    } else {
      var fieldToDiff = col.field.replace(new RegExp("^" + sourcePrefix + "\.(.*)$"), diffPrefix + ".$1");
      var currValue = getNested(row.entity, col.field);
      var nextValue = getNested(row.entity, fieldToDiff);
      if (JSON.stringify(currValue) !== JSON.stringify(nextValue)) {
        return "grid-diff-highlight col-pos-" + sourcePrefix;
      }
    }
  }
  function setGridColumns(config, invoiceType, prefixA, prefixB) {
    var cols = config.columnMapping[invoiceType];
    $scope.gridOptions.columnDefs = [];
    cols.forEach(function (col) {
      var firstCol = angular.copy(col);
      firstCol.description = prefixA + ' - ' + col.description;
      firstCol.field = 'first.' + col.field;
      firstCol.cellClass = angular.bind(null, customColCellClass, 'first');
      addGridColumn(firstCol);
      var secondCol = angular.copy(col);
      secondCol.description = prefixB + ' - ' + col.description;
      secondCol.field = 'second.' + col.field;
      secondCol.cellClass = angular.bind(null, customColCellClass, 'second');
      addGridColumn(secondCol);
      if (col.field == "model.formula.costo_netto") {
        diffCol = {
          description: 'Variazione costo netto',
          field: 'diff.costo_netto',
          format: 'currency'
        };
        addGridColumn(diffCol);
      }
    });
    //colonna con elenco modifiche asset
    var diffCol = {
      field: 'assetDiff',
      displayName: 'Variazioni Asset',
      cellTemplate: '<div class="ui-grid-cell-contents"><span ng-bind-html="grid.appScope.diffFormatter(row.entity)"></span></div>'
    };
    $scope.gridOptions.columnDefs.push(diffCol);
  }
  function addGridColumn(item) {
    item.displayName = item.description;
    //customizzazione in base al format
    switch (item.format) {
      case 'number':
        item.cellTemplate = '<div class="ui-grid-cell-contents">\
            {{grid.appScope.numberFormatter(grid.getCellValue(row, col))}}\
          </div>';
        item.transform = $scope.numberFormatter;
        break;
      case 'currency':
        item.cellTemplate = '<div class="ui-grid-cell-contents">\
            {{grid.appScope.currencyFormatter(grid.getCellValue(row, col))}}\
          </div>';
        item.transform = $scope.currencyFormatter;
        break;
      case 'date':
      case 'string':
      default:
      //nessuna customizzazione
    }

    //asset e um vanno gestiti diversamente
    if (item.field.match(/model\.formula\.um$/)) {
      item.cellTemplate = '<div class="ui-grid-cell-contents">{{grid.getCellValue(row, col).join(",")}}</div>';
      item.transform = function (v) {
        return v.join(",");
      };
    }
    if (item.field.match(/(model\.asset)(\..*)$/)) {
      item.field = item.field.replace(/(model\.asset)(\..*)$/, "$1[0]$2");
    }

    //imposto la somma per determinati campi
    if (item.field.match(/costo_standard|costo_standard_netto|costo_netto$/)) {
      item.aggregationType = uiGridConstants.aggregationTypes.sum;
      item.footerCellTemplate = '<div class="ui-grid-cell-contents cont-right">{{grid.appScope.currencyFormatter(col.getAggregationValue())}}</div>';
    }
    $scope.gridOptions.columnDefs.push(item);
  }

  //___ main ___
  schemaFactory().byCode({
    id: "invoiceheader"
  }).$promise.then(function (schemaResult) {
    var loadLeft = invoiceFactory.getInvoiceById({
      id: $routeParams.version
    }).$promise.then(function (result) {
      if (result) {
        $scope.leftVersion = result;
      } else {
        toaster.pop('error', 'Errore caricamento', "Impossibile caricare la fattura sinistra. Riprova.");
      }
      return result;
    });
    var loadRight = invoiceFactory.getInvoiceById({
      id: $routeParams.diffversion
    }).$promise.then(function (result) {
      if (result) {
        $scope.rightVersion = result;
      } else {
        toaster.pop('error', 'Errore caricamento', "Impossibile caricare la fattura destra. Riprova.");
      }
      return result;
    });
    var loadRows = invoiceFactory.getInvoiceDiff({
      id: $routeParams.version,
      uuid: $routeParams.diffversion
    }).$promise.then(function (result) {
      if (result && result.list) {
        $scope.rowData = result.list;
      }
      return result;
    })["catch"](function (rejection) {
      toaster.pop('error', 'Errore confronto', rejection.data.message ? rejection.data.message : rejection.statusText);
    });
    var configPromise = invoiceConfiguration.getConfiguration().then(function (result) {
      $scope.invoiceConfig = result;
    });
    $q.all([loadLeft, loadRight, loadRows, configPromise]).then(function (results) {
      var modelDiff = diff.getDiff($scope.leftVersion.model, $scope.rightVersion.model, {
        strictNullCheck: false
      });
      var fields = Object.keys(modelDiff).map(function (path) {
        return path.replace(/^\/([^\/]*).*$/, '$1');
      });
      $scope.schema = schemaResult.model.schema;
      $scope.form = disableFormFields(schemaResult.model.form, fields);
      setGridColumns($scope.invoiceConfig, $scope.leftVersion.model.invoiceType, $scope.leftVersion.model.code, $scope.rightVersion.model.code);
      $scope.gridOptions.data = $scope.rowData;

      //pezza per allargare le colonne
      $timeout(function () {
        document.querySelectorAll(".ui-grid-column-resizer.right").forEach(function (el) {
          el.dispatchEvent(new CustomEvent("dblclick"));
        });
      });
    });
  });
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:InvoiceListCtrl
 * @description
 * # InvoiceListCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/invoice', {
    templateUrl: 'plan/invoice/invoice_list.html',
    controller: 'InvoiceListCtrl'
  });
}]).controller('InvoiceListCtrl', ["$scope", "$location", "$filter", "sixGridPaginationConstants", "uiGridConstants", "authFactory", "invoiceFactory", "toaster", function ($scope, $location, $filter, sixGridPaginationConstants, uiGridConstants, authFactory, invoiceFactory, toaster) {
  $scope.invoiceList = {};
  $scope.params = {
    queryParam: '',
    filters: ''
  };
  $scope.autoResizeParams = {
    enabled: true,
    minHeight: 200,
    marginTop: 290
  };
  $scope.viewGridOptions = {
    columnDefs: [{
      name: ' '
    }]
  };
  var currentCommission = authFactory.getAuthData().info.commissions.current;
  var DEFAULT_SORT_FIELD = 'model.code';
  function defaultSort() {
    return $scope.sortFields ? $scope.sortFields : DEFAULT_SORT_FIELD;
  }
  var DEFAULT_SORT_ORDER = 'asc';
  function defaultSortOrder() {
    return $scope.sortOrder ? $scope.sortOrder : DEFAULT_SORT_ORDER;
  }
  function initGridColumns() {
    $scope.viewGridOptions.columnDefs = [];
    $scope.viewGridOptions.columnDefs.push({
      displayName: '',
      field: 'id',
      width: 36,
      enableCellEdit: true,
      enableFiltering: false,
      enableSorting: false,
      cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/invoice/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' + '<span class="fa fa-search"></span>' + '</a>' + '</div>'
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Codice',
      field: 'model.code',
      enableFiltering: true,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Descrizione',
      field: 'model.description',
      enableFiltering: true,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Servizio',
      field: 'model.service_id',
      cellTemplate: '<div class="ui-grid-cell-contents" title="{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}">{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}</div>'
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Azienda',
      field: 'model.company_id',
      cellTemplate: '<div class="ui-grid-cell-contents" title="{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}">{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}</div>'
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Tipologia',
      field: 'model.invoiceType'
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Importo',
      field: 'model.total_price',
      cellTemplate: '<div class="ui-grid-cell-contents cont-right">{{grid.appScope.currencyFormatter(grid.getCellValue(row, col))}}</div>'
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Data inizio',
      field: 'model.from',
      type: 'date',
      cellFilter: 'date:\'dd/MM/yyyy\'',
      width: 100,
      enableFiltering: true,
      filters: [{
        type: sixGridPaginationConstants.filterType.DATE,
        relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
        placeholder: 'da...',
        condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
      }, {
        type: sixGridPaginationConstants.filterType.DATE,
        relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
        placeholder: 'a...',
        condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Data fine',
      field: 'model.to',
      type: 'date',
      cellFilter: 'date:\'dd/MM/yyyy\'',
      width: 100,
      enableFiltering: true,
      filters: [{
        type: sixGridPaginationConstants.filterType.DATE,
        relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
        placeholder: 'da...',
        condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
      }, {
        type: sixGridPaginationConstants.filterType.DATE,
        relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
        placeholder: 'a...',
        condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Approvata',
      field: 'model.status',
      width: 120,
      enableFiltering: false,
      cellTemplate: '<div class="ui-grid-cell-contents text-center">\
            <span ng-if="row.entity.model.status===true"><i class="fa fa-check"></i> SI</span>\
            <span ng-if="row.entity.model.status===false">NO</span>\
          </div>'
    });
    $scope.lookupCellValueFormatter = function (value) {
      var formatted = "";
      if (typeof value != "undefined") {
        if (value !== null && angular.isArray(value)) {
          angular.forEach(value, function (row) {
            formatted += row.description + ' (' + row.code + '); \n';
          });
        } else if (value !== null && angular.isObject(value)) {
          formatted = value.description + ' (' + value.code + ')';
        } else {
          formatted = value;
        }
      }
      return formatted;
    };
    $scope.currencyFormatter = function (value) {
      var decimals = 4;
      var result = Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
      if (!isNaN(result)) {
        return result.toString().replace(/\./g, ',') + ' €';
      }
    };
    $scope.gridAppCallbacks = {
      'lookupCellValueFormatter': $scope.lookupCellValueFormatter,
      'currencyFormatter': $scope.currencyFormatter
    };
  }
  $scope.getData = function () {
    if (!$scope.params.sortFields || $scope.params.sortFields.trim() == '') {
      $scope.params.sortFields = 'model.code:asc';
    }
    var payload = {
      query: $scope.params.queryParam,
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      sort_fields: $scope.params.sortFields,
      show_revision: false
    };
    return invoiceFactory.searchInvoice(payload, $scope.params.filters).$promise.then(function (data) {
      $scope.invoiceList.totalResults = data.totalResults;
      $scope.invoiceList.list = data.list;
      return data;
    });
  };
  $scope.goToNewInvoice = function () {
    $location.path('invoice/new');
  };
  $scope.getLatestDate = function (filter) {
    var payload = {
      'commission': currentCommission.code
    };
    if (filter == 'approved' || filter && filter.indexOf('approved') != -1) {
      payload['approved'] = true;
    }
    if (filter == 'refused' || filter && filter.indexOf('refused') != -1) {
      payload['refused'] = true;
    }
    invoiceFactory.getLatestDate(payload).$promise.then(function (response) {
      var dateStr = $filter('date')(response.date, 'shortDate');
      toaster.pop('success', 'Data ultima fatturazione', "L'ultima data fatturata è: " + dateStr);
    })["catch"](function (rejection) {
      toaster.pop('error', 'Errore recupero fattura', rejection.data.message ? rejection.data.message : rejection.statusText);
    });
  };
  $scope.diffSelected = function () {
    var toDiff = $scope.params.gridApi.selection.getSelectedRows();
    var url = "/invoice/diff/" + toDiff[0].version + "/" + toDiff[1].version;
    $location.path(url);
  };
  $scope.noDiffReason = "";
  $scope.canDiff = function () {
    //verifica che ci siano almeno 2 dati selezionati dello stesso tipo
    if ($scope.params.gridApi) {
      var toDiff = $scope.params.gridApi.selection.getSelectedRows();
      if (toDiff.length == 2) {
        if (toDiff[0].model.company_id.UUID != toDiff[1].model.company_id.UUID || toDiff[0].model.service_id.UUID != toDiff[1].model.service_id.UUID || toDiff[0].model.invoiceType != toDiff[1].model.invoiceType) {
          $scope.noDiffReason = "I documenti selezionati non sono confrontabili";
          return false;
        }
        //TODO: includere un check sull'aggregazione, le due fatture devono avere una config che preveda l'aggregazione tramite asset
      } else {
        $scope.noDiffReason = "Devi selezionare esattamente 2 righe";
        return false;
      }
      $scope.noDiffReason = "";
      return true;
    }
    return false;
  };

  //__main__
  initGridColumns();

  /*************************************
   * Check permissions
   *************************************/

  var RESOURCE_NAME = 'invoice';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
  $scope.isUpdatePermAllowed = function () {
    return authFactory.isUpdatePermAllowed(RESOURCE_NAME);
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:InvoiceConfiguratorCtrl
 * @description
 * # InvoiceConfiguratorCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/invoiceconfigurator', {
    templateUrl: 'plan/invoice/invoiceconfigurator_list.html',
    controller: 'InvoiceConfiguratorCtrl'
  }).when('/invoiceconfigurator/page/:number', {
    templateUrl: 'plan/invoice/invoiceconfigurator_list.html',
    controller: 'InvoiceConfiguratorCtrl'
  }).when('/invoiceconfigurator/:id', {
    templateUrl: 'plan/invoice/invoiceconfigurator_detail.html',
    controller: 'InvoiceConfiguratorCtrl'
  });
}]).controller('InvoiceConfiguratorCtrl', ["$scope", "$q", "$location", "$route", "$routeParams", "$timeout", "$filter", "toaster", "dialogService", "authFactory", "commissionFactory", "formulaFactory", "invoiceFactory", "invoiceConfiguration", "schemaFactory", function ($scope, $q, $location, $route, $routeParams, $timeout, $filter, toaster, dialogService, authFactory, commissionFactory, formulaFactory, invoiceFactory, invoiceConfiguration, schemaFactory) {
  var PATH_CONFIG = 'invoiceconfigurator';
  $scope.bool = {
    isNew: false,
    isDefault: false
  };
  $scope.queryParam = '';
  $scope.pageSize = 10;
  $scope.commission = {
    selected: authFactory.getAuthData().info.commissions.current
  };
  $scope.prevData = {
    commission: [authFactory.getAuthData().info.commissions.current.code],
    code: authFactory.getAuthData().info.commissions.current.code
  };

  // dati di default
  $scope.invoiceConfig = {
    model: {
      code: '',
      commission: [$scope.commission.selected.code]
    }
  };
  $scope.commissions = [];
  $scope.invoiceTypes = invoiceConfiguration.getInvoiceTypes();
  $scope.plainConfigurationDefaultColumns = Object.values(invoiceConfiguration.getDefaultColumns()).join(', ');
  $scope.formulasList = [];
  formulaFactory.getFormulasList().$promise.then(function (result) {
    if (result.list) {
      $scope.formulasList = result.list;
    }
  });
  $scope.aceWaitingChange = null;
  $scope.aceChanged = function () {
    //uso $timeout per fare un po' di throttling e diff per non triggerare tutti i watcher
    $timeout.cancel($scope.aceWaitingChange);
    $scope.aceWaitingChange = $timeout(function () {
      var modifiedData = angular.fromJson(angular.copy($scope.aceModel));
      if (modifiedData) {
        var difference = diff.getDiff($scope.invoiceConfig.model, modifiedData, {
          strictNullCheck: false
        });
        diff.applyDiff($scope.invoiceConfig.model, difference);
      }
    }, 500);
  };
  $scope.aceLoaded = function () {
    $scope.aceModel = JSON.stringify($scope.invoiceConfig.model, null, '\t');
  };
  $scope.$watch('invoiceConfig.model', function (newValue, oldValue) {
    $scope.aceModel = JSON.stringify(angular.copy($scope.invoiceConfig.model), null, '\t');
  }, true);
  $scope.$watch('bool.isDefault', function (value) {
    if (value) {
      $scope.prevData.code = $scope.invoiceConfig.model.code;
      $scope.prevData.commission = $scope.invoiceConfig.model.commission;
      $scope.invoiceConfig.model.commission = null;
      $scope.setCode();
    } else {
      $scope.invoiceConfig.model.commission = $scope.prevData.commission;
      if ($scope.prevData.code == 'default') {
        $scope.setCode($scope.commission.selected.code);
      } else {
        $scope.invoiceConfig.model.code = $scope.prevData.code;
      }
    }
  });
  $scope.$watchGroup(['invoiceConfig.model.commission'], function () {
    if ($scope.invoiceConfig.model.commission) {
      $scope.setCode($scope.invoiceConfig.model.commission[0]);
    } else {
      $scope.setCode();
    }
  });
  $scope.setCommission = function ($item) {
    $scope.invoiceConfig.model.commission = [$item.code];
  };
  $scope.pageChanged = function () {
    $location.path(PATH_CONFIG + '/page/' + $scope.currentPage, false);
    $scope.configuratorList = invoiceFactory.getConfigurationList({
      query: $scope.queryParam,
      page: $scope.currentPage,
      cross: true
    });
  };
  $scope.printCommission = function (commission_array) {
    var commissions = [];
    if (commission_array != null) {
      angular.forEach(commission_array, function (value) {
        authFactory.getAuthData().info.commissions.list.forEach(function (c) {
          if (c.code == value) {
            commissions.push(c.code + ' - ' + c.description);
          }
        });
      });
    }
    return commissions.join(', ');
  };
  $scope.printConfiguration = function (model) {
    var infos = [];
    infos.push("Listini definiti: " + (Array.isArray(model.listMapping) ? model.listMapping.length : 0));
    infos.push("Aggregazione: " + (Array.isArray(model.aggregationMapping) && model.aggregationMapping.length ? 'Sì' : 'No'));
    infos.push("Formule predefinite: " + model.formulaConfig.map(function (el) {
      return el.defaultFormula;
    }).join(', '));
    return infos.join(' - ');
  };
  $scope.setCode = function (commission) {
    if (angular.isDefined(commission)) {
      $scope.invoiceConfig.model.code = commission.replace(/\s/g, "");
    } else {
      $scope.invoiceConfig.model.code = 'default';
    }
  };
  $scope.newConfiguration = function () {
    $location.path(PATH_CONFIG + '/new');
  };
  $scope.refresh = function () {
    $route.reload();
  };
  $scope.back = function () {
    $location.path(PATH_CONFIG);
  };
  $scope["delete"] = function () {
    //disabilitata, per reinserirla serve prima verificare in qualche modo che non si possano introdurre conflitti nel passato
    //es: elimino una catena di versioni, poi salvo un dato con dataIn nel passato che si sovrappone al dato "eliminato"
    return false;
    dialogService.confirmDialog('Eliminare la configurazione?', function () {
      invoiceFactory.deleteConfiguration({
        id: $scope.invoiceConfig.version
      }).$promise.then(function () {
        $scope.back();
      });
    });
  };
  $scope.getConfigurationById = function (UUID, version) {
    var promise;
    if (version) {
      //la ricerca per version ha la priorità
      promise = invoiceFactory.getConfigurationById({
        id: version
      }).$promise;
    } else {
      if ($scope.date.currentDate) {
        // altrimenti mi baso sull'UUID e la data settata
        promise = invoiceFactory.getConfigurationByUUID({
          param1: $filter('date')($scope.date.currentDate, 'yyyy-MM-dd'),
          id: UUID
        }).$promise;
      } else {
        promise = invoiceFactory.getConfigurationByUUID({
          id: UUID
        }).$promise;
      }
    }
    promise.then(function (response) {
      var responseDocument;
      if (response.model) {
        responseDocument = response;
      } else if (response.list && response.list[0].model) {
        responseDocument = response.list[0];
      }
      if (responseDocument) {
        $scope.invoiceConfig = fixDates(responseDocument);
        $scope.bool.isDefault = !$scope.invoiceConfig.model.commission;
        if (!$scope.bool.isDefault) {
          $scope.commission.selected = {
            code: $scope.invoiceConfig.model.commission[0]
          };
          for (var c in $scope.commissions) {
            if ($scope.commissions[c].code == $scope.commission.selected.code) {
              $scope.commission.selected = $scope.commissions[c];
            }
          }
        }
        $scope.modelLoaded = true;
      }
    });
  };
  $scope.getConfigurationList = function () {
    invoiceFactory.getConfigurationList({
      query: $scope.queryParam,
      pageSize: $scope.pageSize,
      cross: true
    }).$promise.then(function (response) {
      $scope.configuratorList = response;
    });
  };
  $scope.getCommission = function () {
    //TODO: rilevare quali commesse sono già state configurate ed escluderle
    commissionFactory().getCommissionsList().$promise.then(function (response) {
      if (response.list) {
        $scope.commissions = response.list;
      }
    });
  };
  $scope.create = function () {
    return invoiceFactory.saveConfiguration($scope.invoiceConfig).$promise.then(function () {
      toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
      $scope.back();
    })["catch"](function (rejection) {
      toaster.pop('error', 'Errore salvataggio', rejection.data.message ? rejection.data.message : rejection.statusText);
    });
  };
  $scope.update = function (overwrite) {
    var params = {
      id: $scope.invoiceConfig.version
    };
    if (overwrite) {
      params.history = false;
    }
    return invoiceFactory.updateConfiguration(params, $scope.invoiceConfig).$promise.then(function () {
      toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
      $scope.back();
    })["catch"](function (rejection) {
      toaster.pop('error', 'Errore salvataggio', rejection.data.message ? rejection.data.message : rejection.statusText);
    });
  };
  $scope.saveForm = function (overwrite) {
    //TODO: validazione
    if ($scope.invoiceConfig.version) {
      return $scope.update(overwrite);
    } else {
      return $scope.create();
    }
  };

  /* TIMELINE */
  $scope.date = {
    currentDate: null
  };
  $scope.timelineFlags = {
    showTimeline: false
  };
  $scope.changeCurrentDate = function (currentDate) {
    if (currentDate) {
      $scope.timelineFlags.showTimeline = true;
    }
    if ($scope.invoiceConfig.UUID) {
      $scope.getConfigurationById($scope.invoiceConfig.UUID);
    }
  };
  $scope.isPastVersion = function () {
    if ($scope.invoiceConfig.dataOut) {
      var dataOut = new Date($scope.invoiceConfig.dataOut);
      return dataOut < new Date();
    } else {
      return false;
    }
  };
  $scope.closeTimeline = function () {
    $scope.date.currentDate = null;
    $scope.timelineFlags.showTimeline = false;
  };
  function refreshTimeline() {
    var timeline = angular.element(document.getElementById('timeline_section'));
    timeline.scope().buildTimeline('configuration', $scope.invoiceConfig.UUID, $scope.invoiceConfig.version);
  }
  $scope.hardDelete = function () {
    $scope.deleteDialog.close();
    invoiceFactory.hardDeleteConfiguration({
      id: $scope.invoiceConfig.version
    }).$promise.then(function (response) {
      $scope.getConfigurationById($scope.invoiceConfig.UUID);
      refreshTimeline();
    });
  };
  $scope.openDeleteVersionDialog = function () {
    //TODO: inserire il controllo per verificare che la versione non sia utilizzata in un periodo già fatturato e approvato
    var deleteMessage = 'Stai eliminando permanentemente la versione <i>' + $scope.invoiceConfig.version + '</i> ' + 'del documento (dataIn: ' + $filter('date')($scope.invoiceConfig.dataIn, 'dd/MM/yyyy HH:mm:ss') + ' - dataOut: ' + $filter('date')($scope.invoiceConfig.dataOut, 'dd/MM/yyyy HH:mm:ss') + '), ' + 'modificandone la relativa timeline. <br />' + 'Probabilmente sarà necessario modificare anche gli attributi <i>dataIn</i> e <i>dataOut</i> delle versioni precedenti e successive a questa, per ripristinare una timeline coerente.<br /><br />' + '<b>L\'operazione è IRREVERSIBILE</b><br /><br />' + 'Eliminarla comunque?';
    var dialogScope = {
      lang: 'html',
      deleteMessage: deleteMessage,
      deleteFunction: $scope.hardDelete,
      notDeleteFunction: $scope.closeDeleteDialog
    };
    var opts = {
      name: 'infoDelete',
      closeByDocument: true,
      plain: false
    };
    $scope.deleteDialog = dialogService.templateDialog('recordDelete.html', dialogService.DIALOG_TYPE.DANGER, dialogScope, opts, -1, false);
  };
  $scope.closeDeleteDialog = function () {
    $scope.deleteDialog.close();
  };

  /* LISTMAPPING */
  $scope.listKeySortableOptions = {
    containerPositioning: 'relative',
    containment: '#listKeysManager'
  };
  $scope.addListMapping = function () {
    if (!$scope.invoiceConfig.model.listMapping) {
      $scope.invoiceConfig.model.listMapping = [];
    }
    $scope.invoiceConfig.model.listMapping.push({
      keylist: [{
        source: null,
        destination: null
      }]
    });
  };
  $scope.removeListMapping = function (pos) {
    $scope.invoiceConfig.model.listMapping.splice(pos, 1);
  };
  $scope.addListKey = function (pos) {
    if (!$scope.invoiceConfig.model.listMapping[pos].keylist) {
      $scope.invoiceConfig.model.listMapping[pos].keylist = [];
    }
    $scope.invoiceConfig.model.listMapping[pos].keylist.push({
      source: null,
      destination: null
    });
  };
  $scope.removeListKey = function (mappingPos, keyPos) {
    $scope.invoiceConfig.model.listMapping[mappingPos].keylist.splice(keyPos, 1);
  };
  $scope.availableFields = {};
  $scope.getAvailableFields = function (mappingPos, type) {
    var schema = $scope.invoiceConfig.model.listMapping[mappingPos][type];
    if (!schema) {
      return null;
    }
    if (!$scope.availableFields.hasOwnProperty(schema.UUID)) {
      $scope.availableFields[schema.UUID] = [];
      schemaFactory().byUUID({
        id: schema.UUID
      }).$promise.then(function (uuid) {
        return function (response) {
          if (response && response.model) {
            var props = response.model.schema.properties;
            if (type == 'asset_type_id') {
              //inject di azienda e servizio se il dato non li ha già
              if (angular.isUndefined(props.company_id)) {
                var row = {
                  'field': 'model.company_id.UUID',
                  'label': 'Azienda'
                };
                $scope.availableFields[uuid].push(row);
              }
              if (angular.isUndefined(props.service_id)) {
                var row = {
                  'field': 'model.service_id.UUID',
                  'label': 'Servizio'
                };
                $scope.availableFields[uuid].push(row);
              }
            }
            Object.keys(props).forEach(function (prop) {
              var row = {
                'field': 'model.' + prop,
                'label': props[prop].title
              };
              if (props[prop].format == 'lookup') {
                row.field += '.UUID';
              }
              $scope.availableFields[uuid].push(row);
            });
          }
        };
      }(schema.UUID));
    }
    return $scope.availableFields[schema.UUID];
  };

  /* FORMULACONFIG */
  $scope.addFormulaConfig = function () {
    $scope.invoiceConfig.model.formulaMapping = undefined; //fix old data
    $scope.invoiceConfig.model.defaultFormula = undefined; //fix old data
    if (!$scope.invoiceConfig.model.formulaConfig) {
      $scope.invoiceConfig.model.formulaConfig = [];
    }
    $scope.invoiceConfig.model.formulaConfig.push({});
  };
  $scope.removeFormulaConfig = function (pos) {
    $scope.invoiceConfig.model.formulaConfig.splice(pos, 1);
  };
  $scope.addFormulaMapping = function (typeIndex) {
    if (!$scope.invoiceConfig.model.formulaConfig[typeIndex].formulaMapping) {
      $scope.invoiceConfig.model.formulaConfig[typeIndex].formulaMapping = [];
    }
    $scope.invoiceConfig.model.formulaConfig[typeIndex].formulaMapping.push({});
  };
  $scope.removeFormulaMapping = function (typeIndex, pos) {
    $scope.invoiceConfig.model.formulaConfig[typeIndex].formulaMapping.splice(pos, 1);
  };

  /* COLUMNMAPPING */
  $scope.columnSortableOptions = {
    containerPositioning: 'relative',
    containment: '#columnManager'
  };
  $scope.availableFieldFormats = [{
    key: "string",
    description: "Testo"
  }, {
    key: "number",
    description: "Numero"
  }, {
    key: "currency",
    description: "Valuta"
  }, {
    key: "date",
    description: "Data"
  }];
  $scope.addColumnMapping = function () {
    if (!$scope.invoiceConfig.model.columnMapping) {
      $scope.invoiceConfig.model.columnMapping = [];
    }
    $scope.invoiceConfig.model.columnMapping.push({
      columns: [{
        active: true
      }]
    });
  };
  $scope.removeColumnMapping = function (pos) {
    $scope.invoiceConfig.model.columnMapping.splice(pos, 1);
  };
  $scope.availableColumns = {};
  $scope.loadAvailableColumns = function (key, column, firstTime) {
    if (!firstTime) {
      column.field = undefined;
    }
    $timeout(function () {
      //eseguo al successivo digest per attendere il valore della select
      if (!column.fieldType) {
        column.fieldAsset = undefined;
      } else {
        if (column.fieldType.key == 'default') {
          $scope.availableColumns[key] = invoiceConfiguration.getDefaultColumns();
          column.fieldAsset = undefined;
        } else if (column.fieldType.key == 'asset') {
          var assetPrefix = 'model.asset.model.';
          $scope.availableColumns[key] = undefined;
          if (column.fieldAsset) {
            schemaFactory().byUUID({
              id: column.fieldAsset.UUID
            }).$promise.then(function (response) {
              if (response && response.model) {
                var props = response.model.schema.properties;
                var result = [];
                Object.keys(props).forEach(function (prop) {
                  result[assetPrefix + prop] = props[prop].title;
                });
                $scope.availableColumns[key] = result;
              }
            });
          }
        }
      }
    });
  };
  $scope.addColumn = function (mappingIndex) {
    $scope.invoiceConfig.model.columnMapping[mappingIndex].columns.push({
      active: true
    });
  };
  $scope.removeColumn = function (mappingIndex, keyPos) {
    $scope.invoiceConfig.model.columnMapping[mappingIndex].columns.splice(keyPos, 1);
  };
  $scope.addDefaultColumns = function (mappingIndex) {
    var destination = $scope.invoiceConfig.model.columnMapping[mappingIndex].columns;
    var toAdd = invoiceConfiguration.getDefaultColumns();
    angular.forEach(toAdd, function (newColLabel, newColField) {
      var shouldAdd = true;
      destination.forEach(function (col) {
        if (!shouldAdd) return;
        if (col.field == newColField) {
          shouldAdd = false;
        }
      });
      if (shouldAdd) {
        destination.push({
          active: true,
          field: newColField,
          description: newColLabel,
          fieldType: {
            key: 'default',
            description: 'Predefinito'
          }
        });
      }
    });
  };
  $scope.setAssetColumnFormat = function (column, item) {
    if (item && item.key) {
      column.format = item.key;
    } else {
      column.format = undefined;
    }
  };

  /* AGGREGATION MAPPING */
  $scope.aggregationSortableOptions = {
    containerPositioning: 'relative',
    containment: '#aggregationManager'
  };
  $scope.knownAggregations = [{
    key: "UUID",
    description: "Nessuna"
  }, {
    key: "model.asset.UUID",
    description: "Asset"
  }, {
    key: "model.service_id.UUID",
    description: "Servizio"
  }, {
    key: "model.company_id.UUID",
    description: "Azienda"
  }];
  $scope.addAggregationMapping = function () {
    if (!$scope.invoiceConfig.model.aggregationMapping) {
      $scope.invoiceConfig.model.aggregationMapping = [];
    }
    $scope.invoiceConfig.model.aggregationMapping.push({
      aggregationKeys: []
    });
  };
  $scope.removeAggregationMapping = function (pos) {
    $scope.invoiceConfig.model.aggregationMapping.splice(pos, 1);
  };
  $scope.isInvoiceTypeMapped = function (item, source) {
    var mapping = $scope.invoiceConfig.model[source];
    for (var i = 0; i < mapping.length; i++) {
      if (mapping[i].type === item) {
        return true;
      }
    }
    return false;
  };
  function fixDates(data) {
    if (data.creationDate) {
      data.creationDate = new Date(data.creationDate);
    }
    if (data.dataIn) {
      data.dataIn = new Date(data.dataIn);
    }
    if (data.dataOut) {
      data.dataOut = new Date(data.dataOut);
    }
    return data;
  }
  $scope.modelsWithCompanyAndService = [];
  function loadModelsWithCompanyAndService() {
    var filters = {
      'withCompany': sixFiltersLib.exists('model.schema.properties.company_id'),
      'withService': sixFiltersLib.exists('model.schema.properties.service_id')
    };
    var payload = {
      show_revision: false
    };
    schemaFactory().search(payload, filters).$promise.then(function (response) {
      var result = [];
      if (response.list) {
        response.list.forEach(function (value) {
          result.push({
            code: value.model.code,
            description: value.model.description
          });
        });
      }
      $scope.modelsWithCompanyAndService = result;
    });
  }
  if ($routeParams.id) {
    if ($routeParams.id !== 'new') {
      $scope.bool.isNew = false;
      $scope.UUID = $routeParams.id;
      commissionFactory().getCommissionsList().$promise.then(function (response) {
        if (response.list.length) {
          $scope.commissions = response.list;
        }
        $scope.getConfigurationById($routeParams.id);
      });
    } else {
      $scope.bool.isNew = true;
      $scope.getCommission();
    }
    loadModelsWithCompanyAndService();
  } else {
    $scope.getConfigurationList();
  }

  /*************************************
   * Check permissions
   *************************************/

  var RESOURCE_NAME = 'invoice/configuration';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isWriteVersionAllowed = function () {
    return authFactory.checkPerm(RESOURCE_NAME, 'MODIFY_HISTORY');
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
  $scope.isUpdatePermAllowed = function () {
    return authFactory.isUpdatePermAllowed(RESOURCE_NAME);
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name emma.plan.controller:InvoiceTimelineCtrl
 * @description
 * # InvoiceTimelineCtrl
 * Controller of the emma.plan
 */
angular.module('emma.plan').controller('InvoiceTimelineCtrl', ["$scope", "$routeParams", "schemaFactory", "authFactory", "invoiceFactory", function ($scope, $routeParams, schemaFactory, authFactory, invoiceFactory) {
  var currentCommission = authFactory.getAuthData().info.commissions.current;
  $scope.data = {};
  $scope.model = {};
  $scope.timeline = [];
  var basePath = $routeParams.basePath || 'record';
  $scope.buildTimeline = function (entity, UUID, selectedVersion) {
    $scope.entity = entity;
    $scope.timeline = invoiceFactory.getTimeline({
      uuid: UUID,
      entity: entity
    }).$promise.then(function (data) {
      $scope.timeline = data.list;
      if (angular.isDefined(selectedVersion)) {
        $scope.model['version'] = selectedVersion;
      }
    });
  };
  $scope.getModelDetail = function (version) {
    invoiceFactory.byID({
      id: version,
      entity: entity
    }).$promise.then(function (data) {
      $scope.data = data;
      $scope.model.version = data.version;
      if (angular.isDefined(data.creationDate) && data.creationDate) {
        // elimino i millisecondi dalla visualizzazione
        var date = new Date(data.creationDate);
        data.creationDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
      }
      if (angular.isDefined(data.dataIn) && data.dataIn) {
        // elimino i millisecondi dalla visualizzazione
        var date = new Date(data.dataIn);
        data.dataIn = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
      }
    });
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:CallcenterCtrl
 * @description
 * # CallcenterCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/callcenter_detail/:id', {
    templateUrl: 'plan/issue/callcenter_detail.html',
    controller: 'CallcenterCtrl'
  }).when('/callcenter_list', {
    templateUrl: 'plan/issue/callcenter_list.html',
    controller: 'CallcenterCtrl'
  });
}]).controller('CallcenterCtrl', ["$routeParams", "$scope", "issueFactory", "recordFactory", "$location", "$log", "toaster", "localStorageService", "authFactory", "uiGridConstants", "issueToOdl", "$timeout", "errorService", "$route", "issueWorkflow", "ngDialog", "sixGridPaginationConstants", function ($routeParams, $scope, issueFactory, recordFactory, $location, $log, toaster, localStorageService, authFactory, uiGridConstants, issueToOdl, $timeout, errorService, $route, issueWorkflow, ngDialog, sixGridPaginationConstants) {
  var PATH_ISSUE_RECORD = 'issue/record';
  var PATH_ISSUE_SCHEMA = 'issue/schema';
  var PATH_CALLCENTER_DETAIL = 'callcenter_detail';

  /**  VARIABILI  **/
  $scope.issueList = {
    list: []
  };
  $scope.autoResizeParams = {
    autoresize: true,
    minHeight: 200,
    marginTop: 260
  };
  $scope.gridAppCallbacks = {};
  $scope.gridAppCallbacks['getReadableStatus'] = issueWorkflow.getReadableStatus;
  $scope.gridAppCallbacks['buildMultiSelectFilter'] = buildMultiSelectFilter;
  $scope.gridAppCallbacks['lookupCellValueFormatter'] = lookupCellValueFormatter;
  if (localStorageService.get('issue_bool')) {
    $scope.bool = localStorageService.get('issue_bool');
  } else {
    $scope.bool = {
      allIssues: true
    };
  }
  $scope.params = {
    pageNumber: 1,
    pageSize: 100,
    totalItems: 0,
    filters: {}
  };
  $scope.statusMappings = {};
  issueWorkflow.getStatusMappings().then(function (mapping) {
    $scope.statusMappings = mapping;
  });

  /**  GESTIONE DELLA GRID  **/
  $scope.viewGridOptions = {
    enableSorting: true,
    enableGridMenu: true,
    exporterCsvColumnSeparator: ';',
    exporterSuppressColumns: ['id', 'odl'],
    exporterMenuPdf: false,
    enableFiltering: true,
    // columnDef: [],
    enableColumnResizing: true,
    paginationPageSizes: [100, 250, 500, 1000, 10000],
    paginationPageSize: 100,
    totalItems: 0,
    useExternalPagination: true,
    // rowHeight: 50,
    // data: 'issueList.list',
    useExternalFiltering: true,
    multiSelect: true,
    enableRowHeaderSelection: true,
    enableRowSelection: true,
    enableHorizontalScrollbar: 1,
    columnDefs: [{
      name: ' '
    }]
  };
  $scope.getColumns = function () {
    getColumnOrDefault();
    return $scope.columnDefs;
  };
  function getColumnOrDefault() {
    issueWorkflow.getStatuses().then(function (statuses) {
      var statusOptions = [];
      for (var s in statuses) {
        statusOptions.push({
          "value": statuses[s].code,
          "label": statuses[s].label
        });
      }
      $scope.viewGridOptions.columnDefs = [];
      $scope.viewGridOptions.columnDefs.push({
        displayName: '',
        field: 'id',
        width: 36,
        enableCellEdit: false,
        enableFiltering: false,
        enableSorting: false,
        pinnedLeft: true,
        cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/callcenter_detail/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' + '<span class="fa fa-search"></span>' + '</a>' + '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Codice Segnalaz.',
        field: 'model.code',
        enableFiltering: true,
        pinnedLeft: true,
        width: 120,
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'ODL committente',
        field: 'model.odl_commit',
        enableFiltering: true,
        width: 150,
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Descrizione',
        field: 'model.description',
        enableFiltering: true,
        width: 300,
        cellTooltip: function cellTooltip(row) {
          return row.entity.model.description;
        },
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Tipo asset',
        field: 'model.type_id',
        cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.model.record_id.description}} ({{row.entity.model.record_id.code}})</div>',
        enableFiltering: true,
        width: 150,
        filters: [{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Asset',
        field: 'model.record_id',
        cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.model.record_id.description}} ({{row.entity.model.record_id.code}})</div>',
        enableFiltering: true,
        width: 150,
        filters: [{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          //exact o contains non funziona comunque, colpa del lowercase da qualche parte...
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data richiesta',
        field: 'date_requested',
        cellFilter: 'date:\'dd/MM/yyyy\'',
        enableFiltering: true,
        width: 100,
        filters: [{
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
          placeholder: 'da...',
          condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
        }, {
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
          placeholder: 'a...',
          condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Stato',
        field: 'status',
        enableFiltering: true,
        width: 100,
        filterHeaderTemplate: '<div class="ui-grid-filter-container"><a class="block btn btn-default btn-xs" ng-repeat="colFilter in col.filters" ' + 'ng-click="grid.appScope.buildMultiSelectFilter(colFilter)">Filtro</a></div>',
        filters: [{
          type: sixGridPaginationConstants.filterType.SELECTMULTIPLE,
          selectOptions: statusOptions,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }],
        cellTemplate: '<div class="ui-grid-cell-contents" style="vertical-align:middle;">' + '{{grid.appScope.getReadableStatus(row.entity.status)}}' + '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Note',
        field: 'model.note',
        enableFiltering: true,
        width: 500,
        cellTooltip: function cellTooltip(row) {
          return row.entity.model.note;
        },
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          //exact o contains non funziona comunque, colpa del lowercase da qualche parte...
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Richiedente',
        field: 'reporter_id',
        cellTemplate: '<div class="ui-grid-cell ui-grid-cell-contents"><span ng-if="grid.getCellValue(row, col)">{{grid.getCellValue(row, col).description}} ({{grid.getCellValue(row, col).code}})</span></div>',
        enableFiltering: true,
        width: 150,
        filters: [{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Utente di inserimento',
        field: 'user',
        enableFiltering: true,
        width: 200,
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }],
        cellTemplate: '<div class="ui-grid-cell-contents" style="vertical-align:middle;text-align:center;">' + '{{grid.appScope.getReadableUser(row.entity)}}' + '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Odl associati',
        field: 'odl',
        enableFiltering: false,
        width: 200,
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }],
        cellTemplate: '<div class="ui-grid-cell-contents" style="vertical-align:middle;text-align:center; height: 50px">' + '{{grid.appScope.show_odl_ref(row.entity.odl)}}' + '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Resp. esterno',
        field: 'references_assignee.supervisorExternal_id',
        width: 150,
        enableFiltering: true,
        visible: false,
        filters: [{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }],
        cellTemplate: '<div class="ui-grid-cell-contents" title="{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}">{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Segreteria',
        field: 'references_assignee.secretariat_id',
        width: 150,
        enableFiltering: true,
        visible: false,
        filters: [{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }],
        cellTemplate: '<div class="ui-grid-cell-contents" title="{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}">{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Ref. Attività',
        field: 'references_assignee.activityReferer_id',
        width: 150,
        enableFiltering: true,
        visible: false,
        filters: [{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }],
        cellTemplate: '<div class="ui-grid-cell-contents" title="{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}">{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Servizio',
        field: 'model.service_id',
        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope">{{row.entity.model.service_id.description}} ({{row.entity.model.service_id.code}})</div>',
        enableFiltering: true,
        visible: false,
        width: 150,
        filters: [{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Priorità',
        field: 'model.priority_id',
        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope">{{row.entity.model.priority_id.description}} ({{row.entity.model.priority_id.code}})</div>',
        enableFiltering: true,
        visible: false,
        width: 150,
        filters: [{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Gen. ODL',
        field: 'odl',
        width: 80,
        enableCellEdit: false,
        enableFiltering: false,
        enableSorting: false,
        enableColumnMenu: false,
        cellTemplate: '<div class="ui-grid-cell-contents" ng-if="grid.appScope.show_generate_odl(row.entity.status)" style="vertical-align:middle;text-align:center;">' +
        // N.B. show_generate_odl() deve essere passata alla sixgridpagination tramite l'attributo 'grid-app-callbacks'
        '<button type="button" class="btn btn-xs btn-primary" ng-click="grid.appScope.generate_odl(row.entity.UUID)">' +
        // N.B. generate_odl() deve essere passata alla sixgridpagination tramite l'attributo 'grid-app-callbacks'
        '<i class="fa fa-magic"></i>' + '</button>' + '</div>'
      });
    });
  }
  function lookupCellValueFormatter(value) {
    var formatted = "";
    if (typeof value != "undefined") {
      if (value !== null && angular.isArray(value)) {
        angular.forEach(value, function (row) {
          formatted += row.description + ' (' + row.code + '); \n';
        });
      } else if (value !== null && angular.isObject(value)) {
        formatted = value.description + ' (' + value.code + ')';
      } else {
        formatted = value;
      }
    }
    return formatted;
  }
  function buildMultiSelectFilter(filter) {
    var options = '';
    filter.selectOptions.forEach(function (val, key) {
      options += '<label class="checkbox i-checks m-t-none m-b-none"><input type="checkbox" ' + 'ng-model="ngDialogData.selection[' + key + '].active"><i></i> ' + val.label + '</label>';
    });
    if (Array.isArray(filter.term)) {
      filter.term.forEach(function (term) {
        filter.selectOptions.forEach(function (v, k, opt) {
          if (v.value == term) opt[k].active = true;
        });
      });
    }
    ngDialog.openConfirm({
      name: 'multiSelectFilterDialog',
      closeByDocument: false,
      showClose: true,
      template: '' + '<div style="text-align:center">Seleziona filtri da attivare ' + '</div><br>' + '' + options + '' + '<div class="row" style="text-align:center; clear: both">' + '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ' + 'ng-click="confirm(ngDialogData.selection)">Applica filtro</button>' + '</div>',
      data: {
        selection: filter.selectOptions
      },
      plain: true,
      className: 'ngdialog-theme-default ngdialog-theme-custom'
    }).then(function (selection) {
      filter.term = [];
      selection.forEach(function (sel) {
        if (sel.active) {
          filter.term.push(sel.value);
        }
      });
    });
  }
  var OPERATOR_NOT_FOUND_ERR_SHOWN = false;
  $scope.getCurrentUserOperator = function () {
    $scope.currentUserOperator = undefined;
    var currentUser = authFactory.getAuthData().authId;
    var filters = {};
    filters['model.username'] = {
      type: '_exact',
      key: 'model.username',
      value: currentUser
    };
    return recordFactory('operatore').search({
      page_size: 1,
      show_revision: false
    }, filters).$promise.then(function (data) {
      $scope.currentUserOperator = data.list[0];
    })["catch"](function (response) {
      if (!OPERATOR_NOT_FOUND_ERR_SHOWN) {
        toaster.pop('error', 'Errore', 'Operatore corrispondente all\'utente \'' + currentUser + '\' non trovato');
        OPERATOR_NOT_FOUND_ERR_SHOWN = true;
      }
    })["finally"](function (response) {
      return $scope.currentUserOperator;
    });
  };
  $scope.getCurrentUserIssueList = function () {
    if (!$scope.currentUserOperator || !$scope.currentUserOperator.UUID) {
      return $scope.getCurrentUserOperator().then(function (operator) {
        return $scope.getIssueList();
      });
    } else {
      return $scope.getIssueList();
    }
  };
  function show_odl_ref(array) {
    // costruisco una stringa da stampare partendo da un array di codici di ODL
    var str = '';
    for (var i = 0; i < array.length; i++) {
      if (i == 0) {
        str = array[i];
      } else {
        str = str + ', ' + array[i];
      }
    }
    return str;
  }
  $scope.gridAppCallbacks['show_odl_ref'] = show_odl_ref; // da passare alla sixgridpagination per caricare correttamente il template della colonna "Genera ODL"

  function getReadableUser(issue) {
    if (issue.userinfo) {
      return issue.userinfo.description;
    } else {
      return issue.user;
    }
  }
  $scope.gridAppCallbacks['getReadableUser'] = getReadableUser;
  $scope.getIssueList = function () {
    var payload = {
      query: $scope.queryParam,
      page_size: $scope.params.pageSize,
      sort_fields: $scope.params.sortFields,
      show_revision: false
    };
    var filters = angular.copy($scope.params.filters);
    if ($scope.currentUserOperator && $scope.currentUserOperator.UUID && !$scope.bool.allIssues) {
      filters['user'] = sixFiltersLib.exact('user', $scope.currentUserOperator.model.username, sixFiltersLib.CONSTRAINTS.OR);
      filters['supervisorExternal_id'] = sixFiltersLib.exact('references_assignee.supervisorExternal_id.UUID', $scope.currentUserOperator.UUID, sixFiltersLib.CONSTRAINTS.OR);
      filters['secretariat_id'] = sixFiltersLib.exact('references_assignee.secretariat_id.UUID', $scope.currentUserOperator.UUID, sixFiltersLib.CONSTRAINTS.OR);
      filters['activityReferer_id'] = sixFiltersLib.exact('references_assignee.activityReferer_id.UUID', $scope.currentUserOperator.UUID, sixFiltersLib.CONSTRAINTS.OR);
      filters['reporter_id'] = sixFiltersLib.exact('references_assignee.reporter_id.UUID', $scope.currentUserOperator.UUID, sixFiltersLib.CONSTRAINTS.OR);
    }
    return issueFactory(PATH_ISSUE_RECORD).searchWithOdl(payload, filters).$promise.then(function (data) {
      $scope.params.totalItems = data.totalResults;
      $scope.viewGridOptions.totalItems = data.totalResults;
      $scope.issueList.totalResults = data.totalResults;
      $scope.issueList.list = data.list;
      $scope.params.sixApi.refreshList(data.list);
      return data;
    });
  };
  $scope.getSelectedRows = function () {
    var api = $scope.params.gridApi;
    if (api && api.selection) {
      return api.selection.getSelectedRows();
    } else {
      return [];
    }
  };
  $scope.deleteIssueSelected = function () {
    var rows = $scope.getSelectedRows();
    rows.forEach(function (val, i) {
      rows[i] = val.version;
    });
    issueFactory(PATH_ISSUE_RECORD).bulkDeleteIssue(rows).$promise.then(function (data) {
      $scope.refresh();
    });
  };
  $scope.bulkEditorVisible = false;
  $scope.bulkEditConf = {
    dataGetter: function dataGetter() {
      //recupero l'ultima versione dei dati selezionati nella grid
      var rows = $scope.getSelectedRows();
      var uuid_filters = {};
      for (var r in rows) {
        uuid_filters['uuid_' + r] = sixFiltersLib.exact('UUID', rows[r].UUID, sixFiltersLib.CONSTRAINTS.OR);
      }
      var filters = {
        "uuid": sixFiltersLib.must(uuid_filters)
      };
      var payload = {
        page_size: 10000,
        show_revision: false
      };
      return issueFactory(PATH_ISSUE_RECORD).search(payload, filters).$promise.then(function (results) {
        if (results.list) {
          return results.list;
        }
        return [];
      });
    },
    factory: function factory(payload) {
      return issueFactory(PATH_ISSUE_RECORD).bulkUpdateIssue(payload).$promise;
    },
    compactSchema: {
      "date_requested": {
        title: "Data Richiesta",
        format: "date",
        form_type: "datepicker"
      },
      "date_handling": {
        title: "Data Inizio Lavori",
        format: "date",
        form_type: "datepicker"
      },
      "date_closing": {
        title: "Data Chiusura",
        format: "date",
        form_type: "datepicker"
      },
      "model.service_id": {
        title: "Servizio",
        form_type: "sixlookup",
        format: "lookup",
        war: "six-data-set",
        entity_id: "servizio"
      },
      "reporter_id": {
        title: "Richiedente",
        form_type: "sixlookup",
        format: "lookup",
        war: "six-data-set",
        entity_id: "operatore"
      },
      "references_assignee.secretariat_id": {
        title: "Segreteria",
        form_type: "sixlookup",
        format: "lookup",
        war: "six-data-set",
        entity_id: "segreteria"
      },
      "references_assignee.supervisorExternal_id": {
        title: "Responsabile esterno",
        form_type: "sixlookup",
        format: "lookup",
        war: "six-data-set",
        entity_id: "operatore"
      },
      "references_assignee.activityReferer_id": {
        title: "Referente attività",
        form_type: "sixlookup",
        format: "lookup",
        war: "six-data-set",
        entity_id: "operatore"
      }
    },
    callbacks: {
      "references_assignee.secretariat_id": bulkWatcherCallback,
      "references_assignee.supervisorExternal_id": bulkWatcherCallback,
      "references_assignee.activityReferer_id": bulkWatcherCallback
    },
    postSave: function postSave() {
      $scope.bulkEditorVisible = false;
      $scope.refresh();
    },
    cancel: function cancel() {
      $scope.bulkEditorVisible = false;
    }
  };
  issueFactory(PATH_ISSUE_SCHEMA).callCenter().$promise.then(function (response) {
    if (response.model) {
      $scope.bulkEditConf.schemaForm = response.model;
    }
  });
  function bulkWatcherCallback(fieldValue, fullObject, sourceValue, sourceObject) {
    if (fieldValue || sourceValue) {
      var valueArray = fieldValue;
      if (!Array.isArray(fieldValue)) {
        //wrappo in un array anche i singoli valori per generalizzare l'operazione
        valueArray = [fieldValue];
      }
      var oldValueArray = sourceValue;
      if (!Array.isArray(sourceValue)) {
        oldValueArray = [sourceValue];
      }
      //faccio un diff tra sourceValue e fieldValue per determinare quali sono stati rimossi e toglierli dai watcher
      oldValueArray.forEach(function (oldValue) {
        var shouldBeRemoved = true;
        valueArray.forEach(function (newValue) {
          if (newValue.UUID == oldValue.UUID) {
            shouldBeRemoved = false;
          }
        });
        if (shouldBeRemoved) {
          //rimuovo dai watchers
          for (var i = 0; i < fullObject.watchers.internal.length; i++) {
            if (oldValue.UUID == fullObject.watchers.internal[i].UUID) {
              delete fullObject.watchers.internal[i];
            }
          }
        }
      });
      valueArray.forEach(function (fieldValue) {
        var alreadyWatching = false;
        for (var i = 0; i < fullObject.watchers.internal.length; i++) {
          if (fieldValue.UUID == fullObject.watchers.internal[i].UUID) {
            alreadyWatching = true;
          }
        }
        if (alreadyWatching == false) {
          fullObject.watchers.internal.push(fieldValue);
        }
      });
    }
    return fullObject;
  }
  $scope.bulkEdit = function () {
    $scope.bulkEditorVisible = true;
  };
  $scope.newIssueByCallcenter = function () {
    $location.path(PATH_CALLCENTER_DETAIL + '/new');
  };
  $scope.refresh = function () {
    // $route.reload();
    $scope.getCurrentUserIssueList();
  };
  $scope.show_generate_odl = function (status) {
    return $scope.statusMappings['open'] == status || $scope.statusMappings['in_service'] == status;
  };
  $scope.gridAppCallbacks['show_generate_odl'] = $scope.show_generate_odl; // da passare alla sixgridpagination per caricare correttamente il template della colonna "Genera ODL"

  $scope.generate_odl = function (issueId) {
    issueFactory(PATH_ISSUE_RECORD + "/_uuid/" + issueId).getUUID().$promise.then(function (response) {
      if (response) {
        issueToOdl.push(response);
        $location.path('/odl/new', false);
      }
    });
  };
  $scope.gridAppCallbacks['generate_odl'] = $scope.generate_odl; // da passare alla sixgridpagination per caricare correttamente il template della colonna "Genera ODL"

  /*** PARTE CONFIGURAZIONE ***/
  $scope.toggleAllIssues = function () {
    $scope.bool.allIssues = !$scope.bool.allIssues;
    localStorageService.set('issue_bool', $scope.bool);
    $scope.refresh();
  };

  /*** PARTE INIZIALIZZAZIONE DELLA PAGINA  ***/
  if ($routeParams.id) {
    $scope.issueId = $routeParams.id;
  } else {
    $scope.getColumns();
    setTimeout(function () {
      if ($scope.params.sixApi) {
        $scope.params.sixApi.restoreState();
      }
    }, 500);
  }

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'issue/record';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:IssueconfiguratorCtrl
 * @description
 * # IssueconfiguratorCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/issueconfigurator', {
    templateUrl: 'plan/issue/issueconfigurator_list.html',
    controller: 'IssueconfiguratorCtrl'
  }).when('/issueconfigurator/page/:number', {
    templateUrl: 'plan/issue/issueconfigurator_list.html',
    controller: 'IssueconfiguratorCtrl'
  }).when('/issueconfigurator/:id', {
    templateUrl: 'plan/issue/issueconfigurator_detail.html',
    controller: 'IssueconfiguratorCtrl'
  });
}]).controller('IssueconfiguratorCtrl', ["$scope", "$routeParams", "$location", "$log", "$window", "issueFactory", "commissionFactory", "schemaFactory", "toaster", "authFactory", "dialogService", function ($scope, $routeParams, $location, $log, $window, issueFactory, commissionFactory, schemaFactory, toaster, authFactory, dialogService) {
  var PATH_ISSUE_SCHEMA = 'issue/schema';
  var PATH_ISSUE_CONFIG = 'issueconfigurator';
  $scope.typeName = 'issue';
  $scope.bool = {
    /* contenitore per le variabili booleane */
    isNew: false,
    isCross: false,
    isCallCenter: false,
    confModel: false
  };
  $scope.commissionDependent = true;
  $scope.commissionCode = '';
  $scope.commissions = [];
  $scope.commissionsSelected = {
    codes: []
  };
  $scope.selected = {}; /* contenitore del dato */

  $scope.form = {};
  $scope.model = {};
  $scope.schema = {};
  $scope.property = {};
  $scope.checked = {};
  $scope.uiselectMap = {};
  $scope.itemTypeMap = {};
  $scope.pageSize = 10;
  $scope.status = {
    isFirstOpen: true,
    isFirstDisabled: false
  };
  $scope.modeltypeList = schemaFactory().lookupList({
    page_size: 1000
  });
  $scope.addProperty = function () {
    /* aggiungo una proprietà allo Schema e al Form */
    if (angular.isDefined($scope.property.key)) {
      var p = {
        title: angular.copy($scope.property.title),
        type: angular.copy($scope.property.type),
        check: false
      };
      if ($scope.property.format) {
        p.format = angular.copy($scope.property.format);
      }
      if (p.type == 'date') {
        p.type = 'string';
        p.format = 'date';
      }
      if (p.type == 'array') {
        p.items = {
          type: angular.copy($scope.property.items_type)
        }; // default
        if ($scope.property.items_type === 'date') {
          // se è una data è diverso...
          p.items = {
            type: 'string',
            format: 'date'
          };
        }
      }
      $scope.selected.model.schema.properties[$scope.property.key] = p;
      var item = {
        title: angular.copy($scope.property.title),
        type: null,
        key: [angular.copy($scope.property.key)]
      };
      if (p.format) {
        if (p.format == 'date') {
          item.type = 'datepicker';
        } else if (p.format == 'enum') {
          item.type = 'uiselect';
          item.titleMap = [];
        } else if (p.format == 'lookup') {
          item.type = 'sixlookup';
        }
      } else if (p.type == 'string') {
        item.type = 'text';
      } else if (p.type == 'number' || p.type == 'integer') {
        item.type = 'number';
      } else if (p.type == 'boolean') {
        item.type = 'checkbox';
      } else if (p.type == 'array') {
        item.type = 'uiselectmultiple';
        item.titleMap = [];
      } else {
        // default
        item.type = angular.copy(p.type);
      }
      for (var i in $scope.selected.model.form[0].items) {
        if ($scope.selected.model.form[0].items[i].tabs) {
          $scope.selected.model.form[0].items[i].tabs[0].items.push(item);
        }
      }
    }
    $scope.getUiselectMap();
    $scope.clearNewCol();
    $scope.updateScope();
  };
  $scope.updateScope = function () {
    $scope.schema = angular.fromJson(angular.copy($scope.selected.model.schema));
    $scope.form = [angular.fromJson(angular.copy($scope.selected.model.form[0]))];
    $scope.columnDefs = angular.fromJson(angular.copy($scope.selected.model.columnDefs));
    $scope.getUiselectMap();
    $scope.formChanged();
  };
  $scope.clearNewCol = function () {
    /* pulisco la riga di inserimento di nuove proprietà */
    $scope.property.key = '';
    $scope.property.title = '';
    delete $scope.property.type;
    delete $scope.property.format;
  };
  $scope.getItemType = function (key) {
    console.log(valueSchema);
    if (valueSchema.type != 'array') {
      return valueSchema.type;
    } else {
      return valueSchema.items.type;
    }
  };
  $scope.addItemOnArray = function (key, newItem) {
    if (newItem != undefined && newItem != null) {
      newItem.name = newItem.name.toString();
      if ($scope.itemTypeMap[key] == 'integer') {
        if (parseInt(newItem.name)) {
          newItem.value = parseInt(newItem.name);
          newItem.name = newItem.value.toString(); /* nel caso ci dovesse essere un cast, torno a sovrascrivere il name */
        } else {
          return;
        }
      } else if ($scope.itemTypeMap[key] == 'number') {
        if (parseFloat(newItem.name)) {
          newItem.value = parseFloat(newItem.name);
        } else {
          return;
        }
      } else {
        newItem.value = newItem.name.toString().replace(/\s/g, '_').toLowerCase();
      }
      for (var i in $scope.selected.model.form[0].items) {
        if ($scope.selected.model.form[0].items[i].tabs) {
          $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
            if (key == item.key[0]) {
              item.titleMap.push(newItem);
            }
          });
        }
      }
      this.newItem = null;
      $scope.updateScope();
    }
  };
  $scope.deleteItemOnArray = function (key, obj) {
    for (var i in $scope.selected.model.form[0].items) {
      if ($scope.selected.model.form[0].items[i].tabs) {
        $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
          if (key == item.key[0]) {
            for (var j = item.titleMap.length; j--;) {
              if (item.titleMap[j].value == obj.value) {
                item.titleMap.splice(j, 1);
              }
            }
          }
        });
      }
    }
    this.newItem = null;
    $scope.updateScope();
  };
  $scope.deleteProperty = function (keyToDelete) {
    delete $scope.selected.model.schema.properties[keyToDelete];
    for (var i = $scope.selected.model.columnDefs.length; i--;) {
      if ($scope.selected.model.columnDefs[i].field == keyToDelete) $scope.selected.model.columnDefs.splice(i, 1);
    }
    // ...elimino sempre dalla form
    for (var i = $scope.selected.model.form[0].items.length; i--;) {
      if ($scope.selected.model.form[0].items[i].key && $scope.selected.model.form[0].items[i].key[0] == keyToDelete) {
        $scope.selected.model.form[0].items.splice(i, 1);
      }
      // Scorro anche i tabs
      if ($scope.selected.model.form[0].items[i].tabs) {
        for (var j = $scope.selected.model.form[0].items[i].tabs.length; j--;) {
          for (var k = $scope.selected.model.form[0].items[i].tabs[j].items.length; k--;) {
            if ($scope.selected.model.form[0].items[i].tabs[j].items[k].key[0] == keyToDelete) {
              $scope.selected.model.form[0].items[i].tabs[j].items.splice(k, 1);
            }
          }
        }
      }
    }
    $scope.updateScope();
  };
  $scope.formChanged = function () {
    $scope.aceModel = JSON.stringify(angular.copy($scope.selected), null, '\t');
  };
  $scope.refreshLookup = function (key, entity_id) {
    $scope.chargeAceModel();
    for (var i = $scope.selected.model.form[0].items.length; i--;) {
      if ($scope.selected.model.form[0].items[i].key && $scope.selected.model.form[0].items[i].key[0] == key) {
        $scope.selected.model.form[0].items[i].entity_id = angular.copy(entity_id);
      }
      // Scorro anche i tabs
      if ($scope.selected.model.form[0].items[i].tabs) {
        for (var j = $scope.selected.model.form[0].items[i].tabs.length; j--;) {
          for (var k = $scope.selected.model.form[0].items[i].tabs[j].items.length; k--;) {
            if ($scope.selected.model.form[0].items[i].tabs[j].items[k].key[0] == key) $scope.selected.model.form[0].items[i].tabs[j].items[k].entity_id = angular.copy(entity_id);
          }
        }
      }
    }
    $scope.selected.model.schema.properties[key].entity_id = angular.copy(entity_id);
    $scope.updateScope();
  };
  $scope.refreshBasePath = function (key, basePath) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].basePath = angular.copy(basePath);
    $scope.updateScope();
  };
  $scope.refreshWar = function (key, war) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].war = angular.copy(war);
    $scope.updateScope();
  };
  $scope.refreshFiltered = function (key, filtered) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].filtered = angular.copy(filtered);
    $scope.updateScope();
  };
  $scope.refreshFilterSourceField = function (key, filterSourceField) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].filterSourceField = angular.copy(filterSourceField);
    $scope.updateScope();
  };
  $scope.refreshFilterDestField = function (key, filterDestField) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].filterDestField = angular.copy(filterDestField);
    $scope.updateScope();
  };
  $scope.refreshLookupOption = function (key, option, value) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key][option] = angular.copy(value);
    $scope.updateScope();
  };
  $scope.refreshTitleForm = function (title) {
    $scope.chargeAceModel();
    $scope.selected.model.form[0].title = angular.copy(title);
    $scope.updateScope();
  };
  $scope.chargeAceModel = function () {
    var defaultData = angular.fromJson(angular.copy($scope.aceModel));
    if (defaultData) {
      $scope.selected = defaultData;
      $scope.schema = angular.fromJson(defaultData.model.schema);
      $scope.form = angular.fromJson(defaultData.model.form);
      $scope.columnDefs = angular.fromJson(defaultData.model.columnDefs);
    }
  };
  $scope.changeColumnDefs = function (key, value) {
    var item = {
      name: value.title,
      field: key
    };
    var map = new Map();
    angular.forEach($scope.selected.model.columnDefs, function (v) {
      map[v.field] = angular.copy(v);
    });
    if (value.check) {
      map[item.field] = angular.copy(item);
      if (value.width == '' || value.width == null) {
        delete $scope.selected.model.schema.properties[key].width;
      }
    } else {
      delete map[item.field];
      delete $scope.selected.model.schema.properties[key].width;
      $scope.selected.model.schema.properties[key].enableFiltering = false;
      $scope.selected.model.schema.properties[key].enableSorting = false;
    }
    $scope.selected.model.columnDefs = [];
    for (var it in map) {
      var app = {
        name: map[it].name,
        field: map[it].field
      };
      $scope.selected.model.columnDefs.push(app);
    }
    $scope.updateScope();
  };
  $scope.aceLoaded = function () {
    var defaultModel = {
      model: {
        schema: {
          type: "object",
          title: "",
          properties: {
            code: {
              title: "Codice",
              type: "string",
              check: true
            },
            description: {
              title: "Descrizione",
              type: "string",
              check: true
            }
          },
          required: ["code", "description"]
        },
        form: [{
          type: "fieldset",
          items: [{
            type: "tabs",
            tabs: [{
              title: "Campi",
              items: [{
                key: ["code"],
                title: "Codice",
                required: true,
                type: "text"
              }, {
                key: ["description"],
                title: "Descrizione",
                required: true,
                type: "textarea",
                placeholder: "Inserire qui la descrizione della segnalazione..."
              }]
            }]
          }]
        }],
        columnDefs: [{
          "field": "code",
          "name": "Codice"
        }, {
          "field": "description",
          "name": "Descrizione"
        }]
      }
    };
    $scope.aceModel = JSON.stringify(defaultModel, null, '\t');
    $scope.chargeAceModel();
    $scope.title = angular.copy($scope.selected.model.form[0].title);
  };
  $scope.getUiselectMap = function () {
    $scope.uiselectMap = {};
    $scope.itemTypeMap = {};
    for (var i in $scope.selected.model.form[0].items) {
      if ($scope.selected.model.form[0].items[i].tabs) {
        $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
          $scope.itemTypeMap[item.key[0]] = $scope.selected.model.schema.properties[item.key[0]].type;
          if ($scope.selected.model.schema.properties[item.key[0]].type == 'array') {
            $scope.itemTypeMap[item.key[0]] = $scope.selected.model.schema.properties[item.key[0]].items.type;
          }
          if (item.type == 'uiselect' || item.type == 'uiselectmultiple') {
            var blankObject = {
              name: '',
              value: ''
            };
            $scope.uiselectMap[item.key[0]] = addSelectedValue(item.titleMap, blankObject); /* aggiunto un elemento vuoto all'array per consentire il deselezionamento */
          }
        });
      }
    }
  };

  $scope.toggleEnumDefault = function (key, objValue) {
    var property = $scope.selected.model.schema.properties[key];
    if (typeof property["default"] == "undefined" || property["default"].indexOf(objValue) == -1) {
      property["default"] = [objValue];
    } else {
      property["default"] = undefined;
    }
    this.newItem = null;
    $scope.updateScope();
  };
  function addSelectedValue(array, obj) {
    var blankValuePresent = false;
    array.forEach(function (item) {
      if (item.value == obj.value && item.name == obj.name) {
        blankValuePresent = true;
      }
    });
    if (blankValuePresent == false) {
      array.push(obj);
    }
    return array;
  }
  $scope.isInheritable = function (type) {
    return type == 'number' || type == 'integer' || type == 'string' || type == 'boolean' || type == 'lookup';
  };

  /**********************/
  /***** FIX SCHEMA *****/
  /**********************/

  $scope.fixSchemaFormModel = function () {
    for (var i in $scope.selected.model.form[0].items) {
      if ($scope.selected.model.form[0].items[i].tabs) {
        $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
          if (item.type == 'uiselect') {
            $scope.selected.model.schema.properties[item.key[0]].format = 'enum';
          }
          if (item.type == 'uiselectmultiple') {
            $scope.selected.model.schema.properties[item.key[0]].type = 'array';
          }
        });
      }
    }
  };

  /****************/
  /***** FORM *****/
  /****************/

  $scope.newFieldForm = {};
  $scope.newTab = {
    title: "",
    items: []
  };
  $scope.addTab = function (container) {
    if (!container.tabs) {
      container.tabs = [];
    }
    if (container.type !== 'tabs') {
      container.type = 'tabs';
    }
    var toAdd = angular.copy($scope.newTab);
    $log.log(container);
    container.tabs.push(toAdd);
    $log.log(container);
    $scope.updateScope();
    $scope.newTab = {
      title: "",
      items: []
    };
  };
  $scope.addFieldToTab = function (tab) {
    if (!tab.items) {
      tab.items = [];
    }
    var toAdd = angular.copy($scope.newFieldForm);
    if ($scope.newFieldForm.type === '' || $scope.newFieldForm.type === 'formula' || $scope.newFieldForm.type === 'inherited') {
      delete toAdd.type;
    }
    /* key è da cambiare in un array */
    toAdd.key = [];
    toAdd.key.push($scope.newFieldForm.key);
    /* se è una lookup, e se ha definito il campo entity_id nello schema, ci attacco anche l'entity_id */
    if (toAdd.type == 'sixlookup' && $scope.schema.properties[$scope.newFieldForm.key]['entity_id']) {
      toAdd['entity_id'] = $scope.schema.properties[$scope.newFieldForm.key]['entity_id'];
    }
    tab.items.push(toAdd);
    $scope.updateScope();
    $scope.newFieldForm = {
      key: [],
      title: "",
      required: false,
      type: "text"
    };
  };
  $scope.removeTabOrField = function (key, container) {
    container.splice(key, 1);
    $log.log(container);
    $scope.updateScope();
  };
  $scope.swapUp = function (key, collection) {
    if (key > 0) {
      var tmp = collection[key];
      collection[key] = collection[key - 1];
      collection[key - 1] = tmp;
    }
    $scope.updateScope();
  };
  $scope.swapDown = function (key, collection) {
    if (key < collection.length - 1) {
      var tmp = collection[key];
      collection[key] = collection[key + 1];
      collection[key + 1] = tmp;
    }
    $scope.updateScope();
  };
  $scope.updateField = function (field) {
    if (field.type === '') {
      delete field.type;
    }
    $scope.updateScope();
  };
  $scope.$watchGroup(['commissionDependent', 'history'], function () {
    if ($scope.commissionDependent === true) {
      $scope.history = true;
    }
    if ($scope.selected.model) {
      $scope.selected.model.history = $scope.history;
      $scope.selected.model.commissionDependent = $scope.commissionDependent;
      $scope.updateScope();
    }
  });
  $scope.pageChanged = function () {
    $location.path('/issueconfigurator/page/' + $scope.issueConfiguratorList.currentPage, false);
    $scope.issueConfiguratorList = issueFactory(PATH_ISSUE_SCHEMA).query({
      query: $scope.queryParam,
      page: $scope.issueConfiguratorList.currentPage
    });
  };
  $scope.printCommission = function (commission_array) {
    var result = '';
    var pos = 0;
    if (commission_array != null) {
      angular.forEach(commission_array, function (value) {
        if (pos == 0) {
          result = value;
        } else {
          result = value + ', ' + result;
        }
        pos++;
      });
    }
    return result;
  };
  $scope.updateCode = function () {
    if ($scope.bool.isCross == true) {
      $scope.commissionCode = 'default';
      $scope.commissionsSelected.codes = [];
    } else {
      $scope.commissionCode = '';
    }
  };
  $scope.setCallCenter = function () {
    /* impostare le varaibili per salvare la configurazione per il call center */
    if ($scope.bool.isCallCenter == true) {
      $scope.commissionCode = 'callcenter';
      $scope.commissionsSelected.codes = [];
    } else {
      $scope.commissionCode = '';
    }
  };
  $scope.setConfModel = function () {
    $scope.bool.confModel = true;
    $scope.bool.isCross = false;
    $scope.bool.isCallCenter = false;
    delete $scope.selected.version;
    $scope.commissionsSelected.codes = [];
    $scope.commissionCode = '';
  };
  $scope.newIssueConfig = function () {
    $location.path(PATH_ISSUE_CONFIG + '/new');
  };
  $scope.refresh = function () {
    $location.path(PATH_ISSUE_CONFIG);
  };
  $scope.back = function () {
    $location.path(PATH_ISSUE_CONFIG);
  };
  $scope["delete"] = function () {
    dialogService.confirmDialog('Eliminare la configurazione?', function () {
      issueFactory(PATH_ISSUE_SCHEMA)["delete"]({
        id: $scope.selected.version
      }).$promise.then(function (response) {
        $scope.back();
      });
    });
  };
  $scope.setCommissionSelected = function () {
    angular.forEach($scope.selected.model.commission, function (value_cm_string) {
      var index = null;
      angular.forEach($scope.commissions, function (value_cm_obj) {
        if (value_cm_string == value_cm_obj.code) {
          index = $scope.commissions.indexOf(value_cm_obj);
          $scope.commissionsSelected.codes.push(value_cm_obj);
          $scope.commissions.splice(index, 1);
        }
      });
    });
  };
  $scope.setBooleanFlag = function () {
    if ($scope.selected.model) {
      if ($scope.selected.model.code == 'default') {
        $scope.bool.isCross = true;
      } else if ($scope.selected.model.code == 'callcenter') {
        $scope.bool.isCallCenter = true;
      }
    }
  };
  $scope.getIssueConfigurationById = function (code) {
    issueFactory(PATH_ISSUE_SCHEMA + '/_code/' + code).show().$promise.then(function (response) {
      if (response.model) {
        $scope.selected = angular.copy(response);
        $scope.commissionCode = $scope.selected.model.code;
        $scope.setCommissionSelected();
        $scope.setBooleanFlag();
        $scope.updateScope();
      }
    });
  };
  $scope.getIssueConfigurationList = function () {
    issueFactory(PATH_ISSUE_SCHEMA).query({
      query: $scope.queryParam,
      pageSize: $scope.pageSize
    }).$promise.then(function (response) {
      $scope.issueConfiguratorList = response;
    });
  };
  $scope.getCommission = function () {
    commissionFactory().getCommissionsList().$promise.then(function (response) {
      if (response.list.length) {
        $scope.commissions = response.list;
      }
    });
  };
  $scope.create = function () {
    issueFactory(PATH_ISSUE_SCHEMA).create($scope.aceModel).$promise.then(function () {
      toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
      $scope.back();
    })["catch"](function (response) {
      toaster.pop('error', 'Errore salvataggio', 'Si è verificato un errore durante il salvataggio');
    });
  };
  $scope.update = function () {
    issueFactory(PATH_ISSUE_SCHEMA).update({
      id: $scope.selected.version
    }, $scope.aceModel).$promise.then(function () {
      toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
      $scope.back();
    })["catch"](function (rejection) {
      toaster.pop('error', 'Errore salvataggio', rejection.data.message ? rejection.data.message : rejection.statusText);
    });
  };
  $scope.saveForm = function () {
    $scope.chargeAceModel();
    $scope.selected.model.code = $scope.commissionCode;
    if ($scope.bool.isCross || $scope.bool.isCallCenter) {
      /* se è cross non serve riempire il vettore delle commesse */
      $scope.selected.model.commission = null;
      $scope.selected.model.commissionDependent = false;
      $scope.formChanged(); /* aggiorno l'aceModel */
      if ($scope.selected.version) {
        $scope.update();
      } else {
        $scope.create();
      }
    } else {
      /* riempio il vettore delle commesse */
      $scope.selected.model.commission = [];
      angular.forEach($scope.commissionsSelected.codes, function (obj) {
        $scope.selected.model.commission.push(obj.code);
      });
      $scope.formChanged(); /* aggiorno l'aceModel */
      if ($scope.bool.confModel) {
        /* create obbligatoria */
        $scope.create();
      } else {
        if ($scope.selected.version) {
          $scope.update();
        } else {
          $scope.create();
        }
      }
    }
  };
  if ($routeParams.id) {
    if ($routeParams.id !== 'new') {
      $scope.bool.isNew = false;
      commissionFactory().getCommissionsList().$promise.then(function (response) {
        if (response.list.length) {
          $scope.commissions = response.list;
          $scope.getIssueConfigurationById($routeParams.id);
        }
      });
    } else {
      $scope.bool.isNew = true;
      $scope.getCommission();
    }
  } else {
    $scope.getIssueConfigurationList();
  }

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'issue/schema';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:OdlCtrl
 * @description
 * # OdlCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/odl', {
    templateUrl: 'plan/odl/odl_list.html',
    controller: 'OdlCtrl'
  }).when('/odl/:id', {
    templateUrl: 'plan/odl/odl_detail.html',
    controller: 'OdlCtrl'
  });
}]).controller('OdlCtrl', ["$scope", "modelFactory", "authFactory", "odlFactory", "notificationFactory", "$routeParams", "$log", "$window", "errorService", "localStorageService", "modelIconService", "$location", "treePlanConfigFactory", "taskFactory", "issueFactory", "lookupFactory", "dialogService", "ngDialog", "toaster", "$filter", "issueToOdl", "uiGridConstants", "$timeout", "$route", "counterFactory", "userFactory", "recordFactory", "sixGridPaginationConstants", "odlWorkflow", "treeUtilities", "$http", "APP_URL", "SaveAs", "$q", "DEV", "ENV", function ($scope, modelFactory, authFactory, odlFactory, notificationFactory, $routeParams, $log, $window, errorService, localStorageService, modelIconService, $location, treePlanConfigFactory, taskFactory, issueFactory, lookupFactory, dialogService, ngDialog, toaster, $filter, issueToOdl, uiGridConstants, $timeout, $route, counterFactory, userFactory, recordFactory, sixGridPaginationConstants, odlWorkflow, treeUtilities, $http, APP_URL, SaveAs, $q, DEV, ENV) {
  /**** CONSTANTS ****/

  var currentCommission = authFactory.getAuthData().info.commissions.current;
  $scope.counterNameOdl = 'odl';
  $scope.odlRef = null;
  $scope.queryParam = '';
  $scope.uiGridFiltersQuery = '';
  $scope.loadingSixMail = true;
  $scope.commissionDependent = true;
  $scope.schemaOdlDefined = false;
  $scope.typeName = 'odl';
  $scope.issue = {}; /* ci salvo tutto il dato della segnalazione a cui faccio riferimento */
  $scope.issueDisplayConfig = {
    'mode': 'portal',
    'tabs': [{
      'component': 'ictIssue',
      'config': {
        'mode': 'extended',
        'showWatchers': true,
        'showAssignee': true
      }
    }, 'ictAttachments', 'ictQrcode', 'ictNotification'],
    'fullPage': false
  };
  $scope.notifications;
  if (localStorageService.get('odl_bool')) {
    $scope.bool = localStorageService.get('odl_bool');
  } else {
    $scope.bool = {
      allOdl: true
    };
  }
  $scope.odlList = {
    list: []
  };
  $scope.params = {
    pageNumber: 1,
    pageSize: 50,
    filters: {}
  };
  $scope.autoResizeParams = {
    enabled: true,
    minHeight: 200,
    marginTop: 290
  };

  // Gestione allegati
  $scope.attachments = [];
  function readAttachments(modelList) {
    if (angular.isDefined(modelList)) {
      $scope.attachments.splice(0, $scope.attachments.length);
      for (var i = 0; i < modelList.length; i++) {
        $scope.attachments.push(modelList[i]);
      }
    }
  }
  function writeAttachments(modelList) {
    modelList.splice(0, modelList.length);
    for (var i = 0; i < $scope.attachments.length; i++) {
      modelList.push($scope.attachments[i]);
    }
  }
  $scope.updAttachments = function () {
    if (angular.isUndefined($scope.data.model.attachments)) {
      $scope.data.model.attachments = [];
    }
    writeAttachments($scope.data.model.attachments);
    if ($scope.isNew) {
      odlFactory().createOdl({
        commissionDependent: $scope.commissionDependent
      }, $scope.data).$promise.then(function (resp) {
        if (resp.version) {
          $scope.data.version = resp.version;
          $log.info('saving: ' + $scope.data.version);
        }
      })["catch"](function () {
        //parametri disponibili, ma non utilizzati: rejection
        toaster.pop('error', 'Errore salvataggio', 'Errore salvataggio allegati');
      });
    } else {
      odlFactory().updateOdl({
        id: $scope.data.version
      }, $scope.data).$promise.then(function (resp) {
        if (resp.version) {
          $scope.data.version = resp.version;
          $log.info('updating id: ' + $scope.data.version);
        }
      })["catch"](function (rejection) {
        toaster.pop('error', 'Errore salvataggio', rejection.data.message ? rejection.data.message : rejection.statusText);
      });
    }
  };

  /**  VARIABILI  **/

  $scope.responsableList = [];
  $scope.bool_watch_internal = true;
  $scope.bool_watch_external = false;
  $scope.watcher = {
    user: '',
    mail: ''
  };
  $scope.issueRefreshed = {
    bool: false,
    filter: {}
  };
  $scope.assetTreeFilter = [];
  $scope.init = true; // per prima inizializzazione controller (altrimenti si incasina la watch su $scope.data.model.type_id che pulisce $scope.data.model.record_id)

  /*** PARTE ODL ***/

  var now = new Date();
  $scope.data = {
    status: '',
    generated_by: 'issue',
    issue_id: undefined,
    date_insertion: now,
    date_requested: now,
    date_handling: now,
    date_closing: undefined,
    references_assignee: {
      // oggetto per contenere i riferimenti a: tecnici, assegnatari, fornitore...
      supplier_id: undefined,
      company_id: undefined,
      headmanCommission_id: undefined,
      technicianCommission_id: [],
      maintainer_id: [],
      supervisorExternal_id: undefined,
      supervisorInternal_id: undefined
    },
    watchers: {
      external: [],
      internal: []
    },
    // reporter_id: null, -> qua il riferimento non serve
    model: {
      code: undefined,
      /* da riempire automaticamente */
      description: undefined,
      type_id: undefined,
      record_id: undefined,
      service_id: undefined,
      attachments: []
    }
  };

  /** VARIABILI FILTRAGGIO LOOK UP */
  var typeoperatorFilterField = 'model.typeoperator_map.' + currentCommission.code + '.code';
  var typeoperatorFallbackFilterField = 'model.typeoperator_map.tutte.code';
  $scope.technicianCommissionFilter = {
    'typeoperator_map': sixFiltersLib.must({
      "specific": sixFiltersLib.should({
        "match_specific": sixFiltersLib.exact(typeoperatorFilterField, 'tecnico_commessa')
      }),
      "fallback": sixFiltersLib.should({
        "miss_specific": sixFiltersLib.missing(typeoperatorFilterField),
        "match_fallback": sixFiltersLib.exact(typeoperatorFallbackFilterField, 'tecnico_commessa')
      })
    })
  };
  $scope.headmanCommissionFilter = {
    'typeoperator_map': sixFiltersLib.must({
      "specific": sixFiltersLib.should({
        "match_specific": sixFiltersLib.exact(typeoperatorFilterField, 'capo_commessa')
      }),
      "fallback": sixFiltersLib.should({
        "miss_specific": sixFiltersLib.missing(typeoperatorFilterField),
        "match_fallback": sixFiltersLib.exact(typeoperatorFallbackFilterField, 'capo_commessa')
      })
    })
  };
  $scope.supervisorExternalFilter = {
    'typeoperator_map': sixFiltersLib.must({
      "specific": sixFiltersLib.should({
        "match_specific": sixFiltersLib.exact(typeoperatorFilterField, 'tecnico_esterno')
      }),
      "fallback": sixFiltersLib.should({
        "miss_specific": sixFiltersLib.missing(typeoperatorFilterField),
        "match_fallback": sixFiltersLib.exact(typeoperatorFallbackFilterField, 'tecnico_esterno')
      })
    })
  };
  $scope.supervisorInternalFilter = angular.copy($scope.technicianCommissionFilter);
  $scope.maintainerFilter = {
    'typeoperator_map': sixFiltersLib.must({
      "specific": sixFiltersLib.should({
        "match_specific": sixFiltersLib.exact(typeoperatorFilterField, 'manutentore')
      }),
      "fallback": sixFiltersLib.should({
        "miss_specific": sixFiltersLib.missing(typeoperatorFilterField),
        "match_fallback": sixFiltersLib.exact(typeoperatorFallbackFilterField, 'manutentore')
      })
    })
  };
  $scope.companyFilter = {};
  $scope.supplierFilter = {};
  $scope.gridAppCallbacks = {};
  $scope.gridAppCallbacks['getReadableStatus'] = odlWorkflow.getReadableStatus;
  $scope.gridAppCallbacks['getReadableType'] = getReadableType;
  $scope.gridAppCallbacks['getReadableUser'] = getReadableUser;
  $scope.gridAppCallbacks['buildMultiSelectFilter'] = buildMultiSelectFilter;
  $scope.gridAppCallbacks['lookupCellValueFormatter'] = lookupCellValueFormatter;
  $scope.viewGridOptions = {
    enableSorting: true,
    enableGridMenu: true,
    exporterCsvColumnSeparator: ';',
    exporterSuppressColumns: ['id', 'timeline'],
    exporterMenuPdf: false,
    enableFiltering: true,
    enableColumnResizing: true,
    paginationPageSizes: [50, 100, 250, 500],
    paginationPageSize: 50,
    useExternalPagination: true,
    useExternalFiltering: true,
    multiSelect: true,
    enableRowHeaderSelection: true,
    enableRowSelection: true,
    enableHorizontalScrollbar: 1,
    columnDefs: [{
      name: ' '
    }]
  };
  $scope.odlWorkflow = odlWorkflow;
  $scope.typeIdFilter = null;
  treeUtilities.getFlatStructureUuids().then(function (types) {
    if (types) {
      $scope.typeIdFilter = {
        'typeIdFilter': sixFiltersLib["in"]('UUID', types)
      };
    }
  });
  $scope.newOdl = function () {
    $location.path('odl/new');
  };
  $scope.refresh = function () {
    // $route.reload();
    if ($scope.viewGridOptions.columnDefs.length <= 1) {
      $scope.getColumns();
    }
    $scope.getCurrentUserOdlList();
  };
  $scope.goToOdlList = function () {
    $location.path('odl');
  };
  $scope.goToIssue = function () {
    $location.path('callcenter_detail/' + $scope.data.issue_id.UUID);
  };
  $scope.getColumns = function () {
    getColumnOrDefault();
    return $scope.columnDefs;
  };
  function hidrateColumnDef(col) {
    var property = $scope.schema.properties[col.field];
    if (property.check && property.check == true) {
      var hidrated = {
        displayName: property.title,
        field: 'model.' + col.field,
        enableFiltering: true,
        width: 100
      };
      if (property.type == 'string') {
        hidrated.filters = [{
          type: 'text',
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }];
      }
      // template per le colonne in base al loro tipo
      if (property.type == 'string') {
        hidrated.cellTemplate = '<div class="ui-grid-cell-contents cont-left">{{ row.entity.model[\'' + col.field + '\'] }}</div>';
      }
      if (property.type == 'number' || property.type == 'integer') {
        hidrated.cellTemplate = '<div class="ui-grid-cell-contents cont-right">{{ row.entity.model[\'' + col.field + '\'] }}</div>';
      }
      if (property.format && property.format == 'date') {
        hidrated.cellTemplate = '<div class="ui-grid-cell-contents cont-center">{{ row.entity.model[\'' + col.field + '\'] | date: \'dd/MM/yyyy\' }}</div>';
      }
      if (property.format && property.format == 'lookup') {
        hidrated.cellTemplate = '<div class="ui-grid-cell-contents cont-center">{{ row.entity.model[\'' + col.field + '\'] | reference }}</div>';
      }
      return hidrated;
    }
  }
  function getColumnOrDefault() {
    var requirementPromises = [odlWorkflow.getStatuses()];
    if (!$scope.schemaOdlDefined) {
      requirementPromises.push($scope.getSchemaOdl());
    }
    $q.all(requirementPromises).then(function (requirements) {
      var statuses = requirements[0];
      var statusOptions = [];
      for (var s in statuses) {
        statusOptions.push({
          "value": statuses[s].code,
          "label": statuses[s].label
        });
      }
      $scope.viewGridOptions.columnDefs = [];
      $scope.viewGridOptions.columnDefs.push({
        displayName: '',
        field: 'id',
        width: 36,
        enableCellEdit: true,
        enableFiltering: false,
        enableSorting: false,
        pinnedLeft: true,
        cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/odl/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' + '<span class="fa fa-search"></span>' + '</a>' + '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Codice',
        field: 'model.code',
        enableFiltering: true,
        pinnedLeft: true,
        width: 120,
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Titolo',
        field: 'model.title',
        enableFiltering: true,
        width: 300,
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Tipo asset',
        field: 'model.type_id',
        cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.model.type_id.description}}</div>',
        enableFiltering: true,
        width: 100,
        filters: [{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Asset',
        field: 'model.record_id',
        cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.model.record_id.description}} ({{row.entity.model.record_id.code}})</div>',
        enableFiltering: true,
        width: 150,
        filters: [{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Tipo asset target (qta)',
        field: 'model.target_type_id',
        cellTemplate: '<div class="ui-grid-cell-contents" ng-if="!row.entity.is_aggregated">-</div>' + '<div class="ui-grid-cell-contents" ng-if="row.entity.is_aggregated">{{row.entity.model.target_type_id.description}} ({{row.entity.model.record_id.children_count}})</div>',
        enableFiltering: true,
        width: 150,
        filters: [{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Servizio',
        field: 'model.service_id',
        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope">{{row.entity.model.service_id.description}} ({{row.entity.model.service_id.code}})</div>',
        enableFiltering: true,
        width: 150,
        filters: [{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Descrizione',
        field: 'model.description',
        enableFiltering: true,
        width: 500,
        cellTooltip: function cellTooltip(row) {
          return row.entity.model.description;
        },
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      //--- campi dinamici da model
      //blacklist delle colonne già visibili
      var hardcodedCols = ["code", "title", "type_id", "record_id", "target_type_id", "service_id", "description", "generation_tag", "priority_id"];
      var filteredCols = $scope.columnDefs.filter(function (col) {
        return hardcodedCols.indexOf(col.field) == -1;
      }).map(hidrateColumnDef);
      $scope.viewGridOptions.columnDefs = $scope.viewGridOptions.columnDefs.concat(filteredCols);
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Stato',
        field: 'status',
        enableFiltering: true,
        width: 100,
        filterHeaderTemplate: '<div class="ui-grid-filter-container"><a class="block btn btn-default btn-xs" ng-repeat="colFilter in col.filters" ' + 'ng-click="grid.appScope.buildMultiSelectFilter(colFilter)">Filtro</a></div>',
        filters: [{
          type: sixGridPaginationConstants.filterType.SELECTMULTIPLE,
          selectOptions: statusOptions,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }],
        cellTemplate: '<div class="ui-grid-cell-contents" style="vertical-align:middle;">' + '{{grid.appScope.getReadableStatus(row.entity.status)}}' + '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data generazione',
        field: 'dataIn',
        type: 'date',
        cellFilter: 'date:\'dd/MM/yyyy\'',
        width: 100,
        enableFiltering: true,
        filters: [{
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
          placeholder: 'da...',
          condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
        }, {
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
          placeholder: 'a...',
          condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data pianifica',
        field: 'date_requested',
        type: 'date',
        cellFilter: 'date:\'dd/MM/yyyy\'',
        width: 100,
        enableFiltering: true,
        filters: [{
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
          placeholder: 'da...',
          condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
        }, {
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
          placeholder: 'a...',
          condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data presa in carico',
        field: 'date_handling',
        type: 'date',
        cellFilter: 'date:\'dd/MM/yyyy\'',
        width: 100,
        enableFiltering: true,
        visible: false,
        filters: [{
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
          placeholder: 'da...',
          condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
        }, {
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
          placeholder: 'a...',
          condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data chiusura',
        field: 'date_closing',
        type: 'date',
        cellFilter: 'date:\'dd/MM/yyyy\'',
        width: 100,
        enableFiltering: true,
        visible: false,
        filters: [{
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
          placeholder: 'da...',
          condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
        }, {
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
          placeholder: 'a...',
          condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Utente generazione',
        field: 'user',
        cellTemplate: '<div class="ui-grid-cell-contents">{{grid.appScope.getReadableUser(row.entity)}}</div>',
        enableFiltering: true,
        width: 100,
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Codice generazione programmata',
        field: 'model.generation_tag',
        enableFiltering: true,
        width: 150,
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Sorgente',
        field: 'generated_by',
        width: 150,
        enableFiltering: true,
        filters: [{
          type: sixGridPaginationConstants.filterType.SELECT,
          condition: uiGridConstants.filter.CONTAINS,
          selectOptions: [{
            value: 'issue',
            label: 'Segnalazione'
          }, {
            value: 'plan',
            label: 'Programmata'
          }],
          placeholder: ''
        }],
        cellTemplate: '<div class="ui-grid-cell-contents" style="vertical-align:middle;">' + '{{grid.appScope.getReadableType(row.entity.generated_by)}}' + '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Fornitore',
        field: 'references_assignee.supplier_id',
        width: 150,
        enableFiltering: true,
        visible: false,
        filters: [{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }],
        cellTemplate: '<div class="ui-grid-cell-contents" title="{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}">{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Azienda',
        field: 'references_assignee.company_id',
        width: 150,
        enableFiltering: true,
        visible: false,
        filters: [{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }],
        cellTemplate: '<div class="ui-grid-cell-contents" title="{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}">{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Capo comm.',
        field: 'references_assignee.headmanCommission_id',
        width: 150,
        enableFiltering: true,
        visible: false,
        filters: [{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }],
        cellTemplate: '<div class="ui-grid-cell-contents" title="{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}">{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Resp. interno',
        field: 'references_assignee.supervisorInternal_id',
        width: 150,
        enableFiltering: true,
        visible: false,
        filters: [{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }],
        cellTemplate: '<div class="ui-grid-cell-contents" title="{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}">{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Resp. esterno',
        field: 'references_assignee.supervisorExternal_id',
        width: 150,
        enableFiltering: true,
        visible: false,
        filters: [{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }],
        cellTemplate: '<div class="ui-grid-cell-contents" title="{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}">{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Tecnico comm.',
        field: 'references_assignee.technicianCommission_id',
        width: 150,
        enableFiltering: true,
        visible: false,
        filters: [{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }],
        cellTemplate: '<div class="ui-grid-cell-contents" title="{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}">{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Manutentori',
        field: 'references_assignee.maintainer_id',
        width: 150,
        enableFiltering: true,
        visible: false,
        filters: [{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }],
        cellTemplate: '<div class="ui-grid-cell-contents" title="{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}">{{grid.appScope.lookupCellValueFormatter(grid.getCellValue(row, col))}}</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Priorità',
        field: 'model.priority_id',
        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope">{{row.entity.model.priority_id.description}} ({{row.entity.model.priority_id.code}})</div>',
        enableFiltering: true,
        visible: false,
        width: 150,
        filters: [{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
    });
  }
  function lookupCellValueFormatter(value) {
    var formatted = "";
    if (typeof value != "undefined") {
      if (value !== null && angular.isArray(value)) {
        angular.forEach(value, function (row) {
          formatted += row.description + ' (' + row.code + '); \n';
        });
      } else if (value !== null && angular.isObject(value)) {
        formatted = value.description + ' (' + value.code + ')';
      } else {
        formatted = value;
      }
    }
    return formatted;
  }
  function buildMultiSelectFilter(filter) {
    var options = '';
    filter.selectOptions.forEach(function (val, key) {
      options += '<label class="checkbox i-checks m-t-none m-b-none"><input type="checkbox" ' + 'ng-model="ngDialogData.selection[' + key + '].active"><i></i> ' + val.label + '</label>';
    });
    if (Array.isArray(filter.term)) {
      filter.term.forEach(function (term) {
        filter.selectOptions.forEach(function (v, k, opt) {
          if (v.value == term) opt[k].active = true;
        });
      });
    }
    ngDialog.openConfirm({
      name: 'multiSelectFilterDialog',
      closeByDocument: false,
      showClose: true,
      template: '' + '<div style="text-align:center">Seleziona filtri da attivare ' + '</div><br>' + '' + options + '' + '<div class="row" style="text-align:center; clear: both">' + '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ' + 'ng-click="confirm(ngDialogData.selection)">Applica filtro</button>' + '</div>',
      data: {
        selection: filter.selectOptions
      },
      plain: true,
      className: 'ngdialog-theme-default ngdialog-theme-custom'
    }).then(function (selection) {
      filter.term = [];
      selection.forEach(function (sel) {
        if (sel.active) {
          filter.term.push(sel.value);
        }
      });
    });
  }
  var OPERATOR_NOT_FOUND_ERR_SHOWN = false;
  $scope.getCurrentUserOperator = function () {
    $scope.currentUserOperator = undefined;
    var currentUser = authFactory.getAuthData().authId;
    var filters = {};
    filters['model.username'] = {
      type: '_exact',
      key: 'model.username',
      value: currentUser
    };
    return recordFactory('operatore').search({
      page_size: 1,
      show_revision: false
    }, filters).$promise.then(function (data) {
      $scope.currentUserOperator = data.list[0];
    })["catch"](function () {
      //parametri disponibili, ma non utilizzati: response
      if (!OPERATOR_NOT_FOUND_ERR_SHOWN) {
        toaster.pop('error', 'Errore', 'Operatore corrispondente all\'utente \'' + currentUser + '\' non trovato');
        OPERATOR_NOT_FOUND_ERR_SHOWN = true;
      }
    })["finally"](function () {
      //parametri disponibili, ma non utilizzati: response
      return $scope.currentUserOperator;
    });
  };
  $scope.getCurrentUserOdlList = function () {
    if (!$scope.currentUserOperator || !$scope.currentUserOperator.UUID) {
      return $scope.getCurrentUserOperator().then(function () {
        //parametri disponibili, ma non utilizzati: operator
        return $scope.getOdlList();
      });
    } else {
      return $scope.getOdlList();
    }
  };
  $scope.promiseCounter = 0;
  $scope.getOdlList = function () {
    $scope.buildformattedString();
    var filters = angular.copy($scope.params.filters);
    // filtraggio in base all'operatore sugli assegnatari
    if ($scope.currentUserOperator && $scope.currentUserOperator.UUID && !$scope.bool.allOdl) {
      filters['user'] = sixFiltersLib.exact('user', $scope.currentUserOperator.model.username);
      filters['headmanCommission_id'] = sixFiltersLib.exact('references_assignee.headmanCommission_id.UUID', $scope.currentUserOperator.UUID, sixFiltersLib.CONSTRAINTS.OR);
      filters['technicianCommission_id'] = sixFiltersLib["in"]('references_assignee.technicianCommission_id', [$scope.currentUserOperator.UUID], sixFiltersLib.CONSTRAINTS.OR);
      filters['maintainer_id'] = sixFiltersLib["in"]('references_assignee.maintainer_id', [$scope.currentUserOperator.UUID], sixFiltersLib.CONSTRAINTS.OR);
      filters['supervisorInternal_id'] = sixFiltersLib.exact('references_assignee.supervisorInternal_id.UUID', $scope.currentUserOperator.UUID, sixFiltersLib.CONSTRAINTS.OR);
      filters['supervisorExternal_id'] = sixFiltersLib.exact('references_assignee.supervisorExternal_id.UUID', $scope.currentUserOperator.UUID, sixFiltersLib.CONSTRAINTS.OR);
    }
    // creazione payload
    var payload = {
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      sort_fields: $scope.params.sortFields,
      show_revision: false,
      commission: currentCommission.code
    };
    $scope.promiseCounter += 1;
    return odlFactory().search(payload, filters).$promise.then(function (counter) {
      if (counter == $scope.promiseCounter) {
        return function (data) {
          $scope.odlList.totalResults = data.totalResults;
          $scope.odlList.list = data.list;
          $scope.params.sixApi.refreshList(data.list);
          return data;
        };
      }
    }($scope.promiseCounter));
  };
  $scope.validate = function () {
    var form = document.forms['detailForm'];
    if (form) {
      $scope.$broadcast('schemaFormValidate');
      $timeout(function () {
        var invElements = angular.element(form.getElementsByClassName("ng-invalid"));
        if (invElements.length > 0) {
          toaster.pop('error', 'Errore', 'Dati obbligatori mancanti.');
        } else {
          $scope.update();
        }
      }, 500);
    }
  };
  $scope.update = function () {
    if (($scope.data.model.type_id || $scope.data.model.record_type_id) && /* odl da issue e da plan usano una variabile diversa */
    $scope.data.model.record_id && $scope.data.model.service_id) {
      if (!$scope.data.version) {
        /* se è nuovo */
        $scope.data.model.insertedFrom = 'callcenter'; //inietto origine
        counterFactory.next({
          code: $scope.counterNameOdl
        }).$promise.then(function (response) {
          if (response.errors) {
            $scope.errorsRetrievingCounter(response.errors);
            return;
          }
          $scope.data.model.code = response.next;
          if (!$scope.data.model.description) {
            $scope.data.model.description = $scope.data.model.code + ' - ' + $scope.data.model.type_id.description + ' - ' + $scope.data.model.record_id.description;
          }
          if (angular.isUndefined($scope.data.model.attachments)) {
            $scope.data.model.attachments = [];
          }
          writeAttachments($scope.data.model.attachments);
          odlFactory().createOdl({
            commissionDependent: $scope.commissionDependent
          }, $scope.data).$promise.then(function (response) {
            toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
            $location.path('odl/' + response.UUID);
          })["catch"](function () {
            //parametri disponibili, ma non utilizzati: response
            toaster.pop('error', 'Errore salvataggio', 'Si è verificato un errore durante il salvataggio');
          });
        });
      } else {
        /* se è già versionato */
        if (angular.isDefined($scope.data.model.attachments)) {
          writeAttachments($scope.data.model.attachments);
        }
        $scope.data.status_note = null; //le note devono appartenere solo alla versione salvata appositamente per il cambiamento di stato dell'odl -> resetto il campo
        odlFactory().updateOdl({
          id: $scope.data.version
        }, $scope.data).$promise.then(function (resp) {
          $scope.data.version = resp.version;
          toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
        })["catch"](function (rejection) {
          toaster.pop('error', 'Errore salvataggio', rejection.data.message ? rejection.data.message : rejection.statusText);
        });
      }
    } else {
      toaster.pop('error', 'Errore Inserimento', 'Non sono stati riempiti tutti i campi necessari: Elemento tecnologico, Asset, Servizio');
    }
  };
  $scope["delete"] = function (idToDelete) {
    odlFactory().referenceCount({
      id: $scope.data.UUID
    }).$promise.then(function (response) {
      var deleteMessage = 'Eliminare l\'ODL?';
      if (response.count != 0) {
        deleteMessage = 'L\'ODL che stai eliminando è in uso nel sistema.<br> Vuoi rimuoverlo comunque?';
      }
      dialogService.confirmDialog(deleteMessage, function () {
        $log.info('deleting id:' + idToDelete);
        if ($scope.data.generated_by == 'plan' && angular.isDefined($scope.data.model.parent_record_id)) {
          odlFactory().deletePlanOdl({
            id: idToDelete
          }).$promise.then(function () {
            $scope.getOdlList();
            $location.path('/odl', false);
          });
        } else {
          odlFactory().deleteIssueOdl({
            id: idToDelete
          }).$promise.then(function () {
            $scope.getOdlList();
            $location.path('/odl', false);
          });
        }
      });
    });
  };
  $scope.getSelectedRows = function () {
    var api = $scope.params.gridApi;
    if (api && api.selection) {
      return api.selection.getSelectedRows();
    } else {
      return [];
    }
  };
  $scope.deleteOdlSelected = function () {
    var rows = $scope.getSelectedRows();
    rows.forEach(function (val, i) {
      rows[i] = val.version;
    });
    odlFactory().bulkDeleteOdl(rows).$promise.then(function () {
      //parametri disponibili, ma non utilizzati: data
      $scope.refresh();
    });
  };
  $scope.getOdlById = function (itemUUID) {
    if (itemUUID == 'new') {
      $scope.isNew = true;
      $scope.getSchemaOdl();
      counterFactory.current({
        code: $scope.counterNameOdl
      }).$promise.then(function (response) {
        if (response.errors) {
          $scope.errorsRetrievingCounter(response.errors);
          $window.history.back();
          return;
        }
        $scope.data.model.code = (parseInt(response.current) + 1).toString();
      });
      odlWorkflow.getStatusMappings().then(function (mapping) {
        $scope.data.status = mapping['open'];
      });
    } else {
      $scope.isNew = false;
      odlFactory().getOdlByUUID({
        uuid: itemUUID
      }).$promise.then(function (response) {
        if (response) {
          $scope.data = response;
          if (!$scope.data.references_assignee) {
            // se non c'è lo inizializzo per evitare che le lookup vadano in errore
            $scope.data.references_assignee = {
              supplier_id: undefined,
              company_id: undefined,
              headmanCommission_id: undefined,
              technicianCommission_id: [],
              maintainer_id: [],
              supervisorExternal_id: undefined,
              supervisorInternal_id: undefined
            };
          }
          if (!$scope.data.watchers) {
            $scope.data.watchers = {
              external: [],
              internal: []
            };
          }

          /* ho cambiato la posizione per ottenere lo schema dell'odl altrimenti non si riusciva ad inizializzare la lookup */
          $scope.getSchemaOdl();
          $scope.currentOdlRef = sixObjectLib.recordToHisRef($scope.data);
          // FIXME: vedere come risolvere la gestione delle date
          if ($scope.data.date_requested) {
            $scope.data.date_requested = new Date($scope.data.date_requested);
          }
          if ($scope.data.date_insertion) {
            $scope.data.date_insertion = new Date($scope.data.date_insertion);
          }
          if ($scope.data.date_handling) {
            $scope.data.date_handling = new Date($scope.data.date_handling);
          }
          if ($scope.data.date_closing) {
            $scope.data.date_closing = new Date($scope.data.date_closing);
          }
          if ($scope.data.dataIn) {
            $scope.data.dataIn = new Date($scope.data.dataIn);
          }
          $scope.getNotificationsList();
          if (angular.isUndefined($scope.data.model.attachments)) {
            $scope.data.model.attachments = [];
          }
          readAttachments($scope.data.model.attachments);
        }
      });
    }
  };
  $scope.getSchemaOdl = function () {
    return odlFactory().getOdlSchema().$promise.then(function (data) {
      if (data.model) {
        $scope.schemaOdlDefined = true;
        $scope.configCurrentSchema = angular.copy(data);
        $scope.schema = data.model.schema;
        $scope.form = data.model.form;
        $scope.columnDefs = data.model.columnDefs;
        $scope.model = {};
      } else {
        $scope.schemaOdlDefined = false;
        toaster.pop('error', 'Errore caricamento pagina', 'Nessun modello salvato per il tipo \'odl\'.');
      }
    });
  };
  $scope.massiveClosingOdl = function () {
    var odlList = $scope.params.gridApi.selection.getSelectedRows();
    if (odlList && odlList.length > 0) {
      var dateClosingDialog = ngDialog.openConfirm({
        name: 'dateClosingDialog',
        closeByDocument: false,
        showClose: true,
        template: '' + '<div style="text-align:center"><i class="fa fa fa-calendar"></i> Inserire la data di chiusura</div><br>' + '<div style="text-align:left">' + ' da calendario:' + '<input class="form-control" id="input_dialog_date" type="date" ng-model="date">' + '</div>' + '<div style="text-align:left">' + ' o da num. giorni lavorativi:' + '<input class="form-control" id="input_dialog_days" type="number" ng-model="days">' + '</div>' + '<div style="text-align:left">' + ' Note:' + '<textarea id="odl_note" style="margin: 0px; width: 420px; height: 98px; resize: vertical;" ng-model="notes">' + '</textarea>' + '</div>' + '<div style="text-align:center">' + '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ng-click="confirm()">OK</button>' + '</div>',
        plain: true,
        className: 'ngdialog-theme-default ngdialog-theme-custom'
      });
      dateClosingDialog.then(function () {
        // success
        var type = '';
        var value = null;
        if (document.getElementById('odl_note').value) {
          var note = document.getElementById('odl_note').value;
          odlList.forEach(function (odl) {
            odl.status_note = note;
          });
        }
        if (document.getElementById("input_dialog_date").value) {
          value = document.getElementById("input_dialog_date").value;
          type = 'date';
        }
        if (document.getElementById("input_dialog_days").value) {
          value = document.getElementById("input_dialog_days").value;
          type = 'days';
        }
        var daysVar = null;
        var dateVar = null;
        if (type == 'days') {
          daysVar = parseInt(value);
        }
        if (type == 'date') {
          dateVar = new Date(value);
        }
        var payload = {
          odlList: odlList,
          typeClosingOdl: type,
          daysClosingValue: daysVar,
          dateClosingValue: dateVar
        };
        odlFactory().bulkClose(payload).$promise.then(function (data) {
          if (data.hasErrors || data.hasWarnings) {
            dialogService.serviceResponse('Esito', data, false);
          }
        })["catch"](function (response) {
          // error
        })["finally"](function () {
          //parametri disponibili, ma non utilizzati: response
          $scope.getOdlList();
        });
      }, function (resp) {} // reject
      );
    } else {
      toaster.pop('warning', 'Nessuna selezione', 'Nessun ODL selezionato');
    }
  };
  $scope.bulkEditorVisible = false;
  $scope.bulkEditConf = {
    dataGetter: function dataGetter() {
      //recupero l'ultima versione dei dati selezionati nella grid
      var rows = $scope.getSelectedRows();
      var uuid_filters = {};
      for (var r in rows) {
        uuid_filters['uuid_' + r] = sixFiltersLib.exact('UUID', rows[r].UUID, sixFiltersLib.CONSTRAINTS.OR);
      }
      var filters = {
        "uuid": sixFiltersLib.must(uuid_filters)
      };
      var payload = {
        page_size: 10000,
        show_revision: false
      };
      return odlFactory().search(payload, filters).$promise.then(function (results) {
        if (results.list) {
          return results.list;
        }
        return [];
      });
    },
    factory: function factory(payload) {
      return odlFactory().bulkUpdateOdl(payload).$promise;
    },
    compactSchema: {
      "date_requested": {
        title: "Data Richiesta",
        format: "date",
        form_type: "datepicker"
      },
      "date_handling": {
        title: "Data Inizio Lavori",
        format: "date",
        form_type: "datepicker"
      },
      "date_closing": {
        title: "Data Chiusura",
        format: "date",
        form_type: "datepicker"
      },
      "model.service_id": {
        title: "Servizio",
        form_type: "sixlookup",
        format: "lookup",
        war: "six-data-set",
        entity_id: "servizio"
      },
      "references_assignee.supplier_id": {
        title: "Fornitore",
        form_type: "sixlookup",
        format: "lookup",
        war: "six-data-set",
        entity_id: "fornitore",
        form_sxFilter: $scope.supplierFilter
      },
      "references_assignee.company_id": {
        title: "Azienda assegnataria",
        form_type: "sixlookup",
        format: "lookup",
        war: "six-data-set",
        entity_id: "azienda",
        form_sxFilter: $scope.companyFilter
      },
      "references_assignee.headmanCommission_id": {
        title: "Capo commessa",
        form_type: "sixlookup",
        format: "lookup",
        war: "six-data-set",
        entity_id: "operatore",
        form_sxFilter: $scope.headmanCommissionFilter
      },
      "references_assignee.supervisorInternal_id": {
        title: "Responsabile interno",
        form_type: "sixlookup",
        format: "lookup",
        war: "six-data-set",
        entity_id: "operatore",
        form_sxFilter: $scope.supervisorInternalFilter
      },
      "references_assignee.supervisorExternal_id": {
        title: "Referente esterno",
        form_type: "sixlookup",
        format: "lookup",
        war: "six-data-set",
        entity_id: "operatore",
        form_sxFilter: $scope.supervisorExternalFilter
      },
      "references_assignee.technicianCommission_id": {
        title: "Tecnico di commessa",
        form_type: "sixlookup",
        format: "lookup",
        war: "six-data-set",
        entity_id: "operatore",
        multiple: true,
        form_sxFilter: $scope.technicianCommissionFilter
      },
      "references_assignee.maintainer_id": {
        title: "Manutentori",
        form_type: "sixlookup",
        format: "lookup",
        war: "six-data-set",
        entity_id: "operatore",
        multiple: true,
        form_sxFilter: $scope.maintainerFilter
      }
    },
    callbacks: {
      "references_assignee.supplier_id": bulkWatcherCallback,
      "references_assignee.company_id": bulkWatcherCallback,
      "references_assignee.supervisorInternal_id": bulkWatcherCallback,
      "references_assignee.supervisorExternal_id": bulkWatcherCallback,
      "references_assignee.headmanCommission_id": bulkWatcherCallback,
      "references_assignee.technicianCommission_id": bulkWatcherCallback,
      "references_assignee.maintainer_id": bulkWatcherCallback
    },
    postSave: function postSave() {
      $scope.bulkEditorVisible = false;
      $scope.refresh();
    },
    cancel: function cancel() {
      $scope.bulkEditorVisible = false;
    }
  };
  $scope.getSchemaOdl().then(function () {
    $scope.bulkEditConf.schemaForm = $scope.configCurrentSchema.model;
  });
  function bulkWatcherCallback(fieldValue, fullObject, sourceValue) {
    //parametri disponibili, ma non utilizzati: sourceObject
    if (fieldValue || sourceValue) {
      var valueArray = fieldValue;
      if (!Array.isArray(fieldValue)) {
        //wrappo in un array anche i singoli valori per generalizzare l'operazione
        valueArray = [fieldValue];
      }
      var oldValueArray = sourceValue;
      if (!Array.isArray(sourceValue)) {
        oldValueArray = [sourceValue];
      }
      //faccio un diff tra sourceValue e fieldValue per determinare quali sono stati rimossi e toglierli dai watcher
      oldValueArray.forEach(function (oldValue) {
        var shouldBeRemoved = true;
        valueArray.forEach(function (newValue) {
          if (newValue.UUID == oldValue.UUID) {
            shouldBeRemoved = false;
          }
        });
        if (shouldBeRemoved) {
          //rimuovo dai watchers
          for (var i = 0; i < fullObject.watchers.internal.length; i++) {
            if (oldValue.UUID == fullObject.watchers.internal[i].UUID) {
              delete fullObject.watchers.internal[i];
            }
          }
        }
      });
      valueArray.forEach(function (fieldValue) {
        var alreadyWatching = false;
        for (var i = 0; i < fullObject.watchers.internal.length; i++) {
          if (fieldValue.UUID == fullObject.watchers.internal[i].UUID) {
            alreadyWatching = true;
          }
        }
        if (alreadyWatching == false) {
          fullObject.watchers.internal.push(fieldValue);
        }
      });
    }
    return fullObject;
  }
  $scope.bulkEdit = function () {
    $scope.bulkEditorVisible = true;
  };
  function setBodyText(notification) {
    var model = notification.model;
    if (angular.isDefined(model)) {
      var bodyHtml = model.body;
      if (angular.isDefined(bodyHtml)) {
        bodyHtml = "<div>" + bodyHtml + "</div>";
        model.bodyAsText = $(bodyHtml).text();
      }
    }
  }
  $scope.getNotificationsList = function () {
    var payload = {
      page: 1,
      pageSize: 10000,
      UUID: $scope.data.UUID,
      //index: 'six_odl',
      typeNotification: 'odl',
      list: null
    };
    notificationFactory().getListFiltered(payload).$promise.then(function (data) {
      $scope.notifications = data.list;
      if ($scope.notifications) {
        for (var i = 0; i < $scope.notifications.length; i++) {
          var notification = $scope.notifications[i];
          setBodyText(notification);
          notification.color = 'b-l-warning';
          notification.href = "#/notification/" + notification.version;
        }
      }
    });
  };
  $scope.showAssetsList = function () {
    if (angular.isUndefined($scope.assetsList)) {
      var payload = {
        page: 1,
        pageSize: 10000,
        code: $scope.data.model.code,
        sortFields: "model.record_id.description",
        sortDirections: "asc",
        id: $scope.data.model.code
      };
      odlFactory().getAssetsList(payload).$promise.then(function (data) {
        $scope.assetsList = data.list;
      });
    }
  };

  /* watch per popolare i campi dipendenti dalla segnalazione */
  $scope.$watch(function () {
    return $scope.data.issue_id;
  }, function (newVal) {
    //parametri disponibili, ma non utilizzati: oldVal
    $scope.issue = undefined;
    if (angular.isDefined(newVal) && newVal != null) {
      loadIssue($scope.data.issue_id.UUID).then(function (response) {
        if (response.model) {
          $scope.issueRefreshed.bool = true;
          if ($scope.issue.date_handling != null) {
            $scope.data.date_insertion = $scope.issue.date_handling;
          }
          // carico tutti gli altri dati per l'odl
          $scope.data.model.type_id = $scope.issue.model.type_id;
          $scope.data.model.record_id = $scope.issue.model.record_id;
          $scope.data.model.service_id = $scope.issue.model.service_id;
          $scope.data.model.priority_id = $scope.issue.model.priority_id;
          $scope.data.model.activity_id = $scope.issue.model.activity_id;
          $scope.data.model.odltype_id = $scope.issue.model.issuetype_id;
          $scope.data.model.title = $scope.issue.model.description;
          $scope.data.model.description = $scope.issue.model.note;
          /* imposto anche la descrizione dell'ordine di lavoro */
          if (!$scope.data.model.description) {
            $scope.data.model.description = $scope.data.model.code + ' - ' + $scope.data.model.type_id.description + ' - ' + $scope.data.model.record_id.description;
          }
        }
      });
    }
  });

  /* watch per refreshare lo stato della segnalazione associata */
  $scope.$watch(function () {
    return $scope.data.status;
  }, function (newVal, oldVal) {
    if (newVal && newVal != oldVal && $scope.data.issue_id && $scope.data.issue_id.UUID) {
      loadIssue($scope.data.issue_id.UUID); // così lancio il refresh del tab
    }
  });

  function loadIssue(uuidIssue) {
    var deferred = $q.defer();
    issueFactory("issue/record/_uuid/" + uuidIssue).getUUID().$promise.then(function (response) {
      if (angular.isDefined(response.model)) {
        $scope.issue = response;
        if ($scope.issue.date_requested) {
          $scope.issue.date_requested = new Date($scope.issue.date_requested);
        }
        if ($scope.issue.date_insertion) {
          $scope.issue.date_insertion = new Date($scope.issue.date_insertion);
        }
        if ($scope.issue.date_handling) {
          $scope.issue.date_handling = new Date($scope.issue.date_handling);
        }
        if ($scope.issue.date_closing) {
          $scope.issue.date_closing = new Date($scope.issue.date_closing);
        }
        deferred.resolve(response);
      } else {
        deferred.reject(response);
      }
    });
    return deferred.promise;
  }
  $scope.$watch('issueRefreshed.bool', function (newVal, oldVal) {
    if (newVal != oldVal) {
      if (newVal == true) {
        odlFactory().getIssueNotAssigned().$promise.then(function (data) {
          if (data.hasErrors || data.hasWarnings) {
            dialogService.serviceResponse('Esito', data, false);
          }
          if (data.result) {
            if (data.result.length > 0) {
              delete $scope.issueRefreshed.filter;
              var filterStr = '';
              angular.forEach(data.result, function (value) {
                if (value.UUID) {
                  if (filterStr == '') {
                    filterStr = value.UUID;
                  } else {
                    filterStr = filterStr + ', ' + value.UUID;
                  }
                }
              });
              $scope.issueRefreshed.filter = {
                'UUID': filterStr
              };
            }
          }
        })["catch"](function (response) {
          // error
        });
      } else {
        $scope.issueRefreshed.filter = {};
      }
    }
  });
  $scope.$watch('data.model.type_id', function (newVal, oldVal) {
    if (newVal != oldVal && $scope.issueRefreshed.bool == false && $scope.init !== true) {
      $scope.data.model.record_id = null;
    }
    if (newVal) {
      $scope.init = false; // prima inizializzazione eseguita
    }

    $scope.issueRefreshed.bool = false;
  });

  /*** PARTE CONFIGURAZIONE ***/

  /* controlla che tutti rif. siano vuoti */
  function isReferencesEmpty(data) {
    return !data.references_assignee || !data.references_assignee.supplier_id && !data.references_assignee.company_id && !data.references_assignee.supervisorInternal_id && !data.references_assignee.supervisorExternal_id && !data.references_assignee.headmanCommission_id && data.references_assignee.technicianCommission_id.length == 0 && data.references_assignee.maintainer_id == 0;
  }
  $scope.$watchGroup(['data.model.record_id', 'data.model.service_id'], function () {
    //parametri disponibili, ma non utilizzati: newValue, oldValue
    if ($scope.data.model.type_id && $scope.data.model.record_id && isReferencesEmpty($scope.data) && !$scope.data.version) {
      // azzero i precedenti
      $scope.data.references_assignee = {
        technicianCommission_id: [],
        maintainer_id: []
      };
      $scope.data.watchers.internal = [];
      $scope.data.watchers.external = [];

      // scarico la configurazione...
      var payload = {
        type_id: $scope.data.model.type_id,
        record_id: $scope.data.model.record_id,
        service_id: $scope.data.model.service_id,
        response: {}
      };
      treePlanConfigFactory.getCompleteConfiguration(payload).$promise.then(function (respConf) {
        if (respConf.response != {} && respConf.response != undefined && respConf.response != null) {
          if (respConf.response.responsable && respConf.response.responsable.length > 0) {
            $scope.responsableList = respConf.response.responsable;
          }
          /* COMPANY */
          if (respConf.response.company) {
            if (respConf.response.company["default"].length > 0) {
              $scope.data.references_assignee.company_id = respConf.response.company["default"][0];
            }
            // creaz. filtro
            if (respConf.response.company.assignee.length > 0) {
              $scope.companyFilter = getFilter($scope.companyFilter, respConf.response.company.assignee);
            }
          }
          /* SUPPLIER */
          if (respConf.response.supplier) {
            if (respConf.response.supplier["default"].length > 0) {
              $scope.data.references_assignee.supplier_id = respConf.response.supplier["default"][0];
            }
            if (respConf.response.supplier.assignee.length > 0) {
              $scope.supplierFilter = getFilter($scope.supplierFilter, respConf.response.supplier.assignee);
            }
          }
          /* ISSUE TYPE */
          if (respConf.response.issueType) {
            if (respConf.response.issueType["default"].length > 0) {
              $scope.data.model.odltype_id = respConf.response.issueType["default"][0];
            }
            // creaz. filtro
            // al momento non riusciamo a filtrare dentro al model -> condizionare angular-schema-form-sixlookup
          }
          /* RESPONSE PRIORITY */
          if (respConf.response.priority) {
            if (respConf.response.priority["default"].length > 0) {
              $scope.data.model.priority_id = respConf.response.priority["default"][0];
            }
            // creaz. filtro
            // al momento non riusciamo a filtrare dentro al model -> condizionare angular-schema-form-sixlookup
          }
          /* HEADMAN COMMISSION */
          if (respConf.response.headmanCommission) {
            if (respConf.response.headmanCommission["default"].length > 0) {
              $scope.data.references_assignee.headmanCommission_id = respConf.response.headmanCommission["default"][0];
            }
            if (respConf.response.headmanCommission.assignee.length > 0) {
              $scope.headmanCommissionFilter = getFilter($scope.headmanCommissionFilter, respConf.response.headmanCommission.assignee);
            }
          }
          /* SUPERVISOR EXTERNAL */
          if (respConf.response.supervisorExternal) {
            if (respConf.response.supervisorExternal["default"].length > 0) {
              $scope.data.references_assignee.supervisorExternal_id = respConf.response.supervisorExternal["default"][0];
            }
            if (respConf.response.supervisorExternal.assignee.length > 0) {
              $scope.supervisorExternalFilter = getFilter($scope.supervisorExternalFilter, respConf.response.supervisorExternal.assignee);
            }
          }
          /* SUPERVISOR INTERNAL */
          if (respConf.response.supervisorInternal) {
            if (respConf.response.supervisorInternal["default"].length > 0) {
              $scope.data.references_assignee.supervisorInternal_id = respConf.response.supervisorInternal["default"][0];
            }
            if (respConf.response.supervisorInternal.assignee.length > 0) {
              $scope.supervisorInternalFilter = getFilter($scope.supervisorInternalFilter, respConf.response.supervisorInternal.assignee);
            }
          }
          /* TECHNICIAN COMMISSION */
          if (respConf.response.technicianCommission) {
            if (respConf.response.technicianCommission["default"].length > 0) {
              $scope.data.references_assignee.technicianCommission_id = respConf.response.technicianCommission["default"];
            }
            if (respConf.response.technicianCommission.assignee.length > 0) {
              $scope.technicianCommissionFilter = getFilter($scope.technicianCommissionFilter, respConf.response.technicianCommission.assignee);
            }
          }
          /* MANTEINER */
          if (respConf.response.maintainer) {
            if (respConf.response.maintainer["default"].length > 0) {
              $scope.data.references_assignee.maintainer_id = respConf.response.maintainer["default"];
            }
            if (respConf.response.maintainer.assignee.length > 0) {
              $scope.maintainerFilter = getFilter($scope.maintainerFilter, respConf.response.maintainer.assignee);
            }
          }
        }
      });
    }
  });

  /* costruzione filtro per profilare le lookup su tutti gli operatori -> in base all'azienda */
  $scope.buildCompanyFilter = function (ref_company_id) {
    if (ref_company_id) {
      // aggiungo il filtro dell'azienda su tutte le lookup
      $scope.technicianCommissionFilter['company_id'] = sixFiltersLib.exact('model.company_id.UUID', ref_company_id.UUID);
      $scope.headmanCommissionFilter['company_id'] = sixFiltersLib.exact('model.company_id.UUID', ref_company_id.UUID);
      $scope.supervisorExternalFilter['company_id'] = sixFiltersLib.exact('model.company_id.UUID', ref_company_id.UUID);
      $scope.supervisorInternalFilter['company_id'] = sixFiltersLib.exact('model.company_id.UUID', ref_company_id.UUID);
      $scope.maintainerFilter['company_id'] = sixFiltersLib.exact('model.company_id.UUID', ref_company_id.UUID);
    } else {
      // tolgo il filtro dell'azienda
      delete $scope.technicianCommissionFilter['company_id'];
      delete $scope.headmanCommissionFilter['company_id'];
      delete $scope.supervisorExternalFilter['company_id'];
      delete $scope.supervisorInternalFilter['company_id'];
      delete $scope.maintainerFilter['company_id'];
    }
  };

  /* lookup sui campi singoli per popolare i watchers */
  $scope.$watchGroup(['data.references_assignee.company_id', 'data.references_assignee.supplier_id', 'data.references_assignee.headmanCommission_id', 'data.references_assignee.supervisorExternal_id', 'data.references_assignee.supervisorInternal_id'], function (newValues, oldValues) {
    for (var i = 0; i < 5; i++) {
      if (newValues[i] != oldValues[i]) {
        // se è cambiato il riferimento, gestisco i vari casi:
        if (newValues[i] && !oldValues[i]) {
          // aggiungo il nuovo ai watchers
          copyInWatchers(newValues[i]);
        } else if (!newValues[i] && oldValues[i]) {
          // tolgo dai watchers
          deleteFromWatchers(oldValues[i]);
        } else if (newValues[i] && oldValues[i]) {
          // se sono entrambi definiti tolgo il vecchio e metto il nuovo rif.
          deleteFromWatchers(oldValues[i]);
          copyInWatchers(newValues[i]);
        }
      }
    }
  });

  /* lookup multiple per popolare i watchers */
  $scope.$watchGroup(['data.references_assignee.technicianCommission_id', 'data.references_assignee.maintainer_id'], function (newValues, oldValues) {
    for (var i = 0; i < 2; i++) {
      if (newValues[i] && oldValues[i] && newValues[i] != oldValues[i]) {
        newValues[i].forEach(function (ref) {
          deleteFromWatchers(ref);
          copyInWatchers(ref);
        });
      }
    }
  });
  function deleteFromWatchers(obj) {
    var index = -1;
    for (var i = 0; i < $scope.data.watchers.internal.length; i++) {
      if (obj.UUID == $scope.data.watchers.internal[i].UUID) {
        index = i;
      }
    }
    if (index > -1) {
      $scope.data.watchers.internal.splice(index, 1);
    }
  }
  function copyInWatchers(obj) {
    var bool = false;
    for (var i = 0; i < $scope.data.watchers.internal.length; i++) {
      if (obj.UUID == $scope.data.watchers.internal[i].UUID) {
        bool = true;
      }
    }
    if (bool == false) {
      $scope.data.watchers.internal.push(obj);
    }
  }
  $scope.toggleAllOdl = function () {
    $scope.bool.allOdl = !$scope.bool.allOdl;
    localStorageService.set('odl_bool', $scope.bool);
    $scope.refresh();
  };
  $scope.addParentFilter = function () {
    $scope.assetTreeFilter.push({
      type: {},
      item: {},
      parents: {}
    });
  };
  $scope.removeParentFilter = function (k) {
    $scope.assetTreeFilter.splice(k, 1);
  };
  $scope.resetTreeFiltering = function () {
    $scope.assetTreeFilter = [];
    $scope.refresh();
  };
  $scope.buildformattedString = function () {
    var out = {};

    //filtri albero
    var parents = $scope.assetTreeFilter;
    var parentFilters = {};
    for (var p in parents) {
      if (angular.isDefined(parents[p].type.type_id)) {
        //filtro per includere tutti i nodi che hanno tra i parent la radice scelta
        var subfilters = {
          "p_type": sixFiltersLib.exact("parents.type", parents[p].type.type_id.UUID),
          "p_uuid": sixFiltersLib.exact("parents.UUID", parents[p].item.record_id.UUID)
        };
        parentFilters["descendants" + p] = sixFiltersLib.should({
          "nest_wrap": sixFiltersLib.nested("parents", subfilters)
        });

        //per includere anche la radice scelta tra i risultati
        var pfilter = {
          "type": sixFiltersLib.exact("schemaCode", parents[p].type.type_id.UUID),
          "uuid": sixFiltersLib.exact("UUID", parents[p].item.record_id.UUID)
        };
        parentFilters["root" + p] = sixFiltersLib.should(pfilter);
      }
    }
    if (Object.keys(parentFilters).length) {
      var assetWhitelist = ["azienda", "servizio"];
      for (var w in assetWhitelist) {
        //aggiungo gli asset in whitelist
        parentFilters["whitelist" + w] = sixFiltersLib.should({
          "whiteList": sixFiltersLib.exact("schemaCode", assetWhitelist[w])
        });
      }
      out["parents"] = sixFiltersLib.must(parentFilters);
      $scope.params.filters["assetSubtree"] = out;
    } else {
      $scope.params.filters["assetSubtree"] = undefined;
    }
  };

  /**************
   *  --- MAIN ---
   *********** */

  if ($routeParams.id) {
    $scope.issue = issueToOdl.pop();
    if (angular.isDefined($scope.issue)) {
      $scope.data.issue_id = sixObjectLib.recordToHisRef($scope.issue);
    }
    $scope.getOdlById($routeParams.id);
  } else {
    $scope.getColumns();
    setTimeout(function () {
      if ($scope.params.sixApi) {
        $scope.params.sixApi.restoreState();
      }
    }, 500);
  }

  /******** gestione timeline **************/

  $scope.modelDataInTimeline = {};
  $scope.schemaDataInTimeline = {};
  $scope.formDataInTimeline = {};
  $scope.timeline = [];
  $scope.entity = 'odl/record';
  $scope.getTimeline = function () {
    if (angular.isDefined($scope.entity) && angular.isDefined($scope.data.UUID)) {
      $scope.buildTimeline($scope.entity, $scope.data.UUID);
    }
  };
  $scope.buildTimeline = function (entity, UUID, version) {
    $scope.entity = entity;
    $scope.timeline = odlFactory().getTimeline({
      id: UUID
    }).$promise.then(function (data) {
      $scope.timeline = data.list;
      if (angular.isDefined(version)) {
        $scope.modelDataInTimeline['version'] = version;
      }
    });
  };
  $scope.getModelDetail = function (version) {
    odlFactory().getOdlById({
      id: version
    }).$promise.then(function (data) {
      $scope.currentDataInTimeline = data;
      $scope.modelDataInTimeline.version = data.version;
      if (angular.isUndefined(data.dataOut) || data.dataOut == null) {
        data.dataOut = "_current";
      }
      console.log('type -> schema, UUID -> ' + $scope.configCurrentSchema.UUID);
      odlFactory().getSchemaInTimeline({
        id: $scope.configCurrentSchema.UUID,
        param1: data.dataOut
      }).$promise.then(function (response) {
        if (response.model) {
          $scope.showDetail = true;
          $scope.schemaDataInTimeline = response.model.schema;
          $scope.formDataInTimeline = response.model.form;
        }
      });

      // FIX date
      if ($scope.currentDataInTimeline.date_requested) {
        $scope.currentDataInTimeline.date_requested = new Date($scope.currentDataInTimeline.date_requested);
      }
      if ($scope.currentDataInTimeline.date_insertion) {
        $scope.currentDataInTimeline.date_insertion = new Date($scope.currentDataInTimeline.date_insertion);
      }
      if ($scope.currentDataInTimeline.date_handling) {
        $scope.currentDataInTimeline.date_handling = new Date($scope.currentDataInTimeline.date_handling);
      }
      if ($scope.currentDataInTimeline.date_closing) {
        $scope.currentDataInTimeline.date_closing = new Date($scope.currentDataInTimeline.date_closing);
      }
      if ($scope.currentDataInTimeline.dataIn) {
        $scope.currentDataInTimeline.dataIn = new Date($scope.currentDataInTimeline.dataIn);
      }
      if ($scope.currentDataInTimeline.dataOut && $scope.currentDataInTimeline.dataOut != '_current') {
        $scope.currentDataInTimeline.dataOut = new Date($scope.currentDataInTimeline.dataOut);
      }
    });
  };

  /******** funzioni di utility ***********/

  var PATH_ODL_DETAIL = 'odl';
  var PATH_PORTAL_ODL_DETAIL = 'portal/odl';
  $scope.getMessage = function () {
    /* creazione testo mail */
    var searchInit = {
      search: {
        obj: {
          'username': authFactory.getAuthData().authId
        }
      },
      init: {
        authId: true,
        email: true
      }
    };
    if (angular.isDefined($scope.data.model.type_id) && angular.isDefined($scope.data.model.record_id)) {
      var promiseMailReceiver = odlFactory().getMailReceiver($scope.data).$promise;
      var promiseMailUser = userFactory.getMail(searchInit).$promise;
      $scope.loadingSixMail = true;
      Promise.all([promiseMailReceiver, promiseMailUser]).then(function (response) {
        // response[0] = promiseMailReceiver, response[1] = promiseMailUser
        $scope.loadingSixMail = false;
        var httpLink = 'http://' + $location.$$host + ':' + $location.$$port + (DEV ? '' : '/' + ENV) + '/#/' + PATH_ODL_DETAIL + '/' + $scope.data.UUID;
        $scope.objMail = {
          title: 'ODL ' + $scope.data.model.code + ' su asset ' + $scope.data.model.type_id.description + ' - ' + $scope.data.model.record_id.description,
          to: formatMailReceiver(response[0]),
          cc: formatMailCc(response[1].list[0].email),
          message: 'ODL <b>' + $scope.data.model.code + '</b> su asset <b>' + $scope.data.model.type_id.description + '</b> - <b>' + $scope.data.model.record_id.description + '</b><br /><br />' + 'Dettagli ODL:<br />' + '<i>Codice</i>: <b>' + $scope.data.model.code + '</b> (link: ' + httpLink + ')' + '<br />' + '<i>Tipo elemento tecnologico</i>: (<i>cod.</i>) <b>' + getText($scope.data.model.type_id, 'code') + '</b> - (<i>descr.</i>) <b>' + getText($scope.data.model.type_id, 'description') + '</b><br />' + '<i>Elemento tecnologico</i>: (<i>cod.</i>) <b>' + getText($scope.data.model.record_id, 'code') + '</b> - (<i>descr.</i>) <b>' + getText($scope.data.model.record_id, 'description') + '</b><br />' + '<i>Segnalazione di riferimento</i>: (<i>cod.</i>) ' + getText($scope.data.issue_id, 'code') + ' - (<i>descr.</i>) ' + getText($scope.data.issue_id, 'description') + '<br />' + '<i>Tipo</i>: ' + getText($scope.data.model.odltype_id, 'description') + '<br />' + '<i>Servizio</i>: ' + getText($scope.data.model.service_id, 'description') + '<br />' + '<i>Priorità</i>: ' + getText($scope.data.model.priority_id, 'description') + '<br /><br />' + '<i>Oggetto</i>: ' + getText($scope.data.model, 'title') + '<br />' + '<i>Note</i>: ' + getText($scope.data.model, 'description') + '<br /><br />'
        };
      });
    } else {
      toaster.pop('error', 'Errore', 'Creazione della mail precompilata non riuscita.');
    }
  };

  //FIXME unused function
  function pad(value, _char, length) {
    return value.toString().length < length ? pad(_char + value, _char, length) : value;
  }
  $scope.setBoolWatchInternal = function () {
    $scope.bool_watch_internal = true;
    $scope.bool_watch_external = false;
  };
  $scope.setBoolWatchExternal = function () {
    $scope.bool_watch_internal = false;
    $scope.bool_watch_external = true;
  };
  $scope.addWatcher = function () {
    if ($scope.bool_watch_internal) {
      /* se è interno */
      if ($scope.watcher.user != null && include($scope.data.watchers.internal, $scope.watcher.user) == false) {
        $scope.data.watchers.internal.push($scope.watcher.user);
      }
      $scope.watcher.user = null;
    } else if ($scope.bool_watch_external) {
      /* se è esterno */
      if ($scope.watcher.mail != null) {
        $scope.data.watchers.external.push($scope.watcher.mail);
      }
      $scope.watcher.mail = null;
    }
  };
  $scope.addWatcherFromLookUp = function (lookup) {
    if (angular.isDefined(lookup) && lookup != null) {
      if (angular.isArray(lookup)) {
        for (var i = 0; i < lookup.length; i++) {
          copyInWatchers(lookup[i]);
        }
      } else {
        copyInWatchers(lookup);
      }
    }
  };
  $scope.addAllTechnicianCommissionFromLookUp = function () {
    //parametri disponibili, ma non utilizzati: lookup
    for (var i = 0; i < $scope.data.references_assignee.technicianCommission_id.length; i++) {
      copyInWatchers($scope.data.references_assignee.technicianCommission_id[i]);
    }
  };
  $scope.deleteWatcher = function (array, toDelete) {
    var index = array.indexOf(toDelete);
    if (index > -1) {
      array.splice(index, 1);
    }
  };
  function include(arr, obj) {
    var bool = false;
    for (var i = 0; i < arr.length; i++) {
      if (obj.code == arr[i].code) {
        bool = true;
      }
    }
    return bool;
  }

  //FIXME unused function
  function formattedLookUpOperator(obj) {
    return {
      type: 'operatore',
      code: obj.model.code,
      description: obj.model.description,
      UUID: obj.UUID
    };
  }
  function getFilter(filter, array) {
    var filterRet;
    if (!filter) {
      filterRet = {};
    } else {
      filterRet = filter;
    }
    var string = '';
    array.forEach(function (item, index) {
      if (index == 0) {
        string = item.UUID;
      } else {
        string = string + ',' + item.UUID;
      }
      filterRet['UUID'] = string;
    });
    return filterRet;
  }
  function getText(ref, element) {
    if (angular.isDefined(ref) && ref != null) {
      if (angular.isDefined(ref[element]) && ref[element] != null) {
        return ref[element];
      }
    }
    return '';
  }
  function formatMailReceiver(array) {
    /* from array to formatted string with comma */
    if (angular.isDefined(array.result)) {
      if (array.result.length != 0) {
        var strConcat = '';
        for (var i = 0; i < array.result.length; i++) {
          if (i == 0) {
            strConcat = array.result[i];
          } else {
            strConcat = strConcat + ', ' + array.result[i];
          }
        }
        return strConcat;
      } else {
        return '';
      }
    } else {
      return '';
    }
  }
  function formatMailCc(UserMailSix) {
    if (UserMailSix) {
      return UserMailSix;
    } else {
      return null;
    }
  }
  $scope.getType = function (modelItem) {
    if (modelItem.type == 'datepicker') {
      return 'date';
    } else {
      return modelItem.type;
    }
  };
  function getReadableType(type) {
    switch (type) {
      case 'issue':
        return 'Segnalazione';
      case 'plan':
        return 'Programmata';
      default:
        return 'Sconosciuta';
    }
  }
  function getReadableUser(odl) {
    if (odl.userinfo) {
      return odl.userinfo.description;
    } else {
      return odl.user;
    }
  }

  /** Jasper **/

  /*
   * 2 tipi di report:
   * - odl
   * - plan
   *
   * E' possibile specializzare i report per commessa inserendo il suffisso '_[codice_commessa]' (es. odl_1600000).
   * Questi report devono chiaramente essere caricarti su Jasper.
   */

  $scope.printOdl = function (extension) {
    var report;
    if ($scope.data.generated_by == 'plan') {
      report = 'plan';
    } else {
      report = 'odl';
    }
    var response = jasperReport(report + '_' + currentCommission.code, extension); // provo il report specifico della commessa
    response.success(function (data, status) {
      //parametri disponibili, ma non utilizzati: headers, config
      if (status == 204) {
        // se è vuoto, provo il report di default
        $log.warn('jasper report error with params report=' + report + ' and extension=' + extension + '_' + currentCommission.code + ': trying with default report');
        jasperReport(report, extension).success(function (data, status) {
          //parametri disponibili, ma non utilizzati: headers, config
          if (status != 200) {
            toaster.pop('error', "Errore", 'Errore generazione report');
          }
        });
      }
    }).error(function () {
      //parametri disponibili, ma non utilizzati: data, status, headers, config
      toaster.pop('error', "Errore", 'Errore generazione report');
    });
  };
  function jasperReport(report, extension) {
    var REPORT_URL = 'reports/EMMA/Asset/';
    report = report || 'odl';
    extension = extension || 'pdf';
    var query = '&uuid=' + $scope.data.UUID + '&commission=' + currentCommission.code;
    var reportNameToSave = 'odl_' + $scope.data.model.code + '.' + extension;
    var reportPath = REPORT_URL + report + '.' + extension;
    var payload = {
      path: reportPath,
      query: query
    };
    var config = {
      responseType: 'arraybuffer'
    };
    var promise = $http.post(APP_URL + '/rest/report/generate', payload, config);
    promise.success(function (data, status) {
      //parametri disponibili, ma non utilizzati: headers, config
      if (status == 200 && data) {
        var options;
        if (extension == 'pdf') {
          options = {
            type: 'application/pdf'
          };
        } else if (extension == 'xls') {
          options = {
            type: 'application/vnd.ms-excel;'
          };
        }
        SaveAs.download(data, reportNameToSave, options);
      }
    });
    return promise;
  }
  $scope.printSelectedOdl = function () {
    var odlList = $scope.params.gridApi.selection.getSelectedRows();
    var userFilter = {
      'model.username': sixFiltersLib.exact('model.username', authFactory.getAuthData().authId)
    };
    if (odlList && odlList.length > 0) {
      var notifyData = {
        to: null
      };
      var notifyToDialog = ngDialog.openConfirm({
        name: 'notifyToDialog',
        closeByDocument: false,
        showClose: true,
        data: notifyData,
        template: '' + '<div style="text-align:center">' + 'Invia una notifica di completamento al seguente indirizzo:<br>' + '<input class="form-control" type="email" ng-model="ngDialogData.to" placeholder="Indirizzo email">' + '</div>' + '<div style="text-align:center">' + '<button style="alignment: center; margin: 10px" type="button" ' + ' ng-disabled="!ngDialogData.to" class="btn btn-default" ng-click="confirm(ngDialogData)">OK</button>' + '</div>',
        plain: true,
        className: 'ngdialog-theme-default ngdialog-theme-custom'
      });
      recordFactory('operatore').search(userFilter).$promise.then(function (resp) {
        if (resp.list) {
          notifyData.to = resp.list[0].model.mail;
        }
      });
      notifyToDialog.then(function (notify) {
        // success
        var notifyTo = notify.to;
        var payload = [];
        var REPORT_URL = 'reports/EMMA/Asset/';
        for (var i in odlList) {
          var report = odlList[i].generated_by == 'plan' ? 'plan' : 'odl';
          var extension = 'pdf';
          var query = '&uuid=' + odlList[i].UUID + '&commission=' + currentCommission.code;
          var filename = 'odl_' + odlList[i].model.code + '.' + extension;
          var reportPaths = [
          //report specifico commessa + fallback
          REPORT_URL + report + '_' + currentCommission.code + '.' + extension, REPORT_URL + report + '.' + extension];
          payload.push({
            path: reportPaths,
            query: query,
            filename: filename
          });
        }
        var promise = $http.post(APP_URL + '/rest/report/generate-many?notifyTo=' + notifyTo, payload);
        promise.success(function (data, status) {
          //parametri disponibili, ma non utilizzati: headers, config
          if (status == 202) {
            toaster.pop('success', 'Elaborazione avviata', 'Elaborazione avviata, riceverai una email al completamento.');
          }
        });
      }, function (resp) {} // reject
      );
    } else {
      toaster.pop('warning', 'Nessuna selezione', 'Nessun ODL selezionato');
    }
  };

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'odl';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
  $scope.isUpdatePermAllowed = function () {
    return authFactory.isUpdatePermAllowed(RESOURCE_NAME);
  };
  $scope.searchAllPermAllowed = function () {
    return authFactory.checkPerm(RESOURCE_NAME, 'SEARCH_ALL');
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:OdlconfiguratorCtrl
 * @description
 * # OdlconfiguratorCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/odlconfigurator', {
    templateUrl: 'plan/odl/odlconfigurator_list.html',
    controller: 'OdlconfiguratorCtrl'
  }).when('/odlconfigurator/page/:number', {
    templateUrl: 'plan/odl/odlconfigurator_list.html',
    controller: 'OdlconfiguratorCtrl'
  }).when('/odlconfigurator/:id', {
    templateUrl: 'plan/odl/odlconfigurator_detail.html',
    controller: 'OdlconfiguratorCtrl'
  });
}]).controller('OdlconfiguratorCtrl', ["$scope", "$routeParams", "$location", "$log", "$window", "odlFactory", "schemaFactory", "commissionFactory", "toaster", "authFactory", "dialogService", function ($scope, $routeParams, $location, $log, $window, odlFactory, schemaFactory, commissionFactory, toaster, authFactory, dialogService) {
  var PATH_ODL_CONFIG = 'odlconfigurator';
  $scope.bool = {
    /* contenitore per le variabili booleane */
    isNew: false,
    isCross: false,
    confModel: false
  };
  $scope.commissionDependent = true;
  $scope.commissionCode = '';
  $scope.commissions = [];
  $scope.commissionsSelected = {
    codes: []
  };
  $scope.selected = {}; /* contenitore */

  $scope.form = {};
  $scope.model = {};
  $scope.schema = {};
  $scope.property = {};
  $scope.checked = {};
  $scope.uiselectMap = {};
  $scope.itemTypeMap = {};
  $scope.pageSize = 10;
  $scope.status = {
    isFirstOpen: true,
    isFirstDisabled: false
  };
  $scope.modeltypeList = schemaFactory().lookupList({
    page_size: 1000
  });
  $scope.addProperty = function () {
    /* aggiungo una proprietà allo Schema e al Form */
    if (angular.isDefined($scope.property.key)) {
      var p = {
        title: angular.copy($scope.property.title),
        type: angular.copy($scope.property.type),
        check: false
      };
      if ($scope.property.format) {
        p.format = angular.copy($scope.property.format);
      }
      if (p.type == 'date') {
        p.type = 'string';
        p.format = 'date';
      }
      if (p.type == 'array') {
        p.items = {
          type: angular.copy($scope.property.items_type)
        }; // default
        if ($scope.property.items_type === 'date') {
          // se è una data è diverso...
          p.items = {
            type: 'string',
            format: 'date'
          };
        }
      }
      $scope.selected.model.schema.properties[$scope.property.key] = p;
      var item = {
        title: angular.copy($scope.property.title),
        type: null,
        key: [angular.copy($scope.property.key)]
      };
      if (p.format) {
        if (p.format == 'date') {
          item.type = 'datepicker';
        } else if (p.format == 'enum') {
          item.type = 'uiselect';
          item.titleMap = [];
        } else if (p.format == 'lookup') {
          item.type = 'sixlookup';
        }
      } else if (p.type == 'string') {
        item.type = 'text';
      } else if (p.type == 'number' || p.type == 'integer') {
        item.type = 'number';
      } else if (p.type == 'boolean') {
        item.type = 'checkbox';
      } else if (p.type == 'array') {
        item.type = 'uiselectmultiple';
        item.titleMap = [];
      } else {
        // default
        item.type = angular.copy(p.type);
      }
      for (var i in $scope.selected.model.form[0].items) {
        if ($scope.selected.model.form[0].items[i].tabs) {
          $scope.selected.model.form[0].items[i].tabs[0].items.push(item);
        }
      }
    }
    $scope.getUiselectMap();
    $scope.clearNewCol();
    $scope.updateScope();
  };
  $scope.updateScope = function () {
    $scope.schema = angular.fromJson(angular.copy($scope.selected.model.schema));
    $scope.form = [angular.fromJson(angular.copy($scope.selected.model.form[0]))];
    $scope.columnDefs = angular.fromJson(angular.copy($scope.selected.model.columnDefs));
    $scope.getUiselectMap();
    $scope.formChanged();
  };
  $scope.clearNewCol = function () {
    /* pulisco la riga di inserimento di nuove proprietà */
    $scope.property.key = '';
    $scope.property.title = '';
    delete $scope.property.type;
    delete $scope.property.format;
  };
  $scope.getItemType = function (key) {
    if (valueSchema.type != 'array') {
      return valueSchema.type;
    } else {
      return valueSchema.items.type;
    }
  };
  $scope.addItemOnArray = function (key, newItem) {
    if (newItem != undefined && newItem != null) {
      newItem.name = newItem.name.toString();
      if ($scope.itemTypeMap[key] == 'integer') {
        if (parseInt(newItem.name)) {
          newItem.value = parseInt(newItem.name);
          newItem.name = newItem.value.toString(); /* nel caso ci dovesse essere un cast, torno a sovrascrivere il name */
        } else {
          return;
        }
      } else if ($scope.itemTypeMap[key] == 'number') {
        if (parseFloat(newItem.name)) {
          newItem.value = parseFloat(newItem.name);
        } else {
          return;
        }
      } else {
        newItem.value = newItem.name.toString().replace(/\s/g, '_').toLowerCase();
      }
      for (var i in $scope.selected.model.form[0].items) {
        if ($scope.selected.model.form[0].items[i].tabs) {
          $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
            if (key == item.key[0]) {
              item.titleMap.push(newItem);
            }
          });
        }
      }
      this.newItem = null;
      $scope.updateScope();
    }
  };
  $scope.deleteItemOnArray = function (key, obj) {
    for (var i in $scope.selected.model.form[0].items) {
      if ($scope.selected.model.form[0].items[i].tabs) {
        $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
          if (key == item.key[0]) {
            for (var j = item.titleMap.length; j--;) {
              if (item.titleMap[j].value == obj.value) {
                item.titleMap.splice(j, 1);
              }
            }
          }
        });
      }
    }
    this.newItem = null;
    $scope.updateScope();
  };
  $scope.deleteProperty = function (keyToDelete) {
    delete $scope.selected.model.schema.properties[keyToDelete];
    for (var i = $scope.selected.model.columnDefs.length; i--;) {
      if ($scope.selected.model.columnDefs[i].field == keyToDelete) $scope.selected.model.columnDefs.splice(i, 1);
    }
    // ...elimino sempre dalla form
    for (var i = $scope.selected.model.form[0].items.length; i--;) {
      if ($scope.selected.model.form[0].items[i].key && $scope.selected.model.form[0].items[i].key[0] == keyToDelete) {
        $scope.selected.model.form[0].items.splice(i, 1);
      }
      // Scorro anche i tabs
      if ($scope.selected.model.form[0].items[i].tabs) {
        for (var j = $scope.selected.model.form[0].items[i].tabs.length; j--;) {
          for (var k = $scope.selected.model.form[0].items[i].tabs[j].items.length; k--;) {
            if ($scope.selected.model.form[0].items[i].tabs[j].items[k].key[0] == keyToDelete) {
              $scope.selected.model.form[0].items[i].tabs[j].items.splice(k, 1);
            }
          }
        }
      }
    }
    $scope.updateScope();
  };
  $scope.formChanged = function () {
    $scope.aceModel = JSON.stringify(angular.copy($scope.selected), null, '\t');
  };
  $scope.refreshLookup = function (key, entity_id) {
    $scope.chargeAceModel();
    for (var i = $scope.selected.model.form[0].items.length; i--;) {
      if ($scope.selected.model.form[0].items[i].key && $scope.selected.model.form[0].items[i].key[0] == key) {
        $scope.selected.model.form[0].items[i].entity_id = angular.copy(entity_id);
      }
      // Scorro anche i tabs
      if ($scope.selected.model.form[0].items[i].tabs) {
        for (var j = $scope.selected.model.form[0].items[i].tabs.length; j--;) {
          for (var k = $scope.selected.model.form[0].items[i].tabs[j].items.length; k--;) {
            if ($scope.selected.model.form[0].items[i].tabs[j].items[k].key[0] == key) $scope.selected.model.form[0].items[i].tabs[j].items[k].entity_id = angular.copy(entity_id);
          }
        }
      }
    }
    $scope.selected.model.schema.properties[key].entity_id = angular.copy(entity_id);
    $scope.updateScope();
  };
  $scope.refreshBasePath = function (key, basePath) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].basePath = angular.copy(basePath);
    $scope.updateScope();
  };
  $scope.refreshWar = function (key, war) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].war = angular.copy(war);
    $scope.updateScope();
  };
  $scope.refreshFiltered = function (key, filtered) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].filtered = angular.copy(filtered);
    $scope.updateScope();
  };
  $scope.refreshFilterSourceField = function (key, filterSourceField) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].filterSourceField = angular.copy(filterSourceField);
    $scope.updateScope();
  };
  $scope.refreshFilterDestField = function (key, filterDestField) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key].filterDestField = angular.copy(filterDestField);
    $scope.updateScope();
  };
  $scope.refreshLookupOption = function (key, option, value) {
    $scope.chargeAceModel();
    $scope.selected.model.schema.properties[key][option] = angular.copy(value);
    $scope.updateScope();
  };
  $scope.refreshTitleForm = function (title) {
    $scope.chargeAceModel();
    $scope.selected.model.form[0].title = angular.copy(title);
    $scope.updateScope();
  };
  $scope.chargeAceModel = function () {
    var defaultData = angular.fromJson(angular.copy($scope.aceModel));
    if (defaultData) {
      $scope.selected = defaultData;
      $scope.schema = angular.fromJson(defaultData.model.schema);
      $scope.form = angular.fromJson(defaultData.model.form);
      $scope.columnDefs = angular.fromJson(defaultData.model.columnDefs);
    }
  };
  $scope.changeColumnDefs = function (key, value) {
    var item = {
      name: value.title,
      field: key
    };
    var map = new Map();
    angular.forEach($scope.selected.model.columnDefs, function (v) {
      map[v.field] = angular.copy(v);
    });
    if (value.check) {
      map[item.field] = angular.copy(item);
      if (value.width == '' || value.width == null) {
        delete $scope.selected.model.schema.properties[key].width;
      }
    } else {
      delete map[item.field];
      delete $scope.selected.model.schema.properties[key].width;
      $scope.selected.model.schema.properties[key].enableFiltering = false;
      $scope.selected.model.schema.properties[key].enableSorting = false;
    }
    $scope.selected.model.columnDefs = [];
    for (var it in map) {
      var app = {
        name: map[it].name,
        field: map[it].field
      };
      $scope.selected.model.columnDefs.push(app);
    }
    $scope.updateScope();
  };
  $scope.aceLoaded = function () {
    var defaultModel = {
      model: {
        schema: {
          type: "object",
          title: "",
          properties: {
            code: {
              title: "Codice",
              type: "string",
              check: true
            },
            description: {
              title: "Descrizione",
              type: "string",
              check: true
            }
          },
          required: ["code", "description"]
        },
        form: [{
          type: "fieldset",
          items: [{
            type: "tabs",
            tabs: [{
              title: "Odl",
              items: [{
                key: ["code"],
                title: "Codice",
                required: true,
                type: "text"
              }, {
                key: ["description"],
                title: "Descrizione",
                required: true,
                type: "textarea",
                placeholder: "Testo di descrizione..."
              }]
            }]
          }]
        }],
        columnDefs: [{
          "field": "code",
          "name": "Codice"
        }, {
          "field": "description",
          "name": "Descrizione"
        }]
      }
    };
    $scope.aceModel = JSON.stringify(defaultModel, null, '\t');
    $scope.chargeAceModel();
    $scope.title = angular.copy($scope.selected.model.form[0].title);
  };
  $scope.getUiselectMap = function () {
    $scope.uiselectMap = {};
    $scope.itemTypeMap = {};
    for (var i in $scope.selected.model.form[0].items) {
      if ($scope.selected.model.form[0].items[i].tabs) {
        $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
          $scope.itemTypeMap[item.key[0]] = $scope.selected.model.schema.properties[item.key[0]].type;
          if ($scope.selected.model.schema.properties[item.key[0]].type == 'array') {
            $scope.itemTypeMap[item.key[0]] = $scope.selected.model.schema.properties[item.key[0]].items.type;
          }
          if (item.type == 'uiselect' || item.type == 'uiselectmultiple') {
            var blankObject = {
              name: '',
              value: ''
            };
            $scope.uiselectMap[item.key[0]] = addSelectedValue(item.titleMap, blankObject); /* aggiunto un elemento vuoto all'array per consentire il deselezionamento */
          }
        });
      }
    }
  };

  $scope.toggleEnumDefault = function (key, objValue) {
    var property = $scope.selected.model.schema.properties[key];
    if (typeof property["default"] == "undefined" || property["default"].indexOf(objValue) == -1) {
      property["default"] = [objValue];
    } else {
      property["default"] = undefined;
    }
    this.newItem = null;
    $scope.updateScope();
  };
  function addSelectedValue(array, obj) {
    var blankValuePresent = false;
    array.forEach(function (item) {
      if (item.value == obj.value && item.name == obj.name) {
        blankValuePresent = true;
      }
    });
    if (blankValuePresent == false) {
      array.push(obj);
    }
    return array;
  }
  $scope.isInheritable = function (type) {
    return type == 'number' || type == 'integer' || type == 'string' || type == 'boolean' || type == 'lookup';
  };

  /**********************/
  /***** FIX SCHEMA *****/
  /**********************/

  $scope.fixSchemaFormModel = function () {
    for (var i in $scope.selected.model.form[0].items) {
      if ($scope.selected.model.form[0].items[i].tabs) {
        $scope.selected.model.form[0].items[i].tabs[0].items.forEach(function (item) {
          if (item.type == 'uiselect') {
            $scope.selected.model.schema.properties[item.key[0]].format = 'enum';
          }
          if (item.type == 'uiselectmultiple') {
            $scope.selected.model.schema.properties[item.key[0]].type = 'array';
          }
        });
      }
    }
  };

  /****************/
  /***** FORM *****/
  /****************/

  $scope.newFieldForm = {};
  $scope.newTab = {
    title: "",
    items: []
  };
  $scope.addTab = function (container) {
    if (!container.tabs) {
      container.tabs = [];
    }
    if (container.type !== 'tabs') {
      container.type = 'tabs';
    }
    var toAdd = angular.copy($scope.newTab);
    $log.log(container);
    container.tabs.push(toAdd);
    $log.log(container);
    $scope.updateScope();
    $scope.newTab = {
      title: "",
      items: []
    };
  };
  $scope.addFieldToTab = function (tab) {
    if (!tab.items) {
      tab.items = [];
    }
    var toAdd = angular.copy($scope.newFieldForm);
    if ($scope.newFieldForm.type === '' || $scope.newFieldForm.type === 'formula' || $scope.newFieldForm.type === 'inherited') {
      delete toAdd.type;
    }
    /* key è da cambiare in un array */
    toAdd.key = [];
    toAdd.key.push($scope.newFieldForm.key);
    /* se è una lookup, e se ha definito il campo entity_id nello schema, ci attacco anche l'entity_id */
    if (toAdd.type == 'sixlookup' && $scope.schema.properties[$scope.newFieldForm.key]['entity_id']) {
      toAdd['entity_id'] = $scope.schema.properties[$scope.newFieldForm.key]['entity_id'];
    }
    tab.items.push(toAdd);
    $log.log(tab);
    $scope.updateScope();
    $scope.newFieldForm = {
      key: [],
      title: "",
      required: false,
      type: "text"
    };
  };
  $scope.removeTabOrField = function (key, container) {
    container.splice(key, 1);
    $log.log(container);
    $scope.updateScope();
  };
  $scope.swapUp = function (key, collection) {
    if (key > 0) {
      var tmp = collection[key];
      collection[key] = collection[key - 1];
      collection[key - 1] = tmp;
    }
    $scope.updateScope();
  };
  $scope.swapDown = function (key, collection) {
    if (key < collection.length - 1) {
      var tmp = collection[key];
      collection[key] = collection[key + 1];
      collection[key + 1] = tmp;
    }
    $scope.updateScope();
  };
  $scope.updateField = function (field) {
    if (field.type === '') {
      delete field.type;
    }
    $scope.updateScope();
  };
  $scope.$watchGroup(['commissionDependent', 'history'], function () {
    if ($scope.commissionDependent === true) {
      $scope.history = true;
    }
    if ($scope.selected) {
      if ($scope.selected.model) {
        $scope.selected.model.history = $scope.history;
        $scope.selected.model.commissionDependent = $scope.commissionDependent;
        $scope.updateScope();
      }
    }
  });
  $scope.pageChanged = function () {
    $location.path('/odlconfigurator/page/' + $scope.odlConfiguratorList.currentPage, false);
    $scope.odlConfiguratorList = odlFactory().getOdlSchemaList({
      query: $scope.queryParam,
      page: $scope.odlConfiguratorList.currentPage
    });
  };
  $scope.printCommission = function (commission_array) {
    var result = '';
    var pos = 0;
    if (commission_array != null) {
      angular.forEach(commission_array, function (value) {
        if (pos == 0) {
          result = value;
        } else {
          result = value + ', ' + result;
        }
        pos++;
      });
    }
    return result;
  };
  $scope.updateCode = function () {
    if ($scope.bool.isCross == true) {
      $scope.commissionCode = 'default';
      $scope.commissionsSelected.codes = [];
    } else {
      $scope.commissionCode = '';
    }
  };
  $scope.setConfModel = function () {
    $scope.bool.confModel = true;
    $scope.bool.isCross = false;
    delete $scope.selected.version;
    $scope.commissionsSelected.codes = [];
    $scope.commissionCode = '';
  };
  $scope.newOdl = function () {
    $location.path(PATH_ODL_CONFIG + '/new');
  };
  $scope.refresh = function () {
    console.log('refresh');
    $location.path(PATH_ODL_CONFIG);
  };
  $scope.back = function () {
    $location.path(PATH_ODL_CONFIG);
  };
  $scope["delete"] = function () {
    dialogService.confirmDialog('Eliminare la configurazione?', function () {
      odlFactory().deleteOdlSchema({
        id: $scope.selected.version
      }).$promise.then(function () {
        $scope.back();
      });
    });
  };
  $scope.setCommissionSelected = function () {
    angular.forEach($scope.selected.model.commission, function (value_cm_string) {
      var index = null;
      angular.forEach($scope.commissions, function (value_cm_obj) {
        if (value_cm_string == value_cm_obj.code) {
          index = $scope.commissions.indexOf(value_cm_obj);
          $scope.commissionsSelected.codes.push(value_cm_obj);
          $scope.commissions.splice(index, 1);
        }
      });
    });
  };
  $scope.setBooleanFlag = function () {
    if ($scope.selected.model) {
      if ($scope.selected.model.code == 'default') {
        $scope.bool.isCross = true;
      }
    }
  };
  $scope.getOdlConfigurationById = function (UUID) {
    odlFactory().getOdlSchemaByUUID({
      id: UUID
    }).$promise.then(function (response) {
      if (response.model) {
        $scope.selected = angular.copy(response);
        $scope.commissionCode = $scope.selected.model.code;
        $scope.setCommissionSelected();
        $scope.setBooleanFlag();
        $scope.updateScope();
      }
    });
  };
  $scope.getOdlConfigurationList = function () {
    odlFactory().getOdlSchemaList({
      query: $scope.queryParam,
      pageSize: $scope.pageSize
    }).$promise.then(function (response) {
      $scope.odlConfiguratorList = response;
    });
  };
  $scope.getCommission = function () {
    commissionFactory().getCommissionsList().$promise.then(function (response) {
      if (response.list) {
        $scope.commissions = response.list;
      }
    });
  };
  $scope.create = function () {
    odlFactory().createOdlSchema($scope.aceModel).$promise.then(function () {
      toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
      $scope.back();
    })["catch"](function (response) {
      toaster.pop('error', 'Errore salvataggio', 'Si è verificato un errore durante il salvataggio');
    });
  };
  $scope.update = function () {
    odlFactory().updateOdlSchema({
      id: $scope.selected.version
    }, $scope.aceModel).$promise.then(function () {
      toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
      $scope.back();
    })["catch"](function (rejection) {
      toaster.pop('error', 'Errore salvataggio', rejection.data.message ? rejection.data.message : rejection.statusText);
    });
  };
  $scope.saveForm = function () {
    $scope.chargeAceModel();
    $scope.selected.model.code = $scope.commissionCode;
    if ($scope.bool.isCross) {
      /* se è cross non serve riempire il vettore delle commesse */
      $scope.selected.model.commission = null;
      $scope.selected.model.commissionDependent = false;
      $scope.formChanged(); /* aggiorno l'aceModel */
      if ($scope.selected.version) {
        $scope.update();
      } else {
        $scope.create();
      }
    } else {
      /* riempio il vettore delle commesse */
      $scope.selected.model.commission = [];
      angular.forEach($scope.commissionsSelected.codes, function (obj) {
        $scope.selected.model.commission.push(obj.code);
      });
      $scope.formChanged(); /* aggiorno l'aceModel */
      if ($scope.bool.confModel) {
        /* create obbligatoria */
        $scope.create();
      } else {
        if ($scope.selected.version) {
          $scope.update();
        } else {
          $scope.create();
        }
      }
    }
  };
  if ($routeParams.id) {
    if ($routeParams.id !== 'new') {
      $scope.bool.isNew = false;
      commissionFactory().getCommissionsList().$promise.then(function (response) {
        if (response.list.length) {
          $scope.commissions = response.list;
        }
        $scope.getOdlConfigurationById($routeParams.id);
      });
    } else {
      $scope.bool.isNew = true;
      $scope.getCommission();
    }
  } else {
    $scope.getOdlConfigurationList();
  }

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'odl/schema';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:PlanCtrl
 * @description Controller for planned tasks
 * # PlanCtrl
 */
angular.module('emma.plan').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/plan/detail', {
    templateUrl: 'plan/plan/plan_detail.html',
    controller: 'PlanCtrl'
  }).when('/plan/detail/:id', {
    templateUrl: 'plan/plan/plan_detail.html',
    controller: 'PlanCtrl'
  }).when('/plan/detail/:id/:generationcode', {
    templateUrl: 'plan/plan/plan_detail.html',
    controller: 'PlanCtrl'
  });
}]).controller('PlanCtrl', ["$scope", "$log", "$location", "dialogService", "$routeParams", "toaster", "$window", "$rootScope", "loadingBarService", "authFactory", "planFactory", "taskFactory", "cronExpressionFactory", "planOdlFactory", "recordFactory", "schemaFactory", "treeUtilities", "ngDialog", "invoiceWSFactory", "$q", "notificationService", "localStorageService", function ($scope, $log, $location, dialogService, $routeParams, toaster, $window, $rootScope, loadingBarService, authFactory, planFactory, taskFactory, cronExpressionFactory, planOdlFactory, recordFactory, schemaFactory, treeUtilities, ngDialog, invoiceWSFactory, $q, notificationService, localStorageService) {
  // var ungroupedTargetsList = [];
  var PREFIX = 'def';
  var loadCount = 0;
  var overlay = angular.element(document.getElementsByClassName('list-sidebar-overlay')[0]);
  var centerPage = angular.element(document.getElementsByClassName('center-page')[0]);
  var originalPlan;
  $scope.taskObj = {};
  // Gestione allegati
  function clearAttachments() {
    $scope.attachments = [];
    $scope.hasAttachments = false;
  }
  clearAttachments();
  function readAttachments(modelList) {
    $scope.attachments.splice(0, $scope.attachments.length);
    $scope.hasAttachments = modelList && (modelList.length > 1 || modelList[0].nodes.length > 0);
    if ($scope.hasAttachments) {
      for (var i = 0; i < modelList.length; i++) {
        $scope.attachments.push(modelList[i]);
      }
    }
  }
  function writeAttachments(modelList) {
    modelList.splice(0, modelList.length);
    for (var i = 0; i < $scope.attachments.length; i++) {
      modelList.push($scope.attachments[i]);
    }
  }
  $scope.EVERY = {
    WEEK: 'week_1',
    MONTH: 'month_1',
    MONTHx2: 'month_2',
    MONTHx3: 'month_3',
    MONTHx4: 'month_4',
    MONTHx6: 'month_6',
    YEAR: 'year_1',
    YEARx2: 'year_2',
    YEARx3: 'year_3',
    YEARx4: 'year_4',
    YEARx5: 'year_5',
    YEARx6: 'year_6'
  };
  $scope.REPETITION = {
    WEEKLY: 'week',
    MONTHLY: 'month',
    ANNUAL: 'year'
  };
  $scope.DAY_OF_MONTH = {
    FIRST: "1",
    MIDDLE: "15"
  };
  $scope.STEP = {
    DESCRIPTION: 1,
    SIMULATION: 2,
    GENERATION: 3
  };
  $scope.DAY_OF_WEEK = {
    MON: 'MON',
    TUE: 'TUE',
    WEN: 'WED',
    THU: 'THU',
    FRI: 'FRI',
    SAT: 'SAT',
    SUN: 'SUN'
  };
  $scope.MONTH_OF_YEAR = {
    JAN: '1',
    FEB: '2',
    MAR: '3',
    APR: '4',
    MAY: '5',
    JUNE: '6',
    JULY: '7',
    AUG: '8',
    SEPT: '9',
    OCT: '10',
    NOV: '11',
    DEC: '12'
  };
  $scope.simulationParams = {
    date_from: new Date(),
    date_to: new Date(),
    expression: ""
  };
  $scope.simulationParams.date_to.setMonth($scope.simulationParams.date_from.getMonth() + 6);
  $scope.step = $scope.STEP.DESCRIPTION;
  $scope.popupTo = {
    opened: false
  };
  $scope.popupFrom = {
    opened: false
  };
  $scope.planAssetsId = [];
  $scope.planAssets = []; // Panel
  $scope.availableAssets = []; // Sidebar
  $scope.filteredAssets = [];
  $scope.addCheckModel = [];
  $scope.remCheckModel = [];
  $scope.generatedOdl = [];
  $scope.assetFilter = "";
  $scope.description = "";
  $scope.commissionCode = authFactory.getAuthData().info.commissions.current.code;
  $scope.planOptions = {};
  $scope.planOptions.generateOverParent = false;
  $scope.planOptions.specifyAssets = false;
  $scope.planOptions.modelChanged = false;
  $scope.disablePlanOptions = true;
  $scope.frequencyDetail = false;
  $scope.isFreqTipeChanged = false;
  $scope.isSidebarOpened = false;
  $scope.simulationOk = false;
  $scope.isRangeChanged = false;
  $scope.searchFilterObj = {};
  $scope.searchFilterArray = [];
  $scope.ganttOptions = {
    toDate: new Date(),
    fromDate: new Date(),
    viewScale: "week",
    freqLabel: "Mensile"
  };
  $scope.ganttData = [{
    name: 'Risultato della simulazione',
    tasks: []
  }];
  $scope.tooltipContent = '{{getFromLabel()}}';
  $scope.dateOptions = {
    formatYear: 'yyyy',
    minDate: new Date()
  };
  $scope.bool = {
    activitiesModified: false
  };
  $scope.plan = {
    model: {
      frequency: {
        type: $scope.EVERY.MONTH,
        dayOfMonth: $scope.DAY_OF_MONTH.FIRST,
        dayOfWeek: $scope.DAY_OF_WEEK.MON,
        monthOfYear: $scope.MONTH_OF_YEAR.JAN
      },
      custom_activities: [],
      search_filter: {
        json_object: "{}",
        json_array: "[]",
        description: ""
      }
    }
  };
  $scope.typeIdFilter = null;
  treeUtilities.getFlatStructureUuids().then(function (types) {
    if (types) {
      $scope.typeIdFilter = {
        'typeIdFilter': sixFiltersLib["in"]('UUID', types)
      };
    }
  });
  $scope.openToPicker = function () {
    $scope.popupTo.opened = true;
  };
  $scope.openFromPicker = function () {
    $scope.popupFrom.opened = true;
  };
  $scope.isWeekly = function () {
    var result = false;
    if (angular.isDefined($scope.plan.model.frequency.type)) {
      var type = $scope.plan.model.frequency.type;
      result = type.indexOf($scope.REPETITION.WEEKLY) != -1;
    }
    return result;
  };
  $scope.isMonthly = function () {
    var result = false;
    if (angular.isDefined($scope.plan.model.frequency.type)) {
      var type = $scope.plan.model.frequency.type;
      result = type.indexOf($scope.REPETITION.MONTHLY) != -1;
    }
    return result;
  };
  $scope.isAnnual = function () {
    var result = false;
    if (angular.isDefined($scope.plan.model.frequency.type)) {
      var type = $scope.plan.model.frequency.type;
      result = type.indexOf($scope.REPETITION.ANNUAL) != -1;
    }
    return result;
  };
  $scope.toggleFrequencyDetail = function () {
    $scope.frequencyDetail = !$scope.frequencyDetail;
  };
  $scope.closeFrequencyDetail = function () {
    $scope.frequencyDetail = false;
  };
  function initAddCheckModel(length) {
    $scope.addCheckModel = [];
    for (var i = 0; i < length; i++) {
      $scope.addCheckModel.push(false);
    }
  }
  function initRemCheckModel(length) {
    $scope.remCheckModel = [];
    for (var i = 0; i < length; i++) {
      $scope.remCheckModel.push(false);
    }
  }
  function fullLoaded() {
    var result = true;
    if ($scope.plan.version) {
      if (loadCount < $scope.loadCountRef) {
        loadCount++;
        result = false;
      }
    }
    return result;
  }
  $scope.closeSidebar = function () {
    var sidebar = angular.element(document.getElementById('list-sidebar'));
    sidebar.removeClass('open');
    centerPage.removeClass('center-open');
    $scope.isSidebarOpened = false;
    if ((sidebar.hasClass('list-sidebar-fixed-left') || sidebar.hasClass('list-sidebar-fixed-right')) && sidebar.hasClass('open')) {
      overlay.addClass('active');
    } else {
      overlay.removeClass('active');
    }
  };
  $scope.openSidebar = function () {
    var sidebar = angular.element(document.getElementById('list-sidebar'));
    initAddCheckModel();
    sidebar.addClass('open');
    centerPage.addClass('center-open');
    $scope.isSidebarOpened = true;
    if ((sidebar.hasClass('list-sidebar-fixed-left') || sidebar.hasClass('list-sidebar-fixed-right')) && sidebar.hasClass('open')) {
      overlay.addClass('active');
    } else {
      overlay.removeClass('active');
    }
  };
  $scope.selectAsset = function () {
    $scope.openSidebar();
    if ($scope.availableAssets.length == 0 || $scope.planOptions.modelChanged) {
      $scope.planOptions.modelChanged = false;
      $scope.loadAssets();
    }
    invalidatePlanAssets();
  };
  $scope.confirmSelectAssets = function () {
    $scope.closeSidebar();
    for (var i = 0; i < $scope.addCheckModel.length; i++) {
      if ($scope.addCheckModel[i]) {
        var r = $scope.filteredAssets[i];
        if ($scope.planAssets.indexOf(r) == -1) {
          $scope.planAssets.push(r);
        }
      }
    }
    initRemCheckModel($scope.planAssets.length);
  };
  $scope.loadAssets = function () {
    var entity;
    var filter;
    if ($scope.planOptions.generateOverParent) {
      if (angular.isDefined($scope.plan.model.target_model_type)) {
        entity = $scope.plan.model.target_model_type.code;
        filter = {};
      } else {
        entity = $scope.plan.model.model_type.code;
        filter = $scope.searchFilterObj;
      }
    } else {
      entity = $scope.plan.model.model_type.code;
      filter = $scope.searchFilterObj;
    }
    recordFactory(entity).filter({
      page_size: 10000
    }, filter).$promise.then(function (data) {
      $scope.availableAssets = data.list;
      initAddCheckModel($scope.availableAssets.length);
    });
  };
  function invalidatePlanAssets() {
    var plan;
    $scope.planAssetsId = [];
    for (var i = 0; i < $scope.planAssets.length; i++) {
      plan = $scope.planAssets[i];
      $scope.planAssetsId.push(plan.UUID);
    }
  }
  $scope.isDisabledAsset = function (UUID) {
    var result;
    if ($scope.planAssetsId.indexOf(UUID) == -1) {
      result = false;
    } else {
      result = true;
    }
    return result;
  };
  $scope.removeAsset = function () {
    var count = $scope.remCheckModel.length;
    var removed = 0;
    for (var i = 0; i < $scope.remCheckModel.length; i++) {
      if ($scope.remCheckModel[i]) {
        $scope.planAssets.splice(i - removed, 1);
        removed++;
      }
    }
    count -= removed;
    initRemCheckModel(count);
  };
  $scope.clearSiderbar = function () {
    $scope.closeSidebar();
    $scope.planOptions.modelChanged = true;
  };
  $scope.$watch('plan.model.model_type', function (newValue, oldValue) {
    if (newValue != oldValue && fullLoaded()) {
      $scope.closeSidebar();
      $scope.planOptions.modelChanged = true;
      var disable = true;
      if ($scope.loadingFilter) {
        $scope.loadingFilter = false;
      } else {
        $scope.emptyFilter();
      }
      if (angular.isDefined(newValue)) {
        disable = false;
        $scope.updateSearchTerms();
      }
      if (angular.isDefined($scope.plan.model.target_model_type) || $scope.planAssets.length > 0) {
        if ($scope.prompt) {
          dialogService.confirmDialog('Modificando la selezione verranno invalidati i dati sottostanti. Continuare?', function () {
            $scope.plan.model.target_model_type = undefined;
            $scope.planAssets = [];
            $scope.planOptions.generateOverParent = false;
            $scope.planOptions.specifyAssets = false;
          }, function () {
            $scope.plan.model.model_type = oldValue;
            $scope.prompt = false;
          });
        } else {
          $scope.prompt = true;
        }
      } else {
        if (disable) {
          $scope.planOptions.generateOverParent = false;
          $scope.planOptions.specifyAssets = false;
          $scope.closeSidebar();
          $scope.availableAssets = [];
        }
      }
      $scope.disablePlanOptions = disable;
    }
  });
  $scope.$watch('plan.model.target_model_type', function (newValue, oldValue) {
    if (newValue != oldValue && fullLoaded()) {
      $scope.closeSidebar();
      $scope.planOptions.modelChanged = true;
      if (newValue.UUID == $scope.plan.model.model_type.UUID) {
        dialogService.alert('Asset di generazione e aggregazione non possono essere uguali', 4000);
        setTimeout(function () {
          $scope.plan.model.target_model_type = oldValue;
        }, 50);
      }
      if ($scope.planAssets.length > 0) {
        if ($scope.prompt) {
          dialogService.confirmDialog('Modificando la selezione verranno invalidati i dati sottostanti. Continuare?', function () {
            $scope.planAssets = [];
            $scope.planOptions.specifyAssets = false;
          }, function () {
            $scope.plan.model.target_model_type = oldValue;
            $scope.prompt = false;
          });
        } else {
          $scope.prompt = true;
        }
      }
    }
  });
  $scope.checkFreqTypeChanged = function () {
    if ($scope.isFreqTipeChanged) {
      $scope.isFreqTipeChanged = false;
      // necessario passare attraverso la creazione di una nuova data, altrimenti il modello
      // non si aggiona.
      // ref: https://github.com/angular/angular.js/issues/13001
      // It is because the code doesn't change the date but the content of the date, therefore the input doesn't "see" that the object is changed. You must assign a new date to the model when you change it from the code and everything will run fine.
      var newDate = new Date();
      newDate.setDate($scope.simulationParams.date_from.getDate());
      newDate.setMonth($scope.simulationParams.date_from.getMonth());
      newDate.setFullYear($scope.simulationParams.date_from.getFullYear());
      var N = 12;
      if ($scope.isWeekly()) {
        newDate.setDate($scope.simulationParams.date_from.getDate() + N * 7);
      } else if ($scope.isMonthly()) {
        newDate.setMonth($scope.simulationParams.date_from.getMonth() + N);
      } else {
        newDate.setFullYear($scope.simulationParams.date_from.getFullYear() + N);
      }
      $scope.simulationParams.date_to = newDate;
    }
  };
  $scope.$watch('planOptions.generateOverParent', function (newValue, oldValue) {
    if (newValue == false && newValue != oldValue && angular.isDefined($scope.plan.model.target_model_type) && $scope.planAssets.length > 0) {
      dialogService.confirmDialog('Modificando la selezione verranno invalidati i dati sottostanti. Continuare?', function () {
        $scope.planAssets = [];
        $scope.planOptions.specifyAssets = false;
        $scope.planOptions.modelChanged = true;
      }, function () {
        $scope.planOptions.generateOverParent = oldValue;
        $scope.prompt = false;
      });
    }
  });
  $scope.$watch('plan.model.frequency.type', function (newValue, oldValue) {
    if (angular.isDefined(newValue)) {
      $scope.isFreqTipeChanged = true;
    }
  });
  $scope.$watch('taskObj.obj', function (newValue, oldValue) {
    if (newValue != oldValue) {
      if (angular.isDefined($scope.taskObj.obj) && $scope.taskObj.obj.model) {
        readAttachments($scope.taskObj.obj.model.attachments);
      } else {
        clearAttachments();
      }
      $scope.plan.model.task_activities = [];
      if (angular.isDefined(newValue)) {
        // Compilo la lista delle attività.
        if (angular.isDefined($scope.taskObj.obj.model) && $scope.taskObj.obj.model.activities) {
          for (var i = 0; i < $scope.taskObj.obj.model.activities.length; i++) {
            $scope.plan.model.task_activities.push($scope.taskObj.obj.model.activities[i]);
          }
        }
      }
    }
  });
  $scope.$watch('taskObj.obj.model.activities', function (activities) {
    if ($scope.plan.model.task_activities != undefined && activities != undefined && $scope.plan.model.task_activities.length != activities.length) {
      //se la lunghezza è diversa, assumo che sia avvenuta una modifica alla lista
      $scope.bool.activitiesModified = true;
    }
    $scope.plan.model.task_activities = activities;
  });
  $scope.activitiesModified = function () {
    $scope.bool.activitiesModified = true;
  };
  $scope.showSimulationWarning = function () {
    var warning = false;
    if (angular.isDefined($scope.simulationEvents)) {
      warning = $scope.ganttOptions.fromDate != $scope.simulationParams.date_from || $scope.ganttOptions.toDate != $scope.simulationParams.date_to;
    }
    return warning;
  };
  function validateForm() {
    var isValid = true;
    if (angular.isUndefined($scope.plan.model.code)) {
      toaster.pop('error', 'Errore', 'Codice obbligatorio');
      isValid = false;
    } else if (angular.isUndefined($scope.plan.model.description)) {
      toaster.pop('error', 'Errore', 'Descrizione obbligatoria');
      isValid = false;
    } else if (angular.isUndefined($scope.plan.model.task_id)) {
      toaster.pop('error', 'Errore', 'Selezionare un compito');
      isValid = false;
    } else if (angular.isUndefined($scope.plan.model.model_type)) {
      toaster.pop('error', 'Errore', 'Selezionare il tipo di asset su cui generare la programmata');
      isValid = false;
    } else if (angular.isUndefined($scope.plan.model.service_id)) {
      toaster.pop('error', 'Errore', 'Selezionare un servizio');
      isValid = false;
    } else if (angular.isUndefined($scope.plan.model.priority_id)) {
      toaster.pop('error', 'Errore', 'Selezionare una priorità');
      isValid = false;
    }
    return isValid;
  }
  function validateSimulation(askForGeneration) {
    var isValid = true;
    if (angular.isUndefined($scope.simulationParams.date_from) || $scope.simulationParams.date_from == null) {
      toaster.pop('error', 'Errore', 'Selezionare una data iniziale su cui generare la programmata');
      isValid = false;
    } else if (angular.isUndefined($scope.simulationParams.date_to) || $scope.simulationParams.date_to == null) {
      toaster.pop('error', 'Errore', 'Selezionare una data finale su cui generare la programmata');
      isValid = false;
    } else if ($scope.simulationParams.date_to < $scope.simulationParams.date_from) {
      toaster.pop('error', 'Errore', 'La data finale non può essere antecedente alla data di partenza');
      isValid = false;
    }
    if (askForGeneration) {
      if ($scope.simulationEvents.list.length == 0) {
        toaster.pop('error', 'Errore', 'Nessun evento corrisponde ai criteri di ricerca');
        isValid = false;
      } else if ($scope.simulationTargets.list.length == 0) {
        toaster.pop('error', 'Errore', 'Nessun asset corrisponde ai criteri di ricerca');
        isValid = false;
      }
    }
    return isValid;
  }
  $scope.stepBack = function () {
    switch ($scope.step) {
      case $scope.STEP.DESCRIPTION:
        $location.path('/plan');
        break;
      case $scope.STEP.SIMULATION:
        $scope.step = $scope.STEP.DESCRIPTION;
        break;
      case $scope.STEP.GENERATION:
        $scope.step = $scope.STEP.SIMULATION;
        break;
    }
  };
  $scope.goToSimulation = function () {
    if (validateForm()) {
      $scope.simulationOk = false;
      $scope.simulationEvents = undefined;
      $scope.simulationTargets = undefined;
      $scope.checkFreqTypeChanged();
      $scope.step = $scope.STEP.SIMULATION;
      $scope.closeSidebar();
    }
  };
  $scope.goToGeneration = function () {
    if (validateSimulation(true)) {
      if (originalPlan) if (!angular.equals(originalPlan, $scope.plan)) $scope.saveForm(false);
      $scope.generateOdlList();
    }
  };
  $scope.goToPlanOdlList = function () {
    $location.path('/plan/odl/' + $scope.plan.UUID);
  };

  // Eseguo una serie di operazioni preliminari al salvataggio.
  $scope.saveForm = function (showSuccessMessage) {
    showSuccessMessage = angular.isDefined(showSuccessMessage) ? showSuccessMessage : true;
    if (validateForm()) {
      // Tolgo gli spazi dal code
      $scope.plan.model.code = $scope.plan.model.code.replace(/ /g, '_');
      // Recupero la cronExpression aggiornata
      var payload = {
        frequency: $scope.plan.model.frequency.type,
        day_of_month: $scope.plan.model.frequency.dayOfMonth,
        day_of_week: $scope.plan.model.frequency.dayOfWeek,
        month_of_year: $scope.plan.model.frequency.monthOfYear
      };
      cronExpressionFactory.getCronExpression(payload).$promise.then(function (data) {
        $scope.plan.model.frequency.cronExpression = data.result;
        // Voglio generare su un padre?
        if (!$scope.planOptions.generateOverParent) {
          $scope.plan.model.target_model_type = undefined;
        }
        // Compilo la lista degli specifici asset
        $scope.plan.model.assets = [];
        if ($scope.planOptions.specifyAssets) {
          for (var i = 0; i < $scope.planAssets.length; i++) {
            var asset = $scope.planAssets[i];
            $scope.plan.model.assets.push(asset);
          }
        }
        // Scrivo gli allegati.
        $scope.plan.model.attachments = [];
        writeAttachments($scope.plan.model.attachments);
        // Converto il filtro in stringa, altrimenti elasticsearch si arrabbia per via dei "."
        $scope.plan.model.search_filter.json_object = JSON.stringify($scope.searchFilterObj);
        $scope.plan.model.search_filter.json_array = JSON.stringify($scope.searchFilterArray);
        // Salvo o aggiorno.
        if ($scope.bool.activitiesModified) {
          dialogService.confirmDialog('ATTENZIONE!\nEventuali modifiche alle attività del compito, saranno salvate permanentemente!\nContinuare con il salvataggio?', function () {
            if ($scope.plan.version) {
              $scope.updatePlan(showSuccessMessage);
            } else {
              $scope.savePlan(showSuccessMessage);
            }
            $scope.updateTask();
            $scope.bool.activitiesModified = false;
          });
        } else {
          if ($scope.plan.version) {
            $scope.updatePlan(showSuccessMessage);
          } else {
            $scope.savePlan(showSuccessMessage);
          }
          $scope.updateTask(); //senza modifiche alle attività questa riga dovrebbe essere inutile, ma la lascio per scaramanzia
        }
      });
    }
  };

  function printOnGantt(date, isNew) {
    var task = {
      name: '',
      from: date,
      to: date
    };
    if (isNew) {
      task.color = $scope.app.color.info;
      $scope.ganttData[0].tasks.push(task);
    } else {
      task.color = $scope.app.color.warning;
      $scope.ganttData[1].tasks.push(task);
    }
  }
  $scope.simulate = function () {
    if (validateSimulation(false)) {
      // Before simulate, retrieve the cronExpression
      var payload = {
        frequency: $scope.plan.model.frequency.type,
        day_of_month: $scope.plan.model.frequency.dayOfMonth,
        day_of_week: $scope.plan.model.frequency.dayOfWeek,
        month_of_year: $scope.plan.model.frequency.monthOfYear
      };
      cronExpressionFactory.getCronExpression(payload).$promise.then(function (data) {
        $scope.simulationParams.expression = data.result;
        $log.info($scope.simulationParams.expression);
        $scope.isRangeChanged = false;
        // Ready for simulation
        $scope.getSimulationEvents();
        $scope.getSimulationTargets();
      });
    }
  };
  $scope.getSimulationEvents = function () {
    // preparo il gantt
    $scope.ganttData[0].tasks = [];
    if ($scope.isWeekly()) {
      $scope.ganttOptions.viewScale = "day";
    } else if ($scope.isMonthly()) {
      $scope.ganttOptions.viewScale = "week";
    } else {
      $scope.ganttOptions.viewScale = "month";
    }
    var freqSelect = angular.element(document.getElementById('frequencySelect'));
    $scope.ganttOptions.freqLabel = freqSelect.find('option:selected').text();
    $scope.ganttOptions.fromDate = $scope.simulationParams.date_from;
    $scope.ganttOptions.toDate = $scope.simulationParams.date_to;

    // eseguo e stampo la simulazione
    $scope.simulationParams.date_from.setHours(0, 0, 0, 0);
    $scope.simulationParams.date_to.setHours(23, 59, 59, 999);
    $scope.simulationParams.plan_uuid = $scope.plan.UUID;
    var payload = JSON.parse(JSON.stringify($scope.simulationParams));
    payload.date_from = new Date($scope.simulationParams.date_from.getTime());
    payload.date_from.setDate($scope.simulationParams.date_from.getDate() - 1);
    cronExpressionFactory.getSimulationEvents(payload).$promise.then(function (data) {
      $scope.simulationEvents = data;
      if (angular.isDefined(data.list)) {
        $scope.simulationOk = true;
        for (var i = 0; i < data.list.length; i++) {
          printOnGantt(data.list[i], true);
        }
      }
    });
    getOldEvents();
  };
  function getOldEvents() {
    planOdlFactory().getOldEvents($scope.simulationParams).$promise.then(function (data) {
      if (data.list.length > 0) {
        if ($scope.ganttData.length < 2) {
          var newRow = {
            name: 'Vecchi ODL',
            tasks: []
          };
          $scope.ganttData.push(newRow);
        }
        for (var i = 0; i < data.list.length; i++) {
          printOnGantt(data.list[i], false);
        }
      }
    });
  }
  $scope.selectAllAddCheck = function (array) {
    for (var i = 0; i < $scope.addCheckModel.length; i++) {
      $scope.addCheckModel[i] = true;
    }
  };
  $scope.unselectAllAddCheck = function (array) {
    for (var i = 0; i < $scope.addCheckModel.length; i++) {
      $scope.addCheckModel[i] = false;
    }
  };
  $scope.selectAllRemCheck = function (array) {
    for (var i = 0; i < $scope.remCheckModel.length; i++) {
      $scope.remCheckModel[i] = true;
    }
  };
  $scope.unselectAllRemCheck = function (array) {
    for (var i = 0; i < $scope.remCheckModel.length; i++) {
      $scope.remCheckModel[i] = false;
    }
  };
  $scope.initGenerationTag = function () {
    var now = new Date();
    var yyyy = now.getFullYear();
    var MM = now.getMonth() + 1; // getMonth() is zero-based
    var dd = now.getDate();
    var hh = now.getUTCHours();
    var mm = now.getUTCMinutes();
    var dateString = dd + "/" + MM + "/" + yyyy;
    var timeString = hh + ":" + mm;
    $scope.generationTag = authFactory.getAuthData().authId + " " + dateString + " " + timeString;
  };
  $scope.getSimulationTargets = function () {
    var payload = {
      model_type: $scope.plan.model.model_type.code
    };
    if ($scope.planOptions.generateOverParent && angular.isDefined($scope.plan.model.target_model_type)) {
      payload.target_model_type = $scope.plan.model.target_model_type.code;
    }
    if ($scope.planOptions.specifyAssets && $scope.planAssets.length > 0) {
      payload.assets = $scope.planAssets;
    }
    if ($scope.searchFilterArray.length > 0) {
      payload.filter = $scope.searchFilterObj;
    }
    loadingBarService.start('Simulazione ODL ...');
    planFactory().getSimulationTargets(payload).$promise.then(function (data) {
      $scope.simulationTargets = data;
      // rimuovo i doppioni
      if (data.count_grouped > 0 && data.count != data.count_grouped) {
        var array = [];
        var prevId = "";
        for (var i = 0; i < data.list.length; i++) {
          if (data.list[i].parent_id.UUID == prevId) {
            array.push(i);
          }
          prevId = data.list[i].parent_id.UUID;
        }
        var offset = 0;
        for (var i = 0; i < array.length; i++) {
          var index = array[i];
          data.list.splice(index - offset, 1);
          offset++;
        }
      }
      loadingBarService.stop();
    });
  };
  $scope["delete"] = function (version) {
    planFactory().referenceCount({
      id: $scope.plan.UUID
    }).$promise.then(function (response) {
      var deleteMessage = 'Eliminare la programmata "' + $scope.plan.model.code + ' - ' + $scope.plan.model.description + '"?';
      if (response.count != 0) {
        var deleteMessage = 'La programmata: "' + $scope.plan.model.code + ' - ' + $scope.plan.model.description + '"' + ' è in uso nel sistema.<br> Vuoi rimuoverla comunque?';
      }
      dialogService.confirmDialog(deleteMessage, function () {
        planFactory().deletePlan({
          id: version
        }).$promise.then(function () {
          $location.path('/plan');
        });
      });
    });
  };
  $scope.updateTask = function () {
    var payload = {
      id: $scope.taskObj.obj.version
    };
    taskFactory.updateTask(payload, $scope.taskObj.obj).$promise.then(function (data) {
      if (data.version) {
        $scope.taskObj.obj.version = data.version;
      }
    });
  };
  $scope.getPlanById = function (id) {
    $scope.emptyFilter();
    return planFactory().getPlanByUUID({
      id: id
    }).$promise.then(function (data) {
      $scope.plan = data;
      originalPlan = angular.copy(data);
      $log.info(data);
      // Riconverto da stringa a oggetto.
      var tempObj = $.parseJSON($scope.plan.model.search_filter.json_object);
      for (var key in tempObj) {
        $scope.searchFilterObj[key] = tempObj[key];
      }
      var tempArray = $.parseJSON($scope.plan.model.search_filter.json_array);
      $scope.searchFilterArray.length = 0;
      for (var i = 0; i < tempArray.length; i++) {
        $scope.searchFilterArray.push(tempArray[i]);
      }
      $scope.loadingFilter = true;
      // Estrapolo i dati che mi servono per l'interfaccia.
      $scope.loadCountRef = angular.isDefined($scope.plan.model.target_model_type) ? 1 : 0;
      $scope.disablePlanOptions = angular.isUndefined(data.model.model_type);
      $scope.planOptions.generateOverParent = angular.isDefined(data.model.target_model_type);
      $scope.planOptions.specifyAssets = angular.isDefined(data.model.assets) && data.model.assets.length > 0;
      for (var i = 0; i < data.model.assets.length; i++) {
        var asset = data.model.assets[i];
        $scope.planAssets.push(asset);
      }
      initRemCheckModel($scope.planAssets.length);
    });
  };
  $scope.updatePlan = function (showSuccessMessage) {
    showSuccessMessage = angular.isDefined(showSuccessMessage) ? showSuccessMessage : true;
    planFactory().updatePlan({
      id: $scope.plan.version
    }, $scope.plan).$promise.then(function (data) {
      if (data.version) {
        $scope.plan.version = data.version;
        if (showSuccessMessage) {
          toaster.pop('success', 'Aggiornamento completato', 'Salvataggio eseguito correttamente');
        }
      }
    });
  };
  $scope.savePlan = function (showSuccessMessage) {
    showSuccessMessage = angular.isDefined(showSuccessMessage) ? showSuccessMessage : true;
    planFactory().savePlan($scope.plan.model).$promise.then(function (data) {
      if (showSuccessMessage) {
        toaster.pop('success', 'Salvataggio completato', 'Salvataggio eseguito correttamente');
      }
      $location.path('/plan/detail/' + data.UUID);
    });
  };
  $scope.generateOdlList = function () {
    registerWsHandler(invoiceWSFactory, toaster, notificationService, '/plan/detail/' + $routeParams.id);
    var toastInstance;
    notifyToDialog().then(function (notify) {
      toastInstance = toaster.pop({
        type: 'warning',
        title: 'Upload',
        body: 'Upload file in corso, non ricaricare la pagina.',
        timeout: 0
      });
      if ($scope.plan.model.attachments.length == 0) {
        var defaultAttachment = {
          "id": 0,
          "title": "Documenti",
          "folder": true,
          "readonly": true,
          "nodes": []
        };
        $scope.plan.model.attachments.push(defaultAttachment);
      }
      var payload = {
        simulation_id: $scope.simulationTargets.simulation_id,
        plan: $scope.plan,
        events: $scope.simulationEvents.list,
        generation_tag: $scope.generationTag
      };
      if (notify.async) var notifyTo = notify.to;
      return planFactory().generateOdl({
        notify_to: notifyTo
      }, payload).$promise;
    }, function () {
      toaster.clear(toastInstance);
      return $q.reject("Operazione annullata");
    }).then(function (response) {
      toaster.clear(toastInstance);
      if (response.status === 'errors') {
        toaster.pop('error', 'Errore', 'Errore durante il salvataggio');
      } else if (response.meta.type === 'async') {
        toaster.pop('success', 'Creazione avviata', 'Creazione avviata. Riceverai una notifica al termine.');
        invoiceWSFactory.subscribe('plan_odl/' + response.result);
      } else {
        toaster.pop('success', 'Importazione completata', 'L\'importazione è terminata correttamente.');
      }
    })["catch"](function (response) {
      toaster.clear(toastInstance);
      toaster.pop('error', 'Errore', 'Impossibile eseguire l\'importazione: ' + response);
    });
  };
  function notifyToDialog() {
    var notifyData = {
      async: true,
      to: null
    };
    var notifyToDialog = ngDialog.openConfirm({
      name: 'notifyToDialog',
      closeByDocument: false,
      showClose: true,
      data: notifyData,
      template: '' + '<div style="text-align:center"><i class="fa fa-list"></i>&nbsp; Notifica Import Eventi Calendario</div><br>' + '<div class="m-l-n-xxs" style="clear: both">' + '<input type="checkbox" id="async_elaboration" ng-model="ngDialogData.async" style="clear: both" /> <label for="async_elaboration" class="control-label"> Invia via mail</label><br />' + '</div>' + '<div class="row wrapper" style="text-align:center; clear: both" ng-show="ngDialogData.async">' + 'Invia una notifica di completamento al seguente indirizzo:<br>' + '<input class="form-control" type="email" ng-model="ngDialogData.to" placeholder="Indirizzo email"><br />' + '</div>' + '<div class="row" style="text-align:center; clear: both">' + '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ng-click="confirm(ngDialogData)">Continua</button>' + '</div>',
      plain: true,
      className: 'ngdialog-theme-default ngdialog-theme-custom'
    });
    var userFilter = {
      'model.username': sixFiltersLib.exact('model.username', authFactory.getAuthData().authId)
    };
    recordFactory('operatore').search(userFilter).$promise.then(function (resp) {
      if (resp.list) {
        notifyData.to = resp.list[0].model.mail;
      }
    });
    return notifyToDialog;
  }
  function registerWsHandler(invoiceWSFactory, toaster, notificationService, path) {
    invoiceWSFactory.addHandler(function (n) {
      var object = "Creazione odl completata";
      var icon = n.message_type == 'success' ? 'fa-check' : 'fa-exclamation';
      var level = n.message_type == 'success' ? 'info' : 'warning';
      var message = n.message || "";
      var notification = {
        icon: 'fa ' + icon,
        object: object,
        message: message,
        params: n.serviceResponse,
        level: level,
        time: new Date(),
        action: 'link',
        url: n.serviceResponse.hasErrors ? path + '/error' : path + '/' + n.serviceResponse.result.generation_code
      };
      notificationService.push(notification);
      if (n.message_type == 'success') {
        toaster.success(object + " - " + message);
      } else {
        toaster.error(object + " - " + message);
      }
    });
  }
  $scope.getGeneratedOdlList = function (generationCode) {
    $scope.generationDone = false;
    var payload = {
      page: 1,
      pageSize: 10000,
      sortFields: 'date_requested:asc'
    };
    planOdlFactory(generationCode).getGeneratedOdlList(payload).$promise.then(function (data) {
      $scope.generatedOdl = data.list || [];
      $scope.generationDone = true;
    })["catch"](function () {
      $scope.generationDone = true;
    });
  };

  // Gestione sixSearchTerms
  $scope.sxSearchTerms = {
    id: 'filter-search',
    open: false,
    type_id: undefined,
    type_obj: undefined
  };
  $scope.toggleSearchTerms = function () {
    $rootScope.$broadcast('sixSidebar:open', {
      id: $scope.sxSearchTerms.id
    });
  };
  $scope.updateSearchTerms = function () {
    schemaFactory().byCode({
      id: $scope.plan.model.model_type.code
    }).$promise.then(function (data) {
      $scope.sxSearchTerms.type_id = $scope.plan.model.model_type;
      $scope.sxSearchTerms.type_obj = data;
    });
  };
  $scope.onFilterChanged = function () {
    $scope.planAssets = [];
    $scope.planOptions.specifyAssets = false;
  };
  $scope.isEmptyFilter = function () {
    return Object.keys($scope.searchFilterObj).length === 0;
  };
  $scope.emptyFilter = function () {
    for (var key in $scope.searchFilterObj) {
      delete $scope.searchFilterObj[key];
    }
    $scope.plan.model.search_filter.description = '';
  };
  $(document).ready(function () {
    $('.list-sidebar-overlay').on('click', function () {
      $(this).removeClass('active');
      $('#list-sidebar').removeClass('open');
    });
  });

  //___ main ___
  $scope.prompt = true;
  if ($routeParams.id) {
    if ($routeParams.id != 'new') {
      $scope.prompt = false;
      $scope.initGenerationTag();
      $scope.getPlanById($routeParams.id).then(function () {
        $scope.updateSearchTerms();
      }).then(function () {
        if ($routeParams.generationcode) {
          var response = localStorageService.get('params');
          $scope.step = $scope.STEP.GENERATION;
          if ($routeParams.generationcode != 'error') {
            if (response) {
              $scope.affectedAssets = response.result.children_assets_count;
              $scope.affectedEvents = response.result.events_count;
            }
            $scope.getGeneratedOdlList($routeParams.generationcode);
          } else if ($routeParams.generationcode == 'error') {
            $scope.generationErrors = [];
            if (response) {
              response.messages.forEach(function (message) {
                if (message.error) $scope.generationErrors.push(message.message);
              });
            }
          }
          localStorageService.remove('params');
        }
      });
    }
  }

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'plan';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name emma.dataset.controller:PlanImportCtrl
 * @description
 * # PlanImportCtrl
 * Versione semplificata dell'import del dataset
 */
angular.module('emma.dataset').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/plan/import', {
    templateUrl: 'plan/plan/plan_import.html',
    controller: 'PlanImportCtrl'
  });
}]).controller('PlanImportCtrl', ["$scope", "$log", "$q", "planConfiguration", "planFactory", "recordFactory", "schemaFactory", "errorService", "dialogService", "$timeout", "toaster", "authFactory", "cronExpressionFactory", function ($scope, $log, $q, planConfiguration, planFactory, recordFactory, schemaFactory, errorService, dialogService, $timeout, toaster, authFactory, cronExpressionFactory) {
  $scope.errorCount = 0;
  $scope.importBusy = false;
  $scope.percent = 0;
  $scope.prePercent = 0;
  $scope.preprocessToResolve = 0;
  $scope.preprocessResolved = 0;
  $scope.data = [];
  $scope.reportMessages = [];
  $scope.cronExpressions = [];
  $scope.schemaDefinition = planConfiguration.getSchema();
  $scope.gridOptions = {};
  var currentCommission = authFactory.getAuthData().info.commissions.current;
  var currentCustomer = authFactory.getCurrentCustomer();
  $scope.reportGridOptions = {
    enableSorting: true,
    exporterMenuPdf: false,
    paginationPageSizes: [10, 20, 30],
    paginationPageSize: 10,
    useExternalPagination: false,
    data: 'reportMessages',
    columnDefs: [{
      displayName: 'Codice',
      field: 'code',
      width: '60'
    }, {
      displayName: 'Stato',
      field: 'status',
      width: '100'
    }, {
      displayName: 'Messaggio',
      field: 'message'
    }, {
      displayName: 'Record type',
      field: 'record.type',
      width: '120'
    }, {
      displayName: 'Record code',
      field: 'record.code',
      width: '120'
    }, {
      displayName: 'Record UUID',
      field: 'record.uuid',
      width: '120'
    }, {
      displayName: 'Record Id',
      field: 'recordId',
      width: '120'
    }, {
      displayName: 'Commission',
      field: 'commission',
      width: '120'
    }]
  };
  $scope.reset = function () {
    $scope.errorCount = 0;
    $scope.importBusy = false;
    $scope.percent = 0;
    $scope.prePercent = 0;
    $scope.preprocessToResolve = 0;
    $scope.preprocessResolved = 0;
    $scope.data = [];
    $scope.gridOptions.data = [];
    $scope.gridOptions.columnDefs = [];
    $scope.schemaDefinition = planConfiguration.getSchema();
    $scope.reportMessages = [];
    $scope.cronExpressions = [];
  };

  //dati caricati da xls
  $scope.$watch(function () {
    return $scope.gridOptions.xlsData;
  }, function (newValue, oldValue) {
    if (newValue && newValue.length > 0) {
      $scope.checkData();
    }
  });
  function checkDate(value) {
    // aaaa-MM-gg
    if (value) {
      var dateArray = value.split("-");
      // se la stringa è composta come: aaaa-MM-gg, la analizzo
      if (dateArray.length > 0 && dateArray.length == 3) {
        // qui effettuo il confronto tra le due stringhe
        var date = new Date(dateArray[0], dateArray[1] - 1, dateArray[2]); // year, month, day
        var convertedDate = "" + date.getFullYear() + ("0" + (date.getMonth() + 1)).slice(-2) + ("0" + date.getDate()).slice(-2);
        var initialDate = "" + dateArray[0] + dateArray[1] + dateArray[2];
        // CONFRONTO
        return initialDate == convertedDate;
      }
    }
    // se non è definita (= vuota), o se non arriva al confronto, non va bene
    return false;
  }
  $scope.checkData = function () {
    //FIXME dialogService.showLoadingMessage('Controllo dati...');
    console.log('Controllo e preprocesso i dati');
    /// $scope.gridOptions.xlsData ----> $scope.gridOptions.data

    $scope.gridOptions.columnDefs.splice(0, 0, {
      field: 'sixImportStatus',
      cellTemplate: "<div class=\"ui-grid-cell-contents\" title=\"{{COL_FIELD}}\">{{COL_FIELD}}</div>"
    });
    var properties = $scope.schemaDefinition.model.schema.properties;
    var propertiesRequired = {};
    var lookups = [];
    var arrays = [];
    var numbers = [];
    var booleans = [];
    var dates = [];
    var maps = [];
    var cronFrequencyLabels = planConfiguration.getFrequenciesByLabel();
    var cronRepetitions = planConfiguration.getRepetitions();

    // carico i campi obbligatori
    if ($scope.schemaDefinition.model.schema.required.length) {
      $scope.schemaDefinition.model.schema.required.forEach(function (p) {
        propertiesRequired[p] = properties[p];
      });
    }
    for (var key in properties) {
      if (properties[key]) {
        if (properties[key].format == 'lookup' && properties[key].entity_id) {
          lookups.push(key);
        } else if (properties[key].type == 'array') {
          arrays.push(key);
        } else if (properties[key].type == 'integer' || properties[key].type == 'number') {
          numbers.push(key);
        } else if (properties[key].type == 'boolean') {
          booleans.push(key);
        } else if (properties[key].type == 'string' && properties[key].format == 'date') {
          dates.push(key);
        } else if (properties[key].type == 'string' && properties[key].format == 'commissionmapper') {
          maps.push(key);
        }
      }
    }
    function parseBoolean(value) {
      var lower = value.toLowerCase();
      return lower === 'vero' || lower === 'v' || lower === 'true' || lower === 't' || lower === 'si' || lower === 's';
    }
    var indexMapToResolve = {
      record: {}
    };
    $scope.gridOptions.xlsData.forEach(function (value) {
      // uso un array per gestire l'assenza di uno o più campi -> per stampare un messaggio associato
      var stringWithPropertiesRequired = [];
      value['sixImportStatus'] = 'OK';
      $scope.preprocessToResolve++; ///un po' così.... conto 1 per ogni record+ 1 per ogni lookup da risolvere...
      if (!value.commission && $scope.schemaDefinition.model.commissionDependent) {
        //se la commessa non è indicata, ma il dato dipende dalla commessa allora uso la commessa corrente
        value.commission = currentCommission.code;
      }
      if (value.commission != currentCommission.code) {
        //per il plan non è consentito l'import su commesse diverse dall'attuale
        value['sixImportStatus'] = 'La commessa è diversa da quella attuale.';
        $scope.errorCount++;
      }
      for (var l in lookups) {
        (function () {
          //closure <3
          var k = lookups[l];
          var v = value[k];
          var lookupCommission = value.commission ? value.commission : currentCommission.code;
          if (!angular.isUndefined(v)) {
            var mapToResolve = {};
            if (angular.isUndefined(properties[k].basePath) || properties[k].basePath == 'record') {
              // FIXME forse sarebbe meglio controllare gli attributi 'war' e 'entity_id'
              if (!indexMapToResolve.record.hasOwnProperty(lookupCommission)) {
                indexMapToResolve.record[lookupCommission] = {};
              }
              mapToResolve = indexMapToResolve.record[lookupCommission];
            } else {
              if (properties[k].basePath in indexMapToResolve) {
                mapToResolve = indexMapToResolve[properties[k].basePath];
              } else {
                indexMapToResolve[properties[k].basePath] = {};
                mapToResolve = indexMapToResolve[properties[k].basePath];
              }
            }
            if (properties[k].entity_id in mapToResolve === false) {
              mapToResolve[properties[k].entity_id] = {};
            }
            var innerMap = mapToResolve[properties[k].entity_id];
            if (properties[k].hasOwnProperty('multiple') && properties[k].multiple == true) {
              // gestione lookup multipla
              var arrayLookup = arrayLookupParser(v);
              if (arrayLookup.length > 0) {
                arrayLookup.forEach(function (vlookup) {
                  innerMap[vlookup] = '';
                });
              }
            } else {
              // gestione lookup singola
              innerMap[v] = '';
            }
          }
        })();
      }
      arrays.forEach(function (a) {
        if (value[a]) {
          var isArray = false; // se il json è un array
          var jsonArray; // variabile risultato
          try {
            value[a] = value[a].replace(/[“”']/g, '"');
            jsonArray = JSON.parse(value[a]);
            if (jsonArray.length) {
              // deve essere un array -> length
              isArray = true;
            }
          } catch (e) {
            isArray = false;
          }
          if (!isArray) {
            // errore
            value['sixImportStatus'] = 'Array ' + a + ' non valido';
            $scope.errorCount++;
          } else {
            // ok
            value[a] = jsonArray;
          }
        }
      });
      numbers.forEach(function (n) {
        if (value[n] && value[n].trim().length > 0) {
          if (isNaN(value[n])) {
            // errore
            value['sixImportStatus'] = 'Numero ' + n + ' non valido';
            $scope.errorCount++;
          } else {
            // ok
            value[n] = parseFloat(value[n]);
          }
        }
      });
      booleans.forEach(function (b) {
        if (value[b]) {
          // il check non serve -> sempre true/false
          value[b] = parseBoolean(value[b]);
        }
      });
      dates.forEach(function (d) {
        if (value[d] && value[d].trim().length > 0) {
          // check sul formato della data
          if (!checkDate(value[d])) {
            // errore
            value['sixImportStatus'] = 'Data ' + d + ' non valida';
            $scope.errorCount++;
          } else {
            // ok
            // non devo fare niente ci pensa il be
          }
        }
      });
      maps.forEach(function (m) {
        if (value[m]) {
          var isObj = false; // se il json è un oggetto
          var jsonObj; // variabile risultato
          try {
            value[m] = value[m].replace(/[“”']/g, '"');
            jsonObj = JSON.parse(value[m]);
            if (jsonObj) {
              isObj = true;
            }
          } catch (e) {
            isObj = false;
          }
          if (!isObj) {
            // errore
            value['sixImportStatus'] = 'Oggetto ' + m + ' non valido';
            $scope.errorCount++;
          } else {
            // ok
            value[m] = jsonObj;
          }
        }
      });
      $scope.preprocessResolved++;
      $scope.updatePreprocessPercent();

      // controllo la presenza dei campi obbligatori
      for (var req in propertiesRequired) {
        // controllo se non ha la proprietà, oppure se ce l'ha ma non è valorizzata o è uno spazio bianco...
        if (!value.hasOwnProperty(req) || value.hasOwnProperty(req) && (!value[req] || value[req].trim().length == 0)) {
          stringWithPropertiesRequired.push(req);
          $scope.errorCount++;
        }
      }
      // stampo un messaggio legato a quanti campi obbligatori non trovo
      if (stringWithPropertiesRequired.length == 1) {
        value['sixImportStatus'] = stringWithPropertiesRequired[0] + ' non trovato;';
      } else if (stringWithPropertiesRequired.length > 1) {
        value['sixImportStatus'] = stringWithPropertiesRequired.toString() + ' non trovati;';
      } else if (value['parents']) {
        value['sixImportStatus'] = 'La colonna parents non è importabile;';
      }

      //validazione e conversione cron expression

      var frequencyLabel = value['frequency'].toLowerCase();
      if (cronFrequencyLabels[frequencyLabel] !== undefined) {
        var freqObj = {
          frequency: cronFrequencyLabels[frequencyLabel].key,
          day_of_month: "1",
          day_of_week: "MON",
          month_of_year: "1"
        };
        var repetition = cronRepetitions[cronFrequencyLabels[frequencyLabel].repetition];
        if (repetition.dayOfWeek) {
          var dayIndex = sixDateLib.getWeekDayIndex(value['frequency_day']);
          freqObj.day_of_week = repetition.dayOfWeek[dayIndex];
        }
        if (repetition.dayOfMonth) {
          var number = value['frequency_day'].match(/\d+/ig)[0];
          freqObj.day_of_month = number;
        }
        if (repetition.month) {
          //FIXME se c'è un numero davanti
          var month = value['frequency_day'].match(/[A-Za-z]+/ig)[0];
          freqObj.month_of_year = (sixDateLib.getMonthIndex(month) + 1).toString();
        }
        //TODO: validazioni aggiuntive se salta uno degli if sopra
        $scope.cronExpressions.push(freqObj);
      } else {
        value['sixImportStatus'] = 'La colonna frequencies non ha un valore valido';
      }

      // add
      $scope.gridOptions.data = $scope.gridOptions.data.concat(value);
    });

    // se non ci sono errori (tutti campi obbligatori presenti): risolvo le lookup ed elaboro le cron expression
    if ($scope.errorCount <= 0) {
      $log.info(indexMapToResolve);

      //elaboro le cron expression
      cronExpressionFactory.getCronExpressionBulk($scope.cronExpressions).$promise.then(function (data) {
        if (data.result) {
          data.result.forEach(function (result, pos) {
            //la cronexpression da salvare ha delle chiavi diverse
            var cronToSave = {
              "cronExpression": result.cron_expression,
              "monthOfYear": result.month_of_year,
              "dayOfWeek": result.day_of_week,
              "dayOfMonth": result.day_of_month,
              "type": result.frequency
            };
            delete $scope.gridOptions.xlsData[pos].frequency_day;
            $scope.gridOptions.xlsData[pos].frequency = cronToSave;
          });
        } else {
          toaster.pop('error', 'Errore', "Impossibile elaborare la frequenza della programmata.");
        }
      });
      for (var index in indexMapToResolve) {
        var mapToResolve = indexMapToResolve[index];
        var promise;
        if (index === 'record') {
          promise = recordFactory('type').bulkResolveMC(mapToResolve).$promise;
        } else if (index === 'schema') {
          promise = schemaFactory().bulkResolve(mapToResolve).$promise;
        }
        promise.then(function (index) {
          return function (data) {
            $log.info(data);
            $scope.gridOptions.xlsData.forEach(function (value) {
              $scope.preprocessToResolve++; ///un po' così.... conto 1 per ogni record+ 1 per ogni lookup da risolvere...
              for (var l in lookups) {
                (function () {
                  //closure <3
                  var k = lookups[l];
                  var v = value[k];
                  if (!angular.isUndefined(v) && v !== null) {
                    $scope.preprocessResolved++;
                    //$scope.updatePreprocessPercent();
                    if (index === 'record') {
                      var resolved = data[value.commission][properties[k].entity_id];
                    } else {
                      var resolved = data[properties[k].entity_id];
                    }
                    if (resolved) {
                      if (properties[k].hasOwnProperty('multiple') && properties[k].multiple == true) {
                        // lookup multipla
                        var arrayLookup = arrayLookupParser(v);
                        if (arrayLookup.length > 0) {
                          value[k] = [];
                          arrayLookup.forEach(function (vlookup) {
                            if (resolved.hasOwnProperty(vlookup)) {
                              var ref = sixObjectLib.recordToHisRef(resolved[vlookup]);
                              if (!ref) {
                                if (value['sixImportStatus'] == 'OK') value['sixImportStatus'] = '';
                                value['sixImportStatus'] = value['sixImportStatus'].concat(k + ' (' + properties[k].entity_id + ') array di lookup non risolto per: "' + vlookup + '"; ');
                                $scope.errorCount++;
                              } else {
                                value[k].push(ref);
                              }
                            }
                          });
                        }
                      } else {
                        var ref = sixObjectLib.recordToHisRef(resolved[v]);
                        if (!ref) {
                          if (value['sixImportStatus'] == 'OK') value['sixImportStatus'] = '';
                          value['sixImportStatus'] = value['sixImportStatus'].concat(k + ' (' + properties[k].entity_id + ') ' + v + ' non trovato; ');
                          $scope.errorCount++;
                        } else {
                          value[k] = ref;
                        }
                      }
                    }
                  }
                })();
              }

              //Gestione ad-hoc delle task activities
              if (index === 'record') {
                value['task_activities'] = data[value.commission].task[value.task_id.code].model.activities;
              }
            });
          };
        }(index));
      }
    }
    dialogService.hideLoadingMessage(true);
  };
  function arrayLookupParser(string) {
    var arrayString = string;
    var arrayLookup = [];
    arrayString = arrayString.replace(new RegExp('"', 'g'), ''); // pulizia dai vari tipi di virgolette, in base alla formattazione..
    arrayString = arrayString.replace(new RegExp('“', 'g'), '');
    arrayString = arrayString.replace(new RegExp('”', 'g'), '');
    arrayString = arrayString.replace(new RegExp(' ', 'g'), ''); // pulizia dagli spazi dei codici..
    arrayString = arrayString.substring(arrayString.lastIndexOf("[") + 1, arrayString.lastIndexOf("]")); // eliminazione []
    if (arrayString.length > 0) {
      arrayLookup = arrayString.split(","); // creazione array con i 'code'
    }

    return arrayLookup;
  }
  $scope.updatePreprocessPercent = function () {
    $scope.prePercent = $scope.preprocessResolved * 1.0 / $scope.preprocessToResolve * 100;
  };
  $scope.importData = function () {
    if ($scope.errorCount > 0) {
      dialogService.dialog('Sono presenti errori', 'Impossibile importare i dati', 'warning', 4000, true);
      return;
    }
    dialogService.showLoadingMessage('Importazione...');
    $scope.importBusy = true;
    var counter = 0;
    $scope.data = [];
    $scope.gridOptions.data.forEach(function (value) {
      delete value['$$hashKey']; //questa è robaccia di uigrid
      delete value['sixImportStatus'];
      value["search_filter"] = {
        //imposto i filtri sul default
        "description": "",
        "json_object": "{}",
        "json_array": "[]"
      };
      $scope.data = $scope.data.concat(value);
    });
    stopDummyUpdateProgressBar = false;
    updateDummyProgressBar();
    var promise = planFactory().bulkImport($scope.data).$promise;
    promise.then(function (response) {
      $scope.reportMessages = response.messages;
      stopDummyUpdateProgressBar = true;
      dialogService.stopLoading();
      if (response.status === 'errors') {
        toaster.pop('error', 'Errore', 'Errore durante il salvataggio');
      } else {
        counter = $scope.data.length;
        $scope.percent = counter / $scope.data.length * 100;
      }
    })["catch"](function (response) {
      $scope.percent = 0;
      stopDummyUpdateProgressBar = true;
      toaster.pop('error', 'Errore', 'Errore durante il salvataggio');
    });
  };

  /*************************************/
  // Template xlsx
  /*************************************/

  function buildDataType(prop) {
    if (prop.type === 'string' && prop.format === 'date') {
      return 'yyyy-MM-dd';
    } else if (prop.type === 'string' && prop.format === 'lookup') {
      return 'ref';
    } else if (prop.type === 'integer') {
      return 1;
    } else if (prop.type === 'number') {
      return 1.234;
    } else if (prop.type === 'object') {
      var obj = {};
      for (var key in prop.properties) {
        obj[key] = buildDataType(prop.properties[key]);
      }
      return JSON.stringify(obj);
    }
    return 'text';
  }
  function schemaDefinitionToSheet() {
    var ws = {};
    var range = {
      s: {
        c: 10000000,
        r: 10000000
      },
      e: {
        c: 0,
        r: 0
      }
    };
    var data = [[], []];
    if ($scope.schemaDefinition.model.commissionDependent) {
      data[0].push("commission");
      data[1].push("text");
    }
    for (var key in $scope.schemaDefinition.model.schema.properties) {
      // Intestazione di colonna
      data[0].push(key);
      // Riga di esempio
      var prop = $scope.schemaDefinition.model.schema.properties[key];
      var example = 'text';
      if (prop.type === 'array') {
        if (!prop.items) {
          example = '[item1, item2]';
        } else {
          example = '[' + buildDataType(prop.items) + ',' + buildDataType(prop.items) + ']';
        }
      } else {
        example = buildDataType(prop);
      }
      data[1].push(example);
    }
    for (var R = 0; R != data.length; ++R) {
      for (var C = 0; C != data[R].length; ++C) {
        if (range.s.r > R) range.s.r = R;
        if (range.s.c > C) range.s.c = C;
        if (range.e.r < R) range.e.r = R;
        if (range.e.c < C) range.e.c = C;
        var cell = {
          v: data[R][C]
        };
        if (cell.v == null) continue;
        var cell_ref = XLSX.utils.encode_cell({
          c: C,
          r: R
        });
        if (typeof cell.v === 'number') cell.t = 'n';else if (typeof cell.v === 'boolean') cell.t = 'b';else if (cell.v instanceof Date) {
          cell.t = 'n';
          cell.z = XLSX.SSF._table[14];
          cell.v = datenum(cell.v);
        } else cell.t = 's';
        ws[cell_ref] = cell;
      }
    }
    if (range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
    return ws;
  }
  function Workbook() {
    if (!(this instanceof Workbook)) return new Workbook();
    this.SheetNames = [];
    this.Sheets = {};
  }
  function datenum(v, date1904) {
    if (date1904) v += 1462;
    var epoch = Date.parse(v);
    return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
  }
  $scope.schemaDefinitionToXlsx = function () {
    //var ranges = oo[1];

    /* original data */
    var ws_name = "plan";
    var wb = new Workbook();
    var ws = schemaDefinitionToSheet();

    /* add ranges to worksheet */
    //ws['!merges'] = ranges;

    /* add worksheet to workbook */
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    var wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      bookSST: false,
      type: 'binary'
    });
    saveAs(new Blob([s2ab(wbout)], {
      type: "application/octet-stream"
    }), "plan-template.xlsx");
  };
  function s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
  }

  // fa avanzare la progress bar a caso, giusto per far vedere che sta facendo qualcosa
  var stopDummyUpdateProgressBar = false;
  function updateDummyProgressBar() {
    if ($scope.percent < 100 && stopDummyUpdateProgressBar === false) {
      $timeout(function () {
        if (stopDummyUpdateProgressBar === false) {
          $scope.percent += $scope.percent < 90 ? Math.random() * 5 : 0; // appena supero il 90% mi fermo e attendo che qualcuno lo porti a 100%
          if ($scope.percent < 100) {
            updateDummyProgressBar();
          }
        }
      }, Math.random() * 2000);
    }
  }

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'plan';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:PlanCtrl
 * @description Controller for planned tasks
 * # PlanCtrl
 */
angular.module('emma.plan').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/plan', {
    templateUrl: 'plan/plan/plan_list.html',
    controller: 'PlanListCtrl'
  });
}]).controller('PlanListCtrl', ["$scope", "$log", "$location", "planFactory", "uiGridConstants", "sixGridPaginationConstants", "authFactory", "planConfiguration", function ($scope, $log, $location, planFactory, uiGridConstants, sixGridPaginationConstants, authFactory, planConfiguration) {
  $scope.planList = {};
  $scope.params = {
    queryParam: '',
    filters: ''
  };
  $scope.autoResizeParams = {
    enabled: true,
    minHeight: 200,
    marginTop: 290
  };
  $scope.viewGridOptions = {
    columnDefs: [{
      name: ' '
    }]
  };
  var DEFAULT_SORT_FIELD = 'model.code';
  function defaultSort() {
    return $scope.sortFields ? $scope.sortFields : DEFAULT_SORT_FIELD;
  }
  var DEFAULT_SORT_ORDER = 'asc';
  function defaultSortOrder() {
    return $scope.sortOrder ? $scope.sortOrder : DEFAULT_SORT_ORDER;
  }
  function initGridColumns() {
    $scope.viewGridOptions.columnDefs = [];
    $scope.viewGridOptions.columnDefs.push({
      displayName: '',
      field: 'id',
      width: 36,
      enableCellEdit: true,
      enableFiltering: false,
      enableSorting: false,
      cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/plan/detail/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' + '<span class="fa fa-search"></span>' + '</a>' + '</div>'
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Codice',
      field: 'model.code',
      enableFiltering: true,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Descrizione',
      field: 'model.description',
      enableFiltering: true,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Filtro',
      field: 'model.search_filter.description_short',
      enableFiltering: false,
      cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center" ng-bind-html="row.entity.model.search_filter.description_short"></div>',
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'ODL',
      field: 'odl',
      width: 50,
      enableCellEdit: true,
      enableFiltering: false,
      enableSorting: false,
      cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/plan/odl/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' + '<span class="fa fa-tasks"></span>' + '</a>' + '</div>'
    });
  }
  $scope.getData = function () {
    if (!$scope.params.sortFields || $scope.params.sortFields.trim() == '') {
      $scope.params.sortFields = 'model.code:asc';
    }
    var payload = {
      query: $scope.params.queryParam,
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      sort_fields: $scope.params.sortFields,
      show_revision: false
    };
    return planFactory().getPlanListFiltered(payload, $scope.params.filters).$promise.then(function (data) {
      $scope.planList.totalResults = data.totalResults;
      $scope.planList.list = data.list;
      return data;
    });
  };
  $scope.goToNewPlan = function () {
    $location.path('plan/detail/new');
  };
  $scope.goToGantt = function () {
    $location.path('task/gantt');
  };
  $scope.goToPlanImport = function () {
    $location.path('plan/import');
  };

  //__main__
  initGridColumns();

  /* EXPORT */
  $scope.limit = 10000;
  $scope.schema = planConfiguration.getSchema();
  function frequencyTransformer(v) {
    if (v.type) {
      var f = planConfiguration.getFrequencies();
      return f[v.type].label;
    }
  }
  function frequencyDayTransformer(v) {
    if (v.type) {
      var value = '';
      var f = planConfiguration.getFrequencies();
      var r = planConfiguration.getRepetitions();
      var repConf = r[f[v.type].repetition];
      if (repConf.dayOfWeek) {
        var dayNumber = repConf.dayOfWeek.indexOf(v.dayOfWeek);
        value = sixDateLib.getWeekDayName(dayNumber);
      } else if (repConf.dayOfMonth) {
        value = v.dayOfMonth;
      }
      if (repConf.month) {
        var m = parseInt(v.monthOfYear) - 1;
        value += (repConf.dayOfMonth ? ' ' : '') + sixDateLib.getMonthName(m);
      }
      return value;
    }
  }
  $scope.exportXLSX = function (typeExport) {
    // preparo colonne
    var columns = [];
    angular.forEach($scope.schema.model.schema.properties, function (property, key) {
      var column = {
        key: 'model.' + key,
        name: typeExport == 'exportToImport' ? key : property.title
      };
      if (key == 'frequency') {
        column.transform = frequencyTransformer;
      }
      if (key == 'frequency_day') {
        column.transform = frequencyDayTransformer;
      }
      columns.push(column);
    });
    columns.push({
      key: 'commission',
      name: typeExport == 'exportToImport' ? 'commission' : 'Commessa'
    });

    // preparo righe
    var rows = $scope.params.gridApi.selection.getSelectedRows();
    if (!rows || rows.length == 0) {
      var promise = {};
      var payload = {
        query: $scope.queryParam,
        page: 1,
        page_size: 10000,
        show_revision: false,
        solve_inherit: typeExport == 'exportToImport' ? false : true
      };
      promise = planFactory().getPlanListFiltered(payload, $scope.params.filters).$promise;
      // aspetto la risposta...
      promise.then(function (data) {
        rows = data.list;
        rows.forEach(function (v, k) {
          rows[k].model.frequency_day = v.model.frequency;
        });
        sixExportLib.exportXLSX(columns, rows, "plan", typeExport !== 'exportToImport');
      });
    } else {
      rows.forEach(function (v, k) {
        rows[k].model.frequency_day = v.model.frequency;
      });
      sixExportLib.exportXLSX(columns, rows, "plan", typeExport !== 'exportToImport');
    }
  };

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'plan';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:PlanodlCtrl
 * @description
 * # PlanodlCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/plan/odl/:id', {
    templateUrl: 'plan/plan/plan_odl.html',
    controller: 'PlanOdlCtrl'
  });
}]).controller('PlanOdlCtrl', ["$scope", "uiGridConstants", "$log", "planOdlFactory", "$routeParams", "$location", "planFactory", "authFactory", "sixGridPaginationConstants", "odlFactory", "odlWorkflow", "ngDialog", "$route", function ($scope, uiGridConstants, $log, planOdlFactory, $routeParams, $location, planFactory, authFactory, sixGridPaginationConstants, odlFactory, odlWorkflow, ngDialog, $route) {
  $scope.planId;

  // Funzioni specifiche per vista paginata ---------------------------------------------
  $scope.odlList = {};
  $scope.params = {
    queryParam: '',
    filterQuery: ''
  };
  $scope.viewGridOptions = {
    columnDefs: [{
      name: ' '
    }]
  };
  $scope.gridAppCallbacks = {};
  $scope.gridAppCallbacks['getReadableStatus'] = odlWorkflow.getReadableStatus;
  $scope.gridAppCallbacks['buildMultiSelectFilter'] = buildMultiSelectFilter;
  var DEFAULT_SORT_FIELD = 'date_requested';
  function defaultSort() {
    var result = $scope.sortFields ? $scope.sortFields : DEFAULT_SORT_FIELD;
    return result;
  }
  var DEFAULT_SORT_ORDER = 'asc';
  function defaultSortOrder() {
    var result = $scope.sortOrder ? $scope.sortOrder : DEFAULT_SORT_ORDER;
    return result;
  }
  var getPage = function getPage() {
    $scope.viewGridOptions.totalItems = $scope.odlList.totalResults;
    var firstRow = ($scope.params.pageNumber - 1) * $scope.params.pageSize;
    var lastRow = firstRow + $scope.params.pageSize;
    $scope.viewGridOptions.data = $scope.viewGridOptions.data.slice(firstRow, lastRow);
  };
  function initGridColumns() {
    odlWorkflow.getStatuses().then(function (statuses) {
      var statusOptions = [];
      for (var s in statuses) {
        statusOptions.push({
          "value": statuses[s].code,
          "label": statuses[s].label
        });
      }
      $scope.viewGridOptions.columnDefs = [];
      $scope.viewGridOptions.columnDefs.push({
        displayName: '',
        field: 'id',
        width: 36,
        enableCellEdit: true,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/odl/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' + '<span class="fa fa-search"></span>' + '</a>' + '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Asset',
        field: 'model.record_id',
        cellTemplate: '<div class="ui-grid-cell ui-grid-cell-contents"><span ng-if="grid.getCellValue(row, col)">{{grid.getCellValue(row, col).code}} - {{grid.getCellValue(row, col).description}}</span></div>',
        enableFiltering: true,
        filters: [{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Titolo',
        field: 'model.title',
        enableFiltering: true,
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Stato',
        field: 'status',
        enableFiltering: true,
        width: 100,
        filterHeaderTemplate: '<div class="ui-grid-filter-container"><a class="block btn btn-default btn-xs" ng-repeat="colFilter in col.filters" ' + 'ng-click="grid.appScope.buildMultiSelectFilter(colFilter)">Filtro</a></div>',
        filters: [{
          type: sixGridPaginationConstants.filterType.SELECTMULTIPLE,
          selectOptions: statusOptions,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }],
        cellTemplate: '<div class="ui-grid-cell-contents" style="vertical-align:middle;">' + '{{grid.appScope.getReadableStatus(row.entity.status)}}' + '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Elemento tecnologico',
        field: 'model.type_id.description',
        enableFiltering: true,
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Generato per',
        field: 'model.target_type_id.description',
        enableFiltering: true,
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Codice generazione',
        field: 'model.generation_tag',
        enableFiltering: true,
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Utente generazione',
        field: 'user',
        enableFiltering: true,
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data generazione',
        field: 'dataIn',
        type: 'date',
        cellFilter: 'date:\'dd/MM/yyyy\'',
        width: 100,
        enableFiltering: true,
        filters: [{
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
          placeholder: 'da...',
          condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
        }, {
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
          placeholder: 'a...',
          condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data pianifica',
        field: 'date_requested',
        type: 'date',
        cellFilter: 'date:\'dd/MM/yyyy\'',
        width: 100,
        enableFiltering: true,
        filters: [{
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
          placeholder: 'da...',
          condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
        }, {
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
          placeholder: 'a...',
          condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
        }]
      });
    });
  }
  function buildMultiSelectFilter(filter) {
    var options = '';
    filter.selectOptions.forEach(function (val, key) {
      options += '<label class="checkbox i-checks m-t-none m-b-none"><input type="checkbox" ' + 'ng-model="ngDialogData.selection[' + key + '].active"><i></i> ' + val.label + '</label>';
    });
    if (Array.isArray(filter.term)) {
      filter.term.forEach(function (term) {
        filter.selectOptions.forEach(function (v, k, opt) {
          if (v.value == term) opt[k].active = true;
        });
      });
    }
    ngDialog.openConfirm({
      name: 'multiSelectFilterDialog',
      closeByDocument: false,
      showClose: true,
      template: '' + '<div style="text-align:center">Seleziona filtri da attivare ' + '</div><br>' + '' + options + '' + '<div class="row" style="text-align:center; clear: both">' + '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ' + 'ng-click="confirm(ngDialogData.selection)">Applica filtro</button>' + '</div>',
      data: {
        selection: filter.selectOptions
      },
      plain: true,
      className: 'ngdialog-theme-default ngdialog-theme-custom'
    }).then(function (selection) {
      filter.term = [];
      selection.forEach(function (sel) {
        if (sel.active) {
          filter.term.push(sel.value);
        }
      });
    });
  }
  $scope.getData = function () {
    if (!$scope.params.sortFields || $scope.params.sortFields.trim() == '') {
      $scope.params.sortFields = 'date_requested:asc';
    }
    if (!$scope.params.filters) {
      $scope.params.filters = {};
    }
    $scope.params.filters["plan_id.UUID"] = sixFiltersLib.exact('plan_id.UUID', $scope.planId);
    var payload = {
      query: $scope.params.queryParam,
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      sort_fields: $scope.params.sortFields,
      show_revision: false
    };
    return planOdlFactory().search(payload, $scope.params.filters).$promise.then(function (data) {
      $scope.odlList.totalResults = data.totalResults;
      $scope.odlList.list = data.list;
      getPage();
      $scope.params.sixApi.refreshList(data.list);
      return data;
    });
  };
  $scope.getPlanById = function (id) {
    planFactory().getPlanByUUID({
      id: id
    }).$promise.then(function (data) {
      $scope.plan = data;
      $scope.frequency = getFrequencyDescription(data.model.frequency.type);
    });
  };
  function getFrequencyDescription(type) {
    var description = "";
    switch (type) {
      case 'week_1':
        description = "Settimanale";
        break;
      case 'month_1':
        description = "Mensile";
        break;
      case 'month_2':
        description = "Bimestrale";
        break;
      case 'month_3':
        description = "Trimestrale";
        break;
      case 'month_4':
        description = "Quadrimestrale";
        break;
      case 'month_6':
        description = "Semestrale";
        break;
      case 'year_1':
        description = "Annuale";
        break;
      case 'year_2':
        description = "Biennale";
        break;
      case 'year_3':
        description = "Triennale";
        break;
      case 'year_4':
        description = "Quadriennale";
        break;
      case 'year_5':
        description = "Quinquennale";
        break;
      case 'year_6':
        description = "ogni 6 anni";
        break;
    }
    return description;
  }
  $scope.getSelectedRows = function () {
    var api = $scope.params.gridApi;
    if (api && api.selection) {
      return api.selection.getSelectedRows();
    } else {
      return [];
    }
  };

  // FINE - Funzioni specifiche per vista paginata ---------------------------------------------

  $scope.goToPlan = function () {
    $location.path('plan/detail/' + $scope.planId);
  };
  $scope.goToReplan = function () {
    $location.path('plan/replan/' + $scope.planId);
  };
  $scope.deleteOdlList = function (query) {
    var payload = {
      planId: $scope.planId
    };
    planOdlFactory().deletePlanOdlList(payload).$promise.then(function (data) {
      $location.path('plan');
    });
  };
  $scope.deleteOdlSelected = function () {
    var rows = $scope.getSelectedRows();
    rows.forEach(function (val, i) {
      rows[i] = val.version;
    });
    odlFactory().bulkDeleteOdl(rows).$promise.then(function (data) {
      $route.reload();
    });
  };

  //___main___
  if ($routeParams.id) {
    $scope.planId = $routeParams.id;
    $scope.getPlanById($scope.planId);
  }
  initGridColumns();

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'plan/odl';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:PlanReplanCtrl
 * @description
 * # PlanReplanCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/plan/replan/:id', {
    templateUrl: 'plan/plan/plan_replan.html',
    controller: 'PlanReplanCtrl'
  });
}]).controller('PlanReplanCtrl', ["$scope", "$log", "planOdlFactory", "$routeParams", "$location", "planFactory", "odlFactory", "authFactory", function ($scope, $log, planOdlFactory, $routeParams, $location, planFactory, odlFactory, authFactory) {
  $scope.planId;

  // Funzioni specifiche per vista paginata ---------------------------------------------
  $scope.odlList = {};
  $scope.popup = {
    opened: false
  };
  $scope.dateOptions = {
    formatYear: 'yyyy',
    minDate: new Date()
  };
  function getPlanById(id) {
    planFactory().getPlanByUUID({
      id: id
    }).$promise.then(function (data) {
      $scope.plan = data;
      $scope.frequency = getFrequencyDescription(data.model.frequency.type);
    });
  }
  ;
  function getFrequencyDescription(type) {
    var description = "";
    switch (type) {
      case 'week_1':
        description = "Settimanale";
        break;
      case 'month_1':
        description = "Mensile";
        break;
      case 'month_2':
        description = "Bimestrale";
        break;
      case 'month_3':
        description = "Trimestrale";
        break;
      case 'month_4':
        description = "Quadrimestrale";
        break;
      case 'month_6':
        description = "Semestrale";
        break;
      case 'year_1':
        description = "Annuale";
        break;
      case 'year_2':
        description = "Biennale";
        break;
      case 'year_3':
        description = "Triennale";
        break;
      case 'year_4':
        description = "Quadriennale";
        break;
      case 'year_5':
        description = "Quinquennale";
        break;
      case 'year_6':
        description = "ogni 6 anni";
        break;
    }
    return description;
  }
  $scope.goToPlan = function () {
    $location.path('plan/detail/' + $scope.planId);
  };
  $scope.checkAllDay = function (dayIndex) {
    var dailyItem = $scope.dayCheckList[dayIndex];
    for (var i = 0; i < dailyItem.odlCheckItems.length; i++) {
      dailyItem.odlCheckItems[i].isChecked = dailyItem.isChecked;
    }
  };
  $scope.isEditing = function (dayIndex) {
    var isEditing = false;
    var dailyItem = $scope.dayCheckList[dayIndex];
    for (var i = 0; i < dailyItem.odlCheckItems.length; i++) {
      if (dailyItem.odlCheckItems[i].isChecked) {
        isEditing = true;
        break;
      }
    }
    return isEditing;
  };
  $scope.selectDate = function (dayIndex) {
    var dailyItem = $scope.dayCheckList[dayIndex];
    for (var i = 0; i < dailyItem.odlCheckItems.length; i++) {
      if (dailyItem.odlCheckItems[i].isChecked) {
        dailyItem.odlCheckItems[i].newDate = dailyItem.newDate;
        dailyItem.odlCheckItems[i].isChecked = false;
        dailyItem.odlCheckItems[i].canUndo = true;
      }
    }
    dailyItem.isChecked = false;
  };
  $scope.undoOdlItem = function (checkItem) {
    checkItem.newDate = undefined;
    checkItem.canUndo = false;
  };
  function getPlanning() {
    var payload = {
      query: '',
      page: 1,
      page_size: 10000,
      plan_id: $scope.planId,
      sort_fields: "date_requested:asc"
    };
    planOdlFactory().getPlanning(payload).$promise.then(function (data) {
      $scope.planning = data.list;
      $scope.odlCheckList = [];
      $scope.dayCheckList = [];
      var count = 0;
      for (var i = 0; i < $scope.planning.length; i++) {
        var daily = {
          isChecked: false,
          dayIndex: i,
          odlCheckItems: [],
          newDate: new Date($scope.planning[i].date_requested),
          popup: {
            opened: false
          }
        };
        var day = $scope.planning[i];
        for (var j = 0; j < day.list.length; j++) {
          var item = {
            isChecked: false,
            dayIndex: i,
            innerIndex: j,
            odlIndex: count,
            canUndo: false
          };
          day.list[j].temp_index = count;
          $scope.odlCheckList.push(item);
          daily.odlCheckItems.push(item);
          count++;
        }
        $scope.dayCheckList.push(daily);
      }
    });
  }
  $scope.save = function () {
    var index = 0;
    var payload = [];
    for (var i = 0; i < $scope.planning.length; i++) {
      var day = $scope.planning[i];
      for (var j = 0; j < day.list.length; j++) {
        var checkItem = $scope.odlCheckList[index];
        if (angular.isDefined(checkItem.newDate)) {
          var odl = day.list[checkItem.innerIndex];
          odl.date_requested = checkItem.newDate;
          delete day.list[j].temp_index;
          payload.push(odl);
        }
        index++;
      }
    }
    if (payload.length > 0) {
      odlFactory().bulkUpdateOdl(payload).$promise.then(function (data) {
        $location.path('plan/odl/' + $scope.planId);
      });
    } else {
      $location.path('plan/odl/' + $scope.planId);
    }
  };

  //___main___
  if ($routeParams.id) {
    $scope.planId = $routeParams.id;
    getPlanById($scope.planId);
    getPlanning($scope.planId);
  }

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'plan/odl';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:ReportCtrl
 * @description
 * # ReportCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/report/average_closing_time', {
    templateUrl: 'plan/report/average_closing_time.html',
    controller: 'ReportCtrl'
  }).when('/report/odl_closed_by_service', {
    templateUrl: 'plan/report/odl_closed_by_service.html',
    controller: 'ReportCtrl'
  }).when('/report/percentage_odl_by_status', {
    templateUrl: 'plan/report/percentage_odl_by_status.html',
    controller: 'ReportCtrl'
  }).when('/report/ratio_odl_by_status', {
    templateUrl: 'plan/report/ratio_odl_by_status.html',
    controller: 'ReportCtrl'
  });
}]).controller('ReportCtrl', ["$scope", "authFactory", "$http", "APP_URL", "$log", "toaster", "SaveAs", "treeUtilities", function ($scope, authFactory, $http, APP_URL, $log, toaster, SaveAs, treeUtilities) {
  var currentCommission = authFactory.getAuthData().info.commissions.current;
  $scope.generatedReport = {
    data: new Uint8Array(),
    name: undefined,
    extension: undefined
  };
  $scope.data = {
    type_id: "",
    record_id: [],
    priority_id: undefined,
    odl_type: {
      key: 'all',
      description: 'Tutti'
    },
    from: undefined,
    to: undefined
  };
  $scope.odlTypeList = [{
    key: 'issue',
    description: 'Da segnalazione'
  }, {
    key: 'plan',
    description: 'Da programmata'
  }, {
    key: 'all',
    description: 'Tutti'
  }];
  $scope.dateFormat = 'dd/MM/yyyy';
  $scope.dateOptionsFrom = {
    formatYear: 'yyyy',
    startingDay: 1,
    datepickerMode: 'day',
    minMode: 'day',
    maxMode: 'year'
  };
  $scope.dateOptionsTo = {
    formatYear: 'yyyy',
    startingDay: 1,
    datepickerMode: 'day',
    minMode: 'day',
    maxMode: 'year',
    minDate: $scope.data.from
  };
  $scope.typeIdFilter = null;
  treeUtilities.getFlatStructureUuids().then(function (types) {
    if (types) {
      $scope.typeIdFilter = {
        'typeIdFilter': sixFiltersLib["in"]('UUID', types)
      };
    }
  });

  /* $watch per pulire il campo record quando cancello il tipo */
  $scope.$watch('data.type_id', function (newValue, oldValue) {
    console.log(newValue, oldValue);
    if (newValue != oldValue) {
      $scope.data.record_id = [];
    }
  }, true);

  /*
   * Questi report devono chiaramente essere caricarti su Jasper.
   */

  $scope.printReport = function (reportName, extension, statusToPrint) {
    if (!$scope.data.from || !$scope.data.to) {
      toaster.pop('error', "Errore", 'Errore inserimento date: occorre inserire entrambe le date');
    } else {
      var reportNameByCommission = reportName + '_' + currentCommission.code;
      var response = jasperReport(reportNameByCommission, extension, statusToPrint); // provo il report specifico della commessa
      response.success(function (data, status, headers, config) {
        if (status == 204) {
          // se è vuoto, provo il report di default
          $log.warn('jasper report error with params report = ' + reportNameByCommission + ' and extension = ' + extension + ': trying with default report');
          jasperReport(reportName, extension, statusToPrint).success(function (data, status, headers, config) {
            if (status != 200) {
              toaster.pop('error', "Errore", 'Errore generazione report');
            }
          });
        }
      }).error(function (data, status, headers, config) {
        toaster.pop('error', "Errore", 'Errore generazione report');
      });
    }
  };
  function jasperReport(reportName, extension, statusToPrint) {
    var REPORT_URL = 'reports/EMMA/Asset/';
    extension = extension || 'pdf';
    var query = '';
    if (currentCommission.code) {
      query = query + '&commission=' + currentCommission.code;
    }
    if ($scope.data.type_id.UUID) {
      query = query + '&type=' + $scope.data.type_id.UUID;
    }
    if ($scope.data.record_id.length > 0) {
      query = query + '&record=' + getRecordList();
    }
    if ($scope.data.priority_id) {
      query = query + '&priority=' + getPriorityUUID();
    }
    if ($scope.data.odl_type.key) {
      query = query + '&odl_type=' + $scope.data.odl_type.key;
    }
    if ($scope.data.from) {
      query = query + '&from=' + $scope.data.from.toISOString();
    }
    if ($scope.data.to) {
      query = query + '&to=' + $scope.data.to.toISOString();
    }
    if (statusToPrint) {
      query = query + '&status=' + statusToPrint;
    }
    var reportNameToSave = reportName + '.' + extension;
    var reportPath = REPORT_URL + reportName + '.' + extension;
    $scope.generatedReport.name = reportNameToSave;
    $scope.generatedReport.extension = extension;
    var payload = {
      path: reportPath,
      query: query
    };
    var config = {
      responseType: 'arraybuffer'
    };
    var promise = $http.post(APP_URL + '/rest/report/generate', payload, config);
    promise.success(function (data, status, headers, config) {
      if (status == 200 && data) {
        $scope.generatedReport.data = new Uint8Array(data);
      }
    });
    return promise;
  }
  $scope.download = function () {
    var report = $scope.generatedReport;
    var options;
    if (report.extension == 'pdf') {
      options = {
        type: 'application/pdf'
      };
    } else if (report.extension == 'xls') {
      options = {
        type: 'application/vnd.ms-excel;'
      };
    }
    SaveAs.download(report.data, report.name, options);
  };
  function getRecordList() {
    var list = 'null';
    if ($scope.data.record_id.length > 0) {
      $scope.data.record_id.forEach(function (val, index) {
        if (index == 0) {
          list = val.UUID;
        } else {
          list = list + ',' + val.UUID;
        }
      });
    }
    return list;
  }
  function getPriorityUUID() {
    var uuid = 'null';
    if ($scope.data.priority_id) {
      uuid = $scope.data.priority_id.UUID;
    }
    return uuid;
  }
}]);
'use strict';

angular.module('emma.plan').service('consipWrapper', ["$log", "$injector", "$q", function ($log, $injector, $q) {
  var service = {};
  service.isPlafondEnabled = function () {
    if ($injector.has("contractFactory")) {
      return $injector.get("contractFactory")().recordByCommission().$promise.then(function (contract) {
        return contract && contract.model && contract.model.plafond && contract.model.plafond > 0;
      }, function (err) {
        $log.error(err);
        return $q.resolve(false);
      });
    }
    return $q.resolve(false);
  };
  service.getPlafondService = function () {
    if ($injector.has("plafondSrv")) {
      return $injector.get("plafondSrv");
    }
    $log.warn("Missing required service plafondSrv");
    return false;
  };
  service.getContract = function () {
    if ($injector.has("contractFactory")) {
      return $injector.get("contractFactory")().recordByCommission().$promise;
    }
    $log.warn("Missing required service contractFactory");
    return $q.reject("Missing required service contractFactory");
  };
  if ($injector.has('CONTRACT_TYPES')) {
    service.CONTRACT_TYPES = $injector.get('CONTRACT_TYPES');
  } else {
    service.CONTRACT_TYPES = {};
  }
  return service;
}]);
'use strict';

/**
 * @ngdoc factory
 * @name sixEmmaApp.invoiceConfiguration
 * @description
 * # invoiceConfiguration
 * Service in the sixEmmaApp.
 */
angular.module('emma.plan').service('invoiceConfiguration', ["invoiceFactory", function (invoiceFactory) {
  var self = this;
  var invoiceTypes = {
    "default": "Generica",
    "sanitaria": "Sanitaria"
  };
  var knownColumns = {
    'parents': 'Dettaglio alberatura',
    'model.asset.model.code': 'Codice Asset',
    'model.asset.model.description': 'Descrizione Asset',
    'asset_link': 'Link Asset',
    'model.formula.segment_days': 'Giorni calcolo',
    'model.formula.open_days': 'Aperture',
    'model.formula.closed_days': 'Chiusure',
    'model.asset.closures': 'Date chiusura',
    'model.row_reason': 'Stato Asset',
    'model.asset_variation': 'Variazioni Asset',
    'model.formula.um': 'Unità di misura',
    'model.formula.costo_standard': 'Costo standard',
    'model.formula.costo_standard_netto': 'Costo standard netto',
    'model.formula.sconto_perc': 'Sconto %',
    'model.formula.costo_netto': 'Costo netto'
  };
  this.getInvoiceTypes = function () {
    return invoiceTypes;
  };
  this.getDefaultColumns = function () {
    return knownColumns;
  };
  this.getConfiguration = function () {
    return invoiceFactory.getConfiguration().$promise.then(function (response) {
      return response;
    });
  };
  return this;
}]);
'use strict';

/**
 * @ngdoc factory
 * @name sixEmmaApp.issueToOdl
 * @description
 * # issueToOdl
 * Service in the sixEmmaApp.
 */
angular.module('emma.plan').service('issueToOdl', function () {
  var issueToOdl = {
    issueList: []
  };
  issueToOdl.push = function (obj) {
    this.issueList.push(obj);
  };
  issueToOdl.pop = function () {
    return this.issueList.pop();
  };
  return issueToOdl;
});
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.issueWorkflow
 * @description
 * # issueWorkflow
 * Service in the sixEmmaApp.
 */
angular.module('emma.plan').service('issueWorkflow', ['$q', 'issueFactory', 'workflowFactory', function ($q, issueFactory, workflowFactory) {
  var self = this;
  var workflowType = "issue";
  this.getReadableStatus = function (status) {
    //mantenuta per retrocompatibilità
    var statuses = {
      "OPEN": "Aperto",
      "ABORT": "Annullato",
      "IN_SERVICE": "In lavorazione",
      "SUSPENDED": "Sospeso",
      "CLOSED": "Chiuso"
    };
    if (statuses[status]) {
      return statuses[status];
    }
    return status;
  };
  this.getStatusMappings = function () {
    return workflowFactory.getWorkflowStatusMappings({
      id: workflowType
    }).$promise.then(function (response) {
      return response;
    });
  };
  this.getStatus = function (status) {
    return workflowFactory.getWorkflowStatus({
      id: workflowType,
      status: status
    }).$promise.then(function (response) {
      return response;
    });
  };
  this.getStatuses = function () {
    return workflowFactory.getWorkflowStatuses({
      id: workflowType
    }).$promise.then(function (response) {
      var statuses = [];
      if (response.list) {
        statuses = formatStatusList(response.list);
      }
      return statuses;
    });
  };
  this.getNextStatuses = function (currentStatus) {
    return workflowFactory.getWorkflowNextStatuses({
      id: workflowType,
      status: currentStatus
    }).$promise.then(function (response) {
      var statuses = [];
      if (response.list) {
        statuses = formatStatusList(response.list);
      }
      return statuses;
    });
  };
  this.setStatus = function (statusCode, issueObject) {
    return issueFactory('issue/record').setStatus({
      status: statusCode
    }, issueObject).$promise.then(function (response) {
      if (response.status == statusCode) {
        issueObject.status = response.status;
        issueObject.version = response.version;
        if (response.date_handling) {
          issueObject.date_handling = new Date(response.date_handling);
        }
        if (response.date_closing) {
          issueObject.date_closing = new Date(response.date_closing);
        }
        return issueObject;
      } else {
        throw 'StatusChangeError';
      }
    });
  };
  function formatStatusList(stringList) {
    //formatto il dato per retrocompatibilità
    var statuses = [];
    if (Array.isArray(stringList)) {
      stringList.forEach(function (status) {
        var item = {
          code: status,
          label: self.getReadableStatus(status),
          style: "neutral"
        };
        statuses.push(item);
      });
    }
    return statuses;
  }
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.odlWorkflow
 * @description
 * # odlWorkflow
 * Service in the sixEmmaApp.
 */
angular.module('emma.plan').service('odlWorkflow', ['$q', 'odlFactory', 'workflowFactory', function ($q, odlFactory, workflowFactory) {
  var self = this;
  this.getReadableStatus = function (status) {
    //mantenuta per retrocompatibilità
    var statuses = {
      "OPEN": "Aperto",
      "ABORT": "Annullato",
      "PRE_SERVICE": "In valutazione",
      "ESTIMATE_REQUESTED": "Preventivo richiesto",
      "ESTIMATE_PUBLISHED": "Preventivo pubblicato",
      "ESTIMATE_DENIED": "Preventivo rifiutato",
      "ESTIMATE_TO_BE_REVISED": "Richiesta revisione",
      "ESTIMATE_ACCEPTED": "Preventivo accettato",
      "ESTIMATE_SUSPENDED": "Preventivo sospeso",
      "IN_SERVICE": "In lavorazione",
      "SUSPENDED": "Sospeso",
      "DONE": "Eseguito",
      "CLOSED": "Chiuso",
      "ACCOUNTED": "In contabilità"
    };
    if (statuses[status]) {
      return statuses[status];
    }
    return status;
  };
  this.getStatusMappings = function () {
    return workflowFactory.getWorkflowStatusMappings({
      id: 'odl'
    }).$promise.then(function (response) {
      return response;
    });
  };
  this.getStatus = function (status) {
    return workflowFactory.getWorkflowStatus({
      id: 'odl',
      status: status
    }).$promise.then(function (response) {
      return response;
    });
  };
  this.getStatuses = function () {
    return workflowFactory.getWorkflowStatuses({
      id: 'odl'
    }).$promise.then(function (response) {
      var statuses = [];
      if (response.list) {
        statuses = formatStatusList(response.list);
      }
      return statuses;
    });
  };
  this.getNextStatuses = function (currentStatus) {
    return workflowFactory.getWorkflowNextStatuses({
      id: 'odl',
      status: currentStatus
    }).$promise.then(function (response) {
      var statuses = [];
      if (response.list) {
        statuses = formatStatusList(response.list);
      }
      return statuses;
    });
  };
  this.setStatus = function (statusCode, odlObject) {
    return odlFactory().setStatus({
      status: statusCode
    }, odlObject).$promise.then(function (response) {
      if (response.status == statusCode) {
        odlObject.status = response.status;
        odlObject.version = response.version;
        if (response.date_handling) {
          odlObject.date_handling = new Date(response.date_handling);
        }
        if (response.date_closing) {
          odlObject.date_closing = new Date(response.date_closing);
        }
        return odlObject;
      } else {
        throw 'StatusChangeError';
      }
    });
  };
  function formatStatusList(stringList) {
    //formatto il dato per retrocompatibilità
    var statuses = [];
    if (Array.isArray(stringList)) {
      stringList.forEach(function (status) {
        var item = {
          code: status,
          label: self.getReadableStatus(status),
          style: "neutral"
        };
        statuses.push(item);
      });
    }
    return statuses;
  }
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.planConfiguration
 * @description
 * # planConfiguration
 * Service in the sixEmmaApp.
 */
angular.module('emma.plan').service('planConfiguration', function () {
  //utilizzo uno schema cablato
  var schema = {
    "model": {
      "schema": {
        "type": "object",
        "title": "",
        "properties": {
          "code": {
            "title": "Codice",
            "type": "string"
          },
          "description": {
            "title": "Descrizione",
            "type": "string"
          },
          "service_id": {
            "format": "lookup",
            "title": "Servizio",
            "type": "string",
            "entity_id": "servizio"
          },
          "task_id": {
            "format": "lookup",
            "title": "Compito",
            "type": "string",
            "entity_id": "task"
          },
          "priority_id": {
            "format": "lookup",
            "title": "Priorità",
            "type": "string",
            "entity_id": "priorita"
          },
          "frequency": {
            "title": "Frequenza",
            "type": "string"
          },
          "frequency_day": {
            "title": "Giorno",
            "type": "string"
          },
          "model_type": {
            "format": "lookup",
            "title": "Elemento Tecnologico",
            "type": "string",
            "basePath": "schema",
            "entity_id": "schema"
          },
          "target_model_type": {
            "format": "lookup",
            "title": "Genera su genitore",
            "type": "string",
            "basePath": "schema",
            "entity_id": "schema"
          }
        },
        "required": ["code", "description", "service_id", "task_id", "priority_id", "frequency", "frequency_day", "model_type"]
      },
      "code": "plan",
      "description": "Programmata",
      "commissionDependent": true
    }
  };
  this.getSchema = function () {
    return schema;
  };
  var frequencies = {
    "week_1": {
      "label": "Settimanale",
      "repetition": "week"
    },
    "month_1": {
      "label": "Mensile",
      "repetition": "month"
    },
    "month_2": {
      "label": "Bimestrale",
      "repetition": "month"
    },
    "month_3": {
      "label": "Trimestrale",
      "repetition": "month"
    },
    "month_4": {
      "label": "Quadrimestrale",
      "repetition": "month"
    },
    "month_6": {
      "label": "Semestrale",
      "repetition": "month"
    },
    "year_1": {
      "label": "Annuale",
      "repetition": "year"
    },
    "year_2": {
      "label": "Biennale",
      "repetition": "year"
    },
    "year_3": {
      "label": "Triennale",
      "repetition": "year"
    },
    "year_4": {
      "label": "Quadriennale",
      "repetition": "year"
    },
    "year_5": {
      "label": "Quinquennale",
      "repetition": "year"
    },
    "year_6": {
      "label": "6 anni",
      "repetition": "year"
    }
  };
  var repetitions = {
    "week": {
      "dayOfWeek": ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT']
    },
    "month": {
      "dayOfMonth": [1, 15]
    },
    "year": {
      "dayOfMonth": [1, 15],
      "month": true
    }
  };
  this.getFrequencies = function () {
    return frequencies;
  };
  this.getFrequenciesByLabel = function () {
    var result = {};
    for (var key in frequencies) {
      result[frequencies[key].label.toLowerCase()] = {
        "key": key,
        "repetition": frequencies[key].repetition
      };
    }
    return result;
  };
  this.getRepetitions = function () {
    return repetitions;
  };
  return this;
});
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:QuestionsCtrl
 * @description
 * # QuestionsCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/question', {
    templateUrl: 'plan/survey/question_model_list.html',
    controller: 'QuestionConfCtrl'
  }).when('/question/:uuid', {
    templateUrl: 'plan/survey/question_model_detail.html',
    controller: 'QuestionConfCtrl'
  });
}]).controller('QuestionConfCtrl', ["$scope", "$routeParams", "$location", "$log", "$window", "uiGridConstants", "sixGridPaginationConstants", "questionFactory", "toaster", "authFactory", "dialogService", function ($scope, $routeParams, $location, $log, $window, uiGridConstants, sixGridPaginationConstants, questionFactory, toaster, authFactory, dialogService) {
  $scope.suppressToolbar = false;
  var VIEW_BASEPATH = 'question';

  /*********************
   * List
   *********************/

  $scope.list = {
    list: []
  };
  $scope.params = {
    pageNumber: 1,
    pageSize: 100,
    filters: {}
  };
  $scope.autoResizeParams = {
    enabled: true,
    minHeight: 200,
    marginTop: 290
  };
  $scope.gridAppCallbacks = {};
  $scope.viewGridOptions = {
    enableSorting: true,
    enableGridMenu: true,
    exporterCsvColumnSeparator: ';',
    exporterSuppressColumns: ['id'],
    exporterMenuPdf: false,
    enableFiltering: true,
    enableColumnResizing: true,
    paginationPageSizes: [100, 250, 500, 1000, 10000],
    paginationPageSize: 100,
    useExternalPagination: true,
    useExternalFiltering: true,
    multiSelect: true,
    enableRowHeaderSelection: true,
    enableRowSelection: true,
    enableHorizontalScrollbar: 1,
    columnDefs: [{
      name: ' '
    }]
  };
  $scope.getColumns = function () {
    $scope.viewGridOptions.columnDefs = [];
    $scope.viewGridOptions.columnDefs.push({
      displayName: '',
      field: 'search',
      width: 36,
      enableCellEdit: true,
      enableFiltering: false,
      enableSorting: false,
      pinnedLeft: true,
      cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/question/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' + '<i class="fa fa-search"></i>' + '</a>' + '</div>'
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Codice',
      field: 'model.code',
      enableFiltering: true,
      pinnedLeft: true,
      width: 120,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Descrizione',
      field: 'model.description',
      enableFiltering: true,
      width: 300,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Testo',
      field: 'model.text',
      enableFiltering: true,
      width: 800,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Tipo risposta',
      field: 'model.answerType.description',
      enableFiltering: true,
      width: 200,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
  };

  /**
   * List
   */
  $scope.getList = function () {
    if (!$scope.params.sortFields || $scope.params.sortFields.trim() == '') {
      $scope.params.sortFields = 'model.code:asc';
    }
    var payload = {
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      sort_fields: $scope.params.sortFields,
      show_revision: false
    };
    return questionFactory.search(payload, $scope.params.filters).$promise.then(function (data) {
      $scope.list.totalResults = data.totalResults;
      $scope.list.list = data.list;
      $scope.params.sixApi.refreshList(data.list);
      return data;
    })["catch"](function (err) {
      toaster.pop('error', 'Errore', 'Errore durante il recupero dei dati');
    });
  };

  /**
   * Navigation
   */
  $scope.goToList = function () {
    $location.path(VIEW_BASEPATH);
  };

  /*********************
   * Detail
   *********************/

  $scope.uuid;
  $scope.newData = function () {
    $location.path(VIEW_BASEPATH + '/new');
  };

  /*********************
   * Main
   *********************/

  if ($routeParams.uuid) {
    $scope.uuid = $routeParams.uuid;
  } else {
    $scope.getColumns();
    // $scope.getList();
    setTimeout(function () {
      if ($scope.params.sixApi) {
        $scope.params.sixApi.restoreState();
      }
    }, 500);
  }

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'question';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
  $scope.searchAllPermAllowed = function () {
    return authFactory.checkPerm(RESOURCE_NAME, 'SEARCH_ALL');
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:QuestionsCtrl
 * @description
 * # QuestionsCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/survey/resp', {
    templateUrl: 'plan/survey/survey_list.html',
    controller: 'SurveyCtrl'
  }).when('/survey/resp/:uuid', {
    templateUrl: 'plan/survey/survey_detail.html',
    controller: 'SurveyCtrl'
  }).when('/survey/resp/source/:uuid', {
    templateUrl: 'plan/survey/survey_detail.html',
    controller: 'SurveyCtrl',
    resolve: {
      // http://stackoverflow.com/questions/12524533/can-angularjs-routes-have-default-parameter-values
      type: ['$route', function ($route) {
        $route.current.params["new"] = true; // forzo il parametro di route :new a true
      }]
    }
  });
}]).controller('SurveyCtrl', ["$scope", "$routeParams", "$location", "$log", "$window", "uiGridConstants", "sixGridPaginationConstants", "surveyFactory", "toaster", "authFactory", "dialogService", function ($scope, $routeParams, $location, $log, $window, uiGridConstants, sixGridPaginationConstants, surveyFactory, toaster, authFactory, dialogService) {
  var MODEL_TYPE = 'survey';
  var TYPE = 'response';
  var VIEW_BASEPATH = 'survey/resp';

  /*********************
   * List
   *********************/

  $scope.list = {
    list: []
  };
  $scope.params = {
    pageNumber: 1,
    pageSize: 100,
    filters: {}
  };
  $scope.autoResizeParams = {
    enabled: true,
    minHeight: 200,
    marginTop: 290
  };
  $scope.gridAppCallbacks = {};
  $scope.viewGridOptions = {
    enableSorting: true,
    enableGridMenu: true,
    exporterCsvColumnSeparator: ';',
    exporterSuppressColumns: ['id'],
    exporterMenuPdf: false,
    enableFiltering: true,
    enableColumnResizing: true,
    paginationPageSizes: [100, 250, 500, 1000, 10000],
    paginationPageSize: 100,
    useExternalPagination: true,
    useExternalFiltering: true,
    multiSelect: true,
    enableRowHeaderSelection: true,
    enableRowSelection: true,
    enableHorizontalScrollbar: 1,
    columnDefs: [{
      name: ' '
    }]
  };
  $scope.getColumns = function () {
    $scope.viewGridOptions.columnDefs = [];
    $scope.viewGridOptions.columnDefs.push({
      displayName: '',
      field: 'search',
      width: 36,
      enableCellEdit: true,
      enableFiltering: false,
      enableSorting: false,
      pinnedLeft: true,
      cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/survey/resp/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' + '<i class="fa fa-search"></i>' + '</a>' + '</div>'
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Codice',
      field: 'model.code',
      enableFiltering: true,
      pinnedLeft: true,
      width: 120,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Data risposta',
      field: 'dataIn',
      type: 'date',
      cellFilter: 'date:\'dd/MM/yyyy\'',
      width: 100,
      enableFiltering: true,
      filters: [{
        type: sixGridPaginationConstants.filterType.DATE,
        relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
        placeholder: 'da...',
        condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
      }, {
        type: sixGridPaginationConstants.filterType.DATE,
        relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
        placeholder: 'a...',
        condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Descrizione',
      field: 'model.description',
      enableFiltering: true,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Testo',
      field: 'model.text',
      enableFiltering: true,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Tipo risposta',
      field: 'model.answerType.description',
      enableFiltering: true,
      width: 200,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
  };

  /**
   * List
   */
  $scope.getList = function () {
    if (!$scope.params.sortFields || $scope.params.sortFields.trim() == '') {
      $scope.params.sortFields = 'model.code:asc';
    }
    var payload = {
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      sort_fields: $scope.params.sortFields,
      show_revision: false
    };
    return surveyFactory(TYPE).search(payload, $scope.params.filters).$promise.then(function (data) {
      $scope.list.totalResults = data.totalResults;
      $scope.list.list = data.list;
      $scope.params.sixApi.refreshList(data.list);
      return data;
    })["catch"](function (err) {
      toaster.pop('error', 'Errore', 'Errore durante il recupero dei dati');
    });
  };

  /**
   * Navigation
   */
  $scope.goToList = function () {
    $location.path(VIEW_BASEPATH);
  };
  $scope.goBack = function () {
    $window.history.back();
  };

  /*********************
   * Detail
   *********************/

  function emptyData() {
    $scope.data = {
      model: {
        categories: [{
          code: 1,
          description: 'Categoria 1',
          questions: []
        }]
      }
    };
    $scope.data.model.absmin = 0; // punteggio minimo ottenibile da tutte le domande di questo sondaggio
    $scope.data.model.absmax = 0; // punteggio massimo ottenibile da tutte le domande di questo sondaggio
  }

  /**
   * Save or update
   */
  $scope.save = function () {
    if (angular.isUndefined($scope.data)) {
      toaster.pop('error', 'Questionario non compilato', 'Prima di procedere compilare il questionario');
      return;
    }
    var promise;
    if ($scope.data.version) {
      // update
      $scope.data.model.is_new = false;
      promise = surveyFactory(TYPE).update({
        id: $scope.data.version,
        history: true
      }, $scope.data).$promise;
    } else {
      // create
      promise = surveyFactory(TYPE).create({
        history: true,
        commission_dependent: true
      }, $scope.data.model).$promise;
    }
    promise.then(function (resp) {
      // success
      toaster.pop('success', 'Salvataggio riuscito', 'Salvataggio eseguito correttamente');
      $scope.data = resp;
    })["catch"](function (err) {
      // error
      toaster.pop('error', 'Errore salvataggio', 'Errore durante il salvataggio');
    });
  };

  /**
   * Delete
   * @param idToDelete
   */
  $scope["delete"] = function (idToDelete) {
    surveyFactory(TYPE).referenceCount({
      id: $scope.data.UUID
    }).$promise.then(function (response) {
      var deleteMessage = 'Eliminare il questionario?';
      if (response.count != 0) {
        deleteMessage = 'Il questionario che stai eliminando è in uso nel sistema.<br> Vuoi eliminarlo comunque?';
      }
      dialogService.confirmDialog(deleteMessage, function () {
        $log.info('deleting id:' + idToDelete);
        surveyFactory(TYPE)["delete"]({
          id: idToDelete
        }).$promise.then(function () {
          // success
          toaster.pop('success', 'Eliminazione riuscita', 'Eliminazione eseguita con successo');
          $scope.goBack();
        })["catch"](function () {
          // error
          toaster.pop('error', 'Errore eliminazione', 'Errore durante l\'eliminazione');
        });
      });
    });
  };

  /**
   * Get data
   * @param uuid
   */
  $scope.getData = function (uuid) {
    surveyFactory(TYPE).getByUuid({
      uuid: uuid,
      param1: '_current'
    }).$promise.then(function (response) {
      if (response && response.model) {
        $scope.data = response;
      }
    })["catch"](function (err) {
      toaster.pop('error', 'Errore', 'Errore durante il recupero dei dati');
    });
  };

  /**
   * Get source
   * @param uuid
   */
  $scope.getModel = function (uuid) {
    surveyFactory(MODEL_TYPE).getByUuid({
      uuid: uuid
    }).$promise.then(function (response) {
      if (response && response.list && response.list.length > 0) {
        $scope.data = response.list[0];
        delete $scope.data.version;
        delete $scope.data.UUID;
      }
    })["catch"](function (err) {
      toaster.pop('error', 'Errore', 'Errore durante il recupero dei dati');
    });
  };

  /*********************
   * Main
   *********************/

  if ($routeParams["new"]) {
    $scope.getModel($routeParams.uuid);
  } else if ($routeParams.uuid) {
    $scope.getData($routeParams.uuid);
  } else {
    $scope.getColumns();
    // $scope.getList();
    setTimeout(function () {
      if ($scope.params.sixApi) {
        $scope.params.sixApi.restoreState();
      }
    }, 500);
  }

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'respond';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
  $scope.searchAllPermAllowed = function () {
    return authFactory.checkPerm(RESOURCE_NAME, 'SEARCH_ALL');
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:SurveysCtrl
 * @description
 * # SurveysCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/survey/model', {
    templateUrl: 'plan/survey/survey_model_list.html',
    controller: 'SurveyModelCtrl'
  }).when('/survey/model/:uuid', {
    templateUrl: 'plan/survey/survey_model_detail.html',
    controller: 'SurveyModelCtrl'
  });
}]).controller('SurveyModelCtrl', ["$scope", "$routeParams", "$location", "$log", "$window", "uiGridConstants", "sixGridPaginationConstants", "surveyFactory", "toaster", "authFactory", "dialogService", "$timeout", function ($scope, $routeParams, $location, $log, $window, uiGridConstants, sixGridPaginationConstants, surveyFactory, toaster, authFactory, dialogService, $timeout) {
  var TYPE = 'survey';
  var VIEW_BASEPATH = 'survey/model';

  /*********************
   * List
   *********************/

  $scope.list = {
    list: []
  };
  $scope.params = {
    pageNumber: 1,
    pageSize: 100,
    filters: {}
  };
  $scope.autoResizeParams = {
    enabled: true,
    minHeight: 200,
    marginTop: 290
  };
  $scope.gridAppCallbacks = {};
  $scope.viewGridOptions = {
    enableSorting: true,
    enableGridMenu: true,
    exporterCsvColumnSeparator: ';',
    exporterSuppressColumns: ['id'],
    exporterMenuPdf: false,
    enableFiltering: true,
    enableColumnResizing: true,
    paginationPageSizes: [100, 250, 500, 1000, 10000],
    paginationPageSize: 100,
    useExternalPagination: true,
    useExternalFiltering: true,
    multiSelect: true,
    enableRowHeaderSelection: true,
    enableRowSelection: true,
    enableHorizontalScrollbar: 1,
    columnDefs: [{
      name: ' '
    }]
  };
  $scope.getColumns = function () {
    $scope.viewGridOptions.columnDefs = [];
    $scope.viewGridOptions.columnDefs.push({
      displayName: '',
      field: 'search',
      width: 36,
      enableCellEdit: true,
      enableFiltering: false,
      enableSorting: false,
      pinnedLeft: true,
      cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/survey/model/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' + '<i class="fa fa-search"></i>' + '</a>' + '</div>'
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Codice',
      field: 'model.code',
      enableFiltering: true,
      pinnedLeft: true,
      width: 120,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Descrizione',
      field: 'model.description',
      enableFiltering: true,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: '',
      field: 'search',
      width: 36,
      enableCellEdit: true,
      enableFiltering: false,
      enableSorting: false,
      pinnedRight: true,
      cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/survey/resp/source/{{row.entity.UUID}}" class="btn btn-xs btn-primary" title="Rispondi">' + '<i class="fa fa-check-square-o"></i>' + '</a>' + '</div>'
    });
  };

  /**
   * List
   */
  $scope.getList = function () {
    var payload = {
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      sort_fields: $scope.params.sortFields,
      show_revision: false
    };
    return surveyFactory(TYPE).search(payload, $scope.params.filters).$promise.then(function (data) {
      $scope.list.totalResults = data.totalResults;
      $scope.list.list = data.list;
      $scope.params.sixApi.refreshList(data.list);
      return data;
    })["catch"](function (err) {
      toaster.pop('error', 'Errore', 'Errore durante il recupero dei dati');
    });
  };

  /**
   * Navigation
   */
  $scope.goToList = function () {
    $location.path(VIEW_BASEPATH);
  };

  /*********************
   * Detail
   *********************/

  $scope.question = {};
  emptyData();
  function emptyData() {
    $scope.data = {
      model: {
        categories: [{
          code: 1,
          description: 'Categoria 1',
          questions: []
        }]
      }
    };
    $scope.data.model.absmin = 0; // punteggio minimo ottenibile da tutte le domande di questo sondaggio
    $scope.data.model.absmax = 0; // punteggio massimo ottenibile da tutte le domande di questo sondaggio
  }

  /**
   * Save or update
   */
  $scope.save = function () {
    if (angular.isUndefined($scope.data)) {
      toaster.pop('error', 'Domanda non compilata', 'Prima di procedere compilare la domanda');
      return;
    }
    var promise;
    if ($scope.data.version) {
      // update
      promise = surveyFactory(TYPE).update({
        id: $scope.data.version,
        history: false
      }, $scope.data).$promise;
    } else {
      // create
      promise = surveyFactory(TYPE).create({
        history: false,
        commission_dependent: false
      }, $scope.data.model).$promise;
    }
    promise.then(function (resp) {
      // success
      toaster.pop('success', 'Salvataggio riuscito', 'Salvataggio eseguito correttamente');
      $scope.data = resp;
    })["catch"](function (err) {
      // error
      toaster.pop('error', 'Errore salvataggio', 'Errore durante il salvataggio');
    });
  };

  /**
   * Delete
   * @param idToDelete
   */
  $scope["delete"] = function (idToDelete) {
    surveyFactory(TYPE).referenceCount({
      id: $scope.data.UUID
    }).$promise.then(function (response) {
      var deleteMessage = 'Eliminare il questionario?';
      if (response.count != 0) {
        deleteMessage = 'Il questionario che stai eliminando è in uso nel sistema.<br> Vuoi eliminarlo comunque?';
      }
      dialogService.confirmDialog(deleteMessage, function () {
        $log.info('deleting id:' + idToDelete);
        surveyFactory(TYPE)["delete"]({
          id: idToDelete
        }).$promise.then(function () {
          // success
          toaster.pop('success', 'Eliminazione riuscita', 'Eliminazione eseguita con successo');
        })["catch"](function () {
          // error
          toaster.pop('error', 'Errore eliminazione', 'Errore durante l\'eliminazione');
        });
      });
    });
  };

  /**
   * Get data
   * @param uuid
   */
  $scope.getData = function (uuid) {
    if (uuid == 'new') {
      // new survey (=> empty data)
      emptyData();
    } else {
      surveyFactory(TYPE).getByUuid({
        uuid: uuid
      }).$promise.then(function (response) {
        if (response && response.list && response.list.length > 0) {
          $scope.data = response.list[0];
        }
      })["catch"](function (err) {
        toaster.pop('error', 'Errore', 'Errore durante il recupero dei dati');
      });
    }
  };
  $scope.newData = function () {
    $location.path(VIEW_BASEPATH + '/new');
  };
  function _updateAbsMinMax() {
    $scope.data.model.absmin = 0;
    $scope.data.model.absmax = 0;
    $scope.data.model.categories.forEach(function (c) {
      $scope.data.model.absmin += c.absmin;
      $scope.data.model.absmax += c.absmax;
    });
  }

  /**************************
   * Categories
   **************************/

  $scope.newCategory = function () {
    var code = 0;
    if (!$scope.data.model.categories) {
      $scope.data.model.categories = [];
    }
    code = Math.max.apply(Math, $scope.data.model.categories.map(function (c) {
      return c.code;
    })) + 1;
    var cat = {
      code: code,
      description: 'Categoria ' + code,
      questions: [],
      _focus: true
    };
    $scope.data.model.categories.push(cat);
    $timeout(function () {
      var newCatElem = angular.element(document.getElementById('cat' + cat.code));
      newCatElem.addClass('highlight-cat');
    }, 100);
  };
  $scope.removeCategory = function (cat) {
    if (!$scope.data.model.categories) {
      $scope.data.model.categories = [];
    }
    var index = $scope.data.model.categories.indexOf(cat);
    if (~index) {
      $scope.data.model.categories.splice(index, 1);
    }
  };
  $scope.onCategoryChange = function (cat) {
    _updateAbsMinMax();
  };

  /*********************
   * Main
   *********************/

  if ($routeParams.uuid) {
    $scope.getData($routeParams.uuid);
  } else {
    $scope.getColumns();
    // $scope.getList();
    setTimeout(function () {
      if ($scope.params.sixApi) {
        $scope.params.sixApi.restoreState();
      }
    }, 500);
  }

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'survey';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
  $scope.searchAllPermAllowed = function () {
    return authFactory.checkPerm(RESOURCE_NAME, 'SEARCH_ALL');
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:SurveysConfCtrl
 * @description
 * # SurveysConfCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/survey/conf', {
    templateUrl: 'plan/survey/survey_conf_list.html',
    controller: 'SurveysConfCtrl'
  }).when('/survey/conf/:uuid', {
    templateUrl: 'plan/survey/survey_conf_detail.html',
    controller: 'SurveysConfCtrl'
  });
}]).controller('SurveysConfCtrl', ["$scope", "$routeParams", "$location", "$log", "$window", "uiGridConstants", "sixGridPaginationConstants", "surveyFactory", "toaster", "authFactory", "dialogService", "$timeout", function ($scope, $routeParams, $location, $log, $window, uiGridConstants, sixGridPaginationConstants, surveyFactory, toaster, authFactory, dialogService, $timeout) {
  var TYPE = 'config';
  var VIEW_BASEPATH = 'survey/conf';
  var currentCommission = authFactory.getAuthData().info.commissions.current;

  /*********************
   * List
   *********************/

  $scope.list = {
    list: []
  };
  $scope.params = {
    pageNumber: 1,
    pageSize: 100,
    filters: {}
  };
  $scope.autoResizeParams = {
    enabled: true,
    minHeight: 200,
    marginTop: 290
  };
  $scope.gridAppCallbacks = {};
  $scope.viewGridOptions = {
    enableSorting: true,
    enableGridMenu: true,
    exporterCsvColumnSeparator: ';',
    exporterSuppressColumns: ['id'],
    exporterMenuPdf: false,
    enableFiltering: true,
    enableColumnResizing: true,
    paginationPageSizes: [100, 250, 500, 1000, 10000],
    paginationPageSize: 100,
    useExternalPagination: true,
    useExternalFiltering: true,
    multiSelect: true,
    enableRowHeaderSelection: true,
    enableRowSelection: true,
    enableHorizontalScrollbar: 1,
    columnDefs: [{
      name: ' '
    }]
  };
  $scope.getColumns = function () {
    $scope.viewGridOptions.columnDefs = [];
    $scope.viewGridOptions.columnDefs.push({
      displayName: '',
      field: 'search',
      width: 36,
      enableCellEdit: true,
      enableFiltering: false,
      enableSorting: false,
      pinnedLeft: true,
      cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/survey/conf/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' + '<i class="fa fa-search"></i>' + '</a>' + '</div>'
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Codice',
      field: 'model.code',
      enableFiltering: true,
      pinnedLeft: true,
      width: 120,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Descrizione',
      field: 'model.description',
      enableFiltering: true,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
  };

  /**
   * List
   */
  $scope.getList = function () {
    var payload = {
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      sort_fields: $scope.params.sortFields,
      show_revision: false
    };
    return surveyFactory(TYPE).search(payload, $scope.params.filters).$promise.then(function (data) {
      $scope.list.totalResults = data.totalResults;
      $scope.list.list = data.list;
      $scope.params.sixApi.refreshList(data.list);
      return data;
    })["catch"](function (err) {
      toaster.pop('error', 'Errore', 'Errore durante il recupero dei dati');
    });
  };

  /**
   * Navigation
   */
  $scope.goToList = function () {
    $location.path(VIEW_BASEPATH);
  };

  /*********************
   * Detail
   *********************/

  $scope.recordTypes = [{
    key: 'issue',
    description: 'Segnalazione'
  }, {
    key: 'odl',
    description: 'ODL'
  }];
  $scope.showOptions = {
    web: true,
    app: true
  };
  emptyData();
  function emptyData() {
    $scope.data = {
      commission: currentCommission.code,
      model: {
        code: currentCommission.code,
        description: 'Configurazione questionario comm. ' + currentCommission.code,
        rows: [{
          code: 0
        }]
      }
    };
  }

  /**
   * Save or update
   */
  $scope.save = function () {
    if (angular.isUndefined($scope.data)) {
      toaster.pop('error', 'Configurazione non compilata', 'Prima di procedere completare la configurazione');
      return;
    } else {
      if ($scope.showOptions.web || $scope.showOptions.app) {
        $scope.data.model["showOptions"] = $scope.showOptions;
      } else {
        toaster.pop('error', 'Configurazione non completa', 'Selezionare almeno un\'opzione tra \'web\' e \'app\'');
        return;
      }
    }
    var promise;
    if ($scope.data.version) {
      // update
      promise = surveyFactory(TYPE).update({
        id: $scope.data.version,
        history: false
      }, $scope.data).$promise;
    } else {
      // create
      promise = surveyFactory(TYPE).create({
        history: false,
        commission_dependent: true
      }, $scope.data.model).$promise;
    }
    promise.then(function (resp) {
      // success
      toaster.pop('success', 'Salvataggio riuscito', 'Salvataggio eseguito correttamente');
      $scope.data = resp;
    })["catch"](function (err) {
      // error
      toaster.pop('error', 'Errore salvataggio', 'Errore durante il salvataggio');
    });
  };

  /**
   * Delete
   * @param idToDelete
   */
  $scope["delete"] = function (idToDelete) {
    surveyFactory(TYPE).referenceCount({
      id: $scope.data.UUID
    }).$promise.then(function (response) {
      var deleteMessage = 'Eliminare la configurazione?';
      if (response.count != 0) {
        deleteMessage = 'La configurazione che stai eliminando è in uso nel sistema.<br> Vuoi eliminarla comunque?';
      }
      dialogService.confirmDialog(deleteMessage, function () {
        $log.info('deleting id:' + idToDelete);
        surveyFactory(TYPE)["delete"]({
          id: idToDelete
        }).$promise.then(function () {
          // success
          toaster.pop('success', 'Eliminazione riuscita', 'Eliminazione eseguita con successo');
          $scope.goToList();
        })["catch"](function () {
          // error
          toaster.pop('error', 'Errore eliminazione', 'Errore durante l\'eliminazione');
        });
      });
    });
  };

  /**
   * Get data
   * @param uuid
   */
  $scope.getData = function (uuid) {
    if (uuid == 'new') {
      // new survey (=> empty data)
      emptyData();
    } else {
      surveyFactory(TYPE).getByUuid({
        uuid: uuid
      }).$promise.then(function (response) {
        if (response && response.list && response.list.length > 0) {
          $scope.data = response.list[0];
          $scope.showOptions = angular.copy($scope.data.model.showOptions);
        }
      })["catch"](function (err) {
        toaster.pop('error', 'Errore', 'Errore durante il recupero dei dati');
      });
    }
  };
  $scope.newData = function () {
    $location.path(VIEW_BASEPATH + '/new');
  };
  $scope.newRow = function () {
    var code = 0;
    if (!$scope.data.model.rows) {
      $scope.data.model.rows = [];
    }
    code = Math.max.apply(Math, $scope.data.model.rows.map(function (r) {
      return r.code;
    })) + 1;
    var row = {
      code: code
    };
    $scope.data.model.rows.push(row);
    $timeout(function () {
      var newRow = angular.element(document.getElementById('row' + row.code));
      newRow.addClass('highlight-row');
    }, 100);
  };
  $scope.removeRow = function (row) {
    if (!$scope.data.model.rows) {
      $scope.data.model.rows = [];
    }
    var index = $scope.data.model.rows.indexOf(row);
    if (~index) {
      $scope.data.model.rows.splice(index, 1);
    }
  };

  /*********************
   * Main
   *********************/

  if ($routeParams.uuid) {
    $scope.getData($routeParams.uuid);
  } else {
    $scope.getColumns();
    // $scope.getList();
    setTimeout(function () {
      if ($scope.params.sixApi) {
        $scope.params.sixApi.restoreState();
      }
    }, 500);
  }

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'survey';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
  $scope.searchAllPermAllowed = function () {
    return authFactory.checkPerm(RESOURCE_NAME, 'SEARCH_ALL');
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:TaskCtrl
 * @description
 * # TaskCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/task/detail', {
    templateUrl: 'plan/task/task_detail.html',
    controller: 'TaskCtrl'
  }).when('/task/detail/:id', {
    templateUrl: 'plan/task/task_detail.html',
    controller: 'TaskCtrl'
  });
}]).controller('TaskCtrl', ["$scope", "taskFactory", "activityFactory", "$log", "$routeParams", "$location", "$window", "toaster", "authFactory", "dialogService", function ($scope, taskFactory, activityFactory, $log, $routeParams, $location, $window, toaster, authFactory, dialogService) {
  $scope.isSidebarOpened = false;
  var sidebar = angular.element(document.getElementById('list-sidebar'));
  var overlay = angular.element(document.getElementsByClassName('list-sidebar-overlay')[0]);
  var centerPage = angular.element(document.getElementsByClassName('center-page')[0]);
  $scope.taskActivitiesId = [];
  $scope.taskActivities = []; // Panel
  $scope.availableActivities = []; // Sidebar
  $scope.addCheckModel = [];
  $scope.remCheckModel = [];
  $scope.filteredActivities = [];
  $scope.newTask = true;
  $scope.task = {
    model: {
      attachments: []
    }
  };
  $scope.activityFilter = "";
  $scope.description = "";

  // Gestione allegati
  $scope.attachments = [];
  function readAttachments(modelList) {
    $scope.attachments.splice(0, $scope.attachments.length);
    if (modelList) {
      for (var i = 0; i < modelList.length; i++) {
        $scope.attachments.push(modelList[i]);
      }
    }
  }
  function writeAttachments(modelList) {
    modelList.splice(0, modelList.length);
    for (var i = 0; i < $scope.attachments.length; i++) {
      modelList.push($scope.attachments[i]);
    }
  }
  $scope.updAttachments = function () {
    writeAttachments($scope.task.model.attachments);
    taskFactory.updateTask({
      id: $scope.task.model.code
    }, $scope.task).$promise.then(function (response) {
      if (response.version) {
        $scope.task.version = response.version;
      }
    });
  };
  function invalidateTaskActivities() {
    var task;
    $scope.taskActivitiesId = [];
    for (var i = 0; i < $scope.taskActivities.length; i++) {
      task = $scope.taskActivities[i];
      $scope.taskActivitiesId.push(task.UUID);
    }
  }
  $scope.isDisabledActivity = function (UUID) {
    var result;
    if ($scope.taskActivitiesId.indexOf(UUID) == -1) {
      result = false;
    } else {
      result = true;
    }
    return result;
  };
  $scope.selectActivity = function () {
    $scope.openSidebar();
    if ($scope.availableActivities.length == 0) {
      $scope.loadActivities();
    }
    invalidateTaskActivities();
  };
  $scope.removeActivity = function () {
    var count = $scope.remCheckModel.length;
    var removed = 0;
    for (var i = 0; i < $scope.remCheckModel.length; i++) {
      if ($scope.remCheckModel[i]) {
        $scope.taskActivities.splice(i - removed, 1);
        removed++;
      }
    }
    count -= removed;
    initRemCheckModel(count);
  };
  $scope.confirmSelectActivities = function () {
    $scope.closeSidebar();
    for (var i = 0; i < $scope.addCheckModel.length; i++) {
      if ($scope.addCheckModel[i]) {
        var r = $scope.filteredActivities[i];
        if ($scope.taskActivities.indexOf(r) == -1) {
          $scope.taskActivities.push(r);
        }
      }
    }
    initRemCheckModel();
  };
  function initAddCheckModel(length) {
    $scope.addCheckModel = [];
    for (var i = 0; i < length; i++) {
      $scope.addCheckModel.push(false);
    }
  }
  function initRemCheckModel(length) {
    $scope.remCheckModel = [];
    for (var i = 0; i < length; i++) {
      $scope.remCheckModel.push(false);
    }
  }
  $scope.loadActivities = function () {
    activityFactory.getActivitiesList({
      page_size: 10000,
      page: 1
    }).$promise.then(function (data) {
      $scope.availableActivities = data.list;
      initAddCheckModel($scope.availableActivities.length);
    });
  };
  $scope.toggleSidebar = function () {
    if ($scope.isSidebarOpened) {
      $scope.closeSidebar();
    } else {
      $scope.openSidebar();
    }
  };
  $scope.closeSidebar = function () {
    sidebar.removeClass('open');
    centerPage.removeClass('center-open');
    $scope.isSidebarOpened = false;
    if ((sidebar.hasClass('list-sidebar-fixed-left') || sidebar.hasClass('list-sidebar-fixed-right')) && sidebar.hasClass('open')) {
      overlay.addClass('active');
    } else {
      overlay.removeClass('active');
    }
  };
  $scope.openSidebar = function () {
    initAddCheckModel();
    sidebar.addClass('open');
    centerPage.addClass('center-open');
    $scope.isSidebarOpened = true;
    if ((sidebar.hasClass('list-sidebar-fixed-left') || sidebar.hasClass('list-sidebar-fixed-right')) && sidebar.hasClass('open')) {
      overlay.addClass('active');
    } else {
      overlay.removeClass('active');
    }
  };
  $scope.refreshDescription = function (description) {
    if (description) {
      $scope.task.model.description = angular.copy(description);
    }
  };
  function fillActivitiesList() {
    $scope.task.model.activities = [];
    for (var i = 0; i < $scope.taskActivities.length; i++) {
      var activity = $scope.taskActivities[i];
      var ref;
      if (angular.isDefined(activity.model)) {
        ref = sixObjectLib.recordToHisRef($scope.taskActivities[i]);
      } else {
        ref = activity;
      }
      $scope.task.model.activities.push(ref);
    }
  }
  $scope.saveForm = function () {
    if ($scope.task.model.code && $scope.task.model.description) {
      fillActivitiesList();
      if ($scope.task.version) {
        taskFactory.updateTask({
          id: $scope.task.model.code
        }, $scope.task).$promise.then(function () {
          $window.history.back();
        });
      } else {
        writeAttachments($scope.task.model.attachments);
        taskFactory.saveTask({
          commissionDependent: true
        }, $scope.task.model).$promise.then(function () {
          $window.history.back();
        });
      }
    } else {
      toaster.pop('error', 'Errore', 'Descrizione obbligatoria');
    }
  };
  $scope.getTaskByUUID = function (id) {
    taskFactory.getTaskByUUID({
      uuid: id
    }).$promise.then(function (data) {
      $scope.task = data;
      $log.info(data);
      $scope.description = $scope.task.model.description;
      readAttachments($scope.task.model.attachments);
      for (var i = 0; i < $scope.task.model.activities.length; i++) {
        $scope.taskActivities.push($scope.task.model.activities[i]);
      }
    });
  };
  $scope["delete"] = function (version) {
    taskFactory.referenceCount({
      id: $scope.task.UUID
    }).$promise.then(function (response) {
      var deleteMessage = 'Eliminare il compito "' + $scope.task.model.code + '"?';
      if (response.count != 0) {
        var deleteMessage = 'Il compito: "' + $scope.task.model.code + '"' + ' è in uso nel sistema.<br> Vuoi rimuoverlo comunque?';
      }
      dialogService.confirmDialog(deleteMessage, function () {
        taskFactory.deleteTask({
          id: version
        }).$promise.then(function () {
          $window.history.back();
        });
      });
    });
  };
  $(document).ready(function () {
    $('.list-sidebar-overlay').on('click', function () {
      $(this).removeClass('active');
      $('#list-sidebar').removeClass('open');
    });
  });

  //___ main ___
  if ($routeParams.id) {
    if ($routeParams.id != 'new') {
      $scope.getTaskByUUID($routeParams.id);
    }
  }

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'task';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:TaskganttCtrl
 * @description
 * # TaskganttCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/task/gantt', {
    templateUrl: 'plan/task/task_gantt.html',
    controller: 'TaskGanttCtrl'
  });
}]).controller('TaskGanttCtrl', ["$scope", "$log", "$filter", "$location", "$window", "taskFactory", "authFactory", "localStorageService", "modelIconService", "toaster", function ($scope, $log, $filter, $location, $window, taskFactory, authFactory, localStorageService, modelIconService, toaster) {
  $scope.opt = {
    open: false,
    viewScale: "day",
    fromDate: new Date(),
    toDate: new Date(),
    filterRow: '',
    assetFilter: {}
  };
  $scope.opt.toDate.setDate($scope.opt.toDate.getDate() + 30);
  $scope.ganttFromDate = $scope.opt.fromDate;
  $scope.ganttToDate = $scope.opt.toDate;
  if (localStorageService.get('taskgantt.gantt_options')) {
    var tmp = localStorageService.get('taskgantt.gantt_options');
    var fromStr = '' + tmp.fromDate;
    var toStr = '' + tmp.toDate;
    tmp.fromDate = new Date(fromStr);
    tmp.toDate = new Date(toStr);
    $scope.opt = tmp;
  }
  $scope.commissionCode = authFactory.getAuthData().info.commissions.current.code;
  $scope.tooltipContent = '<strong>{{task.model.description}}</strong></br>' + '{{task.model.status}}<br/>' + '<small>' + '{{getFromLabel()}}' + '</small>';
  $scope.treeContent = '<div title="{{row.model.entity}}">' + '<span ng-if="row.model.children" class="gantt-tree-handle glyphicon" ng-class="{ \'glyphicon-chevron-right\': collapsed, \'glyphicon-chevron-down\': !collapsed, \'gantt-tree-collapsed\': collapsed, \'gantt-tree-expanded\': !collapsed}"></span>&nbsp&nbsp' + '<span class="entity-icon hidden text-info-dker">{{row.model.entity}}</span> ' + '{{row.model.name}}</div>';
  $scope.options = {};
  $scope.visibleRows = [];
  $scope.parentRows = [];
  $scope.registerApi = function (api) {
    $scope.api = api;
    api.core.on.ready($scope, function () {
      // Call API methods and register events.
    });
    api.directives.on["new"]($scope, function (directiveName, directiveScope, element) {
      if (directiveName === 'ganttTask' && directiveScope.task.model.status !== 'INFO') {
        element.bind('click', function (event) {
          event.stopPropagation();
          taskClickEvent('task-click', directiveScope.task);
        });
      }
      if (directiveName === 'ganttRowLabel' && directiveScope.$parent.childrenRows !== undefined) {
        element.bind('click', function (event) {
          event.stopPropagation();
          rowLabelClickEvent('rowlabel-click', directiveScope.row);
        });
      }
    });
  };

  // Event handler
  var taskClickEvent = function taskClickEvent(eventName, task) {
    $window.open("#/odl/" + task.model.id, '_blank');
    $scope.$apply();
  };
  var rowLabelClickEvent = function rowLabelClickEvent(eventName, row) {
    $scope.collapseAll();
    if (row._collapsed == true) {
      $scope.api.tree.expand(row.model.id);
    }
    $scope.getGanttData(row.model.asset_id, row.model.is_single);
    $scope.$apply();
  };
  $scope.load = function () {
    $scope.data = $scope.ganttData;
  };
  $scope.reload = function () {
    $scope.getGanttData();
  };

  // Etichetta e contenuto colonne.
  //$scope.tableColumns = ['model.frequency'];
  //$scope.tableHeaders = {'model.frequency': 'Frequenza'};
  $scope.tableColumns = [];

  // Etichetta e contenuto tree.
  $scope.treeHeader = "Compito";
  $scope.toggleArrow = function () {
    $scope.opt.open = !$scope.opt.open;
  };
  $scope.collapseAll = function () {
    $scope.$broadcast('angular-ui-tree:collapse-all');
  };
  $scope.expandAll = function () {
    $scope.$broadcast('angular-ui-tree:expand-all');
  };
  $scope.goToNewTask = function () {
    $location.path('task/detail');
  };
  $scope.clearAssetFilter = function () {
    $scope.opt.assetFilter = {};
    $scope.opt.filterRow = '';
    $scope.getGanttData();
  };
  function slideDateRange(newdate, pivot) {
    var slided = false;
    var datediff;
    var maxdiff = 5 * 365 * 24 * 3600 * 1000; //5 anni in millisecondi
    var mindiff = 30 * 24 * 3600 * 1000; //30gg in millisecondi
    var toasterTitle = 'Date aggiornate';
    var toasterMessageReduce = 'Le date scelte sono troppo distanti. L\'intervallo di date selezionato è stato ridotto.';
    var toasterMessageExtend = 'Le date scelte sono troppo vicine. L\'intervallo di date selezionato è stato esteso.';
    if (pivot == 'to') {
      datediff = newdate.getTime() - $scope.opt.fromDate.getTime();
      if (datediff > maxdiff) {
        $scope.opt.fromDate = new Date(newdate.getTime() - maxdiff);
        toaster.pop('info', toasterTitle, toasterMessageReduce);
        slided = true;
      }
      if (datediff < 0) {
        $scope.opt.fromDate = new Date(newdate.getTime() - mindiff);
        toaster.pop('info', toasterTitle, toasterMessageExtend);
        slided = true;
      }
    } else {
      datediff = $scope.opt.toDate.getTime() - newdate.getTime();
      if (datediff > maxdiff) {
        $scope.opt.toDate = new Date(newdate.getTime() + maxdiff);
        toaster.pop('info', toasterTitle, toasterMessageReduce);
        slided = true;
      }
      if (datediff < 0) {
        $scope.opt.toDate = new Date(newdate.getTime() + mindiff);
        toaster.pop('info', toasterTitle, toasterMessageExtend);
        slided = true;
      }
    }
    return slided;
  }
  $scope.$watch('opt.fromDate', function (newValue, oldValue) {
    if (newValue != oldValue) {
      if (!slideDateRange(newValue, 'from')) {
        $scope.getGanttData();
      }
    }
  });
  $scope.$watch('opt.toDate', function (newValue, oldValue) {
    if (newValue != oldValue) {
      if (!slideDateRange(newValue, 'to')) {
        $scope.getGanttData();
      }
    }
  });
  $scope.$watch('opt.viewScale', function (newValue, oldValue) {
    if (newValue != oldValue) {
      $scope.getGanttData();
    }
  });
  $scope.$watch('opt.open', function (newValue, oldValue) {
    if (newValue != oldValue) {
      $scope.opt.open = newValue;
      localStorageService.set('taskgantt.gantt_options', $scope.opt);
    }
  });
  $scope.$watch('opt.filterRow', function (newValue, oldValue) {
    if (newValue != oldValue) {
      localStorageService.set('taskgantt.gantt_options', $scope.opt);
    }
  });
  $scope.printModelIcons = function () {
    var array = $('.entity-icon');
    for (var i = 0; i < array.length; i++) {
      var target = $(array[i]);
      var entity = target.html();
      target.addClass($scope.getModelIcon(entity));
      target.html('');
      target.removeClass('hidden');
    }
  };
  $scope.getModelIcon = function (modelName) {
    var icon = modelIconService.getModelIcon(modelName) || 'fa fa-list';
    return icon;
  };
  $scope.getGanttData = function (parentUUID, isSingle) {
    // Compose payload
    var payload = {};
    payload.date_from = new Date(new Date($scope.opt.fromDate.getTime()).setHours(0, 0, 0, 0));
    payload.date_from.setDate($scope.opt.fromDate.getDate()); //old: -1
    payload.date_to = new Date(new Date($scope.opt.toDate.getTime()).setHours(0, 0, 0, 0));
    payload.date_to.setDate($scope.opt.toDate.getDate()); //old: +1
    payload.parent_uuid = parentUUID;
    payload.parent_is_single = isSingle;
    payload.view_scale = $scope.opt.viewScale;
    // Add filters
    if (angular.isDefined($scope.opt.assetFilter.description)) {
      payload.asset_description = $scope.opt.assetFilter.description;
    }
    if (angular.isDefined($scope.opt.assetFilter.code)) {
      payload.asset_code = $scope.opt.assetFilter.code;
    }
    if (angular.isDefined($scope.opt.assetFilter.type_id)) {
      payload.asset_type = $scope.opt.assetFilter.type_id.code;
    }
    // Call endpoint
    taskFactory.getGantt(payload).$promise.then(function (data) {
      $scope.ganttFromDate = new Date(new Date($scope.opt.fromDate).setHours(0, 0, 0, 0));
      $scope.ganttToDate = new Date(new Date($scope.opt.toDate).setHours(0, 0, 0, 0));
      if (!parentUUID) {
        $scope.collapseAll();
        $scope.ganttData = data.list;
        $scope.parentRows = data.list;
      } else {
        $scope.ganttData = [];
        $scope.parentRows.forEach(function (row) {
          //resetto i placeholder
          row.children = [];
          $scope.parentRows.forEach(function (rowPlaceholder) {
            if ("placeholder" + row.asset_id == rowPlaceholder.asset_id) {
              row.children.push(rowPlaceholder.id);
            }
          });
          $scope.ganttData.push(row);
        });
        var newData = $scope.ganttData.filter(function (el) {
          //inizializzo newData, come la lista dei record meno il placeholder del parentUUID
          return el.asset_id !== "placeholder" + parentUUID;
        });
        var oldRecordList = $scope.ganttData.filter(function (el) {
          //pesco la vecchia versione del record
          return el.asset_id === parentUUID;
        });
        var oldRecord = oldRecordList[0];
        oldRecord.children = [];
        data.list.forEach(function (newRecord) {
          oldRecord.children.push(newRecord.id);
          newData.push(newRecord);
        });
        $scope.ganttData = newData;
      }
      setTimeout(function () {
        $scope.api.rows.refresh();
        $scope.printModelIcons();
      }, 1000);
    });
    localStorageService.set('taskgantt.gantt_options', $scope.opt);
  };
  $scope.getGanttData();
  var RESOURCE_NAME = 'task';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:TaskCtrl
 * @description
 * # TaskCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/task', {
    templateUrl: 'plan/task/task_list.html',
    controller: 'TaskListCtrl'
  });
}]).controller('TaskListCtrl', ["$scope", "taskFactory", "$log", "$routeParams", "$location", "uiGridConstants", "authFactory", function ($scope, taskFactory, $log, $routeParams, $location, uiGridConstants, authFactory) {
  $scope.tasksList = {};
  $scope.params = {
    pageNumber: 1,
    pageSize: 15,
    filters: {}
  };
  $scope.viewGridOptions = {
    columnDefs: [{
      name: ' '
    }]
  };
  var currentCommission = authFactory.getAuthData().info.commissions.current;
  $scope.bool = {
    viewCommissionData: true,
    viewCrossData: true
  };
  function initGridColumns() {
    $scope.viewGridOptions.columnDefs = [];
    $scope.viewGridOptions.columnDefs.push({
      displayName: '',
      field: 'id',
      width: 36,
      enableCellEdit: true,
      enableFiltering: false,
      enableSorting: false,
      cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/task/detail/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' + '<span class="fa fa-search"></span>' + '</a>' + '</div>'
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Codice',
      field: 'model.code',
      enableFiltering: true,
      filters: [{
        type: 'text',
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Descrizione',
      field: 'model.description',
      enableFiltering: true,
      filters: [{
        type: 'text',
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    });
  }
  function setCommissionFilters() {
    if ($scope.bool.viewCommissionData == true && $scope.bool.viewCrossData == true) {
      $scope.params.filters['commission'] = undefined;
      $scope.params.filters['cross_commission'] = undefined;
    } else if ($scope.bool.viewCommissionData == true && $scope.bool.viewCrossData == false) {
      $scope.params.filters['commission'] = sixFiltersLib.match('commission', currentCommission.code, sixFiltersLib.CONSTRAINTS.AND);
      $scope.params.filters['cross_commission'] = undefined;
    } else if ($scope.bool.viewCommissionData == false && $scope.bool.viewCrossData == true) {
      $scope.params.filters['commission'] = undefined;
      $scope.params.filters['cross_commission'] = sixFiltersLib.missing('commission', sixFiltersLib.CONSTRAINTS.AND);
    } else {
      $scope.params.filters['commission'] = sixFiltersLib.match('commission', currentCommission.code, sixFiltersLib.CONSTRAINTS.AND);
      $scope.params.filters['cross_commission'] = sixFiltersLib.missing('commission', sixFiltersLib.CONSTRAINTS.AND);
    }
  }
  $scope.getData = function () {
    var payload = {
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      show_revision: false
    };
    setCommissionFilters();
    return taskFactory.getTasksListFiltered(payload, $scope.params.filters).$promise.then(function (data) {
      $scope.tasksList.totalResults = data.totalResults;
      $scope.tasksList.list = data.list;
      $scope.params.sixApi.refreshList(data.list);
      return data;
    });
  };
  $scope.goToNewTask = function () {
    $location.path('task/detail');
  };
  $scope.goToGantt = function () {
    $location.path('task/gantt');
  };

  //__main__
  initGridColumns();

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'task';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };

  /** ***********************************
    * Watches
   * ***********************************/

  $scope.$watch('bool', function (nv, ov) {
    if (!angular.equals(nv, ov)) $scope.getData();
  }, true);
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:WorkflowCtrl
 * @description
 * # WorkflowCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/workflow/:type/:id', {
    templateUrl: 'plan/workflow/workflow.html',
    controller: 'WorkflowCtrl'
  });
}]).controller('WorkflowCtrl', ["$scope", "$routeParams", "$location", "$log", "$window", "workflowFactory", "FileUploader", "schemaFactory", "commissionFactory", "toaster", "authFactory", "dialogService", function ($scope, $routeParams, $location, $log, $window, workflowFactory, FileUploader, schemaFactory, commissionFactory, toaster, authFactory, dialogService) {
  var BpmnViewer = new window.BpmnJS({
    container: '#bpmnViewer'
  });
  $scope.workflowList = {};
  $scope.workflowType = 'odl';

  //alcune tipologie di workflow devono assegnare ad alcuni stati un significato particolare
  //per poter poi eseguire alcune logiche di business
  var typeSpecialStatuses = {
    'odl': ['open', 'closed', 'in_service'],
    'issue': ['open', 'closed', 'in_service']
  };
  if ($routeParams.type) {
    $scope.workflowType = $routeParams.type;
  }
  $scope.mappableStatuses = typeSpecialStatuses[$scope.workflowType];
  var PATH_WORKFLOW = 'workflow/' + $scope.workflowType;
  $scope.bool = {
    /* contenitore per le variabili booleane */
    isNew: false,
    isCross: false
  };
  $scope.acee = null;
  $scope.commissionDependent = true;
  $scope.commissionCode = '';
  $scope.commissions = [];
  $scope.commissionsSelected = {
    codes: []
  };
  $scope.selected = {
    model: {}
  }; /* contenitore */

  $scope.back = function () {
    $location.path(PATH_WORKFLOW);
  };
  $scope.$watchGroup(['commissionDependent', 'history'], function () {
    if ($scope.commissionDependent === true) {
      $scope.history = true;
    }
    if ($scope.selected) {
      if ($scope.selected.model) {
        $scope.selected.model.history = $scope.history;
        $scope.selected.model.commissionDependent = $scope.commissionDependent;
      }
    }
  });
  $scope.updateCode = function () {
    if ($scope.bool.isCross == true) {
      $scope.commissionCode = 'default';
      $scope.commissionsSelected.codes = [];
    } else {
      $scope.commissionCode = '';
    }
  };
  $scope["delete"] = function () {
    dialogService.confirmDialog('Eliminare la configurazione?', function () {
      workflowFactory.deleteWorkflow({
        id: $scope.selected.version
      }).$promise.then(function () {
        $scope.back();
      });
    });
  };
  $scope.setCommissionSelected = function () {
    angular.forEach($scope.selected.model.commission, function (value_cm_string) {
      var index = null;
      angular.forEach($scope.commissions, function (value_cm_obj) {
        if (value_cm_string == value_cm_obj.code) {
          index = $scope.commissions.indexOf(value_cm_obj);
          $scope.commissionsSelected.codes.push(value_cm_obj);
          $scope.commissions.splice(index, 1);
        }
      });
    });
  };
  $scope.setBooleanFlag = function () {
    if ($scope.selected.model) {
      if ($scope.selected.model.code == 'default') {
        $scope.bool.isCross = true;
      }
    }
  };
  $scope.aceLoaded = function (_editor) {
    $scope.acee = _editor;
  };
  $scope.getWorkflowById = function (UUID) {
    workflowFactory.getWorkflowByUUID({
      id: UUID
    }).$promise.then(function (response) {
      if (response) {
        $scope.selected = angular.copy(response);
        $scope.commissionCode = $scope.selected.model.code;
        $scope.setCommissionSelected();
        $scope.setBooleanFlag();
        refreshVisualization();
      }
    });
  };
  $scope.getCommission = function () {
    commissionFactory().getCommissionsList().$promise.then(function (response) {
      if (response.list && response.list.length) {
        $scope.commissions = response.list;
      }
    });
  };
  $scope.setConfModel = function () {
    $scope.bool.confModel = true;
    $scope.bool.isCross = false;
    delete $scope.selected.version;
    $scope.getCommission();
    $scope.commissionsSelected.codes = [];
    $scope.commissionCode = '';
  };
  $scope.create = function () {
    workflowFactory.saveWorkflow($scope.selected).$promise.then(function () {
      toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
      $scope.back();
    })["catch"](function (response) {
      toaster.pop('error', 'Errore salvataggio', 'Si è verificato un errore durante il salvataggio');
    });
  };
  $scope.update = function () {
    workflowFactory.updateWorkflow({
      id: $scope.selected.version
    }, $scope.selected).$promise.then(function () {
      toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
      $scope.back();
    })["catch"](function (rejection) {
      toaster.pop('error', 'Errore salvataggio', rejection.data.message ? rejection.data.message : rejection.statusText);
    });
  };
  $scope.saveForm = function () {
    $scope.selected.model.code = $scope.commissionCode;
    $scope.selected.model.workflowType = $scope.workflowType;
    if ($scope.bool.isCross) {
      /* se è cross non serve riempire il vettore delle commesse */
      $scope.selected.model.commission = null;
      $scope.selected.model.commissionDependent = false;
    } else {
      /* riempio il vettore delle commesse */
      $scope.selected.model.commission = [];
      angular.forEach($scope.commissionsSelected.codes, function (obj) {
        $scope.selected.model.commission.push(obj.code);
      });
    }

    //valido e poi salvo
    workflowFactory.validateWorkflow($scope.selected.model).$promise.then(function (response) {
      if ($scope.selected.version) {
        $scope.update();
      } else {
        $scope.create();
      }
    })["catch"](function (rejection) {
      toaster.pop('error', 'Errore salvataggio', rejection.data.message ? rejection.data.message : rejection.statusText);
    });
  };
  $scope.bpmnStatuses = function () {
    var nodes = [];
    if ($scope.selected.model.bpmn) {
      nodes = $($scope.selected.model.bpmn).find('bpmn2\\:manualTask').map(function (i, el) {
        return $(el).attr("name");
      }).get();
    }
    return nodes;
  };
  if ($routeParams.id) {
    if ($routeParams.id !== 'new') {
      $scope.bool.isNew = false;
      commissionFactory().getCommissionsList().$promise.then(function (response) {
        if (response.list && response.list.length) {
          $scope.commissions = response.list;
        }
        $scope.getWorkflowById($routeParams.id);
      });
    } else {
      $scope.bool.isNew = true;
      $scope.getCommission();
    }
  }

  //non fa un vero upload, legge solo dinamicamente il file
  var uploader = $scope.uploader = new FileUploader({
    queueLimit: 1
  });
  $scope.upload = {
    show: false
  };
  var uploadReader = new FileReader();
  uploadReader.addEventListener("loadend", function () {
    $scope.selected.model.bpmn = uploadReader.result;
    $scope.upload.show = false;
    refreshVisualization();
    console.log("new Business Process loaded");
  });
  uploader.onAfterAddingFile = function (fileItem) {
    uploadReader.readAsText(fileItem._file);
  };
  uploader.onAfterAddingAll = function (addedFileItems) {
    uploader.clearQueue();
  };
  function refreshVisualization() {
    //refresh visualizzazione ace-editor e bpmn
    if ($scope.selected.model.bpmn) {
      BpmnViewer.importXML($scope.selected.model.bpmn, function (err) {
        if (err) {
          console.log("error: " + objToString(err));
          toaster.pop('error', 'Errore di rendering', err);
        }
        BpmnViewer.get('canvas').zoom('fit-viewport', 'auto');
      });
    }
    $scope.$digest();
  }
  function objToString(obj) {
    var str = '';
    for (var p in obj) {
      if (obj.hasOwnProperty(p)) {
        str += p + '::' + obj[p] + '\n';
      }
    }
    return str;
  }

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'workflow';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME, true);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME, true);
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:WorkflowListCtrl
 * @description
 * # WorkflowListCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/workflow/:type/page/:number', {
    templateUrl: 'plan/workflow/workflow_list.html',
    controller: 'WorkflowListCtrl'
  }).when('/workflow/:type', {
    templateUrl: 'plan/workflow/workflow_list.html',
    controller: 'WorkflowListCtrl'
  });
}]).controller('WorkflowListCtrl', ["$scope", "$routeParams", "$location", "workflowFactory", "authFactory", function ($scope, $routeParams, $location, workflowFactory, authFactory) {
  $scope.pageSize = 10;
  $scope.queryParam = null;
  $scope.workflowList = {};
  $scope.workflowType = 'odl';
  if ($routeParams.type) {
    $scope.workflowType = $routeParams.type;
  }
  var PATH_WORKFLOW = 'workflow/' + $scope.workflowType;
  $scope.filters = {
    'typeFilter': sixFiltersLib.exact('model.workflowType', $scope.workflowType)
  };
  $scope.pageChanged = function () {
    $location.path('/workflow/page/' + $scope.workflowList.currentPage, false);
    $scope.refresh();
  };
  $scope.printCommission = function (commission_array) {
    var result = '';
    var pos = 0;
    if (commission_array != null) {
      angular.forEach(commission_array, function (value) {
        if (pos == 0) {
          result = value;
        } else {
          result = value + ', ' + result;
        }
        pos++;
      });
    }
    return result;
  };
  $scope.newWorkflow = function () {
    $location.path(PATH_WORKFLOW + '/new');
  };
  $scope.refresh = function () {
    $scope.getWorkflowList();
  };
  $scope.getWorkflowList = function () {
    var payload = {
      query: $scope.queryParam,
      pageSize: $scope.pageSize,
      page: $scope.workflowList.currentPage
    };
    var filter = {
      'type': sixFiltersLib.exact("model.workflowType", $scope.workflowType)
    };
    workflowFactory.getWorkflowsListFiltered(payload, filter).$promise.then(function (response) {
      $scope.workflowList = response;
    });
  };
  $scope.getWorkflowList();

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'workflow';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME, true);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME, true);
  };
}]);
'use strict';

angular.module('emma.portal').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/document', {
    templateUrl: 'portal/document/document.html',
    controller: 'DocumentNewCtrl'
  });
}]).controller('DocumentNewCtrl', ['$scope', 'toaster', 'FileUploader', 'recordFactory', 'authFactory', 'ALFRESCO_URL', 'ENV', 'alfrescoFactory', '$timeout', 'dialogService', function ($scope, toaster, FileUploader, recordFactory, authFactory, ALFRESCO_URL, ENV, alfrescoFactory, $timeout, dialogService) {
  var DESTINATION = '/Sites/' + ENV + '/' + authFactory.getAuthData().info.commissions.current.code;
  var DOCTYPE = 'documenti';
  var ROOTID = '__root__';
  $scope.currentUser = authFactory.getAuthData().authId;
  $scope.uploader = new FileUploader({
    url: ALFRESCO_URL + '/upload',
    formData: [{
      destination: DESTINATION
    }],
    queue: [],
    // queueLimit: 1,
    autoUpload: true,
    removeAfterUpload: true,
    onAfterAddingAll: function onAfterAddingAll() {
      dialogService.loading("Upload file in corso...");
    },
    onWhenAddingFileFailed: function onWhenAddingFileFailed(item, filter, options) {
      console.error("onWhenAddingFileFailed", item, filter, options);
      dialogService.stopLoading();
    },
    onErrorItem: function onErrorItem(fileItem, response, status, headers) {
      toaster.error('', 'Impossibile allegare il documento');
      console.error('onErrorItem', fileItem, response, status, headers);
      dialogService.stopLoading();
    },
    onSuccessItem: function onSuccessItem(fileItem, response, status, headers) {
      if (response.ERROR || !response.objectId) {
        toaster.error('', 'Impossibile allegare il documento');
        console.error('onErrorItem', fileItem, response, status, headers);
        dialogService.stopLoading();
      } else {
        dialogService.loading('Salvataggio documenti in corso');
        var model = {
          code: Date.now() + "_" + $scope.currentUser,
          description: fileItem.file.name,
          attached_file: {
            date_insertion: new Date(),
            destination: DESTINATION,
            object_id: response.objectId,
            title: fileItem.file.name
          }
        };
        if ($scope.selected) {
          model.parent_id = node2ref($scope.selected);
        }
        recordFactory(DOCTYPE).create(model).$promise.then(function (saved) {
          $scope.selected.nodes.push(doc2node(saved));
          $timeout(function () {
            return dialogService.stopLoading();
          });
        })["catch"](function (err) {
          console.log(err);
          toaster.error('', 'Impossibile salvare il nuovo documento. Riprova.');
        });
      }
    }
  });
  $scope.dowloadUrl = ALFRESCO_URL + '/api/alfresco/';

  //mock document per retrocompatibilità con la view
  $scope.asset = {
    model: {
      attachments: []
    }
  };
  function node2ref(node) {
    //costruisce una finta ref, il code è errato ma non rilevante
    return {
      type: DOCTYPE,
      UUID: node.id,
      code: node.id,
      description: node.title
    };
  }
  function doc2node(doc) {
    var isFile = doc.model.attached_file && doc.model.attached_file.object_id;
    var node = {
      folder: !isFile,
      id: doc.UUID,
      readonly: false,
      nodes: [],
      user: doc.user
    };
    if (isFile) {
      return Object.assign(node, {
        title: doc.model.attached_file.title,
        date: doc.model.attached_file.date_insertion,
        destination: doc.model.attached_file.destination,
        object_id: doc.model.attached_file.object_id
      });
    } else {
      node.title = doc.model.description;
      return node;
    }
  }
  function loadChilds(node) {
    var filter;
    if (node == ROOTID) {
      filter = {
        noParent: sixFiltersLib.missing("model.parent_id.UUID")
      };
    } else {
      filter = {
        noParent: sixFiltersLib.exact("model.parent_id.UUID", node.id)
      };
      node.fetchDate = new Date();
    }
    recordFactory(DOCTYPE).search({
      page_size: 10000,
      sort_fields: 'dataIn'
    }, filter).$promise.then(function (response) {
      if (response && response.list) {
        if (node == ROOTID) {
          var nodes = response.list.map(doc2node);
          $scope.asset.model.attachments = nodes.filter(function (n) {
            return n.folder;
          });
          if (nodes.filter(function (n) {
            return !n.folder;
          }).length) {
            //inject falsa cartella per i documenti sfusi
            $scope.asset.model.attachments.unshift({
              folder: true,
              id: ROOTID,
              readonly: true,
              nodes: nodes.filter(function (n) {
                return !n.folder;
              }),
              title: "Documenti"
            });
          }
        } else {
          node.nodes = response.list.map(doc2node);
        }
      }
    })["catch"](function (err) {
      console.log(err);
      toaster.error('', 'Impossibile caricare i documenti');
    });
  }
  function deleteNode(node) {
    if (node.id == ROOTID) {
      return $q.resolve();
    }
    return recordFactory(DOCTYPE).deleteByQuery({}, {
      uuid: sixFiltersLib.exact("UUID", node.id)
    }).$promise;
  }
  $scope.select = function (folder) {
    $scope.selected = folder;
    if (folder && folder.id != ROOTID && !folder.fetchDate) {
      loadChilds(folder);
    }
  };
  $scope.newFolder = function (onRoot) {
    dialogService.loading('Creazione cartella');
    var nameBlacklist = [];
    var parent = false;
    if (!onRoot) {
      if ($scope.selected) {
        nameBlacklist = $scope.selected.nodes.map(function (n) {
          return n.title;
        });
        parent = node2ref($scope.selected);
      } else {
        dialogService.stopLoading();
        toaster.error('', 'Selezionare una cartella.');
        return;
      }
    } else {
      nameBlacklist = $scope.asset.model.attachments.map(function (n) {
        return n.title;
      });
    }
    var description = "Nuova cartella ";
    var suffix = 1;
    while (nameBlacklist.includes(description + suffix)) {
      suffix++;
    }
    var model = {
      code: Date.now() + "_" + $scope.currentUser,
      description: description + suffix
    };
    if (parent) {
      model.parent_id = parent;
    }
    recordFactory(DOCTYPE).create(model).$promise.then(function (saved) {
      if (parent) {
        loadChilds($scope.selected);
      } else {
        loadChilds(ROOTID);
      }
      dialogService.stopLoading();
    });
  };
  $scope.removeFolder = function (node, scope) {
    console.log("REMOVE", node);
    if (confirm("Confermi di voler eliminare la cartelle e tutto il contenuto? L'operazione non è annullabile.")) {
      removeAllFile(node);
      deleteNode(node).then(function () {
        var idx = $scope.selected.nodes.findIndex(function (n) {
          return n.id == node.id;
        });
        if (idx >= 0) {
          $scope.selected.nodes.splice(idx, 1);
        }
        scope.remove();
        $scope.select(undefined);
      });
    }
  };
  $scope.getDocumentClass = function (name) {
    if (name) {
      switch (name.substring(name.lastIndexOf('.') + 1)) {
        case 'png':
        case 'jpg':
          return 'fa-file-image-o';
        case 'pdf':
          return 'fa-file-pdf-o';
        case 'xlsx':
        case 'xls':
          return 'fa-file-excel-o';
        case 'doc':
          return 'fa-file-word-o';
        default:
          return 'fa-file-o';
      }
    }
  };
  $scope.update = function (node) {
    //si tratta solo del cambio nome delle cartelle, ma non conservando la version va fatto un get+update
    var uuid = node.id;
    recordFactory(DOCTYPE).byUUID({
      id: uuid
    }).$promise.then(function (doc) {
      doc.model.description = node.title;
      recordFactory(DOCTYPE).update({
        id: doc.version
      }, doc).$promise.then(function () {
        return toaster.info('', "Cartella rinominata");
      });
    });
  };
  $scope.isAdmin = function () {
    return authFactory.getAuthData().options.admin;
  };
  function transformObjectIdForBackend(objectId) {
    return objectId.replace('workspace://SpacesStore/', '$WorkspaceSpacesStore$');
  }
  ;
  $scope.deleteFile = function (node) {
    if (confirm("Confermi di voler eliminare il file: " + node.title + "\nL'operazione non è reversibile.")) {
      deleteNode(node).then(function (res) {
        //alfrescoFactory.delete({ id: transformObjectIdForBackend(node.object_id) }); //FIXME: vogliamo davvero eliminare i file?
        var idx = $scope.selected.nodes.findIndex(function (n) {
          return n.object_id == node.object_id;
        });
        $scope.selected.nodes.splice(idx, 1);
      })["catch"](function (err) {
        console.log(err);
        toaster.error('', "Impossibile eliminare il file, aggiorna la pagina e riprova.");
      });
    }
  };
  function removeAllFile(node) {
    node.nodes.forEach(function (c) {
      if (c.folder) {
        deleteNode(c).then(function (res) {
          return removeAllFile(c);
        });
      } else {
        deleteNode(c).then(function (res) {
          //alfrescoFactory.delete({ id: transformObjectIdForBackend(c.object_id) }); //FIXME: vogliamo davvero eliminare i file?
        })["catch"](function (err) {
          console.log(err);
        });
      }
    });
    node.nodes = [];
  }

  //recupera i doc a livello 0, ovvero senza parent_id
  loadChilds(ROOTID);
}]);
'use strict';

angular.module('emma.portal').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/document-old', {
    templateUrl: 'portal/document/document.html',
    controller: 'DocumentCtrl'
  });
}]).controller('DocumentCtrl', ['$scope', '$location', 'toaster', 'FileUploader', 'recordFactory', 'authFactory', 'ALFRESCO_URL', 'ENV', 'alfrescoFactory', '$timeout', 'dialogService', function ($scope, $location, toaster, FileUploader, recordFactory, authFactory, ALFRESCO_URL, ENV, alfrescoFactory, $timeout, dialogService) {
  var DESTINATION = '/Sites/' + ENV + '/' + authFactory.getAuthData().info.commissions.current.code;
  $scope.currentUser = authFactory.getAuthData().authId;
  $scope.uploader = new FileUploader({
    url: ALFRESCO_URL + '/upload',
    formData: [{
      destination: DESTINATION
    }],
    queue: [],
    // queueLimit: 1,
    autoUpload: true,
    removeAfterUpload: true,
    onWhenAddingFileFailed: function onWhenAddingFileFailed(item, filter, options) {
      console.error("onWhenAddingFileFailed", item, filter, options);
      dialogService.stopLoading();
    },
    onErrorItem: function onErrorItem(fileItem, response, status, headers) {
      toaster.error('', 'Impossibile allegare il documento');
      console.error('onErrorItem', fileItem, response, status, headers);
      dialogService.stopLoading();
    },
    onSuccessItem: function onSuccessItem(fileItem, response, status, headers) {
      if (response.ERROR || !response.objectId) {
        toaster.error('', 'Impossibile allegare il documento');
        console.error('onErrorItem', fileItem, response, status, headers);
        dialogService.stopLoading();
      } else {
        dialogService.loading('Upload documenti in corso');
        addFile({
          date: new Date(),
          destination: DESTINATION,
          folder: false,
          id: 0,
          nodes: [],
          object_id: response.objectId,
          readonly: false,
          title: fileItem.file.name,
          user: $scope.currentUser
        }, this.queue);
      }
    }
  });
  $scope.dowloadUrl = ALFRESCO_URL + '/api/alfresco/';
  $scope.select = function (folder) {
    $scope.selected = folder;
  };
  $scope.newFolder = function (onRoot) {
    dialogService.loading('Creazione cartella');
    var nodeData = $scope.asset.model.attachments;
    var id = nodeData.length;
    if (!onRoot) {
      if ($scope.selected) {
        nodeData = $scope.selected.nodes;
        id = $scope.selected.id * 10 + nodeData.length;
      } else {
        dialogService.stopLoading();
        toaster.error('', 'Selezionare una cartella.');
      }
    }
    nodeData.push({
      id: id,
      folder: true,
      title: 'Nuova cartella ' + id,
      nodes: []
    });
    $scope.update();
  };
  $scope.removeFolder = function (node, scope) {
    console.log("REMOVE", node);
    if (confirm("Confermi di voler eliminare la cartelle e tutto il contenuto? L'operazione non è annullabile.")) {
      removeAllFile(node);
      var idx = $scope.selected.nodes.findIndex(function (n) {
        return n.id == node.id;
      });
      if (idx >= 0) {
        $scope.selected.nodes.splice(idx, 1);
      }
      scope.remove();
      $timeout(function () {
        //attendo un ciclo di digest prima di persistere
        $scope.update();
        $scope.select(undefined);
      });
    }
  };
  $scope.getDocumentClass = function (name) {
    if (name) {
      switch (name.substring(name.lastIndexOf('.') + 1)) {
        case 'png':
        case 'jpg':
          return 'fa-file-image-o';
        case 'pdf':
          return 'fa-file-pdf-o';
        case 'xlsx':
        case 'xls':
          return 'fa-file-excel-o';
        case 'doc':
          return 'fa-file-word-o';
        default:
          return 'fa-file-o';
      }
    }
  };
  $scope.update = function () {
    recordFactory('documentale').update({
      id: $scope.asset.version
    }, $scope.asset).$promise.then(function (response) {
      $scope.asset.version = response.version;
      dialogService.stopLoading();
    })["catch"](function (e) {
      return dialogService.stopLoading();
    });
  };
  $scope.isAdmin = function () {
    return authFactory.getAuthData().options.admin;
  };
  $scope.deleteFile = function (node) {
    if (confirm("Confermi di voler eliminare il file: " + node.title + "\nL'operazione non è reversibile.")) {
      alfrescoFactory["delete"]({
        id: transformObjectIdForBackend(node.object_id)
      });
      var idx = $scope.selected.nodes.findIndex(function (n) {
        return n.object_id == node.object_id;
      });
      $scope.selected.nodes.splice(idx, 1);
      $scope.update();
    }
  };
  function loadAsset() {
    recordFactory('documentale').search({
      page_size: 1,
      sort_fields: 'dataIn'
    }, {}).$promise.then(function (response) {
      if (response.totalResults > 1) {
        toaster.warning('', 'Sono stati trovati diversi gruppi di allegati<br>Verrà usato l\'originale.');
      } else if (response.totalResults == 0) {
        toaster.error('', 'Non è possibile acceddere a questa sezione. Contattare l\'amministratore.');
        $location.path('/');
        return;
      }
      $scope.asset = response.list[0];
      if (!$scope.asset.model.attachments) {
        $scope.asset.model.attachments = [];
      }
    }, function (err) {
      toaster.error('', 'Impossibile caricare i documenti');
    });
  }
  function addFile(file, queue) {
    $scope.selected.nodes.push(file);
    if (queue.length <= 1) {
      $scope.update();
    }
  }
  function transformObjectIdForBackend(objectId) {
    return objectId.replace('workspace://SpacesStore/', '$WorkspaceSpacesStore$');
  }
  ;
  function removeAllFile(node) {
    node.nodes.forEach(function (c) {
      if (c.folder) {
        removeAllFile(c);
      } else {
        alfrescoFactory["delete"]({
          id: transformObjectIdForBackend(c.object_id)
        });
      }
    });
    node.nodes = [];
  }
  loadAsset();
}]);
'use strict';

angular.module('emma.portal').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/so', {
    templateUrl: 'portal/home/home.html',
    controller: 'HomeCtrl'
  }).when('/tracking', {
    templateUrl: 'portal/home/tracking.html',
    controller: 'TrackingCtrl'
    // controller: function(LM_URL, TTR_URL, TRULY_URL) {
    //     this.sixlmUrl = LM_URL;
    //     this.sixTtrUrl = TTR_URL;
    //     this.trulyUrl = TRULY_URL;
    // },
    // controllerAs: 'ctrl'
  }).when('/contact', {
    templateUrl: 'portal/home/contact.html',
    controller: 'IssueModalCtrl'
  }).when('/quality-management', {
    templateUrl: 'portal/home/quality.html',
    controller: 'IssueModalCtrl'
  }).when('/business', {
    templateUrl: 'portal/home/business.html',
    controller: 'IssueModalCtrl'
  }).when('/link-modal', {
    templateUrl: 'portal/home/link-modal.html',
    controller: 'LinkEditModalCtrl'
  });
}]).controller('HomeCtrl', ['$scope', '$location', 'toaster', 'authFactory', 'localStorageService', 'issueFactory', 'recordFactory', 'IssueSrv', 'LinkSrv', function ($scope, $location, toaster, authFactory, localStorageService, issueFactory, recordFactory, IssueSrv, LinkSrv) {
  $scope.user = authFactory.getAuthData().info;
  $scope.paginatedRequest = {
    page_size: 5,
    page: 1,
    show_revision: false
  };
  var PATH_ISSUE_RECORD = 'issue/record';
  var filter = {
    status: sixFiltersLib.match('status', 'Aperto')
  };
  $scope.loadData = function () {
    issueFactory(PATH_ISSUE_RECORD).search($scope.paginatedRequest, filter).$promise.then(function (response) {
      $scope.issueResponse = response;
    }, function (err) {
      toaster.error('', 'Impossibile caricare le segnalazioni');
    });
  };
  $scope.openIssue = function (issue) {
    $location.path('issue/' + issue.UUID);
  };
  $scope.createIssue = function () {
    IssueSrv.creatioDialog().then(function (data) {
      console.log(data.id, 'closed with value', data.value);
      if (data.value == 'saved') {
        $scope.loadData();
      }
    });
  };

  //gestione visualizzazione
  /*******************************
   * dashboardconfiguration, dato dipendente da commessa, quindi la commessa è gestita in maniera trasparente
   * ->role_id             | role_id del ruolo associato
   * ->active_widget_map   | mappa dei widget attualmente attivi.
   *******************************/

  //chiavi di activewidgetMap
  var activewidgetMap_keyset = ['tracking', 'quality-management', 'business', 'document', 'issue', 'contact']; //da aggiornare in caso di aggiunta o rimozione di widget.
  $scope.widgetEditMode = false; //true se entrati in "edit mode" ( modifica della visualizzazione dei widget )
  $scope.blurredWidgetStyle = {}; //determina lo sfocamento o meno di un widget
  $scope.activeWidgetMap = {}; //mappa dei widget attualmente attivi.
  $scope.dashboardconfiguration = {};
  $scope.dashboardconfiguration_all_data = {};
  function load_activeWidgetMap() {
    //al caricamento della pagina carico le configurazioni precedentemente salvate
    //queste configurazioni sono legate all'utente attualmente loggato
    var filtro_operatore = {
      'filtro_operatore': sixFiltersLib.exact('model.code', authFactory.getAuthData().authPermission)
    };
    recordFactory('ruolooperatore').search(filtro_operatore).$promise.then(function (response) {
      $scope.ruolo_operatore = response.list[0].model; //ottenuto il ruolo_operatore
      //controllo l'eventuale esistenza di una configurazione precedentemente salvata
      _load_activeWidgetMap();
    });
  }
  function _load_activeWidgetMap() {
    var filtro_ruolo = {
      'filtro_ruolo': sixFiltersLib.exact('model.role_id.code', $scope.ruolo_operatore.code)
    };
    recordFactory('dashboardconfiguration').search(filtro_ruolo).$promise.then(function (response) {
      if (!isEmpty(response.list)) {
        $scope.dashboardconfiguration_all_data = response.list[0];
        $scope.dashboardconfiguration = response.list[0].model;
        $scope.activeWidgetMap = $scope.dashboardconfiguration.active_widget_map;

        //imposto la grafica delle varie config
        for (var i = 0; i < activewidgetMap_keyset.length; i++) {
          if ($scope.activeWidgetMap[activewidgetMap_keyset[i]] == true) $scope.blurredWidgetStyle[activewidgetMap_keyset[i]] = {};else $scope.blurredWidgetStyle[activewidgetMap_keyset[i]] = {
            'opacity': '0.6'
          };
        }
      } else {
        //non esiste nessuna entry, me la creo.
        for (var i = 0; i < activewidgetMap_keyset.length; i++) {
          $scope.activeWidgetMap[activewidgetMap_keyset[i]] = true;
          $scope.blurredWidgetStyle[activewidgetMap_keyset[i]] = {};
        }
        //caricamento della nuova config

        $scope.dashboardconfiguration.role_id = $scope.ruolo_operatore;
        $scope.dashboardconfiguration.commission = authFactory.getAuthData().info.commissions.current.code;
        $scope.dashboardconfiguration.code = $scope.dashboardconfiguration.role_id.code;
        $scope.dashboardconfiguration.active_widget_map = $scope.activeWidgetMap;

        //uploadConfig($scope.dashboardconfiguration)
      }
    });
  }

  $scope.exitEditMode = function () {
    //funzione chiamata alla pressione di salva disposizione
    //salvo la configurazione
    if (!isEmpty($scope.ruolo_operatore)) {
      $scope.dashboardconfiguration.role_id = $scope.ruolo_operatore;
      $scope.dashboardconfiguration.commission = authFactory.getAuthData().info.commissions.current.code;
      $scope.dashboardconfiguration.code = $scope.dashboardconfiguration.role_id.code;
      $scope.dashboardconfiguration.active_widget_map = $scope.activeWidgetMap;
      var filtro_ruolo = {
        'filtro_ruolo': sixFiltersLib.exact('model.role_id.code', $scope.ruolo_operatore.code)
      };
      recordFactory('dashboardconfiguration').search(filtro_ruolo).$promise.then(function (response) {
        //controllo l'eventuale esistenza di una configurazione precedentemente salvata
        if (!isEmpty(response.list)) {
          //esiste già, la aggiorno
          $scope.dashboardconfiguration_all_data = response.list[0];
          $scope.dashboardconfiguration_all_data.model = Object.assign({}, $scope.dashboardconfiguration);
          var updated_config = Object.assign({}, $scope.dashboardconfiguration_all_data);
          recordFactory('dashboardconfiguration').update({
            id: $scope.dashboardconfiguration_all_data.version
          }, updated_config).$promise.then(function (response) {
            console.log('La configurazione è stata salvata');
            load_activeWidgetMap(); //mostra config del ruolo attuale dopo il salvataggio
          }, function (err) {
            if (err.data.message.search('concurrent versions') >= 0) {
              toaster.error('Impossibile salvare la configurazione', 'Un altro utente ha modificato questo configurazione. Ricarica i dati.');
            } else {
              toaster.error('Errore', 'Impossibile salvare la configurazione');
            }
          });
        } else {
          //non esiste, la creo
          uploadConfig($scope.dashboardconfiguration);
          load_activeWidgetMap(); //mostra config del ruolo attuale dopo il caricamento
        }
      });

      $scope.widgetEditMode = false;
    } else {
      toaster.error('uploadError', 'per poter salvare la configurazione è necessario selezionare un ruolo');
    }
  };
  function uploadConfig(config) {
    //salva la config come una nuova entry
    recordFactory('dashboardconfiguration').create(config).$promise.then(function (resp_dasboardconfiguration) {
      toaster.pop('success', 'Creato un nuovo dashboardconfiguration per il ruolo' + authFactory.getAuthData().info.commissions.current.code + '\': codice ' + resp_dasboardconfiguration.model.code);
      var filtro_ruolo = {
        'filtro_ruolo': sixFiltersLib.exact('model.role_id.code', $scope.ruolo_operatore.code)
      };
      recordFactory('dashboardconfiguration').search(filtro_ruolo).$promise.then(function (response) {
        if (!isEmpty(response.list)) {
          //controllo l'eventuale esistenza di una configurazione precedentemente salvata
          $scope.dashboardconfiguration_all_data = response.list[0];
        } else {
          console.log('ERROR I SHOULD NOT BE HERE');
        }
      });
    }, function (err) {
      toaster.error('uploadError', 'Impossibile salvare la configurazione');
    });
  }
  $scope.urlHandler = function (url) {
    if ($scope.widgetEditMode == true) return '';
    return url;
  };
  $scope.isWidgetVisible = function (widget_key) {
    if ($scope.activeWidgetMap[widget_key] || $scope.widgetEditMode) return true;
    return false;
  };
  $scope.hideWidget = function (widget_key) {
    if ($scope.activeWidgetMap[widget_key]) {
      //visibile
      $scope.blurredWidgetStyle[widget_key] = {
        'opacity': '0.6'
      };
    } else {
      //nascosto
      $scope.blurredWidgetStyle[widget_key] = {};
    }
    $scope.activeWidgetMap[widget_key] = !$scope.activeWidgetMap[widget_key]; //inverto il valore in entrambi i casi
  };

  $scope.enterEditMode = function () {
    //funzione chiamata alla pressione di modifica disposizione
    $scope.widgetEditMode = true;
  };
  $scope.updateRuoloFilter = function (ruolo) {
    //aggiorna i campi di ruolo_operatore in base al valore selezionato
    $scope.ruolo_operatore.code = ruolo.code;
    $scope.ruolo_operatore.description = ruolo.description;
    $scope.ruolo_operatore.UUID = ruolo.UUID;
    _load_activeWidgetMap();
  };
  $scope.clearRuoloFilter = function () {
    $scope.ruolo_operatore = {};
  };
  function isEmpty(obj) {
    //Verifica se un object è vuoto
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }

  /**
   * EDIT LINK
   */
  $scope.showEditQualityManagementLink = function () {
    LinkSrv.creatioDialog($scope.qualityUrl).then(function (data) {
      console.log(data.id, 'closed with value', data.value);
      if (data.value == 'saved') {
        //bravo.
        retriveQualityUrl();
      }
    });
  };
  $scope.qualityUrl = '';
  retriveQualityUrl();
  function retriveQualityUrl() {
    var code = authFactory.getAuthData().info.commissions.current.code + '_' + authFactory.getAuthData().info.commissions.current.description;
    var filtro_code = {
      'filtro_code': sixFiltersLib.exact('model.code', code)
    };
    recordFactory('trackinglist').search(filtro_code).$promise.then(function (response) {
      if (!isEmpty(response.list)) {
        if (response.list[0].model.home === true) $scope.qualityUrl = response.list[0].model.track.url;
      }
    });
  }

  /**
   * MAIN
   */
  function getOpGroup() {
    return localStorageService.get("operator-group") ? localStorageService.get("operator-group").UUID : null;
  }
  var waitCount = 0;
  function reloadForOperatorGroup() {
    //attendo per dare tempo all'operatorgroupservice di inizializzare l'operatore
    if (getOpGroup() != initialOpGroup) {
      $scope.loadData();
    } else {
      console.log("wait operator-group change");
      waitCount++;
      if (waitCount < 20) {
        setTimeout(function () {
          reloadForOperatorGroup();
        }, 200);
      }
    }
  }

  //attendo 500msec per evitare un flash di dati sbagliati al primo login
  //di contro, tutti i login successivi dovranno subire questo ritardo
  var initialOpGroup = getOpGroup();
  setTimeout(function () {
    if (getOpGroup() == initialOpGroup) {
      console.log("fallback loading");
      $scope.loadData();
    }
  }, 500);
  reloadForOperatorGroup();
  load_activeWidgetMap();

  /** ***********************************
   * Check permissions
   * ***********************************/
  var RESOURCE_NAME = 'commission';
  $scope.superuser = function () {
    return $scope.isWritePermAllowed() && $scope.isDeletePermAllowed();
  };
  $scope.isWritePermAllowed = function () {
    //true se l'utente può modificare la visualizzazione dei widget
    return authFactory.isWritePermAllowed(RESOURCE_NAME, true);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME, true);
  };
}]).controller('TrackingCtrl', ['$scope', '$location', 'toaster', 'authFactory', 'issueFactory', 'recordFactory', 'IssueSrv', 'TrackSrv', function ($scope, $location, toaster, authFactory, issueFactory, recordFactory, IssueSrv, TrackSrv) {
  $scope.user = authFactory.getAuthData().info;
  $scope.ruolo_operatore = {};
  $scope.activeWidgetMap = {};
  $scope.widgetTrackEditMode = false;
  $scope.blurredWidgetStyle = {};
  $scope.dashboardconfiguration = {};
  $scope.widgetList = {}; //lista dei widget (elementi di trackinglist) da mostrare con ng-repeat
  $scope.trackinglist = {};
  $scope.dashboardconfiguration_all_data = {};
  $scope.params = {
    pageNumber: 1,
    pageSize: 100
  };
  var activewidgetMap_keyset = ['tracking', 'quality-management', 'business', 'document', 'issue', 'contact']; //da aggiornare in caso di aggiunta o rimozione di widget.

  /**
   * trackinglist
   * -> track {
   *      url
   *      title
   *      description
   * }
   * -> code
   * //////////////////////////
    * dashboardconfiguration
    * -> hidden_track_map     | <key>: "value" % se esiste i valori sono:
    *                                                      key = trackinglist.code
    *                                                         value = false
    */

  function load_trackingList() {
    //Recupero il ruolo attuale
    var filtro_operatore = {
      'filtro_operatore': sixFiltersLib.exact('model.code', authFactory.getAuthData().authPermission)
    };
    recordFactory('ruolooperatore').search(filtro_operatore).$promise.then(function (response) {
      $scope.ruolo_operatore = response.list[0].model; //ottenuto il ruolo_operatore
      console.log($scope.ruolo_operatore.code);
      _load_trackingList();
    });
  }
  function _load_trackingList() {
    //Recupero la configurazione in funzione del $scope.ruolo_operatore.code corrente
    var filtro_ruolo = {
      'filtro_ruolo': sixFiltersLib.exact('model.role_id.code', $scope.ruolo_operatore.code)
    };
    recordFactory('dashboardconfiguration').search(filtro_ruolo).$promise.then(function (response) {
      if (!isEmpty(response.list)) {
        //controllo l'eventuale esistenza di una configurazione precedentemente salvata
        $scope.dashboardconfiguration_all_data = response.list[0];
        $scope.dashboardconfiguration = response.list[0].model;
        _load_all_tracks();
      } else {
        //non esiste, me la creo
        for (var i = 0; i < activewidgetMap_keyset.length; i++) {
          $scope.activeWidgetMap[activewidgetMap_keyset[i]] = true;
        }
        //caricamento della nuova config

        $scope.dashboardconfiguration.role_id = $scope.ruolo_operatore;
        $scope.dashboardconfiguration.commission = authFactory.getAuthData().info.commissions.current.code;
        $scope.dashboardconfiguration.code = $scope.dashboardconfiguration.role_id.code;
        $scope.dashboardconfiguration.active_widget_map = $scope.activeWidgetMap;

        //uploadConfig($scope.dashboardconfiguration)
      }
    });
  }

  function _load_all_tracks() {
    //Inizializzo la lista di tutti i widget
    var payload = {
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize
    };
    var commission_filter = {
      'filtro_commessa': sixFiltersLib.match('model.commission', authFactory.getAuthData().info.commissions.current.code, sixFiltersLib.CONSTRAINTS.OR),
      'filtro_missing': sixFiltersLib.missing('model.commission', sixFiltersLib.CONSTRAINTS.OR)
    };
    var trackinglist_filter = {
      'filtro_must': sixFiltersLib.must(commission_filter)
    };
    recordFactory('trackinglist').search(payload, trackinglist_filter).$promise.then(function (response) {
      if (response.list) {
        $scope.widgetList = Object.assign({}, response.list.filter(function (item) {
          //TODO: check
          return !item.model.hasOwnProperty('home');
        }).map(function (obj) {
          return obj.model;
        }));
      }
      _load_graphics();
    });
  }
  $scope.isHidden = function (code) {
    //determina se un widget è visibile o meno
    if ($scope.dashboardconfiguration.hidden_track_map) if ($scope.dashboardconfiguration.hidden_track_map[code]) return $scope.dashboardconfiguration.hidden_track_map[code];
    return false;
  };
  $scope.isWidgetVisible = function (widget) {
    //determina se un widget è visibile o meno in funzione della widgetTrackEditMode
    if ($scope.dashboardconfiguration.hidden_track_map) if ($scope.dashboardconfiguration.hidden_track_map[widget.code]) return !$scope.dashboardconfiguration.hidden_track_map[widget.code] || $scope.widgetTrackEditMode;
    return true;
  };
  $scope.hideWidget = function (code) {
    $scope.dashboardconfiguration.hidden_track_map = $scope.dashboardconfiguration.hidden_track_map || {}; //se non esiste una config ne creo una vuota
    if ($scope.dashboardconfiguration.hidden_track_map[code]) delete $scope.dashboardconfiguration.hidden_track_map[code];else $scope.dashboardconfiguration.hidden_track_map[code] = true;
    _load_graphics();
  };
  function uploadConfig(config) {
    //salva la config come una nuova entry
    recordFactory('dashboardconfiguration').create(config).$promise.then(function (resp_dasboardconfiguration) {
      _load_graphics();
      toaster.pop('success', 'Creato un nuovo dashboardconfiguration per il ruolo' + authFactory.getAuthData().info.commissions.current.code + '\': codice ' + resp_dasboardconfiguration.model.code);
      var filtro_ruolo = {
        'filtro_ruolo': sixFiltersLib.exact('model.role_id.code', $scope.ruolo_operatore.code)
      };
      recordFactory('dashboardconfiguration').search(filtro_ruolo).$promise.then(function (response) {
        if (!isEmpty(response.list)) {
          //controllo l'eventuale esistenza di una configurazione precedentemente salvata
          $scope.dashboardconfiguration_all_data = response.list[0];
        } else {
          console.log('ERROR I SHOULD NOT BE HERE');
        }
      });
    }, function (err) {
      toaster.error('uploadError', 'Impossibile salvare la configurazione');
    });
  }
  function updateConfig(config) {
    //Aggiorna la config
    $scope.dashboardconfiguration_all_data.model = Object.assign({}, config);
    var updated_config = Object.assign({}, $scope.dashboardconfiguration_all_data);
    recordFactory('dashboardconfiguration').update({
      id: $scope.dashboardconfiguration_all_data.version
    }, updated_config).$promise.then(function (response) {
      console.log('La configurazione è stata salvata');
    }, function (err) {
      if (err.data.message.search('concurrent versions') >= 0) {
        toaster.error('Impossibile salvare la configurazione', 'Un altro utente ha modificato questo configurazione. Ricarica i dati.');
      } else {
        toaster.error('Errore', 'Impossibile salvare la configurazione');
      }
    });
  }
  $scope.dashborad_version = {};
  $scope.enterEditMode = function () {
    //ingresso nella modalità di modifica
    _load_graphics();
    $scope.widgetTrackEditMode = true;
  };
  $scope.exitEditMode = function () {
    //funzione chiamata alla pressione di salva disposizione
    //salvo la configurazione
    if (!isEmpty($scope.ruolo_operatore)) {
      var filtro_ruolo = {
        'filtro_ruolo': sixFiltersLib.exact('model.role_id.code', $scope.ruolo_operatore.code)
      };
      recordFactory('dashboardconfiguration').search(filtro_ruolo).$promise.then(function (response) {
        //controllo l'eventuale esistenza di una configurazione precedentemente salvata
        if (!isEmpty(response.list)) {
          //esiste già, la aggiorno
          $scope.dashboardconfiguration_all_data = response.list[0];
          updateConfig($scope.dashboardconfiguration);
        } else {
          //non esiste, la creo
          uploadConfig($scope.dashboardconfiguration);
        }
      });
      load_trackingList();
      _reset_graphics();
      $scope.widgetTrackEditMode = false;
    } else {
      toaster.error('uploadError', 'per poter salvare la configurazione è necessario selezionare un ruolo');
    }
  };
  $scope.urlHandler = function (url) {
    if ($scope.widgetTrackEditMode == true) return '';
    return url;
  };
  $scope.clearRuoloFilter = function () {
    //chiamata allo svuotamento del filtro sui ruoli
    $scope.widgetList = {};
    $scope.ruolo_operatore = {};
    _reset_graphics();
  };
  $scope.updateRuoloFilter = function (ruolo) {
    //chiamata alla selezione di un altro ruolo
    $scope.ruolo_operatore.code = ruolo.code;
    $scope.ruolo_operatore.description = ruolo.description;
    $scope.ruolo_operatore.UUID = ruolo.UUID;
    _load_trackingList();
  };
  $scope.removeWidget = function (code) {
    var filtro_code = {
      'filtro_code': sixFiltersLib.exact('model.code', code)
    };
    recordFactory('trackinglist').search(filtro_code).$promise.then(function (response) {
      if (!isEmpty(response.list)) {
        //controllo l'eventuale esistenza di una configurazione precedentemente salvata
        $scope.trackinglist = response.list[0];
        recordFactory('trackinglist')["delete"]({
          id: $scope.trackinglist.version
        }).$promise.then(function (response) {
          if (!isEmpty(response)) {
            if ($scope.dashboardconfiguration.hidden_track_map[code])
              //elimino eventuali configurazioni salvate
              delete $scope.dashboardconfiguration.hidden_track_map[code];
            _load_all_tracks();
          } else {
            toaster.error('Errore', 'Errore nell\'eliminare la configurazione');
          }
        });
      } else {
        toaster.error('Errore', 'Errore nel caricare la configurazione');
      }
    });
  };
  function _reset_graphics() {
    //reimposta l'effetto blur di tutti gli elementi
    for (var key in $scope.widgetList) {
      $scope.blurredWidgetStyle[$scope.widgetList[key].code] = {};
    }
  }
  function _load_graphics() {
    //gestisce l'effetto blur
    console.log($scope.widgetList.length);
    for (var key in $scope.widgetList) {
      //controllo esistenza del dato
      console.log($scope.widgetList[key].code);
      $scope.dashboardconfiguration.hidden_track_map = $scope.dashboardconfiguration.hidden_track_map || {};
      if ($scope.dashboardconfiguration.hidden_track_map[$scope.widgetList[key].code]) $scope.blurredWidgetStyle[$scope.widgetList[key].code] = {
        'opacity': '0.6'
      };else $scope.blurredWidgetStyle[$scope.widgetList[key].code] = {};
    }
  }
  $scope.createTrackingListItem = function () {
    TrackSrv.creatioDialog().then(function (data) {
      console.log(data.id, 'closed with value', data.value);
      if (data.value == 'saved') {
        load_trackingList();
      }
    });
  };
  function isEmpty(obj) {
    //Verifica se un object è vuoto
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }

  /**
   * MAIN
   */
  load_trackingList();

  /** ***********************************
  * Check permissions
     * ***********************************/
  var RESOURCE_NAME = 'commission';
  $scope.superuser = function () {
    return $scope.isWritePermAllowed() && $scope.isDeletePermAllowed();
  };
  $scope.isWritePermAllowed = function () {
    //true se l'utente può modificare la visualizzazione dei widget
    return authFactory.isWritePermAllowed(RESOURCE_NAME, true);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME, true);
  };
}]).controller('TrackModalCtrl', ['$scope', '$location', 'toaster', 'authFactory', 'issueFactory', 'recordFactory', 'IssueSrv', 'commissionFactory', 'loadingBarService', function ($scope, $location, toaster, authFactory, issueFactory, recordFactory, IssueSrv, commissionFactory, loadingBarService) {
  var regex = /[^\w_]/g; //tutti i caratteri, meno alfanumerici e underscore
  var second_regex = /^(\d)(.*)/; //primo carattere della stringa numerico

  $scope.commissionLoaded = false;
  $scope.track = {};
  $scope.isCommissionModeEnabled = false;
  ;
  $scope.commissionslist = [];
  $scope.commissions = {
    selected: [{
      key: authFactory.getAuthData().info.commissions.current.code,
      description: authFactory.getAuthData().info.commissions.current.description
    }]
  };
  loadingBarService.start('Caricamento commesse, attendere...');
  commissionFactory().getCommissionsList({
    page_size: 100
  }).$promise.then(function (response) {
    if (response.list) {
      for (var idx in response.list) {
        $scope.commissionslist.push({
          key: response.list[idx].code,
          description: response.list[idx].description
        });
      }
    }
    $scope.commissionLoaded = true;
    loadingBarService.stop();
  })["catch"](function (e) {
    loadingBarService.stop();
    toaster.pop('error', '', 'Errore caricamento commesse.');
    $scope.commissionslist.push({
      key: authFactory.getAuthData().info.commissions.current.code,
      description: authFactory.getAuthData().info.commissions.current.description
    });
    $scope.commissionLoaded = true;
  });
  $scope.save = function () {
    //controlla se esiste già un widget con lo stesso codice
    if ($scope.superuser()) {
      var code;
      //assegno al code il titolo formattato
      if (regex.test($scope.track.title) || second_regex.test($scope.track.title)) code = $scope.track.title.replace(second_regex, '_' + $scope.track.title.split(-1)).replace(regex, '');else code = $scope.track.title;
      //controllo se esiste già un widget con questo codice
      var filtro_titolo = {
        'filtro_titolo': sixFiltersLib.exact('model.code', code)
      };
      recordFactory('trackinglist').search(filtro_titolo).$promise.then(function (response) {
        if (!isEmpty(response.list)) {
          //esiste già
          toaster.error('titleError', 'Esiste già un elemento con questo titolo.');
        } else {
          //non esiste, creo una nuova entry
          var tmp_track = {};
          tmp_track.title = $scope.track.title;
          tmp_track.description = $scope.track.description;
          tmp_track.url = $scope.track.url;
          var tmp_tracklist = {};
          tmp_tracklist.code = code;
          tmp_tracklist.track = tmp_track;
          //commission
          if (!$scope.isCommissionModeEnabled && $scope.commissions.selected.length > 0) {
            var tmp_selected_commissions = [];
            for (var idx in $scope.commissions.selected) {
              tmp_selected_commissions.push($scope.commissions.selected[idx].key);
            }
            tmp_tracklist.commission = tmp_selected_commissions;
          }
          uploadTrack(tmp_tracklist);
        }
      });
    } else {
      toaster.error('Errore', 'Devi essere un amministratore per poter effettuare questa operazione. Se sei un amministratore e appare questo messaggio, contatta l\'assistenza');
    }
  };
  function uploadTrack(tracklist) {
    //carica la nuova entry e chiude il dialog
    recordFactory('trackinglist').create(tracklist).$promise.then(function (resp_trackinglist) {
      console.log('Creato una nuova trackinglist con codice: ' + resp_trackinglist.model.code);
      uploadTrackConfig(resp_trackinglist.model.code);
    }, function (err) {
      toaster.error('uploadError', 'Impossibile salvare la trackinglist');
    });
  }
  $scope.dashboardconfiguration_all_data = {};
  $scope.dashboardconfiguration = {};
  $scope.dashboardconfiguration.hidden_track_map = {};
  $scope.ruoli = {};
  $scope.commission = [];
  $scope.activeWidgetMap = {};
  var activewidgetMap_keyset = ['tracking', 'quality-management', 'business', 'document', 'issue', 'contact']; //da aggiornare in caso di aggiunta o rimozione di widget.

  function uploadTrackConfig(code) {
    recordFactory('ruolooperatore').fetchAll({}).$promise.then(function (response) {
      //per tutti gli operatori
      if (response.length) {
        $scope.ruoli = response.map(sixObjectLib.recordToHisRef);
        $scope.ruoli.forEach(function (entry) {
          var filtro_ruolo = {
            'filtro_ruolo': sixFiltersLib.exact('model.role_id.code', entry.code)
          };
          recordFactory('dashboardconfiguration').search(filtro_ruolo).$promise.then(function (response) {
            //TODO - Deve impostare PER TUTTE LE COMMESSE non solo la corrente.
            if (!isEmpty(response.list)) {
              //Se non è vuota, una dashboardconfiguration esiste già, la aggiorno con il dato
              $scope.dashboardconfiguration_all_data = response.list[0];
              $scope.dashboardconfiguration = response.list[0].model;
              if (!$scope.dashboardconfiguration.hasOwnProperty('hidden_track_map')) {
                $scope.dashboardconfiguration.hidden_track_map = {};
              }
              $scope.dashboardconfiguration.hidden_track_map[code] = true;
              updateConfig($scope.dashboardconfiguration);
            } else {
              //Può capitare che non sia stata ancora configurata una dashboardconfiguration per il ruolo scelto, provvedo a crearne una con i valori di default (settando il nuovo dato come "hidden").
              for (var i = 0; i < activewidgetMap_keyset.length; i++) {
                $scope.activeWidgetMap[activewidgetMap_keyset[i]] = true;
              }
              //caricamento della nuova config

              $scope.dashboardconfiguration.role_id = Object.assign({}, entry);
              $scope.dashboardconfiguration.commission = authFactory.getAuthData().info.commissions.current.code;
              $scope.dashboardconfiguration.code = entry.code;
              $scope.dashboardconfiguration.active_widget_map = $scope.activeWidgetMap;
              $scope.dashboardconfiguration.hidden_track_map[code] = true;
              uploadConfig($scope.dashboardconfiguration);
            }
            $scope.closeThisDialog('saved'); //dismiss dialog
          });
        });
      } else {
        toaster.error('Errore nel caricamento della config per il tracking appena creato.');
      }
    });
  }
  function updateConfig(config) {
    $scope.dashboardconfiguration_all_data.model = Object.assign({}, config);
    var updated_config = Object.assign({}, $scope.dashboardconfiguration_all_data);
    recordFactory('dashboardconfiguration').update({
      id: $scope.dashboardconfiguration_all_data.version
    }, updated_config).$promise.then(function (response) {
      console.log('La configurazione è stata salvata');
    }, function (err) {
      if (err.data.message.search('concurrent versions') >= 0) {
        toaster.error('Impossibile salvare la configurazione', 'Un altro utente ha modificato questo configurazione. Ricarica i dati.');
      } else {
        toaster.error('Errore', 'Impossibile salvare la configurazione');
      }
    });
  }
  function uploadConfig(config) {
    //salva la config come una nuova entry
    recordFactory('dashboardconfiguration').create(config).$promise.then(function (resp_dasboardconfiguration) {
      console.log('Creato un nuovo dashboardconfiguration per il ruolo' + authFactory.getAuthData().info.commissions.current.code + '\': codice ' + resp_dasboardconfiguration.model.code);
    }, function (err) {
      toaster.error('uploadError', 'Impossibile salvare la configurazione');
    });
  }
  function isEmpty(obj) {
    //Verifica se un object è vuoto
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }

  /** ***********************************
  * Check permissions
     * ***********************************/
  var RESOURCE_NAME = 'commission';
  $scope.superuser = function () {
    return $scope.isWritePermAllowed() && $scope.isDeletePermAllowed();
  };
  $scope.isWritePermAllowed = function () {
    //true se l'utente può modificare la visualizzazione dei widget
    return authFactory.isWritePermAllowed(RESOURCE_NAME, true);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME, true);
  };
}]).controller('LinkEditModalCtrl', ['$scope', '$location', 'toaster', 'authFactory', 'issueFactory', 'recordFactory', 'IssueSrv', function ($scope, $location, toaster, authFactory, issueFactory, recordFactory, IssueSrv) {
  $scope.link = {};
  $scope.link.url = $scope.ngDialogData.url;
  $scope.save = function () {
    //saves new home link
    if ($scope.superuser()) {
      if ($scope.ngDialogData.url === $scope.link.url) {
        toaster.pop('success', 'La trackinglist è stata salvata');
        $scope.closeThisDialog(); //chiudo il dialog
      } else {
        //assegno al code l'attuale commessa
        var code = authFactory.getAuthData().info.commissions.current.code + '_' + authFactory.getAuthData().info.commissions.current.description;
        //controllo se esiste già un widget con questo codice
        var filtro_titolo = {
          'filtro_titolo': sixFiltersLib.exact('model.code', code)
        };
        recordFactory('trackinglist').search(filtro_titolo).$promise.then(function (response) {
          if (!isEmpty(response.list)) {
            //esiste già, lo aggiorno
            var tmp_track = {};
            tmp_track.url = $scope.link.url;
            var tmp_tracklist = response.list[0];
            tmp_tracklist.model.track = tmp_track;
            tmp_tracklist.model.home = true;
            updateTrack(tmp_tracklist);
          } else {
            //non esiste, creo una nuova entry
            var tmp_track = {};
            tmp_track.url = $scope.link.url;
            var tmp_tracklist = {};
            tmp_tracklist.code = code;
            tmp_tracklist.home = true; //IDENTIFICATORE URL HOME_PAGE --> verrà ignorato nelle sotto-cartelle
            tmp_tracklist.track = tmp_track;
            uploadTrack(tmp_tracklist);
          }
        });
      }
    } else {
      toaster.error('Errore', 'Devi essere un amministratore per poter effettuare questa operazione. Se sei un amministratore e appare questo messaggio, contatta l\'assistenza');
    }
    //$scope.closeThisDialog('saved');
  };

  function uploadTrack(tracklist) {
    //carica la nuova entry e chiude il dialog
    recordFactory('trackinglist').create(tracklist).$promise.then(function (resp_trackinglist) {
      console.log('Creato una nuova trackinglist con codice: ' + resp_trackinglist.model.code);
      $scope.closeThisDialog('saved'); //chiudo il dialog
      //non serve caricare nessuna config per ora -> selve solo per salvare un eventuale link nella home
    }, function (err) {
      toaster.error('uploadError', 'Impossibile salvare la trackinglist');
    });
  }
  function updateTrack(tracklist) {
    recordFactory('trackinglist').update({
      id: tracklist.version
    }, tracklist).$promise.then(function (response) {
      $scope.closeThisDialog('saved'); //chiudo il dialog
      console.log('La trackinglist è stata salvata');
    }, function (err) {
      if (err.data.message.search('concurrent versions') >= 0) {
        toaster.error('Impossibile salvare la trackinglist', 'Un altro utente ha modificato questa trackinglist. Ricarica i dati.');
      } else {
        toaster.error('Errore', 'Impossibile salvare la trackinglist');
      }
    });
  }
  function isEmpty(obj) {
    //Verifica se un object è vuoto
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }

  /** ***********************************
  * Check permissions
     * ***********************************/
  var RESOURCE_NAME = 'commission';
  $scope.superuser = function () {
    return $scope.isWritePermAllowed() && $scope.isDeletePermAllowed();
  };
  $scope.isWritePermAllowed = function () {
    //true se l'utente può modificare la visualizzazione dei widget
    return authFactory.isWritePermAllowed(RESOURCE_NAME, true);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME, true);
  };
}]);
'use strict';

angular.module('emma.portal').service('LinkSrv', ['ngDialog', 'authFactory', 'localStorageService', function (ngDialog, authFactory, localStorageService) {
  return {
    creatioDialog: function creatioDialog(link) {
      return ngDialog.open({
        template: 'portal/home/link-modal.html',
        controller: 'LinkEditModalCtrl',
        className: 'ngdialog-theme-default',
        appendClassName: 'ngdialog-track-create',
        closeByNavigation: true,
        data: {
          url: link
        }
      }).closePromise;
    }
  };
}]);
'use strict';

angular.module('emma.portal').service('TrackSrv', ['ngDialog', 'authFactory', 'localStorageService', function (ngDialog, authFactory, localStorageService) {
  return {
    getFileIcon: function getFileIcon(fileName) {
      if (fileName) {
        switch (fileName.substring(fileName.lastIndexOf('.') + 1)) {
          default:
            return 'images/portal/app.svg';
        }
      }
    },
    creatioDialog: function creatioDialog() {
      return ngDialog.open({
        template: 'portal/home/track-modal.html',
        controller: 'TrackModalCtrl',
        className: 'ngdialog-theme-default',
        appendClassName: 'ngdialog-track-create',
        closeByNavigation: true
      }).closePromise;
    },
    getMineOperator: function getMineOperator() {
      var operator = localStorageService.get('operatore');
      var ref = sixObjectLib.recordToHisRef(operator);
      var role = !operator.model.typeoperator_map ? null : operator.model.typeoperator_map[authFactory.getAuthData().info.commissions.current.code] || operator.model.typeoperator_map['tutte'];
      return {
        operator: ref,
        role: role
      };
    }
  };
}]);
'use strict';

angular.module('emma.portal').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/issue', {
    templateUrl: 'portal/issue/issue-list.html',
    controller: 'IssueCtrl',
    resolve: {
      onlyMine: function onlyMine() {
        return null;
      }
    }
  }).when('/avvisi', {
    templateUrl: 'portal/issue/issue-list.html',
    controller: 'IssueCtrl',
    resolve: {
      onlyMine: ["recordFactory", "authFactory", function onlyMine(recordFactory, authFactory) {
        return recordFactory('operatore').search({
          'model.username': sixFiltersLib.exact('model.username', authFactory.getAuthData().authId)
        }).$promise.then(function (resp) {
          if (resp.list || resp.list.length == 1) {
            return sixObjectLib.recordToHisRef(resp.list[0]);
          }
          return null;
        }, function (err) {
          return null;
        });
      }]
    }
  }).when('/issue/:uuid', {
    templateUrl: 'portal/issue/issue-detail.html',
    controller: 'IssueDetailCtrl'
  });
}]).controller('IssueCtrl', ['$scope', '$timeout', '$location', 'toaster', 'recordFactory', 'issueFactory', 'IssueSrv', 'onlyMine', '$q', function ($scope, $timeout, $location, toaster, recordFactory, issueFactory, IssueSrv, onlyMine, $q) {
  var PATH_ISSUE_RECORD = 'issue/record';
  $scope.onlyMineOpened = onlyMine != null;
  $scope.paginatedRequest = {
    page_size: 25,
    page: 1,
    show_revision: false,
    sort_fields: 'date_requested:desc'
  };
  $scope.statues = ['Aperto', 'Annullato', 'Chiuso'];
  $scope.sla_states = [{
    code: 'OK',
    description: 'Rispettata',
    "class": 'fa fa-check-circle-o text-success'
  }, {
    code: 'KO',
    description: 'Violata',
    "class": 'fa fa-times-circle-o text-danger'
  }, {
    code: 'NA',
    description: 'N/A',
    "class": ''
  }];
  $scope.filter = {
    status: {},
    sla: {},
    priorities: []
    // VERSIONE FILTRI SIX-LOOKUP
    // segnalazioninonconformi: {},
    // azionicorrettive: {}
  };

  $scope.clearFilter = function () {
    $scope.filter = {
      status: {},
      sla: {},
      priorities: []
    };
    $scope.loadData();
  };
  var buffered;
  $scope.loadData = function () {
    if (buffered) $timeout.cancel(buffered);
    buffered = $timeout(function () {
      var filter = compueFilter();
      issueFactory(PATH_ISSUE_RECORD).search($scope.paginatedRequest, filter).$promise.then(function (response) {
        $scope.issueResponse = response;
        $scope.selectAllSelector = false;
      }, function (err) {
        toaster.error('', 'Impossibile caricare le segnalazioni');
      });
    }, 200);
  };
  $scope.goToIssue = function (issue) {
    $location.path('issue/' + issue.UUID);
  };
  $scope.hasAttachment = function (issue) {
    var attachments = issue.model.attachments;
    attachments = attachments && attachments.length && attachments[0];
    if (attachments && attachments.folder) {
      return attachments.nodes && attachments.nodes.length && !attachments.nodes[0].folder;
    }
    return attachments;
  };
  $scope.createIssue = function () {
    IssueSrv.creatioDialog().then(function (data) {
      console.log(data.id, 'closed with value', data.value);
      if (data.value == 'saved') {
        $scope.loadData();
      }
    });
  };
  $scope.getStatusClass = IssueSrv.getStatusIcon;
  function compueFilter() {
    var sixFilter = {};
    if (onlyMine && onlyMine.UUID) {
      sixFilter.mine = sixFiltersLib.exact('reporter_id.UUID', onlyMine.UUID);
      sixFilter.opened = sixFiltersLib.exact('status', "Aperto");
    }
    var statues = [];
    angular.forEach($scope.filter.status, function (value, key) {
      if (value) {
        statues.push(key);
      }
    });
    if (statues.length) {
      sixFilter.status = sixFiltersLib["in"]('status', statues);
    }
    //SLA
    if ($scope.filter.sla['OK'] || $scope.filter.sla['KO'] || $scope.filter.sla['NA']) {
      var slaFilters = {};
      if ($scope.filter.sla['OK']) {
        slaFilters['OK'] = sixFiltersLib.match('model.tempistiche_SLA', true, sixFiltersLib.CONSTRAINTS.OR);
      }
      if ($scope.filter.sla['KO']) {
        slaFilters['KO'] = sixFiltersLib.match('model.tempistiche_SLA', false, sixFiltersLib.CONSTRAINTS.OR);
      }
      if ($scope.filter.sla['NA']) {
        slaFilters['NA'] = sixFiltersLib.missing('model.tempistiche_SLA', sixFiltersLib.CONSTRAINTS.OR);
      }
      sixFilter.sla = sixFiltersLib.must(slaFilters);
    }
    if ($scope.filter.priority) {
      sixFilter.priority = sixFiltersLib.exact('model.priority_id.UUID', $scope.filter.priority.UUID);
    }
    if ($scope.filter.note && $scope.filter.note.length) {
      sixFilter.note = sixFiltersLib.text('model.note', '*' + $scope.filter.note + '*');
    }
    if ($scope.filter.reporter && $scope.filter.reporter.length) {
      sixFilter.reporter = sixFiltersLib.must({
        desc: sixFiltersLib.text('reporter_id.description', '*' + $scope.filter.reporter + '*', sixFiltersLib.CONSTRAINTS.OR),
        code: sixFiltersLib.text('reporter_id.code', '*' + $scope.filter.reporter + '*', sixFiltersLib.CONSTRAINTS.OR)
      });
    }
    if ($scope.filter.to) {
      sixFilter.lte = sixFiltersLib.rangeLte('date_requested', moment($scope.filter.to).endOf('day').format());
    }
    if ($scope.filter.from) {
      sixFilter.gte = sixFiltersLib.rangeGte('date_requested', moment($scope.filter.from).startOf('day').format());
    }
    //data chiusura
    if ($scope.filter.to_cl) {
      sixFilter.lte_cl = sixFiltersLib.rangeLte('date_closing', moment($scope.filter.to_cl).endOf('day').format());
    }
    if ($scope.filter.from_cl) {
      sixFilter.gte_cl = sixFiltersLib.rangeGte('date_closing', moment($scope.filter.from_cl).startOf('day').format());
    }

    //reparto
    if ($scope.filter.reparto && $scope.filter.reparto.length) {
      sixFilter.reparto = sixFiltersLib.must({
        desc: sixFiltersLib.text('model.record_id.description', '*' + $scope.filter.reparto + '*', sixFiltersLib.CONSTRAINTS.OR),
        code: sixFiltersLib.text('model.record_id.code', '*' + $scope.filter.record + '*', sixFiltersLib.CONSTRAINTS.OR)
      });
    }
    //categoria
    if ($scope.filter.categoria && $scope.filter.categoria.length) {
      sixFilter.categoria = sixFiltersLib.must({
        desc: sixFiltersLib.text('model.categoria.description', '*' + $scope.filter.categoria + '*', sixFiltersLib.CONSTRAINTS.OR),
        code: sixFiltersLib.text('model.categoria.code', '*' + $scope.filter.categoria + '*', sixFiltersLib.CONSTRAINTS.OR)
      });
    }
    //sottocategoria
    if ($scope.filter.sottocategoria && $scope.filter.sottocategoria.length) {
      sixFilter.sottocategoria = sixFiltersLib.must({
        desc: sixFiltersLib.text('model.sottocategoria.description', '*' + $scope.filter.sottocategoria + '*', sixFiltersLib.CONSTRAINTS.OR),
        code: sixFiltersLib.text('model.sottocategoria.code', '*' + $scope.filter.sottocategoria + '*', sixFiltersLib.CONSTRAINTS.OR)
      });
    }
    //Segnalazioni non conformi
    if ($scope.filter.segnalazioninonconformi && $scope.filter.segnalazioninonconformi) {
      sixFilter.segnalazioninonconformi = sixFiltersLib.must({
        desc: sixFiltersLib.text('model.segnalazioninonconformi.description', '*' + $scope.filter.segnalazioninonconformi + '*', sixFiltersLib.CONSTRAINTS.OR),
        code: sixFiltersLib.text('model.segnalazioninonconformi.code', '*' + $scope.filter.segnalazioninonconformi + '*', sixFiltersLib.CONSTRAINTS.OR)
      });
    }
    //azioni correttive
    if ($scope.filter.azionicorrettive && $scope.filter.azionicorrettive) {
      sixFilter.azionicorrettive = sixFiltersLib.must({
        desc: sixFiltersLib.text('model.azionicorrettive.description', '*' + $scope.filter.azionicorrettive + '*', sixFiltersLib.CONSTRAINTS.OR),
        code: sixFiltersLib.text('model.azionicorrettive.code', '*' + $scope.filter.azionicorrettive + '*', sixFiltersLib.CONSTRAINTS.OR)
      });
    }
    // VERSIONE FILTRI SIX-LOOKUP
    // //Segnalazioni non conformi
    // if($scope.filter.segnalazioninonconformi.selected_item && $scope.filter.segnalazioninonconformi.selected_item.code){
    //   sixFilter.segnalazioninonconformi = sixFiltersLib.must({
    //     code:   sixFiltersLib.text('model.segnalazioninonconformi.code', $scope.filter.segnalazioninonconformi.selected_item.code, sixFiltersLib.CONSTRAINTS.OR)
    //   })
    // }
    // //azioni correttive
    // if($scope.filter.azionicorrettive.selected_item && $scope.filter.azionicorrettive.selected_item.code){
    //   sixFilter.azionicorrettive = sixFiltersLib.must({
    //     code:   sixFiltersLib.text('model.azionicorrettive.code', $scope.filter.azionicorrettive.selected_item.code, sixFiltersLib.CONSTRAINTS.OR)
    //   })
    // }
    return sixFilter;
  }
  function init() {
    recordFactory('priorita').fetchAll({}).$promise.then(function (response) {
      if (response.length) {
        $scope.priorities = response.map(sixObjectLib.recordToHisRef);
      } else {
        toaster.warning('', 'I livelli di priorità  non sono stati configurati');
      }
    }, function (err) {
      toaster.warning('Proitità', 'Impossibile trovare le priorità');
    });
  }
  $scope.selectAllHandler = function () {
    var counter = 0;
    for (var i = 0; i < $scope.issueResponse.list.length; i++) {
      if ($scope.issueResponse.list[i].checked) {
        counter++;
      }
    }
    if (counter == 0) {
      _selectAllApply(true);
    } else if (counter == $scope.issueResponse.list.length) {
      _selectAllApply(false);
    } else {
      _selectAllApply(true);
    }
  };
  function _selectAllApply(type) {
    //type ù-> seleziono tutto . !type-> deseleziono tutto
    $scope.issueResponse.list.forEach(function (item) {
      if (type) {
        item.checked = true;
      } else {
        if (item.hasOwnProperty('checked')) {
          delete item.checked;
        }
      }
    });
  }

  //EXPORT
  $scope.export_filetypes_list = ['CSV', 'XLS'];
  $scope.exportIssueList = function (filetype) {
    if ($scope.export_filetypes_list.includes(filetype)) {
      var current_date = moment();
      var filename = 'export_segnalazioni_' + current_date.date() + '_' + current_date.month() + '_' + current_date.year();
      if (filetype === $scope.export_filetypes_list[0]) {
        //CSV
        if (!_isAllSelected()) {
          //export selected
          _genFakeGridApi(false).then(function (fake_gridApi) {
            if (fake_gridApi) {
              sixExportLib.exportCSVAllRowsGrid(fake_gridApi, filename);
            }
          });
        } else {
          //export ALL
          _genFakeGridApi(true).then(function (fake_gridApi) {
            if (fake_gridApi) {
              sixExportLib.exportCSVAllRowsGrid(fake_gridApi, filename);
            }
          });
        }
      }
      if (filetype === $scope.export_filetypes_list[1]) {
        //XLS
        if (!_isAllSelected()) {
          //export selected
          _genFakeGridApi(false).then(function (fake_gridApi) {
            if (fake_gridApi) {
              sixExportLib.exportXLSXAllRowsGrid(fake_gridApi, filename);
            }
          });
        } else {
          //export ALL
          _genFakeGridApi(true).then(function (fake_gridApi) {
            if (fake_gridApi) {
              sixExportLib.exportXLSXAllRowsGrid(fake_gridApi, filename);
            }
          });
        }
      }
    }
  };
  function _genFakeGridApi(exportAll) {
    var promise = $q.defer();
    var gridApi = {
      grid: {
        options: {}
      }
    };
    gridApi.grid.options.columnDefs = _genFakeColumnDefs();
    if (!exportAll) {
      _genFakeRows($scope.issueResponse.list).then(function (rows) {
        if (rows) {
          _setVisibleRows(rows).then(function (selected_gridApi) {
            gridApi.grid.rows = selected_gridApi;
            promise.resolve(gridApi);
          })["catch"](function (empty_gridApi) {
            gridApi.grid.rows = empty_gridApi;
            promise.resolve(gridApi);
          });
        } else {
          promise.reject();
        }
      });
    } else {
      _genFakeRows().then(function (rows) {
        if (rows) {
          gridApi.grid.rows = rows;
          promise.resolve(gridApi);
        } else {
          promise.reject();
        }
      });
    }
    return promise.promise;
  }
  function _genFakeColumnDefs() {
    //HARDCODED FIELDS
    var cols = [{
      field: "date_insertion",
      name: "Data inserimento",
      exportFormat: 'd'
    }, {
      field: "date_closing",
      name: "Data chiusura",
      exportFormat: 'd'
    }, {
      field: "model.record_id.description",
      name: "Descrizione reparto"
    }, {
      field: "model.priority_id.description",
      name: "Priorità"
    }, {
      field: "model.description",
      name: "Titolo"
    }, {
      field: "model.note",
      name: "Descrizione"
    }, {
      field: "reporter_id.description",
      name: "Utente"
    }, {
      field: "status",
      name: "Stato"
    }, {
      field: "model.approvazione",
      name: "Stato approvazione"
    }, {
      field: "model.utente_approvatore.description",
      name: "Utente approvatore"
    }, {
      field: "model.data_approvazione",
      name: "Data approvazione",
      exportFormat: 'd'
    }, {
      field: "model.categoria.description",
      name: "Categoria"
    }, {
      field: "model.sottocategoria.description",
      name: "Sottocategoria"
    }, {
      field: "model.quantity",
      name: "Quantità"
    }];
    return cols;
  }
  function _genFakeRows(list) {
    var promise = $q.defer();
    var rows = [];
    var tmp_request = angular.copy($scope.paginatedRequest);
    tmp_request.page_size = 10000;
    var filter = compueFilter();
    if (list) {
      list.forEach(function (item) {
        var row = {};
        row.entity = item;
        rows.push(row);
      });
      promise.resolve(rows);
    } else {
      issueFactory(PATH_ISSUE_RECORD).search(tmp_request, filter).$promise.then(function (response) {
        if (response && response.list && response.list.length) {
          response.list.forEach(function (item) {
            var row = {};
            row.entity = item;
            rows.push(row);
          });
          promise.resolve(rows);
        } else {
          promise.resolve(rows);
        }
      })["catch"](function (err) {
        promise.reject(err);
      });
    }
    return promise.promise;
  }
  function _setVisibleRows(rows) {
    var promise = $q.defer();
    var result = [];
    rows.forEach(function (row) {
      if (row.entity.checked == true) {
        result.push(row);
      }
    });
    if (result.length) {
      promise.resolve(result);
    } else {
      promise.reject(result);
    }
    return promise.promise;
  }
  function _isAllSelected() {
    var counter = 0;
    for (var i = 0; i < $scope.issueResponse.list.length; i++) {
      if ($scope.issueResponse.list[i].checked) {
        counter++;
      }
    }
    // return (counter == 0) || (counter == $scope.issueResponse.list.length)
    return counter == 0;
  }

  //SIDEBAR
  $scope.sidebar = {};
  $scope.sidebar.isVisible = false;
  $scope.openSidebar = function (item, key) {
    //key-> issueResponse.list.model.key
    $scope.sidebar = {};
    if (angular.isArray(item)) {
      $scope.sidebar[key] = angular.copy(item);
      $scope.sidebar.isVisible = true;
    } else {
      $scope.sidebar.isVisible = false;
    }
  };
  $scope.goToAzioneCorrettiva = function (azionecorrettiva) {
    $location.path('record/stable/azionecorrettiva/' + azionecorrettiva.UUID);
  };

  // MAIN
  $scope.loadData();
  init();
}]).controller('IssueDetailCtrl', ['$scope', '$routeParams', '$window', 'toaster', 'dialogService', 'issueFactory', 'issueWorkflow', 'IssueSrv', 'ALFRESCO_URL', 'authFactory', 'recordFactory', 'slaService', function ($scope, $routeParams, $window, toaster, dialogService, issueFactory, issueWorkflow, IssueSrv, ALFRESCO_URL, authFactory, recordFactory, slaService) {
  $scope.operator = IssueSrv.getMineOperator();
  $scope.replyOpenedIndex = -1;
  $scope.statues = ['Aperto', 'Annullato', 'Chiuso'];
  $scope.dowloadUrl = ALFRESCO_URL + '/api/alfresco/';
  $scope.getStatusClass = IssueSrv.getStatusIcon;
  $scope.readonly = !IssueSrv.canEdit();
  $scope.canDelete = IssueSrv.canDelete();
  $scope.status_approvazione = {};
  $scope.status_approvazione_list = [{
    key: 1,
    value: "Approvato"
  }, {
    key: 2,
    value: "Non Approvato"
  }, {
    key: 3,
    value: "In attesa"
  }];
  $scope.data_approvazione;
  $scope.operatoreFilter = {
    "operatoreFilter": sixFiltersLib.bool("model.utente_approvatore", true, sixFiltersLib.CONSTRAINTS.FILTER)
  };
  $scope.sla = {};
  $scope.back = function () {
    $window.history.back();
  };
  $scope.getDocumentClass = function () {
    if ($scope.attachment) {
      return IssueSrv.getFileIcon($scope.attachment.title);
    }
  };
  $scope.deleteIssue = function () {
    if ($scope.readonly) {
      toaster.error('Permesso negato', 'Non puoi effettuare modifiche. La richiesta è in sola lettura');
      return;
    }
    issueFactory('issue/record')["delete"]({
      id: $scope.issue.version
    }).$promise.then(function (response) {
      toaster.info('', 'La richiesta è stata eliminata');
      $scope.back();
    }, function (err) {
      toaster.error('Errore', 'Impossibile eliminare la richiesta');
    });
  };
  $scope.updateIssue = function () {
    if ($scope.readonly) {
      toaster.error('Permesso negato', 'Non puoi effettuare modifiche. La richiesta è in sola lettura');
      return;
    }
    dialogService.fillTextField('Note per passaggio di stato', function (status_note) {
      if (status_note != "") {
        $scope.issue.status_note = status_note;
      }
      issueWorkflow.setStatus($scope.issue.status, $scope.issue).then(function (response) {
        toaster.info('', 'La richiesta è stata salvata');
        if ($scope.issue.status === 'Chiuso') {
          slaService.isSLAEnabled(authFactory.getAuthData().info.commissions.current.code, $scope.issue.model.record_id.UUID).then(function (response) {
            if (response == true) {
              if (angular.isUndefined($scope.issue.model.tempistiche_SLA)) {
                $scope.issue.model.tempistiche_SLA = $scope.sla.isSLAValid;
                $scope.issue.model.date_time_consegna = $scope.sla.date_time_consegna.toISOString();
                $scope.issue.model.total_workhours = $scope.sla.total_workhours;
                _updateIssueSLA();
              }
            }
          });
        }
      }, function (err) {
        toaster.error('Errore', 'Impossibile salvare la richiesta');
      });
    });
  };
  $scope.updateStatusApprovazione = function (oldValue, newValue) {
    $scope.status_approvazione = newValue;
    if (newValue) {
      if (angular.isUndefined(oldValue) || oldValue.key != newValue.key) {
        $scope.issue.model.approvazione = $scope.status_approvazione.value;
        _updateIssueField('approvazione', $scope.issue.model.approvazione, $scope.issue).then(function (response) {
          _handleDateUpdate(newValue.value);
          toaster.info('', 'La richiesta è stata salvata');
        }, function (err) {
          toaster.error('Errore', 'Impossibile salvare la richiesta');
        });
      }
    } else {
      _handleDateUpdate(undefined);
    }
  };
  $scope.updateIssueUtenteApprovatore = function (utente) {
    $scope.issue.model.utente_approvatore = utente;
    issueFactory('issue/record').update({
      id: $scope.issue.version
    }, $scope.issue).$promise.then(function (response) {
      if (response) {
        $scope.issue.version = response.version;
      } else {
        throw 'ApprovazioneChangeError';
      }
    });
  };
  function _updateIssueSLA() {
    issueFactory('issue/record').update({
      id: $scope.issue.version
    }, $scope.issue).$promise.then(function (response) {
      if (response) {
        $scope.issue.version = response.version;
      } else {
        throw 'ApprovazioneChangeError';
      }
    });
  }
  function _updateIssueField(fieldToUpdate, value, issueObj) {
    //USAGE: fieldToUpdate-> stringa del campo da aggiornare | value => valore da aggiornare | issueObj -> issue da aggiornare
    if (angular.isUndefined(value) || angular.isUndefined(fieldToUpdate)) {
      throw 'UpdateIssueFieldError';
    } else {
      return issueFactory('issue/record').update({
        id: issueObj.version
      }, issueObj).$promise.then(function (response) {
        if (response && response.model[fieldToUpdate] === value) {
          issueObj.version = response.version;
          return issueObj;
        } else {
          throw 'UpdateIssueFieldError';
        }
      });
    }
  }
  $scope.loadData = function () {
    return issueFactory('issue/record/_uuid/' + $routeParams.uuid).getUUID().$promise.then(function (response) {
      if (response.model) {
        $scope.issue = response;
        if (!response.model.comments) {
          response.model.comments = [];
        }
        var attachments = $scope.issue.model.attachments;
        attachments = attachments && attachments.length && attachments[0];
        if (attachments && attachments.folder) {
          attachments = attachments.nodes && attachments.nodes.length && !attachments.node[0].folder && attachments.node[0];
        }
        $scope.attachment = attachments;
        if (angular.isUndefined($scope.issue.model.approvazione)) {
          $scope.status_approvazione = $scope.status_approvazione_list[2];
          $scope.issue.model.approvazione = $scope.status_approvazione.value;
        } else {
          var found_value = $scope.status_approvazione_list.filter(function (current_status) {
            return current_status.value === $scope.issue.model.approvazione;
          })[0]; //prendo solo il primo elemento in quanto l'array è univoco
          $scope.status_approvazione = found_value;
        }
        if (angular.isDefined($scope.issue.model.data_approvazione)) {
          $scope.data_approvazione = moment($scope.issue.model.data_approvazione).toDate(); //formato leggibile dal sixdatetimepicker
        }

        _isRepartoAllowed();
        slaService.isSLAEnabled(authFactory.getAuthData().info.commissions.current.code, $scope.issue.model.record_id.UUID).then(function (response) {
          if (response == true) {
            if (angular.isDefined($scope.issue.model.tempistiche_SLA)) {
              $scope.sla.enableSLA = true;
              $scope.sla.isSLAValid = $scope.issue.model.tempistiche_SLA;
              $scope.sla.date_time_consegna = moment($scope.issue.model.date_time_consegna);
              $scope.sla.total_workhours = $scope.issue.model.total_workhours;
            } else {
              var commissionCode = authFactory.getAuthData().info.commissions.current.code;
              var repartoCode = $scope.issue.model.record_id.UUID;
              var openTime = $scope.issue.date_insertion;
              var closeTime = $scope.issue.date_closing;
              $scope.sla.enableSLA = true;
              slaService.getSLA(commissionCode, repartoCode, openTime, closeTime).then(function (response) {
                if (response) {
                  $scope.sla.isSLAValid = response.isValid;
                  $scope.sla.date_time_consegna = response.date_time_consegna;
                  $scope.sla.total_workhours = response.total_workhours;
                }
              });
            }
          }
        });
      } else {
        toaster.error('', 'La segnalazione non esiste');
      }
    }, function (err) {
      toaster.error('', 'Impossiblie caricare la segnalazione');
    });
  };
  $scope.getInitial = function (val) {
    return val.trim().split(/\s+/).map(function (term) {
      return term[0].toUpperCase();
    }).slice(0, 2).join('');
  };
  $scope.addComment = function (text) {
    $scope.issue.model.comments.push({
      author: $scope.operator.operator,
      author_role: $scope.operator.role,
      creation_date: new Date(),
      text: text,
      replies: []
    });
    update();
  };
  $scope.addReply = function (text, comment) {
    $scope.replyOpenedIndex = -1;
    comment.replies.push({
      author: $scope.operator.operator,
      author_role: $scope.operator.role,
      creation_date: new Date(),
      text: text
    });
    update();
  };
  $scope.toggleReply = function (index) {
    $scope.replyOpenedIndex = $scope.replyOpenedIndex == index ? -1 : index;
  };
  function update() {
    issueFactory('issue/record').update({
      id: $scope.issue.version
    }, $scope.issue).$promise.then(function (response) {
      toaster.info('', 'La richiesta è stata salvata');
      $scope.issue = angular.copy(response);
    }, function (err) {
      if (err.data.message.search('concurrent versions') >= 0) {
        toaster.error('Impossibile salvare la richiesta', 'Un altro utente ha modificato questo richiesta. Ricarica i dati.');
      } else {
        toaster.error('Errore', 'Impossibile salvare la richiesta');
      }
    });
  }
  function _isRepartoAllowed() {
    var repartoFilter = {
      'UUID': sixFiltersLib.exact('UUID', $scope.issue.model.record_id.UUID)
    };
    recordFactory('reparto').search(repartoFilter).$promise.then(function (resp) {
      if (resp.list) {
        if (resp.list.length && resp.list[0].model.enable_approvazione) {
          $scope.isRepartoAllowed = true;
        } else {
          $scope.isRepartoAllowed = false;
        }
      }
    })["catch"](function (err) {
      $scope.isRepartoAllowed = false;
    });
  }

  /**
   * DATE
   *  */
  $scope.dateFormat = 'dd MMMM yyyy';
  function _handleDateUpdate(stato_approvazione) {
    if (angular.isUndefined(stato_approvazione)) {
      _resetDate();
    } else {
      if (stato_approvazione === 'Approvato') {
        var now = moment().toISOString(); //formato per caricare il valore sul DB
        $scope.data_approvazione = moment(now).toDate(); //formato leggibile dal sixdatetimepicker
        $scope.issue.model.data_approvazione = now;
        _updateIssueField('data_approvazione', $scope.issue.model.data_approvazione, $scope.issue);
      } else {
        _resetDate();
      }
    }
  }
  function _resetDate() {
    $scope.data_approvazione = undefined;
    if (angular.isDefined($scope.issue.model.data_approvazione)) {
      delete $scope.issue.model.data_approvazione;
      _updateIssueField('data_approvazione', $scope.issue.model.data_approvazione, $scope.issue);
    }
  }

  /**
   * MAIN
   **/
  $scope.loadData();
}]).controller('IssueModalCtrl', ['$scope', 'FileUploader', 'toaster', 'authFactory', 'issueFactory', 'counterFactory', 'recordFactory', 'ALFRESCO_URL', 'ENV', 'slaService', 'commissionFactory', function ($scope, FileUploader, toaster, authFactory, issueFactory, counterFactory, recordFactory, ALFRESCO_URL, ENV, slaService, commissionFactory) {
  // riempio automaticamente il reporter
  var operatorPromise = recordFactory('operatore').search({
    'model.username': sixFiltersLib.exact('model.username', authFactory.getAuthData().authId)
  }).$promise.then(function (resp) {
    if (resp.list || resp.list.length == 1) {
      return sixObjectLib.recordToHisRef(resp.list[0]);
    }
    return null;
  }, function (err) {
    return null;
  });
  var DESTINATION = '/Sites/' + ENV + '/' + authFactory.getAuthData().info.commissions.current.code;
  var uploader = $scope.uploader = new FileUploader({
    url: ALFRESCO_URL + '/upload',
    formData: [{
      destination: DESTINATION
    }],
    queueLimit: 1,
    onErrorItem: function onErrorItem(fileItem, response, status, headers) {
      toaster.error('', 'Impossibile allegare il documento');
      console.error('onErrorItem', fileItem, response, status, headers);
    },
    onSuccessItem: function onSuccessItem(fileItem, response, status, headers) {
      if (response.ERROR || !response.objectId) {
        toaster.error('', 'Impossibile allegare il documento');
        console.error('onErrorItem', fileItem, response, status, headers);
      } else {
        _save([{
          date: new Date(),
          destination: DESTINATION,
          folder: false,
          id: 0,
          nodes: [],
          object_id: response.objectId,
          readonly: false,
          title: fileItem.file.name,
          user: authFactory.getAuthData().authId
        }]);
      }
    }
  });
  $scope.issue = {};
  $scope.issue.segnalazionenonconforme_list = [];
  $scope.issue.azionecorrettiva_list = [];
  function _SLAHandler() {
    var commissionCode = authFactory.getAuthData().info.commissions.current.code;
    var repartoUUID = $scope.issue.assetReference.UUID;
    slaService.isSLAEnabled(commissionCode, repartoUUID).then(function (response) {
      if (response == true) {
        commissionFactory().getCommissionByCode({
          code: commissionCode
        }).$promise.then(function (resp) {
          if (resp.startTime && resp.endTime) {
            if (!slaService.isSLACreatedDuringCommissionWorkhours(resp.startTime, resp.endTime)) {
              toaster.info("Issue creata fuori dall'orario di lavoro della commessa.");
            }
          }
        });
      }
    });
  }
  $scope.save = function () {
    _SLAHandler(); //mostrare popup se issue creata al di fuori dell'orario di una commission

    if (uploader.queue.length) {
      uploader.uploadAll();
    } else {
      _save();
    }
  };

  //filtro le sottocategorie in base allo UUID della categoria selezionata
  $scope.categoriaIdFilter = null;
  $scope.updateCategoriaIdFilter = function (item) {
    //item è la categoria selezionata
    if (item) {
      //assegnazione valore al filtro
      $scope.issue.sottocategoria = null;
      $scope.categoriaIdFilter = {
        "filter": sixFiltersLib.exact("model.categoria_id.UUID", item.UUID)
      };
      var filter = {
        "filter": sixFiltersLib.exact("UUID", item.UUID)
      };
      //recupero with_quantity
      recordFactory('categoria').search(filter).$promise.then(function (resp) {
        if (resp && resp.list && resp.list[0].model.with_quantity) {
          $scope.with_quantity = resp.list[0].model.with_quantity;
        } else {
          delete $scope.with_quantity;
          delete $scope.issue.quantity;
        }
      });
    } else {
      delete $scope.with_quantity;
      delete $scope.issue.quantity;
      $scope.categoriaIdFilter = {};
    }
  };
  function _save(attachments) {
    counterFactory.next({
      code: 'issue'
    }).$promise.then(function (response) {
      if (response.errors) {
        toaster.error('Contatore mancante', 'Imopssibile salvare la segnalazione.<br>Contattare l\'amministratore del sistema.');
      } else {
        operatorPromise.then(function (reporter) {
          var now = new Date();
          var issue = {
            date_insertion: now,
            date_requested: now,
            reporter_id: reporter,
            model: {
              code: response.next,
              description: response.next + ' - portale - ' + $scope.issue.assetReference.description,
              insertedFrom: 'portal',
              categoria: $scope.issue.categoria,
              sottocategoria: $scope.issue.sottocategoria,
              note: $scope.issue.note,
              record_id: $scope.issue.assetReference,
              priority_id: $scope.issue.priority,
              attachments: attachments,
              segnalazioninonconformi: $scope.issue.segnalazionenonconforme_list.code,
              azionicorrettive: $scope.issue.azionecorrettiva_list.code,
              quantity: $scope.issue.quantity
            }
          };
          issueFactory('issue/record').create(issue).$promise.then(function (response) {
            $scope.closeThisDialog('saved');
          }, function (err) {
            toaster.error('', 'Impossibile salvare la segnalazione');
          });
        });
      }
    }, function (err) {
      toaster.error('Contatore mancante', 'Imopssibile salvare la segnalazione.<br>Contattare l\'amministratore del sistema.');
    });
  }
  function init() {
    recordFactory('priorita').fetchAll({}).$promise.then(function (response) {
      if (response.length) {
        $scope.priorities = response.map(sixObjectLib.recordToHisRef);
        $scope.issue.priority = $scope.priorities[0];
      } else {
        toaster.error('', 'I livelli di priorità  non sono stati configurati');
      }
    }, function (err) {
      toaster.error('Proitità', 'Impossibile trovare le priorità');
    });
  }
  init();
}]);
'use strict';

angular.module('emma.portal').service('IssueSrv', ['ngDialog', 'authFactory', 'localStorageService', function (ngDialog, authFactory, localStorageService) {
  return {
    canEdit: function canEdit() {
      return authFactory.isUpdatePermAllowed('issue/record');
    },
    canDelete: function canDelete() {
      return authFactory.isDeletePermAllowed('issue/record');
    },
    getFileIcon: function getFileIcon(fileName) {
      if (fileName) {
        switch (fileName.substring(fileName.lastIndexOf('.') + 1)) {
          case 'png':
          case 'jpg':
            return 'fa-file-image-o';
          case 'pdf':
            return 'fa-file-pdf-o';
          case 'xlsx':
          case 'xls':
            return 'fa-file-excel-o';
          case 'doc':
            return 'fa-file-word-o';
          default:
            return 'fa-file-o';
        }
      }
    },
    getStatusIcon: function getStatusIcon(issueStatus) {
      var status = issueStatus && issueStatus.toLowerCase();
      switch (status) {
        case 'aperto':
        case 'open':
        case 'in_service':
        case 'in lavorazione':
          return 'fa-clock-o text-warning';
        case 'chiuso':
          return 'fa-check-circle-o text-success';
        case 'annullato':
        case 'abort':
          return 'fa-times-circle-o text-danger';
        default:
          return 'fa-circle-o test-muted';
      }
    },
    creatioDialog: function creatioDialog() {
      return ngDialog.open({
        template: 'portal/issue/issue-modal.html',
        controller: 'IssueModalCtrl',
        className: 'ngdialog-theme-default',
        appendClassName: 'ngdialog-issue-create',
        closeByNavigation: true
      }).closePromise;
    },
    getMineOperator: function getMineOperator() {
      var operator = localStorageService.get('operatore');
      var ref = sixObjectLib.recordToHisRef(operator);
      var role = !operator.model.typeoperator_map ? null : operator.model.typeoperator_map[authFactory.getAuthData().info.commissions.current.code] || operator.model.typeoperator_map['tutte'];
      return {
        operator: ref,
        role: role
      };
    }
  };
}]);
'use strict';

angular.module('emma.portal').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/plan/survey', {
    templateUrl: 'portal/quality/plan-survey.html',
    controller: 'PlanSurveyCtrl'
  });
}]).controller('PlanSurveyCtrl', ['$scope', '$q', 'cronExpressionFactory', 'toaster', 'surveyFactory', function ($scope, $q, cronExpressionFactory, toaster, surveyFactory) {
  var colorScale = d3.scale.category20();
  var calendarApi;
  $scope.frequencies = [{
    value: 'week_1',
    label: 'Settimanale'
  }, {
    value: 'month_1',
    label: 'Mensile'
  }, {
    value: 'month_2',
    label: 'Bimestrale'
  }, {
    value: 'month_3',
    label: 'Trimestrale'
  }, {
    value: 'month_4',
    label: 'Quadrimestrale'
  }, {
    value: 'month_6',
    label: 'Semestrale'
  }, {
    value: 'year_1',
    label: 'Annuale'
  }, {
    value: 'year_2',
    label: 'Biennale'
  }, {
    value: 'year_3',
    label: 'Triennale'
  }, {
    value: 'year_4',
    label: 'Quadriennale'
  }, {
    value: 'year_5',
    label: 'Quinquennale'
  }, {
    value: 'year_6',
    label: '6 anni'
  }];
  $scope.dayOfWeek = [{
    value: 'MON',
    label: 'Lun'
  }, {
    value: 'TUE',
    label: 'Mar'
  }, {
    value: 'WED',
    label: 'Mer'
  }, {
    value: 'THU',
    label: 'Gio'
  }, {
    value: 'FRI',
    label: 'Ven'
  }, {
    value: 'SAT',
    label: 'Sab'
  }, {
    value: 'SUN',
    label: 'Dom'
  }];
  $scope.monthOfYear = [{
    value: '1',
    label: 'Gen'
  }, {
    value: '2',
    label: 'Feb'
  }, {
    value: '3',
    label: 'Mar'
  }, {
    value: '4',
    label: 'Apr'
  }, {
    value: '5',
    label: 'Mag'
  }, {
    value: '6',
    label: 'Giu'
  }, {
    value: '7',
    label: 'Lug'
  }, {
    value: '8',
    label: 'Ago'
  }, {
    value: '9',
    label: 'Set'
  }, {
    value: '10',
    label: 'Ott'
  }, {
    value: '11',
    label: 'Nov'
  }, {
    value: '12',
    label: 'Dic'
  }];
  $scope.dateRange = {
    from: new Date()
  };
  $scope.dateOptionsFrom = {};
  $scope.dateOptionsTo = {};
  $scope.plan = {};
  $scope.frequency = {
    frequency: 'month_1',
    day_of_month: '1',
    day_of_week: 'MON',
    month_of_year: '1'
  };
  $scope.calendarOptions = {
    language: 'it'
  };
  $scope.reset = function () {
    $scope.frequency = {
      frequency: 'month_1',
      day_of_month: '1',
      day_of_week: 'MON',
      month_of_year: '1'
    };
    $scope.plan = {};
  };
  $scope.updateMinDate = function () {
    $scope.dateOptionsTo.minDate = $scope.dateRange.from;
  };
  $scope.isAnnual = function () {
    return $scope.frequency.frequency.startsWith('year');
  };
  $scope.getColor = function (idx) {
    return {
      color: colorScale(idx)
    };
  };
  $scope.registerCalendar = function (api) {
    calendarApi = api;
  };
  $scope.resolveCron = function () {
    calendarApi.setDataSource([]);
    calendarApi.setYear($scope.dateRange.from.getFullYear());
    calendarApi.setMinDate(moment($scope.dateRange.from).startOf('d').toDate());
    calendarApi.setMaxDate($scope.dateRange.to);
    $scope.plan.surveyResponse = [];
    // Recupero la cronExpression aggiornata
    cronExpressionFactory.getCronExpression($scope.frequency).$promise.then(function (data) {
      cronExpressionFactory.getSimulationEvents({
        expression: data.result,
        date_from: moment($scope.dateRange.from).startOf('d'),
        date_to: moment($scope.dateRange.to).endOf('d')
      }).$promise.then(function (dateResponse) {
        dateResponse.list.forEach(function (date) {
          $scope.plan.commissions.forEach(function (commission, idx) {
            var color = colorScale(idx);
            loadSurvey(Math.floor(Math.random() * $scope.plan.surveies.length)).then(function (surveyModel) {
              $scope.plan.surveyResponse.push({
                model: surveyModel,
                commission: [commission.code],
                dataIn: date
              });
              var momentDate = moment(date).startOf('d');
              calendarApi.addEvent({
                startDate: momentDate.toDate(),
                endDate: momentDate.endOf('d').toDate(),
                commission: commission,
                survey: surveyModel,
                color: color,
                name: commission.code + ' - ' + surveyModel.code
              });
            });
          });
        });
      }, function (err) {
        toaster.error('', 'Impossibile ottenere le date');
      });
    }, function (err) {
      toaster.error('', 'Impossibile ottenere le date');
    });
  };
  $scope.save = function () {
    surveyFactory('response').bulkSave($scope.plan.surveyResponse).$promise.then(function (response) {
      console.log(response);
      toaster.info('', 'Questionari salvati');
      $scope.reset();
    }, function (err) {
      toaster.error('', 'Impossibile salvare i questionari');
    });
  };
  var surveyCache = {};
  function loadSurvey(index) {
    return surveyCache[index] || (surveyCache[index] = surveyFactory('survey').getByUuid({
      uuid: $scope.plan.surveies[index].UUID
    }).$promise.then(function (response) {
      if (response && response.list && response.list.length > 0) {
        var model = response.list[0].model;
        model.is_new = true;
        return model;
      }
    }));
  }
}]);
'use strict';

angular.module('emma.portal').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/quality', {
    templateUrl: 'portal/quality/quality-list.html',
    controller: 'QualityCtrl'
  });
}]).controller('QualityCtrl', ['$scope', '$location', 'toaster', 'surveyFactory', function ($scope, $location, toaster, surveyFactory) {
  $scope.paginatedRequest = {
    page_size: 25,
    page: 1,
    show_revision: false,
    currentDate: new Date()
  };
  $scope.loadData = function () {
    surveyFactory('response').search($scope.paginatedRequest, {}).$promise.then(function (data) {
      $scope.surveyResponse = data;
    })["catch"](function (err) {
      toaster.pop('error', 'Errore', 'Errore durante il recupero dei dati');
    });
  };
  $scope.goToSurvey = function (uuid) {
    $location.path('survey/resp/' + uuid);
  };
  $scope.loadData();
}]);
'use strict';

/**
 * @ngdoc function
 * @name emma.theme.controller:AdminCtrl
 * @description
 * # AdminCtrl
 * Controller of the emma.theme
 */
angular.module('emma.theme').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/admin/:page', {
    template: '<div class="container-fluid"><h3>La pagina è stata aperta in una nuova scheda</h3><p>Disattiva il blocco popup se non dovesse essere visibile.</p></div>',
    controller: 'AdminCtrl'
  });
}]).controller('AdminCtrl', ["APP_URL", "$scope", "authFactory", "$routeParams", "ENV", "DEV", "ADMIN_URL", function (APP_URL, $scope, authFactory, $routeParams, ENV, DEV, ADMIN_URL) {
  $scope.getAdminURL = function () {
    var params = '?username=' + authFactory.getAuthData().authId + '&nextPage=';
    if ($routeParams.page) {
      params = params + $routeParams.page;
    } else {
      params = params + 'admin';
    }
    return ADMIN_URL + params;
  };
  window.open($scope.getAdminURL());
}]);
'use strict';

/**
 * @ngdoc function
 * @name emma.theme.controller:AdminchiamCtrl
 * @description
 * # AdminchiamCtrl
 * Controller of the emma.theme
 */
angular.module('emma.theme').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/adminchiam', {
    templateUrl: 'theme/adminchiam/adminchiam.html',
    controller: 'AdminchiamCtrl'
  });
}]).controller('AdminchiamCtrl', ["APP_URL", "$scope", "authFactory", "$routeParams", "baseFactory", "adminchiamFactory", "errorService", "dialogService", "toaster", "moduleInfoFactory", "$http", "$log", "loadingBarService", "broadcastWSFactory", "localStorageService", function (APP_URL, $scope, authFactory, $routeParams, baseFactory, adminchiamFactory, errorService, dialogService, toaster, moduleInfoFactory, $http, $log, loadingBarService, broadcastWSFactory, localStorageService) {
  $scope.modelType = {};
  $scope.params = {};
  $scope.messages = [];
  $scope.calls = [];
  $scope.advancedStatus = {
    open: false
  };
  $scope.selected = {};
  $scope.selected.httpAction = {
    key: 'get',
    description: 'GET'
  };
  $scope.selected.module = {
    key: 'six-data-set',
    description: 'six-data-set'
  };
  $scope.httpActionsList = [{
    key: 'get',
    description: 'GET'
  }, {
    key: 'post',
    description: 'POST'
  }, {
    key: 'put',
    description: 'PUT'
  }, {
    key: 'delete',
    description: 'DELETE'
  }];
  $scope.modulesList = [{
    key: 'six-data-set',
    description: 'six-data-set'
  }, {
    key: 'six-energy',
    description: 'six-energy'
  }, {
    key: 'six-plan',
    description: 'six-plan'
  }, {
    key: 'six-consip',
    description: 'six-consip'
  }, {
    key: 'six',
    description: 'six'
  }];
  $scope.serviceList = [{
    key: 'testrest',
    description: 'Test REST'
  }, {
    key: 'tree',
    description: 'Tree'
  }, {
    key: 'record',
    description: 'Record'
  }, {
    key: 'nashornuomconversion',
    description: 'Nashorn Uom Conversion'
  }, {
    key: 'nashornformula',
    description: 'Nashorn Formula Conversion'
  }, {
    key: 'consumption',
    description: 'Consumptions'
  }, {
    key: 'energy/dd',
    description: 'Day Degree'
  }, {
    key: 'config',
    description: 'Config'
  }, {
    key: 'acquisitionwizard/acquisition',
    description: 'Acquisition Wizard'
  }, {
    key: 'acquisitionwizard/additionalacts',
    description: 'Additional Acts'
  }, {
    key: 'zonatermica',
    description: 'Zona Termica'
  }, {
    key: 'snapshot',
    description: 'Snapshot'
  }];
  $scope.secondList = [];
  $scope.secondMap = [];
  $scope.secondMap['testrest'] = [{
    key: 'messages',
    description: 'Messages'
  }];
  $scope.secondMap['record'] = [{
    key: 'record/_check',
    description: 'Generic check'
  }, {
    key: 'record/_fix',
    description: 'Generic fix'
  }, {
    key: '_fix',
    description: 'Fix'
  }, {
    key: '*/_fix/references',
    description: 'Refresh All References'
  }];
  $scope.secondMap['tree'] = [{
    key: '_check',
    description: 'Check'
  }, {
    key: '_fix',
    description: 'Fix'
  }, {
    key: '_copy',
    description: 'Copy'
  }, {
    key: '_copytoall',
    description: 'Copy to all'
  }, {
    key: 'v2/_index',
    description: 'Indicizza'
  }, {
    key: 'v2/_indexall',
    description: 'Indicizza tutto'
  }, {
    key: '_parents/_propagate',
    description: 'Propaga parents'
  }];
  $scope.secondMap['nashornuomconversion'] = [{
    key: '_admin',
    description: 'Admin'
  }];
  $scope.secondMap['nashornformula'] = [{
    key: '_admin',
    description: 'Admin'
  }];
  $scope.secondMap['consumption'] = [{
    key: 'calcall',
    description: 'Elaborate'
  }];
  $scope.secondMap['energy/dd'] = [{
    key: 'tempToDD',
    description: 'Historical DD'
  }, {
    key: 'saveAllReferring',
    description: 'Referring ZT DD'
  }];
  $scope.secondMap['config'] = [{
    key: '_refresh',
    description: 'Refresh'
  }];
  $scope.secondMap['acquisitionwizard/acquisition'] = [{
    key: '_admin/_deleteInvalidActsRef',
    description: 'Cancella riferimenti atti'
  }, {
    key: '_admin/_recalcPlafond',
    description: 'Recalc. Plafond'
  }];
  $scope.secondMap['acquisitionwizard/additionalacts'] = [{
    key: '_admin/_deleteOrphanActs',
    description: 'Cancella atti orfani'
  }, {
    key: '_admin/_recalcPlafond',
    description: 'Recalc. Plafond'
  }];
  $scope.secondMap['zonatermica'] = [{
    key: 'tempProvinciaToZonaTermica/_all',
    description: 'Elabora temperature da comune'
  }];
  $scope.secondMap['snapshot'] = [{
    key: '',
    description: 'All'
  }, {
    key: 'budget',
    description: 'Budget'
  }, {
    key: 'recordassociation',
    description: 'Record Association'
  }, {
    key: 'daydegree',
    description: 'Day Degree'
  }, {
    key: 'consumption',
    description: 'Consumption'
  }, {
    key: 'consanalysis',
    description: 'Consumption Analysis'
  }];
  $scope.thirdList = [];
  $scope.thirdMap = [];
  $scope.thirdMap['record_fix'] = [{
    key: 'all',
    description: 'Tutto'
  }, {
    key: 'schemacode',
    description: 'Schema'
  }, {
    key: 'commission',
    description: 'Commission'
  }, {
    key: 'dataout',
    description: 'dataOut'
  }, {
    key: 'formulas',
    description: 'Formulas'
  }, {
    key: 'references',
    description: 'Refresh References'
  }];
  $scope.thirdMap['recordrecord/_check'] = [{
    key: 'timeline',
    description: 'Timeline'
  }];
  $scope.thirdMap['recordrecord/_fix'] = [{
    key: 'timeline',
    description: 'Timeline'
  }];
  $scope.thirdMap['tree_fix'] = [{
    key: 'tree',
    description: 'Tree'
  }, {
    key: 'dataout',
    description: 'dataOut'
  }];
  $scope.thirdMap['nashornuomconversion_admin'] = [{
    key: 'cache/invalidate',
    description: 'Invalidate cache'
  }];
  $scope.thirdMap['nashornformula_admin'] = [{
    key: 'cache/invalidate',
    description: 'Invalidate cache'
  }];
  $scope.thirdMap['energy/ddtempToDD'] = [{
    key: 'all',
    description: 'Tutto'
  }];
  $scope.path = {
    path: ''
  };
  $scope.reportGridOptions = {
    enableSorting: true,
    exporterMenuPdf: false,
    paginationPageSizes: [10, 20, 30],
    paginationPageSize: 10,
    useExternalPagination: false,
    data: 'messages',
    columnDefs: [{
      displayName: 'Codice',
      field: 'key',
      width: '60'
    }, {
      displayName: 'Stato',
      field: 'status',
      width: '100'
    }, {
      displayName: 'Messaggio',
      field: 'message'
    }, {
      displayName: 'Record type',
      field: 'record.type',
      width: '120'
    }, {
      displayName: 'Record code',
      field: 'record.code',
      width: '120'
    }, {
      displayName: 'Record UUID',
      field: 'record.uuid',
      width: '120'
    }, {
      displayName: 'Record Id',
      field: 'recordId',
      width: '120'
    }, {
      displayName: 'Commission',
      field: 'commission',
      width: '120'
    }, {
      displayName: '',
      field: 'code',
      cellTemplate: '<div><a class="btn btn-xs" title="Correggi" ng-confirm-message="Correggere?" ng-if="grid.appScope.isFixable(row.entity.code)===true" ng-confirm-click="grid.appScope.tryFixProblem(row.entity)" ng-confirm-condition=true><span class="fa fa-medkit"></span></a></div>',
      width: 50,
      enableSorting: false,
      enableFiltering: false,
      enableCellEdit: false
    }]
  };
  $scope.go = function () {
    $log.debug('Esecuzione di ' + $scope.path.path);
    // dialogService.pushLoading($scope.path.path + '...');
    loadingBarService.start($scope.path.path + ' ...');
    var call = {
      module: angular.copy($scope.selected.module.key),
      path: angular.copy($scope.path.path),
      start: new Date(),
      end: '-'
    };
    $scope.calls.push(call);
    var promise;
    switch ($scope.selected.httpAction.key) {
      case 'get':
        promise = adminchiamFactory($scope.selected.module.key, $scope.path.path).get().$promise;
        break;
      case 'post':
        promise = adminchiamFactory($scope.selected.module.key, $scope.path.path).post().$promise;
        break;
      case 'put':
        promise = adminchiamFactory($scope.selected.module.key, $scope.path.path).put().$promise;
        break;
      case 'delete':
        promise = adminchiamFactory($scope.selected.module.key, $scope.path.path)["delete"]().$promise;
        break;
      default:
        promise = adminchiamFactory($scope.selected.module.key, $scope.path.path).get().$promise;
        break;
    }
    promise.then(function (response) {
      call.end = new Date();
      call.duration = call.end.getTime() - call.start.getTime();
      call.status = 'OK';
      call.response = response;
      $scope.response = response;
      $scope.messages = response.messages;
      if (!isServiceResponseObject($scope.response)) {
        if (response.status === 'ok') {
          toaster.pop('success', 'Eseguito', 'Eseguito con successo');
        } else {
          var msg = '';
          if (angular.isDefined($scope.messages) === true && angular.isArray($scope.messages) === true) {
            msg = 'Problemi rilevati: ' + $scope.messages.length;
          } else {
            msg = 'La richiesta potrebbe essere andata in timeout: controllare i log del server';
          }
          toaster.pop('warning', 'Attenzione', msg);
        }
      }
      loadingBarService.stop(response, $scope.path.path + ': messaggi');
    })["catch"](function (error) {
      // error
      call.end = new Date();
      call.duration = call.end.getTime() - call.start.getTime();
      call.status = 'ERROR';
      $log.error('Impossibile completare l\'operazione ' + $scope.path.path, error);
      loadingBarService.stop();
      toaster.pop('error', 'Errore', 'Impossibile completare l\'operazione ' + $scope.path.path);
    });
  };
  $scope.showResponse = function (response) {
    dialogService.serviceResponse('Esito', response);
  };
  function isServiceResponseObject(response) {
    return angular.isDefined(response) && response !== null && angular.isObject(response) && response.hasOwnProperty('status') && response.hasOwnProperty('result') && response.hasOwnProperty('messages') && response.hasOwnProperty('hasErrors') && response.hasOwnProperty('hasWarnings');
  }
  $scope.$watchCollection('selected', function (newVal, oldVal) {
    buildPath();
  });
  $scope.$watchCollection('modelType', function (newVal, oldVal) {
    buildPath();
  });
  $scope.$watch('params.path', function (newVal, oldVal) {
    buildPath();
  });
  $scope.$watch('params.query', function (newVal, oldVal) {
    buildPath();
  });
  function buildPath() {
    $scope.path.path = '';
    if ($scope.selected.service) {
      $scope.path.path += $scope.selected.service.key;
      if ($scope.selected.service.key == 'record' && $scope.modelType.id) {
        $scope.path.path += '/' + $scope.modelType.id.UUID;
      }
    }
    if ($scope.selected.serviceType) {
      $scope.path.path += '/' + $scope.selected.serviceType.key;
    }
    if ($scope.selected.third) {
      $scope.path.path += '/' + $scope.selected.third.key;
    }
    if ($scope.params.path) {
      $scope.path.path += '/' + $scope.params.path;
    }
    if ($scope.params.query) {
      $scope.path.path += '?' + $scope.params.query;
    }
  }
  $scope.reset = function () {
    $scope.params.path = undefined;
    $scope.modelType.id = undefined;
    $scope.selected.third = undefined;
    $scope.selected.serviceType = undefined;
    $scope.selected.service = undefined;
    $scope.selected.module = undefined;
    $scope.path.path = '';
    $scope.messages = [];
  };

  // VERSIONING

  $scope.frontEndInfo = {};
  $scope.loadFrontEndInfo = function () {
    $scope.frontEndInfo = {
      title: 'EMMA FrontEnd',
      vendor: 'it.ictgroup',
      version: '-',
      revision: '-',
      builddate: '-',
      builprofile: '-',
      cipipelineid: '-',
      cibuildid: '-'
    };
    $http.get('meta/manifest.json').then(function (response) {
      // success
      if (!response.status || response.status == 200) {
        $scope.frontEndInfo = response.data;
        getModuleInfo($scope.frontEndInfo.installedmodules);
      }
    });
  };
  $scope.modulesInfo = {};
  function getModuleInfo(modules) {
    modules.forEach(function (module) {
      var api = 'api';
      if (module == 'six') {
        api = 'rest';
      }
      moduleInfoFactory(module, api).info().$promise.then(function (response) {
        $scope.modulesInfo[module] = response;
      });
    });
  }
  $scope.loadFrontEndInfo();

  // ACTIVE USERS

  $scope.activeUsers = [];
  $scope.usersListener = function (msg) {
    if (msg.type == 'sessions') {
      $scope.activeUsers = msg.users || [];
    }
  };
  $scope.refreshUsers = function () {
    var request = {
      type: 'sessions',
      authId: authId
    };
    broadcastWSFactory.send(request);
  };
  broadcastWSFactory.register($scope.usersListener);
  $scope.refreshUsers();
  $scope.userSearch = {}; // search filters
  $scope.userSort = []; // sort
  $scope.userSortBy = function (propertyName) {
    var idx = $scope.userSort.indexOf(propertyName);
    if (~idx) {
      $scope.userSort[idx] = '-' + propertyName;
    } else {
      idx = $scope.userSort.indexOf('-' + propertyName);
      if (~idx) {
        $scope.userSort.splice(idx, 1);
      } else {
        $scope.userSort.push(propertyName);
      }
    }
  };
  $scope.userIsSorted = function (propertyName) {
    var idx = $scope.userSort.indexOf(propertyName);
    if (~idx) {
      return 1;
    } else {
      idx = $scope.userSort.indexOf('-' + propertyName);
      if (~idx) {
        return -1;
      }
    }
    return 0;
  };

  // BROADCAST NOTIFICATION

  $scope.precompiledMessages = [{
    level: 'WARNING',
    pinned: true,
    object: 'AGGIORNAMENTO PROGRAMMATO',
    message: 'Si comunica che è previsto un aggiornamento di sistema in data <b>------DATA------</b> a partire dalle ore <b>------ORE------</b><br /><br />Ci scusiamo per eventuali disagi riscontrati.'
  }, {
    level: 'WARNING',
    pinned: true,
    object: 'AGGIORNAMENTO IN CORSO',
    message: 'Si comunica che tra pochi minuti il sistema verrà aggiornato.<br /><br />Ci scusiamo per eventuali disagi riscontrati.'
  }, {
    level: 'WARNING',
    pinned: true,
    object: 'AGGIORNAMENTO CONCLUSO',
    message: 'Il sistema è stato aggiornato, è possibile riprendere la normale operatività.'
  }];
  $scope.selectPrecompiledMessage = function (msg) {
    $scope.broadcast = angular.copy(msg);
    $scope.broadcast.type = 'broadcast';
    $scope.broadcast.authId = authId;
    $scope.broadcast.from = authId;
  };
  var authId = authFactory.getAuthData().authId;
  $scope.broadcast = {
    type: 'broadcast',
    from: authId,
    authId: authId,
    object: '',
    level: 'INFO',
    message: ''
  };
  $scope.sendBroadcast = function (msg) {
    broadcastWSFactory.send(msg);
  };

  /* *************** */
  /* force six login */
  /* *************** */

  $scope.forceSixLogin = {
    active: localStorageService.get('force_six_login')
  };
  $scope.$watch('forceSixLogin.active', function (newVal, oldVal) {
    if ($scope.forceSixLogin && $scope.forceSixLogin.active) {
      localStorageService.set('force_six_login', $scope.forceSixLogin.active);
    } else {
      localStorageService.remove('force_six_login');
    }
  });
}]);
'use strict';

// Default:
// {
//   'get':    {method:'GET'},
//   'save':   {method:'POST'},
//   'query':  {method:'GET', isArray:true},
//   'remove': {method:'DELETE'},
//   'delete': {method:'DELETE'}
// }

/**
 * @ngdoc service
 * @name emma.theme.baseFactory
 * @description
 * # baseFactory
 * Factory in the emma.theme.
 */
angular.module('emma.theme').factory('adminchiamFactory', ["APP_URL", "ENERGY_URL", "DATA_SET_URL", "PLAN_URL", "CONSIP_URL", "$resource", function (APP_URL, ENERGY_URL, DATA_SET_URL, PLAN_URL, CONSIP_URL, $resource) {
  return function (module, resource) {
    var base;
    switch (module) {
      case 'six-data-set':
        base = DATA_SET_URL + '/api';
        break;
      case 'six-energy':
        base = ENERGY_URL + '/api';
        break;
      case 'six-plan':
        base = PLAN_URL + '/api';
        break;
      case 'six-consip':
        base = CONSIP_URL + '/api';
        break;
      default:
        base = APP_URL + '/rest';
        break;
    }
    return $resource(base + '/' + resource + '/:verb/:p1/:p2/:p3/:p4/:p5/:p6', {}, {
      get: {
        method: 'GET',
        isArray: false
      },
      post: {
        method: 'POST',
        isArray: false
      },
      put: {
        method: 'PUT',
        isArray: false
      },
      "delete": {
        method: 'DELETE',
        isArray: false
      }
    });
  };
}]);
'use strict';

/**
 * @ngdoc overview
 * @name sixEmmaApp
 * @description
 * # sixEmmaApp
 *
 * Main module of the application.
 */
angular.module('emma.theme').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/logout', {
    templateUrl: 'theme/auth/logout.html',
    controller: 'LogoutCtrl'
  });
}]).controller('LogoutCtrl', ["$scope", "$routeParams", "$rootScope", "authFactory", function ($scope, $routeParams, $rootScope, authFactory) {
  authFactory.logout();
}]);
'use strict';

/**
 * @ngdoc overview
 * @name sixEmmaApp
 * @description
 * # sixEmmaApp
 *
 * Main module of the application.
 */
angular.module('emma.theme').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/cas/postauth', {
    templateUrl: 'theme/auth/postauth.html',
    controller: 'PostAuthCtrl'
  });
}]).controller('PostAuthCtrl', ["$scope", "$routeParams", "$rootScope", "authFactory", "recordFactory", "schemaFactory", "sysConfigFactory", "$timeout", "counterFactory", "toaster", "$location", "$http", "$log", "ENV", "localStorageService", "operatorGroupService", "$animate", "menuProfiling", "loginFactory", "commissionFactory", function ($scope, $routeParams, $rootScope, authFactory, recordFactory, schemaFactory, sysConfigFactory, $timeout, counterFactory, toaster, $location, $http, $log, ENV, localStorageService, operatorGroupService, $animate, menuProfiling, loginFactory, commissionFactory) {
  if (window.postAuthFix) return;
  window.postAuthFix = true;
  function createNewOperator(authData) {
    var filters = {
      'model.username': sixFiltersLib.exact('model.username', authData.authId)
    };
    recordFactory('operatore').search(filters).$promise.then(function (resp) {
      $log.info('------ operator ------');
      $log.info(resp);
      $log.info('----------------------');

      // Creo l'operatore solo se non esiste già un operatore con lo username loggato
      if (!resp.list || resp.list.length == 0) {
        var newOp = {};
        newOp.description = authData.info.name + ' ' + authData.info.surname;
        newOp.mail = authData.info.mail;
        newOp.username = authData.authId;
        schemaFactory().byUUID({
          id: 'operatore'
        }).$promise.then(function (schemaResp) {
          if (!schemaResp.model) {
            dialogService.alert('Non è stato definito un modello per l\'entità operatore', 4000);
            return;
          }
          /* ***** Search filters ***** */
          if (schemaResp.model.selfGeneratedCode) {
            var selfGeneratedCode = schemaResp.model.selfGeneratedCode;
            counterFactory.next({
              code: selfGeneratedCode.codeNameSix
            }).$promise.then(function (counterResp) {
              if (counterResp.errors) {
                $log.error('Errore', 'Problema rilevato nell\'inizializziazione automatica del codice: ' + counterResp.errors.error);
                toaster.pop('error', 'Errore', 'Problema rilevato nell\'inizializziazione automatica del codice: ' + counterResp.errors.error);
              } else {
                newOp.code = counterResp.next;
                var payload = {
                  page: 1,
                  page_size: 1,
                  cross: true,
                  history: false
                };
                var filters = {
                  role: sixFiltersLib["in"]('model.ldap_groups.code', authData.authPermission)
                };
                sysConfigFactory('rolemapping').search(payload, filters).$promise.then(function (result) {
                  if (result && result.list.length > 0) {
                    newOp.typeoperator_map = {};
                    authData.profiles.forEach(function (commission) {
                      newOp.typeoperator_map[commission.code] = result.list[0].model.emma_role_id;
                    });
                  } else {
                    $log.error('Mapping per il ruolo \'' + authData.authPermission + '\' non trovato');
                    // toaster.pop('warning', 'Mapping per il ruolo \''+ authData.authPermission +'\' non trovato');
                  }

                  $log.info('------ new operator ------');
                  $log.info(newOp);
                  $log.info('--------------------------');
                  recordFactory('operatore').create(newOp).$promise.then(function (respOp) {
                    $log.info('------ create operator ------');
                    $log.info(respOp);
                    $log.info('-----------------------------');
                    toaster.pop('success', 'Creato nuovo operatore per l\'utente \'' + authData.authId + '\': codice ' + respOp.model.code);
                    // set in localStorageService il gruppo operatore
                    operatorGroupService.setGroupInLocalStorage({
                      operatore: respOp
                    });
                    localStorageService.set('operatore', respOp);
                  });
                });
              }
            });
          }
        });
      } else {
        // set in localStorageService il gruppo operatore
        operatorGroupService.setGroupInLocalStorage({
          operatore: resp.list[0]
        });
        localStorageService.set('operatore', resp.list[0]);
      }
    });
  }
  function _init() {
    $log.log('PostAuthCtrl');
    $http.get('emmacas/postauth/' + ENV).success(function (data, status) {
      $log.log(status);
      $log.log(data);
      $scope.response = data;
      if (!data.info || !data.info.commissions || !data.info.commissions.current) {
        return;
      }
      var lastCommission = localStorageService.get(ENV + '_lastCommission');
      var lastCustomer = localStorageService.get(ENV + '_lastCustomer');
      var currentCustomer = data.profile.items.find(function (t) {
        return t.type == 'customer';
      }) || {};
      authFactory.setAuthData(data); //necessario al createNewOperator

      //switcho immediatamente commessa e cliente se necessario
      if (lastCommission && lastCommission.code != data.info.commissions.current.code || lastCustomer && lastCustomer.code != currentCustomer.code) {
        var switchProfileElement = {
          selected: {
            type: "",
            cod: 0,
            code: lastCommission.code,
            description: lastCommission.description,
            items: [{
              type: "commission",
              cod: 0,
              code: lastCommission.code,
              description: lastCommission.code + " - " + lastCommission.description
            }]
          }
        };
        if (lastCustomer && lastCustomer.code) {
          switchProfileElement.selected.items.push({
            type: "customer",
            cod: 0,
            code: lastCustomer.code,
            description: lastCustomer.description
          });
        }
        loginFactory["switch"](switchProfileElement).$promise.then(function (response) {
          $log.info("Switch automatico commessa");
          completeAuth(response);
        });
      } else {
        completeAuth(data);
      }
    }).error(function (error) {
      $log.log(error);
    });
  }
  function completeAuth(authData) {
    $log.info(authData);
    var commissionCode = authData.info.commissions.current.code;
    commissionFactory().getCommissionByCode({
      code: commissionCode
    }).$promise.then(function (response) {
      authData.info.commissions.current = angular.extend(response, authData.info.commissions.current);
      authFactory.setAuthData(authData);
      menuProfiling.updateMenu(authData.menu);
      createNewOperator(authData);
      var next = localStorageService.get(ENV + '_nextPath') || '/home';
      localStorageService.remove(ENV + '_nextPath');
      $location.path(next);
      $timeout(function () {
        $animate.enabled(true);
      });
    });
  }
  _init();
}]);
'use strict';

/**
 * @ngdoc function
 * @name myNewProjectApp.controller:ChangeUserCtrl
 * @description
 * # ChangeUserCtrl
 * Controller of the myNewProjectApp
 */
angular.module('emma.theme').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/changeuser', {
    templateUrl: 'theme/changeuser/changeuser.html',
    controller: 'ChangeUserCtrl'
  });
}]).controller('ChangeUserCtrl', ["APP_URL", "$scope", "$location", "$log", "dbBaseFactory", "authFactory", "changeUserFactory", function (APP_URL, $scope, $location, $log, dbBaseFactory, authFactory, changeUserFactory) {
  $scope.data = null;
  $scope.searchString = '';
  $scope.searchUsers = function () {
    $scope.showTimeline = false;
    dbBaseFactory('user').search({
      'search': {
        'obj': {
          'searchString': $scope.searchString,
          'attivo': 'T'
        }
      },
      'init': {
        'username': true,
        'surname': true,
        'name': true,
        'email': true
      }
    }
    /*{query: getQuery(), page: paginationOptions.pageNumber, pageSize: paginationOptions.pageSize,
        sortFields: defaultSort(), history: $scope.isSnapshot()
    }*/).$promise.then(function (result) {
      $scope.data = result;
      //getPage();
    });
  };

  //copia e incolla da login.js
  $scope.changeUser = function (user) {
    changeUserFactory.changeUser(user, false);
  };
  $scope.isCurrent = function (username) {
    return username === authFactory.getAuthData().authId;
  };
  $scope.searchUsers();
}]);
'use strict';

angular.module('emma.theme').controller('LiquidChartCtrl', ['$scope', '$element', function ($scope, $element) {
  var config = {
    minValue: 0,
    // The gauge minimum value.
    maxValue: 100,
    // The gauge maximum value.
    circleThickness: 0.05,
    // The outer circle thickness as a percentage of it's radius.
    circleFillGap: 0.05,
    // The size of the gap between the outer circle and wave circle as a percentage of the outer circles radius.
    circleColor: "#178BCA",
    // The color of the outer circle.
    waveHeight: 0.05,
    // The wave height as a percentage of the radius of the wave circle.
    waveCount: 1,
    // The number of full waves per width of the wave circle.
    waveRiseTime: 1000,
    // The amount of time in milliseconds for the wave to rise from 0 to it's final height.
    waveAnimateTime: 18000,
    // The amount of time in milliseconds for a full wave to enter the wave circle.
    waveRise: true,
    // Control if the wave should rise from 0 to it's full height, or start at it's full height.
    waveHeightScaling: true,
    // Controls wave size scaling at low and high fill percentages. When true, wave height reaches it's maximum at 50% fill, and minimum at 0% and 100% fill. This helps to prevent the wave from making the wave circle from appear totally full or empty when near it's minimum or maximum fill.
    waveAnimate: true,
    // Controls if the wave scrolls or is static.
    waveColor: "#178BCA",
    // The color of the fill wave.
    waveOffset: 0,
    // The amount to initially offset the wave. 0 = no offset. 1 = offset of one full wave.
    textVertPosition: .5,
    // The height at which to display the percentage text withing the wave circle. 0 = bottom, 1 = top.
    textSize: 1,
    // The relative height of the text to display in the wave circle. 1 = 50%
    valueCountUp: true,
    // If true, the displayed value counts up from 0 to it's final value upon loading. If false, the final value is displayed.
    displayPercent: true,
    // If true, a % symbol is displayed after the value.
    textColor: "#045681",
    // The color of the value text when the wave does not overlap it.
    waveTextColor: "#A4DBf8" // The color of the value text when the wave overlaps it.
  };

  var gauge = loadLiquidFillGauge($element[0], $scope.percentage || 0, angular.extend({}, config, $scope.options));
  $scope.$watch('percentage', function (newValue, oldValue) {
    if (newValue != oldValue) {
      gauge.update(newValue);
    }
  });
  function loadLiquidFillGauge(element, value, config) {
    if (config == null) config = liquidFillGaugeDefaultSettings();
    var radius = Math.min(element.offsetWidth, $scope.height || 200) / 2;
    var fillPercent = Math.max(config.minValue, Math.min(config.maxValue, value)) / config.maxValue;
    var gauge = d3.select(element).append("svg:svg").attr("width", radius * 2).attr("height", radius * 2).style({
      display: 'block',
      margin: 'auto'
    });
    var waveHeightScale;
    if (config.waveHeightScaling) {
      waveHeightScale = d3.scale.linear().range([0, config.waveHeight, 0]).domain([0, 50, 100]);
    } else {
      waveHeightScale = d3.scale.linear().range([config.waveHeight, config.waveHeight]).domain([0, 100]);
    }
    var textPixels = config.textSize * radius / 2;
    var textFinalValue = parseFloat(value).toFixed(2);
    var textStartValue = config.valueCountUp ? config.minValue : textFinalValue;
    var percentText = config.displayPercent ? "%" : "";
    var circleThickness = config.circleThickness * radius;
    var circleFillGap = config.circleFillGap * radius;
    var fillCircleMargin = circleThickness + circleFillGap;
    var fillCircleRadius = radius - fillCircleMargin;
    var waveHeight = fillCircleRadius * waveHeightScale(fillPercent * 100);
    var waveLength = fillCircleRadius * 2 / config.waveCount;
    var waveClipCount = 1 + config.waveCount;
    var waveClipWidth = waveLength * waveClipCount;

    // Rounding functions so that the correct number of decimal places is always displayed as the value counts up.
    var textRounder = function textRounder(value) {
      return Math.round(value);
    };
    if (parseFloat(textFinalValue) != parseFloat(textRounder(textFinalValue))) {
      textRounder = function textRounder(value) {
        return parseFloat(value).toFixed(1);
      };
    }
    if (parseFloat(textFinalValue) != parseFloat(textRounder(textFinalValue))) {
      textRounder = function textRounder(value) {
        return parseFloat(value).toFixed(2);
      };
    }

    // Data for building the clip wave area.
    var data = [];
    for (var i = 0; i <= 40 * waveClipCount; i++) {
      data.push({
        x: i / (40 * waveClipCount),
        y: i / 40
      });
    }

    // Scales for drawing the outer circle.
    var gaugeCircleX = d3.scale.linear().range([0, 2 * Math.PI]).domain([0, 1]);
    var gaugeCircleY = d3.scale.linear().range([0, radius]).domain([0, radius]);

    // Scales for controlling the size of the clipping path.
    var waveScaleX = d3.scale.linear().range([0, waveClipWidth]).domain([0, 1]);
    var waveScaleY = d3.scale.linear().range([0, waveHeight]).domain([0, 1]);

    // Scales for controlling the position of the clipping path.
    var waveRiseScale = d3.scale.linear()
    // The clipping area size is the height of the fill circle + the wave height, so we position the clip wave
    // such that the it will overlap the fill circle at all when at 0%, and will totally cover the fill
    // circle at 100%.
    .range([fillCircleMargin + fillCircleRadius * 2 + waveHeight, fillCircleMargin - waveHeight]).domain([0, 1]);
    var waveAnimateScale = d3.scale.linear().range([0, waveClipWidth - fillCircleRadius * 2]) // Push the clip area one full wave then snap back.
    .domain([0, 1]);

    // Scale for controlling the position of the text within the gauge.
    var textRiseScaleY = d3.scale.linear().range([fillCircleMargin + fillCircleRadius * 2, fillCircleMargin + textPixels * 0.7]).domain([0, 1]);

    // Center the gauge within the parent SVG.
    var gaugeGroup = gauge.append("g");
    // .attr('transform', 'translate(' + locationX + ',' + locationY + ')');

    // Draw the outer circle.
    var gaugeCircleArc = d3.svg.arc().startAngle(gaugeCircleX(0)).endAngle(gaugeCircleX(1)).outerRadius(gaugeCircleY(radius)).innerRadius(gaugeCircleY(radius - circleThickness));
    gaugeGroup.append("path").attr("d", gaugeCircleArc).style("fill", config.circleColor).attr('transform', 'translate(' + radius + ',' + radius + ')');

    // Text where the wave does not overlap.
    var text1 = gaugeGroup.append("text").text(textRounder(textStartValue) + percentText).attr("class", "liquidFillGaugeText").attr("text-anchor", "middle").attr("font-size", textPixels + "px").style("fill", config.textColor).attr('transform', 'translate(' + radius + ',' + textRiseScaleY(config.textVertPosition) + ')');

    // The clipping wave area.
    var clipArea = d3.svg.area().x(function (d) {
      return waveScaleX(d.x);
    }).y0(function (d) {
      return waveScaleY(Math.sin(Math.PI * 2 * config.waveOffset * -1 + Math.PI * 2 * (1 - config.waveCount) + d.y * 2 * Math.PI));
    }).y1(function (d) {
      return fillCircleRadius * 2 + waveHeight;
    });
    var waveGroup = gaugeGroup.append("defs").append("clipPath").attr("id", "clipWave");
    var wave = waveGroup.append("path").datum(data).attr("d", clipArea).attr("T", 0);

    // The inner circle with the clipping wave attached.
    var fillCircleGroup = gaugeGroup.append("g").attr("clip-path", "url(#clipWave)");
    fillCircleGroup.append("circle").attr("cx", radius).attr("cy", radius).attr("r", fillCircleRadius).style("fill", config.waveColor);

    // Text where the wave does overlap.
    var text2 = fillCircleGroup.append("text").text(textRounder(textStartValue) + percentText).attr("class", "liquidFillGaugeText").attr("text-anchor", "middle").attr("font-size", textPixels + "px").style("fill", config.waveTextColor).attr('transform', 'translate(' + radius + ',' + textRiseScaleY(config.textVertPosition) + ')');

    // Make the value count up.
    if (config.valueCountUp) {
      var textTween = function textTween() {
        var i = d3.interpolate(this.textContent, textFinalValue);
        return function (t) {
          this.textContent = textRounder(i(t)) + percentText;
        };
      };
      text1.transition().duration(config.waveRiseTime).tween("text", textTween);
      text2.transition().duration(config.waveRiseTime).tween("text", textTween);
    }

    // Make the wave rise. wave and waveGroup are separate so that horizontal and vertical movement can be controlled independently.
    var waveGroupXPosition = fillCircleMargin + fillCircleRadius * 2 - waveClipWidth;
    if (config.waveRise) {
      waveGroup.attr('transform', 'translate(' + waveGroupXPosition + ',' + waveRiseScale(0) + ')').transition().duration(config.waveRiseTime).attr('transform', 'translate(' + waveGroupXPosition + ',' + waveRiseScale(fillPercent) + ')').each("start", function () {
        wave.attr('transform', 'translate(1,0)');
      }); // This transform is necessary to get the clip wave positioned correctly when waveRise=true and waveAnimate=false. The wave will not position correctly without this, but it's not clear why this is actually necessary.
    } else {
      waveGroup.attr('transform', 'translate(' + waveGroupXPosition + ',' + waveRiseScale(fillPercent) + ')');
    }
    if (config.waveAnimate) animateWave();
    function animateWave() {
      wave.attr('transform', 'translate(' + waveAnimateScale(wave.attr('T')) + ',0)');
      wave.transition().duration(config.waveAnimateTime * (1 - wave.attr('T'))).ease('linear').attr('transform', 'translate(' + waveAnimateScale(1) + ',0)').attr('T', 1).each('end', function () {
        wave.attr('T', 0);
        animateWave(config.waveAnimateTime);
      });
    }
    function GaugeUpdater() {
      this.update = function (value) {
        var newFinalValue = parseFloat(value).toFixed(2);
        var textRounderUpdater = function textRounderUpdater(value) {
          return Math.round(value);
        };
        if (parseFloat(newFinalValue) != parseFloat(textRounderUpdater(newFinalValue))) {
          textRounderUpdater = function textRounderUpdater(value) {
            return parseFloat(value).toFixed(1);
          };
        }
        if (parseFloat(newFinalValue) != parseFloat(textRounderUpdater(newFinalValue))) {
          textRounderUpdater = function textRounderUpdater(value) {
            return parseFloat(value).toFixed(2);
          };
        }
        var textTween = function textTween() {
          var i = d3.interpolate(this.textContent, parseFloat(value).toFixed(2));
          return function (t) {
            this.textContent = textRounderUpdater(i(t)) + percentText;
          };
        };
        text1.transition().duration(config.waveRiseTime).tween("text", textTween);
        text2.transition().duration(config.waveRiseTime).tween("text", textTween);
        var fillPercent = Math.max(config.minValue, Math.min(config.maxValue, value)) / config.maxValue;
        var waveHeight = fillCircleRadius * waveHeightScale(fillPercent * 100);
        var waveRiseScale = d3.scale.linear()
        // The clipping area size is the height of the fill circle + the wave height, so we position the clip wave
        // such that the it will overlap the fill circle at all when at 0%, and will totally cover the fill
        // circle at 100%.
        .range([fillCircleMargin + fillCircleRadius * 2 + waveHeight, fillCircleMargin - waveHeight]).domain([0, 1]);
        var newHeight = waveRiseScale(fillPercent);
        var waveScaleX = d3.scale.linear().range([0, waveClipWidth]).domain([0, 1]);
        var waveScaleY = d3.scale.linear().range([0, waveHeight]).domain([0, 1]);
        var newClipArea;
        if (config.waveHeightScaling) {
          newClipArea = d3.svg.area().x(function (d) {
            return waveScaleX(d.x);
          }).y0(function (d) {
            return waveScaleY(Math.sin(Math.PI * 2 * config.waveOffset * -1 + Math.PI * 2 * (1 - config.waveCount) + d.y * 2 * Math.PI));
          }).y1(function (d) {
            return fillCircleRadius * 2 + waveHeight;
          });
        } else {
          newClipArea = clipArea;
        }
        var newWavePosition = config.waveAnimate ? waveAnimateScale(1) : 0;
        wave.transition().duration(0).transition().duration(config.waveAnimate ? config.waveAnimateTime * (1 - wave.attr('T')) : config.waveRiseTime).ease('linear').attr('d', newClipArea).attr('transform', 'translate(' + newWavePosition + ',0)').attr('T', '1').each("end", function () {
          if (config.waveAnimate) {
            wave.attr('transform', 'translate(' + waveAnimateScale(0) + ',0)');
            animateWave(config.waveAnimateTime);
          }
        });
        waveGroup.transition().duration(config.waveRiseTime).attr('transform', 'translate(' + waveGroupXPosition + ',' + newHeight + ')');
      };
    }
    return new GaugeUpdater();
  }
}]).directive('liquid', function () {
  return {
    scope: {
      percentage: '=',
      height: "=?",
      options: '='
    },
    template: '<div class="w-full"></div>',
    replace: true,
    restrict: 'AE',
    controller: 'LiquidChartCtrl'
  };
});
'use strict';

/**
 * @ngdoc function
 * @name emma.theme.controller:CommissionCtrl
 * @description
 * # CommissionCtrl
 * Controller of the emma.theme
 */
angular.module('emma.theme').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/commission', {
    templateUrl: 'theme/commission/commission_list.html',
    controller: 'CommissionCtrl'
  }).when('/commission/:id', {
    templateUrl: 'theme/commission/commission_detail.html',
    controller: 'CommissionCtrl'
  });
}]).controller('CommissionCtrl', ["$scope", "$routeParams", "$rootScope", "$location", "$log", "$window", "$filter", "commissionFactory", "toaster", "counterFactory", "$route", "authFactory", "loginFactory", "dialogService", "uiGridConstants", "sixGridPaginationConstants", "formulaFactory", function ($scope, $routeParams, $rootScope, $location, $log, $window, $filter, commissionFactory, toaster, counterFactory, $route, authFactory, loginFactory, dialogService, uiGridConstants, sixGridPaginationConstants, formulaFactory) {
  $scope.isTimeSpanValid = false;
  $scope.timespan = {
    startTime: null,
    endTime: null
  };
  $scope.enableTimePicker;
  $scope.typeName = 'commission';
  $scope.counterName = 'commission';
  $scope.data = {
    list: [],
    selected: ""
  };
  $scope.commissionTypeList = [{
    key: 'standard',
    description: 'Normale'
  }, {
    key: 'multiCustomer',
    description: 'Multi Cliente (Consip)'
  }];
  $scope.statusList = [{
    key: 'open',
    description: 'Aperta'
  }, {
    key: 'closed',
    description: 'Chiusa'
  }];
  $scope.dateOptions = {
    formatYear: 'yyyy'
  };
  $scope.closingDateOptions = {
    formatYear: 'yyyy',
    maxDate: new Date()
  };
  $scope.params = {
    pageNumber: 1,
    pageSize: 15,
    totalItems: 0,
    queryParam: undefined,
    filters: {}
  };
  $scope.gridAppCallbacks = {};
  $scope.disableSave = false;
  var watchgroup = ['data.selected.description', 'data.selected.typeSelect', 'data.selected.customer', 'data.selected.sapCode', 'data.selected.date', 'data.selected.status'];
  var isFormulaCode = false;
  var isCustomCode; //necessario per la modifica in creazione del codice

  $scope.cellClassFormatter = function (grid, row, col, rowRenderIndex, colRenderIndex) {
    if (row.entity.status) {
      return row.entity.status === 'closed' ? "closed-commission" : "";
    }
    return "";
  };
  $scope.gridAppCallbacks['cellClassFormatter'] = $scope.cellClassFormatter;
  $scope.viewGridOptions = {
    exporterCsvColumnSeparator: ';',
    exporterSuppressColumns: ['id', 'select'],
    exporterMenuPdf: false,
    enableRowSelection: false,
    enableRowHeaderSelection: false,
    paginationPageSize: $scope.params.pageSize,
    columnDefs: [{
      displayName: '',
      field: 'id',
      width: 72,
      cellClass: $scope.cellClassFormatter,
      enableColumnMenu: false,
      enableFiltering: false,
      enableSorting: false,
      enableColumnResizing: false,
      enableHiding: false,
      cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/commission/{{row.entity.code}}" class="btn btn-xs btn-primary">' + '<span class="fa fa-search"></span>' + '</a>' + '<a ng-href="#/commission/{{row.entity.code}}/copy" class="btn btn-xs btn-primary m-l-xs">' + '<span class="fa fa-clone"></span>' + '</a>' + '</div>'
    }, {
      displayName: 'Codice',
      field: 'code',
      width: 100,
      cellClass: $scope.cellClassFormatter,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }, {
      displayName: 'Descrizione',
      field: 'description',
      cellClass: $scope.cellClassFormatter,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }, {
      displayName: 'Stato',
      field: 'status',
      width: 150,
      cellClass: $scope.cellClassFormatter,
      filters: [{
        type: sixGridPaginationConstants.filterType.SELECT,
        condition: uiGridConstants.filter.CONTAINS,
        selectOptions: [{
          value: 'open',
          label: 'Aperta'
        }, {
          value: 'closed',
          label: 'Chiusa'
        }],
        placeholder: ''
      }],
      cellTemplate: '<div class="ui-grid-cell-contents" style="vertical-align:middle;">' + '{{row.entity.status != "closed"? "Aperta" : "Chiusa"}}' + '</div>'
    }, {
      displayName: 'Data apertura',
      field: 'date',
      cellClass: $scope.cellClassFormatter,
      cellFilter: 'date:\'dd/MM/yyyy\'',
      width: 100,
      filters: [{
        type: sixGridPaginationConstants.filterType.DATE,
        relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
        placeholder: 'da...',
        condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
      }, {
        type: sixGridPaginationConstants.filterType.DATE,
        relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
        placeholder: 'a...',
        condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
      }]
    }, {
      displayName: 'Data chiusura',
      field: 'closing_date',
      cellClass: $scope.cellClassFormatter,
      cellFilter: 'date:\'dd/MM/yyyy\'',
      width: 100,
      filters: [{
        type: sixGridPaginationConstants.filterType.DATE,
        relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
        placeholder: 'da...',
        condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
      }, {
        type: sixGridPaginationConstants.filterType.DATE,
        relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
        placeholder: 'a...',
        condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
      }]
    }, {
      displayName: '',
      field: 'select',
      cellClass: $scope.cellClassFormatter,
      width: 36,
      enableColumnMenu: false,
      enableFiltering: false,
      enableSorting: false,
      enableColumnResizing: false,
      enableHiding: false,
      cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-click="grid.appScope.changeCommission(row.entity)" class="btn btn-xs btn-primary">' + '<span class="fa fa-arrow-left"></span>' + '</a>' + '</div>'
    }]
  };
  $scope.addCommission = function () {
    $location.path('commission/new');
  };
  $scope.refresh = function () {
    $location.path('commission');
  };
  $scope.changeCommission = function (commission) {
    var switchProfileElement = {
      selected: {
        type: '',
        cod: 0,
        code: commission.code,
        description: commission.description,
        items: [{
          type: 'commission',
          cod: 0,
          code: commission.code,
          description: commission.description
        }]
      }
    };
    dialogService.loading('Cambio commessa ' + authFactory.getAuthData().info.commissions.current.code + ' <i class="fa fa-angle-double-right"></i> ' + commission.code);
    loginFactory["switch"](switchProfileElement).$promise.then(function (response) {
      response.info.commissions.current = commission;
      authFactory.setAuthData(response);
      $route.reload();
      dialogService.stopLoading();
    });
  };
  $scope.gridAppCallbacks['changeCommission'] = $scope.changeCommission;
  $scope.codeChanged = function () {
    isCustomCode = true;
  };
  $scope.getData = function () {
    var payload = {
      query: $scope.params.queryParam,
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      sort_fields: $scope.params.sortFields
    };
    return commissionFactory().search(payload, $scope.params.filters).$promise.then(function (response) {
      $scope.data = response;
      if ($scope.params.sixApi) {
        $scope.params.sixApi.refreshList($scope.data);
      }
      return $scope.data;
    });
  };
  $scope.getAllData = function () {
    var payload = {
      page: 1,
      page_size: 10000,
      sort_fields: $scope.params.sortFields
    };
    return commissionFactory().search(payload, {}).$promise.then(function (response) {
      $scope.data = response;
      if ($scope.params.sixApi) {
        $scope.params.sixApi.refreshList($scope.data);
      }
      return $scope.data;
    });
  };
  $scope.errorsRetrievingCounter = function (errors) {
    $log.error('impossibile recuperare il contatore ' + JSON.stringify(errors));
    $rootScope.$broadcast('topPanel', {
      messages: errors
    });
  };
  function _timespanvalid() {
    return $scope.timespan.startTime.diff($scope.timespan.endTime) < 0;
  }
  $scope.onSubmit = function (form) {
    if ($scope.timespan.startTime && $scope.timespan.endTime && _timespanvalid()) {
      if ($scope.timespan.startTime) {
        $scope.data.selected.startTime = $scope.timespan.startTime.toISOString();
      }
      if ($scope.timespan.endTime) {
        $scope.data.selected.endTime = $scope.timespan.endTime.toISOString();
      }
      if (!isCustomCode) {
        form.$setSubmitted();
        if (form.$valid) {
          $scope.update();
        } else {
          toaster.pop('error', 'Errore', 'Controllare i dati inseriti');
        }
      } else {
        _customCodeOnSubmit(form);
      }
    } else {
      toaster.pop('error', 'Errore', 'Controllare i dati inseriti');
    }
  };
  function _customCodeOnSubmit(form) {
    if ($scope.data.selected.code && $scope.data.selected.code != "") {
      commissionFactory().getCommissionByCode({
        code: $scope.data.selected.code
      }).$promise.then(function (resp) {
        if (!resp.code) {
          form.$setSubmitted();
          if (form.$valid) {
            upd();
          } else {
            toaster.pop('error', 'Errore', 'Controllare i dati inseriti');
          }
        } else {
          toaster.pop("error", "Errore", "Codice commessa già esistente");
        }
      })["catch"](function (error) {
        toaster.pop("error", "Errore", "Errore impossibile salvare");
        console.error(error);
      });
    } else {
      toaster.pop("error", "Errore", "Codice commessa non valido");
    }
  }
  $scope.update = function () {
    if ($scope.isNew) {
      if (isFormulaCode) {
        if ($scope.data.selected.code && !new RegExp(/\s/g).test($scope.data.selected.code)) {
          updateWithFormulaCode();
        } else {
          toaster.pop("error", "Errore", "Il campo codice non puù contenere spazi");
        }
      } else {
        updateWithCounterCode();
      }
    } else {
      upd();
    }
  };
  function updateWithFormulaCode() {
    if ($scope.data.selected.code && $scope.data.selected.code != "") {
      commissionFactory().getCommissionByCode({
        code: $scope.data.selected.code
      }).$promise.then(function (resp) {
        if (!resp.code) {
          upd();
        } else {
          toaster.pop("error", "Errore", "Codice commessa già esistente");
        }
      })["catch"](function (error) {
        toaster.pop("error", "Errore", "Errore impossibile salvare");
        console.error(error);
      });
    } else {
      toaster.pop("error", "Errore", "Codice commessa non valido");
    }
  }
  function updateWithCounterCode() {
    $log.info('sto facendo una commission nuova, confermo contatore');
    counterFactory.next({
      code: $scope.counterName
    }).$promise.then(function (response) {
      if (response.errors) {
        $scope.errorsRetrievingCounter(response.errors);
        return;
      }
      $scope.data.selected.code = response.next;
      upd();
    });
  }
  function upd() {
    //evito il flash di undefined sull'interfaccia lavorando su una copia
    var toSave = JSON.parse(JSON.stringify($scope.data.selected));
    toSave.status = toSave.status.key;
    toSave.commissionType = toSave.commissionType.key;
    commissionFactory().saveCommission(toSave).$promise.then(function () {
      $log.info('saving: ' + toSave);
      $window.history.back();
    });
  }
  $scope.deleteWithDialog = function (idToDelete) {
    dialogService.confirmDialog('Eliminare la commessa?', function () {
      $scope["delete"](idToDelete);
    });
  };
  $scope["delete"] = function (idToDelete) {
    $log.info('deleting id:' + idToDelete);
    commissionFactory().deleteCommission({
      id: idToDelete
    }).$promise.then(function () {
      $scope.getData();
      $location.path('commission');
      $route.reload(); //refresh della pagina per "forzare" reload del controller
    });
  };

  $scope.getCommissionById = function (itemId) {
    //console.log('currentpage '+$scope.data.currentPage);
    $scope.isNew = false;
    commissionFactory().getCommissionByCode({
      code: itemId
    }).$promise.then(function (response) {
      $scope.data = {
        selected: response
      };
      console.log('current commission found: ', $scope.data.selected);
      if ($scope.data.selected.date) {
        $scope.data.selected.date = new Date($scope.data.selected.date);
      }
      if ($scope.data.selected.status) {
        var filteredStatus = $scope.statusList.filter(function (val) {
          if (val.key == $scope.data.selected.status) {
            return true;
          }
          return false;
        });
        $scope.data.selected.status = filteredStatus[0];
      }
      if ($scope.data.selected.commissionType) {
        var filteredType = $scope.commissionTypeList.filter(function (val) {
          if (val.key == $scope.data.selected.commissionType) {
            return true;
          }
          return false;
        });
        $scope.data.selected.commissionType = filteredType[0];
      }
      if ($scope.data.selected.startTime) {
        $scope.timespan.startTime = moment($scope.data.selected.startTime);
      }
      if ($scope.data.selected.endTime) {
        $scope.timespan.endTime = moment($scope.data.selected.endTime);
      }
      $scope.enableTimePicker = true;
      if ($scope.data.selected.closing_date) {
        $scope.data.selected.closing_date = new Date($scope.data.selected.closing_date);
      }
      if (!$scope.data.selected.cliente) {
        $scope.data.selected.cliente = [];
      }
      if ($routeParams.id == 'new') {
        $scope.isNew = true;
        setNewCommission();
        $scope.data.selected.commissionType = $scope.commissionTypeList[0];
      }
    });
  };
  var getCommissionCode;
  function setNewCommission() {
    commissionFactory().getCodeConfig().$promise.then(function (resp) {
      if (resp.result.codeConfig) {
        //codice commessa calcolato con formula
        formulaFactory.getFormulaById({
          id: resp.result.codeConfig
        }).$promise.then(function (formula) {
          if (formula.formula && formula.formula != "") {
            try {
              getCommissionCode = eval("(" + formula.formula + ")");
            } catch (e) {
              toaster.pop("error", "ERRORE", "Impossibile ottenere la funzione per il calcolo del codice commessa, verificare la formula");
              $scope.disableSave = true;
              throw new Error(e.message);
            }
            isFormulaCode = true;
            $scope.disableSave = false;
          } else {
            toaster.pop("error", "Errore", "impossibile calcolare il codice commessa, verificare configurazione matrix-par e formula");
            $scope.disableSave = true;
          }
        });
      } else {
        //codice commessa calcolato con contatore
        counterFactory.current({
          code: $scope.counterName
        }).$promise.then(function (response) {
          if (response.errors) {
            $scope.errorsRetrievingCounter(response.errors);
            $window.history.back();
            return;
          }
          $log.info('sto facendo una commission nuova ' + response + ' ' + JSON.stringify(response));
          $scope.data.selected.code = parseInt(response.current) + 1;
        });
      }
    });
  }
  $scope.setClosure = function (item) {
    if (item && item.key == "closed") {
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      $scope.data.selected.closing_date = today;
    }
  };
  $scope.exportCommissions = function (typeExport) {
    // preparo colonne
    var columns = [{
      key: 'code',
      name: 'Codice'
    }, {
      key: 'description',
      name: 'Descrizione'
    }, {
      key: 'date',
      name: 'Data Apertura',
      transform: function transform(v) {
        return $filter('date')(v, 'dd/MM/yyyy');
      }
    }, {
      key: 'closing_date',
      name: 'Data Chiusura',
      transform: function transform(v) {
        return $filter('date')(v, 'dd/MM/yyyy');
      }
    }, {
      key: 'status',
      name: 'Status',
      transform: function transform(v) {
        return v == 'closed' ? 'Chiusa' : 'Aperta';
      }
    }];

    // preparo righe
    var rows = $scope.params.gridApi.selection.getSelectedRows();
    if (!rows || rows.length == 0) {
      var promise = {};
      var payload = {
        page: 1,
        page_size: 10000,
        show_revision: false
      };
      promise = commissionFactory().search(payload, $scope.params.filters).$promise;
      // aspetto la risposta...
      promise.then(function (data) {
        rows = data.list;
        sixExportLib.exportXLSX(columns, rows, "commission");
      });
    } else {
      sixExportLib.exportXLSX(columns, rows, "commission");
    }
  };
  $scope.$watch(function () {
    return $scope.data.selected ? $scope.data.selected.date : '';
  }, function () {
    if ($scope.data.selected && $scope.data.selected.date) {
      $scope.closingDateOptions.minDate = $scope.data.selected.date;
    }
  });
  $scope.$watch(function () {
    return $scope.data.selected ? $scope.data.selected.closing_date : '';
  }, function () {
    if ($scope.data.selected && $scope.data.selected.closing_date) {
      $scope.dateOptions.maxDate = $scope.data.selected.closing_date;
    }
  });
  $scope.$watch(function () {
    return $scope.data.selected ? $scope.data.selected.status : "";
  }, function () {
    if ((!$scope.data.selected.status || $scope.data.selected.status.key == 'open') && $scope.data.selected.closing_date) {
      delete $scope.data.selected.closing_date;
    }
  });

  /* ------- MAIN ------ */
  if ($routeParams.id) {
    $scope.getCommissionById($routeParams.id);
  }

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'commission';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME, true);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME, true);
  };
}]);
"use strict";

angular.module('emma.theme').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/commission/:id/copy', {
    templateUrl: 'theme/commission/commission_copy.html',
    controller: 'CommissionCopyCtrl'
  });
}]).controller('CommissionCopyCtrl', ["$scope", "$rootScope", "$routeParams", "$window", "$log", "$interpolate", "commissionFactory", "counterFactory", "dataSetFactory", "toaster", function ($scope, $rootScope, $routeParams, $window, $log, $interpolate, commissionFactory, counterFactory, dataSetFactory, toaster) {
  var copiedMess = $interpolate('Copiati {{count}} {{type}}');
  var treeMess = $interpolate('Impossibile risolvere il riferimento nell\'albero di {{type}}-{{UUID}}');
  $scope.warningGrid = {
    rowHeight: 35,
    columnDefs: [{
      displayName: '',
      field: 'status',
      width: 35,
      cellTemplate: 'theme/commission/circle-tmpl.html'
    }, {
      displayName: 'Messaggio',
      field: 'code'
    }]
  };
  $scope.copy = function () {
    var request = {
      source_code: $scope.sourceCommission,
      description: $scope.commission.description,
      sap_code: $scope.commission.sapCode,
      types: ($scope.commission.types || []).map(function (i) {
        return i.code;
      }),
      customers: ($scope.commission.customers || []).map(function (i) {
        return i.code;
      }),
      copy_tree: $scope.commission.tree
    };
    counterFactory.next({
      code: 'commission'
    }).$promise.then(function (response) {
      if (response.errors) {
        $log.error('impossibile recuperare il contatore ' + JSON.stringify(response.errors));
        $rootScope.$broadcast('topPanel', {
          messages: response.errors
        });
        return;
      }
      request.code = response.next;
      copy(request);
    }, function (err) {
      $log.error(err);
      toaster.pop('error', 'Errore', 'Impossibile confermare il nuovo codice commessa');
    });
  };
  function copy(request) {
    $log.info(request);
    dataSetFactory('commission').copy(request).$promise.then(function (response) {
      if (response.status == 'error') {
        response.messages.forEach(function (m) {
          toaster.pop('error', 'Errore', m.message);
        });
      } else {
        $scope.response = response;
        $scope.warningGrid.data = $scope.response.messages.filter(function (m) {
          return m.warning;
        }).map(function (m) {
          if (m.code == 'corrupted_parent') {
            m.code = treeMess(m.payload);
          }
          return m;
        });
        angular.forEach($scope.response.result.imported_documents, function (count, key) {
          $scope.warningGrid.data.push({
            status: "SUCCESS",
            code: copiedMess({
              count: count,
              type: key
            })
          });
        });
      }
    }, function (err) {
      $log.error(err);
      toaster.pop('error', 'Errore', 'Copia non riuscita');
    });
  }
  function init() {
    $scope.sourceCommission = $routeParams.id;
    commissionFactory().getCommissionByCode({
      code: $routeParams.id
    }).$promise.then(function (response) {
      $scope.commissionCustomers = angular.isArray(response.cliente) ? response.cliente : angular.isDefined(response.cliente) ? [response.cliente] : [];
      $scope.commission = response;
      $scope.commission.sapCode = null;
      counterFactory.current({
        code: 'commission'
      }).$promise.then(function (response) {
        if (response.errors) {
          $log.error('impossibile recuperare il contatore ' + JSON.stringify(response.errors));
          $rootScope.$broadcast('topPanel', {
            messages: response.errors
          });
          $window.history.back();
        } else {
          $log.info('sto facendo una commission nuova ' + response + ' ' + JSON.stringify(response));
          $scope.commission.code = parseInt(response.current) + 1;
        }
      }, function (err) {
        $log.error('impossibile recuperare il contatore ' + JSON.stringify(err));
        $window.history.back();
      });
    }, function (err) {
      toaster.pop('error', 'Errore', 'Impossibile trovare la commessa');
      $window.history.back();
    });
  }
  init();
}]);
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/**
 * recursive-diff - Licensed under The MIT License (MIT) - Copyright (C) 2015 Anant Shukla <anant.shukla.rkgit@gmail.com>
 *
 *
 * getDiff(object1, object 2) -> ritorna le differenze tra due oggetti, accetta un oggetto options {optionKey: optionValue}:
  *     - strictNullCheck: type -> boolean (default: true) => distingue null da undefined.
 *       ES:
 *         diff.getDiff({a: null},{a: undefined}, {strictNullCheck: true}) = {/a: {operation: 'delete'}}
 *         diff.getDiff({a: null},{a: undefined}, {strictNullCheck: false}) = {}
 *
 *     - doNotMatch: type -> function (default: return !startsWith("$")) => funzione  usata per escludere proprietà degli oggetti dal confronto. riceve come parametro
 *        la chiave dell'oggetto confrontato.
 *        ES:
 *         diff.getDiff({a: null},{a: 'test'}, {strictNullCheck: false}) = {/a: {operation: 'add', value: 'test'}}
 *         diff.getDiff({a: null},{a: 'test'}, {doNotMatch: function(key){return key != 'a'}} ) = {}
 *
 *     - dateToPrimitive: type -> function (default: return date.getTime()) => funzione da usare per convertire oggetti data in primitivo per il confronto,
 *       riceve come parametro un nuovo oggetto data, le modifiche sul parametro non si ripercuotono sul valore originale dell'oggetto.
 *       Viene eseguita se almeno una delle due chiavi degli oggetti confrontati ha come valore un oggetto data, in quel caso entrambe le chiavi sono convertite
 *       in primitivo usando la funzione provvista, o quella di default se nessuna funzione viene specificata.
 *       ES:
 *         var t = new Date()
 *         diff.getDiff({a: t.toString()},{a: t}, {dateToPrimitive: function(val){return val.toLocalDateTime() }} ) = {}
 *
 *     -ATTENZIONE: Nella conversione stringa -> data, se nella stringa non sono specificati anche i millisecondi, js inserisce i millisecondi al momento della creazione,
 *       il che può generare due date diverse anche a partire dalla stessa data.
 *       Per questo motivo la funzione di confronto di default azzera i millisecondi a entrambe le date prima di effettuare il confronto.
 *
 *       N.B. ->  il valore ritornato è comunque quello originale prima della conversione.
 *       N.B.B. -> la stessa data formattata in modi diversi (ISO vs DD/MM/YYYY) risulterà come differenza
 *
 */
;
(function () {
  var diff = function () {
    var getType = function getType(x) {
      var type = _typeof(x);
      if (type === 'object' && Object.prototype.toString.call(x).match(/array/i)) {
        type = 'array';
      }
      return type;
    };
    var isType = function isType(x, typ) {
      if (x) {
        var t = _typeof(x);
        if (t === 'object' && Object.prototype.toString.call(x).match(/array/i)) t = 'array';
        return t === typ;
      }
      return false;
    };
    var isArrayOfNull = function isArrayOfNull(arr) {
      if (isType(arr, 'array')) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] != null) {
            //null or undefined
            return false;
          }
        }
        return true;
      }
      return false;
    };
    var findDiff = function findDiff(ob1, ob2, path, result, strictNullCheck, doNotMatch, dateToPrimitive) {
      var val1, val2, newpath, key;
      var type1 = getType(ob1);
      var type2 = getType(ob2);
      //initialize some defaults
      if (path == null || typeof path !== 'string') path = '/'; //initialize to root path
      if (result == null || _typeof(result) !== 'object') result = {};
      //diff algo
      if (ob1 == null || ob2 == null) {
        var diffObjs = strictNullCheck ? ob1 !== ob2 : ob1 != ob2;
        if (diffObjs) {
          if (type1 === 'undefined') {
            result[path] = {
              operation: 'add',
              value: ob2
            };
          } else if (type2 === 'undefined') {
            result[path] = {
              operation: 'delete'
            };
          } else {
            result[path] = {
              operation: 'update',
              value: ob2
            };
          }
        }
      } else if (type1 !== type2 || type1 !== 'object' && type1 !== 'array' || type2 !== 'object' && type2 !== 'array') {
        if (ob1 !== ob2) {
          result[path] = {
            operation: 'update',
            value: ob2
          };
        }
      } else {
        for (key in ob1) {
          if (doNotMatch(key)) {
            newpath = path === '/' ? path + key : path + '/' + key;
            val1 = ob1[key];
            val2 = ob2[key];
            if (val1 == null || val2 == null) {
              if (!strictNullCheck) {
                if (val1 != val2) {
                  //null != undefined = false
                  if (isType(val1, 'array') || isType(val2, 'array')) {
                    if (val1 && val1.length && !isArrayOfNull(val1)) result[newpath] = {
                      operation: 'delete'
                    }; // val1 is non empty array
                    else if (val2 && val2.length && !isArrayOfNull(val2)) result[newpath] = {
                      operation: 'add',
                      value: val2
                    }; // val2 is non empty array
                  } else {
                    if (!val1) {
                      result[newpath] = {
                        operation: 'add',
                        value: val2
                      };
                    } else if (!val2) {
                      result[newpath] = {
                        operation: 'delete'
                      };
                    }
                  }
                }
              } else {
                if (val1 !== val2) {
                  // null !== undefined = true
                  if (typeof val1 === 'undefined') {
                    result[newpath] = {
                      operation: 'add',
                      value: val2
                    };
                  } else if (typeof val2 === 'undefined') {
                    result[newpath] = {
                      operation: 'delete'
                    };
                  } else {
                    result[newpath] = {
                      operation: 'update',
                      value: val2
                    };
                  }
                }
              }
            } else {
              if (val1.constructor.name == 'Date' || val2.constructor.name == 'Date') {
                //val1 e val2 puntano alla data modificata, non posso ritornare val, ritorno obj[key];
                if (val1.constructor.name == 'Date') {
                  if (!isNaN(val1)) {
                    val1 = dateToPrimitive(new Date(val1));
                  } else {
                    throw 'value at path ' + newpath + ' is invalid date';
                  }
                } else if (val1.constructor.name == 'String') {
                  val1 = dateToPrimitive(new Date(val1));
                }
                if (val2.constructor.name == 'Date') {
                  if (!isNaN(val2)) {
                    val2 = dateToPrimitive(new Date(val2));
                  } else {
                    throw 'value at path ' + newpath + ' is invalid date';
                  }
                } else if (val2.constructor.name == 'String') {
                  val2 = dateToPrimitive(new Date(val2));
                }
              }
              if (getType(val1) !== getType(val2)) {
                result[newpath] = {
                  operation: 'update',
                  value: ob2[key]
                };
              } else {
                if (_typeof(val1) === 'object') {
                  findDiff(ob1[key], ob2[key], newpath, result, strictNullCheck, doNotMatch, dateToPrimitive);
                } else {
                  if (val1 !== val2) {
                    result[newpath] = {
                      operation: 'update',
                      value: ob2[key]
                    };
                  }
                }
              }
            }
          }
        }
        for (key in ob2) {
          if (doNotMatch(key)) {
            newpath = path === '/' ? path + key : path + '/' + key;
            val1 = ob1[key];
            val2 = ob2[key];
            if (val1 && val2 && (val1.constructor.name == 'Date' || val2.constructor.name == 'Date')) {
              if (val1.constructor.name == 'Date') {
                if (!isNaN(val1)) {
                  val1 = dateToPrimitive(new Date(val1));
                } else {
                  throw 'value at path ' + newpath + ' is invalid date';
                }
              } else if (val1.constructor.name == 'String') {
                val1 = dateToPrimitive(new Date(val1));
              }
              if (val2.constructor.name == 'Date') {
                if (!isNaN(val2)) {
                  val2 = dateToPrimitive(new Date(val2));
                } else {
                  throw 'value at path ' + newpath + ' is invalid date';
                }
              } else if (val2.constructor.name == 'String') {
                val2 = dateToPrimitive(new Date(val2));
              }
            }
            if (!strictNullCheck) {
              if (val1 != val2) {
                if (!val1 && !isArrayOfNull(val2)) {
                  result[newpath] = {
                    operation: 'add',
                    value: ob2[key]
                  };
                }
              }
            } else {
              if (val1 !== val2) {
                if (typeof val1 === 'undefined') {
                  result[newpath] = {
                    operation: 'add',
                    value: ob2[key]
                  };
                }
              }
            }
          }
        }
      }
      return result;
    };
    var setValueByPath = function setValueByPath(ob, path, value, visitorCallback) {
      if (!path.match(/^\//)) {
        throw 'diff path is not valid';
      }
      var keys = path.split('/');
      keys.shift();
      var val = ob;
      var length = keys.length;
      for (var i = 0; i < length; i++) {
        if (val == null || keys[i].length < 1) {
          throw 'Invalid data';
        }
        if (i !== length - 1) {
          val = val[keys[i]];
          if (visitorCallback) {
            visitorCallback(val);
          }
        } else {
          val[keys[i]] = value;
        }
      }
      return ob;
    };
    var deleteValueByPath = function deleteValueByPath(ob, path) {
      var keys = path.split('/');
      keys.shift(); //removing initial blank element ''
      var val = ob;
      var length = keys.length;
      for (var i = 0; i < length; i++) {
        if (i !== length - 1) {
          if (val[keys[i]] == null) {
            throw 'invalid data';
          }
          val = val[keys[i]];
        } else {
          if (getType(val) === 'object') {
            delete val[keys[i]];
          } else {
            var index = parseInt(keys[i]);
            while (val.length > index) {
              val.pop();
            }
          }
        }
      }
      return ob;
    };
    var _applyDiff = function applyDiff(ob1, diff, visitorCallback) {
      var path, diffOb, op;
      if (diff == null) {
        throw 'No diff object is provided, Nothing to apply';
      }
      for (var key in diff) {
        path = key;
        diffOb = diff[key];
        op = diffOb.operation;
        if (op.match(/add|update|delete/)) {
          if (op === 'add') {
            if (path === '/') {
              ob1 = diffOb.value;
              break;
            }
            setValueByPath(ob1, path, diffOb.value, visitorCallback);
          } else if (op === 'update') {
            if (path === '/') {
              ob1 = diffOb.value;
              break;
            }
            setValueByPath(ob1, path, diffOb.value, visitorCallback);
          } else {
            if (path === '/') {
              ob1 = null;
              break;
            }
            deleteValueByPath(ob1, path);
          }
        } else {
          throw 'malformed diff object';
        }
      }
      return ob1;
    };
    return {
      getDiff: function getDiff(ob1, ob2, options) {
        var strictNullCheck = options && options.strictNullCheck == false ? options.strictNullCheck : true;
        var doNotMatch = options && options.doNotMatch && typeof options.doNotMatch == 'function' ? options.doNotMatch : function (key) {
          return !key.startsWith("$");
        };
        var dateToPrimitive = options && options.dateToPrimitive && typeof options.dateToPrimitive == 'function' ? options.dateToPrimitive : function (val) {
          return new Date(val.setMilliseconds(0)).getTime();
        };
        var result = findDiff(ob1, ob2, undefined, undefined, strictNullCheck, doNotMatch, dateToPrimitive);
        return result;
      },
      applyDiff: function applyDiff(ob, diff, visitorCallback) {
        var result = _applyDiff(ob, diff, visitorCallback);
        return result;
      }
    };
  }();
  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = diff;
  } else {
    window.diff = diff;
  }
})();
"use strict";

(function (window, document) {
  'use strict';

  // attach sixDateLib as a property of window
  var sixDateLib = window.sixDateLib || (window.sixDateLib = {});

  // BEGIN API

  function getLocale() {
    return {
      'decimal': '.',
      'thousands': ',',
      'grouping': [3],
      'currency': ['$', ''],
      'dateTime': '%a %b %e %X %Y',
      'date': '%d/%m/%Y',
      'time': '%H:%M:%S',
      'periods': ['AM', 'PM'],
      'days': ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
      'shortDays': ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
      'months': ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
      'shortMonths': ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic']
    };
  }
  function getMonthIndex(name) {
    return getLocale().months.indexOf(name);
  }
  function getMonthName(n) {
    return getLocale().months[n];
  }
  function getMonthShortName(n) {
    return getLocale().shortMonths[n];
  }
  function getMonths() {
    return getLocale().months;
  }
  function getWeekDayIndex(name) {
    return getLocale().days.indexOf(name);
  }
  function getWeekDayName(n) {
    return getLocale().days[n];
  }
  function getWeekDayShortName(n) {
    return getLocale().shortDays[n];
  }
  function getWeekDays() {
    return getLocale().days;
  }
  function getYearsInPeriod(fromDate, toDate) {
    //var start = $filter('date')(fromDate, 'yyyy');
    //var end = $filter('date')(toDate, 'yyyy');
    var start = fromDate.getFullYear();
    var end = toDate.getFullYear();
    var list = [];
    for (var y = start; y <= end; y++) {
      list.push(y);
    }
    return list;
  }
  Date.prototype.addDays = function (days) {
    var dat = new Date(this.valueOf());
    dat.setDate(dat.getDate() + days);
    return dat;
  };
  function getMonthsInPeriod(fromDate, toDate) {
    var from = new Date(fromDate);
    var to = new Date(toDate);
    var list = [];
    for (var i = 0; i < countMonthsInPeriod(from, to); i++) {
      var dateItem = new Date(from.getFullYear(), from.getMonth() + i, 1);
      list.push(dateItem);
    }
    return list;
  }
  function countMonthsInPeriod(from, to) {
    return to.getFullYear() * 12 + to.getMonth() - (from.getFullYear() * 12 + from.getMonth()) + 1;
  }
  function getDatesInPeriod(startDate, stopDate) {
    var dateArray = new Array();
    var currentDate = startDate;
    while (currentDate <= stopDate) {
      dateArray.push(new Date(currentDate));
      currentDate = currentDate.addDays(1);
    }
    return dateArray;
  }

  //Month is 0 based
  function daysNumberInMonth(year, month) {
    return new Date(year, month + 1, 0).getDate();
  }
  function getDateStringFormattedFromDate(date) {
    // from type date return a string formatted as: yyyy-MM-dd
    return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
  }

  /**
   * Converte un oggetto java Instant in una data javascript
   * @param dateAsInstant oggetto in formato {epochSecond: <sec>, nano: <nano>}
   * @returns {Date}
   */
  function fixDatesAsInstant(dateAsInstant) {
    var utcSeconds = dateAsInstant.epochSecond;
    var d = new Date(0); // The 0 there is the key, which sets the date to the epoch
    d.setUTCSeconds(utcSeconds);
    return d;
  }

  /**
   * Cerca gli oggetti java Instant tra le varie properties dell'oggetto passato e li converte in date javascript
   * @param obj
   */
  function fixObjDates(obj) {
    angular.forEach(obj, function (value, key) {
      if (value instanceof Object) {
        if (value.hasOwnProperty('epochSecond') && value.hasOwnProperty('nano')) {
          // trovata la nostra data in formato java Instant
          var d = fixDatesAsInstant(value);
          obj[key] = d;
        } else {
          fixObjDates(value);
        }
      }
    });
  }

  /**
   * Fixa le date java Instant di un array di oggetti che arriva dal backend.
   * Accetta una lista di oggetti o un oggetto singolo, e ne converte gli attributi java Instant in date javascript
   * @param objList: lista di oggetti o oggetto singolo
   */
  function fixDates(objList) {
    var list = [].concat(objList);
    angular.forEach(list, function (obj) {
      fixObjDates(obj);
    });
  }

  // END API

  // publish external API by extending sixDateLib
  function publishExternalAPI(sixDateLib) {
    angular.extend(sixDateLib, {
      'getMonthIndex': getMonthIndex,
      'getMonthShortName': getMonthShortName,
      'getMonthName': getMonthName,
      'getWeekDayIndex': getWeekDayIndex,
      'getWeekDayShortName': getWeekDayShortName,
      'getWeekDayName': getWeekDayName,
      'getYearsInPeriod': getYearsInPeriod,
      'getMonthsInPeriod': getMonthsInPeriod,
      'getDatesInPeriod': getDatesInPeriod,
      'daysNumberInMonth': daysNumberInMonth,
      'getMonths': getMonths,
      'getWeekDays': getWeekDays,
      'countMonthsInPeriod': countMonthsInPeriod,
      'getDateStringFormattedFromDate': getDateStringFormattedFromDate,
      'fixDatesAsInstant': fixDatesAsInstant,
      'fixObjDates': fixObjDates,
      'fixDates': fixDates
    });
  }
  publishExternalAPI(sixDateLib);
})(window, document);
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
(function (window, document) {
  'use strict';

  // attach sixExportLib as a property of window
  var sixExportLib = window.sixExportLib || (window.sixExportLib = {});

  // BEGIN API

  function buildColumnsFromGrid(gridApi, arrayKeyToSkip) {
    var columns = [];
    gridApi.grid.options.columnDefs.forEach(function (col) {
      var colName = col.displayName ? col.displayName : col.name ? col.name : col.field;
      if (!arrayKeyToSkip || arrayKeyToSkip.indexOf(colName) == -1) {
        columns.push({
          key: col.field,
          name: colName,
          transform: col.transform,
          t: col.exportFormat,
          format: col.exportFormatTemplate
        });
      }
    });
    return columns;
  }
  function exportXLSXVisibleRowsGrid(gridApi, filename, arrayKeyToSkip) {
    var columns = buildColumnsFromGrid(gridApi, arrayKeyToSkip);
    var filtered = gridApi.grid.rows.filter(function (o) {
      return o.visible;
    });
    var rows = filtered.map(function (r) {
      return r.entity;
    }); // Entities extracted from the GridRow array
    exportXLSX(columns, rows, filename, true);
  }
  function exportXLSXAllRowsGrid(gridApi, filename, arrayKeyToSkip, showLookupDescription) {
    var columns = buildColumnsFromGrid(gridApi, arrayKeyToSkip);
    var rows = gridApi.grid.rows.map(function (r) {
      return r.entity;
    }); // Entities extracted from the GridRow array
    exportXLSX(columns, rows, filename, showLookupDescription);
  }
  function exportXLSXRowsGrid(gridApi, promise, filename, arrayKeyToSkip) {
    var columns = buildColumnsFromGrid(gridApi, arrayKeyToSkip);
    promise.then(function (response) {
      var list;
      if (angular.isArray(response)) {
        list = response;
      }
      if (response && response.list) {
        list = response.list;
      }
      exportXLSX(columns, list, filename);
    });
  }

  /*
    Esempio columns:
    columns = [
      {key: 'instant', name: 'Data', transform: function(v) { return (v && v.epochSecond)?new Date(v.epochSecond*1000):new Date(v) }},
      {key: 'model.code', name: 'Codice'},
      {key: 'status', name: 'Stato'},
      {key: 'messages[0].text', name: 'Messaggio'}
    ];
  */

  function exportXLSX(columns, rows, filename, showLookupDescription) {
    var sheet = {};
    filename = filename || 'export';
    if (angular.isUndefined(showLookupDescription)) {
      showLookupDescription = false;
    }
    var endLoc = 'A1';
    if (columns.length) {
      var i = 0;
      columns.forEach(function (col) {
        var loc = XLSX.utils.encode_cell({
          r: 0,
          c: i
        });
        sheet[loc] = {
          v: col.name
        };
        i += 1;
        endLoc = loc;
      });
      if (rows.length) {
        rows.forEach(function (row, ri) {
          ri += 1;
          columns.forEach(function (col, ci) {
            var loc = XLSX.utils.encode_cell({
              r: ri,
              c: ci
            });
            if (angular.isDefined(Object.byString(row, col.key))) {
              var value = Object.byString(row, col.key);
              if (angular.isFunction(col.transform)) {
                value = col.transform(value);
              }
              // if value is a lookup i can't return an object in a XLSX cell -> value must be a string: code + " - " + description
              if (value && angular.isDefined(value.UUID)) {
                if (showLookupDescription) {
                  value = value.code + " - " + value.description;
                } else {
                  value = value.code;
                }
              }
              //if value is an object i want to represent it as a JSON string
              if (Object.prototype.toString.call(value) == '[object Object]') {
                value = JSON.stringify(value);
              }
              // if value is an array i can't return the classic format in a XLSX cell -> value must be a string like: "[\"string1\", \"string2\"]"
              // se è il campo commessa non va formattato come un array
              if (isExportableArray(value) && col.key != 'commission' && col.key != 'customer') {
                var newValue = "[";
                value.forEach(function (string, index) {
                  if (index == 0) {
                    newValue = newValue + "\"" + string + "\"";
                  } else {
                    newValue = newValue + "," + "\"" + string + "\"";
                  }
                });
                newValue = newValue + "]";
                value = newValue; // salvo la nuova stringa formattata nella variabile value
              }

              //excel non gestisce i timezone, in output le date si intendono in ora locale
              if (col.t == 'd' && angular.isDefined(value) && value != null) {
                value = new Date(value);
                //FIXME: se il valore non contiente un'orario, sarebbe meglio impostare l'ora alla mezzanotte?
              }

              sheet[loc] = {
                v: value || '',
                t: getXLXSType(value, col.t)
              };
              if (col.format) {
                sheet[loc].z = col.format;
              }

              //supporto hyperlink
              var linkMatches = String(col.t).match(/^link(:?)(.*)/);
              if (linkMatches && value) {
                sheet[loc].v = linkMatches[2] || value;
                XLSX.utils.cell_set_hyperlink(sheet[loc], value, sheet[loc].v);
              }
            }
            endLoc = loc;
          });
        });
      }
    }
    function getXLXSType(value, colType) {
      if (value === undefined || value === null) return 's';
      switch (_typeof(value)) {
        case 'number':
          return 'n';
        case 'boolean':
          return 'b';
        case 'object':
          if (value instanceof Date) {
            return 'd';
          }
        default:
          return colType || 's';
      }
    }
    sheet['!ref'] = XLSX.utils.encode_range({
      s: 'A1',
      e: endLoc
    });
    var workbook = {
      SheetNames: ['Sheet1'],
      Sheets: {
        Sheet1: sheet
      }
    };
    var wopts = {
      bookType: 'xlsx',
      bookSST: false,
      type: 'binary',
      cellDates: true
    };
    var wbout = XLSX.write(workbook, wopts);
    saveAs(new Blob([s2ab(wbout)], {
      type: ""
    }), filename + ".xlsx");
  }
  function exportCSVAllRowsGrid(gridApi, filename, arrayKeyToSkip, showLookupDescription) {
    var columns = buildColumnsFromGrid(gridApi, arrayKeyToSkip);
    var rows = gridApi.grid.rows.map(function (r) {
      return r.entity;
    }); // Entities extracted from the GridRow array
    exportCSV(columns, rows, filename, showLookupDescription);
  }

  /*
    Esempio columns:
    columns = [
      {key: 'instant', name: 'Data', transform: function(v) { return (v && v.epochSecond)?new Date(v.epochSecond*1000):new Date(v) }},
      {key: 'model.code', name: 'Codice'},
      {key: 'status', name: 'Stato'},
      {key: 'messages[0].text', name: 'Messaggio'}
    ];
  */
  function exportCSV(columns, rows, filename, showLookupDescription) {
    filename = filename || 'export';
    var data = [];
    if (angular.isUndefined(showLookupDescription)) {
      showLookupDescription = false;
    }
    if (columns.length && rows.length) {
      rows.forEach(function (row) {
        var current_row = {};
        columns.forEach(function (col) {
          if (angular.isDefined(Object.byString(row, col.key))) {
            var value = Object.byString(row, col.key);
            if (angular.isFunction(col.transform)) {
              value = col.transform(value);
            }
            if (value && angular.isDefined(value.UUID)) {
              if (showLookupDescription) {
                value = value.code + " - " + value.description;
              } else {
                value = value.code;
              }
            }
            if (Object.prototype.toString.call(value) == '[object Object]') {
              value = JSON.stringify(value);
            }
            if (isExportableArray(value) && col.key != 'commission' && col.key != 'customer') {
              var newValue = "[";
              value.forEach(function (string, index) {
                if (index == 0) {
                  newValue = newValue + "\"" + string + "\"";
                } else {
                  newValue = newValue + "," + "\"" + string + "\"";
                }
              });
              newValue = newValue + "]";
              value = newValue; // salvo la nuova stringa formattata nella variabile value
            }

            //csv non gestisce le date, mostro una stringa formattata ad hoc
            if (col.t == 'd' && angular.isDefined(value) && value != null) {
              value = moment(value).format("DD/MM/YYYY");
            }
            current_row[col.name] = value;
          }
        });
        data.push(current_row);
      });
    }
    var ws = XLSX.utils.json_to_sheet(data);
    var csv = XLSX.utils.sheet_to_csv(ws);
    saveAs(new Blob([s2ab(csv)], {
      type: ""
    }), filename + ".csv");
  }
  function isExportableArray(value) {
    var isExp = false;
    // evita che vengano analizzati dati che non sono array o che sono array senza elementi, oppure sono array nella forma [null]
    if (value && Array.isArray(value) && value.length > 0 && value.indexOf(null) == -1) {
      isExp = true;
    }
    return isExp;
  }
  function s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
  }
  Object.byString = function (o, s) {
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    s = s.replace(/^\./, ''); // strip a leading dot
    var a = s.split('.');
    for (var i = 0, n = a.length; i < n; ++i) {
      var k = a[i];
      if (o && k in o) {
        o = o[k];
      } else {
        return;
      }
    }
    return o;
  };

  // END API

  // publish external API by extending sixExportLib
  function publishExternalAPI(sixExportLib) {
    angular.extend(sixExportLib, {
      'exportXLSXVisibleRowsGrid': exportXLSXVisibleRowsGrid,
      'exportXLSXAllRowsGrid': exportXLSXAllRowsGrid,
      'exportXLSXRowsGrid': exportXLSXRowsGrid,
      'exportXLSX': exportXLSX,
      'exportCSVAllRowsGrid': exportCSVAllRowsGrid,
      'exportCSV': exportCSV
    });
  }
  publishExternalAPI(sixExportLib);
})(window, document);
"use strict";

/**
 * Created by Stefano Poli on 06/12/16.
 */

/**
 * Libreria per la costruzione dei filtri da passare al backend.
 * Endpoint di default su backend implementato dalla classe
 *   it.ictgroup.six.framework.index.service.AbstractIndexService
 * progetto six-elastic
 */

(function (window, document) {
  'use strict';

  // attach sixDateLib as a property of window
  var sixFiltersLib = window.sixFiltersLib || (window.sixFiltersLib = {});
  var FILTER_TYPE = {
    RANGE: '_range',
    MISSING: '_missing',
    EXISTS: '_exists',
    NOT: '_not',
    IN: '_in',
    TEXT: '_text',
    MATCH: '_match',
    EXACT: '_exact',
    REGEX: '_regex',
    BOOL: '_bool',
    NESTED: '_nested',
    SCRIPT: '_script',
    MUST: '_must',
    MUST_NOT: '_must_not',
    SHOULD: '_should'
  };
  var FILTER_REL = {
    LESS_THAN: 'lt',
    LESS_THAN_OR_EQUAL: 'lte',
    GREATER_THAN: 'gt',
    GREATER_THAN_OR_EQUAL: 'gte',
    EQUAL: 'eq'
  };
  var CONSTRAINTS = {
    AND: 'and',
    // produce una must
    OR: 'or',
    // produce una should
    ANDNOT: 'andnot',
    // produce una must_not
    FILTER: 'filter' // produce una filter
  };

  // BEGIN API

  /*
   {
     type: "_range",
     key: <attributo da cercare>,
     lt|lte:  <valore limite massimo escluso/incluso>    e/o
     gt|gte:  <valore limite minimo escluso/incluso>     oppure
     eq|equal|equals: <valore>
   }
   */

  function range(key, lt, gt, eq, includeBounds, constraint) {
    if (angular.isUndefined(includeBounds)) {
      includeBounds = false;
    }

    // oggetto filtro generico
    var obj = _buildMap(key, undefined, FILTER_TYPE.RANGE, constraint);

    // elimino l'attributo 'value' che qui non serve
    delete obj.value;

    // aggiungo attributi specifici del filtro '_range'
    if (lt) {
      var k = includeBounds ? FILTER_REL.LESS_THAN_OR_EQUAL : FILTER_REL.LESS_THAN;
      obj[k] = lt;
    }
    if (gt) {
      var k = includeBounds ? FILTER_REL.GREATER_THAN_OR_EQUAL : FILTER_REL.GREATER_THAN;
      obj[k] = gt;
    }
    if (eq) {
      obj[FILTER_REL.EQUAL] = eq;
    }
    return obj;
  }
  function rangeEq(key, eq, constraint) {
    return range(key, undefined, undefined, eq, true, constraint);
  }
  function rangeLt(key, lt, constraint) {
    return range(key, lt, undefined, undefined, false, constraint);
  }
  function rangeGt(key, gt, constraint) {
    return range(key, undefined, gt, undefined, false, constraint);
  }
  function rangeLte(key, lte, constraint) {
    return range(key, lte, undefined, undefined, true, constraint);
  }
  function rangeGte(key, gte, constraint) {
    return range(key, undefined, gte, undefined, true, constraint);
  }
  function updateRange(key, value, relation, filter, constraint) {
    if (!_checkConstant(FILTER_REL, relation)) {
      throw new Error('Invalid filter relation type ' + relation);
    } else {
      if (!filter || filter == {}) {
        switch (relation) {
          case FILTER_REL.LESS_THAN:
            filter = rangeLt(key, value, constraint);
            break;
          case FILTER_REL.LESS_THAN_OR_EQUAL:
            filter = rangeLte(key, value, constraint);
            break;
          case FILTER_REL.GREATER_THAN:
            filter = rangeGt(key, value, constraint);
            break;
          case FILTER_REL.GREATER_THAN_OR_EQUAL:
            filter = rangeGte(key, value, constraint);
            break;
          case FILTER_REL.EQUAL:
            filter = rangeEq(key, value, constraint);
            break;
          default:
            throw new Error('Invalid filter relation type ' + relation);
        }
      }
      filter[relation] = value;
      return filter;
    }
  }
  function missing(key, constraint) {
    return _buildMap(key, null, FILTER_TYPE.MISSING, constraint);
  }
  function exists(key, constraint) {
    return _buildMap(key, null, FILTER_TYPE.EXISTS, constraint);
  }
  function not(key, value, constraint) {
    return _buildMap(key, value, FILTER_TYPE.NOT, constraint);
  }
  function _in(key, value, constraint) {
    return _buildMap(key, value, FILTER_TYPE.IN, constraint);
  }
  function text(key, value, constraint) {
    return _buildMap(key, value, FILTER_TYPE.TEXT, constraint);
  }
  function match(key, value, constraint, options) {
    return _buildMap(key, value, FILTER_TYPE.MATCH, constraint, options);
  }
  function exact(key, value, constraint) {
    return _buildMap(key, value, FILTER_TYPE.EXACT, constraint);
  }
  function regex(key, value, constraint) {
    return _buildMap(key, value, FILTER_TYPE.REGEX, constraint);
  }
  function bool(key, value, constraint) {
    return _buildMap(key, value, FILTER_TYPE.BOOL, constraint);
  }
  function nested(key, value, constraint) {
    return _buildMap(key, value, FILTER_TYPE.NESTED, constraint);
  }
  function script(key, value) {
    return _buildMap(key, value, FILTER_TYPE.SCRIPT);
  }
  function must(value, constraint) {
    return _buildMap("must", value, FILTER_TYPE.MUST, constraint);
  }
  function mustNot(value, constraint) {
    return _buildMap("must_not", value, FILTER_TYPE.MUST_NOT, constraint);
  }
  function should(value, constraint) {
    return _buildMap("should", value, FILTER_TYPE.SHOULD, constraint);
  }

  // utils
  /*
   {
     type: ["_range"|"_missing"|"_exists"|"_not"|"_in"|"_text"|"_match"|"_exact"|"regex"|"_bool"|"_boolean"|"_nested"|"_script"|"_must"|"_must_not"|"_should"]
     key: <attributo da cercare>,
     value: <valore da cercare>,      tranne per "_missing", "_exists"
     contraint: <or|and|andnot>
   }
   */

  function _buildMap(key, value, type, constraint, options) {
    constraint = constraint || CONSTRAINTS.AND;
    if (!_checkConstant(CONSTRAINTS, constraint)) {
      throw new Error('Invalid filter constraint type ' + constraint);
    }
    if (!_checkConstant(FILTER_TYPE, type)) {
      throw new Error('Invalid filter type ' + type);
    }
    var map = {
      type: type,
      key: key,
      value: value,
      constraint: constraint
    };
    map = Object.assign(map, options);
    return map;
  }
  function _checkConstant(constantsObj, value) {
    for (var key in constantsObj) {
      if (constantsObj[key] === value) {
        return true;
      }
    }
    return false;
  }

  // END API

  // publish external API by extending sixDateLib
  function publishExternalAPI(sixFiltersLib) {
    angular.extend(sixFiltersLib, {
      'FILTER_REL': FILTER_REL,
      'CONSTRAINTS': CONSTRAINTS,
      'range': range,
      'updateRange': updateRange,
      'rangeEq': rangeEq,
      'rangeLt': rangeLt,
      'rangeLte': rangeLte,
      'rangeGt': rangeGt,
      'rangeGte': rangeGte,
      'missing': missing,
      'exists': exists,
      'not': not,
      'in': _in,
      'text': text,
      'match': match,
      'exact': exact,
      'regex': regex,
      'bool': bool,
      'nested': nested,
      'script': script,
      'must': must,
      'mustNot': mustNot,
      'should': should
    });
  }
  publishExternalAPI(sixFiltersLib);
})(window, document);
"use strict";

(function (window) {
  'use strict';

  // attach sixMatrixLib as a property of window
  var sixMatrixLib = window.sixMatrixLib || (window.sixMatrixLib = {});

  // BEGIN API
  function getTimes(n) {
    var list = [];
    for (var i = 0; i < n; i++) {
      list.push(i);
    }
    return list;
  }

  /** Function di utility; usare getInitializedMatrix() **/
  // initValue, matrix, [... dimensions]
  function recursiveInitMatrix() {
    var initValue = arguments[0];
    var matrix = arguments[1];
    if (arguments.length === 2) {
      matrix = initValue;
      return matrix;
    }

    // Recupero la dimensione da scorrere
    var dim = arguments[2];
    if (!Array.isArray(dim)) {
      dim = getTimes(dim);
    }
    if (arguments.length === 3) {
      dim.forEach(function (item) {
        matrix[item] = angular.copy(initValue);
      });
      return matrix;
    }
    var otherDims = [].slice.call(arguments, 3);
    dim.forEach(function (item) {
      matrix[item] = [];
      var args = [initValue, matrix[item]].concat(otherDims);
      matrix[item] = recursiveInitMatrix.apply(null, args);
    });
    return matrix;
  }

  /*
   * Inizializza una matrice n dimensionale.
   * Da richiamare con i parametri:
   * - initValue: valore di inizializzazione
   * - dim1: dimensione di riga
   * - dim2: dimensione di colonna
   * - dim3: 3° dimensione
   * - dim4: 4° dimensione
   * - ...
   *
   * le dimensioni 'dim' possono essere array contenenti i valori delle chiavi di dimensione, oppure numeri che indicano la dimensione.
   * Casi d'uso:
   *
   * - var matrix = getInitializedMatrix(0, 10, 10, 5) => matrix è una matrice 3-dimensionale (10x10x5) le cui celle sono inizializzate con il valore 0
   * - var matrix = getInitializedMatrix(8, [5, 8], 3) => matrix è una matrice 2-dimensionale (2x3) le cui celle sono inizializzate con il valore 8;
   *   la matrice risultante è la seguente:
   *
   *      [0]  [1]  [2]  <- chiavi di colonna
   *   [5] 8    8    8
   *   [8] 8    8    8
   *    ^
   *    |
   * chiavi di riga
   */
  /**
   * @param {Object} [initValue]
   * @param {...Array.<T> | number} [dim]
   * @return {Array.<T>}
   **/
  function getInitializedMatrix() {
    var args = [arguments[0], []];
    for (var i = 1; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    return recursiveInitMatrix.apply(null, args);
  }
  // END API

  // publish external API by extending sixMatrixLib
  function publishExternalAPI(sixMatrixLib) {
    angular.extend(sixMatrixLib, {
      'getInitializedMatrix': getInitializedMatrix
    });
  }
  publishExternalAPI(sixMatrixLib);
})(window, document);
"use strict";

(function (window) {
  'use strict';

  // attach sixObjectLib as a property of window
  var sixObjectLib = window.sixObjectLib || (window.sixObjectLib = {});

  // BEGIN API

  /*
  * Converte un oggetto flat in oggetti innestati. Ad esempio:
  * flat = {
  *   code;
  *   model.code;
  *   model.type;
  *   model.status;
  * }
  *
  * nested = {
  *   code;
  *   model = {
  *     code;
  *     type;
  *     status;
  *   }
  * }
  */
  var flatToNested = function flatToNested(flat, nested) {
    if (!nested) {
      nested = {};
    }
    for (var key in flat) {
      var splittedKey = key.split('.');
      if (splittedKey.length > 1) {
        var tmp = {};
        tmp[key.substr(key.indexOf('.') + 1)] = flat[key];
        nested[splittedKey[0]] = flatToNested(tmp, nested[splittedKey[0]]);
      } else {
        nested[key] = flat[key];
      }
    }
    return nested;
  };

  /**
   * Converte un record nella sua rappresentazione "lookup"/"riferimento"
   * Può opzionalmente contere un customCode
   *
   * Es:
   * "zonatermica_id": {
       "type": "zonatermica",
       "code": "ancona",
       "description": "Ancona",
       "UUID": "ancona"
    }
   */

  var recordToHisRef = function recordToHisRef(obj) {
    if (angular.isUndefined(obj) || obj === null) {
      return null;
    }
    var ref = {};
    if (obj.hasOwnProperty('UUID') && obj.model && obj.model.hasOwnProperty('code') && obj.hasOwnProperty('schemaCode')) {
      ref.type = obj.schemaCode;
      ref.UUID = obj.UUID;
      ref.code = obj.model.code;
      ref.description = obj.model.description;
      if (obj.model.customCode) {
        ref.customCode = obj.model.customCode;
      }
    } else {
      console.log('recordToHisRef: WRONG FORMAT. One or more fields missing ', obj);
      return null;
    }
    return ref;
  };

  /**
   * Controlla se un oggetto è vuoto. Un oggetto obj è vuoto se:
   * - obj === null
   * - obj === undefined
   * - obj === {}
   * - obj === []
   * @param obj
   * @returns {boolean}
   */
  var isEmpty = function isEmpty(obj) {
    if (angular.isUndefined(obj) || obj === null || obj === {} || obj === []) {
      return true;
    }
    for (var k in obj) {
      if (obj.hasOwnProperty(k)) {
        return false;
      }
    }
    return true;
  };

  /**
   * Restituisce un array che rappresenta la differenza tra due array.
   * Es: diffArray([1, 2, 3, 4, 5, 6, 7], [3, 2, 1, 4, 5]);    // return [6, 7]
   * @param arr1
   * @param arr2
   */
  function diffArray(arr1, arr2) {
    return arr1.concat(arr2).filter(function (val) {
      if (arr1.includes(val) && !arr2.includes(val)) return val;
    });
  }

  /**
   * Restituisce un array che rappresenta la differenza simmetrica tra due array.
   * Es: symmetricDiffArray([1, 2, 3, 7], [3, 2, 1, 4, 5]);    // return [7, 4, 5]
   * @param arr1
   * @param arr2
   */
  function symmetricDiffArray(arr1, arr2) {
    return arr1.concat(arr2).filter(function (val) {
      if (!(arr1.includes(val) && arr2.includes(val))) return val;
    });
  }

  /**
   * Restituisce un array che rappresenta l'intersezione tra due array.
   * Es: intersectArray([1, 2, 3, 7], [6, 4, 5]);    // return [1, 2, 3, 7, 6, 4, 5]
   * @param arr1
   * @param arr2
   */
  function intersectArray(arr1, arr2) {
    return arr1.concat(arr2).filter(function (val) {
      if (arr1.includes(val) && arr2.includes(val)) return val;
    });
  }

  /**
   * Restituisce un ID generato con lettere, cifre e caratteri speciali (-_) casuali
   * @param allowDigits: abilita le cifre
   * @param allowBars: abilita i caratteri - e _
   * @returns {string}
   */
  function makeId(allowDigits, allowBars) {
    var text = '';
    allowDigits = angular.isDefined(allowDigits) ? allowDigits : true;
    allowBars = angular.isDefined(allowBars) ? allowBars : true;
    var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    if (allowDigits) {
      possible += '0123456789';
    }
    if (allowBars) {
      possible += '-_';
    }
    for (var i = 0; i < 10; i++) text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
  }

  /**
   * Restituisce un GUID autogenerato
   * @returns {string}
   */
  function makeGUID() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  }
  function clearObject(obj) {
    for (var key in obj) {
      delete obj[key];
    }
    return obj;
  }

  // END API

  // publish external API by extending sixObjectLib
  function publishExternalAPI(sixObjectLib) {
    angular.extend(sixObjectLib, {
      'flatToNested': flatToNested,
      'recordToHisRef': recordToHisRef,
      'isEmpty': isEmpty,
      'diffArray': diffArray,
      'symmetricDiffArray': symmetricDiffArray,
      'intersectArray': intersectArray,
      'makeId': makeId,
      'makeGUID': makeGUID,
      'clearObject': clearObject
    });
  }
  publishExternalAPI(sixObjectLib);
})(window, document);
"use strict";

(function (window) {
  'use strict';

  // attach sixServiceMessageLib as a property of window
  var sixServiceMessageLib = window.sixServiceMessageLib || (window.sixServiceMessageLib = {});

  // BEGIN API

  var emulateLogServiceMessage = function emulateLogServiceMessage(msg, success, warning, error, code) {
    var status = success ? 'SUCCESS' : warning ? 'WARNING' : 'ERROR';
    var message = {
      status: status,
      code: code,
      message: msg,
      success: success,
      warning: warning,
      error: error
    };
    return message;
  };
  var emulateServiceResponse = function emulateServiceResponse(messages) {
    var response = {
      messages: [],
      errors: false,
      warnings: false
    };
    messages.forEach(function (msg) {
      response.messages.push(msg);
      if (msg.error) {
        response.errors = true;
      }
      if (msg.warning) {
        response.warnings = true;
      }
    });
    return response;
  };

  // END API

  // publish external API by extending sixObjectLib
  function publishExternalAPI(sixServiceMessageLib) {
    angular.extend(sixServiceMessageLib, {
      'emulateLogServiceMessage': emulateLogServiceMessage,
      'emulateServiceResponse': emulateServiceResponse
    });
  }
  publishExternalAPI(sixServiceMessageLib);
})(window, document);
"use strict";

(function (window, document) {
  'use strict';

  // attach sixStringLib as a property of window
  var sixStringLib = window.sixStringLib || (window.sixStringLib = {});

  // BEGIN API

  /*
   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at
    http://www.apache.org/licenses/LICENSE-2.0
    Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
   */
  var defaultDiacriticsRemovalap = [{
    'base': 'A',
    'letters': "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
  }, {
    'base': 'AA',
    'letters': "\uA732"
  }, {
    'base': 'AE',
    'letters': "\xC6\u01FC\u01E2"
  }, {
    'base': 'AO',
    'letters': "\uA734"
  }, {
    'base': 'AU',
    'letters': "\uA736"
  }, {
    'base': 'AV',
    'letters': "\uA738\uA73A"
  }, {
    'base': 'AY',
    'letters': "\uA73C"
  }, {
    'base': 'B',
    'letters': "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
  }, {
    'base': 'C',
    'letters': "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
  }, {
    'base': 'D',
    'letters': "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
  }, {
    'base': 'DZ',
    'letters': "\u01F1\u01C4"
  }, {
    'base': 'Dz',
    'letters': "\u01F2\u01C5"
  }, {
    'base': 'E',
    'letters': "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
  }, {
    'base': 'F',
    'letters': "F\u24BB\uFF26\u1E1E\u0191\uA77B"
  }, {
    'base': 'G',
    'letters': "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
  }, {
    'base': 'H',
    'letters': "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
  }, {
    'base': 'I',
    'letters': "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
  }, {
    'base': 'J',
    'letters': "J\u24BF\uFF2A\u0134\u0248"
  }, {
    'base': 'K',
    'letters': "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
  }, {
    'base': 'L',
    'letters': "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
  }, {
    'base': 'LJ',
    'letters': "\u01C7"
  }, {
    'base': 'Lj',
    'letters': "\u01C8"
  }, {
    'base': 'M',
    'letters': "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
  }, {
    'base': 'N',
    'letters': "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
  }, {
    'base': 'NJ',
    'letters': "\u01CA"
  }, {
    'base': 'Nj',
    'letters': "\u01CB"
  }, {
    'base': 'O',
    'letters': "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
  }, {
    'base': 'OI',
    'letters': "\u01A2"
  }, {
    'base': 'OO',
    'letters': "\uA74E"
  }, {
    'base': 'OU',
    'letters': "\u0222"
  }, {
    'base': 'OE',
    'letters': "\x8C\u0152"
  }, {
    'base': 'oe',
    'letters': "\x9C\u0153"
  }, {
    'base': 'P',
    'letters': "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
  }, {
    'base': 'Q',
    'letters': "Q\u24C6\uFF31\uA756\uA758\u024A"
  }, {
    'base': 'R',
    'letters': "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
  }, {
    'base': 'S',
    'letters': "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
  }, {
    'base': 'T',
    'letters': "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
  }, {
    'base': 'TZ',
    'letters': "\uA728"
  }, {
    'base': 'U',
    'letters': "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
  }, {
    'base': 'V',
    'letters': "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
  }, {
    'base': 'VY',
    'letters': "\uA760"
  }, {
    'base': 'W',
    'letters': "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
  }, {
    'base': 'X',
    'letters': "X\u24CD\uFF38\u1E8A\u1E8C"
  }, {
    'base': 'Y',
    'letters': "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
  }, {
    'base': 'Z',
    'letters': "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
  }, {
    'base': 'a',
    'letters': "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
  }, {
    'base': 'aa',
    'letters': "\uA733"
  }, {
    'base': 'ae',
    'letters': "\xE6\u01FD\u01E3"
  }, {
    'base': 'ao',
    'letters': "\uA735"
  }, {
    'base': 'au',
    'letters': "\uA737"
  }, {
    'base': 'av',
    'letters': "\uA739\uA73B"
  }, {
    'base': 'ay',
    'letters': "\uA73D"
  }, {
    'base': 'b',
    'letters': "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
  }, {
    'base': 'c',
    'letters': "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
  }, {
    'base': 'd',
    'letters': "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
  }, {
    'base': 'dz',
    'letters': "\u01F3\u01C6"
  }, {
    'base': 'e',
    'letters': "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
  }, {
    'base': 'f',
    'letters': "f\u24D5\uFF46\u1E1F\u0192\uA77C"
  }, {
    'base': 'g',
    'letters': "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
  }, {
    'base': 'h',
    'letters': "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
  }, {
    'base': 'hv',
    'letters': "\u0195"
  }, {
    'base': 'i',
    'letters': "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
  }, {
    'base': 'j',
    'letters': "j\u24D9\uFF4A\u0135\u01F0\u0249"
  }, {
    'base': 'k',
    'letters': "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
  }, {
    'base': 'l',
    'letters': "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
  }, {
    'base': 'lj',
    'letters': "\u01C9"
  }, {
    'base': 'm',
    'letters': "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
  }, {
    'base': 'n',
    'letters': "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
  }, {
    'base': 'nj',
    'letters': "\u01CC"
  }, {
    'base': 'o',
    'letters': "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
  }, {
    'base': 'oi',
    'letters': "\u01A3"
  }, {
    'base': 'ou',
    'letters': "\u0223"
  }, {
    'base': 'oo',
    'letters': "\uA74F"
  }, {
    'base': 'p',
    'letters': "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
  }, {
    'base': 'q',
    'letters': "q\u24E0\uFF51\u024B\uA757\uA759"
  }, {
    'base': 'r',
    'letters': "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
  }, {
    'base': 's',
    'letters': "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
  }, {
    'base': 't',
    'letters': "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
  }, {
    'base': 'tz',
    'letters': "\uA729"
  }, {
    'base': 'u',
    'letters': "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
  }, {
    'base': 'v',
    'letters': "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
  }, {
    'base': 'vy',
    'letters': "\uA761"
  }, {
    'base': 'w',
    'letters': "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
  }, {
    'base': 'x',
    'letters': "x\u24E7\uFF58\u1E8B\u1E8D"
  }, {
    'base': 'y',
    'letters': "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
  }, {
    'base': 'z',
    'letters': "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
  }];
  var diacriticsMap = {};
  for (var i = 0; i < defaultDiacriticsRemovalap.length; i++) {
    var letters = defaultDiacriticsRemovalap[i].letters;
    for (var j = 0; j < letters.length; j++) {
      diacriticsMap[letters[j]] = defaultDiacriticsRemovalap[i].base;
    }
  }

  // "what?" version ... http://jsperf.com/diacritics/12
  function removeDiacritics(str) {
    return str.replace(/[^\u0000-\u007E]/g, function (a) {
      return diacriticsMap[a] || a;
    });
  }

  // END API

  // publish external API by extending sixDateLib
  function publishExternalAPI(sixStringLib) {
    angular.extend(sixStringLib, {
      'removeDiacritics': removeDiacritics
    });
  }
  publishExternalAPI(sixStringLib);
})(window, document);
'use strict';

angular.module('emma.theme').controller('sixBulkEditorCtrl', ["$scope", "$log", "$q", "toaster", function ($scope, $log, $q, toaster) {
  var ctrl = this;
  var formSubItemkeys = ["items", "tabs"]; //indicano le chiavi del form che potrebbero contenere sottoelementi e vanno esplorate

  ctrl.schema = {
    compact: null,
    full: null
  };
  ctrl.form = {
    compact: [],
    full: []
  };
  ctrl.filteredForm = {
    compact: [],
    full: []
  };
  ctrl.edits = {
    compact: {},
    full: {}
  };
  ctrl.fieldsList = []; //ogni field ha i campi: key, title, active

  ctrl.mergeMode = "replace";
  ctrl.availableMergers = {
    "replace": "Sostituisci",
    "replaceIfSet": "Sostituisci se impostato",
    "insert": "Inserisci se vuoto",
    "append": "Accoda/Unisci il dato",
    "appendIfSet": "Accoda/Unisci se impostato",
    "deltaVariation": "Variazione fissa (soli campi numerici)",
    "percentVariation": "Variazione percentuale (soli campi numerici)"
  };
  function applyEdits(edits, fullItem, mergeMode) {
    if (Object.keys(edits).length) {
      try {
        for (var k in edits) {
          var sourceValue = getField(fullItem, k);
          var editedValue = edits[k];
          //merge
          var result = ctrl[mergeMode + "Merger"](sourceValue, editedValue);
          setField(fullItem, k, result);
        }
      } catch (err) {
        $log.error(edits, fullItem, mergeMode, err.message);
        throw Error("Impossibile modificare il dato: " + err.message);
      }
    }
  }
  ctrl.replaceMerger = function (source, edit) {
    return edit;
  };
  ctrl.replaceIfSetMerger = function (source, edit) {
    if (typeof source != "undefined" && source != null) {
      return ctrl.replaceMerger(source, edit);
    } else {
      return source;
    }
  };
  ctrl.insertMerger = function (source, edit) {
    if (typeof source == "undefined" || source == null) {
      return ctrl.replaceMerger(source, edit);
    } else {
      return source;
    }
  };
  ctrl.appendMerger = function (source, edit) {
    // concat per stringhe e array, merge per oggetti
    if (source === null || typeof source == "undefined" || typeof source == "boolean" || typeof source == "number") {
      //per determinati dati il concat non ha senso
      return edit;
    } else if (Array.isArray(source) || typeof source == "string") {
      return source.concat(edit);
    } else {
      return Object.assign(source, edit);
    }
  };
  ctrl.appendIfSetMerger = function (source, edit) {
    if (typeof source != "undefined" && source != null) {
      return ctrl.appendMerger(source, edit);
    } else {
      return source;
    }
  };
  ctrl.deltaVariationMerger = function (source, edit) {
    var decimals = 4;
    var opResult = parseFloat(source) + parseFloat(edit);
    var result = Number(Math.round(opResult + 'e' + decimals) + 'e-' + decimals);
    if (isNaN(result)) {
      throw Error("Il risultato della variazione non è valido. Valore originale: " + source + " Modifica: " + edit);
    }
    return result;
  };
  ctrl.percentVariationMerger = function (source, edit) {
    var decimals = 4;
    var opResult = parseFloat(source) + parseFloat(source) * (parseFloat(edit) / 100);
    var result = Number(Math.round(opResult + 'e' + decimals) + 'e-' + decimals);
    if (isNaN(result)) {
      throw Error("Il risultato della variazione non è valido. Valore originale: " + source + " Modifica: " + edit);
    }
    return result;
  };
  function applyCallbacks(callbacks, fullItem, sourceItem) {
    if (callbacks != null && Object.keys(callbacks).length) {
      for (var k in callbacks) {
        var callable = getField(callbacks, k);
        if (typeof callable == "function") {
          //eseguo la callback e aggiorno il dato
          fullItem = callable(getField(fullItem, k), fullItem, getField(sourceItem, k), sourceItem);
        }
      }
    }
  }
  function getField(obj, key) {
    //accetta anche key del tipo model.record_id.type
    var subObj = obj;
    var keyPieces = key.split('.');
    var len = keyPieces.length;
    for (var i = 0; i < len - 1; i++) {
      var elem = keyPieces[i];
      if (!subObj[elem]) subObj[elem] = {};
      subObj = subObj[elem];
    }
    return subObj[keyPieces[len - 1]];
  }
  function setField(obj, key, value) {
    var subObj = obj;
    var keyPieces = key.split('.');
    var len = keyPieces.length;
    for (var i = 0; i < len - 1; i++) {
      var elem = keyPieces[i];
      if (!subObj[elem]) subObj[elem] = {};
      subObj = subObj[elem];
    }
    subObj[keyPieces[len - 1]] = value;
  }
  ctrl.cancelEdit = function () {
    if (angular.isDefined(ctrl.sxCancel) && typeof ctrl.sxCancel == "function") {
      ctrl.sxCancel();
    }
  };
  ctrl.saveAll = function () {
    //recupero i dati
    var dataRows = ctrl.sxDataGetter({
      searchDate: ctrl.selectedDate()
    });
    $q.resolve(dataRows).then(function (results) {
      dataRows = angular.copy(results);
      if (dataRows.length) {
        var edits = {};
        ctrl.fieldsList.forEach(function (field) {
          if (field.active) {
            var prefixedKey = (field.prefix ? field.prefix + "." : "") + field.key;
            edits[prefixedKey] = null;
            if (ctrl.edits.compact[field.key]) {
              edits[prefixedKey] = ctrl.edits.compact[field.key];
            }
            if (ctrl.edits.full[field.key]) {
              edits[prefixedKey] = ctrl.edits.full[field.key];
            }
          }
        });
        if (Object.keys(edits).length) {
          try {
            dataRows.forEach(function (dataItem, row) {
              var sourceItem = angular.copy(dataItem);
              dataItem.dataIn = ctrl.selectedDate();
              //applico le modifiche al dato
              applyEdits(edits, dataItem, ctrl.mergeMode);
              //chiamo le callback
              applyCallbacks(ctrl.sxCallbacks, dataItem, sourceItem);
            });
          } catch (err) {
            toaster.pop('error', 'Errore', err.message);
            return;
          }
          var saveResult = ctrl.sxSave({
            searchDate: ctrl.selectedDate(),
            payload: dataRows
          });
          $q.resolve(saveResult).then(function (resultData) {
            toaster.pop('success', 'Operazione completata', 'Aggiornamento effettuato.');
            if (angular.isDefined(ctrl.sxPostSave)) {
              ctrl.sxPostSave({
                result: resultData
              });
            }
          });
        } else {
          toaster.pop('error', 'Errore', 'Nessun campo modificato.');
        }
      } else {
        toaster.pop('error', 'Errore', 'Nessun dato da salvare.');
      }
    });
  };
  ctrl.toggleFields = function () {
    ctrl.toggledFields = !ctrl.toggledFields;
    for (var f in ctrl.fieldsList) {
      ctrl.fieldsList[f].active = ctrl.toggledFields;
    }
  };
  ctrl.fieldsActiveCount = function () {
    return ctrl.fieldsList.reduce(function (count, obj) {
      return count + obj.active;
    }, 0);
  };
  ctrl.insertDate = new Date();
  ctrl.dateEnabled = function () {
    if (angular.isDefined(ctrl.sxDateEnabled) && ctrl.sxDateEnabled == true) {
      return true;
    }
    return false;
  };
  ctrl.selectedDate = function () {
    if (ctrl.dateEnabled()) {
      return ctrl.insertDate;
    }
    return new Date();
  };
  function buildFieldsList() {
    ctrl.fieldsList = [].concat(buildFieldsListFor(ctrl.schema.compact, ctrl.form.compact, ctrl.sxCompactSchemaPrefix), buildFieldsListFor(ctrl.schema.full, ctrl.form.full, ctrl.sxSchemaFormPrefix));
  }
  function buildFieldsListFor(schema, form, prefix) {
    var fieldsList = [];
    if (schema) {
      var props = schema.properties;
      for (var key in props) {
        if (formCanEdit(form, key)) {
          fieldsList.push({
            'key': key,
            'title': props[key].title,
            'active': false,
            'type': props[key].type,
            'enabled': true,
            'prefix': prefix
          });
        }
      }
    }
    return fieldsList;
  }
  function formCanEdit(form, keyToSearch) {
    //ricerca ricorsiva di key dentro form
    var found = false;
    form.forEach(function (row, i) {
      if (!found) {
        if (row.hasOwnProperty("key")) {
          if (Array.isArray(row.key) && row.key.indexOf(keyToSearch) != -1 || typeof row.key == "string" && row.key == keyToSearch) {
            //ho trovato la key
            found = true;
            return;
          }
        }
        //esploro i subItem
        formSubItemkeys.forEach(function (prop) {
          if (row.hasOwnProperty(prop)) {
            found = formCanEdit(row[prop], keyToSearch);
          }
        });
      }
    });
    return found;
  }
  function buildFilteredForm() {
    var keyBlacklist = ctrl.fieldsList.filter(function (obj) {
      return obj.active != true;
    }).map(function (obj) {
      return obj.key;
    });
    ctrl.filteredForm.compact = filterFormSubItems(ctrl.form.compact, keyBlacklist);
    ctrl.filteredForm.full = filterFormSubItems(ctrl.form.full, keyBlacklist);
  }
  function filterFormSubItems(items, keyBlacklist) {
    var filtered = [];
    var hasEditableFields = false;
    items.forEach(function (rowSource, i) {
      var row = angular.copy(rowSource);
      if (row.hasOwnProperty("key")) {
        if (Array.isArray(row.key) && keyBlacklist.indexOf(row.key[0]) != -1 || typeof row.key == "string" && keyBlacklist.indexOf(row.key) != -1) {
          //se l'item ha una key in blacklist lo salto
          return;
        } else {
          hasEditableFields = true;
        }
      }
      //esploro i subItem
      formSubItemkeys.forEach(function (prop) {
        if (row.hasOwnProperty(prop)) {
          row[prop] = filterFormSubItems(row[prop], keyBlacklist);
          if (row[prop].length) hasEditableFields = true;
        }
      });
      filtered.push(row);
    });
    if (hasEditableFields) {
      return filtered;
    } else {
      return [];
    }
  }
  $scope.$watch('$ctrl.fieldsList', function (newVal, oldVal) {
    if (newVal != oldVal || ctrl.filteredForm.compact.length == 0 && ctrl.filteredForm.full.length == 0) {
      buildFilteredForm();
      $scope.$broadcast('schemaFormRedraw');
    }
  }, true);
  $scope.$watch('$ctrl.mergeMode', function (newVal, oldVal) {
    if (newVal != oldVal) {
      if (ctrl.mergeMode == "deltaVariation" || ctrl.mergeMode == "percentVariation") {
        //per alcuni mergeMode sono validi solo i campi numerici
        ctrl.fieldsList.forEach(function (item) {
          item.enabled = item.type == 'number';
          item.active = item.active && item.enabled;
        });
      } else {
        ctrl.fieldsList.forEach(function (item) {
          item.enabled = true;
        });
      }
      $scope.$broadcast('schemaFormRedraw');
    }
  }, true);
  ctrl.$onChanges = function (changes) {
    //se ho schema form, lo setto diretto 
    if (changes.sxSchemaForm && changes.sxSchemaForm.currentValue && changes.sxSchemaForm.currentValue.schema && changes.sxSchemaForm.currentValue.form) {
      ctrl.schema.full = changes.sxSchemaForm.currentValue.schema;
      ctrl.form.full = changes.sxSchemaForm.currentValue.form;
      buildFieldsList();
    }
    if (changes.sxCompactSchema && changes.sxCompactSchema.currentValue) {
      //prendo le sxCompactSchema per comporre schema e form
      var hidrated = hidrateCompactSchema(changes.sxCompactSchema.currentValue);
      ctrl.schema.compact = hidrated.schema;
      ctrl.form.compact = hidrated.form;
      buildFieldsList();
    }
  };
  function hidrateCompactSchema(compactSchema) {
    /*
    Una riga del compactSchema è così composta:
    "key": { "title": xxxx, "subKey": yyyy, .... }
    Dove:
        key: è la chiave del dato, es: "model.description"
        title: il nome leggibile del dato
        subKey: tutte le restanti chiavi aggiuntive per configurare le schemaProperties
                nel caso inizino col prefisso "form_" verranno usate per configurare il form (e omesse dalle schemaProperties)
    */
    var schemaProp = {};
    var form = [];
    for (var key in compactSchema) {
      var element = angular.copy(compactSchema[key]);
      var formItem = {
        //dato base minimo per il form
        "title": element.title,
        "type": "text",
        "key": [key]
      };
      for (var subKey in element) {
        if (subKey.indexOf("form_") === 0) {
          formItem[subKey.replace(/^form_/, "")] = element[subKey];
          delete element[subKey];
        }
      }
      form.push(formItem);
      var schemaItem = element;
      schemaItem.type = element.type || "string";
      schemaProp[key] = schemaItem;
    }
    ;
    var schema = {
      "type": "object",
      "title": "",
      "properties": schemaProp
    };
    return {
      "schema": schema,
      "form": form
    };
  }
}]);

/**
 * @ngdoc component
 * @name emma.theme.directive:sixBulkEditor
 * @description
 * # sixBulkEditor
 */
angular.module('emma.theme').component('sixBulkEditor', {
  controller: 'sixBulkEditorCtrl',
  templateUrl: 'theme/components/templates/sixbulkeditor.html',
  restrict: 'E',
  bindings: {
    sxDataGetter: '&',
    //getter per la lista di dati completi da modificare
    sxSave: '&',
    //deve essere un metodo che accetti "payload" contenente la lista di documenti modificati e restituisca una promise
    sxCompactSchema: '<?',
    //formato custom (di base le sole properties dello schema) il componente poi le "idrata"
    sxSchemaForm: '<?',
    //full schema form
    sxCallbacks: '<?',
    //oggetto: le chiavi indicano per quali dati operano, il valore deve essere una funzione che verrà eseguita prima del salvataggio
    //la funzione riceverà come parametri il nuovo valore del dato e l'intero oggetto, deve restituire l'intero oggetto modificato
    sxPostSave: '&?',
    sxCancel: '&?',
    sxCompactSchemaPrefix: '@?',
    //Prefix: se indicati lo schemaform deve riferirsi alla chiave indicata (es: model per i record generici)
    sxSchemaFormPrefix: '@?',
    //le modifiche saranno applicate solo alla chiave indicata
    sxDateEnabled: '<?',
    //abilita o meno il selettore per la data
    sxDateOptions: '<?'
  }
});
'use strict';

angular.module('emma.theme').controller('sixDatePickerCtrl', ["$scope", "$log", function ($scope, $log) {
  this.status = {
    opened: false
  };
  if (angular.isUndefined(this.sxDisabled)) {
    this.sxDisabled = false;
    $log.log('Default sxDisabled: ' + this.sxDisabled);
  }
  if (angular.isUndefined(this.sxRequired)) {
    this.sxRequired = false;
  }
  this.format = this.format || 'dd/MM/yyyy';
  this.dateOptions = this.dateOptions || {};
  if (angular.isUndefined(this.dateOptions.formatYear)) {
    this.dateOptions.formatYear = 'yyyy';
  }
  if (angular.isUndefined(this.dateOptions.startingDay)) {
    this.dateOptions.startingDay = 1;
  }
  this.open = function ($event) {
    this.status.opened = true;
  };
  function isEmpty() {
    var model = this.ngModel;
    return model == null || model == undefined;
  }
  $scope.$on('SchemaFormValidate', function () {
    if (this.sxRequired && isEmpty()) {
      this.ngInvalid = true;
      this.ngValid = false;
    } else if (this.sxRequired && isEmpty()) {
      this.ngInvalid = false;
      this.ngValid = true;
    }
  });
}]);

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixDatePicker
 * @description
 * # sixDatePicker
 */
angular.module('emma.theme').component('sixDatePicker', {
  transclude: true,
  controller: 'sixDatePickerCtrl',
  templateUrl: 'theme/components/templates/sixdatepicker.html',
  restrict: 'E',
  bindings: {
    ngModel: '=',
    name: '@',
    dateOptions: '=?',
    format: '=?',
    sxDisabled: '=?',
    sxRequired: '=?'
  }
});
'use strict';

angular.module('emma.theme').controller('sixDateTimePickerCtrl', ["$scope", "$log", function ($scope, $log) {
  var ctrl = this;
  this.isOpen = false;
  this.dateOptions = this.dateOptions || {};
  this.timePickerOptions = this.timePickerOptions || {
    showMeridian: false
  };
  if (angular.isUndefined(this.sxDisabled)) {
    this.sxDisabled = false;
  }
  if (angular.isUndefined(this.enableDate)) {
    this.enableDate = true;
  }
  if (angular.isUndefined(this.enableTime)) {
    this.enableTime = true;
  }
  if (angular.isUndefined(this.sxRequired)) {
    this.sxRequired = false;
  }
  if (angular.isUndefined(this.format)) {
    this.format = '';
    var sep = '';
    if (this.enableDate) {
      this.format += sep + 'dd/MM/yyyy';
      sep = ' ';
    }
    if (this.enableTime) {
      this.format += sep + 'HH:mm';
    }
  }
  this.buttonBar = {
    show: true,
    now: {
      show: true,
      text: 'Adesso',
      cls: 'btn-sm btn-bg btn-info'
    },
    today: {
      show: true,
      text: 'Oggi',
      cls: 'btn-sm btn-bg btn-info'
    },
    clear: {
      show: true,
      text: 'Cancella',
      cls: 'btn-sm btn-bg btn-danger'
    },
    date: {
      show: true,
      text: 'Data',
      cls: 'btn-sm btn-default'
    },
    time: {
      show: true,
      text: 'Ora',
      cls: 'btn-sm btn-default'
    },
    cancel: {
      show: true,
      text: 'Annulla',
      cls: 'btn-sm btn-default'
    },
    close: {
      show: true,
      text: 'Chiudi',
      cls: 'btn-sm btn-default'
    }
  };
  this.openCalendar = function (e) {
    if (ctrl.sxForm && ctrl.sxForm[$scope.sxId]) {
      ctrl.sxForm[ctrl.sxId].$pristine = false; // forzo il pristine per indicare che il valore è stato effettivamente "toccato" (serve ad evidenziare eventuali errori di validazione)
    }

    e.preventDefault();
    e.stopPropagation();
    this.isOpen = true;
  };
  function isEmpty() {
    var model = this.ngModel;
    return model == null || model == undefined;
  }
  $scope.$on('SchemaFormValidate', function () {
    var _this = this;
    if (_this.sxRequired && isEmpty()) {
      _this.ngInvalid = true;
      _this.ngValid = false;
    } else if (_this.sxRequired && isEmpty()) {
      _this.ngInvalid = false;
      _this.ngValid = true;
    }
  });
}]);

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixDateTimePicker
 * @description
 * # sixDateTimePicker
 */
angular.module('emma.theme').component('sixDateTimePicker', {
  transclude: true,
  controller: 'sixDateTimePickerCtrl',
  templateUrl: 'theme/components/templates/sixdatetimepicker.html',
  restrict: 'E',
  bindings: {
    ngModel: '=',
    sxId: '@',
    format: '=?',
    dateOptions: '=?',
    // https://angular-ui.github.io/bootstrap/#/datepicker
    timePickerOptions: '=?',
    // https://angular-ui.github.io/bootstrap/#/timepicker
    enableDate: '=?',
    enableTime: '=?',
    sxDisabled: '<?',
    sxRequired: '=?',
    sxForm: '=?' // form in cui è contenuta la sixdatetimepicker (serve per la validazione e la segnalazione di eventuali errori)
  }
});
'use strict';

/**
 * Created by Rita Beltrami on 22/06/16.
 */
angular.module('emma.theme').constant('sixGridPaginationConstants', {
  filterType: {
    TEXT: 'text',
    DATE: 'date',
    DATE_OR_NULL: 'date_or_null',
    NUMBER: 'number',
    SELECT: 'select',
    SELECTMULTIPLE: 'selectmultiple',
    CHECKBOX: 'checkbox',
    SIXLOOKUP: 'sixlookup',
    FILE: 'file'
  },
  filterRel: {
    LESS_THAN: 'lt',
    LESS_THAN_OR_EQUAL: 'lte',
    GREATER_THAN: 'gt',
    GREATER_THAN_OR_EQUAL: 'gte',
    EQUAL: 'eq'
  }
});
angular.module('emma.theme').controller('sixGridPaginationController', ["$scope", "sixGridPaginationConstants", "uiGridConstants", "$timeout", "$log", "authFactory", "userPreferenceService", function ($scope, sixGridPaginationConstants, uiGridConstants, $timeout, $log, authFactory, userPreferenceService) {
  var ctrl = this;
  var filterTimeout = undefined;
  var commission = authFactory.getAuthData().info.commissions.current;
  ctrl.$onInit = function () {
    if (angular.isUndefined(ctrl.sxId)) {
      ctrl.sxId = 'grid1';
    }
    $log.debug("Init grid component started", ctrl.sxId);
    if (angular.isUndefined(ctrl.enableXlsExport)) {
      ctrl.enableXlsExport = true;
    }
    if (angular.isUndefined(ctrl.enableStateSaving)) {
      ctrl.enableStateSaving = false;
    }

    // Mostra/nasconde il campo di ricerca globale (input text) sopra alla griglia
    if (angular.isUndefined(ctrl.showGlobalSearch)) {
      ctrl.showGlobalSearch = true;
    }

    // merge default autoresize params with ctrl.autoResizeParams
    ctrl.autoResizeParams = angular.extend({
      enabled: true,
      minHeight: 200,
      marginTop: 260,
      filterRows: 0
    }, ctrl.autoResizeParams);
    // Opzioni griglia.
    ctrl.gridOptions = angular.extend({
      enableSorting: true,
      enableHorizontalScrollbar: true,
      exporterMenuPdf: false,
      enableFiltering: true,
      enableColumnResizing: true,
      paginationPageSizes: [10, 15, 25, 50, 100, 250, 500],
      paginationPageSize: 15,
      useExternalPagination: true,
      useExternalSorting: true,
      multiSelect: true,
      enableRowHeaderSelection: true,
      enableRowSelection: true,
      gridMenuCustomItems: [],
      columnDefs: []
    }, ctrl.gridOptions, {
      data: ctrl.itemsList.list,
      onRegisterApi: onRegisterApi,
      enableGridMenu: true,
      exporterCsvColumnSeparator: ';'
    });
    ctrl.gridOptions.gridMenuCustomItems.push({
      title: 'Adatta colonne',
      icon: 'fa fa-text-width',
      action: function action($event) {
        document.querySelectorAll(".ui-grid-column-resizer.right").forEach(function (el) {
          el.dispatchEvent(new CustomEvent("dblclick"));
        });
      },
      order: 208
    });
    if (ctrl.enableStateSaving) {
      ctrl.gridOptions.gridMenuCustomItems.push({
        title: 'Resetta colonne',
        icon: 'fa fa-history',
        action: function action($event) {
          resetState();
        },
        order: 209
      });
    }
    if (ctrl.enableXlsExport) {
      ctrl.gridOptions.gridMenuCustomItems.push({
        title: 'Esporta in XLS',
        icon: 'fa fa-file-excel-o',
        action: function action($event) {
          exportAll();
        },
        order: 210
      }, {
        title: 'Esporta solo righe visibili in XLS',
        icon: 'fa fa-file-excel-o',
        action: function action($event) {
          sixExportLib.exportXLSXVisibleRowsGrid(ctrl.params.gridApi, 'export');
        },
        order: 211
      }, {
        title: 'Esporta solo dati visibili in XLS',
        icon: 'fa fa-file-excel-o',
        action: function action($event) {
          var toSkip = this.grid.columns.filter(function (col) {
            return !col.visible;
          }).map(function (col) {
            return col.displayName || col.name || col.field;
          });
          sixExportLib.exportXLSXVisibleRowsGrid(ctrl.params.gridApi, 'export', toSkip);
        },
        order: 212
      });
    }
    /*
     * Grid app callbacks: sono le callback richiamabili dall'interno della grid (ad es. nel template delle colonne tramite grid.appScope.function() ).
     * Es:
     * ctrl.gridAppCallbacks = function() { ... };  // funzione
     *
     * ctrl.gridAppCallbacks = [        // array posizionale di funzioni
     *   fun1 = function() { ... },
     *   fun2 = function() { ... }
     * ]
     *
     * ctrl.gridAppCallbacks = {        // mappa di funzioni
     *   fun1: function() { ... },
     *   fun2: function() { ... }
     * }
     */
    if (ctrl.gridAppCallbacks) {
      if (angular.isFunction(ctrl.gridAppCallbacks)) {
        // funzione secca
        $scope[ctrl.gridAppCallbacks] = ctrl.gridAppCallbacks;
      } else if (angular.isObject(ctrl.gridAppCallbacks) || angular.isArray(ctrl.gridAppCallbacks)) {
        // array posizionale o mappa di funzioni
        for (var key in ctrl.gridAppCallbacks) {
          var clbck = ctrl.gridAppCallbacks[key];
          if (angular.isFunction(clbck)) {
            $scope[key] = clbck;
          } else {
            $log.error('\'key\'' + ' is not a function');
          }
        }
      } else {
        $log.error('\'grid-app-callbacks\' is not a function or map of functions or positional array of functions');
      }
    }
    ctrl.params.pageNumber = 1;
    ctrl.params.pageSize = ctrl.gridOptions.paginationPageSize;
    ctrl.params.sixApi = {
      restoreState: restoreState,
      refreshList: refreshList
    };
    callDataCallback();
  };
  ctrl.$onDestroy = function () {
    $log.debug("Destroy grid component", ctrl.sxId);
    $(window).off('resize', resizeHandler);
  };
  ctrl.$postLink = function () {
    $log.debug("Post link grid component", ctrl.sxId);
    // Quando ridimensiono la finestra ridimensiono anche la grid
    $(window).resize(resizeHandler);

    // Ridimensiona la griglia appena la pagina è caricata
    // angular.element(document).ready(function () {
    //   resizeGrid();
    // });
  };

  function onRegisterApi(gridApi) {
    gridApi.pagination.on.paginationChanged($scope, pageChangedCallback);
    gridApi.core.on.filterChanged($scope, filterChangedCallback);
    gridApi.core.on.sortChanged($scope, sortChangedCallback);
    gridApi.core.on.columnVisibilityChanged($scope, saveState);
    gridApi.colMovable.on.columnPositionChanged($scope, saveState);
    gridApi.colResizable.on.columnSizeChanged($scope, saveState);
    gridApi.pinning.on.columnPinned($scope, saveState);
    gridApi.core.refresh();
    ctrl.params.gridApi = gridApi;
  }
  function pageChangedCallback(newPage, pageSize, totalItems) {
    ctrl.params.pageNumber = newPage;
    if (pageSize != ctrl.pageSize) {
      ctrl.params.pageSize = pageSize;
      resizeHandler();
    }
    callDataCallback();
  }
  function sortChangedCallback(scope, sortColumns) {
    $log.debug('sortChangedCallback');
    ctrl.params.sortFields = sortColumns.map(function (col) {
      // devo sapere se è una lookup o text: uso il primo filtro
      // non posso specificare il type in fase di definizione delle columnDefs
      var colType = col.filters.length && col.filters[0] && col.filters[0].type;
      if (sixGridPaginationConstants.filterType.SIXLOOKUP == colType) {
        return col.field + '.description:' + col.sort.direction;
      }
      return col.field + ':' + col.sort.direction;
    }).join(',');
    callDataCallback();
    saveState();
  }
  function filterChangedCallback() {
    $log.debug('filterChangedCallback');
    ctrl.params.filterQuery = {};
    ctrl.params.filters = {};
    this.grid.columns.filter(function (col) {
      return col.enableFiltering && col.filters.length > 0;
    }).forEach(function (col) {
      col.filters.forEach(function (filter) {
        var term = filter.term;
        var field = angular.isFunction(col.colDef.sixFieldCallback) ? col.colDef.sixFieldCallback() : col.field;
        if (typeof field !== "string") field = col.field;
        if (angular.isFunction(col.colDef.sixFilteringCallback)) {
          term = col.colDef.sixFilteringCallback(term);
        }
        if (term && term != '') {
          ctrl.params.filterQuery[field] = '*' + term + '*';
          addFilter(ctrl.params.filters, field, filter.type || sixGridPaginationConstants.filterType.TEXT, term, filter.relation);
        }
      });
    });
    // Timeout per evitare rimbalzi di chiamate.
    if (angular.isDefined(filterTimeout)) {
      $timeout.cancel(filterTimeout);
    }
    filterTimeout = $timeout(function () {
      callDataCallback();
    }, 200);
  }
  function saveState() {
    if (ctrl.enableStateSaving) {
      var state = ctrl.params.gridApi.saveState.save();
      state.columns.forEach(function (c) {
        c.filters.forEach(function (f) {
          delete f.term;
        });
      });
      userPreferenceService.set(commission.code + '_' + ctrl.sxId + '_grid_state', state);
    }
  }
  function restoreState() {
    if (ctrl.enableStateSaving) {
      if (!ctrl.oldState) {
        // primo stato (di default) prima che venga restorato quello salvato (custom)
        ctrl.oldState = ctrl.params.gridApi.saveState.save();
      }
      userPreferenceService.get(commission.code + '_' + ctrl.sxId + '_grid_state').then(function (state) {
        if (state) {
          ctrl.params.gridApi.saveState.restore($scope, state);
        }
      });
    } else {
      $log.warn('Grid state saving not enabled!!');
    }
  }
  function resetState() {
    if (ctrl.enableStateSaving) {
      if (ctrl.oldState) {
        ctrl.params.gridApi.saveState.restore($scope, ctrl.oldState);
      }
      userPreferenceService.remove(commission.code + '_' + ctrl.sxId + '_grid_state');
    } else {
      $log.warn('Grid state saving not enabled!!');
    }
  }

  /*
    Endpoint di default su backend implementato dalla classe
      it.ictgroup.six.framework.index.service.AbstractIndexService
      progetto six-elastic
     Struttura attributo di filtraggio:
    {
      type: ["_range"|"_missing"|"_not"|"_in"|"_text"|"_exact"|"_bool"|"_boolean"]
      key: <attributo da cercare>,
      value: <valore da cercare>      tranne per "_missing"
    }
   */
  function addFilter(filters, key, type, value, relation) {
    filters = filters || {};
    if (angular.isDefined(key) && angular.isDefined(type)) {
      var rel = relation || '=';
      if (!Array.isArray(value)) {
        var value4Regex = getValue4Regex(value);
      }
      var filter = null;
      var subfilters = {};
      switch (type) {
        case sixGridPaginationConstants.filterType.SELECTMULTIPLE:
          //se value è un array lo gestisco come tale, altrimenti va in fallback sul TEXT per retrocompatibilità
          if (Array.isArray(value)) {
            value.forEach(function (val, index) {
              var value4Regex = getValue4Regex(val);
              subfilters['filter_' + index] = sixFiltersLib.regex(key, '.*' + value4Regex + '.*', 'or');
            });
            filters[key] = sixFiltersLib.must(subfilters);
          }
          break;
        case sixGridPaginationConstants.filterType.TEXT:
          filters[key] = sixFiltersLib.regex(key, '.*' + value4Regex + '.*');
          break;
        case sixGridPaginationConstants.filterType.DATE:
          filter = filters[key];
          var parts = value.split(/[-\\\/]+/); // dd/MM/yyyy ; dd-MM-yyyy ; dd\MM\yyyy
          filters[key] = sixFiltersLib.updateRange(key, new Date(parts[2], parts[1] - 1, parts[0]), rel, filter);
          break;
        case sixGridPaginationConstants.filterType.DATE_OR_NULL:
          if (filters[key]) {
            filter = filters[key]["value"]["date_" + key];
          }
          var parts = value.split(/[-\\\/]+/); // dd/MM/yyyy ; dd-MM-yyyy ; dd\MM\yyyy
          subfilters["date_" + key] = sixFiltersLib.updateRange(key, new Date(parts[2], parts[1] - 1, parts[0]), rel, filter, sixFiltersLib.CONSTRAINTS.OR);
          subfilters["missing_" + key] = sixFiltersLib.should({
            "missing": sixFiltersLib.missing(key, sixFiltersLib.CONSTRAINTS.OR)
          });
          filters[key] = sixFiltersLib.must(subfilters);
          break;
        case sixGridPaginationConstants.filterType.NUMBER:
          filter = filters[key];
          filters[key] = sixFiltersLib.updateRange(key, parseFloat(value), rel, filter);
          break;
        case sixGridPaginationConstants.filterType.CHECKBOX:
          filters[key] = sixFiltersLib.bool(key, parseBool(value));
          break;
        case sixGridPaginationConstants.filterType.SIXLOOKUP:
          filters[key + ".code"] = sixFiltersLib.must({
            "codeFilter": sixFiltersLib.regex(key + ".code", '.*' + value4Regex + '.*', "or"),
            "descrFilter": sixFiltersLib.regex(key + ".description", '.*' + value4Regex + '.*', "or")
          });
          break;
        case sixGridPaginationConstants.filterType.SELECT:
          filters[key] = sixFiltersLib.regex(key, '.*' + value4Regex + '.*');
          break;
        case sixGridPaginationConstants.filterType.FILE:
          filters[key + ".title"] = sixFiltersLib.regex(key + ".title", '.*' + value4Regex + '.*');
          break;
        default:
          // lo tratto come testo
          filters[key] = sixFiltersLib.regex(key, '.*' + value4Regex + '.*');
          break;
      }
    }
    return filters;
  }
  function getValue4Regex(value) {
    var value4Regex = value.replace(/(\.\*\+\?\\\/ "'\(\)\[]{}\^\$)/g, '\\\$1');
    value4Regex = value4Regex.replace(/[a-zA-Z]/g, function (match) {
      var low = match.toLowerCase();
      var up = match.toUpperCase();
      return "[" + low + up + "]";
    });
    return value4Regex;
  }
  function parseBool(value) {
    return value == 'true' || value == 't' || value == 'vero' || value == 'v' || value == 'yes' || value == 'y' || value == 'si' || value == 's' || value == 1 || value == '1' || value == true;
  }

  /*NB: sebbene la ui-grid supporti il passaggio di dati tramite lista,
  questa callback si aspetta una promise, spesso di una response */
  $scope.loadingPlaceholder = {
    show: true,
    message: 'Caricamento dati...'
  };
  ctrl.callDataCallback = function () {
    // Timeout per evitare rimbalzi di chiamate.
    if (angular.isDefined(filterTimeout)) {
      $timeout.cancel(filterTimeout);
    }
    filterTimeout = $timeout(_callDataCallback, 500);
  };
  function _callDataCallback() {
    if (ctrl.getDataCallback && angular.isFunction(ctrl.getDataCallback)) {
      $log.debug('---- _callDataCallback', ctrl.params);
      ctrl.getDataCallback().then(function (data) {
        $scope.loadingPlaceholder.show = false;
        ctrl.gridOptions.data = [];
        ctrl.gridOptions.data = data.list;
        if (ctrl.gridOptions.hideTotalItems) {
          ctrl.gridOptions.totalItems = 0;
        } else {
          ctrl.gridOptions.totalItems = data.totalResults || data.list && data.list.length || 0;
        }
        /* FIXME: se la callback non chiama il DB, essa viene risolta prima che il controller abbia recuperato le api da ui-grid, sollevando una eccezione.
           Siccome il metodo richiamato serve solo a ridisegnare la griglia, posso saltarlo se non è ancora disponibile*/
        if (ctrl.params.gridApi.core) {
          ctrl.params.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
        }
      })["catch"](function (error) {
        $log.error('sixgridpagination: error retrieving data', error);
        $scope.loadingPlaceholder = {
          show: true,
          message: 'Errore durante il recupero dei dati',
          error: true
        };
      });
    }
  }
  function callDataCallback() {
    if (ctrl.getDataCallback && angular.isFunction(ctrl.getDataCallback)) {
      ctrl.getDataCallback().then(function (data) {
        ctrl.gridOptions.data = [];
        ctrl.gridOptions.data = data.list;
        ctrl.gridOptions.totalItems = data.totalResults || data.list && data.list.length || 0;
        ctrl.params.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
      });
    }
  }

  /**
   * WATCHES
   */

  // $scope.$watch('$ctrl.params.queryParam', function (newV) {

  // })

  // ***** RESIZE GRID ***** //

  function resizeGrid() {
    var newHeight = ctrl.gridOptions.paginationPageSize * 30 + 140 + ctrl.autoResizeParams.filterRows * 15;
    var windowHeight = $(window).height() - ctrl.autoResizeParams.marginTop;
    windowHeight = Math.max(windowHeight, ctrl.autoResizeParams.minHeight); // minimo 200px
    newHeight = Math.min(windowHeight, newHeight); // massima altezza: altezza visualizzabile dalla finestra alle dimensioni correnti
    angular.element(document.getElementById(ctrl.sxId + '_grid')).css('height', newHeight);
  }
  function resizeHandler() {
    if (ctrl.autoResizeParams.enabled) {
      resizeGrid();
    }
  }

  /* **************** */
  /* **** EXPORT **** */
  /* **************** */

  function exportAll() {
    if (ctrl.getAllDataCallback && angular.isFunction(ctrl.getAllDataCallback)) {
      sixExportLib.exportXLSXRowsGrid(ctrl.params.gridApi, ctrl.getAllDataCallback(), 'export');
    } else {
      $log.info('get-all-data-allback attribute is not a function: exporting only grid known rows');
      sixExportLib.exportXLSXAllRowsGrid(ctrl.params.gridApi, 'export');
    }
  }
  function refreshList(data) {
    ctrl.gridOptions.data = data;
  }
}]);
'use strict';

/**
 * Created by Rita Beltrami on 22/06/16.
 * @ngdoc component
 * @name emma.theme.component:sixTreeAttachments
 * @description
 * # sixTreeAttachments
 */
angular.module('emma.theme').component('sixGridPagination', {
  controller: 'sixGridPaginationController',
  templateUrl: 'theme/components/templates/sixgridpagination.html',
  bindings: {
    getDataCallback: '&',
    getAllDataCallback: '&?',
    gridAppCallbacks: '=?',
    // funzione, array posizionale di funzioni o mappa di funzioni da richiamare dall'interno della grid (es. nel template di una colonna tramite grid.appScope.function() )
    itemsList: '=',
    gridOptions: '=',
    params: '=',
    sxId: '@',
    showGlobalSearch: '=?',
    autoResizeParams: '=?',
    // {enabled: true, minHeight: 200px, marginTop: 260px}
    enableXlsExport: '=?',
    enableStateSaving: '=?'
  }
});
'use strict';

/**
 * Created by Rita Beltrami on 05/09/16.
 */
angular.module('emma.theme').controller('sixProfileController', ["$scope", "$rootScope", "authFactory", "loginFactory", "commissionFactory", "dialogService", "$route", "operatorGroupService", "menuProfiling", function ($scope, $rootScope, authFactory, loginFactory, commissionFactory, dialogService, $route, operatorGroupService, menuProfiling) {
  var ctrl = this;
  $scope.sxId = "six-profile";
  $scope.sxTitle = "Profilo";
  $scope.sxOpened = false;
  $scope.itemsWhitelist = {};
  $scope.tabHeaderList = ctrl.sxProfileItems;
  function init() {
    // Ho tolto filtri, li rimuovo anche dal local storage
    if ($scope.userInfo() && $scope.tabHeaderList.length < $scope.userInfo().profile.items.length) {
      var reset = [];
      $scope.switchProfile($scope.userInfo().profile.items[0], reset);
    }
    //precarico la lista commesse esistenti per usarla come whitelist all'apertura della sidebar
    commissionFactory().getCommissionsList().$promise.then(function (commissionList) {
      if (commissionList.list) {
        $scope.itemsWhitelist.commission = [];
        commissionList.list.forEach(function (el) {
          if (el.status != "closed") {
            $scope.itemsWhitelist.commission.push(el.code);
          }
        });
      }
    });
  }
  $scope.isLoggedIn = function () {
    return authFactory.isAuthenticated();
  };
  $scope.userInfo = function () {
    if ($scope.isLoggedIn()) {
      var authData = authFactory.getAuthData();
      if (authData.options === undefined) {
        //default
        authData.options = {
          admin: false,
          config: false,
          revokeAdmin: false,
          touch: false
        };
      }
      return authData;
    } else {
      return undefined;
    }
  };
  function getSelectedDescription(type, currentProfiles) {
    var description = '';
    for (var i = 0; i < currentProfiles.length; i++) {
      if (currentProfiles[i].type === type) {
        description = currentProfiles[i].description;
        break;
      }
    }
    ;
    return description;
  }
  ;
  function selectProfile(item, currentProfiles) {
    var found = false;
    if (currentProfiles === null) {
      currentProfiles = [];
    }
    for (var i = 0; i < currentProfiles.length; i++) {
      if (currentProfiles[i].type === item.type) {
        currentProfiles[i] = item;
        found = true;
        break;
      }
    }
    ;
    if (!found) {
      currentProfiles.push(item);
    }
    return currentProfiles;
  }
  $scope.isItemSelected = function (item) {
    var isSelected = false;
    var profileInfo = $scope.userInfo();
    if (angular.isDefined(profileInfo) && angular.isDefined(profileInfo.profile.items) && profileInfo.profile.items.length > 0) {
      profileInfo.profile.items.forEach(function (p) {
        if (p.type === item.type && p.code === item.code) {
          isSelected = true;
        }
      });
    }
    return isSelected;
  };
  $scope.switchProfile = function (item, currentProfiles) {
    dialogService.loading('Cambio profilo <i class="fa fa-angle-double-right"></i> ' + item.description);
    if (item.type == 'commission') {
      currentProfiles = [item];
    } else {
      currentProfiles = selectProfile(item, currentProfiles);
    }
    var description = '';
    var i = 0;
    $scope.tabHeaderList.forEach(function (element) {
      // Non serve a niente, solo per eventuale debug del backend.
      var label = getSelectedDescription(element.type, currentProfiles);
      if (label !== '') {
        description += " [" + i + "] " + label;
      }
      i++;
    });
    var commissionCode = '';
    for (var i = 0; i < currentProfiles.length; i++) {
      if (currentProfiles[i].type === 'commission') {
        commissionCode = currentProfiles[i].code;
        break;
      }
    }
    ;
    var switchProfileElement = {
      selected: {
        type: '',
        cod: 0,
        code: commissionCode,
        description: description,
        items: currentProfiles
      }
    };
    loginFactory["switch"](switchProfileElement).$promise.then(function (response) {
      var commissionCode = response.info.commissions.current.code;
      commissionFactory().getCommissionByCode({
        code: commissionCode
      }).$promise.then(function (commissionData) {
        authFactory.setAuthData(response);
        menuProfiling.updateMenu(response.menu);
        operatorGroupService.setGroupInLocalStorage().then(function () {
          $route.reload();
          loadData();
          dialogService.stopLoading();
        });
      });
    });
  };
  $scope.clearProfileAndSwitch = function (profile) {
    var userInfo = $scope.userInfo();
    var switchProfileElement = {
      selected: {
        type: '',
        cod: 0,
        code: userInfo.info.commissions.current.code,
        items: userInfo.profile.items.filter(function (p) {
          return p.code != profile.code;
        })
      }
    };
    loginFactory["switch"](switchProfileElement).$promise.then(function (response) {
      authFactory.setAuthData(response);
      menuProfiling.updateMenu(response.menu);
      operatorGroupService.setGroupInLocalStorage().then(function () {
        $route.reload();
        loadData();
        dialogService.stopLoading();
      });
    });
  };
  $rootScope.$on('sixFramework:close-profile', function (event, param) {
    $scope.sxOpened = false;
  });
  $rootScope.$on('sixFramework:toggle-profile', function (event, param) {
    $scope.sxOpened = !$scope.sxOpened;
    if ($scope.sxOpened) {
      loadData();
    }
  });
  function loadData() {
    $('#sx-profile-tab-headers').find("li").removeClass('active');
    $('#sx-profile-tab-headers').find("li").first().addClass('active');
    var authInfo = $scope.userInfo();
    if (angular.isDefined(authInfo) && angular.isDefined($scope.tabHeaderList)) {
      $scope.tabBodyList = [];
      $scope.tabHeaderList.forEach(function (item) {
        var type = item.type;
        var body = {};
        if (angular.isDefined(type)) {
          var body = {
            label: item.label,
            type: type,
            list: getItemsList(authInfo, type),
            current: getCurrentItem(authInfo, type),
            filter: '',
            canClear: isCrossPermitted(authInfo, type)
          };
          if (body.list.length) $scope.tabBodyList.push(body);
        }
      });
    }
  }
  function getItemsList(authInfo, type) {
    var list = [];
    if (angular.isDefined(authInfo.profiles)) {
      authInfo.profiles.forEach(function (item) {
        if (type === item.type) {
          if ($scope.itemsWhitelist[type]) {
            if ($scope.itemsWhitelist[type].indexOf(item.code) != -1) {
              list.push(item);
            }
          } else {
            list.push(item);
          }
        }
      });
    }
    return list;
  }
  ;
  function getCurrentItem(authInfo, type) {
    var result = undefined;
    var list = authInfo.profile.items;
    if (angular.isDefined(list)) {
      for (var i = 0; i < list.length; i++) {
        if (type === list[i].type) {
          result = list[i];
          break;
        }
      }
    }
    return result;
  }
  ;
  function isCrossPermitted(authInfo, type) {
    if (authInfo.info.operations.CROSS) {
      var operation = authInfo.info.operations.CROSS.find(function (opp) {
        return opp.name == type;
      });
      return operation && operation.permitted;
    }
    return false;
  }

  //___main___
  init();
}]);
'use strict';

/**
 * Created by Rita Beltrami on 05/09/16.
 * @ngdoc component
 * @name emma.theme.component:sixProfile
 * @description Panel to handle the selection of current applicaction profile
 * (i.e. selezione commessa/cliente correnti)
 * # sixSearchSingleTerm
 */
angular.module('emma.theme').component('sixProfile', {
  restrict: 'E',
  controller: 'sixProfileController',
  templateUrl: 'theme/components/templates/sixprofile.html',
  bindings: {
    sxProfileItems: '='
  },
  link: function postLink(scope, element, attrs) {}
});
'use strict';

/**
 * Created by Rita Beltrami on 21/07/16.
 */
angular.module('emma.theme').controller('sixSearchFiltersController', ["$scope", "lookupFactory", "DATA_SET_URL", function ($scope, lookupFactory, DATA_SET_URL) {
  var ctrl = this;
  $scope.searchResult = ctrl.sxList;
  $scope.sxOpen = ctrl.sxOpen;
  $scope.sxId = ctrl.sxId;
  $scope.sxModel = ctrl.sxModel || undefined;
  $scope.sxFilterOnly = ctrl.sxFilterOnly || false;
  $scope.sxFilter = ctrl.sxFilter;
  $scope.sxAutoConfirmFilter = ctrl.sxAutoConfirmFilter || false;
  $scope.sxOnFilterChanged = ctrl.sxOnFilterChanged;
  $scope.sxOnListChanged = ctrl.sxOnListChanged;
  $scope.loading = true;
  $scope.showSelectModel = ctrl.sxShowSelectSchema || angular.isUndefined(ctrl.sxModel);
  $scope.params = {
    type_id: {},
    type_obj: $scope.def,
    attributes: [],
    attributes_unfiltered: [],
    terms: [{
      attribute_obj: {},
      attribute_rel: 'eq'
    }]
  };
  $scope.$watchCollection('sxOpen.open', function (newValue, oldValue) {
    //alert(test);
  });
  $scope.initialized = false;
  $scope.stored_value = {};
  $scope.$watchCollection('sxModel.type_obj', function (newValue, oldValue) {
    $scope.params.type_id = $scope.sxModel.type_id;
    $scope.params.type_obj = $scope.sxModel.type_obj;
    $scope.showSelectModel = ctrl.sxShowSelectSchema || angular.isUndefined(ctrl.sxModel);
    //fix per /treefilter  -> reinizializza solo al cambio di valore
    if (angular.isDefined(newValue) && $scope.initialized && $scope.stored_value.UUID !== newValue.UUID) {
      $scope.setValue(undefined);
      $scope.setObject(undefined);
      $scope.params.attributes = [];
      $scope.params.attributes_unfiltered = [];
    }
    $scope.stored_value = Object.assign({}, oldValue);
    $scope.initialized = true;
  });
  $scope.addSearchTerm = function () {
    var term = {
      attribute_obj: {},
      attribute_rel: 'eq'
    };
    $scope.params.terms.push(term);
  };

  // Se cambia il modello di riferimento, parso l'oggetto (schema-form) per compilare la lista dei possibili attributi su cui filtrare.
  $scope.$watchCollection('params.type_obj', function (newValue, oldValue) {
    if (newValue && ($scope.params.attributes.length == 0 || typeof oldValue == "undefined" || newValue.UUID != oldValue.UUID)) {
      loadAttributesListFromSchemaForm(newValue);
      initFilters();
    }
  });
  $scope.$watch('params.terms', function (newValue, oldValue) {
    if ($scope.sxAutoConfirmFilter) {
      $scope.getFiltersList();
    }
  }, true);
  function loadAttributesListFromSchemaForm(newValue) {
    if (angular.isDefined(newValue) && angular.isDefined(newValue.model)) {
      for (var q = 0; q < newValue.model.form.length; q++) {
        var form = newValue.model.form[q];
        for (var i = 0; i < form.items.length; i++) {
          var its = form.items[i];
          parseFormItems(its, newValue.model.schema.properties);
        }
      }
    }
  }
  function parseFormItems(its, properties) {
    for (var j = 0; j < its.tabs.length; j++) {
      var tab = its.tabs[j];
      for (var k = 0; k < tab.items.length; k++) {
        var item = tab.items[k];
        if (item.type != 'sixinherit' && item.type != 'array') {
          $scope.params.attributes_unfiltered.push(item);
          $scope.params.attributes = $scope.params.attributes_unfiltered.slice(0, $scope.params.attributes_unfiltered.length);
        }
      }
    }
  }
  $scope.setValue = function (value) {
    for (var i = 0; i < $scope.params.terms.length; i++) {
      $scope.params.terms[i].attribute_value = value;
    }
  };
  $scope.setObject = function (obj) {
    for (var i = 0; i < $scope.params.terms.length; i++) {
      $scope.params.terms[i].attribute_obj = obj;
    }
  };
  $scope.clearSelect = function () {
    $scope.setValue(undefined);
    $scope.setObject(undefined);
    $scope.refreshData();
  };
  function getPath() {
    var path = 'record' + '/' + $scope.params.type_id.UUID + '/_lookup';
    return path;
  }
  function getWarUrl() {
    var url = DATA_SET_URL + '/api/';
    return url;
  }
  function getPayload() {
    var payload = {
      page: 1,
      page_size: 10000,
      show_revision: false
    };
    return payload;
  }
  function fillFilter(filter, i) {
    if (angular.isDefined($scope.params.terms[i].attribute_obj) && angular.isDefined($scope.params.terms[i].attribute_value)) {
      var attribute = 'model.' + $scope.params.terms[i].attribute_obj.key[0];
      var value = $scope.params.terms[i].attribute_value;
      switch ($scope.params.terms[i].attribute_obj.type) {
        case 'text':
        case 'uiselectmultiple':
          if (value && value != '') {
            if ($scope.params.terms[i].rel == 'like') {
              filter[attribute] = sixFiltersLib.text(attribute, '*' + value + '*');
            } else if ($scope.params.terms[i].rel == 'eq') {
              filter[attribute] = sixFiltersLib.exact(attribute, value);
            }
          }
          break;
        case 'datepicker':
        case 'number':
          if (value && value != '') {
            var f = filter[attribute];
            filter[attribute] = sixFiltersLib.updateRange(attribute, value, $scope.params.terms[i].attribute_rel, f);
          }
          break;
        case 'checkbox':
          filter[attribute] = sixFiltersLib.bool(attribute, value);
          break;
        case 'sixlookup':
          attribute += '.UUID';
          filter[attribute] = sixFiltersLib.exact(attribute, value.UUID);
          break;
        case 'uiselect':
          var ui_value = $scope.params.terms[i].attribute_value.value;
          filter[attribute] = sixFiltersLib.exact(attribute, ui_value);
          break;
        default:
          break;
      }
    }
    return filter;
  }
  function fillFilterDescription(filter, i) {
    var attribute;
    var rel = '=';
    var value;
    if (angular.isDefined($scope.params.terms[i].attribute_obj) && angular.isDefined($scope.params.terms[i].attribute_value)) {
      attribute = $scope.params.terms[i].attribute_obj.title;
      switch ($scope.params.terms[i].attribute_obj.type) {
        case 'text':
        case 'uiselectmultiple':
        case 'checkbox':
          value = $scope.params.terms[i].attribute_value;
          break;
        case 'uiselect':
          value = $scope.params.terms[i].attribute_value.name;
          break;
        case 'datepicker':
        case 'number':
          switch ($scope.params.terms[i].attribute_rel) {
            case "lt":
              rel = "&lt;";
              break;
            case "lte":
              rel = "&le;";
              break;
            case "gt":
              rel = "&gt;";
              break;
            case "gte":
              rel = "&ge;";
              break;
          }
          value = $scope.params.terms[i].attribute_value;
          break;
        case 'sixlookup':
          value = $scope.params.terms[i].attribute_value.description;
          break;
        default:
          break;
      }
      var obj = {
        attribute: attribute,
        relation: rel,
        value: String(value)
      };
      ctrl.sxFilterDescriptionLong.push(obj);
      ctrl.sxFilterDescriptionShort += attribute + rel + value + "; ";
    }
  }
  function fillSxFilter(filter) {
    // Filtro vero e proprio
    if (angular.isDefined($scope.sxFilter)) {
      for (var key in $scope.sxFilter) {
        delete $scope.sxFilter[key];
      }
      for (var key in filter) {
        $scope.sxFilter[key] = filter[key];
      }
    }
    // Descrizione parlante
    if ($scope.params.terms.length > 0) {
      ctrl.sxFilterDescriptionLong = [];
      ctrl.sxFilterDescriptionShort = "";
      for (var i = 0; i < $scope.params.terms.length; i++) {
        fillFilterDescription(filter, i);
      }
    } else {
      ctrl.sxFilterDescriptionLong = [];
      ctrl.sxFilterDescriptionShort = "";
    }
    $scope.sxOnFilterChanged();
  }
  function fillSxModel() {
    if (ctrl.sxShowSelectSchema) {
      $scope.sxModel.type_id = JSON.parse(JSON.stringify($scope.params.type_id));
      $scope.sxModel.type_obj = JSON.parse(JSON.stringify($scope.params.type_obj));
    }
  }
  $scope.getFiltersList = function () {
    var filter = {};
    // Compongo il mio filtro interno per la ricerca
    for (var i = 0; i < $scope.params.terms.length; i++) {
      fillFilter(filter, i);
    }
    // Se il modello è stato scelto da me, ripasso indietro anche la sua descrizione.
    fillSxModel();
    // Compongo il filtro da ripassare all'esterno a chi mi sta chiamando
    fillSxFilter(filter);
    return filter;
  };
  $scope.search = function () {
    $scope.searchResult.length = 0;
    lookupFactory(getWarUrl(), getPath()).search(getPayload(), $scope.getFiltersList()).$promise.then(function (data) {
      if (angular.isDefined(data) && data.hasOwnProperty('list')) {
        for (var i = 0; i < data.list.length; i++) {
          $scope.searchResult.push(data.list[i]);
        }
        $scope.sxOnListChanged();
      }
    });
  };
  function isEmpty(obj) {
    return Object.keys(obj).length === 0;
  }
  function initFilters() {
    // Può essere che da fuori mi siano stai impostati dei filtri di default da applicare...
    if ($scope.loading) {
      // probabilmente ha più senso salvare proprio tutto l'oggetto come lo vuole la direttiva
      if (angular.isDefined(ctrl.sxFilterInit)) {
        $scope.params.terms = ctrl.sxFilterInit;
      }
    } else {
      $scope.loading = false;
    }
  }
}]);
'use strict';

/**
 * Created by Rita Beltrami on 21/07/16.
 * @ngdoc component
 * @name emma.theme.component:sixSearchTerms
 * @description Advanced search con multiple fields
 * # sixSearchTerms
 */
angular.module('emma.theme').component('sixSearchFilters', {
  restrict: 'E',
  controller: 'sixSearchFiltersController',
  templateUrl: 'theme/components/templates/sixsearchfilters.html',
  bindings: {
    sxList: '=',
    sxOpen: '=',
    sxId: '@',
    sxModel: '=?',
    sxFilterOnly: '=',
    sxFilter: "=",
    sxFilterDescription: "=?",
    sxFilterDescriptionLong: "=?",
    sxFilterDescriptionShort: "=?",
    sxFilterInit: "=",
    sxAutoConfirmFilter: "=",
    sxOnFilterChanged: "&",
    sxOnListChanged: "&",
    sxShowSelectSchema: "="
  },
  link: function postLink(scope, element, attrs) {}
});
'use strict';

/**
 * Created by Rita Beltrami on 21/07/16.
 */
angular.module('emma.theme').controller('sixSearchSingleTermController', ["$scope", function ($scope) {
  var ctrl = this;
  $scope.params = ctrl.sxParams;
  $scope.filter = ctrl.sxFilter;
  $scope.index = ctrl.sxPosition;
  $scope.ngModel = $scope.params.terms[$scope.index].attribute_obj;
  $scope.dateOptions = {
    formatYear: 'yyyy',
    opened: false
  };
  $scope.setValue = function (value) {
    $scope.params.terms[$scope.index].attribute_value = value;
  };
  $scope.setObject = function (obj) {
    $scope.params.terms[$scope.index].attribute_obj = obj;
  };
  $scope.clearSelect = function () {
    $scope.setValue(undefined);
    $scope.setObject(undefined);
    $scope.refreshData();
  };
  $scope.selectAttribute = function (item) {
    $scope.setObject(item);
    $scope.setValue(undefined);
  };
  $scope.isRel = function () {
    var isARelation = false;
    if (angular.isDefined($scope.params.terms[$scope.index].attribute_obj)) {
      switch ($scope.params.terms[$scope.index].attribute_obj.type) {
        case 'datepicker':
        case 'number':
          isARelation = true;
          break;
        default:
          isARelation = false;
      }
    }
    return isARelation;
  };
  $scope.selectAttributeValue = function (item) {
    $scope.params.terms[$scope.index].attribute_value = item;
  };
  $scope.removeTerm = function () {
    $scope.params.terms.splice($scope.index, 1);
  };
  $scope.refreshData = function (search) {
    $scope.params.attributes = [];
    if (angular.isUndefined(search)) {
      $scope.params.attributes = $scope.params.attributes_unfiltered.slice(0, $scope.params.attributes_unfiltered.length);
    } else {
      var toLower = search.toLowerCase();
      for (var i = 0; i < $scope.params.attributes_unfiltered.length; i++) {
        var title = $scope.params.attributes_unfiltered[i].title.toLowerCase();
        ;
        if (title.indexOf(toLower) > -1) {
          $scope.params.attributes.push($scope.params.attributes_unfiltered[i]);
        }
      }
    }
  };
}]);
'use strict';

/**
 * Created by Rita Beltrami on 21/07/16.
 * @ngdoc component
 * @name emma.theme.component:sixSearchSingleTerm
 * @description Single line of advanced search form
 * # sixSearchSingleTerm
 */
angular.module('emma.theme').component('sixSearchSingleTerm', {
  restrict: 'E',
  controller: 'sixSearchSingleTermController',
  templateUrl: 'theme/components/templates/sixsearchsingleterm.html',
  bindings: {
    onRemove: '&',
    sxParams: '=',
    sxPosition: '=',
    sxFilter: '='
  },
  link: function postLink(scope, element, attrs) {}
});
'use strict';

/**
 * Created by Rita Beltrami on 21/07/16.
 */
angular.module('emma.theme').controller('sixSearchTermsController', ["$scope", "lookupFactory", "DATA_SET_URL", function ($scope, lookupFactory, DATA_SET_URL) {
  var ctrl = this;
  $scope.searchResult = ctrl.sxList;
  $scope.sxOpen = ctrl.sxOpen;
  $scope.sxId = ctrl.sxId;
  $scope.sxModel = ctrl.sxModel || undefined;
  $scope.sxFilterOnly = ctrl.sxFilterOnly || false;
  $scope.sxFilter = ctrl.sxFilter;
  $scope.sxOnFilterChanged = ctrl.sxOnFilterChanged;
  $scope.sxOnListChanged = ctrl.sxOnListChanged;
  $scope.loading = true;
  $scope.showSelectModel = ctrl.sxShowSelectSchema | angular.isUndefined(ctrl.sxModel);
  $scope.$watchCollection('sxOpen.open', function (newValue, oldValue) {
    //alert(test);
  });
  $scope.params = {
    type_id: {},
    type_obj: $scope.def,
    attributes: [],
    attributes_unfiltered: [],
    terms: [{
      attribute_obj: {},
      attribute_rel: 'equal'
    }]
  };
  $scope.$watchCollection('sxModel.type_obj', function (newValue, oldValue) {
    $scope.params.type_id = $scope.sxModel.type_id;
    $scope.params.type_obj = $scope.sxModel.type_obj;
    $scope.showSelectModel = ctrl.sxShowSelectSchema | angular.isUndefined(ctrl.sxModel);
  });
  $scope.addSearchTerm = function () {
    var term = {
      attribute_obj: {},
      attribute_rel: 'equal'
    };
    $scope.params.terms.push(term);
  };

  // Se cambia il modello di riferimento, parso l'oggetto (schema-form) per compilare la lista dei possibili attributi su cui filtrare.
  $scope.$watchCollection('params.type_obj', function (newValue, oldValue) {
    if (newValue != oldValue) {
      loadAttributesListFromSchemaForm(newValue);
      initFilters();
    }
  });
  function loadAttributesListFromSchemaForm(newValue) {
    $scope.setValue(undefined);
    $scope.setObject(undefined);
    $scope.params.attributes = [];
    $scope.params.attributes_unfiltered = [];
    if (angular.isDefined(newValue) && angular.isDefined(newValue.model)) {
      for (var q = 0; q < newValue.model.form.length; q++) {
        var form = newValue.model.form[q];
        for (var i = 0; i < form.items.length; i++) {
          var its = form.items[i];
          parseFormItems(its, newValue.model.schema.properties);
        }
      }
    }
  }
  ;
  function parseFormItems(its, properties) {
    for (var j = 0; j < its.tabs.length; j++) {
      var tab = its.tabs[j];
      for (var k = 0; k < tab.items.length; k++) {
        var item = tab.items[k];
        if (item.type != 'sixinherit' && item.type != 'array') {
          $scope.params.attributes_unfiltered.push(item);
          $scope.params.attributes = $scope.params.attributes_unfiltered.slice(0, $scope.params.attributes_unfiltered.length);
        }
      }
    }
  }
  $scope.setValue = function (value) {
    for (var i = 0; i < $scope.params.terms.length; i++) {
      $scope.params.terms[i].attribute_value = value;
    }
  };
  $scope.setObject = function (obj) {
    for (var i = 0; i < $scope.params.terms.length; i++) {
      $scope.params.terms[i].attribute_obj = obj;
    }
  };
  $scope.clearSelect = function () {
    $scope.setValue(undefined);
    $scope.setObject(undefined);
    $scope.refreshData();
  };
  function getPath() {
    var path = 'record' + '/' + $scope.params.type_id.UUID + '/_lookup';
    return path;
  }
  function getWarUrl() {
    var url = DATA_SET_URL + '/api/';
    return url;
  }
  function getPayload() {
    var payload = {
      page: 1,
      page_size: 10000,
      show_revision: false
    };
    return payload;
  }

  /* Compongo il filtro per eseguire la query */
  function fillFilter(filter, i) {
    if (angular.isDefined($scope.params.terms[i].attribute_obj) && angular.isDefined($scope.params.terms[i].attribute_value)) {
      var attribute = 'model.' + $scope.params.terms[i].attribute_obj.key[0];
      switch ($scope.params.terms[i].attribute_obj.type) {
        case 'text':
        case 'uiselectmultiple':
          var value = $scope.params.terms[i].attribute_value;
          if (value && value != '') {
            filter[attribute] = '*' + value + '*';
          }
          break;
        case 'datepicker':
        case 'number':
          var value = $scope.params.terms[i].attribute_value;
          if (value && value != '') {
            filter['_range'] = {
              key: attribute,
              relation: $scope.params.terms[i].attribute_rel,
              value: value
            };
          }
          break;
        case 'checkbox':
          var value = $scope.params.terms[i].attribute_value;
          filter[attribute] = value;
          break;
        case 'sixlookup':
          var value = $scope.params.terms[i].attribute_value.UUID;
          attribute += '.UUID';
          filter[attribute] = value;
          break;
        case 'uiselect':
          var value = $scope.params.terms[i].attribute_value.value;
          filter[attribute] = value;
          break;
        default:
          break;
      }
    }
    return filter;
  }
  function fillFilterDescription(filter, i) {
    var attribute;
    var rel = '=';
    var value;
    if (angular.isDefined($scope.params.terms[i].attribute_obj) && angular.isDefined($scope.params.terms[i].attribute_value)) {
      attribute = $scope.params.terms[i].attribute_obj.title;
      switch ($scope.params.terms[i].attribute_obj.type) {
        case 'text':
        case 'uiselectmultiple':
        case 'checkbox':
          value = $scope.params.terms[i].attribute_value;
          break;
        case 'uiselect':
          value = $scope.params.terms[i].attribute_value.name;
          break;
        case 'datepicker':
        case 'number':
          switch ($scope.params.terms[i].attribute_rel) {
            case "lt":
              rel = "&lt;";
              break;
            case "lte":
              rel = "&le;";
              break;
            case "gt":
              rel = "&gt;";
              break;
            case "gte":
              rel = "&ge;";
              break;
          }
          value = $scope.params.terms[i].attribute_value;
          break;
        case 'sixlookup':
          value = $scope.params.terms[i].attribute_value.description;
          break;
        default:
          break;
      }
      var obj = {
        attribute: attribute,
        relation: rel,
        value: String(value)
      };
      ctrl.sxFilterDescriptionLong.push(obj);
      ctrl.sxFilterDescriptionShort += attribute + rel + value + "; ";
    }
  }
  function fillSxFilter(filter) {
    // Filtro vero e proprio
    if (angular.isDefined($scope.sxFilter)) {
      for (var key in $scope.sxFilter) {
        delete $scope.sxFilter[key];
      }
      for (var key in filter) {
        $scope.sxFilter[key] = filter[key];
      }
    }
    // Descrizione parlante
    if ($scope.params.terms.length > 0) {
      ctrl.sxFilterDescriptionLong = [];
      ctrl.sxFilterDescriptionShort = "";
      for (var i = 0; i < $scope.params.terms.length; i++) {
        fillFilterDescription(filter, i);
      }
    } else {
      ctrl.sxFilterDescriptionLong = [];
      ctrl.sxFilterDescriptionShort = "";
    }
    $scope.sxOnFilterChanged();
  }
  function fillSxModel() {
    if (ctrl.sxShowSelectSchema) {
      $scope.sxModel.type_id = JSON.parse(JSON.stringify($scope.params.type_id));
      $scope.sxModel.type_obj = JSON.parse(JSON.stringify($scope.params.type_obj));
    }
  }
  ;
  $scope.getFiltersList = function () {
    var filter = {};
    // Compongo il mio filtro interno per la ricerca
    for (var i = 0; i < $scope.params.terms.length; i++) {
      fillFilter(filter, i);
    }
    // Se il modello è stato scelto da me, ripasso indietro anche la sua descrizione.
    fillSxModel();
    // Compongo il filtro da ripassare all'esterno a chi mi sta chiamando
    fillSxFilter(filter);
    return filter;
  };
  $scope.search = function () {
    $scope.searchResult.length = 0;
    lookupFactory(getWarUrl(), getPath()).search(getPayload(), $scope.getFiltersList()).$promise.then(function (data) {
      if (angular.isDefined(data) && data.hasOwnProperty('list')) {
        for (var i = 0; i < data.list.length; i++) {
          $scope.searchResult.push(data.list[i]);
        }
        $scope.sxOnListChanged();
      }
    });
  };
  function isEmpty(obj) {
    return Object.keys(obj).length === 0;
  }
  function initFilters() {
    // Può essere che da fuori mi siano stai impostati dei filtri di default da applicare...
    if ($scope.loading) {
      // probabilmente ha più senso salvare proprio tutto l'oggetto come lo vuole la direttiva
      if (angular.isDefined(ctrl.sxFilterInit)) {
        $scope.params.terms = ctrl.sxFilterInit;
      }
    } else {
      $scope.loading = false;
    }
  }
}]);
'use strict';

/**
 * Created by Rita Beltrami on 21/07/16.
 * @ngdoc component
 * @name emma.theme.component:sixSearchTerms
 * @description Advanced search con multiple fields
 * # sixSearchTerms
 */
angular.module('emma.theme').component('sixSearchTerms', {
  restrict: 'E',
  controller: 'sixSearchTermsController',
  templateUrl: 'theme/components/templates/sixsearchterms.html',
  bindings: {
    sxList: '=',
    sxOpen: '=',
    sxId: '@',
    sxModel: '=?',
    sxFilterOnly: '=',
    sxFilter: "=",
    sxFilterDescription: "=?",
    sxFilterDescriptionLong: "=?",
    sxFilterDescriptionShort: "=?",
    sxFilterInit: "=",
    sxOnFilterChanged: "&",
    sxOnListChanged: "&",
    sxShowSelectSchema: "="
  },
  link: function postLink(scope, element, attrs) {}
});
'use strict';

/**
 * Created by Rita Beltrami on 22/06/16.
 */
angular.module('emma.theme').controller('sixTreeAttachmentsController', ["$scope", "FileUploader", "authFactory", "lookupFactory", "DATA_SET_URL", "ENV", "ALFRESCO_URL", "alfrescoFactory", function ($scope, FileUploader, authFactory, lookupFactory, DATA_SET_URL, ENV, ALFRESCO_URL, alfrescoFactory) {
  var ctrl = this;
  $scope.nodes = ctrl.nodes;
  ctrl.$doCheck = function () {
    if ($scope.sxReadonly) {
      $scope.nodes = ctrl.nodes;
    }
  };
  $scope.fullMode = angular.isUndefined(ctrl.sxFullEditor) || ctrl.sxFullEditor;
  if (angular.isDefined(ctrl.sxReadonly) && ctrl.sxReadonly) {
    $scope.sxReadonly = true;
    $scope.fullMode = false;
  } else {
    $scope.sxReadonly = false;
  }
  $scope.sxDownloadable = angular.isDefined(ctrl.sxDownloadable) && ctrl.sxDownloadable;
  $scope.sxExpanded = angular.isDefined(ctrl.sxExpanded) && ctrl.sxExpanded;
  if (angular.isUndefined(ctrl.sxTagModel)) {
    $scope.sxTagModel = 'tipoallegato';
  } else {
    $scope.sxTagModel = ctrl.sxTagModel;
  }

  //prende la specifica classe di tag se indicata tra i parametri del componente, altrimente prende solo quelli con class=_empty_
  if (angular.isUndefined(ctrl.sxTagFilter)) {
    ctrl.sxTagFilter = "class=_empty_";
  }
  var splitted = ctrl.sxTagFilter.split('=');
  $scope.tagFilterKey = splitted[0];
  $scope.tagFilterValue = splitted[1];
  $scope.tagFilter = {};
  if ($scope.tagFilterValue == "_empty_" || $scope.tagFilterValue == "") {
    $scope.tagFilter['tagFilter'] = sixFiltersLib.exact("model." + $scope.tagFilterKey, "_empty_");
    //FIXME: l'ideale sarebbe avere un'opzione vuota in OR con null, in modo da prendere anche le voci per cui una classe non è stata scelta
  } else {
    $scope.tagFilter['tagFilter'] = sixFiltersLib["in"]("model." + $scope.tagFilterKey, ["_empty_", $scope.tagFilterValue]);
  }
  if (angular.isUndefined(ctrl.sxForceCrossCommissionTag) || !ctrl.sxForceCrossCommissionTag) {
    //default, escludi cross commission sse non esistono voci ad-hoc per la commessa
    var commission = authFactory.getAuthData().info.commissions.current.code;
    var commissionFilter = {
      'excludeCrossCommission': sixFiltersLib.exact('commission', commission)
    };
    var fullFilter = Object.assign({}, $scope.tagFilter, commissionFilter);
    var query = {
      history: false,
      page: 1,
      page_size: 1000
    };
    lookupFactory(DATA_SET_URL + '/api/', 'record/' + $scope.sxTagModel + '/_lookup').search(query, fullFilter).$promise.then(function (availableTags) {
      if (availableTags.totalResults > 0) {
        $scope.tagFilter = fullFilter;
      }
    });
  }
  var defaultAttachment = {
    "id": 0,
    "title": "Documenti",
    "folder": true,
    "readonly": true,
    "nodes": []
  };
  if (angular.isUndefined(ctrl.nodes)) {
    ctrl.nodes = [];
    $scope.nodes = ctrl.nodes;
  }
  if ($scope.nodes.length == 0) {
    $scope.nodes.push(defaultAttachment);
  }

  // var DESTINATION = "/Sites/emma/documentLibrary/" + authFactory.getAuthData().info.commissions.current.code;
  var DESTINATION = '/Sites/' + ENV + '/' + authFactory.getAuthData().info.commissions.current.code;
  $scope.DOWNLOAD_URL = ALFRESCO_URL + '/api/alfresco/';
  var uploader = $scope.uploader = new FileUploader({
    url: ALFRESCO_URL + '/upload',
    formData: [{
      destination: DESTINATION
    }]
  });

  // Variabili temporanee per salvare lo stato del componente.
  $scope.opt = {
    dragEnabled: true
  };
  $scope.edit = {};
  $scope.upload = {
    show: false
  };

  // Tree tree callbacks
  $scope.treeOptions = {
    // Richiamata quando si cerca di trascinare un nodo in un punto dell'albero:
    // controlla se la destinazione può accettare il nodo
    accept: function accept(sourceNodeScope, destNodesScope) {
      var destNode = $scope.tree;
      if (destNodesScope.$nodeScope != undefined) {
        // per evitare errori nel log
        destNode = destNodesScope.$nodeScope.$modelValue;
      }
      // il nodo è ammesso se è previsto nella struttura del tree e non è già stato inserito
      return isChildAllowed(sourceNodeScope.$modelValue, destNode);
    },
    beforeDrag: function beforeDrag() {
      return $scope.isWritePermAllowed() && !$scope.sxReadonly;
    },
    dropped: function dropped() {
      //var destBrothers = event.dest.nodesScope.$modelValue;
      //sortNodes(destBrothers);
      doSave();
    }
  };

  // TODO: fixme
  function sortNodes(nodes) {
    var firstFolderIndex = -1;
    var i;
    for (i = 0; i < nodes.length; i++) {
      if (nodes[i].folder) {
        firstFolderIndex = i;
        break;
      }
    }
    if (firstFolderIndex >= 0) {
      var moveMeIndex = [];
      for (i = 0; i < nodes.length; i++) {
        if (!nodes[i].folder && i > firstFolderIndex) {
          moveMeIndex.push(i);
        }
      }
      if (moveMeIndex.length > 0) {
        var moveMeNode = [];
        var index;
        for (i = 0; i < moveMeIndex.length; i++) {
          index = moveMeIndex[i];
          moveMeNode.push(JSON.parse(JSON.stringify(nodes[index])));
        }
        for (i = moveMeIndex.length - 1; i >= 0; i--) {
          index = moveMeIndex[i];
          nodes.splice(index, 1);
        }
        for (i = 0; i < moveMeNode.length; i++) {
          nodes.splice(firstFolderIndex, 0, moveMeNode[i]);
        }
      }
    }
  }
  var isChildAllowed = function isChildAllowed(node, parent) {
    // solo le cartelle possono contenere altri nodi.
    var result = false;
    if (angular.isDefined(parent)) {
      if (parent.folder) {
        result = true;
      }
    }
    return result;
  };
  $scope.undoUpload = function () {
    $scope.upload = {
      show: false
    };
    uploader.clearQueue();
  };
  function addUploadedFileToTree(fileItem) {
    var nodeData = $scope.upload.nodeData;
    nodeData.nodes.push({
      id: nodeData.id * 10 + nodeData.nodes.length,
      title: fileItem.file.name,
      folder: false,
      readonly: false,
      user: authFactory.getAuthData().authId,
      date: new Date(),
      destination: DESTINATION,
      object_id: fileItem.objectId,
      nodes: []
    });
    doSave();
  }
  $scope.newFileNode = function (scope) {
    var nodeData = scope.$modelValue;
    $scope.upload = {
      show: true,
      started: false,
      completed: false,
      nodeData: nodeData
    };
  };
  $scope.newFolderNode = function (scope) {
    var nodeData = scope.$modelValue;
    nodeData.nodes.push({
      id: nodeData.id * 10 + nodeData.nodes.length,
      title: 'Nuova cartella ' + '.' + (nodeData.nodes.length + 1),
      folder: true,
      readonly: false,
      nodes: []
    });
    doSave();
  };
  $scope.stopEditing = function () {
    if ($scope.opt.dragEnabled == false) {
      $scope.opt.dragEnabled = true;
      $scope.edit.writeSpan.hide();
      $scope.edit.readSpan.show();
    }
  };
  $scope.renameNode = function (obj) {
    if ($scope.opt.dragEnabled == false) {
      $scope.stopEditing();
    } else {
      $scope.opt.dragEnabled = false;
      var parent = $(obj.target).parents("div:first");
      var writeSpan = parent.find('.file-title-write');
      var readSpan = parent.find('.file-title-read');
      $scope.edit.writeSpan = writeSpan;
      $scope.edit.readSpan = readSpan;
      $scope.edit.writeSpan.show();
      $scope.edit.readSpan.hide();
    }
  };
  $scope.confirmRename = function () {
    $scope.stopEditing();
    doSave();
  };
  $scope.editNodeTag = function (obj) {
    if ($scope.opt.dragEnabled == false) {
      $scope.stopEditing();
    } else {
      $scope.opt.dragEnabled = false;
      var parent = $(obj.target).parents("div:first");
      var writeSpan = parent.find('.file-tag-write');
      var readSpan = parent.find('.file-tag-read');
      $scope.edit.writeSpan = writeSpan;
      $scope.edit.readSpan = readSpan;
      $scope.edit.writeSpan.show();
      $scope.edit.readSpan.hide();
    }
  };
  $scope.confirmTag = function () {
    $scope.stopEditing();
    doSave();
  };
  $scope.removeFile = function (node, scope, index) {
    scope.remove();
    var nodeRef = $scope.transformObjectIdForBackend(node.object_id);
    alfrescoFactory["delete"]({
      id: nodeRef
    });
    ctrl.nodes.splice(index, 1);
    doSave();
  };
  $scope.removeFolder = function (scope, node, index) {
    $scope.emptyFolder(scope, false);
    scope.remove();
    doSave();
  };
  $scope.emptyFolder = function (scope, mustSave) {
    var nodeData = scope.$modelValue;
    loopRemoveFiles(nodeData.nodes);
    nodeData.nodes = [];
    if (mustSave) {
      doSave();
    }
  };
  function loopRemoveFiles(nodes) {
    nodes.forEach(function (node) {
      if (node.object_id) {
        var nodeRef = $scope.transformObjectIdForBackend(node.object_id);
        alfrescoFactory["delete"]({
          id: nodeRef
        });
      }
      if (node.nodes.length) loopRemoveFiles(node.nodes);
    });
  }
  function doSave() {
    ctrl.nodes = $scope.nodes;
    ctrl.saveCallback();
  }
  function printUploadError(errorMessage) {
    if (angular.isUndefined($scope.upload.errors)) {
      $scope.upload.errors = [];
    }
    $scope.upload.errors.push(errorMessage);
  }
  $scope.transformObjectIdForBackend = function (objectId) {
    return objectId.replace('workspace://SpacesStore/', '$WorkspaceSpacesStore$');
  };

  /** ***********************************
  * Check permissions
  * ***********************************/

  var RESOURCE_NAME = 'tree';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };

  /** ***********************************
   * Uploader callbacks
   * ***********************************/
  uploader.onWhenAddingFileFailed = function (item /*{File|FileLikeObject}*/, filter, options) {
    console.info('onWhenAddingFileFailed', item, filter, options);
  };
  uploader.onAfterAddingFile = function (fileItem) {
    $scope.upload.completed = false;
    $scope.upload.started = false;
    console.info('onAfterAddingFile', fileItem);
  };
  uploader.onAfterAddingAll = function (addedFileItems) {
    $scope.upload.completed = false;
    $scope.upload.started = false;
    console.info('onAfterAddingAll', addedFileItems);
  };
  uploader.onBeforeUploadItem = function (item) {
    $scope.upload.started = true;
    console.info('onBeforeUploadItem', item);
  };
  uploader.onProgressItem = function (fileItem, progress) {
    console.info('onProgressItem', fileItem, progress);
  };
  uploader.onProgressAll = function (progress) {
    console.info('onProgressAll', progress);
  };
  uploader.onSuccessItem = function (fileItem, response, status, headers) {
    if (angular.isDefined(response.ERROR)) {
      printUploadError(response.ERROR);
    } else {
      fileItem.objectId = response.objectId;
      addUploadedFileToTree(fileItem);
    }
    console.info('onSuccessItem', fileItem, response, status, headers);
  };
  uploader.onErrorItem = function (fileItem, response, status, headers) {
    printUploadError("Errore nel caricamento del file " + fileItem.file.name);
    console.info('onErrorItem', fileItem, response, status, headers);
  };
  uploader.onCancelItem = function (fileItem, response, status, headers) {
    console.info('onCancelItem', fileItem, response, status, headers);
  };
  uploader.onCompleteItem = function (fileItem, response, status, headers) {
    console.info('onCompleteItem', fileItem, response, status, headers);
  };
  uploader.onCompleteAll = function () {
    $scope.upload.completed = true;
    console.info('onCompleteAll');
  };
}]);
'use strict';

/**
 * Created by Rita Beltrami on 22/06/16.
 * @ngdoc component
 * @name emma.theme.component:sixTreeAttachments
 * @description
 * # sixTreeAttachments
 */
angular.module('emma.theme').component('sixTreeAttachments', {
  restrict: 'E',
  controller: 'sixTreeAttachmentsController',
  templateUrl: 'theme/components/templates/sixtreeattachments.html',
  bindings: {
    saveCallback: '&',
    sxFullEditor: '=?',
    //default attivo
    sxReadonly: '=?',
    //default disattivo
    sxDownloadable: '=?',
    //ha effetto solo con sxReadonly attivo, default disattivo
    sxExpanded: '=?',
    //default disattivo, indica se espandere tutti i nodi all'apertura
    nodes: '=',
    sxForceCrossCommissionTag: '=?',
    //obbliga a mostrare anche i tag cross-commessa (default: false)
    sxTagModel: '=?',
    //permette di utilizzare un modello diverso per la tipologia allegato (default: "tipoallegato")
    sxTagFilter: '=?' //permette di filtrare le voci in base a un campo del modello. (default: "class=_empty_")
    //Formato: "chiave=valore", la stringa "_empty_" è considerata come assenza del valore
  },

  link: function postLink(scope, element, attrs) {}
});
'use strict';

angular.module('emma.theme').controller('timeSpanPickerCtrl', ["$scope", "$log", "$timeout", "$document", "$filter", function ($scope, $log, $timeout, $document, $filter) {
  /**
   * VARIABILI
   */
  var ctrl = this;
  ctrl.current = moment();
  ctrl.local_start;
  ctrl.local_end;
  ctrl.startForm = {
    startTimeInput: {
      error: {
        time: false,
        missingField: true
      }
    }
  };
  ctrl.endForm = {
    endTimeInput: {
      error: {
        time: false,
        missingField: true
      }
    }
  };

  /**
   * FUNZIONI
   */
  ctrl.onInit = function () {
    //Converto inizio e fine in formato moment() se già non lo sono.
    if (ctrl.start && ctrl.start._isAMomentObject) {
      ctrl.startForm.startTimeInput.error.missingField = false;
      ctrl.local_start = new Date(ctrl.start.year(), ctrl.start.month(), ctrl.start.date(), ctrl.start.hours(), ctrl.start.minutes());
    } else if (ctrl.start && !ctrl.start._isAMomentObject) {
      ctrl.startForm.startTimeInput.error.missingField = false;
      ctrl.start = moment(ctrl.start);
      ctrl.local_start = new Date(ctrl.start.year(), ctrl.start.month(), ctrl.start.date(), ctrl.start.hours(), ctrl.start.minutes());
    }
    if (ctrl.end && ctrl.end._isAMomentObject) {
      ctrl.endForm.endTimeInput.error.missingField = false;
      ctrl.local_end = new Date(ctrl.end.year(), ctrl.end.month(), ctrl.end.date(), ctrl.end.hours(), ctrl.end.minutes()); // alternativa a ctrl.end.toDate(); spacca l'integrazione con l'input di angularJS
    } else if (ctrl.end && !ctrl.end._isAMomentObject) {
      ctrl.endForm.endTimeInput.error.missingField = false;
      ctrl.end = moment(ctrl.end);
      ctrl.local_end = new Date(ctrl.end.year(), ctrl.end.month(), ctrl.end.date(), ctrl.end.hours(), ctrl.end.minutes());
    }
    if (ctrl.start && ctrl.end) {
      if (_checkTime('start', ctrl.start)) {
        _updateValid('start', 'time', false);
      } else {
        _updateValid('start', 'time', true);
      }
      if (_checkTime('end', ctrl.end)) {
        _updateValid('end', 'time', false);
      } else {
        _updateValid('end', 'time', true);
      }
    }
    _updateParentScopeValidation();
  };

  // Update orario
  ctrl.changeTime = function (type) {
    switch (type) {
      case 'start':
        var tmp_start = moment(ctrl.local_start);
        ctrl.start = moment(ctrl.local_start);
        if (ctrl.local_start && tmp_start && tmp_start.isValid()) {
          _updateValid('start', 'missingField', false);
          if (_checkTime('start', tmp_start)) {
            _updateValid('start', 'time', false);
          } else {
            _updateValid('start', 'time', true);
          }
        } else {
          _updateValid('start', 'missingField', true);
        }
        ctrl.callbackStart();
        break;
      case 'end':
        var tmp_end = moment(ctrl.local_end);
        ctrl.end = moment(ctrl.local_end);
        if (ctrl.local_end && tmp_end && tmp_end.isValid()) {
          _updateValid('end', 'missingField', false);
          if (_checkTime('end', tmp_end)) {
            _updateValid('end', 'time', false);
          } else {
            _updateValid('end', 'time', true);
          }
        } else {
          _updateValid('end', 'missingField', true);
        }
        ctrl.callbackEnd();
        break;
      default:
        break;
    }
    ctrl.callbackAll();
  };

  /**
   * UTILITY
   */

  function _checkTime(type, date) {
    if (ctrl.end && ctrl.start) {
      return type === 'start' && (date.hours() < ctrl.end.hours() || date.hours() === ctrl.end.hours() && date.minutes() <= ctrl.end.minutes()) || type === 'end' && (date.hours() > ctrl.start.hours() || date.hours() === ctrl.start.hours() && date.minutes() >= ctrl.start.minutes());
    } else {
      return true;
    }
  }
  function _updateValid(type, err, bool) {
    if (err === 'missingField') {
      if (type == 'start') {
        ctrl.startForm.startTimeInput.error[err] = bool;
      }
      if (type === 'end') {
        ctrl.endForm.endTimeInput.error[err] = bool;
      }
    } else {
      ctrl.startForm.startTimeInput.error[err] = bool;
      ctrl.endForm.endTimeInput.error[err] = bool;
    }
    _updateParentScopeValidation();
  }
  function _updateParentScopeValidation() {
    var isValid = !ctrl.endForm.endTimeInput.error.missingField && !ctrl.endForm.endTimeInput.error.time && !ctrl.startForm.startTimeInput.error.missingField && !ctrl.startForm.startTimeInput.error.time;
    //$scope.$parent.isTimeSpanValid = isValid;
    //TOOO handle callback
    if (angular.isFunction(ctrl.validateChange)) {
      ctrl.validateChange({
        isValid: isValid
      });
    }
  }

  /**
   * CALLBACKS
   */

  // Callback al cambio del tempo iniziale
  ctrl.callbackStart = function () {
    if (angular.isFunction(ctrl.onChangeStart)) {
      $timeout(function () {
        ctrl.onChangeStart();
      });
    }
  };

  // Callback al cambio del tempo finale
  ctrl.callbackEnd = function () {
    if (angular.isFunction(ctrl.onChangeEnd)) {
      $timeout(function () {
        ctrl.onChangeEnd();
      });
    }
  };

  // Callback chiamata su qualsiasi cambiamento
  ctrl.callbackAll = function () {
    if (angular.isFunction(ctrl.onChange)) {
      $timeout(function () {
        ctrl.onChange();
      });
    }
  };

  /**
   * MAIN
   */
  ctrl.onInit();
}]);

/**
 * @ngdoc directive
 * @name emma.theme.directive:timeSpanPicker
 * @description
 * # timeSpanPicker
 */
angular.module('emma.theme').component('timeSpanPicker', {
  transclude: true,
  controller: 'timeSpanPickerCtrl',
  templateUrl: 'theme/components/templates/timespanpicker.html',
  restrict: 'E',
  bindings: {
    start: '=',
    // moment o formato convertibile in "moment"
    end: '=',
    // moment o formato convertibile in "moment"
    validateChange: '&?',
    onChange: '&?',
    //callback al cambiamento di un valore qualsiasi
    onChangeStart: '&?',
    //callback al cambiamento di start
    onChangeEnd: '&?' // callback al cambiamento di end
  }
});
'use strict';

/**
 * @ngdoc function
 * @name myNewProjectApp.controller:MainCtrl
 * @description
 * # MainCtrl
 * Controller of the myNewProjectApp
 */
angular.module('emma.theme').controller('AppCtrl', ["$scope", "$rootScope", "$location", "$http", "authFactory", "dialogService", "moduleInfoFactory", "ENV", "APP_NAME", "TITLE", "CAPTION", function ($scope, $rootScope, $location, $http, authFactory, dialogService, moduleInfoFactory, ENV, APP_NAME, TITLE, CAPTION) {
  if (window.appCtrlFix) return;
  window.appCtrlFix = true;
  $scope.logout = function () {
    authFactory.logout();
    $location.path("/login");
  };
  $scope.app = {
    name: APP_NAME,
    title: TITLE,
    caption: CAPTION,
    version: '4.0.0',
    bestemmia: 'yes',
    showCommissions: true,
    showNotifications: true,
    // for chart colors
    color: {
      primary: '#7266ba',
      info: '#23b7e5',
      success: '#27c24c',
      warning: '#fad733',
      danger: '#f05050',
      light: '#e8eff0',
      dark: '#3a3f51',
      black: '#1c2b36'
    },
    settings: {
      themeID: 1,
      navbarHeaderColor: 'bg-black',
      navbarCollapseColor: 'bg-white-only',
      asideColor: 'bg-black',
      headerFixed: true,
      asideFixed: false,
      asideFolded: true,
      asideDock: false,
      container: false
    },
    notifications: {
      link: "#/notification"
    },
    profileCustomer: false,
    homepage: ENV
  };
  $rootScope.isSidebarOpen = !$scope.app.settings.asideFolded;
  $scope.profileItems = [{
    type: 'commission',
    icon: 'fa fa-money',
    label: 'Commessa'
  }, {
    type: 'customer',
    icon: 'fa fa-user',
    label: 'Cliente'
  }];
  $scope.$watch('app.settings', function () {
    if ($scope.app.settings.asideDock && $scope.app.settings.asideFixed) {
      // aside dock and fixed must set the header fixed.
      $scope.app.settings.headerFixed = true;
    }
    // save to local storage
    //$localStorage.settings = $scope.app.settings;
  }, true);

  // angular translate
  $scope.lang = {
    isopen: false
  };
  $scope.langs = {
    en: 'English',
    de_DE: 'German',
    it_IT: 'Italian'
  };
  //$scope.selectLang = $scope.langs[$translate.proposedLanguage()] || "English";
  $scope.selectLang = "Italian";
  $scope.setLang = function (langKey, $event) {
    // set the current lang
    $scope.selectLang = $scope.langs[langKey];
    // You can change the language during runtime
    //$translate.use(langKey);
    $scope.lang.isopen = !$scope.lang.isopen;
  };
  function isSmartDevice($window) {
    // Adapted from http://www.detectmobilebrowsers.com
    var ua = $window['navigator']['userAgent'] || $window['navigator']['vendor'] || $window['opera'];
    // Checks for iOs, Android, Blackberry, Opera Mini, and Windows mobile devices
    return /iPhone|iPod|iPad|Silk|Android|BlackBerry|Opera Mini|IEMobile/.test(ua);
  }
  $scope.getPermission = function () {
    if (authFactory.getAuthData()) {
      var permission = authFactory.getAuthData().authPermission;
      return 'ICTUser' === permission || 'ICTAdmin' === permission || 'EMAdmin' === permission || 'SuperAdmin' === permission || 'Admin' === permission || 'emma-SuperAdmin' === permission || 'asset-SuperAdmin' === permission || 'consip-SuperAdmin' === permission || 'emma-Admin' === permission || 'asset-Admin' === permission || 'consip-Admin' === permission;
    }
    return false;
  };

  // VERSIONING

  $rootScope.frontEndInfo = {};
  $scope.loadFrontEndInfo = function () {
    $rootScope.frontEndInfo = {
      title: 'EMMA FrontEnd',
      vendor: 'it.ictgroup',
      version: '-',
      revision: '-',
      builddate: '-',
      builprofile: '-',
      cipipelineid: '-',
      cibuildid: '-'
    };
    $http.get('meta/manifest.json').then(function (response) {
      // success
      if (!response.status || response.status == 200) {
        $rootScope.frontEndInfo = response.data;
        $scope.app.version = response.data.version;
        if ($rootScope.frontEndInfo) {
          getModuleInfo($rootScope.frontEndInfo.installedmodules);
        }
      }
    });
  };
  $scope.modulesInfo = {};
  function getModuleInfo(modules) {
    modules.forEach(function (module) {
      var api = 'api';
      if (module == 'six') {
        api = 'rest';
      }
      moduleInfoFactory(module, api).info().$promise.then(function (response) {
        $scope.modulesInfo[module] = response;
      });
    });
  }
  $scope.loadFrontEndInfo();
  $scope.showVersion = function () {
    var dialogScope = {
      modulesInfo: $scope.modulesInfo,
      frontEndInfo: $rootScope.frontEndInfo
    };
    var opts = {
      name: 'modulesInfoDialog',
      closeByDocument: true,
      plain: false
    };
    dialogService.templateDialog('modulesInfo.html', dialogService.DIALOG_TYPE.INFO, dialogScope, opts, -1, false, '500px');
  };
}]);
'use strict';

/* Controllers */
var app = angular.module('emma.theme');
// bootstrap controller
app.controller('AccordionDemoCtrl', ['$scope', function ($scope) {
  $scope.oneAtATime = true;
  $scope.groups = [{
    title: 'Accordion group header - #1',
    content: 'Dynamic group body - #1'
  }, {
    title: 'Accordion group header - #2',
    content: 'Dynamic group body - #2'
  }];
  $scope.items = ['Item 1', 'Item 2', 'Item 3'];
  $scope.addItem = function () {
    var newItemNo = $scope.items.length + 1;
    $scope.items.push('Item ' + newItemNo);
  };
  $scope.status = {
    isFirstOpen: true,
    isFirstDisabled: false
  };
}]);
app.controller('AlertDemoCtrl', ['$scope', function ($scope) {
  $scope.alerts = [{
    type: 'success',
    msg: 'Well done! You successfully read this important alert message.'
  }, {
    type: 'info',
    msg: 'Heads up! This alert needs your attention, but it is not super important.'
  }, {
    type: 'warning',
    msg: 'Warning! Best check yo self, you are not looking too good...'
  }];
  $scope.addAlert = function () {
    $scope.alerts.push({
      type: 'danger',
      msg: 'Oh snap! Change a few things up and try submitting again.'
    });
  };
  $scope.closeAlert = function (index) {
    $scope.alerts.splice(index, 1);
  };
}]);
app.controller('ButtonsDemoCtrl', ['$scope', function ($scope) {
  $scope.singleModel = 1;
  $scope.radioModel = 'Middle';
  $scope.checkModel = {
    left: false,
    middle: true,
    right: false
  };
}]);
app.controller('CarouselDemoCtrl', ['$scope', function ($scope) {
  $scope.myInterval = 5000;
  var slides = $scope.slides = [];
  $scope.addSlide = function () {
    slides.push({
      image: 'img/c' + slides.length + '.jpg',
      text: ['Carousel text #0', 'Carousel text #1', 'Carousel text #2', 'Carousel text #3'][slides.length % 4]
    });
  };
  for (var i = 0; i < 4; i++) {
    $scope.addSlide();
  }
}]);
app.controller('DropdownDemoCtrl', ['$scope', function ($scope) {
  $scope.items = ['The first choice!', 'And another choice for you.', 'but wait! A third!'];
  $scope.status = {
    isopen: false
  };
  $scope.toggled = function (open) {
    //console.log('Dropdown is now: ', open);
  };
  $scope.toggleDropdown = function ($event) {
    $event.preventDefault();
    $event.stopPropagation();
    $scope.status.isopen = !$scope.status.isopen;
  };
}]);
app.controller('ModalInstanceCtrl', ['$scope', '$modalInstance', 'items', function ($scope, $modalInstance, items) {
  $scope.items = items;
  $scope.selected = {
    item: $scope.items[0]
  };
  $scope.ok = function () {
    $modalInstance.close($scope.selected.item);
  };
  $scope.cancel = function () {
    $modalInstance.dismiss('cancel');
  };
}]);
app.controller('ModalDemoCtrl', ['$scope', '$modal', '$log', function ($scope, $modal, $log) {
  $scope.items = ['item1', 'item2', 'item3'];
  $scope.open = function (size) {
    var modalInstance = $modal.open({
      templateUrl: 'myModalContent.html',
      controller: 'ModalInstanceCtrl',
      size: size,
      resolve: {
        items: function items() {
          return $scope.items;
        }
      }
    });
    modalInstance.result.then(function (selectedItem) {
      $scope.selected = selectedItem;
    }, function () {
      $log.info('Modal dismissed at: ' + new Date());
    });
  };
}]);
app.controller('PaginationDemoCtrl', ['$scope', '$log', function ($scope, $log) {
  $scope.totalItems = 64;
  $scope.currentPage = 4;
  $scope.setPage = function (pageNo) {
    $scope.currentPage = pageNo;
  };
  $scope.pageChanged = function () {
    $log.info('Page changed to: ' + $scope.currentPage);
  };
  $scope.maxSize = 5;
  $scope.bigTotalItems = 175;
  $scope.bigCurrentPage = 1;
}]);
app.controller('PopoverDemoCtrl', ['$scope', function ($scope) {
  $scope.dynamicPopover = 'Hello, World!';
  $scope.dynamicPopoverTitle = 'Title';
}]);
app.controller('ProgressDemoCtrl', ['$scope', function ($scope) {
  $scope.max = 200;
  $scope.random = function () {
    var value = Math.floor(Math.random() * 100 + 1);
    var type;
    if (value < 25) {
      type = 'success';
    } else if (value < 50) {
      type = 'info';
    } else if (value < 75) {
      type = 'warning';
    } else {
      type = 'danger';
    }
    $scope.showWarning = type === 'danger' || type === 'warning';
    $scope.dynamic = value;
    $scope.type = type;
  };
  $scope.random();
  $scope.randomStacked = function () {
    $scope.stacked = [];
    var types = ['success', 'info', 'warning', 'danger'];
    for (var i = 0, n = Math.floor(Math.random() * 4 + 1); i < n; i++) {
      var index = Math.floor(Math.random() * 4);
      $scope.stacked.push({
        value: Math.floor(Math.random() * 30 + 1),
        type: types[index]
      });
    }
  };
  $scope.randomStacked();
}]);
app.controller('TabsDemoCtrl', ['$scope', function ($scope) {
  $scope.tabs = [{
    title: 'Dynamic Title 1',
    content: 'Dynamic content 1'
  }, {
    title: 'Dynamic Title 2',
    content: 'Dynamic content 2',
    disabled: true
  }];
}]);
app.controller('RatingDemoCtrl', ['$scope', function ($scope) {
  $scope.rate = 7;
  $scope.max = 10;
  $scope.isReadonly = false;
  $scope.hoveringOver = function (value) {
    $scope.overStar = value;
    $scope.percent = 100 * (value / $scope.max);
  };
}]);
app.controller('TooltipDemoCtrl', ['$scope', function ($scope) {
  $scope.dynamicTooltip = 'Hello, World!';
  $scope.dynamicTooltipText = 'dynamic';
  $scope.htmlTooltip = 'I\'ve been made <b>bold</b>!';
}]);
app.controller('TypeaheadDemoCtrl', ['$scope', '$http', function ($scope, $http) {
  $scope.selected = undefined;
  $scope.states = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Dakota', 'North Carolina', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];
  // Any function returning a promise object can be used to load values asynchronously
  $scope.getLocation = function (val) {
    return $http.get('http://maps.googleapis.com/maps/api/geocode/json', {
      params: {
        address: val,
        sensor: false
      }
    }).then(function (res) {
      var addresses = [];
      angular.forEach(res.data.results, function (item) {
        addresses.push(item.formatted_address);
      });
      return addresses;
    });
  };
}]);
app.controller('DatepickerDemoCtrl', ['$scope', function ($scope) {
  $scope.today = function () {
    $scope.dt = new Date();
  };
  $scope.today();
  $scope.clear = function () {
    $scope.dt = null;
  };

  // Disable weekend selection
  $scope.disabled = function (date, mode) {
    return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
  };
  $scope.toggleMin = function () {
    $scope.minDate = $scope.minDate ? null : new Date();
  };
  $scope.toggleMin();
  $scope.open = function ($event) {
    $event.preventDefault();
    $event.stopPropagation();
    $scope.opened = true;
  };
  $scope.dateOptions = {
    formatYear: 'yy',
    startingDay: 1,
    "class": 'datepicker'
  };
  $scope.initDate = new Date('2016-15-20');
  $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
  $scope.format = $scope.formats[0];
}]);
app.controller('TimepickerDemoCtrl', ['$scope', function ($scope) {
  $scope.mytime = new Date();
  $scope.hstep = 1;
  $scope.mstep = 15;
  $scope.options = {
    hstep: [1, 2, 3],
    mstep: [1, 5, 10, 15, 25, 30]
  };
  $scope.ismeridian = true;
  $scope.toggleMode = function () {
    $scope.ismeridian = !$scope.ismeridian;
  };
  $scope.update = function () {
    var d = new Date();
    d.setHours(14);
    d.setMinutes(0);
    $scope.mytime = d;
  };
  $scope.changed = function () {
    //console.log('Time changed to: ' + $scope.mytime);
  };
  $scope.clear = function () {
    $scope.mytime = null;
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name myNewProjectApp.controller:MainCtrl
 * @description
 * # MainCtrl
 * Controller of the myNewProjectApp
 */
angular.module('emma.theme').controller('MainCtrl', ["$scope", "$location", function ($scope, $location) {
  // redirecting to the right dashboard
  $location.path($scope.app.homepage);
}]);
'use strict';

/**
 * @ngdoc function
 * @author Rita Beltrami 29/04/2016
 * @name emma.theme.controller:NoticeCtrl
 * @description
 * # NotificationCtrl
 * Controller to display notifications.
 */
angular.module('emma.theme').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/notification', {
    templateUrl: 'theme/notification/notification_list.html',
    controller: 'NotificationCtrl'
  }).when('/notification/:id', {
    templateUrl: 'theme/notification/notification_detail.html',
    controller: 'NotificationCtrl'
  });
}]).controller('NotificationCtrl', ["$scope", "$log", "notificationFactory", "$routeParams", "$location", function ($scope, $log, notificationFactory, $routeParams, $location) {
  $scope.notifications;
  $scope.data;
  $scope.currentPage = 1;
  $scope.pageSize = 10;
  $scope.ISSUE_INDEX = "six_issue";
  $scope.ODL_INDEX = "six_odl";
  function setBodyText(notification) {
    var model = notification.model;
    if (angular.isDefined(model)) {
      var bodyHtml = model.body;
      if (angular.isDefined(bodyHtml)) {
        bodyHtml = "<div>" + bodyHtml + "</div>";
        var bodyText = $(bodyHtml).text();
        model.bodyAsText = bodyText;
      }
    }
  }
  function setColor(notification) {
    var model = notification.model;
    if (angular.isDefined(model) && angular.isDefined(model.record_id) && model.record_id !== null) {
      if (angular.isUndefined(model.record_id.index)) {
        notification.color = 'b-l-light';
      } else {
        var index = "";
        index = model.record_id.index;
        if (angular.equals(index, $scope.ISSUE_INDEX)) {
          notification.color = 'b-l-primary';
        } else if (angular.equals(index, $scope.ODL_INDEX)) {
          notification.color = 'b-l-warning';
        }
      }
    }
  }
  function setHref(notification) {
    notification.href = "#/notification/" + notification.version;
  }
  $scope.getNotificationsList = function () {
    if ($scope.app.homepage == 'asset') {
      var payload = {
        page: $scope.currentPage,
        pageSize: $scope.pageSize
      };
      notificationFactory().getList(payload).$promise.then(function (data) {
        $log.info(data);
        $scope.data = data;
        $scope.notifications = data.list;
        for (var i = 0; i < $scope.notifications.length; i++) {
          var notification = $scope.notifications[i];
          setBodyText(notification);
          setColor(notification);
          setHref(notification);
        }
      });
    }
  };
  $scope.getNotificationById = function (id) {
    var payload = {
      id: id
    };
    notificationFactory().getEmailById(payload).$promise.then(function (data) {
      $log.info(data);
      $scope.notification = data.email;
    });
  };
  $scope.goToIssue = function () {
    $location.path('issue/' + $scope.notification.model.record_id.UUID);
  };
  $scope.goToOdl = function () {
    $location.path('odl/' + $scope.notification.model.record_id.UUID);
  };
  $scope.goToWysiwyg = function () {
    $location.path('wysiwyg');
  };
  $scope.pageChanged = function () {
    $scope.getNotificationsList();
  };

  //__main__
  if ($routeParams.id) {
    $scope.getNotificationById($routeParams.id);
  } else {
    $scope.getNotificationsList();
  }
}]);
'use strict';

/**
 * @ngdoc function
 * @name emma.theme.controller:WysiwygCtrl
 * @description
 * # WysiwygCtrl
 * Controller of the emma.theme
 */
angular.module('emma.theme').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/wysiwyg', {
    templateUrl: 'theme/wysiwyg.html',
    controller: 'WysiwygCtrl'
  });
}]).controller('WysiwygCtrl', ["$scope", function ($scope) {}]);
'use strict';

/**
 * @ngdoc directive
 * @name myNewProjectApp.directive:back
 * @description
 * # back
 */
angular.module('emma.theme').directive('back', ["$window", function ($window) {
  return {
    restrict: 'A',
    link: function link(scope, elem, attrs) {
      elem.bind('click', function () {
        $window.history.back();
      });
    }
  };
}]);
'use strict';

/**
 * @ngdoc directive
 * @name myNewProjectApp.directive:confirmClick
 * @description
 * # confirmClick
 * A generic confirmation for risky actions.
 * Usage: Add attributes:
 * * ng-confirm-message="Are you sure?"
 * * ng-confirm-click="takeAction()" function
 * * ng-confirm-condition="mustBeEvaluatedToTrueForTheConfirmBoxBeShown" expression
 */
angular.module('emma.theme').directive('ngConfirmClick', function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      element.bind('click', function () {
        var condition = scope.$eval(attrs.ngConfirmCondition);
        if (condition) {
          var message = attrs.ngConfirmMessage;
          if (message && confirm(message)) {
            scope.$apply(attrs.ngConfirmClick);
          }
        } else {
          scope.$apply(attrs.ngConfirmClick);
        }
      });
    }
  };
});
"use strict";

/**
 * Created by stefano on 15/12/16.
 */

angular.module('emma.theme').directive("dateValidation", ["$log", "$q", function ($log, $q) {
  return {
    restrict: "A",
    replace: false,
    require: "ngModel",
    link: function link($scope, $element, $attrs, ctrl) {
      ctrl.$parsers.unshift(checkDate);
      ctrl.$formatters.unshift(checkDate);
      function checkDate(value) {
        var valid = angular.isDate(value);
        $log.log(valid);
        if (valid) {
          ctrl.$setValidity('date', true);
        } else {
          ctrl.$setValidity('date', false);
        }
        return value;
      }
      ctrl.$validators.temporal = function (modelValue, viewValue) {
        var valid = true;
        if ($attrs.isBefore) {
          var beforeDate = new Date($attrs.isBefore.replace(/"/g, ''));
          if (angular.isDate(beforeDate)) {
            valid = valid && modelValue.getTime() <= beforeDate.getTime();
          }
        }
        if ($attrs.isAfter) {
          var afterDate = new Date($attrs.isAfter.replace(/"/g, ''));
          if (angular.isDate(afterDate)) {
            valid = valid && modelValue.getTime() >= afterDate.getTime();
          }
        }
        return valid;
      };
    }
  };
}]);
"use strict";

angular.module('emma.theme').directive('setNgAnimate', ['$animate', function ($animate) {
  return {
    link: function link($scope, $element, $attrs) {
      $scope.$watch(function () {
        return $scope.$eval($attrs.setNgAnimate, $scope);
      }, function (valnew, valold) {
        $animate.enabled(!!valnew, $element);
      });
    }
  };
}]);
'use strict';

angular.module('emma.theme').directive('sixAttachments', ['$log', '$window', function ($log, $window) {
  return {
    template: '<iframe ng-src="{{ url | trustAsResourceUrl }}" width="100%" height="1024px" style="border: none;"></iframe>',
    restrict: 'E',
    controller: ["$scope", function controller($scope) {
      var BASE = '/six/app/#/statix?path=';
      $scope.url = '';
      refreshUrl($scope.path);
      console.log($scope.path);
      console.log($scope.url);
      $scope.$watch(function () {
        return $scope.path;
      }, function (newVal, oldVal) {
        refreshUrl($scope.path);
        $log.log($scope.url);
      });
      function refreshUrl(path) {
        $scope.url = BASE + path;
      }
    }],
    /*link: function(scope, element, attrs) {
      element.on('load', function(){
        // var iFrameHeight = element[0].contentWindow.document.body.scrollHeight + 'px';
        var iFrameHeight = $window.innerHeight + 'px';
        var iFrameWidth = '100%';
        element.css('width', iFrameWidth);
        element.css('height', iFrameHeight);
        $log.log('iFrameHeight = ' + iFrameHeight);
        $log.log('iFrameWidth = ' + iFrameWidth);
      })
    },*/
    scope: {
      path: '='
    }
  };
}]);
'use strict';

angular.module('emma.theme').directive('sixCalendar', function () {
  return {
    restrict: 'E',
    template: '<div></div>',
    scope: {
      calendar: '=',
      register: '&?'
    },
    link: function link(scope, el, atts) {
      scope.calendar.api = el.children().calendar(scope.calendar);
      var api = scope.calendar.api;
      if (angular.isDefined(scope.register)) {
        scope.register({
          $api: api
        });
      }
    }
  };
});
'use strict';

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixSelect
 * @description
 * # sixSelect
 */
angular.module('emma.theme').directive('sixConsipTimingLed', function () {
  return {
    template: '<i class="fa fa-circle text-muted m-r-xs m-l-sm" ng-if="sxValue==0" ng-attr-title="{{sxDescription}}"></i>' + '<i class="fa fa-circle text-success m-r-xs m-l-sm" ng-if="sxValue==1" ng-attr-title="{{sxDescription}}"></i>' + '<i class="fa fa-circle text-warning m-r-xs m-l-sm" ng-if="sxValue==2" ng-attr-title="{{sxDescription}}"></i>' + '<i class="fa fa-circle text-danger m-r-xs m-l-sm" ng-if="sxValue==3" ng-attr-title="{{sxDescription}}"></i>',
    restrict: 'E',
    scope: {
      sxValue: '=',
      sxDescription: '=?'
    }
  };
});
'use strict';

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixCopy
 * @description
 * # sixcopy
 *
 * Parametri della iteratorCopy:
 * scKey: campo per il binding
 * scDuplicate: destinazioni dove copiare i valori dalla 'key'
 * scModel: modello alla quale agganciare la $watch
 * scDoc: variabile contenente il documento dove andare a copiare il valore di destinazione -> bisogna specificare in value.copyTo l'indirizzo completo
 *
 */
angular.module('emma.theme').directive('sixCopy', function () {
  return {
    template: '<div></div>',
    scope: {
      scKey: '=',
      scDuplicate: '=',
      scModel: '=',
      scDoc: '='
    },
    restrict: 'E',
    link: function postLink(scope, log, element, attrs) {
      Object.navDocByString = function (o, s) {
        s = s.replace(/\[(\w+)\]/g, '.$1');
        s = s.replace(/^\./, '');
        var a = s.split('.');
        for (var i = 0, n = a.length - 1; i < n; ++i) {
          var k = a[i];
          if (k in o) {
            o = o[k];
          } else {
            return;
          }
        }
        return o;
      };
      function fieldToFill(path) {
        var a = path.split('.');
        var fieldToFill = a[a.length - 1];
        return fieldToFill;
      }
      scope.$watch(function () {
        return scope.scModel[scope.scKey];
      }, function () {
        if (angular.isDefined(scope.scModel[scope.scKey])) {
          if (angular.isDefined(scope.scDuplicate)) {
            angular.forEach(scope.scDuplicate, function (value) {
              Object.navDocByString(scope.scDoc, value)[fieldToFill(value)] = scope.scModel[scope.scKey];
            });
          }
        }
      });
    }
  };
});
'use strict';

/*

 http://bl.ocks.org/dbuezas/9306799
 */
angular.module('emma.theme').controller('sixDonutChartCtrl', ['$scope', '$log', '$timeout', function ($scope, $log, $timeout) {
  $scope.sxXAxisFormat = $scope.sxXAxisFormat || '%B';
  $scope.sxXAxisTicks = $scope.sxXAxisTicks || undefined;
  $scope.sxInterpolate = $scope.sxInterpolate || 'monotone';
  $scope.sxShowPoints = $scope.sxShowPoints || false;
  $scope.sxChartType = $scope.sxChartType || 'line';
  $scope.sxChartWidth = $scope.sxChartWidth || 460;
  $scope.sxChartHeight = $scope.sxChartHeight || 300;
  $scope.sxChartRatio = $scope.sxChartHeight / $scope.sxChartWidth * 100;
  $scope.sxHideLabels = $scope.sxHideLabels || false;
  $scope.showGraph = function () {
    var donutSelector = '#donutGraph' + $scope.sxId;
    if (!document.getElementById('donutGraph' + $scope.sxId)) {
      console.log(donutSelector + ' still undefined'); //se viene invocata troppo presto
      return;
    }
    var svg = d3.select(donutSelector).append("svg").attr('viewBox', '0 0 ' + $scope.sxChartWidth + ' ' + $scope.sxChartHeight).append("g");
    $scope.svg = svg;
    svg.append("g").attr("class", "slices");
    svg.append("g").attr("class", "labels");
    svg.append("g").attr("class", "lines");
    var spacingDivider = $scope.sxHideLabels ? 2 : 4;
    var width = $scope.sxChartWidth,
      height = $scope.sxChartHeight,
      radius = Math.min(width, height) / spacingDivider;
    $scope.radius = radius;
    var pie = d3.layout.pie().sort(null).value(function (d) {
      return d.value;
    });
    $scope.pie = pie;
    var arc = d3.svg.arc().outerRadius(radius * 0.8).innerRadius(0);
    $scope.arc = arc;
    var outerArc = d3.svg.arc().innerRadius(radius * 0.9).outerRadius(radius * 0.9);
    $scope.outerArc = outerArc;
    svg.attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");
    var key = function key(d) {
      return d.data.label;
    };
    $scope.key = key;
    var color = d3.scale.ordinal().domain(["Metano", "Elettricità", "Gpl", "Gasolio", "Totale", "elit", "sed", "do", "eiusmod", "tempor", "incididunt"]).range(["#98abc5", "#8a89a6", "#7b6888", "#6b486b", "#e4eaec", "#d0743c", "#ff8c00"]);
    $scope.color = color;
    function randomData() {
      var labels = color.domain();
      return labels.map(function (label) {
        return {
          label: label,
          value: Math.random()
        };
      });
    }
    $scope.change($scope.sxGraphData);
    d3.select(".randomize").on("click", function () {
      $scope.change(randomData());
    });
  };
  $scope.change = function (data) {
    /* ------- PIE SLICES -------*/
    var slice = $scope.svg.select(".slices").selectAll("path.slice").data($scope.pie(data), $scope.key);
    slice.enter().insert("path").style("fill", function (d) {
      var sliceColor = $scope.color(d.data.label);
      if (angular.isDefined(d.data.color)) {
        sliceColor = d.data.color;
      }
      return sliceColor; //$scope.color(d.data.label);
    }).attr("class", "slice");
    slice.transition().duration(1000).attrTween("d", function (d) {
      this._current = this._current || d;
      var interpolate = d3.interpolate(this._current, d);
      this._current = interpolate(0);
      return function (t) {
        return $scope.arc(interpolate(t));
      };
    });
    slice.exit().remove();

    /* ------- TEXT LABELS -------*/

    var text = $scope.svg.select(".labels").selectAll("text").data($scope.pie(data), $scope.key);
    text.enter().append("text").attr("dy", ".35em").text(function (d) {
      return d.data.label;
    });
    var getAngle = function getAngle(d) {
      return 180 / Math.PI * (d.startAngle + d.endAngle) / 2 - 90;
    };
    function midAngle(d) {
      return d.startAngle + (d.endAngle - d.startAngle) / 2;
    }
    text.transition().duration(1000).attrTween("transform", function (d) {
      this._current = this._current || d;
      var interpolate = d3.interpolate(this._current, d);
      this._current = interpolate(0);
      return function (t) {
        var d2 = interpolate(t);
        var pos = $scope.outerArc.centroid(d2);
        var angle = getAngle(d);
        var flip = "";
        if (angle > 90 || angle < -90) {
          flip = "rotate(180)";
          pos[0] *= -1;
          pos[1] *= -1;
        }
        return flip + "translate(" + pos + ") " + "rotate(" + angle + ") ";
      };
    }).styleTween("text-anchor", function (d) {
      this._current = this._current || d;
      var interpolate = d3.interpolate(this._current, d);
      this._current = interpolate(0);
      return function (t) {
        var d2 = interpolate(t);
        return midAngle(d2) < Math.PI ? "start" : "end";
      };
    });
    if ($scope.sxHideLabels) {
      text.style("display", "none");
    }
    text.exit().remove();

    /* ------- SLICE TO TEXT POLYLINES -------*/

    var polyline = $scope.svg.select(".lines").selectAll("polyline").data($scope.pie(data), $scope.key);
    polyline.enter().append("polyline");
    polyline.transition().duration(1000).attrTween("points", function (d) {
      this._current = this._current || d;
      var interpolate = d3.interpolate(this._current, d);
      this._current = interpolate(0);
      return function (t) {
        var d2 = interpolate(t);
        var pos = $scope.outerArc.centroid(d2);
        //pos[0] = $scope.radius * 0.95 * (midAngle(d2) < Math.PI ? 1 : -1);
        return [$scope.arc.centroid(d2), $scope.outerArc.centroid(d2), pos];
      };
    });
    if ($scope.sxHideLabels) {
      polyline.style("display", "none");
    }
    polyline.exit().remove();
    $scope.showing = true;
  };
  $scope.showing = false;
  $scope.renderStart = false;
  $scope.$watchCollection(function (scope) {
    return scope.sxGraphData.concat([scope.sxXAxisFormat, scope.sxXAxisTicks, scope.sxInterpolate, scope.sxShowPoints, scope.sxChartType]);
  }, function (newValue, oldValue) {
    if (newValue && !$scope.renderStart) {
      if ($scope.showing) {
        $scope.change($scope.sxGraphData);
      } else {
        $scope.renderStart = true;
        $timeout(function () {
          $scope.showGraph();
          $scope.renderStart = false;
        });
      }
    }
  });
}]);

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixMultiSeriesLineChart
 * @description
 * # sixMultiSeriesLineChart
 */
angular.module('emma.theme').directive('sixDonutChart', ['$log', function ($log) {
  return {
    template: '<style>' + '.six-donut-chart-area { width: 100%; position: relative; }' + 'svg {' + 'width: 100%;' + 'height: 100%;' + 'position: absolute;' + 'top: 0;' + 'left: 0;' + '}' + 'path.slice{' + 'stroke-width:2px;' + '}' + 'polyline{' + 'opacity: .3;' + 'stroke: black;' + 'stroke-width: 2px;' + '  fill: none;' + '}' + '</style>' + '<div class="six-donut-wrapper"><div id="donutGraph{{sxId}}" class="six-donut-chart-area" style="padding-top: {{sxChartRatio}}%"></div></div>',
    restrict: 'E',
    scope: {
      sxGraphData: '=',
      sxId: '=?',
      //da usare se si vogliono mettere più grafici! style="height:300px; width:460px"
      sxYAxisLegend: '=?',
      sxXAxisFormat: '=?',
      sxXAxisTicks: '=?',
      sxHideToolbar: '=?',
      sxGraphTitle: '=?',
      sxSeriesColors: '=?',
      sxShowPoints: '=?',
      sxInterpolate: '=?',
      // basis (default), linear , step-after, etc... http://www.d3noob.org/2013/01/smoothing-out-lines-in-d3js.html
      sxChartType: '=?',
      // line, bar
      sxChartWidth: '=?',
      sxChartHeight: '=?',
      sxHideLabels: '=?'
    },
    controller: 'sixDonutChartCtrl'
  };
}]);
'use strict';

angular.module('emma.theme').controller('sixFormulaCtrl', ['$scope', '$log', 'formulaFactory', function ($scope, $log, formulaFactory) {
  var UPDATE_EVT = 'UPDATE_FORMULA';
  $log.log('--- sixformula --- ' + $scope.formulaId);
  $scope.itemSelected = '';
  $scope.output = null;
  $scope.getListWrapper = function () {
    formulaFactory.getFormulasList({
      query: $scope.queryParam
    }).$promise.then(function (data) {
      $scope.listWrapper = data;
    });
  };
  $scope.getFormula = function () {
    formulaFactory.getFormulaById({
      id: $scope.formulaId
    }).$promise.then(function (data) {
      $scope.itemSelected = data.formula;
      $scope.calculate();
    });
  };
  $scope.calculate = function () {
    var obj = {
      formula: $scope.itemSelected,
      value: $scope.params
    };
    formulaFactory.getCalculationResult(obj).$promise.then(function (data) {
      $scope.output = data.result;
      if ($scope.fieldType === 'number') {
        $scope.ngModel = parseFloat($scope.output);
      } else if ($scope.fieldType === 'integer') {
        $scope.ngModel = parseInt($scope.output);
      } else {
        $scope.ngModel = $scope.output;
      }
      console.log($scope.output);
    });
  };
  $scope.$on(UPDATE_EVT, function (newVal, oldVal) {
    $scope.calculate();
  });
  $scope.$watch(function () {
    return $scope.params;
  }, function (newVal, oldVal) {
    $scope.$broadcast(UPDATE_EVT);
  });
  $scope.getFormula();
}]);

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixLookup
 * @description
 * # sixLookup
 */
angular.module('emma.theme').directive('sixFormula', ['$log', 'formulaFactory', function ($log, formulaFactory) {
  return {
    template: "<div class=\"form-group\" ng-class=\"{'has-error': hasError()}\">" + "<div class=\"input-group has-button\" style=\"width: 100%\">" + "<span class=\"input-group-addon\" ng-if=\"fieldAddonLeft\">{{fieldAddonLeft}}</span>" + "<input type=\"text\" class=\"form-control\" ng-model=\"ngModel\" readonly>" + "<span class=\"input-group-addon\" ng-if=\"fieldAddonRight\">{{fieldAddonRight}}</span>" + "</div>" + "<div ng-if=\"showDebug === 'true'\">" + "<input type=\"checkbox\" ng-model=\"sxDebug\"><span style=\"font-size:smaller;color:lightslategray\">debug</span></input>" + "<div ng-if=\"sxDebug\" style=\"font-size:smaller; color:lightslategray\">" + "model: {{ngModel}}<br/>" + "type: {{sxType}}<br/>" + "list: {{list}}<br/>" + "object: {{object}}" + "</div>" + "</div>" + "</div>",
    restrict: 'E',
    scope: {
      ngModel: '=',
      params: '=?',
      formulaId: '=',
      fieldType: '=',
      fieldAddonLeft: '=?',
      fieldAddonRight: '=?'
    },
    controller: 'sixFormulaCtrl'
  };
}]);
'use strict';

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixiterator
 * @description
 * # sixiterator
 *
 * Parametri della iteratorCopy:
 * siAttribute: stringa con il nome del campo da cercare nello schema
 * siSchema: schema
 * siModel: variabile alla quale agganciare la $watch
 * siDoc: variabile contenente il documento dove andare a copiare il valore di destinazione -> bisogna specificare in value.copyTo l'indirizzo completo
 * key: campo per il binding
 * value.copyTo[]: destinazioni dove copiare i valori dalla 'key'
 *
 */
angular.module('emma.theme').directive('sixIteratorCopy', function () {
  return {
    template: '<div ng-repeat="(key, value) in fieldsToCopy">' + '<six-copy sc-model="siModel" sc-key="key" sc-duplicate="value.copyTo" sc-doc="siDoc"></six-copy>' + '</div>',
    restrict: 'E',
    scope: {
      siSchema: '=',
      siAttribute: '=',
      siModel: '=',
      siDoc: '='
    },
    link: function postLink(scope, element, attrs) {
      scope.fieldsToCopy = {};
      scope.$watch('siSchema', function () {
        if (angular.isDefined(scope.siSchema)) {
          angular.forEach(scope.siSchema.properties, function (p, pKey) {
            if (angular.isDefined(p[scope.siAttribute])) {
              scope.fieldsToCopy[pKey] = scope.siSchema.properties[pKey];
            }
          });
        }
      });
    }
  };
});
'use strict';

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixSelect
 * @description
 * # sixSelect
 */
angular.module('emma.theme').directive('sixLoadingPlaceHolder', function () {
  return {
    template: '<div ng-if="sxModel.show" style="height:{{sxHeight}}">' + '<div class="loadingPlaceholder progress-bar-striped active"' + ' role="progressbar"' + ' aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"' + ' ng-style="{width: percent + ' % '}" aria-valuetext="100%"' + ' style="width: 100%;height:100%;text-align:center;vertical-align: middle;line-height: {{sxHeight}}; ">' + '<span class="ng-binding ng-scope" style="font-size:xx-large">' + '<i class="fa fa-exclamation-triangle" ng-if="sxModel.error" style="margin-right: 10px"></i> ' + '<i class="fa fa-exclamation" ng-if="sxModel.warn" style="margin-right: 10px"></i> ' + '<i class="fa fa-info" ng-if="sxModel.info" style="margin-right: 10px"></i> ' + '<i class="fa fa-refresh fa-spin" ng-if="!sxModel.info && !sxModel.warn && !sxModel.error" style="margin-right: 10px"></i> ' + '{{sxModel.message}}</span>' + '</div></div>',
    restrict: 'E',
    scope: {
      sxHeight: '=',
      /*sxLoading: '=',
      sxLoadingMessage: '=',*/
      sxModel: '='
    }
  };
});
angular.module('emma.theme').directive('sixLoadingSmall', function () {
  return {
    template: '<span ng-if="sxFor === undefined"><i class="fa fa-refresh fa-spin text-muted m-r-sm"></i></span>',
    restrict: 'E',
    scope: {
      sxFor: '='
    }
  };
});
'use strict';

angular.module('emma.theme').controller('sixLookupCtrl', ['$scope', '$log', 'baseFactory', 'lookupFactory', 'DATA_SET_URL', function ($scope, $log, baseFactory, lookupFactory, DATA_SET_URL) {
  if (angular.isUndefined($scope.sxHistory)) {
    $scope.sxHistory = false;
  }
  if (angular.isUndefined($scope.sxShowDescription)) {
    $scope.sxShowDescription = false;
  }
  if (angular.isUndefined($scope.sxClosable)) {
    $scope.sxClosable = true;
  }
  if (angular.isUndefined($scope.sxAutoInit)) {
    $scope.sxAutoInit = false;
  } // indica se la lookup deve auto-inizializzarsi quando la lista di record scaricati ha lunghezza uno
  if (angular.isUndefined($scope.sxOnSelect)) {
    $scope.sxOnSelect = function () {/* vuota */};
  }
  $scope.sxDescriptionClass = $scope.sxDescriptionClass || 'font-bold';
  $scope.sxPlaceholder = $scope.sxPlaceholder || 'Enter...';
  if (angular.isDefined($scope.sxWar)) {
    $scope.sxWarUrl = 'api/' + $scope.sxWar + '/api/';
    $scope.sxBasePath = $scope.sxBasePath;
  } else {
    $scope.sxWarUrl = DATA_SET_URL + '/api/';
    $scope.sxBasePath = $scope.sxBasePath || 'record';
  }
  $scope.clearSelectClicked = false;
  function buildPathLookup(basePath, type) {
    // basePath/type/lookup
    $log.log('sx-base-path ' + basePath + ' ; sx-type ' + type);
    var path = '';
    if (angular.isDefined(basePath)) {
      if (path != '' && path.slice(-1) != '/') path += '/';
      path += basePath;
    }
    if (angular.isDefined(type)) {
      if (path != '' && path.slice(-1) != '/') path += '/';
      path += type;
    }
    if (path != '' && path.slice(-1) != '/') path += '/';
    path += '_lookup';
    $log.info('builded lookup path: ' + path);
    return path;
  }
  function buildPathSelect(basePath, type, uuid) {
    // basePath/type/lookup
    $log.log('sx-base-path ' + basePath + ' ; sx-type ' + type);
    var path = '';
    if (angular.isDefined(basePath)) {
      if (path != '' && path.slice(-1) != '/') path += '/';
      path += basePath;
    }
    if (angular.isDefined(type)) {
      if (path != '' && path.slice(-1) != '/') path += '/';
      path += type;
    }
    if (angular.isUndefined(uuid)) {
      $log.error('lookup: selected uuid is undefined!!');
    }
    if (path != '' && path.slice(-1) != '/') path += '/';
    path += '_uuid/' + uuid + '/_current';
    $log.info('builded lookup selected path: ' + path);
    return path;
  }
  $scope.refreshData = function (search) {
    $scope.list = [];
    var path = buildPathLookup($scope.sxBasePath, $scope.sxType);
    var prefix = '';
    if (angular.isDefined($scope.sxSearchPrefix) && angular.isDefined($scope.sxSearchPrefix)) {
      prefix = $scope.sxSearchPrefix;
    }
    var toLower = angular.isUndefined(search) ? prefix : (prefix + search).toLowerCase();
    var query = {
      query: toLower,
      history: $scope.sxHistory
    };
    if (angular.isDefined($scope.sxFilter)) {
      lookupFactory($scope.sxWarUrl, path).search(query, $scope.sxFilter).$promise.then(function (resp) {
        if (angular.isDefined(resp) && resp.hasOwnProperty('list')) {
          $scope.list = resp.list;
        }
      });
    } else {
      lookupFactory($scope.sxWarUrl, path).query(query).$promise.then(function (resp) {
        if (angular.isDefined(resp) && resp.hasOwnProperty('list')) {
          $scope.list = resp.list;
        }
      });
    }
  };
  function autoInit() {
    // lancio una chiamata con pageSize = 1 per inizializzare la lookup
    if (!$scope.clearSelectClicked && $scope.sxAutoInit && isEmpty()) {
      //l'inizializzazione della promise replica il funzionamento di refreshData
      var path = buildPathLookup($scope.sxBasePath, $scope.sxType);
      var prefix = '';
      if (angular.isDefined($scope.sxSearchPrefix) && angular.isDefined($scope.sxSearchPrefix)) {
        prefix = $scope.sxSearchPrefix;
      }
      var query = {
        query: prefix,
        history: $scope.sxHistory,
        page: 1,
        page_size: 1
      };
      var promise;
      if (angular.isDefined($scope.sxFilter) && $scope.sxFilter != null) {
        promise = lookupFactory($scope.sxWarUrl, path).search(query, $scope.sxFilter).$promise;
      } else {
        promise = lookupFactory($scope.sxWarUrl, path).query(query).$promise;
      }
      promise.then(function (resp) {
        if (angular.isDefined(resp) && resp.hasOwnProperty('list')) {
          // se la lista totale dei risultati ha davvero 1 risultato -> lo carico direttamente
          if (resp.totalResults == 1) {
            $scope.select(resp.list[0]);
          }
        }
      });
    }
  }
  function isEmpty() {
    // se il campo è multiplo e con lunghezza pari a zero, o se è singolo e null/undefined
    var model = $scope.ngModel;
    if ($scope.sxField) {
      model = $scope.ngModel[$scope.sxField];
    }
    return model == null || model == undefined;
  }

  // serve per caricare la lista iniziale dei record anche senza aver cliccato sulla lookup
  autoInit();
  $scope.select = function (item) {
    var ref = {
      type: $scope.sxType,
      code: item.model.code,
      description: item.model.description,
      UUID: item.UUID
    };
    $scope.setValue(ref);
    $scope.loadObject();
    $scope.sxOnSelect(); //callback
  };

  $scope.setValue = function (value) {
    if (angular.isUndefined($scope.sxField)) {
      $scope.ngModel = value;
    } else {
      $scope.ngModel[$scope.sxField] = value;
    }
  };
  $scope.getValue = function () {
    if (angular.isUndefined($scope.sxField)) {
      return $scope.ngModel;
    } else {
      return $scope.ngModel[$scope.sxField];
    }
  };
  $scope.setObject = function (obj) {
    $scope.object = angular.isDefined(obj) && obj.hasOwnProperty('model') ? obj.model : undefined;
    if ($scope.hasOwnProperty('sxObject')) {
      $scope.sxObject = obj;
    }
  };
  $scope.loaded = false;
  $scope.loadObject = function () {
    $scope.setObject(undefined);
    if ($scope.getValue()) {
      var path = buildPathSelect($scope.sxBasePath, $scope.sxType, $scope.getValue().UUID);
      lookupFactory($scope.sxWarUrl, path).query().$promise.then(function (response) {
        $scope.setObject(response);
        $log.info('lookup loaded');
      });
    }
  };
  $scope.clearSelect = function () {
    $scope.setValue(undefined);
    $scope.setObject(undefined);
    $scope.refreshData();
    // se la lookup ha la priorità di auto-riempimento, setto la variabile di stato del bottone
    if ($scope.sxAutoInit) {
      $scope.clearSelectClicked = true;
    }
    $scope.sxOnSelect(); //callback
  };

  $scope.$watch(function (scope) {
    if (angular.isUndefined($scope.sxField)) {
      return scope.ngModel;
    } else {
      return scope.ngModel[$scope.sxField];
    }
  }, function (newValue, oldValue) {
    $scope.loadObject();
  });
  $scope.$watchGroup(['sxType', 'sxFilter'], function (newValue, oldValue) {
    $scope.refreshData();
    autoInit();
  });
  $scope.$on('refreshLookUp', function () {
    $scope.refreshData();
    autoInit();
  });
}]);

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixLookup
 * @description
 * # sixLookup
 */
angular.module('emma.theme').directive('sixLookup', ['$log', 'lookupFactory', function ($log, lookupFactory) {
  return {
    template: '<div class="input-group has-button" style="width: 100%">' + '<ui-select ng-model="ngModel" theme="bootstrap" on-select="select($item, $model)" ng-disabled="sxDisabled" reset-search-input="false">' + '<ui-select-match class="ui-select-match" placeholder="{{sxPlaceholder}}"><span ng-if="object.description">{{object.description}}</span><span ng-if="!object.description">{{object.code}}</span></ui-select-match>' + '<ui-select-choices class="ui-select-choices" repeat="item in list track by $index" refresh="refreshData($select.search)" refresh-delay="0">' + '<span ng-bind-html="item.model.code | highlight: $select.search"></span> - <span ng-bind-html="item.model.description | highlight: $select.search"></span>' + '</ui-select-choices>' + '</ui-select>' + '<span class="input-group-btn" ng-if="sxClosable == true">' + '<button type="button" class="btn btn-bg btn-default" ng-click="clearSelect()" ng-disabled="sxDisabled"><i class="fa fa-times"></i></button>' + '<span id="{{sxId}}-transclude" ng-transclude></span>' + '</span>' + '</div>' + '<div ng-if="sxShowDescription === true" class="{{sxDescriptionClass}}">' + '{{object.description}}' + '</div>' + '<div ng-if="showDebug"><input type="checkbox" ng-model="sxDebug"><span style="font-size:smaller;color:lightslategray">debug</span>' + '<div ng-if="sxDebug" style="font-size:smaller; color:lightslategray">' + 'model: {{ngModel}}<br/>' + 'type: {{sxType}}<br/>' + 'list: {{list}}<br/>' + 'object: {{object}}</div></div>',
    restrict: 'E',
    scope: {
      ngModel: '=',
      sxBasePath: '=?',
      //nome dell'endpoint rest
      sxType: '=',
      //tipo 'entity'
      sxField: '=?',
      //nome del campo nell'oggetto che mi referenzia
      sxObject: '=?',
      //nome del campo in cui salvare l'intero oggetto selezionato
      showDebug: '=?',
      sxDebug: '=?',
      sxHistory: '=?',
      sxSearchPrefix: '=?',
      sxShowDescription: '=?',
      sxFilter: '=?',
      sxDisabled: '=?',
      sxPlaceholder: '=?',
      sxWar: '=?',
      sxClosable: '=?',
      // per abilitare o meno il pulsante per pulire la lookup
      sxOnSelect: '=?',
      sxAutoInit: '=?'
    },
    transclude: true,
    controller: 'sixLookupCtrl'
  };
}]);
'use strict';

function makeId() {
  var text = "";
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  for (var i = 0; i < 10; i++) text += possible.charAt(Math.floor(Math.random() * possible.length));
  return text;
}
angular.module('emma.theme').controller('sixLookup2Ctrl', ['$scope', '$rootScope', '$log', 'schemaFactory', 'dialogService', 'recordFactory', 'lookupFactory', 'counterFactory', 'toaster', '$q', '$filter', '$timeout', '$location', 'DATA_SET_URL', 'DATA_REL_URL', 'ENERGY_URL', 'PLAN_URL', 'CONSIP_URL', 'authFactory', 'treeFactory', 'modelIconService', '$animate', function ($scope, $rootScope, $log, schemaFactory, dialogService, recordFactory, lookupFactory, counterFactory, toaster, $q, $filter, $timeout, $location, DATA_SET_URL, DATA_REL_URL, ENERGY_URL, PLAN_URL, CONSIP_URL, authFactory, treeFactory, modelIconService, $animate) {
  /**** VARIABLES INIT *****/

  var lastSelectedObj = undefined;
  $scope.filter = {};
  $scope.vars = {
    schema: {},
    // schema del tipo di record selezionato
    form: {},
    // form del tipo di record selezionato
    schemaLoaded: false,
    // indica se è stato caricato o meno lo schema del tipo di record
    commissionDependent: false,
    // true=inserisce la commessa ; false=toglie la commessa
    customerDependent: false,
    // true=inserisce il cliente ; false=toglie il cliente
    historyMode: false,
    // true=SNAP ; false=STABLE
    insertMode: false,
    // indica se è abilitata la modalità di inserimento "al volo" di un nuovo record
    clearSelectClicked: false,
    // indica se il bottone per pulire la lookup è stato cliccato, da quando è stata inizializzata la lookup
    selfGeneratedCode: {
      // indica se il codice è da auto-generare (flag) e quale è il nome del contatore di six
      codeNameSix: '',
      active: false
    },
    listLoaded: false,
    treeLoaded: false,
    totalItems: 0,
    page: 1
  };
  $scope.sxId = $scope.sxId || makeId();
  if (angular.isUndefined($scope.sxObject)) {
    $scope.sxObject = {};
  } // oggetto completo da restituire al chimante della six-lookup-2
  if (angular.isUndefined($scope.sxFilter)) {
    $scope.sxFilter = undefined;
  } // filtri per il backend
  if (angular.isUndefined($scope.sxHistory)) {
    $scope.sxHistory = false;
  } // mostra/nasconde i dati storicizzati
  if (angular.isUndefined($scope.sxCross)) {
    $scope.sxCross = false;
  } // filtro cross commessa
  if (angular.isUndefined($scope.sxShowDescription)) {
    $scope.sxShowDescription = false;
  }
  if (angular.isUndefined($scope.sxShowDetails)) {
    $scope.sxShowDetails = false;
  } // visualizza/nasconde il tab dei dettagli
  if (angular.isUndefined($scope.sxShowList)) {
    $scope.sxShowList = true;
  } // visualizza/nasconde il tab della lista
  if (angular.isUndefined($scope.sxShowTree)) {
    $scope.sxShowTree = false;
  } // visualizza/nasconde il tab del tree
  if (angular.isUndefined($scope.sxShowFilters)) {
    $scope.sxShowFilters = false;
  } // visualizza/nasconde il tab dei filtri
  if (angular.isUndefined($scope.sxPinnable)) {
    $scope.sxPinnable = false;
  } // indica se la sidebar può essere bloccata o meno
  if (angular.isUndefined($scope.sxVisible)) {
    $scope.sxVisible = false;
  } // indica se la sidebar è visibile o meno
  if (angular.isUndefined($scope.sxMultiple)) {
    $scope.sxMultiple = false;
  } // indica se la lookup deve gestire valori multipli o singoli
  if (angular.isUndefined($scope.sxCompact)) {
    $scope.sxCompact = false;
  } // indica se la lookup deve essere visualizzata in modalità compatta o con sidebar
  if (angular.isUndefined($scope.sxMaxLength)) {
    $scope.sxMaxLength = undefined;
  }
  if (angular.isUndefined($scope.sxAutoInit)) {
    $scope.sxAutoInit = false;
  } // indica se la lookup deve auto-inizializzarsi quando la lista di record scaricati ha lunghezza uno
  if (angular.isUndefined($scope.sxRequired)) {
    $scope.sxRequired = false;
  }
  $scope.sxPageSize = $scope.sxPageSize || 50; // dimensione pagina della lista caricata
  $scope.sxBasePath = $scope.sxBasePath || 'record'; // base path per le chiamate al backend
  $scope.sxDescriptionClass = $scope.sxDescriptionClass || 'font-bold';
  $scope.sxPosition = $scope.sxPosition || 'left'; // posizione della sidebar (left|right)
  $scope.sxDimension = $scope.sxDimension || 'l'; // dimensione della sidebar (s|m|l)
  $scope.valueToShow = undefined; // valore selezionato da mostrare nella input text della lookup se singola
  $scope.sxPinned = isMultiple(); // indica se la sidebar è bloccata o meno (inizializzata qui)
  $scope.sxDetailRoute || 'record/snap/' + $scope.sxType;
  $scope.fullTmpObj = {}; // oggetto mostrato nel tab 'details'

  // info di paginazione mostrati in lista
  $scope.start = 0;
  $scope.end = 0;

  /* ***** Search filters ***** */
  $scope.sxSearchTerms = {
    id: $scope.sxId + '_filter-search',
    open: false,
    type_id: undefined,
    type_obj: undefined
  };
  $scope.bools = {
    currentcommission: true,
    crossCommission: true
  };
  var SIX_DATA_SET_WAR = 'six-data-set';
  var SIX_DATA_REL_WAR = 'six-data-rel';
  var SIX_PLAN_WAR = 'six-plan';
  var SIX_CONSIP_WAR = 'six-consip';
  var SIX_ENERGY_WAR = 'six-energy';
  var VIRTUAL_DS = 'virtual-ds';
  resetSxFilters();
  var moduleUrl = DATA_SET_URL;
  setWarUrl($scope.sxWar);
  function setWarUrl(war) {
    switch (war) {
      case 'six-data-set':
        moduleUrl = DATA_SET_URL;
        break;
      case 'six-energy':
        moduleUrl = ENERGY_URL;
        break;
      case 'six-plan':
        moduleUrl = PLAN_URL;
        break;
      case 'six-consip':
        moduleUrl = CONSIP_URL;
        break;
      case 'six-data-rel':
        moduleUrl = DATA_REL_URL;
        $scope.sxSources = [];
        angular.forEach($scope.sxFieldMapping, function (v, k) {
          if (v) $scope.sxSources.push("".concat(v, " AS ").concat(k));
        });
        break;
      default:
        moduleUrl = DATA_SET_URL;
        $scope.sxBasePath = $scope.sxBasePath || 'record';
        break;
    }
    $scope.sxWarUrl = moduleUrl + '/api/';
    console.debug("war is: ", $scope.sxWar, "war url is: ", $scope.sxWarUrl);
  }
  setPlaceholder(); // inizializzo il placeholder da mostrare

  /**** LOOKUP PATH FUNCTIONS *****/

  function buildPathLookup(basePath, type) {
    // basePath/type/lookup
    var path = '';
    if (angular.isDefined(basePath)) {
      if (path != '' && path.slice(-1) != '/') path += '/';
      path += basePath;
    }
    if (angular.isDefined(type)) {
      if (path != '' && path.slice(-1) != '/') path += '/';
      path += type;
    }
    if (path != '' && path.slice(-1) != '/') path += '/';
    path += '_lookup';
    return path;
  }
  function buildPathSelect(basePath, type, uuid) {
    // basePath/type/lookup
    var path = '';
    if (angular.isDefined(basePath)) {
      if (path != '' && path.slice(-1) != '/') path += '/';
      path += basePath;
    }
    if (angular.isDefined(type)) {
      if (path != '' && path.slice(-1) != '/') path += '/';
      path += type;
    }
    if (angular.isUndefined(uuid)) {
      $log.error('lookup: selected uuid is undefined!!');
    }
    if (path != '' && path.slice(-1) != '/') path += '/';
    path += '_uuid/' + uuid + '/_current';
    return path;
  }

  /**** LIST FUNCTIONS *****/

  $scope.getListForTags = function (query) {
    $animate.enabled(false);
    return refreshList(query).then($animate.enabled(true));
  };

  // Instantiate these variables outside the watch
  var refreshListTimeout;
  function refreshList(search) {
    if (refreshListTimeout) $timeout.cancel(refreshListTimeout);
    refreshListTimeout = $timeout(_refreshList, 250, true, search);
    return refreshListTimeout;
  }
  function _refreshList(search) {
    var deferred = $q.defer();
    $scope.vars.listLoaded = false;
    $scope.list = [];
    var path = buildPathLookup($scope.sxBasePath, $scope.sxType);
    var prefix = '';
    if (angular.isDefined($scope.sxSearchPrefix) && angular.isDefined($scope.sxSearchPrefix)) {
      prefix = $scope.sxSearchPrefix;
    }
    var postfix = '';
    if (angular.isDefined($scope.sxSearchPostfix) && angular.isDefined($scope.sxSearchPostfix)) {
      postfix = $scope.sxSearchPostfix;
    }
    var toLower = angular.isUndefined(search) ? prefix : (prefix + search + postfix).toLowerCase();
    var query = {
      query: toLower,
      history: $scope.sxHistory,
      cross: $scope.sxCross,
      page: $scope.vars.page,
      page_size: $scope.sxPageSize
    };
    if ($scope.sxSources) {
      query.sources = $scope.sxSources.join(';');
    }
    if ($scope.sxFieldMapping) {
      query.sort_fields = $scope.sxFieldMapping.code || $scope.sxFieldMapping.description || '';
    }

    // filtri da sxFilter e sxSearchFilters
    var filters = {};
    angular.merge(filters, $scope.sxFilter, $scope.searchFilterObj);
    if ($scope.sxWar == SIX_DATA_REL_WAR && query.query && $scope.sxFieldMapping) {
      var columns = [];
      angular.forEach($scope.sxFieldMapping, function (col) {
        console.debug("Schema: ", $scope.vars.schema);
        if (col && $scope.vars.schema && $scope.vars.schema.properties && $scope.vars.schema.properties[col].type == 'string') {
          columns.push(col);
        } else {
          //FIXME: per ora usato solo in inventoryReport che utilizza mapping su stringhe in tutti e tre i campi
          if (col != "id") columns.push(col);
        }
      });
      if (columns.length) {
        filters = angular.merge({
          queryFilter: sixFiltersLib.text(columns.join(';'), "*".concat(query.query, "*"))
        }, filters);
      }
    }
    var promise;
    if (Object.keys(filters).length) {
      promise = lookupFactory($scope.sxWarUrl, path).search(query, filters).$promise;
      console.debug("search: ", $scope.sxWarUrl, path);
    } else {
      promise = lookupFactory($scope.sxWarUrl, path).query(query, filters).$promise;
    }
    promise.then(function (resp) {
      $scope.vars.listLoaded = true;
      if (angular.isDefined(resp) && resp.hasOwnProperty('list')) {
        $scope.list = resp.list.map(function (i) {
          return buildListRef(i);
        });
        $scope.vars.totalItems = resp.totalResults;
      } else {
        $scope.vars.totalItems = 0;
      }

      // info di paginazione mostrate in lista
      $scope.start = $scope.sxPageSize * ($scope.vars.page - 1) + 1;
      var min = Math.min($scope.sxPageSize, $scope.list.length);
      $scope.end = min + $scope.sxPageSize * ($scope.vars.page - 1);
      deferred.resolve($scope.list);
    });
    return deferred.promise;
  }
  function autoInit() {
    // lancio una chiamata con pageSize = 1 per inizializzare la lookup
    if (!$scope.vars.clearSelectClicked && $scope.sxAutoInit && isEmpty()) {
      //l'inizializzazione della promise replica il funzionamento di refreshList
      var path = buildPathLookup($scope.sxBasePath, $scope.sxType);
      var prefix = '';
      if (angular.isDefined($scope.sxSearchPrefix) && angular.isDefined($scope.sxSearchPrefix)) {
        prefix = $scope.sxSearchPrefix;
      }
      var query = {
        query: prefix,
        history: $scope.sxHistory,
        page: 1,
        page_size: 1
      };

      // filtri da sxFilter e sxSearchFilters
      var filters = {};
      angular.merge(filters, $scope.sxFilter, $scope.searchFilterObj);
      var promise;
      if ($scope.sxWar == SIX_DATA_REL_WAR && query.query && $scope.sxFieldMapping) {
        var columns = [];
        angular.forEach($scope.sxFieldMapping, function (col) {
          console.debug("Schema: ", $scope.vars);
          if (col && $scope.vars.schema && $scope.vars.schema.properties && $scope.vars.schema.properties[col].type == 'string') {
            columns.push(col);
          } else {
            if (col != "id") columns.push(col);
          }
        });
        if (columns.length) {
          filters = angular.merge({
            queryFilter: sixFiltersLib.text(columns.join(';'), "*".concat(query.query, "*"))
          }, filters);
        }
      }
      if (Object.keys(filters).length) {
        promise = lookupFactory($scope.sxWarUrl, path).search(query, filters).$promise;
      } else {
        promise = lookupFactory($scope.sxWarUrl, path).query(query, filters).$promise;
      }
      promise.then(function (resp) {
        if (angular.isDefined(resp) && resp.hasOwnProperty('list')) {
          var list = resp.list.map(function (i) {
            return buildListRef(i);
          });
          // se la lista totale dei risultati ha davvero 1 risultato -> lo carico direttamente
          if (resp.totalResults == 1) {
            $scope.select(list[0]);
          }
        }
      });
    }
  }
  function isEmpty() {
    // se il campo è multiplo e con lunghezza pari a zero, o se è singolo e null/undefined
    var model = $scope.ngModel;
    if ($scope.sxField) {
      model = $scope.ngModel[$scope.sxField];
    }
    return isMultiple() && model.length == 0 || !isMultiple() && (model == null || model == undefined);
  }

  // serve per caricare la lista iniziale dei record anche senza aver cliccato sulla lookup
  autoInit();

  /**** VALUE FUNCTIONS *****/

  // Contruisce un riferimento in stile lookup
  function buildRef(item) {
    var typeRef = null;
    var code = null;
    var description = null;
    var uuid = null;
    var customCode = null;
    if (item.model) {
      if (item.schemaCode) {
        typeRef = item.schemaCode;
      } else {
        typeRef = $scope.sxType;
      }
      code = item.model.code;
      description = item.model.description;
      uuid = item.UUID;
      customCode = item.model.customCode;
    } else {
      if (item.type) {
        typeRef = item.type;
      } else {
        typeRef = $scope.sxType;
      }
      code = item.code;
      description = item.description;
      uuid = item.UUID;
      customCode = item.customCode;
    }
    return {
      type: typeRef,
      code: code,
      description: description,
      UUID: uuid,
      customCode: customCode
    };
  }
  function buildListRef(item) {
    //per dare un po' più di flessibilità nei template, le ref in lista sono più ricche
    return Object.assign({}, item.model, buildRef(item));
  }
  function addOrSetValue(value) {
    if (isMultiple()) {
      if ($scope.sxField) {
        if (angular.isUndefined($scope.ngModel[$scope.sxField])) {
          $scope.ngModel[$scope.sxField] = [];
        }
        checkAndAdd($scope.ngModel[$scope.sxField], value);
      } else {
        checkAndAdd($scope.ngModel, value);
      }
    } else {
      if ($scope.sxField) {
        $scope.ngModel[$scope.sxField] = value;
      } else {
        $scope.ngModel = value;
      }
    }
    setPlaceholder();
  }
  function setValueToShow(value) {
    if (value) {
      if ($scope.sxItemTemplate) {
        $scope.valueToShow = $scope.evaluateTemplate($scope.sxItemTemplate, value);
      } else {
        $scope.valueToShow = $filter('reference')(value, 100);
      }
    } else {
      $scope.valueToShow = undefined;
    }
  }
  function checkAndAdd(list, value) {
    var found = list.some(function (el) {
      return el.UUID === value.UUID;
    });
    if (!found) {
      list.push(value);
    }
  }
  function unsetValue() {
    if (angular.isUndefined($scope.sxField)) {
      if (isMultiple()) {
        $scope.ngModel = [];
      } else {
        $scope.ngModel = undefined;
        setValueToShow($scope.ngModel);
      }
    } else {
      if (isMultiple()) {
        $scope.ngModel[$scope.sxField] = [];
      } else {
        $scope.ngModel[$scope.sxField] = undefined;
        setValueToShow($scope.ngModel[$scope.sxField]);
      }
    }
    setPlaceholder();
  }
  function getValue() {
    if ($scope.ngModel && $scope.sxField) {
      return $scope.ngModel[$scope.sxField];
    } else {
      return $scope.ngModel;
    }
  }
  $scope.toggleSelect = function (item) {
    $scope.undoNewRecord();
    if ($scope.isItemSelected(item)) {
      $scope.unselect(item);
    } else {
      $scope.select(item);
    }
  };
  $scope.select = function (item, autoclose) {
    if ($scope.sxForm && $scope.sxForm[$scope.sxId]) {
      $scope.sxForm[$scope.sxId].$pristine = false; // forzo il pristine per indicare che il valore è stato effettivamente "toccato" (serve ad evidenziare eventuali errori di validazione)
    }

    autoclose = angular.isDefined(autoclose) ? autoclose : true;
    $scope.undoNewRecord();
    $scope.vars.insertMode = false;

    // se è multipla e ho la selezione da tree, la spunta su un parent provoca la selezione di tutti i nodi figli (di primo livello) del tipo desiderato
    if ($scope.isMultiple() && $scope.treeTabEnabled()) {
      // se sto selezionando un nodo 'selezionabile' (cioè con type == sxType), allora seleziono solo lui ...
      if (item.type == $scope.sxType) {
        addOrSetValue(buildRef(item));
      } else {
        // ... altrimenti lo espando e seleziono tutti i suoi figli 'selezionabili'
        explodeNode(item).then(function () {
          item.nodes.forEach(function (n) {
            if (n.type == $scope.sxType) {
              addOrSetValue(buildRef(n));
            }
          });
        });
      }
    } else {
      // non è multipla e/o non ho il tree abilitato => selezione secca del nodo
      addOrSetValue(buildRef(item));
    }
    if (!$scope.sxPinned && autoclose) {
      closeLookup();
    }
    if (angular.isDefined($scope.sxOnSelect) && angular.isFunction($scope.sxOnSelect)) {
      $scope.sxOnSelect({
        item: buildRef(item)
      }); //callback
    }
  };

  $scope.unselect = function (item) {
    if ($scope.sxForm && $scope.sxForm[$scope.sxId]) {
      $scope.sxForm[$scope.sxId].$pristine = false; // forzo il pristine per indicare che il valore è stato effettivamente "toccato" (serve ad evidenziare eventuali errori di validazione)
    }

    $scope.vars.insertMode = false;
    if (isMultiple()) {
      var idx = getValue().findIndex(function (v) {
        return v.UUID === item.UUID;
      });
      if (idx > -1) {
        getValue().splice(idx, 1);
      }
    } else {
      unsetValue();
    }
    if (angular.isDefined($scope.sxOnSelect) && angular.isFunction($scope.sxOnSelect)) {
      $scope.sxOnSelect(); //callback
    }
  };

  $scope.clearSelect = function () {
    unsetValue();
    unsetObject();
    if ($scope.listTabEnabled()) {
      refreshList($scope.filter.text);
    }
    if ($scope.treeTabEnabled()) {
      refreshTree($scope.filter.text);
    }
    // se la lookup ha la priorità di auto-riempimento, setto la variabile di stato del bottone
    if ($scope.sxAutoInit) {
      $scope.vars.clearSelectClicked = true;
    }
    if (angular.isDefined($scope.sxOnClear) && angular.isFunction($scope.sxOnClear)) {
      $scope.sxOnClear(); //callback
    }
  };

  $scope.goToRecord = function (event) {
    $log.debug(event);
    // var path = $scope.sxDetailRoute+'/'+getValue().UUID;
    var path = $scope.sxDetailRoute;
    if (event.ctrlKey) {
      window.open('#/' + path, '_blank'); // in new tab
    } else {
      $location.path(path); // in same tab
    }
  };

  $scope.isItemSelected = function (item) {
    var selectedValue = getValue();
    if (selectedValue && isMultiple()) {
      var found = false;
      selectedValue.forEach(function (i) {
        found |= i.UUID == item.UUID;
      });
      return found;
    } else if (selectedValue) {
      return selectedValue.UUID == item.UUID;
    }
    return false;
  };

  /**** TREE FUNCTIONS *****/

  var currentCommission = authFactory.getAuthData().info.commissions.current;
  $scope.currentCustomer = authFactory.getCurrentCustomer();
  function getTreeCode() {
    var code = 'def' + currentCommission.code;
    if (angular.isDefined($scope.currentCustomer)) {
      code += 'cli' + $scope.currentCustomer.code;
    }
    return code;
  }
  function buildSearchRegexp(text) {
    text = text.replace(/(\.\*\+\?\\\/\ \"\'\(\)\[\]\{\}\^\$)/g, '\\\$1'); //escaping caratteri speciali
    text = text.replace(/[a-zA-Z]/g, function (match) {
      var low = match.toLowerCase();
      var up = match.toUpperCase();
      return "[" + low + up + "]";
    });
    return text;
  }
  function refreshTree(search) {
    var deferred = $q.defer();
    $scope.vars.treeLoaded = false;
    $scope.tree = {};
    var prefix = '';
    if (angular.isDefined($scope.sxSearchPrefix) && angular.isDefined($scope.sxSearchPrefix)) {
      prefix = $scope.sxSearchPrefix;
    }
    var postfix = '';
    if (angular.isDefined($scope.sxSearchPostfix) && angular.isDefined($scope.sxSearchPostfix)) {
      postfix = $scope.sxSearchPostfix;
    }
    var toLower = angular.isUndefined(search) ? prefix : (prefix + search + postfix).toLowerCase();

    // filtri da sxFilter e sxSearchFilters
    var payload = {
      id: getTreeCode(),
      show_configurations: false,
      depth: 1
    };
    var filters = {
      // schemaCode: sixFiltersLib.match('schemaCode', $scope.sxType)
    };
    if (search && search.length >= 3) {
      // filtrato
      var value4Regex = buildSearchRegexp(toLower);
      filters.code = sixFiltersLib.regex('model.code', '.*' + value4Regex + '.*', sixFiltersLib.CONSTRAINTS.OR);
      filters.description = sixFiltersLib.regex('model.description', '.*' + value4Regex + '.*', sixFiltersLib.CONSTRAINTS.OR);
      filters.customCode = sixFiltersLib.regex('model.customCode', '.*' + value4Regex + '.*', sixFiltersLib.CONSTRAINTS.OR);
      payload.depth = 100;
    }
    var promise;
    promise = treeFactory.filtered(payload, filters).$promise;
    promise.then(function (data) {
      if (data.result) {
        $scope.tree = data.result;
        if ($scope.tree.nodes) {
          $scope.tree.nodes.forEach(function (n) {
            n.collapsed = true;
          });
        }
      }
      $scope.vars.treeLoaded = true;
      deferred.resolve(data.result);
    });
    return deferred.promise;
  }
  $scope.$watch('sxFieldMapping', function (newValue, oldValue) {
    if (newValue && newValue != oldValue) {
      $scope.sxSources = [];
      angular.forEach($scope.sxFieldMapping, function (v, k) {
        if (v) $scope.sxSources.push("".concat(v, " AS ").concat(k));
      });
    }
  }, true);

  // (De)Comprime i rami dell'albero
  $scope.toggleNode = function (node) {
    if (node.collapsed == true) {
      $scope.$broadcast('tree:explode', node);
    } else {
      // pulisco i nodi
      if (node.nodes && angular.isArray(node.nodes)) {
        node.nodes.length = 0;
      } else {
        node.nodes = [];
      }
      node.collapsed = true;
    }
  };
  function getNodesChilds(node, search) {
    // pulisco l'array dei nodi
    if (node.nodes && angular.isArray(node.nodes)) {
      node.nodes.length = 0;
    } else {
      node.nodes = [];
    }
    var payload = {
      id: getTreeCode(),
      show_configurations: false,
      path: (node.parents && node.parents.length > 0 ? node.parents.map(function (p) {
        return p.UUID;
      }).join(';') + ';' : '') + node.UUID,
      depth: 0
    };
    if (payload.path.charAt(0) == ';') {
      payload.path = payload.path.substring(1);
    }
    var prefix = '';
    if (angular.isDefined($scope.sxSearchPrefix) && angular.isDefined($scope.sxSearchPrefix)) {
      prefix = $scope.sxSearchPrefix;
    }
    var postfix = '';
    if (angular.isDefined($scope.sxSearchPostfix) && angular.isDefined($scope.sxSearchPostfix)) {
      postfix = $scope.sxSearchPostfix;
    }
    var toLower = angular.isUndefined(search) ? prefix : (prefix + search + postfix).toLowerCase();
    var filters = {
      // schemaCode: sixFiltersLib.match('schemaCode', $scope.sxType)
    };
    if (search && search.length >= 3) {
      // filtrato
      var value4Regex = buildSearchRegexp(toLower);
      filters.code = sixFiltersLib.regex('model.code', '.*' + value4Regex + '.*', sixFiltersLib.CONSTRAINTS.OR);
      filters.description = sixFiltersLib.regex('model.description', '.*' + value4Regex + '.*', sixFiltersLib.CONSTRAINTS.OR);
      filters.customCode = sixFiltersLib.regex('model.customCode', '.*' + value4Regex + '.*', sixFiltersLib.CONSTRAINTS.OR);
    }
    var deferred = $q.defer();
    treeFactory.childs(payload, filters).$promise.then(function (resp) {
      if (!resp.hasErrors) {
        node.nodes = resp.result;
        node.nodes.forEach(function (n) {
          n.collapsed = true;
        });
        deferred.resolve(resp);
      } else {
        toaster.pop('error', 'Errore caricamento', 'Errore recupero nodi');
        deferred.reject(resp);
      }
    })["catch"](function (response) {
      toaster.pop('error', 'Errore caricamento', 'Errore recupero nodi');
      deferred.reject(response);
    });
    return deferred.promise;
  }

  // Recupera l'icona del model da menu
  $scope.getModelIcon = function (modelName) {
    var icon = modelIconService.getModelIcon(modelName) || 'fa fa-circle-o';
    return 'fa-fw ' + icon;
  };
  function explodeNodePath(root, path) {
    if (!path || path.length == 0) {
      return root;
    }
    var tmp = angular.copy(path[0]);
    root.nodes.forEach(function (n) {
      if (n.UUID == tmp.UUID) {
        explodeNode(n).then(function () {
          explodeNodePath(n, path.slice(1));
        });
      }
    });
  }
  function explodeNode(node) {
    return getNodesChilds(node).then(function (res) {
      node.collapsed = false;
      return res;
    });
  }
  $scope.$on('tree:explode', function (evt, data) {
    explodeNode(data);
  });

  /**** OBJECT FUNCTIONS *****/

  function addOrSetFullObj(obj) {
    lastSelectedObj = $scope.fullTmpObj;
    if (isMultiple()) {
      $scope.sxObject[obj.UUID] = obj;
    } else {
      $scope.sxObject = obj;
      angular.extend($scope.fullTmpObj, obj);
    }
    if (angular.isDefined($scope.sxOnObjLoaded) && angular.isFunction($scope.sxOnObjLoaded)) {
      $scope.sxOnObjLoaded({
        obj: obj
      });
    }
    $scope.$broadcast('schemaFormRedraw');
  }
  function unsetObject() {
    if (isMultiple()) {
      $scope.sxObject = {};
    } else {
      $scope.sxObject = undefined;
    }
  }
  function loadAllFullObjs() {
    unsetObject();
    var val = getValue();
    if (!isMultiple() && val) {
      // lookup singola
      loadSingleFullObj(val).then(function (response) {
        addOrSetFullObj(response);
      });
    } else if (val && angular.isArray(val)) {
      // lookup multipla
      var promises = [];
      val.forEach(function (v) {
        promises.push(loadSingleFullObj(v));
      });
      $q.all(promises).then(function (responses) {
        responses.forEach(function (resp) {
          addOrSetFullObj(resp);
        });
      });
    }
  }
  function loadSingleFullObj(ref) {
    if (ref && ref.UUID) {
      var path = buildPathSelect($scope.sxBasePath, $scope.sxType, ref.UUID);
      return lookupFactory($scope.sxWarUrl, path).query().$promise;
    } else {
      var promise = $q.defer();
      promise.reject('ref is undefined');
      return promise.promise;
    }
  }

  /**** NEW DYNAMIC RECORD ****/

  $scope.addNewRecord = function () {
    angular.extend($scope.fullTmpObj, {});
    var newRecord = {
      model: {}
    };
    if ($scope.sxPrefill) {
      newRecord = angular.copy($scope.sxPrefill);
    }
    $scope.vars.insertMode = true;
    if ($scope.vars.selfGeneratedCode.active == true) {
      counterFactory.current({
        code: $scope.vars.selfGeneratedCode.codeNameSix
      }).$promise.then(function (response) {
        if (response.errors) {
          toaster.pop('error', 'Errore', 'Problema rilevato nell\'inizializziazione automatica del codice: ' + response.errors.error);
        } else {
          newRecord.model.code = (parseInt(response.current) + 1).toString();
          angular.extend($scope.fullTmpObj, newRecord);
        }
      });
    } else {
      angular.extend($scope.fullTmpObj, newRecord);
    }
    $scope.$broadcast('schemaFormRedraw');
    goToTab('details');
  };
  $scope.undoNewRecord = function () {
    $scope.vars.insertMode = false;
    angular.extend($scope.fullTmpObj, $scope.sxObject);
  };
  $scope.updateRecord = function () {
    // gestione code tramite contatore di SIX, confermo il codice...
    // FIXME per ora funziona perchè lo schema viene caricato in tempo (prima), ma occhio alle temporizzazioni...
    // FIXME ...se lo schema viene caricato in ritardo per problemi di rete e l'utente fa in tempo a cliccare su '+' per generare un nuovo record, il codice non viene autocompilato
    if ($scope.vars.selfGeneratedCode.active == true) {
      counterFactory.next({
        code: $scope.vars.selfGeneratedCode.codeNameSix
      }).$promise.then(function (response) {
        if (response.errors) {
          toaster.pop('error', 'Errore', 'Problema rilevato nell\'inizializziazione automatica del codice: ' + response.errors.error);
        } else {
          if (!$scope.fullTmpObj.model.code) {
            // se è ancora vuoto lo riempio
            $scope.fullTmpObj.model.code = response.next; // se è nuovo, confermo il codice...
          }
        }

        _update();
      });
    } else {
      _update();
    }
  };
  function _update() {
    if (angular.isDefined($scope.fullTmpObj) && angular.isDefined($scope.fullTmpObj.model) && angular.isDefined($scope.sxType)) {
      var params = {
        commission_dependent: $scope.vars.commissionDependent,
        customer_dependent: $scope.vars.customerDependent,
        history: $scope.vars.historyMode
      };
      recordFactory($scope.sxType).create(params, $scope.fullTmpObj.model).$promise.then(function (data) {
        if ($scope.listTabEnabled()) {
          refreshList($scope.filter.text);
        }
        if ($scope.treeTabEnabled()) {
          refreshTree($scope.filter.text);
        }
        $scope.select(data);
      });
    }
  }
  $scope.checkable = function (node) {
    return $scope.isMultiple() || node.type == $scope.sxType;
  };

  /**** TABS NAVIGATION ****/

  function goToTab(tabName) {
    angular.element(document.querySelector('#' + $scope.sxId + '_tab-s-filters')).removeClass('active');
    angular.element(document.querySelector('#' + $scope.sxId + '_tab-s-list')).removeClass('active');
    angular.element(document.querySelector('#' + $scope.sxId + '_tab-s-tree')).removeClass('active');
    angular.element(document.querySelector('#' + $scope.sxId + '_tab-s-details')).removeClass('active');
    angular.element(document.querySelector('#' + $scope.sxId + '_tab-filters')).removeClass('active');
    angular.element(document.querySelector('#' + $scope.sxId + '_tab-list')).removeClass('active');
    angular.element(document.querySelector('#' + $scope.sxId + '_tab-tree')).removeClass('active');
    angular.element(document.querySelector('#' + $scope.sxId + '_tab-details')).removeClass('active');
    angular.element(document.querySelector('#' + $scope.sxId + '_tab-s-' + tabName)).addClass('active');
    angular.element(document.querySelector('#' + $scope.sxId + '_tab-' + tabName)).addClass('active');
  }
  $scope.viewItemDetails = function (item) {
    $scope.undoNewRecord();
    loadSingleFullObj(item).then(function (resp) {
      angular.extend($scope.fullTmpObj, resp);
    });
    goToTab('details');
  };
  $scope.filtersTabEnabled = function () {
    return $scope.sxShowFilters == true;
  };
  $scope.detailsTabEnabled = function () {
    return $scope.sxShowDetails == true || $scope.sxAdd == true;
  };
  $scope.treeTabEnabled = function () {
    return $scope.sxShowTree == true;
  };
  $scope.listTabEnabled = function () {
    return $scope.sxShowList == true;
  };
  $scope.isActiveTab = function (tab) {
    if (tab == 'list' && $scope.listTabEnabled()) {
      return true;
    }
    if (tab == 'tree' && !$scope.listTabEnabled() && $scope.treeTabEnabled()) {
      return true;
    }
    return false;
  };

  /**** SCHEMA FUNCTIONS ****/

  // FIXME sarebbe corretto far recuperare lo schema puntando all'endpoint corretto... ad es. six-plan per lo schema delle issue
  function loadSchema() {
    if ($scope.vars.schemaLoaded == false && $scope.sxType) {
      schemaFactory().byUUID({
        id: $scope.sxType
      }).$promise.then(function (data) {
        if (!data.model) {
          dialogService.alert('Non è stato definito un modello per l\'entità ' + $scope.sxType, 4000);
          $scope.vars.schemaLoaded = false;
          return;
        }
        /* ***** Search filters ***** */
        $scope.sxSearchTerms.type_id = data;
        $scope.sxSearchTerms.type_obj = data;
        $scope.vars.schema = data.model.schema;
        $scope.vars.form = data.model.form;
        $scope.vars.commissionDependent = data.model.commissionDependent;
        $scope.vars.customerDependent = data.model.customerDependent;
        $scope.vars.historyMode = data.model.history;
        if (data.model.selfGeneratedCode) {
          $scope.vars.selfGeneratedCode = data.model.selfGeneratedCode;
        }
        $scope.vars.schemaLoaded = true;
      });
    }
  }

  /**** WATCHERS *****/

  $scope.$watchCollection(function (scope) {
    if (angular.isDefined(scope.ngModel)) {
      if (angular.isUndefined($scope.sxField)) {
        return scope.ngModel;
      } else {
        return scope.ngModel[$scope.sxField];
      }
    }
  }, function () {
    loadAllFullObjs();
    setPlaceholder();
    if (!isMultiple()) {
      if ($scope.ngModel && $scope.sxField) {
        setValueToShow($scope.ngModel[$scope.sxField]);
      } else if ($scope.ngModel) {
        setValueToShow($scope.ngModel);
      } else {
        setValueToShow();
      }
    }
  });
  $scope.$watch('sxWar', function (newValue, oldValue) {
    if (newValue && newValue != oldValue) {
      setWarUrl(newValue);
    }
  });
  $scope.$watch('sxType', function (newValue) {
    setPlaceholder();
    if (isListToLoad()) {
      if ($scope.listTabEnabled()) {
        refreshList($scope.filter.text);
      }
      if ($scope.treeTabEnabled()) {
        refreshTree($scope.filter.text);
      }
      if (newValue && newValue != undefined && ($scope.detailsTabEnabled() || $scope.filtersTabEnabled())) {
        $scope.vars.schemaLoaded = false; // type cambiato!!
        resetSxFilters();
        loadSchema();
      }
    }
    autoInit();
  });
  $scope.$watchCollection('sxFilter', function (newValue, oldValue) {
    if (newValue != oldValue && isListToLoad()) {
      if ($scope.listTabEnabled()) {
        refreshList($scope.filter.text);
      }
      if ($scope.treeTabEnabled()) {
        refreshTree($scope.filter.text);
      }
    }
    autoInit();
  });
  $scope.$watchCollection('sxAutoInit', function (newValue, oldValue) {
    if (newValue != oldValue) {
      if ($scope.listTabEnabled()) {
        refreshList($scope.filter.text);
      }
      if ($scope.treeTabEnabled()) {
        refreshTree($scope.filter.text);
      }
      autoInit();
    }
  });
  $scope.$watch('filter.text', function () {
    $scope.vars.page = 1;
    if (isListToLoad()) {
      if ($scope.listTabEnabled()) {
        refreshList($scope.filter.text);
      }
      if ($scope.treeTabEnabled()) {
        refreshTree($scope.filter.text);
      }
    }
  });
  $scope.$watch('vars.page', function () {
    if (isListToLoad()) {
      if ($scope.listTabEnabled()) {
        refreshList($scope.filter.text);
      }
      if ($scope.treeTabEnabled()) {
        refreshTree($scope.filter.text);
      }
    }
  });
  $scope.$watch('sxVisible', function (newVal, oldVal) {
    // chiudo tuttle le altre lookup e passo il mio id per comunicare che devo restare aperta solo io
    if (newVal === true && oldVal != true) {
      $rootScope.$broadcast('closeSixLookup2', {
        id: $scope.sxId
      });
    }
    if (isListToLoad()) {
      if ($scope.listTabEnabled()) {
        refreshList($scope.filter.text);
      }
      if ($scope.treeTabEnabled()) {
        refreshTree($scope.filter.text).then(function (tree) {
          if (!isEmpty()) {
            if ($scope.isMultiple()) {
              for (var i in $scope.sxObject) {
                var obj = $scope.sxObject[i];
                explodeNodePath($scope.tree, obj.parents.slice(1)); // tolgo il primo parent (è il riferimento al tree)
              }
            } else {
              if ($scope.sxObject) explodeNodePath($scope.tree, $scope.sxObject.parents.slice(1)); // tolgo il primo parent (è il riferimento al tree)
            }
          }
        });
      }

      if ($scope.detailsTabEnabled() || $scope.filtersTabEnabled()) {
        $scope.vars.schemaLoaded = false; // type cambiato!!
        resetSxFilters();
        loadSchema();
      }
    }
  });
  $rootScope.$on('closeSixLookup2', function ($event, args) {
    if (args && args.id != $scope.sxId) {
      // se non ho lanciato io il broadcast mi chiudo
      closeLookup();
    }
  });
  $scope.$on('sixlookup2:' + $scope.sxId + ':clear', function () {
    $scope.clearSelect();
  });
  $scope.$on('schemaFormValidate', function () {
    if ($scope.sxRequired && isEmpty()) {
      $scope.ngInvalid = true;
      $scope.ngValid = false;
    } else if ($scope.sxRequired && !isEmpty()) {
      $scope.ngInvalid = false;
      $scope.ngValid = true;
    }
  });

  /**** FILTERS FUNCTIONS ****/

  $scope.onFilterChanged = function () {
    if ($scope.listTabEnabled()) {
      refreshList($scope.filter.text);
    }
    if ($scope.treeTabEnabled()) {
      refreshTree($scope.filter.text);
    }
    goToTab('list');
  };
  $scope.clearSearchFn = function () {
    $scope.filter.text = '';
  };
  function resetSxFilters() {
    $scope.searchFilterObj = {}; //contiene i filtri di ricerca nel formato "sixFiltersLib"
    $scope.searchFilterArray = []; //contiene i filtri di ricerca nel formato usato dall'interfaccia
    $scope.sxSearchTerms.open = false;
    $scope.sxSearchTerms.type_id = undefined;
    $scope.sxSearchTerms.type_obj = undefined;
  }
  $scope.updateLookupFilter = function () {
    if ($scope.bools.currentcommission && $scope.bools.crossCommission) {
      delete $scope.searchFilterObj['commission'];
      delete $scope.searchFilterObj['cross_commission'];
    } else if ($scope.bools.currentcommission && !$scope.bools.crossCommission) {
      $scope.searchFilterObj['commission'] = sixFiltersLib.match('commission', currentCommission.code, sixFiltersLib.CONSTRAINTS.AND);
      delete $scope.searchFilterObj['cross_commission'];
    } else if (!$scope.bools.currentcommission && $scope.bools.crossCommission) {
      delete $scope.searchFilterObj['commission'];
      $scope.searchFilterObj['cross_commission'] = sixFiltersLib.missing('commission', sixFiltersLib.CONSTRAINTS.AND);
    } else {
      $scope.searchFilterObj['commission'] = sixFiltersLib.match('commission', currentCommission.code, sixFiltersLib.CONSTRAINTS.AND);
      $scope.searchFilterObj['cross_commission'] = sixFiltersLib.missing('commission', sixFiltersLib.CONSTRAINTS.AND);
    }
    $scope.onFilterChanged();
  };

  /**** OTHER ****/

  $timeout(function () {
    //per le lookup multiple con sidebar disabilito l'input manuale
    var tags = document.querySelectorAll(".sixLookup2-disable-input");
    tags.forEach(function (tag) {
      var input = tag.children[0].children[0].children[1];
      if (input && input.tagName == 'INPUT') {
        input.disabled = true;
      }
    });
  });
  function isMultiple() {
    return $scope.sxMultiple === true || $scope.sxMultiple === 'true';
  }
  $scope.isMultiple = isMultiple;
  function isListToLoad() {
    return $scope.sxVisible || $scope.sxCompact;
  }
  $scope.onFocusItCB = function () {
    if (!$scope.sxDisabled) {
      $scope.sxVisible = true;
    }
  };
  function closeLookup() {
    $scope.sxVisible = false;
    // emptyList();
  }

  function setPlaceholder() {
    if ($scope.sxEmptyPlaceholder) {
      $scope.emptyPlaceholder = $scope.sxEmptyPlaceholder;
    } else {
      $scope.emptyPlaceholder = ($scope.sxTitle || $scope.sxType || 'Seleziona').toLowerCase() + '...';
    }
    if (!$scope.ngModel || !$scope.ngModel[$scope.sxField] || $scope.ngModel[$scope.sxField].length == 0) {
      $scope.placeholder = $scope.emptyPlaceholder;
    } else if ($scope.sxPlaceholder) {
      $scope.placeholder = $scope.sxPlaceholder;
    } else {
      $scope.placeholder = ($scope.sxTitle || $scope.sxType || 'Seleziona').toLowerCase() + '...';
    }
  }
  $scope.evaluateTemplate = function (template, item) {
    var string = template.replace(/{{item\.(.*?)}}/g, function (match, token) {
      var tokens = token.split('.');
      return _evaluateTemplate(item, tokens);
    });
    return $filter('cut')(string, true, 100, '...');
  };
  function _evaluateTemplate(item, tokens) {
    if (!tokens || tokens.length == 0) {
      return item ? item : '';
    } else {
      return _evaluateTemplate(item[tokens[0]], tokens.slice(1));
    }
  }
  $scope.getDetailUrl = function (record) {
    if ($scope.sxBasePath == 'record' && record) {
      return '#/record/' + ($scope.vars.historyMode ? 'snap' : 'stable') + '/' + $scope.sxType + '/' + record.UUID;
    }
  };
}]);

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixLookup
 * @description
 * # sixLookup
 */
angular.module('emma.theme').directive('sixLookup2', ['$log', 'baseFactory', function ($log, baseFactory) {
  return {
    templateUrl: 'theme/directives/templates/sixlookup2.html',
    restrict: 'E',
    scope: {
      sxId: '@',
      ngModel: '=',
      sxBasePath: '=?',
      //nome dell'endpoint rest
      sxType: '=?',
      //tipo 'entity'
      sxField: '=?',
      //nome del campo nell'oggetto che mi referenzia
      sxObject: '=?',
      //nome del campo in cui salvare l'intero oggetto selezionato
      sxHistory: '=?',
      sxCross: '=?',
      // filtro cross commessa
      sxSearchPrefix: '=?',
      sxSearchPostfix: '=?',
      sxShowDescription: '=?',
      sxShowList: '=?',
      sxFilter: '=?',
      sxDisabled: '=?',
      sxPlaceholder: '=?',
      // placeholder mostrato quando la selezione è vuota (viene sempre mostrato in caso di selezione multipla)
      sxEmptyPlaceholder: '=?',
      // placeholder mostrato quando la selezione multipla è vuota
      sxWar: '=?',
      sxTitle: '=?',
      sxPosition: '=?',
      // posizione della sidebar: 'left'/'right'
      sxDimension: '=?',
      // dimensione sidebar: 's'/'m'/'l'
      sxAdd: '=?',
      sxShowTree: '=?',
      sxShowDetails: '=?',
      sxShowFilters: '=?',
      sxPinnable: '=?',
      sxVisible: '=?',
      sxMultiple: '@',
      sxPageSize: '=?',
      sxSources: '=?',
      sxFieldMapping: '=?',
      //usato solo per six-data-rel, incompatibile con sxSources (lo sovrascrive)
      sxCompact: '=?',
      // modalità compatta (a tendina) o con sidebar
      sxPrefill: '=?',
      sxItemTemplate: '=?',
      // template degli elementi da mostrare in lista. Es. <span>{{item.description}} ({{item.code}})</span>
      sxItemTemplateUrl: '=?',
      sxListItemTemplate: '=?',
      //template per la lista (solo sidebar), ha a disposizione anche i campi del model presi via sources
      sxMaxLength: '=?',
      // in associazione con sxMultiple, definisce il numero massimo di elementi selezionabili nella lookup
      sxAutoInit: '=?',
      // indica se la lookup deve auto-inizializzarsi quando la lista di record scaricati ha lunghezza uno
      sxOnSelect: '&?',
      sxOnClear: '&?',
      sxOnObjLoaded: '&?',
      sxRequired: '=?',
      sxShowLinkToDetail: '=?',
      // mostra/nasconde il button per accedere alla pagina di dettaglio del record selezionato
      sxDetailRoute: '=?',
      // route angular per il link alla pagina di dettaglio del record selezionato
      sxForm: '=?' // form in cui è contenuta la sixlookup2 (serve per la validazione e la segnalazione di eventuali errori)
    },

    transclude: true,
    controller: 'sixLookup2Ctrl'
  };
}]);
'use strict';

angular.module('emma.theme').controller('sixMonthPickerCtrl', ['$scope', '$log', function ($scope, $log) {
  $scope.getMonths = function () {
    var months = sixDateLib.getMonths();
    return months;
  };
  $scope.previousMonth = function () {
    if (sixDateLib.getMonthIndex($scope.ngModel) > 0) {
      var prevMonth = sixDateLib.getMonthIndex($scope.ngModel) - 1;
      $scope.ngModel = sixDateLib.getMonthName(prevMonth);
    }
  };
  $scope.nextMonth = function () {
    if (sixDateLib.getMonthIndex($scope.ngModel) < 11) {
      var prevMonth = sixDateLib.getMonthIndex($scope.ngModel) + 1;
      $scope.ngModel = sixDateLib.getMonthName(prevMonth);
    }
  };
}]);

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixLookup
 * @description
 * # sixLookup
 */
angular.module('emma.theme').directive('sixMonthPicker', function () {
  return {
    template: '<div class="input-group">' + '<a ng-click="previousMonth()" class="btn btn-default btn-sm">' + '<i class="fa fa-angle-left pull-left"></i>' + '</a>' + '<select ng-model="ngModel" class="btn btn-default btn-sm">' + '<option ng-repeat="m in getMonths()" value="{{m}}" ng-selected="ngModel == m">{{m}}</option>' + '</select>' + '<a ng-click="nextMonth()" class="btn btn-default btn-sm">' + '<i class="fa fa-angle-right pull-left"></i>' + '</a>' + '</div>',
    restrict: 'E',
    scope: {
      ngModel: '=',
      sxChange: '&'
    },
    controller: 'sixMonthPickerCtrl'
  };
});
'use strict';

/*
 http://jsfiddle.net/PW48M/
 http://bl.ocks.org/mbostock/3884955
 heatmap http://bl.ocks.org/oyyd/859fafc8122977a3afd6


 [ES: dati

 {"date":"2013-12-31T23:00:00.000Z",
 "Consuntivo":"8",
 "Storico":"8",}

 {"date":"2014-01-01T23:00:00.000Z",
 "Consuntivo":"9",
 "Storico":"8",

 {"date":"2014-01-02T23:00:00.000Z",
 "Consuntivo":"8",
 "Storico":"8",
 "Consuntivo (cum.)":"0.1588021778584392",
 "Storico (cum.)":"0.24525547445255477"},
 ...etc

 */
angular.module('emma.theme').controller('sixMultiSeriesLineChartCtrl', ['$scope', '$log', 'SaveAs', '$window', function ($scope, $log, SaveAs, $window) {
  var w = angular.element($window);
  w.bind('resize', function () {
    console.log('resizing graph');
    $scope.showGraph();
  });
  $scope.dateAxisFormats = [{
    name: 'HH:mm:ss',
    value: '%H:%M:%S'
  }, {
    name: 'dd/MM/yy',
    value: '%d/%m/%Y'
  }, {
    name: 'dd/MM',
    value: '%d/%m'
  }, {
    name: 'dd',
    value: '%d'
  }, {
    name: 'MM',
    value: '%b'
  }, {
    name: 'MMMM',
    value: '%B'
  }, {
    name: 'MM yy',
    value: '%b %y'
  }, {
    name: 'MMMM yy',
    value: '%B %y'
  }, {
    name: 'MMMM yyyy',
    value: '%B %Y'
  }];

  //linear – Normal line (jagged).
  //step-before – a stepping graph alternating between vertical and horizontal segments.
  //step-after - a stepping graph alternating between horizontal and vertical segments.
  //basis - a B-spline, with control point duplication on the ends (that's the one above).
  //basis-open - an open B-spline; may not intersect the start or end.
  //basis-closed - a closed B-spline, with the start and the end closed in a loop.
  //bundle - equivalent to basis, except a separate tension parameter is used to straighten the spline. This could be really cool with varying tension.
  //cardinal - a Cardinal spline, with control point duplication on the ends. It looks slightly more 'jagged' than basis.
  //cardinal-open - an open Cardinal spline; may not intersect the start or end, but will intersect other control points. So kind of shorter than 'cardinal'.
  //cardinal-closed - a closed Cardinal spline, looped back on itself.
  //monotone - cubic interpolation that makes the graph only slightly smoother.

  $scope.interpolationTypes = [{
    name: 'linear',
    value: 'linear'
  }, {
    name: 'step-before',
    value: 'step-before'
  }, {
    name: 'step-after',
    value: 'step-after'
  }, {
    name: 'basis',
    value: 'basis'
  }, {
    name: 'basis-open',
    value: 'basis-open'
  }, {
    name: 'basis-closed',
    value: 'basis-closed'
  }, {
    name: 'bundle',
    value: 'bundle'
  }, {
    name: 'cardinal',
    value: 'cardinal'
  }, {
    name: 'cardinal-open',
    value: 'cardinal.open'
  }, {
    name: 'cardinal-closed',
    value: 'cardinal-closed'
  }, {
    name: 'monotone',
    value: 'monotone'
  }];
  $scope.chartTypes = [{
    name: 'line',
    value: 'line'
  }, {
    name: 'bar',
    value: 'bar'
  }];
  $scope.sxXAxisFormat = $scope.sxXAxisFormat || '%B';
  $scope.sxXAxisTicks = $scope.sxXAxisTicks || undefined;
  $scope.sxInterpolate = $scope.sxInterpolate || 'monotone';
  $scope.sxShowPoints = $scope.sxShowPoints || false;
  $scope.sxChartType = $scope.sxChartType || 'line';
  (function () {
    d3.legend = function (g) {
      g.each(function () {
        var g = d3.select(this),
          items = {},
          svg = d3.select(g.property("nearestViewportElement")),
          legendPadding = g.attr("data-style-padding") || 5,
          lb = g.selectAll(".legend-box").data([true]),
          li = g.selectAll(".legend-items").data([true]);
        lb.enter().append("rect").classed("legend-box", true);
        li.enter().append("g").classed("legend-items", true);
        svg.selectAll("[data-legend]").each(function () {
          var self = d3.select(this);
          items[self.attr("data-legend")] = {
            pos: self.attr("data-legend-pos") || this.getBBox().y,
            color: self.attr("data-legend-color") != undefined ? self.attr("data-legend-color") : self.style("fill") != 'none' ? self.style("fill") : self.style("stroke")
          };
        });
        items = d3.entries(items).sort(function (a, b) {
          //return a.value.pos-b.value.pos}
          return a.name < b.name;
        });
        li.selectAll("text").data(items, function (d) {
          return d.key;
        }).call(function (d) {
          d.enter().append("text");
        }).call(function (d) {
          d.exit().remove();
        }).attr("y", function (d, i) {
          return i + "em";
        }).attr("x", "1em").text(function (d) {
          ;
          return d.key;
        });
        li.selectAll("circle").data(items, function (d) {
          return d.key;
        }).call(function (d) {
          d.enter().append("circle");
        }).call(function (d) {
          d.exit().remove();
        }).attr("cy", function (d, i) {
          return i - 0.25 + "em";
        }).attr("cx", 0).attr("r", "0.4em").style("fill", function (d) {
          return d.value.color;
        });

        // Reposition and resize the box
        var lbbox = li[0][0].getBBox();
        lb.attr("x", lbbox.x - legendPadding).attr("y", lbbox.y - legendPadding).attr("height", lbbox.height + 2 * legendPadding).attr("width", lbbox.width + 2 * legendPadding).style("fill", "none");
      });
      return g;
    };
  })();
  $scope.showGraph = function () {
    var containerWidth = 1024;

    //console.log(document.getElementById('graphPlaceholder'+$scope.sxId));
    var placeholder = document.getElementById('graphPlaceholder' + $scope.sxId);
    if (placeholder != null && !angular.isUndefined(placeholder) && !angular.isUndefined(placeholder.parentElement) && !angular.isUndefined(placeholder.parentElement.parentElement)) {
      containerWidth = placeholder.parentElement.parentElement.clientWidth;
      if (containerWidth < 200) {
        containerWidth = 1024;
      }
      //console.log('containerWidth:'+containerWidth);
    }

    var margin = {
        top: 20,
        right: 80,
        bottom: 30,
        left: 50
      },
      width = containerWidth - margin.left - margin.right,
      height = $scope.sxHeight > 0 ? $scope.sxHeight : 200;
    var parseDate = d3.time.format("%Y%m%d").parse;
    var myFormatter = d3.time.format = d3.locale({
      "decimal": ".",
      "thousands": ",",
      "grouping": [3],
      "currency": ["€", ""],
      "dateTime": "%a %b %e %X %Y",
      "date": "%d/%m/%Y",
      "time": "%H:%M:%S",
      "periods": ["AM", "PM"],
      "days": ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
      "shortDays": ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
      "months": ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
      "shortMonths": ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"]
    });
    d3.time.format = myFormatter.timeFormat;
    var data = $scope.sxGraphData;
    if (angular.isUndefined(data) || !data || data == {}) {
      $log.error("No graphData");
      return;
    }
    var x = d3.time.scale().range([0, width]);
    var y = d3.scale.linear().range([height, 0]);
    var color = d3.scale.category10();
    if ($scope.sxSeriesColors) {
      //es: color.range(["#1044EE", "#10BB99", "red"]);
      //es: v. daydegree.html
      color.range($scope.sxSeriesColors);
    }
    var xAxis = d3.svg.axis().scale(x).orient("bottom").tickFormat(myFormatter.timeFormat($scope.sxXAxisFormat)).ticks($scope.sxXAxisTicks);
    var yAxis = d3.svg.axis().scale(y).orient("left");
    var line = d3.svg.line().interpolate($scope.sxInterpolate).x(function (d) {
      return x(d.date);
    }).y(function (d) {
      return y(d.value);
    });
    d3.select("#ddGraph" + $scope.sxId).remove();
    var svg = d3.select("#graphPlaceholder" + $scope.sxId).append("svg").attr("id", "ddGraph" + $scope.sxId).attr("width", "100%" /*width + margin.left + margin.right*/).attr("height", height + margin.top + margin.bottom).append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");
    color.domain(d3.keys(data[0]).filter(function (key) {
      return key !== "date";
    }));
    var pointsMap = color.domain().map(function (name, i) {
      return {
        name: name,
        values: data.map(function (d) {
          return {
            seriesIdx: i,
            name: name,
            date: d.date,
            value: +d[name]
          };
        })
      };
    });
    var xExtent = d3.extent(data, function (d) {
      return d.date;
    });
    var nxExtent = [d3.time.day.offset(xExtent[0], -20), d3.time.day.offset(xExtent[1], 20)];
    x.domain(nxExtent);
    //x.domain(d3.extent(data, function(d) { return d.date; }));

    y.domain([0, d3.max(pointsMap, function (c) {
      return d3.max(c.values, function (v) {
        return v.value;
      });
    })]);
    svg.append("g").attr("class", "xaxis").attr("transform", "translate(0," + height + ")").call(xAxis);
    svg.append("g").attr("class", "xaxis").call(yAxis).append("text").attr("transform", "rotate(-90)").attr("y", 6).attr("dy", ".71em").style("text-anchor", "end").text($scope.sxYAxisLegend);
    var point = svg.selectAll(".point").data(pointsMap).enter().append("g").attr("class", "point");
    var tip = d3.tip().attr('class', 'd3-tip').offset([-10, 0]).html(function (d) {
      return "<strong style='color:" + color(d.name) + "'>" + d.name.split(' ')[0] + ": </strong> <span>" + parseFloat(Math.round(d.value * 1000) / 1000).toFixed(3) + "</span>";
    });
    if (svg[0][0]) {
      svg.call(tip);
    } else {
      return; //non so bene a cosa serve questo controllo... ma evita eccezioni
    }

    switch ($scope.sxChartType) {
      case 'line':
        // Line chart
        point.append("path").attr("class", "line").attr("d", function (d) {
          return line(d.values);
        }).attr("data-legend", function (d) {
          return d.name;
        }).style("fill", "none").style("stroke", function (d) {
          return color(d.name);
        }).on("mouseover", function (d) {
          d3.select(this).style("opacity", 1);
          var lines = $('.line').not(this); //select all the rest of the lines, except the one you are hovering on and drop their opacity
          d3.selectAll(lines).style("opacity", 0.2);
        }).on("mouseout", function (d) {
          var lines = $('.line'); //select all the rest of the lines, except the one you are hovering on and drop their opacity
          d3.selectAll(lines).style("opacity", 1);
        });

        // Tooltip
        if ($scope.sxShowPoints === true) {
          // Disegna i pallini in corrispondenza dei punti
          // http://bl.ocks.org/ChrisJamesC/5896521/943f325deacb4a533e086d56478c1e76b6c6b4bd
          point.append("g").selectAll("circle").data(function (d) {
            return d.values;
          }).enter().append("circle").attr("class", "circle").attr("r", 4).attr("cx", function (dd) {
            return x(dd.date);
          }).attr("cy", function (dd) {
            return y(dd.value);
          }).attr("fill", function (dd) {
            return color(dd.name);
          }).attr("stroke", function (dd) {
            return color(dd.name);
          })
          // Tooltip stuff after this [https://github.com/Caged/d3-tip]
          .on("mouseover", tip.show).on("mouseout", tip.hide);
        }
        ;
        point.append("text").datum(function (d) {
          return {
            name: d.name,
            value: d.values[d.values.length - 1]
          };
        }).attr("transform", function (d) {
          return "translate(" + x(d.value.date) + "," + y(d.value.value) + ")";
        }).attr("x", 3).attr("dy", ".35em").text(function (d) {
          return d.name;
        });
        break;
      case 'bar':
        // Bar chart [http://bl.ocks.org/mbostock/3887051]
        var barWidth = (width - 150) / data.length / pointsMap.length;
        var offset = pointsMap.length % 2 !== 0 ? barWidth / 2 : 0;
        point.selectAll("rect").data(function (d) {
          return d.values;
        }).enter().append("rect").attr("data-legend", function (d) {
          return d.name;
        }).attr("class", function (d) {
          return "rect_" + d.seriesIdx;
        }).attr("x", function (d) {
          return x(d.date) - d.seriesIdx * barWidth + offset;
        }).attr("y", function (d) {
          return y(d.value);
        }).attr("width", function (d) {
          return barWidth;
        }).attr("height", function (d) {
          return height - y(d.value);
        }).style("fill", function (d) {
          return color(d.name);
        }).on("mouseover", function (d) {
          d3.select(this).style("opacity", 1);
          var thisClass = d3.select(this).attr("class");
          var bars = $("[class^=rect]").not($("[class^=" + thisClass + "]")); //select all the rest of the bars, except the one you are hovering on and drop their opacity
          d3.selectAll(bars).style("opacity", 0.2);
          tip.show(d);
        }).on("mouseout", function (d) {
          var bars = $('[class^=rect]'); //select all the rest of the bars, except the one you are hovering on and drop their opacity
          d3.selectAll(bars).style("opacity", 1);
          tip.hide(d);
        });
        break;
    }
    var legend = svg.append("g").attr("class", "legend").attr("transform", "translate(50,30)").style("font-size", "9px").call(d3.legend);
  };
  $(function () {
    $("#btnSave").click(function () {
      var svg = document.getElementById("ddGraph" + $scope.sxId).outerHTML;
      var options = {
        type: "data:image/svg+xml;base64"
      };
      SaveAs.download(svg, 'graph.svg', options);
      canvg('canvas', document.getElementById("ddGraph" + $scope.sxId).innerHTML, {
        forceRedraw: true,
        ignoreAnimation: true
      });
      html2canvas([document.getElementById("canvas")], {
        onrendered: function onrendered(canvas) {
          document.body.appendChild(canvas);
        }
      });
    });
  });
  $scope.$watchCollection(function (scope) {
    if (angular.isDefined(scope.sxGraphData)) {
      return scope.sxGraphData.concat([scope.sxXAxisFormat, scope.sxXAxisTicks, scope.sxInterpolate, scope.sxShowPoints, scope.sxChartType]);
    } else {
      return null;
    }
  }, function (newValue, oldValue) {
    //$log.debug('reloading graph ' + $scope.sxId);
    $scope.showGraph();
  });
  $scope.selectXAxisFormat = function (f) {
    $scope.sxXAxisFormat = f.value;
  };
  $scope.selectInterpolationType = function (t) {
    $scope.sxInterpolate = t.value;
  };
  $scope.selectChartType = function (t) {
    $scope.sxChartType = t.value;
  };
  $scope.formatForwardMapping = function (name, list) {
    var result;
    list.forEach(function (item) {
      if (item.name === name) {
        result = item.value;
      }
    });
    return result;
  };
  $scope.formatBackwardMapping = function (value, list) {
    var result;
    list.forEach(function (item) {
      if (item.value === value) {
        result = item.name;
      }
    });
    return result;
  };
  $scope.togglePoints = function () {
    $scope.sxShowPoints = !$scope.sxShowPoints;
  };
}]);

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixMultiSeriesLineChart
 * @description
 * # sixMultiSeriesLineChart
 */
angular.module('emma.theme').directive('sixMultiSeriesLineChart', ['$log', function ($log) {
  return {
    template: '<style>#graphPlaceholder{{sxId}} {font: 10px monospace;}' + '.axis path, .axis line {fill: none; stroke: #000; shape-rendering: crispEdges;}' + '.x.axis path {display: none;}' + '.line {fill: none; stroke: steelblue;stroke-width: 2.0px;}' +
    //'.line:hover {stroke-width: 4.0px;}' +
    '.legend rect { fill:white; stroke:black; opacity:0.4; }' + '.custom-toolbar { margin-left: 0 }' + '.custom-navbar { min-height: 25px !important }' + '.custom-navbar-nav > li > a { padding: 8px 15px 8px 0px}' + '.custom-navbar-form { margin: 3px 15px 3px 0px}' + '.circle { fill-opacity: 0.2; }' + '.circle:hover { fill-opacity: 1; }' + '.d3-tip {                    ' + '  line-height: 1;            ' + '  font-weight: bold;         ' + '  padding: 12px;             ' + '  background: rgba(0, 0, 0, 0.8); ' + '  color: #fff;               ' + '  border-radius: 2px;        ' + '}                            ' + /* Creates a small triangle extender for the tooltip */
    'd3-tip:after {               ' + '  box-sizing: border-box;    ' + '  display: inline;           ' + '  font-size: 10px;           ' + '  width: 100%;               ' + '  line-height: 1;            ' + '  color: rgba(0, 0, 0, 0.8); ' + '  content: "p";          ' + '  position: absolute;        ' + '  text-align: center;        ' + '}                            ' + /* Style northward tooltips differently */
    'd3-tip.n:after {             ' + '  margin: -1px 0 0 0;        ' + '  top: 100%;                 ' + '  left: 0;                   ' + '}                            ' + '</style>' + '<nav class="navbar navbar-default custom-navbar" ng-show="sxHideToolbar !== \'true\' && sxGraphData && sxGraphData.length">' + '<div class="navbar-collapse custom-toolbar" id="toolbar">' + '<ul class="nav navbar-nav custom-navbar-nav">' +
    //<!-- Asse x -->
    '<li>' + '<a href class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false">' + '<i class="fa fa-arrows-h icon text-primary-dker"></i>' + '<span class="font-bold">: </span>' + '<span class="pull-right text-muted">' + '<i class="fa fa-fw fa-angle-down text"></i>' + '</span>' + '<span class="font-bold">{{formatBackwardMapping(sxXAxisFormat, dateAxisFormats)}}</span>' + '</a>' + '<ul class="dropdown-menu">' + '<li ng-repeat="f in dateAxisFormats">' + '<a href ng-click="selectXAxisFormat(f)">{{f.name}}</a>' + '</li>' + '</ul>' + '</li>' +
    //<!-- Asse x: end -->

    //<!-- Chart type -->
    '<li>' + '<a href class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false">' + '<i class="fa fa-bar-chart icon text-success-dker"></i>' + '<span class="font-bold">: </span>' + '<span class="pull-right text-muted">' + '<i class="fa fa-fw fa-angle-down text"></i>' + '</span>' + '<span class="font-bold">{{formatBackwardMapping(sxChartType, chartTypes)}}</span>' + '</a>' + '<ul class="dropdown-menu">' + '<li ng-repeat="t in chartTypes">' + '<a href ng-click="selectChartType(t)">{{t.name}}</a>' + '</li>' + '</ul>' + '</li>' +
    //<!-- Chart type: end -->

    //<!-- Interpolation -->
    '<li>' + '<a href class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false">' + '<i class="fa fa-line-chart icon text-info-dker"></i>' + '<span class="font-bold">: </span>' + '<span class="pull-right text-muted">' + '<i class="fa fa-fw fa-angle-down text"></i>' + '</span>' + '<span class="font-bold">{{formatBackwardMapping(sxInterpolate, interpolationTypes)}}</span>' + '</a>' + '<ul class="dropdown-menu">' + '<li ng-repeat="t in interpolationTypes">' + '<a href ng-click="selectInterpolationType(t)">{{t.name}}</a>' + '</li>' + '</ul>' + '</li>' +
    //<!-- Interpolation: end -->

    //<!-- Show Points -->
    '<li>' + '<a href ng-click="togglePoints()">' + '<i class="fa fa-fw fa-square-o icon" ng-if="!sxShowPoints"></i>' + '<i class="fa fa-fw fa-check-square-o icon" ng-if="sxShowPoints"></i>' + '<span class="font-bold"> Punti</span>' + '</a>' + '</li>' +
    //<!-- Show Points: end -->

    '</ul>' +
    //<!-- Asse x: ticks -->
    '<form class="navbar-form navbar-left custom-navbar-form" role="search">' + '<div class="input-group input-group-sm"> ' + '<span class="font-bold input-group-addon" id="basic-addon1">X Ticks</span>' + '<input style="width:75px; height: 30px" type="number" ng-model="sxXAxisTicks" class="form-control text-xs" maxlength="3"></input>' + '</div>' + '</form>' +
    //<!-- Asse x ticks: end -->

    '<ul class="nav navbar-nav custom-navbar-nav navbar-left">' + '<li><input type="button" id="btnSave" class="btn btn-default btn-sm" value="Save"/></li>' + '</ul>' + '<ul class="nav navbar-nav custom-navbar-nav navbar-right">' + '<li><a href><span class="font-bold">{{sxGraphTitle}}</span></a></li>' + '</ul>' + '</div>' + '</nav>' + '<div id="graphPlaceholder{{sxId}}" ng-show="sxGraphData && sxGraphData.length"></div>' + '<canvas id="canvas" width=1200 height=350 style="display: none"></canvas>',
    restrict: 'E',
    scope: {
      sxGraphData: '=',
      sxId: '@',
      //da usare se si vogliono mettere più grafici!
      sxYAxisLegend: '=?',
      sxXAxisFormat: '=?',
      sxXAxisTicks: '=?',
      sxHideToolbar: '=?',
      sxGraphTitle: '@',
      sxSeriesColors: '=?',
      sxShowPoints: '=?',
      sxInterpolate: '=?',
      // basis (default), linear , step-after, etc... http://www.d3noob.org/2013/01/smoothing-out-lines-in-d3js.html
      sxChartType: '=?',
      // line, bar
      sxHeight: '=?'
    },
    controller: 'sixMultiSeriesLineChartCtrl'
  };
}]);
'use strict';

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixPagination
 * @description
 * # sixPagination
 */
angular.module('emma.theme').directive('sixPagination', ["$filter", function ($filter) {
  return {
    template: '<uib-pagination total-items="totalItems" ng-model="ngModel" items-per-page="itemsPerPage" max-size="maxSize" boundary-links="true" class="pagination-sm" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></uib-pagination>',
    restrict: 'E',
    scope: {
      ngModel: '=',
      totalItems: '=',
      maxSize: '=',
      itemsPerPage: '='
      //items: '=',
      //filterName: '@',
      //updateEvt: '=',
      //watchEvt: '='
    },

    link: function link(scope, element, attrs) {
      //// $watch search to update pagination
      //scope.$watch('updateEvt', function (newVal, oldVal) {
      //  scope.filtered = $filter(scope.filterName)(scope.items, newVal);
      //  scope.totalItems = scope.filtered.length;
      //  //scope.maxSize = Math.ceil(scope.totalItems / scope.itemsPerPage);
      //  scope.ngModel = 1;
      //}, true);
      //
      //scope.$on('watchEvt', function (newVal, oldVal) {
      //  scope.filtered = $filter(scope.filterName)(scope.items, newVal);
      //  scope.totalItems = scope.filtered.length;
      //  //scope.maxSize = Math.ceil(scope.totalItems / scope.itemsPerPage);
      //  scope.ngModel = 1;
      //});
    }
  };
}]);
'use strict';

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixRecordSidebar
 * @description
 * # sixRecordSidebar
 *
 * <six-sidebar lookup-model="contatoreType" lookup-type="'schema'" lookup-field="'tipo_id'" lookup-filter="contatoreTypeFilter" ng-model="contatore.contatore_id" custom-class="'custom-sidebar'"></six-sidebar>
 */
angular.module('emma.theme').directive('sixRecordSidebar', function () {
  return {
    template: '' + '<style type="text/css">' + '.floating-button {' + 'position: fixed;' + 'opacity: 0.5;' + 'overflow: hidden;' + 'text-align: center;' + 'z-index: 99999999;' + 'background-color: #1199C4;' + 'color: #eeeeee;' + 'width: 25px;' + 'height: 25px;' + 'padding-top: 2px;' + 'border-top-right-radius: 10px;' + 'border-bottom-right-radius: 10px;' + '-webkit-transition: all 0.5s ease-in-out;' + '-moz-transition: all 0.5s ease-in-out;' + '-ms-transition: all 0.5s ease-in-out;' + '-o-transition: all 0.5s ease-in-out;' + 'transition: all 0.5s ease-in-out;' + '}' + '.selected {' + 'background-color: #11c7f5 !important;' + '} ' + '</style> ' + '<div class="list-sidebar-overlay"></div> ' + '<aside id="list-sidebar" class="list-sidebar list-sidebar-default open list-sidebar-stacked {{customClass}}" role="navigation"> ' + '<div class="m-xs"> ' + '<six-lookup ng-model="lookupModel" sx-type="lookupType" sx-field="lookupField" sx-filter="lookupFilter" sx-placeholder="\'Tipo...\'" <!--sx-base-path="lookupBasePath"-->></six-lookup> ' + '</div> ' + '<ul class="nav list-sidebar-nav"> ' + '<li ng-if="!recordList || recordList.length == 0"> ' + '<a> ' + '<span ng-if="lookupModel && lookupModel[lookupField] && lookupModel[lookupField].description">Nessun {{lookupModel[lookupField].description}} caricato</span> ' + '<span ng-if="!lookupModel || !lookupModel[lookupField] || !lookupModel[lookupField].description">Selezionare un tipo di record</span> ' + '</a> ' + '</li> ' + '<span ng-if="recordList && recordList.length > 0"> ' + '<li> ' + '<div class="form-group m-l-xs m-r-xs"> ' + '<six-search-form ng-model="recordSearchText.text" placeholder="Filtra..." show-search-btn="false"></six-search-form> ' + '</div> ' + '</li> ' + '<li ng-repeat="record in recordList | filter:recordSearchText.text"> ' + '<a ng-click="selectRecord(record.UUID, record.model.code, record.model.description)" title="{{record.model.code}} - {{record.model.description}}" ng-class="{\'selected\': isRecordSelected(record.UUID)}"> ' + '{{record.model.code}} - {{record.model.description}} ' + '</a> ' + '</li> ' + '</span> ' + '</ul> ' + '</aside> ' + '<div class="list-sidebar-toggle floating-button" ng-click="toggleSidebar()"> ' + '<i ng-class="{\'fa fa-times\': isSidebarOpened==true, \'fa fa-bars\': isSidebarOpened==false}"></i> ' + '</div>',
    restrict: 'E',
    scope: {
      ngModel: '=',
      lookupType: '=',
      lookupBasePath: '=',
      lookupModel: '=',
      lookupField: '=',
      lookupFilter: '=',
      customClass: '='
    },
    link: function postLink(scope, element, attrs) {
      $(document).ready(function () {
        $('.list-sidebar-overlay').on('click', function () {
          $(this).removeClass('active');
          $('#list-sidebar').removeClass('open');
        });
      });
    },
    controller: ["$scope", "$element", "baseFactory", "$log", function controller($scope, $element, baseFactory, $log) {
      $scope.isSidebarOpened = angular.element(document.getElementById('list-sidebar')).hasClass('open');
      $scope.recordList = [];
      $scope.lookupBasePath = $scope.lookupBasePath || 'record';
      $scope.loadRecords = function () {
        if ($scope.lookupModel && $scope.lookupModel[$scope.lookupField] && $scope.lookupModel[$scope.lookupField].code) {
          $scope.recordList = baseFactory('record/' + $scope.lookupModel[$scope.lookupField].code + '/_lookup').select({
            pageSize: 1000
          });
        }
      };
      $scope.selectRecord = function (uuid, code, description) {
        if (uuid) {
          $scope.ngModel = {
            type: $scope.lookupModel[$scope.lookupField].code,
            UUID: uuid,
            code: code,
            description: description
          };
        }
      };
      $scope.isRecordSelected = function (uuid) {
        if ($scope.ngModel) {
          return $scope.ngModel.UUID === uuid;
        }
        return false;
      };
      $scope.toggleSidebar = function () {
        var sidebar = angular.element(document.getElementById('list-sidebar'));
        var overlay = angular.element(document.getElementsByClassName('list-sidebar-overlay')[0]);
        sidebar.toggleClass('open');
        $scope.isSidebarOpened = sidebar.hasClass('open');
        if ((sidebar.hasClass('list-sidebar-fixed-left') || sidebar.hasClass('list-sidebar-fixed-right')) && sidebar.hasClass('open')) {
          overlay.addClass('active');
        } else {
          overlay.removeClass('active');
        }
      };
      $scope.$watchCollection(function () {
        return $scope.lookupModel;
      }, function (newValue, oldValue) {
        $scope.recordList = [];
        if (newValue) {
          $scope.loadRecords();
        }
      });
    }]
  };
});
'use strict';

/**
 * @ngdoc directive
 * @name emma.theme.directive:searchForm
 * @description
 * # searchForm
 */
angular.module('emma.theme').directive('sixSearchForm', function () {
  return {
    templateUrl: 'theme/directives/templates/sixsearchform.html',
    restrict: 'E',
    scope: {
      ngModel: '=',
      placeholder: '@',
      showSearchBtn: '=',
      hideClearBtn: '=',
      isValid: '=',
      cstKeyupFn: '&keyupFn',
      // Custom keyup function
      cstClearFn: '&clearFn',
      // Custom clear function
      cstSearchFn: '&searchFn',
      // Custom search function
      cstOnChangeFn: '&changeFn' // Custom change function
    },

    link: function postLink(scope, element, attrs) {
      if (!attrs.hasOwnProperty('showSearchBtn')) {
        scope.showSearchBtn = true;
      }
      if (!attrs.hasOwnProperty('hideClearBtn')) {
        scope.hideClearBtn = false;
      }
    },
    controller: ["$scope", "$element", function controller($scope, $element) {
      $scope.keyupFn = function ($event) {
        $scope.showClearBtn = Boolean($scope.ngModel) && !$scope.hideClearBtn;
        if ($scope.cstKeyupFn) {
          $scope.cstKeyupFn({
            "$event": $event
          });
        }
      };
      $scope.clearSearchFn = function () {
        $scope.ngModel = "";
        $scope.showClearBtn = false;
        if ($scope.cstClearFn) {
          $scope.cstClearFn();
        }
      };
      $scope.searchFn = function () {
        if ($scope.cstSearchFn) {
          $scope.cstSearchFn();
        }
      };
      $scope.changeFn = function () {
        if ($scope.cstOnChangeFn) {
          $scope.cstOnChangeFn();
        }
      };
    }]
  };
});
'use strict';

angular.module('emma.theme').controller('sixSelectCtrl', ['$scope', '$log', function ($scope, $log) {
  $scope.object;
  if (angular.isUndefined($scope.sxShowDescription)) {
    $scope.sxShowDescription = false;
  }
  $scope.sxDescriptionClass = $scope.sxDescriptionClass || 'font-bold';
  $scope.select = function (item) {
    $scope.object = item;
    $scope.ngModel = item;
    if ($scope.sxSelect) {
      $scope.sxSelect();
    }
  };
  $scope.clearSelect = function () {
    $scope.select(undefined);
    if ($scope.sxClearSelect) {
      $scope.sxClearSelect();
    }
  };
  $scope.getSelectMatch = function (obj) {
    if (angular.isUndefined(obj)) {
      return undefined;
    }
    if (angular.isUndefined(obj.description)) {
      return obj.code;
    }
    if (!angular.isUndefined(obj.description)) {
      return obj.description;
    }
    return undefined;
  };
  $scope.$watch(function () {
    return $scope.ngModel;
  }, function (newValue, oldValue) {
    // TODO va bene commentare? altrimenti non si riesce a sbiancare la lookup dall'esterno...
    //if(newValue) {
    $scope.object = $scope.ngModel;
    //}
  });
}]);

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixSelect
 * @description
 * # sixSelect
 */
angular.module('emma.theme').directive('sixSelect', function () {
  return {
    template: '<div class="input-group has-button" style="width: 100%">' + '<ui-select ng-model="ngModel" theme="bootstrap" on-select="select($item)" reset-search-input="false" ng-disabled="sxDisabled">' + '<ui-select-match class="ui-select-match" placeholder="Enter...">{{getSelectMatch(object)}}</ui-select-match>' + '<ui-select-choices class="ui-select-choices" repeat="item in sxItemList track by $index">' + '<div ng-bind-html="item.description | highlight: $select.search"></div>' + '<small ng-bind-html="item.code | highlight: $select.search"></small>' + '</ui-select-choices>' + '</ui-select>' + '<span class="input-group-btn">' + '<button type="button" class="btn btn-bg btn-default" ng-click="clearSelect()" ng-disabled="sxDisabled"><i class="fa fa-times"></i></button>' + '</span>' + '</div>' + '<div ng-if="sxShowDescription === true" class="{{sxDescriptionClass}}">' + '{{ngModel.description}}' + '</div>',
    restrict: 'E',
    scope: {
      ngModel: '=',
      sxItemList: '=',
      sxShowDescription: '=?',
      sxDescriptionClass: '=?',
      sxSelect: '&',
      sxClearSelect: '&',
      sxDisabled: '=?'
    },
    controller: 'sixSelectCtrl'
  };
});
'use strict';

angular.module('emma.theme').controller('sixSelect2Ctrl', ['$scope', '$rootScope', '$log', 'baseFactory', 'schemaFactory', 'dialogService', 'recordFactory', 'lookupFactory', 'counterFactory', 'toaster', '$q', '$filter', 'DATA_SET_URL', '$timeout', function ($scope, $rootScope, $log, baseFactory, schemaFactory, dialogService, recordFactory, lookupFactory, counterFactory, toaster, $q, $filter, DATA_SET_URL, $timeout) {
  /**** VARIABLES INIT *****/

  if (angular.isUndefined($scope.sxObject)) {
    $scope.sxObject = {};
  } // oggetto completo da restituire al chimante della six-lookup-2
  if (angular.isUndefined($scope.sxClearable)) {
    $scope.sxClearable = true;
  }
  if (angular.isUndefined($scope.sxPinnable)) {
    $scope.sxPinnable = false;
  } // indica se la sidebar può essere bloccata o meno
  if (angular.isUndefined($scope.sxVisible)) {
    $scope.sxVisible = false;
  } // indica se la sidebar è visibile o meno
  if (angular.isUndefined($scope.sxMultiple)) {
    $scope.sxMultiple = false;
  } // indica se la lookup deve gestire valori multipli o singoli
  if (angular.isUndefined($scope.sxPlaceholder)) {
    $scope.sxPlaceholder = ($scope.sxTitle || $scope.sxType || 'Seleziona').toLowerCase() + '...';
  }
  if (angular.isUndefined($scope.sxEmptyPlaceholder)) {
    $scope.sxEmptyPlaceholder = $scope.sxPlaceholder;
  }
  if (angular.isUndefined($scope.sxRequired)) {
    $scope.sxRequired = false;
  }
  $scope.sxKey = $scope.sxKey || 'key'; // nome dell'attributo che funge da key
  $scope.sxDescription = $scope.sxDescription || 'description'; // nome dell'attributo che funge da description
  $scope.sxDescriptionClass = $scope.sxDescriptionClass || 'font-bold';
  $scope.sxPosition = $scope.sxPosition || 'left'; // posizione della sidebar (left|right)
  $scope.sxDimension = $scope.sxDimension || 'l'; // dimensione della sidebar (s|m|l)
  $scope.valueToShow = undefined; // valore selezionato da mostrare nella input text della lookup se singola
  $scope.sxPinned = isMultiple(); // indica se la sidebar è bloccata o meno (inizializzata qui)
  $scope.sxMaxSelected = $scope.sxMaxSelected || -1; // indica il limite di elementi selezionabili se isMultiple = true (infiniti quando sxMaxSelected <= 0)

  $scope.filter = {
    text: ''
  };
  setPlaceholder(); // inizializzo il placeholder da mostrare

  // $scope.sxList = [
  //   { key: key, description: description }
  // ];

  /**** LIST FUNCTIONS *****/

  function refreshList() {
    var deferred = $q.defer();
    deferred.resolve($scope.sxList);
    return deferred.promise;
  }
  function isEmpty() {
    // se il campo è multiplo e con lunghezza pari a zero, o se è singolo e null/undefined
    var model = $scope.ngModel;
    if ($scope.sxField) {
      model = $scope.ngModel[$scope.sxField];
    }
    return isMultiple() && model.length == 0 || !isMultiple() && (model == null || model == undefined);
  }

  /**** VALUE FUNCTIONS *****/

  function addOrSetValue(value) {
    if (isMultiple()) {
      if (!$scope.ngModel[$scope.sxField] || !angular.isArray($scope.ngModel[$scope.sxField])) {
        $scope.ngModel[$scope.sxField] = [];
      }
      if ($scope.sxField) {
        checkAndAdd($scope.ngModel[$scope.sxField], value);
      } else {
        checkAndAdd($scope.ngModel, value);
      }
    } else {
      if ($scope.sxField) {
        $scope.ngModel[$scope.sxField] = value;
      } else {
        $scope.ngModel = value;
      }
    }
    setPlaceholder();
  }
  function setValueToShow(value) {
    if (value) {
      if ($scope.sxItemTemplate) {
        $scope.valueToShow = $scope.evaluateTemplate($scope.sxItemTemplate, value);
      } else {
        $scope.valueToShow = (value[$scope.sxKey] ? value[$scope.sxKey] + ' - ' : '') + $filter('cut')(value[$scope.sxDescription], true, 100, '...');
      }
    } else {
      $scope.valueToShow = undefined;
    }
  }
  function checkAndAdd(list, value) {
    if ($scope.sxMaxSelected > 0 && list.length == $scope.sxMaxSelected) {
      $log.debug('max selected item reached! ' + list.length + ' (max is )' + $scope.sxMaxSelected);
      toaster.pop('error', 'Limite raggiunto', 'Limite massimo di elementi selezionabili raggiunto (' + $scope.sxMaxSelected + ')');
    } else {
      var found = list.some(function (el) {
        return el[$scope.sxKey] === value[$scope.sxKey];
      });
      if (!found) {
        list.push(value);
      }
    }
  }
  function unsetValue() {
    if (angular.isUndefined($scope.sxField)) {
      if (isMultiple()) {
        $scope.ngModel = [];
      } else {
        $scope.ngModel = undefined;
        setValueToShow($scope.ngModel);
      }
    } else {
      if (isMultiple()) {
        $scope.ngModel[$scope.sxField] = [];
      } else {
        $scope.ngModel[$scope.sxField] = undefined;
        setValueToShow($scope.ngModel[$scope.sxField]);
      }
    }
    setPlaceholder();
  }
  function getValue() {
    if ($scope.ngModel && $scope.sxField) {
      return $scope.ngModel[$scope.sxField];
    } else {
      return $scope.ngModel;
    }
  }
  $scope.toggleSelect = function (item) {
    if ($scope.isItemSelected(item)) {
      $scope.unselect(item);
    } else {
      $scope.select(item);
    }
  };
  function validateForm() {
    if ($scope.sxForm && $scope.sxForm[$scope.sxId]) {
      $scope.sxForm[$scope.sxId].$pristine = false; // forzo il pristine per indicare che il valore è stato effettivamente "toccato" (serve ad evidenziare eventuali errori di validazione)
    }
  }

  $scope.select = function (item) {
    validateForm();
    addOrSetValue(item);
    if (!$scope.sxPinned) {
      closeLookup();
    }
    if (angular.isDefined($scope.sxOnSelect) && angular.isFunction($scope.sxOnSelect)) {
      $scope.sxOnSelect({
        item: item
      }); //callback
    }
  };

  $scope.unselect = function (item) {
    validateForm();
    if (isMultiple()) {
      var idx = getValue().findIndex(function (v) {
        return v[$scope.sxKey] === item[$scope.sxKey];
      });
      if (idx > -1) {
        getValue().splice(idx, 1);
      }
      setPlaceholder();
    } else {
      unsetValue();
    }
    if (angular.isDefined($scope.sxOnSelect)) {
      $scope.sxOnSelect();
    }
  };
  $scope.selectAll = function () {
    $filter('filter')($scope.sxList, $scope.filter.text).forEach(function (item) {
      $scope.select(item);
    });
    validateForm();
  };
  $scope.unselectAll = function () {
    $scope.clearSelect();
  };
  $scope.clearSelect = function () {
    if (!$scope.sxDisabled) {
      validateForm();
      unsetValue();
      refreshList();
      if (angular.isDefined($scope.sxOnSelect)) {
        $scope.sxOnSelect();
      }
    }
  };
  $scope.isItemSelected = function (item) {
    var selectedValue = getValue();
    if (selectedValue && isMultiple()) {
      var found = false;
      selectedValue.forEach(function (i) {
        found |= i[$scope.sxKey] == item[$scope.sxKey];
      });
      return found;
    } else if (selectedValue) {
      return selectedValue[$scope.sxKey] == item[$scope.sxKey];
    }
    return false;
  };

  /**** WATCHERS *****/

  $scope.$watchCollection(function (scope) {
    if (angular.isDefined(scope.ngModel)) {
      if (angular.isUndefined($scope.sxField)) {
        return scope.ngModel;
      } else {
        return scope.ngModel[$scope.sxField];
      }
    }
  }, function (newValue, oldValue) {
    setPlaceholder();
    if (!isMultiple()) {
      if ($scope.ngModel && $scope.sxField) {
        setValueToShow($scope.ngModel[$scope.sxField]);
      } else if ($scope.ngModel) {
        setValueToShow($scope.ngModel);
      } else {
        setValueToShow();
      }
    }
  });
  $scope.$watch('sxVisible', function (newVal, oldVal) {
    // chiudo tuttle le altre lookup e passo il mio id per comunicare che devo restare aperta solo io
    if (newVal === true && oldVal != true) {
      $rootScope.$broadcast('closeSixLookup2', {
        id: $scope.sxId
      });
    }
  });
  $rootScope.$on('closeSixLookup2', function ($event, args) {
    if (args && args.id != $scope.sxId) {
      // se non ho lanciato io il broadcast mi chiudo
      closeLookup();
    }
  });
  $rootScope.$on('SchemaFormValidate', function () {
    if ($scope.sxRequired && isEmpty()) {
      $scope.ngInvalid = true;
      $scope.ngValid = false;
    } else if ($scope.sxRequired && !isEmpty()) {
      $scope.ngInvalid = false;
      $scope.ngValid = true;
    }
  });

  /**** FILTERS FUNCTIONS ****/

  $scope.clearSearchFn = function () {
    $scope.filter.text = '';
  };

  /**** OTHER ****/

  $timeout(function () {
    //per le select multiple senza sidebar disabilito l'input manuale
    var tags = document.querySelectorAll(".sixSelect2-disable-input");
    tags.forEach(function (tag) {
      var input = tag.children[0].children[0].children[1];
      if (input && input.tagName == 'INPUT') {
        input.disabled = true;
      }
    });
  });
  $scope.onFocusItCB = function () {
    if (!$scope.sxDisabled) {
      $scope.sxVisible = true;
    }
    $scope.onClick();
  };
  $scope.onClick = function () {
    if (!$scope.sxDisabled) {
      if (angular.isDefined($scope.sxClick) && angular.isFunction($scope.sxClick)) {
        $scope.sxClick();
      }
    }
  };
  function closeLookup() {
    $scope.sxVisible = false;
  }
  function isMultiple() {
    return $scope.sxMultiple === true || $scope.sxMultiple === 'true';
  }
  $scope.isMultiple = isMultiple;
  $scope.showKey = function () {
    return $scope.sxShowKey === true || $scope.sxShowKey === 'true';
  };
  function setPlaceholder() {
    if (!$scope.ngModel || !$scope.ngModel[$scope.sxField] || $scope.ngModel[$scope.sxField].length == 0) {
      $scope.placeholder = $scope.sxEmptyPlaceholder;
    } else {
      $scope.placeholder = $scope.sxPlaceholder;
    }
  }

  /**** TEMPLATE ****/

  $scope.evaluateTemplate = function (template, item) {
    return template.replace(/{{item\.(.*?)}}/g, function (match, token) {
      var tokens = token.split('.');
      return _evaluateTemplate(item, tokens);
    });
  };
  function _evaluateTemplate(item, tokens) {
    if (!tokens || tokens.length == 0) {
      return item;
    } else {
      return _evaluateTemplate(item[tokens[0]], tokens.slice(1));
    }
  }
}]);

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixLookup
 * @description
 * # sixLookup
 */
angular.module('emma.theme').directive('sixSelect2', ['$log', 'baseFactory', function ($log, baseFactory) {
  return {
    templateUrl: 'theme/directives/templates/sixselect2.html',
    restrict: 'E',
    scope: {
      sxId: '@',
      ngModel: '=',
      sxField: '=?',
      //nome del campo nell'oggetto che mi referenzia (FIXME sembra non funzionare se sxMultiple = true)
      showDebug: '=?',
      sxDebug: '=?',
      sxSearchPrefix: '=?',
      sxKey: '=?',
      // nome dell'attributo che funge da key
      sxDescription: '=?',
      // nome dell'attributo che funge da description
      sxDisabled: '=?',
      sxPlaceholder: '=?',
      // placeholder mostrato quando la selezione è vuota (viene sempre mostrato in caso di selezione multipla)
      sxEmptyPlaceholder: '=?',
      // placeholder mostrato quando la selezione multipla è vuota
      sxTitle: '=?',
      sxPosition: '=?',
      // posizione della sidebar: 'left'/'right'
      sxDimension: '=?',
      // dimensione sidebar: 's'/'m'/'l'
      sxPinnable: '=?',
      sxVisible: '=?',
      sxMultiple: '@',
      sxMaxSelected: '@?',
      // limite massimo di elementi selezionabili se isMultiple=true (infiniti quando sxMaxSelected <= 0)
      sxList: '=',
      //per consentire il 'seleziona tutti'
      sxClearable: '=?',
      sxCompact: '=?',
      sxOnSelect: '&?',
      sxRequired: '=?',
      sxItemTemplate: '=?',
      sxItemTemplateUrl: '=?',
      sxForm: '=?',
      // form in cui è contenuta la sixselect2 (serve per la validazione e la segnalazione di eventuali errori)
      sxClick: '&?'
    },
    transclude: true,
    controller: 'sixSelect2Ctrl'
  };
}]);
'use strict';

angular.module('emma.theme').controller('sixSelectStatusCtrl', ["$scope", "baseFactory", "$log", function ($scope, baseFactory, $log) {
  $scope.object;
  $scope.sxItemList = [];
  $scope.getAvailableStates = function () {
    baseFactory('issue/record/_states').show().$promise.then(function (response) {
      $scope.sxItemList = response.result;
    });
  };
  if (angular.isUndefined($scope.sxShowDescription)) {
    $scope.sxShowDescription = false;
  }
  $scope.sxDescriptionClass = $scope.sxDescriptionClass || 'font-bold';
  $scope.getAvailableStates();
  $scope.select = function (item) {
    $scope.object = item.code;
    $scope.ngModel = item.code;
    if ($scope.sxSelect) {
      $scope.sxSelect();
    }
  };
  $scope.clearSelect = function () {
    $scope.select(undefined);
    if ($scope.sxClearSelect) {
      $scope.sxClearSelect();
    }
  };
  $scope.getSelectMatch = function (obj) {
    if (angular.isUndefined(obj)) {
      return undefined;
    }
    // if(angular.isUndefined(obj.description)) { return obj.code; }
    // if(!angular.isUndefined(obj.description)) { return obj.description; }
    return obj;
  };
  $scope.$watch(function () {
    return $scope.ngModel;
  }, function (newValue, oldValue) {
    // TODO va bene commentare? altrimenti non si riesce a sbiancare la lookup dall'esterno...
    //if(newValue) {
    $scope.object = $scope.ngModel;
    //}
  });
}]);

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixSelectStatus
 * @description
 * # sixSelectStatus
 */
angular.module('emma.theme').directive('sixSelectStatus', function () {
  return {
    template: '<div class="input-group has-button" style="width: 100%">' + '<ui-select ng-model="ngModel" theme="bootstrap" on-select="select($item)" reset-search-input="false" ng-disabled="sxDisabled">' + '<ui-select-match class="ui-select-match" placeholder="Enter...">{{getSelectMatch(object)}}</ui-select-match>' + '<ui-select-choices class="ui-select-choices" repeat="item in sxItemList track by $index">' + '<div ng-bind-html="item.code | highlight: $select.search"></div>' + '<small ng-bind-html="item.code | highlight: $select.search"></small>' + '</ui-select-choices>' + '</ui-select>' + '<span class="input-group-btn">' + '<button type="button" class="btn btn-bg btn-default" ng-click="clearSelect()" ng-disabled="sxDisabled"><i class="fa fa-times"></i></button>' + '</span>' + '</div>' + '<div ng-if="sxShowDescription === true" class="{{sxDescriptionClass}}">' + '{{ngModel.description}}' + '</div>',
    restrict: 'E',
    scope: {
      ngModel: '=',
      sxItemList: '=?',
      sxShowDescription: '=?',
      sxDescriptionClass: '=?',
      sxSelect: '&',
      sxClearSelect: '&',
      sxDisabled: '=?'
    },
    controller: 'sixSelectStatusCtrl'
  };
});
'use strict';

angular.module('emma.theme').controller('sixSelectUserCtrl', ["$scope", "dbBaseFactory", "$log", function ($scope, dbBaseFactory, $log) {
  $scope.object;
  $scope.sxItemList = [];
  $scope.getUsers = function () {
    dbBaseFactory('user').search({
      'search': {
        'obj': {
          'searchString': $scope.searchString,
          'attivo': 'T'
        }
      },
      'init': {
        'username': true,
        'surname': true,
        'name': true,
        'email': true
      }
    }
    /*{query: getQuery(), page: paginationOptions.pageNumber, pageSize: paginationOptions.pageSize,
     sortFields: defaultSort(), history: $scope.isSnapshot()
     }*/).$promise.then(function (result) {
      $scope.sxItemList = result.list;
    });
  };
  if (angular.isUndefined($scope.sxShowDescription)) {
    $scope.sxShowDescription = false;
  }
  $scope.sxDescriptionClass = $scope.sxDescriptionClass || 'font-bold';
  $scope.getUsers();
  $scope.select = function (item) {
    $scope.object = item;
    $scope.ngModel = item;
    console.log(item);
    if ($scope.sxSelect) {
      $scope.sxSelect();
    }
  };
  $scope.clearSelect = function () {
    $scope.select(undefined);
    if ($scope.sxClearSelect) {
      $scope.sxClearSelect();
    }
  };
  $scope.getSelectMatch = function (obj) {
    if (angular.isUndefined(obj) || obj == null) {
      return undefined;
    }
    return obj.username;
  };
  $scope.$watch(function () {
    return $scope.ngModel;
  }, function (newValue, oldValue) {
    // TODO va bene commentare? altrimenti non si riesce a sbiancare la lookup dall'esterno...
    //if(newValue) {
    $scope.object = $scope.ngModel;
    //}
  });
}]);

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixSelectUser
 * @description
 * # sixSelectuser
 */
angular.module('emma.theme').directive('sixSelectUser', function () {
  return {
    template: '<div class="input-group has-button" style="width: 100%">' + '<ui-select ng-model="ngModel" theme="bootstrap" on-select="select($item)" reset-search-input="false" ng-disabled="sxDisabled">' + '<ui-select-match class="ui-select-match" placeholder="Enter...">{{getSelectMatch(object)}}</ui-select-match>' + '<ui-select-choices class="ui-select-choices" repeat="item in sxItemList track by $index">' + '<div ng-bind-html="item.surname | highlight: $select.search"></div> ' + '<small ng-bind-html="item.surname | highlight: $select.search"></small> <small ng-bind-html="item.name | highlight: $select.search"></small>' + '</ui-select-choices>' + '</ui-select>' + '<span class="input-group-btn">' + '<button type="button" class="btn btn-bg btn-default" ng-click="clearSelect()" ng-disabled="sxDisabled"><i class="fa fa-times"></i></button>' + '</span>' + '</div>' + '<div ng-if="sxShowDescription === true" class="{{sxDescriptionClass}}">' + '{{ngModel.description}}' + '</div>',
    restrict: 'E',
    scope: {
      ngModel: '=',
      sxItemList: '=?',
      sxShowDescription: '=?',
      sxDescriptionClass: '=?',
      sxSelect: '&',
      sxClearSelect: '&',
      sxDisabled: '=?'
    },
    controller: 'sixSelectUserCtrl'
  };
});
'use strict';

angular.module('emma.theme').controller('sixSendEmailCtrl', ['$scope', 'notificationFactory', 'salAttachmentsFactory', '$log', 'toaster', function ($scope, notificationFactory, salAttachmentsFactory, $log, toaster) {
  if (angular.isUndefined($scope.sxId)) {
    $scope.sxId = new Date().getTime();
  }
  $scope.getAttachmentsList = function () {
    if (angular.isFunction($scope.sxAttachmentsList)) {
      $scope.attachmentsList = $scope.sxAttachmentsList() || [];
    } else {
      //Fallback legacy, recupera gli allegati al SAL Consip
      salAttachmentsFactory.search({
        id: $scope.sxRecordId.code
      }).$promise.then(function (response) {
        if (response.list) {
          response.list.forEach(function (currentItem) {
            var objectId = currentItem.model.object_id.replace('workspace://SpacesStore/', '$WorkspaceSpacesStore$');
            $scope.attachmentsList.push({
              key: objectId,
              description: currentItem.model.title
            });
          });
        } else if (response.result) {
          response.result.forEach(function (currentItem) {
            var objectId = currentItem.model.object_id.replace('workspace://SpacesStore/', '$WorkspaceSpacesStore$');
            $scope.attachmentsList.push({
              key: objectId,
              description: currentItem.model.title
            });
          });
        } else {
          $scope.attachmentsList = [];
        }
      });
    }
  };
  $scope.initTinyMce = function () {
    window.tinymce.dom.Event.domLoaded = true;
    var body_id = $scope.sxId + '_body';
    $log.info("BODY-ID --", body_id);
    tinymce.baseURL = 'scripts/tinymce';
    tinymce.init({
      selector: '#' + $scope.sxId,
      theme: 'modern',
      body_id: body_id,
      /*width: 600,*/
      height: 300,
      plugins: ['advlist autolink link image lists charmap print preview hr anchor pagebreak', 'searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime nonbreaking', 'save table contextmenu directionality template paste textcolor'],
      /*content_css: [
          '//www.tinymce.com/css/codepen.min.css'
      ],*/
      toolbar: 'insertfile undo redo | fontsizeselect fontselect styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link | print preview fullpage | forecolor backcolor',
      menu: {
        file: {
          title: 'File',
          items: 'print'
        },
        edit: {
          title: 'Edit',
          items: 'undo redo | cut copy paste pastetext | selectall'
        },
        insert: {
          title: 'Insert',
          items: 'link hr'
        },
        view: {
          title: 'View',
          items: 'preview'
        },
        format: {
          title: 'Format',
          items: 'bold italic underline strikethrough superscript subscript | formats'
        },
        table: {
          title: 'Table',
          items: 'inserttable tableprops deletetable | cell row column'
        },
        tools: {
          title: 'Tools',
          items: 'spellchecker code'
        }
      },
      language_url: 'theme/attachments/it.conf',
      language: 'it',
      force_br_newlines: false,
      force_p_newlines: false,
      forced_root_block: ''
    });
    if (tinymce.editors.length > 0) {
      tinymce.execCommand('mceFocus', true, "message");
      tinymce.execCommand('mceRemoveEditor', true, "message");
      tinymce.execCommand('mceAddEditor', true, "message");
    }
  };
  $scope.save = function () {};
  $scope.sendEmail = function () {
    $scope.message = tinyMCE.get($scope.sxId).getContent({
      format: 'raw'
    });
    var payload = {
      to: $scope.to,
      cc: $scope.cc,
      subject: $scope.title,
      body: $scope.message,
      type_mail: $scope.sxTypeMail,
      mail_format: 'HTML',
      record_id: $scope.sxRecordId,
      alfresco_attachments: null
    };
    if ($scope.attachments.selected.length > 0) {
      $scope.attachments.selected.forEach(function (element, index) {
        if (index == 0) {
          payload.alfresco_attachments = transformObjectIdForBackend(element.key);
        } else {
          payload.alfresco_attachments = payload.alfresco_attachments + ',' + transformObjectIdForBackend(element.key);
        }
      });
    }
    notificationFactory().sendEmail(payload).$promise.then(function (response) {
      toaster.pop('success', 'Eseguito', 'Email inviata con successo');
    });
  };
  function transformObjectIdForBackend(objectId) {
    return objectId.replace('workspace://SpacesStore/', '$WorkspaceSpacesStore$');
  }
  function isInit(data) {
    return angular.isDefined(data) && data != null;
  }
  function convertNewlines(str) {
    //converte i \n in br solo se non viene rilevato alcun tag html
    if (!/<[a-z][\s\S]*>/i.test(str)) {
      str = str.replace(/(?:\r\n|\r|\n)/g, '<br />');
    }
    return str;
  }
  $scope.$watchGroup(['sxBodyMail', 'sxToMail'], function () {
    if (isInit($scope.sxBodyMail) && isInit($scope.sxToMail)) {
      $scope.message = convertNewlines($scope.sxBodyMail);
      $scope.to = $scope.sxToMail;
      if ($scope.sxTitleMail) {
        $scope.title = $scope.sxTitleMail.replace(/\s/g, ' ');
      }
      if ($scope.sxCcMail) {
        $scope.cc = $scope.sxCcMail;
      }
      $scope.init();
    }
  });
  $scope.init = function () {
    setTimeout(function () {
      $scope.initTinyMce();
    }, 50);
  };
  $scope.attachmentsList = [];
  $scope.attachments = {
    selected: []
  };
  $scope.to = "";
  $scope.cc = "";
  $scope.title = "Titolo di esempio";
  $scope.message = "Messaggio di esempio";
  if (angular.isUndefined($scope.sxDisableToMail)) {
    $scope.sxDisableToMail = false;
  }
  if (angular.isUndefined($scope.sxAlfrescoAttachments)) {
    $scope.sxAlfrescoAttachments = false;
  } else {
    if ($scope.sxAlfrescoAttachments) {
      $scope.getAttachmentsList();
    }
  }
} // End of controller function
]);

/**
 * @ngdoc directive
 * @author Rita Beltrami 27/04/2016
 * @name emma.theme.directive:sixSendEmail
 * @description Form to send emails
 * # sixSendEmail
 */
angular.module('emma.theme').directive('sixSendEmail', function () {
  return {
    template: '<div id="tinymce_id">' + '<row ng-hide="sxHideTo">' + '<div class="form-group schema-form-text">' + '<label for="receiver">Destinatari</label>' + '<input type="text" ng-disabled="sxDisableToMail" placeholder="" class="form-control" id="receiver" ng-model="to" >' + '</div>' + '</row>' + '<row ng-hide="sxHideCc">' + '<div class="form-group schema-form-text">' + '<label for="cc">Cc</label>' + '<input type="text" placeholder="" class="form-control" id="cc" ng-model="cc" >' + '</div>' + '</row>' + '<row>' + '<div class="form-group schema-form-text">' + '<label for="title">Titolo</label>' + '<input type="text" placeholder="" class="form-control" id="title" ng-model="title" >' + '</div>' + '</row>' + '<row ng-if="sxAlfrescoAttachments == true">' + '<div class="form-group schema-form-text">' + '<label for="title">Allegati</label>' + '<six-select-2 sx-id="attachments"' + 'sx-list="attachmentsList"' + 'sx-title="\'Allegati...\'"' + 'ng-model="attachments"' + 'sx-field="\'selected\'"' + 'sx-item-template="\'{{item.description}}\'"' + 'sx-multiple="true"' + 'sx-show-key="false">' + '</six-select-2>' + '</div>' + '</row>' + '<ng-transclude></ng-transclude>' + '<row>' + '<div class="form-group schema-form-text">' + '<label for="message">Messaggio</label>' + '<textarea ng-model="message" id={{sxId}}></textarea>' + '</div>' + '</row>' + '<row>' + '<div class="pull-right">' + '<button ng-click="sendEmail()" type="button" class="btn btn-info pull-right">' + '<i class="fa fa-envelope"></i>&nbsp;Invia' + '</button>' + '</div>' + '</row>' + '</div>',
    transclude: true,
    scope: {
      sxRecordId: '=?',
      sxTypeMail: '=?',
      sxTitleMail: '=?',
      // titolo del messaggio
      sxBodyMail: '=?',
      // contenuto del messaggio
      sxToMail: '=?',
      // destinatari
      sxCcMail: '=?',
      // destinatari in cc
      sxAlfrescoAttachments: '=?',
      // riferimenti agli oggetti allegati
      sxAttachmentsList: '&?',
      sxDisableToMail: '=?',
      sxHideTo: '=?',
      sxHideCc: '=?'
    },
    controller: 'sixSendEmailCtrl'
  };
});
'use strict';

function makeId() {
  var text = "";
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  for (var i = 0; i < 10; i++) text += possible.charAt(Math.floor(Math.random() * possible.length));
  return text;
}

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixSidebar
 * @description
 * # sixSidebar
 *
 * Di default, quando si clicca sul contenuto della sidebar (se questa non è pinnata - sxPinned=true), la sidebar si chiude.
 * Per fare in modo che il click su un elemento causi la chiusura automatica, inserire l'attributo 'six-sidebar-autoclose=true'.
 * Es. <input id="filter" type="search" class="form-control" placeholder="Filtra..." ng-model="filter.text" six-sidebar-autoclose="false">
 */
angular.module('emma.theme').directive('sixSidebar', function () {
  return {
    templateUrl: 'theme/directives/templates/sixsidebar.html',
    restrict: 'E',
    scope: {
      sxId: '@',
      // id della sidebar
      sxTitle: '=?',
      // titolo della sidebar
      sxShowTitle: '=?',
      // titolo della sidebar
      sxClass: '@?',
      // ulteriori classi custom da aggiungere alla sidebar
      sxPosition: '@?',
      // posizione della sidebar: 'left'/'right'/'bottom'
      sxDimension: '@?',
      // dimensione sidebar: 's'/'m'/'l'
      sxPinned: '=?',
      // stato della sidebar (pinned/unpinned)
      sxOpened: '=?',
      // stato della sidebar (aperta/chiusa)
      sxClosable: '@?',
      // mostra/nasconde il pulsante per chiudere la sidebar
      sxPinnable: '@?' // mostra/nasconde il pulsante per 'pinnare' la sidebar
    },

    transclude: true,
    link: function postLink(scope, element, attrs) {
      scope.sxId = scope.sxId || makeId();
      $(document).ready(function () {
        var PINNED_CLASS = 'sidebar-pinned';
        var OPENED_CLASS = 'open';
        var opened = scope.sxOpened === true || scope.sxOpened === 'true';
        var pinned = scope.sxPinned === true || scope.sxPinned === 'true';
        var sidebar = angular.element(document.getElementById(scope.sxId));
        opened ? sidebar.addClass(OPENED_CLASS) : sidebar.removeClass(OPENED_CLASS);
        pinned ? sidebar.addClass(PINNED_CLASS) : sidebar.removeClass(PINNED_CLASS);

        // moving the content (constructor class) to the right or left
        if (opened && pinned) {
          var constructors = angular.element(document.getElementsByClassName('constructor'));
          constructors.addClass('sixsidebar-' + scope.sxDimension + '-' + scope.sxPosition + '-padded');
        }
        function smartCloseSidebar() {
          if (scope.sxPinned !== true && scope.sxPinned !== 'true') {
            scope.$apply(scope.closeSidebar);
          }
        }
        $('.list-sidebar-overlay').on('click', smartCloseSidebar);
      });
      $(window).resize(function () {
        var sidebar = angular.element(document.getElementById(scope.sxId));
        var height = $(window).height() - sidebar.prop('offsetTop');
        sidebar.css('height', height + 'px');
      });
    },
    controller: ["$scope", "$element", "baseFactory", "$log", "$rootScope", "$timeout", function controller($scope, $element, baseFactory, $log, $rootScope, $timeout) {
      // CONSTANTS
      var PINNED_CLASS = 'sidebar-pinned';
      var OPENED_CLASS = 'open';
      var OVERLAY_CLASS = 'list-sidebar-overlay';

      // VARIABLES
      $scope.sxPosition = $scope.sxPosition || 'left';
      $scope.sxDimension = $scope.sxDimension || 'm';
      $scope.sxClass = $scope.sxClass || '';
      $scope.sxPinned = angular.isUndefined($scope.sxPinned) ? false : $scope.sxPinned === true || $scope.sxPinned === 'true';
      $scope.sxOpened = angular.isUndefined($scope.sxOpened) ? true : $scope.sxOpened === true || $scope.sxOpened === 'true';
      $scope.sxClosable = angular.isUndefined($scope.sxClosable) ? true : $scope.sxClosable === true || $scope.sxClosable === 'true';
      $scope.sxPinnable = angular.isUndefined($scope.sxPinnable) ? true : $scope.sxPinnable === true || $scope.sxPinnable === 'true';
      $scope.sxShowTitle = angular.isUndefined($scope.sxShowTitle) ? true : $scope.sxShowTitle === true || $scope.sxShowTitle === 'true';

      // INIT
      $element.addClass('sidebar-' + $scope.sxDimension + '-' + $scope.sxPosition);

      //***************************//
      //**** SHOW/HIDE SIDEBAR ****//
      //***************************//

      $scope.toggleSidebar = function () {
        var sidebar = angular.element(document.getElementById($scope.sxId));
        var overlay = angular.element(document.getElementsByClassName(OVERLAY_CLASS)[0]);
        sidebar.toggleClass(OPENED_CLASS);
        $element.toggleClass(OPENED_CLASS);
        $scope.sxOpened = sidebar.hasClass(OPENED_CLASS);
        if ((sidebar.hasClass('list-sidebar-fixed-left') || sidebar.hasClass('list-sidebar-fixed-right')) && sidebar.hasClass(OPENED_CLASS)) {
          overlay.addClass('active');
        } else {
          overlay.removeClass('active');
        }

        // move the content (constructor class) to the right or left
        if (sidebar.hasClass(PINNED_CLASS)) {
          var constructors = angular.element(document.getElementsByClassName('constructor'));
          constructors.toggleClass('sixsidebar-' + $scope.sxDimension + '-' + $scope.sxPosition + '-padded');
        }
      };
      $scope.openSidebar = function () {
        var sidebar = angular.element(document.getElementById($scope.sxId));
        var overlay = angular.element(document.getElementsByClassName(OVERLAY_CLASS)[0]);
        sidebar.addClass(OPENED_CLASS);
        $element.addClass(OPENED_CLASS);
        $scope.sxOpened = sidebar.hasClass(OPENED_CLASS);
        if ((sidebar.hasClass('list-sidebar-fixed-left') || sidebar.hasClass('list-sidebar-fixed-right')) && sidebar.hasClass(OPENED_CLASS)) {
          overlay.addClass('active');
        } else {
          overlay.removeClass('active');
        }

        // move the content (constructor class) to the right or left
        if (sidebar.hasClass(PINNED_CLASS)) {
          deferFunction(function () {
            // per evitare che la chiusura di un'altra sidebar (es. sixlookup2) tolga la classe css dopo che l'ho inserita io (=> verrrebbe così spostato il content in modo errato)
            var constructors = angular.element(document.getElementsByClassName('constructor'));
            constructors.addClass('sixsidebar-' + $scope.sxDimension + '-' + $scope.sxPosition + '-padded');
          });
        }
      };
      $rootScope.$on('sixSidebar:toggle', function (event, param) {
        if (param.id == $scope.sxId) {
          $scope.toggleSidebar();
        }
      });
      $rootScope.$on('sixSidebar:open', function (event, param) {
        if (param.id == $scope.sxId) {
          $scope.openSidebar();
        }
      });
      $rootScope.$on('sixFramework:toggle-profile', function (event, param) {
        if ($scope.sxPosition == 'right') {
          $scope.closeSidebar();
        }
      });
      $scope.closeSidebar = function () {
        var sidebar = angular.element(document.getElementById($scope.sxId));
        var overlay = angular.element(document.getElementsByClassName(OVERLAY_CLASS)[0]);
        sidebar.removeClass(OPENED_CLASS);
        $element.removeClass(OPENED_CLASS);
        $scope.sxOpened = sidebar.hasClass(OPENED_CLASS);
        if ((sidebar.hasClass('list-sidebar-fixed-left') || sidebar.hasClass('list-sidebar-fixed-right')) && sidebar.hasClass(OPENED_CLASS)) {
          overlay.addClass('active');
        } else {
          overlay.removeClass('active');
        }

        // move the content (constructor class) to the right or left
        if (sidebar.hasClass(PINNED_CLASS)) {
          var constructors = angular.element(document.getElementsByClassName('constructor'));
          constructors.removeClass('sixsidebar-' + $scope.sxDimension + '-' + $scope.sxPosition + '-padded');
        }
      };
      $scope.smartCloseSidebar = function ($event) {
        if ($scope.sxPinned !== true && checkAutoclose($event.target)) {
          $scope.closeSidebar();
        }
      };
      function checkAutoclose(elem) {
        var autoclose = elem.attributes['six-sidebar-autoclose'];
        if (angular.isUndefined(autoclose)) {
          return false;
        }
        return autoclose.value != 'false';
      }

      //************************//
      //**** UN/PIN SIDEBAR ****//
      //************************//

      $scope.togglePinnedSidebar = function () {
        var sidebar = angular.element(document.getElementById($scope.sxId));
        sidebar.toggleClass(PINNED_CLASS);
        $element.toggleClass(PINNED_CLASS);
        $scope.sxPinned = sidebar.hasClass(PINNED_CLASS);
        var constructors = angular.element(document.getElementsByClassName('constructor'));
        constructors.toggleClass('sixsidebar-' + $scope.sxDimension + '-' + $scope.sxPosition + '-padded');
      };
      $scope.pinSidebar = function () {
        var sidebar = angular.element(document.getElementById($scope.sxId));
        sidebar.addClass(PINNED_CLASS);
        $element.addClass(PINNED_CLASS);
        $scope.sxPinned = sidebar.hasClass(PINNED_CLASS);

        // move the content (constructor class) to the right or left
        var constructors = angular.element(document.getElementsByClassName('constructor'));
        constructors.addClass('sixsidebar-' + $scope.sxDimension + '-' + $scope.sxPosition + '-padded');
      };
      $scope.unpinSidebar = function () {
        var sidebar = angular.element(document.getElementById($scope.sxId));
        sidebar.removeClass(PINNED_CLASS);
        $element.removeClass(PINNED_CLASS);
        $scope.sxPinned = sidebar.hasClass(PINNED_CLASS);

        // move the content (constructor class) to the right or left
        var constructors = angular.element(document.getElementsByClassName('constructor'));
        constructors.removeClass('sixsidebar-' + $scope.sxDimension + '-' + $scope.sxPosition + '-padded');
      };

      //******************//
      //**** WATCHERS ****//
      //******************//

      $scope.$watch(function () {
        return $scope.sxOpened;
      }, function (newVal, oldVal) {
        if (newVal === true && oldVal !== true) {
          $scope.openSidebar();
        } else if (newVal === false && oldVal === true) {
          $scope.closeSidebar();
        }
      });
      $scope.$watch(function () {
        return $scope.sxPinned;
      }, function (newVal, oldVal) {
        if (newVal === true && oldVal !== true) {
          $scope.pinSidebar();
        } else if (newVal === false && oldVal === true) {
          $scope.unpinSidebar();
        }
      });

      //****************//
      //**** OTHERS ****//
      //****************//

      function deferFunction(fn) {
        $timeout(function () {
          fn();
        }, Math.floor(Math.random() * 20));
      }

      // Forzo il ridimensionamento della sidebar in base all'offset 'top'
      $(window).trigger('resize');
    }]
  };
});
'use strict';

angular.module('emma.theme').controller('sixYearPickerCtrl', ['$scope', function ($scope) {
  var plusMinus = $scope.sxPlusMinus || 5;
  var low = new Date().getFullYear() - plusMinus;
  var high = new Date().getFullYear() + plusMinus;
  $scope.getYears = function () {
    var years = [];
    for (var i = low; i < high; i++) {
      years.push(i);
    }
    return years;
  };
  $scope.previousYear = function () {
    $scope.ngModel = $scope.ngModel - 1;
    if ($scope.ngModel <= low) {
      low = low - plusMinus;
    }
  };
  $scope.nextYear = function () {
    $scope.ngModel = parseInt($scope.ngModel) + 1;
    if ($scope.ngModel >= high) {
      high = high + plusMinus;
    }
  };
  $scope.parseModel = function () {
    $scope.ngModel = parseInt($scope.ngModel);
    if ($scope.sxChange) {
      $scope.sxChange();
    }
  };
}]);

/**
 * @ngdoc directive
 * @name emma.theme.directive:sixYearPicker
 * @description
 * # sixYearPicker
 */
angular.module('emma.theme').directive('sixYearPicker', function () {
  return {
    template: '<style>' + 'six-year-picker select{' + 'min-height:29px;' + 'min-width:70px;' + '}' + '.six-year-picker-select-bg{' + 'min-height:34px !important;' + 'min-width:80px !important;' + '}' + 'six-year-picker .pick-btn-left{' + 'right:-1px;' + '}' + '</style>' + '<div class="input-group has-button" style="width: 100%">' + '<span>{{labelYear}} </span><span class="input-group-btn pick-btn-left"><a ng-click="previousYear()" class="btn btn-default" ng-class="{\'btn-sm\': !sxBig, \'btn-bg\': sxBig}">' + '<i class="fa fa-angle-left pull-left"></i>' + '</a></span>' + '<select ng-model="ngModel" class="btn btn-default" ng-class="{\'btn-sm\': !sxBig, \'six-year-picker-select-bg\': sxBig}" ng-change="parseModel()" style="width: 100%">' + '<option ng-repeat="y in getYears()" value="{{y}}" ng-selected="ngModel == y">{{y}}</option>' + '</select>' + '<span class="input-group-btn pick-btn-right"><a ng-click="nextYear()" class="btn btn-default" ng-class="{\'btn-sm\': !sxBig, \'btn-bg\': sxBig}">' + '<i class="fa fa-angle-right pull-left"></i>' + '</a></span>' + '</div>',
    restrict: 'E',
    scope: {
      ngModel: '=',
      sxPlusMinus: '=',
      sxChange: '&',
      sxBig: '=',
      labelYear: '@?'
    },
    controller: 'sixYearPickerCtrl'
  };
});
'use strict';

/**
 * @ngdoc directive
 * @name emma.theme.directive:tooltip
 * @description
 * # tooltip
 */
angular.module('emma.theme').directive('tooltip', function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      $(element).hover(function () {
        // on mouseenter
        $(element).tooltip('show');
      }, function () {
        // on mouseleave
        $(element).tooltip('hide');
      });
    }
  };
});
"use strict";

angular.module('emma.theme').directive('uiButterbar', ['$rootScope', '$anchorScroll', function ($rootScope, $anchorScroll) {
  return {
    restrict: 'AC',
    template: '<span class="bar"></span>',
    link: function link(scope, el, attrs) {
      el.addClass('butterbar hide');
      scope.$on('$stateChangeStart', function (event) {
        $anchorScroll();
        el.removeClass('hide').addClass('active');
      });
      scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState) {
        event.targetScope.$watch('$viewContentLoaded', function () {
          el.addClass('hide').removeClass('active');
        });
      });
    }
  };
}]);
"use strict";

angular.module('emma.theme').directive('uiFocus', ["$timeout", "$parse", function ($timeout, $parse) {
  return {
    link: function link(scope, element, attr) {
      var model = $parse(attr.uiFocus);
      scope.$watch(model, function (value) {
        if (value === true) {
          $timeout(function () {
            element[0].focus();
          });
        }
      });
      element.bind('blur', function () {
        scope.$apply(model.assign(scope, false));
      });
    }
  };
}]);
"use strict";

angular.module('emma.theme').directive('uiFullscreen', ['uiLoad', 'JQ_CONFIG', '$document', '$window', function (uiLoad, JQ_CONFIG, $document, $window) {
  return {
    restrict: 'AC',
    template: '<i class="fa fa-expand fa-fw text"></i><i class="fa fa-compress fa-fw text-active"></i>',
    link: function link(scope, el, attr) {
      el.addClass('hide');
      uiLoad.load(JQ_CONFIG.screenfull).then(function () {
        // disable on ie11
        if (screenfull.enabled && !navigator.userAgent.match(/Trident.*rv:11\./)) {
          el.removeClass('hide');
        }
        el.on('click', function () {
          var target;
          attr.target && (target = $(attr.target)[0]);
          screenfull.toggle(target);
        });
        $document.on(screenfull.raw.fullscreenchange, function () {
          if (screenfull.isFullscreen) {
            el.addClass('active');
          } else {
            el.removeClass('active');
          }
        });
      });
    }
  };
}]);
'use strict';

/**
 * 0.1.1
 * General-purpose jQuery wrapper. Simply pass the plugin name as the expression.
 *
 * It is possible to specify a default set of parameters for each jQuery plugin.
 * Under the jq key, namespace each plugin by that which will be passed to ui-jq.
 * Unfortunately, at this time you can only pre-define the first parameter.
 * @example { jq : { datepicker : { showOn:'click' } } }
 *
 * @param ui-jq {string} The $elm.[pluginName]() to call.
 * @param [ui-options] {mixed} Expression to be evaluated and passed as options to the function
 *     Multiple parameters can be separated by commas
 * @param [ui-refresh] {expression} Watch expression and refire plugin on changes
 *
 * @example <input ui-jq="datepicker" ui-options="{showOn:'click'},secondParameter,thirdParameter" ui-refresh="iChange">
 */
angular.module('ui.jq', ['ui.load']).value('uiJqConfig', {}).directive('uiJq', ['uiJqConfig', 'JQ_CONFIG', 'uiLoad', '$timeout', function uiJqInjectingFunction(uiJqConfig, JQ_CONFIG, uiLoad, $timeout) {
  return {
    restrict: 'A',
    compile: function uiJqCompilingFunction(tElm, tAttrs) {
      if (!angular.isFunction(tElm[tAttrs.uiJq]) && !JQ_CONFIG[tAttrs.uiJq]) {
        throw new Error('ui-jq: The "' + tAttrs.uiJq + '" function does not exist');
      }
      var options = uiJqConfig && uiJqConfig[tAttrs.uiJq];
      return function uiJqLinkingFunction(scope, elm, attrs) {
        function getOptions() {
          var linkOptions = [];

          // If ui-options are passed, merge (or override) them onto global defaults and pass to the jQuery method
          if (attrs.uiOptions) {
            linkOptions = scope.$eval('[' + attrs.uiOptions + ']');
            if (angular.isObject(options) && angular.isObject(linkOptions[0])) {
              linkOptions[0] = angular.extend({}, options, linkOptions[0]);
            }
          } else if (options) {
            linkOptions = [options];
          }
          return linkOptions;
        }

        // If change compatibility is enabled, the form input's "change" event will trigger an "input" event
        if (attrs.ngModel && elm.is('select,input,textarea')) {
          elm.bind('change', function () {
            elm.trigger('input');
          });
        }

        // Call jQuery method and pass relevant options
        function callPlugin() {
          $timeout(function () {
            elm[attrs.uiJq].apply(elm, getOptions());
          }, 0, false);
        }
        function refresh() {
          // If ui-refresh is used, re-fire the the method upon every change
          if (attrs.uiRefresh) {
            scope.$watch(attrs.uiRefresh, function () {
              callPlugin();
            });
          }
        }
        if (JQ_CONFIG[attrs.uiJq]) {
          uiLoad.load(JQ_CONFIG[attrs.uiJq]).then(function () {
            callPlugin();
            refresh();
          })["catch"](function () {});
        } else {
          callPlugin();
          refresh();
        }
      };
    }
  };
}]);
"use strict";

angular.module('emma.theme').directive('uiModule', ['MODULE_CONFIG', 'uiLoad', '$compile', function (MODULE_CONFIG, uiLoad, $compile) {
  return {
    restrict: 'A',
    compile: function compile(el, attrs) {
      var contents = el.contents().clone();
      return function (scope, el, attrs) {
        el.contents().remove();
        uiLoad.load(MODULE_CONFIG[attrs.uiModule]).then(function () {
          $compile(contents)(scope, function (clonedElement, scope) {
            el.append(clonedElement);
          });
        });
      };
    }
  };
}]);
"use strict";

angular.module('emma.theme').directive('uiNav', ['$timeout', function ($timeout) {
  return {
    restrict: 'AC',
    link: function link(scope, el, attr) {
      var _window = $(window),
        _mb = 768,
        wrap = $('.app-aside'),
        next,
        backdrop = '.dropdown-backdrop';
      // unfolded
      el.on('click', 'a', function (e) {
        next && next.trigger('mouseleave.nav');
        var _this = $(this);
        _this.parent().siblings(".active").toggleClass('active');
        _this.next().is('ul') && _this.parent().toggleClass('active') && e.preventDefault();
        // mobile
        _this.next().is('ul') || _window.width() < _mb && $('.app-aside').removeClass('show off-screen');
      });

      // folded & fixed
      el.on('mouseenter', 'a', function (e) {
        next && next.trigger('mouseleave.nav');
        $('> .nav', wrap).remove();
        if (!$('.app-aside-fixed.app-aside-folded').length || _window.width() < _mb || $('.app-aside-dock').length) return;
        var _this = $(e.target),
          top,
          w_h = $(window).height(),
          offset = 50,
          min = 150;
        !_this.is('a') && (_this = _this.closest('a'));
        if (_this.next().is('ul')) {
          next = _this.next();
        } else {
          return;
        }
        _this.parent().addClass('active');
        top = _this.parent().position().top + offset;
        next.css('top', top);
        if (top + next.height() > w_h) {
          next.css('bottom', 0);
        }
        if (top + min > w_h) {
          next.css('bottom', w_h - top - offset).css('top', 'auto');
        }
        next.appendTo(wrap);
        next.on('mouseleave.nav', function (e) {
          $(backdrop).remove();
          next.appendTo(_this.parent());
          next.off('mouseleave.nav').css('top', 'auto').css('bottom', 'auto');
          _this.parent().removeClass('active');
        });
        $('.smart').length && $('<div class="dropdown-backdrop"/>').insertAfter('.app-aside').on('click', function (next) {
          next && next.trigger('mouseleave.nav');
        });
      });
      wrap.on('mouseleave', function (e) {
        next && next.trigger('mouseleave.nav');
        $('> .nav', wrap).remove();
      });
    }
  };
}]);
"use strict";

angular.module('emma.theme').directive('uiScrollTo', ['$location', '$anchorScroll', function ($location, $anchorScroll) {
  return {
    restrict: 'AC',
    link: function link(scope, el, attr) {
      el.on('click', function (e) {
        $location.hash(attr.uiScrollTo);
        $anchorScroll();
      });
    }
  };
}]);
"use strict";

angular.module('emma.theme').directive('uiShift', ['$timeout', function ($timeout) {
  return {
    restrict: 'A',
    link: function link(scope, el, attr) {
      // get the $prev or $parent of this el
      var _el = $(el),
        _window = $(window),
        prev = _el.prev(),
        parent,
        width = _window.width();
      !prev.length && (parent = _el.parent());
      function sm() {
        $timeout(function () {
          var method = attr.uiShift;
          var target = attr.target;
          _el.hasClass('in') || _el[method](target).addClass('in');
        });
      }
      function md() {
        parent && parent['prepend'](el);
        !parent && _el['insertAfter'](prev);
        _el.removeClass('in');
      }
      width < 768 && sm() || md();
      _window.resize(function () {
        if (width !== _window.width()) {
          $timeout(function () {
            _window.width() < 768 && sm() || md();
            width = _window.width();
          });
        }
      });
    }
  };
}]);
"use strict";

/**
 * Binds a TinyMCE widget to <textarea> elements.
 */
angular.module('emma.theme').constant('uiTinymceConfig', {
  baseUrl: "scripts/tinymce"
}).directive('uiTinymce', ['$rootScope', '$compile', '$timeout', '$window', '$sce', 'uiTinymceConfig', 'uiTinymceService', function ($rootScope, $compile, $timeout, $window, $sce, uiTinymceConfig, uiTinymceService) {
  uiTinymceConfig = uiTinymceConfig || {};
  if (uiTinymceConfig.baseUrl) {
    tinymce.baseURL = uiTinymceConfig.baseUrl;
  }
  return {
    restrict: 'A',
    require: ['ngModel', '^?form'],
    priority: 599,
    link: function link(scope, element, attrs, ctrls) {
      if (!$window.tinymce) {
        return;
      }
      var ngModel = ctrls[0],
        form = ctrls[1] || null;
      var expression,
        options = {
          debounce: true
        },
        tinyInstance,
        updateView = function updateView(editor) {
          var content = editor.getContent({
            format: options.format
          }).trim();
          content = $sce.trustAsHtml(content);
          ngModel.$setViewValue(content);
          if (!$rootScope.$$phase) {
            scope.$digest();
          }
        };
      function toggleDisable(disabled) {
        if (disabled) {
          ensureInstance();
          if (tinyInstance) {
            tinyInstance.getBody().setAttribute('contenteditable', false);
          }
        } else {
          ensureInstance();
          if (tinyInstance && !tinyInstance.settings.readonly && tinyInstance.getDoc()) {
            tinyInstance.getBody().setAttribute('contenteditable', true);
          }
        }
      }

      // fetch a unique ID from the service
      var uniqueId = uiTinymceService.getUniqueId();
      attrs.$set('id', uniqueId);
      expression = {};
      angular.extend(expression, scope.$eval(attrs.uiTinymce));

      //Debounce update and save action
      var debouncedUpdate = function (debouncedUpdateDelay) {
        var debouncedUpdateTimer;
        return function (ed) {
          $timeout.cancel(debouncedUpdateTimer);
          debouncedUpdateTimer = $timeout(function () {
            return function (ed) {
              if (ed.isDirty()) {
                ed.save();
                updateView(ed);
              }
            }(ed);
          }, debouncedUpdateDelay);
        };
      }(400);
      var setupOptions = {
        // Update model when calling setContent
        // (such as from the source editor popup)
        setup: function setup(ed) {
          ed.on('init', function () {
            ngModel.$render();
            ngModel.$setPristine();
            ngModel.$setUntouched();
            if (form) {
              form.$setPristine();
            }
          });

          // Update model when:
          // - a button has been clicked [ExecCommand]
          // - the editor content has been modified [change]
          // - the node has changed [NodeChange]
          // - an object has been resized (table, image) [ObjectResized]
          ed.on('ExecCommand change NodeChange ObjectResized', function () {
            if (!options.debounce) {
              ed.save();
              updateView(ed);
              return;
            }
            debouncedUpdate(ed);
          });
          ed.on('blur', function () {
            element[0].blur();
            ngModel.$setTouched();
            if (!$rootScope.$$phase) {
              scope.$digest();
            }
          });
          ed.on('remove', function () {
            element.remove();
          });
          if (uiTinymceConfig.setup) {
            uiTinymceConfig.setup(ed, {
              updateView: updateView
            });
          }
          if (expression.setup) {
            expression.setup(ed, {
              updateView: updateView
            });
          }
        },
        format: expression.format || 'html',
        selector: '#' + attrs.id
      };
      // extend options with initial uiTinymceConfig and
      // options from directive attribute value
      angular.extend(options, uiTinymceConfig, expression, setupOptions);
      // Wrapped in $timeout due to $tinymce:refresh implementation, requires
      // element to be present in DOM before instantiating editor when
      // re-rendering directive
      $timeout(function () {
        if (options.baseURL) {
          tinymce.baseURL = options.baseURL;
        }
        var maybeInitPromise = tinymce.init(options);
        if (maybeInitPromise && typeof maybeInitPromise.then === 'function') {
          maybeInitPromise.then(function () {
            toggleDisable(scope.$eval(attrs.ngDisabled));
          });
        } else {
          toggleDisable(scope.$eval(attrs.ngDisabled));
        }
      });

      //Nota: questa direttiva va in conflitto con quella identica presente sul componente bower ui-tinymce
      //per motivi non chiariti, sul branch principale il problema non si verifica
      ngModel.$formatters.unshift(function (modelValue) {
        return modelValue; // ? $sce.trustAsHtml(modelValue) : '';
      });

      ngModel.$parsers.unshift(function (viewValue) {
        return viewValue; // ? $sce.getTrustedHtml(viewValue) : '';
      });

      ngModel.$render = function () {
        ensureInstance();
        var viewValue = ngModel.$viewValue ? $sce.getTrustedHtml(ngModel.$viewValue) : '';

        // instance.getDoc() check is a guard against null value
        // when destruction & recreation of instances happen
        if (tinyInstance && tinyInstance.getDoc()) {
          tinyInstance.setContent(viewValue);
          // Triggering change event due to TinyMCE not firing event &
          // becoming out of sync for change callbacks
          tinyInstance.fire('change');
        }
      };
      attrs.$observe('disabled', toggleDisable);

      // This block is because of TinyMCE not playing well with removal and
      // recreation of instances, requiring instances to have different
      // selectors in order to render new instances properly
      var unbindEventListener = scope.$on('$tinymce:refresh', function (e, id) {
        var eid = attrs.id;
        if (angular.isUndefined(id) || id === eid) {
          var parentElement = element.parent();
          var clonedElement = element.clone();
          clonedElement.removeAttr('id');
          clonedElement.removeAttr('style');
          clonedElement.removeAttr('aria-hidden');
          tinymce.execCommand('mceRemoveEditor', false, eid);
          parentElement.append($compile(clonedElement)(scope));
          unbindEventListener();
        }
      });
      scope.$on('$destroy', function () {
        ensureInstance();
        if (tinyInstance) {
          tinyInstance.remove();
          tinyInstance = null;
        }
      });
      function ensureInstance() {
        if (!tinyInstance) {
          tinyInstance = tinymce.get(attrs.id);
        }
      }
    }
  };
}]).service('uiTinymceService', [
// A service is used to create unique ID's, this prevents duplicate ID's if there are multiple editors on screen.

function () {
  var UITinymceService = function UITinymceService() {
    var ID_ATTR = 'ui-tinymce';
    // uniqueId keeps track of the latest assigned ID
    var uniqueId = 0;
    // getUniqueId returns a unique ID
    var getUniqueId = function getUniqueId() {
      uniqueId++;
      return ID_ATTR + '-' + uniqueId;
    };
    // return the function as a public method of the service
    return {
      getUniqueId: getUniqueId
    };
  };
  // return a new instance of the service
  return new UITinymceService();
}]);
"use strict";

angular.module('emma.theme').directive('uiToggleClass', ['$timeout', '$document', function ($timeout, $document) {
  return {
    restrict: 'AC',
    link: function link(scope, el, attr) {
      el.on('click', function (e) {
        e.preventDefault();
        if (attr.disabled) {
          return;
        }
        var classes = attr.uiToggleClass.split(','),
          targets = attr.target && attr.target.split(',') || Array(el),
          key = 0;
        angular.forEach(classes, function (_class) {
          var target = targets[targets.length && key];
          _class.indexOf('*') !== -1 && magic(_class, target);
          $(target).toggleClass(_class);
          key++;
        });
        $(el).toggleClass('active');
        function magic(_class, target) {
          var patt = new RegExp('\\s' + _class.replace(/\*/g, '[A-Za-z0-9-_]+').split(' ').join('\\s|\\s') + '\\s', 'g');
          var cn = ' ' + $(target)[0].className + ' ';
          while (patt.test(cn)) {
            cn = cn.replace(patt, ' ');
          }
          $(target)[0].className = $.trim(cn);
        }
      });
    }
  };
}]);
"use strict";

// thanks to https://github.com/Joiler/ui-grid-edit-datepicker

var app = angular.module('ui.grid.edit');
app.directive('uiGridEditDatepicker', ['$timeout', '$document', 'uiGridConstants', 'uiGridEditConstants', function ($timeout, $document, uiGridConstants, uiGridEditConstants) {
  return {
    template: function template(element, attrs) {
      var html = '<div class="datepicker-wrapper" ><input type="text" uib-datepicker-popup datepicker-options="datepickerOptions" datepicker-append-to-body="true" is-open="isOpen" ng-model="datePickerValue" ng-change="changeDate($event)" ng-keydown="editDate($event)" popup-placement="auto top"/></div>';
      return html;
    },
    require: ['?^uiGrid', '?^uiGridRenderContainer'],
    scope: true,
    compile: function compile() {
      return {
        pre: function pre($scope, $elm, $attrs) {
          if ($attrs.datepickerOptions) {
            if ($scope.col.grid.appScope[$attrs.datepickerOptions]) {
              $scope.datepickerOptions = $scope.col.grid.appScope[$attrs.datepickerOptions];
            }
          }
        },
        post: function post($scope, $elm, $attrs, controllers) {
          var setCorrectPosition = function setCorrectPosition() {
            var gridElement = $('.ui-grid-viewport');
            var gridPosition = {
              width: gridElement.outerWidth(),
              height: gridElement.outerHeight(),
              offset: gridElement.offset()
            };
            var cellElement = $($elm);
            var cellPosition = {
              width: cellElement.outerWidth(),
              height: cellElement.outerHeight(),
              offset: cellElement.offset()
            };
            var datepickerElement = $('body > .dropdown-menu, body > div > .dropdown-menu');
            var datepickerPosition = {
              width: datepickerElement.outerWidth(),
              height: datepickerElement.outerHeight()
            };
            var setCorrectTopPositionInGrid = function setCorrectTopPositionInGrid() {
              var topPosition;
              var freePixelsOnBottom = gridPosition.height - (cellPosition.offset.top - gridPosition.offset.top) - cellPosition.height;
              var freePixelsOnTop = gridPosition.height - freePixelsOnBottom - cellPosition.height;
              var requiredPixels = (datepickerPosition.height - cellPosition.height) / 2;
              if (freePixelsOnBottom >= requiredPixels && freePixelsOnTop >= requiredPixels) {
                topPosition = cellPosition.offset.top - requiredPixels + 10;
              } else if (freePixelsOnBottom >= requiredPixels && freePixelsOnTop < requiredPixels) {
                topPosition = cellPosition.offset.top - freePixelsOnTop + 10;
              } else {
                topPosition = gridPosition.height - datepickerPosition.height + gridPosition.offset.top - 20;
              }
              return topPosition;
            };
            var setCorrectTopPositionInWindow = function setCorrectTopPositionInWindow() {
              var topPosition;
              var windowHeight = window.innerHeight - 10;
              var freePixelsOnBottom = windowHeight - cellPosition.offset.top;
              var freePixelsOnTop = windowHeight - freePixelsOnBottom - cellPosition.height;
              var requiredPixels = (datepickerPosition.height - cellPosition.height) / 2;
              if (freePixelsOnBottom >= requiredPixels && freePixelsOnTop >= requiredPixels) {
                topPosition = cellPosition.offset.top - requiredPixels;
              } else if (freePixelsOnBottom >= requiredPixels && freePixelsOnTop < requiredPixels) {
                topPosition = cellPosition.offset.top - freePixelsOnTop;
              } else {
                topPosition = windowHeight - datepickerPosition.height - 10;
              }
              return topPosition;
            };
            var newOffsetValues = {};
            var isFreeOnRight = gridPosition.width - (cellPosition.offset.left - gridPosition.offset.left) - cellPosition.width > datepickerPosition.width;
            if (isFreeOnRight) {
              newOffsetValues.left = cellPosition.offset.left + cellPosition.width;
            } else {
              newOffsetValues.left = cellPosition.offset.left - datepickerPosition.width;
            }
            if (datepickerPosition.height < gridPosition.height) {
              newOffsetValues.top = setCorrectTopPositionInGrid();
            } else {
              newOffsetValues.top = setCorrectTopPositionInWindow();
            }
            datepickerElement.offset(newOffsetValues);
            datepickerElement.css("visibility", "visible");
          };
          $timeout(function () {
            setCorrectPosition();
          }, 0);
          $scope.datePickerValue = new Date($scope.row.entity[$scope.col.field]);
          $scope.isOpen = true;
          var uiGridCtrl = controllers[0];
          var renderContainerCtrl = controllers[1];
          var onWindowClick = function onWindowClick(evt) {
            var classNamed = angular.element(evt.target).attr('class');
            if (classNamed) {
              var inDatepicker = classNamed.indexOf('datepicker-calendar') > -1;
              if (!inDatepicker && evt.target.nodeName !== "INPUT") {
                $scope.stopEdit(evt);
              }
            } else {
              $scope.stopEdit(evt);
            }
          };
          var onCellClick = function onCellClick(evt) {
            angular.element(document.querySelectorAll('.ui-grid-cell-contents')).off('click', onCellClick);
            $scope.stopEdit(evt);
          };
          $scope.editDate = function (evt) {
            if (evt.keyCode > 48) {
              $scope.datePickerValue = new Date($scope.row.entity[$scope.col.field]);
            }
          };
          $scope.changeDate = function (evt) {
            if (angular.isDate($scope.datePickerValue)) {
              $scope.row.entity[$scope.col.field] = $scope.datePickerValue;
              $scope.stopEdit(evt);
            } else {
              $scope.datePickerValue = new Date($scope.row.entity[$scope.col.field]);
            }
          };
          $scope.$on(uiGridEditConstants.events.BEGIN_CELL_EDIT, function () {
            if (uiGridCtrl.grid.api.cellNav) {
              uiGridCtrl.grid.api.cellNav.on.navigate($scope, function (newRowCol, oldRowCol) {
                $scope.stopEdit();
              });
            } else {
              angular.element(document.querySelectorAll('.ui-grid-cell-contents')).on('click', onCellClick);
            }
            angular.element(window).on('click', onWindowClick);
          });
          $scope.$on('$destroy', function () {
            angular.element(window).off('click', onWindowClick);
            $('body > .dropdown-menu, body > div > .dropdown-menu').remove();
          });
          $scope.stopEdit = function (evt) {
            $scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
          };
          $elm.on('keydown', function (evt) {
            switch (evt.keyCode) {
              case uiGridConstants.keymap.ESC:
                evt.stopPropagation();
                $scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
                break;
            }
            if (uiGridCtrl && uiGridCtrl.grid.api.cellNav) {
              evt.uiGridTargetRenderContainerId = renderContainerCtrl.containerId;
              if (uiGridCtrl.cellNav.handleKeyDown(evt) !== null) {
                $scope.stopEdit(evt);
              }
            } else {
              switch (evt.keyCode) {
                case uiGridConstants.keymap.ENTER:
                case uiGridConstants.keymap.TAB:
                  evt.stopPropagation();
                  evt.preventDefault();
                  $scope.stopEdit(evt);
                  break;
              }
            }
            return true;
          });
        }
      };
    }
  };
}]);
"use strict";

uniqueValidation.$inject = ["recordFactory", "$log", "$q", "$injector"];
/**
 * Created by stefano on 15/12/16.
 */

angular.module('emma.theme').directive("uniqueValidation", uniqueValidation);
function uniqueValidation(recordFactory, $log, $q, $injector) {
  return {
    restrict: "A",
    require: "ngModel",
    link: function link($scope, $element, $attrs, ctrl) {
      ctrl.$asyncValidators.unique = function (modelValue, viewValue) {
        var factoryName = $attrs.uniqueValidation || 'recordFactory';
        var factoryParams = $attrs.factoryParams;
        var factoryMethodName = $attrs.factoryMethodName || 'unique';
        var isSchemaForm = angular.isDefined($attrs.sfSchema) && angular.isDefined($attrs.sfForm) && angular.isDefined($attrs.sfModel);
        var field = $attrs.uniqueField || 'model.code';
        var exclusions = $attrs.uniqueExclusions ? JSON.parse($attrs.uniqueExclusions) : null; //è obbligatorio
        var splitted = field.split('.');
        var sfBroadcastName = 'schemaForm.error.' + splitted[splitted.length - 1];
        $log.debug('uniqueValidation using factory ' + factoryName + ' method ' + factoryMethodName + ' (factory-params: ' + factoryParams + ')' + ' on field ' + field + ' (value = ' + viewValue + ')');
        var factory = $injector.get(factoryName);
        var deferred = $q.defer();
        if (!viewValue || viewValue.length < 1 || angular.isArray(exclusions) && exclusions.indexOf(viewValue) != -1) {
          deferred.resolve();
          if (isSchemaForm) {
            $scope.$broadcast(sfBroadcastName, 'unique', 'Non univoco', true);
          }
        } else {
          var promise;
          if (factoryParams) {
            $log.debug('uniqueValidation: checking with ' + factoryName + '(' + factoryParams + ')[' + factoryMethodName + ']({ param1: ' + field + ', param2: ' + viewValue + '})');
            promise = factory(factoryParams)[factoryMethodName]({
              param1: field,
              param2: viewValue
            }).$promise;
          } else {
            $log.debug('uniqueValidation: checking with ' + factoryName + '[' + factoryMethodName + ']({ param1: ' + field + ', param2: ' + viewValue + '})');
            promise = factory[factoryMethodName]({
              param1: field,
              param2: viewValue
            }).$promise;
          }
          promise.then(function (resp) {
            if (resp.result == true) {
              deferred.resolve();
              if (isSchemaForm) {
                $scope.$broadcast(sfBroadcastName, 'unique', 'Non univoco', true);
              }
            } else {
              $log.debug(field + ' NOT unique');
              if (isSchemaForm) {
                deferred.resolve();
                $scope.$broadcast(sfBroadcastName, 'unique', 'Non univoco', false);
              } else {
                deferred.reject();
              }
            }
          })["catch"](function (response) {
            deferred.resolve();
            if (isSchemaForm) {
              $scope.$broadcast(sfBroadcastName, 'unique', 'Non univoco', true);
            }
          });
        }
        return deferred.promise;
      };
    }
  };
}
;
'use strict';

/**
 * @ngdoc directive
 * @name emma.theme.directive:xlsxreader
 * @description
 * # xlsxreader
 */
angular.module('emma.theme').directive('xlsxreader', function () {
  return {
    scope: {
      opts: '='
    },
    link: function link($scope, $elm, $attrs) {
      $elm.on('change', function (changeEvent) {
        var reader = new FileReader();
        reader.onload = function (evt) {
          $scope.$apply(function () {
            var data = evt.target.result;
            var workbook = XLSX.read(data, {
              type: 'binary'
            });
            var headerNames = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], {
              header: 1
            })[0];
            var data = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);
            $scope.opts.columnDefs = [];
            headerNames.forEach(function (h) {
              $scope.opts.columnDefs.push({
                field: h
              });
            });
            $scope.opts.xlsData = data; //da preprocessare
            //$scope.opts.data = data;

            $elm.val(null);
          });
        };
        reader.readAsBinaryString(changeEvent.target.files[0]);
      });
    }
  };
});
'use strict';

/**
 * @ngdoc function
 * @name emma.theme.controller:EventConfigCtrl
 * @description
 * # EventConfigCtrl
 * Controller of the emma.dataset
 */
angular.module('emma.theme').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/eventconfig', {
    templateUrl: 'theme/eventconfig/eventconfig_list.html',
    controller: 'EventConfigCtrl'
  }).when('/eventconfig/:uuid', {
    templateUrl: 'theme/eventconfig/eventconfig_detail.html',
    controller: 'EventConfigCtrl'
  });
}]).controller('EventConfigCtrl', ["APP_URL", "$scope", "$log", "$q", "authFactory", "$location", "eventconfigFactory", "$routeParams", "toaster", "sixGridPaginationConstants", "uiGridConstants", "dialogService", "odlFactory", "issueFactory", "schemaFactory", "commissionFactory", "ngDialog", function (APP_URL, $scope, $log, $q, authFactory, $location, eventconfigFactory, $routeParams, toaster, sixGridPaginationConstants, uiGridConstants, dialogService, odlFactory, issueFactory, schemaFactory, commissionFactory, ngDialog) {
  var currentCommission = authFactory.getAuthData().info.commissions.current;
  $scope.commissions = {
    list: [],
    selected: []
  };

  //il frontend conosce a priori tutte le action, tutti i type e tutti gli event che può configurare
  $scope.knownActions = [{
    key: undefined,
    value: "Nessuna"
  }, {
    key: "mail",
    value: "Invia E-mail"
  }, {
    key: "rest",
    value: "Chiamata REST"
  }];
  $scope.knownEvents = [{
    key: undefined,
    value: "Qualsiasi"
  }, {
    key: "save",
    value: "Inserimento"
  }, {
    key: "update",
    value: "Aggiornamento"
  }, {
    key: "delete",
    value: "Eliminazione"
  }];
  $scope.knownTypes = [{
    key: undefined,
    value: "Qualsiasi"
  }, {
    key: "record",
    value: "Dati base / Anagrafica"
  }, {
    key: "odl",
    value: "ODL"
  }, {
    key: "issue",
    value: "Segnalazione"
  }, {
    key: "estimate",
    value: "Preventivo"
  }, {
    key: "consumptiveodl",
    value: "Consuntivo"
  }, {
    key: "invoice",
    value: "Fattura"
  }, {
    key: "salheader",
    value: "Sal"
  }];
  //FIXME: eliminare i valori hardcoded e permettere ai moduli (es: plan) di definire i types

  //suggerimenti di query drools ad-hoc per il sistema
  $scope.whenTips = [{
    value: "Tipologia Dato base/Anagrafica",
    key: "Item(getField(\"schemaCode\") == \"VALORE\")\n"
  }, {
    value: "Campo specifico modificato",
    key: "OldItem($prevValue: getField(\"CAMPO\"))  Item(getField(\"CAMPO\") != $prevValue) \n"
  }, {
    value: "Campo con valore specifico",
    key: "Item(getField(\"CAMPO\") == \"VALORE\") \n"
  }, {
    value: "Modifica calendario",
    key: "Calendar(getField(\"CAMPO\") !=\"VALORE\")\n"
  }];
  $scope.whereTips = {
    "mail": [{
      key: "mail_subject",
      value: "Oggetto"
    }, {
      key: "mail_body",
      value: "Corpo"
    }],
    "rest": [{
      key: "rest_url",
      value: "URL"
    }, {
      key: "rest_body",
      value: "Body"
    }]
  };
  $scope.fieldToSolve = {};
  //FIXME: eliminare i valori hardcoded e permettere ai moduli (es: plan) di definire dei when custom

  $scope.ruleConfConnectors = [{
    key: "&&",
    value: "E logica (AND)"
  }, {
    key: "||",
    value: "O logica (OR)"
  }];
  $scope.ruleConfOperators = [{
    key: "==",
    value: "Uguale (==)"
  }, {
    key: "!=",
    value: "Diverso (!=)"
  }, {
    key: ">",
    value: "Maggiore (>)"
  }, {
    key: ">=",
    value: "Maggiore o uguale (>=)"
  }, {
    key: "<",
    value: "Minore (<)"
  }, {
    key: "<=",
    value: "Minore o uguale (<=)"
  }];
  $scope.httpMethods = [{
    key: "GET",
    value: "GET"
  }, {
    key: "POST",
    value: "POST"
  }, {
    key: "PUT",
    value: "PUT"
  }, {
    key: "DELETE",
    value: "DELETE"
  }];
  $scope.calendarMode = {
    knownFields: [{
      key: "model.status",
      value: "Stato asset"
    }, {
      key: "model.extraordinary",
      value: "Straordinarietà evento"
    }, {
      key: "model.openingTime",
      value: "Ore di apertura"
    }],
    knownValues: {
      "model.status": [{
        key: "\"open\"",
        value: "Aperto"
      }, {
        key: "\"closed\"",
        value: "Chiuso"
      }],
      "model.extraordinary": [{
        key: false,
        value: "Ordinario"
      }, {
        key: true,
        value: "Straordinario"
      }]
    }
  };
  $scope.ruleKnownValues = {
    "invoice": {
      "model.status": [{
        key: "true",
        value: "Approvata"
      }, {
        key: "false",
        value: "Rifiutata"
      }],
      "model.generation_pending": [{
        key: "true",
        value: "Generazione in corso"
      }, {
        key: "false",
        value: "Generazione effettuata"
      }]
    }
  };
  $scope.counterNameEventconfig = 'eventconfig';
  $scope.eventconfig = {
    model: {}
  };
  $scope.eventconfigList = {
    list: []
  };
  $scope.schema = {};
  $scope.properties = {};
  $scope.params = {
    pageNumber: 1,
    pageSize: 100,
    filters: {}
  };
  $scope.autoResizeParams = {
    enabled: true,
    minHeight: 200,
    marginTop: 290
  };
  $scope.gridAppCallbacks = {};
  $scope.gridAppCallbacks['getReadableConfig'] = getReadableConfig;
  $scope.viewGridOptions = {
    enableSorting: true,
    enableGridMenu: true,
    exporterCsvColumnSeparator: ';',
    exporterSuppressColumns: ['id', 'timeline'],
    exporterMenuPdf: false,
    enableFiltering: true,
    enableColumnResizing: true,
    paginationPageSizes: [100, 250, 500, 1000, 10000],
    paginationPageSize: 100,
    useExternalPagination: true,
    useExternalFiltering: true,
    multiSelect: true,
    enableRowHeaderSelection: true,
    enableRowSelection: false,
    enableHorizontalScrollbar: 1
  };
  $scope.viewGridOptions.columnDefs = [];
  $scope.viewGridOptions.columnDefs.push({
    displayName: '',
    field: 'id',
    width: 36,
    enableCellEdit: true,
    enableFiltering: false,
    enableSorting: false,
    pinnedLeft: true,
    cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/eventconfig/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' + '<span class="fa fa-search"></span>' + '</a>' + '</div>'
  });
  $scope.viewGridOptions.columnDefs.push({
    displayName: 'Codice',
    field: 'model.code',
    enableFiltering: true,
    pinnedLeft: true,
    width: 120,
    filters: [{
      type: sixGridPaginationConstants.filterType.TEXT,
      condition: uiGridConstants.filter.CONTAINS,
      placeholder: ''
    }]
  });
  $scope.viewGridOptions.columnDefs.push({
    displayName: 'Dato',
    field: 'model.type',
    enableFiltering: true,
    width: 120,
    filters: [{
      type: sixGridPaginationConstants.filterType.TEXT,
      condition: uiGridConstants.filter.CONTAINS,
      placeholder: ''
    }]
  });
  $scope.viewGridOptions.columnDefs.push({
    displayName: 'Evento',
    field: 'model.event',
    enableFiltering: true,
    width: 120,
    filters: [{
      type: sixGridPaginationConstants.filterType.TEXT,
      condition: uiGridConstants.filter.CONTAINS,
      placeholder: ''
    }]
  });
  $scope.viewGridOptions.columnDefs.push({
    displayName: 'Azione',
    field: 'model.action',
    enableFiltering: true,
    width: 120,
    filters: [{
      type: sixGridPaginationConstants.filterType.TEXT,
      condition: uiGridConstants.filter.CONTAINS,
      placeholder: ''
    }]
  });
  $scope.viewGridOptions.columnDefs.push({
    displayName: 'Bulk',
    field: 'model.bulkOperation',
    enableFiltering: false,
    enableSorting: false,
    width: 60,
    cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<span ng-if="row.entity.model.bulkOperation" class="fa fa-check"></span>' + '</div>'
  });
  $scope.viewGridOptions.columnDefs.push({
    displayName: 'Configurazione',
    field: 'model.when',
    enableFiltering: false,
    enableSorting: false,
    cellTemplate: '<div class="ui-grid-cell-contents" ng-bind-html="grid.appScope.getReadableConfig(row.entity)"></div>'
  });
  loadCommissionList();
  function getReadableConfig(conf) {
    var list = "";
    switch (conf.model.action) {
      case 'rest':
        list = conf.model.config.rest_url;
        break;
      case 'mail':
        var to_list = [];
        if (conf.model.config.to_mail.length) {
          to_list.push(conf.model.config.to_mail);
        }
        conf.model.config.to_operator.forEach(function (val) {
          to_list.push(val.description);
        });
        conf.model.config.to_field.forEach(function (val) {
          to_list.push("[" + val + "]");
        });
        list = conf.model.config.mail_subject + " - <b>Destinatari:</b> " + to_list.join("; ");
        break;
      default:
        list = '--';
    }
    return "<span title=\"" + list.replace(/<(?:.|\n)*?>|"/gm, '') + "\">" + list + "</span>";
  }
  $scope.getEventConfigList = function () {
    var filters = angular.copy($scope.params.filters);
    // creazione payload
    var payload = {
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      show_revision: false,
      commission: currentCommission.code
    };
    return eventconfigFactory.search(payload, filters).$promise.then(function (data) {
      $scope.eventconfigList.totalResults = data.totalResults;
      $scope.eventconfigList.list = data.list;
      return data;
    });
  };
  $scope.refresh = function () {
    $scope.getEventConfigList();
  };
  $scope.goToEventconfigList = function () {
    $location.path('eventconfig');
  };
  $scope.newEventConfig = function () {
    $location.path('eventconfig/new');
  };
  $scope.getEventConfigById = function (UUID) {
    if (UUID == 'new') {
      $scope.isNew = true;
    } else {
      $scope.isNew = false;
      eventconfigFactory.getEventConfigByUUID({
        uuid: UUID
      }).$promise.then(function (response) {
        if (response) {
          $scope.eventconfig = response.list[0];
          if ($scope.eventconfig.model.config) {
            if ($scope.eventconfig.model.action == 'mail') {
              $scope.mailConf = $scope.eventconfig.model.config;
            } else if ($scope.eventconfig.model.action == 'rest') {
              $scope.restConf = $scope.eventconfig.model.config;
            }
          }
          if (response.list[0].commission) {
            fillCommissionFromAvailables(response.list[0].commission);
          }
        }
      });
    }
  };
  $scope["delete"] = function (idToDelete) {
    eventconfigFactory.referenceCount({
      id: $scope.eventconfig.UUID
    }).$promise.then(function (response) {
      var deleteMessage = 'Eliminare la Configurazione?';
      if (response.count != 0) {
        deleteMessage = 'La configurazione che stai eliminando è in uso nel sistema.<br> Vuoi rimuoverla comunque?';
      }
      dialogService.confirmDialog(deleteMessage, function () {
        $log.info('deleting id:' + idToDelete);
        eventconfigFactory.deleteEventConfig({
          id: idToDelete
        }).$promise.then(function () {
          $scope.getEventConfigList();
          $location.path('/eventconfig', false);
        });
      });
    });
  };
  $scope.save = function () {
    //semplice validazione
    if (!$scope.eventconfig.model.code) {
      toaster.pop('error', 'Errore salvataggio', 'Devi dare un nome alla regola.');
      return;
    }
    if (!$scope.eventconfig.model.then && !$scope.eventconfig.model.action) {
      toaster.pop('error', 'Errore salvataggio', 'Devi indicare un\'azione o un THEN da eseguire.');
      return;
    }
    if ($scope.eventconfig.model.action == 'mail') {
      $scope.eventconfig.model.config = removeEmptyElements(angular.copy($scope.mailConf));
    } else if ($scope.eventconfig.model.action == 'rest') {
      $scope.eventconfig.model.config = removeEmptyElements(angular.copy($scope.restConf));
    }
    //valido e poi salvo
    eventconfigFactory.validateEventConfig($scope.eventconfig).$promise.then(function (response) {
      if ($scope.isNew) {
        /* se è nuovo */
        eventconfigFactory.saveEventConfig($scope.eventconfig.model).$promise.then(function (response) {
          toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
          $scope.goToEventconfigList();
        })["catch"](function (response) {
          toaster.pop('error', 'Errore salvataggio', 'Si è verificato un errore durante il salvataggio');
        });
      } else {
        /* se è già versionato */
        setDataCommissions($scope.eventconfig, $scope.commissions.selected);
        eventconfigFactory.updateEventConfig({
          id: $scope.eventconfig.version
        }, $scope.eventconfig).$promise.then(function (resp) {
          toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
          $scope.goToEventconfigList();
        })["catch"](function (rejection) {
          toaster.pop('error', 'Errore salvataggio', rejection.data.message ? rejection.data.message : rejection.statusText);
        });
      }
    })["catch"](function (rejection) {
      toaster.pop('error', 'Errore salvataggio', rejection.data.message ? rejection.data.message : rejection.statusText);
    });
  };
  $scope.cloneSelected = function () {
    ngDialog.open({
      plain: false,
      template: 'theme/eventconfig/clonemodal.html',
      name: 'cloneconfig',
      closeByDocument: true,
      showClose: true,
      className: 'ngdialog-theme-default',
      width: '50%',
      scope: $scope
    });
  };
  $scope.cloneConfig = function (commission) {
    var rows = $scope.params.gridApi.selection.getSelectedGridRows();
    if (rows.length && commission) {
      var docs = rows.map(function (row) {
        return row.entity.model;
      });
      eventconfigFactory.bulkSave({
        commission: commission.key
      }, docs).$promise.then(function (resp) {
        toaster.pop('success', "Configurazioni Salvate");
      })["catch"](function (error) {
        toaster.pop("error", "Errore", error.message);
      });
    }
  };
  $scope.toggleCalendarMode = function (rule) {
    if (angular.isUndefined(rule.calendar_mode)) {
      rule.calendar_mode = true;
    } else {
      rule.calendar_mode = !rule.calendar_mode;
    }
    if (rule.calendar_mode == false) {
      rule.field = '';
      rule.value = '';
    } else {
      rule.field = {
        key: '',
        value: ''
      };
      rule.value = {
        key: '',
        value: ''
      };
    }
  };
  $scope.appendWhenTemplate = function (template) {
    if (!$scope.eventconfig.model.when) {
      $scope.eventconfig.model.when = template.key;
    } else {
      if ($scope.eventconfig.model.when.indexOf(template.key) == -1) {
        $scope.eventconfig.model.when += template.key;
      }
    }
  };
  $scope.needSchema = function () {
    return $scope.eventconfig.model.type == 'record';
  };
  $scope.addRuleConfig = function (where) {
    if (!where) {
      if (!$scope.eventconfig.model.ruleConfig) {
        $scope.eventconfig.model.ruleConfig = [];
      }
      where = $scope.eventconfig.model.ruleConfig;
    }
    where.push({
      calendar_mode: false,
      connector: '&&',
      field: '',
      op: '==',
      value: '',
      prevValue: false,
      rules: []
    });
  };
  $scope.removeRuleConfig = function (scope, index) {
    scope.$parent.$parent.ruleContainer.splice(index, 1);
  };

  /* Configurazione azioni */
  $scope.mailConf = {
    to_mail: [],
    to_field: [],
    to_operator: [],
    cc_mail: [],
    cc_field: [],
    cc_operator: [],
    bcc_mail: [],
    bcc_field: [],
    bcc_operator: [],
    mail_subject: "",
    mail_body: ""
  };
  $scope.restConf = {
    rest_method: "GET",
    rest_url: "",
    rest_body: ""
  };
  $scope.addEmptyValue = function (variable, type) {
    switch (type) {
      case 'string':
        variable.push("");
        break;
      case "reference":
        variable.push({});
    }
  };
  $scope.removeValue = function (variable, index) {
    variable.splice(index, 1);
  };
  $scope.mailOperatorFilter = function (item) {
    return item.value && (item.value.format == 'lookup' && item.value.entity_id == 'operatore' || item.value.format == 'watcher');
  };
  $scope.assignSchema = function (item) {
    $scope.eventconfig.model.schema = item.code;
  };
  function removeEmptyElements(config) {
    //usata per il cleanup delle config prima del salvataggio
    angular.forEach(config, function (el, i, arr) {
      if (Array.isArray(el)) {
        angular.forEach(arr[i], function (subEl, k, subArr) {
          if (subEl == null || angular.equals({}, subEl) || subEl == "") {
            subArr.splice(k, 1);
          }
        });
      }
    });
    return config;
  }
  function ruleConfigCompile(ruleArray, isRoot, ruleStart) {
    if (!ruleArray) return "";
    if (!ruleStart) ruleStart = {};
    var compiled = "";
    ruleArray.forEach(function (rule) {
      if (isRoot) compiled += "\n\t\t";
      compiled += rule.connector + " (";
      var field = rule.field;
      var value = rule.calendar_mode ? rule.value : escapedString(rule.value);
      var prop = $scope.properties[field];
      if (prop && prop.format && prop.format == 'lookup') {
        field += '.UUID';
      }
      if (rule.prevValue) {
        ruleStart[makeVarname(field)] = "OldItem(" + makeVarname(field) + ": getField(" + escapedString(field) + ")) ";
      }
      compiled += rule.calendar_mode ? "Calendar" : "Item";
      compiled += "(getField(\"" + field + "\") " + rule.op + (rule.prevValue ? makeVarname(field) : value) + ") ";
      compiled += ruleConfigCompile(rule.rules, false, ruleStart);
      compiled += ") ";
    });
    if (isRoot) {
      for (var r in ruleStart) {
        compiled = "\n\t\t" + ruleStart[r] + compiled;
      }
    }
    return compiled;
  }
  function makeVarname(string) {
    return "$prev" + string.replace(".", "");
  }
  function escapedString(string) {
    return "\"" + string.replace("\"", "\\\"") + "\"";
  }

  /* update regola when generata */
  $scope.$watch('eventconfig.model.ruleConfig', function (newVal, oldVal) {
    $scope.eventconfig.model.generated_when = ruleConfigCompile(newVal, true);
  }, true);

  /* caricamento dei campi del modello per mostrarli tra {{ }} */
  $scope.$watch('eventconfig.model.type', function (newVal, oldVal) {
    if (newVal != oldVal) {
      loadFieldList(newVal);
    }
  });
  $scope.$watch('eventconfig.model.schemaRef', function (newVal, oldVal) {
    if (!newVal) {
      $scope.properties = {};
      $scope.eventconfig.model.schema = undefined;
    } else if (newVal != oldVal) {
      loadFieldList($scope.eventconfig.model.type);
    }
  }, true);
  $scope.hasProperties = function () {
    return Object.keys($scope.properties).length != 0;
  };
  $scope.ruleValueNeedsFormat = function (eventconfig, rule, format) {
    var canBeLookup = ruleValueNeedsLookup(rule);
    var knownValueTypes = $scope.ruleKnownValues[eventconfig.model.type];
    var canBeSelect = knownValueTypes ? knownValueTypes[rule.field] : false;
    if (format == 'lookup' && canBeLookup || format == 'select' && canBeSelect || format == 'input' && !canBeSelect && !canBeLookup) {
      return true;
    } else {
      return false;
    }
  };
  var ruleValueNeedsLookup = function ruleValueNeedsLookup(rule) {
    var prop = $scope.properties[rule.field];
    return prop && prop.format && prop.format == "lookup";
  };
  $scope.ruleValueLookupBasePath = function (rule) {
    var prop = $scope.properties[rule.field];
    if (prop && prop.basePath) {
      return prop.basePath;
    } else {
      return 'record';
    }
  };
  $scope.ruleValueLookupType = function (rule) {
    var prop = $scope.properties[rule.field];
    if (prop && prop.entity_id) {
      return prop.entity_id;
    } else {
      return null;
    }
  };
  $scope.ruleValueLookupWar = function (rule) {
    var prop = $scope.properties[rule.field];
    if (prop && prop.war) {
      return prop.war;
    } else {
      return 'six-data-set';
    }
  };
  $scope.assignRuleValue = function (rule, item) {
    if (item) {
      rule.value = item.UUID;
    } else {
      rule.value = '';
    }
  };
  function loadFieldList(type) {
    var promise;
    var customProperties = {};
    switch (type) {
      case 'odl':
        promise = odlFactory().getOdlSchema().$promise;
        customProperties = {
          'date_insertion': {
            title: 'Data inserimento'
          },
          'date_requested': {
            title: 'Data richiesta'
          },
          'date_handling': {
            title: 'Data inizio lavori'
          },
          'date_closing': {
            title: 'Data chiusura'
          },
          'issue_id': {
            title: 'Segnalazione',
            format: 'lookup',
            entity_id: 'record',
            basePath: 'issue',
            war: 'six-plan'
          },
          'model.type_id': {
            title: 'Tipo Asset',
            format: 'lookup',
            entity_id: 'schema'
          },
          'model.record_id.UUID': {
            title: 'Asset (UUID)'
          },
          'model.service_id': {
            title: 'Servizio',
            format: 'lookup',
            entity_id: 'service'
          },
          'references_assignee.supplier_id': {
            title: 'Fornitore',
            format: 'lookup',
            entity_id: 'operatore'
          },
          'references_assignee.company_id': {
            title: 'Azienda assegnataria',
            format: 'lookup',
            entity_id: 'operatore'
          },
          'references_assignee.headmanCommission_id': {
            title: 'Capo commessa',
            format: 'lookup',
            entity_id: 'operatore'
          },
          'references_assignee.supervisorInternal_id': {
            title: 'Responsabile interno',
            format: 'lookup',
            entity_id: 'operatore'
          },
          'references_assignee.supervisorExternal_id': {
            title: 'Responsabile esterno',
            format: 'lookup',
            entity_id: 'operatore'
          },
          'references_assignee.technicianCommission_id': {
            title: 'Tecnico commessa',
            format: 'lookup',
            entity_id: 'operatore'
          },
          'references_assignee.maintainer_id': {
            title: 'Manutentori',
            format: 'lookup',
            entity_id: 'operatore'
          },
          'watchers.external': {
            title: 'Watchers Esterni',
            format: 'watcher'
          },
          'watchers.internal': {
            title: 'Watchers Interni',
            format: 'watcher'
          },
          'status': {
            title: 'Stato'
          },
          'status_note': {
            title: 'Note Stato'
          },
          'task_id': {
            title: 'Compito',
            format: 'lookup',
            entity_id: 'task',
            basePath: './',
            war: 'six-plan'
          },
          'model.insertedFrom': {
            title: 'Fonte (portal o callcenter)'
          }
        };
        break;
      case 'issue':
        promise = issueFactory('issue/schema').callCenter().$promise;
        customProperties = {
          'date_insertion': {
            title: 'Data inserimento'
          },
          'date_requested': {
            title: 'Data richiesta'
          },
          'date_handling': {
            title: 'Data di presa in carico'
          },
          'date_closing': {
            title: 'Data chiusura'
          },
          'model.type_id': {
            title: 'Tipo Asset',
            format: 'lookup',
            entity_id: 'schema'
          },
          'model.record_id.UUID': {
            title: 'Asset (UUID)'
          },
          'model.service_id': {
            title: 'Servizio',
            format: 'lookup',
            entity_id: 'service'
          },
          'reporter_id': {
            title: 'Richiedente',
            format: 'lookup',
            entity_id: 'operatore'
          },
          'references_assignee.supervisorExternal_id': {
            title: 'Responsabile esterno',
            format: 'lookup',
            entity_id: 'operatore'
          },
          'references_assignee.secretariat_id': {
            title: 'Segreteria',
            format: 'lookup',
            entity_id: 'segreteria'
          },
          'references_assignee.activityReferer_id': {
            title: 'Referente attività',
            format: 'lookup',
            entity_id: 'operatore'
          },
          'watchers.external': {
            title: 'Watchers Esterni',
            format: 'watcher'
          },
          'watchers.internal': {
            title: 'Watchers Interni',
            format: 'watcher'
          },
          'status': {
            title: 'Stato'
          },
          'status_note': {
            title: 'Note Stato'
          },
          'model.insertedFrom': {
            title: 'Fonte (portal o callcenter)'
          }
        };
        break;
      case 'record':
        promise = schemaFactory().byUUID({
          id: $scope.eventconfig.model.schema
        }).$promise;
        break;
      case 'estimate':
        promise = schemaFactory().byCode({
          id: 'estimateheader'
        }).$promise;
        break;
      case 'consumptive':
        promise = schemaFactory().byCode({
          id: 'consumptiveheader'
        }).$promise;
        break;
      case 'invoice':
        promise = schemaFactory().byCode({
          id: 'invoiceheader'
        }).$promise;
        customProperties = {
          'model.status': {
            title: 'Stato'
          },
          'model.generation_code': {
            title: 'Id generazione righe'
          },
          'model.generation_pending': {
            title: 'Stato generazione righe'
          }
        };
        break;
      default:
        promise = $q(function (resolve, reject) {
          resolve(false);
        });
        break;
    }
    /* una volta risolto lo schema */
    promise.then(function (response) {
      if (response.UUID) {
        $scope.schema = response;
        if ($scope.schema.model.schema.properties) {
          // attacco la stringa 'model.' a tutte le proprietà del modello
          for (var key in $scope.schema.model.schema.properties) {
            $scope.schema.model.schema.properties['model.' + key] = $scope.schema.model.schema.properties[key];
            delete $scope.schema.model.schema.properties[key];
          }
          $scope.properties = Object.assign($scope.schema.model.schema.properties, customProperties);
        }
      } else {
        $scope.properties = {};
      }
    });
  }
  $scope.appendSchema = function (dest) {
    switch (dest.key) {
      case 'mail_subject':
        if ($scope.mailConf.mail_subject) {
          $scope.mailConf.mail_subject = $scope.mailConf.mail_subject.concat(" {{" + $scope.fieldToSolve.value + "}}");
        } else {
          $scope.mailConf.mail_subject = "{{" + $scope.fieldToSolve.value + "}}";
        }
        break;
      case 'mail_body':
        if ($scope.mailConf.mail_body) {
          $scope.mailConf.mail_body = $scope.mailConf.mail_body.concat(" {{" + $scope.fieldToSolve.value + "}}");
        } else {
          $scope.mailConf.mail_body = "{{" + $scope.fieldToSolve.value + "}}";
        }
        break;
      case 'rest_url':
        if ($scope.restConf.rest_url) {
          $scope.restConf.rest_url = $scope.restConf.rest_url.concat(" {{" + $scope.fieldToSolve.value + "}}");
        } else {
          $scope.restConf.rest_url = "{{" + $scope.fieldToSolve.value + "}}";
        }
        break;
      case 'rest_body':
        if ($scope.restConf.rest_body) {
          $scope.restConf.rest_body = $scope.restConf.rest_body.concat(" {{" + $scope.fieldToSolve.value + "}}");
        } else {
          $scope.restConf.rest_body = "{{" + $scope.fieldToSolve.value + "}}";
        }
        break;
    }
  };

  //configurazione analoga a sixsendemail
  $scope.tinymceOptions = {
    height: 300,
    plugins: ['advlist autolink link image lists charmap print preview hr anchor pagebreak', 'searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime nonbreaking', 'save table contextmenu directionality template paste textcolor'],
    toolbar: 'insertfile undo redo | fontsizeselect fontselect styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link | print preview fullpage | forecolor backcolor',
    menu: {
      file: {
        title: 'File',
        items: 'print'
      },
      edit: {
        title: 'Edit',
        items: 'undo redo | cut copy paste pastetext | selectall'
      },
      insert: {
        title: 'Insert',
        items: 'link hr'
      },
      view: {
        title: 'View',
        items: 'preview'
      },
      format: {
        title: 'Format',
        items: 'bold italic underline strikethrough superscript subscript | formats'
      },
      table: {
        title: 'Table',
        items: 'inserttable tableprops deletetable | cell row column'
      },
      tools: {
        title: 'Tools',
        items: 'spellchecker code'
      }
    },
    language_url: 'theme/attachments/it.conf',
    language: 'it',
    force_br_newlines: false,
    force_p_newlines: false,
    convert_urls: false
  };
  if ($routeParams.uuid) {
    $scope.getEventConfigById($routeParams.uuid);
  } else {
    $scope.getEventConfigList();
  }

  /** ***********************************
   * Commesse
   * ***********************************/

  function loadCommissionList() {
    return commissionFactory().getCommissionsSelectList().$promise.then(function (response) {
      if (response.list) {
        $scope.commissions.list = response.list;
      }
      return response;
    });
  }
  function fillCommissionFromAvailables(commissions) {
    if (!$scope.commissions.list || $scope.commissions.list.length === 0) {
      loadCommissionList().then(function () {
        _fillCommissionFromAvailables(commissions);
      });
    } else {
      _fillCommissionFromAvailables(commissions);
    }
  }
  function _fillCommissionFromAvailables(commissions) {
    $scope.commissions.selected = [];
    [].concat(commissions).forEach(function (code) {
      var found = _findCommissionFromAvailables(code);
      if (found) {
        $scope.commissions.selected.push(found);
      }
    });
  }
  function _findCommissionFromAvailables(code) {
    if ($scope.commissions.list && $scope.commissions.list.length > 0) {
      for (var idx in $scope.commissions.list) {
        if ($scope.commissions.list[idx].key === code) {
          return $scope.commissions.list[idx];
        }
      }
    }
    return undefined;
  }
  function setDataCommissions(data, commissions) {
    data.commission = [];
    [].concat(commissions).forEach(function (c) {
      data.commission.push(c.key);
    });
  }

  /** ************************************
   * HELP WINDOW
   *********************************** **/

  $scope.showHelpWindow = function () {
    var dialogScope = {};
    var opts = {
      name: 'helpDialog',
      closeByDocument: true,
      plain: false
    };
    dialogService.templateDialog('helpTemplate.html', dialogService.DIALOG_TYPE.INFO, dialogScope, opts, -1, false);
  };
}]);
'use strict';

/**
 * @ngdoc service
 * @name emma.theme.alfrescoFactory
 * @description
 * # alfrescoFactory
 */
angular.module('emma.theme').factory('alfrescoFactory', ["$resource", "ALFRESCO_URL", function ($resource, ALFRESCO_URL) {
  return $resource(ALFRESCO_URL + '/api/alfresco' + '/:verb/:id', {}, {
    renameNode: {
      method: 'POST',
      isArray: false,
      params: {
        id: '@id',
        verb: '_rename'
      }
    },
    listFiles: {
      method: 'GET',
      isArray: false,
      params: {
        verb: '_list'
      }
    },
    fileExists: {
      method: 'GET',
      isArray: false,
      params: {
        verb: '_exists'
      }
    }
  });
}]);
'use strict';

/**
 * @ngdoc service
 * @name emma.theme.commissionFactory
 * @description
 * # commissionFactory
 * Factory in the emma.theme.
 */
angular.module('emma.theme').factory('commissionFactory', ["APP_URL", "$resource", function (APP_URL, $resource) {
  return function (entity) {
    return $resource(APP_URL + '/rest/commission/:verb/:id/:code', {}, {
      getCommissionsList: {
        method: 'GET',
        params: {
          verb: '_list',
          sort_fields: 'code:asc',
          page_size: 10000
        }
      },
      search: {
        method: 'POST',
        isArray: false,
        params: {
          verb: '_search',
          sort_fields: 'code:asc'
        }
      },
      getCommissionsSelectList: {
        method: 'GET',
        isArray: false,
        params: {
          verb: '_select',
          sort_fields: 'code:asc',
          page_size: 10000
        }
      },
      saveCommission: {
        method: 'POST'
      },
      deleteCommission: {
        method: 'DELETE'
      },
      getCommissionByCode: {
        method: 'GET',
        params: {
          verb: '_code'
        }
      },
      getCodeConfig: {
        method: 'GET',
        params: {
          verb: '_config'
        }
      }
    });
  };
}]);
"use strict";

angular.module('emma.theme').factory('concurrencyEntityWSFactory', ["APP_URL", "ENV", "DEV", "$websocket", "$log", "$location", "$timeout", "dialogService", function (APP_URL, ENV, DEV, $websocket, $log, $location, $timeout, dialogService) {
  var MAX_ATTEMPTS = 2;
  var user;
  var ws;
  var listeners = [];
  var method = {};
  method.connect = function (userName) {
    if (ws) ws.close();

    // costruzione url
    var wsPath;
    if ($location.protocol() == 'https') {
      wsPath = 'wss://'; // se viaggio su https
    } else {
      wsPath = 'ws://'; // se viaggio su http
    }

    wsPath += $location.host() + ':' + $location.port() + '/';
    if (!DEV) {
      wsPath += ENV + '/';
    }
    wsPath += 'ws/' + APP_URL + '/concurrency/ws/' + userName;
    ws = $websocket(wsPath);
    user = userName;
    ws.onOpen(function () {
      $log.info("Socket with concurrency/ws has been opened!");
    });
    ws.onClose(function (event) {
      $log.warn("Socket with concurrency/ws has been closed!");
    });
    ws.onError(function (event) {
      $log.error('concurrencyEntityWSFactory error', event);
    });
    ws.onMessage(function (message) {
      $log.debug(message);
      var parsed = JSON.parse(message.data);
      $log.debug('responseId = ' + parsed.$id);
      listeners.forEach(function (l) {
        l(parsed);
      });
    });
  };
  method.register = function (listener) {
    listeners.push(listener);
    return function () {
      var idx = listeners.indexOf(listener);
      if (idx > -1) {
        listeners.splice(idx, 1);
      }
    };
  };
  method.sendOpen = function (params, template) {
    var msg = {
      operation: 'open',
      resource_type: params.type || getType(template),
      uid: params.id
    };
    _send(msg, 0);
  };
  method.sendClose = function (params, template) {
    var msg = {
      operation: 'close',
      resource_type: params.type || getType(template),
      uid: params.id
    };
    _send(msg, 0);
  };
  function _send(msg, attempts) {
    if (!(msg.uid && msg.operation)) {
      $log.debug('Invalid message', msg);
      return;
    }
    if (ws) {
      if (ws.readyState == 0) {
        // connecting => aspetto e riprovo ad inviare
        $log.info('readyState = ' + ws.readyState + ' => retry ' + (attempts + 1));
        $timeout(function () {
          _send(msg, attempts + 1);
        }, 1000);
      } else if (ws.readyState == 1) {
        // open
        $log.debug('Sending message ', msg);
        var stringified = JSON.stringify(msg);
        ws.send(stringified).then(function () {
          $log.info('Message sent ', msg);
        });
      } else if (attempts < MAX_ATTEMPTS) {
        // closing o closed => provo a riconnettermi
        $log.warn('readyState = ' + ws.readyState + ' => retry ' + (attempts + 1));
        method.connect(user);
        $timeout(function () {
          _send(msg, attempts + 1);
        }, 200);
      } else {
        $log.error('readyState = ' + ws.readyState + ' => too many attempts (' + attempts + ')!!!');
        dialogService.dialog('Attenzione', 'La connessione con il server è stata persa: provare a ricaricare la pagina', dialogService.DIALOG_TYPE.WARNING, -1);
      }
    } else {
      $log.error('ws undefined: maybe you\'re not connected');
    }
  }
  function getType(route) {
    console.log(route);
    return route.replace(/\/:([^\/]+)|(\/|_)detail|^\//g, '').replace('/', '_');
  }
  return method;
}]);
'use strict';

/**
 * @ngdoc service
 * @name emma.theme.counter
 * @description
 * # counter
 * Factory in the emma.theme.
 */
angular.module('emma.theme').factory('counterFactory', ["APP_URL", "$resource", function (APP_URL, $resource) {
  return $resource(APP_URL + '/rest/counter/:op/:code', {}, {
    next: {
      method: 'GET',
      params: {
        op: 'next'
      },
      isArray: false
    },
    current: {
      method: 'GET',
      params: {
        op: 'current'
      },
      isArray: false
    }
  });
}]);
'use strict';

/**
 * @ngdoc service
 * @name emma.theme.cronExpressionFactory
 * @description
 * # cronExpressionFactory
 * Factory in the emma.theme.
 */
angular.module('emma.theme').factory('cronExpressionFactory', ["APP_URL", "$resource", function (APP_URL, $resource) {
  return $resource(APP_URL + '/rest/cron/:verb/:param1', {}, {
    getSimulationEvents: {
      method: 'POST',
      params: {
        verb: '_events'
      }
    },
    getCronExpression: {
      method: 'POST',
      params: {
        verb: '_expression'
      }
    },
    getCronExpressionBulk: {
      method: 'POST',
      params: {
        verb: '_expression',
        param1: '_bulk'
      }
    }
  });
}]);
'use strict';

/**
 * @ngdoc service
 * @name emma.theme.dashboardAssetFactory
 * @description
 * # dashboardAssetFactory
 * Factory in the emma.theme.
 */
angular.module('emma.theme').factory('dashboardAssetFactory', ["PLAN_URL", "$resource", function (PLAN_URL, $resource) {
  return function (entity) {
    return $resource(PLAN_URL + '/api/' + entity + '/:id', {}, {
      query: {
        method: 'GET',
        isArray: false
      }
    });
  };
}]);
'use strict';

/**
 * @ngdoc service
 * @name emma.theme.dashboardEmmaFactory
 * @description
 * # dashboardEmmaFactory
 * Factory in the emma.theme.
 */
angular.module('emma.theme').factory('dashboardEmmaFactory', ["ENERGY_URL", "$resource", function (ENERGY_URL, $resource) {
  return function (entity) {
    return $resource(ENERGY_URL + '/api/' + entity + '/:id', {}, {
      getConfig: {
        method: 'GET',
        url: ENERGY_URL + '/api/dashboard/_config'
      }
    });
  };
}]);
'use strict';

/**
 * @ngdoc service
 * @name emma.theme.baseFactory
 * @description
 * # baseFactory
 * Factory in the emma.theme.
 */
angular.module('emma.theme').factory('evalFactory', ["ENERGY_URL", "$resource", function (ENERGY_URL, $resource) {
  return $resource(ENERGY_URL + '/api/eval/:verb/:id/:param1/:param2/:param3', {}, {
    evalConsumption: {
      method: 'GET',
      isArray: false,
      params: {
        verb: 'consumption'
      }
    },
    evalBudget: {
      method: 'GET',
      isArray: false,
      params: {
        verb: 'budget'
      }
    },
    budgetAndEval: {
      method: 'POST',
      isArray: false,
      params: {
        verb: 'budgetandeval'
      }
    },
    analysis: {
      method: 'GET',
      isArray: false,
      params: {
        verb: 'analysis'
      }
    }
  });
}]);
'use strict';

/**
 * @ngdoc service
 * @name sixEmmaApp.eventconfigFactory
 * @description
 * # eventconfigFactory
 * Factory in the sixEmmaApp.
 */
angular.module('emma.theme').factory('eventconfigFactory', ["APP_URL", "$resource", function (APP_URL, $resource) {
  return $resource(APP_URL + '/rest/eventconfig/:verb/:id/:uuid', {}, {
    search: {
      method: 'POST',
      isArray: false,
      params: {
        verb: '_search'
      }
    },
    deleteEventConfig: {
      method: 'DELETE'
    },
    updateEventConfig: {
      method: 'PUT'
    },
    saveEventConfig: {
      method: 'POST'
    },
    bulkSave: {
      method: 'POST',
      params: {
        verb: '_bulk'
      }
    },
    validateEventConfig: {
      method: 'POST',
      params: {
        verb: '_validate'
      }
    },
    getEventConfigByUUID: {
      method: 'GET',
      params: {
        verb: '_uuid'
      }
    },
    referenceCount: {
      method: 'GET',
      params: {
        verb: '_referencecount'
      },
      isArray: false,
      ignoreLoadingBar: true
    }
  });
}]);
'use strict';

/**
 * @ngdoc service
 * @name emma.theme.groupFactory
 * @description
 * # groupFactory
 * Factory in the emma.theme.
 */
angular.module('emma.theme').factory('groupFactory', ["APP_URL", "$resource", function (APP_URL, $resource) {
  return $resource(APP_URL + '/rest/group/:verb/:id/:uuid', {}, {
    getGroup: {
      method: 'GET',
      params: {
        verb: '_list'
      }
    },
    getGroupsList: {
      method: 'GET',
      params: {
        verb: '_relations'
      }
    },
    getModelsList: {
      method: 'GET',
      params: {
        verb: 'domain.model'
      }
    },
    saveKey: {
      method: 'POST'
    }
    //deleteGroup:             {method: 'DELETE',  params: {verb: '_delete'}},
    //updateGroup:             {method: 'PUT',     params: {verb: '_update'}},
    //saveGroup:               {method: 'POST',    params: {verb: '_save'}},
    //getGroupByUUID:          {method: 'GET',     params: {verb: '_uuid'}}
  });
}]);
'use strict';

/**
 * @ngdoc service
 * @name emma.theme.groupFactory
 * @description
 * # groupFactory
 * Factory in the emma.theme.
 */
angular.module('emma.theme').factory('moduleInfoFactory', ["$resource", "DEV", function ($resource, DEV) {
  return function (MODULE_URL, api) {
    api = api || 'api';
    return $resource('api/' + MODULE_URL + '/' + api + '/meta/:verb/:param1/:param2/:param3', {}, {
      info: {
        method: 'GET',
        params: {
          verb: '_info'
        }
      }
    });
  };
}]);
'use strict';

/**
 * @ngdoc service
 * @name emma.theme.notificationFactory
 * @description
 * # notificationFactory
 * Factory in the emma.theme.
 */
angular.module('emma.theme').factory('notificationFactory', ["APP_URL", "$resource", function (APP_URL, $resource) {
  return function (entity) {
    return $resource(APP_URL + '/rest/notification/:type/:verb/:id/:param1', {}, {
      sendEmail: {
        method: 'POST',
        params: {
          type: 'mail',
          verb: '_send'
        }
      },
      getList: {
        method: 'POST',
        params: {
          type: 'mail',
          verb: '_list'
        }
      },
      getEmailById: {
        method: 'POST',
        params: {
          type: 'mail',
          verb: '_detail'
        }
      },
      getListFiltered: {
        method: 'POST',
        params: {
          type: 'mail',
          verb: '_list',
          param1: '_filtered'
        }
      },
      search: {
        method: 'POST',
        isArray: false,
        params: {
          verb: '_search'
        }
      }
    });
  };
}]);
'use strict';

angular.module('emma.theme').factory('profilinggroupFactory', ["APP_URL", "$resource", function (APP_URL, $resource) {
  return $resource(APP_URL + '/rest/profilinggroup/:id/:verb', {}, {
    update: {
      method: 'PUT',
      params: {}
    },
    search: {
      method: 'POST',
      params: {
        verb: '_search'
      }
    },
    fetchAll: {
      method: 'POST',
      params: {
        verb: '_fetchall'
      }
    },
    groups: {
      method: 'GET',
      params: {
        verb: 'groups'
      }
    }
  });
}]);
/**
 * Created by luca on 18/10/16.
 */

'use strict';

/**
 * @ngdoc service
 * @name emma.theme.user
 * @description
 * # user
 * Factory in the emma.theme.
 */
angular.module('emma.theme').factory('userFactory', ["APP_URL", "$resource", function (APP_URL, $resource) {
  return $resource(APP_URL + '/rest/user/:verb', {}, {
    getMail: {
      method: 'POST',
      params: {
        verb: 'search'
      }
    }
  });
}]);
"use strict";

/**
 * Permette la formattazione di un numero in bytes e suoi multipli
 */

angular.module('emma.theme').filter('bytes', function () {
  return function (bytes, precision) {
    if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return '-';
    if (typeof precision === 'undefined') precision = 1;
    var units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'],
      number = Math.floor(Math.log(bytes) / Math.log(1024));
    return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) + ' ' + units[number];
  };
});
"use strict";

/**
 * Created by stefano on 08/03/17.
 *
 * Il filtro 'cut' consente di visualizzare le stringhe fino ad un limite massimo di caratteri.
 * Es. text='abcdefghilmnopqrstuvz'
 *     {{text | cut:true:10:'...'}} visualizza 'abcdefghil...'
 */

angular.module('emma.theme').filter('cut', function () {
  return function (value, wordwise, max, tail) {
    if (!value) return '';
    max = parseInt(max, 10);
    if (!max) return value;
    if (value.length <= max) return value;
    value = value.substr(0, max);
    if (wordwise) {
      var lastspace = value.lastIndexOf(' ');
      if (lastspace !== -1) {
        //Also remove . and , so its gives a cleaner result.
        if (value.charAt(lastspace - 1) === '.' || value.charAt(lastspace - 1) === ',') {
          lastspace = lastspace - 1;
        }
        value = value.substr(0, lastspace);
      }
    }
    return value + (tail || '...');
  };
});
'use strict';

angular.module('emma.theme').filter('minValue', function () {
  return Math.min;
}).filter('maxValue', function () {
  return Math.max;
});
"use strict";

angular.module('emma.theme').filter('reference', ['$filter', function ($filter) {
  return function (value, cutDescription) {
    if (!value) return '';
    var description = value.description;
    if (cutDescription) {
      description = $filter('cut')(value.description, true, 100, '...');
    }
    if (value.customCode) {
      return '[' + value.customCode + '] - ' + description + (value.code ? ' - ' + value.code : '');
    } else {
      return (value.code ? value.code + ' - ' : '') + description;
    }
  };
}]);
"use strict";

//mediaApp.filter('capitalize', function() {
//    return function(input, scope) {
//        if (input!=null)
//            return input.substring(0,1).toUpperCase()+input.substring(1);
//    }
//});

angular.module('emma.theme')

//USO: {{m|monthName}} --> m=0 -> Gennaio
.filter('monthName', function () {
  return function (input, scope) {
    return sixDateLib.getMonthName(input);
  };
})

//USO: {{m|monthShortName}} --> m=0 -> Gen
.filter('monthShortName', function () {
  return function (input, scope) {
    return sixDateLib.getMonthShortName(input);
  };
});
'use strict';

/**
 * @ngdoc filter
 * @name emma.theme.filter:startfrom
 * @function
 * @description
 * # startfrom
 * Filter in the emma.theme.
 */
angular.module('emma.theme').filter('startFrom', function () {
  return function (input, start) {
    if (input) {
      start = +start;
      var filtered = input.slice(start);
      return filtered;
    }
    return [];
  };
});
'use strict';

angular.module('emma.theme').filter('titleCase', function () {
  return function (input, delimiters) {
    if (angular.isString(input) && input.length) {
      var delimiterArray = [' '];
      if (angular.isString(delimiters) && delimiters.length) {
        delimiterArray = delimiter.split('');
      }
      var capitalizeNext = true,
        output = '';
      for (var i = 0; i < input.length; i++) {
        var ch = input.charAt(i);
        if (delimiterArray.indexOf(ch) >= 0) {
          output += ch;
          capitalizeNext = true;
        } else if (capitalizeNext) {
          output += ch.toUpperCase();
          capitalizeNext = false;
        } else {
          output += ch;
        }
      }
      return output;
    }
    return input;
  };
});
'use strict';

/**
 * @ngdoc filter
 * @name emma.theme.filter:trustAsResourceUrl
 * @function
 * @description
 * # trustAsResourceUrl
 * Filter in the emma.theme.
 */
angular.module('emma.theme').filter('trustAsResourceUrl', ["$sce", function ($sce) {
  return function (input) {
    return $sce.trustAsResourceUrl(input);
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name emma.theme.controller:GroupDetailCtrl
 * @description
 * # GroupDetailCtrl
 * Controller of the emma.theme
 */
angular.module('emma.theme').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/group/detail/:id', {
    templateUrl: 'theme/group/group_detail.html',
    controller: 'GroupDetailCtrl'
  });
}]).controller('GroupDetailCtrl', ["$scope", "$rootScope", "groupFactory", "$log", "$location", "$routeParams", "commissionFactory", "schemaFactory", "treeFactory", "toaster", function ($scope, $rootScope, groupFactory, $log, $location, $routeParams, commissionFactory, schemaFactory, treeFactory, toaster) {
  $scope.modelsList = [];
  $scope.group = {};
  $scope.TEMP_NEW = 'TEMP';

  // Gestione sixSearchTerms
  $scope.searchResult = [];
  $scope.searchFilterObj = {};
  $scope.sxSearchTerms = {
    id: 'group-search',
    showSelectSchema: true,
    open: false,
    type_id: undefined,
    type_obj: undefined
  };
  $scope.toggleSearchTerms = function () {
    $rootScope.$broadcast('sixSidebar:open', {
      id: $scope.sxSearchTerms.id
    });
  };
  $scope.onFilterChanged = function () {
    if (angular.isDefined($scope.sxSearchTerms.type_id)) {
      var key = $scope.sxSearchTerms.type_id.UUID;
      $scope.group[key] = JSON.parse(JSON.stringify(emptyKey));
      $scope.group[key].id.domain.domain1 = $scope.group.id;
      $scope.group[key].id.key = key;
      $scope.group[key].value = JSON.stringify($scope.searchFilterObj);
    }
    for (var key in $scope.sxSearchTerms.type_id) {
      delete $scope.sxSearchTerms.type_id[key];
    }
    delete $scope.group[$scope.TEMP_NEW];
  };
  $scope.isEmptyFilter = function () {
    return Object.keys($scope.searchFilterObj).length === 0;
  };
  $scope.emptyFilter = function () {
    for (var key in $scope.searchFilterObj) {
      delete $scope.searchFilterObj[key];
    }
  };
  //---
  $scope.addAssetDetail = function () {
    $scope.group[$scope.TEMP_NEW] = JSON.parse(JSON.stringify(emptyKey));
    $scope.group[$scope.TEMP_NEW].id.key = 'Seleziona un modello';
    $scope.emptyFilter();
    $scope.toggleSearchTerms();
  };
  var emptyKey = {
    id: {
      domain: {
        domain1: "*",
        domain2: "*",
        domain3: "*",
        domain4: "*",
        domain5: "*"
      }
      // key
    }
    // value
  };

  $scope.getModelsList = function () {
    groupFactory.getModelsList().$promise.then(function (data) {
      $scope.modelsList = data.listModel;
      $log.info("___getModelsList___");
      $log.info(data);
    });
  };
  $scope.getModels = function (id) {
    groupFactory.getModelsList().$promise.then(function (data) {
      $scope.modelsList = data.listModel;
      $log.info("___getModels___");
      $log.info(data);
      for (var i = 0; i < $scope.modelsList.length; i++) {
        var model = $scope.modelsList[i];
        $scope.group[model.name] = JSON.parse(JSON.stringify(emptyKey));
        $scope.group[model.name].id.key = model.name;
      }
      if (angular.isDefined(id)) {
        $scope.getGroup(id);
      }
    });
  };
  $scope.getGroup = function (id) {
    $scope.group.id = id;
    var payload = {
      id: $scope.group.id
    };
    groupFactory.getGroup(payload).$promise.then(function (data) {
      $log.info("___getGroup___");
      $log.info(data);
      for (var i = 0; i < data.list.length; i++) {
        var key = data.list[i].id.key;
        if (angular.isDefined($scope.group[key])) {
          $scope.group[key].value = data.list[i].value;
          $scope.group[key].id.domain.domain1 = data.list[i].id.domain.domain1;
          $scope.group[key].id.domain.domain2 = data.list[i].id.domain.domain2;
          $scope.group[key].id.domain.domain3 = data.list[i].id.domain.domain3;
          $scope.group[key].id.domain.domain4 = data.list[i].id.domain.domain4;
          $scope.group[key].id.domain.domain5 = data.list[i].id.domain.domain5;
        }
      }
      $scope.loadCommissions();
      $scope.loadTreeEntities();
    });
  };
  $scope.getCommissions = function () {
    $scope.commissionsSelected = {
      items: []
    };
    commissionFactory().getCommissionsList().$promise.then(function (response) {
      if (response.list) {
        $scope.commissions = response.list;
      }
    });
  };
  $scope.loadCommissions = function () {
    if (angular.isDefined($scope.group.commission) && angular.isDefined($scope.group.commission.value)) {
      var tokens = $scope.group.commission.value.split(";");
      for (var i = 0; i < tokens.length; i++) {
        commissionFactory().getCommissionByCode({
          code: tokens[i]
        }).$promise.then(function (response) {
          $scope.commissionsSelected.items.push(response);
        });
      }
    }
  };
  $scope.getTreeEntities = function () {
    $scope.schemasSelected = {
      items: []
    };
    treeFactory.nodeSchemasList({
      pageSize: 10000
    }).$promise.then(function (response) {
      if (response.list) {
        $scope.schemas = response.list;
      }
    });
  };
  $scope.loadTreeEntities = function () {
    if (angular.isDefined($scope.group.tree) && angular.isDefined($scope.group.tree.value)) {
      var tokens = $scope.group.tree.value.split(";");
      for (var i = 0; i < tokens.length; i++) {
        schemaFactory().byCode({
          id: tokens[i]
        }).$promise.then(function (response) {
          $scope.schemasSelected.items.push(response);
        });
      }
    }
  };
  $scope.saveForm = function () {
    if (angular.isUndefined($scope.group.id || $scope.group.id == '')) {
      toaster.pop('error', 'Errore', 'Inserire un nome per il gruppo');
    } else {
      // commission
      $scope.group.commission.value = '';
      for (var i = 0; i < $scope.commissionsSelected.items.length; i++) {
        if ($scope.group.commission.value != '') {
          $scope.group.commission.value += ';';
        }
        $scope.group.commission.value += $scope.commissionsSelected.items[i].code;
      }
      groupFactory.saveKey($scope.group.commission).$promise.then(function (response) {
        var test = response;
      });
      // tree
      $scope.group.tree.value = '';
      for (var i = 0; i < $scope.schemasSelected.items.length; i++) {
        if ($scope.group.tree.value != '') {
          $scope.group.tree.value += ';';
        }
        $scope.group.tree.value += $scope.schemasSelected.items[i].model.code;
      }
      groupFactory.saveKey($scope.group.tree).$promise.then(function (response) {
        var test = response;
      });
      // Altre entry
      if (angular.isDefined($scope.group[$scope.TEMP_NEW])) {
        delete $scope.group[$scope.TEMP_NEW];
      }
      for (var key in $scope.group) {
        if ($scope.isAssetEntry($scope.group[key])) {
          groupFactory.saveKey($scope.group[key]);
        }
      }
    }
  };
  $scope.isAssetEntry = function (group) {
    var result = true;
    if (angular.isUndefined(group.id)) {
      result = false;
    } else if (group.id.key == 'commission') {
      result = false;
    } else if (group.id.key == 'tree') {
      result = false;
    }
    return result;
  };
  $scope.removeGroup = function (key) {
    delete $scope.group[key];
  };

  //__main__
  if ($routeParams.id) {
    if ($routeParams.id != 'new') {
      $scope.isNew = false;
      $scope.getModels($routeParams.id);
    } else {
      $scope.isNew = true;
      $scope.getModels();
    }
  }
  $scope.getCommissions();
  $scope.getTreeEntities();
}]);
'use strict';

/**
 * @ngdoc function
 * @name emma.theme.controller:GroupListCtrl
 * @description
 * # GroupListCtrl
 * Controller of the emma.theme
 */
angular.module('emma.theme').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/group', {
    templateUrl: 'theme/group/group_list.html',
    controller: 'GroupListCtrl'
  });
}]).controller('GroupListCtrl', ["$scope", "groupFactory", "$log", "$location", function ($scope, groupFactory, $log, $location) {
  $scope.groupsList = {};
  $scope.getGroupsList = function () {
    groupFactory.getGroupsList().$promise.then(function (data) {
      $scope.groupsList = data.list;
    });
  };
  $scope.goToNewGroup = function () {
    $location.path('group/detail');
  };

  //__main__
  $scope.getGroupsList();
}]);
'use strict';

/**
 * @ngdoc function
 * @name ictportal.controller:ExtCtrl
 * @ExtCtrl
 * # JsfctrlCtrl
 * Controller of the ictportal
 */
angular.module('emma.theme').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/jasper', {
    templateUrl: 'theme/jasper/jasper.html',
    controller: 'JasperCtrl'
  });
}]).controller('JasperCtrl', ["APP_URL", "$scope", "$log", "authFactory", "$routeParams", "$location", function (APP_URL, $scope, $log, authFactory, $routeParams, $location) {
  var MAX_HISTORY = 5;
  var authData = authFactory.getAuthData();
  $scope.showHistory = false; //Hard-coded, sarebbe da impostare da costanti (app.constants)
  $scope.functionHistory = [];
  if (angular.isDefined(authData.info) && angular.isDefined(authData.info.history)) {
    //se viene ricaricato il browser recupero l'history
    authData.info.history.forEach(function (item) {
      var found = false;
      var i = 0;
      for (; i < $scope.functionHistory.length; i++) {
        if ($scope.functionHistory[i].route === item.route) {
          found = true;
          break;
        }
      }
      if (found) {
        $scope.functionHistory = $scope.functionHistory.splice(i, 0);
      }
      $scope.functionHistory.push(item);
    });
    $scope.functionHistory.length = MAX_HISTORY;
    $scope.extern = [];
    $scope.functionHistory.forEach(function (item) {
      if (item.route.indexOf('jasper') !== -1) {
        $scope.extern.push({
          id: item.$$hashKey,
          route: item.route
        });
      }
    });
  }
  ;
  $scope.changeRoute = function (item) {
    var tokens = item.route.split("jasper");
    if (tokens.length === 1) {
      $location.path('/' + item.route);
    } else {
      var el = angular.element(document.getElementById(item.$$hashKey));
      window.location.href = el[0].href;
    }
  };
  function random(seed) {
    var x = Math.sin(seed) * 10000;
    return x - Math.floor(x);
  }
  function pseudoguid() {
    return (S4() + S4() + "-" + S4() + "-4" + S4().substr(0, 3) + "-" + S4() + "-" + S4() + S4() + S4()).toLowerCase();
  }
  function S4(seed) {
    if (!seed) seed = new Date().getSeconds();
    return ((1 + random(seed)) * 0x10000 | 0).toString(16).substring(1);
  }
  var baseURL = "http://portale-gare.demo.sixcloud.it/";
  $scope.getExtURL = function () {
    if (authFactory.getAuthData() == null) {
      console.log('JsfCtrl auth data null');
      return '';
    }
    return baseURL + $routeParams.url + "&userId=" + authFactory.getAuthData().info.userId + "&divcod=" + authFactory.getAuthData().info.divCod;
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name emma.theme.controller:LoginCtrl
 * @description
 * # LoginCtrl
 * Controller of the emma.theme
 */
angular.module('emma.theme').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/fakelogin', {
    templateUrl: 'theme/login/fakelogin.html',
    controller: 'FakeLoginCtrl'
  });
}]).controller('FakeLoginCtrl', ["APP_URL", "$rootScope", "$scope", "$http", "$location", "authFactory", "recordFactory", "counterFactory", "toaster", "sysConfigFactory", "schemaFactory", "$log", "ENV", "localStorageService", "operatorGroupService", "$animate", "$timeout", "menuProfiling", "loginFactory", "commissionFactory", function LoginCtrl(APP_URL, $rootScope, $scope, $http, $location, authFactory, recordFactory, counterFactory, toaster, sysConfigFactory, schemaFactory, $log, ENV, localStorageService, operatorGroupService, $animate, $timeout, menuProfiling, loginFactory, commissionFactory) {
  $scope.profiles = [{
    user: 'polist',
    role: 'SuperAdmin'
  }, {
    user: 'emil',
    role: 'ICTUser'
  }, {
    user: 'dummy',
    role: 'Dummy'
  }];
  function createNewOperator(authData) {
    var filters = {
      'model.username': sixFiltersLib.exact('model.username', authData.authId)
    };
    recordFactory('operatore').search(filters).$promise.then(function (resp) {
      $log.info('------ operator ------');
      $log.info(resp);
      $log.info('----------------------');

      // Creo l'operatore solo se non esiste già un operatore con lo username loggato
      if (!resp.list || resp.list.length == 0) {
        var newOp = {};
        newOp.description = authData.info.name + ' ' + authData.info.surname;
        newOp.mail = authData.info.mail;
        newOp.username = authData.authId;
        schemaFactory().byUUID({
          id: 'operatore'
        }).$promise.then(function (schemaResp) {
          if (!schemaResp.model) {
            dialogService.alert('Non è stato definito un modello per l\'entità operatore', 4000);
            return;
          }
          /* ***** Search filters ***** */
          if (schemaResp.model.selfGeneratedCode) {
            var selfGeneratedCode = schemaResp.model.selfGeneratedCode;
            counterFactory.next({
              code: selfGeneratedCode.codeNameSix
            }).$promise.then(function (counterResp) {
              if (counterResp.errors) {
                $log.error('Errore', 'Problema rilevato nell\'inizializziazione automatica del codice: ' + counterResp.errors.error);
                toaster.pop('error', 'Errore', 'Problema rilevato nell\'inizializziazione automatica del codice: ' + counterResp.errors.error);
              } else {
                newOp.code = counterResp.next;
                var payload = {
                  page: 1,
                  page_size: 1,
                  cross: true,
                  history: false
                };
                var filters = {
                  role: sixFiltersLib["in"]('model.ldap_groups.code', authData.authPermission)
                };
                sysConfigFactory('rolemapping').search(payload, filters).$promise.then(function (result) {
                  if (result && result.list.length > 0) {
                    newOp.typeoperator_map = {};
                    authData.profiles.forEach(function (commission) {
                      newOp.typeoperator_map[commission.code] = result.list[0].model.emma_role_id;
                    });
                  } else {
                    $log.error('Mapping per il ruolo \'' + authData.authPermission + '\' non trovato');
                    // toaster.pop('warning', 'Mapping per il ruolo \''+ authData.authPermission +'\' non trovato');
                  }

                  $log.info('------ new operator ------');
                  $log.info(newOp);
                  $log.info('--------------------------');
                  recordFactory('operatore').create(newOp).$promise.then(function (respOp) {
                    $log.info('------ create operator ------');
                    $log.info(respOp);
                    $log.info('-----------------------------');
                    toaster.pop('success', 'Creato nuovo operatore per l\'utente \'' + authData.authId + '\': codice ' + respOp.model.code);
                    // set in localStorageService il gruppo operatore
                    operatorGroupService.setGroupInLocalStorage({
                      operatore: respOp
                    });
                    localStorageService.set('operatore', respOp);
                  });
                });
              }
            });
          }
        });
      } else {
        // set in localStorageService il gruppo operatore
        operatorGroupService.setGroupInLocalStorage({
          operatore: resp.list[0]
        });
        localStorageService.set('operatore', resp.list[0]);
      }
    });
  }
  $scope.login = function (profile) {
    $http.get('emmacas/fakepostauth/' + profile.user + '/' + ENV).success(function (data, status) {
      $log.info(status);
      $log.info(data);
      $scope.response = data;
      if (!data.info || !data.info.commissions || !data.info.commissions.current) {
        return;
      }
      var lastCommission = localStorageService.get(ENV + '_lastCommission');
      var lastCustomer = localStorageService.get(ENV + '_lastCustomer');
      var currentCustomer = data.profile.items.find(function (t) {
        return t.type == 'customer';
      }) || {};
      authFactory.setAuthData(data); //necessario al createNewOperator

      //switcho immediatamente commessa e cliente se necessario
      if (lastCommission && lastCommission.code != data.info.commissions.current.code || lastCustomer && lastCustomer.code != currentCustomer.code) {
        var switchProfileElement = {
          selected: {
            type: "",
            cod: 0,
            code: lastCommission.code,
            description: lastCommission.description,
            items: [{
              type: "commission",
              cod: 0,
              code: lastCommission.code,
              description: lastCommission.code + " - " + lastCommission.description
            }]
          }
        };
        if (lastCustomer && lastCustomer.code) {
          switchProfileElement.selected.items.push({
            type: "customer",
            cod: 0,
            code: lastCustomer.code,
            description: lastCustomer.description
          });
        }
        loginFactory["switch"](switchProfileElement).$promise.then(function (response) {
          $log.info("Switch automatico commessa");
          completeAuth(response);
        });
      } else {
        completeAuth(data);
      }
    }).error(function (error) {
      $log.log(error);
    });
  };
  function completeAuth(authData) {
    $log.info("fakelogin", authData);
    var commissionCode = authData.info.commissions.current.code;
    commissionFactory().getCommissionByCode({
      code: commissionCode
    }).$promise.then(function (response) {
      authData.info.commissions.current = angular.extend(response, authData.info.commissions.current);
      authFactory.setAuthData(authData);
      menuProfiling.updateMenu(authData.menu);
      createNewOperator(authData);
      var next = localStorageService.get(ENV + '_nextPath') || '/home';
      localStorageService.remove(ENV + '_nextPath');
      $location.path(next);
    });
    $timeout(function () {
      $animate.enabled(true);
    });
  }
}]);
'use strict';

/**
 * @ngdoc function
 * @name emma.theme.controller:LoginCtrl
 * @description
 * # LoginCtrl
 * Controller of the emma.theme
 */
angular.module('emma.theme').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/login', {
    templateUrl: 'theme/login/login.html',
    controller: 'LoginCtrl'
  });
}]).controller('LoginCtrl', ["APP_URL", "$rootScope", "$scope", "$http", "$location", "authFactory", "recordFactory", "counterFactory", "toaster", "sysConfigFactory", "schemaFactory", "$log", "ENV", "localStorageService", "operatorGroupService", "$animate", "$timeout", "menuProfiling", "loginFactory", "commissionFactory", function LoginCtrl(APP_URL, $rootScope, $scope, $http, $location, authFactory, recordFactory, counterFactory, toaster, sysConfigFactory, schemaFactory, $log, ENV, localStorageService, operatorGroupService, $animate, $timeout, menuProfiling, loginFactory, commissionFactory) {
  $scope.getAPIURL = function () {
    return APP_URL;
  };
  function createNewOperator(authData) {
    var filters = {
      'model.username': sixFiltersLib.exact('model.username', authData.authId)
    };
    recordFactory('operatore').search(filters).$promise.then(function (resp) {
      $log.info('------ operator ------');
      $log.info(resp);
      $log.info('----------------------');

      // Creo l'operatore solo se non esiste già un operatore con lo username loggato
      if (!resp.list || resp.list.length == 0) {
        var newOp = {};
        newOp.description = authData.info.name + ' ' + authData.info.surname;
        newOp.mail = authData.info.mail;
        newOp.username = authData.authId;
        schemaFactory().byUUID({
          id: 'operatore'
        }).$promise.then(function (schemaResp) {
          if (!schemaResp.model) {
            dialogService.alert('Non è stato definito un modello per l\'entità operatore', 4000);
            return;
          }
          /* ***** Search filters ***** */
          if (schemaResp.model.selfGeneratedCode) {
            var selfGeneratedCode = schemaResp.model.selfGeneratedCode;
            counterFactory.next({
              code: selfGeneratedCode.codeNameSix
            }).$promise.then(function (counterResp) {
              if (counterResp.errors) {
                $log.error('Errore', 'Problema rilevato nell\'inizializziazione automatica del codice: ' + counterResp.errors.error);
                toaster.pop('error', 'Errore', 'Problema rilevato nell\'inizializziazione automatica del codice: ' + counterResp.errors.error);
              } else {
                newOp.code = counterResp.next;
                var payload = {
                  page: 1,
                  page_size: 1,
                  cross: true,
                  history: false
                };
                var filters = {
                  role: sixFiltersLib["in"]('model.ldap_groups.code', authData.authPermission)
                };
                sysConfigFactory('rolemapping').search(payload, filters).$promise.then(function (result) {
                  if (result && result.list.length > 0) {
                    newOp.typeoperator_map = {};
                    authData.profiles.forEach(function (commission) {
                      newOp.typeoperator_map[commission.code] = result.list[0].model.emma_role_id;
                    });
                  } else {
                    $log.error('Mapping per il ruolo \'' + authData.authPermission + '\' non trovato');
                    // toaster.pop('warning', 'Mapping per il ruolo \''+ authData.authPermission +'\' non trovato');
                  }

                  $log.info('------ new operator ------');
                  $log.info(newOp);
                  $log.info('--------------------------');
                  recordFactory('operatore').create(newOp).$promise.then(function (respOp) {
                    $log.info('------ create operator ------');
                    $log.info(respOp);
                    $log.info('-----------------------------');
                    toaster.pop('success', 'Creato nuovo operatore per l\'utente \'' + authData.authId + '\': codice ' + respOp.model.code);
                    // set in localStorageService il gruppo operatore
                    operatorGroupService.setGroupInLocalStorage({
                      operatore: respOp
                    });
                    localStorageService.set('operatore', respOp);
                  });
                });
              }
            });
          }
        });
      } else {
        // set in localStorageService il gruppo operatore
        operatorGroupService.setGroupInLocalStorage({
          operatore: resp.list[0]
        });
        localStorageService.set('operatore', resp.list[0]);
      }
    });
  }
  $scope.login = function (user) {
    $http.post(APP_URL + '/rest/auth/login', user).success(function (data, status) {
      $log.info(status);
      $log.info(data);
      $scope.response = data;
      if (!data.info || !data.info.commissions || !data.info.commissions.current) {
        displayError();
        return;
      }
      $scope.errors = false;
      var lastCommission = localStorageService.get(ENV + '_lastCommission');
      authFactory.setAuthData(data); //necessario al createNewOperator

      //switcho immediatamente commessa se necessario
      if (lastCommission && lastCommission.code != data.info.commissions.current.code) {
        var switchProfileElement = {
          selected: {
            type: "",
            cod: 0,
            code: lastCommission.code,
            description: lastCommission.description,
            items: [{
              type: "commission",
              cod: 0,
              code: lastCommission.code,
              description: lastCommission.code + " - " + lastCommission.description
            }]
          }
        };
        loginFactory["switch"](switchProfileElement).$promise.then(function (response) {
          $log.info("Switch automatico commessa");
          completeAuth(response);
        });
      } else {
        completeAuth(data);
      }
    }).error(function (error) {
      $log.log(error);
      displayError();
    });
  };
  function displayError() {
    if ($scope.errors) {
      $('#error').fadeOut();
    }
    $('#error').fadeIn();
    $scope.errors = true;
  }
  function completeAuth(authData) {
    $log.info(authData);
    var commissionCode = authData.info.commissions.current.code;
    commissionFactory().getCommissionByCode({
      code: commissionCode
    }).$promise.then(function (response) {
      authData.info.commissions.current = angular.extend(response, authData.info.commissions.current);
      authFactory.setAuthData(authData);
      menuProfiling.updateMenu(authData.menu);
      createNewOperator(authData);
      var next = localStorageService.get(ENV + '_nextPath') || '/home';
      localStorageService.remove(ENV + '_nextPath');
      $location.path(next);
    });
    $timeout(function () {
      $animate.enabled(true);
    });
  }
}]);
'use strict';

angular.module('emma.theme').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/profilinggroup', {
    templateUrl: 'theme/profilinggroup/profilinggroup.html',
    controller: 'ProfilingGroupListCtrl'
  });
}]).controller('ProfilingGroupListCtrl', ["$scope", "$filter", "toaster", "dialogService", "profilinggroupFactory", function ($scope, $filter, toaster, dialogService, profilinggroupFactory) {
  var titleCase = $filter('titleCase');
  $scope.groupList = {
    list: []
  };
  $scope.groupNames = [];
  $scope.query = {};
  $scope.getData = function () {
    var parameters = {
      page: $scope.groupList.currentPage,
      page_size: $scope.groupList.pageSize,
      query: $scope.query.value,
      sort_fields: 'creation_date:desc'
    };
    return profilinggroupFactory.search(parameters, buildFilter()).$promise.then(function (data) {
      $scope.groupList = data;
      data.list.forEach(function (groupFilter) {
        var originalFilter = angular.copy(groupFilter);
        groupFilter.isDirty = function () {
          return !angular.equals(originalFilter, groupFilter);
        };
      });
      if (data.totalResults == 0) {
        toaster.pop('info', 'Gruppi profilazione', 'Non esistono gruppi di profilazione associati alla commessa');
      }
      return data;
    })["catch"](function (err) {
      toaster.pop('error', '', 'Errore durante il caricamento dei dati');
    });
  };
  $scope.saveAll = function () {
    var toSave = $scope.groupList.list.filter(function (item) {
        return item.isDirty();
      }),
      invalid = toSave.filter($scope.isInvalid);
    if (toSave.length) {
      if (invalid.length) {
        dialogService.dialog('Impossibili salvare i dati', 'Ci sono dei gruppi di profilazione incompleti.<br/> Contollare i dati e riprovare', 'warning', -1);
      } else {
        toSave.forEach($scope.save);
      }
    }
  };
  $scope.save = function (filter) {
    filter.$$saving = true;
    if (filter.id) {
      return profilinggroupFactory.update({
        id: filter.id
      }, filter).$promise.then(function (response) {
        filter.isDirty = function () {
          return !angular.equals(filter, response);
        };
      }, function (err) {
        toaster.pop('error', 'Errore', 'Errore durante il salvataggio dei dati');
      })["finally"](function () {
        delete filter.$saving;
      });
    } else {
      return profilinggroupFactory.save(filter).$promise.then(function (response) {
        var currentValue = angular.copy(angular.merge(filter, JSON.parse(JSON.stringify(response))));
        filter.isDirty = function () {
          return !angular.equals(filter, currentValue);
        };
      }, function (err) {
        toaster.pop('error', 'Errore', 'Errore durante il salvataggio dei dati');
      })["finally"](function () {
        delete filter.$$saving;
      });
    }
  };
  $scope["delete"] = function (id, index) {
    dialogService.confirmDialog("Eliminare la profilazione?", function () {
      if (id) {
        profilinggroupFactory["delete"]({
          id: id
        }).$promise.then(function (response) {
          $scope.groupList.list.splice(index, 1);
        })["catch"](function (err) {
          toaster.pop('error', 'Errore', 'Impossibile eliminare il gruppo di profilazione');
        });
      } else {
        $scope.groupList.list.splice(index, 1);
      }
    });
  };
  $scope.refresh = function () {
    if ($scope.disabledSaveAll()) {
      $scope.getData();
    } else {
      dialogService.confirmDialog('Le modifiche non ancora slavate saranno perse.<br>Vuoi procedere comunque?', $scope.getData);
    }
  };
  $scope.disabledSaveAll = function () {
    return $scope.groupList.list.filter(function (item) {
      return item.isDirty();
    }).length == 0;
  };
  $scope.isInvalid = function (filter) {
    return filter.profiling_groups.length == 0 || filter.records.length == 0;
  };
  $scope.createFilter = function () {
    $scope.groupList.list.splice(0, 0, {
      profiling_groups: [],
      records: [],
      type: 'record',
      exclude: false,
      isDirty: function isDirty() {
        return true;
      }
    });
  };
  $scope.newGroupName = function (name) {
    if (name && name.length) {
      var newGroup = {
        code: name,
        description: titleCase(name)
      };
      if ($scope.groupNames.findIndex(function (g) {
        return g.code == name;
      }) < 0) {
        $scope.groupNames.push(newGroup);
        return newGroup;
      }
    }
    return false;
  };
  function buildFilter() {
    var filter = {};
    if (angular.isDefined($scope.query.exclude)) {
      filter.exclude = sixFiltersLib.match('exclude', $scope.query.exclude);
    }
    if ($scope.query.profilingGroup) {
      filter.profilingGroup = sixFiltersLib.match('profiling_groups', $scope.query.profilingGroup);
    }
    if ($scope.query.profilingGroup) {
      filter.profilingGroup = sixFiltersLib.match('profiling_groups', $scope.query.profilingGroup);
    }
    if ($scope.query.schema) {
      filter.schema = sixFiltersLib.match('schema.UUID', $scope.query.schema.UUID);
    }
    return filter;
  }
  function init() {
    profilinggroupFactory.groups().$promise.then(function (response) {
      if (response.hasErrors) {
        dialogService.serviceResponse('Gruppi di profilazione', response);
      } else {
        $scope.groupNames = response.result;
      }
    })["catch"](function (err) {
      toaster.warning('', 'Impossibile caricare i gruppi');
    });
    $scope.getData();
  }
  init();
}]);
'use strict';

/**
 * @ngdoc function
 * @name emma.theme.controller:ReportCtrl
 * @description
 * # ReportCtrl
 * Controller of the emma.theme
 */
angular.module('emma.theme').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/report', {
    templateUrl: 'theme/report/report_analysis.html',
    controller: 'ReportCtrl',
    controllerAs: 'report'
  });
}]).controller('ReportCtrl', ["$log", "$scope", "$route", "$http", "authFactory", "baseFactory", "budgetFactory", "energyCarrierFactory", "errorService", "dialogService", "SaveAs", "APP_URL", "ENERGY_URL", "$sce", "toaster", function ($log, $scope, $route, $http, authFactory, baseFactory, budgetFactory, energyCarrierFactory, errorService, dialogService, SaveAs, APP_URL, ENERGY_URL, $sce, toaster) {
  $scope.contatoreTypeFilter = {
    'model.code': 'contatoreacqua,contatoreelettricita,contatoregas,contatoregpl,serbatoioinpressione,serbatoiopressioneatmosferica,contatoreteleriscaldamento,contatoreteleraffreddamento'
  };
  $scope.vector = {};
  $scope.type = {};
  $scope.compare = {
    what1: undefined,
    what2: undefined
  };
  $scope.period = {
    dateFrom: new Date(new Date().getFullYear(), 0, 1),
    dateTo: new Date(new Date().getFullYear(), 11, 31)
  };
  $scope.compareType = [{
    code: 'budget',
    description: 'Budget'
  }, {
    code: 'consumptive',
    description: 'Consuntivo'
  }, {
    code: 'season',
    description: 'Stagionale'
  }];
  $scope.budget = {
    searchCode: []
  };
  $scope.ids = {
    searchCode: []
  };
  $scope.commission = {
    searchCode: []
  };
  $scope.availableBudgetCodes = [];
  $scope.availableCommissionCodes = [];
  $scope.availableIdCodes = [];
  function createDateFrom() {
    return $scope.period.dateFrom.getFullYear() + '-' + ('0' + ($scope.period.dateFrom.getMonth() + 1)).slice(-2) + '-' + ('0' + $scope.period.dateFrom.getDate()).slice(-2);
  }
  function createDateTo() {
    return $scope.period.dateTo.getFullYear() + '-' + ('0' + ($scope.period.dateTo.getMonth() + 1)).slice(-2) + '-' + ('0' + $scope.period.dateTo.getDate()).slice(-2);
  }
  function checkDates() {
    if ($scope.period.dateFrom == null || $scope.period.dateTo == null) {
      return false;
    } else {
      if ($scope.period.dateFrom > $scope.period.dateTo) {
        return false;
      }
    }
    return true;
  }
  $scope.getAvailableCommissionCodes = function () {
    var resp = [];
    authFactory.getAuthData().info.commissions.list.forEach(function (item) {
      if (isAlreadySelectedCommission(item.code) === false) {
        resp.push(item);
      }
    });
    return resp;
  };
  function isAlreadySelectedCommission(code) {
    if ($scope.commission.searchCode) {
      for (var i in $scope.commission.searchCode) {
        if ($scope.commission.searchCode[i] && $scope.commission.searchCode[i].code === code) {
          return true;
        }
      }
    }
    return false;
  }
  $scope.getAvailableBudgetCodes = function () {
    if (checkDates()) {
      var query = {
        from: createDateFrom(),
        to: createDateTo()
      };
      if ($scope.commission.searchCode.length != 0) {
        $scope.commission.searchCode.forEach(function (item) {
          if (angular.isUndefined(query.commission)) {
            query.commission = item.code;
          } else {
            query.commission = query.commission + ',' + item.code;
          }
        });
      }
      return budgetFactory.budgetCodesFromCommissions(query).$promise.then(function (response) {
        var resp = [];
        if (response.hasOwnProperty('list') && response.list.length) {
          response.list.forEach(function (item) {
            if (isAlreadySelectedBudget(item.UUID) === false) {
              resp.push(item);
            }
          });
        }
        return resp;
      });
    }
  };
  function isAlreadySelectedBudget(uuid) {
    if ($scope.budget.searchCode) {
      for (var i in $scope.budget.searchCode) {
        if ($scope.budget.searchCode[i] && $scope.budget.searchCode[i].UUID === uuid) {
          return true;
        }
      }
    }
    return false;
  }
  function updateContatoreTypeFilter() {
    if ($scope.vector.id) {
      energyCarrierFactory.schemas({
        id: $scope.vector.id.UUID
      }).$promise.then(function (response) {
        $scope.contatoreTypeFilter = {
          'model.code': response.list.join()
        };
      })["catch"](function (response) {
        // error
        toaster.pop('error', 'Errore', 'Errore durante il recupero dei modelli');
      })["finally"](function (response) {
        // finally
      });
    }
  }
  $scope.getAvailableIdCodes = function () {
    var query = {
      from: createDateFrom(),
      to: createDateTo()
    };
    if (angular.isDefined($scope.type.id)) {
      query.type = $scope.type.id.UUID;
    }
    if ($scope.commission.searchCode.length != 0) {
      $scope.commission.searchCode.forEach(function (item) {
        if (angular.isUndefined(query.commission)) {
          query.commission = item.code;
        } else {
          query.commission = query.commission + ',' + item.code;
        }
      });
    }
    if ($scope.budget.searchCode.length != 0) {
      $scope.budget.searchCode.forEach(function (item) {
        if (angular.isUndefined(query.budget)) {
          query.budget = item.UUID;
        } else {
          query.budget = query.budget + "," + item.UUID;
        }
      });
    }
    return budgetFactory.recordIdsFromBudgets(query).$promise.then(function (response) {
      var resp = [];
      if (response.hasOwnProperty('records') && response.records.length) {
        response.records.forEach(function (item) {
          if (isAlreadySelectedId(item.uuid) === false) {
            resp.push(item);
          }
        });
      }
      return resp;
    });
  };
  function isAlreadySelectedId(uuid) {
    if ($scope.ids.searchCode) {
      for (var i in $scope.ids.searchCode) {
        if ($scope.ids.searchCode[i] && $scope.ids.searchCode[i].uuid === uuid) {
          return true;
        }
      }
    }
    return false;
  }
  $scope.$watchGroup(['commission.searchCode', 'period.dateFrom', 'period.dateTo'], function (newValue, oldValue) {
    if (newValue != oldValue) {
      $scope.getAvailableBudgetCodes().then(function (list) {
        $scope.availableBudgetCodes = list;
      });
    }
  });
  $scope.$watchGroup(['budget.searchCode', 'type.id'], function (newValue, oldValue) {
    if (newValue != oldValue) {
      $scope.getAvailableIdCodes().then(function (list) {
        $scope.availableIdCodes = list;
      });
    }
  });
  $scope.$watch('vector.id', function (newVal) {
    if (newVal) {
      updateContatoreTypeFilter();
    }
  });
  var REPORT_BASE_DIR = "reports/EMMA/";
  var REPORT_API_BASE = "http://172.29.151.99:8080" + ENERGY_URL + "/api/report/";
  //var REPORT_API_BASE = "http://docker0.ict-group.it:7878/six/rest/report/";
  var REPORT_QUERY_BASE = "&net.sf.jasperreports.json.source=" + REPORT_API_BASE;
  $scope.generateReport = function (reportPath, query, reportName) {
    console.log("generation report " + query);
    dialogService.loading('Generazione report in corso');
    $http.post(APP_URL + '/rest/report/generate', {
      path: reportPath,
      query: query
    }, {
      responseType: 'arraybuffer'
    }).success(function (data, status, headers, config) {
      dialogService.stopLoading();
      var options = {
        type: 'application/pdf'
      };
      SaveAs.download(data, reportName + '.pdf', options);
    }).error(function (data, status, headers, config) {
      dialogService.stopLoading();
      toaster.pop('error', "Errore", 'Errore generazione report');
      // called asynchronously if an error occurs
      // or server returns response with an error status.
    });
  };

  $scope.availableCommissionCodes = $scope.getAvailableCommissionCodes();
  $scope.reloadPage = function () {
    $route.reload();
  };
  $scope.clearVariable = function () {
    $scope.contatoreTypeFilter = {
      'model.code': 'contatoreacqua,contatoreelettricita,contatoregas,contatoregpl,serbatoioinpressione,serbatoiopressioneatmosferica,contatoreteleriscaldamento,contatoreteleraffreddamento'
    };
    $scope.budget.searchCode = [];
    $scope.ids.searchCode = [];
    $scope.vector = {};
    $scope.type = {};
    $scope.compare = {
      what1: undefined,
      what2: undefined
    };
  };
  $scope.generateBudgetReport = function (reportFile, energyVector, recordTypes, records, endPoint) {
    if (checkDates()) {
      var from = createDateFrom();
      var to = createDateTo();
      var reportName;
      var what1 = {
        code: null,
        description: null
      };
      var what2 = {
        code: null,
        description: null
      };
      var vector = {
        UUID: null,
        code: null,
        description: null,
        type: null
      };
      var types = {
        UUID: null,
        code: null,
        description: null,
        type: null
      };
      var commissions = 'null';
      var budgets = 'null';
      var budgetsCode = 'null';
      var ids = 'null';
      var idsCode = 'null';
      if ($scope.commission.searchCode.length != 0) {
        $scope.commission.searchCode.forEach(function (item) {
          if (commissions != 'null') {
            commissions = commissions + "," + item.code;
          } else {
            commissions = item.code;
          }
        });
      }
      if ($scope.budget.searchCode.length != 0) {
        $scope.budget.searchCode.forEach(function (item) {
          if (budgets != 'null') {
            budgets = budgets + "," + item.UUID;
            budgetsCode = budgetsCode + "," + item.code;
          } else {
            budgets = item.UUID;
            budgetsCode = item.code;
          }
        });
      }
      if (angular.isDefined($scope.compare.what1)) {
        what1 = $scope.compare.what1;
      }
      if (angular.isDefined($scope.compare.what2)) {
        what2 = $scope.compare.what2;
      }
      if (angular.isDefined(energyVector.id)) {
        vector = energyVector.id;
      }
      if (angular.isDefined(recordTypes.id)) {
        types = recordTypes.id;
      }
      if (records.length != 0) {
        records.forEach(function (item) {
          if (ids != 'null') {
            ids = ids + "," + item.uuid;
            idsCode = idsCode + "," + item.code;
          } else {
            ids = item.uuid;
            idsCode = item.code;
          }
        });
      }
      var query = REPORT_QUERY_BASE;
      var filters = from + "::" + to + "::" + what1.description + "::" + what2.description + "::" + commissions + "::" + budgetsCode + "::" + vector.description + "::" + types.description + "::" + idsCode;
      if (endPoint == 'generic') {
        query = query + endPoint + "/" + from + "/" + to + "/" + what1.code + "/" + what2.code + "/" + commissions + "/" + budgets + "/" + vector.UUID + "/" + types.UUID + "/" + ids + "/" + filters;
        reportName = 'Report_analisi';
      } else if (endPoint == 'cusum') {
        query = query + endPoint + "/" + from + "/" + to + "/" + commissions + "/" + budgets + "/" + vector.UUID + "/" + types.UUID + "/" + ids + "/" + filters;
        reportName = 'Report_cusum';
      }
      $scope.generateReport(REPORT_BASE_DIR + reportFile, query, reportName);
    } else {
      toaster.pop('error', 'Errore', 'Errore nell\'inserimento delle date');
    }
  };
  $scope.generateBudgetReportGraphLines = function () {
    $scope.generateBudgetReport("Analisi_generale_lines.pdf", {}, {}, [], "generic");
  };
  $scope.generateBudgetReportGraphBars = function () {
    $scope.generateBudgetReport("Analisi_generale_bars.pdf", {}, {}, [], "generic");
  };
  $scope.generateBudgetCounterReportGraphLines = function () {
    $scope.generateBudgetReport("Analisi_generale_lines.pdf", $scope.vector, $scope.type, $scope.ids.searchCode, "generic");
  };
  $scope.generateBudgetCounterReportGraphBars = function () {
    $scope.generateBudgetReport("Analisi_generale_bars.pdf", $scope.vector, $scope.type, $scope.ids.searchCode, "generic");
  };
  $scope.generateCusum = function () {
    $scope.generateBudgetReport("Cusum.pdf", $scope.vector, $scope.type, $scope.ids.searchCode, "cusum");
  };

  /***** Data ready events *****/

  var DATA_READY_EVENT = 'dataReady';
  $scope.$on(DATA_READY_EVENT, function (event) {
    setTimeout(function () {
      // evita che venga richiamato troppo velocemente (altrimenti si accavalla a showLoadingMessage)
      dialogService.hideLoadingMessage();
    }, 200);
  });

  // URL per iframe

  //$scope.JASPER_URL = 'http://172.29.2.15:7979/jasperserver';
  //$scope.reportUnit = '/reports/EMMA/Analisi_generale_bars';
  //$scope.parentFolderUri = '/reports/EMMA';
  //$scope.j_username = 'jasperadmin';
  //$scope.j_password = 'jasperadmin';
  //$scope.jasperParams = '_flowId=viewReportFlow&standAlone=true&_flowId=viewReportFlow&theme=embed';
  //$scope.reportUrl = function () {
  //  return $sce.trustAsResourceUrl($scope.JASPER_URL + '/flow.html?' + $scope.jasperParams
  //    + '&j_username=' + $scope.j_username + '&j_password=' + $scope.j_password
  //    + '&ParentFolderUri=' + $scope.parentFolderUri + '&reportUnit=' + $scope.reportUnit);
  //};

  var reportUrlVar = '';
  $scope.reportUrl = function () {
    return $sce.trustAsResourceUrl(reportUrlVar);
  };
  $scope.generateReportUrl = function () {
    dialogService.loading('Generazione report in corso');
    var query = {};
    query.parent_folder_uri = '/reports/EMMA';
    query.report_unit = '/reports/EMMA/Analisi_generale_bars';
    query.query = 'net.sf.jasperreports.json.source=' + REPORT_API_BASE;
    baseFactory('report/generate/url').search(query).$promise.then(function (response) {
      reportUrlVar = response.url;
    })["catch"](function (response) {
      // error
    })["finally"](function (response) {
      // finally
      dialogService.stopLoading();
    });
  };
}]);
'use strict';

/**
 * @ngdoc function
 * @name emma.theme.controller:ReportCtrl
 * @description
 * # ReportCtrl
 * Controller of the emma.theme
 */
angular.module('emma.theme').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/report/daydegree', {
    templateUrl: 'theme/report/report_daydegree.html',
    controller: 'ReportDayDegreeCtrl',
    controllerAs: 'reportdaydegree'
  });
}]).controller('ReportDayDegreeCtrl', ["$log", "$scope", "$http", "authFactory", "baseFactory", "dialogService", "$location", "SaveAs", "APP_URL", function ($log, $scope, $http, authFactory, baseFactory, dialogService, $location, SaveAs, APP_URL) {
  var currentCommission = authFactory.getAuthData().info.commissions.current;
  $scope.report = {};
  $scope.fromYearPicker = {
    year: new Date().getFullYear().toString()
  };
  $scope.zonatermica = {};
  var REPORT_BASE_DIR = "reports/EMMA/";
  var REPORT_API_BASE = $location.protocol() + '://' + location.host + '' + APP_URL + '/rest/report/';
  //var REPORT_API_BASE = "http://docker0.ict-group.it:7878/six/rest/report/";
  var REPORT_QUERY_BASE = "&net.sf.jasperreports.json.source=" + REPORT_API_BASE;
  $scope.generateDayDegreeReport = function () {
    dialogService.loading('Generazione report in corso');
    //var query = REPORT_QUERY_BASE + "chart/analysis/" + currentCommission.code + "/" + $scope.fromYearPicker.year + "/" + $scope.report.budget.UUID;
    var query = REPORT_QUERY_BASE + "daydegree/" + currentCommission.code + "/" + $scope.fromYearPicker.year + "/" + $scope.zonatermica.zonatermica_id.UUID;
    console.log("generating report " + query);
    $http.post(APP_URL + '/rest/report/generate', {
      path: REPORT_BASE_DIR + "Gg_lines.pdf",
      query: query
    }, {
      responseType: 'arraybuffer'
    }).then(function (data, status, headers, config) {
      dialogService.stopLoading();
      var options = {
        type: 'application/pdf'
      };
      SaveAs.download(data, 'daydegree.pdf', options);
    }, function (data, status, headers, config) {
      dialogService.stopLoading();
      toaster.pop('error', "Errore", 'Errore generazione report');
      // called asynchronously if an error occurs
      // or server returns response with an error status.
    });
  };

  /***** Data ready events *****/

  var DATA_READY_EVENT = 'dataReady';
  $scope.$on(DATA_READY_EVENT, function (event) {
    setTimeout(function () {
      // evita che venga richiamato troppo velocemente (altrimenti si accavalla a showLoadingMessage)
      dialogService.hideLoadingMessage();
    }, 200);
  });
}]);
'use strict';

/**
 * @ngdoc service
 * @name emma.theme.authFactory
 * @description
 * # authFactory
 * Factory in the myNewProjectApp.
 */
angular.module('emma').factory('authFactory', ["$rootScope", "localStorageService", "$log", "md5", "$location", "ENV", "CAS", "CAS_LOGOUT", function ($rootScope, localStorageService, $log, md5, $location, ENV, CAS, CAS_LOGOUT) {
  var forceSixLogin = localStorageService.get('force_six_login');
  var authInStore = {};
  if (CAS && !forceSixLogin) {
    authInStore = {};
  } else {
    authInStore = localStorageService.get(ENV + '_authData');
  }
  var authFactory = {
    authData: authInStore || undefined
  };
  authFactory.setAuthData = function (authData) {
    this.authData = {
      authId: authData.authId,
      authToken: authData.authToken,
      authPermission: authData.authPermission,
      menu: authData.menu,
      info: authData.info,
      profile: authData.profile,
      profiles: authData.profiles,
      options: authData.options
    };
    // md5
    try {
      this.authData.md5 = md5.createHash(angular.toJson(authData.info.operations));
    } catch (ex) {
      $log.error(ex);
    }
    if (CAS && !forceSixLogin) {
      authInStore = this.authData;
    }
    computeOptions();
    localStorageService.set(ENV + '_authData', this.authData);
    authFactory.setCurrentCommission(authFactory.getCurrentCommission());
    localStorageService.set(ENV + '_lastCustomer', this.authData.profile.items.find(function (p) {
      return p.type == 'customer';
    }) || {});
    $rootScope.$broadcast('authChanged');
  };
  authFactory.getAuthData = function () {
    return this.authData;
  };
  authFactory.setAuthToken = function (authToken) {
    this.authData.authToken = authToken;
    localStorageService.set(ENV + '_authData', this.authData);
  };
  authFactory.getCurrentCommission = function () {
    return this.authData.info.commissions.current;
  };
  authFactory.setCurrentCommission = function (newCurrent) {
    // set new current commission
    if (this.authData.info.commissions) {
      this.authData.info.commissions.current = newCurrent;
    }
    localStorageService.set(ENV + '_lastCommission', newCurrent);
  };
  authFactory.setMenu = function (newMenu) {
    this.authData.menu = newMenu;
    //faccio persistere il menu modificato
    localStorageService.set(ENV + '_authData', this.authData);
  };
  authFactory.isAuthenticated = function () {
    var data = this.getAuthData();
    if (!angular.isUndefined(data)) {
      return data.hasOwnProperty('authToken');
    }
    return false;
  };
  authFactory.logout = function () {
    this.authData = undefined;
    localStorageService.remove(ENV + '_authData');
    localStorageService.remove(ENV + '_nextPath'); // rimuove il nextPath usato in theme.run.js e postauth.js
    if (CAS) {
      authInStore = {};
      window.location = CAS_LOGOUT;
    } else {
      // window.location.reload();
      window.location = '//' + $location.$$host + ':' + $location.$$port;
    }
    $rootScope.$destroy();
    console.log('*** LOGOUT');
  };
  authFactory.isWritePermAllowed = function (resourceKey, cross) {
    return this.checkPerm(resourceKey, 'NEW', cross);
  };
  authFactory.isDeletePermAllowed = function (resourceKey, cross) {
    return this.checkPerm(resourceKey, 'DELETE', cross);
  };
  authFactory.isUpdatePermAllowed = function (resourceKey, cross) {
    return this.checkPerm(resourceKey, 'UPDATE', cross);
  };
  authFactory.checkPerm = function (resourceKey, opKey, cross) {
    //le commission chiuse sono NON modificabili
    var comm = authFactory.getCurrentCommission();
    if (comm.status && comm.status == "closed" && !cross) {
      var whitelist = ["SEARCH", "SEARCH_ALL", "DETAIL"];
      if (whitelist.indexOf(opKey) === -1) {
        return false;
      }
    }

    //check commission
    var perms = this.getAuthData().info.operations[resourceKey];
    for (var k in perms) {
      var p = perms[k];
      if (p.name === opKey) {
        return p.permitted;
      }
    }
    return false;
  };
  authFactory.getCurrentCustomer = function () {
    if (angular.isDefined(this.authData) && angular.isDefined(this.authData.profile)) {
      return this.authData.profile.items.find(function (p) {
        return p.type == 'customer';
      });
    }
    return null;
  };
  function computeOptions() {
    authFactory.authData.options.admin = authFactory.checkPerm('ADMIN', 'ADMIN_MENU', true);
    authFactory.authData.options.config = authFactory.checkPerm('ADMIN', 'CONFIG_MENU', true);
    authFactory.authData.options.revokeAdmin = authFactory.authData.options.admin || authFactory.authData.options.config;
  }
  return authFactory;
}]);
'use strict';

/**
 * @ngdoc service
 * @name emma.theme.authHttpRequestInterceptor
 * @description
 * # authHttpRequestInterceptor
 * Factory in the emma.theme.
 */
angular.module('emma').service('authHttpRequestInterceptor', ["notificationService", "$log", "$rootScope", "authFactory", "$q", "localStorageService", function (notificationService, $log, $rootScope, authFactory, $q, localStorageService) {
  var service = this;
  service.request = function (config) {
    if (authFactory.isAuthenticated()) {
      config.headers = config.headers || {};
      config.headers['auth-id'] = authFactory.getAuthData().authId;
      config.headers['auth-token'] = authFactory.getAuthData().authToken;
      config.headers['auth-md5'] = authFactory.getAuthData().md5;
      // se è stato salvato un gruppo operatore, lo allego all'header
      if (localStorageService.get('operator-group')) {
        config.headers['auth-op-group'] = localStorageService.get('operator-group').UUID;
      }
    }
    return config;
  };
  service.responseError = function (response) {
    if (response.status === 401 || response.status === 415) {
      $rootScope.$broadcast('unauthorized');
      if (response.headers('www-authenticate').indexOf('invalid_token') != -1) {
        authFactory.logout();
      }
    }
    $log.error(response);
    return $q.reject(response);
  };

  // optional method
  service.response = function (response) {
    if (response.config.pushNotification) {
      $log.debug(response);
      if (response.config.pushNotificationMessage) {
        notificationService.push({
          message: response.config.pushNotificationMessage,
          time: new Date(),
          data: response.data
        });
      } else {
        notificationService.push({
          message: response.config.url + ' -> fine',
          time: new Date(),
          data: response.data
        });
      }
    }
    return response;
  };
}]);
'use strict';

/**
 * @ngdoc service
 * @name emma.theme.baseFactory
 * @description
 * # baseFactory
 * Factory in the emma.theme.
 */
angular.module('emma.theme').factory('baseFactory', ["APP_URL", "$resource", function (APP_URL, $resource) {
  return function (entity) {
    return $resource(APP_URL + '/rest/' + entity + '/:verb/:id', {}, {
      query: {
        method: 'GET',
        isArray: false
      },
      search: {
        method: 'POST',
        isArray: false
      },
      filter: {
        method: 'POST',
        isArray: true
      },
      select: {
        method: 'GET',
        isArray: true
      },
      create: {
        method: 'POST'
      },
      bulk: {
        method: 'POST',
        isArray: true
      },
      show: {
        method: 'GET'
      },
      update: {
        method: 'PUT',
        params: {
          id: '@id'
        }
      },
      "delete": {
        method: 'DELETE',
        params: {
          id: '@id'
        }
      }
    });
  };
}]);
'use strict';

/**
 * @ngdoc service
 * @name emma.theme.authFactory
 * @description
 * # authFactory
 * Factory in the myNewProjectApp.
 */
angular.module('emma').factory('changeUserFactory', ["$rootScope", "localStorageService", "$log", "md5", "$location", "$http", "dialogService", "authFactory", "commissionFactory", "$route", "APP_URL", function ($rootScope, localStorageService, $log, md5, $location, $http, dialogService, authFactory, commissionFactory, $route, APP_URL) {
  var changeUserFactory = {};

  /* *********** */
  /* change user */
  /* *********** */

  changeUserFactory.changeUser = function (user, isOriginUser) {
    isOriginUser = angular.isDefined(isOriginUser) ? isOriginUser : false;
    var config = {
      headers: {
        'ict-auth': authFactory.getAuthData().authToken
      }
    };
    console.info('switch to ' + user);
    var errors = false;
    dialogService.pushLoading('login');
    $http.post(APP_URL + '/rest/auth/loginas/' + user, user, config).then(function (data, status) {
      dialogService.popLoading();
      if (data.status === 200) {
        if (!data.data.info || !data.data.info.commissions || !data.data.info.commissions.current) {
          dialogService.popLoading();
          dialogService.alert('Non sono state configurate commesse per l\'utente selezionato', 4000);
          return;
        }
        var commissionCode = data.data.info.commissions.current.code;
        commissionFactory().getCommissionByCode({
          code: commissionCode
        }).$promise.then(function (response) {
          data.data.info.commissions.current = response;
          if (!isOriginUser && (!authFactory.getAuthData().options || !authFactory.getAuthData().options.originUser)) {
            data.data.options = data.data.options || {};
            data.data.options.originUser = angular.copy(authFactory.getAuthData().authId);
          } else if (isOriginUser) {
            data.data.options = data.data.options || {};
            delete data.data.options.originUser;
          }
          authFactory.setAuthData(data.data);
          $route.reload();
        });
      } // Redirect etc.
      else {
        errors = true;
        dialogService.alert('Errore di accesso', 4000);
      }
    }, function () {
      // Error handling
      errors = true;
      dialogService.popLoading();
      dialogService.alert('Errore di accesso', 4000);
    });
  };
  return changeUserFactory;
}]);
'use strict';

/**
 * @ngdoc service
 * @name emma.theme.baseFactory
 * @description
 * # baseFactory
 * Factory in the emma.theme.
 */
angular.module('emma.theme').factory('dbBaseFactory', ["APP_URL", "$resource", function (APP_URL, $resource) {
  return function (entity) {
    return $resource(APP_URL + '/rest/' + entity + '/search/:id', {}, {
      //FIXME: togliere search
      //query: {method: 'GET', isArray: false},
      search: {
        method: 'POST',
        isArray: false
      }
      /*select: {method: 'GET', isArray: true}
      create: {method: 'POST'},
      bulk: {method: 'POST', isArray: true},
      show: {method: 'GET'},
      update: {method: 'PUT', params: {id: '@id'}},
      delete: {method: 'DELETE', params: {id: '@id'}}*/
    });
  };
}]);
'use strict';

/**
 * @ngdoc service
 * @name emma.theme.dialogService
 * @description
 * # dialogService
 * Service in the emma.theme.
 */
angular.module('emma.theme').service('dialogService', ["ngDialog", "$rootScope", "$filter", "$log", function (ngDialog, $rootScope, $filter, $log) {
  //http://ngmodules.org/modules/ngDialog
  //v. http://likeastore.github.io/ngDialog/#

  /* ************************ */
  /* **** LOADING DIALOG **** */
  /* ************************ */

  this.loadingDialog;
  this.loadingMessageShowedNr = 0;
  this.loading = function (message) {
    if (!this.loadingDialog || !this.loadingDialog.id) {
      this.loadingDialog = ngDialog.open({
        name: 'loadingDialog',
        closeByDocument: false,
        showClose: false,
        template: '<div class="progress">' + '<div class="progress-bar progress-bar-striped active" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%">' + '<span class="sr-only">100% Complete</span>' + '</div>' + '</div><div style="text-align:center"><i class="fa fa-refresh fa-spin" style="font-size:large"></i>&nbsp; ' + message + '</div>',
        plain: 'true',
        /*controller: 'FirstDialogCtrl',*/ //<-- si potrebbe usare un ctrl per fare cose più fiche... tipo progressbar che va avanti
        className: 'ngdialog-theme-default ngdialog-theme-custom'
      });
      return this.loadingDialog.id;
    } else {
      console.warn('Loading dialog already opened: ' + this.loadingDialog.id);
      return undefined;
    }
  };
  this.stopLoading = function () {
    if (this.loadingDialog && this.loadingDialog.id) {
      ngDialog.close(this.loadingDialog.id);
      this.loadingDialog = undefined;
    }
  };
  this.showLoadingMessage = function (message) {
    if (this.loadingMessageShowedNr <= 0) {
      this.loading(message);
    }
    this.loadingMessageShowedNr++;
  };
  this.hideLoadingMessage = function (forceHideAll) {
    this.loadingMessageShowedNr--;
    if (forceHideAll === true || this.loadingMessageShowedNr <= 0) {
      this.stopLoading();
      this.loadingMessageShowedNr = 0;
    }
  };

  // Loading dialogs with stack

  this.loadingMessagesStack = [];
  this.pushLoading = function (message) {
    var thisLoadingDialog = ngDialog.open({
      name: 'loadingDialog',
      closeByDocument: false,
      showClose: false,
      template: '<div class="progress">' + '<div class="progress-bar progress-bar-striped active" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%">' + '<span class="sr-only">100% Complete</span>' + '</div>' + '</div>' + '<div style="text-align:center"><i class="fa fa-refresh fa-spin" style="font-size:large"></i>&nbsp; ' + message + '</div>',
      plain: 'true',
      /*controller: 'FirstDialogCtrl',*/ //<-- si potrebbe usare un ctrl per fare cose più fiche... tipo progressbar che va avanti
      className: 'ngdialog-theme-default ngdialog-theme-custom'
    });
    this.loadingMessagesStack.push(thisLoadingDialog);
    return thisLoadingDialog.id;
  };
  this.popLoading = function () {
    if (this.loadingMessagesStack.length > 0) {
      var id = this.loadingMessagesStack[this.loadingMessagesStack.length - 1].id;
      ngDialog.close(id);
      return id;
    }
  };
  this.emptyLoadingStack = function () {
    if (this.loadingMessagesStack.length > 0) {
      this.loadingMessagesStack.forEach(function (loadingId) {
        this.popLoading();
      });
    }
  };
  this.cycleLoading = function (message) {
    this.popLoading();
    this.pushLoading(message);
  };

  /* ************************ */
  /* **** GENERIC ALERT  **** */
  /* ************************ */

  this.alert = function (message, duration) {
    var alertDialog = ngDialog.open({
      name: 'loadingDialog',
      closeByDocument: true,
      showClose: true,
      template: '' + '<div style="text-align:center"><i class="fa fa-warning" style="font-size:large"></i>&nbsp; ' + message + '</div>',
      plain: 'true',
      /*controller: 'FirstDialogCtrl',*/ //<-- si potrebbe usare un ctrl per fare cose più fiche... tipo progressbar che va avanti
      className: 'ngdialog-theme-default ngdialog-theme-custom'
    });
    function setTimeOutWithClosure(id, duration) {
      var id = id;
      setTimeout(function () {
        ngDialog.close(id);
      }, duration);
    }
    setTimeOutWithClosure(alertDialog.id, duration);
  };

  /* ************************ */
  /* **** GENERIC DIALOG **** */
  /* ************************ */

  /*
   * type:
   *   success
   *   info
   *   warning
   *   danger
   * bodyTextAlign:
   *   left
   *   center
   *   right
   */

  this.DIALOG_TYPE = {
    SUCCESS: 'success',
    INFO: 'info',
    WARNING: 'warning',
    DANGER: 'danger'
  };
  this.BODY_ALIGNMENT = {
    LEFT: 'left',
    CENTER: 'center',
    RIGHT: 'right'
  };
  this.genericDialog;
  this.dialog = function (title, content, type, duration, discreet, bodyTextAlign) {
    var icon;
    type = type || 'info';
    duration = duration || 5000;
    discreet = discreet || false;
    bodyTextAlign = bodyTextAlign || 'center';
    this.genericDialog = ngDialog.open({
      name: 'dialog',
      closeByDocument: true,
      showClose: true,
      template: '' + '<strong><span class="ngdialog-icon"></span></strong>' + '<div style="text-align: center;">' + '<div><strong>' + title + '</strong></div>' + '<div style="margin: 10px 5px 5px 5px; text-align: ' + bodyTextAlign + ';">' + content + '</div>' + '</div>',
      plain: true,
      /*overlay: !discreet,*/ // Non lo uso altrimenti non mette l'overlay che consente di chiudere la dialog premendo su qualsiasi punto del background => lo faccio fuori con la trasparenza nel css
      /*controller: 'FirstDialogCtrl',*/ //<-- si potrebbe usare un ctrl per fare cose più fiche... tipo progressbar che va avanti
      className: 'ngdialog-theme-default' + (type ? ' ngdialog-theme-' + type : '') + (discreet ? ' discreet' : '')
    });
    function setTimeOutWithClosure(id, duration) {
      var idToClose = id;
      setTimeout(function () {
        if (ngDialog.isOpen(idToClose)) {
          // nel caso fosse stata chiusa manualmente, ngDialog.close(id, value) mi chiuderebbe tutte le altre dialog aperte
          ngDialog.close(idToClose, 'close!');
        }
      }, duration);
    }
    setTimeOutWithClosure(this.genericDialog.id, duration);
    return this.genericDialog;
  };
  this.closeDialog = function () {
    ngDialog.close(this.genericDialog, 'close!');
  };

  /* ************************************** */
  /* **** DIALOG WITH CUSTOM TEMPLATE  **** */
  /* ************************************** */

  this.templDialog;

  /**
   *
   * @param template template da mostrare nella dialog
   * @param type info (default), success, warning, danger
   * @param scope oggetto contenente le variabili utilizzate all'interno del template
   * @param opts ulteriori opzioni da passare alla ngDialog.open()
   * @param duration durata della dialog (defualt: -1 ms => illimitata)
   * @param discreet indica se mostrare un popup al centro della pagina (false, default) o una barra in alto (true)
   */
  this.templateDialog = function (template, type, scope, opts, duration, discreet, width) {
    type = type || 'info';
    duration = duration || -1;
    discreet = discreet || false;
    var dialogScope = $rootScope.$new();
    angular.extend(dialogScope, scope);
    var options = opts || {};
    options.template = template;
    options.scope = dialogScope;
    if (angular.isUndefined(options.name)) {
      options.name = 'templateDialog';
    }
    if (angular.isUndefined(options.closeByDocument)) {
      options.closeByDocument = true;
    }
    if (angular.isUndefined(options.showClose)) {
      options.showClose = true;
    }
    if (angular.isUndefined(options.plain)) {
      options.plain = true; // N.B. se true si aspetta direttamente una stringa contenente il template, se false si aspetta un html esterno o un template definito in <script type="text/ng-template">
    }

    if (angular.isUndefined(options.className)) {
      options.className = 'ngdialog-theme-default' + (type ? ' ngdialog-theme-' + type : '');
    }
    if (discreet) {
      options.className += ' discreet';
    }
    if (width) {
      options.width = width;
    }
    this.templDialog = ngDialog.open(options);
    function setTimeOutWithClosure(id, duration) {
      var idToClose = id;
      setTimeout(function () {
        if (ngDialog.isOpen(idToClose)) {
          // nel caso fosse stata chiusa manualmente, ngDialog.close(id, value) mi chiuderebbe tutte le altre dialog aperte
          ngDialog.close(idToClose, 'close!');
        }
      }, duration);
    }
    setTimeOutWithClosure(this.templDialog.id, duration);
    return this.templDialog;
  };

  /* ************************ */
  /* **** CONFIRM DIALOG **** */
  /* ************************ */

  this.confirmDialog = function (message, functionY, functionN) {
    var alertDialog = ngDialog.openConfirm({
      name: 'alertDialog',
      closeByDocument: false,
      showClose: true,
      template: '' + '<div style="text-align:center"><i class="fa fa-exclamation-triangle"></i>&nbsp; ' + message + '</div><br>' + '<div style="text-align:center">' + '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ng-click="confirm()">Si</button>' + '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ng-click="closeThisDialog()">No</button>' + '</div>' + '' + '',
      plain: true,
      className: 'ngdialog-theme-default ngdialog-theme-custom'
    });
    alertDialog.then(function (resp) {
      console.log(resp);
      if (angular.isFunction(functionY)) {
        functionY();
      }
    }, function (resp) {
      console.log(resp);
      if (angular.isFunction(functionN)) {
        functionN();
      }
    });
  };

  /* ********************************************************* */
  /* **** DIALOG RESPONSE FROM BACKEND (ServiceResponse)  **** */
  /* ********************************************************* */

  /**
   * Mostra una tabella contenente i log dal backend (LogServiceMessage)
   */
  this.serviceResponse = function (title, resp, hideSuccesses, width) {
    hideSuccesses = hideSuccesses || false;
    width = width || '60%';
    var dialogScope = $rootScope.$new();
    dialogScope.hideSuccesses = hideSuccesses;
    dialogScope.resp = resp;
    dialogScope.exportFn = this.exportXLSX;
    dialogScope.totals = {};
    resp.messages = resp.messages || [];
    if (hideSuccesses) {
      resp.messages = $filter('filter')(resp.messages, {
        success: false
      });
    }
    dialogScope.totals.tot = resp.messages.length;
    dialogScope.totals.errors = $filter('filter')(resp.messages, {
      error: true
    }).length;
    dialogScope.totals.warnings = $filter('filter')(resp.messages, {
      warning: true
    }).length;
    dialogScope.totals.successes = $filter('filter')(resp.messages, {
      success: true
    }).length;
    dialogScope.columns = [{
      key: 'instant',
      name: 'Data',
      transform: function transform(v) {
        return v && v.epochSecond ? new Date(v.epochSecond * 1000) : new Date(v);
      }
    }, {
      key: 'code',
      name: 'Codice'
    }, {
      key: 'status',
      name: 'Stato'
    }, {
      key: 'message',
      name: 'Messaggio'
    }];
    dialogScope.search = {}; // search filters
    dialogScope.sort = []; // sort
    dialogScope.sortBy = function (propertyName) {
      var idx = dialogScope.sort.indexOf(propertyName);
      if (~idx) {
        dialogScope.sort[idx] = '-' + propertyName;
      } else {
        idx = dialogScope.sort.indexOf('-' + propertyName);
        if (~idx) {
          dialogScope.sort.splice(idx, 1);
        } else {
          dialogScope.sort.push(propertyName);
        }
      }
    };
    dialogScope.isSorted = function (propertyName) {
      var idx = dialogScope.sort.indexOf(propertyName);
      if (~idx) {
        return 1;
      } else {
        idx = dialogScope.sort.indexOf('-' + propertyName);
        if (~idx) {
          return -1;
        }
      }
      return 0;
    };
    this.messagesDialog = ngDialog.open({
      name: 'serviceResponseDialog',
      closeByDocument: false,
      showClose: true,
      template: '' + '<script type="text/ng-template" id="messages-table.html">' + '<table class="tinyTable">' + '<tr>' + '<th style="min-width: 15%">' + '<a ng-click="sortBy(\'status\')">Stato</a> <i class="fa" ng-class="{\'fa-caret-up\': isSorted(\'status\')==1, \'fa-caret-down\': isSorted(\'status\')==-1}"></i>' + '<input type="text" ng-model="search.status" class="form-control input-sm" placeholder="Stato ..." /> ' + '</th>' + '<th style="min-width: 15%">' + '<a ng-click="sortBy(\'code\')">Codice</a> <i class="fa" ng-class="{\'fa-caret-up\': isSorted(\'code\')==1, \'fa-caret-down\': isSorted(\'code\')==-1}"></i>' + '<input type="text" ng-model="search.code" class="form-control input-sm" placeholder="Codice ..." /> ' + '</th>' + '<th style="min-width: 70%">' + '<a ng-click="sortBy(\'message\')">Messaggio</a> <i class="fa" ng-class="{\'fa-caret-up\': isSorted(\'message\')==1, \'fa-caret-down\': isSorted(\'message\')==-1}"></i>' + '<input type="text" ng-model="search.message" class="form-control input-sm" placeholder="Messaggio ..." /> ' + '</th>' + '</tr>' + '<tr ng-repeat="r in filtered=(resp.messages | filter: {error: config.errors, warning: config.warnings, success: config.successes, status: search.status, code: search.code, message: search.message}) | orderBy: sort track by $index" ng-if="resp.messages && resp.messages.length>0">' + '<td ng-class="{\'text-success\': r.success, \'text-warning-dker\': r.warning, \'text-danger-dker\': r.error}">{{r.status}}</td>' + '<td>{{r.code}}</td>' + '<td>{{r.message}}</td>' + '</tr>' + '<tr ng-if="!filtered || filtered.length==0">' + '<td colspan="3">' + '<span ng-if="config.all">Nessun messaggio</span>' + '<span ng-if="config.errors">Nessun errore</span>' + '<span ng-if="config.warnings">Nessun warning</span>' + '<span ng-if="config.successes">Nessun successo</span>' + '</td>' + '</tr>' + '</table>' + '</script>' + '<div style="font-size: small"><strong>' + title + '</strong></div>' + '<div style="float: right; margin-top: 10px; margin-right: 15px"><a class="btn btn-xs btn-default" ng-click="exportFn(columns, resp.messages)"><span class="fa fa-download"></span> Esporta xlsx</a></div>' + '<uib-tabset>' + '<uib-tab ng-click="config={all:true}">' + '<uib-tab-heading>' + '<span class="fa fa-bars text-info-dker"></span> Tutti ({{totals.tot}})' + '</uib-tab-heading>' + '<div ng-include="\'messages-table.html\'"></div>' + '</uib-tab>' + '<uib-tab ng-click="config={errors:true}">' + '<uib-tab-heading>' + '<span class="fa fa-exclamation-circle text-danger-dker"></span> Errori ({{totals.errors}})' + '</uib-tab-heading>' + '<div ng-include="\'messages-table.html\'"></div>' + '</uib-tab>' + '<uib-tab ng-click="config={warnings:true}">' + '<uib-tab-heading>' + '<span class="fa fa-exclamation-triangle text-warning-dker"></span> Warnings ({{totals.warnings}})' + '</uib-tab-heading>' + '<div ng-include="\'messages-table.html\'"></div>' + '</uib-tab>' + '<uib-tab ng-click="config={successes:true}" ng-if="!hideSuccesses">' + '<uib-tab-heading>' + '<span class="fa fa-check-circle-o text-success-dker"></span> Successi ({{totals.successes}})' + '</uib-tab-heading>' + '<div ng-include="\'messages-table.html\'"></div>' + '</uib-tab>' + '</uib-tabset>',
      plain: true,
      className: 'ngdialog-theme-default',
      width: width,
      scope: dialogScope
    });
    return this.messagesDialog.id;
  };

  /* ******************** */
  /* **** EXPORT XLS **** */
  /* ******************** */

  this.exportXLSX = function (columns, rows) {
    var sheet = {};
    var i = 0;
    columns.forEach(function (col) {
      var loc = XLSX.utils.encode_cell({
        r: 0,
        c: i
      });
      sheet[loc] = {
        v: col.name
      };
      i += 1;
    });
    var endLoc;
    rows.forEach(function (row, ri) {
      ri += 1;
      columns.forEach(function (col, ci) {
        var loc = XLSX.utils.encode_cell({
          r: ri,
          c: ci
        });
        if (angular.isDefined(row[col.key])) {
          var value = row[col.key];
          if (angular.isFunction(col.transform)) {
            value = col.transform(value);
          }
          sheet[loc] = {
            v: value,
            t: 's'
          };
        }
        endLoc = loc;
      });
    });
    sheet['!ref'] = XLSX.utils.encode_range({
      s: 'A1',
      e: endLoc
    });
    var workbook = {
      SheetNames: ['Sheet1'],
      Sheets: {
        Sheet1: sheet
      }
    };
    var wopts = {
      bookType: 'xlsx',
      bookSST: false,
      type: 'binary'
    };
    var wbout = XLSX.write(workbook, wopts);
    saveAs(new Blob([s2ab(wbout)], {
      type: ""
    }), "messages.xlsx");
  };
  function s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
  }

  /* *************** */
  /* **** OTHER **** */
  /* *************** */

  // FIXME verificare se è possibile spostarlo su issue e odl per evitare di "sporcare" la dialogService con funzioni specifiche

  this.fillTextField = function (message, functionY, functionN) {
    var alertDialog = ngDialog.openConfirm({
      name: 'alertDialog',
      closeByDocument: false,
      showClose: true,
      template: '' + '<div style="text-align:center"><i class="fa fa-exclamation-triangle"></i>&nbsp; ' + message + '</div><br>' + '<div style="text-align:center"><textarea id="status_note" rows="4" class="col-md-12" ng-model="note"></textarea></div>' + '<div style="text-align:center">' + '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ng-click="confirm()">Salva</button>' +
      // '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ng-click="closeThisDialog()">No</button>' +
      '</div>' + '' + '',
      plain: true,
      className: 'ngdialog-theme-default ngdialog-theme-custom'
    });
    alertDialog.then(function (resp) {
      console.log(resp);
      var note = "";
      if (document.getElementById("status_note").value) {
        note = document.getElementById("status_note").value;
      }
      if (angular.isFunction(functionY)) {
        functionY(note);
      }
    }, function (resp) {
      console.log(resp);
      if (angular.isFunction(functionN)) {
        functionN(note);
      }
    });
  };
}]);
'use strict';

/**
 * @ngdoc service
 * @name emma.theme.errorService
 * @description
 * Service in the emma.theme.
 */
angular.module('emma.theme').service('errorService', ["dialogService", "toaster", function (dialogService, toaster) {
  this.handleError = function (backendResponse, showErrorPopup) {
    if (backendResponse.hasOwnProperty('status') && backendResponse.status >= 500) {
      if (backendResponse.hasOwnProperty('message')) {
        showErrorPopup === true && toaster.pop('error', "Errore", backendResponse.message);
        return false;
      }
      if (backendResponse.hasOwnProperty('developerMessage') && showErrorPopup === true) {
        showErrorPopup === true && toaster.pop('error', "Errore", backendResponse.developerMessage);
        return false;
      }
    }
    return true;
  };
}]);
"use strict";

/* angular-file-saver
*
* A AngularJS service that implements the HTML5 W3C saveAs() in browsers that
* do not natively support it
*
* (c) 2015 Philipp Alferov
* License: MIT
*
*/

(function () {
  'use strict';

  angular.module('fileSaver', []).factory('SaveAs', SaveAs);
  function SaveAs() {
    function isBlobInstance(data) {
      return data instanceof Blob;
    }
    function save(blob, filename) {
      try {
        saveAs(blob, filename);
      } catch (err) {
        console.error(err.message);
      }
    }
    return {
      /**
      * saveFile - Immediately starts saving a file, returns undefined.
      *
      * @param  {array|Blob} data Represented as an array or a Blob object
      * @param  {string} filename
      * @param  {object} options Set of Blob constructor options.
      * Optional parameter, if Blob object is passed as first argument
      * @return {undefined}
      */

      download: function download(data, filename, options) {
        var blob;
        data = data instanceof Array ? data : [data];
        if (isBlobInstance(data)) {
          save(data, filename);
        }
        blob = new Blob(data, options);
        save(blob, filename);
      }
    };
  }
})();
'use strict';

/**
 * @ngdoc service
 * @name emma.theme.loadingBarService
 * @description
 * # loadingBarService
 * Service in the emma.theme.
 */
angular.module('emma.theme').service('loadingBarService', ["cfpLoadingBar", "dialogService", "$log", function (cfpLoadingBar, dialogService, $log) {
  this.start = function (message) {
    cfpLoadingBar.start();
    if (angular.isDefined(message)) {
      angular.element(document.getElementById('loading-bar-spinner')).addClass('custom-loading-bar-spinner');
      document.getElementById('loading-bar-spinner').innerHTML = '<div class="spinner-icon"></div> ' + message;
    } else {
      angular.element(document.getElementById('loading-bar-spinner')).removeClass('custom-loading-bar-spinner');
      document.getElementById('loading-bar-spinner').innerHTML = '<div class="spinner-icon"></div>';
    }
  };
  this.stop = function (response, title, hideSuccesses) {
    title = title || 'Esito';
    hideSuccesses = hideSuccesses || false;
    angular.element(document.getElementById('loading-bar-spinner')).removeClass('custom-loading-bar-spinner');
    document.getElementById('loading-bar-spinner').innerHTML = '<div class="spinner-icon"></div>';
    cfpLoadingBar.complete();
    if (isServiceResponseObject(response)) {
      $log.debug('response is a ServiceResponse', response);
      dialogService.serviceResponse(title, response, hideSuccesses);
    } else {
      $log.debug('response is not a ServiceResponse', response);
    }
  };
  function isServiceResponseObject(response) {
    return angular.isDefined(response) && response !== null && angular.isObject(response) && response.hasOwnProperty('status') && response.hasOwnProperty('result') && response.hasOwnProperty('messages') && response.hasOwnProperty('hasErrors') && response.hasOwnProperty('hasWarnings');
  }
}]);
'use strict';

/**
 * @ngdoc service
 * @name emma.theme.loginFactory
 * @description
 * # loginFactory
 * Factory in the emma.theme.
 */
angular.module('emma.theme').factory('loginFactory', ["APP_URL", "$resource", function (APP_URL, $resource) {
  //cambiare la switch commission, fare una loginfactory.
  //    usare in sixframeworkcontroller e in login.js (controller)
  //loginfactory per fare la login e la switch
  //poi i due controller usano i dati di login

  return $resource(APP_URL + '/rest/auth/:param/:selected', {}, {
    "switch": {
      method: 'POST',
      params: {
        param: 'switch'
      },
      isArray: false
    },
    changePassword: {
      method: 'POST',
      url: APP_URL + '/rest/auth/change/password',
      isArray: false
    }
  });
}]);
'use strict';

/**
 * @ngdoc service
 * @name emma.theme.lookupFactory
 * @description
 * # lookupFactory
 * Factory supergenerica per essere richiamata dalle lookup. Può puntare ai vari war.
 */
angular.module('emma.theme').factory('lookupFactory', ["$resource", function ($resource) {
  return function (url, entity) {
    return $resource(url + entity + '/:verb/:id', {}, {
      query: {
        method: 'GET',
        isArray: false
      },
      search: {
        method: 'POST',
        isArray: false
      }
    });
  };
}]);
'use strict';

angular.module('emma.theme').service('menuProfiling', ["authFactory", "treeUtilities", function (authFactory, treeUtilities) {
  this.updateMenu = function (sourceMenu) {
    if (!sourceMenu) {
      var authData = authFactory.getAuthData();
      if (authData && authData.menu) sourceMenu = authData.menu;
    }
    treeUtilities.getFlatStructureUuids().then(function (types) {
      if (types) {
        sourceMenu.forEach(function (item, pos) {
          if (item.description == "ANAGRAFICA") {
            //FIXME: orribile.
            var decimatedAnagraphic = decimateMenu(item.children, types);
            sourceMenu[pos].children = decimatedAnagraphic;
            authFactory.setMenu(sourceMenu);
          }
        });
      }
    });
    return sourceMenu;
  };
  //FIXME: rimuovere anche le voci non visibili per via della profilazione
  function decimateMenu(menu, blacklist) {
    var baseCode = "record\/(snap|stable)\/";
    var toDelete = [];
    menu.forEach(function (el, i) {
      if (el.code && el.code.match(baseCode)) {
        var markForDelete = true;
        blacklist.forEach(function (code) {
          if (el.code.match(baseCode + code)) {
            markForDelete = false;
          }
        });
        if (markForDelete) {
          toDelete.push(i);
        }
      }
      if (el.children) {
        menu[i].children = decimateMenu(el.children, blacklist);
      }
    });
    for (var i = toDelete.length - 1; i >= 0; i--) {
      menu.splice(toDelete[i], 1);
    }
    return menu;
  }
}]);
'use strict';

/**
 * @ngdoc service
 * @name emma.theme.modelIconService
 * @description
 * # modelIconService
 * Service in the emma.theme.
 */
angular.module('emma.theme').service('modelIconService', ["localStorageService", "authFactory", function (localStorageService, authFactory) {
  // AngularJS will instantiate a singleton by calling "new" on this function

  // var iconsMap = localStorageService.get('iconsMap');
  var iconsMap = undefined;

  // Carica le icone in base a quelle da menu
  this.loadModelIcons = function (parent) {
    for (var index in parent.children) {
      var child = parent.children[index];
      if (child.code && child.icon) {
        var splitted = child.code.split("/");
        if (splitted && splitted[splitted.length - 1]) {
          iconsMap[splitted[splitted.length - 1]] = child.icon;
        }
      }
      this.loadModelIcons(child);
    }
    return iconsMap;
  };
  this.getModelIcon = function (modelName) {
    return iconsMap[modelName];
  };
  if (!iconsMap) {
    iconsMap = {};
    this.loadModelIcons({
      children: authFactory.getAuthData().menu
    });
    // localStorageService.set('iconsMap', iconsMap);
  }
}]);
'use strict';

/**
 * @ngdoc service
 * @name emma.theme.notificationService
 * @description
 * # notificationService
 * Service in the emma.theme.
 */
angular.module('emma.theme').service('notificationService', ["$rootScope", function ($rootScope) {
  this.push = function (notif) {
    $rootScope.$broadcast('notification:push', notif);
  };
  this.clear = function () {
    $rootScope.$broadcast('notification:clear');
  };
}]);
'use strict';

/**
 * @ngdoc factory
 * @name emma.theme.operatorGroupService
 * @description
 * # operatorGroupService
 * Helper per settare il gruppo dell'operatore
 */
angular.module('emma.theme').service('operatorGroupService', ["localStorageService", "recordFactory", "authFactory", "$log", "$q", function (localStorageService, recordFactory, authFactory, $log, $q) {
  var self = this;
  var operatore = undefined;
  var group = undefined;
  self.setGroupInLocalStorage = function (input) {
    //cerca il primo gruppo valido per l'operatore o username indicato e imposta il localstorage

    var opPromise;
    var input = typeof input !== 'undefined' ? input : {};
    //priorità: input.operatore > input.username > self.operatore > auth.username
    if (angular.isDefined(input.operatore)) {
      opPromise = $q(function (resolve, reject) {
        self.operatore = input.operatore;
        resolve(input.operatore);
      });
    } else if (angular.isDefined(input.username)) {
      opPromise = self.setOperatoreFromUsername(input.username);
    } else if (angular.isDefined(self.operatore)) {
      opPromise = $q(function (resolve, reject) {
        resolve(self.operatore);
      });
    } else {
      opPromise = self.setOperatoreFromUsername(authFactory.getAuthData().authId);
    }

    //una volta ottenuto l'operatore, recupero il gruppo
    //NOTA: il gruppo è determinato anche dal filtro implicito sulla commessa, quindi è importante aggiornarlo solo a cambio commessa avvenuto
    return opPromise.then(function () {
      var payload = {
        page: 1,
        page_size: 1,
        show_revision: false,
        sort_fields: "creationDate:desc"
      };
      var filters = {
        'operatore': sixFiltersLib.exact('model.operatori.UUID', self.operatore.UUID)
      };
      return recordFactory('gruppo').search(payload, filters).$promise.then(function (resp) {
        if (resp.totalResults != 0) {
          $log.info('Gruppo operatore --> ', resp.list[0].UUID);
          localStorageService.set('operator-group', resp.list[0]);
          self.group = resp.list[0];
        } else {
          localStorageService.remove('operator-group');
          self.group = undefined;
        }
        return self.group;
      });
    });
  };
  self.setOperatoreFromUsername = function (username) {
    var filters = {
      'model.username': sixFiltersLib.exact('model.username', username)
    };
    return recordFactory('operatore').search(filters).$promise.then(function (resp) {
      if (resp.list && resp.list.length != 0) {
        self.operatore = resp.list[0];
        return resp.list[0];
      } else {
        $log.error("Operatore non trovato");
        return $q.reject("Operatore non trovato");
      }
    });
  };
}]);
'use strict';

/**
 * @ngdoc factory
 * @name emma.theme.pipeConfigurationTree
 * @description
 * # pipeConfigurationTree
 * Service in the emma.theme.
 */
angular.module('emma.theme').service('pipeConfigurationTree', function () {
  var pipeConfigurationTree = {
    treeIdToConfig: {
      list: []
    },
    treeObjToConfig: {
      list: []
    }
  };
  pipeConfigurationTree.pushTreeIdToConfig = function (uuid, when) {
    this.treeIdToConfig.list.push({
      uuid: uuid,
      date: when
    });
  };
  pipeConfigurationTree.pushTreeVersionToConfig = function (uuid, version) {
    this.treeIdToConfig.list.push({
      uuid: uuid,
      version: version
    });
  };
  pipeConfigurationTree.popTreeIdToConfig = function () {
    return this.treeIdToConfig.list.pop();
  };
  pipeConfigurationTree.pushTreeObjToConfig = function (obj) {
    this.treeObjToConfig.list.push(obj);
  };
  pipeConfigurationTree.popTreeObjToConfig = function () {
    return this.treeObjToConfig.list.pop();
  };
  return pipeConfigurationTree;
});
"use strict";

/**
 * Created by luca on 25/04/17.
 */

/**
 * @ngdoc factory
 * @name emma.theme.pipeConsumptive
 * @description
 * # pipeConsumptive
 * Service in the emma.theme.
 */
angular.module('emma.theme').service('pipeConsumptive', function () {
  var pipeConsumptive = {
    list: []
  };
  pipeConsumptive.pushConsumptiveRows = function (consumptive) {
    this.list.push(consumptive);
  };
  pipeConsumptive.popConsumptiveRows = function () {
    return this.list.pop();
  };
  return pipeConsumptive;
});
"use strict";

/**
 * Created by luca on 25/04/17.
 */

/**
 * @ngdoc factory
 * @name emma.theme.pipeEstimatePromote
 * @description
 * # pipeEstimatePromote
 * Service in the emma.theme.
 */
angular.module('emma.theme').service('pipeEstimatePromote', function () {
  var pipeEstimatePromote = {
    list: []
  };
  pipeEstimatePromote.pushEstimateRows = function (estimate) {
    this.list.push(estimate);
  };
  pipeEstimatePromote.popEstimateRows = function () {
    return this.list.pop();
  };
  return pipeEstimatePromote;
});
'use strict';

/**
 * @ngdoc service
 * @name emma.theme.sessionFactory
 * @description
 * # sessionFactory
 * Factory in the emma.theme.
 */
angular.module('emma.theme').factory('sessionFactory', ["$rootScope", "$log", function ($rootScope, $log) {
  var sessionFactory = {
    sessionData: {}
  };
  sessionFactory.setSessionData = function (sessionData) {
    this.sessionData = {
      currentDate: sessionData.currentDate
    };
    $log.info(sessionData.currentDate);
    $rootScope.$broadcast('sessionChanged');
  };
  sessionFactory.getSessionData = function () {
    return this.sessionData;
  };
  return sessionFactory;
}]);
'use strict';

/**
 * @ngdoc service
 * @name emma.theme.slaService
 * @description
 * # slaService
 * permette la gestione SLA
 */
angular.module('emma.theme').service('slaService', ["$q", "commissionFactory", "recordFactory", function ($q, commissionFactory, recordFactory) {
  /**
   * METHODS
   */
  this.getSLA = function (commissionCode, repartoUUID, issueOpenTime, issueCloseTime) {
    //issueOpenTime e issueCloseTime DEVONO essere due moment() obj
    var promise = $q.defer();
    var result = {};
    //var pending;
    if (!commissionCode || !issueOpenTime || !repartoUUID) {
      promise.reject('dati in input SLA non validi');
    } else {
      if (!issueCloseTime) {
        //pending = true;
        issueCloseTime = moment();
      }
      if (!issueCloseTime._isAMomentObject) {
        issueCloseTime = moment(issueCloseTime);
      }
      if (!issueOpenTime._isAMomentObject) {
        issueOpenTime = moment(issueOpenTime);
      }
      commissionFactory().getCommissionByCode({
        code: commissionCode
      }).$promise.then(function (response) {
        if (response) {
          if (response.startTime && response.endTime) {
            var startTime = moment(response.startTime);
            var endTime = moment(response.endTime);
            var total_workhours = _calc_total_workhours(startTime.clone(), endTime.clone(), issueOpenTime.clone(), issueCloseTime.clone()); //ore totali di lavoro da inizio a chiusura
            var repartoFilter = {
              'UUID': sixFiltersLib.exact('UUID', repartoUUID)
            };
            recordFactory('reparto').search(repartoFilter).$promise.then(function (resp) {
              if (resp.list && resp.list[0].model.max_ore) {
                var max_ore = resp.list[0].model.max_ore;
                if (max_ore >= total_workhours) {
                  result.isValid = true;
                  //result.pending = pending;
                  result.total_workhours = total_workhours;
                  //result.max_ore = max_ore;
                  //passare data/ore termine SLA
                  result.date_time_consegna = _getDateTimeConsegna(startTime.clone(), endTime.clone(), max_ore, issueOpenTime.clone());
                  promise.resolve(result); //tempo totale impiegato da inizio a chiusura
                } else {
                  result.isValid = false;
                  // result.pending = pending;
                  result.total_workhours = total_workhours;
                  // result.max_ore = max_ore;
                  result.date_time_consegna = _getDateTimeConsegna(startTime.clone(), endTime.clone(), max_ore, issueOpenTime.clone()); //_getDateTimeConsegna(startTime.clone(), endTime.clone(), max_ore, issueOpenTime.clone()).clone();
                  promise.resolve(result); //tempo totale impiegato da inizio a chiusura
                }
              } else {
                promise.reject('Definire ore SLA del reparto');
              }
            });
          } else {
            promise.reject('errore nel recupero degli orari per la commission');
          }
        } else {
          promise.reject('errore nel recupero della commission');
        }
      });
    }
    return promise.promise;
  };
  this.isSLAEnabled = function (commissionCode, repartoUUID) {
    var promise = $q.defer();
    commissionFactory().getCommissionByCode({
      code: commissionCode
    }).$promise.then(function (response) {
      if (response) {
        if (response.startTime && response.endTime) {
          var repartoFilter = {
            'UUID': sixFiltersLib.exact('UUID', repartoUUID)
          };
          recordFactory('reparto').search(repartoFilter).$promise.then(function (resp) {
            if (resp.list && resp.list[0].model.max_ore) {
              promise.resolve(true);
            } else {
              promise.resolve(false);
            }
          })["catch"](function (error) {
            promise.reject('errore nel recupero del reparto');
          });
        } else {
          promise.resolve(false);
        }
      } else {
        promise.reject('errore nel recupero della commission');
      }
    })["catch"](function (err) {
      promise.reject('errore nel recupero della commission');
    });
    return promise.promise;
  };
  this.isSLACreatedDuringCommissionWorkhours = function (startTime, endTime) {
    var issueOpenTime = moment();
    var tmp_startTime = moment(startTime);
    var tmp_endTime = moment(endTime);
    if (issueOpenTime.hours() - tmp_startTime.hours() > 0) {
      if (tmp_endTime.hours() - issueOpenTime.hours() > 0) {
        return true;
      }
    }
    return false;
  };

  /**
   * UTILITY
   */

  /** _calc_total_workhours(startTime,endTime,issueOpenTime,issueCloseTime)
   * @param {*} startTime | moment().clone() inizio orario lavorativo della commessa
   * @param {*} endTime | moment().clone() fine orario lavorativo della commessa
   * @param {*} issueOpenTime | moment().clone() dell'apertura della issue
   * @param {*} issueCloseTime | moment().clone() della chiusura della issue
   */
  function _calc_total_workhours(startTime, endTime, issueOpenTime, issueCloseTime) {
    var result = 0;
    var total_hours_day = 24;
    var issue_days = [];
    var diff_issueTime = issueCloseTime.diff(issueOpenTime, "hours");
    if (diff_issueTime <= total_hours_day) {
      //sono passate meno di 24h
      result = _calc_workhours_perday(startTime, endTime, issueOpenTime, issueCloseTime);
    } else {
      //sono passate più di 24h
      var track = 0;
      var modifier;
      var _init = true;
      //split tempo impiegato a chiudere la issue
      while (track < diff_issueTime) {
        var tmp_day = {};
        modifier = 24 - issueOpenTime.hours();
        if (diff_issueTime - track <= total_hours_day) {
          tmp_day.startTime = issueOpenTime.clone();
          tmp_day.endTime = issueCloseTime.clone();
          issue_days.push(tmp_day);
        } else {
          tmp_day.startTime = issueOpenTime.clone();
          tmp_day.endTime = issueOpenTime.add(modifier, 'hours').clone();
          issue_days.push(tmp_day);
        }
        if (_init) {
          track += modifier;
          _init = false;
        } else {
          track += total_hours_day;
        }
      }
      //iterate days and get result
      for (var i = 0; i < issue_days.length; i++) {
        result += _calc_workhours_perday(startTime, endTime, issue_days[i].startTime, issue_days[i].endTime);
      }
    }
    return result;
  }
  function _calc_workhours_perday(startTime, endTime, issueOpenTime, issueCloseTime) {
    var result;
    var time_diff = issueCloseTime.diff(issueOpenTime, 'hours');
    var issue_close_time = issueOpenTime.hours() + time_diff;
    if (startTime.hours() >= issueOpenTime.hours()) {
      if (issue_close_time >= endTime.hours()) {
        result = endTime.hours() - startTime.hours(); //endTime.diff(startTime, "hours");
      } else {
        if (issue_close_time < startTime.hours()) {
          result = 0;
        } else {
          result = issue_close_time - startTime.hours();
        }
      }
    } else {
      if (issue_close_time >= endTime.hours()) {
        if (endTime.hours() < issueOpenTime.hours()) {
          result = 0;
        } else {
          result = endTime.hours() - issueOpenTime.hours();
        }
      } else {
        if (endTime.hours() < issueOpenTime.hours()) {
          result = 0;
        } else {
          result = issue_close_time - issueOpenTime.hours();
        }
      }
    }
    return result;
  }
  function _getDateTimeConsegna(startTime, endTime, max_ore, issueOpenTime) {
    var result = issueOpenTime.clone();
    var timer = 0; //n ore contate
    var modifier = 1; //n ore da aggiungere alla data volta per volta
    while (timer < max_ore) {
      result.add(modifier, "hours");
      if (result.hours() > startTime.hours()) {
        if (result.hours() < endTime.hours()) {
          timer++;
        }
      }
    }
    return result;
  }
}]);
'use strict';

/**
 * @ngdoc service
 * @name emma.theme.userPreferenceService
 * @description
 * # userPreferenceService
 * Permette il salvataggio di preferenze utente lato backend.
 * Imita i metodi del localstorage, ma restituisce delle promise.
 */
angular.module('emma.theme').service('userPreferenceService', ["APP_URL", "$resource", "$q", "localStorageService", function (APP_URL, $resource, $q, localStorageService) {
  var throttlingDelay = 1000; //millisecondi

  var resource = $resource(APP_URL + '/rest/userpreference/:id', {}, {});
  var keyAge = {};
  var keyDelay = {};
  function isStale(key) {
    if (key instanceof Date) {
      var age = Date.now() - key.getTime();
      return age > throttlingDelay;
    }
    return false;
  }
  this.get = function (key) {
    if ((!keyAge.hasOwnProperty(key) || isStale(keyAge[key])) && !keyDelay.hasOwnProperty(key)) {
      //per chiavi non ancora note o obsolete, contatto il backend
      //se esiste un keyDelay per la chiave, il backend è implicitamente obsoleto e non verrà affatto contattato.
      keyAge[key] = new Date();
      return resource.get({
        id: key
      }).$promise.then(function (value) {
        if (keyDelay.hasOwnProperty(key)) {
          //se in attesa di invio il dato in localstorage è più fresco di quello appena ricevuto
          return localStorageService.get(key);
        } else {
          localStorageService.set(key, value);
          return value;
        }
      }, function () {
        return localStorageService.get(key);
      });
    } else {
      return $q.resolve(localStorageService.get(key));
    }
  };

  //set e remove operano istantaneamente da localstorage e con un delay aggiornano il backend
  //eventuali set o remove (sulla stessa chiave) durante il delay, lo prorogano (Nota: potenzialmente all'infinito)
  this.remove = function (key) {
    var deferred = $q.defer();
    if (keyDelay.hasOwnProperty(key)) {
      clearTimeout(keyDelay[key]);
    }
    keyDelay[key] = setTimeout(function () {
      delete keyDelay[key];
      resource["delete"]({
        id: key
      }).$promise.then(deferred.resolve, deferred.reject);
    }, throttlingDelay);
    localStorageService.remove(key);
    return deferred.promise;
  };
  this.set = function (key, value) {
    var deferred = $q.defer();
    if (keyDelay.hasOwnProperty(key)) {
      clearTimeout(keyDelay[key]);
    }
    keyDelay[key] = setTimeout(function () {
      delete keyDelay[key];
      resource.save({
        id: key
      }, value).$promise.then(deferred.resolve, deferred.reject);
    }, throttlingDelay);
    localStorageService.set(key, value);
    return deferred.promise;
  };
}]);
'use strict';

/**
 * @ngdoc service
 * @name emma.theme.wsfactory
 * @description
 * # wsfactory
 * Factory in the emma.theme.
 */
angular.module('emma.theme').factory('wsfactory', ["APP_URL", "$websocket", function (APP_URL, $websocket) {
  var dataStream = $websocket('ws://' + APP_URL.split('http://')[1] + '/testendpoint');
  //var dataStream = $websocket('ws://localhost:8080/six/testendpoint');

  var collection = [];
  dataStream.onMessage(function (message) {
    collection.push(JSON.parse(message.data));
  });
  var methods = {
    collection: collection,
    get: function get() {
      dataStream.send(JSON.stringify({
        action: 'get'
      }));
    }
  };
  return methods;
}]);
"use strict";

/**
 * Created by stefano on 15/12/16.
 */

angular.module('emma.consip').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/test', {
    templateUrl: 'theme/test/test.html',
    controller: 'TestCtrl'
  });
}]).controller('TestCtrl', ["$scope", "$log", function ($scope, $log) {
  $scope.data = {
    list: []
  };
  $scope.params = {
    pageNumber: 1,
    pageSize: 100,
    totalItems: 0,
    filters: {}
  };
  $scope.viewGridOptions = {
    enableSorting: true,
    enableGridMenu: true,
    exporterCsvColumnSeparator: ';',
    exporterSuppressColumns: ['id', 'odl'],
    exporterMenuPdf: false,
    enableFiltering: true,
    enableColumnResizing: true,
    paginationPageSizes: [100, 250, 500, 1000, 10000],
    paginationPageSize: 100,
    totalItems: 0,
    useExternalPagination: true,
    useExternalFiltering: true,
    multiSelect: true,
    enableRowHeaderSelection: true,
    enableRowSelection: true,
    enableHorizontalScrollbar: 1,
    columnDefs: [{
      name: ' '
    }]
  };
  $scope.getData = function () {
    $scope.data.list = [{
      label: '1',
      value: 20,
      color: '#7266ba',
      description: 'Pippo'
    }, {
      label: '2',
      value: 50,
      color: '#23b7e5',
      description: 'Pluto'
    }, {
      label: '3',
      value: 30,
      color: '#fad733',
      description: 'Paperino'
    }];
  };
  $scope.getColumns = function () {
    $scope.viewGridOptions.columnDefs = [];
    $scope.viewGridOptions.columnDefs.push({
      displayName: 'Label',
      field: 'label',
      enableFiltering: true,
      pinnedLeft: true,
      width: 120
    });
  };
  setTimeout(function () {
    $scope.getData();
  }, 500);
  $scope.getColumns();
}]);
'use strict';

angular.module('emma.consip').component('importPdi', {
  controller: 'ImportPdiController',
  templateUrl: 'consip/acquisitionstep/importpdi/import.html',
  bindings: {
    xlsData: '<',
    onError: '&'
  }
}).controller('ImportPdiController', ["$scope", "recordFactory", "$interpolate", function ($scope, recordFactory, $interpolate) {
  var ctrl = this;
  var ERROR_COL = 'Stato';
  var MAX_ERR = .05;
  var COLUMNS = {
    QTA: 'Qta',
    PU: 'PU',
    PERC_SCONTO: '% Sconto',
    MESI_EROGAZIONE: 'Mesi erogazione',
    N_PREST_PER_ANNO: 'N° prest x anno',
    RIDUZ_PER_ATTIVITA: 'Riduzione x attivita canone',
    REPERIBLILITA: 'Reperibilita',
    IMPORTO_TOTALE: 'Importo totale',
    IMPORTO_ANNUO: 'Importo annuo',
    SERVIZIO: 'Servizio',
    EDIFICIO: 'Edificio',
    UM: 'UM',
    START_DATE: 'Data inizio',
    END_DATE: 'Data fine'
  };
  var CURRENCY_COLUMNS = [COLUMNS.IMPORTO_ANNUO, COLUMNS.IMPORTO_TOTALE, COLUMNS.PU];
  var RELATED_COLUMNS = [COLUMNS.SERVIZIO, COLUMNS.EDIFICIO, COLUMNS.UM];
  var MANDATORY_COLUMNS = [COLUMNS.MESI_EROGAZIONE, COLUMNS.QTA, COLUMNS.PU, COLUMNS.START_DATE, COLUMNS.END_DATE];
  var MISSING_MSG = $interpolate('Impossibile trovare il {{type}} con codice {{code}}');
  var ROUNDING_MSG = $interpolate('Errore di arrotondamento sul {{field}}. Originale {{read | currency:"€":3}} Calcolato {{computed | currency:"€":3}} Errore {{(computed - read) | number:3}}');
  $scope.gridOptions = {
    enableFiltering: true,
    enableOrdering: true,
    enableGridMenu: true,
    showGridFooter: false,
    columnDefs: [],
    data: [],
    gridFooterTemplate: 'consip/acquisitionstep/importpdi/grid-footer.template.html',
    gridMenuCustomItems: [{
      title: 'Adatta colonne',
      icon: 'fa fa-text-width',
      action: function action($event) {
        document.querySelectorAll(".ui-grid-column-resizer.right").forEach(function (el) {
          el.dispatchEvent(new CustomEvent("dblclick"));
        });
      },
      order: 208
    }]
  };
  ctrl.$onChanges = function (changesObj) {
    if (changesObj.xlsData.currentValue) {
      var workbook = changesObj.xlsData.currentValue;
      var sheet = workbook.Sheets[workbook.SheetNames[0]];
      initGrid(sheet);
      $scope.error = false;
      var entities = reduceData($scope.fileRows);
      recordFactory('WTF').bulkResolve(entities).$promise.then(function (response) {
        $scope.resolvedEntities = response;
        angular.forEach(response, function (values, type) {
          angular.forEach(values, function (value, code) {
            if (!value) {
              $scope.error = true;
              var msg = MISSING_MSG({
                type: type,
                code: code
              });
              entities[type][code].forEach(function (rowIndex) {
                $scope.fileRows[rowIndex][ERROR_COL] = append($scope.fileRows[rowIndex][ERROR_COL], msg, ';');
              });
            }
          });
        });
        validateFile();
        if ($scope.error) {
          ctrl.onError();
        }
      }, function (err) {
        console.error(err);
      });
    } else {
      $scope.gridOptions.data.length = 0;
      $scope.gridOptions.showGridFooter = false;
    }
  };
  function checkMissingFields(row) {
    var rowHasErr = false;
    MANDATORY_COLUMNS.forEach(function (mandatoryCol) {
      if (!row[mandatoryCol]) {
        $scope.error = true;
        rowHasErr = true;
        row[ERROR_COL] = append(row[ERROR_COL], 'Manca il campo ' + mandatoryCol, ';');
      }
    });
    return !rowHasErr;
  }
  $scope["export"] = function () {
    var exportData = XLSX.utils.json_to_sheet($scope.fileRows.map(function (r) {
      var row = angular.copy(r);
      delete row.umCode;
      return row;
    }), {
      header: $scope.gridOptions.columnDefs.map(function (c) {
        return c.field;
      })
    });
    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, exportData, "Sheet1");
    XLSX.writeFile(wb, 'review.xlsx', {
      bookType: 'xlsx',
      bookSST: false,
      type: 'binary'
    });
  };
  function initGrid(sheet) {
    $scope.gridOptions.columnDefs = XLSX.utils.sheet_to_json(sheet, {
      header: 1
    })[0].map(function (h) {
      var col = {
        field: h,
        width: 100
      };
      if (CURRENCY_COLUMNS.indexOf(h) >= 0) {
        col.cellClass = 'cont-right';
        col.cellFilter = 'currency:"€":2';
      } else if (h.toLowerCase().indexOf('data') >= 0) {
        col.cellClass = 'cont-center';
        col.cellFilter = 'date:"dd/MM/yyyy"';
      }
      return col;
    });
    $scope.gridOptions.showGridFooter = false;
    if ($scope.gridOptions.columnDefs[0].field != ERROR_COL) $scope.gridOptions.columnDefs.unshift({
      field: ERROR_COL,
      width: 100
    });
    $scope.gridOptions.data = $scope.fileRows = XLSX.utils.sheet_to_json(sheet, {
      raw: true
    }).map(fixData);
  }
  function reduceData(rows) {
    return rows.reduce(function (entities, row, index) {
      RELATED_COLUMNS.forEach(function (col) {
        var code = col == COLUMNS.UM ? row.umCode : row[col];
        if (!code) {
          $scope.error = true;
          row[ERROR_COL] = append(row[ERROR_COL], 'Manca il ' + col, ';');
        } else {
          var entityRequest = entities[col.toLowerCase()];
          if (!entityRequest[code]) {
            entityRequest[code] = [];
          }
          entityRequest[code].push(index);
        }
      });
      return entities;
    }, RELATED_COLUMNS.reduce(function (body, col) {
      body[col.toLowerCase()] = {};
      return body;
    }, {}));
  }
  function fixData(row) {
    delete row[ERROR_COL];
    if (angular.isString(row.UM)) {
      row.umCode = row.UM.replace(/\//g, '_').toLowerCase();
    }
    return row;
  }
  function validateFile() {
    var totals = $scope.totals = {
      computed: 0,
      original: 0
    };
    var resolvedService = $scope.resolvedEntities.servizio;
    $scope.fileRows.filter(checkMissingFields).forEach(function (row) {
      var service = resolvedService[row[COLUMNS.SERVIZIO]];
      var unaTantum = service && service.model.una_tantum;
      var qta = row[COLUMNS.QTA];
      var pu = row[COLUMNS.PU];
      var sconto = row[COLUMNS.PERC_SCONTO];
      var availability = row[COLUMNS.REPERIBLILITA];
      var mesi = row[COLUMNS.MESI_EROGAZIONE];
      var nPrestAnno = row[COLUMNS.N_PREST_PER_ANNO];
      var ridAtt = row[COLUMNS.RIDUZ_PER_ATTIVITA];
      if (nPrestAnno > 0) {
        qta *= nPrestAnno;
      }
      if (sconto > 0) {
        sconto = sconto / 100;
        pu = pu - sconto * pu;
      }
      if (ridAtt > 0) {
        ridAtt = ridAtt / 100;
        pu = pu - ridAtt * pu;
      }
      if (availability > 0) {
        pu = pu + availability / 100 * pu;
      }
      var tot_year, tot_month, tot_total;
      if (unaTantum) {
        tot_total = pu * qta;
        tot_month = tot_total / mesi;
        tot_year = tot_month * 12;
      } else {
        tot_year = pu * qta;
        tot_month = tot_year / 12;
        tot_total = tot_month * mesi;
      }
      var tot_total_excel = row[COLUMNS.IMPORTO_TOTALE];
      var tot_year_excel = row[COLUMNS.IMPORTO_ANNUO];
      if (Math.abs(tot_year - tot_year_excel) >= MAX_ERR) {
        $scope.error = true;
        row[ERROR_COL] = append(row[ERROR_COL], ROUNDING_MSG({
          field: 'totale annuo',
          read: tot_year_excel,
          computed: tot_year
        }), '; ');
      } else if (Math.abs(tot_total - tot_total_excel) >= MAX_ERR) {
        $scope.error = true;
        row[ERROR_COL] = append(row[ERROR_COL], ROUNDING_MSG({
          field: 'totale',
          read: tot_total_excel,
          computed: tot_total
        }), '; ');
      }
      totals.computed += tot_total;
      totals.original += tot_total_excel;
      var actualMonths = Math.floor(monthsDiff(row[COLUMNS.START_DATE], row[COLUMNS.END_DATE]));
      if (isNaN(actualMonths)) {
        row[ERROR_COL] = append(row[ERROR_COL], 'Impossibile calcolare i mesi tra Data inizio e Data fine', '; ');
        $scope.error = true;
      } else if (mesi != actualMonths) {
        row[ERROR_COL] = append(row[ERROR_COL], 'I mesi di erogazione non sono coerenti alle date di inizio e fine erogazione', '; ');
        $scope.error = true;
      }
    });
    if (Math.abs(totals.computed - totals.original) >= MAX_ERR * $scope.fileRows.length) {
      $scope.error = true;
      $scope.gridOptions.showGridFooter = true;
    }
  }
  function monthsDiff(startDate, endDate) {
    return moment(endDate).add(1, 'd').diff(moment(startDate), 'month', true);
  }
  function append(str, value, separator) {
    if (str) {
      return str + (separator || '') + value;
    } else {
      return value;
    }
  }
}]);
'use strict';

angular.module('emma.consip').controller('AddSalRow', ["$scope", "$log", "dialogService", "salGenerationService", "authFactory", "uiGridConstants", function ($scope, $log, dialogService, salGenerationService, authFactory, uiGridConstants) {
  var ctrl = this;
  var permission = {
    manualRow: authFactory.checkPerm('SAL', 'manual_row'),
    manualRowCanone: authFactory.checkPerm('SAL', 'manual_row_canone'),
    fakeRow: authFactory.checkPerm('SAL', 'fake_row')
  };
  $scope.gridOptions = {
    enableGridMenu: true,
    enableFiltering: true,
    onRegisterApi: function onRegisterApi(gridApi) {
      $scope.gridApi = gridApi;
    },
    data: [],
    columnDefs: [{
      displayName: 'Cod. Edificio',
      field: 'model.asset_id.code'
    }, {
      displayName: 'Edificio',
      field: 'model.asset_id.description'
    }, {
      displayName: 'Cod. Servizio',
      field: 'model.service_id.code'
    }, {
      displayName: 'Descr. Servizio',
      field: 'model.service_id.description'
    }, {
      displayName: 'Tipo servizio',
      field: 'model.service_type',
      filters: [{
        type: uiGridConstants.filter.SELECT,
        condition: uiGridConstants.filter.STARTS_WITH,
        selectOptions: [{
          value: 'canone',
          label: 'Canone'
        }, {
          value: 'extra',
          label: 'Extra canone'
        }]
      }]
    }, {
      displayName: 'UM',
      field: 'model.um_id.description'
    }]
  };
  $scope.canAddRow = function () {
    return permission.manualRow || permission.fakeRow;
  };
  $scope.showServiceDialog = function () {
    var opts = {
      name: 'addSalRowDialog',
      closeByDocument: false,
      width: '90%',
      plain: false
    };
    if (permission.manualRow) {
      var filter = {
        data_fine: sixFiltersLib.rangeGt('model.data_fine', ctrl.dateRange.start_date),
        data_inizio: sixFiltersLib.rangeLt('model.data_inizio', ctrl.dateRange.end_date)
      };
      if (ctrl.customer) {
        filter.customer = sixFiltersLib.exact('customer', ctrl.customer);
      }
      if (!permission.manualRowCanone) {
        filter.service = sixFiltersLib.exact('model.tipo_servizio', 'canone', sixFiltersLib.CONSTRAINTS.ANDNOT);
      }
      salGenerationService.availableRow(filter).then(function (response) {
        if (!response.hasErrors) {
          $scope.gridOptions.data = response.distinctResult;
        }
      });
    }
    dialogService.templateDialog('dialogChooseServiceTemplate.html', dialogService.DIALOG_TYPE.INFO, {
      gridOptions: $scope.gridOptions,
      permission: permission,
      row: {
        pu: 1,
        qty: 0,
        amount: 0
      },
      onAddRows: function onAddRows() {
        ctrl.onAddRows({
          rows: $scope.gridApi.selection.getSelectedRows(),
          type: 'manual'
        });
      },
      onAddFakeRow: function onAddFakeRow(row) {
        ctrl.onAddRows({
          rows: [{
            model: row
          }],
          type: 'fake'
        });
      },
      selectedCount: function selectedCount() {
        if ($scope.gridApi) {
          return $scope.gridApi.selection.getSelectedCount();
        }
        return 0;
      }
    }, opts, -1, false);
  };
}]).component('addSalRow', {
  controller: 'AddSalRow',
  templateUrl: 'consip/sal/createrow/add_sal_row.html',
  bindings: {
    dateRange: '<',
    customer: '<',
    onAddRows: '&'
  }
});
'use strict';

(function () {
  /**** CONSTANTS ****/

  var SCHEMA = 'schema'; // endpoint per le entity
  var TREE = 'tree'; // endpoint per i tree
  var RECORD = 'record'; // endpoint per le istanze di entity
  var PREFIX = 'def'; // prefisso del code del tree nell'indice
  var DEFAULT_DIALOG_TIMEOUT = 4000;
  var CHILDREN_FIELD_NAME = 'nodes';
  var PARENTS_FIELD_NAME = 'parents';
  var TREETYPE = 'definition';

  /**** COMMON FUNCTIONS ****/

  // Comparatore di oggetti record e schema
  var record2SchemaComparator = function record2SchemaComparator(node1, node2) {
    if (node1 && node2 && node1.schemaCode === node2.model.code) {
      return true;
    }
    return false;
  };

  // Comparatore di oggetti record
  var record2RecordComparator = function record2RecordComparator(node1, node2) {
    if (node1 && node2 && node1.version === node2.version) {
      return true;
    }
    return false;
  };

  /**** ANGULAR ****/

  /**
   * @ngdoc function
   * @name emma.dataset.controller:TreeCtrl
   * @description
   * # TreeCtrl
   * Controller of the emma.dataset
   */
  var app = angular.module('emma.dataset');
  app.config(["$routeProvider", "treeConfig", function ($routeProvider, treeConfig) {
    $routeProvider.when('/treeold', {
      templateUrl: 'dataset/tree/old/tree.html',
      controller: 'TreeOldCtrl',
      controllerAs: 'TreeOldCtrl'
    }).when('/treeold/:treeStructureId', {
      templateUrl: 'dataset/tree/old/tree.html',
      controller: 'TreeOldCtrl'
    }).when('/treeold/:treeStructureId/:id', {
      templateUrl: 'dataset/tree/old/tree.html',
      controller: 'TreeOldCtrl'
    });
    treeConfig.defaultCollapsed = true; // collapse nodes by default
  }]);

  app.controller('TreeOldCtrl', ["$scope", "$routeParams", "$location", "treeFactory", "recordFactory", "schemaFactory", "$filter", "$log", "authFactory", "counterFactory", "dialogService", "treeService", "modelIconService", "errorService", "toaster", "pipeConfigurationTree", "treePlanConfigFactory", "$q", "$timeout", function ($scope, $routeParams, $location, treeFactory, recordFactory, schemaFactory, $filter, $log, authFactory, counterFactory, dialogService, treeService, modelIconService, errorService, toaster, pipeConfigurationTree, treePlanConfigFactory, $q, $timeout) {
    var currentCommission = authFactory.getAuthData().info.commissions.current;
    $scope.showRecordsList = false; // flag per mostrare/nascondere la lista dei record
    $scope.showDetails = false; // flag per mostrare/nascondere i dettagli del record selezionato
    $scope.rightSidebarSize = '50';
    $scope.searchInput = {
      text: undefined
    }; // Oggetto che contiene i filtri di ricerca
    $scope.searchInputInTree = {
      text: undefined
    }; // Oggetto che contiene i filtri di ricerca nel tree

    $scope.tree = {
      wrapper: {
        model: {
          nodes: [],
          type: TREETYPE
        }
      },
      // wrapper che arriva dall'endpoint che fornisce l'albero richiesto
      structure: {},
      // struttura dell'albero creata tramite il tree configurator
      loaded: false,
      structureLoaded: false
    };
    $scope.treeCollapsed = true;
    $scope.records = {
      list: [],
      // lista non filtrata delle entity ammesse nel nodo selezionato
      loaded: false
    };

    // Parametri di paginazione delle records
    $scope.pagination = {
      totalItems: 0,
      // Numero di records in $scope.records.list
      currentPage: 1,
      // Pagina di navigazione correntemente visualizzata
      pageSize: 15,
      // Numero di elementi per pagina da visualizzare
      noOfPages: 4 // Numero di pagine mostrate
    };

    $scope.commissionDependent = false;
    $scope.historyMode = 'snap';

    // Record da aggiungere "inline" da questa pagina
    $scope.record = {
      wrapper: {},
      // wrapper che arriva dall'endpoint che fornisce l'albero richiesto
      type: {},
      // tipo di record (schemaCode)
      model: {},
      // valorizzazione del record
      schema: {},
      form: {},
      version: undefined,
      parent: undefined,
      // nodo in cui si sta cercando di aggiungere il record
      loaded: false
    };
    $scope.typeDescription = undefined;
    $scope.selected = {
      treeNode: undefined,
      // Nodo dell'albero correntemente selezionato
      records: [] // Record correntemente selezionati (selezione multipla)
    };

    $scope.dropdownList = {
      roots: [],
      // Lista delle radici che è possibile creare ex-novo
      nodes: [] // Lista dei nodi che è possibile creare ex-novo in base all'elemento del tree selezionato
    };

    $scope.selfGeneratedCode = {
      codeNameSix: '',
      active: false
    };
    $scope.isCustomerMissing = function () {
      var missing = $scope.app.profileCustomer && angular.isUndefined($scope.currentCustomer);
      return missing;
    };

    // records tree callbacks
    $scope.recordsOptions = {
      // Richiamata quando si cerca di trascinare un nodo in un punto dell'albero:
      // controlla se la destinazione può accettare il nodo
      accept: function accept(sourceNodeScope, destNodesScope, destIndex) {
        return false;
      },
      // Richiamata prima di iniziare il trascinamento
      beforeDrag: function beforeDrag(sourceNodeScope) {
        return $scope.isWritePermAllowed();
      },
      // Richiamata quando si inizia il trascinamento
      dragStart: function dragStart(event) {
        // Tolgo dal nodo tutte le info che non servono
      },
      // Richiamata quando si rilascia il nodo dopo il trascinamento
      dragStop: function dragStop(event) {
        $scope.addParentToChildren(event.dest.nodesScope.$parent.$modelValue, event.source.nodeScope.$modelValue);
        $scope.removeRecordFromSelection(event.source.nodeScope.$modelValue); // Se era selezionato lo rimuovo
        $timeout(function () {
          $scope.updateTree();
        }, 50);
      }
    };

    // Tree tree callbacks
    $scope.treeOptions = {
      // Richiamata quando si cerca di trascinare un nodo in un punto dell'albero:
      // controlla se la destinazione può accettare il nodo
      accept: function accept(sourceNodeScope, destNodesScope, destIndex) {
        var destNode = undefined;
        if (destNodesScope.$nodeScope != undefined) {
          // per evitare errori nel log
          destNode = destNodesScope.$nodeScope.$modelValue;
        }
        // il nodo è ammesso se è previsto nella struttura del tree e non è già stato inserito
        return isChildAllowed(sourceNodeScope.$modelValue, destNode);
      },
      beforeDrag: function beforeDrag(sourceNodeScope) {
        return $scope.isWritePermAllowed();
      },
      // Richiamata quando si inizia il trascinamento
      dragStart: function dragStart(event) {
        $scope.removeParentFromChild(event.dest.nodesScope.$parent.$modelValue, event.source.nodeScope.$modelValue);
      },
      // Richiamata quando si rilascia il nodo dopo il trascinamento
      dragStop: function dragStop(event) {
        $scope.addParentToChildren(event.dest.nodesScope.$parent.$modelValue, event.source.nodeScope.$modelValue);
        $scope.updateTree();
      }
    };

    // Rimuove un nodo dall'albero
    $scope.removeTreeNode = function (scope) {
      $log.info('remove ' + scope.index());
      if (scope.$modelValue.nodes.length === 0) {
        _removeTreeNode(scope);
      } else {
        dialogService.confirmDialog('Il nodo non è vuoto, eliminarlo ugualmente?', function () {
          _removeTreeNode(scope);
        }, function () {});
      }
    };
    function _removeTreeNode(scope) {
      scope.remove();
      /* se è una configurazione devo eleminare anche l'elemento associato che abbiamo creato sull'indice di tipo 'configurazione' */
      if (scope.$parent.$modelValue.schemaCode == 'configurazione') {
        treePlanConfigFactory.deleteConfiguration({
          id: scope.$parent.$modelValue.UUID
        }).$promise.then(function () {
          console.log('Configuration deleted on index');
          if ($scope.showDetails) {
            $scope.getRecordDetail(false, scope.$parent.$modelValue.parents[0].schemaCode, scope.$parent.$modelValue.parents[0].UUID);
          }
        });
      }
      addNodeToRecordsList(scope.$parent.$modelValue);
      $timeout(function () {
        // devo attendere che la scope.remove() precedente venga completata
        $scope.updateTree();
      }, 50);
    }

    // (De)Comprime i rami dell'albero
    $scope.toggleNode = function (scope) {
      scope.toggle();
    };
    $scope.toggleAll = function () {
      var scope = angular.element(document.getElementById("tree1-root")).scope();
      if ($scope.treeCollapsed === false) {
        $scope.collapseAll();
        $scope.treeCollapsed = true;
      } else {
        $scope.expandAll();
        $scope.treeCollapsed = false;
      }
    };
    $scope.collapseAll = function () {
      $scope.$broadcast('angular-ui-tree:collapse-all');
    };
    $scope.expandAll = function () {
      $scope.$broadcast('angular-ui-tree:expand-all');
    };
    $scope.isNodeVisible = function (node) {
      if ($scope.searchInputInTree.text && $scope.searchInputInTree.text !== '') {
        var expr = $scope.searchInputInTree.text.toLowerCase();
        return recursiveNodeSearch(node, expr, false);
      } else {
        return true;
      }
    };
    $scope.isRecordVisible = function (record) {
      if (angular.isUndefined($scope.searchInput) || angular.isUndefined($scope.searchInput.text)) {
        return true;
      }
      var search = angular.lowercase($scope.searchInput.text);
      if (angular.isDefined(record.model) && record.model != null) {
        if (angular.lowercase(record.model.code).includes(search) || angular.lowercase(record.model.description) && angular.lowercase(record.model.description).includes(search) || angular.lowercase(record.schemaCode).includes(search)) {
          return true;
        }
      }
      return false;
    };
    function recursiveNodeSearch(node, expr, partialResult) {
      var found = partialResult;
      if (!found && node) {
        // se l'ho già trovato ritorno subito true, altrimenti cerco ricorsivamente
        found = found || node.model.code.toLowerCase().includes(expr);
        found = found || node.model.description.toLowerCase().includes(expr);
        if (!found && node.nodes && node.nodes.length > 0) {
          node.nodes.forEach(function (child) {
            if (!found) {
              found = found || recursiveNodeSearch(child, expr, found);
            }
          });
        }
      }
      return found;
    }

    // utils

    // Salva o aggiorna l'albero nell'indice
    $scope.updateTree = function () {
      if ($scope.tree.wrapper.version) {
        treeFactory.update({
          id: $scope.tree.wrapper.version
        }, $scope.tree.wrapper).$promise.then(function (data) {
          if (errorService.handleError(data)) {
            sixObjectLib.clearObject($scope.tree.wrapper); // svuoto il wrapper senza pedere il riferimento
            Object.assign($scope.tree.wrapper, data); // copio il risultato nel wrapper (senza riassegnarlo, così non perdo il riferimento)
            if (data.dataIn) {
              $scope.tree.wrapper.dataIn = new Date(data.dataIn);
            }
            if (data.dataOut) {
              $scope.tree.wrapper.dataOut = new Date(data.dataOut);
            }
          } else {
            toaster.pop('error', 'Errore', 'Errore durante il salvataggio');
          }
        });
      } else {
        $log.info(angular.toJson($scope.tree.wrapper.model));
        treeFactory.create($scope.tree.wrapper.model).$promise.then(function (data) {
          if (errorService.handleError(data)) {
            sixObjectLib.clearObject($scope.tree.wrapper); // svuoto il wrapper senza pedere il riferimento
            Object.assign($scope.tree.wrapper, data); // copio il risultato nel wrapper (senza riassegnarlo, così non perdo il riferimento)
            if (data.dataIn) {
              $scope.tree.wrapper.dataIn = new Date(data.dataIn);
            }
            if (data.dataOut) {
              $scope.tree.wrapper.dataOut = new Date(data.dataOut);
            }
          } else {
            toaster.pop('error', 'Errore', 'Errore durante il salvataggio');
          }
        });
      }
    };

    // Cancella un albero dall'indice
    $scope.deleteTree = function () {
      treeFactory["delete"]({
        id: $scope.tree.wrapper.version
      }).$promise.then(function () {
        sixObjectLib.clearObject($scope.tree.wrapper); // svuoto il wrapper senza pedere il riferimento
        Object.assign($scope.tree.wrapper, {
          model: {
            nodes: []
          }
        });
        dialogService.dialog('Albero eliminato', '', 'success', DEFAULT_DIALOG_TIMEOUT, true);
      });
    };

    // Salva o aggiorna un record nell'indice
    $scope.updateRecord = function () {
      // gestione code tramite contatore di SIX, confermo il codice...
      if ($scope.selfGeneratedCode.active == true) {
        counterFactory.next({
          code: $scope.selfGeneratedCode.codeNameSix
        }).$promise.then(function (response) {
          if (response.errors) {
            toaster.pop('error', 'Errore', 'Problema rilevato nell\'inizializziazione automatica del codice: ' + response.errors.error);
          } else {
            if (!$scope.record.model.code) {
              // se è ancora vuoto lo riempio
              $scope.record.model.code = response.next; // se è nuovo, confermo il codice...
            }
          }

          _update();
        });
      } else {
        _update();
      }
    };
    function _update() {
      if ($scope.record.version) {
        recordFactory($scope.record.type).update({
          id: $scope.record.version,
          history: $scope.historyMode === 'snap'
        }, $scope.record.wrapper).$promise.then(function (data) {
          $scope.record.wrapper = data;
          $scope.record.model = $scope.record.wrapper.model;
          $scope.selected.treeNode.model = $scope.record.wrapper.model; // Aggiorno la visualizzazione nel tree

          dialogService.dialog('Record salvato', '', 'success', DEFAULT_DIALOG_TIMEOUT, true);
        });
      } else {
        recordFactory($scope.record.type).create({
          commissionDependent: $scope.commissionDependent,
          history: $scope.historyMode === 'snap'
        }, $scope.record.model).$promise.then(function (data) {
          $scope.record.wrapper = data;
          $scope.record.model = $scope.record.wrapper.model;
          $scope.record.wrapper.nodes = [];
          $scope.addNodesToParent($scope.record.parent, $scope.record.wrapper);
          $scope.updateTree();
          dialogService.dialog('Record salvato', '', 'success', DEFAULT_DIALOG_TIMEOUT, true);
        });
      }
    }

    // Aggiunge un nodo ad un padre
    $scope.addNodesToParent = function (parent, nodes) {
      var root = false;
      if (angular.isUndefined(parent)) {
        root = true;
      }
      parent = parent || $scope.tree.wrapper.model;
      if (parent && nodes && [].concat(nodes).length > 0) {
        // Controllo se i nodi sono già presenti nel tree
        var childrenToAdd = [];
        var alreadyAdded = [];
        [].concat(nodes).forEach(function (child) {
          if (treeService.findNodeInTree(child, $scope.tree.wrapper.model, record2RecordComparator) === undefined) {
            childrenToAdd.push(child);
            removeNodeFromRecordsList(child);
          } else {
            alreadyAdded.push(child);
          }
        });
        // Se ho trovato nodi già presenti nel tree li mostro in una dialog
        if (alreadyAdded.length > 0) {
          var msg = '';
          alreadyAdded.forEach(function (child) {
            msg += child.model.code + ' - ' + child.model.description + '<br/>';
          });
          dialogService.dialog('Nodi già presenti:', msg, 'warning', -1, false, 'left');
        }

        // Se ho nodi da aggiungere (non ancora presenti nel tree) li aggiungo
        if (childrenToAdd.length > 0) {
          if (treeService.addNodesToParent(parent, childrenToAdd, CHILDREN_FIELD_NAME)) {
            if (root === false) {
              $scope.addParentToChildren(parent, childrenToAdd);
            }
            $scope.updateTree();
            $scope.selected.records = [];
          } else {
            dialogService.dialog('Errore nell\'inserimento del riferimento al figlio', '', 'danger', DEFAULT_DIALOG_TIMEOUT, true);
          }
        }
      } else {
        dialogService.dialog('Nessun nodo selezionato', '', 'warning', DEFAULT_DIALOG_TIMEOUT, true);
      }
    };

    // Aggiunge i parent ai figli
    $scope.addParentToChildren = function (parents, children) {
      if (children && [].concat(children).length > 0 && parents && [].concat(parents).length > 0) {
        [].concat(children).forEach(function (child) {
          if (!child.parents) {
            child.parents = [];
          }
          if (!treeService.addNodesToParent(child, treeService.drainRecords(parents), PARENTS_FIELD_NAME)) {
            dialogService.dialog('Errore nell\'inserimento del riferimento al padre', '', 'danger', DEFAULT_DIALOG_TIMEOUT, true);
          }
        });
      }
    };

    // Rimuove il parent dal figlio
    $scope.removeParentFromChild = function (parent, child) {
      if (child && parent) {
        if (!child.parents) {
          child.parents = [];
        }
        child.parents.forEach(function (p, index) {
          if (p.version === parent.version) {
            child.parents.splice(index, 1);
          }
        });
      }
    };

    // Submit del form dettagli record
    $scope.onSubmitDetailForm = function (form) {
      // First we broadcast an event so all fields validate themselves
      $scope.$broadcast('schemaFormValidate');

      // Then we check if the form is valid
      if (form.$valid) {
        $scope.updateRecord();
      }
    };

    // Recupera i dettagli del record selezionato (o carica il form per inserirne uno nuovo)
    $scope.getRecordDetail = function (isRoot, entityType, id) {
      $scope.record.loaded = false;
      $scope.record.type = entityType;
      if (isRoot) {
        $scope.record.parent = $scope.tree.wrapper.model;
      } else {
        $scope.record.parent = $scope.selected.treeNode;
      }
      schemaFactory().byCode({
        id: $scope.record.type
      }).$promise.then(function (data) {
        $scope.record.wrapper = data;
        $scope.record.model = {};
        $scope.record.schema = data.model.schema;
        $scope.record.form = data.model.form;
        $scope.commissionDependent = data.model.commissionDependent;
        $scope.historyMode = data.model.history == true ? 'snap' : 'stable';
        if (data.model.selfGeneratedCode) {
          $scope.selfGeneratedCode = data.model.selfGeneratedCode;
        } else {
          $scope.selfGeneratedCode = {
            codeNameSix: '',
            active: false
          };
        }
        $scope.record.version = undefined;
        $scope.typeDescription = data.model.description;
        if ($scope.record.type == 'configurazione') {
          // apro il caricamento della configurazione...
          $scope.openConfiguration();
          // mostro il pannello (abilito entrambe le variabili)...
          $scope.record.loaded = true;
          $scope.showDetails = true;
        } else {
          // se è un record lancio la chiamata per scaricare il dato...
          recordFactory($scope.record.type).byUUID({
            id: id
          }).$promise.then(function (data) {
            if (data.model) {
              $scope.record.wrapper = data;
              $scope.record.model = $scope.record.wrapper.model;
              $scope.record.version = $scope.record.wrapper.version;
              $scope.$broadcast('schemaFormRedraw');
            } else {
              /* scarico il codice della segnalazione dal contatore di SIX */
              if ($scope.selfGeneratedCode.active == true) {
                counterFactory.current({
                  code: $scope.selfGeneratedCode.codeNameSix
                }).$promise.then(function (response) {
                  if (response.errors) {
                    toaster.pop('error', 'Errore', 'Problema rilevato nell\'inizializziazione automatica del codice: ' + response.errors.error);
                  } else {
                    $scope.record.model.code = (parseInt(response.current) + 1).toString();
                  }
                });
              }
            }
            if (!data.model && isRoot) {
              $scope.selected.treeNode = {
                schemaCode: 'root'
              };
            }
            // mostro il pannello (abilito entrambe le variabili)...
            $scope.record.loaded = true;
            $scope.showDetails = true;
          });
        }
      });
    };
    $scope.getTreeByUUID = function (treeId) {
      $scope.tree.loaded = false;
      return treeFactory.byUUID({
        id: treeId
      }).$promise.then(function (data) {
        if (data.version) {
          $scope.tree.wrapper = data;
        } else {
          $scope.tree.wrapper = {
            model: {
              nodes: [],
              type: TREETYPE
            }
          };
        }
        $scope.tree.loaded = true;
        $log.info($scope.tree.loaded);
      });
    };
    $scope.getTreeStructureByUUID = function (treeId) {
      $scope.tree.structureLoaded = false;
      return treeFactory.byUUID({
        id: treeId
      }).$promise.then(function (data) {
        if (data.model) {
          $scope.tree.structure = data.model.nodes;
          if ($scope.showRecordsList) {
            $scope.loadAllowedRecords(); // senza parametri parte dalla root
          }

          $scope.dropdownList.roots = $scope.getEntityChildsInTreeStructure(); // tutte le root
          $scope.dropdownList.nodes = angular.copy($scope.dropdownList.roots);
        } else {
          dialogService.dialog('ATTENZIONE', 'Nessuna struttura albero definita', 'warning', DEFAULT_DIALOG_TIMEOUT);
        }
        $scope.tree.structureLoaded = true;
      });
    };

    // Recupera un tree salvato
    $scope.getTree = function () {
      $scope.tree.loaded = false;
      var promise = treeFactory.getTreeDefinition().$promise;
      promise.then(function (data) {
        if (data.version) {
          $scope.tree.wrapper = data;
        } else {
          $scope.tree.wrapper = {
            model: {
              nodes: [],
              type: TREETYPE
            }
          };
        }
        $scope.tree.loaded = true;
      });
      return promise;
    };

    // Recupera la struttura dell'albero realizzata con il tree configurator
    $scope.getTreeStructure = function () {
      return treeFactory.getTreeStructure().$promise.then(function (data) {
        if (data.model) {
          $scope.tree.structure = data.model.nodes;
          if ($scope.showRecordsList) {
            $scope.loadAllowedRecords(); // senza parametri parte dalla root
          }

          $scope.dropdownList.roots = $scope.getEntityChildsInTreeStructure(); // tutte le root
          $scope.dropdownList.nodes = angular.copy($scope.dropdownList.roots);
        } else {
          dialogService.dialog('ATTENZIONE', 'Nessuna struttura albero definita', 'warning', DEFAULT_DIALOG_TIMEOUT);
        }
      });
    };
    $scope.selectAllFromRecordsList = function () {
      $scope.selected.records = $filter('recordsSearchFilter')($scope.records.list, $scope.searchInput.text);
    };
    $scope.unselectAllFromRecordsList = function () {
      $scope.selected.records = [];
    };

    // De/Seleziona un record (lista di sinistra)
    $scope.toggleRecordSelection = function (node) {
      if (node === undefined) {
        $scope.selected.records = [];
      } else {
        if ($scope.isRecordSelected(node)) {
          $scope.removeRecordFromSelection(node);
        } else {
          $scope.selected.records.push(node);
        }
      }
    };

    // Deselezione il record
    $scope.removeRecordFromSelection = function (node) {
      if ($scope.selected.records && node) {
        $scope.selected.records.forEach(function (elem, index) {
          if (node.version === elem.version) {
            $scope.selected.records.splice(index, 1);
            return;
          }
        });
      }
    };

    // Seleziona un nodo dell'albero
    $scope.selectNode = function (node) {
      if (node === undefined) {
        if ($scope.showRecordsList && angular.isDefined($scope.selected.treeNode)) {
          $scope.loadAllowedRecords();
        }
        $scope.unselectRecord();
        $scope.dropdownList.nodes = angular.copy($scope.dropdownList.roots);
        $scope.showRecordsList = true;
      } else {
        if ($scope.showRecordsList && (angular.isUndefined($scope.selected.treeNode) || node.UUID != $scope.selected.treeNode.UUID)) {
          $scope.loadAllowedRecords(node);
        }
        if ($scope.showDetails && (angular.isUndefined($scope.selected.treeNode) || node.UUID != $scope.selected.treeNode.UUID)) {
          $scope.getRecordDetail(false, node.schemaCode, node.UUID);
        }
        $scope.selected.treeNode = node;
        $scope.selected.records = [];
        $scope.dropdownList.nodes = $scope.getEntityChildsInTreeStructure(node);
      }
    };

    // Deseleziona il nodo selezionato
    $scope.unselectRecord = function () {
      $scope.record = {
        wrapper: {},
        type: {},
        version: undefined,
        schema: {},
        model: {},
        form: {},
        parent: $scope.tree.wrapper.model
      };
      $scope.selected.treeNode = undefined;
      $scope.selected.records = [];
      $scope.dropdownList.nodes = $scope.getEntityChildsInTreeStructure();
    };
    $scope.loadAllowedRecords = function (parent) {
      $scope.records.list = [];
      $scope.records.loaded = false;
      var parentId = angular.isDefined(parent) ? parent.UUID : undefined;
      // rest: six-data-set/api/tree/_allowedChilds/{tree_config_id}/{tree_id}/{parent_id}?dublicates_allowed=[true,false]
      return treeFactory.allowedChilds({
        id: currentCommission.code,
        // tree_config_id
        param1: $scope.tree.wrapper.UUID,
        // tree_id
        param2: parentId,
        // parent_id
        duplicates_allowed: false
      }).$promise.then(function (data) {
        addNodeToRecordsList(treeService.drainRecords(data.list));
        $scope.records.loaded = true;
      });
    };

    // Restituisce i possibili nodi figli (entity) di un parent
    $scope.getEntityChildsInTreeStructure = function (parent) {
      if (parent === undefined) {
        // root
        return $scope.tree.structure;
      }
      var node = treeService.findNodeInTree(parent, {
        nodes: $scope.tree.structure
      }, record2SchemaComparator);
      if (!angular.isUndefined(node)) {
        return node.nodes;
      }
      return undefined;
    };

    // Controlla se un figlio è ammissibile per un nodo
    var isChildAllowed = function isChildAllowed(sourceNode, destNode) {
      var allowedChildren = $scope.getEntityChildsInTreeStructure(destNode);
      if (allowedChildren != undefined) {
        var allowed = false;
        allowedChildren.forEach(function (item) {
          if (item.model.code == sourceNode.schemaCode) {
            allowed = true;
          }
        });
        return allowed;
      }
    };

    // Aggiunge un array di nodi alla lista dei records
    function addNodeToRecordsList(nodes) {
      if (angular.isUndefined($scope.records.list)) {
        $scope.records.list = [];
      }
      $scope.records.list = $scope.records.list.concat(nodes);
    }

    // Rimuove un nodo dalla lista dei records
    function removeNodeFromRecordsList(node) {
      if (angular.isDefined($scope.records.list)) {
        var pos = $scope.records.list.indexOf(node);
        if (~pos) $scope.records.list.splice(pos, 1);
      }
    }

    // Mostra/nascondi la lista di record a sinistra
    $scope.toggleRecordsList = function () {
      $scope.showRecordsList = !$scope.showRecordsList;
    };

    // Mostra/nascondi dettagli
    $scope.toggleDetails = function () {
      $scope.showDetails = !$scope.showDetails;
      // se è da visualizzare, allora lancio la chiamata per scaricare il dato...
      if ($scope.showDetails == true) {
        $scope.getRecordDetail(false, $scope.selected.treeNode.schemaCode, $scope.selected.treeNode.UUID);
      } else {
        // altrimenti pulisco la variabile del panel di destra...
        $scope.record = {
          wrapper: {},
          type: {},
          model: {},
          schema: {},
          form: {},
          version: undefined,
          parent: undefined,
          loaded: false
        };
      }
    };
    $scope.$watch('showRecordsList', function () {
      if ($scope.showRecordsList) {
        $scope.loadAllowedRecords($scope.selected.treeNode); // senza parametri parte dalla root
      }
    });

    // Recuper l'icona del model da menu
    $scope.getModelIcon = function (modelName) {
      var icon = modelIconService.getModelIcon(modelName) || 'fa fa-circle-o';
      return icon;
    };

    // Necessario per evitare deselezione (solo a livello html) del nodo selezionato ogni volta che viene
    // ridisegnato l'albero (i riferimenti cambiano)
    $scope.isNodeSelected = function (node) {
      if ($scope.selected.treeNode && node) {
        return record2RecordComparator(node, $scope.selected.treeNode);
      }
      return false;
    };
    $scope.isRecordSelected = function (node) {
      var selected = false;
      if ($scope.selected.records && node) {
        $scope.selected.records.forEach(function (elem) {
          if (record2RecordComparator(node, elem)) {
            selected = true;
          }
        });
      }
      return selected;
    };

    // Restituisce il path sottoforma di array
    $scope.getNodePath = function (node) {
      if (node) {
        var res = treeService.getNodePath(node, {
          nodes: $scope.tree.wrapper.model.nodes
        }, record2RecordComparator, 'nodes');
        if (res && res.length > 1) {
          return res.slice(1); // La root è solo un contenitore senza code e description
        }
      }

      return [];
    };
    $scope.concatFields = function (item) {
      return item.model.code + item.model.description;
    };
    $scope.saveConfigurationOnTree = function (resp) {
      var obj = {
        schemaVersion: resp.schemaVersion,
        schemaCode: resp.schemaCode,
        model: {
          code: resp.model.code,
          description: resp.model.description
        },
        UUID: resp.UUID,
        version: resp.version,
        parents: [],
        nodes: []
      };
      $scope.addNodesToParent($scope.record.parent, obj);
    };
    $scope.updateConfigurationOnTree = function (resp) {
      dialogService.dialog('Configurazione salvata', '', 'success', DEFAULT_DIALOG_TIMEOUT, true);
    };
    $scope.openConfiguration = function () {
      var ref = {};
      if ($scope.selected.treeNode.schemaCode == 'configurazione') {
        /* apertura di uno già esistente */
        pipeConfigurationTree.pushTreeIdToConfig($scope.selected.treeNode.UUID);
      } else {
        /* gestione per un tipo di dato diverso da 'configurazione' */
        if ($scope.record.parent.UUID) {
          /* se ho selezionato un nodo */
          ref = {
            UUID: $scope.selected.treeNode.UUID,
            code: $scope.selected.treeNode.model.code,
            description: $scope.selected.treeNode.model.description
          };
        } else {
          /* se è la root */
          ref = {
            UUID: null,
            code: $scope.selected.treeNode.model.code,
            description: 'Root'
          };
        }
        pipeConfigurationTree.pushTreeObjToConfig(ref);
      }
    };
    $scope.toggleRightSidebarSize = function () {
      $scope.rightSidebarSize = $scope.rightSidebarSize == '50' ? '100' : '50';
    };

    /** ***********************************
     * Check permissions
     * ***********************************/

    var RESOURCE_NAME = 'tree';
    $scope.isWritePermAllowed = function () {
      return authFactory.isWritePermAllowed(RESOURCE_NAME);
    };
    $scope.isDeletePermAllowed = function () {
      return authFactory.isDeletePermAllowed(RESOURCE_NAME);
    };
    $scope.isWriteRecordPermAllowed = function () {
      return authFactory.isWritePermAllowed('record/{entity}');
    };
    $scope.recordsIndexing = function () {
      treeFactory.recordsIndexing({
        param1: $scope.tree.wrapper.UUID
      }).$promise.then(function (resp) {
        dialogService.serviceResponse('Indicizzazione', resp);
      });
    };
    $scope.showIndexRecordsButton = function () {
      return true; // qui visualizzato, nascosto nel nuovo tree
    };

    $scope.showExpandAllButton = function () {
      return true; // qui visualizzato, nascosto nel nuovo tree
    };

    // Route: tree/treeStructureId/id

    $scope.currentCustomer = authFactory.getCurrentCustomer();
    if ($routeParams.id) {
      $scope.getTreeByUUID($routeParams.id);
    } else {
      if ($scope.isCustomerMissing()) {
        dialogService.alert('Selezionare un cliente.', 4000);
      } else {
        $scope.getTree();
      }
    }
    if ($routeParams.treeStructureId) {
      $scope.getTreeStructureByUUID($routeParams.treeStructureId);
    } else {
      if ($scope.isCustomerMissing()) {
        dialogService.alert('Selezionare un cliente.', 4000);
      } else {
        $scope.getTreeStructure();
      }
    }
  }]);

  /**** FILTERS ****/

  app.filter('recordsSearchFilter', function () {
    return function (input, search, destList) {
      if (search) {
        var lower = angular.lowercase(search);
        var output = [];
        input.forEach(function (node) {
          if (angular.isDefined(node.model) && node.model != null) {
            if (angular.lowercase(node.model.code).includes(lower) || angular.lowercase(node.model.description) && angular.lowercase(node.model.description).includes(lower) || angular.lowercase(node.schemaCode).includes(lower)) {
              output.push(node);
            }
          }
        });
        if (destList) {
          destList = output;
        }
        return output;
      } else {
        return input;
      }
    };
  });
})();
'use strict';

angular.module('emma.plan').filter('odlStatus', ["odlWorkflow", function (odlWorkflow) {
  return odlWorkflow.getReadableStatus;
}]).controller('InvoiceOdlPanel', ["ngDialog", "$timeout", "$q", "uiGridConstants", "sixGridPaginationConstants", "authFactory", "odlWorkflow", "odlFactory", "invoiceFactory", function (ngDialog, $timeout, $q, uiGridConstants, sixGridPaginationConstants, authFactory, odlWorkflow, odlFactory, invoiceFactory) {
  var ctrl = this;
  ctrl.odlPanelParams = {
    filters: {}
  };
  ctrl.preselectedItems = [];
  ctrl.statusFilterOptions = [];
  odlWorkflow.getStatuses().then(function (statuses) {
    for (var s in statuses) {
      ctrl.statusFilterOptions.push({
        "value": statuses[s].code,
        "label": statuses[s].label
      });
    }
  });
  ctrl.closePanel = function () {
    angular.element('.odl-panel').removeClass("active");
    var selection = ctrl.odlPanelParams.gridApi.selection.getSelectedRows().map(function (item) {
      return {
        type: item.schemaCode,
        code: item.model.code,
        description: item.model.description,
        UUID: item.UUID,
        customCode: item.model.customCode
      };
    });
    if (angular.isDefined(ctrl.onClose) && typeof ctrl.onClose == "function") {
      ctrl.onClose({
        selection: selection
      });
    }
  };
  function forceSelection(items) {
    if (ctrl.odlPanelGridOptions.data && ctrl.odlPanelGridOptions.data.length) {
      ctrl.odlPanelParams.gridApi.selection.clearSelectedRows();
      var uuids = items ? items.map(function (i) {
        return i.UUID;
      }) : [];
      ctrl.odlPanelGridOptions.data.forEach(function (el) {
        if (uuids.indexOf(el.UUID) !== -1) {
          ctrl.odlPanelParams.gridApi.selection.selectRow(el);
        }
      });
    }
  }
  ctrl.$onChanges = function (changes) {
    if (changes.open && changes.open.currentValue) {
      angular.element('.odl-panel').addClass("active");
      forceSelection(ctrl.preselectedItems);
    }
    if (changes.invoiceExclusions) {
      var prev = Array.isArray(changes.invoiceExclusions.previusValue) ? changes.invoiceExclusions.previusValue : [changes.invoiceExclusions.previusValue];
      var curr = Array.isArray(changes.invoiceExclusions.currentValue) ? changes.invoiceExclusions.currentValue : [changes.invoiceExclusions.currentValue];
      var diff = curr.filter(function (v) {
        return prev.indexOf(v) === -1;
      });
      if (diff.length) {
        buildOdlBlacklist(true).then(ctrl.getOdlList);
      }
    }
    if (changes.odlRefs) {
      //salvo la lista nel caso ci sia un getOdlList successivo al change
      //uso la lista per effettuare la selezione dei dati già visualizzati
      ctrl.preselectedItems = changes.odlRefs.currentValue;
      forceSelection(ctrl.preselectedItems);
    }
  };
  ctrl.odlPanelGridOptions = {
    enablePagination: false,
    enablePaginationControls: false,
    exporterMenuCsv: false,
    appScopeProvider: ctrl,
    multiSelect: true,
    enableHorizontalScrollbar: true,
    isRowSelectable: hasApprovedConsumptive,
    columnDefs: [{
      displayName: 'Codice ODL',
      field: 'model.code',
      width: 150,
      cellClass: cellClass,
      cellTooltip: cellTooltip,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }, {
      name: 'Stato',
      field: 'status',
      width: 100,
      cellClass: cellClass,
      cellTooltip: cellTooltip,
      filterHeaderTemplate: '<div class="ui-grid-filter-container"><a class="block btn btn-default btn-xs" ng-repeat="colFilter in col.filters" ' + 'ng-click="grid.appScope.buildMultiSelectFilter(colFilter)">Filtro</a></div>',
      filters: [{
        type: sixGridPaginationConstants.filterType.SELECTMULTIPLE,
        selectOptions: ctrl.statusFilterOptions,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }],
      cellFilter: 'odlStatus'
    }, {
      displayName: 'Descrizione',
      field: 'model.description',
      width: 150,
      cellClass: cellClass,
      cellTooltip: cellTooltip,
      filters: [{
        type: sixGridPaginationConstants.filterType.TEXT,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }, {
      displayName: 'Data richiesta',
      field: 'date_requested',
      type: 'date',
      cellFilter: 'date:\'dd/MM/yyyy\'',
      width: 100,
      cellClass: cellClass,
      cellTooltip: cellTooltip,
      filters: [{
        type: sixGridPaginationConstants.filterType.DATE,
        relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
        placeholder: 'da...',
        condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
      }, {
        type: sixGridPaginationConstants.filterType.DATE,
        relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
        placeholder: 'a...',
        condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
      }]
    }, {
      displayName: 'Data inizio lavori',
      field: 'date_handling',
      type: 'date',
      cellFilter: 'date:\'dd/MM/yyyy\'',
      width: 100,
      cellClass: cellClass,
      cellTooltip: cellTooltip,
      filters: [{
        type: sixGridPaginationConstants.filterType.DATE,
        relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
        placeholder: 'da...',
        condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
      }, {
        type: sixGridPaginationConstants.filterType.DATE,
        relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
        placeholder: 'a...',
        condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
      }]
    }, {
      displayName: 'Data chiusura',
      field: 'date_closing',
      type: 'date',
      cellFilter: 'date:\'dd/MM/yyyy\'',
      width: 100,
      cellClass: cellClass,
      cellTooltip: cellTooltip,
      enableFiltering: false
    }, {
      displayName: 'Edificio',
      field: 'model.record_id',
      cellFilter: 'reference',
      enableFiltering: true,
      width: 150,
      cellClass: cellClass,
      cellTooltip: cellTooltip,
      filters: [{
        type: sixGridPaginationConstants.filterType.SIXLOOKUP,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }, {
      displayName: 'Servizio',
      field: 'model.service_id',
      cellFilter: 'reference',
      enableFiltering: true,
      width: 150,
      cellClass: cellClass,
      cellTooltip: cellTooltip,
      filters: [{
        type: sixGridPaginationConstants.filterType.SIXLOOKUP,
        condition: uiGridConstants.filter.CONTAINS,
        placeholder: ''
      }]
    }, {
      name: 'Preventivo cliente',
      field: 'customer_estimates',
      enableFiltering: false,
      enableSorting: false,
      width: 150,
      cellClass: cellClass,
      cellTooltip: cellTooltip,
      cellTemplate: '<div class="ui-grid-cell-contents" ng-bind-html="grid.appScope.detectPrice(row.entity.customer_estimates)"></div>'
    }, {
      name: 'Consuntivi',
      field: 'consumptives',
      enableFiltering: false,
      enableSorting: false,
      width: 150,
      cellClass: cellClass,
      cellTooltip: cellTooltip,
      cellTemplate: '<div class="ui-grid-cell-contents" ng-bind-html="grid.appScope.detectPrice(row.entity.consumptives)"></div>'
    }]
  };
  ctrl.odlList = {
    list: []
  };
  ctrl.odlBlacklist = null;
  function filterResult(response) {
    return response.filter(function (record) {
      return angular.isDefined(record.consumptives);
    });
  }
  function buildOdlBlacklist(forceRefresh) {
    if (!ctrl.odlBlacklist || forceRefresh) {
      var payload = {
        page_size: 200,
        show_revision: false
      };
      var invoicefilter = {
        "notrejected": sixFiltersLib.exact("model.status", "false", sixFiltersLib.CONSTRAINTS.ANDNOT),
        "withodl": sixFiltersLib.exists("model.odl_id.UUID")
      };
      if (ctrl.invoiceExclusions) {
        invoicefilter.notblacklisted = sixFiltersLib["in"]("UUID", ctrl.invoiceExclusions, sixFiltersLib.CONSTRAINTS.ANDNOT);
      }
      return invoiceFactory.searchInvoice(payload, invoicefilter).$promise.then(function (data) {
        ctrl.odlBlacklist = data.list.reduce(function (blacklist, invoice) {
          var odl_uuids = invoice.model.odl_id.map(function (odlRef) {
            return odlRef.UUID;
          });
          return blacklist.concat(odl_uuids);
        }, []);
        return ctrl.odlBlacklist;
      });
    } else {
      return $q.resolve(ctrl.odlBlacklist);
    }
  }
  ctrl.getOdlList = function () {
    return buildOdlBlacklist().then(function () {
      var payload = {
        page_size: 200,
        show_revision: false,
        commission: authFactory.getAuthData().info.commissions.current.code,
        enrich: 'dashboard'
      };
      var filters = angular.copy(ctrl.odlPanelParams.filters);
      filters.notblacklisted = sixFiltersLib["in"]("UUID", ctrl.odlBlacklist, sixFiltersLib.CONSTRAINTS.ANDNOT);
      filters.fromissue = sixFiltersLib.exact('generated_by', 'issue');
      return odlFactory().search(payload, filters).$promise.then(function (data) {
        var list = filterResult(data.list);
        ctrl.odlList.totalResults = list.length;
        ctrl.odlList.list = list;
        if (ctrl.odlPanelParams.sixApi) ctrl.odlPanelParams.sixApi.refreshList(list);
        $timeout(function () {
          forceSelection(ctrl.preselectedItems);
        });
        return ctrl.odlList;
      });
    });
  };
  ctrl.buildMultiSelectFilter = function (filter) {
    ngDialog.openConfirm({
      name: 'multiSelectFilterDialog',
      closeByDocument: false,
      showClose: true,
      template: '<div style="text-align:center">Seleziona filtri da attivare</div><br>' + '<label ng-repeat="opt in ngDialogData.selection" class="checkbox i-checks m-t-none m-b-none">' + '<input type="checkbox" ng-model="opt.active"><i></i> {{opt.label}}</label>' + '<div class="row text-center" style="clear: both">' + '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ' + 'ng-click="confirm(ngDialogData.selection)">Applica filtro</button>' + '</div>',
      data: {
        selection: filter.selectOptions
      },
      plain: true,
      className: 'ngdialog-theme-default ngdialog-theme-custom'
    }).then(function (selection) {
      filter.term = selection.filter(function (i) {
        return i.active;
      }).map(function (i) {
        return i.value;
      });
    });
  };
  ctrl.detectPrice = function (list) {
    var approved_status = 'approved';
    if (typeof list == 'undefined' || list.length == 0) {
      return '';
    }
    var content = '<span class="badge primary pull-right">' + list.length + '</span>';
    if (list.length == 1) {
      var status = list[0].model.status == approved_status ? '<i class="fa fa-check"></i> ' : '';
      content += status + formatPrice(list[0].model.total);
    } else {
      //cerco il primo approvato
      list.forEach(function (item) {
        if (item.model.status == approved_status) {
          var status = '<i class="fa fa-check"></i> ';
          content += status + formatPrice(item.model.total);
          return; //termino il foreach
        }
      });
    }

    return content;
  };
  function formatPrice(num) {
    if (num) {
      num = Math.round(num * 100) / 100;
      num = num.toFixed(2);
    }
    return num ? num.toString().replace(/\./g, ',') + ' €' : '--';
  }
  function hasApprovedConsumptive(row) {
    if (row.entity.consumptives && row.entity.consumptives.length) {
      return row.entity.consumptives.filter(function (i) {
        return i.model.status == 'approved';
      }).length == 1;
    }
    return false;
  }
  function cellClass(grid, row) {
    if (!hasApprovedConsumptive(row)) {
      return 'red-highlight';
    }
  }
  function cellTooltip(row) {
    if (!row.entity.consumptives || row.entity.consumptives.length == 0) {
      return 'L\'ODL non ha un consuntivo approvato';
    }
    var approved = row.entity.consumptives.filter(function (i) {
      return i.model.status == 'approved' && i.model.type != "supplier";
    });
    if (approved.length == 0) {
      return 'L\'ODL non ha un consuntivo approvato';
    }
    if (approved.length > 1) {
      return 'L\'ODL ha più di un consuntivo approvato';
    }
  }
}]).component('invoiceOdlPanel', {
  controller: 'InvoiceOdlPanel',
  templateUrl: 'plan/invoice/components/odl_panel.html',
  restrict: 'E',
  bindings: {
    invoiceExclusions: '<',
    //fatture da escludere nella generazione dalla blacklist per gli odl
    odlRefs: '<',
    //elenco odl selezionati
    open: '<',
    //stato di apertura del pannello, "watchata" per permettere l'apertura dall'esterno
    onClose: '&' //triggerata alla chiusura del pannello
  }
});
'use strict';

angular.module('emma.plan').controller('lookupModalCtrl', ['$scope', '$timeout', 'recordFactory', 'schemaFactory', 'dialogService', 'treeUtilities', function ($scope, $timeout, recordFactory, schemaFactory, dialogService, treeUtilities) {
  if (angular.isUndefined($scope.sxRow)) {
    $scope.sxRow = {};
  }
  if (angular.isUndefined($scope.sxField)) {
    $scope.sxField = '';
  }
  if (angular.isUndefined($scope.sxUseRef)) {
    $scope.sxUseRef = true;
  }
  var asset = $scope.sxField.split('.').reduce(function (obj, current) {
    return obj && obj[current] ? obj[current] : null;
  }, $scope.sxRow);
  $scope.forcedType = false;
  if (angular.isDefined($scope.sxType)) {
    $scope.forcedType = true;
    $scope.type = buildSchemaRef($scope.sxType);
  } else {
    if (asset && asset.schemaCode) {
      $scope.type = buildSchemaRef(asset.schemaCode);
    } else {
      $scope.type = {};
    }
  }
  $scope.typeIdFilter = null;
  treeUtilities.getFlatStructureUuids().then(function (types) {
    if (types) {
      $scope.typeIdFilter = {
        'typeIdFilter': sixFiltersLib["in"]('UUID', types)
      };
    }
  });
  $scope.confirm = function (schema, assetRef, fullAsset) {
    var path = $scope.sxField.split('.');
    var asset = $scope.sxRow;
    for (var p = 0; p < path.length - 1; p++) {
      asset = asset[path[p]];
    }
    if ($scope.sxUseRef) {
      asset[path[p]] = assetRef;
    } else {
      asset[path[p]] = fullAsset;
    }
    $scope.dialogRef.close();
  };
  $scope.cancel = function () {
    $scope.dialogRef.close();
  };
  var dialogScope = {
    asset: getReference(asset),
    fullAsset: asset,
    schema: $scope.type,
    typeIdFilter: $scope.typeIdFilter,
    forcedType: $scope.forcedType,
    confirm: $scope.confirm,
    cancel: $scope.cancel
  };
  var opts = {
    name: 'lookupModalTemplate',
    closeByDocument: false,
    plain: false,
    preCloseCallback: function preCloseCallback(value) {
      $scope.$emit('uiGridEventEndCellEdit');
    }
  };
  $scope.dialogRef = dialogService.templateDialog('lookupModalTemplate.html', null, dialogScope, opts, -1, false);
  function getReference(asset) {
    if (asset && asset.model) {
      return {
        UUID: asset.UUID,
        type: asset.schemaCode,
        code: asset.model.code,
        description: asset.model.description
      };
    } else {
      return asset;
    }
  }
  function buildSchemaRef(schemaCode) {
    //per semplicità creo un mock della reference, idealmente sarebbe meglio chiedere al server la ref per lo schemaCode indicato
    if (schemaCode) {
      return {
        UUID: schemaCode,
        type: 'schema',
        code: schemaCode,
        description: schemaCode
      };
    }
  }
}]);

/**
 * @ngdoc directive
 * @name sixEmmaApp.directive:lookupModal
 * @description
 * # lookupModal
 */
angular.module('emma.plan').directive('lookupModal', function () {
  return {
    templateUrl: 'plan/invoice/directives/lookupmodal.html',
    restrict: 'E',
    scope: {
      sxRow: '=',
      sxField: '@',
      sxType: '@?',
      sxUseRef: '=?'
    },
    controller: 'lookupModalCtrl'
  };
});
/**
 * Created by luca on 15/03/17.
 */

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:IssuePortalCtrl
 * @description
 * # IssuePortalCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/portal/issue', {
    templateUrl: 'plan/portal/issue/issue_list.html',
    controller: 'IssuePortalCtrl'
  }).when('/portal/issue/:id', {
    templateUrl: 'plan/portal/issue/issue_detail.html',
    controller: 'IssuePortalCtrl'
  });
}]).controller('IssuePortalCtrl', ["$scope", "authFactory", "$routeParams", "$log", "localStorageService", "issueFactory", "$location", "toaster", "sixGridPaginationConstants", "uiGridConstants", "$route", "recordFactory", "errorService", "ngDialog", "issueWorkflow", function ($scope, authFactory, $routeParams, $log, localStorageService, issueFactory, $location, toaster, sixGridPaginationConstants, uiGridConstants, $route, recordFactory, errorService, ngDialog, issueWorkflow) {
  /**** CONSTANTS ****/

  var PATH_ISSUE_RECORD = 'issue/record';
  $scope.queryParam = '';
  $scope.issueList = {};
  $scope.params = {
    pageNumber: 1,
    pageSize: 100,
    totalItems: 0,
    filters: {}
  };
  $scope.autoResizeParams = {
    enabled: true,
    minHeight: 200,
    marginTop: 290
  };
  $scope.gridAppCallbacks = {};
  $scope.gridAppCallbacks['getReadableStatus'] = issueWorkflow.getReadableStatus;
  $scope.gridAppCallbacks['getReadableUser'] = getReadableUser;
  $scope.gridAppCallbacks['buildMultiSelectFilter'] = buildMultiSelectFilter;
  $scope.viewGridOptions = {
    enableSorting: true,
    enableGridMenu: true,
    exporterCsvColumnSeparator: ';',
    exporterSuppressColumns: ['id', 'timeline'],
    exporterMenuPdf: false,
    enableFiltering: true,
    enableColumnResizing: true,
    paginationPageSizes: [10, 100, 250, 500, 1000, 10000],
    paginationPageSize: 100,
    useExternalPagination: true,
    useExternalFiltering: true,
    multiSelect: true,
    enableRowHeaderSelection: true,
    enableRowSelection: true,
    enableHorizontalScrollbar: 1,
    columnDefs: [{
      name: ' '
    }]
  };

  /*** PARTE GRID ***/

  function getColumnOrDefault() {
    issueWorkflow.getStatuses().then(function (statuses) {
      var statusOptions = [];
      for (var s in statuses) {
        statusOptions.push({
          "value": statuses[s].code,
          "label": statuses[s].label
        });
      }
      $scope.viewGridOptions.columnDefs = [];
      $scope.viewGridOptions.columnDefs.push({
        displayName: '',
        field: 'id',
        width: 36,
        enableCellEdit: true,
        enableFiltering: false,
        enableSorting: false,
        pinnedLeft: true,
        cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#/portal/issue/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' + '<span class="fa fa-search"></span>' + '</a>' + '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Codice',
        field: 'model.code',
        enableFiltering: true,
        pinnedLeft: true,
        width: 120,
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Tipo asset',
        field: 'model.type_id.description',
        enableFiltering: true,
        width: 150,
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Asset',
        field: 'model.record_id',
        enableFiltering: true,
        width: 250,
        cellTemplate: '<div class="ui-grid-cell ui-grid-cell-contents"><span ng-if="grid.getCellValue(row, col)">{{grid.getCellValue(row, col).description}} - {{grid.getCellValue(row, col).code}}</span></div>',
        filters: [{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          //exact o contains non funziona comunque, colpa del lowercase da qualche parte...
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Oggetto',
        field: 'model.description',
        enableFiltering: true,
        width: 500,
        cellTooltip: function cellTooltip(row) {
          return row.entity.model.description;
        },
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          //exact o contains non funziona comunque, colpa del lowercase da qualche parte...
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Note',
        field: 'model.note',
        enableFiltering: true,
        width: 300,
        cellTooltip: function cellTooltip(row) {
          return row.entity.model.note;
        },
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          //exact o contains non funziona comunque, colpa del lowercase da qualche parte...
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Stato',
        field: 'status',
        enableFiltering: true,
        width: 100,
        filterHeaderTemplate: '<div class="ui-grid-filter-container"><a class="block btn btn-default btn-xs" ng-repeat="colFilter in col.filters" ' + 'ng-click="grid.appScope.buildMultiSelectFilter(colFilter)">Filtro</a></div>',
        filters: [{
          type: sixGridPaginationConstants.filterType.SELECTMULTIPLE,
          selectOptions: statusOptions,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }],
        cellTemplate: '<div class="ui-grid-cell-contents" style="vertical-align:middle;">' + '{{grid.appScope.getReadableStatus(row.entity.status)}}' + '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data Inserimento',
        field: 'date_insertion',
        cellFilter: 'date:\'dd/MM/yyyy\'',
        enableFiltering: true,
        width: 100,
        filters: [{
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
          placeholder: 'da...',
          condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
        }, {
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
          placeholder: 'a...',
          condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data richiesta',
        field: 'date_requested',
        cellFilter: 'date:\'dd/MM/yyyy\'',
        enableFiltering: true,
        width: 100,
        filters: [{
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
          placeholder: 'da...',
          condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
        }, {
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
          placeholder: 'a...',
          condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data presa in carico',
        field: 'date_handling',
        cellFilter: 'date:\'dd/MM/yyyy\'',
        enableFiltering: true,
        width: 100,
        filters: [{
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
          placeholder: 'da...',
          condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
        }, {
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
          placeholder: 'a...',
          condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data chiusura',
        field: 'date_closing',
        cellFilter: 'date:\'dd/MM/yyyy\'',
        enableFiltering: true,
        width: 100,
        filters: [{
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
          placeholder: 'da...',
          condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
        }, {
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
          placeholder: 'a...',
          condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Richiedente',
        field: 'reporter_id',
        cellTemplate: '<div class="ui-grid-cell ui-grid-cell-contents"><span ng-if="grid.getCellValue(row, col)">{{grid.getCellValue(row, col).description}} ({{grid.getCellValue(row, col).code}})</span></div>',
        enableFiltering: true,
        width: 150,
        filters: [{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Utente',
        field: 'user',
        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope">{{grid.appScope.getReadableUser(row.entity)}}</div>',
        enableFiltering: true,
        width: 200,
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
    });
  }
  function buildMultiSelectFilter(filter) {
    var options = '';
    filter.selectOptions.forEach(function (val, key) {
      options += '<label class="checkbox i-checks m-t-none m-b-none"><input type="checkbox" ' + 'ng-model="ngDialogData.selection[' + key + '].active"><i></i> ' + val.label + '</label>';
    });
    if (Array.isArray(filter.term)) {
      filter.term.forEach(function (term) {
        filter.selectOptions.forEach(function (v, k, opt) {
          if (v.value == term) opt[k].active = true;
        });
      });
    }
    ngDialog.openConfirm({
      name: 'multiSelectFilterDialog',
      closeByDocument: false,
      showClose: true,
      template: '' + '<div style="text-align:center">Seleziona filtri da attivare ' + '</div><br>' + '' + options + '' + '<div class="row" style="text-align:center; clear: both">' + '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ' + 'ng-click="confirm(ngDialogData.selection)">Applica filtro</button>' + '</div>',
      data: {
        selection: filter.selectOptions
      },
      plain: true,
      className: 'ngdialog-theme-default ngdialog-theme-custom'
    }).then(function (selection) {
      filter.term = [];
      selection.forEach(function (sel) {
        if (sel.active) {
          filter.term.push(sel.value);
        }
      });
    });
  }
  function getReadableUser(issue) {
    if (issue.userinfo) {
      return issue.userinfo.description;
    } else {
      return issue.user;
    }
  }

  /*** PARTE ISSUE ***/
  var PORTAL_ISSUE_GENERIC = '/portal/issue';
  var PORTAL_ISSUE_NEW = '/portal/issue/new';
  $scope.newIssue = function () {
    $location.path(PORTAL_ISSUE_NEW);
  };
  $scope.refresh = function () {
    // $route.reload();
    $scope.getCurrentUserIssueList();
  };
  var OPERATOR_NOT_FOUND_ERR_SHOWN = false;
  $scope.getCurrentUserOperator = function () {
    $scope.currentUserOperator = undefined;
    var currentUser = authFactory.getAuthData().authId;
    var filters = {};
    filters['model.username'] = {
      type: '_exact',
      key: 'model.username',
      value: currentUser
    };
    return recordFactory('operatore').search({
      page_size: 1,
      show_revision: false
    }, filters).$promise.then(function (data) {
      $scope.currentUserOperator = data.list[0];
    })["catch"](function (response) {
      if (!OPERATOR_NOT_FOUND_ERR_SHOWN) {
        toaster.pop('error', 'Errore', 'Operatore corrispondente all\'utente \'' + currentUser + '\' non trovato');
        OPERATOR_NOT_FOUND_ERR_SHOWN = true;
      }
    })["finally"](function (response) {
      return $scope.currentUserOperator;
    });
  };
  $scope.getCurrentUserIssueList = function () {
    if (!$scope.currentUserOperator || !$scope.currentUserOperator.UUID) {
      return $scope.getCurrentUserOperator().then(function (operator) {
        return $scope.getIssueList();
      });
    } else {
      return $scope.getIssueList();
    }
  };
  $scope.getIssueList = function () {
    var filters = angular.copy($scope.params.filters);
    if ($scope.currentUserOperator && $scope.currentUserOperator.UUID && !$scope.bool.allIssues) {
      filters['user'] = sixFiltersLib.exact('user', $scope.currentUserOperator.model.username, sixFiltersLib.CONSTRAINTS.OR);
      filters['supervisorExternal_id'] = sixFiltersLib.exact('references_assignee.supervisorExternal_id.UUID', $scope.currentUserOperator.UUID, sixFiltersLib.CONSTRAINTS.OR);
      filters['secretariat_id'] = sixFiltersLib.exact('references_assignee.secretariat_id.UUID', $scope.currentUserOperator.UUID, sixFiltersLib.CONSTRAINTS.OR);
      filters['activityReferer_id'] = sixFiltersLib.exact('references_assignee.activityReferer_id.UUID', $scope.currentUserOperator.UUID, sixFiltersLib.CONSTRAINTS.OR);
      filters['reporter_id'] = sixFiltersLib.exact('references_assignee.reporter_id.UUID', $scope.currentUserOperator.UUID, sixFiltersLib.CONSTRAINTS.OR);
    }
    var payload = {
      query: $scope.queryParam,
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      sort_fields: $scope.params.sortFields,
      show_revision: false
    };
    return issueFactory(PATH_ISSUE_RECORD).search(payload, filters).$promise.then(function (data) {
      $scope.params.totalItems = data.totalResults;
      $scope.viewGridOptions.totalItems = data.totalResults;
      $scope.issueList.totalResults = data.totalResults;
      $scope.issueList.list = data.list;
      $scope.params.sixApi.refreshList(data.list);
      return data;
    });
  };
  $scope.getSelectedRows = function () {
    var api = $scope.params.gridApi;
    if (api && api.selection) {
      return api.selection.getSelectedRows();
    } else {
      return [];
    }
  };
  $scope.deleteIssueSelected = function () {
    var rows = $scope.getSelectedRows();
    rows.forEach(function (val, i) {
      rows[i] = val.version;
    });
    issueFactory(PATH_ISSUE_RECORD).bulkDeleteIssue(rows).$promise.then(function (data) {
      $scope.refresh();
    });
  };

  /*** PARTE CONFIGURAZIONE ***/

  $scope.toggleAllIssues = function () {
    $scope.bool.allIssues = !$scope.bool.allIssues;
    localStorageService.set('portal_issue_bool', $scope.bool);
    $scope.refresh();
  };

  /*** PARTE INIZIALIZZAZIONE DELLA PAGINA  ***/

  if ($routeParams.id) {
    $scope.issueId = $routeParams.id;
  } else {
    getColumnOrDefault();
    setTimeout(function () {
      if ($scope.params.sixApi) {
        $scope.params.sixApi.restoreState();
      }
    }, 500);
  }

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'issue/record';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
  $scope.searchAllPermAllowed = function () {
    return authFactory.checkPerm(RESOURCE_NAME, 'SEARCH_ALL');
  };
  if (localStorageService.get('portal_issue_bool')) {
    $scope.bool = localStorageService.get('portal_issue_bool');
    $scope.bool.allIssues = $scope.bool.allIssues && $scope.searchAllPermAllowed();
  } else {
    $scope.bool = {
      allIssues: $scope.searchAllPermAllowed()
    };
  }
}]);
/**
 * Created by luca on 16/03/17.
 */

'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:OdlPortalCtrl
 * @description
 * # OdlPortalCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').config(["$routeProvider", function ($routeProvider) {
  $routeProvider.when('/portal/odl', {
    templateUrl: 'plan/portal/odl/odl_list.html',
    controller: 'OdlPortalCtrl'
  }).when('/portal/odl/:id', {
    templateUrl: 'plan/portal/odl/odl_detail.html',
    controller: 'OdlPortalCtrl'
  });
}]).controller('OdlPortalCtrl', ["$scope", "modelFactory", "authFactory", "odlFactory", "$routeParams", "$log", "$window", "errorService", "localStorageService", "modelIconService", "$location", "treePlanConfigFactory", "taskFactory", "issueFactory", "lookupFactory", "dialogService", "ngDialog", "toaster", "$filter", "issueToOdl", "uiGridConstants", "$timeout", "$route", "counterFactory", "userFactory", "recordFactory", "$q", "odlWorkflow", "$http", "APP_URL", "SaveAs", "sixGridPaginationConstants", function ($scope, modelFactory, authFactory, odlFactory, $routeParams, $log, $window, errorService, localStorageService, modelIconService, $location, treePlanConfigFactory, taskFactory, issueFactory, lookupFactory, dialogService, ngDialog, toaster, $filter, issueToOdl, uiGridConstants, $timeout, $route, counterFactory, userFactory, recordFactory, $q, odlWorkflow, $http, APP_URL, SaveAs, sixGridPaginationConstants) {
  /**** CONSTANTS ****/

  var currentCommission = authFactory.getAuthData().info.commissions.current;
  $scope.counterNameOdl = 'odl';
  $scope.odlRef = null;
  $scope.queryParam = '';
  $scope.uiGridFiltersQuery = '';
  $scope.loadingSixMail = true;
  $scope.commissionDependent = true;
  $scope.schemaOdlDefined = false;
  $scope.typeName = 'odl';
  $scope.issue = {}; /* ci salvo tutto il dato della segnalazione a cui faccio riferimento */
  $scope.issueDisplayConfig = {
    'mode': 'portal',
    'tabs': [{
      'component': 'ictIssue',
      'config': {
        'mode': 'basic',
        'showWatchers': false,
        'showAssignee': true
      }
    }, 'ictAttachments', 'ictQrcode', 'ictNotification'],
    'fullPage': false
  };
  $scope.popupRequested = {
    opened: false
  };
  $scope.odlList = {
    list: []
  };
  $scope.params = {
    pageNumber: 1,
    pageSize: 100,
    filters: {}
  };
  $scope.autoResizeParams = {
    enabled: true,
    minHeight: 200,
    marginTop: 290
  };

  // Gestione allegati
  $scope.attachments = [];
  function readAttachments(modelList) {
    $scope.attachments.splice(0, $scope.attachments.length);
    for (var i = 0; i < modelList.length; i++) {
      $scope.attachments.push(modelList[i]);
    }
  }
  function writeAttachments(modelList) {
    modelList.splice(0, modelList.length);
    for (var i = 0; i < $scope.attachments.length; i++) {
      modelList.push($scope.attachments[i]);
    }
  }

  /**  VARIABILI  **/

  $scope.bool_watch_internal = true;
  $scope.bool_watch_external = false;
  $scope.watcher = {
    user: '',
    mail: ''
  };
  $scope.issueRefreshed = {
    bool: false,
    filter: {}
  };
  $scope.init = true; // per prima inizializzazione controller (altrimenti si incasina la watch su $scope.data.model.type_id che pulisce $scope.data.model.record_id)

  /*** PARTE ODL ***/

  var now = new Date();
  $scope.data = {
    status: 'OPEN',
    generated_by: 'issue',
    issue_id: undefined,
    // riferimento alla segnalazione: type, UUID, code, description
    date_insertion: now,
    date_requested: now,
    // data richiesta: ??? non so se tenerla così o se metterla a null ???
    date_handling: undefined,
    // ??? non so se tenerla così o se metterla a null ???
    date_closing: undefined,
    // data chiusura
    references_assignee: {
      // oggetto per contenere i riferimenti a: tecnici, assegnatari, fornitore...
      supplier_id: undefined,
      // Fornitore
      company_id: undefined,
      // Azienda assegnataria
      headmanCommission_id: undefined,
      // Capo commessa
      technicianCommission_id: [],
      // Tecnico di commessa
      maintainer_id: [],
      // Manutentori
      supervisorExternal_id: undefined,
      // Responsabile esterno
      supervisorInternal_id: undefined // Responsabile interno
    },

    watchers: {
      external: [],
      internal: []
    },
    model: {
      attachments: []
    }
  };

  /** VARIABILI FILTRAGGIO LOOK UP */
  var typeoperatorFilterField = 'model.typeoperator_map.' + currentCommission.code + '.code';
  var typeoperatorFallbackFilterField = 'model.typeoperator_map.tutte.code';
  $scope.technicianCommissionFilter = {
    'typeoperator_map': sixFiltersLib.must({
      "specific": sixFiltersLib.should({
        "match_specific": sixFiltersLib.exact(typeoperatorFilterField, 'tecnico_commessa')
      }),
      "fallback": sixFiltersLib.should({
        "miss_specific": sixFiltersLib.missing(typeoperatorFilterField),
        "match_fallback": sixFiltersLib.exact(typeoperatorFallbackFilterField, 'tecnico_commessa')
      })
    })
  };
  $scope.headmanCommissionFilter = {
    'typeoperator_map': sixFiltersLib.must({
      "specific": sixFiltersLib.should({
        "match_specific": sixFiltersLib.exact(typeoperatorFilterField, 'capo_commessa')
      }),
      "fallback": sixFiltersLib.should({
        "miss_specific": sixFiltersLib.missing(typeoperatorFilterField),
        "match_fallback": sixFiltersLib.exact(typeoperatorFallbackFilterField, 'capo_commessa')
      })
    })
  };
  $scope.supervisorExternalFilter = {
    'typeoperator_map': sixFiltersLib.must({
      "specific": sixFiltersLib.should({
        "match_specific": sixFiltersLib.exact(typeoperatorFilterField, 'tecnico_esterno')
      }),
      "fallback": sixFiltersLib.should({
        "miss_specific": sixFiltersLib.missing(typeoperatorFilterField),
        "match_fallback": sixFiltersLib.exact(typeoperatorFallbackFilterField, 'tecnico_esterno')
      })
    })
  };
  $scope.supervisorInternalFilter = angular.copy($scope.technicianCommissionFilter);
  $scope.maintainerFilter = {
    'typeoperator_map': sixFiltersLib.must({
      "specific": sixFiltersLib.should({
        "match_specific": sixFiltersLib.exact(typeoperatorFilterField, 'manutentore')
      }),
      "fallback": sixFiltersLib.should({
        "miss_specific": sixFiltersLib.missing(typeoperatorFilterField),
        "match_fallback": sixFiltersLib.exact(typeoperatorFallbackFilterField, 'manutentore')
      })
    })
  };
  $scope.companyFilter = {};
  $scope.supplierFilter = {};
  $scope.gridAppCallbacks = {};
  $scope.gridAppCallbacks['getReadableStatus'] = odlWorkflow.getReadableStatus;
  $scope.gridAppCallbacks['getReadableType'] = getReadableType;
  $scope.gridAppCallbacks['getReadableUser'] = getReadableUser;
  $scope.gridAppCallbacks['buildMultiSelectFilter'] = buildMultiSelectFilter;
  $scope.viewGridOptions = {
    enableSorting: true,
    enableGridMenu: true,
    exporterCsvColumnSeparator: ';',
    exporterSuppressColumns: ['id', 'timeline'],
    exporterMenuPdf: false,
    enableFiltering: true,
    enableColumnResizing: true,
    paginationPageSizes: [100, 250, 500, 1000, 10000],
    paginationPageSize: 100,
    useExternalPagination: true,
    useExternalFiltering: true,
    multiSelect: true,
    enableRowHeaderSelection: true,
    enableRowSelection: true,
    enableHorizontalScrollbar: 1,
    columnDefs: [{
      name: ' '
    }]
  };
  $scope.odlWorkflow = odlWorkflow;
  $scope.newOdl = function () {
    $location.path('/portal/odl/new');
  };
  $scope.refresh = function () {
    $scope.getCurrentUserOdlList();
  };
  $scope.goToOdlList = function () {
    $location.path('/portal/odl');
  };
  $scope.goToIssue = function () {
    $location.path('/portal/issue/' + $scope.data.issue_id.UUID);
  };
  $scope.openRequestedPicker = function () {
    $scope.popupRequested.opened = true;
  };
  $scope.getColumns = function () {
    getColumnOrDefault();
    return $scope.columnDefs;
  };
  function hidrateColumnDef(col) {
    var property = $scope.schema.properties[col.field];
    if (property.check && property.check == true) {
      var hidrated = {
        displayName: property.title,
        field: 'model.' + col.field,
        enableFiltering: true,
        width: 100
      };
      if (property.type == 'string') {
        hidrated.filters = [{
          type: 'text',
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }];
      }
      // template per le colonne in base al loro tipo
      if (property.type == 'string') {
        hidrated.cellTemplate = '<div class="ui-grid-cell-contents cont-left">{{ row.entity.model[\'' + col.field + '\'] }}</div>';
      }
      if (property.type == 'number' || property.type == 'integer') {
        hidrated.cellTemplate = '<div class="ui-grid-cell-contents cont-right">{{ row.entity.model[\'' + col.field + '\'] }}</div>';
      }
      if (property.format && property.format == 'date') {
        hidrated.cellTemplate = '<div class="ui-grid-cell-contents cont-center">{{ row.entity.model[\'' + col.field + '\'] | date: \'dd/MM/yyyy\' }}</div>';
      }
      if (property.format && property.format == 'lookup') {
        hidrated.cellTemplate = '<div class="ui-grid-cell-contents cont-center">{{ row.entity.model[\'' + col.field + '\'] | reference }}</div>';
      }
      return hidrated;
    }
  }
  function getColumnOrDefault() {
    var requirementPromises = [odlWorkflow.getStatuses()];
    if (!$scope.schemaOdlDefined) {
      requirementPromises.push(getSchemaOdl());
    }
    $q.all(requirementPromises).then(function (requirements) {
      var statuses = requirements[0];
      var statusOptions = [];
      for (var s in statuses) {
        statusOptions.push({
          "value": statuses[s].code,
          "label": statuses[s].label
        });
      }
      $scope.viewGridOptions.columnDefs = [];
      $scope.viewGridOptions.columnDefs.push({
        displayName: '',
        field: 'id',
        width: 36,
        enableCellEdit: true,
        enableFiltering: false,
        enableSorting: false,
        pinnedLeft: true,
        cellTemplate: '<div class="ui-grid-cell-contents" style="text-align: center">' + '<a ng-href="#portal/odl/{{row.entity.UUID}}" class="btn btn-xs btn-primary">' + '<span class="fa fa-search"></span>' + '</a>' + '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Codice',
        field: 'model.code',
        enableFiltering: true,
        pinnedLeft: true,
        width: 120,
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Tipo asset',
        field: 'model.type_id.description',
        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope">{{row.entity.model.type_id.description}} - {{row.entity.model.type_id.code}}</div>',
        enableFiltering: true,
        width: 150,
        filters: [{
          type: 'text',
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Asset',
        field: 'model.record_id.description',
        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope">{{row.entity.model.record_id.description}} - {{row.entity.model.record_id.code}}</div>',
        enableFiltering: true,
        width: 150,
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          //exact o contains non funziona comunque, colpa del lowercase da qualche parte...
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Servizio',
        field: 'model.service_id',
        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope">{{row.entity.model.service_id.description}} - {{row.entity.model.service_id.code}}</div>',
        enableFiltering: true,
        width: 150,
        filters: [{
          type: sixGridPaginationConstants.filterType.SIXLOOKUP,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Oggetto',
        field: 'model.description',
        enableFiltering: true,
        width: 500,
        cellTooltip: function cellTooltip(row) {
          return row.entity.model.description;
        },
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Note',
        field: 'model.note',
        enableFiltering: true,
        width: 500,
        cellTooltip: function cellTooltip(row) {
          return row.entity.model.note;
        },
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      //--- campi dinamici da model
      //blacklist delle colonne già visibili
      var hardcodedCols = ["code", "title", "type_id", "record_id", "note", "service_id", "description", "generation_tag"];
      var filteredCols = $scope.columnDefs.filter(function (col) {
        return hardcodedCols.indexOf(col.field) == -1;
      }).map(hidrateColumnDef);
      $scope.viewGridOptions.columnDefs = $scope.viewGridOptions.columnDefs.concat(filteredCols);
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Stato',
        field: 'status',
        enableFiltering: true,
        width: 100,
        filterHeaderTemplate: '<div class="ui-grid-filter-container"><a class="block btn btn-default btn-xs" ng-repeat="colFilter in col.filters" ' + 'ng-click="grid.appScope.buildMultiSelectFilter(colFilter)">Filtro</a></div>',
        filters: [{
          type: sixGridPaginationConstants.filterType.SELECTMULTIPLE,
          selectOptions: statusOptions,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }],
        cellTemplate: '<div class="ui-grid-cell-contents" style="vertical-align:middle;">' + '{{grid.appScope.getReadableStatus(row.entity.status)}}' + '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data generazione',
        field: 'dataIn',
        type: 'date',
        cellFilter: 'date:\'dd/MM/yyyy\'',
        width: 100,
        enableFiltering: true,
        filters: [{
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
          placeholder: 'da...',
          condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
        }, {
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
          placeholder: 'a...',
          condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Data pianifica',
        field: 'date_requested',
        type: 'date',
        cellFilter: 'date:\'dd/MM/yyyy\'',
        width: 100,
        enableFiltering: true,
        filters: [{
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.GREATER_THAN_OR_EQUAL,
          placeholder: 'da...',
          condition: uiGridConstants.filter.GREATER_THAN_OR_EQUAL
        }, {
          type: sixGridPaginationConstants.filterType.DATE,
          relation: sixGridPaginationConstants.filterRel.LESS_THAN_OR_EQUAL,
          placeholder: 'a...',
          condition: uiGridConstants.filter.LESS_THAN_OR_EQUAL
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Utente generazione',
        field: 'user',
        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope">{{grid.appScope.getReadableUser(row.entity)}}</div>',
        enableFiltering: true,
        width: 200,
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Codice generazione programmata',
        field: 'model.generation_tag',
        enableFiltering: true,
        width: 150,
        filters: [{
          type: sixGridPaginationConstants.filterType.TEXT,
          condition: uiGridConstants.filter.CONTAINS,
          placeholder: ''
        }]
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Sorgente',
        field: 'generated_by',
        width: 150,
        enableFiltering: true,
        filters: [{
          type: sixGridPaginationConstants.filterType.SELECT,
          condition: uiGridConstants.filter.CONTAINS,
          selectOptions: [{
            value: 'issue',
            label: 'Segnalazione'
          }, {
            value: 'plan',
            label: 'Programmata'
          }],
          placeholder: ''
        }],
        cellTemplate: '<div class="ui-grid-cell-contents" style="vertical-align:middle;">' + '{{grid.appScope.getReadableType(row.entity.generated_by)}}' + '</div>'
      });
      $scope.viewGridOptions.columnDefs.push({
        displayName: 'Timeline',
        field: 'timeline',
        width: 106,
        enableCellEdit: false,
        enableFiltering: false,
        enableSorting: false,
        cellTemplate: '<div class="ui-grid-cell-contents" style="vertical-align:middle;text-align:center;">' + '<a ng-href="#/timeline/odl/record/{{row.entity.UUID}}">' + '<button type="button" class="btn btn-xs btn-primary">' + '<i class="fa fa-history"></i>' + '</button>' + '</a>' + '</div>'
      });
    });
  }
  function buildMultiSelectFilter(filter) {
    var options = '';
    filter.selectOptions.forEach(function (val, key) {
      options += '<label class="checkbox i-checks m-t-none m-b-none"><input type="checkbox" ' + 'ng-model="ngDialogData.selection[' + key + '].active"><i></i> ' + val.label + '</label>';
    });
    if (Array.isArray(filter.term)) {
      filter.term.forEach(function (term) {
        filter.selectOptions.forEach(function (v, k, opt) {
          if (v.value == term) opt[k].active = true;
        });
      });
    }
    ngDialog.openConfirm({
      name: 'multiSelectFilterDialog',
      closeByDocument: false,
      showClose: true,
      template: '' + '<div style="text-align:center">Seleziona filtri da attivare ' + '</div><br>' + '' + options + '' + '<div class="row" style="text-align:center; clear: both">' + '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ' + 'ng-click="confirm(ngDialogData.selection)">Applica filtro</button>' + '</div>',
      data: {
        selection: filter.selectOptions
      },
      plain: true,
      className: 'ngdialog-theme-default ngdialog-theme-custom'
    }).then(function (selection) {
      filter.term = [];
      selection.forEach(function (sel) {
        if (sel.active) {
          filter.term.push(sel.value);
        }
      });
    });
  }
  var OPERATOR_NOT_FOUND_ERR_SHOWN = false;
  $scope.getCurrentUserOperator = function () {
    $scope.currentUserOperator = undefined;
    var currentUser = authFactory.getAuthData().authId;
    var filters = {};
    filters['model.username'] = {
      type: '_exact',
      key: 'model.username',
      value: currentUser
    };
    return recordFactory('operatore').search({
      page_size: 1,
      show_revision: false
    }, filters).$promise.then(function (data) {
      $scope.currentUserOperator = data.list[0];
    })["catch"](function (response) {
      if (!OPERATOR_NOT_FOUND_ERR_SHOWN) {
        toaster.pop('error', 'Errore', 'Operatore corrispondente all\'utente \'' + currentUser + '\' non trovato');
        OPERATOR_NOT_FOUND_ERR_SHOWN = true;
      }
    })["finally"](function (response) {
      return $scope.currentUserOperator;
    });
  };
  $scope.getCurrentUserOdlList = function () {
    if (!$scope.currentUserOperator || !$scope.currentUserOperator.UUID) {
      return $scope.getCurrentUserOperator().then(function (operator) {
        return $scope.getOdlList();
      });
    } else {
      return $scope.getOdlList();
    }
  };
  $scope.getOdlList = function () {
    var filters = angular.copy($scope.params.filters);
    if ($scope.currentUserOperator && $scope.currentUserOperator.UUID && !$scope.bool.allOdl) {
      filters['user'] = sixFiltersLib.exact('user', $scope.currentUserOperator.model.username);
      filters['headmanCommission_id'] = sixFiltersLib.exact('references_assignee.headmanCommission_id.UUID', $scope.currentUserOperator.UUID, sixFiltersLib.CONSTRAINTS.OR);
      filters['technicianCommission_id'] = sixFiltersLib["in"]('references_assignee.technicianCommission_id', [$scope.currentUserOperator.UUID], sixFiltersLib.CONSTRAINTS.OR);
      filters['maintainer_id'] = sixFiltersLib["in"]('references_assignee.maintainer_id', [$scope.currentUserOperator.UUID], sixFiltersLib.CONSTRAINTS.OR);
      filters['supervisorInternal_id'] = sixFiltersLib.exact('references_assignee.supervisorInternal_id.UUID', $scope.currentUserOperator.UUID, sixFiltersLib.CONSTRAINTS.OR);
      filters['supervisorExternal_id'] = sixFiltersLib.exact('references_assignee.supervisorExternal_id.UUID', $scope.currentUserOperator.UUID, sixFiltersLib.CONSTRAINTS.OR);
    }
    // creazione payload
    var payload = {
      page: $scope.params.pageNumber,
      page_size: $scope.params.pageSize,
      show_revision: false,
      hide_plan: $scope.bool.hidePlan,
      sort_fields: $scope.params.sortFields,
      commission: currentCommission.code
    };
    return odlFactory().search(payload, filters).$promise.then(function (data) {
      $scope.odlList.totalResults = data.totalResults;
      $scope.odlList.list = data.list;
      $scope.params.sixApi.refreshList(data.list);
      return data;
    });
  };
  $scope.validate = function () {
    var form = document.forms['detailForm'];
    if (form) {
      $scope.$broadcast('schemaFormValidate');
      $timeout(function () {
        var invElements = angular.element(form.getElementsByClassName("ng-invalid"));
        if (invElements.length > 0) {
          toaster.pop('error', 'Errore', 'Dati obbligatori mancanti.');
        } else {
          $scope.update();
        }
      }, 500);
    }
  };
  $scope.update = function () {
    if (($scope.data.model.type_id || $scope.data.model.record_type_id) && /* odl da issue e da plan usano una variabile diversa */
    $scope.data.model.record_id && $scope.data.model.service_id) {
      _update().then(function (resp) {
        // succeeded
        if (resp.model) {
          $scope.data = resp;
          $scope.data.dataIn = new Date($scope.data.dataIn);
          if (resp.date_requested) {
            $scope.data.date_requested = new Date(resp.date_requested);
          }
          if (resp.date_insertion) {
            $scope.data.date_insertion = new Date(resp.date_insertion);
          }
          if (resp.date_handling) {
            $scope.data.date_handling = new Date(resp.date_handling);
          }
          if (resp.date_closing) {
            $scope.data.date_closing = new Date(resp.date_closing);
          }
          if (resp.date_handling != null) {
            $scope.data.date_insertion = resp.date_handling;
          }
          toaster.pop('success', 'Salvataggio eseguito', 'Salvataggio eseguito con successo');
        }
      }, function (rejection) {
        // rejected
        toaster.pop('error', 'Errore salvataggio', rejection.data.message ? rejection.data.message : rejection.statusText);
      });
    } else {
      toaster.pop('error', 'Errore Inserimento', 'Non sono stati riempiti tutti i campi necessari: Elemento tecnologico, Asset, Servizio');
    }
  };
  function _update() {
    if ($scope.isNew) {
      /* se è nuovo */
      $scope.data.model.insertedFrom = 'portal'; //inietto origine
      return counterFactory.next({
        code: $scope.counterNameOdl
      }).$promise.then(function (response) {
        if (response.errors) {
          $scope.errorsRetrievingCounter(response.errors);
          var deferred = $q.defer();
          deferred.reject('Errore nel recupero del contatore per la generazione del codice dell\'odl');
          return deferred.promise;
        } else {
          $scope.data.model.code = response.next;
          if (!$scope.data.model.description) {
            $scope.data.model.description = $scope.data.model.code + ' - ' + $scope.data.model.type_id.description + ' - ' + $scope.data.model.record_id.description;
          }
          $scope.data.model.attachments = [];
          writeAttachments($scope.data.model.attachments);
          return odlFactory().createOdl({
            commissionDependent: $scope.commissionDependent
          }, $scope.data).$promise;
        }
      });
    } else {
      if (angular.isUndefined($scope.data.model.attachments)) {
        writeAttachments($scope.data.model.attachments);
      }
      return odlFactory().updateOdl({
        id: $scope.data.version
      }, $scope.data).$promise;
    }
  }
  $scope.updAttachments = function () {
    writeAttachments($scope.data.model.attachments);
    if ($scope.isNew) {
      odlFactory().createOdl({
        commissionDependent: $scope.commissionDependent
      }, $scope.data).$promise.then(function (resp) {
        if (resp.version) {
          $scope.data.version = resp.version;
          $log.info('saving: ' + $scope.data.version);
        }
      })["catch"](function (rejection) {
        toaster.pop('error', 'Errore salvataggio', 'Errore salvataggio allegati');
      });
    } else {
      odlFactory().updateOdl({
        id: $scope.data.version
      }, $scope.data).$promise.then(function (resp) {
        if (resp.version) {
          $scope.data.version = resp.version;
          $log.info('updating id: ' + $scope.data.version);
        }
      })["catch"](function (rejection) {
        toaster.pop('error', 'Errore salvataggio', rejection.data.message ? rejection.data.message : rejection.statusText);
      });
    }
  };
  $scope["delete"] = function (idToDelete) {
    odlFactory().referenceCount({
      id: $scope.data.UUID
    }).$promise.then(function (response) {
      var deleteMessage = 'Eliminare l\'ODL?';
      if (response.count != 0) {
        var deleteMessage = 'L\'ODL che stai eliminando è in uso nel sistema.<br> Vuoi rimuoverlo comunque?';
      }
      dialogService.confirmDialog(deleteMessage, function () {
        $log.info('deleting id:' + idToDelete);
        if ($scope.data.generated_by == 'plan' && angular.isDefined($scope.data.model.parent_record_id)) {
          odlFactory().deletePlanOdl({
            id: idToDelete
          }).$promise.then(function () {
            $scope.getOdlList();
            $location.path('/portal/odl', false);
          });
        } else {
          odlFactory().deleteIssueOdl({
            id: idToDelete
          }).$promise.then(function () {
            $scope.getOdlList();
            $location.path('/portal/odl', false);
          });
        }
      });
    });
  };
  $scope.getSelectedRows = function () {
    var api = $scope.params.gridApi;
    if (api && api.selection) {
      return api.selection.getSelectedRows();
    } else {
      return [];
    }
  };
  $scope.deleteOdlSelected = function () {
    var rows = $scope.getSelectedRows();
    rows.forEach(function (val, i) {
      rows[i] = val.version;
    });
    odlFactory().bulkDeleteOdl(rows).$promise.then(function (data) {
      $scope.refresh();
    });
  };
  $scope.getOdlById = function (itemUUID) {
    if (itemUUID == 'new') {
      $scope.isNew = true;
      getSchemaOdl();
      getCurrentUser($scope.data.user);
      counterFactory.current({
        code: $scope.counterNameOdl
      }).$promise.then(function (response) {
        if (response.errors) {
          $scope.errorsRetrievingCounter(response.errors);
          $window.history.back();
          return;
        }
        $scope.data.model.code = (parseInt(response.current) + 1).toString();
      });
    } else {
      $scope.isNew = false;
      odlFactory().getOdlByUUID({
        uuid: itemUUID
      }).$promise.then(function (response) {
        if (response) {
          $scope.data = response;
          /* ho cambiato la posizione per ottenere lo schema dell'odl altrimenti non si riusciva ad inizializzare la lookup */
          getSchemaOdl();
          getCurrentUser($scope.data.user);
          $scope.currentOdlRef = sixObjectLib.recordToHisRef($scope.data);
          /** TO FIX: vedere come risolvere la gestione delle date */
          if ($scope.data.date_requested) {
            $scope.data.date_requested = new Date($scope.data.date_requested);
          }
          if ($scope.data.date_insertion) {
            $scope.data.date_insertion = new Date($scope.data.date_insertion);
          }
          if ($scope.data.date_handling) {
            $scope.data.date_handling = new Date($scope.data.date_handling);
          }
          if ($scope.data.date_closing) {
            $scope.data.date_closing = new Date($scope.data.date_closing);
          }
          if (angular.isUndefined($scope.data.model.attachments)) {
            $scope.data.model.attachments = [];
          }
          readAttachments($scope.data.model.attachments);
        }
      });
    }
  };
  function getCurrentUser(userInfo) {
    var userFilter = {};
    if (userInfo) {
      userFilter = {
        'model.username': sixFiltersLib.exact('model.username', userInfo)
      };
    } else {
      userFilter = {
        'model.username': sixFiltersLib.exact('model.username', authFactory.getAuthData().authId)
      };
    }
    recordFactory('operatore').search(userFilter).$promise.then(function (resp) {
      if (resp.list || resp.list.length == 1) {
        $scope.cacheVariable = {
          loggedUser: sixObjectLib.recordToHisRef(resp.list[0])
        };
      }
    });
  }
  function getSchemaOdl() {
    return odlFactory().getOdlSchema().$promise.then(function (response) {
      if (response.model) {
        $scope.schemaOdlDefined = true;
        $scope.schema = response.model.schema;
        $scope.form = response.model.form;
        $scope.schemaUUID = response.UUID;
        $scope.columnDefs = response.model.columnDefs;
      } else {
        $scope.schemaOdlDefined = false;
        $scope.schema = {};
        $scope.form = {};
        $scope.schemaUUID = undefined;
        toaster.pop('error', 'Errore caricamento pagina', 'Nessun modello salvato per il tipo \'odl\'.');
      }
    });
  }
  $scope.massiveClosingOdl = function () {
    var odlList = $scope.params.gridApi.selection.getSelectedRows();
    if (odlList && odlList.length > 0) {
      var dateClosingDialog = ngDialog.openConfirm({
        name: 'dateClosingDialog',
        closeByDocument: false,
        showClose: true,
        template: '' + '<div style="text-align:center"><i class="fa fa fa-calendar"></i> Inserire la data di chiusura</div><br>' + '<div style="text-align:left">' + ' da calendario:' + '<input class="form-control" id="input_dialog_date" type="date" ng-model="date">' + '</div>' + '<div style="text-align:left">' + ' o da num. giorni lavorativi:' + '<input class="form-control" id="input_dialog_days" type="number" ng-model="days">' + '</div>' + '<div style="text-align:center">' + '<button style="alignment: center; margin: 10px" type="button" class="btn btn-default" ng-click="confirm()">OK</button>' + '</div>',
        plain: true,
        className: 'ngdialog-theme-default ngdialog-theme-custom'
      });
      dateClosingDialog.then(function () {
        // success
        var type = '';
        var value = null;
        if (document.getElementById("input_dialog_date").value) {
          value = document.getElementById("input_dialog_date").value;
          type = 'date';
        }
        if (document.getElementById("input_dialog_days").value) {
          value = document.getElementById("input_dialog_days").value;
          type = 'days';
        }
        var daysVar = null;
        var dateVar = null;
        if (type == 'days') {
          daysVar = parseInt(value);
        }
        if (type == 'date') {
          dateVar = new Date(value);
        }
        var payload = {
          odlList: odlList,
          typeClosingOdl: type,
          daysClosingValue: daysVar,
          dateClosingValue: dateVar
        };
        odlFactory().bulkClose(payload).$promise.then(function (data) {
          if (data.hasErrors || data.hasWarnings) {
            dialogService.serviceResponse('Esito', data, false);
          }
        })["catch"](function (response) {
          // error
        })["finally"](function (response) {
          $scope.getOdlList();
        });
      }, function (resp) {} // reject
      );
    } else {
      toaster.pop('warning', 'Nessuna selezione', 'Nessun ODL selezionato');
    }
  };
  $scope.showAssetsList = function () {
    if (angular.isUndefined($scope.assetsList)) {
      var payload = {
        page: 1,
        pageSize: 10000,
        code: $scope.data.model.code,
        sortFields: "model.record_id.description",
        sortDirections: "asc",
        id: $scope.data.model.code
      };
      odlFactory().getAssetsList(payload).$promise.then(function (data) {
        $scope.assetsList = data.list;
      });
    }
  };

  /* $watch per popolare i campi dipendenti dalla segnalazione */
  $scope.$watch(function () {
    return $scope.data.issue_id;
  }, function (newVal, oldVal) {
    $scope.issue = undefined;
    if (angular.isDefined(newVal) && newVal != null) {
      issueFactory("issue/record/_uuid/" + $scope.data.issue_id.UUID).getUUID().$promise.then(function (response) {
        if (angular.isDefined(response.model)) {
          $scope.issue = response;
          $scope.issueRefreshed.bool = true;
          if ($scope.issue.date_requested) {
            $scope.issue.date_requested = new Date($scope.issue.date_requested);
          }
          if ($scope.issue.date_insertion) {
            $scope.issue.date_insertion = new Date($scope.issue.date_insertion);
          }
          if ($scope.issue.date_handling) {
            $scope.issue.date_handling = new Date($scope.issue.date_handling);
          }
          if ($scope.issue.date_closing) {
            $scope.issue.date_closing = new Date($scope.issue.date_closing);
          }
          if ($scope.issue.date_handling != null) {
            $scope.data.date_insertion = $scope.issue.date_handling;
          }
          if (!$scope.data.model.type_id) {
            $scope.data.model.type_id = $scope.issue.model.type_id;
          }
          if (!$scope.data.model.record_id) {
            $scope.data.model.record_id = $scope.issue.model.record_id;
          }
          if (!$scope.data.model.service_id) {
            $scope.data.model.service_id = $scope.issue.model.service_id;
          }
          if (!$scope.data.model.priority_id) {
            $scope.data.model.priority_id = $scope.issue.model.priority_id;
          }
          if (!$scope.data.model.activity_id) {
            $scope.data.model.activity_id = $scope.issue.model.activity_id;
          }
          if (!$scope.data.model.odltype_id) {
            $scope.data.model.odltype_id = $scope.issue.model.issuetype_id;
          }
          if (!$scope.data.model.title) {
            $scope.data.model.title = $scope.issue.model.description;
          }
          if (!$scope.data.model.description) {
            $scope.data.model.description = $scope.issue.model.note;
          }
        }
      });
    }
  });
  $scope.$watch('issueRefreshed.bool', function (newVal, oldVal) {
    if (newVal != oldVal) {
      if (newVal == true) {
        odlFactory().getIssueNotAssigned().$promise.then(function (data) {
          if (data.hasErrors || data.hasWarnings) {
            dialogService.serviceResponse('Esito', data, false);
          }
          if (data.result) {
            if (data.result.length > 0) {
              delete $scope.issueRefreshed.filter;
              var filterStr = '';
              angular.forEach(data.result, function (value) {
                if (value.UUID) {
                  if (filterStr == '') {
                    filterStr = value.UUID;
                  } else {
                    filterStr = filterStr + ', ' + value.UUID;
                  }
                }
              });
              $scope.issueRefreshed.filter = {
                'UUID': filterStr
              };
            }
          }
        })["catch"](function (response) {
          // error
        })["finally"](function (response) {
          // finally
        });
      } else {
        $scope.issueRefreshed.filter = {};
      }
    }
  });
  $scope.$watch('data.model.type_id', function (newVal, oldVal) {
    if (newVal != oldVal && $scope.issueRefreshed.bool == false && $scope.init !== true) {
      $scope.data.model.record_id = null;
    }
    if (newVal) {
      $scope.init = false; // prima inizializzazione eseguita
    }

    $scope.issueRefreshed.bool = false;
  });

  /*** PARTE CONFIGURAZIONE ***/

  $scope.$watchGroup(['data.model.record_id', 'data.model.service_id'], function (newValue, oldValue) {
    if ($scope.data.model.type_id && $scope.data.model.record_id && isReferencesEmpty($scope.data) && !$scope.data.version) {
      // azzero i precedenti
      $scope.data.references_assignee = {};
      $scope.data.watchers.internal = [];
      $scope.data.watchers.external = [];

      // scarico la configurazione...
      var payload = {
        type_id: $scope.data.model.type_id,
        record_id: $scope.data.model.record_id,
        service_id: $scope.data.model.service_id,
        response: {}
      };
      treePlanConfigFactory.getCompleteConfiguration(payload).$promise.then(function (respConf) {
        if (respConf.response != {} && respConf.response != undefined && respConf.response != null) {
          if (respConf.response.responsable && respConf.response.responsable.length > 0) {
            $scope.responsableList = respConf.response.responsable;
          }
          if (respConf.response.company) {
            if (respConf.response.company["default"].length > 0) {
              $scope.data.references_assignee.company_id = respConf.response.company["default"][0];
            }
            // creaz. filtro
            if (respConf.response.company.assignee.length > 0) {
              $scope.companyFilter = getFilter($scope.companyFilter, respConf.response.company.assignee);
            }
          }
          if (respConf.response.supplier) {
            if (respConf.response.supplier["default"].length > 0) {
              $scope.data.references_assignee.supplier_id = respConf.response.supplier["default"][0];
            }
            if (respConf.response.supplier.assignee.length > 0) {
              $scope.supplierFilter = getFilter($scope.supplierFilter, respConf.response.supplier.assignee);
            }
          }
          if (respConf.response.issueType) {
            if (respConf.response.issueType["default"].length > 0) {
              $scope.data.model.odltype_id = respConf.response.issueType["default"][0];
            }
            // creaz. filtro
            // al momento non riusciamo a filtrare dentro al model -> condizionare angular-schema-form-sixlookup
          }

          if (respConf.response.priority) {
            if (respConf.response.priority["default"].length > 0) {
              $scope.data.model.priority_id = respConf.response.priority["default"][0];
            }
            // creaz. filtro
            // al momento non riusciamo a filtrare dentro al model -> condizionare angular-schema-form-sixlookup
          }

          if (respConf.response.headmanCommission) {
            if (respConf.response.headmanCommission["default"].length > 0) {
              $scope.data.references_assignee.headmanCommission_id = respConf.response.headmanCommission["default"][0];
            }
            if (respConf.response.headmanCommission.assignee.length > 0) {
              $scope.headmanCommissionFilter = getFilter($scope.headmanCommissionFilter, respConf.response.headmanCommission.assignee);
            }
          }
          if (respConf.response.supervisorExternal) {
            if (respConf.response.supervisorExternal["default"].length > 0) {
              $scope.data.references_assignee.supervisorExternal_id = respConf.response.supervisorExternal["default"][0];
            }
            if (respConf.response.supervisorExternal.assignee.length > 0) {
              $scope.supervisorExternalFilter = getFilter($scope.supervisorExternalFilter, respConf.response.supervisorExternal.assignee);
            }
          }
          if (respConf.response.supervisorInternal) {
            if (respConf.response.supervisorInternal["default"].length > 0) {
              $scope.data.references_assignee.supervisorInternal_id = respConf.response.supervisorInternal["default"][0];
            }
            if (respConf.response.supervisorInternal.assignee.length > 0) {
              $scope.supervisorInternalFilter = getFilter($scope.supervisorInternalFilter, respConf.response.supervisorInternal.assignee);
            }
          }
          if (respConf.response.technicianCommission) {
            if (respConf.response.technicianCommission["default"].length > 0) {
              $scope.data.references_assignee.technicianCommission_id = respConf.response.technicianCommission["default"];
            }
            if (respConf.response.technicianCommission.assignee.length > 0) {
              $scope.technicianCommissionFilter = getFilter($scope.technicianCommissionFilter, respConf.response.technicianCommission.assignee);
            }
          }
          if (respConf.response.maintainer) {
            if (respConf.response.maintainer["default"].length > 0) {
              $scope.data.references_assignee.maintainer_id = respConf.response.maintainer["default"];
            }
            if (respConf.response.maintainer.assignee.length > 0) {
              $scope.maintainerFilter = getFilter($scope.maintainerFilter, respConf.response.maintainer.assignee);
            }
          }
        }
      });
    }
  });

  /* controlla che tutti rif. siano vuoti */
  function isReferencesEmpty(data) {
    return !data.references_assignee || !data.references_assignee.supplier_id && !data.references_assignee.company_id && !data.references_assignee.supervisorInternal_id && !data.references_assignee.supervisorExternal_id && !data.references_assignee.headmanCommission_id && data.references_assignee.technicianCommission_id.length == 0 && data.references_assignee.maintainer_id == 0;
  }

  /* lookup singole per popolare i watchers */
  $scope.$watchGroup(['data.references_assignee.supplier_id', 'data.references_assignee.company_id', 'data.references_assignee.supervisorInternal_id', 'data.references_assignee.supervisorExternal_id', 'data.references_assignee.headmanCommission_id'], function (newValues, oldValues) {
    for (var i = 0; i < 5; i++) {
      if (newValues[i] != oldValues[i]) {
        // se è cambiato il riferimento, gestisco i vari casi:
        if (newValues[i] && !oldValues[i]) {
          // aggiungo il nuovo ai watchers
          copyInWatchers(newValues[i]);
        } else if (!newValues[i] && oldValues[i]) {
          // tolgo dai watchers
          deleteFromWatchers(oldValues[i]);
        } else if (newValues[i] && oldValues[i]) {
          // se sono entrambi definiti tolgo il vecchio e metto il nuovo rif.
          deleteFromWatchers(oldValues[i]);
          copyInWatchers(newValues[i]);
        }
      }
    }
  });

  /* lookup multiple per popolare i watchers */
  $scope.$watchGroup(['data.references_assignee.technicianCommission_id', 'data.references_assignee.maintainer_id'], function (newValues, oldValues) {
    for (var i = 0; i < 2; i++) {
      if (newValues[i] && oldValues[i] && newValues[i] != oldValues[i]) {
        newValues[i].forEach(function (ref) {
          deleteFromWatchers(ref);
          copyInWatchers(ref);
        });
      }
    }
  });
  function deleteFromWatchers(obj) {
    var index = -1;
    for (var i = 0; i < $scope.data.watchers.internal.length; i++) {
      if (obj.UUID == $scope.data.watchers.internal[i].UUID) {
        index = i;
      }
    }
    if (index > -1) {
      $scope.data.watchers.internal.splice(index, 1);
    }
  }
  function copyInWatchers(obj) {
    var bool = false;
    for (var i = 0; i < $scope.data.watchers.internal.length; i++) {
      if (obj.code == $scope.data.watchers.internal[i].code) {
        bool = true;
      }
    }
    if (bool == false) {
      $scope.data.watchers.internal.push(obj);
    }
  }

  /*** PARTE INIZIALIZZAZIONE DELLA PAGINA  ***/

  if ($routeParams.id) {
    $scope.issue = issueToOdl.pop();
    if (angular.isDefined($scope.issue)) {
      $scope.data.issue_id = sixObjectLib.recordToHisRef($scope.issue);
    }
    $scope.getOdlById($routeParams.id);
  } else {
    $scope.getColumns();
    setTimeout(function () {
      if ($scope.params.sixApi) {
        $scope.params.sixApi.restoreState();
      }
    }, 500);
  }

  /******** gestione timeline **************/

  $scope.modelDataInTimeline = {};
  $scope.schemaDataInTimeline = {};
  $scope.formDataInTimeline = {};
  $scope.timeline = [];
  $scope.entity = 'odl/record';
  $scope.getTimeline = function () {
    if (angular.isDefined($scope.entity) && angular.isDefined($scope.data.UUID)) {
      $scope.buildTimeline($scope.entity, $scope.data.UUID);
    }
  };
  $scope.buildTimeline = function (entity, UUID, version) {
    $scope.entity = entity;
    $scope.timeline = odlFactory().getTimeline({
      id: UUID
    }).$promise.then(function (data) {
      $scope.timeline = data.list;
      if (angular.isDefined(version)) {
        $scope.modelDataInTimeline['version'] = version;
      }
    });
  };
  $scope.getModelDetail = function (version) {
    odlFactory().getOdlById({
      id: version
    }).$promise.then(function (data) {
      $scope.currentDataInTimeline = data;
      $scope.modelDataInTimeline.version = data.version;
      if (angular.isUndefined(data.dataOut) || data.dataOut == null) {
        data.dataOut = "_current";
      }
      if (data.date_requested) {
        $scope.currentDataInTimeline.date_requested = new Date(data.date_requested);
      }
      if (data.date_insertion) {
        $scope.currentDataInTimeline.date_insertion = new Date(data.date_insertion);
      }
      if (data.date_handling) {
        $scope.currentDataInTimeline.date_handling = new Date(data.date_handling);
      }
      if (data.date_closing) {
        $scope.currentDataInTimeline.date_closing = new Date(data.date_closing);
      }
      if (data.date_handling != null) {
        $scope.currentDataInTimeline.date_insertion = $scope.issue.date_handling;
      }
      console.log('type -> schema, UUID -> ' + $scope.schemaUUID);
      odlFactory().getSchemaInTimeline({
        id: $scope.schemaUUID,
        param1: data.dataOut
      }).$promise.then(function (response) {
        if (response.model) {
          $scope.showDetail = true;
          $scope.schemaDataInTimeline = response.model.schema;
          $scope.formDataInTimeline = response.model.form;
        }
      });
    });
  };

  /******** funzioni di utility ***********/

  $scope.getMessage = function () {
    /* creazione testo mail */
    var searchInit = {
      search: {
        obj: {
          'username': authFactory.getAuthData().authId
        }
      },
      init: {
        authId: true,
        email: true
      }
    };
    if (angular.isDefined($scope.data.model.type_id) && angular.isDefined($scope.data.model.record_id)) {
      var promiseMailReceiver = odlFactory().getMailReceiver($scope.data).$promise;
      var promiseMailUser = userFactory.getMail(searchInit).$promise;
      $scope.loadingSixMail = true;
      Promise.all([promiseMailReceiver, promiseMailUser]).then(function (response) {
        // response[0] = promiseMailReceiver, response[1] = promiseMailUser
        $scope.loadingSixMail = false;
        var httpLink = 'http://' + $location.$$host + ':' + $location.$$port + '/#' + '/portal/odl' + '/' + $scope.data.UUID;
        $scope.objMail = {
          title: 'ODL ' + $scope.data.model.code + ' su asset ' + $scope.data.model.type_id.description + ' - ' + $scope.data.model.record_id.description,
          to: formatMailReceiver(response[0]),
          cc: formatMailCc(response[1].list[0].email),
          message: 'ODL <b>' + $scope.data.model.code + '</b> su asset <b>' + $scope.data.model.type_id.description + '</b> - <b>' + $scope.data.model.record_id.description + '</b><br /><br />' + 'Dettagli ODL:<br />' + '<i>Codice</i>: <b>' + $scope.data.model.code + '</b> (link: ' + httpLink + ')' + '<br />' + '<i>Tipo elemento tecnologico</i>: (<i>cod.</i>) <b>' + getText($scope.data.model.type_id, 'code') + '</b> - (<i>descr.</i>) <b>' + getText($scope.data.model.type_id, 'description') + '</b><br />' + '<i>Elemento tecnologico</i>: (<i>cod.</i>) <b>' + getText($scope.data.model.record_id, 'code') + '</b> - (<i>descr.</i>) <b>' + getText($scope.data.model.record_id, 'description') + '</b><br />' + '<i>Segnalazione di riferimento</i>: (<i>cod.</i>) ' + getText($scope.data.issue_id, 'code') + ' - (<i>descr.</i>) ' + getText($scope.data.issue_id, 'description') + '<br />' + '<i>Tipo</i>: ' + getText($scope.data.model.odltype_id, 'description') + '<br />' + '<i>Servizio</i>: ' + getText($scope.data.model.service_id, 'description') + '<br />' + '<i>Priorità</i>: ' + getText($scope.data.model.priority_id, 'description') + '<br /><br />' + '<i>Oggetto</i>: ' + getText($scope.data.model, 'title') + '<br />' + '<i>Note</i>: ' + getText($scope.data.model, 'description') + '<br /><br />'
        };
      });
    } else {
      toaster.pop('error', 'Errore', 'Creazione della mail precompilata non riuscita.');
    }
  };
  function pad(value, _char, length) {
    return value.toString().length < length ? pad(_char + value, _char, length) : value;
  }
  $scope.setBoolWatchInternal = function () {
    $scope.bool_watch_internal = true;
    $scope.bool_watch_external = false;
  };
  $scope.setBoolWatchExternal = function () {
    $scope.bool_watch_internal = false;
    $scope.bool_watch_external = true;
  };
  $scope.addWatcher = function () {
    if ($scope.bool_watch_internal) {
      /* se è interno */
      if ($scope.watcher.user != null && include($scope.data.watchers.internal, $scope.watcher.user) == false) {
        $scope.data.watchers.internal.push($scope.watcher.user);
      }
      $scope.watcher.user = null;
    } else if ($scope.bool_watch_external) {
      /* se è esterno */
      if ($scope.watcher.mail != null) {
        $scope.data.watchers.external.push($scope.watcher.mail);
      }
      $scope.watcher.mail = null;
    }
  };
  $scope.addWatcherFromLookUp = function (lookUp) {
    if (angular.isDefined(lookUp) && lookUp != null) {
      if (angular.isArray(lookUp)) {
        for (var i = 0; i < lookUp.length; i++) {
          copyInWatchers(lookUp[i]);
        }
      } else {
        copyInWatchers(lookUp);
      }
    }
  };
  $scope.addAllTechnicianCommissionFromLookUp = function (lookup) {
    for (var i = 0; i < $scope.data.references_assignee.technicianCommission_id.length; i++) {
      copyInWatchers($scope.data.references_assignee.technicianCommission_id[i]);
    }
  };
  $scope.deleteWatcher = function (array, toDelete) {
    var index = array.indexOf(toDelete);
    if (index > -1) {
      array.splice(index, 1);
    }
  };
  function include(arr, obj) {
    var bool = false;
    for (var i = 0; i < arr.length; i++) {
      if (obj.code == arr[i].code) {
        bool = true;
      }
    }
    return bool;
  }
  function formattedLookUpOperator(obj) {
    var objRef = {
      type: 'operatore',
      code: obj.model.code,
      description: obj.model.description,
      UUID: obj.UUID
    };
    return objRef;
  }
  function getFilter(filter, array) {
    var filterRet;
    if (filter == null) {
      filterRet = {};
    } else {
      filterRet = filter;
    }
    var string = '';
    array.forEach(function (item, index) {
      if (index == 0) {
        string = item.UUID;
      } else {
        string = string + ',' + item.UUID;
      }
      filterRet['UUID'] = string;
    });
    return filterRet;
  }
  function getText(ref, element) {
    if (angular.isDefined(ref) && ref != null) {
      if (angular.isDefined(ref[element]) && ref[element] != null) {
        return ref[element];
      }
    }
    return '';
  }
  function formatMailReceiver(array) {
    /* from array to formatted string with comma */
    if (angular.isDefined(array.result)) {
      if (array.result.length != 0) {
        var strConcat = '';
        for (var i = 0; i < array.result.length; i++) {
          if (i == 0) {
            strConcat = array.result[i];
          } else {
            strConcat = strConcat + ', ' + array.result[i];
          }
        }
        return strConcat;
      } else {
        return '';
      }
    } else {
      return '';
    }
  }
  function formatMailCc(UserMailSix) {
    if (UserMailSix) {
      return UserMailSix;
    } else {
      return null;
    }
  }
  $scope.getType = function (modelItem) {
    if (modelItem.type == 'datepicker') {
      return 'date';
    } else {
      return modelItem.type;
    }
  };
  function getReadableType(type) {
    switch (type) {
      case 'issue':
        return 'Segnalazione';
      case 'plan':
        return 'Programmata';
      default:
        return 'Sconosciuta';
    }
  }
  function getReadableUser(odl) {
    if (odl.userinfo) {
      return odl.userinfo.description;
    } else {
      return odl.user;
    }
  }
  ;

  /** Jasper **/

  /*
   * 2 tipi di report:
   * - odl
   * - plan
   *
   * E' possibile specializzare i report per commessa inserendo il suffisso '_[codice_commessa]' (es. odl_1600000).
   * Questi report devono chiaramente essere caricarti su Jasper.
   */

  $scope.printOdl = function (extension) {
    var report;
    if ($scope.data.generated_by == 'plan') {
      report = 'plan';
    } else {
      report = 'odl';
    }
    var response = jasperReport(report + '_' + currentCommission.code, extension); // provo il report specifico della commessa
    response.success(function (data, status, headers, config) {
      if (status == 204) {
        // se è vuoto, provo il report di default
        $log.warn('jasper report error with params report=' + report + ' and extension=' + extension + '_' + currentCommission.code + ': trying with default report');
        jasperReport(report, extension).success(function (data, status, headers, config) {
          if (status != 200) {
            toaster.pop('error', "Errore", 'Errore generazione report');
          }
        });
      }
    }).error(function (data, status, headers, config) {
      toaster.pop('error', "Errore", 'Errore generazione report');
    });
  };
  function jasperReport(report, extension) {
    var REPORT_URL = 'reports/EMMA/Asset/';
    report = report || 'odl';
    extension = extension || 'pdf';
    var query = '&uuid=' + $scope.data.UUID + '&commission=' + currentCommission.code;
    var reportNameToSave = 'odl_' + $scope.data.model.code + '.' + extension;
    var reportPath = REPORT_URL + report + '.' + extension;
    var payload = {
      path: reportPath,
      query: query
    };
    var config = {
      responseType: 'arraybuffer'
    };
    var promise = $http.post(APP_URL + '/rest/report/generate', payload, config);
    promise.success(function (data, status, headers, config) {
      if (status == 200 && data) {
        var options;
        if (extension == 'pdf') {
          options = {
            type: 'application/pdf'
          };
        } else if (extension == 'xls') {
          options = {
            type: 'application/vnd.ms-excel;'
          };
        }
        SaveAs.download(data, reportNameToSave, options);
      }
    });
    return promise;
  }
  $scope.printSelectedOdl = function () {
    var odlList = $scope.params.gridApi.selection.getSelectedRows();
    var userFilter = {
      'model.username': sixFiltersLib.exact('model.username', authFactory.getAuthData().authId)
    };
    if (odlList && odlList.length > 0) {
      var notifyData = {
        to: null
      };
      var notifyToDialog = ngDialog.openConfirm({
        name: 'notifyToDialog',
        closeByDocument: false,
        showClose: true,
        data: notifyData,
        template: '' + '<div style="text-align:center">' + 'Invia una notifica di completamento al seguente indirizzo:<br>' + '<input class="form-control" type="email" ng-model="ngDialogData.to" placeholder="Indirizzo email">' + '</div>' + '<div style="text-align:center">' + '<button style="alignment: center; margin: 10px" type="button" ' + ' ng-disabled="!ngDialogData.to" class="btn btn-default" ng-click="confirm(ngDialogData)">OK</button>' + '</div>',
        plain: true,
        className: 'ngdialog-theme-default ngdialog-theme-custom'
      });
      recordFactory('operatore').search(userFilter).$promise.then(function (resp) {
        if (resp.list) {
          notifyData.to = resp.list[0].model.mail;
        }
      });
      notifyToDialog.then(function (notify) {
        // success
        var notifyTo = notify.to;
        var payload = [];
        var REPORT_URL = 'reports/EMMA/Asset/';
        for (var i in odlList) {
          var report = odlList[i].generated_by == 'plan' ? 'plan' : 'odl';
          var extension = 'pdf';
          var query = '&uuid=' + odlList[i].UUID + '&commission=' + currentCommission.code;
          var filename = 'odl_' + odlList[i].model.code + '.' + extension;
          var reportPaths = [
          //report specifico commessa + fallback
          REPORT_URL + report + '_' + currentCommission.code + '.' + extension, REPORT_URL + report + '.' + extension];
          payload.push({
            path: reportPaths,
            query: query,
            filename: filename
          });
        }
        var promise = $http.post(APP_URL + '/rest/report/generate-many?notifyTo=' + notifyTo, payload);
        promise.success(function (data, status, headers, config) {
          if (status == 202) {
            toaster.pop('success', 'Elaborazione avviata', 'Elaborazione avviata, riceverai una email al completamento.');
          }
        });
      }, function (resp) {} // reject
      );
    } else {
      toaster.pop('warning', 'Nessuna selezione', 'Nessun ODL selezionato');
    }
  };

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'odl';
  $scope.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  $scope.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
  $scope.searchAllPermAllowed = function () {
    return authFactory.checkPerm(RESOURCE_NAME, 'SEARCH_ALL');
  };
  $scope.toggleAllOdl = function () {
    $scope.bool.allOdl = !$scope.bool.allOdl;
    localStorageService.set('portal_odl_bool', $scope.bool);
    $scope.refresh();
  };
  if (localStorageService.get('portal_odl_bool')) {
    $scope.bool = localStorageService.get('portal_odl_bool');
    $scope.bool.allOdl = $scope.bool.allOdl && $scope.searchAllPermAllowed();
  } else {
    $scope.bool = {
      allOdl: $scope.searchAllPermAllowed()
    };
  }
}]);
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:IctCategoryRespondController
 * @description
 * # IctCategoryRespondController
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').controller('IctCategoryController', ["$scope", "$routeParams", "$location", "$log", "$window", "uiGridConstants", "sixGridPaginationConstants", "questionFactory", "toaster", "authFactory", "dialogService", function ($scope, $routeParams, $location, $log, $window, uiGridConstants, sixGridPaginationConstants, questionFactory, toaster, authFactory, dialogService) {
  var ctrl = this;

  /**************************
   * Questions
   **************************/

  /**************************
   * Question 'on-the-fly'
   **************************/

  /**************************
   * Callbacks
   **************************/

  function _notifyChange() {
    if (angular.isDefined(ctrl.onChange) && angular.isFunction(ctrl.onChange)) {
      ctrl.onChange({
        data: ctrl.data
      });
    }
  }
  function _processScore() {
    if (ctrl.data.questions && angular.isArray(ctrl.data.questions)) {
      var score = 0;
      ctrl.data.questions.forEach(function (q) {
        if (q.model.response && q.model.response.score) {
          score += q.model.response.score;
        }
      });
      ctrl.data.score = score;
    }
  }
  ctrl.$doCheck = function () {
    _processScore();
  };
}]);
angular.module('emma.plan').component('ictCategory', {
  restrict: 'E',
  controller: 'IctCategoryController',
  templateUrl: 'plan/survey/components/ict_category.html',
  bindings: {
    data: '=',
    onChange: '&?'
  },
  link: function postLink(scope, element, attrs) {}
});
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:QuestionsCtrl
 * @description
 * # QuestionsCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').controller('IctCategoryModelController', ["$scope", "$routeParams", "$location", "$log", "$window", "uiGridConstants", "sixGridPaginationConstants", "questionFactory", "toaster", "authFactory", "dialogService", function ($scope, $routeParams, $location, $log, $window, uiGridConstants, sixGridPaginationConstants, questionFactory, toaster, authFactory, dialogService) {
  var ctrl = this;
  ctrl.question = {}; // domanda selezionata dalla lookup

  ctrl.questionsSortableOptions = {
    containerPositioning: 'relative',
    containment: '#questionsManager'
  };

  /**************************
   * Questions
   **************************/

  ctrl.addQuestion = function (q) {
    if (!ctrl.data.questions) {
      ctrl.data.questions = [];
    }
    if (q && q.UUID) {
      // se non mi arriva vuota
      ctrl.data.questions.push(q);
      $scope.$broadcast('sixlookup2:questions_' + ctrl.data.code + ':clear'); // sbianco il dato in ict-question
    }

    _updateAbsMinMax();
    _notifyChange();
  };
  ctrl.removeQuestion = function (q) {
    if (!ctrl.data.questions) {
      ctrl.data.questions = [];
    }
    var index = ctrl.data.questions.indexOf(q);
    if (~index) {
      ctrl.data.questions.splice(index, 1);
    }
    _updateAbsMinMax();
    _notifyChange();
  };
  function _updateAbsMinMax() {
    ctrl.data.absmin = 0; // punteggio minimo ottenibile da tutte le domande di questa categoria
    ctrl.data.absmax = 0; // punteggio massimo ottenibile da tutte le domande di questa categoria
    ctrl.data.questions.forEach(function (a) {
      ctrl.data.absmin += _getMinAnswerScore(a);
      ctrl.data.absmax += _getMaxAnswerScore(a);
    });
  }
  function _getMinAnswerScore(q) {
    var minScore = 0;
    if (q.model.answers && q.model.answers.length > 0) {
      minScore = Math.min.apply(Math, q.model.answers.map(function (a) {
        if (angular.isDefined(a.score)) {
          return a.score;
        } else {
          return 0;
        }
      }));
    }
    return minScore;
  }
  function _getMaxAnswerScore(q) {
    var maxScore = 0;
    if (q.model.answers && q.model.answers.length > 0) {
      maxScore = Math.max.apply(Math, q.model.answers.map(function (a) {
        if (angular.isDefined(a.score)) {
          return a.score;
        } else {
          return 0;
        }
      }));
    }
    return maxScore;
  }

  /**************************
   * Question 'on-the-fly'
   **************************/

  ctrl.questionToEdit = undefined; // domanda selezionata per l'edit
  ctrl.showDetails = false;
  this.editQuestion = function (q) {
    ctrl.questionToEdit = q;
    ctrl.showDetails = true;
  };
  ctrl.newQuestion = function () {
    ctrl.questionToEdit = undefined;
    ctrl.showDetails = true;
  };

  // callback per ict-question
  ctrl.onSave = function (q) {
    ctrl.addQuestion(angular.copy(q));
    ctrl.showDetails = false;
    $scope.$broadcast('ictquestion:clearData'); // sbianco il dato in ict-question
  };

  /**************************
   * Callbacks
   **************************/

  function _notifyChange() {
    if (angular.isDefined(ctrl.onChange) && angular.isFunction(ctrl.onChange)) {
      ctrl.onChange({
        data: ctrl.data
      });
    }
  }
}]);
angular.module('emma.plan').component('ictCategoryModel', {
  restrict: 'E',
  controller: 'IctCategoryModelController',
  templateUrl: 'plan/survey/components/ict_category_model.html',
  bindings: {
    data: '=',
    onChange: '&?'
  },
  link: function postLink(scope, element, attrs) {}
});
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:IctQuestionRespondController
 * @description
 * # IctQuestionRespondController
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').controller('IctQuestionController', ["$scope", "$routeParams", "$location", "$log", "$window", "uiGridConstants", "sixGridPaginationConstants", "questionFactory", "toaster", "authFactory", "dialogService", "$timeout", function ($scope, $routeParams, $location, $log, $window, uiGridConstants, sixGridPaginationConstants, questionFactory, toaster, authFactory, dialogService, $timeout) {
  var ctrl = this;

  /*********************
   * Detail
   *********************/

  function _init() {
    if (!ctrl.data) {
      ctrl.data = {};
    }
    if (!ctrl.data.model) {
      ctrl.data.model = {};
    }
    if (!ctrl.data.model.answerType) {
      ctrl.data.model.answerType = {
        args: {}
      };
    }
    if (!ctrl.data.model.response) {
      if (ctrl.data.model.answerType.key == 'selectmulti' && ctrl.data.model.answerType.args.multi) {
        ctrl.data.model.response = [];
      } else {
        ctrl.data.model.response = {};
      }
    }
  }

  /*********************
   * Watch
   *********************/

  ctrl.$onInit = function () {
    _init();
  };
}]);
angular.module('emma.plan').component('ictQuestion', {
  restrict: 'E',
  controller: 'IctQuestionController',
  templateUrl: 'plan/survey/components/ict_question.html',
  bindings: {
    data: '='
  },
  link: function postLink(scope, element, attrs) {}
});
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:QuestionsCtrl
 * @description
 * # QuestionsCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').controller('IctQuestionDataConfController', ["$scope", "$routeParams", "$location", "$log", "$window", "uiGridConstants", "sixGridPaginationConstants", "questionFactory", "toaster", "authFactory", "dialogService", "$timeout", function ($scope, $routeParams, $location, $log, $window, uiGridConstants, sixGridPaginationConstants, questionFactory, toaster, authFactory, dialogService, $timeout) {
  var ctrl = this;
  ctrl.answersSortableOptions = {
    containerPositioning: 'relative',
    containment: '#answersManager'
  };

  /*********************
   * Detail
   *********************/

  ctrl.answerTypesList = [{
    key: 'text',
    description: 'Testo libero'
  }, {
    key: 'textarea',
    description: 'Testo libero espanso'
  }, {
    key: 'number',
    description: 'Numero'
  }, {
    key: 'truefalse',
    description: 'Vero/Falso'
  }, {
    key: 'select',
    description: 'Selezione singola',
    args: {
      multi: false
    }
  }, {
    key: 'selectmulti',
    description: 'Selezione multipla',
    args: {
      multi: true
    }
  }];
  ctrl.newAnswer = function () {
    ctrl.addAnswer({
      description: '',
      score: 1
    });
  };
  ctrl.addAnswer = function (answer) {
    answer.key = 0;
    if (!ctrl.data.model.answers) {
      ctrl.data.model.answers = [];
    }
    if (ctrl.data.model.answers && ctrl.data.model.answers.length > 0) {
      answer.key = Math.max.apply(Math, ctrl.data.model.answers.map(function (c) {
        return c.key;
      })) + 1;
    }
    ctrl.data.model.answers.push(answer);
    $timeout(function () {
      var newElem = angular.element(document.getElementById('ans' + answer.key));
      newElem.addClass('highlight-cat');
    }, 100);
  };
  ctrl.removeAnswer = function (answer) {
    if (!ctrl.data.model.answers) {
      ctrl.data.model.answers = [];
    }
    var index = ctrl.data.model.answers.indexOf(answer);
    if (~index) {
      ctrl.data.model.answers.splice(index, 1);
    }
  };

  /**************************
   * Watches
   **************************/

  // var previousData;
  //
  // /**
  //  * Inizializzo il dato
  //  */
  // // ctrl.$onInit = function () {
  // //   $log.log('$onInit');
  // //   _initData();
  // //   previousData = angular.copy(ctrl.data);
  // // };
  //
  // /**
  //  * Catturo i cambiamenti al dato
  //  */
  // ctrl.$onChanges = function(changesObj) {
  //   $log.log('$onChanges');
  //   $log.log(changesObj);
  //   // if(changesObj.isFirstChange()) {
  //   //
  //   // }
  // };
  //
  // ctrl.$doCheck = function () {
  //   if( previousData && previousData.model && previousData.model.answerType
  //       && ctrl.data && ctrl.data.model && ctrl.data.model.answerType
  //       && previousData.model.answerType.key != ctrl.data.model.answerType.key) {
  //     $log.log('$doCheck');
  //     $log.log(previousData);
  //     $log.log(ctrl.data);
  //     ctrl.data.model.answers = [];
  //     if(ctrl.data.model.answerType.key == 'truefalse') {
  //       ctrl.addAnswer({description: 'Vero', score: 1});
  //       ctrl.addAnswer({description: 'Falso', score: 0});
  //     }
  //     previousData = angular.copy(ctrl.data);
  //   }
  // };

  /**************************
   * Utilities
   **************************/

  /**
   * Initialize data if not initialized
   */
  function _initData() {
    if (!ctrl.data) {
      ctrl.data = {};
    }
    if (!ctrl.data.model) {
      ctrl.data.model = {};
    }
    if (!ctrl.data.model.answerType) {
      ctrl.data.model.answerType = {};
    }
  }

  /**
   * Clear data
   */
  function _clearData() {
    if (ctrl.data) {
      for (var prop in ctrl.data) {
        delete ctrl.data[prop];
      }
    }
    _initData();
  }
}]);
angular.module('emma.plan').component('ictQuestionDataConf', {
  restrict: 'E',
  controller: 'IctQuestionDataConfController',
  templateUrl: 'plan/survey/components/ict_question_model_data.html',
  bindings: {
    data: '='
  },
  link: function postLink(scope, element, attrs) {}
});
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:QuestionsCtrl
 * @description
 * # QuestionsCtrl
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').controller('IctQuestionModelController', ["$scope", "$routeParams", "$location", "$log", "$window", "uiGridConstants", "sixGridPaginationConstants", "questionFactory", "toaster", "authFactory", "dialogService", function ($scope, $routeParams, $location, $log, $window, uiGridConstants, sixGridPaginationConstants, questionFactory, toaster, authFactory, dialogService) {
  var ctrl = this;
  if (angular.isUndefined(ctrl.suppressToolbar)) {
    ctrl.suppressToolbar = false;
  }
  if (angular.isUndefined(ctrl.backToList)) {
    ctrl.backToList = true;
  }

  /*********************
   * Detail
   *********************/

  /**
   * Initialize data if not initialized
   */
  function _initData() {
    if (!ctrl.data) {
      ctrl.data = {};
    }
    if (!ctrl.data.model) {
      ctrl.data.model = {};
    }
    if (!ctrl.data.model.answerType) {
      ctrl.data.model.answerType = {};
    }
  }

  /**
   * Clear data
   */
  function _clearData() {
    if (ctrl.data) {
      for (var prop in ctrl.data) {
        delete ctrl.data[prop];
      }
    }
    _initData();
  }

  /**
   * Save or update
   */
  ctrl.save = function () {
    if (angular.isUndefined(ctrl.data)) {
      toaster.pop('error', 'Domanda non compilata', 'Prima di procedere compilare la domanda');
      return;
    }
    var promise;
    if (ctrl.data.version) {
      // update
      promise = questionFactory.update({
        id: ctrl.data.version,
        history: false
      }, ctrl.data).$promise;
    } else {
      // create
      promise = questionFactory.create({
        history: false,
        commission_dependent: false
      }, ctrl.data.model).$promise;
    }
    promise.then(function (resp) {
      // success
      toaster.pop('success', 'Salvataggio riuscito', 'Salvataggio eseguito correttamente');
      ctrl.data = resp;
      if (ctrl.onSave && angular.isFunction(ctrl.onSave)) {
        ctrl.onSave({
          q: ctrl.data
        });
      }
      if (ctrl.backToList) {
        ctrl.goToList();
      }
    })["catch"](function (err) {
      // error
      toaster.pop('error', 'Errore salvataggio', 'Errore durante il salvataggio');
    });
  };

  /**
   * Delete
   * @param idToDelete
   */
  ctrl["delete"] = function (id) {
    questionFactory.referenceCount({
      id: ctrl.data.UUID
    }).$promise.then(function (response) {
      var deleteMessage = 'Eliminare la domanda?';
      if (response.count != 0) {
        deleteMessage = 'La domanda che stai eliminando è in uso nel sistema.<br> Vuoi eliminarla comunque?';
      }
      dialogService.confirmDialog(deleteMessage, function () {
        $log.info('deleting id:' + id);
        questionFactory["delete"]({
          id: id
        }).$promise.then(function () {
          // success
          toaster.pop('success', 'Eliminazione riuscita', 'Eliminazione eseguita con successo');
          if (ctrl.onDelete && angular.isFunction(ctrl.onDelete)) {
            ctrl.onDelete({
              q: ctrl.data
            });
          }
          ctrl.goToList();
        })["catch"](function () {
          // error
          toaster.pop('error', 'Errore eliminazione', 'Errore durante l\'eliminazione');
        });
      });
    });
  };

  /**
   * Get data
   * @param uuid
   */
  ctrl.getData = function (uuid) {
    if (uuid == 'new') {
      // new question (=> empty data)
      _clearData();
    } else {
      questionFactory.getByUuid({
        uuid: uuid
      }).$promise.then(function (response) {
        if (response && response.list && response.list.length > 0) {
          ctrl.data = response.list[0];
          if (ctrl.onLoad && angular.isFunction(ctrl.onLoad)) {
            ctrl.onLoad({
              q: ctrl.data
            });
          }
        }
      })["catch"](function (err) {
        toaster.pop('error', 'Errore', 'Errore durante il recupero dei dati');
      });
    }
  };
  $scope.$on('ictquestion:clearData', function () {
    _clearData();
  });

  /*********************
   * Navigation
   *********************/

  ctrl.goToList = function () {
    $location.path('question');
  };

  /*********************
   * Main
   *********************/

  if (ctrl.uuid) {
    ctrl.getData(ctrl.uuid);
  } else if (ctrl.data) {
    _initData();
  } else {
    _initData();
  }

  /*********************
   * Watchers
   *********************/

  ctrl.$doCheck = function () {
    if (!ctrl.data) {
      _initData();
    }
  };

  /** ***********************************
   * Check permissions
   * ***********************************/

  var RESOURCE_NAME = 'question';
  ctrl.isWritePermAllowed = function () {
    return authFactory.isWritePermAllowed(RESOURCE_NAME);
  };
  ctrl.isDeletePermAllowed = function () {
    return authFactory.isDeletePermAllowed(RESOURCE_NAME);
  };
  ctrl.searchAllPermAllowed = function () {
    return authFactory.checkPerm(RESOURCE_NAME, 'SEARCH_ALL');
  };
}]);
angular.module('emma.plan').component('ictQuestionModel', {
  restrict: 'E',
  controller: 'IctQuestionModelController',
  templateUrl: 'plan/survey/components/ict_question_model.html',
  bindings: {
    uuid: '=?',
    data: '=?',
    suppressToolbar: '=?',
    backToList: '<?',
    onLoad: '&?',
    // callback: onLoad(q)
    onSave: '&?',
    // callback: onSave(q)
    onDelete: '&?' // callback: onDelete(q)
  },

  link: function postLink(scope, element, attrs) {}
});
'use strict';

/**
 * @ngdoc function
 * @name sixEmmaApp.controller:IctSurveyController
 * @description
 * # IctSurveyController
 * Controller of the sixEmmaApp
 */
angular.module('emma.plan').controller('IctSurveyController', ["$scope", "$routeParams", "$location", "$log", "$window", "surveyFactory", "toaster", "dialogService", function ($scope, $routeParams, $location, $log, $window, surveyFactory, toaster, dialogService) {
  var ctrl = this;

  /*********************
   * Detail
   *********************/

  function _init() {
    if (!ctrl.data) {
      ctrl.data = {};
    }
    if (!ctrl.data.model) {
      ctrl.data.model = {};
    }
    if (!ctrl.data.model.categories) {
      ctrl.data.model.categories = [{
        code: 1,
        description: 'Categoria 1',
        questions: []
      }];
    }
    if (angular.isUndefined(ctrl.data.model.absmin)) {
      ctrl.data.model.absmin = 0; // punteggio minimo ottenibile da tutte le domande di questo sondaggio
    }

    if (angular.isUndefined(ctrl.data.model.absmax)) {
      ctrl.data.model.absmax = 0; // punteggio massimo ottenibile da tutte le domande di questo sondaggio
    }
  }

  function emptyData() {
    _init();
  }

  /*********************
   * Watchers
   *********************/

  function _processScore() {
    if (ctrl.data.model.categories && angular.isArray(ctrl.data.model.categories)) {
      var score = 0;
      ctrl.data.model.categories.forEach(function (c) {
        if (angular.isDefined(c.score)) {
          score += c.score;
        }
      });
      ctrl.data.model.score = score;
    }
  }
  ctrl.$doCheck = function () {
    _processScore();
  };

  /*********************
   * Main
   *********************/

  if (!ctrl.data) {
    _init();
  }
}]);
angular.module('emma.plan').component('ictSurvey', {
  restrict: 'E',
  controller: 'IctSurveyController',
  templateUrl: 'plan/survey/components/ict_survey_detail.html',
  bindings: {
    data: '=?',
    onChange: '&?'
  },
  link: function postLink(scope, element, attrs) {}
});
angular.module("emma").run(["$templateCache", function($templateCache) {$templateCache.put("404.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><title>Page Not Found :(</title><style>\n      ::-moz-selection {\n        background: #b3d4fc;\n        text-shadow: none;\n      }\n\n      ::selection {\n        background: #b3d4fc;\n        text-shadow: none;\n      }\n\n      html {\n        padding: 30px 10px;\n        font-size: 20px;\n        line-height: 1.4;\n        color: #737373;\n        background: #f0f0f0;\n        -webkit-text-size-adjust: 100%;\n        -ms-text-size-adjust: 100%;\n      }\n\n      html,\n      input {\n        font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n      }\n\n      body {\n        max-width: 500px;\n        _width: 500px;\n        padding: 30px 20px 50px;\n        border: 1px solid #b3b3b3;\n        border-radius: 4px;\n        margin: 0 auto;\n        box-shadow: 0 1px 10px #a7a7a7, inset 0 1px 0 #fff;\n        background: #fcfcfc;\n      }\n\n      h1 {\n        margin: 0 10px;\n        font-size: 50px;\n        text-align: center;\n      }\n\n      h1 span {\n        color: #bbb;\n      }\n\n      h3 {\n        margin: 1.5em 0 0.5em;\n      }\n\n      p {\n        margin: 1em 0;\n      }\n\n      ul {\n        padding: 0 0 0 40px;\n        margin: 1em 0;\n      }\n\n      .container {\n        max-width: 380px;\n        _width: 380px;\n        margin: 0 auto;\n      }\n\n      /* google search */\n\n      #goog-fixurl ul {\n        list-style: none;\n        padding: 0;\n        margin: 0;\n      }\n\n      #goog-fixurl form {\n        margin: 0;\n      }\n\n      #goog-wm-qt,\n      #goog-wm-sb {\n        border: 1px solid #bbb;\n        font-size: 16px;\n        line-height: normal;\n        vertical-align: top;\n        color: #444;\n        border-radius: 2px;\n      }\n\n      #goog-wm-qt {\n        width: 220px;\n        height: 20px;\n        padding: 5px;\n        margin: 5px 10px 0 0;\n        box-shadow: inset 0 1px 1px #ccc;\n      }\n\n      #goog-wm-sb {\n        display: inline-block;\n        height: 32px;\n        padding: 0 10px;\n        margin: 5px 0 0;\n        white-space: nowrap;\n        cursor: pointer;\n        background-color: #f5f5f5;\n        background-image: -webkit-linear-gradient(rgba(255,255,255,0), #f1f1f1);\n        background-image: -moz-linear-gradient(rgba(255,255,255,0), #f1f1f1);\n        background-image: -ms-linear-gradient(rgba(255,255,255,0), #f1f1f1);\n        background-image: -o-linear-gradient(rgba(255,255,255,0), #f1f1f1);\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        appearance: none;\n        *overflow: visible;\n        *display: inline;\n        *zoom: 1;\n      }\n\n      #goog-wm-sb:hover,\n      #goog-wm-sb:focus {\n        border-color: #aaa;\n        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);\n        background-color: #f8f8f8;\n      }\n\n      #goog-wm-qt:hover,\n      #goog-wm-qt:focus {\n        border-color: #105cb6;\n        outline: 0;\n        color: #222;\n      }\n\n      input::-moz-focus-inner {\n        padding: 0;\n        border: 0;\n      }\n    </style></head><body><div class=\"container\"><h1>Not found <span>:(</span></h1><p>Sorry, but the page you were trying to view does not exist.</p><p>It looks like this was the result of either:</p><ul><li>a mistyped address</li><li>an out-of-date link</li></ul><script>\n        var GOOG_FIXURL_LANG = (navigator.language || \'\').slice(0,2),GOOG_FIXURL_SITE = location.host;\n      </script><script src=\"//linkhelp.clients.google.com/tbproxy/lh/wm/fixurl.js\"></script></div></body></html>");
$templateCache.put("index.html","<!doctype html><html class=\"no-js\" ng-app=\"emma\" ng-controller=\"AppCtrl\"><head><meta charset=\"utf-8\"><title>{{app.title}}</title><meta name=\"description\" content=\"\"><meta name=\"viewport\" content=\"width=device-width, initial-scale=1, maximum-scale=1\"><link rel=\"stylesheet\" href=\"bower_components/pickadate/lib/themes/default.css\"><link rel=\"stylesheet\" href=\"bower_components/pickadate/lib/themes/default.date.css\"><link rel=\"stylesheet\" href=\"bower_components/pickadate/lib/themes/default.time.css\"><link rel=\"stylesheet\" href=\"bower_components/angular-ui-grid/ui-grid.css\"><link rel=\"stylesheet\" href=\"bower_components/angular-ui-grid/ui-grid.min.css\"><link rel=\"stylesheet\" href=\"bower_components/angular-ui-select/dist/select.css\"><link rel=\"stylesheet\" href=\"bower_components/angular-ui-tree/dist/angular-ui-tree.css\"><link rel=\"stylesheet\" href=\"bower_components/angularjs-toaster/toaster.css\"><link rel=\"stylesheet\" href=\"bower_components/animate.css/animate.css\"><link rel=\"stylesheet\" href=\"bower_components/bootstrap/dist/css/bootstrap.css\"><link rel=\"stylesheet\" href=\"bower_components/fontawesome/css/font-awesome.css\"><link rel=\"stylesheet\" href=\"bower_components/ngDialog/css/ngDialog.css\"><link rel=\"stylesheet\" href=\"bower_components/ngDialog/css/ngDialog-theme-default.css\"><link rel=\"stylesheet\" href=\"bower_components/simple-line-icons/css/simple-line-icons.css\"><link rel=\"stylesheet\" href=\"bower_components/seiyria-bootstrap-slider/dist/css/bootstrap-slider.css\"><link rel=\"stylesheet\" href=\"bower_components/angular-gantt/assets/angular-gantt.css\"><link rel=\"stylesheet\" href=\"bower_components/angular-gantt/assets/angular-gantt-plugins.css\"><link rel=\"stylesheet\" href=\"bower_components/angular-loading-bar/build/loading-bar.css\"><link rel=\"stylesheet\" href=\"bower_components/ng-tags-input/ng-tags-input.css\"></head><body class=\"{{$root.bodyClass}}\" id=\"scroll-top-target\"><div ng-view=\"\" class=\"view-frame\" ng-if=\"$root.bodyClass == \'login-six\'\"></div><div ng-controller=\"AppCtrl\" data-ng-include=\"\'theme/app.html\'\" ng-class=\"{\'app-header-fixed\':app.settings.headerFixed, \'app-aside-fixed\':app.settings.asideFixed, \'app-aside-folded\':app.settings.asideFolded, \'app-aside-dock\':app.settings.asideDock, \'container\':app.settings.container}\" class=\"app app-header-fixed\" ng-if=\"$root.bodyClass != \'login-six\'\"></div><script>\n  (function(i,s,o,g,r,a,m){i[\'GoogleAnalyticsObject\']=r;i[r]=i[r]||function(){\n      (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\n    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)\n  })(window,document,\'script\',\'https://www.google-analytics.com/analytics.js\',\'ga\');\n\n  ga(\'create\', \'UA-78512873-1\', \'auto\');\n  ga(\'send\', \'pageview\');\n\n</script><script src=\"bower_components/jquery/dist/jquery.js\"></script><script src=\"bower_components/angular/angular.js\"></script><script src=\"bower_components/angular-animate/angular-animate.js\"></script><script src=\"bower_components/angular-bootstrap/ui-bootstrap-tpls.js\"></script><script src=\"bower_components/angular-cookies/angular-cookies.js\"></script><script src=\"bower_components/blob-polyfill/Blob.js\"></script><script src=\"bower_components/file-saver.js/FileSaver.js\"></script><script src=\"bower_components/angular-file-saver/src/file-saver.js\"></script><script src=\"bower_components/angular-i18n/angular-locale_it-it.js\"></script><script src=\"bower_components/angular-local-storage/dist/angular-local-storage.js\"></script><script src=\"bower_components/angular-resource/angular-resource.js\"></script><script src=\"bower_components/angular-route/angular-route.js\"></script><script src=\"bower_components/angular-sanitize/angular-sanitize.js\"></script><script src=\"bower_components/tv4/tv4.js\"></script><script src=\"bower_components/objectpath/lib/ObjectPath.js\"></script><script src=\"bower_components/angular-schema-form/dist/schema-form.js\"></script><script src=\"bower_components/angular-schema-form/dist/bootstrap-decorator.js\"></script><script src=\"bower_components/pickadate/lib/picker.js\"></script><script src=\"bower_components/pickadate/lib/picker.date.js\"></script><script src=\"bower_components/pickadate/lib/picker.time.js\"></script><script src=\"bower_components/angular-schema-form-datepicker/bootstrap-datepicker.min.js\"></script><script src=\"bower_components/angular-schema-form-sixformula/angular-schema-form-sixformula.min.js\"></script><script src=\"bower_components/angular-schema-form-sixlookup/angular-schema-form-sixlookup.js\"></script><script src=\"bower_components/angular-schema-form-sixinherit/angular-schema-form-sixinherit.min.js\"></script><script src=\"bower_components/angular-touch/angular-touch.js\"></script><script src=\"bower_components/angular-translate/angular-translate.js\"></script><script src=\"bower_components/angular-translate-loader-static-files/angular-translate-loader-static-files.js\"></script><script src=\"bower_components/angular-translate-storage-cookie/angular-translate-storage-cookie.js\"></script><script src=\"bower_components/angular-translate-storage-local/angular-translate-storage-local.js\"></script><script src=\"bower_components/ace-builds/src-min-noconflict/ace.js\"></script><script src=\"bower_components/ace-builds/src-min-noconflict/mode-json.js\"></script><script src=\"bower_components/angular-ui-ace/ui-ace.js\"></script><script src=\"bower_components/angular-ui-grid/ui-grid.js\"></script><script src=\"bower_components/angular-ui-grid/ui-grid.min.js\"></script><script src=\"bower_components/angular-ui-select/dist/select.js\"></script><script src=\"bower_components/angular-ui-tree/dist/angular-ui-tree.js\"></script><script src=\"bower_components/angular-websocket/angular-websocket.min.js\"></script><script src=\"bower_components/angularjs-toaster/toaster.js\"></script><script src=\"bower_components/bootstrap/dist/js/bootstrap.js\"></script><script src=\"bower_components/canvg/dist/canvg.bundle.js\"></script><script src=\"bower_components/canvg/dist/canvg.bundle.min.js\"></script><script src=\"bower_components/csv-js/csv.js\"></script><script src=\"bower_components/d3/d3.js\"></script><script src=\"bower_components/d3-tip/index.js\"></script><script src=\"bower_components/html2canvas/build/html2canvas.js\"></script><script src=\"bower_components/js-xlsx/dist/xlsx.full.min.js\"></script><script src=\"bower_components/ngDialog/js/ngDialog.js\"></script><script src=\"bower_components/screenfull/dist/screenfull.js\"></script><script src=\"bower_components/six-framework/dist/six-framework.js\"></script><script src=\"bower_components/six-menu/dist/six-menu.js\"></script><script src=\"bower_components/six-toolbar/dist/six-toolbar.js\"></script><script src=\"bower_components/seiyria-bootstrap-slider/dist/bootstrap-slider.js\"></script><script src=\"bower_components/angular-bootstrap-slider/slider.js\"></script><script src=\"bower_components/angular-ui-scroll/dist/ui-scroll.js\"></script><script src=\"bower_components/angular-ui-scrollpoint/dist/scrollpoint.js\"></script><script src=\"bower_components/angular-ui-event/dist/event.js\"></script><script src=\"bower_components/angular-ui-mask/dist/mask.js\"></script><script src=\"bower_components/angular-ui-validate/dist/validate.js\"></script><script src=\"bower_components/angular-ui-indeterminate/dist/indeterminate.js\"></script><script src=\"bower_components/angular-ui-uploader/dist/uploader.js\"></script><script src=\"bower_components/angular-ui-utils/index.js\"></script><script src=\"bower_components/angular-strap/dist/angular-strap.js\"></script><script src=\"bower_components/angular-strap/dist/angular-strap.tpl.js\"></script><script src=\"bower_components/angular-schema-form-dynamic-select/angular-schema-form-dynamic-select.min.js\"></script><script src=\"bower_components/angular-schema-form-multiple-sixlookup/angular-schema-form-multiple-sixlookup.js\"></script><script src=\"bower_components/angular-md5/angular-md5.js\"></script><script src=\"bower_components/qrcode-generator/js/qrcode.js\"></script><script src=\"bower_components/qrcode-generator/js/qrcode_UTF8.js\"></script><script src=\"bower_components/angular-qrcode/angular-qrcode.js\"></script><script src=\"bower_components/moment/moment.js\"></script><script src=\"bower_components/angular-moment/angular-moment.js\"></script><script src=\"bower_components/angular-gantt/assets/angular-gantt.js\"></script><script src=\"bower_components/angular-gantt/assets/angular-gantt-plugins.js\"></script><script src=\"bower_components/keycloak/dist/keycloak.js\"></script><script src=\"bower_components/angular-file-upload/dist/angular-file-upload.min.js\"></script><script src=\"bower_components/angular-loading-bar/build/loading-bar.js\"></script><script src=\"bower_components/ng-tags-input/ng-tags-input.js\"></script><script src=\"app.constants.js\"></script></body></html>");
$templateCache.put("theme/app.html","<script type=\"text/ng-template\" id=\"frontendInfo\"><h4> <div class=\"label label-success pull-left m-xs wrapper-xs\"> <b>{{frontEndInfo.title}}</b><br> <i>{{frontEndInfo.vendor}}</i><br> v. {{frontEndInfo.version}}<br> Rev. {{frontEndInfo.revision | limitTo: 8}} ({{frontEndInfo.gitbranch}})<br> Built on {{frontEndInfo.builddate | date: \"yyyy-MM-dd HH:mm:ss\"}}<br> Build profile: {{frontEndInfo.buildprofile}}<br> CI pipeline: {{frontEndInfo.cipipelineid}}<br> CI build: {{frontEndInfo.cibuildid}}<br> </div> </h4></script><script type=\"text/ng-template\" id=\"moduleInfo\"><h4> <div class=\"label label-info pull-left m-xs wrapper-xs\"> <b>{{info.title}}</b><br> <i>{{info.vendor}}</i><br> v. {{info.version}}<br> Rev. {{info.gitSHA1 | limitTo : 8}} ({{info.gitbranch}})<br> Built on {{info.buildtime | date: \"yyyy-MM-dd HH:mm:ss\"}}<br> Build profile: {{info.buildprofile}}<br> CI pipeline: {{info.cipipelineid}}<br> CI build: {{info.cibuildid}}<br> </div> </h4></script><script type=\"text/ng-template\" id=\"modulesInfo.html\"><h4 class=\"text-center\">Versione moduli</h4> <div ng-include=\"\'frontendInfo\'\" class=\"col-md-6\"></div> <div ng-include=\"\'moduleInfo\'\" class=\"col-md-6\" ng-repeat=\"info in modulesInfo\"></div></script><div id=\"loading-bar-container\"></div><toaster-container></toaster-container><six-framework caption=\"{{app.caption}}\" logo=\"{{app.logo}}\" commissions=\"true\" logout-label=\"Logout\" emma=\"\"><six-menu></six-menu></six-framework><six-profile ng-if=\"isLoggedIn()\" sx-profile-items=\"profileItems\"></six-profile><div class=\"app-content\"><div ui-butterbar=\"\"></div><a href=\"\" class=\"off-screen-toggle hide\" ui-toggle-class=\"off-screen\" data-target=\".app-aside\"></a><div class=\"app-content-body fade-in-up\" autoscroll=\"true\" ng-view=\"\"></div></div><div class=\"app-footer b-t bg-light\"><a class=\"pull-right\" ng-click=\"showVersion()\">{{app.version}} <span href=\"\" ui-scroll-to=\"scroll-top-target\" class=\"m-l-sm text-muted\"><button class=\"btn\" id=\"scroll-top-button\"><i class=\"fa fa-arrow-up\"></i></button></span></a> <span class=\"app-copyright\">&copy; 2017 Copyright.</span></div>");
$templateCache.put("theme/main.html","");
$templateCache.put("theme/view404.html","<div class=\"col-md-12 wrapper-md\"><div class=\"container\"><h1>Not found <span>:(</span></h1><p>Sorry, but the page you were trying to view does not exist.</p><p>It looks like this was the result of either:</p><ul><li>a mistyped address</li><li>an out-of-date link</li></ul><script>\n      var GOOG_FIXURL_LANG = (navigator.language || \'\').slice(0,2),GOOG_FIXURL_SITE = location.host;\n    </script><script src=\"//linkhelp.clients.google.com/tbproxy/lh/wm/fixurl.js\"></script></div></div>");
$templateCache.put("theme/wysiwyg.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Invia messaggio</h1><small class=\"text-muted\">Composizione messaggio</small></div></div></div><div class=\"panel wrapper\"><div class=\"panel-body\"><six-send-email sx-title-mail=\"\'\'\" sx-body-mail=\"\'\'\" sx-to-mail=\"\'\'\" sx-cc-mail=\"\'\'\"></six-send-email></div></div></div>");
$templateCache.put("consip/acquisitionstep/acquisitionstep_detail.html","<six-toolbar><six-toolbar-button label=\"Lista\" icon=\"fa fa-chevron-left\" toolbar-function=\"back()\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" sx-disabled=\"!selected.version\" ng-confirm-message=\"Sei sicuro?\" ng-confirm-click=\"delete(selected.version)\" ng-confirm-condition=\"true\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"save()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Dettaglio Step di Acquisizione</h1></div></div></div><div class=\"panel wrapper\"><div class=\"panel-heading\"><div class=\"page-header-bleed-right\"><div class=\"actions\"><div class=\"row\"><form name=\"header\"><div class=\"form-group\"><label id=\"schema_id_key\" for=\"code\" class=\"col-md-1 control-label\">Codice</label><div class=\"col-md-12\"><input type=\"text\" class=\"form-control\" id=\"code\" placeholder=\"\" ng-model=\"selected.model.code\" name=\"code\" required=\"\" readonly=\"\"><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"header.code.$error.required\">Obbligatorio</span></div></div></div><div class=\"form-group\"><label id=\"schema_desc_key\" for=\"description\" class=\"col-md-1 control-label\">Descrizione</label><div class=\"col-md-12\"><input type=\"text\" class=\"form-control\" id=\"description\" placeholder=\"\" ng-model=\"selected.model.description\" name=\"description\" ng-keyup=\"refreshDescription(selected.model.description)\" required=\"\"><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"header.description.$error.required\">Obbligatorio</span></div></div></div><div class=\"form-group\"><div class=\"col-md-12\"><input type=\"checkbox\" id=\"attachment_management\" ng-model=\"attachmentManagement\" name=\"attachment_management\"> <label id=\"attachment_management_key\" for=\"attachment_management\" class=\"control-label\">Gestione allegati</label></div><div class=\"col-md-12\"><input type=\"checkbox\" id=\"custom_form\" ng-model=\"customForm\" name=\"custom_form\"> <label id=\"custom_form_key\" for=\"custom_form\" class=\"control-label\">Form custom</label></div></div></form></div></div></div></div><div class=\"panel-body\"><uib-tabset justified=\"true\"><uib-tab heading=\"Step\"><form name=\"myForm\" sf-schema=\"schema\" sf-form=\"form\" sf-model=\"model\" ng-submit=\"onSubmit(myForm)\"></form></uib-tab><uib-tab heading=\"Schema\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><div class=\"col-md-12 centered\"><b>SCHEMA</b></div><div class=\"col-md-12 override-padding-no-pad-left-right\"><hr class=\"override-margin-top-bottom\"></div><div class=\"col-md-12 centered\"><div class=\"col-md-2 col-md-offset-1\"><b>CODICE</b></div><div class=\"col-md-3\"><b>DESCRIZIONE</b></div><div class=\"col-md-1\"><b>TIPOLOGIA</b></div><div class=\"col-md-2\"><b>FORMATO</b></div></div><div class=\"col-md-12 override-padding-no-pad-left-right\"><hr class=\"override-margin-top-bottom\"></div><div class=\"col-md-12 centered\"><div class=\"col-md-2 col-md-offset-1\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><form name=\"propertyKeyForm\"><input class=\"form-control\" name=\"property_key\" placeholder=\"Codice...\" type=\"text\" ng-model=\"property.key\" pattern=\"^[a-zA-Z]+[\\w]*$\"><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"propertyKeyForm.property_key.$error.pattern\">Caratteri non consentiti</span></div></form></div></div><div class=\"col-md-3\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><input class=\"form-control\" placeholder=\"Descrizione\" type=\"text\" ng-model=\"property.title\"></div></div><div class=\"col-md-1\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><select class=\"form-control\" ng-model=\"property.type\"><option></option><option value=\"string\">string</option><option value=\"number\">number</option><option value=\"integer\">integer</option><option value=\"boolean\">boolean</option><option value=\"date\">date</option><option value=\"array\">array</option></select></div></div><div class=\"col-md-2\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><select class=\"form-control\" ng-model=\"property.format\" ng-if=\"(property.type == \'string\')\"><option></option><option value=\"lookup\">lookup</option><option value=\"formula\">formula</option><option value=\"enum\">enum</option></select><select class=\"form-control\" ng-model=\"property.format\" ng-if=\"(property.type == \'number\' || property.type == \'integer\')\"><option></option><option value=\"formula\">formula</option><option value=\"enum\">enum</option></select><select class=\"form-control\" ng-model=\"property.items_type\" ng-if=\"(property.type == \'array\')\"><option></option><option value=\"lookup\">lookup</option><option value=\"string\">string</option><option value=\"number\">number</option><option value=\"integer\">integer</option><option value=\"date\">date</option></select></div></div><div class=\"col-md-2\"><div ng-if=\"isInheritable(property.type)\"><label><input type=\"checkbox\" ng-model=\"property.inherited\"> Campo ereditato</label></div></div><div class=\"col-md-1\"><button ng-click=\"addProperty()\" class=\"btn btn-sm btn-info pull-right\"><span class=\"fa fa-plus\"></span> Add</button></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-repeat=\"(key, value) in selected.model.schema.properties\" style=\"align-content: center; padding-bottom: 0px;\"><div class=\"col-md-12 uniform-height\" style=\"align-content: center;\"><div class=\"col-md-1\"><a href=\"\" ng-click=\"status[key].open = !status[key].open\" id=\"btn_row_detail\"><i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status[key].open, \'glyphicon-chevron-right\': !status[key].open}\"></i></a></div><div class=\"col-md-2\">{{ key }}</div><div class=\"col-md-3\">{{ value.title }}</div><div class=\"col-md-1\">{{ value.type }}</div><div class=\"col-md-2\"><span ng-if=\"value.format\">{{value.format}}</span> <span ng-if=\"value.type == \'array\' && value.items\">{{value.items.format}}</span></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-show=\"status[key].open\"><div class=\"col-md-12 uniform-height-2\" ng-if=\"value.format !== \'lookup\' && value.format !== \'formula\' && value.format !== \'enum\' && value.format !== \'inherit\' && value.type !== \'array\'\"><div class=\"col-md-2\">FORMATO:</div><div class=\"col-md-10\">{{value.format}}</div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">PROPAGA VALORE:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.enableCopyTo\" ng-change=\"refreshCopyToCheckbox(key, value.enableCopyTo)\"></div></div><div class=\"col-md-12\" ng-if=\"value.enableCopyTo == true\"><div class=\"col-md-2 uniform-height-2\">CAMPI DI DESTINAZIONE:</div><div class=\"col-md-10 uniform-height-2\"><input type=\"{{itemTypeMap[key]}}\" size=\"45\" name=\"new_item_name\" ng-model=\"newItem.name\"> <button ng-click=\"addItemCopyTo(key, newItem)\" class=\"btn btn-xs btn-info equal-margin-left-right\"><span class=\"fa fa-plus\"></span> Add</button></div><div class=\"col-md-10 col-md-offset-2\"><div class=\"col-md-12 override-padding-no-pad-left-right uniform-height-2\" ng-repeat=\"itemArray in value.copyTo track by $index\" ng-if=\"itemArray != \'\'\"><input type=\"text\" size=\"45\" name=\"item_name\" ng-model=\"itemArray\" disabled=\"\"> <button ng-click=\"deleteItemCopyTo(key,itemArray)\" class=\"btn btn-danger btn-xs btn-default equal-margin-left-right\"><i class=\"fa fa-trash\"></i></button></div></div></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'inherit\'\" ng-include=\"\'views/modeltype/detail_inherit.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'lookup\' && value.type != \'array\'\" ng-include=\"\'views/modeltype/detail_lookup.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'formula\'\" ng-include=\"\'views/modeltype/detail_formula.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'enum\'\" ng-include=\"\'views/modeltype/detail_enum.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.type === \'array\'\" ng-include=\"\'views/modeltype/detail_array.html\'\"></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">ELIMINA:</div><div class=\"col-md-10\"><button ng-click=\"deleteProperty(key)\" class=\"btn btn-danger btn-xs btn-default\" ng-disabled=\"(key === \'code\' || key === \'description\')\"><i class=\"fa fa-trash\"></i></button></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">IN TABELLA:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.check\" ng-change=\"changeColumnDefs(key, value)\" ng-disabled=\"(key === \'code\' || key === \'description\')\"></div></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-show=\"value.check == true\"><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">LARGHEZZA (px):</div><div class=\"col-md-10\"><input type=\"text\" min=\"1\" step=\"1\" size=\"45\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=\"value.width\" ng-change=\"changeColumnDefs(key, value)\"></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">ORDINAMENTO:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.enableSorting\" ng-change=\"changeColumnDefs(key, value)\"></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">FILTRAGGIO:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.enableFiltering\" ng-change=\"changeColumnDefs(key, value)\"></div></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div></div></div></div></uib-tab><uib-tab heading=\"Form\"><table class=\"table table-striped\"><thead><th colspan=\"5\">FORM</th><tr><th colspan=\"5\"><div class=\"form-group\"><label for=\"title\" class=\"control-label\">Titolo</label><div class=\"\"><input type=\"text\" class=\"form-control\" id=\"title\" placeholder=\"\" ng-model=\"title\" name=\"title\" ng-keyup=\"refreshTitleForm(title)\"></div></div></th></tr><tr><td></td><td></td><td><input type=\"text\" placeholder=\"Titolo...\" ng-model=\"newTab.title\"></td><td><button ng-click=\"addTab(selected.model.form[0].items[0])\" class=\"btn btn-xs btn-info\"><span class=\"fa fa-plus\"></span> Add</button></td></tr><tr><th></th><th>POSIZIONE</th><th>TITOLO</th><th></th></tr></thead><tbody><tr ng-repeat-start=\"(key, tab) in selected.model.form[0].items[0].tabs\"><td><a href=\"\" ng-click=\"statusForm[key].open = !statusForm[key].open\"><i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': statusForm[key].open, \'glyphicon-chevron-right\': !statusForm[key].open}\"></i></a></td><td><span class=\"btn btn-sm\" ng-click=\"swapUp(key, selected.model.form[0].items[0].tabs)\" ng-disabled=\"key<=0\"><i class=\"fa fa-caret-up\"></i></span> {{key+1}} <span class=\"btn btn-sm\" ng-click=\"swapDown(key, selected.model.form[0].items[0].tabs)\" ng-disabled=\"key>=selected.model.form[0].items[0].tabs.length-1\"><i class=\"fa fa-caret-down\"></i></span></td><td><input type=\"text\" ng-model=\"tab.title\" ng-disabled=\"(tab.key[0] == \'code\' || tab.key[0] == \'description\')\" ng-keyup=\"updateScope()\"></td><td><a ng-click=\"removeTabOrField(key, selected.model.form[0].items[0].tabs)\" class=\"btn btn-danger btn-xs btn-default\" id=\"btn_row_detail_form\"><i class=\"fa fa-trash\"></i></a></td></tr><tr ng-repeat-end=\"\" ng-show=\"statusForm[key].open\"><td></td><td colspan=\"3\" style=\"background-color:rgba(211, 211, 211, 0.38);\"><table class=\"table table-striped override-margin\"><tr><td></td><td><select ng-options=\"k as v.title for (k, v) in schema.properties\" ng-model=\"newFieldForm.key\"></select></td><td><input type=\"text\" placeholder=\"Titolo...\" ng-model=\"newFieldForm.title\"></td><td><input type=\"checkbox\" placeholder=\"Richiesto...\" ng-model=\"newFieldForm.required\"></td><td><input type=\"checkbox\" placeholder=\"Nascosto...\" ng-model=\"newFieldForm.htmlClass\" ng-true-value=\"\'hidden\'\" ng-false-value=\"\'\'\"></td><td><select ng-model=\"newFieldForm.type\" ng-change=\"updateScope()\"><option value=\"\"></option><option value=\"text\">text</option><option value=\"textarea\">textarea</option><option value=\"number\">number</option><option value=\"datepicker\">date</option><option value=\"password\">password</option><option value=\"checkbox\">checkbox</option><option value=\"select\">enum</option><option value=\"array\">array</option><option value=\"sixlookup\">lookup</option><option value=\"inherited\">ereditato</option><option value=\"formula\">formula</option></select></td><td><button ng-click=\"addFieldToTab(tab)\" class=\"btn btn-xs btn-info\"><span class=\"fa fa-plus\"></span> Add</button></td></tr><tr><th>POSIZIONE</th><th>CAMPO</th><th>TITOLO</th><th>REQUIRED</th><th>NASCOSTO</th><th>TIPO</th><th></th></tr><tr ng-repeat=\"(fieldKey, field) in tab.items\"><td class=\"override-width-200px\"><div><span class=\"btn btn-sm\" ng-click=\"swapUp(fieldKey, tab.items)\" ng-disabled=\"fieldKey<=0\"><i class=\"fa fa-caret-up\"></i></span> {{fieldKey+1}} <span class=\"btn btn-sm\" ng-click=\"swapDown(fieldKey, tab.items)\" ng-disabled=\"fieldKey>=tab.items.length-1\"><i class=\"fa fa-caret-down\"></i></span></div></td><td ng-if=\"!field.title\">{{field}}</td><td ng-if=\"!field.title\"></td><td ng-if=\"!field.title\"></td><td ng-if=\"!field.title\"></td><td ng-if=\"field.title\">{{field.key[0]}}</td><td ng-if=\"field.title\"><input type=\"text\" ng-model=\"field.title\" ng-keyup=\"updateScope()\"></td><td ng-if=\"field.title\"><input type=\"checkbox\" ng-model=\"field.required\" ng-change=\"updateScope()\"></td><td ng-if=\"field.title\"><input type=\"checkbox\" ng-model=\"field.htmlClass\" ng-change=\"updateScope()\" ng-true-value=\"\'hidden\'\" ng-false-value=\"\'\'\"></td><td ng-if=\"field.title\"><select ng-model=\"field.type\" ng-change=\"updateField(field)\"><option value=\"\"></option><option value=\"text\">text</option><option value=\"textarea\">textarea</option><option value=\"number\">number</option><option value=\"datepicker\">date</option><option value=\"password\">password</option><option value=\"checkbox\">checkbox</option><option value=\"select\">enum</option><option value=\"array\">array</option><option value=\"sixlookup\">lookup</option><option value=\"inherited\">ereditato</option><option value=\"formula\">formula</option></select></td><td><a ng-click=\"removeTabOrField(fieldKey, tab.items)\" class=\"btn btn-danger btn-xs btn-default\"><i class=\"fa fa-trash\"></i></a></td></tr></table></td></tr></tbody></table></uib-tab></uib-tabset></div><div class=\"panel-footer\"><div class=\"form-group\"><input id=\"jsonShowCheck\" type=\"checkbox\" ng-model=\"jsonshow\" data-toggle=\"collapse\" data-target=\"#json-collapse\" class=\"pull-left\"> <label for=\"jsonShowCheck\" class=\"pull-left control-label\">Dettaglio avanzato</label></div></div></div><div class=\"row collapse\" id=\"json-collapse\"><div class=\"col-md-8\"><div class=\"panel-heading wrapper b-b b-light\"><h4 class=\"font-thin m-t-none m-b-none text-muted\">Dettaglio</h4></div><div style=\"margin-top:0px;\" ui-ace=\"{ useWrapMode : true, showGutter: true, mode: \'json\', firstLineNumber: 1, onLoad: aceLoaded, onChange: aceChanged }\" ng-model=\"aceModel\"></div><div class=\"panel-footer\"></div></div><div class=\"col-md-4\"><div class=\"list-group list-group-lg list-group-sp\"><pre>{{ model}}</pre></div></div></div></div></div>");
$templateCache.put("consip/acquisitionstep/acquisitionstep_list.html","<six-toolbar><six-toolbar-button label=\"Crea step\" icon=\"fa fa-plus\" toolbar-function=\"newStep()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"refresh()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista step di acquisizione</h1></div></div></div><div class=\"panel-body\"><table id=\"step_list\" class=\"table table-striped\"><thead><tr><th></th><th>CODICE</th><th>DESCRIZIONE</th></tr></thead><tbody><tr ng-repeat=\"item in stepList.list\"><td><a ng-href=\"#/acquisitionstep/{{item.UUID}}\" class=\"btn btn-default\"><span class=\"fa fa-search\"></span></a></td><td>{{ item.model.code }}</td><td>{{ item.model.description }}</td></tr><tr ng-hide=\"stepList.list.length\"><td><p class=\"text-center\">Nessun record recuperato</p></td></tr></tbody></table></div><div class=\"panel-footer\"><div class=\"row text-center\"><uib-pagination ng-change=\"pageChanged()\" boundary-links=\"true\" total-items=\"stepList.totalResults\" ng-model=\"stepList.currentPage\" class=\"pagination-sm\" items-per-page=\"stepList.pageSize\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></uib-pagination></div></div></div></div>");
$templateCache.put("consip/acquisitionstep/opf.html","<div ng-controller=\"OpfCtrl\"><div><table class=\"table table-hover\"><thead><tr><th></th><th>Totale Canone</th><th>Totale Extra Canone</th><th>Totale</th><th></th></tr></thead><tbody><tr><td>Acquisizione</td><td>{{opfModel.totals.canone | currency}}</td><td>{{opfModel.totals.extra_canone | currency}}</td><td>{{opfModel.totals.total | currency}}</td></tr><tr ng-repeat=\"oat in additionalActs\"><td>Atto aggiuntivo</td><td>{{oat.totals.canone | currency}}</td><td>{{oat.totals.extra_canone | currency}}</td><td>{{oat.totals.total | currency}}</td><td><a ng-href=\"#/additionalacts/detail/{{oat.UUID}}\" class=\"btn btn-xs btn-primary\">{{oat.UUID}}</a></td></tr></tbody><tfoot ng-if=\"additionalActs.length>0\"><tr><th></th><th>{{opfModel.totals.canone + additionalActTotals.canone | currency }}</th><th>{{opfModel.totals.extra_canone + additionalActTotals.extra_canone | currency }}</th><th>{{opfModel.totals.total + additionalActTotals.total | currency }}</th><th></th></tr></tfoot></table></div><form name=\"{{opfId}}\" id=\"{{opfId}}\" class=\"form-validation\"><uib-tabset class=\"tabs-left\"><uib-tab index=\"$index\" ng-repeat=\"tab in (opfForm[0].items[0].tabs)\" heading=\"{{tab.title}}\"><div ng-switch=\"\" on=\"tab.title\"><div class=\"row\" ng-switch-when=\"Opf|Emissione\" ng-switch-when-separator=\"|\"><div class=\"form-group col-md-4\" ng-repeat=\"item in tab.items | filter:validFormItem\"><label class=\"control-label\">{{item.title}}</label><div ng-switch=\"\" on=\"item.type\"><div class=\"input-group w-full\" ng-switch-when=\"textarea\"><textarea class=\"sf-form-control form-control\" ng-model=\"data.model[item.key[0]]\" ng-required=\"item.required\" aria-describedby=\"sizing-addon\"></textarea></div><div ng-switch-when=\"sixlookup\"><six-lookup class=\"sf-form-control\" ng-model=\"data.model\" sx-type=\"item.entity_id\" sx-field=\"item.key[0]\" sx-war=\"schema.properties[item.key[0]].war\" ng-required=\"item.required\"></six-lookup></div><div class=\"input-group w-full\" ng-switch-default=\"\"><span class=\"input-group-addon\" ng-if=\"item.fieldAddonLeft\">{{item.fieldAddonLeft}}</span> <input class=\"sf-form-control form-control\" type=\"{{getInputType(item)}}\" step=\"any\" ng-model=\"data.model[item.key[0]]\" ng-required=\"item.required\" aria-describedby=\"sizing-addon\" ng-readonly=\"item.key[0]===\'reserved_amount\'\"></div></div></div></div><div class=\"row\" ng-switch-when=\"Sezione Economica\"><div class=\"col-lg-12\"><div ui-grid=\"gridSeOptions\" class=\"grid\" style=\"height: 420px\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\" ui-grid-auto-resize=\"\"></div></div><div class=\"col-lg-12\"><a href=\"\" class=\"btn btn-sm btn-info m-t pull-right\" ng-click=\"exportSe()\"><i class=\"fa fa-download\"></i> XLS</a></div></div><div class=\"row\" ng-switch-when=\"Dett.Val.Economici\"><div class=\"col-lg-12\"><div ui-grid=\"gridDveOptions\" class=\"grid\" style=\"height: 420px\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\" ui-grid-auto-resize=\"\"></div></div><div class=\"col-lg-12\"><a href=\"\" class=\"btn btn-sm btn-info m-t pull-right\" ng-click=\"exportDve()\"><i class=\"fa fa-download\"></i> XLS</a></div></div><div class=\"row\" ng-switch-when=\"Email\"><div class=\"col-md-12\" ng-init=\"getMessage()\"><div class=\"col-md-12\" ng-if=\"loadingSixMail == true\"><uib-progressbar class=\"progress-striped active\" type=\"info\"><i>Caricamento messaggio</i></uib-progressbar></div><six-send-email ng-if=\"!loadingSixMail\" sx-title-mail=\"objMail.title\" sx-body-mail=\"objMail.message\" sx-to-mail=\"objMail.to\" sx-cc-mail=\"objMail.cc\" sx-type-mail=\"\'opf\'\" sx-record-id=\"opfRef\"></six-send-email></div></div><div class=\"row wrapper\" ng-switch-default=\"\"><div class=\"col-md-12\"><div class=\"alert alert-info\">Non ci sono elementi da visualizzare</div></div></div></div></uib-tab></uib-tabset></form></div>");
$templateCache.put("consip/acquisitionstep/pdi.html","<div ng-controller=\"PdiCtrl\"><div class=\"wrapper m-t-n-sm\"><form id=\"{{pdiId}}\" name=\"{{pdiId}}\"><div class=\"override-form-group override-checkbox\" sf-schema=\"pdiSchema\" sf-form=\"pdiForm\" sf-model=\"pdiModel\" update-six-formula=\"\"></div></form></div><div id=\"upload_div\" class=\"m-t-sm\" ng-controller=\"CreatePdi\"><div class=\"col col-md-12 wrapper\" ng-if=\"upload.errors.length>0\"><div class=\"alert alert-danger\"><strong>Caricamento FALLITO</strong><div ng-repeat=\"error in upload.errors\">{{error}}</div></div></div><input type=\"file\" id=\"fileUploadBtn\" nv-file-select=\"\" uploader=\"uploader\" multiple=\"\" ng-hide=\"true\"> <button class=\"btn btn-default\" ng-click=\"loadQuote()\" ng-hide=\"readonlyMode || upload.show\">Carica preventivo</button><div class=\"panel panel-default\" ng-if=\"upload.show\"><div class=\"wrapper-xs panel-heading text-md text-center\"><button class=\"btn btn-default btn-xs pull-left\" ng-click=\"undoUpload()\" ng-disabled=\"upload.started\"><span class=\"fa fa-undo\"></span> Annulla</button> Nuovo preventivo <button class=\"btn btn-success btn-xs pull-right\" ng-click=\"uploader.uploadAll()\" ng-disabled=\"confirmDisabled()\"><span class=\"fa fa-check\"></span> Conferma</button></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col col-md-6\"><label for=\"quote_date\" class=\"control-label\">Data creazione revisione</label><p class=\"input-group\" style=\"width:100%\"><input type=\"text\" name=\"toDate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"revision.date_emission\" is-open=\"upload.pupupEmissionOpened\" datepicker-options=\"dateOptions\" close-text=\"Chiudi\" current-text=\"Oggi\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"upload.pupupEmissionOpened=!upload.pupupEmissionOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><span class=\"badge bg-danger badge-sm m-l-xs\" ng-hide=\"revision.date_emission\">Obbligatorio</span></div><div class=\"col col-md-6\"><label for=\"quote_date\" class=\"control-label\">Numero di revisione</label><div class=\"input-group\" style=\"width:100%\"><input name=\"quote_date\" type=\"text\" ng-model=\"revision.revision_number\" class=\"form-control\"></div><span class=\"badge bg-danger badge-sm m-l-xs\" ng-hide=\"revision.revision_number\">Obbligatorio</span></div></div><div class=\"alert alert-warning\" ng-if=\"upload.warnings.length\"><strong>Attenzione</strong><div ng-repeat=\"warning in upload.warnings track by $index\">{{warning}}</div></div><table class=\"table\"><thead><tr><th style=\"width: 15px;\"></th><th>Nome file</th><th ng-show=\"uploader.isHTML5\">Dimensione</th><th ng-show=\"uploader.isHTML5\">Avanzamento</th></tr></thead><tbody><tr ng-repeat=\"item in uploader.queue\" ng-init=\"item.popupSendingOpened=false\"><td><a href=\"\" ng-click=\"remove(item)\"><i class=\"fa fa-trash text-danger\"></i></a></td><td><strong>{{ item.file.name }}</strong></td><td ng-show=\"uploader.isHTML5\" nowrap=\"\">{{ item.file.size/1024/1024|number:2 }} MB</td><td ng-show=\"uploader.isHTML5\"><div class=\"progress\" style=\"margin-bottom: 0;\"><div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{ \'width\': item.progress + \'%\' }\"></div></div></td></tr><tr><td colspan=\"5\"><button class=\"btn btn-primary btn-sm\" ng-click=\"addQuote()\"><span class=\"fa fa-plus\"></span> Aggiungi file</button></td></tr></tbody></table><div class=\"row\"><div class=\"col-lg-12\" ng-hide=\"hasXls\"><div class=\"alert alert-danger\"><strong>Obbligatorio:</strong> inserire anche un preventivo in formato Excel</div></div><div class=\"col-lg-12\" ng-show=\"hasXls\"><import-pdi xls-data=\"xlsData\" on-error=\"onInvalidPdi()\"></import-pdi></div></div></div></div></div><div id=\"uploaded_div\" class=\"wrapper\"><div ng-hide=\"(revisions.length>0) || (upload.show)\" class=\"alert alert-info\">Nessun preventivo trovato</div><div ng-show=\"revisions.length>0\"><div class=\"legend\"><span class=\"text-xs text-muted pull-right\"><i class=\"fa fa-circle text-warning m-r-xs m-l-sm\"></i> inserita <i class=\"fa fa-circle text-info m-r-xs m-l-sm\"></i> approvata <i class=\"fa fa-circle text-danger m-r-xs m-l-sm\"></i> rifiutata</span> <span style=\"clear:both\"></span></div><div class=\"pdi_element\" ng-repeat=\"revision in revisions track by $index\"><h4 class=\"pdi_title\" ng-if=\"differentFromPrevious($index)\"><i class=\"fa fa-circle text-warning\" ng-if=\"isInserted(revision,$index)\"></i> <i class=\"fa fa-circle text-danger\" ng-if=\"isRefused(revision,$index)\"></i> <i class=\"fa fa-circle text-info\" ng-if=\"isApproved(revision,$index)\"></i> Revisione <strong>{{ revision.revision_number }}</strong></h4><div class=\"row pdi_file_row\" ng-if=\"differentFromPrevious($index)\"><div class=\"col col-md-3\" ng-repeat=\"file in revision.files\"><div class=\"pdi_file\"><span class=\"pull-left thumb-sm\"><i class=\"fa fa-file-o fa-2x text-muted\"></i></span><div class=\"media-body\"><a ng-href=\"{{DOWNLOAD_URL}}{{transformObjectIdForBackend(file.object_id)}}\" target=\"_blank\" download=\"{{file.title}}\" class=\"h5\">{{file.title}}</a> <small class=\"block\">{{file.date_insertion | date:\'dd/MM/yyyy\'}}</small></div></div></div></div><div class=\"row\" style=\"font-weight:bold\" ng-if=\"differentFromPrevious($index)\"><div class=\"col-xs-2 col-sm-2 col-md-2\">Stato</div><div class=\"col-xs-2 col-sm-2 col-md-2\">Data creazione</div><div class=\"col-xs-2 col-sm-2 col-md-2\">Data approvazione</div><div class=\"col-xs-2 col-sm-2 col-md-2\">Data rifiuto</div><div class=\"col-xs-4 col-sm-4 col-md-4\">Azioni</div></div><div class=\"row\"><div class=\"col-xs-2 col-sm-2 col-md-2\"><span><span ng-if=\"isInserted(revision)\">Inserita</span> <span ng-if=\"isRefused(revision)\">Rifiutata</span> <span ng-if=\"isApproved(revision)\">Approvata</span></span></div><div class=\"col-xs-2 col-sm-2 col-md-2\"><span ng-if=\"!editing[$index]\">{{revision.date_emission | date:\'dd/MM/yyyy\'}}</span> <span ng-if=\"editing[$index]\"><p class=\"input-group\" ng-class=\"{\'has-error\': datesError}\" style=\"width:100%\" ng-if=\"revision.date_emission\"><input type=\"text\" ng-change=\"areDatesValid($index)\" name=\"toDate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"editData.date_emission\" is-open=\"upload.pupupEmissionOpened\" datepicker-options=\"dateOptions\" close-text=\"Chiudi\" current-text=\"Oggi\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-class=\"{\'btn-danger\': datesError}\" ng-click=\"upload.pupupEmissionOpened=!upload.pupupEmissionOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></span></div><div class=\"col-xs-2 col-sm-2 col-md-2\"><span ng-if=\"!editing[$index]\">{{revision.date_approval | date:\'dd/MM/yyyy\'}}</span> <span ng-if=\"editing[$index]\"><p class=\"input-group\" ng-class=\"{\'has-error\': datesError}\" style=\"width:100%\" ng-if=\"revision.date_approval\"><input type=\"text\" ng-change=\"areDatesValid($index)\" name=\"toDate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"editData.date_approval\" is-open=\"upload.pupupApprovalOpened\" datepicker-options=\"dateOptions\" close-text=\"Chiudi\" current-text=\"Oggi\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-class=\"{\'btn-danger\': datesError}\" ng-click=\"upload.pupupApprovalOpened=!upload.pupupApprovalOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></span></div><div class=\"col-xs-2 col-sm-2 col-md-2\"><span ng-if=\"!editing[$index]\">{{revision.date_refusal | date:\'dd/MM/yyyy\'}}</span> <span ng-if=\"editing[$index]\"><p class=\"input-group\" ng-class=\"{\'has-error\': datesError}\" style=\"width:100%\" ng-if=\"revision.date_refusal\"><input type=\"text\" ng-change=\"areDatesValid($index)\" name=\"toDate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"editData.date_refusal\" is-open=\"upload.pupupRefusalOpened\" datepicker-options=\"dateOptions\" close-text=\"Chiudi\" current-text=\"Oggi\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-class=\"{\'btn-danger\': datesError}\" ng-click=\"upload.pupupRefusalOpened=!upload.pupupRefusalOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></span></div><div class=\"col-xs-4 col-sm-4 col-md-4\"><span ng-if=\"!isOld(revision)\"><button class=\"btn btn-default\" ng-click=\"approveQuote(revision, $index)\" ng-disabled=\"readonlyMode || isApproved(revision) || uploadError\" ng-if=\"!editingMode\"><span class=\"fa fa-check text-info\"></span> Approva</button> <button class=\"btn btn-default\" ng-click=\"refuseQuote(revision, $index)\" ng-disabled=\"readonlyMode || isRefused(revision)\" ng-if=\"!editingMode\"><span class=\"fa fa-times text-danger\"></span> Rifiuta</button> <button class=\"btn btn-default\" ng-click=\"startEditQuote($index)\" ng-disabled=\"readonlyMode\" ng-if=\"!editingMode\"><span class=\"fa fa-pencil text-warning\"></span> Modifica</button> <button class=\"btn btn-default\" ng-click=\"stopEditQuote($index)\" ng-disabled=\"readonlyMode || datesError\" ng-if=\"editing[$index]\"><span class=\"fa fa-save text-success\"></span> Conferma</button> <button class=\"btn btn-default\" ng-click=\"undoEditQuote($index)\" ng-disabled=\"readonlyMode\" ng-if=\"editing[$index]\"><span class=\"fa fa-undo text-primary\"></span> Annulla</button></span></div></div></div></div></div><div ng-if=\"alfrescoList\"><pre>{{alfrescoList | json}}</pre></div></div>");
$templateCache.put("consip/acquisitionwizard/acquisitionwizard_detail.html","<six-toolbar><six-toolbar-item label=\"Marca come NON ADERENTE\" icon=\"fa fa-ban text-primary-dker\" toolbar-function=\"setNotAdherent()\" sx-disabled=\"isWizardReadonly()\" ng-hide=\"isNotAdherent()\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" ng-if=\"!isAdditionalAct\" toolbar-function=\"backToList()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-chevron-left\" ng-if=\"isAdditionalAct\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"save()\" sx-disabled=\"isWizardReadonly()\"></six-toolbar-button><six-toolbar-button label=\"Annulla step\" btn-class=\"btn-warning\" icon=\"fa fa-arrow-left\" toolbar-function=\"undoStep()\" sx-disabled=\"(maxActiveTab&lt;1) || isWizardReadonly()\"></six-toolbar-button><six-toolbar-button label=\"Approva step\" btn-class=\"btn-info\" icon=\"fa fa-arrow-right\" toolbar-function=\"approveStep()\" sx-disabled=\"isApprovalLocked() || isWizardReadonly()\"></six-toolbar-button><six-toolbar-button label=\"Atti aggiuntivi\" btn-class=\"btn-primary-override\" icon=\"fa fa-plus\" toolbar-function=\"insertAdditionalActs()\" ng-if=\"!isAdditionalAct && (wizard.model.current_step.status==\'terminated\')\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"fa fa-trash\" toolbar-function=\"delete()\" ng-if=\"!isWizardReadonly()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar alert alert-warning\" ng-if=\"isNotAdherent()\"><strong>Cliente non aderente.</strong> Convenzione rifiutata in data {{wizard.adhesion_refusal_date | date}}</div><div class=\"col-md-12\" ng-class=\"{\'override-padding-toolbar\': !isNotAdherent()}\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-md-12\"><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"!isAdditionalAct\">Acquisizione <span ng-if=\"wizard.model.code\">cod. {{wizard.model.code}}</span> cliente {{wizard.model.client_id.description}}</h1><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"isAdditionalAct\">Atto aggiuntivo per il cliente {{wizard.model.client_id.description}}</h1></div></div></div><div class=\"panel-body\"><uib-tabset active=\"activeTab\"><uib-tab ng-repeat=\"tab in tabs track by $index\" index=\"$index\" disable=\"tab.disabled\"><uib-tab-heading>{{tab.title}}<six-consip-timing-led sx-value=\"getStepDocument($index+1).timing_status\"></six-consip-timing-led></uib-tab-heading><uib-tabset class=\"tabs-right\"><uib-tab><uib-tab-heading><span class=\"fa fa-list-alt text-info-dker\"></span> Dati</uib-tab-heading><div class=\"row wrapper\" ng-if=\"!tab.customForm\"><form id=\"{{getId($index+1)}}\" name=\"{{getId($index+1)}}\"><div class=\"override-form-group override-checkbox\" sf-schema=\"tab.schema\" sf-form=\"tab.form\" sf-model=\"getModel($index+1)\" update-six-formula=\"\"></div><six-iterator-copy si-model=\"getModel($index+1)\" si-schema=\"tab.schema\" si-doc=\"wizard\" si-attribute=\"\'copyTo\'\"></six-iterator-copy></form></div><div class=\"row wrapper\" ng-if=\"tab.customForm\"><div ng-if=\"tab.code==\'pdi\' || tab.code==\'pditracciato\'\" ng-include=\"\'consip/acquisitionstep/pdi.html\'\"></div><div ng-if=\"tab.code==\'opf\' || tab.code==\'opftracciato\'\" ng-include=\"\'consip/acquisitionstep/opf.html\'\"></div></div></uib-tab><uib-tab ng-if=\"tab.attachmentManagement\"><uib-tab-heading><span class=\"fa fa-book text-info-dker\"></span> Allegati</uib-tab-heading><six-tree-attachments nodes=\"tab.attachments\" save-callback=\"updAttachments($index)\"></six-tree-attachments></uib-tab></uib-tabset></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("consip/acquisitionwizard/acquisitionwizard_list.html","<six-toolbar><six-toolbar-item label=\"Plafond disponibile: {{plafond.available | currency}}\" icon=\"fa fa-credit-card text-info-dker\"></six-toolbar-item><six-toolbar-item label=\"Plafond sottoscritto: {{plafond.used | currency}}\" icon=\"fa fa-credit-card text-primary-dker\"></six-toolbar-item><six-toolbar-item label=\"Plafond residuo: {{plafond.remaining | currency}}\" icon=\"fa fa-credit-card {{plafond.remaining_class}}\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-check\" label=\"Nuova acquisizione\" btn-class=\"btn-info\" toolbar-function=\"newWizard()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista Acquisizioni</h1></div></div></div><div class=\"panel-body\"><six-grid-pagination get-data-callback=\"getData()\" get-list-callback=\"getData()\" items-list=\"wizardList\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div></div>");
$templateCache.put("consip/acquisitionwizard/acquisitionwizard_new.html","<six-toolbar><six-toolbar-button icon=\"fa fa-plus\" label=\"Conferma\" btn-class=\"btn-info\" toolbar-function=\"confirmNewWizard()\" sx-disabled=\"!validDefaultSettings\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Creazione nuova acquisizione</h1></div></div></div><div class=\"panel-body\"><label class=\"control-label\">Seleziona cliente</label><six-lookup-2 ng-model=\"wizard\" sx-type=\"\'cliente\'\" sx-field=\"\'client_id\'\"></six-lookup-2></div></div></div>");
$templateCache.put("consip/acquisitionwizard/additionalacts_list.html","<six-toolbar><six-toolbar-item label=\"Plafond disponibile: {{plafond.available | currency}}\" icon=\"fa fa-credit-card text-info-dker\"></six-toolbar-item><six-toolbar-item label=\"Plafond sottoscritto: {{plafond.used | currency}}\" icon=\"fa fa-credit-card text-primary-dker\"></six-toolbar-item><six-toolbar-item label=\"Plafond residuo: {{plafond.remaining | currency}}\" icon=\"fa fa-credit-card {{plafond.remaining_class}}\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-plus\" label=\"Crea atto aggiuntivo\" btn-class=\"btn-info\" toolbar-function=\"newAdditionalAct()\" ng-if=\"sourceAcquisition\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-md-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista Atti Aggiuntivi</h1><small ng-if=\"sourceAcquisition\"><span class=\"text-muted\">Atti aggiuntivi generati a partire dall\'acquisizione di codice</span> {{sourceAcquisition.UUID}} <span class=\"text-muted\">per il cliente</span>{{sourceAcquisition.model.client_id.description}}</small></div></div></div><div class=\"panel-body\"><six-grid-pagination get-data-callback=\"getData()\" get-list-callback=\"getData()\" items-list=\"actsList\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div></div>");
$templateCache.put("consip/contract/contract.html","<six-toolbar><six-toolbar-item label=\"Plafond disponibile: {{plafond.available | currency}}\" icon=\"fa fa-credit-card text-info-dker\" ng-hide=\"!plafond_total\"></six-toolbar-item><six-toolbar-item label=\"Plafond sottoscritto: {{plafond.used | currency}}\" icon=\"fa fa-credit-card text-primary-dker\" ng-hide=\"!plafond_total\"></six-toolbar-item><six-toolbar-item label=\"Plafond residuo: {{plafond.remaining | currency}}\" icon=\"fa fa-credit-card {{plafond.remaining_class}}\" ng-hide=\"!plafond_total\"></six-toolbar-item><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"fa fa-trash-o\" toolbar-function=\"delete()\" sx-disabled=\"lock\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"onSubmit(header)\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\" ng-hide=\"selected.version\"><h1 class=\"m-n font-thin h3 text-black\">Nuova Convenzione</h1></div><div class=\"col-sm-6 col-xs-12\" ng-show=\"selected.version\"><h1 class=\"m-n font-thin h3 text-black\">Convenzione</h1></div></div></div><div class=\"panel-body\"><form name=\"header\" ng-submit=\"onSubmit(header)\"><uib-tabset><uib-tab index=\"0\" heading=\"Dati\"><div class=\"col-md-12\"><div class=\"row\"><div class=\"form-group col-md-6\"><label id=\"schema_id_key\" for=\"code\" class=\"control-label m-t-xxs\">Codice</label><div><input type=\"text\" class=\"form-control\" id=\"code\" placeholder=\"\" ng-model=\"selected.model.code\" name=\"code\" required=\"\"><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"header.code.$error.required\">Obbligatorio</span></div></div></div><div class=\"form-group col-md-6\"><label id=\"schema_desc_key\" for=\"description\" class=\"control-label m-t-xxs\">Descrizione</label><div><input type=\"text\" class=\"form-control\" id=\"description\" placeholder=\"\" ng-model=\"selected.model.description\" name=\"description\" required=\"\"><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"header.description.$error.required\">Obbligatorio</span></div></div></div><div class=\"form-group\"><div class=\"col-md-12\" ng-if=\"workflow.ref == \'\'\"><div uib-alert=\"\" class=\"alert-danger col-md-12\" style=\"display: flex\">Nessuna connessione al workflow</div></div><div ng-if=\"workflow.ref !== \'\'\"><div ng-repeat=\"items in form[0].items\"><div ng-repeat=\"tabs in items.tabs\"><div ng-repeat=\"model_items in tabs.items\"><div ng-if=\"model_items.type !== \'array\'\" ng-init=\"iter = iter + 1\"><div class=\"form-group col-md-6\" ng-if=\"(\'sixlookup\' !== model_items.type) && (model_items.key[0]!==\'plafond\') && model_items.type !== \'uiselect\'\"><label class=\"control-label m-t-xxs\">{{model_items.title}}</label><div class=\"input-group\" style=\"width: 100%\"><span class=\"input-group-addon\" id=\"sizing-addon-left\" ng-if=\"model_items.fieldAddonLeft\">{{model_items.fieldAddonLeft}}</span> <input class=\"form-control\" type=\"{{getInputType(model_items)}}\" step=\"any\" ng-model=\"selected.model[model_items.key[0]]\" aria-describedby=\"sizing-addon\" ng-change=\"boolUpdate(model_items)\" ng-if=\"getInputType(model_items)!==\'textarea\'\"> <textarea class=\"form-control\" ng-model=\"selected.model[model_items.key[0]]\" ng-if=\"getInputType(model_items)===\'textarea\'\" aria-describedby=\"sizing-addon\" ng-change=\"boolUpdate(model_items)\"></textarea> <span class=\"input-group-addon\" id=\"sizing-addon-right\" ng-if=\"model_items.fieldAddonRight\">{{model_items.fieldAddonRight}}</span></div></div><div class=\"form-group col-md-6\" ng-if=\"model_items.key[0]===\'plafond\'\"><label class=\"control-label m-t-xxs\">{{model_items.title}}</label><div class=\"input-group\" style=\"width: 100%\"><span class=\"input-group-addon\" id=\"sizing-addon-left\" ng-if=\"model_items.fieldAddonLeft\">{{model_items.fieldAddonLeft}}</span> <input class=\"form-control\" type=\"{{getInputType(model_items)}}\" step=\"any\" ng-model=\"selected.model[model_items.key[0]]\" aria-describedby=\"sizing-addon\" ng-change=\"boolUpdate(model_items)\" ng-if=\"getInputType(model_items)!==\'textarea\'\" ng-readonly=\"hasPlafondIntegrations()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-bg btn-default\" ng-click=\"integratePlafond()\" ng-disabled=\"!isIntegrationEnabled()\" ng-hide=\"isPlafondEditing\" title=\"Aggiungi integrazioni\"><i class=\"fa fa-plus\"></i></button></span> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-bg btn-default\" ng-click=\"saveIntegratePlafond()\" title=\"Salva\" ng-if=\"isPlafondEditing\"><i class=\"fa fa-save\"></i></button></span> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-bg btn-default\" ng-click=\"undoIntegratePlafond()\" title=\"Annulla\" ng-if=\"isPlafondEditing\"><i class=\"fa fa-undo\"></i></button></span></div><div class=\"panel panel-default\" ng-if=\"hasPlafondIntegrations() || isPlafondEditing\"><table width=\"100%\" class=\"table\"><thead><tr><th></th><th>Valore</th><th>Data integrazione</th></tr></thead><tbody><tr><td>Valore iniziale</td><td>{{selected.model.plafond | currency}}</td><td></td></tr><tr ng-repeat=\"item in selected.model.plafond_integrations\"><td>Integrazione {{$index+1}}</td><td>{{item.value | currency}}</td><td>{{item.date | date}}</td></tr><tr ng-if=\"isPlafondEditing\"><td>Integrazione</td><td><input type=\"number\" ng-model=\"newPlafondIntegration.value\" step=\"0.01\"></td><td><input type=\"date\" ng-model=\"newPlafondIntegration.date\"></td></tr></tbody><thead><tr><th>Totale</th><th>{{plafond_total + newPlafondIntegration.value | currency}}</th><th></th></tr></thead></table></div></div><div class=\"form-group col-md-6\" ng-if=\"\'sixlookup\' == model_items.type && model_items.entity_id == \'workflow\'\"><label class=\"control-label m-t-xxs\">{{model_items.title}}</label><six-lookup ng-model=\"selected.model\" sx-type=\"model_items.entity_id\" sx-field=\"model_items.key[0]\" sx-disabled=\"lock\"></six-lookup></div><div class=\"form-group col-md-6\" ng-if=\"model_items.type == \'uiselect\'\"><label class=\"control-label m-t-xxs\">{{model_items.title}}</label><div class=\"input-group w-full\"><ui-select ng-model=\"selected.model[model_items.key[0]]\" theme=\"bootstrap\"><ui-select-match class=\"ui-select-match\" placeholder=\"Seleziona un valore...\">{{$select.selected.name}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item.value as item in model_items.titleMap track by $index\">{{item.name}}</ui-select-choices></ui-select></div></div></div></div></div></div></div></div></div></div></uib-tab><uib-tab index=\"1\" heading=\"Istat\"><uib-tab-heading>Istat</uib-tab-heading><div class=\"form-group col-md-6 m-t-sm\"><label class=\"control-label\">Tipologia:</label><six-select-2 sx-form=\"header\" sx-required=\"true\" sx-id=\"type\" sx-list=\"istatType.types\" sx-title=\"\'Tipologia\'\" ng-model=\"istatType.selected.type\" sx-multiple=\"false\" sx-item-template=\"\'{{item.title}}\'\" sx-compact=\"true\"></six-select-2><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"header.type.$error.required\">Obbligatorio</span></div></div><div class=\"form-group col-md-6 m-t-sm\"><label class=\"control-label\">Step:</label><six-select-2 sx-form=\"header\" sx-required=\"true\" sx-id=\"step\" sx-list=\"stepList\" sx-disabled=\"!istatType.selected.type\" sx-title=\"\'Step\'\" ng-model=\"istatType.selected.step_id\" sx-multiple=\"false\" sx-item-template=\"\'{{item.description}}\'\" sx-compact=\"true\" sx-on-select=\"onStepSelect()\"></six-select-2><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"istatType.selected.type && header.step.$error.required\">Obbligatorio</span></div></div><div class=\"form-group col-md-6 m-t-sm\"><label class=\"control-label\">Campo:</label><six-select-2 sx-form=\"header\" sx-required=\"true\" sx-disabled=\"!istatType.selected.step_id\" sx-id=\"field\" sx-list=\"fieldList\" sx-title=\"\'Campo\'\" ng-model=\"istatType.selected.step_field\" sx-multiple=\"false\" sx-item-template=\"\'{{item.title}}\'\" sx-compact=\"true\" sx-click=\"getStepFields()\"></six-select-2><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"header.field.$error.required\">Obbligatorio</span></div></div><div class=\"form-group col-md-3 m-t-sm\" ng-if=\"istatType.selected.type.key && istatType.selected.type.key != \'month_adhesion\'\"><label class=\"control-label\" style=\"width: 100%;\">Mese:</label><six-select-2 sx-form=\"header\" sx-required=\"true\" sx-id=\"month\" sx-list=\"monthList\" sx-title=\"\'Mese\'\" ng-model=\"istatType.selected.month\" sx-multiple=\"false\" sx-item-template=\"\'{{item.title}}\'\" sx-compact=\"true\"></six-select-2><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"header.month.$error.required\">Obbligatorio</span></div></div><div class=\"form-group col-md-3 m-t-sm\" ng-if=\"istatType.selected.type.key && istatType.selected.type.key != \'single_date\'\"><label class=\"control-label\">Ricorrenza (Mesi):</label> <input type=\"number\" class=\"form-control\" ng-model=\"istatType.selected.recurrency\"><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-hide=\"istatType.selected.recurrency\">Obbligatorio</span></div></div><div class=\"form-group col-md-12 m-t-sm\" ng-if=\"enableServiceExclusion\"><label class=\"control-label\">Servizi esclusi da adeguamento Istat:</label><six-lookup-2 sx-form=\"header\" sx-required=\"false\" sx-id=\"services\" sx-base-path=\"\'record\'\" sx-type=\"\'servizio\'\" sx-title=\"\'Servizio\'\" ng-model=\"excludedServices\" sx-field=\"\'services\'\" sx-show-filters=\"true\" sx-multiple=\"true\"></six-lookup-2></div></uib-tab><uib-tab index=\"2\" heading=\"Fasi\"><div class=\"col-md-12 form-group hr-margin-t\"><div class=\"row\"><div class=\"col-md-6\"><label class=\"control-label m-t-xxs\">Associazione fasi</label></div><div class=\"col-md-12 no-pad-l-r pad-list-t-b\" ng-repeat=\"row in arrayRet\"><div class=\"col-md-12 no-pad-l-r\"><div class=\"col-md-6\"><six-lookup sx-disabled=\"lock\" ng-model=\"selected.model.steps[arrayIds[$index]]\" sx-type=\"\'acquisitionstep\'\" sx-field=\"\'step_id\'\" sx-war=\"\'six-consip\'\" sx-object=\"selectedStep.value\"></six-lookup></div></div></div></div></div></uib-tab><uib-tab index=\"3\" heading=\"Tempistiche\" ng-click=\"initFormuleDescriptors()\"><div class=\"col-md-12\"><div class=\"col-md-12 no-pad-l-r m-t-sm\"><div class=\"col-md-12 no-pad-l-r\" ng-show=\"workflowSelected(selected.model.workflow_id)\"><uib-tabset><uib-tab ng-click=\"setCurrentTab($index);setDefaultDays(arrayIds[$index]);setDefaultDaysActs(arrayIds[$index])\" ng-repeat=\"tab in arrayRet\" heading=\"{{tab.step_id.description}}\"><div class=\"col-md-12 no-pad-l-r\"><div class=\"col-md-2\"><b>DATA INSERIMENTO</b></div><div class=\"col-md-2\"><b>DATA SCADENZA</b></div><div class=\"col-md-4\"><div class=\"col-md-12 no-pad-l-r\"><div class=\"col-md-5 no-pad-l-r\"><b>TIPO GIORNI ACQ.</b></div><div class=\"col-md-7 no-pad-l-r\"><b>GIORNI ACQ.</b></div></div></div><div class=\"col-md-4\"><div class=\"col-md-12 no-pad-l-r\"><div class=\"col-md-5 no-pad-l-r\"><b>TIPO GIORNI ATTI</b></div><div class=\"col-md-7 no-pad-l-r\"><b>GIORNI ATTI</b></div></div></div></div><div class=\"col-md-12 no-pad-l-r pad-list-t-b-15\"><hr class=\"override-margin-top-bottom border-bold\"></div><div class=\"col-md-12 no-pad-l-r\"><div class=\"col-md-2\"><select class=\"col-md-8 form-control\" ng-model=\"selected.model.steps[arrayIds[currentTab]].date_start\" ng-options=\"date.key[0] as date.title for date in dateStepArray[arrayIds[currentTab]]\"></select></div><div class=\"col-md-2\"><select class=\"col-md-8 form-control\" ng-model=\"selected.model.steps[arrayIds[currentTab]].date_end\" ng-options=\"date.key[0] as date.title for date in dateStepArray[arrayIds[currentTab]]\"></select></div><div class=\"col-md-4\"><div class=\"col-md-12 no-pad-l-r\" ng-init=\"setDefaultDays(arrayIds[currentTab])\"><div class=\"col-md-5 btn-group no-pad-l-r\"><label class=\"btn btn-default\" ng-model=\"selected.model.steps[arrayIds[currentTab]].type_days\" ng-change=\"refreshDays(arrayIds[currentTab])\" uib-btn-radio=\"\'number\'\" title=\"Numero giorni definito\"><i class=\"fa fa-sort-numeric-desc\" aria-hidden=\"true\"></i></label> <label class=\"btn btn-default\" ng-model=\"selected.model.steps[arrayIds[currentTab]].type_days\" ng-change=\"refreshDays(arrayIds[currentTab])\" uib-btn-radio=\"\'formula\'\" title=\"Numero giorni da formula\"><i class=\"fa fa-cogs\" aria-hidden=\"true\"></i></label> <label class=\"btn btn-default\" ng-model=\"selected.model.steps[arrayIds[currentTab]].type_days\" ng-change=\"refreshDays(arrayIds[currentTab])\" uib-btn-radio=\"\'nolimits\'\" title=\"Numero giorni illimitato\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></label></div><div class=\"col-md-7 no-pad-l-r\"><div class=\"col-md-12 no-pad-l-r\" ng-if=\"selected.model.steps[arrayIds[currentTab]].type_days != \'formula\'\"><input ng-disabled=\"selected.model.steps[arrayIds[currentTab]].type_days == \'nolimits\'\" ng-model=\"selected.model.steps[arrayIds[currentTab]].days\" class=\"form-control\" type=\"number\" min=\"0\" step=\"1\"></div><div class=\"col-md-12 no-pad-l-r\" ng-if=\"selected.model.steps[arrayIds[currentTab]].type_days == \'formula\'\"><select ng-model=\"selected.model.steps[arrayIds[currentTab]].formula_days\" ng-selected=\"selected.model.steps[arrayIds[currentTab]].formula_days == formula.code\" class=\"form-control\" ng-click=\"getParams(arrayIds[currentTab], \'formula_days\', \'params_days\')\" ng-options=\"formula.code as formula.description for formula in formulaList\"></select></div></div></div></div><div class=\"col-md-4\"><div class=\"col-md-12 no-pad-l-r\" ng-init=\"setDefaultDaysActs(arrayIds[currentTab])\"><div class=\"col-md-5 btn-group no-pad-l-r\"><label class=\"btn btn-default\" ng-model=\"selected.model.steps[arrayIds[currentTab]].type_days_acts\" ng-change=\"refreshDaysActs(arrayIds[currentTab])\" uib-btn-radio=\"\'number\'\" title=\"Numero giorni definito\"><i class=\"fa fa-sort-numeric-desc\" aria-hidden=\"true\"></i></label> <label class=\"btn btn-default\" ng-model=\"selected.model.steps[arrayIds[currentTab]].type_days_acts\" ng-change=\"refreshDaysActs(arrayIds[currentTab])\" uib-btn-radio=\"\'formula\'\" title=\"Numero giorni da formula\"><i class=\"fa fa-cogs\" aria-hidden=\"true\"></i></label> <label class=\"btn btn-default\" ng-model=\"selected.model.steps[arrayIds[currentTab]].type_days_acts\" ng-change=\"refreshDaysActs(arrayIds[currentTab])\" uib-btn-radio=\"\'nolimits\'\" title=\"Numero giorni illimitato\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></label></div><div class=\"col-md-7 no-pad-l-r\"><div class=\"col-md-12 no-pad-l-r\" ng-if=\"selected.model.steps[arrayIds[currentTab]].type_days_acts != \'formula\'\"><input ng-disabled=\"selected.model.steps[arrayIds[currentTab]].type_days_acts == \'nolimits\'\" ng-model=\"selected.model.steps[arrayIds[currentTab]].days_acts\" class=\"form-control\" type=\"number\" min=\"0\" step=\"1\"></div><div class=\"col-md-12 no-pad-l-r\" ng-if=\"selected.model.steps[arrayIds[currentTab]].type_days_acts == \'formula\'\"><select ng-model=\"selected.model.steps[arrayIds[currentTab]].formula_days_acts\" class=\"form-control\" ng-click=\"getParams(arrayIds[currentTab],\'formula_days_acts\', \'params_days_acts\')\" ng-options=\"formula.code as formula.description for formula in formulaList\"></select></div></div></div></div></div><div class=\"col-md-12 hr-margin-t\"><div class=\"col-md-5 no-pad-l-r\" ng-if=\"selected.model.steps[arrayIds[currentTab]].type_days == \'formula\'\"><h5><b>Parametri formula acquisizione</b></h5><div class=\"col-md-12 no-pad-l-r pnl-margin-l-r\"><textarea class=\"form-control\" rows=\"4\" ng-model=\"formuleStrBodyDays[arrayIds[currentTab]]\" disabled=\"\"></textarea></div><div ng-repeat=\"(key, value) in selected.model.steps[arrayIds[currentTab]].params_days\"><div class=\"col-md-12 no-pad-l-r pnl-margin-l-r\"><div class=\"col-md-1 no-pad-l-r cont-center\">{{key}}</div><div class=\"col-md-11 no-pad-l-r\"><input type=\"string\" class=\"form-control\" ng-model=\"selected.model.steps[arrayIds[currentTab]].params_days[key]\"></div></div></div></div><div class=\"no-pad-l-r\" ng-class=\"getFormattedParams(arrayIds[currentTab])\" ng-if=\"selected.model.steps[arrayIds[currentTab]].type_days_acts == \'formula\'\"><h5><b>Parametri formula atti aggiuntivi</b></h5><div class=\"col-md-12 no-pad-l-r pnl-margin-l-r\"><textarea class=\"form-control\" rows=\"4\" ng-model=\"formuleStrBodyDaysActs[arrayIds[currentTab]]\" disabled=\"\"></textarea></div><div ng-repeat=\"(key, value) in selected.model.steps[arrayIds[currentTab]].params_days_acts\"><div class=\"col-md-12 no-pad-l-r pnl-margin-l-r\"><div class=\"col-md-1 no-pad-l-r cont-center\">{{key}}</div><div class=\"col-md-11 no-pad-l-r\"><input type=\"string\" class=\"form-control\" ng-model=\"selected.model.steps[arrayIds[currentTab]].params_days_acts[key]\"></div></div></div></div></div></uib-tab></uib-tabset></div></div></div></uib-tab><uib-tab index=\"4\" heading=\"Tempistiche SAL\"><div class=\"row m-b\"><div class=\"col-md-4\"><a class=\"btn btn-success\" ng-click=\"addSalRule()\"><i class=\"fa fa-plus\"></i> Aggiungi regola</a></div><div class=\"col-md-8\"><p class=\"text-muted\">Il sistema cambierà automaticamente lo stato dei SAL al decorrere dei i giorni inseriti.</p></div></div><div class=\"hbox hbox-auto-xs b-t wrapper-sm\" ng-repeat=\"rule in selected.model.sal_timing_rules\"><a ng-click=\"deleteSalRule($index)\" class=\"col btn btn-rounded btn-icon b-a b-danger text-danger\"><i class=\"fa fa-trash\"></i></a><h5 class=\"col v-middle text-center\">Dallo stato</h5><div class=\"col w-sm\"><ui-select ng-model=\"rule.status_from\" ng-required=\"true\"><ui-select-match placeholder=\"Seleziona Stato\">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"status.code as status in salSatatus\"><span class=\"{{status.style}}\">{{status.label}}</span></ui-select-choices></ui-select></div><h5 class=\"col v-middle text-center\">a</h5><div class=\"col w-sm\"><ui-select ng-model=\"rule.status_to\" ng-required=\"true\"><ui-select-match placeholder=\"Seleziona Stato\">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"status.code as status in salSatatus\"><span class=\"{{status.style}}\">{{status.label}}</span></ui-select-choices></ui-select></div><h5 class=\"col v-middle text-center\">dopo</h5><div class=\"col w-xxs\"><input type=\"number\" class=\"form-control\" min=\"1\" placeholder=\"#\" ng-model=\"rule.days\" required=\"\"></div><h5 class=\"col v-middle text-center\">giorn{{rule.days &gt; 1?\'i\':\'o\'}}</h5></div></uib-tab><uib-tab index=\"5\" heading=\"Allegati\" ng-click=\"initAttachments()\" ng-if=\"enableAttachments\"><uib-tab-heading><span class=\"fa fa-book text-info-dker\"></span> Allegati</uib-tab-heading><six-tree-attachments save-callback=\"updateAttachments()\" nodes=\"attachments\"></six-tree-attachments></uib-tab></uib-tabset></form></div></div></div>");
$templateCache.put("consip/contract/contractconfigurator_detail.html","<six-toolbar><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"fa fa-trash-o\" toolbar-function=\"delete()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"save()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Dettaglio Configurazione</h1></div></div></div><div class=\"panel wrapper\"><div class=\"panel-heading\"><div class=\"page-header-bleed-right\"><div class=\"actions\"><div class=\"row\"><form name=\"header\"><div class=\"form-group\"><div class=\"col-md-4\"><label id=\"schema_id_key\" for=\"code\" class=\"col-md-1 control-label\">Codice</label> <input type=\"text\" class=\"form-control\" id=\"code\" placeholder=\"\" ng-model=\"code\" name=\"code\" required=\"\" readonly=\"\"><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"header.code.$error.required\">Obbligatorio</span></div></div></div><div class=\"form-group\"><div class=\"col-md-4\"><label id=\"schema_desc_key\" for=\"description\" class=\"col-md-1 control-label\">Descrizione</label> <input type=\"text\" class=\"form-control\" id=\"description\" placeholder=\"\" ng-model=\"description\" name=\"description\" ng-keyup=\"refreshDescription(description)\" required=\"\" readonly=\"\"><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"header.description.$error.required\">Obbligatorio</span></div></div></div><div class=\"form-group\"><div class=\"col-md-4 override-padding-no-pad-left-right\"><div class=\"col-md-12\"><label class=\"col-md-1 control-label\">Convenzione</label><div id=\"vectors_budget_code\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"commissionsSelected.codes\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\" ng-change=\"refreshCommission()\" ng-disabled=\"true\"><ui-select-match class=\"ui-select-match\" placeholder=\"Selezionare una commessa...\">{{$item.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in commissions\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div></div></div><div class=\"form-group\"><div class=\"col-md-12\"><input type=\"checkbox\" id=\"attachment_management\" ng-model=\"attachmentManagement\" name=\"attachment_management\" ng-change=\"refreshAttachmentManagement()\"> <label id=\"attachment_management_key\" for=\"attachment_management\" class=\"control-label\">Gestione allegati</label></div><div class=\"col-md-12\"><input type=\"checkbox\" id=\"exclude_services_from_istat\" ng-model=\"excludeServicesFromIstat\" name=\"exclude_services_from_istat\" ng-change=\"refreshExcludeServicesFromIstat()\"> <label id=\"exclude_services_from_istat_key\" for=\"exclude_services_from_istat\" class=\"control-label\">Abilita esclusione servizi da adeguamento Istat</label></div></div></form></div></div></div></div><div class=\"panel-body\"><uib-tabset justified=\"true\"><uib-tab heading=\"Convenzione\"><form name=\"myForm\" sf-schema=\"schema\" sf-form=\"form\" sf-model=\"model\" ng-submit=\"onSubmit(myForm)\"></form></uib-tab><uib-tab heading=\"Schema\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><div class=\"col-md-12 centered\"><b>SCHEMA</b></div><div class=\"col-md-12 override-padding-no-pad-left-right\"><hr class=\"override-margin-top-bottom\"></div><div class=\"col-md-12 centered\"><div class=\"col-md-2 col-md-offset-1\"><b>CODICE</b></div><div class=\"col-md-3\"><b>DESCRIZIONE</b></div><div class=\"col-md-1\"><b>TIPOLOGIA</b></div><div class=\"col-md-2\"><b>FORMATO</b></div></div><div class=\"col-md-12 override-padding-no-pad-left-right\"><hr class=\"override-margin-top-bottom\"></div><div class=\"col-md-12 centered\"><div class=\"col-md-2 col-md-offset-1\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><form name=\"propertyKeyForm\"><input class=\"form-control\" name=\"property_key\" placeholder=\"Codice...\" type=\"text\" ng-model=\"property.key\" pattern=\"^[a-zA-Z]+[\\w]*$\"><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"propertyKeyForm.property_key.$error.pattern\">Caratteri non consentiti</span></div></form></div></div><div class=\"col-md-3\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><input class=\"form-control\" placeholder=\"Descrizione\" type=\"text\" ng-model=\"property.title\"></div></div><div class=\"col-md-1\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><select class=\"form-control\" ng-model=\"property.type\"><option></option><option value=\"string\">string</option><option value=\"number\">number</option><option value=\"integer\">integer</option><option value=\"boolean\">boolean</option><option value=\"date\">date</option><option value=\"array\">array</option></select></div></div><div class=\"col-md-2\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><select class=\"form-control\" ng-model=\"property.format\" ng-if=\"(property.type == \'string\')\"><option></option><option value=\"lookup\">lookup</option><option value=\"formula\">formula</option><option value=\"enum\">enum</option></select><select class=\"form-control\" ng-model=\"property.format\" ng-if=\"(property.type == \'number\' || property.type == \'integer\')\"><option></option><option value=\"formula\">formula</option><option value=\"enum\">enum</option></select><select class=\"form-control\" ng-model=\"property.items_type\" ng-if=\"(property.type == \'array\')\"><option></option><option value=\"lookup\">lookup</option><option value=\"string\">string</option><option value=\"number\">number</option><option value=\"integer\">integer</option><option value=\"date\">date</option></select></div></div><div class=\"col-md-2\"><div ng-if=\"isInheritable(property.type)\"><label><input type=\"checkbox\" ng-model=\"property.inherited\"> Campo ereditato</label></div></div><div class=\"col-md-1\"><button ng-click=\"addProperty()\" class=\"btn btn-sm btn-info pull-right\"><span class=\"fa fa-plus\"></span> Add</button></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-repeat=\"(key, value) in selected.model.schema.properties\" style=\"align-content: center; padding-bottom: 0px;\"><div class=\"col-md-12 uniform-height\" style=\"align-content: center;\"><div class=\"col-md-1\"><a href=\"\" ng-click=\"status[key].open = !status[key].open\" id=\"btn_row_detail\"><i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status[key].open, \'glyphicon-chevron-right\': !status[key].open}\"></i></a></div><div class=\"col-md-2\">{{ key }}</div><div class=\"col-md-3\">{{ value.title }}</div><div class=\"col-md-1\">{{ value.type }}</div><div class=\"col-md-2\"><span ng-if=\"value.format\">{{value.format}}</span> <span ng-if=\"value.type == \'array\' && value.items\">{{value.items.format}}</span></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-show=\"status[key].open\"><div class=\"col-md-12 uniform-height-2\" ng-if=\"value.format !== \'lookup\' && value.format !== \'formula\' && value.format !== \'enum\' && value.format !== \'inherit\' && value.type !== \'array\'\"><div class=\"col-md-2\">FORMATO:</div><div class=\"col-md-10\">{{value.format}}</div></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'date\'\" ng-include=\"\'dataset/modeltype/detail_constraints.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'inherit\'\" ng-include=\"\'dataset/modeltype/detail_inherit.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'lookup\' && value.type != \'array\'\" ng-include=\"\'dataset/modeltype/detail_lookup.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'formula\'\" ng-include=\"\'dataset/modeltype/detail_formula.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'enum\'\" ng-include=\"\'dataset/modeltype/detail_enum.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.type === \'array\'\" ng-include=\"\'dataset/modeltype/detail_array.html\'\"></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">ELIMINA:</div><div class=\"col-md-10\"><button ng-click=\"deleteProperty(key)\" class=\"btn btn-danger btn-xs btn-default\" ng-disabled=\"(key === \'code\' || key === \'description\')\"><i class=\"fa fa-trash\"></i></button></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">IN TABELLA:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.check\" ng-change=\"changeColumnDefs(key, value)\" ng-disabled=\"(key === \'code\' || key === \'description\')\"></div></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-show=\"value.check == true\"><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">LARGHEZZA (px):</div><div class=\"col-md-10\"><input type=\"text\" min=\"1\" step=\"1\" size=\"45\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=\"value.width\" ng-change=\"changeColumnDefs(key, value)\"></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">ORDINAMENTO:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.enableSorting\" ng-change=\"changeColumnDefs(key, value)\"></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">FILTRAGGIO:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.enableFiltering\" ng-change=\"changeColumnDefs(key, value)\"></div></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div></div></div></div></uib-tab><uib-tab heading=\"Form\"><table class=\"table table-striped\"><thead><th colspan=\"5\">FORM</th><tr><th colspan=\"5\"><div class=\"form-group\"><label for=\"title\" class=\"control-label\">Titolo</label><div class=\"\"><input type=\"text\" class=\"form-control\" id=\"title\" placeholder=\"\" ng-model=\"title\" name=\"title\" ng-keyup=\"refreshTitleForm(title)\"></div></div></th></tr><tr><td></td><td></td><td><input type=\"text\" placeholder=\"Titolo...\" ng-model=\"newTab.title\"></td><td><button ng-click=\"addTab(selected.model.form[0].items[0])\" class=\"btn btn-xs btn-info\"><span class=\"fa fa-plus\"></span> Add</button></td></tr><tr><th></th><th>POSIZIONE</th><th>TITOLO</th><th></th></tr></thead><tbody><tr ng-repeat-start=\"(key, tab) in selected.model.form[0].items[0].tabs\"><td><a href=\"\" ng-click=\"statusForm[key].open = !statusForm[key].open\"><i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': statusForm[key].open, \'glyphicon-chevron-right\': !statusForm[key].open}\"></i></a></td><td><span class=\"btn btn-sm\" ng-click=\"swapUp(key, selected.model.form[0].items[0].tabs)\" ng-disabled=\"key<=0\"><i class=\"fa fa-caret-up\"></i></span> {{key+1}} <span class=\"btn btn-sm\" ng-click=\"swapDown(key, selected.model.form[0].items[0].tabs)\" ng-disabled=\"key>=selected.model.form[0].items[0].tabs.length-1\"><i class=\"fa fa-caret-down\"></i></span></td><td><input type=\"text\" ng-model=\"tab.title\" ng-disabled=\"(tab.key[0] == \'code\' || tab.key[0] == \'description\')\" ng-keyup=\"updateScope()\"></td><td><a ng-click=\"removeTabOrField(key, selected.model.form[0].items[0].tabs)\" class=\"btn btn-danger btn-xs btn-default\" id=\"btn_row_detail_form\"><i class=\"fa fa-trash\"></i></a></td></tr><tr ng-repeat-end=\"\" ng-show=\"statusForm[key].open\"><td></td><td colspan=\"3\" style=\"background-color:rgba(211, 211, 211, 0.38);\"><table class=\"table table-striped override-margin\"><tr><td></td><td><select ng-options=\"k as v.title for (k, v) in schema.properties\" ng-model=\"newFieldForm.key\"></select></td><td><input type=\"text\" placeholder=\"Titolo...\" ng-model=\"newFieldForm.title\"></td><td><input type=\"checkbox\" placeholder=\"Richiesto...\" ng-model=\"newFieldForm.required\"></td><td><input type=\"checkbox\" placeholder=\"Nascosto...\" ng-model=\"newFieldForm.htmlClass\" ng-true-value=\"\'hidden\'\" ng-false-value=\"\'\'\"></td><td><select ng-model=\"newFieldForm.type\" ng-change=\"updateScope()\"><option value=\"\"></option><option value=\"text\">text</option><option value=\"textarea\">textarea</option><option value=\"number\">number</option><option value=\"datepicker\">date</option><option value=\"password\">password</option><option value=\"checkbox\">checkbox</option><option value=\"select\">enum</option><option value=\"array\">array</option><option value=\"sixlookup\">lookup</option><option value=\"inherited\">ereditato</option><option value=\"formula\">formula</option></select></td><td><button ng-click=\"addFieldToTab(tab)\" class=\"btn btn-xs btn-info\"><span class=\"fa fa-plus\"></span> Add</button></td></tr><tr><th>POSIZIONE</th><th>CAMPO</th><th>TITOLO</th><th>REQUIRED</th><th>NASCOSTO</th><th>TIPO</th><th></th></tr><tr ng-repeat=\"(fieldKey, field) in tab.items\"><td class=\"override-width-200px\"><div><span class=\"btn btn-sm\" ng-click=\"swapUp(fieldKey, tab.items)\" ng-disabled=\"fieldKey<=0\"><i class=\"fa fa-caret-up\"></i></span> {{fieldKey+1}} <span class=\"btn btn-sm\" ng-click=\"swapDown(fieldKey, tab.items)\" ng-disabled=\"fieldKey>=tab.items.length-1\"><i class=\"fa fa-caret-down\"></i></span></div></td><td ng-if=\"!field.title\">{{field}}</td><td ng-if=\"!field.title\"></td><td ng-if=\"!field.title\"></td><td ng-if=\"!field.title\"></td><td ng-if=\"field.title\">{{field.key[0]}}</td><td ng-if=\"field.title\"><input type=\"text\" ng-model=\"field.title\" ng-keyup=\"updateScope()\"></td><td ng-if=\"field.title\"><input type=\"checkbox\" ng-model=\"field.required\" ng-change=\"updateScope()\"></td><td ng-if=\"field.title\"><input type=\"checkbox\" ng-model=\"field.htmlClass\" ng-change=\"updateScope()\" ng-true-value=\"\'hidden\'\" ng-false-value=\"\'\'\"></td><td ng-if=\"field.title\"><select ng-model=\"field.type\" ng-change=\"updateField(field)\"><option value=\"\"></option><option value=\"text\">text</option><option value=\"textarea\">textarea</option><option value=\"number\">number</option><option value=\"datepicker\">date</option><option value=\"password\">password</option><option value=\"checkbox\">checkbox</option><option value=\"select\">enum</option><option value=\"array\">array</option><option value=\"sixlookup\">lookup</option><option value=\"inherited\">ereditato</option><option value=\"formula\">formula</option></select></td><td><a ng-click=\"removeTabOrField(fieldKey, tab.items)\" class=\"btn btn-danger btn-xs btn-default\"><i class=\"fa fa-trash\"></i></a></td></tr></table></td></tr></tbody></table></uib-tab></uib-tabset></div><div class=\"panel-footer\"><div class=\"form-group\"><input id=\"jsonShowCheck\" type=\"checkbox\" ng-model=\"jsonshow\" data-toggle=\"collapse\" data-target=\"#json-collapse\" class=\"pull-left\"> <label for=\"jsonShowCheck\" class=\"pull-left control-label\">Dettaglio avanzato</label></div></div></div><div class=\"row collapse\" id=\"json-collapse\"><div class=\"col-md-8\"><div class=\"panel-heading wrapper b-b b-light\"><h4 class=\"font-thin m-t-none m-b-none text-muted\">Dettaglio</h4></div><div style=\"margin-top:0px;\" ui-ace=\"{ useWrapMode : true, showGutter: true, mode: \'json\', firstLineNumber: 1, onLoad: aceLoaded, onChange: aceChanged }\" ng-model=\"aceModel\"></div><div class=\"panel-footer\"></div></div><div class=\"col-md-4\"><div class=\"list-group list-group-lg list-group-sp\"><pre>{{ model}}</pre></div></div></div></div></div>");
$templateCache.put("consip/contract/contractconfigurator_list.html","<six-toolbar><six-toolbar-button label=\"Crea configurazione\" icon=\"fa fa-plus\" toolbar-function=\"newContract()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"refresh()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista configurazioni convenzioni</h1></div></div></div><div class=\"panel-body\"><table id=\"contract_list\" class=\"table table-striped\"><thead><tr><th></th><th>CODICE CONFIGURAZIONE</th><th>CONVENZIONE</th><th>DATA</th></tr></thead><tbody><tr ng-repeat=\"item in contractList.list\"><td><a ng-href=\"#/contractconfigurator/{{item.version}}\" class=\"btn btn-default\"><span class=\"fa fa-search\"></span></a></td><td>{{ item.model.code }}</td><td>{{ item.model.commission }}</td><td>{{ item.dataIn | date:\'dd/MM/yyyy\' }}</td></tr><tr ng-hide=\"contractList.list.length\"><td><p class=\"text-center\">Nessun record recuperato</p></td></tr></tbody></table></div><div class=\"panel-footer\"><div class=\"row text-center\"><uib-pagination ng-change=\"pageChanged()\" boundary-links=\"true\" total-items=\"contractList.totalResults\" ng-model=\"contractList.currentPage\" class=\"pagination-sm\" items-per-page=\"contractList.pageSize\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></uib-pagination></div></div></div></div>");
$templateCache.put("consip/dashboard/plafond_dashboard.html","<style>\n  .liquidFillGaugeText {\n    font-weight: bold;\n  }\n</style><div class=\"row wrapper\"><div class=\"col-lg-8\" ng-if=\"customerData\"><sunburst chart-data=\"customerData\"></sunburst></div><div class=\"col-lg-4\" ng-if=\"customerData\"><div class=\"panel panel-default\"><div class=\"text-center text-primary-dk m-t\"><span class=\"h3\">Plafond sottoscritto</span></div><div class=\"text-center wrapper m-b-sm\"><liquid percentage=\"contractPlafond.acquiredPercent\" options=\"liquidOpt\"></liquid></div><div class=\"hbox text-center b-b b-t b-light text-sm\"><div class=\"col padder-v text-muted b-r b-light\" tooltip-append-to-body=\"true\" uib-tooltip=\"Plafond totale di contratto\"><i class=\"fa fa-calculator block m-b-xs fa-2x\"></i> <span>{{contractPlafond.total | currency}}</span></div><div class=\"col padder-v text-muted b-r b-light\" tooltip-append-to-body=\"true\" uib-tooltip=\"Plafond sottoscritto\"><i class=\"fa fa-handshake-o block m-b-xs fa-2x\"></i> <span>{{contractPlafond.acquired | currency}}</span></div><div class=\"col padder-v text-muted\" tooltip-append-to-body=\"true\" uib-tooltip=\"Totale del fatturato\"><div><div class=\"fa-stack m-b-xs\"><i class=\"fa fa-file-o fa-stack-2x\"></i> <i class=\"fa fa-eur fa-stack-1x\"></i></div></div><span>{{contractPlafond.turnover | currency}}</span></div></div><div class=\"col text-center dk padder-v r-r\"><div class=\"text-primary-dk font-thin h1\"><span>{{contractPlafond.residual | currency}}</span></div><span class=\"text-muted\">Fondi ancora disponibili. {{100 - contractPlafond.acquiredPercent | currency:\"%\":2}} del totale</span></div></div></div></div><div class=\"row wrapper\"><div class=\"col-lg-12\"><div class=\"panel panel-default\"><table class=\"table table-striped m-b-none\"><thead><tr><th class=\"w-sm\"></th><th>Cliente</th><th>Totale</th><th>Fatturato</th></tr></thead><tbody><tr ng-repeat=\"customer in customers\"><td><uib-progressbar class=\"m-n\" ng-if=\"customer.total > 0\" max=\"customer.total\" value=\"customer.turnover\"><i ng-if=\"customer.turnover > 0\">{{(customer.turnover * 100 / customer.total) | currency:\'%\':1}}</i></uib-progressbar></td><td><strong class=\"m-r-sm\">{{customer.customer.code}}</strong>{{customer.customer.description}}</td><td>{{customer.total | currency}}</td><td>{{customer.turnover | currency}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("consip/dashboard/sunburst.html","<style>\n  #sequence {\n    height: 70px;\n  }\n\n  #sequence text {\n    font-weight: 600;\n    fill: #fff;\n  }\n\n  #chart {\n    position: relative;\n  }\n\n  #chart path {\n    stroke: #fff;\n  }\n\n  .explanation {\n    position: absolute;\n    top: 220px;\n  }\n\n</style><div class=\"w-full\" id=\"sequence\"></div><div id=\"chart\" class=\"w-full\"><div class=\"explanation text-muted text-center w-full\" ng-show=\"point\"><h1 class=\"m-n\">{{point.percentage}}%</h1>{{point.value | currency}}<h2 class=\"m-xs\">{{point.name}}</h2><h4 class=\"m-xs w-lg inline\">{{point.description}}</h4></div></div>");
$templateCache.put("consip/order/istat_dialog.html","<div class=\"modal-body ng-scope\"><div class=\"row\"><div class=\"col-sm-12\"><h3 class=\"m-t-none m-b font-thin\">Adeguamento ISTAT</h3><form role=\"form\" name=\"istat\"><div class=\"form-group\"><label>Data</label><p class=\"input-group\"><input required=\"\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"datePicker.from\" is-open=\"dateOptions.opened\" datepicker-options=\"dateOptions\" datepicker-append-to-body=\"true\" ng-required=\"true\" close-text=\"Chiudi\" clear-text=\"Cancella\" current-text=\"Oggi\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"dateOptions.opened=!dateOptions.opened\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"form-group\"><label>Percentuale adeguamento</label><div class=\"input-group\"><input required=\"\" type=\"number\" step=\".01\" min=\"0\" max=\"100\" class=\"form-control\" placeholder=\"Percentuale di adeguamento\" ng-model=\"percentage\"> <span class=\"input-group-addon\">%</span></div></div><div class=\"form-group\" ng-if=\"minDate\">Data minima consentita per l\'adeguamento: {{minDate | date:\'dd/MM/yyyy\'}}</div><button ng-disabled=\"istat.$invalid\" class=\"btn btn-sm btn-success pull-right text-uc m-t-xs\" ng-click=\"fn(datePicker.from, percentage); closeThisDialog();\"><i class=\"fa fa-check\"></i>Applica</button></form></div></div></div>");
$templateCache.put("consip/order/order_detail.html","<style>\n.m-left{\n  margin-left: 10px;\n\n}\n\n.m-left-xl{\n  margin-left: 50px;\n}\n\n.m-bottom{\n  margin-bottom: 10px;\n}\n\n.m-bottom-l{\n  margin-bottom: 20px;\n}\n\n.m-top-xl{\n  margin-top: 50px;\n}\n\nsix-tree-attachments div.row{\n  width: 90%;\n  margin-left: 10px;\n}\n\n</style><six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-download\" label=\"XLS\" btn-class=\"btn-info\" toolbar-function=\"export()\" sx-disabled=\"viewGridOptions.data.length == 0\"></six-toolbar-button><six-toolbar-button label=\"Adeguamento ISTAT\" btn-class=\"btn-info\" icon=\"fa fa-percent\" toolbar-function=\"showIstatDialog()\" sx-disabled=\"viewGridOptions.data.length == 0\"></six-toolbar-button><six-toolbar-button hidden=\"\" icon=\"fa fa-trash\" label=\"Elimina\" btn-class=\"btn-danger\" toolbar-function=\"bulkDelete()\" sx-disabled=\"viewGridOptions.data.length == 0\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\" ng-if=\"wizard\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Ordine {{wizard.model.client_id.description}}</h1></div></div></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col col-md-12\"><div id=\"locDetail\" style=\"margin: 0px; padding: 0px;\"><div class=\"panel-group\" id=\"accordion\"><div class=\"panel panel-default\" id=\"panel1\"><a data-toggle=\"collapse\" data-target=\"#collapseOne\"><div class=\"panel-heading\" ng-click=\"show = !show\"><h4 class=\"panel-title\"><i class=\"pull-right fa ng-scope fa-angle-right\" ng-class=\"{\'fa-angle-down\': show, \'fa-angle-right\': !show}\"></i> Storico Adeguamento ISTAT</h4></div></a><div id=\"collapseOne\" class=\"collapse\" style=\"margin: 15px\"><span ng-if=\"appliedIstats\" style=\"position: relative;\"><div class=\"row\"><span ng-repeat=\"item in appliedIstats track by $index\"><div class=\"col-md-12 m-bottom-l\"><span class=\"m-left\"><strong>Data adeguamento Istat:</strong> {{toDateString(item.model.adjustment_date)}}</span> <span class=\"m-left\"><strong>Aumento Istat:</strong> {{item.model.adjustment_percentage + \'%\'}}</span> <span class=\"m-left\"><strong>Operatore:</strong> {{item.model.user}}</span> <span class=\"m-left\"><strong>Data operazione:</strong> {{item.creationDate | date:\'dd/MM/yyyy\'}}</span></div><div ng-class=\"col-md-10\"><six-tree-attachments save-callback=\"updateAttachments(item, $index)\" nodes=\"attachments[$index]\"></six-tree-attachments></div><hr style=\"margin-top:10px; margin-bottom:10px\"></span></div></span> <span ng-if=\"!appliedIstats\">Nessun adeguamento salvato</span></div></div></div></div></div></div><div class=\"row\"><div class=\"col col-md-12\"><six-grid-pagination sx-id=\"orders\" get-data-callback=\"getOrder()\" items-list=\"orderRows\" grid-options=\"viewGridOptions\" column-defs=\"viewGridOptions.columnDefs\" params=\"params\" auto-resize-params=\"autoResizeParams\" show-global-search=\"false\"></six-grid-pagination></div></div></div></div></div>");
$templateCache.put("consip/order/order_list.html","<six-toolbar><six-toolbar-button label=\"Adeguamento ISTAT\" btn-class=\"btn-info\" icon=\"fa fa-percent\" toolbar-function=\"showIstatDialog()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\" ng-if=\"crossCustomer()\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista ordini</h1></div></div></div><div class=\"panel-body\"><six-grid-pagination sx-id=\"order_list_grid\" get-data-callback=\"getData()\" get-list-callback=\"getData()\" items-list=\"{}\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div></div>");
$templateCache.put("consip/plafond/report.html","<div class=\"wrapper\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Plafond</h1></div></div></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-lg-12\"><uib-alert type=\"danger\" ng-if=\"!currentCustomer\">Selezionare un cliente per abilitare la funzione</uib-alert><div ui-grid=\"gridOptions\" class=\"grid\" style=\"height: 420px\" ui-grid-exporter=\"\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\"></div></div></div></div></div></div>");
$templateCache.put("consip/pricelists/pricelist_detail.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-download\" label=\"XLS\" btn-class=\"btn-info\" toolbar-function=\"export()\" sx-disabled=\"viewGridOptions.data.length == 0 || !isAlreadyPresent\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-upload\" label=\"Importa\" btn-class=\"btn-success\" toolbar-function=\"import()\" sx-disabled=\"viewGridOptions.data.length == 0 || isAlreadyPresent || importingError\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-trash\" label=\"Elimina\" btn-class=\"btn-danger\" toolbar-function=\"delete()\" sx-disabled=\"viewGridOptions.data.length == 0 || !isAlreadyPresent\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Listino {{wizard.model.client_id.description}}</h1></div></div></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col col-md-12\"><div id=\"viewGrid\" ui-grid=\"viewGridOptions\" class=\"grid\" external-scopes=\"clickHandler\" style=\"height: 420px\" ui-grid-pagination=\"\" ui-grid-cellnav=\"\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\" ui-grid-auto-resize=\"\"><div class=\"grid-msg-overlay\" ng-show=\"!viewGridOptions.data.length\"><div class=\"msg\"><div class=\"center\"><span class=\"muted\">Selezionare File Excel</span><br><input type=\"file\" accept=\".xls,.xlsx,.ods\" xlsxreader=\"\" opts=\"viewGridOptions\" multiple=\"false\"></div></div></div></div></div></div></div></div></div>");
$templateCache.put("consip/sal/expandableRowTemplate.html","<div class=\"h-full w-full\"><textarea class=\"form-control w-full\" style=\"resize:none; height: 100%;\" ng-model=\"row.entity.model.note\" placeholder=\"Note\" ng-change=\"grid.api.rowEdit.setRowsDirty([row.entity])\" ng-readonly=\"!grid.appScope.isWritePermAllowed()\"></textarea></div>");
$templateCache.put("consip/sal/invoice_dialog.html","<div class=\"text-center\"><h4 class=\"font-bold\">{{invoice.description}}</h4><a class=\"text-muted\" ng-href=\"#/invoice/{{uuid}}\" target=\"_blank\"><i class=\"fa fa-external-link text-dark\"></i> {{invoice.code}}</a></div><div class=\"text-center\"><i class=\"m-xs fa fa-calendar text-siccess-dker\"></i> {{invoice.from | date:\'dd MMM yyyy\'}} - {{invoice.to | date:\'dd MMM yyyy\'}}</div><table align=\"center\" class=\"text-right small\"><thead><tr><th class=\"w-xs\"></th></tr></thead><tbody><tr><td class=\"font-bold\">Azienda: <i class=\"fa fa-building-o text-info m-r-xs\"></i></td><td class=\"text-left\">{{invoice.company_id.description}}</td></tr><tr><td class=\"font-bold\">Importo: <i class=\"fa fa-credit-card text-success m-r-xs\"></i></td><td class=\"text-left\">{{invoice.total_price | currency}}</td></tr></tbody></table>");
$templateCache.put("consip/sal/invoice_panel.html","<div class=\"panel-heading\">Seleziona Prefatture <a class=\"pull-right\" ng-click=\"onCloseInvoice()\"><i class=\"fa fa-times\"></i></a></div><div class=\"panel-body\" ng-init=\"resizeParams = {enabled: false}\"><six-grid-pagination sx-id=\"sal_invoice\" get-data-callback=\"loadInvoiceList()\" get-list-callback=\"loadInvoiceList()\" items-list=\"invoiceList\" grid-options=\"viewGridOptions\" column-defs=\"viewGridOptions.columnDefs\" params=\"params\" auto-resize-params=\"resizeParams\" show-global-search=\"false\" enable-xls-export=\"false\"></six-grid-pagination></div><div class=\"panel-footer\"><button class=\"btn btn-sm btn-success\" ng-click=\"onAddInvoice()\" ng-disabled=\"params.gridApi.selection.getSelectedRows().length == 0\"><i class=\"fa fa-plus\"></i> Aggiungi</button> <button class=\"btn btn-sm btn-default pull-right\" ng-click=\"onCloseInvoice()\"><i class=\"fa fa-undo\"></i> Annulla</button></div>");
$templateCache.put("consip/sal/odl_dialog.html","<div class=\"text-center\"><h4 class=\"m-n font-bold\">{{odl.status}}</h4><a class=\"text-muted\" ng-href=\"#/odl/{{odl.UUID}}\" target=\"_blank\"><i class=\"fa fa-external-link text-dark\"></i> {{odl.model.code}}</a></div><div class=\"text-center\"><i class=\"m-xs fa fa-calendar text-siccess-dker\"></i> {{odl.date_handling | date:\'dd MMM yyyy\'}} - {{(odl.date_closing || \'In lavorazione\') | date:\'dd MMM yyyy\'}}</div><table align=\"center\" class=\"text-right small\"><tbody><tr><td class=\"font-bold\">Preventivi: <span class=\"m-xs badge bg-primary\">{{odl.customer_estimates.length || 0}}</span></td><td class=\"text-left\"><ng-repeat ng-repeat=\"est in odl.customer_estimates | filter:{model: {status: \'approved\'}}\"><i class=\"fa fa-check text-success-dker\"></i> {{est.model.total | currency}}</ng-repeat></td></tr><tr><td class=\"font-bold\">Consuntivi: <span class=\"m-xs badge bg-info\">{{odl.consumptives.length}}</span></td><td class=\"text-left\"><ng-repeat ng-repeat=\"est in odl.consumptives | filter:{model: {status: \'approved\'}}\"><i class=\"fa fa-check text-success-dker\"></i> {{est.model.total | currency}}</ng-repeat></td></tr></tbody></table>");
$templateCache.put("consip/sal/odl_panel.html","<style>\n  .odl-panel .panel-heading {\n    color: #dcf2f8;\n    background-color: #23b7e5;\n    padding: 10px 15px;\n    border-bottom: 1px solid transparent;\n    border-radius: 2px 2px 0 0;\n    font-size: 20px;\n    height: 50px;\n    text-align: center;\n  }\n\n  .odl-panel .panel-heading a {\n    font-size: 14px;\n    color: #dcf2f8;\n  }\n\n  .odl-panel .grid {\n    height: 365px;\n  }\n\n  .red-highlight {\n    color: rgb(240, 80, 80);\n  }\n\n</style><div class=\"panel-heading\">Seleziona ODL <a class=\"pull-right\" ng-click=\"onCloseOdl()\" ng-hide=\"odlSixLookupStyle\"><i class=\"fa fa-times\"></i></a> <a class=\"pull-right\" ui-toggle-class=\"active\" ng-click=\"onAddOdl()\" target=\".odl-panel\" ng-show=\"odlSixLookupStyle\"><i class=\"fa fa-times\"></i></a></div><div class=\"panel-body\"><div class=\"row m-b-sm\"><div class=\"col-lg-3 col-sm-6\"><label>Data di chiusura:</label> <input type=\"date\" ng-model=\"dateClosing.date\" ng-change=\"getOdlList()\" class=\"form-control input-sm bg-light no-border rounded padder\"></div></div><div class=\"row\"><div class=\"col-lg-12\" ng-init=\"resizeParams = {enabled: false}\"><six-grid-pagination sx-id=\"sal_odl\" get-data-callback=\"getOdlList()\" items-list=\"odlList\" grid-options=\"viewGridOptions\" params=\"params\" auto-resize-params=\"resizeParams\" show-global-search=\"false\" enable-xls-export=\"false\"></six-grid-pagination></div></div></div><div class=\"panel-footer\" ng-hide=\"odlSixLookupStyle\"><button class=\"btn btn-sm btn-success\" ng-click=\"onAddOdl()\" ng-disabled=\"params.gridApi.selection.getSelectedRows().length == 0\"><i class=\"fa fa-plus\"></i> Aggiungi</button> <button class=\"btn btn-sm btn-default pull-right\" ng-click=\"onCloseOdl()\"><i class=\"fa fa-undo\"></i> Annulla</button></div>");
$templateCache.put("consip/sal/order_dialog.html","<div class=\"text-center\"><h4 class=\"m-n font-bold\">{{order.tipo_riga == \'aa\'? \'Atto aggiuntivo\' : \'Ordine principale\'}}</h4><span class=\"text-muted\">{{order.code}}</span></div><div class=\"text-center\"><i class=\"m-xs fa fa-calendar text-siccess-dker\"></i> {{order.data_inizio | date:\'MMM yyyy\'}} - {{order.data_fine | date:\'MMM yyyy\'}} <span class=\"small text-muted\">({{order.mesi_erogazione}} mesi)</span></div><table align=\"center\" class=\"text-right small\"><tbody><tr><td class=\"font-bold\">Totale: <i class=\"m-xs fa fa-credit-card text-info-dker\"></i></td><td class=\"text-left\">{{order.importo_totale | currency}}</td></tr><tr><td class=\"font-bold\">Totale annuo: <i class=\"m-xs fa fa-credit-card text-primary-dker\"></i></td><td class=\"text-left\">{{order.importo_annuo | currency}}</td></tr><tr><td class=\"font-bold\">ISTAT: <i class=\"m-xs fa fa-line-chart text-danger-dker\"></i></td><td class=\"text-left\" ng-show=\"order.istat_updated\">{{order.istat_alteration | number:2}} %</td><td class=\"text-left\" ng-hide=\"order.istat_updated\">Non applicato</td></tr></tbody></table>");
$templateCache.put("consip/sal/plafond_dialog.html","<div class=\"text-center\"><h4 class=\"m-n font-bold\">Plafond</h4>{{row.model.service_id.description}} - {{row.model.asset_id.description}}</div><table align=\"center\" class=\"text-right small\"><tbody><tr><td class=\"font-bold\">Totale: <i class=\"m-xs fa fa-credit-card text-info-dker\"></i></td><td>{{plafond.total | currency}}</td></tr><tr><td class=\"font-bold\">Consumato: <i class=\"m-xs fa fa-credit-card text-primary-dker\"></i></td><td>{{plafond.used | currency}}</td></tr><tr><td class=\"font-bold\">Residuo: <i class=\"m-xs fa fa-credit-card text-{{plafond.residual &gt; 0? \'success\' : \'danger\'}}-dker\"></i></td><td>{{plafond.residual | currency}}</td></tr></tbody></table>");
$templateCache.put("consip/sal/sal_configuration.html","<six-toolbar ng-if=\"contract\"><six-toolbar-item label=\"{{currentCustomer.description}}\" ng-show=\"currentCustomer\"></six-toolbar-item><six-toolbar-item icon=\"fa fa-exclamation text-danger-dker\" label=\"Selezionare un cliente per abilitare la creazione\" ng-hide=\"currentCustomer\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\" ng-hide=\"configuration\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-chevron-left\" toolbar-function=\"setConfiguration()\" ng-show=\"configuration\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-plus\" label=\"Nuovo\" btn-class=\"btn-success\" toolbar-function=\"newSalConfiguration()\" sx-disabled=\"!currentCustomer\" ng-hide=\"configuration\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-trash\" label=\"Elimina\" btn-class=\"btn-danger\" toolbar-function=\"deleteSalConfiguration(configuration)\" ng-show=\"configuration.version\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-save\" label=\"Salva\" btn-class=\"btn-success\" ng-if=\"configuration\" sx-disabled=\"form.confForm.$invalid || !form.confForm.$dirty\" toolbar-function=\"saveSalConfiguration()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 wrapper-lg\" ng-hide=\"contract || loading\"><uib-alert type=\"danger\">La configurazione della <strong>convenzione</strong> è obbligatoria per poter procedere.</uib-alert></div><div class=\"col-md-12 override-padding-toolbar\" ng-if=\"contract\"><div class=\"panel panel-default\" ng-hide=\"configuration\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista configurazioni SAL</h1></div></div></div><div class=\"panel-body\"><six-grid-pagination get-data-callback=\"getList()\" get-list-callback=\"getList()\" items-list=\"configurations\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\" show-global-search=\"0\"></six-grid-pagination></div></div><div class=\"panel panel-default\" ng-show=\"configuration\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-12 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Configurazione SAL commessa: {{commission.code}} - cliente {{currentCustomer.description}}</h1></div></div></div><form name=\"form.confForm\" class=\"wrapper\"><div class=\"row\"><div class=\"col-md-6\"><label class=\"control-label\">Codice:</label> <input type=\"text\" name=\"code\" ng-model=\"configuration.model.code\" class=\"form-control no-grey\" ng-required=\"true\" ng-minlength=\"3\"> <span ng-messages=\"confForm.code.$error\" class=\"error alert-b-r\" role=\"alert\"><span ng-message=\"required\">Il codice è obbligatorio</span> <span ng-message=\"minlength\">Minimo 3 caratteri</span></span></div><div class=\"col-md-6\"><label class=\"control-label\">Descrizione:</label> <input type=\"text\" name=\"description\" ng-model=\"configuration.model.description\" class=\"form-control no-grey\" ng-required=\"true\" ng-minlength=\"3\"> <span ng-messages=\"confForm.description.$error\" class=\"error alert-b-r\" role=\"alert\"><span ng-message=\"required\">La descrizione è obbligatoria</span> <span ng-message=\"minlength\">Minimo 3 caratteri</span></span></div></div><div class=\"row\"><div class=\"form-group col-md-12\"><label class=\"control-label\">Emails:</label><div class=\"input-group w-full\"><ui-select multiple=\"\" tagging=\"emailValidation\" tagging-label=\"false\" ng-model=\"configuration.model.emails\"><ui-select-match placeholder=\"Inserisci email ...\">{{$item}}</ui-select-match><ui-select-choices repeat=\"email in emailsOpt\">{{email}}</ui-select-choices></ui-select></div></div></div><div class=\"row\" ng-if=\"contract.model.contract_type == \'loose\'\"><div class=\"col-md-12\"><label class=\"control-label\">Servizi fatturabili:</label><six-lookup-2 sx-id=\"service\" sx-base-path=\"\'record\'\" sx-type=\"\'servizio\'\" sx-title=\"\'Servizio\'\" ng-model=\"configuration.model\" sx-empty-placeholder=\"\'Tutti i servizi\'\" sx-field=\"\'billable_services\'\" sx-show-filters=\"true\" sx-show-details=\"true\" sx-multiple=\"true\"></six-lookup-2></div></div><div class=\"row\" ng-if=\"!contract.model.contract_type || contract.model.contract_type == \'strict\'\"><div class=\"col-md-6\"><label class=\"control-label\">Tipo:</label><six-select-2 sx-id=\"service_type\" sx-list=\"serviceTypeList\" sx-title=\"\'Tipo servizio\'\" ng-model=\"configuration.model\" sx-empty-placeholder=\"\'Tutti i tipi\'\" sx-field=\"\'serviceType\'\" sx-multiple=\"true\" sx-item-template=\"\'{{item.description}}\'\"></six-select-2></div><div class=\"col-md-6\"><label class=\"control-label\">Edifici:</label><six-lookup-2 sx-id=\"assets\" sx-base-path=\"\'record\'\" sx-type=\"\'edificio\'\" sx-title=\"\'Edificio\'\" sx-empty-placeholder=\"\'Tutti gli edifici\'\" ng-model=\"configuration.model\" sx-field=\"\'assets\'\" sx-show-filters=\"true\" sx-show-details=\"true\" sx-multiple=\"true\"></six-lookup-2></div><div class=\"col-md-3\"><label class=\"control-label\">Gruppi servizio:</label><six-lookup-2 sx-id=\"service_groups\" sx-base-path=\"\'record\'\" sx-type=\"\'classeservizio\'\" sx-title=\"\'Gruppo servizio\'\" sx-empty-placeholder=\"\'Tutte le classi\'\" ng-model=\"configuration.model\" sx-field=\"\'serviceGroups\'\" sx-show-filters=\"true\" sx-show-details=\"true\" sx-multiple=\"true\"></six-lookup-2></div><div class=\"col-md-3\"><label class=\"control-label\">Servizi:</label><six-lookup-2 sx-id=\"service\" sx-base-path=\"\'record\'\" sx-type=\"\'servizio\'\" sx-title=\"\'Servizio\'\" ng-model=\"configuration.model\" sx-empty-placeholder=\"\'Tutti i servizi\'\" sx-field=\"\'services\'\" sx-show-filters=\"true\" sx-show-details=\"true\" sx-multiple=\"true\"></six-lookup-2></div><div class=\"col-md-6\"><label class=\"control-label\">Aggregazioni:</label><six-select-2 sx-id=\"aggregations\" sx-list=\"aggregationFields\" sx-title=\"\'Aggregazioni\'\" ng-model=\"configuration.model\" sx-field=\"\'aggregations\'\" sx-multiple=\"true\" sx-item-template=\"\'{{item.description}}\'\" sx-key=\"\'code\'\"></six-select-2></div><div class=\"col-md-12 m-t\"><label class=\"checkbox-inline i-checks m-t-none m-b-none\"><input type=\"checkbox\" ng-model=\"configuration.model.scheduleActive\"><i></i> Abilita generazione automatica</label> <label class=\"checkbox-inline i-checks m-t-none m-b-none\"><input type=\"checkbox\" ng-model=\"configuration.model.suspended\" ng-disabled=\"!configuration.model.scheduleActive\"><i></i> Sospenti i SAL</label></div></div></form></div></div>");
$templateCache.put("consip/sal/sal_detail.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" toolbar-function=\"goToSalList()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-file-pdf-o text-success-dker\" label=\"Esporta PDF\" btn-class=\"btn-default\" toolbar-function=\"jasperReport(\'sal\', \'pdf\')\" sx-disabled=\"viewGridOptions.data.length == 0\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh\" label=\"Aggiorna\" btn-class=\"btn-info\" toolbar-function=\"refresh()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-save\" ng-if=\"isWritePermAllowed()\" label=\"Salva\" btn-class=\"btn-success\" toolbar-function=\"saveSal()\" sx-disabled=\"!canSave()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-trash\" ng-if=\"isDeletionAllowed()\" label=\"Elimina\" btn-class=\"btn-danger\" toolbar-function=\"deleteSal()\" sx-disabled=\"viewGridOptions.data.length == 0\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\" ui-i18n=\"\'it\'\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-8 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Cod. SAL: {{currentSalCode}} - Cliente: {{currentCustomer.description}}</h1></div><div class=\"col-sm-4 col-xs-12\"><sal-status class=\"pull-right\" sx-object=\"headerSalInformation.model\" sx-status=\"headerSalInformation.model.status\" sx-uuid=\"headerSalInformation.UUID\" sx-callback=\"loadAlowedSatatus()\"></sal-status></div></div></div><div class=\"panel-body\"><uib-tabset active=\"activeTab\"><uib-tab index=\"0\"><uib-tab-heading><span class=\"fa fa-table text-info-dker\"></span> Dati</uib-tab-heading><uib-tabset class=\"tabs-right\"><div class=\"row wrapper\"><div class=\"col-md-4\"><div class=\"control-group\"><label class=\"control-label\">Codice:</label> <input name=\"salCode\" type=\"text\" ng-model=\"headerSalInformation.model.code\" class=\"form-control\" readonly=\"\"></div></div><div class=\"col-md-8\"><div class=\"control-group\"><label class=\"control-label\">Descrizione:</label> <input name=\"salDescription\" type=\"text\" ng-model=\"headerSalInformation.model.description\" class=\"form-control\" readonly=\"\"></div></div></div><div class=\"row wrapper\" ng-if=\"isLooseContract &amp;&amp; isWritePermAllowed()\" ng-init=\"selectedService = {}\"><div class=\"col-lg-8\"><six-lookup-2 sx-id=\"service\" sx-base-path=\"\'record\'\" sx-type=\"\'servizio\'\" sx-placeholder=\"\'Servizio\'\" ng-model=\"selectedService\" sx-field=\"\'service\'\" sx-compact=\"true\" sx-filter=\"billableServices\"></six-lookup-2></div><div class=\"col-lg-4 no-padder m-l-n\"><button class=\"btn btn-success\" ng-click=\"onAddManualRow(selectedService.service); selectedService.service = null\" ng-disabled=\"!selectedService.service\"><i class=\"fa fa-plus\"></i> Aggiungi riga</button></div></div><div class=\"row wrapper\"><div class=\"col col-md-12\"><div class=\"m-b-xs\" ng-if=\"isWritePermAllowed()\"><add-sal-row ng-if=\"!isLooseContract\" on-add-rows=\"addSalRows(rows, type)\" date-range=\"headerSalInformation.model\" customer=\"headerSalInformation.customer[0]\"></add-sal-row><span ng-if=\"isLooseContract\"><b class=\"m-l\">Plafond totale:</b> <i class=\"m-xs fa fa-credit-card text-info-dker\"></i> {{plafond.total | currency}} <b class=\"m-l\">Plafond consumato:</b> <i class=\"m-xs fa fa-credit-card text-primary-dker\"></i> {{plafond.turnover || 0 | currency}} <b class=\"m-l\">Plafond residuo:</b> <i class=\"m-xs fa fa-credit-card text-{{plafond.total &gt; plafond.turnover + getSalAmount()? \'success\' : \'danger\'}}-dker\"></i> {{plafond.total - plafond.turnover | currency}} <span class=\"text-muted\" ng-if=\"getSalAmount()\">({{plafond.total - plafond.turnover - getSalAmount() | currency}})</span></span></div><div class=\"grid ict-grid-edit\" ui-grid=\"viewGridOptions\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\" ui-grid-auto-resize=\"\" ui-grid-edit=\"\" ui-grid-row-edit=\"\" ui-grid-cellnav=\"\" ui-grid-expandable=\"\"></div></div></div></uib-tabset></uib-tab><uib-tab index=\"1\" disable=\"isDirty()\"><uib-tab-heading uib-tooltip=\"Salva le modifiche\" tooltip-enable=\"isDirty()\"><span class=\"fa fa-book text-info-dker\"></span> Gestione documenti</uib-tab-heading><uib-tabset class=\"tabs-right\"><div class=\"wrapper\" ng-controller=\"SalAttachmentCtrl\"><div class=\"row\"><uib-alert type=\"danger\" ng-if=\"upload.errors.length\"><strong>Caricamento FALLITO</strong><div ng-repeat=\"error in upload.errors\">{{error}}</div></uib-alert><input type=\"file\" id=\"fileUploadBtn\" nv-file-select=\"\" uploader=\"uploader\" class=\"hidden\" multiple=\"\"><div class=\"col-md-12\" ng-if=\"uploader.queue.length\"><div class=\"panel panel-default\"><div class=\"panel-body\"><table class=\"table m-n\"><thead><tr><th>Nome file</th><th ng-show=\"uploader.isHTML5\">Dimensione</th><th ng-show=\"uploader.isHTML5\">Avanzamento</th><th ng-if=\"canAttachInvoice()\">Fattura</th></tr></thead><tbody><tr ng-repeat=\"item in uploader.queue\"><td><strong>{{ item.file.name }}</strong></td><td ng-show=\"uploader.isHTML5\" nowrap=\"\">{{ item.file.size/1024/1024|number:2 }} MB</td><td ng-show=\"uploader.isHTML5\"><div class=\"progress m-b-none\"><div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{ \'width\': item.progress + \'%\' }\"></div></div></td><td ng-if=\"canAttachInvoice()\"><div class=\"checkbox m-n\"><label class=\"i-checks\"><input type=\"checkbox\" ng-model=\"item.is_invoice\" ng-disbled=\"uploader.isUploading\" ng-change=\"setInvoice(item)\"><i></i></label></div></td></tr></tbody></table><div class=\"row m-t-sm\" ng-if=\"(uploader.queue | filter:{is_invoice:true}).length\"><div class=\"col-md-3\"><p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"invoice.invoice_date\" placeholder=\"Data fattura\" is-open=\"opened\" datepicker-options=\"{showWeeks: false}\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"opened = !opened;\"><i class=\"fa fa-calendar\"></i></button></span></p></div><div class=\"col-md-9\"><input type=\"text\" class=\"form-control\" placeholder=\"Note\" ng-model=\"invoice.note\"></div></div></div><footer class=\"panel-footer bg-light lter\"><a class=\"btn btn-primary\" ng-click=\"addQuote()\"><i class=\"fa fa-plus\"></i> Aggiungi file</a> <a class=\"btn btn-success\" ng-click=\"uploader.uploadAll()\" ng-disabled=\"uploader.queue.length == 0\"><i class=\"fa fa-check\"></i> Conferma</a> <a class=\"btn btn-warning\" ng-click=\"undoUpload()\" ng-disabled=\"uploader.isUploading\"><i class=\"fa fa-undo\"></i> Annulla</a></footer></div></div></div><uib-alert type=\"info\" ng-hide=\"attachmentsListDocument.length || uploaduploader.queue.length\">Nessun documento caricato</uib-alert><div ng-repeat=\"file in attachmentsListDocument\"><div class=\"row\"><div class=\"col-md-12\"><h5 class=\"b-b b-2x\"><div class=\"m-b-xs\"><a ng-href=\"{{DOWNLOAD_URL}}{{file.model.object_id}}\" target=\"_blank\" download=\"{{file.model.title}}\">Nome documento: <strong>{{file.model.title}}</strong> <i class=\"fa fa-arrow-down text-primary\" aria-hidden=\"true\"></i></a> <a ng-click=\"removeAttachment(file)\" ng-if=\"canRemoveInvoice\"><i class=\"fa fa-times text-danger\"></i></a></div></h5></div></div><div class=\"row\"><div class=\"col-md-1\"><i ng-if=\"!file.model.is_invoice\" class=\"fa fa-file-o fa-2x text-muted\"></i> <span class=\"fa-stack text-muted\" ng-if=\"file.model.is_invoice\"><i class=\"fa fa-file-o fa-stack-2x\"></i> <i class=\"fa fa-eur fa-stack-1x text-info\"></i></span></div><div class=\"col-md-2\"><small class=\"block\">Data caricamento</small> <small class=\"block\">{{file.model.date_insertion | date:\'dd/MM/yyyy\'}}</small></div><div class=\"col-md-2\"><small class=\"block\">Utente</small> <small class=\"block\">{{file.model.user}}</small></div><div class=\"col-md-6\" ng-if=\"file.model.is_invoice\"><small class=\"block\">Data fattura: {{file.model.invoice_date | date:\'dd/MM/yyyy\'}}</small> <small class=\"block\">{{file.model.note}}</small></div></div></div><div class=\"row m-t-sm\"><div ng-hide=\"uploader.queue.length\" class=\"col-md-12\"><button class=\"btn btn-default\" ng-click=\"loadQuote()\" ng-disabled=\"readonlyMode\">Carica</button></div></div></div></uib-tabset></uib-tab><uib-tab index=\"2\" select=\"getMessage()\"><uib-tab-heading><span class=\"fa fa-envelope text-info-dker\"></span> Messaggi</uib-tab-heading><uib-tabset class=\"tabs-right\"><div class=\"col-md-12\" ng-if=\"loadingSixMail == true\"><uib-progressbar class=\"progress-striped active\" type=\"info\"><i>Caricamento messaggio</i></uib-progressbar></div><six-send-email ng-if=\"loadingSixMail == false\" sx-title-mail=\"objMail.title\" sx-body-mail=\"objMail.message\" sx-to-mail=\"objMail.to\" sx-cc-mail=\"objMail.cc\" sx-type-mail=\"\'sal\'\" sx-record-id=\"currentSalRef\" sx-alfresco-attachments=\"true\"></six-send-email></uib-tabset></uib-tab><uib-tab index=\"3\" select=\"getNotificationsList()\"><uib-tab-heading><span class=\"icon-bell text-info-dker\"></span> Notifiche</uib-tab-heading><div ng-if=\"notifications.length==0\" class=\"alert alert-info\" role=\"alert\">Nessun messaggio inviato</div><ul class=\"list-group list-group-lg no-radius m-b-none m-t-n-xxs\"><li ng-repeat=\"notification in notifications\" class=\"list-group-item clearfix b-l-3x ng-scope\" ng-class=\"notification.color\"><span class=\"avatar thumb pull-left m-r\"><img ng-hide=\"notification.user\" ng-src=\"/images/avatar_system.png\"> <img ng-show=\"notification.user\" ng-src=\"/images/avatar_emil.png\"></span><div class=\"pull-right text-sm text-muted\"><span class=\"hidden-xs ng-binding\">{{notification.dataIn | date:\"dd/MM/yyyy\"}}</span></div><div class=\"clear\"><div><a class=\"text-md ng-binding\" ng-href=\"{{notification.href}}\"><span ng-show=\"notification.model.subject\">Oggetto: {{notification.model.subject}}</span> <span ng-show=\"notification.user\">da {{notification.user}}</span> <span ng-show=\"notification.model.to\">a {{notification.model.to}}</span></a></div><div class=\"text-ellipsis m-t-xs ng-binding\">{{notification.model.bodyAsText}}</div></div></li></ul></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("consip/sal/sal_detail_action_col.html","<div class=\"ui-grid-cell-contents text-center\"><a ng-click=\"grid.api.expandable.toggleRowExpansion(row.entity)\" class=\"m-r-xs btn btn-rounded btn-xs btn-icon btn-{{row.isExpanded? \'default\' : \'info\'}}\" ng-class=\"{shadow: row.entity.model.note}\" ng-if=\"grid.appScope.isWritePermAllowed() || row.entity.model.note.length\"><i class=\"fa fa-pencil-square-o\"></i></a> <a ng-if=\"grid.appScope.isWritePermAllowed()\" ng-click=\"grid.appScope.deleteRowDialog(row)\" class=\"btn btn-xs btn-icon btn-danger\"><i class=\"m-n fa fa-trash\"></i></a></div>");
$templateCache.put("consip/sal/sal_list.html","<six-toolbar><six-toolbar-button icon=\"fa fa-plus\" label=\"Nuovo\" btn-class=\"btn-success\" toolbar-function=\"goToNewSal()\" ng-if=\"salConfigurations.length == 0\"></six-toolbar-button><six-toolbar-item icon=\"fa fa-plus\" label=\"Nuovo\" sx-disabled=\"salConfigurations.length == 0\"><li ng-repeat=\"salc in salConfigurations\"><a ng-click=\"goToNewSal(salc)\">{{salc.model.description}}</a></li></six-toolbar-item><six-toolbar-button ng-if=\"canClose\" icon=\"fa fa-times-circle-o\" label=\"Chiudi SAL\" btn-class=\"btn-danger\" toolbar-function=\"closeSal()\" sx-disabled=\"getSelectedRows().length == 0\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista SAL</h1></div></div></div><div class=\"panel-body\"><six-grid-pagination get-data-callback=\"getListSal()\" get-list-callback=\"getListSal()\" items-list=\"listSalRows\" column-defs=\"viewGridListSalOptions.columnDefs\" grid-options=\"viewGridListSalOptions\" params=\"params\" grid-app-callbacks=\"gridAppCallbacks\"></six-grid-pagination></div></div></div>");
$templateCache.put("consip/sal/sal_new.html","<style type=\"text/css\">\n\n  .highlight-row {\n    background-color: #00fcf3;\n    padding: 0 4px 0 4px;\n    border: thin solid lightblue;\n  }\n\n  .odl-panel {\n    position: absolute;\n    top: -592px;\n    z-index: 900;\n    width: 100%;\n    height: 512px;\n    -webkit-transition: top 0.5s;\n    transition: top 0.5s;\n  }\n\n  .odl-panel.active {\n    top: 0px;\n  }\n\n</style><script type=\"text/ng-template\" id=\"dialogTemplate.html\"><strong> <span class=\"ngdialog-icon\"></span> </strong> <div style=\"text-align: center;\"> <h4 class=\"m-t-none m-b font-bold\">ATTENZIONE</h4> </div> <table align=\"center\" style=\"text-align: right;\"> <caption style=\"text-align: right\">{{allCount}} righe totali di cui:</caption> <tr> <td>a canone:</td> <td style=\"padding-left: 5px\">{{canoneCount}}</td> </tr> <tr> <td>extra-canone non modificate:</td> <td style=\"padding-left: 5px\">{{notModifiedCount}}</td> </tr> <tr> <td>extra-canone da ODL:</td> <td style=\"padding-left: 5px\">{{extraCanoneOdlToSaveCount}}</td> </tr> <tr> <td>extra-canone con importo nullo:</td> <td style=\"padding-left: 5px\">{{zeroAmountCount}}</td> </tr> <tr> <td>con residui negativi:</td> <td style=\"padding-left: 5px\">{{errors}}</td> </tr> <tr> <td>già generate:</td> <td style=\"padding-left: 5px\">{{alreadyGeneratedCount}}</td> </tr> </table> <div class=\"row m-t\"> <div class=\"col-sm-4\" style=\"text-align: center\"> <button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"saveAll(); closeThisDialog();\" ng-disabled=\"allToSaveCount==0\"> <i class=\"fa fa-save\"></i> Salva tutto ({{allToSaveCount}})</button> </div> <div class=\"col-sm-5\" style=\"text-align: center\"> <button type=\"button\" class=\"btn btn-sm btn-warning\" ng-click=\"saveDirty(); closeThisDialog();\" ng-disabled=\"canoneToSaveCount+dirtyToSaveCount+extraCanoneOdlToSaveCount==0\"> <i class=\"fa fa-save\"></i> Salva canone + mod + ODL. ({{canoneToSaveCount}}+{{dirtyToSaveCount}}+{{extraCanoneOdlToSaveCount}})</button> </div> <div class=\"col-sm-3\" style=\"text-align: center\"> <button type=\"button\" class=\"btn btn-sm btn-default\" ng-click=\"closeThisDialog()\"> <i class=\"fa fa-undo\"></i> Annulla</button> </div> </div></script><script type=\"text/ng-template\" id=\"dialogOldRowTemplate.html\"><strong> <span class=\"ngdialog-icon\"></span> </strong> <div style=\"text-align: center;\"> <h4 class=\"m-t-none m-b font-bold\">Riga già generata</h4> </div> <table class=\"tinyTable\"> <tr> <th>Cod. SAL</th> <th>Edificio</th> <th>Classe serv.</th> <th>Servizio</th> <th>Tipo serv.</th> <th>Data inizio</th> <th>Data fine</th> <th>Importo</th> </tr> <tr> <td colspan=\"8\" class=\"head\">Vecchia riga</td> </tr> <tr ng-repeat=\"oldRow in row\"> <td>{{oldRow.model.header_id.code}}</td> <td>{{oldRow.model.asset_id.code}} - {{oldRow.model.asset_id.description}}</td> <td>{{oldRow.model.serviceclass_id.code}} - {{oldRow.model.serviceclass_id.description}}</td> <td>{{oldRow.model.service_id.code}} - {{oldRow.model.service_id.description}}</td> <td>{{oldRow.model.service_type}}</td> <td class=\"dateCell\">{{oldRow.model.start_date | date:\'dd/MM/yyyy\'}}</td> <td class=\"dateCell\">{{oldRow.model.end_date | date:\'dd/MM/yyyy\'}}</td> <td class=\"numberCell\">{{oldRow.model.amount | currency:\'€\':3}}</td> </tr> </table></script><six-toolbar><six-toolbar-item icon=\"fa fa-exclamation text-danger-dker\" label=\"Selezionare un cliente per abilitare la funzione\" ng-show=\"isCustomerMissing()\"></six-toolbar-item><six-toolbar-item label=\"{{currentCustomer.description}}\" ng-hide=\"isCustomerMissing()\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" toolbar-function=\"goToSalList()\" ng-hide=\"isCustomerMissing()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-undo\" label=\"Reset\" btn-class=\"btn-info\" toolbar-function=\"resetSalRows()\" sx-disabled=\"salRows.length == 0\" ng-hide=\"isCustomerMissing()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-gears\" label=\"Crea\" btn-class=\"btn-success\" toolbar-function=\"create()\" sx-disabled=\"salRows.length > 0 || form.$invalid || !isSalGenerable\" ng-hide=\"isCustomerMissing()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-save\" label=\"Salva\" btn-class=\"btn-success\" toolbar-function=\"saveWithDialog()\" sx-disabled=\"!canSave()\" ng-hide=\"isCustomerMissing()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\" ng-hide=\"isCustomerMissing()\"><div class=\"panel panel-default constructor\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12 col-md-12\"><span class=\"error pull-right\" role=\"alert\" ng-if=\"!acquisition\">Impossibile recuperare le informazioni di contratto</span> <span class=\"error pull-right\" role=\"alert\" ng-if=\"acquisition && !isSalGenerable\">Il contratto risulta NON attivo nelle date selezionate: data inizio contratto: {{acquisition.model.start_contract_date | date: \'dd/MM/yyyy\'}}, data fine contratto: {{acquisition.model.end_contract_date | date: \'dd/MM/yyyy\'}}</span><h1 class=\"m-n font-thin h3 text-black\">Creazione SAL cliente {{currentCustomer.description}}</h1></div></div></div><form name=\"form\" class=\"wrapper\"><div class=\"row\"><div class=\"col-md-3 padder-v-xs\"><div class=\"control-group\"><label class=\"control-label\">Periodo da:</label><six-date-time-picker name=\"datePickerFrom\" ng-model=\"salConfiguration.from\" date-options=\"dateOptions\" format=\"dateFormat\" ng-required=\"true\" sx-form=\"form\" enable-time=\"0\" ng-change=\"dateChange()\"></six-date-time-picker></div></div><div class=\"col-md-3 padder-v-xs\"><div class=\"control-group\"><label class=\"control-label\">Periodo a:</label><six-date-time-picker name=\"datePickerTo\" ng-model=\"salConfiguration.to\" date-options=\"dateOptions\" format=\"dateFormat\" sx-disabled=\"true\" ng-required=\"true\" sx-form=\"form\"></six-date-time-picker></div></div></div><div class=\"row\"><div class=\"col-md-3 padder-v-xs\"><div class=\"control-group\" ng-class=\"{\'has-error\': form.salCode.$invalid}\"><label class=\"control-label\">Codice:</label> <input id=\"salCode\" name=\"salCode\" type=\"text\" ng-model=\"salConfiguration.code\" class=\"form-control\" ng-minlength=\"3\" ng-required=\"true\" ng-readonly=\"salRows.length>0\" unique-validation=\"salFactory\" unique-field=\"model.code\"> <span ng-messages=\"form.salCode.$error\" class=\"error alert-b-r\" role=\"alert\"><span ng-message=\"required\">Il codice è obbligatorio</span> <span ng-message=\"unique\">Il codice è già stato utilizzato</span> <span ng-message=\"minlength\">Minimo 3 caretteri</span></span></div></div><div class=\"col-md-9 padder-v-xs\"><div class=\"control-group\" ng-class=\"{\'has-error\': form.salDescription.$invalid}\"><label class=\"control-label\">Descrizione:</label> <input id=\"salDescription\" name=\"salDescription\" type=\"text\" ng-model=\"salConfiguration.description\" class=\"form-control\" ng-minlength=\"3\" ng-required=\"true\" ng-readonly=\"salRows.length>0\"> <span ng-messages=\"form.salDescription.$error\" class=\"error alert-b-r\" role=\"alert\"><span ng-message=\"required\">La descrizione è obbligatoria</span> <span ng-message=\"unique\">La descrizione è già stata utilizzata</span> <span ng-message=\"minlength\">Minimo 3 caratteri</span></span></div></div></div><div class=\"row m-t-xs\"><div class=\"form-group col-md-12\"><label class=\"control-label\">Emails:</label><div class=\"input-group w-full\"><ui-select multiple=\"\" tagging=\"emailValidation\" tagging-label=\"false\" ng-model=\"salConfiguration.emails\"><ui-select-match placeholder=\"Inserisci email ...\">{{$item}}</ui-select-match><ui-select-choices repeat=\"email in salConfiguration.emails\">{{email}}</ui-select-choices></ui-select></div></div></div><div class=\"row padder-v-xs\"><div class=\"col-lg-6 col-md-12 padder-v-xs\"><label class=\"control-label\">Gruppi servizio:</label><six-lookup-2 sx-id=\"service_groups\" sx-base-path=\"\'record\'\" sx-type=\"\'classeservizio\'\" sx-title=\"\'Gruppo servizio\'\" sx-empty-placeholder=\"\'Tutti i gruppi servizio\'\" ng-model=\"salConfiguration\" sx-field=\"\'serviceGroups\'\" sx-show-filters=\"true\" sx-show-details=\"true\" sx-multiple=\"true\"></six-lookup-2></div><div class=\"col-lg-6 col-md-12 padder-v-xs\"><label class=\"control-label\">Servizi:</label><six-lookup-2 sx-id=\"service\" sx-base-path=\"\'record\'\" sx-type=\"\'servizio\'\" sx-title=\"\'Servizio\'\" sx-empty-placeholder=\"\'Tutti i servizi\'\" ng-model=\"salConfiguration\" sx-field=\"\'services\'\" sx-show-filters=\"true\" sx-show-details=\"true\" sx-multiple=\"true\"></six-lookup-2></div><div class=\"col-lg-4 col-md-9 padder-v-xs\"><label class=\"control-label\">Tipo servizio:</label><six-select-2 sx-id=\"service_type\" sx-list=\"serviceTypeList\" sx-title=\"\'Tipo servizio\'\" ng-model=\"salConfiguration\" sx-field=\"\'serviceType\'\" sx-empty-placeholder=\"\'Tutto\'\" sx-multiple=\"true\" sx-item-template=\"\'{{item.description}}\'\"></six-select-2></div><div class=\"col-lg-2 col-md-3 padder-v-xs\"><a class=\"btn btn-bg btn-default btn-block\" style=\"margin-top: 25px;\" ng-click=\"openOdlPanel()\" ui-toggle-class=\"active\" target=\".odl-panel\" ng-disabled=\"!isFromOdlMode()\"><i class=\"fa fa-search\"></i> ODL <b class=\"badge bg-info\">{{odl.selected.length}}</b></a></div><div ng-include=\"\'consip/sal/odl_panel.html\'\" ng-controller=\"SalOdlPanel\" class=\"odl-panel panel panel-default\"></div><div class=\"col-lg-6 col-md-12 padder-v-xs\"><label class=\"control-label\">Edifici:</label><six-lookup-2 sx-id=\"assets\" sx-base-path=\"\'record\'\" sx-type=\"\'edificio\'\" sx-title=\"\'Edificio\'\" sx-empty-placeholder=\"\'Tutti gli edifici\'\" sx-placeholder=\"\' \'\" ng-model=\"salConfiguration\" sx-field=\"\'assets\'\" sx-show-filters=\"true\" sx-show-details=\"true\" sx-multiple=\"true\"></six-lookup-2></div><div class=\"col-md-12 padder-v-xs\"><label class=\"control-label\">Aggregazioni:</label><six-select-2 sx-id=\"aggregations\" sx-list=\"aggregationFields\" sx-title=\"\'Aggregazioni\'\" sx-empty-placeholder=\"\'Nessuna\'\" sx-placeholder=\"\' \'\" ng-model=\"salConfiguration\" sx-field=\"\'aggregations\'\" sx-multiple=\"true\" sx-key=\"\'code\'\" sx-item-template=\"\'{{item.description}}\'\"></six-select-2></div></div></form></div><div class=\"panel panel-default constructor\"><div class=\"panel-body\" ng-if=\"salRows.length\"><div class=\"row\"><div class=\"col col-md-12\"><div id=\"salrows_grid\" class=\"grid ict-grid-edit\" ui-grid=\"viewGridOptions\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\" ui-grid-auto-resize=\"\" ui-grid-edit=\"\" ui-grid-row-edit=\"\" ui-grid-cellnav=\"\" ui-grid-expandable=\"\"></div></div></div></div></div></div>");
$templateCache.put("consip/sal/sal_new_loose.html","<six-toolbar><six-toolbar-item icon=\"fa fa-exclamation text-danger-dker\" label=\"Selezionare un cliente per abilitare la funzione\" ng-show=\"isCustomerMissing()\"></six-toolbar-item><six-toolbar-item label=\"{{currentCustomer.description}}\" ng-hide=\"isCustomerMissing()\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-undo\" label=\"Reset\" btn-class=\"btn-info\" toolbar-function=\"salRows.length = 0\" sx-disabled=\"salRows.length == 0\" ng-hide=\"isCustomerMissing()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-save\" label=\"Salva\" btn-class=\"btn-success\" toolbar-function=\"saveWithDialog()\" sx-disabled=\"!canSave()\" ng-hide=\"isCustomerMissing()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\" ng-hide=\"isCustomerMissing()\" ui-i18n=\"\'it\'\"><div class=\"panel panel-default constructor animated fadeInRight\" ng-show=\"visiblePanel.sal\" ng-class=\"{fadeOutLeft: !visiblePanel.sal}\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12 col-md-12\"><span class=\"error pull-right\" role=\"alert\" ng-if=\"!context.acquisition\">Impossibile recuperare le informazioni di contratto</span> <span class=\"error pull-right\" role=\"alert\" ng-if=\"context.acquisition && !isSalGenerable\">Il contratto risulta NON attivo nelle date selezionate: data inizio contratto: {{context.acquisition.model.start_contract_date | date: \'dd/MM/yyyy\'}}, data fine contratto: {{context.acquisition.model.end_contract_date | date: \'dd/MM/yyyy\'}}</span><h1 class=\"m-n font-thin h3 text-black\">Creazione SAL cliente {{context.customer.description}}</h1></div></div></div><form name=\"form\" class=\"wrapper\"><div class=\"row\"><div class=\"col-md-3 padder-v-xs\"><div class=\"control-group\"><label class=\"control-label\">Periodo da:</label><six-date-time-picker name=\"datePickerFrom\" ng-model=\"salConfiguration.from\" date-options=\"dateOptions\" format=\"dateFormat\" ng-required=\"true\" sx-form=\"form\" enable-time=\"0\" ng-change=\"dateChange()\"></six-date-time-picker></div></div><div class=\"col-md-3 padder-v-xs\"><div class=\"control-group\"><label class=\"control-label\">Periodo a:</label><six-date-time-picker name=\"datePickerTo\" ng-model=\"salConfiguration.to\" date-options=\"dateOptions\" format=\"dateFormat\" sx-disabled=\"true\" ng-required=\"true\" sx-form=\"form\"></six-date-time-picker></div></div></div><div class=\"row padder-v-xs\"><div class=\"col-md-3\"><div class=\"control-group\" ng-class=\"{\'has-error\': form.salCode.$invalid}\"><label class=\"control-label\">Codice:</label> <input id=\"salCode\" name=\"salCode\" type=\"text\" ng-model=\"salConfiguration.code\" class=\"form-control\" ng-minlength=\"3\" ng-required=\"true\" unique-validation=\"salFactory\" unique-field=\"model.code\"> <span ng-messages=\"form.salCode.$error\" class=\"error alert-b-r\" role=\"alert\"><span ng-message=\"required\">Il codice è obbligatorio</span> <span ng-message=\"unique\">Il codice è già stato utilizzato</span> <span ng-message=\"minlength\">Minimo 3 caretteri</span></span></div></div><div class=\"col-md-9\"><div class=\"control-group\" ng-class=\"{\'has-error\': form.salDescription.$invalid}\"><label class=\"control-label\">Descrizione:</label> <input id=\"salDescription\" name=\"salDescription\" type=\"text\" ng-model=\"salConfiguration.description\" class=\"form-control\" ng-minlength=\"3\" ng-required=\"true\"> <span ng-messages=\"form.salDescription.$error\" class=\"error alert-b-r\" role=\"alert\"><span ng-message=\"required\">La descrizione è obbligatoria</span> <span ng-message=\"unique\">La descrizione è già stata utilizzata</span> <span ng-message=\"minlength\">Minimo 3 caratteri</span></span></div></div></div><div class=\"row m-t-xs\"><div class=\"form-group col-md-12\"><label class=\"control-label\">Emails:</label><div class=\"input-group w-full\"><ui-select multiple=\"\" tagging=\"emailValidation\" tagging-label=\"false\" ng-model=\"salConfiguration.emails\"><ui-select-match placeholder=\"Inserisci email ...\">{{$item}}</ui-select-match><ui-select-choices repeat=\"email in salConfiguration.emails\">{{email}}</ui-select-choices></ui-select></div></div></div><div class=\"row m-t-sm\"><div class=\"col-lg-12\"><a class=\"btn btn-bg btn-default m-r\" ng-click=\"visiblePanel.odl = true; visiblePanel.sal = false\"><i class=\"fa fa-search\"></i> ODL <b class=\"badge bg-info\">{{(salRows | filter:{ odl: { UUID: \'!!\' } }).length}}</b></a> <a class=\"btn btn-bg btn-default m-r\" ng-click=\"visiblePanel.invoice = true; visiblePanel.sal = false\"><i class=\"fa fa-search\"></i> Prefatture <b class=\"badge bg-info\">{{(salRows | filter:{ invoice: { UUID: \'!!\' } }).length}}</b></a> <a class=\"btn btn-success\" ng-click=\"visiblePanel.manual = true; visiblePanel.sal = false\"><i class=\"fa fa-plus\"></i> Aggiungi riga</a></div></div></form></div><div class=\"panel panel-default animated fadeInRight\" ng-include=\"\'consip/sal/invoice_panel.html\'\" ng-controller=\"SalInvoicePanel\" ng-show=\"visiblePanel.invoice\" ng-class=\"{fadeOutLeft: !visiblePanel.invoice}\"></div><div class=\"panel panel-default animated fadeInRight\" ng-include=\"\'consip/sal/odl_panel.html\'\" ng-controller=\"SalOdlPanel\" ng-show=\"visiblePanel.odl\" ng-class=\"{fadeOutLeft: !visiblePanel.odl}\"></div><div class=\"panel panel-default animated fadeInRight\" ng-show=\"visiblePanel.manual\" ng-class=\"{fadeOutLeft: !visiblePanel.manual}\"><div class=\"panel-heading\">Riga manuale <a class=\"pull-right\" ng-click=\"visiblePanel.manual = false; visiblePanel.sal = true\"><i class=\"fa fa-times\"></i></a></div><div class=\"panel-body\"><div class=\"w-full padder-v-xs\" ng-init=\"selectedService = {}\"><label class=\"control-label\">Servizio:</label><six-lookup-2 sx-id=\"service\" sx-base-path=\"\'record\'\" sx-type=\"\'servizio\'\" sx-placeholder=\"\'Servizio\'\" ng-model=\"selectedService\" sx-field=\"\'service\'\" sx-compact=\"true\" sx-required=\"true\" sx-filter=\"billableServices\"></six-lookup-2></div><div class=\"w-full m-t\"><div class=\"checkbox m-r-xs inline\"><label class=\"i-checks\"><input type=\"checkbox\" ng-model=\"createAnother\"><i></i> Aggiungi un\'altra</label></div><button class=\"btn btn-sm btn-success\" ng-click=\"onAddManualRow(selectedService.service, createAnother); selectedService.service= null\" ng-disabled=\"!selectedService.service\"><i class=\"fa fa-plus\"></i> Aggiungi riga</button> <button class=\"btn btn-sm btn-default pull-right\" ng-click=\"visiblePanel.manual = false; visiblePanel.sal = true\"><i class=\"fa fa-undo\"></i> Annulla</button></div></div></div><div class=\"panel panel-default constructor\"><div class=\"panel-body\"><div class=\"row\"><span><b class=\"m-l\">Plafond totale:</b> <i class=\"m-xs fa fa-credit-card text-info-dker\"></i> {{plafond.total | currency}} <b class=\"m-l\">Plafond consumato:</b> <i class=\"m-xs fa fa-credit-card text-primary-dker\"></i> {{plafond.turnover || 0 | currency}} <b class=\"m-l\">Plafond residuo:</b> <i class=\"m-xs fa fa-credit-card text-{{plafond.total &gt; plafond.turnover + getSalAmount()? \'success\' : \'danger\'}}-dker\"></i> {{plafond.total - plafond.turnover | currency}} <span class=\"text-muted\" ng-if=\"getSalAmount()\">({{plafond.total - plafond.turnover - getSalAmount() | currency}})</span></span></div><div class=\"row\"><div class=\"col col-md-12\"><div id=\"salrows_grid\" class=\"grid ict-grid-edit\" ui-grid=\"viewGridOptions\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\" ui-grid-auto-resize=\"\" ui-grid-edit=\"\" ui-grid-row-edit=\"\" ui-grid-cellnav=\"\" ui-grid-expandable=\"\"></div></div></div></div></div></div>");
$templateCache.put("consip/tasklog/tasklog_list.html","<style>\n    .sx-widget {\n        margin: 0px;\n        padding: 2px;\n        text-align: center;\n        width: 50%;\n    }\n</style><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h3 class=\"m-n font-thin h3 text-black\">Lista Task</h3></div><div class=\"col-sm-6 col-xs-12 text-right\"><button class=\"btn btn-default btn-success m-r\" ng-click=\"triggerSalGeneration()\"><span class=\"fa fa-play\"></span>Genera SAL</button> <button class=\"btn btn-default btn-success\" ng-click=\"triggerStatusChange()\"><span class=\"fa fa-play\"></span>Esegui cambio stato</button></div></div></div><div class=\"panel-body\"><div class=\"col col-md-12\"><table class=\"table table-striped\"><thead><tr><td>Status</td><td>Code</td><td>Time</td></tr></thead><tbody><tr ng-repeat=\"task in taskList\" ng-click=\"openDialog(task)\" style=\"cursor: pointer\"><td><div ng-class=\"{\'sx-widget\': true, \'alert alert-info\': getStatus(task) == \'Avviato\', \'alert alert-error\': getStatus(task) == \'Errore\', \'alert alert-warning\': getStatus(task) == \'Sconosciuto\', \'alert alert-success\': getStatus(task) == \'Terminato\'}\"><i ng-class=\"{\'fa\':true, \'fa-check\': getStatus(task) == \'Terminato\', \'fa-times\':getStatus(task) == \'Errore\', \'fa-exclamation\': getStatus(task) == \'Sconosciuto\', \'fa-info\': getStatus(task) == \'Avviato\' }\">{{getStatus(task)}}</i></div></td><td ng-bind-html=\"task.version\"></td><td><i aria-hidden=\"true\" class=\"fa fa-calendar m-b-sm\"><span class=\"m-l-sm\">{{getStartTime(task.start_time)}}</span></i><br><i aria-hidden=\"true\" class=\"fa fa-clock-o\"><span class=\"m-l-sm\">{{getElapsed(task.elapsed)}}</span></i></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("dataset/assetcalendar/assetcalendar.html","<style>\n  .month-container {\n    height: 230px !important;\n  }\n\n  .calendar {\n    overflow: unset;\n  }\n</style><six-toolbar><six-toolbar-button label=\"Cerca evento asset\" icon=\"fa fa-th-list\" toolbar-function=\"goToOpeningView()\"></six-toolbar-button><six-toolbar-button label=\"Vedi calendario\" icon=\"fa fa-calendar\" toolbar-function=\"toggleViewMode()\" ng-hide=\"!bool.gridViewMode\"></six-toolbar-button><six-toolbar-button label=\"Vedi tabella\" icon=\"fa fa-th\" toolbar-function=\"toggleViewMode()\" ng-hide=\"bool.gridViewMode\"></six-toolbar-button><six-toolbar-button label=\"Importa calendario\" icon=\"fa fa-upload\" toolbar-function=\"goToXlsImport()\" btn-class=\"btn-success\"></six-toolbar-button><six-toolbar-button label=\"Nuovo evento\" icon=\"fa fa-plus\" toolbar-function=\"goToNewEvent(getPageChangedParams())\" btn-class=\"btn-success\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3\">Calendario eventi</h1></div></div></div><div class=\"panel-heading\"><div id=\"calendar-options-form\" class=\"row\"><div class=\"col-sm-6 col-xs-12 form-group\" ng-show=\"bool.gridViewMode\"><label class=\"control-label\">Data inizio</label><six-date-time-picker name=\"from_date_picker\" ng-model=\"gridDates.fromDate\" enable-time=\"false\"></six-date-time-picker></div><div class=\"col-sm-6 col-xs-12 form-group\" ng-show=\"bool.gridViewMode\"><label class=\"control-label\">Data fine</label><six-date-time-picker name=\"to_date_picker\" ng-model=\"gridDates.toDate\" enable-time=\"false\"></six-date-time-picker></div><div class=\"col-sm-6 col-xs-12 form-group\" ng-show=\"bool.gridViewMode\"><label class=\"control-label\">Filtra per stato</label><six-select-2 sx-id=\"statusFilterSelect\" ng-model=\"gridCustomFilters\" sx-field=\"\'statusFilter\'\" sx-list=\"[{key: null, description:\'Tutti gli stati\'}, {key:\'open\', description:\'Aperto\'}, {key:\'closed\', description:\'Chiuso\'}]\" sx-item-template=\"\'{{item.description}}\'\" sx-compact=\"true\" sx-clearable=\"false\" sx-multiple=\"false\"></six-select-2></div><div class=\"col-sm-6 col-xs-12 form-group\" ng-show=\"bool.gridViewMode\"><label class=\"control-label\">Filtra per straordinarietà</label><six-select-2 sx-id=\"extraordinaryFilterSelect\" ng-model=\"gridCustomFilters\" sx-field=\"\'extraordinaryFilter\'\" sx-list=\"[{key: null, description:\'Tutti gli eventi\'}, {key: false, description:\'Eventi ordinari\'}, {key: true, description:\'Eventi straordinari\'}]\" sx-item-template=\"\'{{item.description}}\'\" sx-compact=\"true\" sx-clearable=\"false\" sx-multiple=\"false\"></six-select-2></div><div class=\"col-sm-6 form-group\" ng-hide=\"bool.commissionCalendar\"><label class=\"control-label\">Elemento tecnologico</label><six-lookup-2 sx-id=\"odl-schema\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" ng-model=\"opt.model\" sx-field=\"\'type_id\'\" sx-compact=\"true\" sx-show-details=\"false\" sx-show-filters=\"false\" sx-filter=\"typeIdFilter\" sx-required=\"true\"></six-lookup-2></div><div class=\"col-sm-6 form-group\" ng-hide=\"bool.commissionCalendar\"><label class=\"control-label\">Asset</label><six-lookup-2 sx-id=\"asset\" sx-base-path=\"\'record\'\" sx-type=\"opt.model.type_id.UUID\" ng-model=\"opt.model\" sx-field=\"\'record_id\'\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-show-tree=\"true\" sx-show-list=\"true\" sx-required=\"true\"></six-lookup-2></div><div class=\"col-sm-3 form-group pul-left\"><label class=\"checkbox i-checks m-b\"><input id=\"check-1\" type=\"checkbox\" ng-model=\"bool.commissionCalendar\"><i></i> <span class=\"i-checks\">Mostra calendario commessa</span></label></div><div class=\"col-sm-2 form-group pull-right\"><div class=\"input-group m-t\" style=\"width:100%\"><button class=\"btn btn-default\" name=\"calendarLoadBtn\" ng-click=\"getAssetCalendar()\"><i class=\"fa fa-search\"></i>Carica calendario</button></div></div></div></div><div class=\"panel-body\"><div id=\"year-calendar-view\" ng-show=\"!bool.gridViewMode\"></div><div ng-show=\"bool.gridViewMode\"><six-grid-pagination sx-id=\"grid_calendar_view\" get-data-callback=\"getAssetCalendar()\" get-list-callback=\"getAssetCalendar()\" show-global-search=\"false\" items-list=\"calendarDataSource\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\" enable-xls-export=\"true\"></six-grid-pagination></div></div></div></div>");
$templateCache.put("dataset/assetcalendar/assetcalendar_import.html","<style>\n  .no-resize{\n    resize: none;\n  }\n  .inline {\n    display: inline;\n  }\n</style><six-toolbar><six-toolbar-item label=\"Template\" icon=\"fa fa-download icon text-info-dker\" toolbar-function=\"getTemplate()\" ng-show=\"bool.showImportXls\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" toolbar-function=\"back()\"></six-toolbar-button><six-toolbar-button label=\"Reset\" icon=\"fa fa-undo\" toolbar-function=\"reset()\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" icon=\"fa fa-trash\" toolbar-function=\"deleteEvent()\" btn-class=\"btn-danger\" ng-show=\"bool.showDeleteButton && isDeletePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" icon=\"fa fa-save\" toolbar-function=\"saveSingle()\" btn-class=\"btn-success\" ng-show=\"bool.showSingleEvent && isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Importa\" icon=\"fa fa-upload\" toolbar-function=\"importXls()\" btn-class=\"btn-success\" ng-show=\"bool.showImportXls && isWritePermAllowed()\" sx-disabled=\"errorCount > 0 || !bool.importHasData\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3\" ng-show=\"bool.showSingleEvent\">Dettaglio evento</h1><h1 class=\"m-n font-thin h3\" ng-show=\"bool.showImportXls\">Importazione eventi</h1><h1 class=\"m-n font-thin h3\" ng-show=\"bool.showOpeningView\">Apertura/Chiusura Asset</h1></div></div></div><div class=\"panel-body\"><div id=\"calendar-options-form\"><div class=\"row\"><div ng-class=\"{\'col-sm-4\': bool.showOpeningView, \'col-sm-6\': !bool.showOpeningView, \'form-group\': true}\" ng-hide=\"bool.commissionCalendar || bool.showImportXls\"><label class=\"control-label\">Elemento tecnologico</label><six-lookup-2 sx-id=\"odl-schema\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" ng-model=\"opt.model\" sx-field=\"\'type_id\'\" sx-compact=\"true\" sx-item-template=\"\'{{item.description}}\'\" sx-filter=\"typeIdFilter\"></six-lookup-2></div><div class=\"col-sm-4 form-group\" ng-show=\"bool.showOpeningView\"><label class=\"control-label\">Evento</label><six-select-2 sx-id=\"calEvent\" sx-list=\"calendarEvent.list\" sx-title=\"\'Evento\'\" ng-model=\"calendarEvent.selected\" sx-multiple=\"false\" sx-item-template=\"\'{{item.key}}\'\" sx-compact=\"true\"></six-select-2></div><div class=\"col-sm-6 form-group\" ng-hide=\"bool.showImportXls || bool.showOpeningView || bool.commissionCalendar\"><label class=\"control-label\">Asset</label><six-lookup-2 sx-id=\"asset\" sx-base-path=\"\'record\'\" sx-type=\"opt.model.type_id.UUID\" ng-model=\"opt.model\" sx-field=\"\'record_id_list\'\" sx-multiple=\"true\" sx-dimension=\"\'xxl\'\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-show-tree=\"true\" sx-show-list=\"true\" sx-title=\"\'Asset\'\"></six-lookup-2></div><div class=\"col-sm-4 form-group\" ng-show=\"bool.showOpeningView\"><label class=\"control-label\"><b>Data</b></label><six-date-time-picker name=\"opening_date_picker\" ng-model=\"opt.openingDate\" enable-time=\"false\"></six-date-time-picker></div></div><div class=\"row\"><div class=\"col-sm-12 form-group\" ng-hide=\"bool.showOpeningView || bool.showImportXls\"><label class=\"checkbox i-checks m-b\"><input id=\"check-1\" type=\"checkbox\" ng-model=\"bool.commissionCalendar\"><i></i> <span class=\"i-checks\">Applica su tutta la commessa</span></label></div><div class=\"col-sm-12 form-group\" ng-show=\"bool.showOpeningView\"><div class=\"m-t btn btn-default pull-right\" ng-click=\"getAssetOpenings(searchedAssetList)\"><i class=\"fa fa-search\"></i> Cerca evento</div></div></div></div><div id=\"sigle-event-options-form\" ng-show=\"bool.showSingleEvent\"><div class=\"row\"><div class=\"col-sm-6 form-group\"><label class=\"control-label\"><b>Data inizio</b></label><six-date-time-picker name=\"start_date_picker\" ng-model=\"toSave.startDate\" enable-time=\"false\"></six-date-time-picker></div><div class=\"col-sm-6 form-group\"><label class=\"control-label\"><b>Data fine</b></label><six-date-time-picker name=\"end_date_picker\" ng-model=\"toSave.endDate\" enable-time=\"false\"></six-date-time-picker></div></div><div class=\"row\"><div class=\"col-sm-6 form-group\" ng-hide=\"toSave.endDate != undefined\"><label class=\"control-label\"><b>Tipo evento</b></label><six-select-2 sx-id=\"typeSelect\" ng-model=\"toSave\" sx-field=\"\'type\'\" sx-list=\"[{key: \'r\', description:\'Evento con durata indefinita\'}, {key: \'k\', description:\'Eredita il calendario padre\'}]\" sx-item-template=\"\'{{item.description}}\'\" sx-compact=\"true\" sx-multiple=\"false\"></six-select-2></div><div class=\"col-sm-6 form-group\" ng-hide=\"toSave.endDate != undefined\"><label class=\"control-label\"><b>Modalità di salvataggio</b></label><six-select-2 sx-id=\"savemodeSelect\" ng-model=\"savemode\" sx-list=\"[{key: \'keep\', description: \'Mantieni eventi futuri\'}, {key: \'overwrite\', description: \'Sovrascrivi eventi futuri\'}]\" sx-item-template=\"\'{{item.description}}\'\" sx-compact=\"true\" sx-multiple=\"false\"></six-select-2></div></div><div class=\"row\" ng-hide=\"toSave.type.key == \'k\'\"><div class=\"col-sm-6 form-group\"><label class=\"control-label\"><b>Stato</b></label><six-select-2 sx-id=\"statusSelect\" ng-model=\"toSave\" sx-field=\"\'status\'\" sx-list=\"[{key:\'open\', description:\'Aperto\'}, {key:\'closed\', description:\'Chiuso\'}]\" sx-item-template=\"\'{{item.description}}\'\" sx-compact=\"true\" sx-multiple=\"false\"></six-select-2></div><div class=\"col-sm-6 form-group\"><label class=\"control-label\"><b>Straordinarietà</b></label><six-select-2 sx-id=\"extraordinarySelect\" ng-model=\"toSave\" sx-field=\"\'extraordinary\'\" sx-list=\"[{key: false, description:\'Evento ordinario\'}, {key: true, description:\'Evento straordinario\'}]\" sx-item-template=\"\'{{item.description}}\'\" sx-compact=\"true\" sx-multiple=\"false\"></six-select-2></div></div><div class=\"row\" ng-hide=\"toSave.type.key == \'k\'\"><div class=\"col-sm-12 form-group\"><label class=\"control-label\" for=\"description_txtarea\"><b>Description</b></label> <textarea id=\"description_txtarea\" class=\"no-resize form-control\" ng-model=\"toSave.description\"></textarea></div></div><div class=\"row\" ng-hide=\"toSave.type.key == \'k\'\"><div class=\"col-sm-12 form-group\" ng-show=\"toSave.status.key == \'open\'\"><a class=\"btn btn-success btn-xs m-l-md\" ng-click=\"addTimeSlot()\"><i class=\"fa fa-plus\"></i> Fascia oraria</a><div ng-repeat=\"timeSlot in toSave.timeSlots\"><div class=\"col-sm-5 form-group\"><label class=\"control-label\">Dalle</label><six-date-time-picker name=\"start_time_picker\" ng-model=\"timeSlot.fromH\" enable-date=\"false\"></six-date-time-picker></div><div class=\"col-sm-5 form-group\"><label class=\"control-label\">Alle</label><six-date-time-picker name=\"end_time_picker\" ng-model=\"timeSlot.toH\" enable-date=\"false\"></six-date-time-picker></div><div class=\"col-sm-2 text-right m-t-xs\"><label class=\"control-label\"></label><a class=\"btn btn-danger form-control\" ng-click=\"removeTimeSlot(timeSlot)\"><i class=\"fa fa-trash\"></i></a></div></div></div></div></div><div id=\"import-xls-view\" ng-show=\"bool.showImportXls\"><div ui-grid=\"importGridOptions\" class=\"grid\" ui-grid-resize-columns=\"\"><div class=\"grid-msg-overlay\" ng-show=\"!importGridOptions.data.length\"><div class=\"msg\"><div class=\"center\"><span class=\"muted\">Selezionare File Excel</span><br><input type=\"file\" accept=\".xls, .xlsx, .ods\" xlsxreader=\"\" opts=\"importGridOptions\"></div></div></div></div></div><div id=\"asset-opening-view\" ng-show=\"bool.showOpeningView\"><div ng-show=\"openAssetList\"><table class=\"table table-striped\"><thead><tr><th></th><th>Codice</th><th>Descrizione</th></tr></thead><tbody><tr ng-repeat=\"asset in openAssetList track by $index\"><td><div ng-click=\"goToAssetDetail(asset)\" title=\"Vai al dettaglio asset\" class=\"btn btn-xs btn-info\"><i class=\"fa fa-pencil\"></i></div>&nbsp;&nbsp;<div ng-click=\"viewAssetCalendar(asset)\" title=\"Vedi calendario asset\" class=\"btn btn-xs btn-info\"><i class=\"fa fa-eye\"></i></div></td><td><i class=\"{{getIconClbck(asset.type)}}\"></i> - {{asset.code}}</td><td>{{asset.description}}</td></tr></tbody></table></div></div></div></div><div class=\"panel panel-default\" ng-show=\"nextEventDetail != undefined && bool.showSingleEvent\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 inline\" ng-show=\"bool.showSingleEvent\">Dettaglio evento successivo</h1>&nbsp;&nbsp;&nbsp;</div></div></div><div class=\"panel-body\"><div id=\"next-event-options-form\"><div class=\"row\"><div class=\"col-sm-6 form-group\"><label class=\"control-label\"><b>Data inizio</b></label><six-date-time-picker name=\"start_date_picker\" ng-model=\"nextEventDetail.startDate\" enable-time=\"false\" sx-disabled=\"true\"></six-date-time-picker></div><div class=\"col-sm-6 form-group\"><label class=\"control-label\" for=\"nextEvtType\"><b>Data Fine</b></label> <input id=\"nextEvtType\" class=\"form-control\" type=\"text\" ng-model=\"nextEventDetail.endDate\" ng-disabled=\"true\"></div></div><div class=\"row\" ng-hide=\"nextEventDetail.type.key == \'k\'\"><div class=\"col-sm-6 form-group\"><label class=\"control-label\" for=\"nextEvtStatus\"><b>Stato</b></label> <input id=\"nextEvtStatus\" class=\"form-control\" type=\"text\" ng-model=\"nextEventDetail.status.description\" ng-disabled=\"true\"></div><div class=\"col-sm-6 form-group\"><label class=\"control-label\" for=\"nextEvtExtraordinary\"><b>Straordinarietà</b></label> <input id=\"nextEvtExtraordinary\" class=\"form-control\" type=\"text\" ng-model=\"nextEventDetail.extraordinary.description\" ng-disabled=\"true\"></div></div><div class=\"row\" ng-hide=\"nextEventDetail.type.key == \'k\'\"><div class=\"col-sm-12 form-group\"><label class=\"control-label\" for=\"nextDescription_txtarea\"><b>Description</b></label> <textarea id=\"nextDescription_txtarea\" class=\"no-resize form-control\" ng-disabled=\"true\" ng-model=\"nextEventDetail.description\"></textarea></div></div><div class=\"row\" ng-hide=\"nextEventDetail.type.key == \'k\'\"><div class=\"col-sm-12 form-group\" ng-show=\"nextEventDetail.status.key == \'open\'\"><label class=\"control-label\" ng-show=\"nextEventDetail.timeSlots.length > 0\"><b>Fasce orarie</b></label><div ng-repeat=\"timeSlot in nextEventDetail.timeSlots track by $index\"><div class=\"col-sm-6 form-group\"><label class=\"control-label\" for=\"start_time_picker\">Dalle</label><six-date-time-picker id=\"start_time_picker\" ng-model=\"timeSlot.fromH\" enable-date=\"false\" sx-disabled=\"true\"></six-date-time-picker></div><div class=\"col-sm-6 form-group\"><label class=\"control-label\" for=\"end_time_picker\">Alle</label><six-date-time-picker id=\"end_time_picker\" ng-model=\"timeSlot.toH\" enable-date=\"false\" sx-disabled=\"true\"></six-date-time-picker></div></div></div></div></div></div></div></div>");
$templateCache.put("dataset/components/ict_drawing.html","<style>\n.ictDrawing {\n  display: block;\n  height: 500px;\n  border: 1px solid #dce4e7;\n  border-radius: 4px;\n  position: relative;\n}\n.ictDrawingCanvas {\n  width: 100%;\n  height: 100%;\n}\n.ictDrawing .controls {\n  display: none;\n  width: 120px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: rgba(255,255,255,0.8);\n}\n.ictDrawing .toolbar {\n  display: none;\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 40px;\n  background: blue;\n}\n.ictDrawing .preloader {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n</style><div class=\"ictDrawing\"><div class=\"controls\">aree di rischio<br>date chiusura<br>layer visibili</div><div class=\"ictDrawingCanvas\" id=\"ictDrawingCanvas\"><div class=\"preloader\" ng-if=\"!$ctrl.loaded\"><i class=\"fa fa-spinner fa-2x fa-pulse fa-fw text-info-dker\" aria-hidden=\"true\"></i></div></div><div class=\"toolbar\"><button class=\"btn btn-default fa fa-2x fa-info\" title=\"Identifica\"></button> <button class=\"btn btn-default fa fa-2x fa-zoom-plus\" title=\"Apri\"></button> <button class=\"btn btn-default fa fa-2x fa-map-marker\" title=\"Contrassegna\"></button></div></div>");
$templateCache.put("dataset/diff/diff.html","<style>\n  .de-emphasize {\n    opacity: 0.8;\n  }\n  .diff-highlight {\n    padding: 5px 10px 10px;\n    margin: 5px -10px 0px;\n    border: 1px solid #89b189;\n    border-radius: 4px;\n  }\n  .diff-highlight, .diff-highlight > * {\n    background-color: #f3fdf4;\n\n  }\n</style><six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" toolbar-function=\"back()\"></six-toolbar-button><six-toolbar-button label=\"Versione sinistra\" btn-class=\"btn-primary\" icon=\"fa fa-search\" toolbar-function=\"gotoLeftVersion()\"></six-toolbar-button><six-toolbar-button label=\"Versione destra\" btn-class=\"btn-primary\" icon=\"fa fa-search\" toolbar-function=\"gotoRightVersion()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"row wrapper\"><div class=\"col-md-6\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-xs-12\"><h1 class=\"m-n font-thin h4 text-black\">{{leftVersion.model.code}} - {{leftVersion.model.description}} (valido dal {{leftVersion.dataIn | date:\'d/M/yyyy H:mm:ss\'}})</h1></div></div></div><div class=\"panel-body\"><div class=\"m-t-n padder-v\"><i class=\"fa fa-sitemap\"></i> <span ng-bind-html=\"leftTree\"></span></div><div sf-schema=\"schema\" sf-form=\"form\" sf-model=\"leftVersion.model\"></div></div></div></div><div class=\"col-md-6\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-xs-12\"><h1 class=\"m-n font-thin h4 text-black\">{{rightVersion.model.code}} - {{rightVersion.model.description}} (valido dal {{rightVersion.dataIn | date:\'d/M/yyyy H:mm:ss\'}})</h1></div></div></div><div class=\"panel-body\"><div class=\"m-t-n padder-v\"><i class=\"fa fa-sitemap\"></i> <span ng-bind-html=\"rightTree\"></span></div><div sf-schema=\"schema\" sf-form=\"form\" sf-model=\"rightVersion.model\" disabled=\"true\"></div></div></div></div></div></div>");
$templateCache.put("dataset/diff/diff_list.html","<style>\n.ui-grid-row{\n  height: auto!important;\n}\n\n.ui-grid-row   > div {\n  display: table-row;\n  \n}\n\n.ui-grid-row > div .ui-grid-cell {\n  display: table-cell;\n  float: none;\n  vertical-align: middle;\n  height: auto!important;\n}\n\n.ui-grid-cell-contents{\n  white-space: normal;\n  text-overflow: inherit;\n  word-break: break-word;\n}\n</style><six-toolbar><six-toolbar-button icon=\"fa fa-plus\" label=\"Confronta selezionati\" btn-class=\"btn-info\" toolbar-function=\"diffSelected()\" sx-disabled=\"!canDiff()\" title=\"{{noDiffReason}}\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista Variazioni</h1></div></div></div><div class=\"panel-body\"><form name=\"form\" class=\"m-b-md\"><div class=\"col-md-2 form-group\"><div class=\"control-group\"><label class=\"control-label\">Periodo da</label><six-date-time-picker name=\"from\" ng-model=\"search.from\" date-options=\"dateOptionsFrom\" format=\"dateFormat\" ng-required=\"true\"></six-date-time-picker></div></div><div class=\"col-md-2 form-group\"><div class=\"control-group\"><label class=\"control-label\">Periodo a</label><six-date-time-picker name=\"to\" ng-model=\"search.to\" date-options=\"dateOptionsTo\" format=\"dateFormat\" ng-required=\"true\"></six-date-time-picker></div></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Elemento tecnologico</label><six-lookup-2 sx-id=\"schema\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" ng-model=\"search\" sx-field=\"\'type_id\'\" sx-filter=\"typeIdFilter\" sx-show-details=\"false\" sx-show-filters=\"false\" sx-on-obj-loaded=\"hidratePreselection(obj, search.type_id)\" sx-on-clear=\"clearAsset()\" sx-on-select=\"clearAsset(item)\"></six-lookup-2></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Asset</label><six-lookup-2 sx-id=\"asset\" sx-base-path=\"\'record\'\" sx-type=\"search.type_id.UUID\" ng-model=\"search\" sx-field=\"\'record_id\'\" sx-multiple=\"true\" sx-auto-init=\"true\" sx-on-obj-loaded=\"hidratePreselection(obj, search.record_id)\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div><div class=\"col-md-2 form-group\"><label class=\"control-label\">&nbsp;</label> <a class=\"form-control btn btn-primary\" ng-click=\"getVariationsList()\"><i class=\"fa fa-search\"></i> Cerca</a></div></form></div><div class=\"panel-body\"><div ui-grid=\"gridOptions\" class=\"grid\" ui-grid-resize-columns=\"\" ui-grid-selection=\"\" ui-grid-exporter=\"\"></div></div></div></div>");
$templateCache.put("dataset/drawing/drawing_detail.html","<ict-drawing drawing-uuid=\"drawingUuid\"></ict-drawing><h3>Blocchi</h3><ol><li ng-repeat=\"block in drawing.blocks\">Codice Vano: {{block.code}} - Handle Polilinea: {{block.polyline}} - Handle blocco: {{block.handle}}</li></ol><h3>Layers</h3><ol><li ng-repeat=\"layer in drawing.layers\"><span ng-style=\"{ \'font-weight\': layer.visible? \'bold\' : \'normal\' }\">Nome layer: {{layer.name}}</span></li></ol><h3>Dati completi</h3><pre>{{drawing.all}}</pre>");
$templateCache.put("dataset/drawing/drawinglist.html","<six-toolbar><six-toolbar-button icon=\"fa fa-upload\" label=\"Carica nuovo\" btn-class=\"btn-success\" toolbar-function=\"upload.show=!upload.show\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh\" label=\"Aggiorna\" btn-class=\"btn-default\" toolbar-function=\"getList()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\" ng-show=\"upload.show\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-md-12 col-sm-12 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Upload</h1><small>File accettati: DWG, DXF</small></div></div></div><div class=\"panel-body\"><div class=\"col-md-12\"><div class=\"col-md-6\"><h4>Seleziona file</h4><div><input type=\"file\" nv-file-select=\"\" uploader=\"uploader\"></div></div><div class=\"col-md-6\"><h4>Oppure</h4><div ng-show=\"uploader.isHTML5\"><div nv-file-drop=\"\" class=\"well my-drop-zone\" nv-file-over=\"\" uploader=\"uploader\">Trascina qui</div></div></div></div><div class=\"col-md-12\"><span class=\"file-info\"><strong>File selezionato:</strong> {{upload.lastfile || \'--\'}}</span> <span ng-if=\"upload.lastfile\" ng-click=\"resetUploadStatus(true)\" class=\"btn btn-xs btn-danger\"><i class=\"fa fa-trash\"></i> cancella</span> <button ng-disabled=\"!upload.readyToSend\" class=\"btn btn-sm btn-success pull-right\" ng-click=\"doUpload()\"><i class=\"fa fa-check\"></i>Conferma</button></div></div></div><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-md-12 col-sm-12 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista Planimetrie</h1><small>Gestione planimetrie</small></div></div></div><div class=\"panel-body\"><six-grid-pagination get-data-callback=\"getList()\" get-list-callback=\"getList()\" items-list=\"rows\" column-defs=\"viewGridOptions.columnDefs\" grid-app-callbacks=\"gridAppCallbacks\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div></div>");
$templateCache.put("dataset/export/export.html","<six-toolbar><six-toolbar-item label=\"Commessa ({{getCommissionFilterLabel()}})\" icon=\"fa fa-money icon text-success-dker\"><li><a ng-click=\"setCommissionFilter(\'current\')\"><i class=\"fa fa-{{(commissionFilter == \'current\')?\'check-\':\'\'}}square-o\"></i> Corrente ({{currentCommission.code}})</a></li><li><a ng-click=\"setCommissionFilter(\'open\')\"><i class=\"fa fa-{{(commissionFilter == \'open\')?\'check-\':\'\'}}square-o\"></i> Aperte</a></li><li><a ng-click=\"setCommissionFilter(\'all\')\"><i class=\"fa fa-{{(commissionFilter == \'all\')?\'check-\':\'\'}}square-o\"></i> Tutte</a></li></six-toolbar-item><six-toolbar-button label=\"Esporta Excel\" icon=\"fa fa-file-excel-o\" btn-class=\"btn-success\" ng-if=\"isEntitySelected\" toolbar-function=\"exportXLSX()\"></six-toolbar-button></six-toolbar><div class=\"constructor\"><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Esportazione dati</h1><small class=\"text-muted\">Esportazione dati anagrafici</small></div></div></div><div class=\"form-validation panel-body font-bold\"><div class=\"row\"><div class=\"col-lg-3 col-md-6 col-sm-6\"><label>Modello:</label><six-lookup-2 id=\"schema\" sx-base-path=\"\'schema\'\" ng-model=\"entity\" sx-field=\"\'type\'\" sx-item-template=\"\'{{item.description}}\'\" sx-compact=\"true\" sx-page-size=\"10000\"></six-lookup-2></div><div class=\"form-group col-lg-9 col-md-6 col-sm-6 m-t-xs\"><label class=\"radio i-checks m-b m-r-xl inline\"><input id=\"normal_export\" type=\"radio\" ng-model=\"typeExport\" value=\"export\"> <i></i> Esportazione normale</label> <label class=\"radio i-checks m-b m-r-xl inline\"><input id=\"import_export\" type=\"radio\" ng-model=\"typeExport\" value=\"exportToImport\"> <i></i> Esportazione per reimportazione</label> <label class=\"radio i-checks m-b inline\" ng-show=\"operation.ALL || operation.EXPORT_VERSION\" ng-click=\"setVersionColumn()\"><input id=\"import_export_versioned\" type=\"radio\" ng-model=\"typeExport\" value=\"exportToImportVersioned\"> <i></i> Esportazione per reimportazione versionata</label></div></div><div class=\"row\"><div class=\"form-group col-lg-5 col-md-6 col-sm-6\"><label>Altre colonne:</label><six-select-2 sx-id=\"extraCol\" sx-list=\"extraColumnsToExport.list\" sx-title=\"\'Colonne aggiuntive\'\" ng-model=\"extraColumnsToExport\" sx-field=\"\'selected\'\" sx-multiple=\"true\" sx-clearable=\"true\" sx-compact=\"false\" sx-pinned=\"false\" sx-position=\"\'right\'\" sx-item-template=\"\'{{item.key}}\'\"></six-select-2></div><div class=\"col-lg-3 col-md-3 col-sm-6\"><label>In data:</label> <input type=\"date\" ng-model=\"date.currentDate\" class=\"form-control input-sm bg-light rounded padder\" max=\"{{typeExport == \'exportToImportVersioned\' &amp;&amp; (date.toDate | date:\'yyyy-MM-ddT23:59:59\')}}\"></div><div class=\"col-lg-3 col-md-3 col-sm-6\" ng-class=\"{\'text-muted\': typeExport != \'exportToImportVersioned\'}\"><label>Alla data:</label> <input type=\"date\" ng-model=\"date.toDate\" class=\"form-control input-sm bg-light rounded padder\" ng-disabled=\"typeExport != \'exportToImportVersioned\'\" ng-class=\"{\'no-border\': typeExport != \'exportToImportVersioned\'}\" min=\"{{date.currentDate | date:\'yyyy-MM-dd\'}}\"></div></div></div><div class=\"panel-body\" ng-if=\"isEntitySelected\"><six-grid-pagination sx-id=\"exportlist\" get-data-callback=\"getExportList()\" get-list-callback=\"getExportList()\" items-list=\"exportList\" grid-options=\"viewGridOptions\" column-defs=\"viewGridOptions.columnDefs\" params=\"params\" grid-app-callbacks=\"gridAppCallbacks\" show-global-search=\"false\"></six-grid-pagination></div></div></div></div>");
$templateCache.put("dataset/export/exportcross.html","<style type=\"text/css\">\n  six-toolbar-item .invisible-check{\n    visibility: hidden;\n  }\n</style><six-toolbar><six-toolbar-item label-condition=\"(typeExport == \'exportToImport\')\" label=\"Modo (NORMALE)\" label-disabled=\"Modo (REIMPORTAZIONE)\" icon=\"fa fa-upload icon text-info-dker\"><li><a ng-click=\"setTypeExport(\'export\')\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': (typeExport == \'exportToImport\')}\"></i> Normale</a></li><li><a ng-click=\"setTypeExport(\'exportToImport\')\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': (typeExport == \'export\')}\"></i> Reimportazione</a></li></six-toolbar-item><six-toolbar-item label=\"Commessa ({{getCommissionFilterLabel()}})\" icon=\"fa fa-money icon text-success-dker\"><li><a ng-click=\"setCommissionFilter(\'current\')\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': commissionFilter != \'current\'}\"></i> Corrente ({{currentCommission.code}})</a></li><li><a ng-click=\"setCommissionFilter(\'open\')\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': commissionFilter != \'open\'}\"></i> Aperte</a></li><li><a ng-click=\"setCommissionFilter(\'all\')\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': commissionFilter != \'all\'}\"></i> Tutte</a></li></six-toolbar-item><six-toolbar-button label=\"Esporta Excel\" icon=\"fa fa-file-excel-o\" btn-class=\"btn-success\" ng-if=\"isEntitySelected\" toolbar-function=\"exportXLSX()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Esportazione dati cross</h1><small class=\"text-muted\">Esportazione dati anagrafici cross-commessa</small></div></div></div><div class=\"panel-body font-bold\"><six-lookup-2 id=\"schema\" sx-base-path=\"\'schema\'\" ng-model=\"entity\" sx-field=\"\'type\'\" sx-item-template=\"\'{{item.description}}\'\" sx-compact=\"true\" sx-page-size=\"10000\"></six-lookup-2></div><div class=\"panel-body\" ng-if=\"isEntitySelected\"><six-grid-pagination sx-id=\"exportlist\" get-data-callback=\"getExportList()\" get-list-callback=\"getExportList()\" items-list=\"exportList\" grid-options=\"viewGridOptions\" column-defs=\"viewGridOptions.columnDefs\" grid-app-callbacks=\"gridAppCallbacks\" params=\"params\" show-global-search=\"false\"></six-grid-pagination></div></div></div>");
$templateCache.put("dataset/formula/formula_detail.html","<style type=\"text/css\">\n  /* Modifiche per l\'impaginazione */\n  #formula-view .content-table{\n    border: 10px solid rgba(211, 211, 211, 0.38);\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n\n  #formula-view .content-acemodel {\n    height: 300px;\n  }\n\n  #formula-view .no-margin-bottom{\n    margin-bottom: 0px;\n  }\n\n  #formula-view .no-margin-top{\n    margin-top: 0px;\n  }\n</style><six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"saveForm()\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" ng-confirm-message=\"Sei sicuro?\" ng-confirm-click=\"delete(type.selected.version)\" ng-confirm-condition=\"true\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\" id=\"formula-view\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">DETTAGLIO FORMULA</h1></div></div></div><div class=\"panel-body\"><div class=\"col-md-12\"><div class=\"row wrapper\"><label class=\"col-md-2 control-label\">Codice:</label> <input id=\"code\" type=\"text\" class=\"col-md-10\" ng-model=\"model.code\" value=\"model.code\"></div><div class=\"row wrapper\"><label class=\"col-md-2 control-label\">Descrizione:</label> <input id=\"description\" type=\"text\" class=\"col-md-10\" ng-model=\"model.description\" value=\"model.description\"></div><div class=\"row wrapper margin-bottom\"><label class=\"col-md-2 control-label\">Formula:</label><div class=\"col-md-7 content-acemodel no-margin-top\" rows=\"4\" ui-ace=\"{ useWrapMode : true, showGutter: true, mode: \'javascript\', firstLineNumber: 1, }\" ng-model=\"model.formula\"></div><div class=\"col-md-3 content-table\"><table class=\"table table-striped no-margin-bottom\"><thead></thead><tbody ng-repeat=\"(key, value) in arrayFunction\"><tr><td><a href=\"\" ng-click=\"arrayFunction[key].check = !arrayFunction[key].check\" id=\"item\"><i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': arrayFunction[key].check, \'glyphicon-chevron-right\': !arrayFunction[key].check}\"></i></a></td><td>{{value.key}}</td></tr><tr ng-show=\"arrayFunction[key].check == true\" class=\"background-color\"><td></td><td>{{value.description}}</td></tr></tbody></table></div></div><div class=\"row wrapper\"><label class=\"col-md-2 control-label\">Valori:</label> <input id=\"params\" name=\"params\" type=\"text\" class=\"col-md-8\" ng-model=\"params\" value=\"params\" placeholder=\"es: 31, 2, 4.56, 7.45\"> <button class=\"btn btn-success btn-sm center col-md-offset-1\" ng-click=\"calculate(params)\"><span class=\"fa fa-youtube-play\"></span> Calcola</button></div><div class=\"row wrapper\"><label class=\"col-md-2 control-label\">Risultato:</label> <input id=\"output\" type=\"text\" class=\"col-md-8\" ng-model=\"output\" value=\"output\"></div></div></div></div></div>");
$templateCache.put("dataset/formula/formula_list.html","<six-toolbar><six-toolbar-button label=\"Nuovo\" icon=\"fa fa-plus\" toolbar-function=\"newFormula()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"getListWrapper()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista Formule</h1></div></div></div><div class=\"panel-body\"><div class=\"form-group\"><input ng-keyup=\"getListWrapper()\" class=\"form-control\" type=\"text\" ng-model=\"queryParam\" placeholder=\"Scrivere qui per filtrare la lista...\"></div><table id=\"modeltype_list\" class=\"table table-striped\"><thead><tr><th class=\"col-md-2\"></th><th class=\"col-md-2\">CODICE</th><th class=\"col-md-2\">DESCRIZIONE</th></tr></thead><tbody><tr ng-repeat=\"item in listWrapper.list\"><td><a ng-href=\"#/formula/{{item.code}}\" class=\"btn btn-default btn-sm\" id=\"btn_model_detail\"><span class=\"fa fa-pencil\"></span></a></td><td>{{item.code}}</td><td>{{item.description}}</td></tr><tr ng-hide=\"listWrapper.list.length\"><td colspan=\"10\"><p class=\"text-center\">Nessun risultato trovato</p></td></tr></tbody></table></div><div class=\"panel-footer\"><div class=\"row\"><div class=\"col-lg-12 text-center\"><uib-pagination ng-change=\"pageChanged()\" boundary-links=\"true\" total-items=\"listWrapper.totalResults\" ng-model=\"listWrapper.currentPage\" class=\"pagination-sm\" items-per-page=\"listWrapper.pageSize\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\" max-size=\"10\"></uib-pagination></div></div></div></div></div>");
$templateCache.put("dataset/import/import.html","<style type=\"text/css\">\n  .notice {\n    padding: 1.2em 1.5em;\n    margin: -1em;\n    border: 2px solid #23b7e5;\n    border-radius: 4px;\n    background-color: #edf1f2;\n    text-align: center;\n    font-weight: 700;\n    color: #363f44;\n  }\n  .notice > .icon {\n    position: absolute;\n    top: 10px;\n    left: 10px;\n    font-size: 1.5em;\n  }\n</style><script type=\"text/ng-template\" id=\"helpTemplate.html\"><div class=\"text-base\"> <strong><span class=\"ngdialog-icon\"></span></strong> <div style=\"text-align: center;\"><h4 class=\"m-t-none m-b font-bold\">Aiuto</h4></div> <div class=\"wrapper\"> <div style=\"text-align: center;\"><h4 class=\"m-t-none m-b font-bold\">Dati storicizzati e/o dipendenti da commessa</h4></div> <p> Nel file Excel di import è possibile specificare una <span class=\"font-bold\">commessa (commission)</span>, un <strong>cliente (customer)</strong>, ed un\'eventuale <span class=\"font-bold\">data di inizio validità (dataIn)</span>. Se tali informazioni non vengono specificate, verranno considerati i valori di default: <ul> <li>commission: la commessa con cui si è loggati</li> <li>customer: il cliente con cui si è loggati</li> <li>dataIn: data in cui si desidera importare la versione (default: data odierna)</li> </ul> La <span class=\"font-bold\">data di fine validità (dataOut)</span>, se presente, verrà ignorata. </p> <p>Esempio:</p> <table class=\"tinyTable m-t\"> <thead> <tr> <th style=\"text-transform: none;\">commission</th> <th style=\"text-transform: none;\">customer</th> <th style=\"text-transform: none;\">dataIn</th> </tr> </thead> <tbody> <tr> <td>1600000</td> <td>236</td> <td>2018-01-01</td> </tr> </tbody> </table> <div class=\"m-t-xl\" style=\"text-align: center;\"><h4 class=\"m-t-none m-b font-bold\">Dati non storicizzati</h4></div> <p> L\'eventuale <span class=\"font-bold\">data di inizio validità (dataIn)</span> specificata nel file verrà ignorata. </p> <div class=\"m-t-xl\" style=\"text-align: center;\"><h4 class=\"m-t-none m-b font-bold\">Dati cross commessa</h4></div> <p> L\'eventuale <span class=\"font-bold\">commessa (commission)</span> specificata nel file verrà ignorata. </p> <p> L\'eventuale <span class=\"font-bold\">cliente (customer)</span> specificato nel file verrà ignorato. </p> </div> <div class=\"m-t-xl\" style=\"text-align: center;\"><h4 class=\"m-t-none m-b font-bold\">Dati cross cliente</h4> <p> Per quanto riguarda il <strong>cliente (customer) </strong>, il processo di import utilizza il codice cliente (customer) inserito nella riga, o eventualmente quello in uso al momento dell\'import nel caso la riga fosse vuota. Se nessuno di questi è disponibile, il dato sarà salvato cross-customer. </p> </div> </div></script><six-toolbar><six-toolbar-item icon=\"fa fa-question text-success-dker\" label-class=\"text-success-dker\" label=\"Aiuto\" toolbar-function=\"showHelpDialog()\"></six-toolbar-item><six-toolbar-item label=\"Template\" icon=\"fa fa-download icon text-info-dker\" toolbar-function=\"schemaDefinitionToXlsx()\" ng-show=\"isEntitySelected\"></six-toolbar-item><six-toolbar-button label=\"Reset\" icon=\"fa fa-undo\" toolbar-function=\"reset()\"></six-toolbar-button><six-toolbar-button label=\"Importa\" icon=\"fa fa-upload\" toolbar-function=\"importData()\" btn-class=\"btn-success\" ng-if=\"isEntitySelected\" sx-disabled=\"!isWritePermAllowed() || errorCount > 0 || prePercent<100 || importBusy || 100 === percent\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Importazione Dati</h1><small class=\"text-muted\">Importazione dati anagrafici</small></div><a class=\"col-sm-6 col-xs-12 notice\" ng-if=\"schemaDefinition && schemaDefinition.model\" ng-click=\"showHelpDialog()\"><div class=\"icon\"><i class=\"fa fa-question text-success-dker\"></i></div><div ng-if=\"schemaDefinition.model.commissionDependent\">Dipendente da commessa</div><div ng-if=\"!schemaDefinition.model.commissionDependent\">Cross commessa</div><div ng-if=\"schemaDefinition.model.history\">Storicizzato</div><div ng-if=\"!schemaDefinition.model.history\">Non storicizzato</div></a></div></div><div class=\"panel-body row\"><div class=\"col-md-10\"><six-lookup-2 id=\"schema\" sx-base-path=\"\'schema\'\" ng-model=\"entity\" sx-item-template=\"\'{{item.description}}\'\" sx-field=\"\'type\'\" sx-compact=\"true\"></six-lookup-2></div><div class=\"col-md-2\"><label class=\"checkbox i-checks col-md-12 m-t-xs\"><input type=\"checkbox\" ng-model=\"withTree\" ng-disabled=\"!schemaDefinition.model.commissionDependent\"><i></i> <span class=\"i-checks\">Importa tree</span></label></div><div style=\"font-size: xx-small\" ng-if=\"false\">{{schemaDefinition.model.schema.properties}}</div></div><div class=\"panel-body\" ng-if=\"isEntitySelected\"><div ui-grid=\"gridOptions\" class=\"grid\" ui-grid-resize-columns=\"\"><div class=\"grid-msg-overlay\" ng-show=\"!gridOptions.data.length\"><div class=\"msg\"><div class=\"center\"><span class=\"muted\">Selezionare File Excel</span><br><input type=\"file\" accept=\".xls,.xlsx,.ods\" xlsxreader=\"\" opts=\"gridOptions\" multiple=\"false\"></div></div></div></div><div class=\"wrapper m-t\"><div class=\"text-center-folded\"><span class=\"pull-right pull-none-folded\">{{prePercent|number : 0}}%</span> <span class=\"hidden-folded ng-scope\">Verifica dati</span></div><div class=\"progress-s m-t-sm dk progress ng-isolate-scope\" value=\"{{prePercent}}\" type=\"info\"><div class=\"progress-bar progress-bar-info\" ng-class=\"type &amp;&amp; \'progress-bar-\' + type\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: prePercent + \'%\'}\" aria-valuetext=\"0%\" style=\"width: {{prePercent|number : 0}}%;\"></div></div><div class=\"text-center-folded\"><span class=\"pull-right pull-none-folded\">{{percent|number : 0}}%</span> <span class=\"hidden-folded ng-scope\">Importazione</span></div><div class=\"progress-s m-t-sm dk progress ng-isolate-scope\" value=\"{{percent}}\" type=\"info\"><div class=\"progress-bar progress-bar-info\" ng-class=\"type &amp;&amp; \'progress-bar-\' + type\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: percent + \'%\'}\" aria-valuetext=\"0%\" style=\"width: {{percent|number : 0}}%;\"></div></div></div><div id=\"messages\" class=\"wrapper m-t\" ng-if=\"reportMessages.length\"><div class=\"panel-group\" id=\"accordion\"><div class=\"panel panel-default\" id=\"panel1\"><div class=\"panel-heading\"><h4 class=\"panel-title\">Messaggi</h4></div><div class=\"panel-body\"><div class=\"col-md-12\"><div id=\"gridReport\" ui-grid=\"reportGridOptions\" class=\"grid\" style=\"height: 420px\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\"></div></div></div></div></div></div></div></div></div>");
$templateCache.put("dataset/mailrecord/mailrecord_list.html","<div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista notifiche</h1></div></div></div><div class=\"panel-body\"><six-grid-pagination get-data-callback=\"getList()\" items-list=\"notificationList\" grid-options=\"viewgridOpt\" params=\"params\"></six-grid-pagination></div></div></div><six-sidebar sx-id=\"notificationDetailView\" sx-position=\"right\" sx-title=\"\'Dettaglio\'\" sx-dimension=\"50\" six-sidebar-autoclose=\"true\" sx-opened=\"notificationPanelOpen\" sx-pinnable=\"false\"><div class=\"wrapper b-b\"><h2 class=\"font-thin m-n ng-binding\">{{selectedNotification.model.subject}}</h2></div><div class=\"wrapper b-b ng-binding\"><img ng-hide=\"selectedNotification.user\" class=\"img-circle thumb-xs m-r-sm\" ng-src=\"/images/avatar_system.png\"> <img ng-show=\"selectedNotification.user\" class=\"img-circle thumb-xs m-r-sm\" ng-src=\"/images/avatar_emil.png\"> Segnalazione inviata da <strong ng-hide=\"selectedNotification.user\">System</strong><strong>{{selectedNotification.user}}</strong> relativa a <strong ng-show=\"!selectedNotification.model.type_notification\">/</strong> <strong ng-show=\"selectedNotification.model.type_notification\">{{selectedNotification.model.type_notification}}</strong> e con destinatari: <strong ng-show=\"!selectedNotification.model.to\">/</strong> <strong ng-show=\"selectedNotification.model.to\">{{selectedNotification.model.to}}</strong> del {{selectedNotification.dataIn | date:\"dd/MM/yyyy\"}}</div><div class=\"wrapper ng-binding\" ng-bind-html=\"selectedNotification.model.body\"></div></six-sidebar>");
$templateCache.put("dataset/modeltype/detail_array.html","<div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">FORMATO:</div><div class=\"col-md-2\">{{value.items.type}}</div><div ng-if=\"value.items.type == \'lookup\'\"><div class=\"col-md-2\">INDICE:</div><div class=\"col-md-2\"><select class=\"col-md-12\" ng-model=\"value.basePath\" ng-change=\"refreshBasePath(key, value.basePath)\"><option value=\"record\">Anagrafica</option><option value=\"pricelsit\">Listino</option></select></div><div class=\"col-md-2\">TIPO:</div><div class=\"col-md-2\"><select class=\"col-md-12\" ng-model=\"value.entity_id\" ng-change=\"refreshLookup(key, value.entity_id)\"><option ng-repeat=\"entity in modeltypeList\" ng-value=\"entity.model.code\" ng-selected=\"entity.model.code === value.entity_id\">{{entity.model.description}}</option></select></div></div></div><div class=\"col-md-12\"><div class=\"col-md-2\" ng-if=\"value.items.format != \'date\'\">VALORI DEFINITI:</div><div class=\"col-md-10 pnl-margin-l-r\" ng-if=\"value.items.type != \'lookup\'\"><div ng-if=\"value.items.format != \'date\'\"><input type=\"{{itemTypeMap[key]}}\" size=\"46\" ng-model=\"newItem.name\"> <button ng-click=\"addItemOnArray(key, newItem)\" class=\"btn btn-success btn-xs btn-default equal-margin-left-right\"><i class=\"fa fa-plus\"></i></button></div></div><div class=\"col-md-10 col-md-offset-2 pnl-margin-l-r\" ng-if=\"value.items.type != \'lookup\'\"><div class=\"col-md-12 no-pad-l-r pnl-margin-l-r\" ng-repeat=\"itemArray in uiselectMap[key] track by $index\" ng-if=\"itemArray.name != \'\'\"><input type=\"text\" size=\"46\" name=\"item_name\" ng-model=\"itemArray.name\" disabled=\"\"> <button ng-click=\"deleteItemOnArray(key,itemArray)\" class=\"btn btn-danger btn-xs btn-default equal-margin-left-right\"><i class=\"fa fa-minus\"></i></button></div></div><div class=\"col-md-10 pnl-margin-l-r\" ng-if=\"value.items.type == \'lookup\'\"><div class=\"col-md-3 col-md-3-adapted no-pad-l-r\"><six-lookup ng-model=\"newItemArray\" sx-type=\"value.entity_id\" sx-field=\"\'record_id\'\"></six-lookup></div><button ng-click=\"addRefOnArray(key, newItemArray)\" class=\"btn btn-success btn-xs btn-default equal-margin-left-right\"><i class=\"fa fa-plus\"></i></button></div><div class=\"col-md-10 col-md-offset-2 pnl-margin-l-r\" ng-if=\"value.items.type == \'lookup\'\"><div class=\"col-md-12 no-pad-l-r pnl-margin-l-r\" ng-repeat=\"itemArray in uiselectMap[key] track by $index\" ng-if=\"itemArray.name != \'\'\"><input type=\"text\" size=\"46\" name=\"item_name\" ng-model=\"itemArray.name\" disabled=\"\"> <button ng-click=\"deleteItemOnArray(key,itemArray)\" class=\"btn btn-danger btn-xs btn-default equal-margin-left-right\"><i class=\"fa fa-minus\"></i></button></div></div></div>");
$templateCache.put("dataset/modeltype/detail_constraints.html","<div class=\"col-md-12 uniform-height-2\" ng-if=\"value.format === \'date\'\"><div class=\"col-md-2\">VINCOLA CAMPI:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.enableConstraints\" ng-change=\"refreshContraintsCheckbox(key, value.enableConstraints)\"></div></div><div class=\"col-md-12\" ng-if=\"value.enableConstraints == true\"><div class=\"col-md-2 uniform-height-2\">STEP DESTINAZIONE:</div><div class=\"col-md-10 uniform-height-2\"><select ng-model=\"newItem.step\" ng-options=\"step.model.description for step in stepList track by step.UUID\"></select></div><div class=\"col-md-2 uniform-height-2\">CODICE CAMPO:</div><div class=\"col-md-10 uniform-height-2\"><input type=\"{{itemTypeMap[key]}}\" size=\"45\" name=\"new_item_name\" ng-model=\"newItem.name\"></div><div class=\"col-md-2 uniform-height-2\">VINCOLO:</div><div class=\"col-md-10 uniform-height-2\"><select ng-model=\"newItem.relation\"><option value=\">\">></option><option value=\"<\"><</option></select><button ng-click=\"addConstraint(key, newItem)\" class=\"btn btn-xs btn-info equal-margin-left-right\"><span class=\"fa fa-plus\"></span> Add</button></div><div class=\"col-md-10 col-md-offset-2\"><div class=\"col-md-12 override-padding-no-pad-left-right uniform-height-2\" ng-repeat=\"itemArray in value.constraints track by $index\" ng-if=\"itemArray != \'\'\"><input style=\"width: 50%\" type=\"text\" size=\"45\" name=\"item_name\" ng-value=\"itemArray.step.description +\' : \' + itemArray.step.fieldToCheck + \' \'+ itemArray.relation + \' \' + value.title\" disabled=\"\"> <button ng-click=\"deleteConstraint(key, $index)\" class=\"btn btn-danger btn-xs btn-default equal-margin-left-right\"><i class=\"fa fa-trash\"></i></button></div></div></div>");
$templateCache.put("dataset/modeltype/detail_date.html","<div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">FORMATO:</div><div class=\"col-md-10\">{{value.format}}</div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">PROPAGA VALORE:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.enableCopyTo\" ng-change=\"refreshCopyToCheckbox(key, value.enableCopyTo)\"></div></div><div class=\"col-md-12\" ng-if=\"value.enableCopyTo == true\"><div class=\"col-md-2 uniform-height-2\">CAMPI DI DESTINAZIONE:</div><div class=\"col-md-10 uniform-height-2\"><input type=\"{{itemTypeMap[key]}}\" size=\"45\" name=\"new_item_name\" ng-model=\"newItem.name\"> <button ng-click=\"addItemCopyTo(key, newItem)\" class=\"btn btn-xs btn-info equal-margin-left-right\"><span class=\"fa fa-plus\"></span> Add</button></div><div class=\"col-md-10 col-md-offset-2\"><div class=\"col-md-12 override-padding-no-pad-left-right uniform-height-2\" ng-repeat=\"itemArray in value.copyTo track by $index\" ng-if=\"itemArray != \'\'\"><input type=\"text\" size=\"45\" name=\"item_name\" ng-model=\"itemArray\" disabled=\"\"> <button ng-click=\"deleteItemCopyTo(key,itemArray)\" class=\"btn btn-danger btn-xs btn-default equal-margin-left-right\"><i class=\"fa fa-trash\"></i></button></div></div></div>");
$templateCache.put("dataset/modeltype/detail_enum.html","<div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">FORMATO:</div><div class=\"col-md-10\">{{value.format}}</div></div><div class=\"col-md-12\"><div class=\"col-md-2 uniform-height-2\">VALORI DEFINITI:</div><div class=\"col-md-10 uniform-height-2 pnl-margin-l-r\"><input type=\"{{itemTypeMap[key]}}\" size=\"45\" name=\"new_item_name\" ng-model=\"newItem.name\"> <button ng-click=\"addItemOnArray(key, newItem)\" class=\"btn btn-xs btn-success equal-margin-left-right\"><i class=\"fa fa-plus\"></i></button></div><div class=\"col-md-10 col-md-offset-2\"><div class=\"col-md-12 no-pad-l-r uniform-height-2 pnl-margin-l-r\" ng-repeat=\"itemArray in uiselectMap[key] track by $index\" ng-if=\"itemArray.name != \'\'\"><input type=\"text\" size=\"45\" name=\"item_name\" ng-model=\"itemArray.name\" disabled=\"\"> <button ng-click=\"deleteItemOnArray(key,itemArray)\" class=\"btn btn-danger btn-xs btn-default equal-margin-left-right\"><i class=\"fa fa-minus\"></i></button> <label><input type=\"checkbox\" name=\"item_selected\" ng-checked=\"value.default.indexOf(itemArray.value) > -1\" ng-click=\"toggleEnumDefault(key,itemArray.value)\"> Predefinito</label></div></div></div>");
$templateCache.put("dataset/modeltype/detail_formula.html","<div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">FORMULA:</div><div class=\"col-md-2\"><select class=\"col-md-12\" ng-model=\"value.formula_id\" ng-change=\"refreshFormula(key, value.formula_id)\"><option ng-repeat=\"formula in formulaList\" ng-value=\"formula.code\" ng-selected=\"value.formula_id === formula.code\">{{formula.description}}</option></select></div><div class=\"col-md-2\">PARAEMTRI FORMULA:</div><div class=\"col-md-6\"><input class=\"override-full-width\" type=\"text\" ng-model=\"value.formula_params\" placeholder=\"esempio: potere_calorifico_sup\" ng-keyup=\"refreshFormulaParams(key, value.formula_params)\"></div></div>");
$templateCache.put("dataset/modeltype/detail_inherit.html","<div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">FORMATO:</div><div class=\"col-md-2\">Campo Ereditato</div><div class=\"col-md-2\">CAMPO RIF. PADRE:</div><div class=\"col-md-2\"><input class=\"override-full-width\" type=\"text\" placeholder=\"esempio: model.remi...\" ng-model=\"value.record\" ng-change=\"refreshInheritRecord(key, value.record)\"></div><div class=\"col-md-2\">ATTRIBUTO DA EREDITARE:</div><div class=\"col-md-2\"><input class=\"override-full-width\" type=\"text\" placeholder=\"esempio: model.potere_calorifico_sup...\" ng-model=\"value.field\" ng-change=\"refreshInheritField(key, value.field)\"></div></div>");
$templateCache.put("dataset/modeltype/detail_lookup.html","<div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">FORMATO:</div><div class=\"col-md-2\">{{value.format}}</div><div class=\"col-md-2\">INDICE:</div><div class=\"col-md-2\"><select class=\"col-md-12\" ng-model=\"value.war\" ng-change=\"refreshWar(key, value.war)\"><option value=\"six-data-set\">Anagrafica</option><option value=\"six-energy\">Energy</option><option value=\"six-plan\">Plan</option></select></div><div class=\"col-md-2\">TIPO:</div><div class=\"col-md-2\" ng-hide=\"(value.war==\'six-energy\') || (value.war==\'six-plan\')\"><select class=\"col-md-12\" ng-model=\"value.entity_id\" ng-change=\"refreshLookup(key, value.entity_id)\"><option ng-repeat=\"entity in modeltypeList\" ng-value=\"entity.model.code\" ng-selected=\"entity.model.code === value.entity_id\">{{entity.model.description}}</option></select></div><div class=\"col-md-2\" ng-show=\"(value.war==\'six-energy\') || (value.war==\'six-plan\')\"><input class=\"override-full-width\" type=\"text\" placeholder=\"esempio: activity\" ng-model=\"value.entity_id\" ng-keyup=\"refreshLookup(key, value.entity_id)\"></div></div><div class=\"col-md-12 bd-callout\"><div class=\"header-sm\">LOOKUP CONDIZIONATA <label class=\"m-l-lg\"><input type=\"checkbox\" ng-init=\"reverseLookup = !!value.reverseFilterField\" ng-click=\"updateReverseLookup(key, reverseLookup)\" ng-model=\"reverseLookup\"> Modalità invertita (Sola visualizzazione)</label></div><div class=\"row\"><div class=\"col-md-2\" ng-if=\"reverseLookup\">CAMPO DI RICERCA:</div><div class=\"col-md-10\" ng-if=\"reverseLookup\"><input class=\"override-full-width\" type=\"text\" placeholder=\"esempio: model.regione_id.UUID...\" ng-model=\"value.reverseFilterField\" ng-keyup=\"refreshReverseFilterField(key, value.reverseFilterField)\"><div class=\"row col-md-12\">Es.: <span class=\"font-italic\">model.regione_id.UUID</span> è il campo su cui verrà cercato l\'UUID del dato corrente</div></div><div class=\"col-md-2\">VALORE SORGENTE:</div><div class=\"col-md-4\"><input class=\"override-full-width\" type=\"text\" placeholder=\"esempio: regione_id...\" ng-model=\"value.filterSourceField\" ng-keyup=\"refreshFilterSourceField(key, value.filterSourceField)\"><div class=\"row col-md-12\">Es.: attributo <span class=\"font-italic\">regione_id</span> di questo modello</div></div><div class=\"col-md-2\">CHIAVE MODELLO DEST.:</div><div class=\"col-md-4\"><input class=\"override-full-width\" type=\"text\" placeholder=\"esempio: model.regione_id...\" ng-model=\"value.filterDestField\" ng-keyup=\"refreshFilterDestField(key, value.filterDestField)\"><div class=\"row col-md-12\">Es.: attributo <span class=\"font-italic\">regione_id</span> del modello <span class=\"font-italic\">provincia</span></div></div><div class=\"col-md-2\">TEMPLATE VISUALIZZAZIONE:</div><div class=\"col-md-4\"><input class=\"override-full-width\" type=\"text\" placeholder=\"{{\'esempio: {\' + \'{item.description}\' + \'}\'}}\" ng-model=\"value.item_template\" ng-keyup=\"refreshLookupOption(key, \'item_template\', value.item_template)\"><div class=\"row col-md-12\">Es.: attributo <span class=\"font-italic\">description</span> del modello collegato</div></div><div class=\"col-md-2\">PLACEHOLDER:</div><div class=\"col-md-4\"><input class=\"override-full-width\" type=\"text\" ng-model=\"value.placeholder\" ng-keyup=\"refreshLookupOption(key, \'placeholder\', value.placeholder)\"></div><div class=\"row col-md-12\"><div class=\"col-md-2\">OPZIONI ESTESE:</div><div class=\"col-md-10\"><label><input type=\"checkbox\" ng-model=\"value.compact\" ng-click=\"refreshLookupOption(key, \'compact\', value.compact)\" ng-disabled=\"reverseLookup\"> Modalità compatta</label></div><div class=\"col-md-10 col-md-offset-2\"><label><input type=\"checkbox\" ng-model=\"value.history\" ng-click=\"refreshLookupOption(key, \'history\', value.history)\"> Includi dati storicizzati</label></div><div class=\"col-md-10 col-md-offset-2\"><label><input type=\"checkbox\" ng-model=\"value.multiple\" ng-click=\"refreshLookupOption(key, \'multiple\', value.multiple)\"> Abilita selezione multipla</label></div><div class=\"col-md-10 col-md-offset-2\"><label><input type=\"checkbox\" ng-model=\"value.auto_init\" ng-click=\"refreshLookupOption(key, \'auto_init\', value.auto_init)\" ng-disabled=\"reverseLookup\"> Abilita inizializzazione automatica</label></div><div class=\"col-md-10 col-md-offset-2\" ng-hide=\"value.compact\"><label><input type=\"checkbox\" ng-model=\"value.show_filters\" ng-click=\"refreshLookupOption(key, \'show_filters\', value.show_filters)\"> Abilita filtri</label></div><div class=\"col-md-10 col-md-offset-2\" ng-hide=\"value.compact\"><label><input type=\"checkbox\" ng-model=\"value.show_details\" ng-click=\"refreshLookupOption(key, \'show_details\', value.show_details)\"> Abilita visualizzazione dettagli</label></div><div class=\"col-md-10 col-md-offset-2\" ng-hide=\"value.compact\"><label><input type=\"checkbox\" ng-model=\"value.addable\" ng-click=\"refreshLookupOption(key, \'addable\', value.addable)\"> Abilita inserimento rapido</label></div><div class=\"col-md-10 col-md-offset-2\" ng-hide=\"value.compact\"><label><input type=\"checkbox\" ng-model=\"value.showLinkToDetail\" ng-click=\"refreshLookupOption(key, \'showLinkToDetail\', value.showLinkToDetail)\"> Abilita link al dettaglio</label></div><div class=\"col-md-10 col-md-offset-2\"><label><input type=\"checkbox\" ng-model=\"value.readonly\" ng-click=\"refreshLookupOption(key, \'readonly\', value.readonly)\" ng-disabled=\"reverseLookup\"> Sola lettura</label></div></div></div></div>");
$templateCache.put("dataset/modeltype/modeltype_detail.html","<style type=\"text/css\">\n  .override-checkbox-i {\n    margin-left: inherit !important;\n  }\n\n  #timelineRow {\n    height:26px;\n    line-height:26px;\n  }\n  .floating-btn {\n    z-index: 9999999;\n    right: 0;\n    top: 150px;\n    bottom: auto;\n    padding: 0;\n    margin: 0;\n    opacity: 0.5;\n  }\n  .floating-btn a {\n    color: #58666e;\n    background-color: #23b7e5;\n    border-radius: 10px 0px 0px 10px;\n  }\n  .floating-btn.active {\n    visibility: hidden;\n  }\n  .floating-btn .mfb-component__button--main {\n    width: 26px;\n  }\n  .floating-btn:hover {\n    opacity: 1;\n  }\n  .glyphicon-ok{\n    visibility: hidden;\n  }\n  .hr-info {\n    margin: 20px 0 10px 0;\n    border-top: 1px solid #fad733\n  }\n\n  #record-tabset .nav-tabs {\n    border: medium none;\n    background: #333;\n  }\n\n  .month-container {\n    height: 230px !important;\n  }\n\n  .calendar {\n    overflow: unset;\n  }\n</style><script type=\"text/ng-template\" id=\"deleteTemplate.html\"><strong><span class=\"ngdialog-icon\"></span></strong> <div style=\"text-align: center;\"><h4 class=\"m-t-none m-b font-bold\">ATTENZIONE</h4></div> <table align=\"center\" style=\"text-align: left; width: 100%\"> <caption style=\"text-align: center; font-weight: bold\" ng-if=\"lang!=\'html\'\">{{deleteMessage}}</caption> <caption style=\"text-align: center; font-weight: bold\" ng-if=\"lang==\'html\'\" ng-bind-html=\"deleteMessage\"></caption> <tr> <td style=\"text-align: center;\"> <button type=\"button\" class=\"btn btn-default\" ng-click=\"deleteFunction()\">Si</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"notDeleteFunction()\">No</button> </td> </tr> </table></script><six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"saveForm(true)\" sx-disabled=\"isDataChanged(aceModel)==false\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" ng-click=\"delete()\"></six-toolbar-button></six-toolbar><nav class=\"floating-btn\" ng-class=\"{\'active\': timelineFlags.showTimeline}\" mfb-menu=\"\" position=\"br\" effect=\"zoomin\" label=\"Timeline\" active-icon=\"fa {{timelineFlags.showTimeline?\'fa-chevron-right\':\'fa-chevron-left\'}}\" resting-icon=\"fa fa-history\" toggling-method=\"hover\" ng-click=\"timelineFlags.showTimeline=!timelineFlags.showTimeline\"></nav><six-sidebar sx-id=\"timeline_sidebar\" sx-position=\"right\" sx-title=\"\'Timeline\'\" sx-dimension=\"xxl\" sx-opened=\"timelineFlags.showTimeline\" sx-pinned=\"true\"><six-timeline options=\"{datePickerEnabled: false}\" history-perm=\"isWriteVersionAllowed()\" ext-selected=\"type.selected\" get-timeline=\"refreshTimeline()\" on-fix-timeline=\"fixTimeline()\" on-check-timeline=\"checkTimeline()\" on-select=\"onSelectVersion(value, event)\" on-save=\"onSaveVersion(value)\" on-delete=\"onDeleteVersion(value)\"></six-timeline></six-sidebar><div class=\"constructor\"><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\" ng-show=\"type.selected.model.code\"><h1 class=\"m-n font-thin h3 text-black\">{{type.selected.model.description}}</h1><small class=\"text-muted\">{{type.selected.model.code}}</small></div><div class=\"col-sm-6 col-xs-12\" ng-hide=\"type.selected.model.code\"><h1 class=\"m-n font-thin h3 text-black\">Modelli</h1><small class=\"text-muted\">Nuovo modello</small></div></div></div><div class=\"panel wrapper\"><div class=\"panel-heading\"><div class=\"page-header-bleed-right\"><div class=\"actions\"><div class=\"row\" ng-if=\"isWriteVersionAllowed()\"><div class=\"col-sm-6 col-md-3\"><label>UUID:</label> <input type=\"text\" class=\"form-control\" ng-model=\"type.selected.UUID\"></div><div class=\"col-sm-6 col-md-3\"><label>Version:</label> <input type=\"text\" class=\"form-control\" ng-model=\"type.selected.version\" readonly=\"\"></div><div class=\"col-sm-6 col-md-3\"><label>Inizio validità:</label><six-date-time-picker name=\"dataIn\" format=\"\'dd/MM/yyyy HH:mm:ss\'\" ng-model=\"type.selected.dataIn\"></six-date-time-picker></div><div class=\"col-sm-6 col-md-3\"><label>Fine validità:</label><six-date-time-picker name=\"dataOut\" format=\"\'dd/MM/yyyy HH:mm:ss\'\" ng-model=\"type.selected.dataOut\"></six-date-time-picker></div></div><div class=\"row\"><form name=\"header\"><div class=\"form-group\"><label id=\"schema_id_key\" for=\"code\" class=\"col-md-1 control-label\">Tipo</label><div class=\"col-md-12\"><input type=\"text\" class=\"form-control\" id=\"code\" placeholder=\"\" ng-model=\"code\" name=\"code\" required=\"\" readonly=\"\"><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"header.code.$error.required\">Obbligatorio</span></div></div></div><div class=\"form-group\"><label id=\"schema_desc_key\" for=\"description\" class=\"col-md-1 control-label\">Descrizione</label><div class=\"col-md-12\"><input type=\"text\" class=\"form-control\" id=\"description\" placeholder=\"\" ng-model=\"description\" name=\"description\" ng-keyup=\"refreshDescription(description)\" required=\"\"><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"header.description.$error.required\">Obbligatorio</span></div></div></div><div class=\"m-t col-md-12\"><label class=\"checkbox-inline i-checks override-checkbox-i m-b col-md-4\"><input id=\"commissionDependent\" type=\"checkbox\" ng-model=\"commissionDependent\"><i></i> <span class=\"i-checks\">Dipendente da commessa</span></label> <label class=\"checkbox-inline i-checks override-checkbox-i m-b col-md-4\" ng-if=\"app.profileCustomer\"><input id=\"customerDependent\" type=\"checkbox\" ng-model=\"customerDependent\"><i></i> <span class=\"i-checks\">Dipendente da cliente</span></label> <label class=\"checkbox-inline i-checks override-checkbox-i m-b col-md-4\"><input id=\"history\" type=\"checkbox\" ng-model=\"history\" ng-disabled=\"commissionDependent === true || priceListManagement === true\"><i></i> <span class=\"i-checks\">Storicizzato</span></label> <label class=\"checkbox-inline i-checks override-checkbox-i m-b col-md-4\"><input id=\"attachmentManagement\" type=\"checkbox\" ng-model=\"attachmentManagement\" ng-disabled=\"priceListManagement === true\"><i></i> <span class=\"i-checks\">Gestione allegati</span></label> <label class=\"checkbox-inline i-checks override-checkbox-i m-b col-md-4\"><input id=\"calendarManagement\" type=\"checkbox\" ng-model=\"calendarManagement\"><i></i> <span class=\"i-checks\">Gestione calendario</span></label> <label class=\"checkbox-inline i-checks override-checkbox-i m-b col-md-4\"><input id=\"selfGeneratedCode\" type=\"checkbox\" ng-model=\"selfGeneratedCode.active\"><i></i> <span class=\"i-checks\">Codice auto-generato</span></label> <label class=\"checkbox-inline i-checks override-checkbox-i m-b col-md-2\"><input id=\"priceListManagement\" type=\"checkbox\" ng-model=\"priceListManagement\"><i></i> <span class=\"i-checks\">Gestisci come listino</span></label><select class=\"col-md-2\" ng-options=\"k as v.title for (k, v) in schema.properties\" ng-model=\"priceListKey\" ng-disabled=\"!priceListManagement\"></select><label class=\"checkbox-inline i-checks override-checkbox-i m-b col-md-4\"><input id=\"drawingManagement\" type=\"checkbox\" ng-model=\"drawingManagement\"><i></i> <span class=\"i-checks\">Gestione planimetria</span></label> <label class=\"checkbox-inline i-checks override-checkbox-i m-b col-md-3\"><input id=\"showSubnodes\" type=\"checkbox\" ng-model=\"showSubnodes\"><i></i> <span class=\"i-checks\">Mostra sottonodi</span></label><div class=\"col-md-3\">Tipologia nodi: <input type=\"text\" ng-model=\"subNodesType\" ng-disabled=\"!showSubnodes\"></div><div class=\"col-md-2\">Etichetta tab: <input type=\"text\" ng-model=\"subNodesLabel\" ng-disabled=\"!showSubnodes\"></div><div class=\"col-md-12\" ng-if=\"selfGeneratedCode.active\"><label class=\"control-label\">Nome codice contatore</label> <input type=\"text\" class=\"form-control\" ng-model=\"selfGeneratedCode.codeNameSix\"></div></div></form></div></div></div></div><div class=\"panel-body\"><uib-tabset justified=\"true\"><uib-tab heading=\"Preview\"><form name=\"myForm\" sf-schema=\"schema\" sf-form=\"form\" sf-model=\"model\" ng-submit=\"onSubmit(myForm)\"></form></uib-tab><uib-tab heading=\"Schema\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><div class=\"col-md-12 centered\"><b>SCHEMA</b> <label class=\"checkbox-inline i-checks override-checkbox-i pull-right\"><input type=\"checkbox\" ng-model=\"bools.columndefsCrossCommission\"><i></i> <span class=\"i-checks\">Applica viusalizzazione colonne a tutte le commesse</span></label></div><div class=\"col-md-12 override-padding-no-pad-left-right\"><hr class=\"override-margin-top-bottom\"></div><div class=\"col-md-12 centered\"><div class=\"col-md-2 col-md-offset-1\"><b>CODICE</b></div><div class=\"col-md-3\"><b>DESCRIZIONE</b></div><div class=\"col-md-1\"><b>TIPOLOGIA</b></div><div class=\"col-md-2\"><b>FORMATO</b></div></div><div class=\"col-md-12 override-padding-no-pad-left-right\"><hr class=\"override-margin-top-bottom\"></div><div class=\"col-md-12 centered\"><div class=\"col-md-2 col-md-offset-1\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><form name=\"propertyKeyForm\"><input class=\"form-control\" name=\"property_key\" placeholder=\"Codice...\" type=\"text\" ng-model=\"property.key\" pattern=\"^[a-zA-Z]+[\\w]*$\"><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"propertyKeyForm.property_key.$error.pattern\">Caratteri non consentiti</span></div></form></div></div><div class=\"col-md-3\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><input class=\"form-control\" placeholder=\"Descrizione\" type=\"text\" ng-model=\"property.title\"></div></div><div class=\"col-md-1\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><select class=\"form-control\" ng-model=\"property.type\"><option></option><option value=\"string\">string</option><option value=\"number\">number</option><option value=\"integer\">integer</option><option value=\"boolean\">boolean</option><option value=\"date\">date</option><option value=\"array\">array</option></select></div></div><div class=\"col-md-2\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><select class=\"form-control\" ng-model=\"property.format\" ng-if=\"(property.type == \'string\')\"><option></option><option value=\"lookup\">lookup</option><option value=\"formula\">formula</option><option value=\"enum\">enum</option></select><select class=\"form-control\" ng-model=\"property.format\" ng-if=\"(property.type == \'number\' || property.type == \'integer\')\"><option></option><option value=\"formula\">formula</option><option value=\"enum\">enum</option></select><select class=\"form-control\" ng-model=\"property.items_type\" ng-if=\"(property.type == \'array\')\"><option></option><option value=\"lookup\">lookup</option><option value=\"string\">string</option><option value=\"number\">number</option><option value=\"integer\">integer</option><option value=\"date\">date</option></select></div></div><div class=\"col-md-2\"><div ng-if=\"isInheritable(property.type)\"><label><input type=\"checkbox\" ng-model=\"property.inherited\"> Campo ereditato</label></div></div><div class=\"col-md-1\"><button ng-click=\"addProperty()\" class=\"btn btn-sm btn-info pull-right\"><span class=\"fa fa-plus\"></span> Add</button></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-repeat=\"(key, value) in type.selected.model.schema.properties\" style=\"align-content: center; padding-bottom: 0px;\"><div class=\"col-md-12 uniform-height\" style=\"align-content: center;\"><div class=\"col-md-1\"><a href=\"\" ng-click=\"status[key].open = !status[key].open\" id=\"btn_row_detail\"><i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status[key].open, \'glyphicon-chevron-right\': !status[key].open}\"></i></a></div><div class=\"col-md-2\">{{ key }}</div><div class=\"col-md-3\">{{ value.title }}</div><div class=\"col-md-1\">{{ value.type }}</div><div class=\"col-md-2\"><span ng-if=\"value.format\">{{value.format}}</span> <span ng-if=\"value.type == \'array\' && value.items\">{{value.items.format}}</span></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-show=\"status[key].open\"><div class=\"col-md-12 uniform-height-2\" ng-if=\"value.format !== \'lookup\' && value.format !== \'formula\' && value.format !== \'enum\' && value.format !== \'inherit\' && value.type !== \'array\'\"><div class=\"col-md-2\">FORMATO:</div><div class=\"col-md-10\">{{value.format}}</div></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'inherit\'\" ng-include=\"\'dataset/modeltype/detail_inherit.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'lookup\' && value.type != \'array\'\" ng-include=\"\'dataset/modeltype/detail_lookup.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'formula\'\" ng-include=\"\'dataset/modeltype/detail_formula.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'enum\'\" ng-include=\"\'dataset/modeltype/detail_enum.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.type === \'array\'\" ng-include=\"\'dataset/modeltype/detail_array.html\'\"></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">ELIMINA:</div><div class=\"col-md-10\"><button ng-click=\"deleteProperty(key)\" class=\"btn btn-danger btn-xs btn-default\" ng-disabled=\"(key === \'code\' || key === \'description\')\"><i class=\"fa fa-trash\"></i></button></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">IN TABELLA:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.check\" ng-change=\"changeColumnDefs(key, value)\" ng-disabled=\"(key === \'code\' || key === \'description\') && !priceListManagement\"></div></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-show=\"value.check == true\"><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">LARGHEZZA (px):</div><div class=\"col-md-10\"><input type=\"text\" min=\"1\" step=\"1\" size=\"45\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=\"value.width\" ng-change=\"changeColumnDefs(key, value)\"></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">ORDINAMENTO:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.enableSorting\" ng-change=\"changeColumnDefs(key, value)\"></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">FILTRAGGIO:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.enableFiltering\" ng-change=\"changeColumnDefs(key, value)\"></div></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div></div></div></div></uib-tab><uib-tab heading=\"Form\"><table class=\"table table-striped\"><thead><th colspan=\"5\">FORM <span ng-if=\"type.selected.model.form[0].commission\">({{type.selected.model.form[0].commission}})</span> <label class=\"checkbox-inline i-checks override-checkbox-i pull-right\"><input type=\"checkbox\" ng-model=\"bools.formCrossCommission\"><i></i> <span class=\"i-checks\">Applica a tutte le commesse</span></label></th><tr><th colspan=\"5\"><div class=\"form-group\"><label for=\"title\" class=\"control-label\">Titolo</label><div class=\"\"><input type=\"text\" class=\"form-control\" id=\"title\" placeholder=\"\" ng-model=\"title\" name=\"title\" ng-keyup=\"refreshTitleForm(title)\"></div></div></th></tr><tr><td></td><td></td><td><input type=\"text\" placeholder=\"Titolo...\" ng-model=\"newTab.title\"></td><td><button ng-click=\"addTab(type.selected.model.form[0].items[0])\" class=\"btn btn-xs btn-info\"><span class=\"fa fa-plus\"></span> Add</button></td></tr><tr><th></th><th>POSIZIONE</th><th>TITOLO</th><th></th></tr></thead><tbody><tr ng-repeat-start=\"(key, tab) in type.selected.model.form[0].items[0].tabs\"><td><a href=\"\" ng-click=\"statusForm[key].open = !statusForm[key].open\"><i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': statusForm[key].open, \'glyphicon-chevron-right\': !statusForm[key].open}\"></i></a></td><td><span class=\"btn btn-sm\" ng-click=\"swapUp(key, type.selected.model.form[0].items[0].tabs)\" ng-disabled=\"key<=0\"><i class=\"fa fa-caret-up\"></i></span> {{key+1}} <span class=\"btn btn-sm\" ng-click=\"swapDown(key, type.selected.model.form[0].items[0].tabs)\" ng-disabled=\"key>=type.selected.model.form[0].items[0].tabs.length-1\"><i class=\"fa fa-caret-down\"></i></span></td><td><input type=\"text\" ng-model=\"tab.title\" ng-disabled=\"(tab.key[0] == \'code\' || tab.key[0] == \'description\')\" ng-keyup=\"updateScope()\"></td><td><a ng-click=\"removeTabOrField(key, type.selected.model.form[0].items[0].tabs)\" class=\"btn btn-danger btn-xs btn-default\" id=\"btn_row_detail_form\"><i class=\"fa fa-trash\"></i></a></td></tr><tr ng-repeat-end=\"\" ng-show=\"statusForm[key].open\"><td></td><td colspan=\"3\" style=\"background-color:rgba(211, 211, 211, 0.38);\"><table class=\"table table-striped override-margin\"><tr><td></td><td><select ng-options=\"k as v.title for (k, v) in schema.properties\" ng-model=\"newFieldForm.key\"></select></td><td><input type=\"text\" placeholder=\"Titolo...\" ng-model=\"newFieldForm.title\"></td><td><input type=\"checkbox\" placeholder=\"Richiesto...\" ng-model=\"newFieldForm.required\"></td><td><input type=\"checkbox\" placeholder=\"Nascosto...\" ng-model=\"newFieldForm.htmlClass\" ng-true-value=\"\'hidden\'\" ng-false-value=\"\'\'\"></td><td><select ng-model=\"newFieldForm.type\"><option value=\"\"></option><option value=\"text\">text</option><option value=\"textarea\">textarea</option><option value=\"number\">number</option><option value=\"datepicker\">date</option><option value=\"password\">password</option><option value=\"checkbox\">checkbox</option><option value=\"select\">enum</option><option value=\"array\">array</option><option value=\"sixlookup\">lookup</option><option value=\"inherited\">ereditato</option><option value=\"formula\">formula</option></select></td><td><button ng-click=\"addFieldToTab(tab)\" class=\"btn btn-xs btn-info\"><span class=\"fa fa-plus\"></span> Add</button></td></tr><tr><th>POSIZIONE</th><th>CAMPO</th><th>TITOLO</th><th>REQUIRED</th><th>NASCOSTO</th><th>TIPO</th><th></th></tr><tr ng-repeat=\"(fieldKey, field) in tab.items\"><td class=\"override-width-200px\"><div><span class=\"btn btn-sm\" ng-click=\"swapUp(fieldKey, tab.items)\" ng-disabled=\"fieldKey<=0\"><i class=\"fa fa-caret-up\"></i></span> {{fieldKey+1}} <span class=\"btn btn-sm\" ng-click=\"swapDown(fieldKey, tab.items)\" ng-disabled=\"fieldKey>=tab.items.length-1\"><i class=\"fa fa-caret-down\"></i></span></div></td><td ng-if=\"!field.title\">{{field}}</td><td ng-if=\"!field.title\"></td><td ng-if=\"!field.title\"></td><td ng-if=\"!field.title\"></td><td ng-if=\"field.title\">{{field.key[0]}}</td><td ng-if=\"field.title\"><input type=\"text\" ng-model=\"field.title\" ng-keyup=\"updateScope()\"></td><td ng-if=\"field.title\"><input type=\"checkbox\" ng-model=\"field.required\" ng-change=\"updateRequiredField(field)\"></td><td ng-if=\"field.title\"><input type=\"checkbox\" ng-model=\"field.htmlClass\" ng-change=\"updateScope()\" ng-true-value=\"\'hidden\'\" ng-false-value=\"\'\'\"></td><td ng-if=\"field.title\"><select ng-model=\"field.type\" ng-change=\"updateField(field)\"><option value=\"\"></option><option value=\"text\">text</option><option value=\"textarea\">textarea</option><option value=\"number\">number</option><option value=\"datepicker\">date</option><option value=\"password\">password</option><option value=\"checkbox\">checkbox</option><option value=\"select\">enum</option><option value=\"array\">array</option><option value=\"sixlookup\">lookup</option><option value=\"sixinherit\">ereditato</option><option value=\"formula\">formula</option></select></td><td><a ng-click=\"removeTabOrField(fieldKey, tab.items)\" class=\"btn btn-danger btn-xs btn-default\"><i class=\"fa fa-trash\"></i></a></td></tr></table></td></tr></tbody></table></uib-tab></uib-tabset></div><div class=\"panel-footer\"><div class=\"form-group\"><input id=\"jsonShowCheck\" type=\"checkbox\" ng-change=\"debug()\" ng-model=\"jsonshow\" data-toggle=\"collapse\" data-target=\"#json-collapse\" class=\"pull-left\"> <label for=\"jsonShowCheck\" class=\"pull-left control-label\">Dettaglio avanzato</label></div></div></div><div class=\"row collapse\" id=\"json-collapse\"><div class=\"col-md-8\"><div class=\"panel-heading wrapper b-b b-light\"><div class=\"pull-right\"><a class=\"btn btn-sm\" ng-click=\"aceChanged()\" title=\"Aggiorna preview\"><i class=\"fa fa-upload\"></i></a> <a class=\"btn btn-sm\" ng-click=\"formChanged()\" title=\"Aggiorna json\"><i class=\"fa fa-download\"></i></a></div><h4 class=\"font-thin m-t-none m-b-none text-muted\">Dettaglio</h4></div><div style=\"margin-top:0px;\" ui-ace=\"{ useWrapMode : true, showGutter: true, mode: \'json\', firstLineNumber: 1, onLoad: aceLoaded }\" ng-model=\"aceModel\"></div><div class=\"panel-footer\"></div></div><div class=\"col-md-4\"><div class=\"list-group list-group-lg list-group-sp\"><pre>{{model}}</pre></div></div></div></div></div></div>");
$templateCache.put("dataset/modeltype/modeltype_list.html","<six-toolbar><six-toolbar-button label=\"Nuovo\" icon=\"fa fa-plus\" toolbar-function=\"newModel()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"refresh()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">MODELLI</h1><small class=\"text-muted\">Lista</small></div></div></div><div class=\"panel-body\"><six-grid-pagination get-data-callback=\"getType()\" get-list-callback=\"getType()\" items-list=\"type\" column-defs=\"viewGridOptions.columnDefs\" grid-app-callbacks=\"gridAppCallbacks\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div></div>");
$templateCache.put("dataset/record/record_detail.html","<style type=\"text/css\" xmlns=\"http://www.w3.org/1999/html\">\n  #timelineRow {\n    height:26px;\n    line-height:26px;\n  }\n  .floating-btn {\n    z-index: 9999999;\n    right: 0;\n    top: 150px;\n    bottom: auto;\n    padding: 0;\n    margin: 0;\n    opacity: 0.5;\n  }\n  .floating-btn a {\n    color: #58666e;\n    background-color: #23b7e5;\n    border-radius: 10px 0px 0px 10px;\n  }\n  .floating-btn.active {\n    visibility: hidden;\n  }\n  .floating-btn .mfb-component__button--main {\n    width: 26px;\n  }\n  .floating-btn:hover {\n    opacity: 1;\n  }\n  .glyphicon-ok{\n      visibility: hidden;\n  }\n  .hr-info {\n    margin: 20px 0 10px 0;\n    border-top: 1px solid #fad733\n  }\n\n  #record-tabset .nav-tabs {\n    border: medium none;\n    background: #333;\n  }\n\n  .month-container {\n    height: 230px !important;\n  }\n\n  .calendar {\n    overflow: unset;\n  }\n\n  .warn-close{\n    position: relative;\n    left: 80%;\n    border: none;\n    background: none;\n    top: -12px;\n  }\n\n  .warn-btn{\n    background: none;\n    border: none;\n    position: relative;\n    transform: translateY(20%);\n    left: 70%\n  }\n\n  .blinking {\n  animation: blinker 1s linear 4;\n}\n\n@keyframes blinker {\n  50% {\n    opacity: 0;\n  }\n}\n</style><script type=\"text/ng-template\" id=\"recordInfoTemplate.html\"><strong><span class=\"ngdialog-icon\"></span></strong> <div style=\"text-align: center;\"><h4 class=\"m-t-none m-b font-bold\">INFO</h4></div> <div class=\"row m-t m-l m-r\"> <table align=\"center\" style=\"text-align: left; width: 100%\"> <caption style=\"text-align: right; font-weight: bold\">Record</caption> <tr><td style=\"text-align: right; font-weight: bold\">Model code:</td><td style=\"padding-left: 5px\">{{record.model.code}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">UUID:</td><td style=\"padding-left: 5px\">{{record.UUID}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">version:</td><td style=\"padding-left: 5px\">{{record.version}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">creationDate:</td><td style=\"padding-left: 5px\">{{record.creationDate}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">dataIn:</td><td style=\"padding-left: 5px\">{{record.dataIn}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">dataOut:</td><td style=\"padding-left: 5px\">{{record.dataOut}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">commission:</td><td style=\"padding-left: 5px\">{{record.commission}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">customer:</td><td style=\"padding-left: 5px\">{{record.customer}}</td></tr> </table> <hr class=\"hr-info\" /> <table align=\"center\" style=\"text-align: left; width: 100%\"> <caption style=\"text-align: right; font-weight: bold\">Tree</caption> <tr> <td style=\"text-align: right; font-weight: bold;\">Parents:</td> <td style=\"padding-left: 5px\" ng-if=\"treePaths\"> <div ng-repeat=\"(treeCode, path) in treePaths\"> <div style=\"text-align: left;\"> <span class=\"badge bg-default\" title=\"Radice tree: {{treeCode}}\">{{treeCode}}</span> <!-- elementi del path --> <span ng-repeat=\"p in path\" ng-if=\"p.code\"> /<span class=\"badge bg-info\" title=\"({{p.type}}) - Codice: {{p.code}} - Descrizione: {{p.description}}\"><i ng-class=\"getModelIcon(p.type)\"></i> {{p.code}}</span> </span> </div> </div> </td> <td style=\"padding-left: 5px\" ng-if=\"!treePaths\">Nessuno</td> </tr> </table> <hr class=\"hr-info\" /> <table align=\"center\" style=\"text-align: left; width: 100%\"> <caption style=\"text-align: right; font-weight: bold\">Schema</caption> <tr><td style=\"text-align: right; font-weight: bold\">Model code:</td><td style=\"padding-left: 5px\">{{schema.code}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">UUID:</td><td style=\"padding-left: 5px\">{{schema.UUID}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">version:</td><td style=\"padding-left: 5px\">{{schema.version}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">creationDate:</td><td style=\"padding-left: 5px\">{{schema.creationDate}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">dataIn:</td><td style=\"padding-left: 5px\">{{schema.dataIn}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">dataOut:</td><td style=\"padding-left: 5px\">{{schema.dataOut}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">commission:</td><td style=\"padding-left: 5px\">{{schema.commission}}</td></tr> </table> </div></script><script type=\"text/ng-template\" id=\"nextVersionTemplate.html\"><strong><span class=\"ngdialog-icon\"></span></strong> <div style=\"text-align: center;\"><h4 class=\"m-t-none m-b font-bold\">Versione successiva</h4></div> <div class=\"row wrapper\"> <div class=\"col-sm-6 col-md-6\"> <label>Inizio validità:</label> <six-date-time-picker name=\"dataIn\" sx-disabled=\"true\" format=\"\'dd/MM/yyyy HH:mm:ss\'\" ng-model=\"dataIn\"> </six-date-time-picker> </div> <div class=\"col-sm-6 col-md-6\"> <label>Fine validità:</label> <six-date-time-picker name=\"dataOut\" sx-disabled=\"true\" format=\"\'dd/MM/yyyy HH:mm:ss\'\" ng-model=\"dataOut\"> </six-date-time-picker> </div> </div> <div id=\"nextSF\" class=\"override-form-group override-checkbox\" sf-schema=\"schema\" sf-form=\"form\" sf-model=\"model\" sf-options=\"{formDefaults:{readonly:true}}\" update-six-formula></div></script><script type=\"text/ng-template\" id=\"helpTimelineTemplate.html\"><div class=\"text-base\"> <strong><span class=\"ngdialog-icon\"></span></strong> <div style=\"text-align: center;\"><h4 class=\"m-t-none m-b font-bold\">Versionamento</h4></div> <div ng-if=\"lang!=\'html\'\">{{message}}</div> <div ng-if=\"lang==\'html\'\" ng-bind-html=\"message\"></div> <div class=\"wrapper\"> <ul class=\"timeline timeline-center text-base\"> <li class=\"tl-header\"> <div class=\"btn btn-sm btn-default btn-rounded\">FINE</div> </li> <li class=\"tl-item\" ng-class-odd=\"\'tl-left\'\"> <div class=\"tl-wrap\"> <span class=\"tl-date\"> {{next.dataIn | date : \'dd/MM/yyyy HH:mm:ss\' : timezone}}<br /> </span> <div class=\"tl-content panel padder b-a\"> <span class=\"arrow left pull-up hidden-left\"></span> <span class=\"arrow right pull-up visible-left\"></span> <div class=\"text-lt m-b-sm\"> {{next.model.code}}<br /> {{next.model.description}} </div> <div class=\"panel-body pull-in b-t b-light\"> (VERSIONE SUCCESSIVA) </div> </div> </div> </li> <li class=\"tl-item\"> <div class=\"tl-wrap b-success\"> <span class=\"tl-date\" ng-if=\"dataInChanged\"> {{newVersion.dataIn | date : \'dd/MM/yyyy HH:mm:ss\' : timezone}}<br /> </span> <span class=\"tl-date\" ng-if=\"!dataInChanged\"> {{now | date : \'dd/MM/yyyy HH:mm:ss\' : timezone}}<br /> </span> <div class=\"tl-content panel padder b-a bg-success\"> <span class=\"arrow left pull-up hidden-left arrow-success\"></span> <span class=\"arrow right pull-up visible-left arrow-success\"></span> <div class=\"text-lt m-b-sm\"> {{newVersion.model.code}}<br /> {{newVersion.model.description}} </div> <div class=\"panel-body pull-in b-t b-light\"> (NUOVA VERSIONE) </div> </div> </div> </li> <li class=\"tl-item\" ng-class-odd=\"\'tl-left\'\" ng-if=\"current\"> <div class=\"tl-wrap\"> <span class=\"tl-date\"> {{current.dataIn | date : \'dd/MM/yyyy HH:mm:ss\' : timezone}}<br /> </span> <div class=\"tl-content panel padder b-a\"> <span class=\"arrow left pull-up hidden-left\"></span> <span class=\"arrow right pull-up visible-left\"></span> <div class=\"text-lt m-b-sm\"> {{current.model.code}}<br /> {{current.model.description}} </div> <div class=\"panel-body pull-in b-t b-light\"> (VERSIONE CORRENTE) </div> </div> </div> </li> <li class=\"tl-header\"> <div class=\"btn btn-sm btn-default btn-rounded\">INIZIO</div> </li> </ul> </div> </div></script><script type=\"text/ng-template\" id=\"recordInfoTreeDelete.html\"><strong><span class=\"ngdialog-icon\"></span></strong> <div style=\"text-align: center;\"><h4 class=\"m-t-none m-b font-bold\">ATTENZIONE</h4></div> <div class=\"row m-t m-l m-r\" ng-if=\"!skipTreeCheck && treePaths\"> <table align=\"center\" style=\"text-align: left; width: 100%\"> <caption style=\"text-align: center; font-weight: bold\">Record presente sui seguenti tree:</caption> <tr ng-repeat=\"(treeCode, path) in treePaths\"> <td style=\"text-align: left; font-weight: bold\"> <!-- elementi del path --> <span ng-repeat=\"p in path\"> <!-- elemento radice --> <span ng-if=\"!p.code\" title=\"Radice tree: {{treeCode}}\"><i class=\"fa fa-map-pin\" aria-hidden=\"true\" style=\"margin: 10px;\"></i>{{treeCode}}</span> <!-- altri elementi --> <span ng-if=\"p.code\">/<span class=\"badge bg-info\" title=\"({{(p.type) ? p.type : \'Radice\'}}) - Codice: {{p.code}} - Descrizione: {{p.description}}\"><i ng-class=\"getModelIcon(p.type)\"></i> {{p.code}}</span></span> </span> </td> </tr> <tr ng-if=\"!treePaths\"> <td style=\"text-align: left; font-weight: bold\">Nessuno</td> </tr> </table> <table align=\"center\" style=\"text-align: left; width: 100%\"> <caption style=\"text-align: center; font-weight: bold\">prima di procedere, eliminarlo dai tree.</caption> </table> </div> <div class=\"row m-t m-l m-r\" ng-if=\"skipTreeCheck || !treePaths\"> <table align=\"center\" style=\"text-align: left; width: 100%\"> <caption style=\"text-align: center; font-weight: bold\" ng-if=\"lang!=\'html\'\">{{deleteMessage}}</caption> <caption style=\"text-align: center; font-weight: bold\" ng-if=\"lang==\'html\'\" ng-bind-html=\"deleteMessage\"></caption> <tr> <td style=\"text-align: center;\"> <button type=\"button\" class=\"btn btn-default\" ng-click=\"deleteFunction()\">Si</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"notDeleteFunction()\">No</button> </td> </tr> </table> </div></script><script type=\"text/ng-template\" id=\"recordInfoUpdate.html\"><strong><span class=\"ngdialog-icon\"></span></strong> <div style=\"text-align: center;\"><h4 class=\"m-t-none m-b font-bold\">ATTENZIONE</h4></div> <div class=\"row m-t m-l m-r\"> <table align=\"center\" style=\"text-align: left; width: 100%\"> <caption style=\"text-align: center; font-weight: bold\"> &Egrave; presente una versione futura che in data {{next.dataIn | date: \'dd/MM/yyyy HH:mm:ss\'}} prenderà il posto della versione che si sta cercando di salvare <a ng-click=\"help()\">(maggiori info)</a>. Proseguire comunque? </caption> <tr> <td style=\"text-align: center;\"> <button type=\"button\" class=\"btn btn-default\" ng-click=\"updateFnt()\">Si</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"notUpdateFnt()\">No</button> </td> </tr> </table> </div></script><script type=\"text/ng-template\" id=\"validitySelector.html\"><style> .ngdialog.ngdialog-theme-default .ngdialog-content { overflow: visible; } </style> <strong><span class=\"ngdialog-icon\"></span></strong> <div style=\"text-align: center;\"><h4 class=\"m-t-none m-b font-bold\">VALIDIT&Agrave;</h4></div> <div class=\"row m-t m-l m-r\"> <div class=\"col-sm-12\"> Seleziona le date di inizio e fine validità per la nuova versione del dato.<br/><br/> </div> <div class=\"col-sm-12\"> <label>Inizio validità:</label> <six-date-time-picker name=\"dataIn\" format=\"\'dd/MM/yyyy HH:mm:ss\'\" ng-model=\"dataIn\" date-options=\"dataInOptions\"> </six-date-time-picker> </div> <div class=\"col-sm-12\"> <label>Fine validità:</label> <six-date-time-picker name=\"dataOut\" format=\"\'dd/MM/yyyy HH:mm:ss\'\" ng-model=\"dataOut\" date-options=\"dataOutOptions\"> </six-date-time-picker> </div> <div class=\"col-sm-12 padder-v\"> <a class=\"btn btn-success pull-right\" ng-click=\"proceed(dataIn, dataOut)\">Salva</a> <a class=\"btn btn-default pull-left\" ng-click=\"cancel()\">Annulla</a> </div> </div></script><six-toolbar><six-toolbar-item icon=\"fa fa-exclamation-triangle text-danger-dker\" label-class=\"bg-warning text-dark-dker\" label=\"{{getRecordVersionInfoMsg()}}\" ng-show=\"!isCurrentVersion()\"></six-toolbar-item><six-toolbar-item icon=\"fa fa-exclamation text-danger-dker\" label=\"Selezionare un cliente per abilitare il salvataggio\" ng-show=\"isCustomerMissing()\"></six-toolbar-item><six-toolbar-item label=\"{{currentCustomer.description}}\" ng-hide=\"isCustomerMissing()\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" toolbar-function=\"back()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"onSubmit(detailForm)\" sx-disabled=\"!savePerm.perm\" title=\"{{savePerm.cause}}\"></six-toolbar-button><six-toolbar-button label=\"Salva come nuova versione\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"listEditModeInsert(detailForm)\" ng-if=\"canAddListVersion()\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" toolbar-function=\"openDeleteDialog()\" sx-disabled=\"isDeletePermAllowed() === false\" ng-hide=\"!type.selected.version\"></six-toolbar-button><six-toolbar-button label=\"Clona\" btn-class=\"btn-primary\" icon=\"fa fa-clone\" toolbar-function=\"clone(type.selected.UUID)\" sx-disabled=\"action.clone\" ng-if=\"type.selected.version\"></six-toolbar-button><six-toolbar-button label=\"Rimuovi da tree\" btn-class=\"btn-warning\" icon=\"fa fa-times\" toolbar-function=\"removeFromTree()\" sx-disabled=\"isWritePermAllowed() === false || !withTree\" ng-hide=\"!type.selected.version || isListEditMode()\"></six-toolbar-button></six-toolbar><nav class=\"floating-btn\" ng-class=\"{\'active\': timelineFlags.showTimeline}\" mfb-menu=\"\" position=\"br\" effect=\"zoomin\" label=\"Timeline\" active-icon=\"fa {{timelineFlags.showTimeline?\'fa-chevron-right\':\'fa-chevron-left\'}}\" resting-icon=\"fa fa-history\" toggling-method=\"hover\" ng-click=\"timelineFlags.showTimeline=!timelineFlags.showTimeline\"></nav><six-sidebar sx-id=\"timeline_sidebar\" sx-position=\"right\" sx-title=\"\'Timeline\'\" sx-dimension=\"xxl\" sx-opened=\"timelineFlags.showTimeline\" sx-pinned=\"true\"><six-timeline options=\"{datePickerEnabled: true}\" history-perm=\"isWriteVersionAllowed()\" ext-selected=\"type.selected\" get-timeline=\"refreshTimeline()\" on-fix-timeline=\"fixTimeline()\" on-check-timeline=\"checkTimeline()\" on-select=\"onSelectVersion(value, event)\" on-save=\"onSaveVersion(value)\" on-delete=\"onDeleteVersion(value)\" on-date-changed=\"onDateChanged(value, event)\"></six-timeline></six-sidebar><div class=\"constructor\"><div class=\"col-md-12 override-padding-toolbar\" xmlns=\"http://www.w3.org/1999/html\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-md-6 col-sm-6 col-xs-12\"><div class=\"clone-notice pull-right text-center\" ng-if=\"action.clone\"><b>Copia</b><br><small>Salva per completare la copia.</small></div><h1 class=\"m-n font-thin h3 text-black\">{{typeDescription}} <a href=\"\" ng-click=\"showRecordInfo()\" class=\"m-l\"><i class=\"fa fa-info\"></i></a></h1><small>{{type.selected.model.code}} - {{type.selected.model.description}}</small></div><div class=\"col-md-6\" ng-if=\"editCrossCommission\" style=\"text-align: right;\"><label class=\"checkbox i-checks m-b inline text-right\" style=\"margin-right: 15px\"><input id=\"cross\" type=\"checkbox\" ng-model=\"bool.crossCommission\"><i></i> <span class=\"i-checks\">cross-commessa</span></label></div></div></div><div class=\"panel-body\"><div id=\"locDetail\" class=\"col-md-12\" ng-if=\"isWriteVersionAllowed()\" style=\"margin: 0px; padding: 0px\"><div class=\"panel-group\" id=\"accordion\"><div class=\"panel panel-default\" id=\"panel1\"><a data-toggle=\"collapse\" data-target=\"#collapseOne\"><div class=\"panel-heading\" ng-click=\"show = !show\"><h4 class=\"panel-title\"><i class=\"pull-right fa ng-scope fa-angle-right\" ng-class=\"{\'fa-angle-down\': show, \'fa-angle-right\': !show}\"></i> Dati Tecnici</h4></div></a><div id=\"collapseOne\" class=\"collapse\" style=\"margin: 15px\"><div class=\"row\"><div class=\"col-md-12\" ng-if=\"isWriteVersionAllowed() || (isFutureInsertAllowed() && nextVersionInTimeline)\"><div class=\"alert alert-warning\" role=\"alert\"><div class=\"row\"><ul><li ng-if=\"isWriteVersionAllowed()\">Le lookup recuperano gli asset validi alla data corrente ({{now | date: \'dd/MM/yyyy\'}}): PRESTARE ATTENZIONE AL SALVATAGGIO DI VECCHIE VERSIONI</li><li ng-if=\"isFutureInsertAllowed() && nextVersionInTimeline\">Esiste una versione successiva di questo documento in data {{nextVersionInTimeline.dataIn | date: \'dd/MM/yyyy HH:mm:ss\'}} (<a ng-click=\"showNextVersion()\">vedi versione</a>)</li></ul></div></div></div></div><div class=\"row\" ng-if=\"isWriteVersionAllowed()\"><div class=\"col-sm-4 col-md-4 m-b\"><label>UUID:</label> <input type=\"text\" class=\"form-control\" ng-model=\"type.selected.UUID\"></div><div class=\"col-sm-4 col-md-4 m-b\"><label>Version:</label> <input type=\"text\" class=\"form-control\" ng-model=\"type.selected.version\" readonly=\"\"></div><div class=\"col-sm-4 col-md-4 m-b\"><label>ID import:</label> <input type=\"text\" class=\"form-control\" ng-model=\"type.selected.import_id\" readonly=\"\"></div><div class=\"col-sm-6 col-md-6 m-b\"><label>Commesse:</label><six-select-2 sx-id=\"commission_list\" sx-list=\"commissions.list\" sx-title=\"\'Commessa\'\" ng-model=\"commissions\" sx-field=\"\'selected\'\" sx-placeholder=\"\'commessa...\'\" sx-multiple=\"true\" sx-max-selected=\"1\" sx-disabled=\"!isWriteVersionAllowed() || bool.crossCommission || isNew()\"></six-select-2></div><div class=\"col-sm-6 col-md-6\" ng-if=\"isWriteVersionAllowed() && !isCustomerSchemaForm\"><label>Clienti:</label><six-select-2 sx-id=\"customers_list\" sx-list=\"customers.list\" sx-title=\"\'Cliente\'\" ng-model=\"customers\" sx-field=\"\'selected\'\" sx-placeholder=\"\'cliente...\'\" sx-multiple=\"true\" sx-max-selected=\"1\" sx-disabled=\"!isWriteVersionAllowed() || bool.crossCustomer\"></six-select-2></div></div></div></div></div></div><div class=\"row\"><div class=\"col-sm-6 col-md-6\"><label>Inizio validità:</label><six-date-time-picker name=\"dataIn\" sx-disabled=\"dataInDisabled()\" format=\"\'dd/MM/yyyy HH:mm:ss\'\" ng-model=\"type.selected.dataIn\" date-options=\"dataInOptions\"></six-date-time-picker></div><div class=\"col-sm-6 col-md-6\"><label>Fine validità:</label><six-date-time-picker name=\"dataOut\" sx-disabled=\"dataOutDisabled()\" format=\"\'dd/MM/yyyy HH:mm:ss\'\" ng-model=\"type.selected.dataOut\" date-options=\"dataOutOptions\"></six-date-time-picker></div></div><form name=\"detailForm\" ng-submit=\"onSubmit(detailForm)\" class=\"m-t\"><uib-tabset class=\"tabs-right\"><uib-tab index=\"0\"><uib-tab-heading><span class=\"fa fa-list-alt text-info-dker\"></span> Dati</uib-tab-heading><div class=\"row wrapper\"><div class=\"override-form-group override-checkbox\" sf-schema=\"schema\" sf-form=\"form\" sf-model=\"type.selected.model\" update-six-formula=\"\" unique-validation=\"\" factory-params=\"{{typeName}}\" unique-exclusions=\"{{uniqueExclusions}}\" ng-model=\"type.selected.model.code\"></div></div></uib-tab><uib-tab index=\"1\" ng-if=\"attachmentManagement\"><uib-tab-heading><span class=\"fa fa-book text-info-dker\"></span> Allegati</uib-tab-heading><six-tree-attachments nodes=\"attachments\" save-callback=\"saveAttachments()\"></six-tree-attachments></uib-tab><uib-tab index=\"2\" select=\"initCalendar()\" ng-if=\"calendarManagement\"><uib-tab-heading><span class=\"fa fa-calendar text-info-dker\"></span> Calendario</uib-tab-heading><div id=\"year-calendar-view\"></div></uib-tab><uib-tab index=\"3\" select=\"loadSubNodes()\" ng-if=\"showSubnodes && hasParents()\"><uib-tab-heading><span class=\"fa fa-sitemap text-info-dker\"></span> {{subNodesLabel}}</uib-tab-heading><div id=\"subnodes-view\"><six-grid-pagination sx-id=\"{{typeName}}_subnodes_grid\" get-data-callback=\"getSubnodes()\" get-list-callback=\"getSubnodes()\" get-all-data-callback=\"getAllSubnodes()\" items-list=\"subnodes\" column-defs=\"subNodesViewGridOptions.columnDefs\" grid-app-callbacks=\"gridAppCallbacks\" grid-options=\"subNodesViewGridOptions\" enable-state-saving=\"true\" params=\"params\" show-global-search=\"false\"></six-grid-pagination></div></uib-tab><uib-tab index=\"4\"><uib-tab-heading><span class=\"fa fa-qrcode text-info-dker\"></span> QRCODE</uib-tab-heading><qrcode version=\"5\" error-correction-level=\"H\" size=\"274\" data=\"{{type.selected.UUID}}\"></qrcode></uib-tab><uib-tab index=\"5\" select=\"initDrawing()\" ng-if=\"drawingManagement\" disable=\"!type.selected.UUID || !schema\"><uib-tab-heading><span class=\"fa fa-file-image-o text-info-dker\"></span> Planimetrie</uib-tab-heading><ict-drawing ng-if=\"hasDrawing\" style=\"height: 600px;\" drawing-uuid=\"drawingUuid\" asset-uuid=\"drawingAssetUuid\" highlight=\"type.selected.model.code\"></ict-drawing><div ng-if=\"!hasDrawing\">Nessuna planimetria presente.</div><ict-drawing-uploader ng-if=\"isDrawingUploadAllowed()\"></ict-drawing-uploader></uib-tab></uib-tabset><div ng-repeat=\"alert in alerts\"><div class=\"alert alert-danger alert-dismissible\" role=\"alert\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button> <strong>Warning!</strong> {{alert.msg}}</div></div></form></div><div class=\"panel-footer\" ng-show=\"isWriteVersionAllowed()\"><div class=\"form-group\"><input id=\"jsonShowCheck\" type=\"checkbox\" ng-model=\"jsonshow\" data-toggle=\"collapse\" data-target=\"#json-collapse\" class=\"pull-left\"> <label for=\"jsonShowCheck\" class=\"pull-left control-label\">Dettaglio avanzato</label></div></div><div class=\"row collapse\" id=\"json-collapse\"><div class=\"col-md-12\"><div class=\"panel-heading wrapper b-b b-light\"><h4 class=\"font-thin m-t-none m-b-none text-muted\">Dettaglio</h4></div><div style=\"margin-top:0px;\" ui-ace=\"{ useWrapMode : true, showGutter: true, mode: \'json\', firstLineNumber: 1, onLoad: aceLoaded, onChange: aceChanged }\" ng-model=\"aceModel\"></div><div class=\"panel-footer\"></div></div></div><div class=\"panel-body\"></div><div id=\"messages\" class=\"row m-t\" ng-if=\"messages.length\"><div class=\"panel-group\" id=\"accordion\"><div class=\"panel panel-default\" id=\"panel1\"><div class=\"panel-heading\"><div class=\"panel-title\"><button ng-click=\"tryFixAllProblems()\" type=\"button\" class=\"btn btn-default btn-sm pull-right\"><span class=\"fa fa-medkit\"></span> Fix all</button> Messaggi</div></div><div class=\"panel-body\"><div class=\"col-md-12\"><div id=\"gridReport\" ui-grid=\"reportGridOptions\" class=\"grid\" style=\"height: 420px\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\" ui-grid-move-columns=\"\"></div></div></div></div></div></div></div></div></div>");
$templateCache.put("dataset/record/record_list.html","<style type=\"text/css\">\n  #timelineRow {\n    height:26px;\n    line-height:26px;\n  }\n  .closed-record {\n    color: #ffffff;\n    background-color: #f05050 !important;\n  }\n  .inline{\n    display: inline;\n  }\n</style><six-toolbar><six-toolbar-item icon=\"fa fa-exclamation-triangle text-danger-dker\" label-class=\"bg-warning text-dark-dker\" label=\"Stai visualizzando la lista alla data {{date.currentDate | date: \'dd/MM/yyyy\'}}\" ng-show=\"date.currentDate\"></six-toolbar-item><six-toolbar-item icon=\"fa fa-info\" label=\"Stai visualizzando la lista ad oggi ({{now | date: \'dd/MM/yyyy\'}})\" ng-show=\"!date.currentDate && !isListEditMode()\"></six-toolbar-item><six-toolbar-item label=\"{{currentCustomer.description}}\" ng-hide=\"isCustomerMissing()\"></six-toolbar-item><six-toolbar-button label=\"Crea modello\" btn-class=\"btn-danger\" icon=\"fa fa-wrench\" id=\"btn_item_create_model\" ng-if=\"!isModelDefined\" toolbar-function=\"newModelType()\"></six-toolbar-button><six-toolbar-button label=\"Modifica\" icon=\"fa fa-pencil\" toolbar-function=\"bulkEdit()\" sx-disabled=\"isUpdatePermAllowed() === false || getSelectedRows().length == 0\"></six-toolbar-button><six-toolbar-button label=\"Nuovo\" icon=\"fa fa-plus\" toolbar-function=\"new()\" id=\"btn_item_create\" sx-disabled=\"!isModelDefined || isWritePermAllowed() === false\"></six-toolbar-button><six-toolbar-button label=\"Check\" icon=\"fa fa-heartbeat\" toolbar-function=\"checkType()\" sx-disabled=\"isWritePermAllowed() === false\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"refresh()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\" xmlns=\"http://www.w3.org/1999/html\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">{{typeDescription}}</h1></div><div class=\"col-sm-6 text-right hidden-xs\" id=\"timelineRow\"><div class=\"inline text-left row\"><div class=\"col-sm-4\">Timeline:</div><div class=\"col-sm-8\"><input type=\"date\" ng-model=\"date.currentDate\" ng-change=\"changeCurrentDate(date.currentDate, false)\" class=\"form-control input-sm bg-light no-border rounded padder ng-pristine ng-valid ng-touched\"></div></div></div></div></div><div class=\"panel-body\"><six-bulk-editor ng-if=\"bulkEditorVisible\" sx-cancel=\"bulkEditConf.cancel()\" sx-post-save=\"bulkEditConf.postSave()\" sx-data-getter=\"bulkEditConf.dataGetter(searchDate)\" sx-save=\"bulkEditConf.factory(searchDate, payload)\" sx-schema-form=\"bulkEditConf.schema\" sx-schema-form-prefix=\"model\" sx-date-enabled=\"true\" sx-date-options=\"bulkEditConf.dateOptions\"></six-bulk-editor><div class=\"col-md-12 no-pad-l-r\" ng-if=\"historyMode == \'snap\'\"><label class=\"checkbox i-checks m-b inline\"><input id=\"check-1\" type=\"checkbox\" ng-model=\"bool.viewCommissionData\"><i></i> <span class=\"i-checks\">Visualizza le righe associate alla commessa</span></label> <span>&nbsp;&nbsp;</span> <label class=\"checkbox i-checks m-b inline\"><input id=\"check-2\" type=\"checkbox\" ng-model=\"bool.viewCrossData\"><i></i> <span class=\"i-checks\">Visualizza le righe cross-commessa</span></label></div><six-grid-pagination sx-id=\"{{typeName}}_grid\" get-data-callback=\"getType()\" get-list-callback=\"getType()\" get-all-data-callback=\"getAll()\" items-list=\"type\" column-defs=\"viewGridOptions.columnDefs\" grid-app-callbacks=\"gridAppCallbacks\" grid-options=\"viewGridOptions\" enable-state-saving=\"true\" params=\"params\"></six-grid-pagination></div><div id=\"messages\" class=\"row m-t\" ng-if=\"messages.length\"><div class=\"panel-group\" id=\"accordion\"><div class=\"panel panel-default\" id=\"panel1\"><div class=\"panel-heading\"><div class=\"panel-title\"><button ng-click=\"tryFixAllProblems()\" type=\"button\" class=\"btn btn-default btn-sm pull-right\"><span class=\"fa fa-medkit\"></span> Fix all</button> Messaggi</div></div><div class=\"panel-body\"><div class=\"col-md-12\"><div id=\"gridReport\" ui-grid=\"reportGridOptions\" class=\"grid\" style=\"height: 420px\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\" ui-grid-move-columns=\"\"></div></div></div></div></div></div></div></div>");
$templateCache.put("dataset/record/vettoreenergetico_detail.html","<style type=\"text/css\">\n  table th {\n    text-align: center;\n  }\n\n  table td.bordered,\n  table th.bordered {\n    border-right: solid 1px lightgrey;\n  }\n\n  #timelineRow {\n    height:26px;\n    line-height:26px;\n  }\n</style><script type=\"text/ng-template\" id=\"recordInfoTreeDelete.html\"><strong><span class=\"ngdialog-icon\"></span></strong> <div style=\"text-align: center;\"><h4 class=\"m-t-none m-b font-bold\">ATTENZIONE</h4></div> <div class=\"row m-t m-l m-r\" ng-if=\"treePaths\"> <table align=\"center\" style=\"text-align: left; width: 100%\"> <caption style=\"text-align: center; font-weight: bold\">Record presente sui seguenti tree:</caption> <tr ng-repeat=\"(treeCode, path) in treePaths\"> <td style=\"text-align: left; font-weight: bold\"> <!-- elementi del path --> <span ng-repeat=\"p in path\"> <!-- elemento radice --> <span ng-if=\"!p.code\" title=\"Radice tree: {{treeCode}}\"><i class=\"fa fa-map-pin\" aria-hidden=\"true\" style=\"margin: 10px;\"></i>{{treeCode}}</span> <!-- altri elementi --> <span ng-if=\"p.code\">/<span class=\"badge bg-info\" title=\"({{(p.type) ? p.type : \'Radice\'}}) - Codice: {{p.code}} - Descrizione: {{p.description}}\">{{p.code}}</span></span> </span> </td> </tr> <tr ng-if=\"!treePaths\"> <td style=\"text-align: left; font-weight: bold\">Nessuno</td> </tr> </table> <table align=\"center\" style=\"text-align: left; width: 100%\"> <caption style=\"text-align: center; font-weight: bold\">prima di procedere, eliminarlo dai tree.</caption> </table> </div> <div class=\"row m-t m-l m-r\" ng-if=\"!treePaths\"> <table align=\"center\" style=\"text-align: left; width: 100%\"> <caption style=\"text-align: center; font-weight: bold\">{{deleteMessage}}</caption> <tr> <td style=\"text-align: center;\"> <button type=\"button\" class=\"btn btn-default\" ng-click=\"deleteFunction()\">Si</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"notDeleteFunction()\">No</button> </td> </tr> </table> </div></script><six-toolbar><six-toolbar-button label=\"Crea modello\" btn-class=\"btn-danger\" icon=\"fa fa-wrench\" id=\"btn_item_create_model\" ng-if=\"!isModelDefined && isWritePermAllowed()===true\" toolbar-function=\"newModelType()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"onSubmit(detailForm)\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" sx-disabled=\"isDeletePermAllowed()===false\" toolbar-function=\"openDeleteDialog()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\" xmlns=\"http://www.w3.org/1999/html\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">{{typeDescription}}</h1></div><div class=\"col-sm-6 text-right hidden-xs\" id=\"timelineRow\"><div class=\"inline text-left row\" ng-if=\"isCollapsed\"><div class=\"col-sm-4\">Timeline:</div><div class=\"col-sm-8\"><input type=\"date\" ng-model=\"currentDate\" ng-change=\"changeCurrentDate(currentDate)\" class=\"form-control input-sm bg-light no-border rounded padder ng-pristine ng-valid ng-touched\" style=\"\"></div></div></div></div></div><div class=\"panel-body wrapper\"><div collapse=\"!isCollapsed\" class=\"panel-body\" ng-class=\"{\'col-md-8\': showTimeline}\"><div class=\"row\" ng-if=\"showTimeline\"><div class=\"col-sm-6\"><label>Inizio validità:</label><p class=\"input-group\"><input type=\"text\" readonly=\"true\" class=\"form-control\" id=\"dataIn\" ng-model=\"type.selected.dataIn\" datepicker-popup=\"dd.MM.yyyy\" is-open=\"OpenedIn\" ng-click=\"OpenedIn=true\"> <span class=\"input-group-btn\"><button type=\"button\" disabled=\"true\" class=\"btn btn-default\" ng-click=\"OpenedIn=true;$event.stopPropagation();\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-sm-6\"><label>Fine validità:</label><p class=\"input-group\"><input type=\"text\" readonly=\"true\" class=\"form-control\" id=\"dataOut\" ng-model=\"type.selected.dataOut\" datepicker-popup=\"dd.MM.yyyy\" is-open=\"OpenedOut\" ng-click=\"OpenedOut=true\"> <span class=\"input-group-btn\"><button type=\"button\" disabled=\"true\" class=\"btn btn-default\" ng-click=\"OpenedOut=true;$event.stopPropagation();\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><form name=\"detailForm\" ng-submit=\"onSubmit(detailForm)\"><div ng-repeat=\"items in form[0].items\"><div ng-repeat=\"tabs in items.tabs\"><div ng-repeat=\"model_items in tabs.items\"><div ng-if=\"model_items.type !== \'array\'\" ng-init=\"iter = iter + 1\"><div class=\"form-group col-md-4\" ng-if=\"(\'sixlookup\' !== model_items.type) && (\'convfact\' !== model_items.key)\"><label style=\"font-weight:bold\" class=\"control-label\" ng-if=\"\'convfact\' !== model_items.key[0]\">{{model_items.title}}</label><div class=\"input-group\"><span class=\"input-group-addon\" id=\"sizing-addon\" ng-if=\"model_items.fieldAddonLeft\">m</span> <input class=\"form-control\" ng-disabled=\"!disableModify\" type=\"{{model_items.type}}\" step=\"any\" ng-model=\"type.selected.model[model_items.key[0]]\" aria-describedby=\"sizing-addon\" ng-change=\"boolUpdate(model_items)\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"disableModify=!disableModify\"><i class=\"fa fa-pencil\"></i></button></span></div></div><div class=\"form-group col-md-4\" ng-if=\"\'sixlookup\' == model_items.type\"><label style=\"font-weight:bold\" class=\"control-label\">{{model_items.title}}</label><six-lookup-2 ng-model=\"type.selected.model\" sx-type=\"model_items.entity_id\" sx-field=\"model_items.key[0]\"></six-lookup-2></div></div><div class=\"row wrapper\" ng-if=\"model_items.type === \'array\'\" ng-controller=\"VettoreEnergeticoCtrl\"><div class=\"col-md-12\"><h3>Fattori tecnici <span class=\"btn btn-sm btn-success\" style=\"margin-left: 10px\" ng-click=\"type.selected.model.convfact=type.selected.model.convfact||[]; type.selected.model.convfact.push({});\"><i class=\"fa fa-plus\"></i></span></h3><table ng-if=\"type.selected.model.convfact.length>0\"><tr><th class=\"bordered\">U.M.</th><th class=\"bordered\">TEP</th><th colspan=\"3\" class=\"bordered\">PCS</th><th colspan=\"3\">PCI</th><th></th></tr><tr ng-repeat=\"fact in type.selected.model.convfact track by $index\"><td width=\"15%\" style=\"vertical-align: top;\" class=\"bordered\"><div style=\"width: 100%; padding: 2px 5px 2px 5px\"><div class=\"form-group\" style=\"float: left; width: 100%\"><six-lookup-2 ng-model=\"fact\" sx-type=\"\'um\'\" sx-field=\"\'um_id\'\"></six-lookup-2></div></div></td><td style=\"vertical-align: top;\" class=\"bordered\"><div class=\"input-group\" style=\"width: 100%; padding: 2px 5px 2px 5px\"><input type=\"number\" class=\"form-control\" step=\"any\" ng-model=\"fact.tep\" ng-disabled=\"editingMode == false\" style=\"text-align: center;\"> <span class=\"input-group-addon\">tep/{{fact.um_id.code}}</span></div></td><td style=\"vertical-align: top\"><div class=\"input-group\" style=\"width: 100%; padding: 2px 5px 2px 5px\"><input type=\"number\" class=\"form-control\" step=\"any\" ng-model=\"fact.pcs_kwh\" ng-disabled=\"editingMode == false\"> <span class=\"input-group-addon\">kWh/{{fact.um_id.code}}</span></div></td><td style=\"vertical-align: top\"><div class=\"input-group\" style=\"width: 100%; padding: 2px 5px 2px 5px\"><input type=\"number\" class=\"form-control\" step=\"any\" ng-model=\"fact.pcs_mj\" ng-disabled=\"editingMode == false\"> <span class=\"input-group-addon\">MJ/{{fact.um_id.code}}</span></div></td><td style=\"vertical-align: top;\" class=\"bordered\"><div class=\"input-group\" style=\"width: 100%; padding: 2px 5px 2px 5px\"><input type=\"number\" class=\"form-control\" step=\"any\" ng-model=\"fact.pcs_kcal\" ng-disabled=\"editingMode == false\"> <span class=\"input-group-addon\">kcal/{{fact.um_id.code}}</span></div></td><td style=\"vertical-align: top\"><div class=\"input-group\" style=\"width: 100%; padding: 2px 5px 2px 5px\"><six-formula ng-model=\"fact.pci_kwh\" field-type=\"\'number\'\" params=\"fact.pcs_kwh\" formula-id=\"\'pci\'\" field-addon-right=\"pciUm(\'kWh\', fact.um_id.code)\"></six-formula></div></td><td style=\"vertical-align: top\"><div class=\"input-group\" style=\"width: 100%; padding: 2px 5px 2px 5px\"><six-formula ng-model=\"fact.pci_mj\" field-type=\"\'number\'\" params=\"fact.pcs_mj\" formula-id=\"\'pci\'\" field-addon-right=\"pciUm(\'MJ\', fact.um_id.code)\"></six-formula></div></td><td style=\"vertical-align: top\"><div class=\"input-group\" style=\"width: 100%; padding: 2px 5px 2px 5px\"><six-formula ng-model=\"fact.pci_kcal\" field-type=\"\'number\'\" params=\"fact.pcs_kcal\" formula-id=\"\'pci\'\" field-addon-right=\"pciUm(\'kcal\', fact.um_id.code)\"></six-formula></div></td><td style=\"vertical-align: top\"><div class=\"input-group\" style=\"padding: 2px 5px 2px 5px\"><span class=\"btn btn-sm btn-danger\" ng-click=\"type.selected.model.convfact.splice(type.selected.model.convfact.indexOf(fact), 1);\"><i class=\"fa fa-trash\"></i></span></div></td></tr></table></div></div></div></div></div><div ng-repeat=\"alert in alerts\"><div class=\"alert alert-danger alert-dismissible\" role=\"alert\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button> <strong>Warning!</strong> {{alert.msg}}</div></div></form></div><div class=\"col-md-4\" ng-if=\"showTimeline\" ng-controller=\"TimelineCtrl\" ng-init=\"buildTimeline(typeName, type.selected.UUID, type.selected.version)\"><div class=\"wrapper\"><ul class=\"timeline timeline-center\"><li class=\"tl-header\"><div class=\"btn btn-sm btn-default btn-rounded\">INIZIO</div></li><li ng-repeat=\"item in timeline\" class=\"tl-item\" ng-class-odd=\"\'tl-left\'\"><div class=\"tl-wrap\" ng-class=\"{\'b-success\': (type.selected.model.version == item.version)}\"><span class=\"tl-date\">{{item.dataIn | date : format : timezone}}</span><div class=\"tl-content panel padder b-a\" ng-class=\"{\'bg-success\': (type.selected.model.version == item.version)}\"><span class=\"arrow left pull-up hidden-left\" ng-class=\"{\'arrow-success\': (type.selected.model.version == item.version)}\"></span> <span class=\"arrow right pull-up visible-left\" ng-class=\"{\'arrow-success\': (type.selected.model.version == item.version)}\"></span><div class=\"text-lt m-b-sm\">{{item.model.code}}</div><div class=\"panel-body pull-in b-t b-light\"><span class=\"pull-right label\" ng-class=\"{\'bg-success\': (type.selected.model.version == item.version), \'bg-info\': (type.selected.model.version != item.version)}\">{{item.user}}</span></div><div class=\"panel-body pull-in b-t b-light\">{{item.model.description}}</div></div></div></li><li class=\"tl-header\"><div class=\"btn btn-sm btn-default btn-rounded\">FINE</div></li></ul></div></div><div id=\"messages\" class=\"row m-t\" ng-if=\"messages.length\"><div class=\"panel-group\" id=\"accordion\"><div class=\"panel panel-default\" id=\"panel1\"><div class=\"panel-heading\"><div class=\"panel-title\"><button ng-click=\"tryFixAllProblems()\" type=\"button\" class=\"btn btn-default btn-sm pull-right\"><span class=\"fa fa-medkit\"></span> Fix all</button> Messaggi</div></div><div class=\"panel-body\"><div class=\"col-md-12\"><div id=\"gridReport\" ui-grid=\"reportGridOptions\" class=\"grid\" style=\"height: 420px\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\" ui-grid-move-columns=\"\"></div></div></div></div></div></div></div></div></div>");
$templateCache.put("dataset/rolemapping/mappingdetail.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" toolbar-function=\"goToMappingList()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-save\" label=\"Salva\" btn-class=\"btn-success\" toolbar-function=\"update()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh\" label=\"Aggiorna\" btn-class=\"btn-info\" toolbar-function=\"getMapping()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-trash\" label=\"Elimina\" btn-class=\"btn-danger\" toolbar-function=\"deleteMapping()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-12 col-xs-12 col-md-12\"><h1 class=\"m-n font-thin h3 text-black\">Mapping</h1></div></div></div><div class=\"panel-body\"><div class=\"panel-body\"><div class=\"col-md-4 col-sm-4\"><label for=\"emma_role\" class=\"control-label\">EMMA</label><six-lookup-2 id=\"emma_role\" sx-id=\"emma_role\" ng-model=\"mapping.model\" sx-type=\"\'ruolooperatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'emma_role_id\'\" sx-add=\"false\" sx-show-details=\"false\" sx-show-filters=\"false\" sx-compact=\"true\"></six-lookup-2></div><div class=\"col-md-8 col-sm-8\"><label for=\"ldap_groups\" class=\"control-label\">LDAP</label><div id=\"ldap_groups\" class=\"input-group\" style=\"width:100%\"><tags-input class=\"form-control bootstrap\" style=\"width: 100%; padding: 0px !important;\" placeholder=\"Ldap...\" ng-model=\"mapping.model.ldap_groups\" key-property=\"code\" display-property=\"code\" add-on-space=\"true\" add-from-autocomplete-only=\"false\"></tags-input><span class=\"input-group-btn\"><a class=\"btn btn-default\" ng-click=\"clearLdapGroup()\"><i class=\"fa fa-times\"></i></a></span></div></div></div></div></div></div>");
$templateCache.put("dataset/rolemapping/mappinglist.html","<six-toolbar><six-toolbar-button icon=\"fa fa-plus\" label=\"Nuovo\" btn-class=\"btn-success\" toolbar-function=\"goToNewMapping()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh\" label=\"Aggiorna\" btn-class=\"btn-default\" toolbar-function=\"getList()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-md-12 col-sm-12 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista Mapping</h1><small>Pagina di gestione corrispondenze tra ruoli operatori e gruppi LDAP. Queste corrispondenze vengono utilizzate in fase di aggiunta automatica di un utente non ancora presente nell\'elenco di operatori di sistema.</small></div></div></div><div class=\"panel-body\"><six-grid-pagination get-data-callback=\"getList()\" get-list-callback=\"getList()\" items-list=\"rows\" column-defs=\"viewGridOptions.columnDefs\" grid-app-callbacks=\"gridAppCallbacks\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div></div>");
$templateCache.put("dataset/schema-form/commission-mapper.html","<style type=\"text/css\">\n  .bordered {\n    border-radius: 5px;\n    border: 1px solid lightgray;\n    padding: 5px;\n  }\n</style><div class=\"form-group {{form.htmlClass}}\" ng-class=\"{\'has-error\': hasError()}\" style=\"width: 100%; height: auto;\" six-commission-mapper=\"$$value$$\"><label class=\"control-label {{form.labelHtmlClass}}\">{{form.title}} <a class=\"btn btn-success btn-xs m-l-md\" ng-disabled=\"freeCommissions.length == 0\" ng-click=\"addMapping()\">Aggiungi <i class=\"fa fa-plus\"></i></a></label><div ng-repeat=\"(commission, role) in $$value$$\" ng-class=\"{\'bordered\': form.schema.compact}\"><div class=\"pull-right\" ng-if=\"form.schema.compact\"><a ng-click=\"removeCommission(commission)\"><i class=\"fa fa-times\"></i></a></div><div class=\"clearfix\"></div><div class=\"text-center\" ng-class=\"{\'\': form.schema.compact , \'col-xs-6\': !form.schema.compact}\"><ui-select ng-model=\"keys[commission]\" on-select=\"updateCommission(commission, $model)\"><ui-select-match>{{$select.selected.code}} - {{$select.selected.description}}</ui-select-match><ui-select-choices ui-disable-choice=\"freeCommissions.indexOf(value.code) == -1\" repeat=\"value.code as value in allCommissions\"><div>{{value.code}} - {{value.description}}</div></ui-select-choices></ui-select></div><div ng-class=\"{\'\': form.schema.compact , \'col-xs-5\': !form.schema.compact}\"><six-lookup-2 sx-id=\"roleLookup_{{commission}}\" ng-model=\"$$value$$[commission]\" sx-war=\"form.schema.war\" sx-type=\"form.schema.entity_id\" sx-add=\"false\" sx-item-template=\"form.schema.item_template\" sx-multiple=\"form.schema.multiple\" sx-show-details=\"form.schema.show_details\" sx-show-filters=\"form.schema.show_filters\" sx-compact=\"\'true\'\"></six-lookup-2></div><div class=\"text-right\" ng-if=\"!form.schema.compact\"><a class=\"btn btn-danger\" ng-click=\"removeCommission(commission)\"><i class=\"fa fa-trash\"></i></a></div></div><span class=\"clearfix help-block\">{{ (hasError() && errorMessage(schemaError())) || form.description}}</span></div>");
$templateCache.put("dataset/schema-form/file-field.html","<div sx-file=\"\" class=\"form-group schema-form-text {{form.htmlClass}}\" ng-class=\"{ \'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess(), \'has-feedback\': form.feedback !== false, \'required\': form.required===true }\"><label class=\"control-label {{form.labelHtmlClass}}\" ng-class=\"{\'sr-only\': !showTitle()}\">{{form.title}}</label> <input type=\"file\" uploader=\"uploader\" nv-file-select=\"\" ng-show=\"false\" id=\"{{fieldId()}}\"> <button type=\"submit\" ng-show=\"false\" id=\"{{fieldId()}}submit\"></button><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-icon\" ng-click=\"loadFile()\" ng-disabled=\"form.readonly\"><i class=\"fa fa-upload\"></i></button></span> <input type=\"text\" class=\"form-control {{form.fieldHtmlClass}}\" placeholder=\"Nessun file selezionato\" readonly=\"\" schema-validate=\"form\" sf-changed=\"form\" ng-model=\"model[form.key[0]].title\" title=\"{{$$value$$.title}}\" aria-describedby=\"{{fieldId()}}status\"> <span class=\"input-group-btn\" ng-if=\"$$value$$\"><button type=\"button\" class=\"btn btn-default btn-icon\" ng-click=\"removeFile($$value$$.object_id)\" ng-disabled=\"form.readonly\"><i class=\"fa fa-trash text-danger\"></i></button> <a class=\"btn btn-default btn-icon\" ng-href=\"{{getDownloadLink()}}\" target=\"_blank\" download=\"{{$$value$$.title}}\"><i class=\"fa fa-download text-info\"></i></a></span></div><span ng-if=\"form.feedback !== false\" class=\"form-control-feedback glyphicon\" ng-class=\"evalInScope(form.feedback) || { \'glyphicon-ok\': hasSuccess(), \'glyphicon-remove\': hasError() }\" aria-hidden=\"true\"></span> <span ng-if=\"hasError() || hasSuccess()\" id=\"{{fieldId()}}status\" class=\"sr-only\">{{ hasSuccess() ? \'(success)\' : \'(error)\' }}</span><div class=\"help-block\" sf-message=\"form.description\"></div></div>");
$templateCache.put("dataset/schema-form/nested-reference.html","<div class=\"form-group {{form.htmlClass}}\" ng-class=\"{\'has-error\': hasError()}\" style=\"width: 100%; height: auto;\" six-nested-reference=\"$$value$$\"><label class=\"control-label {{form.labelHtmlClass}}\">{{form.title}} <a class=\"btn btn-success btn-xs m-l-md\" ng-click=\"addReference()\">Aggiungi <i class=\"fa fa-plus\"></i></a></label><div ng-repeat=\"reference in $$value$$\"><div class=\"col-xs-6\"><six-lookup-2 sx-id=\"{{reference.cost_center.UUID}}_lookup\" ng-model=\"reference.cost_center\" sx-war=\"costCenterSchema.war\" sx-type=\"costCenterSchema.entity_id\" sx-item-template=\"costCenterSchema.item_template\" sx-multiple=\"costCenterSchema.multiple\" sx-show-details=\"costCenterSchema.show_details\" sx-show-filters=\"costCenterSchema.show_filters\"></six-lookup-2></div><div class=\"col-xs-5\"><input type=\"number\" ng-model=\"reference.partition\" min=\"{{partitionSchema.min}}\" max=\"{{partitionSchema.max}}\" class=\"form-control text-right\"></div><div class=\"col-xs-1 text-right\"><a class=\"btn btn-danger\" ng-click=\"removeReference(reference)\"><i class=\"fa fa-trash\"></i></a></div></div><span class=\"clearfix help-block\">{{ (hasError() && errorMessage(schemaError())) || form.description}}</span></div>");
$templateCache.put("dataset/timeline/timeline.html","<div class=\"hbox hbox-auto-xs hbox-auto-sm ng-scope\"><div class=\"col w-lg bg-light dk b-r bg-auto\" id=\"aside\"><div class=\"wrapper bg b-b\"><button class=\"btn btn-sm btn-default pull-right\" ui-toggle-class=\"timeline-center\" target=\".timeline\">Center</button> <span class=\"pull-right\">&nbsp;</span> <button back=\"\" type=\"button\" class=\"btn btn-default btn-sm pull-right\"><span class=\"glyphicon glyphicon-menu-left\"></span></button><h3 class=\"m-n font-thin\">Timeline</h3></div><div class=\"wrapper\"><form class=\"ng-pristine ng-valid\"><div class=\"row wrapper-sm\"><label>Modello</label> <input type=\"text\" disabled=\"true\" placeholder=\"Modello\" class=\"input-sm form-control\" ng-model=\"entity\"></div><div class=\"row wrapper-sm\"><label>UUID</label> <input type=\"text\" disabled=\"true\" placeholder=\"UUID\" class=\"input-sm form-control\" ng-model=\"timeline[0].UUID\"></div><div class=\"row wrapper-sm\" ng-show=\"data.version\"><label>Version</label> <input type=\"text\" disabled=\"true\" placeholder=\"Version\" class=\"input-sm form-control\" ng-model=\"data.version\"></div><div class=\"row wrapper-sm\" ng-show=\"data.version\"><label>Data creazione</label> <input type=\"datetime-local\" disabled=\"true\" placeholder=\"-\" class=\"input-sm form-control\" ng-model=\"data.creationDate\"></div><div class=\"row wrapper-sm\" ng-show=\"data.version\"><label>Data inizio validità</label> <input type=\"datetime-local\" disabled=\"true\" placeholder=\"-\" class=\"input-sm form-control\" ng-model=\"data.dataIn\"></div><div class=\"row wrapper-sm\" ng-show=\"data.version\"><label>Data fine validità</label> <input type=\"datetime-local\" disabled=\"true\" placeholder=\"-\" class=\"input-sm form-control\" ng-model=\"data.dataOut\"></div><div class=\"row wrapper-sm\" ng-show=\"data.version\"><label>Utente inserimento/modifica</label> <input type=\"text\" disabled=\"true\" placeholder=\"-\" class=\"input-sm form-control\" ng-model=\"data.user\"></div><div class=\"row wrapper-sm\" ng-show=\"data.version\"><label>Utente cancellazione</label> <input type=\"text\" disabled=\"true\" placeholder=\"-\" class=\"input-sm form-control\" ng-model=\"data.userDelete\"></div></form></div></div><div class=\"col\"><div class=\"wrapper\"><ul class=\"timeline\"><li class=\"tl-header\"><div class=\"btn btn-sm btn-default btn-rounded\">FINE</div></li><li ng-repeat=\"item in timeline\" class=\"tl-item\" ng-class-odd=\"\'tl-left\'\"><div class=\"tl-wrap\" ng-class=\"{\'b-success\': (model.version == item.version)}\"><span class=\"tl-date\">{{item.dataIn | date : format : timezone}}</span><div class=\"tl-content panel padder b-a\" ng-class=\"{\'bg-success\': (model.version == item.version)}\"><span class=\"arrow left pull-up hidden-left\" ng-class=\"{\'arrow-success\': (model.version == item.version)}\"></span> <span class=\"arrow right pull-up visible-left\" ng-class=\"{\'arrow-success\': (model.version == item.version)}\"></span><div class=\"text-lt m-b-sm\"><a ng-click=\"getModelDetail(item.version)\">{{item.model.code}}</a></div><div class=\"panel-body pull-in b-t b-light\"><span class=\"pull-right label\" ng-class=\"{\'bg-success\': (model.version == item.version), \'bg-info\': (model.version != item.version)}\">{{item.user}}</span></div><div class=\"panel-body pull-in b-t b-light\">{{item.model.description}}</div></div></div></li><li class=\"tl-header\"><div class=\"btn btn-sm btn-default btn-rounded\">INIZIO</div></li></ul></div></div><div class=\"col wrapper bg-white\" ng-if=\"showDetail\"><div class=\"panel-body pull-in b-t b-light\">Tree path: <span ng-if=\"!treePaths\">Nessuno</span> <span ng-repeat=\"(treeCode, path) in treePaths\"><span ng-repeat=\"p in path\"><span class=\"badge bg-info\">{{p}}</span> /</span></span></div><div sf-schema=\"schema\" sf-form=\"form\" sf-model=\"data.model\"></div></div></div>");
$templateCache.put("dataset/tree/recorddetails.html","<div class=\"panel-body form-group\"><div ng-if=\"!record.type\" style=\"text-align: center\"><a class=\"btn btn-sm btn-default pull-right\" ng-click=\"toggleDetails()\"><i class=\"fa fa-angle-double-right text-danger-dker\"></i></a> Nessun nodo selezionato</div><div ng-if=\"record.type && !record.loaded\" style=\"text-align: center\"><i class=\"fa fa-spinner fa-2x fa-pulse fa-fw text-info-dker\" aria-hidden=\"true\"></i></div><div ng-if=\"typeDescription != \'Configurazione\' && record.type && record.loaded\"><form name=\"detailForm\" class=\"ng-pristine ng-valid\" ng-submit=\"onSubmitDetailForm(detailForm)\" ng-if=\"record\"><div class=\"panel\"><div class=\"clear m-b-xs\"><div class=\"pull-right\"><button ng-click=\"goToAsset(record)\" class=\"btn btn-sm btn-info m-r\"><i class=\"glyphicon glyphicon-list-alt\"></i> Anagrafica Nodo</button> <button type=\"submit\" class=\"btn btn-sm btn-success m-r\" id=\"btn_create_entity\" ng-disabled=\"isWriteRecordPermAllowed()===false\"><i class=\"glyphicon glyphicon-save\"></i> Salva</button> <a class=\"btn btn-sm btn-default\" id=\"btn_expand\" ng-click=\"toggleRightSidebarSize()\" title=\"Ridimensiona\"><i class=\"fa\" ng-class=\"{\'fa-expand\': rightSidebarSize==\'50\', \'fa-compress\': rightSidebarSize==\'100\'}\"></i></a> <a class=\"btn btn-sm btn-default\" id=\"btn_close\" ng-click=\"toggleDetails()\" title=\"Chiudi\"><i class=\"fa fa-angle-double-right text-danger-dker\"></i></a></div><div class=\"pull-left\"><h1 class=\"font-thin h3 text-black\">{{typeDescription}}</h1><small class=\"text-muted\"><span ng-repeat=\"p in record.wrapper.parents\">{{p.code}}<span class=\"m-r-xs m-l-xs\">/</span></span></small></div></div><div class=\"row\"><div class=\"col-sm-6\"><label>Inizio validità:</label> <input type=\"datetime-local\" disabled=\"true\" placeholder=\"-\" class=\"input-sm form-control\" ng-model=\"record.wrapper.dataIn\"></div><div class=\"col-sm-6\"><label>Fine validità:</label> <input type=\"datetime-local\" disabled=\"true\" placeholder=\"-\" class=\"input-sm form-control\" ng-model=\"record.wrapper.dataOut\"></div></div><div class=\"form-group m-t-md\"><div sf-schema=\"record.schema\" sf-form=\"record.form\" sf-model=\"record.model\" class=\"pull-left col-md-12\"></div></div></div></form></div><div ng-if=\"typeDescription == \'Configurazione\' && record.type && record.loaded\"><div ng-controller=\"TreeplanconfigCtrl\" data-ng-include=\"\'dataset/tree/treeplanconfig.html\'\"></div></div></div>");
$templateCache.put("dataset/tree/recordlist.html","<script type=\"text/ng-template\" id=\"records_renderer.html\"><div class=\"tree-node\" ng-click=\"toggleRecordSelection(node)\" ng-class=\"{\'node_selected\': isRecordSelected(node)}\"> <div class=\"tree-node-content\"> <div class=\"pull-left model-icon\" ui-tree-handle> <span class=\"text-info-dker pull-right m-l-xs m-r-xs model-icon\" title=\"{{node.type}}\" data-placement=\"right\" data-original-title=\"{{node.type}}\" tooltip><i ng-class=\"getModelIcon(node.type)\"></i></span> </div> <div> <span>{{node | reference}}</span> </div> </div> </div></script><div class=\"panel-body form-group\"><form class=\"ng-pristine ng-valid\"><div class=\"clear m-b\"><a class=\"btn btn-xs btn-default pull-left\" id=\"btn_close\" ng-click=\"toggleRecordsList()\" title=\"Chiudi\" data-placement=\"bottom\"><i class=\"fa fa-angle-double-left text-danger-dker\"></i></a> <a class=\"btn btn-xs btn-danger pull-right\" ng-click=\"unselectAllFromRecordsList()\"><i class=\"fa fa-square-o\"></i> Desel. tutto</a> <a class=\"btn btn-xs btn-success m-r-xs pull-right\" ng-click=\"selectAllFromRecordsList()\"><i class=\"fa fa-check-square-o\"></i> Sel. tutto</a></div><div class=\"form-group\"><six-lookup-2 ng-model=\"searchInput\" sx-field=\"\'type\'\" sx-id=\"issue-schema\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" sx-title=\"\'Tipo asset\'\" sx-compact=\"true\" sx-item-template=\"\'{{item.description}}\'\" sx-show-details=\"false\" sx-show-filters=\"false\" sx-page-size=\"10000\" sx-on-select=\"searchList()\"></six-lookup-2><six-search-form ng-model=\"searchInput.text\" placeholder=\"Cerca...\" search-fn=\"searchList()\" keyup-fn=\"$event.key == \'Enter\' && searchList()\" clear-fn=\"searchList()\" show-search-btn=\"true\"></six-search-form></div><div ng-if=\"!records.loaded\" style=\"text-align: center\"><i class=\"fa fa-spinner fa-2x fa-pulse fa-fw text-info-dker\" aria-hidden=\"true\"></i></div><div ui-tree=\"recordsOptions\" id=\"tree2-root\" ng-if=\"records.loaded\"><ol ui-tree-nodes=\"\" ng-model=\"records.list\" id=\"records\"><li ng-repeat=\"node in records.list track by $index\" ui-tree-node=\"\" ng-include=\"\'records_renderer.html\'\"></li></ol></div></form></div>");
$templateCache.put("dataset/tree/toolbar.html","<six-toolbar><six-toolbar-item label=\"Lista\" icon=\"fa fa-dedent icon text-info-dker\" icon-disabled=\"fa fa-fw fa-indent text-muted\" toolbar-function=\"toggleRecordsList()\" icon-condition=\"!showRecordsList\"></six-toolbar-item><six-toolbar-item label=\"Dettagli\" icon=\"fa fa-fw fa-edit icon text-info-dker\" icon-disabled=\"fa fa-fw fa-edit icon text-muted\" toolbar-function=\"toggleDetails()\" icon-condition=\"!showDetails\"></six-toolbar-item><six-toolbar-item ng-show=\"showExpandAllButton()\" label=\"Espandi tutto\" label-disabled=\"Comprimi tutto\" label-condition=\"!treeCollapsed\" icon=\"fa fa-fw fa-plus-square icon text-info-dker\" icon-disabled=\"fa fa-fw fa-minus-square icon text-info-dker\" toolbar-function=\"toggleAll()\" icon-condition=\"!treeCollapsed\"></six-toolbar-item><six-toolbar-item label=\"Home\" icon=\"glyphicon glyphicon-home icon text-success-dker\" toolbar-function=\"selectNode(undefined)\"></six-toolbar-item><six-toolbar-item label=\"Nodo\" icon=\"glyphicon glyphicon-leaf icon text-primary-dker\" sx-disabled=\"isWritePermAllowed()===false\"><li ng-show=\"!dropdownList.nodes.length\"><span class=\"m-sm\">Nessun nodo disp.</span></li><li ng-repeat=\"entity in dropdownList.nodes\"><a href=\"\" ng-click=\"getRecordDetail(false, entity.model.code)\">{{entity.model.description}}</a></li></six-toolbar-item><six-toolbar-item label=\"Root\" icon=\"glyphicon glyphicon-certificate icon text-info-dker\" sx-disabled=\"isWritePermAllowed()===false\"><li ng-show=\"!dropdownList.roots.length\"><span class=\"m-sm\">Nessun nodo disp.</span></li><li ng-repeat=\"entity in dropdownList.roots\"><a href=\"\" ng-click=\"getRecordDetail(true, entity.model.code)\">{{entity.model.description}}</a></li></six-toolbar-item><six-toolbar-item label=\"Aggiungi\" icon=\"fa fa-plus-circle text-warning-dker\" toolbar-function=\"addNodesToParent(selected.treeNode, selected.records)\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-item><six-toolbar-item label=\"Copia\" icon=\"fa fa-plus-circle text-primary-dker\" toolbar-function=\"checkNodeToDestination(selected.treeNode)\" sx-disabled=\"isWritePermAllowed()===false || !isCopyConfPermAllowed(selected.treeNode)\"></six-toolbar-item><input type=\"date\" ng-model=\"date.currentDate\" ng-change=\"changeCurrentDate(date.currentDate, false)\" class=\"input-sm bg-light no-border rounded padder six-toolbar-button inline m-sm text-left stb-content\" style=\"float: left\"><six-toolbar-button label=\"\" icon=\"fa fa-refresh text-info-dker\" toolbar-function=\"getTree()\"></six-toolbar-button><six-toolbar-button ng-if=\"showIndexRecordsButton()\" label=\"Converti\" icon=\"fa fa-exchange text-info-dker\" toolbar-function=\"recordsIndexing()\"></six-toolbar-button></six-toolbar>");
$templateCache.put("dataset/tree/tree.html","<style type=\"text/css\">\n  .custom-sidebar {\n    top: 100px;\n    z-index: 1031;\n    padding-bottom: 70px;\n  }\n  .override-top-sidebar {\n    top: 100px;\n  }\n  .floating-btn {\n    z-index: 999;\n  }\n  .floating-btn a {\n    color: #58666e;\n    background-color: #fff;\n  }\n  .node_withClosedChild {\n    color: #df8000 !important;\n  }\n  .node_closedCalendar {\n    color: red !important;\n  }\n</style><div ng-include=\"\'dataset/tree/toolbar.html\'\"></div><nav class=\"floating-btn\" mfb-menu=\"\" position=\"bl\" effect=\"zoomin\" label=\"Pannelli\" active-icon=\"fa fa-chevron-up\" resting-icon=\"fa fa-columns\" toggling-method=\"hover\"><button mfb-button=\"\" icon=\"fa fa-indent\" label=\"Nodi disponibili\" ng-click=\"toggleRecordsList()\"></button> <button mfb-button=\"\" icon=\"fa fa-edit\" label=\"Dettagli nodo\" ng-click=\"toggleDetails()\"></button></nav><six-sidebar sx-class=\"override-top-sidebar\" sx-id=\"records_sidebar\" sx-position=\"left\" sx-title=\"\'Nodi disponibili\'\" sx-dimension=\"l\" sx-opened=\"showRecordsList\" sx-pinned=\"true\" sx-show-title=\"false\"><div ng-include=\"\'dataset/tree/recordlist.html\'\"></div></six-sidebar><six-sidebar sx-class=\"override-top-sidebar\" sx-id=\"details_sidebar\" sx-position=\"right\" sx-title=\"\'Dettagli\'\" sx-dimension=\"{{rightSidebarSize}}\" sx-opened=\"showDetails\" sx-pinned=\"false\" sx-show-title=\"false\"><div ng-include=\"\'dataset/tree/recorddetails.html\'\"></div></six-sidebar><div class=\"constructor\"><div class=\"hbox hbox-auto-xs hbox-auto-sm override-padding-50-px\"><div class=\"wrapper\"><div class=\"panel panel-default\"><div ng-if=\"viewMode != \'grid\'\" ng-include=\"\'dataset/tree/treenode.html\'\"></div><div ng-if=\"viewMode == \'grid\'\" ng-include=\"\'dataset/tree/treegrid.html\'\"></div></div></div></div><div class=\"panel panel-default panel-body\" ng-if=\"true\"><div class=\"wrapper\"><div class=\"row form-group\"><input id=\"jsonShowCheck\" type=\"checkbox\" ng-model=\"jsonshow\" class=\"pull-left\"> <label for=\"jsonShowCheck\" class=\"pull-left control-label\">Dettaglio avanzato</label></div><div class=\"row\" ng-show=\"jsonshow\"><div class=\"list-group list-group-lg list-group-sp\"><pre>{{ tree.wrapper | json }}</pre></div></div></div></div></div>");
$templateCache.put("dataset/tree/treeconfigurator.html","<style>\n    .panel-tree{\n        margin-bottom: 0px;\n    }\n    .override-top-sidebar {\n      top: 100px;\n    }\n</style><script type=\"text/ng-template\" id=\"tree_renderer.html\"><div class=\"tree-node\" ng-click=\"selectNode(node)\" ng-class=\"{\'node_selected\': isNodeSelected(node)}\"> <div class=\"tree-node-content\"> <div class=\"pull-left model-icon\" style=\"width: 26px;\" ui-tree-handle> <span class=\"text-info-dker pull-right m-l-xs m-r-xs model-icon\" title=\"{{node.model.code}}\" data-placement=\"left\" data-original-title=\"{{node.model.code}}\" tooltip><i ng-class=\"getModelIcon(node.model.code)\"></i></span> </div> <div> <a class=\"btn btn-xs btn-default\" ng-click=\"toggleNode(this)\" ng-if=\"node.nodes.length>0\"> <span class=\"fa\" ng-class=\"{\'fa-plus\': collapsed, \'fa-minus\': !collapsed}\"></span> </a> {{node.model.description}} ({{node.model.code}}) <span class=\"pull-right btn btn-xs\" ng-confirm-message=\"Eliminare il nodo?\" ng-confirm-click=\"removeTreeNode(this)\" ng-confirm-condition=true ng-if=\"isWritePermAllowed()===true\"><i class=\"fa fa-times text-danger-dker remove-tree-btn\"></i></span> </div> </div> </div> <ol ui-tree-nodes=\"\" ng-model=\"node.nodes\" ng-class=\"{hidden: collapsed}\"> <li ng-repeat=\"node in node.nodes\" ui-tree-node ng-include=\"\'tree_renderer.html\'\" ng-show=\"isNodeVisible(node)\" /> </ol></script><script type=\"text/ng-template\" id=\"entities_renderer.html\"><div class=\"tree-node\" ng-click=\"toggleEntitySelection(node)\" ng-class=\"{\'node_selected\': isEntitySelected(node)}\"> <div class=\"tree-node-content\"> <div class=\"pull-left model-icon\" ui-tree-handle> <span class=\"text-info-dker pull-right m-l-xs m-r-xs model-icon\" title=\"{{node.model.code}}\" data-placement=\"right\" data-original-title=\"{{node.model.code}}\" tooltip><i ng-class=\"getModelIcon(node.model.code)\"></i></span> </div> <div> <span>{{node.model.description}} ({{node.model.code}})</span> </div> </div> </div></script><six-toolbar><six-toolbar-item label=\"Lista\" icon=\"fa fa-dedent icon text-info-dker\" icon-disabled=\"fa fa-fw fa-indent text-muted\" toolbar-function=\"toggleEntitiesList()\" icon-condition=\"!showEntitiesList\"></six-toolbar-item><six-toolbar-item label=\"Espandi tutto\" label-disabled=\"Comprimi tutto\" label-condition=\"!treeCollapsed\" icon=\"fa fa-fw fa-plus-square icon text-info-dker\" icon-disabled=\"fa fa-fw fa-minus-square icon text-info-dker\" toolbar-function=\"toggleAll()\" icon-condition=\"!treeCollapsed\"></six-toolbar-item><six-toolbar-item label=\"Aggiungi\" icon=\"fa fa-plus-circle text-warning-dker\" toolbar-function=\"addNodesToParent(selected.treeNode, selected.entities)\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-item><six-toolbar-item icon=\"fa fa-exclamation text-danger-dker\" label=\"Selezionare un cliente per abilitare il salvataggio\" ng-show=\"isCustomerMissing()\"></six-toolbar-item><six-toolbar-item label=\"{{currentCustomer.description}}\" ng-hide=\"isCustomerMissing()\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"saveForm()\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button></six-toolbar><six-sidebar sx-class=\"override-top-sidebar\" sx-id=\"entities_sidebar\" sx-position=\"left\" sx-title=\"\'Nodi disponibili\'\" sx-dimension=\"l\" sx-opened=\"showEntitiesList\" sx-pinned=\"true\" sx-show-title=\"false\"><div class=\"panel-body form-group\"><form class=\"ng-pristine ng-valid\"><div class=\"clear m-b\"><a class=\"btn btn-xs btn-default pull-left\" id=\"btn_close\" ng-click=\"toggleEntitiesList()\" title=\"Chiudi\" data-placement=\"bottom\"><i class=\"fa fa-angle-double-left text-danger-dker\"></i></a> <a class=\"btn btn-xs btn-danger pull-right\" ng-click=\"unselectAllFromEntitiesList()\"><i class=\"fa fa-square-o\"></i> Desel. tutto</a> <a class=\"btn btn-xs btn-success m-r-xs pull-right\" ng-click=\"selectAllFromEntitiesList()\"><i class=\"fa fa-check-square-o\"></i> Sel. tutto</a></div><div class=\"form-group\"><six-search-form ng-model=\"searchInput.text\" placeholder=\"Cerca...\" show-search-btn=\"false\"></six-search-form></div><div ng-if=\"!entities.loaded\" style=\"text-align: center\"><i class=\"fa fa-spinner fa-2x fa-pulse fa-fw text-info-dker\" aria-hidden=\"true\"></i></div><div ui-tree=\"entitiesOptions\" id=\"tree2-root\" ng-if=\"entities.loaded\" data-nodrop-enabled=\"true\" data-clone-enabled=\"true\"><ol ui-tree-nodes=\"\" ng-model=\"entities.list\" id=\"entities\"><li ng-repeat=\"node in entities.list\" ui-tree-node=\"\" ng-include=\"\'entities_renderer.html\'\" ng-show=\"isEntityVisible(node)\"></li></ol></div></form></div></six-sidebar><div class=\"constructor\"><div class=\"hbox hbox-auto-xs hbox-auto-sm override-padding-30-px\"><div class=\"wrapper\"><h3 class=\"font-thin\">Albero</h3><div class=\"panel panel-default\"><div class=\"panel-body form-group\"><div class=\"form-group m-t-xs\"><six-search-form ng-model=\"searchInputInTree.text\" placeholder=\"Cerca...\" show-search-btn=\"false\"></six-search-form></div><div ng-if=\"!tree.loaded\" style=\"text-align: center\"><i class=\"fa fa-spinner fa-2x fa-pulse fa-fw text-info-dker\" aria-hidden=\"true\"></i></div><div ui-tree=\"treeOptions\" id=\"tree1-root\" ng-if=\"tree.loaded\"><ol ui-tree-nodes=\"\" ng-model=\"tree.wrapper.model.nodes\" id=\"tree\"><li ng-repeat=\"node in tree.wrapper.model.nodes\" ui-tree-node=\"\" ng-include=\"\'tree_renderer.html\'\" ng-show=\"isNodeVisible(node)\"></li></ol></div></div></div></div></div></div>");
$templateCache.put("dataset/tree/treegrid.html","<div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"col-sm-12 m-t\"><six-grid-pagination sx-id=\"treetable_grid\" get-data-callback=\"getNodesList()\" get-list-callback=\"getNodesList()\" items-list=\"nodeList\" grid-options=\"viewGridOptions\" column-defs=\"viewGridOptions.columnDefs\" auto-resize-params=\"autoResizeParams\" params=\"params\" show-global-search=\"false\" enable-state-saving=\"true\"></six-grid-pagination></div></div></div></div>");
$templateCache.put("dataset/tree/treenode.html","<script type=\"text/ng-template\" id=\"tree_renderer.html\"><div class=\"tree-node\" ng-click=\"selectNode(node)\" ng-class=\"{\'node_selected\': isNodeSelected(node), \'node_closedCalendar\': isNodeWithClosedCalendar(node), \'node_withClosedChild\': isNodeWithClosedChild(node) }\"> <div class=\"tree-node-content\"> <div class=\"pull-left model-icon\" style=\"width: 26px;\" ui-tree-handle> <span class=\"text-info-dker pull-right m-l-xs m-r-xs model-icon\" title=\"{{node.type}}\" data-placement=\"left\" data-original-title=\"{{node.type}}\" tooltip><i ng-class=\"getModelIcon(node.type)\"></i></span> </div> <div> <a class=\"btn btn-xs btn-default\" data-nodrag ng-click=\"toggleNode(this)\" ng-if=\"node.hasChilds || node.nodes.length>0\"> <span class=\"fa\" ng-class=\"{\'fa-plus\': collapsed, \'fa-minus\': !collapsed}\"></span> </a> {{node.type}} - {{node | reference}} <span class=\"pull-right btn btn-xs\" data-nodrag ng-confirm-message=\"Eliminare il nodo?\" ng-confirm-click=\"removeTreeNode(this)\" ng-confirm-condition=true ng-if=\"isWritePermAllowed()===true\"><i class=\"fa fa-times text-danger-dker remove-tree-btn\"></i></span> <span class=\"pull-right badge\" style=\"margin-top: 2px\" ng-if=\"node.childCount\">{{node.childCount}}</span> </div> </div> </div> <ol ui-tree-nodes=\"\" ng-model=\"node.nodes\" ng-class=\"{hidden: collapsed}\"> <li ng-repeat=\"node in node.nodes track by node.UUID\" ui-tree-node data-expand-on-hover=\"1000\" ng-include=\"\'tree_renderer.html\'\" /> </ol></script><div class=\"panel-body\"><div class=\"row m-t-xs m-b\"><div class=\"pull-right\" style=\"padding-right: 15px; padding-left: 15px;\"><div class=\"form-group form-inline\" ng-class=\"{\'has-error\': searchInputInTree.depth==undefined}\"><label for=\"depth\" class=\"m-r-xs\">Profondità:</label> <input type=\"number\" id=\"depth\" class=\"form-control\" ng-model=\"searchInputInTree.depth\" min=\"1\" style=\"width: 70px; cursor: help;\" tooltip=\"\" data-placement=\"bottom\" data-html=\"true\" title=\"<div style=\'text-align: left\'>Profondità del tree:<br>0 = radice<br>>0 = livelli successivi</div>\"></div></div><div class=\"pull-right\" style=\"padding-right: 15px; padding-left: 15px;\"><div class=\"form-group form-inline m-t-xs\"><label class=\"checkbox i-checks m-b inline col-md-12 text-right\" tooltip=\"\" data-placement=\"bottom\" title=\"Evidenzia asset chiusi da calendario.\"><input type=\"checkbox\" ng-model=\"calendar.show\" ng-change=\"loadCalendars()\"><i></i> <span class=\"i-checks\">Evidenzia chiusure</span></label></div></div><div style=\"margin-right: 360px; padding-right: 15px; padding-left: 15px;\"><six-search-form ng-model=\"searchInputInTree.text\" placeholder=\"Filtra... (almeno 3 caratteri)\" search-fn=\"searchInTree()\" keyup-fn=\"$event.key == \'Enter\' && searchInTree()\" clear-fn=\"searchInTree()\" show-search-btn=\"true\" is-valid=\"!searchInputInTree.text || searchInputInTree.text.length >= 3\"></six-search-form></div></div><div ng-if=\"!tree.loaded\" style=\"text-align: center\"><i class=\"fa fa-spinner fa-2x fa-pulse fa-fw text-info-dker\" aria-hidden=\"true\"></i></div><div ui-tree=\"treeOptions\" id=\"tree1-root\" ng-if=\"tree.loaded\" data-nodrop-enabled=\"\"><ol ui-tree-nodes=\"\" ng-model=\"tree.wrapper.nodes\" id=\"tree\"><li ng-repeat=\"node in tree.wrapper.nodes track by node.UUID\" ui-tree-node=\"\" data-expand-on-hover=\"1000\" ng-include=\"\'tree_renderer.html\'\"></li></ol></div></div>");
$templateCache.put("dataset/tree/treeplanconfig.html","<div class=\"white\"><div class=\"panel wrapper\"><div class=\"panel-header pad-l-r-10 pull-right m-b-xl\"><button type=\"submit\" class=\"btn btn-sm btn-success m-r\" id=\"btn_create_entity\" ng-click=\"save()\"><i class=\"glyphicon glyphicon-save\"></i> Salva</button> <a class=\"btn btn-sm btn-default\" ng-click=\"toggleTimeline()\" title=\"Timeline\"><i class=\"fa fa-history\"></i></a> <a class=\"btn btn-sm btn-default\" id=\"btn_expand\" ng-click=\"toggleRightSidebarSize()\" title=\"Ridimensiona\"><i class=\"fa\" ng-class=\"{\'fa-expand\': rightSidebarSize==\'50\', \'fa-compress\': rightSidebarSize==\'100\'}\"></i></a> <a class=\"btn btn-sm btn-default\" id=\"btn_close\" ng-click=\"toggleDetails()\" title=\"Chiudi\"><i class=\"fa fa-angle-double-right text-danger-dker\"></i></a></div><span class=\"pull-left\"><h1 class=\"m-n font-thin h3 text-black\">Configurazione</h1><small class=\"text-muted\"><span ng-repeat=\"p in selected.parents\">{{p.code}}<span class=\"m-r-xs m-l-xs\">/</span></span></small></span><div class=\"col-md-12 m-b m-l-none m-t-n-md row\"><div class=\"row\"><div class=\"col-sm-6\"><label>Inizio validità:</label> <input type=\"datetime-local\" ng-disabled=\"!isWriteVersionAllowed() || isNew()\" placeholder=\"-\" class=\"input-sm form-control\" ng-model=\"selected.dataIn\"></div><div class=\"col-sm-6\"><label>Fine validità:</label> <input type=\"datetime-local\" ng-disabled=\"!isWriteVersionAllowed() || isNew()\" placeholder=\"-\" class=\"input-sm form-control\" ng-model=\"selected.dataOut\"></div></div></div><div class=\"panel-body no-pad-l-r override-padding-30-px\"><div class=\"col-md-12\"><uib-tabset active=\"active\"><uib-tab heading=\"Profilazione assegnatari\"><ng-include src=\"\'dataset/tree/treeplanconfig_assignee_row.html\'\"></ng-include></uib-tab><uib-tab heading=\"Valori default\"><ng-include src=\"\'dataset/tree/treeplanconfig_default_row.html\'\"></ng-include></uib-tab><uib-tab heading=\"Contatti responsabili\"><ng-include src=\"\'dataset/tree/treeplanconfig_responsable_row.html\'\"></ng-include></uib-tab><uib-tab heading=\"Watchers\"><ng-include src=\"\'dataset/tree/treeplanconfig_watchers.html\'\"></ng-include></uib-tab><uib-tab heading=\"Fatturazione\"><ng-include src=\"\'dataset/tree/treeplanconfig_invoicing.html\'\"></ng-include></uib-tab></uib-tabset></div></div><six-sidebar sx-id=\"timeline_sidebar\" sx-position=\"left\" sx-title=\"\'Timeline\'\" sx-dimension=\"xl\" sx-opened=\"timelineFlags.showTimeline\" sx-pinned=\"false\" style=\"transform: rotate(0); position: fixed; top: -50px; left: -200px; z-index: 10;\"><div class=\"col-md-12 col-sm-12\" id=\"timelineRow\"><input type=\"date\" ng-model=\"date.currentDate\" class=\"form-control input-sm bg-light no-border rounded padder\" disabled=\"\"></div><div class=\"clearfix\"></div><div ng-controller=\"TreePlanConfigTimelineCtrl\" ng-init=\"buildTimeline(selected.UUID, selected.version)\" ng-if=\"timelineFlags.showTimeline\" id=\"timeline_section\"><div class=\"wrapper\"><ul class=\"timeline timeline-center\"><li class=\"tl-header\"><div class=\"btn btn-sm btn-default btn-rounded\">FINE</div></li><li ng-repeat=\"item in timeline\" class=\"tl-item\" ng-class-odd=\"\'tl-left\'\"><div class=\"tl-wrap\" ng-class=\"{\'b-success\': (selected.version == item.version)}\"><span class=\"tl-date\">{{item.dataIn | date : format : timezone}}<br></span> <span class=\"tl-date-2\" ng-if=\"isWriteVersionAllowed()\">{{item.dataIn | date: \'dd/MM/yyyy HH:mm:ss\'}} <i class=\"tl-icon fa fa-caret-up fa-xs\"></i><br><span ng-if=\"item.dataOut\">{{item.dataOut | date: \'dd/MM/yyyy HH:mm:ss\'}}</span><span ng-if=\"!item.dataOut\"><i class=\"fa fa-ban fa-xs\"></i></span> <i class=\"tl-icon fa fa-caret-down fa-xs\"></i><div ng-if=\"isWriteVersionAllowed() && selected.version == item.version\"><a class=\"btn btn-xs btn-success\" ng-click=\"overwriteDocument()\" title=\"Sovrascrivi versione\"><i class=\"fa fa-save\"></i></a> <a class=\"btn btn-xs btn-danger\" ng-click=\"openDeleteVersionDialog()\" title=\"Elimina versione\"><i class=\"fa fa-trash\"></i></a></div></span><div class=\"tl-content panel padder b-a\" ng-class=\"{\'bg-success\': (selected.version == item.version)}\"><span class=\"arrow left pull-up hidden-left\" ng-class=\"{\'arrow-success\': (selected.version == item.version)}\"></span> <span class=\"arrow right pull-up visible-left\" ng-class=\"{\'arrow-success\': (selected.version == item.version)}\"></span> <a class=\"text-lt m-b-sm\" ng-click=\"openDetail(item.UUID, item.version)\">{{item.model.code}}</a><div class=\"panel-body pull-in b-t b-light\"><span class=\"pull-right label\" ng-class=\"{\'bg-success\': (selected.version == item.version), \'bg-info\': (selected.version != item.version)}\">{{item.user}}</span></div><div class=\"panel-body pull-in b-t b-light\">{{item.model.description}}</div><div class=\"panel-body pull-in b-t b-light\" ng-if=\"isWriteVersionAllowed()\">Version: {{item.version}}</div></div></div></li><li class=\"tl-header\"><div class=\"btn btn-sm btn-default btn-rounded\">INIZIO</div></li></ul></div></div></six-sidebar></div></div><script type=\"text/ng-template\" id=\"recordDelete.html\"><strong><span class=\"ngdialog-icon\"></span></strong> <div style=\"text-align: center;\"><h4 class=\"m-t-none m-b font-bold\">ATTENZIONE</h4></div> <div class=\"row m-t m-l m-r\"> <table align=\"center\" style=\"text-align: left; width: 100%\"> <caption style=\"text-align: center; font-weight: bold\" ng-if=\"lang!=\'html\'\">{{deleteMessage}}</caption> <caption style=\"text-align: center; font-weight: bold\" ng-if=\"lang==\'html\'\" ng-bind-html=\"deleteMessage\"></caption> <tr> <td style=\"text-align: center;\"> <button type=\"button\" class=\"btn btn-default\" ng-click=\"deleteFunction()\">Si</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"notDeleteFunction()\">No</button> </td> </tr> </table> </div></script>");
$templateCache.put("dataset/tree/treeplanconfig_assignee_row.html","<style type=\"text/css\">\n  table.treeplanconfig_table_ass {\n    width: 100%;\n  }\n\n  .treeplanconfig_table_ass th {\n    font-weight: bold;\n  }\n\n  .treeplanconfig_table_ass td, .treeplanconfig_table_ass th {\n    width: 13%;\n    padding: 0 2px 0 2px;\n  }\n\n  .treeplanconfig_table_ass td.record {\n    width: 34%;\n  }\n\n  .treeplanconfig_table_ass tr {\n    border-bottom: 1px solid #ddd;\n  }\n\n  .treeplanconfig_table_ass td.tools, .treeplanconfig_table_ass th.tools {\n    width: 70px;\n    overflow: hidden;\n    display: inline-block;\n    white-space: nowrap;\n    text-align: right;\n    padding: 0 2px 0 2px;\n  }\n\n  .placeholder_style {\n    width: 100%;\n    padding-left: 10px;\n  }\n</style><table class=\"treeplanconfig_table_ass\"><thead><tr><th>Servizio</th><th>Asset</th><th>Tipo profilaz.</th><th>Azienda</th><th>Tipo operatore</th><th>Record profilaz.</th><th class=\"tools\"><a class=\"btn pull-right\" ng-click=\"newAssignee=true\"><i class=\"fa fa-plus-circle\"></i></a></th></tr></thead><tbody><tr ng-repeat=\"assigneeRow in selected.model.configuration.assignee\"><td><six-lookup-2 sx-base-path=\"\'record\'\" ng-model=\"assigneeRow\" sx-field=\"\'service_id\'\" sx-type=\"\'servizio\'\" sx-compact=\"true\" sx-disabled=\"crossService\" ng-if=\"assigneeRow.edit\"></six-lookup-2><div ng-if=\"!assigneeRow.edit\"><span>{{assigneeRow.service_id.description}}</span></div></td><td><six-lookup-2 sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" ng-model=\"assigneeRow\" sx-field=\"\'type_id\'\" sx-disabled=\"crossType\" sx-item-template=\"\'{{item.description}}\'\" sx-page-size=\"10000\" sx-compact=\"true\" ng-if=\"assigneeRow.edit\"></six-lookup-2><div ng-if=\"!assigneeRow.edit\"><span>{{assigneeRow.type_id.description}}</span></div></td><td><six-lookup-2 ng-model=\"assigneeRow\" sx-base-path=\"\'schema\'\" sx-field=\"\'typeprofiling_id\'\" sx-filter=\"typeProfilingFilter\" sx-compact=\"true\" sx-page-size=\"10000\" sx-item-template=\"\'{{item.description}}\'\" ng-if=\"assigneeRow.edit\"></six-lookup-2><div ng-if=\"!assigneeRow.edit\"><span>{{assigneeRow.typeprofiling_id.description}}</span></div></td><td><div ng-if=\"assigneeRow.edit\"><six-lookup-2 sx-base-path=\"\'record\'\" ng-model=\"assigneeRow\" sx-type=\"\'azienda\'\" sx-field=\"\'company_id\'\" sx-compact=\"true\" ng-if=\"assigneeRow.typeprofiling_id.code!=\'azienda\'\"></six-lookup-2><div class=\"placeholder_style\" ng-if=\"assigneeRow.typeprofiling_id.code==\'azienda\'\">-</div></div><div ng-if=\"!assigneeRow.edit\"><span>{{assigneeRow.company_id.description}}</span></div></td><td><div ng-if=\"assigneeRow.edit\"><six-select-2 sx-id=\"operatorType\" ng-model=\"assigneeRow\" sx-field=\"\'typeprofiling_filter\'\" sx-list=\"availableTypeOperatorList\" sx-item-template=\"\'{{item.description}}\'\" sx-compact=\"true\" sx-multiple=\"false\" ng-if=\"assigneeRow.typeprofiling_id.code==\'operatore\'\"></six-select-2><div class=\"placeholder_style\" ng-if=\"assigneeRow.typeprofiling_id.code!=\'operatore\'\">-</div></div><div ng-if=\"!assigneeRow.edit\"><span>{{assigneeRow.typeprofiling_filter.description}}</span></div></td><td class=\"record\"><six-lookup-2 sx-base-path=\"\'record\'\" ng-model=\"assigneeRow\" sx-type=\"assigneeRow.typeprofiling_id.code\" sx-field=\"\'assignee_id\'\" sx-compact=\"true\" sx-filter=\"assigneeRow.typeprofiling_filter.filters\" sx-multiple=\"true\" ng-if=\"assigneeRow.edit\"></six-lookup-2><div ng-if=\"!assigneeRow.edit\"><span ng-repeat=\"a in assigneeRow.assignee_id track by $index\" ng-if=\"assigneeRow.assignee_id.length\">{{a.description}} ;</span> <span ng-if=\"!assigneeRow.assignee_id.length\">{{assigneeRow.assignee_id.description}}</span></div></td><td class=\"tools\"><a class=\"btn pull-right\" ng-click=\"deleteAssignee(assigneeRow)\" ng-if=\"!assigneeRow.edit\"><i class=\"fa fa-trash-o\"></i></a> <a class=\"btn pull-right\" ng-click=\"restoreHistory(assigneeRow)\" ng-if=\"assigneeRow.edit\"><i class=\"fa fa-history\"></i></a> <a class=\"btn\" ng-click=\"editRow(assigneeRow)\" ng-if=\"!assigneeRow.edit\"><i class=\"fa fa-pencil-square-o\"></i></a> <a class=\"btn\" ng-click=\"confirmRow(assigneeRow)\" ng-if=\"assigneeRow.edit\"><i class=\"fa fa-check-circle\"></i></a></td></tr><tr ng-show=\"newAssignee==true\"><td><six-lookup-2 sx-base-path=\"\'record\'\" ng-model=\"insertNewRowAssignee\" sx-field=\"\'service_id\'\" sx-type=\"\'servizio\'\" sx-compact=\"true\" sx-disabled=\"crossService\"></six-lookup-2></td><td><six-lookup-2 sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" ng-model=\"insertNewRowAssignee\" sx-field=\"\'type_id\'\" sx-disabled=\"crossType\" sx-item-template=\"\'{{item.description}}\'\" sx-page-size=\"10000\" sx-compact=\"true\"></six-lookup-2></td><td><six-lookup-2 ng-model=\"insertNewRowAssignee\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" sx-field=\"\'typeprofiling_id\'\" sx-filter=\"typeProfilingFilterAssignee\" sx-compact=\"true\" sx-page-size=\"10000\" sx-item-template=\"\'{{item.description}}\'\"></six-lookup-2></td><td><six-lookup-2 sx-base-path=\"\'record\'\" ng-model=\"insertNewRowAssignee\" sx-type=\"\'azienda\'\" sx-field=\"\'company_id\'\" sx-compact=\"true\" ng-if=\"showCompanyLookup(insertNewRowAssignee)\" sx-on-select=\"buildRecordFilter(insertNewRowAssignee)\"></six-lookup-2><div class=\"placeholder_style\" ng-if=\"!showCompanyLookup(insertNewRowAssignee)\">-</div></td><td><six-select-2 sx-id=\"operatorType\" ng-model=\"insertNewRowAssignee\" sx-field=\"\'typeprofiling_filter\'\" sx-list=\"availableTypeOperatorList\" sx-item-template=\"\'{{item.description}}\'\" sx-compact=\"true\" sx-multiple=\"false\" ng-if=\"showTypeProfilingFilter(insertNewRowAssignee)\" sx-on-select=\"buildRecordFilter(insertNewRowAssignee)\"></six-select-2><div class=\"placeholder_style\" ng-if=\"!showTypeProfilingFilter(insertNewRowAssignee)\">-</div></td><td class=\"record\"><six-lookup-2 sx-base-path=\"\'record\'\" ng-model=\"insertNewRowAssignee\" sx-type=\"insertNewRowAssignee.typeprofiling_id.code\" sx-field=\"\'assignee_id\'\" sx-compact=\"true\" sx-filter=\"insertNewRowAssignee.filters\" sx-multiple=\"true\"></six-lookup-2></td><td class=\"tools\"><a class=\"btn pull-right m-xs-l\" ng-click=\"newAssignee=false\"><i class=\"fa fa-history\"></i></a> <a class=\"btn\"><i class=\"fa fa-check-circle\" ng-click=\"addAssignee(insertNewRowAssignee)\"></i></a></td></tr></tbody></table>");
$templateCache.put("dataset/tree/treeplanconfig_default_row.html","<style type=\"text/css\">\n  table.treeplanconfig_table_def {\n    width: 100%;\n  }\n\n  .treeplanconfig_table_def th {\n    font-weight: bold;\n  }\n\n  .treeplanconfig_table_def td, .treeplanconfig_table_def th {\n    width: 16%;\n    padding: 0 2px 0 2px;\n  }\n\n  .treeplanconfig_table_def tr {\n    border-bottom: 1px solid #ddd;\n  }\n\n  .treeplanconfig_table_def td.tools, .treeplanconfig_table_def th.tools {\n    width: 70px;\n    overflow: hidden;\n    display: inline-block;\n    white-space: nowrap;\n    text-align: right;\n    padding: 0 2px 0 2px;\n  }\n</style><table class=\"treeplanconfig_table_def\"><thead><tr><th>Servizio</th><th>Asset</th><th>Tipo profilaz.</th><th>Azienda</th><th>Tipo operatore</th><th>Record profilaz.</th><th class=\"tools\"><a class=\"btn pull-right\" ng-click=\"newDefault=true\"><i class=\"fa fa-plus-circle\"></i></a></th></tr></thead><tbody><tr ng-repeat=\"defaultRow in selected.model.configuration.default\"><td><six-lookup-2 sx-base-path=\"\'record\'\" ng-model=\"defaultRow\" sx-field=\"\'service_id\'\" sx-type=\"\'servizio\'\" sx-compact=\"true\" sx-disabled=\"crossService\" ng-if=\"defaultRow.edit\"></six-lookup-2><div ng-if=\"!defaultRow.edit\"><span>{{defaultRow.service_id.description}}</span></div></td><td><six-lookup-2 sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" ng-model=\"defaultRow\" sx-field=\"\'type_id\'\" sx-disabled=\"crossType\" sx-item-template=\"\'{{item.description}}\'\" sx-page-size=\"10000\" sx-compact=\"true\" ng-if=\"defaultRow.edit\"></six-lookup-2><div ng-if=\"!defaultRow.edit\"><span>{{defaultRow.type_id.description}}</span></div></td><td><six-lookup-2 ng-model=\"defaultRow\" sx-base-path=\"\'schema\'\" sx-field=\"\'typeprofiling_id\'\" sx-filter=\"typeProfilingFilter\" sx-compact=\"true\" sx-page-size=\"10000\" sx-item-template=\"\'{{item.description}}\'\" ng-if=\"defaultRow.edit\"></six-lookup-2><div ng-if=\"!defaultRow.edit\"><span>{{defaultRow.typeprofiling_id.description}}</span></div></td><td><div ng-if=\"defaultRow.edit\"><six-lookup-2 sx-base-path=\"\'record\'\" ng-model=\"defaultRow\" sx-type=\"\'azienda\'\" sx-field=\"\'company_id\'\" sx-compact=\"true\" ng-if=\"defaultRow.typeprofiling_id.code!=\'azienda\'\"></six-lookup-2><div style=\"width: 100%; padding-left: 10px\" ng-if=\"defaultRow.typeprofiling_id.code==\'azienda\'\">-</div></div><div ng-if=\"!defaultRow.edit\"><span>{{defaultRow.company_id.description}}</span></div></td><td><div ng-if=\"defaultRow.edit\"><six-select-2 sx-id=\"operatorType\" ng-model=\"defaultRow\" sx-field=\"\'typeprofiling_filter\'\" sx-list=\"availableTypeOperatorList\" sx-item-template=\"\'{{item.description}}\'\" sx-compact=\"true\" sx-multiple=\"false\" ng-if=\"defaultRow.typeprofiling_id.code==\'operatore\'\"></six-select-2><div style=\"width: 100%; padding-left: 10px\" ng-if=\"defaultRow.typeprofiling_id.code!=\'operatore\'\">-</div></div><div ng-if=\"!defaultRow.edit\"><span>{{defaultRow.typeprofiling_filter.description}}</span></div></td><td><six-lookup-2 sx-base-path=\"\'record\'\" ng-model=\"defaultRow\" sx-type=\"defaultRow.typeprofiling_id.code\" sx-field=\"\'assignee_id\'\" sx-compact=\"true\" sx-filter=\"defaultRow.typeprofiling_filter.filters\" sx-multiple=\"true\" sx-add=\"false\" sx-show-details=\"false\" sx-show-filters=\"false\" ng-if=\"defaultRow.edit\"></six-lookup-2><div ng-if=\"!defaultRow.edit\"><span ng-repeat=\"a in defaultRow.assignee_id track by $index\" ng-if=\"defaultRow.assignee_id.length\">{{a.description}} ;</span> <span ng-if=\"!defaultRow.assignee_id.length\">{{defaultRow.assignee_id.description}}</span></div></td><td class=\"tools\"><a class=\"btn pull-right\" ng-click=\"deleteDefault(defaultRow)\" ng-if=\"!defaultRow.edit\"><i class=\"fa fa-trash-o\"></i></a> <a class=\"btn pull-right\" ng-click=\"restoreHistory(defaultRow)\" ng-if=\"defaultRow.edit\"><i class=\"fa fa-history\"></i></a> <a class=\"btn\" ng-click=\"editRow(defaultRow)\" ng-if=\"!defaultRow.edit\"><i class=\"fa fa-pencil-square-o\"></i></a> <a class=\"btn\" ng-click=\"confirmRow(defaultRow)\" ng-if=\"defaultRow.edit\"><i class=\"fa fa-check-circle\"></i></a></td></tr><tr ng-show=\"newDefault==true\"><td><six-lookup-2 sx-base-path=\"\'record\'\" ng-model=\"insertNewRowDefault\" sx-field=\"\'service_id\'\" sx-type=\"\'servizio\'\" sx-compact=\"true\" sx-disabled=\"crossService\"></six-lookup-2></td><td><six-lookup-2 sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" ng-model=\"insertNewRowDefault\" sx-field=\"\'type_id\'\" sx-disabled=\"crossType\" sx-item-template=\"\'{{item.description}}\'\" sx-page-size=\"10000\" sx-compact=\"true\"></six-lookup-2></td><td><six-lookup-2 ng-model=\"insertNewRowDefault\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" sx-field=\"\'typeprofiling_id\'\" sx-filter=\"typeProfilingFilterDefault\" sx-compact=\"true\" sx-page-size=\"10000\" sx-item-template=\"\'{{item.description}}\'\"></six-lookup-2></td><td><six-lookup-2 sx-base-path=\"\'record\'\" ng-model=\"insertNewRowDefault\" sx-type=\"\'azienda\'\" sx-field=\"\'company_id\'\" sx-compact=\"true\" ng-if=\"showCompanyLookup(insertNewRowDefault)\" sx-on-select=\"buildRecordFilter(insertNewRowDefault)\"></six-lookup-2><div style=\"width: 100%; padding-left: 10px\" ng-if=\"!showCompanyLookup(insertNewRowDefault)\">-</div></td><td><six-select-2 sx-id=\"operatorType\" ng-model=\"insertNewRowDefault\" sx-field=\"\'typeprofiling_filter\'\" sx-list=\"availableTypeOperatorList\" sx-item-template=\"\'{{item.description}}\'\" sx-compact=\"true\" sx-multiple=\"false\" ng-if=\"showTypeProfilingFilter(insertNewRowDefault)\" sx-on-select=\"buildRecordFilter(insertNewRowDefault)\"></six-select-2><div style=\"width: 100%; padding-left: 10px\" ng-if=\"!showTypeProfilingFilter(insertNewRowDefault)\">-</div></td><td><six-lookup-2 sx-base-path=\"\'record\'\" ng-model=\"insertNewRowDefault\" sx-type=\"insertNewRowDefault.typeprofiling_id.code\" sx-field=\"\'assignee_id\'\" sx-compact=\"true\" sx-filter=\"insertNewRowDefault.filters\" sx-multiple=\"true\" sx-add=\"false\" sx-show-details=\"false\" sx-show-filters=\"false\"></six-lookup-2></td><td class=\"tools\"><a class=\"btn pull-right m-xs-l\" ng-click=\"newDefault=false\"><i class=\"fa fa-history\"></i></a> <a class=\"btn\"><i class=\"fa fa-check-circle\" ng-click=\"addDefault(insertNewRowDefault)\"></i></a></td></tr></tbody></table>");
$templateCache.put("dataset/tree/treeplanconfig_invoicing.html","<style type=\"text/css\">\n  table.treeplanconfig_table_ass {\n    width: 100%;\n  }\n\n  .treeplanconfig_table_ass th {\n    font-weight: bold;\n  }\n\n  .treeplanconfig_table_ass td, .treeplanconfig_table_ass th {\n    width: 13%;\n    padding: 0 2px 0 2px;\n  }\n\n  .treeplanconfig_table_ass td.multi, .treeplanconfig_table_ass th.multi {\n    width: 40%;\n  }\n\n  .treeplanconfig_table_ass tr {\n    border-bottom: 1px solid #ddd;\n  }\n\n  .treeplanconfig_table_ass td.tools, .treeplanconfig_table_ass th.tools {\n    width: 70px;\n    overflow: hidden;\n    display: inline-block;\n    white-space: nowrap;\n    text-align: right;\n    padding: 0 2px 0 2px;\n  }\n\n  .placeholder_style {\n    width: 100%;\n    padding-left: 10px;\n  }\n</style><table class=\"treeplanconfig_table_ass\"><thead><tr><th>Azienda</th><th class=\"multi\">Servizi</th><th class=\"multi\">Asset</th><th class=\"tools\"><a class=\"btn pull-right\" ng-click=\"newInvoicing=true\"><i class=\"fa fa-plus-circle\"></i></a></th></tr></thead><tbody><tr ng-repeat=\"invoicingRow in selected.model.configuration.invoicing\"><td><six-lookup-2 ng-if=\"invoicingRow.edit\" sx-base-path=\"\'record\'\" ng-model=\"invoicingRow\" sx-field=\"\'company_id\'\" sx-type=\"\'azienda\'\" sx-compact=\"true\"></six-lookup-2><div ng-if=\"!invoicingRow.edit\"><span>{{invoicingRow.company_id.description}}</span></div></td><td class=\"multi\"><six-lookup-2 ng-if=\"invoicingRow.edit\" sx-base-path=\"\'record\'\" ng-model=\"invoicingRow\" sx-type=\"\'servizio\'\" sx-field=\"\'service_id\'\" sx-compact=\"true\" sx-multiple=\"true\" sx-page-size=\"10000\" sx-item-template=\"\'{{item.description}}\'\"></six-lookup-2><div ng-if=\"!invoicingRow.edit\"><span ng-repeat=\"a in invoicingRow.service_id track by $index\" ng-if=\"invoicingRow.service_id.length\">{{a.description}} ;</span> <span ng-if=\"!invoicingRow.service_id.length\">{{invoicingRow.service_id.description}}</span></div></td><td class=\"multi\"><six-lookup-2 ng-if=\"invoicingRow.edit\" sx-base-path=\"\'schema\'\" ng-model=\"invoicingRow\" sx-type=\"\'schema\'\" sx-field=\"\'type_id\'\" sx-compact=\"true\" sx-multiple=\"true\" sx-page-size=\"10000\" sx-item-template=\"\'{{item.description}}\'\"></six-lookup-2><div ng-if=\"!invoicingRow.edit\"><span ng-repeat=\"a in invoicingRow.type_id track by $index\" ng-if=\"invoicingRow.type_id.length\">{{a.description}} ;</span> <span ng-if=\"!invoicingRow.type_id.length\">{{invoicingRow.type_id.description}}</span></div></td><td class=\"tools\"><a class=\"btn pull-right\" ng-click=\"deleteInvoicing(invoicingRow)\" ng-if=\"!invoicingRow.edit\"><i class=\"fa fa-trash-o\"></i></a> <a class=\"btn pull-right\" ng-click=\"restoreHistory(invoicingRow)\" ng-if=\"invoicingRow.edit\"><i class=\"fa fa-history\"></i></a> <a class=\"btn\" ng-click=\"editRow(invoicingRow)\" ng-if=\"!invoicingRow.edit\"><i class=\"fa fa-pencil-square-o\"></i></a> <a class=\"btn\" ng-click=\"confirmRow(invoicingRow)\" ng-if=\"invoicingRow.edit\"><i class=\"fa fa-check-circle\"></i></a></td></tr><tr ng-show=\"newInvoicing==true\"><td><six-lookup-2 sx-base-path=\"\'record\'\" ng-model=\"insertNewRowInvoicing\" sx-field=\"\'company_id\'\" sx-type=\"\'azienda\'\" sx-compact=\"true\"></six-lookup-2></td><td class=\"multi\"><six-lookup-2 sx-base-path=\"\'record\'\" ng-model=\"insertNewRowInvoicing\" sx-type=\"\'servizio\'\" sx-field=\"\'service_id\'\" sx-compact=\"true\" sx-multiple=\"true\" sx-page-size=\"10000\" sx-item-template=\"\'{{item.description}}\'\"></six-lookup-2></td><td class=\"multi\"><six-lookup-2 sx-base-path=\"\'schema\'\" ng-model=\"insertNewRowInvoicing\" sx-type=\"\'schema\'\" sx-field=\"\'type_id\'\" sx-compact=\"true\" sx-multiple=\"true\" sx-page-size=\"10000\" sx-item-template=\"\'{{item.description}}\'\"></six-lookup-2></td><td class=\"tools\"><a class=\"btn pull-right m-xs-l\" ng-click=\"newInvoicing=false\"><i class=\"fa fa-history\"></i></a> <a class=\"btn\"><i class=\"fa fa-check-circle\" ng-click=\"addInvoicing(insertNewRowInvoicing)\"></i></a></td></tr></tbody></table>");
$templateCache.put("dataset/tree/treeplanconfig_responsable_row.html","<style type=\"text/css\">\n  table.treeplanconfig_table_resp {\n    width: 100%;\n  }\n\n  .treeplanconfig_table_resp th {\n    font-weight: bold;\n  }\n\n  .treeplanconfig_table_resp td, .treeplanconfig_table_resp th {\n    width: 49%;\n    padding: 0 2px 0 2px;\n  }\n\n  .treeplanconfig_table_resp tr {\n    border-bottom: 1px solid #ddd;\n  }\n\n  .treeplanconfig_table_resp td.tools, .treeplanconfig_table_resp th.tools {\n    width: 70px;\n    overflow: hidden;\n    display: inline-block;\n    white-space: nowrap;\n    text-align: right;\n    padding: 0 2px 0 2px;\n  }\n</style><table class=\"treeplanconfig_table_resp\"><thead><tr><th>Nominativo</th><th>Contatti</th><th class=\"tools\"><a class=\"btn pull-right\" ng-click=\"newResponsable=true\"><i class=\"fa fa-plus-circle\"></i></a></th></tr></thead><tbody><tr ng-repeat=\"responsableRow in selected.model.configuration.responsable\"><td><input class=\"form-control\" placeholder=\"Cognome, nome\" type=\"text\" ng-model=\"responsableRow.name\" ng-disabled=\"!responsableRow.edit\"></td><td><input class=\"form-control\" placeholder=\"Mail, telefono, ...\" type=\"text\" ng-model=\"responsableRow.contacts\" ng-disabled=\"!responsableRow.edit\"></td><td class=\"tools\"><a class=\"btn pull-right\" ng-click=\"delete(selected.model.configuration.responsable, responsableRow)\" ng-if=\"!responsableRow.edit\"><i class=\"fa fa-trash-o\"></i></a> <a class=\"btn pull-right\" ng-click=\"restoreHistory(responsableRow)\" ng-if=\"responsableRow.edit\"><i class=\"fa fa-history\"></i></a> <a class=\"btn\" ng-click=\"editRow(responsableRow)\" ng-if=\"!responsableRow.edit\"><i class=\"fa fa-pencil-square-o\"></i></a> <a class=\"btn\" ng-click=\"confirmRow(responsableRow)\" ng-if=\"responsableRow.edit\"><i class=\"fa fa-check-circle\"></i></a></td></tr><tr ng-show=\"newResponsable==true\"><td><input class=\"form-control\" placeholder=\"Cognome, nome\" type=\"text\" ng-model=\"insertNewRowResponsable.name\"></td><td><input class=\"form-control\" placeholder=\"Mail, telefono, ...\" type=\"text\" ng-model=\"insertNewRowResponsable.contacts\"></td><td class=\"tools\"><a class=\"btn pull-right m-xs-l\" ng-click=\"newResponsable=false\"><i class=\"fa fa-history\"></i></a> <a class=\"btn\"><i class=\"fa fa-check-circle\" ng-click=\"addResponsable(insertNewRowResponsable)\"></i></a></td></tr></tbody></table>");
$templateCache.put("dataset/tree/treeplanconfig_watchers.html","<style type=\"text/css\">\n  table.treeplanconfig_watchers {\n    width: 100%;\n  }\n\n  .treeplanconfig_watchers th {\n    font-weight: bold;\n  }\n\n  .treeplanconfig_watchers td, .treeplanconfig_watchers th {\n    padding: 0 2px 0 2px;\n  }\n\n  .treeplanconfig_watchers tr {\n    border-bottom: 1px solid #ddd;\n  }\n\n  .treeplanconfig_watchers td.tools, .treeplanconfig_watchers th.tools {\n    width: 70px;\n    overflow: hidden;\n    display: inline-block;\n    white-space: nowrap;\n    text-align: right;\n    padding: 0 2px 0 2px;\n  }\n</style><table class=\"treeplanconfig_watchers\"><thead><tr><th>Operatore</th><th>Esterno</th><th>Nominativo</th><th>Contatti</th><th class=\"tools\"><a class=\"btn pull-right\" ng-click=\"newWatcher=true\"><i class=\"fa fa-plus-circle\"></i></a></th></tr></thead><tbody><tr ng-repeat=\"watcher in selected.model.configuration.watchers.internal\"><td><input type=\"radio\" disabled=\"\" ng-checked=\"watcher.UUID != undefined\"></td><td><input type=\"radio\" disabled=\"\" ng-checked=\"watcher.UUID == undefined\"></td><td><six-lookup-2 ng-model=\"watcher\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-compact=\"true\" sx-disabled=\"!watcher.edit\"></six-lookup-2></td><td></td><td class=\"tools\"><a class=\"btn pull-right\" ng-click=\"delete(selected.model.configuration.watchers.internal, watcher)\" ng-if=\"!watcher.edit\"><i class=\"fa fa-trash-o\"></i></a></td></tr><tr ng-repeat=\"watcher in selected.model.configuration.watchers.external\"><td><input type=\"radio\" disabled=\"\" ng-checked=\"watcher.UUID != undefined\"></td><td><input type=\"radio\" disabled=\"\" ng-checked=\"watcher.UUID == undefined\"></td><td></td><td><input class=\"form-control\" placeholder=\"Mail, telefono, ...\" type=\"text\" ng-model=\"watcher\" ng-disabled=\"!watcher.edit\"></td><td class=\"tools\"><a class=\"btn pull-right\" ng-click=\"delete(selected.model.configuration.watchers.external, watcher)\" ng-if=\"!watcher.edit\"><i class=\"fa fa-trash-o\"></i></a></td></tr><tr ng-show=\"newWatcher == true\"><td><input type=\"radio\" name=\"reference\" ng-model=\"insertNewWatcher.internal\" ng-init=\"insertNewWatcher.internal = true\" ng-value=\"true\" ng-change=\"insertNewWatcher.external = false\"></td><td><input type=\"radio\" name=\"reference\" ng-model=\"insertNewWatcher.external\" ng-init=\"insertNewWatcher.external = false\" ng-value=\"true\" ng-change=\"insertNewWatcher.internal = false\"></td><td><six-lookup-2 ng-model=\"insertNewWatcher\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'lookup\'\" sx-compact=\"true\" ng-show=\"insertNewWatcher.internal == true\"></six-lookup-2></td><td><input type=\"text\" ng-if=\"insertNewWatcher.external\" class=\"form-control\" placeholder=\"Mail, telefono, ...\" ng-model=\"insertNewWatcher.mail\"></td><td class=\"tools\"><a class=\"btn pull-right m-xs-l\" ng-click=\"newWatcher=false\"><i class=\"fa fa-history\"></i></a> <a class=\"btn\"><i class=\"fa fa-check-circle\" ng-click=\"addWatcher(insertNewWatcher)\"></i></a></td></tr></tbody></table>");
$templateCache.put("dataset/treefilter/profilefilters.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" toolbar-function=\"goToProfileList()\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"fa fa-trash\" toolbar-function=\"delete()\" ng-hide=\"!record.version\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-save\" label=\"Salva\" btn-class=\"btn-success\" toolbar-function=\"save()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"!record.version\">Nuovo {{recordType.model.description}}</h1><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"record.version\">{{recordType.model.description}} <span class=\"m-l-xs\">{{record.model.code}} - {{record.model.description}}</span></h1></div></div></div><uib-tabset class=\"tabs-left\" style=\"padding: 15px\"><uib-tab index=\"0\"><uib-tab-heading><span class=\"fa fa-book text-info-dker\"></span> Dettaglio</uib-tab-heading><div class=\"panel-body m-t-n\"><div class=\"row\"><div class=\"col col-md-12\"><form name=\"detailForm\" sf-schema=\"recordType.model.schema\" sf-form=\"recordType.model.form\" sf-model=\"record.model\"></form></div></div></div></uib-tab><uib-tab index=\"1\" disable=\"!record.version\"><uib-tab-heading><span class=\"fa fa-sitemap text-info-dker\"></span> Profilazione Tree</uib-tab-heading><div class=\"panel-body m-t-n\"><div class=\"col-sm-12\"><fieldset><legend>Tipologie asset visibili:</legend><div ng-repeat=\"(key, rule) in recordFilters.node\" class=\"list-group-item b-l-primary b-l-3x m-b hover-anchor hover\"><span ng-click=\"removeNodeFilter(key)\" class=\"pull-right text-muted hover-action\" role=\"button\" tabindex=\"0\"><i class=\"fa fa-times\"></i></span> <span class=\"block attr\"><label>Modello</label><six-lookup-2 sx-id=\"nodeLookup_{{key}}\" ng-model=\"rule.model\" sx-object=\"rule.model.type_obj\" sx-base-path=\"\'schema\'\" sx-field=\"\'type_id\'\" sx-add=\"false\" sx-show-details=\"false\" sx-show-filters=\"false\" sx-compact=\"true\" sx-item-template=\"\'{{item.description}}\'\"></six-lookup-2><six-search-filters sx-filter=\"rule.filtersOut\" sx-filter-init=\"rule.filters\" sx-id=\"nodeFilter_{{key}}\" sx-filter-only=\"true\" sx-auto-confirm-filter=\"true\" sx-model=\"rule.model\" sx-show-select-schema=\"false\" sx-on-filter-changed=\"onFilterChanged()\"></six-search-filters></span></div><div class=\"wrapper\"><button class=\"btn btn-success pull-right\" ng-click=\"addNodeFilter()\"><i class=\"fa fa-plus\"></i> Aggiungi tipo asset</button></div></fieldset></div><div class=\"col-sm-12\"><fieldset><legend>Filtra albero:</legend><p>Determina quali sottoalberi potrà vedere. Vanno indicate solo le radici.</p><div ng-repeat=\"(key, rule) in recordFilters.parents\" class=\"list-group-item b-l-primary b-l-3x m-b hover-anchor hover\"><span ng-click=\"removeParentFilter(key)\" class=\"pull-right text-muted hover-action\" role=\"button\" tabindex=\"0\"><i class=\"fa fa-times\"></i></span> <span class=\"block attr row\"><div class=\"col-md-11 form-group\"><label>Modello:</label><six-lookup-2 sx-id=\"parentLookup_{{key}}\" ng-model=\"rule.type\" sx-base-path=\"\'schema\'\" sx-field=\"\'type_id\'\" sx-add=\"false\" sx-show-details=\"false\" sx-show-filters=\"false\" sx-compact=\"true\" sx-item-template=\"\'{{item.description}}\'\"></six-lookup-2></div><div class=\"col-md-4 form-group\"><label>UUID:</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"rule.uuid\"> <span class=\"input-group-btn\"><button class=\"btn btn-secondary\" ng-click=\"searchNode(this,\'uuid\')\" type=\"button\"><i class=\"fa fa-search\"></i></button></span></div></div><div class=\"col-md-4 form-group\"><label>Codice:</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"rule.code\"> <span class=\"input-group-btn\"><button class=\"btn btn-secondary\" ng-click=\"searchNode(this,\'code\')\" type=\"button\"><i class=\"fa fa-search\"></i></button></span></div></div><div class=\"col-md-4 form-group\"><label>Descrizione:</label> <input type=\"text\" class=\"form-control\" ng-model=\"rule.description\"></div></span></div><div class=\"wrapper\"><button class=\"btn btn-success pull-right\" ng-click=\"addParentFilter()\"><i class=\"fa fa-plus\"></i> Aggiungi radice</button></div></fieldset></div></div><div class=\"panel-footer clearfix\"><div class=\"form-group\"><input id=\"jsonShowCheck\" type=\"checkbox\" ng-model=\"jsonshow\" data-toggle=\"collapse\" data-target=\"#json-collapse\" class=\"pull-left\"> <label for=\"jsonShowCheck\" class=\"pull-left control-label\">Dettaglio avanzato</label></div></div><div class=\"row collapse\" id=\"json-collapse\" aria-expanded=\"true\"><div class=\"col-md-12\"><div class=\"panel-heading wrapper b-b b-light\"><h4 class=\"font-thin m-t-none m-b-none text-muted\">Dettaglio</h4></div><div style=\"margin-top:0px;\" ng-model=\"formattedString\" readonly=\"\" ui-ace=\"{ useWrapMode : true, showGutter: true, mode: \'json\', firstLineNumber: 1, onLoad: aceLoaded }\"></div></div></div></uib-tab><uib-tab index=\"2\" disable=\"!record.version\"><uib-tab-heading><span class=\"fa fa-calendar text-info-dker\"></span> Autorizzazioni Plan</uib-tab-heading><div class=\"panel-body m-t-n\"><div class=\"col-sm-12\"><div class=\"form-group\"><h4 class=\"override-h4-no-margin\">Segnalazioni</h4><hr class=\"m-t-sm m-b-n-xxs\"><div class=\"col-md-4 col-sm-12 m-t\"><label class=\"checkbox i-checks m-b\" style=\"width:100%\"><input id=\"issueVisibilityAll\" type=\"radio\" ng-model=\"planFilters.issueVisibility\" value=\"all\"><i></i> <span class=\"i-checks\">Visualizza tutte</span></label></div><div class=\"col-md-4 col-sm-12 m-t\"><label class=\"checkbox i-checks m-b\" style=\"width:100%\"><input id=\"issueVisibilityAsset\" type=\"radio\" ng-model=\"planFilters.issueVisibility\" value=\"filtered\"><i></i> <span class=\"i-checks\">Solo su asset/servizi visibili</span></label></div><div class=\"col-md-4 col-sm-12 m-t\"><label class=\"checkbox i-checks m-b\" style=\"width:100%\"><input id=\"issueVisibilityOwn\" type=\"radio\" ng-model=\"planFilters.issueVisibility\" value=\"own\"><i></i> <span class=\"i-checks\">Solo proprie</span></label></div></div><div class=\"form-group\"><h4 class=\"override-h4-no-margin\">ODL</h4><hr class=\"m-t-sm m-b-n-xxs\"><div class=\"col-md-4 col-sm-12 m-t\"><label class=\"checkbox i-checks m-b\" style=\"width:100%\"><input id=\"odlVisibilityAll\" type=\"radio\" ng-model=\"planFilters.odlVisibility\" value=\"all\"><i></i> <span class=\"i-checks\">Visualizza tutte</span></label></div><div class=\"col-md-4 col-sm-12 m-t\"><label class=\"checkbox i-checks m-b\" style=\"width:100%\"><input id=\"odlVisibilityAsset\" type=\"radio\" ng-model=\"planFilters.odlVisibility\" value=\"filtered\"><i></i> <span class=\"i-checks\">Solo su asset/servizi/aziende visibili</span></label></div><div class=\"col-md-4 col-sm-12 m-t\"><label class=\"checkbox i-checks m-b\" style=\"width:100%\"><input id=\"odlVisibilityOwn\" type=\"radio\" ng-model=\"planFilters.odlVisibility\" value=\"own\"><i></i> <span class=\"i-checks\">Solo proprie</span></label></div></div></div></div></uib-tab></uib-tabset></div></div>");
$templateCache.put("dataset/treefilter/profilelist.html","<six-toolbar ng-if=\"profilable\"><six-toolbar-button icon=\"fa fa-plus\" label=\"Nuovo {{recordType.model.description}}\" btn-class=\"btn-success\" toolbar-function=\"goToNewProfile()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh\" label=\"Aggiorna\" btn-class=\"btn-default\" toolbar-function=\"getList()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div ng-if=\"profilable\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-md-12 col-sm-12 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Profilazione tree</h1><small>Permette di associare a ciascun {{recordType.model.description}} dei filtri per determinare il tree utilizzato.</small></div></div></div><div class=\"panel-body\"><six-grid-pagination get-data-callback=\"getList()\" items-list=\"rows\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div><div ng-if=\"!profilable\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-md-12 col-sm-12 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Tree non profilabile tramite l\'entità {{recordType.model.description}}</h1></div></div></div></div></div></div>");
$templateCache.put("dataset/uom/uom_detail.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"saveForm()\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" sx-disabled=\"isDeletePermAllowed()===false\" toolbar-function=\"deleteWithDialog(type.selected.version)\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">CONVERSIONE UNITA\' DI MISURA</h1></div></div></div><div class=\"panel-body\"><uib-tabset><uib-tab index=\"0\"><uib-tab-heading>Dati</uib-tab-heading><div class=\"main col-lg-12\" style=\"padding-right: 0px;\"><div class=\"col-md-7\"><div class=\"row wrapper\"><div class=\"row\"><label for=\"vettore\" class=\"col-md-3 control-label\">Vettore energetico:</label><six-lookup id=\"vettore\" ng-model=\"model.record_id\" sx-type=\"\'vettoreenergetico\'\" sx-field=\"\'id\'\" class=\"col-md-6\"></six-lookup></div></div><div class=\"row wrapper\"><div class=\"row\"><label for=\"uom_from\" class=\"col-md-3 control-label\">Da:</label><six-lookup id=\"uom_from\" ng-model=\"model.uom_from\" sx-type=\"\'um\'\" sx-field=\"\'uom\'\" class=\"col-md-6\" sx-object=\"container_from.obj\"></six-lookup></div></div><div class=\"row wrapper\"><div class=\"row\"><label for=\"uom_to\" class=\"col-md-3 control-label\">A:</label><six-lookup id=\"uom_to\" ng-model=\"model.uom_to\" sx-type=\"\'um\'\" sx-field=\"\'uom\'\" class=\"col-md-6\" sx-object=\"container_to.obj\"></six-lookup></div></div><div class=\"row wrapper\"><div class=\"row\"><label for=\"uom_to\" class=\"col-md-3 control-label\">Nome variabile:</label><div class=\"col-md-6\"><input id=\"inputName\" type=\"text\" class=\"col-md-6 form-control\" ng-model=\"model.inputName\"></div></div></div><div class=\"row wrapper\"><div class=\"row\"><label class=\"col-md-3 control-label\">Formula:</label><div class=\"col-md-6\"><textarea ng-model=\"model.formula\" class=\"col-md-6 form-control\" rows=\"4\"></textarea></div></div></div><div class=\"row wrapper\"><div class=\"row\"><label class=\"control-label col-md-3\">Arrotondamento:</label><div class=\"col-md-6\"><select ng-model=\"model.rounding_mode\" class=\"col-md-6 form-control\"><option value=\"none\">Nessuno</option><option value=\"round\">Da 5 al valore superiore</option><option value=\"ceil\">Al valore superiore</option><option value=\"floor\">Al valore inferiore</option></select></div></div></div><div class=\"row wrapper\" ng-show=\"model.rounding_mode!=\'none\'\"><div class=\"row\"><label class=\"col-md-3 control-label\">N. cifre decimali:</label><div class=\"col-md-6\"><input id=\"precision\" type=\"number\" class=\"col-md-6 form-control\" min=\"0\" ng-model=\"model.precision\"></div></div></div></div><div class=\"col-md-5 override-padding-no-pad-left-right\"><div class=\"row wrapper\"><div class=\"panel panel-default\" id=\"panel1\"><a data-toggle=\"collapse\" data-target=\"#collapseOne\"><div class=\"panel-heading\"><h4 class=\"panel-title\"><i class=\"pull-right fa ng-scope fa-angle-right\" ng-class=\"{\'fa-angle-down\': status.open, \'fa-angle-right\': !status.open}\"></i> Test conversione formula</h4></div></a><div id=\"collapseOne\" class=\"panel-collapse panel-heading collapse\"><div class=\"row wrapper\"><div class=\"row\"><label for=\"input\" class=\"col-md-2 control-label\">Input:</label><div class=\"col-md-6\"><input id=\"input\" type=\"text\" class=\"col-md-6 form-control\" ng-model=\"inputVal\"></div><div class=\"col-md-4\"><button ng-click=\"calculate(inputVal)\" class=\"btn btn-success btn-sm text-center col-md-offset-3\"><span class=\"fa fa-youtube-play\"></span> Calcola</button></div></div></div><div class=\"row wrapper\"><div class=\"row\"><label for=\"output\" class=\"col-md-2 control-label\">Risultato:</label><div class=\"col-md-6\"><input id=\"output\" type=\"text\" class=\"col-md-6 form-control\" ng-model=\"output\"></div></div></div></div></div></div></div></div></uib-tab><uib-tab index=\"1\"><uib-tab-heading>Parametri</uib-tab-heading><div class=\"main col-lg-12\"><div class=\"col-md-12 params-row\" ng-repeat=\"item in model.constant_params\"><div class=\"row wrapper\"><div class=\"row\"><label class=\"col-md-1 control-label\">Nome:</label><div class=\"col-md-4\"><input type=\"text\" class=\"col-md-12 form-control\" ng-model=\"item.name\"></div><label class=\"col-md-1 col-md-offset-1 control-label\">Valore:</label><div class=\"col-md-4\"><input class=\"col-md-12 form-control\" ng-model=\"item.value\" type=\"number\"></div><div class=\"col-md-1\" style=\"text-align: right;\"><button ng-click=\"deleteItemOnArray($index)\" class=\"btn btn-danger btn-md btn-default\"><i class=\"fa fa-trash\"></i></button></div></div></div></div><div class=\"col-md-12\"><div class=\"row wrapper\"><div class=\"row\"><div class=\"col-md-2 col-md-offset-10\"><button ng-click=\"appendToArray()\" type=\"button\" class=\"btn btn-default pull-right\"><i class=\"glyphicon glyphicon-plus\"></i> Aggiungi param.</button></div></div></div></div></div></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("dataset/uom/uom_list.html","<six-toolbar><six-toolbar-button label=\"Nuovo\" icon=\"fa fa-plus\" toolbar-function=\"newUom()\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"getListWrapper()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">CONVERSIONE UNITA\' DI MISURA</h1></div></div></div><div class=\"panel-body\"><div class=\"form-group\"><input ng-keyup=\"getListWrapper()\" class=\"form-control\" type=\"text\" ng-model=\"queryParam\" placeholder=\"Scrivere qui per filtrare la lista...\"></div><table id=\"modeltype_list\" class=\"table table-striped\"><thead><tr><th class=\"col-md-2\"></th><th class=\"col-md-2\">Vettore</th><th class=\"col-md-2\">DA</th><th class=\"col-md-2\">A</th><th class=\"col-md-6\">FORMULA</th></tr></thead><tbody><tr ng-repeat=\"item in listWrapper.list\"><td><a ng-href=\"#/uom/{{item.code}}\" class=\"btn btn-default btn-sm\" id=\"btn_model_detail\"><span class=\"fa fa-pencil\"></span></a></td><td>{{ item.record_id.id.description}}</td><td>{{ item.uom_from.uom.description}}</td><td>{{ item.uom_to.uom.description}}</td><td>{{ item.formula }}</td></tr><tr ng-hide=\"listWrapper.list.length\"><td colspan=\"10\"><p class=\"text-center\">Nessun risultato trovato</p></td></tr></tbody></table></div><div class=\"panel-footer\"><div class=\"row\"><div class=\"col-lg-12 text-center\"><uib-pagination ng-change=\"pageChanged()\" boundary-links=\"true\" total-items=\"listWrapper.totalResults\" ng-model=\"listWrapper.currentPage\" class=\"pagination-sm\" items-per-page=\"listWrapper.pageSize\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\" max-size=\"10\"></uib-pagination></div></div></div></div></div>");
$templateCache.put("energy/budget/budget_detail.html","<style type=\"text/css\">\n  .hidden {\n    visibility: hidden;\n  }\n  .grid{\n    height: 800px;\n  }\n  .alignment{\n    padding-top: 28px;\n  }\n  six-toolbar-item .fa-check{\n    margin-right: 8px;\n  }\n  six-toolbar-item .invisible-check{\n    visibility:hidden;\n  }\n  .row-sep,\n  .row-sep td:first-child {\n    height: 2px;\n    background-color: #a6deff;\n  }\n  .selected {\n    background-color: #a6deff;\n    font-weight: bold;\n  }\n  .detail-bdg-row {\n    vertical-align: top;\n  }\n  .detail-bdg-row th {\n    font-weight: normal;\n    font-style: italic;\n  }\n  .override-th th {\n    text-align: center;\n  }\n</style><script type=\"text/ng-template\" id=\"budgetInfoDelete.html\"><strong><span class=\"ngdialog-icon\"></span></strong> <div style=\"text-align: center;\"><h4 class=\"m-t-none m-b font-bold\">ATTENZIONE</h4></div> <table align=\"center\" style=\"text-align: left; width: 100%\"> <caption style=\"text-align: center; font-weight: bold\">{{deleteMessage}}</caption> <tr> <td style=\"text-align: center;\"> <button type=\"button\" class=\"btn btn-default\" ng-click=\"deleteFunction()\">Si</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"notDeleteFunction()\">No</button> </td> </tr> </table></script><six-toolbar><six-toolbar-item label=\"Esporta\" icon=\"fa fa-file-excel-o text-success-dker\" toolbar-function=\"exportXLSX()\" sx-disabled=\"!data.length\"></six-toolbar-item><six-toolbar-item label=\"Vista\" icon=\"fa fa-eye icon text-primary-dker\"><li><a href=\"\" ng-click=\"viewMode(\'um\')\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': (viewMode().um == false)}\"></i> Valori</a></li><li><a href=\"\" ng-click=\"viewMode(\'std\')\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': (viewMode().std == false)}\"></i> Std</a></li><li><a href=\"\" ng-click=\"viewMode(\'economic\')\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': (viewMode().economic == false)}\"></i> Economico</a></li></six-toolbar-item><six-toolbar-item label=\"Aggiungi voci\" icon=\"fa fa-plus text-info-dker\" toolbar-function=\"addVoices()\" ng-show=\"budget.budget_code\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" ng-click=\"goBack()\" ng-if=\"budget.budget_code\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"glyphicon glyphicon-save\" toolbar-function=\"update()\" ng-if=\"importingOperation === false && budget.searchCode.UUID\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" ng-if=\"budget.budget_code\" toolbar-function=\"deleteWithDialog()\" sx-disabled=\"isDeletePermAllowed()===false\"></six-toolbar-button><six-toolbar-button label=\"Nuovo\" btn-class=\"btn-info\" icon=\"fa fa-file\" toolbar-function=\"newBudget()\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-md-8\"><h1 class=\"m-n font-thin h3 text-black\">BUDGET</h1><small class=\"text-muted\" ng-if=\"!budget.budget_code\">Dettaglio</small> <small class=\"text-muted\" ng-if=\"budget.budget_code\">{{budget.budget_code}}</small></div></div></div><div class=\"panel-body\" collapse=\"!isCollapsed\"><div class=\"row form-group\"><div class=\"col-md-3\"><label id=\"code_label\" for=\"code\" class=\"control-label\">Codice</label> <input type=\"text\" id=\"code\" class=\"form-control\" ng-model=\"budget.budget_code\" ng-disabled=\"\'true\'\"></div><div class=\"col-md-4\"><label id=\"description_label\" for=\"description\" class=\"control-label\">Descrizione</label> <input type=\"text\" id=\"description\" class=\"form-control\" ng-model=\"budget.budget_description\"></div><div class=\"col-md-1\"><label id=\"year_label\" for=\"code\" class=\"control-label\">Anno</label> <input type=\"text\" id=\"year\" class=\"form-control\" ng-model=\"budget.year\" ng-disabled=\"\'true\'\"></div><div class=\"col-md-2\"><label id=\"date_label\" class=\"control-label\">Data di valorizzazione</label><six-date-time-picker id=\"budget_eval_date\" name=\"budget_eval_date\" ng-model=\"budget.eval_date\" enable-time=\"false\" date-options=\"dateOptions\"></six-date-time-picker></div><div class=\"col-md-2\"><label class=\"checkbox i-checks m-b col-md-12\"><input type=\"checkbox\" ng-model=\"budget.budget_default\"><i></i> <span class=\"i-checks\">Default</span></label></div></div><uib-tabset><uib-tab index=\"0\"><uib-tab-heading><span class=\"fa fa-money text-info-dker\"></span> Budget</uib-tab-heading><div class=\"row\"><div class=\"col-md-12\"><div style=\"overflow:auto;\"><table class=\"detailTable table-hover override-th\"><tr style=\"vertical-align: top\"><th style=\"vertical-align: middle\"><a ng-click=\"toggleAllRows()\"><i class=\"fa\" ng-class=\"{\'fa-chevron-right\': !allRowsExpanded, \'fa-chevron-down\': allRowsExpanded}\"></i></a></th><th><a ng-click=\"sortBy(\'record_type\')\">Tipo cont.</a> <i class=\"fa\" ng-class=\"{\'fa-caret-up\': isSorted(\'record_type\')==1, \'fa-caret-down\': isSorted(\'record_type\')==-1}\"></i> <input type=\"text\" ng-model=\"search.record_type\" class=\"form-control input-sm\" placeholder=\"Tipo ...\"></th><th><a ng-click=\"sortBy(\'record_code\')\">Contatore</a> <i class=\"fa\" ng-class=\"{\'fa-caret-up\': isSorted(\'record_code\')==1, \'fa-caret-down\': isSorted(\'record_code\')==-1}\"></i> <input type=\"text\" ng-model=\"search.record_code\" class=\"form-control input-sm\" placeholder=\"Codice ...\"></th><th>Gennaio</th><th>Febbraio</th><th>Marzo</th><th>Aprile</th><th>Maggio</th><th>Giugno</th><th>Luglio</th><th>Agosto</th><th>Settembre</th><th>Ottobre</th><th>Novembre</th><th>Dicembre</th><th>Tot.</th></tr><tr ng-repeat-start=\"row in filtered=(data | filter: {record_type: search.record_type, record_code: search.record_code} | orderBy: sort)\" ng-dblclick=\"row.expanded=!row.expanded\" ng-class=\"{selected: row.expanded}\"><td><a ng-click=\"row.expanded=!row.expanded\"><i class=\"fa\" ng-class=\"{\'fa-chevron-right\': !row.expanded, \'fa-chevron-down\': row.expanded}\"></i></a></td><td>{{row.record_type}}</td><td><a ng-href=\"{{getRecordDetailURL(row.record_type, row.record_uuid)}}\" title=\"Vedi dettaglio\">{{row.record_code}}</a></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">{{row.gennaio.tot | number: 2}} {{row.gennaio.um.code}}</div><div ng-if=\"viewMode().std\">{{row.gennaio.tot_std | number: 2}} kWh</div><div ng-if=\"viewMode().economic\">{{row.gennaio.tot_economic | currency:\"€\":2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">{{row.febbraio.tot | number: 2}} {{row.febbraio.um.code}}</div><div ng-if=\"viewMode().std\">{{row.febbraio.tot_std | number: 2}} kWh</div><div ng-if=\"viewMode().economic\">{{row.febbraio.tot_economic | currency:\"€\":2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">{{row.marzo.tot | number: 2}} {{row.marzo.um.code}}</div><div ng-if=\"viewMode().std\">{{row.marzo.tot_std | number: 2}} kWh</div><div ng-if=\"viewMode().economic\">{{row.marzo.tot_economic | currency:\"€\":2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">{{row.aprile.tot | number: 2}} {{row.aprile.um.code}}</div><div ng-if=\"viewMode().std\">{{row.aprile.tot_std | number: 2}} kWh</div><div ng-if=\"viewMode().economic\">{{row.aprile.tot_economic | currency:\"€\":2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">{{row.maggio.tot | number: 2}} {{row.maggio.um.code}}</div><div ng-if=\"viewMode().std\">{{row.maggio.tot_std | number: 2}} kWh</div><div ng-if=\"viewMode().economic\">{{row.maggio.tot_economic | currency:\"€\":2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">{{row.giugno.tot | number: 2}} {{row.giugno.um.code}}</div><div ng-if=\"viewMode().std\">{{row.giugno.tot_std | number: 2}} kWh</div><div ng-if=\"viewMode().economic\">{{row.giugno.tot_economic | currency:\"€\":2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">{{row.luglio.tot | number: 2}} {{row.luglio.um.code}}</div><div ng-if=\"viewMode().std\">{{row.luglio.tot_std | number: 2}} kWh</div><div ng-if=\"viewMode().economic\">{{row.luglio.tot_economic | currency:\"€\":2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">{{row.agosto.tot | number: 2}} {{row.agosto.um.code}}</div><div ng-if=\"viewMode().std\">{{row.agosto.tot_std | number: 2}} kWh</div><div ng-if=\"viewMode().economic\">{{row.agosto.tot_economic | currency:\"€\":2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">{{row.settembre.tot | number: 2}} {{row.settembre.um.code}}</div><div ng-if=\"viewMode().std\">{{row.settembre.tot_std | number: 2}} kWh</div><div ng-if=\"viewMode().economic\">{{row.settembre.tot_economic | currency:\"€\":2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">{{row.ottobre.tot | number: 2}} {{row.ottobre.um.code}}</div><div ng-if=\"viewMode().std\">{{row.ottobre.tot_std | number: 2}} kWh</div><div ng-if=\"viewMode().economic\">{{row.ottobre.tot_economic | currency:\"€\":2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">{{row.novembre.tot | number: 2}} {{row.novembre.um.code}}</div><div ng-if=\"viewMode().std\">{{row.novembre.tot_std | number: 2}} kWh</div><div ng-if=\"viewMode().economic\">{{row.novembre.tot_economic | currency:\"€\":2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">{{row.dicembre.tot | number: 2}} {{row.dicembre.um.code}}</div><div ng-if=\"viewMode().std\">{{row.dicembre.tot_std | number: 2}} kWh</div><div ng-if=\"viewMode().economic\">{{row.dicembre.tot_economic | currency:\"€\":2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">{{row.tot.tot | number: 2}} {{row.tot.um.code}}</div><div ng-if=\"viewMode().std\">{{row.tot.tot_std | number: 2}} kWh</div><div ng-if=\"viewMode().economic\">{{row.tot.tot_economic | currency:\"€\":2}}</div></td></tr><tr class=\"detail-bdg-row\" ng-if=\"row.expanded\"><th></th><th>Voce <input type=\"text\" ng-model=\"search.voice_code\" class=\"form-control input-sm\" placeholder=\"Voce ...\"></th><th>Prezzo un.</th><th>Gennaio</th><th>Febbraio</th><th>Marzo</th><th>Aprile</th><th>Maggio</th><th>Giugno</th><th>Luglio</th><th>Agosto</th><th>Settembre</th><th>Ottobre</th><th>Novembre</th><th>Dicembre</th><th>Tot.</th></tr><tr ng-repeat=\"det in filteredDet=(row.details | filter: {voice_code: search.voice_code})\" ng-if=\"row.expanded\"><td></td><td>{{det.voice_code}}</td><td class=\"text-right\">{{det.unit_price | currency:\"€\":2}}</td><td class=\"text-right\"><div ng-if=\"viewMode().um\">{{det.gennaio.tot | number: 2}} {{det.gennaio.um.code}}</div><div ng-if=\"viewMode().std\">{{det.gennaio.tot_std | number: 2}} kWh</div><div ng-if=\"viewMode().economic\">{{det.gennaio.tot_economic | currency:\"€\":2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">{{det.febbraio.tot | number: 2}} {{det.febbraio.um.code}}</div><div ng-if=\"viewMode().std\">{{det.febbraio.tot_std | number: 2}} kWh</div><div ng-if=\"viewMode().economic\">{{det.febbraio.tot_economic | currency:\"€\":2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">{{det.marzo.tot | number: 2}} {{det.marzo.um.code}}</div><div ng-if=\"viewMode().std\">{{det.marzo.tot_std | number: 2}} kWh</div><div ng-if=\"viewMode().economic\">{{det.marzo.tot_economic | currency:\"€\":2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">{{det.aprile.tot | number: 2}} {{det.aprile.um.code}}</div><div ng-if=\"viewMode().std\">{{det.aprile.tot_std | number: 2}} kWh</div><div ng-if=\"viewMode().economic\">{{det.aprile.tot_economic | currency:\"€\":2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">{{det.maggio.tot | number: 2}} {{det.maggio.um.code}}</div><div ng-if=\"viewMode().std\">{{det.maggio.tot_std | number: 2}} kWh</div><div ng-if=\"viewMode().economic\">{{det.maggio.tot_economic | currency:\"€\":2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">{{det.giugno.tot | number: 2}} {{det.giugno.um.code}}</div><div ng-if=\"viewMode().std\">{{det.giugno.tot_std | number: 2}} kWh</div><div ng-if=\"viewMode().economic\">{{det.giugno.tot_economic | currency:\"€\":2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">{{det.luglio.tot | number: 2}} {{det.luglio.um.code}}</div><div ng-if=\"viewMode().std\">{{det.luglio.tot_std | number: 2}} kWh</div><div ng-if=\"viewMode().economic\">{{det.luglio.tot_economic | currency:\"€\":2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">{{det.agosto.tot | number: 2}} {{det.agosto.um.code}}</div><div ng-if=\"viewMode().std\">{{det.agosto.tot_std | number: 2}} kWh</div><div ng-if=\"viewMode().economic\">{{det.agosto.tot_economic | currency:\"€\":2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">{{det.settembre.tot | number: 2}} {{det.settembre.um.code}}</div><div ng-if=\"viewMode().std\">{{det.settembre.tot_std | number: 2}} kWh</div><div ng-if=\"viewMode().economic\">{{det.settembre.tot_economic | currency:\"€\":2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">{{det.ottobre.tot | number: 2}} {{det.ottobre.um.code}}</div><div ng-if=\"viewMode().std\">{{det.ottobre.tot_std | number: 2}} kWh</div><div ng-if=\"viewMode().economic\">{{det.ottobre.tot_economic | currency:\"€\":2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">{{det.novembre.tot | number: 2}} {{det.novembre.um.code}}</div><div ng-if=\"viewMode().std\">{{det.novembre.tot_std | number: 2}} kWh</div><div ng-if=\"viewMode().economic\">{{det.novembre.tot_economic | currency:\"€\":2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">{{det.dicembre.tot | number: 2}} {{det.dicembre.um.code}}</div><div ng-if=\"viewMode().std\">{{det.dicembre.tot_std | number: 2}} kWh</div><div ng-if=\"viewMode().economic\">{{det.dicembre.tot_economic | currency:\"€\":2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">{{det.tot.tot | number: 2}} {{det.tot.um.code}}</div><div ng-if=\"viewMode().std\">{{det.tot.tot_std | number: 2}} kWh</div><div ng-if=\"viewMode().economic\">{{det.tot.tot_economic | currency:\"€\":2}}</div></td></tr><tr ng-repeat-end=\"\" class=\"row-sep\" ng-if=\"row.expanded\"><td colspan=\"16\"></td></tr><tr ng-if=\"filtered && filtered.length>0\"><td class=\"text-center\" colspan=\"3\">Totali</td><td class=\"text-right\"><div ng-if=\"viewMode().um\">[um] {{getTotals(filtered, \'gennaio\', \'tot\') | number: 2}}</div><div ng-if=\"viewMode().std\">[std] {{getTotals(filtered, \'gennaio\', \'tot_std\') | number: 2}}</div><div ng-if=\"viewMode().economic\">{{getTotals(filtered, \'gennaio\', \'tot_economic\') | currency:\'€\':2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">[um] {{getTotals(filtered, \'febbraio\', \'tot\') | number: 2}}</div><div ng-if=\"viewMode().std\">[std] {{getTotals(filtered, \'febbraio\', \'tot_std\') | number: 2}}</div><div ng-if=\"viewMode().economic\">{{getTotals(filtered, \'febbraio\', \'tot_economic\') | currency:\'€\':2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">[um] {{getTotals(filtered, \'marzo\', \'tot\') | number: 2}}</div><div ng-if=\"viewMode().std\">[std] {{getTotals(filtered, \'marzo\', \'tot_std\') | number: 2}}</div><div ng-if=\"viewMode().economic\">{{getTotals(filtered, \'marzo\', \'tot_economic\') | currency:\'€\':2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">[um] {{getTotals(filtered, \'aprile\', \'tot\') | number: 2}}</div><div ng-if=\"viewMode().std\">[std] {{getTotals(filtered, \'aprile\', \'tot_std\') | number: 2}}</div><div ng-if=\"viewMode().economic\">{{getTotals(filtered, \'aprile\', \'tot_economic\') | currency:\'€\':2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">[um] {{getTotals(filtered, \'maggio\', \'tot\') | number: 2}}</div><div ng-if=\"viewMode().std\">[std] {{getTotals(filtered, \'maggio\', \'tot_std\') | number: 2}}</div><div ng-if=\"viewMode().economic\">{{getTotals(filtered, \'maggio\', \'tot_economic\') | currency:\'€\':2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">[um] {{getTotals(filtered, \'giugno\', \'tot\') | number: 2}}</div><div ng-if=\"viewMode().std\">[std] {{getTotals(filtered, \'giugno\', \'tot_std\') | number: 2}}</div><div ng-if=\"viewMode().economic\">{{getTotals(filtered, \'giugno\', \'tot_economic\') | currency:\'€\':2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">[um] {{getTotals(filtered, \'luglio\', \'tot\') | number: 2}}</div><div ng-if=\"viewMode().std\">[std] {{getTotals(filtered, \'luglio\', \'tot_std\') | number: 2}}</div><div ng-if=\"viewMode().economic\">{{getTotals(filtered, \'luglio\', \'tot_economic\') | currency:\'€\':2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">[um] {{getTotals(filtered, \'agosto\', \'tot\') | number: 2}}</div><div ng-if=\"viewMode().std\">[std] {{getTotals(filtered, \'agosto\', \'tot_std\') | number: 2}}</div><div ng-if=\"viewMode().economic\">{{getTotals(filtered, \'agosto\', \'tot_economic\') | currency:\'€\':2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">[um] {{getTotals(filtered, \'settembre\', \'tot\') | number: 2}}</div><div ng-if=\"viewMode().std\">[std] {{getTotals(filtered, \'settembre\', \'tot_std\') | number: 2}}</div><div ng-if=\"viewMode().economic\">{{getTotals(filtered, \'settembre\', \'tot_economic\') | currency:\'€\':2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">[um] {{getTotals(filtered, \'ottobre\', \'tot\') | number: 2}}</div><div ng-if=\"viewMode().std\">[std] {{getTotals(filtered, \'ottobre\', \'tot_std\') | number: 2}}</div><div ng-if=\"viewMode().economic\">{{getTotals(filtered, \'ottobre\', \'tot_economic\') | currency:\'€\':2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">[um] {{getTotals(filtered, \'novembre\', \'tot\') | number: 2}}</div><div ng-if=\"viewMode().std\">[std] {{getTotals(filtered, \'novembre\', \'tot_std\') | number: 2}}</div><div ng-if=\"viewMode().economic\">{{getTotals(filtered, \'novembre\', \'tot_economic\') | currency:\'€\':2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">[um] {{getTotals(filtered, \'dicembre\', \'tot\') | number: 2}}</div><div ng-if=\"viewMode().std\">[std] {{getTotals(filtered, \'dicembre\', \'tot_std\') | number: 2}}</div><div ng-if=\"viewMode().economic\">{{getTotals(filtered, \'dicembre\', \'tot_economic\') | currency:\'€\':2}}</div></td><td class=\"text-right\"><div ng-if=\"viewMode().um\">[um] {{getTotals(filtered, \'tot\', \'tot\') | number: 2}}</div><div ng-if=\"viewMode().std\">[std] {{getTotals(filtered, \'tot\', \'tot_std\') | number: 2}}</div><div ng-if=\"viewMode().economic\">{{getTotals(filtered, \'tot\', \'tot_economic\') | currency:\'€\':2}}</div></td></tr></table></div></div></div><form class=\"wrapper m-t\"><div class=\"col-md-12\"><div class=\"row\" ng-if=\"percent > 0\"><div class=\"text-center-folded\"><span class=\"pull-right pull-none-folded\">{{percent | number : 0}}%</span> <span class=\"hidden-folded ng-scope\">Salvataggio</span></div><div class=\"progress-s m-t-sm dk progress ng-isolate-scope\" value=\"{{percent}}\" type=\"info\"><div class=\"progress-bar progress-bar-info\" ng-class=\"type &amp;&amp; \'progress-bar-\' + type\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: percent + \'%\'}\" aria-valuetext=\"0%\" style=\"width: {{percent}}%;\"></div></div></div></div></form><div class=\"panel-body\"><div id=\"messages\" class=\"row m-t\" ng-if=\"reportMessages.length\"><div class=\"panel-group\" id=\"accordion\"><div class=\"panel panel-default\" id=\"panel1\"><div class=\"panel-heading\"><h4 class=\"panel-title\">Messaggi</h4></div><div class=\"panel-body\"><div class=\"col-md-12\"><div id=\"gridReport\" ui-grid=\"reportGridOptions\" class=\"grid\" style=\"height: 420px\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\"></div></div></div></div></div></div></div></uib-tab><uib-tab index=\"1\"><uib-tab-heading><span class=\"fa fa-line-chart text-primary-dker\"></span> Grafici</uib-tab-heading><div class=\"col-md-12 m-t\" ng-class=\"{\'hidden\': !data.length}\"><six-multi-series-line-chart sx-graph-data=\"graphData\" sx-id=\"budgetGraph\" sx-y-axis-legend=\"\'Consumi\'\" sx-graph-title=\"Budget\"></six-multi-series-line-chart></div><div class=\"col-md-12 m-t\" ng-if=\"!data.length\"><div class=\"row\">Nessun grafico da mostrare</div></div></uib-tab><uib-tab index=\"2\" ng-if=\"false\"><uib-tab-heading><span class=\"fa fa-file-pdf-o text-warning-dker\"></span> Esportazioni</uib-tab-heading><div class=\"col-md-12 m-t\" ng-class=\"{\'hidden\': !data.length}\"><button ng-click=\"getPdf()\" class=\"btn btn-default btn-sm\" id=\"btn_pdf\"><span class=\"fa fa-file-pdf-o text-warning-dker\"></span> Scarica PDF</button> <button ng-click=\"getXlsx()\" class=\"btn btn-default btn-sm\" id=\"btn_xlsx\"><span class=\"fa fa-file-excel-o text-success-dker\"></span> Scarica XLSX</button> <button ng-click=\"getChart()\" class=\"btn btn-default btn-sm\" id=\"btn_chart\"><span class=\"fa fa-file-pdf-o text-danger-dker\"></span> Scarica Chart</button></div><div class=\"col-md-12 m-t\" ng-if=\"!data.length\"><div class=\"row\">Nessuna esportazione possibile</div></div></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("energy/budget/budget_eval.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" ng-click=\"goBack()\"></six-toolbar-button><six-toolbar-button label=\"Aggiorna\" btn-class=\"btn-info\" icon=\"fa fa-refresh\" toolbar-function=\"getData()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">ANALISI ECONOMICA</h1><small>{{budget.code}} - {{budget.description}} - {{budget.year}}</small></div></div></div><div class=\"row wrapper\"><div class=\"col-md-2\"><label class=\"control-label\">Da data:</label><p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"\" ng-model=\"datePicker.from\" is-open=\"statusFrom.opened\" datepicker-options=\"dateOptions\" ng-required=\"true\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openFrom($event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-2\"><label class=\"control-label\">A data:</label><p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"\" ng-model=\"datePicker.to\" is-open=\"statusTo.opened\" datepicker-options=\"dateOptions\" ng-required=\"true\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openTo($event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-2\"><label class=\"control-label\">Budget</label><six-select ng-model=\"budget\" sx-item-list=\"budgetList\"></six-select></div><div class=\"col-md-2\"><label for=\"type\" class=\"control-label\">Vettore energetico</label><six-lookup-2 ng-model=\"vector\" sx-type=\"\'vettoreenergetico\'\" sx-field=\"\'id\'\" sx-compact=\"true\" sx-item-template=\"\'{{item.description}}\'\"></six-lookup-2></div><div class=\"col-md-2\"><label id=\"type_label\" for=\"type\" class=\"control-label\">Tipo</label><six-lookup-2 id=\"type\" sx-base-path=\"\'schema\'\" ng-model=\"type\" sx-field=\"\'id\'\" sx-filter=\"recordTypeFilter\" sx-compact=\"true\" sx-item-template=\"\'{{item.description}}\'\"></six-lookup-2></div><div class=\"col-md-2\"><label id=\"contatoreId_label\" for=\"contatore_id\" class=\"control-label\">Contatore</label><six-lookup-2 id=\"contatore_id\" ng-model=\"record\" sx-type=\"type.id.UUID\" sx-field=\"\'id\'\"></six-lookup-2></div></div><div class=\"panel-body\"><div class=\"col-md-12\"><six-loading-place-holder sx-model=\"loadingPlaceHolder\" sx-height=\"\'450px\'\"></six-loading-place-holder></div><div class=\"row wrapper\" ng-if=\"!loadingPlaceHolder.show\"><div class=\"col-md-12\" ng-if=\"data && data.length > 0\"><div style=\"overflow:auto;\"><table class=\"detailTable table-hover\"><tr><th style=\"text-align: center; text-transform: none !important;\"></th><th ng-repeat=\"record in data\"><span ng-if=\"record.date\">{{record.date | date: \'MMM-yy\'}}</span> <span ng-if=\"!record.date\">Tot.</span></th></tr><tr><td>Budget [kWh]</td><td class=\"numberCell\" ng-repeat=\"record in data\"><span ng-if=\"record.bdg!==undefined\">{{record.bdg | number: 2}} kWh</span> <span ng-if=\"!record.bdg===undefined\">-</span></td></tr><tr><td>Consuntivo valorizzato [€]</td><td class=\"numberCell\" ng-repeat=\"record in data\"><span ng-if=\"record.consEval!==undefined\">{{record.consEval | currency:\'€\':2}}</span> <span ng-if=\"!record.consEval===undefined\">-</span></td></tr><tr><td>Budget valorizzato [€]</td><td class=\"numberCell\" ng-repeat=\"record in data\"><span ng-if=\"record.bdgEval!==undefined\">{{record.bdgEval | currency:\'€\':2}}</span> <span ng-if=\"!record.bdgEval===undefined\">-</span></td></tr><tr uib-tooltip=\"Budget valorizzato come consuntivo\" tooltip-placement=\"left\" tooltip-append-to-body=\"true\"><td>Budget attualizzato [€]</td><td class=\"numberCell\" ng-repeat=\"record in data\"><span ng-if=\"record.bdgEvalConsLike!==undefined\">{{record.bdgEvalConsLike | currency:\'€\':2}}</span> <span ng-if=\"!record.bdgEvalConsLike===undefined\">-</span></td></tr><tr uib-tooltip-html=\"\'Bdg attualizzato - Bdg valorizzato\'\" tooltip-placement=\"left\" tooltip-append-to-body=\"true\"><td>Fatt. revisione [€]</td><td class=\"numberCell\" ng-repeat=\"record in data\"><span ng-if=\"record.fattRevEuros!==undefined\">{{record.fattRevEuros | currency:\'€\':2}}</span> <span ng-if=\"!record.fattRevEuros===undefined\">-</span></td></tr><tr uib-tooltip-html=\"\'(Bdg attualizzato - Bdg valorizzato) / Bdg valorizzato * 100\'\" tooltip-placement=\"left\" tooltip-append-to-body=\"true\"><td>Fatt. revisione [%]</td><td class=\"numberCell\" ng-repeat=\"record in data\"><span ng-if=\"record.fattRevPerc!==undefined\">{{record.fattRevPerc | number: 2}} %</span> <span ng-if=\"!record.fattRevPerc===undefined\">-</span></td></tr><tr uib-tooltip-html=\"\'Consuntivo valorizzato - Bdg valorizzato\'\" tooltip-placement=\"left\" tooltip-append-to-body=\"true\"><td>Scostamento consuntivo [€]</td><td class=\"numberCell\" ng-repeat=\"record in data\"><span ng-if=\"record.consDiffEuros!==undefined\">{{record.consDiffEuros | currency:\'€\':2}}</span> <span ng-if=\"!record.consDiffEuros===undefined\">-</span></td></tr><tr uib-tooltip-html=\"\'(Consuntivo valorizzato - Bdg valorizzato) / Bdg valorizzato * 100\'\" tooltip-placement=\"left\" tooltip-append-to-body=\"true\"><td>Scostamento consuntivo [%]</td><td class=\"numberCell\" ng-repeat=\"record in data\"><span ng-if=\"record.consDiffPerc!==undefined\">{{record.consDiffPerc | number: 2}} %</span> <span ng-if=\"!record.consDiffPerc===undefined\">-</span></td></tr></table></div></div></div><div class=\"col-md-12 m-t\" ng-class=\"{\'hidden\': !graphData.length}\"><six-multi-series-line-chart sx-graph-data=\"graphData\" sx-id=\"data\" sx-y-axis-legend=\"\'Euro\'\" sx-graph-title=\"Valorizzazioni\"></six-multi-series-line-chart></div></div></div></div>");
$templateCache.put("energy/budget/budget_list.html","<style type=\"text/css\">\n  .hidden {\n    visibility: hidden;\n  }\n\n  .grid{\n    height: 800px;\n  }\n\n  .alignment{\n    padding-top: 28px;\n  }\n\n  .align-btn-row{\n    margin-top: 25px;\n  }\n\n  .padding-search-row{\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n</style><six-toolbar><six-toolbar-item label=\"Valorizza\" icon=\"fa fa-files-o text-primary-dker\" toolbar-function=\"getData(true)\" ng-show=\"budget.budget_code\"></six-toolbar-item><six-toolbar-item label=\"Aggiungi voci\" icon=\"fa fa-plus text-info-dker\" toolbar-function=\"addVoices()\" ng-show=\"budget.budget_code\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" ng-click=\"unselectBudget()\" ng-if=\"budget.budget_code\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"glyphicon glyphicon-save\" toolbar-function=\"update()\" ng-if=\"importingOperation === false && budget.searchCode.UUID\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" ng-if=\"budget.budget_code\" toolbar-function=\"deleteWithDialog(budget)\" sx-disabled=\"isDeletePermAllowed()===false\"></six-toolbar-button><six-toolbar-button label=\"Nuovo\" btn-class=\"btn-info\" icon=\"fa fa-plus\" toolbar-function=\"newBudget()\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-md-8\"><h1 class=\"m-n font-thin h3 text-black\">BUDGET</h1><small class=\"text-muted\" ng-if=\"!budget.budget_code\">Lista</small></div></div></div><div class=\"panel-body\" collapse=\"isCollapsed\"><div class=\"row wrapper\"><div class=\"col-md-3\"><label id=\"tipo_label\" for=\"record_type\" class=\"control-label\">Tipo</label><six-lookup id=\"record_type\" sx-base-path=\"\'schema\'\" ng-model=\"record\" sx-field=\"\'type_id\'\"></six-lookup></div><div class=\"col-md-3\"><label id=\"contatoreId_label\" for=\"record_id\" class=\"control-label\">Record</label><six-lookup id=\"record_id\" ng-model=\"record\" sx-type=\"record.type_id.UUID\" sx-field=\"\'record_id\'\"></six-lookup></div><div class=\"col-md-2\"><label id=\"year_label\" for=\"year\" class=\"control-label\">Anno</label><six-year-picker id=\"year\" ng-model=\"year\" sx-big=\"true\" class=\"input-group\"></six-year-picker></div><div class=\"col-md-1 align-btn-row\"><button id=\"btn_search\" ng-click=\"loadAvailableBudgetCodes()\" class=\"btn btn-info btn-sm pull-right padding-search-row\"><span class=\"fa fa-search\"></span> Cerca</button></div></div><div class=\"col-md-12\"><hr></div><div class=\"row\"><div class=\"col-md-12\"><div id=\"gridList\" ui-grid=\"gridListOptions\" class=\"grid\" ui-grid-resize-columns=\"\" ui-grid-auto-resize=\"\"></div></div></div></div></div></div>");
$templateCache.put("energy/budget/budget_new.html","<style type=\"text/css\">\n  .hidden {\n    visibility: hidden;\n  }\n</style><six-toolbar><six-toolbar-item label=\"Template\" icon=\"fa fa-download icon text-info-dker\" toolbar-function=\"downloadTemplate()\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Reset\" icon=\"fa fa-undo\" toolbar-function=\"reset()\" sx-disabled=\"importingOperation === false\"></six-toolbar-button><six-toolbar-button label=\"Importa\" icon=\"fa fa-upload\" toolbar-function=\"importData()\" btn-class=\"btn-success\" sx-disabled=\"importingOperation === false || percent === 100 || !budget.budget_code || !data || data.length === 0\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-12 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">BUDGET</h1><small class=\"text-muted\">{{budget.searchCode.code}}</small></div></div></div><div class=\"panel wrapper\"><div class=\"panel-body\"><form><div class=\"row form-group\"><div class=\"col-md-3\"><label id=\"code_label\" for=\"code\" class=\"control-label\">Codice</label> <input type=\"text\" id=\"code\" class=\"form-control\" ng-model=\"budget.budget_code\" ng-disabled=\"budget.searchCode.UUID\" ng-pattern=\"CODE_PATTERN\" required=\"\"></div><div class=\"col-md-5\"><label id=\"description_label\" for=\"description\" class=\"control-label\">Descrizione</label> <input type=\"text\" id=\"description\" class=\"form-control\" ng-model=\"budget.budget_description\" ng-disabled=\"budget.searchCode.UUID\"></div><div class=\"col-md-2\"><label id=\"date_label\" class=\"control-label\">Data di valorizzazione</label><six-date-time-picker id=\"budget_eval_date\" name=\"budget_eval_date\" ng-model=\"budget.eval_date\" enable-time=\"false\" sx-disabled=\"budget.searchCode.UUID\" date-options=\"dateOptions\"></six-date-time-picker></div><div class=\"col-md-2\"><label class=\"checkbox i-checks m-b col-md-12\"><input type=\"checkbox\" ng-model=\"budget.budget_default\" ng-disabled=\"budget.searchCode.UUID\"><i></i> <span class=\"i-checks\">Default</span></label></div><div class=\"col-md-2\"><a href=\"energy/attachments/template_budget.xls\" class=\"btn bg-info pull-right control-label hidden\" id=\"linkToTemplate\"><i class=\"fa fa-download\"></i> Template</a></div><div class=\"col-md-12\"><hr></div></div></form><div class=\"row\"><div class=\"col-md-12\"><div ui-grid=\"gridImportOptions\" class=\"grid\" ui-grid-resize-columns=\"\"><div class=\"grid-msg-overlay\" ng-show=\"!gridImportOptions.data.length\"><div class=\"msg\"><div class=\"center\"><span class=\"muted\">Selezionare File Excel</span><br><input type=\"file\" accept=\".xls,.xlsx,.ods\" xlsxreader=\"\" opts=\"gridImportOptions\" multiple=\"false\"></div></div></div></div></div></div><div class=\"col-md-12\"><div class=\"wrapper m-t\"><div class=\"row\" ng-if=\"percent > 0\"><div class=\"text-center-folded\"><span class=\"pull-right pull-none-folded\">{{percent | number : 0}}%</span> <span class=\"hidden-folded ng-scope\">Salvataggio</span></div><div class=\"progress-s m-t-sm dk progress ng-isolate-scope\" value=\"{{percent}}\" type=\"info\"><div class=\"progress-bar progress-bar-info\" ng-class=\"type &amp;&amp; \'progress-bar-\' + type\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: percent + \'%\'}\" aria-valuetext=\"0%\" style=\"width: {{percent}}%;\"></div></div></div></div></div></div><div class=\"panel-body\"><div id=\"messages\" class=\"row m-t\" ng-if=\"reportMessages.length\"><div class=\"panel-group\" id=\"accordion\"><div class=\"panel panel-default\" id=\"panel1\"><div class=\"panel-heading\"><h4 class=\"panel-title\">Messaggi</h4></div><div class=\"panel-body\"><div class=\"col-md-12\"><div id=\"gridReport\" ui-grid=\"reportGridOptions\" class=\"grid\" style=\"height: 420px\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\"></div></div></div></div></div></div></div></div></div>");
$templateCache.put("energy/budget/detail.html","<div class=\"col-md-12\"><div class=\"row\"><div class=\"col-sm-4\"><label>Tipo</label><p class=\"form-control-static\">{{detailSelected.record_type}}</p></div><div class=\"col-sm-6\"><label>Codice - Descrizione</label> <a href=\"{{detailSelected.record_url}}\"><p class=\"form-control-static\">{{detailSelected.record_code}} - {{detailSelected.record_description}}</p></a></div><div class=\"col-sm-2\"><label>Anno</label><p class=\"form-control-static\">{{detailSelected.anno}}</p></div></div></div><div class=\"col-md-12\"><hr></div><div class=\"col-md-12\"><table class=\"detailTable table-hover\"><tr><th style=\"text-align: center\" ng-repeat=\"column in detailSelected.subGridOptions.columnDefs\">{{column.name}}</th></tr><tr ng-repeat=\"data in detailSelected.subGridOptions.data | filter: \'!tot_std\'\"><td>{{data.record_code}}</td><td class=\"numberCell\" ng-repeat=\"month in [\'gennaio\', \'febbraio\', \'marzo\', \'aprile\', \'maggio\', \'giugno\', \'luglio\', \'agosto\', \'settembre\', \'ottobre\', \'novembre\', \'dicembre\']\">{{data[month] | number: 2}}</td><td class=\"numberCell\">{{data.tot | number: 2}}</td></tr><tr><td>Totale</td><td class=\"numberCell\" ng-repeat=\"month in [\'gennaio\', \'febbraio\', \'marzo\', \'aprile\', \'maggio\', \'giugno\', \'luglio\', \'agosto\', \'settembre\', \'ottobre\', \'novembre\', \'dicembre\']\"><b>{{detailSelected[month] | number: 2}}</b></td><td class=\"numberCell\"><b>{{detailSelected.tot | number: 2}}</b></td></tr></table></div><div class=\"col-md-12\"><hr></div><div class=\"col-md-12\"><table class=\"detailTable\"><tr><th style=\"text-align: center\">Fattore</th><th style=\"text-align: center\" ng-repeat=\"month in [\'gennaio\', \'febbraio\', \'marzo\', \'aprile\', \'maggio\', \'giugno\', \'luglio\', \'agosto\', \'settembre\', \'ottobre\', \'novembre\', \'dicembre\']\">{{month}}</th></tr><tr ng-repeat=\"data in detailSelected.subGridOptions.data | filter: \'!tot_std\'\"><td>{{data.record_code}}</td><td class=\"numberCell\" ng-repeat=\"month in [\'gennaio\', \'febbraio\', \'marzo\', \'aprile\', \'maggio\', \'giugno\', \'luglio\', \'agosto\', \'settembre\', \'ottobre\', \'novembre\', \'dicembre\']\"><slider ng-model=\"seasonFactor[data.record_code][month]\" orientation=\"vertical\" min=\"-1\" step=\"0.05\" max=\"1\" ng-change=\"\"></slider></td></tr></table></div><div class=\"col-md-12\"><hr></div>");
$templateCache.put("energy/budget/expandableRowTemplate.html","<div ui-grid=\"row.entity.subGridOptions\" ui-grid-resize-columns=\"\" style=\"height:240px;\"></div>");
$templateCache.put("energy/closure/closure.html","<div class=\"col-md-12 pad-t-15\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Wizard chiusura contatore</h1></div></div></div><div class=\"col-md-12 panel panel-default panel-body\"><div class=\"col-md-6\"><label class=\"m-t\">Tipo:</label><six-lookup id=\"record_type\" sx-base-path=\"\'schema\'\" ng-model=\"schema\" sx-field=\"\'id\'\"></six-lookup></div><div class=\"col-md-6\"><label class=\"m-t\">Contatore:</label><six-lookup id=\"record_id\" ng-model=\"record\" sx-type=\"schema.id.UUID\" sx-field=\"\'id\'\" sx-object=\"record.obj\"></six-lookup></div></div><div class=\"col-md-12 panel panel-default panel-body\"><div class=\"col-md-6\"><label class=\"m-t\">Codice:</label> <input type=\"text\" class=\"form-control\" readonly=\"\" value=\"{{record.obj.model.code}}\"></div><div class=\"col-md-6\"><label class=\"m-t\">Descrizione:</label> <input type=\"text\" class=\"form-control\" readonly=\"\" value=\"{{record.obj.model.description}}\"></div><div class=\"col-md-6\"><label class=\"m-t\">Stato:</label> <input type=\"text\" class=\"form-control\" readonly=\"\" value=\"{{record.obj.model.stato}}\"></div></div><div class=\"col-md-12 panel panel-default panel-body\" ng-if=\"record.obj && record.obj.model.stato===\'chiuso\'\"><div class=\"alert alert-warning\" role=\"alert\"><span class=\"font-bold\">ATTENZIONE</span>: il {{schema.id.description}} <span class=\"font-italic\">{{record.id.code}}</span> è già stato chiuso.</div></div><div class=\"col-md-12 panel panel-default panel-body\" ng-if=\"record.obj && record.obj.model.stato!==\'chiuso\'\"><label class=\"m-t\">Data chiusura:</label><p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"\" ng-model=\"datePicker.date\" is-open=\"dpStatus.opened\" datepicker-options=\"dateOptions\" ng-required=\"true\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"dpOpen()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=\"m-t\" ng-if=\"schema.id.code\">Ultima lettura:</div><div ng-if=\"schema.id.code === \'contatoreelettricita\'\"><div class=\"col-md-3\"><label class=\"m-t\">F0:</label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"read.f0\"> <span class=\"input-group-addon\">{{um.description}}</span></div></div><div class=\"col-md-3\"><label class=\"m-t\">F1:</label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"read.f1\"> <span class=\"input-group-addon\">{{um.description}}</span></div></div><div class=\"col-md-3\"><label class=\"m-t\">F2:</label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"read.f2\"> <span class=\"input-group-addon\">{{um.description}}</span></div></div><div class=\"col-md-3\"><label class=\"m-t\">F3:</label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"read.f3\"> <span class=\"input-group-addon\">{{um.description}}</span></div></div></div><div ng-if=\"schema.id.code === \'contatoregas\'\"><div class=\"col-md-6\"><label class=\"m-t\">F0:</label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"read.f0\"> <span class=\"input-group-addon\">{{um.description}}</span></div></div><div class=\"col-md-6\"><label class=\"m-t\">Correttore:</label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"read.correttore\"> <span class=\"input-group-addon\">{{um.description}}</span></div></div></div><div ng-if=\"schema.id.code === \'serbatoioinpressione\' || schema.id.code === \'serbatoiopressioneatmosferica\'\"><div class=\"col-md-6\"><label class=\"m-t\">F0:</label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"read.f0\"> <span class=\"input-group-addon\">{{um.description}}</span></div></div><div class=\"col-md-6\"><label class=\"m-t\">Scarico:</label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"read.scarico\"> <span class=\"input-group-addon\">{{um.description}}</span></div></div></div><div ng-if=\"schema.id.code && schema.id.code !== \'contatoreelettricita\' && schema.id.code !== \'contatoregas\' && schema.id.code !== \'serbatoioinpressione\' && schema.id.code !== \'serbatoiopressioneatmosferica\'\"><div class=\"col-md-12\"><label class=\"m-t\">F0:</label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"read.f0\"> <span class=\"input-group-addon\">{{um.description}}</span></div></div></div><button class=\"btn btn-info pull-right m-t\" ng-click=\"closeRecord()\" ng-disabled=\"!checkInputData()\">Chiudi</button></div></div></div>");
$templateCache.put("energy/consumptionanalysis/consumptionanalysis.html","<div id=\"loading-bar-container\"></div><style type=\"text/css\">\n  .menu-item-snap .header {\n    margin-right: 70px;\n  }\n\n  .menu-item-snap:hover {\n    background-color: #edf1f2 !important;\n  }\n\n  .menu-item-snap {\n    display: block;\n    padding: 5px 15px;\n    clear: both;\n    color: #333;\n    font-weight: normal;\n    line-height: 1.42857143;\n    white-space: nowrap;\n  }\n\n  .vector-heading {\n    border-radius: 2px 2px 0 0;\n    padding: 10px 15px;\n    border-bottom: 1px solid transparent;\n    border-top-left-radius: 3px;\n    border-top-right-radius: 3px;\n  }\n\n  .no-skin {\n    background-color: #f6f8f8;\n  }\n\n  six-toolbar-item .fa-check{\n    margin-right: 8px;\n  }\n  six-toolbar-item .invisible-check{\n    visibility:hidden;\n  }\n</style><script type=\"text/ng-template\" id=\"economicInfoTemplate.html\"><strong><span class=\"ngdialog-icon\"></span></strong> <div style=\"text-align: center;\"><h4 class=\"m-t-none m-b font-bold\">AVVISO</h4></div> <div class=\"wrapper\"> <div class=\"row\"> I dati mostrati potrebbero non contenere la valorizzazione economica del consuntivo. Aggiornare i dati con l\'apposito pulsante. </div> <div class=\"row text-center m-t\"> <a class=\"btn {{btnUpdate.class}}\" ng-click=\"reload()\" uib-tooltip=\"{{btnUpdate.label}}\" tooltip-placement=\"left\"><i class=\"fa fa-refresh\"></i></a> </div> </div></script><script type=\"text/ng-template\" id=\"vector-detail.html\"><div class=\"vector-heading\" ng-class=\"{\'bg-{{vector.model.skin}}\': vector.model.skin, \'no-skin\': !vector.model.skin}\"> <a class=\"pull-right font-bold\" ng-click=\"showInvolvedRecords(vector.cachedData.budget.consumptionInvolvedRecords, \'Contatori coinvolti a consuntivo\', true, \'A bdg\')\" ng-if=\"vector.cachedData.budget.consumptionInvolvedRecords.length>0\">{{vector.cachedData.budget.consumptionInvolvedRecords.length}} a consuntivo</a> <span class=\"pull-right font-bold\" ng-if=\"!vector.cachedData.budget.consumptionInvolvedRecords || vector.cachedData.budget.consumptionInvolvedRecords.length==0\">0 a consuntivo</span> <span class=\"pull-right font-bold m-l-xs m-r-xs\">/</span> <a class=\"pull-right font-bold\" ng-click=\"showInvolvedRecords(vector.cachedData.budget.involvedRecords, \'Contatori coinvolti a budget\', true, \'A cons.\')\" ng-if=\"vector.cachedData.budget.involvedRecords.length>0\">{{vector.cachedData.budget.involvedRecords.length}} a bdg</a> <span class=\"pull-right font-bold\" ng-if=\"!vector.cachedData.budget.involvedRecords || vector.cachedData.budget.involvedRecords.length==0\">0 a bdg</span> <span class=\"pull-right font-bold m-r-xs\">Contatori:</span> <a class=\"pull-right m-r-xs\" tooltip data-placement=\"top\" title=\"{{getWarningTooltip(vector)}}\" ng-if=\"getWarningTooltip(vector)\" ng-click=\"showInvolvedRecords(vector.cachedData.budget.consumptionInvolvedRecords, \'Contatori non a budget\', true, \'A bdg\', {check: false})\"><i class=\"fa fa-warning text-warning-dker\"></i></a> <h4 class=\"panel-title font-bold\">{{vector.model.description}}</h4> </div> <div class=\"col-md-12\"> <six-loading-place-holder sx-model=\"vector.loadingPlaceHolder\" sx-height=\"\'450px\'\"></six-loading-place-holder> </div> <div class=\"row m-t\" ng-if=\"!vector.loadingPlaceHolder.show\"> <div class=\"col-md-12\" ng-if=\"vector.cachedData.budget.toRender.list && vector.cachedData.budget.toRender.list.length > 0\"> <div style=\"overflow:auto;\"> <table class=\"detailTable table-hover\"> <tr> <th style=\"text-align: center; text-transform: none !important;\"></th> <th ng-repeat=\"record in vector.cachedData.budget.toRender.list\">{{record.date | date: \'MMM-yy\'}}</th> <th>Tot.</th> </tr> <tr ng-if=\"views.um\"> <td style=\"cursor: pointer\" ng-click=\"showInvolvedRecords(vector.cachedData.budget.involvedRecords, \'Contatori coinvolti a budget\', true, \'A cons.\')\">Budget [{{vector.model.um.code}}]</td> <td class=\"numberCell\" ng-repeat=\"record in vector.cachedData.budget.toRender.list\">{{record.budget | number: 3}}</td> <td class=\"numberCell\">{{vector.cachedData.budget.toRender.totalBudget | number: 3}}</td> </tr> <tr uib-tooltip=\"{{getWarningTooltip(vector)}}\" tooltip-placement=\"left\" tooltip-append-to-body=\"true\" style=\"cursor: hand\" ng-if=\"!vector.total && views.um\"> <td style=\"cursor: pointer\" ng-click=\"showInvolvedRecords(vector.cachedData.budget.consumptionInvolvedRecords, \'Contatori coinvolti a consuntivo\', true, \'A bdg\')\">Consuntivo [{{vector.model.um.code}}] <span class=\"pull-right m-r-xs\"><i ng-if=\"getWarningTooltip(vector)\" class=\"text-warning-dker fa fa-warning\"></i></span></td> <td class=\"numberCell\" ng-repeat=\"record in vector.cachedData.budget.toRender.list\">{{record.cons | number: 3}}</td> <td class=\"numberCell\">{{vector.cachedData.budget.toRender.totalConsumption | number: 3}}</td> </tr> <tr ng-if=\"currentVector != totVector && currentVector.model.code != \'elettricita\' && currentVector.model.code != \'tlr\' && currentVector.model.code != \'acqua\' && views.std\" uib-tooltip=\"{{getWarningTooltip(vector)}}\" tooltip-placement=\"left\" tooltip-append-to-body=\"true\"> <td style=\"cursor: pointer\" ng-click=\"showInvolvedRecords(vector.cachedData.budget.consumptionInvolvedRecords, \'Contatori coinvolti a consuntivo\', true, \'A bdg\')\">Consuntivo [kWh] <span class=\"pull-right m-r-xs\"><i ng-if=\"getWarningTooltip(vector)\" class=\"text-warning-dker fa fa-warning\"></i></span></td> <td class=\"numberCell\" ng-repeat=\"record in vector.cachedData.budget.list\">{{record.std.cons | number: 3}}</td> <td class=\"numberCell\">{{vector.cachedData.budget.totalConsumptionStd | number: 3}}</td> </tr> <tr ng-if=\"views.um\"> <td>Stagionalità [{{vector.model.um.code}}]</td> <td class=\"numberCell\" ng-repeat=\"record in vector.cachedData.budget.toRender.list\">{{record.season | number: 3}}</td> <td class=\"numberCell\">{{vector.cachedData.budget.toRender.season | number: 3}}</td> </tr> <tr ng-if=\"views.um\"> <td>&Delta; Stagionalità [{{vector.model.um.code}}]</td> <td class=\"numberCell\" ng-repeat=\"record in vector.cachedData.budget.toRender.list\">{{record.deltaSeason | number: 3}}</td> <td class=\"numberCell\">{{vector.cachedData.budget.toRender.deltaSeason | number: 3}}</td> </tr> <tr ng-if=\"views.um\"> <td>&Delta; Tecnico [{{vector.model.um.code}}]</td> <td class=\"numberCell\" ng-repeat=\"record in vector.cachedData.budget.toRender.list\">{{record.deltaTech | number: 3}}</td> <td class=\"numberCell\">{{vector.cachedData.budget.toRender.deltaTech | number: 3}}</td> </tr> <tr ng-if=\"views.um\"> <td>%</td> <td class=\"numberCell\" ng-repeat=\"record in vector.cachedData.budget.toRender.list\">{{record.percentage | number: 2}}</td> <td class=\"numberCell\">{{vector.cachedData.budget.toRender.percentage | number: 2}}</td> </tr> <tr ng-if=\"views.economic\"> <td style=\"cursor: pointer\" ng-click=\"showInvolvedRecords(vector.cachedData.budget.involvedRecords, \'Contatori coinvolti a budget\', true, \'A cons.\')\">Budget [€]</td> <td class=\"numberCell\" ng-repeat=\"record in vector.cachedData.budget.toRender.list\">{{record.budgetEconomic | currency:\'€\':2}}</td> <td class=\"numberCell\">{{vector.cachedData.budget.toRender.totalBudgetEconomic | currency:\'€\':2}}</td> </tr> <tr uib-tooltip=\"{{getWarningTooltip(vector, true)}}\" tooltip-placement=\"left\" tooltip-append-to-body=\"true\" style=\"cursor: hand\" ng-if=\"views.economic\"> <td style=\"cursor: pointer\" ng-click=\"showInvolvedRecords(vector.cachedData.budget.consumptionInvolvedRecords, \'Contatori coinvolti a consuntivo\', true, \'A bdg\')\">Consuntivo [€] <span class=\"pull-right m-r-xs\"><i ng-if=\"getWarningTooltip(vector)\" class=\"text-warning-dker fa fa-warning\"></i></span></td> <td class=\"numberCell\" ng-repeat=\"record in vector.cachedData.budget.toRender.list\">{{record.consEconomic | currency:\'€\':2}}</td> <td class=\"numberCell\">{{vector.cachedData.budget.toRender.totalConsEconomic | currency:\'€\':2}}</td> </tr> </table> </div> </div> </div> <div class=\"row m-t\"> <div class=\"col-md-12\"> <six-multi-series-line-chart sx-id=\"graph_{{vector.model.code}}\" sx-graph-data=\"vector.cachedData.graphData\" sx-y-axis-legend=\"\'Consumi\'\" sx-graph-title=\"{{vector.model.description}}\" sx-series-colors=\"[\'#1044EE\', \'#10BB99\', \'#EE2222\']\" sx-interpolate=\"\'monotone\'\"></six-multi-series-line-chart> </div> </div> <div class=\"row m-t\"> <div class=\"col-md-12\"> <six-multi-series-line-chart sx-id=\"graph_cum_{{vector.model.code}}\" sx-graph-data=\"vector.cachedData.graphDataCumulative\" sx-y-axis-legend=\"\'Consumi\'\" sx-graph-title=\"{{vector.model.description}} - cumulato\" sx-series-colors=\"[\'#1044EE\', \'#10BB99\']\" sx-interpolate=\"\'monotone\'\"></six-multi-series-line-chart> </div> </div></script><six-toolbar class=\"constructor\"><six-toolbar-item label=\"Vett. energ.\" icon=\"fa fa-bars\" toolbar-function=\"toggleSidebar()\"></six-toolbar-item><six-toolbar-item label=\"Snaps\" icon=\"fa fa-puzzle-piece icon text-success-dker\"><li><a ng-click=\"recreateAllSnapshots()\"><i class=\"fa fa-play fa-fw text-info-dker\"></i> Ricrea tutti</a></li><li class=\"dropdown-submenu\"><a ng-mouseover=\"loadBudgetSnapDate()\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-money fa-fw text-primary-dker\"></i> Budget <i class=\"fa fa-caret-right pull-right\"></i></a><ul class=\"dropdown-menu\"><li><a ng-click=\"createAllBudgetSnap()\" title=\"Ricrea tutti\"><i class=\"fa fa-cogs fa-fw text-info-dker m-r-xs\"></i> Ricrea bdg Snap (Tutti)</a></li><li><a ng-click=\"deleteBudgetSnap()\" title=\"Elimina tutti\"><i class=\"fa fa-trash fa-fw text-danger-lter m-r-xs\"></i> Elimina bdg Snap (Tutti)</a></li><li><div class=\"menu-item-snap\"><div class=\"pull-right\"><a class=\"fa fa-cog fa-fw text-info-dker\" ng-click=\"recreateBudgetSnap(undefined, \'ONLY_FILTERS\')\" title=\"Ricrea tutti\"></a> <a class=\"fa fa-trash fa-fw text-danger-lter\" ng-click=\"deleteBudgetSnap(undefined, \'ONLY_FILTERS\')\" title=\"Elimina tutti\"></a></div><div class=\"header\">Filtri <span class=\"text-muted\" ng-if=\"!filterBdgSnapDate\">- <i class=\"fa fa-spin fa-spinner\"></i></span> <span class=\"text-muted\" ng-if=\"filterBdgSnapDate\">- {{filterBdgSnapDate | date: \"dd/MM/yyyy HH:mm:ss\"}}</span></div></div></li><li ng-repeat=\"vector in allVectors\"><div class=\"menu-item-snap\"><div class=\"pull-right\"><a class=\"fa fa-cog fa-fw text-info-dker\" ng-click=\"recreateBudgetSnap(vector)\" title=\"Ricrea\"></a> <a class=\"fa fa-trash fa-fw text-danger-lter\" ng-click=\"deleteBudgetSnap(vector)\" title=\"Elimina\"></a></div><div class=\"header\">{{vector.model.description}} <span class=\"text-muted\" ng-if=\"!vector.bdgSnapDate\">- <i class=\"fa fa-spin fa-spinner\"></i></span> <span class=\"text-muted\" ng-if=\"vector.bdgSnapDate\">- {{vector.bdgSnapDate | date: \"dd/MM/yyyy HH:mm:ss\"}}</span></div></div></li></ul></li><li class=\"dropdown-submenu\"><a tabindex=\"-1\" href=\"#\"><i class=\"fa fa-globe fa-fw text-warning-dker\"></i> Zone Term. <i class=\"fa fa-caret-right pull-right\"></i></a><ul class=\"dropdown-menu\"><li><a ng-click=\"createZtSnap()\" title=\"Crea\"><i class=\"fa fa-cog fa-fw text-info-dker m-r-xs\"></i> Crea ZT Snap</a></li><li><a ng-click=\"deleteZtSnap()\" title=\"Elimina\"><i class=\"fa fa-trash fa-fw text-danger-lter m-r-xs\"></i> Elimina ZT Snap</a></li><li><a ng-click=\"recreateZtSnap()\" title=\"Ricrea\"><i class=\"fa fa-cogs fa-fw text-info-dker m-r-xs\"></i> Ricrea ZT Snap</a></li></ul></li><li class=\"dropdown-submenu\"><a ng-mouseover=\"loadDDSnapsDate()\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-sun-o fa-fw text-info-dker\"></i> GG <i class=\"fa fa-caret-right pull-right\"></i></a><ul class=\"dropdown-menu\"><li><a ng-click=\"createAllDDSnap()\" title=\"Ricrea tutti\"><i class=\"fa fa-cogs fa-fw text-info-dker m-r-xs\"></i> Ricrea GG Snap (Tutti)</a></li><li><a ng-click=\"deleteDDSnap()\" title=\"Elimina tutti\"><i class=\"fa fa-trash fa-fw text-danger-lter m-r-xs\"></i> Elimina GG Snap (Tutti)</a></li><li><div class=\"menu-item-snap\"><div class=\"pull-right\"><a class=\"fa fa-cog fa-fw text-info-dker\" ng-click=\"recreateDDSnap()\" title=\"Ricrea\"></a> <a class=\"fa fa-trash fa-fw text-danger-lter\" ng-click=\"deleteDDSnap()\" title=\"Elimina\"></a></div><div class=\"header\">Filtri <span class=\"text-muted\" ng-if=\"!filterDDSnapDate\">- <i class=\"fa fa-spin fa-spinner\"></i></span> <span class=\"text-muted\" ng-if=\"filterDDSnapDate\">- {{filterDDSnapDate | date: \"dd/MM/yyyy HH:mm:ss\"}}</span></div></div></li><li ng-repeat=\"vector in allVectors\"><div class=\"menu-item-snap\"><div class=\"pull-right\"><a class=\"fa fa-cog fa-fw text-info-dker\" ng-click=\"recreateDDSnap(vector)\" title=\"Ricrea\"></a> <a class=\"fa fa-trash fa-fw text-danger-lter\" ng-click=\"deleteDDSnap(vector)\" title=\"Elimina\"></a></div><div class=\"header\">{{vector.model.description}} <span class=\"text-muted\" ng-if=\"!vector.ddSnapDate\">- <i class=\"fa fa-spin fa-spinner\"></i></span> <span class=\"text-muted\" ng-if=\"vector.ddSnapDate\">- {{vector.ddSnapDate | date: \"dd/MM/yyyy HH:mm:ss\"}}</span></div></div></li></ul></li><li class=\"dropdown-submenu\"><a ng-mouseover=\"loadConsumptionsSnapsDate()\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-bolt fa-fw text-default-dker\"></i> Consumi <i class=\"fa fa-caret-right pull-right\"></i></a><ul class=\"dropdown-menu\"><li><a ng-click=\"createAllConsumptionsSnap()\" title=\"Ricrea tutti\"><i class=\"fa fa-cogs fa-fw text-info-dker m-r-xs\"></i> Ricrea Consumi Snap (Tutti)</a></li><li><a ng-click=\"deleteCommissionConsumptionsSnap()\" title=\"Elimina tutti\"><i class=\"fa fa-trash fa-fw text-danger-lter m-r-xs\"></i> Elimina Consumi Snap (Tutti)</a></li><li><div class=\"menu-item-snap\"><div class=\"pull-right\"><a class=\"fa fa-cog fa-fw text-info-dker\" ng-click=\"recreateConsumptionsSnap(undefined, \'ONLY_FILTERS\')\" title=\"Ricrea\"></a> <a class=\"fa fa-trash fa-fw text-danger-lter\" ng-click=\"deleteConsumptionsSnap(undefined, \'ONLY_FILTERS\')\" title=\"Elimina\"></a></div><div class=\"header\">Filtri <span class=\"text-muted\" ng-if=\"!filterConsumptionsSnapDate\">- <i class=\"fa fa-spin fa-spinner\"></i></span> <span class=\"text-muted\" ng-if=\"filterConsumptionsSnapDate\">- {{filterConsumptionsSnapDate | date: \"dd/MM/yyyy HH:mm:ss\"}}</span></div></div></li><li ng-repeat=\"vector in allVectors\"><div class=\"menu-item-snap\"><div class=\"pull-right\"><a class=\"fa fa-cog fa-fw text-info-dker\" ng-click=\"recreateConsumptionsSnap(vector)\" title=\"Ricrea\"></a> <a class=\"fa fa-trash fa-fw text-danger-lter\" ng-click=\"deleteConsumptionsSnap(vector)\" title=\"Elimina\"></a></div><div class=\"header\">{{vector.model.description}} <span class=\"text-muted\" ng-if=\"!vector.consumptionsSnapDate\">- <i class=\"fa fa-spin fa-spinner\"></i></span> <span class=\"text-muted\" ng-if=\"vector.consumptionsSnapDate\">- {{vector.consumptionsSnapDate | date: \"dd/MM/yyyy HH:mm:ss\"}}</span></div></div></li></ul></li><li class=\"dropdown-submenu\"><a ng-mouseover=\"loadConsAnalysisSnapsDate()\" tabindex=\"-1\" href=\"#\"><i class=\"fa fa-bar-chart fa-fw text-success-dker\"></i> Analisi <i class=\"fa fa-caret-right pull-right\"></i></a><ul class=\"dropdown-menu\"><li><a ng-click=\"createAllConsAnalysisSnap()\" title=\"Ricrea tutti\"><i class=\"fa fa-cogs fa-fw text-info-dker m-r-xs\"></i> Ricrea Analisi Snap (Tutti)</a></li><li><a ng-click=\"deleteCommissionConsAnalysisSnap()\" title=\"Elimina tutti\"><i class=\"fa fa-trash fa-fw text-danger-lter m-r-xs\"></i> Elimina Analisi Snap (Tutti)</a></li><li><div class=\"menu-item-snap\"><div class=\"pull-right\"><a class=\"fa fa-cog fa-fw text-info-dker\" ng-click=\"recreateConsAnalysisSnap(undefined, \'ONLY_FILTERS\')\" title=\"Ricrea\"></a> <a class=\"fa fa-trash fa-fw text-danger-lter\" ng-click=\"deleteConsAnalysisSnap()\" title=\"Elimina\"></a></div><div class=\"header\">Filtri <span class=\"text-muted\" ng-if=\"!filterConsAnalysisSnapDate\">- <i class=\"fa fa-spin fa-spinner\"></i></span> <span class=\"text-muted\" ng-if=\"filterConsAnalysisSnapDate\">- {{filterConsAnalysisSnapDate | date: \"dd/MM/yyyy HH:mm:ss\"}}</span></div></div></li><li ng-repeat=\"vector in allVectors\"><div class=\"menu-item-snap\"><div class=\"pull-right\"><a class=\"fa fa-cog fa-fw text-info-dker\" ng-click=\"recreateConsAnalysisSnap(vector)\" title=\"Ricrea\"></a> <a class=\"fa fa-trash fa-fw text-danger-lter\" ng-click=\"deleteConsAnalysisSnap(vector)\" title=\"Elimina\"></a></div><div class=\"header\">{{vector.model.description}} <span class=\"text-muted\" ng-if=\"!vector.consAnalysisSnapDate\">- <i class=\"fa fa-spin fa-spinner\"></i></span> <span class=\"text-muted\" ng-if=\"vector.consAnalysisSnapDate\">- {{vector.consAnalysisSnapDate | date: \"dd/MM/yyyy HH:mm:ss\"}}</span></div></div></li></ul></li></six-toolbar-item><six-toolbar-item label=\"Vista\" icon=\"fa fa-eye icon text-success-dker\"><li><a href=\"\" ng-click=\"viewMode(\'um\')\"><i class=\"fa fa-check fa-fw text-success-dker\" ng-class=\"{\'invisible-check\': (viewMode().um == false)}\"></i> Valori</a></li><li><a href=\"\" ng-click=\"viewMode(\'std\')\"><i class=\"fa fa-check fa-fw text-success-dker\" ng-class=\"{\'invisible-check\': (viewMode().std == false)}\"></i> Std</a></li><li><a href=\"\" ng-click=\"viewMode(\'economic\')\"><i class=\"fa fa-check fa-fw text-success-dker\" ng-class=\"{\'invisible-check\': (viewMode().economic == false)}\"></i> Economico</a></li></six-toolbar-item><six-toolbar-button label=\"PDF\" btn-class=\"btn-default\" icon=\"fa fa-file-pdf-o\" toolbar-function=\"openDialogReport(\'pdf\')\"></six-toolbar-button><six-toolbar-button label=\"Excel\" btn-class=\"btn-default\" icon=\"fa fa-file-excel-o\" toolbar-function=\"openDialogReport(\'xlsx\')\"></six-toolbar-button><six-toolbar-button btn-class=\"{{btnUpdate.class}}\" icon=\"fa fa-refresh icon\" toolbar-function=\"checkAndLoadVectors()\" uib-tooltip=\"{{btnUpdate.label}}\" tooltip-placement=\"left\"></six-toolbar-button></six-toolbar><six-sidebar sx-id=\"vectors_sidebar\" sx-position=\"left\" sx-title=\"\'Vettori\'\" sx-dimension=\"s\" sx-opened=\"sidebar\"><ul id=\"list-sidebar-ul\" class=\"nav list-sidebar-nav\"><li class=\"m-l-xs m-r-xs\"><a ng-click=\"goToAnchor(\'top\')\">Top</a></li><li ng-repeat=\"vector in vectors\" class=\"m-l-xs m-r-xs\"><a ng-click=\"goToAnchor(vector.model.code+\'_details\')\" six-sidebar-autoclose=\"true\">{{vector.model.description}} <span class=\"badge\">{{vector.cachedData.budget.involvedRecords.length}}</span></a></li></ul></six-sidebar><div id=\"top\" class=\"constructor\"><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">ANALISI CONSUMI</h1><small class=\"text-muted\" ng-if=\"budget.list && budget.list.length > 0\">Cod. Commessa ({{info.commissions.current.code}}): {{type.type_id.description}} - {{contatore.contatore_id.description}} - Cod. Budget: {{analysisHeaderInfos.budgets}} (Periodo: {{analysisHeaderInfos.period.from}} - {{analysisHeaderInfos.period.to}})</small> <small class=\"text-muted\" ng-if=\"!budget.list || budget.list.length <= 0\">Selezionare un budget</small></div></div></div><div class=\"panel-body\"><div class=\"row wrapper\"><div class=\"col-md-2\"><label class=\"control-label\">Vettore energetico</label><six-lookup-2 sx-id=\"vetten\" ng-model=\"vector\" sx-type=\"\'vettoreenergetico\'\" sx-field=\"\'id\'\" sx-object=\"currentVector\"></six-lookup-2></div><div class=\"col-md-2\"><label id=\"type_label\" class=\"control-label\">Tipo</label><six-lookup-2 sx-id=\"type\" sx-base-path=\"\'schema\'\" ng-model=\"type\" sx-title=\"\'Tipo\'\" sx-field=\"\'type_id\'\" sx-filter=\"contatoreTypeFilter\"></six-lookup-2></div><div class=\"col-md-2\"><label id=\"contatoreId_label\" class=\"control-label\">Contatore</label><six-lookup-2 sx-id=\"contatore\" ng-model=\"contatore\" sx-type=\"type.type_id.UUID\" sx-field=\"\'contatore_id\'\"></six-lookup-2></div><div class=\"col-md-2\"><label class=\"control-label\">Da data:</label><p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"\" ng-model=\"datePicker.from\" is-open=\"statusFrom.opened\" datepicker-options=\"dateOptionsStart\" ng-required=\"true\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openFrom($event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-2\"><label class=\"control-label\">A data:</label><p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"\" ng-model=\"datePicker.to\" is-open=\"statusTo.opened\" datepicker-options=\"dateOptionsEnd\" ng-required=\"true\" close-text=\"Close\" ng-change=\"setEndDate()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openTo($event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-2\"><label class=\"control-label\">Budget</label><six-select-2 sx-id=\"search_budget_code\" ng-model=\"selectedBudgets\" sx-field=\"\'selected\'\" sx-list=\"availableBudgetCodes\" sx-key=\"\'UUID\'\" sx-item-template=\"\'{{item.description}}\'\" sx-compact=\"false\" sx-multiple=\"true\" sx-pinnable=\"false\" sx-position=\"\'right\'\"></six-select-2></div></div><div class=\"col-md-12\"><hr style=\"margin: 0px\"></div></div><div class=\"panel-body\" style=\"padding-top: 0px !important; padding-bottom: 0px !important\" ng-repeat=\"vector in vectors\"><div class=\"row wrapper\"><div ng-include=\"\'vector-detail.html\'\" id=\"{{vector.model.code}}_details\"></div></div></div></div></div></div>");
$templateCache.put("energy/consumptionanalysis/consumptionanalysiscross.html","<div id=\"loading-bar-container\"></div><six-toolbar class=\"constructor\"><six-toolbar-button label=\"Stampa PDF\" btn-class=\"btn-default\" icon=\"fa fa-print\" toolbar-function=\"openDialogReport(\'pdf\')\"></six-toolbar-button><six-toolbar-button label=\"Stampa Excel\" btn-class=\"btn-default\" icon=\"fa fa-file-excel-o\" toolbar-function=\"openDialogReport(\'xlsx\')\"></six-toolbar-button></six-toolbar><six-sidebar sx-id=\"vectors_sidebar\" sx-position=\"left\" sx-title=\"\'Vettori\'\" sx-dimension=\"s\" sx-opened=\"sidebar\"><ul id=\"list-sidebar-ul\" class=\"nav list-sidebar-nav\"><li class=\"m-l-xs m-r-xs\"><a ng-click=\"goToAnchor(\'top\')\">Top</a></li><li ng-repeat=\"vector in vectors\" class=\"m-l-xs m-r-xs\"><a ng-click=\"goToAnchor(vector.model.code+\'_details\')\" six-sidebar-autoclose=\"true\">{{vector.model.description}}</a></li></ul></six-sidebar><div id=\"top\" class=\"constructor\"><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">ANALISI CONSUMI MULTICOMMESSA</h1></div></div></div><div class=\"panel-body\"><div class=\"row wrapper\"><div class=\"col-md-4\"><label class=\"control-label\">Commessa</label><six-select-2 sx-id=\"commission_list\" sx-list=\"commissionList\" sx-title=\"\'Commessa\'\" ng-model=\"commissions\" sx-field=\"\'selected\'\" sx-placeholder=\"\'commessa...\'\" sx-multiple=\"true\"></six-select-2></div><div class=\"col-md-2\"><label class=\"control-label\">Vettore energetico</label><six-lookup-2 sx-id=\"vetten\" ng-model=\"vector\" sx-type=\"\'vettoreenergetico\'\" sx-field=\"\'id\'\" sx-object=\"currentVector\"></six-lookup-2></div><div class=\"col-md-2\"><label id=\"type_label\" class=\"control-label\">Tipo</label><six-lookup-2 sx-id=\"type\" sx-base-path=\"\'schema\'\" ng-model=\"type\" sx-title=\"\'Tipo\'\" sx-field=\"\'type_id\'\" sx-filter=\"contatoreTypeFilter\"></six-lookup-2></div><div class=\"col-md-2\"><label class=\"control-label\">Da data:</label><p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"\" ng-model=\"datePicker.from\" is-open=\"statusFrom.opened\" datepicker-options=\"dateOptionsStart\" ng-required=\"true\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openFrom($event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-2\"><label class=\"control-label\">A data:</label><p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"\" ng-model=\"datePicker.to\" is-open=\"statusTo.opened\" datepicker-options=\"dateOptionsEnd\" ng-required=\"true\" close-text=\"Close\" ng-change=\"setEndDate()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openTo($event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div></div></div></div>");
$templateCache.put("energy/consumptive/consumptive.html","<style type=\"text/css\">\n  .summaryTable {\n    width:100%;\n    border: 1px solid lightblue;\n  }\n  .summaryTable th {\n    text-align: center;\n  }\n  .summaryTable td {\n    width: 20%;\n    padding: 3px;\n    border: 1px solid lightgrey;\n    text-align: center;\n  }\n  .summaryTable td:first-child {\n    text-align: left;\n    background-color: #fafbfc;\n    font-weight: 800;\n  }\n  .resetRead {\n    background-color: rgba(81, 253, 0, 0.24) !important;\n    color: #58666e !important;\n  }\n  .warningRead {\n    background-color: rgb(239, 253, 80) !important;\n    color: #58666e !important;\n  }\n  .errorRead {\n    background-color: rgb(253, 90, 78) !important;\n    color: white !important;\n  }\n  .automaticRead {\n    background-color: rgb(218, 234, 255) !important;\n    color: #58666e !important;\n  }\n\n  .floating-btn {\n    z-index: 9999999;\n  }\n  .floating-btn a {\n    color: #58666e;\n    background-color: #fff;\n  }\n\n  .padded {\n    margin-left: 280px;\n  }\n\n  .selected {\n    background-color: #11c7f5 !important;\n  }\n\n  .bg-messages-header {\n    background-color: #e8faff !important;\n  }\n\n  .perm-table-check {\n    padding-right: 5px;\n  }\n  .perm-table-perm {\n    padding-left: 5px;\n    text-align: left;\n    font-weight: bold\n  }\n\n  .closed-record {\n    color: #98a6ad !important;\n  }\n</style><script type=\"text/ng-template\" id=\"summary-view.html\"><table class=\"summaryTable\"> <tr> <th>Fascia</th> <th>Consumo</th> <th>€</th> <th>Giorni</th> <th>Cons. giorn. medio</th> </tr> <tr ng-repeat=\"(key, slot) in totalPeriodConsumptions\"> <td ng-if=\"key !== \'totale\'\">{{key}}</td> <td ng-if=\"key === \'totale\'\">Tot.</td> <td>{{slot | number: 3}}</td> <td> <span ng-if=\"totalEvaluatedPeriodConsumptions[key]\">{{totalEvaluatedPeriodConsumptions[key] | number: 2}}</span> <span ng-if=\"!totalEvaluatedPeriodConsumptions[key]\">-</span> </td> <td>{{totalPeriodDays}}</td> <td>{{slot/totalPeriodDays | number: 3}}</td> </tr> </table></script><script type=\"text/ng-template\" id=\"month-view.html\"><table style=\"width:100%\" class=\"m-t-xs m-b-xs\"> <thead> <tr> <th>Fascia</th> <th ng-repeat=\"day in getTimes(daysInMonth(selectedMonthDetail.year, selectedMonthDetail.month))\" class=\"dayCl\"> <div class=\"dayHeader\">{{day+1}}</div> </th> </tr> </thead> <tbody> <tr ng-repeat=\"(idx, consElem) in (dailyConsumptions[selectedMonthDetail.year][selectedMonthDetail.month][0]).slotted\"> <td>{{(dailyConsumptions[selectedMonthDetail.year][selectedMonthDetail.month][0]).slotted[idx].time_slot}}</td> <td ng-repeat=\"day in getTimes(daysInMonth(selectedMonthDetail.year, selectedMonthDetail.month))\" class=\"dayCl\" ng-class=\"{\'budget\': (dailyConsumptions[selectedMonthDetail.year][selectedMonthDetail.month][day]).type === TYPE_BDG}\"> <span tooltip data-placement=\"top\" title=\"{{((dailyConsumptions[selectedMonthDetail.year][selectedMonthDetail.month][day]).type === TYPE_BDG)?\'Da budget\':\'Da consuntivo\'}} ({{(dailyConsumptions[selectedMonthDetail.year][selectedMonthDetail.month][day]).slotted[idx].consumption | number: 4}})\" ng-if=\"(dailyConsumptions[selectedMonthDetail.year][selectedMonthDetail.month][day]).type !== undefined\"> {{(dailyConsumptions[selectedMonthDetail.year][selectedMonthDetail.month][day]).slotted[idx].consumption | number: 0}} </span> <span tooltip data-placement=\"top\" title=\"No data\" ng-if=\"(dailyConsumptions[selectedMonthDetail.year][selectedMonthDetail.month][day]).type === undefined\"> - </span> </td> </tr> <tr> <td>Totale</td> <td ng-repeat=\"day in getTimes(daysInMonth(selectedMonthDetail.year, selectedMonthDetail.month))\" class=\"dayCl\" ng-class=\"{\'budget\': (dailyConsumptions[selectedMonthDetail.year][selectedMonthDetail.month][day]).type === TYPE_BDG}\"> <span tooltip data-placement=\"top\" title=\"{{((dailyConsumptions[selectedMonthDetail.year][selectedMonthDetail.month][day]).type === TYPE_BDG)?\'Da budget\':\'Da consuntivo\'}} ({{(dailyConsumptions[selectedMonthDetail.year][selectedMonthDetail.month][day]).total | number: 4}})\" ng-if=\"(dailyConsumptions[selectedMonthDetail.year][selectedMonthDetail.month][day]).type !== undefined\"> {{(dailyConsumptions[selectedMonthDetail.year][selectedMonthDetail.month][day]).total | number: 0}} </span> <span tooltip data-placement=\"top\" title=\"No data\" ng-if=\"(dailyConsumptions[selectedMonthDetail.year][selectedMonthDetail.month][day]).type === undefined\"> - </span> </td> </tr> </tbody> </table></script><script type=\"text/ng-template\" id=\"permissionsInfoTemplate.html\"><strong><span class=\"ngdialog-icon\"></span></strong> <div style=\"text-align: center;\"><h4 class=\"m-t-none m-b font-bold\">Permessi</h4></div> <div class=\"row m-t\"> <table align=\"center\" style=\"text-align: left;\"> <tr> <td class=\"perm-table-check\"><i class=\"fa\" ng-class=\"{\'fa-check-circle-o text-success-dker\': isWritePermAllowed(), \'fa-times-circle-o text-danger-dker\': !isWritePermAllowed()}\"></i></td> <td class=\"perm-table-perm\">Aggiungere letture</td> </tr> <tr> <td class=\"perm-table-check\"><i class=\"fa\" ng-class=\"{\'fa-check-circle-o text-success-dker\': isWritePermAllowed(), \'fa-times-circle-o text-danger-dker\': !isWritePermAllowed()}\"></i></td> <td class=\"perm-table-perm\">Modificare letture</td> </tr> <tr> <td class=\"perm-table-check\"><i class=\"fa\" ng-class=\"{\'fa-check-circle-o text-success-dker\': isWritePermAllowed(), \'fa-times-circle-o text-danger-dker\': !isDeletePermAllowed()}\"></i></td> <td class=\"perm-table-perm\">Eliminare letture</td> </tr> <tr> <td class=\"perm-table-check\"><i class=\"fa\" ng-class=\"{\'fa-check-circle-o text-success-dker\': modifyOldAllowed(), \'fa-times-circle-o text-danger-dker\': !modifyOldAllowed()}\"></i></td> <td class=\"perm-table-perm\">Aggiungere letture prima del {{limit | date:\'yyyy-MM-dd\'}}</td> </tr> <tr> <td class=\"perm-table-check\"><i class=\"fa\" ng-class=\"{\'fa-check-circle-o text-success-dker\': modifyOldAllowed(), \'fa-times-circle-o text-danger-dker\': !modifyOldAllowed()}\"></i></td> <td class=\"perm-table-perm\">Modificare letture prima del {{limit | date:\'yyyy-MM-dd\'}}</td> </tr> <tr> <td class=\"perm-table-check\"><i class=\"fa\" ng-class=\"{\'fa-check-circle-o text-success-dker\': modifyOldAllowed(), \'fa-times-circle-o text-danger-dker\': !modifyOldAllowed()}\"></i></td> <td class=\"perm-table-perm\">Eliminare letture prima del {{limit | date:\'yyyy-MM-dd\'}}</td> </tr> <tr> <td class=\"perm-table-check\"><i class=\"fa\" ng-class=\"{\'fa-check-circle-o text-success-dker\': isWritePermAllowed(), \'fa-times-circle-o text-danger-dker\': !isWritePermAllowed()}\"></i></td> <td class=\"perm-table-perm\">Aggiungere consumi</td> </tr> <tr> <td class=\"perm-table-check\"><i class=\"fa\" ng-class=\"{\'fa-check-circle-o text-success-dker\': isWritePermAllowed(), \'fa-times-circle-o text-danger-dker\': !isWritePermAllowed()}\"></i></td> <td class=\"perm-table-perm\">Modificare consumi</td> </tr> <tr> <td class=\"perm-table-check\"><i class=\"fa\" ng-class=\"{\'fa-check-circle-o text-success-dker\': isWritePermAllowed(), \'fa-times-circle-o text-danger-dker\': !isDeletePermAllowed()}\"></i></td> <td class=\"perm-table-perm\">Eliminare consumi</td> </tr> <tr> <td class=\"perm-table-check\"><i class=\"fa\" ng-class=\"{\'fa-check-circle-o text-success-dker\': modifyOldAllowed(), \'fa-times-circle-o text-danger-dker\': !modifyOldAllowed()}\"></i></td> <td class=\"perm-table-perm\">Aggiungere consumi prima del {{limit | date:\'yyyy-MM-dd\'}}</td> </tr> <tr> <td class=\"perm-table-check\"><i class=\"fa\" ng-class=\"{\'fa-check-circle-o text-success-dker\': modifyOldAllowed(), \'fa-times-circle-o text-danger-dker\': !modifyOldAllowed()}\"></i></td> <td class=\"perm-table-perm\">Modificare consumi prima del {{limit | date:\'yyyy-MM-dd\'}}</td> </tr> <tr> <td class=\"perm-table-check\"><i class=\"fa\" ng-class=\"{\'fa-check-circle-o text-success-dker\': modifyOldAllowed(), \'fa-times-circle-o text-danger-dker\': !modifyOldAllowed()}\"></i></td> <td class=\"perm-table-perm\">Eliminare consumi prima del {{limit | date:\'yyyy-MM-dd\'}}</td> </tr> </table> </div></script><six-toolbar><six-toolbar-item icon=\"{{getIconPerm()}}\" label-class=\"text-info-dker\" label=\"{{getLabelPerm()}}\" toolbar-function=\"showPermissions()\"></six-toolbar-item><six-toolbar-button btn-class=\"btn-default\" toolbar-function=\"back()\" label=\"\" icon=\"fa fa-chevron-left\"></six-toolbar-button><six-toolbar-button btn-class=\"btn-info\" toolbar-function=\"goToUpdateRegistrationNumber()\" label=\"Sost. cont.\" icon=\"fa fa-exchange\" ng-show=\"isWritePermAllowed()\" sx-disabled=\"isWritePermAllowed()===false || isClosed() || !contatoreType.tipo_id || !contatore.contatore_id\"></six-toolbar-button><six-toolbar-button btn-class=\"btn-warning\" toolbar-function=\"goToClosure()\" label=\"Chiudi cont.\" icon=\"fa fa-ban\" ng-show=\"isWritePermAllowed()\" sx-disabled=\"isWritePermAllowed()===false || isClosed() || !contatoreType.tipo_id || !contatore.contatore_id\"></six-toolbar-button><six-toolbar-button btn-class=\"btn-success\" toolbar-function=\"importData()\" label=\"Importa\" icon=\"fa fa-upload\" ng-show=\"isWritePermAllowed() && selectedTab===\'read\'\" sx-disabled=\"importingOperation === false || isImportBusy === true || isAllOk === false || isWritePermAllowed() === false || isClosed() || !viewGridOptions.data.length\"></six-toolbar-button><six-toolbar-button btn-class=\"btn-default\" toolbar-function=\"resetGrid()\" label=\"Reset\" icon=\"fa fa-history\" ng-show=\"isWritePermAllowed() && selectedTab===\'read\'\"></six-toolbar-button></six-toolbar><six-sidebar sx-id=\"list-sidebar\" sx-position=\"left\" sx-dimension=\"m\" sx-opened=\"isSidebarOpened\" sx-pinned=\"isPinned\" sx-class=\"override-custom-top-toolbar\" sx-show-title=\"false\"><div class=\"m-xs\"><six-lookup-2 ng-model=\"contatoreType\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" sx-field=\"\'tipo_id\'\" sx-filter=\"contatoreTypeFilter\" sx-compact=\"true\" sx-item-template=\"\'{{item.description}}\'\" sx-placeholder=\"\'Tipo...\'\"></six-lookup-2></div><ul class=\"nav list-sidebar-nav\"><li ng-if=\"!recordList || recordList.length == 0\"><a><span ng-if=\"contatoreType && contatoreType.tipo_id && contatoreType.tipo_id.description\">Nessun {{contatoreType.tipo_id.description}} caricato</span> <span ng-if=\"!contatoreType || !contatoreType.tipo_id || !contatoreType.tipo_id.description\">Selezionare un tipo di contatore</span></a></li><span ng-if=\"recordList && recordList.length > 0\"><li><div class=\"form-group m-l-xs m-r-xs\"><six-search-form ng-model=\"recordSearchText.text\" placeholder=\"Filtra...\" show-search-btn=\"false\"></six-search-form></div></li><li ng-repeat=\"record in recordList | filter:recordSearchText.text\"><a ng-click=\"selectRecord(record.UUID, record.model.code, record.model.description)\" title=\"{{record.model.code}} - {{record.model.description}} - {{record.model.stato | uppercase}}\" ng-class=\"{\'selected\': isRecordSelected(record.UUID), \'closed-record\': record.model.stato==\'chiuso\'}\">{{record.model.code}} - {{record.model.description}}</a></li></span></ul></six-sidebar><nav class=\"floating-btn\" mfb-menu=\"\" position=\"bl\" effect=\"zoomin\" label=\"Contatori\" active-icon=\"fa {{isSidebarOpened?\'fa-chevron-left\':\'fa-chevron-right\'}}\" resting-icon=\"fa fa-columns\" toggling-method=\"hover\" ng-click=\"toggleSidebar()\"></nav><div class=\"constructor\"><div class=\"wrapper override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-4 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">CONSUNTIVO</h1></div><div class=\"col-sm-8 col-xs-6 text-right\"><h4 class=\"m-n\" ng-if=\"contatoreType.tipo_id.description && contatore.contatore_id.code && contatore.contatore_id.description\">{{contatoreType.tipo_id.description}} - <a href=\"\" ng-click=\"goToRecordDetails()\" title=\"Vai al dettaglio\">{{contatore.contatore_id.code}} - {{contatore.contatore_id.description}}</a> <span ng-if=\"contatore.obj.model.stato\">- <span class=\"text-u-c\" ng-class=\"{\'text-danger\': contatore.obj.model.stato===\'chiuso\', \'text-success\': contatore.obj.model.stato===\'aperto\'}\">{{contatore.obj.model.stato}}</span></span> <a class=\"m-l\" ng-click=\"goToRecordDetails()\" title=\"Vai al dettaglio contatore\"><i class=\"fa fa-external-link text-info-dker\"></i></a></h4></div></div></div><div class=\"panel-body\"><div class=\"row wrapper\"><div class=\"row wrapper\" ng-if=\"isSidebarOpened==false\"><div class=\"col-md-3\"><label class=\"control-label\">Tipo</label><six-lookup-2 sx-id=\"type\" ng-model=\"contatoreType\" sx-base-path=\"\'schema\'\" sx-field=\"\'tipo_id\'\" sx-filter=\"contatoreTypeFilter\" sx-compact=\"true\" sx-item-template=\"\'{{item.description}}\'\"></six-lookup-2></div><div class=\"col-md-3\"><label class=\"control-label\">Contatore</label><six-lookup-2 sx-id=\"contatore\" ng-model=\"contatore\" sx-type=\"contatoreType.tipo_id.UUID\" sx-field=\"\'contatore_id\'\" sx-object=\"contatore.obj\"></six-lookup-2></div></div><div class=\"col-md-2\"><label class=\"control-label\">Da:</label><six-date-time-picker ng-model=\"datePicker.from\" enable-time=\"false\" date-options=\"dateOptions.from\"></six-date-time-picker></div><div class=\"col-md-2\"><label class=\"control-label\">A:</label><six-date-time-picker ng-model=\"datePicker.to\" enable-time=\"false\" date-options=\"dateOptions.to\"></six-date-time-picker></div><div class=\"col-md-3\"><label class=\"control-label\">Budget</label><six-select-2 sx-id=\"budget\" ng-model=\"budget\" sx-field=\"\'searchCode\'\" sx-list=\"availableBudgetCodes\" sx-item-template=\"\'{{item.description}}\'\" sx-compact=\"false\" sx-multiple=\"true\" sx-pinnable=\"false\" sx-key=\"\'UUID\'\" sx-position=\"\'right\'\"></six-select-2></div><div class=\"col-md-3\"><label class=\"control-label\">Listino</label><six-lookup-2 id=\"listino\" ng-model=\"priceList\" sx-war=\"\'six-energy\'\" sx-base-path=\"\'pricelist\'\" sx-type=\"\'header\'\" sx-field=\"\'id\'\" sx-position=\"\'right\'\"></six-lookup-2></div></div><hr><div class=\"pull-right\"><label class=\"checkbox-inline i-checks override-checkbox-i\" ng-if=\"isWritePermAllowed()\"><input type=\"checkbox\" ng-model=\"recordHistory.active\"><i></i> <span class=\"i-checks\">Considera storico</span></label> <label class=\"checkbox-inline i-checks override-checkbox-i\"><input type=\"checkbox\" ng-model=\"economic.active\"><i></i> <span class=\"i-checks\">Economico</span></label></div><uib-tabset><uib-tab ng-click=\"selectTab(\'read\')\"><uib-tab-heading><span class=\"fa fa-book text-info-dker\"></span> Letture</uib-tab-heading><div class=\"col-md-12 m-t\" ng-if=\"!getTemplateUrl()\"><div class=\"row\">Selezionare un tipo di contatore</div></div><div class=\"col-md-12 m-t-sm\" ng-if=\"getTemplateUrl()\"><div class=\"row\"><div class=\"formGroup pull-left\"><a ng-href=\"{{getTemplateUrl()}}\" class=\"btn btn-info btn-sm\" ng-if=\"getTemplateUrl() && isWritePermAllowed()===true && !isClosed()\"><i class=\"fa fa-file-excel-o\"></i> Template</a></div><div class=\"formGroup col-md-3 col-md-offset-3\"><div class=\"btn-group btn-group-sm\" ng-if=\"isWritePermAllowed()\"><label class=\"btn\" ng-class=\"{\'btn-primary\':!importingOperation, \'btn-default\':importingOperation}\" ng-click=\"switchMode(MODE_MODIFY)\">MODIFICA</label> <label class=\"btn\" ng-class=\"{\'btn-primary\':importingOperation, \'btn-default\':!importingOperation}\" ng-click=\"switchMode(MODE_IMPORT)\">IMPORTA</label></div></div><div class=\"formGroup pull-right\"><a ng-click=\"loadReads()\" class=\"btn btn-default btn-sm m-r\" ng-disabled=\"!contatore.contatore_id || importingOperation\"><i class=\"fa fa-refresh\"></i></a> <a ng-click=\"addRead()\" class=\"btn btn-info btn-sm\" ng-if=\"isWritePermAllowed()\" ng-disabled=\"!contatore.contatore_id || importingOperation || isWritePermAllowed() === false || isClosed()\"><span class=\"fa fa-plus\"></span> Aggiungi</a> <a ng-click=\"removeReadsWithDialog(gridApi.selection.getSelectedRows())\" class=\"btn btn-danger btn-sm\" ng-if=\"isWritePermAllowed()\" ng-disabled=\"!contatore.contatore_id || isDeletePermAllowed() === false\"><span class=\"fa fa-times\"></span> Rimuovi</a></div></div><div class=\"row m-t-sm\"><div class=\"col-md-6\"><span class=\"badge automaticRead\">Lett. prevista</span> <span class=\"badge resetRead\">Lett. di reset</span> <span class=\"badge warningRead\">Lett. con problemi</span> <span class=\"badge errorRead\">Lett. in errore</span></div></div><div class=\"row m-t-sm\"><div id=\"grid1\" ui-grid=\"viewGridOptions\" class=\"grid\" external-scopes=\"clickHandler\" style=\"height: 420px\" ui-grid-pagination=\"\" ui-grid-auto-resize=\"\" ui-grid-exporter=\"\" ui-grid-edit=\"\" ui-grid-row-edit=\"\" ui-grid-cellnav=\"\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\"><div class=\"grid-msg-overlay\" ng-show=\"!viewGridOptions.data.length && isWritePermAllowed()===true && !isClosed()\"><div class=\"msg\"><div class=\"center\"><span class=\"muted\">Selezionare File Excel</span><br><input type=\"file\" accept=\".xls,.xlsx,.ods\" xlsxreader=\"\" opts=\"viewGridOptions\" multiple=\"false\"></div></div></div></div><div class=\"wrapper m-t\" ng-if=\"viewGridOptions.data.length\"><div class=\"text-center-folded\"><span class=\"pull-right pull-none-folded\">{{percent|number: 0}}%</span> <span class=\"hidden-folded ng-scope\">Salvataggio</span></div><div class=\"progress-s m-t-sm dk progress ng-isolate-scope\" value=\"{{percent}}\" type=\"info\"><div class=\"progress-bar progress-bar-info\" ng-class=\"type &amp;&amp; \'progress-bar-\' + type\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: percent + \'%\'}\" aria-valuetext=\"0%\" style=\"width: {{percent|number: 0}}%;\"></div></div></div></div></div></uib-tab><uib-tab ng-click=\"selectTab(\'consumption\')\"><uib-tab-heading><span class=\"fa fa-cog text-success-dker\"></span> Consumi</uib-tab-heading><div class=\"col-md-12 m-t pull-right\"><div class=\"row\"><a class=\"btn btn-default btn-sm m-r\" ng-if=\"isWritePermAllowed()\" ng-confirm-message=\"Calcolare i consumi per tutta la commessa?\" ng-confirm-click=\"calcAllConsumptions(false)\" ng-confirm-condition=\"true\" title=\"Calcola tutti i consumi della commessa\" ng-disabled=\"!contatoreType.tipo_id || contatoreType.tipo_id.code === \'contatoreelettricita\' || isWritePermAllowed() === false || isClosed()\"><i class=\"fa fa-gears\"></i> Calc. commessa</a> <a class=\"btn btn-default btn-sm m-r\" ng-if=\"isWritePermAllowed()\" ng-confirm-message=\"Calcolare i consumi per TUTTE le commesse?\" ng-confirm-click=\"calcAllConsumptions(true)\" ng-confirm-condition=\"true\" title=\"Calcola tutti i consumi per tutte le commesse\" ng-disabled=\"!contatoreType.tipo_id || contatoreType.tipo_id.code === \'contatoreelettricita\' || isWritePermAllowed() === false || isClosed()\"><i class=\"fa fa-gears\"></i> Calc. tutte le commesse</a><div class=\"formGroup pull-right\"><a ng-if=\"contatoreType.tipo_id.UUID === \'contatoreelettricita\'\" class=\"btn btn-default btn-sm m-r\" ng-click=\"goToImportConsumptions()\" ng-disabled=\"isWritePermAllowed() === false || isClosed()\"><i class=\"fa fa-upload\"></i> Importa</a> <a ng-click=\"loadConsumptions()\" class=\"btn btn-default btn-sm m-r\" ng-disabled=\"!contatore.contatore_id\"><span class=\"fa fa-refresh\"></span></a> <a ng-click=\"recalcConsumptions()\" class=\"btn btn-info btn-sm\" ng-if=\"isWritePermAllowed()\" ng-disabled=\"!contatore.contatore_id || isWritePermAllowed() === false\"><span class=\"fa fa-gear\"></span> Ricalcola</a> <a ng-click=\"deleteConsumptionsWithDialog()\" class=\"btn btn-danger btn-sm\" ng-if=\"isWritePermAllowed()\" ng-disabled=\"!contatore.contatore_id || isDeletePermAllowed() === false\"><span class=\"fa fa-trash\"></span> Cancella</a></div></div></div><div class=\"col-md-12 m-t\" ng-if=\"!monthlyConsumptions.length\"><div class=\"row\">Nessun dato da mostrare</div></div><div class=\"col-md-12 m-t\" ng-if=\"monthlyConsumptions.length\"><div class=\"row\"><div ng-include=\"\'summary-view.html\'\" class=\"col-md-4\"></div><div class=\"col-md-2\"><label for=\"um\" class=\"control-label font-bold\">U.M.&nbsp;</label><six-lookup id=\"um\" ng-model=\"um\" sx-type=\"\'um\'\" sx-field=\"\'um\'\"></six-lookup></div></div><div class=\"row m-t\"><table style=\"width:100%\" class=\"table-striped\"><thead><tr style=\"border-bottom: 1px solid lightblue\"><th>Anno</th><th ng-repeat=\"m in getTimes(12) track by $index\" class=\"monthCl\"><div class=\"dayHeader\"><span ng-class=\"{\'badge bg-info\': m===selectedMonthDetail.month}\">{{getMonthName($index)}}</span></div></th></tr></thead><tbody><tr ng-repeat-start=\"year in getYears(datePicker.from.getFullYear(), datePicker.to.getFullYear())\"><td><span ng-class=\"{\'badge bg-info\': year===selectedMonthDetail.year}\">{{year}}</span></td><td ng-repeat=\"m in getTimes(12) track by $index\" class=\"monthCl\"><a href=\"\" ng-click=\"toggleSelectMonth(year, m)\" ng-class=\"{\'disabled\': (monthlyConsumptions[year][m]).total === 0}\"><div><span class=\"badge\" ng-class=\"{\'consumption\': true, \'budget\': (monthlyConsumptions[year][m]).type === TYPE_BDG, \'partialMonth\': (monthlyConsumptions[year][m]).type === TYPE_MIXED, \'negativeConsumption\':(monthlyConsumptions[year][m]).total < 0}\" tooltip=\"\" data-placement=\"top\" title=\"{{getTooltip(monthlyConsumptions[year][m])}}\" ng-if=\"(monthlyConsumptions[year][m]).type !== undefined\">{{(monthlyConsumptions[year][m]).total | number: 1}}</span></div><div><span class=\"badge\" tooltip=\"\" data-placement=\"top\" title=\"No data\" ng-if=\"(monthlyConsumptions[year][m]).type === undefined\">-</span></div><div><span class=\"badge money\" tooltip=\"\" data-placement=\"top\" title=\"€\" ng-if=\"monthlyEvaluatedConsumptions[year][m] !== 0\">{{monthlyEvaluatedConsumptions[year][m] | number: 2}} €</span></div></a><div><span class=\"fa fa-chevron-up text-info\" ng-if=\"year===selectedMonthDetail.year && m===selectedMonthDetail.month\"></span></div></td></tr><tr ng-repeat=\"m in getTimes(12) track by $index\" ng-repeat-end=\"\" ng-if=\"year===selectedMonthDetail.year && m===selectedMonthDetail.month\"><td></td><td colspan=\"12\"><div ng-include=\"\'month-view.html\'\" class=\"month-detail\"></div></td></tr></tbody></table></div></div></uib-tab><uib-tab ng-click=\"selectTab(\'graph\')\"><uib-tab-heading><span class=\"fa fa-line-chart text-primary-dker\"></span> Grafici</uib-tab-heading><div class=\"col-md-12 m-t\" ng-if=\"!graph.graphData.length\"><div class=\"row\">Nessun grafico da mostrare</div></div><div class=\"col-md-12 m-t\" ng-if=\"monthlyConsumptions.length\"><div class=\"row\"><div ng-include=\"\'summary-view.html\'\" class=\"col-md-4\"></div></div><div class=\"row m-t-lg\"><six-multi-series-line-chart sx-graph-data=\"graph.graphData\" sx-id=\"consumptionsGraph\" sx-y-axis-legend=\"\'Consumi\'\" sx-graph-title=\"Consumi puntuali\" sx-interpolate=\"\'basis\'\"></six-multi-series-line-chart></div><div class=\"row m-t-lg\"><six-multi-series-line-chart sx-graph-data=\"graph.graphDataCum\" sx-id=\"consumptionsGraphCum\" sx-y-axis-legend=\"\'Consumi (cum)\'\" sx-graph-title=\"Consumi cumulati\" sx-interpolate=\"\'basis\'\"></six-multi-series-line-chart></div></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("energy/consumptive/expandableRowTemplate.html","<div ui-grid=\"row.entity.model.subGridOptions\" ui-grid-edit=\"\" ui-grid-row-edit=\"\" ui-grid-cellnav=\"\" ui-grid-resize-columns=\"\" style=\"height:180px;\"></div>");
$templateCache.put("energy/consumptive/import.html","<style type=\"text/css\">\n  .limitExceeded {\n    background-color: #d9534f !important;\n    color: #FFFFFF;\n  }\n  .error {\n    background-color: #d9534f !important;\n    color: #FFFFFF;\n  }\n  .perm-table-check {\n    padding-right: 5px;\n  }\n  .perm-table-perm {\n    padding-left: 5px;\n    text-align: left;\n    font-weight: bold\n  }\n</style><script type=\"text/ng-template\" id=\"permissionsInfoTemplate.html\"><strong><span class=\"ngdialog-icon\"></span></strong> <div style=\"text-align: center;\"><h4 class=\"m-t-none m-b font-bold\">Permessi</h4></div> <div class=\"row m-t\"> <table align=\"center\" style=\"text-align: left;\"> <tr> <td class=\"perm-table-check\"><i class=\"fa\" ng-class=\"{\'fa-check-circle-o text-success-dker\': isWritePermAllowed(), \'fa-times-circle-o text-danger-dker\': !isWritePermAllowed()}\"></i></td> <td class=\"perm-table-perm\">Aggiungere letture</td> </tr> <tr> <td class=\"perm-table-check\"><i class=\"fa\" ng-class=\"{\'fa-check-circle-o text-success-dker\': isWritePermAllowed(), \'fa-times-circle-o text-danger-dker\': !isWritePermAllowed()}\"></i></td> <td class=\"perm-table-perm\">Modificare letture</td> </tr> <tr> <td class=\"perm-table-check\"><i class=\"fa\" ng-class=\"{\'fa-check-circle-o text-success-dker\': isWritePermAllowed(), \'fa-times-circle-o text-danger-dker\': !isDeletePermAllowed()}\"></i></td> <td class=\"perm-table-perm\">Eliminare letture</td> </tr> <tr> <td class=\"perm-table-check\"><i class=\"fa\" ng-class=\"{\'fa-check-circle-o text-success-dker\': modifyOldAllowed(), \'fa-times-circle-o text-danger-dker\': !modifyOldAllowed()}\"></i></td> <td class=\"perm-table-perm\">Aggiungere letture prima del {{limit | date:\'yyyy-MM-dd\'}}</td> </tr> <tr> <td class=\"perm-table-check\"><i class=\"fa\" ng-class=\"{\'fa-check-circle-o text-success-dker\': modifyOldAllowed(), \'fa-times-circle-o text-danger-dker\': !modifyOldAllowed()}\"></i></td> <td class=\"perm-table-perm\">Modificare letture prima del {{limit | date:\'yyyy-MM-dd\'}}</td> </tr> <tr> <td class=\"perm-table-check\"><i class=\"fa\" ng-class=\"{\'fa-check-circle-o text-success-dker\': modifyOldAllowed(), \'fa-times-circle-o text-danger-dker\': !modifyOldAllowed()}\"></i></td> <td class=\"perm-table-perm\">Eliminare letture prima del {{limit | date:\'yyyy-MM-dd\'}}</td> </tr> <tr> <td class=\"perm-table-check\"><i class=\"fa\" ng-class=\"{\'fa-check-circle-o text-success-dker\': isWritePermAllowed(), \'fa-times-circle-o text-danger-dker\': !isWritePermAllowed()}\"></i></td> <td class=\"perm-table-perm\">Aggiungere consumi</td> </tr> <tr> <td class=\"perm-table-check\"><i class=\"fa\" ng-class=\"{\'fa-check-circle-o text-success-dker\': isWritePermAllowed(), \'fa-times-circle-o text-danger-dker\': !isWritePermAllowed()}\"></i></td> <td class=\"perm-table-perm\">Modificare consumi</td> </tr> <tr> <td class=\"perm-table-check\"><i class=\"fa\" ng-class=\"{\'fa-check-circle-o text-success-dker\': isWritePermAllowed(), \'fa-times-circle-o text-danger-dker\': !isDeletePermAllowed()}\"></i></td> <td class=\"perm-table-perm\">Eliminare consumi</td> </tr> <tr> <td class=\"perm-table-check\"><i class=\"fa\" ng-class=\"{\'fa-check-circle-o text-success-dker\': modifyOldAllowed(), \'fa-times-circle-o text-danger-dker\': !modifyOldAllowed()}\"></i></td> <td class=\"perm-table-perm\">Aggiungere consumi prima del {{limit | date:\'yyyy-MM-dd\'}}</td> </tr> <tr> <td class=\"perm-table-check\"><i class=\"fa\" ng-class=\"{\'fa-check-circle-o text-success-dker\': modifyOldAllowed(), \'fa-times-circle-o text-danger-dker\': !modifyOldAllowed()}\"></i></td> <td class=\"perm-table-perm\">Modificare consumi prima del {{limit | date:\'yyyy-MM-dd\'}}</td> </tr> <tr> <td class=\"perm-table-check\"><i class=\"fa\" ng-class=\"{\'fa-check-circle-o text-success-dker\': modifyOldAllowed(), \'fa-times-circle-o text-danger-dker\': !modifyOldAllowed()}\"></i></td> <td class=\"perm-table-perm\">Eliminare consumi prima del {{limit | date:\'yyyy-MM-dd\'}}</td> </tr> </table> </div></script><six-toolbar><six-toolbar-item label=\"Template\" icon=\"fa fa-download icon text-info-dker\" toolbar-function=\"downloadTemplate()\"></six-toolbar-item><six-toolbar-item icon=\"{{getIconPerm()}}\" label-class=\"text-info-dker\" label=\"{{getLabelPerm()}}\" toolbar-function=\"showPermissions()\"></six-toolbar-item><six-toolbar-button btn-class=\"btn-default\" toolbar-function=\"back()\" label=\"\" icon=\"fa fa-chevron-left\"></six-toolbar-button><six-toolbar-button btn-class=\"btn-success\" toolbar-function=\"importData()\" label=\"Importa\" icon=\"fa fa-upload\" sx-disabled=\"isWritePermAllowed()===false || isImportBusy === true || isAllOk === false || !viewGridOptions.data.length\"></six-toolbar-button><six-toolbar-button btn-class=\"btn-default\" toolbar-function=\"resetGrid()\" label=\"Reset\" icon=\"fa fa-history\"></six-toolbar-button></six-toolbar><div class=\"wrapper override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">CONSUNTIVO</h1><small class=\"text-muted\">Importazione consumi</small></div></div></div><div class=\"panel-body\"><div class=\"row wrapper\"><div id=\"grid1\" ui-grid=\"viewGridOptions\" class=\"grid\" external-scopes=\"clickHandler\" style=\"height: 420px\" ui-grid-pagination=\"\" ui-grid-cellnav=\"\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\"><div class=\"grid-msg-overlay\" ng-show=\"!viewGridOptions.data.length\"><div class=\"msg\"><div class=\"center\"><span class=\"muted\">Selezionare File Excel</span><br><input type=\"file\" accept=\".xls,.xlsx,.ods\" xlsxreader=\"\" opts=\"viewGridOptions\" multiple=\"false\"></div></div></div></div><div class=\"wrapper m-t\" ng-if=\"viewGridOptions.data.length\"><div class=\"text-center-folded\"><span class=\"pull-right pull-none-folded\">{{percent|number: 0}}%</span> <span class=\"hidden-folded ng-scope\">Salvataggio</span></div><div class=\"progress-s m-t-sm dk progress ng-isolate-scope\" value=\"{{percent}}\" type=\"info\"><div class=\"progress-bar progress-bar-info\" ng-class=\"type &amp;&amp; \'progress-bar-\' + type\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: percent + \'%\'}\" aria-valuetext=\"0%\" style=\"width: {{percent|number: 0}}%;\"></div></div></div></div></div><div class=\"panel-body\"><div id=\"messages\" class=\"row m-t\" ng-if=\"reportMessages.length\"><div class=\"panel-group\" id=\"accordion\"><div class=\"panel panel-default\" id=\"panel1\"><div class=\"panel-heading\"><h4 class=\"panel-title\">Messaggi</h4></div><div class=\"panel-body\"><div class=\"col-md-12\"><div id=\"gridReport\" ui-grid=\"reportGridOptions\" class=\"grid\" style=\"height: 420px\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\"></div></div></div></div></div></div></div></div></div>");
$templateCache.put("energy/consumptive/importTemplate.html","<input type=\"file\" accept=\".xls,.xlsx,.ods\" xlsxreader=\"\" opts=\"viewGridOptions\" multiple=\"false\">");
$templateCache.put("energy/consumptive/import_multicommission.html","<style type=\"text/css\">\n  .errorRead {\n    background-color: rgb(253, 90, 78) !important;\n    color: white !important;\n  }\n</style><six-toolbar><six-toolbar-item ng-show=\"getTemplateUrl()\" label=\"Template\" icon=\"fa fa-download icon text-info-dker\" toolbar-function=\"downloadTemplate()\"></six-toolbar-item><six-toolbar-button label=\"Reset\" icon=\"fa fa-undo\" ng-if=\"viewGridOptions.data.length && importingOperation\" toolbar-function=\"resetGrid()\"></six-toolbar-button><six-toolbar-button label=\"Importa\" icon=\"fa fa-upload\" ng-if=\"viewGridOptions.data.length && importingOperation\" toolbar-function=\"importData()\" btn-class=\"btn-success\" sx-disabled=\"isImportBusy === true || isAllOk === false\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">CONSUNTIVO</h1></div></div></div><div class=\"panel-body\"><div class=\"row wrapper\"><div class=\"col-md-3\">Tipo<six-lookup-2 id=\"tipo\" sx-base-path=\"\'schema\'\" ng-model=\"contatoreType\" sx-field=\"\'tipo_id\'\" sx-filter=\"contatoreTypeFilter\" sx-compact=\"true\" sx-item-template=\"\'{{item.description}}\'\"></six-lookup-2></div></div><div class=\"row wrapper\"><div class=\"col-md-12 m-t\" ng-if=\"!getTemplateUrl()\"><div class=\"alert alert-info\" role=\"alert\">Selezionare un tipo di contatore.</div></div><div class=\"col-md-12 m-t-sm\" ng-if=\"getTemplateUrl()\"><div class=\"row hidden\"><div class=\"formGroup pull-left\"><a ng-href=\"{{getTemplateUrl()}}\" id=\"linkToTemplate\" class=\"btn btn-default btn-sm\" ng-if=\"getTemplateUrl()\">Template <i class=\"fa fa-file-excel-o pull-right\"></i></a></div></div><div class=\"row m-t-sm\"><div id=\"grid1\" ui-grid=\"viewGridOptions\" class=\"grid\" external-scopes=\"clickHandler\" style=\"height: 420px\" ui-grid-pagination=\"\" ui-grid-exporter=\"\" ui-grid-edit=\"\" ui-grid-row-edit=\"\" ui-grid-cellnav=\"\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\"><div class=\"grid-msg-overlay\" ng-show=\"!viewGridOptions.data.length\"><div class=\"msg\"><div class=\"center\"><span class=\"muted\">Selezionare File Excel</span><br><input type=\"file\" accept=\".xls,.xlsx,.ods\" xlsxreader=\"\" opts=\"viewGridOptions\" multiple=\"false\"></div></div></div></div><div class=\"wrapper m-t\" ng-if=\"viewGridOptions.data.length\"><div class=\"text-center-folded\"><span class=\"pull-right pull-none-folded\">{{percent|number: 0}}%</span> <span class=\"hidden-folded ng-scope\">Salvataggio</span></div><div class=\"progress-s m-t-sm dk progress ng-isolate-scope\" value=\"{{percent}}\" type=\"info\"><div class=\"progress-bar progress-bar-info\" ng-class=\"type &amp;&amp; \'progress-bar-\' + type\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: percent + \'%\'}\" aria-valuetext=\"0%\" style=\"width: {{percent|number: 0}}%;\"></div></div></div></div></div></div></div><div class=\"panel-body\"><div id=\"messages\" class=\"row m-t\" ng-if=\"reportMessages.length\"><div class=\"panel-group\" id=\"accordion\"><div class=\"panel panel-default\" id=\"panel1\"><div class=\"panel-heading\"><h4 class=\"panel-title\">Messaggi</h4></div><div class=\"panel-body\"><div class=\"col-md-12\"><div id=\"gridReport\" ui-grid=\"reportGridOptions\" class=\"grid\" style=\"height: 420px\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\"></div></div></div></div></div></div></div></div></div>");
$templateCache.put("energy/daydegrees/daydegree.html","<style type=\"text/css\">\n  #year-select{\n    height: 29px;\n    margin-right: -4px;\n    margin-left: -5px;\n  }\n\n  .dayClHead {\n    width: 3%;\n    text-align: center;\n  }\n  .dayCl {\n    text-align: right;\n    padding: 1px;\n  }\n  .dayCl input {\n    text-align: end;\n    color: black;\n    margin-left: 1px;\n    width: 98%;\n  }\n  input[type=number]::-webkit-inner-spin-button,\n  input[type=number]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  .dayClEmpty{\n    text-align: right;\n    color:lightgray;\n  }\n  .rCl{\n    text-align: right;\n    padding-left: 3px;\n    padding-right: 3px;\n  }\n  .dayHeader{\n    -webkit-transform: rotate(300deg);\n    -moz-transform: rotate(300deg);\n    -o-transform: rotate(300deg);\n    writing-mode: lr-tb;\n  }\n  .currMonthRow{\n    background-color: #bdf1c3 !important;\n  }\n  .seasonEnd{\n    border-bottom: 1px solid lightcoral;\n    border-right: 1px solid lightcoral;\n    /*box-shadow: 3px 2px 1px lightcoral;*/\n  }\n  .seasonStart{\n    border-top: 1px solid lightcoral;\n    border-left: 1px solid lightcoral;\n    /*box-shadow: -3px 2px 1px lightcoral;*/\n  }\n  .locDetailsTable{\n    width:100%;\n    border: 1px solid lightblue;\n  }\n  .locDetailsTable td{\n    padding: 3px;\n    border: 1px solid lightgrey;\n  }\n  .locDetailsTable th{\n    background-color: #DDE6E9;\n    padding: 3px;\n    border: 1px solid lightgrey;\n  }\n  .transTable td{\n    border: none\n  }\n  .dd-table tr{\n    border-top: 1px solid #e4edf8;\n  }\n  .inSeas{\n    /*background-color: #e4edf8;*/\n  }\n  .outSeas{\n    background-color: #f7f3f8;\n  }\n\n  #tipogg_label{\n    line-height: 37px;\n  }\n\n  #localita_label  {\n    float: left;\n    line-height: 35px;\n    margin-right: 15px;\n  }\n</style><six-toolbar><six-toolbar-button label=\"Importa\" icon=\"fa fa-upload\" toolbar-function=\"goToImportDD()\" btn-class=\"btn-success\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button><six-toolbar-button label=\"Stampa PDF\" icon=\"fa fa-print\" toolbar-function=\"printReport(\'pdf\')\" btn-class=\"btn-default\"></six-toolbar-button><six-toolbar-button label=\"Stampa Excel\" icon=\"fa fa-file-excel-o\" toolbar-function=\"printReport(\'xls\')\" btn-class=\"btn-default\"></six-toolbar-button><six-toolbar-button label=\"Aggiorna\" icon=\"fa fa-refresh\" toolbar-function=\"loadDD()\" btn-class=\"btn-info\"></six-toolbar-button><six-toolbar-button label=\"Cancella\" icon=\"fa fa-trash\" toolbar-function=\"delete()\" ng-if=\"zonatermica.model\" btn-class=\"btn-danger\" sx-disabled=\"isDeletePermAllowed()===false\"></six-toolbar-button></six-toolbar><div class=\"constructor\"><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">GRADI GIORNO</h1></div></div></div><div class=\"panel-body\"><div class=\"col-md-6\"><div class=\"panel panel-default\" id=\"lookupLoc\"><div class=\"panel-heading\"><h5 class=\"panel-title\"><label id=\"localita_label\" class=\"control-label\">Zona Termica</label><div style=\"width:300px !important; display:inline-block\"><six-lookup-2 sx-id=\"zonatermica\" ng-model=\"zonatermica\" sx-type=\"\'zonatermica\'\" sx-field=\"\'zonatermica_id\'\" sx-show-filters=\"true\" sx-show-details=\"true\" sx-search-prefix=\"\'*\'\" sx-search-postfix=\"\'*\'\" sx-item-template=\"\'{{item.description}}\'\"></six-lookup-2></div></h5></div></div></div><div class=\"col-md-6\"><div class=\"panel panel-default\" id=\"commands1\"><div class=\"panel-heading\"><h5 class=\"panel-title\" id=\"tipogg_label\"><div class=\"row\"><div class=\"col col-md-6\">Tipo GG:&nbsp; <span ng-if=\"type==\'real\'\">Consuntivo anno</span> <span ng-if=\"type==\'hist\'\">Storico</span></div><div class=\"col col-md-6\" ng-if=\"type == \'real\'\"><button ng-click=\"previousYear()\" ng-disabled=\"bool.selectPeriod\" class=\"btn btn-default btn-sm\"><i class=\"fa fa-angle-left pull-left\"></i></button><select class=\"btn btn-default btn-sm\" id=\"year-select\" ng-model=\"selected.year\" convert-to-number=\"\"><option ng-repeat=\"y in getYears()\" value=\"{{y}}\" ng-selected=\"selected.year == y\">{{y}}</option></select><button ng-click=\"nextYear()\" ng-disabled=\"bool.selectPeriod\" class=\"btn btn-default btn-sm\"><i class=\"fa fa-angle-right pull-left\"></i></button></div></div></h5><div ng-if=\"type==\'real\'\"><div class=\"row\"><div class=\"col col-md-12\"><input type=\"checkbox\" ng-model=\"bool.selectPeriod\" class=\"wrapper-md\" ng-init=\"false\" ng-click=\"clearDates()\"> Visualizzazione periodo</div></div><div class=\"row wrapper-md\" ng-if=\"bool.selectPeriod\"><div class=\"col col-md-12\"><div class=\"col-md-5\"><label>Da</label> <input class=\"btn btn-default btn-sm\" type=\"date\" ng-model=\"period.dateFrom\"></div><div class=\"col-md-5\"><label>A</label> <input class=\"btn btn-default btn-sm\" type=\"date\" ng-model=\"period.dateTo\"></div><div class=\"col-md-2\"><button class=\"btn btn-info btn-sm\" ng-click=\"loadDD()\"><i class=\"fa fa-refresh\"></i> Aggiorna</button></div></div></div></div></div></div></div><div id=\"locDetail\" class=\"col-md-12\" ng-show=\"zonatermica.zonatermica_id != undefined\"><div class=\"panel-group\" id=\"accordion\"><div class=\"panel panel-default\" id=\"panel1\"><a data-toggle=\"collapse\" data-target=\"#collapseOne\"><div class=\"panel-heading\"><h4 class=\"panel-title\"><i class=\"pull-right fa ng-scope fa-angle-right\" ng-class=\"{\'fa-angle-down\': status.open, \'fa-angle-right\': !status.open}\"></i> Dettagli Zona Termica {{detailPanel}}</h4></div></a><div id=\"collapseOne\" class=\"collapse\"><div class=\"panel-body\"><div class=\"col-md-8\"><table class=\"locDetailsTable\"><thead><tr><td></td><th>Zona T. corrente</th><th>Zona T. di riferimento</th></tr><tr><th>Nome</th><td>{{zonatermica.model.description}} (comune: {{comune.model.description}})</td><td>{{refZonaTermica.model.description}}</td></tr></thead><tr><th>Temperature<br>medie<br></th><td><div ng-repeat=\"t in zonatermica.model.temp_giorn_medie\">{{t.month}}: {{t.temp}}</div></td><td><div ng-repeat=\"t in refZonaTermica.model.temp_giorn_medie\">{{t.month}}: {{t.temp}}</div></td></tr><tr><th>Altitudine</th><td ng-if=\"zonatermica.model.altitude\">{{zonatermica.model.altitude}} m</td><td ng-if=\"!zonatermica.model.altitude\"><span ng-if=\"comune.model.altitude\">{{comune.model.altitude}} m (comune)</span></td><td><span ng-if=\"refZonaTermica.model.altitude\">{{refZonaTermica.model.altitude}} m</span></td></tr><tr><th>GG DPR</th><td ng-if=\"zonatermica.model.gg_stag_termica\">{{zonatermica.model.gg_stag_termica}}</td><td ng-if=\"!zonatermica.model.gg_stag_termica\"><span ng-if=\"comune.model.gg_stag_termica\">{{comune.model.gg_stag_termica}} (comune)</span></td><td>{{refZonaTermica.model.gg_stag_termica}}</td></tr><tr><th>Coefficiente C</th><td ng-if=\"zonatermica.model.c_coeff\">{{zonatermica.model.c_coeff}}</td><td ng-if=\"!zonatermica.model.c_coeff\"><span ng-if=\"comune.model.c_coeff\">{{comune.model.c_coeff}} (comune)</span></td><td>{{refZonaTermica.model.c_coeff}}</td></tr><tr><th>Gradiente termico</th><td ng-if=\"zonatermica.model.gradiente_vert_temp\">{{zonatermica.model.gradiente_vert_temp}}</td><td ng-if=\"!zonatermica.model.gradiente_vert_temp\"><span ng-if=\"provincia.model.gradiente_vert_temp\">{{provincia.model.gradiente_vert_temp}} (provincia)</span></td><td>{{refZonaTermica.model.gradiente_vert_temp}}</td></tr><tr><th>Zona climatica</th><td><span ng-if=\"comune.model.zona_climatica_id\">{{comune.model.zona_climatica_id.code}} (comune)</span></td><td>{{refZonaTermica.model.zona_climatica_id.code}}</td></tr></table><div style=\"font-size: xx-small\" ng-if=\"false\"><hr>{{zonatermica.model}}<hr>{{comune.model}}<hr>{{provincia.model}}</div></div><div class=\"col-md-4\"><div class=\"panel panel-default\" id=\"commands2\"><div class=\"panel-heading\"><h5 class=\"panel-title\"><i class=\"pull-right fa ng-scope fa-gears\"></i> Calcolo Gradi giorno</h5></div><div class=\"panel-body\"><span ng-if=\"refZonaTermica.model && zonatermica.model && type == \'real\'\"><button ng-click=\"calculateFromRef()\" class=\"btn btn-info {{refZonaTermica.model.code == zonatermica.model.code?\'disabled\':\'\'}}\" ng-disabled=\"isWritePermAllowed()===false || bool.selectPeriod===true\" style=\"width:100%\">Da Zona Termica di riferimento</button><br><br></span> <span ng-if=\"!refZonaTermica.model && zonatermica.model && type == \'real\'\">{{zonatermica.model.description}} non ha una Zona Termica di riferimento</span><div ng-if=\"zonatermica.model && referring.length>0 && type == \'real\'\"><div class=\"btn-group\" uib-dropdown=\"\" style=\"width:100%\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"calculateReferring()\" ng-disabled=\"isWritePermAllowed()===false || bool.selectPeriod===true\" style=\"width:85%\">Per Zone Termiche referenti &nbsp;</button> <button type=\"button\" class=\"btn btn-info dropdown-toggle\" uib-dropdown-toggle=\"\" aria-haspopup=\"true\" aria-expanded=\"false\" style=\"width:15%\"><b class=\"badge bg-info pull-right\">{{referring.length}}</b> <span class=\"caret\"></span> <span class=\"sr-only\">--</span></button><ul class=\"dropdown-menu\" role=\"menu\" uib-dropdown-toggle=\"\"><li><a href=\"\">Zone Termiche che fanno riferimento a {{zonatermica.model.description}}:</a></li><li class=\"divider\"></li><li ng-repeat=\"item in referring\"><a href=\"\" style=\"{{(item.model.code == zonatermica.model.code)?\'color:gray\':\'\'}}\">{{item.model.description}} <span style=\"font-size: xx-small; color:gray\">({{item.model.code}})</span></a></li></ul></div><br><br></div><div ng-if=\"zonatermica.model && type == \'real\'\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"calculateAllReferring()\" ng-disabled=\"isWritePermAllowed()===false || bool.selectPeriod===true\" style=\"margin-top: 10px; width:100%\">Per TUTTE le Zone Termiche &nbsp;</button></div><div ng-if=\"type == \'hist\'\"><button type=\"button\" class=\"btn btn-info\" ng-if=\"type == \'hist\'\" ng-click=\"tempToDD(true)\" ng-disabled=\"isWritePermAllowed()===false || bool.selectPeriod===true\" style=\"width:100%\">Da temp. normalizzato DPR</button> <label ng-if=\"false\" class=\"btn btn-sm btn-default ng-untouched ng-valid ng-dirty ng-valid-parse\" ng-model=\"normalized\" uib-btn-checkbox=\"\" aria-invalid=\"false\" style=\"width:29%\">Normalizza</label> <button type=\"button\" class=\"btn btn-default\" ng-if=\"type == \'hist\'\" ng-click=\"tempToDDAll()\" ng-disabled=\"isWritePermAllowed()===false || bool.selectPeriod===true\" style=\"margin-top: 10px; width:100%\">Ricalcola per TUTTE le ZT</button></div></div></div></div></div></div></div></div></div><uib-tabset ng-show=\"zonatermica.zonatermica_id != undefined\"><uib-tab><uib-tab-heading><span class=\"fa fa-book text-info-dker\"></span> Dati</uib-tab-heading><div id=\"ddTable\" class=\"col-md-12\"><div><form name=\"myForm\"><table style=\"width:100%\" class=\"dd-table\"><thead><tr style=\"border-bottom: 1px solid lightblue\"><th>Mese</th><th ng-repeat=\"d in getTimes(31) track by $index\" class=\"dayClHead\" ng-if=\"showDay($index)\"><div class=\"dayHeader\">{{$index+1}}</div></th><th class=\"rCl\" ng-if=\"type==\'real\'\" style=\"min-width:62px\"><button ng-click=\"editMonthsValues(false)\" ng-if=\"monthsValues == null || monthsValuesHist\" ng-disabled=\"(monthsValues!=null && monthsValuesHist) || isWritePermAllowed()===false\" class=\"btn btn-default btn-sm\" style=\"min-width:60px\"><i class=\"fa fa-edit\"></i>Tot.</button> <button ng-click=\"undoEditMonths()\" ng-if=\"monthsValues != null && !monthsValuesHist\" class=\"btn btn-default btn-sm\" style=\"max-width:25px\"><i class=\"fa fa-undo\"></i></button> <button ng-click=\"confirmEditMonthsWithDialog()\" ng-if=\"monthsValues != null && !monthsValuesHist\" class=\"btn btn-default btn-sm\" style=\"max-width:25px\"><i class=\"fa fa-check\"></i></button></th><th class=\"rCl\" ng-if=\"type==\'real\'\">Cum.</th><th class=\"rCl\" style=\"min-width:62px\"><button ng-if=\"type!=\'real\'\" ng-click=\"editMonthsValues(true)\" ng-disabled=\"monthsValues!=null && !monthsValuesHist || !(type===\'hist\') || isWritePermAllowed()===false\" class=\"btn btn-default btn-sm\" style=\"min-width:0px\"><i class=\"fa fa-edit\"></i>Tot. st</button> <span ng-if=\"type==\'real\'\">Tot. st</span> <button ng-click=\"undoEditMonths()\" ng-if=\"monthsValues != null && monthsValuesHist\" class=\"btn btn-default btn-sm\" style=\"max-width:25px\"><i class=\"fa fa-undo\"></i></button> <button ng-click=\"confirmEditMonthsWithDialog()\" ng-if=\"monthsValues != null && monthsValuesHist\" class=\"btn btn-default btn-sm\" style=\"max-width:25px\"><i class=\"fa fa-check\"></i></button></th><th class=\"rCl\">Cum. st.</th><th class=\"rCl\" ng-if=\"type==\'real\' && show.stats\">% su storico</th><th class=\"rCl\" ng-if=\"type==\'real\' && show.stats\">% cum. su stor.</th><th class=\"rCl\" ng-if=\"type==\'real\' && show.stats\">% su tot. stor.</th><th class=\"rCl\" ng-if=\"type==\'real\' && show.stats\">Previs.</th></tr></thead><tbody><tr ng-repeat=\"m in months\" class=\"{{editingMonth == m.indexMatrix ? \'currMonthRow\':\'\'}}\"><td><button ng-if=\"type==\'real\' && editingMonth != m.indexMatrix\" ng-click=\"editMonth(m.indexMatrix)\" ng-disabled=\"editingMonth != null || isWritePermAllowed()===false\" class=\"btn btn-default btn-sm\" style=\"min-width:70px; width: 85px\"><i class=\"fa fa-edit\"></i> {{m.descrMonth}}</button> <button ng-if=\"type==\'hist\' && editingMonth != m.indexMatrix\" ng-click=\"editMonth(m.indexMatrix)\" ng-disabled=\"editingMonth != null || isWritePermAllowed()===false\" class=\"btn btn-default btn-sm\" style=\"min-width:70px; width: 85px\"><i class=\"fa fa-edit\"></i> {{m.numMonth|monthShortName}}</button> <button ng-click=\"undoMonth(m.indexMatrix)\" ng-if=\"editingMonth == m.indexMatrix\" class=\"btn btn-default btn-sm\" style=\"min-width:30px\"><i class=\"fa fa-undo\"></i></button> <button ng-click=\"confirmMonthWithDialog(m.indexMatrix)\" ng-if=\"editingMonth == m.indexMatrix\" class=\"btn btn-default btn-sm\" style=\"min-width:30px\"><i class=\"fa fa-check\"></i></button></td><td ng-repeat=\"d in getTimes(31) track by $index\" ng-if=\"showDay($index)\" class=\"{{DrawInSeason(m, $index+1)?\'inSeas\':\'outSeas\'}} {{dataMatrix[m.indexMatrix][$index][type].value==0?\'dayClEmpty\':\'dayCl\'}} {{drawSeasonEnd(m, $index)?\'seasonEnd\':\'\'}} {{drawSeasonStart(m, $index)?\'seasonStart\':\'\'}}\"><span ng-if=\"editingMonth != m.indexMatrix\">{{dataMatrix[m.indexMatrix][$index][type].value | number:1}}</span> {{dataMatrix[m.indexMatrix][$index][type] == null?\'-\': \'\'}} <input name=\"{{m.indexMatrix+\'_\'+$index}}\" ng-if=\"dataMatrix[m.indexMatrix][$index][type] != null && editingMonth == m.indexMatrix\" ng-model=\"dataMatrix[m.indexMatrix][$index][type].value\" class=\"form-control ng-pristine ng-valid ng-touched\" type=\"number\" min=\"0\" tabindex=\"0\" aria-invalid=\"false\" style=\"height: 24px !important; padding: 2px\"></td><td class=\"rCl\" ng-if=\"type==\'real\'\"><span ng-if=\"monthsValues == null || monthsValuesHist\">{{dataTotals[m.indexMatrix].totReal | number:1}}</span> <span ng-if=\"monthsValues != null && ! monthsValuesHist\"><input name=\"{{m.indexMatrix}}\" ng-model=\"monthsValues[m.indexMatrix]\" class=\"form-control ng-pristine ng-valid ng-touched\" type=\"number\" min=\"0\" tabindex=\"0\" aria-invalid=\"false\" style=\"height: 24px !important; padding: 2px\"></span></td><td class=\"rCl\" ng-if=\"type==\'real\'\">{{dataTotals[m.indexMatrix].cumulReal | number:1}}</td><td class=\"rCl\"><span ng-if=\"monthsValues == null || !monthsValuesHist\">{{dataTotals[m.indexMatrix].totHist | number:1}}</span> <span ng-if=\"monthsValues != null && monthsValuesHist\"><input name=\"{{m.indexMatrix}}\" ng-model=\"monthsValues[m.indexMatrix]\" class=\"form-control ng-pristine ng-valid ng-touched\" type=\"number\" min=\"0\" tabindex=\"0\" aria-invalid=\"false\" style=\"height: 24px !important; padding: 2px\"></span></td><td class=\"rCl\">{{dataTotals[m.indexMatrix].cumulHist | number:1}}</td><td class=\"rCl\" ng-if=\"type==\'real\' && show.stats\">{{(dataTotals[m.indexMatrix].totReal - dataTotals[m.indexMatrix].totHist)*100/dataTotals[m.indexMatrix].totHist | number:1}}{{(dataTotals[m.indexMatrix].totReal)>0?\'%\':\'\'}}</td><td class=\"rCl\" ng-if=\"type==\'real\' && show.stats\">{{(dataTotals[m.indexMatrix].cumulReal)*100/dataTotals[months.length].totHist | number:1}}%</td><td class=\"rCl\" ng-if=\"type==\'real\' && show.stats\">{{(dataTotals[m.indexMatrix].totReal)*100/dataTotals[months.length].totHist | number:1}}%</td><td class=\"rCl\" ng-if=\"type==\'real\' && show.stats\">{{(1-(dataTotals[months.length].totHist - dataTotals[m.indexMatrix].cumulHist + dataTotals[m.indexMatrix].cumulReal)/dataTotals[months.length].totHist)*100| number:1}}%</td></tr><tr style=\"border-top: 1px solid lightblue\"><td></td><td ng-repeat=\"d in getTimes(31) track by $index\" ng-if=\"showDay($index)\"></td><td class=\"rCl\" ng-if=\"type==\'real\'\">{{dataTotals[months.length].totReal | number:1}}</td><td class=\"rCl\" ng-if=\"type==\'real\'\">{{dataTotals[months.length].cumulReal | number:1}}</td><td class=\"rCl\">{{dataTotals[months.length].totHist | number:1}}</td><td class=\"rCl\">{{dataTotals[months.length].cumulHist | number:1}}</td><td class=\"rCl\" ng-if=\"type==\'real\' && show.stats\"></td><td class=\"rCl\" ng-if=\"type==\'real\' && show.stats\"></td><td class=\"rCl\" ng-if=\"type==\'real\' && show.stats\"></td><td class=\"rCl\" ng-if=\"type==\'real\' && show.stats\"></td></tr></tbody></table><div class=\"btn-group\"><label class=\"btn btn-default ng-untouched ng-valid ng-dirty ng-valid-parse\" ng-model=\"show.firstHalf\" uib-btn-checkbox=\"\" tabindex=\"0\" aria-invalid=\"false\">1-15</label> <label class=\"btn btn-default ng-untouched ng-valid ng-dirty ng-valid-parse active\" ng-model=\"show.secondHalf\" uib-btn-checkbox=\"\" tabindex=\"0\" aria-invalid=\"false\">16-31</label> <label class=\"btn btn-default ng-untouched ng-valid ng-dirty ng-valid-parse active\" ng-model=\"show.stats\" uib-btn-checkbox=\"\" tabindex=\"0\" aria-invalid=\"false\" ng-if=\"type==\'real\'\">Statistiche</label></div></form></div></div></uib-tab><uib-tab><uib-tab-heading><span class=\"fa fa-line-chart text-info-dker\"></span> Grafici</uib-tab-heading><div class=\"col-md-12\"><six-multi-series-line-chart sx-id=\"graph1\" sx-graph-data=\"graphData\" sx-y-axis-legend=\"\'Gradi Giorno\'\" sx-graph-title=\"Gradi Giorno\" sx-series-colors=\"[\'#1044EE\', \'#10BB99\']\"></six-multi-series-line-chart><six-multi-series-line-chart sx-id=\"graph2\" sx-graph-data=\"graphDataCum\" sx-y-axis-legend=\"\'Cumulativo GG\'\" sx-graph-title=\"Cumulativo GG\" sx-series-colors=\"[\'#1044EE\', \'#10BB99\']\"></six-multi-series-line-chart></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("energy/daydegrees/importgg.html","<style>\n    .red{\n    color:red;\n    }\n\n    .customButton{\n    min-width: 100px;\n    color: #58666e !important;\n    background-color: #fcfdfd;\n    background-color: #fff;\n    border-color: #dee5e7;\n    border-bottom-color: #d8e1e3;\n    box-shadow: 0 1px 1px rgba(90, 90, 90, 0.1);\n    }\n\n    .smallHeader{\n    font-size:x-small;\n    }\n\n    .customButton:hover,\n    .customButton:focus,\n    .customButton:active,\n    .customButton.active,\n    .open .dropdown-toggle.btn-info {\n    color: #ffffff !important;\n    background-color: #8bd56c !important;\n    border-color: #1bd500 !important;\n    }\n\n    .customButton:active,\n    .customButton.active,\n    .open .dropdown-toggle.btn-info {\n    background-image: none;\n    }\n\n    .customButton.disabled,\n    .customButton[disabled],\n    fieldset[disabled] .customButton,\n    .customButton.disabled:hover,\n    .customButton[disabled]:hover,\n    fieldset[disabled] .customButton:hover,\n    .customButton.disabled:focus,\n    .customButton[disabled]:focus,\n    fieldset[disabled] .customButton:focus,\n    .customButton.disabled:active,\n    .customButton[disabled]:active,\n    fieldset[disabled] .customButton:active,\n    .customButton.disabled.active,\n    .customButton[disabled].active,\n    fieldset[disabled] .customButton.active {\n    color: #000000 !important;\n    background-color: #8bd56c;\n    border-color: #1bd500;\n    }\n\n    six-toolbar-item .fa-check{\n        margin-right: 8px;\n    }\n\n    six-toolbar-item .invisible-check{\n        visibility:hidden;\n    }\n\n    #help-panel{\n        margin-bottom:-20px;\n    }\n\n    #help-area{\n        font-family:monospace;\n        font-size:smaller;\n        width:100%;\n        height: 60px;\n    }\n</style><six-toolbar><six-toolbar-item label-condition=\"(period == \'month\')\" label=\"PERIODO (dati giornalieri)\" label-disabled=\"PERIODO (dati mensili)\" icon=\"fa fa-calendar icon text-success-dker\"><li><a href=\"\" ng-click=\"importByDay()\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': (period == \'month\')}\"></i> Dati giornalieri</a></li><li><a href=\"\" ng-click=\"importByMonth()\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': (period == \'day\')}\"></i> Dati mensili</a></li></six-toolbar-item><six-toolbar-item label-condition=\"(type == \'real\')\" label=\"RIEPILOGO (storico)\" label-disabled=\"RIEPILOGO (consuntivo)\" icon=\"fa fa-calendar-check-o icon text-success-dker\"><li><a href=\"\" ng-click=\"importHist()\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': (type == \'real\')}\"></i> Storico</a></li><li><a href=\"\" ng-click=\"importReal()\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': (type == \'hist\')}\"></i> Consuntivo</a></li></six-toolbar-item><six-toolbar-item label=\"Template\" icon=\"fa fa-download icon text-info-dker\" toolbar-function=\"downloadTemplate()\"></six-toolbar-item><six-toolbar-item label=\"Aiuto\" icon=\"fa fa-question icon text-danger-dker\" toolbar-function=\"toggleHelp()\"></six-toolbar-item><six-toolbar-button label=\"Con stagionalità\" icon=\"fa fa-square-o\" icon-disabled=\"fa fa-check-square-o\" icon-condition=\"season.considerSeasonality\" toolbar-function=\"toggleSeasonality()\"></six-toolbar-button><six-toolbar-button label=\"Reset\" icon=\"fa fa-undo\" toolbar-function=\"clearData()\" sx-disabled=\"!canUndo\"></six-toolbar-button><six-toolbar-button label=\"Importa\" icon=\"fa fa-upload\" toolbar-function=\"importDataWithDialog()\" btn-class=\"btn-success\" sx-disabled=\"!canImport\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 wrapper-md override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Importa Gradi Giorno</h1></div></div></div><div class=\"panel-body\" ng-if=\"showHelp\" id=\"help-panel\"><div class=\"bd-callout bd-callout-info\"><h4>Esempio di file</h4><textarea id=\"help-area\" read=\"\">\n\"Zona_Termica\",\"Anno\", \"Gen\", \"Feb\", \"Mar\", \"Apr\", \"Mag\", \"Giu\", \"Lug\", \"Ago\", \"Set\", \"Ott\", \"Nov\", \"Dic\"\n\"reggioemilia\",\"2014\", \"20\", \"20\", \"10\", \"0\", \"0\", \"0\", \"0\", \"5\", \"10\", \"20\", \"30\", \"30\"\n            </textarea></div></div><div class=\"panel-body\"><a id=\"linkToTemplate\" style=\"display:none\" href=\"energy/attachments/importGG_{{period}}.xlsx\"></a><div ui-grid=\"gridOptions\" class=\"grid\" ui-grid-resize-columns=\"\"><div class=\"grid-msg-overlay\" ng-show=\"!gridOptions.data.length\"><div class=\"msg\"><div class=\"center\"><span class=\"muted\">Selezionare File Excel</span><br><input type=\"file\" accept=\".xls,.xlsx,.ods\" xlsxreader=\"\" opts=\"gridOptions\" multiple=\"false\"></div></div></div></div></div></div></div>");
$templateCache.put("energy/measurements/measurement.html","<six-toolbar><six-toolbar-item disabled=\"runningDisabled\" label=\"START\" icon=\"fa fa-play icon text-success-dker\" toolbar-function=\"fight()\"></six-toolbar-item><six-toolbar-item disabled=\"stopDisabled\" label=\"STOP\" icon=\"fa fa-stop icon text-danger-dker\" toolbar-function=\"stopFight()\"></six-toolbar-item><six-toolbar-item disabled=\"resetDisabled\" label=\"RESET\" icon=\"fa fa-undo icon text-info-dker\" toolbar-function=\"resetFight()\"></six-toolbar-item></six-toolbar><div class=\"wrapper-md ng-scope override-padding-toolbar\"><div class=\"row\"><div class=\"col-md-5\"><div class=\"row row-sm text-center\"><div class=\"col-xs-6\"><div class=\"panel padder-v item\"><div class=\"h1 text-info font-thin h1\">{{dayCount}}</div><span class=\"text-muted text-xs\">Dati giornalieri</span><div class=\"top text-right w-full\"><i class=\"fa fa-caret-down text-warning m-r-sm\"></i></div></div></div><div class=\"col-xs-6\"><div class=\"panel padder-v item\"><div class=\"h1 text-info font-thin h1\">{{monthCount}}</div><span class=\"text-muted text-xs\">Dati mensili</span><div class=\"top text-right w-full\"><i class=\"fa fa-caret-down text-warning m-r-sm\"></i></div></div></div></div></div><div class=\"col-md-7\"><div class=\"panel wrapper\"><h4 class=\"font-thin m-t-none m-b text-muted\">Dati centraline</h4><six-multi-series-line-chart sx-id=\"graph1\" sx-graph-data=\"graphData\" sx-y-axis-legend=\"\'Rilevazione dati\'\" sx-graph-title=\"Dati acquisiti\" sx-x-axis-format=\"\'%H:%M:%S\'\"></six-multi-series-line-chart></div></div></div></div>");
$templateCache.put("energy/overridedates/overridedates.html","<style type=\"text/css\">\n  .margin {\n    margin-top: 3px;\n    margin-bottom: 3px;\n  }\n\n  .no_padding {\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n</style><div class=\"col-md-12 pad-t-15\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-12 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">DATE STAGIONE TERMICA</h1></div></div></div><div class=\"panel-body\"><div class=\"col-md-12\"><div class=\"row wrapper\"><div class=\"row\"><div class=\"col-md-3\"><label id=\"tipo_label\" class=\"control-label\">Tipo</label><six-lookup-2 sx-id=\"record_type\" sx-base-path=\"\'schema\'\" ng-model=\"record\" sx-field=\"\'type_id\'\" sx-disabled=\"true\" sx-compact=\"true\"></six-lookup-2></div><div class=\"col-md-3\"><label id=\"contatoreId_label\" class=\"control-label\">Record</label><six-lookup-2 sx-id=\"record_id\" ng-model=\"record\" sx-type=\"record.type_id.UUID\" sx-field=\"\'record_id\'\"></six-lookup-2></div><div class=\"col-md-6\"><div><div class=\"col-md-6\"><label>Data di inizio:</label></div><div class=\"col-md-6\"><label>Data di fine:</label></div></div><div class=\"margin\"><div class=\"col-md-6\"><six-date-time-picker ng-model=\"dates.in\" date-options=\"dateOptions\" enable-time=\"false\"><a class=\"btn btn-success\" ng-click=\"addDate(dates.in, \'begin\')\" ng-disabled=\"isWritePermAllowed()===false\"><i class=\"fa fa-plus-circle\"></i></a></six-date-time-picker></div><div class=\"col-md-6\"><six-date-time-picker ng-model=\"dates.out\" date-options=\"dateOptions\" enable-time=\"false\"><a class=\"btn btn-success\" ng-click=\"addDate(dates.out, \'end\')\" ng-disabled=\"isWritePermAllowed()===false\"><i class=\"fa fa-plus-circle\"></i></a></six-date-time-picker></div></div></div></div></div><div class=\"row wrapper\"><div class=\"row\"><div class=\"col-md-3 control-label\"><label>Data di inizio predefinita:</label></div><div class=\"col-md-3 control-label\"><label>Data di fine predefinita:</label></div></div><div class=\"row\"><div class=\"col-md-3\"><input class=\"form-control\" value=\"{{zonaClimatica.model.day_in}} {{zonaClimatica.model.month_in}}\" disabled=\"\"></div><div class=\"col-md-3\"><input class=\"form-control\" value=\"{{zonaClimatica.model.day_out}} {{zonaClimatica.model.month_out}}\" disabled=\"\"></div></div></div><div class=\"row wrapper\"><div class=\"row\"><div class=\"col-md-3 control-label\"><label>Elenco modifiche:</label></div></div><div id=\"gridDates\" ui-grid=\"gridDates\" class=\"grid col-md-12 no_padding\" ui-grid-resize-columns=\"\"></div></div></div></div></div></div>");
$templateCache.put("energy/perspective/detail.html","<div class=\"row\"><div class=\"col-sm-12\"><button ng-click=\"unselect()\" type=\"button\" class=\"btn btn-default btn-sm\"><span class=\"glyphicon glyphicon-menu-left\"></span> Indietro</button></div></div><div class=\"col-md-12\"><hr></div><div class=\"row\"><div class=\"col-sm-12\"><tabset class=\"tab-container\"><tab heading=\"Dettaglio\"><div class=\"row\"><div class=\"col-sm-4\"><label for=\"code\">Codice</label> <input id=\"code\" name=\"code\" class=\"form-control\" ng-model=\"perspective.code\" disabled=\"\"></div><div class=\"col-sm-8\"><label for=\"description\">Descrizione</label> <input id=\"description\" name=\"description\" placeholder=\"\" class=\"form-control\" ng-model=\"perspective.description\" disabled=\"\"></div></div><div class=\"row\"><div class=\"col-sm-8\"><label for=\"type\">Tipologia</label> <input id=\"type\" name=\"type\" class=\"form-control\" ng-model=\"perspective.type.description\" disabled=\"\"></div><div class=\"col-sm-4\"><label for=\"year\">Anno</label> <input id=\"year\" name=\"description\" placeholder=\"\" class=\"form-control\" ng-model=\"perspective.year\" disabled=\"\"></div></div></tab><tab heading=\"Statistiche\"><div class=\"row\"><div class=\"col-md-12\"><six-loading-place-holder sx-model=\"loadingPlaceHolder\" sx-height=\"\'450px\'\"></six-loading-place-holder></div><div class=\"row wrapper\" ng-if=\"!loadingPlaceHolder.show\"><div class=\"col-md-12\" ng-if=\"!budget.list || budget.list.length === 0\">Nessun dato da mostrare</div><div class=\"col-md-12\" ng-if=\"budget.list && budget.list.length > 0\"><table class=\"detailTable table-hover\"><tr><th style=\"text-align: center\">U.M. [Kwh]</th><th ng-repeat=\"record in budget.list\">{{record.date | date: \'MMM\': \'+01:00\'}}</th><th>Tot.</th></tr><tr><td>Budget</td><td class=\"numberCell\" ng-repeat=\"record in budget.list\">{{record.budget | number: 3}}</td><td class=\"numberCell\">{{budget.totalBudget | number: 3}}</td></tr><tr><td>Consuntivo</td><td class=\"numberCell\" ng-repeat=\"record in budget.list\">{{record.consumption | number: 3}}</td><td class=\"numberCell\">{{budget.totalConsumption | number: 3}}</td></tr><tr><td>Stagionalità</td><td class=\"numberCell\" ng-repeat=\"record in budget.list\">{{record.season | number: 3}}</td><td class=\"numberCell\">{{budget.season | number: 3}}</td></tr><tr><td>&Delta; Stagionalità</td><td class=\"numberCell\" ng-repeat=\"record in budget.list\">{{record.deltaSeason | number: 3}}</td><td class=\"numberCell\">{{budget.deltaSeason | number: 3}}</td></tr><tr><td>&Delta; Tecnico</td><td class=\"numberCell\" ng-repeat=\"record in budget.list\">{{record.deltaTech | number: 3}}</td><td class=\"numberCell\">{{budget.deltaTech | number: 3}}</td></tr><tr><td>%</td><td class=\"numberCell\" ng-repeat=\"record in budget.list\">{{record.percentage | number: 2}}</td><td class=\"numberCell\">{{budget.percentage | number: 2}}</td></tr></table></div></div><div class=\"row wrapper\"><div class=\"col-md-12\"><six-multi-series-line-chart sx-id=\"graph1\" sx-graph-data=\"graphData\" sx-y-axis-legend=\"\'Consumi\'\" sx-graph-title=\"Consumi\" sx-series-colors=\"[\'#1044EE\', \'#10BB99\', \'#EE2222\']\" sx-interpolate=\"\'monotone\'\"></six-multi-series-line-chart></div></div><div class=\"row wrapper\"><div class=\"col-md-12\"><six-multi-series-line-chart sx-id=\"graph2\" sx-graph-data=\"graphDataCumulative\" sx-y-axis-legend=\"\'Consumi\'\" sx-graph-title=\"Consumi cumulati\" sx-series-colors=\"[\'#1044EE\', \'#10BB99\']\" sx-interpolate=\"\'monotone\'\"></six-multi-series-line-chart></div></div></div></tab><tab heading=\"Prospettiva\"><div class=\"row wrapper\"><div class=\"col-sm-2 col-md-offset-10\"><button ng-click=\"generate()\" type=\"button\" class=\"btn btn-default btn-sm\"><i class=\"fa fa-cog\"></i> Genera Budget</button></div></div><div class=\"row\"><div class=\"col-md-12\" ng-if=\"perspective.list && perspective.list.length > 0\"><table class=\"detailTable table-hover\"><tr><th style=\"text-align: center\">U.M. [Kwh]</th><th ng-repeat=\"record in perspective.list\">{{record.date | date: \'MMM\': \'+01:00\'}}</th><th>Tot.</th></tr><tr><td>Budget Precedente</td><td class=\"numberCell\" ng-repeat=\"record in perspective.list\">{{record.oldBudget | number: 3}}</td><td class=\"numberCell\">{{perspective.totalOldBudget | number: 3}}</td></tr><tr ng-if=\"perspective.type.code !== \'PT001\'\"><td>&Delta; Tecnico</td><td class=\"numberCell\" ng-repeat=\"record in perspective.list\">{{record.deltaTech | number: 3}}</td><td class=\"numberCell\">{{perspective.deltaTech | number: 3}}</td></tr><tr><td>Budget Previsione</td><td class=\"numberCell\" ng-repeat=\"record in perspective.list\">{{record.budget | number: 3}}</td><td class=\"numberCell\">{{perspective.totalBudget | number: 3}}</td></tr><tr ng-if=\"perspective.type.code !== \'PT001\'\"><td>&Delta; Tecnico Previsoine %</td><td class=\"numberCell\" ng-repeat=\"i in [0,1,2,3,4,5,6,7,8,9,10,11]\">{{techFactor[i] * 100 | number: 2}}</td><td class=\"numberCell\"></td></tr><tr><td>Stagionalità</td><td class=\"numberCell\" ng-repeat=\"record in perspective.list\">{{record.season | number: 3}}</td><td class=\"numberCell\">{{perspective.season | number: 3}}</td></tr><tr><td>&Delta; Stagionalità %</td><td class=\"numberCell\" ng-repeat=\"record in perspective.list\">{{record.deltaSeason | number: 2}}</td><td class=\"numberCell\">{{perspective.deltaSeason | number: 2}}</td></tr><tr><td>Prospettiva</td><td class=\"numberCell\" ng-repeat=\"record in perspective.list\">{{record.perspective | number: 2}}</td><td class=\"numberCell\">{{perspective.totalPerspective | number: 3}}</td></tr></table></div></div><div class=\"row wrapper\"><div class=\"col-md-12\"><six-multi-series-line-chart sx-id=\"graph3\" sx-graph-data=\"graphPrev\" sx-y-axis-legend=\"\'Prospettiva\'\" sx-graph-title=\"Prospettiva\" sx-series-colors=\"[\'#1044EE\', \'#f9d21a\', \'#398439\']\" sx-interpolate=\"\'monotone\'\"></six-multi-series-line-chart></div></div><div class=\"row wrapper-md\"><table class=\"detailTable\"><tr><th>Prospettiva</th><th style=\"text-align: left\" ng-repeat=\"record in perspective.list\">{{record.date | date: \'MMM\': \'+01:00\'}}</th></tr><tr><td>Fattore Stagionale</td><td style=\"text-align: center\" ng-repeat=\"i in [0,1,2,3,4,5,6,7,8,9,10,11]\"><slider ng-model=\"seasonFactor[i]\" orientation=\"vertical\" min=\"-1\" step=\"0.05\" max=\"1\" ng-change=\"perspectiveComputation(budget, seasonFactor)\"></slider></td></tr><tr ng-if=\"perspective.type.code !== \'PT001\'\"><td>Fattore Tecnico</td><td style=\"text-align: center\" ng-repeat=\"i in [0,1,2,3,4,5,6,7,8,9,10,11]\"><slider ng-model=\"techFactor[i]\" orientation=\"vertical\" min=\"-1\" step=\"0.05\" max=\"1\" ng-change=\"perspectiveComputation(budget, seasonFactor)\"></slider></td></tr></table></div></tab></tabset></div></div>");
$templateCache.put("energy/perspective/perspective.html","<style>\n  .ui-grid-menu-button {\n   height: 30px;\n }\n</style><six-toolbar><six-toolbar-button ng-if=\"generatePerspectiveForm\" icon=\"fa fa-chevron-left\" toolbar-function=\"backToPerspective()\"></six-toolbar-button><six-toolbar-button ng-if=\"!generatePerspectiveForm\" label=\"Trova\" btn-class=\"btn-info\" icon=\"fa fa-search\" toolbar-function=\"loadPerspectiveList()\"></six-toolbar-button><six-toolbar-button ng-if=\"!generatePerspectiveForm\" label=\"Genera\" id=\"btn_new\" btn-class=\"btn-success\" icon=\"fa fa-plus\" toolbar-function=\"toggleNewPerspective()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-12 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Previsioni e Prospettive</h1><small class=\"text-muted\" ng-if=\"!generatePerspectiveForm\">Lista</small> <small class=\"text-muted\" ng-if=\"generatePerspectiveForm\">{{budget.budget_code}}</small></div></div></div><div class=\"wrapper\" collapse=\"isCollapsed\" ng-if=\"!generatePerspectiveForm\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"row\"><div class=\"col-xs-8 col-sm-6\"><six-year-picker id=\"year\" ng-model=\"searchFilter.year\" class=\"input-group\" label-year=\"Anno:\"></six-year-picker></div></div></div></div><div class=\"col-md-12\"><hr></div><div class=\"row\"><div class=\"col-md-12\"><div id=\"gridList\" ui-grid=\"gridListOptions\" class=\"grid\" ui-grid-resize-columns=\"\" ui-grid-exporter=\"\"></div></div></div></div></div><div class=\"wrapper\" collapse=\"!isCollapsed\" ng-if=\"!generatePerspectiveForm\"><div ng-if=\"isCollapsed\" data-ng-include=\"\'energy/perspective/detail.html\'\" class=\"panel-body\"></div></div><div class=\"wrapper-md\" ng-if=\"generatePerspectiveForm\"><uib-tabset class=\"tab-container\" active=\"step\"><uib-tab heading=\"Step 1\" disable=\"step!=1\" index=\"1\" select=\"percent=10\"><p class=\"m-b\">Wizard per la generazione di una nuova previsione e/o prospettiva di budget.</p><uib-progressbar value=\"percent\" class=\"progress-xs\" type=\"success\"></uib-progressbar><h4>Dati Base</h4><form name=\"step1\" class=\"form-validation\"><p>Codice:</p><input name=\"code\" class=\"form-control\" ng-model=\"perspective.code\" required=\"\"><p class=\"m-t\">Descrizione:</p><input name=\"description\" placeholder=\"\" class=\"form-control\" ng-model=\"perspective.description\" required=\"\"><div class=\"m-t m-b\"><button type=\"button\" class=\"btn btn-default btn-rounded\" ng-click=\"toggleNewPerspective()\">Annulla</button> <button type=\"submit\" ng-disabled=\"step1.$invalid\" class=\"btn btn-default btn-rounded\" ng-click=\"goToStep(2)\">Successivo</button></div></form></uib-tab><uib-tab heading=\"Step 2\" index=\"2\" disable=\"step!=2\" select=\"percent=30\"><form name=\"step2\" class=\"form-validation\"><p class=\"m-b\">Avanzamento</p><uib-progressbar value=\"percent\" class=\"progress-xs\" type=\"success\"></uib-progressbar><six-year-picker id=\"yearPerspective\" name=\"yearPerspective\" ng-model=\"perspective.year\" class=\"input-group\" label-year=\"Anno Previsione :\" sx-plus-minus=\"10\" required=\"\"></six-year-picker><label>Tipologia :</label><select class=\"form-control\" ng-model=\"perspective.type\" ng-options=\"t.description for t in perspectiveTemplate.template\" required=\"\"></select><div class=\"m-t m-b\"><button type=\"button\" class=\"btn btn-default btn-rounded\" ng-click=\"goToStep(1)\">Precedente</button> <button type=\"submit\" ng-disabled=\"step2.$invalid\" class=\"btn btn-default btn-rounded\" ng-click=\"goToStep(3)\">Successivo</button></div></form></uib-tab><uib-tab heading=\"Step 3\" disable=\"step!=3\" index=\"3\" select=\"percent=60\"><p class=\"m-b\">Tutte le informazioni necessarie sono state inserite.</p><uib-progressbar value=\"percent\" class=\"progress-xs\" type=\"success\"></uib-progressbar><p>Premere \"Genera\" per completare la procedura di generazione</p><div class=\"m-t m-b\"><button type=\"button\" class=\"btn btn-default btn-rounded\" ng-click=\"goToStep(2)\">Precedente</button> <button type=\"button\" class=\"btn btn-default btn-rounded\" ng-click=\"percent=100; createPerspective();\">Genera</button></div></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("energy/pricelist/importTemplate.html","<input type=\"file\" accept=\".xls,.xlsx,.ods\" xlsxreader=\"\" opts=\"gridDetailOptions\" multiple=\"false\">");
$templateCache.put("energy/pricelist/pricelist_component_menu.html","<style type=\"text/css\">\n  .floating-btn {\n    z-index: 9999999;\n    right: 0;\n    top: 150px;\n    bottom: auto;\n    padding: 0;\n    margin: 0;\n    opacity: 0.5;\n  }\n  .floating-btn a {\n    color: #58666e;\n    background-color: #23b7e5;\n    border-radius: 10px 0px 0px 10px;\n  }\n  .floating-btn.active {\n    visibility: hidden;\n  }\n  .floating-btn .mfb-component__button--main {\n    width: 26px;\n  }\n  .floating-btn:hover {\n    opacity: 1;\n  }\n  .selected {\n    background-color: #11c7f5 !important;\n  }\n</style><six-toolbar><six-toolbar-item label=\"Template\" icon=\"fa fa-download icon text-info-dker\" ng-show=\"mode.mode === \'import\'\" toolbar-function=\"createTemplate()\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Importa\" icon=\"fa fa-upload\" toolbar-function=\"importData()\" ng-if=\"mode.mode === \'import\'\" btn-class=\"btn-success\" sx-disabled=\"percent === 100 || isAllOk === false || !importGridOptions.data.length\"></six-toolbar-button><six-toolbar-button id=\"btn_search\" icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"loadData()\" sx-disabled=\"!selectedComponentType\"></six-toolbar-button></six-toolbar><nav class=\"floating-btn\" ng-if=\"!menu.show\" mfb-menu=\"\" position=\"br\" effect=\"zoomin\" label=\"Menu componenti\" active-icon=\"fa {{menu.show?\'fa-chevron-right\':\'fa-chevron-left\'}}\" resting-icon=\"fa fa-puzzle-piece\" toggling-method=\"hover\" ng-click=\"menu.show=!menu.show\"></nav><six-sidebar sx-id=\"componentMenu\" sx-position=\"right\" sx-title=\"\'Comp.\'\" sx-dimension=\"s\" six-sidebar-autoclose=\"false\" sx-opened=\"menu.show\" sx-pinned=\"true\" sx-pinnable=\"true\"><ul class=\"nav list-sidebar-nav\"><li ng-repeat=\"c in menu.list\"><a ng-click=\"selectComponent(c)\" ng-class=\"{\'selected\': c.code==menu.selected.code}\">{{c.description}}</a></li></ul></six-sidebar><div class=\"constructor\"><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">{{menu.selected.description}}</h1></div><div class=\"pull-right m-r\"><div class=\"btn-group\"><label class=\"btn btn-sm btn-default\" ng-model=\"mode.mode\" uib-btn-radio=\"\'show\'\" tooltip=\"Visualizza\" title=\"Visualizza\"><span class=\"fa fa-eye\"></span></label> <label class=\"btn btn-sm btn-default\" ng-model=\"mode.mode\" uib-btn-radio=\"\'import\'\" tooltip=\"Importa\" title=\"Importa\" ng-disabled=\"isWritePermAllowed()===false\"><span class=\"fa fa-upload\"></span></label></div><div class=\"m-l btn-group\"><button ng-click=\"addRecord()\" class=\"btn btn-default btn-sm\" ng-disabled=\"mode.mode === \'import\' || isWritePermAllowed()===false\"><span class=\"fa fa-plus\"></span> Aggiungi</button> <button ng-click=\"removeRecords()\" class=\"btn btn-default btn-sm\" ng-disabled=\"mode.mode === \'import\' || isWritePermAllowed()===false\"><span class=\"fa fa-times\"></span> Rimuovi</button></div></div></div></div><div class=\"panel-body\"><six-grid-pagination sx-id=\"{{menu.selected.code}}_grid\" get-data-callback=\"getData()\" get-list-callback=\"getData()\" get-all-data-callback=\"getAll()\" items-list=\"components.list\" column-defs=\"gridDetailOptions.columnDefs\" grid-app-callbacks=\"gridAppCallbacks\" grid-options=\"gridDetailOptions\" enable-state-saving=\"true\" params=\"params\" import-mode=\"mode.mode==\'import\'\" ng-if=\"mode.mode!=\'import\'\"></six-grid-pagination><div id=\"import_grid\" class=\"grid\" ui-grid=\"importGridOptions\" ui-grid-resize-columns=\"\" ng-if=\"mode.mode==\'import\'\"><div class=\"grid-msg-overlay\" ng-show=\"!importGridOptions.data || importGridOptions.data.length==0\"><div class=\"msg\"><div class=\"center\"><span class=\"muted\">Selezionare File Excel</span><br><input type=\"file\" accept=\".xls,.xlsx,.ods\" xlsxreader=\"\" opts=\"importGridOptions\" multiple=\"false\"></div></div></div></div></div></div></div></div>");
$templateCache.put("energy/pricelist/pricelist_detail.html","<style type=\"text/css\">\n  .override-checkbox-i {\n    margin-left: inherit !important;\n  }\n</style><form name=\"form\"><six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" toolbar-function=\"goBack()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"saveOrUpdate()\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" ng-if=\"header.version\" toolbar-function=\"deleteWithDialog(header.version)\" sx-disabled=\"isDeletePermAllowed()===false\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><span ng-if=\"header.version\"><h1 class=\"m-n font-thin h3 text-black\">{{header.model.description}}</h1><small class=\"text-muted\">{{header.model.code}} [UUID: {{header.UUID}}]</small></span> <span ng-if=\"!header.version\"><h1 class=\"m-n font-thin h3 text-black\">NUOVO LISTINO</h1><small class=\"text-muted\">Dettaglio listino</small></span></div></div></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-3\">Codice:<div class=\"input-group col-md-12\"><input type=\"text\" id=\"code\" name=\"code\" class=\"form-control\" ng-class=\"{\'bg-danger lt\': (form.$submitted && form.code.$error.required)}\" ng-model=\"header.model.code\" ng-disabled=\"header.version\" required=\"\"></div></div><div class=\"col-md-3\">Descrizione:<div class=\"input-group col-md-12\"><input type=\"text\" id=\"description\" name=\"description\" class=\"form-control col-md-12\" ng-model=\"header.model.description\" required=\"\"></div></div><div class=\"col-md-3\">Inizio validità:<six-date-time-picker id=\"from\" name=\"date_from\" ng-model=\"header.model.from\" enable-time=\"false\" sx-required=\"true\" date-options=\"dateOptions\"></six-date-time-picker></div><div class=\"col-md-3\">Fine validità:<six-date-time-picker id=\"to\" name=\"date_to\" ng-model=\"header.model.to\" enable-time=\"false\" date-options=\"dateOptions\"></six-date-time-picker></div></div><div class=\"row\"><div class=\"col-md-3\">Vettore<six-lookup-2 id=\"tipo\" ng-model=\"header.model\" sx-type=\"\'vettoreenergetico\'\" sx-field=\"\'vettore_id\'\" sx-compact=\"true\" sx-item-template=\"\'{{item.description}}\'\"></six-lookup-2></div><div class=\"col-md-3\">Fornitore<six-lookup-2 id=\"provider\" ng-model=\"header.model\" sx-type=\"\'fornitore\'\" sx-field=\"\'fornitore_id\'\"></six-lookup-2></div><div class=\"col-md-3\" ng-if=\"header.model.vettore_id.code===\'gas\'\">Spread<div class=\"input-group\"><input type=\"number\" class=\"form-control\" step=\"any\" ng-model=\"header.model.spread\"> <span class=\"input-group-addon\">€/GJ</span></div></div></div><div class=\"row\"><div class=\"col-md-3\">Tipo<six-select id=\"type\" ng-model=\"header.model.type\" sx-item-list=\"types\" ng-show-description=\"\'false\'\" sx-disabled=\"!header.model.vettore_id\"></six-select></div></div><hr><div ng-if=\"showFixedPricesGrid()\"><h1 class=\"m-b m-t font-thin h3 text-black\">Tariffe:</h1><div id=\"slotsGridList\" ui-grid=\"pricesGridOptions\" class=\"grid\" external-scopes=\"clickHandler\" style=\"height: 350px\" ui-grid-edit=\"\" ui-grid-row-edit=\"\" ui-grid-cellnav=\"\" ui-grid-selection=\"\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\"></div></div><div class=\"row\" ng-if=\"(header.model.type.code===\'monomia\' || header.model.type.code===\'binomia\') && header.model.vettore_id.code===\'gas\'\"><div class=\"col-md-3\">Delibera AEEG:<six-select ng-model=\"header.model.delibera_aeeg\" sx-item-list=\"deliberaAEEGList\" sx-show-description=\"false\"></six-select></div><div class=\"col-md-3\">PCS std.:<div class=\"input-group\"><ui-select tagging=\"\" tagging-label=\"(personalizzato)\" ng-model=\"header.model.pcs_std\" theme=\"bootstrap\" sortable=\"true\" ng-disabled=\"disabled\" on-select=\"$select.selected = onPcsStdSelect($item)\"><ui-select-match class=\"ui-select-match\" placeholder=\"Select...\">{{$select.selected}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in pcsStdList | filter:$select.search\">{{item}}</ui-select-choices></ui-select><span class=\"input-group-addon\">Mj/SMC</span></div></div></div><hr><div ng-if=\"header.model.vettore_id.code===\'gas\'\"><h4>Dipendenze:</h4><div class=\"list-group-item clearfix m-t\" ng-repeat=\"cat in dependencies\"><h4>{{cat.description}}</h4><label class=\"checkbox-inline i-checks override-checkbox-i m-b col-md-3\" ng-repeat=\"dep in cat.deps\" uib-tooltip-html=\"\'um: {{dep.um}}<br> Rif. legislativo: {{dep.ref}}\'\" tooltip-placement=\"left\"><input type=\"checkbox\" ng-model=\"header.model.dependencies[dep.code]\"><i></i><span class=\"i-checks\" ng-bind-html=\"dep.description\"></span></label></div></div></div></div></div></form>");
$templateCache.put("energy/pricelist/pricelist_list.html","<six-toolbar><six-toolbar-button label=\"Nuovo\" icon=\"fa fa-plus\" toolbar-function=\"newPricelist()\" btn-class=\"btn-info\" id=\"btn_item_create\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button></six-toolbar><form name=\"form\"><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><span ng-if=\"!header.version\"><h1 class=\"m-n font-thin h3 text-black\">LISTINI</h1><small class=\"text-muted\">Lista</small></span></div></div></div><div class=\"panel-body\"><div class=\"wrapper\"><six-grid-pagination sx-id=\"pricelist_list\" get-data-callback=\"findPriceList()\" get-list-callback=\"findPriceList()\" items-list=\"list\" column-defs=\"listGridOptions.columnDefs\" grid-app-callbacks=\"gridAppCallbacks\" grid-options=\"listGridOptions\" enable-state-saving=\"true\" params=\"params\"></six-grid-pagination></div></div></div></div></form>");
$templateCache.put("energy/pricelist/pricelist_sim.html","<style>\n    six-toolbar-item .fa-check{\n        margin-right: 8px;\n    }\n\n    six-toolbar-item .invisible-check{\n        visibility:hidden;\n    }\n\n    six-toolbar-item .fa-check{\n      margin-right: 8px;\n    }\n\n    six-toolbar-item .invisible-check{\n      visibility:hidden;\n    }\n</style><form name=\"form\"><six-toolbar><six-toolbar-item icon-condition=\"simType === ELETTRICITA\" label-condition=\"simType === ELETTRICITA\" label=\"Simulazione (GAS)\" label-disabled=\"Simulazione (ELETTRICO)\" icon-disabled=\"fa fa-bolt icon text-danger-dker\" icon=\"fa fa-cloud icon text-primary-dk\"><li><a href=\"\" ng-click=\"simulateElettric()\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': (simType === GAS)}\"></i> Elettrico</a></li><li><a href=\"\" ng-click=\"simulateGas()\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': simType === ELETTRICITA}\"></i> Gas</a></li></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-save\" label=\"Salva\" btn-class=\"btn-success\" toolbar-function=\"saveOrUpdate();\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-3 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">SIMULAZIONE</h1><small class=\"text-muted\">{{simType}}</small></div></div></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-3\">Codice:<div class=\"input-group\"><input type=\"text\" name=\"code\" class=\"form-control\" ng-class=\"{\'bg-danger lt\': (form.$submitted && form.code.$error.required)}\" ng-model=\"params.code\" required=\"\"></div></div></div><div class=\"row\"><div class=\"col-md-3\">Anno:<six-year-picker ng-model=\"params.year\" sx-plus-minus=\"20\"></six-year-picker></div><div class=\"col-md-3\">Mese:<six-month-picker ng-model=\"params.month\"></six-month-picker></div><div class=\"col-md-3\">Tipo simulazione:<six-select ng-model=\"params.algorithmType\" sx-item-list=\"algorithmTypes\" sx-show-description=\"false\"></six-select></div></div><div class=\"row\"><div class=\"col-md-3\">Vettore<six-lookup id=\"vettore\" ng-model=\"vettore\" sx-type=\"\'vettoreenergetico\'\" sx-field=\"\'id\'\" sx-disabled=\"\'true\'\"></six-lookup></div><div class=\"col-md-3\">Tipo contatore<six-lookup id=\"tipo\" sx-base-path=\"\'schema\'\" ng-model=\"params.contatoreType\" sx-field=\"\'id\'\" sx-filter=\"contatoreTypeFilter\" sx-disabled=\"!vettore.id\"></six-lookup></div><div class=\"col-md-3\">Contatore<six-lookup id=\"contatore\" ng-model=\"params.contatore\" sx-type=\"params.contatoreType.id.UUID\" sx-field=\"\'id\'\" sx-object=\"params.contatore.obj\" sx-disabled=\"!params.contatoreType.id\"></six-lookup></div><div class=\"col-md-3\">Fornitore<six-lookup id=\"fornitore\" ng-model=\"params.fornitore\" sx-type=\"\'fornitore\'\" sx-field=\"\'id\'\"></six-lookup></div></div><div class=\"m-t panel-group\" id=\"accordion\"><div class=\"panel panel-default\" id=\"panel1\"><div class=\"panel-body\"><a data-toggle=\"collapse\" data-target=\"#collapseOne\" ng-click=\"advancedStatus.open=!advancedStatus.open\"><div class=\"panel-heading\"><h4 class=\"panel-title\"><i class=\"pull-right fa ng-scope fa-angle-right\" ng-class=\"{\'fa-angle-down\': advancedStatus.open, \'fa-angle-right\': !advancedStatus.open}\"></i> Avanzate</h4></div></a><div id=\"collapseOne\" class=\"panel-collapse collapse\"><div id=\"ee_params\" ng-if=\"simType===ELETTRICITA\"><div class=\"row\"><div class=\"col-md-3\">Comune: <span class=\"font-bold\">{{params.comune.id.code}}</span><six-lookup ng-model=\"params.comune\" sx-type=\"\'comune\'\" sx-field=\"\'id\'\" sx-object=\"params.comune.obj\" sx-show-description=\"false\"></six-lookup></div><div class=\"col-md-3\">Provincia: <span class=\"font-bold\">{{params.provincia.id.code}}</span><six-lookup ng-model=\"params.provincia\" sx-type=\"\'provincia\'\" sx-field=\"\'id\'\" sx-object=\"params.provincia.obj\" sx-show-description=\"false\" sx-disabled=\"\'true\'\"></six-lookup></div><div class=\"col-md-3\">Regione: <span class=\"font-bold\">{{params.regione.id.code}}</span><six-lookup ng-model=\"params.regione\" sx-type=\"\'regione\'\" sx-field=\"\'id\'\" sx-object=\"params.regione.obj\" sx-show-description=\"false\" sx-disabled=\"\'true\'\"></six-lookup></div></div><div class=\"row\"><div class=\"col-md-3\">Utenza: <span class=\"font-bold\">{{params.utenza.id.code}}</span><six-lookup ng-model=\"params.utenza\" sx-type=\"\'utenza\'\" sx-field=\"\'id\'\" sx-object=\"params.utenza.obj\" sx-show-description=\"false\"></six-lookup></div><div class=\"col-md-3\">Regime fiscale: <span class=\"font-bold\">{{params.regimeFiscale.id.code}}</span><six-lookup ng-model=\"params.regimeFiscale\" sx-type=\"\'regimefiscale\'\" sx-field=\"\'id\'\" sx-show-description=\"false\" sx-disabled=\"\'true\'\"></six-lookup></div></div><div class=\"row\"><div class=\"col-md-3\">Tensione: <span class=\"font-bold\">{{params.tensione.selected.code}}</span><six-select ng-model=\"params.tensione.selected\" sx-item-list=\"tensioneList\" sx-show-description=\"false\"></six-select></div><div class=\"col-md-3\">Livello tensione: <span class=\"font-bold\">{{params.livelloTensione.id.code}}</span><six-lookup ng-model=\"params.livelloTensione\" sx-type=\"\'classificazionetensione\'\" sx-field=\"\'id\'\" sx-show-description=\"false\" sx-disabled=\"\'true\'\"></six-lookup></div><div class=\"col-md-3\">Perdite:<div class=\"input-group col-md-6\"><span ng-if=\"params.perdite != undefined\" class=\"form-control\">{{params.perdite * 100}}</span> <span ng-if=\"params.perdite == undefined\" class=\"form-control\"></span> <span class=\"input-group-addon\">%</span></div></div></div><div class=\"row\"><div class=\"col-md-3\">Potenza impegnata:<div class=\"input-group col-md-6\"><input type=\"number\" class=\"form-control\" ng-model=\"params.potenzaImpegnata\" step=\"1\"> <span class=\"input-group-addon\">kW</span></div></div><div class=\"col-md-3\">Potenza disponibile:<div class=\"input-group col-md-6\"><input type=\"number\" class=\"form-control\" ng-model=\"params.potenzaDisponibile\" step=\"1\"> <span class=\"input-group-addon\">kW</span></div></div><div class=\"col-md-3\"><div class=\"input-group col-md-6\">Potenza max.:<div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"params.potenzaMax\" step=\"1\"> <span class=\"input-group-addon\">kW</span></div></div></div></div><div class=\"row\"><div class=\"col-md-3\">N. contratto:<div class=\"input-group col-md-6\"><input type=\"text\" class=\"form-control\" ng-model=\"params.numContratto\" readonly=\"\"></div></div><div class=\"col-md-3\">Tipo contratto:<div class=\"input-group col-md-12\"><input type=\"text\" class=\"form-control\" ng-model=\"params.tipoContratto\" readonly=\"\"></div></div><div class=\"col-md-3\">Lettera comma 2.1 TIV:<div class=\"input-group col-md-6\"><input type=\"text\" class=\"form-control\" ng-model=\"params.tiv\" readonly=\"\"></div></div><div class=\"col-md-3\">Lettera comma 2.2 TIT:<div class=\"input-group col-md-6\"><input type=\"text\" class=\"form-control\" ng-model=\"params.tit\" readonly=\"\"></div></div><div class=\"col-md-3\">Spread:<div class=\"input-group col-md-6\"><input type=\"number\" class=\"form-control\" ng-model=\"params.spread\" step=\"0.000001\"> <span class=\"input-group-addon\">c€/kWh</span></div></div></div><div class=\"row panel wrapper\">Consumi [kWh]:<table><tr><td ng-repeat=\"month in getMonths()\">{{getMonthName(month)}}</td></tr><tr><td ng-repeat=\"month in getMonths()\"><input type=\"number\" class=\"form-control\" ng-model=\"params.consumptions[month]\" step=\"0.0001\"></td></tr></table></div></div><div id=\"gas_params\" ng-if=\"simType===GAS\"><div class=\"row\"><div class=\"col-md-3\">Comune: <span class=\"font-bold\">{{params.comune.id.code}}</span><six-lookup ng-model=\"params.comune\" sx-type=\"\'comune\'\" sx-field=\"\'id\'\" sx-object=\"params.comune.obj\" sx-show-description=\"false\"></six-lookup></div><div class=\"col-md-3\">Provincia: <span class=\"font-bold\">{{params.provincia.id.code}}</span><six-lookup ng-model=\"params.provincia\" sx-type=\"\'provincia\'\" sx-field=\"\'id\'\" sx-object=\"params.provincia.obj\" sx-show-description=\"false\" sx-disabled=\"\'true\'\"></six-lookup></div><div class=\"col-md-3\">Regione: <span class=\"font-bold\">{{params.regione.id.code}}</span><six-lookup ng-model=\"params.regione\" sx-type=\"\'regione\'\" sx-field=\"\'id\'\" sx-object=\"params.regione.obj\" sx-show-description=\"false\" sx-disabled=\"\'true\'\"></six-lookup></div><div class=\"col-md-3\">Ambito tariffario: <span class=\"font-bold\">{{params.ambitoTariffario.id.code}}</span><six-lookup ng-model=\"params.ambitoTariffario\" sx-type=\"\'ambitotariffario\'\" sx-field=\"\'id\'\" sx-show-description=\"false\" sx-disabled=\"\'true\'\"></six-lookup></div></div><div class=\"row\"><div class=\"col-md-3\">Classe misuratore: <input type=\"text\" class=\"form-control\" ng-model=\"params.classeMisuratore\"></div><div class=\"col-md-3\">Regime fiscale: <span class=\"font-bold\">{{params.regimeFiscale.id.code}}</span><six-lookup ng-model=\"params.regimeFiscale\" sx-type=\"\'regimefiscale\'\" sx-field=\"\'id\'\" sx-show-description=\"false\"></six-lookup></div><div class=\"col-md-3\">Tipologia cliente: <span class=\"font-bold\">{{params.tipologiaCliente.id.code}}</span><six-lookup ng-model=\"params.tipologiaCliente\" sx-type=\"\'tipologiacliente\'\" sx-field=\"\'id\'\" sx-show-description=\"false\"></six-lookup></div><div class=\"col-md-3\">Delibera AEEG: <span class=\"font-bold\">{{params.deliberaAEEG.code}}</span><six-select ng-model=\"params.deliberaAEEG\" sx-item-list=\"deliberaEEGList\" sx-show-description=\"false\"></six-select></div></div><div class=\"row\"><div class=\"col-md-3\">PCS std.:<input type=\"number\" class=\"form-control\" ng-model=\"params.pcsStd\" step=\"0.0001\"></div><div class=\"col-md-3\">PCS:<input type=\"number\" class=\"form-control\" ng-model=\"params.pcsSim\" step=\"0.0001\"></div></div><div class=\"row\"><div class=\"col-md-3\">Cg:<div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"params.cg\" step=\"0.000001\" required=\"\"> <span class=\"input-group-addon\">m<sup>3</sup>/gg</span></div></div><div class=\"col-md-3\">D:<div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"params.d\" step=\"0.000001\" required=\"\"> <span class=\"input-group-addon\">m</span></div></div><div class=\"col-md-3\">TF:<div class=\"input-group\"><input type=\"number\" name=\"tf\" class=\"form-control\" ng-model=\"params.tf\" step=\"0.000001\" required=\"\" readonly=\"\"> <span class=\"input-group-addon\">€/PDR/Mese</span></div></div></div><div class=\"row\"><div class=\"col-md-3\" ng-if=\"params.algorithmType.code!==\'fisso\'\">Spread:<div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"params.spread\" step=\"0.000001\"> <span class=\"input-group-addon\">c€/SMC</span></div></div><div class=\"col-md-3\" ng-if=\"params.algorithmType.code===\'fisso\'\">Fisso:<div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"params.fisso\" step=\"0.000001\"> <span class=\"input-group-addon\">c€/SMC</span></div></div></div><div class=\"row wrapper\">Consumi [SMC]:<table><tr><td ng-repeat=\"month in getMonths()\">{{getMonthName(month)}}</td></tr><tr><td ng-repeat=\"month in getMonths()\"><input type=\"number\" class=\"form-control\" ng-model=\"params.consumptions[month]\" step=\"0.0001\"></td></tr></table></div></div></div></div></div></div><div class=\"panel\"><div class=\"row panel-body\"><h1 class=\"m-b m-t font-thin h3 text-black\">Risultati simulazione:</h1><div class=\"row wrapper\">UM: <span class=\"font-bold well well-sm\">{{um}}</span> <button type=\"button\" class=\"btn btn-sm pull-right\" ng-click=\"simulate()\"><span class=\"fa fa-gear\"></span> Simula</button></div><div id=\"grid1\" ui-grid=\"gridOptions\" class=\"grid\" external-scopes=\"clickHandler\" style=\"height: 460px\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\"></div></div><div class=\"row panel-body\"><h1 class=\"m-b m-t font-thin h3 text-black\">Configurazioni salvate:</h1><div id=\"gridList\" ui-grid=\"listGridOptions\" class=\"grid\" external-scopes=\"clickHandler\" style=\"height: 350px\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\"></div></div><div class=\"row panel-body\"><h1 class=\"m-b m-t font-thin h3 text-black\">Listini salvati:</h1><six-grid-pagination sx-id=\"priceListGridOptions\" get-data-callback=\"findPriceList()\" get-list-callback=\"findPriceList()\" items-list=\"pricelist\" column-defs=\"priceListGridOptions.columnDefs\" grid-app-callbacks=\"priceListGridAppCallbacks\" grid-options=\"priceListGridOptions\" enable-state-saving=\"true\" params=\"priceListParams\"></six-grid-pagination></div></div></div></div></div></form>");
$templateCache.put("energy/readsexport/readsexport.html","<div id=\"loading-bar-container\"></div><six-toolbar class=\"constructor\"><six-toolbar-button label=\"Stampa PDF\" btn-class=\"btn-default\" icon=\"fa fa-print\" toolbar-function=\"callJasper(\'pdf\')\"></six-toolbar-button><six-toolbar-button label=\"Stampa Excel\" btn-class=\"btn-default\" icon=\"fa fa-file-excel-o\" toolbar-function=\"callJasper(\'xlsx\')\"></six-toolbar-button></six-toolbar><six-sidebar sx-id=\"vectors_sidebar\" sx-position=\"left\" sx-title=\"\'Vettori\'\" sx-dimension=\"s\" sx-opened=\"sidebar\"><ul id=\"list-sidebar-ul\" class=\"nav list-sidebar-nav\"><li class=\"m-l-xs m-r-xs\"><a ng-click=\"goToAnchor(\'top\')\">Top</a></li><li ng-repeat=\"vector in vectors\" class=\"m-l-xs m-r-xs\"><a ng-click=\"goToAnchor(vector.model.code+\'_details\')\" six-sidebar-autoclose=\"true\">{{vector.model.description}}</a></li></ul></six-sidebar><div id=\"top\" class=\"constructor\"><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">ESPORTAZIONE LETTURE</h1><small>Esportazione letture per sistema di fatturazione</small></div></div></div><div class=\"panel-body\"><div class=\"row wrapper\"><div class=\"col-md-2\"><label class=\"control-label\">Commesse</label><six-select-2 sx-id=\"commission_list\" sx-list=\"commissionList\" sx-title=\"\'Commessa\'\" ng-model=\"commissions\" sx-field=\"\'selected\'\" sx-placeholder=\"\'commessa...\'\" sx-required=\"true\" sx-multiple=\"true\"></six-select-2></div><div class=\"col-md-2\"><label class=\"control-label\">Vettore energetico</label><six-lookup-2 sx-id=\"vetten\" ng-model=\"vector\" sx-type=\"\'vettoreenergetico\'\" sx-field=\"\'id\'\" sx-object=\"currentVector\"></six-lookup-2></div><div class=\"col-md-2\"><label id=\"type_label\" class=\"control-label\">Tipo</label><six-lookup-2 sx-id=\"type\" sx-base-path=\"\'schema\'\" ng-model=\"type\" sx-title=\"\'Tipo\'\" sx-field=\"\'type_id\'\" sx-auto-init=\"true\" sx-filter=\"contatoreTypeFilter\" sx-required=\"true\"></six-lookup-2></div><div class=\"col-md-2\"><label id=\"record_label\" class=\"control-label\">Contatore</label><six-lookup-2 sx-id=\"record\" ng-model=\"record\" sx-field=\"\'record_id\'\" sx-title=\"\'Contatore\'\" sx-type=\"type.type_id.code\" sx-cross=\"true\" sx-filter=\"recordFilter\"></six-lookup-2></div><div class=\"col-md-2\"><label class=\"control-label\">Da data:</label><p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"\" ng-model=\"datePicker.from\" is-open=\"statusFrom.opened\" datepicker-options=\"dateOptionsStart\" ng-required=\"true\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openFrom($event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-2\"><label class=\"control-label\">A data:</label><p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"\" ng-model=\"datePicker.to\" is-open=\"statusTo.opened\" datepicker-options=\"dateOptionsEnd\" ng-required=\"true\" close-text=\"Close\" ng-change=\"setEndDate()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openTo($event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"row wrapper\"><div class=\"col-md-12\"><div class=\"alert alert-warning\" role=\"alert\">N.B. Attualmente è supportata soltanto l\'esportazione di letture di contatori gas</div></div></div></div></div></div></div>");
$templateCache.put("energy/readtemplate/readtemplate.html","<style type=\"text/css\">\n  .insert_padding {\n    padding: 15px;\n  }\n\n  .dimesion_grid{\n    height: 240px;\n  }\n\n  .readingsButton{\n      width:130px;\n      margin-left: 20px;\n  }\n</style><div class=\"col-md-12 override-padding-15-px\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-12 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">STAMPA LETTURE</h1></div></div></div><div class=\"panel-body\"><div class=\"col-md-12\"><div class=\"col-md-4\"><label id=\"contatoreId_label\" for=\"schema\" class=\"control-label\">Tipo</label><six-lookup id=\"schema\" ng-model=\"entity\" sx-field=\"\'type\'\" sx-base-path=\"\'schema\'\"></six-lookup></div><div class=\"col-md-3\"><label id=\"month_label\" for=\"month\" class=\"control-label\">Mese</label><six-month-picker id=\"month\" ng-model=\"month\" class=\"input-group\"></six-month-picker></div><div class=\"col-md-3\"><label id=\"year_label\" for=\"year\" class=\"control-label\">Anno</label><six-year-picker id=\"year\" ng-model=\"year\" class=\"input-group\"></six-year-picker></div><div class=\"col-md-12\"><hr></div><div class=\"row\"><div class=\"col-md-12\"><div ui-grid=\"gridOptions\" ui-grid-selection=\"\" ui-grid-exporter=\"\" class=\"grid dimesion_grid\"></div></div><div class=\"col-md-12 insert_padding\"><button ng-click=\"addToExportGridOptions()\" ng-disabled=\"gridApi.selection.getSelectedRows().length == 0\" class=\"btn btn-success pull-right control-label readingsButton\"><i class=\"fa fa-plus\"></i> Aggiungi righe</button> <button ng-click=\"clearGridOptions()\" ng-disabled=\"data.length == 0\" class=\"btn btn-danger pull-right control-label readingsButton\"><i class=\"fa fa-times\"></i> Svuota tabella</button></div><div class=\"col-md-3\"><label id=\"export_label\" for=\"schema\" class=\"control-label form-group\">Tabella per importazione Excel</label></div><div class=\"col-md-12\"><div ui-grid=\"exportGridOptions\" ui-grid-selection=\"\" ui-grid-exporter=\"\" class=\"grid dimesion_grid\"></div></div><div class=\"col-md-12 insert_padding\"><button ng-click=\"exportXLSX()\" ng-disabled=\"dataExport.length == 0\" class=\"btn btn-success pull-right control-label readingsButton\"><i class=\"fa fa-download\"></i> Esporta</button> <button ng-click=\"clearExportGridOptions()\" ng-disabled=\"dataExport.length == 0\" class=\"btn btn-danger pull-right control-label readingsButton\"><i class=\"fa fa-times\"></i> Svuota tabella</button></div></div></div></div></div></div>");
$templateCache.put("energy/updateregistrationnumber/updateregistrationnumber.html","<div class=\"col-md-12 pad-t-15\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Wizard cambio matricola contatore</h1></div></div></div><div class=\"col-md-12 panel panel-default panel-body\"><div class=\"wrapper-md\"><uib-tabset class=\"tab-container\"><uib-tab index=\"1\"><uib-tab-heading>Step 1</uib-tab-heading><h4>Dati Base</h4><form name=\"step1\" class=\"form-validation\"><p class=\"m-t\">Tipo:</p><six-lookup id=\"record_type\" sx-base-path=\"\'schema\'\" ng-model=\"record\" sx-field=\"\'type_id\'\"></six-lookup><p class=\"m-t\">Contatore:</p><six-lookup id=\"record_id\" ng-model=\"record\" sx-type=\"record.type_id.UUID\" sx-field=\"\'record_id\'\"></six-lookup><div class=\"m-t m-b\" ng-if=\"updates.record_id.type == \'contatoregas\'\"><p class=\"m-t\">Matricola:</p><input name=\"code\" class=\"form-control\" ng-model=\"updates.contatore.model.matricola\" required=\"\"></div><div class=\"m-t m-b\" ng-if=\"updates.record_id.type == \'contatoregas\'\"><p class=\"m-t\">Matricola correttore:</p><input name=\"matricola_correttore\" class=\"form-control\" ng-model=\"updates.contatore.model.matricola_correttore\" required=\"\"></div><div class=\"m-t m-b\" ng-if=\"updates.record_id.type == \'contatoregas\'\"><label class=\"checkbox i-checks m-b inline col-md-12\"><input type=\"checkbox\" ng-model=\"updates.contatore.model.integrato\"><i></i> <span class=\"i-checks\">Misuratore integrato:</span></label></div><div class=\"m-t m-b\" ng-if=\"updates.record_id.type == \'contatoreacqua\' || updates.record_id.type == \'contatoreelettricita\' || updates.record_id.type == \'contatoreteleriscaldamento\' || updates.record_id.type == \'contatoreteleraffreddamento\'\"><p class=\"m-t\">Matricola:</p><input name=\"code\" class=\"form-control\" ng-model=\"updates.contatore.model.code\" required=\"\"></div><div class=\"m-t m-b\" ng-if=\"updates.contatore.model.description != undefined\"><p class=\"m-t\">Descrizione:</p><input name=\"description\" placeholder=\"\" class=\"form-control\" ng-model=\"updates.contatore.model.description\" disabled=\"\"></div></form></uib-tab><uib-tab index=\"2\"><uib-tab-heading>Step 2</uib-tab-heading><form name=\"step2\" class=\"form-validation\"><div class=\"m-t\"><label id=\"date_label\" class=\"control-label\">Data di cambio</label><six-date-time-picker name=\"changingDate\" sx-disabled=\"false\" format=\"\'dd/MM/yyyy\'\" date-options=\"dateOptions\" enable-time=\"false\" ng-model=\"date.changingDate\"></six-date-time-picker></div><div class=\"m-t\" ng-if=\"updates.record_id.type == undefined || updates.contatore.model == undefined\"><p>Nessun contatore selezionato</p></div><hr><div class=\"m-t\" ng-if=\"updates.record_id.type == \'contatoregas\'\"><p>Lettura vecchio contatore alla data di cambio:</p><input type=\"number\" step=\"any\" name=\"readOldLettura\" class=\"form-control\" ng-model=\"reads.readOld.lettura\" ng-required=\"updates.record_id.type == \'contatoregas\'\"><p ng-if=\"!updates.contatore.model.correttore\">Correttore vecchio contatore:</p><p ng-if=\"updates.contatore.model.correttore\">Correttore vecchio contatore: (correttore obbligatorio)</p><input type=\"number\" step=\"any\" name=\"readOldCorrettore\" class=\"form-control\" ng-model=\"reads.readOld.correttore\" ng-required=\"updates.contatore.model.correttore\"><hr><p>Lettura nuovo contatore alla data di cambio:</p><input type=\"number\" step=\"any\" name=\"readNewLettura\" class=\"form-control\" ng-model=\"reads.readNew.lettura\" ng-required=\"updates.record_id.type == \'contatoregas\'\"><p ng-if=\"!updates.contatore.model.correttore\">Correttore nuovo contatore:</p><p ng-if=\"updates.contatore.model.correttore\">Correttore nuovo contatore: (correttore obbligatorio)</p><input type=\"number\" step=\"any\" name=\"readNewCorrettore\" class=\"form-control\" ng-model=\"reads.readNew.correttore\" ng-required=\"updates.contatore.model.correttore\"></div><div class=\"m-t\" ng-if=\"updates.record_id.type == \'contatoreelettricita\'\"><p>Lettura vecchio contatore alla data di cambio:</p><p>Fascia 0:</p><input type=\"number\" step=\"any\" name=\"readOldLetturaF0\" class=\"form-control col-md-6\" ng-model=\"reads.readOld.lettura.f0\"><p>Fascia 1:</p><input type=\"number\" step=\"any\" name=\"readOldLetturaF1\" class=\"form-control col-md-6\" ng-model=\"reads.readOld.lettura.f1\"><p>Fascia 2:</p><input type=\"number\" step=\"any\" name=\"readOldLetturaF2\" class=\"form-control col-md-6\" ng-model=\"reads.readOld.lettura.f2\"><p>Fascia 3:</p><input type=\"number\" step=\"any\" name=\"readOldLetturaF3\" class=\"form-control col-md-6\" ng-model=\"reads.readOld.lettura.f3\"><hr><p>Lettura nuovo contatore alla data di cambio:</p><p>Fascia 0:</p><input type=\"number\" step=\"any\" name=\"readNewLetturaF0\" class=\"form-control col-md-6\" ng-model=\"reads.readNew.lettura.f0\"><p>Fascia 1:</p><input type=\"number\" step=\"any\" name=\"readNewLetturaF1\" class=\"form-control col-md-6\" ng-model=\"reads.readNew.lettura.f1\"><p>Fascia 2:</p><input type=\"number\" step=\"any\" name=\"readNewLetturaF2\" class=\"form-control col-md-6\" ng-model=\"reads.readNew.lettura.f2\"><p>Fascia 3:</p><input type=\"number\" step=\"any\" name=\"readNewLetturaF3\" class=\"form-control col-md-6\" ng-model=\"reads.readNew.lettura.f3\"></div><div class=\"m-t\" ng-if=\"updates.record_id.type == \'contatoreteleriscaldamento\' || updates.record_id.type == \'contatoreteleraffreddamento\'\"><p>Lettura vecchio contatore alla data di cambio:</p><input type=\"number\" step=\"any\" name=\"readOldLettura\" class=\"form-control\" ng-model=\"reads.readOld.lettura\" ng-required=\"updates.record_id.type == \'contatoreteleriscaldamento\' || updates.record_id.type == \'contatoreteleraffreddamento\'\"><hr><p>Lettura nuovo contatore alla data di cambio:</p><input type=\"number\" step=\"any\" name=\"readNewLettura\" class=\"form-control\" ng-model=\"reads.readNew.lettura\" ng-required=\"updates.record_id.type == \'contatoreteleriscaldamento\' || updates.record_id.type == \'contatoreteleraffreddamento\'\"></div><div class=\"m-t\" ng-if=\"updates.record_id.type == \'serbatoiopressioneatmosferica\'\"><p>Steccatura vecchio serbatoio alla data di cambio:</p><input type=\"number\" step=\"any\" name=\"readOldLettura\" class=\"form-control\" ng-model=\"reads.readOld.lettura\" ng-required=\"updates.record_id.type == \'serbatoiopressioneatmosferica\'\"><hr><p>Steccatura nuovo serbatoio alla data di cambio:</p><input type=\"number\" step=\"any\" name=\"readNewLettura\" class=\"form-control\" ng-model=\"reads.readNew.lettura\" ng-required=\"updates.record_id.type == \'serbatoiopressioneatmosferica\'\"></div><div class=\"m-t\" ng-if=\"updates.record_id.type == \'serbatoioinpressione\'\"><p>Lettura vecchio serbatoio alla data di cambio:</p><input type=\"number\" step=\"any\" name=\"readOldLettura\" class=\"form-control\" ng-model=\"reads.readOld.lettura\" ng-required=\"updates.record_id.type == \'serbatoioinpressione\'\"><hr><p>Lettura nuovo serbatoio alla data di cambio:</p><input type=\"number\" step=\"any\" name=\"readNewLettura\" class=\"form-control\" ng-model=\"reads.readNew.lettura\" ng-required=\"updates.record_id.type == \'serbatoioinpressione\'\"></div></form></uib-tab><uib-tab index=\"3\"><uib-tab-heading>Step 3</uib-tab-heading><div ng-if=\"updates.record_id.type != undefined && updates.contatore.model != undefined && allDataInserted()\"><p class=\"m-b\">Tutte le informazioni necessarie sono state inserite.</p><p>Premere \"Procedi\" per completare la procedura di modifica.</p><div class=\"m-t m-b\"><button type=\"button\" class=\"btn btn-default btn-rounded\" ng-click=\"update()\">Procedi</button></div></div><div ng-if=\"updates.record_id.type == undefined || updates.contatore.model == undefined || !allDataInserted()\"><p class=\"m-b\">Non è possibile concludere l\'operazione in quanto non sono state inserite tutte le informazioni necessarie.</p></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("energy/zonatermica/zonatermica_detail.html","<style type=\"text/css\">\n  .form-group{\n    margin-bottom: 5px;\n  }\n\n  .dayHeader {\n    -webkit-transform: rotate(300deg);\n    -moz-transform: rotate(300deg);\n    -o-transform: rotate(300deg);\n    text-align: center;\n  }\n\n  .label-zt {\n    font-weight:bold;\n  }\n\n  .height-zt {\n    height: 80px;\n  }\n</style><script type=\"text/ng-template\" id=\"recordInfoTemplate.html\"><strong><span class=\"ngdialog-icon\"></span></strong> <div style=\"text-align: center;\"><h4 class=\"m-t-none m-b font-bold\">INFO</h4></div> <div class=\"row m-t\"> <table align=\"center\" style=\"text-align: left;\"> <caption style=\"text-align: right; font-weight: bold\">Record</caption> <tr><td style=\"text-align: right; font-weight: bold\">Model code:</td><td style=\"padding-left: 5px\">{{record.model.code}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">UUID:</td><td style=\"padding-left: 5px\">{{record.UUID}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">version:</td><td style=\"padding-left: 5px\">{{record.version}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">creationDate:</td><td style=\"padding-left: 5px\">{{record.creationDate}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">dataIn:</td><td style=\"padding-left: 5px\">{{record.dataIn}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">dataOut:</td><td style=\"padding-left: 5px\">{{record.dataOut}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">commission:</td><td style=\"padding-left: 5px\">{{record.commission}}</td></tr> </table> <table align=\"center\" style=\"text-align: left;\"> <caption style=\"text-align: right; font-weight: bold\">Schema</caption> <tr><td style=\"text-align: right; font-weight: bold\">Model code:</td><td style=\"padding-left: 5px\">{{schema.code}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">UUID:</td><td style=\"padding-left: 5px\">{{schema.UUID}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">version:</td><td style=\"padding-left: 5px\">{{schema.version}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">creationDate:</td><td style=\"padding-left: 5px\">{{schema.creationDate}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">dataIn:</td><td style=\"padding-left: 5px\">{{schema.dataIn}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">dataOut:</td><td style=\"padding-left: 5px\">{{schema.dataOut}}</td></tr> <tr><td style=\"text-align: right; font-weight: bold\">commission:</td><td style=\"padding-left: 5px\">{{schema.commission}}</td></tr> </table> </div></script><six-toolbar ng-if=\"showDetailView\"><six-toolbar-button icon=\"fa fa-chevron-left\" toolbar-function=\"back()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"onSubmit(detailForm)\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" sx-disabled=\"isDeletePermAllowed()===false\" toolbar-function=\"deleteWithDialog(type.selected.version)\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\" xmlns=\"http://www.w3.org/1999/html\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">{{typeDescription}} <a href=\"\" ng-click=\"showRecordInfo()\" class=\"m-l\"><i class=\"fa fa-info\"></i></a></h1><small>{{type.selected.model.code}} - {{type.selected.model.description}}</small></div></div></div><div class=\"panel-body\"><div collapse=\"!isCollapsed\" class=\"form-group .margin_bottom\" ng-class=\"{\'col-md-8\': showTimeline}\"><form name=\"detailForm\" ng-submit=\"onSubmit(detailForm)\"><div ng-repeat=\"items in form[0].items\"><div ng-repeat=\"tabs in items.tabs\"><div ng-repeat=\"model_items in tabs.items\"><div ng-if=\"model_items.type !== \'array\'\" ng-init=\"iter = iter + 1\"><div class=\"form-group col-md-4 height-zt\" ng-if=\"(\'sixlookup\' !== model_items.type) && (\'temp_giorn_medie\' !== model_items.key)\"><label class=\"control-label label-zt\" ng-if=\"\'temp_giorn_medie\' !== model_items.key[0]\">{{model_items.title}}</label><div class=\"input-group\"><span class=\"input-group-addon\" id=\"sizing-addon\" ng-if=\"model_items.fieldAddonLeft\">m</span> <input class=\"form-control\" ng-disabled=\"!disableModify\" type=\"{{model_items.type}}\" step=\"any\" ng-model=\"model[model_items.key[0]]\" ng-if=\"\'temp_giorn_medie\' !== model_items.key[0]\" aria-describedby=\"sizing-addon\" ng-change=\"boolUpdate(model_items)\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" ng-click=\"disableModify=!disableModify\"><i class=\"fa fa-pencil\"></i></button></span></div><div>{{dataPrint(model_items.key[0])}}</div></div><div class=\"form-group col-md-4 height-zt\" ng-if=\"\'sixlookup\' == model_items.type && model_items.entity_id != \'comune\'\"><label class=\"control-label label-zt\">{{model_items.title}}</label><six-lookup ng-model=\"model\" sx-type=\"model_items.entity_id\" sx-field=\"model_items.key[0]\"></six-lookup></div><div class=\"form-group col-md-4 height-zt\" ng-if=\"\'sixlookup\' == model_items.type && model_items.entity_id == \'comune\'\"><label class=\"control-label label-zt\">{{model_items.title}}</label><six-lookup ng-model=\"model\" sx-type=\"model_items.entity_id\" sx-field=\"model_items.key[0]\" sx-object=\"comune\"></six-lookup></div></div></div></div></div><div class=\"form-group col-md-4 height-zt\"><label class=\"control-label label-zt\" for=\"zonaClimaticaLabel\">Zona Climatica (dal comune)</label> <input id=\"zonaClimaticaLabel\" disabled=\"\" class=\"form-control\" type=\"{{comune.model.zona_climatica_id.type}}\" ng-model=\"comune.model.zona_climatica_id.description\"></div><div class=\"form-group col-md-4 height-zt\"><label class=\"control-label label-zt\" for=\"gradVerticaleLabel\">Gradiente verticale Temp. (dalla provincia)</label> <input id=\"gradVerticaleLabel\" disabled=\"\" class=\"form-control\" type=\"{{provincia.model.gradiente_vert_temp.type}}\" ng-model=\"provincia.model.gradiente_vert_temp\"></div><uib-tabset class=\"col-md-12 hr-margin-t\"><div class=\"pull-right\"><button type=\"button\" ng-if=\"typeName == \'zonatermica\'\" class=\"btn btn-info btn-sm\" ng-click=\"calculateTempFromProv()\" ng-disabled=\"isWritePermAllowed()===false\"><i class=\"fa fa-gears\">Ricalcola</i></button></div><uib-tab><uib-tab-heading><label style=\"font-weight:bold\" class=\"control-label\">Temperature Giornaliere Medie</label></uib-tab-heading><div id=\"ddTable\"><div><form name=\"myForm\"><table style=\"width:100%;\" class=\"dd-table\"><thead><tr style=\"height: 80px; text-align: center; border-bottom: 1px solid lightblue\"><th>Mesi</th><th ng-repeat=\"d in getTimes(12) track by $index\" class=\"dayHeader\"><div>{{getMonthName($index)}}</div></th></tr></thead><tbody><tr style=\"height: 100px\"><td style=\"width: 100px;\"><table style=\"min-width: 140px; min-height: 46px;\"><td><div><div ng-if=\"editingMode == false\" style=\"text-align: right;\"><button ng-click=\"edit()\" ng-if=\"editingMode == false\" class=\"btn btn-default btn-sm\"><i class=\"fa fa-edit\"></i></button> Z. Termica [°C]:</div><div ng-if=\"editingMode == true\" style=\"text-align: right;\"><button ng-click=\"undo()\" ng-if=\"editingMode == true\" class=\"btn btn-default btn-sm\" style=\"min-width:60px\"><i class=\"fa fa-undo\"></i></button> <button ng-click=\"confirm()\" ng-if=\"editingMode == true\" class=\"btn btn-default btn-sm\" style=\"min-width:60px\"><i class=\"fa fa-check\"></i></button></div><div ng-if=\"provincia\" style=\"text-align: right;\">Provincia [°C]:</div></div></td></table></td><td ng-repeat=\"d in getTimes(12) track by $index\"><div style=\"width: 100%; text-align: center\"><input type=\"number\" step=\"any\" ng-model=\"model.temp_giorn_medie[$index].temp\" ng-disabled=\"editingMode == false\" style=\"width: 70%; text-align: center;\"></div><div ng-if=\"provincia\" class=\"control-label\" style=\"width: 100%; text-align: center\">{{mapProvTemp[$index].temp}}</div></td></tr></tbody></table></form></div></div></uib-tab></uib-tabset><div ng-repeat=\"alert in alerts\"><div class=\"alert alert-danger alert-dismissible\" role=\"alert\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button> <strong>Warning!</strong> {{alert.msg}}</div></div></form></div></div></div></div>");
$templateCache.put("energy/zonatermica/zonatermica_list.html","<style type=\"text/css\">\n  .form-group{\n    margin-bottom: 5px;\n  }\n\n  .dayHeader {\n    -webkit-transform: rotate(300deg);\n    -moz-transform: rotate(300deg);\n    -o-transform: rotate(300deg);\n    text-align: center;\n  }\n\n</style><six-toolbar ng-if=\"!showDetailView\"><six-toolbar-button label=\"Nuovo\" icon=\"fa fa-plus\" toolbar-function=\"new()\" id=\"btn_item_create\" sx-disabled=\"!isModelDefined || isWritePermAllowed()===false\"></six-toolbar-button><six-toolbar-button label=\"Check\" icon=\"fa fa-heartbeat\" toolbar-function=\"checkType()\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"refresh()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\" xmlns=\"http://www.w3.org/1999/html\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">{{typeDescription}}</h1></div></div></div><div class=\"panel-body\"><div class=\"m-t-sm\"><six-grid-pagination get-data-callback=\"getType()\" get-list-callback=\"getType()\" items-list=\"type\" column-defs=\"viewGridOptions.columnDefs\" grid-app-callbacks=\"gridAppCallbacks\" grid-options=\"viewGridOptions\" enable-state-saving=\"true\" params=\"params\"></six-grid-pagination></div><div id=\"messages\" class=\"row m-t\" ng-if=\"messages.length\"><div class=\"panel-group\" id=\"accordion\"><div class=\"panel panel-default\" id=\"panel1\"><div class=\"panel-heading\"><div class=\"panel-title\"><button ng-click=\"tryFixAllProblems()\" type=\"button\" class=\"btn btn-default btn-sm pull-right\"><span class=\"fa fa-medkit\"></span> Fix all</button> Messaggi</div></div><div class=\"panel-body\"><div class=\"col-md-12\"><div id=\"gridReport\" ui-grid=\"reportGridOptions\" class=\"grid\" style=\"height: 420px\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\" ui-grid-move-columns=\"\"></div></div></div></div></div></div></div></div></div>");
$templateCache.put("lm/inventory-report/inventory-report.html","<style>\n    .resizeFrame{\n        margin-left:25px;\n        padding-right:50px;\n        margin-top:25px;\n    }\n</style><div class=\"override-padding-toolbar\"><six-toolbar title=\"customTitle\"></six-toolbar><div class=\"row\"><div class=\"col-md-6 col-xs-12\" style=\"padding-left:35px;\"><div class=\"row\"><label class=\"col-sm-2 control-label\">Commesse</label><div class=\"col-sm-10\"><six-select-2 sx-id=\"commission\" sx-list=\"avaiableCommissions\" sx-field=\"\'obj\'\" sx-key=\"\'code\'\" sx-item-template=\"\'{{item.code}} - {{item.description}}\'\" ng-model=\"record.lookup.commission\" sx-on-select=\"onCommissionChange()\" sx-on-clear=\"onCommissionChange()\"></six-select-2></div></div><div class=\"row\" style=\"margin-top:10px;\"><label class=\"col-sm-2 control-label\">Reparto</label><div class=\"col-sm-10\"><six-lookup-2 sx-id=\"department\" sx-war=\"\'six-data-rel\'\" sx-entity=\"\'record\'\" sx-base-path=\"\'record/externaldb\'\" sx-field-mapping=\"mapping[\'department\']\" sx-type=\"\'reparti\'\" ng-model=\"record.lookup.department\" sx-field=\"\'obj\'\" sx-on-select=\"onDepartmentChange()\" sx-on-clear=\"onDepartmentChange()\"></six-lookup-2></div></div><div class=\"row\" style=\"margin-top:10px;\"><label class=\"col-sm-2 control-label\">Articoli</label><div class=\"col-sm-10\"><six-lookup-2 sx-id=\"product\" sx-war=\"\'six-data-rel\'\" sx-entity=\"\'record\'\" sx-base-path=\"\'record/externaldb\'\" sx-field-mapping=\"mapping[\'product\']\" sx-type=\"\'articoli\'\" ng-model=\"record.lookup.product\" sx-field=\"\'obj\'\" sx-on-select=\"onProductChange()\" sx-on-clear=\"onProductChange()\"></six-lookup-2></div></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"row\"><div class=\"col-sm-6 col-md-4 col-lg-3 col-xl-3\"><label class=\"control-label\">Fascia Temporale</label></div><div class=\"col-sm-6 col-md-4 col-lg-3 col-xl-3\"><select ng-model=\"selectedTime\" class=\"form-control\"><option ng-repeat=\"t in times\" value=\"{{t}}\">{{t}}</option></select></div></div><div class=\"row\" style=\"margin-top:10px;\"><div class=\"col-sm-6 col-md-4 col-lg-3 col-xl-3\"><input type=\"checkbox\" ng-model=\"negate\"> <label class=\"control-label\">Escludi destinazione</label></div><div class=\"col-sm-2\"><button ng-click=\"resetFilters()\" class=\"btn btn-info btn-sm pull-right\"><span class=\"fa fa-redo\"></span>RESET</button></div></div></div></div><div class=\"row\"><iframe id=\"kFrame\" class=\"resizeFrame\" unsafe-inline=\"\" src=\"{{ getKibanaURL() | trustAsResourceUrl }}\" width=\"100%\" height=\"1000\" frameborder=\"0\"></iframe></div></div>");
$templateCache.put("lm/report-overview/report-modal.html","<style>\n    textarea {\n        resize: none;\n    }\n</style><div class=\"panel-body\"><form name=\"reportForm\" class=\"form-validation\"><div class=\"form-group\" ng-class=\"{\'has-error\': reportForm.title.$invalid}\"><label>Inserire Titolo</label> <input type=\"text\" name=\"title\" class=\"form-control\" ng-model=\"report.title\" required=\"\"></div><div class=\"form-group\" ng-class=\"{\'has-error\': reportForm.description.$invalid}\"><label>Inserire Descrizione</label> <textarea type=\"textarea\" name=\"description\" class=\"form-control\" rows=\"4\" ng-model=\"report.description\"></textarea></div><div class=\"form-group\" ng-class=\"{\'has-error\': reportForm.url.$invalid}\"><label>Inserire url</label> <textarea type=\"textarea\" name=\"url\" class=\"form-control\" rows=\"7\" ng-model=\"report.url\" required=\"\"></textarea></div><br><div class=\"form-group\"><div><label>Tutte le commesse</label> <label class=\"i-switch bg-success m-b-n-xs m-l-xs m-r\"><input type=\"checkbox\" ng-model=\"isCommissionModeEnabled\"> <i></i></label></div><div ng-if=\"!isCommissionModeEnabled && commissions\"><six-select-2 sx-id=\"commission_list\" sx-list=\"commissionslist\" sx-title=\"\'Commessa\'\" ng-model=\"commissions\" sx-field=\"\'selected\'\" sx-placeholder=\"\'commessa...\'\" sx-multiple=\"true\" sx-item-template=\"\'{{item.description}}\'\"></six-select-2></div></div><br><button class=\"btn btn-success btn-block btn-lg\" ng-click=\"save()\" ng-disabled=\"reportForm.$invalid\">Invia</button></form></div>");
$templateCache.put("lm/report-overview/report-overview.html","<style>\n\n    .item-image-no-hover {\n        background-color: #2B4A61;\n        height: 100%;\n        min-height: 130px;\n        line-height: 130px;\n        transition: all .3s linear;\n        border-radius: 3px 0px 0px 3px;\n        cursor: default;\n    }\n    .item-image-no-hover .icon{\n          width: 70px;\n    }\n    .white-box-no-hover {\n          cursor: default !important;\n      }\n  </style><div class=\"bg-light lter b-b portal-header\"><button ng-if=\"superuser() && !widgetReportEditMode\" class=\"btn btn-secondary pull-right m-r-sm r-2x\" ng-click=\"enterEditMode()\"><i class=\"fa fa-pencil\"></i> Modifica disposizione</button> <button ng-if=\"superuser() && widgetReportEditMode\" class=\"btn btn-success pull-right m-r-sm r-2x\" ng-click=\"exitEditMode()\"><i class=\"fa fa-save\"></i> Salva disposizione</button><div ng-if=\"superuser() && widgetReportEditMode\" class=\"col-md-4 form-group pull-right m-r-sm r-2x\" ng-class=\"{\'has-error\': roleForm.$invalid, \'has-success\': roleForm.$valid}\"><six-lookup-2 sx-id=\"ruolo\" sx-base-path=\"\'record\'\" sx-type=\"\'ruolooperatore\'\" sx-title=\"\'Ruolo\'\" ng-model=\"ruolo_operatore\" sx-compact=\"true\" sx-required=\"true\" sx-on-select=\"updateRuoloFilter(item)\" sx-on-clear=\"clearRuoloFilter()\" sx-form=\"roleForm\"></six-lookup-2></div><div ng-if=\"superuser() && !widgetReportEditMode\" class=\"align-text-bottom pull-right m-r-sm r-2x\"><p style=\"margin: 7px 10px;\">Ruolo: {{ruolo_operatore.code}}</p></div><button ng-if=\"superuser()\" class=\"btn btn-success pull-right m-r-sm r-2x\" ng-click=\"createReportListItem()\"><i class=\"fa fa-plus\"></i> Nuovo</button><div class=\"page-title\">Business Intelligence e reporting</div></div><div class=\"portal-content\"><div class=\"container-fluid\"><div class=\"row\"><div ng-if=\"isWidgetVisible(widget)\" ng-repeat=\"widget in widgetList\" class=\"col-sm-4 col-xs-12\"><a ng-href=\"{{urlHandler(widget.report.url)}}\" target=\"_blank\"><div class=\"white-box clearfix\" ng-class=\"{\'white-box-no-hover\': widgetReportEditMode}\"><div class=\"item-wrapper\" ng-style=\"blurredWidgetStyle[widget.code]\"><div class=\"col-sm-4 no-margin no-padder\"><div ng-class=\"{\'item-image\': !widgetReportEditMode, \'item-image-no-hover\': widgetReportEditMode }\"><img src=\"images/portal/chart.svg\" class=\"icon\"></div></div><div class=\"col-sm-8 no-margin no-padder\"><div class=\"item\"><h3 class=\"title\">{{widget.report.title}}</h3><p>{{widget.report.description}}</p></div></div></div></div></a> <button class=\"btn-light\" ng-if=\"widgetReportEditMode\" style=\"position: absolute; top:0px; right: 14px;\" ng-click=\"hideWidget(widget.code)\"><i class=\"fa\" ng-class=\"{\'fa-eye-slash\': isHidden(widget.code), \'fa-eye\': !isHidden(widget.code)}\"></i></button> <button class=\"btn-danger\" ng-if=\"widgetReportEditMode\" style=\"position: absolute; bottom:20px; right: 14px;\" ng-click=\"removeWidget(widget.code)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div>");
$templateCache.put("plan/activity/activity_detail.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"saveForm()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" toolbar-function=\"delete(activity.version)\" sx-disabled=\"!activity.version || !isDeletePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar center-page\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\" ng-hide=\"activity.version\"><h1 class=\"m-n font-thin h3 text-black\">Nuova Attività</h1></div><div class=\"col-sm-6 col-xs-12\" ng-show=\"activity.version\"><h1 class=\"m-n font-thin h3 text-black\">Attività</h1></div></div></div><div class=\"wrapper\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12 col-sm-12\"><label for=\"code\" class=\"control-label\">Codice</label><div class=\"input-group\" style=\"width:100%\"><input name=\"code\" type=\"text\" ng-model=\"activity.model.code\" class=\"form-control\" required=\"\"></div></div></div><div class=\"row\"><div class=\"col-md-12 col-sm-12 m-t\"><label for=\"description\" class=\"control-label\">Descrizione</label><div class=\"input-group\" style=\"width:100%\"><input name=\"description\" type=\"text\" ng-model=\"description\" ng-keyup=\"refreshDescription(description)\" required=\"\" class=\"form-control\"></div></div></div></div></div></div></div>");
$templateCache.put("plan/activity/activity_list.html","<six-toolbar><six-toolbar-button icon=\"fa fa-plus\" label=\"Nuova attività\" btn-class=\"btn-info\" toolbar-function=\"goToNewActivity()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista Attività</h1></div></div></div><div class=\"panel-body\"><six-grid-pagination get-data-callback=\"getActivitiesList()\" get-list-callback=\"getActivitiesList()\" items-list=\"activitiesList\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div></div>");
$templateCache.put("plan/components/ict_issue.html","<six-toolbar ng-if=\"$ctrl.config.fullPage\"><six-toolbar-item label=\"Segnalazione n. {{$ctrl.data.model.code}} - {{$ctrl.issueWorkflow.getReadableStatus($ctrl.data.status)}}\" ng-show=\"$ctrl.data.version\"></six-toolbar-item><six-toolbar-item label=\"Nuova segnalazione\" ng-show=\"!$ctrl.data.version\"></six-toolbar-item><six-toolbar-button label=\"Lista\" icon=\"fa fa-chevron-left\" toolbar-function=\"$ctrl.back()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"$ctrl.validate()\" sx-disabled=\"!$ctrl.schemaIssueDefined || !$ctrl.isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Salva e genera ODL\" btn-class=\"btn-success\" icon=\"fa fa-save\" ng-if=\"$ctrl.config.mode != \'portal\' || $ctrl.data.version\" toolbar-function=\"$ctrl.validate(true)\" sx-disabled=\"!$ctrl.schemaIssueDefined || (!$ctrl.isWritePermAllowed() && !$ctrl.isOdlWritePermAllowed())\"></six-toolbar-button><six-toolbar-button label=\"Genera ODL\" btn-class=\"btn-btn-default\" icon=\"fa fa-code-fork\" toolbar-function=\"$ctrl.generate_odl($ctrl.data.UUID)\" sx-disabled=\"!$ctrl.schemaIssueDefined || ($ctrl.show_generate_odl($ctrl.data.status) && !$ctrl.isWritePermAllowed() && !$ctrl.isOdlWritePermAllowed())\" ng-if=\"$ctrl.data.UUID\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\" ng-if=\"$ctrl.config.fullPage\"><div class=\"panel panel-default constructor\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"!$ctrl.data.version\">Nuova segnalazione</h1><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"$ctrl.data.version\">Segnalazione n. <span class=\"m-l-xs\">{{$ctrl.data.model.code}}</span></h1></div><div class=\"col-sm-6 col-xs-12\"><issue-tab class=\"pull-right\" sx-object=\"$ctrl.data\" sx-base-path=\"\'issue\'\" sx-status=\"$ctrl.data.status\" sx-uuid=\"$ctrl.data.UUID\" sx-show-buttons=\"isWritePermAllowed()\"></issue-tab></div></div></div><div class=\"panel-body\"><ng-include src=\"\'plan/components/ict_issue_tabset.html\'\"></ng-include></div></div></div><ng-include src=\"\'plan/components/ict_issue_tabset.html\'\" ng-if=\"(!$ctrl.config.fullPage)\"></ng-include>");
$templateCache.put("plan/components/ict_issue_data.html","<div ng-if=\"$ctrl.schemaIssueDefined\"><div class=\"row m-b\" ng-if=\"$ctrl.config.mode == \'extended\'\"><div class=\"col-md-12\"><div class=\"list-group-item clearfix b-l-3x b-l-primary\"><div class=\"col-md-3 form-group\"><label class=\"control-label\">Data inserimento</label><six-date-time-picker name=\"date_insertion\" date-options=\"$ctrl.dateOptions\" ng-model=\"$ctrl.data.date_insertion\"></six-date-time-picker></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Data richiesta</label><six-date-time-picker name=\"date_requested\" date-options=\"$ctrl.dateOptions\" ng-model=\"$ctrl.data.date_requested\"></six-date-time-picker></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Data di presa in carico</label><six-date-time-picker name=\"date_handling\" date-options=\"$ctrl.dateOptions\" ng-model=\"$ctrl.data.date_handling\"></six-date-time-picker></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Data chiusura</label><six-date-time-picker name=\"date_closing\" date-options=\"$ctrl.dateOptions\" ng-model=\"$ctrl.data.date_closing\"></six-date-time-picker></div></div></div></div><div class=\"row m-b\"><div class=\"col-md-12\"><div class=\"list-group-item clearfix b-l-3x b-l-info\"><div class=\"col-md-3 form-group\"><label class=\"control-label\">Tipo Asset</label><six-lookup-2 sx-id=\"issue-schema\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" sx-title=\"\'Tipo asset\'\" ng-model=\"$ctrl.data.model\" sx-filter=\"$ctrl.typeIdFilter\" sx-compact=\"true\" sx-item-template=\"\'{{item.description}}\'\" sx-field=\"\'type_id\'\" sx-auto-init=\"$ctrl.isNew\" sx-show-details=\"false\" sx-show-filters=\"false\" sx-page-size=\"10000\"></six-lookup-2></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Asset</label><six-lookup-2 sx-id=\"issue-asset\" sx-base-path=\"\'record\'\" sx-title=\"\'Asset\'\" ng-model=\"$ctrl.data.model\" sx-type=\"$ctrl.data.model.type_id.UUID\" sx-field=\"\'record_id\'\" sx-auto-init=\"$ctrl.isNew\" sx-dimension=\"\'xxl\'\" sx-show-list=\"false\" sx-show-tree=\"true\" sx-show-details=\"true\" sx-show-filters=\"false\" sx-filter=\"$ctrl.assetFilter\"></six-lookup-2></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Servizio</label><six-lookup-2 sx-id=\"service\" ng-model=\"$ctrl.data.model\" sx-type=\"\'servizio\'\" sx-base-path=\"\'record\'\" sx-field=\"\'service_id\'\" sx-auto-init=\"$ctrl.isNew\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Richiedente</label><six-lookup-2 sx-id=\"issue-richiedente\" ng-model=\"$ctrl.data\" sx-field=\"\'reporter_id\'\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-title=\"\'Richiedente\'\" sx-add=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div></div></div></div><div class=\"row m-b\" ng-if=\"$ctrl.config.mode == \'basic\' && $ctrl.config.showAssignee\"><div class=\"col-md-12\"><div class=\"list-group-item clearfix b-l-3x b-l-primary\"><div class=\"{{$ctrl.assigneeColumnWidth}} form-group\" ng-if=\"$ctrl.config.showAssignee == true || $ctrl.config.showAssignee.indexOf(\'date_insertion\') != -1\"><label class=\"control-label\">Data inserimento</label><six-date-time-picker name=\"date_insertion\" date-options=\"$ctrl.dateOptions\" ng-model=\"$ctrl.data.date_insertion\" sx-disabled=\"true\"></six-date-time-picker></div><div class=\"{{$ctrl.assigneeColumnWidth}} form-group\" ng-if=\"$ctrl.config.showAssignee == true || $ctrl.config.showAssignee.indexOf(\'supervisorExternal_id\') != -1\"><label class=\"control-label\">Responsabile esterno</label><six-lookup-2 sx-id=\"supervisorExternal_id\" ng-model=\"$ctrl.data.references_assignee\" sx-field=\"\'supervisorExternal_id\'\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-title=\"\'Responsabile esterno\'\" sx-add=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-filter=\"$ctrl.supervisorExternalFilter\"></six-lookup-2></div><div class=\"{{$ctrl.assigneeColumnWidth}} form-group\" ng-if=\"$ctrl.config.showAssignee == true || $ctrl.config.showAssignee.indexOf(\'secretariat_id\') != -1\"><label class=\"control-label\">Segreteria</label><six-lookup-2 sx-id=\"secretariat_id\" ng-model=\"$ctrl.data.references_assignee\" sx-type=\"\'segreteria\'\" sx-base-path=\"\'record\'\" sx-field=\"\'secretariat_id\'\" sx-show-details=\"true\" sx-filter=\"$ctrl.secretariatFilter\"></six-lookup-2></div><div class=\"{{$ctrl.assigneeColumnWidth}} form-group\" ng-if=\"$ctrl.config.showAssignee == true || $ctrl.config.showAssignee.indexOf(\'activityReferer_id\') != -1\"><label class=\"control-label\">Referente Attività</label><six-lookup-2 sx-id=\"activityReferer_id\" ng-model=\"$ctrl.data.references_assignee\" sx-field=\"\'activityReferer_id\'\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-title=\"\'Referente Attività\'\" sx-add=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-filter=\"$ctrl.activityRefererFilter\"></six-lookup-2></div></div></div></div><div class=\"row\"><div class=\"col-md-12 m-b\" ng-if=\"$ctrl.config.showWatchers\"><div class=\"panel panel-default pnl-no-margin-t-b\" id=\"panel1\"><a data-toggle=\"collapse\" data-target=\"#ictIssueDataWatchers\" ng-click=\"watchers = !watchers\"><div class=\"panel-heading\"><h5 class=\"override-margin-top-bottom\"><i class=\"pull-right fa ng-scope fa-angle-right\" ng-class=\"{\'fa-angle-down\': watchers, \'fa-angle-right\': !watchers}\"></i>Watchers</h5></div></a><div id=\"ictIssueDataWatchers\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"col-md-12 no-pad-l-r\"><div class=\"col-md-1 no-pad-l-r\"><h5>Aggiungi:</h5></div><form name=\"validationForm\"><div class=\"col-md-11\"><div class=\"col-md-1\"><input type=\"radio\" id=\"bool_watch_internal\" ng-checked=\"$ctrl.bool_watch_internal\" ng-click=\"$ctrl.setBoolWatchInternal()\"><label for=\"bool_watch_internal\" class=\"control-label\">Interno</label></div><div class=\"col-md-1\"><input type=\"radio\" id=\"bool_watch_external\" ng-checked=\"$ctrl.bool_watch_external\" ng-click=\"$ctrl.setBoolWatchExternal()\"><label for=\"bool_watch_external\" class=\"control-label\">Esterno</label></div></div><div class=\"row col-md-12 no-pad-l-r\"><div class=\"col-md-4 form-group\" ng-if=\"$ctrl.bool_watch_internal == true\"><six-lookup-2 ng-model=\"$ctrl.watcher\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'user\'\"><a class=\"btn btn-success\" ng-click=\"$ctrl.addWatcher()\"><span class=\"fa fa-plus\"></span></a></six-lookup-2></div><div class=\"col-md-4 form-group\" ng-if=\"$ctrl.bool_watch_external == true\"><span class=\"input-group has-button\"><input type=\"email\" name=\"inputMail\" class=\"form-control\" ng-model=\"$ctrl.watcher.mail\"> <span class=\"input-group-btn\"><a class=\"btn btn-success\" ng-click=\"$ctrl.addWatcher()\"><span class=\"fa fa-plus\"></span></a></span></span><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"$ctrl.validationForm.inputMail.$error.email\">Email non valida</span></div></div></div></form><div class=\"row col-md-12 no-pad-l-r\"><div class=\"col-md-6\" ng-if=\"$ctrl.data.watchers.internal.length != 0\"><label class=\"control-label\">Watcher interni:</label></div><div class=\"col-md-6\" ng-if=\"$ctrl.data.watchers.external.length != 0\"><label class=\"control-label\">Watcher esterni:</label></div></div><div class=\"row col-md-12 no-pad-l-r\"><div class=\"col-md-6\" ng-if=\"$ctrl.data.watchers.internal.length != 0\"><div class=\"col-md-12 no-pad-l-r margin-col-l\" ng-repeat=\"w in $ctrl.data.watchers.internal track by $index\"><span class=\"input-group has-button\"><six-lookup-2 ng-model=\"w\" sx-type=\"w.type\" sx-base-path=\"\'record\'\" sx-disabled=\"true\" sx-closable=\"false\"></six-lookup-2><span class=\"input-group-btn\"><a class=\"btn btn-danger\" ng-click=\"$ctrl.deleteWatcher($ctrl.data.watchers.internal, w)\"><span class=\"fa fa-trash-o\"></span></a></span></span></div></div><div class=\"col-md-6\" ng-if=\"$ctrl.data.watchers.external.length != 0\"><div class=\"col-md-12 no-pad-l-r margin-col-l\" ng-repeat=\"w in $ctrl.data.watchers.external\"><span class=\"input-group has-button\"><input type=\"email\" class=\"form-control\" ng-model=\"w\" disabled=\"\"> <span class=\"input-group-btn\"><a class=\"btn btn-danger\" ng-click=\"$ctrl.deleteWatcher($ctrl.data.watchers.external, w)\"><span class=\"fa fa-trash-o\"></span></a></span></span></div></div></div></div></div></div></div></div><div class=\"col-md-12 m-b\" ng-if=\"$ctrl.config.mode==\'extended\' && $ctrl.config.showAssignee\"><div class=\"panel panel-default pnl-no-margin-t-b\" id=\"panel2\"><a data-toggle=\"collapse\" data-target=\"#ictIssueDataAssignee\" ng-click=\"assignee = !assignee\"><div class=\"panel-heading\"><h5 class=\"override-margin-top-bottom\"><i class=\"pull-right fa ng-scope fa-angle-down\" ng-class=\"{\'fa-angle-down\': !assignee, \'fa-angle-right\': assignee}\"></i> Tecnici - Assegnatari</h5></div></a><div id=\"ictIssueDataAssignee\" class=\"panel-collapse collapse in\"><div class=\"panel-body\"><div class=\"col-md-12 no-pad-l-r\"><div class=\"col-md-4 form-group\"><label class=\"control-label\">Responsabile esterno</label><div class=\"col-md-11 no-pad-l-r\"><six-lookup-2 sx-id=\"supervisorExternal_id\" ng-model=\"$ctrl.data.references_assignee\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'supervisorExternal_id\'\" sx-add=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-filter=\"$ctrl.supervisorExternalFilter\"><button class=\"btn btn-default\" ng-click=\"$ctrl.addWatcherFromLookUp($ctrl.data.references_assignee.supervisorExternal_id)\"><i class=\"fa fa-envelope-o\"></i></button></six-lookup-2></div></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Segreteria</label><div class=\"col-md-11 no-pad-l-r\"><six-lookup-2 sx-id=\"secretariat_id\" ng-model=\"$ctrl.data.references_assignee\" sx-type=\"\'segreteria\'\" sx-base-path=\"\'record\'\" sx-field=\"\'secretariat_id\'\" sx-show-details=\"true\" sx-filter=\"$ctrl.secretariatFilter\"><button class=\"btn btn-default\" ng-click=\"$ctrl.addWatcherFromLookUp($ctrl.data.references_assignee.secretariat_id)\"><i class=\"fa fa-envelope-o\"></i></button></six-lookup-2></div></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Referente Attività</label><div class=\"col-md-11 no-pad-l-r\"><six-lookup-2 sx-id=\"activityReferer_id\" ng-model=\"$ctrl.data.references_assignee\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'activityReferer_id\'\" sx-add=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-filter=\"$ctrl.activityRefererFilter\"><button class=\"btn btn-default\" ng-click=\"$ctrl.addWatcherFromLookUp($ctrl.data.references_assignee.activityReferer_id)\"><i class=\"fa fa-envelope-o\"></i></button></six-lookup-2></div></div></div></div></div></div></div><div class=\"col-md-12 m-b\" ng-if=\"$ctrl.responsableList.length > 0\"><div class=\"panel panel-default pnl-no-margin-t-b\" id=\"panel3\"><a data-toggle=\"collapse\" data-target=\"#collapseThree\" ng-click=\"responsable = !responsable\"><div class=\"panel-heading\"><h5 class=\"override-margin-top-bottom\"><i class=\"pull-right fa ng-scope fa-angle-right\" ng-class=\"{\'fa-angle-down\': responsable, \'fa-angle-right\': !responsable}\"></i> Contatti responsabili</h5></div></a><div id=\"collapseThree\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"col-md-12 no-pad-l-r\"><div class=\"row col-md-12 no-pad-l-r\" ng-repeat=\"r in $ctrl.responsableList\"><div class=\"col-md-12\"><div class=\"col-md-4 form-group\"><input type=\"text\" class=\"form-control\" ng-model=\"r.name\" disabled=\"\"></div><div class=\"col-md-4 form-group\"><input type=\"text\" class=\"form-control\" ng-model=\"r.contacts\" disabled=\"\"></div></div></div></div></div></div></div></div><div class=\"form-group s-f-height\" ng-if=\"$ctrl.data.UUID\" ng-class=\"{ \'col-md-10\': $ctrl.config.mode==\'extended\', \'col-md-12\': $ctrl.config.mode==\'basic\' }\"><label class=\"margin-col-l\">Codice</label> <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.data.model.code\" disabled=\"\"></div><div class=\"col-md-2 form-group s-f-height\" ng-if=\"$ctrl.data.UUID && $ctrl.config.mode==\'extended\'\"><label class=\"margin-col-l\">Utente inserimento</label> <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.data.user\" disabled=\"\"></div><div class=\"col-md-12\"><form name=\"detailForm\"><div class=\"row wrapper\"><div class=\"override-checkbox\" ng-class=\"{\'override-form-group\': ($ctrl.config.mode==\'extended\')}\" sf-schema=\"$ctrl.schema\" sf-form=\"$ctrl.form\" sf-model=\"$ctrl.data.model\"></div></div></form></div></div></div><div ng-if=\"!($ctrl.schemaIssueDefined)\"><div class=\"wrapper\"><div class=\"row\"><label class=\"control-label\">Schema non definito</label></div></div></div>");
$templateCache.put("plan/components/ict_issue_tabset.html","<div class=\"pull-left m-t-sm\" ng-if=\"$ctrl.data.status\">Stato Segnalazione: <span class=\"well well-sm\" style=\"pointer-events: none; margin-left: 10px; padding: 0.5em 1em;\">{{$ctrl.issueWorkflow.getReadableStatus($ctrl.data.status)}}</span></div><uib-tabset class=\"tabs-right\"><uib-tab ng-if=\"$ctrl.getTab(\'ictIssue\').active\"><uib-tab-heading><span class=\"fa fa-list-alt text-info-dker\"></span> Dati</uib-tab-heading><ict-issue-data data=\"$ctrl.data\" is-new-issue=\"$ctrl.isNew\" schema=\"$ctrl.schema\" form=\"$ctrl.form\" config=\"$ctrl.getTab(\'ictIssue\').config\"></ict-issue-data></uib-tab><uib-tab ng-if=\"$ctrl.getTab(\'ictTimeline\').active\" disable=\"!$ctrl.data.UUID\"><uib-tab-heading><span class=\"fa fa-history text-info-dker\"></span> Storico stati</uib-tab-heading><ict-issue-timeline datauuid=\"$ctrl.data.UUID\" schemauuid=\"$ctrl.schemaUUID\" dataversion=\"$ctrl.data.version\" config=\"$ctrl.getTab(\'ictTimeline\').config\"></ict-issue-timeline></uib-tab><uib-tab ng-if=\"$ctrl.getTab(\'ictAttachments\').active\" disable=\"!$ctrl.data.version\"><uib-tab-heading><span class=\"fa fa-book text-info-dker\"></span> Allegati</uib-tab-heading><six-tree-attachments nodes=\"$ctrl.attachments\" save-callback=\"$ctrl.updAttachments()\" sx-tag-filter=\"\'class=issue\'\"></six-tree-attachments></uib-tab><uib-tab ng-if=\"$ctrl.getTab(\'ictMessage\').active\" disable=\"!$ctrl.data.version\" select=\"$ctrl.getMessage()\"><uib-tab-heading><span class=\"fa fa-envelope text-info-dker\"></span> Messaggio</uib-tab-heading><div class=\"col-md-12\" ng-if=\"$ctrl.loadingSixMail == true\"><uib-progressbar class=\"progress-striped active\" type=\"info\"><i>Caricamento messaggio</i></uib-progressbar></div><six-send-email ng-if=\"$ctrl.loadingSixMail == false\" sx-title-mail=\"$ctrl.objMail.title\" sx-body-mail=\"$ctrl.objMail.message\" sx-to-mail=\"$ctrl.objMail.to\" sx-cc-mail=\"$ctrl.objMail.cc\" sx-type-mail=\"\'issue\'\" sx-record-id=\"$ctrl.currentIssueRef\"></six-send-email></uib-tab><uib-tab ng-if=\"$ctrl.getTab(\'ictQrcode\').active\" disable=\"!$ctrl.data.version\"><uib-tab-heading><span class=\"fa fa-qrcode text-info-dker\"></span> QRCODE</uib-tab-heading><qrcode version=\"5\" error-correction-level=\"H\" size=\"274\" data=\"{{$ctrl.data.UUID}}\"></qrcode></uib-tab><uib-tab ng-if=\"$ctrl.getTab(\'ictNotification\').active\" disable=\"!$ctrl.data.version\" select=\"notificationUuid = $ctrl.data.UUID\" deselect=\"notificationUuid = undefined\"><uib-tab-heading><span class=\"icon-bell text-info-dker\"></span> Notifiche</uib-tab-heading><ict-notifications ict-type=\"\'issue\'\" ict-uuid=\"notificationUuid\" ict-detail-view=\"sidebar\"></ict-notifications></uib-tab><uib-tab ng-if=\"$ctrl.getTab(\'ictOdl\').active\" disable=\"!$ctrl.data.version\"><uib-tab-heading><span class=\"fa fa-tasks text-info-dker\"></span> ODL</uib-tab-heading><div><div ng-if=\"$ctrl.odlList.length==0\" class=\"alert alert-info\">Non ci sono ODL associati a questa segnalazione</div><div ng-if=\"$ctrl.odlList.length>0\"><div class=\"row wrapper\"><table class=\"table table-striped\"><thead><th></th><th>Asset</th><th>Titolo</th><th>Stato</th><th>Utente generazione</th><th>Data generazione</th><th>Data pianifica</th></thead><tbody><tr ng-repeat=\"item in $ctrl.odlList\"><td><a ng-href=\"#/odl/{{item.UUID}}\" class=\"btn btn-xs btn-primary\"><span class=\"fa fa-search\"></span></a></td><td>{{item.model.asset_description}}</td><td>{{item.model.title}}</td><td>{{item.status}}</td><td>{{item.model.user_input_name}} {{item.model.user_input_surname}}</td><td>{{item.dataIn |date }}</td><td>{{item.date_requested | date}}</td></tr></tbody></table></div></div></div></uib-tab></uib-tabset>");
$templateCache.put("plan/components/ict_issue_timeline.html","<div class=\"col-md-12\"><div class=\"hbox hbox-auto-xs hbox-auto-sm ng-scope\"><div class=\"col col-md-4\"><div class=\"wrapper\"><ul class=\"timeline\"><li class=\"tl-header\"><div class=\"btn btn-sm btn-default btn-rounded\">INIZIO</div></li><li ng-repeat=\"item in $ctrl.timeline\" class=\"tl-item\" ng-class-odd=\"\'tl-left\'\"><div class=\"tl-wrap\" ng-class=\"{\'b-success\': ($ctrl.modelDataInTimeline.version == item.version)}\"><span class=\"tl-date\">{{item.dataIn | date : format : timezone}}</span><div class=\"tl-content panel padder b-a\" ng-class=\"{\'bg-success\': ($ctrl.modelDataInTimeline.version == item.version)}\"><span class=\"arrow left pull-up hidden-left\" ng-class=\"{\'arrow-success\': ($ctrl.modelDataInTimeline.version == item.version)}\"></span> <span class=\"arrow right pull-up visible-left\" ng-class=\"{\'arrow-success\': ($ctrl.modelDataInTimeline.version == item.version)}\"></span><div class=\"text-lt m-b-sm\"><a ng-click=\"$ctrl.getModelDetail(item.version)\">{{item.model.code}}</a></div><div class=\"panel-body pull-in b-t b-light\"><span class=\"pull-right label\" ng-class=\"{\'bg-success\': ($ctrl.modelDataInTimeline.version == item.version), \'bg-info\': ($ctrl.modelDataInTimeline.version != item.version)}\">{{item.user}}</span></div><div class=\"panel-body pull-in b-t b-light\">Stato: {{item.status}}</div><div class=\"panel-body pull-in b-t b-light\">Note: {{item.status_note}}</div></div></div></li><li class=\"tl-header\"><div class=\"btn btn-sm btn-default btn-rounded\">FINE</div></li></ul></div></div><div class=\"col wrapper bg-white\" ng-if=\"$ctrl.showDetail\"><div class=\"col-md-12 no-pad-l-r\"><div class=\"row wrapper\"><div class=\"col-md-12\"><label class=\"control-label\">Stato</label><div class=\"col-md-12 no-pad-l-r\"><span disabled=\"true\" class=\"form-control\">{{$ctrl.currentDataInTimeline.status}}</span></div></div><div class=\"col-md-12\"><label class=\"control-label\">Note cambio di stato</label><div class=\"col-md-12 no-pad-l-r\"><textarea rows=\"4\" class=\"col-md-12\">{{$ctrl.currentDataInTimeline.status_note}}</textarea></div></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Tipo Asset</label><six-lookup-2 sx-id=\"issue-schema\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" sx-title=\"\'Tipo asset\'\" ng-model=\"$ctrl.currentDataInTimeline.model\" sx-field=\"\'type_id\'\"></six-lookup-2></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Asset</label><six-lookup-2 sx-id=\"issue-asset\" sx-base-path=\"\'record\'\" sx-title=\"\'Asset\'\" ng-model=\"$ctrl.data.model\" sx-type=\"$ctrl.currentDataInTimeline.model.type_id.UUID\" sx-field=\"\'record_id\'\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Richiedente</label><div class=\"col-md-12 no-pad-l-r\"><six-lookup-2 sx-id=\"issue-richiedente\" ng-model=\"$ctrl.currentDataInTimeline\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'reporter_id\'\" sx-add=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Data inserimento</label><div class=\"col-md-12 no-pad-l-r\"><input type=\"datetime-local\" class=\"form-control\" ng-model=\"$ctrl.currentDataInTimeline.date_insertion\"></div></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Data richiesta</label><div class=\"col-md-12 no-pad-l-r\"><input type=\"datetime-local\" class=\"form-control\" ng-model=\"$ctrl.currentDataInTimeline.date_requested\"></div></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Data di presa in carico</label><div class=\"col-md-12 no-pad-l-r\"><input type=\"datetime-local\" class=\"form-control\" ng-model=\"$ctrl.currentDataInTimeline.date_handling\"></div></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Data chiusura</label><div class=\"col-md-12 no-pad-l-r\"><input type=\"datetime-local\" class=\"form-control\" ng-model=\"$ctrl.currentDataInTimeline.date_closing\"></div></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Responsabile esterno</label><div class=\"col-md-12 no-pad-l-r\"><six-lookup-2 sx-id=\"timeline-supervisorExternal_id\" ng-model=\"$ctrl.currentDataInTimeline.references_assignee\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'supervisorExternal_id\'\" sx-add=\"true\" sx-filter=\"supervisorExternalFilter\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Segreteria</label><div class=\"col-md-12 no-pad-l-r\"><six-lookup-2 sx-id=\"timeline-secretariat_id\" ng-model=\"$ctrl.currentDataInTimeline.references_assignee\" sx-type=\"\'segreteria\'\" sx-base-path=\"\'record\'\" sx-field=\"\'secretariat_id\'\"></six-lookup-2></div></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Referente Attività</label><div class=\"col-md-12 no-pad-l-r\"><six-lookup-2 sx-id=\"timeline-activityReferer_id\" ng-model=\"$ctrl.currentDataInTimeline.references_assignee\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'activityReferer_id\'\" sx-add=\"true\" sx-filter=\"activityRefererFilter\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div></div></div><div class=\"col-md-12\"><div sf-schema=\"$ctrl.schemaDataInTimeline\" sf-form=\"$ctrl.formDataInTimeline\" sf-model=\"$ctrl.currentDataInTimeline.model\"></div></div></div></div></div></div>");
$templateCache.put("plan/components/ict_notifications.html","<div ng-if=\"$ctrl.notifications.length==0\" class=\"alert alert-info\" role=\"alert\">Nessuna notifica</div><ul class=\"list-group list-group-lg no-radius m-b-none m-t-n-xxs\"><li ng-repeat=\"notification in $ctrl.notifications\" class=\"list-group-item clearfix b-l-3x ng-scope\" ng-class=\"notification.color\"><span class=\"avatar thumb pull-left m-r\"><img ng-hide=\"notification.user\" src=\"images/avatar_system.png\"> <img ng-show=\"notification.user\" src=\"images/avatar_emil.png\"></span><div class=\"pull-right text-sm text-muted\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"{{notification.model.mailId > 0? \'Mail Consegnata\' : \'Mail Non Consegnata\' }}\"><span class=\"hidden-xs ng-binding\">{{notification.dataIn | date:\"dd/MM/yyyy\"}}</span><six-consip-timing-led sx-value=\"$ctrl.getStoplightValue(notification.model.mailId)\"></six-consip-timing-led></div><div class=\"clear\"><div><a class=\"text-md ng-binding\" ng-click=\"$ctrl.openDetail(notification)\"><span ng-show=\"notification.model.subject\">Oggetto: {{notification.model.subject}}</span> <span ng-show=\"notification.user\">da {{notification.user}}</span> <span ng-show=\"notification.model.to\">a {{notification.model.to}}</span></a></div><div class=\"text-ellipsis m-t-xs ng-binding\">{{notification.model.bodyAsText}}</div></div></li></ul><six-sidebar ng-if=\"$ctrl.ictDetailView == \'sidebar\'\" sx-id=\"notificationDetailView\" sx-position=\"right\" sx-title=\"\'Dettaglio\'\" sx-dimension=\"50\" six-sidebar-autoclose=\"true\" sx-opened=\"$ctrl.notificationPanelOpen\" sx-pinnable=\"false\"><div class=\"wrapper b-b\"><h2 class=\"font-thin m-n ng-binding\">{{$ctrl.selectedNotification.model.subject}}</h2></div><div class=\"wrapper b-b ng-binding\"><img ng-hide=\"$ctrl.selectedNotification.user\" class=\"img-circle thumb-xs m-r-sm\" ng-src=\"/images/avatar_system.png\"> <img ng-show=\"$ctrl.selectedNotification.user\" class=\"img-circle thumb-xs m-r-sm\" ng-src=\"/images/avatar_emil.png\"> Segnalazione inviata da <strong ng-hide=\"$ctrl.selectedNotification.user\">System</strong><strong>{{$ctrl.selectedNotification.user}}</strong> relativa a <strong ng-show=\"!$ctrl.selectedNotification.model.type_notification\">/</strong> <strong ng-show=\"$ctrl.selectedNotification.model.type_notification\">{{$ctrl.selectedNotification.model.type_notification}}</strong> e con destinatari: <strong ng-show=\"!$ctrl.selectedNotification.model.to\">/</strong> <strong ng-show=\"$ctrl.selectedNotification.model.to\">{{$ctrl.selectedNotification.model.to}}</strong> del {{$ctrl.selectedNotification.dataIn | date:\"dd/MM/yyyy\"}}</div><div class=\"wrapper ng-binding\" ng-bind-html=\"$ctrl.selectedNotification.model.body\"></div></six-sidebar>");
$templateCache.put("plan/components/ict_odl_consumptive.html","<style type=\"text/css\">\n  .cont-center{\n    text-align: center;\n  }\n  .cont-right{\n    text-align: right;\n  }\n  .cont-left{\n    text-align: left;\n  }\n</style><div class=\"content\"><div class=\"row m-b\"><div class=\"toolbar-add-consumptive m-r pull-right\"><six-lookup-2 style=\"display: inline-block; vertical-align: middle; width: 250px;\" ng-if=\"$ctrl.opAllowed(\'linkConsumptive\')\" sx-placeholder=\"\'Seleziona un consuntivo\'\" sx-id=\"link-consumptive\" sx-base-path=\"\'./\'\" sx-type=\"\'consumptiveodl\'\" sx-title=\"\'Consuntivo\'\" ng-model=\"$ctrl.consumptiveToLink\" sx-war=\"\'six-plan\'\" sx-show-details=\"false\" sx-show-filters=\"false\" sx-filter=\"$ctrl.linkConsumptiveFilter\"></six-lookup-2><a class=\"btn btn-primary m-r\" title=\"Seleziona un consuntivo\" ng-disabled=\"!$ctrl.consumptiveToLink\" ng-click=\"!$ctrl.consumptiveToLink || $ctrl.linkConsumptive()\" ng-if=\"$ctrl.opAllowed(\'linkConsumptive\')\"><i class=\"fa fa-link\"></i> Collega consuntivo</a> <a class=\"btn btn-success\" ng-click=\"$ctrl.gotoNewConsumptive()\" ng-if=\"$ctrl.opAllowed(\'gotoNewConsumptive\')\"><i class=\"fa fa-plus\"></i> Crea nuovo consuntivo</a></div></div><div class=\"well\" ng-show=\"!$ctrl.consumptiveList.totalResults\">Nessun consuntivo presente.</div><six-grid-pagination ng-show=\"$ctrl.consumptiveList.totalResults\" sx-id=\"consumptive\" get-data-callback=\"$ctrl.getConsumptiveList()\" get-list-callback=\"$ctrl.getConsumptiveList()\" items-list=\"$ctrl.consumptiveList\" grid-options=\"$ctrl.viewGridOptions\" column-defs=\"$ctrl.viewGridOptions.columnDefs\" params=\"$ctrl.params\" auto-resize-params=\"$ctrl.autoResizeParams\" show-global-search=\"false\" grid-app-callbacks=\"$ctrl.gridAppCallbacks\"></six-grid-pagination><div class=\"row m-t\"><div class=\"col-xs-12 text-right\"><a class=\"btn btn-success m-r\" title=\"Seleziona un unico consuntivo\" ng-disabled=\"$ctrl.opDisabled(\'acceptConsumptive\')\" ng-click=\"$ctrl.opDisabled(\'acceptConsumptive\') || $ctrl.acceptConsumptive()\" ng-if=\"$ctrl.opAllowed(\'acceptConsumptive\')\"><i class=\"fa fa-check\"></i> Accetta consuntivo</a> <a class=\"btn btn-danger m-r\" title=\"Rifiuta tutti i consuntivi\" ng-disabled=\"$ctrl.opDisabled(\'denyConsumptives\')\" ng-click=\"$ctrl.opDisabled(\'denyConsumptives\') || $ctrl.denyConsumptives()\" ng-if=\"$ctrl.opAllowed(\'denyConsumptives\')\"><i class=\"fa fa-close\"></i> Rifiuta consuntivi</a></div></div></div><six-sidebar sx-id=\"attachmentsPanel\" sx-position=\"left\" sx-title=\"$ctrl.panelConfig.title\" sx-dimension=\"l\" six-sidebar-autoclose=\"true\" sx-opened=\"$ctrl.attachmentsPanelOpen\" sx-pinnable=\"false\"><six-tree-attachments nodes=\"$ctrl.panelConfig.item.model.attachments\" sx-readonly=\"true\" sx-downloadable=\"true\" sx-expanded=\"true\" sx-tag-filter=\"\'class=consumptive\'\"></six-tree-attachments></six-sidebar>");
$templateCache.put("plan/components/ict_odl_estimate.html","<style type=\"text/css\">\n  .cont-center{\n    text-align: center;\n  }\n  .cont-right{\n    text-align: right;\n  }\n  .cont-left{\n    text-align: left;\n  }\n</style><div class=\"content\"><div class=\"row m-b\"><div class=\"col-xs-4\"><a class=\"btn btn-primary pull-left\" ng-click=\"$ctrl.startPreService()\" ng-if=\"$ctrl.opAllowed(\'startPreService\')\">Abilita preventivi</a></div><div class=\"toolbar-add-estimate m-r pull-right\"><six-lookup-2 style=\"display: inline-block; vertical-align: middle; width: 250px;\" ng-if=\"$ctrl.opAllowed(\'linkEstimate\')\" sx-placeholder=\"\'Seleziona un preventivo\'\" sx-id=\"link-estimate\" sx-base-path=\"\'./\'\" sx-type=\"\'estimate\'\" sx-title=\"\'Preventivo\'\" ng-model=\"$ctrl.estimateToLink\" sx-war=\"\'six-plan\'\" sx-show-details=\"false\" sx-show-filters=\"false\" sx-filter=\"$ctrl.linkEstimateFilter\"></six-lookup-2><a class=\"btn btn-primary m-r\" title=\"Seleziona un preventivo\" ng-disabled=\"!$ctrl.estimateToLink\" ng-click=\"!$ctrl.estimateToLink || $ctrl.linkEstimate()\" ng-if=\"$ctrl.opAllowed(\'linkEstimate\')\"><i class=\"fa fa-link\"></i> Collega preventivo</a> <a class=\"btn btn-success\" ng-click=\"$ctrl.gotoNewEstimate()\" ng-if=\"$ctrl.opAllowed(\'gotoNewEstimate\')\"><i class=\"fa fa-plus\"></i> Crea nuovo preventivo</a></div></div><div class=\"well\" ng-show=\"!$ctrl.estimateList.totalResults\">Nessun preventivo presente.</div><six-grid-pagination ng-show=\"$ctrl.estimateList.totalResults\" sx-id=\"estimate\" get-data-callback=\"$ctrl.getEstimateList()\" get-list-callback=\"$ctrl.getEstimateList()\" items-list=\"$ctrl.estimateList\" grid-options=\"$ctrl.viewGridOptions\" column-defs=\"$ctrl.viewGridOptions.columnDefs\" params=\"$ctrl.params\" auto-resize-params=\"$ctrl.autoResizeParams\" show-global-search=\"false\" grid-app-callbacks=\"$ctrl.gridAppCallbacks\"></six-grid-pagination><div class=\"row m-t\"><div class=\"col-xs-4\"><a class=\"btn btn-primary m-r\" title=\"Pubblica i preventivi cliente selezionati\" ng-disabled=\"$ctrl.opDisabled(\'publishEstimates\')\" ng-click=\"$ctrl.opDisabled(\'publishEstimates\') || $ctrl.publishEstimates()\" ng-if=\"$ctrl.opAllowed(\'publishEstimates\')\"><i class=\"fa fa-sign-out\"></i> Pubblica preventivi cliente</a> <a class=\"btn btn-danger m-r\" title=\"Sospendi tutti i preventivi\" ng-disabled=\"$ctrl.opDisabled(\'suspendEstimates\')\" ng-click=\"$ctrl.opDisabled(\'suspendEstimates\') || $ctrl.suspendEstimates()\" ng-if=\"$ctrl.opAllowed(\'suspendEstimates\')\"><i class=\"fa fa-ban\"></i> Sospendi preventivi</a></div><div class=\"col-xs-8 text-right\"><a class=\"btn btn-success m-r\" title=\"Seleziona un unico preventivo\" ng-disabled=\"$ctrl.opDisabled(\'acceptEstimate\')\" ng-click=\"$ctrl.opDisabled(\'acceptEstimate\') || $ctrl.acceptEstimate()\" ng-if=\"$ctrl.opAllowed(\'acceptEstimate\')\"><i class=\"fa fa-check\"></i> Accetta preventivo</a> <a class=\"btn btn-danger m-r\" title=\"Rifiuta tutti i preventivi\" ng-disabled=\"$ctrl.opDisabled(\'denyEstimates\')\" ng-click=\"$ctrl.opDisabled(\'denyEstimates\') || $ctrl.denyEstimates()\" ng-if=\"$ctrl.opAllowed(\'denyEstimates\')\"><i class=\"fa fa-close\"></i> Rifiuta preventivi</a> <a class=\"btn btn-primary\" title=\"Revisiona un unico preventivo\" ng-disabled=\"$ctrl.opDisabled(\'reviseEstimate\')\" ng-click=\"$ctrl.opDisabled(\'reviseEstimate\') || $ctrl.reviseEstimate()\" ng-if=\"$ctrl.opAllowed(\'reviseEstimate\')\"><i class=\"fa fa-edit\"></i> Revisiona preventivo</a></div></div></div><six-sidebar sx-id=\"attachmentsPanel\" sx-position=\"left\" sx-title=\"$ctrl.panelConfig.title\" sx-dimension=\"l\" six-sidebar-autoclose=\"true\" sx-opened=\"$ctrl.attachmentsPanelOpen\" sx-pinnable=\"false\"><six-tree-attachments nodes=\"$ctrl.panelConfig.item.model.attachments\" sx-readonly=\"true\" sx-downloadable=\"true\" sx-expanded=\"true\" sx-tag-filter=\"\'class=estimate\'\"></six-tree-attachments></six-sidebar><div class=\"content\" ng-if=\"false\"><div class=\"well row m-t\"><div class=\"col-xs-4\">ictOdlUuid: <input type=\"text\" ng-model=\"$ctrl.ictOdlUuid\"></div><div class=\"col-xs-4\">ictOdlStatus:<select ng-model=\"$ctrl.ictOdlStatus\"><option>OPEN</option><option>ABORT</option><option>PRE_SERVICE</option><option>ESTIMATE_REQUESTED</option><option>ESTIMATE_PUBLISHED</option><option>ESTIMATE_DENIED</option><option>ESTIMATE_TO_BE_REVISED</option><option>ESTIMATE_ACCEPTED</option><option>ESTIMATE_SUSPENDED</option><option>IN_SERVICE</option><option>SUSPENDED</option><option>DONE</option><option>CLOSED</option><option>ACCOUNTED</option></select></div><div class=\"col-xs-4\"><label><input type=\"checkbox\" ng-model=\"$ctrl.ictManage\"> ictManage</label></div></div></div>");
$templateCache.put("plan/components/ict_plafond.html","<div ng-if=\"contract == \'loose\'\"><span ng-if=\"$ctrl.plafond\"><b class=\"\">Plafond totale:</b> <i class=\"m-xs fa fa-credit-card text-info-dker\"></i> {{$ctrl.plafond.total | currency}} <b class=\"m-l\">Plafond consumato:</b> <i class=\"m-xs fa fa-credit-card text-primary-dker\"></i> {{$ctrl.plafond.turnover | currency}} <b class=\"m-l\">Plafond impegnato:</b> <i class=\"m-xs fa fa-credit-card text-warning-dker\"></i> {{$ctrl.plafond.constrain | currency}} <b class=\"m-l\">Plafond residuo:</b> <i class=\"m-xs fa fa-credit-card text-{{$ctrl.plafond.total &gt; $ctrl.plafond.turnover? \'success\' : \'danger\'}}-dker\"></i> {{$ctrl.plafond.total - $ctrl.plafond.turnover | currency}} <span class=\"text-muted\" ng-if=\"$ctrl.plafond.constrain\">({{$ctrl.plafond.total - $ctrl.plafond.turnover - $ctrl.plafond.constrain | currency}})</span></span> <span ng-if=\"$ctrl.plafond == false\" class=\"alert alert-warning m-l-md\">Impossibile calcolare il plafond</span></div><div ng-if=\"contract == \'strict\'\"><div ng-if=\"$ctrl.service &amp;&amp; $ctrl.asset\">{{$ctrl.service.description}} - {{$ctrl.asset.description}} <span ng-if=\"$ctrl.plafond\"><b class=\"m-l\">Plafond totale:</b> <i class=\"m-xs fa fa-credit-card text-info-dker\"></i> {{$ctrl.plafond.total | currency}} <b class=\"m-l\">Plafond consumato:</b> <i class=\"m-xs fa fa-credit-card text-primary-dker\"></i> {{$ctrl.plafond.used | currency}} <b class=\"m-l\">Plafond impegnato:</b> <i class=\"m-xs fa fa-credit-card text-warning-dker\"></i> {{$ctrl.plafond.constrain | currency}} <b class=\"m-l\">Plafond residuo:</b> <i class=\"m-xs fa fa-credit-card text-{{$ctrl.plafond.residual &gt; 0? \'success\' : \'danger\'}}-dker\"></i> {{$ctrl.plafond.residual | currency}} <span class=\"text-muted\" ng-if=\"$ctrl.plafond.constrain\">({{$ctrl.plafond.residual - $ctrl.plafond.constrain | currency}})</span></span> <span ng-if=\"$ctrl.plafond == false\" class=\"alert alert-warning m-l-md\">Non esistono righe d\'ordine associate</span></div><div ng-if=\"!$ctrl.service || !$ctrl.asset\">Nessun ODL selezionato</div></div>");
$templateCache.put("plan/consumptiveodl/consumptiveodl_detail.html","<style type=\"text/css\">\n  .errorclass {\n    color: red;\n  }\n  .requiredclass{\n    border: 1px solid red;\n  }\n  .newclass {\n    color: green;\n  }\n  .placehodlerclass {\n    color: #afafaf;\n  }\n  .cont-center{\n    text-align: center;\n  }\n  .cont-right{\n    text-align: right;\n  }\n  .cont-left{\n    text-align: left;\n  }\n  six-toolbar-item .invisible-check{\n    visibility: hidden;\n  }\n  .ui-grid-cell{\n    overflow: visible;\n  }\n</style><six-toolbar><six-toolbar-item label=\"Template righe consuntivo\" icon=\"fa fa-download icon text-info-dker\" toolbar-function=\"schemaRowsDefinitionToXlsx()\"></six-toolbar-item><six-toolbar-item label-condition=\"(typeExport == \'exportToImport\')\" label=\"Esportazione (NORMALE)\" label-disabled=\"Esportazione (REIMPORTAZIONE)\" icon=\"fa fa-upload icon text-info-dker\"><li><a ng-click=\"setTypeExport(\'export\')\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': (typeExport == \'exportToImport\')}\"></i> Normale</a></li><li><a ng-click=\"setTypeExport(\'exportToImport\')\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': (typeExport == \'export\')}\"></i> Reimportazione</a></li></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" onclick=\"window.history.back()\"></six-toolbar-button><six-toolbar-button label=\"Esporta Excel\" icon=\"fa fa-file-excel-o\" btn-class=\"btn-success\" toolbar-function=\"exportXLSX()\" ng-hide=\"data.rows.length == 0\"></six-toolbar-button><six-toolbar-button label=\"Copia\" btn-class=\"btn-info\" icon=\"fa fa-files-o\" toolbar-function=\"copy()\" ng-if=\"editable\" ng-hide=\"!data.header.version\"></six-toolbar-button><six-toolbar-button label=\"Stampa\" icon=\"fa fa-print text-info-dker\" toolbar-function=\"printConsumptive(\'pdf\')\" sx-disabled=\"!data.header.version\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"fa fa-trash\" toolbar-function=\"delete()\" ng-if=\"editable\" ng-hide=\"!data.header.version\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"save()\" btn-title=\"Save\" ng-if=\"editable\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default constructor\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"!data.header.version\">Nuovo consuntivo</h1><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"data.header.version\">Consuntivo <span class=\"m-l-xs\">{{data.header.model.code}}</span></h1></div><div class=\"col-sm-6 col-xs-12 text-right\"><span class=\"btn btn-bg btn-default font-bold m-r\" style=\"pointer-events: none;\" ng-show=\"data.header.model.status\">{{getReadableStatus(data.header.model.status)}}</span> <a href=\"\" class=\"btn btn-sm btn-success m-r-xs\" ng-click=\"approveConsumptive()\" ng-if=\"type==\'customer\'\"><i class=\"fa fa-check\"></i> Approva</a> <a href=\"\" class=\"btn btn-sm btn-danger\" ng-click=\"refuseConsumptive()\" ng-if=\"type==\'customer\'\"><i class=\"fa fa-close\"></i> Rifiuta</a></div></div></div><uib-tabset class=\"tabs-left\" style=\"padding: 15px\"><uib-tab index=\"0\"><uib-tab-heading><span class=\"fa fa-list-alt text-info-dker\"></span> Anagrafica</uib-tab-heading><div class=\"panel-body m-t-n\"><div class=\"row\"><div class=\"col col-md-12\"><form ng-if=\"modelLoaded\" name=\"detailForm\" sf-schema=\"schemaHeader.model.schema\" sf-form=\"schemaHeader.model.form\" sf-model=\"data.header.model\"></form></div></div><div class=\"row padder m-t-md\" ng-if=\"isPlafondEnabled\"><div class=\"col-lg-12 well\"><ict-plafond odl=\"data.header.model.odl_id\" on-plafond-change=\"plafondChange(plafond)\"></ict-plafond></div></div><div class=\"m-t-sm m-b-sm pull-right\" ng-if=\"editable\"><div class=\"inline m-r text-left stb-content\"><button class=\"btn btn-info btn-sm\" href=\"\" ng-click=\"data.header.model.auto_refresh_total = !data.header.model.auto_refresh_total\"><span class=\"fa fa-square-o\" ng-show=\"!data.header.model.auto_refresh_total\"></span> <span class=\"fa fa-check-square-o\" ng-show=\"data.header.model.auto_refresh_total\"></span> <span>Ricalcolo automatico tot.</span></button></div><button class=\"btn btn-sm btn-success\" ng-click=\"insertRow()\"><i class=\"fa fa-plus\"></i>Aggiungi riga</button></div><div ui-grid=\"gridOptions\" class=\"grid\" ui-grid-resize-columns=\"\" ui-grid-edit=\"\" ui-grid-row-edit=\"\" ui-grid-exporter=\"\" ui-grid-validate=\"\" style=\"margin-top: 70px\"><div class=\"grid-msg-overlay\" ng-show=\"!gridOptions.data.length &amp;&amp; editable\"><div class=\"msg\"><div class=\"center\"><span class=\"muted\">Selezionare File Excel</span><br><input type=\"file\" accept=\".xls,.xlsx,.ods\" xlsxreader=\"\" opts=\"gridOptions\" multiple=\"false\"></div></div></div></div><label><input type=\"checkbox\" ng-model=\"showDataArray\"> Mostra json</label><div ng-if=\"showDataArray\" class=\"col-md-12\"><b>Righe presenti nella griglia</b><div ng-repeat=\"row in data.rows\" style=\"padding-top: 10px; padding-bottom: 10px; height: 100px;\"><div class=\"col-md-1\">{{row.model.code}}</div><div class=\"col-md-2\">{{row.UUID}}</div><div class=\"col-md-9\">{{row}}</div></div><div ng-if=\"data.rows.length == 0\">array vuoto</div><br><b>Righe nuove da salvare</b><div ng-repeat=\"newRow in insertedList\" style=\"padding-top: 10px; padding-bottom: 10px;\"><div class=\"col-md-1\">{{newRow.model.code}}</div><div class=\"col-md-9 col-md-offset-2\">{{newRow}}</div></div><div ng-if=\"insertedList.length == 0\">array vuoto</div><br><b>Righe modificate da aggiornare</b><div ng-repeat=\"mod in modifiedList\" style=\"padding-top: 10px; padding-bottom: 10px;\"><div class=\"col-md-1\">{{mod.model.code}}</div><div class=\"col-md-2\">{{mod.UUID}}</div><div class=\"col-md-9\">{{mod}}</div></div><div ng-if=\"modifiedList.length == 0\">array vuoto</div><br><b>Righe da eliminare</b><div ng-repeat=\"del in deletedList\" style=\"padding-top: 10px; padding-bottom: 10px;\"><div class=\"col-md-1\">.ui-grid-header-canvas{ padding: 0px; margin: 0px; } {{del.model.code}}</div><div class=\"col-md-2\">{{del.UUID}}</div><div class=\"col-md-9\">{{del}}</div></div><div ng-if=\"deletedList.length == 0\">array vuoto</div>.ui-grid-header-canvas{ padding: 0px; margin: 0px; }</div></div></uib-tab><uib-tab index=\"1\" disable=\"!data.header.version\"><uib-tab-heading><span class=\"fa fa-book text-info-dker\"></span> Allegati</uib-tab-heading><six-tree-attachments nodes=\"attachments\" save-callback=\"updAttachments()\" sx-readonly=\"!editable\" sx-tag-filter=\"\'class=consumptive\'\"></six-tree-attachments></uib-tab></uib-tabset></div></div>");
$templateCache.put("plan/consumptiveodl/consumptiveodl_list.html","<style type=\"text/css\">\n  six-toolbar-item .invisible-check{\n    visibility: hidden;\n  }\n</style><six-toolbar><six-toolbar-item label-condition=\"findCross\" label=\"Commessa ({{currentCommission.code}})\" label-disabled=\"Commessa (TUTTE)\" icon=\"fa fa-money icon text-success-dker\"><li><a ng-click=\"setFindCross(false)\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': findCross}\"></i> Corrente ({{currentCommission.code}})</a></li><li><a ng-click=\"setFindCross(true)\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': !findCross}\"></i> Tutte</a></li></six-toolbar-item><six-toolbar-button label=\"Genera consuntivo\" icon=\"fa fa-plus\" btn-class=\"btn-success\" ng-if=\"editable\" toolbar-function=\"newConsumptive()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"refresh()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista consuntivi</h1></div></div></div><div class=\"panel-body\"><six-grid-pagination sx-id=\"consumptive\" get-data-callback=\"getConsumptiveList()\" get-list-callback=\"getConsumptiveList()\" items-list=\"consumptiveList\" grid-options=\"viewGridOptions\" column-defs=\"viewGridOptions.columnDefs\" params=\"params\" auto-resize-params=\"autoResizeParams\" show-global-search=\"false\"></six-grid-pagination></div></div></div>");
$templateCache.put("plan/consumptiveodl/consumptiveodlrowconfigurator_detail.html","<six-toolbar><six-toolbar-button label=\"Lista\" icon=\"fa fa-chevron-left\" toolbar-function=\"back()\"></six-toolbar-button><six-toolbar-button label=\"Duplica\" btn-class=\"btn-primary\" icon=\"fa fa-files-o\" toolbar-function=\"setConfModel()\" ng-if=\"selected.version\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"fa fa-trash-o\" toolbar-function=\"delete()\" sx-disabled=\"!isDeletePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"saveForm()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Dettaglio Configurazione</h1></div></div></div><div class=\"wrapper\"><div class=\"panel-heading\" style=\"background-color: transparent\"><div class=\"page-header-bleed-right\"><div class=\"actions\"><div class=\"row\"><form name=\"header\"><div class=\"form-group\"><div class=\"col-md-12\"><label class=\"control-label\">Codice:</label> <input type=\"text\" class=\"form-control\" ng-model=\"commissionCode\" ng-disabled=\"bool.isCross || bool.isCallCenter\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"!bool.isCross && !bool.isCallCenter\"><label class=\"col-md-1 control-label\">Commesse:</label><div class=\"col-md-12\"><div id=\"vectors_budget_code\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"commissionsSelected.codes\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Selezionare una commessa...\">{{$item.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in commissions\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div></div><div class=\"col-md-12\"><input type=\"checkbox\" ng-model=\"bool.isCross\" name=\"cross_commission\" ng-click=\"updateCode()\"> <label class=\"control-label\">Imposta come configurazione di default per gli utenti (cross-commessa)</label></div><div class=\"col-md-12\"><input type=\"checkbox\" ng-model=\"bool.isCallCenter\" name=\"isCallCenter\" ng-click=\"setCallCenter()\"> <label class=\"control-label\">Imposta come configurazione del Call Center</label></div></div></form></div></div></div></div><div class=\"panel-body\"><uib-tabset justified=\"true\"><uib-tab heading=\"Preview\"><form name=\"myForm\" sf-schema=\"schema\" sf-form=\"form\" sf-model=\"model\" ng-submit=\"onSubmit(myForm)\"></form></uib-tab><uib-tab heading=\"Schema\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><div class=\"col-md-12 centered\"><b>SCHEMA</b></div><div class=\"col-md-12 override-padding-no-pad-left-right\"><hr class=\"override-margin-top-bottom\"></div><div class=\"col-md-12 centered\"><div class=\"col-md-2 col-md-offset-1\"><b>CODICE</b></div><div class=\"col-md-3\"><b>DESCRIZIONE</b></div><div class=\"col-md-1\"><b>TIPOLOGIA</b></div><div class=\"col-md-2\"><b>FORMATO</b></div></div><div class=\"col-md-12 override-padding-no-pad-left-right\"><hr class=\"override-margin-top-bottom\"></div><div class=\"col-md-12 centered\"><div class=\"col-md-2 col-md-offset-1\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><form name=\"propertyKeyForm\"><input class=\"form-control\" name=\"property_key\" placeholder=\"Codice...\" type=\"text\" ng-model=\"property.key\" pattern=\"^[a-zA-Z]+[\\w]*$\"><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"propertyKeyForm.property_key.$error.pattern\">Caratteri non consentiti</span></div></form></div></div><div class=\"col-md-3\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><input class=\"form-control\" placeholder=\"Descrizione\" type=\"text\" ng-model=\"property.title\"></div></div><div class=\"col-md-1\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><select class=\"form-control\" ng-model=\"property.type\"><option></option><option value=\"string\">string</option><option value=\"number\">number</option><option value=\"integer\">integer</option><option value=\"boolean\">boolean</option><option value=\"date\">date</option><option value=\"array\">array</option></select></div></div><div class=\"col-md-2\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><select class=\"form-control\" ng-model=\"property.format\" ng-if=\"(property.type == \'string\')\"><option></option><option value=\"lookup\">lookup</option><option value=\"formula\">formula</option><option value=\"enum\">enum</option></select><select class=\"form-control\" ng-model=\"property.format\" ng-if=\"(property.type == \'number\' || property.type == \'integer\')\"><option></option><option value=\"formula\">formula</option><option value=\"enum\">enum</option></select><select class=\"form-control\" ng-model=\"property.items_type\" ng-if=\"(property.type == \'array\')\"><option></option><option value=\"lookup\">lookup</option><option value=\"string\">string</option><option value=\"number\">number</option><option value=\"integer\">integer</option><option value=\"date\">date</option></select></div></div><div class=\"col-md-2\"><div ng-if=\"isInheritable(property.type)\"><label><input type=\"checkbox\" ng-model=\"property.inherited\"> Campo ereditato</label></div></div><div class=\"col-md-1\"><button ng-click=\"addProperty()\" class=\"btn btn-sm btn-info pull-right\"><span class=\"fa fa-plus\"></span> Add</button></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-repeat=\"(key, value) in selected.model.schema.properties\" style=\"align-content: center; padding-bottom: 0px;\"><div class=\"col-md-12 uniform-height\" style=\"align-content: center;\"><div class=\"col-md-1\"><a href=\"\" ng-click=\"status[key].open = !status[key].open\" id=\"btn_row_detail\"><i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status[key].open, \'glyphicon-chevron-right\': !status[key].open}\"></i></a></div><div class=\"col-md-2\">{{ key }}</div><div class=\"col-md-3\">{{ value.title }}</div><div class=\"col-md-1\">{{ value.type }}</div><div class=\"col-md-2\"><span ng-if=\"value.format\">{{value.format}}</span> <span ng-if=\"value.type == \'array\' && value.items\">{{value.items.format}}</span></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-show=\"status[key].open\"><div class=\"col-md-12 uniform-height-2\" ng-if=\"value.format !== \'lookup\' && value.format !== \'formula\' && value.format !== \'enum\' && value.format !== \'inherit\' && value.type !== \'array\'\"><div class=\"col-md-2\">FORMATO:</div><div class=\"col-md-10\">{{value.format}}</div></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'inherit\'\" ng-include=\"\'dataset/modeltype/detail_inherit.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'lookup\' && value.type != \'array\'\" ng-include=\"\'dataset/modeltype/detail_lookup.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'formula\'\" ng-include=\"\'dataset/modeltype/detail_formula.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'enum\'\" ng-include=\"\'dataset/modeltype/detail_enum.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.type === \'array\'\" ng-include=\"\'dataset/modeltype/detail_array.html\'\"></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">ELIMINA:</div><div class=\"col-md-10\"><button ng-click=\"deleteProperty(key)\" class=\"btn btn-danger btn-xs btn-default\" ng-disabled=\"disableDeleteColumn(key)\"><i class=\"fa fa-trash\"></i></button></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">IN TABELLA:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.check\" ng-change=\"changeColumnDefs(key, value)\" ng-disabled=\"disableInTableColumn(key)\"></div></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-show=\"value.check == true\"><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">LARGHEZZA (px):</div><div class=\"col-md-10\"><input type=\"text\" min=\"1\" step=\"1\" size=\"45\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=\"value.width\" ng-change=\"changeColumnDefs(key, value)\"></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">ORDINAMENTO:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.enableSorting\" ng-change=\"changeColumnDefs(key, value)\"></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">FILTRAGGIO:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.enableFiltering\" ng-change=\"changeColumnDefs(key, value)\"></div></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div></div></div></div></uib-tab><uib-tab heading=\"Form\"><table class=\"table table-striped\"><thead><th colspan=\"5\">FORM</th><tr><th colspan=\"5\"><div class=\"form-group\"><label for=\"title\" class=\"control-label\">Titolo</label><div class=\"\"><input type=\"text\" class=\"form-control\" id=\"title\" placeholder=\"\" ng-model=\"title\" name=\"title\" ng-keyup=\"refreshTitleForm(title)\"></div></div></th></tr><tr><td></td><td></td><td><input type=\"text\" placeholder=\"Titolo...\" ng-model=\"newTab.title\"></td><td><button ng-click=\"addTab(selected.model.form[0].items[0])\" class=\"btn btn-xs btn-info\"><span class=\"fa fa-plus\"></span> Add</button></td></tr><tr><th></th><th>POSIZIONE</th><th>TITOLO</th><th></th></tr></thead><tbody><tr ng-repeat-start=\"(key, tab) in selected.model.form[0].items[0].tabs\"><td><a href=\"\" ng-click=\"statusForm[key].open = !statusForm[key].open\"><i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': statusForm[key].open, \'glyphicon-chevron-right\': !statusForm[key].open}\"></i></a></td><td><span class=\"btn btn-sm\" ng-click=\"swapUp(key, selected.model.form[0].items[0].tabs)\" ng-disabled=\"key<=0\"><i class=\"fa fa-caret-up\"></i></span> {{key+1}} <span class=\"btn btn-sm\" ng-click=\"swapDown(key, selected.model.form[0].items[0].tabs)\" ng-disabled=\"key>=selected.model.form[0].items[0].tabs.length-1\"><i class=\"fa fa-caret-down\"></i></span></td><td><input type=\"text\" ng-model=\"tab.title\" ng-disabled=\"(tab.key[0] == \'code\' || tab.key[0] == \'description\')\" ng-keyup=\"updateScope()\"></td><td><a ng-click=\"removeTabOrField(key, selected.model.form[0].items[0].tabs)\" class=\"btn btn-danger btn-xs btn-default\" id=\"btn_row_detail_form\"><i class=\"fa fa-trash\"></i></a></td></tr><tr ng-repeat-end=\"\" ng-show=\"statusForm[key].open\"><td></td><td colspan=\"3\" style=\"background-color:rgba(211, 211, 211, 0.38);\"><table class=\"table table-striped override-margin\"><tr><td></td><td><select ng-options=\"k as v.title for (k, v) in schema.properties\" ng-model=\"newFieldForm.key\"></select></td><td><input type=\"text\" placeholder=\"Titolo...\" ng-model=\"newFieldForm.title\"></td><td><input type=\"checkbox\" placeholder=\"Richiesto...\" ng-model=\"newFieldForm.required\"></td><td><input type=\"checkbox\" placeholder=\"Nascosto...\" ng-model=\"newFieldForm.htmlClass\" ng-true-value=\"\'hidden\'\" ng-false-value=\"\'\'\"></td><td><select ng-model=\"newFieldForm.type\" ng-change=\"updateScope()\"><option value=\"\"></option><option value=\"text\">text</option><option value=\"textarea\">textarea</option><option value=\"number\">number</option><option value=\"datepicker\">date</option><option value=\"password\">password</option><option value=\"checkbox\">checkbox</option><option value=\"select\">enum</option><option value=\"array\">array</option><option value=\"sixlookup\">lookup</option><option value=\"inherited\">ereditato</option><option value=\"formula\">formula</option></select></td><td><button ng-click=\"addFieldToTab(tab)\" class=\"btn btn-xs btn-info\"><span class=\"fa fa-plus\"></span> Add</button></td></tr><tr><th>POSIZIONE</th><th>CAMPO</th><th>TITOLO</th><th>REQUIRED</th><th>NASCOSTO</th><th>TIPO</th><th></th></tr><tr ng-repeat=\"(fieldKey, field) in tab.items\"><td class=\"override-width-200px\"><div><span class=\"btn btn-sm\" ng-click=\"swapUp(fieldKey, tab.items)\" ng-disabled=\"fieldKey<=0\"><i class=\"fa fa-caret-up\"></i></span> {{fieldKey+1}} <span class=\"btn btn-sm\" ng-click=\"swapDown(fieldKey, tab.items)\" ng-disabled=\"fieldKey>=tab.items.length-1\"><i class=\"fa fa-caret-down\"></i></span></div></td><td ng-if=\"!field.title\">{{field}}</td><td ng-if=\"!field.title\"></td><td ng-if=\"!field.title\"></td><td ng-if=\"!field.title\"></td><td ng-if=\"field.title\">{{field.key[0]}}</td><td ng-if=\"field.title\"><input type=\"text\" ng-model=\"field.title\" ng-keyup=\"updateScope()\"></td><td ng-if=\"field.title\"><input type=\"checkbox\" ng-model=\"field.required\" ng-change=\"updateScope()\"></td><td ng-if=\"field.title\"><input type=\"checkbox\" ng-model=\"field.htmlClass\" ng-change=\"updateScope()\" ng-true-value=\"\'hidden\'\" ng-false-value=\"\'\'\"></td><td ng-if=\"field.title\"><select ng-model=\"field.type\" ng-change=\"updateField(field)\"><option value=\"\"></option><option value=\"text\">text</option><option value=\"textarea\">textarea</option><option value=\"number\">number</option><option value=\"datepicker\">date</option><option value=\"password\">password</option><option value=\"checkbox\">checkbox</option><option value=\"select\">enum</option><option value=\"array\">array</option><option value=\"sixlookup\">lookup</option><option value=\"inherited\">ereditato</option><option value=\"formula\">formula</option></select></td><td><a ng-click=\"removeTabOrField(fieldKey, tab.items)\" class=\"btn btn-danger btn-xs btn-default\"><i class=\"fa fa-trash\"></i></a></td></tr></table></td></tr></tbody></table></uib-tab></uib-tabset></div><div class=\"panel-footer\"><div class=\"form-group\"><input id=\"jsonShowCheck\" type=\"checkbox\" ng-model=\"jsonshow\" class=\"pull-left\" data-toggle=\"collapse\" data-target=\"#json-collapse\"> <label for=\"jsonShowCheck\" class=\"pull-left control-label\">Dettaglio avanzato</label></div></div><div class=\"row collapse\" id=\"json-collapse\" collapse=\"!jsonshow\"><div class=\"col-md-8\"><div class=\"panel no-border\"><div class=\"panel-heading wrapper b-b b-light\"><h4 class=\"font-thin m-t-none m-b-none text-muted\">Dettaglio</h4></div><div style=\"margin-top:0px;\" ui-ace=\"{ useWrapMode : true, showGutter: true, mode: \'json\', firstLineNumber: 1, onLoad: aceLoaded, onChange: aceChanged }\" ng-model=\"aceModel\"></div></div></div><div class=\"col-md-4\"><div class=\"list-group list-group-lg list-group-sp\"><pre>{{ model}}</pre></div></div></div></div></div></div>");
$templateCache.put("plan/consumptiveodl/consumptiveodlrowconfigurator_list.html","<six-toolbar><six-toolbar-button label=\"Crea conf.\" icon=\"fa fa-plus\" toolbar-function=\"newConsumptiveRowConfiguration()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"refresh()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista configurazioni righe consuntivi</h1></div></div></div><div class=\"panel-body\"><div class=\"form-group\"><input ng-keyup=\"getData(queryParam)\" class=\"form-control\" type=\"text\" ng-model=\"queryParam\" placeholder=\"Type here to filter the list...\"></div><table id=\"consumptive_configurator_list\" class=\"table table-striped\"><thead><tr><th></th><th>CODICE CONFIGURAZIONE</th><th>COMMESSA</th><th>DATA</th></tr></thead><tbody><tr ng-repeat=\"item in consumptiveRowConfiguratorList.list\"><td><a ng-href=\"#/consumptiveconfigurator/row/{{item.UUID}}\" class=\"btn btn-default\" id=\"btn_issue_detail\"><span class=\"fa fa-search\"></span></a></td><td>{{ item.model.code }}</td><td>{{printCommission(item.model.commission)}}</td><td>{{ item.dataIn | date:\'dd/MM/yyyy\' }}</td></tr><tr ng-hide=\"consumptiveRowConfiguratorList.list.length\"><td><p class=\"text-center\">Nessun record recuperato</p></td></tr></tbody></table></div><div class=\"panel-footer\"><div class=\"row text-center\"><uib-pagination ng-change=\"pageChanged()\" boundary-links=\"true\" total-items=\"consumptiveRowConfiguratorList.totalResults\" ng-model=\"consumptiveRowConfiguratorList.currentPage\" class=\"pagination-sm\" items-per-page=\"consumptiveRowConfiguratorList.pageSize\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></uib-pagination></div></div></div></div>");
$templateCache.put("plan/dashboard/dashboardodl.html","<style>\n  #odlDashboardPanel-content { padding: 15px; }\n</style><six-toolbar><six-toolbar-button label=\"Stampa\" icon=\"fa fa-print\" toolbar-function=\"printSelectedOdl()\" sx-disabled=\"getSelectedRows().length == 0\"></six-toolbar-button><six-toolbar-button label=\"Genera Odl\" icon=\"fa fa-plus\" toolbar-function=\"newOdl()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Chiudi Odl\" icon=\"fa fa-trash\" toolbar-function=\"massiveClosingOdl()\" sx-disabled=\"!isWritePermAllowed() || getSelectedRows().length == 0\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" sx-disabled=\"!isDeletePermAllowed() || getSelectedRows().length == 0\" ng-confirm-message=\"Sei sicuro?\" ng-confirm-click=\"deleteOdlSelected()\" ng-confirm-condition=\"true\"></six-toolbar-button><six-toolbar-button label=\"Tutti\" icon=\"fa fa-square-o\" icon-disabled=\"fa fa-check-square-o\" icon-condition=\"bool.allOdl\" toolbar-function=\"toggleAllOdl()\" ng-show=\"searchAllPermAllowed()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"refresh()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Cruscotto</h1></div></div></div><div class=\"panel-body\"><div class=\"col-sm-12\"><label class=\"checkbox i-checks m-b inline\"><input id=\"check-1\" type=\"checkbox\" ng-model=\"bool.viewEstimateAssociated\"><i></i> <span class=\"i-checks\">Visualizza le righe con un preventivo associato</span></label> <span>&nbsp;&nbsp;</span> <label class=\"checkbox i-checks m-b inline\"><input id=\"check-2\" type=\"checkbox\" ng-model=\"bool.viewConsumptiveAssociated\"><i></i> <span class=\"i-checks\">Visualizza le righe con un consuntivo associato</span></label></div><div class=\"col-sm-12\"><div class=\"col-sm-12 btn btn-default\" style=\"text-align: left\" ng-click=\"isAssetTreeFilterOpen = !isAssetTreeFilterOpen\">Filtro asset avanzato <i class=\"fa pull-right\" ng-class=\"{\'fa-chevron-down\': !isAssetTreeFilterOpen, \'fa-chevron-up\': isAssetTreeFilterOpen}\"></i></div><div uib-collapse=\"!isAssetTreeFilterOpen\"><div class=\"well well-lg\"><p><br>Seleziona specifici asset per filtrare gli ODL sull\'asset stesso e i suoi sottoelementi.</p><div ng-repeat=\"(key, rule) in assetTreeFilter\" class=\"list-group-item b-l-primary b-l-3x m-b hover-anchor hover\"><span ng-click=\"removeParentFilter(key)\" class=\"pull-right text-muted hover-action\" role=\"button\" tabindex=\"0\"><i class=\"fa fa-times\"></i></span> <span class=\"block attr row\"><div class=\"col-md-6 form-group\"><label class=\"control-label\">Elemento tecnologico</label><six-lookup-2 sx-id=\"parentLookup_{{key}}\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" sx-field=\"\'type_id\'\" ng-model=\"rule.type\" sx-filter=\"typeIdFilter\" sx-compact=\"true\" sx-item-template=\"\'{{item.description}}\'\" sx-show-details=\"false\" sx-show-filters=\"false\"></six-lookup-2></div><div class=\"col-md-5 form-group\"><label class=\"control-label\">Asset</label><six-lookup-2 sx-id=\"asset\" sx-base-path=\"\'record\'\" sx-type=\"rule.type.type_id.UUID\" ng-model=\"rule.item\" sx-field=\"\'record_id\'\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div></span></div><div><button class=\"btn btn-success\" ng-click=\"addParentFilter()\"><i class=\"fa fa-plus\"></i> Aggiungi radice</button> <button class=\"btn btn-danger\" ng-click=\"resetTreeFiltering()\"><i class=\"fa fa-close\"></i> Reset filtri</button> <button class=\"btn btn-primary pull-right\" ng-click=\"refresh()\"><i class=\"fa fa-search\"></i> Filtra risultati</button></div></div></div></div><div class=\"col-sm-12 m-t\"><six-grid-pagination sx-id=\"dashboardodl_grid\" get-data-callback=\"getCurrentUserOdlList()\" get-list-callback=\"getCurrentUserOdlList()\" items-list=\"odlList\" grid-options=\"viewGridOptions\" column-defs=\"viewGridOptions.columnDefs\" params=\"params\" auto-resize-params=\"autoResizeParams\" show-global-search=\"false\" enable-state-saving=\"true\" grid-app-callbacks=\"gridAppCallbacks\"></six-grid-pagination></div></div><six-sidebar sx-id=\"odlDashboardPanel\" sx-position=\"bottom\" sx-title=\"panelConfig.title\" sx-dimension=\"100\" six-sidebar-autoclose=\"true\" sx-opened=\"odlDashboardPanelOpen\" sx-pinnable=\"false\"><ict-odl-estimate class=\"\" ng-if=\"panelConfig.estimatePanel\" ict-odl=\"panelConfig.odl\" ict-odl-status=\"panelConfig.odlStatus\" ict-odl-uuid=\"panelConfig.odlUuid\" ict-manage=\"panelConfig.estimateManage\"></ict-odl-estimate><ict-odl-consumptive ng-if=\"panelConfig.consumptivePanel\" ict-odl=\"panelConfig.odl\" ict-odl-status=\"panelConfig.odlStatus\" ict-odl-uuid=\"panelConfig.odlUuid\" ict-manage=\"panelConfig.consumptiveManage\"></ict-odl-consumptive><ict-notifications ng-if=\"panelConfig.notificationPanel\" ict-type=\"\'odl\'\" ict-uuid=\"panelConfig.odlUuid\" ict-detail-view=\"sidebar\"></ict-notifications><div ng-if=\"panelConfig.manageNotificationPanel\"><six-send-email sx-title-mail=\"objMail.title\" sx-body-mail=\"objMail.message\" sx-to-mail=\"objMail.to\" sx-cc-mail=\"objMail.cc\" sx-type-mail=\"\'odl\'\" sx-record-id=\"panelConfig.odlRef\"></six-send-email></div><div ng-if=\"panelConfig.attachmentsPanel\"><six-tree-attachments nodes=\"panelConfig.odl.model.attachments\" sx-readonly=\"true\" sx-downloadable=\"true\" sx-expanded=\"true\" sx-tag-filter=\"\'class=odl\'\"></six-tree-attachments></div></six-sidebar></div></div>");
$templateCache.put("plan/dashboard/dashboardodl_configurator.html","<six-toolbar><six-toolbar-button label=\"Crea configurazione\" icon=\"fa fa-plus\" toolbar-function=\"newConfiguration()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"refresh()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista Configurazioni Dashboard ODL</h1></div></div></div><div class=\"panel-body\"><table id=\"dashboardodl_configurator_list\" class=\"table table-striped\"><thead><tr><th></th><th>CODICE CONFIGURAZIONE</th><th>COMMESSA</th><th>RUOLO</th><th>DATA</th></tr></thead><tbody><tr ng-repeat=\"item in configuratorList.list\"><td><a ng-href=\"#/dashboard_odl/configurator/{{item.UUID}}\" class=\"btn btn-default\" id=\"btn_issue_detail\"><span class=\"fa fa-search\"></span></a></td><td>{{ item.model.code }}</td><td>{{ printCommission(item.model.commission) }}</td><td>{{ item.model.role.description }}</td><td>{{ item.dataIn | date:\'dd/MM/yyyy\' }}</td></tr><tr ng-hide=\"configuratorList.list.length\"><td colspan=\"5\"><p class=\"text-center\">Nessun record recuperato</p></td></tr></tbody></table></div><div class=\"panel-footer\"><div class=\"row text-center\"><uib-pagination ng-change=\"pageChanged()\" boundary-links=\"true\" total-items=\"configuratorList.totalResults\" ng-model=\"configuratorList.currentPage\" class=\"pagination-sm\" items-per-page=\"configuratorList.pageSize\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></uib-pagination></div></div></div></div>");
$templateCache.put("plan/dashboard/dashboardodl_configurator_detail.html","<six-toolbar><six-toolbar-button label=\"Lista\" icon=\"fa fa-chevron-left\" toolbar-function=\"back()\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"fa fa-trash-o\" toolbar-function=\"delete()\" ng-if=\"columnConfig.version\" sx-disabled=\"!isDeletePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"saveForm()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Dettaglio Configurazione</h1></div></div></div><div class=\"wrapper\"><div class=\"panel-heading\" style=\"background-color: transparent\"><div class=\"page-header-bleed-right\"><div class=\"actions\"><div class=\"row\"><form name=\"header\"><div class=\"form-group\"><div class=\"col-md-8\"><label class=\"control-label\">Codice:</label> <input type=\"text\" class=\"form-control\" ng-model=\"columnConfig.model.code\" ng-disabled=\"bool.isDefault\" placeholder=\"Generato: \'codice commessa - codice ruolo\'\"></div><div class=\"col-md-4\"><label class=\"checkbox i-checks m-t\"><input id=\"check-1\" type=\"checkbox\" ng-model=\"columnConfig.model.auto_generate_code\"><i></i> <span class=\"i-checks\">Genera codice automaticamente</span></label></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"!bool.isDefault\"><label class=\"col-md-12 control-label\">Commessa:</label><div class=\"col-md-12\"><div class=\"input-group has-button\" style=\"width: 100%\"><ui-select ng-model=\"commission.selected\" theme=\"bootstrap\" on-select=\"setCommission($item)\"><ui-select-match class=\"ui-select-match\" placeholder=\"Selezionare una commessa...\">{{commission.selected.code}} - {{commission.selected.description}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in commissions\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"!bool.isDefault\"><label class=\"col-md-12 control-label\">Ruolo:</label><div class=\"col-md-12\"><six-lookup-2 sx-id=\"selectedRole_lookup\" sx-base-path=\"\'record\'\" sx-type=\"\'ruolooperatore\'\" sx-title=\"\'Edificio\'\" ng-model=\"columnConfig.model.role\" sx-compact=\"true\"></six-lookup-2></div></div><div class=\"col-md-6\"><label class=\"checkbox i-checks m-b inline\"><input id=\"check-1\" type=\"checkbox\" ng-model=\"bool.isDefault\" name=\"cross_commission\"><i></i> <span class=\"i-checks\">Imposta come configurazione di default per gli utenti (cross-commessa)</span></label></div></div></form></div></div></div></div><div class=\"panel-body\"><div class=\"alert alert-warning\" style=\"font-size: medium\" ng-show=\"!configScopeSet\"><p>Seleziona commessa e ruolo su cui effettuare la configurazione.</p></div><div id=\"columnManager\" style=\"position: relative;\" ng-show=\"configScopeSet\"><h3>Gestisci colonne</h3><button class=\"pull-right btn btn-xs\" ng-click=\"activateAllColumns()\">Attiva/Disattiva tutte le colonne</button><p>Riordina e attiva/disattiva le colonne da visualizzare</p><ul class=\"list-group\" as-sortable=\"columnSortableOptions\" ng-model=\"columnConfig.model.columns\"><li class=\"list-group-item\" ng-repeat=\"column in columnConfig.model.columns\" as-sortable-item=\"\"><i as-sortable-item-handle=\"\" class=\"fa fa-arrows\" style=\"padding: 10px; margin: -10px 0 -10px -10px;\"></i> <label class=\"checkbox i-checks pull-right m-t-none m-b-none\"><input type=\"checkbox\" ng-model=\"column.active\"><i></i> Visibile</label> {{column.configName}} {{column.displayName}}</li></ul></div></div><div class=\"panel-footer\"><div class=\"form-group\"><input id=\"jsonShowCheck\" type=\"checkbox\" ng-model=\"jsonshow\" class=\"pull-left\" data-toggle=\"collapse\" data-target=\"#json-collapse\"> <label for=\"jsonShowCheck\" class=\"pull-left control-label\">Dettaglio avanzato</label></div></div><div class=\"row collapse\" id=\"json-collapse\" collapse=\"!jsonshow\"><div class=\"col-md-12\"><div class=\"panel no-border\"><div class=\"panel-heading wrapper b-b b-light\"><h4 class=\"font-thin m-t-none m-b-none text-muted\">Dettaglio</h4></div><div style=\"margin-top:0px;\" readonly=\"\" ui-ace=\"{ useWrapMode : true, showGutter: true, mode: \'json\', firstLineNumber: 1, onLoad: aceLoaded }\" ng-model=\"aceModel\"></div></div></div></div></div></div></div>");
$templateCache.put("plan/directives/issuedetails.html","<div class=\"panel-body\"><uib-tabset class=\"tabs-right\"><uib-tab><uib-tab-heading><span class=\"fa fa-list-alt text-info-dker\"></span> Dati</uib-tab-heading><div class=\"row m-b-xs\" ng-if=\"sxIssue.UUID\"><div class=\"col-md-12\"><div class=\"list-group-item clearfix b-l-3x b-l-info\"><div class=\"col-md-3 form-group\"><label class=\"control-label\">Stato segnalazione</label> <span disabled=\"true\" class=\"form-control\">{{sxIssue.status}}</span></div></div></div></div><div class=\"row m-b-xs\"><div class=\"col-md-12\"><div class=\"list-group-item clearfix b-l-3x b-l-primary\"><div class=\"col-md-3 form-group\"><label class=\"control-label\">Tipo Asset</label><six-lookup-2 sx-id=\"issue-schema\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" sx-title=\"\'Tipo asset\'\" ng-model=\"sxIssue.model\" sx-compact=\"true\" sx-item-template=\"\'{{item.description}}\'\" sx-field=\"\'type_id\'\" sx-show-details=\"false\" sx-show-filters=\"false\" sx-page-size=\"10000\"></six-lookup-2></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Asset</label><six-lookup-2 sx-id=\"issue-asset\" sx-base-path=\"\'record\'\" sx-title=\"\'Asset\'\" ng-model=\"sxIssue.model\" sx-type=\"sxIssue.model.type_id.UUID\" sx-field=\"\'record_id\'\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Servizio</label><six-lookup-2 sx-id=\"issue-service\" ng-model=\"sxIssue.model\" sx-type=\"\'servizio\'\" sx-base-path=\"\'record\'\" sx-field=\"\'service_id\'\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Richiedente</label><six-lookup-2 sx-id=\"issue-richiedente\" ng-model=\"sxIssue\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'reporter_id\'\" sx-add=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-prefill=\"{model: {typeoperator: \'richiedente\'}}\"></six-lookup-2></div></div></div></div><div class=\"row m-b\" ng-if=\"!sxShowCustomerInfo\"><div class=\"col-md-12\"><div class=\"list-group-item clearfix b-l-3x b-l-primary\"><div class=\"col-md-3 form-group\"><label class=\"control-label\">Data inserimento</label><six-date-time-picker name=\"date_insertion\" date-options=\"dateOptions\" ng-model=\"sxIssue.date_insertion\"></six-date-time-picker></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Data richiesta</label><six-date-time-picker name=\"date_requested\" date-options=\"dateOptions\" ng-model=\"sxIssue.date_requested\"></six-date-time-picker></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Data di presa in carico</label><six-date-time-picker name=\"date_handling\" date-options=\"dateOptions\" ng-model=\"sxIssue.date_handling\"></six-date-time-picker></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Data chiusura</label><six-date-time-picker name=\"date_closing\" date-options=\"dateOptions\" ng-model=\"sxIssue.date_closing\"></six-date-time-picker></div></div></div></div><div class=\"row m-b\" ng-if=\"sxShowCustomerInfo\"><div class=\"col-md-12\"><div class=\"list-group-item clearfix b-l-3x b-l-primary\"><div class=\"col-md-4 form-group\"><label class=\"control-label\">Data inserimento</label><six-date-time-picker name=\"date_insertion\" date-options=\"dateOptions\" ng-model=\"sxIssue.date_insertion\" sx-disabled=\"true\"></six-date-time-picker></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Responsabile esterno</label><six-lookup-2 sx-id=\"supervisorExternal_id\" ng-model=\"sxIssue.references_assignee\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'supervisorExternal_id\'\" sx-add=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Segreteria</label><six-lookup-2 sx-id=\"secretariat_id\" ng-model=\"sxIssue.references_assignee\" sx-type=\"\'segreteria\'\" sx-base-path=\"\'record\'\" sx-field=\"\'secretariat_id\'\" sx-show-details=\"true\"></six-lookup-2></div></div></div></div><div class=\"col-md-12 hr-margin\" ng-if=\"sxShowWatchers\"><div class=\"panel panel-default pnl-no-margin-t-b\" id=\"panel1\"><a data-toggle=\"collapse\" data-target=\"#issueCollapseOne\"><div class=\"panel-heading\"><h5 class=\"override-margin-top-bottom\"><i class=\"pull-right fa ng-scope fa-angle-right\" ng-class=\"{\'fa-angle-down\': status.open, \'fa-angle-right\': !status.open}\"></i> Watchers</h5></div></a><div id=\"issueCollapseOne\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"col-md-12 no-pad-l-r\"><div class=\"row col-md-12 no-pad-l-r\"><div class=\"col-md-6\" ng-if=\"sxIssue.watchers.internal.length != 0\"><h5>Watcher interni:</h5></div><div class=\"col-md-6\" ng-if=\"sxIssue.watchers.external.length != 0\"><h5>Watcher esterni:</h5></div></div><div class=\"row col-md-12 no-pad-l-r\"><div class=\"col-md-6\" ng-if=\"sxIssue.watchers.internal.length != 0\"><div class=\"col-md-12 no-pad-l-r margin-col-l\" ng-repeat=\"w in sxIssue.watchers.internal track by $index\"><div class=\"col-md-11 no-pad-l-r\"><six-lookup ng-model=\"w\" sx-type=\"w.type\" sx-base-path=\"\'record\'\" sx-disabled=\"true\" sx-closable=\"false\"></six-lookup></div></div></div><div class=\"col-md-6\" ng-if=\"sxIssue.watchers.external.length != 0\"><div class=\"col-md-12 no-pad-l-r margin-col-l\" ng-repeat=\"w in sxIssue.watchers.external\"><div class=\"col-md-11 no-pad-l-r\"><input type=\"email\" class=\"form-control\" ng-model=\"w\" disabled=\"\"></div></div></div></div></div></div></div></div></div><div class=\"col-md-12 hr-margin\" ng-if=\"sxShowReferencesAssignee\"><div class=\"panel panel-default pnl-no-margin-t-b\" id=\"panel2\"><a data-toggle=\"collapse\" data-target=\"#issueCollapseTwo\"><div class=\"panel-heading\"><h5 class=\"override-margin-top-bottom\"><i class=\"pull-right fa ng-scope fa-angle-right\" ng-class=\"{\'fa-angle-down\': status.open, \'fa-angle-right\': !status.open}\"></i> Tecnici - Assegnatari</h5></div></a><div id=\"issueCollapseTwo\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"col-md-12 no-pad-l-r\"><div class=\"col-md-4 form-group\"><h5>Tecnico esterno</h5><div class=\"col-md-11 no-pad-l-r\"><six-lookup-2 sx-id=\"technicianexternal_id\" ng-model=\"sxIssue.references_assignee\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'technicianexternal_id\'\" sx-add=\"true\" sx-filter=\"technicianexternalIdFilter\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div></div><div class=\"col-md-4 form-group\"><h5>Segreteria</h5><div class=\"col-md-11 no-pad-l-r\"><six-lookup-2 sx-id=\"secretariat_id\" ng-model=\"sxIssue.references_assignee\" sx-type=\"\'segreteria\'\" sx-base-path=\"\'record\'\" sx-field=\"\'secretariat_id\'\"></six-lookup-2></div></div></div></div></div></div></div><div class=\"col-md-12 hr-margin\" ng-if=\"sxShowResponsableList && responsableList.length > 0\"><div class=\"panel panel-default pnl-no-margin-t-b\" id=\"panel3\"><a data-toggle=\"collapse\" data-target=\"#collapseThree\"><div class=\"panel-heading\"><h5 class=\"override-margin-top-bottom\"><i class=\"pull-right fa ng-scope fa-angle-right\" ng-class=\"{\'fa-angle-down\': status.open, \'fa-angle-right\': !status.open}\"></i> Contatti responsabili</h5></div></a><div id=\"collapseThree\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"col-md-12 no-pad-l-r\"><div class=\"row col-md-12 no-pad-l-r\" ng-repeat=\"r in responsableList\"><div class=\"col-md-4 form-group\"><input type=\"text\" class=\"form-control\" ng-model=\"r.name\" disabled=\"\"></div><div class=\"col-md-4 form-group\"><input type=\"text\" class=\"form-control\" ng-model=\"r.contacts\" disabled=\"\"></div></div></div></div></div></div></div><div class=\"col-md-12 no-pad-l-r\"><form name=\"detailForm\"><div class=\"row wrapper\"><div class=\"override-form-group override-checkbox\" sf-schema=\"sxSchema.schema\" sf-form=\"sxSchema.form\" sf-model=\"sxIssue.model\"></div></div></form></div><div ng-if=\"!(schemaIssueDefined)\"><div class=\"wrapper\"><div class=\"row\"><label class=\"control-label\">Schema non definito</label></div></div></div></uib-tab><uib-tab disable=\"!sxIssue.version\"><uib-tab-heading><span class=\"fa fa-book text-info-dker\"></span> Allegati</uib-tab-heading><six-tree-attachments nodes=\"attachments\" save-callback=\"updAttachments()\" sx-tag-filter=\"\'class=issue\'\"></six-tree-attachments></uib-tab><uib-tab index=\"3\" disable=\"!sxIssue.version\"><uib-tab-heading><span class=\"fa fa-qrcode text-info-dker\"></span> QRCODE</uib-tab-heading><qrcode version=\"5\" error-correction-level=\"H\" size=\"274\" data=\"{{sxIssue.UUID}}\"></qrcode></uib-tab><uib-tab index=\"4\" disable=\"!sxIssue.version\" select=\"notificationUuid = sxIssue.UUID\" deselect=\"notificationUuid = undefined\"><uib-tab-heading><span class=\"icon-bell text-info-dker\"></span> Notifiche</uib-tab-heading><ict-notifications ict-type=\"\'issue\'\" ict-uuid=\"notificationUuid\" ict-detail-view=\"sidebar\"></ict-notifications></uib-tab></uib-tabset></div>");
$templateCache.put("plan/estimate/estimate_detail.html","<style type=\"text/css\">\n  .errorclass {\n    color: red;\n  }\n  .requiredclass{\n    border: 1px solid red;\n  }\n  .newclass {\n    color: green;\n  }\n  .placehodlerclass {\n    color: #afafaf;\n  }\n  .cont-center{\n    text-align: center;\n  }\n  .cont-right{\n    text-align: right;\n  }\n  .cont-left{\n    text-align: left;\n  }\n  six-toolbar-item .invisible-check{\n    visibility: hidden;\n  }\n  .ui-grid-cell{\n    overflow: visible;\n  }\n</style><six-toolbar><six-toolbar-item label=\"Template righe preventivo\" icon=\"fa fa-download icon text-info-dker\" toolbar-function=\"schemaRowsDefinitionToXlsx()\"></six-toolbar-item><six-toolbar-item label-condition=\"(typeExport == \'exportToImport\')\" label=\"Esportazione (NORMALE)\" label-disabled=\"Esportazione (REIMPORTAZIONE)\" icon=\"fa fa-upload icon text-info-dker\"><li><a ng-click=\"setTypeExport(\'export\')\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': (typeExport == \'exportToImport\')}\"></i> Normale</a></li><li><a ng-click=\"setTypeExport(\'exportToImport\')\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': (typeExport == \'export\')}\"></i> Reimportazione</a></li></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" onclick=\"window.history.back()\"></six-toolbar-button><six-toolbar-button label=\"Esporta Excel\" icon=\"fa fa-file-excel-o\" btn-class=\"btn-success\" toolbar-function=\"exportXLSX()\" ng-hide=\"data.rows.length == 0\"></six-toolbar-button><six-toolbar-item label=\"Genera\" icon=\"fa fa-files-o icon text-info-dker\" ng-hide=\"!data.header.version || !editable\"><li><a ng-click=\"fullCopy()\"><i class=\"fa fa-clone\"></i> Clone</a></li><li><a ng-click=\"copyRows()\"><i class=\"fa fa-list\"></i> Copia righe</a></li><li ng-hide=\"!(data.header.model.type == \'supplier\')\"><a ng-click=\"promote()\"><i class=\"fa fa-files-o\"></i> Preventivo Cliente</a></li><li ng-show=\"data.header.model.status == \'revised\'\"><a ng-click=\"copyAsRevision()\"><i class=\"fa fa-code-fork\"></i> Revisione</a></li><li><a ng-click=\"generateConsumptive()\"><i class=\"fa fa-file-text-o\"></i> Consuntivo ODL</a></li></six-toolbar-item><six-toolbar-button label=\"Stampa\" icon=\"fa fa-print text-info-dker\" toolbar-function=\"printEstimate(\'pdf\')\" sx-disabled=\"!data.header.version\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"fa fa-trash\" toolbar-function=\"delete()\" ng-hide=\"!data.header.version\" ng-if=\"editable\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"save()\" btn-title=\"Save\" ng-if=\"editable\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default constructor\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"!data.header.version\">Nuovo preventivo</h1><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"data.header.version\">Preventivo <span class=\"m-l-xs\">{{data.header.model.code}}</span></h1></div></div></div><uib-tabset class=\"tabs-left\" style=\"padding: 15px\"><uib-tab index=\"0\"><uib-tab-heading><span class=\"fa fa-list-alt text-info-dker\"></span> Anagrafica</uib-tab-heading><div class=\"panel-body m-t-n\"><div class=\"row\"><div class=\"col col-md-12\"><form ng-if=\"modelLoaded\" name=\"detailForm\" sf-schema=\"schemaHeader.model.schema\" sf-form=\"schemaHeader.model.form\" sf-model=\"data.header.model\"></form></div></div><div class=\"row padder m-t-md\" ng-if=\"isPlafondEnabled\"><div class=\"col-lg-12 well\"><ict-plafond odl=\"data.header.model.odl_id\" on-plafond-change=\"plafondChange(plafond)\"></ict-plafond></div></div><div class=\"m-t-sm m-b-sm pull-right\" ng-if=\"editable\"><div class=\"inline m-r text-left stb-content\"><button class=\"btn btn-info btn-sm\" href=\"\" ng-click=\"data.header.model.auto_refresh_total = !data.header.model.auto_refresh_total\"><span class=\"fa fa-square-o\" ng-show=\"!data.header.model.auto_refresh_total\"></span> <span class=\"fa fa-check-square-o\" ng-show=\"data.header.model.auto_refresh_total\"></span> <span>Ricalcolo automatico tot.</span></button></div><button class=\"btn btn-sm btn-success\" ng-click=\"insertRow()\"><i class=\"fa fa-plus\"></i>Aggiungi riga</button></div><div ui-grid=\"gridOptions\" class=\"grid\" ui-grid-resize-columns=\"\" ui-grid-edit=\"\" ui-grid-row-edit=\"\" ui-grid-exporter=\"\" ui-grid-validate=\"\" style=\"margin-top: 70px\"><div class=\"grid-msg-overlay\" ng-show=\"!gridOptions.data.length &amp;&amp; editable\"><div class=\"msg\"><div class=\"center\"><span class=\"muted\">Selezionare File Excel</span><br><input type=\"file\" accept=\".xls,.xlsx,.ods\" xlsxreader=\"\" opts=\"gridOptions\" multiple=\"false\"></div></div></div></div><label><input type=\"checkbox\" ng-model=\"showDataArray\"> Mostra json</label><div ng-if=\"showDataArray\" class=\"col-md-12\"><b>Righe presenti nella griglia</b><div ng-repeat=\"row in data.rows\" style=\"padding-top: 10px; padding-bottom: 10px; height: 100px;\"><div class=\"col-md-1\">{{row.model.code}}</div><div class=\"col-md-2\">{{row.UUID}}</div><div class=\"col-md-9\">{{row}}</div></div><div ng-if=\"data.rows.length == 0\">array vuoto</div><br><b>Righe nuove da salvare</b><div ng-repeat=\"newRow in insertedList\" style=\"padding-top: 10px; padding-bottom: 10px;\"><div class=\"col-md-1\">{{newRow.model.code}}</div><div class=\"col-md-9 col-md-offset-2\">{{newRow}}</div></div><div ng-if=\"insertedList.length == 0\">array vuoto</div><br><b>Righe modificate da aggiornare</b><div ng-repeat=\"mod in modifiedList\" style=\"padding-top: 10px; padding-bottom: 10px;\"><div class=\"col-md-1\">{{mod.model.code}}</div><div class=\"col-md-2\">{{mod.UUID}}</div><div class=\"col-md-9\">{{mod}}</div></div><div ng-if=\"modifiedList.length == 0\">array vuoto</div><br><b>Righe da eliminare</b><div ng-repeat=\"del in deletedList\" style=\"padding-top: 10px; padding-bottom: 10px;\"><div class=\"col-md-1\">{{del.model.code}}</div><div class=\"col-md-2\">{{del.UUID}}</div><div class=\"col-md-9\">{{del}}</div></div><div ng-if=\"deletedList.length == 0\">array vuoto</div></div></div></uib-tab><uib-tab index=\"1\" disable=\"!data.header.version\"><uib-tab-heading><span class=\"fa fa-book text-info-dker\"></span> Allegati</uib-tab-heading><six-tree-attachments nodes=\"attachments\" save-callback=\"updAttachments()\" sx-readonly=\"!editable\" sx-tag-filter=\"\'class=estimate\'\"></six-tree-attachments></uib-tab></uib-tabset></div></div>");
$templateCache.put("plan/estimate/estimate_list.html","<style type=\"text/css\">\n  six-toolbar-item .invisible-check{\n    visibility: hidden;\n  }\n</style><six-toolbar><six-toolbar-item label-condition=\"findCross\" label=\"Commessa ({{currentCommission.code}})\" label-disabled=\"Commessa (TUTTE)\" icon=\"fa fa-money icon text-success-dker\"><li><a ng-click=\"setFindCross(false)\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': findCross}\"></i> Corrente ({{currentCommission.code}})</a></li><li><a ng-click=\"setFindCross(true)\"><i class=\"fa fa-check\" ng-class=\"{\'invisible-check\': !findCross}\"></i> Tutte</a></li></six-toolbar-item><six-toolbar-button label=\"Genera preventivo\" icon=\"fa fa-plus\" btn-class=\"btn-success\" toolbar-function=\"newEstimate()\"></six-toolbar-button><six-toolbar-button label=\"Prev. Fornitori\" icon=\"fa fa-square-o\" icon-disabled=\"fa fa-check-square-o\" icon-condition=\"bool.showSupplier\" toolbar-function=\"bool.showSupplier = !bool.showSupplier; getEstimateList();\"></six-toolbar-button><six-toolbar-button label=\"Prev. Clienti\" icon=\"fa fa-square-o\" icon-disabled=\"fa fa-check-square-o\" icon-condition=\"bool.showCustomer\" toolbar-function=\"bool.showCustomer = !bool.showCustomer; getEstimateList();\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"refresh()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista preventivi</h1></div></div></div><div class=\"panel-body\"><six-grid-pagination sx-id=\"estimate\" get-data-callback=\"getEstimateList()\" get-list-callback=\"getEstimateList()\" items-list=\"estimateList\" grid-options=\"viewGridOptions\" column-defs=\"viewGridOptions.columnDefs\" params=\"params\" auto-resize-params=\"autoResizeParams\" show-global-search=\"false\"></six-grid-pagination></div></div></div>");
$templateCache.put("plan/estimate/estimaterowconfigurator_detail.html","<six-toolbar><six-toolbar-button label=\"Lista\" icon=\"fa fa-chevron-left\" toolbar-function=\"back()\"></six-toolbar-button><six-toolbar-button label=\"Duplica\" btn-class=\"btn-primary\" icon=\"fa fa-files-o\" toolbar-function=\"setConfModel()\" ng-if=\"selected.version\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"fa fa-trash-o\" toolbar-function=\"delete()\" sx-disabled=\"!isDeletePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"saveForm()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Dettaglio Configurazione</h1></div></div></div><div class=\"wrapper\"><div class=\"panel-heading\" style=\"background-color: transparent\"><div class=\"page-header-bleed-right\"><div class=\"actions\"><div class=\"row\"><form name=\"header\"><div class=\"form-group\"><div class=\"col-md-12\"><label class=\"control-label\">Codice:</label> <input type=\"text\" class=\"form-control\" ng-model=\"commissionCode\" ng-disabled=\"bool.isCross || bool.isCallCenter\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"!bool.isCross && !bool.isCallCenter\"><label class=\"col-md-1 control-label\">Commesse:</label><div class=\"col-md-12\"><div id=\"vectors_budget_code\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"commissionsSelected.codes\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Selezionare una commessa...\">{{$item.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in commissions\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div></div><div class=\"col-md-12\"><input type=\"checkbox\" ng-model=\"bool.isCross\" name=\"cross_commission\" ng-click=\"updateCode()\"> <label class=\"control-label\">Imposta come configurazione di default per gli utenti (cross-commessa)</label></div><div class=\"col-md-12\"><input type=\"checkbox\" ng-model=\"bool.isCallCenter\" name=\"isCallCenter\" ng-click=\"setCallCenter()\"> <label class=\"control-label\">Imposta come configurazione del Call Center</label></div></div></form></div></div></div></div><div class=\"panel-body\"><uib-tabset justified=\"true\"><uib-tab heading=\"Preview\"><form name=\"myForm\" sf-schema=\"schema\" sf-form=\"form\" sf-model=\"model\" ng-submit=\"onSubmit(myForm)\"></form></uib-tab><uib-tab heading=\"Schema\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><div class=\"col-md-12 centered\"><b>SCHEMA</b></div><div class=\"col-md-12 override-padding-no-pad-left-right\"><hr class=\"override-margin-top-bottom\"></div><div class=\"col-md-12 centered\"><div class=\"col-md-2 col-md-offset-1\"><b>CODICE</b></div><div class=\"col-md-3\"><b>DESCRIZIONE</b></div><div class=\"col-md-1\"><b>TIPOLOGIA</b></div><div class=\"col-md-2\"><b>FORMATO</b></div></div><div class=\"col-md-12 override-padding-no-pad-left-right\"><hr class=\"override-margin-top-bottom\"></div><div class=\"col-md-12 centered\"><div class=\"col-md-2 col-md-offset-1\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><form name=\"propertyKeyForm\"><input class=\"form-control\" name=\"property_key\" placeholder=\"Codice...\" type=\"text\" ng-model=\"property.key\" pattern=\"^[a-zA-Z]+[\\w]*$\"><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"propertyKeyForm.property_key.$error.pattern\">Caratteri non consentiti</span></div></form></div></div><div class=\"col-md-3\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><input class=\"form-control\" placeholder=\"Descrizione\" type=\"text\" ng-model=\"property.title\"></div></div><div class=\"col-md-1\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><select class=\"form-control\" ng-model=\"property.type\"><option></option><option value=\"string\">string</option><option value=\"number\">number</option><option value=\"integer\">integer</option><option value=\"boolean\">boolean</option><option value=\"date\">date</option><option value=\"array\">array</option></select></div></div><div class=\"col-md-2\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><select class=\"form-control\" ng-model=\"property.format\" ng-if=\"(property.type == \'string\')\"><option></option><option value=\"lookup\">lookup</option><option value=\"formula\">formula</option><option value=\"enum\">enum</option></select><select class=\"form-control\" ng-model=\"property.format\" ng-if=\"(property.type == \'number\' || property.type == \'integer\')\"><option></option><option value=\"formula\">formula</option><option value=\"enum\">enum</option></select><select class=\"form-control\" ng-model=\"property.items_type\" ng-if=\"(property.type == \'array\')\"><option></option><option value=\"lookup\">lookup</option><option value=\"string\">string</option><option value=\"number\">number</option><option value=\"integer\">integer</option><option value=\"date\">date</option></select></div></div><div class=\"col-md-2\"><div ng-if=\"isInheritable(property.type)\"><label><input type=\"checkbox\" ng-model=\"property.inherited\"> Campo ereditato</label></div></div><div class=\"col-md-1\"><button ng-click=\"addProperty()\" class=\"btn btn-sm btn-info pull-right\"><span class=\"fa fa-plus\"></span> Add</button></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-repeat=\"(key, value) in selected.model.schema.properties\" style=\"align-content: center; padding-bottom: 0px;\"><div class=\"col-md-12 uniform-height\" style=\"align-content: center;\"><div class=\"col-md-1\"><a href=\"\" ng-click=\"status[key].open = !status[key].open\" id=\"btn_row_detail\"><i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status[key].open, \'glyphicon-chevron-right\': !status[key].open}\"></i></a></div><div class=\"col-md-2\">{{ key }}</div><div class=\"col-md-3\">{{ value.title }}</div><div class=\"col-md-1\">{{ value.type }}</div><div class=\"col-md-2\"><span ng-if=\"value.format\">{{value.format}}</span> <span ng-if=\"value.type == \'array\' && value.items\">{{value.items.format}}</span></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-show=\"status[key].open\"><div class=\"col-md-12 uniform-height-2\" ng-if=\"value.format !== \'lookup\' && value.format !== \'formula\' && value.format !== \'enum\' && value.format !== \'inherit\' && value.type !== \'array\'\"><div class=\"col-md-2\">FORMATO:</div><div class=\"col-md-10\">{{value.format}}</div></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'inherit\'\" ng-include=\"\'dataset/modeltype/detail_inherit.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'lookup\' && value.type != \'array\'\" ng-include=\"\'dataset/modeltype/detail_lookup.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'formula\'\" ng-include=\"\'dataset/modeltype/detail_formula.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'enum\'\" ng-include=\"\'dataset/modeltype/detail_enum.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.type === \'array\'\" ng-include=\"\'dataset/modeltype/detail_array.html\'\"></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">ELIMINA:</div><div class=\"col-md-10\"><button ng-click=\"deleteProperty(key)\" class=\"btn btn-danger btn-xs btn-default\" ng-disabled=\"disableDeleteColumn(key)\"><i class=\"fa fa-trash\"></i></button></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">IN TABELLA:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.check\" ng-change=\"changeColumnDefs(key, value)\" ng-disabled=\"disableInTableColumn(key)\"></div></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-show=\"value.check == true\"><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">LARGHEZZA (px):</div><div class=\"col-md-10\"><input type=\"text\" min=\"1\" step=\"1\" size=\"45\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=\"value.width\" ng-change=\"changeColumnDefs(key, value)\"></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">ORDINAMENTO:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.enableSorting\" ng-change=\"changeColumnDefs(key, value)\"></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">FILTRAGGIO:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.enableFiltering\" ng-change=\"changeColumnDefs(key, value)\"></div></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div></div></div></div></uib-tab><uib-tab heading=\"Form\"><table class=\"table table-striped\"><thead><th colspan=\"5\">FORM</th><tr><th colspan=\"5\"><div class=\"form-group\"><label for=\"title\" class=\"control-label\">Titolo</label><div class=\"\"><input type=\"text\" class=\"form-control\" id=\"title\" placeholder=\"\" ng-model=\"title\" name=\"title\" ng-keyup=\"refreshTitleForm(title)\"></div></div></th></tr><tr><td></td><td></td><td><input type=\"text\" placeholder=\"Titolo...\" ng-model=\"newTab.title\"></td><td><button ng-click=\"addTab(selected.model.form[0].items[0])\" class=\"btn btn-xs btn-info\"><span class=\"fa fa-plus\"></span> Add</button></td></tr><tr><th></th><th>POSIZIONE</th><th>TITOLO</th><th></th></tr></thead><tbody><tr ng-repeat-start=\"(key, tab) in selected.model.form[0].items[0].tabs\"><td><a href=\"\" ng-click=\"statusForm[key].open = !statusForm[key].open\"><i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': statusForm[key].open, \'glyphicon-chevron-right\': !statusForm[key].open}\"></i></a></td><td><span class=\"btn btn-sm\" ng-click=\"swapUp(key, selected.model.form[0].items[0].tabs)\" ng-disabled=\"key<=0\"><i class=\"fa fa-caret-up\"></i></span> {{key+1}} <span class=\"btn btn-sm\" ng-click=\"swapDown(key, selected.model.form[0].items[0].tabs)\" ng-disabled=\"key>=selected.model.form[0].items[0].tabs.length-1\"><i class=\"fa fa-caret-down\"></i></span></td><td><input type=\"text\" ng-model=\"tab.title\" ng-disabled=\"(tab.key[0] == \'code\' || tab.key[0] == \'description\')\" ng-keyup=\"updateScope()\"></td><td><a ng-click=\"removeTabOrField(key, selected.model.form[0].items[0].tabs)\" class=\"btn btn-danger btn-xs btn-default\" id=\"btn_row_detail_form\"><i class=\"fa fa-trash\"></i></a></td></tr><tr ng-repeat-end=\"\" ng-show=\"statusForm[key].open\"><td></td><td colspan=\"3\" style=\"background-color:rgba(211, 211, 211, 0.38);\"><table class=\"table table-striped override-margin\"><tr><td></td><td><select ng-options=\"k as v.title for (k, v) in schema.properties\" ng-model=\"newFieldForm.key\"></select></td><td><input type=\"text\" placeholder=\"Titolo...\" ng-model=\"newFieldForm.title\"></td><td><input type=\"checkbox\" placeholder=\"Richiesto...\" ng-model=\"newFieldForm.required\"></td><td><input type=\"checkbox\" placeholder=\"Nascosto...\" ng-model=\"newFieldForm.htmlClass\" ng-true-value=\"\'hidden\'\" ng-false-value=\"\'\'\"></td><td><select ng-model=\"newFieldForm.type\" ng-change=\"updateScope()\"><option value=\"\"></option><option value=\"text\">text</option><option value=\"textarea\">textarea</option><option value=\"number\">number</option><option value=\"datepicker\">date</option><option value=\"password\">password</option><option value=\"checkbox\">checkbox</option><option value=\"select\">enum</option><option value=\"array\">array</option><option value=\"sixlookup\">lookup</option><option value=\"inherited\">ereditato</option><option value=\"formula\">formula</option></select></td><td><button ng-click=\"addFieldToTab(tab)\" class=\"btn btn-xs btn-info\"><span class=\"fa fa-plus\"></span> Add</button></td></tr><tr><th>POSIZIONE</th><th>CAMPO</th><th>TITOLO</th><th>REQUIRED</th><th>NASCOSTO</th><th>TIPO</th><th></th></tr><tr ng-repeat=\"(fieldKey, field) in tab.items\"><td class=\"override-width-200px\"><div><span class=\"btn btn-sm\" ng-click=\"swapUp(fieldKey, tab.items)\" ng-disabled=\"fieldKey<=0\"><i class=\"fa fa-caret-up\"></i></span> {{fieldKey+1}} <span class=\"btn btn-sm\" ng-click=\"swapDown(fieldKey, tab.items)\" ng-disabled=\"fieldKey>=tab.items.length-1\"><i class=\"fa fa-caret-down\"></i></span></div></td><td ng-if=\"!field.title\">{{field}}</td><td ng-if=\"!field.title\"></td><td ng-if=\"!field.title\"></td><td ng-if=\"!field.title\"></td><td ng-if=\"field.title\">{{field.key[0]}}</td><td ng-if=\"field.title\"><input type=\"text\" ng-model=\"field.title\" ng-keyup=\"updateScope()\"></td><td ng-if=\"field.title\"><input type=\"checkbox\" ng-model=\"field.required\" ng-change=\"updateScope()\"></td><td ng-if=\"field.title\"><input type=\"checkbox\" ng-model=\"field.htmlClass\" ng-change=\"updateScope()\" ng-true-value=\"\'hidden\'\" ng-false-value=\"\'\'\"></td><td ng-if=\"field.title\"><select ng-model=\"field.type\" ng-change=\"updateField(field)\"><option value=\"\"></option><option value=\"text\">text</option><option value=\"textarea\">textarea</option><option value=\"number\">number</option><option value=\"datepicker\">date</option><option value=\"password\">password</option><option value=\"checkbox\">checkbox</option><option value=\"select\">enum</option><option value=\"array\">array</option><option value=\"sixlookup\">lookup</option><option value=\"inherited\">ereditato</option><option value=\"formula\">formula</option></select></td><td><a ng-click=\"removeTabOrField(fieldKey, tab.items)\" class=\"btn btn-danger btn-xs btn-default\"><i class=\"fa fa-trash\"></i></a></td></tr></table></td></tr></tbody></table></uib-tab></uib-tabset></div><div class=\"panel-footer\"><div class=\"form-group\"><input id=\"jsonShowCheck\" type=\"checkbox\" ng-model=\"jsonshow\" class=\"pull-left\" data-toggle=\"collapse\" data-target=\"#json-collapse\"> <label for=\"jsonShowCheck\" class=\"pull-left control-label\">Dettaglio avanzato</label></div></div><div class=\"row collapse\" id=\"json-collapse\" collapse=\"!jsonshow\"><div class=\"col-md-8\"><div class=\"panel no-border\"><div class=\"panel-heading wrapper b-b b-light\"><h4 class=\"font-thin m-t-none m-b-none text-muted\">Dettaglio</h4></div><div style=\"margin-top:0px;\" ui-ace=\"{ useWrapMode : true, showGutter: true, mode: \'json\', firstLineNumber: 1, onLoad: aceLoaded, onChange: aceChanged }\" ng-model=\"aceModel\"></div></div></div><div class=\"col-md-4\"><div class=\"list-group list-group-lg list-group-sp\"><pre>{{ model}}</pre></div></div></div></div></div></div>");
$templateCache.put("plan/estimate/estimaterowconfigurator_list.html","<six-toolbar><six-toolbar-button label=\"Crea conf.\" icon=\"fa fa-plus\" toolbar-function=\"newEstimateRowConfiguration()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"refresh()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista configurazioni righe preventivi</h1></div></div></div><div class=\"panel-body\"><div class=\"form-group\"><input ng-keyup=\"getData(queryParam)\" class=\"form-control\" type=\"text\" ng-model=\"queryParam\" placeholder=\"Type here to filter the list...\"></div><table id=\"estimate_configurator_list\" class=\"table table-striped\"><thead><tr><th></th><th>CODICE CONFIGURAZIONE</th><th>COMMESSA</th><th>DATA</th></tr></thead><tbody><tr ng-repeat=\"item in estimateRowConfiguratorList.list\"><td><a ng-href=\"#/estimateconfigurator/row/{{item.UUID}}\" class=\"btn btn-default\" id=\"btn_issue_detail\"><span class=\"fa fa-search\"></span></a></td><td>{{ item.model.code }}</td><td>{{printCommission(item.model.commission)}}</td><td>{{ item.dataIn | date:\'dd/MM/yyyy\' }}</td></tr><tr ng-hide=\"estimateRowConfiguratorList.list.length\"><td><p class=\"text-center\">Nessun record recuperato</p></td></tr></tbody></table></div><div class=\"panel-footer\"><div class=\"row text-center\"><uib-pagination ng-change=\"pageChanged()\" boundary-links=\"true\" total-items=\"estimateRowConfiguratorList.totalResults\" ng-model=\"estimateRowConfiguratorList.currentPage\" class=\"pagination-sm\" items-per-page=\"estimateRowConfiguratorList.pageSize\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></uib-pagination></div></div></div></div>");
$templateCache.put("plan/invoice/invoice_detail.html","<style type=\"text/css\">\n  .tab-pane {\n    position: relative;\n    overflow: hidden;\n  }\n\n  .odl-panel {\n    position: absolute;\n    top: -480px;\n    z-index: 900;\n    width: 100%;\n    -webkit-transition: top 0.5s;\n    transition: top 0.5s;\n  }\n\n  .odl-panel.active {\n    top: 0px;\n  }\n\n</style><six-toolbar><six-toolbar-item ng-if=\"isLocked()\" label=\"Fattura in elaborazione\" icon=\"fa fa-warning\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" onclick=\"window.history.back()\"></six-toolbar-button><six-toolbar-button label=\"Rigenera righe\" btn-class=\"btn-default\" icon=\"fa fa-refresh\" toolbar-function=\"manualRowGeneration()\" ng-hide=\"!header.version\" ng-if=\"isWritePermAllowed()\" sx-disabled=\"!toBeApproved() || isLocked()\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"fa fa-trash\" toolbar-function=\"delete()\" ng-hide=\"!header.version\" ng-if=\"isDeletePermAllowed()\" sx-disabled=\"!toBeApproved() || isLocked()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"saveAndBack()\" ng-if=\"isUpdatePermAllowed()\" sx-disabled=\"!toBeApproved() || isLocked()\"></six-toolbar-button><six-toolbar-button label=\"Salva e genera righe\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"saveAndGenerate()\" ng-if=\"(isNew || !invoiceHasRows()) && !isLocked() && isWritePermAllowed()\" sx-disabled=\"!toBeApproved()\"></six-toolbar-button><six-toolbar-button label=\"Scarica\" icon=\"fa fa-print text-info-dker\" toolbar-function=\"download()\" sx-disabled=\"!header.version || !invoiceHasRows() || isLocked()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default constructor\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"!header.version\">Nuova fattura</h1><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"header.version\">Fattura <span class=\"m-l-xs\">{{header.model.code}}</span></h1></div><div class=\"col-sm-6 col-xs-12 text-right\"><span class=\"btn btn-bg btn-default font-bold m-r\" style=\"pointer-events: none;\" ng-if=\"!toBeApproved()\"><span ng-if=\"header.model.status === false\">Rifiutata</span> <span ng-if=\"header.model.status === true\">Accettata</span></span> <span class=\"btn btn-bg btn-default font-bold m-r\" ng-if=\"!toBeApproved()\" title=\"Modifica stato\" ng-click=\"header.model.status = undefined\"><i class=\"fa fa-close\"></i></span> <span ng-if=\"approvationAllowed() && !isNew && invoiceHasRows() && !isLocked() && toBeApproved()\"><a href=\"\" class=\"btn btn-sm btn-success m-r-xs\" ng-click=\"approveInvoice()\"><i class=\"fa fa-check\"></i> Approva</a> <a href=\"\" class=\"btn btn-sm btn-danger\" ng-click=\"refuseInvoice()\"><i class=\"fa fa-close\"></i> Rifiuta</a></span></div></div></div><uib-tabset class=\"tabs-left\" style=\"padding: 15px\"><uib-tab index=\"0\" select=\"mainTab = !mainTab\" deselect=\"mainTab = !mainTab\"><uib-tab-heading><span class=\"fa fa-cog text-info-dker\"></span> Dati</uib-tab-heading><div class=\"panel-body no-padder\"><form name=\"form.header\"><div class=\"row\"><div class=\"col-md-4 form-group\"><label class=\"control-label\">Tipo periodo:</label><six-select-2 sx-id=\"period_type\" sx-list=\"periodTypeList\" sx-title=\"\'Tipo periodo\'\" ng-model=\"periodType\" sx-field=\"\'selected\'\" sx-compact=\"true\" sx-clearable=\"false\" sx-item-template=\"\'{{item.description}}\'\" sx-disabled=\"invoiceHasRows() || isLocked()\"></six-select-2></div><div class=\"col-md-4 form-group\"><div class=\"control-group\" ng-class=\"{\'has-error\': form.header.datePickerFrom.$invalid}\"><label class=\"control-label\">Periodo da:</label><six-date-time-picker name=\"datePickerFrom\" ng-model=\"datePicker.from\" date-options=\"dateOptionsFrom\" format=\"dateFormat\" ng-required=\"true\" enable-time=\"false\" date-validation=\"\" is-before=\"{{datePicker.to}}\" sx-disabled=\"invoiceHasRows() || isLocked()\"></six-date-time-picker><span ng-messages=\"form.header.datePickerFrom.$error\" class=\"error alert-b-r\" role=\"alert\"><span ng-message=\"date\">Data non valida</span> <span ng-message=\"temporal\">Intervallo non valido</span> <span ng-message=\"required\">Obbligatorio</span></span></div></div><div class=\"col-md-4 form-group\"><div class=\"control-group\" ng-class=\"{\'has-error\': form.header.datePickerTo.$invalid}\"><label class=\"control-label\">Periodo a:</label><six-date-time-picker name=\"datePickerTo\" ng-model=\"datePicker.to\" date-options=\"dateOptionsTo\" format=\"dateFormat\" sx-disabled=\"invoiceHasRows() || isLocked() || periodType.selected.key!=\'custom\'\" ng-required=\"true\" enable-time=\"false\" date-validation=\"\" is-after=\"{{datePicker.from}}\"></six-date-time-picker><span ng-messages=\"form.header.datePickerTo.$error\" class=\"error alert-b-r\" role=\"alert\"><span ng-message=\"date\">Data non valida</span> <span ng-message=\"temporal\">Intervallo non valido</span> <span ng-message=\"required\">Obbligatorio</span></span></div></div></div><div class=\"row\"><div class=\"col-md-3 form-group\"><label class=\"control-label\">Tipologia:</label><ui-select ng-model=\"header.model.invoiceType\" class=\"m-b-xxs\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"true\" ng-disabled=\"invoiceHasRows() || isLocked()\"><ui-select-match class=\"ui-select-match\" placeholder=\"Seleziona...\">{{$select.selected.value}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item.key as (key, item) in invoiceTypes\"><div ng-bind-html=\"item.value | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Azienda:</label><six-lookup-2 sx-id=\"azienda\" sx-base-path=\"\'record\'\" sx-type=\"\'azienda\'\" ng-model=\"header.model\" sx-field=\"\'company_id\'\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-disabled=\"invoiceHasRows() || isLocked()\"></six-lookup-2></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Servizio:</label><six-lookup-2 sx-id=\"servizio\" sx-base-path=\"\'record\'\" sx-type=\"\'servizio\'\" ng-model=\"header.model\" sx-field=\"\'service_id\'\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-disabled=\"invoiceHasRows() || isLocked()\"></six-lookup-2></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">ODL:</label> <a class=\"btn btn-bg btn-default btn-block\" ng-click=\"odlPanel.open = true\" ng-disabled=\"invoiceHasRows() || isLocked()\"><i class=\"fa fa-search\"></i> ODL <b class=\"badge bg-info\">{{header.model.odl_id.length}}</b></a></div></div><invoice-odl-panel invoice-exclusions=\"header.UUID\" odl-refs=\"header.model.odl_id\" open=\"odlPanel.open\" on-close=\"odlPanelClosed(selection)\"></invoice-odl-panel><div class=\"row\"><div class=\"col-md-12 text-small padder-v\" ng-if=\"invoiceHasRows()\">I campi sovrastanti influiscono sulla generazione delle righe. Per modificarli devi prima <a ng-click=\"deleteDetailRows()\" class=\"text-danger-dker\">eliminare</a> le righe presenti.</div></div></form></div><div class=\"panel-body\"><form ng-if=\"modelLoaded\" name=\"detailForm\" sf-schema=\"schemaHeader.model.schema\" sf-form=\"schemaHeader.model.form\" sf-model=\"header.model\" style=\"position: relative\"></form></div><div class=\"panel-body\"><div ng-if=\"mainTab\" ui-grid=\"aggregatedRowsGridOptions\" class=\"grid\" grid-app-callbacks=\"gridAppCallbacks\" ui-grid-resize-columns=\"\" ui-grid-exporter=\"\" ui-grid-validate=\"\" ui-grid-edit=\"\" ui-grid-row-edit=\"\" ui-grid-pinning=\"\" ui-grid-move-columns=\"\" ui-grid-cellnav=\"\"></div></div><div class=\"panel-body m-b\"><a class=\"btn btn-sm btn-success pull-left\" ng-click=\"insertRow(\'aggregatedRowsGridOptions\', \'manualRowEdits\', \'manual\')\" ng-disabled=\"!header.version\" ng-if=\"manualRowsAllowed()\"><i class=\"fa fa-plus\"></i> Inserisci riga extra</a></div></uib-tab><uib-tab index=\"2\" disable=\"!header.version\"><uib-tab-heading><span class=\"fa fa-book text-info-dker\"></span> Allegati</uib-tab-heading><six-tree-attachments nodes=\"attachments\" save-callback=\"updAttachments()\" sx-readonly=\"!editable\" sx-tag-filter=\"\'class=invoice\'\"></six-tree-attachments></uib-tab><uib-tab index=\"3\" disable=\"!header.version\" select=\"rowTab = !rowTab\" deselect=\"rowTab = !rowTab\"><uib-tab-heading><span class=\"fa fa-bars text-info-dker\"></span> Dettaglio Righe</uib-tab-heading><div ng-if=\"rowTab\" ui-grid=\"rowsGridOptions\" class=\"grid\" grid-app-callbacks=\"gridAppCallbacks\" ui-grid-resize-columns=\"\" ui-grid-exporter=\"\" ui-grid-validate=\"\" ui-grid-edit=\"\" ui-grid-row-edit=\"\" ui-grid-pinning=\"\" ui-grid-move-columns=\"\" ui-grid-cellnav=\"\"></div><div class=\"row padder-v\"><div class=\"col-md-12\"><a class=\"btn btn-sm btn-success pull-left\" ng-click=\"insertRow(\'rowsGridOptions\', \'rowOverrides\', null, \'invoicerow\')\" ng-disabled=\"!header.version\" ng-if=\"isRowOverrideAllowed()\"><i class=\"fa fa-plus\"></i> Inserisci riga</a> <a class=\"btn btn-default pull-right\" ng-click=\"download(\'rows\')\" ng-disabled=\"!header.version || rowsGridOptions.data.length == 0\"><i class=\"fa fa-print\"></i> Scarica dettaglio righe</a></div></div></uib-tab><uib-tab index=\"4\" disable=\"!header.version\" select=\"assetTab = !assetTab\" deselect=\"assetTab = !assetTab\"><uib-tab-heading><span class=\"fa fa-sitemap text-info-dker\"></span> Assets coinvolti</uib-tab-heading><div ng-if=\"assetTab\" ui-grid=\"assetsGridOptions\" class=\"grid\" grid-app-callbacks=\"gridAppCallbacks\" ui-grid-resize-columns=\"\" ui-grid-exporter=\"\" ui-grid-validate=\"\"></div></uib-tab></uib-tabset></div></div>");
$templateCache.put("plan/invoice/invoice_diff.html","<style>\n  .de-emphasize {\n    opacity: 0.8;\n  }\n  .diff-highlight {\n    padding: 5px 10px 10px;\n    margin: 5px -10px 0px;\n    border: 1px solid #89b189;\n    border-radius: 4px;\n  }\n  .diff-highlight, .diff-highlight > * {\n    background-color: #f3fdf4;\n  }\n  .ui-grid-row .ui-grid-cell.grid-diff-highlight.col-pos-first, .ui-grid-row .ui-grid-cell.grid-miss-highlight.miss-second {\n    background-color: #e6fbe5;\n  }\n  .ui-grid-row .ui-grid-cell.grid-diff-highlight.col-pos-second, .ui-grid-row .ui-grid-cell.grid-miss-highlight.miss-first {\n    background-color: #dde8ec;\n  }\n\n  .ui-grid-row:nth-child(even) .ui-grid-cell.grid-diff-highlight.col-pos-first, .ui-grid-row:nth-child(even) .ui-grid-cell.grid-miss-highlight.miss-second {\n    background-color: #ceefcd;\n  }\n  .ui-grid-row:nth-child(even) .ui-grid-cell.grid-diff-highlight.col-pos-second, .ui-grid-row:nth-child(even) .ui-grid-cell.grid-miss-highlight.miss-first {\n    background-color: #c1d5dc;\n  }\n</style><six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" toolbar-function=\"back()\"></six-toolbar-button><six-toolbar-button label=\"Versione sinistra\" btn-class=\"btn-primary\" icon=\"fa fa-search\" toolbar-function=\"gotoLeftVersion()\"></six-toolbar-button><six-toolbar-button label=\"Scambia\" btn-class=\"btn-primary\" icon=\"fa fa-arrows-h\" toolbar-function=\"invertVersions()\"></six-toolbar-button><six-toolbar-button label=\"Versione destra\" btn-class=\"btn-primary\" icon=\"fa fa-search\" toolbar-function=\"gotoRightVersion()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"row wrapper\"><div class=\"col-md-12\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-xs-12\"><h1 class=\"m-n font-thin h4 text-black\">Dati Fatturazione</h1></div></div></div><div class=\"panel-body\"><div class=\"col-md-4 form-group\"><label class=\"control-label\">Azienda</label> <input class=\"form-control\" type=\"text\" disabled=\"\" ng-value=\"leftVersion.model.company_id.code + \' - \' + leftVersion.model.company_id.description\"></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Servizio</label> <input class=\"form-control\" type=\"text\" disabled=\"\" ng-value=\"leftVersion.model.service_id.code + \' - \' + leftVersion.model.service_id.description\"></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Tipologia</label> <input class=\"form-control\" type=\"text\" disabled=\"\" ng-value=\"leftVersion.model.invoiceType\"></div></div></div></div><div class=\"col-md-6\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-xs-12\"><h1 class=\"m-n font-thin h4 text-black\">{{leftVersion.model.code}} - {{leftVersion.model.description}}<br>(dal {{leftVersion.model.from | date:\'d/M/yyyy\'}} al {{leftVersion.model.to | date:\'d/M/yyyy\'}})</h1></div></div></div><div class=\"panel-body\"><div sf-schema=\"schema\" sf-form=\"form\" sf-model=\"leftVersion.model\"></div></div></div></div><div class=\"col-md-6\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-xs-12\"><h1 class=\"m-n font-thin h4 text-black\">{{rightVersion.model.code}} - {{rightVersion.model.description}}<br>(dal {{rightVersion.model.from | date:\'d/M/yyyy\'}} al {{rightVersion.model.to | date:\'d/M/yyyy\'}})</h1></div></div></div><div class=\"panel-body\"><div sf-schema=\"schema\" sf-form=\"form\" sf-model=\"rightVersion.model\" disabled=\"true\"></div></div></div></div><div class=\"col-md-12\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-xs-12\"><h1 class=\"m-n font-thin h4 text-black\">Dettaglio righe</h1></div></div></div><div class=\"panel-body\"><div ui-grid=\"gridOptions\" class=\"grid\" grid-app-callbacks=\"gridAppCallbacks\" ui-grid-resize-columns=\"\" ui-grid-exporter=\"\" ui-grid-validate=\"\"></div></div></div></div></div></div>");
$templateCache.put("plan/invoice/invoice_list.html","<six-toolbar><six-toolbar-item label=\"Ultima data fatturata\" icon=\"fa fa-money\"><li><a ng-click=\"getLatestDate(\'approved\')\">Solo approvate</a></li><li><a ng-click=\"getLatestDate(\'refused\')\">Solo rifiutate</a></li><li><a ng-click=\"getLatestDate([\'approved\', \'refused\'])\">Rifiutate o approvate</a></li><li><a ng-click=\"getLatestDate()\">Qualsiasi tipo</a></li></six-toolbar-item><six-toolbar-button icon=\"fa fa-plus\" label=\"Confronta selezionate\" btn-class=\"btn-info\" toolbar-function=\"diffSelected()\" sx-disabled=\"!canDiff()\" title=\"{{noDiffReason}}\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-plus\" label=\"Nuova fattura\" btn-class=\"btn-info\" toolbar-function=\"goToNewInvoice()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista Fatture</h1></div></div></div><div class=\"panel-body\"><six-grid-pagination get-data-callback=\"getData()\" get-list-callback=\"getData()\" items-list=\"invoiceList\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" grid-app-callbacks=\"gridAppCallbacks\" params=\"params\" auto-resize-params=\"autoResizeParams\"></six-grid-pagination></div></div></div>");
$templateCache.put("plan/invoice/invoiceconfigurator_detail.html","<style type=\"text/css\" xmlns=\"http://www.w3.org/1999/html\">\n  #timelineRow {\n    height:26px;\n    line-height:26px;\n  }\n  .floating-btn {\n    z-index: 9999999;\n    right: 0;\n    top: 150px;\n    bottom: auto;\n    padding: 0;\n    margin: 0;\n    opacity: 0.5;\n  }\n  .floating-btn a {\n    color: #58666e;\n    background-color: #23b7e5;\n    border-radius: 10px 0px 0px 10px;\n  }\n  .floating-btn.active {\n    visibility: hidden;\n  }\n  .floating-btn .mfb-component__button--main {\n    width: 26px;\n  }\n  .floating-btn:hover {\n    opacity: 1;\n  }\n</style><six-toolbar><six-toolbar-item icon=\"fa fa-exclamation-triangle text-danger-dker\" label-class=\"bg-warning text-dark-dker\" label=\"Stai visualizzando una vecchia versione\" ng-show=\"isPastVersion()\"></six-toolbar-item><six-toolbar-button label=\"Lista\" icon=\"fa fa-chevron-left\" toolbar-function=\"back()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"saveForm()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button></six-toolbar><nav class=\"floating-btn\" ng-class=\"{\'active\': timelineFlags.showTimeline}\" mfb-menu=\"\" position=\"br\" effect=\"zoomin\" label=\"Timeline\" active-icon=\"fa {{timelineFlags.showTimeline?\'fa-chevron-right\':\'fa-chevron-left\'}}\" resting-icon=\"fa fa-history\" toggling-method=\"hover\" ng-click=\"timelineFlags.showTimeline=!timelineFlags.showTimeline\"></nav><six-sidebar sx-id=\"timeline_sidebar\" sx-position=\"right\" sx-title=\"\'Timeline\'\" sx-dimension=\"xxl\" sx-opened=\"timelineFlags.showTimeline\" sx-pinned=\"true\"><div class=\"col-md-12 col-sm-12\" id=\"timelineRow\"><input type=\"date\" ng-model=\"date.currentDate\" ng-change=\"changeCurrentDate(date.currentDate)\" class=\"form-control input-sm bg-light no-border rounded padder\"></div><div class=\"clearfix\"></div><div ng-controller=\"InvoiceTimelineCtrl\" ng-init=\"buildTimeline(\'configuration\', UUID, invoiceConfig.version)\" id=\"timeline_section\"><div class=\"wrapper\"><ul class=\"timeline timeline-center\"><li class=\"tl-header\"><div class=\"btn btn-sm btn-default btn-rounded\">FINE</div></li><li ng-repeat=\"item in timeline\" class=\"tl-item\" ng-class-odd=\"\'tl-left\'\"><div class=\"tl-wrap\" ng-class=\"{\'b-success\': (invoiceConfig.version == item.version)}\"><span class=\"tl-date\">{{item.dataIn | date : format : timezone}}<br></span> <span class=\"tl-date-2\" ng-if=\"isWriteVersionAllowed()\">{{item.dataIn | date: \'dd/MM/yyyy HH:mm:ss\'}} <i class=\"tl-icon fa fa-caret-up fa-xs\"></i><br><span ng-if=\"item.dataOut\">{{item.dataOut | date: \'dd/MM/yyyy HH:mm:ss\'}}</span><span ng-if=\"!item.dataOut\"><i class=\"fa fa-ban fa-xs\"></i></span> <i class=\"tl-icon fa fa-caret-down fa-xs\"></i><div ng-if=\"isWriteVersionAllowed() && invoiceConfig.version == item.version\"><a class=\"btn btn-xs btn-success\" ng-click=\"saveForm(true)\" title=\"Sovrascrivi versione\"><i class=\"fa fa-save\"></i></a> <a class=\"btn btn-xs btn-danger\" ng-click=\"openDeleteVersionDialog()\" title=\"Elimina versione\"><i class=\"fa fa-trash\"></i></a></div></span><div class=\"tl-content panel padder b-a\" ng-class=\"{\'bg-success\': (invoiceConfig.version == item.version)}\"><span class=\"arrow left pull-up hidden-left\" ng-class=\"{\'arrow-success\': (invoiceConfig.version == item.version)}\"></span> <span class=\"arrow right pull-up visible-left\" ng-class=\"{\'arrow-success\': (invoiceConfig.version == item.version)}\"></span> <a class=\"text-lt m-b-sm\" ng-click=\"getConfigurationById(item.UUID, item.version)\">{{item.model.code}}</a><div class=\"panel-body pull-in b-t b-light\"><span class=\"pull-right label\" ng-class=\"{\'bg-success\': (invoiceConfig.version == item.version), \'bg-info\': (invoiceConfig.version != item.version)}\">{{item.user}}</span></div><div class=\"panel-body pull-in b-t b-light\">{{item.model.description}}</div><div class=\"panel-body pull-in b-t b-light\" ng-if=\"isWriteVersionAllowed()\">Version: {{item.version}}</div></div></div></li><li class=\"tl-header\"><div class=\"btn btn-sm btn-default btn-rounded\">INIZIO</div></li></ul></div></div></six-sidebar><script type=\"text/ng-template\" id=\"recordDelete.html\"><strong><span class=\"ngdialog-icon\"></span></strong> <div style=\"text-align: center;\"><h4 class=\"m-t-none m-b font-bold\">ATTENZIONE</h4></div> <div class=\"row m-t m-l m-r\"> <table align=\"center\" style=\"text-align: left; width: 100%\"> <caption style=\"text-align: center; font-weight: bold\" ng-if=\"lang!=\'html\'\">{{deleteMessage}}</caption> <caption style=\"text-align: center; font-weight: bold\" ng-if=\"lang==\'html\'\" ng-bind-html=\"deleteMessage\"></caption> <tr> <td style=\"text-align: center;\"> <button type=\"button\" class=\"btn btn-default\" ng-click=\"deleteFunction()\">Si</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"notDeleteFunction()\">No</button> </td> </tr> </table> </div></script><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Dettaglio Configurazione</h1></div></div></div><div class=\"wrapper\"><div class=\"panel-heading\" style=\"background-color: transparent\"><div class=\"page-header-bleed-right\"><div class=\"actions\"><div class=\"row\"><form name=\"header\"><div class=\"form-group\"><div class=\"col-md-12\" ng-if=\"isWriteVersionAllowed() && isPastVersion()\"><div class=\"alert alert-warning\" role=\"alert\">N.B. Le lookup recuperano gli asset validi alla data corrente ({{now | date: \'dd/MM/yyyy\'}}): PRESTARE ATTENZIONE AL SALVATAGGIO DI VECCHIE VERSIONI</div></div><div class=\"col-sm-6 col-md-6\"><label>Inizio validità:</label><six-date-time-picker name=\"dataIn\" sx-disabled=\"isWriteVersionAllowed()==false || bool.isNew\" format=\"\'dd/MM/yyyy HH:mm:ss\'\" ng-model=\"invoiceConfig.dataIn\"></six-date-time-picker></div><div class=\"col-sm-6 col-md-6\"><label>Fine validità:</label><six-date-time-picker name=\"dataOut\" sx-disabled=\"isWriteVersionAllowed()==false || bool.isNew\" format=\"\'dd/MM/yyyy HH:mm:ss\'\" ng-model=\"invoiceConfig.dataOut\"></six-date-time-picker></div><div class=\"col-md-6 override-padding-no-pad-left-right\" ng-if=\"!bool.isDefault\"><label class=\"col-md-12 control-label\">Commessa:</label><div class=\"col-md-12\"><div class=\"input-group has-button\" style=\"width: 100%\"><ui-select ng-model=\"commission.selected\" theme=\"bootstrap\" on-select=\"setCommission($item)\"><ui-select-match class=\"ui-select-match\" placeholder=\"Selezionare una commessa...\">{{commission.selected.code}} - {{commission.selected.description}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in commissions\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div></div><div class=\"col-md-6\"><label class=\"control-label\">Codice:</label> <input type=\"text\" class=\"form-control\" ng-model=\"invoiceConfig.model.code\" disabled=\"disabled\"></div><div class=\"col-md-12\"><label class=\"checkbox i-checks m-b inline\"><input id=\"check-1\" type=\"checkbox\" ng-model=\"bool.isDefault\" name=\"cross_commission\"><i></i> <span class=\"i-checks\">Imposta come configurazione di default per gli utenti (cross-commessa)</span></label></div></div></form></div></div></div></div><div class=\"panel-body\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-sm\"><div class=\"row\"><div class=\"col-xs-12\"><h4 class=\"m-n font-thin text-black\">Configurazione listini</h4></div></div></div><div class=\"panel-body m-b m-t no-padder\"><p class=\"col-md-12 text-justify\">Configura gli asset che devono utilizzare un listino. Per ciascun tipo di asset indica il modello utilizzato dal listino. Seleziona poi su quali chiavi deve essere effettuata la ricerca in fase di valorizzazione, la prima coppia di chiavi è obbligatoria, le seguenti sono opzionali e utilizzate per ottenere un best-match. L\'etichetta verrà utilizzata come chiave per il passaggio del dato valorizzato alla formula.</p><div class=\"col-md-12 well well-sm m-b\" ng-repeat=\"mapping in invoiceConfig.model.listMapping\" ng-init=\"mappingIndex = $index\"><div class=\"form-group col-md-4\"><label class=\"control-label\">Etichetta:</label> <input type=\"text\" class=\"form-control\" ng-model=\"mapping.label\"></div><div class=\"form-group col-md-4\"><label class=\"control-label\">Asset:</label><six-lookup-2 sx-id=\"assetSchema{{$index}}\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" sx-title=\"\'Tipo asset\'\" ng-model=\"mapping\" sx-field=\"\'asset_type_id\'\" sx-compact=\"true\"></six-lookup-2></div><div class=\"form-group col-md-4\"><label class=\"control-label\">Listino:</label><six-lookup-2 sx-id=\"listSchema{{$index}}\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" sx-title=\"\'Tipo asset\'\" ng-model=\"mapping\" sx-field=\"\'list_type_id\'\" sx-compact=\"true\"></six-lookup-2></div><div class=\"form-group col-md-12 m-t\"><button class=\"btn btn-xs btn-success pull-right\" ng-click=\"addListKey($index)\"><i class=\"fa fa-plus\"></i> Aggiungi chiave</button> <label class=\"control-label\">Chiavi:</label><ul id=\"listKeysManager\" class=\"list-group\" as-sortable=\"listKeySortableOptions\" ng-model=\"mapping.keylist\"><li class=\"list-group-item col-md-12 m-b-xs\" ng-repeat=\"keymap in mapping.keylist\" as-sortable-item=\"\"><button class=\"btn btn-xs pos-abt\" style=\"right: 0; top: 0;\" ng-click=\"removeListKey(mappingIndex, $index)\">&nbsp;<i class=\"fa fa-close\"></i></button> <i as-sortable-item-handle=\"\" class=\"fa fa-arrows pos-abt\" style=\"top:50%; z-index: 1; padding: 10px; margin: -15px 0 -10px -15px;\"></i><div class=\"form-group col-md-6\"><label class=\"control-label\">Campo sorgente:</label><six-select-2 sx-id=\"source_{{mappingIndex}}\" sx-list=\"getAvailableFields(mappingIndex, \'asset_type_id\')\" sx-title=\"\'Sorgente\'\" ng-model=\"keymap.source\" sx-compact=\"true\" sx-item-template=\"\'{{item.label}} ({{item.field}})\'\"></six-select-2></div><div class=\"form-group col-md-6\"><label class=\"control-label\">Campo ricerca:</label><six-select-2 sx-id=\"destination_{{mappingIndex}}\" sx-list=\"getAvailableFields(mappingIndex, \'list_type_id\')\" sx-title=\"\'Ricerca\'\" ng-model=\"keymap.destination\" sx-compact=\"true\" sx-item-template=\"\'{{item.label}} ({{item.field}})\'\"></six-select-2></div></li></ul></div><button class=\"btn btn-xs pos-abt\" style=\"right: 0; top: 0;\" ng-click=\"removeListMapping($index)\">&nbsp;<i class=\"fa fa-close\"></i></button></div><div class=\"col-md-12\"><button class=\"btn btn-success pull-right\" ng-click=\"addListMapping()\"><i class=\"fa fa-plus\"></i> Aggiungi configurazione</button></div><div class=\"col-md-12 m-t\">Nota: i campi Azienda (chiave: company_id) e Servizio (chiave: service_id) <span ng-if=\"modelsWithCompanyAndService.length == 0\">non sono definiti in alcun modello.</span> <span ng-if=\"modelsWithCompanyAndService.length != 0\">sono definiti nel modello solo per le seguenti tipologie di asset: <span ng-repeat=\"model in modelsWithCompanyAndService\">{{model.description}} ({{model.code}}){{$last ? \'.\' : \', \'}}</span></span><br>Tramite configurazione sul tree è comunque possibile indicare Azienda e Servizio per qualsiasi asset.</div></div></div><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-sm\"><div class=\"row\"><div class=\"col-xs-12\"><h4 class=\"m-n font-thin text-black\">Configurazione formule</h4></div></div></div><div class=\"panel-body m-b m-t no-padder\"><p class=\"col-md-12 text-justify\">Configura per ogni asset quale formula deve essere utilizzata.</p><div class=\"col-md-12 well well-sm m-b\" ng-repeat=\"singleFormulaConfig in invoiceConfig.model.formulaConfig\" ng-init=\"configIndex = $index\"><div class=\"form-group col-md-12\"><label class=\"control-label\">Tipo fattura:</label><ui-select ng-model=\"singleFormulaConfig.type\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"true\"><ui-select-match class=\"ui-select-match\" placeholder=\"Selezionare una tipologia...\">{{$select.selected.value}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" ui-disable-choice=\"isInvoiceTypeMapped(item.key, \'formulaConfig\')\" repeat=\"item.key as (key, item) in invoiceTypes\"><div ng-bind-html=\"item.value | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"col-md-12 m-b\"><div class=\"form-group col-md-12\"><label class=\"control-label\">Formula predefinita:</label><ui-select ng-model=\"singleFormulaConfig.defaultFormula\" theme=\"bootstrap\"><ui-select-match class=\"ui-select-match\" placeholder=\"Selezionare una formula...\">{{$select.selected.code}} - {{$select.selected.description}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item.code as item in formulasList\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"col-md-12 well well-sm m-b\" ng-repeat=\"mapping in singleFormulaConfig.formulaMapping\"><div class=\"form-group col-md-6\"><label class=\"control-label\">Asset:</label><six-lookup-2 sx-id=\"formulaAssetSchema{{$index}}\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" sx-title=\"\'Tipo asset\'\" ng-model=\"mapping\" sx-field=\"\'asset_type_id\'\" sx-compact=\"true\"></six-lookup-2></div><div class=\"form-group col-md-6\"><label class=\"control-label\">Formula:</label><ui-select ng-model=\"mapping.formula\" theme=\"bootstrap\"><ui-select-match class=\"ui-select-match\" placeholder=\"Selezionare una formula...\">{{$select.selected.code}} - {{$select.selected.description}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item.code as item in formulasList\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div><button class=\"btn btn-xs pos-abt\" style=\"right: 0; top: 0;\" ng-click=\"removeFormulaMapping(configIndex, $index)\">&nbsp;<i class=\"fa fa-close\"></i></button></div><div class=\"col-md-12\"><button class=\"btn btn-success pull-right\" ng-click=\"addFormulaMapping(configIndex)\"><i class=\"fa fa-plus\"></i> Aggiungi configurazione</button></div><button class=\"btn btn-xs pos-abt\" style=\"right: 0; top: 0;\" ng-click=\"removeFormulaConfig($index)\">&nbsp;<i class=\"fa fa-close\"></i></button></div><div class=\"col-md-12\"><button class=\"btn btn-success pull-right\" ng-click=\"addFormulaConfig()\"><i class=\"fa fa-plus\"></i> Configura tipologia</button></div></div></div><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-sm\"><div class=\"row\"><div class=\"col-xs-12\"><h4 class=\"m-n font-thin text-black\">Configurazione colonne</h4></div></div></div><div class=\"panel-body m-b m-t no-padder\"><p class=\"col-md-12 text-justify\">Configura per ogni tipologia di fattura le colonne da visualizzare. Per le tipologie non configurate verranno mostrate le colonne:<br>{{plainConfigurationDefaultColumns}}</p><div class=\"col-md-12 well well-sm m-b\" ng-repeat=\"mapping in invoiceConfig.model.columnMapping\" ng-init=\"mappingIndex = $index\"><div class=\"form-group col-md-12\"><label class=\"control-label\">Tipo fattura:</label><ui-select ng-model=\"mapping.type\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"true\"><ui-select-match class=\"ui-select-match\" placeholder=\"Selezionare una tipologia...\">{{$select.selected.value}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" ui-disable-choice=\"isInvoiceTypeMapped(item.key, \'columnMapping\')\" repeat=\"item.key as (key, item) in invoiceTypes\"><div ng-bind-html=\"item.value | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"form-group m-t col-md-12\"><button class=\"btn btn-xs btn-success pull-right\" ng-click=\"addColumn($index)\"><i class=\"fa fa-plus\"></i> Aggiungi colonna</button> <button class=\"btn btn-xs btn-success pull-right m-r\" ng-click=\"addDefaultColumns($index)\"><i class=\"fa fa-bars\"></i> Aggiungi colonne predefinite</button> <label class=\"control-label\">Colonne:</label><ul id=\"columnManager\" class=\"list-group pad-l-r-10\" as-sortable=\"columnSortableOptions\" ng-model=\"mapping.columns\"><li class=\"list-group-item row m-b-xs\" ng-repeat=\"column in mapping.columns\" ng-init=\"columnIndex = $index\" as-sortable-item=\"\"><button class=\"btn btn-xs pos-abt\" style=\"right: 0; top: 0;\" ng-click=\"removeColumn(mappingIndex, $index)\">&nbsp;<i class=\"fa fa-close\"></i></button> <i as-sortable-item-handle=\"\" class=\"fa fa-arrows pos-abt\" style=\"top:50%; z-index: 1; padding: 10px; margin: -15px 0 -10px -15px;\"></i> <label class=\"checkbox i-checks pos-abt\" style=\"right: 35px; top: 5px; z-index: 1; margin: 0;\"><input type=\"checkbox\" ng-model=\"column.active\"><i></i> Visibile</label><div class=\"form-group col-md-2\"><label class=\"control-label\">Intestazione</label> <input type=\"text\" class=\"form-control\" ng-model=\"column.description\"></div><div class=\"form-group col-md-2\"><label class=\"control-label\">Tipologia Campo</label><six-select-2 sx-list=\"[{key:\'default\', description:\'Predefinito\'},{key:\'asset\', description:\'Da asset\'}]\" ng-model=\"column.fieldType\" sx-compact=\"true\" sx-on-select=\"loadAvailableColumns(columnIndex, column)\" ng-init=\"loadAvailableColumns(columnIndex, column, true)\" sx-item-template=\"\'{{item.description}}\'\"></six-select-2></div><div class=\"form-group col-md-7\" ng-if=\"column.fieldType.key == \'default\' && availableColumns[columnIndex]\"><label class=\"control-label\">Campo</label><ui-select ng-model=\"column.field\" theme=\"bootstrap\" reset-search-input=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Selezionare un campo...\">{{$select.selected.value}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item.key as (key, item) in availableColumns[columnIndex]\"><div ng-bind-html=\"item.value | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"form-group col-md-3\" ng-if=\"column.fieldType.key == \'asset\'\"><label class=\"control-label\">Tipo Asset</label><six-lookup-2 sx-id=\"columnSchema{{$index}}\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" sx-title=\"\'Tipo asset\'\" ng-model=\"column\" sx-field=\"\'fieldAsset\'\" sx-compact=\"true\" sx-on-clear=\"loadAvailableColumns(columnIndex, column)\" sx-on-select=\"loadAvailableColumns(columnIndex, column)\" ng-init=\"loadAvailableColumns(columnIndex, column, true)\"></six-lookup-2></div><div class=\"form-group col-md-2\" ng-if=\"column.fieldType.key == \'asset\' && availableColumns[columnIndex]\"><label class=\"control-label\">Campo</label><ui-select ng-model=\"column.field\" theme=\"bootstrap\" reset-search-input=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Selezionare un campo...\">{{$select.selected.value}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item.key as (key, item) in availableColumns[columnIndex]\"><div ng-bind-html=\"item.value | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"form-group col-md-2\" ng-if=\"column.fieldType.key == \'asset\' && availableColumns[columnIndex]\"><label class=\"control-label\">Formato</label><six-select-2 sx-list=\"availableFieldFormats\" ng-model=\"column.fieldFormat\" sx-compact=\"true\" sx-item-template=\"\'{{item.description}}\'\" sx-on-select=\"setAssetColumnFormat(column, item)\"></six-select-2></div></li></ul></div><button class=\"btn btn-xs pos-abt\" style=\"right: 0; top: 0;\" ng-click=\"removeColumnMapping($index)\">&nbsp;<i class=\"fa fa-close\"></i></button></div><div class=\"col-md-12\"><button class=\"btn btn-success pull-right\" ng-click=\"addColumnMapping()\"><i class=\"fa fa-plus\"></i> Configura tipologia</button></div></div></div><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-sm\"><div class=\"row\"><div class=\"col-xs-12\"><h4 class=\"m-n font-thin text-black\">Configurazione aggregazioni</h4></div></div></div><div class=\"panel-body m-b m-t no-padder\"><p class=\"col-md-12 text-justify\">Configura per ogni tipologia come raggruppare i dati. Per le tipologie non configurate non verrà fatto alcun raggruppamento.</p><div class=\"col-md-12 well well-sm m-b\" ng-repeat=\"mapping in invoiceConfig.model.aggregationMapping\" ng-init=\"mappingIndex = $index\"><div class=\"form-group col-md-12\"><label class=\"control-label\">Tipo fattura:</label><ui-select ng-model=\"mapping.type\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"true\"><ui-select-match class=\"ui-select-match\" placeholder=\"Selezionare una tipologia...\">{{$select.selected.value}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" ui-disable-choice=\"isInvoiceTypeMapped(item.key, \'aggregationMapping\')\" repeat=\"item.key as (key, item) in invoiceTypes\"><div ng-bind-html=\"item.value | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"form-group m-t col-md-12\"><label class=\"control-label\">Aggregazioni:</label><six-select-2 sx-id=\"aggregations\" sx-list=\"knownAggregations\" sx-title=\"\'Aggregazioni\'\" ng-model=\"mapping\" sx-field=\"\'aggregationKeys\'\" sx-multiple=\"true\" sx-item-template=\"\'{{item.description}}\'\"></six-select-2></div><button class=\"btn btn-xs pos-abt\" style=\"right: 0; top: 0;\" ng-click=\"removeAggregationMapping($index)\">&nbsp;<i class=\"fa fa-close\"></i></button></div><div class=\"col-md-12\"><button class=\"btn btn-success pull-right\" ng-click=\"addAggregationMapping()\"><i class=\"fa fa-plus\"></i> Configura tipologia</button></div></div></div></div><div class=\"panel-footer\"><div class=\"form-group\"><input id=\"jsonShowCheck\" type=\"checkbox\" ng-model=\"jsonshow\" class=\"pull-left\" data-toggle=\"collapse\" data-target=\"#json-collapse\"> <label for=\"jsonShowCheck\" class=\"pull-left control-label\">Dettaglio avanzato</label></div></div><div class=\"row collapse\" id=\"json-collapse\" collapse=\"!jsonshow\"><div class=\"col-md-12\"><div class=\"panel no-border\"><div class=\"panel-heading wrapper b-b b-light\"><h4 class=\"font-thin m-t-none m-b-none text-muted\">Dettaglio</h4></div><div style=\"margin-top:0px;\" ui-ace=\"{ useWrapMode : true, showGutter: true, mode: \'json\', firstLineNumber: 1, onLoad: aceLoaded, onChange: aceChanged }\" ng-model=\"aceModel\"></div></div></div></div></div></div></div>");
$templateCache.put("plan/invoice/invoiceconfigurator_list.html","<six-toolbar><six-toolbar-button label=\"Crea configurazione\" icon=\"fa fa-plus\" toolbar-function=\"newConfiguration()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"refresh()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista Configurazioni Fatturazione</h1></div></div></div><div class=\"panel-body\"><table id=\"configuration_list\" class=\"table table-striped\"><thead><tr><th></th><th>CODICE</th><th>COMMESSA</th><th>CONFIGURAZIONE</th><th>DATA</th></tr></thead><tbody><tr ng-repeat=\"item in configuratorList.list\"><td><a ng-href=\"#/invoiceconfigurator/{{item.UUID}}\" class=\"btn btn-default\"><span class=\"fa fa-search\"></span></a></td><td>{{ item.model.code }}</td><td>{{ printCommission(item.model.commission) }}</td><td>{{ printConfiguration(item.model) }}</td><td>{{ item.dataIn | date:\'dd/MM/yyyy\' }}</td></tr><tr ng-hide=\"configuratorList.list.length\"><td colspan=\"5\"><p class=\"text-center\">Nessun record recuperato</p></td></tr></tbody></table></div><div class=\"panel-footer\"><div class=\"row text-center\"><uib-pagination ng-change=\"pageChanged()\" boundary-links=\"true\" total-items=\"configuratorList.totalResults\" ng-model=\"configuratorList.currentPage\" class=\"pagination-sm\" items-per-page=\"configuratorList.pageSize\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></uib-pagination></div></div></div></div>");
$templateCache.put("plan/issue/callcenter_detail.html","<ict-issue issue-id=\"issueId\" config=\"{ \'mode\': \'callcenter\', \'tabs\': [ { \'component\': \'ictIssue\', \'config\': {\'mode\': \'extended\', \'showWatchers\': true, \'showAssignee\': true}}, \'ictTimeline\', \'ictAttachments\', \'ictMessage\', \'ictQrcode\', \'ictNotification\', \'ictOdl\' ] }\"></ict-issue>");
$templateCache.put("plan/issue/callcenter_list.html","<six-toolbar><six-toolbar-button label=\"Aggiungi segnalazione\" icon=\"fa fa-plus\" toolbar-function=\"newIssueByCallcenter()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Modifica\" icon=\"fa fa-pencil\" toolbar-function=\"bulkEdit()\" sx-disabled=\"isUpdatePermAllowed() === false || getSelectedRows().length == 0\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" sx-disabled=\"!isDeletePermAllowed() || getSelectedRows().length == 0\" ng-confirm-message=\"Sei sicuro?\" ng-confirm-click=\"deleteIssueSelected()\" ng-confirm-condition=\"true\"></six-toolbar-button><six-toolbar-button label=\"Tutte\" icon=\"fa fa-square-o\" icon-disabled=\"fa fa-check-square-o\" icon-condition=\"bool.allIssues\" toolbar-function=\"toggleAllIssues();\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"refresh()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista segnalazioni - Call center</h1></div></div></div><div class=\"panel-body\"><six-bulk-editor class=\"col-md-12\" ng-if=\"bulkEditorVisible\" sx-cancel=\"bulkEditConf.cancel()\" sx-post-save=\"bulkEditConf.postSave()\" sx-data-getter=\"bulkEditConf.dataGetter()\" sx-save=\"bulkEditConf.factory(payload)\" sx-compact-schema=\"bulkEditConf.compactSchema\" sx-schema-form=\"bulkEditConf.schemaForm\" sx-schema-form-prefix=\"model\" sx-callbacks=\"bulkEditConf.callbacks\"></six-bulk-editor><div class=\"col-sm-12 m-t\"><six-grid-pagination sx-id=\"callcenter_issues_grid\" get-data-callback=\"getCurrentUserIssueList()\" get-list-callback=\"getCurrentUserIssueList()\" items-list=\"issueList\" grid-options=\"viewGridOptions\" column-defs=\"viewGridOptions.columnDefs\" params=\"params\" grid-app-callbacks=\"gridAppCallbacks\" auto-resize-params=\"autoResizeParams\" enable-state-saving=\"true\" show-global-search=\"false\"></six-grid-pagination></div></div></div></div>");
$templateCache.put("plan/issue/issueconfigurator_detail.html","<six-toolbar><six-toolbar-button label=\"Lista\" icon=\"fa fa-chevron-left\" toolbar-function=\"back()\"></six-toolbar-button><six-toolbar-button label=\"Duplica\" btn-class=\"btn-primary\" icon=\"fa fa-files-o\" toolbar-function=\"setConfModel()\" ng-if=\"selected.version\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"fa fa-trash-o\" toolbar-function=\"delete()\" sx-disabled=\"!isDeletePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"saveForm()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Dettaglio Configurazione</h1></div></div></div><div class=\"wrapper\"><div class=\"panel-heading\" style=\"background-color: transparent\"><div class=\"page-header-bleed-right\"><div class=\"actions\"><div class=\"row\"><form name=\"header\"><div class=\"form-group\"><div class=\"col-md-12\"><label class=\"control-label\">Codice:</label> <input type=\"text\" class=\"form-control\" ng-model=\"commissionCode\" ng-disabled=\"bool.isCross || bool.isCallCenter\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"!bool.isCross && !bool.isCallCenter\"><label class=\"col-md-1 control-label\">Commesse:</label><div class=\"col-md-12\"><div id=\"vectors_budget_code\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"commissionsSelected.codes\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Selezionare una commessa...\">{{$item.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in commissions\"><span ng-bind-html=\"item.code | highlight: $select.search\"></span> - <span ng-bind-html=\"item.description | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div class=\"col-md-12\"><input type=\"checkbox\" ng-model=\"bool.isCross\" name=\"cross_commission\" ng-click=\"updateCode()\"> <label class=\"control-label\">Imposta come configurazione di default per gli utenti (cross-commessa)</label></div><div class=\"col-md-12\"><input type=\"checkbox\" ng-model=\"bool.isCallCenter\" name=\"isCallCenter\" ng-click=\"setCallCenter()\"> <label class=\"control-label\">Imposta come configurazione del Call Center</label></div></div></form></div></div></div></div><div class=\"panel-body\"><uib-tabset justified=\"true\"><uib-tab heading=\"Preview\"><form name=\"myForm\" sf-schema=\"schema\" sf-form=\"form\" sf-model=\"model\" ng-submit=\"onSubmit(myForm)\"></form></uib-tab><uib-tab heading=\"Schema\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><div class=\"col-md-12 centered\"><b>SCHEMA</b></div><div class=\"col-md-12 override-padding-no-pad-left-right\"><hr class=\"override-margin-top-bottom\"></div><div class=\"col-md-12 centered\"><div class=\"col-md-2 col-md-offset-1\"><b>CODICE</b></div><div class=\"col-md-3\"><b>DESCRIZIONE</b></div><div class=\"col-md-1\"><b>TIPOLOGIA</b></div><div class=\"col-md-2\"><b>FORMATO</b></div></div><div class=\"col-md-12 override-padding-no-pad-left-right\"><hr class=\"override-margin-top-bottom\"></div><div class=\"col-md-12 centered\"><div class=\"col-md-2 col-md-offset-1\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><form name=\"propertyKeyForm\"><input class=\"form-control\" name=\"property_key\" placeholder=\"Codice...\" type=\"text\" ng-model=\"property.key\" pattern=\"^[a-zA-Z]+[\\w]*$\"><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"propertyKeyForm.property_key.$error.pattern\">Caratteri non consentiti</span></div></form></div></div><div class=\"col-md-3\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><input class=\"form-control\" placeholder=\"Descrizione\" type=\"text\" ng-model=\"property.title\"></div></div><div class=\"col-md-1\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><select class=\"form-control\" ng-model=\"property.type\"><option></option><option value=\"string\">string</option><option value=\"number\">number</option><option value=\"integer\">integer</option><option value=\"boolean\">boolean</option><option value=\"date\">date</option><option value=\"array\">array</option></select></div></div><div class=\"col-md-2\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><select class=\"form-control\" ng-model=\"property.format\" ng-if=\"(property.type == \'string\')\"><option></option><option value=\"lookup\">lookup</option><option value=\"formula\">formula</option><option value=\"enum\">enum</option></select><select class=\"form-control\" ng-model=\"property.format\" ng-if=\"(property.type == \'number\' || property.type == \'integer\')\"><option></option><option value=\"formula\">formula</option><option value=\"enum\">enum</option></select><select class=\"form-control\" ng-model=\"property.items_type\" ng-if=\"(property.type == \'array\')\"><option></option><option value=\"lookup\">lookup</option><option value=\"string\">string</option><option value=\"number\">number</option><option value=\"integer\">integer</option><option value=\"date\">date</option></select></div></div><div class=\"col-md-2\"><div ng-if=\"isInheritable(property.type)\"><label><input type=\"checkbox\" ng-model=\"property.inherited\"> Campo ereditato</label></div></div><div class=\"col-md-1\"><button ng-click=\"addProperty()\" class=\"btn btn-sm btn-info pull-right\"><span class=\"fa fa-plus\"></span> Add</button></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-repeat=\"(key, value) in selected.model.schema.properties\" style=\"align-content: center; padding-bottom: 0px;\"><div class=\"col-md-12 uniform-height\" style=\"align-content: center;\"><div class=\"col-md-1\"><a href=\"\" ng-click=\"status[key].open = !status[key].open\" id=\"btn_row_detail\"><i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status[key].open, \'glyphicon-chevron-right\': !status[key].open}\"></i></a></div><div class=\"col-md-2\">{{ key }}</div><div class=\"col-md-3\">{{ value.title }}</div><div class=\"col-md-1\">{{ value.type }}</div><div class=\"col-md-2\"><span ng-if=\"value.format\">{{value.format}}</span> <span ng-if=\"value.type == \'array\' && value.items\">{{value.items.format}}</span></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-show=\"status[key].open\"><div class=\"col-md-12 uniform-height-2\" ng-if=\"value.format !== \'lookup\' && value.format !== \'formula\' && value.format !== \'enum\' && value.format !== \'inherit\' && value.type !== \'array\'\"><div class=\"col-md-2\">FORMATO:</div><div class=\"col-md-10\">{{value.format}}</div></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'inherit\'\" ng-include=\"\'dataset/modeltype/detail_inherit.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'lookup\' && value.type != \'array\'\" ng-include=\"\'dataset/modeltype/detail_lookup.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'formula\'\" ng-include=\"\'dataset/modeltype/detail_formula.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'enum\'\" ng-include=\"\'dataset/modeltype/detail_enum.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.type === \'array\'\" ng-include=\"\'dataset/modeltype/detail_array.html\'\"></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">ELIMINA:</div><div class=\"col-md-10\"><button ng-click=\"deleteProperty(key)\" class=\"btn btn-danger btn-xs btn-default\" ng-disabled=\"(key === \'code\' || key === \'description\')\"><i class=\"fa fa-trash\"></i></button></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">IN TABELLA:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.check\" ng-change=\"changeColumnDefs(key, value)\" ng-disabled=\"(key === \'code\' || key === \'description\')\"></div></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-show=\"value.check == true\"><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">LARGHEZZA (px):</div><div class=\"col-md-10\"><input type=\"text\" min=\"1\" step=\"1\" size=\"45\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=\"value.width\" ng-change=\"changeColumnDefs(key, value)\"></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">ORDINAMENTO:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.enableSorting\" ng-change=\"changeColumnDefs(key, value)\"></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">FILTRAGGIO:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.enableFiltering\" ng-change=\"changeColumnDefs(key, value)\"></div></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div></div></div></div></uib-tab><uib-tab heading=\"Form\"><table class=\"table table-striped\"><thead><th colspan=\"5\">FORM</th><tr><th colspan=\"5\"><div class=\"form-group\"><label for=\"title\" class=\"control-label\">Titolo</label><div class=\"\"><input type=\"text\" class=\"form-control\" id=\"title\" placeholder=\"\" ng-model=\"title\" name=\"title\" ng-keyup=\"refreshTitleForm(title)\"></div></div></th></tr><tr><td></td><td></td><td><input type=\"text\" placeholder=\"Titolo...\" ng-model=\"newTab.title\"></td><td><button ng-click=\"addTab(selected.model.form[0].items[0])\" class=\"btn btn-xs btn-info\"><span class=\"fa fa-plus\"></span> Add</button></td></tr><tr><th></th><th>POSIZIONE</th><th>TITOLO</th><th></th></tr></thead><tbody><tr ng-repeat-start=\"(key, tab) in selected.model.form[0].items[0].tabs\"><td><a href=\"\" ng-click=\"statusForm[key].open = !statusForm[key].open\"><i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': statusForm[key].open, \'glyphicon-chevron-right\': !statusForm[key].open}\"></i></a></td><td><span class=\"btn btn-sm\" ng-click=\"swapUp(key, selected.model.form[0].items[0].tabs)\" ng-disabled=\"key<=0\"><i class=\"fa fa-caret-up\"></i></span> {{key+1}} <span class=\"btn btn-sm\" ng-click=\"swapDown(key, selected.model.form[0].items[0].tabs)\" ng-disabled=\"key>=selected.model.form[0].items[0].tabs.length-1\"><i class=\"fa fa-caret-down\"></i></span></td><td><input type=\"text\" ng-model=\"tab.title\" ng-disabled=\"(tab.key[0] == \'code\' || tab.key[0] == \'description\')\" ng-keyup=\"updateScope()\"></td><td><a ng-click=\"removeTabOrField(key, selected.model.form[0].items[0].tabs)\" class=\"btn btn-danger btn-xs btn-default\" id=\"btn_row_detail_form\"><i class=\"fa fa-trash\"></i></a></td></tr><tr ng-repeat-end=\"\" ng-show=\"statusForm[key].open\"><td></td><td colspan=\"3\" style=\"background-color:rgba(211, 211, 211, 0.38);\"><table class=\"table table-striped override-margin\"><tr><td></td><td><select ng-options=\"k as v.title for (k, v) in schema.properties\" ng-model=\"newFieldForm.key\"></select></td><td><input type=\"text\" placeholder=\"Titolo...\" ng-model=\"newFieldForm.title\"></td><td><input type=\"checkbox\" placeholder=\"Richiesto...\" ng-model=\"newFieldForm.required\"></td><td><input type=\"checkbox\" placeholder=\"Nascosto...\" ng-model=\"newFieldForm.htmlClass\" ng-true-value=\"\'hidden\'\" ng-false-value=\"\'\'\"></td><td><select ng-model=\"newFieldForm.type\" ng-change=\"updateScope()\"><option value=\"\"></option><option value=\"text\">text</option><option value=\"textarea\">textarea</option><option value=\"number\">number</option><option value=\"datepicker\">date</option><option value=\"password\">password</option><option value=\"checkbox\">checkbox</option><option value=\"select\">enum</option><option value=\"array\">array</option><option value=\"sixlookup\">lookup</option><option value=\"inherited\">ereditato</option><option value=\"formula\">formula</option></select></td><td><button ng-click=\"addFieldToTab(tab)\" class=\"btn btn-xs btn-info\"><span class=\"fa fa-plus\"></span> Add</button></td></tr><tr><th>POSIZIONE</th><th>CAMPO</th><th>TITOLO</th><th>REQUIRED</th><th>NASCOSTO</th><th>TIPO</th><th></th></tr><tr ng-repeat=\"(fieldKey, field) in tab.items\"><td class=\"override-width-200px\"><div><span class=\"btn btn-sm\" ng-click=\"swapUp(fieldKey, tab.items)\" ng-disabled=\"fieldKey<=0\"><i class=\"fa fa-caret-up\"></i></span> {{fieldKey+1}} <span class=\"btn btn-sm\" ng-click=\"swapDown(fieldKey, tab.items)\" ng-disabled=\"fieldKey>=tab.items.length-1\"><i class=\"fa fa-caret-down\"></i></span></div></td><td ng-if=\"!field.title\">{{field}}</td><td ng-if=\"!field.title\"></td><td ng-if=\"!field.title\"></td><td ng-if=\"!field.title\"></td><td ng-if=\"field.title\">{{field.key[0]}}</td><td ng-if=\"field.title\"><input type=\"text\" ng-model=\"field.title\" ng-keyup=\"updateScope()\"></td><td ng-if=\"field.title\"><input type=\"checkbox\" ng-model=\"field.required\" ng-change=\"updateScope()\"></td><td ng-if=\"field.title\"><input type=\"checkbox\" ng-model=\"field.htmlClass\" ng-change=\"updateScope()\" ng-true-value=\"\'hidden\'\" ng-false-value=\"\'\'\"></td><td ng-if=\"field.title\"><select ng-model=\"field.type\" ng-change=\"updateField(field)\"><option value=\"\"></option><option value=\"text\">text</option><option value=\"textarea\">textarea</option><option value=\"number\">number</option><option value=\"datepicker\">date</option><option value=\"password\">password</option><option value=\"checkbox\">checkbox</option><option value=\"select\">enum</option><option value=\"array\">array</option><option value=\"sixlookup\">lookup</option><option value=\"inherited\">ereditato</option><option value=\"formula\">formula</option></select></td><td><a ng-click=\"removeTabOrField(fieldKey, tab.items)\" class=\"btn btn-danger btn-xs btn-default\"><i class=\"fa fa-trash\"></i></a></td></tr></table></td></tr></tbody></table></uib-tab></uib-tabset></div><div class=\"panel-footer\"><div class=\"form-group\"><input id=\"jsonShowCheck\" type=\"checkbox\" ng-model=\"jsonshow\" class=\"pull-left\" data-toggle=\"collapse\" data-target=\"#json-collapse\"> <label for=\"jsonShowCheck\" class=\"pull-left control-label\">Dettaglio avanzato</label></div></div><div class=\"row collapse\" id=\"json-collapse\" collapse=\"!jsonshow\"><div class=\"col-md-8\"><div class=\"panel no-border\"><div class=\"panel-heading wrapper b-b b-light\"><h4 class=\"font-thin m-t-none m-b-none text-muted\">Dettaglio</h4></div><div style=\"margin-top:0px;\" ui-ace=\"{ useWrapMode : true, showGutter: true, mode: \'json\', firstLineNumber: 1, onLoad: aceLoaded, onChange: aceChanged }\" ng-model=\"aceModel\"></div></div></div><div class=\"col-md-4\"><div class=\"list-group list-group-lg list-group-sp\"><pre>{{ model}}</pre></div></div></div></div></div></div>");
$templateCache.put("plan/issue/issueconfigurator_list.html","<six-toolbar><six-toolbar-button label=\"Crea modello segnalaz.\" icon=\"fa fa-plus\" toolbar-function=\"newIssueConfig()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"refresh()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista configurazioni segnalazioni</h1></div></div></div><div class=\"panel-body\"><div class=\"form-group\"><input ng-keyup=\"getData(queryParam)\" class=\"form-control\" type=\"text\" ng-model=\"queryParam\" placeholder=\"Type here to filter the list...\"></div><table id=\"issue_configurator_list\" class=\"table table-striped\"><thead><tr><th></th><th>CODICE CONFIGURAZIONE</th><th>COMMESSA</th><th>DATA</th></tr></thead><tbody><tr ng-repeat=\"item in issueConfiguratorList.list\"><td><a ng-href=\"#/issueconfigurator/{{item.UUID}}\" class=\"btn btn-default\" id=\"btn_issue_detail\"><span class=\"fa fa-search\"></span></a></td><td>{{ item.model.code }}</td><td>{{printCommission(item.model.commission)}}</td><td>{{ item.dataIn | date:\'dd/MM/yyyy\' }}</td></tr><tr ng-hide=\"issueConfiguratorList.list.length\"><td><p class=\"text-center\">Nessun record recuperato</p></td></tr></tbody></table></div><div class=\"panel-footer\"><div class=\"row text-center\"><uib-pagination ng-change=\"pageChanged()\" boundary-links=\"true\" total-items=\"issueConfiguratorList.totalResults\" ng-model=\"issueConfiguratorList.currentPage\" class=\"pagination-sm\" items-per-page=\"issueConfiguratorList.pageSize\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></uib-pagination></div></div></div></div>");
$templateCache.put("plan/odl/odl_detail.html","<six-toolbar><six-toolbar-item label=\"ODL n. {{data.model.code}} - {{odlWorkflow.getReadableStatus(data.status)}}\" ng-show=\"data.version\"></six-toolbar-item><six-toolbar-item label=\"Nuovo ODL\" ng-show=\"!data.version\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" onclick=\"window.history.back()\"></six-toolbar-button><six-toolbar-button label=\"Stampa\" icon=\"fa fa-print text-info-dker\" toolbar-function=\"printOdl(\'pdf\')\" sx-disabled=\"!data.version\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" toolbar-function=\"delete(data.version)\" sx-disabled=\"!data.version || !isDeletePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"validate()\" sx-disabled=\"!(schemaOdlDefined) || !isWritePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default constructor\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"!data.version\">Nuovo ODL</h1><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"data.version\">ODL n. <span class=\"m-l-xs\">{{data.model.code}}</span></h1></div><div class=\"col-sm-6 col-xs-12\"><odl-tab class=\"pull-right\" sx-object=\"data\" sx-base-path=\"\'odl\'\" sx-status=\"data.status\" sx-uuid=\"data.UUID\" sx-show-buttons=\"isWritePermAllowed()\"></odl-tab></div></div></div><uib-tabset class=\"tabs-left\"><uib-tab index=\"0\"><uib-tab-heading><span class=\"fa fa-list-alt text-info-dker\"></span> ODL</uib-tab-heading><div ng-if=\"data.generated_by==\'plan\'\" ng-include=\"\'plan/odl/odl_detail_plan.html\'\"></div><div ng-if=\"data.generated_by==\'issue\'\" ng-include=\"\'plan/odl/odl_detail_issue.html\'\"></div><div class=\"col-md-12\"><div class=\"panel panel-default pnl-no-margin-t-b\" id=\"panel1\"><a data-toggle=\"collapse\" data-target=\"#collapseOne\"><div class=\"panel-heading\"><h5 class=\"override-margin-top-bottom\"><i class=\"pull-right fa ng-scope fa-angle-right\" ng-class=\"{\'fa-angle-down\': status.open, \'fa-angle-right\': !status.open}\"></i> Watchers</h5></div></a><div id=\"collapseOne\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"col-md-12 no-pad-l-r\"><div class=\"col-md-1 no-pad-l-r\"><h5>Aggiungi:</h5></div><form name=\"validationForm\"><div class=\"col-md-11\"><div class=\"col-md-1\"><input type=\"radio\" ng-checked=\"bool_watch_internal\" ng-click=\"setBoolWatchInternal()\"> Interno</div><div class=\"col-md-1\"><input type=\"radio\" ng-checked=\"bool_watch_external\" ng-click=\"setBoolWatchExternal()\"> Esterno</div></div><div class=\"row col-md-12 no-pad-l-r\"><div class=\"col-md-4 form-group\" ng-if=\"bool_watch_internal == true\"><six-lookup ng-model=\"watcher\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'user\'\"></six-lookup></div><div class=\"col-md-4 form-group\" ng-if=\"bool_watch_external == true\"><input type=\"email\" name=\"inputMail\" class=\"form-control\" ng-model=\"watcher.mail\"><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"validationForm.inputMail.$error.email\">Email non valida</span></div></div><div class=\"col-md-1 form-group\"><button class=\"btn btn-default\" ng-click=\"addWatcher()\"><span class=\"fa fa-plus\"></span></button></div></div></form><div class=\"row col-md-12 no-pad-l-r m-t-md\"><div class=\"col-md-6\" ng-if=\"data.watchers.internal.length != 0\"><label class=\"control-label\">Watcher interni:</label></div><div class=\"col-md-6\" ng-if=\"data.watchers.external.length != 0\"><label class=\"control-label\">Watcher esterni:</label></div></div><div class=\"row col-md-12 no-pad-l-r\"><div class=\"col-md-6\" ng-if=\"data.watchers.internal.length != 0\"><div class=\"col-md-12 no-pad-l-r margin-col-l\" ng-repeat=\"w in data.watchers.internal track by $index\"><span class=\"input-group has-button\"><six-lookup-2 ng-model=\"w\" sx-type=\"w.type\" sx-base-path=\"\'record\'\" sx-disabled=\"true\" sx-closable=\"false\"></six-lookup-2><span class=\"input-group-btn\"><a class=\"btn btn-danger\" ng-click=\"deleteWatcher(data.watchers.internal, w)\"><span class=\"fa fa-trash-o\"></span></a></span></span></div></div><div class=\"col-md-6\" ng-if=\"data.watchers.external.length != 0\"><div class=\"col-md-12 no-pad-l-r margin-col-l\" ng-repeat=\"w in data.watchers.external\"><span class=\"input-group has-button\"><input type=\"email\" class=\"form-control\" ng-model=\"w\" disabled=\"\"> <span class=\"input-group-btn\"><a class=\"btn btn-danger\" ng-click=\"deleteWatcher(data.watchers.external, w)\"><span class=\"fa fa-trash-o\"></span></a></span></span></div></div></div></div></div></div></div></div><div class=\"col-md-12 hr-margin\"><div class=\"panel panel-default pnl-no-margin-t-b\" id=\"panel2\"><a data-toggle=\"collapse\" data-target=\"#collapseTwo\"><div class=\"panel-heading\"><h5 class=\"override-margin-top-bottom\"><i class=\"pull-right fa ng-scope fa-angle-right\" ng-class=\"{\'fa-angle-down\': status.open, \'fa-angle-right\': !status.open}\"></i> Tecnici - Assegnatari</h5></div></a><div id=\"collapseTwo\" class=\"panel-collapse collapse in\"><div class=\"panel-body\"><div class=\"col-md-4 form-group m-t\"><label class=\"control-label\">Fornitore</label><six-lookup-2 sx-id=\"supplier_id\" ng-model=\"data.references_assignee\" sx-type=\"\'fornitore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'supplier_id\'\" sx-add=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-filter=\"supplierFilter\"></six-lookup-2></div><div class=\"col-md-4 form-group m-t\"><label class=\"control-label\">Azienda assegnataria</label><six-lookup-2 sx-id=\"company_id\" ng-model=\"data.references_assignee\" sx-type=\"\'azienda\'\" sx-base-path=\"\'record\'\" sx-field=\"\'company_id\'\" sx-add=\"false\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-filter=\"companyFilter\" sx-on-select=\"buildCompanyFilter(data.references_assignee.company_id)\"><button class=\"btn btn-default\" ng-click=\"addWatcherFromLookUp(data.references_assignee.company_id)\"><i class=\"fa fa-envelope-o\"></i></button></six-lookup-2></div><div class=\"col-md-4 form-group m-t\"><label class=\"control-label\">Capo commessa</label><six-lookup-2 sx-id=\"headmanCommission_id\" ng-model=\"data.references_assignee\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'headmanCommission_id\'\" sx-add=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-filter=\"headmanCommissionFilter\"><button class=\"btn btn-default\" ng-click=\"addWatcherFromLookUp(data.references_assignee.headmanCommission_id)\"><i class=\"fa fa-envelope-o\"></i></button></six-lookup-2></div><div class=\"col-md-4 form-group m-t\"><label class=\"control-label\">Responsabile interno</label><six-lookup-2 sx-id=\"supervisorInternal_id\" ng-model=\"data.references_assignee\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'supervisorInternal_id\'\" sx-add=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-filter=\"supervisorInternalFilter\"><button class=\"btn btn-default\" ng-click=\"addWatcherFromLookUp(data.references_assignee.supervisorInternal_id)\"><i class=\"fa fa-envelope-o\"></i></button></six-lookup-2></div><div class=\"col-md-4 form-group m-t\"><label class=\"control-label\">Responsabile esterno</label><six-lookup-2 sx-id=\"supervisorExternal_id\" ng-model=\"data.references_assignee\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'supervisorExternal_id\'\" sx-add=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-filter=\"supervisorExternalFilter\"><button class=\"btn btn-default\" ng-click=\"addWatcherFromLookUp(data.references_assignee.supervisorExternal_id)\"><i class=\"fa fa-envelope-o\"></i></button></six-lookup-2></div><div class=\"col-md-4 form-group m-t\"><label class=\"control-label\">Tecnico di commessa</label><six-lookup-2 sx-id=\"technicianCommission_id\" ng-model=\"data.references_assignee\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'technicianCommission_id\'\" sx-add=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-multiple=\"true\" sx-title=\"\'Tecnico\'\" sx-filter=\"technicianCommissionFilter\"><button class=\"btn btn-default\" ng-click=\"addWatcherFromLookUp(data.references_assignee.technicianCommission_id)\"><i class=\"fa fa-envelope-o\"></i></button></six-lookup-2></div><div class=\"col-md-4 form-group m-t\"><label class=\"control-label\">Manutentori</label><six-lookup-2 sx-id=\"maintainer_id\" ng-model=\"data.references_assignee\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'maintainer_id\'\" sx-add=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-multiple=\"true\" sx-title=\"\'Manutentore\'\" sx-filter=\"maintainerFilter\"><button class=\"btn btn-default\" ng-click=\"addWatcherFromLookUp(data.references_assignee.maintainer_id)\"><i class=\"fa fa-envelope-o\"></i></button></six-lookup-2></div></div></div></div></div><div class=\"col-md-12 hr-margin\" ng-if=\"responsableList.length > 0\"><div class=\"panel panel-default pnl-no-margin-t-b\" id=\"panel3\"><a data-toggle=\"collapse\" data-target=\"#collapseThree\"><div class=\"panel-heading\"><h5 class=\"override-margin-top-bottom\"><i class=\"pull-right fa ng-scope fa-angle-right\" ng-class=\"{\'fa-angle-down\': status.open, \'fa-angle-right\': !status.open}\"></i> Contatti responsabili</h5></div></a><div id=\"collapseThree\" class=\"panel-collapse collapse\"><div class=\"panel-body\"><div class=\"col-md-12 no-pad-l-r\"><div class=\"row col-md-12 no-pad-l-r\" ng-repeat=\"r in responsableList\"><div class=\"col-md-4 form-group\"><input type=\"text\" class=\"form-control\" ng-model=\"r.name\" disabled=\"\"></div><div class=\"col-md-4 form-group\"><input type=\"text\" class=\"form-control\" ng-model=\"r.contacts\" disabled=\"\"></div></div></div></div></div></div></div><div class=\"panel-body m-t-n\"><div ng-if=\"schemaOdlDefined\"><uib-tabset class=\"tabs-right\"><uib-tab index=\"0\"><uib-tab-heading><span class=\"fa fa-list-alt text-info-dker\"></span> Dati</uib-tab-heading><div class=\"col-md-12 form-group s-f-height\" ng-if=\"data.version\"><label class=\"control-label\">Codice</label> <input type=\"text\" class=\"form-control\" ng-model=\"data.model.code\" disabled=\"\"></div><div class=\"col-md-12 no-pad-l-r\"><form name=\"detailForm\"><div class=\"row wrapper\"><div class=\"override-form-group override-checkbox text-area\" sf-schema=\"schema\" sf-form=\"form\" sf-model=\"data.model\"></div></div></form></div><div ng-if=\"!(schemaOdlDefined)\"><div class=\"wrapper\"><div class=\"row\"><label class=\"control-label\">Schema non definito &#x2192; Configurare prima il modello \'odl\'</label></div></div></div></uib-tab><uib-tab index=\"1\" disable=\"!data.UUID\" select=\"getTimeline(); storico_dati == undefined ? storico_dati = true : angular.noop()\"><uib-tab-heading><span class=\"fa fa-history text-info-dker\"></span> Storico stati</uib-tab-heading><div class=\"col-md-12\" ng-if=\"storico_dati\"><div class=\"hbox hbox-auto-xs hbox-auto-sm ng-scope\"><div class=\"col col-md-4\"><div class=\"wrapper\"><ul class=\"timeline\"><li class=\"tl-header\"><div class=\"btn btn-sm btn-default btn-rounded\">FINE</div></li><li ng-repeat=\"item in timeline\" class=\"tl-item\" ng-class-odd=\"\'tl-left\'\"><div class=\"tl-wrap\" ng-class=\"{\'b-success\': (currentDataInTimeline.version == item.version)}\"><span class=\"tl-date\">{{item.dataIn | date : \'dd/MM/yyyy HH:mm:ss\' : timezone}}</span><div class=\"tl-content panel padder b-a\" ng-class=\"{\'bg-success\': (currentDataInTimeline.version == item.version)}\"><span class=\"arrow left pull-up hidden-left\" ng-class=\"{\'arrow-success\': (currentDataInTimeline.version == item.version)}\"></span> <span class=\"arrow right pull-up visible-left\" ng-class=\"{\'arrow-success\': (currentDataInTimeline.version == item.version)}\"></span><div class=\"text-lt m-b-sm\"><a ng-click=\"getModelDetail(item.version)\">{{item.model.code}}</a></div><div class=\"panel-body pull-in b-t b-light\"><span class=\"pull-right label\" ng-class=\"{\'bg-success\': (currentDataInTimeline.version == item.version), \'bg-info\': (currentDataInTimeline.version != item.version)}\">{{item.user}}</span></div><div class=\"panel-body pull-in b-t b-light\">Stato: {{item.status}}</div><div class=\"panel-body pull-in b-t b-light\">Note: {{item.status_note}}</div><div class=\"panel-body pull-in b-t b-light\"><div>Sorgente: <span ng-if=\"item.source\">{{item.source}}</span><span ng-if=\"!item.source\">web</span></div><div ng-if=\"item.merged\" class=\"badge bg-light\">Autogenerato</div></div></div></div></li><li class=\"tl-header\"><div class=\"btn btn-sm btn-default btn-rounded\">INIZIO</div></li></ul></div></div><div class=\"col wrapper bg-white\" ng-if=\"showDetail\"><div class=\"col-md-12 no-pad-l-r\"><div class=\"row wrapper\"><div class=\"col-md-12 col\"><h5>Version</h5><div class=\"col-md-12 no-pad-l-r\"><span disabled=\"true\" class=\"form-control\">{{currentDataInTimeline.version}}</span></div></div><div class=\"col-md-6\"><h5>Inizio validità</h5><div class=\"col-md-12 no-pad-l-r\"><span disabled=\"true\" class=\"form-control\">{{currentDataInTimeline.dataIn | date : \'dd/MM/yyyy HH:mm:ss\' : timezone}}</span></div></div><div class=\"col-md-6\"><h5>Fine validità</h5><div class=\"col-md-12 no-pad-l-r\"><span disabled=\"true\" class=\"form-control\">{{currentDataInTimeline.dataOut | date : \'dd/MM/yyyy HH:mm:ss\' : timezone}}</span></div></div><div class=\"col-md-12\"><h5>Stato</h5><div class=\"col-md-12 no-pad-l-r\"><span disabled=\"true\" class=\"form-control\">{{currentDataInTimeline.status}}</span></div></div><div class=\"col-md-12\"><h5>Note cambio di stato</h5><div class=\"col-md-12 no-pad-l-r\"><textarea rows=\"4\" class=\"col-md-12\" readonly=\"\">{{currentDataInTimeline.status_note}}</textarea></div></div><div class=\"col-md-4 form-group\"><h5>Issue</h5><six-lookup sx-id=\"issue\" sx-base-path=\"\'issue\'\" sx-type=\"\'record\'\" ng-model=\"currentDataInTimeline\" sx-field=\"\'issue_id\'\" sx-war=\"\'six-plan\'\" sx-disabled=\"\'true\'\"></six-lookup></div><div class=\"col-md-4 form-group\"><h5>Tipo Asset</h5><six-lookup-2 sx-id=\"issue-schema\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" sx-title=\"\'Tipo asset\'\" ng-model=\"currentDataInTimeline.model\" sx-field=\"\'type_id\'\" sx-filter=\"typeIdFilter\" sx-disabled=\"\'true\'\"></six-lookup-2></div><div class=\"col-md-4 form-group\"><h5>Asset</h5><six-lookup-2 sx-id=\"issue-asset\" sx-base-path=\"\'record\'\" sx-title=\"\'Asset\'\" ng-model=\"data.model\" sx-type=\"currentDataInTimeline.model.type_id.UUID\" sx-field=\"\'record_id\'\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-disabled=\"\'true\'\"></six-lookup-2></div><div class=\"col-md-4 form-group\"><h5>Data inserimento</h5><div class=\"col-md-12 no-pad-l-r\"><six-date-time-picker id=\"tl_date_insertion_issue\" name=\"date_insertion_issue\" ng-model=\"currentDataInTimeline.date_insertion\" sx-disabled=\"\'false\'\" date-options=\"dateOptions\" ng-if=\"data.generated_by==\'issue\'\"></six-date-time-picker><six-date-time-picker id=\"tl_date_insertion_plan\" name=\"date_insertion_plan\" ng-model=\"currentDataInTimeline.dataIn\" sx-disabled=\"\'false\'\" date-options=\"dateOptions\" ng-if=\"data.generated_by==\'plan\'\"></six-date-time-picker></div></div><div class=\"col-md-4 form-group\"><h5>Data richiesta</h5><div class=\"col-md-12 no-pad-l-r\"><six-date-time-picker id=\"tl_date_requested\" name=\"date_requested\" ng-model=\"currentDataInTimeline.date_requested\" sx-disabled=\"\'false\'\" date-options=\"dateOptions\"></six-date-time-picker></div></div><div class=\"col-md-4 form-group\"><h5>Data di presa in carico</h5><div class=\"col-md-12 no-pad-l-r\"><six-date-time-picker id=\"tl_date_handling\" name=\"date_handling\" ng-model=\"currentDataInTimeline.date_handling\" sx-disabled=\"\'false\'\" date-options=\"dateOptions\"></six-date-time-picker></div></div><div class=\"col-md-4 form-group\"><h5>Data chiusura</h5><div class=\"col-md-12 no-pad-l-r\"><six-date-time-picker id=\"tl_date_closing\" name=\"date_closing\" ng-model=\"currentDataInTimeline.date_closing\" sx-disabled=\"\'false\'\" date-options=\"dateOptions\"></six-date-time-picker></div></div></div><div class=\"col-md-12\"><div sf-schema=\"schemaDataInTimeline\" sf-form=\"formDataInTimeline\" sf-model=\"currentDataInTimeline.model\" sf-options=\"{ formDefaults: { readonly: true } }\"></div></div></div></div></div></div></uib-tab><uib-tab index=\"2\" disable=\"!data.version\"><uib-tab-heading><span class=\"fa fa-book text-info-dker\"></span> Allegati</uib-tab-heading><six-tree-attachments nodes=\"attachments\" save-callback=\"updAttachments()\" sx-tag-filter=\"\'class=odl\'\"></six-tree-attachments></uib-tab><uib-tab index=\"3\" disable=\"!data.version\" select=\"getMessage(); messaggio == undefined ? messaggio = true : angular.noop()\"><uib-tab-heading><span class=\"fa fa-envelope text-info-dker\"></span> Messaggio</uib-tab-heading><div class=\"col-md-12\" ng-if=\"loadingSixMail == true\"><uib-progressbar class=\"progress-striped active\" type=\"info\"><i>Caricamento messaggio</i></uib-progressbar></div><six-send-email ng-if=\"loadingSixMail == false && messaggio\" sx-title-mail=\"objMail.title\" sx-body-mail=\"objMail.message\" sx-to-mail=\"objMail.to\" sx-cc-mail=\"objMail.cc\" sx-type-mail=\"\'odl\'\" sx-record-id=\"currentOdlRef\"></six-send-email></uib-tab><uib-tab index=\"4\" disable=\"!data.version\"><uib-tab-heading><span class=\"fa fa-qrcode text-info-dker\"></span> QRCODE</uib-tab-heading><qrcode version=\"5\" error-correction-level=\"H\" size=\"274\" data=\"{{data.UUID}}\"></qrcode></uib-tab><uib-tab index=\"5\" disable=\"!data.version\" select=\"notificationUuid = data.UUID\" deselect=\"notificationUuid = undefined\"><uib-tab-heading><span class=\"icon-bell text-info-dker\"></span> Notifiche</uib-tab-heading><ict-notifications ict-type=\"\'odl\'\" ict-uuid=\"notificationUuid\" ict-detail-view=\"sidebar\"></ict-notifications></uib-tab></uib-tabset></div></div></uib-tab><uib-tab index=\"1\" disable=\"!data.version\" select=\"preventivi == undefined ? preventivi = true : angular.noop()\"><uib-tab-heading><span class=\"fa fa-list-alt text-info-dker\"></span> Preventivi</uib-tab-heading><div class=\"panel-body m-t-n\"><ict-odl-estimate ng-if=\"data.version && preventivi\" ict-odl=\"data\" ict-odl-status=\"data.status\" ict-odl-uuid=\"data.UUID\" ict-manage=\"true\"></ict-odl-estimate></div></uib-tab><uib-tab index=\"2\" disable=\"!data.version\" select=\"consuntivi == undefined ? consuntivi = true : angular.noop()\"><uib-tab-heading><span class=\"fa fa-list-alt text-info-dker\"></span> Consuntivi</uib-tab-heading><div class=\"panel-body m-t-n\"><ict-odl-consumptive ng-if=\"data.version && consuntivi\" ict-odl=\"data\" ict-odl-status=\"data.status\" ict-odl-uuid=\"data.UUID\" ict-manage=\"true\"></ict-odl-consumptive></div></uib-tab><uib-tab index=\"3\" disable=\"!issue.version\" select=\"segnalazione == undefined ? segnalazione = true : angular.noop()\"><uib-tab-heading><span class=\"fa fa-list-alt text-info-dker\"></span> Segnalazione</uib-tab-heading><div class=\"panel-body m-t-n\"><ict-issue ng-if=\"segnalazione\" issue-id=\"issue.UUID\" issue-obj-full=\"issue\" config=\"issueDisplayConfig\"></ict-issue></div></uib-tab></uib-tabset></div></div>");
$templateCache.put("plan/odl/odl_detail_issue.html","<div class=\"wrapper\"><div class=\"row m-b-xs\"><div class=\"col-md-12\"><div class=\"list-group-item clearfix b-l-3x b-l-primary\"><div class=\"col-md-3 form-group\"><label class=\"control-label\">Data inserimento</label><six-date-time-picker name=\"date_insertion\" ng-model=\"data.date_insertion\" date-options=\"dateOptions\" sx-disabled=\"true\"></six-date-time-picker></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Data richiesta</label><six-date-time-picker name=\"date_requested\" ng-model=\"data.date_requested\" date-options=\"dateOptions\"></six-date-time-picker></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Data inizio lavori</label><six-date-time-picker name=\"date_handling\" ng-model=\"data.date_handling\" date-options=\"dateOptions\"></six-date-time-picker></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Data chiusura</label><six-date-time-picker name=\"date_closing\" ng-model=\"data.date_closing\" date-options=\"dateOptions\"></six-date-time-picker></div></div></div></div><div class=\"row\"><div class=\"col-md-12 m-t\"><div class=\"list-group-item clearfix b-l-3x b-l-info\"><div class=\"col-md-3 form-group format-h-odl\"><label class=\"control-label\">Segnalazione</label><six-lookup sx-id=\"issue\" sx-base-path=\"\'issue\'\" sx-type=\"\'record\'\" ng-model=\"data\" sx-field=\"\'issue_id\'\" sx-auto-init=\"isNew\" sx-war=\"\'six-plan\'\" sx-filter=\"issueRefreshed.filter\"><button class=\"btn btn-default\" ng-click=\"goToIssue()\" ng-disabled=\"!data.issue_id\"><i class=\"fa fa-external-link\"></i></button></six-lookup><label class=\"checkbox i-checks m-b inline\"><input id=\"check-1\" type=\"checkbox\" ng-model=\"issueRefreshed.bool\"><i></i> <span class=\"i-checks\">Filtra per segnalazioni non \"associate\"</span></label></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Elemento tecnologico</label><six-lookup-2 sx-id=\"odl-schema\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" ng-model=\"data.model\" sx-field=\"\'type_id\'\" sx-auto-init=\"isNew\" sx-filter=\"typeIdFilter\" sx-compact=\"true\" sx-item-template=\"\'{{item.description}}\'\" sx-show-details=\"false\" sx-show-filters=\"false\" sx-required=\"true\"></six-lookup-2></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Asset</label><six-lookup-2 sx-id=\"asset\" sx-base-path=\"\'record\'\" sx-type=\"data.model.type_id.UUID\" ng-model=\"data.model\" sx-field=\"\'record_id\'\" sx-auto-init=\"isNew\" sx-show-list=\"false\" sx-show-tree=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-required=\"true\"></six-lookup-2></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Servizio</label><six-lookup-2 sx-id=\"service\" ng-model=\"data.model\" sx-type=\"\'servizio\'\" sx-base-path=\"\'record\'\" sx-field=\"\'service_id\'\" sx-auto-init=\"isNew\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-required=\"true\"></six-lookup-2></div></div></div></div></div>");
$templateCache.put("plan/odl/odl_detail_plan.html","<div class=\"wrapper\"><div class=\"row\"><div class=\"col-md-6\"><h4>Parametri da Programmata</h4></div></div><div class=\"row\"><div class=\"col-md-4 m-t\"><label for=\"date_requested\" class=\"control-label\">Data pianifica</label><div class=\"input-group\" style=\"width:100%\"><six-date-time-picker id=\"date_requested\" name=\"date_requested\" ng-model=\"data.date_requested\" date-options=\"dateOptions\"></six-date-time-picker></div></div><div class=\"col-md-4 m-t\"><label for=\"date_handling\" class=\"control-label\">Data inizio lavori</label><div class=\"input-group\" style=\"width:100%\"><six-date-time-picker id=\"date_handling\" name=\"date_handling\" ng-model=\"data.date_handling\" date-options=\"dateOptions\"></six-date-time-picker></div></div><div class=\"col-md-4 m-t\"><label for=\"date_closing\" class=\"control-label\">Data chiusura</label><div class=\"input-group\" style=\"width:100%\"><six-date-time-picker id=\"date_closing\" name=\"date_closing\" ng-model=\"data.date_closing\" date-options=\"dateOptions\"></six-date-time-picker></div></div><div class=\"col-md-4 m-t\"><label for=\"dataIn\" class=\"control-label\">Data inserimento</label><p class=\"input-group\" style=\"width:100%\"><six-date-time-picker id=\"dataIn\" name=\"dataIn\" ng-model=\"data.dataIn\" date-options=\"dateOptions\" sx-disabled=\"true\"></six-date-time-picker></p></div><div class=\"col-md-4 m-t\"><label for=\"generationTag\" class=\"control-label\">Codice generazione</label><div class=\"input-group\" style=\"width:100%\"><input id=\"generationTag\" type=\"text\" value=\"{{data.model.generation_tag}}\" class=\"form-control\" readonly=\"\"></div></div><div class=\"col-md-4 m-t\"><label for=\"record_istatusd_type\" class=\"control-label\">Stato</label><div class=\"input-group\" style=\"width:100%\"><input id=\"record_istatusd_type\" type=\"text\" value=\"{{odlWorkflow.getReadableStatus(data.status)}}\" class=\"form-control\" readonly=\"\"></div></div></div><div class=\"row\"><div class=\"col-md-6 m-t\" ng-if=\"data.is_aggregated\"><div class=\"list-group-item clearfix b-l-3x b-l-info\"><div class=\"col-md-8\"><label for=\"record_id\" class=\"control-label\">Asset</label><div class=\"input-group\" style=\"width:100%\"><input id=\"record_id\" type=\"text\" value=\"{{data.model.record_id.code}} - {{data.model.record_id.description}}\" class=\"form-control\" readonly=\"\"></div></div><div class=\"col-md-4\"><label for=\"record_id_type\" class=\"control-label\">Elemento tecnologico</label><div class=\"input-group\" style=\"width:100%\"><input id=\"record_id_type\" type=\"text\" value=\"{{data.model.type_id.description}}\" class=\"form-control\" readonly=\"\"></div></div><div class=\"col-md-8 m-t\"><label for=\"user\" class=\"control-label\">Generato per l\'elemento tecnologico</label><div class=\"input-group\" style=\"width:100%\"><input id=\"user\" type=\"text\" value=\"{{data.model.target_type_id.description}}\" class=\"form-control\" readonly=\"\"></div></div><div class=\"col-md-4 m-t\"><label class=\"control-label\"></label><div class=\"input-group\" style=\"width:100%\"><button class=\"btn btn-default m-t-xs\" style=\"width:100%\" ng-click=\"showAssetsList()\" data-toggle=\"collapse\" data-target=\"#assetsList\"><span class=\"fa fa-search\"></span> Asset ({{data.model.targets.length}})</button></div></div><div class=\"col-md-12 m-t collapse\" id=\"assetsList\"><h4 class=\"override-h4-no-margin\">Dettaglio asset</h4><hr class=\"m-t-sm\"><div class=\"m-t-n-sm\"><div ng-repeat=\"asset in data.model.targets\">{{asset.code}} - {{asset.description}}</div></div></div></div></div><div class=\"col-md-6 m-t\" ng-if=\"!data.is_aggregated\"><div class=\"list-group-item clearfix b-l-3x b-l-info\"><div class=\"col-md-8\"><label for=\"record_id\" class=\"control-label\">Asset</label><div class=\"input-group\" style=\"width:100%\"><input name=\"record_id\" type=\"text\" value=\"{{data.model.record_id.code}} - {{data.model.record_id.description}}\" class=\"form-control\" readonly=\"\"></div></div><div class=\"col-md-4\"><label for=\"record_id_type\" class=\"control-label\">Tipo di Asset</label><div class=\"input-group\" style=\"width:100%\"><input name=\"record_id_type\" type=\"text\" value=\"{{data.model.type_id.description}}\" class=\"form-control\" readonly=\"\"></div></div></div></div><div class=\"col-md-6 m-t\"><div class=\"list-group-item clearfix b-l-3x b-l-primary\"><div class=\"col-md-8\"><label for=\"record_id\" class=\"control-label\">Compito</label><div class=\"input-group\" style=\"width:100%\"><input name=\"record_id\" type=\"text\" value=\"{{data.task_id.description}}\" class=\"form-control\" readonly=\"\"></div></div><div class=\"col-md-4\"><label class=\"control-label\"></label><div class=\"input-group\" style=\"width:100%\"><button class=\"btn btn-default m-t-xs\" style=\"width:100%\" data-toggle=\"collapse\" data-target=\"#activitiesList\"><span class=\"fa fa-search\"></span> Attività ({{data.task_activities.length}})</button></div></div><div class=\"col-md-12 m-t collapse\" id=\"activitiesList\"><h4 class=\"override-h4-no-margin\">Dettaglio attività</h4><hr class=\"m-t-sm\"><div class=\"m-t-n-sm\"><ul><li ng-repeat=\"activity in data.task_activities\">{{activity.description}}</li></ul></div></div></div></div></div></div>");
$templateCache.put("plan/odl/odl_list.html","<six-toolbar><six-toolbar-button label=\"Stampa\" icon=\"fa fa-print\" toolbar-function=\"printSelectedOdl()\" sx-disabled=\"getSelectedRows().length == 0\"></six-toolbar-button><six-toolbar-button label=\"Genera Odl\" icon=\"fa fa-plus\" toolbar-function=\"newOdl()\" sx-disabled=\"isWritePermAllowed() === false\"></six-toolbar-button><six-toolbar-button label=\"Modifica\" icon=\"fa fa-pencil\" toolbar-function=\"bulkEdit()\" sx-disabled=\"isUpdatePermAllowed() === false || getSelectedRows().length == 0\"></six-toolbar-button><six-toolbar-button label=\"Chiudi Odl\" icon=\"fa fa-trash\" toolbar-function=\"massiveClosingOdl()\" sx-disabled=\"isUpdatePermAllowed() === false || getSelectedRows().length == 0\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" sx-disabled=\"!isDeletePermAllowed() || getSelectedRows().length == 0\" ng-confirm-message=\"Sei sicuro?\" ng-confirm-click=\"deleteOdlSelected()\" ng-confirm-condition=\"true\"></six-toolbar-button><six-toolbar-button label=\"Tutti\" icon=\"fa fa-square-o\" icon-disabled=\"fa fa-check-square-o\" icon-condition=\"bool.allOdl\" toolbar-function=\"toggleAllOdl()\" ng-show=\"searchAllPermAllowed()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"refresh()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista ODL</h1></div></div></div><div class=\"panel-body\"><six-bulk-editor class=\"col-md-12\" ng-if=\"bulkEditorVisible\" sx-cancel=\"bulkEditConf.cancel()\" sx-post-save=\"bulkEditConf.postSave()\" sx-data-getter=\"bulkEditConf.dataGetter()\" sx-save=\"bulkEditConf.factory(payload)\" sx-compact-schema=\"bulkEditConf.compactSchema\" sx-schema-form=\"bulkEditConf.schemaForm\" sx-schema-form-prefix=\"model\" sx-callbacks=\"bulkEditConf.callbacks\"></six-bulk-editor><div class=\"col-sm-12\"><div class=\"col-sm-12 btn btn-default\" style=\"text-align: left\" ng-click=\"isAssetTreeFilterOpen = !isAssetTreeFilterOpen\">Filtro asset avanzato <i class=\"fa pull-right\" ng-class=\"{\'fa-chevron-down\': !isAssetTreeFilterOpen, \'fa-chevron-up\': isAssetTreeFilterOpen}\"></i></div><div uib-collapse=\"!isAssetTreeFilterOpen\"><div class=\"well well-lg\"><p><br>Seleziona specifici asset per filtrare gli ODL sull\'asset stesso e i suoi sottoelementi.</p><div ng-repeat=\"(key, rule) in assetTreeFilter\" class=\"list-group-item b-l-primary b-l-3x m-b hover-anchor hover\"><span ng-click=\"removeParentFilter(key)\" class=\"pull-right text-muted hover-action\" role=\"button\" tabindex=\"0\"><i class=\"fa fa-times\"></i></span> <span class=\"block attr row\"><div class=\"col-md-6 form-group\"><label class=\"control-label\">Elemento tecnologico</label><six-lookup-2 sx-id=\"parentLookup_{{key}}\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" sx-field=\"\'type_id\'\" ng-model=\"rule.type\" sx-filter=\"typeIdFilter\" sx-compact=\"true\" sx-item-template=\"\'{{item.description}}\'\" sx-show-details=\"false\" sx-show-filters=\"false\"></six-lookup-2></div><div class=\"col-md-5 form-group\"><label class=\"control-label\">Asset</label><six-lookup-2 sx-id=\"asset\" sx-base-path=\"\'record\'\" sx-type=\"rule.type.type_id.UUID\" ng-model=\"rule.item\" sx-field=\"\'record_id\'\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div></span></div><div><button class=\"btn btn-success\" ng-click=\"addParentFilter()\"><i class=\"fa fa-plus\"></i> Aggiungi radice</button> <button class=\"btn btn-danger\" ng-click=\"resetTreeFiltering()\"><i class=\"fa fa-close\"></i> Reset filtri</button> <button class=\"btn btn-primary pull-right\" ng-click=\"refresh()\"><i class=\"fa fa-search\"></i> Filtra risultati</button></div></div></div></div><div class=\"col-sm-12 m-t\"><six-grid-pagination sx-id=\"plan_odl_grid\" get-data-callback=\"getCurrentUserOdlList()\" get-list-callback=\"getCurrentUserOdlList()\" items-list=\"odlList\" grid-options=\"viewGridOptions\" column-defs=\"viewGridOptions.columnDefs\" params=\"params\" auto-resize-params=\"autoResizeParams\" show-global-search=\"false\" enable-state-saving=\"true\" grid-app-callbacks=\"gridAppCallbacks\"></six-grid-pagination></div></div></div></div>");
$templateCache.put("plan/odl/odlconfigurator_detail.html","<six-toolbar><six-toolbar-button label=\"Lista\" icon=\"fa fa-chevron-left\" toolbar-function=\"back()\"></six-toolbar-button><six-toolbar-button label=\"Duplica\" btn-class=\"btn-primary\" icon=\"fa fa-files-o\" toolbar-function=\"setConfModel()\" ng-if=\"selected.version\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"fa fa-trash-o\" toolbar-function=\"delete()\" sx-disabled=\"!isDeletePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"saveForm()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Dettaglio Configurazione</h1></div></div></div><div class=\"wrapper\"><div class=\"panel-heading\" style=\"background-color: transparent\"><div class=\"page-header-bleed-right\"><div class=\"actions\"><div class=\"row\"><form name=\"header\"><div class=\"form-group\"><div class=\"col-md-12\"><label class=\"control-label\">Codice:</label> <input type=\"text\" class=\"form-control\" ng-model=\"commissionCode\" ng-disabled=\"bool.isCross || bool.isCallCenter\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"!bool.isCross && !bool.isCallCenter\"><label class=\"col-md-1 control-label\">Commesse:</label><div class=\"col-md-12\"><div id=\"vectors_budget_code\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"commissionsSelected.codes\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Selezionare una commessa...\">{{$item.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in commissions\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div></div><div class=\"col-md-12\"><input type=\"checkbox\" ng-model=\"bool.isCross\" name=\"cross_commission\" ng-click=\"updateCode()\"> <label class=\"control-label\">Imposta come configurazione di default per gli utenti (cross-commessa)</label></div></div></form></div></div></div></div><div class=\"panel-body\"><uib-tabset justified=\"true\"><uib-tab heading=\"Preview\"><form name=\"myForm\" sf-schema=\"schema\" sf-form=\"form\" sf-model=\"model\" ng-submit=\"onSubmit(myForm)\"></form></uib-tab><uib-tab heading=\"Schema\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><div class=\"col-md-12 centered\"><b>SCHEMA</b></div><div class=\"col-md-12 override-padding-no-pad-left-right\"><hr class=\"override-margin-top-bottom\"></div><div class=\"col-md-12 centered\"><div class=\"col-md-2 col-md-offset-1\"><b>CODICE</b></div><div class=\"col-md-3\"><b>DESCRIZIONE</b></div><div class=\"col-md-1\"><b>TIPOLOGIA</b></div><div class=\"col-md-2\"><b>FORMATO</b></div></div><div class=\"col-md-12 override-padding-no-pad-left-right\"><hr class=\"override-margin-top-bottom\"></div><div class=\"col-md-12 centered\"><div class=\"col-md-2 col-md-offset-1\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><form name=\"propertyKeyForm\"><input class=\"form-control\" name=\"property_key\" placeholder=\"Codice...\" type=\"text\" ng-model=\"property.key\" pattern=\"^[a-zA-Z]+[\\w]*$\"><div role=\"alert\"><span class=\"badge bg-danger badge-sm m-l-xs\" ng-show=\"propertyKeyForm.property_key.$error.pattern\">Caratteri non consentiti</span></div></form></div></div><div class=\"col-md-3\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><input class=\"form-control\" placeholder=\"Descrizione\" type=\"text\" ng-model=\"property.title\"></div></div><div class=\"col-md-1\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><select class=\"form-control\" ng-model=\"property.type\"><option></option><option value=\"string\">string</option><option value=\"number\">number</option><option value=\"integer\">integer</option><option value=\"boolean\">boolean</option><option value=\"date\">date</option><option value=\"array\">array</option></select></div></div><div class=\"col-md-2\"><div class=\"col-md-12 override-padding-no-pad-left-right\"><select class=\"form-control\" ng-model=\"property.format\" ng-if=\"(property.type == \'string\')\"><option></option><option value=\"lookup\">lookup</option><option value=\"formula\">formula</option><option value=\"enum\">enum</option></select><select class=\"form-control\" ng-model=\"property.format\" ng-if=\"(property.type == \'number\' || property.type == \'integer\')\"><option></option><option value=\"formula\">formula</option><option value=\"enum\">enum</option></select><select class=\"form-control\" ng-model=\"property.items_type\" ng-if=\"(property.type == \'array\')\"><option></option><option value=\"lookup\">lookup</option><option value=\"string\">string</option><option value=\"number\">number</option><option value=\"integer\">integer</option><option value=\"date\">date</option></select></div></div><div class=\"col-md-2\"><div ng-if=\"isInheritable(property.type)\"><label><input type=\"checkbox\" ng-model=\"property.inherited\"> Campo ereditato</label></div></div><div class=\"col-md-1\"><button ng-click=\"addProperty()\" class=\"btn btn-sm btn-info pull-right\"><span class=\"fa fa-plus\"></span> Add</button></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-repeat=\"(key, value) in selected.model.schema.properties\" style=\"align-content: center; padding-bottom: 0px;\"><div class=\"col-md-12 uniform-height\" style=\"align-content: center;\"><div class=\"col-md-1\"><a href=\"\" ng-click=\"status[key].open = !status[key].open\" id=\"btn_row_detail\"><i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status[key].open, \'glyphicon-chevron-right\': !status[key].open}\"></i></a></div><div class=\"col-md-2\">{{ key }}</div><div class=\"col-md-3\">{{ value.title }}</div><div class=\"col-md-1\">{{ value.type }}</div><div class=\"col-md-2\"><span ng-if=\"value.format\">{{value.format}}</span> <span ng-if=\"value.type == \'array\' && value.items\">{{value.items.format}}</span></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-show=\"status[key].open\"><div class=\"col-md-12 uniform-height-2\" ng-if=\"value.format !== \'lookup\' && value.format !== \'formula\' && value.format !== \'enum\' && value.format !== \'inherit\' && value.type !== \'array\'\"><div class=\"col-md-2\">FORMATO:</div><div class=\"col-md-10\">{{value.format}}</div></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'inherit\'\" ng-include=\"\'dataset/modeltype/detail_inherit.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'lookup\' && value.type != \'array\'\" ng-include=\"\'dataset/modeltype/detail_lookup.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'formula\'\" ng-include=\"\'dataset/modeltype/detail_formula.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.format === \'enum\'\" ng-include=\"\'dataset/modeltype/detail_enum.html\'\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"value.type === \'array\'\" ng-include=\"\'dataset/modeltype/detail_array.html\'\"></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">ELIMINA:</div><div class=\"col-md-10\"><button ng-click=\"deleteProperty(key)\" class=\"btn btn-danger btn-xs btn-default\" ng-disabled=\"(key === \'code\' || key === \'description\')\"><i class=\"fa fa-trash\"></i></button></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">IN TABELLA:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.check\" ng-change=\"changeColumnDefs(key, value)\" ng-disabled=\"(key === \'code\' || key === \'description\')\"></div></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-show=\"value.check == true\"><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">LARGHEZZA (px):</div><div class=\"col-md-10\"><input type=\"text\" min=\"1\" step=\"1\" size=\"45\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=\"value.width\" ng-change=\"changeColumnDefs(key, value)\"></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">ORDINAMENTO:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.enableSorting\" ng-change=\"changeColumnDefs(key, value)\"></div></div><div class=\"col-md-12 uniform-height-2\"><div class=\"col-md-2\">FILTRAGGIO:</div><div class=\"col-md-10\"><input type=\"checkbox\" ng-model=\"value.enableFiltering\" ng-change=\"changeColumnDefs(key, value)\"></div></div></div><div class=\"col-md-12 override-padding-no-pad-left-right override-padding-top-bottom-modeltype\"><hr class=\"override-margin-top-bottom border-bold\"></div></div></div></div></uib-tab><uib-tab heading=\"Form\"><table class=\"table table-striped\"><thead><th colspan=\"5\">FORM</th><tr><th colspan=\"5\"><div class=\"form-group\"><label for=\"title\" class=\"control-label\">Titolo</label><div class=\"\"><input type=\"text\" class=\"form-control\" id=\"title\" placeholder=\"\" ng-model=\"title\" name=\"title\" ng-keyup=\"refreshTitleForm(title)\"></div></div></th></tr><tr><td></td><td></td><td><input type=\"text\" placeholder=\"Titolo...\" ng-model=\"newTab.title\"></td><td><button ng-click=\"addTab(selected.model.form[0].items[0])\" class=\"btn btn-xs btn-info\"><span class=\"fa fa-plus\"></span> Add</button></td></tr><tr><th></th><th>POSIZIONE</th><th>TITOLO</th><th></th></tr></thead><tbody><tr ng-repeat-start=\"(key, tab) in selected.model.form[0].items[0].tabs\"><td><a href=\"\" ng-click=\"statusForm[key].open = !statusForm[key].open\"><i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': statusForm[key].open, \'glyphicon-chevron-right\': !statusForm[key].open}\"></i></a></td><td><span class=\"btn btn-sm\" ng-click=\"swapUp(key, selected.model.form[0].items[0].tabs)\" ng-disabled=\"key<=0\"><i class=\"fa fa-caret-up\"></i></span> {{key+1}} <span class=\"btn btn-sm\" ng-click=\"swapDown(key, selected.model.form[0].items[0].tabs)\" ng-disabled=\"key>=selected.model.form[0].items[0].tabs.length-1\"><i class=\"fa fa-caret-down\"></i></span></td><td><input type=\"text\" ng-model=\"tab.title\" ng-disabled=\"(tab.key[0] == \'code\' || tab.key[0] == \'description\')\" ng-keyup=\"updateScope()\"></td><td><a ng-click=\"removeTabOrField(key, selected.model.form[0].items[0].tabs)\" class=\"btn btn-danger btn-xs btn-default\" id=\"btn_row_detail_form\"><i class=\"fa fa-trash\"></i></a></td></tr><tr ng-repeat-end=\"\" ng-show=\"statusForm[key].open\"><td></td><td colspan=\"3\" style=\"background-color:rgba(211, 211, 211, 0.38);\"><table class=\"table table-striped override-margin\"><tr><td></td><td><select ng-options=\"k as v.title for (k, v) in schema.properties\" ng-model=\"newFieldForm.key\"></select></td><td><input type=\"text\" placeholder=\"Titolo...\" ng-model=\"newFieldForm.title\"></td><td><input type=\"checkbox\" placeholder=\"Richiesto...\" ng-model=\"newFieldForm.required\"></td><td><input type=\"checkbox\" placeholder=\"Nascosto...\" ng-model=\"newFieldForm.htmlClass\" ng-true-value=\"\'hidden\'\" ng-false-value=\"\'\'\"></td><td><select ng-model=\"newFieldForm.type\" ng-change=\"updateScope()\"><option value=\"\"></option><option value=\"text\">text</option><option value=\"textarea\">textarea</option><option value=\"number\">number</option><option value=\"datepicker\">date</option><option value=\"password\">password</option><option value=\"checkbox\">checkbox</option><option value=\"select\">enum</option><option value=\"array\">array</option><option value=\"sixlookup\">lookup</option><option value=\"inherited\">ereditato</option><option value=\"formula\">formula</option></select></td><td><button ng-click=\"addFieldToTab(tab)\" class=\"btn btn-xs btn-info\"><span class=\"fa fa-plus\"></span> Add</button></td></tr><tr><th>POSIZIONE</th><th>CAMPO</th><th>TITOLO</th><th>REQUIRED</th><th>NASCOSTO</th><th>TIPO</th><th></th></tr><tr ng-repeat=\"(fieldKey, field) in tab.items\"><td class=\"override-width-200px\"><div><span class=\"btn btn-sm\" ng-click=\"swapUp(fieldKey, tab.items)\" ng-disabled=\"fieldKey<=0\"><i class=\"fa fa-caret-up\"></i></span> {{fieldKey+1}} <span class=\"btn btn-sm\" ng-click=\"swapDown(fieldKey, tab.items)\" ng-disabled=\"fieldKey>=tab.items.length-1\"><i class=\"fa fa-caret-down\"></i></span></div></td><td ng-if=\"!field.title\">{{field}}</td><td ng-if=\"!field.title\"></td><td ng-if=\"!field.title\"></td><td ng-if=\"!field.title\"></td><td ng-if=\"field.title\">{{field.key[0]}}</td><td ng-if=\"field.title\"><input type=\"text\" ng-model=\"field.title\" ng-keyup=\"updateScope()\"></td><td ng-if=\"field.title\"><input type=\"checkbox\" ng-model=\"field.required\" ng-change=\"updateScope()\"></td><td ng-if=\"field.title\"><input type=\"checkbox\" ng-model=\"field.htmlClass\" ng-change=\"updateScope()\" ng-true-value=\"\'hidden\'\" ng-false-value=\"\'\'\"></td><td ng-if=\"field.title\"><select ng-model=\"field.type\" ng-change=\"updateField(field)\"><option value=\"\"></option><option value=\"text\">text</option><option value=\"textarea\">textarea</option><option value=\"number\">number</option><option value=\"datepicker\">date</option><option value=\"password\">password</option><option value=\"checkbox\">checkbox</option><option value=\"select\">enum</option><option value=\"array\">array</option><option value=\"sixlookup\">lookup</option><option value=\"inherited\">ereditato</option><option value=\"formula\">formula</option></select></td><td><a ng-click=\"removeTabOrField(fieldKey, tab.items)\" class=\"btn btn-danger btn-xs btn-default\"><i class=\"fa fa-trash\"></i></a></td></tr></table></td></tr></tbody></table></uib-tab></uib-tabset></div><div class=\"panel-footer\"><div class=\"form-group\"><input id=\"jsonShowCheck\" type=\"checkbox\" ng-model=\"jsonshow\" class=\"pull-left\" data-toggle=\"collapse\" data-target=\"#json-collapse\"> <label for=\"jsonShowCheck\" class=\"pull-left control-label\">Dettaglio avanzato</label></div></div><div class=\"row collapse\" id=\"json-collapse\" collapse=\"!jsonshow\"><div class=\"col-md-8\"><div class=\"panel no-border\"><div class=\"panel-heading wrapper b-b b-light\"><h4 class=\"font-thin m-t-none m-b-none text-muted\">Dettaglio</h4></div><div style=\"margin-top:0px;\" ui-ace=\"{ useWrapMode : true, showGutter: true, mode: \'json\', firstLineNumber: 1, onLoad: aceLoaded, onChange: aceChanged }\" ng-model=\"aceModel\"></div></div></div><div class=\"col-md-4\"><div class=\"list-group list-group-lg list-group-sp\"><pre>{{ model}}</pre></div></div></div></div></div></div>");
$templateCache.put("plan/odl/odlconfigurator_list.html","<six-toolbar><six-toolbar-button label=\"Crea modello ODL\" icon=\"fa fa-plus\" toolbar-function=\"newOdl()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"refresh()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista Configurazioni ODL</h1></div></div></div><div class=\"panel-body\"><div class=\"form-group\"><input ng-keyup=\"getData(queryParam)\" class=\"form-control\" type=\"text\" ng-model=\"queryParam\" placeholder=\"Type here to filter the list...\"></div><table id=\"odl_configurator_list\" class=\"table table-striped\"><thead><tr><th></th><th>CODICE CONFIGURAZIONE</th><th>COMMESSA</th><th>DATA</th></tr></thead><tbody><tr ng-repeat=\"item in odlConfiguratorList.list\"><td><a ng-href=\"#/odlconfigurator/{{item.UUID}}\" class=\"btn btn-default\" id=\"btn_issue_detail\"><span class=\"fa fa-search\"></span></a></td><td>{{ item.model.code }}</td><td>{{printCommission(item.model.commission)}}</td><td>{{ item.dataIn | date:\'dd/MM/yyyy\' }}</td></tr><tr ng-hide=\"odlConfiguratorList.list.length\"><td><p class=\"text-center\">Nessun record recuperato</p></td></tr></tbody></table></div><div class=\"panel-footer\"><div class=\"row text-center\"><uib-pagination ng-change=\"pageChanged()\" boundary-links=\"true\" total-items=\"odlConfiguratorList.totalResults\" ng-model=\"odlConfiguratorList.currentPage\" class=\"pagination-sm\" items-per-page=\"odlConfiguratorList.pageSize\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></uib-pagination></div></div></div></div>");
$templateCache.put("plan/plan/plan_detail.html","<style type=\"text/css\">\n.center-open{\n    padding-left: 295px;\n}\n\n  .selected {\n    background-color: #11c7f5 !important;\n  }\n\n  #frequency-popup{\n      width: 100%;\n      margin-top: 6px;\n  }\n\n  #frequency-popup .title{\n      line-height: 36px;\n      font-size: 16px;\n      text-align: center;\n  }\n\n  .uib-clear{\n    display: none;\n  }\n\n  .transparent{\n      opacity: 0;\n  }\n\n  .list-sidebar-overlay.active {\n      visibility: hidden;\n  }\n</style><six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" toolbar-function=\"stepBack()\"></six-toolbar-button><six-toolbar-button label=\"Salva programmata\" btn-class=\"btn-success\" icon=\"fa fa-save\" ng-hide=\"step!=STEP.DESCRIPTION\" toolbar-function=\"saveForm()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Elimina programmata\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" toolbar-function=\"delete(plan.version)\" ng-hide=\"(!plan.version || (step!=STEP.DESCRIPTION))\" sx-disabled=\"!isDeletePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Simula\" btn-class=\"btn-primary-override\" icon=\"icon-magic-wand\" ng-hide=\"(!plan.version || step!=STEP.DESCRIPTION)\" toolbar-function=\"goToSimulation()\"></six-toolbar-button><six-toolbar-button label=\"Salva e genera\" btn-class=\"btn-info\" icon=\"icon-rocket\" ng-hide=\"(!plan.version || step!=STEP.SIMULATION)\" toolbar-function=\"goToGeneration()\" sx-disabled=\"!simulationOk || !isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Riepilogo\" btn-class=\"btn-warning\" icon=\"icon-share-alt\" ng-hide=\"(!plan.version || step!=STEP.GENERATION)\" toolbar-function=\"goToPlanOdlList()\"></six-toolbar-button></six-toolbar><div class=\"list-sidebar-overlay\"></div><aside id=\"list-sidebar\" class=\"list-sidebar list-sidebar-default list-sidebar-stacked custom-six-sidebar\" role=\"navigation\"><div class=\"panel sidebar-panel\"><button class=\"btn btn-info pull-left\" ng-click=\"closeSidebar()\"><span class=\"fa fa-times icon-only\"></span></button> <button class=\"btn btn-info pull-right\" ng-click=\"confirmSelectAssets()\"><span class=\"fa fa-check icon-only\"></span></button><div class=\"panel-heading bg-info sidebar-heading\">Seleziona Asset</div></div><ul class=\"nav list-sidebar-nav\"><li><div class=\"form-group m-l-xs m-r-xs m-t-xs\"><six-search-form ng-model=\"assetFilter\" placeholder=\"Filtra...\" show-search-btn=\"false\"></six-search-form><span class=\"input-group-btn\"><button class=\"btn btn-default btn-sm\" title=\"Seleziona tutti\" style=\"width:50%\" ng-click=\"selectAllAddCheck()\"><i class=\"fa fa-square\"></i> Seleziona tutti</button> <button class=\"btn btn-default btn-sm\" title=\"Deseleziona tutti\" style=\"width:50%\" ng-click=\"unselectAllAddCheck()\"><i class=\"fa fa-square-o\"></i> Deseleziona tutti</button></span></div></li><li ng-show=\"availableAssets.length==0\" style=\"text-align:center\"><span style=\"width:100%;\">Nessun <strong>{{plan.model.model_type.description}}</strong> trovato</span></li><li ng-repeat=\"asset in availableAssets | filter:assetFilter as filteredAssets\" class=\"m-l-xs m-r-xs\"><label class=\"checkbox i-checks m-b-sx\" ng-hide=\"isDisabledAsset(asset.UUID)\"><input type=\"checkbox\" ng-model=\"addCheckModel[$index]\" ng-disabled=\"isDisabledActivity(isDisabledAsset.UUID)\"><i></i>{{asset.model.code}} - {{asset.model.description}}</label></li></ul></aside><div class=\"col-md-12 override-padding-toolbar center-page\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Attività Programmata</h1><small>Compito: {{plan.model.task_id.code}} - {{plan.model.task_id.description | cut:true:100:\'...\'}}</small></div></div></div><div class=\"wrapper\"><div class=\"panel-body\"><six-search-terms sx-filter=\"searchFilterObj\" sx-filter-description=\"plan.model.search_filter.description\" sx-filter-description-long=\"plan.model.search_filter.description_long\" sx-filter-description-short=\"plan.model.search_filter.description_short\" sx-filter-init=\"searchFilterArray\" sx-id=\"{{sxSearchTerms.id}}\" sx-open=\"sxSearchTerms.open\" sx-filter-only=\"true\" sx-model=\"sxSearchTerms\" sx-on-filter-changed=\"onFilterChanged()\"></six-search-terms><uib-tabset active=\"step\"><uib-tab disable=\"(step!=STEP.DESCRIPTION)\" index=\"STEP.DESCRIPTION\"><uib-tab-heading><i class=\"icon-note text-success-dker\"></i> Descrizione</uib-tab-heading><div class=\"row\"><div class=\"col-md-3 col-sm-12 m-t-xs\"><label for=\"code\" class=\"control-label\">Codice</label><div class=\"input-group\" style=\"width:100%\"><input id=\"code\" name=\"code\" type=\"text\" ng-model=\"plan.model.code\" class=\"form-control\" ng-readonly=\"plan.version\" required=\"\"></div></div><div class=\"col-md-9 col-sm-12 m-t-xs\"><label for=\"description\" class=\"control-label\">Descrizione</label><div class=\"input-group\" style=\"width:100%\"><input id=\"description\" name=\"description\" type=\"text\" ng-model=\"plan.model.description\" required=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-md-3 col-sm-12 m-t\"><label for=\"service\" class=\"control-label\">Servizio</label><div class=\"input-group\" style=\"width:100%\"><six-lookup id=\"service\" ng-model=\"plan.model\" sx-type=\"\'servizio\'\" sx-field=\"\'service_id\'\"></six-lookup></div></div><div class=\"col-md-3 col-sm-12 m-t\"><label for=\"priority\" class=\"control-label\">Priorità</label><div class=\"input-group\" style=\"width:100%\"><six-lookup id=\"priority\" ng-model=\"plan.model\" sx-type=\"\'priorita\'\" sx-field=\"\'priority_id\'\"></six-lookup></div></div></div><div class=\"row m-t\"><div class=\"col-md-6 m-t\"><div class=\"list-group-item clearfix b-l-3x b-l-primary\"><div class=\"form-group\"><label for=\"task\" class=\"control-label\">Compito</label><six-lookup-2 id=\"task\" sx-id=\"task\" name=\"task\" sx-war=\"\'six-plan\'\" ng-model=\"plan.model\" sx-base-path=\"\'./\'\" sx-type=\"\'task\'\" sx-field=\"\'task_id\'\" sx-object=\"taskObj.obj\" sx-show-filters=\"true\" sx-disabled=\"plan.version\" sx-placeholder=\"\'Compito...\'\" required=\"\" aria-required=\"true\"></six-lookup-2></div><div class=\"form-group\" ng-if=\"taskObj.obj.model\"><label for=\"activity\" class=\"control-label\">Attività</label><six-lookup-2 id=\"activity\" sx-id=\"activity\" name=\"activity\" sx-war=\"\'six-plan\'\" sx-base-path=\"\'./\'\" ng-model=\"taskObj.obj.model\" sx-field=\"\'activities\'\" sx-multiple=\"true\" sx-type=\"\'activity\'\" sx-empty-placeholder=\"\'Attività...\'\" sx-add=\"true\" sx-show-details=\"true\" sx-prefill=\"{ model: {}}\" sx-on-select=\"activitiesModified()\"></six-lookup-2></div><div class=\"form-group\" ng-if=\"hasAttachments\"><h4 class=\"override-h4-no-margin\">Allegati</h4><hr class=\"m-t\"><div class=\"m-l-n-sm m-t-n-lg\"><six-tree-attachments nodes=\"attachments\" sx-readonly=\"true\"></six-tree-attachments></div></div></div></div><div class=\"col-md-6 m-t\"><div class=\"list-group-item clearfix b-l-3x b-l-warning\"><div class=\"input-group\" style=\"width:100%\"><label for=\"frequencySelect\" class=\"control-label\">Frequenza</label><select name=\"frequencySelect\" id=\"frequencySelect\" class=\"form-control\" ng-model=\"plan.model.frequency.type\" ng-click=\"closeFrequencyDetail()\"><option label=\"Settimanale\" value=\"{{EVERY.WEEK}}\">Settimanale</option><option label=\"Mensile\" value=\"{{EVERY.MONTH}}\">Mensile</option><option label=\"Bimestrale\" value=\"{{EVERY.MONTHx2}}\">Bimestrale</option><option label=\"Trimestrale\" value=\"{{EVERY.MONTHx3}}\">Trimestrale</option><option label=\"Quadrimestrale\" value=\"{{EVERY.MONTHx4}}\">Quadrimestrale</option><option label=\"Semestrale\" value=\"{{EVERY.MONTHx6}}\">Semestrale</option><option label=\"Annuale\" value=\"{{EVERY.YEAR}}\">Annuale</option><option label=\"Biennale\" value=\"{{EVERY.YEARx2}}\">Biennale</option><option label=\"Triennale\" value=\"{{EVERY.YEARx3}}\">Triennale</option><option label=\"Quadriennale\" value=\"{{EVERY.YEARx4}}\">Quadriennale</option><option label=\"Quinquennale\" value=\"{{EVERY.YEARx5}}\">Quinquennale</option><option label=\"6 anni\" value=\"{{EVERY.YEARx6}}\">6 anni</option></select></div><div><div class=\"m-t\" id=\"weekly-detail\" ng-show=\"isWeekly()\"><div class=\"btn-group\" role=\"group\" aria-label=\"Giorno\"><button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.dayOfWeek\" uib-btn-radio=\"\'{{DAY_OF_WEEK.MON}}\'\">Lun</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.dayOfWeek\" uib-btn-radio=\"\'{{DAY_OF_WEEK.TUE}}\'\">Mar</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.dayOfWeek\" uib-btn-radio=\"\'{{DAY_OF_WEEK.WEN}}\'\">Mer</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.dayOfWeek\" uib-btn-radio=\"\'{{DAY_OF_WEEK.THU}}\'\">Gio</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.dayOfWeek\" uib-btn-radio=\"\'{{DAY_OF_WEEK.FRI}}\'\">Ven</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.dayOfWeek\" uib-btn-radio=\"\'{{DAY_OF_WEEK.SAT}}\'\">Sab</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.dayOfWeek\" uib-btn-radio=\"\'{{DAY_OF_WEEK.SUN}}\'\">Dom</button></div></div><div class=\"m-t\" id=\"monthly-detail\" ng-show=\"isMonthly() || isAnnual()\"><div class=\"btn-group\" role=\"group\" aria-label=\"Mese\"><button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.dayOfMonth\" uib-btn-radio=\"\'{{DAY_OF_MONTH.FIRST}}\'\">1° del mese</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.dayOfMonth\" uib-btn-radio=\"\'{{DAY_OF_MONTH.MIDDLE}}\'\">15 del mese</button></div></div><div class=\"m-t\" id=\"annual-detail\" ng-show=\"isAnnual()\"><div class=\"btn-group btn-group-sm\" role=\"group\" aria-label=\"Giorno\"><button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.monthOfYear\" uib-btn-radio=\"\'{{MONTH_OF_YEAR.JAN}}\'\">Gen</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.monthOfYear\" uib-btn-radio=\"\'{{MONTH_OF_YEAR.FEB}}\'\">Feb</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.monthOfYear\" uib-btn-radio=\"\'{{MONTH_OF_YEAR.MAR}}\'\">Mar</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.monthOfYear\" uib-btn-radio=\"\'{{MONTH_OF_YEAR.APR}}\'\">Apr</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.monthOfYear\" uib-btn-radio=\"\'{{MONTH_OF_YEAR.MAY}}\'\">Mag</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.monthOfYear\" uib-btn-radio=\"\'{{MONTH_OF_YEAR.JUNE}}\'\">Giu</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.monthOfYear\" uib-btn-radio=\"\'{{MONTH_OF_YEAR.JULY}}\'\">Lug</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.monthOfYear\" uib-btn-radio=\"\'{{MONTH_OF_YEAR.AUG}}\'\">Ago</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.monthOfYear\" uib-btn-radio=\"\'{{MONTH_OF_YEAR.SEPT}}\'\">Set</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.monthOfYear\" uib-btn-radio=\"\'{{MONTH_OF_YEAR.OCT}}\'\">Ott</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.monthOfYear\" uib-btn-radio=\"\'{{MONTH_OF_YEAR.NOV}}\'\">Nov</button> <button type=\"button\" class=\"btn btn-default\" ng-model=\"plan.model.frequency.monthOfYear\" uib-btn-radio=\"\'{{MONTH_OF_YEAR.DEC}}\'\">Dic</button></div></div></div></div></div></div><div class=\"row\"><div class=\"col-md-12 m-t\"><div class=\"list-group-item clearfix b-l-3x b-l-info\"><div class=\"row\"><div class=\"col-md-4 col-sm-12 m-t-xs\"><label for=\"asset\" class=\"control-label\">Elemento tecnologico</label><six-lookup-2 ng-model=\"plan.model\" sx-base-path=\"\'schema\'\" sx-field=\"\'model_type\'\" sx-filter=\"typeIdFilter\" sx-placeholder=\"\'Tipo...\'\" sx-compact=\"true\" sx-item-template=\"\'{{item.description}}\'\" required=\"\" aria-required=\"true\"></six-lookup-2></div><div class=\"col-md-2 col-sm-12 m-t-xs\"><label for=\"asset\" class=\"control-label\" ng-class=\"{\'text-muted\': disablePlanOptions}\">Filtri applicati</label><div class=\"input-group\" style=\"width:100%\"><button class=\"btn btn-default\" ng-disabled=\"disablePlanOptions\" ng-click=\"toggleSearchTerms()\"><span class=\"fa fa-pencil-square-o\"></span> <span ng-if=\"isEmptyFilter()\">Aggiungi filtri</span> <span ng-if=\"!isEmptyFilter()\">Modifica filtri</span></button></div></div><div class=\"col-md-6 col-sm-12 m-t-xs\" ng-if=\"!isEmptyFilter()\"><div class=\"list-group-item clearfix\"><table class=\"filter_desc\"><tr ng-repeat=\"row in plan.model.search_filter.description_long\" class=\"filter_desc_row\"><td class=\"attr\">{{row.attribute}}</td><td class=\"rel\" ng-bind-html=\"row.relation\"></td><td class=\"val\">{{row.value}}</td></tr></table></div></div></div><div class=\"row\"><div class=\"col-md-4 col-sm-12 m-t\"><label class=\"checkbox i-checks m-b\" style=\"width:100%\"><input id=\"check-1\" type=\"checkbox\" ng-model=\"planOptions.generateOverParent\" ng-disabled=\"disablePlanOptions\"><i></i> <span class=\"i-checks\" ng-class=\"{\'text-muted\': disablePlanOptions}\">Genera su genitore</span></label></div><div class=\"col-md-8 col-sm-12 col-sm-12 m-t\" ng-show=\"planOptions.generateOverParent\"><label for=\"target-asset\" class=\"control-label\">Elemento tecnologico su cui generare gli ODL</label><six-lookup-2 ng-model=\"plan.model\" sx-base-path=\"\'tree/v2/_parents\'\" sx-field=\"\'target_model_type\'\" sx-compact=\"true\" sx-item-template=\"\'{{item.description}}\'\" sx-placeholder=\"\'Tipo...\'\"></six-lookup-2></div></div><div class=\"row\"><div class=\"col-md-4 col-sm-12 m-t\"><label class=\"checkbox i-checks m-b\" style=\"width:100%\"><input id=\"check-2\" type=\"checkbox\" ng-model=\"planOptions.specifyAssets\" ng-click=\"clearSiderbar()\" ng-disabled=\"disablePlanOptions\"><i></i> <span class=\"i-checks\" ng-class=\"{\'text-muted\': disablePlanOptions}\">ODL su specifici asset</span></label></div><div class=\"col-md-8 col-sm-12 m-t\" ng-show=\"planOptions.specifyAssets\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div><span class=\"pull-right\"><button class=\"btn btn-sm btn-default add-remove-button add-remove-button-first\" ng-click=\"removeAsset()\" ng-show=\"!isSidebarOpened\" ng-disabled=\"taskActivities.length==0\"><span class=\"fa fa-times\"></span>Rimuovi</button> <button class=\"btn btn-sm btn-default add-remove-button add-remove-button-first\" ng-click=\"closeSidebar()\" ng-show=\"isSidebarOpened\"><span class=\"fa fa-times\"></span>Annulla</button> <button class=\"btn btn-sm btn-default\" ng-click=\"selectAllRemCheck()\" ng-show=\"!isSidebarOpened\" title=\"Seleziona tutti\"><span class=\"fa fa-square m-r-none\"></span></button> <button class=\"btn btn-sm btn-default\" ng-click=\"unselectAllRemCheck()\" ng-show=\"!isSidebarOpened\" title=\"Deseleziona tutti\"><span class=\"fa fa-square-o m-r-none\"></span></button></span> <span class=\"pull-right\"><button class=\"btn btn-sm btn-default add-remove-button\" ng-click=\"selectAsset()\" ng-show=\"!isSidebarOpened\"><span class=\"fa fa-plus\"></span>Aggiungi</button> <button class=\"btn btn-sm btn-default add-remove-button\" ng-click=\"confirmSelectAssets()\" ng-show=\"isSidebarOpened\"><span class=\"fa fa-check\"></span>Conferma</button></span><h4 class=\"override-h4-no-margin\">Dettaglio Asset</h4><hr class=\"m-t\"></div><div><div ng-if=\"planAssets.length==0\" class=\"alert alert-info\">Per tutti gli asset del tipo selezionato</div><label class=\"checkbox i-checks m-b\" ng-repeat=\"assets in planAssets\"><input type=\"checkbox\" ng-model=\"remCheckModel[$index]\"><i></i>{{assets.model.code}} - {{assets.model.description}}</label></div></div></div></div></div></div></div></div></uib-tab><uib-tab disable=\"(step!=STEP.SIMULATION)\" ng-click=\"checkFreqTypeChanged()\" index=\"STEP.SIMULATION\"><uib-tab-heading><i class=\"icon-magic-wand text-primary-dker\"></i> Simulazione</uib-tab-heading><div class=\"row\"><div class=\"col-md-3 col-sm-12 m-t-xs\"><label for=\"generationTag\" class=\"control-label\">Codice generazione</label><div class=\"input-group\" style=\"width:100%\"><input name=\"generationTag\" type=\"text\" ng-model=\"generationTag\" class=\"form-control\" required=\"\"></div></div><div class=\"col-md-3 col-sm-6 m-t-xs\"><label for=\"fromDate\" class=\"control-label\">Simula dal:</label><p class=\"input-group\" style=\"width:100%\"><input type=\"text\" name=\"fromDate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"simulationParams.date_from\" is-open=\"popupFrom.opened\" datepicker-options=\"dateOptions\" close-text=\"Chiudi\" current-text=\"Oggi\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openFromPicker()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-3 col-sm-6 m-t-xs\"><label for=\"toDate\" class=\"control-label\">al:</label><p class=\"input-group\" style=\"width:100%\"><input type=\"text\" name=\"toDate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"simulationParams.date_to\" is-open=\"popupTo.opened\" datepicker-options=\"dateOptions\" close-text=\"Chiudi\" current-text=\"Oggi\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openToPicker()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-3 col-sm-12 m-t-xs\"><label class=\"control-label\"></label><div class=\"input-group\" style=\"width:100%;margin-top:5px;\"><button class=\"btn btn-default\" ng-click=\"simulate()\"><span class=\"fa fa-gear\"></span> Avvia simulazione</button></div></div></div><div class=\"row wrapper\" ng-class=\"{\'transparent\': !simulationEvents}\"><h4 class=\"override-h4-no-margin pull-left\">Ripetizioni</h4><span class=\"text-muted pull-right\">( {{ganttOptions.fromDate | date}} / {{ganttOptions.toDate | date}} &nbsp;&nbsp;|&nbsp;&nbsp; {{ganttOptions.freqLabel}} )</span><hr><h5 ng-if=\"showSimulationWarning()\" class=\"text-warning\">Simulazione non aggiornata</h5><div id=\"gantt\" gantt=\"\" data=\"ganttData\" to-date=\"ganttOptions.toDate\" from-date=\"ganttOptions.fromDate\" daily=\"true\" view-scale=\"ganttOptions.viewScale\"><gantt-tooltips enabled=\"true\" date-format=\"\'DD/MM/YYYY\'\" content=\"tooltipContent\"></gantt-tooltips></div><div class=\"legend m-t\"><span class=\"text-xs text-muted pull-right\"><i class=\"fa fa-circle text-info m-r-xs m-l-sm\"></i> Nuovi ODL <i class=\"fa fa-circle text-warning m-r-xs\"></i> ODL già generati</span> <span style=\"clear:both\"></span></div></div><div class=\"row wrapper\" ng-if=\"simulationTargets\"><small class=\"pull-right text-muted\">Cod. simulazione: <span class=\"text-italic\">{{simulationTargets.simulation_id}}</span></small><h4 class=\"override-h4-no-margin pull-left\">Asset interessati</h4><hr><div ng-if=\"simulationTargets.count==0\"><div class=\"alert alert-info\">Nessun asset corrisponde ai criteri di ricerca.</div></div><div ng-if=\"simulationTargets.count>0\"><table class=\"table table-striped\" ng-if=\"simulationTargets.count_grouped==0\"><thead><th></th><th>{{plan.model.model_type.description}}</th></thead><tbody><tr ng-repeat=\"item in simulationTargets.list\"><td>{{$index+1}}</td><td>{{item.code}} - {{item.description}}</td></tr></tbody></table><table class=\"table table-striped\" ng-if=\"simulationTargets.count_grouped>0\"><thead><th></th><th ng-if=\"simulationTargets.count_grouped>0\">{{plan.model.target_model_type.description}}</th><th>Numero asset \"{{plan.model.model_type.description}}\" contenuti</th></thead><tbody><tr ng-repeat=\"item in simulationTargets.list\"><td>{{$index+1}}</td><td ng-if=\"simulationTargets.count_grouped>0\">{{item.code}} - {{item.description}}</td><td>{{item.children_count}}</td></tr></tbody></table></div></div></uib-tab><uib-tab disable=\"(step!=STEP.GENERATION)\" index=\"STEP.GENERATION\"><uib-tab-heading><i class=\"icon-rocket text-info-dker\"></i> Generazione ODL</uib-tab-heading><div class=\"row wrapper\" ng-if=\"!generationDone\"><div class=\"alert alert-info\"><i class=\"fa fa-refresh fa-spin\" style=\"font-size:large\"></i> Generazione ODL in corso. Attendere...</div></div><div class=\"row wrapper\" ng-if=\"generationDone\"><div ng-if=\"generatedOdl.length==0\"><div class=\"alert alert-danger\">Non è stato generato alcun ODL</div></div><div ng-if=\"generatedOdl.length>0\"><table class=\"table table-striped\"><thead><th></th><th>Asset</th><th>Titolo</th><th>Stato</th><th>Utente generazione</th><th>Data generazione</th><th>Data pianifica</th></thead><tbody><tr ng-repeat=\"item in generatedOdl\"><td><a ng-href=\"#/odl/{{item.UUID}}\" class=\"btn btn-xs btn-primary\"><span class=\"fa fa-search\"></span></a></td><td>{{item.model.type_id.description}} - {{item.model.record_id.description}} ({{item.model.record_id.code}})</td><td>{{item.model.title}}</td><td>{{item.status}}</td><td>{{item.user}}</td><td>{{item.dataIn |date }}</td><td>{{item.date_requested | date}}</td></tr></tbody></table></div></div><div class=\"row wrapper\" ng-if=\"generationErrors && generationErrors.length\"><p style=\"color: red\" ng-repeat=\"error in generationErrors track by $index\">{{error}}</p></div><div class=\"row\"><div class=\"col col-md-4\"><small class=\"text-muted pull-right\">Asset coinvolti: {{affectedAssets}}</small></div><div class=\"col col-md-4\"><small class=\"text-muted pull-right\">Ripetizioni per ogni ODL: {{affectedEvents}}</small></div><div class=\"col col-md-4\"><small class=\"text-muted pull-right\">ODL totali: {{generatedOdl.length}}</small></div></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("plan/plan/plan_import.html","<six-toolbar><six-toolbar-item label=\"Template\" icon=\"fa fa-download icon text-info-dker\" toolbar-function=\"schemaDefinitionToXlsx()\"></six-toolbar-item><six-toolbar-button label=\"Reset\" icon=\"fa fa-undo\" toolbar-function=\"reset()\"></six-toolbar-button><six-toolbar-button label=\"Importa\" icon=\"fa fa-upload\" toolbar-function=\"importData()\" btn-class=\"btn-success\" sx-disabled=\"errorCount > 0 || prePercent<100 || importBusy || 100 === percent\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Importazione Programmate</h1></div></div></div><div class=\"panel-body\"><div ui-grid=\"gridOptions\" class=\"grid\" ui-grid-resize-columns=\"\"><div class=\"grid-msg-overlay\" ng-show=\"!gridOptions.data.length\"><div class=\"msg\"><div class=\"center\"><span class=\"muted\">Selezionare File Excel</span><br><input type=\"file\" accept=\".xls,.xlsx,.ods\" xlsxreader=\"\" opts=\"gridOptions\" multiple=\"false\"></div></div></div></div><div class=\"wrapper m-t\"><div class=\"text-center-folded\"><span class=\"pull-right pull-none-folded\">{{prePercent|number : 0}}%</span> <span class=\"hidden-folded ng-scope\">Verifica dati</span></div><div class=\"progress-s m-t-sm dk progress ng-isolate-scope\" value=\"{{prePercent}}\" type=\"info\"><div class=\"progress-bar progress-bar-info\" ng-class=\"type &amp;&amp; \'progress-bar-\' + type\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: prePercent + \'%\'}\" aria-valuetext=\"0%\" style=\"width: {{prePercent|number : 0}}%;\"></div></div><div class=\"text-center-folded\"><span class=\"pull-right pull-none-folded\">{{percent|number : 0}}%</span> <span class=\"hidden-folded ng-scope\">Importazione</span></div><div class=\"progress-s m-t-sm dk progress ng-isolate-scope\" value=\"{{percent}}\" type=\"info\"><div class=\"progress-bar progress-bar-info\" ng-class=\"type &amp;&amp; \'progress-bar-\' + type\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: percent + \'%\'}\" aria-valuetext=\"0%\" style=\"width: {{percent|number : 0}}%;\"></div></div></div><div id=\"messages\" class=\"wrapper m-t\" ng-if=\"reportMessages.length\"><div class=\"panel-group\" id=\"accordion\"><div class=\"panel panel-default\" id=\"panel1\"><div class=\"panel-heading\"><h4 class=\"panel-title\">Messaggi</h4></div><div class=\"panel-body\"><div class=\"col-md-12\"><div id=\"gridReport\" ui-grid=\"reportGridOptions\" class=\"grid\" style=\"height: 420px\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\"></div></div></div></div></div></div></div></div></div>");
$templateCache.put("plan/plan/plan_list.html","<six-toolbar><six-toolbar-item icon=\"fa fa-download icon text-info-dker\" label=\"Importa\" toolbar-function=\"goToPlanImport()\"></six-toolbar-item><six-toolbar-item label=\"Esporta\" icon=\"fa fa-upload icon text-info-dker\"><li><a ng-click=\"exportXLSX(\'export\')\">Modalità normale</a></li><li><a ng-click=\"exportXLSX(\'exportToImport\')\">Per reimportazione</a></li></six-toolbar-item><six-toolbar-button icon=\"fa fa-calendar-check-o\" label=\"Gantt\" toolbar-function=\"goToGantt()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-plus\" label=\"Nuova programmata\" btn-class=\"btn-info\" toolbar-function=\"goToNewPlan()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista Attività Programmate</h1></div></div></div><div class=\"panel-body\"><six-grid-pagination get-data-callback=\"getData()\" get-list-callback=\"getData()\" items-list=\"planList\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\" auto-resize-params=\"autoResizeParams\"></six-grid-pagination></div></div></div>");
$templateCache.put("plan/plan/plan_odl.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-calendar\" label=\"Visualizza programmata\" btn-class=\"btn-default\" toolbar-function=\"goToPlan()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-pencil\" label=\"Modifica date\" btn-class=\"btn-default\" toolbar-function=\"goToReplan()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Elimina tutti\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" sx-disabled=\"!isDeletePermAllowed()\" ng-confirm-message=\"Sei sicuro?\" ng-confirm-click=\"deleteOdlList()\" ng-confirm-condition=\"true\"></six-toolbar-button><six-toolbar-button label=\"Elimina selezionati\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" sx-disabled=\"!isDeletePermAllowed() || getSelectedRows().length == 0\" ng-confirm-message=\"Sei sicuro?\" ng-confirm-click=\"deleteOdlSelected()\" ng-confirm-condition=\"true\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista ODL generati</h1><small><span class=\"text-muted\">Compito:</span> <span>{{plan.model.task_id.code}} - {{plan.model.task_id.description}}</span> <span>&nbsp;&nbsp;&nbsp;</span> <span class=\"text-muted\">Frequenza:</span> <span>{{frequency}}</span></small></div></div></div><div class=\"panel-body\"><six-grid-pagination get-data-callback=\"getData()\" get-list-callback=\"getData()\" items-list=\"odlList\" column-defs=\"viewGridOptions.columnDefs\" grid-options=\"viewGridOptions\" params=\"params\" grid-app-callbacks=\"gridAppCallbacks\"></six-grid-pagination></div></div></div>");
$templateCache.put("plan/plan/plan_replan.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-calendar\" label=\"Visualizza programmata\" btn-class=\"btn-default\" toolbar-function=\"goToPlan()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-save\" label=\"Salva\" btn-class=\"btn-success\" toolbar-function=\"save()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Modifica date</h1><small><span class=\"text-muted\">Compito:</span> <span>{{plan.model.task_id.code}} - {{plan.model.task_id.description}}</span> <span>&nbsp;&nbsp;&nbsp;</span> <span class=\"text-muted\">Frequenza:</span> <span>{{frequency}}</span></small></div></div></div><div class=\"panel-body\" ng-init=\"rita=0\"><div ng-repeat=\"day in planning\"><div class=\"grouped_ist_element text-info\"><span class=\"grouped_ist_element_title\">{{ day.date_requested | date:\'dd/MM/yyyy\'}}</span></div><div class=\"row\" ng-if=\"isEditing($index)\"><div class=\"col-sm-5 m-b-xs m-t-xs\"><span class=\"input-group\" style=\"width:100%\"><input type=\"text\" name=\"toDate\" class=\"form-control\" ng-change=\"selectDate($index)\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"dayCheckList[$index].newDate\" is-open=\"dayCheckList[$index].popup.opened\" datepicker-options=\"dateOptions\" close-text=\"Chiudi\" current-text=\"Oggi\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"dayCheckList[$index].popup.opened=!dayCheckList[$index].popup.opened\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></span></div><div class=\"col-sm-4\"></div><div class=\"col-sm-3\"></div></div><div class=\"panel panel-default table-responsive\"><table class=\"table table-striped b-t b-light\"><thead><tr><th style=\"width:20px;\"><label class=\"i-checks m-b-none\"><input type=\"checkbox\" ng-click=\"checkAllDay($index)\" ng-model=\"dayCheckList[$index].isChecked\"><i></i></label></th><th>Asset</th><th>Elemento tecnologico</th><th>Nuova data</th><th style=\"width:30px;\"></th></tr></thead><tbody><tr ng-repeat=\"odl in day.list\" ng-init=\"checkItem=odlCheckList[odl.temp_index]\"><td><label class=\"i-checks m-b-none\"><input type=\"checkbox\" ng-model=\"checkItem.isChecked\"><i></i></label></td><td>{{odl.model.record_id.code}} - {{odl.model.record_id.description}}</td><td>{{odl.model.record_type_id.code}} - {{odl.model.record_type_id.description}}</td><td>{{checkItem.newDate | date:\'dd/MM/yyyy\'}}</td><td><i ng-if=\"checkItem.canUndo\" ng-click=\"undoOdlItem(checkItem)\" style=\"cursor:pointer\" class=\"fa fa-undo text-primary\"></i></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("plan/report/average_closing_time.html","<six-toolbar><six-toolbar-button label=\"Scarica\" icon=\"fa fa-download text-info-dker\" toolbar-function=\"download()\" ng-if=\"generatedReport.data.byteLength != 0\"></six-toolbar-button><six-toolbar-button label=\"Genera Report\" icon=\"fa fa-print text-info-dker\" toolbar-function=\"printReport(\'average_closing_time\',\'pdf\')\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default constructor\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Rispetto tempi di intervento per ODL</h1></div></div></div><div class=\"panel-body\"><form name=\"form\" class=\"wrapper\"><div class=\"col-md-2 form-group\"><label class=\"control-label\">Elemento tecnologico</label><six-lookup-2 sx-id=\"schema\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" ng-model=\"data\" sx-field=\"\'type_id\'\" sx-filter=\"typeIdFilter\" sx-show-details=\"false\" sx-show-filters=\"false\"></six-lookup-2></div><div class=\"col-md-2 form-group\"><label class=\"control-label\">Asset</label><six-lookup-2 sx-id=\"asset\" sx-base-path=\"\'record\'\" sx-type=\"data.type_id.UUID\" ng-model=\"data\" sx-field=\"\'record_id\'\" sx-multiple=\"true\" sx-auto-init=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div><div class=\"col-md-2 form-group\"><label class=\"control-label\">Priorità</label><six-lookup-2 sx-id=\"priority\" sx-base-path=\"\'record\'\" sx-type=\"\'priorita\'\" ng-model=\"data\" sx-field=\"\'priority_id\'\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div><div class=\"col-md-2 form-group\"><label class=\"control-label\">Tipo ODL</label><six-select-2 sx-id=\"odl_type\" sx-list=\"odlTypeList\" sx-title=\"\'Tipo odl\'\" ng-model=\"data\" sx-field=\"\'odl_type\'\" sx-multiple=\"false\" sx-clearable=\"false\" sx-item-template=\"\'{{item.description}}\'\"></six-select-2></div><div class=\"col-md-2 form-group\"><div class=\"control-group\"><label class=\"control-label\">Periodo da</label><six-date-time-picker name=\"from\" ng-model=\"data.from\" date-options=\"dateOptionsFrom\" format=\"dateFormat\" ng-required=\"true\"></six-date-time-picker></div></div><div class=\"col-md-2 form-group\"><div class=\"control-group\"><label class=\"control-label\">Periodo a</label><six-date-time-picker name=\"to\" ng-model=\"data.to\" date-options=\"dateOptionsTo\" format=\"dateFormat\" ng-required=\"true\"></six-date-time-picker></div></div></form></div><pdf-report-viewer load=\"generatedReport.data\"></pdf-report-viewer></div></div>");
$templateCache.put("plan/report/odl_closed_by_service.html","<six-toolbar><six-toolbar-button label=\"Scarica\" icon=\"fa fa-download text-info-dker\" toolbar-function=\"download()\" ng-if=\"generatedReport.data.byteLength != 0\"></six-toolbar-button><six-toolbar-button label=\"Genera Report\" icon=\"fa fa-print text-info-dker\" toolbar-function=\"printReport(\'odl_closed_by_service\',\'pdf\')\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default constructor\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Numero interventi eseguiti per tipologia</h1></div></div></div><div class=\"panel-body\"><form name=\"form\" class=\"wrapper\"><div class=\"col-md-2 form-group\"><label class=\"control-label\">Elemento tecnologico</label><six-lookup-2 sx-id=\"schema\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" ng-model=\"data\" sx-field=\"\'type_id\'\" sx-filter=\"typeIdFilter\" sx-show-details=\"false\" sx-show-filters=\"false\"></six-lookup-2></div><div class=\"col-md-2 form-group\"><label class=\"control-label\">Asset</label><six-lookup-2 sx-id=\"asset\" sx-base-path=\"\'record\'\" sx-type=\"data.type_id.UUID\" ng-model=\"data\" sx-field=\"\'record_id\'\" sx-multiple=\"true\" sx-auto-init=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div><div class=\"col-md-2 form-group\"><label class=\"control-label\">Priorità</label><six-lookup-2 sx-id=\"priority\" sx-base-path=\"\'record\'\" sx-type=\"\'priorita\'\" ng-model=\"data\" sx-field=\"\'priority_id\'\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div><div class=\"col-md-2 form-group\"><label class=\"control-label\">Tipo ODL</label><six-select-2 sx-id=\"odl_type\" sx-list=\"odlTypeList\" sx-title=\"\'Tipo odl\'\" ng-model=\"data\" sx-field=\"\'odl_type\'\" sx-multiple=\"false\" sx-clearable=\"false\" sx-item-template=\"\'{{item.description}}\'\"></six-select-2></div><div class=\"col-md-2 form-group\"><div class=\"control-group\"><label class=\"control-label\">Periodo da</label><six-date-time-picker name=\"from\" ng-model=\"data.from\" date-options=\"dateOptionsFrom\" format=\"dateFormat\" ng-required=\"true\"></six-date-time-picker></div></div><div class=\"col-md-2 form-group\"><div class=\"control-group\"><label class=\"control-label\">Periodo a</label><six-date-time-picker name=\"to\" ng-model=\"data.to\" date-options=\"dateOptionsTo\" format=\"dateFormat\" ng-required=\"true\"></six-date-time-picker></div></div></form></div><pdf-report-viewer load=\"generatedReport.data\"></pdf-report-viewer></div></div>");
$templateCache.put("plan/report/percentage_odl_by_status.html","<six-toolbar><six-toolbar-button label=\"Scarica\" icon=\"fa fa-download text-info-dker\" toolbar-function=\"download()\" ng-if=\"generatedReport.data.byteLength != 0\"></six-toolbar-button><six-toolbar-button label=\"Genera Report\" icon=\"fa fa-print text-info-dker\" toolbar-function=\"printReport(\'percentage_odl_by_status\',\'pdf\',\'OPEN\')\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default constructor\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Percentuale attività aperte</h1></div></div></div><div class=\"panel-body\"><form name=\"form\" class=\"wrapper\"><div class=\"col-md-2 form-group\"><label class=\"control-label\">Elemento tecnologico</label><six-lookup-2 sx-id=\"schema\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" ng-model=\"data\" sx-field=\"\'type_id\'\" sx-filter=\"typeIdFilter\" sx-show-details=\"false\" sx-show-filters=\"false\"></six-lookup-2></div><div class=\"col-md-2 form-group\"><label class=\"control-label\">Asset</label><six-lookup-2 sx-id=\"asset\" sx-base-path=\"\'record\'\" sx-type=\"data.type_id.UUID\" ng-model=\"data\" sx-field=\"\'record_id\'\" sx-multiple=\"true\" sx-auto-init=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div><div class=\"col-md-2 form-group\"><label class=\"control-label\">Priorità</label><six-lookup-2 sx-id=\"priority\" sx-base-path=\"\'record\'\" sx-type=\"\'priorita\'\" ng-model=\"data\" sx-field=\"\'priority_id\'\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div><div class=\"col-md-2 form-group\"><label class=\"control-label\">Tipo ODL</label><six-select-2 sx-id=\"odl_type\" sx-list=\"odlTypeList\" sx-title=\"\'Tipo odl\'\" ng-model=\"data\" sx-field=\"\'odl_type\'\" sx-multiple=\"false\" sx-clearable=\"false\" sx-item-template=\"\'{{item.description}}\'\"></six-select-2></div><div class=\"col-md-2 form-group\"><div class=\"control-group\"><label class=\"control-label\">Periodo da</label><six-date-time-picker name=\"from\" ng-model=\"data.from\" date-options=\"dateOptionsFrom\" format=\"dateFormat\" ng-required=\"true\"></six-date-time-picker></div></div><div class=\"col-md-2 form-group\"><div class=\"control-group\"><label class=\"control-label\">Periodo a</label><six-date-time-picker name=\"to\" ng-model=\"data.to\" date-options=\"dateOptionsTo\" format=\"dateFormat\" ng-required=\"true\"></six-date-time-picker></div></div></form></div><pdf-report-viewer load=\"generatedReport.data\"></pdf-report-viewer></div></div>");
$templateCache.put("plan/report/ratio_odl_by_status.html","<six-toolbar><six-toolbar-button label=\"Scarica\" icon=\"fa fa-download text-info-dker\" toolbar-function=\"download()\" ng-if=\"generatedReport.data.byteLength != 0\"></six-toolbar-button><six-toolbar-button label=\"Genera Report\" icon=\"fa fa-print text-info-dker\" toolbar-function=\"printReport(\'ratio_odl_by_status\',\'pdf\', \'CLOSED\')\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default constructor\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Numero interventi eseguiti su previsti</h1></div></div></div><div class=\"panel-body\"><form name=\"form\" class=\"wrapper\"><div class=\"col-md-2 form-group\"><label class=\"control-label\">Elemento tecnologico</label><six-lookup-2 sx-id=\"schema\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" ng-model=\"data\" sx-field=\"\'type_id\'\" sx-filter=\"typeIdFilter\" sx-show-details=\"false\" sx-show-filters=\"false\"></six-lookup-2></div><div class=\"col-md-2 form-group\"><label class=\"control-label\">Asset</label><six-lookup-2 sx-id=\"asset\" sx-base-path=\"\'record\'\" sx-type=\"data.type_id.UUID\" ng-model=\"data\" sx-field=\"\'record_id\'\" sx-multiple=\"true\" sx-auto-init=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div><div class=\"col-md-2 form-group\"><label class=\"control-label\">Priorità</label><six-lookup-2 sx-id=\"priority\" sx-base-path=\"\'record\'\" sx-type=\"\'priorita\'\" ng-model=\"data\" sx-field=\"\'priority_id\'\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div><div class=\"col-md-2 form-group\"><label class=\"control-label\">Tipo ODL</label><six-select-2 sx-id=\"odl_type\" sx-list=\"odlTypeList\" sx-title=\"\'Tipo odl\'\" ng-model=\"data\" sx-field=\"\'odl_type\'\" sx-multiple=\"false\" sx-clearable=\"false\" sx-item-template=\"\'{{item.description}}\'\"></six-select-2></div><div class=\"col-md-2 form-group\"><div class=\"control-group\"><label class=\"control-label\">Periodo da</label><six-date-time-picker name=\"from\" ng-model=\"data.from\" date-options=\"dateOptionsFrom\" format=\"dateFormat\" ng-required=\"true\"></six-date-time-picker></div></div><div class=\"col-md-2 form-group\"><div class=\"control-group\"><label class=\"control-label\">Periodo a</label><six-date-time-picker name=\"to\" ng-model=\"data.to\" date-options=\"dateOptionsTo\" format=\"dateFormat\" ng-required=\"true\"></six-date-time-picker></div></div></form></div><pdf-report-viewer load=\"generatedReport.data\"></pdf-report-viewer></div></div>");
$templateCache.put("plan/survey/question_model_detail.html","<ict-question-model uuid=\"uuid\" suppress-toolbar=\"false\"></ict-question-model>");
$templateCache.put("plan/survey/question_model_list.html","<six-toolbar><six-toolbar-button label=\"Nuovo\" icon=\"fa fa-plus\" toolbar-function=\"newData()\" id=\"btn_item_create\" sx-disabled=\"isWritePermAllowed() === false\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"getList()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\" xmlns=\"http://www.w3.org/1999/html\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Modelli Domanda</h1></div></div></div><div class=\"wrapper\"><div class=\"panel-body\"><six-grid-pagination sx-id=\"questions_grid\" get-data-callback=\"getList()\" get-list-callback=\"getList()\" items-list=\"list\" column-defs=\"viewGridOptions.columnDefs\" grid-app-callbacks=\"gridAppCallbacks\" grid-options=\"viewGridOptions\" enable-state-saving=\"true\" params=\"params\" auto-resize-params=\"autoResizeParams\"></six-grid-pagination></div></div></div></div>");
$templateCache.put("plan/survey/survey_conf_detail.html","<style type=\"text/css\">\n  @-webkit-keyframes highlight-fade {\n    0% {background: #deffca;}\n    100% {background: none;}\n  }\n\n  @keyframes highlight-fade {\n    0% {background: #deffca;}\n    100% {background: none;}\n  }\n\n  .highlight-row{\n    -webkit-animation: highlight-fade 1.5s ease-in 1;\n    animation: highlight-fade 1.5s ease-in 1;\n  }\n</style><six-toolbar><six-toolbar-item label=\"Questionario \'{{data.model.code}}\'\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" toolbar-function=\"goToList()\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" toolbar-function=\"delete(data.version)\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"save()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default constructor\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Configurazione Questionari</h1></div></div></div><div class=\"wrapper\"><div class=\"panel-body\"><div class=\"row padder m-t m-b hidden-sm\"><div class=\"col-md-2 col-sm-2 font-bold\">Commessa</div><div class=\"col-md-2 col-sm-2 font-bold\">Tipo</div><div class=\"col-md-2 col-sm-2 font-bold\">Stato</div><div class=\"col-md-3 col-sm-3 font-bold\">Questionario</div><div class=\"col-md-1 col-sm-1 font-bold\">Web</div><div class=\"col-md-1 col-sm-1 font-bold\">App</div><div class=\"col-md-1 col-sm-1\"><a class=\"pull-right\" ng-click=\"newRow()\" title=\"Nuova\"><i class=\"fa fa-plus text-success\"></i></a></div></div><ul class=\"list-group\"><li class=\"list-group-item\" ng-repeat=\"item in data.model.rows\" id=\"row{{item.code}}\"><div class=\"row\"><div class=\"col-md-2\"><input class=\"form-control\" ng-model=\"data.commission\" readonly=\"\"></div><div class=\"col-md-2\"><six-select-2 sx-id=\"record_type\" sx-list=\"recordTypes\" ng-model=\"item.record_type\" sx-item-template=\"\'{{item.description}}\'\" sx-compact=\"true\"></six-select-2></div><div class=\"col-md-2\"><input class=\"form-control\" ng-model=\"item.status\"></div><div class=\"col-md-3\"><six-lookup-2 sx-id=\"questions_{{data.code}}\" ng-model=\"item\" sx-field=\"\'survey_id\'\" sx-show-filters=\"false\" sx-show-details=\"false\" sx-war=\"\'six-plan\'\" sx-base-path=\"\'survey\'\" sx-type=\"\'survey\'\"></six-lookup-2></div><div class=\"col-md-1\"><label class=\"checkbox i-checks m-b inline\"><input id=\"check-1\" type=\"checkbox\" ng-model=\"showOptions.web\"><i></i></label></div><div class=\"col-md-1\"><label class=\"checkbox i-checks m-b inline\"><input id=\"check-1\" type=\"checkbox\" ng-model=\"showOptions.app\"><i></i></label></div><div class=\"col-md-1\"><a class=\"pull-right\" ng-click=\"removeRow(item);\"><i class=\"fa fa-trash text-danger\"></i></a></div></div></li></ul></div></div></div></div><div class=\"col-md-12 m-t\"><div class=\"panel panel-default panel-body\" ng-if=\"true\"><div class=\"wrapper\"><div class=\"row form-group\"><input id=\"jsonShowCheck\" type=\"checkbox\" ng-model=\"jsonshow\" class=\"pull-left\"> <label for=\"jsonShowCheck\" class=\"pull-left control-label\">Dettaglio avanzato</label></div><div class=\"row\" ng-show=\"jsonshow\"><div class=\"list-group list-group-lg list-group-sp\"><pre>{{ data | json }}</pre></div></div></div></div></div>");
$templateCache.put("plan/survey/survey_conf_list.html","<six-toolbar><six-toolbar-button label=\"Nuovo\" icon=\"fa fa-plus\" toolbar-function=\"newData()\" id=\"btn_item_create\" sx-disabled=\"isWritePermAllowed() === false\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"getList()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\" xmlns=\"http://www.w3.org/1999/html\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Configurazioni Questionari</h1></div></div></div><div class=\"wrapper\"><div class=\"panel-body\"><six-grid-pagination sx-id=\"surveys_grid\" get-data-callback=\"getList()\" get-list-callback=\"getList()\" items-list=\"list\" column-defs=\"viewGridOptions.columnDefs\" grid-app-callbacks=\"gridAppCallbacks\" grid-options=\"viewGridOptions\" enable-state-saving=\"true\" params=\"params\" auto-resize-params=\"autoResizeParams\"></six-grid-pagination></div></div></div></div>");
$templateCache.put("plan/survey/survey_detail.html","<div class=\"bg-light lter b-b portal-header\"><button class=\"btn btn-success pull-right m-l-sm\" ng-click=\"save()\"><i class=\"fa fa-save\"></i> Salva</button> <button class=\"btn btn-danger pull-right m-l-sm\" ng-click=\"delete(data.version)\"><i class=\"fa fa-trash\"></i> Elimina</button><button class=\"btn btn-default pull-right\" ng-click=\"goBack()\"><i class=\"fa fa-angle-left\"></i></button><div class=\"page-title\">Questionario {{data.model.code}}</div></div><div class=\"portal-content survey\"><div class=\"panel panel-default constructor\"><div class=\"panel-body survey-panel\"><h3>Questionario {{data.model.code}}</h3><br><div class=\"clearfix\"></div><ict-survey data=\"data\"></ict-survey></div></div></div>");
$templateCache.put("plan/survey/survey_list.html","<style type=\"text/css\">\n  #timelineRow {\n    height:26px;\n    line-height:26px;\n  }\n  .closed-record {\n    color: #ffffff;\n    background-color: #f05050 !important;\n  }\n</style><div class=\"bg-light lter b-b portal-header\"><a class=\"btn btn-default pull-right r-2x\" toolbar-function=\"getList()\"><i class=\"fa fa-refresh\"></i></a><div class=\"page-title\">Questionari</div></div><div class=\"portal-content issue\"><div class=\"row\"><div class=\"col-md-12\" xmlns=\"http://www.w3.org/1999/html\"><div class=\"panel panel-default\"><div class=\"panel-body\"><six-grid-pagination sx-id=\"surveys_grid\" get-data-callback=\"getList()\" get-list-callback=\"getList()\" items-list=\"list\" column-defs=\"viewGridOptions.columnDefs\" grid-app-callbacks=\"gridAppCallbacks\" grid-options=\"viewGridOptions\" enable-state-saving=\"true\" params=\"params\" auto-resize-params=\"autoResizeParams\"></six-grid-pagination></div></div></div></div></div>");
$templateCache.put("plan/survey/survey_model_detail.html","<style type=\"text/css\">\n  @-webkit-keyframes highlight-fade {\n    0% {background: #deffca;}\n    100% {background: none;}\n  }\n\n  @keyframes highlight-fade {\n    0% {background: #deffca;}\n    100% {background: none;}\n  }\n\n  .highlight-cat {\n    -webkit-animation: highlight-fade 1.5s ease-in 1;\n    animation: highlight-fade 1.5s ease-in 1;\n  }\n</style><six-toolbar><six-toolbar-item label=\"Questionario \'{{data.model.code}}\'\" ng-show=\"data.version\"></six-toolbar-item><six-toolbar-item label=\"Nuovo\" ng-show=\"!data.version\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" toolbar-function=\"goToList()\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" toolbar-function=\"delete(data.version)\" sx-disabled=\"!data.version || !isDeletePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"save()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default constructor\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"!data.version\">Nuovo questionario</h1><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"data.version\">Questionario <span class=\"m-l-xs\">{{data.model.code}}</span></h1></div></div></div><div class=\"wrapper\"><div class=\"panel-body\"><div class=\"col-md-12\"><div class=\"row\"><label class=\"control-label\">Codice</label> <input type=\"text\" class=\"form-control\" ng-model=\"data.model.code\"></div><div class=\"row\"><label class=\"control-label\">Descrizione</label> <input type=\"text\" class=\"form-control\" ng-model=\"data.model.description\"></div><div class=\"row\"><label class=\"control-label\">Note</label> <textarea class=\"form-control\" ng-model=\"data.model.notes\"></textarea></div><div class=\"row\"><label class=\"control-label\">Punteggio minimo</label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"data.model.min_score\"> <span class=\"input-group-addon\">/{{data.model.absmin}}</span></div></div><div class=\"row\"><label class=\"control-label\">Punteggio massimo</label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"data.model.max_score\"> <span class=\"input-group-addon\">/{{data.model.absmax}}</span></div></div><div class=\"row m-t\"><div class=\"pull-right\"><a class=\"btn btn-sm btn-default\" ng-click=\"newCategory();\"><i class=\"fa fa-plus text-success\"></i></a></div><h4 class=\"override-h4-no-margin\">Categorie</h4><hr><uib-accordion close-others=\"oneAtATime\"><uib-accordion-group class=\"panel-default\" ng-repeat=\"cat in data.model.categories\" is-open=\"cat._focus\" id=\"cat{{cat.code}}\"><uib-accordion-heading><div class=\"pull-left\"><i class=\"fa fa-edit m-r text-primary\" ng-click=\"$event.stopPropagation(); $event.preventDefault(); cat.edit=!cat.edit;\"></i></div><div class=\"pull-right\"><i class=\"fa fa-plus m-r text-success\" ng-click=\"$event.stopPropagation(); $event.preventDefault(); newCategory();\"></i> <i class=\"fa fa-trash m-l text-danger\" ng-click=\"$event.stopPropagation(); $event.preventDefault(); removeCategory(cat);\"></i></div><div><span ng-hide=\"cat.edit\">{{cat.description}}</span> <input ng-show=\"cat.edit\" style=\"width: 80%\" ng-model=\"cat.description\" ng-click=\"$event.stopPropagation(); $event.preventDefault();\" autofocus=\"\"></div></uib-accordion-heading><div class=\"wrapper\"><ict-category-model data=\"cat\" on-change=\"onCategoryChange(data)\"></ict-category-model></div></uib-accordion-group></uib-accordion></div></div></div></div></div></div><div class=\"clearfix\"></div><div class=\"wrapper\"><div class=\"panel panel-default panel-body\" ng-if=\"true\"><div class=\"wrapper\"><div class=\"row form-group\"><input id=\"jsonShowCheck\" type=\"checkbox\" ng-model=\"jsonshow\" class=\"pull-left\"> <label for=\"jsonShowCheck\" class=\"pull-left control-label\">Dettaglio avanzato</label></div><div class=\"row\" ng-show=\"jsonshow\"><div class=\"list-group list-group-lg list-group-sp\"><pre>{{ data.model | json }}</pre></div></div></div></div></div>");
$templateCache.put("plan/survey/survey_model_list.html","<six-toolbar><six-toolbar-button label=\"Nuovo\" icon=\"fa fa-plus\" toolbar-function=\"newData()\" id=\"btn_item_create\" sx-disabled=\"isWritePermAllowed() === false\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"getList()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\" xmlns=\"http://www.w3.org/1999/html\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Modelli Questionario</h1></div></div></div><div class=\"wrapper\"><div class=\"panel-body\"><six-grid-pagination sx-id=\"surveys_grid\" get-data-callback=\"getList()\" get-list-callback=\"getList()\" items-list=\"list\" column-defs=\"viewGridOptions.columnDefs\" grid-app-callbacks=\"gridAppCallbacks\" grid-options=\"viewGridOptions\" enable-state-saving=\"true\" params=\"params\" auto-resize-params=\"autoResizeParams\"></six-grid-pagination></div></div></div></div>");
$templateCache.put("plan/survey/survey_question_model_detail.html","<ict-question-model data=\"$ctrl.questionToEdit\" suppress-toolbar=\"true\" back-to-list=\"false\" on-save=\"$ctrl.onSave(q)\"></ict-question-model>");
$templateCache.put("plan/task/task_detail.html","<style type=\"text/css\">\n.center-open{\n    padding-left: 295px;\n}\n\n.selected {\n    background-color: #11c7f5 !important;\n}\n</style><six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"saveForm()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" toolbar-function=\"delete(task.version)\" sx-disabled=\"!task.version || !isDeletePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"list-sidebar-overlay\"></div><aside id=\"list-sidebar\" class=\"list-sidebar list-sidebar-default list-sidebar-stacked custom-six-sidebar\" role=\"navigation\"><div class=\"panel sidebar-panel\"><button class=\"btn btn-info pull-left\" ng-click=\"closeSidebar()\"><span class=\"fa fa-times icon-only\"></span></button> <button class=\"btn btn-info pull-right\" ng-click=\"confirmSelectActivities()\"><span class=\"fa fa-check icon-only\"></span></button><div class=\"panel-heading bg-info sidebar-heading\">Seleziona Attività</div></div><ul class=\"nav list-sidebar-nav\"><li><div class=\"form-group m-l-xs m-r-xs m-t-xs\"><six-search-form ng-model=\"activityFilter\" placeholder=\"Filtra...\" show-search-btn=\"false\"></six-search-form></div></li><li ng-repeat=\"activity in availableActivities | filter:activityFilter as filteredActivities\" class=\"m-l-xs m-r-xs\"><label class=\"checkbox i-checks m-b-sx\" ng-hide=\"isDisabledActivity(activity.UUID)\"><input type=\"checkbox\" ng-model=\"addCheckModel[$index]\" ng-disabled=\"isDisabledActivity(activity.UUID)\"><i></i>{{activity.model.description}}</label></li></ul></aside><div class=\"col-md-12 override-padding-toolbar center-page\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\" ng-hide=\"task.version\"><h1 class=\"m-n font-thin h3 text-black\">Nuovo Compito</h1></div><div class=\"col-sm-6 col-xs-12\" ng-show=\"task.version\"><h1 class=\"m-n font-thin h3 text-black\">Compito</h1></div></div></div><div class=\"wrapper\"><div class=\"panel-body\"><uib-tabset><uib-tab><uib-tab-heading><span class=\"fa fa-list-alt text-info-dker\"></span> Dati</uib-tab-heading><div class=\"row\"><div class=\"col-md-12 col-sm-12\"><label for=\"code\" class=\"control-label\">Codice</label><div class=\"input-group\" style=\"width:100%\"><input id=\"code\" name=\"code\" type=\"text\" ng-model=\"task.model.code\" class=\"form-control\" required=\"\"></div></div></div><div class=\"row\"><div class=\"col-md-12 col-sm-12 m-t\"><label for=\"description\" class=\"control-label\">Descrizione</label><div class=\"input-group\" style=\"width:100%\"><textarea id=\"description\" name=\"description\" ng-model=\"description\" ng-keyup=\"refreshDescription(description)\" required=\"\" class=\"form-control\"></textarea></div></div></div><div class=\"row\"><div class=\"col-md-12 col-sm-12 m-t\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div><span class=\"pull-right\"><button class=\"btn btn-default add-remove-button add-remove-button-first\" ng-click=\"removeActivity()\" ng-show=\"!isSidebarOpened\" ng-disabled=\"taskActivities.length==0\"><span class=\"fa fa-times\"></span>Rimuovi</button> <button class=\"btn btn-default add-remove-button add-remove-button-first\" ng-click=\"closeSidebar()\" ng-show=\"isSidebarOpened\"><span class=\"fa fa-times\"></span>Annulla</button></span> <span class=\"pull-right\"><button class=\"btn btn-default add-remove-button\" ng-click=\"selectActivity()\" ng-show=\"!isSidebarOpened\"><span class=\"fa fa-plus\"></span>Aggiungi</button> <button class=\"btn btn-default add-remove-button\" ng-click=\"confirmSelectActivities()\" ng-show=\"isSidebarOpened\"><span class=\"fa fa-check\"></span>Conferma</button></span><h4 class=\"override-h4-no-margin\">Attività</h4><hr></div><div><label class=\"checkbox i-checks m-b\" ng-repeat=\"activity in taskActivities\"><input type=\"checkbox\" ng-model=\"remCheckModel[$index]\"><i></i>{{activity.model.description}}{{activity.description}}</label></div></div></div></div></div></uib-tab><uib-tab disable=\"!task.version\"><uib-tab-heading><span class=\"fa fa-book text-primary-dker\"></span> Allegati</uib-tab-heading><six-tree-attachments nodes=\"attachments\" save-callback=\"updAttachments()\"></six-tree-attachments></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("plan/task/task_gantt.html","<style>\n.gantt-side {\n    min-width: 200px;\n}\n\n.gantt-task-group {\n    display: none;\n}\n.task-content {\n    color: #ffffff;\n}\n</style><six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"reload()\"></six-toolbar-button><six-toolbar-button id=\"test\" icon=\"fa fa-plus\" label=\"Nuovo compito\" toolbar-function=\"goToNewTask()\" btn-class=\"btn-info\" sx-disabled=\"isWritePermAllowed() === false\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Calendario Compiti Programmati</h1></div></div></div><div class=\"panel-body\"><div class=\"panel panel-default\"><div class=\"panel-heading\" style=\"cursor:pointer;\" data-toggle=\"collapse\" data-target=\"#gantt-options-form\" ng-click=\"toggleArrow()\"><h4 class=\"panel-title\">Opzioni <i class=\"pull-right fa ng-scope fa-angle-right\" ng-class=\"{\'fa-angle-down\': opt.open, \'fa-angle-right\': !opt.open}\"></i></h4></div><div id=\"gantt-options-form\" class=\"panel-body collapse\"><div class=\"row\"><div class=\"col-md-2 col-sm-6 m-t-xs\"><label class=\"control-label\">Da</label><div class=\"input-group\" style=\"width:100%\"><input type=\"date\" ng-model=\"opt.fromDate\" ng-model-options=\"{ debounce: 300 }\" class=\"form-control\"></div></div><div class=\"col-md-2 col-sm-6 m-t-xs\"><label class=\"control-label\">A</label><div class=\"input-group\" style=\"width:100%\"><input type=\"date\" ng-model=\"opt.toDate\" ng-model-options=\"{ debounce: 300 }\" class=\"form-control\"></div></div><div class=\"col-md-2 col-sm-6 m-t-xs\"><label for=\"viewScale\" class=\"control-label\">Dettaglio</label><select id=\"viewScale\" class=\"form-control ng-pristine ng-valid ng-touched\" ng-model=\"opt.viewScale\"><option label=\"giorno\" value=\"day\">giorno</option><option label=\"settimana\" value=\"week\">settimana</option><option label=\"mese\" value=\"month\">mese</option><option label=\"anno\" value=\"year\">anno</option></select></div><div class=\"col-md-2 col-sm-12 m-t-xs\"><label for=\"filter\" class=\"control-label\">Filtro compiti</label><div class=\"input-group\" style=\"width:100%\"><input type=\"text\" id=\"filter\" name=\"filter\" ng-model=\"opt.filterRow\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-md-3 col-sm-12 m-t\"><label for=\"assetFilterCode\" class=\"control-label\">Filtro codice asset</label><p class=\"input-group\" style=\"width:100%\"><input type=\"text\" id=\"assetFilterCode\" name=\"assetFilterCode\" class=\"form-control\" ng-model=\"opt.assetFilter.code\" ng-keyup=\"$event.keyCode == 13 && getGanttData()\"></p></div><div class=\"col-md-3 col-sm-12 m-t\"><label for=\"assetFilterDescr\" class=\"control-label\">Filtro nome asset</label><p class=\"input-group\" style=\"width:100%\"><input type=\"text\" id=\"assetFilterDescr\" name=\"assetFilterDescr\" class=\"form-control\" ng-model=\"opt.assetFilter.description\" ng-keyup=\"$event.keyCode == 13 && getGanttData()\"></p></div><div class=\"col-md-3 col-sm-12 m-t\"><label for=\"assetFilterType\" class=\"control-label\">Filtro elemento tecnologico</label><six-lookup-2 ng-model=\"opt.assetFilter\" id=\"assetFilterType\" name=\"assetFilterType\" sx-base-path=\"\'tree/v2/_flat\'\" sx-field=\"\'type_id\'\" sx-placeholder=\"\'Tipo...\'\" sx-compact=\"true\" sx-item-template=\"\'{{item.description}}\'\" required=\"\" aria-required=\"false\"></six-lookup-2></div><div class=\"col-md-1 col-sm-12 m-t\"><label class=\"control-label\"></label><p class=\"input-group m-t-xs\" style=\"width:100%\"><button class=\"btn btn-default\" name=\"assetFilterBtn\" ng-click=\"getGanttData()\"><i class=\"fa fa-search\"></i>Filtra asset</button></p></div><div class=\"col-md-1 col-sm-12 m-t\"><label class=\"control-label\"></label><p class=\"input-group m-t-xs\" style=\"width:100%\"><button class=\"btn btn-default\" name=\"assetFilterClear\" ng-click=\"clearAssetFilter()\"><i class=\"fa fa-times\"></i>Pulisci filtri</button></p></div></div></div></div><br><div class=\"legend\" ng-hide=\"ganttData.length==0\"><span class=\"text-xs text-muted pull-right\"><i class=\"fa fa-circle m-r-xs\" style=\"color:#00789C;\"></i> riepilogo mese <i class=\"fa fa-circle text-info m-r-xs\"></i> da completare <i class=\"fa fa-circle m-r-xs\"></i> completato</span> <span style=\"clear:both\"></span></div><div gantt=\"\" options=\"options\" api=\"registerApi\" data=\"ganttData\" to-date=\"ganttToDate\" from-date=\"ganttFromDate\" daily=\"true\" view-scale=\"opt.viewScale\" filter-row=\"{\'name\': opt.filterRow}\" ng-hide=\"ganttData.length==0\"><gantt-table columns=\"tableColumns\" headers=\"tableHeaders\"><gantt-tree header=\"treeHeader\" keep-ancestor-on-filter-row=\"true\" content=\"treeContent\"></gantt-tree></gantt-table><gantt-tooltips enabled=\"true\" date-format=\"\'DD/MM/YYYY\'\" content=\"tooltipContent\"></gantt-tooltips><gantt-groups enabled=\"true\" display=\"group\"></gantt-groups></div><div ng-show=\"ganttData.length==0\"><div class=\"alert alert-info\">Nessun risultato trovato.</div></div></div></div></div>");
$templateCache.put("plan/task/task_list.html","<six-toolbar><six-toolbar-button icon=\"fa fa-calendar-check-o\" label=\"Gantt\" toolbar-function=\"goToGantt()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-plus\" label=\"Nuovo compito\" btn-class=\"btn-info\" toolbar-function=\"goToNewTask()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista Compiti</h1></div></div></div><div class=\"col-md-12 m-t-sm m-b-sm\"><label class=\"checkbox i-checks m-b inline\"><input id=\"check-1\" type=\"checkbox\" ng-model=\"bool.viewCommissionData\"><i></i> <span class=\"i-checks\">Visualizza le righe associate alla commessa</span></label> <span>&nbsp;&nbsp;</span> <label class=\"checkbox i-checks m-b inline\"><input id=\"check-2\" type=\"checkbox\" ng-model=\"bool.viewCrossData\"><i></i> <span class=\"i-checks\">Visualizza le righe cross-commessa</span></label></div><div class=\"panel-body\"><six-grid-pagination get-data-callback=\"getData()\" items-list=\"tasksList\" grid-options=\"viewGridOptions\" params=\"params\"></six-grid-pagination></div></div></div>");
$templateCache.put("plan/workflow/workflow.html","<six-toolbar><six-toolbar-button label=\"Lista\" icon=\"fa fa-chevron-left\" toolbar-function=\"back()\"></six-toolbar-button><six-toolbar-button label=\"Duplica\" btn-class=\"btn-primary\" icon=\"fa fa-files-o\" toolbar-function=\"setConfModel()\" ng-if=\"selected.version\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"fa fa-trash-o\" toolbar-function=\"delete()\" sx-disabled=\"!isDeletePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"saveForm()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Dettaglio Configurazione</h1></div></div></div><div class=\"wrapper\"><div class=\"panel-heading\" style=\"background-color: transparent\"><div class=\"page-header-bleed-right\"><div class=\"actions\"><div class=\"row\"><form name=\"header\"><div class=\"form-group\"><div class=\"col-md-12\"><label class=\"control-label\">Codice:</label> <input type=\"text\" class=\"form-control\" ng-model=\"commissionCode\" ng-disabled=\"bool.isCross || bool.isCallCenter\"></div><div class=\"col-md-12 override-padding-no-pad-left-right\" ng-if=\"!bool.isCross && !bool.isCallCenter\"><label class=\"col-md-1 control-label\">Commesse:</label><div class=\"col-md-12\"><div id=\"vectors_budget_code\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"commissionsSelected.codes\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Selezionare una commessa...\">{{$item.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in commissions\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div></div><div class=\"col-md-12\"><input type=\"checkbox\" ng-model=\"bool.isCross\" name=\"cross_commission\" ng-click=\"updateCode()\"> <label class=\"control-label\">Imposta come configurazione di default per gli utenti (cross-commessa)</label></div></div></form></div></div></div></div><div class=\"panel-body\"><div class=\"row m-b\" ng-if=\"selected.model.bpmn\"><div class=\"form-group\"><div class=\"col-md-12\"><h4>Configura stati speciali:</h4></div><div class=\"col-md-4 col-md-6\" ng-repeat=\"status in mappableStatuses\"><label class=\"control-label\">Stato \"{{status}}\":</label><select class=\"form-control\" ng-model=\"selected.model.statusMap[status]\"><option ng-repeat=\"statusName in bpmnStatuses()\" ng-value=\"statusName\">{{statusName}}</option></select></div></div></div><div class=\"row text-center padder-v\" ng-show=\"!upload.show\"><a class=\"btn btn-default\" ng-click=\"upload.show=true\">Carica Business Process</a></div><div ng-show=\"upload.show\"><div class=\"col-md-12 b-a m-b\"><div class=\"col-md-6\"><h4>Seleziona file</h4><div><input type=\"file\" nv-file-select=\"\" uploader=\"uploader\"></div></div><div class=\"col-md-6\"><h4>Oppure</h4><div ng-show=\"uploader.isHTML5\"><div nv-file-drop=\"\" class=\"well my-drop-zone\" nv-file-over=\"\" uploader=\"uploader\">Trascina qui</div></div></div></div></div><div class=\"row m-t\" style=\"clear: both; padding-top: 70%; position: relative; background: #fafafa; border-radius: 5px; border: 1px solid #eee;\"><div id=\"bpmnViewer\" style=\"width: 100%; height: 100%; position: absolute; top: 0; left: 0;\"></div></div></div><div class=\"panel-footer\"><div class=\"form-group\"><input id=\"jsonShowCheck\" type=\"checkbox\" ng-model=\"jsonshow\" class=\"pull-left\" data-toggle=\"collapse\" data-target=\"#json-collapse\"> <label for=\"jsonShowCheck\" class=\"pull-left control-label\">Dettaglio avanzato</label></div></div><div class=\"row collapse\" id=\"json-collapse\" collapse=\"!jsonshow\"><div class=\"col-md-12\"><div class=\"panel no-border\"><div class=\"panel-heading wrapper b-b b-light\"><h4 class=\"font-thin m-t-none m-b-none text-muted\">Dettaglio</h4></div><div style=\"margin-top:0px;\" ui-ace=\"{ useWrapMode : true, showGutter: true, mode: \'json\', firstLineNumber: 1, onLoad: aceLoaded, onChange: aceChanged }\" ng-model=\"selected.model.bpmn\"></div></div></div></div></div></div></div>");
$templateCache.put("plan/workflow/workflow_list.html","<six-toolbar><six-toolbar-button label=\"Crea workflow\" icon=\"fa fa-plus\" toolbar-function=\"newWorkflow()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"refresh()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista Workflow ({{workflowType}})</h1></div></div></div><div class=\"panel-body\"><div class=\"form-group\"><input ng-keyup=\"refresh()\" class=\"form-control\" type=\"text\" ng-model=\"queryParam\" placeholder=\"Type here to filter the list...\"></div><table id=\"odl_configurator_list\" class=\"table table-striped\"><thead><tr><th></th><th>CODICE CONFIGURAZIONE</th><th>COMMESSA</th><th>DATA</th></tr></thead><tbody><tr ng-repeat=\"item in workflowList.list\"><td><a ng-href=\"#/workflow/{{workflowType}}/{{item.UUID}}\" class=\"btn btn-default\"><span class=\"fa fa-search\"></span></a></td><td>{{ item.model.code }}</td><td>{{printCommission(item.model.commission)}}</td><td>{{ item.dataIn | date:\'dd/MM/yyyy\' }}</td></tr><tr ng-hide=\"workflowList.list.length\"><td><p class=\"text-center\">Nessun record recuperato</p></td></tr></tbody></table></div><div class=\"panel-footer\"><div class=\"row text-center\"><uib-pagination ng-change=\"pageChanged()\" boundary-links=\"true\" total-items=\"workflowList.totalResults\" ng-model=\"workflowList.currentPage\" class=\"pagination-sm\" items-per-page=\"workflowList.pageSize\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></uib-pagination></div></div></div></div>");
$templateCache.put("portal/document/document.html","<div class=\"bg-light lter b-b portal-header\"><button class=\"btn btn-success pull-right m-l-sm\" ng-click=\"newFolder()\" ng-disabled=\"!selected\"><i class=\"fa fa-sliders\"></i> Sottocartella</button> <button class=\"btn btn-info pull-right\" onclick=\"document.getElementById(\'fileinput\').click()\" ng-disabled=\"!selected\"><i class=\"fa fa-plus\"></i> Documento</button> <input id=\"fileinput\" type=\"file\" nv-file-select=\"\" uploader=\"uploader\" ng-show=\"false\" multiple=\"\"><div class=\"page-title\">Documenti</div></div><div class=\"portal-content document\"><div class=\"row\"><div class=\"col-lg-4 col-md-4\"><div class=\"panel wrapper-md panel-default\"><div class=\"panel-body tree no-padder\"><div slimscroll=\"{height: 500, noWatch:true}\"><div class=\"folder-list\" ui-tree=\"\"><strong>Elenco Cartelle</strong><hr><ul ui-tree-nodes=\"\" ng-model=\"asset.model.attachments\"><li ng-repeat=\"node in asset.model.attachments\" ui-tree-node=\"\" ng-include=\"\'portal/document/nodes_renderer.html\'\"></li></ul></div></div></div><footer class=\"panel-footer no-padder\"><button class=\"btn btn-block\" ng-click=\"newFolder(true)\"><i class=\"fa fa-plus\"></i> Aggiungi nuova cartella</button></footer></div></div><div class=\"col-lg-8 col-md-8\"><div class=\"panel wrapper-md panel-default file-list\"><div class=\"panel-body no-padder\" slimscroll=\"{height: \'auto\', noWatch:true}\"><table class=\"table\"><thead><tr><th></th><th>Data</th><th>Nome</th><th>Utente</th><th style=\"width: 140px\"></th></tr></thead><tbody><tr class=\"file\" ng-repeat=\"file in selected.nodes | filter:{folder:false}\"><td class=\"p-l-n p-r-n\"><div class=\"btn btn-file\"><i class=\"fa\" ng-class=\"getDocumentClass(file.title)\"></i></div></td><td>{{file.date | date:\'dd/MM/yyyy\'}}</td><td>{{file.title}}</td><td>{{file.user}}</td><td class=\"strip\"><a class=\"btn\" ng-href=\"{{dowloadUrl}}{{file.object_id}}\" target=\"_blank\" download=\"{{file.title}}\"><i class=\"fa fa-chevron-down\"></i> Download</a> <button class=\"btn delete-file\" ng-if=\"isAdmin() || file.user == currentUser\" ng-click=\"deleteFile(file, $index)\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("portal/document/nodes_renderer.html","<div ui-tree-handle=\"\" data-nodrag=\"\" class=\"tree-node tree-node-content\" ng-class=\"{selected: node == selected}\"><li ng-click=\"toggle(this); select(node)\"><a><i class=\"fa\" ng-class=\"{\'fa-folder\': collapsed, \'fa-folder-open\': !collapsed}\"></i> {{node.title}}</a> <a ng-if=\"node.folder && isAdmin() && node == selected\" class=\"pull-right m-l-xs\" ng-click=\"removeFolder(node, this); $event.stopPropagation()\"><i class=\"fa fa-times\"></i></a> <a ng-if=\"node.folder && node == selected\" class=\"pull-right btn-edit\" ng-click=\"node.editing = true; $event.stopPropagation()\"><i class=\"fa fa-pencil\"></i></a></li></div><div class=\"input-group well well-sm\" ng-if=\"node.editing\" ng-init=\"newTitle = node.title\"><input class=\"form-control\" type=\"text\" ng-model=\"newTitle\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"node.editing = undefined; node.title = newTitle; update(node);\"><i class=\"fa fa-check\"></i></button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"node.editing = undefined\"><i class=\"fa fa-close\"></i></button></div></div><ol ui-tree-nodes=\"\" ng-model=\"node.nodes\" ng-hide=\"collapsed\"><li ng-repeat=\"node in node.nodes | filter:{folder:true}\" ui-tree-node=\"\" ng-include=\"\'portal/document/nodes_renderer.html\'\"></li></ol>");
$templateCache.put("portal/home/business.html","<style>\n    .boxcontatti ul li .big {\n        font-size: 1.4em;\n    }\n    \n    .boxcontatti ul {\n        list-style-type: square;\n    }\n</style><div class=\"bg-light lter b-b portal-header\"><div class=\"page-title\">Business Intelligence</div></div><div class=\"portal-content\"><div class=\"col-lg-12 col-sm-12\"><div class=\"panel panel-default\"><div class=\"panel-body\"><img src=\"images/portal/jasper.png\" class=\"img-responsive\"></div></div></div></div>");
$templateCache.put("portal/home/contact.html","<style>\n  .boxcontatti ul li .big {\n    font-size: 1.4em;\n  }\n  .boxcontatti ul {\n    list-style-type: square;\n  }\n</style><div class=\"bg-light lter b-b portal-header\"><div class=\"page-title\">Contatti</div></div><div class=\"portal-content contact\"><div class=\"col-lg-8 col-lg-offset-2\"><div class=\"boxcontatti\"><div class=\"contenuto\"><div class=\"row\"><div class=\"col-sm-7 columns\"><ul><li><span class=\"big\"><strong>Sede legale e stabilimento di Ferrara</strong><br>Via Calvino 33 - 44122 Ferrara<br>Tel. +39 0532 599711<br>Fax +39 0532 773800<br>e-mail <a href=\"mailto:serviziospedalierispa@serviziospedalieri.it\">serviziospedalierispa@serviziospedalieri.it</a></span><br><br><small><strong>Attenzione!</strong>Non è possibile utilizzare questo indirizzo email per inviare curricula. Gli eventuali curricula inviati non verranno presi in considerazione. Chi fosse interessato ad avanzare domande di lavoro può utilizzare la sezione <a href=\"https://www.serviziospedalieri.it/lavora-con-noi\">\"Lavora con noi\"</a>. Grazie.</small></li></ul></div><div class=\"col-sm-5 columns\"><iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d45246.063442429164!2d11.553406994744204!3d44.85734798484372!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x477e4d8f2eef38f1%3A0x6160b8d304c91a8!2sServizi+Ospedalieri!5e0!3m2!1sit!2sit!4v1506498823028\" width=\"100%\" height=\"300\" frameborder=\"0\" style=\"border:0\" allowfullscreen=\"\"></iframe></div></div><div class=\"row m-t-lg\"><div class=\"col-sm-4 columns\"><ul><li><strong>Stabilimento di Castellalto (TE)</strong><br>Case Molino di Villa Zaccheo<br>64020 Castellalto (Te)<br>Tel. +39 0861 20791<br>Fax +39 0861 588765</li></ul></div><div class=\"col-sm-4 columns\"><ul><li><strong>Stabilimento di Lucca</strong><br>Via San Pietro a Vico 205<br>55100 Lucca<br>Tel. +39 0583 467582<br>Fax +39 0583 492761</li></ul></div><div class=\"col-sm-4 columns\"><ul><li><strong>Stabilimento di Marcellinara (CZ)</strong><br>Loc. Serramonda<br>88040 Marcellinara (Cz)<br>Tel. +39 0961 903410<br>Fax +39 0961 903410</li></ul></div></div></div></div><hr><div class=\"row m-t-lg m-b-lg\"><div class=\"col-lg-12\"><h3 class=\"text-center\">Richiesta informazioni</h3><six-send-email sx-title-mail=\"\'Richiesta informazioni\'\" sx-body-mail=\"\'Inserisci la tua richiesta\'\" sx-disable-to-mail=\"true\" sx-to-mail=\"\'serviziospedalierispa@serviziospedalieri.it\'\" sx-type-mail=\"\'contactcenter\'\" sx-hide-from=\"\" sx-alfresco-attachments=\"false\" sx-hide-cc=\"true\" sx-hide-to=\"true\"></six-send-email></div></div></div></div>");
$templateCache.put("portal/home/home.html","<style>\n    .item-image-no-hover {\n        background-color: #2B4A61;\n        height: 100%;\n        min-height: 130px;\n        line-height: 130px;\n        transition: all .3s linear;\n        border-radius: 3px 0px 0px 3px;\n        cursor: default;\n    }\n\n    .item-image-no-hover .icon {\n        width: 70px;\n    }\n\n    .white-box-no-hover {\n        cursor: default !important;\n    }\n</style><div class=\"bg-light lter b-b portal-header\"><a class=\"btn btn-default pull-right r-2x\" ng-click=\"loadData()\"><i class=\"fa fa-refresh\"></i></a> <button ng-if=\"superuser() && !widgetEditMode\" class=\"btn btn-secondary pull-right m-r-sm r-2x\" ng-click=\"enterEditMode()\"><i class=\"fa fa-pencil\"></i> Modifica disposizione</button> <button ng-if=\"superuser() && widgetEditMode\" class=\"btn btn-success pull-right m-r-sm r-2x\" ng-click=\"exitEditMode()\"><i class=\"fa fa-save\"></i> Salva disposizione</button><div ng-if=\"superuser() && widgetEditMode\" class=\"col-md-4 form-group pull-right m-r-sm r-2x\" ng-class=\"{\'has-error\': roleForm.$invalid, \'has-success\': roleForm.$valid}\"><six-lookup-2 sx-id=\"ruolo\" sx-base-path=\"\'record\'\" sx-type=\"\'ruolooperatore\'\" sx-title=\"\'Ruolo\'\" ng-model=\"ruolo_operatore\" sx-compact=\"true\" sx-required=\"true\" sx-on-select=\"updateRuoloFilter(item)\" sx-on-clear=\"clearRuoloFilter()\" sx-form=\"roleForm\"></six-lookup-2></div><div ng-if=\"superuser() && !widgetEditMode\" class=\"align-text-bottom pull-right m-r-sm r-2x\"><p style=\"margin: 7px 10px;\">Ruolo: {{ruolo_operatore.code}}</p></div><button class=\"btn btn-success pull-right m-r-sm r-2x\" ng-click=\"createIssue()\" ng-if=\"isWidgetVisible(\'issue\')\"><i class=\"fa fa-plus\"></i> Nuova Richiesta</button><div class=\"page-title\">Dashboard <span class=\"m-l-sm name\">{{user.name}} {{user.surname}}</span></div></div><div class=\"portal-content portal-home\"><div class=\"container-fluid no-padder\"><div class=\"row\" style=\"position: relative;\"><div class=\"col-sm-4 col-xs-12\" ng-if=\"isWidgetVisible(\'tracking\')\"><a ng-href=\"{{urlHandler(\'#/tracking\')}}\"><div class=\"white-box clearfix\" ng-class=\"{\'white-box-no-hover\': widgetEditMode}\"><div class=\"item-wrapper\" ng-style=\"blurredWidgetStyle[\'tracking\']\"><div class=\"col-sm-4 no-padder\"><div ng-class=\"{\'item-image\': !widgetEditMode, \'item-image-no-hover\': widgetEditMode }\"><img src=\"images/portal/aid.svg\" class=\"icon\"></div></div><div class=\"col-sm-8 no-padder\"><div class=\"item\"><h3 class=\"title\">Sistemi di tracciabilità</h3><p>Consente di gestire e tracciare l’intero processo attraverso le fasi operative.</p></div></div></div></div></a> <button class=\"btn-light\" ng-if=\"widgetEditMode\" style=\"position: absolute; top:0px; right: 14px;\" ng-click=\"hideWidget(\'tracking\')\"><i class=\"fa\" ng-class=\"{\'fa-eye-slash\': !activeWidgetMap[\'tracking\'], \'fa-eye\': activeWidgetMap[\'tracking\']}\"></i></button></div><div class=\"col-sm-4 col-xs-12\" ng-if=\"isWidgetVisible(\'quality-management\')\"><a href=\"{{qualityUrl}}\" target=\"_blank\"><div class=\"white-box clearfix\" ng-class=\"{\'white-box-no-hover\': widgetEditMode}\"><div class=\"item-wrapper\" ng-style=\"blurredWidgetStyle[\'quality-management\']\"><div class=\"col-sm-4 no-padder\"><div ng-class=\"{\'item-image\': !widgetEditMode, \'item-image-no-hover\': widgetEditMode }\"><img src=\"images/portal/qualita.svg\" class=\"icon\"></div></div><div class=\"col-sm-8 no-padder\"><div class=\"item\"><h3 class=\"title\">Gestione Qualità</h3><p>Gestione della pianificazione dei controlli qualitità sul prodotto e servizio</p></div></div></div></div></a> <button class=\"btn-light\" ng-if=\"widgetEditMode\" style=\"position: absolute; top:0px; right: 14px;\" ng-click=\"hideWidget(\'quality-management\')\"><i class=\"fa\" ng-class=\"{\'fa-eye-slash\': !activeWidgetMap[\'quality-management\'], \'fa-eye\': activeWidgetMap[\'quality-management\']}\"></i></button> <button class=\"btn-light\" ng-if=\"activeWidgetMap[\'quality-management\']\" style=\"position: absolute; bottom:20px; right: 14px;\" ng-click=\"showEditQualityManagementLink()\"><i class=\"fa fa-pencil\"></i></button></div><div class=\"col-sm-4 col-xs-12\" ng-if=\"isWidgetVisible(\'business\')\"><a ng-href=\"{{urlHandler(\'#/reportoverview\')}}\"><div class=\"white-box clearfix\" ng-class=\"{\'white-box-no-hover\': widgetEditMode}\"><div class=\"item-wrapper\" ng-style=\"blurredWidgetStyle[\'business\']\"><div class=\"col-sm-4 no-padder\"><div ng-class=\"{\'item-image\': !widgetEditMode, \'item-image-no-hover\': widgetEditMode }\"><img src=\"images/portal/chart.svg\" class=\"icon\"></div></div><div class=\"col-sm-8 no-padder\"><div class=\"item\"><h3 class=\"title\">Business Intelligence e reporting</h3><p>Documentazione riguardante l’appalto</p></div></div></div></div></a> <button class=\"btn-light\" ng-if=\"widgetEditMode\" style=\"position: absolute; top:0px; right: 14px;\" ng-click=\"hideWidget(\'business\')\"><i class=\"fa\" ng-class=\"{\'fa-eye-slash\': !activeWidgetMap[\'business\'], \'fa-eye\': activeWidgetMap[\'business\']}\"></i></button></div><div class=\"col-sm-4 col-xs-12\" ng-if=\"isWidgetVisible(\'document\')\"><a ng-href=\"{{urlHandler(\'#/document\')}}\"><div class=\"white-box clearfix\" ng-class=\"{\'white-box-no-hover\': widgetEditMode}\"><div class=\"item-wrapper\" ng-style=\"blurredWidgetStyle[\'document\']\"><div class=\"col-sm-4 no-padder\"><div ng-class=\"{\'item-image\': !widgetEditMode, \'item-image-no-hover\': widgetEditMode }\"><img src=\"images/portal/docs.svg\" class=\"icon\"></div></div><div class=\"col-sm-8 no-padder\"><div class=\"item\"><h3 class=\"title\">Repository Documentale</h3><p>Documentazione riguardante l’appalto</p></div></div></div></div></a> <button class=\"btn-light\" ng-if=\"widgetEditMode\" style=\"position: absolute; top:0px; right: 14px;\" ng-click=\"hideWidget(\'document\')\"><i class=\"fa\" ng-class=\"{\'fa-eye-slash\': !activeWidgetMap[\'document\'], \'fa-eye\': activeWidgetMap[\'document\']}\"></i></button></div><div class=\"col-sm-4 col-xs-12\" ng-if=\"isWidgetVisible(\'issue\')\"><a ng-href=\"{{urlHandler(\'#/issue\')}}\"><div class=\"white-box clearfix\" ng-class=\"{\'white-box-no-hover\': widgetEditMode}\"><div class=\"item-wrapper\" ng-style=\"blurredWidgetStyle[\'issue\']\"><div class=\"col-sm-4 no-padder\"><div ng-class=\"{\'item-image\': !widgetEditMode, \'item-image-no-hover\': widgetEditMode }\"><img src=\"images/portal/richieste.svg\" class=\"icon\"></div></div><div class=\"col-sm-8 no-padder\"><div class=\"item\"><h3 class=\"title\">Gestione Richieste</h3><p>Gestione sulle richieste / segnalazioni sull’appalto</p></div></div></div></div></a> <button class=\"btn-light\" ng-if=\"widgetEditMode\" style=\"position: absolute; top:0px; right: 14px;\" ng-click=\"hideWidget(\'issue\')\"><i class=\"fa\" ng-class=\"{\'fa-eye-slash\': !activeWidgetMap[\'issue\'], \'fa-eye\': activeWidgetMap[\'issue\']}\"></i></button></div><div class=\"col-sm-4 col-xs-12\" ng-if=\"isWidgetVisible(\'contact\')\"><a ng-href=\"{{urlHandler(\'#/contact\')}}\"><div class=\"white-box clearfix\" ng-class=\"{\'white-box-no-hover\': widgetEditMode}\"><div class=\"item-wrapper\" ng-style=\"blurredWidgetStyle[\'contact\']\"><div class=\"col-sm-4 no-padder\"><div ng-class=\"{\'item-image\': !widgetEditMode, \'item-image-no-hover\': widgetEditMode }\"><img src=\"images/portal/contact.svg\" class=\"icon\"></div></div><div class=\"col-sm-8 no-padder\"><div class=\"item\"><h3 class=\"title\">Contact Center</h3><p>Chiamate, Email</p></div></div></div></div></a> <button class=\"btn-light\" ng-if=\"widgetEditMode\" style=\"position: absolute; top:0px; right: 14px;\" ng-click=\"hideWidget(\'contact\')\"><i class=\"fa\" ng-class=\"{\'fa-eye-slash\': !activeWidgetMap[\'contact\'], \'fa-eye\': activeWidgetMap[\'contact\']}\"></i></button></div><div class=\"col-sm-4 col-xs-12\" ng-if=\"isWidgetVisible(\'ddt\')\"><a ng-href=\"{{urlHandler(\'#/record/snap/ddt\')}}\"><div class=\"white-box clearfix\" ng-class=\"{\'white-box-no-hover\': widgetEditMode}\"><div class=\"item-wrapper\" ng-style=\"blurredWidgetStyle[\'ddt\']\"><div class=\"col-sm-4 no-padder\"><div ng-class=\"{\'item-image\': !widgetEditMode, \'item-image-no-hover\': widgetEditMode }\"><img src=\"images/portal/docs.svg\" class=\"icon\"></div></div><div class=\"col-sm-8 no-padder\"><div class=\"item\"><h3 class=\"title\">DDT</h3><p>Inserimento, Modifica ed Eliminazione DDT</p></div></div></div></div></a> <button class=\"btn-light\" ng-if=\"widgetEditMode\" style=\"position: absolute; top:0px; right: 14px;\" ng-click=\"hideWidget(\'ddt\')\"><i class=\"fa\" ng-class=\"{\'fa-eye-slash\': !activeWidgetMap[\'ddt\'], \'fa-eye\': activeWidgetMap[\'ddt\']}\"></i></button></div></div></div><div class=\"clearfix\"></div><br><div class=\"clearfix\"></div><div class=\"row\"><div class=\"col-lg-12\" ng-if=\"isWidgetVisible(\'issue\')\"><uib-tabset active=\"0\"><uib-tab index=\"0\" heading=\"Ultime richieste\"><div class=\"panel panel-default\"><table class=\"table\"><thead><tr class=\"sort-header\"><th>Codice</th><th>Data</th><th style=\"width: 80px;\">Priorità</th><th>Descrizione</th><th></th><th style=\"width: 75px;\"></th></tr></thead><tbody><tr ng-repeat=\"issue in issueResponse.list\" ng-click=\"openIssue(issue)\"><td>{{issue.model.code}}</td><td><span uib-tooltip=\"{{issue.date_requested | amCalendar}}\" am-time-ago=\"issue.date_requested\"></span></td><td><span class=\"priority prt-{{issue.model.priority_id.description | lowercase}}\">{{issue.model.priority_id.description}}</span></td><td>{{issue.model.note}}</td><td>{{issue.reporter_id.description}}</td><td><div class=\"btn btn-detail btn-sm\" ng-click=\"openIssue(issue)\"><i class=\"fa fa-eye\"></i></div></td></tr></tbody></table><footer class=\"panrl-footer text-center\"><uib-pagination boundary-links=\"true\" total-items=\"issueResponse.totalResults\" ng-model=\"paginatedRequest.page\" class=\"pagination-sm\" items-per-page=\"paginatedRequest.page_size\" ng-change=\"loadData()\" max-size=\"10\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></uib-pagination></footer></div></uib-tab></uib-tabset></div></div><div class=\"clearfix\"></div><br><div class=\"clearfix\"></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"img-banner\"></div></div><div class=\"col-sm-6\" ng-if=\"isWidgetVisible(\'issue\')\"><div class=\"alert-bottom\"><h3>Avviso</h3><p>Richiesta da verificare</p><a class=\"btn btn-alert\" href=\"#/avvisi\">dettagli</a></div></div></div></div>");
$templateCache.put("portal/home/link-modal.html","<style>\n  textarea {\n    resize: none;\n  }\n</style><div class=\"panel-body\"><form name=\"linkForm\" class=\"form-validation\"><div class=\"form-group\" ng-class=\"{\'has-error\': linkForm.url.$invalid}\"><label>Inserire url</label> <textarea type=\"textarea\" name=\"url\" class=\"form-control\" rows=\"7\" ng-model=\"link.url\" required=\"\"></textarea></div><button class=\"btn btn-success btn-block btn-lg\" ng-click=\"save()\" ng-disabled=\"linkForm.$invalid\">Salva</button></form></div>");
$templateCache.put("portal/home/quality.html","<style>\n    .boxcontatti ul li .big {\n        font-size: 1.4em;\n    }\n    \n    .boxcontatti ul {\n        list-style-type: square;\n    }\n</style><div class=\"bg-light lter b-b portal-header\"><div class=\"page-title\">Gestione Qualità</div></div><div class=\"portal-content\"><div class=\"col-lg-12 col-sm-12\"><div class=\"panel panel-default\"><div class=\"panel-body\"><iframe src=\"http://ict.ict-lab.it/dev/qms/\" width=\"100%\" height=\"700\" frameborder=\"0\"></iframe></div></div></div></div>");
$templateCache.put("portal/home/track-modal.html","<style>\n    textarea {\n        resize: none;\n    }\n</style><div class=\"panel-body\"><form name=\"trackForm\" class=\"form-validation\"><div class=\"form-group\" ng-class=\"{\'has-error\': trackForm.title.$invalid}\"><label>Inserire Titolo</label> <input type=\"text\" name=\"title\" class=\"form-control\" ng-model=\"track.title\" required=\"\"></div><div class=\"form-group\" ng-class=\"{\'has-error\': trackForm.description.$invalid}\"><label>Inserire Descrizione</label> <textarea type=\"textarea\" name=\"description\" class=\"form-control\" rows=\"4\" ng-model=\"track.description\" required=\"\"></textarea></div><div class=\"form-group\" ng-class=\"{\'has-error\': trackForm.url.$invalid}\"><label>Inserire url</label> <textarea type=\"textarea\" name=\"url\" class=\"form-control\" rows=\"7\" ng-model=\"track.url\" required=\"\"></textarea></div><br><div class=\"form-group\"><div><label>Tutte le commesse</label> <label class=\"i-switch bg-success m-b-n-xs m-l-xs m-r\"><input type=\"checkbox\" ng-model=\"isCommissionModeEnabled\"> <i></i></label></div><div ng-if=\"!isCommissionModeEnabled && commissions\"><six-select-2 sx-id=\"commission_list\" sx-list=\"commissionslist\" sx-title=\"\'Commessa\'\" ng-model=\"commissions\" sx-field=\"\'selected\'\" sx-placeholder=\"\'commessa...\'\" sx-multiple=\"true\" sx-item-template=\"\'{{item.description}}\'\"></six-select-2></div></div><br><button class=\"btn btn-success btn-block btn-lg\" ng-click=\"save()\" ng-disabled=\"trackForm.$invalid\">Invia</button></form></div>");
$templateCache.put("portal/home/tracking.html","<style>\n\n  .item-image-no-hover {\n      background-color: #2B4A61;\n      height: 100%;\n      min-height: 130px;\n      line-height: 130px;\n      transition: all .3s linear;\n      border-radius: 3px 0px 0px 3px;\n      cursor: default;\n  }\n  .item-image-no-hover .icon{\n        width: 70px;\n  }\n  .white-box-no-hover {\n        cursor: default !important;\n    }\n</style><div class=\"bg-light lter b-b portal-header\"><button ng-if=\"superuser() && !widgetTrackEditMode\" class=\"btn btn-secondary pull-right m-r-sm r-2x\" ng-click=\"enterEditMode()\"><i class=\"fa fa-pencil\"></i> Modifica disposizione</button> <button ng-if=\"superuser() && widgetTrackEditMode\" class=\"btn btn-success pull-right m-r-sm r-2x\" ng-click=\"exitEditMode()\"><i class=\"fa fa-save\"></i> Salva disposizione</button><div ng-if=\"superuser() && widgetTrackEditMode\" class=\"col-md-4 form-group pull-right m-r-sm r-2x\" ng-class=\"{\'has-error\': roleForm.$invalid, \'has-success\': roleForm.$valid}\"><six-lookup-2 sx-id=\"ruolo\" sx-base-path=\"\'record\'\" sx-type=\"\'ruolooperatore\'\" sx-title=\"\'Ruolo\'\" ng-model=\"ruolo_operatore\" sx-compact=\"true\" sx-required=\"true\" sx-on-select=\"updateRuoloFilter(item)\" sx-on-clear=\"clearRuoloFilter()\" sx-form=\"roleForm\"></six-lookup-2></div><div ng-if=\"superuser() && !widgetTrackEditMode\" class=\"align-text-bottom pull-right m-r-sm r-2x\"><p style=\"margin: 7px 10px;\">Ruolo: {{ruolo_operatore.code}}</p></div><button ng-if=\"superuser()\" class=\"btn btn-success pull-right m-r-sm r-2x\" ng-click=\"createTrackingListItem()\"><i class=\"fa fa-plus\"></i> Nuovo</button><div class=\"page-title\">Sistemi di tracciabilità</div></div><div class=\"portal-content\"><div class=\"container-fluid\"><div class=\"row\"><div ng-if=\"isWidgetVisible(widget)\" ng-repeat=\"widget in widgetList\" class=\"col-sm-4 col-xs-12\"><a ng-href=\"{{urlHandler(widget.track.url)}}\" target=\"_blank\"><div class=\"white-box clearfix\" ng-class=\"{\'white-box-no-hover\': widgetTrackEditMode}\"><div class=\"item-wrapper\" ng-style=\"blurredWidgetStyle[widget.code]\"><div class=\"col-sm-4 no-margin no-padder\"><div ng-class=\"{\'item-image\': !widgetTrackEditMode, \'item-image-no-hover\': widgetTrackEditMode }\"><img src=\"images/portal/app.svg\" class=\"icon\"></div></div><div class=\"col-sm-8 no-margin no-padder\"><div class=\"item\"><h3 class=\"title\">{{widget.track.title}}</h3><p>{{widget.track.description}}</p></div></div></div></div></a> <button class=\"btn-light\" ng-if=\"widgetTrackEditMode\" style=\"position: absolute; top:0px; right: 14px;\" ng-click=\"hideWidget(widget.code)\"><i class=\"fa\" ng-class=\"{\'fa-eye-slash\': isHidden(widget.code), \'fa-eye\': !isHidden(widget.code)}\"></i></button> <button class=\"btn-danger\" ng-if=\"widgetTrackEditMode\" style=\"position: absolute; bottom:20px; right: 14px;\" ng-click=\"removeWidget(widget.code)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div>");
$templateCache.put("portal/issue/issue-detail.html","<div class=\"bg-light lter b-b portal-header\"><a class=\"btn btn-default pull-right r-2x\" ng-click=\"loadData()\"><i class=\"fa fa-refresh\"></i></a> <button class=\"btn btn-danger pull-right m-r-sm r-2x\" ng-if=\"canDelete\" ng-confirm-message=\"Vuoi eliminare la segnalazione?\" ng-confirm-click=\"deleteIssue()\" ng-confirm-condition=\"true\"><i class=\"fa fa-trash\"></i> Elimina</button> <button class=\"btn btn-default pull-right m-r-sm r-2x\" ng-click=\"back()\"><i class=\"fa fa-chevron-left\"></i></button><div class=\"page-title\">Richiesta dettaglio</div></div><div class=\"portal-content issue\"><div class=\"row\"><div class=\"col-lg-8 col-lg-offset-2\"><div class=\"panel panel-default wrapper-sm\" ng-if=\"issue\"><div class=\"panel-body\"><span class=\"pull-right priority prt-{{issue.model.priority_id.description | lowercase}}\">{{issue.model.priority_id.description}}</span><div class=\"row\"><h3 class=\"col-md-3\">{{issue.reporter_id.description}}</h3><h3 class=\"col-md-3\">{{issue.model.categoria.description}}</h3><h3 class=\"col-md-3\">{{issue.model.sottocategoria.description}}</h3></div><div class=\"clearfix\"></div><hr><div class=\"date\">{{issue.date_requested | amCalendar}} <span class=\"pull-right status\"><div class=\"btn btn-status-detail\" ng-if=\"!readonly\" ng-repeat=\"status in statues\" ng-model=\"issue.status\" uib-btn-radio=\"status\" ng-change=\"updateIssue()\" ng-class=\"status\" uib-tooltip=\"{{(issue.status == status)?\'\' : \'Sposta la richiesta nello stato: \'}}{{status}}\" tooltip-append-to-body=\"true\"><i class=\"fa\" ng-class=\"getStatusClass(status)\"></i> {{status}}</div><div ng-if=\"readonly\"><i class=\"fa\" ng-class=\"getStatusClass(issue.status)\"></i> {{issue.status}}</div></span></div><div class=\"pull-right\" ng-if=\"sla.enableSLA\"><label>Stato SLA:</label> <i class=\"fa\" ng-class=\"{\'fa-check-circle-o text-success\': sla.isSLAValid == true, \'fa-times-circle-o text-danger\': sla.isSLAValid == false}\"></i> <label>Scadenza SLA: {{sla.date_time_consegna.format(\'DD/MM/YYYY\')}} alle ore: {{sla.date_time_consegna.format(\'HH\')}} .</label> <label>Ore trascorse: {{sla.total_workhours}}</label></div><div class=\"row\"><div class=\"col-md-6\"><h4>{{issue.model.record_id.description}} <span class=\"text-muted h5\">({{issue.model.record_id.code}})</span></h4><p>{{issue.model.note}}</p><div ng-if=\"issue.status_note\"><hr><strong>Note di stato</strong><p>{{issue.status_note}}</p></div></div><div class=\"col-md-6\" style=\"margin-top: 5px;\" ng-if=\"isRepartoAllowed\"><div ng-if=\"!readonly\"><div class=\"col-md-4\"><label>Stato approvazione</label><six-select-2 sx-id=\"status_approvazione\" sx-title=\"\'Approvazione\'\" sx-list=\"status_approvazione_list\" ng-model=\"status_approvazione\" sx-on-select=\"updateStatusApprovazione(status_approvazione, item)\" sx-item-template=\"\'{{item.value}}\'\" sx-clearable=\"false\" sx-empty-placeholder=\"\'Stato approvazione ...\'\" sx-compact=\"true\" sx-multiple=\"false\"></six-select-2></div><div class=\"col-md-4\"><label>Utente approvatore</label><six-lookup-2 sx-id=\"nodeLookup_utenteApprovatore\" ng-model=\"issue.model.utente_approvatore\" sx-base-path=\"record\" sx-type=\"\'operatore\'\" sx-filter=\"operatoreFilter\" sx-compact=\"false\" sx-on-select=\"updateIssueUtenteApprovatore(item)\" sx-on-clear=\"updateIssueUtenteApprovatore()\" sx-item-template=\"\'{{item.description}}\'\"></six-lookup-2></div><div class=\"col-md-4\"><label>Data approvazione</label><six-date-time-picker sx-id=\"dataApprovazionePicker\" name=\"datePicker\" ng-model=\"data_approvazione\" format=\"dateFormat\" enable-time=\"0\" sx-disabled=\"true\"></six-date-time-picker></div></div><div ng-if=\"readonly\"><six-select-2 class=\"col-md-2\" sx-id=\"status_approvazione\" sx-title=\"\'Approvazione\'\" sx-list=\"status_approvazione_list\" ng-model=\"status_approvazione\" sx-on-select=\"updateStatusApprovazione(status_approvazione, item)\" sx-item-template=\"\'{{item.value}}\'\" sx-disabled=\"true\" sx-clearable=\"false\" sx-empty-placeholder=\"\'Stato approvazione ...\'\" sx-compact=\"true\" sx-multiple=\"false\"></six-select-2></div></div></div><div class=\"nonconforme-container\"><div ng-if=\"issue.model.segnalazioninonconformi\">Segnalazioni non conformi:<ul class=\"segnalazionenonconforme-list\"><li ng-repeat=\"segnalazionenonconforme in issue.model.segnalazioninonconformi\">{{segnalazionenonconforme.code}} - {{segnalazionenonconforme.description}}</li></ul></div><div ng-if=\"issue.model.azionicorrettive\">Azioni correttive:<ul class=\"segnalazionenonconforme-list\"><li ng-repeat=\"azionecorrettiva in issue.model.azionicorrettive\">{{azionecorrettiva.code}} - {{azionecorrettiva.description}}</li></ul></div></div><div class=\"quantity-container\"><div ng-if=\"issue.model.quantity\"><label>Quantità: {{issue.model.quantity}}</label></div></div><div class=\"file\" ng-if=\"attachment\"><hr><strong>Allegato</strong><div class=\"clearfix\"></div><div class=\"well-download clearfix\"><a ng-href=\"{{dowloadUrl}}{{attachment.object_id}}\" target=\"_blank\" download=\"{{attachment.title}}\"><i class=\"m-r fa\" ng-class=\"getDocumentClass()\"></i> {{attachment.title | midletruncate:35}}</a> <a ng-href=\"{{dowloadUrl}}{{attachment.object_id}}\" class=\"btn btn-attachment pull-right\" target=\"_blank\" download=\"{{attachment.title}}\"><i class=\"m-r fa\" ng-class=\"getDocumentClass()\"></i> Download</a></div></div></div></div><div class=\"m-t-xl padder-lg\"><div class=\"m-b b-l m-l-md b-2x b-info streamline comment\" ng-if=\"issue.model.comments.length\"><span ng-repeat=\"c in issue.model.comments\"><div><span class=\"pull-left thumb-sm avatar text-center m-l-n-md\"><h3>{{getInitial(c.author.description)}}</h3></span><div class=\"m-l-lg panel b-a\"><div class=\"panel-heading pos-rlt b-b b-light\"><span class=\"arrow left\"></span> {{c.author.description}} <label class=\"label bg-info m-l-xs\" ng-if=\"c.author_role\">{{c.author_role.description}}</label> <span class=\"text-muted m-l-sm pull-right\" uib-tooltip=\"{{c.creation_date | amCalendar}}\"><i class=\"fa fa-clock-o\"></i> {{c.creation_date | amTimeAgo}}</span></div><div class=\"panel-body\"><div>{{c.text}}</div><div class=\"m-t-sm\"><a class=\"btn btn-default btn-xs\" ng-click=\"toggleReply($index)\"><i class=\"fa fa-mail-reply text-muted\"></i> Rispondi</a><div uib-collapse=\"replyOpenedIndex != $index\"><div class=\"input-group collapse m-t-sm\"><input class=\"form-control\" placeholder=\"Inserisci il tuo commento qui\" ng-model=\"reply\"> <span class=\"input-group-btn\"><button class=\"btn btn-info\" type=\"button\" ng-disapled=\"!reply.length\" ng-click=\"addReply(reply, c); reply = \'\'\">Rispondi</button></span></div></div></div></div></div></div><div ng-repeat=\"r in c.replies\" class=\"m-l-lg\"><span class=\"pull-left thumb-sm avatar text-center\"><h3>{{getInitial(r.author.description)}}</h3></span><div class=\"m-l-xxl panel b-a\"><div class=\"panel-heading pos-rlt b-b b-light\"><span class=\"arrow left pull-up\"></span> {{r.author.description}} <label class=\"label bg-info m-l-xs\" ng-if=\"c.author_role\">{{r.author_role.description}}</label> <span class=\"text-muted m-l-sm pull-right\" uib-tooltip=\"{{r.creation_date | amCalendar}}\"><i class=\"fa fa-clock-o\"></i> {{r.creation_date | amTimeAgo}}</span></div><div class=\"panel-body\"><div>{{r.text}}</div></div></div></div></span></div><div class=\"clearfix m-b-lg\"><div class=\"input-group\"><input type=\"text\" class=\"form-control input-lg\" placeholder=\"Inserisci il tuo commento qui\" ng-model=\"comment\"> <span class=\"input-group-btn\"><button class=\"btn btn-info btn-lg\" type=\"button\" ng-click=\"addComment(comment); comment = \'\'\" ng-disabled=\"!comment.length\">Commenta</button></span></div></div></div></div></div></div>");
$templateCache.put("portal/issue/issue-list.html","<style>\n  .td-center-text {\n    text-align: center;\n  }\n</style><div class=\"bg-light lter b-b portal-header\"><a class=\"btn btn-default pull-right r-2x\" ng-click=\"loadData()\"><i class=\"fa fa-refresh\"></i></a> <button class=\"btn btn-success pull-right m-r-sm r-2x\" ng-click=\"createIssue()\"><i class=\"fa fa-plus\"></i> Nuova Richiesta</button> <button class=\"btn btn-success pull-right m-r-sm r-2x\" ng-click=\"exportIssueList(\'XLS\')\"><i class=\"fa fa-file-text-o\"></i> Esporta in XLS</button> <button class=\"btn btn-success pull-right m-r-sm r-2x\" ng-click=\"exportIssueList(\'CSV\')\"><i class=\"fa fa-file-text-o\"></i> Esporta in CSV</button><div class=\"page-title\">Richieste</div></div><six-sidebar style=\"text-align: center;\" sx-id=\"sidebar\" sx-position=\"right\" sx-title=\"Dettaglio\" sx-opened=\"sidebar.isVisible\"><span ng-if=\"sidebar.segnalazioninonconformi.length\" ng-repeat=\"sidebar_segnalazionenonconforme in sidebar.segnalazioninonconformi\"><a ng-click=\"goToIssue(sidebar_segnalazionenonconforme)\"><hr>{{sidebar_segnalazionenonconforme.description}}</a></span> <span style=\"text-align: center;\" ng-if=\"sidebar.azionicorrettive.length\" ng-repeat=\"sidebar_azionecorrettiva in sidebar.azionicorrettive\"><a ng-click=\"goToAzioneCorrettiva(sidebar_azionecorrettiva)\"><hr>{{sidebar_azionecorrettiva.description}}</a></span><hr></six-sidebar><div class=\"portal-content issue\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"panel panel-default animated fadeInUp\" style=\"overflow-x: scroll\"><table class=\"table issue\"><thead><tr class=\"sort-header\"><th width=\"30\">Sel./Desel. pagina</th><th class=\"data\">Data Apertura</th><th class=\"data\">Data Chiusura</th><th width=\"100\">Priorità</th><th>Descrizione</th><th ng-hide=\"onlyMineOpened\"></th><th>Reparto</th><th>Categoria</th><th>Sottocategoria</th><th>Allegati</th><th class=\"w-xs text-right\"><a ng-click=\"clearFilter()\" title=\"Pulisci tutti i filtri\"><i class=\"fa fa-times-circle-o text-default\"></i> Pulisci tutti i filtri</a></th></tr><tr class=\"filter\"><th class=\"td-center-text\"><div><input type=\"checkbox\" ng-model=\"selectAllSelector\" ng-change=\"selectAllHandler()\"></div></th><th><div class=\"input-group input-group-sm m-b-sm\"><input class=\"form-control\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"filter.from\" is-open=\"fropOpened\" clear-text=\"Pulisci\" close-text=\"Chiudi\" current-text=\"Oggi\" ng-change=\"loadData()\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" ng-click=\"fropOpened = !fropOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group input-group-sm\"><input class=\"form-control\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"filter.to\" is-open=\"toOpened\" clear-text=\"Pulisci\" close-text=\"Chiudi\" current-text=\"Oggi\" ng-change=\"loadData()\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" ng-click=\"toOpened = !toOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></th><th><div class=\"input-group input-group-sm m-b-sm\"><input class=\"form-control\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"filter.from_cl\" is-open=\"fromclOpened\" clear-text=\"Pulisci\" close-text=\"Chiudi\" current-text=\"Oggi\" ng-change=\"loadData()\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" ng-click=\"fromclOpened = !fromclOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group input-group-sm\"><input class=\"form-control\" uib-datepicker-popup=\"dd MMM yyyy\" ng-model=\"filter.to_cl\" is-open=\"toclOpened\" clear-text=\"Pulisci\" close-text=\"Chiudi\" current-text=\"Oggi\" ng-change=\"loadData()\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" ng-click=\"toclOpened = !toclOpened\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></th><th><ui-select ng-model=\"filter.priority\" ng-change=\"loadData()\" skip-focusser=\"true\"><ui-select-match allow-clear=\"true\">{{$select.selected.description}}</ui-select-match><ui-select-choices repeat=\"p in (priorities | filter: $select.search) track by p.UUID\"><span ng-bind=\"p.description | highlight: $select.search\"></span></ui-select-choices></ui-select></th><th><div class=\"input-group input-group-sm\"><input type=\"text\" class=\"form-control\" ng-model=\"filter.note\" ng-change=\"loadData()\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" ng-click=\"filter.note = null; loadData()\"><i class=\"glyphicon glyphicon-remove\"></i></button></span></div></th><th ng-hide=\"onlyMineOpened\"><div class=\"input-group input-group-sm\"><input type=\"text\" class=\"form-control\" ng-model=\"filter.reporter\" ng-change=\"loadData()\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" ng-click=\"filter.reporter = null; loadData()\"><i class=\"glyphicon glyphicon-remove\"></i></button></span></div></th><th><div class=\"input-group input-group-sm\"><input type=\"text\" class=\"form-control\" ng-model=\"filter.reparto\" ng-change=\"loadData()\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" ng-click=\"filter.reparto = null; loadData()\"><i class=\"glyphicon glyphicon-remove\"></i></button></span></div></th><th><div class=\"input-group input-group-sm\"><input type=\"text\" class=\"form-control\" ng-model=\"filter.categoria\" ng-change=\"loadData()\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" ng-click=\"filter.categoria = null; loadData()\"><i class=\"glyphicon glyphicon-remove\"></i></button></span></div></th><th><div class=\"input-group input-group-sm\"><input type=\"text\" class=\"form-control\" ng-model=\"filter.sottocategoria\" ng-change=\"loadData()\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" ng-click=\"filter.sottocategoria = null; loadData()\"><i class=\"glyphicon glyphicon-remove\"></i></button></span></div></th><th width=\"100\"></th><th style=\"text-align: center;\" class=\"status-check\"><label style=\"display:block;\" ng-repeat=\"status in statues\" ng-model=\"filter.status[status]\" ng-disabled=\"onlyMineOpened\" uib-btn-checkbox=\"status\" ng-change=\"loadData()\" uib-tooltip=\"{{status}}\" tooltip-append-to-body=\"true\" ng-class=\"{\'badge badge-empty\': filter.status[status]}\"><i class=\"fa\" ng-class=\"getStatusClass(status)\"></i> {{status}}</label></th></tr></thead><tbody><tr ng-repeat=\"item in issueResponse.list\"><td class=\"td-center-text\"><input type=\"checkbox\" ng-model=\"item.checked\"></td><td ng-click=\"goToIssue(item)\"><span uib-tooltip=\"{{item.date_requested | amCalendar}}\" am-time-ago=\"item.date_requested\"></span></td><td ng-click=\"goToIssue(item)\"><span uib-tooltip=\"{{item.date_closing | amCalendar}}\" am-time-ago=\"item.date_closing\"></span></td><td ng-click=\"goToIssue(item)\"><span class=\"priority prt-{{item.model.priority_id.description | lowercase}}\">{{item.model.priority_id.description}}</span></td><td ng-click=\"goToIssue(item)\">{{item.model.note | cut:true:50:\'...\'}}</td><td ng-click=\"goToIssue(item)\" ng-hide=\"onlyMineOpened\">{{item.reporter_id.description}}</td><td ng-click=\"goToIssue(item)\">{{item.model.record_id.description}}</td><td ng-click=\"goToIssue(item)\">{{item.model.categoria.description}}</td><td ng-click=\"goToIssue(item)\">{{item.model.sottocategoria.description}}</td><td ng-click=\"goToIssue(item)\" width=\"50\"><div class=\"btn btn-attachment btn-sm\" ng-if=\"hasAttachment(item)\"><i class=\"fa fa-paperclip\"></i> Allegato</div></td><td ng-click=\"goToIssue(item)\" class=\"text-right\" width=\"120\"><div class=\"btn btn-status btn-sm {{item.status}}\" uib-tooltip=\"{{item.status}} {{item.status_note}}\"><i class=\"fa\"></i></div><div class=\"btn btn-detail btn-sm\"><i class=\"fa fa-eye\"></i></div></td></tr></tbody></table><div class=\"m-md alert alert-success\" ng-if=\"issueResponse.totalResults == 0\">Non ci sono richieste</div><footer class=\"panel-footer text-center\"><uib-pagination boundary-links=\"true\" total-items=\"issueResponse.totalResults\" ng-model=\"paginatedRequest.page\" class=\"pagination-sm\" items-per-page=\"paginatedRequest.page_size\" ng-change=\"loadData()\" max-size=\"10\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></uib-pagination></footer></div></div></div></div>");
$templateCache.put("portal/issue/issue-modal.html","<div class=\"panel-body\"><form name=\"issueForm\" class=\"form-validation\"><div class=\"form-group\" ng-class=\"{\'has-error\': issueForm.asset.$invalid, \'has-success\': issueForm.asset.$valid}\"><label>Seleziona Reparto</label><six-lookup-2 sx-id=\"asset\" sx-base-path=\"\'record\'\" sx-type=\"\'reparto\'\" sx-title=\"\'Reparti\'\" ng-model=\"issue\" sx-field=\"\'assetReference\'\" sx-required=\"true\" sx-form=\"issueForm\"></six-lookup-2></div><div class=\"form-group\" ng-class=\"{\'has-error\': issueForm.categoria.$invalid, \'has-success\': issueForm.categoria.$valid}\"><label>Seleziona Categoria</label><six-lookup-2 sx-id=\"categoria\" sx-base-path=\"\'record\'\" sx-type=\"\'categoria\'\" sx-title=\"\'Categoria\'\" ng-model=\"issue.categoria\" sx-required=\"true\" sx-on-select=\"updateCategoriaIdFilter(item)\" sx-on-clear=\"updateCategoriaIdFilter()\" sx-form=\"issueForm\"></six-lookup-2></div><div ng-if=\"issue.categoria && issue.categoria.code !== \'NC\'\" class=\"form-group\" ng-class=\"{\'has-error\': issueForm.sottocategoria.$invalid, \'has-success\': issueForm.sottocategoria.$valid}\"><label>Seleziona Sottocategoria</label><six-lookup-2 sx-id=\"sottocategoria\" sx-base-path=\"\'record\'\" sx-type=\"\'sottocategoria\'\" sx-title=\"\'Sottocategoria\'\" ng-model=\"issue.sottocategoria\" sx-filter=\"categoriaIdFilter\" sx-required=\"true\" sx-form=\"issueForm\"></six-lookup-2></div><div ng-if=\"issue.categoria && issue.categoria.code === \'NC\'\"><div class=\"form-group\"><label>Elenco segnalazioni non conformi</label><six-lookup-2 sx-id=\"segnalazioninonconformi\" sx-base-path=\"\'issue\'\" sx-type=\"\'record\'\" sx-title=\"\'Segnalazione non conforme\'\" ng-model=\"issue.segnalazionenonconforme_list\" sx-field=\"\'code\'\" sx-item-template=\"\'{{item.code}} - {{item.note}}\'\" sx-war=\"\'six-plan\'\" sx-required=\"false\" sx-form=\"issueForm\" sx-multiple=\"true\" sx-sources=\"[\'model.code\',\'model.description\',\'UUID\',\'model.customCode\',\'model.note\']\"></six-lookup-2></div><div class=\"form-group\"><label>Azioni correttive</label><six-lookup-2 sx-id=\"azionicorrettive\" sx-base-path=\"\'record\'\" sx-type=\"\'azionecorrettiva\'\" sx-title=\"\'Azione correttiva\'\" ng-model=\"issue.azionecorrettiva_list\" sx-field=\"\'code\'\" sx-item-template=\"\'{{item.description}}\'\" sx-required=\"false\" sx-form=\"issueForm\" sx-multiple=\"true\"></six-lookup-2></div></div><div class=\"form-group\" ng-if=\"issue.categoria && with_quantity == true\"><label>Quantità</label><input name=\"quantity\" class=\"form-control\" type=\"number\" ng-model=\"issue.quantity\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" step=\"0.01\"> <span class=\"help-block\" ng-show=\"!issueForm.quantity.$valid\">La Quantità deve essere un numero intero o decimale.</span></div><div class=\"form-group\" ng-class=\"{\'has-error\': issueForm.note.$invalid}\"><label ng-hide=\"issue.categoria && issue.categoria.code === \'NC\'\">Testo richiesta</label> <label ng-if=\"issue.categoria && issue.categoria.code === \'NC\'\">Descrizione non conformità</label> <textarea type=\"textarea\" name=\"note\" class=\"form-control\" rows=\"7\" ng-model=\"issue.note\" required=\"\"></textarea></div><div class=\"btn-group\" ng-if=\"priorities.length\"><label class=\"btn btn-default\" ng-repeat=\"p in priorities\" ng-model=\"issue.priority\" uib-btn-radio=\"p\">{{p.description}}</label></div><div class=\"form-group\" ng-hide=\"uploader.queue.length\"><label>Aggiungi file</label><div ng-if=\"uploader.queue.length == 0\" class=\"well drop-zone text-center\" nv-file-drop=\"\" nv-file-over=\"\" uploader=\"uploader\">Trascina qui o <a class=\"btn\" onclick=\"document.getElementById(\'fileinput\').click()\">Scegli</a> <input id=\"fileinput\" type=\"file\" nv-file-select=\"\" uploader=\"uploader\" ng-show=\"false\"></div></div><div class=\"file\" ng-if=\"uploader.queue.length\" ng-init=\"file = uploader.queue[0]\"><span class=\"file-name\">{{file.file.name | midletruncate:35}}</span> <span class=\"file-size m-l-xs text-muted\">({{ file.file.size/1024/1024|number:2 }} MB)</span> <a class=\"pull-right\" ng-click=\"!file.isUploading && file.remove()\" uib-tooltip=\"Elimina\"><i class=\"fa fa-times text-danger\"></i></a></div><button class=\"btn btn-success btn-block btn-lg\" ng-click=\"save()\" ng-disabled=\"issueForm.$invalid\">Invia</button></form></div>");
$templateCache.put("portal/quality/plan-survey.html","<div class=\"bg-light lter b-b portal-header\"><button class=\"btn btn-success pull-right r-2x m-l-sm\" ng-click=\"save()\" ng-disabled=\"!plan.surveyResponse.length\"><i class=\"fa fa-save\"></i> Salva</button> <button class=\"btn btn-info pull-right r-2x m-l-sm\" ng-click=\"resolveCron()\" ng-disabled=\"simulation.$invalid\"><i class=\"icon-magic-wand\"></i> Simula</button><div class=\"page-title\">Pianificazione Questionari</div></div><div class=\"portal-content plan-survey\"><form name=\"simulation\" class=\"form-validation\"><div class=\"row list-group-item b-l-3x b-l-warning m-t-sm r-2x\"><div class=\"col-md-6 col-sm-12\"><div class=\"input-group w-full\"><label class=\"control-label\">Frequenza</label><select class=\"form-control\" ng-model=\"frequency.frequency\" ng-options=\"f.value as f.label for f in frequencies\"></select></div><div><div class=\"m-t\" ng-show=\"frequency.frequency == \'week_1\'\"><div class=\"btn-group\"><label class=\"btn btn-default\" ng-model=\"frequency.day_of_week\" ng-repeat=\"day in dayOfWeek\" uib-btn-radio=\"day.value\">{{day.label}}</label></div></div><div class=\"m-t\" ng-hide=\"frequency.frequency == \'week_1\'\"><div class=\"btn-group\"><label class=\"btn btn-default\" ng-model=\"frequency.day_of_month\" uib-btn-radio=\"\'1\'\">1° del mese</label> <label class=\"btn btn-default\" ng-model=\"frequency.day_of_month\" uib-btn-radio=\"\'15\'\">15 del mese</label></div></div><div class=\"m-t\" ng-show=\"isAnnual()\"><div class=\"btn-group btn-group-sm\"><label class=\"btn btn-default\" ng-model=\"frequency.month_of_year\" ng-repeat=\"month in monthOfYear\" uib-btn-radio=\"month.value\">{{month.label}}</label></div></div></div></div><div class=\"col-md-3 col-sm-6\"><label for=\"fromDate\" class=\"control-label\">Dal</label><p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"dateRange.from\" ng-required=\"true\" is-open=\"popupFrom\" datepicker-options=\"dateOptionsFrom\" close-text=\"Chiudi\" ng-change=\"updateMinDate()\" current-text=\"Oggi\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"popupFrom = !popupFrom\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-3 col-sm-6\"><label for=\"toDate\" class=\"control-label\">Al</label><p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"dateRange.to\" ng-required=\"true\" is-open=\"popupTo\" datepicker-options=\"dateOptionsTo\" close-text=\"Chiudi\" current-text=\"Oggi\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"popupTo = !popupTo\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"row list-group-item b-l-3x b-l-success m-t-sm r-2x\"><div class=\"col-md-6 col-sm-12\"><label class=\"control-label\">Commessa</label><six-lookup-2 ng-model=\"plan\" sx-type=\"\'commission\'\" sx-field=\"\'commissions\'\" sx-sources=\"[\'code\',\'description\']\" sx-multiple=\"true\" sx-form=\"simulation\" sx-required=\"1\"></six-lookup-2></div><div class=\"col-md-6 col-sm-12\"><label class=\"control-label\">Questionario</label><six-lookup-2 ng-model=\"plan\" sx-type=\"\'survey\'\" sx-field=\"\'surveies\'\" sx-multiple=\"true\" sx-war=\"\'six-plan\'\" sx-base-path=\"\'survey\'\" sx-form=\"simulation\" sx-required=\"1\"></six-lookup-2></div></div></form><div class=\"row m-t-sm\"><div class=\"col-md-12 no-padder\" ng-show=\"plan.surveyResponse.length\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><span ng-repeat=\"c in plan.commissions\"><i class=\"fa fa-circle m-r-xs\" ng-style=\"getColor($index)\"></i> {{c.description}}</span></div><div class=\"panel-body\"><six-calendar calendar=\"calendarOptions\" register=\"registerCalendar($api)\"></six-calendar></div></div></div></div></div>");
$templateCache.put("portal/quality/quality-list.html","<div class=\"bg-light lter b-b portal-header\"><a class=\"btn btn-default pull-right r-2x\" ng-click=\"loadData()\"><i class=\"fa fa-refresh\"></i></a><div class=\"page-title\">Qualità</div></div><div class=\"portal-content quality\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"panel panel-default animated fadeInUp\"><table class=\"table quality\"><thead><tr><th class=\"data\">Data</th><th>Codice</th><th>Descrizione</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in surveyResponse.list\" ng-click=\"goToSurvey(item.UUID)\"><td><span uib-tooltip=\"{{item.dataIn | amCalendar}}\" am-time-ago=\"item.dataIn\"></span></td><td>{{item.model.code}}</td><td>{{item.model.description}}</td><td class=\"text-right\" width=\"120\"><div class=\"btn btn-status btn-sm\" ng-class=\"{ \'is-new\': item.model.is_new, done: item.model.score >= (item.model.min_score || 0) , invalid: item.model.score < (item.model.min_score || 0)}\"><i class=\"fa\"></i></div><div class=\"btn btn-detail btn-sm\"><i class=\"fa fa-eye\"></i></div></td></tr></tbody></table><div class=\"m-md alert alert-success\" ng-if=\"surveyResponse.totalResults == 0\">Non ci sono questionari</div><footer class=\"panel-footer text-center\"><uib-pagination boundary-links=\"true\" total-items=\"surveyResponse.totalResults\" ng-model=\"paginatedRequest.page\" class=\"pagination-sm\" items-per-page=\"paginatedRequest.page_size\" ng-change=\"loadData()\" max-size=\"10\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></uib-pagination></footer></div></div></div></div>");
$templateCache.put("theme/adminchiam/adminchiam.html","<style type=\"text/css\">\n  .endpoint {\n    font-style: italic;\n    font-weight: bold;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    padding: 6px;\n    background-color: #F0FFE9;\n    border-radius: 5px 5px 5px 5px;\n  }\n  .endpoint:before {\n    content: \"REST endpoint: \";\n    font-style: normal;\n    font-weight: normal;\n  }\n  ul.resources li:before {\n    content: attr(method);\n    background-color: #fffea5;\n    margin-right: 10px;\n    color: grey;\n    font-weight: bold;\n    font-size: .8em;\n  }\n</style><script type=\"text/ng-template\" id=\"testrest\"><div class=\"endpoint\">/six/rest/testrest</div> <h4 class=\"title\">Messages</h4> <ul> <li>messages?infosN={number}&successesN={number}&warningsN={number}&errorsN={number}&severesN={number}&result={text}&period={period} <ul> <li>period: PnDTnHnMn.nS (vedere https://docs.oracle.com/javase/8/docs/api/java/time/Duration.html#parse-java.lang.CharSequence-); es. P2DT3H4M15S</li> </ul> </li> </ul></script><script type=\"text/ng-template\" id=\"tree\"><div class=\"endpoint\">/six-data-set/api/tree</div> <h4 class=\"title\">Check</h4> <ul class=\"resources\"> <li method=\"GET\">_check</li> </ul> <h4 class=\"title\">Fix</h4> <ul class=\"resources\"> <li method=\"GET\">_fix/dataout</li> <li method=\"GET\">_fix/tree/{tree_id}</li> </ul> <h4 class=\"title\">Copy</h4> <ul class=\"resources\"> <li method=\"GET\">_copy/{commission}/{to_commission}</li> <li method=\"GET\">_copytoall/{commission}</li> </ul> <h4 class=\"title\">Index</h4> <ul class=\"resources\"> <li method=\"GET\">v2/_index/{treeUUID}</li> <li method=\"GET\">v2/_indexall</li> </ul> <h4 class=\"title\">Propagate</h4> <ul class=\"resources\"> <li method=\"POST\">_parents/_propagate?schema_code={schemaCode}&commission={commission}</li> </ul></script><script type=\"text/ng-template\" id=\"record\"><div class=\"endpoint\">/six-data-set/api/record</div> <h4 class=\"title\">Check</h4> <ul> <li>{type}/_check</li> <li>{type}/_check/timeline?commission={commission}&entity={entity} <i>- N.B. potrebbe non funzionare a dovere se non si specifica commessa e/o entity a causa del limite di 10000 documenti nelle query elasticsearch</i></li> <li>{type}/_check/{commission}/{code}</li> </ul> <h4 class=\"title\">Fix</h4> <ul> <li>{type}/_fix/all</li> <li>{type}/_fix/all/{uuid}</li> <li>{type}/_fix/schemacode</li> <li>{type}/_fix/schemacode/{uuid}</li> <li>{type}/_fix/commission</li> <li>{type}/_fix/commission/{uuid}</li> <li>{type}/_fix/dataout</li> <li>{type}/_fix/dataout/{uuid}</li> <li>{type}/_fix/formulas/{uuid}</li> <li>{type}/_fix/formulas</li> <li>{type}/_fix/timeline?commission={commission}&entity={entity} <i>- N.B. potrebbe non funzionare a dovere se non si specifica commessa e/o entity a causa del limite di 10000 documenti nelle query elasticsearch</i></li> </ul></script><script type=\"text/ng-template\" id=\"nashornuomconversion\"><div class=\"endpoint\">/six-data-set/api/nashornuomconversion</div> <h4 class=\"title\">Admin</h4> <ul> <li>_admin/cache/invalidate</li> </ul></script><script type=\"text/ng-template\" id=\"nashornformula\"><div class=\"endpoint\">six-data-set/api/nashornformula</div> <h4 class=\"title\">Admin</h4> <ul> <li>_admin/cache/invalidate</li> </ul></script><script type=\"text/ng-template\" id=\"consumption\"><div class=\"endpoint\">/six-energy/api/consumption</div> <h4 class=\"title\">Consumptions</h4> <ul> <li>calcall/{type}?from={yyyy-MM-dd}&to={yyyy-MM-dd}: from e to opzionali (default: from=1900-01-01 ; to=2900-12-31)</li> <li>calcall/{type}/{commission}?from={yyyy-MM-dd}&to={yyyy-MM-dd}: from e to opzionali (default: from=1900-01-01 ; to=2900-12-31)</li> </ul></script><script type=\"text/ng-template\" id=\"energy/dd\"><div class=\"endpoint\">/six-energy/api/energy/dd</div> <h4 class=\"title\">Day Degrees</h4> <ul> <li>tempToDD/all: calcola i GG storici a partire dalle temperature medie storiche</li> <li>saveReferring/{year}: calcola i GG a consuntivo per tutte le ZT che fanno riferimento ad altre, per l\'anno {year}</li> </ul></script><script type=\"text/ng-template\" id=\"config\"><div class=\"endpoint\">/[six-data-set|six-consip]/api/config</div> <h4 class=\"title\">Config</h4> <ul> <li>GET _refresh: Aggiorna le configurazioni da matrix par</li> <li>GET _get: Recupera le configurazioni da matrix par</li> </ul></script><script type=\"text/ng-template\" id=\"zonatermica\"><div class=\"endpoint\">/six-energy/api/zonatermica</div> <h4 class=\"title\">Zona Termica</h4> <ul> <li>GET tempProvinciaToZonaTermica/_all: Aggiorna le temperature medie a partire da quelle definite nel comune associato</li> </ul></script><script type=\"text/ng-template\" id=\"snapshot\"><div class=\"endpoint\">/six-energy/api/snapshot</div> <h4 class=\"title\">Snapshot</h4> <ul> <li>DELETE [?commission=&lt;commission&gt;]: Elimina tutti gli snapshot</li> <li>DELETE budget[?commission=&lt;commission&gt;]: Elimina lo snapshot del budget</li> <li>DELETE recordassociation: Elimina lo snapshot dell\'associazione contatore-zonatermica</li> <li>DELETE daydegree: Elimina lo snapshot dei gradi giorno</li> <li>DELETE consumption[?commission=&lt;commission&gt;]: Elimina lo snapshot dei consumi</li> <li>DELETE consanalysis[?commission=&lt;commission&gt;]: Elimina lo snapshot dell\'analisi consumi</li> </ul></script><script type=\"text/ng-template\" id=\"frontendInfo\"><h4> <div class=\"label label-success pull-left m-xs\"> <b>{{frontEndInfo.title}}</b><br> <i>{{frontEndInfo.vendor}}</i><br> v. {{frontEndInfo.version}}<br> Rev. {{frontEndInfo.revision | limitTo: 8}}<br> Built on {{frontEndInfo.builddate | date: \"yyyy-MM-dd HH:mm:ss\"}}<br> Build profile: {{frontEndInfo.buildprofile}}<br> CI pipeline: {{frontEndInfo.cipipelineid}}<br> CI build: {{frontEndInfo.cibuildid}}<br> </div> </h4></script><script type=\"text/ng-template\" id=\"moduleInfo\"><h4> <div class=\"label label-info pull-left m-xs\"> <b>{{info.title}}</b><br> <i>{{info.vendor}}</i><br> v. {{info.version}}<br> Rev. {{info.gitSHA1 | limitTo : 8}} ({{info.gitbranch}})<br> Built on {{info.buildtime | date: \"yyyy-MM-dd HH:mm:ss\"}}<br> Build profile: {{info.buildprofile}}<br> CI pipeline: {{info.cipipelineid}}<br> CI build: {{info.cibuildid}}<br> </div> </h4></script><div class=\"constructor\"><div class=\"col-md-12\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"col-md-12\"><div ng-include=\"\'frontendInfo\'\"></div><div ng-include=\"\'moduleInfo\'\" ng-repeat=\"info in modulesInfo\"></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-body\"><uib-tabset class=\"tabs-left\"><uib-tab index=\"0\"><uib-tab-heading><span class=\"fa fa-list-alt text-info-dker\"></span> REST</uib-tab-heading><div class=\"col-md-12\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-3\">Service<six-select-2 sx-id=\"service\" ng-model=\"selected\" sx-field=\"\'service\'\" sx-list=\"serviceList\" sx-compact=\"true\" sx-item-template=\"\'{{item.description}}\'\"></six-select-2></div><div class=\"col-md-3\">Service type<six-select-2 sx-id=\"serviceType\" ng-model=\"selected\" sx-field=\"\'serviceType\'\" sx-list=\"secondMap[selected.service.key]\" sx-compact=\"true\" sx-item-template=\"\'{{item.description}}\'\"></six-select-2></div><div class=\"col-md-3\">Type<six-select-2 sx-id=\"type\" ng-model=\"selected\" sx-field=\"\'third\'\" sx-list=\"thirdMap[selected.service.key + selected.serviceType.key]\" sx-compact=\"true\" sx-item-template=\"\'{{item.description}}\'\"></six-select-2></div><div class=\"col-md-3\" ng-if=\"selected.service.key===\'record\' || selected.service.key===\'consumption\'\">Model type<six-lookup-2 sx-id=\"modelType\" ng-model=\"modelType\" sx-field=\"\'id\'\" sx-base-path=\"\'schema\'\" sx-compact=\"true\" sx-item-template=\"\'{{item.description}}\'\"></six-lookup-2></div><div class=\"col-md-12\">Path params <input type=\"text\" class=\"form-control\" ng-model=\"params.path\"></div><div class=\"col-md-12\">Query params <input type=\"text\" class=\"form-control\" ng-model=\"params.query\"></div></div><div class=\"row m-t\"><div class=\"col-md-3\">HTTP Action<six-select-2 sx-id=\"httpAction\" ng-model=\"selected\" sx-field=\"\'httpAction\'\" sx-list=\"httpActionsList\" sx-compact=\"true\" sx-item-template=\"\'{{item.description}}\'\"></six-select-2></div><div class=\"col-md-3\">Module<six-select-2 sx-id=\"module\" ng-model=\"selected\" sx-field=\"\'module\'\" sx-list=\"modulesList\" sx-compact=\"true\" sx-item-template=\"\'{{item.description}}\'\"></six-select-2></div><div class=\"col-md-6\">Request<div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"path.path\"> <span class=\"input-group-btn\"><button ng-click=\"go()\" type=\"button\" class=\"btn btn-default\"><span class=\"fa fa-heartbeat\"></span> Go</button> <button ng-click=\"reset()\" type=\"button\" class=\"btn btn-default\"><span class=\"fa fa-times\"></span> Reset</button></span></div></div></div></div><div class=\"m-t panel-group\" id=\"accordion\" ng-if=\"selected.service\"><div class=\"panel panel-default\" id=\"panel1\"><div class=\"panel-body\"><a data-toggle=\"collapse\" data-target=\"#collapseOne\" ng-click=\"advancedStatus.open=!advancedStatus.open\"><div class=\"panel-heading\"><h4 class=\"panel-title\"><i class=\"pull-right fa ng-scope fa-angle-right\" ng-class=\"{\'fa-angle-down\': advancedStatus.open, \'fa-angle-right\': !advancedStatus.open}\"></i> Suggerimenti</h4></div></a><div id=\"collapseOne\" class=\"panel-collapse collapse\"><div ng-include=\"selected.service.key\"></div></div></div></div></div><div class=\"m-t panel-group\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><div class=\"panel-title\">Chiamate</div></div><div class=\"panel-body\"><table class=\"tinyTable\"><tr><th width=\"50px\">Nr.</th><th>Modulo</th><th>Path</th><th>Inizio</th><th>Fine</th><th>Durata</th><th width=\"100px\">Stato</th><th width=\"50px\">Esito</th></tr><tr ng-repeat=\"call in calls track by $index\"><td width=\"50px\" class=\"text-center\">{{$index}}</td><td>{{call.module}}</td><td>{{call.path}}</td><td>{{call.start | date:\'HH:mm:ss.sss\'}}</td><td>{{call.end | date:\'HH:mm:ss.sss\'}}</td><td>{{call.duration}} ms ({{call.duration/1000}} s)</td><td width=\"100px\" class=\"text-center\">{{call.status}}</td><td width=\"50px\" class=\"text-center\"><a ng-click=\"showResponse(call.response)\" ng-if=\"call.response\"><i class=\"fa fa-reply\"></i></a> <span ng-if=\"!call.response\">-</span></td></tr></table></div></div></div></div></uib-tab><uib-tab index=\"1\"><uib-tab-heading><span class=\"fa fa-envelope-o text-primary-dker\"></span> Broadcast</uib-tab-heading><div class=\"col-md-12\"><div class=\"row\"><div class=\"col-md-4\"><label class=\"control-label\">Tipo:</label><select class=\"form-control\" id=\"broadcastLevel\" ng-model=\"broadcast.level\"><option>INFO</option><option>SUCCESS</option><option>WARNING</option><option>ERROR</option></select></div><div class=\"col-md-4\"><label class=\"control-label\">Da:</label> <input type=\"text\" class=\"form-control\" ng-model=\"broadcast.from\"></div><div class=\"col-md-4\"><label class=\"checkbox i-checks m-b inline col-md-12\"><input type=\"checkbox\" ng-model=\"broadcast.pinned\"><i></i> <span class=\"i-checks\">In evidenza:</span></label></div></div><div class=\"row\"><div class=\"col-md-12\"><label class=\"control-label\">Oggetto:</label> <input type=\"text\" class=\"form-control\" ng-model=\"broadcast.object\"></div></div><div class=\"row\"><div class=\"col-md-12\"><label class=\"control-label\">Messagio:</label> <textarea rows=\"4\" class=\"col-md-12\" ng-model=\"broadcast.message\"></textarea></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"btn btn-success pull-right m-t\" ng-click=\"sendBroadcast(broadcast)\">Invia</div></div></div><div class=\"m-t panel-group\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><div class=\"panel-title\">Messaggi precompilati</div></div><div class=\"panel-body\"><table class=\"tinyTable\"><tr><th>Titolo</th><th>Livello</th><th width=\"80px\">Evidenza</th><th width=\"30px\">Sel.</th></tr><tr ng-repeat=\"msg in precompiledMessages track by $index\"><td ng-bind-html=\"msg.object\"></td><td>{{msg.level}}</td><td width=\"80px\">{{msg.pinned}}</td><td width=\"30px\"><a ng-click=\"selectPrecompiledMessage(msg)\" class=\"btn-xs btn-default\"><span class=\"fa fa-play-circle icon text\"></span></a></td></tr></table></div></div></div></div></uib-tab><uib-tab index=\"2\"><uib-tab-heading><span class=\"fa fa-user text-success-dker\"></span> Utenti</uib-tab-heading><div class=\"col-md-12\"><div class=\"btn btn-sm btn-info pull-right m-b\" ng-click=\"refreshUsers()\"><i class=\"fa fa-refresh\"></i> Aggiorna</div><table class=\"tinyTable\"><tr><th><a ng-click=\"userSortBy(\'username\')\">Username</a> <i class=\"fa\" ng-class=\"{\'fa-caret-up\': userIsSorted(\'username\')==1, \'fa-caret-down\': userIsSorted(\'username\')==-1}\"></i> <input type=\"text\" ng-model=\"userSearch.username\" class=\"form-control input-xs m-b-xs\" placeholder=\"Username ...\"></th><th><a ng-click=\"userSortBy(\'commission\')\">Commessa</a> <i class=\"fa\" ng-class=\"{\'fa-caret-up\': userIsSorted(\'commission\')==1, \'fa-caret-down\': userIsSorted(\'commission\')==-1}\"></i> <input type=\"text\" ng-model=\"userSearch.commission\" class=\"form-control input-xs m-b-xs\" placeholder=\"Commessa ...\"></th><th><a ng-click=\"userSortBy(\'location\')\">Percorso</a> <i class=\"fa\" ng-class=\"{\'fa-caret-up\': userIsSorted(\'location\')==1, \'fa-caret-down\': userIsSorted(\'location\')==-1}\"></i> <input type=\"text\" ng-model=\"userSearch.location\" class=\"form-control input-xs m-b-xs\" placeholder=\"Percorso ...\"></th><th><a ng-click=\"userSortBy(\'lastTransaction\')\">Ultima transazione</a> <i class=\"fa\" ng-class=\"{\'fa-caret-up\': userIsSorted(\'lastTransaction\')==1, \'fa-caret-down\': userIsSorted(\'lastTransaction\')==-1}\"></i> <input type=\"text\" ng-model=\"userSearch.lastTransaction\" class=\"form-control input-xs m-b-xs\" placeholder=\"Ultima transazione ...\"></th></tr><tr ng-repeat=\"user in activeUsers | filter: {username: userSearch.username, commission: userSearch.commission, location: userSearch.location, lastTransaction: userSearch.lastTransaction} | orderBy: userSort track by $index\"><td>{{user.username}}</td><td>{{user.commission}}</td><td>{{user.location}}</td><td>{{user.lastTransaction | date: \'dd/MM/yyyy HH:mm:ss\'}}</td></tr></table></div></uib-tab><uib-tab index=\"3\"><uib-tab-heading><span class=\"fa fa-random text-warning-dker\"></span> MISC</uib-tab-heading><div class=\"col-md-12\"><div class=\"panel-body\"><div class=\"row\"><label class=\"checkbox-inline i-checks override-checkbox-i m-b col-md-4\"><input type=\"checkbox\" ng-model=\"forceSixLogin.active\"><i></i> <span class=\"i-checks\">Forza login da SIX (bypassa il CAS)</span></label></div></div></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("theme/auth/logout.html","");
$templateCache.put("theme/auth/postauth.html","");
$templateCache.put("theme/changeuser/changeuser.html","<div class=\"col-md-12 pad-t-15\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Cambio utente</h1><small class=\"text-muted\">Dashboard</small></div></div></div><div class=\"panel-body\"><div class=\"form-group\"><input ng-keyup=\"searchUsers()\" class=\"form-control\" type=\"text\" ng-model=\"searchString\" placeholder=\"Scrivere qui per filtrare la lista...\"></div><table id=\"userList\" class=\"table table-striped\"><thead><tr><th></th><th>Username</th><th>Nome</th><th>Cognome</th><th>E-Mail</th></tr></thead><tbody><tr ng-repeat=\"item in data.list\"><td><a ng-click=\"changeUser(item.username)\" class=\"btn-sm btn-default\" id=\"btn_changeUser\" ng-hide=\"isCurrent(item.username)\"><span class=\"fa fa-play-circle icon text\"></span></a></td><td>{{ item.username }}</td><td>{{ item.surname }}</td><td>{{ item.name }}</td><td>{{ item.email }}</td></tr><tr ng-hide=\"data.list.length\"><td><p class=\"text-center\">No Data Found</p></td></tr></tbody></table></div></div></div>");
$templateCache.put("theme/commission/circle-tmpl.html","<div class=\"ui-grid-cell-contents\" style=\"text-align: center\"><i class=\"fa fa-circle fa-2x\" ng-class=\"{\'text-success\': row.entity.status == \'SUCCESS\', \'text-warning\': row.entity.status == \'WARNING\'}\"></i></div>");
$templateCache.put("theme/commission/commission_copy.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Copia\" btn-class=\"btn-success\" icon=\"fa fa-clone\" toolbar-function=\"copy()\" sx-disabled=\"copyForm.$invalid\" ng-hide=\"response && response.status != \'error\'\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-lg-12\"><h1 class=\"m-n font-thin h3 text-black\">Commesse</h1><small class=\"text-muted\">Copia commessa</small></div></div></div><div class=\"panel-body\"><form name=\"copyForm\"><div class=\"row top12 form-group\"><div class=\"col-md-2\"><label class=\"control-label\">CODICE</label></div><div class=\"col-md-10\"><input class=\"form-control\" readonly=\"\" ng-model=\"commission.code\"></div></div><div class=\"row top12 form-group\" ng-class=\"{\'has-error\': copyForm.description.$invalid}\"><div class=\"col-md-2\"><label class=\"control-label\">DESCRIZIONE</label></div><div class=\"col-md-10\"><input class=\"form-control\" name=\"description\" ng-readonly=\"response && response.status != \'error\'\" ng-model=\"commission.description\" required=\"\"><div ng-messages=\"copyForm.description.$error\"><div ng-message=\"required\" class=\"badge bg-danger badge-sm m-l-xs\">Obbligatorio</div></div></div></div><div class=\"row top12 form-group\"><div class=\"col-md-2\"><label class=\"control-label\">CLIENTI</label></div><div class=\"col-md-10\"><six-select-2 sx-id=\"customer\" ng-model=\"commission\" sx-field=\"\'customers\'\" sx-list=\"commissionCustomers\" sx-multiple=\"true\" sx-compact=\"true\" sx-key=\"\'code\'\" sx-item-template=\"\'{{item.description}}\'\" sx-empty-placeholder=\"\'Tutti i clienti\'\" sx-disabled=\"response && response.status != \'error\'\"></six-select-2></div></div><div class=\"row top12 form-group\"><div class=\"col-md-2\"><label class=\"control-label\">MODELLI</label></div><div class=\"col-md-10\"><six-lookup-2 id=\"schema\" sx-base-path=\"\'schema\'\" ng-model=\"commission\" sx-field=\"\'types\'\" sx-item-template=\"\'{{item.description}}\'\" sx-compact=\"true\" sx-page-size=\"10000\" sx-multiple=\"true\" sx-empty-placeholder=\"\'Tutti i tipi\'\" sx-disabled=\"response && response.status != \'error\'\"></six-lookup-2></div></div><div class=\"row top12 form-group\"><div class=\"col-md-offset-2 col-md-10\"><div class=\"checkbox\"><label class=\"i-checks\"><input type=\"checkbox\" ng-disabled=\"response && response.status != \'error\'\" ng-model=\"commission.tree\"> <i></i> Copia i tree</label></div></div></div><div class=\"row top12 form-group\"><div class=\"col-md-2\"><label class=\"control-label\">CODICE SAP</label></div><div class=\"col-md-10\"><input class=\"form-control\" ng-readonly=\"response && response.status != \'error\'\" ng-model=\"commission.sapCode\"></div></div></form></div><div class=\"panel-body\" ng-if=\"response\"><div ng-if=\"warningGrid.data\" class=\"grid\" ui-grid=\"warningGrid\"></div></div></div></div>");
$templateCache.put("theme/commission/commission_detail.html","<script type=\"text/ng-template\" id=\"generic-messages\"><div ng-message=\"required\" class=\"badge bg-danger badge-sm m-l-xs\">Obbligatorio</div></script><six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"onSubmit(detailForm)\" sx-disabled=\"isWritePermAllowed()===false || disableSave\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" toolbar-function=\"deleteWithDialog(data.selected.code)\" sx-disabled=\"isDeletePermAllowed()===false\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Commesse</h1><small class=\"text-muted\">Dettaglio commessa</small></div></div></div><div class=\"panel-body\"><form name=\"detailForm\" ng-submit=\"onSubmit(detailForm)\" class=\"m-t\"><div class=\"row top12 form-group\"><div class=\"col-md-2\"><label id=\"code_label\" for=\"code\" class=\"control-label\">CODICE</label></div><div class=\"col-md-10\"><input ng-disabled=\"!isNew\" ng-change=\"codeChanged()\" type=\"text\" class=\"form-control\" name=\"code\" id=\"code\" placeholder=\"\" ng-model=\"data.selected.code\"></div></div><div class=\"row top12 form-group\" ng-class=\"{\'has-error ng-invalid\': !detailForm.description.$pristine && detailForm.description.$invalid}\"><div class=\"col-md-2\"><label id=\"description_label\" for=\"description\" class=\"control-label\">DESCRIZIONE</label></div><div class=\"col-md-10\"><input id=\"description\" name=\"description\" type=\"text\" class=\"form-control\" placeholder=\"\" ng-model=\"data.selected.description\" required=\"\"><div ng-messages=\"detailForm.description.$error\" ng-if=\"!detailForm.description.$pristine || (detailForm.$submitted && detailForm.description.$error.required)\"><div ng-messages-include=\"generic-messages\"></div></div></div></div><div class=\"row top12 form-group\"><div class=\"col-md-2\"><label id=\"customer_label\" for=\"customer\" class=\"control-label\">CLIENTE</label></div><div class=\"col-md-10\"><six-lookup-2 sx-id=\"customer\" ng-model=\"data.selected\" sx-type=\"\'cliente\'\" sx-field=\"\'cliente\'\" sx-multiple=\"true\" sx-compact=\"false\" sx-required=\"false\" sx-form=\"detailForm\"></six-lookup-2></div></div><div class=\"row top12 form-group\"><div class=\"col-md-2\"><label id=\"sapCode_label\" for=\"code\" class=\"control-label\">CODICE SAP</label></div><div class=\"col-md-10\"><input type=\"text\" class=\"form-control\" name=\"code\" id=\"sapCode\" placeholder=\"\" ng-model=\"data.selected.sapCode\"></div></div><div class=\"row top12 form-group\" ng-class=\"{\'has-error ng-invalid\': !startTimePickerForm.time.$pristine && startTimePickerForm.time.$invalid && !endTimePickerForm.time.$pristine && endTimePickerForm.time.$invalid}\"><div class=\"col-md-2\"><label id=\"date_label\" for=\"date\" class=\"control-label\">ORARI GESTIONE SEGNALAZIONI</label></div><div class=\"col-md-10\" ng-if=\"enableTimePicker\"><time-span-picker start=\"timespan.startTime\" end=\"timespan.endTime\"></time-span-picker><div ng-messages=\"timePickerForm.date.$error\" ng-if=\"!startTimePickerForm.time.$pristine || (startTimePickerForm.$submitted && startTimePickerForm.time.$error.required) || !endTimePickerForm.time.$pristine || (endTimePickerForm.$submitted && endTimePickerForm.time.$error.required)\"><div ng-messages-include=\"generic-messages\"></div></div></div></div><div class=\"row top12 form-group\" ng-class=\"{\'has-error ng-invalid\': !detailForm.date.$pristine && detailForm.date.$invalid}\"><div class=\"col-md-2\"><label id=\"date_label\" for=\"date\" class=\"control-label\">DATA APERTURA</label></div><div class=\"col-md-10\"><six-date-time-picker sx-id=\"date\" ng-model=\"data.selected.date\" enable-time=\"false\" sx-required=\"true\" date-options=\"dateOptions\" sx-form=\"detailForm\"></six-date-time-picker><div ng-messages=\"detailForm.date.$error\" ng-if=\"!detailForm.date.$pristine || (detailForm.$submitted && detailForm.date.$error.required)\"><div ng-messages-include=\"generic-messages\"></div></div></div></div><div class=\"row top12 form-group\" ng-class=\"{\'has-error ng-invalid\': !detailForm.status.$pristine && detailForm.status.$invalid}\"><div class=\"col-md-2\"><label id=\"status_label\" for=\"status\" class=\"control-label\">STATO</label></div><div class=\"col-md-10\"><six-select-2 sx-id=\"status\" sx-list=\"statusList\" sx-title=\"\'Stato\'\" ng-model=\"data.selected\" sx-field=\"\'status\'\" sx-item-template=\"\'{{item.description}}\'\" sx-placeholder=\"\'stato...\'\" sx-multiple=\"false\" sx-required=\"true\" sx-compact=\"true\" sx-form=\"detailForm\" sx-on-select=\"setClosure(item)\"></six-select-2><div ng-messages=\"detailForm.status.$error\" ng-if=\"!detailForm.status.$pristine || (detailForm.$submitted && detailForm.status.$error.required)\"><div ng-messages-include=\"generic-messages\"></div></div></div></div><div class=\"row top12 form-group\" ng-class=\"{\'has-error ng-invalid\': !detailForm.closing_date.$pristine && detailForm.closing_date.$invalid}\" ng-if=\"data.selected.status.key == \'closed\'\"><div class=\"col-md-2\"><label id=\"closing_date_label\" for=\"closing_date\" class=\"control-label\">DATA CHIUSURA</label></div><div class=\"col-md-10\"><six-date-time-picker sx-id=\"closing_date\" ng-model=\"data.selected.closing_date\" enable-time=\"false\" sx-required=\"true\" date-options=\"closingDateOptions\" sx-form=\"detailForm\"></six-date-time-picker><div ng-messages=\"detailForm.closing_date.$error\" ng-if=\"!detailForm.closing_date.$pristine || (detailForm.$submitted && detailForm.closing_date.$error.required)\"><div ng-messages-include=\"generic-messages\"></div></div></div></div></form></div></div></div>");
$templateCache.put("theme/commission/commission_list.html","<style type=\"text/css\">\n  .closed-commission {\n    color: #ffffff;\n    background-color: #f05050 !important;\n  }\n</style><six-toolbar><six-toolbar-item icon=\"fa fa-upload icon text-info-dker\" label=\"Esporta\" toolbar-function=\"exportCommissions()\"></six-toolbar-item><six-toolbar-button label=\"Aggiungi commessa\" icon=\"fa fa-plus\" toolbar-function=\"addCommission()\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"getData()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista Commesse</h1></div></div></div><div class=\"panel-body\"><six-grid-pagination sx-id=\"commission_grid\" get-data-callback=\"getData()\" get-list-callback=\"getData()\" get-all-data-callback=\"getAllData()\" items-list=\"data\" column-defs=\"viewGridOptions.columnDefs\" grid-app-callbacks=\"gridAppCallbacks\" grid-options=\"viewGridOptions\" enable-state-saving=\"true\" params=\"params\" show-global-search=\"false\"></six-grid-pagination></div></div></div>");
$templateCache.put("theme/dashboard/dashboard.html","<div class=\"hbox hbox-auto-xs hbox-auto-sm ng-scope\" ng-init=\"app.settings.asideFolded = false; app.settings.asideDock = false;\"><div class=\"col\"><six-toolbar><six-toolbar-button label=\"Ricarica\" btn-class=\"btn-info\" icon=\"fa fa-cogs\" toolbar-function=\"reloadDashboard()\"></six-toolbar-button></six-toolbar><div class=\"wrapper-md ng-scope override-padding-toolbar\"><div class=\"row\"><div class=\"col-sm-12 col-md-6 connected\" id=\"center-1-1\" ui-jq=\"sortable\" ui-options=\"{items:\'.panel\', handle:\'.panel-heading\', connectWith:\'.connected\'}\"><div ng-repeat=\"item in pos1\" ng-include=\"\'theme/dashboard/widget_center_pos.html\'\"></div></div><div class=\"col-sm-12 col-md-6 connected\" id=\"center-1-2\" ui-jq=\"sortable\" ui-options=\"{items:\'.panel\', handle:\'.panel-heading\', connectWith:\'.connected\'}\"><div ng-repeat=\"item in pos2\" ng-include=\"\'theme/dashboard/widget_center_pos.html\'\"></div></div></div><div class=\"row\"><div ng-if=\"pos1.length==0\" class=\"col-sm-12 col-md-6 connected\" id=\"center-2-1\" ui-jq=\"sortable\" ui-options=\"{items:\'.panel\', handle:\'.panel-heading\', connectWith:\'.connected\'}\"><div ng-repeat=\"item in tmp1\" ng-include=\"\'theme/dashboard/widget_center_pos.html\'\"></div></div><div ng-if=\"pos1.length==0\" class=\"col-sm-12 col-md-6 connected\" id=\"center-2-2\" ui-jq=\"sortable\" ui-options=\"{items:\'.panel\', handle:\'.panel-heading\', connectWith:\'.connected\'}\"><div ng-repeat=\"item in tmp2\" ng-include=\"\'theme/dashboard/widget_center_pos.html\'\"></div></div></div><div class=\"row\"><div class=\"col-sm-12 col-md-12 connected\" ui-jq=\"sortable\" ui-options=\"{items:\'.panel\', handle:\'.panel-heading\', connectWith:\'.connected\'}\"><div ng-repeat=\"item in wide\" ng-include=\"\'theme/dashboard/widget_center_pos.html\'\"></div></div></div></div></div><div class=\"col w-md bg-white-only b-l bg-auto no-border-xs\" id=\"right-menu\" ng-if=\"pos3.length>0\"><div class=\"nav-tabs-alt\"><ul class=\"nav nav-tabs\" role=\"tablist\"><li ng-repeat=\"item in pos3\" ng-class=\"{\'active\': $index==0}\" ng-init=\"targetId=\'#tab-\'+($index+1)\"><a data-target=\"{{targetId}}\" role=\"tab\" data-toggle=\"tab\" ng-init=\"liClass=\'text-md text-muted wrapper-sm \'+item.icon\"><i class=\"{{liClass}}\"></i></a></li></ul></div><div class=\"tab-content\"><div ng-repeat=\"item in pos3\" role=\"tabpanel\" ng-init=\"tabId=\'tab-\'+($index+1)\" id=\"{{tabId}}\" class=\"tab-pane\" ng-class=\"{\'active\': $index==0}\" ng-include=\"\'theme/dashboard/widget_aside_pos.html\'\" <=\"\" div=\"\"></div></div></div></div>");
$templateCache.put("theme/dashboard/dashboardemma_old.html","<div ng-controller=\"ConsumptionAnalysisCtrl\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Home</h1><small class=\"text-muted\">Dashboard EMMA</small></div><div class=\"col-sm-6 text-right hidden-xs\"><div class=\"inline m-r text-left\"><button type=\"button\" class=\"btn btn-info btn-sm pull-right\" ng-click=\"reload()\"><i class=\"fa fa-refresh\"></i> Aggiorna</button></div></div></div></div><div class=\"col-md-12 wrapper-md\"><div class=\"col-md-12 block panel padder-v\"><table class=\"homeTable table-hover\"><tr><th style=\"width: 25%\"><div class=\"col-sm-6\">Da data:<p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"\" ng-model=\"dashYearsPicker.from\" is-open=\"statusFrom.opened\" datepicker-options=\"dateOptions\" ng-required=\"true\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openFrom($event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-sm-6\">A data:<p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"\" ng-model=\"dashYearsPicker.to\" is-open=\"statusTo.opened\" datepicker-options=\"dateOptions\" ng-required=\"true\" close-text=\"Close\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openTo($event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></th><th class=\"numberCell\">Budget</th><th class=\"numberCell\">Consuntivo</th><th class=\"numberCell\">Stagionalità</th><th class=\"numberCell\">&Delta; Stagionalità</th><th class=\"numberCell\">&Delta; Tecnico</th><th class=\"numberCell\">%</th></tr><tr ng-repeat=\"vector in vectors\" class=\"{{currentVector==vector?\'text-black\':\'\'}}\" ng-if=\"getValues(vector).cons !== 0 || getValues(vector).budget !== 0 || vector.model.description == \'Totale\'\"><td class=\"text-center\"><a href=\"\" ng-click=\"setCurrentVector(vector)\" class=\"block item {{currentVector==vector?\'inShadow\':\'\'}}\" style=\"{{vector.model.color?\'background-color: \'+vector.model.color:\'background-color: #CCC\'}}\"><span class=\"{{currentVector==vector?\'text-white font-bold\':\'text-info-dker\'}} font-thin h3 block\" style=\"{{vector.model.text_color?\'color: \'+vector.model.text_color+\' !important\':\'\'}}\">{{vector.model.description}}<span ng-if=\"vector.model.um.code\">({{vector.model.um.code}})</span></span><div ng-if=\"false\"><span class=\"{{currentVector==vector?\'text-info\':\'text-info-dker\'}} font-thin h3 block\">{{vector.cachedData.budget.totalConsumption| number: 2}}</span> <span class=\"text-muted text-xs\">{{vector.model.description}} <span ng-if=\"vector.cachedData.budget.totalConsumptionStd\">({{vector.cachedData.budget.totalConsumptionStd| number: 2}} Kw/h)</span></span></div></a></td><td class=\"numberCell\">{{getValues(vector).budget | number: 2}}</td><td class=\"numberCell\">{{getValues(vector).cons | number: 2}}</td><td class=\"numberCell\">{{getValues(vector).season | number: 2}}</td><td class=\"numberCell\">{{getValues(vector).deltaSeason | number: 2}}</td><td class=\"numberCell\">{{getValues(vector).deltaTech | number: 2}}</td><td class=\"numberCell\">{{getValues(vector).percentage | number: 2}}</td></tr></table></div><div class=\"panel col-md-12 block\"><div class=\"col-lg-6\"><six-loading-place-holder sx-model=\"currentVector.loadingPlaceHolder\" sx-height=\"\'450px\'\"></six-loading-place-holder><six-multi-series-line-chart sx-id=\"graph1\" sx-graph-data=\"graphData\" sx-y-axis-legend=\"\'Consumi\'\" sx-graph-title=\"Consumi\" sx-series-colors=\"[\'#1044EE\', \'#10BB99\', \'#EE2222\']\" sx-interpolate=\"\'monotone\'\"></six-multi-series-line-chart></div><div class=\"col-lg-6\"><six-loading-place-holder sx-model=\"currentVector.loadingPlaceHolder\" sx-height=\"\'450px\'\"></six-loading-place-holder><six-multi-series-line-chart sx-id=\"graph2\" sx-graph-data=\"graphDataCumulative\" sx-y-axis-legend=\"\'Consumi\'\" sx-graph-title=\"Consumi cumulati\" sx-series-colors=\"[\'#1044EE\', \'#10BB99\']\" sx-interpolate=\"\'monotone\'\"></six-multi-series-line-chart></div></div><div class=\"col-md-5\" ng-if=\"false\"><div class=\"row row-sm text-center\"><div class=\"col-xs-12 block panel padder-v\"><six-year-picker ng-model=\"dashYearsPicker.from\"></six-year-picker></div><div ng-repeat=\"vector in vectors\" class=\"col-xs-6\"><a href=\"\" ng-click=\"setCurrentVector(vector)\" class=\"block panel padder-v {{currentVector==vector?\'\':\'bg-info lter\'}} item {{currentVector==vector?\'inShadow\':\'\'}}\"><span class=\"{{currentVector==vector?\'text-info\':\'text-white\'}} font-thin h1 block\">{{vector.cachedData.budget.totalConsumption| number: 2}}</span> <span class=\"text-muted text-xs\">{{vector.model.description}} <span ng-if=\"vector.cachedData.budget.totalConsumptionStd\">({{vector.cachedData.budget.totalConsumptionStd| number: 2}} Kw/h)</span></span> <span class=\"bottom text-right w-full h3\"><span class=\"text-success-dker font-thin\" ng-if=\"vector.cachedData.budget.budgetComparison<0\">{{vector.cachedData.budget.budgetComparison | number: 0}}%</span> <span class=\"text-danger font-thin h3\" ng-if=\"vector.cachedData.budget.budgetComparison>0\">+{{vector.cachedData.budget.budgetComparison | number: 0}}%</span></span> <span class=\"bottom text-left w-full\" ng-if=\"!vector.cachedData\"><i class=\"fa fa-refresh fa-spin text-muted m-r-sm\"></i></span></a></div><div class=\"col-xs-12 m-b-md\" ng-if=\"loadingPlaceHolder.show\"><six-loading-place-holder sx-model=\"loadingPlaceHolder\" sx-height=\"\'170px\'\"></six-loading-place-holder></div><div class=\"col-xs-12 m-b-md\"><div class=\"r bg-light dker item hbox no-border\" ng-if=\"!loadingPlaceHolder.show\"><div class=\"col w-xs v-middle hidden-md\"><i class=\"fa fa-money\" style=\"font-size: xx-large\"></i></div><div class=\"col dk padder-v r-r\"><div class=\"text-primary-dk font-thin h1\"><span>{{budget.totalBudget | number: 0}}</span></div><span class=\"text-muted text-xs\">Totale budget <span ng-if=\"budget.totalBudgetStd\">({{budget.totalBudgetStd | number: 0}} Kw/h)</span></span></div></div></div><div class=\"col-xs-12 m-b-md\"><div class=\"r bg-light dker item hbox no-border\" ng-if=\"!loadingPlaceHolder.show\"><div class=\"col w-xs v-middle hidden-md\"><i class=\"fa fa-search\" style=\"font-size: xx-large\"></i></div><div class=\"col dk padder-v r-r\"><div class=\"text-primary-dk font-thin h1\"><span>{{budget.totalConsumption | number: 0}}</span></div><span class=\"text-muted text-xs\">Totale consumi <span ng-if=\"budget.totalConsumptionStd\">({{budget.totalConsumptionStd | number: 0}} Kw/h)</span></span> <span class=\"bottom text-right w-full h3\"><span class=\"text-success-dker font-thin\" ng-if=\"budget.budgetComparison<0\">{{budget.budgetComparison | number: 2}}%</span> <span class=\"text-danger font-thin h3\" ng-if=\"budget.budgetComparison>0\">+{{budget.budgetComparison | number: 2}}%</span></span></div></div></div></div></div><div class=\"row\"><div class=\"col-md-9\" ng-if=\"false\"><div class=\"col-md-6\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"clearfix text-center m-t\"><div class=\"inline\"><six-donut-chart sx-id=\"\'donut1\'\" sx-graph-data=\"donutDataBudget\"></six-donut-chart></div></div></div><footer class=\"panel-footer bg-info text-center no-padder\"><div class=\"row no-gutter\"><div class=\"col-xs-6\"><div class=\"wrapper\"><span class=\"m-b-xs h3 block text-white\">Budget</span> <small class=\"text-muted\">{{dashYearsPicker.from}}</small></div></div><div class=\"col-xs-6 dk\"><div class=\"wrapper\"><span class=\"m-b-xs h3 block text-white\">{{vectors.totVector.cachedData.budget.totalBudget | number: 0}}<six-loading-small sx-for=\"vectors.totVector.cachedData.budget.totalBudget\"></six-loading-small></span> <small class=\"text-muted\">Kw/h</small></div></div></div></footer></div></div><div class=\"col-md-6\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"clearfix text-center m-t\"><div class=\"inline\"><six-donut-chart sx-id=\"\'donut2\'\" sx-graph-data=\"donutDataConsumption\"></six-donut-chart></div></div></div><footer class=\"panel-footer bg-info text-center no-padder\"><div class=\"row no-gutter\"><div class=\"col-xs-6\"><div class=\"wrapper\"><span class=\"m-b-xs h3 block text-white\">Consumi</span> <small class=\"text-muted\">{{dashYearsPicker.from}}</small></div></div><div class=\"col-xs-6 dk\"><div class=\"wrapper\"><span class=\"m-b-xs h3 block text-white\">{{vectors.totVector.cachedData.budget.totalConsumptionStd | number: 0}}<six-loading-small sx-for=\"vectors.totVector.cachedData.budget.totalConsumptionStd\"></six-loading-small></span> <small class=\"text-muted\">Kw/h</small></div></div></div></footer></div></div></div><div class=\"col-sm-3 connected\" ui-jq=\"sortable\" ui-options=\"{items:\'.panel\', handle:\'.panel-heading\', connectWith:\'.connected\'}\"><div class=\"panel panel-info\" draggable=\"true\"><div class=\"panel-heading\">Quick link</div><div class=\"list-group bg-white\"><a href=\"#/consumptionanalysis\" class=\"list-group-item\"><i class=\"fa fa-fw fa-money\"></i> Analisi consumi</a> <a href=\"#/consumptive/consumption\" class=\"list-group-item\"><i class=\"fa fa-fw fa-money\"></i> Consuntivo consumi</a> <a href=\"#/budget/view\" class=\"list-group-item\"><i class=\"fa fa-fw fa-money\"></i> Visualizza budget</a></div></div></div></div></div></div>");
$templateCache.put("theme/dashboard/widget_aside_pos.html","<div class=\"wrapper-md\"><div class=\"m-b text-md\">{{ item.title }}</div><div ng-if=\"item.widgetType==\'widget-timeline\'\" ng-init=\"data=item.data; aside=true\" ng-include=\"\'theme/dashboard/widget_timeline.html\'\"></div></div>");
$templateCache.put("theme/dashboard/widget_center_pos.html","<div draggable=\"true\" class=\"widget widget-card\" style=\"display: block;\" ng-init=\"myClass=\'bg-\'+item.skin\" ng-hide=\"item.hideWidget\"><div class=\"panel\" ng-class=\"widgetClass\"><div class=\"panel-heading {{myClass}}\">{{ item.title }}<span ng-if=\"getDynamic(item).subtitle\">- {{ getDynamic(item).subtitle }}</span></div><div><div ng-if=\"item.widgetType==\'widget-label-list\'\" ng-init=\"data=item.data\" ng-include=\"\'theme/dashboard/widget_labellist.html\'\"></div><div ng-if=\"item.widgetType==\'widget-simple-list\'\" ng-init=\"data=item.data\" ng-include=\"\'theme/dashboard/widget_simplelist.html\'\"></div><div ng-if=\"item.widgetType==\'widget-user\'\" ng-init=\"data=item.data[0]\" ng-include=\"\'theme/dashboard/widget_user.html\'\"></div><div ng-if=\"item.widgetType==\'widget-donut\'\" ng-init=\"data=item.data\" ng-include=\"\'theme/dashboard/widget_donut.html\'\"></div><div ng-if=\"item.widgetType==\'widget-timeline\'\" ng-init=\"data=item.data\" ng-include=\"\'theme/dashboard/widget_timeline.html\'\"></div><div ng-if=\"item.widgetType==\'widget-consumptive\'\" ng-init=\"data=item.data\" ng-include=\"\'theme/dashboard/widget_consumptive.html\'\"></div><div ng-if=\"item.widgetType==\'widget-quicklink\'\" ng-init=\"data=item.data\" ng-include=\"\'theme/dashboard/widget_quicklink.html\'\"></div><div ng-if=\"item.widgetType==\'widget-consumptive-graph\'\" ng-init=\"data=item.data\" ng-include=\"\'theme/dashboard/widget_consumptive_graph.html\'\"></div><div ng-if=\"item.widgetType==\'widget-notifications\'\" ng-init=\"data=item.data\" ng-include=\"\'theme/dashboard/widget_notifications.html\'\"></div></div><div class=\"panel-footer\" ng-if=\"item.buttons.length>0\"><a ng-repeat=\"b in item.buttons\" ng-href=\"#/{{b.link}}\"><button class=\"btn btn-default\"><span ng-class=\"b.icon\"></span> {{ b.label }}</button></a></div></div></div>");
$templateCache.put("theme/dashboard/widget_consumptive.html","<div class=\"panel-body\" ng-click=\"selectWidget(data)\" ng-class=\"{\'selected\':isSelectedWidget(data)}\"><div class=\"row no-gutter\"><div class=\"col-xs-6 col-sm-4 col-md-6 col-lg-4 col-xl-2\"><div class=\"wrapper-sm\" ng-mouseenter=\"lightOn(1)\" ng-class=\"widgetEmmaClass[1]\" ng-mouseleave=\"lightOff(1)\"><span class=\"m-b-xs h3 block\"><i class=\"fa fa-refresh fa-spin\" ng-if=\"!data || data.showSpinner\"></i> <span ng-if=\"!data.showSpinner\">{{data.budget | number: 2}}</span></span> <small class=\"text-muted\">Budget</small></div></div><div class=\"col-xs-6 col-sm-4 col-md-6 col-lg-4 col-xl-2\"><div class=\"wrapper-sm widget-emma-3\" ng-mouseenter=\"lightOn(3)\" ng-class=\"widgetEmmaClass[3]\" ng-mouseleave=\"lightOff(3)\"><span class=\"m-b-xs h3 block\"><i class=\"fa fa-refresh fa-spin\" ng-if=\"!data || data.showSpinner\"></i> <span ng-if=\"!data.showSpinner\">{{data.cons | number: 2}}</span></span> <small class=\"text-muted\">Consuntivo</small></div></div><div class=\"row wrapper\" ng-if=\"data.showGraph\"><div class=\"col-md-12\"><six-multi-series-line-chart sx-id=\"graph_{{data.graph.id}}\" sx-graph-data=\"data.graph.graphData\" sx-y-axis-legend=\"\'Consumi\'\" sx-graph-title=\"{{title}}\" sx-series-colors=\"[\'#1044EE\', \'#10BB99\', \'#EE2222\']\" sx-interpolate=\"\'monotone\'\"></six-multi-series-line-chart></div></div></div><div class=\"legend\"><span class=\"text-xs text-muted pull-right\">{{datePicker.from | date}} / {{datePicker.to | date}}</span> <span style=\"clear:both\"></span></div></div>");
$templateCache.put("theme/dashboard/widget_consumptive_graph.html","<div class=\"panel-body\"><div class=\"row no-gutter\"><div class=\"row wrapper\"><div class=\"col-md-12\"><six-multi-series-line-chart sx-id=\"graph\" sx-graph-data=\"widgetEmmaSelected.graph.graphData\" sx-y-axis-legend=\"\'Consumi\'\" sx-graph-title=\"{{widgetEmmaSelected.graph.title}}\" sx-series-colors=\"[\'#1044EE\', \'#10BB99\', \'#EE2222\']\" sx-interpolate=\"\'monotone\'\"></six-multi-series-line-chart></div></div><div class=\"row wrapper\"><div class=\"col-md-12\"><six-multi-series-line-chart sx-id=\"graph_cum\" sx-graph-data=\"widgetEmmaSelected.graph.graphDataCumulative\" sx-y-axis-legend=\"\'Consumi cum.\'\" sx-graph-title=\"{{widgetEmmaSelected.graph.title}} (cum.)\" sx-series-colors=\"[\'#1044EE\', \'#10BB99\', \'#EE2222\']\" sx-interpolate=\"\'monotone\'\"></six-multi-series-line-chart></div></div></div><div class=\"legend\"><span class=\"text-xs text-muted pull-right\">{{datePicker.from | date}} / {{datePicker.to | date}}</span> <span style=\"clear:both\"></span></div></div>");
$templateCache.put("theme/dashboard/widget_donut.html","<div class=\"panel-body m-b font-italic text-muted\" ng-if=\"!data.length\">Nessun dato</div><six-donut-chart ng-show=\"data.length\" ng-init=\"chartId=\'donut\'+$index\" sx-id=\"chartId\" sx-graph-data=\"data\" sx-chart-width=\"300\" sx-chart-height=\"300\" sx-hide-labels=\"true\"></six-donut-chart><ul class=\"list-group no-radius\" style=\"margin-bottom:0px;\"><li class=\"list-group-item\" ng-repeat=\"d in data\" ng-init=\"bgStyle={\'background-color\':d.color}\"><span class=\"pull-right\">{{ d.value }}</span> <span class=\"label donut-label m-r-xs\" ng-style=\"bgStyle\">{{ d.label }}</span> {{ d.description }}</li></ul>");
$templateCache.put("theme/dashboard/widget_labellist.html","<div class=\"panel-body\"><div class=\"m-b font-italic text-muted\" ng-if=\"!data.length\">Nessun dato</div><div class=\"m-b\" ng-repeat=\"d in data\" ng-init=\"bgClass=\'bg-\'+d.color;arrowClass=\'arrow-\'+d.color\"><span class=\"label text-base pos-rlt m-r {{bgClass}}\"><i class=\"arrow right {{arrowClass}}\"></i> {{d.label}}</span> <a ng-href=\"#/{{d.link}}\">{{d.title}}</a></div></div>");
$templateCache.put("theme/dashboard/widget_notifications.html","<div class=\"panel-body\"><div class=\"m-b font-italic text-muted\" ng-if=\"!data.length\">Nessun dato</div><ul class=\"list-group list-group-sm list-group-sp list-group-alt auto m-t\"><li class=\"list-group-item\" ng-repeat=\"d in data\" ng-init=\"textClass=\'text-\'+d.color;\"><a ng-href=\"#/{{d.link}}\"><span class=\"text-muted\">{{ d.label | date:\'dd-MM-yyyy\'}}</span> <span class=\"block text-md {{textClass}}\">{{ d.title }}</span></a></li></ul></div>");
$templateCache.put("theme/dashboard/widget_quicklink.html","<div class=\"no-padder\"><div class=\"hbox text-center b-b b-light text-sm\"><a ng-repeat=\"d in data\" ng-href=\"{{d.link}}\" class=\"col padder-v text-muted\"><i class=\"{{d.icon}} block m-b-xs fa-2x\"></i> <span>{{d.label}}</span></a></div></div>");
$templateCache.put("theme/dashboard/widget_simplelist.html","<div class=\"panel-body\"><div class=\"m-b font-italic text-muted\" ng-if=\"!data.length\">Nessun dato</div><ul class=\"list-group list-group-sm list-group-sp list-group-alt auto m-t\"><li class=\"list-group-item\" ng-repeat=\"d in data\" ng-init=\"textClass=\'text-\'+d.color;\"><a ng-href=\"#/{{d.link}}\"><span class=\"text-muted\">{{ d.title }}</span> <span class=\"block text-md {{textClass}}\">{{ d.label }}</span></a></li></ul></div>");
$templateCache.put("theme/dashboard/widget_timeline.html","<div ng-class=\"{\'wrapper\': !aside}\"><div class=\"streamline b-l m-b\"><div class=\"sl-item b-l {{bClass}}\" ng-repeat=\"d in data\" ng-init=\"bClass=\'b-\'+d.color;\"><div class=\"m-l\"><div class=\"text-muted\">{{ d.label }}</div><a ng-href=\"#/{{d.link}}\"><p>{{ d.title }}</p></a></div></div></div></div>");
$templateCache.put("theme/dashboard/widget_user.html","<div class=\"panel-body\"><div class=\"clearfix text-center m-t\"><div class=\"inline\"><div class=\"easyPieChart\" style=\"width: 134px; height: 134px; line-height: 134px;\"><div class=\"thumb-xl\"><img ng-src=\"{{ data.avatar }}\" style=\"width:128px;height:128px;\" class=\"img-circle\" alt=\"avatar\"></div><canvas width=\"134\" height=\"134\"></canvas></div><div class=\"h4 m-t m-b-xs\">{{ data.user }}</div><small class=\"text-muted m-b\">{{ data.group }}</small></div></div></div><footer class=\"panel-footer bg-info text-center no-padder\"><div class=\"hbox text-center b-b b-light text-sm\"><a ng-repeat=\"b in data.buttons\" ng-href=\"#/{{b.link}}\" ng-init=\"iconClass=\'block m-b-xs fa-2x \' + b.icon\" class=\"col padder-v b-r b-light\"><i class=\"{{iconClass}}\"><span ng-show=\"b.hasBadge\" class=\"bell-badge badge bg-danger\">3</span></i> <span>{{b.label}}</span></a></div></footer>");
$templateCache.put("theme/eventconfig/clonemodal.html","<div class=\"modal-body ng-scope\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"col-md-12 m-b-md\"><six-select-2 sx-list=\"commissions.list\" sx-title=\"\'Seleziona Commessa\'\" ng-model=\"selectedCommission\" sx-empty-placeholder=\"\'Commessa...\'\" sx-multiple=\"false\" sx-compact=\"false\" sx-item-template=\"\'{{item.description}}\'\"></six-select-2></div><div class=\"col-md-12\"><div style=\"float: right\"><button ng-disabled=\"params.gridApi.selection.getSelectedGridRows().length == 0\" type=\"button\" class=\"btn btn-bg btn-default m-\" ng-click=\"closeThisDialog(); cloneConfig(selectedCommission)\" title=\"Conferma\">OK</button> <button type=\"button\" class=\"btn btn-bg btn-default\" ng-click=\"closeThisDialog()\" title=\"Annulla\">Annulla</button></div><p ng-if=\"params.gridApi.selection.getSelectedGridRows().length == 0\">Selezionare le righe da copiare</p></div></div></div></div>");
$templateCache.put("theme/eventconfig/eventconfig_detail.html","<script type=\"text/ng-template\" id=\"helpTemplate.html\"><strong><span class=\"ngdialog-icon\"></span></strong> <div style=\"text-align: center;\"><h4 class=\"m-t-none m-b font-bold\">AIUTO</h4></div> <p>&Egrave; possibile inserire campi del dato con la sintassi: <span ng-non-bindable><code>{{nomecampo}}</code></span> (Es: <span ng-non-bindable><code>{{model.code}}</code></span>)</p> <p>&Egrave; possibile inserire il dato completo con la sintassi: <span ng-non-bindable><code>{{$$document}}</code></span></p> <p>&Egrave; possibile inserire funzioni javascript con la sintassi: <code> function() { // corpo funzione } </code> </p></script><six-toolbar><six-toolbar-item label=\"Configurazione {{eventconfig.model.code}}\" ng-show=\"eventconfig.version\"></six-toolbar-item><six-toolbar-item label=\"Nuova Configurazione\" ng-show=\"!eventconfig.version\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" toolbar-function=\"goToEventconfigList()\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" toolbar-function=\"delete(eventconfig.version)\" sx-disabled=\"!eventconfig.version\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"save()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default constructor\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-xs-12 col-sm-8 col-md-8\"><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"!eventconfig.version\">Nuova Configurazione</h1><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"eventconfig.version\">Configurazione: <span class=\"m-l-xs\">{{eventconfig.model.code}}</span></h1></div><div class=\"col-xs-12 col-sm-4 col-md-4\"><label class=\"control-label\">Commesse:</label><six-select-2 sx-id=\"commission_list\" sx-list=\"commissions.list\" sx-title=\"\'Commessa\'\" ng-model=\"commissions\" sx-field=\"\'selected\'\" sx-placeholder=\"\'commessa...\'\" sx-multiple=\"true\" sx-max-selected=\"1\"></six-select-2></div></div></div><uib-tabset class=\"tabs-left\" style=\"padding: 15px\"><uib-tab index=\"0\"><uib-tab-heading><span class=\"fa fa-sliders text-info-dker\"></span> Condizioni</uib-tab-heading><div class=\"panel-body\"><div class=\"form-group pull-out\"><div class=\"col-md-8 s-f-height\"><label class=\"control-label\">Nome configurazione:</label> <input type=\"text\" class=\"form-control\" ng-model=\"eventconfig.model.code\" required=\"\"></div><div class=\"col-md-4 s-f-height\"><label class=\"control-label\"></label> <label class=\"checkbox i-checks m-b-sx\"><input type=\"checkbox\" ng-model=\"eventconfig.model.bulkOperation\"><i></i>Operazione Bulk</label></div><div class=\"col-md-4 s-f-height\" ng-class=\"{\'col-md-3\': needSchema()}\"><label class=\"control-label\">Dato:</label><div class=\"input-group has-button\" style=\"width: 100%\"><ui-select ng-model=\"eventconfig.model.type\"><ui-select-match placeholder=\"Seleziona...\">{{$select.selected.value}}</ui-select-match><ui-select-choices repeat=\"item.key as item in knownTypes | filter: $select.search\"><div ng-bind-html=\"item.value | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col-md-3 s-f-height\" ng-if=\"needSchema()\"><label class=\"control-label\">Tipo:</label><div class=\"has-button\" style=\"width: 100%\"><six-lookup-2 sx-id=\"schema\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" ng-model=\"eventconfig.model.schemaRef\" sx-on-select=\"assignSchema(item)\" sx-compact=\"true\" sx-item-template=\"\'{{item.description}}\'\" sx-show-details=\"false\" sx-show-filters=\"false\"></six-lookup-2></div></div><div class=\"col-md-4 s-f-height\" ng-class=\"{\'col-md-3\': needSchema()}\"><label class=\"control-label\">Evento:</label><div class=\"input-group has-button\" style=\"width: 100%\"><ui-select ng-model=\"eventconfig.model.event\"><ui-select-match placeholder=\"Seleziona...\">{{$select.selected.value}}</ui-select-match><ui-select-choices repeat=\"item.key as item in knownEvents | filter: $select.search\"><div ng-bind-html=\"item.value | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col-md-4 s-f-height\" ng-class=\"{\'col-md-3\': needSchema()}\"><label class=\"control-label\">Azione:</label><div class=\"input-group has-button\" style=\"width: 100%\"><ui-select ng-model=\"eventconfig.model.action\"><ui-select-match placeholder=\"Seleziona...\">{{$select.selected.value}}</ui-select-match><ui-select-choices repeat=\"item.key as item in knownActions | filter: $select.search\"><div ng-bind-html=\"item.value | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col-md-12 m-b\" ng-hide=\"eventconfig.model.bulkOperation\"><label class=\"control-label\">Condizioni:</label><div ng-repeat=\"rule in eventconfig.model.ruleConfig as ruleContainer track by $index\" class=\"list m-b hover-anchor hover padder-md\"><div ng-include=\"\'single_rule_config.html\'\"></div></div><div><a class=\"btn btn-success\" ng-click=\"addRuleConfig()\">Aggiungi</a></div></div><div class=\"col-md-12 m-b\"><label class=\"control-label\" for=\"advancedSettingsArea\">Condizioni avanzate (ATTRIBUTE):</label> <textarea id=\"advancedSettingsArea\" class=\"form-control\" rows=\"1\" ng-model=\"eventconfig.model.attribute\"></textarea></div><div class=\"col-md-12 m-b\"><label class=\"control-label\">Condizioni avanzate (WHEN):</label><div class=\"dropdown inline m-l-sm\"><button class=\"btn btn-default btn-xs dropdown-toggle\" type=\"button\" id=\"when_templates\" data-toggle=\"dropdown\">Templates <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"item in whenTips | filter: $select.search\" ng-click=\"appendWhenTemplate(item)\"><a>{{item.value}}</a></li></ul></div><div class=\"inline m-l-sm\"><a class=\"btn btn-default btn-xs\" ng-click=\"show_generated_when = !show_generated_when\"><span ng-show=\"!show_generated_when\">Mostra</span><span ng-show=\"show_generated_when\">Nascondi</span> WHEN autogenerato</a></div><textarea class=\"form-control\" rows=\"5\" ng-model=\"eventconfig.model.generated_when\" disabled=\"\" ng-show=\"show_generated_when\"></textarea> <textarea class=\"form-control\" rows=\"5\" ng-model=\"eventconfig.model.when\"></textarea></div><div class=\"col-md-12 m-b\"><label class=\"control-label\">Condizioni avanzate (THEN):</label> <textarea class=\"form-control\" rows=\"3\" ng-model=\"eventconfig.model.then\"></textarea></div><div class=\"col-md-12 m-b\"><span class=\"btn btn-xs btn-default m-b-sm\" ng-click=\"hideRawRule = !hideRawRule\">Visualizza regola salvata</span><div ng-show=\"hideRawRule\" class=\"code\"><pre><code>{{eventconfig.model.rule}}</code></pre></div></div></div></div></uib-tab><uib-tab index=\"1\" ng-if=\"eventconfig.model.action==\'mail\'\"><uib-tab-heading><span class=\"fa fa-envelope-o text-info-dker\"></span> Configurazione E-Mail</uib-tab-heading><div class=\"panel-body\"><div class=\"form-group pull-out\"><div clas=\"col-sm-12\"><div class=\"col-sm-12\"><fieldset><legend class=\"h4 clickable\" ng-click=\"hideMailTo = !hideMailTo\"><span class=\"pull-right btn btn-xs\"><i class=\"fa fa-icon\" ng-class=\"{\'fa-caret-down\': hideMailTo, \'fa-caret-up\': !hideMailTo}\"></i></span>Destinatari (TO):</legend><div ng-include=\"\'mail_addresses_config.html\'\" ng-if=\"true\" ng-show=\"!hideMailTo\" onload=\"directMail = mailConf.to_mail; fieldMail = mailConf.to_field; opMail = mailConf.to_operator\"></div></fieldset></div><div class=\"col-sm-12 m-t-md\"><fieldset><legend class=\"h4 clickable\" ng-click=\"showMailCc = !showMailCc\"><span class=\"pull-right btn btn-xs\"><i class=\"fa fa-icon\" ng-class=\"{\'fa-caret-down\': !showMailCc, \'fa-caret-up\': showMailCc}\"></i></span>Destinatari in copia (CC):</legend><div ng-include=\"\'mail_addresses_config.html\'\" ng-if=\"true\" ng-show=\"showMailCc\" onload=\"directMail = mailConf.cc_mail; fieldMail = mailConf.cc_field; opMail = mailConf.cc_operator\"></div></fieldset></div><div class=\"col-sm-12 m-t-md\"><fieldset><legend class=\"h4 clickable\" ng-click=\"showMailBcc = !showMailBcc\"><span class=\"pull-right btn btn-xs\"><i class=\"fa fa-icon\" ng-class=\"{\'fa-caret-down\': !showMailBcc, \'fa-caret-up\': showMailBcc}\"></i></span>Destinatari in copia nascosta (BCC):</legend><div ng-include=\"\'mail_addresses_config.html\'\" ng-if=\"true\" ng-show=\"showMailBcc\" onload=\"directMail = mailConf.bcc_mail; fieldMail = mailConf.bcc_field; opMail = mailConf.bcc_operator\"></div></fieldset></div></div><div class=\"col-sm-9 m-t no-pad-l-r\"><div class=\"col-md-12\"><label class=\"control-label\">Oggetto:</label> <input type=\"text\" class=\"form-control\" ng-model=\"mailConf.mail_subject\"><p class=\"small\">&Egrave; possibile inserire campi del dato con la sintassi: <span ng-non-bindable=\"\">{{nomecampo}}</span>. <span ng-non-bindable=\"\">{{$$document}}</span> consente di inserire il dato completo.</p></div></div><div class=\"col-sm-3 m-t no-pad-l-r\"><label class=\"control-label col-md-12\">Dati da modello:</label><div class=\"col-md-12\"><div class=\"input-group has-button\" style=\"width: 100%\"><ui-select ng-model=\"fieldToSolve.value\"><ui-select-match placeholder=\"Seleziona...\">{{$select.selected.value.title}}</ui-select-match><ui-select-choices repeat=\"product.key as (key, product) in properties | filter: $select.search\"><div ng-bind-html=\"product.value.title | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col-md-12 dropdown inline\"><button class=\"btn btn-default dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\" style=\"width: 100%\">Aggiungi a:</button><ul class=\"dropdown-menu\"><li ng-repeat=\"item in whereTips.mail | filter: $select.search\" ng-click=\"appendSchema(item)\"><a>{{item.value}}</a></li></ul></div></div><div class=\"col-md-12\"><label class=\"control-label\">Template E-mail:</label> <textarea ui-tinymce=\"tinymceOptions\" class=\"form-control\" rows=\"20\" ng-model=\"mailConf.mail_body\"></textarea><p class=\"small\">&Egrave; possibile inserire campi del dato con la sintassi: <span ng-non-bindable=\"\">{{nomecampo}}</span>. <span ng-non-bindable=\"\">{{$$document}}</span> consente di inserire il dato completo.</p></div></div></div></uib-tab><uib-tab index=\"2\" ng-if=\"eventconfig.model.action==\'rest\'\"><uib-tab-heading><span class=\"fa fa-globe text-info-dker\"></span> Configurazione REST</uib-tab-heading><div class=\"panel-body\"><div class=\"form-group pull-out\"><div class=\"col-md-1 m-t\"><label class=\"control-label\">Metodo:</label><ui-select ng-model=\"restConf.rest_method\"><ui-select-match placeholder=\"Seleziona...\">{{$select.selected.value}}</ui-select-match><ui-select-choices repeat=\"item.key as item in httpMethods | filter: $select.search\"><div ng-bind-html=\"item.value | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"col-md-11 m-t\"><label class=\"control-label\">URL:</label> <input type=\"text\" class=\"form-control\" ng-model=\"restConf.rest_url\"><p class=\"small\">&Egrave; possibile inserire campi del dato con la sintassi: <span ng-non-bindable=\"\">{{nomecampo}}</span>. <span ng-non-bindable=\"\">{{$$document}}</span> consente di inserire il dato completo.</p></div><div class=\"col-md-12 m-t\"><label class=\"control-label\">Content-Type:</label> <input type=\"text\" class=\"form-control\" ng-model=\"restConf.rest_content_type\"><p class=\"small\">Es.: text/plain, application/json, application/xml, application/javascript, text/xml, text/html</p></div><div class=\"col-md-9 m-t\"><label class=\"control-label\">Body:</label> <a title=\"Aiuto\" ng-click=\"showHelpWindow()\"><i class=\"fa fa-question\"></i></a> <textarea class=\"form-control\" rows=\"10\" ng-model=\"restConf.rest_body\"></textarea><p class=\"small\">&Egrave; possibile inserire campi del dato con la sintassi: <span ng-non-bindable=\"\">{{nomecampo}}</span>. <span ng-non-bindable=\"\">{{$$document}}</span> consente di inserire il dato completo.</p></div><div class=\"col-sm-3 m-t\"><label class=\"control-label col-md-12\">Dati da modello:</label><div class=\"col-md-12\"><div class=\"input-group has-button\" style=\"width: 100%\"><ui-select ng-model=\"fieldToSolve.value\"><ui-select-match placeholder=\"Seleziona...\">{{$select.selected.value.title}}</ui-select-match><ui-select-choices repeat=\"product.key as (key, product) in properties | filter: $select.search\"><div ng-bind-html=\"product.value.title | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col-md-12 m-t dropdown inline\"><button class=\"btn btn-default dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\" style=\"width: 100%\">Aggiungi a:</button><ul class=\"dropdown-menu\"><li ng-repeat=\"item in whereTips.rest | filter: $select.search\" ng-click=\"appendSchema(item)\"><a>{{item.value}}</a></li></ul></div></div></div></div></uib-tab></uib-tabset></div></div><script type=\"text/ng-template\" id=\"single_rule_config.html\"><div class=\"row m-b-n-md\"> <div class=\"col-md-2 m-b\"> <label class=\"control-label\">Connettore:</label> <ui-select ng-model=\"rule.connector\"> <ui-select-match placeholder=\"Seleziona...\">{{$select.selected.value}}</ui-select-match> <ui-select-choices repeat=\"item.key as item in ruleConfConnectors | filter: $select.search\"> <div ng-bind-html=\"item.value | highlight: $select.search\"></div> </ui-select-choices> </ui-select> </div> <div class=\"col-md-3 m-b\"> <label class=\"control-label\" for=\"ruleField\">Campo:</label> <div class=\"btn btn-info btn-xs pull-right\" ng-click=\"toggleCalendarMode(rule)\" ng-show=\"eventconfig.model.type==\'record\' && hasProperties()\"><i class=\"fa fa-exchange\"></i> Modifica calendario</div> <div ng-hide=\"rule.calendar_mode\"> <input id=\"ruleField\" class=\"form-control\" type=\"text\" ng-model=\"rule.field\" ng-show=\"!hasProperties()\"> <ui-select ng-model=\"rule.field\" ng-show=\"hasProperties()\"> <ui-select-match placeholder=\"Seleziona...\">{{$select.selected.value.title}}</ui-select-match> <ui-select-choices repeat=\"product.key as (key, product) in properties | filter: $select.search\"> <div ng-bind-html=\"product.value.title | highlight: $select.search\"></div> </ui-select-choices> </ui-select> </div> <div ng-show=\"rule.calendar_mode\"> <ui-select ng-model=\"rule.field\"> <ui-select-match placeholder=\"Seleziona...\">{{$select.selected.value.value}}</ui-select-match> <ui-select-choices repeat=\"product.value.key as (key, product) in calendarMode.knownFields | filter: $select.search\"> <div ng-bind-html=\"product.value.value | highlight: $select.search\"></div> </ui-select-choices> </ui-select> </div> </div> <div class=\"col-md-2 m-b\"> <label class=\"control-label\">Operatore:</label> <ui-select ng-model=\"rule.op\"> <ui-select-match placeholder=\"Seleziona...\">{{$select.selected.value}}</ui-select-match> <ui-select-choices repeat=\"item.key as item in ruleConfOperators | filter: $select.search\"> <div ng-bind-html=\"item.value | highlight: $select.search\"></div> </ui-select-choices> </ui-select> </div> <div class=\"col-md-4 m-b\"> <label class=\"control-label\" for=\"value_lookup\">Valore:</label> <div ng-hide=\"rule.calendar_mode\"> <six-lookup-2 ng-disabled=\"rule.prevValue\" ng-show=\"ruleValueNeedsFormat(eventconfig, rule, \'lookup\')\" sx-id=\"value_lookup\" sx-base-path=\"ruleValueLookupBasePath(rule)\" sx-type=\"ruleValueLookupType(rule)\" sx-war=\"ruleValueLookupWar(rule)\" ng-model=\"rule.valueRef\" sx-on-select=\"assignRuleValue(rule, item)\" sx-on-clear=\"assignRuleValue(rule, item)\" sx-compact=\"true\" sx-show-details=\"false\" sx-show-filters=\"false\"></six-lookup-2> <input id=\"value_lookup\" class=\"form-control\" type=\"text\" ng-model=\"rule.value\" ng-disabled=\"rule.prevValue\" ng-show=\"ruleValueNeedsFormat(eventconfig, rule, \'input\')\"> <ui-select ng-model=\"rule.value\" ng-disabled=\"rule.prevValue\" ng-if=\"ruleValueNeedsFormat(eventconfig, rule, \'select\')\"> <ui-select-match placeholder=\"Seleziona...\">{{$select.selected.value}}</ui-select-match> <ui-select-choices repeat=\"item.key as item in ruleKnownValues[eventconfig.model.type][rule.field] | filter: $select.search\"> <div ng-bind-html=\"item.value | highlight: $select.search\"></div> </ui-select-choices> </ui-select> <label><input type=\"checkbox\" ng-model=\"rule.prevValue\"> Usa il valore precedente</label> </div> <div ng-show=\"rule.calendar_mode\"> <ui-select ng-model=\"rule.value\" ng-if=\"rule.field !=\'model.openingTime\'\"> <ui-select-match placeholder=\"Seleziona...\">{{$select.selected.value}}</ui-select-match> <ui-select-choices repeat=\"item.key as item in calendarMode.knownValues[rule.field] | filter: $select.search\"> <div ng-bind-html=\"item.value | highlight: $select.search\"></div> </ui-select-choices> </ui-select> <input id=\"value_lookup\" class=\"form-control\" type=\"number\" min=\"0\" max=\"24\" step=\"1\" ng-model=\"rule.value\" ng-if=\"rule.field == \'model.openingTime\'\"> </div> </div> <div class=\"col-md-1 m-b\"> <label class=\"control-label\">&nbsp;</label><br> <a class=\"btn btn-xs btn-default\" ng-click=\"addRuleConfig(rule.rules)\" title=\"Aggiungi sottoregola\"><i class=\"fa fa-icon fa-plus\"></i></a> <a class=\"btn btn-xs btn-danger\" ng-click=\"removeRuleConfig(this, $index)\"><i class=\"fa fa-icon fa-trash\"></i></a> </div> <div class=\"m-b col-md-11 col-md-offset-1 m-b no-pad-l-r list-group-item\" ng-show=\"rule.rules.length\"> <div ng-repeat=\"rule in rule.rules as ruleContainer track by $index\" class=\"list m-b hover-anchor hover padder-md\"> <div ng-include=\"\'single_rule_config.html\'\"></div> </div> </div> </div></script><script type=\"text/ng-template\" id=\"mail_addresses_config.html\"><div> <label class=\"control-label m-t-sm\" for=\"directMailTxt\">E-mail dirette: <a class=\"btn btn-success btn-xs\" ng-click=\"addEmptyValue(directMail, \'string\')\">Aggiungi</a></label> <div ng-repeat=\"mail in directMail track by $index\" class=\"list m-b hover-anchor hover padder-md\"> <span ng-click=\"removeValue(directMail, $index)\" class=\"pull-right text-muted delete-action\" role=\"button\" tabindex=\"0\"><i class=\"fa fa-times\"></i></span> <input id=\"directMailTxt\" class=\"form-control\" type=\"text\" ng-model=\"directMail[$index]\"/> </div> </div> <div ng-hide=\"eventconfig.model.bulkOperation\"> <label class=\"control-label m-t-sm\">E-mail estratta dal dato: <a class=\"btn btn-success btn-xs\" ng-click=\"addEmptyValue(fieldMail, \'string\')\">Aggiungi</a></label> <div ng-repeat=\"mail in fieldMail track by $index\" class=\"list m-b hover-anchor hover padder-md\"> <span ng-click=\"removeValue(fieldMail, $index)\" class=\"pull-right text-muted delete-action\" role=\"button\" tabindex=\"0\"><i class=\"fa fa-times\"></i></span> <ui-select ng-model=\"fieldMail[$index]\" ng-show=\"hasProperties()\" style=\"width: 40%; padding: 0 15px 0 0; box-sizing: border-box;\" class=\"pull-left\"> <ui-select-match placeholder=\"Seleziona...\">{{$select.selected.value.title}}</ui-select-match> <ui-select-choices repeat=\"product.key as (key, product) in properties | filter: mailOperatorFilter\"> <div ng-bind-html=\"product.value.title | highlight: $select.search\"></div> </ui-select-choices> </ui-select> <input class=\"form-control\" type=\"text\" ng-model=\"fieldMail[$index]\" placeholder=\"es: model.segreteria\" ng-style=\"hasProperties() && {\'width\': \'60%\'}\"/> <p class=\"small\">Inserisci il path del campo contenente un operatore a cui indirizzare l\'email.</p> </div> </div> <div> <label class=\"control-label m-t-sm\">E-mail operatore: <a class=\"btn btn-success btn-xs\" ng-click=\"addEmptyValue(opMail, \'reference\')\">Aggiungi</a></label> <div ng-repeat=\"mail in opMail track by $index\" class=\"list m-b hover-anchor hover padder-md\"> <span ng-click=\"removeValue(opMail, $index)\" class=\"pull-right text-muted delete-action\" role=\"button\" tabindex=\"0\"><i class=\"fa fa-times\"></i></span> <six-lookup-2 class=\"block m-r-xl\" ng-model=\"opMail[$index]\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-add=\"false\" sx-show-filters=\"false\" sx-multiple=\"false\"> </six-lookup-2> </div> </div></script>");
$templateCache.put("theme/eventconfig/eventconfig_list.html","<six-toolbar><six-toolbar-button label=\"Copia Configurazioni\" icon=\"fa fa-clone\" toolbar-function=\"cloneSelected()\"></six-toolbar-button><six-toolbar-button label=\"Crea Configurazione Evento\" icon=\"fa fa-plus\" toolbar-function=\"newEventConfig()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"refresh()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Configurazione Eventi</h1></div></div></div><div class=\"panel-body\"><div class=\"col-sm-12 m-t\"><six-grid-pagination sx-id=\"eventconfig_grid\" get-data-callback=\"getEventConfigList()\" get-list-callback=\"getEventConfigList()\" items-list=\"eventconfigList\" grid-options=\"viewGridOptions\" column-defs=\"viewGridOptions.columnDefs\" params=\"params\" auto-resize-params=\"autoResizeParams\" show-global-search=\"false\" enable-state-saving=\"true\" grid-app-callbacks=\"gridAppCallbacks\"></six-grid-pagination></div></div></div></div>");
$templateCache.put("theme/group/group_detail.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"saveForm()\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" disabled=\"!group.version\" ng-confirm-message=\"Sei sicuro?\" ng-confirm-click=\"delete(group.version)\" ng-confirm-condition=\"true\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar center-page\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\" ng-hide=\"group.id\"><h1 class=\"m-n font-thin h3 text-black\">Nuovo Gruppo</h1></div><div class=\"col-sm-6 col-xs-12\" ng-show=\"group.id\"><h1 class=\"m-n font-thin h3 text-black\">Dettaglio Gruppo</h1></div></div></div><six-search-terms sx-list=\"searchResult\" sx-id=\"{{sxSearchTerms.id}}\" sx-open=\"sxSearchTerms.open\" sx-model=\"sxSearchTerms\" sx-filter=\"searchFilterObj\" sx-show-select-schema=\"sxSearchTerms.showSelectSchema\" sx-on-filter-changed=\"onFilterChanged()\"></six-search-terms><div class=\"wrapper constructor\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><label for=\"code\" class=\"control-label\">Nome</label><div class=\"input-group\" style=\"width:100%\"><input name=\"name\" type=\"text\" ng-model=\"group.id\" class=\"form-control\" ng-readonly=\"!isNew\"></div></div></div><div class=\"row\"><div class=\"col-md-6 m-t\"><label for=\"code\" class=\"control-label\">Commessa</label><div id=\"commissions\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"commissionsSelected.items\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Selezionare una commessa...\">{{$item.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in commissions\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"col-md-6 m-t\"><label for=\"description\" class=\"control-label\">Elementi del tree</label><div id=\"treeEntities\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"schemasSelected.items\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Selezionare un modello...\">{{$item.model.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in schemas\"><div ng-bind-html=\"item.model.description | highlight: $select.search\"></div><small ng-bind-html=\"item.model.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div></div><div class=\"row\"><div class=\"col-md-6 m-t\" ng-repeat=\"g in group\" ng-if=\"isAssetEntry(g)\"><label for=\"description\" class=\"control-label\">{{g.id.key}}</label><div class=\"input-group\" style=\"width: 100%\"><input name=\"{{g.id.key}}\" type=\"text\" ng-model=\"g.value\" class=\"form-control\" readonly=\"\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-bg btn-default\" ng-click=\"editGroup(g)\"><i class=\"fa fa-pencil\"></i></button></span> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-bg btn-default\" ng-click=\"removeGroup(g.id.key)\"><i class=\"fa fa-times\"></i></button></span></div></div></div><div class=\"row\"><div class=\"col-md-6 col-sm-12 m-t\"><div><button ng-click=\"addAssetDetail()\" class=\"btn btn-default\">Aggiungi dettaglio asset</button></div></div></div></div></div></div></div>");
$templateCache.put("theme/group/group_list.html","<six-toolbar><six-toolbar-button label=\"Aggiungi gruppo\" icon=\"fa fa-plus\" toolbar-function=\"goToNewGroup()\" sx-disabled=\"isWritePermAllowed()===false\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista Gruppi</h1></div></div></div><div class=\"panel-body\"><table id=\"asset_list\" class=\"table table-striped\"><thead><tr><th></th><th>CODICE</th></tr></thead><tbody><tr ng-repeat=\"item in groupsList\"><td><a ng-href=\"#/group/detail/{{item}}\" class=\"btn btn-default\" id=\"btn_commission_detail\"><span class=\"glyphicon glyphicon-pencil\"></span></a></td><td>{{ item }}</td></tr><tr ng-hide=\"groupsList.length\"><td><p class=\"text-center\">Nessun gruppo recuperato</p></td></tr></tbody></table></div></div></div>");
$templateCache.put("theme/jasper/jasper.html","<div><iframe id=\"jasperFrame\" ng-src=\"{{ getExtURL() | trustAsResourceUrl }}\" width=\"100%\" height=\"1000\" frameborder=\"0\"></iframe></div><div ng-repeat=\"item in extern\" ng-hide=\"true\"><a ng-href=\"{{ item.route.indexOf(\'http:\')==0? item.route:\'#/\' + item.route }}\" id=\"{{item.id}}\"></a></div>");
$templateCache.put("theme/login/fakelogin.html","<div class=\"col-md-12 pad-t-15\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Login utente</h1><small class=\"text-muted\">seleziona un utente</small></div></div></div><div class=\"panel-body\"><div class=\"form-group\"><input ng-keyup=\"searchUsers()\" class=\"form-control\" type=\"text\" ng-model=\"searchString\" placeholder=\"Scrivere qui per filtrare la lista...\"></div><table id=\"userList\" class=\"table table-striped\"><thead><tr><th></th><th>Username</th><th>Ruolo</th></tr></thead><tbody><tr ng-repeat=\"item in profiles\"><td><a ng-click=\"login(item)\" class=\"btn-sm btn-default\" id=\"btn_changeUser\"><span class=\"fa fa-play-circle icon text\"></span></a></td><td>{{ item.user}}</td><td>{{ item.role }}</td></tr><tr ng-hide=\"profiles.length\"><td><p class=\"text-center\">No Data Found</p></td></tr></tbody></table></div></div></div>");
$templateCache.put("theme/login/login.html","<div class=\"vertical-center\"><div class=\"container\"><div class=\"col-sm-4 col-sm-offset-4 p-sm animated fadeIn\"><div class=\"loginPanel\"><img src=\"logo_w.png\" alt=\"Logo\" class=\"img-responsive\"><form name=\"form\" class=\"form-validation\" ng-submit=\"login(user)\"><div class=\"form-group\"><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-user-o\"></i></span> <input class=\"form-control\" placeholder=\"Username\" ng-model=\"user.username\" required=\"\"></div></div><div class=\"form-group\"><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-lock\"></i></span> <input type=\"password\" class=\"form-control\" placeholder=\"password\" ng-model=\"user.password\" required=\"\"></div></div><button type=\"submit\" class=\"btn btn-info btn-block\" ng-disabled=\"form.$invalid\" tabindex=\"0\">Accedi</button></form></div><span id=\"error\" ng-show=\"errors\" style=\"font-size: x-large; display: block; padding:10px\" class=\"bg-danger label m-t-lg\">Autenticazione fallita</span></div></div></div>");
$templateCache.put("theme/notification/notification_detail.html","<style>\n    .btn-primary{\n        background-color: #7266ba;\n        border-color: #5a4daa;\n    }\n\n    .btn-primary:hover{\n        background-color: #6254b2;\n        border-color: #5a4daa;\n    }\n</style><six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button label=\"Vai alla segnalazione\" btn-class=\"btn-primary-override\" icon=\"fa fa-search\" toolbar-function=\"goToIssue()\" ng-if=\"notification.model.record_id.index==ISSUE_INDEX\"></six-toolbar-button><six-toolbar-button label=\"Vai all\'odl\" btn-class=\"btn-warning\" icon=\"fa fa-search\" toolbar-function=\"goToOdl()\" ng-if=\"notification.model.record_id.index==ODL_INDEX\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Dettaglio notifica</h1></div></div></div><div class=\"panel-body\"><div class=\"wrapper b-b\"><h2 class=\"font-thin m-n ng-binding\">{{notification.model.subject}}</h2></div><div class=\"wrapper b-b ng-binding\"><img ng-hide=\"notification.user\" class=\"img-circle thumb-xs m-r-sm\" ng-src=\"images/avatar_system.png\"> <img ng-show=\"notification.user\" class=\"img-circle thumb-xs m-r-sm\" ng-src=\"images/avatar_emil.png\"> Segnalazione inviata da <strong ng-hide=\"notification.user\">System</strong><strong>{{notification.user}}</strong> relativa a <strong ng-show=\"!notification.model.type_notification\">/</strong> <strong ng-show=\"notification.model.type_notification\">{{notification.model.type_notification}}</strong> e con destinatari: <strong ng-show=\"!notification.model.to\">/</strong> <strong ng-show=\"notification.model.to\">{{notification.model.to}}</strong> del {{notification.dataIn | date:\"dd/MM/yyyy\"}}</div><div class=\"wrapper ng-binding\" ng-bind-html=\"notification.model.body\"></div></div></div></div>");
$templateCache.put("theme/notification/notification_list.html","<six-toolbar><six-toolbar-button label=\"Nuovo messaggio\" btn-class=\"btn-info\" icon=\"fa fa-envelope\" toolbar-function=\"goToWysiwyg()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Notifiche</h1></div></div></div><div class=\"panel-body\"><div class=\"legend\" ng-if=\"notifications\"><span class=\"text-xs text-muted pull-right\"><i class=\"fa fa-circle text-primary m-r-xs\"></i> segnalazioni <i class=\"fa fa-circle text-warning m-r-xs m-l-sm\"></i> odl <i class=\"fa fa-circle text-light m-r-xs m-l-sm\"></i> altro</span> <span style=\"clear:both\"></span></div><ul class=\"list-group list-group-lg no-radius m-b-none m-t-n-xxs\"><li ng-repeat=\"notification in notifications\" class=\"list-group-item clearfix b-l-3x ng-scope\" ng-class=\"notification.color\"><span class=\"avatar thumb pull-left m-r\"><img ng-hide=\"notification.user\" src=\"images/avatar_system.png\"> <img ng-show=\"notification.user\" src=\"images/avatar_emil.png\"></span><div class=\"pull-right text-sm text-muted\"><span class=\"hidden-xs ng-binding\">{{notification.dataIn | date:\"dd/MM/yyyy\"}}</span></div><div class=\"clear\"><div><a class=\"text-md ng-binding\" ng-href=\"{{notification.href}}\">{{notification.model.subject}}</a></div><div class=\"text-ellipsis m-t-xs ng-binding\">{{notification.model.bodyAsText}}</div></div></li></ul><div class=\"text-center\"><uib-pagination ng-change=\"pageChanged()\" boundary-links=\"true\" total-items=\"data.totalResults\" ng-model=\"currentPage\" class=\"pagination-sm\" items-per-page=\"pageSize\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></uib-pagination></div></div></div></div>");
$templateCache.put("theme/profilinggroup/profilinggroup.html","<six-toolbar><six-toolbar-button icon=\"fa fa-chevron-left\" back=\"\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh\" toolbar-function=\"refresh()\"></six-toolbar-button><six-toolbar-button label=\"Salva tutto\" icon=\"fa fa-save\" sx-disabled=\"disabledSaveAll()\" btn-class=\"btn-success\" toolbar-function=\"saveAll()\"></six-toolbar-button><six-toolbar-button label=\"Aggiungi filtro\" icon=\"fa fa-plus\" btn-class=\"btn-primary-override\" toolbar-function=\"createFilter()\"></six-toolbar-button></six-toolbar><div class=\"override-padding-toolbar profiling-group\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-lg-12\"><h1 class=\"m-n font-thin h3 text-black\">Gruppi di profilazione</h1></div></div></div></div><div class=\"wrapper-md\"><div class=\"form-group\"><input class=\"form-control\" placeholder=\"Ricerca ...\" ng-model=\"query.value\" ng-change=\"getData()\"></div><div class=\"hbox hbox-auto-xs no-border m-t-sm m-b-md\"><div class=\"col w-lg\"><div class=\"m-b-xs btn-group\"><label class=\"btn btn-xs btn-primary\" ng-model=\"query.exclude\" ng-change=\"getData()\" uib-btn-radio=\"undefined\">Tutti</label> <label class=\"btn btn-xs btn-primary\" ng-model=\"query.exclude\" ng-change=\"getData()\" uib-btn-radio=\"false\">Inclusivi</label> <label class=\"btn btn-xs btn-primary\" ng-model=\"query.exclude\" ng-change=\"getData()\" uib-btn-radio=\"true\">Esclusivi</label></div><div class=\"input-group m-r-sm\"><ui-select theme=\"bootstrap\" ng-model=\"query.profilingGroup\" on-select=\"getData()\"><ui-select-match placeholder=\"Seleziona un gruppo ...\">{{$select.selected.description}}</ui-select-match><ui-select-choices repeat=\"group.code as group in groupNames | filter: $select.search\"><div ng-bind-html=\"group.description | highlight: $select.search\"></div></ui-select-choices></ui-select><span class=\"input-group-btn\"><button ng-click=\"query.profilingGroup = undefined; getData()\" ng-disabled=\"!query.profilingGroup\" class=\"btn btn-icon btn-default\"><span class=\"fa fa-times\"></span></button></span></div></div><div class=\"col\"><label style=\"height:22px;\" class=\"m-b-xs\">Filtra per modello</label><six-lookup-2 sx-base-path=\"\'schema\'\" ng-model=\"query\" sx-field=\"\'schema\'\" sx-item-template=\"\'{{item.description}}\'\" sx-compact=\"true\" sx-page-size=\"50\" sx-placeholder=\"\'Cerca i modello ...\'\" sx-on-select=\"getData()\" sx-on-clear=\"getData()\"></six-lookup-2></div></div><div class=\"text-center w-full m-sm\" ng-hide=\"groupList.totalResults\">Nessun gruppo di profilazione configurato</div><div slimscroll=\"{height: 500, noWatch: true}\"><div class=\"panel hbox hbox-auto-xs no-border\" ng-repeat=\"filter in groupList.list\"><div class=\"col wrapper w-lg bg-light dk r-l\" ng-class=\"{ \'b-l b-3x\': filter.isDirty(), \'b-success\': !isInvalid(filter), \'b-danger\': isInvalid(filter)}\"><h4 class=\"font-thin m-t-none m-b\">Gruppi di profilazione</h4><ui-select theme=\"bootstrap\" tagging=\"newGroupName\" tagging-label=\"false\" ng-model=\"filter.profiling_groups\" multiple=\"\"><ui-select-match placeholder=\"Inserisci nome ...\">{{$item.description}}</ui-select-match><ui-select-choices repeat=\"group.code as group in groupNames | filter: $select.search\"><div ng-bind-html=\"group.description | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"m-t\">Escludi <label class=\"i-switch bg-primary pull-right\"><input type=\"checkbox\" ng-model=\"filter.exclude\"> <i></i></label></div></div><div class=\"col wrapper\"><div><span class=\"pull-right\" ng-hide=\"filter.saving\"><a class=\"text-{{(isInvalid(filter) || !filter.isDirty())? \'muted\' : \'success\'}} text-lg\" ng-click=\"!(isInvalid(filter) || !filter.isDirty()) && save(filter)\"><i class=\"fa fa-save\"></i></a> <a class=\"text-danger text-lg\" ng-click=\"delete(filter.id, $index)\"><i class=\"fa fa-trash-o\"></i></a></span> <span ng-show=\"filter.saving\" class=\"text-lg\"><i class=\"fa fa-spinner fa-pulse\"></i></span><h4 ng-show=\"filter.schema.description &amp;&amp; filter.records.length\" class=\"m-t-none text-primary-lt\">{{filter.schema.description}}</h4></div><div class=\"m-b\" ng-hide=\"filter.records.length\"><six-lookup-2 sx-base-path=\"\'schema\'\" ng-model=\"filter\" sx-field=\"\'schema\'\" sx-item-template=\"\'{{item.description}}\'\" sx-compact=\"true\" sx-page-size=\"50\" sx-empty-placeholder=\"\'Seleziona modello ...\'\"></six-lookup-2></div><six-lookup-2 sx-type=\"filter.schema.code\" ng-model=\"filter\" sx-field=\"\'records\'\" sx-compact=\"true\" sx-page-size=\"50\" sx-multiple=\"true\" ng-if=\"filter.schema\"></six-lookup-2></div></div></div><div class=\"w-full form-inline m-t-sm\"><div class=\"form-group\"><uib-pagination ng-change=\"getData()\" boundary-links=\"true\" total-items=\"groupList.totalResults\" ng-model=\"groupList.currentPage\" class=\"pagination-sm m-n\" items-per-page=\"groupList.pageSize\" max-size=\"10\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></uib-pagination></div><div class=\"form-group\"><select ng-init=\"pageSizeOpt = [10,15,20, 50]\" class=\"form-control w-xxs m-b-xs input-sm\" ng-model=\"groupList.pageSize\" ng-options=\"size for size in pageSizeOpt\" ng-change=\"getData()\"></select><label>elementi per pagina</label></div><p class=\"pull-right\">{{(groupList.currentPage - 1) * groupList.pageSize + 1}} - {{(groupList.currentPage * groupList.pageSize) | minValue: groupList.totalResults}} di {{groupList.totalResults}} elementi</p></div></div></div>");
$templateCache.put("theme/report/report_analysis.html","<div class=\"col-md-12 override-padding-15-px\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">ANALISI BUDGET/CONSUMI</h1></div></div></div><div class=\"panel-body\"><uib-tabset class=\"tab-container\"><uib-tab index=\"0\" ng-click=\"clearVariable()\"><uib-tab-heading>Generale</uib-tab-heading><div class=\"row\"><div class=\"col-md-12 wrapper-md\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row wrapper\"><div class=\"col-md-2\"><label class=\"control-label\">Da:</label> <input class=\"btn btn-default btn-sm col-md-12\" type=\"date\" ng-model=\"period.dateFrom\"></div><div class=\"col-md-2\"><label class=\"control-label\">A:</label> <input class=\"btn btn-default btn-sm col-md-12\" type=\"date\" ng-model=\"period.dateTo\"></div><div class=\"col-md-2\"><label for=\"general_commission_code\" class=\"control-label\">Commessa:</label><div id=\"general_commission_code\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"commission.searchCode\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Enter...\">{{$item.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in availableCommissionCodes track by $index\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"col-md-2\"><label for=\"general_budget_code\" class=\"control-label\">Budget:</label><div id=\"general_budget_code\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"budget.searchCode\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Enter...\">{{$item.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in availableBudgetCodes track by $index\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"col-md-2\"><label for=\"general_what_1\" class=\"control-label\">Confronta:</label><six-select id=\"general_what_1\" ng-model=\"compare.what1\" sx-item-list=\"compareType\" sx-show-description=\"false\"></six-select></div><div class=\"col-md-2\"><label for=\"general_what_2\" class=\"control-label\">Con:</label><six-select id=\"general_what_2\" ng-model=\"compare.what2\" sx-item-list=\"compareType\" sx-show-description=\"false\"></six-select></div></div><div class=\"row wrapper\"><div class=\"col-md-12\"><button ng-click=\"reloadPage()\" type=\"button\" class=\"btn btn-default btn-sm\"><i class=\"fa fa-refresh\"></i> Pulisci pagina</button></div><div class=\"col-md-12\"><hr></div><div class=\"col-md-6 col-md-offset-8\"><button ng-disabled=\"budget.searchCode.length == 0 || compare.what1 == isUndefinedOrNull || compare.what2 == isUndefinedOrNull\" ng-click=\"generateBudgetReportGraphLines()\" type=\"button\" class=\"btn btn-default\"><i class=\"fa fa-line-chart\"></i> Grafico a linee</button> <button ng-disabled=\"budget.searchCode.length == 0 || compare.what1 == isUndefinedOrNull || compare.what2 == isUndefinedOrNull\" ng-click=\"generateBudgetReportGraphBars()\" type=\"button\" class=\"btn btn-default\"><i class=\"fa fa-bar-chart\"></i> Grafico a barre</button></div></div></div></div></div></div></uib-tab><uib-tab index=\"1\" ng-click=\"clearVariable()\"><uib-tab-heading>Vettori Energ./Contatori</uib-tab-heading><div class=\"row\"><div class=\"col-md-12 wrapper-md\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row wrapper\"><div class=\"col-md-2\"><label class=\"control-label\">Da:</label> <input class=\"btn btn-default btn-sm col-md-12\" type=\"date\" ng-model=\"period.dateFrom\"></div><div class=\"col-md-2\"><label class=\"control-label\">A:</label> <input class=\"btn btn-default btn-sm col-md-12\" type=\"date\" ng-model=\"period.dateTo\"></div><div class=\"col-md-2\"><label for=\"vectors_commission_code\" class=\"control-label\">Commesse:</label><div id=\"vectors_commission_code\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"commission.searchCode\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Enter...\">{{$item.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in availableCommissionCodes track by $index\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"col-md-2\"><label for=\"vectors_budget_code\" class=\"control-label\">Budget:</label><div id=\"vectors_budget_code\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"budget.searchCode\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Enter...\">{{$item.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in availableBudgetCodes track by $index\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"col-md-2\"><label for=\"vectors_what_1\" class=\"control-label\">Confronta:</label><six-select id=\"vectors_what_1\" ng-model=\"compare.what1\" sx-item-list=\"compareType\" sx-show-description=\"false\"></six-select></div><div class=\"col-md-2\"><label for=\"vectors_what_2\" class=\"control-label\">Con:</label><six-select id=\"vectors_what_2\" ng-model=\"compare.what2\" sx-item-list=\"compareType\" sx-show-description=\"false\"></six-select></div></div><div class=\"row wrapper\"><div class=\"col-md-3\"><label class=\"control-label\" for=\"vectors_vettore_energetico\">Vettore:</label><six-lookup id=\"vectors_vettore_energetico\" ng-model=\"vector\" sx-type=\"\'vettoreenergetico\'\" sx-field=\"\'id\'\"></six-lookup></div><div class=\"col-md-3\"><label class=\"control-label\" for=\"vectors_contatore_type\">Tipo contatore:</label><six-lookup id=\"vectors_contatore_type\" sx-base-path=\"\'schema\'\" ng-model=\"type\" sx-field=\"\'id\'\" sx-filter=\"contatoreTypeFilter\" sx-disabled=\"!vector.id\"></six-lookup></div><div class=\"col-md-3\" ng-if=\"commission.searchCode.length <= 1\"><label class=\"control-label\" for=\"vectors_contatori\">Contatori:</label><div id=\"vectors_contatori\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"ids.searchCode\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Enter...\">{{$item.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in availableIdCodes track by $index\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"col-md-3\" ng-if=\"commission.searchCode.length > 1\"><label class=\"control-label\" for=\"vectors_contatori\">Contatori: (con più commesse non è possibile confrontare singoli contatori)</label></div></div><div class=\"row wrapper\"><div class=\"col-md-12\"><button ng-click=\"reloadPage()\" type=\"button\" class=\"btn btn-default btn-sm\"><i class=\"fa fa-refresh\"></i> Pulisci pagina</button></div><div class=\"col-md-12\"><hr></div><div class=\"col-md-6 col-md-offset-8\"><button ng-disabled=\"budget.searchCode.length == 0 || compare.what1 == isUndefinedOrNull || compare.what2 == isUndefinedOrNull\" ng-click=\"generateBudgetCounterReportGraphLines()\" type=\"button\" class=\"btn btn-default\"><i class=\"fa fa-line-chart\"></i> Grafico a linee</button> <button ng-disabled=\"budget.searchCode.length == 0 || compare.what1 == isUndefinedOrNull || compare.what2 == isUndefinedOrNull\" ng-click=\"generateBudgetCounterReportGraphBars()\" type=\"button\" class=\"btn btn-default\"><i class=\"fa fa-bar-chart\"></i> Grafico a barre</button></div></div></div></div></div></div></uib-tab><uib-tab index=\"2\" ng-click=\"clearVariable()\"><uib-tab-heading>CUSUM</uib-tab-heading><div class=\"row\"><div class=\"col-md-12 wrapper-md\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row wrapper\"><div class=\"col-md-2\"><label class=\"control-label\">Da:</label> <input class=\"btn btn-default btn-sm col-md-12\" type=\"date\" ng-model=\"period.dateFrom\"></div><div class=\"col-md-2\"><label class=\"control-label\">A:</label> <input class=\"btn btn-default btn-sm col-md-12\" type=\"date\" ng-model=\"period.dateTo\"></div><div class=\"col-md-2\"><label for=\"cusum_commission_code\" class=\"control-label\">Commesse:</label><div id=\"cusum_commission_code\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"commission.searchCode\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Enter...\">{{$item.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in availableCommissionCodes track by $index\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"col-md-2\"><label for=\"cusum_budget_code\" class=\"control-label\">Budget:</label><div id=\"cusum_budget_code\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"budget.searchCode\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Enter...\">{{$item.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in availableBudgetCodes track by $index\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"col-md-2\"><label class=\"control-label\" for=\"cusum_vettore_energetico\">Vettore:</label><six-lookup id=\"cusum_vettore_energetico\" ng-model=\"vector\" sx-type=\"\'vettoreenergetico\'\" sx-field=\"\'id\'\"></six-lookup></div><div class=\"col-md-2\"><label class=\"control-label\" for=\"cusum_contatore_type\">Tipo contatore:</label><six-lookup id=\"cusum_contatore_type\" sx-base-path=\"\'schema\'\" ng-model=\"type\" sx-field=\"\'id\'\" sx-filter=\"contatoreTypeFilter\" sx-disabled=\"!vector.id\"></six-lookup></div></div><div class=\"row wrapper\"><div class=\"col-md-4\" ng-if=\"commission.searchCode.length <= 1\"><label class=\"control-label\" for=\"cusum_contatori\">Contatori:</label><div id=\"cusum_contatori\" class=\"input-group has-button\" style=\"width: 100%\"><ui-select multiple=\"\" ng-model=\"ids.searchCode\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Enter...\">{{$item.code}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in availableIdCodes track by $index\"><div ng-bind-html=\"item.description | highlight: $select.search\"></div><small ng-bind-html=\"item.code | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"col-md-4\" ng-if=\"commission.searchCode.length > 1\"><label class=\"control-label\" for=\"cusum_contatori\">Contatori: (con più commesse non è possibile confrontare singoli contatori)</label></div></div><div class=\"row wrapper\"><div class=\"col-md-12\"><button ng-click=\"reloadPage()\" type=\"button\" class=\"btn btn-default btn-sm\"><i class=\"fa fa-refresh\"></i> Pulisci pagina</button></div><div class=\"col-md-12\"><hr></div><div class=\"col-md-6 col-md-offset-10\"><button ng-disabled=\"budget.searchCode.length == 0\" ng-click=\"generateCusum()\" type=\"button\" class=\"btn btn-default\"><i class=\"fa fa-area-chart\"></i> Grafico CUSUM</button></div></div></div></div></div></div></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("theme/report/report_daydegree.html","<div class=\"col-md-12 override-padding-15-px\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">GRADI GIORNO</h1></div></div></div><div class=\"panel-body\"><div class=\"col-sm-12 no-padder\"><uib-tabset class=\"tab-container\"><uib-tab index=\"0\"><uib-tab-heading>Gradi Giorno</uib-tab-heading><div class=\"row\"><div class=\"col-md-12 wrapper-md\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row wrapper\"><div class=\"col-md-3\"><label for=\"zonatermica\" class=\"control-label\">Zona Termica</label><six-lookup id=\"zonatermica\" ng-model=\"zonatermica\" sx-type=\"\'zonatermica\'\" sx-field=\"\'zonatermica_id\'\"></six-lookup></div><div class=\"col-md-2\"><label id=\"data_from_key\" class=\"control-label\">Anno:</label><six-year-picker ng-model=\"fromYearPicker.year\" sx-big=\"true\"></six-year-picker></div></div><div class=\"col-md-12\"><hr></div><div class=\"col-md-1 col-md-offset-10\"><button ng-click=\"generateDayDegreeReport()\" type=\"button\" class=\"btn btn-default\"><i class=\"fa fa-cog\"></i> Genera</button></div></div></div></div></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("theme/test/test.html","<div class=\"panel panel-default\"><div class=\"panel-body\"><six-grid-pagination sx-id=\"test_grid\" get-data-callback=\"getData()\" get-list-callback=\"getData()\" items-list=\"data\" grid-options=\"viewGridOptions\" column-defs=\"viewGridOptions.columnDefs\" params=\"params\" <!--grid-app-callbacks=\"gridAppCallbacks\" --=\"\">enable-state-saving=\"true\" show-global-search=\"false\"></six-grid-pagination></div></div>");
$templateCache.put("consip/acquisitionstep/importpdi/grid-footer.template.html","<div class=\"ui-grid-grid-footer\"><div class=\"alert alert-danger m-xs\"><strong>Errore di arrotondamento sul totale:</strong> totale del file {{grid.appScope.totals.original | currency:\"€\":3}} - totale calcolato {{grid.appScope.totals.computed | currency:\"€\":3}}</div></div>");
$templateCache.put("consip/acquisitionstep/importpdi/import.html","<div class=\"row\"><div ng-if=\"gridOptions.columnDefs.length\" ui-grid=\"gridOptions\" class=\"grid\" ui-grid-resize-columns=\"\"></div></div><div class=\"row\"><a href=\"\" class=\"btn btn-sm btn-info pull-right m-t-xs\" ng-click=\"export()\"><span class=\"fa fa-download\">XLS</span></a></div>");
$templateCache.put("consip/acquisitionwizard/template/acts_column.html","<div class=\"ui-grid-cell-contents text-center\" ng-if=\"row.entity.model.current_step.status == \'terminated\'\" style=\"vertical-align:middle;\"><a ng-href=\"#/additionalacts/acquisition/{{row.entity.UUID}}\" class=\"btn btn-xs btn-primary\"><i class=\"fa fa-pencil-square-o\"></i> <span ng-if=\"row.entity.model.additional_acts.length>0\" class=\"m-l-xs\">{{row.entity.model.additional_acts.length}}</span></a></div>");
$templateCache.put("consip/acquisitionwizard/template/adhesion_column.html","<div class=\"ui-grid-cell-contents text-center\"><span ng-if=\"row.entity.adhesion_status===1\">Non aderente</span></div>");
$templateCache.put("consip/acquisitionwizard/template/detail_column.html","<div class=\"ui-grid-cell-contents text-center\"><a ng-href=\"#/acquisitionwizard/detail/{{row.entity.UUID}}\" class=\"btn btn-xs btn-primary\"><i class=\"fa fa-search\"></i></a></div>");
$templateCache.put("consip/acquisitionwizard/template/steps_column.html","<div class=\"ui-grid-cell-contents\"><span ng-if=\"row.entity.model.step1\"><six-consip-timing-led sx-value=\"row.entity.model.step1.timing_status\" sx-description=\"grid.appScope.$parent.stepLabel.step1\"></six-consip-timing-led></span> <span ng-if=\"row.entity.model.step2\"><six-consip-timing-led sx-value=\"row.entity.model.step2.timing_status\" sx-description=\"grid.appScope.$parent.stepLabel.step2\"></six-consip-timing-led></span> <span ng-if=\"row.entity.model.step3\"><six-consip-timing-led sx-value=\"row.entity.model.step3.timing_status\" sx-description=\"grid.appScope.$parent.stepLabel.step3\"></six-consip-timing-led></span> <span ng-if=\"row.entity.model.step4\"><six-consip-timing-led sx-value=\"row.entity.model.step4.timing_status\" sx-description=\"grid.appScope.$parent.stepLabel.step4\"></six-consip-timing-led></span> <span ng-if=\"row.entity.model.step5\"><six-consip-timing-led sx-value=\"row.entity.model.step5.timing_status\" sx-description=\"grid.appScope.$parent.stepLabel.step5\"></six-consip-timing-led></span> <span ng-if=\"row.entity.model.step6\"><six-consip-timing-led sx-value=\"row.entity.model.step6.timing_status\" sx-description=\"grid.appScope.$parent.stepLabel.step6\"></six-consip-timing-led></span> <span ng-if=\"row.entity.model.step7\"><six-consip-timing-led sx-value=\"row.entity.model.step7.timing_status\" sx-description=\"grid.appScope.$parent.stepLabel.step7\"></six-consip-timing-led></span> <span ng-if=\"row.entity.model.step8\"><six-consip-timing-led sx-value=\"row.entity.model.step8.timing_status\" sx-description=\"grid.appScope.$parent.stepLabel.step8\"></six-consip-timing-led></span> <span ng-if=\"row.entity.model.step9\"><six-consip-timing-led sx-value=\"row.entity.model.step9.timing_status\" sx-description=\"grid.appScope.$parent.stepLabel.step9\"></six-consip-timing-led></span></div>");
$templateCache.put("consip/sal/createrow/add_sal_row.html","<script type=\"text/ng-template\" id=\"dialogChooseServiceTemplate.html\"><uib-tabset class=\"wrapper\" justified=\"true\"> <uib-tab heading=\"Servizio PDI\" index=\"0\" ng-if=\"permission.manualRow\"> <div class=\"grid\" ui-grid=\"gridOptions\" ui-grid-pagination ui-grid-resize-columns ui-grid-move-columns ui-grid-auto-resize ui-grid-selection></div> <div class=\"row m-t\"> <div class=\"col-lg-12 \"> <button class=\"btn btn-sm btn-success pull-left\" ng-click=\"onAddRows(); closeThisDialog();\" ng-disabled=\"selectedCount() == 0\"> <i class=\"fa fa-plus\"></i> Aggiungi {{selectedCount()}} righe </button> <button class=\"btn btn-sm btn-default pull-right\" ng-click=\"closeThisDialog()\"> <i class=\"fa fa-undo\"></i> Annulla </button> </div> </div> </uib-tab> <uib-tab heading=\"Manuali\" index=\"1\" ng-if=\"permission.fakeRow\"> <form name=\"fakeService\"> <div class=\"col-lg-6 col-md-12 padder-v-xs\"> <label class=\"control-label\">Servizio: </label> <six-lookup-2 sx-id=\"service\" sx-base-path=\"\'record\'\" sx-type=\"\'servizio\'\" sx-placeholder=\"\'Servizio\'\" ng-model=\"row\" sx-field=\"\'service_id\'\" sx-compact=\"true\" sx-required=\"true\"> </six-lookup-2> </div> <div class=\"col-lg-6 col-md-12 padder-v-xs\"> <label class=\"control-label\">Edificio: </label> <six-lookup-2 sx-id=\"assets\" sx-base-path=\"\'record\'\" sx-type=\"\'edificio\'\" sx-placeholder=\"\'Edificio\'\" ng-model=\"row\" sx-field=\"\'asset_id\'\" sx-compact=\"true\" sx-required=\"true\"> </six-lookup-2> </div> <div class=\"col-lg-12 m-t\"> <button class=\"btn btn-sm btn-success pull-left\" ng-click=\"onAddFakeRow(row); closeThisDialog();\" ng-disabled=\"fakeService.$invalid\"> <i class=\"fa fa-plus\"></i> Aggiungi riga </button> <button class=\"btn btn-sm btn-default pull-right\" ng-click=\"closeThisDialog()\"> <i class=\"fa fa-undo\"></i> Annulla </button> </div> </form> </uib-tab> </uib-tabset></script><button class=\"btn btn-sm btn-success\" ng-click=\"showServiceDialog()\" ng-show=\"canAddRow()\"><i class=\"fa fa-plus\"></i> Aggiungi riga</button>");
$templateCache.put("dataset/timeline/templates/sixtimeline.html","<div class=\"col-md-2 col-sm-12\" ng-class=\"{\'col-md-offset-8\': !$ctrl.opts.datePickerEnabled}\" ng-if=\"$ctrl.historyPerm\"><a class=\"btn btn-sm btn-default pull-left\" ng-click=\"$ctrl.checkTimeline()\" title=\"Check timeline\"><i class=\"fa fa-medkit\"></i> Check</a></div><div class=\"col-md-8 col-sm-12\" id=\"timelineRow\" ng-class=\"{\'col-md-offset-2\': !$ctrl.historyPerm}\" ng-if=\"$ctrl.opts.datePickerEnabled\"><input type=\"date\" ng-model=\"$ctrl.date.currentDate\" ng-change=\"$ctrl.changeCurrentDate($ctrl.date.currentDate, $ctrl.EVENTS.DATE_SELECTED)\" class=\"form-control input-sm bg-light no-border rounded padder ng-pristine ng-valid ng-touched\"></div><div class=\"col-md-2 col-sm-12\" ng-if=\"$ctrl.historyPerm\"><a class=\"btn btn-sm btn-default pull-right\" ng-click=\"$ctrl.fixTimeline()\" title=\"Fix timeline\"><i class=\"fa fa-wrench\"></i> Fix</a></div><div class=\"clearfix\"></div><div id=\"timeline_section\"><div class=\"wrapper\"><ul class=\"timeline timeline-center\"><li class=\"tl-header\"><div class=\"btn btn-sm btn-default btn-rounded\">FINE</div></li><li ng-repeat=\"item in $ctrl.timeline\" class=\"tl-item\" ng-class-odd=\"\'tl-left\'\"><div class=\"tl-wrap\" ng-class=\"{\'b-success\': ($ctrl.selected.version == item.version)}\"><span class=\"tl-date\">{{item.dataIn | date : format : timezone}}<br></span> <span class=\"tl-date-2\" ng-if=\"$ctrl.historyPerm\">{{item.dataIn | date: \'dd/MM/yyyy HH:mm:ss\'}} <i class=\"tl-icon fa fa-caret-up fa-xs\"></i><br><span ng-if=\"item.dataOut\">{{item.dataOut | date: \'dd/MM/yyyy HH:mm:ss\'}}</span><span ng-if=\"!item.dataOut\"><i class=\"fa fa-ban fa-xs\"></i></span> <i class=\"tl-icon fa fa-caret-down fa-xs\"></i><div ng-if=\"$ctrl.historyPerm && $ctrl.selected.version == item.version\"><a class=\"btn btn-xs btn-success\" ng-click=\"$ctrl.save(item)\" title=\"Sovrascrivi versione\"><i class=\"fa fa-save\"></i></a> <a class=\"btn btn-xs btn-danger\" ng-click=\"$ctrl.delete(item)\" title=\"Elimina versione\"><i class=\"fa fa-trash\"></i></a></div></span><div class=\"tl-content panel padder b-a\" ng-class=\"{\'bg-success\': ($ctrl.selected.version == item.version)}\"><span class=\"arrow left pull-up hidden-left\" ng-class=\"{\'arrow-success\': ($ctrl.selected.version == item.version)}\"></span> <span class=\"arrow right pull-up visible-left\" ng-class=\"{\'arrow-success\': ($ctrl.selected.version == item.version)}\"></span> <a class=\"text-lt m-b-sm\" ng-click=\"$ctrl.onClickedVersion(item)\">{{item.model.code}} <span class=\"pull-right label\" ng-class=\"{\'bg-success\': ($ctrl.selected.version == item.version), \'bg-info\': ($ctrl.selected.version != item.version)}\">{{item.user}}</span></a><div class=\"panel-body pull-in b-t b-light\">{{item.model.description}}</div><div class=\"panel-body pull-in b-t b-light\" ng-if=\"item.parents\"><div ng-repeat=\"(treeCode, path) in $ctrl.treePaths[$index]\"><div style=\"text-align: left;\"><div class=\"badge bg-default\" title=\"Radice tree: {{treeCode}}\">{{treeCode}}</div><div ng-repeat=\"p in path\" ng-if=\"p.code\"><span class=\"badge bg-info\" title=\"({{p.type}}) - Codice: {{p.code}} - Descrizione: {{p.description}}\"><i ng-class=\"getModelIcon(p.type)\"></i> {{p.code}}</span></div></div></div></div><div class=\"panel-body pull-in b-t b-light\" ng-if=\"$ctrl.historyPerm\">Version: {{item.version}}</div></div></div></li><li class=\"tl-header\"><div class=\"btn btn-sm btn-default btn-rounded\">INIZIO</div></li></ul></div></div>");
$templateCache.put("dataset/tree/old/recordlist.html","<script type=\"text/ng-template\" id=\"records_renderer.html\"><div class=\"tree-node\" ng-click=\"toggleRecordSelection(node)\" ng-class=\"{\'node_selected\': isRecordSelected(node)}\"> <div class=\"tree-node-content\"> <div class=\"pull-left model-icon\" ui-tree-handle> <span class=\"text-info-dker pull-right m-l-xs m-r-xs model-icon\" title=\"{{node.schemaCode}}\" data-placement=\"right\" data-original-title=\"{{node.schemaCode}}\" tooltip><i ng-class=\"getModelIcon(node.schemaCode)\"></i></span> </div> <div> <span>{{node.model.code}} - {{node.model.description}}</span> </div> </div> </div></script><div class=\"panel-body form-group\"><form class=\"ng-pristine ng-valid\"><div class=\"clear m-b\"><a class=\"btn btn-xs btn-default pull-left\" id=\"btn_close\" ng-click=\"toggleRecordsList()\" title=\"Chiudi\" data-placement=\"bottom\"><i class=\"fa fa-angle-double-left text-danger-dker\"></i></a> <a class=\"btn btn-xs btn-danger pull-right\" ng-click=\"unselectAllFromRecordsList()\"><i class=\"fa fa-square-o\"></i> Desel. tutto</a> <a class=\"btn btn-xs btn-success m-r-xs pull-right\" ng-click=\"selectAllFromRecordsList()\"><i class=\"fa fa-check-square-o\"></i> Sel. tutto</a></div><div class=\"form-group\"><six-search-form ng-model=\"searchInput.text\" placeholder=\"Cerca...\" show-search-btn=\"false\"></six-search-form></div><div ng-if=\"!records.loaded\" style=\"text-align: center\"><i class=\"fa fa-spinner fa-2x fa-pulse fa-fw text-info-dker\" aria-hidden=\"true\"></i></div><div ui-tree=\"recordsOptions\" id=\"tree2-root\" ng-if=\"records.loaded\"><ol ui-tree-nodes=\"\" ng-model=\"records.list\" id=\"records\"><li ng-repeat=\"node in records.list\" ui-tree-node=\"\" ng-include=\"\'records_renderer.html\'\" ng-show=\"isRecordVisible(node)\"></li></ol></div></form></div>");
$templateCache.put("dataset/tree/old/tree.html","<style type=\"text/css\">\n  .custom-sidebar {\n    top: 100px;\n    z-index: 1031;\n    padding-bottom: 70px;\n  }\n  .override-top-sidebar {\n    top: 100px;\n  }\n  .floating-btn {\n    z-index: 999;\n  }\n  .floating-btn a {\n    color: #58666e;\n    background-color: #fff;\n  }\n</style><div ng-include=\"\'dataset/tree/toolbar.html\'\"></div><nav class=\"floating-btn\" mfb-menu=\"\" position=\"bl\" effect=\"zoomin\" label=\"Pannelli\" active-icon=\"fa fa-chevron-up\" resting-icon=\"fa fa-columns\" toggling-method=\"hover\"><button mfb-button=\"\" icon=\"fa fa-indent\" label=\"Nodi disponibili\" ng-click=\"toggleRecordsList()\"></button> <button mfb-button=\"\" icon=\"fa fa-edit\" label=\"Dettagli nodo\" ng-click=\"toggleDetails()\"></button></nav><six-sidebar sx-class=\"override-top-sidebar\" sx-id=\"records_sidebar\" sx-position=\"left\" sx-title=\"\'Nodi disponibili\'\" sx-dimension=\"l\" sx-opened=\"showRecordsList\" sx-pinned=\"true\" sx-show-title=\"false\"><div ng-include=\"\'dataset/tree/old/recordlist.html\'\"></div></six-sidebar><six-sidebar sx-class=\"override-top-sidebar\" sx-id=\"details_sidebar\" sx-position=\"right\" sx-title=\"\'Dettagli\'\" sx-dimension=\"{{rightSidebarSize}}\" sx-opened=\"showDetails\" sx-pinned=\"false\" sx-show-title=\"false\"><div ng-include=\"\'dataset/tree/recorddetails.html\'\"></div></six-sidebar><div class=\"constructor\"><div class=\"hbox hbox-auto-xs hbox-auto-sm override-padding-50-px\"><div class=\"wrapper\"><div class=\"panel panel-default\"><div ng-include=\"\'dataset/tree/old/treenode.html\'\"></div></div></div></div></div><div class=\"panel-footer\" ng-if=\"false\"><div class=\"row form-group\"><input id=\"jsonShowCheck\" type=\"checkbox\" ng-model=\"jsonshow\" class=\"pull-left\"> <label for=\"jsonShowCheck\" class=\"pull-left control-label\">Dettaglio avanzato</label></div><div class=\"row\" collapse=\"!jsonshow\"><div class=\"list-group list-group-lg list-group-sp\"><pre>{{ tree.wrapper | json }}</pre></div></div></div>");
$templateCache.put("dataset/tree/old/treenode.html","<script type=\"text/ng-template\" id=\"tree_renderer.html\"><div class=\"tree-node\" ng-click=\"selectNode(node)\" ng-class=\"{\'node_selected\': isNodeSelected(node)}\"> <div class=\"tree-node-content\"> <div class=\"pull-left model-icon\" style=\"width: 26px;\" > <span class=\"text-info-dker pull-right m-l-xs m-r-xs model-icon\" title=\"{{node.schemaCode}}\" data-placement=\"left\" data-original-title=\"{{node.schemaCode}}\" tooltip><i ng-class=\"getModelIcon(node.schemaCode)\"></i></span> </div> <div> <a class=\"btn btn-xs btn-default\" data-nodrag ng-click=\"toggleNode(this)\" ng-if=\"node.nodes.length>0\"> <span class=\"fa\" ng-class=\"{\'fa-plus\': collapsed, \'fa-minus\': !collapsed}\"></span> </a> {{node.model.code}} - {{node.model.description}} <span class=\"pull-right btn btn-xs\" data-nodrag ng-confirm-message=\"Eliminare il nodo?\" ng-confirm-click=\"removeTreeNode(this)\" ng-confirm-condition=true ng-if=\"isWritePermAllowed()===true\"><i class=\"fa fa-times text-danger-dker remove-tree-btn\"></i></span> </div> </div> </div> <ol ui-tree-nodes=\"\" ng-model=\"node.nodes\" ng-class=\"{hidden: collapsed}\"> <li ng-repeat=\"node in node.nodes\" ui-tree-node ng-include=\"\'tree_renderer.html\'\" ng-show=\"isNodeVisible(node)\" /> </ol></script><div class=\"panel-body form-group\"><div class=\"form-group m-t-xs\"><six-search-form ng-model=\"searchInputInTree.text\" placeholder=\"Cerca...\" show-search-btn=\"false\"></six-search-form></div><div ng-if=\"!tree.loaded\" style=\"text-align: center\"><i class=\"fa fa-spinner fa-2x fa-pulse fa-fw text-info-dker\" aria-hidden=\"true\"></i></div><div ui-tree=\"treeOptions\" id=\"tree1-root\" ng-if=\"tree.loaded\" data-nodrop-enabled=\"\"><ol ui-tree-nodes=\"\" ng-model=\"tree.wrapper.model.nodes\" id=\"tree\"><li ng-repeat=\"node in tree.wrapper.model.nodes\" ui-tree-node=\"\" ng-include=\"\'tree_renderer.html\'\" ng-show=\"isNodeVisible(node)\"></li></ol></div></div>");
$templateCache.put("plan/invoice/components/odl_panel.html","<style>\n    .odl-panel .panel-heading {\n      color: #dcf2f8;\n      background-color: #23b7e5;\n      padding: 10px 15px;\n      border-bottom: 1px solid transparent;\n      border-radius: 2px 2px 0 0;\n      font-size: 20px;\n      height: 50px;\n      text-align: center;\n    }\n\n    .odl-panel .panel-heading a {\n      font-size: 14px;\n      color: #dcf2f8;\n    }\n\n    .odl-panel .grid {\n      height: 350px;\n    }\n\n    .red-highlight {\n      color: rgb(240, 80, 80);\n    }\n\n  </style><div class=\"odl-panel panel panel-default\"><div class=\"panel-heading\">Seleziona ODL <a class=\"pull-right\" ng-click=\"$ctrl.closePanel()\"><i class=\"fa fa-times\"></i></a></div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-lg-12\" ng-init=\"resizeParams = {enabled: false}\"><six-grid-pagination sx-id=\"invoice_odl\" get-data-callback=\"$ctrl.getOdlList()\" items-list=\"$ctrl.odlList\" grid-options=\"$ctrl.odlPanelGridOptions\" params=\"$ctrl.odlPanelParams\" auto-resize-params=\"resizeParams\" show-global-search=\"false\" enable-xls-export=\"false\"></six-grid-pagination></div></div></div></div>");
$templateCache.put("plan/invoice/directives/lookupmodal.html","<div class=\"ui-grid-cell-contents text-center\"><i class=\"fa fa-edit\"></i></div><script type=\"text/ng-template\" id=\"lookupModalTemplate.html\"><style> aside#assetLookup_sb, aside#schemaLookup_sb { left: 0px; top: 0px; } </style> <strong><span class=\"ngdialog-icon\"></span></strong> <div style=\"text-align: center;\"><h4 class=\"m-t-none m-b font-bold\">SELEZIONA IL VALORE</h4></div> <div class=\"row m-t m-l m-r\"> <div class=\"col-md-12 form-group\" ng-hide=\"forcedType\"> <label class=\"control-label\">Elemento tecnologico</label> <six-lookup-2 sx-id=\"schemaLookup\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" ng-model=\"schema\" sx-filter=\"typeIdFilter\" sx-item-template=\"\'{{item.description}}\'\" sx-show-details=\"false\" sx-show-filters=\"false\" sx-required=\"true\"> </six-lookup-2> </div> <div class=\"col-md-12 form-group\"> <label class=\"control-label\">Asset</label> <six-lookup-2 sx-id=\"assetLookup\" sx-base-path=\"\'record\'\" sx-type=\"schema.UUID\" ng-model=\"asset\" sx-object=\"fullAsset\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-required=\"true\"> </six-lookup-2> </div> <div class=\"col-sm-12 padder-v\"> <a class=\"btn btn-success pull-right\" ng-click=\"confirm(schema, asset, fullAsset)\">Conferma</a> <a class=\"btn btn-default pull-left\" ng-click=\"cancel()\">Annulla</a> </div> </div></script>");
$templateCache.put("plan/portal/issue/issue_detail.html","<ict-issue issue-id=\"issueId\" config=\"{ \'mode\': \'portal\', \'tabs\': [ { \'component\': \'ictIssue\', \'config\': {\'mode\': \'basic\', \'showWatchers\': false, \'showAssignee\': [\'activityReferer_id\'], \'onlyTreeAssets\': true}}, \'ictAttachments\', \'ictNotification\', \'ictMessage\' ] }\"></ict-issue>");
$templateCache.put("plan/portal/issue/issue_list.html","<six-toolbar><six-toolbar-button label=\"Tutti\" icon=\"fa fa-square-o\" icon-disabled=\"fa fa-check-square-o\" icon-condition=\"bool.allIssues\" toolbar-function=\"toggleAllIssues()\" ng-show=\"searchAllPermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Aggiungi segnalazione\" icon=\"fa fa-plus\" toolbar-function=\"newIssue()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" sx-disabled=\"!isDeletePermAllowed() || getSelectedRows().length == 0\" ng-confirm-message=\"Sei sicuro?\" ng-confirm-click=\"deleteIssueSelected()\" ng-confirm-condition=\"true\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"refresh()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista segnalazioni</h1></div></div></div><div class=\"panel-body\"><six-grid-pagination sx-id=\"portal_issue_grid\" get-data-callback=\"getCurrentUserIssueList()\" get-list-callback=\"getCurrentUserIssueList()\" items-list=\"issueList\" grid-options=\"viewGridOptions\" column-defs=\"viewGridOptions.columnDefs\" params=\"params\" auto-resize-params=\"autoResizeParams\" show-global-search=\"false\" enable-state-saving=\"true\" grid-app-callbacks=\"gridAppCallbacks\"></six-grid-pagination></div></div></div>");
$templateCache.put("plan/portal/odl/odl_detail.html","<six-toolbar><six-toolbar-item label=\"ODL n. {{data.model.code}} - {{odlWorkflow.getReadableStatus(data.status)}}\" ng-show=\"data.version\"></six-toolbar-item><six-toolbar-item label=\"Nuovo ODL\" ng-show=\"!data.version\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" toolbar-function=\"goToOdlList()\"></six-toolbar-button><six-toolbar-button label=\"Stampa\" icon=\"fa fa-print text-info-dker\" toolbar-function=\"printOdl(\'pdf\')\" sx-disabled=\"!data.version\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" toolbar-function=\"delete(data.version)\" sx-disabled=\"!data.version || !isDeletePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"validate()\" sx-disabled=\"!(schemaOdlDefined) || !isWritePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default constructor\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"!data.version\">Nuovo ODL</h1><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"data.version\">ODL n. <span class=\"m-l-xs\">{{data.model.code}}</span></h1></div><div class=\"col-sm-6 col-xs-12\" ng-if=\"data.version\"><odl-tab class=\"pull-right\" sx-object=\"data\" sx-base-path=\"\'odl\'\" sx-status=\"data.status\" sx-uuid=\"data.UUID\" sx-show-buttons=\"false\"></odl-tab></div></div></div><uib-tabset class=\"tabs-left\"><uib-tab index=\"0\"><uib-tab-heading><span class=\"fa fa-list-alt text-info-dker\"></span> ODL</uib-tab-heading><div ng-if=\"data.generated_by==\'plan\'\" ng-include=\"\'plan/portal/odl/odl_detail_plan.html\'\"></div><div ng-if=\"data.generated_by==\'issue\'\" ng-include=\"\'plan/portal/odl/odl_detail_issue.html\'\"></div><div class=\"panel-body m-t-n\"><div ng-if=\"schemaOdlDefined\"><uib-tabset class=\"tabs-right\"><uib-tab index=\"0\"><uib-tab-heading><span class=\"fa fa-list-alt text-info-dker\"></span> Dati</uib-tab-heading><div class=\"col-md-12 form-group s-f-height\" ng-if=\"data.version\"><h5 class=\"margin-col-l\">Codice</h5><div class=\"col-md-12 no-pad-l-r\"><input type=\"text\" class=\"form-control\" ng-model=\"data.model.code\" disabled=\"\"></div></div><div class=\"col-md-12 no-pad-l-r\"><form name=\"detailForm\" sf-schema=\"schema\" sf-form=\"form\" sf-model=\"data.model\"></form></div><div ng-if=\"!(schemaOdlDefined)\"><div class=\"wrapper\"><div class=\"row\"><label class=\"control-label\">Schema non definito &#x2192; Configurare prima il modello \'odl\'</label></div></div></div></uib-tab><uib-tab index=\"1\" disable=\"!data.UUID\" select=\"getTimeline()\"><uib-tab-heading><span class=\"fa fa-history text-info-dker\"></span> Storico stati</uib-tab-heading><div class=\"col-md-12\"><div class=\"hbox hbox-auto-xs hbox-auto-sm ng-scope\"><div class=\"col col-md-4\"><div class=\"wrapper\"><ul class=\"timeline\"><li class=\"tl-header\"><div class=\"btn btn-sm btn-default btn-rounded\">INIZIO</div></li><li ng-repeat=\"item in timeline\" class=\"tl-item\" ng-class-odd=\"\'tl-left\'\"><div class=\"tl-wrap\" ng-class=\"{\'b-success\': (currentDataInTimeline.version == item.version)}\"><span class=\"tl-date\">{{item.dataIn | date : \'dd/MM/yyyy HH:mm:ss\' : timezone}}</span><div class=\"tl-content panel padder b-a\" ng-class=\"{\'bg-success\': (currentDataInTimeline.version == item.version)}\"><span class=\"arrow left pull-up hidden-left\" ng-class=\"{\'arrow-success\': (currentDataInTimeline.version == item.version)}\"></span> <span class=\"arrow right pull-up visible-left\" ng-class=\"{\'arrow-success\': (currentDataInTimeline.version == item.version)}\"></span><div class=\"text-lt m-b-sm\"><a ng-click=\"getModelDetail(item.version)\">{{item.model.code}}</a></div><div class=\"panel-body pull-in b-t b-light\"><span class=\"pull-right label\" ng-class=\"{\'bg-success\': (currentDataInTimeline.version == item.version), \'bg-info\': (currentDataInTimeline.version != item.version)}\">{{item.user}}</span></div><div class=\"panel-body pull-in b-t b-light\">Stato: {{item.status}}</div><div class=\"panel-body pull-in b-t b-light\">Note: {{item.status_note}}</div></div></div></li><li class=\"tl-header\"><div class=\"btn btn-sm btn-default btn-rounded\">FINE</div></li></ul></div></div><div class=\"col wrapper bg-white\" ng-if=\"showDetail\"><div class=\"col-md-12 no-pad-l-r\"><div class=\"row wrapper\"><div class=\"col-md-12\"><label class=\"control-label\">Stato</label><div class=\"col-md-12 no-pad-l-r\"><span disabled=\"true\" class=\"form-control\">{{currentDataInTimeline.status}}</span></div></div><div class=\"col-md-12\"><label class=\"control-label\">Note cambio di stato</label><div class=\"col-md-12 no-pad-l-r\"><textarea rows=\"4\" class=\"col-md-12\" readonly=\"\">{{currentDataInTimeline.status_note}}</textarea></div></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Issue</label><six-lookup-2 sx-id=\"issue\" sx-base-path=\"\'issue\'\" sx-type=\"\'record\'\" ng-model=\"currentDataInTimeline\" sx-field=\"\'issue_id\'\" sx-compact=\"true\" sx-disabled=\"true\" sx-war=\"\'six-plan\'\"></six-lookup-2></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Tipo Asset</label><six-lookup-2 sx-id=\"issue-schema\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" sx-title=\"\'Tipo asset\'\" ng-model=\"currentDataInTimeline.model\" sx-field=\"\'type_id\'\" sx-disabled=\"true\"></six-lookup-2></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Asset</label><six-lookup-2 sx-id=\"issue-asset\" sx-base-path=\"\'record\'\" sx-title=\"\'Asset\'\" ng-model=\"data.model\" sx-type=\"currentDataInTimeline.model.type_id.UUID\" sx-field=\"\'record_id\'\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-disabled=\"true\"></six-lookup-2></div><div class=\"col-md-4 form-group\"><label>Data richiesta</label><div class=\"col-md-12 no-pad-l-r\"><input type=\"datetime-local\" class=\"form-control\" ng-model=\"currentDataInTimeline.date_requested\" readonly=\"\"></div></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Data chiusura</label><div class=\"col-md-12 no-pad-l-r\"><input type=\"datetime-local\" class=\"form-control\" ng-model=\"currentDataInTimeline.date_closing\" readonly=\"\"></div></div><div class=\"col-md-4 form-group\"><label class=\"control-label\">Utente di inserimento</label> <input type=\"text\" class=\"form-control\" ng-model=\"currentDataInTimeline.user\" readonly=\"\"></div></div><div class=\"col-md-12\"><div sf-schema=\"schemaDataInTimeline\" sf-form=\"formDataInTimeline\" sf-model=\"currentDataInTimeline.model\" sf-options=\"{ formDefaults: { readonly: true } }\"></div></div></div></div></div></div></uib-tab><uib-tab index=\"2\" disable=\"!data.version\"><uib-tab-heading><span class=\"fa fa-book text-info-dker\"></span> Allegati</uib-tab-heading><six-tree-attachments nodes=\"attachments\" save-callback=\"updAttachments()\" sx-tag-filter=\"\'class=odl\'\"></six-tree-attachments></uib-tab><uib-tab index=\"3\" disable=\"!data.version\" select=\"getMessage()\"><uib-tab-heading><span class=\"fa fa-envelope text-info-dker\"></span> Messaggio</uib-tab-heading><div class=\"col-md-12\" ng-if=\"loadingSixMail == true\"><uib-progressbar class=\"progress-striped active\" type=\"info\"><i>Caricamento messaggio</i></uib-progressbar></div><six-send-email ng-if=\"loadingSixMail == false\" sx-title-mail=\"objMail.title\" sx-body-mail=\"objMail.message\" sx-to-mail=\"objMail.to\" sx-cc-mail=\"objMail.cc\" sx-type-mail=\"\'odl\'\" sx-record-id=\"currentOdlRef\" sx-disable-to-mail=\"true\"></six-send-email></uib-tab><uib-tab index=\"4\" disable=\"!data.version\"><uib-tab-heading><span class=\"fa fa-qrcode text-info-dker\"></span> QRCODE</uib-tab-heading><qrcode version=\"5\" error-correction-level=\"H\" size=\"274\" data=\"{{data.UUID}}\"></qrcode></uib-tab><uib-tab index=\"5\" disable=\"!data.version\" select=\"notificationUuid = data.UUID\" deselect=\"notificationUuid = undefined\"><uib-tab-heading><span class=\"icon-bell text-info-dker\"></span> Notifiche</uib-tab-heading><ict-notifications ict-type=\"\'odl\'\" ict-uuid=\"notificationUuid\" ict-detail-view=\"sidebar\"></ict-notifications></uib-tab></uib-tabset></div></div></uib-tab><uib-tab index=\"1\" disable=\"!data.version\"><uib-tab-heading><span class=\"fa fa-list-alt text-info-dker\"></span> Preventivi</uib-tab-heading><div class=\"panel-body m-t-n\"><ict-odl-estimate ng-if=\"data.version\" ict-odl=\"data\" ict-odl-status=\"data.status\" ict-odl-uuid=\"data.UUID\" ict-manage=\"false\"></ict-odl-estimate></div></uib-tab><uib-tab index=\"2\" disable=\"!data.version\"><uib-tab-heading><span class=\"fa fa-list-alt text-info-dker\"></span> Consuntivi</uib-tab-heading><div class=\"panel-body m-t-n\"><ict-odl-consumptive ng-if=\"data.version\" ict-odl=\"data\" ict-odl-status=\"data.status\" ict-odl-uuid=\"data.UUID\" ict-manage=\"false\"></ict-odl-consumptive></div></uib-tab><uib-tab index=\"3\" disable=\"!issue.version\"><uib-tab-heading><span class=\"fa fa-list-alt text-info-dker\"></span> Segnalazione</uib-tab-heading><issue-details ng-if=\"false\" sx-issue=\"issue\" sx-show-watchers=\"false\" sx-show-references-assignee=\"false\" sx-show-responsable-list=\"false\" sx-show-customer-info=\"true\"></issue-details><div class=\"panel-body m-t-n\"><ict-issue issue-id=\"issue.UUID\" config=\"issueDisplayConfig\"></ict-issue></div></uib-tab></uib-tabset></div></div><div class=\"panel panel-default panel-body\" ng-if=\"true\"><div class=\"wrapper\"><div class=\"row form-group\"><input id=\"jsonShowCheck\" type=\"checkbox\" ng-model=\"jsonshow\" class=\"pull-left\"> <label for=\"jsonShowCheck\" class=\"pull-left control-label\">Dettaglio avanzato</label></div><div class=\"row\" ng-show=\"jsonshow\"><div class=\"list-group list-group-lg list-group-sp\"><pre>{{ data | json }}</pre></div></div></div></div>");
$templateCache.put("plan/portal/odl/odl_detail_issue.html","<div class=\"wrapper\"><div class=\"row m-b-xs\"><div class=\"col-md-12\"><div class=\"list-group-item clearfix b-l-3x b-l-primary\"><div class=\"col-md-3 form-group\"><label class=\"control-label\">Data richiesta</label><six-date-time-picker name=\"date_requested\" ng-model=\"data.date_requested\" date-options=\"dateOptions\" sx-disabled=\"true\"></six-date-time-picker></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Data inizio lavori</label><six-date-time-picker name=\"date_handling\" date-options=\"dateOptions\" ng-model=\"data.date_handling\" sx-disabled=\"true\"></six-date-time-picker></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Data chiusura</label><six-date-time-picker name=\"date_closing\" ng-model=\"data.date_closing\" date-options=\"dateOptions\" sx-disabled=\"true\"></six-date-time-picker></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Utente di inserimento</label><six-lookup-2 sx-id=\"logged-user\" ng-model=\"cacheVariable\" sx-type=\"\'operatore\'\" sx-base-path=\"\'record\'\" sx-field=\"\'loggedUser\'\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-disabled=\"true\"></six-lookup-2></div></div></div></div><div class=\"row\"><div class=\"col-md-12 m-t\"><div class=\"list-group-item clearfix b-l-3x b-l-info\"><div class=\"col-md-3 form-group format-h-odl\"><label class=\"control-label\">Segnalazione</label><six-lookup sx-id=\"issue\" sx-base-path=\"\'issue\'\" sx-type=\"\'record\'\" ng-model=\"data\" sx-field=\"\'issue_id\'\" sx-war=\"\'six-plan\'\" sx-filter=\"issueRefreshed.filter\" sx-show-details=\"false\" sx-show-filters=\"false\" sx-disabled=\"true\"><button class=\"btn btn-default\" ng-click=\"goToIssue()\" ng-disabled=\"!data.issue_id\"><i class=\"fa fa-external-link\"></i></button></six-lookup><div class=\"col-md-12 no-pad-l-r\"><input type=\"checkbox\" ng-model=\"issueRefreshed.bool\" ng-disabled=\"true\">Filtra per segnalazioni non \"associate\"</div></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Elemento tecnologico</label><six-lookup-2 sx-id=\"odl-schema\" sx-base-path=\"\'schema\'\" sx-type=\"\'schema\'\" ng-model=\"data.model\" sx-field=\"\'type_id\'\" sx-show-details=\"false\" sx-show-filters=\"false\" sx-disabled=\"true\"></six-lookup-2></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Asset</label><six-lookup-2 sx-id=\"asset\" sx-base-path=\"\'record\'\" sx-type=\"data.model.type_id.UUID\" ng-model=\"data.model\" sx-field=\"\'record_id\'\" sx-show-list=\"false\" sx-show-tree=\"true\" sx-show-details=\"true\" sx-show-filters=\"true\" sx-disabled=\"true\"></six-lookup-2></div><div class=\"col-md-3 form-group\"><label class=\"control-label\">Servizio</label><six-lookup-2 sx-id=\"issue-service\" ng-model=\"data.model\" sx-type=\"\'servizio\'\" sx-base-path=\"\'record\'\" sx-field=\"\'service_id\'\" sx-show-details=\"true\" sx-show-filters=\"true\"></six-lookup-2></div></div></div></div></div>");
$templateCache.put("plan/portal/odl/odl_detail_plan.html","<div class=\"wrapper\"><h4>Parametri da Programmata</h4><div class=\"row\"><div class=\"col-md-3 m-t\"><label for=\"dateRequested\" class=\"control-label\">Data pianifica</label><p class=\"input-group\" style=\"width:100%\"><input type=\"text\" name=\"dateRequested\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"data.date_requested\" is-open=\"popupRequested.opened\" datepicker-options=\"dateOptions\" clear-text=\"Cancella\" close-text=\"Chiudi\" current-text=\"Oggi\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openRequestedPicker()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-md-3 m-t\"><label for=\"dateRequested\" class=\"control-label\">Data inserimento</label><p class=\"input-group\" style=\"width:100%\"><input type=\"text\" name=\"dateRequested\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"date_in\" clear-text=\"Cancella\" close-text=\"Chiudi\" current-text=\"Oggi\" readonly=\"\"></p></div><div class=\"col-md-3 m-t\"><label for=\"record_istatusd_type\" class=\"control-label\">Stato</label><div class=\"input-group\" style=\"width:100%\"><input name=\"status\" type=\"text\" value=\"{{data.status}}\" class=\"form-control\" readonly=\"\"></div></div><div class=\"col-md-3 m-t\"><label for=\"generatioTag\" class=\"control-label\">Codice generazione</label><div class=\"input-group\" style=\"width:100%\"><input name=\"status\" type=\"text\" value=\"{{data.model.generation_tag}}\" class=\"form-control\" readonly=\"\"></div></div></div><div class=\"row\"><div class=\"col-md-6 m-t\" ng-if=\"data.is_aggregated\"><div class=\"list-group-item clearfix b-l-3x b-l-info\"><div class=\"col-md-8\"><label for=\"record_id\" class=\"control-label\">Asset</label><div class=\"input-group\" style=\"width:100%\"><input name=\"record_id\" type=\"text\" value=\"{{data.model.record_id.code}} - {{data.model.record_id.description}}\" class=\"form-control\" readonly=\"\"></div></div><div class=\"col-md-4\"><label for=\"record_id_type\" class=\"control-label\">Elemento tecnologico</label><div class=\"input-group\" style=\"width:100%\"><input name=\"record_id_type\" type=\"text\" value=\"{{data.model.type_id.description}}\" class=\"form-control\" readonly=\"\"></div></div><div class=\"col-md-8 m-t\"><label for=\"record_id\" class=\"control-label\">Generato per l\'elemento tecnologico</label><div class=\"input-group\" style=\"width:100%\"><input name=\"record_id\" type=\"text\" value=\"{{data.model.type_id.description}}\" class=\"form-control\" readonly=\"\"></div></div><div class=\"col-md-4 m-t\"><label class=\"control-label\"></label><div class=\"input-group\" style=\"width:100%\"><button class=\"btn btn-default m-t-xs\" style=\"width:100%\" ng-click=\"showAssetsList()\" data-toggle=\"collapse\" data-target=\"#assetsList\"><span class=\"fa fa-search\"></span> Dettaglio asset</button></div></div><div class=\"col-md-12 m-t collapse\" id=\"assetsList\"><h4 class=\"override-h4-no-margin\">Dettaglio asset</h4><hr class=\"m-t-sm\"><div class=\"m-t-n-sm\"><div ng-repeat=\"asset in assetsList\">{{asset.code}} - {{asset.description}}</div></div></div></div></div><div class=\"col-md-6 m-t\" ng-if=\"!data.is_aggregated\"><div class=\"list-group-item clearfix b-l-3x b-l-info\"><div class=\"col-md-8\"><label for=\"record_id\" class=\"control-label\">Asset</label><div class=\"input-group\" style=\"width:100%\"><input name=\"record_id\" type=\"text\" value=\"{{data.model.record_id.code}} - {{data.model.record_id.description}}\" class=\"form-control\" readonly=\"\"></div></div><div class=\"col-md-4\"><label for=\"record_id_type\" class=\"control-label\">Tipo di Asset</label><div class=\"input-group\" style=\"width:100%\"><input name=\"record_id_type\" type=\"text\" value=\"{{data.model.record_id.type}}\" class=\"form-control\" readonly=\"\"></div></div></div></div><div class=\"col-md-6 m-t\"><div class=\"list-group-item clearfix b-l-3x b-l-primary\"><div class=\"col-md-8\"><label for=\"record_id\" class=\"control-label\">Compito</label><div class=\"input-group\" style=\"width:100%\"><input name=\"record_id\" type=\"text\" value=\"{{data.task_id.description}}\" class=\"form-control\" readonly=\"\"></div></div><div class=\"col-md-4\"><label class=\"control-label\"></label><div class=\"input-group\" style=\"width:100%\"><button class=\"btn btn-default m-t-xs\" style=\"width:100%\" data-toggle=\"collapse\" data-target=\"#activitiesList\"><span class=\"fa fa-search\"></span> Dettaglio attività</button></div></div><div class=\"col-md-12 m-t collapse\" id=\"activitiesList\"><h4 class=\"override-h4-no-margin\">Dettaglio attività</h4><hr class=\"m-t-sm\"><div class=\"m-t-n-sm\"><div ng-repeat=\"activity in data.task_activities\">{{activity.model.title}}</div></div></div></div></div></div></div>");
$templateCache.put("plan/portal/odl/odl_list.html","<six-toolbar><six-toolbar-button label=\"Stampa\" icon=\"fa fa-print\" toolbar-function=\"printSelectedOdl()\" sx-disabled=\"getSelectedRows().length == 0\"></six-toolbar-button><six-toolbar-button label=\"Genera Odl\" icon=\"fa fa-plus\" toolbar-function=\"newOdl()\" sx-disabled=\"!isWritePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Chiudi Odl\" icon=\"fa fa-trash\" toolbar-function=\"massiveClosingOdl()\" sx-disabled=\"!isWritePermAllowed() || getSelectedRows().length == 0\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" sx-disabled=\"!isDeletePermAllowed() || getSelectedRows().length == 0\" ng-confirm-message=\"Sei sicuro?\" ng-confirm-click=\"deleteOdlSelected()\" ng-confirm-condition=\"true\"></six-toolbar-button><six-toolbar-button label=\"Tutti\" icon=\"fa fa-square-o\" icon-disabled=\"fa fa-check-square-o\" icon-condition=\"bool.allOdl\" toolbar-function=\"toggleAllOdl();\" ng-show=\"searchAllPermAllowed()\"></six-toolbar-button><six-toolbar-button icon=\"fa fa-refresh pull-left\" btn-class=\"icon-padded\" toolbar-function=\"refresh()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12 override-padding-toolbar\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\">Lista odl</h1></div></div></div><div class=\"panel-body\"><six-grid-pagination sx-id=\"portal_odl_grid\" get-data-callback=\"getCurrentUserOdlList()\" get-list-callback=\"getCurrentUserOdlList()\" items-list=\"odlList\" grid-options=\"viewGridOptions\" column-defs=\"viewGridOptions.columnDefs\" params=\"params\" auto-resize-params=\"autoResizeParams\" show-global-search=\"false\" enable-state-saving=\"true\" grid-app-callbacks=\"gridAppCallbacks\"></six-grid-pagination></div></div></div>");
$templateCache.put("plan/survey/components/ict_category.html","<div class=\"row\" ng-repeat=\"q in $ctrl.data.questions\"><ict-question data=\"q\"></ict-question></div>");
$templateCache.put("plan/survey/components/ict_category_model.html","<six-sidebar sx-class=\"override-top-sidebar\" sx-id=\"question_details_sidebar\" sx-position=\"right\" sx-title=\"\'Domanda\'\" sx-dimension=\"70\" sx-opened=\"$ctrl.showDetails\" sx-pinned=\"false\" sx-closable=\"true\" sx-show-title=\"true\"><div ng-include=\"\'plan/survey/survey_question_model_detail.html\'\"></div></six-sidebar><div class=\"row\"><label class=\"control-label\">Punteggio minimo</label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"$ctrl.data.min_score\"> <span class=\"input-group-addon\">/{{$ctrl.data.absmin}}</span></div></div><div class=\"row\"><label class=\"control-label\">Punteggio massimo</label><div class=\"input-group\"><input type=\"number\" class=\"form-control\" ng-model=\"$ctrl.data.max_score\"> <span class=\"input-group-addon\">/{{$ctrl.data.absmax}}</span></div></div><hr><div class=\"row\"><label class=\"control-label\">Aggiungi domanda</label><six-lookup-2 sx-id=\"questions_{{$ctrl.data.code}}\" ng-model=\"$ctrl.question\" sx-field=\"\'ref\'\" sx-show-filters=\"false\" sx-show-details=\"false\" sx-war=\"\'six-plan\'\" sx-base-path=\"\'question\'\" sx-on-obj-loaded=\"$ctrl.addQuestion(obj)\"><a class=\"btn btn-default\" ng-click=\"$ctrl.newQuestion()\" title=\"Nuova\"><i class=\"fa fa-plus text-success\"></i></a></six-lookup-2></div><div class=\"row padder m-t m-b hidden-sm\"><div class=\"col-md-9 col-sm-7 font-bold\">Domanda</div><div class=\"col-md-2 col-sm-3 font-bold\">Tipo risposta</div><div class=\"col-md-1 col-sm-1\"></div></div><div id=\"questionsManager\" style=\"position: relative;\"><ul class=\"list-group\" as-sortable=\"$ctrl.questionsSortableOptions\" data-ng-model=\"$ctrl.data.questions\"><li class=\"list-group-item\" ng-repeat=\"item in $ctrl.data.questions\" id=\"q{{item.model.code}}\" as-sortable-item=\"\"><div class=\"row\" as-sortable-item-handle=\"\"><div class=\"col-md-9 col-sm-7\"><input class=\"form-control input-sm\" ng-model=\"item.model.description\" readonly=\"\"></div><div class=\"col-md-2 col-sm-3\"><input class=\"form-control input-sm\" ng-model=\"item.model.answerType.description\" readonly=\"\"></div><div class=\"col-md-1 col-sm-1 button-group pull-right\"><a class=\"btn btn-sm btn-default pull-right\" ng-click=\"$ctrl.removeQuestion(item)\"><i class=\"fa fa-trash text-danger\"></i></a> <a class=\"btn btn-sm btn-default pull-right\" ng-click=\"$ctrl.editQuestion(item)\"><i class=\"fa fa-edit text-primary\"></i></a></div></div></li></ul></div>");
$templateCache.put("plan/survey/components/ict_question.html","<label class=\"control-label\">{{$ctrl.data.model.text}}</label><div ng-if=\"$ctrl.data.model.answerType.key == \'text\'\"><input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.data.model.response.description\"></div><div ng-if=\"$ctrl.data.model.answerType.key == \'textarea\'\"><textarea class=\"form-control\" ng-model=\"$ctrl.data.model.response.description\"></textarea></div><div ng-if=\"$ctrl.data.model.answerType.key == \'number\'\"><input type=\"number\" class=\"form-control\" ng-model=\"$ctrl.data.model.response.value\"></div><div ng-if=\"$ctrl.data.model.answerType.key == \'truefalse\'\"><div class=\"btn-group\"><label ng-repeat=\"a in $ctrl.data.model.answers\" class=\"btn btn-primary m-r\" ng-model=\"$ctrl.data.model.response\" uib-btn-radio=\"{{a}}\">{{a.description}}</label></div></div><div ng-if=\"$ctrl.data.model.answerType.key == \'select\' || $ctrl.data.model.answerType.key == \'selectmulti\'\"><six-select-2 sx-id=\"\'q\'\" ng-model=\"$ctrl.data.model\" sx-field=\"\'response\'\" sx-list=\"$ctrl.data.model.answers\" sx-multiple=\"{{$ctrl.data.model.answerType.args.multi}}\" sx-item-template=\"\'{{item.description}}\'\" sx-compact=\"\'true\'\"></six-select-2></div>");
$templateCache.put("plan/survey/components/ict_question_model.html","<six-toolbar ng-if=\"!$ctrl.suppressToolbar\"><six-toolbar-item label=\"Domanda \'{{$ctrl.data.model.code}}\'\" ng-show=\"$ctrl.data.version\"></six-toolbar-item><six-toolbar-item label=\"Nuova\" ng-show=\"!$ctrl.data.version\"></six-toolbar-item><six-toolbar-button icon=\"fa fa-chevron-left\" toolbar-function=\"$ctrl.goToList()\"></six-toolbar-button><six-toolbar-button label=\"Elimina\" btn-class=\"btn-danger\" icon=\"glyphicon glyphicon-trash\" toolbar-function=\"$ctrl.delete($ctrl.data.version)\" sx-disabled=\"!$ctrl.data.version || !$ctrl.isDeletePermAllowed()\"></six-toolbar-button><six-toolbar-button label=\"Salva\" btn-class=\"btn-success\" icon=\"fa fa-save\" toolbar-function=\"$ctrl.save()\" sx-disabled=\"!$ctrl.isWritePermAllowed()\"></six-toolbar-button></six-toolbar><div class=\"col-md-12\" ng-class=\"{\'override-padding-toolbar\': !$ctrl.suppressToolbar, \'m-t\': $ctrl.suppressToolbar}\"><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-md\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"!$ctrl.data.version\">Nuova domanda</h1><h1 class=\"m-n font-thin h3 text-black\" ng-if=\"$ctrl.data.version\">Domanda <span class=\"m-l-xs\">{{$ctrl.data.model.code}}</span></h1></div><div class=\"col-sm-6 col-xs-12\"><span class=\"btn btn-sm btn-success pull-right\" ng-click=\"$ctrl.save()\" ng-if=\"$ctrl.suppressToolbar\"><i class=\"fa fa-save\"></i></span></div></div></div><div class=\"wrapper\"><div class=\"panel-body\"><ict-question-data-conf data=\"$ctrl.data\"></ict-question-data-conf></div></div></div></div><div class=\"clearfix\"></div><div class=\"wrapper\"><div class=\"panel panel-default panel-body\" ng-if=\"true\"><div class=\"wrapper\"><div class=\"row form-group\"><input id=\"jsonShowCheck\" type=\"checkbox\" ng-model=\"jsonshow\" class=\"pull-left\"> <label for=\"jsonShowCheck\" class=\"pull-left control-label\">Dettaglio avanzato</label></div><div class=\"row\" ng-show=\"jsonshow\"><div class=\"list-group list-group-lg list-group-sp\"><pre>{{ $ctrl.data | json }}</pre></div></div></div></div></div>");
$templateCache.put("plan/survey/components/ict_question_model_data.html","<style type=\"text/css\">\n  @-webkit-keyframes highlight-fade {\n    0% {background: #deffca;}\n    100% {background: none;}\n  }\n\n  @keyframes highlight-fade {\n    0% {background: #deffca;}\n    100% {background: none;}\n  }\n\n  .highlight-cat {\n    -webkit-animation: highlight-fade 1.5s ease-in 1;\n    animation: highlight-fade 1.5s ease-in 1;\n  }\n</style><div class=\"col-md-12\"><div class=\"row\"><label class=\"control-label\">Codice</label> <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.data.model.code\"></div><div class=\"row\"><label class=\"control-label\">Descrizione</label> <input type=\"text\" class=\"form-control\" ng-model=\"$ctrl.data.model.description\"></div><div class=\"row\"><label class=\"control-label\">Testo</label> <textarea class=\"form-control\" ng-model=\"$ctrl.data.model.text\"></textarea></div><div class=\"row\"><label class=\"control-label\">Tipo risposta</label><six-select2 sx-id=\"answer_type\" ng-model=\"$ctrl.data.model\" sx-field=\"\'answerType\'\" sx-list=\"$ctrl.answerTypesList\" sx-show-key=\"false\" sx-compact=\"true\"></six-select2></div><div class=\"row m-t-xxl\" ng-if=\"$ctrl.data.model.answerType.key==\'select\' || $ctrl.data.model.answerType.key==\'selectmulti\' || $ctrl.data.model.answerType.key==\'truefalse\'\"><a class=\"btn btn-sm btn-default pull-right\" ng-click=\"$ctrl.newAnswer()\"><i class=\"fa fa-plus text-success\"></i></a><h4 class=\"override-h4-no-margin\">Opzioni</h4><hr><div class=\"row padder m-b hidden-sm\"><div class=\"col-md-9 font-bold\">Domanda</div><div class=\"col-md-2 font-bold\">Punteggio</div><div class=\"col-md-1\"></div></div><div id=\"answersManager\" style=\"position: relative;\"><ul class=\"list-group\" as-sortable=\"$ctrl.answersSortableOptions\" data-ng-model=\"$ctrl.data.model.answers\"><li class=\"list-group-item\" ng-repeat=\"item in $ctrl.data.model.answers track by $index\" id=\"ans{{item.key}}\" as-sortable-item=\"\"><div class=\"row\" as-sortable-item-handle=\"\"><div class=\"col-md-9 col-sm-8\"><input class=\"form-control input-sm\" ng-model=\"item.description\" autofocus=\"\"></div><div class=\"col-md-2 col-sm-3\"><input type=\"number\" class=\"form-control input-sm\" ng-model=\"item.score\"></div><div class=\"col-md-1 col-sm-1\"><a class=\"btn btn-sm btn-default pull-right\" ng-click=\"$ctrl.removeAnswer(item)\"><i class=\"fa fa-trash text-danger\"></i></a></div></div></li></ul></div></div></div>");
$templateCache.put("plan/survey/components/ict_survey_detail.html","<div class=\"col-md-12\"><div class=\"row\"><label class=\"control-label\">Descrizione</label> <input class=\"form-control\" ng-model=\"$ctrl.data.model.description\" readonly=\"\"></div><div class=\"row\"><label class=\"control-label\">Note</label> <textarea class=\"form-control\" ng-model=\"$ctrl.data.model.notes\" readonly=\"\"></textarea></div><div class=\"row m-t\"><h4 class=\"override-h4-no-margin\">Categorie</h4><hr><uib-accordion close-others=\"oneAtATime\"><uib-accordion-group class=\"panel-default\" ng-repeat=\"cat in $ctrl.data.model.categories\" ng-init=\"cat._focus=true\" is-open=\"cat._focus\"><uib-accordion-heading><div class=\"pull-right text-muted\">punt. {{cat.score}}</div><div>{{cat.description}}</div></uib-accordion-heading><div class=\"wrapper\"><ict-category data=\"cat\"></ict-category></div></uib-accordion-group></uib-accordion></div></div>");
$templateCache.put("theme/components/templates/sixbulkeditor.html","<style>\n    .check-disabled {\n        opacity: 0.7;\n        cursor: default;\n    }\n</style><div class=\"panel panel-default\"><div class=\"bg-light lter b-b wrapper-sm\"><div class=\"row\"><div class=\"col-sm-6 col-xs-12\"><h4 class=\"m-n font-thin text-black\">Modifica dei dati selezionati</h4></div></div></div><div class=\"panel-body m-b m-t no-padder\"><div class=\"col-md-12\"><legend class=\"h4 m-b padder-v m-t-n\">Campi da aggiornare: <span class=\"pull-right btn btn-xs btn-default\" ng-click=\"$ctrl.toggleFields()\"><i class=\"fa fa-check-square-o\"></i> Tutti/Nessuno</span></legend><label class=\"col-md-3 checkbox i-checks m-t-none m-b-sx\" ng-class=\"{\'check-disabled\': !field.enabled}\" ng-repeat=\"field in $ctrl.fieldsList\"><input type=\"checkbox\" ng-model=\"field.active\" ng-disabled=\"!field.enabled\"><i></i>{{field.title}}</label></div><div class=\"col-md-12\"><legend class=\"h4 padder-v\">Modifiche:</legend><div class=\"padder-v m-b-n\" ng-if=\"!$ctrl.fieldsActiveCount()\">Nessun campo modificabile.</div><div class=\"col-md-12 clearfix padder-v override-form-group override-checkbox m-b-n-lg\" sf-schema=\"$ctrl.schema.compact\" sf-form=\"$ctrl.filteredForm.compact\" sf-model=\"$ctrl.edits.compact\"></div><div class=\"col-md-12 clearfix padder-v override-form-group override-checkbox\" sf-schema=\"$ctrl.schema.full\" sf-form=\"$ctrl.filteredForm.full\" sf-model=\"$ctrl.edits.full\"></div></div><div class=\"col-md-12\"><div class=\"col-md-6 form-group\" ng-if=\"$ctrl.dateEnabled()\"><label class=\"control-label\">Data inserimento:</label><six-date-time-picker ng-model=\"$ctrl.insertDate\" date-options=\"$ctrl.sxDateOptions\"></six-date-time-picker></div><div class=\"col-md-6 form-group\" ng-class=\"{\'pull-right\': !$ctrl.dateEnabled()}\"><label class=\"control-label\">Logica di aggiornamento:</label><ui-select ng-model=\"$ctrl.mergeMode\" theme=\"bootstrap\" reset-search-input=\"false\" close-on-select=\"true\"><ui-select-match class=\"ui-select-match\" placeholder=\"Seleziona metodo di aggiornamento...\">{{$select.selected.value}}</ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"mode.key as (key, mode) in $ctrl.availableMergers\"><div ng-bind-html=\"mode.value | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col-md-12\"><button class=\"btn btn-danger btn-sm\" ng-click=\"$ctrl.cancelEdit()\"><i class=\"fa fa-close\"></i> Annulla</button> <button class=\"btn btn-success pull-right\" ng-click=\"$ctrl.saveAll()\"><i class=\"fa fa-save\"></i> Salva Modifiche</button></div></div></div>");
$templateCache.put("theme/components/templates/sixdatepicker.html","<div class=\"form-group has-feedback\" ng-class=\"{\'has-error ng-invalid\': ngInvalid, \'has-success\': ngValid}\"><div class=\"input-group has-button\" style=\"width: 100%\"><input name=\"{{$ctrl.name}}_input\" type=\"text\" class=\"form-control\" style=\"padding-left: 30px;\" uib-datepicker-popup=\"{{$ctrl.format}}\" ng-model=\"$ctrl.ngModel\" is-open=\"$ctrl.status.opened\" datepicker-options=\"$ctrl.dateOptions\" ng-click=\"$ctrl.open($event)\" close-text=\"Close\" datepicker-append-to-body=\"true\" popup-placement=\"auto bottom\" ng-disabled=\"$ctrl.sxDisabled\"> <a class=\"form-control-feedback\" style=\"right: auto;\" ng-click=\"$ctrl.open($event)\" ng-disabled=\"$ctrl.sxDisabled\"><i class=\"glyphicon glyphicon-calendar\"></i></a> <span class=\"input-group-btn\"><span ng-transclude=\"\"></span></span></div></div>");
$templateCache.put("theme/components/templates/sixdatetimepicker.html","<div class=\"form-group has-feedback\" ng-class=\"{\'has-error ng-invalid\': ngInvalid, \'has-success\': ngValid}\"><div class=\"input-group has-button\" style=\"width: 100%\"><input type=\"text\" id=\"{{$ctrl.sxId}}_dtp\" name=\"{{$ctrl.sxId}}\" class=\"form-control\" style=\"padding-left: 30px;\" ng-click=\"$ctrl.openCalendar($event, prop)\" datetime-picker=\"{{$ctrl.format}}\" datepicker-options=\"$ctrl.dateOptions\" timepicker-options=\"$ctrl.timePickerOptions\" button-bar=\"$ctrl.buttonBar\" enable-time=\"$ctrl.enableTime\" enable-date=\"$ctrl.enableDate\" ng-model=\"$ctrl.ngModel\" is-open=\"$ctrl.isOpen\" ng-disabled=\"$ctrl.sxDisabled\" ng-required=\"$ctrl.sxRequired\"> <a class=\"form-control-feedback\" style=\"right: auto;\" ng-click=\"$ctrl.openCalendar($event, prop)\" ng-disabled=\"$ctrl.sxDisabled\"><i class=\"glyphicon glyphicon-calendar\"></i></a> <span class=\"input-group-btn\"><span ng-transclude=\"\"></span></span></div></div>");
$templateCache.put("theme/components/templates/sixgridpagination.html","<div class=\"form-group\" ng-if=\"$ctrl.showGlobalSearch\"><input ng-keyup=\"$ctrl.callDataCallback()\" class=\"form-control\" type=\"text\" ng-model=\"$ctrl.params.queryParam\" placeholder=\"Type here to filter the list...\"></div><div ui-i18n=\"\'it\'\"><div id=\"{{$ctrl.sxId}}_grid\" class=\"grid\" ui-grid=\"$ctrl.gridOptions\" ui-grid-multiple=\"\" ui-grid-selection=\"\" ui-grid-pagination=\"\" ui-grid-resize-columns=\"\" ui-grid-move-columns=\"\" ui-grid-auto-resize=\"\" ui-grid-exporter=\"\" ui-grid-save-state=\"\" ui-grid-pinning=\"\" external-scopes=\"clickHandler\"></div></div>");
$templateCache.put("theme/components/templates/sixprofile.html","<style type=\"text/css\">\n  .profile-current {\n    padding-bottom: 10px;\n    text-align: center;\n  }\n  .profile-current a {\n    display: inline !important;\n    padding: 0 !important;\n  }\n  .single-header{\n    text-align: center;\n    float: none !important;\n  }\n</style><six-sidebar sx-id=\"sxId\" class=\"sixlookup2\" sx-position=\"right\" sx-title=\"sxTitle\" sx-dimension=\"l\" sx-opened=\"sxOpened\" sx-pinnable=\"false\"><div class=\"nav-tabs-alt\" ng-if=\"tabHeaderList.length>1\"><ul class=\"nav nav-tabs\" role=\"tablist\" id=\"sx-profile-tab-headers\"><li ng-class=\"{\'single-header\': tabBodyList.length<2}\" ng-repeat=\"h in tabHeaderList\" ng-if=\"tabBodyList[$index]\" ng-init=\"targetId=\'#tab-\'+($index+1)\"><a data-target=\"{{targetId}}\" role=\"tab\" data-toggle=\"tab\" class=\"text-md text-muted\"><i class=\"{{h.icon}} wrapper-sm\"></i> {{h.label}}</a></li></ul></div><div class=\"tab-content\"><div ng-repeat=\"b in tabBodyList\" role=\"tabpanel\" ng-init=\"tabId=\'tab-\'+($index+1)\" id=\"{{tabId}}\" class=\"tab-pane\" ng-class=\"{\'active\': $index===0}\"><ul class=\"nav list-sidebar-nav\"><li ng-if=\"b.current.code\"><h4 class=\"profile-current\"><a ng-show=\"b.canClear\" ng-click=\"clearProfileAndSwitch(b.current)\"><i class=\"fa fa-times text-danger\"></i></a> {{b.current.description}}</h4></li><li><div class=\"form-group m-l-xs m-r-xs m-t-xs\"><six-search-form ng-model=\"b.filter\" placeholder=\"Filtra...\" show-search-btn=\"false\"></six-search-form></div></li><li ng-repeat=\"item in b.list | filter:b.filter | orderBy: \'description\'\" class=\"m-l-xs m-r-xs\" ng-class=\"{\'disabled commission-disabled\': isItemSelected(item)}\" title=\"{{item.code}} - {{item.description}}\"><a ng-click=\"!isItemSelected(item) &amp;&amp; switchProfile(item, userInfo().profile.items)\">{{item.description | limitTo:40}}{{item.description > 40 ? \'...\' : \'\'}} <i ng-if=\"isItemSelected(item)\" class=\"fa fa-long-arrow-left m-l-md\" style=\"font-size:smaller\"></i></a></li></ul></div></div></six-sidebar>");
$templateCache.put("theme/components/templates/sixsearchfilters.html","<div class=\"row wrapper\"><div ng-class=\"{ \'col-md-12\': sxAutoConfirmFilter, \'col-md-6\': !sxAutoConfirmFilter }\"><a class=\"btn btn-default\" style=\"width:100%\" ng-click=\"addSearchTerm()\"><i class=\"fa fa-plus\"></i>Aggiungi filtro</a></div><div class=\"col-md-6\" six-sidebar-autoclose=\"true\" ng-if=\"!sxAutoConfirmFilter\"><a ng-if=\"!sxFilterOnly\" class=\"btn btn-default\" style=\"width:100%\" ng-click=\"search()\" six-sidebar-autoclose=\"false\"><i class=\"fa fa-search\"></i>Cerca</a> <a ng-if=\"sxFilterOnly\" class=\"btn btn-default\" style=\"width:100%\" ng-click=\"getFiltersList()\" six-sidebar-autoclose=\"false\"><i class=\"fa fa-check\"></i>Conferma</a></div></div><div class=\"row wrapper\" ng-if=\"showSelectModel\" style=\"margin-top: -30px;\"><div class=\"col-md-12 m-t\"><label id=\"type_label\" class=\"control-label\">Modello</label><six-lookup sx-id=\"type\" sx-base-path=\"\'schema\'\" ng-model=\"params\" sx-title=\"\'Tipo\'\" sx-field=\"\'type_id\'\" sx-object=\"params.type_obj\"></six-lookup></div></div><div class=\"list-group wrapper\" style=\"margin-top: -15px; margin-bottom: -10px;\" ng-if=\"params.terms.length\"><six-search-single-term sx-params=\"params\" ng-repeat=\"term in params.terms track by $index\" sx-position=\"$index\"></six-search-single-term></div>");
$templateCache.put("theme/components/templates/sixsearchsingleterm.html","<style type=\"text/css\">\n    .sx-sst .attr{\n        width: 87%;\n    }\n    .sx-sst .val{\n        width: 100%;\n    }\n    .sx-sst .val-rel{\n        width: 82%;\n    }\n    .sx-sst .val-no-rel{\n        width: 100%;\n    }\n    .sx-sst .caret{\n        margin-left: 6px;\n    }\n</style><div class=\"list-group-item b-l-info b-l-3x hover-anchor hover sx-sst\"><span ng-click=\"removeTerm()\" class=\"pull-right text-muted hover-action\" role=\"button\" tabindex=\"0\"><i class=\"fa fa-times\"></i></span> <span class=\"block attr\"><ui-select ng-model=\"ngModel\" theme=\"bootstrap\" on-select=\"selectAttribute($item)\" ng-disabled=\"sxDisabled\" reset-search-input=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Seleziona un attributo...\"><span ng-if=\"params.terms[index].attribute_obj.title\">{{params.terms[index].attribute_obj.title}}</span></ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in params.attributes track by $index\" refresh=\"refreshData($select.search)\" refresh-delay=\"index\"><div>{{item.title | highlight: $select.search}} ({{item.type | highlight: $select.search}})</div></ui-select-choices></ui-select></span> <span class=\"block m-t-xs val\"><span class=\"input-group-bt pull-left\" ng-if=\"isRel()\"><select class=\"form-control\" ng-model=\"params.terms[index].attribute_rel\"><option value=\"lt\">&lt;</option><option value=\"lte\">&le;</option><option value=\"eq\">=</option><option value=\"gte\">&ge;</option><option value=\"gt\">&gt;</option></select></span> <span class=\"input-group-bt pull-left\" ng-if=\"!isRel() && (params.terms[index].attribute_obj.type==\'text\' || params.terms[index].attribute_obj.type==\'sixformula\')\"><select class=\"form-control\" ng-model=\"params.terms[index].rel\" ng-init=\"params.terms[index].rel = params.terms[index].rel || \'like\'\"><option value=\"eq\">=</option><option value=\"like\">~</option></select></span> <span><div class=\"input-group val-no-rel\" ng-if=\"params.terms[index].attribute_obj.type==\'text\'\"><input name=\"text\" type=\"text\" ng-model=\"params.terms[index].attribute_value\" class=\"form-control\"></div><div class=\"input-group val-no-rel\" style=\"width:100%\" ng-if=\"params.terms[index].attribute_obj.type==\'uiselectmultiple\'\"><input name=\"text\" type=\"text\" ng-model=\"params.terms[index].attribute_value\" class=\"form-control\"></div><div class=\"input-group val-rel\" ng-if=\"params.terms[index].attribute_obj.type==\'number\'\"><input name=\"number\" type=\"number\" ng-model=\"params.terms[index].attribute_value\" class=\"form-control\"></div><div class=\"input-group val-no-rel\" style=\"width:100%\" ng-if=\"params.terms[index].attribute_obj.type==\'sixlookup\'\"><six-lookup id=\"record_id\" ng-model=\"params.terms[index]\" sx-type=\"params.terms[index].attribute_obj.entity_id\" sx-field=\"\'attribute_value\'\"></six-lookup></div><div class=\"input-group val-no-rel\" style=\"width:100%\" ng-if=\"params.terms[index].attribute_obj.type==\'checkbox\'\"><input type=\"checkbox\" ng-model=\"params.terms[index].attribute_value\">{{params.terms[index].attribute_obj.title}}</div><div class=\"input-group val-rel\" style=\"width:100%\" ng-if=\"params.terms[index].attribute_obj.type==\'datepicker\'\"><p class=\"input-group\" style=\"width:100%\"><input type=\"text\" name=\"datepicker\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"params.terms[index].attribute_value\" is-open=\"pickerOptions.opened\" datepicker-options=\"pickerOptions\" close-text=\"Chiudi\" current-text=\"Oggi\"> <span class=\"input-group-btn\"><a class=\"btn btn-default\" ng-click=\"pickerOptions.opened=!pickerOptions.opened\"><i class=\"glyphicon glyphicon-calendar\"></i></a></span></p></div><div class=\"input-group val-no-rel\" style=\"width:100%\" ng-if=\"params.terms[index].attribute_obj.type==\'uiselect\'\"><ui-select ng-model=\"ngModel\" theme=\"bootstrap\" on-select=\"selectAttributeValue($item)\" ng-disabled=\"sxDisabled\" reset-search-input=\"false\"><ui-select-match class=\"ui-select-match\" placeholder=\"Seleziona un valore...\"><span ng-if=\"params.terms[index].attribute_value.name\">{{params.terms[index].attribute_value.name}}</span><span ng-if=\"!params.terms[index].attribute_value.name\">{{params.terms[index].attribute_value.value}}</span></ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in params.terms[index].attribute_obj.titleMap track by $index\"><div>{{item.name | highlight: $select.search}} <span ng-if=\"item.value\">({{item.value | highlight: $select.search}})</span></div></ui-select-choices></ui-select></div></span></span></div>");
$templateCache.put("theme/components/templates/sixsearchterms.html","<six-sidebar sx-id=\"{{sxId}}\" class=\"sixlookup2\" sx-position=\"right\" sx-title=\"params.type_obj.model.description\" sx-dimension=\"l\" sx-opened=\"sxOpen\" sx-pinnable=\"false\"><div class=\"row wrapper\"><div class=\"col-md-6\"><a class=\"btn btn-default\" style=\"width:100%\" ng-click=\"addSearchTerm()\"><i class=\"fa fa-plus\"></i>Aggiungi filtro</a></div><div class=\"col-md-6\" six-sidebar-autoclose=\"true\"><a ng-if=\"!sxFilterOnly\" class=\"btn btn-default\" style=\"width:100%\" ng-click=\"search()\" six-sidebar-autoclose=\"true\"><i class=\"fa fa-search\"></i>Cerca</a> <a ng-if=\"sxFilterOnly\" class=\"btn btn-default\" style=\"width:100%\" ng-click=\"getFiltersList()\" six-sidebar-autoclose=\"true\"><i class=\"fa fa-check\"></i>Conferma</a></div></div><div class=\"row wrapper\" ng-if=\"showSelectModel\" style=\"margin-top: -30px;\"><div class=\"col-md-12 m-t\"><label id=\"type_label\" class=\"control-label\">Modello</label><six-lookup sx-id=\"type\" sx-base-path=\"\'schema\'\" ng-model=\"params\" sx-title=\"\'Tipo\'\" sx-field=\"\'type_id\'\" sx-object=\"params.type_obj\"></six-lookup></div></div><div class=\"list-group wrapper\" style=\"margin-top: -15px;\"><six-search-single-term sx-params=\"params\" ng-repeat=\"term in params.terms track by $index\" sx-position=\"$index\"></six-search-single-term></div></six-sidebar>");
$templateCache.put("theme/components/templates/sixtreeattachments.html","<style type=\"text/css\">\n  .folder {\n    font-weight: bold;\n  }\n\n  .file {\n    margin-left: 16px;\n  }\n\n  .folder-node {\n    display: inline-block;\n    padding: 6px 12px;\n    margin-bottom: 0;\n    font-size: 14px;\n    font-weight: normal;\n    line-height: 1.42857143;\n    white-space: nowrap;\n    vertical-align: middle;\n    -ms-touch-action: manipulation;\n    touch-action: manipulation;\n    cursor: pointer;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    border: 1px solid transparent;\n    border-radius: 4px;\n\n    color: #58666e;\n  }\n\n  .file-node {\n    color: #587180;\n  }\n\n  .file-node:hover {\n    color: #3c4c56;\n  }\n\n  .folder-node:hover {\n    color: #232735;\n  }\n\n  .folder-buttons {\n    margin-left: 16px;\n  }\n\n  .folder-buttons .btn {\n    color: #a6a8b1;\n  }\n\n  .file-title-write input {\n    width: 50%;\n  }\n\n  .my-drop-zone {\n    border: dotted 2px lightgray;\n    box-shadow: none;\n  }\n\n  .nv-file-over {\n    border: dotted 3px #7266ba;\n  }\n\n  .file-tag-write {\n    max-width: 250px;\n    display: inline-block;\n    vertical-align: middle;\n  }\n\n  .inherit-width {\n    width: inherit;\n  }\n\n  .inline {\n    display: inline;\n  }\n\n</style><div class=\"row\" ng-if=\"upload.show\"><div class=\"col-md-12\" style=\"margin-bottom: 40px\"><h4>Aggiungi alla cartella <i>{{upload.nodeData.title}}</i></h4><div class=\"coll-lg-12\"><h4 class=\"inline m-r-sm\">Carica un file</h4><input class=\"inline\" type=\"file\" nv-file-select=\"\" uploader=\"uploader\"><h4 class=\"inline m-l-sm\">Oppure trascinalo nell\'area in tabella</h4></div><table class=\"table\"><thead><tr><th width=\"50%\">Nome</th><th ng-show=\"uploader.isHTML5\">Dimensione</th><th ng-show=\"uploader.isHTML5\">Avanzamento</th><th>Stato</th><th style=\"width:90px;\">Azioni</th></tr></thead><tbody><tr ng-repeat=\"item in uploader.queue\"><td><strong>{{ item.file.name }}</strong></td><td ng-show=\"uploader.isHTML5\" nowrap=\"\">{{ item.file.size/1024/1024|number:2 }} MB</td><td ng-show=\"uploader.isHTML5\"><div class=\"progress\" style=\"margin-bottom: 0;\"><div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{ \'width\': item.progress + \'%\' }\"></div></div></td><td class=\"text-center\"><span ng-show=\"item.isSuccess\"><i class=\"glyphicon glyphicon-ok\"></i></span> <span ng-show=\"item.isCancel\"><i class=\"glyphicon glyphicon-ban-circle\"></i></span> <span ng-show=\"item.isError\"><i class=\"glyphicon glyphicon-remove\"></i></span></td><td nowrap=\"\"><button type=\"button\" class=\"btn btn-icon btn-success btn-xs\" ng-click=\"item.upload()\" ng-disabled=\"item.isReady || item.isUploading || item.isSuccess\" uib-tooltip=\"Carica\"><span class=\"glyphicon glyphicon-upload m-n\"></span></button> <button type=\"button\" class=\"btn btn-icon btn-warning btn-xs\" ng-click=\"item.cancel()\" ng-disabled=\"!item.isUploading\" uib-tooltip=\"Annulla\"><span class=\"glyphicon glyphicon-ban-circle m-n\"></span></button> <button type=\"button\" class=\"btn btn-icon btn-danger btn-xs\" ng-click=\"item.remove()\" ng-disabled=\"item.isSuccess || item.isUploading\" uib-tooltip=\"Elimina\"><span class=\"glyphicon glyphicon-trash m-n\"></span></button></td></tr><tr ng-show=\"uploader.isHTML5\"><td colspan=\"5\"><div nv-file-drop=\"\" class=\"well my-drop-zone text-center wrapper-xs m-b-sm\" nv-file-over=\"\" uploader=\"uploader\">Trascina qui</div></td></tr></tbody></table><div><div>Avanzamento:<div class=\"progress\"><div class=\"progress-bar\" role=\"progressbar\" ng-style=\"{ \'width\': uploader.progress + \'%\' }\" style=\"width: 0%;\"></div></div></div><button type=\"button\" class=\"btn btn-success btn-s\" ng-click=\"uploader.uploadAll()\" ng-disabled=\"!uploader.getNotUploadedItems().length\"><span class=\"glyphicon glyphicon-upload\"></span> Carica tutti</button> <button type=\"button\" class=\"btn btn-warning btn-s\" ng-click=\"uploader.cancelAll()\" ng-disabled=\"!uploader.isUploading\" disabled=\"disabled\"><span class=\"glyphicon glyphicon-ban-circle\"></span> Annulla tutti</button><button type=\"button\" class=\"btn btn-danger btn-s\" ng-click=\"uploader.clearQueue()\" ng-disabled=\"!uploader.getNotUploadedItems().length\"><span class=\"glyphicon glyphicon-trash\"></span> Rimuovi tutti</button></div></div></div><br><div class=\"row\" ng-if=\"upload.show\"><div class=\"col col-md-12 wrapper\" ng-if=\"upload.errors\"><div class=\"alert alert-danger\"><strong>ERRORE</strong><div ng-repeat=\"error in upload.errors\">{{error}}</div></div></div><div class=\"col-md-12\"><button type=\"button\" class=\"btn btn-default btn-s\" ng-click=\"undoUpload()\" ng-disabled=\"!upload.completed\"><span class=\"fa fa-check\"></span> Chiudi</button> <button type=\"button\" class=\"btn btn-default btn-s\" ng-click=\"undoUpload()\" ng-disabled=\"upload.started\"><span class=\"fa fa-undo\"></span> Annulla</button></div></div><div ng-if=\"!upload.show\"><div ui-tree=\"treeOptions\" id=\"tree1-root\" data-drag-enabled=\"opt.dragEnabled\"><ol ui-tree-nodes=\"\" ng-model=\"nodes\" id=\"tree\"><li ng-repeat=\"node in nodes\" ui-tree-node=\"\" ng-include=\"\'tree_renderer.html\'\" data-collapsed=\"!sxExpanded\"></li></ol></div></div><script type=\"text/ng-template\" id=\"tree_renderer.html\"><!-- FILE --> <div ui-tree-handle class=\"tree-node file-node\" ng-if=\"!node.folder\" class=\"inherit-width\"> <div class=\"tree-node-content\" class=\"inherit-width\"> <span class=\"file file-title-read\" ng-click=\"stopEditing()\"> {{node.title}} </span> <span class=\"file file-title-write\" style=\"display:none;\"> <input type=\"text\" ng-model=\"node.title\" ng-keypress=\"($event.which === 13)?confirmRename(node, $event):0\"/> </span> <span class=\"file file-tag-read m-r-n\" ng-if=\"node.tag\" ng-click=\"stopEditing()\">({{node.tag.description}})</span> <span class=\"file file-tag-write m-r-n\" style=\"display:none;\"> <six-lookup-2 ng-model=\"node\" sx-field=\"\'tag\'\" sx-on-select=\"confirmTag()\" sx-base-path=\"\'record\'\" sx-type=\"sxTagModel\" sx-filter=\"tagFilter\" sx-placeholder=\"\'Tipo Allegato\'\" sx-compact=\"true\"> </six-lookup-2> </span> <a ng-if=\"!sxReadonly\" class=\"btn btn-xs m-l\" ng-click=\"editNodeTag($event)\" data-nodrag> <span class=\"glyphicon glyphicon-tag text-primary\" title=\"Imposta Tipo Allegato\" ></span> </a> <!-- pulsanti --> <a ng-if=\"fullMode && !sxReadonly\" class=\"pull-right btn btn-xs\" data-nodrag> <span class=\"glyphicon glyphicon-remove text-danger-dker remove-tree-btn\" title=\"Elimina file\" ng-confirm-message=\"Eliminare il file?\" ng-confirm-click=\"removeFile(node, this, $index)\" ng-confirm-condition=true ng-if=\"isWritePermAllowed()===true\"></span> </a> <a ng-if=\"fullMode && !sxReadonly\" class=\"pull-right btn btn-xs\" data-nodrag> <span class=\"fa fa-edit text-info-dker remove-tree-btn\" title=\"Rinomina file\" ng-click=\"renameNode($event)\"></span> </a> <a ng-if=\"!sxReadonly || sxDownloadable\" class=\"pull-right btn btn-xs\" ng-href=\"{{DOWNLOAD_URL}}{{transformObjectIdForBackend(node.object_id)}}\" target=\"_blank\" download=\"{{node.title}}\" data-nodrag> <span class=\"glyphicon glyphicon-arrow-down text-primary remove-tree-btn\" title=\"Scarica file\" ></span> </a> </div> </div> <!-- FOLDER --> <div ui-tree-handle class=\"tree-node folder-node\" ng-if=\"node.folder\"> <div class=\"tree-node-content\"> <div data-nodrag > <span ng-click=\"toggle(this)\" class=\"fa text-info-dker m-l-xs m-r-xs \" ng-class=\"{\'fa-folder\': collapsed, \'fa-folder-open\': !collapsed}\"></span> <span ng-click=\"toggle(this)\" class=\"folder\"> {{node.title}} </span> <span class=\"file file-title-write\" style=\"display:none;\"> <input type=\"text\" ng-model=\"node.title\" ng-keypress=\"($event.which === 13)?confirmRename(node, $event):0\"/> </span> <!-- pulsanti --> <span class=\"folder-buttons\" ng-if=\"!sxReadonly\"> <a class=\"btn btn-xs\" data-nodrag > <span class=\"fa fa-plus-square remove-tree-btn folder-add\" ng-click=\"newFolderNode(this)\" title=\"Crea nuova cartella\" ng-class=\"{\'text-success-dker\':hovering1}\" ng-mouseenter=\"hovering1=true\" ng-mouseleave=\"hovering1=false\"></span> </a> <a class=\"btn btn-xs\" ng-if=\"!node.readonly && fullMode\" data-nodrag> <span class=\"fa fa-trash remove-tree-btn folder-remove\" title=\"Rimuovi cartella\" ng-class=\"{\'text-warning-dker\':hovering2}\" ng-mouseenter=\"hovering2=true\" ng-mouseleave=\"hovering2=false\" ng-confirm-message=\"Eliminare la cartella e tutti i suoi file?\" ng-confirm-click=\"removeFolder(this, node, $index)\" ng-confirm-condition=true ></span> </a> <a class=\"btn btn-xs\" ng-if=\"!node.readonly\" data-nodrag> <span class=\"fa fa-edit remove-tree-btn folder-remove\" title=\"Rinomina cartella\" ng-class=\"{\'text-info-dker\':hovering4}\" ng-mouseenter=\"hovering4=true\" ng-mouseleave=\"hovering4=false\" ng-click=\"renameNode($event)\"></span> </a> <a class=\"btn btn-xs\" ng-if=\"fullMode\" data-nodrag> <span class=\"glyphicon glyphicon-remove remove-tree-btn\" title=\"Svuota cartella\" ng-class=\"{\'text-danger-dker\':hovering5}\" ng-mouseenter=\"hovering5=true\" ng-mouseleave=\"hovering5=false\" ng-confirm-message=\"Eliminare tutti i file presenti nella cartella?\" ng-confirm-click=\"emptyFolder(this, true)\" ng-confirm-condition=true></span> </a> <a class=\"btn btn-xs\" data-nodrag ng-click=\"newFileNode(this)\"> <span class=\"fa fa-plus remove-tree-btn\" title=\"Carica file\" ng-class=\"{\'text-success\':hovering3}\" ng-mouseenter=\"hovering3=true\" ng-mouseleave=\"hovering3=false\"></span> </a> </span> </div> </div> </div> <!-- TREE --> <ol ui-tree-nodes=\"\" ng-model=\"node.nodes\" ng-class=\"{hidden: collapsed}\"> <li ng-repeat=\"node in node.nodes\" ui-tree-node ng-include=\"\'tree_renderer.html\'\" data-collapsed=\"!sxExpanded\"> </li> </ol></script>");
$templateCache.put("theme/components/templates/timespanpicker.html","<div class=\"time-range row\"><div class=\"start-time col-md-2\"><form name=\"startForm\"><label for=\"startTimeInput\">Orario inizio:</label> <input type=\"time\" id=\"startTimeInput\" name=\"startTimeInput\" ng-model=\"$ctrl.local_start\" ng-change=\"$ctrl.changeTime(\'start\')\" placeholder=\"HH:mm\" required=\"\"><div role=\"alert\"><span class=\"error\" ng-show=\"$ctrl.startForm.startTimeInput.error.missingField\">Campo richiesto.</span></div></form></div><div class=\"end-time col-md-2\"><form name=\"endForm\"><label for=\"endTimeSelect\">Orario fine:</label> <input type=\"time\" id=\"endTimeInput\" name=\"endTimeInput\" ng-model=\"$ctrl.local_end\" ng-change=\"$ctrl.changeTime(\'end\')\" placeholder=\"HH:mm\" required=\"\"><div role=\"alert\"><span class=\"error\" ng-show=\"$ctrl.endForm.endTimeInput.error.missingField\">Campo richiesto.</span></div></form></div><div class=\"errors col-md-8\"><span class=\"error\" ng-show=\"$ctrl.endForm.endTimeInput.error.time || $ctrl.startForm.startTimeInput.error.time\">Correggere gli orari inseriti!</span></div></div>");
$templateCache.put("theme/directives/templates/sixlookup2.html","<style type=\"text/css\">\n  body > .ui-select-bootstrap.open {\n      z-index: 100000;\n  }\n\n  .no-grey {\n    background-color: #fff !important;\n  }\n\n  .adapt-margin-content {\n    margin-right: 0px;\n    margin-left: 0px;\n  }\n\n  .form-group {\n    margin-bottom: 0px;\n  }\n\n  .align-content {\n    text-align: right;\n  }\n\n  .help-block {\n    margin-bottom: 0px;\n  }\n\n  .custom-elem {\n    padding: 3px 5px 3px 5px;\n    display: block;\n    overflow: hidden;\n  }\n\n  .custom-elem:hover {\n    color: #212121;\n    background-color: #e0e0e0;\n  }\n\n  .custom-elem span {\n    min-width: 25px;\n    display: block;\n    overflow: hidden;\n    -webkit-transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);\n    -o-transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);\n    transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);\n  }\n\n  .custom-elem span i {\n    text-align: center;\n  }\n\n  .custom-elem span:hover {\n    cursor: pointer;\n  }\n\n  .custom-elem .custom-code {\n    display: inline;\n  }\n\n  .sixlookup-item-selected:before {\n    content: \"\\f00c\";\n    font-family: FontAwesome;\n    font-style: normal;\n    font-weight: normal;\n    text-decoration: inherit;\n    float: left;\n    /*--adjust as necessary--*/\n    color: #000;\n    /*font-size: 18px;*/\n    padding: 0em 0.5em;\n    /*position: absolute;*/\n    /*top: 10px;*/\n    /*left: 0;*/\n  }\n\n  .sixlookup-item-selected {\n    background-color: #11c7f5 !important;\n    color: #FFFFFF;\n  }\n\n  .sixlookup-value {\n    width: 100%;\n    overflow: hidden;\n    display: inline-block;\n    text-overflow: ellipsis;\n  }\n\n  .form-control > .host {\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n\n  .form-control > .host > .tags {\n    border: 0px;\n    box-shadow: none;\n  }\n\n  .toggle-node {\n    min-width: 45px;\n  }\n\n  ol ol {\n    /* Per ridurre i margini di ol innestati */\n    margin-left: -19px;\n  }\n\n  tags-input.form-control.sixLookup2-multi-compact{\n    height: auto !important;\n  }\n\n  tags-input.form-control.sixLookup2-multi{\n    height: inherit !important;\n    overflow: hidden !important;\n\n  }\n\n  tags-input.form-control.sixLookup2-multi .tags input{\n    margin-right: 10%;\n    background: none !important;\n    position: absolute;\n  }\n\n  tags-input.sixLookup2-multi ul.tag-list li a.remove-button{\n    bottom: 32%;\n    position: relative;\n  }\n\n  tags-input.sixLookup2-multi ul.tag-list li span.sxtag-text{\n    text-decoration: none;\n    text-overflow: ellipsis;\n    display: inline-block;\n    overflow: hidden;\n    white-space: nowrap;\n    width: 85px;\n  }\n</style><script type=\"text/ng-template\" id=\"treenode_renderer.html\"><div class=\"btn btn-xs pull-left toggle-node\" ng-click=\"toggleNode(node)\"> <span class=\"text-info-dker pull-right m-l-xs model-icon\" title=\"{{node.type}}\" data-placement=\"top\" data-original-title=\"{{node.type}}\" tooltip><i ng-class=\"getModelIcon(node.type)\"></i></span> <span class=\"fa fa-fw\" ng-class=\"{\'fa-plus\': node.collapsed, \'fa-minus\': !node.collapsed}\" ng-if=\"node.hasChilds || node.nodes.length>0\"></span> <span class=\"fa fa-fw\" ng-if=\"!node.hasChilds && node.nodes.length<=0\"></span> <!-- per allineare le icone se manca il +/- --> </div> <span class=\"custom-elem\"> <span class=\"pull-right\" ng-if=\"checkable(node)\" ng-click=\"toggleSelect(node)\"> <i class=\"fa\" ng-class=\"{\'fa-check-square-o\': isItemSelected(node), \'fa-square-o\': !isItemSelected(node)}\"></i> </span> <span class=\"pull-right text-center\" ng-click=\"viewItemDetails(node)\" title=\"Dettagli\" six-sidebar-autoclose=\"false\" ng-if=\"detailsTabEnabled() && node.type==sxType\"> <i class=\"fa fa-info\"></i> </span> <span title=\"{{node | reference}}\" six-sidebar-autoclose=\"true\" ng-class=\"{\'sixlookup-item-selected\': isItemSelected(node)}\"> <span ng-if=\"!sxItemTemplate && !sxItemTemplateUrl\">{{node | reference : 50}}</span> <ng-include ng-if=\"!sxItemTemplate && sxItemTemplateUrl\" src=\"sxItemTemplateUrl\"></ng-include> <span ng-if=\"sxItemTemplate\" ng-bind-html=\"evaluateTemplate(sxItemTemplate, node)\"></span> </span> </span> <ol ng-model=\"node.nodes\" ng-class=\"{hidden: node.collapsed}\"> <li ng-repeat=\"node in node.nodes track by node.UUID\" ng-include=\"\'treenode_renderer.html\'\" /> </ol></script><six-sidebar sx-id=\"{{sxId}}_sb\" class=\"sixlookup2\" sx-position=\"{{sxPosition}}\" sx-title=\"sxTitle || sxType\" sx-dimension=\"{{sxDimension}}\" sx-opened=\"sxVisible\" sx-pinnable=\"sxPinnable\" sx-pinned=\"sxPinned\"><div class=\"nav-tabs-alt\"><ul class=\"nav nav-tabs\" style=\"margin: 0px;\" role=\"tablist\" id=\"{{sxId}}_lk-tab-headers\"><li id=\"{{sxId}}_tab-s-filters\" ng-if=\"filtersTabEnabled()\"><a data-target=\"#{{sxId}}_tab-filters\" role=\"tab\" data-toggle=\"tab\" class=\"text-md text-muted\"><span title=\"Filtri\" data-placement=\"top\" data-original-title=\"Filtri\" tooltip=\"\"><i class=\"fa fa-filter m-l-xs\"></i></span></a></li><li id=\"{{sxId}}_tab-s-list\" ng-if=\"listTabEnabled()\" ng-class=\"{\'active\': isActiveTab(\'list\')}\"><a data-target=\"#{{sxId}}_tab-list\" role=\"tab\" data-toggle=\"tab\" class=\"text-md text-muted\"><span title=\"Lista\" data-placement=\"top\" data-original-title=\"Lista\" tooltip=\"\"><i class=\"fa fa-list m-l-xs\"></i></span></a></li><li id=\"{{sxId}}_tab-s-tree\" ng-if=\"treeTabEnabled()\" ng-class=\"{\'active\': isActiveTab(\'tree\')}\"><a data-target=\"#{{sxId}}_tab-tree\" role=\"tab\" data-toggle=\"tab\" class=\"text-md text-muted\"><span title=\"Tree\" data-placement=\"top\" data-original-title=\"Tree\" tooltip=\"\"><i class=\"fa fa-sitemap m-l-xs\"></i></span></a></li><li id=\"{{sxId}}_tab-s-details\" ng-if=\"detailsTabEnabled()\"><a data-target=\"#{{sxId}}_tab-details\" role=\"tab\" data-toggle=\"tab\" class=\"text-md text-muted\"><span title=\"Dettagli\" data-placement=\"top\" data-original-title=\"Dettagli\" tooltip=\"\"><i class=\"fa fa-info m-l-xs\"></i></span></a></li><li class=\"pull-right\" ng-if=\"sxAdd==true\"><a class=\"text-md\" ng-click=\"addNewRecord(true)\" title=\"Aggiungi\" ng-if=\"vars.insertMode==false\"><span><i class=\"fa fa-plus-circle m-l-xs\"></i></span></a> <a class=\"text-md\" ng-click=\"undoNewRecord(true)\" title=\"Annulla\" ng-if=\"vars.insertMode==true\"><span><i class=\"fa fa-undo m-l-xs\"></i></span></a></li></ul></div><div class=\"tab-content\"><div role=\"tabpanel\" id=\"{{sxId}}_tab-filters\" class=\"tab-pane\" ng-if=\"filtersTabEnabled()\"><div ng-if=\"vars.schemaLoaded == true\"><label class=\"i-checks m-l-sm\"><input type=\"checkbox\" ng-model=\"bools.currentcommission\" ng-change=\"updateLookupFilter()\"><i></i> <span class=\"i-checks\">Visualizza dati per la commessa corrente</span></label> <label class=\"i-checks m-l-sm\"><input type=\"checkbox\" ng-model=\"bools.crossCommission\" ng-change=\"updateLookupFilter()\"><i></i> <span class=\"i-checks\">Visualizza dati cross-commessa</span></label><six-search-filters sx-filter=\"searchFilterObj\" sx-filter-init=\"searchFilterArray\" sx-id=\"{{sxId}}_tab-filters-f\" sx-open=\"sxSearchTerms.open\" sx-filter-only=\"true\" sx-on-filter-changed=\"onFilterChanged()\" sx-model=\"sxSearchTerms\"></six-search-filters></div><div ng-if=\"vars.schemaLoaded == false\"><div class=\"row wrapper adapt-margin-content\">Dati non disponibili</div></div></div><div role=\"tabpanel\" id=\"{{sxId}}_tab-list\" class=\"tab-pane\" ng-class=\"{\'active\': isActiveTab(\'list\')}\" ng-if=\"listTabEnabled()\"><ul class=\"nav list-sidebar-nav\"><div class=\"row wrapper adapt-margin-content\" ng-if=\"!sxType && list.length == 0\"><a>Nessun tipo di asset impostato</a></div><span ng-if=\"sxType || (!sxType && list.length > 0)\"><li><div class=\"form-group m-l-xs m-r-xs\"><div class=\"input-group has-button\" style=\"width: 100%\"><input id=\"{{sxId}}-filter\" type=\"search\" class=\"form-control\" placeholder=\"Filtra...\" ng-model=\"filter.text\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-bg btn-default\" ng-click=\"clearSearchFn()\"><i class=\"fa fa-times\"></i></button></span></div></div></li><li ng-if=\"!vars.listLoaded\"><div style=\"text-align: center\"><i class=\"fa fa-spinner fa-2x fa-pulse fa-fw text-info-dker\" aria-hidden=\"true\"></i></div></li><span ng-if=\"vars.listLoaded\"><li class=\"row wrapper adapt-margin-content\" ng-if=\"!list || list.length == 0\"><a>Nessun {{sxType}} disponibile</a></li><li ng-repeat=\"item in list\"><span class=\"custom-elem\"><span class=\"pull-right text-center b-l b-r\" ng-click=\"viewItemDetails(item)\" title=\"Dettagli\" six-sidebar-autoclose=\"false\" ng-if=\"detailsTabEnabled()\"><i class=\"fa fa-info\"></i></span> <span ng-click=\"toggleSelect(item)\" title=\"{{item | reference}}\" six-sidebar-autoclose=\"true\" ng-class=\"{\'sixlookup-item-selected\': isItemSelected(item)}\"><span ng-if=\"sxListItemTemplate\" ng-bind-html=\"evaluateTemplate(sxListItemTemplate, item)\"></span> <span ng-if=\"!sxListItemTemplate\"><span ng-if=\"!sxItemTemplate && !sxItemTemplateUrl\">{{item | reference : 50}}</span><ng-include ng-if=\"!sxItemTemplate && sxItemTemplateUrl\" src=\"sxItemTemplateUrl\"></ng-include><span ng-if=\"sxItemTemplate\" ng-bind-html=\"evaluateTemplate(sxItemTemplate, item)\"></span></span></span></span></li></span></span></ul><div class=\"m-t\" style=\"text-align: center\"><div class=\"text-muted\">{{start}} - {{end}} di {{vars.totalItems}}</div><uib-pagination total-items=\"vars.totalItems\" ng-model=\"vars.page\" items-per-page=\"50\" max-size=\"5\" boundary-links=\"true\" class=\"pagination-sm\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></uib-pagination></div></div><div role=\"tabpanel\" id=\"{{sxId}}_tab-tree\" class=\"tab-pane\" ng-class=\"{\'active\': isActiveTab(\'tree\')}\" ng-if=\"treeTabEnabled()\"><ol class=\"nav list-sidebar-nav\"><div class=\"row wrapper adapt-margin-content\" ng-if=\"!sxType && tree.nodes.length == 0\"><a>Nessun tipo di asset impostato</a></div><span ng-if=\"sxType || (!sxType && tree.nodes.length > 0)\"><li><div class=\"form-group m-l-xs m-r-xs\"><div class=\"input-group has-button\" style=\"width: 100%\"><input id=\"{{sxId}}-filter-tree\" type=\"search\" class=\"form-control\" placeholder=\"Filtra...\" ng-model=\"filter.text\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-bg btn-default\" ng-click=\"clearSearchFn()\"><i class=\"fa fa-times\"></i></button></span></div></div></li><li ng-if=\"!vars.treeLoaded\"><div style=\"text-align: center\"><i class=\"fa fa-spinner fa-2x fa-pulse fa-fw text-info-dker\" aria-hidden=\"true\"></i></div></li><span ng-if=\"vars.treeLoaded\"><li class=\"row wrapper adapt-margin-content\" ng-if=\"!tree || !tree.nodes || tree.nodes.length == 0\"><a>Nessun {{sxType}} disponibile nella struttura ad albero</a></li><li ng-repeat=\"node in tree.nodes\" ng-include=\"\'treenode_renderer.html\'\"></li></span></span></ol></div><div role=\"tabpanel\" id=\"{{sxId}}_tab-details\" class=\"tab-pane\" ng-if=\"detailsTabEnabled()\"><div ng-if=\"vars.schemaLoaded == true && (vars.insertMode == true || fullTmpObj.UUID)\"><div class=\"row wrapper adapt-margin-content align-content\" ng-if=\"vars.insertMode == true\"><span class=\"pull-left form-group\"><input type=\"checkbox\" id=\"commission_dependent\" ng-model=\"vars.commissionDependent\" name=\"commission_dependent\"> <label id=\"schema_commission_key\" for=\"commission_dependent\" class=\"control-label\">Relativo a commessa</label></span> <a ng-click=\"updateRecord()\" class=\"btn btn-success btn-sm\" id=\"btn_item_create\"><i class=\"fa fa-floppy-o\"></i> Salva</a></div><div class=\"m-r pull-right\" ng-if=\"vars.insertMode == false\"><a href=\"{{getDetailUrl(fullTmpObj)}}\" ng-if=\"getDetailUrl(fullTmpObj)\" title=\"Pagina di dettaglio\" class=\"btn btn-info btn-xs m-r\"><i class=\"fa fa-external-link\"></i></a> <a ng-click=\"select(fullTmpObj)\" class=\"btn btn-success btn-xs\" title=\"Seleziona\" id=\"btn_item_select\"><i class=\"fa fa-check\"></i> Seleziona</a></div><div class=\"row wrapper adapt-margin-content\"><div sf-schema=\"vars.schema\" sf-form=\"vars.form\" sf-model=\"fullTmpObj.model\" update-six-formula=\"\" lookup-in-lookup=\"\"></div></div></div><div ng-if=\"vars.schemaLoaded == false || (vars.insertMode == false && !fullTmpObj.UUID)\"><div class=\"row wrapper adapt-margin-content\">Dati non disponibili</div></div></div></div></six-sidebar><script type=\"text/ng-template\" id=\"lookup-custom-template\"><span title=\"{{data | reference}}\"> <small ng-bind-html=\"$highlight($getDisplayText())\"></small> - <small ng-bind-html=\"$highlight(data.description)\"></small> </span></script><script type=\"text/ng-template\" id=\"lookup-tag-template\"><span title=\"{{data | reference}}\"> <span class=\"sxtag-text\" ng-bind=\"$getDisplayText()\"></span> <a class=\"remove-button\" ng-click=\"$removeTag()\" ng-bind=\"::$$removeTagSymbol\"></a> </span></script><div class=\"input-group has-button form-control\" style=\"width: 100%; padding: 0; border: none\" ng-class=\"{\'has-error ng-invalid\': ngInvalid, \'has-success\': ngValid}\" ng-if=\"!sxCompact\"><input id=\"{{sxId}}_div\" name=\"{{sxId}}\" type=\"text\" class=\"form-control no-grey sixlookup-value\" title=\"{{ngModel[sxField] | reference}}\" ng-model=\"valueToShow\" placeholder=\"{{placeholder}}\" ng-click=\"onFocusItCB()\" readonly=\"\" ng-required=\"sxRequired\" ng-if=\"!isMultiple()\"><tags-input id=\"{{sxId}}_2_ti\" name=\"{{sxId}}\" class=\"form-control bootstrap sixLookup2-multi sixLookup2-disable-input\" style=\"width: 100%; padding: 0px !important;\" placeholder=\"{{placeholder}}\" ng-model=\"ngModel[sxField]\" template=\"lookup-tag-template\" display-property=\"description\" key-property=\"UUID\" min-length=\"1\" ng-click=\"onFocusItCB()\" ng-if=\"isMultiple()\" add-from-autocomplete-only=\"true\" ng-disabled=\"sxDisabled\" ng-required=\"sxRequired\"><span ng-if=\"ngModel[sxField].length\" class=\"badge item-count\" style=\"position: absolute; top: 7px; right: 10px;\">{{ngModel[sxField].length}}</span><auto-complete source=\"list | filter: $query\" template=\"lookup-custom-template\" add-from-autocomplete-only=\"true\" min-length=\"3\"></auto-complete></tags-input><span class=\"input-group-btn\" style=\"vertical-align: top\"><a class=\"btn btn-bg btn-default\" ng-click=\"clearSelect()\" six-sidebar-autoclose=\"true\" ng-disabled=\"sxDisabled\"><i class=\"fa fa-times fa-fw\"></i></a> <a class=\"btn btn-bg btn-default\" ng-click=\"goToRecord($event);\" six-sidebar-autoclose=\"true\" ng-if=\"sxShowLinkToDetail\"><i class=\"fa fa-external-link fa-fw\"></i></a> <span id=\"{{sxId}}-transclude\" ng-transclude=\"\"></span></span></div><div class=\"input-group has-button form-control\" style=\"width: 100%; padding: 0; border: none\" ng-class=\"{\'has-error ng-invalid\': ngInvalid, \'has-success\': ngValid}\" ng-if=\"sxCompact\"><ui-select ng-model=\"ngModel\" theme=\"bootstrap\" on-select=\"select($item);item=$item\" ng-disabled=\"sxDisabled\" reset-search-input=\"false\" ng-if=\"!isMultiple()\" append-to-body=\"true\"><ui-select-match class=\"ui-select-match\" placeholder=\"{{placeholder}}\"><input id=\"{{sxId}}_2_it\" name=\"{{sxId}}\" type=\"text\" class=\"ui-select-focusser ui-select-offscreen\" ng-model=\"valueToShow\" ng-required=\"sxRequired\"><span ng-bind-html=\"valueToShow\" ng-if=\"!sxItemTemplateUrl\"></span><ng-include src=\"sxItemTemplateUrl\" ng-if=\"sxItemTemplateUrl\"></ng-include></ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in list track by $index\" refresh=\"getListForTags($select.search)\" refresh-delay=\"0\"><span ng-if=\"!sxItemTemplate && !sxItemTemplateUrl\"><span ng-bind-html=\"item.code | highlight: $select.search\"></span> - <span ng-bind-html=\"item.description | highlight: $select.search\"></span></span><ng-include ng-if=\"!sxItemTemplate && sxItemTemplateUrl\" src=\"sxItemTemplateUrl\"></ng-include><span ng-if=\"sxItemTemplate\" ng-bind-html=\"evaluateTemplate(sxItemTemplate, item) | highlight: $select.search\"></span></ui-select-choices></ui-select><tags-input id=\"{{sxId}}_2_ti\" name=\"{{sxId}}\" class=\"form-control bootstrap sixLookup2-multi-compact\" style=\"width: 100%; padding: 0px !important;\" placeholder=\"{{placeholder}}\" ng-model=\"ngModel[sxField]\" template=\"lookup-tag-template\" display-property=\"description\" key-property=\"UUID\" min-length=\"1\" ng-if=\"isMultiple()\" add-from-autocomplete-only=\"true\" ng-disabled=\"sxDisabled\" ng-required=\"sxRequired\"><span ng-if=\"ngModel[sxField].length\" class=\"badge item-count\" style=\"position: absolute; top: 7px; right: 10px;\">{{ngModel[sxField].length}}</span><auto-complete source=\"getListForTags($query)\" template=\"lookup-custom-template\" load-on-focus=\"true\" load-on-empty=\"true\" load-on-down-arrow=\"true\" add-from-autocomplete-only=\"true\" min-length=\"0\"></auto-complete></tags-input><span class=\"input-group-btn\"><a class=\"btn btn-bg btn-default\" ng-click=\"clearSelect()\" ng-disabled=\"sxDisabled\"><i class=\"fa fa-times fa-fw\"></i></a> <a class=\"btn btn-bg btn-default\" ng-click=\"goToRecord($event);\" six-sidebar-autoclose=\"true\" ng-if=\"sxShowLinkToDetail\"><i class=\"fa fa-external-link fa-fw\"></i></a></span></div>");
$templateCache.put("theme/directives/templates/sixsearchform.html","<div class=\"input-group has-button\" style=\"width: 100%\" ng-class=\"{\'has-error\': isValid==false}\"><input type=\"search\" class=\"form-control\" placeholder=\"{{placeholder}}\" ng-model=\"ngModel\" ng-keyup=\"keyupFn($event)\" ng-change=\"changeFn()\"> <span class=\"input-group-btn\" ng-if=\"showClearBtn || showSearchBtn\"><button type=\"button\" class=\"btn btn-bg btn-default\" ng-click=\"clearSearchFn()\" ng-show=\"showClearBtn\"><i class=\"fa fa-times\"></i></button> <button class=\"btn btn-bg btn-default\" type=\"button\" ng-click=\"searchFn()\" ng-show=\"showSearchBtn\"><i class=\"fa fa-search\"></i></button></span></div>");
$templateCache.put("theme/directives/templates/sixselect2.html","<style type=\"text/css\">\n  .no-grey {\n    background-color: #fff !important;\n  }\n\n  .adapt-margin-content {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  .form-group {\n    margin-bottom: 0;\n  }\n\n  .align-content {\n    text-align: right;\n  }\n\n  .help-block {\n    margin-bottom: 0;\n  }\n\n  .custom-elem {\n    padding: 3px 5px 3px 5px;\n    display: block;\n    overflow: hidden;\n  }\n\n  .custom-elem:hover {\n    color: #212121;\n    background-color: #e0e0e0;\n  }\n\n  .custom-elem span {\n    min-width: 25px;\n    display: block;\n    overflow: hidden;\n    -webkit-transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);\n    -o-transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);\n    transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);\n  }\n\n  .custom-elem span i {\n    text-align: center;\n  }\n\n  .custom-elem span:hover {\n    cursor: pointer;\n  }\n\n  .sixlookup-item-selected:before {\n    content: \"\\f00c\";\n    font-family: FontAwesome;\n    font-style: normal;\n    font-weight: normal;\n    text-decoration: inherit;\n    /*--adjust as necessary--*/\n    color: #000;\n    /*font-size: 18px;*/\n    padding: 0 0.5em;\n    /*position: absolute;*/\n    /*top: 10px;*/\n    /*left: 0;*/\n  }\n\n  .sixlookup-item-selected {\n    background-color: #11c7f5 !important;\n    color: #FFFFFF;\n  }\n\n  .form-control > .host {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n\n  .form-control > .host > .tags {\n    border: 0;\n    box-shadow: none;\n  }\n\n  tags-input.form-control.sixSelect2-multi{\n    height: inherit !important;\n    overflow: hidden !important;\n\n  }\n\n  tags-input.form-control.sixSelect2-multi .tags input{\n    margin-right: 10%;\n    background: none !important;\n    position: absolute;\n  }\n\n  tags-input.sixSelect2-multi ul.tag-list li a.remove-button{\n    bottom: 32%;\n    position: relative;\n  }\n\n  tags-input.sixSelect2-multi ul.tag-list li span.sxtag-text{\n    text-decoration: none;\n    text-overflow: ellipsis;\n    display: inline-block;\n    overflow: hidden;\n    white-space: nowrap;\n    width: 85px;\n  }\n\n</style><six-sidebar sx-id=\"{{sxId}}_sb\" class=\"sixlookup2\" sx-position=\"{{sxPosition}}\" sx-title=\"sxTitle || sxType\" sx-dimension=\"{{sxDimension}}\" sx-opened=\"sxVisible\" sx-pinnable=\"sxPinnable\" sx-pinned=\"sxPinned\"><ul class=\"nav list-sidebar-nav\"><li class=\"row wrapper adapt-margin-content\" ng-if=\"!sxList || sxList.length == 0\"><span ng-if=\"sxType\"><a>Nessun {{sxType}} caricato</a></span> <span ng-if=\"!sxType\"><a>Nessun tipo di asset impostato</a></span></li><li ng-if=\"sxList && sxList.length > 0\"><div class=\"form-group m-l-xs m-r-xs\"><div class=\"input-group has-button\" style=\"width: 100%\"><input id=\"{{sxId}}-filter\" type=\"search\" class=\"form-control\" placeholder=\"Filtra...\" ng-model=\"filter.text\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-bg btn-default\" ng-click=\"clearSearchFn()\"><i class=\"fa fa-times\"></i></button></span></div><div class=\"m-t-xs m-b-xs input-group-btn\" ng-if=\"isMultiple()\"><a class=\"btn btn-success btn-sm\" title=\"Seleziona tutti\" style=\"width: 50%; display: inline-block;\" ng-click=\"selectAll()\"><i class=\"fa fa-check-square-o\"></i> Seleziona tutti</a> <a class=\"btn btn-danger btn-sm\" title=\"Deseleziona tutti\" style=\"width: 50%; display: inline-block;\" ng-click=\"unselectAll()\"><i class=\"fa fa-square-o\"></i> Deseleziona tutti</a></div></div></li><li ng-repeat=\"item in sxList | filter:filter.text track by $index\" ng-if=\"sxList && sxList.length > 0\"><span class=\"custom-elem\"><span ng-click=\"toggleSelect(item)\" title=\"{{item[sxKey]}} - {{item[sxDescription]}}\" six-sidebar-autoclose=\"true\" ng-class=\"{\'sixlookup-item-selected\': isItemSelected(item)}\"><span ng-if=\"!sxItemTemplate && !sxItemTemplateUrl\">{{item[sxKey]}} - {{item[sxDescription] | cut:true:50:\'...\'}}</span><ng-include ng-if=\"!sxItemTemplate && sxItemTemplateUrl\" src=\"sxItemTemplateUrl\"></ng-include><span ng-if=\"sxItemTemplate\" ng-bind-html=\"evaluateTemplate(sxItemTemplate, item)\"></span></span></span></li></ul></six-sidebar><script type=\"text/ng-template\" id=\"select-custom-template\"><span title=\"{{data[$parent.$parent.options.keyProperty]}} - {{data[$parent.$parent.options.displayProperty]}}\"> <small ng-bind-html=\"$highlight($getDisplayText())\"></small> - <small ng-bind-html=\"$highlight(data[sxDescription])\"></small> </span></script><script type=\"text/ng-template\" id=\"select-tag-template\"><span title=\"{{data[$parent.$parent.options.keyProperty]}} - {{data[$parent.$parent.options.displayProperty]}}\"> <span class=\"sxtag-text\" >{{data[$parent.$parent.options.displayProperty] }}</span> <a class=\"remove-button\" ng-click=\"$removeTag()\" ng-bind=\"::$$removeTagSymbol\"></a> </span></script><div class=\"input-group has-button form-control\" style=\"width: 100%; padding: 0; border: none\" ng-if=\"!sxCompact\"><input id=\"{{sxId}}_it\" name=\"{{sxId}}\" type=\"text\" class=\"form-control no-grey\" ng-model=\"valueToShow\" placeholder=\"{{placeholder}}\" ng-click=\"onFocusItCB()\" readonly=\"\" ng-if=\"!isMultiple()\" ng-disabled=\"sxDisabled\" ng-required=\"sxRequired\"><tags-input id=\"{{sxId}}_2_it\" name=\"{{sxId}}\" class=\"form-control bootstrap sixSelect2-multi sixSelect2-disable-input\" style=\"width: 100%; padding: 0 !important;\" placeholder=\"{{placeholder}}\" ng-model=\"ngModel[sxField]\" template=\"select-tag-template\" tag-class=\"{tagOther: canShow($index, this)}\" ng-required=\"sxRequired\" display-property=\"{{sxDescription}}\" key-property=\"{{sxKey}}\" ng-click=\"onFocusItCB()\" ng-if=\"isMultiple()\" add-from-autocomplete-only=\"true\" ng-disabled=\"sxDisabled\"><span ng-if=\"ngModel[sxField].length\" class=\"badge item-count\">{{ngModel[sxField].length}}</span><auto-complete source=\"sxList | filter: $query\" template=\"select-custom-template\" add-from-autocomplete-only=\"true\" min-length=\"3\"></auto-complete></tags-input><span class=\"input-group-btn\" style=\"vertical-align: top\"><a class=\"btn btn-bg btn-default\" ng-click=\"clearSelect()\" six-sidebar-autoclose=\"true\" ng-if=\"sxClearable\" ng-disabled=\"sxDisabled\"><i class=\"fa fa-times\"></i></a> <span id=\"{{sxId}}-transclude\" ng-transclude=\"\"></span></span></div><div class=\"input-group has-button form-control\" style=\"width: 100%; padding: 0; border: none\" ng-if=\"sxCompact\"><ui-select id=\"{{sxId}}_2_us\" ng-model=\"ngModel\" theme=\"bootstrap\" on-select=\"select($item);item=$item\" ng-disabled=\"sxDisabled\" reset-search-input=\"false\" ng-click=\"onClick()\" ng-if=\"!isMultiple()\"><ui-select-match class=\"ui-select-match\" placeholder=\"{{form.placeholder}}\"><input id=\"{{sxId}}_2_it\" name=\"{{sxId}}\" type=\"text\" class=\"ui-select-focusser ui-select-offscreen\" ng-model=\"valueToShow\" ng-required=\"sxRequired\"><span ng-bind-html=\"valueToShow\" ng-if=\"!sxItemTemplateUrl\"></span><ng-include src=\"sxItemTemplateUrl\" ng-if=\"sxItemTemplateUrl\"></ng-include></ui-select-match><ui-select-choices class=\"ui-select-choices\" repeat=\"item in sxList | filter: $select.search track by $index\" refresh-delay=\"0\"><span ng-if=\"!sxItemTemplate && !sxItemTemplateUrl\"><span ng-bind-html=\"item[sxKey] | highlight: $select.search\"></span> - <span ng-bind-html=\"item[sxDescription] | highlight: $select.search\"></span></span><ng-include ng-if=\"!sxItemTemplate && sxItemTemplateUrl\" src=\"sxItemTemplateUrl\"></ng-include><span ng-if=\"sxItemTemplate\" ng-bind-html=\"evaluateTemplate(sxItemTemplate, item) | highlight: $select.search\"></span></ui-select-choices></ui-select><tags-input id=\"{{sxId}}_2_it\" name=\"{{sxId}}\" class=\"form-control bootstrap sixSelect2-multi-compact\" style=\"width: 100%; padding: 0px !important;\" placeholder=\"{{placeholder}}\" ng-model=\"ngModel[sxField]\" template=\"select-tag-template\" display-property=\"{{sxDescription}}\" key-property=\"{{sxKey}}\" min-length=\"1\" ng-if=\"isMultiple()\" ng-click=\"onClick()\" add-from-autocomplete-only=\"true\" ng-disabled=\"sxDisabled\" ng-required=\"sxRequired\" on-tag-removed=\"unselect($tag)\" on-tag-added=\"select($tag)\"><span ng-if=\"ngModel[sxField].length\" class=\"badge item-count\" style=\"position: absolute; top: 7px; right: 10px;\">{{ngModel[sxField].length}}</span><auto-complete source=\"sxList | filter: $query\" template=\"select-custom-template\" load-on-focus=\"true\" load-on-empty=\"false\" load-on-down-arrow=\"true\" add-from-autocomplete-only=\"true\" min-length=\"0\"></auto-complete></tags-input><span class=\"input-group-btn\"><a class=\"btn btn-bg btn-default\" ng-click=\"clearSelect()\" ng-if=\"sxClearable\" ng-disabled=\"sxDisabled\"><i class=\"fa fa-times\"></i></a></span></div>");
$templateCache.put("theme/directives/templates/sixsidebar.html","<style type=\"text/css\">\n  .six-sidebar-header {\n    color: #dcf2f8;\n    background-color: #23b7e5;\n    padding: 10px 15px;\n    border-bottom: 1px solid transparent;\n    border-radius: 2px 2px 0 0;\n  }\n  .sidebar-pinned {\n    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);\n    -webkit-box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);\n  }\n\n  .sidebar-s-left.open,\n  .sidebar-m-left.open,\n  .sidebar-l-left.open,\n  .sidebar-xl-left.open,\n  .sidebar-xxl-left.open,\n  .sidebar-50-left.open,\n  .sidebar-60-left.open,\n  .sidebar-70-left.open,\n  .sidebar-80-left.open,\n  .sidebar-90-left.open,\n  .sidebar-100-left.open {\n    left: 200px;\n  }\n\n  .app.app-aside-folded .sidebar-s-left.open,\n  .app.app-aside-folded .sidebar-m-left.open,\n  .app.app-aside-folded .sidebar-l-left.open,\n  .app.app-aside-folded .sidebar-xl-left.open,\n  .app.app-aside-folded .sidebar-xxl-left.open,\n  .app.app-aside-folded .sidebar-50-left.open,\n  .app.app-aside-folded .sidebar-60-left.open,\n  .app.app-aside-folded .sidebar-70-left.open,\n  .app.app-aside-folded .sidebar-80-left.open,\n  .app.app-aside-folded .sidebar-90-left.open,\n  .app.app-aside-folded .sidebar-100-left.open {\n    left: 60px;\n  }\n\n  .sidebar-s-left.open,\n  .sidebar-s-right.open {\n    min-width: 180px;\n    width: 180px;\n  }\n\n  .sidebar-m-left.open,\n  .sidebar-m-right.open {\n    min-width: 280px;\n    width: 280px;\n  }\n  .sidebar-l-left.open,\n  .sidebar-l-right.open {\n    min-width: 370px;\n    width: 370px;\n  }\n  .sidebar-xl-left.open,\n  .sidebar-xl-right.open {\n    min-width: 460px;\n    width: 460px;\n  }\n  .sidebar-xxl-left.open,\n  .sidebar-xxl-right.open {\n    min-width: 550px;\n    width: 550px;\n  }\n  .sidebar-50-left.open,\n  .sidebar-50-right.open {\n    min-width: 50%;\n    width: 50%;\n  }\n  .sidebar-60-left.open,\n  .sidebar-60-right.open {\n    min-width: 60%;\n    width: 60%;\n  }\n  .sidebar-70-left.open,\n  .sidebar-70-right.open {\n    min-width: 70%;\n    width: 70%;\n  }\n  .sidebar-80-left.open,\n  .sidebar-80-right.open {\n    min-width: 80%;\n    width: 80%;\n  }\n  .sidebar-90-left.open,\n  .sidebar-90-right.open {\n    min-width: 90%;\n    width: 90%;\n  }\n  .sidebar-100-left.open,\n  .sidebar-100-right.open {\n    min-width: 100%;\n    width: 100%;\n  }\n  .sidebar-s-left.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-s-left-padded {\n    padding: 0px 0px 0px 0px;\n    margin-left: 180px;\n  }\n  .sidebar-s-right.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-s-right-padded {\n    padding: 0px 0px 0px 0px;\n    margin-right: 180px;\n  }\n  .sidebar-m-left.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-m-left-padded {\n    padding: 0px 0px 0px 0px;\n    margin-left: 280px;\n  }\n  .sidebar-m-right.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-m-right-padded {\n    padding: 0px 0px 0px 0px;\n    margin-right: 280px;\n  }\n  .sidebar-l-left.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-l-left-padded {\n    padding: 0px 0px 0px 0px;\n    margin-left: 370px;\n  }\n  .sidebar-l-right.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-l-right-padded {\n    padding: 0px 0px 0px 0px;\n    margin-right: 370px;\n  }\n  .sidebar-xl-left.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-xl-left-padded {\n    padding: 0px 0px 0px 0px;\n    margin-left: 460px;\n  }\n  .sidebar-xl-right.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-xl-right-padded {\n    padding: 0px 0px 0px 0px;\n    margin-right: 460px;\n  }\n  .sidebar-xxl-left.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-xxl-left-padded {\n    padding: 0px 0px 0px 0px;\n    margin-left: 550px;\n  }\n  .sidebar-xxl-right.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-xxl-right-padded {\n    padding: 0px 0px 0px 0px;\n    margin-right: 550px;\n  }\n  .sidebar-50-left.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-50-left-padded {\n    padding: 0px 0px 0px 0px;\n    margin-left: 55%;\n  }\n  .sidebar-50-right.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-50-right-padded {\n    padding: 0px 0px 0px 0px;\n    margin-right: 55%;\n  }\n  .sidebar-60-left.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-60-left-padded {\n    padding: 0px 0px 0px 0px;\n    margin-left: 65%;\n  }\n  .sidebar-60-right.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-60-right-padded {\n    padding: 0px 0px 0px 0px;\n    margin-right: 65%;\n  }\n  .sidebar-70-left.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-70-left-padded {\n    padding: 0px 0px 0px 0px;\n    margin-left: 75%;\n  }\n  .sidebar-70-right.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-70-right-padded {\n    padding: 0px 0px 0px 0px;\n    margin-right: 75%;\n  }\n  .sidebar-80-left.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-80-left-padded {\n    padding: 0px 0px 0px 0px;\n    margin-left: 85%;\n  }\n  .sidebar-80-right.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-80-right-padded {\n    padding: 0px 0px 0px 0px;\n    margin-right: 85%;\n  }\n  .sidebar-90-left.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-90-left-padded {\n    padding: 0px 0px 0px 0px;\n    margin-left: 95%;\n  }\n  .sidebar-90-right.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-90-right-padded {\n    padding: 0px 0px 0px 0px;\n    margin-right: 95%;\n  }\n  .sidebar-100-left.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-100-left-padded {\n    padding: 0px 0px 0px 0px;\n    margin-left: 100%;\n  }\n  .sidebar-100-right.sidebar-pinned.open ~ .constructor,\n  .constructor.sixsidebar-100-right-padded {\n    padding: 0px 0px 0px 0px;\n    margin-right: 100%;\n  }\n  aside[class*=\"list-sidebar-fixed-bottom\"].list-sidebar {\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 50%;\n    max-height: 50%;\n    width: 100%;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0);\n  }\n  aside[class*=\"list-sidebar-fixed-bottom\"].list-sidebar.open {\n    width: 100%;\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n  /* fix nested sidebar */\n  .list-sidebar .list-sidebar[class*=sidebar-l] {\n    left: 0;\n  }\n  .list-sidebar .list-sidebar[class*=sidebar-r] {\n    right: 0;\n  }\n</style><aside id=\"{{sxId}}\" class=\"list-sidebar list-sidebar-default list-sidebar-fixed-{{sxPosition}} sidebar-{{sxDimension}}-{{sxPosition}} list-sidebar-stacked custom-six-sidebar {{sxClass}}\" ng-class=\"{\'open\': sxOpened, \'sidebar-pinned\': sxPinned}\" role=\"navigation\"><div class=\"panel sidebar-panel\" ng-if=\"sxShowTitle\"><a class=\"btn btn-info pull-left\" title=\"{{sxPinned?\'Unpin\':\'Pin\'}}\" ng-click=\"togglePinnedSidebar()\" ng-if=\"sxPinnable\"><span style=\"font-size: 14px\" class=\"fa icon-only\" ng-class=\"{\'fa-chain\': sxPinned, \'fa-chain-broken\': !sxPinned}\"></span></a> <a class=\"btn btn-info pull-right\" title=\"Chiudi\" ng-click=\"toggleSidebar()\" ng-if=\"sxClosable\"><span class=\"fa fa-times icon-only\" style=\"font-size: 14px\"></span></a><div class=\"bg-info sidebar-heading six-sidebar-header\"><span>{{sxTitle}}</span></div></div><div id=\"{{sxId}}-content\" ng-click=\"smartCloseSidebar($event)\" ng-transclude=\"\"></div></aside>");}]);